webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(86);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(2122);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(2123);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _2 = __webpack_require__(515);
	
	var _3 = _interopRequireDefault(_2);
	
	var _routes = __webpack_require__(603);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(604);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(262);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	__webpack_require__(881);
	
	var _vueButtonEffect = __webpack_require__(1616);
	
	var _vueButtonEffect2 = _interopRequireDefault(_vueButtonEffect);
	
	var _vform = __webpack_require__(605);
	
	var _auth = __webpack_require__(146);
	
	var _authorize = __webpack_require__(179);
	
	var _trataResponseErro = __webpack_require__(600);
	
	var _tokenInfo = __webpack_require__(599);
	
	var _verificaFormulario = __webpack_require__(602);
	
	var _validaProposta = __webpack_require__(601);
	
	var _formataNumero = __webpack_require__(594);
	
	var _laravelHandoff = __webpack_require__(598);
	
	var _isAdmin = __webpack_require__(596);
	
	var _isFundacao = __webpack_require__(597);
	
	var _buscaCategorizadores = __webpack_require__(589);
	
	var _buscaFormasJuridicas = __webpack_require__(590);
	
	var _buscaRamoAtividades = __webpack_require__(592);
	
	var _buscatiposRegistros = __webpack_require__(593);
	
	var _buscaQuestionarioRisco = __webpack_require__(591);
	
	var _parcelasAdiantamento = __webpack_require__(271);
	
	var _vueMultiselect = __webpack_require__(2113);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _vueJsonExcel = __webpack_require__(1837);
	
	var _vueJsonExcel2 = _interopRequireDefault(_vueJsonExcel);
	
	var _vueDirectiveTooltip = __webpack_require__(1619);
	
	var _vueDirectiveTooltip2 = _interopRequireDefault(_vueDirectiveTooltip);
	
	__webpack_require__(1250);
	
	var _vueHeadful = __webpack_require__(1622);
	
	var _vueHeadful2 = _interopRequireDefault(_vueHeadful);
	
	var _vSwitchCase = __webpack_require__(1614);
	
	var _vSwitchCase2 = _interopRequireDefault(_vSwitchCase);
	
	var _vuedraggable = __webpack_require__(2251);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _quill = __webpack_require__(499);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _quillImageResize = __webpack_require__(1587);
	
	var _quillImageResize2 = _interopRequireDefault(_quillImageResize);
	
	var _quillImageCompress = __webpack_require__(1586);
	
	var _quillImageCompress2 = _interopRequireDefault(_quillImageCompress);
	
	var _vueQuillEditor = __webpack_require__(2121);
	
	var _vueQuillEditor2 = _interopRequireDefault(_vueQuillEditor);
	
	__webpack_require__(1247);
	
	__webpack_require__(1248);
	
	var _vueSliderComponent = __webpack_require__(2125);
	
	var _vueSliderComponent2 = _interopRequireDefault(_vueSliderComponent);
	
	__webpack_require__(1528);
	
	var _vueTippy = __webpack_require__(2247);
	
	var _vueTippy2 = _interopRequireDefault(_vueTippy);
	
	var _vueTabsComponent = __webpack_require__(2244);
	
	__webpack_require__(1249);
	
	var _vSlimDialog = __webpack_require__(1613);
	
	var _vSlimDialog2 = _interopRequireDefault(_vSlimDialog);
	
	var _vueProgress = __webpack_require__(2120);
	
	var _vueProgress2 = _interopRequireDefault(_vueProgress);
	
	var _vueTables = __webpack_require__(2153);
	
	var _vueSweetalert = __webpack_require__(2128);
	
	var _vueSweetalert2 = _interopRequireDefault(_vueSweetalert);
	
	var _vue2Datepicker = __webpack_require__(2249);
	
	var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);
	
	var _vueFlatpickrComponent = __webpack_require__(1621);
	
	var _vueFlatpickrComponent2 = _interopRequireDefault(_vueFlatpickrComponent);
	
	__webpack_require__(1246);
	
	__webpack_require__(1538);
	
	var _vuejsDatepicker = __webpack_require__(880);
	
	var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);
	
	var _locale = __webpack_require__(879);
	
	var _vueTheMask = __webpack_require__(2246);
	
	var _vueTheMask2 = _interopRequireDefault(_vueTheMask);
	
	var _vueJsModal = __webpack_require__(1624);
	
	var _vueJsModal2 = _interopRequireDefault(_vueJsModal);
	
	var _components = __webpack_require__(2111);
	
	__webpack_require__(1526);
	
	var _vueSelect = __webpack_require__(2124);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	var _vueEvents = __webpack_require__(1620);
	
	var _vueEvents2 = _interopRequireDefault(_vueEvents);
	
	__webpack_require__(1530);
	
	var _vuejsDialog = __webpack_require__(2252);
	
	var _vuejsDialog2 = _interopRequireDefault(_vuejsDialog);
	
	var _vMoney = __webpack_require__(1612);
	
	var _vMoney2 = _interopRequireDefault(_vMoney);
	
	var _vueLodash = __webpack_require__(2110);
	
	var _vueLodash2 = _interopRequireDefault(_vueLodash);
	
	var _vueI18n = __webpack_require__(1623);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _veeValidate = __webpack_require__(1615);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _cpf = __webpack_require__(178);
	
	var _cpf2 = _interopRequireDefault(_cpf);
	
	var _cnpj = __webpack_require__(268);
	
	var _cnpj2 = _interopRequireDefault(_cnpj);
	
	var _validdate = __webpack_require__(588);
	
	var _validdate2 = _interopRequireDefault(_validdate);
	
	var _dateeqorpast = __webpack_require__(586);
	
	var _dateeqorpast2 = _interopRequireDefault(_dateeqorpast);
	
	var _dateeqorfuture = __webpack_require__(585);
	
	var _dateeqorfuture2 = _interopRequireDefault(_dateeqorfuture);
	
	var _dictionary = __webpack_require__(587);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	var _agency = __webpack_require__(582);
	
	var _agency2 = _interopRequireDefault(_agency);
	
	var _contaCorrente = __webpack_require__(583);
	
	var _contaCorrente2 = _interopRequireDefault(_contaCorrente);
	
	var _vueViacep = __webpack_require__(2248);
	
	var _vueViacep2 = _interopRequireDefault(_vueViacep);
	
	var _brBankAccountValidator = __webpack_require__(125);
	
	var _brBankAccountValidator2 = _interopRequireDefault(_brBankAccountValidator);
	
	var _vueConfirmDialog = __webpack_require__(1618);
	
	var _vueConfirmDialog2 = _interopRequireDefault(_vueConfirmDialog);
	
	var _vueTextareaAutosize = __webpack_require__(2245);
	
	var _vueTextareaAutosize2 = _interopRequireDefault(_vueTextareaAutosize);
	
	var _vueSnotifyMin = __webpack_require__(2126);
	
	var _vueSnotifyMin2 = _interopRequireDefault(_vueSnotifyMin);
	
	var _bootstrapVue = __webpack_require__(892);
	
	var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);
	
	var _App = __webpack_require__(1625);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(1532);
	
	__webpack_require__(1245);
	
	__webpack_require__(1244);
	
	__webpack_require__(1527);
	
	__webpack_require__(1531);
	
	__webpack_require__(1529);
	
	__webpack_require__(1533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueButtonEffect2.default);
	
	window.Form = _vform.Form;
	_vue2.default.component(_vform.HasError.name, _vform.HasError);
	_vue2.default.component(_vform.AlertError.name, _vform.AlertError);
	
	_vue2.default.component('downloadExcel', _vueJsonExcel2.default);
	
	_vue2.default.use(_vueDirectiveTooltip2.default);
	
	_vue2.default.directive('resizable', {
	  inserted: function inserted(el) {
	    el.addEventListener('input', function (e) {
	      e.target.style.height = 'auto';
	      e.target.style.height = e.target.scrollHeight + 'px';
	    });
	  }
	});
	
	_vue2.default.mixin(_laravelHandoff.laravelHandoff);
	
	_vue2.default.mixin(_parcelasAdiantamento.parcelasAdiantamento);
	
	_vue2.default.component('vue-headful', _vueHeadful2.default);
	
	_vue2.default.use(_vSwitchCase2.default);
	
	_vue2.default.component('draggable', _vuedraggable2.default);
	
	_quill2.default.register('modules/imageResize', _quillImageResize2.default);
	
	_quill2.default.register('modules/imageCompress', _quillImageCompress2.default);
	
	_vue2.default.use(_vueQuillEditor2.default);
	
	_vue2.default.component('VueSlider', _vueSliderComponent2.default);
	
	_vue2.default.use(_vueTippy2.default);
	
	_vue2.default.component('tabs', _vueTabsComponent.Tabs);
	_vue2.default.component('tab', _vueTabsComponent.Tab);
	
	_vue2.default.component('multiselect', _vueMultiselect2.default);
	
	_vue2.default.use(_vSlimDialog2.default);
	
	_vue2.default.use(_vueProgress2.default);
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.emulateJSON = true;
	
	_vue2.default.use(_vueTables.ClientTable, {}, false, 'bootstrap3');
	
	_vue2.default.use(_vueSweetalert2.default);
	
	_vue2.default.use(_vue2Datepicker2.default);
	
	_vue2.default.use(_vueFlatpickrComponent2.default);
	
	_vue2.default.component('datepicker', _vuejsDatepicker2.default);
	
	_vue2.default.prototype.$datePickerPtBR = _locale.ptBR;
	
	_vue2.default.use(_vueTheMask2.default);
	
	_vue2.default.prototype.$cnpjTokens = {
	  'N': { pattern: /[0-9a-zA-Z]/, transform: function transform(valor) {
	      return valor.toLocaleUpperCase();
	    } },
	  '#': { pattern: /\d/ }
	};
	
	_vue2.default.use(_vueJsModal2.default);
	
	_vue2.default.use(_components.MdButton);
	
	_vue2.default.component('v-select', _vueSelect2.default);
	_vue2.default.use(_vueSelect2.default);
	
	_vue2.default.use(_vueEvents2.default);
	
	_vue2.default.use(_vuejsDialog2.default, {
	  cancelText: 'Voltar',
	  reverse: false,
	  type: 'basic',
	  animation: 'bounce',
	  backdropClose: false,
	
	  html: true,
	
	  okText: 'Continuar'
	});
	
	_vue2.default.use(_vMoney2.default, {
	  decimal: ',',
	  thousands: '.',
	  prefix: 'R$ ',
	  precision: 2,
	  masked: false
	});
	
	_vue2.default.filter('real', function (value) {
	  value = parseFloat(value);
	  var formato = { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' };
	  if (!isNaN(value)) {
	    return value.toLocaleString('pt-BR', formato);
	  }
	});
	
	_vue2.default.filter('decimal2', function (value) {
	  return !isNaN(value) ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'decimal', currency: 'BRL' }) : '';
	});
	
	_vue2.default.filter('decimal3', function (value) {
	  return !isNaN(value) ? value.toLocaleString('pt-BR', { minimumFractionDigits: 3, style: 'decimal', currency: 'BRL' }) : '';
	});
	
	_vue2.default.filter('decimal4', function (value) {
	  return !isNaN(value) ? value.toLocaleString('pt-BR', { minimumFractionDigits: 4, style: 'decimal', currency: 'BRL' }) : '';
	});
	
	_vue2.default.filter('cnpj', function (value) {
	  if (value) {
	    return value.replace(/^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})/, '$1.$2.$3/$4-$5');
	  }
	});
	_vue2.default.filter('cpf', function (value) {
	  if (value) {
	    return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
	  }
	});
	_vue2.default.filter('cep', function (value) {
	  if (value) {
	    return value.replace(/^(\d{5})(\d{2})/, '$1-$2');
	  }
	});
	
	_vue2.default.filter('telefone', function (value) {
	  if (value) {
	    if (value.length === 11) {
	      if (value) {
	        return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
	      }
	    }
	    if (value.length === 10) {
	      if (value) {
	        return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
	      }
	    }
	  }
	});
	
	_vue2.default.filter('percentage', function (value, decimals) {
	  if (!value) value = 0;
	  if (!decimals) decimals = 2;
	  value = value * 100;
	  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + '%';
	});
	
	_vue2.default.filter('formataData', function (value) {
	  var today = new Date(value);
	  var yyyy = today.getFullYear();
	
	  if (isNaN(yyyy)) {
	    return '';
	  }
	  var mm = today.getMonth() + 1;
	  var dd = today.getDate();
	
	  if (dd < 10) dd = '0' + dd;
	  if (mm < 10) mm = '0' + mm;
	
	  var formated = dd + '/' + mm + '/' + yyyy;
	  return formated;
	});
	
	_vue2.default.use(_vueRouter2.default);
	
	var options = { name: 'lodash' };
	_vue2.default.use(_vueLodash2.default, options);
	var messages = __webpack_require__(606);
	_vue2.default.use(_vueI18n2.default);
	var i18n = new _vueI18n2.default({
	  locale: 'pt_BR',
	  messages: messages
	});
	
	_vue2.default.use(_veeValidate2.default, {
	  locale: 'pt',
	  dictionary: _dictionary2.default,
	  inject: 'false',
	  fieldsBagName: 'campos'
	});
	
	_veeValidate.Validator.extend('cpf', _cpf2.default);
	_veeValidate.Validator.extend('cnpj', _cnpj2.default);
	_veeValidate.Validator.extend('validdate', _validdate2.default);
	_veeValidate.Validator.extend('dateeqpast', _dateeqorpast2.default);
	_veeValidate.Validator.extend('dateeqfuture', _dateeqorfuture2.default);
	_veeValidate.Validator.extend('agency', _agency2.default);
	_veeValidate.Validator.extend('contacorrente', _contaCorrente2.default);
	
	_vue2.default.use(_vueViacep2.default);
	
	_vue2.default.use(_brBankAccountValidator2.default);
	
	_vue2.default.use(_vueConfirmDialog2.default);
	_vue2.default.component('vue-confirm-dialog', _vueConfirmDialog2.default.default);
	
	_vue2.default.use(_vueTextareaAutosize2.default);
	
	var snotifyoptions = {
	  toast: {
	    position: _vueSnotifyMin.SnotifyPosition.rightTop,
	    timeout: 30000,
	
	    bodyMaxLength: 1000
	  }
	};
	_vue2.default.use(_vueSnotifyMin2.default, snotifyoptions);
	
	_vue2.default.prototype.$aguarde = function (mensagem, config) {
	  return this.$snotify.create({
	    title: null,
	    body: mensagem,
	    config: (0, _assign2.default)({ type: 'async' }, config || {})
	  });
	};
	
	_vue2.default.use(_bootstrapVue2.default);
	window.boostrapTable = __webpack_require__(891);
	
	window.axios = _axios2.default.create({
	  baseURL: ("https://projetos.fbb.org.br:9080"),
	  transformRequest: [function (data) {
	    return (0, _stringify2.default)(data);
	  }],
	
	  headers: {
	    'Content-Type': 'application/json;charset=UTF-8'
	  }
	});
	
	window.axiosLaravel = _axios2.default.create({
	  baseURL: ("https://projetos.fbb.org.br:5443/api/"),
	
	  headers: {
	    'Content-Type': 'application/json;charset=UTF-8'
	  }
	});
	if (window.localStorage.tokenLaravel) axiosLaravel.defaults.headers.Authorization = 'Bearer ' + window.localStorage.tokenLaravel;
	
	(0, _auth.instalaInterceptors)(window.axiosLaravel, function () {
	  (0, _auth.limpaSessao)();
	
	  if (window.location.pathname !== '/login') {
	    window.location = '/login';
	  }
	});
	
	var moment = __webpack_require__(1);
	__webpack_require__(243);
	_vue2.default.use(__webpack_require__(2112), {
	  moment: moment
	});
	
	var router = new _vueRouter2.default({
	  routes: [{ path: '*', component: _3.default }].concat((0, _toConsumableArray3.default)(_routes2.default)),
	
	  mode: 'history',
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    return savedPosition || { x: 0, y: 0 };
	  }
	});
	
	router.beforeEach(function (to, from, next) {
	  if (to.hash.includes('change-my-password')) {
	    var token = to.hash.split('change-my-password/').pop();
	    next({ name: 'altera-senha', params: { token: token } });
	  } else {
	    var logado = window.localStorage.getItem('usuario') !== null;
	    if (to.name === 'preenche-formulario-externo' && logado) {
	      next({ path: '/formulario/' + to.params.id, params: { id: to.params.id } });
	    } else if (to.name === 'preenche-formulario' && !logado) {
	      next({ path: '/form/' + to.params.id, params: { id: to.params.id } });
	    } else {
	      next();
	    }
	  }
	});
	
	if (window.localStorage) {
	  if (_store2.default.state.token !== window.localStorage.getItem('token')) {
	    _store2.default.commit('SET_TOKEN', window.localStorage.getItem('token'));
	    _axios2.default.defaults.headers.common['Authorization'] = 'Bearer ' + _store2.default.state.token;
	  }
	}
	
	_store2.default.commit('SET_LARAVEL', ("https://projetos.fbb.org.br:5443/api/"));
	
	
	router.beforeEach(function (to, from, next) {
	  if (!_.isUndefined(window.localStorage.tokenLaravel)) {
	    _buscaFormasJuridicas.buscaFormasJuridicas.methods.buscaFormasJuridicas(_store2.default);
	    _buscaCategorizadores.buscaCategorizadores.methods.buscaCategorizadores(_store2.default);
	    _buscaRamoAtividades.buscaRamoAtividades.methods.buscaRamoAtividades(_store2.default);
	    _buscatiposRegistros.buscatiposRegistros.methods.buscatiposRegistros(_store2.default);
	    _buscaQuestionarioRisco.buscaQuestionarioRisco.methods.buscaQuestionarioRisco(_store2.default);
	  }
	
	  if (to.meta.title) {
	    document.title = to.meta.title;
	  }
	  if (to.matched.some(function (record) {
	    return record.meta.requiresAuth;
	  }) && (_.isUndefined(window.localStorage.tokenLaravel) || _.isNull(window.localStorage.tokenLaravel))) {
	    next('/login');
	  } else if (!_.isUndefined(window.localStorage.tokenLaravel) && to.path === '/login') {
	    next('/dashboard');
	  } else {
	    next();
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  mixins: [_authorize.authorize, _trataResponseErro.trataErro, _tokenInfo.tokenInfo, _verificaFormulario.verificaFormulario, _validaProposta.validaProposta, _formataNumero.formataNumero, _isAdmin.isAdmin, _isFundacao.isFundacao, _buscaCategorizadores.buscaCategorizadores, _buscaRamoAtividades.buscaRamoAtividades, _buscaFormasJuridicas.buscaFormasJuridicas, _buscatiposRegistros.buscatiposRegistros, _buscaQuestionarioRisco.buscaQuestionarioRisco],
	  router: router,
	  store: _store2.default,
	  i18n: i18n,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	__webpack_require__(893);
	__webpack_require__(555);
	__webpack_require__(556);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1320)
	
	/* script */
	__vue_exports__ = __webpack_require__(775)
	
	/* template */
	var __vue_template__ = __webpack_require__(1906)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-37b63fb5"
	
	module.exports = __vue_exports__


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1490)
	
	/* script */
	__vue_exports__ = __webpack_require__(778)
	
	/* template */
	var __vue_template__ = __webpack_require__(2079)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ca1338e6"
	
	module.exports = __vue_exports__


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1428)
	
	/* script */
	__vue_exports__ = __webpack_require__(725)
	
	/* template */
	var __vue_template__ = __webpack_require__(2016)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-753cc6c9"
	
	module.exports = __vue_exports__


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1313)
	
	/* script */
	__vue_exports__ = __webpack_require__(730)
	
	/* template */
	var __vue_template__ = __webpack_require__(1899)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-325a4869"
	
	module.exports = __vue_exports__


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1409)
	
	/* script */
	__vue_exports__ = __webpack_require__(749)
	
	/* template */
	var __vue_template__ = __webpack_require__(1997)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b9a2036"
	
	module.exports = __vue_exports__


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1470)
	
	/* script */
	__vue_exports__ = __webpack_require__(678)
	
	/* template */
	var __vue_template__ = __webpack_require__(2057)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b521a2be"
	
	module.exports = __vue_exports__


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1335)
	
	/* script */
	__vue_exports__ = __webpack_require__(715)
	
	/* template */
	var __vue_template__ = __webpack_require__(1921)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-40389502"
	
	module.exports = __vue_exports__


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1382)
	
	/* script */
	__vue_exports__ = __webpack_require__(699)
	
	/* template */
	var __vue_template__ = __webpack_require__(1970)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5deab2a8"
	
	module.exports = __vue_exports__


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1257)
	
	/* script */
	__vue_exports__ = __webpack_require__(706)
	
	/* template */
	var __vue_template__ = __webpack_require__(1844)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1473)
	
	/* script */
	__vue_exports__ = __webpack_require__(708)
	
	/* template */
	var __vue_template__ = __webpack_require__(2060)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b64dec2e"
	
	module.exports = __vue_exports__


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1256)
	
	/* script */
	__vue_exports__ = __webpack_require__(727)
	
	/* template */
	var __vue_template__ = __webpack_require__(1843)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-01776124"
	
	module.exports = __vue_exports__


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1291)
	
	/* script */
	__vue_exports__ = __webpack_require__(779)
	
	/* template */
	var __vue_template__ = __webpack_require__(1876)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1451)
	
	/* script */
	__vue_exports__ = __webpack_require__(673)
	
	/* template */
	var __vue_template__ = __webpack_require__(2039)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-92b73e22"
	
	module.exports = __vue_exports__


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1346)
	
	/* script */
	__vue_exports__ = __webpack_require__(697)
	
	/* template */
	var __vue_template__ = __webpack_require__(1932)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-44cd4c84"
	
	module.exports = __vue_exports__


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1472)
	
	/* script */
	__vue_exports__ = __webpack_require__(762)
	
	/* template */
	var __vue_template__ = __webpack_require__(2059)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b5a44916"
	
	module.exports = __vue_exports__


/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1307)
	
	/* script */
	__vue_exports__ = __webpack_require__(707)
	
	/* template */
	var __vue_template__ = __webpack_require__(1891)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-29535244"
	
	module.exports = __vue_exports__


/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1376)
	
	/* script */
	__vue_exports__ = __webpack_require__(854)
	
	/* template */
	var __vue_template__ = __webpack_require__(1964)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-584c69a9"
	
	module.exports = __vue_exports__


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1501)
	
	/* script */
	__vue_exports__ = __webpack_require__(711)
	
	/* template */
	var __vue_template__ = __webpack_require__(2089)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-db94f5d4"
	
	module.exports = __vue_exports__


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1311)
	
	/* script */
	__vue_exports__ = __webpack_require__(777)
	
	/* template */
	var __vue_template__ = __webpack_require__(1897)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2fd201b3"
	
	module.exports = __vue_exports__


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1321)
	
	/* script */
	__vue_exports__ = __webpack_require__(713)
	
	/* template */
	var __vue_template__ = __webpack_require__(1907)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-37f1f8a4"
	
	module.exports = __vue_exports__


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1334)
	
	/* script */
	__vue_exports__ = __webpack_require__(841)
	
	/* template */
	var __vue_template__ = __webpack_require__(1920)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-401874f6"
	
	module.exports = __vue_exports__


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1446)
	
	/* script */
	__vue_exports__ = __webpack_require__(842)
	
	/* template */
	var __vue_template__ = __webpack_require__(2034)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-86b5c208"
	
	module.exports = __vue_exports__


/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1429)
	
	/* script */
	__vue_exports__ = __webpack_require__(747)
	
	/* template */
	var __vue_template__ = __webpack_require__(2017)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-75faa27f"
	
	module.exports = __vue_exports__


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(124);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getConstructor(value) {
	  var string = Object.prototype.toString.call(value);
	
	  var _$exec = /\[object (.*?)\]/.exec(string),
	      _$exec2 = (0, _slicedToArray3.default)(_$exec, 2),
	      constructor = _$exec2[1];
	
	  return constructor;
	}
	function is(value, constructor) {
	  return constructor === getConstructor(value);
	}
	
	function validate(value) {
	  if (!is(value, 'String')) {
	    return false;
	  }
	
	  var cnpj = value.toUpperCase().replace(/[^0-9A-Z]/g, '');
	
	  if (cnpj.length !== 14) {
	    return false;
	  }
	
	  if (!/^\d{2}$/.test(cnpj.substring(12))) {
	    return false;
	  }
	
	  var charValue = function charValue(c) {
	    return c.charCodeAt(0) - 48;
	  };
	
	  var getRest = function getRest(dig) {
	    return dig % 11 < 2 ? 0 : 11 - dig % 11;
	  };
	
	  var calc = function calc(length) {
	    var sum = 0;
	    var pos = length - 7;
	
	    for (var i = 0; i < length; i++) {
	      sum += charValue(cnpj.charAt(i)) * pos;
	      pos--;
	      if (pos < 2) {
	        pos = 9;
	      }
	    }
	
	    return getRest(sum);
	  };
	
	  var digito = parseInt(cnpj.charAt(12) + cnpj.charAt(13));
	
	  return calc(12) * 10 + calc(13) === digito;
	}
	exports.default = validate;

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1264)
	
	/* script */
	__vue_exports__ = __webpack_require__(765)
	
	/* template */
	var __vue_template__ = __webpack_require__(1852)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-09a8e17f"
	
	module.exports = __vue_exports__


/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(76);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.salvaSessao = salvaSessao;
	exports.limpaSessao = limpaSessao;
	exports.getAccessToken = getAccessToken;
	exports.getRefreshToken = getRefreshToken;
	exports.segundosAteExpirar = segundosAteExpirar;
	exports.precisaRenovar = precisaRenovar;
	exports.renovaToken = renovaToken;
	exports.instalaInterceptors = instalaInterceptors;
	
	var _axios = __webpack_require__(262);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var http = _axios2.default.create({
	  baseURL: ("https://projetos.fbb.org.br:5443/api/"),
	  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
	});
	
	var renovacaoEmAndamento = null;
	
	var MARGEM_RENOVACAO_SEGUNDOS = 120;
	
	var CHAVE_LOCK = 'refreshTokenLaravelLock';
	var LOCK_MS = 15000;
	var ESPERA_MS = 150;
	
	function salvaSessao(data) {
	  if (!window.localStorage) {
	    return;
	  }
	
	  window.localStorage.setItem('tokenLaravel', data.access_token);
	  window.localStorage.setItem('tokenLaravelExpires_at', data.expires_at);
	
	  if (data.refresh_token) {
	    window.localStorage.setItem('refreshTokenLaravel', data.refresh_token);
	  }
	
	  if (data.usuario) {
	    window.localStorage.setItem('usuario', (0, _stringify2.default)(data.usuario));
	    window.localStorage.setItem('userPermissions', (0, _stringify2.default)(data.usuario.permissoes));
	  }
	
	  aplicaToken(data.access_token);
	}
	
	function limpaSessao() {
	  if (window.localStorage) {
	    window.localStorage.removeItem('token');
	    window.localStorage.removeItem('user');
	    window.localStorage.removeItem('tokenLaravel');
	    window.localStorage.removeItem('refreshTokenLaravel');
	    window.localStorage.removeItem('tokenLaravelExpires_at');
	    window.localStorage.removeItem('usuario');
	    window.localStorage.removeItem('userPermissions');
	    window.localStorage.removeItem(CHAVE_LOCK);
	  }
	
	  renovacaoEmAndamento = null;
	
	  if (window.Echo) {
	    try {
	      window.Echo.disconnect();
	    } catch (e) {}
	  }
	}
	
	function getAccessToken() {
	  return window.localStorage ? window.localStorage.getItem('tokenLaravel') : null;
	}
	
	function getRefreshToken() {
	  return window.localStorage ? window.localStorage.getItem('refreshTokenLaravel') : null;
	}
	
	function segundosAteExpirar() {
	  var token = getAccessToken();
	
	  if (!token) {
	    return 0;
	  }
	
	  try {
	    var base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
	    var exp = JSON.parse(window.atob(base64)).exp;
	
	    return exp - Math.floor(new Date().getTime() / 1000);
	  } catch (e) {
	    return 0;
	  }
	}
	
	function precisaRenovar() {
	  return !!getRefreshToken() && segundosAteExpirar() < MARGEM_RENOVACAO_SEGUNDOS;
	}
	
	function renovaToken() {
	  if (renovacaoEmAndamento) {
	    return renovacaoEmAndamento;
	  }
	
	  var refreshToken = getRefreshToken();
	
	  if (!refreshToken) {
	    return _promise2.default.reject(new Error('sem refresh token'));
	  }
	
	  var tokenAnterior = getAccessToken();
	
	  if (!assumeLock()) {
	    renovacaoEmAndamento = aguardaOutraAba(tokenAnterior);
	
	    return renovacaoEmAndamento;
	  }
	
	  renovacaoEmAndamento = http.post('auth/refresh', { refresh_token: refreshToken }).then(function (response) {
	    liberaLock();
	    renovacaoEmAndamento = null;
	    salvaSessao(response.data);
	    reconectaWebsocket(response.data.access_token);
	
	    return response.data.access_token;
	  }).catch(function (error) {
	    liberaLock();
	    renovacaoEmAndamento = null;
	
	    return _promise2.default.reject(error);
	  });
	
	  return renovacaoEmAndamento;
	}
	
	function assumeLock() {
	  if (!window.localStorage) {
	    return true;
	  }
	
	  var agora = new Date().getTime();
	  var atual = window.localStorage.getItem(CHAVE_LOCK);
	
	  if (atual && agora - parseInt(atual.split(':')[0], 10) < LOCK_MS) {
	    return false;
	  }
	
	  var meu = agora + ':' + Math.random().toString(36).slice(2);
	  window.localStorage.setItem(CHAVE_LOCK, meu);
	
	  return window.localStorage.getItem(CHAVE_LOCK) === meu;
	}
	
	function liberaLock() {
	  if (window.localStorage) {
	    window.localStorage.removeItem(CHAVE_LOCK);
	  }
	}
	
	function aguardaOutraAba(tokenAnterior) {
	  return new _promise2.default(function (resolve, reject) {
	    var limite = new Date().getTime() + LOCK_MS;
	
	    var verifica = function verifica() {
	      var atual = getAccessToken();
	
	      if (atual && atual !== tokenAnterior) {
	        renovacaoEmAndamento = null;
	        aplicaToken(atual);
	        resolve(atual);
	
	        return;
	      }
	
	      if (new Date().getTime() > limite) {
	        renovacaoEmAndamento = null;
	        reject(new Error('tempo esgotado esperando a renovação de outra aba'));
	
	        return;
	      }
	
	      window.setTimeout(verifica, ESPERA_MS);
	    };
	
	    verifica();
	  });
	}
	
	function aplicaToken(token) {
	  if (window.axiosLaravel) {
	    window.axiosLaravel.defaults.headers.Authorization = 'Bearer ' + token;
	  }
	}
	
	function reconectaWebsocket(token) {
	  if (!window.Echo || !window.Echo.connector || !window.Echo.connector.options) {
	    return;
	  }
	
	  window.Echo.connector.options.auth = window.Echo.connector.options.auth || {};
	  window.Echo.connector.options.auth.headers = (0, _assign2.default)({}, window.Echo.connector.options.auth.headers, { Authorization: 'Bearer ' + token });
	
	  if (window.Echo.connector.pusher && window.Echo.connector.pusher.config) {
	    window.Echo.connector.pusher.config.auth = window.Echo.connector.options.auth;
	  }
	}
	
	function instalaInterceptors(instancia, aoPerderSessao) {
	  instancia.interceptors.request.use(function (config) {
	    var atual = getAccessToken();
	
	    if (atual) {
	      config.headers.Authorization = 'Bearer ' + atual;
	    }
	
	    if (config._retry || !precisaRenovar()) {
	      return config;
	    }
	
	    return renovaToken().then(function (token) {
	      config.headers.Authorization = 'Bearer ' + token;
	
	      return config;
	    }).catch(function () {
	      return config;
	    });
	  });
	
	  instancia.interceptors.response.use(function (response) {
	    return response;
	  }, function (error) {
	    var config = error.config;
	
	    if (!error.response || error.response.status !== 401 || !config) {
	      return _promise2.default.reject(error);
	    }
	
	    if (config._retry) {
	      aoPerderSessao();
	
	      return _promise2.default.reject(error);
	    }
	
	    config._retry = true;
	
	    var atual = getAccessToken();
	    var usado = String(config.headers.Authorization || '').replace('Bearer ', '');
	
	    if (atual && atual !== usado) {
	      aplicaToken(atual);
	      config.headers.Authorization = 'Bearer ' + atual;
	
	      return instancia.request(config);
	    }
	
	    if (!getRefreshToken()) {
	      aoPerderSessao();
	
	      return _promise2.default.reject(error);
	    }
	
	    return renovaToken().then(function (token) {
	      config.headers.Authorization = 'Bearer ' + token;
	
	      return instancia.request(config);
	    }).catch(function () {
	      aoPerderSessao();
	
	      return _promise2.default.reject(error);
	    });
	  });
	}

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1458)
	
	/* script */
	__vue_exports__ = __webpack_require__(859)
	
	/* template */
	var __vue_template__ = __webpack_require__(2046)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a1b7d680"
	
	module.exports = __vue_exports__


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1328)
	
	/* script */
	__vue_exports__ = __webpack_require__(860)
	
	/* template */
	var __vue_template__ = __webpack_require__(1915)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3bc1b45a"
	
	module.exports = __vue_exports__


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1356)
	
	/* script */
	__vue_exports__ = __webpack_require__(865)
	
	/* template */
	var __vue_template__ = __webpack_require__(1943)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4c9cc9ce"
	
	module.exports = __vue_exports__


/***/ }),
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cpf = __webpack_require__(584);
	
	var _cpf2 = _interopRequireDefault(_cpf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validator = {
	  getMessage: function getMessage(field, args) {
	    return 'CPF inválido';
	  },
	  validate: function validate(value, args) {
	    return (0, _cpf2.default)(value);
	  }
	};
	exports.default = validator;

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var authorize = exports.authorize = {
	  methods: {
	    authorize: function authorize(params) {
	      var acessos = params.split('|');
	      var roles = JSON.parse(window.localStorage.userPermissions) ? JSON.parse(window.localStorage.userPermissions) : [];
	      roles = _.map(roles, _.property('ds_nome'));
	      return acessos.some(function (a) {
	        return roles.includes(a);
	      });
	    }
	  }
	};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    form: {
	      type: Object,
	      required: true
	    },
	
	    dismissible: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  methods: {
	    dismiss: function dismiss() {
	      if (this.dismissible) {
	        this.form.clear();
	      }
	    }
	  }
	};

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1453)
	
	/* script */
	__vue_exports__ = __webpack_require__(691)
	
	/* template */
	var __vue_template__ = __webpack_require__(2041)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-963d7b5e"
	
	module.exports = __vue_exports__


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1467)
	__webpack_require__(1466)
	
	/* script */
	__vue_exports__ = __webpack_require__(717)
	
	/* template */
	var __vue_template__ = __webpack_require__(2054)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-aefbfbd0"
	
	module.exports = __vue_exports__


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1284)
	
	/* script */
	__vue_exports__ = __webpack_require__(722)
	
	/* template */
	var __vue_template__ = __webpack_require__(1870)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1b8467c0"
	
	module.exports = __vue_exports__


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1497)
	__webpack_require__(1496)
	
	/* script */
	__vue_exports__ = __webpack_require__(735)
	
	/* template */
	var __vue_template__ = __webpack_require__(2085)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d5500dca"
	
	module.exports = __vue_exports__


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1276)
	
	/* script */
	__vue_exports__ = __webpack_require__(746)
	
	/* template */
	var __vue_template__ = __webpack_require__(1861)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1476)
	
	/* script */
	__vue_exports__ = __webpack_require__(788)
	
	/* template */
	var __vue_template__ = __webpack_require__(2063)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1308)
	
	/* script */
	__vue_exports__ = __webpack_require__(792)
	
	/* template */
	var __vue_template__ = __webpack_require__(1892)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1498)
	
	/* script */
	__vue_exports__ = __webpack_require__(797)
	
	/* template */
	var __vue_template__ = __webpack_require__(2086)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cnpj = __webpack_require__(122);
	
	var _cnpj2 = _interopRequireDefault(_cnpj);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validator = {
	  getMessage: function getMessage(field, args) {
	    return 'CNPJ inválido';
	  },
	  validate: function validate(value, args) {
	    return (0, _cnpj2.default)(value);
	  }
	};
	exports.default = validator;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GRUPOS_CHECKLIST_ANALISE = exports.OPCOES_SIM_NAO = undefined;
	
	var _slicedToArray2 = __webpack_require__(124);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.respostasLegadasParaImportar = respostasLegadasParaImportar;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPCOES_SIM_NAO = exports.OPCOES_SIM_NAO = ['Sim', 'Não', 'N/A'];
	
	var GRUPOS_CHECKLIST_ANALISE = exports.GRUPOS_CHECKLIST_ANALISE = [{
	  titulo: 'Objetivos e Metas',
	  itens: [{ chave: 'ds_indicadores_objetivo_geral', pergunta: 'O objetivo geral define o que se pretende com o projeto?' }, { chave: 'ds_indicadores_objetivo_especifico', pergunta: 'Os objetivos específicos e metas propiciam o atingimento do objetivo geral?' }, { chave: 'ds_indicadores_objetivo_compativel', pergunta: 'Os objetivos são compatíveis com as diretrizes estatutárias da FBB?' }, { chave: 'ds_indicadores_objetivo_estruturado', pergunta: 'Compatíveis com as diretrizes de programa estruturado?' }, { chave: 'ds_indicadores_objetivo_estrategico', pergunta: 'Compatíveis com o plano de trabalho de parcerias estratégicas?' }, { chave: 'existe_critica_objetivos_metas_indicadores', pergunta: 'Existe crítica aos objetivos, metas e indicadores?' }]
	}, {
	  titulo: 'Divulgação do Projeto',
	  itens: [{ chave: 'ds_acoes_comunicacao_memoria_calculo', pergunta: 'Recursos do Plano de Comunicação previstos na memória de cálculo?' }, { chave: 'ds_divulgacao_banner', pergunta: 'Previsto o uso de banner obrigatório de apoio da Fundação?' }, { chave: 'ds_divulgacao_identificacao', pergunta: 'Prevista a identificação de veículos adquiridos com recursos do projeto?' }, { chave: 'ds_divulgacao_placa', pergunta: 'Prevista placa provisória e definitiva em obras civis?' }, { chave: 'ds_divulgacao_solenizacao', pergunta: 'Prevista atividade de solenização de assinatura de convênio?' }]
	}, {
	  titulo: 'Valores e Contrapartida',
	  itens: [{ chave: 'ds_valores_itens', pergunta: 'Itens de despesa compatíveis com objetivos, metas e atividades?' }, { chave: 'ds_valores_contrapartida', pergunta: 'A contrapartida atende aos critérios dos normativos vigentes?' }, { chave: 'ds_valores_deacordo', pergunta: 'Valores de acordo com os praticados no mercado?' }, { chave: 'ds_valores_enquadrados', pergunta: 'Itens sem orçamento enquadrados nas diretrizes de dispensa?' }, { chave: 'ds_valores_vedacoes', pergunta: 'Observadas as vedações de itens de despesa?' }, { chave: 'ds_valores_industrial', pergunta: 'Observados itens para obra civil / bens fixos industriais?' }, { chave: 'ds_valores_formacao', pergunta: 'Observados itens para formação, capacitação e/ou consultorias?' }, { chave: 'conforme_obra_civil', pergunta: 'Verificada conformidade específica para obra civil?' }, { chave: 'ds_valores_ajustes', pergunta: 'Foi realizado ajuste nos valores apresentados?' }]
	}, {
	  titulo: 'Liberação de Recursos',
	  itens: [{ chave: 'ds_liberacao_adiantamentos', pergunta: 'Parâmetros de adiantamento atendidos conforme normativos vigentes?' }]
	}, {
	  titulo: 'Prazo de Execução',
	  observacaoChave: 'ds_execucao_observacoes',
	  itens: [{ chave: 'ds_execucao_compatibilidade', pergunta: 'Há compatibilidade entre o prazo de execução e as atividades?' }]
	}, {
	  titulo: 'Regularidade da Proposta e da Proponente',
	  observacaoChave: 'ds_regularidade_observacoes',
	  itens: [{ chave: 'ds_regularidade_objetivos', pergunta: 'Proposta compatível com os objetivos estatutários da entidade?' }, { chave: 'ds_regularidade_documentacao', chaveLegado: 'ds_regularidade_documentação', pergunta: 'Apresentou toda a documentação exigida para análise?' }, { chave: 'ds_regularidade_cadastral', pergunta: 'Encontra-se em regularidade cadastral?' }, { chave: 'ds_regularidade_fiscal', pergunta: 'Em conformidade fiscal e documental de parceria estratégica?' }]
	}, {
	  titulo: 'Enquadramento e Parecer Jurídico',
	  observacaoChave: 'ds_enquadramento_observacoes',
	  itens: [{ chave: 'ds_enquadramento_orcamento', pergunta: 'Proposta enquadrada no controle orçamentário da FBB?' }, { chave: 'ds_enquadramento_minuta', pergunta: 'Foi utilizada a minuta padrão aprovada?' }]
	}];
	
	var vazio = function vazio(valor) {
	  return valor === null || valor === undefined || valor === '';
	};
	
	function respostasLegadasParaImportar(proposta) {
	  var legado = {};
	  if (proposta && proposta.relatorio_analise) {
	    try {
	      legado = typeof proposta.relatorio_analise === 'string' ? JSON.parse(proposta.relatorio_analise) : proposta.relatorio_analise;
	    } catch (e) {
	      legado = {};
	    }
	  }
	  if (!legado || (typeof legado === 'undefined' ? 'undefined' : (0, _typeof3.default)(legado)) !== 'object') {
	    return {};
	  }
	
	  var dados = proposta && proposta.dados && !Array.isArray(proposta.dados) ? proposta.dados : {};
	  var importar = {};
	
	  GRUPOS_CHECKLIST_ANALISE.forEach(function (grupo) {
	    var pares = grupo.itens.map(function (item) {
	      return [item.chave, item.chaveLegado || item.chave];
	    });
	    if (grupo.observacaoChave) {
	      pares.push([grupo.observacaoChave, grupo.observacaoChave]);
	    }
	    pares.forEach(function (_ref) {
	      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	          chave = _ref2[0],
	          chaveLegado = _ref2[1];
	
	      if (vazio(dados[chave]) && !vazio(legado[chaveLegado])) {
	        importar[chave] = legado[chaveLegado];
	      }
	    });
	  });
	
	  return importar;
	}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getOwnPropertyNames = __webpack_require__(279);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _docxtemplater = __webpack_require__(356);
	
	var _docxtemplater2 = _interopRequireDefault(_docxtemplater);
	
	var _pizzip = __webpack_require__(492);
	
	var _pizzip2 = _interopRequireDefault(_pizzip);
	
	var _index = __webpack_require__(498);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _fileSaver = __webpack_require__(360);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ATESTADO_CAPACIDADE = '../../static/docs/modelos/atestadoCapacidadeTecnica.docx';
	var NOTIFICACAO_AVISO = '../../static/docs/modelos/NotificacaoExtrajudicialAviso.docx';
	var NOTIFICACAO_FINAL = '../../static/docs/modelos/NotificacaoExtrajudicialFinal.docx';
	var RELATORIO_MONITORAMENTO = '../../static/docs/modelos/RelatorioDeMonitoramento.docx';
	var BRIEFING_PROJETO = '../../static/docs/modelos/BriefingTemplate.docx';
	var BRIEFING_PROPOSTA = '../../static/docs/modelos/BriefingPropostaTemplate.docx';
	
	function loadFile(url, callback) {
	  _index2.default.getBinaryContent(url, callback);
	}
	
	var emiteDocumento = {
	  methods: {
	    geraDocumento: function geraDocumento(dados, tipoArquivo) {
	      var enderecoArquivo = '';
	      var nomeArquivo = '';
	
	      switch (tipoArquivo) {
	        case 'atestado':
	          enderecoArquivo = ATESTADO_CAPACIDADE;
	          nomeArquivo = 'Atestado_Capacidade_Tecnica_' + dados.entidade + '.docx';
	          break;
	        case 'notificacaoAviso':
	          enderecoArquivo = NOTIFICACAO_AVISO;
	          nomeArquivo = 'Notificacao_Extrajudicial_Aviso_' + dados.entidade + '.docx';
	          break;
	        case 'notificacaoFinal':
	          enderecoArquivo = NOTIFICACAO_FINAL;
	          nomeArquivo = 'Notificacao_Extrajudicial_Final_' + dados.entidade + '.docx';
	          break;
	        case 'relatorioMonitoramento':
	          enderecoArquivo = RELATORIO_MONITORAMENTO;
	          nomeArquivo = 'Relatorio_de_Monitoramento_' + dados.nome_entidade + '.docx';
	          break;
	        case 'briefingProjeto':
	          enderecoArquivo = BRIEFING_PROJETO;
	          nomeArquivo = 'Briefing_projeto_' + dados.sobreProjeto.nome_projeto + '.docx';
	          break;
	        case 'briefingProposta':
	          enderecoArquivo = BRIEFING_PROPOSTA;
	          nomeArquivo = 'Briefing_proposta_' + dados.sobreProjeto.nome_projeto + '.docx';
	          break;
	        default:
	          break;
	      }
	
	      loadFile(enderecoArquivo, function (error, content) {
	        if (error) {
	          throw error;
	        }
	        var zip = new _pizzip2.default(content);
	        var doc = new _docxtemplater2.default(zip, { paragraphLoop: true, linebreaks: true });
	
	        doc.setData(dados);
	        try {
	          doc.render();
	        } catch (error) {
	          var replaceErrors = function replaceErrors(key, value) {
	            if (value instanceof Error) {
	              return (0, _getOwnPropertyNames2.default)(value).reduce(function (error, key) {
	                error[key] = value[key];
	                return error;
	              }, {});
	            }
	            return value;
	          };
	
	          console.log((0, _stringify2.default)({ error: error }, replaceErrors));
	          if (error.properties && error.properties.errors instanceof Array) {
	            var errorMessages = error.properties.errors.map(function (error) {
	              return error.properties.explanation;
	            }).join('\n');
	            console.log('errorMessages', errorMessages);
	          }
	          throw error;
	        }
	        var out = doc.getZip().generate({
	          type: 'blob',
	          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
	        });
	        return (0, _fileSaver.saveAs)(out, nomeArquivo);
	      });
	    }
	  }
	};
	
	exports.default = emiteDocumento;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parcelasAdiantamento = undefined;
	
	var _lodash = __webpack_require__(170);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ORIGEM_MISTA = '0';
	var ORIGEM_FBB = '1';
	var ORIGEM_CONTRAPARTIDA = '2';
	var ORIGEM_PARCEIRO = '5';
	
	var CAMPOS_TRANSITORIOS = ['valor_fbb', 'valor_parc', 'id_fbb', 'id_parc', '_legadoSemBreakdown', '_origens'];
	
	function codigoOrigem(valor) {
	  if (_lodash2.default.isNil(valor) || valor === '') return '';
	  var texto = ('' + valor).trim();
	  if (texto === 'FUNDACAO') return ORIGEM_FBB;
	  if (texto === 'CONTRAPARTIDA') return ORIGEM_CONTRAPARTIDA;
	  if (texto === 'PARCEIRO_ESTRATEGICO') return ORIGEM_PARCEIRO;
	  if (texto === 'MISTO' || texto === 'MISTA') return ORIGEM_MISTA;
	  return texto.substring(0, 1);
	}
	
	function numeroSeguro(valor) {
	  var n = _lodash2.default.toNumber(valor);
	  return _lodash2.default.isFinite(n) ? n : 0;
	}
	
	function somaValores(lista, campo) {
	  var centavos = _lodash2.default.reduce(lista, function (acc, item) {
	    return acc + Math.round(numeroSeguro(_lodash2.default.get(item, campo, 0)) * 100);
	  }, 0);
	  return centavos / 100;
	}
	
	var parcelasAdiantamento = exports.parcelasAdiantamento = {
	  methods: {
	    rotuloOrigemParcela: function rotuloOrigemParcela(valor) {
	      switch (codigoOrigem(valor)) {
	        case ORIGEM_MISTA:
	          return 'Parcela Mista';
	        case ORIGEM_FBB:
	          return 'Fundação';
	        case ORIGEM_CONTRAPARTIDA:
	          return 'Contrapartida';
	        case ORIGEM_PARCEIRO:
	          return 'Parceiro Estratégico';
	        case '':
	          return '⚠️ Origem não informada';
	        default:
	          return '⚠️ Origem inválida (' + valor + ')';
	      }
	    },
	    ehParcelaMista: function ehParcelaMista(parcela) {
	      return codigoOrigem(_lodash2.default.get(parcela, 'origem')) === ORIGEM_MISTA;
	    },
	    haParcelaMista: function haParcelaMista(parcelas) {
	      var vm = this;
	      return _lodash2.default.some(parcelas || [], function (p) {
	        return vm.ehParcelaMista(p);
	      });
	    },
	    totalParcelasAdiantamento: function totalParcelasAdiantamento(parcelas, campo) {
	      return somaValores(parcelas || [], campo || 'valor');
	    },
	    quantidadeParcelasAdiantamento: function quantidadeParcelasAdiantamento(parcelas) {
	      var validas = _lodash2.default.filter(parcelas || [], function (p) {
	        return !_lodash2.default.isNil(p);
	      });
	      var comNumero = _lodash2.default.filter(validas, function (p) {
	        return !_lodash2.default.isNil(_lodash2.default.get(p, 'parcela')) && _lodash2.default.get(p, 'parcela') !== '';
	      });
	      var numerosDistintos = _lodash2.default.uniq(_lodash2.default.map(comNumero, function (p) {
	        return '' + p.parcela;
	      })).length;
	      return numerosDistintos + (validas.length - comNumero.length);
	    },
	    consolidarParcelasAdiantamento: function consolidarParcelasAdiantamento(parcelas) {
	      if (!_lodash2.default.isArray(parcelas) || parcelas.length === 0) return [];
	      var vm = this;
	      var validas = _lodash2.default.filter(parcelas, function (p) {
	        return !_lodash2.default.isNil(p);
	      });
	      var comNumero = _lodash2.default.filter(validas, function (p) {
	        return !_lodash2.default.isNil(_lodash2.default.get(p, 'parcela')) && _lodash2.default.get(p, 'parcela') !== '';
	      });
	      var semNumero = _lodash2.default.difference(validas, comNumero);
	      var grupos = _lodash2.default.groupBy(comNumero, function (p) {
	        return '' + p.parcela;
	      });
	      var consolidadas = _lodash2.default.flatten(_lodash2.default.map(grupos, function (grupo) {
	        return vm.consolidarGrupoParcelas(grupo);
	      }));
	      var soltas = _lodash2.default.map(semNumero, function (p) {
	        return vm.normalizarParcelaSimples(_lodash2.default.cloneDeep(p));
	      });
	      return _lodash2.default.orderBy(_lodash2.default.concat(consolidadas, soltas), [function (p) {
	        return numeroSeguro(_lodash2.default.get(p, 'parcela'));
	      }], ['asc']);
	    },
	    expandirParcelasAdiantamento: function expandirParcelasAdiantamento(parcelas) {
	      return _lodash2.default.flatMap(parcelas || [], function (p) {
	        if (codigoOrigem(_lodash2.default.get(p, 'origem')) !== ORIGEM_MISTA) {
	          return [_lodash2.default.omit(_lodash2.default.cloneDeep(p), CAMPOS_TRANSITORIOS)];
	        }
	
	        if (_lodash2.default.get(p, '_legadoSemBreakdown') === true) {
	          return [_lodash2.default.omit(_lodash2.default.cloneDeep(p), _lodash2.default.without(CAMPOS_TRANSITORIOS, '_legadoSemBreakdown'))];
	        }
	        var base = _lodash2.default.omit(_lodash2.default.cloneDeep(p), _lodash2.default.concat(CAMPOS_TRANSITORIOS, ['id', 'origem', 'valor']));
	        var monta = function monta(origem, valor, id) {
	          var linha = _lodash2.default.cloneDeep(base);
	          linha.origem = origem;
	          linha.valor = valor;
	          if (!_lodash2.default.isNil(id)) linha.id = id;
	          return linha;
	        };
	        return [monta(1, numeroSeguro(_lodash2.default.get(p, 'valor_fbb', 0)), _lodash2.default.get(p, 'id_fbb', null)), monta(5, numeroSeguro(_lodash2.default.get(p, 'valor_parc', 0)), _lodash2.default.get(p, 'id_parc', null))];
	      });
	    },
	    parcelasLegadasSemDesdobramento: function parcelasLegadasSemDesdobramento(parcelas) {
	      return _lodash2.default.filter(parcelas || [], ['_legadoSemBreakdown', true]);
	    },
	    consolidarGrupoParcelas: function consolidarGrupoParcelas(grupo) {
	      var vm = this;
	      var porOrigem = function porOrigem(codigo) {
	        return _lodash2.default.filter(grupo, function (p) {
	          return codigoOrigem(_lodash2.default.get(p, 'origem')) === codigo;
	        });
	      };
	      var linhasFbb = porOrigem(ORIGEM_FBB);
	      var linhasParc = porOrigem(ORIGEM_PARCEIRO);
	      var linhasMistas = porOrigem(ORIGEM_MISTA);
	
	      var mistasComValores = _lodash2.default.filter(linhasMistas, function (p) {
	        return !_lodash2.default.isNil(_lodash2.default.get(p, 'valor_fbb')) || !_lodash2.default.isNil(_lodash2.default.get(p, 'valor_parc'));
	      });
	      var mistasLegadas = _lodash2.default.difference(linhasMistas, mistasComValores);
	
	      var idsCanonicos = _lodash2.default.compact(_lodash2.default.map(_lodash2.default.union(linhasFbb, linhasParc), 'id'));
	      var mistasNovas = _lodash2.default.filter(mistasComValores, function (m) {
	        var refs = _lodash2.default.compact([_lodash2.default.get(m, 'id', null), _lodash2.default.get(m, 'id_fbb', null), _lodash2.default.get(m, 'id_parc', null)]);
	        return _lodash2.default.intersection(refs, idsCanonicos).length === 0;
	      });
	      var temFbb = linhasFbb.length > 0 || _lodash2.default.some(mistasNovas, function (m) {
	        return !_lodash2.default.isNil(_lodash2.default.get(m, 'valor_fbb'));
	      });
	      var temParc = linhasParc.length > 0 || _lodash2.default.some(mistasNovas, function (m) {
	        return !_lodash2.default.isNil(_lodash2.default.get(m, 'valor_parc'));
	      });
	      if (!temFbb || !temParc) {
	        return _lodash2.default.map(_lodash2.default.union(linhasFbb, linhasParc, mistasNovas, mistasLegadas), function (p) {
	          return vm.normalizarParcelaSimples(_lodash2.default.cloneDeep(p));
	        });
	      }
	      var parcela = _lodash2.default.cloneDeep(_lodash2.default.head(_lodash2.default.union(linhasFbb, linhasParc, mistasNovas)));
	      var valorFbb = somaValores(linhasFbb, 'valor') + somaValores(mistasNovas, 'valor_fbb');
	      var valorParc = somaValores(linhasParc, 'valor') + somaValores(mistasNovas, 'valor_parc');
	      _lodash2.default.set(parcela, 'origem', 0);
	      _lodash2.default.set(parcela, 'valor_fbb', valorFbb);
	      _lodash2.default.set(parcela, 'valor_parc', valorParc);
	
	      _lodash2.default.set(parcela, 'id_fbb', _lodash2.default.get(_lodash2.default.head(linhasFbb), 'id', _lodash2.default.get(_lodash2.default.head(mistasNovas), 'id_fbb', null)));
	      _lodash2.default.set(parcela, 'id_parc', _lodash2.default.get(_lodash2.default.head(linhasParc), 'id', _lodash2.default.get(_lodash2.default.head(mistasNovas), 'id_parc', null)));
	      _lodash2.default.set(parcela, 'valor', Math.round((valorFbb + valorParc) * 100) / 100);
	
	      var legadas = _lodash2.default.map(mistasLegadas, function (p) {
	        return vm.normalizarParcelaSimples(_lodash2.default.cloneDeep(p));
	      });
	      return _lodash2.default.concat([parcela], legadas);
	    },
	    normalizarParcelaSimples: function normalizarParcelaSimples(p) {
	      var codigo = codigoOrigem(_lodash2.default.get(p, 'origem'));
	      var valor = numeroSeguro(_lodash2.default.get(p, 'valor', 0));
	      if (codigo === ORIGEM_MISTA) {
	        var temFbb = !_lodash2.default.isNil(_lodash2.default.get(p, 'valor_fbb'));
	        var temParc = !_lodash2.default.isNil(_lodash2.default.get(p, 'valor_parc'));
	        if (!temFbb && !temParc) {
	          _lodash2.default.set(p, 'valor_fbb', null);
	          _lodash2.default.set(p, 'valor_parc', null);
	          _lodash2.default.set(p, '_legadoSemBreakdown', true);
	          _lodash2.default.set(p, 'valor', valor);
	          return p;
	        }
	        var valorFbb = numeroSeguro(_lodash2.default.get(p, 'valor_fbb', 0));
	        var valorParc = numeroSeguro(_lodash2.default.get(p, 'valor_parc', 0));
	        _lodash2.default.set(p, 'valor_fbb', valorFbb);
	        _lodash2.default.set(p, 'valor_parc', valorParc);
	        _lodash2.default.set(p, 'valor', Math.round((valorFbb + valorParc) * 100) / 100);
	        return p;
	      }
	
	      _lodash2.default.set(p, 'valor_fbb', codigo === ORIGEM_FBB ? valor : null);
	      _lodash2.default.set(p, 'valor_parc', codigo === ORIGEM_PARCEIRO ? valor : null);
	      _lodash2.default.set(p, 'valor', valor);
	      return p;
	    }
	  }
	};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(182);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(282);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(2);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(280);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(281);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _util = __webpack_require__(274);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Errors = function () {
	  function Errors() {
	    (0, _classCallCheck3.default)(this, Errors);
	
	    this.errors = {};
	  }
	
	  (0, _createClass3.default)(Errors, [{
	    key: 'set',
	    value: function set(field, messages) {
	      if ((typeof field === 'undefined' ? 'undefined' : (0, _typeof3.default)(field)) === 'object') {
	        this.errors = field;
	      } else {
	        this.set((0, _extends4.default)({}, this.errors, (0, _defineProperty3.default)({}, field, (0, _util.arrayWrap)(messages))));
	      }
	    }
	  }, {
	    key: 'all',
	    value: function all() {
	      return this.errors;
	    }
	  }, {
	    key: 'has',
	    value: function has(field) {
	      return this.errors.hasOwnProperty(field);
	    }
	  }, {
	    key: 'hasAny',
	    value: function hasAny() {
	      var _this = this;
	
	      for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	        fields[_key] = arguments[_key];
	      }
	
	      return fields.some(function (field) {
	        return _this.has(field);
	      });
	    }
	  }, {
	    key: 'any',
	    value: function any() {
	      return (0, _keys2.default)(this.errors).length > 0;
	    }
	  }, {
	    key: 'get',
	    value: function get(field) {
	      if (this.has(field)) {
	        return this.getAll(field)[0];
	      }
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll(field) {
	      return (0, _util.arrayWrap)(this.errors[field] || []);
	    }
	  }, {
	    key: 'only',
	    value: function only() {
	      var _this2 = this;
	
	      var messages = [];
	
	      for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        fields[_key2] = arguments[_key2];
	      }
	
	      fields.forEach(function (field) {
	        var message = _this2.get(field);
	
	        if (message) {
	          messages.push(message);
	        }
	      });
	
	      return messages;
	    }
	  }, {
	    key: 'flatten',
	    value: function flatten() {
	      return (0, _values2.default)(this.errors).reduce(function (a, b) {
	        return a.concat(b);
	      }, []);
	    }
	  }, {
	    key: 'clear',
	    value: function clear(field) {
	      var _this3 = this;
	
	      var errors = {};
	
	      if (field) {
	        (0, _keys2.default)(this.errors).forEach(function (key) {
	          if (key !== field) {
	            errors[key] = _this3.errors[key];
	          }
	        });
	      }
	
	      this.set(errors);
	    }
	  }]);
	  return Errors;
	}();
	
	exports.default = Errors;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(76);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(282);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(2);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(280);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(281);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Errors = __webpack_require__(272);
	
	var _Errors2 = _interopRequireDefault(_Errors);
	
	var _util = __webpack_require__(274);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Form = function () {
	  function Form() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Form);
	
	    this.busy = false;
	    this.successful = false;
	    this.errors = new _Errors2.default();
	    this.originalData = (0, _util.deepCopy)(data);
	
	    (0, _assign2.default)(this, data);
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'fill',
	    value: function fill(data) {
	      var _this = this;
	
	      this.keys().forEach(function (key) {
	        _this[key] = data[key];
	      });
	    }
	  }, {
	    key: 'data',
	    value: function data() {
	      var _this2 = this;
	
	      return this.keys().reduce(function (data, key) {
	        return (0, _extends4.default)({}, data, (0, _defineProperty3.default)({}, key, _this2[key]));
	      }, {});
	    }
	  }, {
	    key: 'keys',
	    value: function keys() {
	      return (0, _keys2.default)(this).filter(function (key) {
	        return !Form.ignore.includes(key);
	      });
	    }
	  }, {
	    key: 'startProcessing',
	    value: function startProcessing() {
	      this.errors.clear();
	      this.busy = true;
	      this.successful = false;
	    }
	  }, {
	    key: 'finishProcessing',
	    value: function finishProcessing() {
	      this.busy = false;
	      this.successful = true;
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.errors.clear();
	      this.successful = false;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var _this3 = this;
	
	      (0, _keys2.default)(this).filter(function (key) {
	        return !Form.ignore.includes(key);
	      }).forEach(function (key) {
	        _this3[key] = (0, _util.deepCopy)(_this3.originalData[key]);
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(url) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.submit('get', url, config);
	    }
	  }, {
	    key: 'post',
	    value: function post(url) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.submit('post', url, config);
	    }
	  }, {
	    key: 'patch',
	    value: function patch(url) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.submit('patch', url, config);
	    }
	  }, {
	    key: 'put',
	    value: function put(url) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.submit('put', url, config);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(url) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.submit('delete', url, config);
	    }
	  }, {
	    key: 'submit',
	    value: function submit(method, url) {
	      var _this4 = this;
	
	      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.startProcessing();
	
	      var data = method === 'get' ? { params: this.data() } : this.data();
	
	      return new _promise2.default(function (resolve, reject) {
	        axiosLaravel.request((0, _extends4.default)({ url: _this4.route(url), method: method, data: data }, config)).then(function (response) {
	          _this4.finishProcessing();
	
	          resolve(response);
	        }).catch(function (error) {
	          _this4.busy = false;
	
	          if (error.response) {
	            _this4.errors.set(_this4.extractErrors(error.response));
	          }
	
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'extractErrors',
	    value: function extractErrors(response) {
	      if (!response.data || (0, _typeof3.default)(response.data) !== 'object') {
	        return { error: Form.errorMessage };
	      }
	
	      if (response.data.errors) {
	        return (0, _extends4.default)({}, response.data.errors);
	      }
	
	      if (response.data.message) {
	        return { error: response.data.message };
	      }
	
	      return (0, _extends4.default)({}, response.data);
	    }
	  }, {
	    key: 'route',
	    value: function route(name) {
	      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var url = name;
	
	      if (Form.routes.hasOwnProperty(name)) {
	        url = decodeURI(Form.routes[name]);
	      }
	
	      if ((typeof parameters === 'undefined' ? 'undefined' : (0, _typeof3.default)(parameters)) !== 'object') {
	        parameters = { id: parameters };
	      }
	
	      (0, _keys2.default)(parameters).forEach(function (key) {
	        url = url.replace('{' + key + '}', parameters[key]);
	      });
	
	      return url;
	    }
	  }, {
	    key: 'onKeydown',
	    value: function onKeydown(event) {
	      if (event.target.name) {
	        this.errors.clear(event.target.name);
	      }
	    }
	  }]);
	  return Form;
	}();
	
	Form.routes = {};
	Form.errorMessage = 'Something went wrong. Please try again.';
	Form.ignore = ['busy', 'successful', 'errors', 'originalData'];
	
	exports.default = Form;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.deepCopy = deepCopy;
	exports.arrayWrap = arrayWrap;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deepCopy(obj) {
	  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
	    return obj;
	  }
	
	  var copy = Array.isArray(obj) ? [] : {};
	
	  (0, _keys2.default)(obj).forEach(function (key) {
	    copy[key] = deepCopy(obj[key]);
	  });
	
	  return copy;
	}
	
	function arrayWrap(value) {
	  return Array.isArray(value) ? value : [value];
	}

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAApCAYAAAD+tu2AAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATRSURBVHgB7ZtPbhxFFMa/qh5HkbCSBjZsYppIjoSEZHMAxMwJTNYIMjmBbQUWrGZmxYZgcwJPIrGOOcEMcADGK6REoI6zYRVawkiRPV2PV22P7Vgmrr9OFvXb2KMpV7+ur77q6nrPQCKRSCQSiUQikUgkTiEQkKKf53hrfhlSrEj+SAL57DsiTED4ufzq2TYuiSejvI1MrvDVC/6Yn3wjJlSLnRr1+MNOVeIS2Mrn2xnkMv+6JCCKU19VBPVTjWx8twofSxCBtbDy+rVVUljDSwN5LpUAbav9g0H5zV8lAvPbKM/nW3JVcCx0cSwQAsODWg1iCf0wz7t8v3f417ZB8/EU9eButTdGILwFvvn9wiq7sw+DwTxDSaBBee/ZEIHQjhVSbrGwBWyR6C9+8nyAQGzledECbcFM2JfgCTE8gFxnR1fwxEvgmxsLPXZtHx4IHtg/13e9B/aPX/NVpeQmfBA03qvp9scdv4FlcZdZ3BHsJ/1JKGyAA4iO77It4UgIcTW6D90XPAgibhOMaM9n4hE8CCFuEwqvQnPcj14J4IGTwMX9G90Q4s7QfRX3F9bgwO+jvAgi7nEwov3kl3c24IAWg0XRE8RL3ONQeKiPlnlnrAUuvn2v4F2gl+POg5ekXrGRWw/MnJQjhIaw1uzAbWOB6jk9/19N+2F+zWnya+wdfGVOi1sgPDmmdjfyePRul+LEAmR2k1i7lyC6iIA2FPfvtCpYC8wX+wyR4A3Xqo2LRYY7iIVeqi1crN2LeOQZVBcOWAlcfHdDixvk+fI/sIvnl00a6mcvn560EREF2TZvLSza2sPGWoEDlg6OexOHl4DRCjGHzGgi+CAz+tSknd45R3tUnOB0v1YCCymWEBshC5NmNSi6wIJEYdKuhdqonSf5j/nV92GJ83twNIiuG7YsEBlTVxKymI+tY/Zx9W1Y8uYJnAiKlcBEyvtsNCAl4mN0vwL1pYzLFbz4G5bYOZjEU0SHdkxa8a6yRGyIJibNpsiM2nlSfV69sB5/S4HVJeRyxdik1Rzq6LEQCaPJphMCZOh2D5wmkZ3ArZa+SMwbqUwLAj7QGR9hNhlc2Ycamrbl1OcDRISgnPq3ErhcLytODPyASPB5tJUrqa7jDSrR+KNOZewaCRltReHVofyy+mcIB+x30a0mcxPDxaWS0iovfKtTDWO5mIjWbdp/UVVjRHOxcs6XWwvcuBgIVvkwo6nuWC9LWMIuthLCCIXBLQv3zphC6jKhEmGZuLpX4/QeXN7b3eSlOpjIui/X0p1GCKUCikyTxc7zPhzQJTY1xO1QGy49WabcHzxwPugov97thxC5EZf7ggeLnWoziMj83N1T1IEHLPKERe74Oln/fR2gZMe76E5XdxwVABSwozoSN1g1xuNRrkt2H50pSzWDY3F17nno/HAGGgmnI1XxYAqsvfaiuxnFRlGgVn0hoFNaF5bNNjtx3qzp5zkiwEJ3WeiekdBE21PeUMUsm+WL9AyFHrMkg8MNWxiCFr5rDnPGon068yQIlSJ62hyU8Lt0LGHPohP2OqebCVoiyGbiCSiORZ/Iicm/fFjiW0Fpik4pctK+zZNOpyBP/iEAVPKPnZpfs2IUvicSiUQikUgkEolEIjrigs+vizcljvOIFtt/R5veHWVQOqAAAAAASUVORK5CYII="

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1282)
	
	/* script */
	__vue_exports__ = __webpack_require__(619)
	
	/* template */
	var __vue_template__ = __webpack_require__(1868)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1a1d1e04"
	
	module.exports = __vue_exports__


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1525)
	
	/* script */
	__vue_exports__ = __webpack_require__(651)
	
	/* template */
	var __vue_template__ = __webpack_require__(2109)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-fff31510"
	
	module.exports = __vue_exports__


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1258)
	
	/* script */
	__vue_exports__ = __webpack_require__(674)
	
	/* template */
	var __vue_template__ = __webpack_require__(1845)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-01fea68d"
	
	module.exports = __vue_exports__


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1419)
	
	/* script */
	__vue_exports__ = __webpack_require__(677)
	
	/* template */
	var __vue_template__ = __webpack_require__(2007)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1484)
	
	/* script */
	__vue_exports__ = __webpack_require__(681)
	
	/* template */
	var __vue_template__ = __webpack_require__(2071)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bfb6b7a8"
	
	module.exports = __vue_exports__


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1377)
	
	/* script */
	__vue_exports__ = __webpack_require__(682)
	
	/* template */
	var __vue_template__ = __webpack_require__(1965)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-594c8bbb"
	
	module.exports = __vue_exports__


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1455)
	
	/* script */
	__vue_exports__ = __webpack_require__(686)
	
	/* template */
	var __vue_template__ = __webpack_require__(2043)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-99098576"
	
	module.exports = __vue_exports__


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(701)
	
	/* template */
	var __vue_template__ = __webpack_require__(1883)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1493)
	
	/* script */
	__vue_exports__ = __webpack_require__(705)
	
	/* template */
	var __vue_template__ = __webpack_require__(2082)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1322)
	
	/* script */
	__vue_exports__ = __webpack_require__(710)
	
	/* template */
	var __vue_template__ = __webpack_require__(1909)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1492)
	
	/* script */
	__vue_exports__ = __webpack_require__(712)
	
	/* template */
	var __vue_template__ = __webpack_require__(2081)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ce974ae8"
	
	module.exports = __vue_exports__


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1454)
	
	/* script */
	__vue_exports__ = __webpack_require__(723)
	
	/* template */
	var __vue_template__ = __webpack_require__(2042)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-985f90ee"
	
	module.exports = __vue_exports__


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1303)
	
	/* script */
	__vue_exports__ = __webpack_require__(732)
	
	/* template */
	var __vue_template__ = __webpack_require__(1887)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-279c1892"
	
	module.exports = __vue_exports__


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1265)
	
	/* script */
	__vue_exports__ = __webpack_require__(734)
	
	/* template */
	var __vue_template__ = __webpack_require__(1853)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1364)
	
	/* script */
	__vue_exports__ = __webpack_require__(750)
	
	/* template */
	var __vue_template__ = __webpack_require__(1951)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-510d2594"
	
	module.exports = __vue_exports__


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1509)
	__webpack_require__(1510)
	
	/* script */
	__vue_exports__ = __webpack_require__(757)
	
	/* template */
	var __vue_template__ = __webpack_require__(2095)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e888493a"
	
	module.exports = __vue_exports__


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1422)
	
	/* script */
	__vue_exports__ = __webpack_require__(763)
	
	/* template */
	var __vue_template__ = __webpack_require__(2010)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-71ec1dd4"
	
	module.exports = __vue_exports__


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1499)
	
	/* script */
	__vue_exports__ = __webpack_require__(764)
	
	/* template */
	var __vue_template__ = __webpack_require__(2087)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d8bf636a"
	
	module.exports = __vue_exports__


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1302)
	
	/* script */
	__vue_exports__ = __webpack_require__(776)
	
	/* template */
	var __vue_template__ = __webpack_require__(1886)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-27667614"
	
	module.exports = __vue_exports__


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1495)
	
	/* script */
	__vue_exports__ = __webpack_require__(795)
	
	/* template */
	var __vue_template__ = __webpack_require__(2084)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1414)
	
	/* script */
	__vue_exports__ = __webpack_require__(800)
	
	/* template */
	var __vue_template__ = __webpack_require__(2002)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1410)
	
	/* script */
	__vue_exports__ = __webpack_require__(810)
	
	/* template */
	var __vue_template__ = __webpack_require__(1998)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6c2c49af"
	
	module.exports = __vue_exports__


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1369)
	
	/* script */
	__vue_exports__ = __webpack_require__(834)
	
	/* template */
	var __vue_template__ = __webpack_require__(1957)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5335272b"
	
	module.exports = __vue_exports__


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1447)
	
	/* script */
	__vue_exports__ = __webpack_require__(858)
	
	/* template */
	var __vue_template__ = __webpack_require__(2035)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8929ecb0"
	
	module.exports = __vue_exports__


/***/ }),
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var validator = {
	  validate: function validate(value) {
	    var agencia = value.replace('-', '');
	    return agencia.length === 5 && agencia !== '00000';
	  }
	};
	exports.default = validator;

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var validator = {
	  validate: function validate(value) {
	    var conta = value.replace('-', '');
	    return conta.length > 3 && conta !== '000' && conta !== '0000' && conta !== '00000' && conta !== '000000' && conta !== '0000000' && conta !== '0000000000';
	  }
	};
	exports.default = validator;

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function calcChecker1(firstNineDigits) {
	  var sum = null;
	
	  for (var j = 0; j < 9; ++j) {
	    sum += firstNineDigits.toString().charAt(j) * (10 - j);
	  }
	
	  var lastSumChecker1 = sum % 11;
	  var checker1 = lastSumChecker1 < 2 ? 0 : 11 - lastSumChecker1;
	
	  return checker1;
	}
	
	function calcChecker2(cpfWithChecker1) {
	  var sum = null;
	
	  for (var k = 0; k < 10; ++k) {
	    sum += cpfWithChecker1.toString().charAt(k) * (11 - k);
	  }
	  var lastSumChecker2 = sum % 11;
	  var checker2 = lastSumChecker2 < 2 ? 0 : 11 - lastSumChecker2;
	
	  return checker2;
	}
	
	function cleaner(value) {
	  if (value) {
	    var digits = value.replace(/[^\d]/g, '');
	    return digits;
	  }
	}
	
	function validate(value) {
	  if (!value) {
	    return true;
	  }
	  var cleanCPF = cleaner(value);
	  var firstNineDigits = cleanCPF.substring(0, 9);
	  var checker = cleanCPF.substring(9, 11);
	  var result = false;
	
	  for (var i = 0; i < 10; i++) {
	    if (firstNineDigits + checker === Array(12).join(i)) {
	      return false;
	    }
	  }
	
	  var checker1 = calcChecker1(firstNineDigits);
	  var checker2 = calcChecker2('' + firstNineDigits + checker1);
	
	  if (checker.toString() === checker1.toString() + checker2.toString()) {
	    result = true;
	  } else {
	    result = false;
	  }
	  return result;
	}
	exports.default = validate;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validator = {
	  validate: function validate(value) {
	    var newdate = (0, _moment2.default)(value, 'DD/MM/YYYY', true);
	    if (newdate.isValid()) {
	      var datenow = (0, _moment2.default)();
	      return newdate.isSameOrAfter(datenow, 'date');
	    } else {
	      return false;
	    }
	  }
	};
	exports.default = validator;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validator = {
	  validate: function validate(value) {
	    var newdate = (0, _moment2.default)(value, 'DD/MM/YYYY', true);
	    if (newdate.isValid()) {
	      var datenow = (0, _moment2.default)();
	      return newdate.isSameOrBefore(datenow, 'date');
	    } else {
	      return false;
	    }
	  }
	};
	exports.default = validator;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(124);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dictionary = {
	  pt: {
	    messages: {
	      cpf: function cpf() {
	        return 'CPF inválido';
	      },
	      cnpj: function cnpj() {
	        return 'CNPJ inválido';
	      },
	      required: function required(field) {
	        return 'O campo ' + field + ' \xE9 obrigat\xF3rio.';
	      },
	      confirmed: function confirmed(field) {
	        return 'O campo ' + field + ' n\xE3o tem o mesmo valor.';
	      },
	      email: function email(field) {
	        return 'O valor do campo ' + field + ' n\xE3o \xE9 v\xE1lido.';
	      },
	      min: function min(field) {
	        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [],
	            _ref2 = (0, _slicedToArray3.default)(_ref, 1),
	            tamanho = _ref2[0];
	
	        return 'O campo ' + field + ' deve conter pelo menos ' + tamanho + ' caracteres.';
	      },
	      max: function max(field) {
	        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [],
	            _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
	            tamanho = _ref4[0];
	
	        return 'O campo ' + field + ' n\xE3o deve ter mais que ' + tamanho + ' caracteres.';
	      },
	      max_value: function max_value(field) {
	        return 'O valor do campo ' + field + ' \xE9 maior que o permitido.';
	      },
	      min_value: function min_value(field) {
	        return 'O valor do campo ' + field + ' \xE9 menor que o permitido.';
	      },
	      numeric: function numeric(field) {
	        return 'O valor do campo ' + field + ' tem que ser num\xE9rico.';
	      },
	      decimal: function decimal(field) {
	        return 'O valor do campo ' + field + ' tem que ser decimal.';
	      },
	      size: function size(field) {
	        return 'Tamanho do arquivo superiror ao permitido';
	      },
	      mimes: function mimes(field) {
	        return 'Tipo do arquivo n\xE3o permitido';
	      },
	      validdate: function validdate(field) {
	        return 'A data informada n\xE3o \xE9 v\xE1lida.';
	      },
	      dateeqpast: function dateeqpast(field) {
	        return 'A data informada deve ser igual ou anterior a hoje.';
	      },
	      dateeqfuture: function dateeqfuture(field) {
	        return 'A data informada deve ser posterior a hoje.';
	      },
	      agency: function agency(field) {
	        return 'Formato da ag\xEAncia esta incorreto';
	      },
	      contacorrente: function contacorrente(field) {
	        return 'Formato da conta corrente esta incorreto';
	      }
	    }
	  }
	};
	exports.default = dictionary;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validator = {
	  validate: function validate(value) {
	    var newdate = (0, _moment2.default)(value, 'DD/MM/YYYY', true);
	    return newdate.isValid();
	  }
	};
	exports.default = validator;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buscaCategorizadores = undefined;
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buscaCategorizadores = exports.buscaCategorizadores = {
	  methods: {
	    buscaCategorizadores: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(store) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!_.isEmpty(store.state.categorizadores)) {
	                  _context.next = 3;
	                  break;
	                }
	
	                _context.next = 3;
	                return axiosLaravel.get('categorizadores/').then(function (response) {
	                  store.commit('SET_CATEGORIZADORES', response.data);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function buscaCategorizadores(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return buscaCategorizadores;
	    }()
	  }
	};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buscaFormasJuridicas = undefined;
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buscaFormasJuridicas = exports.buscaFormasJuridicas = {
	  methods: {
	    buscaFormasJuridicas: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(store) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!_.isEmpty(store.state.formasJuridicas)) {
	                  _context.next = 3;
	                  break;
	                }
	
	                _context.next = 3;
	                return axiosLaravel.get('formas-juridicas/').then(function (response) {
	                  store.commit('SET_FORMAS_JURIDICAS', response.data);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function buscaFormasJuridicas(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return buscaFormasJuridicas;
	    }()
	  }
	};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buscaQuestionarioRisco = undefined;
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buscaQuestionarioRisco = exports.buscaQuestionarioRisco = {
	  methods: {
	    buscaQuestionarioRisco: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(store) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!_.isEmpty(store.state.questionarioRisco)) {
	                  _context.next = 3;
	                  break;
	                }
	
	                _context.next = 3;
	                return axiosLaravel.get('questionario-risco/').then(function (response) {
	                  store.commit('SET_QUESTIONARIO', response.data);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function buscaQuestionarioRisco(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return buscaQuestionarioRisco;
	    }()
	  }
	};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buscaRamoAtividades = undefined;
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buscaRamoAtividades = exports.buscaRamoAtividades = {
	  methods: {
	    buscaRamoAtividades: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(store) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!_.isEmpty(store.state.ramoAtividades)) {
	                  _context.next = 3;
	                  break;
	                }
	
	                _context.next = 3;
	                return axiosLaravel.get('ramo-atividades/').then(function (response) {
	                  store.commit('SET_RAMO_ATIVIDADES', response.data);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function buscaRamoAtividades(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return buscaRamoAtividades;
	    }()
	  }
	};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buscatiposRegistros = undefined;
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buscatiposRegistros = exports.buscatiposRegistros = {
	  methods: {
	    buscatiposRegistros: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(store) {
	        var _this = this;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!_.isEmpty(store.state.tipoRegistros)) {
	                  _context2.next = 3;
	                  break;
	                }
	
	                _context2.next = 3;
	                return axiosLaravel.get('tipo-registros/').then(function () {
	                  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(response) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            store.commit('SET_TIPOREGISTROS', response.data);
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function buscatiposRegistros(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return buscatiposRegistros;
	    }()
	  }
	};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formataNumero = undefined;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formataNumero = exports.formataNumero = {
	  methods: {
	    formataNumero: function formataNumero(numero, formato) {
	      if (formato === 'moeda') {
	        return 'R$ ' + numero.toLocaleString('pt-BR', {
	          minimumFractionDigits: 2,
	          maximumFractionDigits: 2
	        });
	      } else if (formato === 'percentual') {
	        return (numero * 100).toLocaleString('pt-BR', {
	          minimumFractionDigits: 2,
	          maximumFractionDigits: 2
	        });
	      } else if (formato === 'inteiro' || formato === 'numerico') {
	        return numero.toLocaleString('pt-BR', {
	          minimumFractionDigits: 0,
	          maximumFractionDigits: 0
	        });
	      } else if (formato === 'data') {
	        if (_.isEmpty(numero)) {
	          return null;
	        } else {
	          return (0, _moment2.default)(numero).format('L');
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getOwnPropertyNames = __webpack_require__(279);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _promise = __webpack_require__(76);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _docxtemplater = __webpack_require__(356);
	
	var _docxtemplater2 = _interopRequireDefault(_docxtemplater);
	
	var _pizzip = __webpack_require__(492);
	
	var _pizzip2 = _interopRequireDefault(_pizzip);
	
	var _index = __webpack_require__(498);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _fileSaver = __webpack_require__(360);
	
	var _extenso = __webpack_require__(359);
	
	var _extenso2 = _interopRequireDefault(_extenso);
	
	var _parcelasAdiantamento = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helperParcelas = _parcelasAdiantamento.parcelasAdiantamento.methods;
	
	var SIMPLIFICADA = '../../static/docs/modelos/Minuta Convenio RP - Modelo Processo Simplificado.docx';
	var SIMPLIFICADA_PUBLICA = '../../static/docs/modelos/Minuta Convenio RP - Modelo Processo Simplificado_-_Entidade_publica.docx';
	var SIMPLIFICADA_PRIVADA = '../../static/docs/modelos/Minuta Convenio RP - Modelo Processo Simplificado_-_Entidade_privada.docx';
	var COM_ADIANTAMENTO_PRIVADA = '../../static/docs/modelos/Minuta_Convenio_RP_-_COM_Adiant_-_Entidade_privada.docx';
	var COM_ADIANTAMENTO_PUBLICA = '../../static/docs/modelos/Minuta_Convenio_RP_-_COM_Adiant_-_Entidade_publica.docx';
	var SEM_ADIANTAMENTO_PRIVADA = '../../static/docs/modelos/Minuta_Convenio_RP_-_SEM_Adiant_-_Entidade_privada.docx';
	var SEM_ADIANTAMENTO_PUBLICA = '../../static/docs/modelos/Minuta_Convenio_RP_-_SEM_Adiant_-_Entidade_publica.docx';
	
	var MULHERES_NEGRAS_CONVENIO = '../../static/docs/modelos/Minuta_de_Convenio_Mulheres_Negras_simplificado.docx';
	var CATAFORTE = '../../static/docs/modelos/Minuta_Edital_Cataforte.docx';
	var ECOFORTE = '../../static/docs/modelos/Minuta_Edital_Ecoforte.docx';
	var ECOFORTE_AMAZONIA = '../../static/docs/modelos/Minuta_Edital_Ecoforte_Fundo_Amazonia.docx';
	var POVOS_PRIORIZADOS_SEM_ADIANTAMENTO = '../../static/docs/modelos/Minuta_Convenio_RP_SEM_Adiant___Povos_priorizados_dirigentes.docx';
	var POVOS_PRIORIZADOS_COM_ADIANTAMENTO = '../../static/docs/modelos/Minuta_Convenio_RP_-_COM_Adiant___Povos_priorizados_dirigentes.docx';
	
	
	function loadFile(url, callback) {
	  _index2.default.getBinaryContent(url, callback);
	}
	function formatarNumero(numero) {
	  return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	}
	function formatarRG(rg) {
	  rg = rg.replace(/\D/g, '');
	
	  return rg.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4');
	}
	function formatarCEP(cep) {
	  cep = cep.replace(/\D/g, '');
	
	  return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
	}
	function numeroPorExtenso(numero) {
	  var tipo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'INTEIRO';
	
	  var numeroExtenso = '';
	  if (tipo === 'MOEDA') {
	    numero = '' + _.toNumber(numero).toFixed(2).replace('.', ',');
	
	    numeroExtenso = (0, _extenso2.default)(numero, { mode: 'currency', number: { decimalSeparator: 'comma' } });
	  } else if (tipo === 'INTEIRO') {
	    numero = '' + _.toNumber(numero).toLocaleString('en-US');
	    numeroExtenso = (0, _extenso2.default)(numero);
	  }
	  return numeroExtenso;
	}
	function formatarMoeda(numero) {
	  return _.toNumber(numero).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
	function formatarCPF(cpf) {
	  cpf = cpf.replace(/\D/g, '');
	
	  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
	}
	function formatarCNPJ(cnpj) {
	  cnpj = ('' + cnpj).toUpperCase().replace(/[^0-9A-Z]/g, '');
	
	  return cnpj.replace(/([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})/, '$1.$2.$3/$4-$5');
	}
	var OBJETOBASE = {
	  data_extenso: '[DATA POR EXTENSO]',
	  entidade_personjuridica: '[PERSONALIDADE JURÍDICA]',
	  agencia_prefixo: '[AGÊNCIA PREFIXO]',
	  agencia_nome_uf: '[AGÊNCIA NOME UF]',
	  agencia_cnpj: '[AGÊNCIA CNPJ]',
	  entidade_municipio: '[ENTIDADE MUNICIPIO]',
	  entidade_endereco: '[ENTIDADE ENDEREÇO]',
	  entidade_cep: '[ENTIDADE CEP]',
	  entidade_cnpj: '[ENTIDADE CNPJ]',
	  gerente_nome: '[GERENTE NOME]',
	  gerente_estcivil: '[GERENTE EST.CIVIL]',
	  gerente_tipodoc: '[GERENTE TIPO DOCUMENTO]',
	  gerente_numerodoc: '[GERENTE NUMERO DOCUMENTO]',
	  gerente_cpf: '[GERENTE CPF]',
	  gerente_municipio: '[GERENTE MUNICÍPIO]',
	  representante_funcao: '[REPRESENTANTE FUNÇÃO]',
	  representante_nome: '[REPRESENTANTE NOME]',
	  representante_estcivil: '[REPRESENTANTE EST.CIVIL]',
	  representante_profissao: '[REPRESENTANTE PROFISSÃO]',
	  representante_tipodoc: '[REPRESENTANTE TIPO DOCUMENTO]',
	  representante_numerodoc: '[REPRESENTANTE NUMERO DOCUMENTO]',
	  representante_municipio: '[REPRESENTANTE MUNICÍPIO]',
	  representante_cpf: '[REPRESENTANTE CPF]',
	  representante_fundacao_funcao: '[REPRESENTANTE FUNDAÇÃO FUNÇÃO]',
	  representante_fundacao_nome: '[REPRESENTANTE FUNDAÇÃO NOME]',
	  representante_fundacao_estcivil: '[REPRESENTANTE FUNDAÇÃO EST.CIVIL]',
	  representante_fundacao_profissao: '[REPRESENTANTE FUNDAÇÃO PROFISSÃO]',
	  representante_fundacao_tipodoc: '[REPRESENTANTE FUNDAÇÃO TIPO DOCUMENTO]',
	  representante_fundacao_numerodoc: '[REPRESENTANTE FUNDAÇÃO NUMERO DOCUMENTO]',
	  representante_fundacao_municipio: '[REPRESENTANTE FUNDAÇÃO MUNICÍPIO]',
	  representante_fundacao_cpf: '[REPRESENTANTE FUNDACAO CPF]',
	  proposta_edital: '[EDITAL DA PROPOSTA]',
	  projeto_numero: '[No DO PROJETO]',
	  projeto_titulo: '[TITULO DO PROJETO]',
	  proposta_objeto_resumo: '[RESUMO DA PROPOSTA]',
	  valor_total: '[VALOR TOTAL]',
	  valor_total_extenso: '[VALOR TOTAL POR EXTENSO]',
	  valor_fundacao: '[VALOR FUNDAÇÃO]',
	  valor_fundacao_extenso: '[VALOR FUNDAÇÃO POR EXTENSO]',
	  valor_terceiros: '[VALOR TERCEIROS]',
	  valor_terceiros_extenso: '[VALOR TERCEIROS POR EXTENSO]',
	  valor_convenente: '[VALOR CONVENENTE]',
	  valor_convenente_extenso: '[VALOR CONVENENTE POR EXTENSO]',
	  proposta_vigencia: '[PROPOSTA VIGÊNCIA]',
	  proposta_vigencia_extenso: '[PROPOSTA VIGÊNCIA POR EXTENSO]',
	  periodicidade_de_relatorio_meses: '[PERIODICIDADE DE RELATORIO EM MESES]',
	  total_adiantamento: '[TOTAL ADIANTAMENTO]',
	  numero_parcelas: '[NUMERO PARCELAS]',
	  total_adiantamento_extenso: '[TOTAL ADIANTAMENTO POR EXTENSO]',
	  parcelas_adiantamento: '[PARCELAS ADIANTAMENTO]',
	  primeira_testemunha_nome: '[NOME TESTEMUNHA]',
	  primeira_testemunha_cpf: '[CPF TESTEMUNHA]',
	  segunda_testemunha_nome: '[NOME TESTEMUNHA]',
	  segunda_testemunha_cpf: '[CPF TESTEMUNHA]',
	  proposta_conta_adiantamento: '[CONTA DE ADIANTAMENTO DA PROPOSTA]',
	  proposta_agencia_adiantamento: '[AGENCIA DE ANDIANTAMENTO DA PROPOSTA]',
	  proposta_conta_deb: '[CONTA DEB]',
	  proposta_agencia_deb: '[AGENCIA DEB]',
	  representantes: '[REPRESENTANTES]'
	};
	function adaptaObjeto(objeto, isPublica) {
	  var novoObjeto = OBJETOBASE;
	
	  var dataAtual = new Date();
	  var opcoes = { year: 'numeric', month: 'long', day: 'numeric' };
	  novoObjeto.data_extenso = dataAtual.toLocaleDateString('pt-BR', opcoes);
	
	  objeto.entidade_nome ? novoObjeto.entidade_nome = objeto.entidade_nome.trimStart().toUpperCase() : null;
	  objeto.entidade_municipio ? novoObjeto.entidade_municipio = objeto.entidade_municipio + ' (' + objeto.entidade_uf + ')' : null;
	  objeto.entidade_cep ? novoObjeto.entidade_cep = formatarCEP(objeto.entidade_cep) : null;
	  objeto.entidade_cnpj ? novoObjeto.entidade_cnpj = formatarCNPJ(objeto.entidade_cnpj) : null;
	  objeto.entidade_endereco ? novoObjeto.entidade_endereco = objeto.entidade_endereco : null;
	
	  objeto.entidade_forma_juridica ? novoObjeto.entidade_personjuridica = isPublica ? 'público' : 'privado' : null;
	
	  if (objeto.agencia) {
	    objeto.agencia.cnpj ? novoObjeto.agencia_cnpj = formatarCNPJ(objeto.agencia.cnpj) : null;
	    objeto.agencia.nomeAgencia ? novoObjeto.agencia_nome_uf = objeto.agencia.nomeAgencia : null;
	    objeto.agencia.agencia ? novoObjeto.agencia_prefixo = objeto.agencia.agencia : null;
	
	    objeto.agencia.informacoesGerenteGeral.nome ? novoObjeto.gerente_nome = objeto.agencia.informacoesGerenteGeral.nome : null;
	    objeto.agencia.informacoesGerenteGeral.cpf ? novoObjeto.gerente_cpf = formatarCPF(objeto.agencia.informacoesGerenteGeral.cpf) : null;
	    if (objeto.agencia.informacoesGerenteGeral.estadoCivil) {
	      var estadoCivil = objeto.agencia.informacoesGerenteGeral.estadoCivil;
	      estadoCivil = estadoCivil.charAt(0).toUpperCase() + estadoCivil.slice(1) + '(a)';
	      novoObjeto.gerente_estcivil = estadoCivil;
	    } else {
	      novoObjeto.gerente_estcivil = null;
	    }
	    objeto.agencia.informacoesGerenteGeral.municipioResidencia ? novoObjeto.gerente_municipio = objeto.agencia.informacoesGerenteGeral.municipioResidencia : null;
	
	    objeto.agencia.informacoesGerenteGeral.rg ? novoObjeto.gerente_numerodoc = formatarRG(objeto.agencia.informacoesGerenteGeral.rg) : null;
	    objeto.agencia.informacoesGerenteGeral.rg ? novoObjeto.gerente_tipodoc = 'RG' : null;
	  }
	
	  objeto.representante_fundacao_nome ? novoObjeto.representante_fundacao_nome = objeto.representante_fundacao_nome : null;
	  objeto.representante_fundacao_cargo ? novoObjeto.representante_fundacao_cargo = objeto.representante_fundacao_cargo : null;
	  if (objeto.representante_fundacao_estado_civil) {
	    var _estadoCivil = objeto.representante_fundacao_estado_civil;
	    _estadoCivil = _estadoCivil.charAt(0).toUpperCase() + _estadoCivil.slice(1) + '(a)';
	    novoObjeto.representante_fundacao_estcivil = _estadoCivil;
	  } else {
	    novoObjeto.representante_fundacao_estcivil = null;
	  }
	  objeto.representante_fundacao_tipo_documento ? novoObjeto.representante_fundacao_tipodoc = objeto.representante_fundacao_tipo_documento : null;
	  objeto.representante_fundacao_numero_documento ? novoObjeto.representante_fundacao_numerodoc = objeto.representante_fundacao_numero_documento : null;
	  objeto.representante_fundacao_cpf ? novoObjeto.representante_fundacao_cpf = formatarCPF(objeto.representante_fundacao_cpf) : null;
	  objeto.representante_fundacao_endereco ? novoObjeto.representante_fundacao_endereco = objeto.representante_fundacao_endereco : null;
	  objeto.representante_fundacao_municipio ? novoObjeto.representante_fundacao_municipio = objeto.representante_fundacao_municipio : null;
	
	  objeto.representantes_entidade.endereco.ds_cidade ? novoObjeto.representante_municipio = objeto.representantes_entidade.endereco.ds_cidade : null;
	
	  objeto.proposta_edital ? novoObjeto.proposta_edital = objeto.proposta_edital : novoObjeto.proposta_edital = 'N/A';
	  objeto.projeto_numero ? novoObjeto.projeto_numero = formatarNumero(objeto.projeto_numero) : null;
	  objeto.projeto_titulo ? novoObjeto.projeto_titulo = objeto.projeto_titulo : null;
	  if (objeto.proposta_objeto_resumo) {
	    var resumo = objeto.proposta_objeto_resumo;
	    resumo = resumo.substring(0, 1).toLowerCase() + resumo.substring(1);
	    if (resumo.endsWith('.')) {
	      resumo = resumo.slice(0, -1) + ',';
	    } else {
	      resumo += ',';
	    }
	    novoObjeto.proposta_objeto_resumo = resumo;
	  } else {
	    novoObjeto.proposta_objeto_resumo = null;
	  }
	
	  objeto.proposta_valor_fbb ? novoObjeto.valor_fundacao = formatarMoeda(objeto.proposta_valor_fbb) : null;
	  objeto.proposta_valor_fbb ? novoObjeto.valor_fundacao_extenso = numeroPorExtenso(objeto.proposta_valor_fbb, 'MOEDA') : null;
	  objeto.proposta_valor_terceiros ? novoObjeto.valor_terceiros = formatarMoeda(objeto.proposta_valor_terceiros) : null;
	  objeto.proposta_valor_terceiros ? novoObjeto.valor_terceiros_extenso = numeroPorExtenso(objeto.proposta_valor_terceiros, 'MOEDA') : null;
	  objeto.proposta_valor_contrapartida ? novoObjeto.valor_convenente = formatarMoeda(objeto.proposta_valor_contrapartida) : null;
	  objeto.proposta_valor_contrapartida ? novoObjeto.valor_convenente_extenso = numeroPorExtenso(objeto.proposta_valor_contrapartida, 'MOEDA') : null;
	
	  if (objeto.proposta_valor_fbb && objeto.proposta_valor_contrapartida) {
	    novoObjeto.valor_total = formatarMoeda(_.toNumber(objeto.proposta_valor_fbb) + _.toNumber(objeto.proposta_valor_contrapartida));
	    novoObjeto.valor_total_extenso = numeroPorExtenso(_.toNumber(objeto.proposta_valor_fbb) + _.toNumber(objeto.proposta_valor_contrapartida), 'MOEDA');
	  } else if (objeto.proposta_valor_fbb && !objeto.proposta_valor_contrapartida) {
	    novoObjeto.valor_total = formatarMoeda(objeto.proposta_valor_fbb);
	    novoObjeto.valor_total_extenso = numeroPorExtenso(objeto.proposta_valor_fbb, 'MOEDA');
	  } else if (!objeto.proposta_valor_fbb && objeto.proposta_valor_contrapartida && !objeto.proposta_valor_terceiros) {
	    novoObjeto.valor_total = formatarMoeda(objeto.proposta_valor_contrapartida);
	    novoObjeto.valor_total_extenso = numeroPorExtenso(objeto.proposta_valor_contrapartida, 'MOEDA');
	  } else if (objeto.proposta_valor_contrapartida && objeto.proposta_valor_terceiros) {
	    novoObjeto.valor_total = formatarMoeda(_.toNumber(objeto.proposta_valor_contrapartida) + _.toNumber(objeto.proposta_valor_terceiros));
	    novoObjeto.valor_total_extenso = numeroPorExtenso(_.toNumber(objeto.proposta_valor_contrapartida) + _.toNumber(objeto.proposta_valor_terceiros), 'MOEDA');
	  } else {
	    novoObjeto.valor_total = null;
	    novoObjeto.valor_total_extenso = null;
	  }
	
	  objeto.proposta_periodicidade_formulario ? novoObjeto.periodicidade_de_relatorio_meses = objeto.proposta_periodicidade_formulario : null;
	  objeto.proposta_vigencia_meses ? novoObjeto.proposta_vigencia = objeto.proposta_vigencia_meses : null;
	  objeto.proposta_vigencia_meses ? novoObjeto.proposta_vigencia_extenso = numeroPorExtenso(objeto.proposta_vigencia_meses) : null;
	  objeto.testemunhas[0] ? objeto.testemunhas[0].nome ? novoObjeto.primeira_testemunha_nome = objeto.testemunhas[0].nome : null : null;
	  objeto.testemunhas[0] ? objeto.testemunhas[0].cpf ? novoObjeto.primeira_testemunha_cpf = formatarCPF(objeto.testemunhas[0].cpf) : null : null;
	  objeto.testemunhas[1] ? objeto.testemunhas[1].nome ? novoObjeto.segunda_testemunha_nome = objeto.testemunhas[1].nome : null : null;
	  objeto.testemunhas[1] ? objeto.testemunhas[1].cpf ? novoObjeto.segunda_testemunha_cpf = formatarCPF(objeto.testemunhas[1].cpf) : null : null;
	
	  if (objeto.proposta_parcelas_adiantamento) {
	    var parcelas = helperParcelas.consolidarParcelasAdiantamento(objeto.proposta_parcelas_adiantamento);
	
	    var totalParcelas = helperParcelas.totalParcelasAdiantamento(parcelas);
	
	    var stringParcelas = '';
	    parcelas.forEach(function (parcela, index) {
	      stringParcelas += index + 1 + '\xAA parcela: at\xE9 R$ ' + formatarMoeda(parcela.valor) + ' (' + numeroPorExtenso(parcela.valor, 'MOEDA') + ');\n\n';
	    });
	    novoObjeto.total_adiantamento = formatarMoeda(totalParcelas);
	    novoObjeto.numero_parcelas = parcelas.length;
	    var totalParcelasFormatado = totalParcelas.toFixed(2).replace('.', ',');
	    novoObjeto.total_adiantamento_extenso = (0, _extenso2.default)(totalParcelasFormatado, { mode: 'currency', number: { decimalSeparator: 'comma' } });
	    novoObjeto.parcelas_adiantamento = stringParcelas;
	  }
	
	  objeto.proposta_conta_corrente_deb ? novoObjeto.proposta_conta_deb = objeto.proposta_conta_corrente_deb : null;
	  objeto.proposta_agencia_deb ? novoObjeto.proposta_agencia_deb = objeto.proposta_agencia_deb : null;
	  objeto.proposta_agencia_adiantamento ? novoObjeto.proposta_agencia_adiantamento = objeto.proposta_agencia_adiantamento : null;
	  objeto.proposta_conta_corrente_adiantamento ? novoObjeto.proposta_conta_adiantamento = objeto.proposta_conta_corrente_adiantamento : null;
	  if (Array.isArray(objeto.responsavel_assinatura)) {
	    novoObjeto.representantes = objeto.responsavel_assinatura.map(function (rep) {
	      return {
	        representante_assina_nome: rep.ds_nome,
	        representante_assina_funcao: rep.cargo.ds_descricao
	      };
	    });
	    novoObjeto.representantes_info = objeto.responsavel_assinatura.map(function (rep, index, array) {
	      return {
	        representante_cpf: formatarCPF(rep.ds_cpf),
	        representante_profissao: rep.ds_profissao,
	        representante_municipio: rep.endereco.ds_cidade + ' (' + rep.endereco.ds_estado + ')',
	        representante_nome: rep.ds_nome,
	        representante_estcivil: rep.ds_estado_civil.charAt(0).toUpperCase() + rep.ds_estado_civil.slice(1).toLowerCase() + '(a)',
	        representante_funcao: rep.cargo.ds_descricao,
	        representante_tipodoc: 'RG',
	        representante_numerodoc: formatarRG(rep.ds_rg),
	        e_o: index < array.length - 1 ? 'e; o(a)' : ''
	      };
	    });
	  }
	  return novoObjeto;
	}
	var geraMinuta = {
	  methods: {
	    gerarMinuta: function gerarMinuta(projetoId, minutaSimplificada, fkEdital, tipoEcoforte, minutaPovosPriorizados) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var entidade, isAdiantado, isPublica, isSimplificado, isPovosPriorizados, enderecoArquivo, nomeArquivo;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('consultando dados...', projetoId);
	                _context.next = 3;
	                return axiosLaravel.get('dadosMinutaPorProposta/' + projetoId);
	
	              case 3:
	                entidade = _context.sent;
	
	                console.log(entidade.data);
	                isAdiantado = void 0;
	
	                if (!_.isNull(entidade.data.proposta_parcelas_adiantamento)) {
	                  isAdiantado = entidade.data.proposta_parcelas_adiantamento.length > 0;
	                } else {
	                  isAdiantado = false;
	                }
	                isPublica = entidade.data.entidade_ente_publico;
	                isSimplificado = minutaSimplificada;
	                isPovosPriorizados = minutaPovosPriorizados;
	
	                console.log('ADIANTAMENTO', isAdiantado);
	                console.log('PUBLICA', isPublica);
	                console.log('SIMPLIFICADA', isSimplificado);
	                console.log('EDITAL', fkEdital);
	                console.log('FAIXA PROJETO FBB: ', entidade.data.proposta_valor_fbb);
	                console.log('FAIXA PROJETO PARCEIRO: ', entidade.data.proposta_valor_parceiros);
	                console.log('FAIXA PROJETO: ', _.toNumber(entidade.data.proposta_valor_fbb) + _.toNumber(entidade.data.proposta_valor_parceiros));
	                enderecoArquivo = '';
	                nomeArquivo = '';
	                _context.t0 = true;
	                _context.next = _context.t0 === (isPovosPriorizados && isAdiantado) ? 22 : _context.t0 === (isPovosPriorizados && !isAdiantado) ? 26 : _context.t0 === (isAdiantado && isPublica) ? 30 : _context.t0 === (isAdiantado && !isPublica) ? 34 : _context.t0 === (!isAdiantado && isPublica) ? 38 : _context.t0 === (!isAdiantado && !isPublica) ? 42 : 46;
	                break;
	
	              case 22:
	                enderecoArquivo = POVOS_PRIORIZADOS_COM_ADIANTAMENTO;
	                nomeArquivo = 'Minuta_ADT_Povos_Priorizados_' + entidade.data.projeto_numero + '.docx';
	                console.log(POVOS_PRIORIZADOS_COM_ADIANTAMENTO);
	                return _context.abrupt('break', 48);
	
	              case 26:
	                enderecoArquivo = POVOS_PRIORIZADOS_SEM_ADIANTAMENTO;
	                nomeArquivo = 'Minuta_SEM_ADT_Povos_Priorizados_' + entidade.data.projeto_numero + '.docx';
	                console.log(POVOS_PRIORIZADOS_SEM_ADIANTAMENTO);
	                return _context.abrupt('break', 48);
	
	              case 30:
	                enderecoArquivo = COM_ADIANTAMENTO_PUBLICA;
	                nomeArquivo = 'Minuta_ADT_' + entidade.data.projeto_numero + '.docx';
	                console.log(COM_ADIANTAMENTO_PUBLICA);
	                return _context.abrupt('break', 48);
	
	              case 34:
	                enderecoArquivo = COM_ADIANTAMENTO_PRIVADA;
	                nomeArquivo = 'Minuta_ADT_' + entidade.data.projeto_numero + '.docx';
	                console.log(COM_ADIANTAMENTO_PRIVADA);
	                return _context.abrupt('break', 48);
	
	              case 38:
	                enderecoArquivo = SEM_ADIANTAMENTO_PUBLICA;
	                nomeArquivo = 'Minuta_SEM_ADT_' + entidade.data.projeto_numero + '.docx';
	                console.log(SEM_ADIANTAMENTO_PUBLICA);
	                return _context.abrupt('break', 48);
	
	              case 42:
	                enderecoArquivo = SEM_ADIANTAMENTO_PRIVADA;
	                nomeArquivo = 'Minuta_SEM_ADT_' + entidade.data.projeto_numero + '.docx';
	                console.log(SEM_ADIANTAMENTO_PRIVADA);
	                return _context.abrupt('break', 48);
	
	              case 46:
	                console.log(SIMPLIFICADA);
	                return _context.abrupt('break', 48);
	
	              case 48:
	                if (isSimplificado && isPublica) {
	                  enderecoArquivo = SIMPLIFICADA_PUBLICA;
	                  nomeArquivo = 'Minuta_' + entidade.data.projeto_numero + '.docx';
	                  console.log(SIMPLIFICADA_PUBLICA);
	                } else if (isSimplificado && !isPublica) {
	                  enderecoArquivo = SIMPLIFICADA_PRIVADA;
	                  nomeArquivo = 'Minuta_' + entidade.data.projeto_numero + '.docx';
	                  console.log(SIMPLIFICADA_PRIVADA);
	                }
	                if (fkEdital === 12 && !isSimplificado && !isPovosPriorizados) {
	                  enderecoArquivo = MULHERES_NEGRAS_CONVENIO;
	                  nomeArquivo = 'Minuta_Edital_' + entidade.data.projeto_numero + '.docx';
	                  console.log(MULHERES_NEGRAS_CONVENIO);
	                }
	                if (fkEdital === 10 && !isSimplificado && !isPovosPriorizados) {
	                  enderecoArquivo = CATAFORTE;
	                  nomeArquivo = 'Minuta_Edital_CATAFORTE_' + entidade.data.projeto_numero + '.docx';
	                  console.log(CATAFORTE);
	                }
	                if (fkEdital === 9 && !isSimplificado && tipoEcoforte === 1 && !isPovosPriorizados) {
	                  enderecoArquivo = ECOFORTE;
	                  nomeArquivo = 'Minuta_Edital_ECOFORTE_' + entidade.data.projeto_numero + '.docx';
	                  console.log(ECOFORTE);
	                }
	                if (fkEdital === 9 && !isSimplificado && tipoEcoforte === 2 && !isPovosPriorizados) {
	                  enderecoArquivo = ECOFORTE_AMAZONIA;
	                  nomeArquivo = 'Minuta_Edital_ECOFORTE_FUNDO_AMAZONIA_' + entidade.data.projeto_numero + '.docx';
	                  console.log(ECOFORTE_AMAZONIA);
	                }
	
	                _context.next = 55;
	                return new _promise2.default(function (resolve) {
	                  loadFile(enderecoArquivo, function (error, content) {
	                    if (error) {
	                      console.log('Erro ao carregar o modelo de minuta:', enderecoArquivo, error);
	                      return resolve(false);
	                    }
	                    try {
	                      var zip = new _pizzip2.default(content);
	                      var doc = new _docxtemplater2.default(zip, { paragraphLoop: true, linebreaks: true });
	
	                      doc.setData(adaptaObjeto(entidade.data, isPublica));
	                      doc.render();
	                      var out = doc.getZip().generate({
	                        type: 'blob',
	                        mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
	                      });
	
	                      (0, _fileSaver.saveAs)(out, nomeArquivo);
	                      return resolve(true);
	                    } catch (error) {
	                      var replaceErrors = function replaceErrors(key, value) {
	                        if (value instanceof Error) {
	                          return (0, _getOwnPropertyNames2.default)(value).reduce(function (error, key) {
	                            error[key] = value[key];
	                            return error;
	                          }, {});
	                        }
	                        return value;
	                      };
	
	                      console.log((0, _stringify2.default)({ error: error }, replaceErrors));
	                      if (error.properties && error.properties.errors instanceof Array) {
	                        var errorMessages = error.properties.errors.map(function (error) {
	                          return error.properties.explanation;
	                        }).join('\n');
	                        console.log('errorMessages', errorMessages);
	                      }
	                      return resolve(false);
	                    }
	                  });
	                });
	
	              case 55:
	                return _context.abrupt('return', _context.sent);
	
	              case 56:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	};
	
	exports.default = geraMinuta;

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isAdmin = exports.isAdmin = {
	  methods: {
	    isAdmin: function isAdmin(usuario) {
	      return usuario.profilesConstraint.some(function (perfil) {
	        if (perfil.active === true) {
	          return perfil.profile.name === 'Getec';
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isFundacao = exports.isFundacao = {
	  methods: {
	    isFundacao: function isFundacao(usuario) {
	      if (usuario.userType === 'FUNDACAO') {
	        return usuario.userType === 'FUNDACAO';
	      }
	    }
	  }
	};

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var laravelHandoff = exports.laravelHandoff = {
	  methods: {
	    abreLaravelAutenticado: function abreLaravelAutenticado(path) {
	      var _this = this;
	
	      var win = window.open('', '_blank');
	
	      axiosLaravel.post('sgp/handoff', { target: path }).then(function (response) {
	        if (win) {
	          win.location = response.data.url;
	        } else {
	          window.location = response.data.url;
	        }
	      }).catch(function (error) {
	        var base = _this.$store.state.laravelurl || '';
	        if (win) {
	          win.location = base + path;
	        }
	        _this.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tokenInfo = undefined;
	
	var _auth = __webpack_require__(146);
	
	var tokenInfo = exports.tokenInfo = {
	  created: function created() {
	    var _this = this;
	
	    if (!window.localStorage.getItem('tokenLaravel')) {
	      return;
	    }
	
	    if (!(0, _auth.precisaRenovar)() && (0, _auth.segundosAteExpirar)() > 0) {
	      return;
	    }
	
	    if (!(0, _auth.getRefreshToken)()) {
	      this.encerraSessao();
	
	      return;
	    }
	
	    (0, _auth.renovaToken)().catch(function () {
	      _this.encerraSessao();
	    });
	  },
	
	  methods: {
	    encerraSessao: function encerraSessao() {
	      this.$store.commit('REMOVE_USER');
	      this.$store.commit('REMOVE_USER_DETAIL');
	      this.$store.commit('REMOVE_USER_LARAVEL');
	      (0, _auth.limpaSessao)();
	      this.$router.push('/login');
	    },
	    verificaToken: function verificaToken() {
	      if (window.localStorage.getItem('token')) {
	        var token = window.localStorage.getItem('token');
	        var base64Url = token.split('.')[1];
	        var base64 = base64Url.replace('-', '+').replace('_', '/');
	
	        var tokenExpiraEm = JSON.parse(window.atob(base64)).exp;
	
	        var currentTime = new Date().getTime() / 1000;
	
	        if (currentTime > tokenExpiraEm) {
	          this.encerraSessao();
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.trataErro = undefined;
	
	var _values = __webpack_require__(182);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ultimoAvisoSessao = 0;
	
	var trataErro = exports.trataErro = {
	  created: function created() {},
	
	  methods: {
	    trataErro: function trataErro(error) {
	      var mensagem = null;
	
	      if (!error || !error.response && !error.request) {
	        mensagem = error && error.message ? error.message : 'Erro inesperado no processamento da tela';
	        this.$snotify.error(mensagem, { bodyMaxLength: 1200 });
	        console.error('%cErro:', 'font-size: 20px; background: red; color: white', error);
	        return mensagem;
	      }
	
	      if (!error.response) {
	        mensagem = 'Nenhum registro encontrado';
	      } else if (error.response.status === 403) {
	        mensagem = _.get(error, 'response.data.message', 'Acesso negado');
	      } else if (error.response.status === 503) {
	        mensagem = 'Sistema esta em manutenção favor acessar novamente daqui a alguns segundos. Obrigado';
	      } else if (error.response.status === 422) {
	        var erros = _.get(error, 'response.data.error', null) || _.get(error, 'response.data.errors', null) || {};
	        mensagem = _.flattenDeep((0, _values2.default)(erros));
	        mensagem = _.isEmpty(mensagem) ? _.get(error, 'response.data.message', 'Dados inválidos. Revise os campos informados.') : _.join(mensagem, ' ');
	      } else if (error.response.status === 401) {
	        mensagem = 'Sua sessão expirou. Faça login novamente.';
	
	        var agora = new Date().getTime();
	
	        if (agora - ultimoAvisoSessao < 10000) {
	          return mensagem;
	        }
	
	        ultimoAvisoSessao = agora;
	      } else if (error.response.status === 500) {
	        if (_.get(error, 'response.data.error')) {
	          mensagem = 'Erro no processamento da requisição. ' + error.response.data.error;
	        } else if (_.get(error, 'response.data.message')) {
	          mensagem = 'Erro no processamento da requisição. ' + error.response.data.message;
	        } else {
	          mensagem = 'Erro no processamento da requisição. ' + error.response.data;
	        }
	      } else if (error.response.status === 409) {
	        mensagem = _.get(error, 'response.data.responseInfo.reasons[0].detail', 'Conflito no processamento da requisição');
	      } else {
	        mensagem = error.response.data;
	      }
	      this.$snotify.error(mensagem, { bodyMaxLength: 1200 });
	      console.log('%cErro:', 'font-size: 20px; background: red; color: white', error.response);
	
	      return mensagem;
	    }
	  }
	};

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var validaProposta = exports.validaProposta = {
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    validaProposta: function validaProposta(proposta) {
	      var propostaOK = true;
	      if (!this.isUploadingDocuments(proposta)) {
	        this.$snotify.error('Faltam documentos à serem adicionados');
	        propostaOK = false;
	      }
	      if (!this.validateParticipantsMunicipalization(proposta)) {
	        this.$snotify.error('Faltam participantes a serem adicionados aos municípios');
	        propostaOK = false;
	      }
	      if (!this.validaObjetivos(proposta)) {
	        this.$snotify.error('Faltam adicionar metas para todos os objetivos');
	        propostaOK = false;
	      } else if (!this.validaMetas(proposta)) {
	        this.$snotify.error('Faltam adicionar atividades para todos as metas');
	        propostaOK = false;
	      } else if (!this.validaAtividades(proposta)) {
	        this.$snotify.error('Faltam adicionar items para todas as atividades');
	        propostaOK = false;
	      } else if (!this.outrasValidacoes(proposta)) {
	        propostaOK = false;
	      }
	      return propostaOK;
	    },
	    isUploadingDocuments: function isUploadingDocuments(proposta) {
	      var documentosEsperados = proposta.documentTypes.map(function (item) {
	        return item.type;
	      });
	      var documentosCarregados = proposta.documents.map(function (item) {
	        return item.documentType.type;
	      });
	      return _.difference(documentosEsperados, documentosCarregados).length === 0;
	    },
	    validateParticipantsMunicipalization: function validateParticipantsMunicipalization(proposta) {
	      var totalParticipantes = 0;
	      proposta.audiences.forEach(function (publico) {
	        totalParticipantes = totalParticipantes + publico.directParticipants;
	      });
	      var totalParticipantesMunicipio = 0;
	      proposta.municipalizationResume.forEach(function (municipio) {
	        totalParticipantesMunicipio = totalParticipantesMunicipio + municipio.totalParticipants;
	      });
	      return totalParticipantes === totalParticipantesMunicipio;
	    },
	    validaMetas: function validaMetas(proposta) {
	      var metas = [];
	      proposta.objectives.forEach(function (objetivo) {
	        if (objetivo.goals) {
	          objetivo.goals.forEach(function (meta) {
	            metas.push(meta);
	          });
	        }
	      });
	      return metas.every(function (meta) {
	        return meta.activities ? meta.activities.length > 0 : false;
	      });
	    },
	    validaAtividades: function validaAtividades(proposta) {
	      var atividades = [];
	      proposta.objectives.forEach(function (objetivo) {
	        if (objetivo.goals) {
	          objetivo.goals.forEach(function (meta) {
	            if (meta.activities) {
	              meta.activities.forEach(function (atividade) {
	                atividades.push(atividade);
	              });
	            }
	          });
	        }
	      });
	      return atividades.every(function (atividade) {
	        return atividade.items ? atividade.items.length > 0 : false;
	      });
	    },
	    validaObjetivos: function validaObjetivos(proposta) {
	      return proposta.objectives.every(function (item) {
	        return item.goals ? item.goals.length > 0 : false;
	      });
	    },
	    outrasValidacoes: function outrasValidacoes(proposta) {
	      if (!proposta.audiences || proposta.audiences === 0) {
	        this.$snotify.error('Você deve informar ao menos um público alvo!');
	        return false;
	      }
	
	      if (!proposta.teams || proposta.audiences.teams === 0) {
	        this.$snotify.error('Você deve informar ao menos uma equipe!');
	        return false;
	      }
	
	      if (!proposta.objectives || proposta.audiences.objectives === 0) {
	        this.$snotify.error('Você deve informar ao menos um objetivo específico!');
	        return false;
	      }
	
	      if (!proposta.solemnizations) {
	        this.$snotify.error('Você deve informar ao menos uma solenização!');
	        return false;
	      } else if (proposta.solemnizations.length === 0) {
	        this.$snotify.error('Você deve informar ao menos uma solenização!');
	        return false;
	      }
	      return true;
	    }
	  }
	};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.verificaFormulario = undefined;
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(76);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var verificaFormulario = exports.verificaFormulario = {
	  methods: {
	    reflect: function reflect(promise) {
	      return promise.then(function (v) {
	        return {
	          v: v, status: 'resolved'
	        };
	      }, function (e) {
	        return {
	          e: e, status: 'rejected'
	        };
	      });
	    },
	
	    verificaFormulario: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(componentePai) {
	        var temErro, validacoesFilhos;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                temErro = false;
	                validacoesFilhos = componentePai.$children.map(function (componente) {
	                  return componente.$validator.validateAll();
	                });
	                _context.next = 4;
	                return _promise2.default.all(validacoesFilhos.map(this.reflect)).then(function (results) {
	                  temErro = results.some(function (x) {
	                    return x.v === false;
	                  });
	                });
	
	              case 4:
	                return _context.abrupt('return', temErro);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function verificaFormulario(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return verificaFormulario;
	    }()
	  }
	};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _Login = __webpack_require__(1630);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Dashboard = __webpack_require__(1628);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Manuais = __webpack_require__(1632);
	
	var _Manuais2 = _interopRequireDefault(_Manuais);
	
	var _Preferencias = __webpack_require__(1631);
	
	var _Preferencias2 = _interopRequireDefault(_Preferencias);
	
	var _Index = __webpack_require__(1707);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _ = __webpack_require__(515);
	
	var _2 = _interopRequireDefault(_);
	
	var _Index3 = __webpack_require__(1753);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Buttons = __webpack_require__(1744);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _General = __webpack_require__(1745);
	
	var _General2 = _interopRequireDefault(_General);
	
	var _Icons = __webpack_require__(1746);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _Modals = __webpack_require__(1747);
	
	var _Modals2 = _interopRequireDefault(_Modals);
	
	var _Sliders = __webpack_require__(1748);
	
	var _Sliders2 = _interopRequireDefault(_Sliders);
	
	var _Timeline = __webpack_require__(1749);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _ListaUsuarios_old = __webpack_require__(1684);
	
	var _ListaUsuarios_old2 = _interopRequireDefault(_ListaUsuarios_old);
	
	var _ListaUsuarios = __webpack_require__(1683);
	
	var _ListaUsuarios2 = _interopRequireDefault(_ListaUsuarios);
	
	var _EditaUsuario_old = __webpack_require__(1682);
	
	var _EditaUsuario_old2 = _interopRequireDefault(_EditaUsuario_old);
	
	var _EditaUsuario = __webpack_require__(1681);
	
	var _EditaUsuario2 = _interopRequireDefault(_EditaUsuario);
	
	var _listaPerfis = __webpack_require__(1671);
	
	var _listaPerfis2 = _interopRequireDefault(_listaPerfis);
	
	var _listaEntidades = __webpack_require__(1655);
	
	var _listaEntidades2 = _interopRequireDefault(_listaEntidades);
	
	var _EditarPerfil = __webpack_require__(1670);
	
	var _EditarPerfil2 = _interopRequireDefault(_EditarPerfil);
	
	var _ListaPermissoes = __webpack_require__(1672);
	
	var _ListaPermissoes2 = _interopRequireDefault(_ListaPermissoes);
	
	var _ListaAcoes = __webpack_require__(1633);
	
	var _ListaAcoes2 = _interopRequireDefault(_ListaAcoes);
	
	var _ListaEditais = __webpack_require__(1648);
	
	var _ListaEditais2 = _interopRequireDefault(_ListaEditais);
	
	var _EditarEdital = __webpack_require__(1647);
	
	var _EditarEdital2 = _interopRequireDefault(_EditarEdital);
	
	var _ListaChamado = __webpack_require__(1643);
	
	var _ListaChamado2 = _interopRequireDefault(_ListaChamado);
	
	var _EditarChamado = __webpack_require__(1642);
	
	var _EditarChamado2 = _interopRequireDefault(_EditarChamado);
	
	var _AbrirChamado = __webpack_require__(1641);
	
	var _AbrirChamado2 = _interopRequireDefault(_AbrirChamado);
	
	var _RelatorioChamado = __webpack_require__(1644);
	
	var _RelatorioChamado2 = _interopRequireDefault(_RelatorioChamado);
	
	var _ListaAssunto = __webpack_require__(1637);
	
	var _ListaAssunto2 = _interopRequireDefault(_ListaAssunto);
	
	var _EditarAssunto = __webpack_require__(1636);
	
	var _EditarAssunto2 = _interopRequireDefault(_EditarAssunto);
	
	var _ListaMotivos = __webpack_require__(1666);
	
	var _ListaMotivos2 = _interopRequireDefault(_ListaMotivos);
	
	var _EditarMotivos = __webpack_require__(1665);
	
	var _EditarMotivos2 = _interopRequireDefault(_EditarMotivos);
	
	var _ListaFav = __webpack_require__(1657);
	
	var _ListaFav2 = _interopRequireDefault(_ListaFav);
	
	var _ListaFep = __webpack_require__(1660);
	
	var _ListaFep2 = _interopRequireDefault(_ListaFep);
	
	var _ListaSimplificado = __webpack_require__(1678);
	
	var _ListaSimplificado2 = _interopRequireDefault(_ListaSimplificado);
	
	var _EditarSimplificado = __webpack_require__(1677);
	
	var _EditarSimplificado2 = _interopRequireDefault(_EditarSimplificado);
	
	var _ListaTipoDocumentos = __webpack_require__(1646);
	
	var _ListaTipoDocumentos2 = _interopRequireDefault(_ListaTipoDocumentos);
	
	var _ListaGed = __webpack_require__(1661);
	
	var _ListaGed2 = _interopRequireDefault(_ListaGed);
	
	var _CadastroFormulario = __webpack_require__(1638);
	
	var _CadastroFormulario2 = _interopRequireDefault(_CadastroFormulario);
	
	var _EditaFormulario = __webpack_require__(1639);
	
	var _EditaFormulario2 = _interopRequireDefault(_EditaFormulario);
	
	var _PreencheFormulario = __webpack_require__(1640);
	
	var _PreencheFormulario2 = _interopRequireDefault(_PreencheFormulario);
	
	var _MovimentoDiario = __webpack_require__(1662);
	
	var _MovimentoDiario2 = _interopRequireDefault(_MovimentoDiario);
	
	var _ListaRatificacao = __webpack_require__(1674);
	
	var _ListaRatificacao2 = _interopRequireDefault(_ListaRatificacao);
	
	var _ListaRatificacaoPendentes = __webpack_require__(1675);
	
	var _ListaRatificacaoPendentes2 = _interopRequireDefault(_ListaRatificacaoPendentes);
	
	var _EditaRatificacao = __webpack_require__(1673);
	
	var _EditaRatificacao2 = _interopRequireDefault(_EditaRatificacao);
	
	var _relatorioAnalise = __webpack_require__(523);
	
	var _relatorioAnalise2 = _interopRequireDefault(_relatorioAnalise);
	
	var _visualizaRelatorioAnalise = __webpack_require__(1752);
	
	var _visualizaRelatorioAnalise2 = _interopRequireDefault(_visualizaRelatorioAnalise);
	
	var _relatorioRating = __webpack_require__(1741);
	
	var _relatorioRating2 = _interopRequireDefault(_relatorioRating);
	
	var _relatorioFep = __webpack_require__(1739);
	
	var _relatorioFep2 = _interopRequireDefault(_relatorioFep);
	
	var _relatorioFepAberto = __webpack_require__(1740);
	
	var _relatorioFepAberto2 = _interopRequireDefault(_relatorioFepAberto);
	
	var _EditaFav = __webpack_require__(1656);
	
	var _EditaFav2 = _interopRequireDefault(_EditaFav);
	
	var _NovaFav = __webpack_require__(1658);
	
	var _NovaFav2 = _interopRequireDefault(_NovaFav);
	
	var _EditaFep = __webpack_require__(1659);
	
	var _EditaFep2 = _interopRequireDefault(_EditaFep);
	
	var _EditarDocumentos = __webpack_require__(1645);
	
	var _EditarDocumentos2 = _interopRequireDefault(_EditarDocumentos);
	
	var _ListaProposta = __webpack_require__(1775);
	
	var _ListaProposta2 = _interopRequireDefault(_ListaProposta);
	
	var _EditaProposta = __webpack_require__(1768);
	
	var _EditaProposta2 = _interopRequireDefault(_EditaProposta);
	
	var _PlanoTrabalho = __webpack_require__(529);
	
	var _PlanoTrabalho2 = _interopRequireDefault(_PlanoTrabalho);
	
	var _ImprimirProposta = __webpack_require__(1772);
	
	var _ImprimirProposta2 = _interopRequireDefault(_ImprimirProposta);
	
	var _ImprimirPropostaEdital = __webpack_require__(1773);
	
	var _ImprimirPropostaEdital2 = _interopRequireDefault(_ImprimirPropostaEdital);
	
	var _ListaSolicitacao = __webpack_require__(1790);
	
	var _ListaSolicitacao2 = _interopRequireDefault(_ListaSolicitacao);
	
	var _LogEmails = __webpack_require__(1687);
	
	var _LogEmails2 = _interopRequireDefault(_LogEmails);
	
	var _ConfGerais = __webpack_require__(1686);
	
	var _ConfGerais2 = _interopRequireDefault(_ConfGerais);
	
	var _CadastroRel = __webpack_require__(1782);
	
	var _CadastroRel2 = _interopRequireDefault(_CadastroRel);
	
	var _EditaCadastroRel = __webpack_require__(1783);
	
	var _EditaCadastroRel2 = _interopRequireDefault(_EditaCadastroRel);
	
	var _ListaProjetos = __webpack_require__(1763);
	
	var _ListaProjetos2 = _interopRequireDefault(_ListaProjetos);
	
	var _VisualizaProjeto = __webpack_require__(1766);
	
	var _VisualizaProjeto2 = _interopRequireDefault(_VisualizaProjeto);
	
	var _Projeto = __webpack_require__(1765);
	
	var _Projeto2 = _interopRequireDefault(_Projeto);
	
	var _Timeline3 = __webpack_require__(258);
	
	var _Timeline4 = _interopRequireDefault(_Timeline3);
	
	var _GestaoAtividades = __webpack_require__(257);
	
	var _GestaoAtividades2 = _interopRequireDefault(_GestaoAtividades);
	
	var _PendenciasProjeto = __webpack_require__(527);
	
	var _PendenciasProjeto2 = _interopRequireDefault(_PendenciasProjeto);
	
	var _Roteiro = __webpack_require__(516);
	
	var _Roteiro2 = _interopRequireDefault(_Roteiro);
	
	var _Atividades = __webpack_require__(256);
	
	var _Atividades2 = _interopRequireDefault(_Atividades);
	
	var _EditaEntidades = __webpack_require__(1650);
	
	var _EditaEntidades2 = _interopRequireDefault(_EditaEntidades);
	
	var _VisualizaEntidades = __webpack_require__(1654);
	
	var _VisualizaEntidades2 = _interopRequireDefault(_VisualizaEntidades);
	
	var _CredenciamentoEntidade = __webpack_require__(1649);
	
	var _CredenciamentoEntidade2 = _interopRequireDefault(_CredenciamentoEntidade);
	
	var _EntidadeSimplificado = __webpack_require__(1653);
	
	var _EntidadeSimplificado2 = _interopRequireDefault(_EntidadeSimplificado);
	
	var _EntidadeProposta = __webpack_require__(1651);
	
	var _EntidadeProposta2 = _interopRequireDefault(_EntidadeProposta);
	
	var _EntidadePropostaEdital = __webpack_require__(1652);
	
	var _EntidadePropostaEdital2 = _interopRequireDefault(_EntidadePropostaEdital);
	
	var _ListaParcEstrategico = __webpack_require__(1669);
	
	var _ListaParcEstrategico2 = _interopRequireDefault(_ListaParcEstrategico);
	
	var _ImpressaoRel = __webpack_require__(1778);
	
	var _ImpressaoRel2 = _interopRequireDefault(_ImpressaoRel);
	
	var _relatorioBi = __webpack_require__(1781);
	
	var _relatorioBi2 = _interopRequireDefault(_relatorioBi);
	
	var _GeracaoRemessa = __webpack_require__(1785);
	
	var _GeracaoRemessa2 = _interopRequireDefault(_GeracaoRemessa);
	
	var _TratamentoRetorno = __webpack_require__(1787);
	
	var _TratamentoRetorno2 = _interopRequireDefault(_TratamentoRetorno);
	
	var _Liberacao = __webpack_require__(1774);
	
	var _Liberacao2 = _interopRequireDefault(_Liberacao);
	
	var _Simplificada = __webpack_require__(1777);
	
	var _Simplificada2 = _interopRequireDefault(_Simplificada);
	
	var _ListaValidacaoProposta = __webpack_require__(1809);
	
	var _ListaValidacaoProposta2 = _interopRequireDefault(_ListaValidacaoProposta);
	
	var _PrimeiraAprovacao = __webpack_require__(1815);
	
	var _PrimeiraAprovacao2 = _interopRequireDefault(_PrimeiraAprovacao);
	
	var _aceite = __webpack_require__(1816);
	
	var _aceite2 = _interopRequireDefault(_aceite);
	
	var _analiseGeral = __webpack_require__(1817);
	
	var _analiseGeral2 = _interopRequireDefault(_analiseGeral);
	
	var _mainPreparacaoDocumento = __webpack_require__(1823);
	
	var _mainPreparacaoDocumento2 = _interopRequireDefault(_mainPreparacaoDocumento);
	
	var _mainFormalizacao = __webpack_require__(1822);
	
	var _mainFormalizacao2 = _interopRequireDefault(_mainFormalizacao);
	
	var _mainAprovacaoProjeto = __webpack_require__(1820);
	
	var _mainAprovacaoProjeto2 = _interopRequireDefault(_mainAprovacaoProjeto);
	
	var _mainDeferimento = __webpack_require__(1821);
	
	var _mainDeferimento2 = _interopRequireDefault(_mainDeferimento);
	
	var _ListaValidacaoEntidade = __webpack_require__(1811);
	
	var _ListaValidacaoEntidade2 = _interopRequireDefault(_ListaValidacaoEntidade);
	
	var _ValidaEntidades = __webpack_require__(1812);
	
	var _ValidaEntidades2 = _interopRequireDefault(_ValidaEntidades);
	
	var _ValidaParceiro = __webpack_require__(1814);
	
	var _ValidaParceiro2 = _interopRequireDefault(_ValidaParceiro);
	
	var _DetalheValidaEntidade = __webpack_require__(1810);
	
	var _DetalheValidaEntidade2 = _interopRequireDefault(_DetalheValidaEntidade);
	
	var _ValidaInicial = __webpack_require__(1832);
	
	var _ValidaInicial2 = _interopRequireDefault(_ValidaInicial);
	
	var _ListaValidacaoInicial = __webpack_require__(1831);
	
	var _ListaValidacaoInicial2 = _interopRequireDefault(_ListaValidacaoInicial);
	
	var _ListaValidacaoParcEst = __webpack_require__(1813);
	
	var _ListaValidacaoParcEst2 = _interopRequireDefault(_ListaValidacaoParcEst);
	
	var _ListaValidacaoSolicitacoes = __webpack_require__(1825);
	
	var _ListaValidacaoSolicitacoes2 = _interopRequireDefault(_ListaValidacaoSolicitacoes);
	
	var _EditaPagamento = __webpack_require__(1807);
	
	var _EditaPagamento2 = _interopRequireDefault(_EditaPagamento);
	
	var _EditaAdiantamento = __webpack_require__(1791);
	
	var _EditaAdiantamento2 = _interopRequireDefault(_EditaAdiantamento);
	
	var _EditaProjeto = __webpack_require__(1796);
	
	var _EditaProjeto2 = _interopRequireDefault(_EditaProjeto);
	
	var _Sumula = __webpack_require__(1798);
	
	var _Sumula2 = _interopRequireDefault(_Sumula);
	
	var _Aditivo = __webpack_require__(1795);
	
	var _Aditivo2 = _interopRequireDefault(_Aditivo);
	
	var _PlanoTrabalho3 = __webpack_require__(1797);
	
	var _PlanoTrabalho4 = _interopRequireDefault(_PlanoTrabalho3);
	
	var _EsqueciMinhaSenha = __webpack_require__(1629);
	
	var _EsqueciMinhaSenha2 = _interopRequireDefault(_EsqueciMinhaSenha);
	
	var _AutoCredenciamento = __webpack_require__(1627);
	
	var _AutoCredenciamento2 = _interopRequireDefault(_AutoCredenciamento);
	
	var _ListaValidacaoRelExec = __webpack_require__(1824);
	
	var _ListaValidacaoRelExec2 = _interopRequireDefault(_ListaValidacaoRelExec);
	
	var _EmiteRelatorioERP = __webpack_require__(1784);
	
	var _EmiteRelatorioERP2 = _interopRequireDefault(_EmiteRelatorioERP);
	
	var _EditaParcEstrategico = __webpack_require__(1668);
	
	var _EditaParcEstrategico2 = _interopRequireDefault(_EditaParcEstrategico);
	
	var _ListaRelExec = __webpack_require__(1764);
	
	var _ListaRelExec2 = _interopRequireDefault(_ListaRelExec);
	
	var _EditaRelExec = __webpack_require__(1761);
	
	var _EditaRelExec2 = _interopRequireDefault(_EditaRelExec);
	
	var _validacaoAdiantamentoAnalise = __webpack_require__(1828);
	
	var _validacaoAdiantamentoAnalise2 = _interopRequireDefault(_validacaoAdiantamentoAnalise);
	
	var _validacaoDevolucaoAdiantamentoAnalise = __webpack_require__(1830);
	
	var _validacaoDevolucaoAdiantamentoAnalise2 = _interopRequireDefault(_validacaoDevolucaoAdiantamentoAnalise);
	
	var _AlterarSenha = __webpack_require__(1626);
	
	var _AlterarSenha2 = _interopRequireDefault(_AlterarSenha);
	
	var _ListaSumarioExecutivo = __webpack_require__(1680);
	
	var _ListaSumarioExecutivo2 = _interopRequireDefault(_ListaSumarioExecutivo);
	
	var _EditaSumarioExecutivo = __webpack_require__(1679);
	
	var _EditaSumarioExecutivo2 = _interopRequireDefault(_EditaSumarioExecutivo);
	
	var _ListaArticulacoes = __webpack_require__(1635);
	
	var _ListaArticulacoes2 = _interopRequireDefault(_ListaArticulacoes);
	
	var _EditaArticulacao = __webpack_require__(1634);
	
	var _EditaArticulacao2 = _interopRequireDefault(_EditaArticulacao);
	
	var _ListaOcorrencias = __webpack_require__(1667);
	
	var _ListaOcorrencias2 = _interopRequireDefault(_ListaOcorrencias);
	
	var _EmissaoDocumentos = __webpack_require__(1762);
	
	var _EmissaoDocumentos2 = _interopRequireDefault(_EmissaoDocumentos);
	
	var _ListaRemessaBNDES = __webpack_require__(1786);
	
	var _ListaRemessaBNDES2 = _interopRequireDefault(_ListaRemessaBNDES);
	
	var _ProjetosUsuario = __webpack_require__(1685);
	
	var _ProjetosUsuario2 = _interopRequireDefault(_ProjetosUsuario);
	
	var _odsFundacao = __webpack_require__(1721);
	
	var _odsFundacao2 = _interopRequireDefault(_odsFundacao);
	
	var _cotacaoExcecoes = __webpack_require__(1703);
	
	var _cotacaoExcecoes2 = _interopRequireDefault(_cotacaoExcecoes);
	
	var _listaValidacaoLicencas = __webpack_require__(1715);
	
	var _listaValidacaoLicencas2 = _interopRequireDefault(_listaValidacaoLicencas);
	
	var _ListaSolicitacaoPrestacaoContasSimplificado = __webpack_require__(1724);
	
	var _ListaSolicitacaoPrestacaoContasSimplificado2 = _interopRequireDefault(_ListaSolicitacaoPrestacaoContasSimplificado);
	
	var _ListaValidacaoPrestacaoCOntasSimplificado = __webpack_require__(1725);
	
	var _ListaValidacaoPrestacaoCOntasSimplificado2 = _interopRequireDefault(_ListaValidacaoPrestacaoCOntasSimplificado);
	
	var _PrestacaoSimplificadaGED = __webpack_require__(1729);
	
	var _PrestacaoSimplificadaGED2 = _interopRequireDefault(_PrestacaoSimplificadaGED);
	
	var _downloadArquivoPrestacao = __webpack_require__(1731);
	
	var _downloadArquivoPrestacao2 = _interopRequireDefault(_downloadArquivoPrestacao);
	
	var _GerenciadorEdicaoLog = __webpack_require__(1769);
	
	var _GerenciadorEdicaoLog2 = _interopRequireDefault(_GerenciadorEdicaoLog);
	
	var _ListaValidacaoSolicitacoesFinanceiras = __webpack_require__(1826);
	
	var _ListaValidacaoSolicitacoesFinanceiras2 = _interopRequireDefault(_ListaValidacaoSolicitacoesFinanceiras);
	
	var _GerenciadorPropostaSimplificada = __webpack_require__(1771);
	
	var _GerenciadorPropostaSimplificada2 = _interopRequireDefault(_GerenciadorPropostaSimplificada);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withPrefix = function withPrefix(prefix, routes) {
	  return routes.map(function (route) {
	    route.path = prefix + route.path;
	    return route;
	  });
	};
	
	var routes = [{
	  path: '/login',
	  name: 'login',
	  component: _Login2.default,
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className = 'login-page';
	    next();
	  }
	}, {
	  path: '/esqueci-minha-senha',
	  name: 'recupera-senha',
	  component: _EsqueciMinhaSenha2.default,
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className = 'login-page';
	    next();
	  }
	}, {
	  path: '/altera-senha',
	  name: 'altera-senha',
	  component: _AlterarSenha2.default,
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className = 'login-page';
	    next();
	  }
	}, {
	  path: '/autocredenciamento',
	  name: 'auto-credenciamento',
	  component: _AutoCredenciamento2.default,
	  meta: { requiresAuth: false },
	  beforeEnter: function beforeEnter(to, from, next) {
	    next();
	  }
	}, {
	  path: '/form/:id?',
	  name: 'preenche-formulario-externo',
	  component: _PreencheFormulario2.default,
	  meta: { requiresAuth: false },
	  beforeEnter: function beforeEnter(to, from, next) {
	    next();
	  }
	}, {
	  path: '/se/:id?',
	  name: 'visualiza-sumario-executivo-externo',
	  component: _EditaSumarioExecutivo2.default,
	  meta: { requiresAuth: false },
	  beforeEnter: function beforeEnter(to, from, next) {
	    next();
	  }
	}, {
	  path: '/proposta/visualiza/:id?/edital',
	  name: 'proposta-edital-externo',
	  component: _ImprimirPropostaEdital2.default,
	  meta: { requiresAuth: false },
	  beforeEnter: function beforeEnter(to, from, next) {
	    next();
	  }
	}, {
	  path: '/',
	  component: _Dashboard2.default,
	  meta: { requiresAuth: true },
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className += ' skin-fbb sidebar-mini';
	
	    next();
	  },
	  children: [{
	    path: '',
	    redirect: '/dashboard'
	  }, {
	    path: '/dashboard',
	    name: 'dashboard',
	    component: _Index2.default
	  }, {
	    path: '/widgets',
	    name: 'widgets',
	    component: _Index4.default
	  }, {
	    path: 'baixarArquivoPrestacao/:id?',
	    name: 'baixar-arquivo-prestacao',
	    component: _downloadArquivoPrestacao2.default
	  }, {
	    path: '/log-edicao-proposta',
	    name: 'log-edicao-proposta',
	    component: _GerenciadorEdicaoLog2.default
	  }].concat((0, _toConsumableArray3.default)(withPrefix('/formulario', [{
	    path: '/edita',
	    name: 'edita-formulario',
	    component: _EditaFormulario2.default
	  }, {
	    path: '/cadastro',
	    name: 'cadastro-formulario',
	    component: _CadastroFormulario2.default
	  }, {
	    path: '/:id?',
	    name: 'preenche-formulario',
	    component: _PreencheFormulario2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/sumario_executivo', [{
	    path: '/lista',
	    name: 'lista-sumario-executivo',
	    component: _ListaSumarioExecutivo2.default
	  }, {
	    path: '/:id?',
	    name: 'edita-sumario-executivo',
	    component: _EditaSumarioExecutivo2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/articulacao', [{
	    path: '/lista',
	    name: 'lista-articulacoes',
	    component: _ListaArticulacoes2.default
	  }, {
	    path: '/:id?',
	    name: 'edita-articulacao',
	    component: _EditaArticulacao2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/ocorrencias', [{
	    path: '/lista',
	    name: 'lista-ocorrencias',
	    component: _ListaOcorrencias2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/ods', [{
	    path: '/lista',
	    name: 'lista-ods-fundacao',
	    component: _odsFundacao2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/propostas-simplificadas', [{
	    path: '/lista',
	    name: 'propostas-simplificadas',
	    component: _GerenciadorPropostaSimplificada2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/cotacao', [{
	    path: '/lista',
	    name: 'lista-cotacao-automatica-excecoes',
	    component: _cotacaoExcecoes2.default
	  }])), [{
	    path: '/ui/buttons',
	    name: 'ui-buttons',
	    component: _Buttons2.default
	  }], (0, _toConsumableArray3.default)(withPrefix('/cadastro', [{
	    path: '/usuarios/lista',
	    name: 'cadastro-usuarios-lista',
	    component: _ListaUsuarios_old2.default
	  }, {
	    path: '/usuarios/cadastro',
	    name: 'cadastro-usuarios',
	    component: _ListaUsuarios2.default
	  }, {
	    path: '/usuarios/altera/:id',
	    name: 'cadastro-usuarios-altera',
	    component: _EditaUsuario2.default
	  }, {
	    path: '/usuarios/edita/:id',
	    name: 'cadastro-usuarios-edita',
	    component: _EditaUsuario_old2.default
	  }, {
	    path: '/usuarios/projetos',
	    name: 'projetos-usuarios',
	    component: _ProjetosUsuario2.default
	  }, {
	    path: '/perfis/lista',
	    name: 'cadastro-perfis-lista',
	    component: _listaPerfis2.default
	  }, {
	    path: '/perfis/edita/:id',
	    name: 'cadastro-perfis-edita',
	    component: _EditarPerfil2.default
	  }, {
	    path: '/permissoes/lista',
	    name: 'cadastro-permissoes-lista',
	    component: _ListaPermissoes2.default
	  }, {
	    path: '/acoes/lista',
	    name: 'cadastro-acoes-lista',
	    component: _ListaAcoes2.default
	  }, {
	    path: '/editais/lista',
	    name: 'cadastro-editais-lista',
	    component: _ListaEditais2.default
	  }, {
	    path: '/editais/edita/:number?',
	    name: 'cadastro-editais-edita',
	    component: _EditarEdital2.default
	  }, {
	    path: '/chamado/lista',
	    name: 'cadastro-chamado-lista',
	    component: _ListaChamado2.default
	  }, {
	    path: '/chamado/criar',
	    name: 'abrir-chamado',
	    component: _AbrirChamado2.default
	  }, {
	    path: '/chamado/edita/:id?',
	    name: 'cadastro-chamado-edita',
	    component: _EditarChamado2.default
	  }, {
	    path: '/chamado/relatorio',
	    name: 'relatorio-chamado',
	    component: _RelatorioChamado2.default
	  }, {
	    path: '/assunto/lista',
	    name: 'cadastro-assunto-lista',
	    component: _ListaAssunto2.default
	  }, {
	    path: '/assunto/edita/:number?',
	    name: 'cadastro-assunto-edita',
	    component: _EditarAssunto2.default
	  }, {
	    path: '/motivos/lista',
	    name: 'cadastro-motivos-lista',
	    component: _ListaMotivos2.default
	  }, {
	    path: '/motivos/edita/:number?',
	    name: 'cadastro-motivos-edita',
	    component: _EditarMotivos2.default
	  }, {
	    path: '/simplificado/lista',
	    name: 'cadastro-simplificado-lista',
	    component: _ListaSimplificado2.default
	  }, {
	    path: '/simplificado/edita/:id?',
	    name: 'cadastro-simplificado-edita',
	    component: _EditarSimplificado2.default
	  }, {
	    path: '/documentos/lista',
	    name: 'cadastro-documentos-lista',
	    component: _ListaTipoDocumentos2.default
	  }, {
	    path: '/entidades/lista',
	    name: 'cadastro-entidade-lista',
	    component: _listaEntidades2.default
	  }, {
	    path: '/entidades/edita/:id?',
	    name: 'cadastro-entidade-edita',
	    component: _EditaEntidades2.default
	  }, {
	    path: '/entidades/visualiza/:id?',
	    name: 'cadastro-entidade-visualiza',
	    component: _VisualizaEntidades2.default
	  }, {
	    path: '/entidades/credenciamento',
	    name: 'entidade-credenciamento',
	    component: _CredenciamentoEntidade2.default
	  }, {
	    path: '/entidades/simplificado',
	    name: 'entidade-simplificado',
	    component: _EntidadeSimplificado2.default
	  }, {
	    path: '/entidades/entidadeProposta',
	    name: 'entidade-proposta',
	    component: _EntidadeProposta2.default
	  }, {
	    path: '/entidades/entidadePropostaEdital',
	    name: 'entidade-proposta-edital',
	    component: _EntidadePropostaEdital2.default
	  }, {
	    path: '/parceiros-estrategicos/lista',
	    name: 'cadastro-parceiro-estrategico-lista',
	    component: _ListaParcEstrategico2.default
	  }, {
	    path: '/parceiros-estrategicos/edita/:id?',
	    name: 'cadastro-parceiro-estrategico-edita',
	    component: _EditaParcEstrategico2.default
	  }, {
	    path: '/parceiros-estrategicos/novo',
	    name: 'cadastro-parceiro-estrategico-novo',
	    component: _EditaParcEstrategico2.default
	  }, {
	    path: '/ged',
	    name: 'cadastro-ged',
	    component: _ListaGed2.default
	  }, {
	    path: '/movimento-diario',
	    name: 'movimento-diario',
	    component: _MovimentoDiario2.default
	  }, {
	    path: '/ratificacao/lista',
	    name: 'lista-ratificacao',
	    component: _ListaRatificacao2.default
	  }, {
	    path: '/ratificacao/lista-pendentes',
	    name: 'lista-ratificacao-pendentes',
	    component: _ListaRatificacaoPendentes2.default
	  }, {
	    path: '/ratificacao/',
	    name: 'edita-ratificacao',
	    component: _EditaRatificacao2.default
	  }, {
	    path: '/ratificacao/:id?',
	    name: 'edita-ratificacao',
	    component: _EditaRatificacao2.default
	  }, {
	    path: '/manuais',
	    name: 'manuais',
	    component: _Manuais2.default
	  }, {
	    path: '/fav',
	    name: 'cadastro-fav-lista',
	    component: _ListaFav2.default
	  }, {
	    path: '/fav/edita',
	    name: 'cadastro-fav-edita',
	    component: _EditaFav2.default
	  }, {
	    path: '/fav/nova',
	    name: 'cadastro-fav-nova',
	    component: _NovaFav2.default
	  }, {
	    path: '/fep',
	    name: 'cadastro-fep-lista',
	    component: _ListaFep2.default
	  }, {
	    path: '/fep/edita',
	    name: 'cadastro-fep-edita',
	    component: _EditaFep2.default
	  }, {
	    path: '/fep/manual',
	    name: 'relatorio-fep-aberto',
	    component: _relatorioFepAberto2.default
	  }, {
	    path: '/fep/manual-edita:id?',
	    name: 'relatorio-fep-aberto-edita',
	    component: _relatorioFepAberto2.default
	  }, {
	    path: '/documentos/edita/:id?',
	    name: 'cadastro-documentos-edita',
	    component: _EditarDocumentos2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/proposta', [{
	    path: '/lista',
	    name: 'proposta-lista',
	    component: _ListaProposta2.default
	  }, {
	    path: '/edita/:id?',
	    name: 'proposta-edita',
	    component: _EditaProposta2.default
	  }, {
	    path: '/relatorio-analise/:id?',
	    props: true,
	    name: 'relatorio-analise',
	    meta: { title: 'Relatório da Análise' },
	    component: _relatorioAnalise2.default
	  }, {
	    path: '/visualiza-relatorio-analise/:id?',
	    props: true,
	    name: 'visualiza-relatorio-analise',
	    meta: { title: 'Visualizar Relatório da Análise' },
	    component: _visualizaRelatorioAnalise2.default
	  }, {
	    path: '/relatorio-rating/:id?',
	    props: true,
	    name: 'relatorio-rating',
	    meta: { title: 'Rating da Entidade' },
	    component: _relatorioRating2.default
	  }, {
	    path: '/relatorio-fep/:id?',
	    props: function props() {
	      return { propsRel: {} };
	    },
	    name: 'relatorio-fep',
	    meta: { title: 'FEP' },
	    component: _relatorioFep2.default
	  }, {
	    path: '/visualiza/:id?',
	    name: 'proposta-visualiza',
	    component: _EditaProposta2.default
	  }, {
	    path: '/imprimir/:id?',
	    name: 'imprimir-proposta',
	    component: _ImprimirProposta2.default
	  }, {
	    path: '/plano-trabalho/:id?',
	    name: 'plano-trabalho',
	    component: _PlanoTrabalho2.default
	  }, {
	    path: '/liberacao/:id?',
	    name: 'proposta-liberacao',
	    component: _Liberacao2.default
	  }, {
	    path: '/simplificada/:id?',
	    name: 'proposta-simplificada',
	    component: _Simplificada2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/validacao', [{
	    path: '/proposta/lista/:fase?',
	    name: 'validacao-proposta-lista',
	    component: _ListaValidacaoProposta2.default
	  }, {
	    path: '/proposta/primeira-validacao/:id?',
	    name: 'proposta-primeira-validacao',
	    component: _PrimeiraAprovacao2.default
	  }, {
	    path: '/proposta/analise/:id?',
	    name: 'validacao-proposta-analise',
	    component: _analiseGeral2.default
	  }, {
	    path: '/proposta/deferimento/:id?',
	    name: 'validacao-proposta-deferimento',
	    component: _mainDeferimento2.default
	  }, {
	    path: '/proposta/aceite/:id?',
	    name: 'validacao-proposta-aceite',
	    component: _aceite2.default
	  }, {
	    path: '/proposta/preparaco-documento/:id?',
	    name: 'validacao-proposta-preparacao-documento',
	    component: _mainPreparacaoDocumento2.default
	  }, {
	    path: '/proposta/formalizacao/:id?',
	    name: 'validacao-proposta-formalizacao',
	    component: _mainFormalizacao2.default
	  }, {
	    path: '/proposta/aprovacao/:id?',
	    name: 'validacao-proposta-aprovacao',
	    component: _mainAprovacaoProjeto2.default
	  }, {
	    path: '/adiantamento/analise/:id?',
	    name: 'validacao-adiantamento-analise',
	    component: _validacaoAdiantamentoAnalise2.default
	  }, {
	    path: '/adiantamento/autorizacao/:id?',
	    name: 'validacao-adiantamento-autorizacao',
	    component: _validacaoAdiantamentoAnalise2.default
	  }, {
	    path: '/adiantamento/analise_financeira/:id?',
	    name: 'validacao-adiantamento-analisefinanceira',
	    component: _validacaoAdiantamentoAnalise2.default
	  }, {
	    path: '/adiantamento/revisao/:id?',
	    name: 'validacao-adiantamento-revisao',
	    component: _validacaoAdiantamentoAnalise2.default
	  }, {
	    path: '/devolucao_adiantamento/analise/:id?',
	    name: 'validacao-devolucao-adiantamento-analise',
	    component: _validacaoDevolucaoAdiantamentoAnalise2.default
	  }, {
	    path: '/devolucao_adiantamento/analise_financeira/:id?',
	    name: 'validacao-devolucao-adiantamento-analisefinanceira',
	    component: _validacaoDevolucaoAdiantamentoAnalise2.default
	  }, {
	    path: '/devolucao_adiantamento/revisao/:id?',
	    name: 'validacao-devolucao-adiantamento-revisao',
	    component: _validacaoDevolucaoAdiantamentoAnalise2.default
	  }, {
	    path: '/entidade/validacao/:id?',
	    name: 'validacao-entidades',
	    component: _ValidaEntidades2.default
	  }, {
	    path: '/parceiros-estrategicos/validacao/:id?',
	    name: 'validacao-parceiro',
	    component: _ValidaParceiro2.default
	  }, {
	    path: '/entidade/validacao/detalhe/:id?',
	    name: 'detalhe-validacao-entidades',
	    component: _DetalheValidaEntidade2.default
	  }, {
	    path: '/entidade/validacao/:id?',
	    name: 'validacao-inicial',
	    component: _ValidaInicial2.default
	  }, {
	    path: '/entidade/lista/:fase?',
	    name: 'validacao-entidade-lista',
	    component: _ListaValidacaoEntidade2.default
	  }, {
	    path: '/validacaoInicial/lista/:fase?',
	    name: 'validacao-inicial-lista',
	    component: _ListaValidacaoInicial2.default
	  }, {
	    path: '/validacao-parceiro-estrategico/lista/:fase?',
	    name: 'validacao-parc-est-lista',
	    component: _ListaValidacaoParcEst2.default
	  }, {
	    path: '/validacao-solicitacoes/lista/:fase?',
	    name: 'validacao-solicitacoes-lista',
	    component: _ListaValidacaoSolicitacoes2.default
	  }, {
	    path: '/validacao-solicitacoes-financeiras/lista/:fase?',
	    name: 'validacao-solicitacoes-financeiras-lista',
	    component: _ListaValidacaoSolicitacoesFinanceiras2.default
	  }, {
	    path: '/validacao-licencas',
	    name: 'validacao-licencas',
	    component: _listaValidacaoLicencas2.default
	  }, {
	    path: '/validacao-prestacao-contas-simplificada',
	    name: 'validacao-prestacao-contas-simplificada',
	    component: _ListaValidacaoPrestacaoCOntasSimplificado2.default
	  }, {
	    path: '/validacao-relatorio-execucao/lista/:fase?',
	    name: 'validacao-relatorio-execucao',
	    component: _ListaValidacaoRelExec2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/solicitacao', [{
	    path: '/lista',
	    name: 'solicitacao-lista',
	    component: _ListaSolicitacao2.default
	  }, {
	    path: '/prestacao-contas-simplificada',
	    name: 'prestacao-contas-simplificada',
	    component: _ListaSolicitacaoPrestacaoContasSimplificado2.default
	  }, {
	    path: '/prestacao-contas-simplificada-ged/:id?',
	    name: 'prestacao-contas-simplificada-ged',
	    component: _PrestacaoSimplificadaGED2.default
	  }, {
	    path: 'ui/general',
	    name: 'ui-general',
	    component: _General2.default
	  }, {
	    path: '/pagamento/',
	    name: 'solicitacao-pagamento',
	    component: _EditaPagamento2.default
	  }, {
	    path: '/contrapartida/',
	    name: 'solicitacao-contrapartida',
	    component: _EditaPagamento2.default
	  }, {
	    path: '/prestacaocontas/',
	    name: 'solicitacao-prestacaocontas',
	    component: _EditaPagamento2.default
	  }, {
	    path: '/ressarcimento/',
	    name: 'solicitacao-ressarcimento',
	    component: _EditaPagamento2.default
	  }, {
	    path: '/alteracoesprojeto/',
	    name: 'solicitacao-alteracoes-projeto',
	    component: _EditaProjeto2.default
	  }, {
	    path: '/alteracoesprojeto/:id?',
	    name: 'solicitacao-alteracoes-projeto',
	    component: _EditaProjeto2.default
	  }, {
	    path: '/alteracoesprojeto/visualizacao/:id?',
	    name: 'solicitacao-alteracoes-projeto-visualizacao',
	    component: _EditaProjeto2.default
	  }, {
	    path: '/alteracoesprojeto/sumula/',
	    name: 'solicitacao-alteracoes-projeto-sumula',
	    component: _Sumula2.default
	  }, {
	    path: '/alteracoesprojeto/sumula/:id?',
	    name: 'solicitacao-alteracoes-projeto-sumula',
	    component: _Sumula2.default
	  }, {
	    path: '/alteracoesprojeto/aditivo/',
	    name: 'solicitacao-alteracoes-projeto-aditivo',
	    component: _Aditivo2.default
	  }, {
	    path: '/alteracoesprojeto/aditivo/:id?',
	    name: 'solicitacao-alteracoes-projeto-aditivo',
	    component: _Aditivo2.default
	  }, {
	    path: '/alteracoesprojeto/plano-trabalho/',
	    name: 'solicitacao-alteracoes-projeto-plano-trabalho',
	    component: _PlanoTrabalho4.default
	  }, {
	    path: '/alteracoesprojeto/plano-trabalho/:id?',
	    name: 'solicitacao-alteracoes-projeto-plano-trabalho',
	    component: _PlanoTrabalho4.default
	  }, {
	    path: '/pagamento/:id?',
	    name: 'solicitacao-pagamento',
	    component: _EditaPagamento2.default
	  }, {
	    path: '/contrapartida/:id?',
	    name: 'solicitacao-contrapartida',
	    component: _EditaPagamento2.default
	  }, {
	    path: '/prestacaocontas/:id?',
	    name: 'solicitacao-prestacaocontas',
	    component: _EditaPagamento2.default
	  }, {
	    path: '/ressarcimento/:id?',
	    name: 'solicitacao-ressarcimento',
	    component: _EditaPagamento2.default
	  }, {
	    path: '/adiantamento/',
	    name: 'solicitacao-adiantamento',
	    component: _EditaAdiantamento2.default
	  }, {
	    path: '/adiantamento/:id?',
	    name: 'solicitacao-adiantamento',
	    component: _EditaAdiantamento2.default
	  }, {
	    path: '/devolucao_adiantamento/',
	    name: 'solicitacao-devolucao-adiantamento',
	    component: _EditaAdiantamento2.default
	  }, {
	    path: '/devolucao_adiantamento/:id?',
	    name: 'solicitacao-devolucao-adiantamento',
	    component: _EditaAdiantamento2.default
	  }])), (0, _toConsumableArray3.default)(withPrefix('/projetos', [{
	    path: '/lista',
	    name: 'lista-projetos',
	    component: _ListaProjetos2.default
	  }, {
	    path: '/ger_atividades/:numeroProjeto?',
	    name: 'visualiza-gestao-atividades',
	    component: _GestaoAtividades2.default
	  }, {
	    path: '/pendencias_projeto/:numeroProjeto?',
	    name: 'visualiza-pendencias-projeto',
	    component: _PendenciasProjeto2.default
	  }, {
	    path: '/visualizar/:id?',
	    name: 'visualiza-projeto',
	    component: _VisualizaProjeto2.default
	  }, {
	    path: '/projeto/:numero?',
	    name: 'projeto',
	    component: _Projeto2.default
	  }, {
	    path: '/relatorio-execucao/:id?',
	    name: 'visualiza-relatorio-execucao',
	    component: _ListaRelExec2.default
	  }, {
	    path: '/timeline/:id?',
	    name: 'visualiza-timeline',
	    component: _Timeline4.default
	  }, {
	    path: '/roteiro/:id?',
	    name: 'visualiza-roteiro',
	    component: _Roteiro2.default
	  }, {
	    path: '/atividade/gantt/:id?',
	    name: 'visualiza-gantt',
	    component: _Atividades2.default
	  }, {
	    path: '/relatorio-execucao/',
	    name: 'edita-relatorio-execucao',
	    component: _EditaRelExec2.default
	  }, {
	    path: '/emissao-documentos/:numero?',
	    name: 'emissao-documentos',
	    component: _EmissaoDocumentos2.default
	  }])), [{
	    path: 'ui/general',
	    name: 'ui-general',
	    component: _General2.default
	  }], (0, _toConsumableArray3.default)(withPrefix('/relatorios', [{
	    path: '/impressao',
	    name: 'impressao-relatorio',
	    component: _ImpressaoRel2.default
	  }, {
	    path: '/relatorioBi',
	    name: 'relatorioBi',
	    component: _relatorioBi2.default
	  }, {
	    path: '/remessas',
	    name: 'geracao-remessa',
	    component: _GeracaoRemessa2.default
	  }, {
	    path: '/remessas/lista-bndes',
	    name: 'lista-remessa-bndes',
	    component: _ListaRemessaBNDES2.default
	  }, {
	    path: '/retorno',
	    name: 'tratamento-retorno',
	    component: _TratamentoRetorno2.default
	  }])), [{
	    path: '/ui/icons',
	    name: 'ui-icons',
	    component: _Icons2.default
	  }], (0, _toConsumableArray3.default)(withPrefix('/relatorios-erp', [{
	    path: '/cadastro',
	    name: 'cadastro-relatorio',
	    component: _CadastroRel2.default
	  }, {
	    path: '/cadastro/edita',
	    name: 'edita-relatorio',
	    component: _EditaCadastroRel2.default
	  }, {
	    path: '/relatoriosERP/emissao',
	    name: 'emite-relatorio',
	    component: _EmiteRelatorioERP2.default
	  }])), [{
	    path: '/ui/modals',
	    name: 'ui-modals',
	    component: _Modals2.default
	  }, {
	    path: '/ui/sliders',
	    name: 'ui-sliders',
	    component: _Sliders2.default
	  }, {
	    path: '/ui/timeline',
	    name: 'ui-timeline',
	    component: _Timeline2.default
	  }], (0, _toConsumableArray3.default)(withPrefix('/configuracoes', [{
	    path: '/emails',
	    name: 'logs-email',
	    component: _LogEmails2.default
	  }, {
	    path: '/gerais',
	    name: 'conf-gerais',
	    component: _ConfGerais2.default
	  }, {
	    path: '/gerais',
	    name: 'preferencias',
	    component: _Preferencias2.default
	  }])), [{
	    path: '*',
	    name: '404',
	    component: _2.default
	  }])
	}];
	
	exports.default = routes;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(86);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  token: null,
	  tokenLaravel: null,
	  user: window.localStorage.user,
	  usuario: window.localStorage.usuario ? JSON.parse(window.localStorage.usuario) : null,
	  userPermissions: window.localStorage.userPermissions,
	  laravelurl: null,
	  categorizadores: [],
	  ramoAtividades: [],
	  formasJuridicas: [],
	  configuracoes: [],
	  questionarioRisco: [],
	  tipoRegistros: [],
	  projetosDuplicacao: []
	};
	var env = {
	  laravel: ''
	};
	
	var mutations = {
	  SET_TOKEN: function SET_TOKEN(state, token) {
	    state.token = token;
	  },
	  REMOVE_TOKEN: function REMOVE_TOKEN(state) {
	    state.token = null;
	  },
	  SET_USER: function SET_USER(state, data) {
	    state.token = data.token;
	    state.userPermissions = data.info;
	  },
	  REMOVE_USER: function REMOVE_USER(state) {
	    state.token = null;
	    state.userPermissions = null;
	  },
	  SET_USER_LARAVEL: function SET_USER_LARAVEL(state, data) {
	    state.tokenLaravel = data.access_token;
	    state.usuario = data.usuario;
	    state.userPermissions = data.usuario.permissoes;
	  },
	  REMOVE_USER_LARAVEL: function REMOVE_USER_LARAVEL(state) {
	    state.tokenLaravel = null;
	    state.usuario = null;
	  },
	  SET_USER_DETAIL: function SET_USER_DETAIL(state, data) {
	    state.user = data;
	  },
	  REMOVE_USER_DETAIL: function REMOVE_USER_DETAIL(state) {
	    state.user = null;
	  },
	  SET_LARAVEL: function SET_LARAVEL(state, url) {
	    state.laravelurl = url.replace('/api/', '');
	  },
	  SET_CATEGORIZADORES: function SET_CATEGORIZADORES(state, data) {
	    state.categorizadores = data;
	  },
	  SET_RAMO_ATIVIDADES: function SET_RAMO_ATIVIDADES(state, data) {
	    state.ramoAtividades = data;
	  },
	  SET_FORMAS_JURIDICAS: function SET_FORMAS_JURIDICAS(state, data) {
	    state.formasJuridicas = data;
	  },
	  SET_CONFIGURACOES: function SET_CONFIGURACOES(state, data) {
	    state.configuracoes = data;
	  },
	  SET_QUESTIONARIO: function SET_QUESTIONARIO(state, data) {
	    state.questionarioRisco = data;
	  },
	  SET_TIPOREGISTROS: function SET_TIPOREGISTROS(state, data) {
	    state.tipoRegistros = data;
	  },
	  SET_PROJETOS_DUPLICACAO: function SET_PROJETOS_DUPLICACAO(state, data) {
	    state.projetosDuplicacao = data;
	  }
	};
	
	var getters = {
	  usuarioLogado: function usuarioLogado(state) {
	    return state.usuario;
	  },
	  urlLaravel: function urlLaravel() {
	    return env.laravel;
	  }
	};
	
	var ItensDespesas = {
	  state: {
	    produtos: [],
	    servicos: []
	  },
	  getters: {
	    produtos: function produtos(state) {
	      return state.produtos;
	    },
	    servicos: function servicos(state) {
	      return state.servicos;
	    }
	  }
	};
	
	var UploadDocumentos = {
	  state: {
	    tiposPermitidos: null,
	    tamanhoPermitido: null,
	    documentos: []
	  },
	  getters: {
	    tiposPermitidos: function tiposPermitidos(state) {
	      return state.tiposPermitidos;
	    },
	    tamanhoPermitido: function tamanhoPermitido(state) {
	      return state.tamanhoPermitido;
	    },
	    documentos: function documentos(state) {
	      return state.documentos;
	    }
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations,
	  getters: getters,
	  modules: {
	    itensDespesas: ItensDespesas,
	    uploadDocumentos: UploadDocumentos
	  }
	});

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.AlertSuccess = exports.AlertErrors = exports.AlertError = exports.HasError = exports.Errors = exports.Form = undefined;
	
	var _Form = __webpack_require__(273);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Errors = __webpack_require__(272);
	
	var _Errors2 = _interopRequireDefault(_Errors);
	
	var _HasError = __webpack_require__(1836);
	
	var _HasError2 = _interopRequireDefault(_HasError);
	
	var _AlertError = __webpack_require__(1833);
	
	var _AlertError2 = _interopRequireDefault(_AlertError);
	
	var _AlertErrors = __webpack_require__(1834);
	
	var _AlertErrors2 = _interopRequireDefault(_AlertErrors);
	
	var _AlertSuccess = __webpack_require__(1835);
	
	var _AlertSuccess2 = _interopRequireDefault(_AlertSuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Form = _Form2.default;
	exports.Errors = _Errors2.default;
	exports.HasError = _HasError2.default;
	exports.AlertError = _AlertError2.default;
	exports.AlertErrors = _AlertErrors2.default;
	exports.AlertSuccess = _AlertSuccess2.default;
	exports.default = _Form2.default;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  pt_BR: {
	    REASON_CODES: {
	      forgot_password_used: 'Este token já foi utilizado',
	      data_not_found: 'Registro não encontrado',
	      external_connection_exception: 'Conexão com o servidor de importação dos usuários inativa',
	      recovery_not_permitted: 'Contate o administrador para recuperar a senha.',
	      CHANGE_TOKEN_NOT_FOUND: 'O token informado é inválido',
	      USER_NOT_FOUND: 'Usuário não encontrado',
	      USER_INACTIVE: 'Usuário não está ativo',
	      USER_NOT_IMPORTED: 'Usuário não está importado no sistema',
	      WRONG_CURRENT_PASSWORD: 'Senha atual inválida',
	      CPF_DUPLICATE: 'CPF duplicado',
	      EMAIL_DUPLICATE_REGISTER: 'O e-mail informado já foi cadastrado para outro usuário existente',
	      AGENCY_DUPLICATE_REGISTER: 'Já existe um usuário cadastrado para essa agência',
	      SUPERINTENDENCE_DUPLICATE_REGISTER: 'Já existe um usuário cadastrado para essa superintendência',
	      USER_CANNOT_BE_NULL: 'Usuário não pode ser nulo',
	      USER_PHOTO_NOT_SENT: 'Foto não enviada',
	      PROFILE_DUPLICATE: 'Já existe um perfil existente com o nome informado',
	      FAIL_TO_GET_ENTITY_USERS: 'Falha na requisição da lista de usuário de uma entidade',
	      CANNOT_CHANGE_PASSWORD: 'A troca de senha não permitida para usuários da FUNDAÇÂO. Contacte seu administrador de rede',
	      ENTITY_NOT_FOUND: 'Entidade não encontrada',
	      ENTITY_CNPJ_DUPLICATE: 'Entidade com este CNPJ já registrada',
	      ENTITY_REGISTER_ERROR: 'Falha ao cadastrar proposta',
	      APPROVAL_SAME_APPRAISER: 'Avaliador das aprovações da entidade não pode ser o mesmo',
	      APPROVAL_SAME_APPRAISER_CREATE_ENTITY: 'Avaliador das aprovações da entidade não pode ser o mesmo usuário que cadastrou a entidade',
	      NO_APPROVERS: 'Não existem avaliadores cadastrados',
	      FAIL_TO_CLONE_APPROVAL: 'Falha ao clonar a aprovação',
	      PRE_ANALYSIS_APPROVAL_SAME_APPRAISER: 'Avaliador da pré-análise não pode ser o mesmo que fez a primeira aprovação',
	      PRE_ANALYSIS_APPROVAL_SAME_APPRAISER_CREATE_ENTITY: 'Avaliador da pré-análise não pode ser o mesmo usuário que cadastrou a proposta',
	      INVALID_REQUEST_APPROVAL_RESULT: 'O RequestApprovalResult é inválido.',
	      NOTIFICATION_NOT_FOUND: 'Notificação não encontrada',
	      APPROVAL_ITEM_NOT_FOUND: 'Item não encontrado',
	      DATA_NOT_FOUND: 'Dados não encontrados',
	      DOCUMENT_CANNOT_BE_NULL: 'O documento não pode ser nulo',
	      DOCUMENT_NOT_SENT: 'Documento não enviado',
	      DOCUMENT_TOO_LARGE: 'Documento muito grande',
	      DOCUMENT_NOT_FOUND: 'Documento não encontrado',
	      UNSENT_FILE_INFORMATION: 'Informações do arquivo não enviadas',
	      FAIL_TO_CLEAN_BLOB: 'Falha ao limpar o BLOB',
	      FAIL_TO_HANDLE_DOCUMENT: 'Falha na manipulação do arquivo',
	      FAIL_TO_DELETE_DOCUMENT: 'Falha na exclusão do arquivo',
	      FILE_TOO_LARGE: 'Arquivo muito grande',
	      INVALID_FILE_TYPE: 'Tipo de arquivo não permitido',
	      PROPOSAL_REGISTER_ERROR: 'Falha ao cadastrar proposta'
	    },
	    approval: {
	      OPENED: 'Enviado para aprovação',
	      OPENED_4_APPROVE: 'Pendente de aprovação',
	      APPROVED: 'Aprovada',
	      REJECTED: 'Rejeitada',
	      EXECUTED: 'Executada',
	      preCondition: 'Sua solicitação foi processada e encaminhada para aprovação superior, assim que for aprovada sua requisição será processada.',
	      inbox: 'Caixa de entrada',
	      detail: 'Detalhes'
	    },
	    login: {
	      sign_in_to_start_your_session: 'Faça seu acesso',
	      login_email: 'Login ou E-mail',
	      password: 'Senha',
	      remember_me: 'Lembrar-me',
	      sign_in: 'Acessar',
	      sign_in_loading: 'Carregando',
	      or: 'OU',
	      sign_in_facebook: 'Acessar usando o Facebook',
	      sign_in_google: 'Acessar usando Google+',
	      forgot_my_password: 'Esqueci minha senha',
	      register_a_new_membership: 'Cadastrar um novo usuário',
	      developed_by: 'Desenvolvido por',
	      error: 'Erro:',
	      error_auth: 'Não foi possível realizar seu login, verifique seu usuário ou senha.',
	      error_general: 'Falha ao realizar o login, contate o administrador do sistema.'
	    },
	    pwdConfirm: {
	      title: 'Confirmar operação',
	      description: 'Para confirmar está ação por favor digite sua senha:',
	      password: 'Informe a senha atual',
	      cancel: 'Cancelar',
	      confirm: 'Confirmar',
	      failed: 'Senha incorreta, não foi possível completar sua operação'
	    },
	    recovery: {
	      remember_password: 'Lembrar senha',
	      enter_login: 'Digite o login ou o seu e-mail',
	      login_email: 'Login ou E-mail',
	      recover_password: 'Recuperar senha',
	      back_to_login: 'Voltar para Login'
	    },
	    authority: {
	      register: {
	        'usuario-agencia-editar': 'Alterar Cadastro',
	        'usuario-agencia-visualizar': 'Visualizar Cadastro',
	        'usuario-agencia-novo': 'Criar Cadastro',
	        'usuario-agencia-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'usuario-agencia-atribuir-perfil': 'Atribuir Perfil',
	        'usuario-agencia-visualizar-por-mim': 'Visualizar Criados Por Mim',
	        'usuario-agencia-configurar': 'Configurar',
	        'usuario-fundacao-editar': 'Alterar Cadastro',
	        'usuario-fundacao-visualizar': 'Visualizar Cadastro',
	        'usuario-fundacao-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'usuario-fundacao-atribuir-perfil': 'Atribuir Perfil',
	        'usuario-fundacao-visualizar-por-mim': 'Visualizar Criados Por Mim',
	        'usuario-fundacao-configurar': 'Configurar',
	        'usuario-entidade-editar': 'Alterar Cadastros',
	        'usuario-entidade-visualizar': 'Visualizar Cadastro',
	        'usuario-entidade-novo': 'Criar Cadastro',
	        'usuario-entidade-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'usuario-entidade-atribuir-perfil': 'Atribuir Perfil',
	        'usuario-entidade-visualizar-por-mim': 'Visualizar Criados Por Mim',
	        'usuario-entidade-configurar': 'Configurar',
	        'usuario-estrategico-editar': 'Alterar Cadastro',
	        'usuario-estrategico-visualizar': 'Visualizar Cadastro',
	        'usuario-estrategico-novo': 'Criar Cadastro',
	        'usuario-estrategico-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'usuario-estrategico-atribuir-perfil': 'Atribuir Perfil',
	        'usuario-estrategico-visualizar-por-mim': 'Visualizar Criados Por Mim',
	        'usuario-estrategico-configurar': 'Configurar',
	        'usuario-superintendencia-editar': 'Alterar Cadastro',
	        'usuario-superintendencia-visualizar': 'Visualizar Cadastro',
	        'usuario-superintendencia-novo': 'Criar Cadastro',
	        'usuario-superintendencia-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'usuario-superintendencia-atribuir-perfil': 'Atribuir Perfil',
	        'usuario-superintendencia-visualizar-por-mim': 'Visualizar Criados Por Mim',
	        'usuario-superintendencia-configurar': 'Configurar',
	        'perfil-editar': 'Alterar Cadastro',
	        'perfil-visualizar': 'Visualizar Cadastro',
	        'perfil-novo': 'Criar Cadastro',
	        'perfil-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'perfil-atribuir-usuario': 'Atribuir Usuário',
	        'permissao-editar': 'Alterar Cadastro',
	        'permissao-visualizar': 'Visualizar  Cadastro',
	        'entidade-editar': 'Alterar Cadastro',
	        'entidade-excluir': 'Excluir Cadastro',
	        'entidade-configurar': 'Cadastro de Entidade',
	        'entidade-credenciar': 'Credenciar',
	        'entidade-cadastro-simplificado': 'Criar Cadastro Simplificado',
	        'entidade-cadastro-completo': 'Criar Cadastro Completo',
	        'entidade-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'entidade-validar': 'Validar Cadastro',
	        'entidade-visualizar': 'Visualizar Cadastro',
	        'entidade-visualizar-por-mim': 'Visualizar Criados Por Mim',
	        'minha-entidade-visualizar': 'Visualizar Cadastro',
	        'minha-entidade-editar': 'Alterar Cadastro',
	        'edital-editar': 'Alterar Cadastro',
	        'edital-visualizar': 'Visualizar Cadastro',
	        'edital-novo': 'Criar Cadastro',
	        'edital-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'documento-editar': 'Alterar Cadastro',
	        'documento-visualizar': 'Visualizar Cadastro',
	        'documento-novo': 'Criar Cadastro',
	        'documento-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'documento-configurar': 'Documentos do Sistema',
	        'tipo-documento-editar': 'Alterar Cadastro',
	        'tipo-documento-visualizar': 'Visualizar Cadastro',
	        'tipo-documento-novo': 'Criar Cadastro',
	        'tipo-documento-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'perfil-atribuido-configurar': 'Configurar',
	        'perfil-atribuido-editar': 'Atribuir',
	        'perfil-atribuido-visualizar': 'Visualizar',
	        'minha-proposta-visualizar': 'Visualizar Cadastro',
	        'minha-proposta-editar': 'Alterar Cadastro',
	        'meu-parceiro-estrategico-visualizar': 'Visualizar Cadastro',
	        'meu-parceiro-estrategico-editar': 'Alterar Cadastro',
	        'proposta-visualizar-por-mim': 'Visualizar Criados Por Mim',
	        'proposta-visualizar': 'Visualizar Cadastro',
	        'proposta-configurar': 'Cadastro de Proposta',
	        'proposta-liberar': 'Liberar Cadastro',
	        'proposta-cadastro-simplificado': 'Criar Cadastro Simplificado',
	        'proposta-cadastro-completo': 'Criar Cadastro Completo',
	        'pre-analise-primeira-aprovacao-validar': 'Validar Primeira Aprovação',
	        'pre-analise-segunda-aprovacao-validar': 'Validar Segunda Aprovação',
	        'aceite-proposta-validar': 'Validar Aceite',
	        'analise-aprovacao-validar': 'Validar Aprovação',
	        'analise-pendencia-aprovacao-validar': 'Validar Pendência da Aprovação',
	        'deferimento-aprovacao-validar': 'Validar Deferimento',
	        'preparacao-documentos-aprovacao-validar': 'Validar Preparação de Documentos',
	        'formalizacao-projetos-aprovacao-validar': 'Validar Formalizar Projetos',
	        'parceiro-estrategico-editar': 'Alterar Cadastro',
	        'parceiro-estrategico-visualizar': 'Visualizar Cadastro',
	        'parceiro-estrategico-novo': 'Criar Cadastro',
	        'parceiro-estrategico-ativar-inativar': 'Ativar / Inativar Cadastro',
	        'parceiro-estrategico-validar': 'Validar Cadastro',
	        'fav-editar': 'Acesso ao Módulo',
	        'ged-editar': 'Acesso ao Módulo',
	        'solicitacao-pagamento-editar': 'Criar solicitação',
	        'solicitacao-contrapartida-editar': 'Criar solicitação',
	        'solicitacao-adiantamento-editar': 'Criar solicitação',
	        'solicitacao-prestacaocontas-editar': 'Criar solicitação',
	        'solicitacao-devolucaoadiantamento-editar': 'Criar solicitação',
	        'solicitacao-configurar': 'Cadastro de Solicitação',
	        'solicitacao-pagamento-analisar': 'Analisar solicitação',
	        'solicitacao-pagamento-acompanhar': 'Acompanhar solicitação',
	        'solicitacao-contrapartida-analisar': 'Analisar solicitação',
	        'solicitacao-adiantamento-analisar': 'Analisar solicitação',
	        'solicitacao-adiantamento-aprovar': 'Autorizar solicitação',
	        'solicitacao-adiantamento-analisefinanceira': 'Fazer Análise Financeira da solicitação',
	        'solicitacao-devolucaoadiantamento-analisar': 'Analisar solicitação',
	        'solicitacao-devolucaoadiantamento-analisefinanceira': 'Fazer Análise Financeira da solicitação',
	        'solicitacao-prestacaocontas-analisar': 'Analisar solicitação',
	        'solicitacao-prestacaocontas-analisefinanceira': 'Autorizar solicitação',
	        'relatorio-execucao-editar': 'Editar relatório de execução',
	        'relatorio-execucao-enviar': 'Enviar relatório de execução',
	        'relatorio-execucao-aprovar-envio': 'Aprovar envio de relatório de execução',
	        'relatorio-execucao-aprovar-pendencia': 'Aprovar pendência de relatório de execução',
	        'relatorio-erp-novo': 'Criar',
	        'relatorio-erp-editar': 'Editar',
	        'relatorio-erp-excluir': 'Excluir',
	        'relatorio-erp-visualizar': 'Visualizar',
	        'relatorio-erp-emissao': 'Emissão',
	        'dashboard-propostas': 'Propostas',
	        'dashboard-projetos': 'Projetos',
	        'dashboard-saude-sistema': 'Saúde do sistema',
	        'dashboard-controle-propostas': 'Controle de propostas',
	        'dashboard-mapa-projetos': 'Mapa de projetos',
	        'meu-projeto-visualizar': 'Visualizar Meu Projeto',
	        'projeto-visualizar-por-mim': 'Visualizar Criados Por Mim',
	        'projeto-visualizar': 'Visualizar Projetos',
	        'entidade-cadastro-entidade-proposta-simplificado': 'Criar Cadastro Entidade/Proposta Simplificada',
	        'relatorio-execucao-aprovar-conhecimento': 'Aprovar relatório de execução enviado para conhecimento',
	        USUARIO_AGENCIA_EDITAR: 'Alterar Cadastro',
	        USUARIO_AGENCIA_VISUALIZAR: 'Visualizar Cadastro',
	        USUARIO_AGENCIA_NOVO: 'Criar Cadastro',
	        USUARIO_AGENCIA_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        USUARIO_AGENCIA_ATRIBUIR_PERFIL: 'Atribuir Perfil',
	        USUARIO_AGENCIA_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
	        USUARIO_AGENCIA_CONFIGURAR: 'Configurar',
	        USUARIO_FUNDACAO_EDITAR: 'Alterar Cadastro',
	        USUARIO_FUNDACAO_VISUALIZAR: 'Visualizar Cadastro',
	        USUARIO_FUNDACAO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        USUARIO_FUNDACAO_ATRIBUIR_PERFIL: 'Atribuir Perfil',
	        USUARIO_FUNDACAO_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
	        USUARIO_FUNDACAO_CONFIGURAR: 'Configurar',
	        USUARIO_ENTIDADE_EDITAR: 'Alterar Cadastros',
	        USUARIO_ENTIDADE_VISUALIZAR: 'Visualizar Cadastro',
	        USUARIO_ENTIDADE_NOVO: 'Criar Cadastro',
	        USUARIO_ENTIDADE_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        USUARIO_ENTIDADE_ATRIBUIR_PERFIL: 'Atribuir Perfil',
	        USUARIO_ENTIDADE_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
	        USUARIO_ENTIDADE_CONFIGURAR: 'Configurar',
	        USUARIO_ESTRATEGICO_EDITAR: 'Alterar Cadastro',
	        USUARIO_ESTRATEGICO_VISUALIZAR: 'Visualizar Cadastro',
	        USUARIO_ESTRATEGICO_NOVO: 'Criar Cadastro',
	        USUARIO_ESTRATEGICO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        USUARIO_ESTRATEGICO_ATRIBUIR_PERFIL: 'Atribuir Perfil',
	        USUARIO_ESTRATEGICO_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
	        USUARIO_ESTRATEGICO_CONFIGURAR: 'Configurar',
	        USUARIO_SUPERINTENDENCIA_EDITAR: 'Alterar Cadastro',
	        USUARIO_SUPERINTENDENCIA_VISUALIZAR: 'Visualizar Cadastro',
	        USUARIO_SUPERINTENDENCIA_NOVO: 'Criar Cadastro',
	        USUARIO_SUPERINTENDENCIA_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        USUARIO_SUPERINTENDENCIA_ATRIBUIR_PERFIL: 'Atribuir Perfil',
	        USUARIO_SUPERINTENDENCIA_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
	        USUARIO_SUPERINTENDENCIA_CONFIGURAR: 'Configurar',
	        PERFIL_EDITAR: 'Alterar Cadastro',
	        PERFIL_VISUALIZAR: 'Visualizar Cadastro',
	        PERFIL_NOVO: 'Criar Cadastro',
	        PERFIL_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        PERFIL_ATRIBUIR_USUARIO: 'Atribuir Usuário',
	        PERMISSAO_EDITAR: 'Alterar Cadastro',
	        PERMISSAO_VISUALIZAR: 'Visualizar  Cadastro',
	        ENTIDADE_EDITAR: 'Alterar Cadastro',
	        ENTIDADE_EXCLUIR: 'Excluir Cadastro',
	        ENTIDADE_CONFIGURAR: 'Cadastro de Entidade',
	        ENTIDADE_CREDENCIAR: 'Credenciar',
	        ENTIDADE_CADASTRO_SIMPLIFICADO: 'Criar Cadastro Simplificado',
	        ENTIDADE_CADASTRO_COMPLETO: 'Criar Cadastro Completo',
	        ENTIDADE_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        ENTIDADE_VALIDAR: 'Validar Cadastro',
	        ENTIDADE_VISUALIZAR: 'Visualizar Cadastro',
	        ENTIDADE_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
	        MINHA_ENTIDADE_VISUALIZAR: 'Visualizar Cadastro',
	        MINHA_ENTIDADE_EDITAR: 'Alterar Cadastro',
	        EDITAL_EDITAR: 'Alterar Cadastro',
	        EDITAL_VISUALIZAR: 'Visualizar Cadastro',
	        EDITAL_NOVO: 'Criar Cadastro',
	        EDITAL_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        DOCUMENTO_EDITAR: 'Alterar Cadastro',
	        DOCUMENTO_VISUALIZAR: 'Visualizar Cadastro',
	        DOCUMENTO_NOVO: 'Criar Cadastro',
	        DOCUMENTO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        DOCUMENTO_CONFIGURAR: 'Documentos do Sistema',
	        TIPO_DOCUMENTO_EDITAR: 'Alterar Cadastro',
	        TIPO_DOCUMENTO_VISUALIZAR: 'Visualizar Cadastro',
	        TIPO_DOCUMENTO_NOVO: 'Criar Cadastro',
	        TIPO_DOCUMENTO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        PERFIL_ATRIBUIDO_CONFIGURAR: 'Configurar',
	        PERFIL_ATRIBUIDO_EDITAR: 'Atribuir',
	        PERFIL_ATRIBUIDO_VISUALIZAR: 'Visualizar',
	        MINHA_PROPOSTA_VISUALIZAR: 'Visualizar Cadastro',
	        MINHA_PROPOSTA_EDITAR: 'Alterar Cadastro',
	        MEU_PARCEIRO_ESTRATEGICO_VISUALIZAR: 'Visualizar Cadastro',
	        MEU_PARCEIRO_ESTRATEGICO_EDITAR: 'Alterar Cadastro',
	        PROPOSTA_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
	        PROPOSTA_VISUALIZAr: 'Visualizar Cadastro',
	        PROPOSTA_CONFIGURAR: 'Cadastro de Proposta',
	        PROPOSTA_LIBERAR: 'Liberar Cadastro',
	        PROPOSTA_CADASTRO_SIMPLIFICADO: 'Criar Cadastro Simplificado',
	        PROPOSTA_CADASTRO_COMPLETO: 'Criar Cadastro Completo',
	        PRE_ANALISE_PRIMEIRA_APROVACAO_VALIDAR: 'Validar Primeira Aprovação',
	        PRE_ANALISE_SEGUNDA_APROVACAO_VALIDAR: 'Validar Segunda Aprovação',
	        ACEITE_PROPOSTA_VALIDAR: 'Validar Aceite',
	        ANALISE_APROVACAO_VALIDAR: 'Validar Aprovação',
	        ANALISE_PENDENCIA_APROVACAO_VALIDAR: 'Validar Pendência da Aprovação',
	        DEFERIMENTO_APROVACAO_VALIDAR: 'Validar Deferimento',
	        PREPARACAO_DOCUMENTOS_APROVACAO_VALIDAR: 'Validar Preparação de Documentos',
	        FORMALIZACAO_PROJETOS_APROVACAO_VALIDAR: 'Validar Formalizar Projetos',
	        PARCEIRO_ESTRATEGICO_EDITAR: 'Alterar Cadastro',
	        PARCEIRO_ESTRATEGICO_VISUALIZAR: 'Visualizar Cadastro',
	        PARCEIRO_ESTRATEGICO_NOVO: 'Criar Cadastro',
	        PARCEIRO_ESTRATEGICO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
	        PARCEIRO_ESTRATEGICO_VALIDAR: 'Validar Cadastro',
	        FAV_EDITAR: 'Acesso ao Módulo',
	        GED_EDITAR: 'Acesso ao Módulo',
	        SOLICITACAO_PAGAMENTO_EDITAR: 'Criar solicitação',
	        SOLICITACAO_CONTRAPARTIDA_EDITAR: 'Criar solicitação',
	        SOLICITACAO_ADIANTAMENTO_EDITAR: 'Criar solicitação',
	        SOLICITACAO_PRESTACAOCONTAS_EDITAR: 'Criar solicitação',
	        SOLICITACAO_DEVOLUCAOADIANTAMENTO_EDITAR: 'Criar solicitação',
	        SOLICITACAO_CONFIGURAR: 'Cadastro de Solicitação',
	        SOLICITACAO_PAGAMENTO_ANALISAR: 'Analisar solicitação',
	        SOLICITACAO_PAGAMENTO_ACOMPANHAR: 'Acompanhar solicitação',
	        SOLICITACAO_CONTRAPARTIDA_ANALISAR: 'Analisar solicitação',
	        SOLICITACAO_ADIANTAMENTO_ANALISAR: 'Analisar solicitação',
	        SOLICITACAO_ADIANTAMENTO_APROVAr: 'Autorizar solicitação',
	        SOLICITACAO_ADIANTAMENTO_ANALISEFINANCEIRA: 'Fazer Análise Financeira da solicitação',
	        SOLICITACAO_DEVOLUCAOADIANTAMENTO_ANALISAR: '_analisar solicitação',
	        SOLICITACAO_DEVOLUCAOADIANTAMENTO_ANALISEFINANCEIRA: 'Fazer Análise Financeira da solicitação',
	        SOLICITACAO_PRESTACAOCONTAS_ANALISAR: 'Analisar solicitação',
	        SOLICITACAO_PRESTACAOCONTAS_ANALISEFINANCEIRA: 'Autorizar solicitação',
	        RELATORIO_EXECUCAO_EDITAR: 'Editar relatório de execução',
	        RELATORIO_EXECUCAO_ENVIAR: 'Enviar relatório de execução',
	        RELATORIO_EXECUCAO_APROVAR_ENVIO: 'Aprovar envio de relatório de execução',
	        RELATORIO_EXECUCAO_APROVAR_PENDENCIA: 'Aprovar pendência de relatório de execução',
	        RELATORIO_ERP_NOVO: 'Criar',
	        RELATORIO_ERP_EDITAR: 'Editar',
	        RELATORIO_ERP_EXCLUIR: 'Excluir',
	        RELATORIO_ERP_VISUALIZAR: 'Visualizar',
	        RELATORIO_ERP_EMISSAO: 'Emissão',
	        DASHBOARD_PROPOSTAS: 'Propostas',
	        DASHBOARD_PROJETOS: 'Projetos',
	        DASHBOARD_SAUDE_SISTEMA: 'Saúde do sistema',
	        DASHBOARD_CONTROLE_PROPOSTAS: 'Controle de propostas',
	        DASHBOARD_MAPA_PROJETOS: 'Mapa de projetos',
	        MEU_PROJETO_VISUALIZAR: 'Visualizar Meu Projeto',
	        PROJETO_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
	        PROJETO_VISUALIZAR: 'Visualizar Projetos',
	        ENTIDADE_CADASTRO_ENTIDADE_PROPOSTA_SIMPLIFICADO: 'Criar Cadastro Entidade/Proposta Simplificada',
	        RELATORIO_EXECUCAO_APROVAR_CONHECIMENTO: 'Aprovar relatório de execução enviado para conhecimento',
	        USUARIO_AGENCIA: 'Usuário Agência',
	        USUARIO_FUNDACAO: 'Usuário Fundação',
	        USUARIO_ENTIDADE: 'Usuário Entidade',
	        USUARIO_ESTRATEGICO: 'Usuário Parceiro Estratégico',
	        USUARIO_SUPERINTENDENCIA: 'Usuário Superintendência',
	        PERFIL: 'Perfil',
	        ENTIDADE: 'Entidade',
	        EDITAL: 'Edital / Processo Simplificado',
	        DOCUMENTO: 'Documento',
	        ACOES_PROPRIEDADES: 'Ações e Proprietário',
	        MINHA_ENTIDADE: 'Minha Entidade',
	        PERMISSAO: 'Permissão',
	        TIPO_DOCUMENTO: 'Tipo Documento',
	        PROPOSTA: 'Proposta',
	        MINHA_PROPOSTA: 'Minha Proposta',
	        PARCEIRO_ESTRATEGICO: 'Parceiro Estratégico',
	        PRE_ANALISE: 'Pré-Análise da Proposta',
	        ACEITE: 'Aceite da Proposta',
	        ANALISE: 'Análise da Proposta',
	        DEFERIMENTO: 'Deferimento da Proposta',
	        PREPARACAO_DOCUMENTOS: 'Preparação de Documentos da Proposta',
	        FORMALIZAR_PROJETOS: 'Formalizar Projetos',
	        FAV: 'FAV - Ficha de Auto Verificação',
	        GED: 'GED - Gestão de Documentos',
	        SOLICITACAO_PAGAMENTO: 'Solicitação de Pagamento',
	        SOLICITACAO_CONTRAPARTIDA: 'Solicitação de Contrapartida',
	        SOLICITACAO_ADIANTAMENTO: 'Solicitação de Adiantamento',
	        SOLICITACAO_DEVOLUCAOADIANTAMENTO: 'Solicitação de Devolução de Adiantamento',
	        SOLICITACAO_PRESTACAOCONTAS: 'Solicitação de Prestação de Contas',
	        RELATORIO: 'Relatório de Execução',
	        RELATORIOS_ERP: 'Relatórios do ERP',
	        CONFIGURACOES: 'Configurações do Sistema',
	        DASHBOARD: 'Dashboard',
	        PROJETO: 'Projeto',
	        MEU_PROJETO: 'Meu Projeto',
	        MEU_PARCEIRO_ESTRATEGICO: 'Meu parceiro estratégico'
	      }
	    },
	    MY_PREFERENCES: {
	      SUCCESS: 'Sucesso',
	      SUCCESS_CHANGE_PHOTO: 'Foto alterada com sucesso',
	      SUCCESS_CHANGE_PASSWORD: 'Senha alterada com sucesso',
	      SUCCESS_CHANGE_PREFERENCE: 'Preferência alterada com sucesso'
	    },
	    STRATEGIC_PARTNER: {
	      INCOMPLETO: 'Incompleto',
	      PENDENTE_APROVACAO: 'Aguardando aprovação',
	      COMPLETO: 'Completo'
	    }
	  }
	};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(123);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _downloadjs = __webpack_require__(119);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    type: {
	      type: String,
	      default: "xls"
	    },
	
	    data: {
	      type: Array,
	      required: false,
	      default: null
	    },
	
	    fields: {
	      type: Object,
	      required: false
	    },
	
	    exportFields: {
	      type: Object,
	      required: false
	    },
	
	    defaultValue: {
	      type: String,
	      required: false,
	      default: ""
	    },
	
	    title: {
	      default: null
	    },
	
	    footer: {
	      default: null
	    },
	
	    name: {
	      type: String,
	      default: "data.xls"
	    },
	    fetch: {
	      type: Function
	    },
	    meta: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    worksheet: {
	      type: String,
	      default: "Sheet1"
	    },
	
	    beforeGenerate: {
	      type: Function
	    },
	
	    beforeFinish: {
	      type: Function
	    }
	  },
	  computed: {
	    idName: function idName() {
	      var now = new Date().getTime();
	      return "export_" + now;
	    },
	    downloadFields: function downloadFields() {
	      if (this.fields !== undefined) return this.fields;
	
	      if (this.exportFields !== undefined) return this.exportFields;
	    }
	  },
	  methods: {
	    generate: function generate() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var data, json;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(typeof _this.beforeGenerate === 'function')) {
	                  _context.next = 3;
	                  break;
	                }
	
	                _context.next = 3;
	                return _this.beforeGenerate();
	
	              case 3:
	                data = _this.data;
	
	                if (!(typeof _this.fetch === 'function' || !data)) {
	                  _context.next = 8;
	                  break;
	                }
	
	                _context.next = 7;
	                return _this.fetch();
	
	              case 7:
	                data = _context.sent;
	
	              case 8:
	                if (!(!data || !data.length)) {
	                  _context.next = 10;
	                  break;
	                }
	
	                return _context.abrupt("return");
	
	              case 10:
	                json = _this.getProcessedJson(data, _this.downloadFields);
	
	                if (!(_this.type === "html")) {
	                  _context.next = 15;
	                  break;
	                }
	
	                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name.replace(".xls", ".html"), "text/html"));
	
	              case 15:
	                if (!(_this.type === "csv")) {
	                  _context.next = 17;
	                  break;
	                }
	
	                return _context.abrupt("return", _this.export(_this.jsonToCSV(json), _this.name.replace(".xls", ".csv"), "application/csv"));
	
	              case 17:
	                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name, "application/vnd.ms-excel"));
	
	              case 18:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	
	    export: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(data, filename, mime) {
	        var blob;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                blob = this.base64ToBlob(data, mime);
	
	                if (!(typeof this.beforeFinish === 'function')) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                _context2.next = 4;
	                return this.beforeFinish();
	
	              case 4:
	                (0, _downloadjs2.default)(blob, filename, mime);
	
	              case 5:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function _export(_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      }
	
	      return _export;
	    }(),
	    jsonToXLS: function jsonToXLS(data) {
	      var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>${table}</table></body></html>';
	      var xlsData = "<thead>";
	      var colspan = (0, _keys2.default)(data[0]).length;
	      var _self = this;
	
	      if (this.title != null) {
	        xlsData += this.parseExtraData(this.title, '<tr><th colspan="' + colspan + '">${data}</th></tr>');
	      }
	
	      xlsData += "<tr>";
	      for (var key in data[0]) {
	        xlsData += "<th>" + key + "</th>";
	      }
	      xlsData += "</tr>";
	      xlsData += "</thead>";
	
	      xlsData += "<tbody>";
	      data.map(function (item, index) {
	        xlsData += "<tr>";
	        for (var _key in item) {
	          xlsData += "<td>" + _self.valueReformattedForMultilines(item[_key]) + "</td>";
	        }
	        xlsData += "</tr>";
	      });
	      xlsData += "</tbody>";
	
	      if (this.footer != null) {
	        xlsData += "<tfoot>";
	        xlsData += this.parseExtraData(this.footer, '<tr><td colspan="' + colspan + '">${data}</td></tr>');
	        xlsData += "</tfoot>";
	      }
	
	      return xlsTemp.replace("${table}", xlsData).replace("${worksheet}", this.worksheet);
	    },
	    jsonToCSV: function jsonToCSV(data) {
	      var csvData = [];
	
	      if (this.title != null) {
	        csvData.push(this.parseExtraData(this.title, "${data}\r\n"));
	      }
	
	      for (var key in data[0]) {
	        csvData.push(key);
	        csvData.push(",");
	      }
	      csvData.pop();
	      csvData.push("\r\n");
	
	      data.map(function (item) {
	        for (var _key2 in item) {
	          var escapedCSV = '=\"' + item[_key2] + '\"';
	          if (escapedCSV.match(/[,"\n]/)) {
	            escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
	          }
	          csvData.push(escapedCSV);
	          csvData.push(",");
	        }
	        csvData.pop();
	        csvData.push("\r\n");
	      });
	
	      if (this.footer != null) {
	        csvData.push(this.parseExtraData(this.footer, "${data}\r\n"));
	      }
	      return csvData.join("");
	    },
	    getProcessedJson: function getProcessedJson(data, header) {
	      var keys = this.getKeys(data, header);
	      var newData = [];
	      var _self = this;
	      data.map(function (item, index) {
	        var newItem = {};
	        for (var label in keys) {
	          var property = keys[label];
	          newItem[label] = _self.getValue(property, item);
	        }
	        newData.push(newItem);
	      });
	
	      return newData;
	    },
	    getKeys: function getKeys(data, header) {
	      if (header) {
	        return header;
	      }
	
	      var keys = {};
	      for (var key in data[0]) {
	        keys[key] = key;
	      }
	      return keys;
	    },
	    parseExtraData: function parseExtraData(extraData, format) {
	      var parseData = "";
	      if (Array.isArray(extraData)) {
	        for (var i = 0; i < extraData.length; i++) {
	          parseData += format.replace("${data}", extraData[i]);
	        }
	      } else {
	        parseData += format.replace("${data}", extraData);
	      }
	      return parseData;
	    },
	    getValue: function getValue(key, item) {
	      var field = (typeof key === "undefined" ? "undefined" : (0, _typeof3.default)(key)) !== "object" ? key : key.field;
	      var indexes = typeof field !== "string" ? [] : field.split(".");
	      var value = this.defaultValue;
	
	      if (!field) value = item;else if (indexes.length > 1) value = this.getValueFromNestedItem(item, indexes);else value = this.parseValue(item[field]);
	
	      if (key.hasOwnProperty('callback')) value = this.getValueFromCallback(value, key.callback);
	
	      return value;
	    },
	    valueReformattedForMultilines: function valueReformattedForMultilines(value) {
	      if (typeof value == "string") return value.replace(/\n/ig, "<br/>");else return value;
	    },
	    getValueFromNestedItem: function getValueFromNestedItem(item, indexes) {
	      var nestedItem = item;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(indexes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var index = _step.value;
	
	          if (nestedItem) nestedItem = nestedItem[index];
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return this.parseValue(nestedItem);
	    },
	    getValueFromCallback: function getValueFromCallback(item, callback) {
	      if (typeof callback !== "function") return this.defaultValue;
	      var value = callback(item);
	      return this.parseValue(value);
	    },
	    parseValue: function parseValue(value) {
	      return value || value === 0 || typeof value === 'boolean' ? value : this.defaultValue;
	    },
	    base64ToBlob: function base64ToBlob(data, mime) {
	      var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
	      var bstr = atob(base64);
	      var n = bstr.length;
	      var u8arr = new Uint8ClampedArray(n);
	      while (n--) {
	        u8arr[n] = bstr.charCodeAt(n);
	      }
	      return new Blob([u8arr], { type: mime });
	    }
	  } };

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App',
	  data: function data() {
	    return {
	      data: [],
	      mensagens: []
	    };
	  },
	
	  methods: {
	    show: function show() {
	      this.$modal.show('visualizar');
	      this.$forceUpdate();
	    },
	    hide: function hide() {
	      this.$modal.hide('visualizar');
	    }
	  }
	};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Form = __webpack_require__(273);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AlterarSenha',
	  data: function data() {
	    return {
	      user: {
	        novaSenha: null,
	        confirmaSenha: null
	      },
	
	      form: new _Form2.default({
	        ds_login: ''
	      }),
	      error: ''
	    };
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          axiosLaravel.post('/altera-senha-token/' + _this.$route.params.token, _this.form).then(function (response) {
	            _this.$snotify.success('Senha alterada com sucesso');
	            setTimeout(function () {
	              _this.$router.push('/login');
	            }, 2000);
	          }).catch(function (error) {
	            console.log('error.response', error.response);
	            if (error.response.status === 401) {
	              _this.$snotify.error(error.response.data.responseInfo.reasons[0].detail);
	            } else {
	              _this.$root.trataErro(error);
	            }
	          });
	        }
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    axiosLaravel.get('altera-senha-token/' + this.$route.params.token).then(function (response) {
	      _this2.form = response.data.user;
	    }).catch(function (error) {
	      if (error) {
	        _this2.$root.trataErro(error);
	      }
	    });
	  }
	};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ImportacaoExcel = __webpack_require__(1664);
	
	var _ImportacaoExcel2 = _interopRequireDefault(_ImportacaoExcel);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ImportacaoExcel: _ImportacaoExcel2.default
	  },
	  name: 'auto-credenciamento',
	  data: function data() {
	    return {
	      loading: {
	        tela: false
	      },
	      processos: [],
	      tipo: [],
	      validacaoArquivo: false,
	      excel: {},
	      jaExiste: false,
	      jaExisteMail: false,
	      jaExisteMailUsu: false,
	      campoErro: null,
	      entidade: {
	        ds_cnpj: '',
	        usuarios: [],
	        proposta: {
	          edital: []
	        }
	      },
	      usuario: {
	        ds_cpf: ''
	      },
	      mostrarForm: false,
	      mostrarArquivo: false,
	      mostrarCriarProposta: false,
	      listaEditais: [],
	      erroEmail: false,
	      emailConfirmacao: '',
	      desabilitaListaEditais: false,
	      rotuloSelecaoEdital: 'Selecione um Edital:',
	      emailConfirmacaoEnt: '',
	      entidadesExistentes: [],
	      entidadesVoluntariadoDump: [],
	      tableProjetos: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      fieldsProjetos: [{ key: 'cnpj', label: 'CNPJ', thStyle: 'width: 100px; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'razao_social', label: 'Nome Entidade', thStyle: 'text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'nome_representante_legal', label: 'Representante', thStyle: 'width: 150px; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'cadastro_criado', label: 'Criado', thStyle: 'width: 50px; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }],
	      entidadeMassificada: {},
	      erroMassificado: false,
	      aberturaMassificadaExecutada: false,
	      telaTodosEditais: false,
	      editalAtivoSelecionado: '',
	      emailsEntidades: '',
	      gravando: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    excel: function excel() {
	      if (_.has(this.excel, 'dadosBasicos')) {
	        this.entidade.ds_nome = this.excel.dadosBasicos[2]['valor'];
	        this.entidade.ds_cnpj = this.excel.dadosBasicos[3]['valor'];
	        this.entidade.ds_email = this.excel.dadosBasicos[11]['valor'];
	        this.emailConfirmacaoEnt = this.entidade.ds_email;
	
	        this.usuario.ds_nome_usuario = this.excel.representanteLegal[0]['Nome'];
	        this.usuario.ds_cpf = this.excel.representanteLegal[0]['CPF'];
	        this.usuario.ds_login = this.excel.representanteLegal[0]['Nome'];
	        this.usuario.ds_telefone = this.excel.representanteLegal[0]['Telefone'];
	        this.usuario.ds_email = this.excel.representanteLegal[0]['E-mail'];
	        this.emailConfirmacao = this.usuario.ds_email;
	      } else {
	        this.entidade.ds_nome = '';
	        this.entidade.ds_cnpj = '';
	        this.entidade.ds_email = '';
	        this.emailConfirmacaoEnt = '';
	        this.usuario.ds_nome_usuario = '';
	        this.usuario.ds_cpf = '';
	        this.usuario.ds_login = '';
	        this.usuario.ds_telefone = '';
	        this.usuario.ds_email = '';
	        this.emailConfirmacao = '';
	      }
	      this.$forceUpdate();
	    },
	    validacaoArquivo: function validacaoArquivo() {
	      console.log('Arquivo validado', this.validacaoArquivo);
	    }
	  },
	  created: function created() {
	    var parametro = _.keys(this.$route.query);
	    console.log(parametro);
	    if (parametro.length === 0) {
	      this.buscaTodosAtivos();
	      this.telaTodosEditais = true;
	    } else {
	      this.buscaEditaisAtivos(parametro[0]);
	    }
	  },
	
	  methods: {
	    limpar: function limpar() {
	      this.entidade.ds_nome = '';
	      this.entidade.ds_cnpj = '';
	      this.entidade.ds_login = '';
	      this.usuario.ds_telefone = '';
	      this.entidade.dt_data_expedicao_cnpj = '';
	      this.entidade.ds_nome_fantasia = '';
	      this.entidade.ds_email = '';
	      this.emailConfirmacaoEnt = '';
	      this.usuario.ds_nome_usuario = '';
	      this.usuario.ds_cpf = '';
	      this.usuario.ds_email = '';
	      this.usuario.ds_login = '';
	      this.emailConfirmacao = '';
	    },
	    etiquetaEdital: function etiquetaEdital(option) {
	      return '' + option.ds_numero_edital;
	    },
	    selecionado: function selecionado(selectedOption) {
	      this.mostrarForm = true;
	      this.mostrarArquivo = selectedOption.id === 3 || selectedOption.id === 4;
	    },
	    buscaEditaisAtivos: function buscaEditaisAtivos(parametro) {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('edital/ativos', { 'parametro': parametro }).then(function (response) {
	        console.log('response.data', response.data);
	        _this.listaEditais = response.data;
	
	        if (_this.listaEditais.length === 0) {
	          alert('Não localizamos um edital ativo e vigente para o link informado. Entre em contato com a FBB!');
	        } else if (_this.listaEditais.length > 1) {} else {
	          _this.desabilitaListaEditais = true;
	          _this.rotuloSelecaoEdital = 'Edital:';
	          _this.entidade.proposta.edital = _this.listaEditais;
	          _this.selecionado(_this.entidade.proposta.edital[0]);
	        }
	
	        _this.loading.tela = false;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaTodosAtivos: function buscaTodosAtivos() {
	      var _this2 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('edital/todosAtivos').then(function (response) {
	        console.log('response.data', response.data);
	        _this2.listaEditais = response.data;
	
	        if (_this2.listaEditais.length === 0) {
	          alert('Não localizamos um edital ativo e vigente para o link informado. Entre em contato com a FBB!');
	        }
	
	        _this2.loading.tela = false;
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        _this2.loading.tela = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    gravaViaArquivo: function gravaViaArquivo() {
	      var _this3 = this;
	
	      this.loading.tela = true;
	      this.$snotify.clear();
	      this.$aguarde('Registrando dados da planilha e expedindo e-mails de credenciamento. Por favor, aguarde...');
	      axiosLaravel.post('importacao/excel', { 'arquivo': this.excel, 'modelo': 'cadastro_entidade', 'edital': this.entidade.proposta.edital[0] }).then(function (response) {
	        var resultado = response.data;
	        _this3.loading.tela = false;
	        _this3.$snotify.clear();
	        if (resultado.situacao === 'OK') {
	          _this3.$snotify.success(resultado.mensagem, { timeout: 10000 });
	          alert('E-mails de credenciamento foram enviados para os usuários informados. Verifique em suas caixas de e-mail!');
	          window.location.href = 'http://localhost:8082/login';
	        } else {
	          _this3.$snotify.error(resultado.mensagem, { timeout: 20000 });
	        }
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.loading.tela = false;
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this4 = this;
	
	      this.gravando = true;
	      this.entidade.ds_tipo_registro = 'AUTO_CREDENCIAMENTO';
	      this.entidade.ds_fase_registro = 'CREDENCIAMENTO';
	      this.entidade.ds_status = 'INCOMPLETO';
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this4.usuario.ds_email !== _this4.emailConfirmacao) {
	            _this4.$snotify.error('O formulário possui erros. Favor verificar!');
	            return;
	          }
	          if (_this4.entidade.ds_email !== _this4.emailConfirmacaoEnt) {
	            _this4.$snotify.error('O formulário possui erros. Favor verificar!');
	            return;
	          }
	          if (_this4.jaExiste === true) {
	            _this4.$snotify.error('O login informado já existe. Favor verificar!');
	            return;
	          }
	
	          if (_this4.entidadesExistentes.length > 0 && _.has(_this4.entidadesExistentes[0], 'ds_nome') && !_.isNull(_this4.entidadesExistentes[0].ds_nome)) {
	            _this4.$snotify.error('O CNPJ informado possui cadastrado na FBB. Nesse caso acesse o sistema com login e senha e faça a atualização do cadastro da Entidade!');
	            return;
	          }
	          if (_this4.jaExisteMail === true) {
	            _this4.$snotify.error('O e-mail da entidade informado já existe. Favor verificar!');
	            return;
	          }
	          if (_this4.jaExisteMailUsu === true) {
	            _this4.$snotify.error('O e-mail do usuário informado já existe. Favor verificar!');
	            return;
	          }
	
	          _this4.usuario.ds_cpf = _this4.usuario.ds_cpf.replace('.', '');
	          _this4.usuario.ds_cpf = _this4.usuario.ds_cpf.replace('.', '');
	          _this4.usuario.ds_cpf = _this4.usuario.ds_cpf.replace('-', '');
	          _this4.entidade.ds_cnpj = _this4.entidade.ds_cnpj.replace('.', '');
	          _this4.entidade.ds_cnpj = _this4.entidade.ds_cnpj.replace('.', '');
	          _this4.entidade.ds_cnpj = _this4.entidade.ds_cnpj.replace('.', '');
	          _this4.entidade.ds_cnpj = _this4.entidade.ds_cnpj.replace('/', '');
	          _this4.entidade.ds_cnpj = _this4.entidade.ds_cnpj.replace('-', '');
	          _this4.entidade.ds_login = _this4.entidade.ds_cnpj;
	          var obj = _.cloneDeep(_this4.usuario);
	          var resultArray = [];
	          resultArray.push(obj);
	          _this4.entidade.usuarios = _.cloneDeep(resultArray);
	          _this4.$aguarde('Credenciando a entidade. Por favor, aguarde...');
	          _this4.loading.tela = true;
	          axiosLaravel.post('autocredenciamento/', _this4.entidade).then(function (response) {
	            _this4.$snotify.clear();
	            _this4.$snotify.success('Entidade credenciada com sucesso!');
	
	            setTimeout(function () {
	              window.location.href = 'https://projetos.fbb.org.br';
	            }, 1000);
	            _this4.loading.tela = false;
	          }).catch(function (error) {
	            _this4.$snotify.clear();
	            _this4.loading.tela = false;
	            _this4.gravando = false;
	            _this4.$root.trataErro(error);
	          });
	        } else {
	          _this4.gravando = false;
	          console.log('nao validou');
	        }
	      });
	    },
	    verificaUsuario: function verificaUsuario() {
	      var _this5 = this;
	
	      axiosLaravel.post('/verifica-usuario/', { 'parametro': this.usuario.ds_login }).then(function (response) {
	        if (response.data.length > 0) {
	          _this5.jaExiste = true;
	          var field = _this5.$validator.fields.find({ name: 'Login' });
	          field.setFlags({ invalid: true });
	          _this5.errors.add({
	            field: 'Login',
	            msg: response.data,
	            id: field.id,
	            scope: field.scope
	          });
	        } else {
	          _this5.jaExiste = false;
	        }
	      }).catch(function (error) {
	        if (error) {
	          _this5.$root.trataErro(error);
	        }
	      });
	    },
	    verificaEmailEntidade: function verificaEmailEntidade() {
	      var _this6 = this;
	
	      axiosLaravel.post('/verifica-usuario/', { 'parametro': this.entidade.ds_email }).then(function (response) {
	        if (response.data.length > 0) {
	          _this6.jaExisteMail = true;
	          var field = _this6.$validator.fields.find({ name: 'Email' });
	          field.setFlags({ invalid: true });
	          _this6.errors.add({
	            field: 'Email',
	            msg: response.data,
	            id: field.id,
	            scope: field.scope
	          });
	        } else {
	          _this6.jaExisteMail = false;
	        }
	      }).catch(function (error) {
	        if (error) {
	          _this6.$root.trataErro(error);
	        }
	      });
	    },
	    verificaEmailUsuario: function verificaEmailUsuario() {
	      var _this7 = this;
	
	      axiosLaravel.post('/verifica-usuario/', { 'parametro': this.usuario.ds_email }).then(function (response) {
	        if (response.data.length > 0) {
	          _this7.jaExisteMailUsu = true;
	          var field = _this7.$validator.fields.find({ name: 'userEmail' });
	          field.setFlags({ invalid: true });
	          _this7.errors.add({
	            field: 'userEmail',
	            msg: response.data,
	            id: field.id,
	            scope: field.scope
	          });
	        } else {
	          _this7.jaExisteMailUsu = false;
	        }
	      }).catch(function (error) {
	        if (error) {
	          _this7.$root.trataErro(error);
	        }
	      });
	    },
	    verificaCNPJEntidade: function verificaCNPJEntidade() {
	      var _this8 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('/entidade/cnpj/', { 'cnpj': this.entidade.ds_cnpj }).then(function (response) {
	        _this8.entidadesExistentes = response.data;
	        if (_this8.entidadesExistentes.length > 0) {
	          _this8.mostrarCriarProposta = true;
	        } else {
	          _this8.mostrarCriarProposta = false;
	        }
	        _this8.loading.tela = false;
	      }).catch(function (error) {
	        _this8.loading.tela = false;
	        if (error) {
	          _this8.$root.trataErro(error);
	        }
	      });
	      this.verificaEmailDirigentesEntidade();
	    },
	    verificaEmailDirigentesEntidade: function verificaEmailDirigentesEntidade() {
	      var _this9 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('/entidade/emailDirigentesEntidade/', { 'cnpj': this.entidade.ds_cnpj }).then(function (response) {
	        console.log('EMAILS DIRIGENTES', response.data);
	        _this9.emailsEntidades = response.data;
	        _this9.loading.tela = false;
	      }).catch(function (error) {
	        _this9.loading.tela = false;
	        if (error) {
	          _this9.$root.trataErro(error);
	        }
	      });
	    },
	    criaPropostaEdital: function criaPropostaEdital() {
	      var _this10 = this;
	
	      this.loading.tela = true;
	      this.gravando = true;
	      this.$aguarde('Criando proposta deste edital para a entidade. Por favor, aguarde...');
	      axiosLaravel.post('criaPropostaEdital/', this.entidade).then(function (response) {
	        _this10.$snotify.clear();
	        _this10.$snotify.success('Proposta criada com sucesso!');
	        setTimeout(function () {
	          _this10.$router.go(-1);
	        }, 1000);
	        _this10.limpar();
	        _this10.verificaCNPJEntidade();
	        _this10.mostrarCriarProposta = false;
	
	        _this10.loading.tela = false;
	        setTimeout(function () {
	          window.location.href = 'https://projetos.fbb.org.br';
	        }, 1000);
	      }).catch(function (error) {
	        _this10.loading.tela = false;
	        _this10.mostrarCriarProposta = false;
	        _this10.gravando = false;
	        _this10.limpar();
	        _this10.$snotify.clear();
	        _this10.$root.trataErro(error);
	      });
	    },
	    consultaEntidadesPendentes: function consultaEntidadesPendentes() {
	      var _this11 = this;
	
	      this.loading.tela = true;
	      this.$snotify.clear();
	      this.$aguarde('Consultando Registros em Massificados de Credenciamento...');
	      axiosLaravel.get('consultaEntidadesCredenciamentoDump/').then(function (response) {
	        _this11.entidadesVoluntariadoDump = response.data;
	        _this11.tableProjetos.totalRows = _this11.entidadesVoluntariadoDump.length;
	        _this11.$snotify.clear();
	        _this11.loading.tela = false;
	      }).catch(function (error) {
	        _this11.$snotify.clear();
	        _this11.$root.trataErro(error);
	        _this11.loading.tela = false;
	      });
	    },
	    cadastroMassificado: function cadastroMassificado() {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var i, entidade;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (_this12.entidadesVoluntariadoDump.length <= 0) {
	                  _this12.$snotify.error('Sem Entidades Pendentes de Credenciamento');
	                }
	                _this12.aberturaMassificadaExecutada = true;
	
	                i = 0;
	
	              case 3:
	                if (!(i < _this12.entidadesVoluntariadoDump.length)) {
	                  _context.next = 19;
	                  break;
	                }
	
	                entidade = _this12.entidadesVoluntariadoDump[i];
	                _context.prev = 5;
	
	                _this12.validarEntidade(entidade);
	                _context.next = 9;
	                return _this12.gravaMassificado(entidade);
	
	              case 9:
	                if (_this12.erroMassificado === true) {
	                  _this12.entidadesVoluntariadoDump[i].cadastro_criado = 'ERRO';
	                } else {
	                  _this12.entidadesVoluntariadoDump[i].cadastro_criado = 'S';
	                }
	                _context.next = 16;
	                break;
	
	              case 12:
	                _context.prev = 12;
	                _context.t0 = _context['catch'](5);
	
	                _this12.entidadesVoluntariadoDump[i].cadastro_criado = 'ERRO';
	                console.error('Erro ao processar a entidade' + _this12.entidade.razao_social + ' Erro: ' + _context.t0.message);
	
	              case 16:
	                i++;
	                _context.next = 3;
	                break;
	
	              case 19:
	                _this12.limpar();
	
	              case 20:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this12, [[5, 12]]);
	      }))();
	    },
	    removerCaracteresEspeciais: function removerCaracteresEspeciais(str) {
	      return str.replace(/[^\w\s]/gi, '');
	    },
	    limparString: function limparString(str) {
	      return str.replace(/[,"“”'´`~!@#$%^&*()_+={}[\]:;<>,.?\\|]/g, '').replace(/[^a-zA-Z]([áàâãäéèêëíìîïóòôõöúùûü])[^a-zA-Z]/g, ' ');
	    },
	    validarEntidade: function validarEntidade(entidade) {
	      this.entidade.ds_nome = this.limparString(entidade.razao_social.toUpperCase()).trim();
	
	      this.entidade.ds_cnpj = this.removerCaracteresEspeciais(entidade.cnpj);
	
	      this.entidade.ds_email = entidade.email_entidade;
	      this.emailConfirmacaoEnt = entidade.email_entidade;
	
	      this.usuario.ds_nome_usuario = entidade.nome_representante_legal.trim();
	
	      this.usuario.ds_cpf = this.removerCaracteresEspeciais(entidade.cpf_representante_legal);
	
	      this.usuario.ds_login = entidade.email_representante_legal;
	
	      this.usuario.ds_telefone = entidade.telefone_representante_legal;
	
	      var emailRepresentanteLegal = entidade.email_representante_legal;
	
	      this.usuario.ds_email = emailRepresentanteLegal;
	      this.emailConfirmacao = emailRepresentanteLegal;
	    },
	    gravaMassificado: function gravaMassificado(entidade) {
	      var _this13 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var objMarcacao, obj, resultArray;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this13.erroMassificado = false;
	                _this13.$snotify.clear();
	
	                _this13.usuario.ds_cpf = _this13.usuario.ds_cpf.replace('.', '');
	                _this13.usuario.ds_cpf = _this13.usuario.ds_cpf.replace('.', '');
	                _this13.usuario.ds_cpf = _this13.usuario.ds_cpf.replace('-', '');
	                _this13.entidade.ds_cnpj = _this13.entidade.ds_cnpj.replace('.', '');
	                _this13.entidade.ds_cnpj = _this13.entidade.ds_cnpj.replace('.', '');
	                _this13.entidade.ds_cnpj = _this13.entidade.ds_cnpj.replace('.', '');
	                _this13.entidade.ds_cnpj = _this13.entidade.ds_cnpj.replace('/', '');
	                _this13.entidade.ds_cnpj = _this13.entidade.ds_cnpj.replace('-', '');
	                _this13.entidade.ds_login = '_' + _this13.entidade.ds_cnpj;
	
	                _this13.entidadeMassificada = {
	                  ds_tipo_registro: 'AUTO_CREDENCIAMENTO',
	                  ds_fase_registro: 'CREDENCIAMENTO',
	                  ds_status: 'INCOMPLETO',
	                  ds_nome: _this13.entidade.ds_nome,
	                  ds_cnpj: _this13.entidade.ds_cnpj,
	                  ds_email: _this13.entidade.ds_email,
	                  ds_login: _this13.entidade.ds_login,
	
	                  ds_entidade_email: _this13.entidade.ds_email,
	
	                  ds_entidade_cep: entidade.cep,
	                  ds_entidade_cidade: entidade.municipio_entidade,
	                  ds_estado_entidade: entidade.estado_entidade.slice(-2),
	                  ds_entidade_telefone: _this13.removerCaracteresEspeciais(entidade.telefone_representante_legal),
	
	                  ds_entidade_representante_legal: _this13.usuario.ds_nome_usuario.toUpperCase()
	                };
	                objMarcacao = {
	                  cnpj: entidade.cnpj,
	                  matricula: _this13.usuarioLogado.dadosBB.matricula
	                };
	                obj = _.cloneDeep(_this13.usuario);
	                resultArray = [];
	
	                resultArray.push(obj);
	                _this13.entidadeMassificada.usuarios = _.cloneDeep(resultArray);
	                _this13.entidadeMassificada.proposta = _this13.entidade.proposta;
	                _this13.$aguarde('Credenciando a entidade. Por favor, aguarde...');
	                _context2.next = 21;
	                return axiosLaravel.post('autocredenciamento/', _this13.entidadeMassificada).then(function (response) {
	                  _this13.$snotify.clear();
	                  _this13.$snotify.success('Entidade credenciada com sucesso!');
	                  axiosLaravel.post('marcaEntidadeCadastrada/', objMarcacao).then(function (response) {
	                    console.log(response);
	                  });
	                  setTimeout(function () {
	                    _this13.$router.go(-1);
	                  }, 1000);
	                }).catch(function (error) {
	                  _this13.erroMassificado = true;
	                  _this13.$snotify.clear();
	                  _this13.$root.trataErro(error);
	                });
	
	              case 21:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this13);
	      }))();
	    },
	    selecionaAtivo: function selecionaAtivo() {
	      this.$router.push('/autocredenciamento?' + this.editalAtivoSelecionado);
	      location.reload();
	    },
	    cancelarEnvioEntidadeCadastrada: function cancelarEnvioEntidadeCadastrada() {
	      window.location.reload();
	    }
	  }
	};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Sidebar = __webpack_require__(1757);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Header = __webpack_require__(1756);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(1755);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ControlSidebar = __webpack_require__(1754);
	
	var _ControlSidebar2 = _interopRequireDefault(_ControlSidebar);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Dashboard',
	  components: {
	    'app-sidebar': _Sidebar2.default,
	    'app-header': _Header2.default,
	    'app-footer': _Footer2.default,
	    'control-sidebar': _ControlSidebar2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    if (this.usuarioLogado.entidade) {
	      if (this.usuarioLogado.entidade.registerPhase === 'CREDENCIAMENTO' && this.usuarioLogado.entidade.status === 'INCOMPLETO' && this.usuarioLogado.userType === 'ENTIDADE') {
	        this.carregaTela();
	      }
	    } else {
	      this.verificaUOR();
	    }
	  },
	
	  methods: {
	    carregaTela: function carregaTela() {
	      this.$router.push('/cadastro/entidades/edita/' + this.usuarioLogado.entidade.id);
	      this.$forceUpdate();
	    },
	    verificaUOR: function verificaUOR() {
	      var _this = this;
	
	      axiosLaravel.post('chamado/verificaUOR/').then(function (response) {
	        console.log('RLMB response.data', response.data);
	        _this.usuarioLogado.uor = parseInt(response.data[0]);
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    }
	  }
	};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EsqueciMinhaSenha',
	  data: function data() {
	    return {
	      form: new Form({
	        ds_login: ''
	      })
	    };
	  },
	
	  methods: {
	    onValidate: function onValidate() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(result) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (result) {
	                    _this.form.post('/esqueci-senha', { 'ds_login': _this.form.ds_login }).then(function (response) {
	                      _this.$snotify.success(response.data.resposta);
	                    }).catch(function (error) {
	                      if (error) {
	                        _this.$snotify.error(JSON.parse(error.response.data.message).ds_login[0]);
	                      }
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    }
	  }
	};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _mensagem_sistema = __webpack_require__(1555);
	
	var _mensagem_sistema2 = _interopRequireDefault(_mensagem_sistema);
	
	var _cryptoJs = __webpack_require__(1200);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	var _auth = __webpack_require__(146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Login',
	  components: {
	    Msg: _mensagem_sistema2.default
	  },
	  data: function data() {
	    return {
	      form: new Form({
	        ds_login: '',
	        senha: ''
	      }),
	      senha: null,
	      mensagem: '',
	      credentials: {
	        username: '',
	        password: ''
	      },
	      error: ''
	    };
	  },
	  beforeMount: function beforeMount() {
	    this.mensagem = _mensagem_sistema2.default.texto;
	    this.mostrarMensagem = _mensagem_sistema2.default.ativo;
	  },
	
	  methods: {
	    carregaMensagem: function carregaMensagem() {},
	
	    login: function login() {
	      var _this = this;
	
	      var store = this.$store;
	      var credentials = {
	        username: this.form.ds_login,
	        password: this.form.senha
	      };
	      this.$validator.validateAll().then(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(result) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (!result) {
	                    _context.next = 3;
	                    break;
	                  }
	
	                  _context.next = 3;
	                  return _this.loginLaravel();
	
	                case 3:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    },
	    loginLaravel: function loginLaravel() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.form.senha = _cryptoJs2.default.AES.encrypt(_this2.senha, 'ARtAVARECtoxYGoBsTaBLETeRanTedErEVoLIcHOlsTacKysTERSpERnaPHiCEnEthi').toString();
	                _context2.next = 3;
	                return _this2.form.post(("https://projetos.fbb.org.br:5443/api/") + 'auth/login').then(function (response) {
	                  _this2.$store.commit('SET_USER_LARAVEL', response.data);
	                  if (window.localStorage) {
	                    (0, _auth.limpaSessao)();
	                    (0, _auth.salvaSessao)(response.data);
	                    _this2.$router.push('/dashboard');
	                  }
	                }).catch(function (error) {
	                  console.log('error', error);
	
	                  var data = error.response && error.response.data;
	                  _this2.error = typeof data === 'string' && data ? data : data && (data.message || data.error) || 'Não foi possível efetuar o login. Tente novamente.';
	                  _this2.$snotify.error(_this2.error);
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    }
	  },
	  mounted: function mounted() {
	    this.carregaMensagem();
	  }
	};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'Preferencias',
	  data: function data() {
	    return {
	      documento: {},
	      password: {
	        senhaAtual: '',
	        novaSenha: '',
	        confirmaSenha: ''
	      },
	      url: '',
	      image: ''
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  methods: {
	    isValidPassword: function isValidPassword() {
	      return this.password.novaSenha === this.password.confirmaSenha;
	    },
	    onChangePassword: function onChangePassword(frm) {
	      var _this = this;
	
	      if (frm == null || !this.isValidPassword()) {
	        this.$snotify.error('Verifique o preenchimento do formulário. Há campos com preenchimento inválido.');
	        return;
	      }
	      axiosLaravel.put('/usuario/' + this.usuarioLogado.id + '/altera-senha', frm).then(function (response) {
	        _this.$snotify.success('Senha alterada com Sucesso.');
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this.$root.trataErro(error);
	        }
	      });
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    onFileChange: function onFileChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      this.tamanho = e.target.files[0].size;
	      this.tamanhoFormatado = (this.tamanho / Math.pow(1024, 2)).toFixed(2);
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	
	      var usuarioId = this.usuarioLogado.id;
	      var documento = this.documento;
	      var vm = this;
	      setTimeout(function () {
	        var _this2 = this;
	
	        axiosLaravel.put('/usuario/' + usuarioId + '/foto', { foto: documento.file }).then(function (response) {
	          vm.$snotify.success('Foto Alterada com Sucesso. Efetue novo login no sistema para que a foto atualizada apareça no perfil');
	        }).catch(function (error) {
	          if (error) {
	            console.log('error', error);
	            _this2.$root.trataErro(error);
	          }
	        });
	        vm.$emit('onUpdatePicture', this.url);
	      }, 500);
	    }
	  }
	};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _documentosPorTipo = __webpack_require__(1663);
	
	var _documentosPorTipo2 = _interopRequireDefault(_documentosPorTipo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DocumentosPorTipo: _documentosPorTipo2.default
	  },
	  name: 'Manuais',
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _profiles = __webpack_require__(121);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Profiles: _profiles2.default },
	  name: 'cadastro-acoes-lista',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      profileConstraint: {},
	      filtros: {
	        email: '',
	        login: '',
	        name: '',
	        profile: {},
	        userType: '',
	        createdAt: null,
	        id: ''
	      },
	      usuario: {
	        acao: 'LISTA',
	        pesquisa: null,
	        login: null
	      },
	      profile: [],
	      auths: {},
	      error: 'error',
	      users: [],
	      usersAdicionar: [],
	      todosUsuarios: [],
	      loadingShow: false,
	      perPage: 5,
	      currentPage: 1,
	
	      sortBy: 'initialDate',
	      sortDesc: true,
	      bordered: true,
	      filter: null,
	      emptyText: 'Não tem nenhum registro para mostrar',
	      fields: [{ key: 'username', label: 'Usuário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'initialDate', label: 'Data Inicial', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'inactivateDate', label: 'Data Final', thStyle: 'width: 10%', class: 'text-center' }, { key: 'changedBy', label: 'Alterado Por', sortable: true, thStyle: 'text-align: center', class: 'centraliza' }, { key: 'updatedAt', label: 'Alterado em', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center', class: 'text-center' }],
	      show: {
	        userForm: false
	      },
	      usuariosPesquisa: [],
	      usuariosPraGravar: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    axios.get('/proxy/account/permissions?group=true').then(function (response) {
	      _this.$aguarde('Buscando permissões. Por favor, aguarde...');
	      _this.auths = response.data.value;
	      _this.$snotify.clear();
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	    this.usuario.pesquisa = this.usuarioLogado.profilesConstraint[0].profile;
	    console.log('this.usuario.pesquisa', this.usuario.pesquisa);
	    axiosLaravel.post('/usuarios/acao/', this.usuario).then(function (response) {
	      _this.todosUsuarios = response.data.dados.row;
	      _this.$snotify.clear();
	      _this.$snotify.success('Usuários carregados com sucesso!', { timeout: 1000 });
	      _this.$snotify.clear();
	      _this.profile = _this.usuarioLogado.profilesConstraint[0].profile;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	
	  watch: {
	    profile: function profile(newProfile, oldProfile) {
	      this.buscaUsuariosProfile();
	    }
	  },
	  mounted: function mounted() {},
	  computed: (0, _extends3.default)({
	    totalRows: {
	      get: function get() {
	        return this.users.length;
	      },
	      set: function set() {}
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  methods: {
	    translate: function translate(index) {
	      index = 'hello';
	      var v = 'messages.error';
	      return v;
	    },
	    camelize: function camelize(str) {
	      return str.replace(/\W+(.)/g, function (match, chr) {
	        return chr.toUpperCase();
	      });
	    },
	    verifica: function verifica(name) {
	      if ((0, _keys2.default)(this.profile).length > 0) {
	        return this.profile.authorities.some(function (o) {
	          return o.name === name;
	        });
	      } else {
	        return false;
	      }
	    },
	    adiciona: function adiciona(authority) {
	      if (this.profile.authorities.some(function (o) {
	        return o.name === authority.name;
	      })) {
	        this.profile.authorities = this.profile.authorities.filter(function (o) {
	          return o.name !== authority.name;
	        });
	      } else this.profile.authorities.push(authority);
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    saveAuthoritiesToProfile: function saveAuthoritiesToProfile() {
	      var _this2 = this;
	
	      axios.post('proxy/account/profiles/' + this.profile.id + '/authorities', this.profile.authorities).then(function (response) {
	        _this2.$snotify.success('Permissões salvas com sucesso');
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    onCancelUserToProfile: function onCancelUserToProfile() {
	      this.show.userForm = false;
	      this.profileConstraint = {};
	      this.usersAdicionar = [];
	      this.$validator.errors.clear();
	    },
	    adicionaUsuario: function adicionaUsuario() {
	      var _this3 = this;
	
	      if ((0, _keys2.default)(this.usersAdicionar).length === 0) {
	        this.errors.add('usuarios', 'campo usuarios é obrigatorio');
	      } else {
	        this.errors.remove('usuarios');
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && (0, _keys2.default)(_this3.errors.items).length === 0) {
	          _this3.montaArrayUsuarios();
	
	          axios.post('proxy/account/profiles/' + _this3.profile.id + '/users', _this3.usuariosPraGravar).then(function (response) {
	            _this3.$snotify.success('Usuário adicionado com sucesso');
	            _this3.buscaUsuariosProfile();
	            _this3.onCancelUserToProfile();
	          }).catch(function (error) {
	            _this3.$root.trataErro(error);
	          });
	        }
	      });
	    },
	    montaArrayUsuarios: function montaArrayUsuarios() {
	      var _this4 = this;
	
	      this.usuariosPraGravar = [];
	      var userObject = {};
	
	      var usuario = this.todosUsuarios.find(function (element) {
	        return element.id === _this4.usersAdicionar.id;
	      });
	      userObject.initialDate = this.profileConstraint.initialDate;
	      if (this.profileConstraint.inactivateDate) {
	        userObject.inactivateDate = this.profileConstraint.inactivateDate;
	      }
	      userObject.user = usuario;
	      this.usuariosPraGravar.push(userObject);
	    },
	    buscaUsuariosProfile: function buscaUsuariosProfile() {
	      var _this5 = this;
	
	      var perfil = this.usuarioLogado.profilesConstraint[0].profile.id;
	      console.log('perfil', perfil);
	      axios.get('/proxy/account/profiles/' + perfil + '/users').then(function (response) {
	        _this5.users = response.data.value;
	        _this5.usuariosPesquisa = [];
	        var temporario = { id: 0, userName: '' };
	
	        _this5.todosUsuarios.forEach(function (option) {
	          if (_this5.users.some(function (o) {
	            return o.id === option.id;
	          })) {} else {
	            temporario = { id: 0, userName: '' };
	            temporario.id = option.id;
	            temporario.userName = option.userName;
	
	            _this5.usuariosPesquisa.push(temporario);
	          }
	        });
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    deleteUser: function deleteUser(id) {
	      var _this6 = this;
	
	      axios.delete('proxy/account/profiles/' + this.profile.id + '/users/' + id).then(function (response) {
	        _this6.$snotify.success('Usuário exlucido com sucesso');
	        _this6.buscaUsuariosProfile();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _UploadDocumentosOnline = __webpack_require__(508);
	
	var _UploadDocumentosOnline2 = _interopRequireDefault(_UploadDocumentosOnline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosOnline: _UploadDocumentosOnline2.default
	  },
	  name: 'EditaArticulacao',
	  data: function data() {
	    return {
	      id: null,
	      idCriacao: null,
	      numeroAtualizacao: 0,
	      parceiroTemp: {},
	      parceiro: {
	        nome: null,
	        cnpj: null,
	        dicor: null,
	        parcerias: [],
	        sede: {
	          codigoIbge: null,
	          uf: null,
	          municipio: null
	        },
	        contatos: [],
	        abrangencias: [],
	        historicos: [],
	        bb: {
	          prefixo: null,
	          nome: null,
	          contato: null,
	          telefone: null,
	          email: null
	        },
	        enquadramentos: [],
	        orcamento: {
	          fbb: 0,
	          parceiro: 0,
	          outro: 0
	        }
	      },
	      contato: {
	        nome: null,
	        cargo: null,
	        telefone: null,
	        telefone2: null,
	        email: null
	      },
	      abrangencia: {
	        tipo: null,
	        codigo: null,
	        descricao: null
	      },
	      historico: {
	        tipo: null,
	        conteudo: null,
	        usuario: null,
	        data: null,
	        prazo: null
	      },
	      parceria: {
	        nome: null,
	        situacao: 'ATIVA',
	        enquadramentos: [],
	        projetos: [],
	        instrumentos: [],
	        historicos: [],
	        abrangencias: [],
	        orcamento: {
	          fbb: 0,
	          parceiro: 0,
	          outro: 0
	        }
	      },
	      projeto: {
	        nome: null,
	        numero: null,
	        idPropostaSGP: null,
	        situacao: null,
	        enquadramento: {
	          acaoEstrategica: null,
	          tipoAcao: null,
	          programaEstruturado: null,
	          projetoSuperior: null,
	          cadeiaProdutiva: null,
	          eixoAtuacao: null
	        },
	        orcamento: {
	          fbb: 0,
	          parceiro: 0
	        },
	        execucao: {
	          fbb: 0,
	          parceiro: 0
	        },
	        historicos: [],
	        municipios: [],
	        abrangencias: []
	      },
	      instrumento: {
	        nome: null,
	        dataAssinatura: null,
	        dataVigencia: null,
	        situacao: null,
	        anexos: [],
	        orcamento: {
	          fbb: 0,
	          parceiro: 0,
	          outro: 0
	        }
	      },
	      municipio: {
	        fase: null,
	        codigoIBGE: null,
	        valor: 0,
	        cidade: null,
	        uf: null
	      },
	      anexo: {
	        ds_nome_arquivo: ''
	      },
	      editando: {},
	      edicao: {
	        codigo: null,
	        mensagem: ''
	      },
	      situacoesParceria: [{ 'codigo': 'EM_NEGOCIACAO', 'descricao': 'Em Negociação' }, { 'codigo': 'ATIVA', 'descricao': 'Ativa' }, { 'codigo': 'ENCERRADA', 'descricao': 'Encerrada' }],
	      situacoesProjeto: [{ 'codigo': 'NAO_CONTRATADO', 'descricao': 'Não contratado ainda' }, { 'codigo': 'ATIVO', 'descricao': 'Ativo' }, { 'codigo': 'EM_ENCERRAMENTO', 'descricao': 'Em Encerramento' }, { 'codigo': 'ENCERRADA', 'descricao': 'Encerrada' }, { 'codigo': 'CANCELADO', 'descricao': 'Cancelado' }],
	      listaAbrangencias: [{ 'grupo': 'País', 'lista': [{ 'tipo': 'pais', 'codigo': 'BR', 'descricao': 'Abrangência Nacional' }] }, { 'grupo': 'Regiões', 'lista': [{ 'tipo': 'regiao', codigo: 'CO', descricao: 'Centro-Oeste' }, { 'tipo': 'regiao', codigo: 'NE', descricao: 'Nordeste' }, { 'tipo': 'regiao', codigo: 'NO', descricao: 'Norte' }, { 'tipo': 'regiao', codigo: 'SE', descricao: 'Sudeste' }, { 'tipo': 'regiao', codigo: 'SU', descricao: 'Sul' }] }, { 'grupo': 'UF', 'lista': [{ 'tipo': 'uf', codigo: 'AC', descricao: 'Acre' }, { 'tipo': 'uf', codigo: 'AL', descricao: 'Alagoas' }, { 'tipo': 'uf', codigo: 'AP', descricao: 'Amapá' }, { 'tipo': 'uf', codigo: 'AM', descricao: 'Amazonas' }, { 'tipo': 'uf', codigo: 'BA', descricao: 'Bahia' }, { 'tipo': 'uf', codigo: 'CE', descricao: 'Ceará' }, { 'tipo': 'uf', codigo: 'DF', descricao: 'Distrito Federal' }, { 'tipo': 'uf', codigo: 'ES', descricao: 'Espírito Santo' }, { 'tipo': 'uf', codigo: 'GO', descricao: 'Goiás' }, { 'tipo': 'uf', codigo: 'MA', descricao: 'Maranhão' }, { 'tipo': 'uf', codigo: 'MT', descricao: 'Mato Grosso' }, { 'tipo': 'uf', codigo: 'MS', descricao: 'Mato Grosso do Sul' }, { 'tipo': 'uf', codigo: 'MG', descricao: 'Minas Gerais' }, { 'tipo': 'uf', codigo: 'PA', descricao: 'Pará' }, { 'tipo': 'uf', codigo: 'PB', descricao: 'Paraíba' }, { 'tipo': 'uf', codigo: 'PR', descricao: 'Paraná' }, { 'tipo': 'uf', codigo: 'PE', descricao: 'Pernambuco' }, { 'tipo': 'uf', codigo: 'PI', descricao: 'Piauí' }, { 'tipo': 'uf', codigo: 'RJ', descricao: 'Rio de Janeiro' }, { 'tipo': 'uf', codigo: 'RN', descricao: 'Rio Grande do Norte' }, { 'tipo': 'uf', codigo: 'RS', descricao: 'Rio Grande do Sul' }, { 'tipo': 'uf', codigo: 'RO', descricao: 'Rondônia' }, { 'tipo': 'uf', codigo: 'RR', descricao: 'Roraima' }, { 'tipo': 'uf', codigo: 'SC', descricao: 'Santa Catarina' }, { 'tipo': 'uf', codigo: 'SP', descricao: 'São Paulo' }, { 'tipo': 'uf', codigo: 'SE', descricao: 'Sergipe' }, { 'tipo': 'uf', codigo: 'TO', descricao: 'Tocantins' }] }, { 'grupo': 'Municípios', 'lista': [{ 'tipo': 'municipio', 'codigo': '', 'descricao': '<i class=\'fa fa-refresh fa-spin\'></i> Carregando municípios...', $isDisabled: true }] }],
	      listaTipos: [{ 'codigo': 'CONTATO', 'descricao': 'Contato' }, { 'codigo': 'REUNIAO', 'descricao': 'Reunião' }, { 'codigo': 'COBRANCA', 'descricao': 'Cobrança' }, { 'codigo': 'TELEFONEMA', 'descricao': 'Telefonema' }],
	      listaInstrumentos: [{ 'codigo': 'ACORDO_COOPERACAO', 'descricao': 'Acordo de Cooperação Técnica' }, { 'codigo': 'DOACAO_MODAL', 'descricao': 'Doação Modal' }, { 'codigo': 'CONTRATO', 'descricao': 'Contrato' }],
	      listaSituacoesInstrumento: [{ 'codigo': 'ELABORACAO', 'descricao': 'Em elaboração' }, { 'codigo': 'PENDENTE_ASSINATURA', 'descricao': 'Pendente Assinatura' }, { 'codigo': 'APROVADO', 'descricao': 'Aprovado' }],
	      listaProjetosSociais: [],
	      listaDependenciasBB: [],
	      listaCategorizadoresEnquadramento: [],
	      loading: {
	        tela: false,
	        abrangencia: false,
	        parcerias: false,
	        projetos: false,
	        investimentoProjeto: false,
	        enquadramento: false,
	        dependenciasBB: false
	      },
	      salvaParceiro: {
	        salvamentoAutomaticoAtivo: false,
	        statusSalvamento: 'AGUARDANDO',
	        idTimerSalvamentoAutomatico: null,
	        tempoSalvamentoAutomatico: 30000,
	        contador: 0
	      },
	      projetoSelecionado: null,
	      tabelaMunicipios: {
	        fields: [{ key: 'fase', label: 'Origem', sortable: true, thStyle: 'width: 20%; text-align: center', class: 'text-center' }, { key: 'cidade', label: 'Município', sortable: true, thStyle: 'width: 50%; text-align: left', class: 'text-left' }, { key: 'valor', label: 'Valor Total', sortable: true, thStyle: 'width: 30%; text-align: rigth', class: 'text-rigth' }],
	        currentPage: 1
	      },
	      quillOptionsCompleto: {
	        theme: 'bubble'
	      },
	      ehVisualizacao: false,
	      alturaContentWrapper: window.innerHeight - 151
	    };
	  },
	
	  watch: {
	    projetoSelecionado: function projetoSelecionado() {
	      this.selecionaProjeto();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  created: function created() {
	    this.id = this.$route.params.id;
	    this.ehVisualizacao = this.$route.params.visualizacao || false;
	    if (!_.isNull(this.id)) {
	      this.carregaParceiro();
	    }
	    this.listaMunicipios();
	    this.listaAgencias();
	    this.listaProjetos();
	    this.listaCategorizadores();
	    if (!this.ehVisualizacao) {
	      this.salvamentoAutomatico();
	    }
	    var vm = this;
	    window.addEventListener('resize', function () {
	      vm.alturaContentWrapper = window.innerHeight - 151;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.salvaParceiro.idTimerSalvamentoAutomatico);
	  },
	
	  methods: {
	    carregaParceiro: function carregaParceiro() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('articulacao/edita/', { 'id': this.id }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this.id = response.data.retorno.id;
	          _this.idCriacao = response.data.retorno.fk_criacao;
	          _this.parceiro = response.data.retorno.dados;
	          _this.parceiroTemp = _.cloneDeep(_this.parceiro);
	          _this.salvaParceiro.salvamentoAutomaticoAtivo = true;
	          _this.salvaParceiro.contador = 1;
	          _this.atualizaProjetos();
	        } else {
	          _this.aviso(response.data);
	          _this.$router.go(-1);
	        }
	        _this.loading.tela = false;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.tela = false;
	      });
	    },
	    salvamentoAutomatico: function salvamentoAutomatico() {
	      var _this2 = this;
	
	      this.salvaParceiro.idTimerSalvamentoAutomatico = setInterval(function () {
	        if (_this2.salvaParceiro.salvamentoAutomaticoAtivo && _this2.salvaParceiro.contador > 0 && !_.isEqual(_this2.parceiroTemp, _this2.parceiro)) {
	          _this2.salvarEdicao();
	        }
	      }, this.salvaParceiro.tempoSalvamentoAutomatico);
	    },
	    salvarEdicao: function salvarEdicao() {
	      var _this3 = this;
	
	      var redirecionarChave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      console.log('salvarEdicao');
	      if (this.errors.items.length === 0) {
	        this.$validator.validateAll().then(function (validado) {
	          if (validado && _this3.errors.items.length === 0) {
	            _this3.salvaParceiro.statusSalvamento = 'PROCESSANDO';
	            var rota = _.isNull(_this3.id) ? 'articulacao/cria/' : 'articulacao/salva/';
	            _this3.loading.tela = !_.isNull(redirecionarChave);
	
	            axiosLaravel.post(rota, { 'id': _this3.id, 'articulacao': _this3.parceiro }).then(function (response) {
	              if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	                _this3.salvaParceiro.statusSalvamento = 'FEITO';
	                setTimeout(function () {
	                  _this3.salvaParceiro.statusSalvamento = 'AGUARDANDO';
	                  _this3.salvaParceiro.salvamentoAutomaticoAtivo = true;
	                  _this3.salvaParceiro.contador++;
	                  console.log('salvamento feito! contador', _this3.salvaParceiro.contador);
	                }, 2000);
	                _this3.id = response.data.retorno.id;
	                _this3.idCriacao = response.data.retorno.fk_criacao;
	                _this3.parceiro = _.cloneDeep(response.data.retorno.dados);
	                _this3.parceiroTemp = _.cloneDeep(_this3.parceiro);
	              } else {
	                _this3.aviso(response.data);
	              }
	              _this3.loading.tela = false;
	            }).catch(function (error) {
	              _this3.$root.trataErro(error);
	              _this3.salvaParceiro.statusSalvamento = 'ERRO';
	            });
	          }
	        });
	      }
	    },
	    listaMunicipios: function listaMunicipios() {
	      var _this4 = this;
	
	      axiosLaravel.get('formulario/municipios/lista/').then(function (response) {
	        var municipios = [];
	        response.data.forEach(function (municipio) {
	          municipios.push({ 'codigo': municipio.codrai, 'descricao': municipio.sigufs + ' / ' + municipio.nomcid, 'tipo': 'municipio' });
	        });
	        _.set(_this4.listaAbrangencias, '[3].lista', municipios);
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    listaCategorizadores: function listaCategorizadores() {
	      var _this5 = this;
	
	      this.loading.enquadramento = true;
	      axiosLaravel.get('categorizadores/').then(function (response) {
	        _this5.listaCategorizadoresEnquadramento = _.orderBy(response.data, ['grupo', 'descricao'], ['asc', 'asc']);
	        _this5.loading.enquadramento = false;
	      }).catch(function (error) {
	        _this5.loading.enquadramento = false;
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    },
	    listaAgencias: function listaAgencias() {
	      var _this6 = this;
	
	      this.loading.dependenciasBB = true;
	      axiosLaravel.get('articulacao/agencias/').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this6.listaDependenciasBB = response.data.retorno;
	        } else {
	          _this6.aviso(response.data);
	        }
	        _this6.loading.dependenciasBB = false;
	      }).catch(function (error) {
	        _this6.loading.dependenciasBB = false;
	        _this6.$snotify.clear();
	        _this6.$root.trataErro(error);
	      });
	    },
	    atualizaProjetos: function atualizaProjetos() {
	      var _this7 = this;
	
	      this.parceiro.parcerias.forEach(function (parceria) {
	        parceria.projetos.forEach(function (projeto) {
	          if (!_.isEmpty(projeto.numero)) {
	            console.log('projeto', projeto);
	            _this7.loading.investimentoProjeto = true;
	            axiosLaravel.post('articulacao/dados/projeto', { 'projeto': projeto.numero, 'dados': ['orcamento', 'executado', 'cadastro'] }).then(function (response) {
	              console.log('dados projeto', response.data);
	              if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	                var orcamento = response.data.retorno.orcamento;
	                projeto.orcamento.fbb = orcamento.valorFBB;
	                projeto.orcamento.parceiro = orcamento.valorParceiros;
	                var executado = response.data.retorno.executado;
	                projeto.execucao.fbb = executado.ExecutadoRP;
	                projeto.execucao.parceiro = executado.ExecutadoRT;
	                var cadastro = response.data.retorno.cadastro;
	                projeto.situacao = cadastro.sitprj === 'ENC' ? 'ENCERRADA' : cadastro.sitprj === 'ETO' ? 'EM_ENCERRAMENTO' : _.includes(['ANU', 'CAN', 'REP', 'IND'], cadastro.sitprj) ? 'CANCELADO' : _.includes(['ANN', 'DEF'], cadastro.sitprj) ? 'NAO_CONTRATADO' : 'ATIVO';
	                _this7.$forceUpdate();
	              }
	              _this7.loading.investimentoProjeto = false;
	            }).catch(function (error) {
	              _this7.$root.trataErro(error);
	              _this7.loading.investimentoProjeto = false;
	            });
	          }
	        });
	      });
	    },
	    selecionaProjeto: function selecionaProjeto() {
	      var _this8 = this;
	
	      var selecionado = this.projetoSelecionado;
	      console.log('selecionado', selecionado);
	      if (_.has(selecionado, 'numero')) {
	        this.loading.investimentoProjeto = true;
	        this.editando.parceriaProjeto.numero = selecionado.numero;
	        this.editando.parceriaProjeto.nome = selecionado.nome;
	        axiosLaravel.post('articulacao/dados/projeto', { 'projeto': selecionado.numero, 'dados': ['orcamento', 'executado', 'cadastro', 'categorizadores', 'municipios'] }).then(function (response) {
	          console.log('dados projeto', response.data);
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            var orcamento = response.data.retorno.orcamento;
	            _this8.editando.parceriaProjeto.orcamento.fbb = orcamento.valorFBB;
	            _this8.editando.parceriaProjeto.orcamento.parceiro = orcamento.valorParceiros;
	            var executado = response.data.retorno.executado;
	            _this8.editando.parceriaProjeto.execucao.fbb = executado.ExecutadoRP;
	            _this8.editando.parceriaProjeto.execucao.parceiro = executado.ExecutadoRT;
	            var cadastro = response.data.retorno.cadastro;
	            _this8.editando.parceriaProjeto.situacao = cadastro.sitprj === 'ENC' ? 'ENCERRADA' : cadastro.sitprj === 'ETO' ? 'EM_ENCERRAMENTO' : _.includes(['ANU', 'CAN', 'REP', 'IND'], cadastro.sitprj) ? 'CANCELADO' : _.includes(['ANN', 'DEF'], cadastro.sitprj) ? 'NAO_CONTRATADO' : 'ATIVO';
	            _this8.editando.parceriaProjeto.municipios = response.data.retorno.municipios;
	            _this8.projetoSelecionado.cadastro = _.clone(cadastro);
	            _this8.$forceUpdate();
	          }
	          _this8.loading.investimentoProjeto = false;
	        }).catch(function (error) {
	          _this8.$root.trataErro(error);
	          _this8.loading.investimentoProjeto = false;
	        });
	      } else {
	        this.editando.parceriaProjeto.numero = null;
	        this.editando.parceriaProjeto.nome = null;
	        this.editando.parceriaProjeto.orcamento.fbb = 0;
	        this.editando.parceriaProjeto.orcamento.parceiro = 0;
	      }
	    },
	    listaProjetos: function listaProjetos() {
	      var _this9 = this;
	
	      this.loading.projetos = true;
	      axiosLaravel.get('articulacao/projetos').then(function (response) {
	        console.log('listaProjetos', response.data);
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this9.listaProjetosSociais = response.data.retorno;
	          _this9.$forceUpdate();
	        }
	        _this9.loading.projetos = false;
	      }).catch(function (error) {
	        _this9.$root.trataErro(error);
	        _this9.loading.projetos = false;
	      });
	    },
	    aviso: function aviso(retorno) {
	      var _this10 = this;
	
	      if (_.has(retorno, 'codigo')) {
	        var mensagens = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : ['Erro de processamento. Não sei o que houve'];
	        mensagens.forEach(function (msg) {
	          if (retorno.codigo === 'ERRO') {
	            _this10.$snotify.error(msg);
	          } else if (_.includes(['OK', 'AVISO'], retorno.codigo)) {
	            _this10.$snotify.success(msg, { timeout: 3000 });
	          }
	        });
	      }
	    },
	    dadosUsuarioHistorico: function dadosUsuarioHistorico(destino) {
	      console.log('dadosUsuarioHistorico');
	      _.set(destino, 'usuario.id', this.usuarioLogado.id);
	      _.set(destino, 'usuario.ds_login', this.usuarioLogado.ds_login);
	      _.set(destino, 'usuario.ds_nome_usuario', this.usuarioLogado.ds_nome_usuario);
	    },
	    ok: function ok(objetoPai, local, destino) {
	      var apagarEdicao = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      console.log('ok');
	
	      var idx = _.get(objetoPai, [local, 'idx']);
	      var valor = _.clone(_.get(objetoPai, [local]));
	      _.unset(valor, 'idx');
	
	      if (idx >= 0) {
	        destino[idx] = valor;
	      } else {
	        destino.push(valor);
	      }
	      if (apagarEdicao) {
	        this.cancela(objetoPai, local);
	      }
	    },
	    cancela: function cancela(objetoPai, local) {
	      console.log('cancela :: objetoPai, local', objetoPai, local);
	      _.unset(objetoPai, local);
	      this.$forceUpdate();
	    },
	    edita: function edita(objetoPai, local, modelo, idx) {
	      console.log('edita :: idx, objetoPai, local, modelo', idx, objetoPai, local, modelo);
	      _.set(objetoPai, local, modelo);
	      _.set(objetoPai, [local, 'idx'], idx);
	      this.$forceUpdate();
	    },
	    duplica: function duplica(lista, idx) {
	      console.log('duplica :: lista, idx, ', lista, idx);
	      lista.push(_.clone(lista[idx]));
	      this.$forceUpdate();
	    },
	    remove: function remove(lista, idx) {
	      console.log('remove :: lista, idx, ', lista, idx);
	      lista.splice(idx, 1);
	      this.$forceUpdate();
	    },
	    situacaoInstrumento: function situacaoInstrumento(instrumento) {
	      var situacao = { 'texto': 'Situaçao não prevista', 'classe': '' };
	      if (_.isNull(instrumento.dataAssinatura) && _.isNull(instrumento.dataVigencia) || !_.isNull(instrumento.dataAssinatura) && new Date() < instrumento.dataAssinatura) {
	        situacao = { 'texto': 'Em Negociação', 'classe': 'label label-primary' };
	      } else if (!_.isNull(instrumento.dataAssinatura) && new Date() >= instrumento.dataAssinatura && (_.isNull(instrumento.dataVigencia) || new Date() <= instrumento.dataVigencia)) {
	        situacao = { 'texto': 'Ativo', 'classe': 'label label-success' };
	      } else if (!_.isNull(instrumento.dataVigencia) && new Date() > instrumento.dataVigencia) {
	        situacao = { 'texto': 'Encerrado', 'classe': 'label label-danger' };
	      }
	      return situacao;
	    }
	  }
	};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trunc = __webpack_require__(108);
	
	var _trunc2 = _interopRequireDefault(_trunc);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _xlsx = __webpack_require__(144);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaArticulacoes',
	  data: function data() {
	    return {
	      loading: {
	        tela: false,
	        detalhes: false
	      },
	      numeroAtualizacao: 0,
	      pesquisa: '',
	      hoje: new Date(),
	      situacoesParceria: [{ 'codigo': 'INSTRUMENTO_ELABORACAO', 'descricao': 'Instrumentos jurídicos em elaboração' }, { 'codigo': 'EM_ANALISE', 'descricao': 'Projetos em análise na FBB' }, { 'codigo': 'EM_ARTICULACAO', 'descricao': 'Projeto em articulação' }, { 'codigo': 'AGUARDA_ENVIO_PROJETO', 'descricao': 'Aguardando envio de projetos' }, { 'codigo': 'AGUARDA_MANIFESTACAO_BB', 'descricao': 'Aguardando manifestação do BB' }, { 'codigo': 'PORTIFOLIO_ENVIADO_FBB', 'descricao': 'Portfólio de projetos enviado à FBB' }, { 'codigo': 'AGUARDA_DEFINICAO_PARCERIA', 'descricao': 'Reuniões em andamento para definição sobre a parceria' }, { 'codigo': 'REUNIAO_AGENDA', 'descricao': 'Reuniões agendadas' }, { 'codigo': 'AGUARDA_AGENDA_REUNIAO', 'descricao': 'Aguardando agendamento de reunião pelo BB' }, { 'codigo': 'ATIVA', 'descricao': 'Ativo' }, { 'codigo': 'EM_ENCERRAMENTO', 'descricao': 'Em Encerramento' }, { 'codigo': 'ENCERRADA', 'descricao': 'Encerrado' }],
	      camposArticulacao: [{ key: 'id', label: 'ID', thStyle: 'width: 5%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'nome', label: 'Nome', thStyle: 'text-align: left', sortable: true, 'class': 'word-wrap:break-word text-left' }, { key: 'alertas', label: 'Alertas', thStyle: 'width: 20%; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'actions', label: 'Ações', thStyle: 'width: 20%; text-align: center;', sortable: false, 'class': 'text-center' }],
	      tabelaArticulacao: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'alertas',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      articulacoes: []
	    };
	  },
	  created: function created() {
	    this.listaFormsAvaliacao();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  methods: {
	    listaFormsAvaliacao: function listaFormsAvaliacao() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('articulacao/lista/completo').then(function (response) {
	        _this.articulacoes = response.data;
	        _this.verificarAlertas();
	        _this.tabelaArticulacao.totalRows = _this.articulacoes.length;
	        _this.$forceUpdate();
	        _this.loading.tela = false;
	      }).catch(function (error) {
	        _this.$snotify.clear();
	        _this.$root.trataErro(error);
	        _this.loading.tela = false;
	      });
	    },
	    verificarAlertas: function verificarAlertas() {
	      this.articulacoes.forEach(function (articulacao) {
	        var id = articulacao.id;
	        var parceiro = articulacao.dados;
	        var instrumetosVencer = [];
	        var instrumetosVencidos = [];
	        parceiro.parcerias.forEach(function (parceria) {
	          parceria.instrumentos.forEach(function (instrumento) {
	            var diasTerminoVigencia = (0, _moment2.default)(instrumento.dataVigencia).diff((0, _moment2.default)(), 'days', true);
	            var diasAposVigencia = (0, _moment2.default)().diff((0, _moment2.default)(instrumento.dataVigencia), 'days', true);
	            if (parceria.situacao !== 'ENCERRADA') {
	              if (!_.isNull(instrumento.dataVigencia) && diasTerminoVigencia > 0 && diasTerminoVigencia < 60) {
	                instrumetosVencer.push({ 'instrumento': instrumento, 'dias': (0, _trunc2.default)(diasTerminoVigencia) });
	              }
	              if (!_.isNull(instrumento.dataVigencia) && diasAposVigencia > 0) {
	                instrumetosVencidos.push({ 'instrumento': instrumento, 'dias': (0, _trunc2.default)(diasAposVigencia) });
	              }
	            }
	          });
	        });
	        articulacao.alertas = { 'id': id, 'instrumetosVencer': instrumetosVencer, 'instrumentosVencidos': instrumetosVencidos };
	      });
	    },
	    filtroPorItem: function filtroPorItem(row, filter) {
	      var saida = true;
	      console.log('filtroPorItem row, filter', row, filter);
	      if (filter !== 'retornar_todos_registros') {
	        var termos = _.split(_.toLower(filter), ' ');
	        termos.forEach(function (termo) {
	          saida = saida && (_.toLower(row.id).indexOf(termo) !== -1 || _.toLower(row.articulacao.acao).indexOf(termo) !== -1 || _.toLower(row.articulacao.local).indexOf(termo) !== -1 || row.articulacao.data.indexOf(termo) !== -1);
	        });
	      }
	      return saida;
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.tabelaArticulacao.totalRows = filteredItems.length;
	      this.tabelaArticulacao.currentPage = 1;
	    },
	    ajustaPesquisa: function ajustaPesquisa() {
	      this.tabelaArticulacao.filter = _.isNull(this.pesquisa) || this.pesquisa === '' ? 'retornar_todos_registros' : this.pesquisa;
	    },
	    exportarExcel: function exportarExcel() {
	      var _this2 = this;
	
	      this.loading.tela = true;
	
	      var vm = this;
	      var planilhaPrincipal = [];
	      var contatos = [];
	      var abrangencias = [];
	      var historicos = [];
	      var parcerias = [];
	      var parceriaInstrumentos = [];
	      var parceriaHistoricos = [];
	      var parceriaProjetos = [];
	
	      axiosLaravel.post('articulacao/excel/', { 'lista': null }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var articulacoes = response.data.retorno.articulacoes;
	          var autenticacao = response.data.retorno.autenticacao;
	          var idParceria = 0;
	
	          articulacoes.forEach(function (articulacao) {
	            var parceiro = articulacao.dados;
	            var parceiroTemp = {};
	            _.set(parceiroTemp, 'ID', articulacao.id);
	            _.forEach(parceiro, function (valor, dado) {
	              if (_.isArray(valor)) {
	                _.get(parceiro, _dados, []).forEach(function (registro) {
	                  _.set(registro, 'ID', articulacao.id);
	                });
	              } else {
	                vm.tratamento(parceiroTemp, dado, valor);
	              }
	            });
	            planilhaPrincipal.push(parceiroTemp);
	
	            parceiro.contatos.forEach(function (contato) {
	              var contatoTemp = { 'ID': articulacao.id };
	              _.forEach(contato, function (v, d) {
	                vm.tratamento(contatoTemp, d, v);
	              });
	              contatos.push(contatoTemp);
	            });
	            parceiro.abrangencias.forEach(function (abrangencia) {
	              var abrangenciaTemp = { 'ID': articulacao.id };
	              _.forEach(abrangencia, function (v, d) {
	                vm.tratamento(abrangenciaTemp, d, v);
	              });
	              abrangencias.push(abrangenciaTemp);
	            });
	            parceiro.historicos.forEach(function (historico) {
	              var historicoTemp = { 'ID': articulacao.id };
	              _.forEach(historico, function (v, d) {
	                vm.tratamento(historicoTemp, d, v);
	              });
	              _.unset(historicoTemp, 'usuario_id');
	              historicos.push(historicoTemp);
	            });
	            parceiro.parcerias.forEach(function (parceria) {
	              var parceriaTemp = { 'ID': articulacao.id };
	              _.forEach(parceria, function (v, d) {
	                vm.tratamento(parceriaTemp, d, v);
	              });
	              _.unset(parceriaTemp, 'idx');
	              _.set(parceriaTemp, 'ID_Parceria', idParceria);
	              parcerias.push(parceriaTemp);
	
	              parceria.instrumentos.forEach(function (instrumento) {
	                var instrumentoTemp = { 'ID_Parceria': idParceria };
	                _.forEach(instrumento, function (v, d) {
	                  vm.tratamento(instrumentoTemp, d, v);
	                });
	                _.unset(instrumentoTemp, 'idx');
	
	                parceriaInstrumentos.push(instrumentoTemp);
	              });
	
	              parceria.historicos.forEach(function (historico) {
	                var historicoTemp = { 'ID_Parceria': idParceria };
	                _.forEach(historico, function (v, d) {
	                  vm.tratamento(historicoTemp, d, v);
	                });
	                _.unset(historicoTemp, 'idx');
	                parceriaHistoricos.push(historicoTemp);
	              });
	
	              parceria.projetos.forEach(function (projeto) {
	                var projetoTemp = { 'ID_Parceria': idParceria };
	                _.forEach(projeto, function (v, d) {
	                  vm.tratamento(projetoTemp, d, v);
	                });
	                _.unset(projetoTemp, 'idx');
	                parceriaProjetos.push(projetoTemp);
	              });
	              idParceria++;
	            });
	          });
	          var principal = XLSX.utils.json_to_sheet(planilhaPrincipal);
	
	          var wb = XLSX.utils.book_new();
	          XLSX.utils.book_append_sheet(wb, principal, 'Instituicao Parceira');
	          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(contatos), 'Contatos do parceiro');
	          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(abrangencias), 'Abrangencia do parceiro');
	          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(historicos), 'Historico do parceiro');
	          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(parcerias), 'Parcerias');
	          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(parceriaInstrumentos), 'Parceria - Instrumentos');
	          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(parceriaHistoricos), 'Parceria - Historico');
	          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(parceriaProjetos), 'Parceria - Projetos');
	
	          var _dados = [{ 'Registro': 'IDs das Articulações', 'Informação': _.join(_.map(articulacoes, 'id'), ', ') }, { 'Registro': 'Quem gerou a planilha', 'Informação': autenticacao.usuario }, { 'Registro': 'Quando foi gerada', 'Informação': autenticacao.dataHora }, { 'Registro': 'Autenticação', 'Informação': autenticacao.numero }];
	          var extracao = XLSX.utils.json_to_sheet(_dados);
	          XLSX.utils.book_append_sheet(wb, extracao, 'Extração');
	          XLSX.writeFile(wb, 'articulacoes.xlsx');
	        } else {
	          _this2.$snotify.error(response.data.mensagem);
	        }
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        _this2.$snotify.clear();
	        _this2.$root.trataErro(error);
	        _this2.loading.tela = false;
	      });
	    },
	    tratamento: function tratamento(objeto, propriedade, valor) {
	      if (_.isNull(valor)) {
	        _.set(objeto, propriedade, '');
	      } else if (!_.isObjectLike(valor)) {
	        _.set(objeto, propriedade, ('' + valor).replace(/(<([^>]+)>)/ig, ''));
	      } else if (_.isPlainObject(valor)) {
	        _.forEach(valor, function (v, d) {
	          _.set(objeto, propriedade + '_' + d, ('' + v).replace(/(<([^>]+)>)/ig, ''));
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documentos-online',
	  data: function data() {
	    return {
	      layout: 'LISTA',
	      numeroAtualizacao: 0,
	      documentos: [],
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      idsVigenciaObrigatoria: [],
	      idsVerificaVencimento: null,
	      loading: {
	        adicionando: false,
	        alterando: false,
	        excluindo: false,
	        usosDocumento: false
	      },
	      usosDocumento: 'TODOS',
	
	      documento: {
	        ds_nome_arquivo: ''
	      },
	      editando: false,
	      file: {} };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'layoutInicial', 'idProcesso', 'ehVisualizacao', 'localUso', 'secaoOrigem', 'processo_ratificacao', 'vigenciaObrigatoria', 'docsInformaVencimento'],
	  created: function created() {
	    var _this = this;
	
	    this.layout = this.layoutInicial || 'LISTA';
	
	    if (!_.isEmpty(this.vigenciaObrigatoria)) {
	      this.idsVigenciaObrigatoria = this.vigenciaObrigatoria;
	    }
	    this.idsVerificaVencimento = this.docsInformaVencimento || null;
	    this.usosDocumento = this.localUso || 'TODOS';
	    this.carregaTiposDocumento();
	
	    if (_.isNull(this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	          return item.ds_mime_type;
	        }).join('|');
	        _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    } else {
	      this.tiposPermitidos = this.$store.state.uploadDocumentos.tiposPermitidos;
	      this.tamanhoPermitido = this.$store.state.uploadDocumentos.tamanhoPermitido;
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    localUso: function localUso() {
	      this.carregaTiposDocumento();
	    },
	    vigenciaObrigatoria: function vigenciaObrigatoria() {
	      if (!_.isEmpty(this.vigenciaObrigatoria)) {
	        this.idsVigenciaObrigatoria = this.vigenciaObrigatoria;
	      }
	    },
	    docsInformaVencimento: function docsInformaVencimento() {
	      this.idsVerificaVencimento = this.docsInformaVencimento || null;
	      this.$forceUpdate();
	    }
	  },
	  methods: {
	    carregaTiposDocumento: function carregaTiposDocumento() {
	      var _this2 = this;
	
	      this.loading.usosDocumento = true;
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this2.documentos = _this2.$store.state.uploadDocumentos.documentos = _.sortBy(response.data, [function (o) {
	          return o.ds_tipo;
	        }]);
	        _this2.loading.usosDocumento = false;
	      }).catch(function (error) {
	        _this2.loading.usosDocumento = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    novoDocumento: function novoDocumento() {
	      this.layout = 'EDICAO';
	      this.$emit('layoutAtual', this.layout);
	      this.documento = {};
	    },
	    cancela: function cancela() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.layout = 'LISTA';
	      this.$emit('layoutAtual', this.layout);
	      this.editando = false;
	      this.$forceUpdate();
	    },
	    onDownload: function onDownload(documento) {
	      var _this3 = this;
	
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this4 = this;
	
	      this.$snotify.clear();
	      if (!_.isNull(this.idProcesso)) {
	        this.loading.adicionando = true;
	        this.$snotify.info('Anexando arquivo', { timeout: 0 });
	        this.$emit('acaoProcessamento', this.numeroAtualizacao++);
	        this.documento.pk = this.documento.id ? this.documento.id : 0;
	        this.documento.usuario = this.usuarioLogado;
	        this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	        var data = new FormData();
	        data.append('file', this.file);
	        data.append('id_processo', this.idProcesso);
	        data.append('local_inclusao', this.secaoOrigem);
	        data.append('document', (0, _stringify2.default)(this.documento));
	        axiosLaravel.post('articulacao/adicionar/arquivo/', data, {
	          headers: { 'Content-Type': undefined, 'Accept': 'application/json' },
	          transformRequest: [function (data, headers) {
	            return data;
	          }]
	        }).then(function (response) {
	          _this4.$snotify.clear();
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this4.$snotify.success('Arquivo anexado', { timeout: 2000 });
	            _this4.$emit('arquivoAnexado', response.data.retorno);
	            _this4.cancela();
	            _this4.$emit('acaoSalvar', _this4.numeroAtualizacao++);
	          } else {
	            _this4.$snotify.error(response.data.mensagem);
	          }
	          _this4.$emit('acaoAguardando', _this4.numeroAtualizacao++);
	          _this4.loading.adicionando = false;
	        }).catch(function (error) {
	          _this4.loading.adicionando = false;
	          _this4.$emit('acaoAguardando', _this4.numeroAtualizacao++);
	          _this4.$snotify.clear();
	          _this4.$root.trataErro(error);
	        });
	      } else {
	        this.$dialog.alert('Não pode adicionar anexos antes de salvar/criar esta solicitação', { html: true, animation: 'fade', customClass: 'avisoAlerta' });
	      }
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento, documento) {
	      var _this5 = this;
	
	      this.$snotify.clear();
	      if (!_.isNull(this.idProcesso)) {
	        this.loading.excluindo = true;
	        this.$snotify.success('Arquivo excluido', { timeout: 2000 });
	        this.$emit('acaoProcessamento', this.numeroAtualizacao++);
	        axiosLaravel.post('articulacao/excluir/arquivo/', { 'id_processo': this.idProcesso, 'id_documento': documento.id, 'local_inclusao': this.secaoOrigem }).then(function (response) {
	          _this5.$snotify.clear();
	          if (_.has(response.data, 'codigo')) {
	            if (response.data.codigo === 'OK') {
	              _this5.$snotify.success('Arquivo excluido');
	              _this5.propDocumentos.splice(indexDocumento, 1);
	              _this5.$emit('arquivoExcluido', response.data.retorno);
	              _this5.$emit('acaoOk', _this5.numeroAtualizacao++);
	              _this5.$emit('acaoSalvar', _this5.numeroAtualizacao++);
	            } else if (response.data.codigo === 'DOCUMENTO_NAO_LOCALIZADO') {
	              _this5.propDocumentos.splice(indexDocumento, 1);
	              _this5.$emit('arquivoExcluido', response.data.retorno);
	              _this5.$emit('acaoOk', _this5.numeroAtualizacao++);
	            } else {
	              _this5.$snotify.error(response.data.mensagem);
	            }
	          }
	          _this5.$forceUpdate();
	          _this5.$emit('acaoAguardando', _this5.numeroAtualizacao++);
	          _this5.loading.excluindo = false;
	        }).catch(function (error) {
	          _this5.loading.excluindo = false;
	          _this5.$emit('acaoAguardando', _this5.numeroAtualizacao++);
	          _this5.$snotify.clear();
	          _this5.$root.trataErro(error);
	        });
	      } else {
	        this.$dialog.alert('Não pode adicionar anexos antes de Criar este parceiro no SGP', { html: true, animation: 'fade', customClass: 'avisoAlerta' });
	      }
	    }
	  }
	};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'editar-assunto',
	  data: function data() {
	    return {
	      assunto: {},
	      loading: {
	        show: false
	      },
	      areas: [{ id: 1, nome: 'Gerência de Pagamentos e Contratações', uor: 341862 }, { id: 2, nome: 'Gerência de Implementação e Assessoramento de Projetos', uor: 341860 }, { id: 3, nome: 'Gerência de Análise e Avaliação', uor: 341861 }]
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {
	    this.selectedValue;
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      this.loading.show = true;
	      axiosLaravel.get('assunto/' + this.$route.params.id).then(function (response) {
	        _this.assunto = response.data;
	        _this.assunto.area_responsavel = _.filter(_this.areas, { 'nome': _this.assunto.area_responsavel });
	        _this.assunto.data_inclusao = (0, _moment2.default)(_this.assunto.data_inclusao).format('DD/MM/YYYY');
	        _this.assunto.data_atualizado = (0, _moment2.default)(_this.assunto.data_atualizado).format('DD/MM/YYYY');
	        _this.loading.show = false;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    }
	  },
	
	  methods: {
	    selectedValue: function selectedValue() {},
	    salva: function salva() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.assunto.id) {
	            _this2.atualiza();
	          } else {
	            _this2.grava();
	          }
	        } else {
	          _this2.errors.items.forEach(function (item) {
	            _this2.$snotify.error(item.msg);
	          });
	        }
	      });
	    },
	    atualiza: function atualiza() {
	      var _this3 = this;
	
	      this.$aguarde('Salvando o Assunto. Por favor, aguarde...');
	      axiosLaravel.put('assunto/' + this.assunto.id, this.assunto).then(function (response) {
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Assunto salvo com sucesso!');
	        _this3.$router.go(-1);
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this4 = this;
	
	      this.$aguarde('Salvando o Assunto. Por favor, aguarde...');
	      axiosLaravel.post('assunto', this.assunto).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Assunto salvo com sucesso!');
	        _this4.$router.go(-1);
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    etiquetaArea: function etiquetaArea(option) {
	      return '' + option.nome;
	    },
	    changeArea: function changeArea(area) {
	      this.assunto.area_responsavel = area;
	    }
	  }
	};

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'lista-assunto',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'bt_ativo',
	        sortDesc: true,
	        fields: [{ key: 'assunto', label: 'Assunto', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'area_responsavel', label: 'Área Responsável', sortable: true, thStyle: 'text-align: center; width: 30%', class: 'text-center' }, { key: 'data_inclusao', label: 'Data Inclusão', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 10%', class: 'text-center' }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['urlLaravel']), {
	    computedFields: function computedFields() {
	      if (!this.$root.authorize('chamado-criar-assunto')) {
	        return _.reject(this.table.fields, { label: 'Ações' });
	      } else {
	        return this.table.fields;
	      }
	    }
	  }),
	  created: function created() {
	    var _this = this;
	
	    this.loading.show = true;
	    axiosLaravel.get('assunto/').then(function (response) {
	      _this.table.items = response.data;
	      _this.table.totalRows = response.data.length;
	      _this.loading.show = false;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	      _this.loading.show = false;
	    });
	  },
	
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    inativa: function inativa(item) {
	      var _this2 = this;
	
	      this.loading.show = true;
	      axiosLaravel.delete('assunto/' + item.id).then(function (response) {
	        _this2.$snotify.success('Assunto ' + item.assunto + ' atualizado com sucesso!');
	        item.bt_ativo = !item.bt_ativo;
	        _this2.loading.show = false;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _xlsx = __webpack_require__(144);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CadastroFormsAvaliacao',
	  data: function data() {
	    return {
	      loading: {
	        tela: false,
	        detalhes: false
	      },
	      numeroAtualizacao: 0,
	      pesquisa: '',
	      hoje: new Date(),
	      camposFormularios: [{ key: 'id', label: 'ID', thStyle: 'width: 5%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'criacao', label: 'Criado em', thStyle: 'width: 10%; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'nome', label: 'Nome', thStyle: 'width: 25%; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'tipo', label: 'Tipo de formulário', thStyle: 'width: 10%; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'situacao', label: 'Situação', thStyle: 'width: 15%; text-align: center', sortable: false, 'class': 'word-wrap:break-word text-center' }, { key: 'uso', label: 'Preenchido', thStyle: 'width: 10%; text-align: center', sortable: false, 'class': 'word-wrap:break-word text-center' }, { key: 'actions', label: 'Ações', thStyle: 'width: 20%; text-align: center', sortable: false, 'class': 'text-center' }],
	      tabelaFormularios: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      camposDetalhamento: [{ key: 'processo', label: 'Processo', thStyle: 'width: 10%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'projeto', label: 'Projeto', thStyle: 'text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'situacao', label: 'Situação', thStyle: 'width: 10%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'width: 30%; text-align: center', sortable: false, 'class': 'text-center' }],
	      tabelaDetalhamento: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'processo.id',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      tipoFormulario: [{ codigo: 'AVALIACAO_APROVACAO', descricao: 'Marco zero' }, { codigo: 'AVALIACAO_ENCERRAMENTO', descricao: 'Marco um' }, { codigo: 'AVALIACAO_GENERICO', descricao: 'Genérico' }, { codigo: 'AVALIACAO_PARTICIPANTE', descricao: 'Participante' }],
	      detalhamentoFormulario: {},
	      projetoSelecionadoEnvioManual: {},
	      formularios: [],
	      alertasFormulariosCadastrados: []
	    };
	  },
	  created: function created() {
	    this.listaFormsAvaliacao();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  methods: {
	    assinaCanais: function assinaCanais() {
	      var vm = this;
	      if (!_.isEmpty(vm.detalhamentoFormulario)) {
	        _.forEach(vm.detalhamentoFormulario, function (formCadastroDetalhado) {
	          _.get(formCadastroDetalhado, 'listaProjetosVinculadosFormulario', []).forEach(function (formPreenchido) {
	            var canalFormPreenchimento = 'formulario.preenchido.' + formPreenchido.id;
	            window.Echo.channel(canalFormPreenchimento).listen('FormularioEvents', function (notificacao) {
	              var form = void 0;
	              _.forEach(vm.detalhamentoFormulario, function (formCad) {
	                if (form) {
	                  return false;
	                } else {
	                  _.forEach(formCad.listaProjetosVinculadosFormulario, function (formPre) {
	                    if (formPre.id === notificacao.id) {
	                      form = formPre;
	                      return false;
	                    }
	                  });
	                }
	              });
	
	              if (form) {
	                if (notificacao.mensagem.acao === 'FORMULARIO_ABERTO') {
	                  _.set(form, '_rowVariant', 'form-aberto');
	                } else if (notificacao.mensagem.acao === 'FORMULARIO_FECHADO') {
	                  _.set(form, '_rowVariant', 'form-fechando');
	                  setTimeout(function () {
	                    _.unset(form, '_rowVariant');vm.numeroAtualizacao += 1;
	                  }, 4000);
	                } else if (notificacao.mensagem.acao === 'FORMULARIO_SALVANDO') {
	                  _.set(form, '_rowVariant', 'form-salvando');
	                  setTimeout(function () {
	                    _.set(form, '_rowVariant', 'form-aberto');vm.numeroAtualizacao += 1;
	                  }, 4000);
	                } else if (notificacao.mensagem.acao === 'FORMULARIO_EDITANDO') {
	                  var andamento = _.get(form, 'andamento');
	                  _.set(form, 'andamento', 'Preenchendo...');
	                  setTimeout(function () {
	                    _.set(form, 'andamento', andamento);vm.numeroAtualizacao += 1;
	                  }, 800);
	                } else if (notificacao.mensagem.acao === 'PERCENTUAL_PREENCHIDO') {
	                  _.set(form, 'andamento', notificacao.mensagem.percentagem);
	                }
	                vm.numeroAtualizacao += 1;
	              }
	            });
	          });
	        });
	      }
	    },
	    notificacaoDeFormCadastrado: function notificacaoDeFormCadastrado(canal, id, mensagem) {
	      var _this = this;
	
	      var msg = { canal: canal, id: id, mensagem: mensagem };
	      axiosLaravel.post('formulario/mensageria', msg).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          console.log('Mensagem enviada!');
	        } else {
	          console.log('Erro de mensageria!');
	        }
	      }).catch(function (error) {
	        _this.$snotify.clear();
	        _this.$root.trataErro(error);
	      });
	    },
	    listaFormsAvaliacao: function listaFormsAvaliacao() {
	      var _this2 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('formulario/lista/simples').then(function (response) {
	        _this2.formularios = response.data;
	        _this2.tabelaFormularios.totalRows = _this2.formularios.length;
	        _this2.verificaIrregularidadesFormsCadastrados();
	        _this2.assinaCanais();
	        _this2.$forceUpdate();
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        _this2.$snotify.clear();
	        _this2.$root.trataErro(error);
	        _this2.loading.tela = false;
	      });
	    },
	    verificaIrregularidadesFormsCadastrados: function verificaIrregularidadesFormsCadastrados() {
	      var _this3 = this;
	
	      this.formularios.forEach(function (formulario) {
	        var mesmoNome = _.filter(_this3.formularios, ['nome', formulario.nome]);
	        if (mesmoNome.length > 1) {
	          _this3.alertasFormulariosCadastrados.push('Formulários com mesmo nome "' + formulario.nome + '" repetido nos id\'s ' + _.join(_.map(mesmoNome, 'id'), ', '));
	        }
	      });
	      this.formularios.forEach(function (formulario) {
	        var mesmoTipoEPrograma = _.filter(_this3.formularios, function (f) {
	          return f.tipo === formulario.tipoFormulario;
	        });
	        if (mesmoTipoEPrograma.length > 1) {
	          _this3.alertasFormulariosCadastrados.push('Formulários com mesmo tipo "' + formulario.nome + '" repetido nos id\'s ' + _.join(_.map(mesmoTipoEPrograma, 'id'), ', '));
	        }
	      });
	    },
	    mostrarDetalhes: function mostrarDetalhes(row) {
	      row.toggleDetails();
	      if (!row.detailsShowing) {
	        this.carregarProcessosPreenchimentoPorFormulario(row.item.id);
	      }
	    },
	    carregarProcessosPreenchimentoPorFormulario: function carregarProcessosPreenchimentoPorFormulario(idFormulario) {
	      var _this4 = this;
	
	      this.loading.detalhes = true;
	      axiosLaravel.get('formulario/' + idFormulario + '/projetos/vinculados').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _.set(_this4.detalhamentoFormulario, [idFormulario, 'listaProjetosVinculadosFormulario'], response.data.retorno);
	          _this4.assinaCanais();
	        } else {
	          _this4.$snotify.error(response.data.mensagem);
	        }
	        _this4.loading.detalhes = false;
	        _this4.carregarProjetosDisponiveisPorFormulario(idFormulario);
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.loading.detalhes = false;
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    carregarProjetosDisponiveisPorFormulario: function carregarProjetosDisponiveisPorFormulario(idFormulario) {
	      var _this5 = this;
	
	      axiosLaravel.get('formulario/' + idFormulario + '/projetos/disponiveis').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _.set(_this5.detalhamentoFormulario, [idFormulario, 'listaProjetosDisponiveis'], response.data.retorno);
	        } else {
	          _this5.$snotify.error(response.data.mensagem);
	        }
	        _this5.$forceUpdate();
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    },
	    vincularFormularioAoProjeto: function vincularFormularioAoProjeto(idFormulario) {
	      var _this6 = this;
	
	      this.loading.tela = true;
	      var vm = this;
	      var projetoSelecionado = _.get(this.projetoSelecionadoEnvioManual, [idFormulario]);
	      var projetoJaVinculado = _.find(_.get(this.detalhamentoFormulario, [idFormulario, 'listaProjetosVinculadosFormulario']), function (p) {
	        return _.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _.find(vm.formularios, ['id', idFormulario])['tipo']) && _.has(p.projeto, 'ds_codigo_projeto_erp') && '' + p.projeto.ds_codigo_projeto_erp === '' + projetoSelecionado.ds_codigo_projeto_erp && _.includes(['EM_EXECUCAO'], p.processo.situacao);
	      });
	      var formSelecionado = _.find(this.formularios, ['id', idFormulario]);
	      var msg = projetoJaVinculado ? 'Este formulário <br/><b>' + formSelecionado.id + '</b> - <b>' + formSelecionado.nome + '</b><br/>está atualmente vinculado ao projeto <br/><b>' + projetoSelecionado.ds_codigo_projeto_erp + '</b> - <b>' + projetoSelecionado.ds_nome + '</b>.<br/><br/>Somente pode ter um deste tipo por projeto.<br/><br/>Então, se continuar, o formulário atual será cancelado e um novo será vinculado ao projeto!' : 'Deseja vincular o formulário <br/><b>' + formSelecionado.id + '</b> - <b>' + formSelecionado.nome + '</b><br/> ao projeto <br/><b>' + projetoSelecionado.ds_codigo_projeto_erp + '</b> - <b>' + projetoSelecionado.ds_nome + '</b>';
	
	      this.$dialog.confirm(msg, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	        axiosLaravel.post('formulario/vincula/', { 'idFormularioCadastrado': idFormulario, 'numeroProjeto': vm.projetoSelecionadoEnvioManual[idFormulario]['ds_codigo_projeto_erp'] }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this6.carregarProcessosPreenchimentoPorFormulario(idFormulario);
	            _this6.loading.tela = false;
	            _this6.projetoSelecionadoEnvioManual[idFormulario] = null;
	          } else {
	            _this6.aviso(response.data);
	          }
	        }).catch(function (error) {
	          _this6.loading.tela = false;
	          _this6.$root.trataErro(error);
	        });
	      }).catch(function () {
	        _this6.loading.tela = false;
	        console.log('Cancelou a vinculação do formulário ao projeto');
	      });
	    },
	    abreFormulario: function abreFormulario(chave) {
	      window.open(location.protocol + '//' + location.host + '/formulario/' + chave, '_blank');
	    },
	    cancelaProcessoPreenchimento: function cancelaProcessoPreenchimento(row) {
	      var _this7 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.put('formulario/processo/' + row.item.processo.id + '/cancelar/').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var idFormCadastrado = _.findKey(_this7.detalhamentoFormulario, function (detalhamentos) {
	            return _.find(detalhamentos.listaProjetosVinculadosFormulario, function (formVinculado) {
	              return formVinculado.fk_processo === row.item.processo.id;
	            });
	          });
	          _this7.notificacaoDeFormCadastrado('preenchido', row.item.id, { acao: 'FORMULARIO_CANCELADO', valor: null });
	          _this7.carregarProcessosPreenchimentoPorFormulario(idFormCadastrado);
	        }
	        _this7.loading.tela = false;
	      }).catch(function (error) {
	        _this7.loading.tela = false;
	        _this7.$root.trataErro(error);
	      });
	    },
	    copiaUrl: function copiaUrl(row) {
	      var _this8 = this;
	
	      var link = row.item['link_externo'] || _.split(row.item.link_acesso, '-')[0];
	      var linkCompleto = location.protocol + '//' + location.host + '/form/' + link;
	      navigator.clipboard.writeText(linkCompleto).then(function () {
	        _.set(row, 'item.link_copia', { classe: 'label label-success', msg: 'Copiado!' });
	        _this8.$forceUpdate();
	        setTimeout(function () {
	          _.unset(row, 'item.link_copia');_this8.$forceUpdate();
	        }, 2000);
	      }).catch(function (err) {
	        _.set(row, 'item.link_copia', { classe: 'label label-danger', msg: 'Erro: ' + err });
	        _this8.$forceUpdate();
	      });
	    },
	    exportarExcel: function exportarExcel(lista) {
	      var _this9 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('formulario/completo/', { 'lista': _.map(lista, 'fk_processo') }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var planilhaPrincipal = [];
	          response.data.retorno.listaFormulariosPrincipais.forEach(function (form) {
	            var formularioTemp = {};
	
	            _.set(formularioTemp, 'ID Processo', form['fk_processo']);
	
	            _.set(formularioTemp, 'Nr Projeto', form['processo']['nome'] === 'AVALIACAO_PROJETO' ? form['processo']['documentos_liberacao'][0]['numero'] : null);
	            form.formulario.forEach(function (controle) {
	              if (_.includes(['CONTROLE', 'PERSONALIZADO'], controle.grupo)) {
	                if (!_.isNull(controle.valor)) {
	                  if (controle.elemento === 'UF_MUNICIPIO' && _.has(controle.valor, 'nomcid') && _.has(controle.valor, 'sigufs')) {
	                    controle.valor = controle.valor.nomcid + ' (' + controle.valor.sigufs + ')';
	                  } else if (controle.elemento === 'DATA') {
	                    controle.valor = (0, _moment2.default)(controle.valor).add(1, 'day').format('DD/MM/YYYY');
	                  } else if (controle.elemento === 'PERIODO' && _.has(controle.valor, 'inicio') && _.has(controle.valor, 'termino')) {
	                    controle.valor = (0, _moment2.default)(controle.valor.inicio).format('DD/MM/YYYY') + ' - ' + (0, _moment2.default)(controle.valor.termino).format('DD/MM/YYYY');
	                  } else if (controle.elemento === 'LIKERT' && _.values(controle.valor).length > 0) {
	                    _.forEach(controle.valor, function (resposta, pergunta) {
	                      _.set(formularioTemp, [('' + pergunta).replace(/(<([^>]+)>)/ig, '')], resposta);
	                    });
	                  } else if (controle.elemento === 'SELECAO_MULTIPLA') {
	                    controle.valor = _.toString(controle.valor);
	                  }
	                }
	                if (controle.elemento !== 'LIKERT') {
	                  _.set(formularioTemp, [('' + controle.titulo).replace(/(<([^>]+)>)/ig, '')], controle.valor);
	                }
	              }
	            });
	            planilhaPrincipal.push(formularioTemp);
	          });
	          var principal = XLSX.utils.json_to_sheet(planilhaPrincipal);
	
	          var wb = XLSX.utils.book_new();
	          XLSX.utils.book_append_sheet(wb, principal, 'Formulario Principal');
	          response.data.retorno.subformularios.forEach(function (subForm) {
	            var planilhaSubForm = XLSX.utils.json_to_sheet(subForm.preenchido);
	            var tituloPlanilhaSubForm = subForm.titulo.substring(0, 30);
	            tituloPlanilhaSubForm = _.isNull(tituloPlanilhaSubForm) ? tituloPlanilhaSubForm : ('' + tituloPlanilhaSubForm).replace(/(<([^>]+)>)/ig, '');
	            XLSX.utils.book_append_sheet(wb, planilhaSubForm, tituloPlanilhaSubForm);
	          });
	
	          var dados = [{ 'Registro': 'ID do formulário', 'Informação': response.data.retorno.listaFormulariosPrincipais[0]['fk_formulario'] }, { 'Registro': 'Quem gerou a planilha', 'Informação': _this9.usuarioLogado.userName }, { 'Registro': 'Quando foi gerada', 'Informação': Date(Date.now()).toString() }, { 'Registro': 'Autenticação', 'Informação': response.data.retorno.autenticacao }];
	          var extracao = XLSX.utils.json_to_sheet(dados);
	          XLSX.utils.book_append_sheet(wb, extracao, 'Extração');
	          XLSX.writeFile(wb, 'Preenchimentos_formulario_id_' + response.data.retorno.listaFormulariosPrincipais[0]['fk_formulario'] + '.xlsx');
	        } else {
	          _this9.$snotify.error(response.data.mensagem);
	        }
	        _this9.loading.tela = false;
	      }).catch(function (error) {
	        _this9.$snotify.clear();
	        _this9.$root.trataErro(error);
	        _this9.loading.tela = false;
	      });
	    },
	    alteraConfiguracaoFormulario: function alteraConfiguracaoFormulario(item, alteracoes) {
	      var _this10 = this;
	
	      var itemBackup = _.cloneDeep(item);
	      _.forEach(alteracoes, function (v, k) {
	        _.set(item, k, v);
	      });
	      this.loading.tela = true;
	      axiosLaravel.post('formulario/salva/', item).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'ERRO') {
	          _.remove(_this10.formularios, function (f) {
	            return f.id === item.id;
	          });
	          _this10.formularios.push(itemBackup);
	          _this10.$forceUpdate();
	          _this10.aviso(response.data);
	        } else {
	          _this10.notificacaoDeFormCadastrado('cadastro', item.id, { acao: 'SITUACAO_FORMULARIO_CADASTRO_ALTERADA', valor: item.situacao });
	        }
	        _this10.loading.tela = false;
	      }).catch(function (error) {
	        _this10.$root.trataErro(error);
	        _this10.loading.tela = false;
	      });
	    },
	    aviso: function aviso(retorno) {
	      var _this11 = this;
	
	      if (_.has(retorno, 'codigo')) {
	        var mensagens = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : ['Erro de processamento. Não sei o que houve'];
	        mensagens.forEach(function (msg) {
	          if (retorno.codigo === 'ERRO') {
	            _this11.$snotify.error(msg);
	          } else if (_.includes(['OK', 'AVISO'], retorno.codigo)) {
	            _this11.$snotify.success(msg);
	          }
	        });
	      }
	    },
	    filtroPorItem: function filtroPorItem(row, filter) {
	      var saida = true;
	      if (filter !== 'retornar_todos_registros') {
	        var termos = _.split(_.toLower(filter), ' ');
	        termos.forEach(function (termo) {
	          saida = saida && (_.toLower(row.nome).indexOf(termo) !== -1 || _.toLower(row.tipo).indexOf(termo) !== -1 || _.toLower(row.id).indexOf(termo) !== -1 || _.toLower(row.situacao).indexOf(termo) !== -1 || _.toLower(_.join(_.map(row.opcoes.vinculo.programas, 'descricao'), ' | ')).indexOf(termo) !== -1);
	        });
	      }
	      return saida;
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.tabelaFormularios.totalRows = filteredItems.length;
	      this.tabelaFormularios.currentPage = 1;
	    },
	    ajustaPesquisa: function ajustaPesquisa() {
	      this.tabelaFormularios.filter = _.isNull(this.pesquisa) || this.pesquisa === '' ? 'retornar_todos_registros' : this.pesquisa;
	    }
	  }
	};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditaFormulario',
	  data: function data() {
	    return {
	      quillOptionsTitulo: {
	        modules: {
	          toolbar: [['italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'color': [] }, { 'background': [] }], ['video', 'image'], ['clean']]
	        },
	        placeholder: 'Informe o tílulo',
	        theme: 'bubble',
	        readonly: false
	      },
	      quillOptionsCompleto: {
	        theme: 'bubble'
	      },
	
	      loading: {
	        tela: false,
	        componentes: false,
	        programas: false
	      },
	      mostrarTitulo: true,
	      mostrarComponentes: true,
	      salvaFormulario: {
	        salvamentoAutomaticoAtivo: false,
	        statusSalvamento: 'AGUARDANDO',
	        idTimerSalvamentoAutomatico: null,
	        tempoSalvamentoAutomatico: 60000,
	        contador: 0
	      },
	      formatoValores: [{ 'elemento': 'NUMERO', 'formatos': [{ 'valor': 'INTEIRO', 'descricao': 'Inteiro' }, { 'valor': 'DECIMAL', 'descricao': 'Decimal' }, { 'valor': 'MOEDA', 'descricao': 'Reais (R$)' }, { 'valor': 'CPF', 'descricao': 'CPF' }, { 'valor': 'CNPJ', 'descricao': 'CNPJ' }, { 'valor': 'TELEFONE', 'descricao': 'Telefone' }, { 'valor': 'CEP', 'descricao': 'CEP' }] }, { 'elemento': 'TEXTO_LONGO', 'formatos': [{ 'valor': 'SOMENTE_TEXTO', 'descricao': 'Somente Texto' }, { 'valor': 'TEXTO_FORMATADO', 'descricao': 'Texto com formatação' }] }, { 'elemento': 'CLASSIFICACAO', 'formatos': [{ 'valor': 'ESTRELA', 'descricao': 'Estrelas' }, { 'valor': 'EMOJI', 'descricao': 'Expressões' }, { 'valor': 'CIRCULO', 'descricao': 'Círculos' }, { 'valor': 'LIKE', 'descricao': 'Gostei' }, { 'valor': 'NUMEROS', 'descricao': 'Círculos Numerados' }] }, { 'elemento': 'LOGOMARCA_FBB', 'formatos': [{ 'valor': 'LOGO_HORIZONTAL', 'descricao': 'Marca FBB' }, { 'valor': 'LOGO_VERTICAL', 'descricao': 'Logo Grande FBB' }] }, { 'elemento': 'SELECAO_SIMPLES', 'formatos': [{ 'valor': 'AUTOCOMPLETE', 'descricao': 'Lista com opção de busca' }, { 'valor': 'NORMAL', 'descricao': 'Lista simples' }] }, { 'elemento': 'SECAO', 'formatos': [{ 'valor': 'PADRAO', 'descricao': 'Padrão: Título com fundo cinza' }, { 'valor': 'SIMPLES', 'descricao': 'Simples: Linha sobre título' }, { 'valor': 'OCULTO', 'descricao': 'Oculto: Só linha sem título' }] }, { 'elemento': 'SUB_FORMULARIO', 'formatos': [{ 'valor': 'COMPLETO_COM_LINK', 'descricao': 'Completo Com link', 'info': 'Pode ver, alterar, incluir e excluir qualquer dado diretamente e tem link para acesso externo' }, { 'valor': 'COMPLETO_SEM_LINK', 'descricao': 'Completo Sem link', 'info': 'Pode ver, alterar, incluir e excluir qualquer dado diretamente somente para usuários do SGP' }, { 'valor': 'VISUALIZACAO_COM_LINK', 'descricao': 'Visualização Com link', 'info': 'Pode ver todo o conteúdo do sub formulário e tem link para acesso externo' }, { 'valor': 'VISUALIZACAO_SEM_LINK', 'descricao': 'Visualização Sem link', 'info': 'Pode ver todo o conteúdo do sub formulário somente para usuários do SGP' }, { 'valor': 'MINIMO_COM_LINK', 'descricao': 'Mínimo Com link', 'info': 'Pode ver somente as colunas selecionadas deste sub formulário e tem link para acesso externo' }, { 'valor': 'MINIMO_SEM_LINK', 'descricao': 'Mínimo Sem link', 'info': 'Pode ver somente as colunas selecionadas deste sub formulário para usuários do SGP' }, { 'valor': 'SOMENTE_LINK', 'descricao': 'Só link', 'info': 'Há somente o link de acesso ao sub formulário assim qualquer um (usuário do SGP ou não) terá acesso ao formulário' }] }],
	      colunaParaAdicionarSubFormulario: null,
	      programasSociais: [],
	      dados: [],
	      pesquisa: {
	        termo: '',
	        personalizado: false,
	        formulario: false
	      },
	      ehVisualizacao: false,
	      controles: [],
	      formularioCarregado: {
	        id: null,
	        nome: '',
	        tipo: '',
	        link_acesso: '',
	        formulario: [],
	        fk_criacao: null,
	        fk_processo: null,
	        opcoes: {
	          bi: true,
	          vinculo: {
	            programas: []
	          },
	          elemento_chave: null,
	          abrir: { acao: 'FORMULARIO_NORMAL' },
	          concluir: { acao: 'SAIR_FORMULARIO', parametro: null },
	          numeracao: null,
	          observacao: null,
	          historico: null
	        },
	        situacao: '',
	        cadastro: null
	      },
	      formularioCarregadoTemp: {},
	      editandoFormulario: [],
	      editandoColunaSubFormulario: {},
	      editandoElemento: null,
	      dragging: false,
	      tipoFormulario: [{ codigo: 'AVALIACAO_APROVACAO', descricao: 'Marco zero' }, { codigo: 'AVALIACAO_ENCERRAMENTO', descricao: 'Marco um' }, { codigo: 'AVALIACAO_GENERICO', descricao: 'Genérico' }, { codigo: 'AVALIACAO_PARTICIPANTE', descricao: 'Participante' }],
	      acoesAposAbrir: [{ codigo: 'FORMULARIO_NORMAL', descricao: 'Normal', info: 'Todos os botões de acordo com a regra atual' }, { codigo: 'FORCA_SOMENTE_LEITURA', descricao: 'Só leitura', info: 'Modo de visualização sem botão algum' }],
	      acoesAposConcluir: [{ codigo: 'SAIR_FORMULARIO', descricao: 'Sai da tela' }, { codigo: 'ABRIR_FORMULARIO', descricao: 'Abre o formulário' }, { codigo: 'ABRIR_URL', descricao: 'Vai para o endereço' }],
	      opcoesNumeracaoAutomatica: [{ codigo: null, descricao: 'Não numerar' }, { codigo: 'INTEIROS', descricao: 'Números inteiros' }, { codigo: 'ROMANOS', descricao: 'Números romanos' }],
	      opcoesHistorico: [{ codigo: null, descricao: 'Não mostrar' }, { codigo: 'SOMENTE_FBB', descricao: 'Mostrar só para FBB' }, { codigo: 'TODOS', descricao: 'Todos veem' }],
	      opcoesObservacao: [{ codigo: null, descricao: 'Não mostrar' }, { codigo: 'SOMENTE_FBB', descricao: 'Disponível para FBB' }, { codigo: 'TODOS', descricao: 'Disponível para todos' }],
	      icones: { 'TEXTO_SIMPLES': 'fa-text-width', 'TEXTO_LONGO': 'fa-file-text-o', 'SELECAO_SIMPLES': 'fa-list', 'SELECAO_MULTIPLA': 'fa-indent', 'NUMERO': 'fa-numero', 'BOOLEANO': 'fa-dot-circle-o', 'CLASSIFICACAO': 'fa-star', 'DATA': 'fa-calendar', 'PERIODO': 'fa-arrows-h', 'NPS': 'fa-thumbs-o-up', 'LIKERT': 'fa-server', 'UF_MUNICIPIO': 'fa-map-marker', 'TEXTO_FIXO': 'fa-font', 'SECAO': 'fa-credit-card', 'LINHA_HORIZONTAL': 'fa-minus', 'LOGOMARCA_FBB': 'fa-minus-square', 'AVALIACAO_GENERICO': 'fa-list-alt', 'AVALIACAO_PARTICIPANTE': 'fa-male', 'INTEIRO': 'fa-inteiro', 'MOEDA': 'fa-dollar', 'DECIMAL': 'fa-decimal', 'TELEFONE': 'fa-phone', 'CPF': 'fa-user', 'CNPJ': 'fa-industry', 'CEP': 'fa-map-signs' },
	      gruposControles: { 'PERSONALIZADO': 'Questões fixas', 'CONTROLE': '+Adicionar nova', 'LAYOUT': 'Layout', 'FORMULARIO': 'Subformulários' },
	      alturaContentWrapper: window.innerHeight - 151
	    };
	  },
	
	  watch: {
	    'pesquisa.personalizado': function pesquisaPersonalizado() {
	      this.filtrar();
	      this.$refs['pesquisaControle'].focus();
	    },
	    'pesquisa.formulario': function pesquisaFormulario() {
	      this.filtrar();
	      this.$refs['pesquisaControle'].focus();
	    },
	    editandoFormulario: function editandoFormulario() {
	      this.numeracaoAutomatica();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  created: function created() {
	    this.formularioCarregado.id = this.$route.params.id;
	    this.ehVisualizacao = this.$route.params.visualizacao || false;
	    if (!_.isNull(this.formularioCarregado.id)) {
	      this.carregaFormulario();
	    } else {
	      this.carregaControles();
	    }
	    this.salvamentoAutomatico();
	    this.carregaProgramas();
	    var vm = this;
	    window.addEventListener('resize', function () {
	      vm.mostrarTitulo = vm.mostrarTitulo && window.innerHeight - 180 > 400;
	      vm.alturaContentWrapper = window.innerHeight - 151;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.salvaFormulario.idTimerSalvamentoAutomatico);
	  },
	
	  methods: {
	    carregaFormulario: function carregaFormulario() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('formulario/edita/' + this.formularioCarregado.id).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this.formularioCarregado = response.data.retorno;
	          _this.editandoFormulario = _.isNull(_this.formularioCarregado.formulario) ? [] : _.cloneDeep(_this.formularioCarregado.formulario);
	          _this.salvaFormulario.salvamentoAutomaticoAtivo = true;
	          _this.salvaFormulario.contador = 1;
	          _this.formularioCarregadoTemp = _.cloneDeep(_this.formularioCarregado);
	          _this.carregaControles();
	        } else {
	          _this.aviso(response.data);
	          _this.$router.go(-1);
	        }
	        _this.loading.tela = false;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.tela = false;
	      });
	    },
	    carregaProgramas: function carregaProgramas() {
	      var _this2 = this;
	
	      this.loading.programas = true;
	      axiosLaravel.get('categorizadores').then(function (response) {
	        var demais = _.filter(response.data, ['grupo', 'PROGRAMA']);
	        var atuais = _.remove(demais, function (p) {
	          return _.includes([16, 17, 18, 20, 21], p.id);
	        });
	        _this2.programasSociais = _.union(atuais, [{ id: '', descricao: '', $isDisabled: true }], demais);
	        _this2.loading.programas = false;
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.loading.programas = false;
	      });
	    },
	    carregaControles: function carregaControles() {
	      var _this3 = this;
	
	      this.loading.componentes = true;
	      axiosLaravel.get('formulario/componentes').then(function (response) {
	        _this3.controles = response.data;
	        _this3.loading.componentes = false;
	        _this3.carregaOutrosFormularios();
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.loading.componentes = false;
	      });
	    },
	    carregaOutrosFormularios: function carregaOutrosFormularios() {
	      var _this4 = this;
	
	      this.loading.componentes = true;
	      var vm = this;
	      axiosLaravel.get('formulario/lista/completo').then(function (response) {
	        var formsAtivos = _.filter(response.data, function (f) {
	          return f.situacao === 'Ativo' && _.includes(['AVALIACAO_GENERICO', 'AVALIACAO_PARTICIPANTE'], f.tipo) && f.id !== vm.formularioCarregado.id;
	        });
	
	        formsAtivos.forEach(function (formulario) {
	          var subformulario = _.isNull(formulario.formulario) ? [] : formulario.formulario;
	          if (subformulario.length > 0) {
	            var colunas = [];
	            subformulario.every(function (elemento) {
	              if (_.includes(['NUMERO', 'TEXTO_SIMPLES', 'DATA'], elemento.elemento)) {
	                colunas.push({ key: elemento.id, label: _this4.removerTagHtmlString(elemento.titulo), thStyle: 'text-align: center', sortable: true, 'class': 'text-center' });
	              }
	              return colunas.length <= 3;
	            });
	            colunas.push({ key: 'actions', label: 'Ações', thStyle: 'text-align: center', sortable: true, 'class': 'text-center' });
	
	            var conteudo = _.clone({ colunas: colunas, formulario: subformulario, tipo: formulario.tipo, currentPage: 1, perPage: 10, totalRows: 1, sortBy: colunas[0]['key'], sortDesc: true, bordered: true, filter: null });
	
	            _this4.controles.push({
	              'grupo': 'FORMULARIO',
	              'elemento': 'SUB_FORMULARIO',
	              'titulo': formulario.nome,
	              'descricao': _.find(_this4.tipoFormulario, ['codigo', formulario.tipo])['descricao'],
	              'informacao': formulario.nome,
	              'bi': null,
	              'mostrar': true,
	              'obrigatorio': true,
	              'valor': [{ 'actions': '...' }],
	              'configuracao': {
	                'minimo': null,
	                'maximo': null,
	                'padrao': _.split(formulario['link_acesso'], '-'),
	                'formato': 'COMPLETO_COM_LINK',
	                'conteudo': conteudo,
	                'regras': []
	              }
	            });
	          }
	        });
	        _this4.$forceUpdate();
	        _this4.loading.componentes = false;
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	        _this4.loading.componentes = false;
	      });
	    },
	    salvamentoAutomatico: function salvamentoAutomatico() {
	      var _this5 = this;
	
	      this.salvaFormulario.idTimerSalvamentoAutomatico = setInterval(function () {
	        if (_this5.salvaFormulario.salvamentoAutomaticoAtivo && _this5.salvaFormulario.contador > 0 && !_.isEqual(_this5.formularioCarregadoTemp, _this5.formularioCarregado)) {
	          _this5.salvarEdicao();
	        }
	      }, this.salvaFormulario.tempoSalvamentoAutomatico);
	    },
	    salvarEdicao: function salvarEdicao() {
	      var _this6 = this;
	
	      var redirecionarChave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.errors.remove('edicao_formulario');
	      if (this.errors.items.length === 0) {
	        this.$validator.validateAll().then(function (validado) {
	          if (_this6.editandoFormulario.length === 0) {
	            _this6.errors.add({ field: 'edicao_formulario', rule: 'form_vazio', msg: 'Não pode criar nem salvar um formulário sem elemento algum' });
	          }
	          if (validado && _this6.errors.items.length === 0) {
	            _.set(_this6.formularioCarregado, 'formulario', _.clone(_this6.editandoFormulario));
	            _this6.salvaFormulario.statusSalvamento = 'PROCESSANDO';
	            var rota = _.isNull(_this6.formularioCarregado.id) ? 'formulario/cria/' : 'formulario/salva/';
	            _this6.loading.tela = !_.isNull(redirecionarChave);
	
	            axiosLaravel.post(rota, _this6.formularioCarregado).then(function (response) {
	              if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	                ['id', 'nome', 'tipo', 'situacao', 'opcoes'].forEach(function (p) {
	                  _.set(_this6.formularioCarregado, p, _.get(response.data.retorno, p));
	                });
	                _this6.salvaFormulario.statusSalvamento = 'FEITO';
	                setTimeout(function () {
	                  _this6.salvaFormulario.statusSalvamento = 'AGUARDANDO';
	                  _this6.salvaFormulario.salvamentoAutomaticoAtivo = true;
	                  _this6.salvaFormulario.contador++;
	                  console.log('salvamento feito! contador', _this6.salvaFormulario.contador);
	                }, 2000);
	                _this6.formularioCarregadoTemp = _.cloneDeep(_this6.formularioCarregado);
	                if (!_.isNull(redirecionarChave)) {
	                  window.open(location.protocol + '//' + location.host + '/formulario/' + redirecionarChave, '_blank');
	                }
	              } else {
	                _this6.aviso(response.data);
	              }
	              _this6.loading.tela = false;
	            }).catch(function (error) {
	              _this6.$root.trataErro(error);
	              _this6.salvaFormulario.statusSalvamento = 'ERRO';
	            });
	          } else {
	            _this6.mostrarTitulo = true;
	            _this6.$refs[_.get(_.head(_this6.errors.items), 'field')].scrollIntoView({ block: 'start', behavior: 'smooth' });
	          }
	        });
	      } else {
	        this.mostrarTitulo = true;
	        this.$refs[_.get(_.head(this.errors.items), 'field')].scrollIntoView({ block: 'start', behavior: 'smooth' });
	      }
	    },
	    abreFormulario: function abreFormulario(chave) {
	      this.salvarEdicao(chave);
	    },
	    aviso: function aviso(retorno) {
	      var _this7 = this;
	
	      if (_.has(retorno, 'codigo')) {
	        var mensagens = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : ['Erro de processamento. Não sei o que houve'];
	        mensagens.forEach(function (msg) {
	          if (retorno.codigo === 'ERRO') {
	            _this7.$snotify.error(msg);
	          } else if (_.includes(['OK', 'AVISO'], retorno.codigo)) {
	            _this7.$snotify.success(msg, { timeout: 3000 });
	          }
	        });
	      }
	    },
	    adicionaControle: function adicionaControle(controle) {
	      if (!_.find(this.editandoFormulario, ['id', controle.bi])) {
	        this.editandoFormulario.push(this.clonarControle(controle));
	      }
	    },
	    removeElemento: function removeElemento(idx) {
	      this.editandoFormulario.splice(idx, 1);
	      this.editandoElemento = null;
	    },
	    duplicaElemento: function duplicaElemento(idx, controle) {
	      var controleDuplicado = this.clonarControle(controle);
	      this.editandoFormulario.splice(idx, 0, controleDuplicado);
	    },
	    moveElemento: function moveElemento(idx, passo, lista) {
	      var elemento = lista[idx];
	      lista.splice(idx, 1);
	      lista.splice(idx + passo, 0, elemento);
	    },
	    clonarControle: function clonarControle(controle) {
	      var controleClonado = _.cloneDeep(controle);
	      var id = _.isNull(controleClonado.bi) ? _.uniqueId(controleClonado.elemento + '-') : controleClonado.bi;
	
	      var repetido = _.find(this.editandoFormulario, ['id', id]);
	      if (repetido) {
	        return undefined;
	      } else {
	        _.set(controleClonado, 'id', id);
	        return controleClonado;
	      }
	    },
	    editaElemento: function editaElemento(idx) {
	      this.editandoElemento = this.editandoFormulario[idx];
	      console.log('editandoElemento idx', idx, this.editandoElemento);
	      this.$refs[this.editandoElemento.id][0].scrollIntoView(true);
	      this.$forceUpdate();
	    },
	    filtrar: function filtrar() {
	      var _this8 = this;
	
	      var lista = _.cloneDeep(this.controles);
	      var termo = _.toLower(this.pesquisa.termo);
	      lista.forEach(function (item) {
	        item.mostrar = true;
	        item.mostrar = _.includes(_.toLower(item.titulo), termo) || _.includes(_.toLower(item.descricao), termo) || _.includes(_.toLower(item.informacao), termo);
	        if (_this8.pesquisa.personalizado && item.grupo !== 'PERSONALIZADO') {
	          item.mostrar = item.mostrar && _this8.pesquisa.formulario && item.grupo === 'FORMULARIO';
	        }
	        if (_this8.pesquisa.formulario && item.grupo !== 'FORMULARIO') {
	          item.mostrar = item.mostrar && _this8.pesquisa.personalizado && item.grupo === 'PERSONALIZADO';
	        }
	      });
	      this.controles = lista;
	    },
	    mostraOcultaElemento: function mostraOcultaElemento(idx) {
	      var _this9 = this;
	
	      var verificacaoSessao = this.elementosSecao(idx);
	      if (this.editandoFormulario[idx].elemento === 'SECAO') {
	        verificacaoSessao.forEach(function (elemento) {
	          elemento.mostrar = !_this9.editandoFormulario[idx].mostrar;
	        });
	        this.editandoFormulario[idx].mostrar = !this.editandoFormulario[idx].mostrar;
	      } else {
	        this.editandoFormulario[idx].mostrar = _.isNull(verificacaoSessao) || verificacaoSessao.mostrar ? !this.editandoFormulario[idx].mostrar : false;
	      }
	    },
	    elementosSecao: function elementosSecao(idx) {
	      var lista = [];
	      if (this.editandoFormulario[idx].elemento === 'SECAO') {
	        for (var i = idx + 1; i < this.editandoFormulario.length; i++) {
	          if (this.editandoFormulario[i].elemento === 'SECAO') break;
	          lista.push(this.editandoFormulario[i]);
	        }
	      } else {
	        lista = idx - 1 < 0 ? null : _.findLast(this.editandoFormulario, function (n) {
	          return n.elemento === 'SECAO';
	        }, idx - 1) || null;
	      }
	      return lista;
	    },
	    adicionaColunaSubFormulario: function adicionaColunaSubFormulario(idx) {
	      var listaColunas = this.editandoFormulario[idx].configuracao.conteudo.colunas;
	      var colunaNova = { key: this.colunaParaAdicionarSubFormulario.id, label: this.colunaParaAdicionarSubFormulario.informacao, thStyle: 'text-align: center', sortable: true, 'class': 'text-center' };
	      var colunaAcoes = _.head(_.remove(listaColunas, ['key', 'actions']));
	      listaColunas.push(colunaNova);
	      listaColunas.push(colunaAcoes);
	      this.colunaParaAdicionarSubFormulario = null;
	      this.$forceUpdate();
	    },
	    verificaNomeJaExiste: function verificaNomeJaExiste() {
	      var _this10 = this;
	
	      this.errors.remove('nome_existe');
	      axiosLaravel.post('formulario/validacao/duplicidade/nome', { id: this.formularioCarregado.id, nome: this.formularioCarregado.nome }).then(function (response) {
	        if (response.data > 0) {
	          _this10.errors.add({ field: 'nome_existe', msg: 'Este nome já esta sendo usado por um formulário' });
	        }
	      }).catch(function (error) {
	        _this10.$root.trataErro(error);
	      });
	    },
	    removerTagHtmlString: function removerTagHtmlString(str) {
	      return _.isNull(str) ? str : ('' + str).replace(/(<([^>]+)>)/ig, '');
	    },
	    numeracaoAutomatica: function numeracaoAutomatica() {
	      var _this11 = this;
	
	      if (!_.isNull(this.formularioCarregado.opcoes.numeracao)) {
	        var map = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 };
	        var controles = _.filter(this.editandoFormulario, function (c) {
	          return c.grupo !== 'LAYOUT';
	        });
	        controles.forEach(function (controle, idx) {
	          var numeral = idx + 1;
	          if (_this11.formularioCarregado.opcoes.numeracao === 'ROMANOS') {
	            var convertidoRomano = '';
	            _.forEach(map, function (numero, romano) {
	              convertidoRomano += romano.repeat(Math.floor(numeral / numero));
	              numeral %= numero;
	            });
	            _.set(controle, 'numeracao', convertidoRomano);
	          } else {
	            _.set(controle, 'numeracao', '' + numeral);
	          }
	        });
	      }
	    },
	    mover: function mover() {
	      this.numeracaoAutomatica();
	    },
	    fecharEdicao: function fecharEdicao() {
	      this.editandoElemento = null;
	      this.editandoColunaSubFormulario = {};
	    }
	  }
	};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _xlsx = __webpack_require__(144);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _cpfCnpjValidator = __webpack_require__(232);
	
	var _cnpj = __webpack_require__(122);
	
	var _cnpj2 = _interopRequireDefault(_cnpj);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PreencheFormulario',
	  data: function data() {
	    return {
	      quillOptions: {
	        modules: {
	          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'color': [] }, { 'background': [] }], ['video', 'image'], ['clean']],
	          imageResize: {
	            displaySize: true
	          },
	          imageCompress: {
	            quality: 0.7,
	            maxWidth: 800,
	            imageType: 'image/jpeg'
	          }
	        },
	        theme: 'bubble',
	        readonly: false
	      },
	      loading: {
	        tela: false,
	        programas: false,
	        link: false,
	        excluindo: false,
	        duplicidade: null
	      },
	      msgErroPreenchimento: { obrigatorio: 'Este campo é obrigatório', obrigatorios: 'Estes campos são obrigatórios', antes: 'Deve ser igual ou antes da data anterior', depois: 'Deve ser igual ou após a data seguinte' },
	      salvaFormulario: {
	        salvamentoAutomaticoAtivo: false,
	        statusSalvamento: 'AGUARDANDO',
	        idTimerSalvamentoAutomatico: null,
	        tempoSalvamentoAutomatico: 60000,
	        contador: 0
	      },
	      programasSociais: [],
	      acao: null,
	      projeto: null,
	      processo: null,
	      ehAcessoExterno: false,
	      ehSubFormulario: false,
	      municipiosUf: [],
	      formularioBackup: [],
	      formularioPreenchimento: {
	        id: null,
	        origem: '',
	        formulario: [],
	        fk_processo: null
	      },
	      formularioPreenchimentoTemp: {},
	      ultimaTarefa: {
	        nome: 'SOLICITACAO'
	      },
	      aprovacao: {
	        resultadoAprovacao: null,
	        observacao: null
	      },
	      formularioCadastrado: {
	        id: null,
	        nome: '',
	        tipo: '',
	        link_acesso: '',
	        formulario: [],
	        opcoes: {
	          elemento_chave: null,
	          abrir: { acao: 'FORCA_SOMENTE_LEITURA' },
	          concluir: { acao: 'SAIR_FORMULARIO', parametro: null }
	        }
	      },
	      formulario: [],
	      pesquisa: '',
	      editandoElemento: null,
	      dragging: false,
	      numeroAtualizacao: 0,
	      mostrarHistorico: false,
	      tipoFormulario: [{ codigo: 'AVALIACAO_APROVACAO', descricao: 'Marco zero' }, { codigo: 'AVALIACAO_ENCERRAMENTO', descricao: 'Marco um' }, { codigo: 'AVALIACAO_GENERICO', descricao: 'Genérico' }, { codigo: 'AVALIACAO_PARTICIPANTE', descricao: 'Participante' }],
	      nomesTarefas: { 'FEITO': 'Feito', 'CANCELADO': 'Cancelado', 'EM_EXECUCAO': 'Em Execução', 'SOLICITACAO': 'Solicitação', 'ANALISE': 'Análise FBB', 'REVISAO': 'Revisão', 'REABILITA': 'Processo Reabilitado', 'CANCELA': 'Processo Cancelado', 'CONCLUSAO': 'Conclusão' }
	    };
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	
	  created: function created() {
	    this.ehAcessoExterno = _.isNull(this.usuarioLogado);
	    if (!_.isNull(this.$route.params.id)) {
	      this.carregaFormulario();
	    }
	    this.salvamentoAutomatico();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.ehSubFormulario) {
	      this.notificacaoDeFormPreenchimento('sub', this.formularioPreenchimento.id, { acao: 'SUB_FORMULARIO_FECHADO', valor: this.formularioPreenchimento['id_elemento'] });
	      if (!this.ehAcessoExterno) {
	        Echo.leave('formulario.sub.' + this.formularioPreenchimento.id);
	      }
	    } else {
	      this.notificacaoDeFormPreenchimento('preenchido', this.formularioPreenchimento.id, { acao: 'FORMULARIO_FECHADO', valor: null });
	      if (!this.ehAcessoExterno) {
	        Echo.leave('formulario.preenchido.' + this.formularioPreenchimento.id);
	      }
	    }
	    clearInterval(this.salvaFormulario.idTimerSalvamentoAutomatico);
	  },
	
	  methods: {
	    carregaFormulario: function carregaFormulario() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('formulario/acesso/' + this.$route.params.id).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this.acao = response.data.retorno.acao;
	          if (_this.acao === 'inativo') {
	            if (_this.ehAcessoExterno) {
	              alert('Este formulário foi inativado');
	            } else {
	              _this.$snotify.error('Este formulário foi inativado');
	            }
	            _this.$router.replace('/#/inicial');
	          } else {
	            _this.formularioCadastrado = response.data.retorno.formularioCadastrado;
	            _this.processo = _.get(response.data.retorno, 'processo', null);
	            _this.acao = _this.formularioCadastrado.opcoes.abrir.acao === 'FORCA_SOMENTE_LEITURA' || _.has(_this.processo, 'situacao') && _this.processo.situacao !== 'EM_EXECUCAO' ? 'visualizacao' : _this.acao;
	            var edicaoComPreenchimento = _this.acao === 'edicao' && _.has(response.data.retorno, 'formularioPreenchido');
	
	            if (_this.acao === 'novo') {
	              _this.formularioCadastrado = response.data.retorno.formularioCadastrado;
	              if (typeof Storage !== 'undefined') {
	                var formulariosJaAcessadosLocalmente = JSON.parse(window.localStorage.getItem('formularios-sgp'));
	                if (_.isNull(formulariosJaAcessadosLocalmente)) {
	                  window.localStorage.setItem('formularios-sgp', (0, _stringify2.default)([{ cadastro: _this.$route.params.id }]));
	                } else {
	                  _.uniq(formulariosJaAcessadosLocalmente);
	                  var formsCadastrados = _.filter(formulariosJaAcessadosLocalmente, ['cadastro', _this.$route.params.id]);
	                  if (formsCadastrados.length > 0) {
	                    var ultimoPreenchido = _.findLast(formulariosJaAcessadosLocalmente, function (form) {
	                      return _.has(form, 'preenchido');
	                    });
	                    if (ultimoPreenchido && _.has(ultimoPreenchido, 'situacao')) {
	                      if (ultimoPreenchido.situacao === 'concluido') {
	                        alert('Jà concluiu este formulario nesta máquina');
	                        _this.$router.replace('/#/inicial');
	                      } else if (_.includes(['iniciado', 'preenchendo'], ultimoPreenchido.situacao)) {
	                        window.open(location.protocol + '//' + location.host + '/' + (_this.ehAcessoExterno ? 'form' : 'formulario') + '/' + ultimoPreenchido.preenchido, '_self');
	                      } else {
	                        alert('Situacao não prevista para este formulário');
	                        _this.$router.replace('/#/inicial');
	                      }
	                    }
	                  }
	                }
	              }
	            } else {
	              edicaoComPreenchimento = _this.acao === 'edicao' && _.has(response.data.retorno, 'formularioPreenchido');
	              _this.formularioPreenchimento = _.get(response.data.retorno, 'formularioPreenchido', response.data.retorno.formularioCadastrado);
	              _this.projeto = response.data.retorno['projeto'] || null;
	              _this.ehSubFormulario = !_.isNull(_this.formularioPreenchimento['fk_pai']);
	              _this.ultimaTarefa = response.data.retorno.ultimaTarefa || _this.ultimaTarefa;
	              _this.acao = (_this.ehAcessoExterno || _this.usuarioLogado.userType !== 'FUNDACAO') && !_.includes(['SOLICITACAO', 'REVISAO'], _this.ultimaTarefa.nome) ? 'visualizacao' : _this.acao;
	              if (_.isNull(_this.formularioPreenchimento.formulario) || _.isEmpty(_this.formularioPreenchimento.formulario) || _this.formularioPreenchimento.formulario.length === 0) {
	                _this.formularioPreenchimento.formulario = _.cloneDeep(_.isNull(_this.formularioCadastrado.formulario) ? [] : _this.formularioCadastrado.formulario);
	              }
	              _this.formularioPreenchimento['link_acesso'] = _this.$route.params.id;
	              _this.formularioPreenchimento.formulario.forEach(function (controle, idx) {
	                if (controle.elemento === 'SELECAO_MULTIPLA' && _.isNull(controle.valor)) {
	                  controle.valor = [];
	                }
	
	                if (controle.grupo === 'FORMULARIO') {
	                  controle.informacao = '';
	                  _.remove(controle.valor, ['actions', '...']);
	                  if (controle.configuracao.padrao[0].length > 15) {
	                    _this.carregaDadosSubForm(idx, controle.configuracao.padrao[0]);
	                  } else {
	                    _this.loading.link = true;
	                    var base = _this.formularioPreenchimento.id + '|' + controle.configuracao.padrao[0] + '|' + controle.id;
	                    axiosLaravel.post('formulario/link/', { 'texto': base }).then(function (response) {
	                      controle.configuracao.padrao[0] = response.data;
	                      _this.loading.link = false;
	                      _this.carregaDadosSubForm(idx, controle.configuracao.padrao[0]);
	                    }).catch(function (error) {
	                      _this.loading.link = false;
	                      _this.$root.trataErro(error);
	                    });
	                  }
	                }
	              });
	              if (_.find(_this.formularioPreenchimento.formulario, ['elemento', 'UF_MUNICIPIO'])) {
	                var listaMunicipios = [];
	                axiosLaravel.get('formulario/municipios/lista/').then(function (response) {
	                  var listaAgrupada = _.groupBy(response.data, 'sigufs');
	                  _.forEach(listaAgrupada, function (municipios, uf) {
	                    listaMunicipios.push({ 'uf': uf, 'municipios': municipios });
	                  });
	                  _this.municipiosUf = _.sortBy(listaMunicipios, ['uf']);
	                });
	              }
	              _this.formularioBackup = _.cloneDeep(_this.formularioCadastrado.formulario);
	              _this.formularioPreenchimentoTemp = _.cloneDeep(_this.formularioPreenchimento);
	              if (_this.acao === 'edicao') {
	                if (_this.ehSubFormulario) {
	                  var idOuChaveAcesso = _this.formularioPreenchimento['link_acesso'].length > 15 ? _this.formularioPreenchimento['link_acesso'] : _this.formularioPreenchimento.id;
	                  _this.notificacaoDeFormPreenchimento('sub', idOuChaveAcesso, { acao: 'SUB_FORMULARIO_ABERTO', valor: _this.formularioPreenchimento['id_elemento'] });
	                } else {
	                  _this.notificacaoDeFormPreenchimento('preenchido', _this.formularioPreenchimento.id, { acao: 'FORMULARIO_ABERTO', valor: null });
	                }
	              }
	            }
	
	            if (_this.acao === 'impressao') {
	              setTimeout(function () {
	                window.print();
	              }, 500);
	            }
	
	            if (edicaoComPreenchimento) {
	              _this.salvaFormulario.salvamentoAutomaticoAtivo = true;
	              _this.salvaFormulario.contador = 1;
	            }
	          }
	          _this.assinaCanais();
	        } else {
	          _this.aviso(response.data);
	        }
	        _this.loading.tela = false;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.tela = false;
	      });
	    },
	    carregaDadosSubForm: function carregaDadosSubForm(idx, chave) {
	      var _this2 = this;
	
	      axiosLaravel.get('formulario/subform/' + chave).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var saida = [];
	          var subForms = response.data.retorno;
	          subForms.forEach(function (subForm) {
	            var formValores = {};
	            subForm.formulario.forEach(function (elemento) {
	              if (!_.isNull(elemento.valor)) {
	                if (elemento.elemento === 'UF_MUNICIPIO' && _.has(elemento.valor, 'nomcid') && _.has(elemento.valor, 'sigufs')) {
	                  elemento.valor = elemento.valor.nomcid + ' (' + elemento.valor.sigufs + ')';
	                } else if (elemento.elemento === 'DATA') {
	                  elemento.valor = (0, _moment2.default)(elemento.valor).add(1, 'day').format('DD/MM/YYYY');
	                } else if (elemento.elemento === 'PERIODO' && _.has(elemento.valor, 'inicio') && _.has(elemento.valor, 'termino')) {
	                  elemento.valor = (0, _moment2.default)(elemento.valor.inicio).format('DD/MM/YYYY') + ' - ' + (0, _moment2.default)(elemento.valor.termino).format('DD/MM/YYYY');
	                } else if (elemento.elemento === 'LIKERT' && _.values(elemento.valor).length > 0) {
	                  elemento.valor = (0, _stringify2.default)(_.countBy(_.values(elemento.valor))).replaceAll('{', '').replaceAll('}', '').replaceAll('"', '');
	                }
	              }
	              _.set(formValores, elemento.id, _.toString(elemento.valor));
	            });
	            var acessos = _.split(subForm.link_acesso, '-');
	            _.set(formValores, 'idSubFormulario', subForm.id);
	            _.set(formValores, 'idElemento', subForm.id_elemento);
	            _.set(formValores, 'editar', acessos[1]);
	            _.set(formValores, 'visualizar', acessos[2]);
	            _.set(formValores, 'excluir', acessos[3]);
	            saida.push(formValores);
	          });
	          _.set(_this2.formularioPreenchimento.formulario[idx], 'valor', saida);
	        } else {
	          _this2.aviso(response.data);
	        }
	        _this2.assinaCanaisRegistrosSubFormularios(idx);
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    assinaCanaisRegistrosSubFormularios: function assinaCanaisRegistrosSubFormularios(idx) {
	      var _this3 = this;
	
	      if (!this.ehAcessoExterno) {
	        var subFormularios = [];
	        if (idx) {
	          subFormularios.push(this.formularioPreenchimento.formulario[idx]);
	        } else {
	          subFormularios = _.filter(this.formularioPreenchimento.formulario, ['grupo', 'FORMULARIO']);
	        }
	        subFormularios.forEach(function (formulario) {
	          var canalSubFormRegistroNovo = 'formulario.sub.' + formulario.configuracao.padrao[0];
	          window.Echo.channel(canalSubFormRegistroNovo).listen('FormularioEvents', function (notificacao) {
	            var acao = notificacao.mensagem.acao;
	            if (_.includes(['SUB_FORMULARIO_ABERTO', 'SUB_FORMULARIO_SALVANDO'], acao)) {
	              var chaveAcessoFormulario = notificacao.id;
	              var _idx = _.findIndex(_this3.formularioPreenchimento.formulario, ['configuracao.padrao.0', chaveAcessoFormulario]);
	              var controle = _this3.formularioPreenchimento.formulario[_idx];
	              controle.informacao = acao === 'SUB_FORMULARIO_ABERTO' ? 'Registro novo iniciado!' : acao === 'SUB_FORMULARIO_SALVANDO' ? 'Atualizando...' : '';
	              setTimeout(function () {
	                controle.informacao = '';
	                _this3.numeroAtualizacao += 1;
	              }, 2000);
	              if (acao === 'SUB_FORMULARIO_SALVANDO') {
	                _this3.carregaDadosSubForm(_idx, chaveAcessoFormulario);
	              }
	            }
	          });
	
	          _.map(formulario.valor, 'idSubFormulario').forEach(function (idSubFormPreenchido) {
	            var canalSubForm = 'formulario.sub.' + idSubFormPreenchido;
	            window.Echo.channel(canalSubForm).listen('FormularioEvents', function (notificacao) {
	              var acao = notificacao.mensagem.acao;
	              var idFormulario = notificacao.id;
	              var idElemento = notificacao.mensagem.valor;
	              if (!_.isNull(idElemento)) {
	                var _idx2 = _.findIndex(_this3.formularioPreenchimento.formulario, ['id', idElemento]);
	                var controle = _this3.formularioPreenchimento.formulario[_idx2];
	                var registro = _.find(controle.valor, ['idSubFormulario', idFormulario]);
	                if (registro) {
	                  if (acao === 'SUB_FORMULARIO_ABERTO') {
	                    _.set(registro, '_rowVariant', 'form-aberto');
	                  } else if (acao === 'SUB_FORMULARIO_FECHADO') {
	                    _.set(registro, '_rowVariant', 'form-fechando');
	                    setTimeout(function () {
	                      _.unset(registro, '_rowVariant');
	                      _this3.numeroAtualizacao += 1;
	                    }, 4000);
	                  } else if (acao === 'SUB_FORMULARIO_SALVANDO') {
	                    _.set(registro, '_rowVariant', 'form-salvando');
	                    controle.informacao = 'Atualizando...';
	                    _this3.carregaDadosSubForm(_idx2, controle.configuracao.padrao[0]);
	                    setTimeout(function () {
	                      _.set(registro, '_rowVariant', 'form-aberto');
	                      controle.informacao = '';
	                      _this3.numeroAtualizacao += 1;
	                    }, 2000);
	                  } else if (acao === 'SUB_FORMULARIO_EDITANDO') {
	                    var andamento = _.get(form, 'andamento');
	                    _.set(registro, 'andamento', 'Preenchendo...');
	                    setTimeout(function () {
	                      _.set(registro, 'andamento', andamento);
	                      _this3.numeroAtualizacao += 1;
	                    }, 800);
	                  } else if (acao === 'PERCENTUAL_PREENCHIDO') {
	                    _.set(registro, 'andamento', notificacao.mensagem.percentagem);
	                  }
	                  _this3.numeroAtualizacao += 1;
	                }
	              }
	            });
	          });
	        });
	      }
	    },
	    salvamentoAutomatico: function salvamentoAutomatico() {
	      var _this4 = this;
	
	      this.salvaFormulario.idTimerSalvamentoAutomatico = setInterval(function () {
	        if (_this4.salvaFormulario.salvamentoAutomaticoAtivo && _this4.salvaFormulario.contador > 0 && !_.isNull(_this4.formularioPreenchimento.id) && !_.isEqual(_this4.formularioPreenchimentoTemp, _this4.formularioPreenchimento)) {
	          _this4.salvarPreenchimento(false);
	        }
	      }, this.salvaFormulario.tempoSalvamentoAutomatico);
	    },
	    validaConclusao: function validaConclusao() {
	      var _this5 = this;
	
	      if (_.isNull(this.loading.duplicidade) && this.errors.items.length === 0) {
	        this.$validator.validateAll().then(function (validado) {
	          if (!_.isNull(_this5.formularioCadastrado.opcoes.elemento_chave)) {
	            _this5.validacaoElementoChave(_this5.formularioCadastrado.opcoes.elemento_chave);
	          }
	          _this5.formularioPreenchimento.formulario.forEach(function (controle, idx) {
	            if (_.has(controle.configuracao, 'formato') && _.includes(['CPF', 'CNPJ'], controle.configuracao.formato)) {
	              _this5.validaCpfCnpj(idx);
	            }
	          });
	          if (validado && _this5.errors.items.length === 0) {
	            _this5.loading.tela = true;
	
	            _this5.formularioPreenchimento.formulario.forEach(function (controle, idx) {
	              if (controle.grupo === 'FORMULARIO' && controle.configuracao.padrao[0].length === 15) {
	                _this5.carregaDadosSubForm(idx, controle.configuracao.padrao[0]);
	              }
	            });
	
	            var formsParticipantes = _.filter(_this5.formularioPreenchimento.formulario, function (controle) {
	              return controle.grupo === 'FORMULARIO' && controle.configuracao.conteudo.tipo === 'AVALIACAO_PARTICIPANTE';
	            });
	            if (_.includes(['SOLICITACAO', 'REVISAO'], _this5.ultimaTarefa.nome)) {
	              if (!_.isNull(_this5.projeto) && formsParticipantes.length > 0) {
	                var participantesProjeto = _.sumBy(_this5.projeto['publicos_alvo'], 'nr_participantes_diretos');
	                if (participantesProjeto > 0) {
	                  var totalRegistradoSubFormsParticipante = _.sumBy(formsParticipantes, 'valor.length');
	                  var percentualRegistradoSobreContratado = participantesProjeto === 0 ? 0 : totalRegistradoSubFormsParticipante / participantesProjeto;
	
	                  var intervaloConfianca = 0.95;
	                  var margemErro = 0.05;
	                  var distribuicao = 50;
	                  var populacao = participantesProjeto;
	                  var Y = void 0,
	                      Real1 = void 0,
	                      Real2 = void 0,
	                      variavelPadronizadaPorNivelSignificancia = void 0;
	                  var PN = [0, -0.322232431088, -1.0, -0.342242088547, -0.0204231210245, -0.453642210148E-4];
	                  var QN = [0, 0.0993484626060, 0.588581570495, 0.531103462366, 0.103537752850, 0.38560700634E-2];
	                  var Pr = 0.5 - intervaloConfianca / 2;
	                  if (Pr <= 1.0E-8) variavelPadronizadaPorNivelSignificancia = 6;else {
	                    if (Pr === 0.5) variavelPadronizadaPorNivelSignificancia = 0;else {
	                      Y = Math.sqrt(Math.log(1.0 / Math.pow(Pr, 2)));
	                      Real1 = PN[5];
	                      Real2 = QN[5];
	                      for (var i = 4; i >= 1; i--) {
	                        Real1 = Real1 * Y + PN[i];
	                        Real2 = Real2 * Y + QN[i];
	                      }
	                      variavelPadronizadaPorNivelSignificancia = Y + Real1 / Real2;
	                    }
	                  }
	                  var dividendo = Math.pow(variavelPadronizadaPorNivelSignificancia, 2) * distribuicao * (100.0 - distribuicao);
	                  var divisor = (populacao - 1.0) * Math.pow(margemErro * 100, 2) + dividendo;
	                  var tamanhoAmostraMinimo = divisor > 0.0 ? Math.ceil(populacao * dividendo / divisor) : 0;
	                  if (totalRegistradoSubFormsParticipante < tamanhoAmostraMinimo) {
	                    var vm = _this5;
	                    _this5.$dialog.confirm('<b>' + participantesProjeto + '</b> foram previstos na contratação deste projeto<br/><br/>' + '<b>' + tamanhoAmostraMinimo + '</b> participantes é o mínimo esperado para esta avaliação<br/><br/>' + '<b>' + totalRegistradoSubFormsParticipante + '</b> participantes foram registrados nesta avaliação, até agora<br/><br/>' + 'Deseja concluir mesmo assim e enviar este formulário para a Fundação BB?', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	                      vm.salvarPreenchimento(true);
	                    }).catch(function () {
	                      vm.loading.tela = false;
	                    });
	                  }
	                } else {
	                  _this5.salvarPreenchimento(true);
	                }
	              } else {
	                _this5.salvarPreenchimento(true);
	              }
	            } else {
	              _this5.salvarPreenchimento(true);
	            }
	          } else {
	            var elementoErro = _this5.$refs[_.join(_.split(_.get(_.head(_this5.errors.items), 'field'), '-', 2), '-')];
	            elementoErro = _.isArray(elementoErro) ? elementoErro[0] : elementoErro;
	            elementoErro.scrollIntoView();
	          }
	        });
	      } else {
	        var elementoErro = this.$refs[_.join(_.split(_.get(_.head(this.errors.items), 'field'), '-', 2), '-')];
	        elementoErro = _.isArray(elementoErro) ? elementoErro[0] : elementoErro;
	        elementoErro.scrollIntoView();
	      }
	    },
	    salvarPreenchimento: function salvarPreenchimento(concluirEtapa) {
	      var _this6 = this;
	
	      this.loading.tela = concluirEtapa;
	      this.salvaFormulario.statusSalvamento = 'PROCESSANDO';
	      axiosLaravel.post('formulario/id/' + this.$route.params.id + '/' + (this.ehAcessoExterno ? 'salva' : 'salvar') + '/', { 'id': this.formularioPreenchimento.id, 'formulario': this.formularioPreenchimento.formulario, 'link_acesso': this.$route.params.id }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          if (_this6.ehSubFormulario) {
	            var idOuChaveAcesso = _this6.formularioPreenchimento['link_acesso'].length > 15 ? _this6.formularioPreenchimento['link_acesso'] : _this6.formularioPreenchimento.id;
	            _this6.notificacaoDeFormPreenchimento('sub', idOuChaveAcesso, { acao: 'SUB_FORMULARIO_SALVANDO', valor: _this6.formularioPreenchimento['id_elemento'] });
	          } else {
	            _this6.notificacaoDeFormPreenchimento('preenchido', _this6.formularioPreenchimento.id, { acao: 'FORMULARIO_SALVANDO', valor: null });
	          }
	
	          _this6.salvaFormulario.statusSalvamento = 'FEITO';
	          setTimeout(function () {
	            _this6.salvaFormulario.statusSalvamento = 'AGUARDANDO';
	            _this6.salvaFormulario.salvamentoAutomaticoAtivo = true;
	            _this6.salvaFormulario.contador++;
	          }, 2000);
	          _this6.formularioPreenchimentoTemp = _.cloneDeep(_this6.formularioPreenchimento);
	          if (concluirEtapa) {
	            if (!_this6.ehSubFormulario) {
	              _this6.concluir();
	            }
	            if (_this6.formularioCadastrado.opcoes.concluir.acao === 'SAIR_FORMULARIO') {
	              if (_.includes(['ANALISE'], _this6.ultimaTarefa.nome)) {
	                _this6.$router.push({ name: 'validacao-solicitacoes-lista', params: { fase: 'AVALIACOES' } });
	              } else {
	                _this6.$router.replace('/#/inicial');
	              }
	            } else if (_this6.formularioCadastrado.opcoes.concluir.acao === 'ABRIR_URL') {
	              window.open(_this6.formularioCadastrado.opcoes.concluir.parametro, '_blank');
	            } else if (_this6.formularioCadastrado.opcoes.concluir.acao === 'ABRIR_FORMULARIO') {
	              window.open(location.protocol + '//' + location.host + '/' + (_this6.ehAcessoExterno ? 'form' : 'formulario') + '/' + _this6.formularioCadastrado.opcoes.concluir.parametro, '_self');
	            }
	          }
	        } else {
	          _this6.aviso(response.data);
	          _this6.salvaFormulario.statusSalvamento = 'AGUARDANDO';
	        }
	        _this6.loading.tela = false;
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	        _this6.loading.tela = false;
	        _this6.salvaFormulario.statusSalvamento = 'AGUARDANDO';
	        _this6.salvaFormulario.statusSalvamento = 'ERRO';
	      });
	    },
	    concluir: function concluir() {
	      var _this7 = this;
	
	      this.loading.tela = true;
	
	      var proximaEtapa = this.processo.nome === 'PREENCHIMENTO_FORMULARIO' ? 'CONCLUSAO' : _.isNull(this.aprovacao.resultadoAprovacao) ? 'ANALISE' : this.aprovacao.resultadoAprovacao;
	      if (proximaEtapa !== this.ultimaTarefa.nome) {
	        var observacao = this.aprovacao.observacao;
	        axiosLaravel.post('formulario/id/' + this.formularioPreenchimento.id + '/' + (this.ehAcessoExterno ? 'conclui' : 'concluir') + '/', { 'id': this.formularioPreenchimento.id, 'formulario': this.formularioPreenchimento.formulario, 'proximaEtapa': proximaEtapa, 'observacao': observacao }).then(function (response) {
	          _this7.aviso(response.data);
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            if (_this7.formularioCadastrado.opcoes.concluir.acao === 'SAIR_FORMULARIO') {
	              if (_this7.ehAcessoExterno) _this7.$router.replace('/#/inicial');else _this7.$router.push('/#/inicial');
	            }
	          }
	          _this7.loading.tela = false;
	        }).catch(function (error) {
	          _this7.$root.trataErro(error);
	          _this7.loading.tela = false;
	          _this7.salvaFormulario.statusSalvamento = 'ERRO';
	        });
	      } else {
	        this.$snotify.error('Erro. A próxima etapa é a mesma que a tarefa atual');
	      }
	    },
	    aviso: function aviso(retorno) {
	      var _this8 = this;
	
	      if (_.has(retorno, 'codigo')) {
	        var mensagens = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? (0, _typeof3.default)(retorno.mensagem) === string ? [retorno.mensagem] : retorno.mensagem : ['Erro de processamento. Não sei o que houve'];
	        mensagens.forEach(function (msg) {
	          if (retorno.codigo === 'ERRO') {
	            _this8.$snotify.error(msg);
	          } else if (_.includes(['OK', 'AVISO'], retorno.codigo)) {
	            _this8.$snotify.success(msg, { timeout: 3000 });
	          }
	        });
	      }
	    },
	    gerarNovoFormularioPreenchimento: function gerarNovoFormularioPreenchimento() {
	      var _this9 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('formulario/novo/' + this.$route.params.id).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var formulariosJaAcessadosLocalmente = JSON.parse(window.localStorage.getItem('formularios-sgp'));
	          formulariosJaAcessadosLocalmente.push({ cadastro: _this9.$route.params.id, preenchido: response.data.retorno, situacao: 'iniciado', data: new Date() });
	
	          window.localStorage.setItem('formularios-sgp', (0, _stringify2.default)(formulariosJaAcessadosLocalmente));
	          window.open(location.protocol + '//' + location.host + '/' + (_this9.ehAcessoExterno ? 'form' : 'formulario') + '/' + response.data.retorno, '_self');
	        }
	      }).catch(function (error) {
	        _this9.$root.trataErro(error);
	        _this9.loading.tela = false;
	        _this9.salvaFormulario.statusSalvamento = 'ERRO';
	      });
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    },
	    valorArrayElemento: function valorArrayElemento(idx, elemento) {
	      var valor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      if (!_.isNull(valor)) {
	        _.set(this.formularioPreenchimento.formulario[idx], ['valor', elemento], valor === '' ? null : valor);
	        this.executarRegras();
	        this.$forceUpdate();
	      }
	      return _.isNull(this.formularioPreenchimento.formulario[idx].valor) ? -1 : this.formularioPreenchimento.formulario[idx].valor[elemento];
	    },
	    valorPrimitivoElemento: function valorPrimitivoElemento(idx) {
	      var valor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (!_.isNull(valor)) {
	        _.set(this.formularioPreenchimento.formulario[idx], ['valor'], valor);
	        this.$forceUpdate();
	        this.executarRegras();
	      }
	      return this.formularioPreenchimento.formulario[idx].valor;
	    },
	    validacaoElementoChave: function validacaoElementoChave(idx) {
	      var _this10 = this;
	
	      var elemento = _.isNumber(idx) ? this.formularioPreenchimento.formulario[idx] : _.find(this.formularioPreenchimento.formulario, ['id', idx]);
	      if (!_.isNull(this.formularioCadastrado.opcoes.elemento_chave) && this.formularioCadastrado.opcoes.elemento_chave === elemento.id) {
	        this.loading.duplicidade = elemento.id;
	        this.errors.removeById(elemento.id);
	        axiosLaravel.post('formulario/validacao/duplicidade/valor/', { 'link_acesso': this.formularioPreenchimento.link_acesso, 'elemento': elemento.id, 'valor': elemento.valor }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'ERRO') {
	            _this10.errors.add({ field: elemento.id, rule: 'duplicidade', msg: 'Este campo não aceita repetição e o valor \'' + elemento.valor + '\' já foi informado', id: elemento.id });
	          }
	          _this10.aviso(response.data);
	          _this10.loading.duplicidade = null;
	        }).catch(function (error) {
	          _this10.loading.duplicidade = null;
	          _this10.$root.trataErro(error);
	        });
	      }
	    },
	    assinaCanais: function assinaCanais() {
	      var _this11 = this;
	
	      if (!this.ehAcessoExterno) {
	        var canalFormCadastro = 'formulario.cadastro.' + this.formularioCadastrado.id;
	        window.Echo.channel(canalFormCadastro).listen('FormularioEvents', function (notificacao) {
	          if (notificacao.mensagem.acao === 'SITUACAO_FORMULARIO_CADASTRO_ALTERADA' && notificacao.mensagem.valor === 'Inativo') {
	            _this11.salvarPreenchimento(false);
	            _this11.$snotify.error('Este formulário foi inativado!');
	            _this11.$router.replace('/#/inicial');
	          }
	        });
	
	        var idOuChaveAcesso = this.ehSubFormulario && this.formularioPreenchimento['link_acesso'].length > 15 ? this.formularioPreenchimento['link_acesso'] : this.formularioPreenchimento.id;
	        var canalFormPreenchimento = 'formulario.' + (this.ehSubFormulario ? 'sub' : 'preenchido') + '.' + idOuChaveAcesso;
	        window.Echo.channel(canalFormPreenchimento).listen('FormularioEvents', function (notificacao) {
	          if (_.includes(['SUB_FORMULARIO_EXCLUIDO', 'FORMULARIO_EXCLUIDO', 'FORMULARIO_CANCELADO'], notificacao.mensagem.acao) && idOuChaveAcesso === notificacao.id) {
	            _this11.$snotify.error('O preenchimento desse formulário foi excluído/cancelado!');
	            _this11.$router.replace('/#/inicial');
	          }
	        });
	      }
	    },
	    notificacaoDeFormPreenchimento: function notificacaoDeFormPreenchimento(canal, id, mensagem) {
	      var _this12 = this;
	
	      if (!this.ehAcessoExterno) {
	        axiosLaravel.post('formulario/mensageria', { canal: canal, id: id, mensagem: mensagem }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            console.log('Mensagem enviada');
	          } else {
	            console.log('Erro de mensageria');
	            _this12.$snotify.error(response.data.mensagem);
	          }
	        }).catch(function (error) {
	          _this12.$snotify.clear();
	          _this12.$root.trataErro(error);
	        });
	      }
	    },
	    executarRegras: function executarRegras() {
	      var _this13 = this;
	
	      var formulario = _.cloneDeep(this.formularioBackup);
	
	      this.formularioPreenchimento.formulario.forEach(function (elemento) {
	        if (_.has(elemento.configuracao, 'regras')) {
	          elemento.configuracao.regras.forEach(function (regra) {
	            if (regra.condicao === 'ENTRE' && _.toNumber(elemento.valor) >= _.toNumber(regra.valor) && _.toNumber(elemento.valor) <= _.toNumber(regra.valor2) && !_.isNull(elemento.valor) || regra.condicao === 'MENOR' && _.toNumber(elemento.valor) < _.toNumber(regra.valor) && _.toNumber(elemento.valor) > -1 && !_.isNull(elemento.valor) || regra.condicao === 'MENOR_IGUAL' && _.toNumber(elemento.valor) <= _.toNumber(regra.valor) && _.toNumber(elemento.valor) > -1 && !_.isNull(elemento.valor) || regra.condicao === 'MAIOR' && _.toNumber(elemento.valor) > _.toNumber(regra.valor) && !_.isNull(elemento.valor) || regra.condicao === 'MAIOR_IGUAL' && _.toNumber(elemento.valor) >= _.toNumber(regra.valor) && !_.isNull(elemento.valor) || regra.condicao === 'NAO_CONTEM' && !_.includes('' + elemento.valor, _.toLower(regra.valor)) || regra.condicao === 'CONTEM' && _.includes('' + elemento.valor, _.toLower(regra.valor)) || regra.condicao === 'NAO_VAZIO' && !_.isEmpty('' + elemento.valor) || regra.condicao === 'VAZIO' && _.isEmpty('' + elemento.valor) || regra.condicao === 'IGUAL' && _.toLower('' + elemento.valor) === _.toLower('' + regra.valor) || regra.condicao === 'DIFERENTE' && _.toLower('' + elemento.valor) !== _.toLower('' + regra.valor) || regra.condicao === 'ITEM_SELECIONADO' && (!_.has(regra, 'valor2') && (_.isArray(elemento.valor) && _.includes(elemento.valor, regra.valor) || regra.valor === elemento.valor) || _.has(regra, 'valor2') && !_.isNull(elemento.valor) && elemento.valor[regra.valor2] === regra.valor)) {
	                regra.id.forEach(function (itemOndeAplicarRegra) {
	                  _.set(_.find(formulario, ['id', itemOndeAplicarRegra.id]), ['mostrar'], regra.acao === 'MOSTRAR');
	                  if (itemOndeAplicarRegra.elemento === 'SECAO') {
	                    var idx = _.findIndex(_this13.formularioPreenchimento.formulario, ['id', itemOndeAplicarRegra.id]);
	                    for (var i = idx + 1; i < _this13.formularioPreenchimento.formulario.length; i++) {
	                      if (_this13.formularioPreenchimento.formulario[i].elemento === 'SECAO') break;
	                      _.set(formulario, [i, 'mostrar'], regra.acao === 'MOSTRAR');
	                    }
	                  }
	                });
	              }
	          });
	        }
	      });
	
	      var totalElementos = 0;
	      var totalElementosNaoPreenchidos = 0;
	      this.formularioPreenchimento.formulario.forEach(function (elemento) {
	        elemento.mostrar = _.get(_.find(formulario, ['id', elemento.id]), 'mostrar');
	        if (!elemento.mostrar) {
	          elemento.valor = null;
	        }
	
	        if (elemento['grupo'] !== 'LAYOUT' && _.has(elemento, 'mostrar') && elemento.mostrar && elemento.obrigatorio) {
	          totalElementos += 1;
	          totalElementosNaoPreenchidos += _.isNull(elemento.valor) || elemento.valor === [] || elemento.valor === '' ? 1 : 0;
	        }
	      });
	
	      var percentualPreenchimento = totalElementos === 0 ? 0 : Math.ceil((totalElementos - totalElementosNaoPreenchidos) / totalElementos * 100);
	      percentualPreenchimento = percentualPreenchimento < 0 ? 0 : percentualPreenchimento > 100 ? 100 : percentualPreenchimento;
	      this.notificacaoDeFormPreenchimento(this.ehSubFormulario ? 'sub' : 'preenchido', this.formularioPreenchimento.id, { acao: 'PERCENTUAL_PREENCHIDO', valor: this.formularioPreenchimento['id_elemento'], percentagem: percentualPreenchimento + '%' });
	      this.$forceUpdate();
	    },
	    validaCpfCnpj: function validaCpfCnpj(idx) {
	      var controle = this.formularioPreenchimento.formulario[idx];
	      this.errors.removeById(controle.id);
	      if (controle.configuracao.formato === 'CPF' && !_cpfCnpjValidator.cpf.isValid(controle.valor) || controle.configuracao.formato === 'CNPJ' && !(0, _cnpj2.default)(controle.valor)) {
	        this.errors.add({ field: controle.id, rule: _.lowerCase(controle.configuracao.formato) + '_digito', msg: 'Dígito verificador do ' + controle.configuracao.formato + ' inválido' });
	      }
	    },
	    abreFormulario: function abreFormulario(chave) {
	      window.open(location.protocol + '//' + location.host + '/' + (this.ehAcessoExterno ? 'form' : 'formulario') + '/' + chave, '_blank');
	    },
	    excluirItemSubFormulario: function excluirItemSubFormulario(idx, chaveSubForm, chave) {
	      var _this14 = this;
	
	      axiosLaravel.post('formulario/id/' + this.formularioPreenchimento.id + '/excluir/', { 'chave': chave }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this14.notificacaoDeFormPreenchimento('sub', _this14.formularioPreenchimento.id, { acao: 'SUB_FORMULARIO_EXCLUIDO', valor: _this14.formularioPreenchimento['id_elemento'] });
	          var registroExcluido = _.find(_this14.formularioPreenchimento[idx].valor, function (item) {
	            return item.excluir === idRegistro || item.editar === idRegistro || item.visualizar === idRegistro;
	          });
	          if (!_this14.ehAcessoExterno) {
	            Echo.leave('formulario.sub.' + registroExcluido.id);
	          }
	          _this14.carregaDadosSubForm(idx, chaveSubForm);
	        } else {
	          _this14.aviso(response.data);
	        }
	      }).catch(function (error) {
	        _this14.$root.trataErro(error);
	      });
	    },
	    filtroPorItem: function filtroPorItem(row, filter) {
	      var encontrado = 0;
	      if (filter !== 'retornar_todos_registros') {
	        row = _.join(_.values(_.omit(row, ['idSubFormulario', 'idElemento', 'editar', 'excluir', 'visualizar'])), '|');
	        var termos = _.split(_.toLower(filter), ' ');
	        termos.forEach(function (termo) {
	          encontrado += _.toLower(row).indexOf(termo) !== -1 ? 1 : 0;
	        });
	      }
	      return encontrado > 0;
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      if (filteredItems.length > 0) {
	        var conteudo = _.find(this.formularioPreenchimento.formulario, ['id', filteredItems[0].idElemento])['configuracao']['conteudo'];
	        conteudo.totalRows = filteredItems.length;
	        conteudo.currentPage = 1;
	      }
	    },
	    exportarExcel: function exportarExcel() {
	      var _this15 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('formulario/completo/', { 'lista': [this.formularioPreenchimento['fk_processo']] }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var planilhaPrincipal = [];
	          response.data.retorno.listaFormulariosPrincipais.forEach(function (form) {
	            var formularioTemp = {};
	            _.set(formularioTemp, 'ID Processo', form['fk_processo']);
	
	            form.formulario.forEach(function (controle) {
	              if (_.includes(['CONTROLE', 'PERSONALIZADO'], controle.grupo)) {
	                if (!_.isNull(controle.valor)) {
	                  if (controle.elemento === 'UF_MUNICIPIO' && _.has(controle.valor, 'nomcid') && _.has(controle.valor, 'sigufs')) {
	                    controle.valor = controle.valor.nomcid + ' (' + controle.valor.sigufs + ')';
	                  } else if (controle.elemento === 'DATA') {
	                    controle.valor = (0, _moment2.default)(controle.valor).add(1, 'day').format('DD/MM/YYYY');
	                  } else if (controle.elemento === 'PERIODO' && _.has(controle.valor, 'inicio') && _.has(controle.valor, 'termino')) {
	                    controle.valor = (0, _moment2.default)(controle.valor.inicio).format('DD/MM/YYYY') + ' - ' + (0, _moment2.default)(controle.valor.termino).format('DD/MM/YYYY');
	                  } else if (controle.elemento === 'LIKERT' && _.values(controle.valor).length > 0) {
	                    _.forEach(controle.valor, function (resposta, pergunta) {
	                      _.set(formularioTemp, [('' + pergunta).replace(/(<([^>]+)>)/ig, '')], resposta);
	                    });
	                  } else if (controle.elemento === 'SELECAO_MULTIPLA') {
	                    controle.valor = _.toString(controle.valor);
	                  }
	                }
	                if (controle.elemento !== 'LIKERT') {
	                  _.set(formularioTemp, [('' + controle.titulo).replace(/(<([^>]+)>)/ig, '')], controle.valor);
	                }
	              }
	            });
	            planilhaPrincipal.push(formularioTemp);
	          });
	          var principal = XLSX.utils.json_to_sheet(planilhaPrincipal);
	
	          var wb = XLSX.utils.book_new();
	          XLSX.utils.book_append_sheet(wb, principal, 'Formulario Principal');
	          response.data.retorno.subformularios.forEach(function (subForm) {
	            var planilhaSubForm = XLSX.utils.json_to_sheet(subForm.preenchido);
	            var tituloPlanilhaSubForm = subForm.titulo.substring(0, 30);
	            tituloPlanilhaSubForm = _.isNull(tituloPlanilhaSubForm) ? tituloPlanilhaSubForm : ('' + tituloPlanilhaSubForm).replace(/(<([^>]+)>)/ig, '');
	            XLSX.utils.book_append_sheet(wb, planilhaSubForm, tituloPlanilhaSubForm);
	          });
	
	          var dados = [{ 'Registro': 'ID do formulário', 'Informação': response.data.retorno.listaFormulariosPrincipais[0]['fk_formulario'] }, { 'Registro': 'Quem gerou a planilha', 'Informação': _this15.usuarioLogado.userName }, { 'Registro': 'Quando foi gerada', 'Informação': Date(Date.now()).toString() }, { 'Registro': 'Autenticação', 'Informação': response.data.retorno.autenticacao }];
	          var extracao = XLSX.utils.json_to_sheet(dados);
	          XLSX.utils.book_append_sheet(wb, extracao, 'Extração');
	          XLSX.writeFile(wb, 'Formulario_processo_id_' + _this15.formularioPreenchimento.fk_processo + '.xlsx');
	        } else {
	          _this15.$snotify.error(response.data.mensagem);
	        }
	        _this15.loading.tela = false;
	      }).catch(function (error) {
	        _this15.$snotify.clear();
	        _this15.$root.trataErro(error);
	        _this15.loading.tela = false;
	      });
	    },
	    copiaUrlSubFormulario: function copiaUrlSubFormulario(controle) {
	      var _this16 = this;
	
	      var linkCompleto = location.protocol + '//' + location.host + '/form/' + controle.configuracao.padrao[0];
	      navigator.clipboard.writeText(linkCompleto).then(function () {
	        _.set(controle.configuracao, 'link_copia', { classe: 'label label-success', msg: 'Copiado!' });
	        _this16.$forceUpdate();
	        setTimeout(function () {
	          _.unset(controle.configuracao, 'link_copia');_this16.$forceUpdate();
	        }, 2000);
	      }).catch(function (err) {
	        _.set(controle.configuracao, 'link_copia', { classe: 'label label-danger', msg: 'Erro: ' + err });
	        _this16.$forceUpdate();
	      });
	    }
	  }
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _uploadDocumentosChamado = __webpack_require__(526);
	
	var _uploadDocumentosChamado2 = _interopRequireDefault(_uploadDocumentosChamado);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'abrir-chamado',
	  components: { UploadDocumentosChamado: _uploadDocumentosChamado2.default },
	  data: function data() {
	    return {
	      data: [],
	      items: [],
	      projeto: [],
	      projetos: [],
	      tarefas: [],
	      tarefa: [],
	      edital: null,
	      assuntos: [{
	        id: 1,
	        nome: 'Geral'
	      }],
	      listaAssuntos: [],
	      assunto: [],
	      projetoSuperior: '',
	      filtros: {
	        createdAt: null,
	        createdAtDate: null,
	        entityId: null,
	        project: null,
	        requestType: null
	      },
	      place: 'Descreva de forma objetiva e sucinta qual o problema ou dúvida que deseja enviar para a Fundação Banco do Brasil.',
	      chamadoObj: {
	        anexos: [],
	        status_id: null,
	        fk_documento: null,
	        entidade_id: null,
	        processo_id: null,
	        projeto_id: null,
	        tarefa_id: null,
	        assunto_id: null,
	        descricao: null
	      },
	      projetoEspecifico: null,
	      tarefaEspecifica: null,
	      pesquisa: '',
	      loading: {
	        tela: false,
	        projetos: false,
	        assuntos: false,
	        ids: false
	      }
	    };
	  },
	
	  props: ['propsProjetos'],
	  watch: {
	    projetos: function projetos() {
	      this.preencheDadosExternos();
	    },
	    listaAssuntos: function listaAssuntos() {
	      this.preencheDadosExternosAssunto();
	      console.log('assuntos: ', this.listaAssuntos);
	    },
	    tarefas: function tarefas() {
	      this.preencheTarefasExterno();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.buscaAssuntosAtivos();
	
	            case 2:
	              _context.next = 4;
	              return _this.buscaProjetos();
	
	            case 4:
	              if (_this.usuarioLogado.userType === 'ENTIDADE') {
	                _this.chamadoObj.entidade_id = _this.usuarioLogado.entidade.id;
	              }
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    changeProjeto: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(projeto) {
	        var _this2 = this;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                this.loading.ids = true;
	                this.pesquisa = projeto.Numero_projeto;
	                this.chamadoObj.projeto_id = projeto.Id_proposta;
	                this.chamadoObj.entidade_id = projeto.fk_entidade;
	                _context2.next = 6;
	                return axiosLaravel.get('processos/projeto/' + this.pesquisa).then(function (response) {
	                  if (response.data) {
	                    _this2.tarefas = response.data;
	                    _this2.tarefas.unshift({ 'projeto': 'Cabeçalho de tarefas', $isDisabled: true });
	                  }
	                  _this2.pesquisa = '';
	                  _this2.loading.ids = false;
	                  _this2.$forceUpdate();
	                }).catch(function (error) {
	                  if (error) {
	                    _this2.loading.ids = false;
	                    _this2.$root.trataErro(error);
	                  }
	                });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function changeProjeto(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return changeProjeto;
	    }(),
	    showAlert: function showAlert() {
	      this.$swal({
	        title: '<font color="red"><b>Atenção!</b></font>',
	        html: '<div align="left"> A tarefa selecionada se encontra em Revisão pela sua entidade. Gentileza se manifestar na própria tarefa!</div>'
	      });
	    },
	
	    changeTarefa: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(tarefa) {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this.chamadoObj.processo_id = tarefa.id;
	                this.chamadoObj.tarefa_id = tarefa.id_tarefa;
	                this.tarefaSelecionada = tarefa;
	                console.log('tarefa', tarefa);
	                if (tarefa.etapa === 'Revisão' || tarefa.etapa === 'Revisão pela entidade') {
	                  this.showAlert(tarefa);
	                }
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function changeTarefa(_x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return changeTarefa;
	    }(),
	    changeAssunto: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(assunto) {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                this.chamadoObj.assunto_id = assunto.id;
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function changeAssunto(_x3) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return changeAssunto;
	    }(),
	    buscaProjetos: function buscaProjetos() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this3.loading.projetos = true;
	                axiosLaravel.post('processos/projetos', { processo: 'PAGAMENTO', 'tipoBusca': 'simples' }).then(function (response) {
	                  var listaProjetos = response.data;
	                  var acessosProjetos = _.get(_this3.usuarioLogado, 'configuracoes.acesso_projetos');
	                  if (acessosProjetos) {
	                    acessosProjetos.forEach(function (projeto) {
	                      if (_.find(projeto.acesso, ['codigo', 'SEM_ACESSO'])) {
	                        _.remove(listaProjetos, ['Numero_projeto', projeto.numero]);
	                      }
	                    });
	                  }
	                  _this3.projetos = listaProjetos;
	                  _this3.loading.projetos = false;
	                  _this3.$forceUpdate();
	                }).catch(function (error) {
	                  _this3.loading.projetos = false;
	                  console.log('error', error);
	                  _this3.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this3);
	      }))();
	    },
	    etiquetaTarefas: function etiquetaTarefas(option) {
	      var valor = parseFloat(option.valor).toFixed(2);
	      return 'ID: ' + option.id + ' - Tipo: ' + option.tipo_solicitacao + ' - Valor: R$ ' + valor;
	    },
	    etiquetaAssuntos: function etiquetaAssuntos(option) {
	      return '' + option.assunto;
	    },
	    salvaChamado: function salvaChamado(tarefa) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(_this4.chamadoObj.assunto_id === 17)) {
	                  _context6.next = 4;
	                  break;
	                }
	
	                _context6.next = 3;
	                return _this4.buscaNumProjetoSuperior();
	
	              case 3:
	                _this4.chamadoObj.descricao += ' [Projeto Superior] ' + _this4.projetoSuperior;
	
	              case 4:
	                _this4.chamadoObj.status_id = 1;
	
	                if (_this4.usuarioLogado.userType === 'FUNDACAO') {
	                  _this4.chamadoObj.status_id = 2;
	                  _this4.chamadoObj.usuario_atendimento = _this4.usuarioLogado.id;
	                }
	                _this4.$validator.validateAll().then(function (result) {
	                  if (result) {
	                    _this4.$aguarde('Salvando o Chamado. Por favor, aguarde...');
	                    _this4.loading.tela = true;
	                    axiosLaravel.post('chamado/grava', _this4.chamadoObj).then(function (response) {
	                      _this4.$snotify.clear();
	                      _this4.$snotify.success('Chamado salvo com sucesso! Você receberá um e-mail de confirmação com o número.');
	                      if (_.includes([1, 2, 3, 4], _.get(response.data, ['status_id'], 0)) && _.includes([15, 16], _.get(response.data, ['assunto_id'], 0))) {
	                        _this4.encerrarAtendimento(response.data.id);
	                      } else {
	                        _this4.loading.tela = false;
	                        _this4.$emit('fechaModal', false);
	                        _this4.$router.push('/cadastro/chamado/lista/');
	                      }
	                    }).catch(function (error) {
	                      _this4.$snotify.clear();
	                      _this4.loading.tela = false;
	                      _this4.$root.trataErro(error);
	                    });
	                  } else {
	                    _this4.$snotify.error('O formulário possui erros. Favor verificar!');
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this4);
	      }))();
	    },
	    encerrarAtendimento: function encerrarAtendimento(id) {
	      var _this5 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('chamado/encerrarAtendimento/', { 'parametro': id }).then(function (response) {
	        console.log('   encerrado FEITO', response.data);
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Chamado encerrado automaticamente!', { timeout: 3000 });
	        _this5.loading.tela = false;
	        _this5.$emit('fechaModal', false);
	        _this5.$router.push('/cadastro/chamado/lista/');
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.loading.tela = false;
	        _this5.$root.trataErro(error);
	      });
	    },
	    buscaAssuntosAtivos: function buscaAssuntosAtivos() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        var listaAssuntos, diferenca;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this6.loading.assuntos = true;
	
	                if (!(typeof Storage !== 'undefined')) {
	                  _context7.next = 11;
	                  break;
	                }
	
	                listaAssuntos = JSON.parse(window.localStorage.getItem('assuntos-chamado'));
	                diferenca = Math.floor(new Date().getTime() / 86400000 - _.get(listaAssuntos, 'atualizado', new Date('2023-01-01').getTime()) / 86400000);
	
	                if (!(diferenca >= 1)) {
	                  _context7.next = 9;
	                  break;
	                }
	
	                _context7.next = 7;
	                return axiosLaravel.post('assuntos/ativos').then(function (response) {
	                  if (response.data) {
	                    _this6.listaAssuntos = _this6.usuarioLogado.userType !== 'FUNDACAO' ? _.filter(response.data, function (assunto) {
	                      return !_.includes([15, 16], assunto.id);
	                    }) : response.data;
	                    window.localStorage.setItem('assuntos-chamado', (0, _stringify2.default)({ 'atualizado': Math.floor(new Date().getTime()), 'lista': _this6.listaAssuntos }));
	                  }
	
	                  _this6.loading.assuntos = false;
	                  _this6.$forceUpdate();
	                }).catch(function (error) {
	                  _this6.loading.assuntos = false;
	                  if (error) {
	                    _this6.$root.trataErro(error);
	                  }
	                });
	
	              case 7:
	                _context7.next = 11;
	                break;
	
	              case 9:
	                _this6.listaAssuntos = listaAssuntos.lista;
	                _this6.loading.assuntos = false;
	
	              case 11:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this6);
	      }))();
	    },
	    onDownload: function onDownload(documento) {
	      var _this7 = this;
	
	      if (documento.file) {
	        download(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this7.$root.trataErro(error);
	        });
	      }
	    },
	    preencheDadosExternos: function preencheDadosExternos() {
	      var idTarefa = this.$route.query.idTarefa;
	      var projeto = this.$route.query.projeto;
	      if (typeof idTarefa === 'undefined') {
	        return;
	      } else {
	        this.projetoEspecifico = 'SIM';
	        var indexProjeto = this.projetos.map(function (e) {
	          return e.Numero_projeto;
	        }).indexOf(projeto);
	        var projetoSelecionado = this.projetos[indexProjeto];
	        this.changeProjeto(projetoSelecionado);
	        this.projeto = projetoSelecionado;
	      }
	    },
	    preencheDadosExternosAssunto: function preencheDadosExternosAssunto() {
	      var idTarefa = this.$route.query.idTarefa;
	      var processo = this.$route.query.processo;
	      if (typeof idTarefa === 'undefined') {
	        return;
	      }
	      if (processo === 'PRESTACAO_DE_CONTAS') {
	        processo = 'Prestação de Contas de Recursos Adiantados';
	      } else if (processo === 'DEVOLUCAO_DE_ADIANTAMENTO') {
	        processo = 'Devolução de Adiantamento';
	      } else {
	        processo = processo[0].toUpperCase() + processo.slice(1).toLowerCase();
	      }
	      var indexAssunto = this.listaAssuntos.map(function (e) {
	        return e.assunto;
	      }).indexOf(processo);
	      var assuntoSelecionado = this.listaAssuntos[indexAssunto];
	
	      this.changeAssunto(assuntoSelecionado);
	      this.assunto = assuntoSelecionado;
	    },
	    preencheTarefasExterno: function preencheTarefasExterno() {
	      var idTarefa = this.$route.query.idTarefa;
	      if (idTarefa !== 'null') {
	        this.tarefaEspecifica = 'SIM';
	        var indexTarefa = this.tarefas.map(function (e) {
	          return e.id;
	        }).indexOf(parseInt(idTarefa));
	        var tarefaSelecionada = this.tarefas[indexTarefa];
	        this.tarefa = tarefaSelecionada;
	        this.changeTarefa(tarefaSelecionada);
	      } else {
	        this.tarefaEspecifica = 'NAO';
	      }
	    },
	    buscaNumProjetoSuperior: function buscaNumProjetoSuperior() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        var response;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.prev = 0;
	                _context8.next = 3;
	                return axiosLaravel.get('chamado/projetoSuperior/' + _this8.projeto.Numero_projeto);
	
	              case 3:
	                response = _context8.sent;
	
	                _this8.projetoSuperior = response.data;
	                _context8.next = 12;
	                break;
	
	              case 7:
	                _context8.prev = 7;
	                _context8.t0 = _context8['catch'](0);
	
	                _this8.$snotify.clear();
	                _this8.$root.trataErro(_context8.t0);
	                throw _context8.t0;
	
	              case 12:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this8, [[0, 7]]);
	      }))();
	    }
	  }
	};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _uploadDocumentosChamado = __webpack_require__(526);
	
	var _uploadDocumentosChamado2 = _interopRequireDefault(_uploadDocumentosChamado);
	
	var _vuex = __webpack_require__(3);
	
	var _vueStarRating = __webpack_require__(2127);
	
	var _vueStarRating2 = _interopRequireDefault(_vueStarRating);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    StarRating: _vueStarRating2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    UploadDocumentosChamado: _uploadDocumentosChamado2.default
	  },
	  name: 'editar-chamado',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    problemaSelecionadoObj: {
	      get: function get() {
	        var _this = this;
	
	        return this.problemas.find(function (p) {
	          return Number(p.prob_id) === Number(_this.suporte.prob_id);
	        }) || null;
	      },
	      set: function set(valor) {
	        this.suporte.prob_id = valor ? valor.prob_id : null;
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      rating: 0,
	      carregou: false,
	      chamado: {
	        entidade: {},
	        assunto: [],
	        status: {},
	        documento: {
	          tipo_documento: []
	        },
	        data_atendimento: null,
	        usuario_atendimento: null
	      },
	      esconderDados: true,
	      place: 'Descreva para a FBB o que faltou para que o chamado fosse atentido.\nObs: O chamado retornará para Em Atendimento da FBB.',
	      placeFBB: 'Informe para o solicitante o que foi feito para resolução do chamado.\nObs: O chamado irá para o status Aguardando Avaliação.',
	      placeAssentamento: 'Descreva de forma clara e objetiva o assentamento.',
	      assuntoAntigo: '',
	      areaAssuntoNovo: '',
	      areaAssuntoAntigo: '',
	      problemaResolvido: '',
	      resolucao: '',
	      resolucaoNOK: '',
	      documento: [],
	      habilita: false,
	      chamadoAtualiza: {
	        usuario_atendimento: null
	      },
	      habilitaSalvarReclassificacao: false,
	      apertouSalvar: false,
	      mostraAvaliacao: false,
	      assentamentos: [],
	      textoAssentamento: '',
	      assentamento: {
	        fk_documento: null,
	        usuario: null,
	        descricao: null,
	        data_inclusao: null,
	        visivel_entidade: 1,
	        anexos: []
	      },
	      usuarioAlterado: {},
	      assentamentoEnvio: {
	        descricao: null
	      },
	      loading: {
	        show: false
	      },
	      usuarios: [],
	      suporte: {
	        numero: '',
	        problema: 332,
	        descricao: '',
	        equipamento: 1,
	        sistema: 3,
	        contato: '',
	        telefone: '31087000',
	        local: 19,
	        operador: 0,
	        data_abertura: new Date().toISOString().slice(0, 19).replace('T', ' '),
	        data_fechamento: null,
	        status: 1,
	        data_atendimento: null,
	        instituicao: 17,
	        aberto_por: 0,
	        operadorbkp: null,
	        abertoporbkp: null,
	        lido: 0,
	        sub_status: 0,
	        data_prev_encerramento: null,
	        mudanca: 0,
	        prioridade: 2,
	        resumo_ocor: ''
	      },
	      botaoSalvaAnalista: false,
	      mostraListaUsuarios: false,
	      preencheResolucao: false,
	      resolucaoPreenchida: false,
	      assuntos: [],
	      diasEmAberto: '',
	      mostraNovo: false,
	      mostraTextoSuporte: false,
	      descricaoSuporte: '',
	      problemas: [{
	        prob_id: 332,
	        problema: 'SGP - Novo'
	      }, {
	        prob_id: 287,
	        problema: 'Acertos em Projetos'
	      }, {
	        prob_id: 303,
	        problema: 'Design - Produção gráfica layout'
	      }, {
	        prob_id: 164,
	        problema: 'Dados/Informações - Consulta'
	      }],
	      linkSuporte: 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=',
	      link: '',
	      problemaSelecionado: null,
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'data_inclusao',
	        sortDesc: true,
	        fields: [{ key: 'usuario.ds_nome_usuario', label: 'Usuário', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'data_inclusao', label: 'Data', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'descricao', label: 'Observações', sortable: true, thStyle: 'text-align: center; width: 40%', class: 'text-center' }, { key: 'anexos', label: 'Anexo', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }]
	      },
	      carteira: ''
	    };
	  },
	  created: function created() {
	    this.assentamento.descricao = '';
	    if (this.$route.params.id) {
	      this.loading.show = true;
	      this.buscaChamado();
	      this.buscaAssentamento();
	      this.buscaAssunto();
	    }
	  },
	  mounted: function mounted() {
	    this.buscaUsuarios();
	  },
	
	  methods: {
	    verificaUsuarioLogado: function verificaUsuarioLogado() {
	      if (this.usuarioLogado.userType === 'FUNDACAO' || this.usuarioLogado.entidade.ds_cnpj === this.chamado.entidade.ds_cnpj) {
	        return true;
	      } else {
	        this.$router.push({ name: 'dashboard' });
	      }
	    },
	    formata: function formata(row) {
	      return (0, _moment2.default)(row).format('DD/MM/YYYY');
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    },
	    buscaChamado: function buscaChamado() {
	      var _this2 = this;
	
	      var now = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	      if (this.$route.params.id) {
	        this.loading.show = true;
	        axiosLaravel.get('chamado/' + this.$route.params.id).then(function (response) {
	          _this2.chamado = response.data;
	          _this2.verificaUsuarioLogado();
	          if ((0, _moment2.default)(_this2.chamado.data_inclusao).format('YYYYMMDD') === (0, _moment2.default)(now).format('YYYYMMDD')) {
	            _this2.diasEmAberto = 0;
	          } else {
	            _this2.diasEmAberto = _moment2.default.utc((0, _moment2.default)(now).diff((0, _moment2.default)(_this2.chamado.data_inclusao))).format('DD');
	          }
	          _this2.horasEmAberto = _moment2.default.utc((0, _moment2.default)(now).diff((0, _moment2.default)(_this2.chamado.data_inclusao))).format('HH');
	          _this2.minutosEmAberto = _moment2.default.utc((0, _moment2.default)(now).diff((0, _moment2.default)(_this2.chamado.data_inclusao))).format('mm');
	          _this2.documento = _this2.chamado.documento;
	          if (_this2.chamado.data_inclusao) {
	            _this2.chamado.data_inclusao = (0, _moment2.default)(_this2.chamado.data_inclusao).format('DD/MM/YYYY HH:mm:ss');
	          }
	          if (_this2.chamado.data_encerramento) {
	            _this2.chamado.data_encerramento = (0, _moment2.default)(_this2.chamado.data_encerramento).format('DD/MM/YYYY HH:mm:ss');
	          }
	          if (_this2.chamado.data_atendimento) {
	            _this2.chamado.data_atendimento = (0, _moment2.default)(_this2.chamado.data_atendimento).format('DD/MM/YYYY HH:mm:ss');
	          }
	          _this2.assuntoAntigo = _this2.chamado.assunto.assunto;
	          _this2.areaAssuntoAntigo = _this2.chamado.assunto.area_responsavel;
	          _this2.usuarioNome = _this2.chamado.usuario_abertura.ds_nome_usuario;
	          _this2.$forceUpdate();
	          _this2.loading.show = false;
	          _this2.buscaCarteira();
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	          _this2.loading.show = false;
	        });
	      }
	    },
	    buscaAssentamento: function buscaAssentamento() {
	      var _this3 = this;
	
	      this.carregou = false;
	      if (this.$route.params.id) {
	        this.loading.show = true;
	        axiosLaravel.post('assentamento/busca/', { 'parametro': this.$route.params.id }).then(function (response) {
	          _this3.assentamentos = response.data;
	          _this3.table.items = _.cloneDeep(_this3.assentamentos);
	          _this3.table.totalRows = _this3.table.items.length;
	          _this3.$forceUpdate();
	          _this3.$refs.table.refresh();
	          _this3.carregou = true;
	          _this3.loading.show = false;
	        }).catch(function (error) {
	          _this3.$root.trataErro(error);
	          _this3.loading.show = false;
	        });
	      }
	    },
	    adicionaAssentamento: function adicionaAssentamento() {
	      var _this4 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this4.apertouSalvar = true;
	          _this4.assentamento.usuario = _this4.usuarioLogado;
	          _this4.assentamento.data_inclusao = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	          _this4.table.items.push(_this4.assentamento);
	          _this4.mostraNovo = false;
	          _this4.$forceUpdate();
	          _this4.salvaAssentamento();
	        } else {
	          _this4.$snotify.error('É necessário preencher o campo Assentamento. Favor verificar!');
	        }
	      });
	    },
	    fechaAssentamento: function fechaAssentamento() {
	      this.mostraNovo = false;
	      this.assentamento.descricao = '';
	      this.assentamento.anexos = [];
	    },
	    salvaAssentamento: function salvaAssentamento() {
	      var _this5 = this;
	
	      this.apertouSalvar = true;
	      this.carregou = false;
	      this.$aguarde('Salvando o assentamento. Por favor, aguarde...');
	      axiosLaravel.post('assentamento/grava/', { 'parametro': this.$route.params.id, 'descricao': this.assentamento.descricao, 'anexos': this.assentamento.anexos, 'visivel_entidade': this.assentamento.visivel_entidade }).then(function (response) {
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Assentamento salvo com sucesso!');
	        _this5.apertouSalvar = false;
	        _this5.assentamento.descricao = '';
	        _this5.assentamento.visivel_entidade = null;
	        _this5.assentamento.anexos = [];
	        _this5.buscaAssentamento();
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    },
	    salvaAssentamentoAutomatico: function salvaAssentamentoAutomatico(descricao) {
	      var _this6 = this;
	
	      this.apertouSalvar = false;
	      axiosLaravel.post('assentamento/grava/', { 'parametro': this.$route.params.id, 'descricao': descricao }).then(function (response) {
	        _this6.buscaAssentamento();
	      }).catch(function (error) {
	        _this6.$snotify.clear();
	        _this6.$root.trataErro(error);
	      });
	    },
	    iniciarAtendimento: function iniciarAtendimento() {
	      var _this7 = this;
	
	      var descricao = 'Atendimento Iniciado';
	      this.$aguarde('Salvando o Chamado. Por favor, aguarde...');
	      axiosLaravel.post('chamado/iniciaAtendimento/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this7.salvaAssentamentoAutomatico(descricao);
	        _this7.$snotify.clear();
	        _this7.$snotify.success('Chamado salvo com sucesso!');
	        _this7.buscaChamado();
	      }).catch(function (error) {
	        _this7.$snotify.clear();
	        _this7.$root.trataErro(error);
	      });
	    },
	    devolveAguardandoAtendimento: function devolveAguardandoAtendimento() {
	      var _this8 = this;
	
	      var descricao = 'Devolvido para o status Aguardando Atendimento';
	      this.$aguarde('Salvando o Chamado. Por favor, aguarde...');
	      axiosLaravel.post('chamado/devolveAguardandoAtendimento/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this8.salvaAssentamentoAutomatico(descricao);
	        _this8.$snotify.clear();
	        _this8.$snotify.success('Chamado salvo com sucesso!');
	        _this8.buscaChamado();
	      }).catch(function (error) {
	        _this8.$snotify.clear();
	        _this8.$root.trataErro(error);
	      });
	    },
	    liberaParaAvaliacao: function liberaParaAvaliacao() {
	      this.preencheResolucao = true;
	      this.resolucaoPreenchida = false;
	    },
	    enviarAvaliacao: function enviarAvaliacao() {
	      var _this9 = this;
	
	      this.adicionaAssentamento();
	      var descricaoAux = 'Chamado enviado para avaliação do usuário.';
	      var descricao = '<b>' + this.resolucao + '</b>' + '<br/>' + descricaoAux;
	      this.$aguarde('Salvando o Chamado. Por favor, aguarde...');
	      axiosLaravel.post('chamado/enviarAvaliacao/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this9.salvaAssentamentoAutomatico(descricao);
	        _this9.$snotify.clear();
	        _this9.$snotify.success('Chamado salvo com sucesso!');
	        _this9.buscaChamado();
	      }).catch(function (error) {
	        _this9.$snotify.clear();
	        _this9.$root.trataErro(error);
	      });
	    },
	    avaliarChamado: function avaliarChamado() {
	      this.mostraAvaliacao = true;
	    },
	    enviarEncerramento: function enviarEncerramento() {
	      var _this10 = this;
	
	      var descricao = '';
	      if (this.problemaResolvido === 'SIM') {
	        descricao = 'O chamado foi solucionado e a Avaliação foi efetuada.';
	      } else {
	        descricao = 'O chamado não foi solucionado';
	      }
	      this.$aguarde('Salvando o Chamado. Por favor, aguarde...');
	      axiosLaravel.post('chamado/enviarEncerramento/', { 'parametro': this.$route.params.id, 'rating': this.rating }).then(function (response) {
	        _this10.salvaAssentamentoAutomatico(descricao);
	        _this10.$snotify.clear();
	        _this10.$snotify.success('Chamado salvo com sucesso!');
	        _this10.buscaChamado();
	      }).catch(function (error) {
	        _this10.$snotify.clear();
	        _this10.$root.trataErro(error);
	      });
	    },
	    enviarAvaliacaoEEncerrar: function enviarAvaliacaoEEncerrar() {
	      var _this11 = this;
	
	      var descricao = '';
	      if (this.problemaResolvido === 'SIM') {
	        descricao = 'O chamado avaliado e encerrado.';
	        this.$aguarde('Enviado avaliação e encerramento o Chamado. Por favor, aguarde...');
	        axiosLaravel.post('chamado/avaliarEEncerrarChamado/', { 'parametro': this.$route.params.id, 'rating': this.rating }).then(function (response) {
	          _this11.salvaAssentamentoAutomatico(descricao);
	          _this11.$snotify.clear();
	          _this11.$snotify.success('Chamado salvo com sucesso!');
	          _this11.buscaChamado();
	        }).catch(function (error) {
	          _this11.$snotify.clear();
	          _this11.$root.trataErro(error);
	        });
	      }
	    },
	    devolverChamado: function devolverChamado() {
	      var _this12 = this;
	
	      var descricaoAux = 'Chamado devolvido para Aguardando Atendimento.';
	      var descricao = '<b>' + this.resolucaoNOK + '</b>' + '<br/>' + descricaoAux;
	      this.$aguarde('Salvando o Chamado. Por favor, aguarde...');
	      axiosLaravel.post('chamado/devolverChamado/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this12.salvaAssentamentoAutomatico(descricao);
	        _this12.$snotify.clear();
	        _this12.$snotify.success('Chamado salvo com sucesso!');
	        _this12.resolucaoPreenchida = false;
	        _this12.preencheResolucao = false;
	        _this12.resolucao = '';
	        _this12.buscaChamado();
	      }).catch(function (error) {
	        _this12.$snotify.clear();
	        _this12.$root.trataErro(error);
	      });
	    },
	    salvaReclassificacao: function salvaReclassificacao() {
	      var _this13 = this;
	
	      var descricao = '';
	      if (this.areaAssuntoNovo !== this.areaAssuntoAntigo) {
	        descricao = 'Chamado reclassificado de ' + '<b>' + this.assuntoAntigo + '</b>' + ' para ' + '<b>' + this.assuntoNovo + '</b>' + '.' + '<br>' + 'Status alterado para Aguardando Atendimento';
	        this.$aguarde('Reclassificando o Chamado. Por favor, aguarde...');
	        axiosLaravel.post('chamado/salvaReclassificacaoOutraArea/', {
	          'parametro': this.$route.params.id,
	          'assunto': this.assuntoNovoId
	        }).then(function (response) {
	          _this13.salvaAssentamentoAutomatico(descricao);
	          _this13.$snotify.clear();
	          _this13.$snotify.success('Chamado salvo com sucesso!');
	          _this13.habilitaSalvarReclassificacao = false;
	          _this13.habilita = false;
	          _this13.buscaChamado();
	        }).catch(function (error) {
	          _this13.$snotify.clear();
	          _this13.$root.trataErro(error);
	        });
	      } else {
	        descricao = 'Chamado reclassificado de ' + '<b>' + this.assuntoAntigo + '</b>' + ' para ' + '<b>' + this.assuntoNovo + '</b>';
	        this.$aguarde('Reclassificando o Chamado. Por favor, aguarde...');
	        axiosLaravel.post('chamado/salvaReclassificacao/', {
	          'parametro': this.$route.params.id,
	          'assunto': this.assuntoNovoId
	        }).then(function (response) {
	          _this13.salvaAssentamentoAutomatico(descricao);
	          _this13.$snotify.clear();
	          _this13.$snotify.success('Chamado salvo com sucesso!');
	          _this13.habilitaSalvarReclassificacao = false;
	          _this13.habilita = false;
	          _this13.buscaChamado();
	        }).catch(function (error) {
	          _this13.$snotify.clear();
	          _this13.$root.trataErro(error);
	        });
	      }
	    },
	    encerrarAtendimento: function encerrarAtendimento() {
	      var _this14 = this;
	
	      var descricao = 'Chamado Encerrado';
	      this.$aguarde('Salvando o Chamado. Por favor, aguarde...');
	      axiosLaravel.post('chamado/encerrarAtendimento/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this14.salvaAssentamentoAutomatico(descricao);
	        _this14.$snotify.clear();
	        _this14.$snotify.success('Chamado salvo com sucesso!');
	        _this14.buscaChamado();
	      }).catch(function (error) {
	        _this14.$snotify.clear();
	        _this14.$root.trataErro(error);
	      });
	    },
	    encerrarAtendimentoSemAvaliacao: function encerrarAtendimentoSemAvaliacao() {
	      var _this15 = this;
	
	      var descricao = 'Chamado Encerrado sem a avaliação do usuário';
	      this.$aguarde('Salvando o Chamado. Por favor, aguarde...');
	      axiosLaravel.post('chamado/encerrarAtendimento/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this15.salvaAssentamentoAutomatico(descricao);
	        _this15.$snotify.clear();
	        _this15.$snotify.success('Chamado salvo com sucesso!');
	        _this15.buscaChamado();
	      }).catch(function (error) {
	        _this15.$snotify.clear();
	        _this15.$root.trataErro(error);
	      });
	    },
	    mostraAlterarAnalista: function mostraAlterarAnalista() {
	      this.mostraListaUsuarios = true;
	    },
	    mostraTextoNovoSuporte: function mostraTextoNovoSuporte() {
	      this.mostraTextoSuporte = true;
	    },
	    salvaNovoAnalista: function salvaNovoAnalista() {
	      var _this16 = this;
	
	      var descricao = 'Alteração do Analista responsável de ' + '<b>' + this.chamado.usuario_atendimento.ds_nome_usuario + '</b>' + ' para ' + '<b>' + this.usuarioAlterado.ds_nome_usuario + '</b>';
	      this.$aguarde('Reclassificando o Chamado. Por favor, aguarde...');
	      axiosLaravel.post('chamado/salvaNovoAnalista/', { 'parametro': this.$route.params.id, 'analista': this.usuarioAlterado.id }).then(function (response) {
	        _this16.salvaAssentamentoAutomatico(descricao);
	        _this16.$snotify.clear();
	        _this16.$snotify.success('Chamado salvo com sucesso!');
	        _this16.mostraListaUsuarios = false;
	        _this16.botaoSalvaAnalista = false;
	        _this16.buscaChamado();
	      }).catch(function (error) {
	        _this16.$snotify.clear();
	        _this16.$root.trataErro(error);
	      });
	    },
	    criarNovoSuporte: function criarNovoSuporte() {
	      var _this17 = this;
	
	      this.suporte.aberto_por = this.usuarioLogado.id;
	      this.suporte.contato = this.usuarioLogado.userName;
	      this.suporte.descricao = 'Qual a sua necessidade?<br>' + this.descricaoSuporte + '<br><br>' + 'Dados Chamado:<br> <br>' + 'N° Chamado: ' + this.chamado.id + '<br>' + 'Projeto: ' + this.chamado.projeto + '<br>' + 'Descrição do chamado: <br>' + this.chamado.descricao;
	      this.suporte.resumo_ocor = this.chamado.id;
	      this.suporte.ds_login = this.usuarioLogado.ds_login;
	      console.log('usuario', this.usuarioLogado);
	
	      this.$aguarde('Criando suporte. Por favor, aguarde...');
	      console.log('suporte', this.suporte);
	      axiosLaravel.post('chamado/criarSuporte/', { 'parametro': this.$route.params.id, 'suporte': this.suporte }).then(function (response) {
	        if (response.data.numero_suporte) {
	          _this17.link = _this17.ocomonLink(response.data.numero_suporte);
	          _this17.textoAssentamento = 'Suporte nº ' + response.data.numero_suporte + ' aberto. ';
	          _this17.salvaAssentamentoAutomatico(_this17.link);
	        }
	        _this17.$snotify.clear();
	        _this17.$snotify.success(_this17.textoAssentamento);
	        console.log(response.data.numero_suporte);
	      }).catch(function (error) {
	        _this17.$snotify.clear();
	        console.log('erro', error);
	        _this17.$root.trataErro(error);
	      });
	    },
	    ocomonLink: function ocomonLink(numero) {
	      var urlBase = 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=';
	      var url = '' + urlBase + encodeURIComponent(numero);
	      var link = 'Suporte n\xBA <a href="' + url + '" target="_blank">' + numero + '</a> aberto';
	      return link;
	    },
	    buscaUsuarios: function buscaUsuarios() {
	      var _this18 = this;
	
	      axiosLaravel.post('chamado/buscaUsuarios').then(function (response) {
	        _this18.usuarios = response.data;
	      }).catch(function (error) {
	        _this18.$root.trataErro(error);
	        _this18.loading.show = false;
	      });
	    },
	    reclassificarAssunto: function reclassificarAssunto() {
	      this.habilita = true;
	    },
	    setRating: function setRating(rating) {
	      this.rating = rating;
	    },
	    buscaAssunto: function buscaAssunto() {
	      var _this19 = this;
	
	      axiosLaravel.post('assuntos/ativos').then(function (response) {
	        _this19.assuntos = response.data;
	      }).catch(function (error) {
	        _this19.$root.trataErro(error);
	      });
	    },
	    changeUsuario: function changeUsuario(parametro) {
	      this.botaoSalvaAnalista = true;
	    },
	    etiquetaAssunto: function etiquetaAssunto(option) {
	      return '' + option.assunto;
	    },
	    etiquetaUsuario: function etiquetaUsuario(option) {
	      return '' + option.ds_nome_usuario;
	    },
	
	    changeAssunto: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(assunto) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('assunto', assunto);
	                this.areaAssuntoNovo = assunto.area_responsavel;
	                this.habilita = false;
	                this.assuntoNovo = assunto.assunto;
	                this.assuntoNovoId = assunto.id;
	                this.habilitaSalvarReclassificacao = true;
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function changeAssunto(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return changeAssunto;
	    }(),
	    irAte: function irAte() {
	      var _this20 = this;
	
	      this.$nextTick(function () {
	        _this20.$refs['assentamentoNovo'].scrollIntoView();
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this21 = this;
	
	      if (documento.file) {
	        download(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this21.$root.trataErro(error);
	        });
	      }
	    },
	    buscaCarteira: function buscaCarteira() {
	      var _this22 = this;
	
	      if (this.chamado.projeto) {
	        axiosLaravel.get('carteira/projeto/' + this.chamado.projeto).then(function (response) {
	          var idCarteiraProjeto = response.data.retorno.carteira_projeto.usu_codcart;
	          var carteiraProjeto = response.data.retorno.carteiras.find(function (e) {
	            return e.usu_codcart === idCarteiraProjeto;
	          });
	          _this22.carteira = carteiraProjeto.usu_nomcart;
	        });
	      } else {
	        return;
	      }
	    },
	    onOkDescricao: function onOkDescricao() {
	      var _this23 = this;
	
	      this.$validator.validateAll().then(function (isValid) {
	        if (!isValid) return;
	        _this23.criarNovoSuporte();
	        _this23.mostraTextoSuporte = false;
	      });
	    },
	    onCancelarDescricao: function onCancelarDescricao() {
	      this.descricaoSuporte = this.descricaoSuporteBackup;
	      this.mostraTextoSuporte = false;
	    },
	    onSelecionaProblema: function onSelecionaProblema(valor) {
	      this.suporte.prob_id = valor ? valor.prob_id : null;
	      this.problemaSelecionado = valor;
	      console.log('dhahfdj', valor);
	    }
	  }
	};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'lista-chamado',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      carteira: '',
	      carteiras: ['AABB Comunidade', 'Ajuda Humanitária', 'Educação', 'Esporte e Cultura', 'Geração de Renda', 'Meio Ambiente', 'Saúde e Bem-Estar', 'Voluntariado'],
	      qtdMeusChamados: 0,
	      listaStatus: 0,
	      areaResponsavel: '',
	      usuarioSelecionado: 0,
	      usuarios: [],
	      meusChamados: false,
	      areas: [],
	      usu: {},
	      filtro: '',
	      areasFBB: [{ id: 1, nome: 'Gerência de Pagamentos e Contratações', uor: 341862 }, { id: 2, nome: 'Gerência de Implementação e Assessoramento de Projetos', uor: 341860 }, { id: 3, nome: 'Gerência de Análise e Avaliação', uor: 341861 }],
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'id', label: 'Número do Chamado', sortable: true, thStyle: 'text-align: center; width: 7%', class: 'text-center' }, { key: 'data_inclusao', label: 'Data Abertura', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'projeto', label: 'Projeto', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'carteira', label: 'Carteira', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'status.status', label: 'Status', sortable: true, thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'assunto.assunto', label: 'Assunto', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'assunto.area_responsavel', label: 'Área Responsável', sortable: true, thStyle: 'text-align: center; width: 17%', class: 'text-center' }, { key: 'descricao', label: 'Descrição do Chamado', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'usuario_atendimento.ds_nome_usuario', label: 'Analista', sortable: true, thStyle: 'text-align: center; width: 21%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['urlLaravel', 'usuarioLogado']), {
	    itemsFiltrados: function itemsFiltrados() {
	      var area = this.areaResponsavel;
	      var carteira = this.carteira;
	      var status = Number(this.listaStatus) || 0;
	      var analista = Number(this.usuarioSelecionado) || 0;
	      var busca = (this.table.filter || '').trim().toLowerCase();
	      if (!area && !carteira && !status && !analista && !busca) {
	        return this.table.items;
	      }
	      return this.table.items.filter(function (item) {
	        if (area && _.get(item, 'assunto.area_responsavel') !== area) {
	          return false;
	        }
	        if (carteira && item.carteira !== carteira) {
	          return false;
	        }
	        if (status && Number(item.status_id) !== status) {
	          return false;
	        }
	        if (analista && Number(_.get(item, 'usuario_atendimento.id')) !== analista) {
	          return false;
	        }
	        if (busca) {
	          var campos = [item.id, item.processo_id, item.descricao, item.carteira, _.get(item, 'assunto.assunto'), _.get(item, 'assunto.area_responsavel'), _.get(item, 'status.status'), _.get(item, 'usuario_atendimento.ds_nome_usuario')];
	          var haystack = campos.filter(function (v) {
	            return v != null;
	          }).join(' ').toLowerCase();
	          if (!haystack.includes(busca)) {
	            return false;
	          }
	        }
	        return true;
	      });
	    }
	  }),
	  mounted: function mounted() {
	    var vm = this;
	    var statusMap = {
	      'Aguardando Atendimento': 1,
	      'Em Atendimento': 2,
	      'Aguardando Avaliação': 3,
	      'Chamado Avaliado': 4
	    };
	    $('#table-delegate').on('click', 'tr', function (e) {
	      var texto = $(e.target).closest('tr').find('td').first().text().trim();
	      if (texto in statusMap) {
	        vm.listaStatus = statusMap[texto];
	      }
	    });
	  },
	
	  watch: {
	    areaResponsavel: function areaResponsavel() {
	      this.table.currentPage = 1;
	    },
	    carteira: function carteira() {
	      this.table.currentPage = 1;
	    },
	    listaStatus: function listaStatus() {
	      this.table.currentPage = 1;
	    },
	    usuarioSelecionado: function usuarioSelecionado() {
	      this.table.currentPage = 1;
	    },
	    'table.filter': function tableFilter() {
	      this.table.currentPage = 1;
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loading.show = true;
	    if (this.usuarioLogado.userType === 'FUNDACAO') {
	      this.quantidadeMeusChamados();
	    }
	    this.listaAreas();
	    this.quantidadeChamados();
	    this.buscaUsuarios();
	    axiosLaravel.get('chamado/').then(function (response) {
	      _this.table.items = _this.limitarAcessoProjetos(response.data);
	      _this.table.totalRows = response.data.length;
	      _this.loading.show = false;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	      _this.loading.show = false;
	    });
	  },
	
	  methods: {
	    formata: function formata(row) {
	      return (0, _moment2.default)(row).format('DD/MM/YYYY');
	    },
	    quantidadeMeusChamados: function quantidadeMeusChamados() {
	      var _this2 = this;
	
	      axiosLaravel.post('chamado/buscaStatus', {
	        'analista': this.usuarioLogado.id
	      }).then(function (response) {
	        _this2.qtdMeusChamados = _.toArray(response.data).length;
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.loading.show = false;
	      });
	    },
	    filtraMeusChamados: function filtraMeusChamados() {
	      this.meusChamados = true;
	      this.usuarioSelecionado = this.usuarioLogado.id;
	      this.quantidadeChamadosUsuario();
	    },
	    filtraChamadosMinhaArea: function filtraChamadosMinhaArea() {
	      var _this3 = this;
	
	      this.loading.show = true;
	      this.quantidadeChamadosMinhaArea();
	      axiosLaravel.post('chamado/buscaMinhaArea', {
	        'uor': this.usuarioLogado.uor
	      }).then(function (response) {
	        _this3.table.items = _this3.limitarAcessoProjetos(_.toArray(response.data));
	        _this3.table.totalRows = _this3.table.items.length;
	        _this3.loading.show = false;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.loading.show = false;
	      });
	    },
	    limitarAcessoProjetos: function limitarAcessoProjetos(lista) {
	      var listaProjetos = lista;
	      var acessosProjetos = _.get(this.usuarioLogado, 'configuracoes.acesso_projetos');
	      if (acessosProjetos) {
	        acessosProjetos.forEach(function (projeto) {
	          if (_.find(projeto.acesso, ['codigo', 'SEM_ACESSO'])) {
	            _.remove(listaProjetos, ['projeto', projeto.numero]);
	          }
	        });
	      }
	      return listaProjetos;
	    },
	    buscaUsuarios: function buscaUsuarios() {
	      var _this4 = this;
	
	      axiosLaravel.post('chamado/buscaUsuarios').then(function (response) {
	        _this4.usuarios = response.data;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	        _this4.loading.show = false;
	      });
	    },
	    listaAreas: function listaAreas() {
	      var _this5 = this;
	
	      axiosLaravel.post('chamado/listaAreas').then(function (response) {
	        _this5.areas = response.data;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	        _this5.loading.show = false;
	      });
	    },
	    quantidadeChamados: function quantidadeChamados() {
	      var _this6 = this;
	
	      axiosLaravel.post('chamado/quantidadeChamados').then(function (response) {
	        _this6.quantidadeChamadosResult = response.data;
	        _this6.$forceUpdate();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	        _this6.loading.show = false;
	      });
	    },
	    quantidadeChamadosUsuario: function quantidadeChamadosUsuario() {
	      var _this7 = this;
	
	      axiosLaravel.post('chamado/quantidadeChamadosUsuario').then(function (response) {
	        _this7.quantidadeChamadosResult = response.data;
	        _this7.$forceUpdate();
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	        _this7.loading.show = false;
	      });
	    },
	    quantidadeChamadosMinhaArea: function quantidadeChamadosMinhaArea() {
	      var _this8 = this;
	
	      axiosLaravel.post('chamado/quantidadeChamadosMinhaArea').then(function (response) {
	        _this8.quantidadeChamadosResult = response.data;
	        _this8.$forceUpdate();
	      }).catch(function (error) {
	        _this8.$root.trataErro(error);
	        _this8.loading.show = false;
	      });
	    },
	    limpaFiltros: function limpaFiltros() {
	      this.meusChamados = false;
	      this.listaStatus = 0;
	      this.usuarioSelecionado = 0;
	      this.table.filter = '';
	      this.areaResponsavel = '';
	      this.carteira = '';
	      this.table.currentPage = 1;
	      this.quantidadeChamados();
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'relatorio-chamado',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      link: 'https://app.powerbi.com/view?r=eyJrIjoiYzU0MzNhNzctNmI1YS00MTU0LTkxZDAtMmVlOGI1ODIyOTIzIiwidCI6ImQ1MWI3ZWQ5LWUxOWMtNDBmNi04YmNkLWNiMzE2NmJiYmRiNiJ9'
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {
	    this.link = 'https://app.powerbi.com/view?r=eyJrIjoiYzU0MzNhNzctNmI1YS00MTU0LTkxZDAtMmVlOGI1ODIyOTIzIiwidCI6ImQ1MWI3ZWQ5LWUxOWMtNDBmNi04YmNkLWNiMzE2NmJiYmRiNiJ9';
	    this.$forceUpdate();
	  },
	  created: function created() {},
	
	  methods: {}
	};

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'editar-documento',
	  data: function data() {
	    return {
	      documento: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      axiosLaravel.get('documentos/tipo-documento/' + this.$route.params.id).then(function (response) {
	        _this.documento = response.data;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	
	  methods: {
	    salva: function salva() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.documento.id) {
	            _this2.atualiza();
	          } else {
	            _this2.grava();
	          }
	        } else {
	          _this2.errors.items.forEach(function (item) {
	            _this2.$snotify.clear();
	            _this2.$snotify.error(item.msg, '', _this2.$root._data.error);
	          });
	        }
	      });
	    },
	    atualiza: function atualiza() {
	      var _this3 = this;
	
	      axiosLaravel.put('documentos/tipo-documento/' + this.documento.id, this.documento).then(function (response) {
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Documento salvo com sucesso', '', _this3.$root._data.sucesso);
	        _this3.$router.go(-1);
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this4 = this;
	
	      axiosLaravel.post('documentos/tipo-documento/', this.documento).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Documento salvo com sucesso', '', _this4.$root._data.sucesso);
	        _this4.$router.go(-1);
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'lista-tipo-documentos',
	  data: function data() {
	    return {
	      items: [],
	      hover: true,
	      bordered: true,
	      currentPage: 1,
	      perPage: 10,
	
	      filter: null,
	      sortBy: 'ds_tipo',
	      sortDesc: false,
	      emptyText: 'Não há registros a serem mostrados',
	      fields: [{ key: 'ds_tipo', label: 'Tipo de Documento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'dt_data_inclusao', label: 'Data de Adição', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'dt_data_vigencia', label: 'Data de Inativação', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 15%', class: 'text-center' }],
	      filtros: {
	        beginAdded: null,
	        beginAddedDate: null,
	        endAddedDate: null,
	        beginInactivateDate: null,
	        endInactivateDate: null,
	        type: null
	      },
	      loading: {
	        show: false
	      }
	    };
	  },
	  created: function created() {
	    this.buscaTipos();
	  },
	
	  computed: {
	    totalRows: {
	      get: function get() {
	        return this.items.length;
	      },
	      set: function set() {}
	    }
	  },
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    onNew: function onNew() {},
	    clear: function clear() {
	      this.filtros = {};
	      this.buscaTipos();
	    },
	    buscaTipos: function buscaTipos() {
	      var _this = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('/documentos/tipo-documento', this.filtros).then(function (response) {
	        _this.items = response.data;
	
	        _this.loading.show = false;
	        _this.filtros = {};
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'editar-edital',
	  data: function data() {
	    return {
	      edital: {
	        opcoes: {
	          acesso: {
	            antecipado: false
	          }
	        }
	      },
	      loading: {
	        tela: false
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      this.loading.tela = true;
	      axiosLaravel.get('editais/' + this.$route.params.id).then(function (response) {
	        _this.edital = response.data;
	        _this.edital.dt_data_inicial = (0, _moment2.default)(_this.edital.dt_data_inicial).format('DD/MM/YYYY');
	        _this.edital.dt_data_final = (0, _moment2.default)(_this.edital.dt_data_final).format('DD/MM/YYYY');
	        _this.loading.tela = false;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.tela = false;
	      });
	    }
	  },
	
	  methods: {
	    salva: function salva() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.edital.id) {
	            _this2.atualiza();
	          } else {
	            _this2.grava();
	          }
	        } else {
	          _this2.errors.items.forEach(function (item) {
	            _this2.$snotify.error(item.msg);
	          });
	        }
	      });
	    },
	    atualiza: function atualiza() {
	      var _this3 = this;
	
	      this.loading.tela = true;
	      this.$aguarde('Salvando o Edital. Por favor, aguarde...');
	      axiosLaravel.put('editais/' + this.edital.id, this.edital).then(function (response) {
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Edital salvo com sucesso!');
	        _this3.loading.tela = false;
	        _this3.$router.go(-1);
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.loading.tela = false;
	        _this3.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this4 = this;
	
	      this.loading.tela = true;
	      this.$aguarde('Salvando o Edital. Por favor, aguarde...');
	      axiosLaravel.post('editais', this.edital).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Edital salvo com sucesso!');
	        _this4.loading.tela = false;
	        _this4.$router.go(-1);
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.loading.tela = false;
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'lista-editais',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'bt_ativo',
	        sortDesc: true,
	        fields: [{ key: 'ds_numero_edital', label: 'Tipo do Edital', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'parametro', label: 'Parâmetro URL', sortable: true, thStyle: 'text-align: center; width: 30%', class: 'text-center' }, { key: 'dt_data_inicial', label: 'Data Inicial', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'dt_data_final', label: 'Data Final', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'edicao', label: 'Edição', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['urlLaravel'])),
	  created: function created() {
	    var _this = this;
	
	    this.loading.show = true;
	    axiosLaravel.get('editais/').then(function (response) {
	      _this.table.items = response.data;
	      _this.loading.show = false;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	      _this.loading.show = false;
	    });
	  },
	
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    inativa: function inativa(item) {
	      var _this2 = this;
	
	      console.log('item', item);
	      axiosLaravel.delete('editais/' + item.id).then(function (response) {
	        _this2.$snotify.success('Edital ' + item.ds_numero_edital + ' atualizado com sucesso!');
	        item.bt_ativo = !item.bt_ativo;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentos: _uploadDocumentos2.default,
	    Usuarios: _usuarios2.default
	  },
	  name: 'entidade-credenciamento',
	  data: function data() {
	    return {
	      loading: false,
	      tiposArquivos: [],
	      campoErro: null,
	      jaExiste: false,
	      usuario: {
	        ds_cpf: ''
	      },
	      dt_data_expedicao_cnpj: '',
	      entidade: {
	        ds_cnpj: '',
	        ds_cpf: '',
	        dt_data_expedicao_cnpj: '',
	        usuarios: [],
	        tipoDocumentos: []
	      },
	      emailConfirmacao: '',
	      emailConfirmacaoEnt: '',
	      entidadesExistentes: [],
	
	      possuiCebas: 'Não',
	      possuiCmas: 'Não'
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    dt_data_expedicao_cnpj: function dt_data_expedicao_cnpj(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.entidade.dt_data_expedicao_cnpj = newdate.format('YYYY-MM-DD');
	      }
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.localUso === undefined) {
	      this.localUso = 'TODOS';
	    }
	    axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	      _this.tiposArquivos = response.data;
	
	      _this.loading = false;
	    }).catch(function (error) {
	      _this.loading = false;
	      _this.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this2 = this;
	
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this2.entidade.tipoDocumentos = response.data.configuracao_entidade.documentos_obrigatorios;
	        _this2.loading = false;
	      }).catch(function (error) {
	        _this2.loading = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    limpar: function limpar() {
	      this.entidade.ds_nome = '';
	      this.entidade.ds_cnpj = '';
	      this.entidade.ds_login = '';
	      this.usuario.ds_telefone = '';
	      this.entidade.dt_data_expedicao_cnpj = '';
	      this.entidade.ds_nome_fantasia = '';
	      this.entidade.ds_email = '';
	      this.emailConfirmacaoEnt = '';
	      this.usuario.ds_nome_usuario = '';
	      this.usuario.ds_cpf = '';
	      this.usuario.ds_email = '';
	      this.usuario.ds_login = '';
	      this.emailConfirmacao = '';
	    },
	    conclui: function conclui() {
	      var _this3 = this;
	
	      this.loading = true;
	      this.entidade.ds_tipo_registro = 'CREDENCIAMENTO';
	      this.entidade.ds_fase_registro = 'CREDENCIAMENTO';
	      this.entidade.ds_status = 'INCOMPLETO';
	      var entidadeOK = true;
	      if (entidadeOK) {
	        this.$validator.validateAll().then(function (result) {
	          if (result) {
	            if (_this3.usuario.ds_email !== _this3.emailConfirmacao) {
	              _this3.$snotify.error('O formulário possui erros. Favor verificar!');
	              return;
	            }
	            if (_this3.entidade.ds_email !== _this3.emailConfirmacaoEnt) {
	              _this3.$snotify.error('O formulário possui erros. Favor verificar!');
	              return;
	            }
	            if (_this3.entidade.ds_email === _this3.usuario.ds_email) {
	              _this3.$snotify.error('Os e-mails da entidade e do usuário não podem ser iguais. Favor verificar!');
	              return;
	            }
	            if (_this3.jaExiste === true) {
	              _this3.$snotify.error('O login informado já existe. Favor verificar!');
	              return;
	            }
	
	            if (_this3.entidadesExistentes.length > 0 && _.has(_this3.entidadesExistentes[0], 'ds_nome') && !_.isNull(_this3.entidadesExistentes[0].ds_nome)) {
	              _this3.$snotify.error('O CNPJ informado já está cadastrado!');
	              return;
	            }
	            if (_this3.jaExisteMail === true) {
	              _this3.$snotify.error('O e-mail da entidade informado já existe. Favor verificar!');
	              return;
	            }
	            if (_this3.jaExisteMailUsu === true) {
	              _this3.$snotify.error('O e-mail do usuário informado já existe. Favor verificar!');
	              return;
	            }
	
	            _this3.usuario.ds_cpf = _this3.usuario.ds_cpf.replace('.', '');
	            _this3.usuario.ds_cpf = _this3.usuario.ds_cpf.replace('.', '');
	            _this3.usuario.ds_cpf = _this3.usuario.ds_cpf.replace('-', '');
	            _this3.entidade.ds_cnpj = _this3.entidade.ds_cnpj.replace('.', '');
	            _this3.entidade.ds_cnpj = _this3.entidade.ds_cnpj.replace('.', '');
	            _this3.entidade.ds_cnpj = _this3.entidade.ds_cnpj.replace('.', '');
	            _this3.entidade.ds_cnpj = _this3.entidade.ds_cnpj.replace('/', '');
	            _this3.entidade.ds_cnpj = _this3.entidade.ds_cnpj.replace('-', '');
	            _this3.entidade.ds_login = _this3.entidade.ds_cnpj;
	            var obj = _.cloneDeep(_this3.usuario);
	            var resultArray = [];
	            resultArray.push(obj);
	            _this3.entidade.usuarios = _.cloneDeep(resultArray);
	            _this3.$aguarde('Credenciando a entidade. Por favor, aguarde...');
	            _this3.loading = false;
	            axiosLaravel.post('entidades/', _this3.entidade).then(function (response) {
	              _this3.$snotify.clear();
	              _this3.$snotify.success('Entidade credenciada com sucesso!');
	              _this3.loading = false;
	              setTimeout(function () {
	                _this3.$router.go(-1);
	              }, 1000);
	            }).catch(function (error) {
	              _this3.loading = false;
	              console.log(error.response);
	              _this3.$snotify.clear();
	              _this3.$root.trataErro(error);
	            });
	          }
	        });
	      }
	      this.loading = false;
	    },
	    verificaUsuario: function verificaUsuario() {
	      var _this4 = this;
	
	      axiosLaravel.post('/verifica-usuario/', { 'parametro': this.usuario.ds_login }).then(function (response) {
	        if (response.data.length > 0) {
	          _this4.jaExiste = true;
	          var field = _this4.$validator.fields.find({ name: 'Login' });
	          field.setFlags({ invalid: true });
	          _this4.errors.add({
	            field: 'Login',
	            msg: response.data,
	            id: field.id,
	            scope: field.scope
	          });
	        } else {
	          _this4.jaExiste = false;
	        }
	      }).catch(function (error) {
	        if (error) {
	          _this4.$root.trataErro(error);
	        }
	      });
	    },
	    verificaEmailEntidade: function verificaEmailEntidade() {
	      var _this5 = this;
	
	      axiosLaravel.post('/verifica-usuario/', { 'parametro': this.entidade.ds_email }).then(function (response) {
	        if (response.data.length > 0) {
	          _this5.jaExisteMail = true;
	          var field = _this5.$validator.fields.find({ name: 'EmailEnt' });
	          field.setFlags({ invalid: true });
	          _this5.errors.add({
	            field: 'EmailEnt',
	            msg: response.data,
	            id: field.id,
	            scope: field.scope
	          });
	        } else {
	          _this5.jaExisteMail = false;
	        }
	      }).catch(function (error) {
	        if (error) {
	          _this5.$root.trataErro(error);
	        }
	      });
	    },
	    verificaEmailUsuario: function verificaEmailUsuario() {
	      var _this6 = this;
	
	      axiosLaravel.post('/verifica-usuario/', { 'parametro': this.usuario.ds_email }).then(function (response) {
	        if (response.data.length > 0) {
	          _this6.jaExisteMailUsu = true;
	          var field = _this6.$validator.fields.find({ name: 'userEmail' });
	          field.setFlags({ invalid: true });
	          _this6.errors.add({
	            field: 'userEmail',
	            msg: response.data,
	            id: field.id,
	            scope: field.scope
	          });
	        } else {
	          _this6.jaExisteMailUsu = false;
	        }
	      }).catch(function (error) {
	        if (error) {
	          _this6.$root.trataErro(error);
	        }
	      });
	    },
	    verificaCNPJEntidade: function verificaCNPJEntidade() {
	      var _this7 = this;
	
	      this.loading = true;
	      axiosLaravel.post('/entidade/cnpj/', { 'cnpj': this.entidade.ds_cnpj }).then(function (response) {
	        _this7.entidadesExistentes = response.data;
	        _this7.loading = false;
	      }).catch(function (error) {
	        _this7.loading = false;
	        if (error) {
	          _this7.$root.trataErro(error);
	        }
	      });
	    },
	    onChangeCebasCmas: function onChangeCebasCmas($event) {
	      var value = $event.target.value;
	      var name = $event.target.name;
	      if (name === 'possuiCmas') {
	        if (value === 'Sim') {
	          this.entidade.tipoDocumentos.push(this.tiposArquivos.find(function (e) {
	            return e.id === 70;
	          }));
	        } else if (value === 'Não') {
	          var index = this.entidade.tipoDocumentos.findIndex(function (e) {
	            return e.id === 70;
	          });
	          if (index > 0) {
	            this.entidade.tipoDocumentos.splice(index, 1);
	          }
	        }
	      } else if (name === 'possuiCebas') {
	        if (value === 'Sim') {
	          this.entidade.tipoDocumentos.push(this.tiposArquivos.find(function (e) {
	            return e.id === 71;
	          }));
	        } else {
	          var _index = this.entidade.tipoDocumentos.findIndex(function (e) {
	            return e.id === 71;
	          });
	          if (_index > 0) {
	            this.entidade.tipoDocumentos.splice(_index, 1);
	          }
	        }
	      }
	    },
	    removeDocumento: function removeDocumento(doc) {
	      var index = this.entidade.tipoDocumentos.findIndex(function (e) {
	        return e.id === doc.id;
	      });
	      this.entidade.tipoDocumentos.splice(index, 1);
	      if (doc.id === 70) {
	        this.possuiCmas = 'Não';
	      } else if (doc.id === 71) {
	        this.possuiCebas = 'Não';
	      }
	    }
	  }
	};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _historicoEntidade = __webpack_require__(105);
	
	var _historicoEntidade2 = _interopRequireDefault(_historicoEntidade);
	
	var _assinaturaDirigentes = __webpack_require__(511);
	
	var _assinaturaDirigentes2 = _interopRequireDefault(_assinaturaDirigentes);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    HistoricoEntidade: _historicoEntidade2.default,
	    Usuarios: _usuarios2.default,
	    assinaturaDirigentes: _assinaturaDirigentes2.default
	  },
	  name: 'cadastro-entidade-edita',
	  data: function data() {
	    return {
	      loading: {
	        tela: true,
	        poderes: true
	      },
	      propostas: [],
	      projetos: [],
	      hoje: new Date(),
	      propostaUnicaEditalVigente: false,
	      poderes: [],
	      titulo: 'SGP',
	      campoErro: null,
	      restricaParaConcluir: [],
	      entidade: {
	        contato: {},
	        dirigentes: [],
	        documentos: [],
	        usuarios: [],
	        proximaEtapa: ''
	      },
	      salvouOK: false,
	      boqueia: false,
	      dirigentes: [],
	      contEndereco: 0,
	      listaRamosAtividade: [],
	      endereco: [],
	      historico: [],
	      historico_atualizado: [],
	      listaHistorico: [],
	      usuarios: [],
	      tarefas: [],
	      documentosExidigidos: false,
	      representanteLegalAtivo: false,
	      cont: 0,
	      existePrincipal: false,
	      listaFormasJuridicas: [],
	      mostraHistorico: false,
	      listaDocConstituicao: [],
	      listaDocEntidades: 'CADASTRO_ENTIDADE',
	      data_expedicao_cnpj: '',
	      erroData: false,
	      urlLaravel: 'https://projetos.fbb.org.br:5443',
	
	      possuiCmas: '',
	      possuiCebas: '',
	      tiposArquivos: []
	    };
	  },
	
	  watch: {
	    data_expedicao_cnpj: function data_expedicao_cnpj(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.entidade.dt_data_expedicao_cnpj = newdate.format('YYYY-MM-DD');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {},
	  created: function created() {
	    var _this = this;
	
	    this.loading.tela = true;
	
	    this.propostas = _.get(JSON.parse(window.localStorage.getItem('propostas')), 'lista', []);
	    this.projetos = _.get(JSON.parse(window.localStorage.getItem('projetos')), 'lista', []);
	    this.cadastroEntidadeRefEdital();
	    this.$aguarde('Buscando dados da Entidade. Por favor, aguarde...');
	    if (this.$route.params.id) {
	      axiosLaravel.get('entidades/' + this.$route.params.id).then(function (response) {
	        _this.entidade = response.data;
	
	        _this.entidade.tipos_documento = _.filter(_this.entidade.tipos_documento, function (v) {
	          return v !== null;
	        });
	        _this.entidade.observacao = '';
	        _this.$route.params.entidade = _this.entidade;
	        if (_.isObject(_this.entidade.forma_juridica) === false) {
	          _this.entidade.forma_juridica = [];
	        }
	        if (_.isObject(_this.entidade.documento_constituicao) === false) {
	          _this.entidade.documento_constituicao = [];
	        }
	        _this.carregaListaFormasJuridicas();
	        _this.carregaListaRamosAtividade();
	        _this.carregaListaDocumentosConstituicao();
	        if (_.isNull(_this)) {
	          _this.verificaUsuarioDirigente();
	        }
	        _this.verificar();
	        _this.buscaTiposArquivos();
	        _this.$snotify.clear();
	        _this.data_expedicao_cnpj = (0, _moment2.default)(_this.entidade.dt_data_expedicao_cnpj).format('DD/MM/YYYY');
	
	        _this.processos = response.data.processos;
	        _this.cnpj = _this.entidade.cnpj;
	        _this.dirigentes = response.data.dirigentes;
	        _this.verificarDirigenteAtivo();
	        _this.tarefas = _this.processos.map(function (item) {
	          return item.tarefas;
	        });
	        _this.historico = _this.tarefas;
	        _this.historico = _.sortBy(_this.historico, 'id').reverse();
	
	        _this.$snotify.clear();
	
	        _this.$snotify.success('Dados da Entidade recuperados com sucesso!', { timeout: 2000 });
	        _this.titulo = 'SGP' + (_.has(_this.entidade, 'ds_nome') ? ' - ' + _this.entidade.ds_nome : '');
	
	        if (_this.entidade.tipos_documento.findIndex(function (e) {
	          return e.id === 70;
	        }) >= 0 || _this.entidade.documentos.findIndex(function (e) {
	          return e.tipo_documento.id === 70;
	        }) >= 0) {
	          _this.possuiCmas = 'Sim';
	        } else {
	          _this.possuiCmas = 'Não';
	        }
	        if (_this.entidade.tipos_documento.findIndex(function (e) {
	          return e.id === 71;
	        }) >= 0 || _this.entidade.documentos.findIndex(function (e) {
	          return e.tipo_documento.id === 71;
	        }) >= 0) {
	          _this.possuiCebas = 'Sim';
	        } else {
	          _this.possuiCebas = 'Não';
	        }
	
	        _this.loading.tela = false;
	        _this.$forceUpdate();
	
	        if (_this.entidade.ds_tipo_registro === 'CREDENCIAMENTO' && _this.entidade.edital) {
	          _this.boqueia = true;
	          return;
	        }
	      }).catch(function (error) {
	        if (error) {
	          _this.loading.tela = false;
	          _this.$snotify.clear();
	          _this.$root.trataErro(error);
	        }
	      });
	    }
	  },
	
	  methods: {
	    adicionaRestricao: function adicionaRestricao(ev) {
	      if (!_.isNil(ev) && _.has(ev, 'tag')) {
	        _.remove(this.restricaParaConcluir, function (i) {
	          return i.tag === ev.tag;
	        });
	
	        this.restricaParaConcluir.push(ev);
	      }
	    },
	    etiquetaListaFormaJuridica: function etiquetaListaFormaJuridica(option) {
	      return '' + (option.codigo + ' / ' + option.descricao);
	    },
	    etiquetaListaRamosAtividade: function etiquetaListaRamosAtividade(option) {
	      return '' + (option.ds_codigo + '    ' + option.ds_descricao);
	    },
	    cadastroEntidadeRefEdital: function cadastroEntidadeRefEdital() {
	      var propostas = _.cloneDeep(this.propostas);
	
	      _.remove(propostas, function (p) {
	        return !_.isNull(p.ds_codigo_projeto_erp);
	      });
	      var dataTerminoEdital = _.get(propostas[0], 'dt_data_final');
	
	      this.propostaUnicaEditalVigente = propostas.length === 1 && !_.isNull(dataTerminoEdital) && new Date(dataTerminoEdital).getTime() >= this.hoje.getTime();
	      console.log('Tem uma só proposta e é de edital vigente', this.propostaUnicaEditalVigente);
	    },
	    isEditable: function isEditable() {
	      return this.$root.authorize('entidade-editar') || this.$root.authorize('minha-entidade-editar');
	    },
	    verificar: function verificar() {
	      if (!this.entidade.contato.ds_telefone) {
	        this.entidade.contato = {};
	        this.entidade.contato.ds_telefone = '';
	        this.entidade.contato.ds_celular = '';
	      }
	    },
	    carregaListaFormasJuridicas: function carregaListaFormasJuridicas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this2.$root.buscaFormasJuridicas(_this2.$store);
	
	              case 2:
	                _this2.listaFormasJuridicas = _this2.$store.state.formasJuridicas;
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    carregaListaRamosAtividade: function carregaListaRamosAtividade() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _this3.$root.buscaRamoAtividades(_this3.$store);
	
	              case 2:
	                _this3.listaRamosAtividade = _this3.$store.state.ramoAtividades;
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    },
	    verificarDirigenteAtivo: function verificarDirigenteAtivo(lista) {
	      var dirigentes = lista || this.entidade.dirigentes || [];
	      var temPoderes = dirigentes.some(function (item) {
	        var btAtivo = Number(item.bt_ativo);
	        var btRepresentanteLegal = Number(item.bt_representante_legal);
	
	        var fkCargoMandato = Number(item.fk_cargo_mandato) || Number(_.get(item, 'cargo.ds_codigo', 0));
	        return btAtivo === 1 && btRepresentanteLegal === 1 || btAtivo === 1 && fkCargoMandato === 12;
	      });
	      this.adicionaRestricao({
	        'tag': 'semDirigenteAtivo',
	        'ativo': !temPoderes,
	        'tipo': 'restricao',
	        'acao': null,
	        'mensagem': 'Cadastro sem representante legal ativo. Para a conclusão desta solicitação é necessário o cadastramento pelo menos um representante legal ou designado.'
	      });
	    },
	    onDirigenteSalvo: function onDirigenteSalvo(lista) {
	      this.entidade.dirigentes = lista;
	      this.gravarCadastroEntidade('SALVAR');
	    },
	    carregaListaDocumentosConstituicao: function carregaListaDocumentosConstituicao() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return axiosLaravel.post('documentos/tipos/ENTIDADE_DOC_CONSTITUICAO').then(function (response) {
	                  _this4.listaDocConstituicao = response.data;
	                }).catch(function (error) {
	                  _this4.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    },
	    outrasValidacoes: function outrasValidacoes() {
	      if (!this.entidade.dirigentes || this.entidade.dirigentes === 0) {
	        this.$snotify.error('Os dados obrigatórios do dirigente devem ser preenchidos!');
	        return false;
	      }
	      return true;
	    },
	    salvaUsuarios: function salvaUsuarios() {
	      if (this.entidade.usuarios) {
	        for (var i = 0; i < this.entidade.usuarios.length; i++) {
	          if (!this.entidade.usuarios[i].ds_tipo_usuario) {
	            this.entidade.usuarios[i].ds_tipo_usuario = 'ENTIDADE';
	
	            this.entidade.usuarios[i].fk_entidade = this.entidade.id;
	            this.entidade.usuarios[i].fk_usuario_criador = this.usuarioLogado.id;
	            this.entidade.usuarios[i].fk_preferencia = null;
	            this.entidade.usuarios[i].dt_data_inativacao = null;
	            this.entidade.usuarios[i].fk_agencia = null;
	            this.entidade.usuarios[i].fk_parceiro_estrategico = null;
	            this.entidade.usuarios[i].fk_superintendencia = null;
	          }
	        }
	      }
	    },
	    verificaDocumentosExigidos: function verificaDocumentosExigidos() {
	      var _this5 = this;
	
	      if (this.entidade.tipos_documento.length > this.entidade.documentos.length) {
	        this.documentosExidigidos = false;
	        return;
	      }
	
	      var iguais = [];
	      this.cont = 0;
	      this.entidade.documentos.forEach(function (doc) {
	        _this5.entidade.tipos_documento.forEach(function (tipo) {
	          if (tipo.id === doc.tipo_documento.id) {
	            iguais.push(doc.tipo_documento.id);
	            _this5.cont++;
	          }
	        });
	      });
	      console.log('Cont: ' + this.cont);
	      console.log('Tipos: ' + this.entidade.tipos_documento.length);
	      console.log('Docs: ' + this.entidade.documentos.length);
	      console.log('Iguais: ' + iguais.length);
	      var unicos = [];
	      if (this.entidade.documentos.length >= this.entidade.tipos_documento.length) {
	        if (iguais.length >= this.entidade.tipos_documento.length) {
	          iguais.forEach(function (i) {
	            if (!unicos.includes(i)) {
	              unicos.push(i);
	            }
	          });
	        }
	      }
	      console.log('Unicos: ' + unicos.length);
	
	      if (this.cont >= this.entidade.tipos_documento.length && unicos.length === this.entidade.tipos_documento.length) {
	        this.documentosExidigidos = true;
	      }
	    },
	    verificaUsuarioDirigente: function verificaUsuarioDirigente() {
	      var _this6 = this;
	
	      if (this.usuarioLogado.userType !== 'FUNDACAO') {
	        this.loading.poderes = true;
	        axiosLaravel.get('projeto/usuario/dirigente').then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            if (!_.isNull(response.data.retorno)) {
	              _.remove(_this6.poderes, 'PERMITE_CONCLUIR');
	              _this6.adicionaRestricao({ 'tag': 'semPoderesParaConcluir', 'ativo': true, 'tipo': 'restricao', 'acao': null, 'mensagem': response.data.retorno + '. A conclusão e envio desta solicitação deverá ser realizada pelo representante legal ou designado.' });
	            } else {
	              _this6.poderes.push('PERMITE_CONCLUIR');
	            }
	            _this6.poderes = _.uniq(_this6.poderes);
	          } else {
	            _this6.$snotify.error(response.data.mensagem[0]);
	          }
	          _this6.loading.poderes = false;
	        }).catch(function (error) {
	          _this6.loading.poderes = false;
	          console.log('error', error);
	          _this6.$root.trataErro(error);
	        });
	      } else {
	        this.poderes.push('PERMITE_CONCLUIR');
	      }
	    },
	    permiteConcluir: function permiteConcluir(obj) {
	      var vm = this;
	      this.$dialog.confirm('<p>Atenção!</p>Declaro que todas as informações fornecidas neste cadastro são verdadeiras, precisas e completas.<br/>Comprometo-me a informar imediatamente qualquer alteração nas informações prestadas.<br/>Adicionalmente, atesto que os documentos anexados a este cadastro são legítimos e autênticos.<br/>Estou ciente de que a apresentação de informações falsas ou documentos fraudulentos pode resultar em sanções legais.<br/>Assumo total responsabilidade pela veracidade das informações prestadas.', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        if (vm.restricaParaConcluir.length > 0 && _.filter(vm.restricaParaConcluir, { 'ativo': true }).length > 0) {
	          var restricoes = _.filter(vm.restricaParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	          var informacoes = _.filter(vm.restricaParaConcluir, { 'ativo': true, 'tipo': 'informacao' });
	          var confirmacoes = _.filter(vm.restricaParaConcluir, { 'ativo': true, 'tipo': 'confirmacao' });
	          if (restricoes.length > 0) {
	            var mensagens = '<div class=avisoAlerta><li>' + _.join(_.map(restricoes, 'mensagem'), '<li>') + '</div>';
	            vm.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	          } else {
	            if (informacoes.length > 0) {
	              var _mensagens = '<div class=avisoInfo><li>' + _.join(_.map(informacoes, 'mensagem'), '<li>') + '</div>';
	              vm.$dialog.alert(_mensagens, { html: true, animation: 'fade', customClass: 'avisoInfo' }).then(function (dialog) {
	                _.forEach(vm.restricaParaConcluir, function (item) {
	                  if (item.tipo === 'informacao') {
	                    _set(item, 'ativo', false);
	                  }
	                });
	              });
	            } else if (confirmacoes.length > 0) {
	              var _mensagens2 = '<div class=avisoConfirmacao><li>' + _.join(_.map(confirmacoes, 'mensagem'), '<li>') + '</div>';
	              vm.$dialog.confirm(_mensagens2, { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	                _.forEach(vm.restricaParaConcluir, function (item) {
	                  if (item.tipo === 'confirmacao') {
	                    _set(item, 'ativo', false);
	                  }
	                });
	              }).catch(function () {});
	
	              if (informacoes.length === 0 & confirmacoes.length === 0) {
	                vm.concluir(obj);
	              }
	            }
	          }
	        } else {
	          vm.concluir(obj);
	        }
	      }).catch(function () {});
	    },
	    concluir: function concluir() {
	      var _this7 = this;
	
	      var vm = this;
	      var entidadeOK = true;
	      var aba = '';
	      if (_.isEmpty(this.entidade.endereco)) {
	        entidadeOK = false;
	        aba = 'Endereço';
	      }
	      if (_.isEmpty(this.entidade.dirigentes)) {
	        entidadeOK = false;
	        aba = 'Dirigentes';
	      }
	      if (_.isEmpty(this.entidade.documentos)) {
	        entidadeOK = false;
	        aba = 'Documentos';
	      }
	
	      this.verificaDocumentosExigidos();
	      if (this.documentosExidigidos === false) {
	        this.$snotify.error('Favor Preencher Documentos Pendentes!');
	        return;
	      }
	
	      if (entidadeOK === true) {
	        this.entidade.endereco.forEach(function (end) {
	          if (end.bt_principal && (end.bt_principal === true || end.bt_principal === 1)) {
	            _this7.existePrincipal = true;
	            _this7.contEndereco++;
	          } else {
	            _this7.existePrincipal = false;
	          }
	        });
	        if (this.existePrincipal === false && this.contEndereco === 0) {
	          this.$snotify.error('Favor sinalizar um Endereço como Principal!');
	          return;
	        }
	
	        this.$validator.validateAll().then(function (result) {
	          if (result) {
	            _this7.outrasValidacoes();
	            if (_this7.entidade.id) {
	              if (_this7.usuarioLogado.userType === 'ENTIDADE') {
	                _this7.$dialog.confirm('Ao confirmar será enviado esse cadastro para Fundação', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	                  vm.gravarCadastroEntidade('ANALISE');
	                }).catch(function () {
	                  console.log('Aviso de Confirmações fechado SEM confirmar conclusão de cadastro de entidade');
	                });
	              } else {
	                _this7.gravarCadastroEntidade('ANALISE');
	              }
	            }
	          } else {
	            _this7.$snotify.error('O formulário de Dados da Entidade possui erros. Favor verificar!');
	          }
	        });
	      } else {
	        this.boqueia = false;
	        this.$snotify.error('Erros no preenchimento da aba ' + aba + '. Favor verificar.');
	      }
	    },
	    devolverRevisao: function devolverRevisao() {
	      var vm = this;
	      this.$dialog.confirm('Esse cadastro foi enviado para Análise da FBB.<br/>Ao confirmar, ele será enviado para revisão da entidade, enquanto o edital não estiver finalizado', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        vm.loading.tela = true;
	        vm.$aguarde('Devolvendo cadastro para revisão da entidade. Por favor, aguarde...');
	        vm.entidade.proximaEtapa = 'REVISAO';
	        vm.salvaUsuarios();
	        axiosLaravel.put('entidades/' + vm.entidade.id, vm.entidade).then(function (response) {
	          if (response.data) {
	            vm.$snotify.clear();
	            vm.$snotify.success('Cadastro devolvido com sucesso! Abrindo o cadastro da entidade...');
	            setTimeout(function () {
	              location.reload(true);
	            }, 3000);
	            vm.loading.tela = false;
	          }
	        }).catch(function (error) {
	          vm.$snotify.clear();
	          vm.loading.tela = false;
	          vm.$root.trataErro(error);
	        });
	      }).catch(function () {
	        console.log('Aviso de Confirmações fechado SEM confirmar devolução para revisão');
	      });
	    },
	    salvar: function salvar() {
	      var vm = this;
	      if (this.usuarioLogado.userType === 'ENTIDADE') {
	        this.$dialog.confirm('Salvamento desse cadastro não implica em enviou ainda para Fundação BB', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	          vm.gravarCadastroEntidade('SALVAR');
	        }).catch(function () {
	          console.log('Aviso de Confirmações fechado SEM confirmar salvamento de cadastro de entidade');
	        });
	      } else {
	        this.gravarCadastroEntidade('SALVAR');
	      }
	    },
	    gravarCadastroEntidade: function gravarCadastroEntidade(etapa) {
	      var _this8 = this;
	
	      if (this.$refs.componenteDirigentes) {
	        this.entidade.dirigentes = this.$refs.componenteDirigentes.table.items;
	      }
	      var concluir = etapa !== 'SALVAR';
	      this.loading.tela = true;
	      this.boqueia = true;
	      this.$aguarde(concluir ? 'Gravando cadastro' : 'Atualizando dados' + ' da entidade. Por favor, aguarde...');
	      this.entidade.proximaEtapa = etapa;
	      this.salvaUsuarios();
	      axiosLaravel.put('entidades/' + this.entidade.id, this.entidade).then(function (response) {
	        if (response.data) {
	          _this8.$snotify.clear();
	          _this8.$snotify.success(concluir ? 'Alteração cadastral concluída com sucesso!' : 'Entidade salva com sucesso!');
	          _this8.boqueia = false;
	          _this8.loading.tela = false;
	          if (!concluir) {
	            _this8.$emit('salvou', 'OK');
	            _this8.salvouOK = true;
	          } else {
	            _this8.$router.go(-1);
	          }
	        }
	      }).catch(function (error) {
	        _this8.$snotify.clear();
	        _this8.loading.tela = false;
	        _this8.boqueia = false;
	        _this8.$root.trataErro(error);
	      });
	    },
	    buscaTiposArquivos: function buscaTiposArquivos() {
	      var _this9 = this;
	
	      if (this.localUso === undefined) {
	        this.localUso = 'TODOS';
	      }
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this9.tiposArquivos = response.data;
	      }).catch(function (error) {
	        _this9.$root.trataErro(error);
	      });
	    },
	    onChangeCebasCmas: function onChangeCebasCmas($event) {
	      var name = $event.target.name;
	      var value = $event.target.value;
	      if (name === 'possuiCmas') {
	        if (value === 'Sim') {
	          this.entidade.tipos_documento.push(this.tiposArquivos.find(function (e) {
	            return e.id === 70;
	          }));
	        } else if (value === 'Não') {
	          var index = this.entidade.tipos_documento.findIndex(function (e) {
	            return e.id === 70;
	          });
	          if (index > 0) {
	            this.entidade.tipos_documento.splice(index, 1);
	          }
	        }
	      } else if (name === 'possuiCebas') {
	        if (value === 'Sim') {
	          this.entidade.tipos_documento.push(this.tiposArquivos.find(function (e) {
	            return e.id === 71;
	          }));
	        } else if (value === 'Não') {
	          var _index = this.entidade.tipos_documento.findIndex(function (e) {
	            return e.id === 71;
	          });
	          if (_index > 0) {
	            this.entidade.tipos_documento.splice(_index, 1);
	          }
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoEntidade = __webpack_require__(105);
	
	var _historicoEntidade2 = _interopRequireDefault(_historicoEntidade);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    HistoricoEntidade: _historicoEntidade2.default,
	    Usuarios: _usuarios2.default,
	    PublicoAlvo: _publicoAlvo2.default
	  },
	  name: 'entidade-proposta',
	  data: function data() {
	    return {
	      okGeral: false,
	      okEndereco: false,
	      configuracoes: {},
	      propostaSimplificada: {
	        documents: [],
	        documentStatements: [],
	        audiences: []
	      },
	      agencias: [],
	      agenciaSelecionada: null,
	      documentosProp: [],
	      documentosObrigatoriosProp: ['Memória de cálculo', 'Declaração'],
	      adimplencia: [],
	      adimplenciaObrig: ['Declaração de Adimplência e Inexistência de outras fontes'],
	      processos: [],
	      processo: [],
	      tipo: [],
	      entidade: {
	        address: [],
	        chiefs: [],
	        documents: [],
	        contact: {
	          email: null,
	          phone: null
	        }
	      },
	      procSelecionado: null,
	      campoErro: null,
	      user: {
	        entity: {
	          contact: {
	            phone: null,
	            mobile: null
	          }
	        }
	      },
	      contato: [],
	      criarProposta: true,
	      documentosObrigatorios: [],
	      docs: [],
	      docsProp: [],
	      documentTypes: [],
	      tiposArquivos: [],
	      mandatos: {},
	      mandato: {},
	      dirigentes: {},
	      ramoAtividade: [],
	      endereco: {},
	      historico: {},
	      usuarios: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    agenciaSelecionada: function agenciaSelecionada() {
	      this.propostaSimplificada.agencyName = this.agenciaSelecionada.name;
	      this.buscaAgencia(this.agenciaSelecionada.code);
	    }
	  },
	  created: function created() {
	    this.simplificado();
	    if (this.$route.params.id) {
	      this.entidade.id = this.$route.params.id;
	      this.buscaEntidade();
	    }
	    this.loadPositionMandate();
	    this.buscaDocumentos();
	    this.buscaArquivosEsperados();
	    this.buscaConfiguracoes();
	    this.buscaAgencias();
	    this.buscaDocumentosProp();
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    buscaEntidade: function buscaEntidade() {
	      var _this = this;
	
	      axios.get('proxy/account/entities/' + this.entidade.id).then(function (response) {
	        _this.entidade = response.data.value;
	        if (!_this.entidade.contact) {
	          _this.entidade.contact = [];
	          _this.entidade.contact.phone = '';
	        }
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaDocumentosProp: function buscaDocumentosProp() {
	      var _this2 = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this2.documentosProp = response.data.value.proposalConfig.documentTypes;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscaAgencias: function buscaAgencias(searchQuery) {
	      var _this3 = this;
	
	      var filter = null;
	      if (searchQuery) {
	        filter = searchQuery;
	      }
	      axios.post('proxy/account/agencies/tiny/list', filter).then(function (response) {
	        _this3.agencias = response.data.value;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    verificaDocumentosCarregados: function verificaDocumentosCarregados() {
	      if (!this.propostaSimplificada.documents) {
	        return false;
	      }
	      var documentosCarregados = this.propostaSimplificada.documents.map(function (item) {
	        return item.documentType.type;
	      });
	      return _.isEqual(this.documentosObrigatorios.sort(), documentosCarregados.sort());
	    },
	    numeroNomeAgencia: function numeroNomeAgencia(_ref) {
	      var code = _ref.code,
	          name = _ref.name;
	
	      return code + ' / ' + name;
	    },
	    selectFuncionario: function selectFuncionario() {
	      var _this4 = this;
	
	      axios.post('proxy/project/proposal/search/func/' + this.propostaSimplificada.employeeRegistration).then(function (response) {
	        var funcionario = response.data.value[0];
	        _this4.propostaSimplificada.employeeName = funcionario.NomeFunc;
	        _this4.propostaSimplificada.employeePhone = funcionario.DddAge + funcionario.TelAge;
	        _this4.propostaSimplificada.employeeEmail = 'F' + funcionario.MatrFunc + '@bb.com.br';
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    buscaAgencia: function buscaAgencia(agencia) {
	      var _this5 = this;
	
	      axios.post('proxy/project/proposal/search/agencia/' + agencia).then(function (response) {
	        var agencia = response.data.value[0];
	        _this5.propostaSimplificada.agencyAddress = agencia.EndAge;
	        _this5.propostaSimplificada.agencyCNPJ = agencia.CnpjAge;
	        _this5.propostaSimplificada.agencyEmail = agencia.CodAge.substr(0, agencia.CodAge.indexOf('-')) + '@BB.COM.BR';
	        _this5.propostaSimplificada.agencyName = agencia.NomAge;
	        _this5.propostaSimplificada.agencyPhone = agencia.TelAge;
	        _this5.propostaSimplificada.managerCity = agencia.MunGer;
	        _this5.propostaSimplificada.managerCivilStatus = agencia.EcGer;
	        _this5.propostaSimplificada.managerCpf = agencia.CpfGer;
	        _this5.propostaSimplificada.managerName = agencia.NomGer;
	        _this5.propostaSimplificada.managerNationality = 'Brasileiro';
	        _this5.propostaSimplificada.managerOccupation = 'Bancário';
	        _this5.propostaSimplificada.managerRg = agencia.RgGer.split(' - ')[0];
	        _this5.propostaSimplificada.managerRgIssuer = agencia.RgGer.split(' - ')[1];
	        _this5.propostaSimplificada.managerRgUF = agencia.RgGer.split(' - ')[2].replace(/\s/g, '');
	        _this5.propostaSimplificada.managerUf = agencia.UfGer;
	
	        _this5.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this5.$root.trataErro(error);
	      });
	    },
	    buscaConfiguracoes: function buscaConfiguracoes() {
	      var _this6 = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this6.configuracoes = response.data.value;
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this7 = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this7.documentosObrigatorios = response.data.value.entitySimplificadoConfig.documentTypes;
	        for (var i = 0; i < _this7.documentosObrigatorios.length; i++) {
	          _this7.docs[i] = _this7.documentosObrigatorios[i];
	        }
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    buscaDocumentos: function buscaDocumentos() {
	      var _this8 = this;
	
	      axios.get('proxy/document/documents/type?active').then(function (response) {
	        _this8.tiposArquivos = response.data.value;
	        var str = _this8.tiposArquivos.find(function (d) {
	          return d.type === 'Declaração de Adimplência e Inexistência de outras fontes';
	        });
	        _this8.adimplencia[0] = (0, _assign2.default)({}, str);
	      }).catch(function (error) {
	        _this8.$root.trataErro(error);
	      });
	    },
	    simplificado: function simplificado() {
	      var _this9 = this;
	
	      axios.get('proxy/document/simplified/active/list').then(function (response) {
	        _this9.processos = response.data.value;
	      }).catch(function (error) {
	        _this9.$root.trataErro(error);
	      });
	    },
	    escolhido: function escolhido() {
	      this.procSelecionado = this.processos.simplifiedNumber.simplifiedNumber;
	      this.entidade.simplified = this.processos.simplifiedNumber.id;
	      $('#tabEntidade').trigger('click');
	    },
	    loadPositionMandate: function loadPositionMandate() {
	      var _this10 = this;
	
	      axios.get('/proxy/project/position-mandate').then(function (response) {
	        _this10.mandatos = response.data.value;
	      }).catch(function (error) {
	        _this10.$root.trataErro(error);
	      });
	    },
	    verificaDocumentosEntidade: function verificaDocumentosEntidade() {
	      if (this.documentosObrigatorios.length === this.entidade.documents.length) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    verificaDirigentes: function verificaDirigentes() {
	      if (this.entidade.chiefs.length === 0) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    verificaEnderecos: function verificaEnderecos() {
	      if (this.entidade.address.length === 0) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    verificaDocumentosProposta: function verificaDocumentosProposta() {
	      if (this.documentosProp.length === this.propostaSimplificada.documents.length) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    isEditable: function isEditable() {
	      return this.$root.authorize('entidade-editar') || this.$root.authorize('minha-entidade-editar');
	    },
	    salva: function salva() {
	      if (this.entidade.id) {
	        this.atualiza();
	      } else {
	        this.grava();
	      }
	    },
	    conclui: function conclui() {
	      var _this11 = this;
	
	      this.entidade.registerPhase = 'CADASTRO_SIMPLIFICADO';
	      this.propostaSimplificada.documentTypes = this.documentos;
	      this.propostaSimplificada.createdBy = this.usuarioLogado;
	      this.propostaSimplificada.entity = this.entidade;
	      if (!this.entidade.contact) {
	        this.entidade.contact = [];
	        this.entidade.contact.phone = '';
	      }
	      this.propostaSimplificada.proposalPhase = 'CADASTRO';
	      if (this.propostaSimplificada.simplified) {
	        this.propostaSimplificada.simplified = this.processos.simplifiedNumber.id;
	      }
	      this.criarProposta = true;
	      this.entidadeOK = true;
	      var aba = '';
	      if (!this.verificaDirigentes()) {
	        this.$snotify.error('É necessário adicionar ao menos um dirigente!');
	        return;
	      }
	      if (!this.verificaEnderecos()) {
	        this.$snotify.error('É necessário adicionar ao menos um endereço!');
	        return;
	      }
	      if (!this.entidade.notice) {
	        if (!this.verificaDocumentosEntidade()) {
	          this.$snotify.error('Existem documentos obrigatórios da entidade pendentes!');
	          return;
	        }
	      }
	      if (this.entidadeOK) {
	        this.$validator.validateAll().then(function (result) {
	          if (_this11.entidade.businessName && _this11.entidade.cnpj && _this11.entidade.cnpjExpeditionTime && _this11.entidade.companyName) {
	            _this11.okGeral = true;
	          } else {
	            _this11.okGeral = false;
	          }
	          if (!_this11.propostaSimplificada.name && _this11.okGeral === true) {
	            _this11.$snotify.warning('O preenchimento da proposta é obrigatório. Favor verificar.');
	            $('[href="#Proposta"]').tab('show');
	          }
	          if (result) {
	            if (!_this11.verificaDocumentosProposta) {
	              _this11.$snotify.error('Existem documentos obrigatórios da proposta pendentes!');
	              return;
	            }
	            if (_this11.entidade.id) {
	              _this11.$aguarde('Gravando cadastro da entidade. Por favor, aguarde...');
	              axios.put('/proxy/account/entities/' + _this11.entidade.id, _this11.entidade).then(function (response) {
	                _this11.$snotify.clear();
	
	                axios.post('proxy/project/proposal/pre-proposal/entity', _this11.propostaSimplificada).then(function (response) {
	                  _this11.$snotify.success('Proposta simplificada cadastrada com sucesso!');
	                  setTimeout(function () {
	                    _this11.$router.push({ name: 'cadastro-entidade-lista' });
	                  }, 2000);
	                }).catch(function (error) {
	                  _this11.$snotify.clear();
	                  console.log('error', error);
	                  _this11.$root.trataErro(error);
	                });
	              }).catch(function (error) {
	                _this11.$root.trataErro(error);
	              });
	            } else {
	              _this11.$aguarde('Gravando cadastro da entidade. Por favor, aguarde...');
	              axios.post('proxy/account/entities/', _this11.entidade).then(function (response) {
	                _this11.$snotify.clear();
	                _this11.propostaSimplificada.entity.id = response.data.value.id;
	                axios.post('proxy/project/proposal/pre-proposal/entity', _this11.propostaSimplificada).then(function (response) {
	                  _this11.$snotify.success('Proposta simplificada cadastrada com sucesso!');
	                  setTimeout(function () {
	                    _this11.$router.push({ name: 'cadastro-entidade-lista' });
	                  }, 2000);
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this11.$root.trataErro(error);
	                });
	              });
	            }
	          } else {
	            _this11.errors.items.forEach(function (item) {
	              _this11.campoErro = item.field;
	            });
	          }
	        });
	      } else {
	        this.$snotify.error('Erros no preenchimento da aba ' + aba + '. Favor verificar.');
	      }
	    },
	    atualiza: function atualiza() {
	      var _this12 = this;
	
	      this.propostaSimplificada.documentTypes = this.documentos;
	      this.propostaSimplificada.createdBy = this.usuarioLogado;
	      this.propostaSimplificada.entity = this.entidade;
	      this.propostaSimplificada.proposalPhase = 'CADASTRO';
	      this.propostaSimplificada.simplified = this.processos.simplifiedNumber.id;
	      this.entidade.users = this.usuarios;
	      this.entidade.registerPhase = 'CADASTRO_SIMPLIFICADO';
	      this.$aguarde('Gravando proposta da entidade. Por favor, aguarde...');
	      axios.put('/proxy/account/entities/' + this.entidade.id + '/temp', this.entidade).then(function (response) {
	        axios.post('proxy/project/proposal/pre-proposal/entity', _this12.propostaSimplificada).then(function (response) {
	          _this12.$snotify.success('Proposta simplificada salva com sucesso!');
	        }).catch(function (error) {
	          console.log('error', error);
	          _this12.$root.trataErro(error);
	        });
	      }).catch(function (error) {
	        _this12.$snotify.clear();
	        _this12.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this13 = this;
	
	      this.propostaSimplificada.documentTypes = this.documentos;
	      this.propostaSimplificada.createdBy = this.usuarioLogado;
	      this.propostaSimplificada.entity = this.entidade;
	      this.propostaSimplificada.proposalPhase = 'CADASTRO';
	      this.propostaSimplificada.simplified = this.processos.simplifiedNumber.id;
	      this.entidade.registerPhase = 'CADASTRO_SIMPLIFICADO';
	      this.erroSalvar = 0;
	      if (!this.entidade.companyName) {
	        this.erroSalvar = 1;
	      }
	      if (!this.entidade.cnpj) {
	        this.erroSalvar = 1;
	      }
	      if (!this.entidade.businessName) {
	        this.erroSalvar = 1;
	      }
	      if (!this.entidade.contact.phone) {
	        this.erroSalvar = 1;
	      }
	      if (!this.entidade.email) {
	        this.erroSalvar = 1;
	      }
	      if (this.erroSalvar === 0) {
	        this.$aguarde('Gravando proposta da entidade. Por favor, aguarde...');
	        axios.post('proxy/account/entities/temp/', this.entidade).then(function (response) {
	          _this13.$snotify.clear();
	          if (response.data.value.id) {
	            _this13.propostaSimplificada.entity = response.data.value;
	            axios.post('proxy/project/proposal/pre-proposal/entity', _this13.propostaSimplificada).then(function (response) {
	              _this13.$snotify.success('Proposta simplificada salva com sucesso!');
	            }).catch(function (error) {
	              console.log('error', error);
	              _this13.$root.trataErro(error);
	            });
	          }
	        });
	      } else {
	        this.$snotify.error('Preencha os campos mínimos necessários para salvar.');
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoEntidade = __webpack_require__(105);
	
	var _historicoEntidade2 = _interopRequireDefault(_historicoEntidade);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    HistoricoEntidade: _historicoEntidade2.default,
	    Atividades: _atividades2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    Usuarios: _usuarios2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    PublicoAlvo: _publicoAlvo2.default
	  },
	  name: 'entidade-proposta-edital',
	  data: function data() {
	    return {
	      okGeral: false,
	      okEndereco: false,
	      configuracoes: {},
	      concluded: false,
	      propostaSimplificada: {
	        documents: [],
	        documentStatements: [],
	        audiences: [],
	        objectives: [],
	        periods: '',
	        careers: [],
	        teams: [],
	        municipalizationResume: [],
	        entityIsExecutioner: ''
	      },
	      agencias: [],
	      agenciaSelecionada: null,
	      documentosProp: [],
	      documentosObrigatoriosProp: ['Memória de cálculo', 'Declaração'],
	      adimplencia: [],
	      adimplenciaObrig: ['Declaração de Adimplência e Inexistência de outras fontes'],
	      processos: [],
	      processo: [],
	      tipo: [],
	      entidade: {
	        address: [],
	        chiefs: [],
	        documents: [],
	        contact: []
	      },
	      procSelecionado: true,
	      campoErro: null,
	      user: {
	        entity: {
	          contact: {
	            phone: null,
	            mobile: null
	          }
	        }
	      },
	      entidadeUsu: {
	        address: [],
	        documents: [],
	        contact: []
	      },
	      entidadeEdital: [],
	      contato: [],
	      criarProposta: true,
	      documentosObrigatorios: [],
	      docs: [],
	      docsProp: [],
	      documentTypes: [],
	      tiposArquivos: [],
	      mandatos: {},
	      mandato: {},
	      dirigentes: {},
	      ramoAtividade: [],
	      endereco: {},
	      historico: {},
	      usuarios: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    dataFinal: function dataFinal() {
	      if (this.propostaSimplificada.initialDate) {
	        return (0, _moment2.default)(this.propostaSimplificada.initialDate).add(this.propostaSimplificada.periods, 'M').format('DD/MM/YYYY');
	      } else {
	        return '';
	      }
	    }
	  }),
	  watch: {},
	  created: function created() {
	    this.buscaArquivosEsperados();
	    this.loadEntityActivity();
	    this.buscaDocumentos();
	    this.buscaConfiguracoes();
	    this.buscaDocumentosProp();
	  },
	  mounted: function mounted() {
	    $('#tabEntidade').trigger('click');
	    this.entidadeUsu = this.usuarioLogado.entity;
	    if (this.entidadeUsu.id) {
	      this.carregaProposta();
	    }
	    this.entidadeEdital = this.usuarioLogado.entity.notice;
	    this.verificar();
	    this.entidadeUsu.contact.email = this.usuarioLogado.entity.email;
	  },
	
	  methods: {
	    verificar: function verificar() {
	      if (!this.entidadeUsu.hasOwnProperty('contact')) {
	        this.entidadeUsu.contact = {};
	        this.entidadeUsu.contact.phone = '';
	        this.entidadeUsu.contact.email = '';
	      }
	    },
	    buscaEntidade: function buscaEntidade() {
	      var _this = this;
	
	      axios.get('proxy/account/entities/' + this.entidade.id).then(function (response) {
	        _this.entity = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaDocumentosProp: function buscaDocumentosProp() {
	      var _this2 = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this2.documentosProp = response.data.value.proposalConfig.documentTypes;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    verificaDocumentosCarregados: function verificaDocumentosCarregados() {
	      if (!this.propostaSimplificada.documents) {
	        return false;
	      }
	      var documentosCarregados = this.propostaSimplificada.documents.map(function (item) {
	        return item.documentType.type;
	      });
	      return _.isEqual(this.documentosObrigatorios.sort(), documentosCarregados.sort());
	    },
	    buscaConfiguracoes: function buscaConfiguracoes() {
	      var _this3 = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this3.configuracoes = response.data.value;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this4 = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this4.documentosObrigatorios = response.data.value.entitySimplificadoConfig.documentTypes;
	        for (var i = 0; i < _this4.documentosObrigatorios.length; i++) {
	          _this4.docs[i] = _this4.documentosObrigatorios[i];
	        }
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    buscaDocumentos: function buscaDocumentos() {
	      var _this5 = this;
	
	      axios.get('proxy/document/documents/type?active').then(function (response) {
	        _this5.tiposArquivos = response.data.value;
	        var str = _this5.tiposArquivos.find(function (d) {
	          return d.type === 'Declaração de Adimplência e Inexistência de outras fontes';
	        });
	        _this5.adimplencia[0] = (0, _assign2.default)({}, str);
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    isEditable: function isEditable() {
	      return this.$root.authorize('entidade-editar') || this.$root.authorize('minha-entidade-editar');
	    },
	    loadEntityActivity: function loadEntityActivity() {
	      var _this6 = this;
	
	      axios.get('proxy/project/entity-activity/').then(function (response) {
	        _this6.ramoAtividade = response.data.value;
	      });
	    },
	    loadCityAndState: function loadCityAndState() {
	      var _this7 = this;
	
	      if (this.propostaSimplificada.cep) {
	        axios.get('proxy/project/city/within-zip-code-range/' + this.cidade.cep).then(function (response) {
	          _this7.propostaSimplificada.name = response.data.value.name;
	          _this7.$forceUpdate();
	        }).catch(function (error) {
	          _this7.$root.trataErro(error);
	        });
	      } else {
	        this.cidade.name = '';
	        this.$forceUpdate();
	      }
	    },
	    carregaProposta: function carregaProposta() {
	      var _this8 = this;
	
	      axios.get('proxy/project/proposal/' + this.entidadeUsu.id + '/entityAutoRegister').then(function (response) {
	        if (response.data.value !== undefined) {
	          _this8.propostaSimplificada = response.data.value[0];
	        } else {
	          _this8.propostaSimplificada = {};
	        }
	      }).catch(function (error) {
	        _this8.$snotify.clear();
	        console.log('error', error);
	        _this8.$root.trataErro(error);
	      });
	    },
	    conclui: function conclui() {
	      var _this9 = this;
	
	      this.entidadeUsu.registerPhase = 'CADASTRO_COMPLETO';
	      this.propostaSimplificada.documents = this.documentos;
	      this.propostaSimplificada.createdBy = this.usuarioLogado;
	      this.propostaSimplificada.entity = this.entidadeUsu;
	      this.propostaSimplificada.proposalPhase = 'PRE_ANALISE';
	      this.propostaSimplificada.proposalStatus = 'OPE';
	      this.propostaSimplificada.notice = this.entidadeEdital;
	      this.propostaSimplificada.fav = null;
	      this.criarProposta = true;
	      this.entidadeOK = true;
	      var aba = '';
	      var docsOK = false;
	      if (this.entidadeOK) {
	        if (this.entidadeUsu.businessName && this.entidadeUsu.cnpj && this.entidadeUsu.cnpjExpeditionTime && this.entidadeUsu.companyName && this.entidadeUsu.phone && this.entidadeUsu.email) {
	          this.okGeral = true;
	        } else {
	          this.okGeral = false;
	        }
	        if (this.entidadeUsu.chiefs.length < 1) {
	          this.$snotify.warning('Verifique o preenchimento do formulário. O dirigente deve ser preenchido!');
	          return;
	        }
	        if (this.entidadeUsu.address.length < 1) {
	          this.$snotify.warning('Verifique o preenchimento do formulário. O endereço deve ser preenchido!');
	          return;
	        }
	        if (!this.propostaSimplificada.name && this.okGeral === true) {
	          this.$snotify.warning('O preenchimento da proposta é obrigatório. Favor verificar.');
	          $('[href="#Proposta"]').tab('show');
	        }
	        if ((0, _keys2.default)(this.entidadeUsu.documents).length < 4) {
	          this.$snotify.warning('Existem documentos obrigatórios não anexados. Favor verificar.');
	          docsOK = false;
	          return docsOK;
	        } else {
	          docsOK = true;
	          if (!this.propostaSimplificada.name && this.okGeral === true && docsOK === true) {
	            this.$snotify.warning('O preenchimento da proposta é obrigatório. Favor verificar.');
	            $('[href="#Proposta"]').tab('show');
	          }
	        }
	        this.$validator.validateAll().then(function (result) {
	          if (result) {
	            if (_this9.entidadeUsu.id) {
	              _this9.$aguarde('Cadastrando entidade. Por favor, aguarde...');
	              axios.put('/proxy/account/entities/' + _this9.entidadeUsu.id, _this9.entidadeUsu).then(function (response) {
	                _this9.$snotify.clear();
	                _this9.$aguarde('Cadastrando proposta. Por favor, aguarde...');
	                axios.post('proxy/project/proposal/pre-proposal/', _this9.propostaSimplificada).then(function (response) {
	                  _this9.$snotify.clear();
	                  _this9.$snotify.success('Proposta simplificada cadastrada com sucesso!');
	                  setTimeout(function () {
	                    _this9.$router.push({ name: 'cadastro-entidade-lista' });
	                  }, 2000);
	                }).catch(function (error) {
	                  _this9.$snotify.clear();
	                  console.log('error', error);
	                  _this9.$root.trataErro(error);
	                });
	              }).catch(function (error) {
	                _this9.$snotify.clear();
	                _this9.$root.trataErro(error);
	              });
	            } else {
	              axios.post('proxy/account/entities/', _this9.entidadeUsu).then(function (response) {
	                _this9.$snotify.clear();
	                _this9.propostaSimplificada.entity.id = response.data.value.id;
	                axios.post('proxy/project/proposal/pre-proposal/entity', _this9.propostaSimplificada).then(function (response) {
	                  _this9.$snotify.success('Proposta simplificada cadastrada com sucesso!');
	                  setTimeout(function () {
	                    _this9.$router.push({ name: 'cadastro-entidade-lista' });
	                  }, 2000);
	                }).catch(function (error) {
	                  _this9.$snotify.clear();
	                  console.log('error', error);
	                  _this9.$root.trataErro(error);
	                });
	              });
	            }
	          } else {
	            _this9.errors.items.forEach(function (item) {
	              _this9.$snotify.clear();
	              _this9.campoErro = item.field;
	            });
	          }
	        });
	      } else {
	        this.$snotify.error('Erros no preenchimento da aba ' + aba + '. Favor verificar.');
	      }
	    },
	    atualiza: function atualiza() {
	      var _this10 = this;
	
	      if (this.documentos) {
	        this.propostaSimplificada.documents = this.documentos;
	      }
	      this.propostaSimplificada.createdBy = this.usuarioLogado;
	      this.propostaSimplificada.entity = this.entidadeUsu;
	      this.propostaSimplificada.proposalPhase = 'PRE_ANALISE';
	      this.propostaSimplificada.proposalOrigin = 'COMPLETO';
	      this.propostaSimplificada.proposalStatus = 'OPE';
	      this.propostaSimplificada.notice = this.entidadeEdital;
	
	      axios.put('/proxy/account/entities/' + this.entidadeUsu.id + '/temp', this.entidadeUsu).then(function (response) {
	        axios.post('proxy/project/proposal/temp/', _this10.propostaSimplificada).then(function (response) {
	          _this10.$snotify.success('Proposta simplificada salva com sucesso!');
	        }).catch(function (error) {
	          console.log('error', error);
	          _this10.$root.trataErro(error);
	        });
	      }).catch(function (error) {
	        _this10.$snotify.clear();
	        _this10.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this11 = this;
	
	      this.propostaSimplificada.documentTypes = this.documentos;
	      this.propostaSimplificada.createdBy = this.usuarioLogado;
	      this.propostaSimplificada.entity = this.entidadeUsu;
	      this.propostaSimplificada.proposalPhase = 'CADASTRO';
	      this.propostaSimplificada.simplified = this.processos.simplifiedNumber.id;
	      this.entidadeUsu.registerPhase = 'CADASTRO_SIMPLIFICADO';
	      axios.post('proxy/account/entities/temp/', this.entidadeUsu).then(function (response) {
	        axios.post('proxy/project/proposal/pre-proposal/entity', _this11.propostaSimplificada).then(function (response) {
	          _this11.$snotify.success('Proposta simplificada salva com sucesso!');
	        }).catch(function (error) {
	          console.log('error', error);
	          _this11.$root.trataErro(error);
	        });
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoEntidade = __webpack_require__(105);
	
	var _historicoEntidade2 = _interopRequireDefault(_historicoEntidade);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    HistoricoEntidade: _historicoEntidade2.default,
	    Usuarios: _usuarios2.default
	  },
	  name: 'entidade-simplificado',
	  data: function data() {
	    return {
	      processos: [],
	      processo: [],
	      tipo: [],
	      erroSalvar: 0,
	      entidade: {
	        address: [],
	        chiefs: [],
	        documents: [],
	        contact: {
	          email: null,
	          phone: null
	        }
	      },
	      procSelecionado: null,
	      campoErro: null,
	      user: {
	        entity: {
	          contact: {
	            phone: null,
	            mobile: null
	          }
	        }
	      },
	      contato: [],
	      documentosObrigatorios: [],
	      docs: [],
	      documentTypes: [],
	      tiposArquivos: [],
	      mandatos: {},
	      mandato: {},
	      dirigentes: {},
	      ramoAtividade: [],
	      endereco: {},
	      historico: {},
	      usuarios: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    this.simplificado();
	    this.loadPositionMandate();
	    this.buscaDocumentos();
	    this.buscaArquivosEsperados();
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this.documentosObrigatorios = response.data.value.entitySimplificadoConfig.documentTypes;
	        for (var i = 0; i < _this.documentosObrigatorios.length; i++) {
	          _this.docs[i] = _this.documentosObrigatorios[i];
	        }
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaDocumentos: function buscaDocumentos() {
	      var _this2 = this;
	
	      axios.get('proxy/document/documents/type?active').then(function (response) {
	        _this2.tiposArquivos = response.data.value;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    simplificado: function simplificado() {
	      var _this3 = this;
	
	      axios.get('proxy/document/simplified/active/list').then(function (response) {
	        _this3.processos = response.data.value;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    escolhido: function escolhido() {
	      this.procSelecionado = this.processos.simplifiedNumber.simplifiedNumber;
	      this.entidade.simplified = this.processos.simplifiedNumber.id;
	    },
	    loadPositionMandate: function loadPositionMandate() {
	      var _this4 = this;
	
	      axios.get('/proxy/project/position-mandate').then(function (response) {
	        _this4.mandatos = response.data.value;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    isEditable: function isEditable() {
	      return this.$root.authorize('entidade-editar') || this.$root.authorize('minha-entidade-editar');
	    },
	    salva: function salva() {
	      if (this.entidade.id) {
	        this.atualiza();
	      } else {
	        this.grava();
	      }
	    },
	    conclui: function conclui() {
	      var _this5 = this;
	
	      this.entidade.registerPhase = 'CADASTRO_SIMPLIFICADO';
	
	      var entidadeOK = true;
	      var aba = '';
	      if (entidadeOK) {
	        this.$validator.validateAll().then(function (result) {
	          if (result) {
	            if (_this5.entidade.id) {
	              axios.put('/proxy/account/entities/' + _this5.entidade.id, _this5.entidade).then(function (response) {
	                _this5.$snotify.clear();
	                _this5.$snotify.success('Cadastro da Entidade concluído com sucesso!');
	                _this5.$router.go(-1);
	              }).catch(function (error) {
	                _this5.$root.trataErro(error);
	              });
	            } else {
	              axios.post('proxy/account/entities/', _this5.entidade).then(function (response) {
	                _this5.$snotify.clear();
	                _this5.$snotify.success('Cadastro da Entidade concluído com sucesso!');
	                _this5.$router.go(-1);
	              });
	            }
	          } else {
	            _this5.errors.items.forEach(function (item) {
	              _this5.campoErro = item.field;
	            });
	          }
	        });
	      } else {
	        this.$snotify.error('Erros no preenchimento da aba ' + aba + '. Favor verificar.');
	      }
	    },
	    atualiza: function atualiza() {
	      var _this6 = this;
	
	      this.entidade.users = this.usuarios;
	      this.entidade.registerPhase = 'CADASTRO_SIMPLIFICADO';
	      this.$aguarde('Salvando entidade. Por favor, aguarde...');
	      axios.put('/proxy/account/entities/' + this.entidade.id + '/temp', this.entidade).then(function (response) {
	        _this6.$snotify.success('Entidade salva com sucesso!');
	      }).catch(function (error) {
	        _this6.$snotify.clear();
	        _this6.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this7 = this;
	
	      this.erroSalvar = 0;
	      if (!this.entidade.companyName) {
	        this.erroSalvar = 1;
	      }
	      if (!this.entidade.cnpj) {
	        this.erroSalvar = 1;
	      }
	      if (!this.entidade.businessName) {
	        this.erroSalvar = 1;
	      }
	      if (!this.entidade.contact.phone) {
	        this.erroSalvar = 1;
	      }
	      if (!this.entidade.email) {
	        this.erroSalvar = 1;
	      }
	      if (this.erroSalvar === 0) {
	        this.entidade.registerPhase = 'CADASTRO_SIMPLIFICADO';
	        this.$aguarde('Gravando entidade. Por favor, aguarde...');
	        axios.post('proxy/account/entities/temp/', this.entidade).then(function (response) {
	          _this7.$snotify.clear();
	          _this7.$snotify.success('Entidade gravada com sucesso!');
	        });
	      } else {
	        this.$snotify.error('Preencha os campos mínimos necessários para salvar.');
	      }
	    }
	  }
	};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _historicoEntidade = __webpack_require__(105);
	
	var _historicoEntidade2 = _interopRequireDefault(_historicoEntidade);
	
	var _assinaturaDirigentes = __webpack_require__(511);
	
	var _assinaturaDirigentes2 = _interopRequireDefault(_assinaturaDirigentes);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    HistoricoEntidade: _historicoEntidade2.default,
	    Usuarios: _usuarios2.default,
	    assinaturaDirigentes: _assinaturaDirigentes2.default
	  },
	  name: 'cadastro-entidade-visualiza',
	  data: function data() {
	    return {
	      titulo: 'SGP',
	      campoErro: null,
	      disable: true,
	      entidade: {
	        contato: {
	          ds_telefone: null
	        },
	        dirigentes: [],
	        documentos: [],
	        ramo_atividade: []
	      },
	      listaRamosAtividade: [],
	      listaFormasJuridicas: [],
	      listaDocConstituicao: [],
	      boqueia: false,
	      dirigentes: [],
	      ramoAtividade: [],
	      endereco: {},
	      historico: [],
	      tarefas: [],
	      usuarios: {},
	
	      possuiCmas: '',
	      possuiCebas: ''
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {},
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var isTrue;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              isTrue = function isTrue(v) {
	                return v === true || v === 1 || v === '1' || v === 'true';
	              };
	
	              _this.$aguarde('Buscando dados da Entidade. Por favor, aguarde...');
	              _context.next = 4;
	              return _this.$root.buscaRamoAtividades(_this.$store);
	
	            case 4:
	              _this.ramoAtividade = _this.$store.state.ramoAtividades;
	
	              if (_this.$route.params.id) {
	                axiosLaravel.get('entidades/ultimosnapshot/' + _this.$route.params.id).then(function (response) {
	                  _this.entidade = response.data;
	                  if (_.isNull(_this.entidade.contato)) {
	                    _this.entidade.contato = {};
	                  }
	                  _this.$snotify.clear();
	                  if (_.isObject(_this.entidade.forma_juridica) === false) {
	                    _this.entidade.forma_juridica = [];
	                  }
	                  if (_.isObject(_this.entidade.documento_constituicao) === false) {
	                    _this.entidade.documento_constituicao = [];
	                  }
	
	                  if (_this.entidade.documentos.findIndex(function (e) {
	                    return e.tipo_documento.id === 70;
	                  }) >= 0) {
	                    _this.possuiCmas = 'Sim';
	                  } else {
	                    _this.possuiCmas = 'Não';
	                  }
	                  if (_this.entidade.documentos.findIndex(function (e) {
	                    return e.tipo_documento.id === 71;
	                  }) >= 0) {
	                    _this.possuiCebas = 'Sim';
	                  } else {
	                    _this.possuiCebas = 'Não';
	                  }
	                  _this.carregaListaFormasJuridicas();
	                  _this.carregaListaRamosAtividade();
	                  _this.carregaListaDocumentosConstituicao();
	                  _this.processos = response.data.processos;
	                  _this.cnpj = _this.entidade.cnpj;
	                  _this.dirigentes = response.data.dirigentes;
	                  _this.tarefas = _this.processos.map(function (item) {
	                    return item.tarefas;
	                  });
	                  for (var i = 0; i < _this.tarefas.length; i++) {
	                    for (var j = 0; j < _this.tarefas[i].length; j++) {
	                      if (_this.tarefas[i][j].tipo === 'USUARIO') {
	                        _this.historico.push(_this.tarefas[i][j]);
	                      }
	                    }
	                  }
	
	                  _this.$snotify.clear();
	
	                  _this.$snotify.success('Dados da Entidade recuperados com sucesso!', { timeout: 2000 });
	                  _this.titulo = 'SGP' + (_.has(_this.entidade, 'ds_nome') ? ' - ' + _this.entidade.ds_nome : '');
	                  _this.$forceUpdate();
	                  if (isTrue(_this.entidade.bt_ativo) && _this.usuarioLogado.userType === 'ENTIDADE') {
	                    _this.$swal({
	                      title: '<font color="red"><b>Atenção!</b></font>',
	
	                      html: '<div align="left"> A entidade ' + '<b>' + _this.entidade.ds_nome + '</b>' + ', já foi aprovada no sistema. Qualquer alteração cadastral será passível de nova aprovação pela FBB.' + '</div>',
	                      showCloseButton: true,
	                      showCancelButton: false,
	                      showLoaderOnConfirm: true,
	                      focusConfirm: false
	                    });
	                  }
	                  if (_this.entidade.ds_tipo_registro === 'CREDENCIAMENTO' && _this.entidade.edital) {
	                    _this.boqueia = true;
	                    return;
	                  }
	                }).catch(function (error) {
	                  if (error) {
	                    _this.$snotify.clear();
	                    _this.$root.trataErro(error);
	                  }
	                });
	              }
	              _this.formasJuridicas = [{ c: '101-5', d: 'Órgão Público do Poder Executivo Federal' }, {
	                c: '102-3',
	                d: 'Órgão Público do Poder Executivo Estadual ou do Distrito Federal'
	              }, { c: '103-1', d: 'Órgão Público do Poder Executivo Municipal' }, {
	                c: '110-4',
	                d: 'Autarquia Federal'
	              }, { c: '111-2', d: 'Autarquia Estadual ou do Distrito Federal' }, {
	                c: '112-0',
	                d: 'Autarquia Municipal'
	              }, { c: '113-9', d: 'Fundação Pública de Direito Público Federal' }, {
	                c: '114-7',
	                d: 'Fundação Pública de Direito Público Estadual ou do Distrito Federal'
	              }, { c: '115-5', d: 'Fundação Pública de Direito Público Municipal' }, {
	                c: '116-3',
	                d: 'Órgão Público Autônomo Federal'
	              }, { c: '117-1', d: 'Órgão Público Autônomo Estadual ou do Distrito Federal' }, {
	                c: '118-0',
	                d: 'Órgão Público Autônomo Municipal'
	              }, { c: '123-6', d: 'Estado ou Distrito Federal' }, { c: '124-4', d: 'Município' }, {
	                c: '125-2',
	                d: 'Fundação Pública de Direito Privado Federal'
	              }, { c: '126-0', d: 'Fundação Pública de Direito Privado Estadual ou do Distrito Federal' }, {
	                c: '127-9',
	                d: 'Fundação Pública de Direito Privado Municipal'
	              }, { c: '201-1', d: 'Empresa Pública' }, { c: '214-3', d: 'Cooperativa' }, {
	                c: '227-5',
	                d: 'Empresa Binacional'
	              }, { c: '306-9', d: 'Fundação Privada' }, { c: '307-7', d: 'Serviço Social Autônomo' }, {
	                c: '313-1',
	                d: 'Entidade Sindical'
	              }, { c: '320-4', d: 'Estabelecimento, no Brasil, de Fundação ou Associação Estrangeiras' }, {
	                c: '321-2',
	                d: 'Fundação ou Associação Domiciliada no Exterior'
	              }, { c: '323-9', d: 'Comunidade Indígena' }, { c: '330-1', d: 'Organização Social (OS)' }, {
	                c: '399-9',
	                d: 'Associação Privada'
	              }, { c: '501-0', d: 'Organização Internacional' }, {
	                c: '502-9',
	                d: 'Representação Diplomática Estrangeira'
	              }, { c: '503-7', d: 'Outras Instituições Extraterritoriais' }, {
	                c: '204-6',
	                d: 'Sociedade Anônima Aberta'
	              }, { c: '205-4', d: 'Sociedade Anônima Fechada' }];
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    customLabel: function customLabel(option) {
	      return '' + (option.c + ' / ' + option.d);
	    },
	    etiquetaListaFormaJuridica: function etiquetaListaFormaJuridica(option) {
	      return '' + (option.codigo + ' / ' + option.descricao);
	    },
	    etiquetaListaRamosAtividade: function etiquetaListaRamosAtividade(option) {
	      return '' + (option.ds_codigo + '    ' + option.ds_descricao);
	    },
	    carregaListaFormasJuridicas: function carregaListaFormasJuridicas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _this2.$root.buscaFormasJuridicas(_this2.$store);
	
	              case 2:
	                _this2.listaFormasJuridicas = _this2.$store.state.formasJuridicas;
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    carregaListaRamosAtividade: function carregaListaRamosAtividade() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _this3.$root.buscaRamoAtividades(_this3.$store);
	
	              case 2:
	                _this3.listaRamosAtividade = _this3.$store.state.ramoAtividades;
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    carregaListaDocumentosConstituicao: function carregaListaDocumentosConstituicao() {
	      var _this4 = this;
	
	      this.listaDocConstituicao = [{ id: 'ATA_CONSTITUICAO', ds_tipo: 'Ata constituição' }, { id: 'CONTRATO_SOCIAL', ds_tipo: 'Contrato social' }, { id: 'ESTATUTO', ds_tipo: 'Estatuto' }, { id: 'LEI_ORGANICA_MUNICIPAL', ds_tipo: 'Lei orgânica municipal' }];
	
	      axiosLaravel.post('documentos/tipos/ENTIDADE_DOC_CONSTITUICAO').then(function (response) {
	        _this4.listaDocConstituicao = response.data;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    isEditable: function isEditable() {
	      return this.$root.authorize('entidade-editar') || this.$root.authorize('minha-entidade-editar');
	    },
	    outrasValidacoes: function outrasValidacoes() {
	      if (!this.entidade.dirigentes || this.entidade.dirigentes === 0) {
	        this.$snotify.error('Os dados obrigatórios do dirigente devem ser preenchidos!');
	        return false;
	      }
	      return true;
	    },
	    salvaUsuarios: function salvaUsuarios() {
	      var _this5 = this;
	
	      axios.post('proxy/account/entities/' + this.entidade.id + '/users', this.usuarios).then(function (response) {
	        _this5.users = response.data.value;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    salva: function salva() {
	      if (this.entidade.id) {
	        this.atualiza();
	      } else {
	        this.grava();
	      }
	    },
	    conclui: function conclui() {
	      var _this6 = this;
	
	      var entidadeOK = true;
	      var aba = '';
	      if (_.isEmpty(this.endereco)) {
	        entidadeOK = false;
	        aba = 'Endereço';
	      }
	      if (_.isEmpty(this.dirigentes)) {
	        entidadeOK = false;
	        aba = 'Dirigentes';
	      }
	      if (this.entidade.simplified && this.entidade.status === 'PENDENTE_APROVACAO') {
	        entidadeOK = true;
	      }
	      if (entidadeOK) {
	        this.$validator.validateAll().then(function (result) {
	          if (result) {
	            _this6.outrasValidacoes();
	            if (_this6.entidade.id) {
	              axios.put('/proxy/account/entities/' + _this6.entidade.id, _this6.entidade).then(function (response) {
	                _this6.salvaUsuarios();
	              }).catch(function (error) {
	                _this6.$root.trataErro(error);
	              });
	            } else {
	              axios.post('proxy/account/entities/' + _this6.entidade).then(function (response) {});
	            }
	            if (_this6.entidade.active === false) {
	              _this6.$snotify.success('Cadastro da entidade concluído com sucesso! Aguarde e-mail da Fundação Banco do brasil com as informações para dar continuidade ao processo !');
	              setTimeout(function () {
	                _this6.$router.go(-1);
	              }, 2000);
	            } else {
	              _this6.$snotify.success('Alteração cadastral concluída com sucesso!');
	              _this6.$router.go(-1);
	            }
	          } else {
	            _this6.errors.items.forEach(function (item) {
	              _this6.campoErro = item.field;
	              if (_this6.campoErro === 'cnpjExpeditionTime') {
	                $('input[name="cnpjExpeditionTime"]').focus();
	              } else if (_this6.campoErro === 'CNPJ') {
	                $('input[name="CNPJ"]').focus();
	              } else {
	                _this6.$snotify.error(item.msg, '', _this6.$root._data.error, _this6.$refs[_this6.campoErro].focus());
	              }
	            });
	          }
	        });
	      } else {
	        this.$snotify.error('Erros no preenchimento da aba ' + aba + '. Favor verificar.');
	      }
	    },
	    atualiza: function atualiza() {
	      var _this7 = this;
	
	      axiosLaravel.put('entidades/' + this.entidade.id, this.entidade).then(function (response) {}).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	      this.entidade.users = this.usuarios;
	      axios.put('/proxy/account/entities/' + this.entidade.id + '/temp', this.entidade).then(function (response) {
	        _this7.salvaUsuarios();
	        _this7.$snotify.success('Entidade salva com sucesso!');
	      }).catch(function (error) {
	        _this7.$snotify.clear();
	        _this7.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this8 = this;
	
	      this.entidade.users = this.usuarios;
	      axios.post('proxy/account/entities/temp/' + this.entidade).then(function (response) {
	        _this8.$snotify.success('Entidade salva com sucesso!');
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ListaEntidades',
	  data: function data() {
	    return {
	      data: [],
	      loading: {
	        show: false
	      },
	      snap: [],
	
	      textoEditar: 'Editar <br> <div align="right">Cadastro</div>',
	      textoVisualizar: 'Visualizar <br> <div align="right">Cadastro</div>',
	      textoProposta: 'Liberar <br> <div align="right">Proposta</div>',
	      items: [],
	      filtro: '',
	      perfis: {},
	      filtros: {
	        active: '',
	        cnpj: '',
	        situation: '',
	        companyName: '',
	        id: ''
	      },
	      bordered: true,
	      fields: [{ key: 'ds_nome', label: 'Razão Social', sortable: true, thStyle: 'width: 25%; text-align: center', class: 'centraliza' }, { key: 'ds_cnpj', label: 'CNPJ', sortable: true, thStyle: 'width: 10%; text-align: center', class: 'text-center' }, { key: 'ds_nome_fantasia', label: 'Nome Fantasia', sortable: true, thStyle: 'width: 25%; text-align: center', class: 'centraliza' }, { key: 'dt_criado', label: 'Inclusão', sortable: true, thStyle: 'width: 6%; text-align: center', class: 'text-center' }, { key: 'ds_status', label: 'Situação', thStyle: 'width: 6%; text-align: center', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'width: 18%; text-align: center', class: 'text-center' }],
	      table: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não há registros a serem mostrados'
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Entidade',
	        active: true
	      }]
	    };
	  },
	
	  created: function created() {
	    this.busca();
	  },
	  computed: {
	    totalRows: {
	      get: function get() {
	        return this.items.length;
	      },
	      set: function set() {}
	    },
	    sortOptions: function sortOptions() {
	      return this.fields.table.filter(function (f) {
	        return f.sortable;
	      }).map(function (f) {
	        return { text: f.label, value: f.key };
	      });
	    }
	  },
	  mounted: function mounted() {},
	  methods: {
	    busca: function busca() {
	      var _this = this;
	
	      this.snap = [];
	
	      this.loading.show = true;
	      if (this.filtro.length > 0) {
	        axiosLaravel.get('entidades?filtro=' + this.filtro).then(function (response) {
	          _this.items = response.data;
	
	          _this.snap = _.cloneDeep(_this.items.data);
	          _this.loading.show = false;
	          _this.$forceUpdate();
	        }).catch(function (error) {
	          if (error) {
	            _this.$root.trataErro(error);
	            _this.loading.show = false;
	          }
	        });
	      } else {
	        this.snap = [];
	        this.loading.show = true;
	        axiosLaravel.get('entidades/').then(function (response) {
	          _this.items = response.data;
	
	          _this.snap = _.cloneDeep(_this.items.data);
	          _this.loading.show = false;
	          _this.$forceUpdate();
	        }).catch(function (error) {
	          if (error) {
	            _this.$root.trataErro(error);
	          }
	        });
	      }
	    },
	
	    remove: function remove(retorno, item) {
	      var _this2 = this;
	
	      axios.delete('/proxy/account/entities/' + item).then(function (response) {
	        _this2.$snotify.clear();
	        _this2.$snotify.success('Entidade Removida com Sucesso.');
	        _this2.busca();
	      }).catch(function (error) {
	        if (error) {
	          _this2.$root.trataErro(error);
	        }
	      });
	    },
	    onNew: function onNew() {
	      this.$root.$emit('cadastro-entidade-edita');
	    },
	    recarrega: function recarrega(data) {
	      var _this3 = this;
	
	      this.snap = [];
	
	      this.loading.show = true;
	      axiosLaravel.get('entidades?filtro=' + this.filtro + '&page=' + data).then(function (response) {
	        _this3.items = response.data;
	        _this3.table.totalRows = response.data.total;
	        _this3.snap = _this3.items.data;
	        _this3.loading.show = false;
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        if (error) {
	          _this3.$root.trataErro(error);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditaFav',
	  data: function data() {
	    return {
	      favs: {},
	      fav: {
	        favQuestions: {}
	      },
	      editandoIndex: null,
	      questao: {},
	      listaLocais: ['Pré-Análise', 'Aceite', 'Análise', 'Deferimento', 'Preparação de Documentos', 'Formalização de Projeto'],
	      show: null,
	      table2: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'questionNumber', label: 'Número', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'question', label: 'Pergunta', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'local', label: 'Local', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'conformityYes', label: 'Sim', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'conformityNo', label: 'Não', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'conformityNA', label: 'N/A', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	  created: function created() {
	    this.favs = this.$route.params.fav;
	    this.fav = this.$route.params.fav;
	    this.table2.items = this.favs.favQuestions;
	  },
	
	  methods: {
	    onNew: function onNew() {
	      this.show = true;
	    },
	    carregaFav: function carregaFav() {
	      var _this = this;
	
	      axios.get('proxy/project/favs').then(function (response) {
	        _this.favs = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    onAdd: function onAdd() {
	      this.show = true;
	
	      this.errors.clear();
	
	      if (!this.questao.questionNumber) {
	        this.errors.add('questionNumber', 'Campo número da pergunta é obrigatório');
	      }
	      if (!this.questao.local) {
	        this.errors.add('local', 'Campo local é obrigatório');
	      }
	      if (!this.questao.question) {
	        this.errors.add('question', 'Campo pergunta é obrigatório');
	      }
	      if (this.errors.items.length !== 0) {
	        return;
	      }
	      if (this.editandoIndex !== null) {
	        for (var i in this.fav.favQuestions) {
	          this.questao = this.fav.favQuestions[i];
	        }
	      } else {
	        this.table2.items.push((0, _assign2.default)({}, this.questao));
	      }
	      this.$forceUpdate();
	      this.onCancel();
	    },
	    onClean: function onClean() {
	      this.show = false;
	      this.editandoIndex = null;
	      this.fav = {};
	    },
	    onCancel: function onCancel() {
	      this.show = false;
	      this.editandoIndex = null;
	      this.questao = {};
	    },
	    onEdit: function onEdit(row) {
	      this.questao = row.item;
	      this.editandoIndex = row.index;
	
	      this.show = true;
	    },
	    onDelete: function onDelete(row) {
	      this.editandoIndex = null;
	      this.table2.items.splice(row.index, 1);
	    },
	    onSave: function onSave() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.fav.id) {
	            _this2.atualiza();
	          } else {
	            axios.post('proxy/project/favs/' + _this2.fav).then(function (response) {
	              _this2.items = response.data.value;
	              _this2.loading.show = false;
	            }).catch(function (error) {
	              if (error) {
	                _this2.$root.trataErro(error);
	              }
	            });
	          }
	        } else {
	          _this2.errors.items.forEach(function (item) {
	            _this2.$snotify.error(item.msg, '', _this2.$root._data.error);
	          });
	        }
	      });
	    },
	    atualiza: function atualiza() {
	      var _this3 = this;
	
	      axios.put('/proxy/project/favs/' + this.fav.id, this.fav).then(function (response) {
	        _this3.$snotify.success('Fav salva com sucesso!');
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ListaFav',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'situation',
	        sortDesc: true,
	        fields: [{ key: 'name', label: 'FAV', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'situation', label: 'Ativo', sortable: true, thStyle: 'text-align: center; width: 0.2%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 3%', class: 'text-center' }]
	      }
	    };
	  },
	
	  watch: {
	    onEdit: function onEdit(item) {
	      this.$root.$broadcast('editFavEvent', item);
	    }
	  },
	  created: function created() {
	    this.carregaFav();
	  },
	
	  methods: {
	    carregaFav: function carregaFav() {
	      var _this = this;
	
	      axios.get('proxy/project/favs').then(function (response) {
	        _this.table.items = response.data.value;
	        _this.table.totalRows = _this.table.items.length;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.table.totalRows = this.table.items.length;
	      this.currentPage = 1;
	    },
	    inativa: function inativa(item) {
	      var _this2 = this;
	
	      item.situation = !item.situation;
	      axios.put('proxy/project/favs/' + item.id, item).then(function (response) {
	        _this2.$snotify.success('FAV atualizada com sucesso', '', _this2.$root._data.sucesso);
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'NovaFav',
	  data: function data() {
	    return {
	      favs: {},
	      salvar: {},
	      fav: {
	        id: null,
	        name: null,
	        situation: null,
	        favQuestions: []
	      },
	      editandoIndex: null,
	      questao: {},
	      listaLocais: ['Pré-Análise', 'Aceite', 'Análise', 'Deferimento', 'Preparação de Documentos', 'Formalização de Projeto'],
	      show: null,
	      table2: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'questionNumber', label: 'Número', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'question', label: 'Pergunta', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'local', label: 'Local', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'conformityYes', label: 'Sim', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'conformityNo', label: 'Não', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'conformityNA', label: 'N/A', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	  created: function created() {
	    this.carregaFav();
	  },
	
	  methods: {
	    onNew: function onNew() {
	      this.show = true;
	    },
	    carregaFav: function carregaFav() {
	      var _this = this;
	
	      axios.get('proxy/project/favs').then(function (response) {
	        _this.favs = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    onAdd: function onAdd() {
	      this.show = true;
	
	      this.errors.clear();
	
	      if (!this.questao.questionNumber) {
	        this.errors.add('questionNumber', 'Campo número da pergunta é obrigatório');
	      }
	      if (!this.questao.local) {
	        this.errors.add('local', 'Campo local é obrigatório');
	      }
	      if (!this.questao.question) {
	        this.errors.add('question', 'Campo pergunta é obrigatório');
	      }
	      if (this.errors.items.length !== 0) {
	        return;
	      }
	      if (this.editandoIndex !== null) {
	        for (var i in this.fav.favQuestions) {
	          this.questao = this.fav.favQuestions[i];
	        }
	      } else {
	        this.table2.items.push((0, _assign2.default)({}, this.questao));
	      }
	      this.$forceUpdate();
	      this.onCancel();
	    },
	    onCancel: function onCancel() {
	      this.show = false;
	      this.editandoIndex = null;
	      this.questao = {};
	    },
	    onClean: function onClean() {
	      this.show = false;
	      this.editandoIndex = null;
	      this.fav = {};
	    },
	    onEdit: function onEdit(row) {
	      this.questao = row.item;
	      this.editandoIndex = row.index;
	      this.show = true;
	    },
	    onDelete: function onDelete(row) {
	      this.editandoIndex = null;
	      this.table2.items.splice(row.index, 1);
	    },
	    onSave: function onSave() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this2.fav.favQuestions = _this2.table2.items;
	          axios.post('proxy/project/favs', _this2.fav).then(function (response) {
	            _this2.items = response.data.value;
	            _this2.show = false;
	            _this2.$forceUpdate();
	            _this2.onCancel();
	            _this2.$snotify.success('Fav salva com sucesso!');
	            _this2.$router.go(-1);
	          }).catch(function (error) {
	            if (error) {
	              _this2.$root.trataErro(error);
	            }
	          });
	        } else {
	          _this2.errors.items.forEach(function (item) {
	            _this2.$snotify.error(item.msg, '', _this2.$root._data.error);
	          });
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'EditaFep',
	  data: function data() {
	    return {
	      fep: {
	        id: null,
	        fk_proposta: null,
	        proposta: []
	      },
	      selecionado: false,
	      loading: {
	        show: false
	      },
	      projetos: [],
	      projetoSelecionado: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      this.loading.show = true;
	      console.log('this.$route.params.id', this.$route.params.id);
	      axiosLaravel.get('fep/' + this.$route.params.id).then(function (response) {
	        _this.fep = response.data;
	        if (_this.fep.proposta) {
	          _this.projetoSelecionado.id = _this.fep.proposta.id;
	          _this.projetoSelecionado.ds_nome = _this.fep.proposta.ds_nome;
	        }
	        console.log('this.fep', _this.fep);
	        _this.loading.show = false;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.loading.show = true;
	    this.$aguarde('Listando propostas. Por favor, aguarde...');
	    axiosLaravel.get('propostas').then(function (response) {
	      _this2.projetos = _.sortBy(response.data, 'ds_nome');
	      _this2.$snotify.clear();
	      _this2.loading.show = false;
	      _this2.$forceUpdate();
	    }).catch(function (error) {
	      _this2.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    moveObjeto: function moveObjeto(evento) {
	      console.log('caiu aqui');
	      console.log(evento);
	      this.selecionado = true;
	      this.fep.fk_proposta = evento.id;
	    },
	    removeObjeto: function removeObjeto() {
	      this.projetoSelecionado = {};
	      this.fep.fk_proposta = null;
	    },
	    salva: function salva() {
	      var _this3 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this3.fep.id) {
	            _this3.atualiza();
	          } else {
	            _this3.grava();
	          }
	        } else {
	          _this3.errors.items.forEach(function (item) {
	            _this3.$snotify.error(item.msg);
	          });
	        }
	      });
	    },
	    atualiza: function atualiza() {
	      var _this4 = this;
	
	      axiosLaravel.put('fep/' + this.fep.id, this.fep).then(function (response) {
	        _this4.$snotify.success('Fep alterada com sucesso!');
	        _this4.$router.go(-1);
	      }).catch(function (error) {
	        console.log('error>>>>', error.message);
	        if (error.message === 'Request failed with status code 422') {
	          _this4.$snotify.error('Proposta já vinculada a uma FEP!');
	        } else {
	          _this4.$root.trataErro(error);
	        }
	      });
	    },
	    grava: function grava() {
	      var _this5 = this;
	
	      axiosLaravel.post('fep', this.fep).then(function (response) {
	        console.log('response', response.data);
	        _this5.$snotify.success('Número gerado sucesso!');
	        _this5.$router.go(-1);
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ListaFep',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'id',
	        sortDesc: true,
	        totalRows: 10,
	        fields: [{ key: 'id', label: 'Id', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'nomeProjeto', label: 'Proposta', sortable: true, thStyle: 'text-align: center; width: 40%', class: 'text-center' }, { key: 'ano', label: 'Ano', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'numero', label: 'Número', sortable: true, thStyle: 'text-align: center;width: 15%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 10%', class: 'text-center' }]
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loading.show = true;
	    axiosLaravel.get('fep/').then(function (response) {
	      _this.table.items = response.data.map(function (item) {
	        var nomeProjeto = null;
	
	        if (item.fep) {
	          nomeProjeto = JSON.parse(item.fep).nome_projeto || null;
	        } else if (item.proposta) {
	          nomeProjeto = item.proposta.ds_nome || null;
	        }
	        return {
	          id: item.id,
	          ano: item.ano,
	          numero: item.numero,
	          nomeProjeto: nomeProjeto,
	          fep: item.fep ? item.fep : null
	        };
	      });
	      _this.table.totalRows = _this.table.items.length;
	      _this.loading.show = false;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	      _this.loading.show = false;
	    });
	  },
	
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    },
	    inativa: function inativa(item) {}
	  }
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uploadDocumento = __webpack_require__(1750);
	
	var _uploadDocumento2 = _interopRequireDefault(_uploadDocumento);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumento: _uploadDocumento2.default
	  },
	  name: 'ListaGed',
	  data: function data() {
	    return {
	      listaDocumentos: 'CADASTRO_DIRIGENTE',
	      mostrarAdicionarDocumento: false,
	      botaoAdicionarDocumento: true,
	      data: [],
	      loading: {
	        show: false
	      },
	      hoje: new Date(),
	      items: [],
	      perfis: {},
	      documentos: {},
	      documento: {},
	      filtros: {
	        beginAdded: null,
	        beginAddedDate: null,
	        documentType: null,
	        endAddedDate: null,
	        entity: null,
	        fileName: null,
	        project: null
	      },
	      fields: [{ key: 'dt_criado', label: 'Data de Inclusão', sortable: true, thStyle: 'width: 10%; text-align: center', class: 'text-center' }, { key: 'entidade', label: 'Entidade', sortable: true, thStyle: 'width: 10%; text-align: left', class: 'text-left' }, { key: 'proposta', label: 'Projeto', sortable: true, thStyle: 'width: 40%; text-align: left', class: 'text-left' }, { key: 'ds_tipo', label: 'Tipo de Documento', sortable: true, thStyle: 'width: 10%; text-align: center', class: 'text-center' }, { key: 'origem', label: 'Origem', sortable: true, thStyle: 'width: 10%; text-align: center', class: 'text-center' }, { key: 'ds_nome_arquivo', label: 'Arquivo', sortable: true, thStyle: 'width: 20%; text-align: left', class: 'text-left' }],
	      table: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'dt_criado',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não há registros a serem mostrados'
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'GED',
	        active: true
	      }],
	      projetos: [],
	      pastas: [],
	      arquivos: [],
	      entidades: [],
	      tipos_documentos: [],
	      projetosSelecionados: [],
	      entidadesSelecionados: [],
	      tiposDocumentosSelecionados: [],
	      processosSelecionados: [],
	      validadeInicio: '2018-03-01',
	      validadeTermino: '2019-01-01'
	    };
	  },
	
	  created: function created() {
	    this.listaProjetos();
	    this.listaEntidades();
	    this.listaTipoDocumentos();
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  methods: {
	    carregarPastas: function carregarPastas(id) {
	      var i = _.findIndex(this.projetos, ['id', id]);
	      if (!_.has(this.projetos[i], 'pastas')) {
	        var p = { 'pastas': [{ id: 'ADIANTAMENTO', nome: 'Adiantamento', icone: 'fa-file-text-o' }, { id: 'PAGAMENTO', nome: 'Pagamento', icone: 'fa-file-text-o' }, { id: 'CONTRAPARTIDA', nome: 'Contrapartida', icone: 'fa-file-text-o' }, { id: 'PRESTACAO_DE_CONTAS', nome: 'Prestação de Contas', icone: 'fa-file-text-o' }, { id: 'PROPOSTA', nome: 'Documentos da Proposta', icone: 'fa-file-text-o' }, { id: 'DOCUMENTO_DIRIGENTE', nome: 'Documentos de dirigentes', icone: 'fa-file-text-o' }, { id: 'ENTIDADE', nome: 'Documentos da entidade', icone: 'fa-file-text-o' }, { id: 'RELATORIO_DE_EXECUCAO', nome: 'Relatório de Execução', icone: 'fa-file-text-o' }] };
	        _.assign(this.projetos[i], p);
	        this.$forceUpdate();
	      }
	    },
	    irPara: function irPara(link) {
	      window.open(this.urlLaravel + link, '_blank');
	    },
	    carregarArquivos: function carregarArquivos(pasta, id, atualizar) {
	      var _this = this;
	
	      var idxProjeto = _.findIndex(this.projetos, ['id', id]);
	      var projeto = this.projetos[idxProjeto];
	      var vm = this;
	      var idxPasta = _.findIndex(projeto.pastas, ['id', pasta]);
	      if (atualizar || !_.has(this.projetos[idxProjeto]['pastas'][idxPasta], 'arquivos')) {
	        this.loading.show = true;
	        this.$snotify.clear();
	        this.$snotify.success('Procurando...', { timeout: 7000 });
	        axiosLaravel.post('documentos/pasta', { 'processo': pasta, 'id': id }).then(function (response) {
	          if (_.includes(['ADIANTAMENTO', 'PAGAMENTO', 'CONTRAPARTIDA', 'PRESTACAO_DE_CONTAS'], pasta)) {
	            _.forEach(['ADIANTAMENTO', 'PAGAMENTO', 'CONTRAPARTIDA', 'PRESTACAO_DE_CONTAS'], function (p) {
	              var idx = _.findIndex(projeto.pastas, ['id', p]);
	              var arquivos = _.filter(response.data, ['processo', p]);
	              _.assign(vm.projetos[idxProjeto]['pastas'][idx], { 'arquivos': arquivos });
	            });
	          } else {
	            _.assign(vm.projetos[idxProjeto]['pastas'][idxPasta], { 'arquivos': response.data });
	          }
	          _this.$forceUpdate();
	          _this.$snotify.clear();
	          _this.loading.show = false;
	        }).catch(function (error) {
	          _this.$snotify.clear();
	          _this.loading.show = false;
	          if (error) {
	            _this.$root.trataErro(error);
	          }
	        });
	      }
	    },
	    projeto: function projeto(option) {
	      return '' + (option.ds_codigo_projeto_erp + ' - ' + option.ds_nome);
	    },
	    entidade: function entidade(option) {
	      return '' + (option.ds_nome_fantasia + ' - ' + option.ds_nome);
	    },
	    listaProjetos: function listaProjetos() {
	      var _this2 = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('projetos').then(function (response) {
	        _this2.projetos = _.sortBy(response.data, 'ds_codigo_projeto_erp');
	        _this2.projetos = _.filter(_this2.projetos, function (p) {
	          return p.ds_codigo_projeto_erp !== '' && p.ds_codigo_projeto_erp !== null;
	        });
	
	        _this2.projetos.forEach(function (projeto) {
	          var p = { 'pastas': [{ id: 'ADIANTAMENTO', nome: 'Adiantamento', icone: 'fa-file-text-o' }, { id: 'PAGAMENTO', nome: 'Pagamento', icone: 'fa-file-text-o' }, { id: 'CONTRAPARTIDA', nome: 'Contrapartida', icone: 'fa-file-text-o' }, { id: 'PRESTACAO_DE_CONTAS', nome: 'Prestação de Contas', icone: 'fa-file-text-o' }, { id: 'PROPOSTA', nome: 'Documentos da Proposta', icone: 'fa-file-text-o' }, { id: 'DOCUMENTO_DIRIGENTE', nome: 'Documentos de dirigentes', icone: 'fa-file-text-o' }, { id: 'ENTIDADE', nome: 'Documentos da entidade', icone: 'fa-file-text-o' }, { id: 'RELATORIO_DE_EXECUCAO', nome: 'Relatório de Execução', icone: 'fa-file-text-o' }] };
	          _.assign(projeto, p);
	        });
	
	        _this2.loading.show = false;
	        _this2.projetos = _.filter(_this2.projetos, function (p) {
	          return p.ds_codigo_projeto_erp !== '' && p.ds_codigo_projeto_erp !== null;
	        });
	        _this2.loading.show = false;
	      }).catch(function (error) {
	        _this2.loading.show = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    listaEntidades: function listaEntidades() {
	      var _this3 = this;
	
	      axiosLaravel.get('entidades?lista=todos').then(function (response) {
	        _this3.entidades = response.data;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    listaTipoDocumentos: function listaTipoDocumentos() {
	      var _this4 = this;
	
	      axios.get('proxy/document/documents/type').then(function (response) {
	        _this4.tipos_documentos = _.sortBy(response.data.value, 'type');
	      }).catch(function (error) {
	        if (error) {
	          _this4.$root.trataErro(error);
	        }
	      });
	    },
	    dataExpirada: function dataExpirada(validade) {
	      var data = new Date();
	      if (!_.isNull(validade)) {
	        data = new Date(validade.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
	      }
	      return this.hoje > data;
	    },
	    onDownload: function onDownload(documento) {
	      var _this5 = this;
	
	      if (documento.file) {
	        download(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _uploadDocumentoMovimentoDiario = __webpack_require__(1751);
	
	var _uploadDocumentoMovimentoDiario2 = _interopRequireDefault(_uploadDocumentoMovimentoDiario);
	
	var _liquorTree = __webpack_require__(1560);
	
	var _liquorTree2 = _interopRequireDefault(_liquorTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentoMovimentoDiario: _uploadDocumentoMovimentoDiario2.default,
	    Tree: _liquorTree2.default
	  },
	  name: 'MovimentoDiario',
	  data: function data() {
	    return {
	      loading: {
	        tela: false,
	        pastas: false,
	        arquivos: false
	      },
	
	      pastaSelecionada: null,
	      modo: 'pasta',
	      pesquisa: [],
	      arquivos: [],
	      arquivosSelecionados: [],
	      mostrarAdicionarDocumento: false,
	      hoje: new Date(),
	      tipos_documentos: [],
	
	      filter: null,
	      opts: {
	        minFetchDelay: 1000,
	        fetchData: function fetchData(node) {
	          var pastas = axiosLaravel.get('pasta/' + node.id).then(function (response) {
	            return response.data;
	          });
	          console.log('Pastas >>> ', pastas);
	          return pastas;
	        },
	
	        parentSelect: true,
	        checkbox: false,
	        multiple: false
	      },
	      table: {
	        filter: null,
	        hover: true,
	        bordered: true,
	        block: false,
	        currentPage: 1,
	        perPage: 2000,
	        sortBy: 'dt_criado',
	        sortDesc: true,
	        fields: [{ key: 'nome', label: 'Arquivo', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'dt_criado', label: 'Data de Inclusão', sortable: true, thStyle: 'text-align: center; width: 250px', class: 'text-center' }]
	      },
	      arvore: [{ 'id': 1, 'text': 'Movimento Diário', 'isBatch': true, 'selected': true }]
	    };
	  },
	
	  created: function created() {
	    console.log('iniciando');
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  methods: {
	    limparPesquisa: function limparPesquisa() {
	      this.arquivos = [];
	      this.arquivosSelecionados = [];
	      this.pesquisa = '';
	      this.modo = 'pasta';
	      this.mostrarAdicionarDocumento = false;
	      if (!_.isNull(this.pastaSelecionada)) {
	        this.selecionaPasta(this.pastaSelecionada);
	      }
	    },
	    pesquisar: function pesquisar() {
	      var _this = this;
	
	      if (this.pesquisa !== '') {
	        this.loading.arquivos = true;
	        this.arquivos = [];
	        this.arquivosSelecionados = [];
	        this.mostrarAdicionarDocumento = false;
	        axiosLaravel.post('pasta/pesquisar/', { 'tipo': 'arquivos', 'escopo': 'tudo', 'termo': this.pesquisa }).then(function (response) {
	          _this.modo = 'pesquisa';
	          console.log('Arquivos', response.data);
	          _this.arquivos = response.data;
	          _this.$refs.caixaPesquisa.focus();
	          _this.loading.arquivos = false;
	        }).catch(function (error) {
	          _this.loading.arquivos = false;
	          _this.$root.trataErro(error);
	        });
	      }
	    },
	    filtrarArquivos: function filtrarArquivos(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    },
	    selecionarTodosArquivos: function selecionarTodosArquivos() {
	      if (this.arquivosSelecionados.length === this.arquivos.length) {
	        this.arquivosSelecionados = [];
	      } else {
	        this.arquivosSelecionados = _.cloneDeep(this.arquivos);
	      }
	    },
	    selecionarArquivo: function selecionarArquivo(arquivo) {
	      if (_.find(this.arquivosSelecionados, ['id', arquivo.id])) {
	        _.remove(this.arquivosSelecionados, function (i) {
	          return i['id'] === arquivo.id;
	        });
	      } else {
	        this.arquivosSelecionados.push(arquivo);
	      }
	      this.$forceUpdate();
	    },
	    selecionaPasta: function selecionaPasta(node) {
	      var _this2 = this;
	
	      this.mostrarAdicionarDocumento = false;
	      this.arquivos = [];
	      this.arquivosSelecionados = [];
	      this.pesquisa = '';
	      this.modo = 'pasta';
	      if (node.data.ler === 1) {
	        this.loading.arquivos = true;
	        axiosLaravel.get('pasta/conteudo/' + node.id).then(function (response) {
	          console.log('Arquivos', response.data);
	          _this2.arquivos = response.data;
	          _this2.arquivosSelecionados = [];
	          _this2.loading.arquivos = false;
	        }).catch(function (error) {
	          _this2.loading.arquivos = false;
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    renomearPasta: function renomearPasta(node) {
	      var _this3 = this;
	
	      this.loading.pastas = true;
	      console.log('renomearPasta', node);
	      this.$dialog.prompt('Deseja renomear a pasta <b>' + node.text + '</b> para:', { html: true, animation: 'fade', customClass: 'avisoInfo', promptHelp: 'Digite o novo nome da pasta (até 250 caracteres)' }).then(function (dialog) {
	        axiosLaravel.post('pasta/renomear/', { 'id': node.id, 'nome': dialog.data }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _.set(node, 'text', dialog.data);
	          }
	          _this3.loading.pastas = false;
	          _this3.aviso(response.data);
	        }).catch(function (error) {
	          _this3.loading.pastas = false;
	          _this3.$root.trataErro(error);
	        });
	      }).catch(function () {
	        _this3.loading.pastas = false;
	        console.log('Cancelou renomeação da pasta');
	      });
	    },
	    adicionarPasta: function adicionarPasta(node) {
	      var _this4 = this;
	
	      this.loading.pastas = true;
	      console.log('adicionarPasta', node);
	      this.$dialog.prompt('Deseja criar uma pasta nova dentro de <b>' + node.text + '</b> para:', { html: true, animation: 'fade', customClass: 'avisoInfo', promptHelp: 'Digite o nome da pasta nova (até 250 caracteres)' }).then(function (dialog) {
	        axiosLaravel.post('pasta/criar/', { 'id': node.id, 'nome': dialog.data }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            var novaPasta = node.append(dialog.data);
	            _.set(novaPasta, 'id', response.data.retorno.id);
	            _.set(novaPasta, 'data.criar', 1);
	            _.set(novaPasta, 'data.excluir', 1);
	            _.set(novaPasta, 'data.renomear', 1);
	            _.set(novaPasta, 'data.adicionar', 1);
	            _.set(novaPasta, 'data.ler', 1);
	            _.set(node, 'states.expanded', 1);
	          }
	          _this4.loading.pastas = false;
	          _this4.aviso(response.data);
	        }).catch(function (error) {
	          _this4.loading.pastas = false;
	          _this4.$root.trataErro(error);
	        });
	      }).catch(function () {
	        _this4.loading.pastas = false;
	        console.log('Cancelou criação de nova pasta');
	      });
	    },
	    excluirPasta: function excluirPasta(node) {
	      var _this5 = this;
	
	      this.loading.pastas = true;
	      console.log('adicionarPasta', node);
	      this.$dialog.confirm('Deseja excluir a pasta <b>' + node.text + '</b>?', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	        axiosLaravel.post('pasta/excluir/', { 'id': node.id }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            node.remove();
	          }
	          _this5.loading.pastas = false;
	          _this5.aviso(response.data);
	        }).catch(function (error) {
	          _this5.loading.pastas = false;
	          _this5.$root.trataErro(error);
	        });
	      }).catch(function () {
	        _this5.loading.pastas = false;
	        console.log('Cancelou criação de nova pasta');
	      });
	    },
	    excluirArquivos: function excluirArquivos() {
	      var _this6 = this;
	
	      this.loading.arquivos = true;
	      console.log('excluirArquivos');
	      this.$dialog.confirm('Deseja excluir este(s) <b>' + this.arquivosSelecionados.length + '</b> arquivo(s)?', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	        axiosLaravel.post('pasta/excluir/arquivos/', { 'arquivos': _this6.arquivosSelecionados }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            if (_this6.modo === 'pesquisa') {
	              _this6.pesquisar();
	            } else if (_this6.modo === 'pasta' && !_.isNull(_this6.pastaSelecionada)) {
	              _this6.selecionaPasta(_this6.pastaSelecionada);
	            }
	          }
	          _this6.aviso(response.data);
	          _this6.loading.arquivos = false;
	        }).catch(function (error) {
	          _this6.loading.arquivos = false;
	          _this6.$root.trataErro(error);
	        });
	      }).catch(function () {
	        _this6.loading.arquivos = false;
	        console.log('Cancelou exclusão de arquivos');
	      });
	    },
	    aviso: function aviso(retorno) {
	      console.log('aviso (retorno)', retorno);
	      if (_.has(retorno, 'codigo')) {
	        if (retorno.codigo !== 'OK') {
	          var mensagem = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : 'Erro de processamento. Não sei o que houve';
	          this.$snotify.clear();
	          this.$snotify.error(mensagem);
	        } else {
	          if (_.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem)) {
	            this.$snotify.success(retorno.mensagem, { timeout: 3000 });
	          }
	        }
	      }
	    },
	    downloadArquivo: function downloadArquivo(documento) {
	      var _this7 = this;
	
	      if (documento.file) {
	        download(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('pasta/download/arquivo/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var tamanhoRetorno = 0;
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            tamanhoRetorno = blob.size;
	            if (tamanhoRetorno > 150) {
	              var link = document.createElement('a');
	              link.href = window.URL.createObjectURL(blob);
	              link.download = documento.ds_nome_arquivo;
	              document.body.appendChild(link);
	              link.click();
	              document.body.removeChild(link);
	            }
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            tamanhoRetorno = _blob.size;
	            if (tamanhoRetorno > 150) {
	              var _link = document.createElement('blob');
	              _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	              _link.download = documento.ds_nome_arquivo;
	              _link.click();
	            }
	          }
	          _this7.aviso(tamanhoRetorno > 150 ? { 'codigo': 'OK', 'mensagem': 'Baixando arquivo' } : { 'codigo': 'ERRO', 'mensagem': 'Erro ao baixar o arquivo' });
	        }).catch(function (error) {
	          _this7.$root.trataErro(error);
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'documentos-por-tipo',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      tamanho: 0,
	      contador: 0,
	      tamanhoFormatado: 0,
	      salvou: false,
	      acmTamanho: 0,
	      totalMb: 0,
	      mostrarInclusao: false,
	      documento: {},
	      tipoDocumento: '',
	      descricao: '',
	      tabela: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 500,
	        fields: [{ key: 'link', label: 'Documento', sortable: true, thStyle: 'text-align: center; width: 75%', class: 'text-left' }, { key: 'data', label: 'Publicação', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 15%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['tipo'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  created: function created() {
	    if (this.usuarioLogado.userType !== 'FUNDACAO') {
	      this.tabela.fields = _.filter(this.tabela.fields, function (o) {
	        return o.key !== 'actions';
	      });
	    }
	    this.descricaoTipo();
	    this.listarDocumentos();
	  },
	
	  methods: {
	    descricaoTipo: function descricaoTipo() {
	      var _this = this;
	
	      axiosLaravel.post('documentos/tipos/TODOS').then(function (response) {
	        console.log('tipos/TODOS', response);
	        _this.tipoDocumento = _.find(response.data, ['id', _this.tipo])['ds_tipo'];
	        console.log('this.tipoDocumento', _this.tipoDocumento);
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    listarDocumentos: function listarDocumentos() {
	      var _this2 = this;
	
	      this.loading.show = true;
	      console.log('this.tipo', this.tipo);
	      axiosLaravel.post('documentos/tipo', { 'tipo': this.tipo }).then(function (response) {
	        console.log('arquivos', response.data);
	        _this2.tabela.items = response.data;
	        _this2.loading.show = false;
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        _this2.loading.show = false;
	        if (error) {
	          _this2.$root.trataErro(error);
	        }
	      });
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      this.tamanho = e.target.files[0].size;
	      this.tamanhoFormatado = (this.tamanho / Math.pow(1024, 2)).toFixed(2);
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    excluirDocumento: function excluirDocumento(documento) {
	      var _this3 = this;
	
	      this.loading.show = true;
	      documento.dt_inativado = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	      documento.id_usuario = this.usuarioLogado.id;
	      axiosLaravel.put('documentos/excluir', documento).then(function (response) {
	        console.log('response', response);
	        _this3.loading.show = false;
	        _this3.listarDocumentos(_this3.tipo);
	      }).catch(function (error) {
	        _this3.loading.show = false;
	        _this3.$root.trataErro(error);
	      });
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this4 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this4.$validator.errors.all().length === 0) {
	          var data = new FormData();
	          data.append('file', _this4.file);
	          _this4.documento.dt_criado = new Date();
	          _this4.documento.dt_atualizado = new Date();
	          _this4.documento.descricao = _this4.descricao;
	          _this4.documento.loaded = 'upload_por_tipo';
	          _this4.documento.tipo = _this4.tipo;
	          _this4.documento.usuario = _this4.usuarioLogado;
	          _this4.documento.ligacao_type = null;
	          data.append('document', (0, _stringify2.default)(_this4.documento));
	          _this4.$snotify.clear();
	          _this4.$snotify.info('Adicionando arquivo...', { timeout: 0 });
	          _this4.loading.show = true;
	          axiosLaravel.post('documentos/upload', data, {
	            headers: {
	              'Content-Type': undefined,
	              'Accept': 'application/json'
	            },
	            transformRequest: [function (data, headers) {
	              return data;
	            }]
	          }).then(function (response) {
	            _this4.loading.show = false;
	            _this4.$snotify.clear();
	            _this4.$snotify.success('Arquivo incluído!');
	            _this4.cancelar();
	            _this4.listarDocumentos();
	          }).catch(function (error) {
	            console.log('error', error);
	            _this4.loading.show = false;
	            _this4.$snotify.clear();
	            _this4.$root.trataErro(error);
	          });
	        }
	      });
	    },
	    cancelar: function cancelar() {
	      this.$refs.file.value = null;
	      this.descricao = '';
	      this.errors.items = [];
	      this.mostrarInclusao = false;
	    },
	    uploadArquivo: function uploadArquivo() {},
	    onDownload: function onDownload(documento) {
	      var _this5 = this;
	
	      console.log('novo documento');
	      if (documento.file) {
	        download(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _xlsx = __webpack_require__(144);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _cnpj = __webpack_require__(268);
	
	var _cnpj2 = _interopRequireDefault(_cnpj);
	
	var _cpf = __webpack_require__(178);
	
	var _cpf2 = _interopRequireDefault(_cpf);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ImportacaoExcel',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      resultadoAnalise: false,
	      analise: [],
	      acaoComplementar: false,
	      textoAcaoComplementar: '',
	      contadorErrosGerais: 0,
	      verificacaoExcel: '',
	      cadastroEntidade: {},
	      nomeArquivo: '',
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Importação',
	        active: true
	      }]
	    };
	  },
	
	  props: ['modelo'],
	  created: function created() {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {},
	  methods: {
	    lerExcel: function lerExcel() {
	      var vm = this;
	      var fileUpload = document.getElementById('fileUpload');
	      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
	      if (regex.test(fileUpload.value.toLowerCase())) {
	        if (typeof FileReader !== 'undefined') {
	          var reader = new FileReader();
	
	          if (reader.readAsBinaryString) {
	            reader.onload = function (e) {
	              vm.analisarExcel(e.target.result);
	            };
	            reader.readAsBinaryString(fileUpload.files[0]);
	          } else {
	            reader.onload = function (e) {
	              var data = '';
	              var bytes = new Uint8Array(e.target.result);
	              for (var i = 0; i < bytes.byteLength; i++) {
	                data += String.fromCharCode(bytes[i]);
	              }
	              vm.analisarExcel(data);
	            };
	            reader.readAsArrayBuffer(fileUpload.files[0]);
	          }
	        } else {
	          vm.adicionaValidacao('navegador_invalido', false, '<p><span class="verificacaoERRO">O navegador de internet que está usando não suportado a operação. Favor usar um dos recomendados.</span></p>');
	        }
	      } else {
	        vm.adicionaValidacao('arquivo_invalido', false, '<p><span class="verificacaoERRO">Esse arquivo não é do Excel (XLS ou XLSX)</span></p>');
	      }
	      vm.resultado();
	    },
	    analisarExcel: function analisarExcel(data) {
	      var _this = this;
	
	      var vm = this;
	      vm.resultadoAnalise = true;
	
	      var workbook = XLSX.read(data, {
	        type: 'binary'
	      });
	      vm.verificacaoExcel = '';
	
	      var codigoModelo = _.find(XLSX.utils.sheet_to_row_object_array(workbook.Sheets['Dados Básicos']), ['valor', this.modelo]);
	
	      if (_.isUndefined(codigoModelo)) {
	        vm.adicionaValidacao('modelo_invalido', false, '<span class="verificacaoERRO">Ops! Esse Excel não é a planilha correta</span>');
	      } else {
	        vm.cadastroEntidade['dadosBasicos'] = XLSX.utils.sheet_to_row_object_array(workbook.Sheets['Dados Básicos']);
	        vm.cadastroEntidade['enderecos'] = XLSX.utils.sheet_to_row_object_array(workbook.Sheets['Endereços']);
	        vm.cadastroEntidade['dirigentes'] = XLSX.utils.sheet_to_row_object_array(workbook.Sheets['Dirigentes']);
	        vm.cadastroEntidade['usuarios'] = XLSX.utils.sheet_to_row_object_array(workbook.Sheets['Usuários do Sistema']);
	
	        vm.cadastroEntidade['usuarios'] = _.pullAllBy(vm.cadastroEntidade['usuarios'], [{ 'Nome': 0 }], 'Nome');
	        vm.cadastroEntidade['enderecos'] = _.filter(vm.cadastroEntidade['enderecos'], function (o) {
	          return o['Endereço'];
	        });
	        vm.cadastroEntidade['dirigentes'] = _.filter(vm.cadastroEntidade['dirigentes'], function (o) {
	          return o['Nome'];
	        });
	        vm.cadastroEntidade['representanteLegal'] = _.filter(vm.cadastroEntidade['dirigentes'], { 'bt_representante_legal': 1 });
	        var dadosBasicoEmBranco = vm.cadastroEntidade['dadosBasicos'][1]['valor'];
	        if (dadosBasicoEmBranco > 0) {
	          vm.adicionaValidacao('dados_basicos', false, '<p><span class="verificacaoERRO"><strong>Dados Básicos</strong> com ' + dadosBasicoEmBranco + (dadosBasicoEmBranco > 1 ? ' campos não preenchidos' : ' campo não preenchido') + '</span></p>');
	        } else {
	          vm.adicionaValidacao('dados_basicos', true, '<p><span class="verificacaoOK">Dados Básicos preenchidos</span></p>');
	        }
	
	        vm.cadastroEntidade['dadosBasicos'][3]['valor'] = ('' + vm.cadastroEntidade['dadosBasicos'][3]['valor']).replace(/\.|-|\/| /g, '');
	        var CNPJvalidado = _cnpj2.default.validate(vm.cadastroEntidade['dadosBasicos'][3]['valor']);
	        if (!CNPJvalidado && vm.cadastroEntidade['dadosBasicos'][3]['valor'] !== '') {
	          vm.adicionaValidacao('validacao_cnpj', false, '<p><span class="verificacaoERRO">O CNPJ \'<strong>' + vm.cadastroEntidade['dadosBasicos'][3]['valor'] + '</strong>\' informado na planilha, não é um CNPJ válido</span></p>');
	        }
	
	        var enderecosIncompletos = _.filter(vm.cadastroEntidade['enderecos'], function (o) {
	          return o['Obrigatoriedade'] > 0;
	        });
	        if (enderecosIncompletos.length > 0) {
	          var camposEnderecoEmBranco = _.sumBy(enderecosIncompletos, function (o) {
	            return o['Obrigatoriedade'];
	          });
	          vm.adicionaValidacao('enderecos', false, '<p><span class="verificacaoERRO">Há ' + enderecosIncompletos.length + ' endereço' + (enderecosIncompletos.length > 1 ? 's' : '') + ' com ' + camposEnderecoEmBranco + (camposEnderecoEmBranco > 1 ? ' campos não preenchidos' : ' campo não preenchido') + '</span></p>');
	        } else if (vm.cadastroEntidade['enderecos'].length === 0) {
	          vm.adicionaValidacao('enderecos', false, '<p><span class="verificacaoERRO">Nenhum <strong>Endereço</strong> foi cadastrado. Pelo menos da sede deve constar na planilha</span></p>');
	        } else {
	          vm.adicionaValidacao('enderecos', true, '<p><span class="verificacaoOK">' + vm.cadastroEntidade['enderecos'].length + (vm.cadastroEntidade['enderecos'].length > 1 ? ' Endereços informados' : ' Endereço informado') + ' </span></p>');
	        }
	
	        _.forEach(vm.cadastroEntidade['dirigentes'], function (dirigente, id) {
	          dirigente['CPF'] = ('' + dirigente['CPF']).replace(/\.|-|\/| /g, '');
	        });
	
	        var dirigentesIncompletos = _.filter(vm.cadastroEntidade['dirigentes'], function (o) {
	          return o['Obrigatoriedade'] > 0;
	        });
	        if (dirigentesIncompletos.length > 0) {
	          var camposDirigentesEmBranco = _.sumBy(dirigentesIncompletos, function (o) {
	            return o['Obrigatoriedade'];
	          });
	          vm.adicionaValidacao('dirigentes', false, '<p><span class="verificacaoERRO">Há ' + dirigentesIncompletos.length + ' dirigente' + (dirigentesIncompletos.length > 1 ? 's' : '') + ' com ' + camposDirigentesEmBranco + (camposDirigentesEmBranco > 1 ? ' campos não preenchidos' : ' campo não preenchido') + '</span></p>');
	        } else if (vm.cadastroEntidade['dirigentes'].length === 0) {
	          vm.adicionaValidacao('dirigentes', false, '<p><span class="verificacaoERRO">Nenhum <strong>Dirigente</strong> foi cadastrado. Pelo menos, um dirigente da entidade deve ser adicionado na planilha</span></p>');
	        } else {
	          vm.adicionaValidacao('dirigentes', true, '<p><span class="verificacaoOK">' + vm.cadastroEntidade['dirigentes'].length + (vm.cadastroEntidade['dirigentes'].length > 1 ? ' Dirigentes informados' : ' Dirigente informado') + ' </span></p>');
	        }
	
	        _.forEach(vm.cadastroEntidade['usuarios'], function (usuario, id) {
	          axiosLaravel.post('/verifica-usuario/', { 'parametro': usuario['Login'] }).then(function (response) {
	            if (response.data.length > 0) {
	              vm.cadastroEntidade['usuarios'][id].Login = _.split(_.lowerCase(vm.cadastroEntidade['usuarios'][id].Login), ' ', 1) + _.toString(_.now()).substr(-5);
	            }
	          }).catch(function (error) {
	            if (error) {
	              vm.$root.trataErro(error);
	            }
	          });
	
	          usuario['CPF'] = usuario['CPF'].replace(/\.|-|\/| /g, '');
	
	          var CPFvalidado = _cpf2.default.validate(usuario['CPF']);
	          if (!CPFvalidado) {
	            vm.adicionaValidacao('usuario' + usuario['CPF'], false, '<p><span class="verificacaoERRO">O CPF \'<strong>' + usuario['CPF'] + '</strong>\' de ' + usuario['Nome'] + ', não é um CPF válido</span></p>');
	          }
	
	          vm.adicionaValidacao('usuario' + usuario['E-mail'], false, '<p><span class="verificacaoANALISANDO">Analisando <strong>' + usuario['Nome'] + '</strong>...</span></p>');
	          axiosLaravel.post('/verifica-usuario/', { 'parametro': usuario['E-mail'] }).then(function (response) {
	            if (response.data.length > 0) {
	              vm.adicionaValidacao('usuario' + usuario['E-mail'], false, '<p><span class="verificacaoERRO">O e-mail <strong>' + usuario['E-mail'] + '</strong> de <i>' + usuario['Nome'] + '</i> já esta sendo usado. Informe outro e-mail na planilha</span></p>');
	            } else {
	              vm.adicionaValidacao('usuario' + usuario['E-mail'], true, null);
	            }
	            vm.resultado();
	          }).catch(function (error) {
	            if (error) {
	              vm.$root.trataErro(error);
	            }
	          });
	        });
	
	        var cpfs = _.map(_.countBy(vm.cadastroEntidade['usuarios'], 'CPF'), function (o) {
	          return o > 1;
	        });
	        if (_.remove(cpfs, function (n) {
	          return n;
	        }).length !== 0) {
	          vm.adicionaValidacao('cpf_repetidos', false, '<p><span class="verificacaoERRO">Há <strong>CPF</strong> repetido na planilha</span></p>');
	        }
	
	        if (vm.cadastroEntidade['representanteLegal'].length < 1) {
	          vm.adicionaValidacao('representanteLegal', false, '<p><span class="verificacaoERRO">Deve haver pelo menos um Dirigente marcado com \'SIM\' na coluna de <strong>Representante Legal</strong></span></p>');
	        }
	
	        var cnpj = vm.cadastroEntidade['dadosBasicos'][3]['valor'];
	        if (cnpj.length > 3) {
	          axiosLaravel.post('entidade/existe', { 'cnpj': cnpj }).then(function (response) {
	            if (response.data > 0) {
	              _this.acaoComplementar = true;
	              _this.textoAcaoComplementar = 'Esta instituição já está cadastrada. Se prosseguir, substituirá o cadastro atual! Em caso de dúvidas, encaminhe mensagem para <strong>chamadaspublicas@fbb.org.br</strong>  ';
	              _this.adicionaValidacao('entidade', false, null);
	            } else {
	              _this.adicionaValidacao('entidade', true, null);
	            }
	            _this.resultado();
	          }).catch(function (error) {
	            if (error) {
	              _this.$root.trataErro(error);
	            }
	          });
	        }
	      }
	
	      console.log('Excel - Cadastro Entidade', vm.cadastroEntidade);
	      vm.resultado();
	    },
	    verificarModelo: function verificarModelo() {
	      this.lerExcel();
	    },
	    adicionaValidacao: function adicionaValidacao(i, v, h) {
	      var obj = { item: i, validacao: v, html: h };
	      _.remove(this.analise, ['item', i]);
	      this.analise.push(obj);
	    },
	    opcaoAcaoComplementar: function opcaoAcaoComplementar(opcao) {
	      this.adicionaValidacao('entidade', opcao, null);
	      this.$refs.respostaAcaoComplementar.innerHTML = opcao ? 'SIM' : 'NÃO';
	      this.resultado();
	    },
	    limparArquivo: function limparArquivo() {
	      this.analise = [];
	      this.$refs.fileUpload.value = null;
	      this.verificacaoExcel = '';
	      this.acaoComplementar = false;
	      this.textoAcaoComplementar = '';
	      this.resultado();
	    },
	    arquivoAlterado: function arquivoAlterado(e) {
	      this.analise = [];
	      if (e.target.value !== '') {
	        this.verificarModelo();
	        this.nomeArquivo = e.target.value;
	      } else {
	        this.verificacaoExcel = '';
	      }
	    },
	    resultado: function resultado() {
	      this.verificacaoExcel = _.join(_.map(this.analise, 'html'), '');
	      this.contadorErrosGerais = _.filter(_.reject(this.analise, { 'item': 'entidade', 'validacao': false }), ['validacao', false]).length;
	      var analiseExcel = !(_.filter(this.analise, ['validacao', false]).length > 0 || this.analise.length === 0);
	      this.$emit('analiseExcel', analiseExcel);
	      this.$emit('objetoExcel', analiseExcel ? this.cadastroEntidade : {});
	    }
	  }
	};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'editar-motivos',
	  data: function data() {
	    return {
	      motivos: {},
	      loading: {
	        show: false
	      }
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {
	    this.selectedValue;
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      this.loading.show = true;
	      axiosLaravel.get('motivos/' + this.$route.params.id).then(function (response) {
	        _this.motivos = response.data;
	        _this.motivos.data_inclusao = (0, _moment2.default)(_this.motivos.data_inclusao).format('DD/MM/YYYY');
	        _this.motivos.data_atualizado = (0, _moment2.default)(_this.motivos.data_atualizado).format('DD/MM/YYYY');
	        _this.loading.show = false;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    }
	  },
	
	  methods: {
	    selectedValue: function selectedValue() {},
	    salva: function salva() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.motivos.id) {
	            _this2.atualiza();
	          } else {
	            _this2.grava();
	          }
	        } else {
	          _this2.errors.items.forEach(function (item) {
	            _this2.$snotify.error(item.msg);
	          });
	        }
	      });
	    },
	    atualiza: function atualiza() {
	      var _this3 = this;
	
	      this.$aguarde('Salvando o Motivo de Devolução. Por favor, aguarde...');
	      axiosLaravel.put('motivos/' + this.motivos.id, this.motivos).then(function (response) {
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Motivo de Devolução salvo com sucesso!');
	        _this3.$router.go(-1);
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this4 = this;
	
	      this.$aguarde('Salvando o Motivo de Devolução. Por favor, aguarde...');
	      axiosLaravel.post('motivos', this.motivos).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Motivo de Devolução salvo com sucesso!');
	        _this4.$router.go(-1);
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'lista-motivos',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        totalRows: null,
	        fields: [{ key: 'codigo', label: 'Código', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'descricao', label: 'Descrição', sortable: true, thStyle: 'text-align: center; width: 30%', class: 'text-center' }, { key: 'data_inclusao', label: 'Data Inclusão', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 10%', class: 'text-center' }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['urlLaravel'])),
	  created: function created() {
	    var _this = this;
	
	    this.loading.show = true;
	    axiosLaravel.get('motivos/').then(function (response) {
	      _this.table.items = response.data;
	      _this.table.totalRows = response.data.length;
	      _this.loading.show = false;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	      _this.loading.show = false;
	    });
	  },
	
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    inativa: function inativa(item) {
	      var _this2 = this;
	
	      this.loading.show = true;
	      axiosLaravel.delete('motivos/' + item.id).then(function (response) {
	        _this2.$snotify.success('Motivo ' + item.codigo + ' atualizado com sucesso!');
	        item.bt_ativo = !item.bt_ativo;
	        _this2.loading.show = false;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _xlsx = __webpack_require__(144);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default
	  },
	  name: 'EditaOcorrencias',
	  data: function data() {
	    return {
	      acao: 'LISTAR',
	      loading: {
	        tela: false,
	        carteiras: false,
	        codigos: false,
	        detalhes: false,
	        listaOcorrencias: false,
	        listaProjetosEntidades: false
	      },
	      filtro: {
	        id: [],
	        codigo: [],
	        situacao: [],
	        etapa: [],
	        nivel: [],
	        carteira: null,
	        observacao: '',
	        pesquisa: ''
	      },
	      tabelaListaOcorrencias: {
	        currentPage: 1,
	        perPage: 6,
	        totalRows: 0,
	        sortBy: 'tarefaInicio',
	        sortDesc: true,
	        filter: null,
	        bordered: true,
	        numeroAtualizacao: 0,
	
	        fields: [{ key: 'tarefaInicio', label: 'Data criação', thStyle: 'text-align: center; width: 110px', class: 'text-center' }, { key: 'id', label: 'ID', sortable: true, thStyle: 'text-align: center; width: 50px', class: 'text-center' }, { key: 'codigo', label: 'Ocorrência', sortable: true, thStyle: 'text-align: center', class: 'text-left' }, { key: 'projeto', label: 'Projeto / Entidade', sortable: true, thStyle: 'text-align: center', class: 'text-left' }, { key: 'observacao', label: 'Observação', sortable: true, thStyle: 'text-align: center; width: 30%', class: 'text-center' }, { key: 'etapa', label: 'Situação', sortable: true, thStyle: 'text-align: center; width: 100px', class: 'text-center' }, { key: 'acoes', label: 'Ações', thStyle: 'text-align: center; width: 110px', class: 'text-center' }]
	      },
	      pesquisa: '',
	      hoje: new Date(),
	      enumeradores: { 'ANALISE': 'Análise', 'PENDENCIAS': 'Pendências', 'AUTORIZACAO': 'Autorização', 'REVISAO': 'Revisão', 'APROVACAO': 'Aprovação', 'ENTIDADE': 'Entidade', 'PROJETO': 'Projeto', 'OCORRENCIAS': 'Ocorrências', 'OCORRENCIA_PROJETO': 'Ocorrência em projetos', 'OCORRENCIA_ENTIDADE': 'Ocorrência em entidade', 'FLEXIBILIZACAO': 'Flexibilização', 'SOLICITACAO': 'Registro', 'ENCAMINHAR_APROVACAO': 'Encaminhar para Aprovação', 'ENCAMINHAR_BAIXA': 'Encaminhar para Baixa', 'APROVAR': 'Aprovar', 'BAIXAR': 'Aprovar Baixa', 'CANCELAR': 'Cancelar', 'LIBERADO': 'Liberado', 'AGUARDA_APROVACAO': 'Aguardando Aprovação', 'AGUARDA_BAIXA': 'Aguardando Baixa', 'BAIXADO': 'Baixado', 'CANCELADO': 'Cancelado', 'FEITO': 'Feito', 'EM_EXECUCAO': 'Em Execução', 'CRIACAO_OCORRENCIA_SAPIENS': 'Gerando ocorrência no Sapiens', 'ATUALIZACAO_OCORRENCIA_SAPIENS': 'Atualizando ocorrência no Sapiens', 'MIGRADO_MODULO_ACOMPANHAMENTO': 'Migrado do módulo de Acompanhamento', 'ASSENTAMENTO': 'Assentamento', 'INFORMATIVAS': 'Informativas', 'ALERTAS': 'Alertas', 'RESTRITIVAS_RELATIVAS': 'Restritivas Relativas', 'RESTRITIVAS_ABSOLUTAS': 'Restritivas Absolutas' },
	      itensLayoutTela: ['botaoNovo', 'botaoExportarExcel', 'caixaPesquisa', 'filtroTexto', 'filtroCarteira', 'filtroNivelOcorrencia', 'filtroCodigoOcorrencia', 'filtroSituacaoOcorrencia', 'totalizador', 'colunaId', 'colunaCodigo', 'colunaObservacao', 'colunaProjeto', 'colunaUsuarioCriador', 'colunaSituacao', 'colunaDataCriacao', 'colunaAcoes'],
	      listaNiveis: [{ 'nivel': 1, 'codigo': 'INFORMATIVAS' }, { 'nivel': 2, 'codigo': 'ALERTAS' }, { 'nivel': 3, 'codigo': 'RESTRITIVAS_RELATIVAS' }, { 'nivel': 4, 'codigo': 'RESTRITIVAS_ABSOLUTAS' }],
	      listaSituacoesOcorrencias: ['LIBERADO', 'AGUARDA_APROVACAO', 'AGUARDA_BAIXA', 'BAIXADO'],
	      listaCarteiras: [],
	      id: null,
	      ocorrencias: [],
	      itemOcorrencia: {},
	      ocorrencia: {
	        acao: 'SALVAR',
	        tipo: 'PROJETO',
	        alvo: null,
	        enquadramento: null,
	        observacao: '',
	        observacaoDecisao: '',
	        prazo: null,
	        anexos: []
	      },
	      grupoOcorrencia: null,
	      listaTiposOcorrencias: [],
	      listaTiposOcorrenciasBackup: [],
	      listaProjetosEntidades: [],
	      etapa: 'SOLICITACAO',
	      aprovacao: {},
	      numeroAtualizacao: 0,
	      layoutHistorico: 'RESUMIDO',
	      ehVisualizacao: false,
	      ehGestor: false,
	      buscaTipo: 'projeto',
	      placeholderCampoBusca: [{ tipo: 'projeto', placeholder: 'Número do projeto' }, { tipo: 'entidade', placeholder: 'Nome do projeto' }, { tipo: 'cnpj', placeholder: 'CNPJ da entidade' }]
	
	    };
	  },
	
	  props: ['ids', 'idEntidade', 'idProcesso', 'botaoVoltar', 'numeroProjeto', 'situacaoOcorrencia', 'codigoOcorrencia', 'nivelOcorrencia', 'visualizacao', 'informacao', 'itensLayout'],
	  created: function created() {
	    var _this = this;
	
	    var vm = this;
	    this.ehVisualizacao = this.visualizacao || this.$route.params.visualizacao || false;
	
	    this.ehGestor = this.usuarioLogado.perfis.some(function (perfil) {
	      return perfil.ds_nome === 'Gerentes';
	    });
	    this.id = this.idProcesso || this.$route.params.id || null;
	    this.limparPesquisa();
	    if (_.isNil(this.numeroProjeto) && _.has(this.usuarioLogado, 'configuracoes.tela_ocorrencias.filtro')) {
	      var filtroBackup = this.filtro;
	      _.forEach(this.usuarioLogado.configuracoes.tela_ocorrencias.filtro, function (v, p) {
	        vm.filtro[p] = _.isEmpty(v) ? filtroBackup[p] : v;
	      });
	      this.$forceUpdate();
	    }
	
	    if (this.itensLayout && this.itensLayout.length > 0) {
	      var colunasParaRemover = _.filter(_.xor(this.itensLayoutTela, this.itensLayout), function (i) {
	        return i.indexOf('coluna') !== -1;
	      });
	      colunasParaRemover.forEach(function (item) {
	        _.remove(_this.tabelaListaOcorrencias.fields, ['key', _.toLower(item.replace('coluna', ''))]);
	      });
	      if (!_.includes(this.itensLayout, 'colunaProjeto') && _.includes(this.itensLayout, 'colunaObservacao')) {
	        _.set(_.find(this.tabelaListaOcorrencias.fields, ['key', 'observacao']), 'thStyle', 'text-align: center; width: auto');
	      }
	    }
	    this.itensLayoutTela = this.itensLayout || this.itensLayoutTela;
	    if (!_.isNull(this.id)) {
	      this.acaoOcorrencia('EDITAR', this.id);
	    } else if (!_.isNil(this.numeroProjeto)) {
	      this.buscaOcorrencias();
	    }
	    this.carregarListaTiposOcorrencias();
	    this.carregarListaProjetosEntidades();
	    this.buscaCarteiras();
	  },
	
	  watch: {
	    'ocorrencia.tipo': function ocorrenciaTipo() {
	      if (!this.ehVisualizacao && this.etapa === 'SOLICITACAO') {
	        this.ocorrencia.alvo = null;
	        this.grupoOcorrencia = null;
	        this.ocorrencia.enquadramento = null;
	        this.$forceUpdate();
	      }
	    },
	    'ocorrencia.acao': function ocorrenciaAcao() {
	      this.ocorrencia.observacaoDecisao = null;
	      this.$forceUpdate();
	    },
	    'ocorrencia.enquadramento': function ocorrenciaEnquadramento() {
	      var padrao = _.get(this.ocorrencia.enquadramento, 'padrao', '');
	      if (!_.isEmpty(padrao)) {
	        this.ocorrencia.observacao = padrao;
	      }
	      this.$forceUpdate();
	    },
	    'idProcesso': function idProcesso() {
	      this.id = this.idProcesso || null;
	      if (!_.isNull(this.id)) {
	        this.carregaOcorrencia();
	      }
	      this.$forceUpdate();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  methods: {
	    alteraListaTiposOcorrencias: function alteraListaTiposOcorrencias(item) {
	      this.ocorrencia.enquadramento = null;
	      this.listaTiposOcorrencias = [];
	      var lista = _.cloneDeep(this.listaTiposOcorrenciasBackup);
	      var situacaoProjeto = _.get(item, 'sitprj', '');
	      if (!_.includes(['SO3', 'SO4'], situacaoProjeto)) {
	        _.remove(lista, function (o) {
	          return _.includes([2200, 2201, 2202], o.codigo);
	        });
	      }
	      this.listaTiposOcorrencias = _.cloneDeep(lista);
	      this.$forceUpdate();
	    },
	    limparPesquisa: function limparPesquisa() {
	      this.filtro = { id: [], codigo: [], situacao: [], etapa: [], nivel: [], carteira: null, observacao: '', pesquisa: '' };
	      if (_.isNil(this.numeroProjeto)) {
	        this.ocorrencias = [];
	      }
	    },
	    temFiltroPreenchido: function temFiltroPreenchido() {
	      return !_.isEmpty(_.trim(this.filtro.pesquisa)) || !_.isEmpty(this.filtro.codigo) || !_.isEmpty(this.filtro.situacao) || !_.isEmpty(this.filtro.nivel) || !_.isEmpty(this.filtro.carteira);
	    },
	    pesquisarOcorrencias: function pesquisarOcorrencias() {
	      var pesquisa = { 'informacao': this.layout || 'SIMPLIFICADO' };
	      _.set(pesquisa, 'projeto', this.numeroProjeto);
	      switch (this.buscaTipo) {
	        case 'entidade':
	          _.set(pesquisa, 'entidadenome', this.filtro.pesquisa);
	          break;
	        case 'projeto':
	          _.set(pesquisa, 'projeto', this.numeroProjeto || this.filtro.pesquisa);
	          break;
	        case 'cnpj':
	          _.set(pesquisa, 'cnpj', this.filtro.pesquisa);
	          break;
	      }
	      if (!_.isEmpty(this.filtro.codigo)) {
	        _.set(pesquisa, 'codigo', _.map(this.filtro.codigo, 'codigo'));
	      }
	      if (!_.isEmpty(this.filtro.nivel)) {
	        _.set(pesquisa, 'nivel', _.map(this.filtro.nivel, 'nivel'));
	      }
	      if (!_.isNull(this.filtro.carteira)) {
	        _.set(pesquisa, 'carteira', this.filtro.carteira.usu_codcart);
	      }
	      if (!_.isEmpty(this.filtro.situacao)) {
	        _.set(pesquisa, 'situacao', this.filtro.situacao);
	      }
	      this.buscaOcorrencias(pesquisa);
	      this.salvarConfiguracoes();
	    },
	    buscaOcorrencias: function buscaOcorrencias(pesquisa) {
	      var _this2 = this;
	
	      this.loading.tela = true;
	      var consulta = { 'informacao': this.layout || 'SIMPLIFICADO' };
	      _.set(consulta, 'projeto', this.numeroProjeto);
	      _.set(consulta, 'entidade', this.idEntidade);
	      _.set(consulta, 'ativo', this.situacaoOcorrencia);
	      _.set(consulta, 'codigo', this.codigoOcorrencia);
	      _.set(consulta, 'nivel', this.nivelOcorrencia);
	      _.set(consulta, 'ids', this.ids);
	      console.log('consulta', consulta);
	      axiosLaravel.post('ocorrencia/busca', pesquisa || consulta).then(function (response) {
	        if (_.get(response.data, 'codigo', '') === 'OK') {
	          _this2.ocorrencias = response.data.retorno;
	          _this2.tabelaListaOcorrencias.totalRows = _this2.ocorrencias.length;
	          _this2.tabelaListaOcorrencias.currentPage = 1;
	        } else {
	          _this2.$snotify.error(response.data.mensagem);
	        }
	        _this2.$forceUpdate();
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        _this2.$snotify.clear();
	        _this2.$root.trataErro(error);
	        _this2.loading.tela = false;
	      });
	    },
	    carregaOcorrencia: function carregaOcorrencia() {
	      var _this3 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('ocorrencia/busca/', { 'ids': [this.id], 'informacao': 'COMPLETO', 'historico': true }).then(function (response) {
	        if (_.get(response.data, 'codigo', '') === 'OK') {
	          if (response.data.retorno.length > 1) {
	            _this3.$snotify.error('Retornou mais de um registro. Procure o administrador do sistema!');
	          } else {
	            var retorno = response.data.retorno[0];
	            _this3.id = retorno.id;
	            _this3.itemOcorrencia = retorno;
	            _this3.ocorrencia = JSON.parse(_this3.itemOcorrencia.requisicao);
	            _this3.ocorrencia.acao = null;
	            _this3.etapa = _this3.itemOcorrencia.etapa;
	            _this3.grupoOcorrencia = _.toNumber(('' + _this3.ocorrencia.enquadramento.codigo).substr(0, 1));
	            _this3.loading.tela = false;
	          }
	        } else {
	          _this3.$snotify.error(response.data.mensagem);
	        }
	        _this3.$emit('ocorrencia', _this3.ocorrencia);
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.loading.tela = false;
	      });
	    },
	    carregarListaTiposOcorrencias: function carregarListaTiposOcorrencias() {
	      var _this4 = this;
	
	      this.loading.listaOcorrencias = true;
	      if (typeof Storage !== 'undefined') {
	        var listaTiposOcorrencias = JSON.parse(window.localStorage.getItem('codigos-ocorrencia'));
	
	        var diferenca = Math.floor(new Date().getTime() / 43200000 - _.get(listaTiposOcorrencias, 'atualizado', new Date('2023-01-01').getTime()) / 43200000);
	        if (diferenca >= 1 || _.isEmpty(listaTiposOcorrencias)) {
	          axiosLaravel.get('tipo-ocorrencia/').then(function (response) {
	            _this4.listaTiposOcorrencias = _.cloneDeep(response.data);
	            _this4.listaTiposOcorrenciasBackup = _.cloneDeep(response.data);
	            window.localStorage.setItem('codigos-ocorrencia', (0, _stringify2.default)({ 'atualizado': Math.floor(new Date().getTime()), 'lista': _this4.listaTiposOcorrencias }));
	            _this4.loading.listaOcorrencias = false;
	            _this4.$forceUpdate();
	          }).catch(function (error) {
	            _this4.loading.listaOcorrencias = false;
	            if (error) {
	              _this4.$root.trataErro(error);
	            }
	          });
	        } else {
	          this.listaTiposOcorrencias = _.cloneDeep(listaTiposOcorrencias.lista);
	          this.listaTiposOcorrenciasBackup = _.cloneDeep(listaTiposOcorrencias.lista);
	          this.loading.listaOcorrencias = false;
	        }
	      }
	    },
	    carregarListaProjetosEntidades: function carregarListaProjetosEntidades() {
	      var _this5 = this;
	
	      this.loading.listaProjetosEntidades = true;
	      axiosLaravel.get('consulta/projetos-entidades/lista/').then(function (response) {
	        if (_.get(response.data, 'codigo', '') === 'OK') {
	          _this5.listaProjetosEntidades = response.data.retorno;
	          _this5.selecionaProjetoEntidadeLista();
	        } else {
	          _this5.$snotify.error(response.data.mensagem);
	        }
	        _this5.loading.listaProjetosEntidades = false;
	        _this5.$forceUpdate();
	      }).catch(function (error) {
	        _this5.loading.listaProjetosEntidades = false;
	        if (error) {
	          _this5.$root.trataErro(error);
	        }
	      });
	    },
	    selecionaProjetoEntidadeLista: function selecionaProjetoEntidadeLista() {
	      if (_.isNull(_.get(this.ocorrencia, 'alvo', null))) {
	        var numero = !_.isNull(_.get(this.ocorrencia, 'numero', null)) ? this.ocorrencia.numero : !_.isNil(this.numeroProjeto) ? this.numeroProjeto : 0;
	        this.ocorrencia.alvo = _.find(_.get(this.listaProjetosEntidades, this.ocorrencia.tipo === 'PROJETO' ? 'projetos' : 'entidades'), [this.ocorrencia.tipo === 'PROJETO' ? 'ds_codigo_projeto_erp' : 'id', '' + numero]);
	        this.alteraListaTiposOcorrencias(this.ocorrencia.alvo);
	      }
	    },
	    acaoOcorrencia: function acaoOcorrencia(acao, id) {
	      if (acao === 'LISTAR' && !_.isNull(id)) {
	        if (!_.isNil(this.numeroProjeto) || this.temFiltroPreenchido()) {
	          this.pesquisarOcorrencias();
	        }
	        id = null;
	      }
	      this.limparOcorrencia();
	      this.id = id;
	      this.ehVisualizacao = acao === 'VISUALIZAR';
	      this.acao = _.isNull(id) ? 'LISTAR' : acao;
	      if (!_.isNull(this.id) && !_.includes(['CRIAR', 'LISTAR'], this.acao)) {
	        this.carregaOcorrencia();
	      }
	      this.$forceUpdate();
	    },
	    limparOcorrencia: function limparOcorrencia() {
	      this.etapa = 'SOLICITACAO';
	      this.grupoOcorrencia = null;
	      this.ocorrencia = { acao: 'SALVAR', tipo: 'PROJETO', alvo: null, enquadramento: null, observacao: '', prazo: null, anexos: [] };
	      this.selecionaProjetoEntidadeLista();
	    },
	    filtroPorItem: function filtroPorItem(row, filter) {
	      var _this6 = this;
	
	      var saida = true;
	      if (filter !== 'retornar_todos_registros') {
	        var termos = _.split(_.toLower(filter), ' ');
	        termos.forEach(function (termo) {
	          saida = saida && (_.toLower('' + row.id + row.codigo + row.numeroProjeto + row.projeto + row.entidade + row.observacao + _this6.enumeradores[row.etapa]).indexOf(termo) !== -1 || '' + _this6.filtro.carteira === '' + row.codigoCarteira);
	        });
	      }
	      return saida;
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.tabelaListaOcorrencias.totalRows = filteredItems.length;
	      this.tabelaListaOcorrencias.currentPage = 1;
	      this.$forceUpdate();
	    },
	    ajustaPesquisa: function ajustaPesquisa() {
	      this.tabelaListaOcorrencias.filter = _.isNull(this.filtro.pesquisa) || this.filtro.pesquisa === '' ? 'retornar_todos_registros' : this.filtro.pesquisa;
	    },
	    validaConclusao: function validaConclusao() {
	      var _this7 = this;
	
	      this.$validator.validateAll().then(function (validado) {
	        if (validado && _this7.errors.items.length === 0) {
	          _this7.processaOcorrencias();
	        } else {
	          _this7.$snotify.error('Atenção', { timeout: 1000 });
	        }
	      });
	    },
	    processaOcorrencias: function processaOcorrencias() {
	      var _this8 = this;
	
	      this.loading.tela = true;
	      this.$aguarde('Registrando ocorrências. Por favor, aguarde...');
	      var ocorrencia = _.clone(this.ocorrencia);
	      _.set(ocorrencia, 'id', this.id);
	      axiosLaravel.post('ocorrencia/encaminhar/', { 'lista': [ocorrencia] }).then(function (response) {
	        _this8.$snotify.clear();
	        if (_.get(response.data, 'codigo', '') === 'OK') {
	          _this8.$snotify.success('Ocorrência registrada com sucesso', { timeout: 2000 });
	          if (!_.isNil(_this8.botaoVoltar) && _this8.botaoVoltar) {
	            _this8.$router.go(-1);
	          } else {
	            _this8.acaoOcorrencia('LISTAR', _this8.id);
	          }
	        } else {
	          _this8.$snotify.error(response.data.mensagem);
	          _this8.loading.tela = false;
	        }
	      }).catch(function (error) {
	        _this8.$snotify.clear();
	        _this8.loading.tela = false;
	        _this8.$root.trataErro(error);
	      });
	    },
	    buscaCarteiras: function buscaCarteiras() {
	      var _this9 = this;
	
	      this.loading.carteiras = true;
	      if (typeof Storage !== 'undefined') {
	        var carteirasProjeto = JSON.parse(window.localStorage.getItem('carteiras-projeto'));
	
	        var diferenca = Math.floor(new Date().getTime() / 86400000 - _.get(carteirasProjeto, 'atualizado', new Date('2023-01-01').getTime()) / 86400000);
	        if (diferenca >= 1 || _.isEmpty(carteirasProjeto)) {
	          axiosLaravel.get('carteira/projeto/1500').then(function (response) {
	            _this9.listaCarteiras = response.data.retorno['carteiras'];
	            window.localStorage.setItem('carteiras-projeto', (0, _stringify2.default)({ 'atualizado': Math.floor(new Date().getTime()), 'lista': _this9.listaCarteiras }));
	            _this9.loading.carteiras = false;
	            _this9.$forceUpdate();
	          }).catch(function (error) {
	            _this9.loading.carteiras = false;
	            if (error) {
	              _this9.$root.trataErro(error);
	            }
	          });
	        } else {
	          this.listaCarteiras = _.cloneDeep(carteirasProjeto.lista);
	          this.loading.carteiras = false;
	        }
	      }
	    },
	    abrePaginaNova: function abrePaginaNova(url, numero) {
	      window.open(location.protocol + '//' + location.host + '/' + url + numero, '_blank');
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this10 = this;
	
	      _.set(this.usuarioLogado, 'configuracoes.tela_ocorrencias.filtro', this.filtro);
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {
	        console.log('configuracoes', _this10.usuarioLogado.configuracoes);
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this10.$root.trataErro(error);
	        }
	      });
	    },
	    checkboxNivel: function checkboxNivel(item) {
	      if (_.find(this.filtro.nivel, ['nivel', item.nivel])) {
	        _.remove(this.filtro.nivel, item);
	      } else {
	        this.filtro.nivel.push(item);
	      }
	      this.$forceUpdate();
	    },
	    exportarExcel: function exportarExcel() {
	      var vm = this;
	      var listaOcorrencias = [];
	      this.ocorrencias.forEach(function (o) {
	        if (_.get(o, 'mostrar', true)) {
	          listaOcorrencias.push({
	            'Projeto': o.numeroProjeto + ' - ' + o.projeto,
	            'Entidade': o.entidade,
	            'Tipo': o.nome === 'OCORRENCIA_PROJETO' ? 'Projeto' : 'Entidade',
	            'Etapa atual': vm.enumeradores[o.etapa],
	            'Ocorrência': o.codigo + ' - ' + o.descricao,
	            'Usuário Registro': o.usuarioCriadorNome,
	            'Data Criação': (0, _moment2.default)(o.inicio).format('DD/MM/YYYY HH:mm:ss'),
	            'Data Baixa': _.isEmpty(o.dataBaixa) ? '' : (0, _moment2.default)(o.dataBaixa).format('DD/MM/YYYY HH:mm:ss'),
	            'Carteira': o.nomeCarteira,
	            'Id': o.id,
	            'Observação': o.observacao,
	            'Sequência no Sapiens': o.sequencia
	          });
	        }
	      });
	      var principal = XLSX.utils.json_to_sheet(listaOcorrencias);
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, principal, 'Lista de Ocorrências');
	      XLSX.writeFile(wb, 'ocorrencias.xlsx');
	    }
	  }
	};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _EditaOcorrencias = __webpack_require__(509);
	
	var _EditaOcorrencias2 = _interopRequireDefault(_EditaOcorrencias);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaOcorrencias',
	  components: {
	    EditaOcorrencias: _EditaOcorrencias2.default
	  },
	  data: function data() {
	    return {
	      id: null,
	      botaoVoltar: false,
	      loading: {
	        tela: false,
	        detalhes: false
	      }
	    };
	  },
	  created: function created() {
	    this.id = this.$route.params.id || null;
	    this.botaoVoltar = _.get(this.$route.params, 'voltar', false);
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  methods: {}
	};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Usuarios: _usuarios2.default
	  },
	  name: 'EditaParcEstrategico',
	  data: function data() {
	    return {
	      campoErro: null,
	      parceiro: {
	        contato: {},
	        usuarios: [],
	        vinculos: []
	      },
	      vinculos: []
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    this.buscaVinculos();
	    if (this.$route.params.id) {
	      axiosLaravel.get('parceiros/' + this.$route.params.id).then(function (response) {
	        _this.parceiro = response.data;
	        _this.$route.params.parceiro = _this.parceiro;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	
	  methods: {
	    isEditable: function isEditable() {
	      return this.$root.authorize('parceiro-estrategico-editar') || this.$root.authorize('meu-parceiro-estrategico-editar');
	    },
	    customLabel: function customLabel(option) {
	      return '' + ('Cod: ' + option.id + ' - ' + option.desc_vinculo);
	    },
	    buscaVinculos: function buscaVinculos() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return axiosLaravel.get('parceiros/create').then(function (response) {
	                  _this2.vinculos = response.data.vinculos;
	                }).catch(function (error) {
	                  console.log(error.response);
	                  _this2.$snotify.clear();
	                  _this2.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    salva: function salva() {
	      var _this3 = this;
	
	      if (_.isEmpty(this.parceiro.usuarios) || !this.parceiro.usuarios) {
	        this.$snotify.error('É obrigatório incluir ao menos um usuário para o Parceiro Estratégico!');
	        return;
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this3.parceiro.id) {
	            _this3.atualiza();
	          } else {
	            _this3.grava();
	          }
	        } else {
	          _this3.$snotify.error('O formulário de Cadastro de Parceiro Estratégico possui erros. Favor verificar!');
	        }
	      });
	    },
	    atualiza: function atualiza() {
	      var _this4 = this;
	
	      if (_.isEmpty(this.parceiro.usuarios) || !this.parceiro.usuarios) {
	        this.$snotify.error('É obrigatório incluir ao menos um usuário para o Parceiro Estratégico!');
	        return;
	      }
	      this.$aguarde('Atualizando Parceiro Estratégico. Por favor, aguarde...');
	      axiosLaravel.put('parceiros/' + this.parceiro.id, this.parceiro).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Parceiro Estratégico salvo com sucesso!');
	        setTimeout(function () {
	          _this4.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this5 = this;
	
	      this.$aguarde('Salvando Parceiro Estratégico. Por favor, aguarde...');
	      axiosLaravel.post('parceiros/', this.parceiro).then(function (response) {
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Parceiro Estratégico salvo com sucesso!');
	        setTimeout(function () {
	          _this5.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ListaParcEstrategico',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'active',
	        sortDesc: true,
	        totalRows: 0,
	        fields: [{ key: 'ds_nome', label: 'Razão Social', sortable: true, thStyle: 'text-align: center; width: 40%', class: 'text-center' }, { key: 'ds_cnpj', label: 'CNPJ', sortable: true, thStyle: 'text-align: center; width: 25%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 10%', class: 'text-center' }]
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    axiosLaravel.get('parceiros/').then(function (response) {
	      console.log('response.data', response.data);
	      _this.table.items = response.data;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    }
	  }
	};

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'editar-perfil',
	  data: function data() {
	    return {
	      profile: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      axios.get('proxy/account/profiles/' + this.$route.params.id).then(function (response) {
	        _this.profile = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this2 = this;
	
	      if (this.profile.id) {
	        axios.put('proxy/account/profiles/' + this.profile.id, this.profile).then(function (response) {
	          _this2.$snotify.success('usuário atualizado com sucesso');
	          _this2.$router.push({ name: 'cadastro-perfis-lista' });
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      } else {
	        axios.post('proxy/account/profiles', this.profile).then(function (response) {
	          _this2.$snotify.success('usuário criado com sucesso');
	          _this2.$router.push({ name: 'cadastro-perfis-lista' });
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    onClean: function onClean() {
	      this.profile.name = '';
	      this.profile.active = '';
	      this.profile.description = '';
	    }
	  }
	};

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'lista-perfis',
	  data: function data() {
	    return {
	      items: [],
	      loadingShow: false,
	      currentPage: 1,
	      perPage: 10,
	
	      sortBy: 'createdAt',
	      sortDesc: true,
	      bordered: true,
	      filter: null,
	      emptyText: 'Não tem nenhum registro para mostrar',
	      fields: [{ key: 'name', label: 'Perfil', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'description', label: 'Descrição', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'active', label: 'Ativo', thStyle: 'width: 5%', class: 'text-center' }, { key: 'createdAt', label: 'Data de Criação', sortable: true, thStyle: 'text-align: center', class: 'centraliza' }, { key: 'updatedAt', label: 'Data de inativação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	    };
	  },
	
	  created: function created() {
	    this.loadProfiles();
	  },
	  computed: {
	    totalRows: {
	      get: function get() {
	        return this.items.length;
	      },
	      set: function set() {}
	    }
	
	  },
	  methods: {
	    loadProfiles: function loadProfiles() {
	      var _this = this;
	
	      this.items = [];
	      axios.get('/proxy/account/profiles?tiny').then(function (response) {
	        _this.items = response.data.value;
	        _this.totalRows = _this.items.length;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    verificaAcesso: function verificaAcesso(param) {
	      return this.$root.authorize(param);
	    },
	    inativa: function inativa(item) {
	      var _this2 = this;
	
	      axios.put('/proxy/account/profiles/' + item.id + '/status', item).then(function (response) {
	        item.active = !item.active;
	      }).catch(function (error) {
	        if (error) {
	          _this2.$root.trataErro(error);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _profiles = __webpack_require__(121);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Profiles: _profiles2.default },
	  name: 'lista-permissoes',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      profileConstraint: {},
	      profile: [],
	      auths: {},
	      error: 'error',
	      users: [],
	      filtros: {
	        email: '',
	        login: '',
	        name: '',
	        profile: {},
	        userType: '',
	        createdAt: null,
	        id: ''
	      },
	      usuario: {
	        acao: 'LISTA',
	        pesquisa: '',
	        login: null
	      },
	      usersAdicionar: [],
	      todosUsuarios: [],
	      loadingShow: false,
	      perPage: 5,
	      currentPage: 1,
	
	      sortBy: 'initialDate',
	      sortDesc: true,
	      bordered: true,
	      filter: null,
	      emptyText: 'Não tem nenhum registro para mostrar',
	      fields: [{ key: 'username', label: 'Usuário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'initialDate', label: 'Data Inicial', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'inactivateDate', label: 'Data Final', thStyle: 'width: 10%', class: 'text-center' }, { key: 'changedBy', label: 'Alterado Por', sortable: true, thStyle: 'text-align: center', class: 'centraliza' }, { key: 'updatedAt', label: 'Alterado em', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center', class: 'text-center' }],
	      show: {
	        userForm: false
	      },
	      usuariosPesquisa: [],
	      usuariosPraGravar: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    axios.get('/proxy/account/permissions?group=true').then(function (response) {
	      _this.$aguarde('Buscando permissões. Por favor, aguarde...');
	      _this.auths = response.data.value;
	      _this.$snotify.clear();
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	
	    this.usuario.pesquisa = ' ';
	    axiosLaravel.post('/usuarios/acao/', this.usuario).then(function (response) {
	      _this.todosUsuarios = response.data.dados.row;
	      _this.$snotify.clear();
	      _this.$snotify.success('Permissões carregadas com sucesso!', { timeout: 1000 });
	      _this.$snotify.clear();
	      _this.profile = _this.usuarioLogado.profilesConstraint[0].profile;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	
	  watch: {
	    profile: function profile(newProfile, oldProfile) {
	      this.buscaUsuariosProfile();
	    }
	  },
	  mounted: function mounted() {},
	  computed: {
	    totalRows: {
	      get: function get() {
	        return this.users.length;
	      },
	      set: function set() {}
	    }
	  },
	  methods: {
	    translate: function translate(index) {
	      index = 'hello';
	      var v = 'messages.error';
	      return v;
	    },
	    camelize: function camelize(str) {
	      return str.replace(/\W+(.)/g, function (match, chr) {
	        return chr.toUpperCase();
	      });
	    },
	    verifica: function verifica(name) {
	      if ((0, _keys2.default)(this.profile).length > 0) {
	        return this.profile.authorities.some(function (o) {
	          return o.name === name;
	        });
	      } else {
	        return false;
	      }
	    },
	    adiciona: function adiciona(authority) {
	      if (this.profile.authorities.some(function (o) {
	        return o.name === authority.name;
	      })) {
	        this.profile.authorities = this.profile.authorities.filter(function (o) {
	          return o.name !== authority.name;
	        });
	      } else this.profile.authorities.push(authority);
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    saveAuthoritiesToProfile: function saveAuthoritiesToProfile() {
	      var _this2 = this;
	
	      axios.post('proxy/account/profiles/' + this.profile.id + '/authorities', this.profile.authorities).then(function (response) {
	        _this2.$snotify.success('Permissões salvas com sucesso');
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    onCancelUserToProfile: function onCancelUserToProfile() {
	      this.show.userForm = false;
	      this.profileConstraint = {};
	      this.usersAdicionar = [];
	      this.$validator.errors.clear();
	    },
	    adicionaUsuario: function adicionaUsuario() {
	      var _this3 = this;
	
	      if ((0, _keys2.default)(this.usersAdicionar).length === 0) {
	        this.errors.add('usuarios', 'campo usuarios é obrigatorio');
	      } else {
	        this.errors.remove('usuarios');
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && (0, _keys2.default)(_this3.errors.items).length === 0) {
	          _this3.montaArrayUsuarios();
	
	          axios.post('proxy/account/profiles/' + _this3.profile.id + '/users', _this3.usuariosPraGravar).then(function (response) {
	            _this3.$snotify.success('Usuário adicionado com sucesso');
	            _this3.buscaUsuariosProfile();
	            _this3.onCancelUserToProfile();
	          }).catch(function (error) {
	            _this3.$root.trataErro(error);
	          });
	        }
	      });
	    },
	    montaArrayUsuarios: function montaArrayUsuarios() {
	      var _this4 = this;
	
	      this.usuariosPraGravar = [];
	      var userObject = {};
	
	      var usuario = this.usuariosPesquisa.find(function (element) {
	        return element.id === _this4.usersAdicionar.id;
	      });
	      userObject.initialDate = this.profileConstraint.initialDate.toISOString().slice(0, 10);
	      if (this.profileConstraint.inactivateDate) {
	        userObject.inactivateDate = this.profileConstraint.inactivateDate.toISOString().slice(0, 10);
	      }
	      userObject.user = usuario;
	      this.usuariosPraGravar.push(userObject);
	    },
	    buscaUsuariosProfile: function buscaUsuariosProfile() {
	      var _this5 = this;
	
	      if (this.profile.id === 2) {
	        this.usuario.pesquisa = 'ENTIDADE';
	      } else {
	        this.usuario.pesquisa = '@fbb';
	      }
	      axiosLaravel.post('/usuarios/acao/', this.usuario).then(function (response) {
	        _this5.usu = response.data.dados.row;
	        _this5.usuariosPesquisa2 = (0, _assign2.default)([], _this5.usu);
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Permissões carregadas com sucesso!', { timeout: 1000 });
	        _this5.$snotify.clear();
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	      if (this.profile.id !== 2) {
	        axios.get('/proxy/account/profiles/' + this.profile.id + '/users').then(function (response) {
	          _this5.users = response.data.value;
	          _this5.usuariosPesquisa = [];
	          _this5.usuariosPesquisa = (0, _assign2.default)([], _this5.usu);
	          var temporario = { id: 0, userName: '' };
	
	          _this5.todosUsuarios.forEach(function (option) {
	            if (_this5.users.some(function (o) {
	              return o.id === option.id;
	            })) {} else {
	              temporario = { id: 0, userName: '' };
	              temporario.id = option.id;
	              temporario.userName = option.userName;
	
	              _this5.usuariosPesquisa.push(temporario);
	            }
	          });
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	        });
	      }
	    },
	    deleteUser: function deleteUser(id) {
	      var _this6 = this;
	
	      axios.delete('proxy/account/profiles/' + this.profile.id + '/users/' + id).then(function (response) {
	        _this6.$snotify.success('Usuário excluído com sucesso.');
	        _this6.buscaUsuariosProfile();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _UploadDocumentosRatificacao = __webpack_require__(1676);
	
	var _UploadDocumentosRatificacao2 = _interopRequireDefault(_UploadDocumentosRatificacao);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosRatificacao: _UploadDocumentosRatificacao2.default
	  },
	  name: 'EditaRatificacao',
	  data: function data() {
	    return {
	      id: null,
	      loading: {
	        tela: false,
	        usuarios: false
	      },
	      etapa: 'SOLICITACAO',
	      historico: null,
	      ehVisualizacao: false,
	      ehAssinatura: false,
	      usuarioPodeAssinar: false,
	      listaUsuarios: [],
	      ratificacao: {
	        assunto: {},
	        alcada: null,
	        qtdeAssinaturasObrigatorias: 1,
	        requerimento: null,
	        anexos: [],
	        aprovacao: null,
	        observacao: null
	      },
	      listaAssuntos: [{ 'value': 'RATIFICACAO_PAGAMENTO', 'name': 'Ratificação de Pagamento' }, { 'value': 'RATIFICACAO_APLICACAO', 'name': 'Ratificação de Aplicação' }],
	      enumeradores: { 'RATIFICACAO_APLICACAO': 'Ratificação de Aplicação', 'RATIFICACAO_PAGAMENTO': 'Ratificação de Pagamento', 'FEITO': 'Feito', 'CANCELADO': 'Cancelado', 'EM_EXECUCAO': 'Em Execução', 'SOLICITACAO': 'Solicitação', 'ASSINATURA_RATIFICACAO': 'Assinatura Requisitada', 'CONCLUSAO': 'Conclusão' },
	      restricaoParaConcluir: [],
	      foiAssinada: false
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    sortOptions: function sortOptions() {
	      return this.fields.table.filter(function (f) {
	        return f.sortable;
	      }).map(function (f) {
	        return { text: f.label, value: f.key };
	      });
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    if (_.has(this.$route.params, 'visualizacao')) {
	      this.ehVisualizacao = this.$route.params.visualizacao;
	    }
	    if (_.has(this.$route.params, 'assinar')) {
	      this.ehAssinatura = this.$route.params.assinar;
	    }
	    if (_.has(this.$route.params, 'id')) {
	      this.id = this.$route.params.id;
	      this.buscaDados();
	      this.carregarHistorico();
	      this.ratificacaoFoiAssinada();
	    }
	    this.carregarListaUsuarios();
	  },
	  mounted: function mounted() {},
	  methods: {
	    selecaoAssunto: function selecaoAssunto() {
	      if (this.ratificacao.assunto === 'RATIFICACAO_PAGAMENTO') {
	        this.ratificacao.requerimento = '#interna\n' + 'Prezada Diretora,\n' + 'Seguem anexos os documentos para Ratificação dos Pagamentos referentes ao dia ' + (0, _moment2.default)().subtract(1, 'days').format('DD/MM/YYYY') + '.\n' + 'Solicitamos seu "De Acordo".';
	        this.ratificacao.alcada = _.filter(this.listaUsuarios, function (usuario) {
	          return _.includes([16429, 16936], usuario.id);
	        });
	      } else if (this.ratificacao.assunto === 'RATIFICACAO_APLICACAO') {
	        this.ratificacao.requerimento = '#interna\n' + 'Prezada Diretora,\n' + 'Seguem anexos os documentos para Ratificação das Aplicações Financeiras referentes ao dia ' + (0, _moment2.default)().subtract(1, 'days').format('DD/MM/YYYY') + '.\n' + 'Solicitamos seu "De Acordo".';
	        this.ratificacao.alcada = _.filter(this.listaUsuarios, function (usuario) {
	          return _.includes([16429, 16936], usuario.id);
	        });
	      }
	    },
	    carregarHistorico: function carregarHistorico() {
	      var _this = this;
	
	      axiosLaravel.post('/ratificacao/historico', { 'id': this.id }).then(function (response) {
	        console.log('dados recebidos HISTORICO', response.data);
	        _this.historico = response.data.retorno;
	        _this.etapa = _.chain(_.cloneDeep(_this.historico)).remove(['tipo', 'USUARIO']).sortBy('id').last().get('nome').value();
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    permiteConcluir: function permiteConcluir() {
	      var _this2 = this;
	
	      if (this.ehAssinatura) {
	        this.adicionaRestricao({ 'tag': 'decisaoAusente', 'ativo': _.isNull(this.ratificacao.aprovacao), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Deve escolher Sim ou Não para decisão' });
	      }
	      this.$validator.validateAll().then(function (validado) {
	        _this2.adicionaRestricao({ 'tag': 'camposPendentes', 'ativo': !validado, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Revise os campos: ' + _.join(_.uniq(_.map(_this2.$validator.errors.items, 'field')), ', ') });
	
	        if (_this2.restricaoParaConcluir.length > 0 && _.filter(_this2.restricaoParaConcluir, { 'ativo': true }).length > 0) {
	          var restricoes = _.filter(_this2.restricaoParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	          if (restricoes.length > 0) {
	            var mensagens = '<div class=avisoAlerta><li>' + _.join(_.map(restricoes, 'mensagem'), '<li>') + '</div>';
	            _this2.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	          }
	        } else {
	          _this2.concluir();
	        }
	      });
	    },
	    concluir: function concluir() {
	      var _this3 = this;
	
	      this.loading.tela = true;
	      this.$aguarde('Processando. Por favor, aguarde...');
	      var rota = this.ehAssinatura ? '/ratificacao/assinar' : this.etapa === 'CONCLUSAO' ? '/ratificacao/concluir' : '/ratificacao/salvar';
	      axiosLaravel.post(rota, { 'id': this.id, 'ratificacao': this.ratificacao }).then(function (response) {
	        _this3.aviso(response.data);
	        _this3.voltar();
	        _this3.loading.tela = false;
	      }).catch(function (error) {
	        _this3.loading.tela = false;
	        _this3.$root.trataErro(error);
	      });
	    },
	    voltar: function voltar() {
	      if (this.ehAssinatura) {
	        this.$router.push({ name: 'lista-ratificacao-pendentes' });
	      } else {
	        this.$router.push({ name: 'lista-ratificacao' });
	      }
	    },
	    adicionaRestricao: function adicionaRestricao(ev) {
	      if (!_.isNil(ev) && _.has(ev, 'tag')) {
	        _.remove(this.restricaoParaConcluir, function (i) {
	          return i.tag === ev.tag;
	        });
	
	        this.restricaoParaConcluir.push(ev);
	      }
	    },
	    nomeUsuario: function nomeUsuario(option) {
	      return '' + option.ds_nome_usuario;
	    },
	    selecionandoDestinatario: function selecionandoDestinatario() {
	      if (this.ratificacao.alcada.length === 0) {
	        this.ratificacao.qtdeAssinaturasObrigatorias = 1;
	      }
	    },
	    carregarListaUsuarios: function carregarListaUsuarios() {
	      var _this4 = this;
	
	      this.loading.usuarios = true;
	      console.log('carregarListaUsuarios');
	      axiosLaravel.get('/ratificacao/usuarios').then(function (response) {
	        if (response.data.codigo === 'OK') {
	          _this4.listaUsuarios = response.data.retorno;
	        }
	        _this4.aviso(response.data);
	        _this4.loading.usuarios = false;
	      }).catch(function (error) {
	        _this4.loading.usuarios = false;
	        _this4.$root.trataErro(error);
	      });
	    },
	    aviso: function aviso(retorno) {
	      this.$snotify.clear();
	      if (_.has(retorno, 'codigo')) {
	        if (retorno.codigo === 'ERRO') {
	          var mensagem = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : 'Erro de processamento. Não sei o que houve';
	          this.$snotify.error(mensagem);
	        } else {
	          if (retorno.codigo === 'OK') {
	            if (_.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem)) {
	              this.$snotify.success(retorno.mensagem, { timeout: 3000 });
	            }
	          }
	        }
	      }
	    },
	    buscaDados: function buscaDados() {
	      var _this5 = this;
	
	      this.loading.tela = true;
	      console.log('buscaDados');
	      var pendencia = this.ehAssinatura ? 'assinatura' : 'normal';
	      axiosLaravel.post('/ratificacao/edita', { 'id': this.id, 'pendencia': pendencia }).then(function (response) {
	        if (response.data.codigo === 'OK') {
	          _this5.ratificacao = JSON.parse(response.data.retorno[0]['requisicao']);
	          _this5.usuarioPodeAssinar = !_.isEmpty(_.find(_this5.ratificacao.alcada, function (item) {
	            return item.id === _this5.usuarioLogado.id;
	          }));
	          _this5.$forceUpdate();
	        } else {
	          _this5.voltar();
	        }
	        _this5.aviso(response.data);
	        _this5.loading.tela = false;
	      }).catch(function (error) {
	        _this5.loading.tela = false;
	        _this5.$root.trataErro(error);
	      });
	    },
	    filtrar: function filtrar() {
	      console.log('filtrar');
	    },
	    ratificacaoFoiAssinada: function ratificacaoFoiAssinada() {
	      var _this6 = this;
	
	      if (this.etapa === 'SOLICITACAO') {
	        this.foiAssinada = false;
	      } else {
	        axiosLaravel.get('/ratificacao/foi_assinada/' + this.id).then(function (response) {
	          _this6.foiAssinada = !!response.data.resposta;
	          _this6.$forceUpdate();
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaRatificacao',
	  data: function data() {
	    return {
	      loading: {
	        tela: false
	      },
	      listaRatificacoes: [],
	      listaRatificacoesConcluidas: [],
	      ehDoUsuario: false,
	      filtro: [],
	      table: {
	        filter: null,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10000,
	        sortBy: 'id_processo',
	        sortDesc: true,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'id_processo', label: 'ID Processo', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'data_solicitacao', label: 'Criado em', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'ultima_tarefa', label: 'Etapa', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'situacao', label: 'Situação', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'nome', label: 'Assunto da Ratificação', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'resultado', label: 'Informação', sortable: false, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'acoes', label: 'Ações', thStyle: 'text-align: center; width: 20%', class: 'text-center' }]
	      },
	      enumeradores: { 'RATIFICACAO_APLICACAO': 'Ratificação de Aplicação', 'RATIFICACAO_PAGAMENTO': 'Ratificação de Pagamento', 'FEITO': 'Feito', 'CANCELADO': 'Cancelado', 'EM_EXECUCAO': 'Em Execução', 'SOLICITACAO': 'Solicitação', 'ASSINATURA_RATIFICACAO': 'Assinatura Requisitada', 'CONCLUSAO': 'Conclusão' }
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    sortOptions: function sortOptions() {
	      return this.fields.table.filter(function (f) {
	        return f.sortable;
	      }).map(function (f) {
	        return { text: f.label, value: f.key };
	      });
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    if (_.has(this.$route.params, 'filtro')) {
	      console.log('filtro: ', this.filtro);
	    }
	    this.ehDoUsuario = _.includes(this.filtro, 'usuario');
	    this.carregaPendentesDoUsuario();
	    this.carregarListaRatificacoes();
	    console.log('filtro: ', this.filtro);
	  },
	  mounted: function mounted() {},
	  methods: {
	    cancelar: function cancelar(id) {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('/ratificacao/cancelar', { 'id': id }).then(function (response) {
	        _this.aviso(response.data);
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var p = _.filter(_this.listaRatificacoes, ['id_processo', id])[0];
	          _.set(p, 'situacao', 'CANCELADO');
	          _this.$forceUpdate();
	        }
	        _this.loading.tela = false;
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    carregaPendentesDoUsuario: function carregaPendentesDoUsuario() {
	      console.log('carregaPendentesDoUsuario executou');
	      axiosLaravel.get('ratificacao/pendentes_do_usuario/').then(function (response) {
	        console.log('Pendencias do Usuario: ', response.data);
	      });
	    },
	    carregarListaRatificacoes: function carregarListaRatificacoes() {
	      var _this2 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('/ratificacao/lista', { 'filtro': this.filtro }).then(function (response) {
	        console.log('carregarListaRatificacoes', response.data);
	        if (response.data.codigo === 'OK') {
	          _this2.listaRatificacoes = _.filter(response.data.retorno, function (i) {
	            return i.situacao === 'EM_EXECUCAO';
	          });
	          _this2.listaRatificacoesConcluidas = _.filter(response.data.retorno, function (i) {
	            return i.situacao !== 'EM_EXECUCAO';
	          });
	          _this2.$forceUpdate();
	        }
	        _this2.aviso(response.data);
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        if (error) {
	          _this2.$root.trataErro(error);
	        }
	      });
	    },
	    aviso: function aviso(retorno) {
	      if (_.has(retorno, 'codigo')) {
	        if (retorno.codigo === 'ERRO') {
	          var mensagem = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : 'Erro de processamento. Não sei o que houve';
	          this.$snotify.clear();
	          this.$snotify.error(mensagem);
	        } else {
	          if (retorno.codigo === 'OK') {
	            if (_.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem)) {
	              this.$snotify.success(retorno.mensagem, { timeout: 3000 });
	            }
	          }
	        }
	      }
	    },
	    filtrar: function filtrar() {
	      console.log('filtrar');
	    }
	  }
	};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaRatificacaoPendentes',
	  data: function data() {
	    return {
	      loading: {
	        tela: false
	      },
	      listaRatificacoes: [],
	      listaRatificacoesConcluidas: [],
	      ehDoUsuario: false,
	      historico: null,
	      filtro: [],
	      table: {
	        filter: null,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10000,
	        sortBy: 'id_processo',
	        sortDesc: true,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'id_processo', label: 'ID Processo', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'data_solicitacao', label: 'Criado em', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'ultima_tarefa', label: 'Etapa', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'situacao', label: 'Situação', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'nome', label: 'Assunto da Ratificação', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'assinatura', label: 'Assinatura', sortable: false, thStyle: 'text-align: center; width: 20%;', class: 'text-center' }, { key: 'resultado', label: 'Informação', sortable: false, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'acoes', label: 'Ações', thStyle: 'text-align: center; width: 20%', class: 'text-center' }]
	      },
	      enumeradores: { 'RATIFICACAO_APLICACAO': 'Ratificação de Aplicação', 'RATIFICACAO_PAGAMENTO': 'Ratificação de Pagamento', 'FEITO': 'Feito', 'CANCELADO': 'Cancelado', 'EM_EXECUCAO': 'Em Execução', 'SOLICITACAO': 'Solicitação', 'ASSINATURA_RATIFICACAO': 'Assinatura Requisitada', 'CONCLUSAO': 'Conclusão' }
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    sortOptions: function sortOptions() {
	      return this.fields.table.filter(function (f) {
	        return f.sortable;
	      }).map(function (f) {
	        return { text: f.label, value: f.key };
	      });
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    if (_.has(this.$route.params, 'filtro')) {
	      console.log('filtro: ', this.filtro);
	    }
	    this.ehDoUsuario = _.includes(this.filtro, 'usuario');
	    this.carregaPendentesDoUsuario();
	    this.carregarListaRatificacoes();
	    console.log('filtro: ', this.filtro);
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.usuarioLogado.ds_tipo_usuario === 'FUNDACAO') {
	      axiosLaravel.post('/ratificacao/ha_tarefa', { 'processo': 'RATIFICACAO_PAGAMENTO', 'tarefa': 'ASSINATURA_RATIFICACAO', 'situacao': 'EM_EXECUCAO' }).then(function (response) {
	        if (response.data.retorno > 0) {
	          _this.ehDoUsuario = true;
	        }
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	  methods: {
	    cancelar: function cancelar(id) {
	      var _this2 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('/ratificacao/cancelar', { 'id': id }).then(function (response) {
	        _this2.aviso(response.data);
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var p = _.filter(_this2.listaRatificacoes, ['id_processo', id])[0];
	          _.set(p, 'situacao', 'CANCELADO');
	          _this2.$forceUpdate();
	        }
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        _this2.loading.tela = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    carregaPendentesDoUsuario: function carregaPendentesDoUsuario() {
	      console.log('carregaPendentesDoUsuario executou');
	      axiosLaravel.get('ratificacao/pendentes_do_usuario/').then(function (response) {
	        console.log('Pendencias do Usuario: ', response.data);
	      });
	    },
	    carregarListaRatificacoes: function carregarListaRatificacoes() {
	      var _this3 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('/ratificacao/lista', { 'filtro': this.filtro }).then(function (response) {
	        console.log('carregarListaRatificacoes', response.data);
	        if (response.data.codigo === 'OK') {
	          _this3.listaRatificacoes = _.filter(response.data.retorno, function (i) {
	            return i.situacao === 'EM_EXECUCAO';
	          });
	          _this3.listaRatificacoesConcluidas = _.filter(response.data.retorno, function (i) {
	            return i.situacao !== 'EM_EXECUCAO';
	          });
	          _this3.carregarHistorico();
	          _this3.$forceUpdate();
	        }
	        _this3.aviso(response.data);
	        _this3.loading.tela = false;
	      }).catch(function (error) {
	        if (error) {
	          _this3.$root.trataErro(error);
	        }
	      });
	    },
	    aviso: function aviso(retorno) {
	      if (_.has(retorno, 'codigo')) {
	        if (retorno.codigo === 'ERRO') {
	          var mensagem = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : 'Erro de processamento. Não sei o que houve';
	          this.$snotify.clear();
	          this.$snotify.error(mensagem);
	        } else {
	          if (retorno.codigo === 'OK') {
	            if (_.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem)) {
	              this.$snotify.success(retorno.mensagem, { timeout: 3000 });
	            }
	          }
	        }
	      }
	    },
	    filtrar: function filtrar() {
	      console.log('filtrar');
	    },
	    carregarHistorico: function carregarHistorico() {
	      var _this4 = this;
	
	      if (this.listaRatificacoes.length === 0) return;
	
	      var _loop = function _loop(i) {
	        axiosLaravel.post('/ratificacao/historico', { 'id': _this4.listaRatificacoes[i].id }).then(function (response) {
	          console.log('dados recebidos HISTORICO', response.data.retorno[2]);
	
	          var assinaturaRatificacao = response.data.retorno.filter(function (element) {
	            return element['nome'] === 'ASSINATURA_RATIFICACAO';
	          });
	          var assinaturaInfo = assinaturaRatificacao.map(function (item) {
	            if (item.resultado === "\"Sim\"") {
	              return item.ds_nome_usuario + ': ASSINADO';
	            } else {
	              return item.ds_nome_usuario + ': PENDENTE';
	            }
	          });
	
	          _this4.listaRatificacoes[i]['assinatura'] = assinaturaInfo;
	          _this4.$forceUpdate();
	        }).catch(function (error) {
	          _this4.loading.tela = false;
	          _this4.$root.trataErro(error);
	        });
	        _this4.$forceUpdate();
	      };
	
	      for (var i = 0; i < this.listaRatificacoes.length; i++) {
	        _loop(i);
	      }
	    }
	  }
	};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documentos-ratificacao',
	  data: function data() {
	    return {
	      showGrid: true,
	      documentos: [],
	      documento: {
	        ds_nome_arquivo: ''
	      },
	      documentoTabela: {},
	      editando: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      localUso: 'TODOS'
	    };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'documentosObrigatorios', 'disable', 'localUso', 'processo_ratificacao', 'foiAssinada'],
	  created: function created() {
	    var _this = this;
	
	    if (_.isUndefined(this.localUso)) {
	      this.localUso = 'TODOS';
	    }
	    if (this.localUso === 'TODOS') {
	      if (_.isEmpty(this.$store.state.uploadDocumentos.documentos)) {
	        axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	          _this.documentos = _this.$store.state.uploadDocumentos.documentos = _.sortBy(response.data, [function (o) {
	            return o.ds_tipo;
	          }]);
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	        });
	      } else {
	        this.documentos = this.$store.state.uploadDocumentos.documentos;
	      }
	    } else {
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this.documentos = _.sortBy(response.data, [function (o) {
	          return o.ds_tipo;
	        }]);
	        console.log('this.documentos', _this.documentos);
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	
	    if (_.isNull(this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	          return item.ds_mime_type;
	        }).join('|');
	        _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    } else {
	      this.tiposPermitidos = this.$store.state.uploadDocumentos.tiposPermitidos;
	      this.tamanhoPermitido = this.$store.state.uploadDocumentos.tamanhoPermitido;
	    }
	  },
	
	  methods: {
	    novoDocumento: function novoDocumento() {
	      this.showGrid = !this.showGrid;
	      this.documento = {};
	    },
	    existeDocumento: function existeDocumento(documento) {
	      return this.propDocumentos.some(function (item) {
	        if (documento.tipo_documento) {
	          return documento.tipo_documento.ds_tipo === item.tipo_documento.ds_tipo;
	        }
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this3 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          _this3.documento.dt_criado = new Date();
	          if (_this3.editando === true) {
	            for (var i in _this3.documento) {
	              _this3.documentoTabela[i] = _this3.documento[i];
	            }_this3.documentoTabela = (0, _assign2.default)({}, _this3.documento);
	          } else {
	            _this3.propDocumentos.push(_this3.documento);
	          }
	          _this3.onCancel();
	        }
	      });
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.$forceUpdate();
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento, documento) {
	      var _this4 = this;
	
	      console.log('this.processo_ratificacao: ', this.processo_ratificacao);
	      console.log('documento: ', documento);
	      axiosLaravel.post('/ratificacao/deleta_documento', { 'documento_id': documento.id, 'processo_id': this.processo_ratificacao }).then(function (response) {
	        if (response.data.codigo === 'OK') {
	          console.log('retorno do deletaDocumento', response.data.retorno);
	          _this4.propDocumentos.splice(indexDocumento, 1);
	          _this4.$forceUpdate();
	        }
	      });
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    editaDocumento: function editaDocumento(documento) {
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this5 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Subindo arquivo', { timeout: 0 });
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this5.documento = response.data.value;
	        if (_this5.editando === true) {
	          for (var i in _this5.documento) {
	            _this5.documentoTabela[i] = _this5.documento[i];
	          }_this5.documentoTabela = (0, _assign2.default)({}, _this5.documento);
	        } else {
	          _this5.propDocumentos.push(_this5.documento);
	        }
	        _this5.onCancel();
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Arquivo salvo com sucesso');
	      }).catch(function (error) {
	        console.log('error', error);
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'editar-simplificado',
	  data: function data() {
	    return {
	      processo: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      axios.get('proxy/document/simplified/' + this.$route.params.id).then(function (response) {
	        console.log(response);
	        _this.processo = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	
	  methods: {
	    salva: function salva() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.processo.id) {
	            _this2.atualiza();
	          } else {
	            _this2.grava();
	          }
	        } else {
	          _this2.errors.items.forEach(function (item) {
	            _this2.$snotify.success(item.msg);
	          });
	        }
	      });
	    },
	    atualiza: function atualiza() {
	      var _this3 = this;
	
	      axios.put('proxy/document/simplified/' + this.processo.id, this.processo).then(function (response) {
	        _this3.$snotify.success('processo salvo com sucesso');
	        _this3.$router.go(-1);
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this4 = this;
	
	      axios.post('proxy/document/simplified', this.processo).then(function (response) {
	        _this4.$snotify.success('Processo salvo com sucesso');
	        _this4.$router.go(-1);
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'lista-simplificado',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        fields: [{ key: 'simplifiedNumber', label: 'Processo Simplificado', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'createdAt', label: 'Data Inicial', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'endDate', label: 'Data Final', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'active', label: 'Ativo', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'changedBy', label: 'Alterado por', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'updatedAt', label: 'Alterado em', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    axios.get('proxy/document/simplified').then(function (response) {
	      _this.table.items = response.data.value;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    inativa: function inativa(item) {
	      var _this2 = this;
	
	      axios.put('proxy/document/simplified/' + item.id + '/status', item).then(function (response) {
	        _this2.$snotify.success('Edital atualizado com sucesso');
	        item.active = !item.active;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditaSumarioExecutivo',
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      quillOptionsTitulo: {
	        modules: {
	          toolbar: [['italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'color': [] }, { 'background': [] }], ['video', 'image'], ['clean']]
	        },
	        placeholder: 'Informe o tílulo',
	        theme: 'bubble',
	        readonly: false
	      },
	      quillOptionsCompleto: {
	        theme: 'bubble'
	      },
	
	      loading: {
	        tela: false,
	        pesquisa: {
	          participantes: false,
	          projetos: false
	        }
	      },
	      mostrarTitulo: true,
	      salvaSumario: {
	        salvamentoAutomaticoAtivo: false,
	        statusSalvamento: 'AGUARDANDO',
	        idTimerSalvamentoAutomatico: null,
	        tempoSalvamentoAutomatico: 60000,
	        contador: 0
	      },
	      pesquisa: {
	        participantes: {
	          lista: [],
	          mostrar: false
	        },
	        projetos: {
	          lista: [],
	          mostrar: false
	        }
	      },
	      ehVisualizacao: false,
	      ehAcessoPorLink: false,
	      participantesJaCadastrados: [],
	      sumarioCarregado: {
	        id: null,
	        tipo: '',
	        link_acesso: '',
	        sumario: {
	          participantes: [],
	          investimentos: []
	        },
	        fk_criacao: null,
	        fk_processo: null,
	        situacao: 'ATIVO'
	      },
	      horarios: ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'],
	      sumarioCarregadoTemp: {},
	      editandoSumario: [],
	      participanteEditando: null,
	      idParticipanteEditando: 1,
	      interlocutorEditando: null,
	      idInterlocutorEditando: 1,
	      investimentoEditando: null,
	      idInvestimentoEditando: 1,
	      editandoColunaSubSumario: {},
	      editandoElemento: null,
	      dragging: false,
	      alturaContentWrapper: window.innerHeight - 151
	    };
	  },
	
	  watch: {
	    editandoSumario: function editandoSumario() {}
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  created: function created() {
	    this.ehAcessoPorLink = this.$route.path.indexOf('/se/') >= 0;
	    this.sumarioCarregado.id = this.$route.params.id;
	    this.ehVisualizacao = this.$route.params.visualizacao || false;
	    if (!_.isNull(this.sumarioCarregado.id)) {
	      this.carregaSumario();
	    }
	    if (!this.ehVisualizacao) {
	      this.salvamentoAutomatico();
	    }
	    var vm = this;
	    window.addEventListener('resize', function () {
	      vm.mostrarTitulo = vm.mostrarTitulo && window.innerHeight - 180 > 400;
	      vm.alturaContentWrapper = window.innerHeight - 151;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.salvaSumario.idTimerSalvamentoAutomatico);
	  },
	
	  methods: {
	    carregaSumario: function carregaSumario() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('sumario_executivo/edita/' + this.sumarioCarregado.id).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this.sumarioCarregado = response.data.retorno;
	          _this.editandoSumario = _.isNull(_this.sumarioCarregado.sumario) ? [] : _.cloneDeep(_this.sumarioCarregado.sumario);
	          _this.salvaSumario.salvamentoAutomaticoAtivo = true;
	          _this.salvaSumario.contador = 1;
	          _this.sumarioCarregadoTemp = _.cloneDeep(_this.sumarioCarregado);
	        } else {
	          _this.aviso(response.data);
	          _this.$router.go(-1);
	        }
	        _this.loading.tela = false;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.tela = false;
	      });
	    },
	    salvamentoAutomatico: function salvamentoAutomatico() {
	      var _this2 = this;
	
	      this.salvaSumario.idTimerSalvamentoAutomatico = setInterval(function () {
	        if (_this2.salvaSumario.salvamentoAutomaticoAtivo && _this2.salvaSumario.contador > 0 && !_.isEqual(_this2.sumarioCarregadoTemp, _this2.sumarioCarregado)) {
	          _this2.salvarEdicao();
	        }
	      }, this.salvaSumario.tempoSalvamentoAutomatico);
	    },
	    salvarEdicao: function salvarEdicao() {
	      var _this3 = this;
	
	      var redirecionarChave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.errors.remove('edicao_sumario');
	      if (this.errors.items.length === 0) {
	        this.$validator.validateAll().then(function (validado) {
	          if (validado && _this3.errors.items.length === 0) {
	            _this3.salvaSumario.statusSalvamento = 'PROCESSANDO';
	            var rota = _.isNull(_this3.sumarioCarregado.id) ? 'sumario_executivo/cria/' : 'sumario_executivo/salva/';
	            _this3.loading.tela = !_.isNull(redirecionarChave);
	
	            axiosLaravel.post(rota, _this3.sumarioCarregado).then(function (response) {
	              if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	                _this3.salvaSumario.statusSalvamento = 'FEITO';
	                setTimeout(function () {
	                  _this3.salvaSumario.statusSalvamento = 'AGUARDANDO';
	                  _this3.salvaSumario.salvamentoAutomaticoAtivo = true;
	                  _this3.salvaSumario.contador++;
	                  console.log('salvamento feito! contador', _this3.salvaSumario.contador);
	                }, 2000);
	                _this3.sumarioCarregado = _.cloneDeep(response.data.retorno);
	                _this3.sumarioCarregadoTemp = _.cloneDeep(_this3.sumarioCarregado);
	              } else {
	                _this3.aviso(response.data);
	              }
	              _this3.loading.tela = false;
	            }).catch(function (error) {
	              _this3.$root.trataErro(error);
	              _this3.salvaSumario.statusSalvamento = 'ERRO';
	            });
	          }
	        });
	      }
	    },
	    aviso: function aviso(retorno) {
	      var _this4 = this;
	
	      if (_.has(retorno, 'codigo')) {
	        var mensagens = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : ['Erro de processamento. Não sei o que houve'];
	        mensagens.forEach(function (msg) {
	          if (retorno.codigo === 'ERRO') {
	            _this4.$snotify.error(msg);
	          } else if (_.includes(['OK', 'AVISO'], retorno.codigo)) {
	            _this4.$snotify.success(msg, { timeout: 3000 });
	          }
	        });
	      }
	    },
	    mostrarOcultar: function mostrarOcultar(item, opcao) {
	      _.set(item, [opcao], !_.get(item, [opcao], true));
	      this.$forceUpdate();
	    },
	    novoParticipante: function novoParticipante() {
	      this.participanteEditando = { 'id': null, 'participante': '', 'mostrar': true, 'sobre': null, 'grupo': null, 'atuacao': null, 'historico': null };
	    },
	    removeParticipante: function removeParticipante(idx) {
	      this.participanteEditando = null;
	      this.sumarioCarregado.sumario.participantes.splice(idx, 1);
	      this.$forceUpdate();
	    },
	    duplicaParticipante: function duplicaParticipante(idx) {
	      var participante = _.clone(this.sumarioCarregado.sumario.participantes[idx]);
	      this.sumarioCarregado.sumario.participantes.splice(idx, 0, participante);
	      this.$forceUpdate();
	    },
	    editaParticipante: function editaParticipante(idx) {
	      this.participanteEditando = _.clone(this.sumarioCarregado.sumario.participantes[idx]);
	    },
	    okEdicaoParticipante: function okEdicaoParticipante() {
	      var participante = _.clone(this.participanteEditando);
	      if (_.isNull(participante.id)) {
	        _.set(participante, 'id', ++this.idParticipanteEditando);
	        this.sumarioCarregado.sumario.participantes.push(participante);
	      } else {
	        this.sumarioCarregado.sumario.participantes[_.findIndex(this.sumarioCarregado.sumario.participantes, ['id', participante.id])] = _.clone(participante);
	      }
	      this.participanteEditando = null;
	    },
	    cancelaEdicaoParticipante: function cancelaEdicaoParticipante() {
	      this.participanteEditando = null;
	    },
	    novoInterlocutor: function novoInterlocutor() {
	      this.interlocutorEditando = { 'id': null, 'nome': '', 'cargo': null };
	    },
	    removeInterlocutor: function removeInterlocutor(participante, idx) {
	      this.interlocutorEditando = null;
	      participante.interlocutores.splice(idx, 1);
	      this.$forceUpdate();
	    },
	    duplicaInterlocutor: function duplicaInterlocutor(participante, idx) {
	      var interlocutor = _.clone(participante.interlocutores[idx]);
	      participante.interlocutores.splice(idx, 0, interlocutor);
	      this.$forceUpdate();
	    },
	    editaInterlocutor: function editaInterlocutor(participante, idx) {
	      this.interlocutorEditando = _.clone(participante.interlocutores[idx]);
	    },
	    okEdicaoInterlocutor: function okEdicaoInterlocutor(participante) {
	      var interlocutor = _.clone(this.interlocutorEditando);
	      if (!_.has(this.participanteEditando, 'interlocutores')) {
	        _.set(this.participanteEditando, 'interlocutores', []);
	      }
	      if (_.isNull(interlocutor.id)) {
	        _.set(interlocutor, 'id', ++this.idInterlocutorEditando);
	        participante.interlocutores.push(interlocutor);
	      } else {
	        participante.interlocutores[_.findIndex(participante.interlocutores, ['id', interlocutor.id])] = interlocutor;
	      }
	      this.interlocutorEditando = null;
	    },
	    cancelaEdicaoInterlocutor: function cancelaEdicaoInterlocutor() {
	      this.interlocutorEditando = null;
	    },
	    novoInvestimento: function novoInvestimento() {
	      this.investimentoEditando = { 'id': null, 'origem': '', 'valorFBB': 0, 'valorContrapartida': 0, 'valorParceiros': 0 };
	    },
	    removeInvestimento: function removeInvestimento(idx) {
	      this.investimentoEditando = null;
	      this.sumarioCarregado.sumario.investimentos.splice(idx, 1);
	      this.$forceUpdate();
	    },
	    duplicaInvestimento: function duplicaInvestimento(idx) {
	      var investimento = _.clone(this.sumarioCarregado.sumario.investimentos[idx]);
	      this.sumarioCarregado.sumario.investimentos.splice(idx, 0, investimento);
	      this.$forceUpdate();
	    },
	    editaInvestimento: function editaInvestimento(idx) {
	      this.investimentoEditando = _.clone(this.sumarioCarregado.sumario.investimentos[idx]);
	    },
	    okEdicaoInvestimento: function okEdicaoInvestimento() {
	      var investimento = _.clone(this.investimentoEditando);
	      if (_.isNull(investimento.id)) {
	        _.set(investimento, 'id', ++this.idInvestimentoEditando);
	        if (!_.has(this.sumarioCarregado, 'sumario.investimentos')) {
	          _.set(this.sumarioCarregado, 'sumario.investimentos', []);
	        }
	        this.sumarioCarregado.sumario.investimentos.push(investimento);
	      } else {
	        this.sumarioCarregado.sumario.investimentos[_.findIndex(this.sumarioCarregado.sumario.investimentos, ['id', investimento.id])] = _.clone(investimento);
	      }
	      this.investimentoEditando = null;
	    },
	    cancelaEdicaoInvestimento: function cancelaEdicaoInvestimento() {
	      this.investimentoEditando = null;
	    },
	    buscaParticipantesJaCadastrados: function buscaParticipantesJaCadastrados() {
	      var _this5 = this;
	
	      console.log('busca');
	      this.pesquisa.participantes.mostrar = false;
	      if (!_.isEmpty(this.participanteEditando.participante) && this.participanteEditando.participante.length > 3) {
	        this.loading.pesquisa.participantes = true;
	        axiosLaravel.post('sumario_executivo/participantes/', { 'termo': this.participanteEditando.participante }).then(function (response) {
	          console.log('buscaParticipantesJaCadastrados', response.data);
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this5.pesquisa.participantes.lista = response.data.retorno;
	            _this5.pesquisa.participantes.mostrar = true;
	            _this5.$forceUpdate();
	          }
	          _this5.loading.pesquisa.participantes = false;
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	          _this5.loading.pesquisa.participantes = false;
	        });
	      }
	    },
	    ocultaListaParticipantesJaCadastrados: function ocultaListaParticipantesJaCadastrados() {
	      var _this6 = this;
	
	      setTimeout(function () {
	        _this6.pesquisa.participantes.mostrar = false;
	      }, 500);
	    },
	    selecionaParticipanteJaCadastrado: function selecionaParticipanteJaCadastrado(selecionado) {
	      this.participanteEditando.participante = selecionado.nomfor;
	      this.pesquisa.participantes.lista = [];
	      if (selecionado.contatos > 0) {
	        var vm = this;
	        this.$dialog.confirm('Deseja adicionar <b>' + selecionado.contatos + '</b> contato(s) de <b>' + selecionado.nomfor + '</b> como interlocutores?', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	          vm.adicionarInterlocutoresDeParticipanteSelecionado(selecionado.codfor);
	        }).catch(function () {});
	      }
	    },
	    adicionarInterlocutoresDeParticipanteSelecionado: function adicionarInterlocutoresDeParticipanteSelecionado(codigo) {
	      var _this7 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('sumario_executivo/interlocutores/', { 'codigo': codigo }).then(function (response) {
	        console.log('adicionarInterlocutoresDeParticipanteSelecionado response', response.data);
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          if (!_.has(_this7.participanteEditando, 'interlocutores')) {
	            _.set(_this7.participanteEditando, 'interlocutores', []);
	          }
	          response.data.retorno.forEach(function (contato) {
	            _this7.participanteEditando.interlocutores.push({ 'id': ++_this7.idInterlocutorEditando, 'nome': contato.nomcto, 'cargo': contato.desniv });
	          });
	          _this7.$forceUpdate();
	        }
	        _this7.loading.tela = false;
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	        _this7.loading.tela = false;
	      });
	    },
	    buscaProjetosAprovados: function buscaProjetosAprovados() {
	      var _this8 = this;
	
	      console.log('busca');
	      this.pesquisa.projetos.mostrar = false;
	      if (!_.isEmpty(this.investimentoEditando.origem) && this.investimentoEditando.origem.length > 3) {
	        this.loading.pesquisa.projetos = true;
	        axiosLaravel.post('sumario_executivo/projetos/', { 'termo': this.investimentoEditando.origem }).then(function (response) {
	          console.log('buscaProjetosAprovados', response.data);
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this8.pesquisa.projetos.lista = response.data.retorno;
	            _this8.pesquisa.projetos.mostrar = true;
	            _this8.$forceUpdate();
	          }
	          _this8.loading.pesquisa.projetos = false;
	        }).catch(function (error) {
	          _this8.$root.trataErro(error);
	          _this8.loading.pesquisa.projetos = false;
	        });
	      }
	    },
	    ocultaListaProjetosAprovados: function ocultaListaProjetosAprovados() {
	      var _this9 = this;
	
	      setTimeout(function () {
	        _this9.pesquisa.projetos.mostrar = false;
	      }, 500);
	    },
	    selecionaProjetosAprovados: function selecionaProjetosAprovados(selecionado) {
	      var _this10 = this;
	
	      this.investimentoEditando.origem = selecionado.nomprj;
	      this.pesquisa.projetos.lista = [];
	      this.loading.tela = true;
	      axiosLaravel.post('sumario_executivo/projeto/investimento', { 'projeto': selecionado.numprj }).then(function (response) {
	        console.log('buscaProjetosAprovados', response.data);
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this10.investimentoEditando.valorFBB = response.data.retorno.valorFBB;
	          _this10.investimentoEditando.valorContrapartida = response.data.retorno.valorContrapartida;
	          _this10.investimentoEditando.valorParceiros = response.data.retorno.valorParceiros;
	          _this10.$forceUpdate();
	        }
	        _this10.loading.tela = false;
	      }).catch(function (error) {
	        _this10.$root.trataErro(error);
	        _this10.loading.tela = false;
	      });
	    },
	    imprimir: function imprimir() {
	      window.print();
	    },
	    removerTagHtmlString: function removerTagHtmlString(str) {
	      return _.isNull(str) ? str : ('' + str).replace(/(<([^>]+)>)/ig, '');
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	
	      this.carregaArquivo(files[0]);
	
	      _.set(this.participanteEditando, 'logomarca.ds_nome_arquivo', files[0].name);
	
	      _.set(this.participanteEditando, 'logomarca.ds_content_type', files[0].type);
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        _.set(vm.participanteEditando, 'logomarca.file', e.target.result);
	      };
	      reader.readAsDataURL(file);
	    }
	  }
	};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaSumariosExecutivo',
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      loading: {
	        tela: false,
	        detalhes: false
	      },
	      numeroAtualizacao: 0,
	      pesquisa: '',
	      hoje: new Date(),
	      camposSumarioExecutivo: [{ key: 'id', label: 'ID', thStyle: 'width: 5%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'sumario.acao', label: 'Nome', thStyle: 'width: 25%; text-align: left', sortable: true, 'class': 'word-wrap:break-word text-left' }, { key: 'sumario.data', label: 'Data', thStyle: 'width: 10%; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'sumario.local', label: 'Local', thStyle: 'width: 20%; text-align: left', sortable: true, 'class': 'word-wrap:break-word text-left' }, { key: 'actions', label: 'Ações', thStyle: 'width: 20%; text-align: center;', sortable: false, 'class': 'text-center' }],
	      tabelaSumarioExecutivo: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      tabelaDetalhamento: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'processo.id',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      tipoFormulario: [{ codigo: 'AVALIACAO_APROVACAO', descricao: 'Marco zero' }, { codigo: 'AVALIACAO_ENCERRAMENTO', descricao: 'Marco um' }, { codigo: 'AVALIACAO_GENERICO', descricao: 'Genérico' }, { codigo: 'AVALIACAO_PARTICIPANTE', descricao: 'Participante' }],
	      detalhamentoFormulario: {},
	      projetoSelecionadoEnvioManual: {},
	      sumarios: [],
	      alertasFormulariosCadastrados: []
	    };
	  },
	  created: function created() {
	    this.listaFormsAvaliacao();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  methods: {
	    listaFormsAvaliacao: function listaFormsAvaliacao() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('sumario_executivo/lista/').then(function (response) {
	        _this.sumarios = response.data;
	        _this.tabelaSumarioExecutivo.totalRows = _this.sumarios.length;
	        _this.$forceUpdate();
	        _this.loading.tela = false;
	      }).catch(function (error) {
	        _this.$snotify.clear();
	        _this.$root.trataErro(error);
	        _this.loading.tela = false;
	      });
	    },
	    duplicarSumario: function duplicarSumario(id) {
	      var _this2 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('sumario_executivo/duplica/', { 'id': id }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this2.sumarios.push(response.data.retorno);
	        } else {
	          _this2.$snotify.error(response.data.mensagem);
	        }
	        _this2.tabelaSumarioExecutivo.totalRows = _this2.sumarios.length;
	        _this2.$forceUpdate();
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        _this2.$snotify.clear();
	        _this2.$root.trataErro(error);
	        _this2.loading.tela = false;
	      });
	    },
	    filtroPorItem: function filtroPorItem(row, filter) {
	      var saida = true;
	      console.log('filtroPorItem row, filter', row, filter);
	      if (filter !== 'retornar_todos_registros') {
	        var termos = _.split(_.toLower(filter), ' ');
	        termos.forEach(function (termo) {
	          saida = saida && (_.toLower(row.id).indexOf(termo) !== -1 || _.toLower(row.sumario.acao).indexOf(termo) !== -1 || _.toLower(row.sumario.local).indexOf(termo) !== -1 || row.sumario.data.indexOf(termo) !== -1);
	        });
	      }
	      return saida;
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.tabelaSumarioExecutivo.totalRows = filteredItems.length;
	      this.tabelaSumarioExecutivo.currentPage = 1;
	    },
	    ajustaPesquisa: function ajustaPesquisa() {
	      this.tabelaSumarioExecutivo.filter = _.isNull(this.pesquisa) || this.pesquisa === '' ? 'retornar_todos_registros' : this.pesquisa;
	    },
	    copiaUrl: function copiaUrl(row) {
	      var _this3 = this;
	
	      var link = row.item['link_acesso'];
	      var linkCompleto = location.protocol + '//' + location.host + '/se/' + link;
	      navigator.clipboard.writeText(linkCompleto).then(function () {
	        _.set(row, 'item.link_copia', { classe: 'label label-success', msg: 'Copiado!' });
	        _this3.$forceUpdate();
	        setTimeout(function () {
	          _.unset(row, 'item.link_copia');_this3.$forceUpdate();
	        }, 2000);
	      }).catch(function (err) {
	        _.set(row, 'item.link_copia', { classe: 'label label-danger', msg: 'Erro: ' + err });
	        _this3.$forceUpdate();
	      });
	    }
	  }
	};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _profiles = __webpack_require__(121);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _authorize = __webpack_require__(179);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = [];
	
	exports.default = {
	  name: 'alteraUsuario',
	  components: { Profiles: _profiles2.default },
	  mixin: [_authorize.authorize],
	  data: function data() {
	    return {
	      data: [],
	      loading: {
	        show: false
	      },
	      show: false,
	      consulta: {},
	      situacao_opcoes: [{ text: 'Ativo', value: '1' }, { text: 'Inativado', value: '0' }],
	      usuario: {
	        acao: 'VISUALIZA',
	        id: null,
	        id_usuario: null,
	        ativo: null,
	        nome: null,
	        tipo: null,
	        email: null,
	        login: null,
	        data_criacao: null,
	        cpf: null,
	        perfis: []
	      },
	      initialDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	      perfil_novo: {
	        perfil: null,
	        data_inicial: (0, _moment2.default)().format('YYYY-MM-DD'),
	        data_inativacao: '1900-01-01',
	        alterado_por: null
	      },
	      perfis: {},
	      profilesConstraint: [],
	      inactivateDate: null,
	      table: {
	        items: [],
	        currentPage: 1,
	        perPage: 10,
	        totalRows: items.length,
	        sortBy: 'data_alteracao',
	        sortDesc: false,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'perfil', label: 'Perfil', sortable: true, thStyle: 'text-align: center', class: 'text-left' }, { key: 'data_inicial', label: 'Data Inicial', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_inativacao', label: 'Data final', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'alterado_por', label: 'Alterado por', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_alteracao', label: 'Alterado em', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Usuário',
	        active: true
	      }]
	    };
	  },
	  mounted: function mounted() {},
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    this.usuario.id = this.$route.params.id;
	    this.perfil_novo.alterado_por = this.usuarioLogado.userName;
	    this.carregaDados();
	  },
	
	  methods: {
	    alteradoPor: function alteradoPor(item) {
	      item.alterado_por = this.usuarioLogado.userName;
	      this.$forceUpdate();
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    },
	    loadProfiles: function loadProfiles() {
	      var _this = this;
	
	      axios.get('/proxy/account/profiles?tiny').then(function (response) {
	        _this.perfis = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    carregaDados: function carregaDados() {
	      var _this2 = this;
	
	      if (this.$route.params.id) {
	        this.usuario.acao = 'VISUALIZA';
	        this.table.items = [];
	        this.loading.show = true;
	        this.$snotify.clear();
	        this.$aguarde('Buscando informações do usuário. Por favor, aguarde...');
	
	        axiosLaravel.post('/usuarios/acao', this.usuario).then(function (response) {
	          _this2.consulta = response.data.dados;
	          _this2.usuario.id_usuario = _this2.consulta.usuario.id_usuario;
	          _this2.usuario.ativo = _this2.consulta.usuario.ativo;
	          _this2.usuario.nome = _this2.consulta.usuario.nome;
	          _this2.usuario.tipo = _this2.consulta.usuario.tipo;
	          _this2.usuario.email = _this2.consulta.usuario.email;
	          _this2.usuario.login = _this2.consulta.usuario.login;
	          _this2.usuario.data_criacao = _this2.consulta.usuario.data_criacao;
	
	          if (_this2.consulta.perfis) {
	            _this2.usuario.perfis = _this2.consulta.perfis.row;
	            _this2.table.items = _this2.usuario.perfis;
	            _this2.table.totalRows = _this2.table.items.length;
	          } else {
	            _this2.table.items = _this2.usuario.perfis;
	            _this2.table.totalRows = 0;
	          }
	
	          _this2.usuario.perfis.forEach(function (perfil) {
	            perfil.data_inativacao = (0, _moment2.default)(perfil.data_inativacao, _moment2.default.defaultFormat).toDate();
	          });
	          _this2.$snotify.clear();
	          _this2.loading.show = false;
	        }).catch(function (error) {
	          if (error) {
	            _this2.$root.trataErro(error);
	          }
	        });
	      }
	    },
	    adicionaPerfil: function adicionaPerfil() {
	      this.perfil_novo.perfil.admin = this.perfil_novo.perfil.admin ? '1' : '0';
	      this.perfil_novo.perfil.alterado_por = this.usuarioLogado.userName;
	      this.perfil_novo.perfil.ativo = this.perfil_novo.perfil.active ? '1' : '0';
	      this.perfil_novo.perfil.data_alteracao = (0, _moment2.default)();
	      this.perfil_novo.perfil.data_criacao = (0, _moment2.default)();
	      this.perfil_novo.perfil.data_inicial = this.perfil_novo.data_inicial;
	      this.perfil_novo.perfil.data_inativacao = this.perfil_novo.data_inativacao;
	      this.perfil_novo.perfil.descricao = this.perfil_novo.perfil.description;
	      this.perfil_novo.perfil.perfil = this.perfil_novo.perfil.name;
	
	      this.usuario.perfis.push((0, _assign2.default)({}, this.perfil_novo.perfil));
	    },
	    concluirAlteracoes: function concluirAlteracoes() {
	      var _this3 = this;
	
	      this.usuario.acao = 'CONCLUSAO';
	      this.loading.show = true;
	      this.$snotify.clear();
	      this.$aguarde('Atualizando usuário. Por favor, aguarde...');
	
	      axiosLaravel.post('/usuarios/acao', this.usuario).then(function (response) {
	        _this3.$snotify.clear();
	        _this3.loading.show = false;
	        _this3.$snotify.success(response.data.dados.row[0].resultado);
	      }).catch(function (error) {
	        if (error) {
	          _this3.$root.trataErro(error);
	        }
	      });
	    },
	    formatarLinhas: function formatarLinhas(item, type) {
	      if (!item) return;
	      if (item.active) return 'registro_adicionado';
	    }
	  }
	};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(182);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _profiles = __webpack_require__(121);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _authorize = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = [];
	
	exports.default = {
	  name: 'editaUsuario',
	  components: { Profiles: _profiles2.default },
	  mixin: [_authorize.authorize],
	  data: function data() {
	    return {
	      data: [],
	      loading: {
	        show: false
	      },
	      show: false,
	      user: {},
	      perfis: {},
	      profileConstraint: {
	        profile: null
	      },
	      profilesConstraint: [],
	      items: [],
	      initialDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	      inactivateDate: null,
	      fields: [{ key: 'profile.name', label: 'Perfil', sortable: true, thStyle: 'text-align: center', class: 'text-left' }, { key: 'profile.createdAt', label: 'Data Inicial', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'profile.inactivateDate', label: 'Data final', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'changedBy', label: 'Alterado por', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'createdAt', label: 'Alterado em', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }],
	      table: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: items.length,
	        sortBy: 'userName',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar'
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Usuário',
	        active: true
	      }]
	    };
	  },
	  mounted: function mounted() {},
	
	  created: function created() {
	    this.fetchData();
	  },
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    },
	    loadProfiles: function loadProfiles() {
	      var _this = this;
	
	      axios.get('/proxy/account/profiles?tiny').then(function (response) {
	        _this.perfis = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    fetchData: function fetchData() {
	      this.user = this.$route.params;
	      this.profilesConstraint = this.$route.params.profileConstraint.row;
	      this.items = this.profilesConstraint;
	    },
	    onAdd: function onAdd() {
	      this.$validator.errors.remove('profile');
	      this.errors.clear();
	
	      if (!this.profileConstraint.profile) {
	        this.errors.add('profile', 'campo perfil é obrigatorio');
	      }
	      if (this.errors.items.length !== 0) {
	        return;
	      }
	
	      this.items.forEach(function (item, index, object) {});
	
	      this.items.push((0, _assign2.default)({}, this.profileConstraint));
	    },
	    onCancel: function onCancel() {
	      this.profileConstraint.profile = {};
	      this.profileConstraint.initialDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      this.profileConstraint.inactivateDate = '';
	      this.show = false;
	    },
	    onSave: function onSave() {
	      var _this2 = this;
	
	      axios.put('/proxy/account/users/' + this.user.id, this.user).then(function (response) {
	        _this2.$snotify.success('usuário atualizado com sucesso');
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    onClean: function onClean() {
	      this.profileConstraint.profile = {};
	      this.profileConstraint.initialDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      this.profileConstraint.inactivateDate = '';
	      this.user.cpf = null;
	    },
	    onReturn: function onReturn() {},
	    onEdit: function onEdit(p) {
	      this.profileConstraint = p;
	      this.show = true;
	    },
	    onDelete: function onDelete(p) {
	      var _this3 = this;
	
	      this.user.profilesConstraint.forEach(function (item, index, object) {
	        if ((0, _values2.default)(item.profile).indexOf(p.profile.name) > -1) {
	          _this3.user.profilesConstraint.splice(index, 1);
	        }
	      });
	    },
	    bloqueiaPerfil: function bloqueiaPerfil(name) {
	      console.lof(name);
	      this.user.profilesConstraint.forEach(function (item) {
	        if ((0, _values2.default)(item).indexOf(name)) return true;
	      });
	      return false;
	    }
	  }
	};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	var _profiles = __webpack_require__(121);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = [];
	
	exports.default = {
	  name: 'Usuarios',
	  components: { Profiles: _profiles2.default },
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      perfis: {},
	      usuario: {
	        acao: 'LISTA',
	        pesquisa: null,
	        login: null
	      },
	      pesquisa: '',
	      table: {
	        items: [],
	        filter: null,
	        currentPage: 1,
	        perPage: 10,
	        totalRows: items.length,
	        sortBy: 'userName',
	        sortDesc: true,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'tipo_usuario', label: 'Tipo de usuário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'login', label: 'Login', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nome_usuario', label: 'Nome', sortable: true, thStyle: 'text-align: center; width: 25%; white-space:pre-wrap; word-wrap:break-word', class: 'centraliza' }, { key: 'email', label: 'E-mail', sortable: true, thStyle: 'text-align: center; width: 30%; white-space:pre-wrap; word-wrap:break-word', class: 'text-center' }, { key: 'ativo', label: 'Ativo', thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_criacao', label: 'Inclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'acoes', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Usuário',
	        active: true
	      }]
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    sortOptions: function sortOptions() {
	      return this.fields.table.filter(function (f) {
	        return f.sortable;
	      }).map(function (f) {
	        return { text: f.label, value: f.key };
	      });
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    this.onSearch();
	  },
	  mounted: function mounted() {},
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    },
	    onSearch: function onSearch() {
	      var _this = this;
	
	      if (this.pesquisa !== '') {
	        this.usuario.acao = 'LISTA';
	        this.usuario.pesquisa = this.pesquisa;
	        this.table.items = null;
	        this.loading.show = true;
	        this.$snotify.clear();
	        this.$aguarde('Listando usuários. Por favor, aguarde...');
	
	        axiosLaravel.post('/usuarios/acao', this.usuario).then(function (response) {
	          _this.table.items = response.data.dados.row;
	          _this.table.totalRows = _this.table.items.length;
	          _this.$snotify.clear();
	          _this.loading.show = false;
	        }).catch(function (error) {
	          if (error) {
	            _this.$root.trataErro(error);
	          }
	        });
	      }
	    },
	    authorizeDeleteUser: function authorizeDeleteUser(user) {
	      if (user.userType === "AGENCIA") {
	        return this.$root.authorize('usuario-agencia-ativar-inativar');
	      } else if (user.userType === "ENTIDADE") {
	        return this.$root.authorize('usuario-entidade-ativar-inativar');
	      } else if (user.userType === "PARCEIRO_ESTRATEGICO") {
	        return this.$root.authorize('usuario-estrategico-ativar-inativar');
	      } else if (user.userType === "SUPERINTENDENCIA") {
	        return this.$root.authorize('usuario-superintendencia-ativar-inativar');
	      }
	      return true;
	    },
	    onCleanSearch: function onCleanSearch() {
	      this.filtros = { userType: '', login: '', profile: {}, name: '', email: '' };
	    }
	  }
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	var _profiles = __webpack_require__(121);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = [];
	
	exports.default = {
	  name: 'ListaUsuarios',
	  components: { Profiles: _profiles2.default },
	  data: function data() {
	    return {
	      data: [],
	      loading: {
	        show: false
	      },
	      items: [],
	      perfis: {},
	      filtros: {
	        email: '',
	        login: '',
	        name: '',
	        profile: {},
	        userType: '',
	        createdAt: null,
	        id: ''
	      },
	      fields: [{ key: 'userType', label: 'Tipo de usuário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'login', label: 'Login', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'userName', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'centraliza' }, { key: 'email', label: 'E-mail', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'active', label: 'Ativo', thStyle: 'text-align: center', class: 'text-center' }, { key: 'createdAt', label: 'Inclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }],
	      table: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: items.length,
	        sortBy: 'userName',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar'
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Usuário',
	        active: true
	      }]
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    sortOptions: function sortOptions() {
	      return this.fields.table.filter(function (f) {
	        return f.sortable;
	      }).map(function (f) {
	        return { text: f.label, value: f.key };
	      });
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {},
	  mounted: function mounted() {},
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    },
	    onSearch: function onSearch() {
	      var _this = this;
	
	      if (this.filtros.createdAt) {
	        this.filtros.createdAt = (0, _moment2.default)(this.filtros.createdAt).format();
	      }
	      this.items = null;
	      this.loading.show = true;
	      this.$snotify.clear();
	      this.$aguarde('Buscando usuários. Por favor, aguarde...');
	
	      axiosLaravel.post('/usuario/busca_usuario', this.filtros).then(function (response) {
	        _this.items = response.data.dados.row;
	        _this.table.totalRows = _this.items.length;
	        _this.$snotify.clear();
	        _this.loading.show = false;
	      }).catch(function (error) {
	        if (error) {
	          _this.$root.trataErro(error);
	        }
	      });
	    },
	    inativa: function inativa(item) {
	      var _this2 = this;
	
	      axios.put('/proxy/account/users/' + item.id + '/status', item).then(function (response) {
	        item.active = !item.active;
	      }).catch(function (error) {
	        if (error) {
	          _this2.$root.trataErro(error);
	        }
	      });
	    },
	    authorizeDeleteUser: function authorizeDeleteUser(user) {
	      if (user.userType === "AGENCIA") {
	        return this.$root.authorize('usuario-agencia-ativar-inativar');
	      } else if (user.userType === "ENTIDADE") {
	        return this.$root.authorize('usuario-entidade-ativar-inativar');
	      } else if (user.userType === "PARCEIRO_ESTRATEGICO") {
	        return this.$root.authorize('usuario-estrategico-ativar-inativar');
	      } else if (user.userType === "SUPERINTENDENCIA") {
	        return this.$root.authorize('usuario-superintendencia-ativar-inativar');
	      }
	      return true;
	    },
	    onCleanSearch: function onCleanSearch() {
	      this.filtros = { userType: '', login: '', profile: {}, name: '', email: '' };
	    }
	  }
	};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'projetos-usuarios',
	  data: function data() {
	    return {
	      loading: {
	        tela: false,
	        usuarios: false,
	        projetos: true,
	        verifica: {
	          login: false,
	          email: false
	        }
	      },
	      listaProjetos: [],
	      listaProjetosEntidade: [],
	      projetoSelecionado: [],
	      listaUsuarios: [],
	      listaUsuariosBackup: [],
	      restricaoParaInicializar: [],
	      usuarioEditando: {},
	      ehVisualizacao: false,
	      pesquisa: '',
	      tabelaUsuarios: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'ds_nome_usuario',
	        sortDesc: true,
	        filter: null,
	        bordered: true,
	        numeroAtualizacao: 0,
	        fields: [{ key: 'ds_nome_usuario', label: 'Nome', sortable: true, thStyle: 'text-align: center; width: 150px', class: 'text-center' }, { key: 'ds_cpf', label: 'CPF', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_login', label: 'Login', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'ds_telefone', label: 'Telefone', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_email', label: 'E-mail', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', thStyle: 'text-align: center', class: 'text-center' }, { key: 'acessos', label: 'Acesso ao projeto', thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 50px', class: 'text-center' }]
	      },
	      listaAcessos: [{ 'codigo': 'SEM_ACESSO', 'descricao': 'Sem Acesso' }, { 'codigo': 'VISUALIZACAO_PROJETO', 'descricao': 'Só visualização' }, { 'codigo': 'INICIA_SOLICITACAO', 'descricao': 'Inicia solicitações' }]
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    projetoSelecionado: function projetoSelecionado() {
	      this.buscaUsuariosEntidade();
	    }
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    console.clear();
	    this.carregarlistagemProjetos();
	  },
	
	  methods: {
	    carregarlistagemProjetos: function carregarlistagemProjetos() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('usuarios/projetos').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this.listaProjetos = response.data.retorno;
	          _this.$refs.listagemProjetos.activate();
	        } else {
	          _this.$snotify.error(response.data.mensagem[0]);
	        }
	        _this.$forceUpdate();
	        _this.loading.tela = false;
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        console.log('error', error);
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaUsuariosEntidade: function buscaUsuariosEntidade() {
	      var _this2 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('usuarios/entidade', { 'id': this.projetoSelecionado.fk_entidade }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          axiosLaravel.post('usuarios/entidade/projetos', { 'id': _this2.projetoSelecionado.fk_entidade }).then(function (response) {
	            if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	              _this2.listaProjetosEntidade = response.data.retorno;
	            } else {
	              _this2.$snotify.error(response.data.mensagem[0]);
	            }
	            _this2.$forceUpdate();
	            _this2.loading.tela = false;
	          }).catch(function (error) {
	            _this2.loading.tela = false;
	            console.log('error', error);
	            _this2.$root.trataErro(error);
	          });
	          response.data.retorno.forEach(function (usuario) {
	            _.set(usuario, 'tempId', _.uniqueId());
	            _.set(usuario, 'configuracoes.acesso_projetos', _.get(usuario, 'configuracoes.acesso_projetos', []));
	            var acessoPadrao = _.find(_this2.listaAcessos, ['codigo', _.isNull(usuario.ds_cpf) ? 'VISUALIZACAO_PROJETO' : 'INICIA_SOLICITACAO']);
	            var acessoProjetoAtual = _.find(usuario.configuracoes.acesso_projetos, ['numero', _this2.projetoSelecionado.ds_codigo_projeto_erp]);
	            var acesso = acessoProjetoAtual ? acessoProjetoAtual.acesso : acessoPadrao;
	            _.set(usuario, 'acessos', !_.isArray(acesso) ? [acesso] : acesso);
	          });
	
	          _this2.tabelaUsuarios.currentPage = 1;
	          _this2.tabelaUsuarios.totalRows = response.data.retorno.length;
	          _this2.tabelaUsuarios.filter = null;
	          _this2.pesquisa = '';
	
	          _this2.listaUsuarios = response.data.retorno;
	          _this2.listaUsuariosBackup = _.cloneDeep(_this2.listaUsuarios);
	        } else {
	          _this2.$snotify.error(response.data.mensagem[0]);
	        }
	        _this2.$forceUpdate();
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        _this2.loading.tela = false;
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    novoUsuario: function novoUsuario() {
	      this.usuarioEditando = { id: null, bt_ativo: 1 };
	    },
	    adicionaUsuario: function adicionaUsuario() {
	      var _this3 = this;
	
	      this.$validator.validateAll().then(function (validado) {
	        if (validado && _this3.errors.items.length === 0) {
	          _this3.loading.tela = true;
	          _this3.listaUsuarios.push({
	            'id': 0,
	            'ds_nome_usuario': _this3.usuarioEditando.ds_nome_usuario,
	            'ds_cpf': _this3.usuarioEditando.ds_cpf,
	            'ds_login': _this3.usuarioEditando.ds_login,
	            'ds_telefone': _this3.usuarioEditando.ds_telefone,
	            'ds_email': _this3.usuarioEditando.ds_email,
	            'bt_ativo': parseInt(_this3.usuarioEditando.bt_ativo),
	            'configuracoes': _this3.usuarioEditando.configuracoes,
	            'acessos': _this3.usuarioEditando.acessos,
	            'fk_entidade': _this3.projetoSelecionado.fk_entidade,
	            'ds_tipo_usuario': 'ENTIDADE',
	            'tempId': _.uniqueId()
	          });
	          _this3.usuarioEditando = {};
	          _this3.$forceUpdate();
	          _this3.loading.tela = false;
	        }
	      });
	    },
	    alteraUsuario: function alteraUsuario() {
	      var _this4 = this;
	
	      this.$validator.validateAll().then(function (validado) {
	        if (validado && _this4.errors.items.length === 0) {
	          var index = _.findIndex(_this4.listaUsuarios, ['tempId', _this4.usuarioEditando.tempId]);
	          _this4.listaUsuarios[index] = _.clone(_this4.usuarioEditando);
	          _this4.usuarioEditando = {};
	        }
	      });
	    },
	    editaUsuario: function editaUsuario(row) {
	      this.usuarioEditando = _.cloneDeep(row.item);
	      this.$forceUpdate();
	    },
	    excluirUsuarioNovo: function excluirUsuarioNovo(tempId) {
	      _.remove(this.listaUsuarios, ['tempId', tempId]);
	      this.tabelaUsuarios.numeroAtualizacao++;
	    },
	    salvarConfiguracoes: function salvarConfiguracoes(usuario) {
	      var _this5 = this;
	
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': usuario.configuracoes, 'id': usuario.id }).then(function (response) {
	        console.log('configuracoes salvo', usuario);
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this5.$root.trataErro(error);
	        }
	      });
	    },
	    permiteConcluir: function permiteConcluir() {
	      var _this6 = this;
	
	      console.log('backup', this.listaUsuariosBackup);
	      console.log('alterado', this.listaUsuarios);
	      var vm = this;
	      if (this.errors.items.length === 0) {
	        this.$validator.validateAll().then(function (validado) {
	          if (validado && _this6.errors.items.length === 0) {
	            _this6.listaUsuarios.forEach(function (usuario) {
	              _.set(usuario, 'configuracoes.acesso_projetos', _.get(usuario, 'configuracoes.acesso_projetos', []));
	              if (usuario.id !== 0) {
	                var acessoProjetoAtual = _.find(usuario.configuracoes.acesso_projetos, ['numero', _this6.projetoSelecionado.ds_codigo_projeto_erp]);
	                if (acessoProjetoAtual) {
	                  _.set(acessoProjetoAtual, 'acesso', usuario.acessos);
	                } else {
	                  _.set(usuario, 'configuracoes.acesso_projetos', [{ 'numero': _this6.projetoSelecionado.ds_codigo_projeto_erp, 'nome': _this6.projetoSelecionado.ds_nome, 'acesso': usuario.acessos }]);
	                }
	              } else {
	                _.set(usuario, 'configuracoes.acesso_projetos', [{ 'numero': _this6.projetoSelecionado.ds_codigo_projeto_erp, 'nome': _this6.projetoSelecionado.ds_nome, 'acesso': usuario.acessos }]);
	                _this6.listaProjetosEntidade.forEach(function (projeto) {
	                  if (!_.isNull(projeto.ds_codigo_projeto_erp) && projeto.ds_codigo_projeto_erp !== _this6.projetoSelecionado.ds_codigo_projeto_erp) {
	                    usuario.configuracoes.acesso_projetos.push({ 'numero': projeto.ds_codigo_projeto_erp, 'nome': projeto.ds_nome, 'acesso': [{ 'codigo': 'SEM_ACESSO', 'descricao': 'Sem Acesso' }] });
	                  }
	                });
	              }
	            });
	            var usuariosNovos = _.filter(_this6.listaUsuarios, ['id', 0]);
	            if (usuariosNovos.length > 0) {
	              _this6.$dialog.confirm('Há ' + usuariosNovos.length + ' usuário(s) novo(s). Após concluir, o sistema enviará e-mail com login e pedirá para eles criarem suas senhas pessoais', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	                vm.concluir();
	              }).catch(function () {});
	            } else {
	              _this6.concluir();
	            }
	          } else {
	            _this6.$snotify.error('Há ' + _this6.errors.items.length + ' item(ns) obrigatório(s) não preenchido(s)');
	          }
	        });
	      } else {
	        this.$snotify.error('Há ' + this.errors.items.length + ' item(ns) obrigatório(s) não preenchido(s)');
	      }
	    },
	    concluir: function concluir() {
	      var _this7 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('/usuarios/entidade/atualizar', { 'id': this.projetoSelecionado.fk_entidade, 'usuarios': this.listaUsuarios }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          response.data.retorno.incluido.forEach(function (usuario) {
	            _.set(_.find(_this7.listaUsuarios, ['tempId', usuario.tempId]), 'id', usuario.id);
	          });
	          _this7.$snotify.success('Processado com sucesso', { timeout: 3000 });
	          _this7.listaUsuariosBackup = _.cloneDeep(_this7.listaUsuarios);
	        } else {
	          _this7.$snotify.error(response.data.mensagem[0]);
	        }
	        _this7.loading.tela = false;
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this7.loading.tela = false;
	          _this7.$root.trataErro(error);
	        }
	      });
	    },
	    verificaLoginJaCadastrado: function verificaLoginJaCadastrado() {
	      var _this8 = this;
	
	      var verificar = { 'email': 'ds_email', 'login': 'ds_login' };
	      _.keys(verificar).forEach(function (campo) {
	        _.set(_this8.loading.verifica, [campo], true);
	        axiosLaravel.post('/verifica-usuario/', { 'parametro': verificar[campo], 'valor': _.get(_this8.usuarioEditando, [verificar[campo]]), 'idUsuario': _this8.usuarioEditando.id }).then(function (response) {
	          if (response.data.length > 0) {
	            var field = _this8.$validator.fields.find({ name: campo });
	            field.setFlags({ invalid: true });
	            _this8.errors.add({ field: campo, msg: 'Já em uso neste sistema. Informe outro.', id: field.id, scope: field.scope });
	          }
	          _.set(_this8.loading.verifica, [campo], false);
	          _this8.$forceUpdate();
	        }).catch(function (error) {
	          _.set(_this8.loading.verifica, [campo], false);
	          if (error) {
	            _this8.$root.trataErro(error);
	          }
	        });
	      });
	    },
	    filtroPorItem: function filtroPorItem(row, filter) {
	      var saida = true;
	      if (filter !== 'retornar_todos_registros') {
	        var termos = _.split(_.toLower(filter), ' ');
	        termos.forEach(function (termo) {
	          saida = saida && (_.toLower(row.ds_nome_usuario).indexOf(termo) !== -1 || _.toLower(row.ds_email).indexOf(termo) !== -1 || _.toLower(row.ds_login).indexOf(termo) !== -1 || ('' + row.ds_cpf).indexOf(termo) !== -1);
	        });
	      }
	      return saida;
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.tabelaUsuarios.totalRows = filteredItems.length;
	      this.tabelaUsuarios.currentPage = 1;
	      this.$forceUpdate();
	    },
	    ajustaPesquisa: function ajustaPesquisa() {
	      this.tabelaUsuarios.filter = _.isNull(this.pesquisa) || this.pesquisa === '' ? 'retornar_todos_registros' : this.pesquisa;
	    }
	  }
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _vue2Editor = __webpack_require__(2250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    VueEditor: _vue2Editor.VueEditor
	  },
	  name: 'ConfGerais',
	  data: function data() {
	    return {
	      config: [],
	      configUser: [],
	      usuariosLogados: [],
	      configuracao: [],
	      tipo_ant: '',
	      file: {},
	      data: [],
	      loading: {
	        show: false
	      },
	      selected1: '',
	      state: 'STATE_VIEW',
	      todosUsuarios: [],
	      usuariosPesquisa: [],
	      usersAdicionar: [],
	      selected: '',
	      perfil: [],
	      perfis: [],
	      documento: [],
	      documentos: [],
	      mostrar: {
	        isFrmEntityUserOpen: false,
	        isFrmAgencyUserOpen: false,
	        isFrmSuperUserOpen: false,
	        isFrmFbbUserOpen: false,
	        isFrmStrategicUserOpen: false,
	        isFrmAssignedProfileOpen: false,
	        isFrmCredentialOpen: false,
	        isFrmCredentialValidOpen: false,
	        isFrmProposalOpen: false,
	        isFrmSimplificadoOpen: false,
	        isFrmRequestOpen: false,
	        isFrmAcolhimentoOpen: false,
	        isFrmPreAnalysisProposalOpen: false,
	        isFrmAnalysisProposalOpen: false,
	        isFrmDocumentOpen: false
	      },
	      mimeTypes: [{ id: 1, ds_extensao: '.doc', ds_tipo_de_documento: 'Microsoft Word (DOC)', ds_mime_type: 'application/msword' }, { id: 2, ds_extensao: '.docx', ds_tipo_de_documento: 'Microsoft Word (DOCX)', ds_mime_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }, { id: 3, ds_extensao: '.gif', ds_tipo_de_documento: 'Graphi cs Interchange Format (GIF)', ds_mime_type: 'image/gif' }, { id: 4, ds_extensao: '.jpg', ds_tipo_de_documento: 'JPEG images (JPG)', ds_mime_type: 'image/jpeg' }, { id: 5, ds_extensao: '.png', ds_tipo_de_documento: 'Portable Network Graphics (PNG)', ds_mime_type: 'image/png' }, { id: 6, ds_extensao: '.pdf', ds_tipo_de_documento: 'Adobe Portable Document Format (PDF)', ds_mime_type: 'application/pdf' }, { id: 7, ds_extensao: '.ppt', ds_tipo_de_documento: 'Microsoft PowerPoint (PPT)', ds_mime_type: 'application/vnd.ms-powerpoint' }, { id: 8, ds_extensao: '.pptx', ds_tipo_de_documento: 'Microsoft PowerPoint (PPTX)', ds_mime_type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' }, { id: 9, ds_extensao: '.rtf', ds_tipo_de_documento: 'Rich Text Format (RTF)', ds_mime_type: 'application/rtf' }, { id: 10, ds_extensao: '.svg', ds_tipo_de_documento: 'Scalable Vector Graphics (SVG)', ds_mime_type: 'image/svg+xml' }, { id: 11, ds_extensao: '.rtf', ds_tipo_de_documento: 'Rich Text Format (RTF)', ds_mime_type: 'application/rtf' }, { id: 12, ds_extensao: '.tiff', ds_tipo_de_documento: 'Tagged Image File Format (TIFF)', ds_mime_type: 'image/tiff' }, { id: 13, ds_extensao: '.xls', ds_tipo_de_documento: 'Microsoft Excel (XLS)', ds_mime_type: 'application/vnd.ms-excel' }, { id: 14, ds_extensao: '.xlsx', ds_tipo_de_documento: 'Microsoft Excel (XLSX)', ds_mime_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }, { id: 15, ds_extensao: '.txt', ds_tipo_de_documento: 'Arquivo Texto (TXT)', ds_mime_type: 'text/plain' }],
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Configurações',
	        active: true
	      }]
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    this.buscaConfig();
	    this.buscaPerfil();
	    this.buscaDocumentos();
	  },
	  mounted: function mounted() {
	    this.assinaUsuariosLogados();
	    this.$forceUpdate();
	  },
	
	  methods: {
	    salva: function salva() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this.atualiza();
	          _this.updateDocumentType();
	        } else {
	          _this.errors.items.forEach(function (item) {
	            _this.$snotify.error(item.msg);
	          });
	        }
	      });
	    },
	    handleFileUpload: function handleFileUpload() {
	      this.file = this.$refs.file.files[0];
	    },
	    refresh: function refresh() {
	      this.$router.go(0);
	    },
	    updateDocumentType: function updateDocumentType() {
	      axios.put('/proxy/documents/type/:documentId/' + this.configuracao.requestConfig.advanceDefaultDocument.documentType.id).then(function (response) {});
	    },
	    onAdd: function onAdd() {
	      var _this2 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = 1;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      data.append('document', (0, _stringify2.default)(this.configuracao.requestConfig.advanceDefaultDocument));
	      axios.post('proxy/document/documents', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this2.documento = response.data.value;
	        _this2.documentos.push((0, _assign2.default)({}, _this2.documento));
	        _this2.salva();
	        _this2.changeToStateView();
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	      this.onCancel();
	    },
	    atualiza: function atualiza() {
	      var _this3 = this;
	
	      axiosLaravel.post('configuracoes/', this.configuracao).then(function (response) {
	        _this3.$snotify.success('Configuração salva com sucesso.');
	        _this3.mostrar.isFrmEntityUserOpen = false;
	        _this3.mostrar.isFrmAgencyUserOpen = false;
	        _this3.mostrar.isFrmSuperUserOpen = false;
	        _this3.mostrar.isFrmFbbUserOpen = false;
	        _this3.mostrar.isFrmStrategicUserOpen = false;
	        _this3.mostrar.isFrmAssignedProfileOpen = false;
	        _this3.mostrar.isFrmCredentialOpen = false;
	        _this3.mostrar.isFrmCredentialValidOpen = false;
	        _this3.mostrar.isFrmProposalOpen = false;
	        _this3.mostrar.isFrmSimplificadoOpen = false;
	        _this3.mostrar.isFrmRequestOpen = false;
	        _this3.mostrar.isFrmAcolhimentoOpen = false;
	        _this3.mostrar.isFrmPreAnalysisProposalOpen = false;
	        _this3.mostrar.isFrmAnalysisProposalOpen = false;
	        _this3.mostrar.isFrmDocumentOpen = false;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    assinaUsuariosLogados: function assinaUsuariosLogados() {
	      var _this4 = this;
	
	      this.loading.show = true;
	      Echo.leave('usuarios-logados');
	      window.Echo.join('usuarios-logados').here(function (users) {
	        _this4.usuariosLogados = users;
	        console.log('users', users);
	        _this4.carregaEntidadesDosLogados();
	        _this4.$forceUpdate();
	      }).joining(function (user) {
	        _this4.usuariosLogados.push(user);
	      }).leaving(function (user) {
	        _this4.usuariosLogados.splice(_this4.usuariosLogados.findIndex(function (logado) {
	          return logado.id === user.id;
	        }), 1);
	      });
	    },
	    carregaEntidadesDosLogados: function carregaEntidadesDosLogados() {
	      var _this5 = this;
	
	      this.usuariosLogados.forEach(function (usuario, i) {
	        if (!usuario.fk_entidade) {
	          return;
	        }
	        axiosLaravel.get('entidades/' + usuario.fk_entidade).then(function (response) {
	          _this5.$set(_this5.usuariosLogados[i], 'entidade', response.data);
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	        });
	      });
	    },
	    changeToStateNew: function changeToStateNew() {
	      this.state = 'STATE_NEW';
	    },
	    changeToStateView: function changeToStateView() {
	      this.state = 'STATE_VIEW';
	    },
	    onDownload: function onDownload() {
	      var _this6 = this;
	
	      this.progress = 0;
	      axios.get('proxy/document/documents/' + this.configuracao.requestConfig.advanceDefaultDocument.id + '/download', {
	        responseType: 'arraybuffer',
	        headers: {
	          'Content-Type': 'application/json'
	        }
	      }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data]);
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = _this6.configuracao.requestConfig.advanceDefaultDocument.fileName;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var _blob = new Blob([response.data], { type: _this6.configuracao.requestConfig.advanceDefaultDocument.contentType });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, _this6.configuracao.requestConfig.advanceDefaultDocument.fileName);
	          _link.download = _this6.configuracao.requestConfig.advanceDefaultDocument.fileName;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    changeToStateDownloading: function changeToStateDownloading() {
	      this.state = 'STATE_DOWNLOADING';
	    },
	    buscaConfig: function buscaConfig() {
	      var _this7 = this;
	
	      this.config = null;
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this7.config = (0, _stringify2.default)(response.data);
	        _this7.configUser = _this7.prepareData(response.data.configuracao_usuario_entidade);
	        _this7.configuracao = _this7.prepareData(response.data);
	        _this7.tipo_ant = _this7.configuracao.requestConfig.advanceDefaultDocument.fileName;
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    onCancel: function onCancel() {
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento = {};
	      this.file = null;
	      this.showGrid = true;
	      this.$forceUpdate();
	    },
	    buscaPerfil2: function buscaPerfil2() {
	      var _this8 = this;
	
	      this.perfis = null;
	      axios.get('proxy/account/profiles?tiny').then(function (response) {
	        _this8.perfis = response.data.value;
	        _this8.data = (0, _stringify2.default)(_this8.perfis);
	
	        _this8.selected = 'Entidade CNPJ';
	        _this8.selectedCpf = 'Entidade CPF';
	        _this8.usuariosPesquisa = [];
	        var temporario = { id: 0, userName: '' };
	        _this8.todosUsuarios.forEach(function (option) {
	          if (_this8.perfis.some(function (o) {
	            return o.id === option.id;
	          })) {} else {
	            temporario = { id: 0, name: '' };
	            temporario.id = option.id;
	            temporario.name = option.name;
	
	            _this8.usuariosPesquisa.push(temporario);
	          }
	        });
	      }).catch(function (error) {
	        _this8.$root.trataErro(error);
	      });
	    },
	    buscaPerfil: function buscaPerfil() {
	      var _this9 = this;
	
	      this.perfis = null;
	      axiosLaravel.get('perfis/').then(function (response) {
	        _this9.perfis = response.data;
	        _this9.data = (0, _stringify2.default)(_this9.perfis);
	
	        _this9.selected = 'Entidade CNPJ';
	        _this9.selectedCpf = 'Entidade CPF';
	        _this9.usuariosPesquisa = [];
	        var temporario = { id: 0, ds_nome: '' };
	        _this9.todosUsuarios.forEach(function (option) {
	          if (_this9.perfis.some(function (o) {
	            return o.id === option.id;
	          })) {} else {
	            temporario = { id: 0, name: '' };
	            temporario.id = option.id;
	            temporario.ds_nome = option.ds_nome;
	
	            _this9.usuariosPesquisa.push(temporario);
	          }
	        });
	      }).catch(function (error) {
	        _this9.$root.trataErro(error);
	      });
	    },
	    buscaDocumentos: function buscaDocumentos() {
	      var _this10 = this;
	
	      this.documentos = null;
	      if (this.localUso === undefined) {
	        this.localUso = 'TODOS';
	      }
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this10.documentos = response.data;
	        _this10.loading.show = false;
	      }).catch(function (error) {
	        _this10.$root.trataErro(error);
	      });
	    },
	    prepareData: function prepareData(data) {
	      if (!data) {
	        data = {};
	      }
	      if (!data.assignedProfileConfig) {
	        data.assignedProfileConfig = {};
	        data.assignedProfileConfig.managerProfiles = [];
	      }
	      if (!data.configuracao_usuario_entidade) {
	        data.configuracao_usuario_entidade = {};
	        data.configuracao_usuario_entidade.documentos_obrigatorios = [];
	      }
	      if (!data.entitySimplificadoConfig) {
	        data.entitySimplificadoConfig = {};
	        data.entitySimplificadoConfig.documentTypes = [];
	      }
	      if (!data.proposalConfig) {
	        data.proposalConfig = {};
	        data.proposalConfig.documentTypes = [];
	      }
	      if (!data.simplificadoConfig) {
	        data.simplificadoConfig = {};
	        data.simplificadoConfig.documentTypes = [];
	      }
	      if (!data.requestConfig) {
	        data.requestConfig = {};
	      }
	      if (!data.documentConfig) {
	        data.documentConfig = {};
	        data.documentConfig.mimeTypes = [];
	      }
	      return data;
	    }
	  }
	};

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'LogEmails',
	  data: function data() {
	    return {
	      data: [],
	      items: [],
	      loading: {
	        show: false
	      },
	      isBusy: false,
	      bordered: true,
	      fields: [{ key: 'ds_assunto', label: 'Assunto', sortable: true, thStyle: 'width: 10%; text-align: center', class: 'word-wrap:break-word text-center' }, { key: 'ds_destinatario', label: 'Destinatário', sortable: true, thStyle: 'width: 20%; text-align: center', class: 'word-wrap:break-word text-center' }, { key: 'ds_conteudo', label: 'Conteúdo', sortable: true, thStyle: 'width: 40%; text-align: center', class: 'word-wrap:break-word text-center' }, { key: 'dt_criado', label: 'Data de Inclusão', sortable: true, thStyle: 'text-align: center', class: 'word-wrap:break-word text-center' }, { key: 'ds_sucesso', label: 'Sucesso', sortable: true, thStyle: 'width: 4%; text-align: center', class: 'word-wrap:break-word text-center' }, { key: 'ds_desc_erro', label: 'Descrição do Erro', sortable: true, thStyle: 'width: 20%; text-align: center', class: 'text-center' }],
	      table: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar'
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Configurações',
	        active: true
	      }]
	    };
	  },
	
	  computed: {
	    sortOptions: function sortOptions() {
	      return this.fields.table.filter(function (f) {
	        return f.sortable;
	      }).map(function (f) {
	        return { text: f.label, value: f.key };
	      });
	    }
	  },
	  created: function created() {
	    this.onSearch();
	  },
	  mounted: function mounted() {},
	  methods: {
	    onSearch: function onSearch(data) {
	      var _this = this;
	
	      this.loading.show = true;
	      this.isBusy = true;
	      axiosLaravel.get('emails?page=' + data).then(function (response) {
	        _this.items = response.data.data;
	        _this.table.totalRows = response.data.total;
	        _this.table.perPage = response.data.per_page;
	        _this.loading.show = false;
	        _this.isBusy = false;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.isBusy = false;
	        if (error) {
	          _this.$root.trataErro(error);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'gantt',
	  data: function data() {
	    return {};
	  },
	
	  props: ['periodo', 'propsObjetivos', 'atividades'],
	  computed: {
	    propsObjetivos: function propsObjetivos() {
	      var _this = this;
	
	      if (this.propsObjetivos.length > 0) {
	        this.propsObjetivos.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  _this.atividades.push(atividade);
	                });
	              }
	            });
	          }
	        });
	      }
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'agencia-condutora-projeto',
	  data: function data() {
	    return {
	      agencias: [],
	      loading: {
	        show: false
	      },
	      mostrar: true,
	      agenciaSelecionada: [],
	      proposta: {}
	    };
	  },
	
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  props: ['propsProposta'],
	  mounted: function mounted() {
	    this.proposta = this.propsProposta;
	    if (this.propsProposta.ds_agencia_nome) {
	      this.mostrar = false;
	    }
	  },
	
	  watch: {
	    propsProposta: function propsProposta() {
	      this.proposta = this.propsProposta;
	      if (this.propsProposta.ds_agencia_nome) {
	        this.mostrar = false;
	      }
	    }
	  },
	  methods: {
	    buscaAgencias: function buscaAgencias(searchQuery) {
	      var _this = this;
	
	      var filter = null;
	      if (searchQuery) {
	        filter = searchQuery;
	      }
	      this.loading.show = true;
	      axiosLaravel.get('agencias/', filter).then(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(response) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  console.log('response.data', response.data);
	                  _this.agencias = response.data;
	                  _this.loading.show = false;
	
	                case 3:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }()).catch(function (error) {
	        console.log('error', error);
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    },
	    buscaAgencia: function buscaAgencia(agencia) {
	      var _this2 = this;
	
	      var parm = '';
	      if (agencia === undefined || agencia === 'undefined') {
	        parm = this.propsProposta.ds_agencia_nome;
	      } else {
	        parm = agencia.ds_codigo_agencia;
	      }
	      console.log('agencia.ds_codigo_agencia', parm);
	      axiosLaravel.get('agencia/' + parm).then(function (response) {
	        var agencia = response.data;
	        _this2.proposta.ds_agencia_endereco = agencia.logradouro;
	        _this2.proposta.ds_agencia_cnpj = agencia.cnpj;
	        _this2.proposta.ds_agencia_email = agencia.CodAge.substr(0, agencia.CodAge.indexOf('-')) + '@BB.COM.BR';
	        _this2.proposta.ds_agencia_nome = agencia.CodAge.substr(0, agencia.CodAge.indexOf('-'));
	        _this2.proposta.ds_agencia_telefone = agencia.ddd + '' + agencia.fone;
	        _this2.proposta.ds_gerente_cidade = agencia.nome1;
	        _this2.proposta.ds_gerente_estado_civil = agencia.ec_adm;
	        _this2.proposta.ds_gerente_cpf = agencia.cpf;
	        _this2.proposta.ds_gerente_nome = agencia.nome;
	        _this2.proposta.ds_gerente_nacionalidade = 'Brasileiro';
	        _this2.proposta.ds_gerente_profissao = 'Bancário';
	        _this2.proposta.ds_gerente_rg = agencia.rg_adm.split(' - ')[0];
	        _this2.proposta.ds_gerente_orgao_emissor = agencia.rg_adm.split(' - ')[1];
	        _this2.proposta.ds_gerente_rg_uf = agencia.rg_adm.split(' - ')[2].replace(/\s/g, '');
	        _this2.proposta.ds_gerente_uf = agencia.uf;
	
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	
	        _this2.$snotify.error('Erro ao localizar agência!');
	        _this2.proposta.ds_agencia_endereco = '';
	        _this2.proposta.ds_agencia_cnpj = '';
	        _this2.proposta.ds_agencia_email = '';
	        _this2.proposta.ds_agencia_nome = '';
	        _this2.proposta.ds_agencia_telefone = '';
	        _this2.proposta.ds_gerente_cidade = '';
	        _this2.proposta.ds_gerente_estado_civil = '';
	        _this2.proposta.ds_gerente_cpf = '';
	        _this2.proposta.ds_gerente_nome = '';
	        _this2.proposta.ds_gerente_nacionalidade = '';
	        _this2.proposta.ds_gerente_profissao = '';
	        _this2.proposta.ds_gerente_rg = '';
	        _this2.proposta.ds_gerente_orgao_emissor = '';
	        _this2.proposta.ds_gerente_rg_uf = '';
	        _this2.proposta.ds_gerente_uf = '';
	      });
	    },
	    numeroNomeAgencia: function numeroNomeAgencia(_ref2) {
	      var ds_codigo_agencia = _ref2.ds_codigo_agencia,
	          ds_nome = _ref2.ds_nome;
	
	      return ds_codigo_agencia + ' / ' + ds_nome;
	    },
	    selectFuncionario: function selectFuncionario(matricula) {
	      var _this3 = this;
	
	      axiosLaravel.get('funci/' + matricula).then(function (response) {
	        console.log('response.data', response.data);
	        var funcionario = response.data;
	        _this3.proposta.ds_funcionario_nome = funcionario.nome;
	        _this3.proposta.ds_funcionario_telefone = funcionario.ddd + '' + funcionario.fone;
	        _this3.proposta.ds_funcionario_email = 'F' + funcionario.matr_func + '@bb.com.br';
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'agenciaIndicativo',
	  data: function data() {
	    return {
	      editando: false,
	      gravando: false,
	      consultando: false,
	      consultaAgencia: '',
	      agenciaSelecionada: {
	        agencia: '',
	        nomeAgencia: '',
	        emailAgencia: '',
	        informacoesGerenteGeral: {
	          nome: '[NOME DO GERENTE]',
	          cpf: '[000.000.000-00]',
	          estadoCivil: '[ESTADO CIVIL GERENTE]',
	          municipioResidencia: '[MUNICIPIO RESIDENCIA GERENTE]',
	          email: '[EMAIL GERENTE]'
	        }
	      }
	    };
	  },
	
	  props: ['proposta', 'agenciaSelecionadaProp'],
	  watch: {
	    agenciaSelecionadaProp: function agenciaSelecionadaProp(newVal) {
	      if (newVal !== null) {
	        this.agenciaSelecionada = newVal;
	      }
	      console.log('Alterou agenciaSelecionada', newVal);
	    }
	  },
	  computed: {},
	  created: function created() {
	    this.debouncedConsultaDetalhesAgencia = _.debounce(this.consultaDetalhesAgencia, 500);
	    if (this.agenciaSelecionadaProp !== null) {
	      this.agenciaSelecionada = this.agenciaSelecionadaProp;
	    }
	  },
	
	  methods: {
	    digitandoAgencia: function digitandoAgencia() {
	      if (this.consultaAgencia === '') {
	        this.agenciaSelecionada = {
	          agencia: '',
	          nomeAgencia: '',
	          emailAgencia: '',
	          informacoesGerenteGeral: {
	            nome: '[NOME DO GERENTE]',
	            cpf: '[000.000.000-00]',
	            estadoCivil: '[ESTADO CIVIL GERENTE]',
	            municipioResidencia: '[MUNICIPIO RESIDENCIA GERENTE]',
	            email: '[EMAIL GERENTE]'
	          }
	        };
	      }
	      if (this.consultaAgencia.length < 4) {
	        return;
	      }
	      this.consultando = true;
	      this.debouncedConsultaDetalhesAgencia();
	    },
	    verificaSelecaoAgencia: function verificaSelecaoAgencia() {
	      if (this.agenciaSelecionada.agencia === '') {
	        this.$snotify.error('Indique a agência pretendida para abertura de conta do projeto. Favor Verificar.');
	        return false;
	      }
	      return true;
	    },
	    consultaDetalhesAgencia: function consultaDetalhesAgencia() {
	      var _this = this;
	
	      console.log('Consultando agencia');
	      axiosLaravel.get('testemunha/getAgenciaGerente/' + this.consultaAgencia).then(function (response) {
	        var agenciaInfo = response.data;
	        console.log(response.data);
	        _this.agenciaSelecionada.agencia = agenciaInfo.ds_codigo_agencia;
	        _this.agenciaSelecionada.nomeAgencia = agenciaInfo.ds_nome;
	        _this.agenciaSelecionada.emailAgencia = agenciaInfo.ds_email;
	        console.log('AGENCIA SELECIONADA', _this.agenciaSelecionada);
	        _this.proposta.agenciaSelecionada = _this.agenciaSelecionada;
	        _this.consultando = false;
	      }).catch(function (error) {
	        _this.consultando = false;
	        console.error(error);
	      });
	    }
	  }
	};

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'arvore-projeto',
	  data: function data() {
	    return {
	      projetos: [],
	      projetoSelecionado: {},
	      arvoreProjetos: [],
	      projetoDuplicacao: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    axios.get('proxy/project/project-tree/list').then(function (response) {
	      _this.arvoreProjetos = response.data.value;
	      _this.arvoreProjetos.forEach(function (projeto) {
	        projeto.show = false;
	      });
	    }).catch(function (error) {
	      console.log(error);
	      _this.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    mostraFilhos: function mostraFilhos(projeto) {
	      projeto.show = !projeto.show;
	      this.$forceUpdate();
	    },
	    selecionaPai: function selecionaPai(projeto) {
	      delete projeto.show;
	      this.projetoSelecionado = projeto;
	      this.$emit('selecionaProjeto', projeto);
	    },
	    selecionaFilho: function selecionaFilho(filho) {
	      this.projetoSelecionado = filho;
	      this.$emit('selecionaProjeto', filho);
	    }
	  }
	};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'assinaturaDirigentes',
	  data: function data() {
	    return {
	      showgrid: true,
	      adicionando: false,
	      bloqueioCampos: false,
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 50,
	        fields: [{ key: 'ds_nome', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'dt_inicio_mandato', label: 'Inicio do mandato', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'dt_fim_mandato', label: 'Vigência do mandato', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      dirigentesParaAdicionar: [],
	      dirigentesAdicionados: [],
	      dirigenteSelecionado: ''
	    };
	  },
	
	  props: ['visualiza'],
	  watch: {},
	  'table.items': function tableItems() {
	    this.$emit('dirigenteAdicionado', this.table.items);
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel']), {
	    rows: function rows() {
	      return this.table.items.length;
	    }
	  }),
	  created: function created() {
	    console.log('CREATED ASSINATURA', this.$route.params.id);
	    if (this.$route.params.id) {
	      this.loading.show = true;
	      this.consultaDirigentesAssinatura();
	      this.consultaDirigentesCadastrados();
	    }
	  },
	
	  methods: {
	    onNew: function onNew() {
	      this.adicionando = true;
	      this.dirigenteSelecionado = '';
	    },
	    consultaDirigentesAssinatura: function consultaDirigentesAssinatura() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('Consulta dirigentes para assinar  : ', _this.$route.params.id);
	                _context.next = 3;
	                return axiosLaravel.get('simplificado/dirigentesQuePodemAssinar/' + _this.$route.params.id).then(function (response) {
	                  console.log(response.data);
	                  _this.dirigentesParaAdicionar = response.data;
	                }).catch(function (error) {
	                  _this.loading.show = false;
	                  _this.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    consultaDirigentesCadastrados: function consultaDirigentesCadastrados() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return axiosLaravel.get('simplificado/indexAssinatura/' + _this2.$route.params.id).then(function (response) {
	                  _this2.table.items = response.data;
	                  _this2.dirigentesAdicionados = response.data;
	                  _this2.loading.show = false;
	                }).catch(function (error) {
	                  _this2.loading.show = false;
	                  _this2.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    onAdd: function onAdd() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var dirigenteJaAdicionado, obj;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                dirigenteJaAdicionado = _this3.dirigentesAdicionados.some(function (dirigente) {
	                  return dirigente.id === _this3.dirigenteSelecionado.id;
	                });
	
	                if (!dirigenteJaAdicionado) {
	                  _context3.next = 5;
	                  break;
	                }
	
	                _this3.$snotify.error('Dirigente / Designado já se encontra cadastrado na lista. Favor Verificar .');
	                _context3.next = 10;
	                break;
	
	              case 5:
	                _this3.table.items.push(_this3.dirigenteSelecionado);
	
	                _this3.loading.show = true;
	                obj = {
	                  fk_entidade: _this3.$route.params.id,
	                  fk_dirigente: _this3.dirigenteSelecionado.id,
	                  responsavel: _this3.usuarioLogado.ds_login + ' ' + _this3.usuarioLogado.ds_nome_usuario
	                };
	                _context3.next = 10;
	                return axiosLaravel.post('simplificado/gravaEntidadeDirigente/', obj).then(function (response) {
	                  _this3.loading.show = false;
	                  _this3.$snotify.success(response.data);
	                  _this3.dirigenteSelecionado = '';
	                  _this3.adicionando = false;
	                }).catch(function (error) {
	                  _this3.loading.show = false;
	                  _this3.$root.trataErro(error);
	                });
	
	              case 10:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    exclui: function exclui(row) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                console.log(row.item);
	                _this4.table.items.splice(row.index, 1);
	                _this4.loading.show = true;
	                obj = {
	                  fk_entidade: _this4.$route.params.id,
	                  fk_dirigente: row.item.id,
	                  responsavel: _this4.usuarioLogado.ds_login + ' ' + _this4.usuarioLogado.ds_nome_usuario
	                };
	
	                console.log(obj);
	                _context4.next = 7;
	                return axiosLaravel.post('simplificado/excluirEntidadeDirigente/', obj).then(function (response) {
	                  _this4.loading.show = false;
	                  _this4.$snotify.success(response.data);
	                }).catch(function (error) {
	                  _this4.loading.show = false;
	                  _this4.$root.trataErro(error);
	                });
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this4);
	      }))();
	    }
	  }
	};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _trunc = __webpack_require__(108);
	
	var _trunc2 = _interopRequireDefault(_trunc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'atividades',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsAtividades,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 100,
	        fields: [{ key: 'metas', label: 'Metas', sortable: true, thStyle: 'text-align: center; width: 30%;', class: 'text-left' }, { key: 'ds_nome', label: 'Atividades', sortable: true, thStyle: 'text-align: center; width: 30%;', class: 'text-left' }, { key: 'ds_documento_comprobatorio', label: 'Documento comprobatório', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_periodo_inicial', label: 'Início', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_periodo_final', label: 'Fim', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      meta: {},
	      metaIndex: [],
	      formasContratacao: [],
	      editando: null,
	      formEditavel: false,
	      indexEdit: 0,
	      atividadeForm: {
	        nr_periodo_final: null,
	        itens_orcamentos: [],
	        metas: {},
	        ds_nome: '',
	        nr_periodo_inicial: null,
	        ds_documento_comprobatorio: ''
	      },
	      numeracaoAtividadeNova: 0,
	      terminoAtividade: 1,
	      inicioAtividade: 1,
	      periodoProjeto: 1
	    };
	  },
	
	  props: ['propsObjetivos', 'propsMetas', 'propsAtividades', 'meses', 'propsProposta', 'editavel', 'novaAtividade', 'propsPropostaBackup', 'modoVisualizacaoAlteracoes', 'atualizar', 'processoSolicitacao'],
	  computed: {
	    altera: function altera() {
	      var _this = this;
	
	      for (var i = 0; i < this.propsMetas.length; i++) {
	        for (var j = 0; j < this.propsAtividades.length; j++) {
	          for (var x = 0; x < this.propsAtividades[j].metas.length; x++) {
	            if (this.propsMetas[i].id === this.propsAtividades[j].metas[x].id) {
	              this.propsAtividades[j].metas[x] = _.cloneDeep(this.propsMetas[i]);
	            }
	          }
	        }
	      }
	      this.$nextTick(function () {
	        _this.table.items = _this.propsAtividades;
	      });
	      this.$forceUpdate();
	    }
	  },
	  watch: {
	    propsAtividades: function propsAtividades() {
	      var _this2 = this;
	
	      this.table.items = this.propsAtividades;
	      this.metas = this.propsMetas;
	      this.table.items.forEach(function (atividade) {
	        if (_this2.ehAtividadeNova(atividade)) {
	          _this2.numeracaoAtividadeNova++;
	        }
	      });
	    },
	    atualizar: function atualizar() {
	      this.$forceUpdate();
	    },
	    propsMetas: function propsMetas() {
	      var _this3 = this;
	
	      for (var i = 0; i < this.propsMetas.length; i++) {
	        for (var j = 0; j < this.propsAtividades.length; j++) {
	          for (var x = 0; x < this.propsAtividades[j].metas.length; x++) {
	            if (this.propsMetas[i].id === this.propsAtividades[j].metas[x].id) {
	              this.propsAtividades[j].metas[x].ds_descricao = _.cloneDeep(this.propsMetas[i].ds_descricao);
	            }
	          }
	        }
	      }
	      this.$nextTick(function () {
	        _this3.table.items = _this3.propsAtividades;
	      });
	      this.$forceUpdate();
	    },
	    editavel: function editavel() {
	      this.formEditavel = this.editavel;
	    },
	    showgrid: function showgrid() {
	      this.$emit('validacaoAtividades', { 'tag': 'atividadeEditando', 'ativo': !this.showgrid, 'tipo': 'restricao', 'acao': null, 'mensagem': '<span class=\'restricaoEditandoInformacao\'>Atividade em edição<span>' });
	    },
	    novaAtividade: function novaAtividade() {
	      this.inserirAtividade();
	    },
	    'table.items': function tableItems() {
	      this.$emit('atividadeAdicionada', this.table.items);
	    }
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    this.formEditavel = this.editavel;
	    if (!this.formEditavel) {
	      this.table.fields = _.reject(this.table.fields, { key: 'actions' });
	    }
	  },
	  methods: {
	    alteraPeriodo: function alteraPeriodo() {
	      this.inicioAtividade = _.get(this.atividadeForm, 'nr_periodo_inicial', 1);
	      this.terminoAtividade = _.get(this.atividadeForm, 'nr_periodo_final', parseInt(this.propsProposta.nr_periodos));
	      this.periodoProjeto = this.meses;
	    },
	    onCancel: function onCancel() {
	      this.metaIndex = [];
	      this.atividadeForm = {};
	      this.showgrid = true;
	      this.editando = null;
	    },
	    reajustarItensNoPeriodo: function reajustarItensNoPeriodo(inicio, termino, item) {
	      console.log(' >>> reajustarItensNoPeriodo (inicio, termino, item)', inicio, termino, item);
	
	      var itemTipo = ('' + item.fk_itens).substr(0, 1);
	      var itemOrigem = ('' + item.origem).substr(0, 1);
	      var mensalizacao = _.get(item, 'orcamentos_mensalizados', []);
	      if (mensalizacao.length > 0) {
	        var mensalizacaoAgrupada = _.groupBy(mensalizacao, 'fk_itens_orcamentos');
	        var novaMensalizacao = [];
	        _.forEach(mensalizacaoAgrupada, function (periodos, fkProcesso) {
	          var totalValor = _.sumBy(periodos, 'valor');
	          var totalQuantidade = _.sumBy(periodos, 'quantidade');
	          if (itemOrigem === '2') {
	            novaMensalizacao.push({ 'id': null, 'periodo': termino, 'quantidade': totalQuantidade, 'valor': totalValor, 'fk_itens_orcamentos': item.id });
	            console.log('     Contrapartida', { 'id': null, 'periodo': termino, 'quantidade': totalQuantidade, 'valor': totalValor, 'fk_itens_orcamentos': item.id });
	          } else if (itemTipo === 'P') {
	            novaMensalizacao.push({ 'id': null, 'periodo': inicio, 'quantidade': totalQuantidade, 'valor': totalValor, 'fk_itens_orcamentos': item.id });
	            console.log('     Produto', { 'id': null, 'periodo': inicio, 'quantidade': totalQuantidade, 'valor': totalValor, 'fk_itens_orcamentos': item.id });
	          } else if (itemTipo === 'S') {
	            var numeroPeriodos = termino - inicio + 1;
	            var valorRateio = (0, _trunc2.default)(totalValor / numeroPeriodos);
	            var quantidadeRateio = Math.round(totalQuantidade / numeroPeriodos * 100) / 100;
	            console.log('     Servico');
	            console.log('        numeroPeriodos', numeroPeriodos);
	            console.log('        valorRateio', valorRateio);
	            console.log('        quantidadeRateio', quantidadeRateio);
	
	            for (var i = inicio; i <= termino; i++) {
	              if (termino === i) {
	                valorRateio = totalValor - valorRateio * (numeroPeriodos - 1);
	                quantidadeRateio = totalQuantidade - quantidadeRateio * (numeroPeriodos - 1);
	              }
	              novaMensalizacao.push({ 'id': null, 'periodo': i, 'quantidade': quantidadeRateio, 'valor': valorRateio, 'fk_itens_orcamentos': item.id });
	              console.log('        mensalização rateio', { 'id': null, 'periodo': i, 'quantidade': quantidadeRateio, 'valor': valorRateio, 'fk_itens_orcamentos': item.id });
	            }
	          } else {
	            alert('Algo de errado com o item #' + item.id);
	            console.log('Verificar erro com o item', item);
	          }
	        });
	        mensalizacao = novaMensalizacao;
	        console.log('mensalização', mensalizacao);
	      }
	      return item;
	    },
	    onAdd: function onAdd() {
	      var _this4 = this;
	
	      var atividadeBackup = this.table.items[this.indexEdit] || { nr_periodo_final: null, itens_orcamentos: [], metas: {}, ds_nome: '', nr_periodo_inicial: null, ds_documento_comprobatorio: '' };
	
	      if (!_.isEqualWith(atividadeBackup, this.atividadeForm, function (a, b) {
	        return '' + a.nr_periodo_inicial === '' + b.nr_periodo_inicial && '' + a.nr_periodo_final === '' + b.nr_periodo_final;
	      })) {
	        var periodoInicial = _.toNumber(this.atividadeForm.nr_periodo_inicial);
	        var periodoFinal = _.toNumber(this.atividadeForm.nr_periodo_final);
	        if (_.get(this.atividadeForm, 'itens_orcamentos', []).length > 0) {
	          this.atividadeForm.itens_orcamentos.forEach(function (item) {
	            item = _this4.reajustarItensNoPeriodo(periodoInicial, periodoFinal, item);
	          });
	        }
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_.isNull(_this4.atividadeForm.id)) {
	            _this4.atividadeForm.metas = _this4.metaIndex;
	            _.set(_this4.atividadeForm, 'id', 'novo-' + _this4.numeracaoAtividadeNova++);
	            _this4.table.items.push(_this4.atividadeForm);
	          } else {
	            var idxAtividadeEditando = _this4.indexEdit;
	            _this4.atividadeForm.metas = _this4.metaIndex;
	            _.set(_this4.table, ['items', idxAtividadeEditando], _this4.atividadeForm);
	            _this4.$forceUpdate();
	
	            var items = _.cloneDeep(_this4.table.items);
	            _this4.table.items = items;
	            _this4.$emit('atividadeAdicionada', _this4.table.items);
	          }
	          _this4.onCancel();
	          _this4.$emit('acaoAtualizaSolicitacoes', new Date());
	          _this4.$forceUpdate();
	        }
	      });
	    },
	    exclui: function exclui(row) {
	      if (_.has(row.item, 'itens_orcamentos') && row.item.itens_orcamentos.length > 0) {
	        this.$snotify.error('A Atividade não pode ser excluída pois possui ' + row.item.itens_orcamentos.length + ' item(s) vinculado(s).');
	      } else {
	        this.table.items.splice(row.index, 1);
	      }
	    },
	    inserirAtividade: function inserirAtividade() {
	      this.metaIndex = [];
	      this.atividadeForm = { id: null, itens_orcamentos: [] };
	      this.showgrid = false;
	      this.editando = true;
	      this.alteraPeriodo();
	    },
	    ehAtividadeNova: function ehAtividadeNova(atividade) {
	      return _.includes('' + atividade.id, 'novo');
	    },
	    edita: function edita(row) {
	      this.indexEdit = row.index;
	      this.metaIndex = row.item.metas;
	
	      this.atividadeForm = (0, _assign2.default)({}, row.item);
	
	      this.showgrid = false;
	      this.editando = true;
	      this.alteraPeriodo();
	    },
	    ehItemNovo: function ehItemNovo(item) {
	      return !_.has(item, 'id') || _.includes(_.get(item, 'id', ''), 'novo') || _.find(_.get(this.processoSolicitacao, 'inclusao', []), ['id', item.id]);
	    },
	    ehItemExcluido: function ehItemExcluido(item) {
	      return _.includes(_.get(this.processoSolicitacao, 'exclusao', []), item.id);
	    },
	    modificacaoLinha: function modificacaoLinha(item, type) {
	      if (!item || type !== 'row') return;
	      if ('' + this.modoVisualizacaoAlteracoes === 'DETALHADO') {
	        if (this.ehItemNovo(item)) return 'modificacaoInclusao';
	        if (this.ehItemExcluido(item)) return 'modificacaoExlusao';
	      }
	    }
	  }
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'atividades',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsObjetivos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'description', label: 'Objetivo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.description', label: 'Meta do Projeto', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.quantity', label: 'Meta Orçada', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.measurementUnit', label: 'Unidade de medida', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.duration', label: 'Duração', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.performanceIndicators', label: 'Indicador', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      meta: {},
	      formasContratacao: [],
	      editando: null,
	      atividadeForm: {
	        finalPeriod: null,
	        items: [],
	        name: '',
	        startPeriod: null,
	        supportingDocument: ''
	      },
	      atividadeTabela: {},
	      metaIndex: null,
	      rules: 'required|min_value:1|max_value:' + this.meses
	    };
	  },
	
	  props: ['propsObjetivos', 'meses'],
	  computed: {
	    metas: function metas() {
	      var metas = [];
	      this.propsObjetivos.forEach(function (objetivo) {
	        objetivo.goals.forEach(function (meta) {
	          metas.push(meta);
	        });
	      });
	      return metas;
	    }
	  },
	  watch: {
	    propsObjetivos: function propsObjetivos() {
	      this.table.items = this.propsObjetivos;
	    },
	    'table.items': function tableItems() {
	      this.$emit('metaAdicionada', this.table.items);
	      this.$emit('atv', this.propsObjetivos);
	    }
	  },
	  mounted: function mounted() {},
	  methods: {
	    onCancel: function onCancel() {
	      this.meta = {};
	      this.atividadeForm = {};
	      this.showgrid = true;
	      this.editando = null;
	    },
	    onAdd: function onAdd(meta) {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this.editando === true) {
	            for (var i in _this.atividadeForm) {
	              _this.atividadeTabela[i] = _this.atividadeForm[i];
	            }
	          } else {
	            if (!meta.hasOwnProperty('activities')) {
	              meta.activities = [];
	            }
	            meta.activities.push(_this.atividadeForm);
	          }
	          _this.onCancel();
	        }
	      });
	    },
	    exclui: function exclui(meta, atividadeIndex) {
	      meta.activities.splice(atividadeIndex, 1);
	    },
	    edita: function edita(atividade, meta) {
	      this.meta = meta;
	
	      this.atividadeForm = (0, _assign2.default)({}, atividade);
	
	      this.atividadeTabela = atividade;
	      this.showgrid = false;
	      this.editando = true;
	    }
	  }
	};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'indicativoLicencas',
	  components: {},
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      loading: {
	        show: false
	      },
	      indicativo: 'Pendente de Preenchimento',
	      indicativoCodigo: '',
	      questoes: [],
	      respostasProposta: ['', '', '', '', '', '', ''],
	      respostasString: ['', '', '', '', '', '', ''],
	      pontuacaoTotal: 0
	    };
	  },
	
	  props: {
	    idProposta: Number,
	    resultadoAprovacao: String,
	    proximaEtapa: String
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    respostasProposta: function respostasProposta() {
	      this.calcularPontuacao();
	    },
	    indicativoCodigo: function indicativoCodigo(newVal) {
	      this.$emit('indicativo-codigo-updated', newVal);
	    },
	    idProposta: function idProposta() {
	      this.carregarPontuacao();
	    }
	  },
	  mounted: function mounted() {
	    this.consultaQuestoes();
	  },
	  methods: {
	    consultaQuestoes: function consultaQuestoes() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('Consulta questões');
	                _this.loading.show = true;
	                _context.next = 4;
	                return axiosLaravel.get('/avaliacao/questoes/').then(function (response) {
	                  console.log(response.data);
	                  _this.questoes = response.data;
	                  _this.loading.show = false;
	                  _this.carregarPontuacao();
	                  return true;
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                  _this.$snotify.clear();
	                  _this.$snotify.error(error);
	                  _this.loading.show = false;
	                  return false;
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    statusClass: function statusClass(indicativo) {
	      if (indicativo === 'Pendente de Preenchimento') {
	        return 'questoes-pendente';
	      }
	      if (indicativo === 'Indicado para avaliação preferencialmente pela Proponente') {
	        return 'questoes-indicado';
	      }
	      if (indicativo === 'Indicado para avaliação pela FBB') {
	        return 'questoes-indicado';
	      }
	      if (indicativo === 'Não indicado para avaliação') {
	        return 'questoes-nao-indicado';
	      }
	    },
	    calcularPontuacao: function calcularPontuacao() {
	      var _this2 = this;
	
	      if (this.respostasProposta.includes('')) {
	        this.indicativo = 'Pendente de Preenchimento';
	        return;
	      }
	      var pontuacaoTotal = this.respostasProposta.map(function (valor, index) {
	        if (valor === '' || valor === 'sim' || valor === 'não') {
	          return 0;
	        }
	
	        return parseFloat(valor) * _this2.questoes[index].pergunta.peso;
	      }).reduce(function (total, valor) {
	        return total + valor;
	      }, 0);
	
	      this.pontuacaoTotal = pontuacaoTotal;
	
	      if (this.pontuacaoTotal > 13 && this.respostasProposta[6] === 'sim') {
	        this.indicativo = 'Indicado para avaliação preferencialmente pela Proponente';
	        this.indicativoCodigo = '2';
	      }
	      if (this.pontuacaoTotal > 13 && this.respostasProposta[6] === 'não') {
	        this.indicativo = 'Indicado para avaliação pela FBB';
	        this.indicativoCodigo = '1';
	      }
	      if (this.pontuacaoTotal <= 13) {
	        this.indicativo = 'Não indicado para avaliação';
	        this.indicativoCodigo = '3';
	      }
	    },
	    carregarPontuacao: function carregarPontuacao() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('CARREGANDO PONTUAÇÃO ...', _this3.idProposta);
	
	                if (!(_this3.idProposta === undefined)) {
	                  _context2.next = 3;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 3:
	                console.log('Consulta questões');
	                _this3.loading.show = true;
	                _context2.next = 7;
	                return axiosLaravel.get('/avaliacao/carregarRespostas/' + _this3.idProposta).then(function (response) {
	                  if (!_.isEmpty(response.data)) {
	                    _this3.initRespostas(response.data);
	                  }
	                  _this3.loading.show = false;
	                }).catch(function (error) {
	                  _this3.$root.trataErro(error);
	                  _this3.$snotify.clear();
	                  _this3.$snotify.error(error);
	                  _this3.loading.show = false;
	                });
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    },
	    initRespostas: function initRespostas(valores) {
	      var _this4 = this;
	
	      console.log('initRespostas', valores);
	      this.respostasProposta.forEach(function (resposta, index) {
	        console.log(valores[index].pontuacao);
	        _this4.respostasProposta[index] = valores[index].pontuacao;
	        _this4.respostasString[index] = valores[index].resposta;
	        _this4.$forceUpdate();
	      });
	
	      this.calcularPontuacao();
	    },
	    salvarPontuacao: function salvarPontuacao() {
	      var _this5 = this;
	
	      var salvando = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.respostasProposta.includes('') && this.resultadoAprovacao !== 'DEVOLVER_ENTIDADE' && this.proximaEtapa !== 'SALVAR') {
	        if (salvando === false) {
	          this.$snotify.error('Preencha os indicadores de avaliação antes de continuar.');
	        }
	        return false;
	      }
	      if (this.respostasProposta.includes('') && this.resultadoAprovacao === 'DEVOLVER_ENTIDADE') {
	        return true;
	      }
	      if (this.respostasProposta.includes('') && this.proximaEtapa === 'SALVAR') {
	        return true;
	      }
	
	      var respostas = [];
	      this.respostasProposta.forEach(function (pontuacao, index) {
	        var respostaItem = {
	          fk_proposta: _this5.idProposta,
	          id_questao: index + 1,
	          resposta: _this5.respostasString[index],
	          pontuacao: pontuacao
	        };
	        respostas.push(respostaItem);
	      });
	      console.log('Grava questões ');
	      this.loading.show = true;
	      var obj = {
	        indicativo: this.indicativo,
	        idProposta: this.idProposta,
	        respostas: respostas
	      };
	
	      axiosLaravel.post('/avaliacao/gravarRespostas/', obj).then(function (response) {
	        console.log(response.data);
	        _this5.loading.show = false;
	        return true;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	        _this5.$snotify.clear();
	        _this5.$snotify.error(error);
	        _this5.loading.show = false;
	        return false;
	      });
	    },
	    handleRespostas: function handleRespostas(item, index) {
	      this.respostasString[index] = item.resposta;
	    }
	  }
	};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'avaliacoesProjeto',
	  data: function data() {
	    return {
	      avaliacoesProjeto: [],
	      listaFormulariosDisponiveis: [],
	      formularioSelecionadoEnvioManual: null,
	      tipoFormulario: [{ codigo: 'AVALIACAO_APROVACAO', descricao: 'Marco zero' }, { codigo: 'AVALIACAO_ENCERRAMENTO', descricao: 'Marco um' }, { codigo: 'AVALIACAO_GENERICO', descricao: 'Genérico' }, { codigo: 'AVALIACAO_PARTICIPANTE', descricao: 'Participante' }],
	      loading: {
	        tela: false,
	        formulariosDisponiveis: false
	      }
	    };
	  },
	
	  props: ['numeroProjeto', 'editavel'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	
	  watch: {},
	  created: function created() {
	    this.buscaAvaliacoes();
	    this.buscaFormsDisponiveis();
	  },
	
	  methods: {
	    buscaAvaliacoes: function buscaAvaliacoes() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('formulario/projeto/' + this.numeroProjeto + '/listar').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this.avaliacoesProjeto = response.data.retorno;
	        } else {
	          _this.$snotify.error(response.data.mensagem);
	        }
	        _this.loading.tela = false;
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaFormsDisponiveis: function buscaFormsDisponiveis() {
	      var _this2 = this;
	
	      this.loading.formulariosDisponiveis = true;
	      axiosLaravel.get('formulario/projeto/' + this.numeroProjeto + '/disponivel').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this2.listaFormulariosDisponiveis = response.data.retorno;
	        } else {
	          _this2.$snotify.error(response.data.mensagem);
	        }
	        _this2.loading.formulariosDisponiveis = false;
	      }).catch(function (error) {
	        _this2.loading.formulariosDisponiveis = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    encaminharFormularioParaEntidade: function encaminharFormularioParaEntidade() {
	      var _this3 = this;
	
	      this.loading.tela = true;
	      var vm = this;
	      var formularioIgualAtivo = _.find(this.avaliacoesProjeto, function (form) {
	        return form.avaliacao.situacao !== 'CANCELADO' && form.formularioCadastrado.id === vm.formularioSelecionadoEnvioManual.id;
	      });
	      var nomeFormSelecionado = this.formularioSelecionadoEnvioManual.id + ' - ' + this.formularioSelecionadoEnvioManual.nome;
	      var msg = formularioIgualAtivo ? 'Este formulário (<b>' + nomeFormSelecionado + '</b>) está atualmente vinculado ao projeto.<br/>Se continuar, então o atual será cancelado!' : 'Deseja vincular o formulário selecionado (<b>' + nomeFormSelecionado + '</b>) a este projeto?';
	      this.$dialog.confirm(msg, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	        axiosLaravel.post('formulario/vincula/', { 'idFormularioCadastrado': vm.formularioSelecionadoEnvioManual.id, 'numeroProjeto': vm.numeroProjeto }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this3.buscaAvaliacoes();
	            _this3.formularioSelecionadoEnvioManual = null;
	          } else {
	            _this3.aviso(response.data);
	          }
	        }).catch(function (error) {
	          _this3.loading.tela = false;
	          _this3.$root.trataErro(error);
	        });
	      }).catch(function () {
	        _this3.loading.tela = false;
	        console.log('Cancelou a vinculação do formulário ao projeto');
	      });
	    },
	    reativar: function reativar(idx) {
	      var _this4 = this;
	
	      this.loading.tela = true;
	      var idFormCadastrado = this.avaliacoesProjeto[idx]['formularioCadastrado']['id'];
	      var idProcessoParaReativar = this.avaliacoesProjeto[idx]['avaliacao']['id'];
	      var formularioIgualAtivo = _.find(this.avaliacoesProjeto, function (form) {
	        return form.avaliacao.situacao !== 'CANCELADO' && form.formularioCadastrado.id === idFormCadastrado;
	      });
	      var msg = formularioIgualAtivo ? 'A avaliação <b>' + idProcessoParaReativar + '</b> que deseja Reativar já tem um formulário igual (<b>' + formularioIgualAtivo.avaliacao.id + '</b>) não cancelado e vinculado a este projeto.<br/>Se continuar, então o processo atual será cancelado em favor do novo reativado!' : 'Deseja reativar esta avaliação <b>' + idProcessoParaReativar + '</b> ?';
	      this.$dialog.confirm(msg, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	        axiosLaravel.put('formulario/processo/' + idProcessoParaReativar + '/reativar/').then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this4.buscaAvaliacoes();
	          } else {
	            _this4.aviso(response.data);
	          }
	        }).catch(function (error) {
	          _this4.loading.tela = false;
	          _this4.$root.trataErro(error);
	        });
	      }).catch(function () {
	        _this4.loading.tela = false;
	        console.log('Cancelou a reativação de processo de avaliação neste projeto');
	      });
	    },
	    cancelar: function cancelar(id) {
	      var _this5 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.put('formulario/processo/' + id + '/cancelar/').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this5.buscaAvaliacoes();
	          _this5.buscaFormsDisponiveis();
	        } else {
	          _this5.aviso(response.data);
	        }
	      }).catch(function (error) {
	        _this5.loading.tela = false;
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'categorizadores',
	  data: function data() {
	    return {
	      categorizadores: [],
	      preAnalise: {}
	    };
	  },
	
	  props: ['propsAnalise', 'indicativoAvaliacao', 'ehSimplificada'],
	  watch: {
	    propsAnalise: {
	      handler: function handler() {
	        var _this = this;
	
	        if (this.propsAnalise.ds_categ_campo_atuacao) {
	          this.propsAnalise.ds_fep_campo_atuacao = this.propsAnalise.ds_categ_campo_atuacao;
	        }
	        if (this.propsAnalise.ds_categ_programa) {
	          this.propsAnalise.ds_fep_programa = this.propsAnalise.ds_categ_programa;
	        }
	        if (_.has(this.propsAnalise, 'duplicadorSapiens')) {
	          this.carregarCategorizadores();
	        } else if (this.propsAnalise.nr_projeto_duplicacao) {
	          axiosLaravel.get('projeto/sapiens/' + this.propsAnalise.nr_projeto_duplicacao).then(function (response) {
	            _this.propsAnalise.duplicadorSapiens = response.data[0];
	            _this.carregarCategorizadores();
	          }).catch(function (error) {
	            _this.$snotify.clear();
	            _this.$root.trataErro(error);
	          });
	        }
	      }
	    }
	  },
	  created: function created() {
	    if (this.propsAnalise.ds_fase !== 'ANALISE') {
	      this.carregarCategorizadores();
	    }
	    this.carregarCategorizadores();
	  },
	
	  methods: {
	    carregarCategorizadores: function carregarCategorizadores() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                axiosLaravel.get('categorizadores/').then(function (response) {
	                  _this2.categorizadores = response.data;
	                  _this2.propsAnalise.ds_categ_campo_atuacao = _.has(_this2.propsAnalise.duplicadorSapiens, 'usu_campatu') ? _this2.propsAnalise.duplicadorSapiens.usu_campatu : null;
	
	                  _this2.propsAnalise.ds_categ_tecnologia = _.has(_this2.propsAnalise.duplicadorSapiens, 'usu_tecno') ? _this2.propsAnalise.duplicadorSapiens.usu_tecno : null;
	                  _this2.propsAnalise.ds_categ_vetor = _.has(_this2.propsAnalise.duplicadorSapiens, 'usu_prjvet') ? _this2.propsAnalise.duplicadorSapiens.usu_prjvet : null;
	                  _this2.propsAnalise.ds_categ_acao = _.has(_this2.propsAnalise.duplicadorSapiens, 'usu_acao') ? _this2.propsAnalise.duplicadorSapiens.usu_acao : null;
	                }).catch(function (error) {
	                  _this2.$root.trataErro(error);
	                });
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    }
	  }
	};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checklistAnalise = __webpack_require__(269);
	
	exports.default = {
	  name: 'checklistAnalise',
	  props: {
	    dados: {
	      type: Object,
	      required: true
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      grupos: _checklistAnalise.GRUPOS_CHECKLIST_ANALISE,
	      opcoes: _checklistAnalise.OPCOES_SIM_NAO
	    };
	  },
	
	  methods: {
	    respondido: function respondido(chave) {
	      var valor = this.dados[chave];
	      return valor !== null && valor !== undefined && valor !== '';
	    },
	    classeOpcao: function classeOpcao(chave, opcao) {
	      if (this.dados[chave] !== opcao) {
	        return '';
	      }
	
	      return opcao === 'N/A' ? 'chk-seg-btn--na' : 'chk-seg-btn--sel';
	    },
	    atualiza: function atualiza(chave, valor) {
	      this.$set(this.dados, chave, valor);
	    },
	    alterna: function alterna(chave, opcao) {
	      this.atualiza(chave, this.dados[chave] === opcao ? '' : opcao);
	    }
	  }
	};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'checklist-indicadores',
	  props: {
	    opcoes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      novoIndicador: '',
	
	      extras: []
	    };
	  },
	
	  computed: {
	    extrasVisiveis: function extrasVisiveis() {
	      var _this = this;
	
	      return this.extras.filter(function (item) {
	        return !_this.opcoes.includes(item.descricao);
	      });
	    }
	  },
	  watch: {
	    value: {
	      handler: 'sincronizaExtras',
	      immediate: true
	    },
	    opcoes: 'sincronizaExtras'
	  },
	  methods: {
	    sincronizaExtras: function sincronizaExtras() {
	      var _this2 = this;
	
	      (this.value || []).forEach(function (item) {
	        if (!_this2.opcoes.includes(item.descricao) && !_this2.extras.some(function (e) {
	          return e.descricao === item.descricao;
	        })) {
	          _this2.extras.push({ descricao: item.descricao, custom: !!item.custom });
	        }
	      });
	    },
	    estaSelecionado: function estaSelecionado(descricao) {
	      return (this.value || []).some(function (item) {
	        return item.descricao === descricao;
	      });
	    },
	    alterna: function alterna(descricao) {
	      var custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var atual = this.value || [];
	      if (this.estaSelecionado(descricao)) {
	        this.$emit('input', atual.filter(function (item) {
	          return item.descricao !== descricao;
	        }));
	      } else {
	        var ehCustom = custom !== null ? custom : !this.opcoes.includes(descricao);
	        this.$emit('input', [].concat((0, _toConsumableArray3.default)(atual), [{ descricao: descricao, custom: ehCustom }]));
	      }
	    },
	    adiciona: function adiciona() {
	      var descricao = (this.novoIndicador || '').trim();
	      if (!descricao) {
	        return;
	      }
	      var custom = !this.opcoes.includes(descricao);
	
	      if (custom && !this.extras.some(function (e) {
	        return e.descricao === descricao;
	      })) {
	        this.extras.push({ descricao: descricao, custom: true });
	      }
	      if (!this.estaSelecionado(descricao)) {
	        this.$emit('input', [].concat((0, _toConsumableArray3.default)(this.value || []), [{ descricao: descricao, custom: custom }]));
	      }
	      this.novoIndicador = '';
	    }
	  }
	};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _detalheItemLicitacao = __webpack_require__(251);
	
	var _detalheItemLicitacao2 = _interopRequireDefault(_detalheItemLicitacao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'bancoPrecos',
	  components: {
	    detalheItemLicitacao: _detalheItemLicitacao2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      debounceTimer: null,
	      loading: {
	        show: false,
	        categoria: false,
	        grupo: false,
	        classificacao: false,
	        item: false
	      },
	      selectOptions: {
	        tipoItem: ['PRODUTO', 'SERVICO'],
	        uf: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
	        categoria: [],
	        grupo: [],
	        classificacao: [],
	        item: []
	      },
	      selectJustificativa: ['Item está diferente do selecionado.', 'Item com valor MUITO acima do mercado', 'Item com valor MUITO abaixo do mercado'],
	      selecaoJustificativa: [],
	      itemJustificativa: {},
	      indexJustificativa: '',
	      selecaoTipoItens: [],
	      selecaoUfs: [],
	      selecaoCategoria: [],
	      selecaoGrupos: [],
	      selecaoClassificacoes: [],
	      selecaoItems: [],
	      abrirFiltrosAvancados: true,
	      abrirJustificativa: false,
	      procuraIndividual: true,
	      procuraCategorizadores: false,
	      definicaoItem: '',
	      table: {
	        items: this.resultadoSelecionadoItems,
	        totalRows: 0,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 100,
	        sortBy: 'valor_item',
	        sortDesc: true,
	        sortDirection: 'desc',
	        fields: [{ key: 'selecionado', label: 'Selecionar', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Detalhe', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'descricao_item', label: 'Item', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'quantidade_item_aprovado', label: 'Qtd', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'sigla_uf', label: 'UF', sortable: true, thStyle: 'text-align: center', class: 'text-right' }, { key: 'valor_item', label: 'Valor Un.', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_resultado_licitacao', label: 'Data', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      resultadoCaracteristicas: [],
	      resultadoItems: [],
	      resultadoSelecionadoItems: [],
	      remocaoManual: [],
	      itemDetalheSelecionado: {},
	      visibilidade: {},
	      filtroItensCaracteristica: [],
	      filtroKeysCaracteristica: {},
	      idItemsFiltro: [],
	      tipoFiltroCaracteristica: 'INCLUSIVO',
	      mostrarFiltroDetalhe: false,
	      abrirDetalheItem: false,
	      valorMinimo: 0,
	      valorMaximo: 8000
	    };
	  },
	
	  props: {
	    gravaSelecaoItens: Function,
	    toggleBancoPrecos: Function
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {},
	  methods: {
	    toggleVisibility: function toggleVisibility(key) {
	      this.$set(this.visibilidade, key, !this.visibilidade[key]);
	    },
	    toggleJustificativa: function toggleJustificativa(valor) {
	      this.abrirJustificativa = valor;
	    },
	    toggleTodasCaracteristicas: function toggleTodasCaracteristicas(key) {
	      this.$set(this.filtroKeysCaracteristica, key, !this.filtroKeysCaracteristica[key]);
	      this.$set(this.visibilidade, key, this.filtroKeysCaracteristica[key]);
	      this.atualizarSelecaoCaracteristicas(key, [], 0, true, this.filtroKeysCaracteristica[key]);
	    },
	    isVisible: function isVisible(key) {
	      return !!this.visibilidade[key];
	    },
	    isSelected: function isSelected(key) {
	      return !!this.filtroKeysCaracteristica[key];
	    },
	    detalharItem: function detalharItem(item) {
	      var _this = this;
	
	      console.log(item);
	      this.itemDetalheSelecionado = item;
	      setTimeout(function () {
	        return _this.$refs.detalhamentoContainer.scrollIntoView({ behavior: 'smooth' });
	      }, 100);
	      this.toggleDetalhe(true);
	    },
	    toggleDetalhe: function toggleDetalhe(valor) {
	      this.abrirDetalheItem = valor;
	    },
	    debounceFiltro: function debounceFiltro(search, tipo) {
	      var _this2 = this;
	
	      if (tipo !== 'categoria' && !this.procuraIndividual) {
	        return;
	      }
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        if (search === '') {
	          return;
	        }
	        _this2.pesquisarGeral(search, tipo);
	      }, 1000);
	    },
	    pesquisarGeral: function pesquisarGeral(termo, tipo) {
	      var _this3 = this;
	
	      console.log('Pesquisa de Cotação');
	
	      this.loading[tipo] = true;
	      var obj = {
	        campoConsulta: tipo,
	        termoQuery: termo,
	        tipoItem: this.selecaoTipoItens,
	        uf: this.selecaoUfs
	      };
	      axiosLaravel.post('/cotacao/pesquisarGeral/', obj).then(function (response) {
	        console.log(response.data);
	        response.data.map(function (item) {
	          if (!_this3.selectOptions[tipo].includes(item[tipo])) {
	            _this3.selectOptions[tipo].push(item[tipo]);
	          }
	        });
	        _this3.loading[tipo] = false;
	        _this3.selectOptions[tipo].sort();
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.loading[tipo] = false;
	      });
	    },
	    consultarGrupos: function consultarGrupos() {
	      var _this4 = this;
	
	      this.selectOptions.grupo = [];
	      this.selecaoGrupos = [];
	      this.selecaoClassificacoes = [];
	      this.selectOptions.classificacao = [];
	      console.log('[CONSULTANDO GRUPOS]', this.selecaoCategoria, this.selecaoCategoria.length);
	      this.loading['grupo'] = true;
	      if (this.selecaoCategoria.length === 0) {
	        this.selectOptions['grupo'] = [];
	        this.loading['grupo'] = false;
	        return;
	      }
	      var obj = {
	        categorias: this.selecaoCategoria,
	        tipoItem: this.selecaoTipoItens,
	        uf: this.selecaoUfs
	      };
	      axiosLaravel.post('/cotacao/pesquisarGrupos/', obj).then(function (response) {
	        console.log(response.data);
	        response.data.map(function (item) {
	          if (!_this4.selectOptions['grupo'].includes(item['grupo'])) {
	            _this4.selectOptions['grupo'].push(item['grupo']);
	          }
	        });
	        _this4.loading['grupo'] = false;
	        _this4.selectOptions['grupo'].sort();
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	        _this4.loading['grupo'] = false;
	      });
	    },
	    consultarClassificacoes: function consultarClassificacoes() {
	      var _this5 = this;
	
	      this.selectOptions.classificacao = [];
	      console.log('[CONSULTANDO CLASSIFICACOES]');
	      this.loading['classificacao'] = true;
	
	      if (this.selecaoGrupos.length === 0) {
	        this.selectOptions['classificacao'] = [];
	        this.loading['classificacao'] = false;
	        return;
	      }
	
	      var obj = {
	        categorias: this.selecaoCategoria,
	        grupos: this.selecaoGrupos,
	        tipoItem: this.selecaoTipoItens,
	        uf: this.selecaoUfs
	      };
	      axiosLaravel.post('/cotacao/pesquisarClassificacao/', obj).then(function (response) {
	        console.log(response.data);
	        response.data.map(function (item) {
	          if (!_this5.selectOptions['classificacao'].includes(item['classificacao'])) {
	            _this5.selectOptions['classificacao'].push(item['classificacao']);
	          }
	        });
	        _this5.loading['classificacao'] = false;
	        _this5.selectOptions['classificacao'].sort();
	        _this5.$forceUpdate();
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	        _this5.loading['classificacao'] = false;
	      });
	    },
	    consultarItens: function consultarItens() {
	      var _this6 = this;
	
	      this.selectOptions.item = [];
	      this.selecaoItems = [];
	      console.log('[CONSULTANDO ITEMS]');
	      this.loading['item'] = true;
	      if (this.selecaoCategoria.length === 0) {
	        this.selectOptions['item'] = [];
	        this.loading['item'] = false;
	        return;
	      }
	      var obj = {
	        categorias: this.selecaoCategoria,
	        grupos: this.selecaoGrupos,
	        classificacoes: this.selecaoClassificacoes,
	        tipoItem: this.selecaoTipoItens,
	        uf: this.selecaoUfs
	      };
	      axiosLaravel.post('/cotacao/pesquisarItens/', obj).then(function (response) {
	        console.log(response.data);
	        response.data.map(function (item) {
	          if (!_this6.selectOptions['item'].includes(item['item'])) {
	            _this6.selectOptions['item'].push(item['item']);
	          }
	        });
	        _this6.loading['item'] = false;
	        _this6.selectOptions['item'].sort();
	        _this6.$forceUpdate();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	        _this6.loading['item'] = false;
	      });
	    },
	    consultarGrupoItem: function consultarGrupoItem() {
	      this.consultarGrupos();
	      this.consultarItens();
	    },
	    consultarClassificacaoItem: function consultarClassificacaoItem() {
	      this.consultarClassificacoes();
	      this.consultarItens();
	    },
	    clearTipoSelection: function clearTipoSelection() {
	      var _this7 = this;
	
	      this.clearClassificadores();
	      this.selecaoTipoItens = [];
	      this.selecaoUfs = [];
	      setTimeout(function () {
	        return _this7.$refs.topo.scrollIntoView({ behavior: 'smooth' });
	      }, 300);
	      this.resultadoCaracteristicas = [];
	      this.resultadoItems = [];
	      this.resultadoSelecionadoItems = [];
	      this.$forceUpdate();
	    },
	    clearClassificadores: function clearClassificadores() {
	      this.selectOptions.categoria = [];
	      this.selectOptions.grupo = [];
	      this.selectOptions.classificacao = [];
	      this.selectOptions.item = [];
	      this.selecaoCategoria = [];
	      this.selecaoClassificacoes = [];
	      this.selecaoGrupos = [];
	      this.selecaoItems = [];
	      this.procuraIndividual = true;
	      this.procuraCategorizadores = false;
	    },
	    consultarItensLicitacao: function consultarItensLicitacao() {
	      var _this8 = this;
	
	      this.loading.show = true;
	      setTimeout(function () {
	        return _this8.$refs.loadingItems.scrollIntoView({ behavior: 'smooth' });
	      }, 300);
	      console.log('CONSULTANDO ITENS DE LICITACAO');
	      this.resultadoCaracteristicas = [];
	      this.resultadoItems = [];
	      this.resultadoSelecionadoItems = [];
	      this.resultadoSelecionadoItemsFiltro = [];
	      this.filtroItensCaracteristica = [];
	      var obj = {
	        categorias: this.selecaoCategoria,
	        grupos: this.selecaoGrupos,
	        classificacoes: this.selecaoClassificacoes,
	        tipoItem: this.selecaoTipoItens,
	        items: this.selecaoItems,
	        uf: this.selecaoUfs,
	        valorMaximo: this.valorMaximo,
	        valorMinimo: this.valorMinimo
	      };
	      axiosLaravel.post('/cotacao/pesquisarItensLicitacao/', obj).then(function (response) {
	        console.log(response.data);
	        _this8.resultadoItems = response.data.items;
	        _this8.resultadoCaracteristicas = _.groupBy(response.data.caracteristicas, 'tipo_caracteristica');
	
	        var sortedKeys = (0, _keys2.default)(_this8.resultadoCaracteristicas).sort();
	        var groupedItems = sortedKeys.reduce(function (acc, key) {
	          acc[key] = _this8.resultadoCaracteristicas[key];
	          return acc;
	        }, {});
	        _this8.resultadoCaracteristicas = groupedItems;
	        _this8.filtroItensCaracteristica = _.cloneDeep(_this8.resultadoCaracteristicas);
	        console.log('filtro caracteristicas', _this8.filtroItensCaracteristica);
	        _this8.resultadoSelecionadoItems = response.data.items;
	        _this8.resultadoSelecionadoItemsFiltro = _.cloneDeep(_this8.resultadoSelecionadoItems);
	        _this8.table.items = _this8.resultadoSelecionadoItems;
	        _this8.table.totalRows = _this8.table.items.length;
	        _this8.loading.show = false;
	        setTimeout(function () {
	          return _this8.$refs.itemsEncontrados.scrollIntoView({ behavior: 'smooth' });
	        }, 300);
	        _this8.$forceUpdate();
	      }).catch(function (error) {
	        _this8.loading.show = false;
	        _this8.$root.trataErro(error);
	      });
	    },
	    atualizarSelecaoCaracteristicas: function atualizarSelecaoCaracteristicas(key) {
	      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var index = arguments[2];
	      var todos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var valorTodos = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      console.log(key, item, index);
	      if (!todos) {
	        this.filtroItensCaracteristica[key][index].selecionado = !this.filtroItensCaracteristica[key][index].selecionado;
	      } else {
	        this.filtroItensCaracteristica[key].forEach(function (element) {
	          console.log(element);
	          element.selecionado = valorTodos;
	        });
	      }
	
	      this.filtroCaracteristicas();
	    },
	    filtroCaracteristicas: function filtroCaracteristicas() {
	      var _this9 = this;
	
	      console.log('FILTRANDO ...');
	      this.idItemsFiltro = [];
	
	      (0, _keys2.default)(this.filtroItensCaracteristica).forEach(function (key) {
	        _this9.filtroItensCaracteristica[key].forEach(function (caracteristica) {
	          if (caracteristica.selecionado) {
	            if (!_this9.idItemsFiltro.includes(caracteristica.fk_banco_precos_tratado)) {
	              _this9.idItemsFiltro.push(caracteristica.fk_banco_precos_tratado);
	              console.log(_this9.idItemsFiltro);
	            }
	          }
	        });
	      });
	      var resultadoFiltrado = this.resultadoSelecionadoItemsFiltro.filter(function (item) {
	        return _this9.idItemsFiltro.includes(item.id.toString());
	      });
	
	      this.table.items = resultadoFiltrado;
	      this.$forceUpdate();
	      console.log(this.idItemsFiltro);
	      console.log(resultadoFiltrado);
	    },
	    resetarItensTabela: function resetarItensTabela() {
	      this.table.items = this.resultadoSelecionadoItemsFiltro;
	      this.resetarCaracteristicas();
	      this.$forceUpdate();
	    },
	    resetarCaracteristicas: function resetarCaracteristicas() {
	      var _this10 = this;
	
	      (0, _keys2.default)(this.filtroItensCaracteristica).forEach(function (key) {
	        _this10.$set(_this10.filtroKeysCaracteristica, key, false);
	        _this10.$set(_this10.visibilidade, key, false);
	        _this10.filtroItensCaracteristica[key].forEach(function (caracteristica) {
	          caracteristica.selecionado = false;
	        });
	      });
	    },
	    gravarResultado: function gravarResultado() {
	      if (this.resultadoItems.length <= 0) {
	        this.$snotify.error('Atenção, pesquise primeiro antes de gravar o resultado.');
	      }
	      var itensSelecionados = [];
	      this.table.items.forEach(function (item) {
	        if (item.selecionado) {
	          itensSelecionados.push(item);
	        }
	      });
	      if (itensSelecionados.length < 3) {
	        this.$snotify.error('Atenção, a amostra deve conter ao menos 3(TRÊS) itens de cotação.');
	        return;
	      }
	      this.gravaSelecaoItens(itensSelecionados, this.criarDefinicaoItem(), this.remocaoManual);
	      console.log('Gravando resultado..');
	      this.toggleBancoPrecos(false);
	    },
	    handleCategorizadores: function handleCategorizadores() {
	      if (this.procuraCategorizadores) {
	        this.procuraIndividual = false;
	      } else {
	        this.procuraIndividual = true;
	      }
	    },
	    criarDefinicaoItem: function criarDefinicaoItem() {
	      console.log('Criando definição de item');
	      var nomeItem = '';
	      if (this.selecaoItems.length > 0) {
	        nomeItem = nomeItem + ' ' + this.selecaoItems[0];
	      } else {
	        if (this.selecaoCategoria.length > 0) {
	          nomeItem = nomeItem + ' ' + this.selecaoCategoria[0];
	        }
	        if (this.selecaoGrupos.length > 0) {
	          nomeItem = nomeItem + ' ' + this.selecaoGrupos[0];
	        }
	        if (this.selecaoClassificacoes.length > 0) {
	          nomeItem = nomeItem + ' ' + this.selecaoClassificacoes[0];
	        }
	      }
	
	      return nomeItem.toUpperCase();
	    },
	    verificaExclusaoManual: function verificaExclusaoManual(item) {
	      this.itemJustificativa = {};
	      this.selecaoJustificativa = '';
	
	      if (!item.selecionado) {
	        this.toggleJustificativa(true);
	        this.itemJustificativa = item;
	      } else {
	        this.remocaoManual = this.remocaoManual.filter(function (objRemocao) {
	          return objRemocao.item.id !== item.id;
	        });
	      }
	    },
	    gravaRemocaoManual: function gravaRemocaoManual(item) {
	      if (this.selecaoJustificativa === '') {
	        this.$snotify.error('Atenção, selecione um motivo antes de concluir.');
	        return;
	      }
	      var obj = {
	        item: item,
	        justificativa: this.selecaoJustificativa,
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	      this.remocaoManual.push(obj);
	      this.toggleJustificativa(false);
	    },
	    cancelaRemocaoManual: function cancelaRemocaoManual(item) {
	      this.table.items.forEach(function (tableItem) {
	        if (tableItem.id === item.id) {
	          tableItem.selecionado = true;
	        }
	      });
	      this.toggleJustificativa(false);
	    }
	  }
	};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(123);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cotacaoPrecos = __webpack_require__(1696);
	
	var _cotacaoPrecos2 = _interopRequireDefault(_cotacaoPrecos);
	
	var _cotacaoManual = __webpack_require__(1695);
	
	var _cotacaoManual2 = _interopRequireDefault(_cotacaoManual);
	
	var _detalheItemCotacao = __webpack_require__(1698);
	
	var _detalheItemCotacao2 = _interopRequireDefault(_detalheItemCotacao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cotacaoItens',
	  components: {
	    cotacaoPrecos: _cotacaoPrecos2.default,
	    cotacaoManual: _cotacaoManual2.default,
	    detalheItemCotacao: _detalheItemCotacao2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      loading: {
	        show: false
	      },
	      idCotacao: '',
	      textoInstrucao: 'Selecione uma opção para começar o cadastro da cotação.',
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 100,
	        sortBy: 'valorMedio',
	        sortDesc: true,
	        sortDirection: 'desc',
	        fields: [{ key: 'descricao', label: 'Produto/Serviço', sortable: true, thStyle: 'text-align:', class: 'text-left' }, { key: 'valorMedio', label: 'Média Saneada', sortable: true, thStyle: 'text-align: right', class: 'text-right' }, { key: 'CV', label: 'Variação', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-right' }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }]
	      },
	      tableManual: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 100,
	        sortBy: 'valorMedio',
	        sortDesc: true,
	        sortDirection: 'desc',
	        fields: [{ key: 'descricao', label: 'Produto/Serviço', sortable: true, thStyle: 'text-align:', class: 'text-left' }, { key: 'valorMedio', label: 'Valor', sortable: true, thStyle: 'text-align: right', class: 'text-right' }, { key: 'justificativa', label: 'Justificativa', sortable: true, thStyle: 'text-align: right', class: 'text-right' }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }]
	      },
	      itensCotacao: [],
	      itensCotacaoManual: [],
	      itensCotacaoBackup: [],
	      itensCotacaoManualBackup: [],
	      itemSelecionadoDetalhe: {},
	      totalItens: 0,
	      abrirCotacaoPrecos: false,
	      abrirDetalheItem: false,
	      abrirCotacaoManual: false,
	      visualizacaoManual: false,
	      itemCotacaoValidado: false,
	      itemCotacaoResponsavelValidacao: '',
	      horaValidacao: '',
	      descricaoCotacao: '',
	      itemCotacaoResponsavelValidacaoBackup: '',
	      horaValidacaoBackup: '',
	      descricaoCotacaoBackup: '',
	      itensRemocao: []
	    };
	  },
	
	  props: {
	    fk_cotacao: Number,
	    idProposta: Number,
	    toggleCotacao: Function,
	    setDescricaoValor: Function,
	    indexItem: Number,
	    atividadeIndex: Number,
	    cotacaoGravada: Array,
	    cotacaoManualGravada: Array,
	    cotacaoValidada: Object,
	    editarCotacao: Boolean,
	    validandoCotacao: Boolean,
	    visualizandoCotacao: { type: Boolean, default: false },
	    telaProjeto: { type: Boolean, default: false },
	    fecharValidacao: Function,
	    onAdd: Function,
	    gravarValidacaoRow: Function,
	    atividade: Object,
	    item: Object,
	    itemIndex: Number
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {
	    this.initEdicao();
	  },
	  methods: {
	    toggleAdicionarItem: function toggleAdicionarItem(valor) {
	      this.abrirCotacaoPrecos = valor;
	      this.abrirCotacaoManual = false;
	    },
	    toggleDetalharItem: function toggleDetalharItem(valor) {
	      this.abrirDetalheItem = valor;
	    },
	    toggleCotacaoManual: function toggleCotacaoManual(valor) {
	      this.abrirCotacaoManual = valor;
	      this.abrirCotacaoPrecos = false;
	    },
	    adicionarItem: function adicionarItem(cotacao, universoAmostralSaneado, universoAmostralContaminado, valorMedio, descricao, CV, calculoAmostral, calculoFinal, remocaoManual) {
	      var itemCotacao = {
	        cotacao: cotacao,
	        universoAmostralSaneado: universoAmostralSaneado,
	        universoAmostralContaminado: universoAmostralContaminado,
	        descricao: descricao,
	        valorMedio: valorMedio,
	        CV: CV,
	        calculoAmostral: calculoAmostral,
	        calculoFinal: calculoFinal,
	        remocaoManual: remocaoManual
	      };
	      this.itensCotacao.push(itemCotacao);
	      this.table.items = this.itensCotacao;
	      this.resetarValidacao();
	      this.atualizaDescricaoCotacaoGeral();
	      this.calcularTotalItens();
	      this.verificaValidacaoAutomatica();
	      this.$forceUpdate();
	    },
	    adicionarItemManual: function adicionarItemManual(valorMedio, descricao, justificativa, anexos) {
	      var itemCotacao = {
	        descricao: descricao,
	        valorMedio: valorMedio,
	        justificativa: justificativa,
	        anexos: anexos
	      };
	      this.itensCotacaoManual.push(itemCotacao);
	      this.tableManual.items = this.itensCotacaoManual;
	      this.atualizaDescricaoCotacaoGeral();
	      this.calcularTotalItens();
	      this.resetarValidacao();
	      this.verificaValidacaoAutomatica();
	      this.$forceUpdate();
	    },
	    calcularTotalItens: function calcularTotalItens() {
	      var soma = 0;
	      if (this.itensCotacao.length <= 0 && this.itensCotacaoManual.length <= 0) {
	        this.totalItens = soma;
	        return;
	      }
	      this.itensCotacao.forEach(function (item) {
	        soma += parseFloat(item.valorMedio);
	      });
	      this.itensCotacaoManual.forEach(function (item) {
	        soma += parseFloat(item.valorMedio);
	      });
	      this.totalItens = soma;
	      this.$forceUpdate();
	    },
	    atualizaDescricaoCotacaoGeral: function atualizaDescricaoCotacaoGeral() {
	      var _this = this;
	
	      this.descricaoCotacao = '';
	      this.itensCotacao.forEach(function (item) {
	        _this.descricaoCotacao = _this.descricaoCotacao + item.descricao + ', ';
	      });
	      this.itensCotacaoManual.forEach(function (item) {
	        _this.descricaoCotacao = _this.descricaoCotacao + item.descricao + ', ';
	      });
	      if (this.itensCotacao.length < 2 && this.itensCotacaoManual.length < 2 && this.itensCotacaoManual.length + this.itensCotacao.length < 2) {
	        console.log('atualizar descrição');
	        this.descricaoCotacao = this.descricaoCotacao.replace(',', '');
	      } else {
	        this.descricaoCotacao = this.descricaoCotacao.slice(0, -2);
	      }
	      this.descricaoCotacao.trim();
	    },
	    confirmaExclusao: function confirmaExclusao(mensagem, acao) {
	      this.$dialog.confirm(mensagem).then(function () {
	        return acao();
	      }).catch(function () {});
	    },
	    removerItem: function removerItem(item) {
	      var manual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (item.hasOwnProperty('id')) {
	        console.log('removendo..', item.id);
	        this.itensRemocao.push(item.id);
	      }
	      if (manual) {
	        var index = this.tableManual.items.findIndex(function (itemTable) {
	          return itemTable === item;
	        });
	        if (index !== -1) {
	          this.tableManual.items.splice(index, 1);
	
	          this.itensCotacaoManual = this.tableManual.items;
	        }
	      } else {
	        var _index = this.table.items.findIndex(function (itemTable) {
	          return itemTable === item;
	        });
	        if (_index !== -1) {
	          this.table.items.splice(_index, 1);
	
	          this.itensCotacao = this.table.items;
	        }
	      }
	
	      this.calcularTotalItens();
	      this.resetarValidacao();
	      this.atualizaDescricaoCotacaoGeral();
	      this.verificaValidacaoAutomatica();
	      this.$forceUpdate();
	    },
	    detalharItem: function detalharItem(item) {
	      this.itemSelecionadoDetalhe = {};
	
	      this.itemSelecionadoDetalhe = item;
	      this.toggleDetalharItem(true);
	    },
	    detalharItemManual: function detalharItemManual(item) {
	      this.visualizacaoManual = true;
	      this.itemSelecionadoDetalhe = {};
	
	      this.itemSelecionadoDetalhe = item;
	      this.toggleCotacaoManual(true);
	    },
	    novaCotacaoManual: function novaCotacaoManual(value) {
	      this.visualizacaoManual = false;
	      this.itemSelecionadoDetalhe = {};
	      this.toggleCotacaoManual(value);
	    },
	    initEdicao: function initEdicao() {
	      if (this.editarCotacao || this.validandoCotacao) {
	        this.idCotacao = this.fk_cotacao;
	        this.itensCotacao = _.cloneDeep(this.cotacaoGravada[0]);
	        this.table.items = this.itensCotacao;
	        this.itensCotacaoBackup = _.cloneDeep(this.itensCotacao);
	        this.itensCotacaoManual = _.cloneDeep(this.cotacaoManualGravada[0]);
	        this.itensCotacaoManualBackup = _.cloneDeep(this.itensCotacaoManual);
	        this.tableManual.items = this.itensCotacaoManual;
	        this.itemCotacaoValidado = this.cotacaoValidada.validado;
	        this.itemCotacaoResponsavelValidacao = this.cotacaoValidada.responsavel;
	        this.horaValidacao = this.cotacaoValidada.horaValidacao;
	        this.itemCotacaoValidadoBackup = this.cotacaoValidada.validado;
	        this.itemCotacaoResponsavelValidacaoBackup = this.cotacaoValidada.responsavel;
	        this.horaValidacaoBackup = this.cotacaoValidada.horaValidacao;
	        this.calcularTotalItens();
	        this.atualizaDescricaoCotacaoGeral();
	        this.$forceUpdate();
	      }
	    },
	    cancelar: function cancelar() {
	      if (this.editarCotacao) {
	        this.itensCotacao = this.itensCotacaoBackup;
	        this.itensCotacaoManual = this.itensCotacaoManualBackup;
	        this.table.items = this.itensCotacao;
	        this.tableManual.items = this.itensCotacaoManual;
	        console.log('itens cotacao', this.itensCotacao);
	        console.log('itens cotacao manual', this.itensCotacaoManual);
	        this.calcularTotalItens();
	        this.atualizaDescricaoCotacaoGeral();
	        this.$forceUpdate();
	        this.retornaValoresEdicaoForm();
	      } else if (this.validandoCotacao) {
	        this.fecharValidacao();
	      } else {
	        this.toggleCotacao(false);
	      }
	    },
	    salvarCotacao: function salvarCotacao() {
	      this.$aguarde('Gravando Cotação. Por favor, aguarde...');
	      this.gravarCotacaoBase();
	    },
	    validarCotacao: function validarCotacao() {
	      this.$aguarde('Gravando Validação. Por favor, aguarde...');
	      this.itemCotacaoResponsavelValidacao = this.usuarioLogado.ds_login + ' ' + this.usuarioLogado.ds_nome_usuario;
	      this.itemCotacaoValidado = true;
	      this.horaValidacao = (0, _moment2.default)(new Date()).format('DD/MM/YYYY HH:mm:ss');
	
	      this.gravarValidacao();
	    },
	    verificaValidacaoAutomatica: function verificaValidacaoAutomatica() {
	      var validacaoAutomatica = true;
	      if (this.itemCotacaoValidado) {
	        return;
	      }
	      if (this.itensCotacaoManual.length > 0) {
	        return;
	      }
	      this.itensCotacao.forEach(function (item) {
	        console.log('item cotacao', item.remocaoManual);
	        if (item.remocaoManual.length > 0) {
	          validacaoAutomatica = false;
	          return;
	        }
	        if (item.CV > 25) {
	          validacaoAutomatica = false;
	          return;
	        }
	      });
	
	      if (!validacaoAutomatica) {
	        return;
	      }
	
	      this.itemCotacaoValidado = true;
	      this.itemCotacaoResponsavelValidacao = 'SISTEMA / DE ACORDO COM COEFICIENTE DE VARIAÇÃO';
	      this.horaValidacao = (0, _moment2.default)(new Date()).format('DD/MM/YYYY HH:mm:ss');
	    },
	    gravarCotacaoBase: function gravarCotacaoBase() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                obj = {
	                  fk_cotacao: _this2.idCotacao,
	                  fk_proposta: _this2.idProposta,
	                  validado: _this2.itemCotacaoValidado,
	                  valor_cotacao: _this2.totalItens,
	                  descricao: _this2.descricaoCotacao,
	                  responsavel_validacao: _this2.itemCotacaoResponsavelValidacao,
	                  data_validacao: _this2.horaValidacao
	                };
	                _context.next = 3;
	                return axiosLaravel.post('/cotacao/gravarCotacao/', obj).then(function (response) {
	                  console.log(response.data);
	                  var id = response.data;
	                  if (!isNaN(id)) {
	                    _this2.idCotacao = id;
	                    if (_this2.itensCotacao.length > 0) {
	                      _this2.gravaItensCotacaoBase(_this2.itensCotacao, false);
	                    } else if (_this2.itensCotacaoManual.length > 0) {
	                      _this2.gravaItensCotacaoBase(_this2.itensCotacaoManual, true);
	                    } else {
	                      _this2.$snotify.error('Erro no cadastro de banco de dados. Tente novamente mais tarde.');
	                      return;
	                    }
	                  } else {
	                    _this2.$snotify.error('Erro no cadastro de banco de dados. Tente novamente mais tarde.');
	                  }
	
	                  if (_this2.itensRemocao.length > 0) {
	                    console.log('existem itens para marcar como excluído', _this2.itensRemocao);
	                    _this2.removerItensBase();
	                  }
	
	                  _this2.$forceUpdate();
	                }).catch(function (error) {
	                  _this2.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    gravarValidacao: function gravarValidacao() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                obj = {
	                  fk_cotacao: _this3.idCotacao,
	                  validado: _this3.itemCotacaoValidado,
	                  responsavel_validacao: _this3.itemCotacaoResponsavelValidacao,
	                  data_validacao: _this3.horaValidacao
	                };
	                _context2.next = 3;
	                return axiosLaravel.post('/cotacao/gravarValidacaoCotacao/', obj).then(function (response) {
	                  console.log(response.data);
	
	                  _this3.$snotify.clear();
	                  _this3.$snotify.success(response.data);
	                  _this3.gravarValidacaoRow(obj.fk_cotacao, obj);
	                  _this3.fecharValidacao();
	                  _this3.$forceUpdate();
	                }).catch(function (error) {
	                  _this3.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    },
	    removerItensBase: function removerItensBase() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                obj = {
	                  ids: _this4.itensRemocao
	                };
	                _context3.next = 3;
	                return axiosLaravel.post('/cotacao/excluirItensCotacao/', obj).then(function (response) {
	                  console.log(response.data);
	                }).catch(function (error) {
	                  _this4.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    },
	    gravaItensCotacaoBase: function gravaItensCotacaoBase(itensCotacao, manual) {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
	
	        return _regenerator2.default.wrap(function _callee4$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context5.prev = 3;
	                _loop = _regenerator2.default.mark(function _loop() {
	                  var item;
	                  return _regenerator2.default.wrap(function _loop$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          item = _step.value;
	
	                          item.fk_cotacao = _this5.idCotacao;
	                          _context4.next = 4;
	                          return axiosLaravel.post('/cotacao/gravarItemCotacao/', item).then(function (response) {
	                            console.log(response.data);
	                            var id = response.data;
	                            if (!isNaN(id)) {
	                              item.id = id;
	                              if (manual) {
	                                _this5.gravaAnexos(item.anexos, item.id);
	                              }
	                            } else {
	                              _this5.$snotify.error('Erro no cadastro de banco de dados. Tente novamente mais tarde.');
	                            }
	
	                            _this5.$forceUpdate();
	                          }).catch(function (error) {
	                            _this5.$root.trataErro(error);
	                          });
	
	                        case 4:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _loop, _this5);
	                });
	                _iterator = (0, _getIterator3.default)(itensCotacao);
	
	              case 6:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context5.next = 11;
	                  break;
	                }
	
	                return _context5.delegateYield(_loop(), 't0', 8);
	
	              case 8:
	                _iteratorNormalCompletion = true;
	                _context5.next = 6;
	                break;
	
	              case 11:
	                _context5.next = 17;
	                break;
	
	              case 13:
	                _context5.prev = 13;
	                _context5.t1 = _context5['catch'](3);
	                _didIteratorError = true;
	                _iteratorError = _context5.t1;
	
	              case 17:
	                _context5.prev = 17;
	                _context5.prev = 18;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 20:
	                _context5.prev = 20;
	
	                if (!_didIteratorError) {
	                  _context5.next = 23;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 23:
	                return _context5.finish(20);
	
	              case 24:
	                return _context5.finish(17);
	
	              case 25:
	                _this5.retornaValoresEdicaoForm();
	
	              case 26:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee4, _this5, [[3, 13, 17, 25], [18,, 20, 24]]);
	      }))();
	    },
	    gravaAnexos: function gravaAnexos(anexos, idItemCotacao) {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop2, _iterator2, _step2;
	
	        return _regenerator2.default.wrap(function _callee5$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _iteratorNormalCompletion2 = true;
	                _didIteratorError2 = false;
	                _iteratorError2 = undefined;
	                _context7.prev = 3;
	                _loop2 = _regenerator2.default.mark(function _loop2() {
	                  var item, obj;
	                  return _regenerator2.default.wrap(function _loop2$(_context6) {
	                    while (1) {
	                      switch (_context6.prev = _context6.next) {
	                        case 0:
	                          item = _step2.value;
	
	                          item.fk_item_cotacao = idItemCotacao;
	                          obj = {
	                            idItemCotacao: idItemCotacao,
	                            documento: item
	                          };
	                          _context6.next = 5;
	                          return axiosLaravel.post('/cotacao/gravarAnexo/', obj).then(function (response) {
	                            console.log(response.data);
	                            var id = response.data;
	                            if (!isNaN(id)) {
	                              item.id = id;
	                            } else {
	                              _this6.$snotify.error('Erro no cadastro de banco de dados. Tente novamente mais tarde.');
	                            }
	
	                            _this6.$forceUpdate();
	                          }).catch(function (error) {
	                            _this6.$root.trataErro(error);
	                          });
	
	                        case 5:
	                        case 'end':
	                          return _context6.stop();
	                      }
	                    }
	                  }, _loop2, _this6);
	                });
	                _iterator2 = (0, _getIterator3.default)(anexos);
	
	              case 6:
	                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                  _context7.next = 11;
	                  break;
	                }
	
	                return _context7.delegateYield(_loop2(), 't0', 8);
	
	              case 8:
	                _iteratorNormalCompletion2 = true;
	                _context7.next = 6;
	                break;
	
	              case 11:
	                _context7.next = 17;
	                break;
	
	              case 13:
	                _context7.prev = 13;
	                _context7.t1 = _context7['catch'](3);
	                _didIteratorError2 = true;
	                _iteratorError2 = _context7.t1;
	
	              case 17:
	                _context7.prev = 17;
	                _context7.prev = 18;
	
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	
	              case 20:
	                _context7.prev = 20;
	
	                if (!_didIteratorError2) {
	                  _context7.next = 23;
	                  break;
	                }
	
	                throw _iteratorError2;
	
	              case 23:
	                return _context7.finish(20);
	
	              case 24:
	                return _context7.finish(17);
	
	              case 25:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee5, _this6, [[3, 13, 17, 25], [18,, 20, 24]]);
	      }))();
	    },
	    retornaValoresEdicaoForm: function retornaValoresEdicaoForm() {
	      var cotacaoValidado = {
	        responsavel: this.itemCotacaoResponsavelValidacaoBackup,
	        validado: this.itemCotacaoValidadoBackup,
	        horaValidacao: this.horaValidacaoBackup
	      };
	      this.$snotify.clear();
	      this.$snotify.success('Cotação Salva! Não esqueça de salvar a proposta.');
	      this.setDescricaoValor(this.descricaoCotacao, this.totalItens, this.itensCotacao, this.itensCotacaoManual, cotacaoValidado, this.idCotacao);
	      this.toggleCotacao(false);
	    },
	    resetarValidacao: function resetarValidacao() {
	      this.itemCotacaoValidado = false;
	      this.itemCotacaoResponsavelValidacao = null;
	      this.horaValidacao = null;
	    }
	  }
	};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadCotacaoManual = __webpack_require__(1700);
	
	var _uploadCotacaoManual2 = _interopRequireDefault(_uploadCotacaoManual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cotacaoItens',
	  components: {
	    uploadCotacaoManual: _uploadCotacaoManual2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      carregandoAnexos: false,
	      errorInput: false,
	      nomeItem: '',
	      justificativa: '',
	      valor: 0,
	      loading: {
	        show: false
	      },
	      anexos: []
	    };
	  },
	
	  props: {
	    toggleCotacaoManual: Function,
	    adicionarItemManual: Function,
	    visualizacao: { type: Boolean, default: false },
	    itemVisualizacao: { type: Object, default: {} }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {
	    this.initVisualizacao();
	  },
	  methods: {
	    gravarResultado: function gravarResultado(item) {
	
	      if (this.verificaCamposEmBranco()) {
	        console.log('CAMPOS EM BRANCO');
	        return;
	      }
	
	      this.adicionarItemManual(this.valor, this.nomeItem, this.justificativa, this.anexos);
	      this.toggleCotacaoManual(false);
	    },
	    verificaCamposEmBranco: function verificaCamposEmBranco() {
	      if (this.anexos.length < 2) {
	        console.log(this.anexos.length);
	        if (this.anexos.length === 0) {
	          this.$snotify.error('Anexe o documento referente ao Item antes de continuar.');
	          return true;
	        }
	        console.log(this.anexos[0].tipo_documento.ds_tipo);
	
	        var orcamentos = this.anexos.filter(function (anexo) {
	          return anexo.tipo_documento.ds_tipo === 'Orçamentos';
	        });
	        if (orcamentos.length < 2 && orcamentos.length !== 0) {
	          this.$snotify.error('Adicione pelo menos 02 (DOIS) orçamentos antes de continuar.');
	          return true;
	        }
	      }
	
	      if (this.nomeItem === '') {
	        this.$snotify.error('Preencha o NOME do Item de cotação antes de continuar.');
	        return true;
	      }
	      if (this.valor === 0) {
	        this.$snotify.error('Preencha o VALOR do Item de cotação antes de continuar.');
	        return true;
	      }
	      if (this.justificativa === '') {
	        this.$snotify.error('Preencha a JUSTIFICATIVA antes de continuar.');
	        return true;
	      }
	    },
	    initVisualizacao: function initVisualizacao() {
	      console.log('INIT');
	      if (!this.visualizacao && _.isEmpty(this.itemVisualizacao)) {
	        return;
	      } else {
	        this.buscaAnexos(this.itemVisualizacao.id);
	        this.nomeItem = this.itemVisualizacao.descricao;
	        this.justificativa = this.itemVisualizacao.justificativa;
	        this.valor = this.itemVisualizacao.valorMedio;
	
	        this.$forceUpdate();
	      }
	    },
	    buscaAnexos: function buscaAnexos(fkCotacao) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.carregandoAnexos = true;
	                _context.next = 3;
	                return axiosLaravel.get('cotacao/getAnexosCotacaoManual/' + fkCotacao).then(function (response) {
	                  _this.anexos = response.data;
	                  _this.carregandoAnexos = false;
	                }).catch(function (error) {
	                  console.log('error', error);
	
	                  _this.carregandoAnexos = false;
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _bancoPrecos = __webpack_require__(1694);
	
	var _bancoPrecos2 = _interopRequireDefault(_bancoPrecos);
	
	var _detalheItemLicitacao = __webpack_require__(251);
	
	var _detalheItemLicitacao2 = _interopRequireDefault(_detalheItemLicitacao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cotacaoItens',
	  components: {
	    bancoPrecos: _bancoPrecos2.default,
	    detalheItemLicitacao: _detalheItemLicitacao2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      errorInput: false,
	      nomeItem: '',
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'valor_item',
	        sortDesc: true,
	        sortDirection: 'desc',
	        fields: [{ key: 'actions', label: 'Detalhe', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'descricao_item', label: 'Item', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'quantidade_item_aprovado', label: 'QTD', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'sigla_uf', label: 'UF', sortable: true, thStyle: 'text-align: center', class: 'text-right' }, { key: 'valor_item', label: 'Valor Unitário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_resultado_licitacao', label: 'Data', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableSaneados: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'valor_item',
	        sortDesc: true,
	        sortDirection: 'desc',
	        fields: [{ key: 'actions', label: 'Detalhe', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'descricao_item', label: 'Item', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'valor_item', label: 'Valor Unitário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'diagnostico', label: 'Diagnóstico', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableContaminados: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'valor_item',
	        sortDesc: true,
	        sortDirection: 'desc',
	        fields: [{ key: 'actions', label: 'Detalhe', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'descricao_item', label: 'Item', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'valor_item', label: 'Valor Unitário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'diagnostico', label: 'Diagnóstico', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableRemovidosManual: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'valor_item',
	        sortDesc: true,
	        sortDirection: 'desc',
	        fields: [{ key: 'actions', label: 'Detalhe', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'item.descricao_item', label: 'Item', sortable: true, thStyle: 'text-align: left', class: 'text-center' }, { key: 'item.valor_item', label: 'Valor Unitário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'responsavel', label: 'Responsável', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'justificativa', label: 'Justificativa', sortable: true, thStyle: 'text-align: left', class: 'text-left' }]
	      },
	      universoAmostral: [],
	      universoAmostralFinal: [],
	      universoAmostralSaneado: [],
	      universoAmostralContaminado: [],
	      remocaoManual: [],
	      abrirBancoPrecos: true,
	      calculoAmostral: {
	        media: 0,
	        DP: 0,
	        CV: 0,
	        LS: 0,
	        LI: 0
	      },
	      calculoFinal: {
	        media: 0,
	        DP: 0,
	        CV: 0,
	        LS: 0,
	        LI: 0
	      },
	      abrirDetalheItem: false,
	      itemDetalheSelecionado: []
	    };
	  },
	
	  props: {
	    toggleAdicionarItem: Function,
	    adicionarItem: Function
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {},
	  methods: {
	    detalharItem: function detalharItem(item) {
	      var _this = this;
	
	      console.log(item);
	      this.itemDetalheSelecionado = item;
	      setTimeout(function () {
	        return _this.$refs.detalhamentoContainer.scrollIntoView({ behavior: 'smooth' });
	      }, 100);
	      this.toggleDetalhe(true);
	    },
	    toggleDetalhe: function toggleDetalhe(valor) {
	      this.abrirDetalheItem = valor;
	    },
	    toggleBancoPrecos: function toggleBancoPrecos(valor) {
	      var _this2 = this;
	
	      console.log('toggle banco precos');
	      if (valor && this.universoAmostral.length > 0) {
	        this.$dialog.confirm('Se você fizer uma nova pesquisa no banco de cotações e clicar em <b>Utilizar Resultado</b> a COTAÇÃO anterior será <b>sobreescrita</b>. Continua?', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	          console.log(_this2.abrirBancoPrecos);
	          _this2.abrirBancoPrecos = valor;
	          console.log(_this2.abrirBancoPrecos).catch(function (error) {
	            console.log(error);
	            return;
	          });
	        });
	      } else {
	        this.abrirBancoPrecos = valor;
	      }
	    },
	    gravaSelecaoItens: function gravaSelecaoItens(itens, definicao, remocaoManual) {
	      this.limpar();
	      this.universoAmostral = itens;
	      this.nomeItem = definicao;
	      this.table.items = this.universoAmostral;
	      this.remocaoManual = remocaoManual;
	      this.tableRemovidosManual.items = this.remocaoManual;
	      this.calcularAmostra();
	    },
	    calcularAmostra: function calcularAmostra() {
	      this.calcularVariaveis(this.universoAmostral, this.calculoAmostral);
	
	      this.removerLimites(this.universoAmostral);
	
	      this.atualizarTabelas();
	    },
	    calcularVariaveis: function calcularVariaveis(universo, resultado) {
	      var amostra = universo.map(function (item) {
	        return parseFloat(item.valor_item);
	      });
	      var n = amostra.length;
	      var media = amostra.reduce(function (a, b) {
	        return a + b;
	      }) / n;
	      var variancia = amostra.map(function (x) {
	        return Math.pow(x - media, 2);
	      }).reduce(function (a, b) {
	        return a + b;
	      }) / (n - 1);
	      var desvioPadrao = Math.sqrt(variancia);
	      var coeficienteVariacao = desvioPadrao.toFixed(2) / media.toFixed(2) * 100;
	      var limiteSuperior = media + desvioPadrao;
	      var limiteInferior = Math.abs(media - desvioPadrao);
	      resultado.media = media.toFixed(2);
	      resultado.DP = desvioPadrao.toFixed(2);
	      resultado.CV = coeficienteVariacao.toFixed(2);
	      resultado.LS = limiteSuperior.toFixed(2);
	      resultado.LI = limiteInferior.toFixed(2);
	    },
	    removerLimites: function removerLimites(amostra) {
	      var _this3 = this;
	
	      var LS = this.calculoAmostral.LS;
	      var LI = this.calculoAmostral.LI;
	      this.universoAmostralFinal = [];
	      this.universoAmostralSaneado = [];
	      amostra.forEach(function (item) {
	        if (parseFloat(item.valor_item) <= LS && parseFloat(item.valor_item) >= LI) {
	          _this3.universoAmostralFinal.push(item);
	        } else {
	          _this3.universoAmostralSaneado.push(item);
	        }
	      });
	      console.log(this.universoAmostralFinal);
	
	      if (this.universoAmostralFinal.length <= 1) {
	        this.removeMaiorValor();
	        return;
	      }
	
	      this.calcularVariaveis(this.universoAmostralFinal, this.calculoFinal);
	    },
	    removeMaiorValor: function removeMaiorValor() {
	      var indiceMaiorValor = this.universoAmostral.reduce(function (maxIndex, item, index, array) {
	        return parseFloat(item.valor_item) > parseFloat(array[maxIndex].valor_item) ? index : maxIndex;
	      }, 0);
	      this.universoAmostralContaminado.push(this.universoAmostral[indiceMaiorValor]);
	      this.universoAmostral.splice(indiceMaiorValor, 1);
	      this.calcularAmostra();
	    },
	    atualizarTabelas: function atualizarTabelas() {
	      this.table.items = this.universoAmostralFinal;
	      this.tableSaneados.items = this.universoAmostralSaneado;
	      this.tableContaminados.items = this.universoAmostralContaminado;
	      this.$forceUpdate();
	    },
	    limparSelecao: function limparSelecao() {
	      var _this4 = this;
	
	      this.$dialog.confirm('Deseja limpar a pesquisa? A referência dos itens será <b>Perdida</b>. Continuar?', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	        _this4.limpar().catch(function (error) {
	          console.log(error);
	          return;
	        });
	      });
	    },
	    limpar: function limpar() {
	      this.nomeItem = '';
	      this.table.items = [];
	      this.tableSaneados.items = [];
	      this.tableContaminados.items = [];
	      this.universoAmostral = [];
	      this.universoAmostralFinal = [];
	      this.universoAmostralSaneado = [];
	      this.universoAmostralContaminado = [];
	      this.abrirBancoPrecos = false;
	      this.calculoAmostral = {
	        media: 0,
	        DP: 0,
	        CV: 0,
	        LS: 0,
	        LI: 0
	      };
	      this.calculoFinal = {
	        media: 0,
	        DP: 0,
	        CV: 0,
	        LS: 0,
	        LI: 0
	      };
	    },
	    salvarCotacaoItem: function salvarCotacaoItem() {
	      if (this.universoAmostralFinal.length <= 0) {
	        this.$snotify.error('Atenção, pesquise o item de cotação antes de concluir. Ou clique em cancelar e cadastre manualmente uma cotação.');
	        return;
	      }
	      if (this.nomeItem === '') {
	        this.$snotify.error('Atenção, cadastre o nome do item de cotação antes de continuar.');
	        this.errorInput = true;
	        this.$refs.nomeItemCotacao.scrollIntoView({ behavior: 'smooth' });
	        return;
	      }
	
	      this.adicionarItem(this.universoAmostralFinal, this.universoAmostralSaneado, this.universoAmostralContaminado, this.calculoFinal.media, this.nomeItem, this.calculoFinal.CV, this.calculoAmostral, this.calculoFinal, this.remocaoManual);
	      this.toggleAdicionarItem(false);
	    }
	  }
	};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _cotacaoItens = __webpack_require__(514);
	
	var _cotacaoItens2 = _interopRequireDefault(_cotacaoItens);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var itemFormOriginal = {
	  observacao: null,
	  origem: null,
	  periodo_inicial: null,
	  recurso: null,
	  adiantavel: null,
	  unidade_medida: null,
	  item: {
	    ds_code: '',
	    ds_description: '',
	    valor_unitario: null,
	    status: null,
	    ds_type: null
	  },
	  quantidade: null,
	  periodo_final: null,
	  valorTotal: null,
	
	  itemCotacao: [],
	  itemCotacaoManual: [],
	  itemCotacaoValidado: {
	    responsavel: '',
	    validado: false,
	    horaValidacao: new Date()
	  },
	  fk_cotacao: '',
	  valor_unitario: 0
	};
	exports.default = {
	  name: 'cronogramaCotacao',
	  components: {
	    cotacaoItens: _cotacaoItens2.default
	  },
	  data: function data() {
	    return {
	      showForm: false,
	      totalCusteio: 0,
	      totalInvestimento: 0,
	      totalCapacitacao: 0,
	      totalAssessoria: 0,
	      entidadeEhFundacao: false,
	      abrirSistemaCotacao: false,
	      abrirSistemaCotacaoManual: false,
	      bloqueiaBotoes: false,
	      conta_financeira: {},
	      objetivos: [],
	      blockSelect: false,
	      atividade: {},
	      totais: {
	        projeto: {
	          fbb: 0,
	          parceiros: 0,
	          contrapartida: 0,
	          total: 0
	        },
	        adiantavel: {
	          fbb: 0,
	          parceiros: 0,
	          total: 0
	        },
	        itens: {
	          fbb: 0,
	          parceiros: 0,
	          contrapartida: 0,
	          adiantaveis: 0,
	          total: 0
	        }
	      },
	      itemForm: {
	        itens_orcamentos: [],
	        conta_financeira: {},
	        adiantavel: null,
	        item: null,
	        valor_cotado: null
	      },
	      medidas: ['Caixas', 'Capacitações', 'Rolos', 'Unidades', 'Outros'],
	      componentKey: 0,
	      itemTabela: {},
	      items: [],
	      formasContratacao: [],
	      contasFinanceiras: [],
	      editando: false,
	      adicionando: false,
	
	      atividadeTabela: {},
	      rules: 'required|min_value:1|max_value:' + this.meses,
	      submitDisabled: false,
	      editarCotacao: false,
	      validarCotacao: false,
	      visualizarCotacao: false
	    };
	  },
	
	  props: ['propsObjetivos', 'propsAtividades', 'propsMetas', 'proposta', 'meses', 'projetoDuplicacao'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    valorTotal: function valorTotal(itemForm) {
	      itemForm.itemForm.totalValue = parseInt(itemForm.valor_unitario * itemForm.quantidade);
	      return itemForm.itemForm;
	    }
	  }),
	  watch: {
	    propsObjetivos: function propsObjetivos() {
	      this.$forceUpdate();
	    },
	    valorTotal: function valorTotal(itemForm) {
	      this.$forceUpdate();
	    },
	    proposta: function proposta() {},
	    projetoDuplicacao: function projetoDuplicacao() {
	      this.buscaContasFinanceiras();
	    },
	    meses: function meses() {
	      this.$forceUpdate();
	    },
	    propsAtividades: function propsAtividades() {
	      this.$forceUpdate();
	    }
	  },
	  created: function created() {
	    this.entidadeEhFundacao = this.proposta.entidade.ds_cnpj === '01641000000133';
	
	    this.buscaItensDespesas();
	    this.calcularTotais();
	    this.$validator.extend('periodoValido');
	  },
	  methods: {
	    calcularTotais: function calcularTotais() {
	      this.totais.projeto.fbb = 0;
	      this.totais.projeto.parceiros = 0;
	      this.totais.projeto.contrapartida = 0;
	      this.totais.adiantavel.fbb = 0;
	      this.totais.adiantavel.parceiros = 0;
	
	      this.totais.itens.fbb = 0;
	      this.totais.itens.parceiros = 0;
	      this.totais.itens.contrapartida = 0;
	      this.totais.itens.adiantaveis = 0;
	
	      var vm = this;
	
	      this.totais.projeto.fbb = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          if ('' + ite.origem === '1') {
	            vm.totais.itens.fbb++;
	            return _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade);
	          } else return 0;
	        });
	      });
	      this.totais.projeto.contrapartida = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          if ('' + ite.origem === '2') {
	            vm.totais.itens.contrapartida++;
	            return _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade);
	          } else return 0;
	        });
	      });
	      this.totais.projeto.parceiros = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          if ('' + ite.origem === '5') {
	            vm.totais.itens.parceiros++;
	            return _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade);
	          } else return 0;
	        });
	      });
	      this.totais.adiantavel.fbb = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return '' + ite.origem === '1' && '' + ite.adiantavel === '1' ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totais.adiantavel.parceiros = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return '' + ite.origem === '5' && '' + ite.adiantavel === '1' ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totalCusteio = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return '' + ite.ds_type === 'SERVICO' && !_.includes(['S0585', 'S0601', 'S0599'], ite.item.ds_code) ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totalInvestimento = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return '' + ite.ds_type === 'PRODUTO' || _.includes(['S0585', 'S0601', 'S0599'], ite.item.ds_code) ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totalCapacitacao = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return ite.item.ds_code === 'S0587' ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totalAssessoria = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return ite.item.ds_code === 'S0586' ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	
	      this.totais.projeto.total = this.totais.projeto.fbb + this.totais.projeto.parceiros + this.totais.projeto.contrapartida;
	      this.totais.adiantavel.total = this.totais.adiantavel.fbb + this.totais.adiantavel.parceiros;
	      this.totais.itens.total = this.totais.itens.fbb + this.totais.itens.parceiros + this.totais.itens.contrapartida;
	
	      this.$forceUpdate();
	
	      var bc = new BroadcastChannel('propostas');
	      bc.postMessage({ acao: 'notificacaoAtualizacaoCronograma', id: this.proposta.id });
	
	      var semContrapartida = this.totais.projeto.contrapartida === 0;
	      this.$emit('validacaoCronograma', { 'tag': 'cronogramaContrapartida', 'ativo': semContrapartida && !this.entidadeEhFundacao, 'tipo': 'restricao', 'acao': null, 'mensagem': 'É obrigatório registrar <b>Contrapartida</b> ao Cronograma' });
	
	      var itemSemContaFinanceira = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (item) {
	          return !_.has(item, 'conta_financeira') || !_.isNumber(item.conta_financeira['numero_conta']) ? 1 : 0;
	        });
	      });
	      this.$emit('validacaoCronograma', { 'tag': 'cronogramaFaltaContaFinanceira', 'ativo': itemSemContaFinanceira > 0 && this.proposta.ds_fase === 'ANALISE', 'tipo': 'restricao', 'acao': null, 'mensagem': 'Ainda há <b>' + itemSemContaFinanceira + '</b> item(ns) sem contas financeiras indicadas' });
	    },
	    buscaItensDespesas: function buscaItensDespesas() {
	      var _this = this;
	
	      axiosLaravel.post('itens/contratacao', { 'tipos': ['PRODUTO', 'SERVICO'] }).then(function (response) {
	        _this.$store.state.itensDespesa = response.data;
	      });
	      this.items = this.$store.state.itensDespesa;
	    },
	    propostaDentroFbb: function propostaDentroFbb() {
	      return _.includes(['ANALISE', 'DEFERIMENTO', 'FORMALIZACAO', 'APROVACAO_PROJETO'], this.proposta.ds_fase);
	    },
	    itemCodigo: function itemCodigo(_ref) {
	      var ds_code = _ref.ds_code,
	          ds_description = _ref.ds_description;
	
	      return ds_code + ' / ' + ds_description;
	    },
	    contaCodigo: function contaCodigo(_ref2) {
	      var numero_conta = _ref2.numero_conta,
	          descricao = _ref2.descricao;
	
	      return numero_conta + ' / ' + descricao;
	    },
	    buscaContasFinanceiras: function buscaContasFinanceiras(row) {
	      var _this2 = this;
	
	      var codigoItem = '';
	      if (row.ds_code) {
	        codigoItem = row.ds_code;
	      }
	      if (row.item) {
	        codigoItem = row.item.ds_code;
	      }
	      var tipoItem = codigoItem.substring(0, 1);
	      this.itemForm['ds_type'] = tipoItem === 'P' ? 'PRODUTO' : tipoItem === 'S' ? 'SERVICO' : 'ERRO';
	      var projDuplicacao = this.projetoDuplicacao;
	      var fase = this.itemForm.origem;
	      var obj = {};
	      obj.item = codigoItem;
	      obj.duplicador = projDuplicacao;
	      obj.fase = fase;
	      if (this.projetoDuplicacao) {
	        axiosLaravel.post('busca_conta_financeira/', obj).then(function (response) {
	          _this2.contasFinanceiras = response.data;
	          if (_this2.contasFinanceiras.length === 1) {
	            _this2.itemForm.conta_financeira = _this2.contasFinanceiras[0];
	            _this2.blockSelect = true;
	          } else {
	            _this2.blockSelect = false;
	          }
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    cancelaItem: function cancelaItem(atividade, item, itemIndex) {
	      if (this.editando !== true) {
	        atividade.itens_orcamentos.pop();
	      }
	      this.itemForm = (0, _assign2.default)({}, itemFormOriginal);
	      this.itemTabela = {};
	      this.editando = false;
	      this.adicionando = false;
	      item.editando = false;
	      this.bloqueiaBotoes = false;
	    },
	    validaPeriodo: function validaPeriodo() {
	      if (_.toSafeInteger(this.itemForm.periodo_final) < _.toSafeInteger(this.itemForm.periodo_inicial) && this.itemForm.periodo_final && this.itemForm.periodo_inicial) {
	        var error = {
	          field: 'inicio',
	          msg: 'Período inicial não pode ser maior que o fim'
	        };
	        this.$validator.errors.add(error);
	        this.submitDisabled = true;
	        return;
	      } else {
	        this.$validator.reset();
	        this.submitDisabled = false;
	      }
	    },
	    onAdd: function onAdd(atividade) {
	      var _this3 = this;
	
	      console.log('ONADD');
	      if (this.submitDisabled) {
	        return;
	      }
	
	      if (this.itemForm.item.ds_type === null || _.isEmpty(this.itemForm.item.ds_code)) {
	        var error = {
	          field: 'item',
	          msg: 'item não prenchido'
	        };
	        this.$validator.errors.add(error);
	        return;
	      } else {
	        this.$validator.errors.remove('item', 'item não prenchido');
	      }
	
	      if (this.editando === false) {
	        var observacao_form = this.itemForm.observacao.trim();
	        var obs_duplicada = _.find(this.propsAtividades, function (atividade) {
	          return _.find(atividade.itens_orcamentos, function (item) {
	            return item.observacao === observacao_form;
	          });
	        });
	        if (obs_duplicada) {
	          var _error = {
	            field: 'descrição item',
	            msg: 'Descrição do item já utilizada neste cronograma. Gentileza alterar a descrição.'
	          };
	          this.$validator.errors.add(_error);
	          return;
	        } else {
	          this.$validator.errors.remove('descrição item', 'descrição duplicada');
	        }
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this3.editando === true) {
	            if (_this3.itemForm.itemCotacao.length === 0 && _this3.itemForm.itemCotacaoManual.length === 0) {
	              delete _this3.itemForm.itemCotacao;
	              delete _this3.itemForm.itemCotacaoManual;
	              delete _this3.itemForm.itemCotacaoValidado;
	            } else {
	              console.log('Verifica alteracoes', _this3.itemForm.observacao, _this3.itemTabela.observacao);
	              if (_this3.itemForm.observacao !== _this3.itemTabela.observacao || _this3.itemForm.quantidade !== _this3.itemTabela.quantidade || _this3.itemForm.valor_cotado !== _this3.itemTabela.valor_cotado) {
	                console.log('Atualizacao pendente de validacao');
	                _this3.itemForm.itemCotacaoValidado = {
	                  reponsavel: '',
	                  validado: false,
	                  horaValidacao: ''
	                };
	              }
	            }
	            for (var i in _this3.itemForm) {
	              _this3.itemTabela[i] = _this3.itemForm[i];
	            }
	          } else {
	            atividade.itens_orcamentos.pop();
	            var item = (0, _assign2.default)({}, _this3.itemForm);
	            item.editando = false;
	
	            if (item.itemCotacao.length === 0 && item.itemCotacaoManual.length === 0) {
	              delete item.itemCotacao;
	              delete item.itemCotacaoManual;
	              delete item.itemCotacaoValidado;
	            }
	            atividade.itens_orcamentos.push(item);
	          }
	          _this3.itemForm = (0, _assign2.default)({}, itemFormOriginal);
	          _this3.itemTabela = {};
	          _this3.editando = false;
	          _this3.adicionando = false;
	          _this3.itemForm.editando = false;
	          _this3.bloqueiaBotoes = false;
	
	          _this3.calcularTotais();
	          _this3.$forceUpdate();
	        }
	      });
	      this.$forceUpdate();
	    },
	    somaTotal: function somaTotal(items) {
	      if (items !== undefined) {
	        if (items.length > 0) {
	          return items.reduce(function (total, item) {
	            if (item.valor_unitario) {
	              return total + item.valor_unitario * item.quantidade;
	            }
	          }, 0);
	        }
	      }
	    },
	    editaItem: function editaItem(atividade, atividadeIndex, item, itemIndex) {
	      if (this.proposta.ds_fase === 'ANALISE' && _.isNil(this.projetoDuplicacao)) {
	        this.$dialog.alert('Selecione um <b>Projeto de Duplicação</b> antes de Editar este item', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	      } else {
	        this.itemForm = (0, _assign2.default)({}, item);
	        if (!this.itemForm.hasOwnProperty('fk_cotacao')) {
	          this.itemForm.fk_cotacao = '';
	        }
	        if (!this.itemForm.hasOwnProperty('itemCotacao')) {
	          this.itemForm.itemCotacao = [];
	        }
	        if (!this.itemForm.hasOwnProperty('itemCotacaoManual')) {
	          this.itemForm.itemCotacaoManual = [];
	        }
	        if (!this.itemForm.hasOwnProperty('itemCotacaoValidado')) {
	          this.itemForm.itemCotacaoValidado = {
	            reponsavel: '',
	            validado: false,
	            horaValidacao: ''
	          };
	        }
	
	        this.buscaContasFinanceiras(item);
	        this.itemTabela = item;
	        item.editando = true;
	        this.editando = true;
	        this.bloqueiaBotoes = true;
	        this.$forceUpdate();
	        console.log('editaItem() - item: ', item);
	      }
	    },
	    addItem: function addItem(atividade, atividadeIndex) {
	      if (this.proposta.ds_fase === 'ANALISE' && _.isNil(this.projetoDuplicacao)) {
	        this.$dialog.alert('Selecione um <b>Projeto de Duplicação</b> antes de Adicionar item', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	      } else {
	        this.itemForm = (0, _assign2.default)({}, itemFormOriginal);
	        if (!atividade.itens_orcamentos) {
	          atividade.itens_orcamentos = [];
	          this.$forceUpdate();
	        }
	        this.itemForm.itemCotacao = [];
	        this.itemForm.itemCotacaoManual = [];
	        this.itemForm.editando = true;
	        this.adicionando = true;
	        atividade.itens_orcamentos.push((0, _assign2.default)({}, this.itemForm));
	        this.$forceUpdate();
	        this.abrirCotacao();
	      }
	    },
	    deleteItem: function deleteItem(atividade, atividadeIndex, item, itemIndex) {
	      atividade.itens_orcamentos.splice(itemIndex, 1);
	      this.calcularTotais();
	    },
	    deleteTodos: function deleteTodos(retorno) {
	      if (retorno === 'ok') {
	        this.propsAtividades.forEach(function (prop) {
	          return prop.itens_orcamentos.splice(prop.length);
	        });
	      }
	      this.calcularTotais();
	    },
	    selecionaConta: function selecionaConta(conta) {
	      this.itemForm.conta_financeira = conta;
	    },
	    zeraAdiantamento: function zeraAdiantamento() {
	      if ('' + this.itemForm.origem === '2') {
	        this.itemForm.adiantavel = 0;
	      }
	      if ('' + this.itemForm.origem === '1') {
	        this.itemForm.adiantavel = 1;
	      }
	    },
	    toggleCotacao: function toggleCotacao(valor) {
	      this.$refs.cotacaoContainer.scrollIntoView({ behavior: 'smooth' });
	      this.abrirSistemaCotacao = valor;
	    },
	    abrirCotacao: function abrirCotacao() {
	      this.toggleCotacao(true);
	      if (this.itemForm.itemCotacao.length > 0 || this.itemForm.itemCotacaoManual.length > 0) {
	        this.editarCotacao = true;
	      } else {
	        this.editarCotacao = false;
	      }
	    },
	    toggleCotacaoManual: function toggleCotacaoManual() {
	      this.itemForm.itemCotacao = [];
	      this.itemForm.itemCotacaoManual = [];
	      this.itemForm.itemCotacao.push('Orçamento Manual');
	    },
	    setDescricaoValor: function setDescricaoValor(descricao, valor, cotacao, cotacaoManual, validacao, fk_cotacao) {
	      this.itemForm.fk_cotacao = fk_cotacao;
	      this.itemForm.valor_unitario = valor;
	      this.itemForm.valor_cotado = valor;
	      this.itemForm.observacao = descricao;
	      this.itemForm.itemCotacao = [];
	      this.itemForm.itemCotacao.push(cotacao);
	      this.itemForm.itemCotacaoManual = [];
	      cotacaoManual.forEach(function (cotacao) {
	        cotacao.anexos.forEach(function (anexo) {
	          anexo.file = null;
	        });
	      });
	      console.log('cotacaoManual:', cotacaoManual);
	      this.itemForm.itemCotacaoManual.push(cotacaoManual);
	      this.itemForm.itemCotacaoValidado = {
	        responsavel: validacao.responsavel,
	        validado: validacao.validado,
	        horaValidacao: validacao.horaValidacao
	      };
	    },
	    abrirCotacaoValidacao: function abrirCotacaoValidacao(item, visualizacao) {
	      this.validarCotacao = true;
	      this.editarCotacao = false;
	      this.visualizandoCotacao = visualizacao;
	      this.itemForm = (0, _assign2.default)({}, item);
	    },
	    fecharValidacao: function fecharValidacao() {
	      this.itemForm = (0, _assign2.default)({}, itemFormOriginal);
	      this.validarCotacao = false;
	      this.editarCotacao = false;
	      this.$forceUpdate();
	    },
	    verificaValidacao: function verificaValidacao(item) {
	      if (!item.hasOwnProperty('itemCotacaoValidado')) {
	        return 'legado';
	      } else {
	        if (item.itemCotacaoValidado.validado) {
	          if (item.itemCotacaoManual[0].length > 0) {
	            return 'validado-manual';
	          }
	          if (item.itemCotacaoValidado.responsavel === 'SISTEMA / DE ACORDO COM COEFICIENTE DE VARIAÇÃO') {
	            return 'validado-automatico';
	          }
	          return 'validado';
	        } else {
	          return 'pendente-validacao';
	        }
	      }
	    },
	    gravarValidacaoRow: function gravarValidacaoRow(fkCotacao, validacao) {
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.hasOwnProperty('itens_orcamentos')) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (item.hasOwnProperty('fk_cotacao')) {
	              if (item.fk_cotacao === fkCotacao) {
	                if (!item.hasOwnProperty('itemCotacaoValidado')) {
	                  item.itemCotacaoValidado = {
	                    reponsavel: '',
	                    validado: false,
	                    horaValidacao: ''
	                  };
	                }
	                item.itemCotacaoValidado = validacao;
	              }
	            }
	          });
	        }
	      });
	    },
	    verificaPendentesDeValidacao: function verificaPendentesDeValidacao() {
	      var resultado = true;
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.hasOwnProperty('itens_orcamentos')) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (item.hasOwnProperty('itemCotacaoValidado')) {
	              var itemValidado = item.itemCotacaoValidado;
	              console.log(item.itemCotacaoValidado);
	              if (itemValidado.hasOwnProperty('validado')) {
	                if (!item.itemCotacaoValidado.validado) {
	                  console.log('não tem');
	                  resultado = false;
	                }
	              } else {
	                console.log('não tem');
	                resultado = false;
	              }
	            }
	          });
	        }
	      });
	      return resultado;
	    }
	  }
	};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _detalheItemLicitacao = __webpack_require__(251);
	
	var _detalheItemLicitacao2 = _interopRequireDefault(_detalheItemLicitacao);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'detalheItemCotacao',
	  components: {
	    detalheItemLicitacao: _detalheItemLicitacao2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      calculoFinal: [],
	      calculoAmostral: [],
	      showAll: false
	    };
	  },
	
	  props: {
	    itemCotacao: Object,
	    toggleDetalharItem: Function
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {
	    this.calculoFinal = this.itemCotacao.calculoFinal;
	    this.calculoAmostral = this.itemCotacao.calculoAmostral;
	  },
	  methods: {}
	};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _itemDetalheLicitacao = __webpack_require__(1699);
	
	var _itemDetalheLicitacao2 = _interopRequireDefault(_itemDetalheLicitacao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'detalheItemLicitacao',
	  components: {
	    itemDetalheLicitacao: _itemDetalheLicitacao2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default
	    };
	  },
	
	  props: {
	    itemLicitacao: Object,
	    toggleDetalhe: Function,
	    relatorioCotacao: Boolean,
	    index: { type: Number, default: 0 },
	    total: { type: Number, default: 0 },
	    showAll: { type: Boolean, default: true },
	    removidoManual: { type: Boolean, default: false }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {},
	  methods: {
	    linkLicitacao: function linkLicitacao(fonteDados) {
	      if (fonteDados === 'AOP') {
	        return 'https://www.licitacoes-e.com.br/aop/';
	      }
	      if (fonteDados === 'PNCP') {
	        return 'https://pncp.gov.br/app/editais?pagina=1';
	      }
	      if (fonteDados === 'Portal da transparencia') {
	        return 'https://portaldatransparencia.gov.br/licitacoes/consulta';
	      }
	      return '';
	    }
	  }
	};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'detalheItemLicitacao',
	  components: {},
	  data: function data() {
	    return {
	      moment: _moment2.default
	    };
	  },
	
	  props: {
	    titulo: String,
	    icone: String,
	    value: String,
	    formatarValor: Boolean,
	    link: { type: Boolean, default: false }
	  },
	  methods: {}
	};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _deepObjectDiff = __webpack_require__(83);
	
	var _downloadjs = __webpack_require__(119);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'uploadCotacaoManual',
	  data: function data() {
	    return {
	      showGrid: true,
	      tamanho: 0,
	      contador: 0,
	      tamanhoFormatado: 0,
	      salvou: false,
	      acmTamanho: 0,
	      totalMb: 0,
	      documentos: [],
	      documento: {
	        ds_nome_arquivo: '',
	        ligacao_sub_type: ''
	      },
	      documentoTabela: {},
	      editando: false,
	      mostraInclusao: false,
	      mostraExclusao: false,
	      mostraAlteracao: false,
	      dt_data_vigencia: '',
	      indiceAlt: -1,
	      ocultaIcone: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      listaOrdenada: {},
	      mudancas: [],
	      conteudoAnterior: {},
	      table: {
	        items: this.propDocumentos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        totalRows: 0,
	        currentPage: 1,
	        perPage: 100,
	        sortBy: 'dt_criado',
	        sortDesc: true,
	        fields: [{
	          key: 'tipo_documento.ds_tipo',
	          label: 'Tipo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 35%',
	          class: 'text-center'
	        }, {
	          key: 'ds_nome_arquivo',
	          label: 'Arquivo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 30%',
	          class: 'text-center'
	        }, { key: 'dt_criado', label: 'Inclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'documentosObrigatorios', 'disable', 'localUso', 'mudaDocumento', 'diferenca', 'analise', 'revisao', 'salvouOK', 'propsEtapa', 'faseProposta', 'editandoAlteracaoProjeto', 'editandoProrrogacao', 'maxFiles'],
	  watch: {
	    propDocumentos: function propDocumentos() {
	      this.table.items = this.propDocumentos;
	      this.table.totalRows = this.table.items.length;
	      if (this.disable === 'disable') {
	        this.desativado = this.disable;
	      }
	    },
	    diferenca: function diferenca() {
	      this.diferencaDoc = this.diferenca;
	    },
	    analise: function analise() {
	      if (this.analise) {
	        this.analiseDoc = this.analise.documentos;
	      }
	    },
	    dt_data_vigencia: function dt_data_vigencia(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.documento.dt_data_vigencia = newdate.format('YYYY-MM-DD');
	      }
	    },
	    revisao: function revisao() {
	      if (this.revisao) {
	        this.revisaoDoc = this.revisao.documentos;
	      }
	      this.mostraExclusao = false;
	      this.mostraInclusao = false;
	      if (this.analiseDoc && this.revisaoDoc) {
	        if (this.analiseDoc.length > this.revisaoDoc.length) {
	          this.mostraExclusao = true;
	          this.mostraInclusao = false;
	        } else {
	          this.mostraExclusao = true;
	        }
	        if (this.analiseDoc.length < this.revisaoDoc.length) {
	          this.mostraInclusao = true;
	          this.mostraExclusao = false;
	        } else {
	          this.mostraInclusao = false;
	        }
	        if (this.analiseDoc.length === this.revisaoDoc.length) {
	          this.mostraExclusao = false;
	        }
	      }
	      this.adicionados = (0, _deepObjectDiff.detailedDiff)(this.analise, this.revisao).added;
	
	      this.excluidos = _.differenceBy(this.analise.documentos, this.revisao.documentos, 'tipo_documento.ds_tipo');
	      this.atualizados = (0, _deepObjectDiff.detailedDiff)(this.analise.documentos, this.revisao.documentos).updated;
	
	      if (this.adicionados) {
	        if (this.adicionados.documentos) {
	          this.inclDoc = this.adicionados.documentos;
	          this.inclDocTexto = _.map(this.inclDoc, 'tipo_documento.ds_tipo');
	          this.naoExisteDoc = false;
	        } else {
	          this.naoExisteDoc = true;
	        }
	      }
	      if (this.excluidos) {
	        this.excDocTexto = _.map(this.excluidos, 'tipo_documento.ds_tipo');
	      }
	    },
	    mudaDocumento: function mudaDocumento() {
	      this.mudancas = this.mudaDocumento.documentos;
	      if (this.mudancas) {
	        if (_.findKey(this.mudancas, 'ds_nome_arquivo')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_nome_arquivo');
	        }
	        if (_.findKey(this.mudancas, 'ds_content_type')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_content_type');
	        }
	        if (_.findKey(this.mudancas, 'fk_tipo_documento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'fk_tipo_documento');
	        }
	        if (_.findKey(this.mudancas, 'dt_data_validade')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'dt_data_validade');
	        }
	        if (_.findKey(this.mudancas, 'tipo_documento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'tipo_documento');
	        }
	        if (this.indiceAlt !== -1) {
	          this.mostraAlteracao = true;
	          this.texto = this.diferencaDoc.documentos[this.indiceAlt];
	        } else {
	          this.mostraAlteracao = false;
	        }
	      }
	    },
	    salvouOK: function salvouOK() {
	      this.salvou = this.salvouOK;
	      if (this.salvou === true) {
	        this.totalMb = 0;
	        this.acmTamanho = 0;
	      }
	    }
	  },
	  computed: {
	    progress: function progress() {
	      return (this.totalMb / 80 * 100).toFixed(2);
	    },
	    PropEditandoAlteracaoProjeto: function PropEditandoAlteracaoProjeto() {
	      if (this.editandoAlteracaoProjeto) {
	        return this.editandoAlteracaoProjeto;
	      } else {
	        return false;
	      }
	    },
	    PropProrrogacaoEdit: function PropProrrogacaoEdit() {
	      if (this.editandoProrrogacao) {
	        return this.editandoProrrogacao;
	      } else {
	        return false;
	      }
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (_this.localUso === undefined) {
	                _this.localUso = 'TODOS';
	              }
	
	              if (!(_this.localUso === 'TODOS')) {
	                _context.next = 11;
	                break;
	              }
	
	              if (!_.isEmpty(_this.$store.state.uploadDocumentos.documentos)) {
	                _context.next = 7;
	                break;
	              }
	
	              _context.next = 5;
	              return axiosLaravel.post('documentos/tipos/' + _this.localUso).then(function (response) {
	                _this.documentos = _this.$store.state.uploadDocumentos.documentos = _.sortBy(response.data, [function (o) {
	                  return o.ds_tipo;
	                }]);
	                _this.$forceUpdate();
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 5:
	              _context.next = 9;
	              break;
	
	            case 7:
	              _this.documentos = _this.$store.state.uploadDocumentos.documentos;
	              _this.$forceUpdate();
	
	            case 9:
	              _context.next = 13;
	              break;
	
	            case 11:
	              _context.next = 13;
	              return axiosLaravel.post('documentos/tipos/' + _this.localUso).then(function (response) {
	                _this.documentos = _.sortBy(response.data, [function (o) {
	                  return o.ds_tipo;
	                }]);
	                _this.$forceUpdate();
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 13:
	              if (_.isNull(_this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(_this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	                axiosLaravel.get('configuracoes/').then(function (response) {
	                  _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	                    return item.ds_mime_type;
	                  }).join('|');
	                  _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	              } else {
	                _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos;
	                _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido;
	              }
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    novoDocumento: function novoDocumento() {
	      if (this.maxFiles !== undefined) {
	        if (this.propDocumentos.length === this.maxFiles) {
	          this.$snotify.error('Número máximo de documentos por licença atingido, favor verificar.');
	          this.onCancel();
	          return;
	        }
	      }
	      this.ocultaIcone = true;
	      this.showGrid = !this.showGrid;
	
	      this.documento.dt_data_vigencia = '';
	    },
	    existeDocumento: function existeDocumento(documento) {
	      if (!_.isEmpty(this.propDocumentos) && !_.isEmpty(this.propDocumentos) && this.propDocumentos !== []) {
	        return this.propDocumentos.some(function (item) {
	          if (documento.id) {
	            return documento.id === item.tipo_documento.id;
	          }
	        });
	      }
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      if (documento.file) {
	        (0, _downloadjs2.default)(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      this.tamanho = e.target.files[0].size;
	      this.tamanhoFormatado = (this.tamanho / Math.pow(1024, 2)).toFixed(2);
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this3 = this;
	
	      var totalParc = 0;
	      var aux = (this.acmTamanho + this.tamanho) / Math.pow(1024, 2);
	      var auxMb = aux.toFixed(2);
	      if (auxMb > 80) {
	        this.$snotify.error('O limite de envio é 80 MB por lote.\n' + 'Já utilizado: ' + this.totalMb + ' MB, e o arquivo possui: ' + this.tamanhoFormatado + ' MB ' + '\n. Favor salvar o formulário para poder incluir mais arquivos.');
	        return;
	      } else {
	        this.acmTamanho = this.acmTamanho + this.tamanho;
	        totalParc = this.acmTamanho / Math.pow(1024, 2);
	        this.totalMb = totalParc.toFixed(2);
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          _this3.documento.dt_criado = new Date();
	          _this3.documento.ligacao_sub_type = _this3.propsEtapa;
	          if (_this3.editando === true) {
	            for (var i in _this3.documento) {
	              _this3.documentoTabela[i] = _this3.documento[i];
	            }_this3.documentoTabela = (0, _assign2.default)({}, _this3.documento);
	          } else {
	            _this3.propDocumentos.push(_this3.documento);
	            _this3.contador += 1;
	          }
	          _this3.onCancel();
	        }
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.table.totalRows = this.table.items.length;
	      this.currentPage = 1;
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.editandoIndex = '';
	      this.conteudoAnterior = (0, _assign2.default)({}, '');
	      if (this.contador === 0) {
	        this.totalMb = 0;
	      }
	      this.$forceUpdate();
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento) {
	      var temp = 0;
	      if (this.propDocumentos[indexDocumento].file) {
	        this.byteLength = parseInt(this.propDocumentos[indexDocumento].file.replace(/=/g, '').length * 0.75);
	        temp = (this.byteLength / Math.pow(1024, 2)).toFixed(2);
	        this.totalMb = (this.totalMb - temp).toFixed(2);
	        this.contador = this.contador - 1;
	        this.acmTamanho = this.acmTamanho - parseInt(this.propDocumentos[indexDocumento].file.replace(/=/g, '').length * 0.75);
	      }
	      this.propDocumentos.splice(indexDocumento, 1);
	      this.$forceUpdate();
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documentos = {};
	      this.documentos[0] = (0, _assign2.default)({}, pendente);
	      this.documento.tipo_documento = (0, _assign2.default)({}, pendente);
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    editaDocumento: function editaDocumento(documento, indexDocumento) {
	      var _this4 = this;
	
	      this.ocultaIcone = false;
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	
	      this.editandoIndex = indexDocumento;
	      this.documento = (0, _assign2.default)({}, documento);
	      this.documentoTabela = documento;
	      if (this.documento.tipo_documento.pivot) {
	        this.documentos.forEach(function (doc) {
	          if (doc.id === _this4.documento.tipo_documento.id) {
	            _this4.documento.tipo_documento = (0, _assign2.default)({}, doc);
	          }
	        });
	      }
	      this.mudancas = _.cloneDeep(this.mudaDocumento.documentos[indexDocumento]);
	      if (this.mudancas.dt_data_vigencia) {
	        this.mudancas.dt_data_vigencia = (0, _moment2.default)(this.mudancas.dt_data_vigencia).format('DD/MM/YYYY');
	      }
	
	      if (_.hasIn(this.atualizados, indexDocumento)) {
	        this.conteudoAnterior = _.cloneDeep(this.atualizados[indexDocumento]);
	        if (this.conteudoAnterior.dt_data_vigencia) {
	          this.conteudoAnterior.dt_data_vigencia = (0, _moment2.default)(this.conteudoAnterior.dt_data_vigencia).format('DD/MM/YYYY');
	        }
	      } else {
	        this.conteudoAnterior = (0, _assign2.default)({}, {});
	      }
	
	      this.$forceUpdate();
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this5 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Fazendo upload do arquivo ...', { timeout: 0 });
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this5.documento = response.data.value;
	        if (_this5.editando === true) {
	          for (var i in _this5.documento) {
	            _this5.documentoTabela[i] = _this5.documento[i];
	          }_this5.documentoTabela = (0, _assign2.default)({}, _this5.documento);
	        } else {
	          _this5.propDocumentos.push(_this5.documento);
	        }
	        _this5.onCancel();
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Arquivo Adicionado com Sucesso!');
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _deepObjectDiff = __webpack_require__(83);
	
	var _downloadjs = __webpack_require__(119);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'uploadCotacaoManual',
	  data: function data() {
	    return {
	      showGrid: true,
	      tamanho: 0,
	      contador: 0,
	      tamanhoFormatado: 0,
	      salvou: false,
	      acmTamanho: 0,
	      totalMb: 0,
	      documentos: [],
	      documento: {
	        ds_nome_arquivo: '',
	        ligacao_sub_type: ''
	      },
	      documentoTabela: {},
	      editando: false,
	      mostraInclusao: false,
	      mostraExclusao: false,
	      mostraAlteracao: false,
	      dt_data_vigencia: '',
	      indiceAlt: -1,
	      ocultaIcone: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      listaOrdenada: {},
	      mudancas: [],
	      conteudoAnterior: {},
	      table: {
	        items: this.propDocumentos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        totalRows: 0,
	        currentPage: 1,
	        perPage: 100,
	        sortBy: 'dt_criado',
	        sortDesc: true,
	        fields: [{
	          key: 'tipo_documento.ds_tipo',
	          label: 'Tipo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 35%',
	          class: 'text-center'
	        }, {
	          key: 'ds_nome_arquivo',
	          label: 'Arquivo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 30%',
	          class: 'text-center'
	        }, { key: 'dt_criado', label: 'Inclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'documentosObrigatorios', 'disable', 'localUso', 'mudaDocumento', 'diferenca', 'analise', 'revisao', 'salvouOK', 'propsEtapa', 'faseProposta', 'editandoAlteracaoProjeto', 'editandoProrrogacao', 'maxFiles'],
	  watch: {
	    propDocumentos: function propDocumentos() {
	      this.table.items = this.propDocumentos;
	      this.table.totalRows = this.table.items.length;
	      if (this.disable === 'disable') {
	        this.desativado = this.disable;
	      }
	    },
	    diferenca: function diferenca() {
	      this.diferencaDoc = this.diferenca;
	    },
	    analise: function analise() {
	      if (this.analise) {
	        this.analiseDoc = this.analise.documentos;
	      }
	    },
	    dt_data_vigencia: function dt_data_vigencia(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.documento.dt_data_vigencia = newdate.format('YYYY-MM-DD');
	      }
	    },
	    revisao: function revisao() {
	      if (this.revisao) {
	        this.revisaoDoc = this.revisao.documentos;
	      }
	      this.mostraExclusao = false;
	      this.mostraInclusao = false;
	      if (this.analiseDoc && this.revisaoDoc) {
	        if (this.analiseDoc.length > this.revisaoDoc.length) {
	          this.mostraExclusao = true;
	          this.mostraInclusao = false;
	        } else {
	          this.mostraExclusao = true;
	        }
	        if (this.analiseDoc.length < this.revisaoDoc.length) {
	          this.mostraInclusao = true;
	          this.mostraExclusao = false;
	        } else {
	          this.mostraInclusao = false;
	        }
	        if (this.analiseDoc.length === this.revisaoDoc.length) {
	          this.mostraExclusao = false;
	        }
	      }
	      this.adicionados = (0, _deepObjectDiff.detailedDiff)(this.analise, this.revisao).added;
	
	      this.excluidos = _.differenceBy(this.analise.documentos, this.revisao.documentos, 'tipo_documento.ds_tipo');
	      this.atualizados = (0, _deepObjectDiff.detailedDiff)(this.analise.documentos, this.revisao.documentos).updated;
	
	      if (this.adicionados) {
	        if (this.adicionados.documentos) {
	          this.inclDoc = this.adicionados.documentos;
	          this.inclDocTexto = _.map(this.inclDoc, 'tipo_documento.ds_tipo');
	          this.naoExisteDoc = false;
	        } else {
	          this.naoExisteDoc = true;
	        }
	      }
	      if (this.excluidos) {
	        this.excDocTexto = _.map(this.excluidos, 'tipo_documento.ds_tipo');
	      }
	    },
	    mudaDocumento: function mudaDocumento() {
	      this.mudancas = this.mudaDocumento.documentos;
	      if (this.mudancas) {
	        if (_.findKey(this.mudancas, 'ds_nome_arquivo')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_nome_arquivo');
	        }
	        if (_.findKey(this.mudancas, 'ds_content_type')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_content_type');
	        }
	        if (_.findKey(this.mudancas, 'fk_tipo_documento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'fk_tipo_documento');
	        }
	        if (_.findKey(this.mudancas, 'dt_data_validade')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'dt_data_validade');
	        }
	        if (_.findKey(this.mudancas, 'tipo_documento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'tipo_documento');
	        }
	        if (this.indiceAlt !== -1) {
	          this.mostraAlteracao = true;
	          this.texto = this.diferencaDoc.documentos[this.indiceAlt];
	        } else {
	          this.mostraAlteracao = false;
	        }
	      }
	    },
	    salvouOK: function salvouOK() {
	      this.salvou = this.salvouOK;
	      if (this.salvou === true) {
	        this.totalMb = 0;
	        this.acmTamanho = 0;
	      }
	    }
	  },
	  computed: {
	    progress: function progress() {
	      return (this.totalMb / 80 * 100).toFixed(2);
	    },
	    PropEditandoAlteracaoProjeto: function PropEditandoAlteracaoProjeto() {
	      if (this.editandoAlteracaoProjeto) {
	        return this.editandoAlteracaoProjeto;
	      } else {
	        return false;
	      }
	    },
	    PropProrrogacaoEdit: function PropProrrogacaoEdit() {
	      if (this.editandoProrrogacao) {
	        return this.editandoProrrogacao;
	      } else {
	        return false;
	      }
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (_this.localUso === undefined) {
	                _this.localUso = 'TODOS';
	              }
	
	              if (!(_this.localUso === 'TODOS')) {
	                _context.next = 11;
	                break;
	              }
	
	              if (!_.isEmpty(_this.$store.state.uploadDocumentos.documentos)) {
	                _context.next = 7;
	                break;
	              }
	
	              _context.next = 5;
	              return axiosLaravel.post('documentos/tipos/' + _this.localUso).then(function (response) {
	                _this.documentos = _this.$store.state.uploadDocumentos.documentos = _.sortBy(response.data, [function (o) {
	                  return o.ds_tipo;
	                }]);
	                _this.$forceUpdate();
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 5:
	              _context.next = 9;
	              break;
	
	            case 7:
	              _this.documentos = _this.$store.state.uploadDocumentos.documentos;
	              _this.$forceUpdate();
	
	            case 9:
	              _context.next = 13;
	              break;
	
	            case 11:
	              _context.next = 13;
	              return axiosLaravel.post('documentos/tipos/' + _this.localUso).then(function (response) {
	                _this.documentos = _.sortBy(response.data, [function (o) {
	                  return o.ds_tipo;
	                }]);
	                _this.$forceUpdate();
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 13:
	              if (_.isNull(_this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(_this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	                axiosLaravel.get('configuracoes/').then(function (response) {
	                  _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	                    return item.ds_mime_type;
	                  }).join('|');
	                  _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	              } else {
	                _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos;
	                _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido;
	              }
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    novoDocumento: function novoDocumento() {
	      if (this.maxFiles !== undefined) {
	        if (this.propDocumentos.length === this.maxFiles) {
	          this.$snotify.error('Número máximo de documentos por licença atingido, favor verificar.');
	          this.onCancel();
	          return;
	        }
	      }
	      this.ocultaIcone = true;
	      this.showGrid = !this.showGrid;
	
	      this.documento.dt_data_vigencia = '';
	    },
	    existeDocumento: function existeDocumento(documento) {
	      if (!_.isEmpty(this.propDocumentos) && !_.isEmpty(this.propDocumentos) && this.propDocumentos !== []) {
	        return this.propDocumentos.some(function (item) {
	          if (documento.id) {
	            return documento.id === item.tipo_documento.id;
	          }
	        });
	      }
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      if (documento.file) {
	        (0, _downloadjs2.default)(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      this.tamanho = e.target.files[0].size;
	      this.tamanhoFormatado = (this.tamanho / Math.pow(1024, 2)).toFixed(2);
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this3 = this;
	
	      var totalParc = 0;
	      var aux = (this.acmTamanho + this.tamanho) / Math.pow(1024, 2);
	      var auxMb = aux.toFixed(2);
	      if (auxMb > 80) {
	        this.$snotify.error('O limite de envio é 80 MB por lote.\n' + 'Já utilizado: ' + this.totalMb + ' MB, e o arquivo possui: ' + this.tamanhoFormatado + ' MB ' + '\n. Favor salvar o formulário para poder incluir mais arquivos.');
	        return;
	      } else {
	        this.acmTamanho = this.acmTamanho + this.tamanho;
	        totalParc = this.acmTamanho / Math.pow(1024, 2);
	        this.totalMb = totalParc.toFixed(2);
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          _this3.documento.dt_criado = new Date();
	          _this3.documento.ligacao_sub_type = _this3.propsEtapa;
	          if (_this3.editando === true) {
	            for (var i in _this3.documento) {
	              _this3.documentoTabela[i] = _this3.documento[i];
	            }_this3.documentoTabela = (0, _assign2.default)({}, _this3.documento);
	          } else {
	            _this3.propDocumentos.push(_this3.documento);
	            _this3.contador += 1;
	          }
	          _this3.onCancel();
	        }
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.table.totalRows = this.table.items.length;
	      this.currentPage = 1;
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.editandoIndex = '';
	      this.conteudoAnterior = (0, _assign2.default)({}, '');
	      if (this.contador === 0) {
	        this.totalMb = 0;
	      }
	      this.$forceUpdate();
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento) {
	      var temp = 0;
	      if (this.propDocumentos[indexDocumento].file) {
	        this.byteLength = parseInt(this.propDocumentos[indexDocumento].file.replace(/=/g, '').length * 0.75);
	        temp = (this.byteLength / Math.pow(1024, 2)).toFixed(2);
	        this.totalMb = (this.totalMb - temp).toFixed(2);
	        this.contador = this.contador - 1;
	        this.acmTamanho = this.acmTamanho - parseInt(this.propDocumentos[indexDocumento].file.replace(/=/g, '').length * 0.75);
	      }
	      this.propDocumentos.splice(indexDocumento, 1);
	      this.$forceUpdate();
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documentos = {};
	      this.documentos[0] = (0, _assign2.default)({}, pendente);
	      this.documento.tipo_documento = (0, _assign2.default)({}, pendente);
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    editaDocumento: function editaDocumento(documento, indexDocumento) {
	      var _this4 = this;
	
	      this.ocultaIcone = false;
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	
	      this.editandoIndex = indexDocumento;
	      this.documento = (0, _assign2.default)({}, documento);
	      this.documentoTabela = documento;
	      if (this.documento.tipo_documento.pivot) {
	        this.documentos.forEach(function (doc) {
	          if (doc.id === _this4.documento.tipo_documento.id) {
	            _this4.documento.tipo_documento = (0, _assign2.default)({}, doc);
	          }
	        });
	      }
	      this.mudancas = _.cloneDeep(this.mudaDocumento.documentos[indexDocumento]);
	      if (this.mudancas.dt_data_vigencia) {
	        this.mudancas.dt_data_vigencia = (0, _moment2.default)(this.mudancas.dt_data_vigencia).format('DD/MM/YYYY');
	      }
	
	      if (_.hasIn(this.atualizados, indexDocumento)) {
	        this.conteudoAnterior = _.cloneDeep(this.atualizados[indexDocumento]);
	        if (this.conteudoAnterior.dt_data_vigencia) {
	          this.conteudoAnterior.dt_data_vigencia = (0, _moment2.default)(this.conteudoAnterior.dt_data_vigencia).format('DD/MM/YYYY');
	        }
	      } else {
	        this.conteudoAnterior = (0, _assign2.default)({}, {});
	      }
	
	      this.$forceUpdate();
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this5 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Fazendo upload do arquivo ...', { timeout: 0 });
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this5.documento = response.data.value;
	        if (_this5.editando === true) {
	          for (var i in _this5.documento) {
	            _this5.documentoTabela[i] = _this5.documento[i];
	          }_this5.documentoTabela = (0, _assign2.default)({}, _this5.documento);
	        } else {
	          _this5.propDocumentos.push(_this5.documento);
	        }
	        _this5.onCancel();
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Arquivo Adicionado com Sucesso!');
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadCotacaoManualVisualizacao = __webpack_require__(1701);
	
	var _uploadCotacaoManualVisualizacao2 = _interopRequireDefault(_uploadCotacaoManualVisualizacao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cotacaoItens',
	  components: {
	    uploadCotacaoManualVisualizacao: _uploadCotacaoManualVisualizacao2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      carregandoAnexos: false,
	      loading: {
	        show: false
	      },
	      anexos: [],
	      idArquivosParaProcurar: []
	    };
	  },
	
	  props: {
	    proposta: Object
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {
	    this.initVisualizacao();
	  },
	  methods: {
	    initVisualizacao: function initVisualizacao() {
	      var anexosProcurar = [];
	      this.proposta.atividades.forEach(function (atividade) {
	        atividade.itens_orcamentos.forEach(function (item) {
	          if (item.hasOwnProperty('itemCotacaoManual')) {
	            item.itemCotacaoManual.forEach(function (cotacao) {
	              cotacao.forEach(function (itemCotacao) {
	                anexosProcurar.push(itemCotacao.id);
	              });
	            });
	          }
	        });
	      });
	      this.idArquivosParaProcurar = anexosProcurar;
	      this.buscaAnexos();
	    },
	    buscaAnexos: function buscaAnexos() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.carregandoAnexos = true;
	                obj = {
	                  ids: _this.idArquivosParaProcurar
	                };
	                _context.next = 4;
	                return axiosLaravel.post('cotacao/getTodosAnexosCotacaoManual/', obj).then(function (response) {
	                  _this.anexos = response.data;
	                  _this.carregandoAnexos = false;
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this.carregandoAnexos = false;
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cotacaoExcecoes',
	  components: {},
	  data: function data() {
	    return {
	      table: {
	        items: this.restricoesCadastradas,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'id', label: 'ID', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'tipo', label: 'Tipo', sortable: true, thStyle: 'text-align: left', class: 'text-center' }, { key: 'id_restricao', label: 'ID Restricao', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nome_restricao', label: 'Nome Restricao', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'justificativa', label: 'Justificativa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'responsavel', label: 'Alterado por', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ativo', label: 'Ativo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'updated_at', label: 'Data Alteração', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      loading: false,
	      editando: false,
	      restricoesCadastradas: [],
	      editais: [],
	      propostas: [],
	      tipos: ['EDITAL', 'PROPOSTA'],
	      tipoSelecionado: '',
	      justificativa: '',
	      editalSelecionado: [],
	      propostaSelecionada: []
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {
	    console.log('Cotacao Excecoes!');
	    this.buscaExcecoes();
	  },
	  methods: {
	    toggleEdicao: function toggleEdicao(valor) {
	      this.editando = valor;
	      if (this.editando) {
	        this.tipoSelecionado = '';
	        this.editalSelecionado = '';
	        this.propostaSelecionada = '';
	        this.justificativa = '';
	      }
	    },
	    buscaTodosEditais: function buscaTodosEditais() {
	      var _this = this;
	
	      this.loading = true;
	      axiosLaravel.get('edital/').then(function (response) {
	        _this.editais = response.data;
	        _this.loading = false;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.loading = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaPropostas: function buscaPropostas() {
	      var _this2 = this;
	
	      this.loading = true;
	      axiosLaravel.get('cotacao/getPropostas/').then(function (response) {
	        _this2.propostas = response.data;
	        _this2.loading = false;
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        _this2.loading = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscaExcecoes: function buscaExcecoes() {
	      var _this3 = this;
	
	      this.loading = true;
	      axiosLaravel.get('cotacao/getRestricoes/').then(function (response) {
	        _this3.restricoesCadastradas = response.data;
	        _this3.table.items = _this3.restricoesCadastradas;
	        _this3.loading = false;
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.loading = false;
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaOptions: function buscaOptions() {
	      if (this.tipoSelecionado === 'PROPOSTA' || this.tipoSelecionado === 'EXCECAO EDITAL') {
	        if (this.propostas.length === 0) {
	          this.buscaPropostas();
	        }
	      } else {
	        if (this.editais.length === 0) {
	          this.buscaTodosEditais();
	        }
	      }
	    },
	    verificaCamposEmBranco: function verificaCamposEmBranco() {
	      if (this.tipoSelecionado === '') {
	        this.$snotify.error('Selecione o tipo de restrição antes de continuar');
	        return false;
	      }
	      if (this.editalSelecionado === '' && this.tipoSelecionado === 'EDITAL') {
	        this.$snotify.error('Selecione o edital de continuar');
	        return false;
	      }
	      if (this.propostaSelecionada === '' && this.tipoSelecionado === 'PROPOSTA') {
	        this.$snotify.error('Selecione a proposta antes de continuar');
	        return false;
	      }
	      if (this.justificativa === '') {
	        this.$snotify.error('Informe a Justificativa antes de continuar');
	        return false;
	      }
	      return true;
	    },
	    gravaRestricao: function gravaRestricao() {
	      var _this4 = this;
	
	      if (this.verificaCamposEmBranco() === false) {
	        return;
	      }
	      var obj = {
	        tipo: this.tipoSelecionado,
	        id_restricao: this.tipoSelecionado !== 'EDITAL' ? this.propostaSelecionada.id : this.editalSelecionado.id,
	        nome_restricao: this.tipoSelecionado !== 'EDITAL' ? this.propostaSelecionada.ds_nome : this.editalSelecionado.ds_numero_edital,
	        justificativa: this.justificativa,
	        responsavel: this.usuarioLogado.ds_login + ' ' + this.usuarioLogado.ds_nome_usuario
	      };
	      this.loading = true;
	      axiosLaravel.post('/cotacao/gravarExcecaoCotacao/', obj).then(function (response) {
	        _this4.$snotify.success(response.data);
	        _this4.toggleEdicao(false);
	        _this4.buscaExcecoes();
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.loading = false;
	        _this4.$root.trataErro(error);
	      });
	    },
	    ativaDesativaRestricao: function ativaDesativaRestricao(item) {
	      var _this5 = this;
	
	      this.loading = true;
	      axiosLaravel.get('/cotacao/gravaAtivoInativo/' + item.id).then(function (response) {
	        _this5.$snotify.success(response.data);
	        _this5.table.items = [];
	        _this5.buscaExcecoes();
	        _this5.$forceUpdate();
	      }).catch(function (error) {
	        _this5.loading = false;
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var itemFormOriginal = {
	  observacao: null,
	  origem: null,
	  periodo_inicial: null,
	  recurso: null,
	  adiantavel: null,
	  unidade_medida: null,
	  item: {
	    ds_code: '',
	    ds_description: '',
	    valor_unitario: null,
	    status: null,
	    ds_type: null
	  },
	  quantidade: null,
	  periodo_final: null,
	  valorTotal: null,
	  valor_unitario: 0
	};
	exports.default = {
	  name: 'cronograma',
	  data: function data() {
	    return {
	      totalCusteio: 0,
	      totalInvestimento: 0,
	      totalCapacitacao: 0,
	      totalAssessoria: 0,
	      showForm: false,
	      entidadeEhFundacao: false,
	      bloqueiaBotoes: false,
	      conta_financeira: {},
	      objetivos: [],
	      blockSelect: false,
	      atividade: {},
	      totais: {
	        projeto: {
	          fbb: 0,
	          parceiros: 0,
	          contrapartida: 0,
	          total: 0
	        },
	        adiantavel: {
	          fbb: 0,
	          parceiros: 0,
	          total: 0
	        },
	        itens: {
	          fbb: 0,
	          parceiros: 0,
	          contrapartida: 0,
	          adiantaveis: 0,
	          total: 0
	        }
	      },
	      itemForm: {
	        itens_orcamentos: [],
	        conta_financeira: {},
	        adiantavel: null,
	        item: null
	      },
	      medidas: ['Caixas', 'Capacitações', 'Rolos', 'Unidades', 'Outros'],
	      componentKey: 0,
	      itemTabela: {},
	      items: [],
	      formasContratacao: [],
	      contasFinanceiras: [],
	      editando: false,
	      adicionando: false,
	
	      atividadeTabela: {},
	      rules: 'required|min_value:1|max_value:' + this.meses,
	      submitDisabled: false,
	      buscandoContaFinanceira: false,
	      itensProcessoSimplificado: ['S0632', 'P1158', 'S0633', 'P1157', 'S0634'],
	      itemsFiltradosProcessoSimplificado: [],
	
	      propostaSimplificadaForaPadrao: false,
	      limitePropostaSimplificada: 300000
	    };
	  },
	
	  props: ['propsObjetivos', 'propsAtividades', 'propsMetas', 'proposta', 'meses', 'projetoDuplicacao', 'propostaSimplificada'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    valorTotal: function valorTotal(itemForm) {
	      itemForm.itemForm.totalValue = parseInt(itemForm.valor_unitario * itemForm.quantidade);
	      return itemForm.itemForm;
	    }
	  }),
	  watch: {
	    propsObjetivos: function propsObjetivos() {
	      this.$forceUpdate();
	    },
	    valorTotal: function valorTotal(itemForm) {
	      this.$forceUpdate();
	    },
	    projetoDuplicacao: function projetoDuplicacao() {
	      this.buscaContasFinanceiras();
	    },
	    meses: function meses() {
	      this.$forceUpdate();
	    },
	    propsAtividades: function propsAtividades() {
	      console.log('propAtividades', this.propsAtividades);
	
	      if (this.propostaSimplificada) {
	        this.verificarAtividadesPropostaSimplificada();
	      }
	      this.$forceUpdate();
	    }
	  },
	  created: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              this.entidadeEhFundacao = this.proposta.entidade.ds_cnpj === '01641000000133';
	              _context.next = 3;
	              return this.buscaItensDespesas();
	
	            case 3:
	              this.calcularTotais();
	              if (this.propostaSimplificada) {
	                this.verificarAtividadesPropostaSimplificada();
	              }
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function created() {
	      return _ref.apply(this, arguments);
	    }
	
	    return created;
	  }(),
	  methods: {
	    removerAcentos: function removerAcentos(str) {
	      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	    },
	    verificarAtividadesPropostaSimplificada: function verificarAtividadesPropostaSimplificada() {
	      var _this = this;
	
	      console.log('Verificando padrao');
	      var possuiAtividade = false;
	
	      this.propsAtividades.forEach(function (atividade) {
	        if (_this.removerAcentos(atividade.ds_nome).toLowerCase() === _this.removerAcentos('Resumo memória de cálculo').toLowerCase()) {
	          possuiAtividade = true;
	        }
	        if (_this.removerAcentos(atividade.ds_nome).toLowerCase() === _this.removerAcentos('memória de cálculo').toLowerCase()) {
	          possuiAtividade = true;
	        }
	      });
	      if (possuiAtividade) {
	        this.propostaSimplificadaForaPadrao = false;
	      } else {
	        this.propostaSimplificadaForaPadrao = true;
	      }
	    },
	    calcularTotais: function calcularTotais() {
	      this.totais.projeto.fbb = 0;
	      this.totais.projeto.parceiros = 0;
	      this.totais.projeto.contrapartida = 0;
	      this.totais.adiantavel.fbb = 0;
	      this.totais.adiantavel.parceiros = 0;
	
	      this.totais.itens.fbb = 0;
	      this.totais.itens.parceiros = 0;
	      this.totais.itens.contrapartida = 0;
	      this.totais.itens.adiantaveis = 0;
	
	      var vm = this;
	
	      this.totais.projeto.fbb = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          if ('' + ite.origem === '1') {
	            vm.totais.itens.fbb++;
	            return _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade);
	          } else return 0;
	        });
	      });
	      this.totais.projeto.contrapartida = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          if ('' + ite.origem === '2') {
	            vm.totais.itens.contrapartida++;
	            return _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade);
	          } else return 0;
	        });
	      });
	      this.totais.projeto.parceiros = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          if ('' + ite.origem === '5') {
	            vm.totais.itens.parceiros++;
	            return _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade);
	          } else return 0;
	        });
	      });
	      this.totais.adiantavel.fbb = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return '' + ite.origem === '1' && '' + ite.adiantavel === '1' ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totais.adiantavel.parceiros = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return '' + ite.origem === '5' && '' + ite.adiantavel === '1' ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totalCusteio = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return '' + ite.ds_type === 'SERVICO' && !_.includes(['S0585', 'S0601', 'S0599'], ite.item.ds_code) ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totalInvestimento = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return '' + ite.ds_type === 'PRODUTO' || _.includes(['S0585', 'S0601', 'S0599'], ite.item.ds_code) ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totalCapacitacao = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return ite.item.ds_code === 'S0587' ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	      this.totalAssessoria = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (ite) {
	          return ite.item.ds_code === 'S0586' ? _.has(ite, 'valorOrcado') ? parseFloat(ite.valorOrcado) : parseFloat(ite.valor_unitario) * parseFloat(ite.quantidade) : 0;
	        });
	      });
	
	      this.totais.projeto.total = this.totais.projeto.fbb + this.totais.projeto.parceiros + this.totais.projeto.contrapartida;
	      this.totais.adiantavel.total = this.totais.adiantavel.fbb + this.totais.adiantavel.parceiros;
	      this.totais.itens.total = this.totais.itens.fbb + this.totais.itens.parceiros + this.totais.itens.contrapartida;
	
	      this.$forceUpdate();
	
	      var bc = new BroadcastChannel('propostas');
	      bc.postMessage({ acao: 'notificacaoAtualizacaoCronograma', id: this.proposta.id });
	
	      var semContrapartida = this.totais.projeto.contrapartida === 0;
	      this.$emit('validacaoCronograma', { 'tag': 'cronogramaContrapartida', 'ativo': semContrapartida && !this.entidadeEhFundacao, 'tipo': 'restricao', 'acao': null, 'mensagem': 'É obrigatório registrar <b>Contrapartida</b> ao Cronograma' });
	
	      var itemSemContaFinanceira = _.sumBy(vm.propsAtividades, function (atv) {
	        return _.sumBy(atv.itens_orcamentos, function (item) {
	          return !_.has(item, 'conta_financeira') || !_.isNumber(item.conta_financeira['numero_conta']) ? 1 : 0;
	        });
	      });
	      this.$emit('validacaoCronograma', { 'tag': 'cronogramaFaltaContaFinanceira', 'ativo': itemSemContaFinanceira > 0 && this.proposta.ds_fase === 'ANALISE', 'tipo': 'restricao', 'acao': null, 'mensagem': 'Ainda há <b>' + itemSemContaFinanceira + '</b> item(ns) sem contas financeiras indicadas' });
	    },
	    buscaItensDespesas: function buscaItensDespesas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return axiosLaravel.post('itens/contratacao', { 'tipos': ['PRODUTO', 'SERVICO'] }).then(function (response) {
	                  _this2.$store.state.itensDespesa = response.data;
	                });
	
	              case 2:
	                _this2.items = _this2.$store.state.itensDespesa;
	
	                _this2.itemsFiltradosProcessoSimplificado = _this2.items.filter(function (p) {
	                  return _this2.itensProcessoSimplificado.includes(p.ds_code);
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    propostaDentroFbb: function propostaDentroFbb() {
	      return _.includes(['ANALISE', 'DEFERIMENTO', 'FORMALIZACAO', 'APROVACAO_PROJETO'], this.proposta.ds_fase);
	    },
	    itemCodigo: function itemCodigo(_ref2) {
	      var ds_code = _ref2.ds_code,
	          ds_description = _ref2.ds_description;
	
	      return ds_code + ' / ' + ds_description;
	    },
	    contaCodigo: function contaCodigo(_ref3) {
	      var numero_conta = _ref3.numero_conta,
	          descricao = _ref3.descricao;
	
	      return numero_conta + ' / ' + descricao;
	    },
	    buscaContasFinanceiras: function buscaContasFinanceiras(row) {
	      var _this3 = this;
	
	      this.buscandoContaFinanceira = true;
	      var codigoItem = '';
	      if (row.ds_code) {
	        codigoItem = row.ds_code;
	      }
	      if (row.item) {
	        codigoItem = row.item.ds_code;
	      }
	      var tipoItem = codigoItem.substring(0, 1);
	      this.itemForm['ds_type'] = tipoItem === 'P' ? 'PRODUTO' : tipoItem === 'S' ? 'SERVICO' : 'ERRO';
	      var projDuplicacao = this.projetoDuplicacao;
	      var fase = this.itemForm.origem;
	      var obj = {};
	      obj.item = codigoItem;
	      obj.duplicador = projDuplicacao;
	      obj.fase = fase;
	      if (this.projetoDuplicacao) {
	        axiosLaravel.post('busca_conta_financeira/', obj).then(function (response) {
	          _this3.contasFinanceiras = response.data;
	          if (_this3.contasFinanceiras.length === 1) {
	            _this3.itemForm.conta_financeira = _this3.contasFinanceiras[0];
	            _this3.blockSelect = true;
	          } else {
	            _this3.blockSelect = false;
	          }
	          _this3.buscandoContaFinanceira = false;
	        }).catch(function (error) {
	          _this3.$root.trataErro(error);
	          _this3.buscandoContaFinanceira = false;
	        });
	      }
	    },
	    cancelaItem: function cancelaItem(atividade, item, itemIndex) {
	      if (this.editando !== true) {
	        atividade.itens_orcamentos.pop();
	      }
	      this.itemForm = (0, _assign2.default)({}, itemFormOriginal);
	      this.itemTabela = {};
	      this.editando = false;
	      this.adicionando = false;
	      item.editando = false;
	      this.bloqueiaBotoes = false;
	    },
	    validaPeriodo: function validaPeriodo() {
	      if (_.toSafeInteger(this.itemForm.periodo_final) < _.toSafeInteger(this.itemForm.periodo_inicial) && this.itemForm.periodo_final && this.itemForm.periodo_inicial) {
	        var error = {
	          field: 'inicio',
	          msg: 'Período inicial não pode ser maior que o fim'
	        };
	        this.$validator.errors.add(error);
	        this.submitDisabled = true;
	        return;
	      } else {
	        this.$validator.reset();
	        this.submitDisabled = false;
	      }
	    },
	    onAdd: function onAdd(atividade) {
	      var _this4 = this;
	
	      if (this.submitDisabled) {
	        return;
	      }
	
	      if (this.itemForm.item.ds_type === null || _.isEmpty(this.itemForm.item.ds_code)) {
	        var error = {
	          field: 'item',
	          msg: 'item não prenchido'
	        };
	        this.$validator.errors.add(error);
	        return;
	      } else {
	        this.$validator.errors.remove('item', 'item não prenchido');
	      }
	
	      var observacao_form = this.itemForm.observacao.trim();
	      var obs_duplicada = _.find(this.propsAtividades, function (atividade) {
	        return _.find(atividade.itens_orcamentos, function (item) {
	          return item.observacao === observacao_form;
	        });
	      });
	      if (obs_duplicada && !this.editando) {
	        var _error = {
	          field: 'descrição item',
	          msg: 'Descrição do item já utilizada neste cronograma. Gentileza alterar a descrição.'
	        };
	        this.$validator.errors.add(_error);
	        return;
	      } else {
	        this.$validator.errors.remove('descrição item', 'descrição duplicada');
	      }
	
	      if (this.propostaSimplificada) {
	        var valorTotalItem = this.itemForm.quantidade * this.itemForm.valor_unitario;
	        var valorTotalAntesDeEditar = this.itemTabela.quantidade * this.itemTabela.valor_unitario;
	        var valorTotalProjeto = this.somaTotalProjeto() - valorTotalAntesDeEditar;
	        if (valorTotalItem + valorTotalProjeto > this.limitePropostaSimplificada) {
	          this.$snotify.error('Valor máximo atingido para a proposta, favor verificar.');
	          return;
	        }
	      }
	
	      if (this.removerAcentos(atividade.ds_nome).toLowerCase() === this.removerAcentos('Resumo memória de cálculo').toLowerCase() && this.propostaSimplificada && !this.editando) {
	        var itemRepetido = false;
	        atividade.itens_orcamentos.forEach(function (item) {
	          console.log(item.origem, item.item.ds_code);
	          if (item.origem === _this4.itemForm.origem && item.item.ds_code === _this4.itemForm.item.ds_code && _this4.itemForm.origem !== '2') {
	            itemRepetido = true;
	          }
	        });
	        if (itemRepetido) {
	          this.$snotify.error('Item já cadastrado no Resumo da memória de Cálculo, favor verificar.');
	          return;
	        }
	      }
	      this.$validator.validateAll().then(function (result) {
	        console.log('result', result);
	        if (result) {
	          if (_this4.editando === true) {
	            for (var i in _this4.itemForm) {
	              _this4.itemTabela[i] = _this4.itemForm[i];
	            }
	          } else {
	            atividade.itens_orcamentos.pop();
	            var item = (0, _assign2.default)({}, _this4.itemForm);
	            item.editando = false;
	            atividade.itens_orcamentos.push(item);
	          }
	          _this4.itemForm = (0, _assign2.default)({}, itemFormOriginal);
	          _this4.itemTabela = {};
	          _this4.editando = false;
	          _this4.adicionando = false;
	          _this4.itemForm.editando = false;
	          _this4.bloqueiaBotoes = false;
	
	          _this4.calcularTotais();
	          _this4.$forceUpdate();
	        }
	      });
	      this.$forceUpdate();
	    },
	    somaTotal: function somaTotal(items) {
	      if (items !== undefined) {
	        if (items.length > 0) {
	          return items.reduce(function (total, item) {
	            if (item.valor_unitario) {
	              return total + item.valor_unitario * item.quantidade;
	            }
	          }, 0);
	        }
	      }
	    },
	    somaTotalProjeto: function somaTotalProjeto() {
	      var totalFBB = 0;
	      var totalContrapartida = 0;
	      var totalParceiro = 0;
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if ('' + item.origem === '1') {
	              totalFBB += item.valor_unitario * item.quantidade;
	            }
	            if ('' + item.origem === '2') {
	              totalContrapartida += item.valor_unitario * item.quantidade;
	            }
	            if ('' + item.origem === '5') {
	              totalParceiro += item.valor_unitario * item.quantidade;
	            }
	          });
	        }
	      });
	      var totalProjeto = totalFBB + totalParceiro;
	      console.log(totalProjeto, totalContrapartida);
	      return totalProjeto;
	    },
	    editaItem: function editaItem(atividade, atividadeIndex, item, itemIndex) {
	      if (this.proposta.ds_fase === 'ANALISE' && _.isNil(this.projetoDuplicacao)) {
	        this.$dialog.alert('Selecione um <b>Projeto de Duplicação</b> antes de Editar este item', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	      } else {
	        this.itemForm = (0, _assign2.default)({}, item);
	        this.buscaContasFinanceiras(item);
	        this.itemTabela = item;
	        item.editando = true;
	        this.editando = true;
	        this.bloqueiaBotoes = true;
	        if (this.propostaSimplificada && !this.propostaSimplificadaForaPadrao) {
	          this.itemForm.periodo_inicial = 1;
	          this.itemForm.periodo_final = this.proposta.nr_periodos;
	        }
	        this.$forceUpdate();
	      }
	    },
	    addItem: function addItem(atividade, atividadeIndex) {
	      if (this.proposta.ds_fase === 'ANALISE' && _.isNil(this.projetoDuplicacao)) {
	        this.$dialog.alert('Selecione um <b>Projeto de Duplicação</b> antes de Adicionar item', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	      } else {
	        this.itemForm = (0, _assign2.default)({}, itemFormOriginal);
	        if (!atividade.itens_orcamentos) {
	          atividade.itens_orcamentos = [];
	          this.$forceUpdate();
	        }
	        this.itemForm = (0, _assign2.default)({}, itemFormOriginal);
	        this.itemForm.editando = true;
	        this.adicionando = true;
	        atividade.itens_orcamentos.push((0, _assign2.default)({}, this.itemForm));
	        if (this.propostaSimplificada && !this.propostaSimplificadaForaPadrao) {
	          this.itemForm.periodo_inicial = 1;
	          this.itemForm.periodo_final = this.proposta.nr_periodos;
	        }
	        this.$forceUpdate();
	      }
	    },
	    deleteItem: function deleteItem(atividade, atividadeIndex, item, itemIndex) {
	      atividade.itens_orcamentos.splice(itemIndex, 1);
	      this.calcularTotais();
	    },
	    deleteTodos: function deleteTodos(retorno) {
	      if (retorno === 'ok') {
	        this.propsAtividades.forEach(function (prop) {
	          return prop.itens_orcamentos.splice(prop.length);
	        });
	      }
	      this.calcularTotais();
	    },
	    selecionaConta: function selecionaConta(conta) {
	      this.itemForm.conta_financeira = conta;
	    },
	    zeraAdiantamento: function zeraAdiantamento() {
	      if ('' + this.itemForm.origem === '2') {
	        this.itemForm.adiantavel = 0;
	      }
	    }
	  }
	};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var itemFormOrigial = {
	  balance: null,
	  createdAt: null,
	  finalPeriod: null,
	  financialBalance: null,
	  foreseeable: null,
	  id: null,
	  item: {
	    code: null,
	    description: null,
	    measureUnit: null,
	    status: null,
	    type: null
	  },
	  itemDescription: null,
	  quantity: null,
	  resourceSource: null,
	  startPeriod: null,
	  totalValue: null,
	  unitaryValue: 0,
	  updatedAt: null
	};
	exports.default = {
	  name: 'cronogramaOld',
	  data: function data() {
	    return {
	      showForm: false,
	      bloqueiaBotoes: false,
	      financialAccountObject: {},
	      objetivos: [],
	      atividade: {},
	      itemForm: {
	        item: [],
	        foreseeable: null
	      },
	      componentKey: 0,
	      itemTabela: {},
	      items: [],
	      formasContratacao: [],
	      contasFinanceiras: [],
	      editando: false,
	      adicionando: false,
	
	      atividadeTabela: {},
	      rules: 'required|min_value:1|max_value:' + this.meses
	    };
	  },
	
	  props: {
	    propsObjetivos: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    atividades: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    proposta: Object,
	    meses: Number,
	    projetoDuplicacao: Number },
	  computed: {
	    valorTotal: function valorTotal(itemForm) {
	      itemForm.itemForm.totalValue = itemForm.itemForm.quantity * itemForm.itemForm.unitaryValue;
	      return itemForm.itemForm;
	    }
	  },
	  watch: {
	    propsObjetivos: function propsObjetivos() {},
	    valorTotal: function valorTotal(itemForm) {
	      itemForm.itemForm.totalValue = itemForm.itemForm.quantity * itemForm.itemForm.unitaryValue;
	      return itemForm.itemForm;
	    },
	    projetoDuplicacao: function projetoDuplicacao() {
	      this.buscaContasFinanceiras();
	    },
	    meses: function meses() {},
	    atividades: function atividades() {
	      this.componentKey += 1;
	    }
	  },
	  created: function created() {
	    this.buscaContasFinanceiras();
	  },
	  methods: {
	    itemCodigo: function itemCodigo(_ref) {
	      var code = _ref.code,
	          description = _ref.description;
	
	      return code + ' / ' + description;
	    },
	    buscaItems: function buscaItems() {
	      var _this = this;
	
	      this.items = [];
	      if ((0, _keys2.default)(this.itemForm.item).length > 0) {
	        axios.post('/proxy/project/items', { type: this.itemForm.item.type, filter: '' }).then(function (response) {
	          _this.items = response.data.value;
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	        });
	      }
	    },
	    buscaContasFinanceiras: function buscaContasFinanceiras() {
	      var _this2 = this;
	
	      if (this.projetoDuplicacao) {
	        axios.get('proxy/project/financial-accounts/' + this.projetoDuplicacao).then(function (response) {
	          _this2.contasFinanceiras = response.data.value;
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    cancelaItem: function cancelaItem(atividade, item, itemIndex) {
	      if (this.editando !== true) {
	        atividade.items.pop();
	      }
	      this.itemForm = (0, _assign2.default)({}, itemFormOrigial);
	      this.itemTabela = {};
	      this.editando = false;
	      item.editando = false;
	      this.bloqueiaBotoes = false;
	    },
	    onAdd: function onAdd(atividade, item, itemIndex) {
	      var _this3 = this;
	
	      if (item.item.type === null) {
	        this.$validator.errors.add('item', 'item não prenchido');
	      } else {
	        this.$validator.errors.remove('item', 'item não prenchido');
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this3.editando === true) {
	            for (var i in _this3.itemForm) {
	              _this3.itemTabela[i] = _this3.itemForm[i];
	            }
	          } else {
	            atividade.items.pop();
	            var _item = (0, _assign2.default)({}, _this3.itemForm);
	            _item.editando = false;
	            atividade.items.push(_item);
	          }
	          _this3.itemForm = (0, _assign2.default)({}, itemFormOrigial);
	          _this3.itemTabela = {};
	          _this3.editando = false;
	          item.editando = false;
	          _this3.bloqueiaBotoes = false;
	
	          _this3.$forceUpdate();
	        }
	      });
	    },
	    exclui: function exclui(meta, atividadeIndex) {
	      meta.activities.splice(atividadeIndex, 1);
	    },
	    somaTotal: function somaTotal(items) {
	      if (items.length > 0) {
	        return items.reduce(function (total, item) {
	          return total + item.totalValue;
	        }, 0);
	      }
	    },
	    totalFundacao: function totalFundacao() {
	      var totalFundacao = 0;
	      this.atividades.forEach(function (atividade) {
	        atividade.items.forEach(function (item) {
	          if (item.resourceSource === 'FUNDACAO') {
	            totalFundacao = totalFundacao + item.totalValue;
	          }
	        });
	      });
	      return totalFundacao;
	    },
	    totalContraPartida: function totalContraPartida() {
	      var totalContraPartida = 0;
	      this.atividades.forEach(function (atividade) {
	        atividade.items.forEach(function (item) {
	          if (item.resourceSource === 'CONTRAPARTIDA') {
	            totalContraPartida = totalContraPartida + item.totalValue;
	          }
	        });
	      });
	      return totalContraPartida;
	    },
	    editaItem: function editaItem(atividade, atividadeIndex, item, itemIndex) {
	      var _this4 = this;
	
	      this.itemForm = (0, _assign2.default)({}, item);
	      this.financialAccountObject = this.contasFinanceiras.find(function (conta) {
	        return conta.code === _this4.itemForm.financialAccount;
	      });
	      this.itemTabela = item;
	      item.editando = true;
	      this.editando = true;
	      this.bloqueiaBotoes = true;
	      this.$forceUpdate();
	    },
	    addItem: function addItem(atividade) {
	      this.itemForm = (0, _assign2.default)({}, itemFormOrigial);
	      this.itemForm.editando = true;
	      atividade.items.push((0, _assign2.default)({}, this.itemForm));
	    },
	    deleteItem: function deleteItem(atividade, itemIndex) {
	      atividade.items.splice(itemIndex, 1);
	    },
	    selecionaConta: function selecionaConta(conta) {
	      this.itemForm.financialAccount = conta.code;
	      this.itemForm.financialAccountDescription = conta.description;
	    }
	  }
	};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cursos',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsCursos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 20,
	        totalRows: 0,
	        fields: [{ key: 'ds_titulo', label: 'Título do curso', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_qt_educadores', label: 'Quantidade de educadores', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_carga_horaria', label: 'Carga horária', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_qt_turmas', label: 'Quantidade de turmas', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_qt_alunos_turma', label: 'Alunos por turma', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      curso: {},
	      cursoTabela: {},
	      editandoIndex: null,
	      formEditavel: false
	    };
	  },
	
	  props: ['propsCursos'],
	  watch: {
	    propsCursos: function propsCursos() {
	      this.table.items = this.propsCursos;
	      this.table.totalRows = this.propsCursos.length;
	    },
	    'table.items': function tableItems() {
	      this.$emit('cursoAdicionado', this.table.items);
	    }
	  },
	  mounted: function mounted() {
	    this.formEditavel = !_.has(this.$route.params, 'numero');
	    if (!this.formEditavel) {
	      this.table.fields = _.remove(this.table.fields, function (f) {
	        return f.key !== 'actions';
	      });
	    }
	    this.table.totalRows = this.propsCursos.length;
	  },
	  methods: {
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    },
	    edita: function edita(row) {
	      this.editandoIndex = row.index;
	      this.curso = (0, _assign2.default)({}, row.item);
	      this.cursoTabela = row.item;
	      this.showgrid = false;
	    },
	    onCancel: function onCancel() {
	      this.curso = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	      this.$forceUpdate();
	    },
	    onAdd: function onAdd() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this.editandoIndex !== null) {
	            for (var i in _this.curso) {
	              _this.cursoTabela[i] = _this.curso[i];
	            }
	          } else {
	            _this.table.items.push(_this.curso);
	          }
	          _this.onCancel();
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cursosOld',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsCursos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'title', label: 'Título do curso', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'educators', label: 'Quantidade de educadores', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'workload', label: 'Carga horária', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'classes', label: 'Quantidade de turmas', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'studentsPerClass', label: 'Alunos por turma', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      curso: {},
	      cursoTabela: {},
	      editandoIndex: null
	    };
	  },
	
	  props: ['propsCursos'],
	  watch: {
	    propsCursos: function propsCursos() {
	      this.table.items = this.propsCursos;
	    },
	    'table.items': function tableItems() {
	      this.$emit('cursoAdicionado', this.table.items);
	    }
	  },
	  methods: {
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    },
	    edita: function edita(row) {
	      this.editandoIndex = row.index;
	      this.curso = (0, _assign2.default)({}, row.item);
	      this.cursoTabela = row.item;
	      this.showgrid = false;
	    },
	    onCancel: function onCancel() {
	      this.curso = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	      this.$forceUpdate();
	    },
	    onAdd: function onAdd() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this.editandoIndex !== null) {
	            for (var i in _this.curso) {
	              _this.cursoTabela[i] = _this.curso[i];
	            }
	          } else {
	            _this.table.items.push(_this.curso);
	          }
	          _this.onCancel();
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound'
	};

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _Roteiro = __webpack_require__(516);
	
	var _Roteiro2 = _interopRequireDefault(_Roteiro);
	
	var _PendenciasProjeto = __webpack_require__(527);
	
	var _PendenciasProjeto2 = _interopRequireDefault(_PendenciasProjeto);
	
	var _Integridade = __webpack_require__(1708);
	
	var _Integridade2 = _interopRequireDefault(_Integridade);
	
	var _AvisoMudancas = __webpack_require__(1706);
	
	var _AvisoMudancas2 = _interopRequireDefault(_AvisoMudancas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = [];
	
	exports.default = {
	  components: {
	    VisualizaPendenciasProjeto: _PendenciasProjeto2.default,
	    VisualizaRoteiro: _Roteiro2.default,
	    Integridade: _Integridade2.default,
	    AvisoMudancas: _AvisoMudancas2.default
	  },
	  name: 'DashboardIndex',
	  data: function data() {
	    return {
	      data: [],
	      loading: {
	        show: false
	      },
	      usuariosLogados: [],
	      propostas: [],
	      projetos: [],
	      idEntidade: null,
	      items: [],
	      chamados: [],
	
	      mensagens: [],
	      relatorios: {
	        alerta: {
	          row: []
	        }
	      },
	      itemsProjetos: [],
	      perfis: {},
	      filtros: {
	        createdAt: null
	      },
	      projetoEntidade: null,
	      filtrosProjetos: {
	        createdAt: null
	      },
	      fields: [{ key: 'dt_criado', label: 'Data de inclusão', sortable: true, 'class': 'text-center' }, { key: 'NomeEntidade', label: 'Entidade', sortable: true, 'class': 'text-center' }, { key: 'ds_nome', label: 'Proposta', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'ds_fase', label: 'Fase', sortable: true, 'class': 'text-center' }, { key: 'ds_numero_simplificado', label: 'Tipo', 'class': 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'width: 14%' }],
	      fieldsProjetos: [{ key: 'ds_codigo_projeto_erp', label: 'Nº Projeto', thStyle: 'width: 6%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'ds_nome', label: 'Projeto', thStyle: 'width: 30%; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'actions', label: 'Acessar:', thStyle: 'width: 8%; text-align: center', 'class': 'text-center' }],
	      table: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: items.length,
	        sortBy: 'dt_criado',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      tableProjetos: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'dataCriacao',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      store: this.$store
	    };
	  },
	
	  watch: {
	    idEntidade: function idEntidade() {
	      if (this.usuarioLogado.userType === 'ENTIDADE' && !_.isNull(this.idEntidade)) {
	        this.buscaRelatoriosMensagem();
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {
	    if (typeof Storage !== 'undefined') {
	      this.propostas = _.get(JSON.parse(window.localStorage.getItem('propostas')), 'lista', []);
	      this.projetos = _.get(JSON.parse(window.localStorage.getItem('projetos')), 'lista', []);
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.usuarioLogado.ds_tipo_usuario === 'FUNDACAO') {
	      axiosLaravel.post('/ratificacao/ha_tarefa', { 'processo': 'RATIFICACAO_PAGAMENTO', 'tarefa': 'ASSINATURA_RATIFICACAO', 'situacao': 'EM_EXECUCAO' }).then(function (response) {
	        if (response.data.retorno > 0) {
	          _this.$router.push({ name: 'lista-ratificacao-pendentes' });
	        }
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    } else {
	      this.idEntidade = _.has(this.usuarioLogado.entidade, 'id') ? this.usuarioLogado.entidade.id : !_.isNull(this.usuarioLogado.fk_entidade) ? this.usuarioLogado.fk_entidade : null;
	      this.buscaChamados();
	    }
	  },
	  filters: {
	    simplificado: function simplificado(value) {
	      if (value === 'null') return 'Prospecção Direta';
	      return value;
	    }
	  },
	  methods: {
	    buscaRelatoriosMensagem: function buscaRelatoriosMensagem() {
	      var _this2 = this;
	
	      axiosLaravel.get('/relatorio_execucao/busca_relatorios_mensagem/' + this.idEntidade).then(function (response) {
	        _this2.relatorios = response.data;
	        if (_.has(_this2.relatorios, 'alerta') && _.has(_this2.relatorios.alerta, 'row') && (_.has(_this2.relatorios.alerta.row, 'mensagem') || _this2.relatorios.alerta.row.length > 0)) {
	          _this2.mensagens = _.isArray(_this2.relatorios.alerta.row) ? _.map(_this2.relatorios.alerta.row, 'mensagem') : [_this2.relatorios.alerta.row.mensagem];
	        }
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	        _this2.$snotify.clear();
	      });
	    },
	    buscaChamados: function buscaChamados() {
	      var _this3 = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('chamado/').then(function (response) {
	        var listaProjetos = response.data;
	        var acessosProjetos = _.get(_this3.usuarioLogado, 'configuracoes.acesso_projetos');
	        if (acessosProjetos) {
	          acessosProjetos.forEach(function (projeto) {
	            if (_.find(projeto.acesso, ['codigo', 'SEM_ACESSO'])) {
	              _.remove(listaProjetos, ['projeto', projeto.numero]);
	            }
	          });
	        }
	        var array = listaProjetos.filter(function (item) {
	          return item.status_id !== 5;
	        });
	        _this3.chamados = array;
	        _this3.$forceUpdate();
	        _this3.loading.show = false;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.loading.show = false;
	      });
	    },
	    onVisualizate: function onVisualizate(row) {},
	    authorizeEditProposal: function authorizeEditProposal(row) {
	      return row.item.ds_fase === 'CADASTRO' && this.$root.authorize('proposta-cadastro-completo');
	    },
	    isEditable: function isEditable(row) {
	      return true;
	    },
	    accessValidProposal: function accessValidProposal() {
	      var boolean = false;
	      if (this.$root.authorize('proposta-visualizar') || this.$root.authorize('proposta-visualizar-por-mim') || this.$root.authorize('minha-proposta-visualizar')) {
	        if (this.$root.authorize('dashboard-propostas')) {
	          boolean = true;
	        }
	      }
	      return boolean;
	    }
	  }
	};

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'visualiza-roteiro',
	  data: function data() {
	    return {
	      loadingShow: false,
	      propostas: []
	    };
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  mounted: function mounted() {},
	  created: function created() {
	    this.carregarPropostas();
	  },
	
	  methods: {
	    carregarPropostas: function carregarPropostas() {
	      var _this = this;
	
	      var idEntidade = _.has(this.usuarioLogado.entidade, 'id') ? this.usuarioLogado.entidade.id : !_.isNull(this.usuarioLogado.fk_entidade) ? this.usuarioLogado.fk_entidade : null;
	      this.loadingShow = true;
	      if (!_.isNull(idEntidade)) {
	        axiosLaravel.post('roteiro/contratacao', { 'id_entidade': idEntidade }).then(function (response) {
	          console.log('roteiro/contratacao', response.data);
	          _this.propostas = response.data;
	          _this.loadingShow = false;
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	          _this.loadingShow = false;
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _vuex = __webpack_require__(3);
	
	var _deepObjectDiff = __webpack_require__(83);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default
	  },
	  name: 'dirigentes',
	  data: function data() {
	    return {
	      showgrid: true,
	      dataMinima: '1800-01-01',
	      dataMaxima: '9999-12-31',
	      state: 'GRID',
	      chiefs: [],
	      arr: [],
	      bloqueioCampos: false,
	      statusEntidade: '',
	      loading: {
	        show: false
	      },
	      salvouOK: false,
	      indiceAlt: -1,
	      curIndex: 0,
	      index: 0,
	      naoAchou: 0,
	      texto: [],
	      dirigentes: {
	        endereco: [],
	        contato: [],
	        documentos: []
	      },
	      mostraInclusao: false,
	      mostraExclusao: false,
	      mostraAlteracao: false,
	      mudancas: [],
	      listaUsu: [],
	      mandatos: {},
	      mandato: {},
	      editandoIndex: null,
	      campoErro: null,
	      inativosOcultados: true,
	      dt_data_nascimento: '',
	      dt_inicio_mandato: '',
	      dt_fim_mandato: '',
	      estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
	      table: {
	        items: this.entDirigentes,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 50,
	        fields: [{ key: 'ds_nome', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'dt_inicio_mandato', label: 'Inicio do mandato', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'dt_fim_mandato', label: 'Vigência do mandato', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      listaDocDirigentes: 'CADASTRO_DIRIGENTE'
	    };
	  },
	
	  props: ['entDirigentes', 'disable', 'mudaDirigente', 'diferenca', 'analise', 'revisao', 'entidadeParceira'],
	  watch: {
	    entDirigentes: {
	      immediate: true,
	      handler: function handler() {
	        this.table.items = _.map(this.entDirigentes, function (d) {
	          return _.cloneDeep(d);
	        });
	        this.desativado = this.disable;
	        if (this.mudaDirigente) {
	          this.mudancas = this.mudaDirigente;
	        }
	      }
	    },
	    dt_data_nascimento: function dt_data_nascimento(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.dirigentes.dt_data_nascimento = newdate.format('YYYY-MM-DD');
	      }
	    },
	    dt_inicio_mandato: function dt_inicio_mandato(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.dirigentes.dt_inicio_mandato = newdate.format('YYYY-MM-DD');
	      }
	    },
	    dt_fim_mandato: function dt_fim_mandato(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.dirigentes.dt_fim_mandato = newdate.format('YYYY-MM-DD');
	      }
	    },
	    diferenca: function diferenca() {
	      this.diferencaDir = this.diferenca;
	    },
	    analise: function analise() {
	      if (this.analise) {
	        this.analiseDir = this.analise.dirigentes;
	      }
	    },
	    revisao: function revisao() {
	      if (this.revisao) {
	        this.revisaoDir = this.revisao.dirigentes;
	        this.mostraExclusao = false;
	        this.mostraInclusao = false;
	        if (this.analiseDir && this.revisaoDir) {
	          if (this.analiseDir.length > this.revisaoDir.length) {
	            this.mostraExclusao = true;
	            this.mostraInclusao = false;
	          } else {
	            this.mostraExclusao = true;
	          }
	          if (this.analiseDir.length < this.revisaoDir.length) {
	            this.mostraInclusao = true;
	            this.mostraExclusao = false;
	          } else {
	            this.mostraInclusao = false;
	          }
	          if (this.analiseDir.length === this.revisaoDir.length) {
	            this.mostraExclusao = false;
	          }
	        }
	        this.adicionados = (0, _deepObjectDiff.detailedDiff)(this.analise, this.revisao).added;
	        this.excluidos = _.differenceBy(this.analise.dirigentes, this.revisao.dirigentes, 'ds_nome');
	        if (this.adicionados) {
	          if (this.adicionados.dirigentes) {
	            this.inclDir = this.adicionados.dirigentes;
	            this.inclDirTexto = _.map(this.inclDir, 'ds_nome');
	            this.naoExisteDir = false;
	          } else {
	            this.naoExisteDir = true;
	          }
	        }
	        if (this.excluidos) {
	          this.excDirTexto = _.map(this.excluidos, 'ds_nome');
	        }
	      }
	    },
	    mudaDirigente: function mudaDirigente() {
	      if (this.mudaDirigente) {
	        this.mudancas = this.mudaDirigente.dirigentes;
	        console.log('this.mudancas>>>>>', this.mudancas);
	        for (var i = 0; i < this.mudancas.length; i++) {
	          if (this.mudancas[i].cargo) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].contato) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].documentos) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].ds_estado_civil) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].ds_gender) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].ds_rua) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].ds_profissao) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].dt_fim_mandato) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].dt_inicio_mandato) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].bt_ativo) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].bt_assinatura_requerida) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].bt_assinatura_entidade) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].bt_representante_legal) {
	            this.arr.push(i);
	          } else if (this.mudancas[i].endereco) {
	            if (this.mudancas[i].endereco.length > 0) {
	              this.arr.push(i);
	            }
	          }
	        }
	      }
	
	      console.log('this.arr', this.arr);
	
	      for (var _i = 0; _i < this.mudancas.length; _i++) {
	        if (this.mudancas && this.mostraInclusao === false) {
	          console.log('caiu aqui 1');
	          if (_.findKey(this.mudancas, 'cargo')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'cargo');
	          }
	          if (_.findKey(this.mudancas, 'contato')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'contato');
	          }
	          if (_.findKey(this.mudancas, 'documentos')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'documentos');
	          }
	          if (_.findKey(this.mudancas, 'ds_estado_civil')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'ds_estado_civil');
	          }
	          if (_.findKey(this.mudancas, 'ds_gender')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'ds_gender');
	          }
	          if (_.findKey(this.mudancas, 'ds_rua')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'ds_rua');
	          }
	          if (_.findKey(this.mudancas, 'ds_profissao')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'ds_profissao');
	          }
	          if (_.findKey(this.mudancas, 'dt_fim_mandato')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'dt_fim_mandato');
	          }
	          if (_.findKey(this.mudancas, 'dt_inicio_mandato')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'dt_inicio_mandato');
	          }
	          if (_.findKey(this.mudancas, 'endereco')) {
	            if (this.mudancas.endereco) {
	              if (this.mudancas.endereco.length > 0) {
	                this.indiceAlt = _.findKey(this.mudancas, 'endereco');
	              }
	            }
	          }
	          if (_.findKey(this.mudancas, 'bt_ativo')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'bt_ativo');
	          }
	          if (_.findKey(this.mudancas, 'bt_assinatura_requerida')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'bt_assinatura_requerida');
	          }
	          if (_.findKey(this.mudancas, 'bt_assinatura_entidade')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'bt_assinatura_entidade');
	          }
	          if (_.findKey(this.mudancas, 'bt_representante_legal')) {
	            this.indiceAlt = _.findKey(this.mudancas, 'bt_representante_legal');
	          }
	          console.log('arr>>>>', this.indiceAlt);
	          console.log('indiceAlt>>>>', this.indiceAlt);
	          if (this.indiceAlt !== -1) {
	            console.log('mostraAlteracao1', this.mostraAlteracao);
	            this.mostraAlteracao = true;
	            this.texto = this.diferencaDir.dirigentes[this.indiceAlt];
	            console.log('texto======================', this.texto);
	
	            if (this.texto.bt_ativo !== undefined) {
	              this.texto.bt_ativo = this.toBooleanText(this.texto.bt_ativo, 'Ativo', 'Inativo');
	            }
	            if (this.texto.bt_assinatura_entidade !== undefined) {
	              this.texto.bt_assinatura_entidade = this.toBooleanText(this.texto.bt_assinatura_entidade, 'Sim', 'Não');
	            }
	            if (this.texto.bt_assinatura_requerida !== undefined) {
	              this.texto.bt_assinatura_requerida = this.toBooleanText(this.texto.bt_assinatura_requerida, 'Sim', 'Não');
	            }
	            if (this.texto.bt_representante_legal !== undefined) {
	              this.texto.bt_representante_legal = this.toBooleanText(this.texto.bt_representante_legal, 'Sim', 'Não');
	            }
	          } else {
	            console.log('mostraAlteracao2', this.mostraAlteracao);
	            this.texto = [];
	            this.mostraAlteracao = false;
	          }
	        }
	      }
	    }
	  },
	  'table.items': function tableItems() {
	    this.$emit('dirigenteAdicionado', this.table.items);
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel']), {
	    rows: function rows() {
	      return this.table.items.length;
	    }
	  }),
	  created: function created() {
	    this.mandatoDirigente();
	    if (this.$route.params.entidade) {
	      this.statusEntidade = this.$route.params.entidade.ds_status;
	      this.processoAnterior = this.$route.params.entidade.processos.length;
	      if (this.statusEntidade === 'COMPLETO' && this.processoAnterior > 1) {
	        this.bloqueioCampos = true;
	      }
	      if (this.$route.params.name !== 'validacao-entidades') {
	        this.inativosOcultados = false;
	      }
	    }
	  },
	
	  methods: {
	    toBoolean: function toBoolean(value) {
	      if (typeof value === 'boolean') {
	        return value;
	      }
	      return Number(value) === 1;
	    },
	    toBooleanText: function toBooleanText(value) {
	      var textTrue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Sim';
	      var textFalse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Não';
	
	      var boolValue = this.toBoolean(value);
	      return boolValue ? textTrue : textFalse;
	    },
	    inativosMostrarOcultar: function inativosMostrarOcultar(item) {
	      if (this.inativosOcultados) {
	        if (!this.toBoolean(item.bt_ativo)) return 'linha_ocultada';
	      } else {
	        if (!this.toBoolean(item.bt_ativo)) return '';
	      }
	    },
	    trataDatas: function trataDatas() {
	      if (this.dirigentes.ds_cpf) {
	        this.dt_data_nascimento = (0, _moment2.default)(this.dirigentes.dt_data_nascimento).format('DD/MM/YYYY');
	        this.dt_inicio_mandato = (0, _moment2.default)(this.dirigentes.dt_inicio_mandato).format('DD/MM/YYYY');
	        this.dt_fim_mandato = (0, _moment2.default)(this.dirigentes.dt_fim_mandato).format('DD/MM/YYYY');
	      } else {
	        this.dt_data_nascimento = this.dt_inicio_mandato = this.dt_fim_mandato = '';
	      }
	    },
	    onNew: function onNew() {
	      this.dirigentes = {};
	      this.dirigentes.endereco = {};
	      this.dirigentes.contato = {};
	      this.dirigentes.documentos = [];
	      this.state = 'FORM';
	      this.editandoIndex = null;
	      this.curIndex = -1;
	      this.bloqueioCampos = false;
	      this.trataDatas();
	      this.$validator.reset();
	    },
	    mandatoDirigente: function mandatoDirigente() {
	      var _this = this;
	
	      axiosLaravel.get('cargos/').then(function (response) {
	        _this.mandatos = response.data;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onCancel: function onCancel() {
	      this.state = 'GRID';
	      this.curIndex = 0;
	      this.bloqueioCampos = false;
	      this.dt_data_nascimento = this.dt_inicio_mandato = this.dt_fim_mandato = '';
	    },
	    buscaCEP: function buscaCEP() {
	      var _this2 = this;
	
	      if (this.dirigentes.endereco.ds_cep !== undefined && this.dirigentes.endereco.ds_cep !== null && this.dirigentes.endereco.ds_cep !== '') {
	        if (this.dirigentes.endereco.ds_cep) {
	          this.loading.show = true;
	          var cep = this.dirigentes.endereco.ds_cep.replace('-', '');
	          axiosLaravel.get('municipios/cep/' + cep).then(function (response) {
	            _this2.dirigentes.endereco['ds_cidade'] = response.data.ds_nome;
	            _this2.dirigentes.endereco['ds_estado'] = response.data.ds_uf;
	            _this2.$forceUpdate();
	            _this2.loading.show = false;
	          }).catch(function (error) {
	            cep = _.repeat('0', 8 - ('' + cep).length) + cep;
	            _this2.$viaCep.buscarCep(cep).then(function (obj) {
	              if (obj.erro) {
	                _this2.$snotify.error('Não foi encontrado esse CEP. Entre em contato com a Fundação BB.');
	              } else {
	                _this2.dirigentes.endereco['ds_cidade'] = _.toUpper(obj.localidade);
	                _this2.dirigentes.endereco['ds_estado'] = _.toUpper(obj.uf);
	              }
	              _this2.loading.show = false;
	              _this2.$forceUpdate();
	            }).catch(function (errorViaCep) {
	              _this2.$snotify.error('Erro ao buscar CEP externamente. Entre em contato com a Fundação BB.');
	              _this2.loading.show = false;
	              _this2.$root.trataErro(error);
	            });
	          });
	        }
	      }
	    },
	    onAdd: function onAdd() {
	      var _this3 = this;
	
	      if (_.isEmpty(this.dirigentes.documentos)) {
	        this.$snotify.error('É necessário inserir ao menos um documento para o dirigente!');
	        return;
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          var dirigenteNormalizado = _.cloneDeep(_this3.dirigentes);
	
	          if (_this3.editandoIndex !== null) {
	            _this3.table.items[_this3.editandoIndex] = dirigenteNormalizado;
	
	            _this3.$refs.tableDirigentes.refresh();
	          } else {
	            _this3.table.items.push(dirigenteNormalizado);
	          }
	          _this3.$forceUpdate();
	
	          var currentDate = new Date();
	          var hoje = (0, _moment2.default)(currentDate).format('YYYYMMDD');
	          var representantesValidos = [];
	          _.forEach(_this3.table.items, function (o) {
	            if (_this3.toBoolean(o.bt_assinatura_entidade) && _this3.toBoolean(o.bt_ativo) && _this3.toBoolean(o.bt_representante_legal) && _this3.toBoolean(o.bt_assinatura_requerida)) {
	              var dataInicial = (0, _moment2.default)(o.dt_inicio_mandato).format('YYYYMMDD');
	              var dataFinal = (0, _moment2.default)(o.dt_fim_mandato).format('YYYYMMDD');
	              if (dataInicial <= hoje && hoje <= dataFinal) {
	                representantesValidos.push(o);
	              }
	            }
	          });
	          _this3.$emit('validacaoDirigente', { 'tag': 'peloMenosUmRepresentante', 'ativo': representantesValidos.length === 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Deve haver pelo menos um dirigente que é <b>representante legal com mandato vigente e ativo</b>' });
	          _this3.$emit('dirigenteSalvo', _this3.table.items);
	          _this3.onCancel();
	          sessionStorage.removeItem('param');
	        } else {
	          _this3.$snotify.error('O formulário de Dirigentes possui erros. Favor verificar!');
	        }
	      });
	    },
	    edita: function edita(row) {
	      var _this4 = this;
	
	      this.mandatoDirigente();
	      if (this.$route.params.entidade) {
	        this.statusEntidade = this.$route.params.entidade.ds_status;
	        if (this.statusEntidade === 'COMPLETO') {
	          this.bloqueioCampos = true;
	          this.$forceUpdate();
	        }
	        if (row.item.ds_cod_seq_erp && row.item.id) {
	          this.bloqueioCampos = true;
	          this.$forceUpdate();
	        } else {
	          this.bloqueioCampos = false;
	        }
	      }
	
	      this.state = 'FORM';
	      this.editandoIndex = row.index;
	      this.dirigentes = _.cloneDeep(row.item);['bt_ativo', 'bt_assinatura_entidade', 'bt_assinatura_requerida', 'bt_representante_legal'].forEach(function (field) {
	        if (typeof _this4.dirigentes[field] === 'boolean') {
	          _this4.dirigentes[field] = _this4.dirigentes[field] ? 1 : 0;
	        }
	      });
	      this.trataDatas();
	      if (this.dirigentes.endereco && this.dirigentes.endereco.ds_cep && !this.dirigentes.endereco.ds_cidade && !this.dirigentes.endereco.ds_estado) {
	        this.buscaCEP();
	      }
	
	      this.$forceUpdate();
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    },
	    adicionaEmpresaLigada: function adicionaEmpresaLigada(dirigente) {
	      if (_.isNull(_.get(dirigente, 'dados', null))) {
	        _.set(dirigente, 'dados', { 'empresas': [] });
	      }
	      if (!_.has(dirigente.dados, 'empresas')) {
	        _.set(dirigente.dados, 'empresas', []);
	      }
	      dirigente.dados.empresas.push({ 'cnpj': null, 'nome': '', 'inclusao': null, 'desligamento': null });
	      this.$forceUpdate();
	    }
	  }
	};

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _deepObjectDiff = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'endereco',
	  data: function data() {
	    return {
	      showgrid: true,
	      state: '',
	      address: [],
	      naoAchou: 0,
	      curIndex: 0,
	      endereco: {},
	      listaEnd: {},
	      jaExiste: 0,
	      indiceAlt: -1,
	      acao: '',
	      texto: {
	        ds_numero: '',
	        ds_complemento: ''
	      },
	      mostraInclusao: false,
	      mostraExclusao: false,
	      mostraAlteracao: false,
	      naoExisteSapiens: false,
	      loading: {
	        show: false
	      },
	      mudancas: [],
	      tabEndereco: [],
	      retornoCEP: {},
	      tempArray: {},
	      editandoIndex: null,
	      table: {
	        items: this.entEnderecos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'ds_cep', label: 'CEP', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_rua', label: 'Endereço', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_numero', label: 'Número', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, {
	          key: 'ds_complemento',
	          label: 'Complemento',
	          sortable: true,
	          thStyle: 'text-align: center',
	          class: 'text-center'
	        }, { key: 'ds_bairro', label: 'Bairro', thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'ds_cidade', label: 'Cidade', thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'ds_estado', label: 'UF', thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'bt_principal', label: 'Principal', thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['entEnderecos', 'disable', 'mudaEndereco', 'diferenca', 'analise', 'revisao'],
	  watch: {
	    entEnderecos: function entEnderecos() {
	      this.table.items = this.entEnderecos;
	      this.desativado = this.disable;
	    },
	    diferenca: function diferenca() {
	      this.diferencaEnd = this.diferenca;
	    },
	    analise: function analise() {
	      if (this.analise) {
	        this.analiseEnd = this.analise.endereco;
	      }
	    },
	    revisao: function revisao() {
	      this.revisaoEnd = this.revisao.endereco;
	      this.mostraExclusao = false;
	      this.mostraInclusao = false;
	      if (this.analiseEnd && this.revisaoEnd) {
	        if (this.analiseEnd.length > this.revisaoEnd.length) {
	          this.mostraExclusao = true;
	          this.mostraInclusao = false;
	        } else {
	          this.mostraExclusao = true;
	        }
	        if (this.analiseEnd.length < this.revisaoEnd.length) {
	          this.mostraInclusao = true;
	          this.mostraExclusao = false;
	        } else {
	          this.mostraInclusao = false;
	        }
	        if (this.analiseEnd.length === this.revisaoEnd.length) {
	          this.mostraExclusao = false;
	        }
	      }
	      this.adicionados = (0, _deepObjectDiff.detailedDiff)(this.analise, this.revisao).added;
	      this.excluidos = _.differenceBy(this.analise.endereco, this.revisao.endereco, 'ds_rua');
	      if (this.adicionados) {
	        if (this.adicionados.endereco) {
	          this.inclEnd = this.adicionados.endereco;
	          this.inclEndTexto = _.map(this.inclEnd, 'ds_rua');
	          this.naoExisteEnd = false;
	        } else {
	          this.naoExisteEnd = true;
	        }
	      }
	      if (this.excluidos) {
	        this.excEndTexto = _.map(this.excluidos, 'ds_rua');
	      }
	    },
	    mudaEndereco: function mudaEndereco() {
	      this.mudancas = this.diferencaEnd.endereco;
	      if (this.mudancas) {
	        if (_.findKey(this.mudancas, 'ds_cep')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_cep');
	        }
	        if (_.findKey(this.mudancas, 'ds_cidade')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_cidade');
	        }
	        if (_.findKey(this.mudancas, 'ds_estado')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_estado');
	        }
	        if (_.findKey(this.mudancas, 'ds_numero')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_numero');
	        }
	        if (_.findKey(this.mudancas, 'ds_rua')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_rua');
	        }
	        if (_.findKey(this.mudancas, 'ds_bairro')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_bairro');
	        }
	        if (_.findKey(this.mudancas, 'ds_complemento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_complemento');
	        }
	        if (_.findKey(this.mudancas, 'bt_principal')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'bt_principal');
	        }
	        if (this.indiceAlt !== -1) {
	          this.mostraAlteracao = true;
	          this.texto = this.diferencaEnd.endereco[this.indiceAlt];
	        } else {
	          this.mostraAlteracao = false;
	        }
	      }
	    },
	    'table.items': function tableItems() {
	      this.$emit('enderecoAdicionado', this.table.items);
	    }
	  },
	  created: function created() {
	    this.acao = this.$route.params.acao;
	  },
	  updated: function updated() {
	    this.acao = this.$route.params.acao;
	  },
	
	  methods: {
	    onNew: function onNew() {
	      this.endereco = {};
	      this.address = {};
	      this.editandoIndex = null;
	      this.state = 'FORM';
	      this.curIndex = -1;
	    },
	    onCancel: function onCancel() {
	      this.state = 'GRID';
	      this.curIndex = -1;
	    },
	    onAdd: function onAdd() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this.editandoIndex !== null) {
	            for (var i in _this.endereco) {
	              _this.address[i] = _this.endereco[i];
	            }
	          } else {
	            _this.table.items.push(_this.endereco);
	          }
	          _this.$forceUpdate();
	          _this.onCancel();
	        }
	      });
	    },
	    edita: function edita(row) {
	      this.state = 'FORM';
	      this.editandoIndex = row.index;
	      this.endereco = (0, _assign2.default)({}, row.item);
	      this.address = row.item;
	
	      if (this.mostraInclusao === true) {
	        this.mudancas = _.cloneDeep(_.get(this.diferencaEnd, ['endereco', row.index]));
	      } else {
	        this.mudancas = _.cloneDeep(_.get(this.mudaEndereco, ['endereco', row.index]));
	      }
	      if (this.texto === undefined || this.texto === 'undefined') {
	        this.texto.ds_numero = '';
	        this.texto.ds_complemento = '';
	      }
	      this.$forceUpdate();
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    },
	    buscaCEP: function buscaCEP() {
	      var _this2 = this;
	
	      if (this.endereco.ds_cep !== undefined && this.endereco.ds_cep !== null && this.endereco.ds_cep !== '') {
	        if (this.endereco.ds_cep) {
	          this.loading.show = true;
	          var cep = this.endereco.ds_cep.replace('-', '');
	          axiosLaravel.get('municipios/cep/' + cep).then(function (response) {
	            _this2.endereco.ds_cidade = response.data.ds_nome;
	            _this2.endereco.ds_estado = response.data.ds_uf;
	            _this2.$forceUpdate();
	            _this2.loading.show = false;
	          }).catch(function (error) {
	            cep = _.repeat('0', 8 - ('' + cep).length) + cep;
	            _this2.$viaCep.buscarCep(cep).then(function (obj) {
	              if (obj.erro) {
	                _this2.$snotify.error('Não foi encontrado esse CEP. Entre em contato com a FBB.');
	              } else {
	                _this2.endereco.ds_cidade = _.toUpper(obj.localidade);
	                _this2.endereco.ds_estado = _.toUpper(obj.uf);
	              }
	              _this2.loading.show = false;
	              _this2.$forceUpdate();
	            }).catch(function (errorViaCep) {
	              _this2.$snotify.error('Erro ao buscar CEP externamente. Entre em contato com a FBB.');
	              _this2.loading.show = false;
	              _this2.$root.trataErro(error);
	            });
	          });
	        }
	      }
	    },
	    verificaPrincipal: function verificaPrincipal(entidade) {
	      if (entidade.bt_principal === true || entidade.bt_principal === 0) {
	        for (var i = 0; i < this.table.items.length; i++) {
	          if (this.table.items[i].ds_cep !== entidade.ds_cep) {
	            if (this.table.items[i].bt_principal === true || this.table.items[i].bt_principal === 1) {
	              this.jaExiste = 1;
	            }
	          }
	        }
	        if (this.jaExiste === 1) {
	          this.$snotify.error('Somente 1 endereço pode ser selecionado como principal!');
	          return;
	        }
	      } else {
	        this.jaExiste = 0;
	      }
	    }
	  }
	};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'equipe-projeto',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsEquipes,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        totalRows: 0,
	        perPage: 100,
	        fields: [{ key: 'nr_quantidade', label: 'Quantidade', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_cargo', label: 'Cargo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_resumo_atividades', label: 'Resumo das atividades', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_perfil_desejado', label: 'Perfil profissional', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_forma_contratacao', label: 'Forma de contratação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'dc_carga_horaria', label: 'Carga horária semanal', thStyle: 'text-align: center', class: 'text-center' }, { key: 'bt_remunerado', label: 'Remuneração pelo projeto?', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      formEditavel: false,
	      equipe: {},
	      equipeTabela: {},
	      formasContratacao: [],
	      editandoIndex: null
	    };
	  },
	
	  props: ['propsEquipes'],
	  watch: {
	    propsEquipes: function propsEquipes() {
	      this.table.items = this.propsEquipes;
	      this.table.totalRows = this.table.items.length;
	    },
	    'table.items': function tableItems() {
	      this.$emit('equipeAdicionada', this.table.items);
	    }
	  },
	  mounted: function mounted() {
	    this.buscaEquipesDoProjeto();
	    this.buscaFormaContratacao();
	    this.formEditavel = !_.has(this.$route.params, 'numero');
	    if (!this.formEditavel) {
	      this.table.fields = _.remove(this.table.fields, function (f) {
	        return f.key !== 'actions';
	      });
	    }
	  },
	  methods: {
	    buscaEquipesDoProjeto: function buscaEquipesDoProjeto() {},
	    buscaFormaContratacao: function buscaFormaContratacao() {
	      var _this = this;
	
	      axiosLaravel.get('formas-contratacao').then(function (response) {
	        _this.formasContratacao = response.data;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onCancel: function onCancel() {
	      this.equipe = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	    },
	    onAdd: function onAdd() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.editandoIndex !== null) {
	            for (var i in _this2.equipe) {
	              _this2.equipeTabela[i] = _this2.equipe[i];
	            }
	          } else {
	            _this2.table.items.push(_this2.equipe);
	          }
	          _this2.onCancel();
	        }
	      });
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    },
	    edita: function edita(row) {
	      this.editandoIndex = row.index;
	      this.equipe = (0, _assign2.default)({}, row.item);
	      this.equipeTabela = row.item;
	      this.showgrid = false;
	    }
	  }
	};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'equipe-projetoOld',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsEquipes,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        totalRows: 0,
	        perPage: 10,
	        fields: [{ key: 'quantity', label: 'Quantidade', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'role', label: 'Cargo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'activityResume', label: 'Resumo das atividades', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'desiredProfile', label: 'Perfil profissional', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'hiringMethod', label: 'Forma de contratação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'workload', label: 'Carga horária semanal', thStyle: 'text-align: center', class: 'text-center' }, { key: 'remunerated', label: 'Remuneração pelo projeto?', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      equipe: {},
	      equipeTabela: {},
	      formasContratacao: [],
	      editandoIndex: null
	    };
	  },
	
	  props: ['propsEquipes'],
	  watch: {
	    propsEquipes: function propsEquipes() {
	      this.table.items = this.propsEquipes;
	      this.table.totalRows = this.table.items.length;
	    },
	    'table.items': function tableItems() {
	      this.$emit('equipeAdicionada', this.table.items);
	    }
	  },
	  mounted: function mounted() {
	    this.buscaEquipesDoProjeto();
	    this.buscaFormaContratacao();
	  },
	  methods: {
	    buscaEquipesDoProjeto: function buscaEquipesDoProjeto() {},
	    buscaFormaContratacao: function buscaFormaContratacao() {
	      var _this = this;
	
	      axios.get('proxy/project/proposal/project-team/hiring-method').then(function (response) {
	        _this.formasContratacao = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onCancel: function onCancel() {
	      this.equipe = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	    },
	    onAdd: function onAdd() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.editandoIndex !== null) {
	            for (var i in _this2.equipe) {
	              _this2.equipeTabela[i] = _this2.equipe[i];
	            }
	          } else {
	            _this2.table.items.push(_this2.equipe);
	          }
	          _this2.onCancel();
	        }
	      });
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    },
	    edita: function edita(row) {
	      this.editandoIndex = row.index;
	      this.equipe = (0, _assign2.default)({}, row.item);
	      this.equipeTabela = row.item;
	      this.showgrid = false;
	    }
	  }
	};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(123);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _isFinite = __webpack_require__(883);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _cotacaoItens = __webpack_require__(514);
	
	var _cotacaoItens2 = _interopRequireDefault(_cotacaoItens);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'extrato',
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      loading: {
	        cronograma: true,
	        item: true
	      },
	
	      idPropostaCronogramaCarregado: null,
	      requestCronogramaEmCurso: false,
	      totais: {
	        projeto: {
	          fbb: {
	            orcado: 0,
	            saldo: 0,
	            alterado: 0
	          },
	          parceiros: {
	            orcado: 0,
	            saldo: 0,
	            alterado: 0
	          },
	          contrapartida: {
	            orcado: 0,
	            saldo: 0,
	            alterado: 0
	          },
	          total: {
	            orcado: 0,
	            saldo: 0,
	            alterado: 0
	          }
	        },
	        adiantavel: {
	          fbb: {
	            orcado: 0,
	            saldo: 0,
	            alterado: 0
	          },
	          parceiros: {
	            orcado: 0,
	            saldo: 0,
	            alterado: 0
	          },
	          total: {
	            orcado: 0,
	            saldo: 0,
	            alterado: 0
	          }
	        },
	        solicitacao: {
	          fbb: 0,
	          parceiros: 0,
	          contrapartida: 0,
	          adiantavel: 0,
	          percentual: 0
	        }
	      },
	      contas: [],
	      layoutExtrato: 'classico',
	      layoutSolicitacao: null,
	      etapaProcesso: 'SOLICITACAO',
	      layoutFiltrosSelecionados: [],
	      listaSolicitacoes: {},
	      showForm: false,
	      bloqueiaBotoes: false,
	      numeracaoItemNovo: 0,
	      conta_financeira: {},
	      objetivos: [],
	      blockSelect: false,
	      atividade: {},
	      itemEditando: {},
	      alteracoes: [],
	      inclusoes: [],
	      solicitacao: {},
	      medidas: ['Caixas', 'Capacitações', 'Rolos', 'Unidades', 'Outros'],
	      componentKey: 0,
	      itemTabela: {},
	      items: [],
	      formasContratacao: [],
	      contasFinanceiras: [],
	      formEditavel: false,
	      atividadeTabela: {},
	      rules: 'required|min_value:1|max_value:' + this.meses,
	      table: {
	        currentPage: 0,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        fields: [{ key: 'id', label: 'ID', sortable: true, thStyle: 'width: 6%; text-align: center', class: 'text-center' }, { key: 'tipo_solicitacao', label: 'Tipo de Solicitação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_solicitacao', label: 'Data de Solicitação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'valor', label: 'Total da Solicitação', thStyle: 'text-align: center', class: 'text-center' }, { key: 'etapa', label: 'Etapa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'situacao', label: 'Situação', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      abrirCotacao: false,
	      cotacaoForm: []
	    };
	  },
	
	  props: ['propsObjetivos', 'propsAtividades', 'propsMetas', 'proposta', 'meses', 'projetoDuplicacao', 'editavel', 'layout', 'itensLayout', 'etapa', 'filtroInicial', 'tipoSolicitacao', 'atualizarExtrato', 'modoVisualizacaoAlteracoes', 'processoSolicitacao'],
	  components: {
	    cotacaoItens: _cotacaoItens2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    ehFBB: function ehFBB() {
	      return this.usuarioLogado.userType === 'FUNDACAO';
	    },
	    rotuloAgrupamentoExtrato: function rotuloAgrupamentoExtrato() {
	      switch (this.layoutExtrato) {
	        case 'porOrigem':
	          return 'Origem do Recurso';
	        case 'porConta':
	          return 'Conta';
	        default:
	          return 'Atividade';
	      }
	    },
	    extratoPorContaFinanceira: function extratoPorContaFinanceira() {
	      var agrupadoPorConta = this.propsAtividades.reduce(function (acc, atividade) {
	        ;(atividade.itens_orcamentos || []).forEach(function (item) {
	          if (_.has(item, 'mostrar') && !item.mostrar) return;
	          var numero = _.get(item, 'conta_financeira.numero_conta', _.get(item, 'contaFinanceiraNumero', null));
	          var chave = numero === null || numero === undefined || numero === '' ? 'SEM_CONTA' : String(numero);
	          if (!acc[chave]) acc[chave] = [];
	          acc[chave].push(item);
	        });
	        return acc;
	      }, {});
	
	      return agrupadoPorConta;
	    },
	    contas: function contas() {
	      var keys = (0, _keys2.default)(this.extratoPorContaFinanceira || {});
	      return _(keys).filter(function (k) {
	        return k !== 'SEM_CONTA';
	      }).sortBy(function (k) {
	        return k;
	      }).concat(keys.includes('SEM_CONTA') ? ['SEM_CONTA'] : []).value();
	    },
	    totaisPorContaFinanceira: function totaisPorContaFinanceira() {
	      var num = function num(v) {
	        var n = Number(v);
	        return (0, _isFinite2.default)(n) ? n : 0;
	      };
	
	      return _.mapValues(this.extratoPorContaFinanceira || {}, function (itens) {
	        var valorOrcado = _.sumBy(itens, function (i) {
	          return num(_.get(i, 'valorOrcado', 0));
	        });
	        var valorSaldo = _.sumBy(itens, function (i) {
	          return num(_.get(i, 'valorSaldo', 0));
	        });
	
	        var quantidadeOrcado = _.sumBy(itens, function (i) {
	          return num(_.get(i, 'quantidadeOrcado', 0));
	        });
	        var quantidadeSaldo = _.sumBy(itens, function (i) {
	          return num(_.get(i, 'quantidadeSaldo', 0));
	        });
	
	        var valorExecutado = valorOrcado - valorSaldo;
	        var percAtingimento = valorOrcado > 0 ? valorExecutado / valorOrcado : 0;
	
	        return {
	          qtdItens: (itens || []).length,
	          valorOrcado: valorOrcado,
	          valorSaldo: valorSaldo,
	          quantidadeOrcado: quantidadeOrcado,
	          quantidadeSaldo: quantidadeSaldo,
	          percAtingimento: percAtingimento
	        };
	      });
	    }
	  }),
	  watch: {
	    editavel: function editavel() {
	      this.formEditavel = this.editavel;
	      this.alteracoes = [];
	      this.calcularTotais();
	    },
	    propsObjetivos: function propsObjetivos() {},
	    projetoDuplicacao: function projetoDuplicacao() {
	      this.buscaContasFinanceiras();
	    },
	    meses: function meses() {},
	    atividades: function atividades() {
	      this.componentKey += 1;
	    },
	    layout: function layout() {
	      this.layoutExtrato = this.layout;
	    },
	    etapa: function etapa() {
	      this.etapaProcesso = this.etapa;
	    },
	    tipoSolicitacao: function tipoSolicitacao() {
	      this.layoutSolicitacao = this.tipoSolicitacao;
	      this.calcularTotais();
	    },
	    processoSolicitacao: function processoSolicitacao() {
	      this.solicitacao = _.get(this.processoSolicitacao, 'solicitacao', null);
	      this.complementarDadosExtrato();
	      this.$forceUpdate();
	    },
	    layoutFiltrosSelecionados: function layoutFiltrosSelecionados() {
	      this.filtrarExtrato();
	      this.filtrarExtratoPorContaFinanceira();
	      this.calcularTotais();
	    },
	
	    'proposta.id': function propostaId(novoId) {
	      if (!_.isNil(novoId) && novoId !== '' && this.idPropostaCronogramaCarregado !== novoId && (_.isUndefined(this.atualizarExtrato) || this.atualizarExtrato)) {
	        this.buscaCronograma();
	      }
	    },
	
	    propsAtividades: function propsAtividades(novo) {
	      var idProposta = _.get(this, 'proposta.id');
	      if (!_.isNil(idProposta) && idProposta !== '' && this.idPropostaCronogramaCarregado !== idProposta && Array.isArray(novo) && novo.length > 0 && (_.isUndefined(this.atualizarExtrato) || this.atualizarExtrato)) {
	        this.buscaCronograma();
	      }
	    }
	  },
	  created: function created() {
	    this.formEditavel = this.editavel;
	    this.etapaProcesso = this.etapa;
	    this.layoutExtrato = this.layout;
	    this.layoutSolicitacao = this.tipoSolicitacao;
	    this.solicitacao = _.get(this.processoSolicitacao, 'solicitacao', null);
	    this.layoutFiltrosSelecionados = this.filtroInicial || [];
	    if (_.isUndefined(this.atualizarExtrato) || this.atualizarExtrato) {
	      this.buscaCronograma();
	      this.buscaItensDespesas();
	    } else {
	      this.complementarDadosExtrato();
	    }
	  },
	  methods: {
	    filtrarExtrato: function filtrarExtrato() {
	      var _this = this;
	
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            var selecionados = 0;
	            selecionados += _.includes(_this.layoutFiltrosSelecionados, 'contrapartidas') && ('' + item.origem).substring(0, 1) === '2' ? 1 : 0;
	            selecionados += _.includes(_this.layoutFiltrosSelecionados, 'adiantaveis') && '' + item.adiantavel === '1' ? 1 : 0;
	            selecionados += _.includes(_this.layoutFiltrosSelecionados, 'saldos') && _.has(item, 'valorSaldo') && item.valorSaldo > 0 ? 1 : 0;
	            selecionados += _.includes(_this.layoutFiltrosSelecionados, 'servicos') && item.fk_itens.substring(0, 1) === 'S' ? 1 : 0;
	            selecionados += _.includes(_this.layoutFiltrosSelecionados, 'produtos') && item.fk_itens.substring(0, 1) === 'P' ? 1 : 0;
	            selecionados += _.includes(_this.layoutFiltrosSelecionados, 'solicitados') && (_.includes(['SUPLEMENTACAO', 'REMANEJAMENTO'], _this.layoutSolicitacao) && _.get(item, 'valorAlteracao', 0) !== 0 || _.find(_this.alteracoes, ['id', item.id]) || _.find(_this.inclusoes, ['id', item.id])) ? 1 : 0;
	            item['mostrar'] = _this.layoutFiltrosSelecionados.length === selecionados;
	          });
	        }
	      });
	    },
	    atualizaComponente: function atualizaComponente() {
	      this.$forceUpdate();
	    },
	    bloquearAspas: function bloquearAspas(event, obj, campo) {
	      var valorLimpo = event.target.value.replace(/['"`´]/g, '');
	      if (event.target.value !== valorLimpo) {
	        event.target.value = valorLimpo;
	      }
	      obj[campo] = valorLimpo;
	    },
	    getNumeroConta: function getNumeroConta(item) {
	      var numero = _.get(item, 'conta_financeira.numero_conta', null);
	      return numero === null || numero === undefined || numero === '' ? 'SEM_CONTA' : String(numero);
	    },
	    getRotuloConta: function getRotuloConta(numeroConta) {
	      if (numeroConta === 'SEM_CONTA') return 'Sem conta financeira';
	
	      var itemExemplo = _.get(this.extratoPorContaFinanceira, '[' + numeroConta + '][0]', null);
	      var desc = _.get(itemExemplo, 'conta_financeira.descricao', '') || _.get(itemExemplo, 'conta_financeira.descricao_conta', '');
	      return desc ? numeroConta + ' / ' + desc : '' + numeroConta;
	    },
	    filtrarExtratoPorContaFinanceira: function filtrarExtratoPorContaFinanceira() {
	      console.log('filtrarExtratoPorContaFinanceira');
	      var agrupadoPorConta = this.propsAtividades.reduce(function (acc, atividade) {
	        atividade.itens_orcamentos.forEach(function (item) {
	          var numero = item.conta_financeira.numero_conta;
	          if (!acc[numero]) acc[numero] = [];
	          acc[numero].push(item);
	        });
	        return acc;
	      }, {});
	      this.contas = (0, _keys2.default)(agrupadoPorConta);
	      console.log(agrupadoPorConta);
	      return agrupadoPorConta;
	    },
	    totalizarItens: function totalizarItens() {
	      var itens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var num = function num(v) {
	        var n = Number(v);
	        return (0, _isFinite2.default)(n) ? n : 0;
	      };
	      var valorOrcado = _.sumBy(itens, function (i) {
	        return num(i.valorOrcado);
	      });
	      var valorSaldo = _.sumBy(itens, function (i) {
	        return num(i.valorSaldo);
	      });
	
	      var quantidadeOrcado = _.sumBy(itens, function (i) {
	        return num(i.quantidadeOrcado);
	      });
	      var quantidadeSaldo = _.sumBy(itens, function (i) {
	        return num(i.quantidadeSaldo);
	      });
	
	      var valorExecutado = valorOrcado - valorSaldo;
	      var percAtingimento = valorOrcado > 0 ? valorExecutado / valorOrcado : 0;
	      return {
	        qtdItens: itens.length,
	        valorOrcado: valorOrcado,
	        valorSaldo: valorSaldo,
	        valorExecutado: valorExecutado,
	        percAtingimento: percAtingimento,
	        quantidadeOrcado: quantidadeOrcado,
	        quantidadeSaldo: quantidadeSaldo
	      };
	    },
	    valorProjetoOrigem: function valorProjetoOrigem(origem) {
	      var _this2 = this;
	
	      var valorOrcado = 0;
	      var valorSaldo = 0;
	      var valorAlteracao = 0;
	      var valorSolicitado = 0;
	      var valorAdiantavelOrcado = 0;
	      var valorAdiantavelAlterado = 0;
	      var valorAdiantavelSolicitado = 0;
	      if (_.isUndefined(this.propsAtividades)) {
	        return { orcado: 0, saldo: 0, adiantavel: 0, adiantavelAlterado: 0, adiantavelSolicitado: 0, alterado: 0, solicitado: 0 };
	      }
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (('' + item.origem).substring(0, 1) === origem) {
	              var orc = parseFloat(item.valorOrcado);
	              var sld = parseFloat(item.valorSaldo);
	              var alt = parseFloat(_.get(item, 'valorAlteracao', 0));
	
	              if (_this2.ehItemNovo(item)) {
	                valorOrcado += 0;
	              } else {
	                valorOrcado += orc;
	              }
	              valorSaldo += sld;
	              valorAlteracao += alt;
	              valorSolicitado += alt > 0 ? alt : 0;
	              valorAdiantavelOrcado += '' + item.adiantavel === '1' && !_this2.ehItemNovo(item) ? orc : 0;
	              valorAdiantavelAlterado += '' + item.adiantavel === '1' ? alt : 0;
	              valorAdiantavelSolicitado += '' + item.adiantavel === '1' && alt > 0 ? alt : 0;
	            }
	          });
	        }
	      });
	
	      return { orcado: valorOrcado, saldo: valorSaldo, adiantavel: valorAdiantavelOrcado, adiantavelAlterado: valorAdiantavelAlterado, adiantavelSolicitado: valorAdiantavelSolicitado, alterado: valorAlteracao, solicitado: valorSolicitado };
	    },
	    truncarValor: function truncarValor(valor) {
	      var epsilon = 1e-10;
	      valor = valor - epsilon;
	
	      var total = Math.ceil(valor * 100) / 100;
	
	      if (total > 0 && total < 0.09) {
	        total = Math.floor(valor * 100) / 100;
	      }
	
	      return total;
	    },
	    toCentavos: function toCentavos(valor) {
	      return Math.round((Number(valor) || 0) * 100);
	    },
	    fromCentavos: function fromCentavos(centavos) {
	      return centavos / 100;
	    },
	    normalizarDiferencaCentavo: function normalizarDiferencaCentavo(valor) {
	      var c = this.toCentavos(valor);
	      return Math.abs(c) <= 1 ? 0 : c / 100;
	    },
	    calcularTotais: function calcularTotais() {
	      var fbb = this.valorProjetoOrigem('1');
	      var contrapartida = this.valorProjetoOrigem('2');
	      var parceiro = this.valorProjetoOrigem('5');
	      this.totais.projeto.fbb.orcado = this.truncarValor(fbb.orcado);
	      this.totais.projeto.fbb.saldo = this.truncarValor(fbb.saldo);
	      this.totais.projeto.fbb.alterado = this.truncarValor(fbb.alterado);
	      this.totais.adiantavel.fbb.orcado = this.truncarValor(fbb.adiantavel);
	      this.totais.adiantavel.fbb.saldo = 0;
	      this.totais.adiantavel.fbb.alterado = this.truncarValor(fbb.adiantavelAlterado);
	      this.totais.projeto.contrapartida.orcado = this.truncarValor(contrapartida.orcado);
	      this.totais.projeto.contrapartida.saldo = this.truncarValor(contrapartida.saldo);
	      this.totais.projeto.contrapartida.alterado = this.truncarValor(contrapartida.alterado);
	      this.totais.projeto.parceiros.orcado = this.truncarValor(parceiro.orcado);
	      this.totais.projeto.parceiros.saldo = this.truncarValor(parceiro.saldo);
	      this.totais.projeto.parceiros.alterado = this.truncarValor(parceiro.alterado);
	      this.totais.adiantavel.parceiros.orcado = this.truncarValor(parceiro.adiantavel);
	      this.totais.adiantavel.parceiros.saldo = 0;
	      this.totais.adiantavel.parceiros.alterado = this.truncarValor(parceiro.adiantavelAlterado);
	      this.totais.projeto.total.orcado = this.truncarValor(fbb.orcado + contrapartida.orcado + parceiro.orcado);
	      this.totais.projeto.total.saldo = this.truncarValor(fbb.saldo + contrapartida.saldo + parceiro.saldo);
	      this.totais.projeto.total.alterado = this.truncarValor(this.totais.projeto.fbb.alterado + this.totais.projeto.parceiros.alterado + this.totais.projeto.contrapartida.alterado);
	      this.totais.adiantavel.total.orcado = this.truncarValor(fbb.adiantavel + parceiro.adiantavel);
	      this.totais.adiantavel.total.saldo = this.truncarValor(this.totais.adiantavel.fbb.saldo + this.totais.adiantavel.parceiros.saldo);
	      this.totais.adiantavel.total.alterado = this.truncarValor(this.totais.adiantavel.fbb.alterado + this.totais.adiantavel.parceiros.alterado);
	
	      this.totais.solicitacao.fbb = this.truncarValor(fbb.solicitado);
	      this.totais.solicitacao.parceiros = this.truncarValor(parceiro.solicitado);
	      this.totais.solicitacao.contrapartida = this.truncarValor(contrapartida.solicitado);
	      this.totais.solicitacao.adiantavel = this.truncarValor(fbb.adiantavelSolicitado + parceiro.adiantavelSolicitado);
	      this.totais.solicitacao.percentual = this.totais.projeto.fbb.orcado > 0 ? this.totais.solicitacao.fbb / this.totais.projeto.fbb.orcado : 0;
	      this.$forceUpdate();
	
	      this.$emit('validacaoCronograma', { 'tag': 'remanejamentoIncorreto', 'ativo': false });
	      this.$emit('validacaoCronograma', { 'tag': 'suplementacaoIncorreta', 'ativo': false });
	      if (this.layoutSolicitacao === 'REMANEJAMENTO') {
	        var invalido = this.normalizarDiferencaCentavo(this.totais.projeto.fbb.alterado) !== 0 || this.normalizarDiferencaCentavo(this.totais.projeto.parceiros.alterado) !== 0 || this.normalizarDiferencaCentavo(this.totais.projeto.contrapartida.alterado) !== 0;
	        this.$emit('validacaoCronograma', { 'tag': 'remanejamentoIncorreto', 'ativo': invalido, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Remanejamentos devem ter sua movimentação zerada. Verifique os totais!' });
	      }
	      if (this.layoutSolicitacao === 'SUPLEMENTACAO') {
	        var altFbb = this.normalizarDiferencaCentavo(this.totais.projeto.fbb.alterado);
	        var altParc = this.normalizarDiferencaCentavo(this.totais.projeto.parceiros.alterado);
	        var altContr = this.normalizarDiferencaCentavo(this.totais.projeto.contrapartida.alterado);
	        var altAdiFbb = this.normalizarDiferencaCentavo(this.totais.adiantavel.fbb.alterado);
	        var altAdiParc = this.normalizarDiferencaCentavo(this.totais.adiantavel.parceiros.alterado);
	        var possuiValorNegativo = altFbb < 0 || altParc < 0 || altContr < 0 || altAdiFbb < 0 || altAdiParc < 0;
	        var possuiSuplementacaoPositiva = altFbb > 0 || altParc > 0 || altContr > 0;
	        var _invalido = possuiValorNegativo || !possuiSuplementacaoPositiva;
	        this.$emit('validacaoCronograma', { 'tag': 'suplementacaoIncorreta', 'ativo': _invalido, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Suplementação deve ter total maior que zero e não deve conter itens negativos. Verifique o extrato e os totais!' });
	      }
	      this.$emit('acaoTotaisAtualizados', this.totais);
	      console.log('TOTAL CALCULADO: ', this.totais);
	    },
	    buscaCronograma: function buscaCronograma() {
	      var _this3 = this;
	
	      var idProposta = _.get(this, 'proposta.id');
	
	      if (_.isNil(idProposta) || idProposta === '') {
	        this.loading.cronograma = false;
	        return;
	      }
	
	      if (this.requestCronogramaEmCurso) {
	        return;
	      }
	
	      if (this.idPropostaCronogramaCarregado === idProposta) {
	        return;
	      }
	
	      if (_.isUndefined(this.propsAtividades) || _.isNull(this.propsAtividades) || Array.isArray(this.propsAtividades) && this.propsAtividades.length === 0) {
	        this.loading.cronograma = false;
	        return;
	      }
	      this.requestCronogramaEmCurso = true;
	      this.loading.cronograma = true;
	      axiosLaravel.post('processos/cronograma/projeto/', { 'proposta': idProposta, 'processo': 'PAGAMENTO', 'aglutinado': 'Completo', 'documento': 0 }).then(function (response) {
	        if (_.get(_this3, 'proposta.id') !== idProposta) {
	          _this3.requestCronogramaEmCurso = false;
	          _this3.loading.cronograma = false;
	          _this3.buscaCronograma();
	          return 0;
	        }
	        var saldos = response.data;
	
	        if (_.isUndefined(_this3.propsAtividades) || _.isNull(_this3.propsAtividades) || Array.isArray(_this3.propsAtividades) && _this3.propsAtividades.length === 0) {
	          _this3.requestCronogramaEmCurso = false;
	          _this3.loading.cronograma = false;
	          return 0;
	        }
	        try {
	          _this3.complementarDadosExtrato(saldos);
	          _this3.idPropostaCronogramaCarregado = idProposta;
	        } finally {
	          _this3.requestCronogramaEmCurso = false;
	        }
	      }).catch(function (error) {
	        _this3.requestCronogramaEmCurso = false;
	        _this3.loading.cronograma = false;
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    gerarMensalizacao: function gerarMensalizacao(item, valor) {
	      var mensalizacao = [];
	      var codigo = ('' + (_.get(item, 'fk_itens') || _.get(item, 'item.ds_code', ''))).substr(0, 1);
	      var quantidadeTotal = Math.round(parseFloat(_.get(item, 'quantidade', 0))) || 0;
	
	      var inicial = _.toSafeInteger(item.periodo_inicial);
	      var final = _.toSafeInteger(item.periodo_final);
	      if ('' + item.origem === '2') {
	        mensalizacao.push({ 'periodo': final, 'quantidade': quantidadeTotal, 'valor': valor });
	      } else if (codigo === 'P') {
	        mensalizacao.push({ 'periodo': inicial, 'quantidade': quantidadeTotal, 'valor': valor });
	      } else if (codigo === 'S') {
	        var meses = Math.max(final - inicial + 1, 1);
	        var parcelaValor = Math.floor(valor / meses * 100) / 100;
	        var restoValor = _.round(valor - parcelaValor * meses, 2);
	        var parcelaQtde = parseInt(quantidadeTotal / meses);
	        var restoQtde = quantidadeTotal - parcelaQtde * meses;
	        for (var p = 0; p < meses; p++) {
	          var ultimo = p === meses - 1;
	          mensalizacao.push({
	            'periodo': inicial + p,
	            'quantidade': ultimo ? parcelaQtde + restoQtde : parcelaQtde,
	            'valor': ultimo ? _.round(parcelaValor + restoValor, 2) : parcelaValor
	          });
	        }
	      }
	      return mensalizacao;
	    },
	    regenerarMensalizacaoItemNovo: function regenerarMensalizacaoItemNovo(item) {
	      if (!_.includes('' + _.get(item, 'id', ''), 'novo')) {
	        return;
	      }
	
	      _.set(item, 'periodo_inicial', _.toSafeInteger(item.periodo_inicial));
	      _.set(item, 'periodo_final', _.toSafeInteger(item.periodo_final));
	      var valor = _.round(_.toNumber(_.get(item, 'valorAlteracao', 0)), 2);
	      if (!(valor > 0)) {
	        return;
	      }
	
	      var unitario = _.toNumber(_.get(item, 'valor_unitario', 0));
	      if (unitario > 0) {
	        var quantidadeCoerente = _.round(valor / unitario, 2);
	        if (_.round(_.toNumber(_.get(item, 'quantidade', 0)), 2) !== quantidadeCoerente) {
	          _.set(item, 'quantidade', quantidadeCoerente);
	        }
	      }
	      var somaAtual = _.round(_.sumBy(item.orcamentos_mensalizados, function (mes) {
	        return _.has(mes, 'valor') ? mes.valor : 0;
	      }), 2);
	      var qtdeAtual = _.round(_.sumBy(item.orcamentos_mensalizados, function (mes) {
	        return _.toNumber(_.get(mes, 'quantidade', 0));
	      }), 2);
	
	      var qtdeAlvo = Math.round(parseFloat(_.get(item, 'quantidade', 0))) || 0;
	      if (somaAtual === valor && qtdeAtual === qtdeAlvo) {
	        return;
	      }
	      var mensalizacao = this.gerarMensalizacao(item, valor);
	      if (mensalizacao.length > 0) {
	        _.set(item, 'orcamentos_mensalizados', mensalizacao);
	      }
	    },
	    complementarDadosExtrato: function complementarDadosExtrato(saldos) {
	      var _this4 = this;
	
	      this.loading.cronograma = true;
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            _this4.regenerarMensalizacaoItemNovo(item);
	            item['valorOrcado'] = _.sumBy(item.orcamentos_mensalizados, function (iVO) {
	              return iVO.valor;
	            });
	            item['quantidadeOrcado'] = _.sumBy(item.orcamentos_mensalizados, function (iQO) {
	              return Number(iQO.quantidade);
	            });
	
	            item['valorSaldo'] = saldos ? _.sumBy(saldos.itens, function (sVS) {
	              return Number(item.id) === Number(sVS['Id_item']) ? sVS['Valor_saldo'] : 0;
	            }) : item['valorSaldo'];
	            item['quantidadeSaldo'] = saldos ? _.sumBy(saldos.itens, function (sQS) {
	              return Number(item.id) === Number(sQS['Id_item']) ? sQS['Qtde_saldo'] : 0;
	            }) : item['quantidadeSaldo'];
	            item['contaFinanceiraDescricao'] = _.has(item, 'conta_financeira') && _.has(item.conta_financeira, 'descricao') ? item.conta_financeira.descricao : '';
	            item['contaFinanceiraNumero'] = _.has(item, 'conta_financeira') && _.has(item.conta_financeira, 'numero_conta') ? item.conta_financeira.numero_conta : '';
	
	            if (_this4.processoSolicitacao && _this4.processoSolicitacao.hasOwnProperty('processos')) {
	              _this4.processoSolicitacao.processos.forEach(function (proc) {
	                if (proc.hasOwnProperty('alteracao') && proc.alteracao.length > 0) {
	                  proc.alteracao.forEach(function (alteracao) {
	                    if (!alteracao.hasOwnProperty('observacao') || !Array.isArray(alteracao.observacao)) {
	                      return;
	                    }
	                    if (alteracao.id === item.id) {
	                      console.log('achou', item.id);
	
	                      if (typeof alteracao.observacao[1] === 'undefined' || alteracao.observacao[1] === undefined || !alteracao.observacao[1] || alteracao.observacao[1] === 'undefined') {
	                        item['observacao'] = item['observacao'];
	                        item['observacaoNova'] = '';
	                      } else {
	                        if (alteracao.observacao[1].includes('<br/>')) {
	                          alteracao.observacao[1] = alteracao.observacao[1].split('<br/>')[1];
	                        }
	                        item['observacao'] = alteracao.observacao[0];
	                        item['observacao'] = alteracao.observacao[0];
	                        item['observacaoNova'] = alteracao.observacao[1];
	                        console.log('obs0', alteracao.observacao[0]);
	                        console.log('obs1', alteracao.observacao[1]);
	                      }
	                    }
	                  });
	                }
	              });
	            } else {
	              item['observacao'] = item['observacao'];
	              item['observacaoNova'] = '';
	            }
	            item['observacaoOriginal'] = item['observacao'];
	
	            var valorOrcado = saldos ? _.sumBy(saldos.itens, function (sVS) {
	              return Number(item.id) === Number(sVS['Id_item']) ? sVS['Valor_orcado'] : 0;
	            }) : item['valorOrcado'];
	            item['valorOrcado'] = item['valorOrcado'] !== valorOrcado ? valorOrcado : item['valorOrcado'];
	
	            var temSaldoErp = saldos && !_.includes('' + _.get(item, 'id', ''), 'novo');
	            var quantidadeOrcado = temSaldoErp ? _.sumBy(saldos.itens, function (sVS) {
	              return Number(item.id) === Number(sVS['Id_item']) ? sVS['Qtde_orcado'] : 0;
	            }) : item['quantidadeOrcado'];
	            item['quantidadeOrcado'] = item['quantidadeOrcado'] !== quantidadeOrcado ? quantidadeOrcado : item['quantidadeOrcado'];
	            if (item['valorOrcado'] > 0) {
	              item['percAtingimento'] = Math.ceil(('' + item.economicidade === '1' ? item['valorOrcado'] : item['valorOrcado'] - item['valorSaldo']) / item['valorOrcado'] * 100) / 100;
	              item['percAtingimento'] = item['percAtingimento'] > 1 ? 1 : item['percAtingimento'] < 0 ? 0 : item['percAtingimento'];
	            } else {
	              item['percAtingimento'] = 0;
	            }
	            if (_this4.ehItemNovo(item)) {
	              _this4.numeracaoItemNovo++;
	            }
	          });
	          atividade['valorOrcado'] = _.sumBy(atividade.itens_orcamentos, function (aVO) {
	            return aVO.valorOrcado;
	          });
	          atividade['quantidadeOrcado'] = _.sumBy(atividade.itens_orcamentos, function (aQO) {
	            return aQO.quantidadeOrcado;
	          });
	          atividade['valorSaldo'] = _.sumBy(atividade.itens_orcamentos, function (aVS) {
	            return aVS.valorSaldo;
	          });
	          atividade['quantidadeSaldo'] = _.sumBy(atividade.itens_orcamentos, function (aQS) {
	            return aQS.quantidadeSaldo;
	          });
	          if (atividade['valorOrcado'] > 0) {
	            atividade['percAtingimento'] = Math.ceil(('' + atividade.economicidade === '1' ? atividade['valorOrcado'] : atividade['valorOrcado'] - atividade['valorSaldo']) / atividade['valorOrcado'] * 100) / 100;
	            atividade['percAtingimento'] = atividade['percAtingimento'] > 1 ? 1 : atividade['percAtingimento'] < 0 ? 0 : atividade['percAtingimento'];
	          } else {
	            atividade['percAtingimento'] = 0;
	          }
	        }
	      });
	      this.calcularTotais();
	      this.ok();
	      this.loading.cronograma = false;
	    },
	    editar: function editar(item, itemIndex, atividade, atividadeIndex) {
	      this.itemEditando['acao'] = 'editando';
	      this.itemEditando['atividade'] = atividade;
	      this.itemEditando['atividadeIndex'] = atividadeIndex;
	      this.itemEditando['item'] = _.clone(item);
	      this.itemEditando['itemIndex'] = itemIndex;
	      this.itemEditando.item['observacaoNova'] = '';
	      if (this.ehItemNovo(item)) {
	        this.itemEditando.item['valor_unitario'] = parseFloat(item.valor_unitario);
	        this.itemEditando.item['quantidadeMinima'] = item.quantidadeOrcado;
	        this.itemEditando.item['valorAlteracao'] = parseFloat(item.quantidadeOrcado) * parseFloat(item.valor_unitario);
	      } else {
	        this.itemEditando.item['quantidadeMinima'] = item.quantidadeOrcado;
	        this.itemEditando.item['valor_unitario'] = parseFloat(item.valorOrcado) / parseFloat(item.quantidadeOrcado);
	        this.itemEditando.item['valorAlteracao'] = item.valorAlteracao || 0;
	      }
	      this.$forceUpdate();
	    },
	    ok: function ok() {
	      var _this5 = this;
	
	      if (!this.itemEditando.hasOwnProperty('item')) {
	        return;
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this5.propsAtividades.forEach(function (atividade) {
	            if (atividade.itens_orcamentos) {
	              atividade.itens_orcamentos.forEach(function (item) {
	                if (item.id === _this5.itemEditando.item.id) {
	                  if (_this5.ehItemNovo(_this5.itemEditando.item)) {
	                    _.set(item, 'observacao', _this5.itemEditando.item.observacao);
	                    _.set(item, 'observacaoOriginal', _this5.itemEditando.item.observacao);
	                    _.set(item, 'fk_itens', _this5.itemEditando.item.item.ds_code);
	                    var quantidade = _.toNumber(_this5.itemEditando.item.quantidadeOrcado);
	                    _.set(item, 'quantidade', quantidade);
	                    _.set(item, 'quantidadeMinima', quantidade);
	                    _.set(item, 'quantidadeSaldo', quantidade);
	                    var unitario = _.toNumber(_.get(_this5.itemEditando, 'item.valor_unitario', 0));
	                    _.set(item, 'valor_unitario', unitario);
	                    var valor = quantidade * unitario;
	                    _.set(item, 'valorSaldo', valor);
	                    _.set(item, 'valorOrcado', valor);
	                    _.set(item, 'valorAlteracao', valor);
	                    _.set(item, 'valor_total', valor);
	                    _.set(item, 'substituicao', _.get(_this5.itemEditando, 'substituicao', false));
	                    _.set(item, 'orcamentos_mensalizados', _this5.gerarMensalizacao(item, valor));
	                  } else {
	                    var obsNova = _this5.itemEditando.item.observacaoNova;
	                    if (obsNova && obsNova.trim()) {
	                      _this5.itemEditando.item['observacao'] = obsNova;
	                    }
	                    _this5.listaAlteracoes('quantidadeOrcado', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('valorOrcado', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('valor_unitario', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('adiantavel', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('unidade_medida', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('medida_outros', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('observacao', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('justificativa', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('valorAlteracao', item, _this5.itemEditando.item);
	                    _this5.listaAlteracoes('substituicao', item, _this5.itemEditando.item);
	                  }
	                  _.assign(item, _this5.itemEditando.item);
	                }
	              });
	            }
	          });
	          _this5.calcularTotais();
	          _this5.$emit('cronogramaAtividades', _this5.propsAtividades);
	          _this5.$emit('alteracoesCronograma', _this5.alteracoes);
	          _this5.$emit('acaoOk', _this5.componentKey++);
	          _this5.itemEditando = {};
	        }
	      });
	    },
	    cancelar: function cancelar(atividade) {
	      if (atividade && _.includes(['inserindo', 'excluindo'], this.itemEditando.acao)) {
	        _.remove(atividade.itens_orcamentos, ['id', this.itemEditando.item.id]);
	        this.$emit('acaoOk', this.componentKey++);
	      }
	      this.itemEditando = {};
	      this.calcularTotais();
	    },
	    listaAlteracoes: function listaAlteracoes(alteracao, antes, depois) {
	      var vm = this;
	      if (_.get(antes, [alteracao], null) !== depois[alteracao]) {
	        var registro = _.find(this.alteracoes, function (a) {
	          return vm.alteracoes.length > 0 && a.id === antes.id && a.alteracao === alteracao;
	        });
	        if (_.isNil(registro)) {
	          this.alteracoes.push({ 'id': antes.id, 'alteracao': alteracao, 'antes': antes[alteracao] || null, 'depois': depois[alteracao] });
	        } else {
	          if ('' + registro['antes'] === '' + depois[alteracao]) {
	            _.remove(this.alteracoes, function (n) {
	              return vm.alteracoes.length > 0 && n.id === antes.id && n.alteracao === alteracao;
	            });
	          } else {
	            registro['depois'] = depois[alteracao];
	          }
	        }
	      }
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    zeraAdiantamento: function zeraAdiantamento() {
	      if ('' + this.itemEditando.item.origem === '2') {
	        this.itemEditando.item.adiantavel = 0;
	      }
	    },
	    validaPeriodo: function validaPeriodo() {
	      if (_.toSafeInteger(this.itemEditando.item.periodo_final) < _.toSafeInteger(this.itemEditando.item.periodo_inicial) && this.itemEditando.item.periodo_final && this.itemEditando.item.periodo_inicial) {
	        var error = { field: 'inicio', msg: 'Período inicial não pode ser maior que o fim' };
	        this.$validator.errors.add(error);
	        return;
	      } else {
	        this.$validator.reset();
	      }
	    },
	    buscaItensDespesas: function buscaItensDespesas() {
	      var _this6 = this;
	
	      axiosLaravel.post('itens/contratacao', { 'tipos': ['PRODUTO', 'SERVICO'] }).then(function (response) {
	        _this6.items = response.data;
	      });
	    },
	    buscaContasFinanceiras: function buscaContasFinanceiras(row) {
	      var _this7 = this;
	
	      console.log('BUSCA CONTA FINANCEIRA');
	      var codigoItem = '';
	      if (row.ds_code) {
	        codigoItem = row.ds_code;
	      }
	      if (row.item) {
	        codigoItem = row.item.ds_code;
	      }
	      var tipoItem = codigoItem.substring(0, 1);
	      this.itemEditando.item['ds_type'] = tipoItem === 'P' ? 'PRODUTO' : tipoItem === 'S' ? 'SERVICO' : 'ERRO';
	      var projDuplicacao = this.projetoDuplicacao;
	      var fase = this.itemEditando.item.origem;
	      if (fase === 2 || fase === '2') {
	        fase = 1;
	      }
	      var obj = {};
	      obj.item = codigoItem;
	      obj.duplicador = projDuplicacao;
	      obj.fase = fase;
	      console.log(obj);
	      if (this.projetoDuplicacao) {
	        axiosLaravel.post('busca_conta_financeira/', obj).then(function (response) {
	          _this7.contasFinanceiras = response.data;
	          console.log(_this7.contasFinanceiras);
	          if (_this7.contasFinanceiras.length === 1) {
	            _this7.itemEditando.item.conta_financeira = _this7.contasFinanceiras[0];
	            _this7.blockSelect = true;
	          } else {
	            _this7.blockSelect = false;
	          }
	        }).catch(function (error) {
	          _this7.$root.trataErro(error);
	        });
	      }
	    },
	    ehItemNovo: function ehItemNovo(item) {
	      return !_.has(item, 'id') || _.includes(_.get(item, 'id', ''), 'novo') || _.find(_.get(this.solicitacao, 'inclusao', []), ['id', item.id]);
	    },
	    adicionaItem: function adicionaItem(atividade, atividadeIndex) {
	      if (_.includes('' + atividade.id, 'novo')) {
	        this.$snotify.error('Não é possível adicionar itens a uma atividade nova. É necessário processar a alteração antes de incluir novos itens.');
	        return;
	      }
	      var id = 'novo-' + this.numeracaoItemNovo++;
	      var itemNovo = {
	        'id': id,
	        'adiantavel': 0,
	        'origem': 1,
	        'economicidade': 0,
	        'observacao': '',
	        'fk_itens': 'S',
	        'unidade_medida': null,
	        'medida_outros': null,
	        'quantidade': 0,
	        'valor_unitario': 0,
	        'valor_total': 0,
	        'periodo_inicial': atividade.nr_periodo_inicial,
	        'periodo_final': atividade.nr_periodo_final,
	        'item': null,
	        'valorOrcado': 0,
	        'quantidadeOrcado': 0,
	        'valorSaldo': 0,
	        'quantidadeSaldo': 0,
	        'contaFinanceiraDescricao': '',
	        'contaFinanceiraNumero': 0,
	        'observacaoOriginal': '',
	        'percAtingimento': 0
	      };
	      atividade.itens_orcamentos.push(itemNovo);
	      this.itemEditando['acao'] = 'inserindo';
	      this.itemEditando['atividade'] = atividade;
	      this.itemEditando['atividadeIndex'] = atividadeIndex;
	      this.itemEditando['item'] = itemNovo;
	      this.itemEditando['itemIndex'] = atividade.itens_orcamentos.length - 1;
	      this.$forceUpdate();
	    },
	    irAtividades: function irAtividades() {
	      var _this8 = this;
	
	      this.$nextTick(function () {
	        if (_.has(_this8.$parent, 'mostrar')) _this8.$parent.mostrar.atividades = true;
	        setTimeout(function () {
	          _this8.$emit('criacaoAtividade', _.uniqueId());
	          _this8.$parent.$refs['atividades'].scrollIntoView();
	        }, 500);
	      });
	    },
	    desfazerAlteracao: function desfazerAlteracao(itemEdicao) {
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (item.id === itemEdicao.id) {
	              _.set(item, 'observacao', itemEdicao.observacaoOriginal);
	              _.unset(item, 'observacaoNova');
	              _.unset(item, 'valorAlteracao');
	              _.unset(item, 'justificativa');
	              _.unset(item, 'substituicao');
	            }
	          });
	        }
	      });
	      this.calcularTotais();
	      this.$emit('cronogramaAtividades', this.propsAtividades);
	      this.$emit('alteracoesCronograma', this.alteracoes);
	      this.$emit('acaoOk', this.componentKey++);
	      this.itemEditando = {};
	    },
	    consultarAbrirCotacao: function consultarAbrirCotacao(fkCotacao) {
	      var _this9 = this;
	
	      axiosLaravel.get('cotacao/getCotacao/' + fkCotacao).then(function (response) {
	        var cotacoes = response.data;
	
	        var itemCotacao = [];
	        var itemCotacaoManual = [];
	
	        if (cotacoes.itemCotacao[0].anexos.length > 0) {
	          itemCotacaoManual[0] = _this9.transformObjectToCamelCase(cotacoes.itemCotacao);
	          itemCotacao[0] = [];
	        } else {
	          itemCotacao[0] = _this9.transformObjectToCamelCase(cotacoes.itemCotacao);
	          itemCotacaoManual[0] = [];
	        }
	        console.log('itemCotacao - ', itemCotacao);
	        var cotacao = {
	          itemCotacao: itemCotacao,
	          itemCotacaoManual: itemCotacaoManual,
	          itemCotacaoValidado: {
	            responsavel: cotacoes.cotacao[0].responsavel_validacao,
	            validado: cotacoes.cotacao[0].validado,
	            horaValidacao: (0, _moment2.default)(new Date(cotacoes.cotacao[0].data_validacao)).format('DD/MM/YYYY HH:mm:ss')
	          },
	          fk_cotacao: cotacoes.cotacao.fk_cotacao
	        };
	        console.log(cotacao, cotacoes);
	        _this9.cotacaoForm = cotacao;
	        _this9.toggleCotacao(true);
	      }).catch(function (error) {
	        console.log('error', error);
	        _this9.$root.trataErro(error);
	      });
	    },
	    toggleCotacao: function toggleCotacao() {
	      var valor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.abrirCotacao = valor;
	    },
	    toCamelCase: function toCamelCase(str) {
	      return str.replace(/_([a-z])/g, function (match, letter) {
	        return letter.toUpperCase();
	      });
	    },
	    getTextoAdiantamento: function getTextoAdiantamento(item) {
	      if (!this.processoSolicitacao || !this.processoSolicitacao.processos) return '';
	      var lista = this.processoSolicitacao.processos;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(lista), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var grupo = _step.value;
	
	          if (grupo.alteracao && Array.isArray(grupo.alteracao)) {
	            var achou = grupo.alteracao.find(function (a) {
	              return a.id === item.id && a.adiantavel;
	            });
	            if (achou) {
	              var antes = achou.adiantavel[0];
	              var depois = achou.adiantavel[1];
	              if (antes === '0' && depois === '1') {
	                return 'Será adiantável';
	              } else {
	                return 'Era adiantável';
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return '';
	    },
	    transformObjectToCamelCase: function transformObjectToCamelCase(array) {
	      var _this10 = this;
	
	      var newArray = array.map(function (object) {
	        var objetoCamelCase = {};
	        for (var key in object) {
	          if (object.hasOwnProperty(key)) {
	            var camelCaseKey = _this10.toCamelCase(key);
	            objetoCamelCase[camelCaseKey] = object[key];
	          }
	        }
	        return objetoCamelCase;
	      });
	      console.log('NEW', newArray);
	      return newArray;
	    }
	  }
	};

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'fav',
	  data: function data() {
	    return {
	      favs: [],
	      questoes: [],
	      preAnalise: {
	        proposal: {}
	      }
	    };
	  },
	
	  props: ['propsPreAnalise', 'fase'],
	  watch: {
	    'preAnalise.proposal.fav': function preAnaliseProposalFav() {
	      if (this.preAnalise.proposal.fav) {
	        this.montaQuestoes();
	      }
	    },
	    propsPreAnalise: function propsPreAnalise() {
	      this.preAnalise = this.propsPreAnalise;
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    axios.get('proxy/project/favs/situation/true').then(function (response) {
	      _this.favs = response.data.value;
	
	      if (_this.favs.length === 1) {
	        _this.montaQuestoes();
	      }
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    montaQuestoes: function montaQuestoes() {
	      var _this2 = this;
	
	      var questoes = [];
	      this.preAnalise.favAnswers = [];
	      this.favs.forEach(function (fav) {
	        if (fav.id) {
	          fav.favQuestions.forEach(function (questao) {
	            if (questao.local === _this2.fase) {
	              var item = {};
	              item.conformityYes = questao.conformityYes;
	              item.conformityNo = questao.conformityNo;
	              item.conformityNA = questao.conformityNA;
	              item.favQuestion = questao;
	              item.createdAt = null;
	              item.id = 0;
	              item.local = _this2.fase;
	              item.question = questao.question;
	              item.question = questao.questionNumber;
	              item.updatedAt = null;
	              questoes.push(item);
	            }
	          });
	        }
	      });
	      this.preAnalise.favAnswers = questoes;
	    }
	  }
	};

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'fep',
	  data: function data() {
	    return {
	      totalFBB: 0,
	      totalContrapartida: 0,
	      totalParceiro: 0,
	      fep: {
	        actionTypes: [{ 'code': 'AT', 'description': 'Ação Tática' }, { 'code': 'AF', 'description': 'Ação Finalística' }]
	      },
	      opcoes: ['Sim', 'Não'],
	      preAnalise: {
	        publicos_alvo: [],
	        entidade: {}
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.calculaTotais();
	    var vm = this;
	    var bc = new BroadcastChannel('propostas');
	    bc.onmessage = function (e) {
	      var mensagem = e.data;
	      if (mensagem.acao === 'notificacaoAtualizaFep' && mensagem.fep.fk_proposta === vm.propsAnalise.id) {
	        vm.propsAnalise.fep = mensagem['fep'];
	        this.$forceUpdate();
	      }
	    };
	  },
	
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  props: ['propsAnalise'],
	  watch: {
	    propsAnalise: function propsAnalise() {
	      this.analise = this.propsAnalise;
	      this.calculaTotais();
	    }
	  },
	  computed: {
	    participantesDiretos: function participantesDiretos() {
	      var total = 0;
	      if (this.propsAnalise.publicos_alvo) {
	        this.propsAnalise.publicos_alvo.forEach(function (item) {
	          total += parseInt(item.nr_participantes_diretos);
	        });
	        return total;
	      }
	    }
	  },
	  methods: {
	    calculaTotais: function calculaTotais() {
	      var _this = this;
	
	      this.totalFBB = 0;
	
	      if (!Array.isArray(this.propsAnalise && this.propsAnalise.atividades)) {
	        return;
	      }
	      this.propsAnalise.atividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (item.origem === '1' || item.origem === 1) {
	              console.log('ITEM FEP: ', item);
	              console.log('valor unitario ', item.valor_unitario);
	              console.log('quantidade ', item.quantidade);
	              _this.totalFBB += item.valor_unitario * item.quantidade;
	              console.log('TOTAL PARCIAL: ', _this.totalFBB);
	            }
	            if (item.origem === '2' || item.origem === 2) {
	              _this.totalContrapartida += item.valor_unitario * item.quantidade;
	            }
	            if (item.origem === '5' || item.origem === 5) {
	              _this.totalParceiro += item.valor_unitario * item.quantidade;
	            }
	          });
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _from = __webpack_require__(181);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map = __webpack_require__(275);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    Usuarios: _usuarios2.default
	  },
	  name: 'historicoEntidade',
	  data: function data() {
	    return {
	      showgrid: true,
	      showModal: false,
	      confirmed: true,
	      state: 'GRID',
	      historico: {},
	      histEndereco: {},
	      histDirigente: {},
	      histUsuario: {},
	      histDocumento: {},
	      listaFormasJuridicas: [],
	      listaRamosAtividade: [],
	      snap: {
	        contato: []
	      },
	      idEvento: null,
	      disable: true,
	      curIndex: 0,
	      mostraHistorico: false,
	      editandoIndex: null,
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: null,
	        sortDesc: false,
	        fields: [{ key: 'nome', label: 'Tarefa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'inicio', label: 'Início', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'termino', label: 'Conclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'observacao', label: 'Justificativa', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'usuario.ds_nome_usuario', label: 'Usuário que executou a tarefa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      historicoTarefas: null
	    };
	  },
	
	  props: ['entHistorico'],
	  computed: {
	    historicoGridItems: function historicoGridItems() {
	      var origem = Array.isArray(this.entHistorico) ? this.entHistorico : [];
	      var flatten = [];
	      for (var i = 0; i < origem.length; i++) {
	        var itemOuBloco = origem[i];
	        if (Array.isArray(itemOuBloco)) {
	          for (var j = 0; j < itemOuBloco.length; j++) {
	            if (itemOuBloco[j]) flatten.push(itemOuBloco[j]);
	          }
	        } else if (itemOuBloco) {
	          flatten.push(itemOuBloco);
	        }
	      }
	
	      var ordenado = _.sortBy(flatten, 'termino').reverse();
	
	      var dedupe = new _map2.default();
	
	      for (var idx = 0; idx < ordenado.length; idx++) {
	        var item = ordenado[idx];
	        if (!item || item.tipo !== 'USUARIO') continue;
	        if ((item.nome || '') === 'DOCUMENTOS') continue;
	
	        var novo = (0, _extends3.default)({}, item);
	
	        if (novo.inicio && typeof novo.inicio === 'string') {
	          novo.inicio = novo.inicio.replace(' ', 'T');
	        }
	        if (novo.termino && typeof novo.termino === 'string') {
	          novo.termino = novo.termino.replace(' ', 'T');
	        }
	
	        if (novo.nome === 'SOLICITACAO') {
	          novo.nome = idx >= ordenado.length - 1 ? 'Cadastramento Inicial' : 'Alteração Cadastral';
	        } else if (novo.nome === 'REVISAO') {
	          novo.nome = novo.termino === null ? 'Em Revisão pela Entidade' : 'Enviado para Revisão';
	        } else {
	          novo.nome = novo.termino === null ? 'Cadastro aguardando Análise' : 'Cadastro Analisado';
	        }
	
	        var key = novo.nome + '|' + novo.inicio + '|' + novo.termino;
	
	        if (!dedupe.has(key)) {
	          dedupe.set(key, novo);
	        } else {
	          var atual = dedupe.get(key);
	
	          var atualObs = (atual.observacao || '').toString().trim();
	          var novoObs = (novo.observacao || '').toString().trim();
	
	          if (!atualObs && novoObs) {
	            dedupe.set(key, (0, _extends3.default)({}, atual, novo));
	          }
	        }
	      }
	
	      return (0, _from2.default)(dedupe.values());
	    }
	  },
	  watch: {
	    'table.filter': function tableFilter() {
	      this.table.currentPage = 1;
	    },
	    'table.sortBy': function tableSortBy() {
	      this.table.currentPage = 1;
	    },
	    'table.sortDesc': function tableSortDesc() {
	      this.table.currentPage = 1;
	    },
	    historicoGridItems: function historicoGridItems(val) {
	      this.$emit('historico_itens', Array.isArray(val) ? val : []);
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.carregaListaFormasJuridicas();
	              _context.next = 3;
	              return _this.$root.buscaRamoAtividades(_this.$store);
	
	            case 3:
	              _this.listaRamosAtividade = _this.$store.state.ramoAtividades;
	              _this.carregaListaDocumentosConstituicao();
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    etiquetaListaFormaJuridica: function etiquetaListaFormaJuridica(option) {
	      return '' + (option.codigo + ' / ' + option.descricao);
	    },
	    etiquetaListaRamosAtividade: function etiquetaListaRamosAtividade(option) {
	      return '' + (option.ds_codigo + '    ' + option.ds_descricao);
	    },
	    carregaListaFormasJuridicas: function carregaListaFormasJuridicas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _this2.$root.buscaFormasJuridicas(_this2.$store);
	
	              case 2:
	                _this2.listaFormasJuridicas = _this2.$store.state.formasJuridicas;
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    carregaListaDocumentosConstituicao: function carregaListaDocumentosConstituicao() {
	      this.listaDocConstituicao = [{ id: 'ATA_CONSTITUICAO', ds_tipo: 'Ata constituição' }, { id: 'CONTRATO_SOCIAL', ds_tipo: 'Contrato social' }, { id: 'ESTATUTO', ds_tipo: 'Estatuto' }, { id: 'LEI_ORGANICA_MUNICIPAL', ds_tipo: 'Lei orgânica municipal' }];
	    },
	
	    testFunc: function testFunc(row) {
	      this.idEvento = null;
	      this.idEvento = row.item.id;
	      this.carregaEvento();
	    },
	    carregaEvento: function carregaEvento() {
	      var _this3 = this;
	
	      axiosLaravel.get('processos/tarefas/buscahistorico/' + this.idEvento).then(function (response) {
	        _this3.snap = response.data;
	        _this3.histEndereco = _this3.snap.endereco;
	        _this3.histDirigente = _this3.snap.dirigentes;
	        _this3.histDocumento = _this3.snap.documentos;
	        _this3.histUsuario = _this3.snap.usuarios;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Usuarios: _usuarios2.default
	  },
	  name: 'historicoParcEstrategico',
	  data: function data() {
	    return {
	      showgrid: true,
	      showModal: false,
	      confirmed: true,
	      state: 'GRID',
	      historico: {},
	      histEndereco: {},
	      histDirigente: {},
	      histUsuario: {},
	      histDocumento: {},
	      snap: {},
	      idEvento: null,
	      disable: true,
	      curIndex: 0,
	      editandoIndex: null,
	      table: {
	        items: this.parcHistorico,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'eventDate', label: 'Data', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'result', label: 'Evento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'phase', label: 'Fase', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'justify', label: 'Justificativa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'usu', label: 'Usuário Responsável', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Visualização', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['parcHistorico'],
	  watch: {
	    parcHistorico: function parcHistorico() {
	      this.table.items = this.parcHistorico;
	    },
	    'table.items': function tableItems() {
	      this.$emit('historico', this.table.items);
	    }
	  },
	  created: function created() {},
	
	  methods: {
	    testFunc: function testFunc(row) {
	      this.idEvento = null;
	      this.idEvento = row.item.id;
	      this.carregaEvento();
	    },
	    carregaEvento: function carregaEvento() {
	      var _this = this;
	
	      axios.get('/proxy/utility/events/' + this.idEvento).then(function (response) {
	        _this.snap = response.data.value;
	        _this.histEndereco = _this.snap.snapshot.addresses;
	        _this.histDirigente = _this.snap.snapshot.chiefs;
	        _this.histDocumento = _this.snap.snapshot.documents;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _telefone = __webpack_require__(142);
	
	var _telefone2 = _interopRequireDefault(_telefone);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _preAnaliseForm = __webpack_require__(175);
	
	var _preAnaliseForm2 = _interopRequireDefault(_preAnaliseForm);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	var _deferimento = __webpack_require__(173);
	
	var _deferimento2 = _interopRequireDefault(_deferimento);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    PreAnaliseForm: _preAnaliseForm2.default,
	    Analise: _analise2.default,
	    Deferimento: _deferimento2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    Telefone: _telefone2.default,
	    PublicoAlvo: _publicoAlvo2.default,
	    EquipeProjeto: _equipeProjeto2.default },
	  name: 'historico-proposta',
	  data: function data() {
	    return {
	      showgrid: true,
	      showModal: false,
	      esconderEntidade: false,
	      mostraHistorico: false,
	      confirmed: true,
	      state: 'GRID',
	      fase: '',
	      termino: '',
	      historico: {},
	      snap: {},
	      idProcesso: null,
	      disable: true,
	      curIndex: 0,
	      editandoIndex: null,
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'inicio',
	        sortDesc: true,
	        fields: [{ key: 'inicio', label: 'Data Início', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'termino', label: 'Data Término', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'nome', label: 'Evento', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'observacao', label: 'Justificativa', sortable: true, thStyle: 'text-align: center; width: 25%', class: 'text-center' }, { key: 'usuario.ds_nome_usuario', label: 'Usuário Responsável', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Visualização', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['proposta'],
	  watch: {
	    proposta: function proposta() {
	      var array = [];
	      array = _.filter(this.proposta.processo.tarefas, function (o) {
	        if (o.tipo === 'USUARIO') return o;
	      });
	      this.table.items = _.sortBy(array, 'termino').reverse();
	    },
	
	    'table.items': function tableItems() {
	      this.$emit('historico_itens', this.table.items);
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    atividades: function atividades() {
	      return this.proposta.atividades;
	    },
	
	    telefone: function telefone() {
	      if (this.snap.entidade.contato) {
	        var size = this.snap.entidade.contato.ds_telefone.length;
	        if (size < 11) {
	          this.tel = '(' + this.snap.entidade.contato.ds_telefone.substring(0, 2) + ') ' + this.snap.entidade.contato.ds_telefone.substring(2, 6) + ' - ' + this.snap.entidade.contato.ds_telefone.substring(6, 10);
	        } else {
	          this.tel = '(' + this.snap.entidade.contato.ds_telefone.substring(0, 2) + ') ' + this.snap.entidade.contato.ds_telefone.substring(2, 7) + ' - ' + this.snap.entidade.contato.ds_telefone.substring(7, 11);
	        }
	        return this.tel;
	      }
	    }
	  }),
	  created: function created() {
	    this.buscaHistorico();
	  },
	
	  methods: {
	    testFunc: function testFunc(row) {
	      this.idProcesso = null;
	      this.idProcesso = row.item.id;
	      this.fase = row.item.nome;
	      this.termino = row.item.termino;
	      this.$forceUpdate();
	      this.carregaProcesso();
	    },
	    carregaProcesso: function carregaProcesso() {
	      var _this = this;
	
	      axiosLaravel.get('processos/tarefas/buscahistorico/' + this.idProcesso).then(function (response) {
	        _this.snap = response.data;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaHistorico: function buscaHistorico() {
	      var array = [];
	      array = _.filter(this.proposta.processo.tarefas, function (o) {
	        if (o.tipo === 'USUARIO') return o;
	      });
	      this.table.items = _.sortBy(array, 'termino').reverse();
	    }
	  }
	};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _telefone = __webpack_require__(142);
	
	var _telefone2 = _interopRequireDefault(_telefone);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    Telefone: _telefone2.default,
	    PublicoAlvo: _publicoAlvo2.default,
	    EquipeProjeto: _equipeProjeto2.default },
	  name: 'historico-proposta-old',
	  data: function data() {
	    return {
	      showgrid: true,
	      showModal: false,
	      confirmed: true,
	      state: 'GRID',
	      historico: {},
	      snap: {},
	      idEvento: null,
	      disable: true,
	      curIndex: 0,
	      editandoIndex: null,
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        fields: [{ key: 'eventDate', label: 'Data', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'result', label: 'Evento', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'phase', label: 'Fase', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'justify', label: 'Justificativa', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'usu', label: 'Usuário Responsável', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Visualização', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['proposta'],
	  watch: {
	    proposta: function proposta() {
	      this.buscaHistorico();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    atividades: function atividades() {
	      var _this = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  methods: {
	    testFunc: function testFunc(row) {
	      this.idEvento = null;
	      this.idEvento = row.item.id;
	      this.carregaEvento();
	    },
	    carregaEvento: function carregaEvento() {
	      var _this2 = this;
	
	      axios.get('/proxy/utility/events/' + this.idEvento).then(function (response) {
	        _this2.snap = response.data.value;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscaHistorico: function buscaHistorico() {
	      var _this3 = this;
	
	      axios.get('proxy/project/proposal/' + this.proposta.id + '/history').then(function (response) {
	        _this3.table.items = response.data.value;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uploadLicencas = __webpack_require__(253);
	
	var _uploadLicencas2 = _interopRequireDefault(_uploadLicencas);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _downloadjs = __webpack_require__(119);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cadastroLicencas',
	  components: {
	    uploadLicencas: _uploadLicencas2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      loading: {
	        show: false
	      },
	      documentos: [],
	      editarLicencas: false,
	      editarLicencaInformativa: false,
	      editarLicencaProcedimentos: false,
	      editarLicencaEstoque: false,
	      editandoLinhaProcedimento: false,
	      editarLicencaAmbiental: false,
	      editandoLinhaLicencaAmbiental: false,
	      editarLicencaOutras: false,
	      editandoLinhaLicencaOutras: false,
	      editandoLinhaEstoque: false,
	      indicativo: '',
	      textoAnexoInformativo: '',
	      justificativaIndicativo: '',
	      mostrarDemaisLicencas: false,
	      indexEdicao: 0,
	      tiposLicenca: [],
	      tiposLicencaTodos: [],
	      tiposSelecaoInformativa: [],
	      tiposInformativa: [],
	      tiposProcedimento: [],
	      tiposAmbientais: [],
	      tiposOutras: [],
	      licencaInformativa: {
	        id: null,
	        licenca: '',
	        licencaSelecao: '',
	        tipo_licenca: 'INFORMATIVA',
	        fase_proposta: 'ANALISE',
	        periodo_apresentacao: 'Análise',
	        status: 'Informado pela Analise',
	        data_apresentacao: '',
	        possuiAnexo: 'N',
	        validade: '',
	        documento: null,
	        anexo: [],
	        inclusao: '',
	        observacoes: '',
	        responsavel: ''
	      },
	      licencaTemplateBackup: {},
	      licencaTemplateProcedimento: {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'PROCEDIMENTO',
	        fase_proposta: 'ANALISE',
	        periodo_apresentacao: 'Análise',
	        tipo_procedimento: '',
	        prazo_apresentacao: '',
	        data_apresentacao: '',
	        validade: '',
	        status: 'Informado pela Analise',
	        documento: null,
	        anexo: [],
	        observacoes: '',
	        responsavel: ''
	      },
	      licencaTemplateEstoque: {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'PROCEDIMENTO',
	        fase_proposta: 'ESTOQUE',
	        periodo_apresentacao: 'Estoque',
	        tipo_procedimento: '',
	        prazo_apresentacao: '',
	        data_apresentacao: '',
	        validade: '',
	        status: 'Informado pela FBB',
	        documento: null,
	        anexo: [],
	        observacoes: '',
	        responsavel: ''
	      },
	      licencaAmbientalTemplate: {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'LICENCA_AMBIENTAL',
	        fase_proposta: '',
	        periodo_apresentacao: '',
	        prazo_apresentacao: '',
	        prazo_renovacao: '',
	        validade: '',
	        status: 'Aguardando Envio',
	        documento: null,
	        anexo: [],
	        observacoes: '',
	        responsavel: ''
	      },
	      licencaOutrasTemplate: {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'OUTRAS',
	        fase_proposta: '',
	        periodo_apresentacao: '',
	        prazo_apresentacao: '',
	        validade: '',
	        status: 'Aguardando Envio',
	        documento: null,
	        anexo: [],
	        observacoes: '',
	        responsavel: ''
	      },
	      licencasProcedimento: [],
	      licencasAmbientais: [],
	      licencasOutras: [],
	      licencasEstoque: [],
	      licencasGravadas: [],
	      licencaEstoqueGravar: [],
	      tableInformativa: {
	        items: this.licencaInformativa,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'licenca', label: 'Licença/Informativo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'validade', label: 'Data de Validade', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'inclusao', label: 'Data de Inclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'anexo', label: 'Documento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableProcedimento: {
	        items: this.licencasProcedimento,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'licenca', label: 'Procedimento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'validade', label: 'Vigência', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'anexo', label: 'Documento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableEstoque: {
	        items: this.licencasProcedimento,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'licenca', label: 'Procedimento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'validade', label: 'Vigência', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'anexo', label: 'Documento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableLicencaAmbiental: {
	        items: this.licencasAmbientais,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'licenca', label: 'Licença', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'prazo_apresentacao', label: 'Vigência', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'prazo_renovacao', label: 'Prazo Renovação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'periodo_apresentacao', label: 'Período Apresentação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableLicencaOutra: {
	        items: this.licencasOutras,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'licenca', label: 'Licença', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'prazo_apresentacao', label: 'Prazo Apresentação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'periodo_apresentacao', label: 'Período Apresentação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: {
	    idProposta: Number,
	    cadastroProposta: {
	      type: Boolean,
	      default: false
	    },
	    telaProjeto: {
	      type: Boolean,
	      default: false
	    },
	    fecharAnalise: {
	      type: Function,
	      default: function _default() {
	        return function () {
	          console.log('Função padrão');
	        };
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    idProposta: function idProposta() {
	      this.consultaIndicativoLicenciamento();
	      this.buscaTipoLicencas();
	      this.consultaLicencasProposta();
	    }
	  },
	  mounted: function mounted() {
	    this.consultaIndicativoLicenciamento();
	    this.buscaTipoLicencas();
	    this.consultaLicencasProposta();
	  },
	  methods: {
	    buscaTipoLicencas: function buscaTipoLicencas() {
	      var _this = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('/licenciamento/tiposLicenca').then(function (response) {
	        _this.tiposLicenca = response.data;
	        _this.tiposLicenca = _.groupBy(_this.tiposLicenca, 'tipo');
	
	        _this.tiposInformativa = _this.tiposLicenca['Informativa'];
	
	        _this.tiposSelecaoInformativa = _this.tiposLicenca['Seleção'];
	        _this.tiposProcedimento = _this.tiposLicenca['Procedimento'];
	        _this.tiposAmbientais = _this.tiposLicenca['Licença Ambiental'];
	        _this.tiposOutras = _this.tiposLicenca['Outros'];
	        _this.tiposLicencaTodos = [].concat(_this.tiposInformativa, _this.tiposProcedimento, _this.tiposAmbientais, _this.tiposOutras);
	        _this.loading.show = false;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    },
	    changeLicencaInformativa: function changeLicencaInformativa() {
	      if (this.licencaInformativa.licenca === 'Isento com base em legislação estadual/municipal' || this.licencaInformativa.licenca === 'Dispensa com base na legislação estadual/municipal') {
	        this.textoAnexoInformativo = 'Anexar Documento Legal';
	      }
	      if (this.licencaInformativa.licenca === 'Licença') {
	        this.textoAnexoInformativo = 'Anexar Licença';
	        this.licencaInformativa.licencaSelecao = '';
	      }
	      if (this.licencaInformativa.licenca === 'Obrigatório durante o prazo de execução do projeto' && !this.cadastroProposta) {
	        this.mostrarDemaisLicencas = true;
	      } else {
	        this.mostrarDemaisLicencas = false;
	      }
	    },
	    changeLicencaInformativaSelecao: function changeLicencaInformativaSelecao() {
	      if (_.includes(['Prévia (LP)', 'Instalação (LI)', 'Licença de Alteração (LA)'], this.licencaInformativa.licencaSelecao)) {
	        this.licencaInformativa.licenca = 'Obrigatório durante o prazo de execução do projeto';
	        this.mostrarDemaisLicencas = true;
	      } else {
	        this.mostrarDemaisLicencas = false;
	      }
	    },
	    salvarLicencasEstoque: function salvarLicencasEstoque() {
	      var _this2 = this;
	
	      this.loading.show = true;
	
	      var licencas = {
	        idProposta: this.idProposta,
	        licencasEstoque: this.licencaEstoqueGravar,
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	      this.$snotify.clear();
	      this.$aguarde('Gravando informações de licenças de estoque na base. Por favor, aguarde...');
	      axiosLaravel.post('/licenciamento/gravarLicencasEstoqueSeparado', licencas).then(function (response) {
	        _this2.$snotify.clear();
	        _this2.$snotify.success(response.data);
	        _this2.fecharAnalise();
	        _this2.consultaLicencasProposta();
	        return true;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.$snotify.clear();
	        _this2.$snotify.error(error);
	        _this2.loading.show = false;
	      });
	    },
	    salvarLicencas: function salvarLicencas() {
	      var _this3 = this;
	
	      if (this.indicativo === 'Não') {
	        if (this.justificativaIndicativo === '') {
	          this.$snotify.error('Preencha a justificativa antes de continuar.');
	          return false;
	        }
	        this.gravarIndicativoLicenciamento();
	        this.fecharAnalise();
	        this.consultaLicencasProposta();
	        return;
	      } else if (this.indicativo === 'Sim') {
	        if (this.licencaInformativa.licenca === 'Obrigatório durante o prazo de execução do projeto' && !this.cadastroProposta && (this.licencasAmbientais.length === 0 || this.licencasProcedimento.length === 0 && !this.telaProjeto)) {
	          this.$snotify.error('Cadastre as demais Licenças Obrigatórias durante o prazo de execução do projeto para continuar.');
	          return false;
	        }
	      }
	      if (!this.verificaCampos()) {
	        this.$snotify.error('[LICENCIAMENTO]Existem campos obrigatórios não preenchidos, favor verificar.');
	        return false;
	      }
	      if (this.gravarIndicativoLicenciamento() === false) {
	        this.$snotify.error('Selecione o Indicativo de Licenciamento e tente novamente.');
	        return false;
	      }
	
	
	      if (this.licencaInformativa.validade !== '') {
	        this.licencaInformativa.validade = _moment2.default.utc(this.licencaInformativa.validade).format('YYYY-MM-DD');
	      }
	      if (this.cadastroProposta) {
	        this.licencaInformativa.status = 'Informado pela Entidade';
	      }
	      if (this.telaProjeto) {
	        this.licencaInformativa.status = 'Informado pela tela de Projeto';
	        this.licencaInformativa.fase_proposta = 'PROJETO';
	      }
	      this.loading.show = true;
	
	      var licencas = {
	        idProposta: this.idProposta,
	        licencaInformativa: this.licencaInformativa,
	        licencasProcedimento: this.licencasProcedimento,
	        licencasAmbientais: this.licencasAmbientais,
	        licencasOutras: this.licencasOutras,
	
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	      this.$snotify.clear();
	      this.$aguarde('Gravando informações de Licenciamento Ambiental na base. Por favor, aguarde...');
	      axiosLaravel.post('/licenciamento/gravarLicencas', licencas).then(function (response) {
	        _this3.$snotify.clear();
	        _this3.$snotify.success(response.data);
	        _this3.fecharAnalise();
	        _this3.consultaLicencasProposta();
	        return true;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.$snotify.clear();
	        _this3.$snotify.error(error);
	        _this3.loading.show = false;
	      });
	    },
	    verificaCampos: function verificaCampos() {
	      console.log('Verificando campos das Licenças ...');
	
	      if (this.licencaInformativa.licenca === '') {
	        return false;
	      }
	      if (this.licencaInformativa.licenca === 'Licença' && this.licencaInformativa.licencaSelecao === '') {
	        return false;
	      }
	      if (this.licencaInformativa.possuiAnexo === 'S' && this.licencaInformativa.anexo.length === 0) {
	        return false;
	      }
	
	      return true;
	    },
	    consultaLicencasProposta: function consultaLicencasProposta() {
	      var _this4 = this;
	
	      console.log('Consulta licenças');
	      this.loading.show = true;
	      axiosLaravel.get('/licenciamento/consultaLicencasProposta/' + this.idProposta).then(function (response) {
	        if (response.data.length > 0) {
	          _this4.initLicencas(response.data);
	        } else {
	          _this4.loading.show = false;
	        }
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	        _this4.loading.show = false;
	      });
	    },
	    initLicencas: function initLicencas(licencasBase) {
	      console.log('Init Licenças');
	
	      this.licencasGravadas = _.groupBy(licencasBase, 'tipo_licenca');
	      console.log('Licencas Gravadas', this.licencasGravadas);
	
	      if (_.has(this.licencasGravadas, 'INFORMATIVA')) {
	        var informativa = this.licencasGravadas['INFORMATIVA'][0];
	        this.licencaInformativa = {
	          id: informativa.id,
	          licenca: _.includes(['Licença de Operação (LO)', 'Licença Simplificada (LS)', 'Licença Única (LU)'], informativa.licenca) ? 'Licença' : informativa.licenca,
	          licencaSelecao: _.includes(['Licença de Operação (LO)', 'Licença Simplificada (LS)', 'Licença Única (LU)'], informativa.licenca) ? informativa.licenca : '',
	          tipo_licenca: 'INFORMATIVA',
	          fase_proposta: 'ANALISE',
	          periodo_apresentacao: 'Análise',
	          status: 'Informado pela Analise',
	          possuiAnexo: _.isNull(informativa.documento) ? 'N' : 'S',
	          documento: _.isNull(informativa.documento) ? null : informativa.documento,
	          anexo: _.isNull(informativa.documento) ? [] : [informativa.anexo],
	          validade: _.isNull(informativa.validade) ? '' : informativa.validade,
	          inclusao: _.isNull(informativa.documento) ? '' : informativa.anexo.dt_criado,
	          observacoes: informativa.observacoes
	        };
	        if (_.includes(['Licença de Operação (LO)', 'Licença Simplificada (LS)', 'Licença Única (LU)'], informativa.licenca)) {
	          this.tableInformativa.items = [this.licencaInformativa];
	        }
	      }
	      if (_.has(this.licencasGravadas, 'PROCEDIMENTO')) {
	        var procedimentos = this.licencasGravadas['PROCEDIMENTO'];
	        procedimentos.forEach(function (procedimento) {
	          procedimento.anexo = [procedimento.anexo];
	        });
	        this.licencasProcedimento = procedimentos;
	      }
	      if (_.has(this.licencasGravadas, 'LICENCA_AMBIENTAL')) {
	        var licencasAmbientais = this.licencasGravadas['LICENCA_AMBIENTAL'];
	        this.licencasAmbientais = licencasAmbientais;
	      }
	      if (_.has(this.licencasGravadas, 'OUTRAS')) {
	        var licencasOutras = this.licencasGravadas['OUTRAS'];
	        this.licencasOutras = licencasOutras;
	      }
	      if (_.has(this.licencasGravadas, 'ESTOQUE')) {
	        var licencasEstoque = this.licencasGravadas['ESTOQUE'];
	        this.licencasEstoque = licencasEstoque;
	      }
	      console.log('licença informativa', this.licencaInformativa);
	      console.log('licenca Procedimento', this.licencasProcedimento);
	      console.log('licenca Ambiental', this.licencasAmbientais);
	      console.log('Outras licenças', this.licencasOutras);
	      console.log('Estoque ', this.licencasEstoque);
	      this.loading.show = false;
	      this.tableProcedimento.items = this.licencasProcedimento;
	      this.tableLicencaAmbiental.items = this.licencasAmbientais;
	      this.tableLicencaOutra.items = this.licencasOutras;
	      this.tableEstoque.items = this.licencasEstoque;
	
	      if (this.licencaInformativa.licenca === 'Obrigatório durante o prazo de execução do projeto' && !this.cadastroProposta) {
	        this.mostrarDemaisLicencas = true;
	      } else {
	        this.mostrarDemaisLicencas = false;
	      }
	
	      this.$forceUpdate();
	    },
	    toggleInformativo: function toggleInformativo(valor) {
	      var edicao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.editarLicencaInformativa = valor;
	      if (edicao === false) {
	        this.licencaInformativa.validade = '';
	        this.licencaInformativa.observacoes = '';
	      }
	    },
	    toggleProcedimento: function toggleProcedimento(valor) {
	      var edicao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.editandoLinhaProcedimento = false;
	      this.editarLicencaProcedimentos = valor;
	      if (edicao === false) {
	        this.limparCamposProcedimento();
	      }
	    },
	    toggleEstoque: function toggleEstoque(valor) {
	      var edicao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.editandoLinhaEstoque = false;
	      this.editarLicencaEstoque = valor;
	      if (edicao === false) {
	        this.limparCamposEstoque();
	      }
	    },
	    toggleLicencaAmbiental: function toggleLicencaAmbiental(valor) {
	      var edicao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.editandoLinhaLicencaAmbiental = false;
	      this.editarLicencaAmbiental = valor;
	      if (edicao === false) {
	        this.limparCamposLicencaAmbiental();
	      }
	    },
	    toggleLicencaOutras: function toggleLicencaOutras(valor) {
	      var edicao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.editandoLinhaLicencaOutras = false;
	      this.editarLicencaOutras = valor;
	      if (edicao === false) {
	        this.limparCamposLicencaOutras();
	      }
	    },
	    adicionarProcedimento: function adicionarProcedimento() {
	      if (!this.verificaCamposProcedimento()) {
	        this.$snotify.error('[LICENCIAMENTO]Existem campos obrigatórios não preenchidos, favor verificar antes de adicionar um procedimento.');
	        return;
	      }
	      this.licencaTemplateProcedimento.validade = _moment2.default.utc(this.licencaTemplateProcedimento.validade).format('YYYY-MM-DD');
	      this.licencaTemplateProcedimento.data_apresentacao = _moment2.default.utc(new Date()).format('YYYY-MM-DD');
	      this.licencaTemplateProcedimento.fase_proposta = this.telaProjeto ? 'PROJETO' : 'ANALISE';
	      this.licencaTemplateProcedimento.status = this.telaProjeto ? 'Informado pela tela de Projeto' : 'Informado pela Analise';
	
	      this.licencasProcedimento.push(this.licencaTemplateProcedimento);
	
	      this.licencaTemplateProcedimento = {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'PROCEDIMENTO',
	        fase_proposta: 'ANALISE',
	        periodo_apresentacao: 'Análise',
	        tipo_procedimento: '',
	        prazo_apresentacao: '',
	        data_apresentacao: '',
	        validade: '',
	        status: 'Informado pela Analise',
	        documento: null,
	        anexo: [],
	        observacoes: ''
	      };
	      this.tableProcedimento.items = this.licencasProcedimento;
	      this.toggleProcedimento(false);
	      this.$forceUpdate();
	    },
	    adicionarEstoque: function adicionarEstoque() {
	      if (!this.verificaCamposEstoque()) {
	        this.$snotify.error('[LICENCIAMENTO]Existem campos obrigatórios não preenchidos, favor verificar antes de adicionar um procedimento.');
	        return;
	      }
	      this.licencaTemplateEstoque.validade = _moment2.default.utc(this.licencaTemplateEstoque.validade).format('YYYY-MM-DD');
	      this.licencaTemplateEstoque.data_apresentacao = _moment2.default.utc(new Date()).format('YYYY-MM-DD');
	
	      this.licencasEstoque.push(this.licencaTemplateEstoque);
	      this.licencaEstoqueGravar = [];
	      this.licencaEstoqueGravar.push(this.licencaTemplateEstoque);
	
	      this.licencaTemplateEstoque = {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'PROCEDIMENTO',
	        fase_proposta: 'ESTOQUE',
	        periodo_apresentacao: 'Estoque',
	        tipo_procedimento: '',
	        prazo_apresentacao: '',
	        data_apresentacao: '',
	        validade: '',
	        status: 'Informado pela FBB',
	        documento: null,
	        anexo: [],
	        observacoes: '',
	        responsavel: ''
	      };
	      this.tableEstoque.items = this.licencasEstoque;
	      this.toggleEstoque(false);
	      this.salvarLicencasEstoque();
	      this.$forceUpdate();
	    },
	    adicionaInformativa: function adicionaInformativa() {
	      if (!this.verificaCamposInformativa()) {
	        this.$snotify.error('[LICENCIAMENTO]Existem campos obrigatórios não preenchidos, favor verificar antes de adicionar um procedimento.');
	        return;
	      }
	      console.log('validade', this.licencaInformativa.validade);
	      if (this.licencaInformativa.validade !== '') {
	        this.licencaInformativa.validade = _moment2.default.utc(this.licencaInformativa.validade).format('YYYY-MM-DD');
	      }
	      this.licencaInformativa.data_apresentacao = _moment2.default.utc(new Date()).format('YYYY-MM-DD');
	      this.licencaInformativa.inclusao = _moment2.default.utc(this.licencaInformativa.anexo[0].dt_criado).format('YYYY-MM-DD');
	      this.licencaInformativa.status = this.telaProjeto ? 'Informado pela tela de Projeto' : 'Informado pela Analise';
	      this.licencaInformativa.fase_proposta = this.telaProjeto ? 'PROJETO' : 'ANALISE';
	
	      this.tableInformativa.items = [this.licencaInformativa];
	      this.toggleInformativo(false, true);
	      this.$forceUpdate();
	    },
	    adicionarLicencaAmbiental: function adicionarLicencaAmbiental() {
	      console.log(this.licencaAmbientalTemplate);
	      if (!this.verificaCamposLicencaAmbiental()) {
	        this.$snotify.error('[LICENCIAMENTO]Existem campos obrigatórios não preenchidos, favor verificar antes de adicionar um procedimento.');
	        return;
	      }
	      if (this.licencaAmbientalTemplate.periodo_apresentacao === 'Ao decorrer do projeto') {
	        this.licencaAmbientalTemplate.fase_proposta = 'PROJETO';
	      } else {
	        this.licencaAmbientalTemplate.fase_proposta = 'ENCERRAMENTO';
	      }
	      this.licencaAmbientalTemplate.prazo_apresentacao = _moment2.default.utc(this.licencaAmbientalTemplate.prazo_apresentacao).format('YYYY-MM-DD');
	      if (this.licencaAmbientalTemplate.prazo_renovacao !== '') {
	        this.licencaAmbientalTemplate.prazo_renovacao = _moment2.default.utc(this.licencaAmbientalTemplate.prazo_renovacao).format('YYYY-MM-DD');
	      }
	
	      this.licencasAmbientais.push(this.licencaAmbientalTemplate);
	
	      this.licencaAmbientalTemplate = {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'LICENCA_AMBIENTAL',
	        fase_proposta: '',
	        periodo_apresentacao: '',
	        prazo_apresentacao: '',
	        prazo_renovacao: '',
	        validade: '',
	        status: 'Aguardando Envio',
	        documento: null,
	        anexo: [],
	        observacoes: ''
	      };
	      this.tableLicencaAmbiental.items = this.licencasAmbientais;
	      this.toggleLicencaAmbiental(false);
	      this.$forceUpdate();
	    },
	    adicionarLicencaOutra: function adicionarLicencaOutra() {
	      console.log(this.licencaOutrasTemplate);
	      if (!this.verificaCamposLicencaOutras()) {
	        this.$snotify.error('[LICENCIAMENTO]Existem campos obrigatórios não preenchidos, favor verificar antes de adicionar um procedimento.');
	        return;
	      }
	      if (this.licencaOutrasTemplate.periodo_apresentacao === 'Ao decorrer do projeto') {
	        this.licencaOutrasTemplate.fase_proposta = 'PROJETO';
	      } else {
	        this.licencaOutrasTemplate.fase_proposta = 'ENCERRAMENTO';
	      }
	      this.licencaOutrasTemplate.prazo_apresentacao = _moment2.default.utc(this.licencaOutrasTemplate.prazo_apresentacao).format('YYYY-MM-DD');
	
	      this.licencasOutras.push(this.licencaOutrasTemplate);
	
	      this.licencaOutrasTemplate = {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'LICENCA_AMBIENTAL',
	        fase_proposta: '',
	        periodo_apresentacao: '',
	        prazo_apresentacao: '',
	        validade: '',
	        status: 'Aguardando Envio',
	        documento: null,
	        anexo: [],
	        observacoes: ''
	      };
	      this.tableLicencaOutra.items = this.licencasOutras;
	      this.toggleLicencaOutras(false);
	      this.$forceUpdate();
	    },
	    verificaCamposInformativa: function verificaCamposInformativa() {
	      if (this.licencaInformativa.licenca === '') {
	        return false;
	      }
	      if (this.licencaInformativa.anexo.length === 0) {
	        return false;
	      }
	      if (this.licencaInformativa.licenca === 'Isento com base em legislação estadual/municipal') {
	        if (this.licencaInformativa.observacoes === '') {
	          return false;
	        }
	      }
	
	      return true;
	    },
	    verificaCamposProcedimento: function verificaCamposProcedimento() {
	      if (this.licencaTemplateProcedimento.licenca === '') {
	        console.log(this.licencaTemplateProcedimento.licenca);
	        return false;
	      }
	      if (this.licencaTemplateProcedimento.anexo.length === 0) {
	        return false;
	      }
	      if (this.licencaTemplateProcedimento.validade === '') {
	        return false;
	      }
	      if (this.licencaTemplateProcedimento.tipo_procedimento === '') {
	        return false;
	      }
	      return true;
	    },
	    verificaCamposEstoque: function verificaCamposEstoque() {
	      if (this.licencaTemplateEstoque.licenca === '') {
	        console.log(this.licencaTemplateEstoque.licenca);
	        return false;
	      }
	      if (this.licencaTemplateEstoque.anexo.length === 0) {
	        return false;
	      }
	      return true;
	    },
	    verificaCamposLicencaAmbiental: function verificaCamposLicencaAmbiental() {
	      console.log(this.licencaAmbientalTemplate.prazo_apresentacao);
	      if (this.licencaAmbientalTemplate.licenca === '') {
	        console.log(this.licencaAmbientalTemplate.licenca);
	        return false;
	      }
	      if (this.licencaAmbientalTemplate.periodo_apresentacao === '') {
	        return false;
	      }
	      if (this.licencaAmbientalTemplate.prazo_apresentacao === '') {
	        return false;
	      }
	
	      if ((0, _moment2.default)(this.licencaAmbientalTemplate.prazo_apresentacao, 'YYYY-MM-DD').endOf('day').isBefore((0, _moment2.default)())) {
	        this.$snotify.error('Vigência vencida. Favor verificar.');
	        return false;
	      }
	      if (this.licencaAmbientalTemplate.licenca === 'Licença de Operação (LO)') {
	        if ((0, _moment2.default)(this.licencaAmbientalTemplate.prazo_renovacao, 'YYYY-MM-DD').endOf('day').isBefore((0, _moment2.default)())) {
	          this.$snotify.error('Prazo vencido. Favor verificar.');
	          return false;
	        }
	      }
	
	      return true;
	    },
	    verificaCamposLicencaOutras: function verificaCamposLicencaOutras() {
	      if (this.licencaOutrasTemplate.licenca === '') {
	        console.log(this.licencaOutrasTemplate.licenca);
	        return false;
	      }
	      if (this.licencaOutrasTemplate.periodo_apresentacao === '') {
	        return false;
	      }
	      if (this.licencaOutrasTemplate.observacoes === '') {
	        return false;
	      }
	      if (this.licencaOutrasTemplate.prazo_apresentacao === '') {
	        return false;
	      }
	      if ((0, _moment2.default)(this.licencaOutrasTemplate.prazo_apresentacao, 'YYYY-MM-DD').endOf('day').isBefore((0, _moment2.default)())) {
	        this.$snotify.error('Data de apresentação vencida. Favor verificar.');
	        return false;
	      }
	      return true;
	    },
	    confirmaExclusao: function confirmaExclusao(mensagem, acao) {
	      this.$dialog.confirm(mensagem).then(function () {
	        return acao();
	      }).catch(function () {});
	    },
	    excluiProcedimento: function excluiProcedimento(licenca) {
	      var index = this.tableProcedimento.items.indexOf(licenca);
	      if (index < 0) {
	        return;
	      }
	
	      if (licenca.id !== null) {
	        this.excluiLicenca(licenca.id);
	        this.tableProcedimento.items.splice(index, 1);
	      } else {
	        this.tableProcedimento.items.splice(index, 1);
	      }
	    },
	    excluiEstoque: function excluiEstoque(licenca) {
	      var index = this.tableEstoque.items.indexOf(licenca);
	      if (index < 0) {
	        return;
	      }
	
	      if (licenca.id !== null) {
	        this.excluiLicenca(licenca.id);
	        this.tableEstoque.items.splice(index, 1);
	      } else {
	        this.tableEstoque.items.splice(index, 1);
	      }
	    },
	    excluiInformativa: function excluiInformativa(licenca) {
	      var index = this.tableInformativa.items.indexOf(licenca);
	      if (index < 0) {
	        return;
	      }
	
	      if (licenca.id !== null) {
	        this.excluiLicenca(licenca.id);
	        this.tableInformativa.items.splice(index, 1);
	        this.limparCamposLicencaInformativa();
	      } else {
	        this.tableInformativa.items.splice(index, 1);
	        this.limparCamposLicencaInformativa();
	      }
	    },
	    excluirLicencaAmbiental: function excluirLicencaAmbiental(licenca) {
	      var index = this.tableLicencaAmbiental.items.indexOf(licenca);
	      if (index < 0) {
	        return;
	      }
	
	      if (licenca.id !== null) {
	        this.excluiLicenca(licenca.id);
	        this.tableLicencaAmbiental.items.splice(index, 1);
	      } else {
	        this.tableLicencaAmbiental.items.splice(index, 1);
	      }
	    },
	    excluirLicencaOutro: function excluirLicencaOutro(licenca) {
	      var index = this.tableLicencaOutra.items.indexOf(licenca);
	      if (index < 0) {
	        return;
	      }
	
	      if (licenca.id !== null) {
	        this.excluiLicenca(licenca.id);
	        this.tableLicencaOutra.items.splice(index, 1);
	      } else {
	        this.tableLicencaOutra.items.splice(index, 1);
	      }
	    },
	    editaProcedimento: function editaProcedimento(licenca, index) {
	      this.licencaTemplateProcedimento = {
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        tipo_procedimento: licenca.tipo_procedimento,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        prazo_apresentacao: licenca.prazo_apresentacao,
	        data_apresentacao: _moment2.default.utc(new Date()).format('YYYY-MM-DD'),
	        validade: licenca.validade,
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: licenca.anexo,
	        observacoes: licenca.observacoes
	      };
	
	      this.licencaTemplateBackup = _.cloneDeep(this.licencaTemplateProcedimento);
	      this.toggleProcedimento(true, true);
	      this.indexEdicao = index;
	      this.editandoLinhaProcedimento = true;
	      this.$forceUpdate();
	    },
	    editaEstoque: function editaEstoque(licenca, index) {
	      this.licencaTemplateEstoque = {
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        tipo_procedimento: licenca.tipo_procedimento,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        prazo_apresentacao: licenca.prazo_apresentacao,
	        data_apresentacao: _moment2.default.utc(new Date()).format('YYYY-MM-DD'),
	        validade: licenca.validade,
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: licenca.anexo,
	        observacoes: licenca.observacoes
	      };
	
	      this.toggleEstoque(true, true);
	      this.indexEdicao = index;
	      this.editandoLinhaEstoque = true;
	      this.$forceUpdate();
	    },
	    editaLicencaAmbiental: function editaLicencaAmbiental(licenca, index) {
	      this.licencaAmbientalTemplate = {
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        prazo_apresentacao: licenca.prazo_apresentacao,
	        prazo_renovacao: licenca.prazo_renovacao,
	        validade: licenca.validade,
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: licenca.anexo,
	        observacoes: licenca.observacoes
	      };
	      this.toggleLicencaAmbiental(true, true);
	      this.indexEdicao = index;
	      this.editandoLinhaLicencaAmbiental = true;
	      this.$forceUpdate();
	    },
	    editaLicencaOutras: function editaLicencaOutras(licenca, index) {
	      this.licencaOutrasTemplate = {
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        prazo_apresentacao: licenca.prazo_apresentacao,
	        validade: licenca.validade,
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: licenca.anexo,
	        observacoes: licenca.observacoes
	      };
	      this.toggleLicencaOutras(true, true);
	      this.indexEdicao = index;
	      this.editandoLinhaLicencaOutras = true;
	      this.$forceUpdate();
	    },
	    salvarEdicaoProcedimento: function salvarEdicaoProcedimento() {
	      var _this5 = this;
	
	      this.licencaTemplateProcedimento.validade = _moment2.default.utc(this.licencaTemplateProcedimento.validade).format('YYYY-MM-DD');
	      this.licencaTemplateProcedimento.responsavel = this.usuarioLogado.ds_nome_usuario;
	      if (this.licencaTemplateProcedimento.id !== null) {
	        if (!_.has(this.licencaTemplateProcedimento.anexo[0], 'id')) {
	          this.licencaTemplateProcedimento.documento = null;
	        }
	        this.$snotify.clear();
	        this.$aguarde('Gravando informações de Licenciamento Ambiental na base. Por favor, aguarde...');
	        axiosLaravel.post('/licenciamento/atualizaLicencaProcedimento', this.licencaTemplateProcedimento).then(function (response) {
	          _this5.$snotify.clear();
	          _this5.$snotify.success(response.data);
	          _this5.consultaLicencasProposta();
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	          _this5.$snotify.clear();
	          _this5.$snotify.error(error);
	          _this5.loading.show = false;
	        });
	      }
	      this.licencasProcedimento[this.indexEdicao] = this.licencaTemplateProcedimento;
	      this.tableProcedimento.items = this.licencasProcedimento;
	      this.toggleProcedimento(false);
	      this.indexEdicao = 0;
	      this.editandoLinhaProcedimento = false;
	      this.$forceUpdate();
	    },
	    salvarEdicaoEstoque: function salvarEdicaoEstoque() {
	      var _this6 = this;
	
	      this.licencaTemplateEstoque.validade = _moment2.default.utc(this.licencaTemplateEstoque.validade).format('YYYY-MM-DD');
	      this.licencaTemplateEstoque.responsavel = this.usuarioLogado.ds_nome_usuario;
	      if (this.licencaTemplateEstoque.id !== null) {
	        if (!_.has(this.licencaTemplateEstoque.anexo, 'id')) {
	          this.licencaTemplateEstoque.documento = null;
	        }
	        this.$snotify.clear();
	        this.$aguarde('Gravando informações de Licenciamento Ambiental na base. Por favor, aguarde...');
	        axiosLaravel.post('/licenciamento/atualizaLicencaEstoque', this.licencaTemplateEstoque).then(function (response) {
	          _this6.$snotify.clear();
	          _this6.$snotify.success(response.data);
	          _this6.consultaLicencasProposta();
	        }).catch(function (error) {
	          _this6.$root.trataErro(error);
	          _this6.$snotify.clear();
	          _this6.$snotify.error(error);
	          _this6.loading.show = false;
	        });
	      }
	      this.licencasEstoque[this.indexEdicao] = this.licencaTemplateEstoque;
	      this.tableEstoque.items = this.licencasEstoque;
	      this.toggleEstoque(false);
	      this.indexEdicao = 0;
	      this.editandoLinhaEstoque = false;
	      this.$forceUpdate();
	    },
	    salvarEdicaoLicencaAmbiental: function salvarEdicaoLicencaAmbiental() {
	      var _this7 = this;
	
	      if (this.licencaAmbientalTemplate.periodo_apresentacao === 'Ao decorrer do projeto') {
	        this.licencaAmbientalTemplate.fase_proposta = 'PROJETO';
	      } else {
	        this.licencaAmbientalTemplate.fase_proposta = 'ENCERRAMENTO';
	      }
	      this.licencaAmbientalTemplate.prazo_apresentacao = _moment2.default.utc(this.licencaAmbientalTemplate.prazo_apresentacao).format('YYYY-MM-DD');
	      if (this.licencaAmbientalTemplate.prazo_renovacao !== '') {
	        this.licencaAmbientalTemplate.prazo_renovacao = _moment2.default.utc(this.licencaAmbientalTemplate.prazo_renovacao).format('YYYY-MM-DD');
	      }
	      this.licencaAmbientalTemplate.responsavel = this.usuarioLogado.ds_nome_usuario;
	      if (this.licencaAmbientalTemplate.id !== null) {
	        this.$snotify.clear();
	        this.$aguarde('Gravando informações de Licenciamento Ambiental na base. Por favor, aguarde...');
	        axiosLaravel.post('/licenciamento/atualizaLicencaAmbiental', this.licencaAmbientalTemplate).then(function (response) {
	          _this7.$snotify.clear();
	          _this7.$snotify.success(response.data);
	          _this7.consultaLicencasProposta();
	        }).catch(function (error) {
	          _this7.$root.trataErro(error);
	          _this7.$snotify.clear();
	          _this7.$snotify.error(error);
	          _this7.loading.show = false;
	        });
	      }
	      this.licencasAmbientais[this.indexEdicao] = this.licencaAmbientalTemplate;
	      this.tableLicencaAmbiental.items = this.licencasAmbientais;
	      this.toggleLicencaAmbiental(false);
	      this.indexEdicao = 0;
	      this.editandoLinhaLicencaAmbiental = false;
	      this.$forceUpdate();
	    },
	    salvarEdicaoLicencaOutros: function salvarEdicaoLicencaOutros() {
	      var _this8 = this;
	
	      if (this.licencaOutrasTemplate.periodo_apresentacao === 'Ao decorrer do projeto') {
	        this.licencaOutrasTemplate.fase_proposta = 'PROJETO';
	      } else {
	        this.licencaOutrasTemplate.fase_proposta = 'ENCERRAMENTO';
	      }
	      this.licencaOutrasTemplate.prazo_apresentacao = _moment2.default.utc(this.licencaOutrasTemplate.prazo_apresentacao).format('YYYY-MM-DD');
	      this.licencaOutrasTemplate.responsavel = this.usuarioLogado.ds_nome_usuario;
	      if (this.licencaOutrasTemplate.id !== null) {
	        this.$snotify.clear();
	        this.$aguarde('Gravando informações de Licenciamento Ambiental na base. Por favor, aguarde...');
	        axiosLaravel.post('/licenciamento/atualizaLicencaOutros', this.licencaOutrasTemplate).then(function (response) {
	          _this8.$snotify.clear();
	          _this8.$snotify.success(response.data);
	          _this8.consultaLicencasProposta();
	        }).catch(function (error) {
	          _this8.$root.trataErro(error);
	          _this8.$snotify.clear();
	          _this8.$snotify.error(error);
	          _this8.loading.show = false;
	        });
	      }
	      this.licencasOutras[this.indexEdicao] = this.licencaOutrasTemplate;
	      this.tableLicencaOutra.items = this.licencasOutras;
	      this.toggleLicencaOutras(false);
	      this.indexEdicao = 0;
	      this.editandoLinhaLicencaOutras = false;
	      this.$forceUpdate();
	    },
	    limparCamposProcedimento: function limparCamposProcedimento() {
	      this.licencaTemplateProcedimento = {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'PROCEDIMENTO',
	        fase_proposta: 'ANALISE',
	        tipo_procedimento: '',
	        periodo_apresentacao: 'Análise',
	        prazo_apresentacao: '',
	        data_apresentacao: '',
	        validade: '',
	        status: 'Informado pela Analise',
	        documento: null,
	        anexo: [],
	        observacoes: ''
	      };
	    },
	    limparCamposEstoque: function limparCamposEstoque() {
	      this.licencaTemplateEstoque = {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'ESTOQUE',
	        fase_proposta: 'ESTOQUE',
	        periodo_apresentacao: 'Estoque',
	        tipo_procedimento: '',
	        prazo_apresentacao: '',
	        data_apresentacao: '',
	        validade: '',
	        status: 'Informado pela FBB',
	        documento: null,
	        anexo: [],
	        observacoes: '',
	        responsavel: ''
	      };
	    },
	    limparCamposLicencaInformativa: function limparCamposLicencaInformativa() {
	      this.licencaInformativa = {
	        id: null,
	        licenca: '',
	        licencaSelecao: '',
	        tipo_licenca: 'INFORMATIVA',
	        fase_proposta: 'ANALISE',
	        periodo_apresentacao: 'Análise',
	        status: 'Informado pela Analise',
	        data_apresentacao: '',
	        possuiAnexo: 'N',
	        validade: '',
	        documento: null,
	        anexo: [],
	        inclusao: '',
	        observacoes: '',
	        responsavel: ''
	      };
	    },
	    limparCamposLicencaAmbiental: function limparCamposLicencaAmbiental() {
	      this.licencaAmbientalTemplate = {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'LICENCA_AMBIENTAL',
	        fase_proposta: '',
	        periodo_apresentacao: '',
	        prazo_apresentacao: '',
	        prazo_renovacao: '',
	        validade: '',
	        status: 'Aguardando Envio',
	        documento: null,
	        anexo: [],
	        observacoes: ''
	      };
	    },
	    limparCamposLicencaOutras: function limparCamposLicencaOutras() {
	      this.licencaOutrasTemplate = {
	        id: null,
	        licenca: '',
	        tipo_licenca: 'OUTRAS',
	        fase_proposta: '',
	        periodo_apresentacao: '',
	        prazo_apresentacao: '',
	        validade: '',
	        status: 'Aguardando Envio',
	        documento: null,
	        anexo: [],
	        observacoes: ''
	      };
	    },
	    excluiLicenca: function excluiLicenca(id) {
	      var _this9 = this;
	
	      this.$snotify.clear();
	      this.$aguarde('Excluindo licença na base de dados...');
	      var obj = {
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	      axiosLaravel.post('/licenciamento/excluirLicenca/' + id, obj).then(function (response) {
	        _this9.$snotify.clear();
	        _this9.$snotify.success(response.data);
	        _this9.consultaLicencasProposta();
	      }).catch(function (error) {
	        _this9.$root.trataErro(error);
	        _this9.$snotify.clear();
	        _this9.$snotify.error(error);
	        _this9.loading.show = false;
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this10 = this;
	
	      if (documento.file) {
	        (0, _downloadjs2.default)(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this10.$root.trataErro(error);
	        });
	      }
	    },
	    consultaIndicativoLicenciamento: function consultaIndicativoLicenciamento() {
	      var _this11 = this;
	
	      this.loading.show = true;
	      this.consultandoIndicativo = true;
	      axiosLaravel.get('/licenciamento/consultarIndicativoLicenciamento/' + this.idProposta).then(function (response) {
	        if (!_.isEmpty(response.data)) {
	          _this11.indicativo = response.data.status;
	          _this11.justificativaIndicativo = response.data.observacoes;
	        }
	        _this11.loading.show = false;
	        _this11.consultandoIndicativo = false;
	        return true;
	      }).catch(function (error) {
	        _this11.$root.trataErro(error);
	        _this11.$snotify.clear();
	        _this11.$snotify.error(error);
	        _this11.loading.show = false;
	        _this11.consultandoIndicativo = false;
	        return false;
	      });
	    },
	    gravarIndicativoLicenciamento: function gravarIndicativoLicenciamento() {
	      var _this12 = this;
	
	      console.log('gravaIndicativoLicenciamento ');
	      this.loading.show = true;
	      if (this.indicativo === '') {
	        this.loading.show = false;
	        return false;
	      }
	      if (this.indicativo === 'Sim') {
	        if (this.licencaInformativa.licenca === '' && this.cadastroProposta) {
	          this.loading.show = false;
	          return false;
	        }
	        this.justificativaIndicativo = '-';
	      }
	      var indicativo = {
	        idProposta: this.idProposta,
	        indicativo: this.indicativo,
	        justificativa: this.justificativaIndicativo
	      };
	      axiosLaravel.post('/licenciamento/gravarIndicativoLicenciamento', indicativo).then(function (response) {
	        _this12.$snotify.clear();
	        _this12.$snotify.success(response.data);
	        _this12.loading.show = false;
	        return true;
	      }).catch(function (error) {
	        _this12.$root.trataErro(error);
	        _this12.$snotify.clear();
	        _this12.$snotify.error(error);
	        _this12.loading.show = false;
	        return false;
	      });
	    },
	    apagarTodasLicencas: function apagarTodasLicencas() {
	      var _this13 = this;
	
	      console.log('apagaTodasLicencas');
	      this.loading.show = true;
	      if (this.gravarIndicativoLicenciamento() === false) {
	        this.$snotify.error('Ocorreu um problema.');
	        return;
	      }
	      var obj = {
	        idProposta: this.idProposta,
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	      axiosLaravel.post('/licenciamento/apagarTodasLicencas', obj).then(function (response) {
	        _this13.$snotify.clear();
	        _this13.$snotify.success(response.data);
	        _this13.loading.show = false;
	        _this13.limparCamposLicencaInformativa();
	        _this13.consultaLicencasProposta();
	      }).catch(function (error) {
	        _this13.$root.trataErro(error);
	        _this13.$snotify.clear();
	        _this13.$snotify.error(error);
	        _this13.loading.show = false;
	      });
	    },
	    changeIndicativo: function changeIndicativo() {
	      var _this14 = this;
	
	      this.$dialog.confirm('<b>Se existirem licenças prévias cadastradas, serão excluídas. Confirma indicativo de Licenciamento para NÃO ?</b>', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        _this14.apagarTodasLicencas();
	      }).catch(function () {
	        _this14.indicativo = 'Sim';
	      });
	    }
	  }
	};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uploadLicencas = __webpack_require__(253);
	
	var _uploadLicencas2 = _interopRequireDefault(_uploadLicencas);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'envioLicencas',
	  components: {
	    uploadLicencas: _uploadLicencas2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      loading: {
	        show: false,
	        showTable: false
	      },
	      enviarLicenca: false,
	      visualizarLicenca: false,
	      nomeProjeto: 'TESTE',
	      numeroProjeto: '00000',
	      licencas: [],
	      historico: [],
	      licencaTemplate: {
	        id: null,
	        licenca: '',
	        tipo_licenca: '',
	        fase_proposta: '',
	        periodo_apresentacao: '',
	        prazo_apresentacao: '',
	        validade: '',
	        status: '',
	        documento: null,
	        anexo: [],
	        observacoes: ''
	      },
	      indexEdit: '',
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 100,
	        fields: [{ key: 'licenca', label: 'Licença', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'prazo_apresentacao', label: 'Prazo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_apresentacao', label: 'Data Apresentação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'fase_proposta', label: 'Fase', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'status', label: 'Status', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableHistorico: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 100,
	        fields: [{ key: 'etapa', label: 'Etapa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'usuario', label: 'Usuário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'observacao', label: 'Observação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'created_at', label: 'Data/Hora', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: {
	    tipoUsuario: String,
	    idProposta: Number
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {
	    this.consultaLicencasProposta();
	  },
	  methods: {
	    toggleEnvio: function toggleEnvio(valor) {
	      this.enviarLicenca = valor;
	    },
	    toggleVisualizacao: function toggleVisualizacao(valor) {
	      this.visualizarLicenca = valor;
	    },
	    consultaLicencasProposta: function consultaLicencasProposta() {
	      var _this = this;
	
	      console.log('Consulta licenças');
	      this.loading.show = true;
	      axiosLaravel.get('/licenciamento/consultaLicencasProposta/' + this.idProposta).then(function (response) {
	        if (response.data.length > 0) {
	          _this.licencas = response.data;
	          _this.licencas.forEach(function (licenca) {
	            if (licenca.tipo_licenca === 'INFORMATIVA') {
	              licenca.data_apresentacao = _moment2.default.utc(licenca.created_at).format('YYYY-MM-DD');
	            }
	          });
	          _this.table.items = _this.licencas;
	          _this.$forceUpdate();
	          console.log(_this.licencas);
	          _this.loading.show = false;
	        } else {
	          _this.loading.show = false;
	        }
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    },
	    abrirAnexoLicenca: function abrirAnexoLicenca(licenca, index) {
	      this.indexEdit = index;
	      this.licencaTemplate = {
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        data_apresentacao: _.isNull(licenca.data_apresentacao) ? '-' : _moment2.default.utc(licenca.data_apresentacao).format('DD/MM/YYYY'),
	        prazo_apresentacao: _.isNull(licenca.prazo_apresentacao) ? '-' : _moment2.default.utc(licenca.prazo_apresentacao).format('DD/MM/YYYY'),
	        validade: _.isNull(licenca.validade) ? '-' : _moment2.default.utc(licenca.validade).format('YYYY-MM-DD'),
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: _.isNull(licenca.documento) ? [] : [licenca.anexo],
	        observacoes: licenca.observacoes
	      };
	
	      this.consultarHistoricoLicenca(licenca.id);
	      this.toggleEnvio(true);
	    },
	    visualizaLicenca: function visualizaLicenca(licenca, index) {
	      this.indexEdit = index;
	      this.licencaTemplate = {
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        data_apresentacao: _.isNull(licenca.data_apresentacao) ? '-' : _moment2.default.utc(licenca.data_apresentacao).format('DD/MM/YYYY'),
	        prazo_apresentacao: _.isNull(licenca.prazo_apresentacao) ? '-' : _moment2.default.utc(licenca.prazo_apresentacao).format('DD/MM/YYYY'),
	        validade: _.isNull(licenca.validade) ? '-' : _moment2.default.utc(licenca.validade).format('YYYY-MM-DD'),
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: _.isNull(licenca.documento) ? [] : [licenca.anexo],
	        observacoes: licenca.observacoes
	      };
	      this.consultarHistoricoLicenca(licenca.id);
	      this.toggleVisualizacao(true);
	    },
	    gravaLicenca: function gravaLicenca() {
	      var _this2 = this;
	
	      console.log('Grava Licença');
	      if (this.verificaCamposObrigatorios() === false) {
	        this.$snotify.error('Anexe o documento e preencha a data de validade da licença antes de continuar.');
	        return;
	      }
	      this.$snotify.clear();
	      this.$aguarde('Enviando licença...');
	      this.loading.show = true;
	
	      this.licencaTemplate.validade = _moment2.default.utc(this.licencaTemplate.validade).format('YYYY-MM-DD');
	      this.licencaTemplate.responsavel = this.usuarioLogado.ds_nome_usuario;
	      axiosLaravel.post('/licenciamento/gravaLicencaEntidade/', this.licencaTemplate).then(function (response) {
	        console.log(response.data);
	        _this2.$snotify.clear();
	        _this2.$snotify.success(response.data);
	        _this2.loading.show = false;
	        _this2.toggleEnvio(false);
	        _this2.consultaLicencasProposta();
	      }).catch(function (error) {
	        _this2.$snotify.clear();
	        _this2.$root.trataErro(error);
	        _this2.loading.show = false;
	      });
	    },
	    verificaCamposObrigatorios: function verificaCamposObrigatorios() {
	      if (this.licencaTemplate.anexo.length === 0) {
	        return false;
	      }
	      if (this.licencaTemplate.validade === '' || _.isNull(this.licencaTemplate.validade) || this.licencaTemplate.validade === '-') {
	        return false;
	      }
	      return true;
	    },
	    verificarStatusAnexo: function verificarStatusAnexo(licenca) {
	      if (licenca.status === 'Informado pela Analise' || licenca.status === 'Pendente de Validação' || licenca.status === 'Validado' || licenca.status === 'Não' || licenca.status === 'Sim') {
	        return true;
	      }
	      return false;
	    },
	    consultarHistoricoLicenca: function consultarHistoricoLicenca(idLicenca) {
	      var _this3 = this;
	
	      console.log('Consultando Historico', idLicenca, this.idProposta);
	      this.tableHistorico.items = [];
	      this.loading.showTable = true;
	      var obj = {
	        idProposta: this.idProposta,
	        idLicenca: idLicenca
	      };
	      axiosLaravel.post('/licenciamento/consultarHistoricoLicenca/', obj).then(function (response) {
	        console.log(response.data);
	        if (response.data.length > 0) {
	          _this3.historico = response.data;
	          _this3.tableHistorico.items = _this3.historico;
	        }
	        _this3.$forceUpdate();
	        _this3.loading.showTable = false;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.loading.showTable = false;
	      });
	    },
	    statusClass: function statusClass(status) {
	      if (status === 'Pendente de Validação') {
	        return 'tag-status pendente-validacao';
	      }
	      if (status === 'Aguardando Envio') {
	        return 'tag-status pendente';
	      }
	      if (status === 'Devolvido para Ajustes') {
	        return 'tag-status pendente';
	      }
	      if (status === 'Validado') {
	        return 'tag-status validado';
	      }
	      if (status === 'Informado pela Analise') {
	        return 'tag-status validado';
	      }
	    }
	  }
	};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _cadastroLicencas = __webpack_require__(252);
	
	var _cadastroLicencas2 = _interopRequireDefault(_cadastroLicencas);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'licenciamentoAmbientalAnalise',
	  components: {
	    cadastroLicencas: _cadastroLicencas2.default
	  },
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      loading: {
	        show: false
	      },
	      editarLicencas: false,
	      licencas: [],
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'tipo_licenca', label: 'Tipo de licença', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'licenca', label: 'Licença', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'prazo_apresentacao', label: 'Vigência', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_apresentacao', label: 'Data Apresentação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'fase_proposta', label: 'Fase', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'status', label: 'Status', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: {
	    idProposta: null
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    idProposta: function idProposta() {
	      this.consultaLicencasProposta();
	    }
	  },
	  mounted: function mounted() {
	    this.consultaLicencasProposta();
	  },
	  methods: {
	    toggleEdicao: function toggleEdicao(valor) {
	      this.editarLicencas = valor;
	    },
	    consultaLicencasProposta: function consultaLicencasProposta() {
	      var _this = this;
	
	      this.loading.show = true;
	      var queryString = '/licenciamento/consultaLicencasProposta/' + this.idProposta;
	      axiosLaravel.get(queryString).then(function (response) {
	        console.log('licença analise: ', response.data);
	        if (response.data.length > 0) {
	          _this.licencas = response.data;
	          _this.licencas.forEach(function (licenca) {
	            if (licenca.tipo_licenca === 'INFORMATIVA') {
	              licenca.data_apresentacao = _moment2.default.utc(licenca.created_at).format('YYYY-MM-DD');
	            }
	          });
	          _this.table.items = _this.licencas;
	          _this.$forceUpdate();
	          _this.loading.show = false;
	        } else {
	          _this.loading.show = false;
	        }
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    },
	    fecharLicencas: function fecharLicencas() {
	      this.toggleEdicao(false);
	      this.consultaLicencasProposta();
	    },
	    verificaLicencas: function verificaLicencas() {
	      return this.table.items.length > 0;
	    },
	    statusClass: function statusClass(status) {
	      if (status === 'Pendente de Validação') {
	        return 'tag-status pendente-validacao';
	      }
	      if (status === 'Aguardando Envio') {
	        return 'tag-status pendente';
	      }
	      if (status === 'Devolvido para Ajustes') {
	        return 'tag-status pendente';
	      }
	      if (status === 'Validado') {
	        return 'tag-status validado';
	      }
	      if (status === 'Informado pela Analise') {
	        return 'tag-status validado';
	      }
	      if (status === 'Informado pela FBB') {
	        return 'tag-status estoque';
	      }
	      if (status === 'Informado pela Entidade') {
	        return 'tag-status estoque';
	      }
	    },
	    confirmaExclusao: function confirmaExclusao(mensagem, acao) {
	      this.$dialog.confirm(mensagem).then(function () {
	        return acao();
	      }).catch(function () {});
	    },
	    preparaExclusao: function preparaExclusao(licenca) {
	      var index = this.table.items.indexOf(licenca);
	      if (index < 0) {
	        return;
	      }
	
	      if (licenca.id !== null) {
	        this.excluiLicenca(licenca.id);
	        this.table.items.splice(index, 1);
	      }
	    },
	    excluiLicenca: function excluiLicenca(id) {
	      var _this2 = this;
	
	      this.loading.show = true;
	      this.$snotify.clear();
	      this.$aguarde('Excluindo licença na base de dados...');
	      var obj = {
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	      axiosLaravel.post('/licenciamento/excluirLicenca/' + id, obj).then(function (response) {
	        _this2.$snotify.clear();
	        _this2.$snotify.success(response.data);
	        _this2.consultaLicencasProposta();
	        _this2.loading.show = false;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.$snotify.clear();
	        _this2.$snotify.error(error);
	        _this2.loading.show = false;
	      });
	    }
	  }
	};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _cadastroLicencas = __webpack_require__(252);
	
	var _cadastroLicencas2 = _interopRequireDefault(_cadastroLicencas);
	
	var _envioLicencas = __webpack_require__(1712);
	
	var _envioLicencas2 = _interopRequireDefault(_envioLicencas);
	
	var _validacaoLicencas = __webpack_require__(519);
	
	var _validacaoLicencas2 = _interopRequireDefault(_validacaoLicencas);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'licenciamentoAmbientalProjeto',
	  components: {
	    cadastroLicencas: _cadastroLicencas2.default,
	    envioLicencas: _envioLicencas2.default,
	    validacaoLicencas: _validacaoLicencas2.default
	  },
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      editarLicencas: false
	    };
	  },
	
	  props: {
	    tipoUsuario: String,
	    idProposta: Number,
	    numeroProjeto: String,
	    nomeProjeto: String
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {},
	  methods: {
	    toggleEdicao: function toggleEdicao(valor) {
	      this.editarLicencas = valor;
	    },
	    voltarTelaProjeto: function voltarTelaProjeto() {
	      this.toggleEdicao(false);
	    }
	  }
	};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _validacaoLicencas = __webpack_require__(519);
	
	var _validacaoLicencas2 = _interopRequireDefault(_validacaoLicencas);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'licenciamentoAmbientalProjeto',
	  components: {
	    validacaoLicencas: _validacaoLicencas2.default
	  },
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      editarLicencas: false
	    };
	  },
	
	  props: {
	    tipoUsuario: String,
	    idProposta: Number,
	    numeroProjeto: String,
	    nomeProjeto: String
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {},
	  methods: {
	    toggleEdicao: function toggleEdicao(valor) {
	      this.editarLicencas = valor;
	    }
	  }
	};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _deepObjectDiff = __webpack_require__(83);
	
	var _downloadjs = __webpack_require__(119);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'uploadLicencas',
	  data: function data() {
	    return {
	      showGrid: true,
	      tamanho: 0,
	      contador: 0,
	      tamanhoFormatado: 0,
	      salvou: false,
	      acmTamanho: 0,
	      totalMb: 0,
	      documentos: [],
	      documento: {
	        ds_nome_arquivo: '',
	        ligacao_sub_type: ''
	      },
	      documentoTabela: {},
	      editando: false,
	      mostraInclusao: false,
	      mostraExclusao: false,
	      mostraAlteracao: false,
	      dt_data_vigencia: '',
	      indiceAlt: -1,
	      ocultaIcone: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      listaOrdenada: {},
	      mudancas: [],
	      conteudoAnterior: {},
	      table: {
	        items: this.propDocumentos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        totalRows: 0,
	        currentPage: 1,
	        perPage: 100,
	        sortBy: 'dt_criado',
	        sortDesc: true,
	        fields: [{
	          key: 'tipo_documento.ds_tipo',
	          label: 'Tipo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 35%',
	          class: 'text-center'
	        }, {
	          key: 'ds_nome_arquivo',
	          label: 'Arquivo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 30%',
	          class: 'text-center'
	        }, { key: 'dt_criado', label: 'Inclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'documentosObrigatorios', 'disable', 'localUso', 'mudaDocumento', 'diferenca', 'analise', 'revisao', 'salvouOK', 'propsEtapa', 'faseProposta', 'editandoAlteracaoProjeto', 'editandoProrrogacao', 'maxFiles'],
	  watch: {
	    propDocumentos: function propDocumentos() {
	      this.table.items = this.propDocumentos;
	      this.table.totalRows = this.table.items.length;
	      if (this.disable === 'disable') {
	        this.desativado = this.disable;
	      }
	    },
	    diferenca: function diferenca() {
	      this.diferencaDoc = this.diferenca;
	    },
	    analise: function analise() {
	      if (this.analise) {
	        this.analiseDoc = this.analise.documentos;
	      }
	    },
	    dt_data_vigencia: function dt_data_vigencia(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.documento.dt_data_vigencia = newdate.format('YYYY-MM-DD');
	      }
	    },
	    revisao: function revisao() {
	      if (this.revisao) {
	        this.revisaoDoc = this.revisao.documentos;
	      }
	      this.mostraExclusao = false;
	      this.mostraInclusao = false;
	      if (this.analiseDoc && this.revisaoDoc) {
	        if (this.analiseDoc.length > this.revisaoDoc.length) {
	          this.mostraExclusao = true;
	          this.mostraInclusao = false;
	        } else {
	          this.mostraExclusao = true;
	        }
	        if (this.analiseDoc.length < this.revisaoDoc.length) {
	          this.mostraInclusao = true;
	          this.mostraExclusao = false;
	        } else {
	          this.mostraInclusao = false;
	        }
	        if (this.analiseDoc.length === this.revisaoDoc.length) {
	          this.mostraExclusao = false;
	        }
	      }
	      this.adicionados = (0, _deepObjectDiff.detailedDiff)(this.analise, this.revisao).added;
	
	      this.excluidos = _.differenceBy(this.analise.documentos, this.revisao.documentos, 'tipo_documento.ds_tipo');
	      this.atualizados = (0, _deepObjectDiff.detailedDiff)(this.analise.documentos, this.revisao.documentos).updated;
	
	      if (this.adicionados) {
	        if (this.adicionados.documentos) {
	          this.inclDoc = this.adicionados.documentos;
	          this.inclDocTexto = _.map(this.inclDoc, 'tipo_documento.ds_tipo');
	          this.naoExisteDoc = false;
	        } else {
	          this.naoExisteDoc = true;
	        }
	      }
	      if (this.excluidos) {
	        this.excDocTexto = _.map(this.excluidos, 'tipo_documento.ds_tipo');
	      }
	    },
	    mudaDocumento: function mudaDocumento() {
	      this.mudancas = this.mudaDocumento.documentos;
	      if (this.mudancas) {
	        if (_.findKey(this.mudancas, 'ds_nome_arquivo')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_nome_arquivo');
	        }
	        if (_.findKey(this.mudancas, 'ds_content_type')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_content_type');
	        }
	        if (_.findKey(this.mudancas, 'fk_tipo_documento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'fk_tipo_documento');
	        }
	        if (_.findKey(this.mudancas, 'dt_data_validade')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'dt_data_validade');
	        }
	        if (_.findKey(this.mudancas, 'tipo_documento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'tipo_documento');
	        }
	        if (this.indiceAlt !== -1) {
	          this.mostraAlteracao = true;
	          this.texto = this.diferencaDoc.documentos[this.indiceAlt];
	        } else {
	          this.mostraAlteracao = false;
	        }
	      }
	    },
	    salvouOK: function salvouOK() {
	      this.salvou = this.salvouOK;
	      if (this.salvou === true) {
	        this.totalMb = 0;
	        this.acmTamanho = 0;
	      }
	    }
	  },
	  computed: {
	    progress: function progress() {
	      return (this.totalMb / 80 * 100).toFixed(2);
	    },
	    PropEditandoAlteracaoProjeto: function PropEditandoAlteracaoProjeto() {
	      if (this.editandoAlteracaoProjeto) {
	        return this.editandoAlteracaoProjeto;
	      } else {
	        return false;
	      }
	    },
	    PropProrrogacaoEdit: function PropProrrogacaoEdit() {
	      if (this.editandoProrrogacao) {
	        return this.editandoProrrogacao;
	      } else {
	        return false;
	      }
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (_this.localUso === undefined) {
	                _this.localUso = 'TODOS';
	              }
	
	              if (!(_this.localUso === 'TODOS')) {
	                _context.next = 11;
	                break;
	              }
	
	              if (!_.isEmpty(_this.$store.state.uploadDocumentos.documentos)) {
	                _context.next = 7;
	                break;
	              }
	
	              _context.next = 5;
	              return axiosLaravel.post('documentos/tipos/' + _this.localUso).then(function (response) {
	                _this.documentos = _this.$store.state.uploadDocumentos.documentos = _.sortBy(response.data, [function (o) {
	                  return o.ds_tipo;
	                }]);
	                _this.$forceUpdate();
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 5:
	              _context.next = 9;
	              break;
	
	            case 7:
	              _this.documentos = _this.$store.state.uploadDocumentos.documentos;
	              _this.$forceUpdate();
	
	            case 9:
	              _context.next = 13;
	              break;
	
	            case 11:
	              _context.next = 13;
	              return axiosLaravel.post('documentos/tipos/' + _this.localUso).then(function (response) {
	                _this.documentos = _.sortBy(response.data, [function (o) {
	                  return o.ds_tipo;
	                }]);
	                _this.$forceUpdate();
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 13:
	              if (_.isNull(_this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(_this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	                axiosLaravel.get('configuracoes/').then(function (response) {
	                  _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	                    return item.ds_mime_type;
	                  }).join('|');
	                  _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	              } else {
	                _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos;
	                _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido;
	              }
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    novoDocumento: function novoDocumento() {
	      if (this.maxFiles !== undefined) {
	        if (this.propDocumentos.length === this.maxFiles) {
	          this.$snotify.error('Número máximo de documentos por licença atingido, favor verificar.');
	          this.onCancel();
	          return;
	        }
	      }
	      this.ocultaIcone = true;
	      this.showGrid = !this.showGrid;
	
	      this.documento.dt_data_vigencia = '';
	    },
	    existeDocumento: function existeDocumento(documento) {
	      if (!_.isEmpty(this.propDocumentos) && !_.isEmpty(this.propDocumentos) && this.propDocumentos !== []) {
	        return this.propDocumentos.some(function (item) {
	          if (documento.id) {
	            return documento.id === item.tipo_documento.id;
	          }
	        });
	      }
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      if (documento.file) {
	        (0, _downloadjs2.default)(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      this.tamanho = e.target.files[0].size;
	      this.tamanhoFormatado = (this.tamanho / Math.pow(1024, 2)).toFixed(2);
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this3 = this;
	
	      var totalParc = 0;
	      var aux = (this.acmTamanho + this.tamanho) / Math.pow(1024, 2);
	      var auxMb = aux.toFixed(2);
	      if (auxMb > 80) {
	        this.$snotify.error('O limite de envio é 80 MB por lote.\n' + 'Já utilizado: ' + this.totalMb + ' MB, e o arquivo possui: ' + this.tamanhoFormatado + ' MB ' + '\n. Favor salvar o formulário para poder incluir mais arquivos.');
	        return;
	      } else {
	        this.acmTamanho = this.acmTamanho + this.tamanho;
	        totalParc = this.acmTamanho / Math.pow(1024, 2);
	        this.totalMb = totalParc.toFixed(2);
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          _this3.documento.dt_criado = new Date();
	          _this3.documento.ligacao_sub_type = _this3.propsEtapa;
	          if (_this3.editando === true) {
	            for (var i in _this3.documento) {
	              _this3.documentoTabela[i] = _this3.documento[i];
	            }_this3.documentoTabela = (0, _assign2.default)({}, _this3.documento);
	          } else {
	            _this3.propDocumentos.push(_this3.documento);
	            _this3.contador += 1;
	          }
	          _this3.onCancel();
	        }
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.table.totalRows = this.table.items.length;
	      this.currentPage = 1;
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.editandoIndex = '';
	      this.conteudoAnterior = (0, _assign2.default)({}, '');
	      if (this.contador === 0) {
	        this.totalMb = 0;
	      }
	      this.$forceUpdate();
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento) {
	      var temp = 0;
	      if (this.propDocumentos[indexDocumento].file) {
	        this.byteLength = parseInt(this.propDocumentos[indexDocumento].file.replace(/=/g, '').length * 0.75);
	        temp = (this.byteLength / Math.pow(1024, 2)).toFixed(2);
	        this.totalMb = (this.totalMb - temp).toFixed(2);
	        this.contador = this.contador - 1;
	        this.acmTamanho = this.acmTamanho - parseInt(this.propDocumentos[indexDocumento].file.replace(/=/g, '').length * 0.75);
	      }
	      this.propDocumentos.splice(indexDocumento, 1);
	      this.$forceUpdate();
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documentos = {};
	      this.documentos[0] = (0, _assign2.default)({}, pendente);
	      this.documento.tipo_documento = (0, _assign2.default)({}, pendente);
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    editaDocumento: function editaDocumento(documento, indexDocumento) {
	      var _this4 = this;
	
	      this.ocultaIcone = false;
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	
	      this.editandoIndex = indexDocumento;
	      this.documento = (0, _assign2.default)({}, documento);
	      this.documentoTabela = documento;
	      if (this.documento.tipo_documento.pivot) {
	        this.documentos.forEach(function (doc) {
	          if (doc.id === _this4.documento.tipo_documento.id) {
	            _this4.documento.tipo_documento = (0, _assign2.default)({}, doc);
	          }
	        });
	      }
	      this.mudancas = _.cloneDeep(this.mudaDocumento.documentos[indexDocumento]);
	      if (this.mudancas.dt_data_vigencia) {
	        this.mudancas.dt_data_vigencia = (0, _moment2.default)(this.mudancas.dt_data_vigencia).format('DD/MM/YYYY');
	      }
	
	      if (_.hasIn(this.atualizados, indexDocumento)) {
	        this.conteudoAnterior = _.cloneDeep(this.atualizados[indexDocumento]);
	        if (this.conteudoAnterior.dt_data_vigencia) {
	          this.conteudoAnterior.dt_data_vigencia = (0, _moment2.default)(this.conteudoAnterior.dt_data_vigencia).format('DD/MM/YYYY');
	        }
	      } else {
	        this.conteudoAnterior = (0, _assign2.default)({}, {});
	      }
	
	      this.$forceUpdate();
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this5 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Fazendo upload do arquivo ...', { timeout: 0 });
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this5.documento = response.data.value;
	        if (_this5.editando === true) {
	          for (var i in _this5.documento) {
	            _this5.documentoTabela[i] = _this5.documento[i];
	          }_this5.documentoTabela = (0, _assign2.default)({}, _this5.documento);
	        } else {
	          _this5.propDocumentos.push(_this5.documento);
	        }
	        _this5.onCancel();
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Arquivo Adicionado com Sucesso!');
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uploadLicencas = __webpack_require__(253);
	
	var _uploadLicencas2 = _interopRequireDefault(_uploadLicencas);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'validacaoLicencas',
	  components: {
	    uploadLicencas: _uploadLicencas2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  data: function data() {
	    return {
	      moment: _moment2.default,
	      loading: {
	        show: false,
	        showTable: false
	      },
	      validarLicenca: false,
	      visualizarLicenca: false,
	      editarLicenca: false,
	      filtroProjetos: [],
	      filtroStatus: [],
	      filtroProjetoSelecionado: 'TODOS',
	      filtroStatusSelecionado: 'TODOS',
	      licencas: [],
	      licencasBackup: [],
	      historico: [],
	      licencaTemplate: {
	        id: null,
	        licenca: '',
	        tipo_licenca: '',
	        fase_proposta: '',
	        periodo_apresentacao: '',
	        prazo_apresentacao: '',
	        validade: '',
	        status: '',
	        documento: null,
	        anexo: [],
	        observacoes: '',
	        decisao: '',
	        justificativaDecisao: '',
	        responsavel: ''
	      },
	      indexEdit: '',
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 20,
	        fields: [{ key: 'projeto', label: 'Projeto', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'tipo_licenca', label: 'Tipo de licença', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'licenca', label: 'Licença', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'prazo_apresentacao', label: 'Prazo para apresentação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_apresentacao', label: 'Apresentada em', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'validade', label: 'Validade', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'fase_proposta', label: 'Fase', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'status', label: 'Status', sortable: true, thStyle: 'text-align: center; width:13%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableHistorico: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 100,
	        fields: [{ key: 'etapa', label: 'Etapa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'usuario', label: 'Usuário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'observacao', label: 'Observação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'created_at', label: 'Data/Hora', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: {
	    tipoUsuario: String,
	    idProposta: Number,
	    nomeProjeto: String,
	    numeroProjeto: String,
	    todasLicencas: { type: Boolean, default: false }
	  },
	  watch: {},
	  mounted: function mounted() {
	    this.consultaLicencasProposta();
	  },
	  methods: {
	    toggleValidacao: function toggleValidacao(valor) {
	      this.validarLicenca = valor;
	    },
	    toggleEdicao: function toggleEdicao(valor) {
	      this.editarLicenca = valor;
	    },
	    toggleVisualizacao: function toggleVisualizacao(valor) {
	      this.visualizarLicenca = valor;
	    },
	    consultaLicencasProposta: function consultaLicencasProposta() {
	      var _this = this;
	
	      this.loading.show = true;
	      var queryString = '/licenciamento/consultaLicencasProposta/' + this.idProposta;
	      if (this.todasLicencas === true) {
	        queryString = '/licenciamento/consultaTodasLicencasProposta';
	      }
	      axiosLaravel.get(queryString).then(function (response) {
	        if (response.data.length > 0) {
	          _this.licencas = response.data;
	          _this.licencas.forEach(function (licenca) {
	            if (licenca.tipo_licenca === 'INFORMATIVA') {
	              licenca.data_apresentacao = _moment2.default.utc(licenca.created_at).format('YYYY-MM-DD');
	            }
	          });
	          _this.table.items = _this.licencas;
	          _this.licencasBackup = _.cloneDeep(_this.licencas);
	          if (_this.todasLicencas) {
	            _this.initFiltros();
	          }
	          _this.$forceUpdate();
	          _this.loading.show = false;
	        } else {
	          _this.loading.show = false;
	        }
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    },
	    consultarHistoricoLicenca: function consultarHistoricoLicenca(licenca) {
	      var _this2 = this;
	
	      console.log('Consultando Historico', licenca.id, licenca.fk_proposta);
	      this.tableHistorico.items = [];
	      this.loading.showTable = true;
	      var obj = {
	        idProposta: licenca.fk_proposta,
	        idLicenca: licenca.id
	      };
	      axiosLaravel.post('/licenciamento/consultarHistoricoLicenca/', obj).then(function (response) {
	        console.log(response.data);
	        if (response.data.length > 0) {
	          _this2.historico = response.data;
	          _this2.tableHistorico.items = _this2.historico;
	        }
	        _this2.$forceUpdate();
	        _this2.loading.showTable = false;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.loading.showTable = false;
	      });
	    },
	    abrirAnexoLicenca: function abrirAnexoLicenca(licenca) {
	      this.licencaTemplate = {
	        projeto: licenca.projeto,
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        data_apresentacao: _.isNull(licenca.data_apresentacao) ? '-' : _moment2.default.utc(licenca.data_apresentacao).format('DD/MM/YYYY'),
	        prazo_apresentacao: _.isNull(licenca.prazo_apresentacao) ? '-' : _moment2.default.utc(licenca.prazo_apresentacao).format('DD/MM/YYYY'),
	        validade: _.isNull(licenca.validade) ? '-' : _moment2.default.utc(licenca.validade).format('YYYY-MM-DD'),
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: _.isNull(licenca.documento) ? [] : [licenca.anexo],
	        observacoes: licenca.observacoes,
	        decisao: '',
	        justificativaDecisao: '',
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	
	      this.consultarHistoricoLicenca(licenca);
	      this.toggleValidacao(true);
	    },
	    visualizaLicenca: function visualizaLicenca(licenca, index) {
	      this.indexEdit = index;
	      this.licencaTemplate = {
	        projeto: licenca.projeto,
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        data_apresentacao: _.isNull(licenca.data_apresentacao) ? '-' : _moment2.default.utc(licenca.data_apresentacao).format('DD/MM/YYYY'),
	        prazo_apresentacao: _.isNull(licenca.prazo_apresentacao) ? '-' : _moment2.default.utc(licenca.prazo_apresentacao).format('DD/MM/YYYY'),
	        validade: _.isNull(licenca.validade) ? '-' : _moment2.default.utc(licenca.validade).format('YYYY-MM-DD'),
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: _.isNull(licenca.documento) ? [] : [licenca.anexo],
	        observacoes: licenca.observacoes
	      };
	      this.consultarHistoricoLicenca(licenca);
	      this.toggleVisualizacao(true);
	    },
	    editaLicenca: function editaLicenca(licenca, index) {
	      this.indexEdit = index;
	      this.licencaTemplate = {
	        projeto: licenca.projeto,
	        id: licenca.id,
	        licenca: licenca.licenca,
	        tipo_licenca: licenca.tipo_licenca,
	        fase_proposta: licenca.fase_proposta,
	        periodo_apresentacao: licenca.periodo_apresentacao,
	        data_apresentacao: _.isNull(licenca.data_apresentacao) ? '-' : _moment2.default.utc(licenca.data_apresentacao).format('DD/MM/YYYY'),
	        prazo_apresentacao: _.isNull(licenca.prazo_apresentacao) ? '-' : _moment2.default.utc(licenca.prazo_apresentacao).format('YYYY-MM-DD'),
	        validade: _.isNull(licenca.validade) ? '-' : _moment2.default.utc(licenca.validade).format('YYYY-MM-DD'),
	        status: licenca.status,
	        documento: licenca.documento,
	        anexo: _.isNull(licenca.documento) ? [] : [licenca.anexo],
	        observacoes: licenca.observacoes,
	        justificativaDecisao: '',
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	      this.consultarHistoricoLicenca(licenca);
	      this.toggleEdicao(true);
	    },
	    validaLicenca: function validaLicenca() {
	      var _this3 = this;
	
	      console.log('Grava Licença');
	
	      if (this.verificaCamposObrigatorios() === false) {
	        this.$snotify.error('Selecione a decisão e informe a justificativa antes de continuar.');
	        return;
	      }
	      this.$snotify.clear();
	      this.$aguarde('Gravando decisão...');
	      this.loading.show = true;
	
	      axiosLaravel.post('/licenciamento/atualizaDecisaoValidacao/', this.licencaTemplate).then(function (response) {
	        console.log(response.data);
	        _this3.$snotify.clear();
	        _this3.$snotify.success(response.data);
	        _this3.loading.show = false;
	        _this3.toggleValidacao(false);
	        _this3.consultaLicencasProposta();
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	        _this3.loading.show = false;
	      });
	    },
	    atualizaPrazoLicenca: function atualizaPrazoLicenca() {
	      var _this4 = this;
	
	      console.log('Grava Licença');
	
	      if (this.verificaCamposObrigatoriosPrazo() === false) {
	        this.$snotify.error('Informe novo prazo e justifique antes de continuar.');
	        return;
	      }
	      this.$snotify.clear();
	      this.$aguarde('Gravando novo Prazo da Licença...');
	      this.loading.show = true;
	
	      this.licencaTemplate.prazo_apresentacao = _moment2.default.utc(this.licencaTemplate.prazo_apresentacao).format('YYYY-MM-DD');
	      axiosLaravel.post('/licenciamento/atualizaPrazoLicenca/', this.licencaTemplate).then(function (response) {
	        console.log(response.data);
	        _this4.$snotify.clear();
	        _this4.$snotify.success(response.data);
	        _this4.loading.show = false;
	        _this4.toggleEdicao(false);
	        _this4.consultaLicencasProposta();
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	        _this4.loading.show = false;
	      });
	    },
	    verificaCamposObrigatorios: function verificaCamposObrigatorios() {
	      if (this.licencaTemplate.decisao === '') {
	        return false;
	      }
	      if (this.licencaTemplate.justificativaDecisao === '') {
	        return false;
	      }
	      return true;
	    },
	    verificaCamposObrigatoriosPrazo: function verificaCamposObrigatoriosPrazo() {
	      if (this.licencaTemplate.prazo_apresentacao === '') {
	        return false;
	      }
	      if (this.licencaTemplate.justificativaDecisao === '') {
	        return false;
	      }
	      return true;
	    },
	    verificarStatusValidacao: function verificarStatusValidacao(licenca) {
	      if (licenca.status === 'Pendente de Validação') {
	        return true;
	      }
	      return false;
	    },
	    verificarStatusEdicao: function verificarStatusEdicao(licenca) {
	      if (licenca.status === 'Aguardando Envio') {
	        return true;
	      }
	      return false;
	    },
	    statusClass: function statusClass(status) {
	      if (status === 'Pendente de Validação') {
	        return 'tag-status pendente-validacao';
	      }
	      if (status === 'Aguardando Envio') {
	        return 'tag-status pendente';
	      }
	      if (status === 'Devolvido para Ajustes') {
	        return 'tag-status pendente';
	      }
	      if (status === 'Validado') {
	        return 'tag-status validado';
	      }
	      if (status === 'Informado pela Analise' || status === 'Informado pela tela de Projeto') {
	        return 'tag-status validado';
	      }
	      if (status === 'Informado pela FBB') {
	        return 'tag-status estoque';
	      }
	      if (status === 'Informado pela Entidade') {
	        return 'tag-status estoque';
	      }
	    },
	    initFiltros: function initFiltros() {
	      this.filtroProjetos = _.uniq(_.map(this.licencas, 'projeto'));
	      this.filtroStatus = _.uniq(_.map(this.licencas, 'status'));
	    },
	    limparFiltros: function limparFiltros() {
	      this.filtroProjetoSelecionado = 'TODOS';
	      this.filtroStatusSelecionado = 'TODOS';
	      this.aplicarFiltros();
	    },
	    aplicarFiltros: function aplicarFiltros() {
	      var _this5 = this;
	
	      var licencaFiltro = _.cloneDeep(this.licencas);
	      var filtro = '';
	      if (this.filtroProjetoSelecionado === 'TODOS') {
	        if (this.filtroStatusSelecionado === 'TODOS') {
	          this.table.items = this.licencas;
	          return;
	        } else {
	          console.log('licenca status only');
	          filtro = _.filter(licencaFiltro, function (licenca) {
	            return licenca.status === _this5.filtroStatusSelecionado;
	          });
	        }
	        this.$forceUpdate();
	      } else {
	        if (this.filtroStatusSelecionado === 'TODOS') {
	          filtro = _.filter(licencaFiltro, function (licenca) {
	            return licenca.projeto === _this5.filtroProjetoSelecionado;
	          });
	        } else {
	          filtro = _.filter(licencaFiltro, function (licenca) {
	            return licenca.projeto === _this5.filtroProjetoSelecionado;
	          });
	          filtro = _.filter(filtro, function (licenca) {
	            return licenca.status === _this5.filtroStatusSelecionado;
	          });
	        }
	      }
	      this.table.items = filtro;
	      this.$forceUpdate();
	    },
	    confirmaExclusao: function confirmaExclusao(mensagem, acao) {
	      this.$dialog.confirm(mensagem).then(function () {
	        return acao();
	      }).catch(function () {});
	    },
	    preparaExclusao: function preparaExclusao(licenca) {
	      var index = this.table.items.indexOf(licenca);
	      if (index < 0) {
	        return;
	      }
	
	      if (licenca.id !== null) {
	        this.excluiLicenca(licenca.id);
	        this.table.items.splice(index, 1);
	      }
	    },
	    excluiLicenca: function excluiLicenca(id) {
	      var _this6 = this;
	
	      this.$snotify.clear();
	      this.$aguarde('Excluindo licença na base de dados...');
	      var obj = {
	        responsavel: this.usuarioLogado.ds_nome_usuario
	      };
	      axiosLaravel.post('/licenciamento/excluirLicenca/' + id, obj).then(function (response) {
	        _this6.$snotify.clear();
	        _this6.$snotify.success(response.data);
	        _this6.consultaLicencasProposta();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	        _this6.$snotify.clear();
	        _this6.$snotify.error(error);
	        _this6.loading.show = false;
	      });
	    }
	  }
	};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _publicoAlvoDescricao = __webpack_require__(522);
	
	var _publicoAlvoDescricao2 = _interopRequireDefault(_publicoAlvoDescricao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'listaParticipantes',
	  components: {
	    publicoAlvoDescricao: _publicoAlvoDescricao2.default
	  },
	  data: function data() {
	    return {
	      showgrid: true,
	      nomeExcel: '',
	      table: {
	        items: [],
	        bloqueioCampos: false,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 5,
	        fields: [{ key: 'nome', label: 'Nome', sortable: true, thStyle: 'text-align: center; width: 30%', class: 'text-center' }, { key: 'cpf', label: 'CPF', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'data_nascimento', label: 'Data de Nascimento', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'telefone', label: 'Telefone', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'sexo', label: 'Sexo', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'escolaridade', label: 'Escolaridade', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 15%', class: 'text-center' }]
	      },
	      json_data: [],
	      json_fields: {
	        'Nome': 'nome',
	        'CPF': 'cpf',
	        'Data_Nascimento': 'data_nascimento',
	        'Telefone': 'telefone',
	        'Sexo': 'sexo',
	        'Escolaridade': 'escolaridade',
	        'UF': 'municipio.uf',
	        'Cidade': 'municipio.nome'
	      },
	      json_meta: [[{
	        'key': 'charset',
	        'value': 'utf-8'
	      }]],
	      participantes: {
	        telefone: ''
	      },
	      participantesTable: {},
	      editandoIndex: null,
	      dt_nascimento_participante: '',
	      estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
	      municipios: [],
	      descricaoParticipante: [],
	      idParticipante: null,
	      permiteEditarDescricao: true
	    };
	  },
	
	  props: ['propsParticipantes', 'disable', 'propsRelatorio', 'usuarioLogado', 'idRelatorio', 'idProposta'],
	  watch: {
	    propsParticipantes: function propsParticipantes() {
	      this.table.items = this.propsParticipantes || [];
	      this.table.totalRows = this.table.items.length;
	      this.json_data = this.table.items;
	      this.totalizaParticipantes();
	    },
	    dt_nascimento_participante: function dt_nascimento_participante(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.participantes.data_nascimento = newdate.format('YYYY-MM-DD');
	      }
	    }
	  },
	  computed: {
	    calculaIdade: function calculaIdade() {
	      var anoAtualFormatada = (0, _moment2.default)().format('YYYY');
	      var idade = 0;
	      var dtNascimento = (0, _moment2.default)(this.dt_nascimento_participante, 'DD/MM/YYYY', true);
	      if (dtNascimento.isValid()) {
	        var anoNascimento = (0, _moment2.default)(dtNascimento).format('YYYY');
	        idade = anoAtualFormatada - anoNascimento;
	      }
	      return idade;
	    }
	  },
	  created: function created() {
	    this.nomeExcel = 'Lista de participantes' + '_Projeto:' + this.$route.params.row.item.numero + '_Relatório:' + this.$route.params.row.item.sequencia + '.xls';
	  },
	
	  methods: {
	    onCancel: function onCancel() {
	      this.participantes = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	      this.dt_nascimento_participante = '';
	    },
	    onAdd: function onAdd() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (!_.has(_this.participantes, 'editavel')) {
	            _this.participantes['editavel'] = 1;
	          }
	
	          if (_this.editandoIndex !== null) {
	            for (var i in _this.participantes) {
	              _this.participantesTable[i] = _this.participantes[i];
	            }
	            _this.$refs.publicoAlvoDescricao.salvarSelecao();
	          } else {
	            if (_this.table.items) {
	              _this.table.items.forEach(function (item) {
	                if (item.cpf) {
	                  if (item.cpf.toString() === _this.participantes.cpf) {
	                    _this.cpfExiste = true;
	                  } else {
	                    _this.cpfExiste = false;
	                  }
	                }
	              });
	            }
	            if (_this.cpfExiste === true) {
	              _this.$snotify.error('CPF já está cadastrado na lista de participantes!');
	              return;
	            } else {
	              if (_this.descricaoParticipante.length === 0) {
	                _this.descricaoParticipante = [32];
	              }
	              var definicao = {
	                proposta: _this.propsRelatorio.id_proposta,
	                tipo: 'REALIZADO',
	                definicoes: _this.descricaoParticipante
	              };
	              _this.participantes.definicoes = definicao;
	              _this.table.items.push(_this.participantes);
	              _this.$emit('participantesAdicionado', _this.table.items);
	              _this.totalizaParticipantes();
	              _this.json_data = _.cloneDeep(_this.table.items);
	              _this.onCancel();
	            }
	          }
	          _this.onCancel();
	        }
	      });
	    },
	    totalizaParticipantes: function totalizaParticipantes() {
	      var _this2 = this;
	
	      var items = this.table.items || [];
	      var totais = {};
	      var jovens = items.filter(function (p) {
	        var idade = _this2.calcIdade(p.data_nascimento);
	        return idade >= 14 && idade <= 29;
	      }).length;
	
	      var mulheres = items.filter(function (p) {
	        return p.sexo === 'Feminino';
	      }).length;
	      totais['participantes'] = items.length;
	      totais['jovens'] = jovens;
	      totais['mulheres'] = mulheres;
	      this.$emit('totalizadores', totais);
	    },
	    calcIdade: function calcIdade(nascimentoParticipante) {
	      if (!nascimentoParticipante) return 0;
	      var dtNascimento = (0, _moment2.default)(nascimentoParticipante, ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', _moment2.default.ISO_8601], true);
	      if (!dtNascimento.isValid()) return 0;
	      return (0, _moment2.default)().diff(dtNascimento, 'years');
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	      this.json_data = _.cloneDeep(this.table.items);
	    },
	    edita: function edita(row) {
	      this.permiteEditarDescricao = true;
	      this.editandoIndex = row.index;
	      this.carregaMunicipios(row.item.UF);
	      this.participantes = _.cloneDeep(row.item);
	      this.participantesTable = row.item;
	      this.showgrid = false;
	      this.dt_nascimento_participante = (0, _moment2.default)(this.participantes.data_nascimento).format('DD/MM/YYYY');
	      this.idParticipante = row.item.id;
	      this.totalizaParticipantes();
	    },
	    soNumeros: function soNumeros($event) {
	      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
	      if (keyCode < 48 || keyCode > 57) {
	        $event.preventDefault();
	      }
	    },
	    carregaMunicipios: function carregaMunicipios(uf) {
	      var _this3 = this;
	
	      this.participantes.municipio = null;
	      this.municipios = [];
	      var cod = this.participantes.codigo_municipio;
	      console.log('cod', cod);
	      axiosLaravel.get('municipios/' + uf).then(function (response) {
	        _this3.municipios = response.data;
	        var arr = _this3.municipios;
	        if (cod > 0) {
	          _this3.selecionado = _.filter(arr, function (o) {
	            if (o.codigo === cod) return o;
	          });
	          _this3.participantes.municipio = _this3.selecionado;
	        }
	      });
	    },
	    etiquetaListaMunicipios: function etiquetaListaMunicipios(option) {
	      return '' + option.nome;
	    },
	    buscarParticipantes: function buscarParticipantes() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return axiosLaravel.get('/relatorio_execucao/participantes/' + _this4.idRelatorio).then(function (response) {
	                  _this4.table.items = response.data || [];
	                  _this4.$emit('participantesAdicionado', _this4.table.items);
	                  _this4.table.totalRows = _this4.table.items.length;
	                  _this4.json_data = _this4.table.items;
	                  _this4.totalizaParticipantes();
	                  console.log(response.data);
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this4.$snotify.clear();
	                  _this4.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this4);
	      }))();
	    },
	    novoParticipante: function novoParticipante() {
	      this.showgrid = !this.showgrid;
	      this.idParticipante = null;
	    },
	    visualiza: function visualiza(row) {
	      this.edita(row);
	      this.permiteEditarDescricao = false;
	    }
	  }
	};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'metas',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsMetas,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 100,
	        fields: [{ key: 'objetivos', label: 'Objetivos', sortable: true, thStyle: 'text-align: center; width: 30%;', class: 'text-left' }, { key: 'ds_descricao', label: 'Metas', sortable: true, thStyle: 'text-align: center; width: 30%;', class: 'text-left' }, { key: 'nr_quantidade', label: 'Quanto', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_unidade_medida', label: 'Unidade', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_indicadores_execucao', label: 'Indicador', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      objetivos: {},
	      formasContratacao: [],
	      editando: false,
	      formEditavel: false,
	      meta: {
	        id: 0,
	        objetivos: {}
	      },
	      contador: 0,
	      metaTabela: {},
	      metaEdicao: '',
	      objetivoIndex: [],
	      listaIndicadores: ['Capacitação realizada', 'Consultoria/assessoria contratada', 'Máquina/equipamento adquirido', 'Obra concluída', 'Produto adquirido', 'Seguro contratado', 'Serviço realizado', 'Outros']
	    };
	  },
	
	  props: ['propsObjetivos', 'propsMetas', 'propsAtividades', 'propsProposta', 'somenteLeitura', 'editavel', 'propsPropostaBackup', 'modoVisualizacaoAlteracoes', 'atualizar', 'processoSolicitacao'],
	  watch: {
	    propsMetas: function propsMetas() {},
	    propsObjetivos: function propsObjetivos() {
	      var _this = this;
	
	      for (var i = 0; i < this.propsObjetivos.length; i++) {
	        for (var j = 0; j < this.propsMetas.length; j++) {
	          for (var x = 0; x < this.propsMetas[j].objetivos.length; x++) {
	            if (this.propsObjetivos[i].id === this.propsMetas[j].objetivos[x].id) {
	              this.propsMetas[j].objetivos[x].ds_descricao = _.cloneDeep(this.propsObjetivos[i].ds_descricao);
	            }
	          }
	        }
	      }
	      this.$nextTick(function () {
	        _this.table.items = _this.propsMetas;
	      });
	      this.$forceUpdate();
	    },
	    editavel: function editavel() {
	      this.formEditavel = this.editavel;
	    },
	    'table.items': function tableItems() {
	      this.$emit('metaAdicionada', this.table.items);
	    },
	    showgrid: function showgrid() {
	      this.$emit('validacaoMetas', { 'tag': 'metaEditando', 'ativo': !this.showgrid, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Meta em edição' });
	    }
	  },
	  computed: {
	    altera: function altera() {
	      var _this2 = this;
	
	      for (var i = 0; i < this.propsObjetivos.length; i++) {
	        for (var j = 0; j < this.propsMetas.length; j++) {
	          for (var x = 0; x < this.propsMetas[j].objetivos.length; x++) {
	            if (this.propsObjetivos[i].id === this.propsMetas[j].objetivos[x].id) {
	              this.propsMetas[j].objetivos[x].ds_descricao = _.cloneDeep(this.propsObjetivos[i].ds_descricao);
	              this.$forceUpdate();
	            }
	          }
	        }
	      }
	      this.$nextTick(function () {
	        _this2.table.items = _this2.propsMetas;
	      });
	      this.$forceUpdate();
	    }
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    this.formEditavel = this.editavel;
	    if (this.$router.currentRoute.name === 'relatorio-analise' || !this.formEditavel) {
	      this.table.fields = _.reject(this.table.fields, { key: 'actions' });
	      this.$forceUpdate();
	    }
	  },
	  methods: {
	    buscaMetas: function buscaMetas(itens) {
	      for (var i in itens) {
	        if (itens[i].ds_descricao === 'Não informado') {
	          for (var j in itens[i].metas) {
	            if (!itens[i].metas[j].hasOwnProperty('ds_unidade_medida')) {
	              itens[i].metas.splice(j, 1);
	            }
	          }
	        }
	      }
	      return itens;
	    },
	    onCancel: function onCancel() {
	      this.meta = {};
	      this.objetivoIndex = [];
	      this.metaEdicao = '';
	      this.showgrid = true;
	      this.editando = false;
	    },
	    onAdd: function onAdd() {
	      var _this3 = this;
	
	      var vm = this;
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_.find(_this3.table.items, function (m) {
	            return vm.metaEdicao !== vm.meta.ds_descricao && m.ds_descricao === vm.meta.ds_descricao;
	          })) {
	            _this3.$dialog.alert('Já existe uma meta com essa descrição', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	          } else {
	            if (_this3.editando === true) {
	              _this3.meta.objetivos = _this3.objetivoIndex;
	              for (var i in _this3.meta) {
	                _this3.metaTabela[i] = _this3.meta[i];
	              }
	            } else {
	              _this3.meta.objetivos = _this3.objetivoIndex;
	              _this3.contador = _this3.contador + 1;
	              _this3.meta.id = _.cloneDeep(_this3.contador + _this3.meta.ds_descricao);
	              _this3.table.items.push(_this3.meta);
	              _this3.$forceUpdate();
	            }
	            _this3.onCancel();
	            _this3.$emit('acaoAtualizaSolicitacoes', new Date());
	          }
	        }
	      });
	    },
	    exclui: function exclui(row) {
	      var vm = this;
	      this.$dialog.confirm('Deseja <b>APAGAR</b> a meta:<br/>' + row.item.ds_descricao + '?', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        var qtdAtividades = _.chain(vm.propsProposta.atividades).map('metas').flatten().filter({ ds_descricao: row.item.ds_descricao }).value().length;
	        if (qtdAtividades > 0) {
	          vm.$dialog.alert('Deve apagar <b>' + qtdAtividades + ' atividades</b> vinculadas a esta meta primeiro', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	        } else {
	          vm.table.items.splice(row.index, 1);
	        }
	        vm.$forceUpdate();
	      }).catch(function () {
	        console.log('Aviso de Confirmações fechado SEM confirmar exclusão de metas');
	      });
	    },
	    edita: function edita(row) {
	      this.objetivoIndex = row.item.objetivos;
	      this.meta = (0, _assign2.default)({}, row.item);
	      this.metaTabela = row.item;
	      this.metaEdicao = row.item.ds_descricao;
	      this.showgrid = false;
	      this.editando = true;
	    },
	    selecionado: function selecionado(objetivos) {
	      console.log('objetivos', objetivos);
	      console.log('this.meta', this.meta);
	    },
	    ehItemNovo: function ehItemNovo(item) {
	      return !_.has(item, 'id') || _.includes(_.get(item, 'id', ''), 'novo') || _.find(_.get(this.processoSolicitacao, 'inclusao', []), ['id', item.id]);
	    },
	    ehItemExcluido: function ehItemExcluido(item) {
	      return _.includes(_.get(this.processoSolicitacao, 'exclusao', []), item.id);
	    },
	    modificacaoLinha: function modificacaoLinha(item, type) {
	      if (!item || type !== 'row') return;
	      if ('' + this.modoVisualizacaoAlteracoes === 'DETALHADO') {
	        if (this.ehItemNovo(item)) return 'modificacaoInclusao';
	        if (this.ehItemExcluido(item)) return 'modificacaoExlusao';
	      }
	    }
	  }
	};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'metasOld',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsObjetivos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'description', label: 'Objetivo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.description', label: 'Meta do Projeto', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.quantity', label: 'Meta Orçada', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.measurementUnit', label: 'Unidade de medida', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.duration', label: 'Duração', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'goals.performanceIndicators', label: 'Indicador', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      objective: {},
	      formasContratacao: [],
	      editando: false,
	      meta: {},
	      metaTabela: {},
	      objetivoIndex: null,
	      listIndicators: ['Capacitação realizada', 'Consultoria/assessoria contratada', 'Máquina/equipamento adquirido', 'Obra concluída', 'Produto adquirido', 'Seguro contratado', 'Serviço realizado', 'Veículo adquirido']
	    };
	  },
	
	  props: ['propsObjetivos'],
	  watch: {
	    propsObjetivos: function propsObjetivos() {
	      this.table.items = this.propsObjetivos;
	      this.table.items = this.buscaMetas(this.table.items);
	    },
	    'table.items': function tableItems() {
	      this.$emit('metaAdicionada', this.table.items);
	    }
	  },
	  mounted: function mounted() {},
	  methods: {
	    buscaMetas: function buscaMetas(itens) {
	      for (var i in itens) {
	        if (itens[i].description === 'Não informado') {
	          for (var j in itens[i].goals) {
	            if (!itens[i].goals[j].hasOwnProperty('measurementUnit')) {
	              itens[i].goals.splice(j, 1);
	            }
	          }
	        }
	      }
	      return itens;
	    },
	    onCancel: function onCancel() {
	      this.meta = {};
	      this.objetivoIndex = null;
	      this.showgrid = true;
	      this.editando = false;
	    },
	    onAdd: function onAdd() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this.editando === true) {
	            for (var i in _this.meta) {
	              _this.metaTabela[i] = _this.meta[i];
	            }
	          } else {
	            if (!_this.table.items[_this.objetivoIndex].hasOwnProperty('goals')) {
	              _this.table.items[_this.objetivoIndex].goals = [];
	            }
	            _this.table.items[_this.objetivoIndex].goals.push(_this.meta);
	            _this.$forceUpdate();
	          }
	          _this.onCancel();
	        }
	      });
	    },
	    exclui: function exclui(objetivo, metaIndex) {
	      if (objetivo.goals[metaIndex].activities.length > 0) {
	        this.$snotify.error('Meta não pode se excluida pois possui atividades vinculadas');
	        return;
	      }
	      objetivo.goals.splice(metaIndex, 1);
	    },
	    edita: function edita(objetivoIndex, meta) {
	      this.objetivoIndex = objetivoIndex;
	      this.meta = (0, _assign2.default)({}, meta);
	      this.metaTabela = meta;
	      this.showgrid = false;
	      this.editando = true;
	    }
	  }
	};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(275);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'municipalizacao',
	  data: function data() {
	    return {
	      mostraGrid: true,
	      loading: {
	        cepMunicipio: false
	      },
	      table: {
	        items: this.propsProposta.municipalizacao,
	        filter: null,
	        hover: true,
	        bordered: true,
	        block: false,
	        currentPage: 1,
	        perPage: 5000,
	        fields: [{ key: 'ds_fase', label: 'Origem', sortable: true, thStyle: 'text-align: center; width: 150px', class: 'text-center' }, { key: 'ds_cep', label: 'CEP', sortable: true, thStyle: 'text-align: center; width: 200px', class: 'text-center' }, { key: 'ds_municipio', label: 'Município', sortable: true, thStyle: 'text-align: center; width: 450px', class: 'text-center' }, { key: 'dc_valor_municipio', label: 'Valor Total', sortable: true, thStyle: 'text-align: center; width: 250px', class: 'text-center' }, { key: 'nr_total_participantes', label: 'Participantes', sortable: true, thStyle: 'text-align: center; width: 100px', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 170px', class: 'text-center' }]
	      },
	      totais: {
	        valor: {
	          projeto: {
	            fbb: 0,
	            parceiros: 0,
	            contrapartidas: 0
	          },
	          municipalizados: {
	            fbb: 0,
	            parceiros: 0,
	            contrapartidas: 0
	          },
	          restantes: {
	            fbb: 0,
	            parceiros: 0,
	            contrapartidas: 0
	          }
	        },
	        participantes: {
	          projeto: 0,
	          municipalizados: 0,
	          restantes: 0
	        },
	        municipios: {
	          todos: 0
	        }
	      },
	      total: 0,
	      totalFBB: 0,
	      totalParc: 0,
	      totalContra: 0,
	      cidade: {},
	      cidadeIndex: null,
	      cidadeValor: 0,
	      editando: false,
	      visaoReduzida: true,
	      layout: ['SEM_BOTOES_DISTRIBUICAO'],
	      formEditavel: false,
	      existeMunicipioRepetido: []
	    };
	  },
	
	  props: ['propsProposta', 'editavel', 'propsLayout', 'propsPropostaBackup', 'etapa', 'modoVisualizacaoAlteracoes', 'atualizar', 'processoSolicitacao', 'travarMunicipios'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {
	    var bc = new BroadcastChannel('propostas');
	    var vm = this;
	    bc.onmessage = function (e) {
	      var mensagem = e.data;
	      if ('' + mensagem.id === '' + vm.$route.params.id) {
	        if (mensagem.acao === 'notificacaoAtualizacaoPublicoAlvo') {
	          vm.calcularTotais();
	        } else if (mensagem.acao === 'notificacaoAtualizacaoCronograma') {
	          vm.calcularTotais();
	        } else {}
	      }
	    };
	  },
	  created: function created() {
	    this.table.items = this.propsProposta.municipalizacao;
	    this.formEditavel = this.editavel;
	    if (!this.propsLayout || _.isNil(this.propsLayout)) {
	      this.layout = ['COM_BOTOES_DISTRIBUICAO'];
	    }
	    this.calcularTotais();
	    this.ajustarVisao();
	    if (this.travarMunicipios) {
	      this.existeMunicipioRepetido = this.verificaDuplicidadeMunicipios(this.propsProposta.municipalizacao);
	    }
	  },
	
	  watch: {
	    atualizar: function atualizar() {
	      this.calcularTotais();
	    },
	    propsLayout: function propsLayout() {
	      this.layout = this.propsLayout;
	    },
	    'propsProposta.municipalizacao': function propsPropostaMunicipalizacao() {
	      this.table.items = this.propsProposta.municipalizacao;
	      this.calcularTotais();
	      this.ajustarVisao();
	      this.existeMunicipioRepetido = this.verificaDuplicidadeMunicipios(this.propsProposta.municipalizacao);
	    },
	    editavel: function editavel() {
	      this.formEditavel = this.editavel;
	      this.ajustarVisao();
	    },
	    formEditavel: function formEditavel() {
	      this.ajustarVisao();
	    },
	    'table.items': function tableItems() {
	      this.$emit('municipioAdicionado', this.propsProposta.municipalizacao);
	      var qtdeMunicipios = this.table.items.length;
	      var qtdeMunicipiosUnicos = _.uniq(_.map(this.table.items, function (m) {
	        return m.ds_fase + m.ds_municipio + m.ds_uf;
	      })).length;
	      this.$emit('validacaoMunicipio', { 'tag': 'duplicidadeMunicipio', 'ativo': qtdeMunicipios !== qtdeMunicipiosUnicos, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há municípios cadastros em duplicidade para uma mesma fase' });
	    },
	
	    mostraGrid: function mostraGrid() {
	      this.$emit('validacaoMunicipio', { 'tag': 'municipioEditando', 'ativo': !this.mostraGrid, 'tipo': 'restricao', 'acao': null, 'mensagem': '<span class=\'restricaoEditandoInformacao\'>Municípios em edição<span>' });
	    }
	  },
	  methods: {
	    verificaDuplicidadeMunicipios: function verificaDuplicidadeMunicipios(lista) {
	      var mapa = new _map2.default();
	      var duplicados = [];
	      if (!Array.isArray(lista)) {
	        return duplicados;
	      }
	      lista.forEach(function (item) {
	        var municipio = (item.ds_municipio || '').trim().toUpperCase();
	        var uf = (item.ds_uf || '').trim().toUpperCase();
	        var fase = (item.ds_fase || 'SEM_FASE').trim().toUpperCase();
	        var chave = municipio + '|' + uf + '|' + fase;
	        if (mapa.has(chave)) {
	          duplicados.push(item);
	        } else {
	          mapa.set(chave, true);
	        }
	      });
	      return duplicados;
	    },
	    truncarValor: function truncarValor(valor) {
	      return parseInt(valor * 100) / 100;
	    },
	    ajustarVisao: function ajustarVisao() {
	      this.visaoReduzida = this.propsProposta.ds_fase === 'CADASTRO' || this.propsProposta.ds_fase === 'SOLICITACAO' || this.propsProposta.ds_fase === 'REVISAO' || this.usuarioLogado.ds_tipo_usuario !== 'FUNDACAO';
	      if (this.etapa === 'Solicitação' || this.etapa === 'Revisão') {
	        this.visaoReduzida = false;
	      }
	      if (this.visaoReduzida) {
	        this.table.fields = _.remove(this.table.fields, function (f) {
	          return f.key !== 'ds_fase' && f.key !== 'dc_valor_municipio';
	        });
	      }
	      if (!this.formEditavel) {
	        this.table.fields = _.remove(this.table.fields, function (f) {
	          return f.key !== 'actions';
	        });
	      } else if (!_.find(this.table.fields, ['key', 'actions'])) {
	        this.table.fields.push({ key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' });
	      }
	      this.$forceUpdate();
	    },
	    temItemOrigem: function temItemOrigem(origem) {
	      var c = 0;
	      this.propsProposta.atividades.forEach(function (atividade) {
	        if (_.has(atividade, 'itens_orcamentos') && atividade.itens_orcamentos.length > 0) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            c = c + ('' + item.origem === '' + origem ? 1 : 0);
	          });
	        }
	      });
	      return c > 0;
	    },
	    selecionaFase: function selecionaFase() {
	      this.cidade.dc_valor_municipio = 0;
	      this.cidade.nr_total_participantes = '' + this.cidade.ds_fase === '2' ? 0 : this.cidade.nr_total_participantes;
	    },
	    onNew: function onNew() {
	      this.mostraGrid = false;
	    },
	    distribuirParticipantes: function distribuirParticipantes() {
	      var quantidade = _.filter(this.table.items, function (q) {
	        return '' + q.ds_fase !== '2';
	      }).length;
	      var acum = 0;
	      var total = this.totais.participantes.projeto;
	      var parcela = Math.ceil(total / quantidade);
	      this.table.items.forEach(function (item) {
	        if ('' + item.ds_fase !== '2') {
	          if (acum + parcela > total) {
	            var dif = acum + parcela - total;
	            item.nr_total_participantes = parcela - dif;
	          } else {
	            item.nr_total_participantes = parcela;
	          }
	          acum += item.nr_total_participantes;
	        }
	      });
	      this.calcularTotais();
	    },
	    distribuirValores: function distribuirValores() {
	      var _this = this;
	
	      var fases = ['1', '2', '5'];
	      fases.forEach(function (fase) {
	        var quantidade = _.filter(_this.table.items, ['ds_fase', '' + fase]).length;
	        var acum = 0;
	        var total = fase === '1' ? _this.totais.valor.projeto.fbb : fase === '2' ? _this.totais.valor.projeto.contrapartidas : fase === '5' ? _this.totais.valor.projeto.parceiros : 0;
	        var parcela = Math.ceil(total / quantidade);
	        if (quantidade > 0 && total > 0) {
	          _this.table.items.forEach(function (item) {
	            if ('' + item.ds_fase === fase) {
	              if (acum + parcela > total) {
	                var dif = acum + parcela - total;
	                item.dc_valor_municipio = parcela - dif;
	              } else {
	                item.dc_valor_municipio = parcela;
	              }
	              acum += item.dc_valor_municipio;
	            }
	          });
	        }
	      });
	      this.calcularTotais();
	    },
	    buscaCidades: function buscaCidades(cidades) {
	      var _this2 = this;
	
	      this.loading.cepMunicipio = true;
	      var lista = _.uniq(_.map(cidades, 'ds_cep'));
	      axiosLaravel.post('projeto/cidades', { 'referencia': 'CEP', 'lista': lista }).then(function (response) {
	        cidades.forEach(function (municipio) {
	          var cidade = _.find(response.data, function (cid) {
	            return _.toNumber(municipio.ds_cep) >= _.toNumber(cid.nr_cep_inicio) && _.toNumber(municipio.ds_cep) <= _.toNumber(cid.nr_cep_final);
	          });
	          _.set(municipio, 'ds_municipio', cidade.ds_nome);
	          _.set(municipio, 'ds_uf', cidade.ds_uf);
	        });
	        _this2.loading.cepMunicipio = false;
	      }).catch(function (error) {
	        _this2.loading.cepMunicipio = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    valorMaximo: function valorMaximo(cidade) {
	      if (_.has(cidade, 'ds_fase')) {
	        var total = '' + cidade.ds_fase === '1' ? this.totais.valor.projeto.fbb : '' + cidade.ds_fase === '2' ? this.totais.valor.projeto.contrapartidas : '' + cidade.ds_fase === '5' ? this.totais.valor.projeto.parceiros : 0;
	        var municipalizado = '' + cidade.ds_fase === '1' ? this.totais.valor.municipalizados.fbb : '' + cidade.ds_fase === '2' ? this.totais.valor.municipalizados.contrapartidas : '' + cidade.ds_fase === '5' ? this.totais.valor.municipalizados.parceiros : 0;
	        return total - municipalizado + this.cidadeValor;
	      } else return 0;
	    },
	    edita: function edita(row) {
	      this.mostraGrid = false;
	      this.editando = true;
	      this.cidade = _.cloneDeep(row.item);
	
	      this.cidadeIndex = this.table.items.indexOf(row.item);
	      this.cidadeValor = !_.has(this.cidade, 'dc_valor_municipio') || _.isUndefined(this.cidade.dc_valor_municipio) ? 0 : this.cidade.dc_valor_municipio;
	    },
	    confirmaExclusao: function confirmaExclusao(item) {
	      var _this3 = this;
	
	      this.$dialog.confirm('Deseja <b>APAGAR</b> o municipio ' + item.ds_municipio + ' ?').then(function () {
	        return _this3.exclui(item);
	      }).catch(function () {});
	    },
	    exclui: function exclui(item) {
	      var index = this.table.items.indexOf(item);
	      if (index < 0) {
	        return;
	      }
	      this.table.items.splice(index, 1);
	      this.calcularTotais();
	      this.$emit('acaoAtualizaSolicitacoes', new Date());
	    },
	    reincluir: function reincluir(row) {
	      this.table.items.push(row.item);
	      this.calcularTotais();
	      this.$emit('acaoAtualizaSolicitacoes', new Date());
	    },
	    onCancel: function onCancel() {
	      this.mostraGrid = true;
	      this.editando = false;
	      this.cidade = {};
	      this.cidadeIndex = null;
	      this.cidadeValor = 0;
	    },
	    valorProjetoOrigem: function valorProjetoOrigem(fase, texto) {
	      var vm = this;
	      return _.sumBy(this.propsProposta.atividades, function (atv) {
	        return _.has(atv, 'itens_orcamentos') && atv.itens_orcamentos.length > 0 ? _.sumBy(atv.itens_orcamentos, function (item) {
	          if (!(_.has(item, 'origem') && '' + item.origem === '' + fase || item.origem === texto)) {
	            return 0;
	          }
	          var valorAlteracao = _.toNumber(_.get(item, 'valorAlteracao', 0));
	
	          if (_.includes('' + _.get(item, 'id', ''), 'novo')) {
	            return valorAlteracao;
	          }
	          return vm.valorOrcadoItem(item) + valorAlteracao;
	        }) : 0;
	      });
	    },
	    valorOrcadoItem: function valorOrcadoItem(item) {
	      if (_.has(item, 'valorOrcado')) {
	        return _.toNumber(item.valorOrcado);
	      }
	      if (_.has(item, 'valor_unitario') && _.has(item, 'quantidade') && !_.isNil(item.valor_unitario)) {
	        return parseFloat(item.valor_unitario) * parseFloat(item.quantidade);
	      }
	      return _.sumBy(item.orcamentos_mensalizados, function (mes) {
	        return _.has(mes, 'valor') ? mes.valor : 0;
	      });
	    },
	    calcularTotais: function calcularTotais() {
	      this.totais.participantes.projeto = _.sumBy(this.propsProposta.publicos_alvo, function (p) {
	        return parseInt(p.nr_participantes_diretos);
	      });
	      this.totais.participantes.municipalizados = _.sumBy(this.table.items, function (i) {
	        return parseInt(i.nr_total_participantes);
	      });
	      this.totais.participantes.restantes = this.totais.participantes.projeto - this.totais.participantes.municipalizados;
	      this.totais.municipios.todos = this.table.items.length;
	
	      this.totais.valor.projeto.fbb = this.valorProjetoOrigem('1', 'FUNDACAO').toFixed(2);
	      this.totais.valor.projeto.parceiros = this.valorProjetoOrigem('5', 'PARCEIRO_ESTRATEGICO').toFixed(2);
	      this.totais.valor.projeto.contrapartidas = this.valorProjetoOrigem('2', 'CONTRAPARTIDA').toFixed(2);
	      this.totais.valor.municipalizados.fbb = _.sumBy(this.table.items, function (m) {
	        return '' + m.ds_fase === '1' || _.has(m, 'origem') && m.origem === 'FUNDACAO' ? parseFloat(m.dc_valor_municipio) : 0;
	      });
	      this.totais.valor.municipalizados.parceiros = _.sumBy(this.table.items, function (m) {
	        return '' + m.ds_fase === '5' || _.has(m, 'origem') && m.origem === 'PARCEIRO_ESTRATEGICO' ? parseFloat(m.dc_valor_municipio) : 0;
	      });
	      this.totais.valor.municipalizados.contrapartidas = _.sumBy(this.table.items, function (m) {
	        return '' + m.ds_fase === '2' || _.has(m, 'origem') && m.origem === 'CONTRAPARTIDA' ? parseFloat(m.dc_valor_municipio) : 0;
	      });
	
	      this.totais.valor.restantes.fbb = (parseInt(this.totais.valor.projeto.fbb * 100) - parseInt(this.totais.valor.municipalizados.fbb * 100)) / 100;
	      this.totais.valor.restantes.parceiros = (parseInt(this.totais.valor.projeto.parceiros * 100) - parseInt(this.totais.valor.municipalizados.parceiros * 100)) / 100;
	      this.totais.valor.restantes.contrapartidas = (parseInt(this.totais.valor.projeto.contrapartidas * 100) - parseInt(this.totais.valor.municipalizados.contrapartidas * 100)) / 100;
	
	      this.$emit('validacaoMunicipio', { 'tag': 'semMunicipiosCadastrados', 'ativo': this.table.items.length === 0, 'tipo': 'restricao', 'acao': null, 'mensagem': '<b>Não há municipios</b> cadastrado para esse projeto' });
	
	      var qtde = _.sumBy(this.table.items, function (o) {
	        return (_.has(o, 'origem') && '' + o.origem !== '2' || _.has(o, 'ds_fase') && '' + o.ds_fase !== '2') && (o.dc_valor_municipio === 0 || o.nr_total_participantes) === 0 ? 1 : 0;
	      });
	      this.$emit('validacaoMunicipio', { 'tag': 'municipiosSemValorOuParticipantes', 'ativo': qtde > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Tem <b>' + qtde + ' municipio(s)</b> que não tem valor ou participantes informados' });
	
	      if (this.propsProposta.ds_fase === 'ANALISE' || _.get(this.processoSolicitacao, 'nome', '') === 'ALTERACAO_MUNICIPIOS' || _.includes(['Solicitação', 'Revisão', 'Análise'], this.etapa)) {
	        this.$emit('validacaoMunicipio', { 'tag': 'municipiosValoresFBB', 'ativo': Math.abs(this.totais.valor.restantes.fbb) > 0.1, 'tipo': 'restricao', 'acao': null, 'mensagem': 'O total no extrato para recursos FBB (<b>R$ ' + this.totais.valor.projeto.fbb + '</b>) difere do total em municípios com recursos FBB (<b>R$ ' + this.totais.valor.municipalizados.fbb + '</b>)' });
	        this.$emit('validacaoMunicipio', { 'tag': 'municipiosValoresParcEstr', 'ativo': Math.abs(this.totais.valor.restantes.parceiros) > 0.1, 'tipo': 'restricao', 'acao': null, 'mensagem': 'O total no extrato para recursos de Parceiros Estratégicos (<b>R$ ' + this.totais.valor.projeto.parceiros + '</b>) difere do total em municípios com recursos de Parceiros Estratégicos (<b>R$ ' + this.totais.valor.municipalizados.parceiros + '</b>)' });
	        this.$emit('validacaoMunicipio', { 'tag': 'municipiosValoresContr', 'ativo': Math.abs(this.totais.valor.restantes.contrapartidas) > 0.1, 'tipo': 'restricao', 'acao': null, 'mensagem': 'O total no extrato para Contrapartida (<b>R$ ' + this.totais.valor.projeto.contrapartidas + '</b>) difere do total em municípios com Contrapartida (<b>R$ ' + this.totais.valor.municipalizados.contrapartidas + '</b>)' });
	      }
	      this.$forceUpdate();
	    },
	    onAdd: function onAdd() {
	      var _this4 = this;
	
	      if (this.loading.cepMunicipio) {
	        this.$snotify.error('Município não carregado. Favor aguardar');
	      } else {
	        var municipioFaseEditando = this.cidade.ds_fase + this.cidade.ds_municipio + this.cidade.ds_uf;
	        var municipioIgual = _.find(this.table.items, function (m) {
	          return municipioFaseEditando === m.ds_fase + m.ds_municipio + m.ds_uf;
	        });
	        if (municipioIgual && _.get(municipioIgual, 'id', 0) !== _.get(this.cidade, 'id', 0)) {
	          this.$snotify.error('Esse Município já foi cadastrado para essa fase');
	        } else {
	          this.$validator.validateAll().then(function (result) {
	            if (result && _this4.$validator.errors.all().length === 0) {
	              if (_.isNull(_this4.cidadeIndex)) {
	                _this4.table.items.push(_this4.cidade);
	              } else {
	                _this4.table.items.splice(_this4.cidadeIndex, 1, _this4.cidade);
	              }
	              _this4.calcularTotais();
	              _this4.mostraGrid = true;
	              _this4.editando = false;
	              _this4.cidade = {};
	              _this4.cidadeIndex = null;
	              _this4.cidadeValor = 0;
	              _this4.$emit('acaoAtualizaSolicitacoes', new Date());
	            }
	          });
	        }
	      }
	    },
	    etiquetaOrigemRecurso: function etiquetaOrigemRecurso(valor) {
	      return _.includes(['FUNDACAO', '1'], '' + valor) ? 'Fundação' : _.includes(['CONTRAPARTIDA', '2'], '' + valor) ? 'Contrapartida' : _.includes(['PARCEIRO_ESTRATEGICO', '5'], '' + valor) ? 'Parceiro Estratégico' : '';
	    },
	    ehItemNovo: function ehItemNovo(item) {
	      return !_.has(item, 'id') || _.includes(_.get(item, 'id', ''), 'novo') || _.find(_.get(this.processoSolicitacao, 'inclusao', []), ['id', item.id]);
	    },
	    ehItemExcluido: function ehItemExcluido(item) {
	      return _.includes(_.get(this.processoSolicitacao, 'exclusao', []), item.id);
	    },
	    modificacaoLinha: function modificacaoLinha(item, type) {
	      if (!item || type !== 'row') return;
	      if ('' + this.modoVisualizacaoAlteracoes === 'DETALHADO') {
	        if (this.ehItemNovo(item)) return 'modificacaoInclusao';
	        if (this.ehItemExcluido(item)) return 'modificacaoExlusao';
	      }
	    }
	  }
	};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'municipalizacaoOld',
	  data: function data() {
	    return {
	      mostraGrid: true,
	      table: {
	        items: this.proposta.municipalizationResume,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'phase', label: 'Fase', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'cep', label: 'CEP', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'name', label: 'Município', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'valueByActivity', label: 'Valor das ativ. por município', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'percentageByActivity', label: '% das ativ. por município', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'totalParticipants', label: 'Número de participantes por município', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'percentage', label: '% participantes por municípios', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      cidade: {},
	      cidadeTabela: {},
	      editando: false,
	      totalParticipantsAdicionar: 0,
	
	      porcentagemParticipantes: 0,
	      porcentagemAtividade: 0,
	      valorPermitidoAtividade: 0,
	      dadosOriginais: {
	        fase: null,
	        valor: null
	      }
	    };
	  },
	
	  props: ['proposta'],
	  computed: {
	    totalParticipantes: function totalParticipantes() {
	      var totalParticipantes = 0;
	      this.proposta.audiences.forEach(function (publico) {
	        totalParticipantes = totalParticipantes + publico.directParticipants;
	      });
	      return totalParticipantes;
	    },
	    totalParticipantesMunicipios: function totalParticipantesMunicipios() {
	      var total = 0;
	      if (this.table.items.length > 0) {
	        this.table.items.forEach(function (item) {
	          total += item.totalParticipants;
	        });
	      }
	      return total;
	    }
	  },
	  watch: {
	    proposta: function proposta() {
	      this.table.items = this.proposta.municipalizationResume;
	    },
	    'table.items': function tableItems() {
	      this.$emit('municipioAdicionado', this.proposta);
	    },
	    porcentagemAtividade: function porcentagemAtividade() {
	      this.cidade.percentageByActivity = Number(this.porcentagemAtividade / 10000);
	      this.$validator.errors.remove('porcentagem das atividades');
	      if (this.cidade.percentageByActivity > 1) {
	        this.$validator.errors.add('porcentagem das atividades', 'Porcentagem não pode ser maior que 100%');
	      }
	      this.ajustaValorAtividades();
	    },
	    porcentagemParticipantes: function porcentagemParticipantes() {
	      this.cidade.percentage = Number(this.porcentagemParticipantes / 10000);
	      this.$validator.errors.remove('porcentagem de participantes');
	      if (this.cidade.percentage > 1) {
	        this.$validator.errors.add('porcentagem de participantes', 'Porcentagem não pode ser maior que 100%');
	        return;
	      }
	      this.ajustaQuantidadeParticipantes();
	    }
	  },
	  methods: {
	    selecionaFase: function selecionaFase() {
	      this.cidade.valueByActivity = 0;
	      this.valorPermitidoAtividade = this.calculaValorPermitidoAtividade();
	    },
	    onNew: function onNew() {
	      this.mostraGrid = false;
	      this.calculaMaximo();
	    },
	    redistributeParticipants: function redistributeParticipants() {
	      var _this = this;
	
	      var quantidade = this.table.items.length;
	      this.table.items.forEach(function (item) {
	        item.percentage = Number(1 / quantidade).toPrecision(4);
	        item.totalParticipants = _this.totalParticipantes / quantidade;
	      });
	      this.$forceUpdate();
	    },
	    redistributeValues: function redistributeValues() {
	      this.redistribuePraFase('FUNDACAO');
	      this.redistribuePraFase('CONTRAPARTIDA');
	      this.redistribuePraFase('PARCEIRO_ESTRATEGICO');
	    },
	    redistribuePraFase: function redistribuePraFase(fase) {
	      var valorTotalDaFase = this.calculaValorAtividadeporFase(fase);
	
	      var items = this.table.items.filter(function (item) {
	        return item.phase === fase;
	      });
	
	      if (items && items.length > 0) {
	        items.forEach(function (item) {
	          item.percentageByActivity = Number(1 / items.length).toPrecision(4);
	          item.valueByActivity = valorTotalDaFase / items.length;
	        });
	      }
	    },
	    loadCityAndState: function loadCityAndState() {
	      var _this2 = this;
	
	      if (this.cidade.cep) {
	        axios.get('proxy/project/city/within-zip-code-range/' + this.cidade.cep).then(function (response) {
	          _this2.cidade.name = response.data.value.name;
	          _this2.$forceUpdate();
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      } else {
	        this.cidade.name = '';
	        this.$forceUpdate();
	      }
	    },
	    edita: function edita(cidade) {
	      this.mostraGrid = false;
	      this.editando = true;
	      this.cidade = (0, _assign2.default)({}, cidade);
	      this.cidadeTabela = cidade;
	      this.calculaMaximo();
	      if (this.cidade.percentageByActivity) {
	        this.porcentagemAtividade = Number(this.cidade.percentageByActivity * 10000);
	      }
	      this.porcentagemParticipantes = Number(this.cidade.percentage * 10000);
	      this.dadosOriginais.fase = this.cidade.phase;
	      this.dadosOriginais.valor = this.cidade.valueByActivity;
	      this.valorPermitidoAtividade = this.calculaValorPermitidoAtividade();
	    },
	    exclui: function exclui(index) {
	      this.table.items.splice(index, 1);
	    },
	    onCancel: function onCancel() {
	      this.mostraGrid = !this.mostraGrid;
	      this.editando = false;
	      this.cidade = {};
	      this.totalParticipantsAdicionar = 0;
	      this.porcentagemParticipantes = 0;
	      this.porcentagemAtividade = 0;
	    },
	    onAdd: function onAdd() {
	      var _this3 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          if (_this3.editando === true) {
	            for (var i in _this3.cidade) {
	              _this3.cidadeTabela[i] = _this3.cidade[i];
	            }
	          } else {
	            _this3.table.items.push(_this3.cidade);
	          }
	
	          _this3.onCancel();
	        }
	      });
	    },
	    calculaMaximo: function calculaMaximo() {
	      this.totalParticipantsAdicionar = 0;
	      if (this.cidade.totalParticipants > 0) {
	        this.totalParticipantsAdicionar = this.totalParticipantes - Number(this.totalParticipantesMunicipios) + this.cidade.totalParticipants;
	      } else {
	        this.totalParticipantsAdicionar = Number(this.totalParticipantes) - Number(this.totalParticipantesMunicipios);
	        this.$forceUpdate();
	      }
	    },
	    onChangeTotalParticipants: function onChangeTotalParticipants() {
	      if (this.cidade.totalParticipants > 0) {
	        var totalParticipoantesPorcentagem = (this.cidade.totalParticipants / this.totalParticipantes * 100).toFixed(2);
	        this.porcentagemParticipantes = totalParticipoantesPorcentagem;
	      }
	    },
	    ajustaQuantidadeParticipantes: function ajustaQuantidadeParticipantes() {
	      if (this.porcentagemParticipantes > 0 && this.porcentagemParticipantes < 10001) {
	        var totalParticipants = Math.round(this.totalParticipantes * (this.porcentagemParticipantes / 10000));
	        this.cidade.totalParticipants = parseInt(totalParticipants);
	      }
	    },
	    ajustaValorAtividades: function ajustaValorAtividades() {
	      if (this.porcentagemAtividade > 0 && this.porcentagemAtividade < 10001) {
	        var valorAtividades = Math.round(this.calculaValorPermitidoAtividade() * (this.porcentagemAtividade / 10000));
	        this.cidade.valueByActivity = parseInt(valorAtividades);
	      }
	    },
	    calculaValorAtividade: function calculaValorAtividade() {
	      var _this4 = this;
	
	      var total = 0;
	      if (this.proposta.objectives.length > 0) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividade.items.forEach(function (item) {
	                    if (item.resourceSource === _this4.cidade.phase) {
	                      total += item.totalValue;
	                    }
	                  });
	                });
	              }
	            });
	          }
	        });
	      }
	      return total;
	    },
	    calculaValorAtividadeporFase: function calculaValorAtividadeporFase(fase) {
	      var total = 0;
	      if (this.proposta.objectives.length > 0) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividade.items.forEach(function (item) {
	                    if (item.resourceSource === fase) {
	                      total += item.totalValue;
	                    }
	                  });
	                });
	              }
	            });
	          }
	        });
	      }
	      return total;
	    },
	    calculaValorPermitidoAtividade: function calculaValorPermitidoAtividade() {
	      var _this5 = this;
	
	      var valorAtividadeTotal = this.calculaValorAtividade();
	      var items = this.table.items.filter(function (item) {
	        return item.phase === _this5.cidade.phase;
	      });
	      var totalAtividadeJaAlocado = items.reduce(function (acumulador, objeto) {
	        return acumulador + objeto.valueByActivity;
	      }, 0);
	      if (this.cidade.phase === this.dadosOriginais.fase) {
	        return valorAtividadeTotal - totalAtividadeJaAlocado + this.dadosOriginais.valor;
	      } else {
	        return valorAtividadeTotal - totalAtividadeJaAlocado;
	      }
	    },
	    calculaValorPermitidoAtividadeporFase: function calculaValorPermitidoAtividadeporFase(fase) {
	      var valorAtividadeTotal = this.calculaValorAtividadeporFase(fase);
	      var items = this.table.items.filter(function (item) {
	        return item.phase === fase;
	      });
	      var totalAtividadeJaAlocado = items.reduce(function (acumulador, objeto) {
	        return acumulador + objeto.valueByActivity;
	      }, 0);
	      return valorAtividadeTotal - totalAtividadeJaAlocado;
	    }
	  }
	};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'novosMunicipios',
	  data: function data() {
	    return {
	      consultaMunicipios: [],
	      novosMunicipios: []
	    };
	  },
	
	  props: ['municipalizacao'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    municipalizacao: function municipalizacao() {
	      this.buscaNovosMunicipios();
	    }
	  },
	  mounted: function mounted() {
	    this.buscaNovosMunicipios();
	  },
	  methods: {
	    buscaNovosMunicipios: function buscaNovosMunicipios() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(_this.municipalizacao.length <= 0)) {
	                  _context.next = 2;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 2:
	                obj = {
	                  municipalizacao: _this.municipalizacao
	                };
	                _context.next = 5;
	                return axiosLaravel.post('municipalizacao/buscaMunicipiosLista', obj).then(function (response) {
	                  _this.consultaMunicipios = response.data;
	                  _this.verificaSeExistemNovos();
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    verificaSeExistemNovos: function verificaSeExistemNovos() {
	      var _this2 = this;
	
	      if (this.consultaMunicipios.length > 0) {
	        this.novosMunicipios = [];
	        this.consultaMunicipios.forEach(function (municipio) {
	          if (municipio.novo) {
	            _this2.novosMunicipios.push(municipio);
	          }
	        });
	      } else {
	        this.novosMunicipios = [];
	      }
	    }
	  }
	};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'objetivoEspecifico',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsObjetivos
	      },
	      contador: 0,
	      objetivos: {
	        id: '',
	        ds_descricao: ''
	      },
	      objetivosTable: [],
	      editandoIndex: null,
	      formEditavel: false
	    };
	  },
	
	  props: ['propsObjetivos', 'propsProposta', 'somenteLeitura', 'editavel'],
	  watch: {
	    propsObjetivos: function propsObjetivos() {
	      this.table.items = this.propsObjetivos;
	    },
	    'table.items': function tableItems() {
	      this.$emit('objetivoAdicionado', this.table.items);
	    }
	  },
	  mounted: function mounted() {
	    this.formEditavel = !_.has(this.$route.params, 'numero') && this.editavel === true;
	  },
	  methods: {
	    onCancel: function onCancel() {
	      this.objetivos = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	    },
	    onAdd: function onAdd() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_.find(_this.table.items, ['ds_descricao', _this.objetivos.ds_descricao])) {
	            _this.$dialog.alert('Já existe um objetivo com essa descrição', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	          } else {
	            if (_this.editandoIndex !== null) {
	              for (var i in _this.objetivos) {
	                _this.objetivosTable[i] = _this.objetivos[i];
	              }
	            } else {
	              _this.contador = _this.contador + 1;
	              _this.objetivos.id = _.cloneDeep(_this.contador + _this.objetivos.ds_descricao);
	              _this.table.items.push(_this.objetivos);
	            }
	            _this.onCancel();
	          }
	        }
	      });
	    },
	    exclui: function exclui(item, index) {
	      var vm = this;
	      this.$dialog.confirm('Deseja <b>APAGAR</b> o objetivo:<br/>' + item.ds_descricao + '?', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        var qtdMetas = _.chain(vm.propsProposta.metas).map('objetivos').flatten().filter({ ds_descricao: item.ds_descricao }).value().length;
	        if (qtdMetas > 0) {
	          vm.$dialog.alert('Deve apagar <b>' + qtdMetas + ' metas</b> vinculadas a este objetivo primeiro', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	        } else {
	          vm.table.items.splice(index, 1);
	        }
	        vm.$forceUpdate();
	      }).catch(function () {
	        console.log('Aviso de Confirmações fechado SEM confirmar exclusão de objetivo');
	      });
	    },
	    edita: function edita(item, index) {
	      this.editandoIndex = index;
	      this.objetivos = (0, _assign2.default)({}, item);
	      this.objetivosTable = item;
	      this.showgrid = false;
	    }
	  }
	};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'objetivoEspecificoOld',
	  data: function data() {
	    return {
	      showgrid: true,
	      table: {
	        items: this.propsObjetivos
	      },
	      objective: {},
	      objectiveTable: {},
	      formasContratacao: [],
	      editandoIndex: null
	    };
	  },
	
	  props: ['propsObjetivos'],
	  watch: {
	    propsObjetivos: function propsObjetivos() {
	      this.table.items = this.propsObjetivos;
	    },
	    'table.items': function tableItems() {
	      this.$emit('objetivoAdicionado', this.table.items);
	    }
	  },
	  mounted: function mounted() {},
	  methods: {
	    onCancel: function onCancel() {
	      this.objective = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	    },
	    onAdd: function onAdd() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this.editandoIndex !== null) {
	            for (var i in _this.objective) {
	              _this.objectiveTable[i] = _this.objective[i];
	            }
	          } else {
	            _this.table.items.push(_this.objective);
	          }
	          _this.onCancel();
	        }
	      });
	    },
	    exclui: function exclui(item, index) {
	      if (item.goals && item.goals.length > 0) {
	        this.$snotify.error('Objetivo não pode se excluido pois possui metas vinculadas');
	        return;
	      }
	      this.table.items.splice(index, 1);
	    },
	    edita: function edita(item, index) {
	      this.editandoIndex = index;
	      this.objective = (0, _assign2.default)({}, item);
	      this.objectiveTable = item;
	      this.showgrid = false;
	    }
	  }
	};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(109);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'odsFundacao',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      odsCadastrado: [],
	      odsFavoritos: [],
	      baseODS: [],
	      editando: false,
	      termoPesquisa: '',
	      table: {
	        items: this.odsCadastrado,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'idOds', label: 'ID', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'ODS', label: 'ODS', sortable: true, thStyle: 'text-align: left; width: 50%', class: 'text-center' }, { key: 'metas', label: 'Metas', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {
	    this.buscarBaseODS();
	  },
	  methods: {
	    buscarBaseODS: function buscarBaseODS() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.loading.show = true;
	                _context.next = 3;
	                return axiosLaravel.get('/ods').then(function (response) {
	                  _this.baseODS = response.data;
	                  _this.baseODS.forEach(function (item) {
	                    item.abrirMeta = false;
	                    item.metas.forEach(function (meta) {
	                      meta.abrirIndicador = false;
	                      meta.selecionado = false;
	                    });
	                  });
	
	                  _this.buscarFavoritos();
	                  console.log(_this.baseODS);
	                }).catch(function (error) {
	                  _this.loading.show = false;
	                  _this.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    buscarFavoritos: function buscarFavoritos() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.loading.show = true;
	                _context2.next = 3;
	                return axiosLaravel.get('/ods/getFavoritosFundacao').then(function (response) {
	                  console.log('Favoritos Fundação!', response.data);
	                  _this2.odsFavoritos = response.data;
	                  console.log(_this2.odsFavoritos);
	                  _this2.initFavoritos();
	                }).catch(function (error) {
	                  _this2.loading.show = false;
	                  _this2.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    getImageODS: function getImageODS(id) {
	      var caminho = '/static/img/ods/' + id + '.png';
	      return caminho;
	    },
	    toggleMeta: function toggleMeta(id) {
	      this.baseODS.forEach(function (item) {
	        if (item.id === id) {
	          item.abrirMeta = !item.abrirMeta;
	        }
	      });
	      this.$forceUpdate();
	    },
	    toggleIndicador: function toggleIndicador(idOds, idMeta) {
	      this.baseODS.forEach(function (ods) {
	        if (ods.id === idOds) {
	          ods.metas.forEach(function (meta) {
	            if (meta.id === idMeta) {
	              meta.abrirIndicador = !meta.abrirIndicador;
	            }
	          });
	        }
	      });
	      this.$forceUpdate();
	    },
	    salvarODS: function salvarODS() {
	      var _this3 = this;
	
	      console.log(this.baseODS);
	
	      var selecionados = [];
	      this.baseODS.forEach(function (ods) {
	        ods.metas.forEach(function (meta) {
	          if (meta.selecionado) {
	            var selecao = {
	              odsId: ods.id,
	              odsDescricao: ods.descricao,
	
	              metaId: meta.id,
	              metaDescricao: meta.descricao,
	              numero_meta: meta.numero_meta
	            };
	            selecionados.push(selecao);
	          }
	        });
	      });
	      console.log(selecionados);
	
	      this.atualizaSelecaoOds(selecionados);
	      this.editando = false;
	      this.loading.show = true;
	      var selecaoODS = [];
	      selecionados.forEach(function (selecao) {
	        selecaoODS.push(selecao.numero_meta);
	      });
	
	      axiosLaravel.post('/ods/marcarFavoritosFundacao', selecaoODS).then(function (response) {
	        _this3.$snotify.success(response.data);
	        _this3.loading.show = false;
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.loading.show = false;
	        _this3.$forceUpdate();
	      });
	    },
	    atualizaSelecaoOds: function atualizaSelecaoOds(selecao) {
	      var odsItems = [];
	      var odsDistintos = [].concat((0, _toConsumableArray3.default)(new _set2.default(selecao.map(function (item) {
	        return item.odsId;
	      }))));
	      console.log('AGRUPADOS: ', odsDistintos);
	      odsDistintos.forEach(function (idOds) {
	        var itemODS = {
	          idOds: idOds,
	          ODS: '',
	          metas: ''
	        };
	        selecao.forEach(function (item) {
	          if (item.odsId === idOds) {
	            itemODS.ODS = idOds + ' - ' + item.odsDescricao;
	            itemODS.metas = itemODS.metas + ',' + item.numero_meta;
	          }
	        });
	        itemODS.metas = itemODS.metas.substring(1);
	
	        odsItems.push(itemODS);
	      });
	      console.log(odsItems);
	      this.odsCadastrado = odsItems;
	      this.table.items = this.odsCadastrado;
	      this.$forceUpdate();
	    },
	    initFavoritos: function initFavoritos() {
	      console.log('init favoritos');
	      var metasFavoritas = this.odsFavoritos;
	      var odsItems = [];
	      this.baseODS.forEach(function (ods) {
	        var itemODS = {
	          idOds: ods.id,
	          ODS: ods.id + ' | ' + ods.descricao,
	          metas: ''
	        };
	        var metas = '';
	        metasFavoritas.forEach(function (meta) {
	          if (meta.ods_fk === ods.id) {
	            metas = metas + ',' + meta.numero_meta;
	          }
	        });
	        metas = metas.substring(1);
	        itemODS.metas = metas;
	        if (metas !== '') {
	          odsItems.push(itemODS);
	        }
	      });
	
	      this.odsCadastrado = odsItems;
	      this.table.items = this.odsCadastrado;
	      this.initSelecionadosFavoritos();
	      this.$forceUpdate();
	      this.loading.show = false;
	    },
	    initSelecionadosFavoritos: function initSelecionadosFavoritos() {
	      var _this4 = this;
	
	      console.log('init selecionados');
	      this.baseODS.forEach(function (ods) {
	        ods.metas.forEach(function (meta) {
	          var numeroMeta = meta.numero_meta;
	          _this4.odsCadastrado.forEach(function (odsCadastrado) {
	            if (odsCadastrado.idOds === ods.id) {
	              var metas = odsCadastrado.metas.split(',');
	
	              var foundElem = _.findKey(metas, function (meta) {
	                return meta === numeroMeta;
	              });
	              if (foundElem) {
	                meta.selecionado = true;
	              }
	            }
	          });
	        });
	      });
	      this.$forceUpdate();
	    }
	  }
	};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _odsCadastro = __webpack_require__(520);
	
	var _odsCadastro2 = _interopRequireDefault(_odsCadastro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'odsFundacao',
	  components: {
	    odsCadastro: _odsCadastro2.default
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {
	    console.log('ODS!');
	  },
	  methods: {}
	};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(109);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _odsCadastro = __webpack_require__(520);
	
	var _odsCadastro2 = _interopRequireDefault(_odsCadastro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'odsFundacao',
	  components: {
	    odsCadastro: _odsCadastro2.default
	  },
	  data: function data() {
	    return {
	      mostrarTodos: false,
	      detalhamento: false,
	      itemDetalhamento: {
	        idOds: '',
	        ods: 'ODS',
	        metas: []
	      },
	      loading: {
	        show: false
	      },
	      editando: false,
	      baseODS: [{
	        ods: '1 - Número da ODS / Descrição',
	        metas: [{ numeroMeta: '1.1', descricao: '1.a Garantir uma mobilização significativa de recursos a partir de uma variedade de fontes, inclusive por meio do reforço da cooperação para o desenvolvimento, para proporcionar meios adequados e previsíveis para que os países em desenvolvimento, em particular os países menos desenvolvidos, implementem programas e políticas para acabar com a pobreza em todas as suas dimensões', odsFk: '1' }, { numeroMeta: '2.1', descricao: '2.a Aumentar o investimento, inclusive via o reforço da cooperação internacional, em infraestrutura rural, pesquisa e extensão de serviços agrícolas, desenvolvimento de tecnologia, e os bancos de genes de plantas e animais, para aumentar a capacidade de produção agrícola nos países em desenvolvimento, em particular nos países menos desenvolvidos', odsFk: '2' }]
	      }, {
	        ods: '2 - Número da ODS / Descrição',
	        metas: [{ numeroMeta: '1.1', descricao: '3.7 Até 2030, assegurar o acesso universal aos serviços de saúde sexual e reprodutiva, incluindo o planejamento familiar, informação e educação, bem como a integração da saúde reprodutiva em estratégias e programas nacionais', odsFk: '1' }, { numeroMeta: '2.1', descricao: '8.5 Até 2030, alcançar o emprego pleno e produtivo e trabalho decente para todas as mulheres e homens, inclusive para os jovens e as pessoas com deficiência, e remuneração igual para trabalho de igual valor', odsFk: '2' }]
	      }],
	      odsTodaBase: [],
	      odsFavoritos: [],
	      odsCadastrado: [],
	      odsSelecionado: [],
	      backupSelecionado: [],
	      table: {
	        items: this.odsCadastrado,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'idOds', label: 'ID', sortable: true, thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'descricao', label: 'ODS', sortable: true, thStyle: 'text-align: left; width: 50%', class: 'text-center' }, { key: 'metas', label: 'Metas', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'width: 10%; text-align: center;', sortable: false, 'class': 'text-center' }]
	      }
	    };
	  },
	
	  props: ['proposta', 'telaProjeto'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    proposta: function proposta() {}
	  },
	  mounted: function mounted() {
	    this.buscarBaseODSFavoritos();
	    this.buscarBaseODS();
	  },
	  methods: {
	    buscarBaseODS: function buscarBaseODS() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.loading.show = true;
	                _context.next = 3;
	                return axiosLaravel.get('/ods').then(function (response) {
	                  _this.initListaODS(response.data, false);
	                  _this.buscarODSCadastro();
	
	                  _this.$forceUpdate();
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    buscarODSCadastro: function buscarODSCadastro() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('NUMERO PROPOSTA', _this2.proposta);
	                _this2.odsCadastrado = [];
	                _this2.loading.show = true;
	                _context2.next = 5;
	                return axiosLaravel.get('/ods/getMetasODS/' + _this2.proposta).then(function (response) {
	                  var cadastro = response.data;
	                  console.log(cadastro);
	                  _this2.loading.show = true;
	                  if (cadastro.length > 0) {
	                    var idsODs = [].concat((0, _toConsumableArray3.default)(new _set2.default(cadastro.map(function (item) {
	                      return item.ods_fk;
	                    }))));
	                    console.log(idsODs);
	                    idsODs.forEach(function (id) {
	                      var ods = {
	                        idOds: id,
	                        descricao: '',
	                        metas: ''
	                      };
	                      _this2.odsTodaBase.forEach(function (item) {
	                        if (item.odsId === Number(id)) {
	                          ods.descricao = item.ods;
	                        }
	                      });
	                      cadastro.forEach(function (selecionado) {
	                        if (selecionado.ods_fk === id) {
	                          ods.metas = ods.metas + ', ' + selecionado.numero_meta;
	                        }
	                      });
	                      ods.metas = ods.metas.substring(1);
	                      _this2.odsCadastrado.push(ods);
	                    });
	                    _this2.table.items = _this2.odsCadastrado;
	                    _this2.$forceUpdate();
	                    _this2.loading.show = true;
	                    _this2.odsCadastrado.forEach(function (ods) {
	                      var metas = ods.metas.split(', ');
	                      metas.forEach(function (meta) {
	                        var selecionado = {
	                          descricao: '',
	                          numeroMeta: '',
	                          odsFk: ods.idOds
	                        };
	                        selecionado.numeroMeta = meta.trim();
	                        _this2.odsTodaBase.forEach(function (ods) {
	                          ods.metas.forEach(function (meta) {
	                            if (meta.numeroMeta === selecionado.numeroMeta) {
	                              selecionado.descricao = meta.descricao;
	                            }
	                          });
	                        });
	                        _this2.odsSelecionado.push(selecionado);
	                      });
	                    });
	                  } else {
	                    _this2.odsCadastrado = [];
	                  }
	                  _this2.loading.show = false;
	                  _this2.$forceUpdate();
	                }).catch(function (error) {
	                  _this2.loading.show = false;
	                  _this2.$root.trataErro(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    buscarBaseODSFavoritos: function buscarBaseODSFavoritos() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this3.loading.show = true;
	                _context3.next = 3;
	                return axiosLaravel.get('/ods/indexFavoritos').then(function (response) {
	                  _this3.initListaODS(response.data, true);
	
	                  _this3.$forceUpdate();
	                }).catch(function (error) {
	                  _this3.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    salvarODS: function salvarODS() {
	      var _this4 = this;
	
	      this.odsCadastrado = [];
	      this.table.items = this.odsCadastrado;
	      var obj = {
	        proposta: this.proposta,
	        metasOds: this.odsSelecionado
	      };
	      this.odsCadastrado = [];
	      if (this.odsSelecionado.length > 0) {
	        this.odsSelecionado.forEach(function (item) {
	          item.odsFk = Number(item.odsFk);
	        });
	        var idsODs = [].concat((0, _toConsumableArray3.default)(new _set2.default(this.odsSelecionado.map(function (item) {
	          return item.odsFk;
	        }))));
	
	        idsODs.forEach(function (id) {
	          var ods = {
	            idOds: id,
	            descricao: '',
	            metas: ''
	          };
	          _this4.odsTodaBase.forEach(function (item) {
	            if (Number(item.odsId) === Number(id)) {
	              ods.descricao = item.ods;
	            }
	          });
	          _this4.odsSelecionado.forEach(function (selecionado) {
	            if (selecionado.odsFk === id) {
	              ods.metas = ods.metas + ', ' + selecionado.numeroMeta;
	            }
	          });
	          ods.metas = ods.metas.substring(1);
	          _this4.odsCadastrado.push(ods);
	        });
	        this.table.items = this.odsCadastrado;
	        this.$forceUpdate();
	      } else {
	        this.odsCadastrado = [];
	      }
	      this.$forceUpdate();
	      this.loading.show = true;
	      axiosLaravel.post('/ods/vincular', obj).then(function (response) {
	        _this4.$snotify.success(response.data.message);
	        _this4.editando = false;
	        _this4.loading.show = false;
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.loading.show = false;
	        _this4.$root.trataErro(error);
	      });
	    },
	    initListaODS: function initListaODS(lista, favoritos) {
	      var _this5 = this;
	
	      var ods = lista;
	      ods.forEach(function (itemODS) {
	        var odsItem = {
	          odsId: itemODS.id,
	          ods: itemODS.id + ' | ' + itemODS.descricao,
	          metas: []
	        };
	        itemODS.metas.forEach(function (meta) {
	          var metaItem = {
	            numeroMeta: meta.numero_meta,
	            descricao: meta.descricao,
	            odsFk: meta.ods_fk
	          };
	          odsItem.metas.push(metaItem);
	        });
	        if (!favoritos) {
	          _this5.odsTodaBase.push(odsItem);
	        } else {
	          _this5.odsFavoritos.push(odsItem);
	        }
	        _this5.$forceUpdate();
	      });
	      if (this.mostrarTodos) {
	        this.baseODS = this.odsTodaBase;
	      } else {
	        this.baseODS = this.odsFavoritos;
	      }
	    },
	    mudarVisualizacao: function mudarVisualizacao() {
	      this.mostrarTodos = !this.mostrarTodos;
	      if (this.mostrarTodos) {
	        this.baseODS = this.odsTodaBase;
	      } else {
	        this.baseODS = this.odsFavoritos;
	      }
	    },
	    getImageODS: function getImageODS(id) {
	      var caminho = '/static/img/ods/' + id + '.png';
	      return caminho;
	    },
	    customLabel: function customLabel(option) {
	      return option.numeroMeta + ' | ' + option.descricao;
	    },
	    customTag: function customTag(values) {
	      var tags = '';
	      if (values.length > 0) {
	        values.forEach(function (value) {
	          tags = tags + ' ' + '<span class="ods-items-selecao"> ODS: <b>' + value.odsFk + '</b> Meta: <b>' + value.numeroMeta + '</b></span>';
	        });
	        tags = tags.substring(1);
	      }
	      return tags;
	    },
	    abrirEdicao: function abrirEdicao() {
	      this.editando = true;
	      this.backupSelecionado = this.odsSelecionado;
	    },
	    cancelarEdicao: function cancelarEdicao() {
	      this.editando = false;
	      this.odsSelecionado = this.backupSelecionado;
	    },
	    detalharLinha: function detalharLinha(row) {
	      var _this6 = this;
	
	      this.detalhamento = true;
	      this.itemDetalhamento.idOds = row.idOds;
	      this.itemDetalhamento.ods = row.descricao;
	      var metas = row.metas.split(',');
	      var metasDescricao = [];
	      metas.forEach(function (metaDesc) {
	        _this6.odsTodaBase.forEach(function (item) {
	          if (row.odsId === item.idOds) {
	            item.metas.forEach(function (meta) {
	              if (Number(meta.numeroMeta === metaDesc.trim())) {
	                var desc = meta.descricao;
	                metasDescricao.push(desc);
	              }
	            });
	          }
	        });
	      });
	
	      this.itemDetalhamento.metas = metasDescricao;
	    }
	  }
	};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'parcela-adiantamento',
	  data: function data() {
	    return {
	      loading: false,
	      showgrid: true,
	      parcelaAdiantameto: [],
	      totais: {
	        projeto: {
	          fbb: 0,
	          parceiros: 0,
	          misto: 0,
	          total: 0
	        },
	        distribuidos: {
	          fbb: 0,
	          parceiros: 0,
	          misto: 0,
	          total: 0
	        },
	
	        distribuidosEditaveis: {
	          fbb: 0,
	          parceiros: 0,
	          misto: 0,
	          total: 0
	        },
	
	        saldoDisponivel: {
	          fbb: 0,
	          parceiros: 0,
	          misto: 0,
	          total: 0
	        },
	        restantes: {
	          fbb: 0,
	          parceiros: 0,
	          misto: 0,
	          total: 0
	        },
	        residuo: {
	          fbb: 0,
	          parceiros: 0,
	          misto: 0,
	          total: 0
	        }
	      },
	      existeFaseFBB: 0,
	      existeFaseParc: 0,
	      table: {
	        items: this.propsParcelas,
	        filter: null,
	        hover: true,
	        bordered: true,
	        existe: false,
	        currentPage: 1,
	        totalRows: 0,
	        sortBy: 'parcela',
	        sortDesc: false,
	        perPage: 100,
	        fields: [{ key: 'parcela', label: 'Parcela', sortable: false, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'origem', label: 'Origem', sortable: false, thStyle: 'text-align: center;width: 15%', class: 'text-center' }, { key: 'valor_fbb', label: 'Fundação BB (Fase 1)', sortable: false, thStyle: 'text-align: center;width: 14%', class: 'text-center' }, { key: 'valor_parc', label: 'Parceiro Estratégico (Fase 5)', sortable: false, thStyle: 'text-align: center;width: 17%', class: 'text-center' }, { key: 'valor', label: 'Valor Adiantável', sortable: false, thStyle: 'text-align: center;width: 17%', class: 'text-center' }, { key: 'requisitado', label: 'Valor Requisitado', sortable: false, thStyle: 'text-align: center;width: 14%', class: 'text-center' }, { key: 'percentual_comprovado', label: '% Comprov.', sortable: false, thStyle: 'text-align: center;width: 8%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 20%', class: 'text-center' }]
	      },
	      parcela: {},
	      parcelaTabela: {},
	      adiantamentosConcedidos: [],
	      percentualMaximoSobreResiduos: 0.25,
	      editandoIndex: null,
	      formEditavel: false,
	
	      suprimirEmissao: false
	    };
	  },
	
	  props: ['propsParcelas', 'editavel', 'propsAtividades', 'propsProposta', 'propsLayout', 'propsPropostaBackup', 'modoVisualizacaoAlteracoes', 'atualizar', 'processoSolicitacao', 'alteracaoProjeto'],
	  watch: {
	    atualizar: function atualizar() {
	      this.calcularTotais();
	    },
	    propsParcelas: function propsParcelas() {
	      var _this = this;
	
	      this.suprimirEmissao = true;
	      var parc = _.filter(this.propsParcelas, function (value) {
	        return value !== null;
	      });
	      this.table.items = _.cloneDeep(this.consolidarParcelasAdiantamento(parc));
	      this.table.totalRows = this.table.items.length;
	
	      this.aplicarAdiantamentosConcedidosEmTableItems();
	
	      if (this.propsLayout == 'EXECUCAO' && (!this.adiantamentosConcedidos || !this.adiantamentosConcedidos.length)) {
	        this.buscaAdiantamentosConcedidos();
	        this.$nextTick(function () {
	          _this.suprimirEmissao = false;
	        });
	        return;
	      }
	      this.calcularTotais();
	      this.$nextTick(function () {
	        _this.suprimirEmissao = false;
	      });
	    },
	    editavel: function editavel() {
	      this.formEditavel = this.editavel;
	    },
	    'table.items': function tableItems() {
	      if (this.suprimirEmissao) return;
	
	      this.$emit('parcelaAdicionada', this.expandirParcelasAdiantamento(this.table.items));
	    },
	    'parcela.valor_fbb': function parcelaValor_fbb() {
	      if ('' + this.parcela.origem === '0') {
	        this.parcela.valor = (+this.parcela.valor_fbb || 0) + (+this.parcela.valor_parc || 0);
	      }
	    },
	    'parcela.valor_parc': function parcelaValor_parc() {
	      if ('' + this.parcela.origem === '0') {
	        this.parcela.valor = (+this.parcela.valor_fbb || 0) + (+this.parcela.valor_parc || 0);
	      }
	    },
	
	    showgrid: function showgrid() {
	      if (this.existeFaseFBB > 0 && this.existeFaseParc === 0) {
	        this.parcela.origem = 1;
	      } else if (this.existeFaseFBB === 0 && this.existeFaseParc > 0) {
	        this.parcela.origem = 5;
	      }
	      this.$emit('validacaoParcelasAdiantamento', { 'tag': 'parcelasEditando', 'ativo': !this.showgrid, 'tipo': 'restricao', 'acao': null, 'mensagem': '<span class=\'restricaoEditandoInformacao\'>Parcela de Adiantamento em edição<span>' });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {
	    var bc = new BroadcastChannel('propostas');
	    var vm = this;
	    bc.onmessage = function (e) {
	      var mensagem = e.data;
	      if ('' + mensagem.id === '' + vm.$route.params.id) {
	        if (mensagem.acao === 'notificacaoAtualizacaoCronograma') {
	          vm.calcularTotais();
	        } else {}
	      }
	    };
	    this.calcularTotais();
	  },
	
	  created: function created() {
	    var parc = _.filter(this.propsParcelas, function (value) {
	      return value !== null;
	    });
	    this.table.items = _.cloneDeep(this.consolidarParcelasAdiantamento(parc));
	    if (this.propsLayout != 'EXECUCAO') {
	      this.table.fields = _.filter(this.table.fields, function (f) {
	        return f.key !== 'requisitado' && f.key !== 'percentual_comprovado';
	      });
	    }
	
	    if (this.propsLayout == 'EXECUCAO') {
	      this.buscaAdiantamentosConcedidos();
	    }
	    this.formEditavel = this.editavel;
	  },
	  methods: {
	    toNumberSafe: function toNumberSafe(valor) {
	      if (_.isNil(valor) || valor === '') return 0;
	      if (_.isNumber(valor)) return valor;
	      if (_.isString(valor)) {
	        return _.toNumber(valor.replace(/\./g, '').replace(',', '.'));
	      }
	      return _.toNumber(valor) || 0;
	    },
	    somarCampoParcelas: function somarCampoParcelas(campo) {
	      var _this2 = this;
	
	      var centavos = (this.table.items || []).reduce(function (total, parc) {
	        return total + _this2.toCentavos(_this2.toNumberSafe(_.get(parc, campo, 0)));
	      }, 0);
	      return this.fromCentavos(centavos);
	    },
	    obterValorFundacaoParcela: function obterValorFundacaoParcela(parc) {
	      var origem = '' + parc.origem;
	
	      if (origem === '1') {
	        return this.toNumberSafe(parc.valor);
	      }
	
	      if (origem === '0') {
	        return this.toNumberSafe(_.get(parc, 'valor_fundacao', _.get(parc, 'valorFundacao', _.get(parc, 'fase1', _.get(parc, 'valor_fase_1', 0)))));
	      }
	      return 0;
	    },
	    obterValorParceiroParcela: function obterValorParceiroParcela(parc) {
	      var origem = '' + parc.origem;
	
	      if (origem === '5') {
	        return this.toNumberSafe(parc.valor);
	      }
	
	      if (origem === '0') {
	        return this.toNumberSafe(_.get(parc, 'valor_parceiro', _.get(parc, 'valorParceiro', _.get(parc, 'fase5', _.get(parc, 'valor_fase_5', 0)))));
	      }
	      return 0;
	    },
	    valorProjetoOrigem: function valorProjetoOrigem(fase, texto) {
	      var vm = this;
	      var valorTotal = _.sumBy(vm.propsAtividades, function (atv) {
	        var valorOrc = _.has(atv, 'itens_orcamentos') && atv.itens_orcamentos.length > 0 ? _.sumBy(atv.itens_orcamentos, function (item) {
	          var itemDesp = _.has(item, 'origem') && ('' + item.origem === '' + fase || item.origem === texto) && ('' + item.adiantavel === '1' || item.adiantavel === true) ? _.has(item, 'valorOrcado') ? vm.truncarValor(item.valorOrcado > 0 ? item.valorOrcado + (!_.includes(item.id, 'novo') ? _.toNumber(_.get(item, 'valorAlteracao', 0)) : 0) : item.valorOrcado + _.toNumber(_.get(item, 'valorAlteracao', 0))) : _.has(item, 'valor_unitario') && _.has(item, 'quantidade') && !_.isNil(item.valor_unitario) ? vm.truncarValor(parseFloat(item.valor_unitario) * parseFloat(item.quantidade)) : _.sumBy(item.orcamentos_mensalizados, function (mes) {
	            return _.has(mes, 'valor') ? vm.truncarValor(mes.valor) : 0;
	          }) + _.toNumber(_.get(item, 'valorAlteracao', 0)) : 0;
	          return itemDesp;
	        }) : 0;
	        return valorOrc;
	      });
	      return this.truncarRound(valorTotal);
	    },
	    calcularTotais: function calcularTotais() {
	      var _this3 = this;
	
	      console.log('ANTES calcularTotais table.items', JSON.parse((0, _stringify2.default)(this.table.items)));
	      this.totais.distribuidos.total = 0;
	      this.totais.distribuidos.fbb = 0;
	      this.totais.distribuidos.parceiros = 0;
	      this.totais.distribuidos.misto = 0;
	      this.totais.projeto.total = 0;
	      this.totais.projeto.fbb = 0;
	      this.totais.projeto.parceiros = 0;
	      this.totais.projeto.misto = 0;
	
	      this.totais.projeto.fbb = this.truncarValor(this.valorProjetoOrigem('1', 'FUNDACAO'));
	      this.totais.projeto.parceiros = this.truncarValor(this.valorProjetoOrigem('5', 'PARCEIRO_ESTRATEGICO'));
	      this.totais.projeto.misto = 0;
	      this.totais.projeto.total = this.truncarValor(this.totais.projeto.fbb + this.totais.projeto.parceiros);
	
	      this.totais.distribuidos.fbb = this.somarCampoParcelas('valor_fbb');
	      this.totais.distribuidos.parceiros = this.somarCampoParcelas('valor_parc');
	      this.totais.distribuidos.misto = 0;
	      this.totais.distribuidos.total = this.somarCampoParcelas('valor');
	
	      var editaveis = (this.table.items || []).filter(function (p) {
	        return !_.has(p, 'requisitado');
	      });
	      var somarEditaveis = function somarEditaveis(campo) {
	        return _this3.truncarValor(editaveis.reduce(function (t, p) {
	          return t + _this3.toNumberSafe(_.get(p, campo, 0));
	        }, 0));
	      };
	      this.totais.distribuidosEditaveis.fbb = somarEditaveis('valor_fbb');
	      this.totais.distribuidosEditaveis.parceiros = somarEditaveis('valor_parc');
	      this.totais.distribuidosEditaveis.misto = 0;
	      this.totais.distribuidosEditaveis.total = somarEditaveis('valor');
	
	      this.totais.saldoDisponivel.fbb = this.normalizarSaldoDisponivel(this.fromCentavos(this.toCentavos(this.totais.projeto.fbb) - this.toCentavos(this.totais.distribuidos.fbb)));
	      this.totais.saldoDisponivel.parceiros = this.normalizarSaldoDisponivel(this.fromCentavos(this.toCentavos(this.totais.projeto.parceiros) - this.toCentavos(this.totais.distribuidos.parceiros)));
	      this.totais.saldoDisponivel.misto = 0;
	      this.totais.saldoDisponivel.total = this.normalizarSaldoDisponivel(this.fromCentavos(this.toCentavos(this.totais.projeto.total) - this.toCentavos(this.totais.distribuidos.total)));
	
	      this.totais.restantes.fbb = this.truncarValor(this.totais.projeto.fbb - this.totais.distribuidosEditaveis.fbb);
	      this.totais.restantes.parceiros = this.truncarValor(this.totais.projeto.parceiros - this.totais.distribuidosEditaveis.parceiros);
	
	      this.totais.restantes.misto = this.truncarValor(this.totais.restantes.fbb + this.totais.restantes.parceiros);
	      this.totais.restantes.total = this.truncarValor(this.totais.projeto.total - this.totais.distribuidosEditaveis.total);
	
	      if (this.totais.residuo.total === 0) {
	        this.totais.residuo.fbb = this.truncarValor(_.sumBy(this.table.items, function (p) {
	          return p.valor - p.requisitado > 0 && '' + p.origem === '1' ? p.valor - p.requisitado : 0;
	        }) * this.percentualMaximoSobreResiduos);
	        this.totais.residuo.parceiros = this.truncarValor(_.sumBy(this.table.items, function (p) {
	          return p.valor - p.requisitado > 0 && '' + p.origem === '5' ? p.valor - p.requisitado : 0;
	        }) * this.percentualMaximoSobreResiduos);
	        this.totais.residuo.misto = 0;
	        this.totais.residuo.total = this.truncarValor(this.totais.residuo.fbb + this.totais.residuo.parceiros);
	      }
	      this.numerarParcelas();
	      this.verificaFase();
	
	      var totalProjeto = this.totais.projeto.total;
	      var totalDistribuido = this.totais.distribuidos.total;
	      if (totalProjeto !== totalDistribuido) {
	        var totalProjetoFloor = this.truncarValor2(this.totais.projeto.total);
	        var totalDistribuidoFloor = this.truncarValor2(this.totais.distribuidos.total);
	        if (totalProjetoFloor !== totalDistribuidoFloor) {
	          this.totais.projeto.total = this.truncarCeil(this.totais.projeto.total);
	          this.totais.distribuidos.total = this.truncarCeil(this.totais.distribuidos.total);
	        } else {
	          this.totais.projeto.total = this.truncarValor2(this.totais.projeto.total);
	          this.totais.distribuidos.total = this.truncarValor2(this.totais.distribuidos.total);
	        }
	      }
	
	      if (this.totais.projeto.fbb !== this.totais.distribuidos.fbb) {
	        var projFbbFloor = this.truncarValor2(this.totais.projeto.fbb);
	        var distFbbFloor = this.truncarValor2(this.totais.distribuidos.fbb);
	        if (projFbbFloor !== distFbbFloor) {
	          this.totais.projeto.fbb = this.truncarCeil(this.totais.projeto.fbb);
	          this.totais.distribuidos.fbb = this.truncarCeil(this.totais.distribuidos.fbb);
	        } else {
	          this.totais.projeto.fbb = this.truncarValor2(this.totais.projeto.fbb);
	          this.totais.distribuidos.fbb = this.truncarValor2(this.totais.distribuidos.fbb);
	        }
	      }
	      if (this.totais.projeto.parceiros !== this.totais.distribuidos.parceiros) {
	        var projParcFloor = this.truncarValor2(this.totais.projeto.parceiros);
	        var distParcFloor = this.truncarValor2(this.totais.distribuidos.parceiros);
	        if (projParcFloor !== distParcFloor) {
	          this.totais.projeto.parceiros = this.truncarCeil(this.totais.projeto.parceiros);
	          this.totais.distribuidos.parceiros = this.truncarCeil(this.totais.distribuidos.parceiros);
	        } else {
	          this.totais.projeto.parceiros = this.truncarValor2(this.totais.projeto.parceiros);
	          this.totais.distribuidos.parceiros = this.truncarValor2(this.totais.distribuidos.parceiros);
	        }
	      }
	      console.log('DEPOIS totais.distribuidos', JSON.parse((0, _stringify2.default)(this.totais.distribuidos)));
	
	      this.$emit('validacaoParcelasAdiantamento', {
	        tag: 'parcelasAdiantamentoZeradas',
	        ativo: this.table.items.length > 0 && _.filter(this.table.items, ['valor', 0]).length > 0,
	        tipo: 'restricao',
	        acao: null,
	        mensagem: 'Há <b>' + _.filter(this.table.items, ['valor', 0]).length + '</b> Parcela(s) de Adiantamento com valor <b>R$ 0,00</b> (zerada). Deve preencher ou eliminar.'
	      });
	
	      var legadas = _.filter(this.table.items, ['_legadoSemBreakdown', true]);
	      this.$emit('validacaoParcelasAdiantamento', {
	        tag: 'parcelasAdiantamentoSemBreakdown',
	        ativo: legadas.length > 0,
	        tipo: 'restricao',
	        acao: null,
	        mensagem: 'Há <b>' + legadas.length + '</b> Parcela(s) de Adiantamento Mista(s) sem os valores por origem (Fundação/Parceiro). Edite a(s) parcela(s) e informe os valores.'
	      });
	    },
	    truncarValor: function truncarValor(valor) {
	      return valor;
	    },
	    truncarValor2: function truncarValor2(valor) {
	      return Math.floor(valor * 100) / 100;
	    },
	    truncarCeil: function truncarCeil(valor) {
	      return Math.ceil(valor * 100) / 100;
	    },
	    truncarRound: function truncarRound(valor) {
	      return Math.round(valor * 100) / 100;
	    },
	    toCentavos: function toCentavos(valor) {
	      return Math.round((Number(valor) || 0) * 100);
	    },
	    fromCentavos: function fromCentavos(centavos) {
	      return centavos / 100;
	    },
	    normalizarMoeda: function normalizarMoeda(valor) {
	      var c = this.toCentavos(valor);
	      return Math.abs(c) <= 1 ? 0 : c / 100;
	    },
	    normalizarSaldoDisponivel: function normalizarSaldoDisponivel(valor) {
	      var centavos = this.toCentavos(valor);
	
	      if (Math.abs(centavos) <= 1) {
	        return 0;
	      }
	
	      if (centavos > 0 && Math.abs(centavos % 100) === 99) {
	        return (centavos + 1) / 100;
	      }
	      return centavos / 100;
	    },
	    numerarParcelas: function numerarParcelas() {
	      for (var i = 0; i < this.table.items.length; i++) {
	        _.set(this.table.items[i], 'parcela', i + 1);
	      }
	      this.$forceUpdate();
	    },
	    distribuirValores: function distribuirValores() {
	      var _this4 = this;
	
	      var vm = this;
	      var fases = ['1', '5'];
	      fases.forEach(function (fase) {
	        var quantidade = _.filter(_this4.table.items, function (i) {
	          return '' + i.origem === fase && !_.has(i, 'requisitado');
	        }).length;
	        var acum = 0;
	
	        var valorFixo = _.sumBy(_this4.table.items, function (f) {
	          if ('' + f.origem === fase && _.has(f, 'requisitado')) {
	            return vm.toNumberSafe(f.valor);
	          }
	          if ('' + f.origem === '0') {
	            return vm.toNumberSafe(_.get(f, fase === '1' ? 'valor_fbb' : 'valor_parc', 0));
	          }
	          return 0;
	        });
	        var total = (fase === '1' ? _this4.totais.projeto.fbb : fase === '5' ? _this4.totais.projeto.parceiros : 0) - valorFixo;
	        var parcela = Math.ceil(total / quantidade);
	        if (quantidade > 0 && total > 0) {
	          _this4.table.items.forEach(function (item) {
	            if ('' + item.origem === fase && !_.has(item, 'requisitado')) {
	              if (acum + parcela > total) {
	                var dif = acum + parcela - total;
	                item.valor = parcela - dif;
	              } else {
	                item.valor = parcela;
	              }
	              acum += item.valor;
	
	              _this4.normalizarParcelaSimples(item);
	            }
	          });
	        }
	      });
	      this.calcularTotais();
	      this.$emit('acaoAtualizaSolicitacoes', new Date());
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNaN(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    buscaAdiantamentosConcedidos: function buscaAdiantamentosConcedidos() {
	      var _this5 = this;
	
	      this.loading = true;
	      axiosLaravel.get('processos/adiantamento/recursos/' + this.propsProposta.id, { entityId: null }).then(function (response) {
	        _this5.adiantamentosConcedidos = response.data.adiantamentos_concedidos.row;
	        _this5.aplicarAdiantamentosConcedidosEmTableItems();
	        _this5.calcularTotais();
	        _this5.loading = false;
	        _this5.$forceUpdate();
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    aplicarAdiantamentosConcedidosEmTableItems: function aplicarAdiantamentosConcedidosEmTableItems() {
	      var _this6 = this;
	
	      if (!this.adiantamentosConcedidos || !this.adiantamentosConcedidos.length) return;
	      _.forEach(this.table.items, function (parcela) {
	        var ids = _.compact([_.get(parcela, 'id'), _.get(parcela, 'id_fbb'), _.get(parcela, 'id_parc')]);
	        if (!ids.length) return;
	        var concedidos = _.filter(_this6.adiantamentosConcedidos, function (c) {
	          return _.includes(ids, c.id_parcela_adiantamento);
	        });
	        if (!concedidos.length) return;
	
	        var requisitado = _.reduce(concedidos, function (acc, c) {
	          return acc + Math.round(_.toNumber(_.get(c, 'requisitado', 0)) * 100);
	        }, 0) / 100;
	        _.set(parcela, 'requisitado', requisitado);
	
	        var concedidoDaLinha = _.findLast(concedidos, function (c) {
	          return c.id_parcela_adiantamento === parcela.id;
	        });
	        if (concedidoDaLinha) {
	          _.set(parcela, 'percentual_comprovado', concedidoDaLinha.percentual_comprovado);
	        }
	      });
	    },
	    verificaFase: function verificaFase() {
	      var _this7 = this;
	
	      this.existeFaseFBB = 0;
	      this.existeFaseParc = 0;
	
	      var ehAdiantavel = function ehAdiantavel(it) {
	        return '' + it.adiantavel === '1' || it.adiantavel === true;
	      };
	      if (!_.isUndefined(this.propsAtividades)) {
	        this.propsAtividades.forEach(function (atividade) {
	          if (atividade.itens_orcamentos) {
	            atividade.itens_orcamentos.forEach(function (item) {
	              if (item && ehAdiantavel(item)) {
	                if ('' + item.origem === '1' || item.origem === 'FUNDACAO') {
	                  _this7.existeFaseFBB++;
	                }
	                if ('' + item.origem === '5' || item.origem === 'PARCEIRO_ESTRATEGICO') {
	                  _this7.existeFaseParc++;
	                }
	              }
	            });
	          }
	        });
	      }
	      this.$forceUpdate();
	    },
	    onCancel: function onCancel() {
	      this.parcela = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	      this.calcularTotais();
	    },
	    onAdd: function onAdd() {
	      var _this8 = this;
	
	      var origemAtual = '' + _.get(this.parcela, 'origem');
	      if (!_.includes(['0', '1', '5'], origemAtual)) {
	        this.$snotify.error('Selecione uma Origem (Fundação, Parceiro Estratégico ou Parcela Mista) antes de salvar a parcela.');
	        return;
	      }
	
	      if (origemAtual === '0' && (+this.parcela.valor_fbb || 0) + (+this.parcela.valor_parc || 0) <= 0) {
	        this.$snotify.error('Para Parcela Mista, informe um valor maior que zero em Fundação e/ou Parceiro Estratégico.');
	        return;
	      }
	
	      if (origemAtual === '0') {
	        this.errors.remove('valor');
	
	        var totalParcela = (+this.parcela.valor_fbb || 0) + (+this.parcela.valor_parc || 0);
	        var limiteTotal = Math.max(0, this.limiteParcelaTotal(this.parcela));
	        if (this.toCentavos(totalParcela) > this.toCentavos(limiteTotal)) {
	          this.$snotify.error('O total da parcela (' + this.$options.filters.real(totalParcela) + ') ultrapassa o saldo total disponível do projeto (' + this.$options.filters.real(limiteTotal) + ').');
	          return;
	        }
	      } else {
	        this.errors.remove('valor_fbb');
	        this.errors.remove('valor_parc');
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this8.$validator.errors.all().length === 0) {
	          _this8.parcela = _this8.normalizarParcelaSimples(_this8.parcela);
	          if (_.isNull(_this8.editandoIndex)) {
	            _this8.table.items.push(_this8.parcela);
	          } else {
	            _this8.table.items.splice(_this8.editandoIndex, 1, _this8.parcela);
	          }
	          _this8.onCancel();
	          _this8.calcularTotais();
	          _this8.$emit('acaoAtualizaSolicitacoes', new Date());
	        } else {
	          var motivos = _this8.$validator.errors.all().join(' | ');
	          _this8.$snotify.error(motivos || 'Não foi possível salvar a parcela. Verifique os valores informados.');
	        }
	      });
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	      this.parcela = {};
	      this.calcularTotais();
	      this.$emit('acaoAtualizaSolicitacoes', new Date());
	    },
	    reincluir: function reincluir(row) {
	      this.table.items.push(row.item);
	      this.calcularTotais();
	      this.$emit('acaoAtualizaSolicitacoes', new Date());
	    },
	    edita: function edita(row) {
	      this.verificaFase;
	      this.editandoIndex = row.index;
	      this.parcela = (0, _assign2.default)({}, row.item);
	      this.parcelaTabela = row.item;
	      this.showgrid = false;
	    },
	    moverLinha: function moverLinha(linha, direcao) {
	      var itens = _.clone(this.table.items);
	      var idxOrigem = linha.index;
	      var idxDestino = (direcao === 'cima' ? -1 : 1) + idxOrigem;
	      var itemBkp = itens[idxDestino];
	      itens[idxDestino] = itens[idxOrigem];
	      itens[idxOrigem] = itemBkp;
	      this.table.items = itens;
	      this.numerarParcelas();
	      this.$forceUpdate();
	    },
	    ehProximaAposUltimaLiberada: function ehProximaAposUltimaLiberada(parcela) {
	      var ultimaParcelaLiberada = _.last(_.filter(this.table.items, function (p) {
	        return p && (_.has(p, 'requisitado') || p.requisitado > 0);
	      }));
	      if (!ultimaParcelaLiberada) return false;
	      return _.has(parcela, 'parcela') && parcela.parcela === ultimaParcelaLiberada.parcela + 1 || !_.has(parcela, 'parcela') && ultimaParcelaLiberada.parcela === this.table.items.length;
	    },
	    limiteParcelaFundacao: function limiteParcelaFundacao(parcela) {
	      var devolveAtual = 0;
	      if (!_.isNull(this.editandoIndex)) {
	        var o = '' + _.get(parcela, 'origem');
	        if (o === '0') devolveAtual = +_.get(this.parcelaTabela, 'valor_fbb', 0) || 0;else if (o === '1') devolveAtual = +_.get(this.parcelaTabela, 'valor', 0) || 0;
	      }
	      var acrescimo = 0;
	      if (this.totais.residuo.fbb > 0 && this.ehProximaAposUltimaLiberada(parcela)) {
	        acrescimo = this.totais.residuo.fbb;
	      }
	      return devolveAtual + this.totais.saldoDisponivel.fbb + acrescimo;
	    },
	    limiteParcelaParceiro: function limiteParcelaParceiro(parcela) {
	      var devolveAtual = 0;
	      if (!_.isNull(this.editandoIndex)) {
	        var o = '' + _.get(parcela, 'origem');
	        if (o === '0') devolveAtual = +_.get(this.parcelaTabela, 'valor_parc', 0) || 0;else if (o === '5') devolveAtual = +_.get(this.parcelaTabela, 'valor', 0) || 0;
	      }
	      var acrescimo = 0;
	      if (this.totais.residuo.parceiros > 0 && this.ehProximaAposUltimaLiberada(parcela)) {
	        acrescimo = this.totais.residuo.parceiros;
	      }
	      return devolveAtual + this.totais.saldoDisponivel.parceiros + acrescimo;
	    },
	    limiteParcelaTotal: function limiteParcelaTotal(parcela) {
	      return this.limiteParcelaFundacao(parcela) + this.limiteParcelaParceiro(parcela);
	    },
	    limiteParcela: function limiteParcela(parcela) {
	      var o = '' + _.get(parcela, 'origem');
	      if (o === '1') return this.limiteParcelaFundacao(parcela);
	      if (o === '5') return this.limiteParcelaParceiro(parcela);
	      return this.limiteParcelaTotal(parcela);
	    },
	    ehParcelaSemOrigem: function ehParcelaSemOrigem(item) {
	      return !_.includes(['0', '1', '5'], '' + _.get(item, 'origem'));
	    },
	    ehItemNovo: function ehItemNovo(item) {
	      return !_.has(item, 'id') || _.includes(_.get(item, 'id', ''), 'novo') || _.find(_.get(this.processoSolicitacao, 'inclusao', []), ['id', item.id]);
	    },
	    ehItemExcluido: function ehItemExcluido(item) {
	      return _.includes(_.get(this.processoSolicitacao, 'exclusao', []), item.id);
	    },
	    modificacaoLinha: function modificacaoLinha(item, type) {
	      if (!item || type !== 'row') return;
	      if ('' + this.modoVisualizacaoAlteracoes === 'DETALHADO') {
	        if (this.ehItemNovo(item)) return 'modificacaoInclusao';
	        if (this.ehItemExcluido(item)) return 'modificacaoExlusao';
	      }
	    }
	  }
	};

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'parecerJuridicoCampos',
	  inject: ['$validator'],
	  props: ['analise']
	};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadDocumentosPhpPrestacao = __webpack_require__(255);
	
	var _uploadDocumentosPhpPrestacao2 = _interopRequireDefault(_uploadDocumentosPhpPrestacao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    uploadDocumentosPhpPrestacao: _uploadDocumentosPhpPrestacao2.default
	  },
	  name: 'AnexosComplementares',
	  data: function data() {
	    return {
	      loading: false,
	      layoutExtrato: 'classico',
	      editando: false,
	      anexo: [],
	      todosOsAnexos: [],
	      table: {
	        items: [],
	        currentPage: 0,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'documento.tipo_documento.ds_tipo', label: 'Tipo Documento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'documento.ds_nome_arquivo', label: 'Nome Arquivo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'documento.dt_criado', label: 'Data inclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'observacoes', label: 'Observação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: {
	    dadosComplementares: Object
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {},
	  mounted: function mounted() {
	    this.todosOsAnexos = _.cloneDeep(this.anexosComplementares);
	    this.table.items = this.todosOsAnexos;
	    this.getDocumentosComplementares();
	  },
	  methods: {
	    toggleCadastro: function toggleCadastro(valor) {
	      this.editando = valor;
	      if (this.editando) {
	        this.anexo = [];
	        this.observacoes = '';
	      }
	    },
	    salvarAnexo: function salvarAnexo() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var usuario, obj;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (_this.validarCampos()) {
	                  _context.next = 2;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 2:
	                usuario = _this.usuarioLogado.userType === 'FUNDACAO' ? _this.usuarioLogado.ds_nome_usuario + ' (' + _this.usuarioLogado.ds_login + ')' : _this.usuarioLogado.ds_nome_usuario;
	                obj = {
	                  observacoes: _this.observacoes,
	                  anexo: _this.anexo,
	                  idProposta: _this.$route.params.id,
	                  usuario: usuario
	                };
	
	                _this.loading = true;
	                _this.$aguarde('Gravando Documento Complementar. Por favor, aguarde...');
	                _context.next = 8;
	                return axiosLaravel.post('/prestacaoSimplificada/gravaAnexosComplementares', obj).then(function (response) {
	                  if (response.data.codigo === 'OK') {
	                    _this.$snotify.clear();
	                    _this.$snotify.success('Anexo salvo com sucesso');
	                    _this.editando = false;
	
	                    _this.loading = false;
	                    _this.$forceUpdate();
	                    _this.getDocumentosComplementares();
	                  } else {
	                    _this.$snotify.error('Erro ao salvar anexo');
	                  }
	                }).catch(function (error) {
	                  console.log(error);
	                  _this.loading = false;
	                  _this.$snotify.clear();
	                  _this.$snotify.error('Erro ao salvar anexo');
	                });
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    getDocumentosComplementares: function getDocumentosComplementares() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.loading = true;
	                _context2.next = 3;
	                return axiosLaravel.get('/prestacaoSimplificada/getAnexoComplementar/' + _this2.$route.params.id).then(function (response) {
	                  _this2.todosOsAnexos = response.data;
	                  _this2.table.items = _this2.todosOsAnexos;
	                  _this2.loading = false;
	                }).catch(function (error) {
	                  console.log(error);
	                  _this2.loading = false;
	                  _this2.$snotify.error('Erro ao buscar documentos complementares');
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    validarCampos: function validarCampos() {
	      if (this.observacoes === '') {
	        this.$snotify.error('Campo Observação é obrigatório');
	        return false;
	      }
	      if (this.anexo.length === 0) {
	        this.$snotify.error('Campo Anexo é obrigatório');
	        return false;
	      }
	      return true;
	    },
	    downloadAnexo: function downloadAnexo(documento) {
	      var _this3 = this;
	
	      console.log('Baixando anexo: ' + documento.id);
	      this.$aguarde('Baixando anexo: ' + documento.ds_nome_arquivo);
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	        _this3.$snotify.clear();
	      }).catch(function (error) {
	        console.log(error);
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    apagarAnexoComplementar: function apagarAnexoComplementar(id) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var usuario, obj;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this4.$aguarde('Excluindo anexo: ' + id);
	                usuario = _this4.usuarioLogado.userType === 'FUNDACAO' ? _this4.usuarioLogado.ds_nome_usuario + ' (' + _this4.usuarioLogado.ds_login + ')' : _this4.usuarioLogado.ds_nome_usuario;
	                obj = {
	                  id: id,
	                  idProposta: _this4.$route.params.id,
	                  usuario: usuario
	                };
	                _context3.next = 5;
	                return axiosLaravel.post('/prestacaoSimplificada/apagarAnexoComplementar', obj).then(function (response) {
	                  if (response.data.codigo === 'OK') {
	                    _this4.$snotify.clear();
	                    _this4.$snotify.success('Anexo excluído com sucesso');
	                    _this4.getDocumentosComplementares();
	                  } else {
	                    _this4.$snotify.error('Erro ao excluir anexo');
	                  }
	                }).catch(function (error) {
	                  console.log(error);
	                  _this4.$snotify.clear();
	                  _this4.$snotify.error('Erro ao excluir anexo');
	                });
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    },
	    onDownloadZIPComplementar: function onDownloadZIPComplementar() {
	      var _this5 = this;
	
	      this.$forceUpdate();
	      this.$aguarde('Baixando arquivos. Por favor, aguarde...');
	      axiosLaravel({
	        url: 'prestacaoSimplificada/downloadArquivosComplementares/' + this.$route.params.id,
	        method: 'GET',
	        responseType: 'blob'
	      }).then(function (response) {
	        var blob = new Blob([response.data], { type: 'application/zip' });
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.setAttribute('download', (0, _moment2.default)().format('DDMMYYYYhhmmss') + '-' + 'prestacao-simplificada-documentos-complementares-' + _this5.dadosComplementares.numeroProjeto + '.zip');
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	        _this5.$snotify.clear();
	      }).catch(function (error) {
	        console.log(error);
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PrestacaoSimplificadaEmails = __webpack_require__(1728);
	
	var _PrestacaoSimplificadaEmails2 = _interopRequireDefault(_PrestacaoSimplificadaEmails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PrestacaoSimplificadaEmails: _PrestacaoSimplificadaEmails2.default
	  },
	  name: 'ListaSolicitacaoPrestacaoContasSimplificado',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      prompt: '',
	      mostrarEmails: false,
	      moment: _moment2.default,
	      table: {
	        items: [],
	        listaInicial: [],
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        pesquisa: '',
	        sortBy: 'data_atualizacao',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'ds_codigo_projeto_erp', label: 'Projeto', sortable: true, thStyle: 'width: 5%; text-align: center', class: 'text-center' }, { key: 'ds_nome', label: 'Nome', sortable: true, thStyle: 'width: 40%; text-align: left', class: 'text-left' }, { key: 'data_atualizacao', label: 'Atualizado em', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'valor_liberado', label: 'Parcelas Adiantamento', thStyle: 'text-align: center', class: 'text-center' }, { key: 'total_gravado', label: 'Valor Registrado', thStyle: 'text-align: center', class: 'text-center' }, { key: 'status', label: 'Situação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'processos', label: 'Tarefas', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'width: 10%; text-align: center', class: 'text-center' }]
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Solcitações de Prestação de Conta',
	        active: true
	      }]
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {},
	  mounted: function mounted() {
	    if (this.usuarioLogado.userType === 'FUNDACAO') {
	      this.getListaInicial();
	    } else {
	      this.getListaInicialEntidade(this.usuarioLogado.entity.id);
	    }
	  },
	  methods: {
	    toggleEmails: function toggleEmails(valor) {
	      this.mostrarEmails = valor;
	    },
	    getListaInicial: function getListaInicial() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('CARREGANDO LISTA INICIAL...');
	                _this.loading.show = true;
	                _context.next = 4;
	                return axiosLaravel.get('prestacaoSimplificada/getProjetos/').then(function (response) {
	                  _this.loading.show = false;
	                  _this.listaInicial = response.data;
	                  _this.table.items = _.cloneDeep(_this.listaInicial);
	                  _this.table.totalRows = response.data.length;
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this.$root.trataErro(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    getListaInicialEntidade: function getListaInicialEntidade(idEntidade) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('CARREGANDO LISTA INICIAL...');
	                _this2.loading.show = true;
	                _context2.next = 4;
	                return axiosLaravel.get('prestacaoSimplificada/getProjetosEntidade/' + idEntidade).then(function (response) {
	                  _this2.loading.show = false;
	                  _this2.listaInicial = response.data;
	                  _this2.table.items = _.cloneDeep(_this2.listaInicial);
	                  _this2.table.totalRows = response.data.length;
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this2.$root.trataErro(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    editarGED: function editarGED(item) {
	      console.log('EDITAR GED', item);
	      this.$router.push({ name: 'prestacao-contas-simplificada-ged', params: { id: item.id } });
	    },
	    totalPorcentagem: function totalPorcentagem(valorParcela, totalRegistrado) {
	      var total = 0;
	      if (valorParcela && totalRegistrado) {
	        total = parseFloat(valorParcela) / parseFloat(totalRegistrado) * 100;
	      } else if (valorParcela && !totalRegistrado) {
	        total = parseFloat(valorParcela) * 100;
	      } else {
	        total = 0;
	      }
	
	      total = parseFloat(total).toFixed();
	      return parseFloat(total);
	    },
	    onSearch: function onSearch() {
	      var _this3 = this;
	
	      this.table.items = this.listaInicial.filter(function (item) {
	        return item.ds_codigo_projeto_erp.toLowerCase().includes(_this3.pesquisa.toLowerCase()) || item.ds_nome.toLowerCase().includes(_this3.pesquisa.toLowerCase() || item.ds_codigo_projeto_erp.toLowerCase().includes(_this3.pesquisa.toLowerCase()) || item.id.toString().includes(_this3.pesquisa.toLowerCase()));
	      });
	      this.table.totalRows = this.table.items.length;
	    }
	  }
	};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'ListaSolicitacaoPrestacaoContasSimplificado',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        currentPage: 0,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'id', label: 'ID', sortable: true, thStyle: 'width: 5%; text-align: center', class: 'text-center' }, { key: 'tipo_solicitacao', label: 'Tipo de Solicitação', sortable: true, thStyle: 'width: 6%; text-align: center', class: 'text-center' }, { key: 'projeto', label: 'Projeto', sortable: true, thStyle: 'width: 34%; text-align: center', class: 'centraliza' }, { key: 'data_solicitacao', label: 'Data de Solicitação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'valor', label: 'Valor', thStyle: 'text-align: center', class: 'text-center' }, { key: 'etapa', label: 'Etapa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'situacao', label: 'Situação', thStyle: 'text-align: center', class: 'text-center', sortable: true }, { key: 'actions', label: 'Ações', thStyle: 'width: 25%; text-align: center', class: 'text-center' }]
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Solcitações Prestação de Contas Simplificada',
	        active: true
	      }]
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {},
	  mounted: function mounted() {},
	  methods: {
	    buscaDadosBancariosAdiantamento: function buscaDadosBancariosAdiantamento(idSolicitacao) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                axiosLaravel.get('processos/dados_bancarios_adiantamento/' + idSolicitacao).then(function (response) {
	                  _this.dadosBancariosAdiantamento.banco = response.data[0].banco;
	                  _this.dadosBancariosAdiantamento.agencia = response.data[0].agencia;
	                  _this.dadosBancariosAdiantamento.conta = response.data[0].conta;
	                  _this.dadosBancariosAdiantamento.tipo = response.data[0].tipo;
	                  _this.$forceUpdate();
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this.$root.trataErro(error);
	                });
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'PrestacaoDeclaracoes',
	  data: function data() {
	    return {
	      loading: false,
	      moment: _moment2.default,
	      mostrarHistorico: true,
	      declaracoes: [],
	      ehUltimaParcela: false
	    };
	  },
	
	  props: {
	    dadosComplementares: Object,
	    parcelaSelecionada: Object,
	    infoParcelasAdiantamento: Array,
	    idPrestacao: Number
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {},
	  mounted: function mounted() {
	    this.getDeclaracoes();
	    this.verificaUltimaParcela();
	  },
	  methods: {
	    isTrue: function isTrue(v) {
	      return v === true || v === 1 || v === '1' || v === 'true';
	    },
	    chiefActive: function chiefActive() {
	      var _this = this;
	
	      var chefe = this.usuarioLogado.entity.dirigentes.find(function (dirigente) {
	        return _this.isTrue(dirigente.bt_ativo) && _this.isTrue(dirigente.bt_representante_legal);
	      });
	      if (chefe) {
	        return String(chefe.ds_cpf).trim() === String(this.usuarioLogado.ds_cpf).trim();
	      }
	    },
	    verificaUltimaParcela: function verificaUltimaParcela() {
	      var parcelas = this.infoParcelasAdiantamento.map(function (item) {
	        return item.parcela;
	      });
	      var maiorParcela = Math.max.apply(Math, (0, _toConsumableArray3.default)(parcelas));
	
	      this.ehUltimaParcela = String(maiorParcela) === String(this.parcelaSelecionada.parcela);
	    },
	    getDeclaracoes: function getDeclaracoes() {
	      var _this2 = this;
	
	      console.log('buscando declaracoes');
	      this.loading = true;
	
	      var obj = {
	        idProposta: this.$route.params.id,
	        idPrestacao: this.idPrestacao
	      };
	      axiosLaravel.post('/prestacaoSimplificada/getDeclaracoes', obj).then(function (response) {
	        _this2.declaracoes = response.data;
	        console.log('declaracoes', _this2.declaracoes);
	        _this2.loading = false;
	      }).catch(function (error) {
	        console.error('Erro ao buscar declarações:', error);
	        _this2.loading = false;
	      });
	    },
	    aceitarDeclaracao: function aceitarDeclaracao(item) {
	      var _this3 = this;
	
	      item.aceito = item.aceito === 'S' ? 'N' : 'S';
	      if (item.aceito === 'N') {
	        item.usuario = null;
	      }
	      var obj = {
	        idProposta: this.$route.params.id,
	        idPrestacao: this.idPrestacao,
	        aceito: item.aceito,
	        idDeclaracao: item.id,
	        usuario: this.usuarioLogado.ds_nome_usuario
	      };
	      this.loading = true;
	      this.$aguarde('Gravando decisão...');
	      axiosLaravel.post('/prestacaoSimplificada/atualizarDeclaracao', obj).then(function (response) {
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Decisão gravada com sucesso!');
	        _this3.loading = false;
	        console.log('declaracoes', _this3.declaracoes);
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.$snotify.error('Erro ao gravar decisão!');
	        _this3.loading = false;
	        console.error('Erro ao aceitar declaração:', error);
	      });
	    },
	    validarDeclaracoes: function validarDeclaracoes() {
	      var _this4 = this;
	
	      console.log('validarDeclaracoes');
	      var validar = true;
	      this.declaracoes.forEach(function (item) {
	        if (item.aceito === 'N' && !item.declaracao.includes('AVISO DE CONCLUSÃO')) {
	          validar = false;
	        }
	        if (item.aceito === 'N' && item.declaracao.includes('AVISO DE CONCLUSÃO') && _this4.ehUltimaParcela) {
	          validar = false;
	        }
	      });
	      console.log(validar);
	      return validar;
	    }
	  }
	};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'PrestacaoHistorico',
	  data: function data() {
	    return {
	      loading: false,
	      moment: _moment2.default,
	      mostrarHistorico: false,
	      historico: [],
	      table: {
	        items: [],
	        currentPage: 0,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'created_at', label: 'Data', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'evento', label: 'Evento', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'usuario', label: 'Responsável', sortable: true, thStyle: 'text-align: left', class: 'text-left' }]
	      }
	    };
	  },
	
	  props: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {},
	  mounted: function mounted() {},
	  methods: {
	    toggleHistorico: function toggleHistorico(valor) {
	      this.mostrarHistorico = valor;
	      if (this.mostrarHistorico) {
	        this.buscarHistorico();
	      }
	    },
	    buscarHistorico: function buscarHistorico() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('buscando historico');
	                _this.loading = true;
	                _this.historico = [];
	                _context.next = 5;
	                return axiosLaravel.get('/prestacaoSimplificada/getHistorico/' + _this.$route.params.id).then(function (response) {
	                  _this.historico = response.data;
	                  _this.table.items = _this.historico;
	                }).catch(function (error) {
	                  console.log(error);
	                });
	
	              case 5:
	                _this.loading = false;
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'PrestacaoSimplificadaEmails',
	  data: function data() {
	    return {
	      loading: false,
	      moment: _moment2.default,
	      table: {
	        items: [],
	        currentPage: 0,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'numero_projeto', label: 'Projeto', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'nome_projeto', label: 'Nome', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'nome_entidade', label: 'Entidade', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'email_enviado', label: 'e-mail', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'destinatario', label: 'Destinatário', sortable: true, thStyle: 'text-align: left', class: 'text-left' }, { key: 'created_at', label: 'Data Envio', sortable: true, thStyle: 'text-align: left', class: 'text-left' }]
	      }
	    };
	  },
	
	  props: {
	    toggleEmails: Function
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {},
	  mounted: function mounted() {
	    this.buscarEmails();
	  },
	  methods: {
	    fecharEmails: function fecharEmails() {
	      this.toggleEmails(false);
	    },
	    buscarEmails: function buscarEmails() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.loading = true;
	                _context.next = 3;
	                return axiosLaravel.get('/prestacaoSimplificada/getEmails').then(function (response) {
	                  console.log('response', response);
	                  _this.table.items = response.data;
	                  _this.table.totalRows = response.data.length;
	                }).catch(function (error) {
	                  console.log(error);
	                });
	
	              case 3:
	                _this.loading = false;
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cronogramaGED = __webpack_require__(1730);
	
	var _cronogramaGED2 = _interopRequireDefault(_cronogramaGED);
	
	var _uploadDocumentosPhpPrestacao = __webpack_require__(255);
	
	var _uploadDocumentosPhpPrestacao2 = _interopRequireDefault(_uploadDocumentosPhpPrestacao);
	
	var _AnexosComplementares = __webpack_require__(1723);
	
	var _AnexosComplementares2 = _interopRequireDefault(_AnexosComplementares);
	
	var _PrestacaoHistorico = __webpack_require__(1727);
	
	var _PrestacaoHistorico2 = _interopRequireDefault(_PrestacaoHistorico);
	
	var _PrestacaoDeclaracoes = __webpack_require__(1726);
	
	var _PrestacaoDeclaracoes2 = _interopRequireDefault(_PrestacaoDeclaracoes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    cronogramaGED: _cronogramaGED2.default,
	    uploadDocumentosPhpPrestacao: _uploadDocumentosPhpPrestacao2.default,
	    AnexosComplementares: _AnexosComplementares2.default,
	    PrestacaoHistorico: _PrestacaoHistorico2.default,
	    PrestacaoDeclaracoes: _PrestacaoDeclaracoes2.default
	  },
	  formatarDataUtc: function formatarDataUtc(data) {
	    var formato = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY HH:mm';
	
	    return data ? _moment2.default.utc(data).format(formato) : '';
	  },
	
	  filters: {
	    dataUtc: function dataUtc(data) {
	      var formato = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY HH:mm';
	
	      return data ? _moment2.default.utc(data).format(formato) : '';
	    }
	  },
	  name: 'PrestacaoSimplificadaGED',
	  data: function data() {
	    return {
	      loading: {
	        show: false,
	        documentos: false
	      },
	      moment: _moment2.default,
	      mostrarAnexos: false,
	      mostrarDetalheNota: false,
	      editandoNota: false,
	      tableDataKey: 0,
	      anexosNotaModal: [],
	      detalhesNotaModal: [],
	      ehVisualizacao: false,
	      parcelaSelecionada: [],
	      parcelasAdiantamento: [],
	      infoParcelasAdiantamento: [],
	      mensagemAviso: [],
	      cienteDeclaracoes: [],
	      declaracoes: [{ 'codigo': 'fornecedoresNaoLigadosDirigentes', 'texto': 'Declaro que esta liberação de recurso não será destinada ao pagamento de fornecedores de bens e serviços dos quais seu(s) proprietário(s), sócio(s) ou dirigente(s) seja(m) componentes da diretoria e conselhos da {{entidade.ds_nome}}' }, { 'codigo': 'recursosNaoDestinadosDirigentesParentes', 'texto': 'Declaro ainda que o recurso não será destinado a fornecedores de bens e serviços dos quais seu(s) proprietário(s), sócio(s) ou dirigente(s) seja(m) parente(s) consanguíneo(s) ou afins, em linha reta ou colateral, até o terceiro grau com dirigente(s) ou conselheiro(s) da {{entidade.ds_nome}}' }],
	      cronograma: {},
	      mensagemLoading: '',
	      dadosComplementares: {},
	      notasCadastradas: [],
	      notaTarefa: {},
	      table: {
	        items: [],
	        currentPage: 0,
	        perPage: 999,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'item_cronograma', label: 'Item', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'numero_documento', label: 'Número Documento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'item', label: 'Nome Item', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'serie_documento', label: 'Tipo Documento', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'data_emissao_documento', label: 'Data Emissão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'fornecedor_nome', label: 'Nome Emitente', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'valor_documento', label: 'Valor', thStyle: 'text-align: center', class: 'text-center' }, { key: 'anexos', label: 'Anexos', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      excelCampos: {
	        basico: {
	          'Série Documento': 'serie_documento',
	          'Número Documento': 'numero_documento',
	          'Data Emissão': 'data_emissao_documento',
	          'Data Validade': 'data_validade_documento',
	          'Valor Documento': 'valor_documento',
	          'Código Fornecedor': 'fornecedor_codigo',
	          'Tipo Fornecedor': 'fornecedor_tipo',
	          'CPF/CNPJ Fornecedor': 'fornecedor_cpf_cnpj',
	          'Nome Fornecedor': 'fornecedor_nome',
	          'Endereço Fornecedor': 'fornecedor_endereco',
	          'CEP Fornecedor': 'fornecedor_cep',
	          'Item': 'item',
	          'Item Orçamento': 'fk_item_cronograma',
	          'Item Cronograma': 'item_cronograma',
	          'Processo': 'fk_processo',
	
	          'Criado em': 'created_at',
	          'Atualizado em': 'updated_at',
	          'Anexos': 'anexos'
	        }
	      },
	      excelMeta: [[{ 'key': 'charset', 'value': 'utf-8' }]],
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Solcitações Prestação de Contas Simplificada',
	        active: true
	      }]
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    formattedItems: function formattedItems() {
	      return this.notasCadastradas.map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          anexos: item.anexos.map(function (anexo) {
	            return '<div><a href=https://projetos.fbb.org.br/baixarArquivoPrestacao/' + anexo.id + '>' + anexo.ds_nome_arquivo + '</a></div>';
	          }).join(' ')
	        });
	      });
	    },
	    existeProcesso: function existeProcesso() {
	      return this.notasCadastradas.filter(function (nota) {
	        return nota.fk_processo !== null;
	      });
	    },
	    totalProcesso: function totalProcesso() {
	      var total = 0;
	      if (this.notasCadastradas.length > 0) {
	        this.notasCadastradas.forEach(function (nota) {
	          if (nota.hasOwnProperty('fk_processo')) {
	            if (nota.fk_processo !== null) {
	              total += parseFloat(nota.valor_documento);
	            }
	          }
	        });
	      }
	      return total;
	    },
	    totalSemProcesso: function totalSemProcesso() {
	      var total = 0;
	      if (this.notasCadastradas.length > 0) {
	        this.notasCadastradas.forEach(function (nota) {
	          if (nota.fk_processo === null || nota.hasOwnProperty('fk_processo') === false) {
	            total += parseFloat(nota.valor_documento);
	          }
	        });
	      }
	      return total;
	    },
	    totalPorcentagem: function totalPorcentagem() {
	      var total = 0;
	      if (this.parcelaSelecionada.valor_parcela > 0) {
	        total = this.parcelaSelecionada.valor_gravado * 100 / this.parcelaSelecionada.valor_parcela;
	      }
	
	      total = parseFloat(total).toFixed();
	      return parseFloat(total);
	    }
	  }),
	  created: function created() {
	    console.log('CREATED');
	  },
	  mounted: function mounted() {
	    console.log('MOUNTED', this.$route.params.id);
	    if (this.$route.params.id) {
	      this.initDados();
	    }
	  },
	  methods: {
	    chiefActive: function chiefActive() {
	      var isTrue = function isTrue(value) {
	        return value === true || value === 1 || value === '1' || value === 'true';
	      };
	
	      var chefe = this.usuarioLogado.entity.dirigentes.find(function (dirigente) {
	        return isTrue(dirigente.bt_ativo) && isTrue(dirigente.bt_representante_legal);
	      });
	      if (chefe) {
	        return String(chefe.ds_cpf).trim() === String(this.usuarioLogado.ds_cpf).trim();
	      }
	    },
	    toggleAnexos: function toggleAnexos(valor) {
	      var anexos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.mostrarAnexos = valor;
	      if (this.mostrarAnexos) {
	        this.anexosNotaModal = anexos;
	      }
	    },
	    toggleDetalheNota: function toggleDetalheNota(valor) {
	      var nota = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.mostrarDetalheNota = valor;
	      if (this.mostrarDetalheNota) {
	        this.detalhesNotaModal = nota;
	      }
	    },
	    editarNota: function editarNota(nota) {
	      this.editandoNota = true;
	      this.acertoValoresEdicaoCronograma(nota);
	      this.$refs.cronograma.initEdicao(nota);
	    },
	    initDados: function initDados() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this.getDadosComplementares();
	
	              case 2:
	                _context.next = 4;
	                return _this.getParcelasAdiantamento();
	
	              case 4:
	                _context.next = 6;
	                return _this.getInformacoesAdiantamentos();
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    buscaDados: function buscaDados() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('BUSCANDO DADOS');
	                _context2.next = 3;
	                return _this2.carregarCronograma();
	
	              case 3:
	                if (_this2.usuarioLogado.userType === 'ENTIDADE') {}
	                _context2.next = 6;
	                return _this2.getNotas();
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    excluirNota: function excluirNota(nota) {
	      var _this3 = this;
	
	      console.log('Excluir nota', nota);
	
	      this.$dialog.confirm('Deseja realmente excluir esse documento? Essa ação <b>não</b> pode ser desfeita.', {
	        title: 'Excluir Nota',
	        type: 'warning',
	        confirmButtonText: 'Sim, excluir!',
	        cancelButtonText: 'Cancelar'
	      }).then(function () {
	        _this3.excluirNotaConfirmado(nota);
	      }).catch(function () {
	        console.log('Exclusão cancelada');
	      });
	    },
	    excluirNotaConfirmado: function excluirNotaConfirmado(nota) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var usuario, obj;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this4.$aguarde('Excluindo Nota, aguarde...');
	                _this4.mensagemLoading = 'Excluindo documento...';
	                _this4.loading.documentos = true;
	                console.log('Excluir nota confirmada', nota);
	                usuario = _this4.usuarioLogado.userType === 'FUNDACAO' ? _this4.usuarioLogado.ds_nome_usuario + ' (' + _this4.usuarioLogado.ds_login + ')' : _this4.usuarioLogado.ds_nome_usuario;
	                obj = {
	                  idProposta: _this4.$route.params.id,
	                  nota: nota,
	                  usuario: usuario
	                };
	                _context3.next = 8;
	                return axiosLaravel.post('/prestacaoSimplificada/excluirNota', obj).then(function (response) {
	                  console.log('response', response.data);
	                  _this4.$snotify.clear();
	                  _this4.$snotify.success('Nota excluída com sucesso!');
	
	                  _this4.acertoValoresEdicaoCronograma(nota);
	                  _this4.getNotas();
	
	                  _this4.atualizarSaldoItens();
	                }).catch(function (error) {
	                  console.error('Error deleting nota:', error);
	                  _this4.$snotify.clear();
	                  _this4.$snotify.error('Erro ao excluir a nota.');
	                });
	
	              case 8:
	                _this4.$forceUpdate();
	
	              case 9:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    },
	    carregarCronograma: function carregarCronograma() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this5.mensagemLoading = 'Carregando cronograma...';
	                _this5.loading.documentos = true;
	                _context4.next = 4;
	                return axiosLaravel.post('processos/cronograma/projeto/', { 'proposta': _this5.$route.params.id, 'processo': 'PRESTACAO_DE_CONTAS', 'aglutinado': 'Completo', 'documento': 1 }).then(function (response) {
	                  _this5.cronograma = response.data;
	                  _this5.loading.documentos = false;
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this5.loading.documentos = false;
	                  _this5.$root.trataErro(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this5);
	      }))();
	    },
	    getParcelasAdiantamento: function getParcelasAdiantamento() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                console.log('getParcelasAdiantamento');
	                _this6.mensagemLoading = 'Buscando parcelas de adiantamento...';
	                _this6.loading.show = true;
	                _context5.next = 5;
	                return axiosLaravel.get('/prestacaoSimplificada/getParcelasAdiantamento/' + _this6.$route.params.id).then(function (response) {
	                  console.log('response', response.data);
	                  _this6.parcelasAdiantamento = response.data;
	                  if (_this6.parcelasAdiantamento.length === 0) {
	                    _this6.mensagemAviso.push('Nenhuma parcela de adiantamento encontrada para o projeto selecionado.');
	                  }
	                  _this6.loading.show = false;
	                }).catch(function (error) {
	                  console.error('Error fetching parcelas adiantamento:', error);
	                  _this6.loading.show = false;
	                });
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this6);
	      }))();
	    },
	    getInformacoesAdiantamentos: function getInformacoesAdiantamentos() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                console.log('getInformacoesAdiantamentos');
	                _this7.mensagemLoading = 'Buscando informações de todas as parcelas de adiantamento...';
	                _this7.loading.show = true;
	                _context6.next = 5;
	                return axiosLaravel.get('/prestacaoSimplificada/verificaAdiantamentos/' + _this7.$route.params.id).then(function (response) {
	                  console.log('getInformacoesAdiantamentos', response.data);
	                  _this7.infoParcelasAdiantamento = response.data.adiantamentosProposta;
	                  _this7.loading.show = false;
	                }).catch(function (error) {
	                  console.error('Error fetching parcelas adiantamento:', error);
	                  _this7.loading.show = false;
	                });
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this7);
	      }))();
	    },
	    getDadosComplementares: function getDadosComplementares() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                console.log('dadosComplementares');
	                _this8.mensagemLoading = 'Buscando dados complementares...';
	                _this8.loading.show = true;
	                _context7.next = 5;
	                return axiosLaravel.get('/prestacaoSimplificada/getDadosComplementaresProposta/' + _this8.$route.params.id).then(function (response) {
	                  console.log('response', response.data);
	                  _this8.dadosComplementares = response.data[0];
	                  if (_this8.usuarioLogado.userType === 'ENTIDADE') {
	                    if (_this8.dadosComplementares.fk_entidade !== _this8.usuarioLogado.entity.id) {
	                      console.log('ENTIDADE DIFERENTE');
	                      _this8.$snotify.error('Você não tem permissão para acessar essa proposta.');
	                      _this8.$router.push({ name: 'prestacao-contas-simplificada' });
	                      return;
	                    }
	                  }
	                  var datetimeInicial = new Date(_this8.dadosComplementares.data_inicio_sapiens);
	                  var datetimeFim = new Date(_this8.dadosComplementares.data_fim_sapiens);
	                  console.log(_this8.dadosComplementares);
	                  _this8.dadosComplementares.data_inicial = datetimeInicial.toLocaleDateString('pt-BR');
	                  _this8.dadosComplementares.data_final = datetimeFim.toLocaleDateString('pt-BR');
	                }).catch(function (error) {
	                  console.error('Error fetching dados complementares:', error);
	                  _this8.loading.show = false;
	                });
	
	              case 5:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this8);
	      }))();
	    },
	    getNotas: function getNotas() {
	      var _this9 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this9.mensagemLoading = 'Buscando documentos cadastrados...';
	                _this9.loading.documentos = true;
	                _context8.next = 4;
	                return axiosLaravel.get('/prestacaoSimplificada/carregarNotas/' + _this9.parcelaSelecionada.id).then(function (response) {
	                  console.log('response', response.data);
	                  _this9.notasCadastradas = response.data;
	                  _this9.table.items = _this9.notasCadastradas;
	                  _this9.acertoValoresCronograma();
	                  _this9.$forceUpdate();
	                  _this9.loading.documentos = false;
	                }).catch(function (error) {
	                  console.error('Error fetching notas:', error);
	                  _this9.loading.documentos = false;
	                });
	
	              case 4:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this9);
	      }))();
	    },
	    acertoValoresCronograma: function acertoValoresCronograma() {
	      var _this10 = this;
	
	      this.notasCadastradas.forEach(function (nota) {
	        console.log('NOTA', nota);
	        _this10.cronograma.itens.forEach(function (item) {
	          if (String(item.Id_item) === String(nota.fk_item_cronograma)) {
	            console.log('Valor Solicitado', item.Valor_solicitado);
	            console.log('Valor documento', nota.valor_documento);
	
	            if (!nota.fk_processo) {
	              item.Valor_solicitado += parseFloat(nota.valor_documento);
	            }
	          }
	        });
	      });
	    },
	    acertoValoresEdicaoCronograma: function acertoValoresEdicaoCronograma(nota) {
	      this.cronograma.itens.forEach(function (item) {
	        if (String(item.Id_item) === String(nota.fk_item_cronograma)) {
	          item.Valor_solicitado -= parseFloat(nota.valor_documento);
	        }
	      });
	
	      this.parcelaSelecionada.valor_gravado = parseFloat(this.parcelaSelecionada.valor_gravado) - parseFloat(nota.valor_documento);
	      this.parcelaSelecionada.valor_gravado = this.parcelaSelecionada.valor_gravado.toFixed(2);
	    },
	    acertoValoresCancelamentoEdicaoCronograma: function acertoValoresCancelamentoEdicaoCronograma(nota) {
	      console.log('ACERTO CANCELAMENTO', nota);
	      this.editandoNota = false;
	      this.cronograma.itens.forEach(function (item) {
	        if (String(item.Id_item) === String(nota.fk_item_cronograma)) {
	          item.Valor_solicitado += parseFloat(nota.valor_documento);
	        }
	      });
	
	      this.parcelaSelecionada.valor_gravado = parseFloat(this.parcelaSelecionada.valor_gravado) + parseFloat(nota.valor_documento);
	      this.parcelaSelecionada.valor_gravado = this.parcelaSelecionada.valor_gravado.toFixed(2);
	    },
	    concluir: function concluir() {
	      var _this11 = this;
	
	      console.log('Concluir');
	      var totalSolicitacao = 0;
	      this.notasCadastradas.forEach(function (nota) {
	        if (!nota.fk_processo) {
	          totalSolicitacao += parseFloat(nota.valor_documento);
	        }
	      });
	      if (totalSolicitacao <= 0) {
	        this.$snotify.error('Nenhum documento cadastrado para concluir a prestação de contas.');
	        return;
	      }
	      this.$dialog.confirm('<p>Deseja realmente concluir a prestação de contas deste valor e solicitar a baixa do título? Essa ação <b>não</b> poderá ser desfeita e os arquivos dessa sessão <b>não</b> poderão mais ser editados.</p> <br/> <p>Caso os valores não estejam em <b>100% do total</b>, você poderá gravar o restante dos documentos posteriormente.</p> <br/> <p>Total desta solicitação: <b>R$ ' + totalSolicitacao.toFixed(2) + '</b></p>', {
	        title: 'Concluir Prestação de Contas',
	        type: 'warning',
	        confirmButtonText: 'Sim, concluir!',
	        cancelButtonText: 'Cancelar'
	      }).then(function () {
	        if (_this11.$refs.prestacaoDeclaracoes) {
	          if (_this11.$refs.prestacaoDeclaracoes.validarDeclaracoes() === false) {
	            _this11.$snotify.clear();
	            _this11.$snotify.error('Declaração não aceita, para concluir a prestação de contas desta parcela de adiantamento, é necessário aceitar todas as declarações.');
	            _this11.loading.show = false;
	            return;
	          }
	        }
	        _this11.concluirSolicitacao();
	      }).catch(function () {
	        console.log('Concluir cancelado');
	      });
	    },
	    concluirSolicitacao: function concluirSolicitacao() {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                console.log('Concluindo solicitacao');
	                _this12.mensagemLoading = 'Criando tarefa de baixa de título...';
	                _this12.$aguarde('Criando tarefa de baixa de título, por favor, não feche essa janela... Aguarde... ');
	                _this12.loading.show = true;
	
	                _this12.notaTarefa = {
	                  idProposta: _this12.$route.params.id,
	                  usuario: _this12.usuarioLogado.ds_nome_usuario,
	                  idPrestacao: _this12.parcelaSelecionada.id,
	
	                  numeroNota: _this12.$route.params.id,
	                  fkPrestacaoSimplificada: _this12.parcelaSelecionada.id,
	                  serieNota: 'NOTA_FISCAL',
	                  dataInclusao: (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss'),
	                  dataValidade: null,
	                  observacao: 'BAIXA DE TITULO DE ADIANTAMENTO PELA PRESTACAO DE CONTAS SIMPLIFICADA.',
	                  dados_bancarios: {
	                    banco: '000',
	                    agencia: '0',
	                    conta: 1,
	                    tipo: 1
	                  },
	                  tipoFornecedor: 'Pessoa Jurídica',
	                  codigoFornecedor: null,
	                  cnpjFornecedor: _this12.dadosComplementares.cnpj_entidade,
	                  nomeFornecedor: _this12.dadosComplementares.nome_entidade,
	                  enderecoFornecedor: 'N/A',
	                  cepFornecedor: '000000000',
	                  anexos: [],
	                  forma_pagamento: 2,
	                  pagamentoPrioritario: 0,
	                  bypass: null,
	                  dadosComplementares: [],
	                  suporteFbb: [],
	                  tributacao: '',
	                  valorTributado: '',
	
	                  parametros_documento: [],
	                  boleto: {
	                    sucesso: false,
	                    mensagem: null,
	                    tipoCodigoInput: null,
	                    tipoBoleto: null,
	                    codigoBarras: null,
	                    linhaDigitavel: null,
	                    numeroInformadoTela: null,
	                    vencimento: null,
	                    valor: null
	                  },
	                  favorecido: {
	                    CodBan: '',
	                    CodAge: '',
	                    CcbFav: '',
	                    contas: [],
	                    incluidos: [],
	                    excluidos: [],
	                    resultado: [],
	                    dadosBancariosSelecionados: null
	                  },
	                  notasCadastradas: _this12.notasCadastradas
	                };
	
	                _this12.notaTarefa.projeto = {
	                  Id_proposta: _this12.$route.params.id,
	                  Numero_projeto: _this12.dadosComplementares.numeroProjeto,
	                  Projeto: _this12.dadosComplementares.projeto,
	                  fk_entidade: _this12.dadosComplementares.fk_entidade,
	                  Objetivo: _this12.dadosComplementares.objetivo,
	                  Status_ERP: _this12.dadosComplementares.statusERP,
	                  edital: null,
	                  data_inicial_formatada: _this12.dadosComplementares.data_inicial,
	                  data_final_formatada: _this12.dadosComplementares.data_final,
	                  dateInicioSapiens: _this12.dadosComplementares.data_inicio_sapiens,
	                  dateFimSapiens: _this12.dadosComplementares.data_fim_sapiens,
	                  dateAprovacao: _this12.dadosComplementares.data_aprovacao
	                };
	
	                _this12.cienteDeclaracoes = [];
	                _this12.ciente('fornecedoresNaoLigadosDirigentes');
	                _this12.ciente('recursosNaoDestinadosDirigentesParentes');
	                _this12.notaTarefa.parametros_documento.push({ 'parametro': 'DECLARACOES', 'valor': _this12.cienteDeclaracoes });
	
	                _this12.notaTarefa.banco = _this12.notaTarefa.dados_bancarios.banco;
	                _this12.notaTarefa.agencia = _this12.notaTarefa.dados_bancarios.agencia;
	                _this12.notaTarefa.conta = _this12.notaTarefa.dados_bancarios.conta;
	                _this12.notaTarefa.tipo = _this12.notaTarefa.dados_bancarios.tipo;
	                _this12.notaTarefa.processo = { 'nome': 'PRESTACAO_DE_CONTAS', 'situacao': 'EM_EXECUCAO' };
	                _this12.notaTarefa.tarefa = { 'nome': 'SOLICITACAO', 'tipo': 'USUARIO', 'situacao': 'PADRAO' };
	
	                _this12.notaTarefa.itens = [];
	
	                _this12.notasCadastradas.forEach(function (nota) {
	                  if (!nota.fk_processo) {
	                    _this12.cronograma.itens.forEach(function (item) {
	                      if (String(item.Id_item) === String(nota.fk_item_cronograma)) {
	                        item['valorSolicitado'] = item.Valor_solicitado;
	                        item['quantidadeSolicitada'] = 1;
	                        item['Qtde_solicitado'] = 1;
	
	                        if (!_this12.notaTarefa.itens.find(function (i) {
	                          return i.Id_item === item.Id_item;
	                        })) {
	                          _this12.notaTarefa.itens.push(item);
	                        }
	                      }
	                    });
	                  }
	                });
	                _this12.notaTarefa.valorTotal = _.sumBy(_this12.notaTarefa.itens, 'valorSolicitado');
	                _.set(_this12.notaTarefa, 'proximaEtapa', 'Análise');
	
	                _.set(_this12.notaTarefa, 'proxima_etapa', 'Análise');
	                _.set(_this12.notaTarefa, 'data_edicao', (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss'));
	                _context9.next = 24;
	                return axiosLaravel.post('/prestacaoSimplificada/gravaTarefaPrestacao', _this12.notaTarefa).then(function (response) {
	                  console.log('response', response.data);
	                  _this12.$snotify.clear();
	                  _this12.$snotify.success('Tarefa de baixa de título criada com sucesso!');
	                  _this12.loading.show = false;
	
	                  setTimeout(function () {
	                    _this12.$router.push({ name: 'prestacao-contas-simplificada' });
	                  }, 2000);
	                }).catch(function (error) {
	                  console.error('Error tarefa:', error);
	                  console.log(error.response);
	                  _this12.loading.show = false;
	                  _this12.$snotify.clear();
	                  _this12.$snotify.error('Erro ao criar a tarefa de baixa de título. Tente novamente mais tarde. ' + error.response.data.mensagem);
	                });
	
	              case 24:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this12);
	      }))();
	    },
	    ciente: function ciente(codigo) {
	      if (_.find(this.cienteDeclaracoes, ['codigo', codigo])) {
	        _.remove(this.cienteDeclaracoes, ['codigo', codigo]);
	      } else {
	        this.cienteDeclaracoes.push({ 'codigo': codigo, 'texto': _.get(_.find(this.declaracoes, ['codigo', codigo]), 'texto', ''), 'data': new Date(), 'usuario': { 'id': this.usuarioLogado.id, 'nome': this.usuarioLogado.ds_nome_usuario } });
	      }
	      this.$forceUpdate();
	    },
	    setNota: function setNota(nota) {
	      var edicao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      console.log('setNota', nota);
	      if (edicao) {
	        var index = this.notasCadastradas.findIndex(function (item) {
	          return String(item.id) === String(nota.id);
	        });
	        console.log('INDEX', index);
	        console.log(this.notasCadastradas[index]);
	        if (index !== -1) {
	          this.notasCadastradas[index] = {};
	          this.notasCadastradas[index] = _.cloneDeep(nota);
	          this.table.items = [];
	          this.$forceUpdate();
	          this.table.items = this.notasCadastradas;
	          this.$forceUpdate();
	          console.log('DEPOIS', this.notasCadastradas[index]);
	        } else {
	          this.$snotify.error('Erro ao atualizar a nota localmente, favor verificar.');
	        }
	      } else {
	        this.notasCadastradas.push(nota);
	        this.table.items = this.notasCadastradas;
	        this.$forceUpdate();
	      }
	
	      this.cronograma.itens.forEach(function (item) {
	        if (String(item.Id_item) === String(nota.fk_item_cronograma)) {
	          console.log('item', item);
	
	          item.Qtde_solicitado = 1;
	
	          item.Valor_solicitado += parseFloat(nota.valor_documento);
	        }
	      });
	
	      this.parcelaSelecionada.valor_gravado = parseFloat(this.parcelaSelecionada.valor_gravado) + parseFloat(nota.valor_documento);
	      this.parcelaSelecionada.valor_gravado = this.parcelaSelecionada.valor_gravado.toFixed(2);
	      this.editandoNota = false;
	
	      this.tableDataKey++;
	      this.$forceUpdate();
	
	      this.atualizarSaldoItens();
	    },
	    atualizarSaldoItens: function atualizarSaldoItens() {
	      var _this13 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	        var response, cronogramaAtualizado;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _context10.prev = 0;
	                _context10.next = 3;
	                return axiosLaravel.post('processos/cronograma/projeto/', {
	                  'proposta': _this13.$route.params.id,
	                  'processo': 'PRESTACAO_DE_CONTAS',
	                  'aglutinado': 'Completo',
	                  'documento': 1
	                });
	
	              case 3:
	                response = _context10.sent;
	                cronogramaAtualizado = response.data;
	
	                if (cronogramaAtualizado && cronogramaAtualizado.itens) {
	                  _this13.cronograma.itens.forEach(function (item) {
	                    var itemAtualizado = cronogramaAtualizado.itens.find(function (i) {
	                      return String(i.Id_item) === String(item.Id_item);
	                    });
	                    if (itemAtualizado) {
	                      item.Valor_saldo = itemAtualizado.Valor_saldo;
	                      item.Qtde_saldo = itemAtualizado.Qtde_saldo;
	                    }
	                  });
	                  _this13.$forceUpdate();
	                }
	                _context10.next = 12;
	                break;
	
	              case 8:
	                _context10.prev = 8;
	                _context10.t0 = _context10['catch'](0);
	
	                console.error('Erro ao atualizar saldo dos itens:', _context10.t0);
	                _this13.$root.trataErro(_context10.t0);
	
	              case 12:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this13, [[0, 8]]);
	      }))();
	    },
	    downloadAnexo: function downloadAnexo(documento) {
	      var _this14 = this;
	
	      this.$aguarde('Baixando anexo: ' + documento.ds_nome_arquivo);
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	        _this14.$snotify.clear();
	      }).catch(function (error) {
	        _this14.$snotify.clear();
	        console.log(error);
	        _this14.$root.trataErro(error);
	      });
	    },
	    onDownloadZIP: function onDownloadZIP() {
	      var _this15 = this;
	
	      this.$forceUpdate();
	      this.$aguarde('Baixando arquivos. Por favor, aguarde...');
	      axiosLaravel({
	        url: 'prestacaoSimplificada/downloadArquivosPrestacaoSimplificada/' + this.parcelaSelecionada.id,
	        method: 'GET',
	        responseType: 'blob'
	      }).then(function (response) {
	        var blob = new Blob([response.data], { type: 'application/zip' });
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.setAttribute('download', (0, _moment2.default)().format('DDMMYYYYhhmmss') + '-' + 'prestacao-simplificada-documentos-cadastrados-' + _this15.dadosComplementares.numeroProjeto + '.zip');
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	        _this15.$snotify.clear();
	      }).catch(function (error) {
	        _this15.$snotify.clear();
	        _this15.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadDocumentosPhpPrestacao = __webpack_require__(255);
	
	var _uploadDocumentosPhpPrestacao2 = _interopRequireDefault(_uploadDocumentosPhpPrestacao);
	
	var _cpfCnpjValidator = __webpack_require__(232);
	
	var _cnpj = __webpack_require__(122);
	
	var _cnpj2 = _interopRequireDefault(_cnpj);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    uploadDocumentosPhpPrestacao: _uploadDocumentosPhpPrestacao2.default
	  },
	  name: 'cronogramaGED',
	  data: function data() {
	    return {
	      loading: {
	        tela: false,
	        documentos: false
	      },
	      moment: _moment2.default,
	      notaRepetida: {
	        necessidade: false,
	        responsabilidade: false
	      },
	      layoutExtrato: 'classico',
	      processo: 'PRESTACAO_DE_CONTAS',
	      editando: false,
	      notaJaCadastrada: false,
	      notaJaCadastradaNestaPrestacao: false,
	      editandoNotaCadastrada: false,
	      cancelandoEdicao: false,
	      nota: {
	        fk_prestacao_simplificada: null,
	        numero_documento: null,
	        serie_documento: null,
	        data_emissao_documento: null,
	        data_validade_documento: null,
	        valor_documento: null,
	        fornecedor_tipo: null,
	        fornecedor_cpf_cnpj: null,
	        fornecedor_nome: null,
	        fornecedor_endereco: null,
	        fornecedor_cep: null,
	        fornecedor_codigo: null,
	        cidadeFornecedor: null,
	        estadoFornecedor: null,
	        item: null,
	        item_cronograma: null,
	        fk_item_cronograma: null,
	        anexos: []
	      },
	      notaBackup: {},
	      extratoFiltrosSelecionados: [],
	      entidade: {},
	      projeto: {},
	      restricaoParaConcluir: [],
	      contasFinanceiras: ['S0632', 'P1158', 'S0633', 'P1157', 'S0634']
	    };
	  },
	
	  props: {
	    cronograma: Object,
	    setNota: Function,
	    dataInicioSapiens: String,
	    dataInicial: String,
	    dataFinal: String,
	    cnpjEntidade: String,
	    fkPrestacaoSimplificada: Number,
	    notasCadastradas: Array,
	    acertoValoresCancelamentoEdicaoCronograma: Function,
	    idEntidade: Number
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {
	    this.addErrors();
	  },
	  mounted: function mounted() {},
	  methods: {
	    initEdicao: function initEdicao(nota) {
	      var _this = this;
	
	      this.nota = _.cloneDeep(nota);
	      this.notaBackup = _.cloneDeep(nota);
	      this.cronograma.itens.forEach(function (item) {
	        if (String(item.Id_item) === String(_this.nota.fk_item_cronograma)) {
	          _this.nota.itemOrcamento = _.cloneDeep(item);
	        }
	      });
	      this.nota.valor_documento = parseFloat(this.nota.valor_documento);
	      this.loading.documentos = false;
	      this.loading.tela = false;
	      this.editando = true;
	      this.editandoNotaCadastrada = true;
	      this.scrollToDiv();
	    },
	    verificaValidacao: function verificaValidacao() {
	      var _this2 = this;
	
	      if (this.notaRepetida.necessidade && this.notaRepetida.responsabilidade) {
	        this.$validator.validateAll().then(function (result) {
	          if (result) {
	            _this2.notaJaCadastradaNestaPrestacao = false;
	
	            var sufixo = _this2.pegaProximoSulfixoNota();
	            _this2.nota.numero_documento = _this2.nota.numero_documento + sufixo;
	            _this2.$snotify.success('Sulfixo adicionado a nota, tente adicionar novamente.');
	          } else {
	            _this2.$snotify.warning('Por favor, preencha os campos obrigatórios.');
	          }
	        });
	      } else {
	        this.$snotify.warning('Por favor, marque os dois campos de ciência.');
	      }
	    },
	    desvinculaAnexo: function desvinculaAnexo(idAnexo) {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('desvinculando anexo');
	                _this3.loading.documentos = true;
	                _context.next = 4;
	                return axiosLaravel.post('prestacaoSimplificada/desvinculaAnexo/' + idAnexo).then(function (response) {
	                  if (response.data.codigo === 'OK') {
	                    _this3.$snotify.success('Anexo excluído com sucesso');
	
	                    _this3.nota.anexos = _.filter(_this3.nota.anexos, function (anexo) {
	                      return anexo.id !== idAnexo;
	                    });
	                    _this3.loading.documentos = false;
	                  } else {
	                    _this3.$snotify.error(response.data.mensagem);
	                  }
	                }).catch(function (error) {
	                  console.error(error);
	                  _this3.loading.documentos = false;
	                  _this3.$snotify.clear();
	                  _this3.$root.trataErro(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    pegaProximoSulfixoNota: function pegaProximoSulfixoNota() {
	      var _this4 = this;
	
	      var sulfixo = '';
	      var numeroDocumento = this.nota.numero_documento;
	
	      var regexNumero = /^(\d+)([A-Z]\d*|)$/;
	      var matchNota = numeroDocumento.match(regexNumero);
	      var numeroBase = matchNota ? matchNota[1] : numeroDocumento;
	
	      var notasComMesmoNumero = this.notasCadastradas.filter(function (nota) {
	        var match = nota.numero_documento.match(regexNumero);
	        var baseNota = match ? match[1] : nota.numero_documento;
	        return baseNota === numeroBase && nota.fornecedor_cpf_cnpj === _this4.nota.fornecedor_cpf_cnpj;
	      });
	      if (notasComMesmoNumero.length === 0) {
	        return 'A';
	      }
	
	      var sufixos = notasComMesmoNumero.map(function (nota) {
	        var match = nota.numero_documento.match(regexNumero);
	        return match ? match[2] || '' : '';
	      });
	      sufixos = sufixos.filter(function (s) {
	        return s;
	      });
	      console.log('Sufixos limpos:', sufixos);
	
	      sufixos.sort(function (a, b) {
	        var regex = /^([A-Z])(\d*)$/;
	        var matchA = a.match(regex);
	        var matchB = b.match(regex);
	        if (matchA && matchB) {
	          if (matchA[1] !== matchB[1]) {
	            return matchA[1].localeCompare(matchB[1]);
	          }
	          var numA = parseInt(matchA[2] || '0', 10);
	          var numB = parseInt(matchB[2] || '0', 10);
	          return numA - numB;
	        }
	        return a.localeCompare(b);
	      });
	      var ultimoSufixo = sufixos[sufixos.length - 1];
	      console.log('Último sufixo limpo:', ultimoSufixo);
	
	      if (/^[A-Z]$/.test(ultimoSufixo)) {
	        if (ultimoSufixo === 'Z') {
	          sulfixo = 'A1';
	        } else {
	          sulfixo = String.fromCharCode(ultimoSufixo.charCodeAt(0) + 1);
	        }
	      } else if (/^[A-Z]\d+$/.test(ultimoSufixo)) {
	        var letra = ultimoSufixo.charAt(0);
	        var numero = parseInt(ultimoSufixo.substring(1), 10);
	        sulfixo = letra + (numero + 1);
	      } else {
	        sulfixo = 'A';
	      }
	      console.log('Próximo sufixo:', sulfixo);
	      return sulfixo;
	    },
	    toggleEdicao: function toggleEdicao(valor) {
	      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var cancelando = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (this.editandoNotaCadastrada && cancelando) {
	        this.acertoValoresCancelamentoEdicaoCronograma(this.notaBackup);
	      }
	      this.loading.documentos = false;
	      this.loading.tela = false;
	      this.editandoNotaCadastrada = false;
	      this.editando = valor;
	
	      this.limparCamposNota();
	      console.log('TOGGLE EDICAO');
	
	      if (valor) {
	        this.nota.itemOrcamento = _.cloneDeep(item);
	        this.notaRepetida.necessidade = false;
	        this.notaRepetida.responsabilidade = false;
	        this.scrollToDiv();
	      }
	    },
	    scrollToDiv: function scrollToDiv() {
	      setTimeout(function () {
	        var element = document.getElementById('cadastroDocumento');
	        if (element) {
	          var elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
	          var offset = -200;
	          var targetPosition = elementPosition + offset;
	          window.scrollTo({
	            top: targetPosition,
	            behavior: 'smooth'
	          });
	        }
	      }, 200);
	    },
	    addErrors: function addErrors(field) {
	      this.$validator.extend('required', {
	        getMessage: function getMessage(field) {
	          return 'Campo obrigatório';
	        },
	        validate: function validate(value) {
	          return !!value;
	        }
	      });
	    },
	    limparCamposNota: function limparCamposNota() {
	      this.nota = {
	        fk_prestacao_simplificada: null,
	        numero_documento: null,
	        serie_documento: null,
	        data_emissao_documento: null,
	        data_validade_documento: null,
	        valor_documento: 0,
	        fornecedor_tipo: null,
	        fornecedor_cpf_cnpj: null,
	        fornecedor_nome: null,
	        fornecedor_endereco: null,
	        fornecedor_cep: null,
	        fornecedor_codigo: null,
	        cidadeFornecedor: null,
	        estadoFornecedor: null,
	        item: null,
	        item_cronograma: null,
	        fk_item_cronograma: null,
	        anexos: []
	      };
	      this.notaBackup = {};
	    },
	    salvarNota: function salvarNota() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var validacao, usuario, obj, alteracao;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this5.loading.documentos = true;
	                _context2.next = 3;
	                return _this5.validaCamposNota();
	
	              case 3:
	                validacao = _context2.sent;
	
	                if (!(validacao === false)) {
	                  _context2.next = 7;
	                  break;
	                }
	
	                _this5.loading.documentos = false;
	                return _context2.abrupt('return');
	
	              case 7:
	                _this5.nota.fk_prestacao_simplificada = _this5.fkPrestacaoSimplificada;
	                _this5.nota.fk_item_cronograma = _this5.nota.itemOrcamento.Id_item;
	                _this5.nota.item_cronograma = _this5.nota.itemOrcamento.Item + ' / ' + _this5.nota.itemOrcamento.Item_Descricao;
	
	                if (_this5.nota.data_emissao_documento) {
	                  _this5.nota.data_emissao_documento = _moment2.default.utc(_this5.nota.data_emissao_documento).format('YYYY-MM-DD');
	                }
	                if (_this5.nota.data_validade_documento) {
	                  _this5.nota.data_validade_documento = _moment2.default.utc(_this5.nota.data_validade_documento).format('YYYY-MM-DD');
	                }
	                usuario = _this5.usuarioLogado.userType === 'FUNDACAO' ? _this5.usuarioLogado.ds_nome_usuario + ' (' + _this5.usuarioLogado.ds_login + ')' : _this5.usuarioLogado.ds_nome_usuario;
	                obj = {
	                  idProposta: _this5.$route.params.id,
	                  nota: _this5.nota,
	                  usuario: usuario
	                };
	
	                if (!_this5.editandoNotaCadastrada) {
	                  _context2.next = 27;
	                  break;
	                }
	
	                alteracao = _this5.verificarCamposAlterados();
	
	                if (!(alteracao === false)) {
	                  _context2.next = 20;
	                  break;
	                }
	
	                _this5.loading.documentos = false;
	                _this5.$snotify.warning('Não foram encontradas diferenças de Edição. Clique em CANCELAR ou verifique os campos e tente novamente.');
	                return _context2.abrupt('return');
	
	              case 20:
	                obj = {
	                  idProposta: _this5.$route.params.id,
	                  nota: _this5.nota,
	                  notaBackup: _this5.notaBackup,
	                  usuario: usuario
	                };
	                _this5.$aguarde('Editando Alterações no Documento Fiscal. Por favor, aguarde...');
	                _context2.next = 24;
	                return axiosLaravel.post('prestacaoSimplificada/atualizaNota', obj).then(function (response) {
	                  if (response.data.codigo === 'OK') {
	                    _this5.$snotify.clear();
	                    _this5.$snotify.success('Nota atualizada com sucesso');
	                    console.log('response', response.data);
	
	                    _this5.nota = response.data.nota;
	
	                    _this5.setNota(_this5.nota, true);
	                    _this5.toggleEdicao(false);
	                    _this5.loading.documentos = false;
	                  } else {
	                    _this5.$snotify.error(response.data.mensagem);
	                  }
	                }).catch(function (error) {
	                  console.error(error.data);
	                  if (error.response.status === 413) {
	                    _this5.$snotify.error('O tamanho do arquivo é muito grande. O tamanho máximo permitido é de 4MB.');
	                  } else {
	                    _this5.$snotify.error('Erro ao tentar salvar a nota. Tente novamente mais tarde.');
	                  }
	                  _this5.loading.documentos = false;
	                  _this5.$snotify.clear();
	                  _this5.$root.trataErro(error);
	                });
	
	              case 24:
	                return _context2.abrupt('return');
	
	              case 27:
	                _this5.$aguarde('Gravando Documento Fiscal. Por favor, aguarde...');
	                _context2.next = 30;
	                return axiosLaravel.post('prestacaoSimplificada/gravaNota', obj).then(function (response) {
	                  if (response.data.codigo === 'OK') {
	                    _this5.$snotify.clear();
	                    _this5.$snotify.success('Nota adicionada com sucesso');
	                    console.log('response', response.data);
	
	                    _this5.nota = response.data.nota;
	
	                    _this5.setNota(_this5.nota, false);
	                    _this5.toggleEdicao(false);
	                    _this5.loading.documentos = false;
	                  } else {
	                    _this5.loading.documentos = false;
	                    _this5.$snotify.error(response.data.mensagem);
	                  }
	                }).catch(function (error) {
	                  _this5.loading.documentos = false;
	                  console.error(error.data.status);
	                  if (error.response.status === 413) {
	                    _this5.$snotify.error('O tamanho do arquivo é muito grande. O tamanho máximo permitido é de 4MB.');
	                  } else {
	                    _this5.$snotify.error('Erro ao tentar salvar a nota. Tente novamente mais tarde.');
	                  }
	                  _this5.$snotify.clear();
	                  _this5.$root.trataErro(error);
	                });
	
	              case 30:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this5);
	      }))();
	    },
	    limitaFaixaEntrada: function limitaFaixaEntrada(tipo, valor, minimo, maximo) {
	      if (_.isNil(valor) && _.isNull(valor) && _.isNaN(valor)) {
	        valor = minimo;
	      } else {
	        if (tipo === 'inteiro') {
	          valor = _.toSafeInteger(('' + valor).replace(/\D+/g, ''));
	        } else if (tipo === 'decimal') {
	          valor = _.toNumber(('' + valor).replace(/[^.0-9]+/g, ''));
	        }
	        valor = valor <= minimo ? minimo : valor >= maximo ? maximo : valor;
	      }
	      return tipo === 'inteiro' ? parseInt(valor) : tipo === 'decimal' ? parseFloat(valor) : valor;
	    },
	    limitaFaixaEntradaInput: function limitaFaixaEntradaInput(tipo, valor, minimo, maximo) {
	      maximo = Math.round(maximo * 100) / 100;
	      if (_.isNil(valor) && _.isNull(valor) && _.isNaN(valor)) {
	        valor = minimo;
	      } else {
	        if (tipo === 'inteiro') {
	          valor = _.toSafeInteger(('' + valor).replace(/\D+/g, ''));
	        } else if (tipo === 'decimal') {
	          valor = _.toNumber(('' + valor).replace(/[^.0-9]+/g, ''));
	        }
	        console.log(valor, maximo);
	        if (valor > maximo) {
	          this.$snotify.warning('Valor máximo permitido é R$' + maximo.toFixed(2));
	          return 0;
	        }
	        valor = valor <= minimo ? minimo : valor >= maximo ? maximo : valor;
	      }
	      return tipo === 'inteiro' ? parseInt(valor) : tipo === 'decimal' ? parseFloat(valor) : valor;
	    },
	    verificaCpfCnpjSapiens: function verificaCpfCnpjSapiens(CpfCnpj) {
	      var _this6 = this;
	
	      console.log(CpfCnpj);
	      if (_.isNull(CpfCnpj) || _.isEmpty(CpfCnpj) || _.isUndefined(CpfCnpj)) {
	        return;
	      }
	      if (_.isString(this.validandoCpfCnpj())) {} else {
	        this.loading.tela = true;
	        axiosLaravel.get('consulta/busca-fornecedor/' + CpfCnpj).then(function (response) {
	          if (!_.isEmpty(response.data)) {
	            _this6.nota.fornecedor_endereco = response.data.EndFor;
	            _this6.nota.fornecedor_nome = response.data.NomFor;
	            _this6.nota.fornecedor_cep = response.data.CepFor;
	            _this6.nota.fornecedor_codigo = response.data.CodFor;
	            _this6.bloqueiaCamposFornecedorExistente = true;
	            _this6.procurandoCidadeUF();
	          }
	          _this6.loading.tela = false;
	          _this6.$forceUpdate();
	        }).catch(function (error) {
	          _this6.loading.tela = false;
	          console.error(error);
	          _this6.$snotify.clear();
	        });
	      }
	    },
	    validandoCpfCnpj: function validandoCpfCnpj() {
	      if (this.nota.tipoFornecedor === 'Pessoa Física') {
	        this.nota.cpfFornecedor = _.padStart(this.nota.cpfFornecedor, 11, '0');
	        return _cpfCnpjValidator.cpf.isValid(this.nota.cpfFornecedor) ? true : 'CPF inválido';
	      }
	      if (this.nota.tipoFornecedor === 'Pessoa Jurídica') {
	        this.nota.cnpjFornecedor = _.padStart(this.nota.cnpjFornecedor, 14, '0');
	        return (0, _cnpj2.default)(this.nota.cnpjFornecedor) ? true : 'CNPJ inválido';
	      }
	    },
	    procurandoCidadeUF: function procurandoCidadeUF() {
	      var _this7 = this;
	
	      if (this.nota.fornecedor_cep) {
	        axiosLaravel.get('municipios/cep/' + this.nota.fornecedor_cep).then(function (response) {
	          if (!_.isEmpty(response.data) && !_.isString(response.data)) {
	            _this7.nota.cidadeFornecedor = response.data.ds_nome;
	            _this7.nota.estadoFornecedor = response.data.ds_uf;
	            _this7.$forceUpdate();
	          }
	        }).catch(function (error) {
	          _this7.$root.trataErro(error);
	          _this7.$forceUpdate();
	        });
	      } else {
	        this.nota.cidadeFornecedor = '';
	        this.nota.estadoFornecedor = '';
	        this.$forceUpdate();
	      }
	    },
	    adicionaRestricao: function adicionaRestricao(ev) {
	      if (!_.isNil(ev) && _.has(ev, 'tag')) {
	        _.remove(this.restricaoParaConcluir, function (i) {
	          return i.tag === ev.tag;
	        });
	
	        this.restricaoParaConcluir.push(ev);
	      }
	    },
	    removeRestricao: function removeRestricao(ev) {
	      _.remove(this.restricaoParaConcluir, function (i) {
	        return i.tag === ev.tag;
	      });
	    },
	    validaCamposNota: function validaCamposNota() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var valido, notaExistente, notaExisteSapiens, temEmpresaLigada, cpfVinculadoEntidade, dataEmissao;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this8.notaJaCadastrada = false;
	                _context3.next = 3;
	                return _this8.$validator.validateAll().then(function (validado) {
	                  if (!validado) {
	                    _this8.$snotify.error('Preencha todos os campos obrigatórios');
	                    var errors = _this8.$validator.errors.items;
	                    console.log(errors);
	                    return false;
	                  } else {
	                    return true;
	                  }
	                });
	
	              case 3:
	                valido = _context3.sent;
	
	                if (!(valido === false)) {
	                  _context3.next = 6;
	                  break;
	                }
	
	                return _context3.abrupt('return', false);
	
	              case 6:
	                if (!(_this8.notasCadastradas.length > 0)) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                notaExistente = _this8.notasCadastradas.find(function (item) {
	                  return item.numero_documento === _this8.nota.numero_documento && item.fornecedor_cpf_cnpj === _this8.nota.fornecedor_cpf_cnpj;
	                });
	
	                if (!(notaExistente && !_this8.editandoNotaCadastrada)) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                _this8.notaJaCadastradaNestaPrestacao = true;
	                _this8.$snotify.error('Já existe uma nota cadastrada com o mesmo número: ' + _this8.nota.numero_documento + ' e mesmo CPF/CNPJ do fornecedor: ' + _this8.nota.fornecedor_cpf_cnpj);
	                return _context3.abrupt('return', false);
	
	              case 12:
	                notaExisteSapiens = false;
	
	                if (!(!_this8.editandoNotaCadastrada || _this8.editandoNotaCadastrada && _this8.nota.numero_documento !== _this8.notaBackup.numero_documento)) {
	                  _context3.next = 20;
	                  break;
	                }
	
	                _context3.next = 16;
	                return _this8.verificaExisteNota();
	
	              case 16:
	                notaExisteSapiens = _context3.sent;
	
	                console.log('NOTA EXISTE NO SISTEMA', notaExisteSapiens);
	
	                if (!notaExisteSapiens) {
	                  _context3.next = 20;
	                  break;
	                }
	
	                return _context3.abrupt('return', false);
	
	              case 20:
	                console.log('NOTA NAO EXISTE NO SISTEMA');
	
	                console.log('verificaCnpjEmpresaLigada', _this8.nota.fornecedor_tipo);
	
	                if (!(_this8.nota.fornecedor_tipo === 'Pessoa Jurídica')) {
	                  _context3.next = 32;
	                  break;
	                }
	
	                temEmpresaLigada = false;
	                _context3.next = 26;
	                return _this8.verificaEmpresaLigada();
	
	              case 26:
	                temEmpresaLigada = _context3.sent;
	
	                console.log('temEmpresaLigada', temEmpresaLigada);
	
	                if (!temEmpresaLigada) {
	                  _context3.next = 30;
	                  break;
	                }
	
	                return _context3.abrupt('return', false);
	
	              case 30:
	                _context3.next = 40;
	                break;
	
	              case 32:
	                if (!(_this8.nota.fornecedor_tipo === 'Pessoa Física')) {
	                  _context3.next = 40;
	                  break;
	                }
	
	                cpfVinculadoEntidade = false;
	                _context3.next = 36;
	                return _this8.validaDirigentes();
	
	              case 36:
	                cpfVinculadoEntidade = _context3.sent;
	
	                console.log('cpfVinculadoEntidade', cpfVinculadoEntidade);
	
	                if (!cpfVinculadoEntidade) {
	                  _context3.next = 40;
	                  break;
	                }
	
	                return _context3.abrupt('return', false);
	
	              case 40:
	                if (!_this8.nota.data_emissao_documento) {
	                  _context3.next = 45;
	                  break;
	                }
	
	                dataEmissao = (0, _moment2.default)(_this8.nota.data_emissao_documento).utc();
	
	                if (!((0, _moment2.default)(dataEmissao, 'DD/MM/YYYY').isBefore((0, _moment2.default)(_this8.dataInicial, 'DD/MM/YYYY')) || (0, _moment2.default)(dataEmissao, 'DD/MM/YYYY').isAfter((0, _moment2.default)(_this8.dataFinal, 'DD/MM/YYYY')))) {
	                  _context3.next = 45;
	                  break;
	                }
	
	                _this8.$snotify.error('Data de Emissão da Nota fora do prazo de execução do projeto');
	                return _context3.abrupt('return', false);
	
	              case 45:
	                if (!(_this8.nota.anexos.length === 0)) {
	                  _context3.next = 48;
	                  break;
	                }
	
	                _this8.$snotify.error('Anexe o documento fiscal.');
	                return _context3.abrupt('return', false);
	
	              case 48:
	                return _context3.abrupt('return', true);
	
	              case 49:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this8);
	      }))();
	    },
	    verificaExisteNota: function verificaExisteNota() {
	      var _this9 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var obj, resp;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(_this9.notaRepetida.necessidade && _this9.notaRepetida.responsabilidade)) {
	                  _context4.next = 2;
	                  break;
	                }
	
	                return _context4.abrupt('return', false);
	
	              case 2:
	                _this9.$aguarde('Verificando se já existe nota cadastrada no sistema...');
	                obj = {
	                  nota: _this9.nota
	                };
	                _context4.prev = 4;
	                _context4.next = 7;
	                return axiosLaravel.post('prestacaoSimplificada/verificaExisteNota', obj);
	
	              case 7:
	                resp = _context4.sent;
	
	                _this9.$snotify.clear();
	                console.log('RESPONSE: ', resp.data);
	
	                if (!(resp.data.codigo === 'OK')) {
	                  _context4.next = 14;
	                  break;
	                }
	
	                return _context4.abrupt('return', false);
	
	              case 14:
	                _this9.$snotify.error(resp.data.mensagem);
	                return _context4.abrupt('return', true);
	
	              case 16:
	                _context4.next = 25;
	                break;
	
	              case 18:
	                _context4.prev = 18;
	                _context4.t0 = _context4['catch'](4);
	
	                _this9.$snotify.clear();
	                console.error(_context4.t0);
	
	                console.log('ERROR', _context4.t0.response.status);
	                if (_context4.t0.response.status === 413) {
	                  _this9.$snotify.error('O tamanho do arquivo é muito grande. O tamanho máximo permitido é de 4MB.');
	                } else {
	                  _this9.$snotify.error('Erro ao tentar salvar a nota. Tente novamente mais tarde.');
	                }
	                return _context4.abrupt('return', true);
	
	              case 25:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this9, [[4, 18]]);
	      }))();
	    },
	    verificaEmpresaLigada: function verificaEmpresaLigada() {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var obj, resp;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this10.$aguarde('Verificando se o CNPJ está em lista de empresas ligadas aos dirigentes da entidade parceira nos últimos 12 meses após seu desligamento...');
	                obj = {
	                  id: _this10.idEntidade,
	                  cnpj: _this10.nota.fornecedor_cpf_cnpj
	                };
	                _context5.prev = 2;
	                _context5.next = 5;
	                return axiosLaravel.post('prestacaoSimplificada/verificaEmpresaLigada', obj);
	
	              case 5:
	                resp = _context5.sent;
	
	                _this10.$snotify.clear();
	                console.log('RESPONSE: ', resp.data);
	
	                if (!(resp.data.codigo === 'OK')) {
	                  _context5.next = 17;
	                  break;
	                }
	
	                if (!(resp.data.retorno > 0)) {
	                  _context5.next = 14;
	                  break;
	                }
	
	                _this10.$snotify.error('CNPJ vinculado a dirigente ativo, não é possível cadastrar.');
	                return _context5.abrupt('return', true);
	
	              case 14:
	                return _context5.abrupt('return', false);
	
	              case 15:
	                _context5.next = 19;
	                break;
	
	              case 17:
	                _this10.$snotify.error(resp.data.mensagem);
	                return _context5.abrupt('return', true);
	
	              case 19:
	                _context5.next = 27;
	                break;
	
	              case 21:
	                _context5.prev = 21;
	                _context5.t0 = _context5['catch'](2);
	
	                _this10.$snotify.clear();
	                console.error(_context5.t0);
	                _this10.$root.trataErro(_context5.t0);
	                return _context5.abrupt('return', true);
	
	              case 27:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this10, [[2, 21]]);
	      }))();
	    },
	    validaDirigentes: function validaDirigentes() {
	      var _this11 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        var obj, resp;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this11.$aguarde('Verificando CPF do Fornecedor...');
	                obj = {
	                  cpf: _this11.nota.fornecedor_cpf_cnpj,
	                  cnpj: _this11.cnpjEntidade
	                };
	                _context6.prev = 2;
	                _context6.next = 5;
	                return axiosLaravel.post('prestacaoSimplificada/validaDirigentes', obj);
	
	              case 5:
	                resp = _context6.sent;
	
	                _this11.$snotify.clear();
	                console.log('RESPONSE: ', resp.data);
	
	                if (!(resp.data.codigo === 'OK')) {
	                  _context6.next = 12;
	                  break;
	                }
	
	                return _context6.abrupt('return', false);
	
	              case 12:
	                _this11.$snotify.error(resp.data.mensagem);
	                return _context6.abrupt('return', true);
	
	              case 14:
	                _context6.next = 22;
	                break;
	
	              case 16:
	                _context6.prev = 16;
	                _context6.t0 = _context6['catch'](2);
	
	                _this11.$snotify.clear();
	                console.error(_context6.t0);
	                _this11.$root.trataErro(_context6.t0);
	                return _context6.abrupt('return', true);
	
	              case 22:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this11, [[2, 16]]);
	      }))();
	    },
	    verificarCamposAlterados: function verificarCamposAlterados() {
	      console.log('Verificando campos alterados');
	      console.log('NOTA', this.nota);
	      console.log('NOTA BACKUP', this.notaBackup);
	      var diferencas = this.encontrarDiferencas(this.nota, this.notaBackup);
	      console.log('DIFS JS', diferencas);
	      if ((0, _keys2.default)(diferencas).length > 0) {
	        return true;
	      }
	      return false;
	    },
	    encontrarDiferencas: function encontrarDiferencas(obj1, obj2) {
	      var difs = {};
	      for (var key in obj1) {
	        if (String(obj1[key]) !== String(obj2[key])) {
	          difs[key] = { valor1: obj1[key], valor2: obj2[key] };
	        }
	      }
	      _.unset(difs, 'itemOrcamento');
	      return difs;
	    },
	    formatarNumeroDocumento: function formatarNumeroDocumento(event) {
	      var valor = event.target.value;
	
	      valor = valor.replace(/\D/g, '');
	
	      valor = valor.replace(/^0+/, '');
	
	      this.nota.numero_documento = valor;
	    }
	  }
	};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'downloadArquivoPrestacao',
	  data: function data() {
	    return {
	      layoutExtrato: 'classico',
	      documentoBaixado: {}
	    };
	  },
	
	  props: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {},
	  mounted: function mounted() {
	    console.log('BAIXANDO ARQUIVO...');
	    if (this.usuarioLogado.userType === 'FUNDACAO') {
	      this.getDocumento(this.$route.params.id);
	    } else {
	      this.$snotify.error('Você não tem permissão para acessar esta rota.');
	      this.$router.push({ name: '/dashboard' });
	    }
	  },
	  methods: {
	    getDocumento: function getDocumento(id) {
	      var _this = this;
	
	      this.$aguarde('Procurando informações sobre o arquivo...');
	      axiosLaravel.get('prestacaoSimplificada/getDocumento/' + id).then(function (response) {
	        _this.documentoBaixado = response.data;
	        _this.downloadAnexo(id);
	      }).catch(function (error) {
	        _this.$snotify.clear();
	        _this.$snotify.error('Erro ao encontrar informações sobre o arquivo. Tente novamente mais tarde.');
	        console.log(error);
	        _this.$root.trataErro(error);
	      });
	    },
	    downloadAnexo: function downloadAnexo(id) {
	      var _this2 = this;
	
	      this.$aguarde('Baixando anexo...');
	      axiosLaravel.get('prestacaoSimplificada/downloadArquivoPorId/' + id, { responseType: 'arraybuffer' }).then(function (response) {
	        console.log(response.data);
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        var documento = _this2.documentoBaixado;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	        _this2.fecharAba();
	        _this2.$snotify.clear();
	      }).catch(function (error) {
	        _this2.$snotify.clear();
	        _this2.$snotify.error('Erro ao baixar o arquivo. Tente novamente mais tarde.');
	        console.log(error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    fecharAba: function fecharAba() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        _this3.$snotify.clear();
	        _this3.$router.push({ name: '/dashboard' });
	        window.close();
	      }, 2000);
	    }
	  }
	};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documentos-php-prestacao',
	  data: function data() {
	    return {
	      showGrid: true,
	      documentos: [],
	      documento: {
	        ds_nome_arquivo: ''
	      },
	      documentoTabela: {},
	      editando: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: 10 * 1024,
	      image: '',
	      arquivoAnalise: {},
	      analise: {},
	      textoOCR: {},
	      analisandoArquivo: false
	    };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'documentosObrigatorios', 'disable', 'localUso', 'desvinculaAnexo', 'disableAdd', 'restricaoArquivo'],
	  created: function created() {
	    var _this = this;
	
	    this.analise = {};
	    if (_.isUndefined(this.localUso)) {
	      this.localUso = 'TODOS';
	    }
	    if (this.localUso === 'TODOS') {
	      if (_.isEmpty(this.$store.state.uploadDocumentos.documentos)) {
	        axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	          _this.documentos = _this.$store.state.uploadDocumentos.documentos = _.sortBy(response.data, [function (o) {
	            return o.ds_tipo;
	          }]);
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	        });
	      } else {
	        this.documentos = this.$store.state.uploadDocumentos.documentos;
	      }
	    } else {
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this.documentos = _.sortBy(response.data, [function (o) {
	          return o.ds_tipo;
	        }]);
	        console.log('this.documentos', _this.documentos);
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	
	  methods: {
	    novoDocumento: function novoDocumento() {
	      this.showGrid = !this.showGrid;
	      this.documento = {};
	      this.analise = {};
	    },
	    existeDocumento: function existeDocumento(documento) {
	      return this.propDocumentos.some(function (item) {
	        if (documento.tipo_documento) {
	          return documento.tipo_documento.ds_tipo === item.tipo_documento.ds_tipo;
	        }
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var files;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('handleFileUpload', e);
	                files = e.target.files || e.dataTransfer.files;
	
	                _this3.arquivoAnalise = {};
	
	                if (!_this3.restricaoArquivo) {
	                  _context.next = 7;
	                  break;
	                }
	
	                _this3.arquivoAnalise = files[0];
	                _context.next = 7;
	                return _this3.OCRLocal();
	
	              case 7:
	                _this3.carregaArquivo(files[0]);
	
	                _this3.documento.ds_nome_arquivo = files[0].name;
	
	                _this3.documento.ds_content_type = files[0].type;
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this4 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this4.$validator.errors.all().length === 0) {
	          _this4.documento.dt_criado = new Date();
	          if (_this4.editando === true) {
	            for (var i in _this4.documento) {
	              _this4.documentoTabela[i] = _this4.documento[i];
	            }_this4.documentoTabela = (0, _assign2.default)({}, _this4.documento);
	          } else {
	            _this4.propDocumentos.push(_this4.documento);
	          }
	          _this4.onCancel();
	        }
	      });
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.$forceUpdate();
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento, documento) {
	      var vm = this;
	      this.$dialog.confirm('Confirma a exclusão do anexo? Essa ação <b>não</b> pode ser desfeita.', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        vm.propDocumentos.splice(indexDocumento, 1);
	        console.log('documento', documento);
	        if (documento.id) {
	          console.log('desvinculaAnexo', documento.id);
	          vm.desvinculaAnexo(documento.id);
	        }
	        vm.$forceUpdate();
	      }).catch(function () {
	        console.log('cancelado');
	      });
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    editaDocumento: function editaDocumento(documento) {
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	    },
	    extraiTextoArquivo: function extraiTextoArquivo() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var formData;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('extraiTextoArquivoEAnaliseGeneraAI');
	                _this5.analisandoArquivo = true;
	                _this5.analise = {};
	                formData = new FormData();
	
	                formData.append('arquivo', _this5.arquivoAnalise);
	                _this5.$snotify.info('Analisando arquivo', { timeout: 0 });
	                _context2.next = 8;
	                return axiosLaravel.post('http://localhost/api/extrairTexto', formData, {
	                  headers: {
	                    'Content-Type': 'multipart/form-data',
	                    'Accept': 'application/json'
	                  }
	                }).then(function (response) {
	                  console.log('extraiTextoArquivo response', response.data);
	                  _this5.analise = response.data;
	                  _this5.$snotify.clear();
	                  _this5.$snotify.success('Análise concluída. Continue com o cadastro do documento.', { timeout: 5000 });
	                  _this5.analisandoArquivo = false;
	                }).catch(function (error) {
	                  _this5.analisandoArquivo = false;
	                  console.log('error', error);
	                  _this5.$snotify.clear();
	                  _this5.$snotify.error('Erro ao analisar o arquivo. Tente novamente mais tarde.', { timeout: 5000 });
	                });
	
	              case 8:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this5);
	      }))();
	    },
	    extraiTextoSemIA: function extraiTextoSemIA() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var formData;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                console.log('extraiTexto');
	                _this6.analisandoArquivo = true;
	                _this6.analise = {};
	                formData = new FormData();
	
	                formData.append('arquivo', _this6.arquivoAnalise);
	                _this6.$snotify.info('Analisando arquivo', { timeout: 0 });
	                _context3.next = 8;
	                return axiosLaravel.post('https://iae.fbb.org.br/api/OCR', formData, {
	                  headers: {
	                    'Content-Type': 'multipart/form-data',
	                    'Accept': 'application/json'
	                  }
	                }).then(function (response) {
	                  console.log('extraiTextoArquivo response', response.data);
	
	                  if (!response.data.texto || response.data.texto.trim() === '') {
	                    _this6.$snotify.clear();
	                    _this6.$snotify.success('Análise concluída. Continue com o cadastro do documento.', { timeout: 5000 });
	                    _this6.analise.analise = { RESPOSTA: 'NÃO', DESCRITIVO: 'Documento inválido.' };
	                    _this6.analisandoArquivo = false;
	                    return;
	                  }
	                  _this6.analisarComIA(response.data.texto);
	                }).catch(function (error) {
	                  _this6.analisandoArquivo = false;
	                  console.log('error', error);
	                  _this6.$snotify.clear();
	                  _this6.$snotify.error('Erro ao analisar o arquivo. Tente novamente mais tarde.', { timeout: 5000 });
	                });
	
	              case 8:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this6);
	      }))();
	    },
	    OCRLocal: function OCRLocal() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var formData;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                console.log('OCRLocal');
	                _this7.analisandoArquivo = true;
	                _this7.analise = {};
	                formData = new FormData();
	
	                formData.append('arquivo', _this7.arquivoAnalise);
	                _this7.$snotify.info('Analisando arquivo', { timeout: 0 });
	                _context4.next = 8;
	                return axiosLaravel.post('/prestacaoSimplificada/chamarServiceOCR', formData, {
	                  headers: {
	                    'Content-Type': 'multipart/form-data',
	                    'Accept': 'application/json'
	                  }
	                }).then(function (response) {
	                  console.log('extraiTextoArquivo response', response.data);
	
	                  if (!response.data.resultado.texto || response.data.resultado.texto.trim() === '') {
	                    _this7.$snotify.clear();
	                    _this7.$snotify.success('Análise concluída. Continue com o cadastro do documento.', { timeout: 5000 });
	                    _this7.analise.analise = { RESPOSTA: 'NÃO', DESCRITIVO: 'Documento inválido.' };
	                    _this7.analisandoArquivo = false;
	                    return;
	                  } else {
	                    _this7.$snotify.clear();
	                    _this7.$snotify.success('Análise concluída. Continue com o cadastro do documento.', { timeout: 5000 });
	                    _this7.analisandoArquivo = false;
	                    _this7.$forceUpdate();
	                    _this7.analise = response.data.resultado;
	                  }
	                  console.log('Análise da IA:', _this7.analise);
	                }).catch(function (error) {
	                  _this7.analisandoArquivo = false;
	                  console.log('error', error);
	                  _this7.$snotify.clear();
	                  _this7.$snotify.error('Erro ao analisar o arquivo. Tente novamente mais tarde.', { timeout: 5000 });
	                });
	
	              case 8:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this7);
	      }))();
	    },
	    analisarComIA: function analisarComIA(input) {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var prompt, data, response, resposta;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                prompt = 'Analise o texto a seguir que foi extra\xEDdo de um OCR e responda com um JSON, contendo RESPOSTA: SIM ou N\xC3O, DESCRITIVO: Em 5 palavras, o que pode ser o documento enviado: o texto \xE9 um documento fiscal?\n\nTexto:\n' + input;
	
	                console.log('Pesquisando IA com o prompt:', prompt);
	                _this8.analisandoArquivo = true;
	                data = {
	                  input: prompt,
	                  intents: [{}],
	                  entities: [{}]
	                };
	                _context5.prev = 4;
	                _context5.next = 7;
	                return axiosLaravel.post('http://acs-assist-fbb-chatbot.nia.servicos.bb.com.br/assistente/', data);
	
	              case 7:
	                response = _context5.sent;
	                resposta = response.data.data.context.messages[1].content;
	
	                resposta = resposta.replace(/```json|```/g, '').trim();
	                try {
	                  _this8.analise.analise = JSON.parse(resposta);
	                } catch (e) {
	                  console.error('Erro ao parsear resposta da IA:', e);
	                  _this8.analise.analise = { RESPOSTA: 'NÃO', DESCRITIVO: 'Análise não concluída por erro de sistema.' };
	                }
	                console.log(resposta);
	                console.log('Análise da IA:', _this8.analise);
	                _this8.$snotify.clear();
	                _this8.$snotify.success('Análise concluída. Continue com o cadastro do documento.', { timeout: 5000 });
	                _this8.analisandoArquivo = false;
	                _this8.$forceUpdate();
	                _context5.next = 24;
	                break;
	
	              case 19:
	                _context5.prev = 19;
	                _context5.t0 = _context5['catch'](4);
	
	                _this8.analisandoArquivo = false;
	                console.error('Erro ao pesquisar IA:', _context5.t0);
	                _this8.$root.trataErro(_context5.t0);
	
	              case 24:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this8, [[4, 19]]);
	      }))();
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this9 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Subindo arquivo', { timeout: 0 });
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this9.documento = response.data.value;
	        if (_this9.editando === true) {
	          for (var i in _this9.documento) {
	            _this9.documentoTabela[i] = _this9.documento[i];
	          }_this9.documentoTabela = (0, _assign2.default)({}, _this9.documento);
	        } else {
	          _this9.propDocumentos.push(_this9.documento);
	        }
	        _this9.onCancel();
	        _this9.$snotify.clear();
	        _this9.$snotify.success('Arquivo salvo com sucesso');
	      }).catch(function (error) {
	        console.log('error', error);
	        _this9.$snotify.clear();
	        _this9.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'profiles',
	  data: function data() {
	    return {
	      perfis: {},
	      aux: {},
	      profile: this.propsProfile
	    };
	  },
	
	  props: ['propsProfile'],
	  watch: {
	    profile: function profile() {
	      this.$emit('profileSelected', this.profile);
	    },
	    propsProfile: function propsProfile() {
	      this.profile = this.propsProfile;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    axios.get('/proxy/account/profiles?tiny').then(function (response) {
	      _this.perfis = response.data.value;
	      for (var i = 0; i < _this.perfis.length; i++) {
	        if (_this.perfis[i].name !== 'Entidade CNPJ') {
	          _this.aux[i] = _this.perfis[i];
	        }
	      }
	      _this.perfis = _this.aux;
	    });
	  }
	};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'projetos',
	  data: function data() {
	    return {
	      selected: null,
	      showgrid: true,
	      state: 'GRID',
	      users: [],
	      curIndex: 0,
	      projeto: [],
	      entidade: [],
	      projetoNome: {},
	      proposta: [],
	      projetos: {},
	      filtro: {
	        createdBy: null
	      },
	      tabela: {
	        name: null,
	        proposal: {
	          entity: {
	            businessName: null,
	            cnpj: null
	          }
	        }
	      },
	      editandoIndex: null,
	      table: {
	        items: {
	          name: null,
	          proposal: {
	            entity: {
	              businessName: null,
	              cnpj: null
	            }
	          }
	        },
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'proposal.idProjectErp', label: 'Nº do Projeto', sortable: true, thStyle: 'text-align: center; width: 9%', class: 'text-center' }, { key: 'proposal.name', label: 'Nome do Projeto', sortable: true, thStyle: 'text-align: center; width: 50%', class: 'text-center' }, { key: 'proposal.entity.businessName', label: 'Entidade', sortable: true, thStyle: 'text-align: center; width: 12%', class: 'text-center' }, { key: 'proposal.entity.cnpj', label: 'CNPJ', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 8%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['ParcProjetos'],
	  watch: {
	    ParcProjetos: function ParcProjetos() {
	      var _this = this;
	
	      this.ParcProjetos.forEach(function (proposal) {
	        _this.table.items = proposal;
	      });
	      this.table.items = this.ParcProjetos;
	    },
	    'table.items': function tableItems() {
	      this.$emit('projetoAdicionado', this.table.items);
	    }
	  },
	  created: function created() {
	    if (this.ParcProjetos) {
	      this.table.items = this.ParcProjetos;
	    }
	    this.onSearch();
	  },
	
	  methods: {
	    onNew: function onNew() {
	      this.projetos = [];
	      this.state = 'FORM';
	      this.curIndex = -1;
	    },
	    escolhido: function escolhido(id) {
	      var _this2 = this;
	
	      axios.get('proxy/project/project-management/' + id).then(function (response) {
	        _this2.proposta = response.data.value;
	        _this2.entidade = _this2.proposta.proposal.entity;
	        $('#cnpj').val(_this2.entidade.cnpj);
	        $('#nome').val(_this2.entidade.businessName);
	        _this2.$forceUpdate();
	      });
	    },
	    onSearch: function onSearch() {
	      var _this3 = this;
	
	      axios.post('proxy/project/project-management/search/sql', this.filtro).then(function (response) {
	        _this3.projetos = response.data.value;
	        _this3.projetoNome = (0, _assign2.default)([], _this3.projetos);
	      });
	    },
	    onCancel: function onCancel() {
	      this.projetoNome = {};
	      this.state = 'GRID';
	      this.curIndex = -1;
	      this.onSearch();
	    },
	    onAdd: function onAdd() {
	      this.tabela.proposal.entity.businessName = this.entidade.businessName;
	      this.tabela.proposal.entity.cnpj = this.entidade.cnpj;
	      this.tabela.name = this.proposta.name;
	      console.log(this.table.items);
	      this.table.items.push(this.proposta);
	      this.$forceUpdate();
	      this.onCancel();
	    },
	    edita: function edita(row) {
	      this.state = 'FORM';
	      this.editandoIndex = row.index;
	      this.tabela = (0, _assign2.default)({}, row.item);
	      this.tabela = row.item;
	      this.$forceUpdate();
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'publicoAlvo',
	  data: function data() {
	    return {
	      perfis: {},
	      table: {
	        items: this.propsPublicosGrid,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'fonte.ds_descricao', label: 'Público Alvo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_participantes_diretos', label: 'Participantes Diretos', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_jovens', label: 'Jovens atendidos', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_mulheres', label: 'Mulheres atendidas', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }],
	        fields2: [{ key: 'fonte.ds_descricao', label: 'Público Alvo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_participantes_diretos', label: 'Participantes Diretos', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_jovens', label: 'Jovens atendidos', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_mulheres', label: 'Mulheres atendidas', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      mostraGridPublicoAlvo: true,
	      publicosAlvo: {},
	      publicosAlvoTabela: [],
	      publicoAlvo: {},
	      mulheresBool: null,
	      jovensBool: null,
	      editando: false,
	      formEditavel: !_.has(this.$route.params, 'numero'),
	
	      projetoAjudaHumanitaria: [20020, 20313, 20314, 20731, 21263, 21270, 21276, 21277, 21299, 21305, 21310, 21311, 20250, 21316, 20022, 20023, 20262].includes(parseInt(this.$route.params.numero))
	    };
	  },
	
	  props: ['propsPublicosGrid', 'editavel', 'somenteLeitura'],
	  computed: {},
	  watch: {
	    propsPublicosGrid: function propsPublicosGrid() {
	      this.table.items = this.propsPublicosGrid;
	    },
	    editavel: function editavel() {
	      this.formEditavel = this.editavel;
	    },
	    mostraGridPublicoAlvo: function mostraGridPublicoAlvo() {
	      this.$emit('validacaoPublicoAlvo', { 'tag': 'publicoditando', 'ativo': !this.mostraGridPublicoAlvo, 'tipo': 'restricao', 'acao': null, 'mensagem': '<span class=\'restricaoEditandoInformacao\'>Ainda está editando um Público-alvo<span>' });
	    }
	  },
	  mounted: function mounted() {
	    this.buscaPublicoAlvo();
	  },
	  methods: {
	    buscaPublicoAlvo: function buscaPublicoAlvo() {
	      var _this = this;
	
	      axiosLaravel.get('publico-alvo-fonte').then(function (response) {
	        _this.publicosAlvo = response.data;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    cancelaPublico: function cancelaPublico() {
	      this.publicoAlvo = {};
	      this.mulheresBool = null;
	      this.jovensBool = null;
	      this.mostraGridPublicoAlvo = true;
	      this.editando = false;
	    },
	    onAdd: function onAdd() {
	      var _this2 = this;
	
	      console.log('this.publicoAlvo.nr_jovens', this.publicoAlvo.nr_jovens);
	      console.log('this.publicoAlvo.nr_mulheres', this.publicoAlvo.nr_mulheres);
	      console.log('this.publicoAlvo.nr_participantes_diretos', this.publicoAlvo.nr_participantes_diretos);
	      if ((parseInt(this.publicoAlvo.nr_jovens) > parseInt(this.publicoAlvo.nr_participantes_diretos) || parseInt(this.publicoAlvo.nr_mulheres)) > parseInt(this.publicoAlvo.nr_participantes_diretos)) {
	        this.$snotify.error('O número de jovens ou mulheres excede o total de ' + this.publicoAlvo.nr_participantes_diretos + ' participantes diretos!');
	        return;
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.editando === true) {
	            for (var i in _this2.publicoAlvo) {
	              _this2.publicosAlvoTabela[i] = _this2.publicoAlvo[i];
	            }
	          } else {
	            _this2.table.items.push(_this2.publicoAlvo);
	          }
	          _this2.$emit('publicoAlvoAdicionado', _this2.table.items);
	          _this2.cancelaPublico();
	        }
	        var bc = new BroadcastChannel('propostas');
	        bc.postMessage({ acao: 'notificacaoAtualizacaoPublicoAlvo', id: _this2.$route.params.id });
	      });
	    },
	    edita: function edita(item) {
	      this.editando = true;
	      this.publicoAlvo = (0, _assign2.default)({}, item);
	      this.publicosAlvoTabela = item;
	      this.publicoAlvo.nr_mulheres ? this.mulheresBool = 'Sim' : this.mulheresBool = 'Não';
	      this.publicoAlvo.nr_jovens ? this.jovensBool = 'Sim' : this.jovensBool = 'Não';
	      this.mostraGridPublicoAlvo = false;
	    },
	    alteraJovens: function alteraJovens() {
	      this.publicoAlvo.nr_jovens = this.jovensBool === 'Sim' ? this.publicoAlvo.nr_jovens : 0;
	    },
	    alteraMulheres: function alteraMulheres() {
	      this.publicoAlvo.nr_mulheres = this.mulheresBool === 'Sim' ? this.publicoAlvo.nr_mulheres : 0;
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	      var bc = new BroadcastChannel('propostas');
	      bc.postMessage({ acao: 'notificacaoAtualizacaoPublicoAlvo', id: this.$route.params.id });
	    }
	  }
	};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'publicoAlvoDescricao',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      definicaoPublicoAlvo: {},
	      defAux: [],
	      definicoes: [],
	      editar: false
	    };
	  },
	
	  props: {
	    proposta: null,
	    fixado: Boolean,
	    permiteEditar: Boolean,
	    abrirAbas: Boolean,
	    telaProjeto: {
	      type: Boolean,
	      default: false
	    },
	    idParticipante: {
	      type: Number,
	      default: null
	    },
	    telaParticipante: {
	      type: Boolean,
	      default: false
	    },
	    tipoDescricao: {
	      type: String,
	      default: 'PREVISTO'
	    },
	    dataNascimentoEdit: {
	      type: String,
	      default: ''
	    },
	    sexoEdit: {
	      type: String,
	      default: ''
	    },
	    escolaridadeEdit: {
	      type: String,
	      default: ''
	    }
	  },
	  computed: {},
	  watch: {
	    dataNascimentoEdit: function dataNascimentoEdit(newValue, oldValue) {
	      console.log('MUDOU DE ', oldValue, 'PARA', newValue);
	      if (newValue.length >= 10) {
	        var parts = newValue.split('/');
	        var year = parts[2];
	        var yearNumber = parseInt(year, 10);
	        if (yearNumber >= 1946 && yearNumber <= 1964) {
	          this.updateSelecao(11, true, 'Geração');
	        } else if (yearNumber >= 1965 && yearNumber <= 1980) {
	          this.updateSelecao(12, true, 'Geração');
	        } else if (yearNumber >= 1981 && yearNumber <= 1996) {
	          this.updateSelecao(13, true, 'Geração');
	        } else if (yearNumber >= 1997 && yearNumber <= 2009) {
	          this.updateSelecao(14, true, 'Geração');
	        } else if (yearNumber >= 2010) {
	          this.updateSelecao(15, true, 'Geração');
	        }
	      }
	    },
	    sexoEdit: function sexoEdit(newValue, oldValue) {
	      console.log('MUDOU DE ', oldValue, 'PARA', newValue);
	      if (newValue === 'Masculino') {
	        this.updateSelecao(7, true, 'Identidade de Gênero');
	      } else if (newValue === 'Feminino') {
	        this.updateSelecao(8, true, 'Identidade de Gênero');
	      } else {
	        this.updateSelecao(9, true, 'Identidade de Gênero');
	      }
	    },
	    escolaridadeEdit: function escolaridadeEdit(newValue, oldValue) {
	      console.log('MUDOU DE ', oldValue, 'PARA', newValue);
	      if (newValue === 'Analfabeto') {
	        this.updateSelecao(27, true, 'Escolaridade');
	      } else if (newValue === 'Ensino Fundamental') {
	        this.updateSelecao(28, true, 'Escolaridade');
	      } else if (newValue === 'Ensino Médio') {
	        this.updateSelecao(29, true, 'Escolaridade');
	      } else {
	        this.updateSelecao(30, true, 'Escolaridade');
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.telaParticipante) {
	      this.editar = this.permiteEditar;
	      console.log(this.idParticipante);
	    }
	    this.buscaDefinicaoPublicoAlvo();
	  },
	  methods: {
	    buscaDefinicaoPublicoAlvo: function buscaDefinicaoPublicoAlvo() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.loading.show = true;
	                _context.next = 3;
	                return axiosLaravel.get('definicaoparticipante').then(function (response) {
	                  _this.definicaoPublicoAlvo = response.data;
	                  _this.definicaoPublicoAlvo.forEach(function (item) {
	                    item.aberto = _this.abrirAbas;
	                    item.subgrupos.forEach(function (item) {
	                      item.selecionado = false;
	                    });
	                  });
	                  if (!_this.telaParticipante) {
	                    console.log('BUSCA GRAVADAS', _this.telaParticipante);
	                    _this.buscaDefinicoesGravadas();
	                  }
	                  if (_this.idParticipante !== null) {
	                    _this.buscaDefinicoesParticipante();
	                  }
	                  _this.loading.show = false;
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                  _this.loading.show = false;
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    buscaDefinicoesGravadas: function buscaDefinicoesGravadas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.loading.show = true;
	                _context2.next = 3;
	                return axiosLaravel.get('/definicaoparticipante/getPrevistosProjeto/' + _this2.proposta).then(function (response) {
	                  _this2.definicoes = response.data;
	                  _this2.defAux = _this2.definicoes.slice();
	                  console.log('1 - DEFINICOES CHECKBOX', _this2.definicoes);
	                  _this2.initCheckbox();
	                  _this2.loading.show = false;
	                  _this2.$forceUpdate();
	                }).catch(function (error) {
	                  _this2.$root.trataErro(error);
	                  _this2.loading.show = false;
	                  _this2.$forceUpdate();
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    buscaDefinicoesParticipante: function buscaDefinicoesParticipante() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this3.loading.show = true;
	                _context3.next = 3;
	                return axiosLaravel.get('/definicaoparticipante/getRealizadosParticipante/' + _this3.idParticipante).then(function (response) {
	                  _this3.definicoes = response.data;
	                  console.log(_this3.definicoes);
	                  _this3.defAux = _this3.definicoes.slice();
	                  _this3.initCheckbox();
	                  _this3.loading.show = false;
	                  _this3.$forceUpdate();
	                }).catch(function (error) {
	                  _this3.$root.trataErro(error);
	                  _this3.loading.show = false;
	                  _this3.$forceUpdate();
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    initCheckbox: function initCheckbox() {
	      var _this4 = this;
	
	      console.log('2 - INIT CHECKBOX', this.definicaoPublicoAlvo, this.definicoes);
	      if (_.isEmpty(this.definicaoPublicoAlvo)) {
	        return;
	      }
	      this.definicaoPublicoAlvo.forEach(function (item) {
	        item.subgrupos.forEach(function (item) {
	          if (_this4.definicoes.includes(item.id)) {
	            item.selecionado = true;
	          } else {
	            item.selecionado = false;
	          }
	        });
	      });
	      this.$forceUpdate();
	    },
	    toogleItem: function toogleItem(index) {
	      if (this.fixado) {
	        return;
	      }
	      this.definicaoPublicoAlvo[index].aberto = !this.definicaoPublicoAlvo[index].aberto;
	      this.$forceUpdate();
	    },
	    updateSelecao: function updateSelecao(id, seleciona, tipo) {
	      console.log(id, seleciona, tipo);
	      if (seleciona) {
	        if (this.telaParticipante) {
	          var indexTipo = this.getDefinicoesPorTipo(tipo, id);
	          this.removerDefinicoesSelecionadasLista(indexTipo);
	        }
	        console.log(id);
	        if (id === 32) {
	          this.limparSelecao();
	        }
	
	        if (!this.definicoes.includes(id)) {
	          this.definicoes.push(id);
	        }
	      } else {
	        var index = this.definicoes.indexOf(id);
	        if (index !== -1) {
	          this.definicoes.splice(index, 1);
	        }
	      }
	      if (this.tipoDescricao === 'REALIZADO') {
	        this.$emit('descricaoParticipanteDefs', this.definicoes);
	      }
	      console.log('definicoes atualizadas', this.definicoes);
	      this.initCheckbox();
	      this.$forceUpdate();
	    },
	    limparSelecao: function limparSelecao() {
	      this.definicaoPublicoAlvo.forEach(function (item) {
	        item.aberto = true;
	        item.subgrupos.forEach(function (item) {
	          item.selecionado = false;
	        });
	      });
	      this.definicoes = [31];
	      this.initCheckbox();
	      this.$forceUpdate();
	    },
	    salvarSelecao: function salvarSelecao() {
	      var _this5 = this;
	
	      if (_.isEmpty(this.definicoes)) {
	        this.definicoes.push(31);
	      }
	      this.loading.show = true;
	      var obj = {
	        proposta: this.proposta,
	        participante: this.idParticipante,
	        tipo: this.tipoDescricao,
	        definicoes: this.definicoes
	      };
	      axiosLaravel.post('definicaoparticipante/vincular', obj).then(function (response) {
	        _this5.$snotify.success(response.data.message);
	        _this5.defAux = _this5.definicoes.slice();
	        _this5.toggleEdicao(false);
	        _this5.loading.show = false;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	        _this5.loading.show = false;
	      });
	    },
	    toggleEdicao: function toggleEdicao(value) {
	      this.editar = value;
	
	      if (!this.editar) {
	        this.definicoes = this.defAux.slice();
	        this.initCheckbox();
	      }
	    },
	    getDefinicoesPorTipo: function getDefinicoesPorTipo(tipo, idSelecionada) {
	      var indices = [];
	      this.definicaoPublicoAlvo.forEach(function (item) {
	        if (item.tipo === tipo) {
	          item.subgrupos.forEach(function (subgrupo) {
	            if (subgrupo.id !== idSelecionada) {
	              indices.push(subgrupo.id);
	            }
	          });
	        }
	      });
	      return indices;
	    },
	    removerDefinicoesSelecionadasLista: function removerDefinicoesSelecionadasLista(indices) {
	      var _this6 = this;
	
	      indices.forEach(function (indice) {
	        var index = _this6.definicoes.indexOf(indice);
	
	        if (index !== -1) {
	          _this6.definicoes.splice(index, 1);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'publicoAlvoDescricao',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      definicaoPublicoAlvo: {},
	      defAux: [],
	      definicoes: [],
	      editar: false,
	      table: {
	        items: [],
	        currentPage: 0,
	        perPage: 999,
	        totalRows: 0,
	        sortBy: 'publico',
	        sortDesc: false,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'publico', label: 'Grupo', sortable: true, thStyle: 'width: 20%; text-align: left', class: 'text-left' }, { key: 'tipo', label: 'Público-alvo', sortable: true, thStyle: 'width: 80%; text-align: left', class: 'text-left' }]
	      },
	      itemTable: []
	    };
	  },
	
	  props: {
	    proposta: null,
	    fixado: Boolean,
	    permiteEditar: Boolean,
	    abrirAbas: Boolean,
	    telaProjeto: {
	      type: Boolean,
	      default: false
	    },
	    idParticipante: {
	      type: Number,
	      default: null
	    },
	    telaParticipante: {
	      type: Boolean,
	      default: false
	    },
	    tipoDescricao: {
	      type: String,
	      default: 'PREVISTO'
	    },
	    dataNascimentoEdit: {
	      type: String,
	      default: ''
	    },
	    sexoEdit: {
	      type: String,
	      default: ''
	    },
	    escolaridadeEdit: {
	      type: String,
	      default: ''
	    }
	  },
	  computed: {},
	  watch: {
	    dataNascimentoEdit: function dataNascimentoEdit(newValue, oldValue) {
	      console.log('MUDOU DE ', oldValue, 'PARA', newValue);
	      if (newValue.length >= 10) {
	        var parts = newValue.split('/');
	        var year = parts[2];
	        var yearNumber = parseInt(year, 10);
	        if (yearNumber >= 1946 && yearNumber <= 1964) {
	          this.updateSelecao(11, true, 'Geração');
	        } else if (yearNumber >= 1965 && yearNumber <= 1980) {
	          this.updateSelecao(12, true, 'Geração');
	        } else if (yearNumber >= 1981 && yearNumber <= 1996) {
	          this.updateSelecao(13, true, 'Geração');
	        } else if (yearNumber >= 1997 && yearNumber <= 2009) {
	          this.updateSelecao(14, true, 'Geração');
	        } else if (yearNumber >= 2010) {
	          this.updateSelecao(15, true, 'Geração');
	        }
	      }
	    },
	    sexoEdit: function sexoEdit(newValue, oldValue) {
	      console.log('MUDOU DE ', oldValue, 'PARA', newValue);
	      if (newValue === 'Masculino') {
	        this.updateSelecao(7, true, 'Identidade de Gênero');
	      } else if (newValue === 'Feminino') {
	        this.updateSelecao(8, true, 'Identidade de Gênero');
	      } else {
	        this.updateSelecao(9, true, 'Identidade de Gênero');
	      }
	    },
	    escolaridadeEdit: function escolaridadeEdit(newValue, oldValue) {
	      console.log('MUDOU DE ', oldValue, 'PARA', newValue);
	      if (newValue === 'Analfabeto') {
	        this.updateSelecao(27, true, 'Escolaridade');
	      } else if (newValue === 'Ensino Fundamental') {
	        this.updateSelecao(28, true, 'Escolaridade');
	      } else if (newValue === 'Ensino Médio') {
	        this.updateSelecao(29, true, 'Escolaridade');
	      } else {
	        this.updateSelecao(30, true, 'Escolaridade');
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.telaParticipante) {
	      this.editar = this.permiteEditar;
	      console.log(this.idParticipante);
	    }
	    this.buscaDefinicaoPublicoAlvo();
	  },
	  methods: {
	    buscaDefinicaoPublicoAlvo: function buscaDefinicaoPublicoAlvo() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('BUSCANDO DEFINICAO PUBLICO ALVO');
	                _this.loading.show = true;
	                _context.next = 4;
	                return axiosLaravel.get('definicaoparticipante').then(function (response) {
	                  _this.definicaoPublicoAlvo = response.data;
	                  console.log('RESULTADO CONSULTA>>>>>', _this.definicaoPublicoAlvo);
	                  _this.definicaoPublicoAlvo.forEach(function (item) {
	                    item.aberto = _this.abrirAbas;
	                    item.subgrupos.forEach(function (item) {
	                      item.selecionado = false;
	                    });
	                  });
	                  if (!_this.telaParticipante) {
	                    console.log('BUSCA GRAVADAS', _this.telaParticipante);
	                    _this.buscaDefinicoesGravadas();
	                  }
	                  if (_this.idParticipante !== null) {
	                    _this.buscaDefinicoesParticipante();
	                  }
	                  _this.loading.show = false;
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                  _this.loading.show = false;
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    buscaDefinicoesGravadas: function buscaDefinicoesGravadas() {
	      var _this2 = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('/definicaoparticipante/getPrevistosProjeto/' + this.proposta).then(function (response) {
	        _this2.definicoes = response.data;
	        _this2.defAux = _this2.definicoes.slice();
	        console.log('1 - DEFINICOES CHECKBOX', _this2.definicoes);
	        _this2.initCheckbox();
	        _this2.loading.show = false;
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.loading.show = false;
	        _this2.$forceUpdate();
	      });
	    },
	    buscaDefinicoesParticipante: function buscaDefinicoesParticipante() {
	      var _this3 = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('/definicaoparticipante/getRealizadosParticipante/' + this.idParticipante).then(function (response) {
	        _this3.definicoes = response.data;
	        console.log('DEFINICOES', _this3.definicoes);
	        _this3.defAux = _this3.definicoes.slice();
	        _this3.initCheckbox();
	        _this3.loading.show = false;
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	        _this3.loading.show = false;
	        _this3.$forceUpdate();
	      });
	    },
	    initCheckbox: function initCheckbox() {
	      var _this4 = this;
	
	      console.log('2 - INIT CHECKBOX', this.definicaoPublicoAlvo, this.definicoes);
	      this.itemTable = [];
	      if (_.isEmpty(this.definicaoPublicoAlvo)) {
	        return;
	      }
	      this.definicaoPublicoAlvo.forEach(function (subgrupo) {
	        subgrupo.subgrupos.forEach(function (item) {
	          if (_this4.definicoes.includes(item.id)) {
	            var obj = {
	              publico: subgrupo.tipo,
	              tipo: item.subgrupo,
	              descricao: item.descricao
	            };
	            item.selecionado = true;
	            _this4.itemTable.push(obj);
	            console.log(item, subgrupo.tipo);
	          } else {
	            item.selecionado = false;
	          }
	        });
	      });
	      this.table.items = this.itemTable;
	      this.$forceUpdate();
	    },
	    toogleItem: function toogleItem(index) {
	      if (this.fixado) {
	        return;
	      }
	      this.definicaoPublicoAlvo[index].aberto = !this.definicaoPublicoAlvo[index].aberto;
	      this.$forceUpdate();
	    },
	    updateSelecao: function updateSelecao(id, seleciona, tipo) {
	      console.log(id, seleciona, tipo);
	      if (seleciona) {
	        if (this.telaParticipante) {
	          var indexTipo = this.getDefinicoesPorTipo(tipo, id);
	          this.removerDefinicoesSelecionadasLista(indexTipo);
	        }
	        console.log(id);
	        if (id === 32) {
	          this.limparSelecao();
	        }
	
	        if (!this.definicoes.includes(id)) {
	          this.definicoes.push(id);
	        }
	      } else {
	        var index = this.definicoes.indexOf(id);
	        if (index !== -1) {
	          this.definicoes.splice(index, 1);
	        }
	      }
	      if (this.tipoDescricao === 'REALIZADO') {
	        this.$emit('descricaoParticipanteDefs', this.definicoes);
	      }
	      console.log('definicoes atualizadas', this.definicoes);
	      this.initCheckbox();
	      this.$forceUpdate();
	    },
	    limparSelecao: function limparSelecao() {
	      this.definicaoPublicoAlvo.forEach(function (item) {
	        item.aberto = true;
	        item.subgrupos.forEach(function (item) {
	          item.selecionado = false;
	        });
	      });
	      this.definicoes = [31];
	      this.initCheckbox();
	      this.$forceUpdate();
	    },
	    salvarSelecao: function salvarSelecao() {
	      var _this5 = this;
	
	      if (_.isEmpty(this.definicoes)) {
	        this.definicoes.push(31);
	      }
	      this.loading.show = true;
	      var obj = {
	        proposta: this.proposta,
	        participante: this.idParticipante,
	        tipo: this.tipoDescricao,
	        definicoes: this.definicoes
	      };
	      axiosLaravel.post('definicaoparticipante/vincular', obj).then(function (response) {
	        _this5.$snotify.success(response.data.message);
	        _this5.defAux = _this5.definicoes.slice();
	        _this5.toggleEdicao(false);
	        _this5.loading.show = false;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	        _this5.loading.show = false;
	      });
	    },
	    toggleEdicao: function toggleEdicao(value) {
	      this.editar = value;
	
	      if (!this.editar) {
	        this.definicoes = this.defAux.slice();
	        this.initCheckbox();
	      }
	    },
	    getDefinicoesPorTipo: function getDefinicoesPorTipo(tipo, idSelecionada) {
	      var indices = [];
	      this.definicaoPublicoAlvo.forEach(function (item) {
	        if (item.tipo === tipo) {
	          item.subgrupos.forEach(function (subgrupo) {
	            if (subgrupo.id !== idSelecionada) {
	              indices.push(subgrupo.id);
	            }
	          });
	        }
	      });
	      return indices;
	    },
	    removerDefinicoesSelecionadasLista: function removerDefinicoesSelecionadasLista(indices) {
	      var _this6 = this;
	
	      indices.forEach(function (indice) {
	        var index = _this6.definicoes.indexOf(indice);
	
	        if (index !== -1) {
	          _this6.definicoes.splice(index, 1);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'publicoAlvoDescricao',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      definicaoPublicoAlvo: {},
	      totalizadores: [],
	      totalizadorGeral: 0,
	      editar: false
	    };
	  },
	
	  props: ['proposta', 'fixado', 'abrirAbas'],
	  computed: {},
	  watch: {},
	  mounted: function mounted() {
	    this.buscaDefinicaoPublicoAlvo();
	    this.totalGeralPorProjeto();
	  },
	  methods: {
	    buscaDefinicaoPublicoAlvo: function buscaDefinicaoPublicoAlvo() {
	      var _this = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('definicaoparticipante').then(function (response) {
	        _this.definicaoPublicoAlvo = response.data;
	        _this.definicaoPublicoAlvo.forEach(function (item) {
	          item.aberto = _this.abrirAbas;
	          item.subgrupos.forEach(function (item) {
	            item.selecionado = false;
	            item.totalizador = 0;
	          });
	        });
	        _this.buscaTotalizadores();
	        _this.loading.show = false;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	      });
	    },
	    buscaTotalizadores: function buscaTotalizadores() {
	      var _this2 = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('definicaoparticipante/getTotaisDefinicaoPorProjeto/' + this.proposta).then(function (response) {
	        _this2.totalizadores = response.data.result;
	        console.log('totalizadores:', _this2.totalizadores);
	        _this2.initContadores();
	        _this2.loading.show = false;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.loading.show = false;
	      });
	    },
	    initContadores: function initContadores() {
	      var _this3 = this;
	
	      console.log('INIT CONTADORES');
	      this.definicaoPublicoAlvo.forEach(function (item) {
	        item.subgrupos.forEach(function (subgrupo) {
	          var totalExiste = _this3.totalizadores.find(function (total) {
	            return total.id === subgrupo.id;
	          });
	          if (totalExiste) {
	            subgrupo.totalizador = totalExiste.contagem;
	          } else {
	            subgrupo.totalizador = 0;
	          }
	        });
	      });
	    },
	    totalizadoresPorGrupo: function totalizadoresPorGrupo(grupo) {
	      var total = 0;
	      this.totalizadores.forEach(function (item) {
	        if (item.grupo === grupo) {
	          total += item.contagem;
	        }
	      });
	      return total;
	    },
	    totalGeral: function totalGeral() {
	      var total = 0;
	      console.log('totalGeral', this.totalizadores);
	      this.totalizadores.forEach(function (item) {
	        total += item.contagem;
	      });
	      return total;
	    },
	    totalGeralPorProjeto: function totalGeralPorProjeto() {
	      var _this4 = this;
	
	      axiosLaravel.get('definicaoparticipante/getTotalizadorPorProjeto/' + this.proposta).then(function (response) {
	        console.log('totalgeralprojeto', response.data);
	        _this4.totalizadorGeral = response.data[0].participantes;
	        _this4.$forceUpdate();
	      });
	    },
	    toogleItem: function toogleItem(index) {
	      if (this.fixado) {
	        return;
	      }
	      this.definicaoPublicoAlvo[index].aberto = !this.definicaoPublicoAlvo[index].aberto;
	      this.$forceUpdate();
	    }
	  }
	};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'publicoAlvoOld',
	  data: function data() {
	    return {
	      perfis: {},
	      table: {
	        items: this.propsPublicosGrid,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'audience.description', label: 'Público Alvo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'directParticipants', label: 'Participantes Diretos', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'indirectParticipants', label: 'Participantes Indiretos', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'youngs', label: 'Atende Jovens?', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'women', label: 'Atende Mulheres?', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      mostraGridPublicoAlvo: true,
	      publicosAlvo: [],
	      publicosAlvoTabela: [],
	      publicoAlvo: {},
	      womenBool: null,
	      youngsBool: null,
	      editando: false
	    };
	  },
	
	  props: ['propsPublicosGrid'],
	  watch: {
	    propsPublicosGrid: function propsPublicosGrid() {
	      this.table.items = this.propsPublicosGrid;
	    }
	  },
	  mounted: function mounted() {
	    this.buscaPublicoAlvo();
	  },
	  methods: {
	    buscaPublicoAlvo: function buscaPublicoAlvo() {
	      var _this = this;
	
	      axios.get('proxy/project/target-audience-source').then(function (response) {
	        _this.publicosAlvo = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    cancelaPublico: function cancelaPublico() {
	      this.publicoAlvo = {};
	      this.womenBool = null;
	      this.youngsBool = null;
	      this.mostraGridPublicoAlvo = true;
	      this.editando = false;
	    },
	    onAdd: function onAdd() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.editando === true) {
	            for (var i in _this2.publicoAlvo) {
	              _this2.publicosAlvoTabela[i] = _this2.publicoAlvo[i];
	            }
	          } else {
	            _this2.table.items.push(_this2.publicoAlvo);
	          }
	          _this2.$emit('publicoAlvoAdicionado', _this2.table.items);
	          _this2.cancelaPublico();
	        }
	      });
	    },
	    edita: function edita(item) {
	      this.editando = true;
	      this.publicoAlvo = (0, _assign2.default)({}, item);
	      this.publicosAlvoTabela = item;
	      this.publicoAlvo.women ? this.womenBool = 'Sim' : this.womenBool = 'Não';
	      this.publicoAlvo.youngs ? this.youngsBool = 'Sim' : this.youngsBool = 'Não';
	      this.mostraGridPublicoAlvo = false;
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    }
	  }
	};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'quadroRestricoesEntidade',
	  props: {
	    restricoes: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    situacao: function situacao() {
	      return this.restricoes.situacao;
	    },
	    entidade: function entidade() {
	      return this.restricoes.entidade || [];
	    },
	    projetos: function projetos() {
	      return this.restricoes.projetos || [];
	    },
	    total: function total() {
	      return this.entidade.length + this.projetos.length;
	    },
	    tom: function tom() {
	      if (this.situacao === 'concluida') {
	        return this.total > 0 ? 'impeditiva' : 'regular';
	      }
	      return this.situacao === 'erro' ? 'erro' : 'neutro';
	    },
	    icone: function icone() {
	      return {
	        carregando: 'fa-spinner fa-spin',
	        erro: 'fa-exclamation-triangle',
	        dispensada: 'fa-info-circle',
	        concluida: this.total > 0 ? 'fa-ban' : 'fa-check-circle'
	      }[this.situacao] || 'fa-info-circle';
	    },
	    titulo: function titulo() {
	      if (this.situacao === 'carregando') {
	        return 'Consultando ocorrências impeditivas da entidade no Sapiens...';
	      }
	      if (this.situacao === 'erro') {
	        return 'Não foi possível consultar as ocorrências impeditivas da entidade.';
	      }
	      if (this.situacao === 'dispensada') {
	        return 'Esta entidade é dispensada da consulta de ocorrências impeditivas.';
	      }
	      if (this.total === 0) {
	        return 'A entidade não possui ocorrências impeditivas vigentes.';
	      }
	      return this.total === 1 ? 'A entidade possui 1 ocorrência impeditiva vigente:' : 'A entidade possui ' + this.total + ' ocorr\xEAncias impeditivas vigentes:';
	    }
	  }
	};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trunc = __webpack_require__(108);
	
	var _trunc2 = _interopRequireDefault(_trunc);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'questionario-riscos',
	  data: function data() {
	    return {
	      questoes: [],
	      respostas: [],
	      analise: {
	        questionario_respostas: {}
	      },
	      Temp: {},
	      totalInvestido: 0,
	      riscoCalculado: '',
	      questao: [],
	      origemProposta: [],
	      rating: [],
	      investimentoSocial: [],
	      municipiosAtendidos: [],
	      regiaoGeografica: [],
	      prazoExecucao: [],
	      valorInvestimento: [],
	      recursosTerceiros: [],
	      adiantamento: [],
	      natureza: [],
	      reaplicacaoTS: [],
	      legislacaoAmbiental: [],
	      estados: [{ 'Sigla': 'AC', 'Região': 'Norte' }, { 'Sigla': 'AL', 'Região': 'Nordeste' }, { 'Sigla': 'AP', 'Região': 'Norte' }, { 'Sigla': 'AM', 'Região': 'Norte' }, { 'Sigla': 'BA', 'Região': 'Nordeste' }, { 'Sigla': 'CE', 'Região': 'Nordeste' }, { 'Sigla': 'DF', 'Região': 'Centro-Oeste' }, { 'Sigla': 'ES', 'Região': 'Sudeste' }, { 'Sigla': 'GO', 'Região': 'Centro-Oeste' }, { 'Sigla': 'MA', 'Região': 'Nordeste' }, { 'Sigla': 'MT', 'Região': 'Centro-Oeste' }, { 'Sigla': 'MS', 'Região': 'Centro-Oeste' }, { 'Sigla': 'MG', 'Região': 'Sudeste' }, { 'Sigla': 'PA', 'Região': 'Norte' }, { 'Sigla': 'PB', 'Região': 'Nordeste' }, { 'Sigla': 'PR', 'Região': 'Sul' }, { 'Sigla': 'PE', 'Região': 'Nordeste' }, { 'Sigla': 'PI', 'Região': 'Nordeste' }, { 'Sigla': 'RJ', 'Região': 'Sudeste' }, { 'Sigla': 'RN', 'Região': 'Nordeste' }, { 'Sigla': 'RS', 'Região': 'Sul' }, { 'Sigla': 'RO', 'Região': 'Norte' }, { 'Sigla': 'RR', 'Região': 'Norte' }, { 'Sigla': 'SC', 'Região': 'Sul' }, { 'Sigla': 'SP', 'Região': 'Sudeste' }, { 'Sigla': 'SE', 'Região': 'Nordeste' }, { 'Sigla': 'TO', 'Região': 'Norte' }]
	    };
	  },
	
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  props: ['propsAnalise', 'ehSimplificada'],
	  watch: {
	    propsAnalise: function propsAnalise() {
	      var _this = this;
	
	      if (this.propsAnalise.id) {
	        this.analise = this.propsAnalise;
	        if (this.propsAnalise.questionario_respostas) {
	          if (this.propsAnalise.ds_risco_calculado && !this.riscoCalculado) {
	            this.riscoCalculado = this.propsAnalise.ds_risco_calculado;
	          }
	        }
	
	        if (this.propsAnalise.questionario_respostas && (0, _keys2.default)(this.propsAnalise.questionario_respostas).length > 11) {
	          if (this.propsAnalise.ds_risco_calculado === '' || !this.propsAnalise.ds_risco_calculado) {
	            axiosLaravel.put('propostas/' + this.propsAnalise.id + '/calcula-risco').then(function (response) {
	              _this.riscoCalculado = response.data;
	            }).catch(function (error) {
	              _this.$root.trataErro(error);
	            });
	          }
	        }
	        if (this.riscoCalculado) {
	          this.propsAnalise.questionario_respostas.risco_calculado = this.riscoCalculado;
	        }
	        if (this.ehSimplificada) {
	          this.riscoCalculado = 'C';
	          this.propsAnalise.questionario_respostas.risco_calculado = this.riscoCalculado;
	        }
	        this.$emit('questionario', this.propsAnalise.questionario_respostas);
	        if (this.questoes) {
	          this.setQuestionarioRisco(this.questoes);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (_.isUndefined(this.propsAnalise.questionario_respostas) || this.propsAnalise.questionario_respostas.length === 0) {
	      this.propsAnalise.questionario_respostas = {};
	    }
	
	    var rat = {};
	    var bc = new BroadcastChannel('test_channel_1');
	    var self = this;
	    bc.onmessage = function (ev) {
	      rat = ev.data;
	      self.Temp = rat;
	
	      var origem = '';
	      if (self.propsAnalise.ds_categ_edital) {
	        if (self.propsAnalise.ds_categ_edital !== 'NA' || self.Temp !== 'NA') {
	          origem = 'Edital';
	        } else {
	          origem = '';
	        }
	        var textoNum = '';
	        if (origem === 'Edital') {
	          textoNum = 'Edital';
	        } else {
	          textoNum = 'Articulação';
	        }
	        if (!_.isUndefined(self.origemProposta)) {
	          self.propsAnalise.questionario_respostas.origem_proposta = _.filter(self.origemProposta, function (atr) {
	            return atr.ds_descricao.match(new RegExp(textoNum));
	          });
	        }
	        self.$forceUpdate();
	      }
	    };
	    if (this.ehSimplificada) {
	      this.riscoCalculado = 'C';
	      this.propsAnalise.questionario_respostas.risco_calculado = this.riscoCalculado;
	    }
	  },
	  created: function created() {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this2.canalAtualizacaoRating();
	              _context.next = 3;
	              return _this2.$root.buscaQuestionarioRisco(_this2.$store);
	
	            case 3:
	              _this2.questoes = _this2.$store.state.questionarioRisco;
	              _this2.fkOrigemProposta = _this2.$parent.$parent.analise.fk_origem_proposta_erp;
	              _this2.setQuestionarioRisco();
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }))();
	  },
	
	  methods: {
	    canalAtualizacaoRating: function canalAtualizacaoRating() {
	      var bcProposta = new BroadcastChannel('propostas');
	      var vm = this;
	      bcProposta.onmessage = function (e) {
	        var mensagem = e.data;
	        if ('' + mensagem.id === '' + vm.$route.params.id) {
	          if (mensagem.acao === 'set' && mensagem.objeto === 'proposta.rating') {
	            var ratingValor = mensagem.valor;
	            if (ratingValor) {
	              if (ratingValor.classificacao) {
	                if (_.isUndefined(vm.propsAnalise.questionario_respostas)) {
	                  vm.propsAnalise.questionario_respostas = {};
	                }
	                for (var i = 0; i < vm.rating.length; i++) {
	                  if (vm.rating[i].ds_descricao === ratingValor.classificacao.nota) {
	                    vm.propsAnalise.questionario_respostas.rating = vm.rating[i];
	                  }
	                }
	              }
	            }
	          }
	        } else {}
	        vm.$forceUpdate();
	      };
	    },
	    setQuestionarioRisco: function setQuestionarioRisco() {
	      var _this3 = this;
	
	      var array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 7;
	      });
	      this.origemProposta = array[0].respostas;
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 8;
	      });
	      this.rating = array[0].respostas;
	      if (this.propsAnalise.ratingRelatorio && this.propsAnalise.ratingRelatorio.length > 0) {
	        for (var i = 0; i < this.rating.length; i++) {
	          if (this.rating[i].ds_descricao === this.propsAnalise.ratingRelatorio.classificacao.nota) {
	            this.propsAnalise.questionario_respostas.rating = this.rating[i];
	          }
	        }
	      }
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 9;
	      });
	      this.investimentoSocial = array[0].respostas;
	
	      if (this.propsAnalise.atividades) {
	        this.propsAnalise.atividades.forEach(function (atividade) {
	          if (_.has(atividade, 'itens_orcamentos') && atividade.itens_orcamentos.length > 0) {
	            atividade.itens_orcamentos.forEach(function (item) {
	              if (item.origem === '5' || item.origem === 5 || item.origem === '1' || item.origem === 1) {
	                _this3.totalInvestido = parseFloat(_this3.totalInvestido + item.valor_unitario * item.quantidade);
	              }
	            });
	          }
	        });
	      }
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 10;
	      });
	      this.municipiosAtendidos = array[0].respostas;
	
	      if (this.propsAnalise.municipalizacao) {
	        var totMun = _.uniq(_.map(this.propsAnalise.municipalizacao, 'ds_municipio'));
	        var tamanho = totMun.length;
	        var textoNum = '';
	        if (tamanho === 1) {
	          textoNum = '1';
	        }
	        if (tamanho > 1 && tamanho < 6) {
	          textoNum = '2 a 5';
	        }
	
	        if (tamanho > 5) {
	          textoNum = '6';
	        }
	        var _array = _.filter(this.municipiosAtendidos, function (atr) {
	          return atr.ds_descricao.match(new RegExp(textoNum));
	        });
	        this.propsAnalise.questionario_respostas.municipios_atendidos = (0, _assign2.default)({}, _array[0]);
	        this.$forceUpdate();
	      }
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 11;
	      });
	      this.regiaoGeografica = array[0].respostas;
	
	      var contNorte = 0;
	      var contSulSudeste = 0;
	      var contCentroNordeste = 0;
	      if (this.propsAnalise.municipalizacao) {
	        for (var _i = 0; _i < this.propsAnalise.municipalizacao.length; _i++) {
	          for (var j = 0; j < this.estados.length; j++) {
	            if (this.estados[j].Sigla === this.propsAnalise.municipalizacao[_i].ds_uf) {
	              if (this.estados[j].Região === 'Centro-Oeste' || this.estados[j].Região === 'Nordeste') {
	                contCentroNordeste = contCentroNordeste + 1;
	              }
	              if (this.estados[j].Região === 'Sudeste' || this.estados[j].Região === 'Sul') {
	                contSulSudeste = contSulSudeste + 1;
	              }
	              if (this.estados[j].Região === 'Norte') {
	                contNorte = contNorte + 1;
	              }
	            }
	          }
	        }
	
	        var _textoNum = '';
	        if (contCentroNordeste > contSulSudeste && contCentroNordeste > contNorte) {
	          _textoNum = 'Nordeste';
	        }
	        if (contSulSudeste > contCentroNordeste && contSulSudeste > contNorte) {
	          _textoNum = 'Sul';
	        }
	        if (contNorte > contCentroNordeste && contNorte > contSulSudeste) {
	          _textoNum = 'Norte';
	        }
	        var _array2 = _.filter(this.regiaoGeografica, function (atr) {
	          return atr.ds_descricao.match(new RegExp(_textoNum));
	        });
	        this.propsAnalise.questionario_respostas.regiao_predominante = (0, _assign2.default)({}, _array2[0]);
	        this.$forceUpdate();
	      }
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 12;
	      });
	      this.prazoExecucao = array[0].respostas;
	
	      if (this.propsAnalise.nr_periodos) {
	        var _tamanho = this.propsAnalise.nr_periodos;
	        var _textoNum2 = '';
	        if (_tamanho <= 12) {
	          _textoNum2 = 'Até 12';
	        }
	        if (_tamanho >= 13 && _tamanho <= 24) {
	          _textoNum2 = 'De 13 a 24';
	        }
	        if (_tamanho >= 25) {
	          _textoNum2 = '25';
	        }
	        var _array3 = _.filter(this.prazoExecucao, function (atr) {
	          return atr.ds_descricao.match(new RegExp(_textoNum2));
	        });
	        this.propsAnalise.questionario_respostas.prazo_execucao = (0, _assign2.default)({}, _array3[0]);
	        this.$forceUpdate();
	      }
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 13;
	      });
	      this.valorInvestimento = array[0].respostas;
	
	      if (this.totalInvestido) {
	        var _tamanho2 = (0, _trunc2.default)(this.totalInvestido);
	        var _textoNum3 = '';
	        if (_tamanho2 <= 300000) {
	          console.log('tamanho1', _tamanho2);
	          _textoNum3 = 'Até R$ 300.000,00';
	        }
	        if (_tamanho2 > 300000 && _tamanho2 <= 500000) {
	          console.log('tamanho2', _tamanho2);
	          _textoNum3 = 'De R$ 300.000,01 a R$ 500.000,00';
	        }
	        if (_tamanho2 > 500000) {
	          console.log('tamanho3', _tamanho2);
	          _textoNum3 = 'De R$ 500.000,01 ou mais';
	        }
	        var _array4 = _.filter(this.valorInvestimento, function (atr) {
	          return atr.ds_descricao === _textoNum3;
	        });
	        this.propsAnalise.questionario_respostas.valor_investimento = (0, _assign2.default)({}, _array4[0]);
	        this.$forceUpdate();
	      }
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 14;
	      });
	      this.recursosTerceiros = array[0].respostas;
	
	      var existeRT = false;
	      if (this.propsAnalise.atividades) {
	        this.propsAnalise.atividades.forEach(function (atividade) {
	          if (_.has(atividade, 'itens_orcamentos') && atividade.itens_orcamentos.length > 0) {
	            atividade.itens_orcamentos.forEach(function (item) {
	              if (item.origem === '5') {
	                existeRT = true;
	              }
	            });
	          }
	        });
	        var _tamanho3 = existeRT;
	        var _textoNum4 = '';
	        if (_tamanho3 === false) {
	          _textoNum4 = 'apenas com RP';
	        } else {
	          _textoNum4 = 'RT total';
	        }
	        var _array5 = _.filter(this.recursosTerceiros, function (atr) {
	          return atr.ds_descricao.match(new RegExp(_textoNum4));
	        });
	        this.propsAnalise.questionario_respostas.recursos_terceiros = (0, _assign2.default)({}, _array5[0]);
	        this.$forceUpdate();
	      }
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 15;
	      });
	      this.adiantamento = array[0].respostas;
	
	      if (this.propsAnalise.adiantamentos) {
	        var _tamanho4 = this.quantidadeParcelasAdiantamento(this.propsAnalise.adiantamentos);
	        var _textoNum5 = '';
	        if (_tamanho4 === 0) {
	          _textoNum5 = 'Sem adiantamento';
	        }
	        if (_tamanho4 > 0 && _tamanho4 <= 3) {
	          _textoNum5 = 'Com adiantamento, em até 3 parcelas';
	        }
	        if (_tamanho4 > 3 && _tamanho4 <= 4) {
	          _textoNum5 = 'Com adiantamento, em 4 parcelas';
	        }
	        if (_tamanho4 >= 5) {
	          _textoNum5 = 'Com adiantamento, em 5 parcelas ou mais';
	        }
	        var _array6 = _.filter(this.adiantamento, function (atr) {
	          return atr.ds_descricao.match(new RegExp(_textoNum5));
	        });
	        this.propsAnalise.questionario_respostas.adiantamento_recursos = (0, _assign2.default)({}, _array6[0]);
	        this.$forceUpdate();
	      }
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 16;
	      });
	      this.natureza = array[0].respostas;
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 17;
	      });
	      this.reaplicacaoTS = array[0].respostas;
	
	      array = _.filter(this.questoes, function (item) {
	        return item.ds_codigo === 18;
	      });
	      this.legislacaoAmbiental = array[0].respostas;
	
	      this.$forceUpdate();
	    },
	    alteracoes: function alteracoes() {
	      this.$forceUpdate();
	    },
	    recalcular: function recalcular() {
	      var _this4 = this;
	
	      if ((0, _keys2.default)(this.propsAnalise.questionario_respostas).length > 11) {
	        this.$aguarde('Recalculando o risco. Por favor, aguarde...');
	        this.propsAnalise.proximaEtapa = 'SALVAR';
	        axiosLaravel.put('propostas/' + this.propsAnalise.id, this.propsAnalise).then(function (response) {
	          ok = true;
	          _this4.$forceUpdate();
	        }).catch(function (error) {
	          _this4.$snotify.clear();
	          _this4.$root.trataErro(error);
	        });
	        axiosLaravel.put('propostas/' + this.propsAnalise.id + '/calcula-risco').then(function (response) {
	          _this4.riscoCalculado = response.data;
	          _this4.$snotify.clear();
	          _this4.$snotify.success('Risco atualizado com sucesso!');
	        }).catch(function (error) {
	          _this4.$root.trataErro(error);
	        });
	      } else {
	        this.$snotify.error('É necessário preencher todos os questionario de risco para calcular o Risco!');
	        return;
	      }
	      this.$forceUpdate();
	    },
	    onSelectOrigem: function onSelectOrigem(evento) {
	      this.analise.questionario_respostas.origem_proposta = evento;
	    },
	    onSelectMunicipios: function onSelectMunicipios(evento) {
	      this.analise.questionario_respostas.municipios_atendidos = evento;
	    },
	    onSelectPrazos: function onSelectPrazos(evento) {
	      this.analise.questionario_respostas.prazo_execucao = evento;
	    },
	    onSelectNatureza: function onSelectNatureza(evento) {
	      this.analise.questionario_respostas.natureza_dispendios = evento;
	    },
	    onSelectRegiao: function onSelectRegiao(evento) {
	      this.analise.questionario_respostas.regiaoGeografica = evento;
	    },
	    onSelectInvestimento: function onSelectInvestimento(evento) {
	      this.analise.questionario_respostas.investimento_social_participantes = evento;
	    },
	    onSelectValor: function onSelectValor(evento) {
	      this.analise.questionario_respostas.valor_investimento = evento;
	    },
	    onSelectRating: function onSelectRating(evento) {
	      this.analise.questionario_respostas.rating = evento;
	    },
	    onSelectReaplicacao: function onSelectReaplicacao(evento) {
	      this.analise.questionario_respostas.realizacao_ts = evento;
	    },
	    onSelectAdiantamento: function onSelectAdiantamento(evento) {
	      this.analise.questionario_respostas.adiantamento_recursos = evento;
	    },
	    onSelectRT: function onSelectRT(evento) {
	      this.analise.questionario_respostas.recursos_terceiros = evento;
	    },
	    onSelectLA: function onSelectLA(evento) {
	      this.analise.questionario_respostas.legislacao_ambiental = evento;
	    },
	    etiquetaTipos: function etiquetaTipos(option) {
	      return '' + option.ds_descricao;
	    }
	  }
	};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'rating-entidade',
	  components: {
	    Dirigentes: _dirigentes2.default
	  },
	  data: function data() {
	    return {
	      idEntidade: 0,
	      calculando: true,
	      dadosGerais: {},
	      rating: {
	        classificacao: {
	          nota: ''
	        },
	        ratingCalculado: {
	          CD: 0,
	          RFP: 0,
	          IS: 0,
	          PD: 0,
	          HIS1: 0,
	          HIS2: 0,
	          OC1: 0,
	          OC2: 0,
	          OC3: 0,
	          formula: 'R = (3,5 * CD) + (3,5 * RFP) + (IS) + (1,5 * PD) + (2,5 * HIS 1) + (2,5 * HIS 2) + (3,5 * OC 2) + (2,0 * OC 3)',
	          total: 0
	        },
	        consultas: {
	          serasa: {},
	          certidoes: {
	            Cepim: null,
	            CND: null,
	            CRF: null,
	            CNDT: null
	          },
	          scpc: {},
	          cadin: {
	            entidade: null,
	            dirigentes: null,
	            coobrigacao: null
	          },
	          totalGeral: 0,
	          PEP: 0
	        },
	        ocorrencias: {
	          entidade: {
	            tipo2: null,
	            tipo3: null,
	            tipo4: null
	          },
	          projetosExecutando: {
	            qtde: null,
	            tipo2: null,
	            tipo3: null,
	            tipo4: null,
	            qtdeTipo3: null,
	            percTipo3: null
	          },
	          projetosEncerrados: {
	            qtde: null,
	            tipo3: null,
	            tipo4: null,
	            qtdeTipo3: null,
	            percTipo3: null
	          }
	        },
	        experiencia: {
	          investimentoAte3Anos: 0,
	          participantesAte3Anos: 0,
	          qtdeProjeto: 0
	        }
	      },
	      edicaoCalculo: false,
	      analise: {},
	      classificacaoRating: [{ 'nota': 'A', 'de': 90, 'para': 100 }, { 'nota': 'B', 'de': 70.1, 'para': 89.9 }, { 'nota': 'C', 'de': 55.1, 'para': 70 }, { 'nota': 'D', 'de': 40.1, 'para': 55 }, { 'nota': 'E', 'de': 0, 'para': 40 }]
	    };
	  },
	
	  props: ['propsAnalise'],
	  watch: {
	    propsAnalise: function propsAnalise() {
	      this.analise = this.propsAnalise;
	      this.idEntidade = this.propsAnalise.entidade.id;
	    }
	  },
	  computed: {
	    cadinDirigente: function cadinDirigente() {
	      var dirigentesCadin = _.filter(this.dadosGerais.entidade.dirigentes, function (o) {
	        return _.has(o, 'cadin') && o.cadin !== 0;
	      });
	      this.rating.consultas.cadin.dirigentes = dirigentesCadin.length > 0 ? '9999-12-31' : 0;
	      this.totalSCPSSerasa();
	    },
	    totalSerasaDirigentes: function totalSerasaDirigentes() {
	      var dirigentesSerasa = _.sumBy(this.dadosGerais.entidade.dirigentes, 'serasa');
	      this.rating.consultas.serasa.dirigentes = dirigentesSerasa;
	      this.totalSCPSSerasa();
	    },
	    totalSCPCDirigentes: function totalSCPCDirigentes() {
	      var dirigentesSCPC = _.sumBy(this.dadosGerais.entidade.dirigentes, 'scpc');
	      this.rating.consultas.scpc.dirigentes = dirigentesSCPC;
	      this.totalSCPSSerasa();
	    }
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    this.calculando = true;
	    this.consultaEntidade();
	    this.atualizarTodasOcorrencias();
	  },
	
	  methods: {
	    totalSCPSSerasa: function totalSCPSSerasa() {
	      this.rating.consultas.totalGeral = this.rating.consultas.serasa.entidade + this.rating.consultas.serasa.dirigentes + this.rating.consultas.serasa.coobrigacao + this.rating.consultas.scpc.entidade + this.rating.consultas.scpc.dirigentes + this.rating.consultas.scpc.coobrigacao;
	      this.calcularRating();
	    },
	    carregaRating: function carregaRating() {
	      var _this = this;
	
	      axiosLaravel.post('rating/', this.idProjeto).then(function (response) {
	        console.log('carregaRating', response.data);
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    entidadeOcorrenciaTipo2: function entidadeOcorrenciaTipo2() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this2.rating.ocorrencias.entidade.tipo2 = null;
	                _context.next = 3;
	                return _this2.buscaOcorrencias('entidade', { 'id_entidade': _this2.idEntidade, 'tipo': 2, 'situacao_ocorrencia': 'vigentes' });
	
	              case 3:
	                _this2.rating.ocorrencias.entidade.tipo2 = _context.sent;
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    entidadeOcorrenciaTipo3: function entidadeOcorrenciaTipo3() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this3.rating.ocorrencias.entidade.tipo3 = null;
	                _context2.next = 3;
	                return _this3.buscaOcorrencias('entidade', { 'id_entidade': _this3.idEntidade, 'tipo': 3, 'situacao_ocorrencia': 'vigentes' });
	
	              case 3:
	                _this3.rating.ocorrencias.entidade.tipo3 = _context2.sent;
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    },
	    entidadeOcorrenciaTipo4: function entidadeOcorrenciaTipo4() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this4.rating.ocorrencias.entidade.tipo4 = null;
	                _context3.next = 3;
	                return _this4.buscaOcorrencias('entidade', { 'id_entidade': _this4.idEntidade, 'tipo': 4, 'situacao_ocorrencia': 'vigentes' });
	
	              case 3:
	                _this4.rating.ocorrencias.entidade.tipo4 = _context3.sent;
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    },
	    projetosExecutandoOcorrenciaTipo2: function projetosExecutandoOcorrenciaTipo2() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this5.rating.ocorrencias.projetosExecutando.tipo2 = null;
	                _context4.next = 3;
	                return _this5.buscaOcorrencias('projeto', { 'id_entidade': _this5.idEntidade, 'tipo': 2, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'executando', 'dias': 1095 });
	
	              case 3:
	                _this5.rating.ocorrencias.projetosExecutando.tipo2 = _context4.sent;
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this5);
	      }))();
	    },
	    projetosExecutandoOcorrenciaTipo3: function projetosExecutandoOcorrenciaTipo3() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this6.rating.ocorrencias.projetosExecutando.tipo3 = null;
	                _context5.next = 3;
	                return _this6.buscaOcorrencias('projeto', { 'id_entidade': _this6.idEntidade, 'tipo': 3, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'executando', 'dias': 1095 });
	
	              case 3:
	                _this6.rating.ocorrencias.projetosExecutando.tipo3 = _context5.sent;
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this6);
	      }))();
	    },
	    projetosExecutandoOcorrenciaTipo4: function projetosExecutandoOcorrenciaTipo4() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this7.rating.ocorrencias.projetosExecutando.tipo4 = null;
	                _context6.next = 3;
	                return _this7.buscaOcorrencias('projeto', { 'id_entidade': _this7.idEntidade, 'tipo': 4, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'executando', 'dias': 1095 });
	
	              case 3:
	                _this7.rating.ocorrencias.projetosExecutando.tipo4 = _context6.sent;
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this7);
	      }))();
	    },
	    projetosEncerradosOcorrenciaTipo2: function projetosEncerradosOcorrenciaTipo2() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this8.rating.ocorrencias.projetosEncerrados.tipo2 = null;
	                _context7.next = 3;
	                return _this8.buscaOcorrencias('projeto', { 'id_entidade': _this8.idEntidade, 'tipo': 2, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'encerrado', 'dias': 1095 });
	
	              case 3:
	                _this8.rating.ocorrencias.projetosEncerrados.tipo2 = _context7.sent;
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this8);
	      }))();
	    },
	    projetosEncerradosOcorrenciaTipo3: function projetosEncerradosOcorrenciaTipo3() {
	      var _this9 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this9.rating.ocorrencias.projetosEncerrados.tipo3 = null;
	                _context8.next = 3;
	                return _this9.buscaOcorrencias('projeto', { 'id_entidade': _this9.idEntidade, 'tipo': 3, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'encerrado', 'dias': 1095 });
	
	              case 3:
	                _this9.rating.ocorrencias.projetosEncerrados.tipo3 = _context8.sent;
	
	              case 4:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this9);
	      }))();
	    },
	    projetosEncerradosOcorrenciaTipo4: function projetosEncerradosOcorrenciaTipo4() {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _this10.rating.ocorrencias.projetosEncerrados.tipo4 = null;
	                _context9.next = 3;
	                return _this10.buscaOcorrencias('projeto', { 'id_entidade': _this10.idEntidade, 'tipo': 4, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'encerrado', 'dias': 1095 });
	
	              case 3:
	                _this10.rating.ocorrencias.projetosEncerrados.tipo4 = _context9.sent;
	
	              case 4:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this10);
	      }))();
	    },
	    buscaOcorrencias: function buscaOcorrencias(origem, consulta) {
	      var _this11 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	        var resultado;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                resultado = [];
	
	                origem = origem === 'projeto' ? 'consulta/ocorrencias/projeto/' : 'consulta/ocorrencias/entidade/';
	                _context10.next = 4;
	                return axiosLaravel.post(origem, consulta).then(function (response) {
	                  resultado = response.data;
	                }).catch(function (error) {
	                  _this11.$root.trataErro(error);
	                });
	
	              case 4:
	                return _context10.abrupt('return', resultado);
	
	              case 5:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this11);
	      }))();
	    },
	    atualizarTodasOcorrencias: function atualizarTodasOcorrencias() {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _context11.next = 2;
	                return _this12.entidadeOcorrenciaTipo2();
	
	              case 2:
	                _context11.next = 4;
	                return _this12.entidadeOcorrenciaTipo3();
	
	              case 4:
	                _context11.next = 6;
	                return _this12.entidadeOcorrenciaTipo4();
	
	              case 6:
	                _context11.next = 8;
	                return _this12.projetosExecutandoOcorrenciaTipo2();
	
	              case 8:
	                _context11.next = 10;
	                return _this12.projetosExecutandoOcorrenciaTipo3();
	
	              case 10:
	                _context11.next = 12;
	                return _this12.projetosExecutandoOcorrenciaTipo4();
	
	              case 12:
	                _context11.next = 14;
	                return _this12.projetosEncerradosOcorrenciaTipo3();
	
	              case 14:
	                _context11.next = 16;
	                return _this12.projetosEncerradosOcorrenciaTipo4();
	
	              case 16:
	                _this12.calcularRating();
	
	              case 17:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this12);
	      }))();
	    },
	    consultaEntidade: function consultaEntidade() {
	      var _this13 = this;
	
	      axiosLaravel.post('consulta/geral/entidade/', { 'id_entidade': this.idEntidade, 'dias': 1095 }).then(function (response) {
	        console.log('consultaEntidade', response.data);
	        _this13.dadosGerais = response.data;
	        _this13.dadosGerais.entidade['anosAbertura'] = (0, _moment2.default)().diff((0, _moment2.default)(_this13.dadosGerais.entidade.dt_data_expedicao_cnpj), 'years', true);
	        _this13.rating.experiencia.investimentoAte3Anos = _.sumBy(_this13.dadosGerais.projetos, function (o) {
	          return parseFloat(o.investimento);
	        });
	        _this13.rating.experiencia.participantesAte3Anos = _.sumBy(_this13.dadosGerais.projetos, function (o) {
	          return o.participantes;
	        });
	        _this13.rating.experiencia.qtdeProjeto = _this13.dadosGerais.projetos.length;
	        _this13.calcularRating();
	      }).catch(function (error) {
	        _this13.$root.trataErro(error);
	      });
	    },
	    calcularRating: function calcularRating() {
	      this.calculando = true;
	      var vm = this;
	      this.rating.ratingCalculado.CD = this.regua1();
	      this.rating.ratingCalculado.RFP = this.regua2();
	      this.rating.ratingCalculado.IS = this.regua3(vm);
	      this.rating.ratingCalculado.PD = this.regua4(vm);
	      this.rating.ratingCalculado.HIS1 = this.regua5(vm);
	      this.rating.ratingCalculado.HIS2 = this.regua6(vm);
	      this.rating.ratingCalculado.OC1 = this.regua7();
	      this.rating.ratingCalculado.OC2 = this.regua8();
	      this.rating.ratingCalculado.OC3 = this.regua9();
	
	      this.rating.ratingCalculado.total = 3.5 * this.rating.ratingCalculado.CD + 3.5 * this.rating.ratingCalculado.RFP + this.rating.ratingCalculado.IS + 1.5 * this.rating.ratingCalculado.PD + 3.5 * this.rating.ratingCalculado.HIS1 + 1.5 * this.rating.ratingCalculado.HIS2 + 2.5 * this.rating.ratingCalculado.OC1 + 2 * this.rating.ratingCalculado.OC2 + this.rating.ratingCalculado.OC3;
	
	      this.rating.classificacao = _.find(this.classificacaoRating, function (o) {
	        return o.de <= vm.rating.ratingCalculado.total && vm.rating.ratingCalculado.total <= o.para;
	      });
	
	      this.calculando = false;
	      this.$forceUpdate();
	      console.log('rating re-calculado:', this.rating);
	    },
	    vigente: function vigente(data) {
	      return data === 0 || (0, _moment2.default)(data).diff((0, _moment2.default)(), 'days', true) > 0;
	    },
	    regua1: function regua1() {
	      if (this.rating.consultas.certidoes.Cepim !== 0) {
	        return 0;
	      } else {
	        var totalSerasaSCPC = _.sumBy(_.map(this.rating.consultas.serasa)) + _.sumBy(_.map(this.rating.consultas.scpc));
	        var totalSerasaSCPCDirigentes = this.rating.consultas.serasa.dirigentes + this.rating.consultas.serasa.coobrigacao + this.rating.consultas.scpc.dirigentes + this.rating.consultas.scpc.coobrigacao;
	        if (totalSerasaSCPCDirigentes > 0 && totalSerasaSCPCDirigentes === totalSerasaSCPC) {
	          return 2;
	        }
	        var regua = [{ 'nota': 5, 'valor': 0 }, { 'nota': 4, 'valor': 500 }, { 'nota': 3, 'valor': 1000 }, { 'nota': 1, 'valor': 999999999 }];
	        return _.find(regua, function (o) {
	          return totalSerasaSCPC <= o.valor;
	        })['nota'];
	      }
	    },
	    regua2: function regua2() {
	      if (!this.vigente(this.rating.consultas.cadin.entidade) || !this.vigente(this.rating.consultas.cadin.dirigentes) || !this.vigente(this.rating.consultas.cadin.coobrigacao) || !this.vigente(this.rating.consultas.certidoes.CND)) {
	        return 0;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && !this.vigente(this.rating.consultas.cadin.dirigentes) || !this.vigente(this.rating.consultas.cadin.coobrigacao) && this.vigente(this.rating.consultas.certidoes.CND) && (!this.vigente(this.rating.consultas.certidoes.CRF) || !this.vigente(this.rating.consultas.certidoes.CNDT))) {
	        return 1;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && this.vigente(this.rating.consultas.cadin.dirigentes) && this.vigente(this.rating.consultas.cadin.coobrigacao) && this.vigente(this.rating.consultas.certidoes.CND) && !this.vigente(this.rating.consultas.certidoes.CRF) && !this.vigente(this.rating.consultas.certidoes.CNDT)) {
	        return 2;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && this.vigente(this.rating.consultas.cadin.dirigentes) && this.vigente(this.rating.consultas.cadin.coobrigacao) && this.vigente(this.rating.consultas.certidoes.CND) && (this.vigente(this.rating.consultas.certidoes.CRF) || this.vigente(this.rating.consultas.certidoes.CNDT))) {
	        return 3;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && (!this.vigente(this.rating.consultas.cadin.dirigentes) || !this.vigente(this.rating.consultas.cadin.coobrigacao)) && this.vigente(this.rating.consultas.certidoes.CND) && this.vigente(this.rating.consultas.certidoes.CRF) && this.vigente(this.rating.consultas.certidoes.CNDT)) {
	        return 4;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && this.vigente(this.rating.consultas.cadin.dirigentes) && this.vigente(this.rating.consultas.cadin.coobrigacao) && this.vigente(this.rating.consultas.certidoes.CND) && this.vigente(this.rating.consultas.certidoes.CRF) && this.vigente(this.rating.consultas.certidoes.CNDT)) {
	        return 5;
	      }
	      return 999;
	    },
	    regua3: function regua3(vm) {
	      var regua3 = [{ 'nota': 0, 'valor': 0 }, { 'nota': 1, 'valor': 70000 }, { 'nota': 2, 'valor': 100000 }, { 'nota': 3, 'valor': 200000 }, { 'nota': 4, 'valor': 300000 }, { 'nota': 5, 'valor': 999999999 }];
	      return _.find(regua3, function (o) {
	        return o.valor >= vm.rating.experiencia.investimentoAte3Anos;
	      })['nota'];
	    },
	    regua4: function regua4(vm) {
	      var regua4 = [{ 'nota': 0, 'valor': 0 }, { 'nota': 1, 'valor': 50 }, { 'nota': 2, 'valor': 80 }, { 'nota': 3, 'valor': 100 }, { 'nota': 4, 'valor': 200 }, { 'nota': 5, 'valor': 999999999 }];
	      return _.find(regua4, function (o) {
	        return o.valor >= vm.rating.experiencia.participantesAte3Anos;
	      })['nota'];
	    },
	    regua5: function regua5(vm) {
	      var regua5 = [{ 'nota': 1, 'valor': 2 }, { 'nota': 2, 'valor': 4 }, { 'nota': 3, 'valor': 6 }, { 'nota': 4, 'valor': 9 }, { 'nota': 5, 'valor': 999999999 }];
	      return _.find(regua5, function (o) {
	        return o.valor >= _.floor(vm.dadosGerais.entidade.anosAbertura);
	      })['nota'];
	    },
	    regua6: function regua6(vm) {
	      var regua6 = [{ 'nota': 0, 'valor': 0 }, { 'nota': 1, 'valor': 1 }, { 'nota': 2, 'valor': 2 }, { 'nota': 3, 'valor': 3 }, { 'nota': 4, 'valor': 4 }, { 'nota': 5, 'valor': 999999999 }];
	      return _.find(regua6, function (o) {
	        return o.valor >= vm.rating.experiencia.qtdeProjeto;
	      })['nota'];
	    },
	    regua7: function regua7() {
	      return this.rating.ocorrencias.entidade.tipo4 > 0 ? 0 : this.rating.ocorrencias.entidade.tipo3 > 0 ? 1 : this.rating.ocorrencias.entidade.tipo2 > 0 ? 3 : 5;
	    },
	    regua8: function regua8() {
	      this.rating.ocorrencias.projetosExecutando.qtde = _.filter(this.dadosGerais.projetos, ['situacao', 'executando']).length;
	      var projetos = _.map(this.dadosGerais.projetos, 'numero');
	      var ocorrenciasTipos3 = _.map(this.rating.ocorrencias.projetosExecutando.tipo3, 'numprj');
	      this.rating.ocorrencias.projetosExecutando.qtdeTipo3 = _.intersection(projetos, ocorrenciasTipos3).length;
	      this.rating.ocorrencias.projetosExecutando.percTipo3 = this.rating.ocorrencias.projetosExecutando.qtdeTipo3 / this.rating.ocorrencias.projetosExecutando.qtde;
	
	      if (this.rating.ocorrencias.projetosExecutando.qtde === 0) {
	        return 3;
	      }
	      if (this.rating.ocorrencias.projetosExecutando.tipo2.length + this.rating.ocorrencias.projetosExecutando.tipo3.length + this.rating.ocorrencias.projetosExecutando.tipo4.length === 0) {
	        return 5;
	      }
	      if (this.rating.ocorrencias.projetosExecutando.tipo4.length > 0) {
	        return 0;
	      } else {
	        if (this.rating.ocorrencias.projetosExecutando.percTipo3 > 0.5) {
	          return 1;
	        } else {
	          return 3;
	        }
	      }
	    },
	    regua9: function regua9() {
	      this.rating.ocorrencias.projetosEncerrados.qtde = _.filter(this.dadosGerais.projetos, ['situacao', 'executando']).length;
	      var projetos = _.map(this.dadosGerais.projetos, 'numero');
	      var ocorrenciasTipos3 = _.map(this.rating.ocorrencias.projetosEncerrados.tipo3, 'numprj');
	      this.rating.ocorrencias.projetosEncerrados.qtdeTipo3 = _.intersection(projetos, ocorrenciasTipos3).length;
	      this.rating.ocorrencias.projetosEncerrados.percTipo3 = this.rating.ocorrencias.projetosEncerrados.qtdeTipo3 / this.rating.ocorrencias.projetosEncerrados.qtde;
	
	      if (this.rating.ocorrencias.projetosEncerrados.qtde === 0) {
	        return 3;
	      }
	      if (this.rating.ocorrencias.projetosEncerrados.tipo3.length + this.rating.ocorrencias.projetosEncerrados.tipo4.length === 0) {
	        return 5;
	      }
	      if (this.rating.ocorrencias.projetosEncerrados.tipo4.length > 0) {
	        return 0;
	      } else {
	        if (this.rating.ocorrencias.projetosEncerrados.percTipo3 > 0.5) {
	          return 1;
	        } else {
	          return 3;
	        }
	      }
	    },
	    salvar: function salvar() {
	      alert('salvar...');
	      this.cancelar();
	    },
	    cancelar: function cancelar() {
	      this.edicaoCalculo = false;
	    }
	  }
	};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _set = __webpack_require__(109);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _html2pdf = __webpack_require__(140);
	
	var _html2pdf2 = _interopRequireDefault(_html2pdf);
	
	var _vuex = __webpack_require__(3);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'relatorio-analise',
	  components: {
	    PublicoAlvo: _publicoAlvo2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default
	  },
	  data: function data() {
	    return {
	      etapaCarga: [],
	      mostrarLogCarga: false,
	      mostrarAviso: false,
	      riscoCalculado: '',
	      itemSemContaFinanceiraFBB: false,
	      itemSemContaFinanceiraParceiro: false,
	      semProjetoDuplicador: false,
	      showgrid: true,
	      somenteLeitura: false,
	      relatorioAnalise: {
	        itensFbb: [],
	        itensContrapartida: [],
	        itensParceiro: [],
	        dirigentes: [],
	        ds_regularidade_rating: {
	          ds_descricao: null
	        },
	        ds_indicadores_resultado: null,
	        ds_acoes_comunicacao: null,
	        ds_indicadores_publico: []
	      },
	      loading: {
	        show: false
	      },
	      contra: {
	        conta: {
	          obs: ''
	        }
	      },
	      editavel: false,
	      ds_regularidade_ratingSim: false,
	      ds_execucao_prazoSim: false,
	      ds_execucao_relatoriosSim: false,
	      ds_indicadores_participantesSim: false,
	      ds_enquadramento_fepSim: false,
	      adiantamento: [],
	      todasPropostas: [],
	      ds_indicadores_participantesCiente: false,
	      proposta: {},
	      projetoSuperior: '',
	      participantes: 0,
	      opcoes: ['Sim', 'Não', 'N/A'],
	      totalFBB: 0,
	      totalContrapartida: 0,
	      totalParceiro: 0,
	      meta: {},
	      perguntas: {},
	      metaIndex: [],
	      publicosAlvo: {},
	      publico: [],
	      formasContratacao: [],
	      editando: '',
	      contrapartida: [{
	        item: null,
	        valor: null
	      }],
	      faixasInvestimento: [{ faixa: 1, de: 0, para: 100000, alcada: 'Comitê de Desenvolvimento Social' }, { faixa: 2, de: 100000.01, para: 300000.00, alcada: 'Comitê de Desenvolvimento Social' }, { faixa: 3, de: 300000.01, para: 1000000000, alcada: 'Comitê Estratégico' }],
	      ehPIS: false,
	      ehVoluntariado: false,
	      ehEdital: false,
	      ehEditalMN: false,
	      faixaDoProjeto: {},
	      formaJuridica: '',
	      atividadeForm: {
	        nr_periodo_final: null,
	        itens_orcamentos: [],
	        metas: {},
	        ds_nome: '',
	        nr_periodo_inicial: null,
	        ds_documento_comprobatorio: ''
	      },
	      atividadeTabela: {},
	      opcao_qtde_assinaturas: 3,
	
	      sairRelatorio: false,
	      odsCadastrado: [],
	      odsSelecionado: [],
	      tecSocialCadastrado: [],
	      publicoAlvoCadastrado: [],
	      odsTodaBase: [],
	      tecnologiasCadastradas: [],
	      publicoAlvoPrevisto: [],
	      publicoAlvoDefinicoes: [],
	      definicaoPublicoAlvo: [],
	      possuiTecnologiaSocial: false,
	      questoesAvaliacao: [],
	      tabID: '',
	      navegador: '',
	      usuarioSalvamento: ''
	    };
	  },
	
	  props: ['propsProposta'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    indicadoresResultadoLista: function indicadoresResultadoLista() {
	      var lista = this.proposta && this.proposta.dados ? this.proposta.dados.indicadores_resultado : null;
	      return Array.isArray(lista) ? lista : [];
	    },
	    parcelasAdiantamentoExibicao: function parcelasAdiantamentoExibicao() {
	      return this.consolidarParcelasAdiantamento(this.proposta.adiantamentos || []);
	    },
	    exibeDesdobramentoParcelas: function exibeDesdobramentoParcelas() {
	      return this.haParcelaMista(this.parcelasAdiantamentoExibicao);
	    },
	    totalParcelasAdiantamentoFundacao: function totalParcelasAdiantamentoFundacao() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_fbb');
	    },
	    totalParcelasAdiantamentoParceiro: function totalParcelasAdiantamentoParceiro() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_parc');
	    },
	    totalParcelasAdiantamentoGeral: function totalParcelasAdiantamentoGeral() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao);
	    },
	
	    dataFinalProjeto: function dataFinalProjeto() {
	      if (this.proposta.dt_assinatura_convenio) {
	        return (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(this.proposta.periodo_vigencia, 'M').format('MM/YYYY');
	      } else {
	        if (this.proposta.dt_data_inicial) {
	          return (0, _moment2.default)(this.proposta.dt_data_inicial).add(this.proposta.periodo_vigencia, 'M').format('MM/YYYY');
	        }
	      }
	    }
	  }),
	  watch: {
	    propsProposta: function propsProposta() {
	      this.proposta = this.propsProposta;
	    }
	  },
	  mounted: function mounted() {},
	
	  created: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              this.initLogVar();
	              _context.next = 3;
	              return this.carregarRelatorio();
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function created() {
	      return _ref.apply(this, arguments);
	    }
	
	    return created;
	  }(),
	  methods: {
	    carregarRelatorio: function carregarRelatorio() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.loading.show = true;
	                _this.mostrarLogCarga = true;
	
	                _context2.prev = 2;
	                _context2.next = 5;
	                return _this.buscaStatusProposta();
	
	              case 5:
	                _context2.next = 10;
	                break;
	
	              case 7:
	                _context2.prev = 7;
	                _context2.t0 = _context2['catch'](2);
	                console.error('Erro em buscaStatusProposta', _context2.t0);
	
	              case 10:
	                _context2.prev = 10;
	                _context2.next = 13;
	                return _this.buscaPublicoAlvo();
	
	              case 13:
	                _context2.next = 18;
	                break;
	
	              case 15:
	                _context2.prev = 15;
	                _context2.t1 = _context2['catch'](10);
	                console.error('Erro em buscaPublicoAlvo', _context2.t1);
	
	              case 18:
	                _context2.prev = 18;
	                _context2.next = 21;
	                return _this.buscarBaseODS();
	
	              case 21:
	                _context2.next = 26;
	                break;
	
	              case 23:
	                _context2.prev = 23;
	                _context2.t2 = _context2['catch'](18);
	                console.error('Erro em buscarBaseODS', _context2.t2);
	
	              case 26:
	                _context2.prev = 26;
	                _context2.next = 29;
	                return _this.consultaTecnologiasCadastradas();
	
	              case 29:
	                _context2.next = 34;
	                break;
	
	              case 31:
	                _context2.prev = 31;
	                _context2.t3 = _context2['catch'](26);
	                console.error('Erro em consultaTecnologiasCadastradas', _context2.t3);
	
	              case 34:
	                _context2.prev = 34;
	                _context2.next = 37;
	                return _this.buscaDefinicaoPublicoAlvo();
	
	              case 37:
	                _context2.next = 42;
	                break;
	
	              case 39:
	                _context2.prev = 39;
	                _context2.t4 = _context2['catch'](34);
	                console.error('Erro em buscaDefinicaoPublicoAlvo', _context2.t4);
	
	              case 42:
	                _context2.prev = 42;
	                _context2.next = 45;
	                return _this.buscaIndicadorAvaliacao();
	
	              case 45:
	                _context2.next = 50;
	                break;
	
	              case 47:
	                _context2.prev = 47;
	                _context2.t5 = _context2['catch'](42);
	                console.error('Erro em buscaIndicadorAvaliacao', _context2.t5);
	
	              case 50:
	                _context2.prev = 50;
	                _context2.next = 53;
	                return _this.consultaRiscoCalculado();
	
	              case 53:
	                _context2.next = 58;
	                break;
	
	              case 55:
	                _context2.prev = 55;
	                _context2.t6 = _context2['catch'](50);
	                console.error('Erro em consultaRiscoCalculado', _context2.t6);
	
	              case 58:
	                _context2.prev = 58;
	                _context2.next = 61;
	                return _this.buscaProposta();
	
	              case 61:
	                _context2.next = 66;
	                break;
	
	              case 63:
	                _context2.prev = 63;
	                _context2.t7 = _context2['catch'](58);
	                console.error('Erro em buscaProposta', _context2.t7);
	
	              case 66:
	                _context2.prev = 66;
	                _context2.next = 69;
	                return _this.carregaRating();
	
	              case 69:
	                _context2.next = 74;
	                break;
	
	              case 71:
	                _context2.prev = 71;
	                _context2.t8 = _context2['catch'](66);
	                console.error('Erro em carregaRating', _context2.t8);
	
	              case 74:
	                _context2.prev = 74;
	                _context2.next = 77;
	                return _this.carregarProjetoDuplicador();
	
	              case 77:
	                _context2.next = 82;
	                break;
	
	              case 79:
	                _context2.prev = 79;
	                _context2.t9 = _context2['catch'](74);
	                console.error('Erro em carregarProjetoDuplicador', _context2.t9);
	
	              case 82:
	                _context2.prev = 82;
	                _context2.next = 85;
	                return _this.buscaEntidades();
	
	              case 85:
	                _context2.next = 90;
	                break;
	
	              case 87:
	                _context2.prev = 87;
	                _context2.t10 = _context2['catch'](82);
	                console.error('Erro em buscaEntidades', _context2.t10);
	
	              case 90:
	
	                if (_this.verificaErro()) {
	                  _this.mostrarLogCarga = true;
	                  _this.mostrarAviso = true;
	                } else {
	                  _this.mostrarLogCarga = false;
	                }
	                _this.loading.show = false;
	
	              case 92:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this, [[2, 7], [10, 15], [18, 23], [26, 31], [34, 39], [42, 47], [50, 55], [58, 63], [66, 71], [74, 79], [82, 87]]);
	      }))();
	    },
	    verificaErro: function verificaErro() {
	      return this.etapaCarga.some(function (objeto) {
	        return objeto.status === 'ERRO';
	      });
	    },
	    recarregarRelatorio: function recarregarRelatorio() {
	      window.location.reload();
	    },
	    gerenciaRequisicao: function gerenciaRequisicao(nome, status) {
	      var erro = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var existente = this.etapaCarga.find(function (item) {
	        return item.nome === nome;
	      });
	      if (existente) {
	        existente.status = status;
	        if (status === 'ERRO') {
	          existente.erro = erro;
	          this.mostrarLogCarga = true;
	          this.mostrarAviso = true;
	        }
	      } else {
	        this.etapaCarga.push({ nome: nome, status: status });
	      }
	    },
	    closewindow: function closewindow(salvar) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this2.sairRelatorio = true;
	                if (salvar === false) {
	                  close();
	                } else {
	                  _this2.gravaRelatorio();
	                }
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }))();
	    },
	    initLogVar: function initLogVar() {
	      if (!sessionStorage.getItem('tabId')) {
	        var tabId = Date.now().toString() + Math.random().toString(36).substr(2);
	        sessionStorage.setItem('tabId', tabId);
	      }
	      this.tabID = sessionStorage.getItem('tabId');
	      this.navegador = this.verificaNavegador();
	      this.usuarioSalvamento = this.usuarioLogado.ds_login + ' ' + this.usuarioLogado.ds_nome_usuario;
	      console.log('Logvar', this.tabID, this.navegador, this.usuarioSalvamento);
	    },
	    verificaNavegador: function verificaNavegador() {
	      console.log('Verifica Navegador...');
	      var ua = navigator.userAgent;
	      var navegador = '';
	      if (ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('OPR')) {
	        navegador = 'Chrome';
	      } else if (ua.includes('Firefox')) {
	        navegador = 'Firefox';
	      } else if (ua.includes('Safari') && !ua.includes('Chrome')) {
	        navegador = 'Safari';
	      } else if (ua.includes('Edg')) {
	        navegador = 'Edge';
	      } else if (ua.includes('OPR') || ua.includes('Opera')) {
	        navegador = 'Opera';
	      } else {
	        navegador = 'Desconhecido';
	      }
	      return navegador;
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    haObjetivoMeta: function haObjetivoMeta(listaOrigem, vinculo, descricao) {
	      var c = 0;
	      _.forEach(_.map(listaOrigem, vinculo), function (o) {
	        _.forEach(o, function (d) {
	          c += _.has(d, 'ds_descricao') && d.ds_descricao === descricao || _.has(d, 'descricao') && d.descricao === descricao ? 1 : 0;
	        });
	      });
	      return c > 0;
	    },
	    buscaProposta: function buscaProposta() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this3.gerenciaRequisicao('Relatório de Análise', 'Carregando');
	                _this3.loading.show = true;
	                _context6.next = 4;
	                return axiosLaravel.get('propostas/' + _this3.$route.params.id).then(function () {
	                  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(response) {
	                    var metas, objetivosFormatado, objetivoGeral, objetivoEspecificoFinal, metasFormatado, metasFinal, itemFBB, itemParceria, itemSemContaFBB, agrupadoContasFBB, contasValorFBB, itemSemContaParceiro, agrupadoContasParcerias, contasValorParcerias, somenteComContaFinanceira, ordenado, ordenadoAgrupado, key, myNewArray, i, totalProjeto;
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            _this3.proposta = response.data;
	                            _this3.somenteLeitura = _.has(_this3.proposta, 'ds_situacao_erp') && !_.isNull(_this3.proposta.ds_situacao_erp) && !_.includes(['ANA', 'DEF', 'OPE'], _this3.proposta.ds_situacao_erp) || _this3.proposta.ds_fase === 'DEFERIMENTO' || _this3.proposta.ds_fase === 'APROVACAO_PROJETO';
	
	                            if (_this3.proposta.relatorio_analise) {
	                              _this3.relatorioAnalise = JSON.parse(_this3.proposta.relatorio_analise);
	                            }
	
	                            if (!_this3.somenteLeitura) {
	                              _context5.next = 6;
	                              break;
	                            }
	
	                            _context5.next = 6;
	                            return axiosLaravel.put('propostas/' + _this3.$route.params.id + '/calcula-risco').then(function () {
	                              var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(response) {
	                                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                  while (1) {
	                                    switch (_context4.prev = _context4.next) {
	                                      case 0:
	                                        _this3.riscoCalculado = response.data;
	                                        _this3.$forceUpdate();
	
	                                      case 2:
	                                      case 'end':
	                                        return _context4.stop();
	                                    }
	                                  }
	                                }, _callee4, _this3);
	                              }));
	
	                              return function (_x3) {
	                                return _ref3.apply(this, arguments);
	                              };
	                            }());
	
	                          case 6:
	
	                            _this3.proposta['projetoAprovado'] = _.has(_this3.proposta, 'ds_situacao_erp') && !_.isNull(_this3.proposta.ds_situacao_erp) && !_.includes(['ANA', 'DEF', 'ANU', 'CAN', 'IND', 'ENC', 'DLG', 'JUD', 'OPE'], _this3.proposta.ds_situacao_erp);
	                            metas = [];
	                            objetivosFormatado = '';
	                            objetivoGeral = '';
	                            objetivoEspecificoFinal = '';
	                            metasFormatado = '';
	                            metasFinal = '';
	
	                            if (_this3.proposta.ds_indicadores_resultado) {
	                              _this3.relatorioAnalise.ds_indicadores_resultado = _.cloneDeep(_this3.proposta.ds_indicadores_resultado);
	                            }
	                            if (_this3.proposta.ds_acoes_comunicacao) {
	                              _this3.relatorioAnalise.ds_acoes_comunicacao = _.cloneDeep(_this3.proposta.ds_acoes_comunicacao);
	                            }
	                            if (_this3.proposta.questionario_respostas) {
	                              if (_this3.proposta.questionario_respostas.rating) {
	                                _this3.relatorioAnalise.ds_regularidade_rating = _this3.proposta.questionario_respostas.rating;
	                              }
	                            }
	                            if (_this3.proposta.ds_numero_fep) {
	                              _this3.relatorioAnalise.ds_enquadramento_fep = _this3.proposta.ds_numero_fep;
	                            }
	                            itemFBB = [];
	                            itemParceria = [];
	
	                            _this3.proposta.atividades.forEach(function (atividade) {
	                              if (atividade.itens_orcamentos) {
	                                atividade.itens_orcamentos.forEach(function (item) {
	                                  if ('' + item.origem === '1') {
	                                    _this3.relatorioAnalise.itensFbb.push(item);
	                                    itemFBB.push(item);
	                                    _this3.totalFBB += item.valor_unitario * item.quantidade;
	                                  }
	                                  if ('' + item.origem === '2') {
	                                    if (_this3.relatorioAnalise.itensContrapartida) {
	                                      _this3.relatorioAnalise.itensContrapartida.push(item);
	                                    } else {
	                                      for (var i = 0; i < _this3.relatorioAnalise.itensContrapartida.length; i++) {
	                                        if (_this3.relatorioAnalise.itensContrapartida[i].item.obs === null) {
	                                          _this3.relatorioAnalise.itensContrapartida[i].item.obs = '';
	                                        }
	                                      }
	                                    }
	                                    _this3.totalContrapartida += item.valor_unitario * item.quantidade;
	                                  }
	                                  if ('' + item.origem === '5') {
	                                    _this3.relatorioAnalise.itensParceiro.push(item);
	                                    itemParceria.push(item);
	                                    _this3.totalParceiro += item.valor_unitario * item.quantidade;
	                                  }
	                                });
	                              }
	                            });
	                            itemSemContaFBB = false;
	                            agrupadoContasFBB = _.groupBy(itemFBB, function (g) {
	                              if (g.conta_financeira) {
	                                return g.conta_financeira.descricao;
	                              } else {
	                                if (!itemSemContaFBB) {
	                                  itemSemContaFBB = true;
	                                }
	                                return 'SEM CONTA FINANCEIRA CADASTRADA';
	                              }
	                            });
	
	                            _this3.itemSemContaFinanceiraFBB = itemSemContaFBB;
	                            contasValorFBB = [];
	
	                            _.forEach(agrupadoContasFBB, function (conta, contaNome) {
	                              contasValorFBB.push({ 'conta': contaNome, 'valor': _.sumBy(conta, function (item) {
	                                  return parseFloat(parseFloat(item.quantidade) * parseFloat(item.valor_unitario));
	                                }) });
	                            });
	                            _this3.relatorioAnalise.itensFbb = contasValorFBB;
	                            itemSemContaParceiro = false;
	                            agrupadoContasParcerias = _.groupBy(itemParceria, function (g) {
	                              if (g.conta_financeira) {
	                                return g.conta_financeira.descricao;
	                              } else {
	                                if (!itemSemContaParceiro) {
	                                  itemSemContaParceiro = true;
	                                }
	                                return 'SEM CONTA FINANCEIRA CADASTRADA';
	                              }
	                            });
	
	                            _this3.itemSemContaFinanceiraParceiro = itemSemContaParceiro;
	                            contasValorParcerias = [];
	
	                            _.forEach(agrupadoContasParcerias, function (conta, contaNome) {
	                              contasValorParcerias.push({ 'conta': contaNome, 'valor': _.sumBy(conta, function (item) {
	                                  return parseFloat(parseFloat(item.quantidade) * parseFloat(item.valor_unitario));
	                                }) });
	                            });
	                            _this3.relatorioAnalise.itensParceiro = contasValorParcerias;
	                            somenteComContaFinanceira = _.filter(_this3.relatorioAnalise.itensContrapartida, function (c) {
	                              return _.has(c.conta_financeira, 'numero_conta') && _.has(c.conta_financeira, 'descricao');
	                            });
	                            ordenado = _.sortBy(somenteComContaFinanceira, ['item.ds_code']);
	                            ordenadoAgrupado = _.groupBy(ordenado, function (value) {
	                              return value.conta_financeira.descricao;
	                            });
	
	                            for (key in ordenadoAgrupado) {
	                              ordenadoAgrupado[key] = ordenadoAgrupado[key].reduce(function (acc, curr) {
	                                acc[curr.item.ds_code + ' - ' + curr.item.ds_description] ? acc[curr.item.ds_code + ' - ' + curr.item.ds_description] += curr.valor_unitario * curr.quantidade : acc[curr.item.ds_code + ' - ' + curr.item.ds_description] = curr.valor_unitario * curr.quantidade;
	                                return acc;
	                              }, []);
	                            }
	                            myNewArray = [];
	
	                            myNewArray = _.map(ordenadoAgrupado, function (item, key) {
	                              return {
	                                conta: key,
	                                item: _.mapValues(item, function (value, key) {
	                                  return {
	                                    item: key,
	                                    valor: value
	                                  };
	                                })
	                              };
	                            });
	                            _this3.relatorioAnalise.itensContrapartida = _.cloneDeep(myNewArray);
	                            objetivosFormatado = _.map(_this3.proposta.objetivos, 'ds_descricao');
	                            objetivosFormatado = objetivosFormatado.join(',');
	                            objetivoEspecificoFinal = 'Objetivo(s) Específico(s): \n' + objetivosFormatado.split(',').join('\n');
	                            objetivoGeral = 'Objetivo Geral: \n' + _this3.proposta.ds_objetivo_geral;
	
	                            _this3.proposta.metas.forEach(function (meta) {
	                              metas.push(meta.ds_descricao);
	                            });
	                            metasFormatado = _.map(metas).join(',');
	                            metasFinal = 'Meta(s): \n' + metasFormatado.split(',').join('\n');
	
	                            _this3.relatorioAnalise.ds_indicadores_resumo = objetivoGeral + '\n\n' + objetivoEspecificoFinal + '\n\n' + metasFinal;
	                            if (_this3.proposta.publicos_alvo) {
	                              for (i = 0; i < _this3.proposta.publicos_alvo.length; i++) {
	                                _this3.participantes = _this3.participantes + _this3.proposta.publicos_alvo[i].nr_participantes_diretos;
	                              }
	                              _this3.relatorioAnalise.ds_indicadores_participantes = parseInt(_this3.participantes);
	                              _this3.relatorioAnalise.ds_indicadores_publico = _this3.proposta.publicos_alvo[0].fonte;
	                            }
	
	                            _this3.relatorioAnalise.ds_execucao_prazo = _this3.proposta.nr_periodos;
	                            _this3.relatorioAnalise.ds_execucao_relatorios = _this3.proposta.ds_periodicidade_formulario;
	                            if (_this3.proposta.ds_alcada) {
	                              _this3.relatorioAnalise.ds_alcada = _this3.proposta.ds_alcada;
	                            }
	                            totalProjeto = _this3.totalFBB + _this3.totalParceiro;
	
	                            _this3.faixaDoProjeto = _.find(_this3.faixasInvestimento, function (faixa) {
	                              return faixa.de <= totalProjeto && totalProjeto <= faixa.para;
	                            });
	
	                            if (_.includes([1, 2], _this3.faixaDoProjeto.faixa)) {
	                              _this3.riscoCalculado = 'C';
	                            }
	                            _this3.gerenciaRequisicao('Relatório de Análise', 'OK');
	                            _this3.$forceUpdate();
	
	                          case 56:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this3);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this3.gerenciaRequisicao('Relatório de Análise', 'ERRO', error);
	                  _this3.loading.show = false;
	                  console.log('ERRO: ', error);
	                  _this3.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this3);
	      }))();
	    },
	    carregarProjetoDuplicador: function carregarProjetoDuplicador() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (_this4.proposta.nr_projeto_duplicacao) {
	                  _context7.next = 4;
	                  break;
	                }
	
	                _this4.semProjetoDuplicador = true;
	                _this4.gerenciaRequisicao('Projeto Duplicador', 'NAO CADASTRADO');
	                return _context7.abrupt('return');
	
	              case 4:
	                _this4.gerenciaRequisicao('Projeto Duplicador', 'Carregando');
	                _context7.next = 7;
	                return axiosLaravel.get('projeto/sapiens/' + _this4.proposta.nr_projeto_duplicacao).then(function (response) {
	                  _this4.proposta['duplicadorSapiens'] = response.data[0];
	                  _this4.carregarProjetoSuperior();
	                  _this4.gerenciaRequisicao('Projeto Duplicador', 'OK');
	                }).catch(function (error) {
	                  _this4.gerenciaRequisicao('Projeto Duplicador', 'ERRO', error);
	                  _this4.$snotify.clear();
	                  _this4.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 7:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this4);
	      }))();
	    },
	    carregarProjetoSuperior: function carregarProjetoSuperior() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this5.gerenciaRequisicao('Projeto Superior', 'Carregando');
	                _context8.next = 3;
	                return axiosLaravel.get('projeto/sapiens/' + _this5.proposta.duplicadorSapiens.prjsup).then(function (response) {
	                  _this5.proposta['superiorSapiens'] = response.data[0];
	                  _this5.projetoSuperior = _this5.proposta.superiorSapiens.numprj + ' - ' + _this5.proposta.superiorSapiens.nomprj;
	
	                  _this5.ehPIS = _.includes(['15114', '15120', '15126', '15132', '15094', '15575', '18140', '18206'], '' + _this5.proposta.superiorSapiens.numprj);
	                  _this5.ehEditalMN = _.includes(['18286'], '' + _this5.proposta.superiorSapiens.numprj);
	                  _this5.ehVoluntariado = _.includes(['15577', '18182'], '' + _this5.proposta.superiorSapiens.numprj);
	                  _this5.gerenciaRequisicao('Projeto Superior', 'OK');
	                }).catch(function (error) {
	                  _this5.gerenciaRequisicao('Projeto Superior', 'ERRO', error);
	                  _this5.$snotify.clear();
	                  _this5.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 3:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this5);
	      }))();
	    },
	    buscarBaseODS: function buscarBaseODS() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _this6.loading.show = true;
	                _this6.gerenciaRequisicao('ODS', 'Carregando');
	                _context9.next = 4;
	                return axiosLaravel.get('/ods').then(function (response) {
	                  _this6.initListaODS(response.data);
	                  _this6.carregarODS();
	
	                  _this6.$forceUpdate();
	                }).catch(function (error) {
	                  _this6.gerenciaRequisicao('ODS', 'ERRO', error);
	                  _this6.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 4:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this6);
	      }))();
	    },
	    buscaStatusProposta: function buscaStatusProposta() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _this7.loading.show = true;
	                _this7.gerenciaRequisicao('Status da Proposta', 'Carregando');
	                _context10.next = 4;
	                return axiosLaravel.get('/propostas/buscaStatusProposta/' + _this7.$route.params.id).then(function (response) {
	                  console.log(response.data);
	                  var status = response.data;
	                  _this7.gerenciaRequisicao('Status da Proposta', 'OK');
	                  if (_.includes(['APR', 'SO3', 'SO4', 'JUD', 'SUS', 'ENC'], status.ds_situacao_erp)) {
	                    window.location.href = '/proposta/visualiza-relatorio-analise/' + _this7.$route.params.id;
	                  }
	                  _this7.$forceUpdate();
	                }).catch(function (error) {
	                  _this7.gerenciaRequisicao('Status da Proposta', 'ERRO', error);
	                  _this7.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this7);
	      }))();
	    },
	    initListaODS: function initListaODS(lista) {
	      var _this8 = this;
	
	      var ods = lista;
	      ods.forEach(function (itemODS) {
	        var odsItem = {
	          odsId: itemODS.id,
	          ods: itemODS.descricao,
	          metas: []
	        };
	        itemODS.metas.forEach(function (meta) {
	          var metaItem = {
	            numeroMeta: meta.numero_meta,
	            descricao: meta.descricao,
	            odsFk: meta.ods_fk
	          };
	          odsItem.metas.push(metaItem);
	        });
	        _this8.odsTodaBase.push(odsItem);
	        _this8.$forceUpdate();
	      });
	    },
	    carregarODS: function carregarODS() {
	      var _this9 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _context11.next = 2;
	                return axiosLaravel.get('/ods/getMetasODS/' + _this9.$route.params.id).then(function (response) {
	                  var cadastro = response.data;
	                  _this9.loading.show = true;
	                  if (cadastro.length > 0) {
	                    var idsODs = [].concat((0, _toConsumableArray3.default)(new _set2.default(cadastro.map(function (item) {
	                      return item.ods_fk;
	                    }))));
	                    idsODs.forEach(function (id) {
	                      var ods = {
	                        idOds: id,
	                        descricao: '',
	                        metas: ''
	                      };
	                      _this9.odsTodaBase.forEach(function (item) {
	                        if (item.odsId === Number(id)) {
	                          ods.descricao = item.ods;
	                        }
	                      });
	                      cadastro.forEach(function (selecionado) {
	                        if (selecionado.ods_fk === id) {
	                          ods.metas = ods.metas + ', ' + selecionado.numero_meta;
	                        }
	                      });
	                      ods.metas = ods.metas.substring(1);
	                      _this9.odsCadastrado.push(ods);
	                    });
	                    _this9.$forceUpdate();
	                    _this9.loading.show = true;
	                    _this9.odsCadastrado.forEach(function (ods) {
	                      var metas = ods.metas.split(', ');
	                      var metasDescricao = [];
	                      metas.forEach(function (meta) {
	                        var selecionado = {
	                          descricao: '',
	                          numeroMeta: '',
	                          odsFk: ods.idOds
	                        };
	                        selecionado.numeroMeta = meta.trim();
	                        _this9.odsTodaBase.forEach(function (ods) {
	                          ods.metas.forEach(function (meta) {
	                            if (meta.numeroMeta === selecionado.numeroMeta) {
	                              selecionado.descricao = meta.descricao;
	                            }
	                          });
	                        });
	                        metasDescricao.push(selecionado);
	                      });
	                      ods.metasDescricao = metasDescricao;
	                    });
	                  } else {
	                    _this9.odsCadastrado = [];
	                  }
	                  _this9.gerenciaRequisicao('ODS', 'OK');
	                }).catch(function (error) {
	                  _this9.gerenciaRequisicao('ODS', 'ERRO', error);
	                  _this9.$snotify.clear();
	                  console.log('ERRO: ', error);
	                  _this9.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 2:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this9);
	      }))();
	    },
	    consultaTecnologiasCadastradas: function consultaTecnologiasCadastradas() {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _this10.loading.show = true;
	                _this10.gerenciaRequisicao('Tecnologias Sociais', 'Carregando');
	                _context12.next = 4;
	                return axiosLaravel.get('/tecnologiasocial/consultarTecnologiaPorProposta/' + _this10.$route.params.id).then(function (response) {
	                  _this10.tecnologiasCadastradas = response.data;
	                  if (response.data.length > 0) {
	                    _this10.possuiTecnologiaSocial = true;
	                  } else {
	                    _this10.possuiTecnologiaSocial = false;
	                  }
	                  _this10.gerenciaRequisicao('Tecnologias Sociais', 'OK');
	                  _this10.$forceUpdate();
	                }).catch(function (error) {
	                  _this10.gerenciaRequisicao('Tecnologias Sociais', 'ERRO', error);
	                  _this10.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                  _this10.loading.show = false;
	                  _this10.$forceUpdate();
	                });
	
	              case 4:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this10);
	      }))();
	    },
	    buscaDefinicaoPublicoAlvo: function buscaDefinicaoPublicoAlvo() {
	      var _this11 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _this11.loading.show = true;
	                _this11.gerenciaRequisicao('Público-Alvo Previsto', 'Carregando');
	                _context13.next = 4;
	                return axiosLaravel.get('definicaoparticipante').then(function (response) {
	                  _this11.definicaoPublicoAlvo = response.data;
	                  _this11.buscaPublicoAlvoPrevisto();
	                }).catch(function (error) {
	                  _this11.gerenciaRequisicao('Público-Alvo Previsto', 'ERRO', error);
	                  _this11.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                  _this11.loading.show = false;
	                });
	
	              case 4:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this11);
	      }))();
	    },
	    buscaPublicoAlvoPrevisto: function buscaPublicoAlvoPrevisto() {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _this12.loading.show = true;
	                _context14.next = 3;
	                return axiosLaravel.get('/definicaoparticipante/getPrevistosProjeto/' + _this12.$route.params.id).then(function (response) {
	                  _this12.publicoAlvoPrevisto = response.data;
	                  _this12.publicoAlvoPrevisto.forEach(function (item) {
	                    _this12.definicaoPublicoAlvo.forEach(function (definicao) {
	                      definicao.subgrupos.forEach(function (subgrupo) {
	                        if (subgrupo.id === item) {
	                          _this12.publicoAlvoDefinicoes.push(subgrupo.subgrupo);
	                        }
	                      });
	                    });
	                  });
	                  _this12.gerenciaRequisicao('Público-Alvo Previsto', 'OK');
	                  _this12.$forceUpdate();
	                }).catch(function (error) {
	                  _this12.gerenciaRequisicao('Público-Alvo Previsto', 'ERRO', error);
	                  _this12.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                  _this12.loading.show = false;
	                  _this12.$forceUpdate();
	                });
	
	              case 3:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this12);
	      }))();
	    },
	    buscaIndicadorAvaliacao: function buscaIndicadorAvaliacao() {
	      var _this13 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                _this13.loading.show = true;
	                _this13.gerenciaRequisicao('Indicadores de Avaliação', 'Carregando');
	                _context15.next = 4;
	                return axiosLaravel.get('/avaliacao/carregarRespostasRelatorioAnalise/' + _this13.$route.params.id).then(function (response) {
	                  _this13.questoesAvaliacao = response.data;
	                  _this13.loading.show = false;
	                  _this13.gerenciaRequisicao('Indicadores de Avaliação', 'OK');
	                  _this13.$forceUpdate();
	                }).catch(function (error) {
	                  _this13.gerenciaRequisicao('Indicadores de Avaliação', 'ERRO', error);
	                  _this13.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                  _this13.loading.show = false;
	                  _this13.$forceUpdate();
	                });
	
	              case 4:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this13);
	      }))();
	    },
	    buscaEntidades: function buscaEntidades() {
	      var _this14 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16() {
	        var currentDate, hoje;
	        return _regenerator2.default.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                currentDate = new Date();
	                hoje = (0, _moment2.default)(currentDate).format('YYYYMMDD');
	                _context16.next = 4;
	                return axiosLaravel.get('entidades/' + _this14.proposta.entidade.id).then(function (response) {
	                  _this14.proposta.entidade = response.data;
	                  var codigo = _this14.proposta.entidade.fk_forma_juridica;
	                  var descricao = _this14.ehNulo(_.find(_this14.$store.state.formasJuridicas, ['codigo', codigo])['descricao'], '!');
	                  _this14.formaJuridica = codigo + ' - ' + descricao;
	                  var isTrue = function isTrue(v) {
	                    return v === true || v === 1 || v === '1' || v === 'true';
	                  };
	                  var array = _.filter(response.data.dirigentes, function (o) {
	                    if (isTrue(o.bt_assinatura_entidade) && isTrue(o.bt_ativo) && isTrue(o.bt_representante_legal) && isTrue(o.bt_assinatura_requerida)) {
	                      var dataInicial = (0, _moment2.default)(o.dt_inicio_mandato).format('YYYYMMDD');
	                      var dataFinal = (0, _moment2.default)(o.dt_fim_mandato).format('YYYYMMDD');
	
	                      if (dataInicial <= hoje && hoje <= dataFinal) {
	                        o.ds_cpf = ('00000000000' + o.ds_cpf).slice(-11);
	                        return o;
	                      }
	                    }
	                  });
	                  _this14.proposta.entidade.dirigentes = array;
	                  _this14.$forceUpdate();
	                }).catch(function (error) {
	                  if (error) {
	                    _this14.$snotify.clear();
	                    _this14.$root.trataErro(error);
	                    console.log('ERRO: ', error);
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this14);
	      }))();
	    },
	    buscaPublicoAlvo: function buscaPublicoAlvo() {
	      var _this15 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17() {
	        return _regenerator2.default.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                _this15.gerenciaRequisicao('Público-Alvo Fonte', 'Carregando');
	                _context17.next = 3;
	                return axiosLaravel.get('publico-alvo-fonte').then(function (response) {
	                  _this15.publicosAlvo = response.data;
	                  _this15.gerenciaRequisicao('Público-Alvo Fonte', 'OK');
	                }).catch(function (error) {
	                  _this15.gerenciaRequisicao('Público-Alvo Fonte', 'ERRO', error);
	                  _this15.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 3:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this15);
	      }))();
	    },
	    buscaDadosProposta: function buscaDadosProposta() {
	      var _this16 = this;
	
	      if (this.proposta.entidade) {
	        var array = [];
	        axiosLaravel.get('/entidades/' + this.proposta.entidade.id + '/propostas').then(function (response) {
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].ds_codigo_projeto_erp !== null) {
	              array.push(response.data[i]);
	            }
	          }
	          _this16.todasPropostas = _.cloneDeep(array);
	          _this16.$forceUpdate();
	        }).catch(function (error) {
	          if (error) {
	            _this16.$snotify.clear();
	            _this16.$root.trataErro(error);
	            console.log('ERRO: ', error);
	          }
	        });
	      }
	    },
	    atualizaProposta: function atualizaProposta() {
	      var bc = new BroadcastChannel('proposta-' + this.$route.params.id);
	      console.log('>>>> BROADCAST: ' + 'proposta-' + this.$route.params.id);
	      var dadosRelatorio = (0, _stringify2.default)(this.relatorioAnalise);
	      bc.postMessage({ acao: 'set', objeto: 'proposta.relatorio_analise', id: this.$route.params.id, valor: dadosRelatorio });
	
	      bc.postMessage({ acao: 'salvarProposta', id: this.$route.params.id });
	
	      bc.close();
	    },
	    gravaRelatorio: function gravaRelatorio() {
	      var _this17 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          var idProposta = _this17.$route.params.id;
	          _this17.$aguarde('Salvando o Relatório da Análise. Por favor, aguarde...');
	          axiosLaravel.post('propostas/grava-relatorio/' + idProposta, _this17.relatorioAnalise).then(function (response) {
	            _this17.atualizaProposta();
	            _this17.$snotify.clear();
	            _this17.$snotify.success('Relatório da Análise salvo com sucesso');
	
	            _this17.gravarLogRelatorioAnalise();
	          }).catch(function (error) {
	            _this17.$snotify.clear();
	            _this17.$root.trataErro(error);
	            console.log('ERRO: ', error);
	          });
	        } else {
	          if (_this17.$validator.errors.items.length > 0) {
	            _this17.$validator.errors.items.forEach(function (item) {
	              _this17.$snotify.error('O campo ' + item.field + ' não foi preenchido. Favor verificar');
	            });
	          }
	        }
	      });
	    },
	    gravarLogRelatorioAnalise: function gravarLogRelatorioAnalise() {
	      var _this18 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                obj = {
	                  idProposta: _this18.$route.params.id,
	                  relatorioAnalise: _this18.relatorioAnalise,
	                  navegador: _this18.navegador,
	                  usuarioSalvamento: _this18.usuarioSalvamento,
	                  tabID: _this18.tabID
	                };
	
	                _this18.$aguarde('Salvando o LOG do Relatório da Análise. Por favor, aguarde...');
	                _context18.next = 4;
	                return axiosLaravel.post('propostas/gravaLogSnapshotRelatorioAnalise/', obj).then(function (response) {
	                  _this18.$snotify.clear();
	                  _this18.$snotify.success(response.data);
	                  if (_this18.sairRelatorio) {
	                    close();
	                  }
	                }).catch(function (error) {
	                  _this18.$snotify.clear();
	                  _this18.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 4:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this18);
	      }))();
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      if (this.riscoCalculado === '' && !_.includes([1, 2], faixaDoProjeto.faixa)) {
	        this.$snotify.clear();
	        this.$snotify.warning('Atenção: Risco do Projeto ainda não calculdo');
	      }
	
	      this.gravaRelatorio();
	      window.print();
	    },
	    print: function print() {
	      var element = document.getElementById('relatorio_analise');
	      var opt = {
	        margin: 1,
	        filename: 'myfile.pdf',
	        image: { type: 'jpeg', quality: 0.98 },
	        html2canvas: { scale: 2 },
	        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
	      };
	      (0, _html2pdf2.default)(element, opt);
	    },
	    passaParams: function passaParams(data) {
	      for (var i = 0; i < this.relatorioAnalise.itensContrapartida.length; i++) {
	        if (data.conta === this.relatorioAnalise.itensContrapartida[i].conta) {
	          if (data.item.obs) {
	            this.relatorioAnalise.itensContrapartida[i].item.obs = data.item.obs;
	          }
	        }
	      }
	
	      this.$forceUpdate();
	    },
	    confirmacao: function confirmacao(event) {
	      if (event === true) {
	        this.$swal({
	          title: '<font color="red"><b>Confirmação!</b></font>',
	          html: '<div align="left"> Estou ciente do conteúdo retornado automaticamente pelo sistema.' + '</div>',
	          showCloseButton: true,
	          showCancelButton: false,
	          showLoaderOnConfirm: true,
	          focusConfirm: false
	        });
	      }
	    },
	    carregaRating: function carregaRating() {
	      var _this19 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20() {
	        return _regenerator2.default.wrap(function _callee20$(_context20) {
	          while (1) {
	            switch (_context20.prev = _context20.next) {
	              case 0:
	                _this19.gerenciaRequisicao('Rating', 'Carregando');
	                _context20.next = 3;
	                return axiosLaravel.post('rating/carregar/', { 'idProposta': _this19.proposta.id }).then(function () {
	                  var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19(response) {
	                    return _regenerator2.default.wrap(function _callee19$(_context19) {
	                      while (1) {
	                        switch (_context19.prev = _context19.next) {
	                          case 0:
	                            if (!_.isNil(response.data) && !_.isEmpty(response.data)) {
	                              _.set(_this19.proposta, 'rating', response.data);
	                            }
	                            _this19.$forceUpdate();
	                            _this19.gerenciaRequisicao('Rating', 'OK');
	
	                          case 3:
	                          case 'end':
	                            return _context19.stop();
	                        }
	                      }
	                    }, _callee19, _this19);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this19.gerenciaRequisicao('Rating', 'ERRO', error);
	                  _this19.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 3:
	              case 'end':
	                return _context20.stop();
	            }
	          }
	        }, _callee20, _this19);
	      }))();
	    },
	    calculaRisco: function calculaRisco() {
	      var _this20 = this;
	
	      this.$aguarde('Calculando risco da proposta...');
	      axiosLaravel.put('propostas/' + this.$route.params.id + '/calcula-risco').then(function () {
	        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21(response) {
	          return _regenerator2.default.wrap(function _callee21$(_context21) {
	            while (1) {
	              switch (_context21.prev = _context21.next) {
	                case 0:
	                  _this20.riscoCalculado = response.data;
	                  _this20.$snotify.clear();
	                  _this20.$forceUpdate();
	
	                  _this20.gravaRelatorio();
	
	                case 4:
	                case 'end':
	                  return _context21.stop();
	              }
	            }
	          }, _callee21, _this20);
	        }));
	
	        return function (_x5) {
	          return _ref5.apply(this, arguments);
	        };
	      }()).catch(function () {
	        _this20.$snotify.clear();
	        _this20.$snotify.warning('Pendências na proposta: Falta preencher o Questionário de Risco e calcular o Rating da Entidade na edição da proposta.');
	      });
	    },
	    consultaRiscoCalculado: function consultaRiscoCalculado() {
	      var _this21 = this;
	
	      this.gerenciaRequisicao('Risco Calculado', 'Carregando');
	      axiosLaravel.get('propostas/' + this.$route.params.id + '/consulta-risco-calculado').then(function () {
	        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee22(response) {
	          return _regenerator2.default.wrap(function _callee22$(_context22) {
	            while (1) {
	              switch (_context22.prev = _context22.next) {
	                case 0:
	                  _this21.riscoCalculado = response.data;
	                  _this21.gerenciaRequisicao('Risco Calculado', 'OK');
	                  _this21.$forceUpdate();
	
	                case 3:
	                case 'end':
	                  return _context22.stop();
	              }
	            }
	          }, _callee22, _this21);
	        }));
	
	        return function (_x6) {
	          return _ref6.apply(this, arguments);
	        };
	      }()).catch(function (error) {
	        _this21.gerenciaRequisicao('Risco Calculado', 'ERRO', error);
	        _this21.$root.trataErro(error);
	        console.log('ERRO: ', error);
	      });
	    }
	  }
	};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(109);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _html2pdf = __webpack_require__(140);
	
	var _html2pdf2 = _interopRequireDefault(_html2pdf);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'relatorio-fep',
	  data: function data() {
	    return {
	      showgrid: true,
	      relatorioFep: {
	        itensFbb: [],
	        itensContrapartida: [],
	        itensParceiro: []
	      },
	      loading: {
	        show: false
	      },
	      fepExcel: 'fep.xls',
	      categorizadores: {},
	      vinculoParcerias: '',
	      json_data: [],
	      json_fields: {
	        'Título': 'ds_nome',
	        'Proponente': 'entidade.ds_nome',
	        'CNPJ': 'entidade.ds_cnpj',
	        'Projeto Superior': 'nr_projeto_duplicacao',
	        'Eixo de Atuação': 'ds_categ_campo_atuacao',
	        'Programa': 'ds_fep_programa',
	        'Ação': 'ds_categ_acao',
	        'Parceria Estratégica': 'ds_categ_acao',
	        'Tipo Ação': 'ds_fep_tipo_acao',
	        'Abrangência': 'abrangencia',
	        'Participantes Diretos': 'participantes_diretos',
	        'Prospecção': 'ds_categ_prospeccao',
	        'Nome do Processo': 'ds_categ_edital',
	        'Cadeia Produtiva': 'ds_categ_vetor',
	        'Orçamento FBB': 'totalFBB',
	        'Terceiros': 'totalParceiro',
	        'Observação': 'ds_fep_observacao'
	      },
	      json_meta: [[{
	        'key': 'charset',
	        'value': 'utf-8'
	      }]],
	      hoje: (0, _moment2.default)().format('DD/MM/YYYY'),
	      nome: '',
	      nomeEntidade: '',
	      cnpj: '',
	      projetoSuperior: '',
	      proposta: {},
	      opcoes: ['Sim', 'Não', 'N/A'],
	      totalFBB: 0,
	      totalContrapartida: 0,
	      totalParceiro: 0,
	      meta: {},
	      perguntas: {},
	      metaIndex: [],
	      publicosAlvo: {},
	      formasContratacao: [],
	      editando: null,
	      atividadeForm: {
	        nr_periodo_final: null,
	        itens_orcamentos: [],
	        metas: {},
	        ds_nome: '',
	        nr_periodo_inicial: null,
	        ds_documento_comprobatorio: ''
	      },
	      atividadeTabela: {},
	      opcao_qtde_assinaturas: 3
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  created: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var i;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return this.buscaProposta();
	
	            case 2:
	              this.fepExcel = !_.isUndefined(this.proposta.ds_numero_fep) ? 'fep_' + this.proposta.ds_numero_fep.replace('/', '_') + '.xls' : 'fep.xls';
	              this.json_data[0] = this.proposta;
	              this.json_data[0]['abrangencia'] = this.abrangencia;
	              this.json_data[0]['participantes_diretos'] = this.publicoAlvo;
	              this.json_data[0]['totalFBB'] = this.totalFBB;
	              this.json_data[0]['totalFBB'] = this.totalFBB;
	              this.json_data[0]['totalContrapartida'] = this.totalContrapartida;
	              this.json_data[0]['totalParceiro'] = this.totalParceiro;
	              for (i = 0; i < this.json_data.length; i++) {
	                this.json_data[i].entidade.ds_cnpj = this.json_data[i].entidade.ds_cnpj + ' ';
	              }
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function created() {
	      return _ref.apply(this, arguments);
	    }
	
	    return created;
	  }(),
	  methods: {
	    closewindow: function closewindow() {
	      close();
	    },
	    troca: function troca(grupo, valor) {
	      var categorizador = _.find(this.categorizadores, function (c) {
	        return c.grupo === grupo && '' + c.valor === '' + valor;
	      });
	      return valor + ' - ' + (_.isUndefined(categorizador) ? 'Valor não localizado entre os categorizadoes' : categorizador.codigo);
	    },
	    gravaFep: function gravaFep() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return axiosLaravel.post('fep', { 'fk_proposta': _this.proposta.id }).then(function (response) {
	                  _this.proposta.fep = { 'id': response.data['id'] };
	
	                  var bc = new BroadcastChannel('propostas');
	
	                  if (_this.proposta.fep.fk_proposta === _this.proposta.id) {
	                    bc.postMessage({ acao: 'notificacaoAtualizaFep', fep: _this.proposta.fep });
	                  }
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }))();
	    },
	    salvaFep: function salvaFep() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this2.$validator.validateAll().then(function () {
	                  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(result) {
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!result) {
	                              _context3.next = 4;
	                              break;
	                            }
	
	                            _this2.$aguarde('Salvando FEP. Por favor, aguarde...');
	                            _context3.next = 4;
	                            return axiosLaravel.put('fep/' + _this2.proposta.fep.id, { 'fk_proposta': _this2.proposta.id, 'ano': _this2.proposta.fep.ano, 'numero': _this2.proposta.fep.numero }).then(function (response) {
	                              _this2.proposta.fep = response.data;
	                              _this2.$snotify.clear();
	                              _this2.$snotify.success('FEP atualizada com sucesso');
	                              var bc = new BroadcastChannel('propostas');
	
	                              if (_this2.proposta.fep.fk_proposta === _this2.proposta.id) {
	                                bc.postMessage({ acao: 'notificacaoAtualizaFep', fep: _this2.proposta.fep });
	                              }
	                            }).catch(function (error) {
	                              _this2.$snotify.clear();
	                              _this2.$root.trataErro(error);
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }))();
	    },
	    buscaProposta: function buscaProposta() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this3.loading.show = true;
	                _context6.next = 3;
	                return axiosLaravel.get('propostas/' + _this3.$route.params.id).then(function () {
	                  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(response) {
	                    var i, removeDup, str1, _i;
	
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            _this3.proposta = response.data;
	
	                            if (!(_.isEmpty(_this3.proposta.fep) || _.isNull(_this3.proposta.fep) || _.isUndefined(_this3.proposta))) {
	                              _context5.next = 4;
	                              break;
	                            }
	
	                            _context5.next = 4;
	                            return _this3.gravaFep();
	
	                          case 4:
	                            _this3.nome = _this3.proposta.ds_nome;
	                            _this3.nomeEntidade = _this3.proposta.entidade.ds_nome;
	                            _this3.cnpj = _this3.proposta.entidade.ds_cnpj;
	
	                            _this3.abrangencia = '';
	                            if (_this3.proposta.bt_fep_abrangencia === '1') {
	                              _this3.abrangencia = 'TERRITÓRIO NACIONAL';
	                            } else {
	                              for (i = 0; i < _this3.proposta.municipalizacao.length; i++) {
	                                _this3.abrangencia = _this3.proposta.municipalizacao[i].ds_municipio + '-' + _this3.proposta.municipalizacao[i].ds_uf + ' , ' + _this3.abrangencia;
	                              }
	                              removeDup = [].concat((0, _toConsumableArray3.default)(new _set2.default(_this3.abrangencia.split(', ')))).join(',');
	
	                              _this3.abrangencia = removeDup;
	                              str1 = _this3.abrangencia;
	
	                              _this3.abrangencia = str1.substring(0, str1.length - 2) + '';
	                            }
	                            _this3.proposta.atividades.forEach(function (atividade) {
	                              if (atividade.itens_orcamentos) {
	                                atividade.itens_orcamentos.forEach(function (item) {
	                                  if (item.origem === '1' || item.origem === 1) {
	                                    _this3.relatorioFep.itensFbb.push(item);
	                                    _this3.totalFBB += item.valor_unitario * item.quantidade;
	                                  }
	                                  if (item.origem === '2' || item.origem === 2) {
	                                    _this3.relatorioFep.itensContrapartida.push(item);
	                                    _this3.totalContrapartida += item.valor_unitario * item.quantidade;
	                                  }
	                                  if (item.origem === '5' || item.origem === 5) {
	                                    _this3.relatorioFep.itensParceiro.push(item);
	                                    _this3.totalParceiro += item.valor_unitario * item.quantidade;
	                                  }
	                                });
	                              }
	                            });
	                            _this3.publicoAlvo = '';
	                            for (_i = 0; _i < _this3.proposta.publicos_alvo.length; _i++) {
	                              _this3.publicoAlvo += _this3.proposta.publicos_alvo[_i].nr_participantes_diretos + ' ' + _this3.proposta.publicos_alvo[_i].fonte.ds_descricao;
	                              if (_i < _this3.proposta.publicos_alvo.length - 1) {
	                                _this3.publicoAlvo += ', ';
	                              }
	                            }
	                            _this3.carregarCategorizadores();
	                            _this3.carregarVinculosParcerias();
	                            _this3.carregarProjetoDuplicador();
	                            _this3.$forceUpdate();
	                            _this3.loading.show = false;
	
	                          case 17:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this3);
	                  }));
	
	                  return function (_x2) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this3.loading.show = false;
	                  _this3.$root.trataErro(error);
	                });
	
	              case 3:
	                _context6.next = 5;
	                return axiosLaravel.get('fep/consultaFepProposta/' + _this3.$route.params.id).then(function (response) {
	                  _this3.proposta.fep = response.data;
	                });
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this3);
	      }))();
	    },
	    carregarProjetoDuplicador: function carregarProjetoDuplicador() {
	      var _this4 = this;
	
	      axiosLaravel.get('projeto/sapiens/' + this.proposta.nr_projeto_duplicacao).then(function (response) {
	        _this4.proposta['duplicadorSapiens'] = response.data[0];
	        _this4.carregarProjetoSuperior();
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    carregarProjetoSuperior: function carregarProjetoSuperior() {
	      var _this5 = this;
	
	      axiosLaravel.get('projeto/sapiens/' + this.proposta.duplicadorSapiens.prjsup).then(function (response) {
	        _this5.proposta['superiorSapiens'] = response.data[0];
	        _this5.projetoSuperior = _this5.proposta.superiorSapiens.numprj + ' - ' + _this5.proposta.superiorSapiens.nomprj;
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    },
	    carregarCategorizadores: function carregarCategorizadores() {
	      var _this6 = this;
	
	      axiosLaravel.get('categorizadores/').then(function (response) {
	        _this6.categorizadores = response.data;
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    carregarVinculosParcerias: function carregarVinculosParcerias() {
	      var _this7 = this;
	
	      axiosLaravel.get('vinculo_parcerias/').then(function (response) {
	        var vm = _this7;
	        var parceria = _.find(response.data, function (p) {
	          return '' + p.id === '' + vm.proposta.duplicadorSapiens.usu_vinculo;
	        });
	        _this7.vinculoParcerias = _.isUndefined(parceria) ? '' : parceria.id + ' - ' + parceria.desc_vinculo;
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    },
	    print: function print() {
	      var element = document.getElementById('relatorio_fep');
	      var opt = {
	        margin: 1,
	        filename: 'myfile.pdf',
	        image: { type: 'jpeg', quality: 0.98 },
	        html2canvas: { scale: 2 },
	        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
	      };
	      (0, _html2pdf2.default)(element, opt);
	    }
	  }
	};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(109);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _html2pdf = __webpack_require__(140);
	
	var _html2pdf2 = _interopRequireDefault(_html2pdf);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'relatorio-fep-aberto',
	  data: function data() {
	    return {
	      showgrid: true,
	      relatorioFep: {
	        itensFbb: [],
	        itensContrapartida: [],
	        itensParceiro: []
	      },
	      loading: {
	        show: false
	      },
	      tiposAcao: [{ 'code': 'AT', 'description': 'Ação Tática' }, { 'code': 'AF', 'description': 'Ação Finalística' }],
	      fep: {},
	      fepExcel: 'fep.xls',
	      json_data: [],
	      json_fields: {
	        'Ano': 'ds_fep_ano',
	        'Numero': 'ds_fep_numero',
	        'Título': 'ds_nome',
	        'Proponente': 'entidade.ds_nome',
	        'CNPJ': 'entidade.ds_cnpj',
	        'Projeto Superior': 'nr_projeto_duplicacao',
	        'Eixo de Atuação': 'ds_categ_campo_atuacao',
	        'Programa': 'ds_fep_programa',
	        'Ação': 'ds_categ_acao',
	        'Parceria Estratégica': 'ds_categ_acao',
	        'Tipo Ação': 'ds_fep_tipo_acao',
	        'Abrangência': 'abrangencia',
	        'Participantes Diretos': 'participantes_diretos',
	        'Prospecção': 'ds_categ_prospeccao',
	        'Nome do Processo': 'ds_categ_edital',
	        'Cadeia Produtiva': 'ds_categ_vetor',
	        'Orçamento FBB': 'totalFBB',
	        'Terceiros': 'totalParceiro',
	        'Observação': 'ds_fep_observacao'
	      },
	      json_meta: [[{
	        'key': 'charset',
	        'value': 'utf-8'
	      }]],
	      id_fep: '',
	      ds_fep_ano: '',
	      ds_fep_numero: '',
	      hoje: (0, _moment2.default)().format('DD/MM/YYYY'),
	      nome: '',
	      nomeEntidade: '',
	      cnpj: '',
	      proposta: {},
	      opcoes: ['Sim', 'Não', 'N/A'],
	      totalFBB: 0,
	      totalContrapartida: 0,
	      totalParceiro: 0,
	      meta: {},
	      perguntas: {},
	      metaIndex: [],
	      publicosAlvo: {},
	      formasContratacao: [],
	      editando: null,
	      atividadeForm: {
	        nr_periodo_final: null,
	        itens_orcamentos: [],
	        metas: {},
	        ds_nome: '',
	        nr_periodo_inicial: null,
	        ds_documento_comprobatorio: ''
	      },
	      atividadeTabela: {},
	      opcao_qtde_assinaturas: 3
	    };
	  },
	
	  created: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!this.$route.params.id) {
	                _context.next = 3;
	                break;
	              }
	
	              _context.next = 3;
	              return this.buscaFep();
	
	            case 3:
	              this.fepExcel = this.fep.ano && this.fep.numero ? 'fep_' + this.fep.ano + '_' + this.fep.numero + '.xls' : 'fep.xls';
	              this.json_data[0] = this.fep;
	              this.json_data[0]['abrangencia'] = this.fep.abrangencia;
	              this.json_data[0]['participantes_diretos'] = this.fep.publico_alvo;
	              this.json_data[0]['totalFBB'] = this.fep.total_fbb;
	              this.json_data[0]['totalFBB'] = this.totalFBB;
	              this.json_data[0]['totalContrapartida'] = this.totalContrapartida;
	              this.json_data[0]['totalParceiro'] = this.totalParceiro;
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function created() {
	      return _ref.apply(this, arguments);
	    }
	
	    return created;
	  }(),
	  methods: {
	    buscaFep: function buscaFep() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.loading.show = true;
	                _context2.next = 3;
	                return axiosLaravel.get('fep/' + _this.$route.params.id).then(function (response) {
	                  console.log('Juliano buscaFEp response.data.fep', response.data.fep);
	                  _this.fep = JSON.parse(response.data.fep);
	                  delete _this.fep['fep'];
	                  console.log('Juliano buscaFEp this.fep', _this.fep);
	                  _this.id_fep = response.data.id;
	
	                  _this.loading.show = false;
	                }).catch(function (error) {
	                  _this.loading.show = false;
	                  _this.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }))();
	    },
	    salva: function salva() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this2.id_fep) {
	            _this2.fep;
	            console.log('Juliano salva this.fep', _this2.fep.ano);
	            console.log('Juliano salva this.fep', _this2.id_fep);
	            _this2.$aguarde('Atualizando a FEP. Por favor, aguarde...');
	            axiosLaravel.put('fep/atualiza/' + _this2.id_fep, _this2.fep).then(function (response) {
	              _this2.$snotify.clear();
	              _this2.$snotify.success('FEP atualizada com sucesso!');
	              _this2.fep = JSON.parse(response.data.fep);
	              _this2.id_fep = response.data.id;
	            }).catch(function (error) {
	              _this2.$snotify.clear();
	              _this2.$root.trataErro(error);
	            });
	          } else {
	            _this2.$aguarde('Salvando a FEP. Por favor, aguarde...');
	            axiosLaravel.post('fep/grava/', _this2.fep).then(function (response) {
	              _this2.$snotify.clear();
	              _this2.$snotify.success('FEP salva com sucesso!');
	              _this2.fep = JSON.parse(response.data.fep);
	              _this2.id_fep = response.data.id;
	            }).catch(function (error) {
	              _this2.$snotify.clear();
	              _this2.$root.trataErro(error);
	            });
	          }
	        }
	      });
	    },
	    troca: function troca(item) {
	      if (!_.isNull(item) && !_.isUndefined(item) && !_.isEmpty(item)) {
	        var out = item.replace(/^\s*/, '');
	        out = out.replace('_', ' ', function (str, offset) {
	          if (offset === 0) {
	            return str.toUpperCase();
	          } else {
	            return str.substr(0, 1) + ' ' + str.substr(1).toUpperCase();
	          }
	        });
	        return out;
	      }
	    },
	    buscaProposta: function buscaProposta() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this3.loading.show = true;
	                _context3.next = 3;
	                return axiosLaravel.get('propostas/' + _this3.$route.params.id).then(function (response) {
	                  _this3.proposta = response.data;
	                  _this3.nome = _this3.proposta.ds_nome;
	                  _this3.nomeEntidade = _this3.proposta.entidade.ds_nome;
	
	                  _this3.abrangencia = '';
	                  for (var i = 0; i < _this3.proposta.municipalizacao.length; i++) {
	                    _this3.abrangencia = _this3.proposta.municipalizacao[i].ds_municipio + ' , ' + _this3.abrangencia;
	                  }
	                  var removeDup = [].concat((0, _toConsumableArray3.default)(new _set2.default(_this3.abrangencia.split(', ')))).join(',');
	                  _this3.abrangencia = removeDup;
	                  var str1 = _this3.abrangencia;
	                  _this3.abrangencia = str1.substring(0, str1.length - 2) + '';
	                  _this3.proposta.atividades.forEach(function (atividade) {
	                    if (atividade.itens_orcamentos) {
	                      atividade.itens_orcamentos.forEach(function (item) {
	                        if (item.origem === '1') {
	                          _this3.relatorioFep.itensFbb.push(item);
	                          _this3.totalFBB += item.valor_unitario * item.quantidade;
	                        }
	                        if (item.origem === '2') {
	                          _this3.relatorioFep.itensContrapartida.push(item);
	                          _this3.totalContrapartida += item.valor_unitario * item.quantidade;
	                        }
	                        if (item.origem === '5') {
	                          _this3.relatorioFep.itensParceiro.push(item);
	                          _this3.totalParceiro += item.valor_unitario * item.quantidade;
	                        }
	                      });
	                    }
	                  });
	                  _this3.publicoAlvo = '';
	                  for (var _i = 0; _i < _this3.proposta.publicos_alvo.length; _i++) {
	                    _this3.publicoAlvo = _this3.publicoAlvo + _this3.proposta.publicos_alvo[_i].nr_participantes_diretos + ' ' + _this3.proposta.publicos_alvo[_i].fonte.ds_descricao;
	                  }
	                  _this3.$forceUpdate();
	                  _this3.loading.show = false;
	                }).catch(function (error) {
	                  _this3.loading.show = false;
	                  _this3.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    },
	    print: function print() {
	      var element = document.getElementById('relatorio_fep');
	      var opt = {
	        margin: 1,
	        filename: 'myfile.pdf',
	        image: { type: 'jpeg', quality: 0.98 },
	        html2canvas: { scale: 2 },
	        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
	      };
	      (0, _html2pdf2.default)(element, opt);
	    }
	  }
	};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ratingPadrao = function ratingPadrao() {
	  return {
	    idProposta: 0,
	    tudoPreenchido: 0,
	    dirigentes: [],
	    classificacao: {
	      nota: ''
	    },
	    ratingCalculado: {
	      CD: 0,
	      RFP: 0,
	      IS: 0,
	      PD: 0,
	      HIS1: 0,
	      HIS2: 0,
	
	      OC2: 0,
	      OC3: 0,
	
	      formula: 'R = (3,5 * CD) + (3,5 * RFP) + (IS) + (1,5 * PD) + (2,5 * HIS 1) + (2,5 * HIS 2) + (3,5 * OC 1) + (2 * OC 2)',
	      total: 0
	    },
	    consultas: {
	      serasa: {},
	      certidoes: {
	        Cepim: null,
	        dataCepim: null,
	        CND: null,
	        dataCND: null,
	        CRF: null,
	        dataCRF: null,
	        CNDT: null,
	        dataCNDT: null
	      },
	      scpc: {},
	      cadin: {
	        entidade: null,
	        dataEntidade: null,
	        dirigentes: null,
	        dataDirigentes: null,
	        coobrigacao: null,
	        dataCoobrigacao: null
	      },
	      totalGeral: 0,
	      PEP: 0
	    },
	    ocorrencias: {
	      entidade: {
	        tipo2: null,
	        tipo3: null,
	        tipo4: null
	      },
	      projetosExecutando: {
	        qtde: null,
	        tipo2: null,
	        tipo3: null,
	        tipo4: null,
	        qtdeTipo3: null,
	        percTipo3: null
	      },
	      projetosEncerrados: {
	        qtde: null,
	        tipo3: null,
	        tipo4: null,
	        qtdeTipo3: null,
	        percTipo3: null
	      }
	    },
	    experiencia: {
	      investimentoAte3Anos: 0,
	      participantesAte3Anos: 0,
	      qtdeProjeto: 0
	    }
	  };
	};
	
	exports.default = {
	  name: 'relatorio-rating',
	  components: {
	    Dirigentes: _dirigentes2.default
	  },
	  data: function data() {
	    return {
	      somenteLeitura: false,
	      temDataErrada: false,
	      propostaCarregada: false,
	      propostaFalhou: false,
	      dadosGeraisCarregados: false,
	      dadosGeraisFalhou: false,
	      avisoCadastroExibido: false,
	      idEntidade: 0,
	      calculando: true,
	      dadosGerais: {
	        entidade: {
	          dirigentes: []
	        }
	      },
	      proposta: {},
	      rating: ratingPadrao(),
	      analise: {},
	      ratingCarregado: null,
	      classificacaoRating: [{ 'nota': 'A', 'de': 90, 'para': 100 }, { 'nota': 'B', 'de': 70.1, 'para': 89.9 }, { 'nota': 'C', 'de': 55.1, 'para': 70 }, { 'nota': 'D', 'de': 40.1, 'para': 55 }, { 'nota': 'E', 'de': 0, 'para': 40 }]
	    };
	  },
	
	  props: ['propsAnalise'],
	  watch: {
	    propsAnalise: function propsAnalise() {
	      this.analise = this.propsAnalise;
	    }
	  },
	  computed: {
	    pendenciasCadastro: function pendenciasCadastro() {
	      var obrigatorias = [];
	      var opcionais = [];
	
	      if (!this.dadosGeraisCarregados || !this.propostaCarregada) {
	        return { obrigatorias: obrigatorias, opcionais: opcionais, total: 0 };
	      }
	
	      if (this.dadosGeraisFalhou) {
	        obrigatorias.push({
	          titulo: this.$route.query.entidade ? 'Entidade ' + this.$route.query.entidade + ' não localizada' : 'Entidade não informada na URL',
	          efeito: 'os dados cadastrais não foram carregados; o rating exibido não considera entidade, dirigentes nem histórico de projetos'
	        });
	      }
	      if (this.propostaFalhou) {
	        obrigatorias.push({
	          titulo: 'Proposta ' + this.$route.params.id + ' não carregada',
	          efeito: 'sem a proposta não há rating gravado nem ocorrências; a nota exibida não vale'
	        });
	      }
	      if (this.dadosGeraisFalhou || this.propostaFalhou) {
	        return { obrigatorias: obrigatorias, opcionais: opcionais, total: obrigatorias.length };
	      }
	
	      var entidade = _.get(this.dadosGerais, 'entidade', {});
	      var dirigentesAtivos = _.filter(_.get(entidade, 'dirigentes', []), function (dirigente) {
	        return Number(dirigente.bt_ativo) === 1;
	      });
	
	      if (_.isEmpty(entidade.ds_cnpj)) {
	        obrigatorias.push({
	          titulo: 'CNPJ da entidade',
	          efeito: 'é a chave de busca dos projetos no ERP; sem ele IS, PD, HIS 2, OC 1 e OC 2 ficam zerados'
	        });
	      }
	      if (_.isEmpty('' + _.get(entidade, 'nr_codigo_forn_erp', ''))) {
	        obrigatorias.push({
	          titulo: 'Código de fornecedor no ERP',
	          efeito: 'entidade não localizada no ERP; o histórico de projetos não é recuperado'
	        });
	      }
	      if (!(0, _moment2.default)(entidade.dt_data_expedicao_cnpj).isValid()) {
	        obrigatorias.push({
	          titulo: 'Data de expedição do CNPJ',
	          efeito: 'é o tempo de abertura da entidade; sem ela HIS 1 (peso 2,5) fica zerado'
	        });
	      }
	      if (dirigentesAtivos.length === 0) {
	        obrigatorias.push({
	          titulo: 'Nenhum dirigente ativo cadastrado',
	          efeito: 'SERASA, SCPC, CADIN e PEP de dirigentes não podem ser consultados; CD (peso 3,5) e RFP (peso 3,5) ficam comprometidos'
	        });
	      }
	      var semCpf = _.filter(dirigentesAtivos, function (dirigente) {
	        return _.isEmpty(dirigente.ds_cpf);
	      });
	      if (semCpf.length > 0) {
	        obrigatorias.push({
	          titulo: 'CPF de dirigente: ' + this.listaNomes(semCpf),
	          efeito: 'sem CPF não há como consultar SERASA, SCPC, CADIN e PEP do dirigente'
	        });
	      }
	
	      var semMandato = _.filter(dirigentesAtivos, function (dirigente) {
	        return !(0, _moment2.default)(dirigente.dt_inicio_mandato).isValid() || !(0, _moment2.default)(dirigente.dt_fim_mandato).isValid();
	      });
	      if (semMandato.length > 0) {
	        opcionais.push({
	          titulo: 'Mandato de dirigente: ' + this.listaNomes(semMandato),
	          efeito: 'não entra no cálculo, mas o relatório impresso sai com o mandato em branco'
	        });
	      }
	      var semCargo = _.filter(dirigentesAtivos, function (dirigente) {
	        return _.isEmpty(_.get(dirigente, 'cargo.ds_descricao'));
	      });
	      if (semCargo.length > 0) {
	        opcionais.push({
	          titulo: 'Cargo de dirigente: ' + this.listaNomes(semCargo),
	          efeito: 'não entra no cálculo, apenas identifica o dirigente no relatório'
	        });
	      }
	      if (_.isEmpty(entidade.ds_nome)) {
	        opcionais.push({
	          titulo: 'Nome da entidade',
	          efeito: 'não entra no cálculo, mas o relatório sai sem identificação do convenente'
	        });
	      }
	      return { obrigatorias: obrigatorias, opcionais: opcionais, total: obrigatorias.length + opcionais.length };
	    },
	    cadinDirigente: function cadinDirigente() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var dirigentesCadin;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dirigentesCadin = _.filter(_this.rating.dirigentes, function (o) {
	                  return _.has(o, 'cadin') && o.cadin !== 0;
	                });
	
	                _this.rating.consultas.cadin.dirigentes = dirigentesCadin.length > 0 ? '9999-12-31' : 0;
	                _context.next = 4;
	                return _this.totalSCPSSerasa();
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    totalSerasaDirigentes: function totalSerasaDirigentes() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var dirigentesSerasa;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                dirigentesSerasa = _.sumBy(_this2.rating.dirigentes, 'serasa') || 0;
	
	                _this2.rating.consultas.serasa.dirigentes = dirigentesSerasa;
	                _context2.next = 4;
	                return _this2.totalSCPSSerasa();
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    totalSCPCDirigentes: function totalSCPCDirigentes() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var dirigentesSCPC;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                dirigentesSCPC = _.sumBy(_this3.rating.dirigentes, 'scpc') || 0;
	
	                _this3.rating.consultas.scpc.dirigentes = dirigentesSCPC;
	                _context3.next = 4;
	                return _this3.totalSCPSSerasa();
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    }
	  },
	  mounted: function mounted() {
	    this.consultaEntidade();
	    var bc = new BroadcastChannel('propostas');
	    var vm = this;
	    bc.onmessage = function (e) {
	      var mensagem = e.data;
	      if (mensagem.acao === 'notificarSalvamento' && '' + mensagem.id === '' + vm.$route.params.id) {
	        vm.calculando = false;
	      }
	    };
	  },
	  created: function created() {
	    var _this4 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this4.rating.idProposta = _this4.$route.params.id;
	              _this4.calculando = true;
	              _context4.next = 4;
	              return _this4.buscaProposta();
	
	            case 4:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this4);
	    }))();
	  },
	
	  methods: {
	    closewindow: function closewindow() {
	      close();
	    },
	    totalSCPSSerasa: function totalSCPSSerasa() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this5.rating.consultas.totalGeral = _this5.rating.consultas.serasa.entidade + _this5.rating.consultas.serasa.dirigentes + _this5.rating.consultas.serasa.coobrigacao + _this5.rating.consultas.scpc.entidade + _this5.rating.consultas.scpc.dirigentes + _this5.rating.consultas.scpc.coobrigacao;
	                _context5.next = 3;
	                return _this5.calcularRating();
	
	              case 3:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this5);
	      }))();
	    },
	    salvarRating: function salvarRating() {
	      var _this6 = this;
	
	      this.calculando = true;
	      axiosLaravel.post('rating/salvar/', { 'rating': this.rating }).then(function (response) {
	        _this6.salvar();
	        _this6.calculando = false;
	        _this6.$snotify.success('Rating salvo');
	      }).catch(function (error) {
	        _this6.calculando = false;
	        _this6.$root.trataErro(error);
	      });
	    },
	    listaNomes: function listaNomes(dirigentes) {
	      return _.map(dirigentes, function (dirigente) {
	        return _.get(dirigente, 'ds_nome') || 'sem nome';
	      }).join(', ');
	    },
	    avisaCadastroIncompleto: function avisaCadastroIncompleto() {
	      if (this.avisoCadastroExibido || !this.propostaCarregada || !this.dadosGeraisCarregados) {
	        return;
	      }
	      if (this.pendenciasCadastro.total > 0) {
	        this.avisoCadastroExibido = true;
	        this.$modal.show('avisoCadastro');
	      }
	    },
	    normalizaRating: function normalizaRating(carregado) {
	      return _.defaultsDeep(_.cloneDeep(carregado), ratingPadrao());
	    },
	    carregaRating: function carregaRating() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return axiosLaravel.post('rating/carregar/', { 'idProposta': _this7.$route.params.id }).then(function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(response) {
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            _this7.ratingCarregado = response.data;
	                            if (!_.isNull(_this7.ratingCarregado) && _this7.ratingCarregado !== '') {
	                              if (_.has(_this7.ratingCarregado, 'classificacao')) {
	                                _this7.rating = _this7.normalizaRating(_this7.ratingCarregado);
	                              }
	                            } else {
	                              if (!_.has(_this7.proposta, 'rating') || !_.has(_this7.proposta.rating, 'ratingCalculado')) {
	                                _this7.proposta.rating = _this7.rating;
	                              } else {
	                                if (_.has(_this7.proposta, 'rating') && _.has(_this7.proposta.rating, 'ratingCalculado') && _.get(_this7.proposta, 'rating.classificacao.nota', '') !== '') {
	                                  _this7.rating = _this7.normalizaRating(_this7.proposta.rating);
	                                }
	                              }
	                            }
	                            _this7.$forceUpdate();
	
	                          case 3:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this7);
	                  }));
	
	                  return function (_x) {
	                    return _ref.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this7.calculando = false;
	                  _this7.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this7);
	      }))();
	    },
	    entidadeOcorrenciaTipo2: function entidadeOcorrenciaTipo2() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this8.rating.ocorrencias.entidade.tipo2 = null;
	                _context8.next = 3;
	                return _this8.buscaOcorrencias('entidade', { 'id_entidade': _this8.idEntidade, 'tipo': 2, 'situacao_ocorrencia': 'vigentes' });
	
	              case 3:
	                _this8.rating.ocorrencias.entidade.tipo2 = _context8.sent;
	
	              case 4:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this8);
	      }))();
	    },
	    entidadeOcorrenciaTipo3: function entidadeOcorrenciaTipo3() {
	      var _this9 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _this9.rating.ocorrencias.entidade.tipo3 = null;
	                _context9.next = 3;
	                return _this9.buscaOcorrencias('entidade', { 'id_entidade': _this9.idEntidade, 'tipo': 3, 'situacao_ocorrencia': 'vigentes' });
	
	              case 3:
	                _this9.rating.ocorrencias.entidade.tipo3 = _context9.sent;
	
	              case 4:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this9);
	      }))();
	    },
	    entidadeOcorrenciaTipo4: function entidadeOcorrenciaTipo4() {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _this10.rating.ocorrencias.entidade.tipo4 = null;
	                _context10.next = 3;
	                return _this10.buscaOcorrencias('entidade', { 'id_entidade': _this10.idEntidade, 'tipo': 4, 'situacao_ocorrencia': 'vigentes' });
	
	              case 3:
	                _this10.rating.ocorrencias.entidade.tipo4 = _context10.sent;
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this10);
	      }))();
	    },
	    projetosExecutandoOcorrenciaTipo2: function projetosExecutandoOcorrenciaTipo2() {
	      var _this11 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _this11.rating.ocorrencias.projetosExecutando.tipo2 = null;
	                _context11.next = 3;
	                return _this11.buscaOcorrencias('projeto', { 'id_entidade': _this11.idEntidade, 'tipo': 2, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'executando', 'dias': 1095 });
	
	              case 3:
	                _this11.rating.ocorrencias.projetosExecutando.tipo2 = _context11.sent;
	
	              case 4:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this11);
	      }))();
	    },
	    projetosExecutandoOcorrenciaTipo3: function projetosExecutandoOcorrenciaTipo3() {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _this12.rating.ocorrencias.projetosExecutando.tipo3 = null;
	                _context12.next = 3;
	                return _this12.buscaOcorrencias('projeto', { 'id_entidade': _this12.idEntidade, 'tipo': 3, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'executando', 'dias': 1095 });
	
	              case 3:
	                _this12.rating.ocorrencias.projetosExecutando.tipo3 = _context12.sent;
	
	              case 4:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this12);
	      }))();
	    },
	    projetosExecutandoOcorrenciaTipo4: function projetosExecutandoOcorrenciaTipo4() {
	      var _this13 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _this13.rating.ocorrencias.projetosExecutando.tipo4 = null;
	                _context13.next = 3;
	                return _this13.buscaOcorrencias('projeto', { 'id_entidade': _this13.idEntidade, 'tipo': 4, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'executando', 'dias': 1095 });
	
	              case 3:
	                _this13.rating.ocorrencias.projetosExecutando.tipo4 = _context13.sent;
	
	              case 4:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this13);
	      }))();
	    },
	    projetosEncerradosOcorrenciaTipo2: function projetosEncerradosOcorrenciaTipo2() {
	      var _this14 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _this14.rating.ocorrencias.projetosEncerrados.tipo2 = null;
	                _context14.next = 3;
	                return _this14.buscaOcorrencias('projeto', { 'id_entidade': _this14.idEntidade, 'tipo': 2, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'encerrado', 'dias': 1095 });
	
	              case 3:
	                _this14.rating.ocorrencias.projetosEncerrados.tipo2 = _context14.sent;
	
	              case 4:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this14);
	      }))();
	    },
	    projetosEncerradosOcorrenciaTipo3: function projetosEncerradosOcorrenciaTipo3() {
	      var _this15 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                _this15.rating.ocorrencias.projetosEncerrados.tipo3 = null;
	                _context15.next = 3;
	                return _this15.buscaOcorrencias('projeto', { 'id_entidade': _this15.idEntidade, 'tipo': 3, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'encerrado', 'dias': 1095 });
	
	              case 3:
	                _this15.rating.ocorrencias.projetosEncerrados.tipo3 = _context15.sent;
	
	              case 4:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this15);
	      }))();
	    },
	    projetosEncerradosOcorrenciaTipo4: function projetosEncerradosOcorrenciaTipo4() {
	      var _this16 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16() {
	        return _regenerator2.default.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                _this16.rating.ocorrencias.projetosEncerrados.tipo4 = null;
	                _context16.next = 3;
	                return _this16.buscaOcorrencias('projeto', { 'id_entidade': _this16.idEntidade, 'tipo': 4, 'situacao_ocorrencia': 'vigentes', 'situacao_projeto': 'encerrado', 'dias': 1095 });
	
	              case 3:
	                _this16.rating.ocorrencias.projetosEncerrados.tipo4 = _context16.sent;
	
	              case 4:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this16);
	      }))();
	    },
	    buscaOcorrencias: function buscaOcorrencias(origem, consulta) {
	      var _this17 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17() {
	        var resultado;
	        return _regenerator2.default.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                resultado = [];
	
	                origem = origem === 'projeto' ? 'consulta/ocorrencias/projeto/' : 'consulta/ocorrencias/entidade/';
	                _context17.next = 4;
	                return axiosLaravel.post(origem, consulta).then(function (response) {
	                  resultado = response.data;
	                }).catch(function (error) {
	                  _this17.$root.trataErro(error);
	                });
	
	              case 4:
	                return _context17.abrupt('return', resultado);
	
	              case 5:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this17);
	      }))();
	    },
	    atualizarTodasOcorrencias: function atualizarTodasOcorrencias() {
	      var _this18 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
	        return _regenerator2.default.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                _context18.next = 2;
	                return _this18.entidadeOcorrenciaTipo2();
	
	              case 2:
	                _context18.next = 4;
	                return _this18.entidadeOcorrenciaTipo3();
	
	              case 4:
	                _context18.next = 6;
	                return _this18.entidadeOcorrenciaTipo4();
	
	              case 6:
	                _context18.next = 8;
	                return _this18.projetosExecutandoOcorrenciaTipo2();
	
	              case 8:
	                _context18.next = 10;
	                return _this18.projetosExecutandoOcorrenciaTipo3();
	
	              case 10:
	                _context18.next = 12;
	                return _this18.projetosExecutandoOcorrenciaTipo4();
	
	              case 12:
	                _context18.next = 14;
	                return _this18.projetosEncerradosOcorrenciaTipo3();
	
	              case 14:
	                _context18.next = 16;
	                return _this18.projetosEncerradosOcorrenciaTipo4();
	
	              case 16:
	                _context18.next = 18;
	                return _this18.calcularRating();
	
	              case 18:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this18);
	      }))();
	    },
	    buscaProposta: function buscaProposta() {
	      var _this19 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20() {
	        return _regenerator2.default.wrap(function _callee20$(_context20) {
	          while (1) {
	            switch (_context20.prev = _context20.next) {
	              case 0:
	                _this19.$aguarde('Carregando dados do Rating. Por favor, aguarde...');
	                _context20.next = 3;
	                return axiosLaravel.get('propostas/' + _this19.$route.params.id).then(function () {
	                  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19(response) {
	                    return _regenerator2.default.wrap(function _callee19$(_context19) {
	                      while (1) {
	                        switch (_context19.prev = _context19.next) {
	                          case 0:
	                            _this19.proposta = response.data;
	                            _this19.idEntidade = _.get(_this19.proposta, 'entidade.id', 0);
	                            _context19.next = 4;
	                            return _this19.carregaRating();
	
	                          case 4:
	                            if (!(_this19.somenteLeitura === false)) {
	                              _context19.next = 8;
	                              break;
	                            }
	
	                            _context19.next = 7;
	                            return _this19.atualizarTodasOcorrencias();
	
	                          case 7:
	                            if (_.has(_this19.proposta, 'ds_situacao_erp') && !_.isNull(_this19.proposta.ds_situacao_erp) && !_.includes(['ANA', 'DEF', 'OPE'], _this19.proposta.ds_situacao_erp) || _this19.proposta.ds_fase === 'DEFERIMENTO' || _this19.proposta.ds_fase === 'APROVACAO_PROJETO') {
	                              _this19.somenteLeitura = true;
	                            } else {
	                              _this19.somenteLeitura = false;
	                            }
	
	                          case 8:
	                            _this19.$snotify.clear();
	
	                            _this19.$forceUpdate();
	                            _this19.propostaCarregada = true;
	                            _this19.atualizarListaDirigentes();
	                            _this19.avisaCadastroIncompleto();
	
	                          case 13:
	                          case 'end':
	                            return _context19.stop();
	                        }
	                      }
	                    }, _callee19, _this19);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this19.$snotify.clear();
	                  _this19.calculando = false;
	                  _this19.propostaCarregada = true;
	                  _this19.propostaFalhou = true;
	                  _this19.avisaCadastroIncompleto();
	                  _this19.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context20.stop();
	            }
	          }
	        }, _callee20, _this19);
	      }))();
	    },
	    consultaEntidade: function consultaEntidade() {
	      var _this20 = this;
	
	      axiosLaravel.post('consulta/geral/entidade/', { 'id': this.$route.query.entidade, 'tipo': 'entidade', 'dias': 1095 }).then(function (response) {
	        _this20.dadosGerais = _.defaultsDeep(response.data, { entidade: { dirigentes: [] }, projetos: [] });
	        _this20.$forceUpdate();
	
	        var dataAbertura = (0, _moment2.default)(_this20.dadosGerais.entidade.dt_data_expedicao_cnpj);
	        _this20.dadosGerais.entidade['anosAbertura'] = dataAbertura.isValid() ? (0, _moment2.default)().diff(dataAbertura, 'years', true) : null;
	
	        _this20.rating.experiencia.investimentoAte3Anos = _.sumBy(_this20.dadosGerais.projetos, function (o) {
	          return parseFloat(o.investimento);
	        });
	        _this20.rating.experiencia.participantesAte3Anos = _.sumBy(_this20.dadosGerais.projetos, function (o) {
	          return o.participantes;
	        });
	        _this20.rating.experiencia.qtdeProjeto = _this20.dadosGerais.projetos.length;
	        _this20.calcularRating();
	        _this20.dadosGeraisCarregados = true;
	        _this20.atualizarListaDirigentes();
	        _this20.avisaCadastroIncompleto();
	      }).catch(function (error) {
	        _this20.calculando = false;
	        _this20.dadosGeraisCarregados = true;
	        _this20.dadosGeraisFalhou = true;
	        _this20.avisaCadastroIncompleto();
	        _this20.$root.trataErro(error);
	      });
	    },
	    calcularRating: function calcularRating() {
	      this.calculando = true;
	      var vm = this;
	      this.rating.ratingCalculado.CD = this.regua1();
	      this.rating.ratingCalculado.RFP = this.regua2();
	      this.rating.ratingCalculado.IS = this.regua3(vm);
	      this.rating.ratingCalculado.PD = this.regua4(vm);
	      this.rating.ratingCalculado.HIS1 = this.regua5(vm);
	      this.rating.ratingCalculado.HIS2 = this.regua6(vm);
	
	      this.rating.ratingCalculado.OC2 = this.regua8();
	      this.rating.ratingCalculado.OC3 = this.regua9();
	
	      this.rating.ratingCalculado.total = 3.5 * this.rating.ratingCalculado.CD + 3.5 * this.rating.ratingCalculado.RFP + this.rating.ratingCalculado.IS + 1.5 * this.rating.ratingCalculado.PD + 2.5 * this.rating.ratingCalculado.HIS1 + 2.5 * this.rating.ratingCalculado.HIS2 + 3.5 * this.rating.ratingCalculado.OC2 + 2 * this.rating.ratingCalculado.OC3;
	
	      var nota = _.find(this.classificacaoRating, function (o) {
	        return o.de <= vm.rating.ratingCalculado.total && vm.rating.ratingCalculado.total <= o.para;
	      });
	
	      if (!_.isUndefined(nota)) {
	        this.rating.classificacao = nota;
	      }
	      this.calculando = false;
	      this.tudoPreenchido = _.sumBy(_.map(vm.rating.consultas.certidoes), function (certidao) {
	        return _.isNull(certidao) || _.isEmpty(certidao) ? 1 : 0;
	      }) + _.sumBy(_.map(vm.rating.consultas.cadin), function (cadin) {
	        return _.isNull(cadin) || _.isEmpty(cadin) ? 1 : 0;
	      });
	      this.$forceUpdate();
	    },
	    vigente: function vigente(data) {
	      return '' + data === '0';
	    },
	    regua1: function regua1() {
	      if (!this.vigente(this.rating.consultas.certidoes.Cepim)) {
	        return 0;
	      } else {
	        var totalSerasaSCPCEntidade = this.rating.consultas.serasa.entidade + this.rating.consultas.scpc.entidade;
	        var totalSerasaSCPCDirigentes = this.rating.consultas.serasa.dirigentes + this.rating.consultas.serasa.coobrigacao + this.rating.consultas.scpc.dirigentes + this.rating.consultas.scpc.coobrigacao;
	
	        if (totalSerasaSCPCDirigentes > 1000.01 && totalSerasaSCPCEntidade === 0) {
	          return 2;
	        }
	        if (totalSerasaSCPCDirigentes === 0 && totalSerasaSCPCEntidade === 0) {
	          return 5;
	        }
	        if (totalSerasaSCPCDirigentes + totalSerasaSCPCEntidade > 1000.01) {
	          return 1;
	        }
	        if (totalSerasaSCPCDirigentes >= 0 && totalSerasaSCPCEntidade >= 0 && totalSerasaSCPCDirigentes + totalSerasaSCPCEntidade > 500) {
	          return 3;
	        }
	        if (totalSerasaSCPCDirigentes >= 0 && totalSerasaSCPCEntidade >= 0 && totalSerasaSCPCDirigentes + totalSerasaSCPCEntidade <= 500) {
	          return 4;
	        }
	      }
	    },
	    regua2: function regua2() {
	      if (!this.vigente(this.rating.consultas.cadin.entidade) && !this.vigente(this.rating.consultas.cadin.dirigentes) && !this.vigente(this.rating.consultas.cadin.coobrigacao) && (!this.vigente(this.rating.consultas.certidoes.CND) || !this.vigente(this.rating.consultas.certidoes.CNDT))) {
	        return 0;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && (!this.vigente(this.rating.consultas.cadin.dirigentes) || !this.vigente(this.rating.consultas.cadin.coobrigacao)) && this.vigente(this.rating.consultas.certidoes.CND) && (!this.vigente(this.rating.consultas.certidoes.CRF) || !this.vigente(this.rating.consultas.certidoes.CNDT))) {
	        return 1;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && this.vigente(this.rating.consultas.cadin.dirigentes) && this.vigente(this.rating.consultas.cadin.coobrigacao) && this.vigente(this.rating.consultas.certidoes.CND) && !this.vigente(this.rating.consultas.certidoes.CRF) && !this.vigente(this.rating.consultas.certidoes.CNDT)) {
	        return 2;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && this.vigente(this.rating.consultas.cadin.dirigentes) && this.vigente(this.rating.consultas.cadin.coobrigacao) && this.vigente(this.rating.consultas.certidoes.CND) && this.XOR(this.vigente(this.rating.consultas.certidoes.CRF), this.vigente(this.rating.consultas.certidoes.CNDT))) {
	        return 3;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && (!this.vigente(this.rating.consultas.cadin.dirigentes) || !this.vigente(this.rating.consultas.cadin.coobrigacao)) && this.vigente(this.rating.consultas.certidoes.CND) && this.vigente(this.rating.consultas.certidoes.CRF) && this.vigente(this.rating.consultas.certidoes.CNDT)) {
	        return 4;
	      }
	      if (this.vigente(this.rating.consultas.cadin.entidade) && this.vigente(this.rating.consultas.cadin.dirigentes) && this.vigente(this.rating.consultas.cadin.coobrigacao) && this.vigente(this.rating.consultas.certidoes.CND) && this.vigente(this.rating.consultas.certidoes.CRF) && this.vigente(this.rating.consultas.certidoes.CNDT)) {
	        return 5;
	      }
	      return 0;
	    },
	    notaPorFaixa: function notaPorFaixa(faixas, valor) {
	      var numero = _.toNumber(valor);
	      if (!_.isFinite(numero)) {
	        return 0;
	      }
	      var faixa = _.find(faixas, function (o) {
	        return o.valor >= numero;
	      });
	      return _.isUndefined(faixa) ? _.last(faixas).nota : faixa.nota;
	    },
	    regua3: function regua3(vm) {
	      var regua3 = [{ 'nota': 0, 'valor': 0 }, { 'nota': 1, 'valor': 70000 }, { 'nota': 2, 'valor': 100000 }, { 'nota': 3, 'valor': 200000 }, { 'nota': 4, 'valor': 300000 }, { 'nota': 5, 'valor': 999999999 }];
	      return this.notaPorFaixa(regua3, vm.rating.experiencia.investimentoAte3Anos);
	    },
	    regua4: function regua4(vm) {
	      var regua4 = [{ 'nota': 0, 'valor': 0 }, { 'nota': 1, 'valor': 50 }, { 'nota': 2, 'valor': 80 }, { 'nota': 3, 'valor': 100 }, { 'nota': 4, 'valor': 200 }, { 'nota': 5, 'valor': 999999999 }];
	      return this.notaPorFaixa(regua4, vm.rating.experiencia.participantesAte3Anos);
	    },
	    regua5: function regua5(vm) {
	      var regua5 = [{ 'nota': 1, 'valor': 2 }, { 'nota': 2, 'valor': 4 }, { 'nota': 3, 'valor': 6 }, { 'nota': 4, 'valor': 9 }, { 'nota': 5, 'valor': 999999999 }];
	      var anosAbertura = _.get(vm.dadosGerais, 'entidade.anosAbertura');
	      return _.isNil(anosAbertura) ? 0 : this.notaPorFaixa(regua5, _.floor(anosAbertura));
	    },
	    regua6: function regua6(vm) {
	      var regua6 = [{ 'nota': 0, 'valor': 0 }, { 'nota': 1, 'valor': 1 }, { 'nota': 2, 'valor': 2 }, { 'nota': 3, 'valor': 3 }, { 'nota': 4, 'valor': 4 }, { 'nota': 5, 'valor': 999999999 }];
	      return this.notaPorFaixa(regua6, vm.rating.experiencia.qtdeProjeto);
	    },
	    regua8: function regua8() {
	      this.rating.ocorrencias.projetosExecutando.qtde = _.filter(this.dadosGerais.projetos, ['situacao', 'executando']).length;
	      var projetos = _.map(this.dadosGerais.projetos, 'numero');
	      var ocorrenciasTipos3 = _.map(this.rating.ocorrencias.projetosExecutando.tipo3, 'numprj');
	      this.rating.ocorrencias.projetosExecutando.qtdeTipo3 = _.intersection(projetos, ocorrenciasTipos3).length;
	      this.rating.ocorrencias.projetosExecutando.percTipo3 = this.rating.ocorrencias.projetosExecutando.qtdeTipo3 / (this.rating.ocorrencias.projetosExecutando.qtde === 0 || this.ehNulo(this.rating.ocorrencias.projetosExecutando.qtde, true) ? 1 : this.rating.ocorrencias.projetosExecutando.qtde);
	
	      if (this.rating.ocorrencias.projetosExecutando.qtde === 0) {
	        return 3;
	      }
	      if (this.rating.ocorrencias.projetosExecutando.tipo2.length + this.rating.ocorrencias.projetosExecutando.tipo3.length + this.rating.ocorrencias.projetosExecutando.tipo4.length === 0) {
	        return 5;
	      }
	      if (this.rating.ocorrencias.projetosExecutando.tipo4.length > 0) {
	        return 0;
	      } else {
	        if (this.rating.ocorrencias.projetosExecutando.percTipo3 > 0.5) {
	          return 1;
	        } else {
	          return 3;
	        }
	      }
	    },
	    regua9: function regua9() {
	      this.rating.ocorrencias.projetosEncerrados.qtde = _.filter(this.dadosGerais.projetos, ['situacao', 'encerrado']).length;
	      var projetos = _.map(this.dadosGerais.projetos, 'numero');
	      var ocorrenciasTipos3 = _.map(this.rating.ocorrencias.projetosEncerrados.tipo3, 'numprj');
	      this.rating.ocorrencias.projetosEncerrados.qtdeTipo3 = _.intersection(projetos, ocorrenciasTipos3).length;
	      this.rating.ocorrencias.projetosEncerrados.percTipo3 = this.rating.ocorrencias.projetosEncerrados.qtdeTipo3 / (this.rating.ocorrencias.projetosEncerrados.qtde === 0 || this.ehNulo(this.rating.ocorrencias.projetosEncerrados.qtde, true) ? 1 : this.rating.ocorrencias.projetosEncerrados.qtde);
	
	      if (this.rating.ocorrencias.projetosEncerrados.qtde === 0) {
	        return 3;
	      }
	      if (this.rating.ocorrencias.projetosEncerrados.tipo3.length + this.rating.ocorrencias.projetosEncerrados.tipo4.length === 0) {
	        return 5;
	      }
	      if (this.rating.ocorrencias.projetosEncerrados.tipo4.length > 0) {
	        return 0;
	      } else {
	        if (this.rating.ocorrencias.projetosEncerrados.percTipo3 > 0.5) {
	          return 1;
	        } else {
	          return 3;
	        }
	      }
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    salvar: function salvar() {
	      this.$aguarde('Salvando proposta. Por favor, aguarde...');
	      this.calculando = true;
	      var bc = new BroadcastChannel('propostas');
	      console.log('Enviando rating para propostas');
	
	      bc.postMessage({ acao: 'set', objeto: 'proposta.rating', id: this.$route.params.id, valor: this.rating });
	      console.log('|--> set:', { acao: 'set', objeto: 'proposta.rating', id: this.$route.params.id, valor: this.rating });
	
	      bc.postMessage({ acao: 'salvarProposta', id: this.$route.params.id });
	      console.log('|--> salvando proposta:', { acao: 'salvarProposta', id: this.$route.params.id });
	      this.$snotify.clear();
	      this.$snotify.success('Rating atualizado com sucesso!');
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    },
	    XOR: function XOR(a, b) {
	      return (a || b) && !(a && b);
	    },
	    verificaData: function verificaData() {
	      var _this21 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21() {
	        return _regenerator2.default.wrap(function _callee21$(_context21) {
	          while (1) {
	            switch (_context21.prev = _context21.next) {
	              case 0:
	                _this21.temDataErrada = !_.isUndefined(_this21.errors.firstByRule('Cepim', 'dateeqpast')) || !_.isUndefined(_this21.errors.firstByRule('cadin_entidade', 'dateeqpast')) || !_.isUndefined(_this21.errors.firstByRule('cadin_dirigentes', 'dateeqpast')) || !_.isUndefined(_this21.errors.firstByRule('cadin_dirigentes_coobrigacao', 'dateeqpast'));
	
	              case 1:
	              case 'end':
	                return _context21.stop();
	            }
	          }
	        }, _callee21, _this21);
	      }))();
	    },
	    atualizarListaDirigentes: function atualizarListaDirigentes() {
	      var _this22 = this;
	
	      if (!this.propostaCarregada || !this.dadosGeraisCarregados || this.dadosGeraisFalhou) {
	        return;
	      }
	
	      var dirigentes = _.filter(this.dadosGerais.entidade.dirigentes, function (dirigente) {
	        return [true, 1, '1', 'true'].includes(dirigente.bt_ativo);
	      });
	      dirigentes.forEach(function (dirigente) {
	        _this22.rating.dirigentes.forEach(function (dirigenteRating) {
	          if (dirigente.id === dirigenteRating.id) {
	            dirigente['scpc'] = dirigenteRating.scpc;
	            dirigente['serasa'] = dirigenteRating.serasa;
	          }
	        });
	      });
	      this.rating.dirigentes = dirigentes;
	    }
	  }
	};

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'restricoes',
	  data: function data() {
	    return {
	      preAnalise: {
	        proposal: {}
	      }
	    };
	  },
	
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  props: ['propsPreAnalise'],
	  watch: {
	    propsPreAnalise: function propsPreAnalise() {
	      this.preAnalise = this.propsPreAnalise;
	      this.$forceUpdate();
	    }
	  }
	};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'solenizacao',
	  data: function data() {
	    return {
	      solenizacao: {},
	      eventosTabela: this.propsSolenizacao,
	      eventosDisponiveis: []
	    };
	  },
	
	  props: ['propsSolenizacao'],
	  watch: {
	    eventosTabela: function eventosTabela() {
	      this.$emit('solenizacaoAdicionada', this.eventosTabela);
	    },
	    propsSolenizacao: function propsSolenizacao() {
	      this.eventosTabela = this.propsSolenizacao;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    axios.get('proxy/project/solemnization').then(function (response) {
	      _this.eventosDisponiveis = response.data.value;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    addEvent: function addEvent(evento) {
	      var _this2 = this;
	
	      if ((0, _keys2.default)(evento).length > 0) {
	        this.eventosTabela.push(evento);
	        this.eventosDisponiveis = this.eventosDisponiveis.filter(function (item) {
	          return item.id !== _this2.solenizacao.id;
	        });
	        this.solenizacao = {};
	      } else {
	        this.$snotify.error('escolha um evento');
	      }
	    },
	    onDelete: function onDelete(evento, eventoIndex) {
	      this.eventosDisponiveis.push(evento);
	      this.eventosTabela.splice(eventoIndex, 1);
	    }
	  }
	};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(123);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'sumula',
	  data: function data() {
	    return {
	      id: null,
	      etapa: 'Solicitação',
	      quillOptions: {
	        theme: 'bubble'
	      },
	      historico: [],
	      dados: {
	        periodo: {
	          dt_assinatura_convenio: null,
	          nr_periodos: null,
	          periodo_vigencia: null,
	          dt_data_vigencia: null
	        }
	      },
	      loading: {
	        tela: false,
	        projeto: false,
	        ocorrencias: false,
	        motivosSolicitacao: false,
	        aditivo: {
	          lista: true,
	          conteudo: true
	        },
	        historicos: {
	          periodos: false
	        }
	      },
	      mostrar: {
	        periodo: false,
	        metas: false,
	        atividades: false,
	        extratoProjeto: false,
	        parcelasAdiantamento: false,
	        municipios: false,
	        sumula: true,
	        aditivo: false,
	        solicitacao: true,
	        historicos: {
	          periodos: false,
	          tarefas: false
	        }
	      },
	      justificativa: null,
	      ocorrencias: [],
	      tarefas: [],
	      ultimaTarefa: {},
	      anexos: [],
	      proposta: {},
	      propostaBackup: {},
	      atvSemMetas: [],
	      criarAtividade: false,
	      tabela: {
	        historicos: {
	          periodos: {
	            bordered: true,
	            fields: [{ key: 'id', label: 'ID', thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'acao', label: 'Momento', thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'periodo', label: 'Períodos', thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'termino_alterado', label: 'Término do projeto', thStyle: 'text-align: center; width: 15%', class: 'text-center' }]
	          }
	        }
	      },
	      numeroAtualizacao: 0,
	      projetoPeriodos: 0,
	      dataFinalExecucao: '',
	      chamado: [],
	      listaProjetos: {
	        validos: [],
	        demais: []
	      },
	      projeto: {},
	      desabilitarDatasFuturas: {
	        from: new Date() },
	      desabilitarDatasPassadas: {
	        to: new Date() },
	      municipiosUf: [],
	      ehProjetoEspecial: false,
	      tipoAlteracaoCronograma: null,
	      decisao: {
	        encaminhamento: 'ANALISE'
	      },
	      analiseTributaria: {},
	      layoutExtrato: 'classico',
	      extratoFiltrosSelecionados: this.$route.name === 'solicitacao-contrapartida' ? ['saldos'] : ['saldos', 'fundacao'],
	      adiantamentosFiltrosSelecionados: ['adiantamento_pendente'],
	      sumarioQtdeAlteracoes: {},
	      totais: {
	        projeto: {
	          fbb: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          parceiros: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          contrapartida: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          total: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          }
	        },
	        adiantamento: {
	          fbb: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          parceiros: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          total: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          }
	        }
	      },
	      restricaoParaInicializar: [],
	      restricaoParaConcluir: [],
	      solicitacao: {
	        instrumentosLidos: {
	          ok: false,
	          usuario: null,
	          data: null
	        },
	        justificativa: null,
	        anexos: [],
	        processos: [],
	        aditivo: {
	          modelo: {},
	          conteudo: ''
	        },
	        sumula: {
	          textoAnalise: null,
	          textoProposta: null,
	          textoContexto: null,
	          textoSituacaoProblema: null,
	          textoParecer: null,
	          questionario: [{ 'codigo': 'Q001', 'questao': 'Há concordância da convenente com a proposta de alteração quando de iniciativa da Fundação?', 'resposta': null }, { 'codigo': 'Q002', 'questao': 'Há alteração nos objetivos específicos, metas e indicadores previstos no projeto?', 'resposta': null }, { 'codigo': 'Q003', 'questao': 'Há impacto da alteração proposta no prazo de execução estabelecido?', 'resposta': null }, { 'codigo': 'Q004', 'questao': 'Há impacto da alteração proposta nos resultados esperados do projeto?', 'resposta': null }, { 'codigo': 'Q005', 'questao': 'Existem ocorrências restritivas para aprovação da alteração proposta, registrados no sistema informatizado da Fundação?', 'resposta': null }, { 'codigo': 'Q006', 'questao': 'Foram apresentados orçamentos ou há enquadramento dos valores orçados aos parâmetros operacionais estabelecidos pela Fundação? Em caso negativo, registre a(s) justificativa(s) para apoio superior ao previsto no campo "Análise".', 'resposta': null }, { 'codigo': 'Q009', 'questao': 'Há ajuste ou glosa realizados na proposta apresentada? Em caso afirmativo, registre a justificativa e itens alterados no campo "Análise".', 'resposta': null }, { 'codigo': 'Q010', 'questao': 'A alteração proposta demanda formalização de termo aditivo?', 'resposta': null }, { 'codigo': 'Q011', 'questao': 'Existem itens de despesas que não podem ser custeados, conforme as disposições gerais e as instruções específicas do SIC 13.3.7?', 'resposta': null }, { 'codigo': 'Q012', 'questao': 'As certidões estão válidas, quando previstas em instruções específicas do SIC 13.3.7?', 'resposta': null }, { 'codigo': 'Q013', 'questao': 'Consta autorização recebida do parceiro estratégico, conforme instruções específicas do SIC 13.3.7?', 'resposta': null }, { 'codigo': 'Q014', 'questao': 'Foram cumpridas outras exigências previstas em instruções específicas do SIC 13.3.7?', 'resposta': null }, { 'codigo': 'Q015', 'questao': 'Há compatibilidade da alteração proposta com os objetivos, as metas e as atividades do projeto?', 'resposta': null }],
	          parceriaEstrategica: null,
	          providencias: []
	        }
	      },
	      registrosAlteracoes: [],
	      listaMinutasAditivo: [],
	      ehVisualizacao: false,
	      permiteConcluir: false,
	      cronogramaAlteracoes: [],
	      validacao: {},
	      tarefaNome: { 'ANALISE': 'Análise', 'AUTORIZACAO': 'Autorização', 'REVISAO': 'Revisão', 'SOLICITACAO': 'Solicitação' },
	      descricaoProcesso: { 'PAGAMENTO': 'Pagamento', 'PRESTACAO_DE_CONTAS': 'Prestação de Contas', 'CONTRAPARTIDA': 'Contrapartida', 'RESSARCIMENTO': 'Ressarcimento' },
	      listaRelatoriosSapiens: [{ 'codigo': 248, 'descricao': '248 - Monitoramento Administrativo' }, { 'codigo': 300, 'descricao': '300 - Extrato de Projetos por Beneficiária' }],
	      relatorioSapiensSelecionado: null,
	      poderes: {
	        codigo: '',
	        mensagem: []
	      },
	      motivosSolicitacao: [],
	      motivosDevolucao: []
	    };
	  },
	
	  props: ['idProcesso', 'propsProposta', 'propsSolicitacao'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    dataFinalVigencia: function dataFinalVigencia() {
	      if (this.propostaBackup.dt_assinatura_convenio) {
	        this.propostaBackup.dt_data_vigencia = (0, _moment2.default)(this.propostaBackup.dt_assinatura_convenio).add(parseInt(this.propostaBackup.periodo_vigencia), 'M').format('YYYY-MM-DD');
	      } else {
	        if (this.propostaBackup.dt_data_inicial) {
	          this.propostaBackup.dt_data_vigencia = (0, _moment2.default)(this.propostaBackup.dt_data_inicial).add(parseInt(this.propostaBackup.periodo_vigencia), 'M').format('YYYY-MM-DD');
	        }
	      }
	      return this.proposta.dt_data_vigencia;
	    },
	    dataFinal: function dataFinal() {
	      if (this.proposta.dt_assinatura_convenio) {
	        this.dataFinalExecucao = (0, _moment2.default)(this.propostaBackup.dt_assinatura_convenio).add(this.propostaBackup.nr_periodos, 'M').format('DD/MM/YYYY');
	        return this.dataFinalExecucao;
	      }
	    }
	  }),
	  watch: {
	    projeto: function projeto() {
	      if (_.has(this.projeto, 'ds_codigo_projeto_erp') && !_.isEmpty(this.projeto.ds_codigo_projeto_erp)) {
	        this.carregarDados({ 'numero': this.projeto.ds_codigo_projeto_erp });
	      }
	    },
	    idProcesso: function idProcesso() {
	      this.id = this.idProcesso;
	    },
	    propsProposta: function propsProposta() {
	      if (_.isNil(this.idProcesso)) {
	        this.proposta = this.propsProposta;
	      }
	    },
	    propsSolicitacao: function propsSolicitacao() {
	      if (_.isNil(this.idProcesso)) {
	        this.solicitacao = this.propsSolicitacao;
	      }
	    },
	    relatorioSapiensSelecionado: function relatorioSapiensSelecionado() {
	      this.emitir(this.relatorioSapiensSelecionado);
	    }
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    this.id = this.idProcesso;
	    if (_.isNil(this.idProcesso)) {
	      if (_.isNil(this.propsProposta) || _.isNil(this.propsSolicitacao)) {
	        this.$snotify.error('Não foi informado ID do processo nem dados da solicitação ou proposta');
	        this.$router.go(-1);
	      } else {
	        if (!_.isNil(this.propsProposta)) {
	          this.proposta = this.propsProposta;
	        }
	        if (!_.isNil(this.propsSolicitacao)) {
	          this.solicitacao = this.propsSolicitacao;
	        }
	      }
	    } else {
	      this.carregarDados({ 'id': this.id });
	    }
	  },
	
	  methods: {
	    carregarDados: function carregarDados(requisicao) {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('projeto/alteracoes', requisicao).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var proposta = response.data.retorno.projeto;
	          _this.propostaBackup = _.cloneDeep(proposta);
	          _this.projeto = _.find(_this.listaProjetos.validos, ['ds_codigo_projeto_erp', '' + proposta.ds_codigo_projeto_erp]);
	          var solicitacao = response.data.retorno.solicitacao;
	          if (!_.isEmpty(solicitacao)) {
	            _this.solicitacao = solicitacao.dados;
	            _this.id = solicitacao.processo.id;
	            _this.ehVisualizacao = _.includes(['FEITO', 'CANCELADO'], solicitacao.processo.situacao);
	            _this.tarefas = _.initial(solicitacao.tarefas);
	            _this.ultimaTarefa = _.last(solicitacao.tarefas);
	            _this.etapa = _this.tarefaNome[_this.ultimaTarefa['nome']];
	            _this.mostrar.solicitacao = !_.includes(['Autorização', 'Deliberação'], _this.etapa) || _this.ehVisualizacao;
	            var objetosRefProcesso = { 'ALTERACAO_METAS': 'metas', 'ALTERACAO_ATIVIDADES': 'atividades', 'ALTERACAO_PARCELAS_ADIANTAMENTO': 'adiantamentos', 'ALTERACAO_MUNICIPIOS': 'municipalizacao', 'ALTERACAO_PERIODO_PROJETO': '' };
	            _this.solicitacao.processos.forEach(function (processo) {
	              var alteracoes = _.get(processo, 'alteracao', []);
	              alteracoes.forEach(function (alteracao) {
	                var registroAlterado = proposta;
	                if (_.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], processo.nome)) {
	                  proposta.atividades.forEach(function (atividade) {
	                    registroAlterado = _.find(_.get(atividade, 'itens_orcamentos', []), ['id', alteracao.id]);
	                  });
	                } else if (processo.nome !== 'ALTERACAO_PERIODO_PROJETO') {
	                  registroAlterado = _.find(_.get(proposta, objetosRefProcesso[processo.nome], []), ['id', alteracao.id]);
	                }
	                _.forIn(alteracao, function (value, key, obj) {
	                  if (key !== 'id') {
	                    var valor = _.isNaN(_.toNumber(value[1])) ? value[1] : _.toNumber(value[1]);
	                    _.set(registroAlterado, [key], valor);
	                  }
	                });
	              });
	
	              var inclusoes = _.get(processo, 'inclusao', []);
	              var lista = _.get(proposta, [objetosRefProcesso[processo.nome]], []);
	              inclusoes.forEach(function (inclusao) {
	                if (_.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], processo.nome)) {
	                  lista = _.get(_.find(proposta.atividades, ['id', inclusao.atividade.id]), 'itens_orcamentos');
	                }
	                if (_.isArray(lista)) {
	                  lista.push(inclusao);
	                }
	              });
	            });
	            _this.calcularTotaisAlteracaoSumula();
	          }
	          _this.proposta = proposta;
	          var mesesVigencia = Math.round((0, _moment2.default)(_this.proposta.projetoSapiens.usu_datfimvig).diff((0, _moment2.default)(_this.proposta.dt_assinatura_convenio), 'months', true));
	          console.log('mesesVigencia', mesesVigencia);
	          _this.projetoPeriodos = _this.propostaBackup.nr_periodos;
	
	          if (_this.proposta.projetoSapiens.sitprj !== 'APR') {
	            _this.restricaoParaInicializar.push('Projeto tem ocorrência registrada e a solicitação pode ser indeferida caso a pendência não seja regularizada');
	          }
	
	          var alteracaoCronogramaRealizada = _.find(_.get(_this.solicitacao, 'processos', []), function (prc) {
	            return _.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome);
	          });
	
	          var tiposAlteracaoCronogramaPermitidos = alteracaoCronogramaRealizada ? [alteracaoCronogramaRealizada['nome']] : _.intersection(_.get(_this.proposta, 'opcoes.alteracoesPermitidas', []), ['remanejamento', 'suplementacao']);
	          _this.tipoAlteracaoCronograma = tiposAlteracaoCronogramaPermitidos.length === 1 ? _.toUpper(_.head(tiposAlteracaoCronogramaPermitidos)) : null;
	          _this.buscaCidades();
	          _this.$forceUpdate();
	          _this.buscaOcorrencias();
	          _this.loading.tela = false;
	        } else {
	          console.log('   erro');
	          _this.$snotify.error(response.data.mensagem);
	        }
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    itemExtrato: function itemExtrato(id) {
	      var item = null;
	      this.proposta.atividades.forEach(function (atividade) {
	        var itemLocalizado = _.find(_.get(atividade, 'itens_orcamentos', []), ['id', id]);
	        if (itemLocalizado) {
	          item = _.cloneDeep(itemLocalizado);
	        }
	      });
	      return item;
	    },
	    calcularTotaisAlteracaoSumula: function calcularTotaisAlteracaoSumula() {
	      var resumo = _.get(this.solicitacao, 'sumula.resumoAlteracoes');
	      if (!resumo) {
	        return;
	      }
	      var creditos = 0;
	      var debitos = 0;
	      _.get(this.solicitacao, 'processos', []).forEach(function (prc) {
	        if (!_.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)) {
	          return;
	        }
	        _.get(prc, 'alteracao', []).forEach(function (a) {
	          var delta = _.toNumber(_.get(a, 'valorAlteracao.1', 0));
	          if (delta > 0) {
	            creditos += delta;
	          }
	          if (delta < 0) {
	            debitos += Math.abs(delta);
	          }
	        });
	        _.get(prc, 'inclusao', []).forEach(function (i) {
	          var valor = _.toNumber(_.get(i, 'valorAlteracao', 0));
	          if (valor > 0) {
	            creditos += valor;
	          }
	          if (valor < 0) {
	            debitos += Math.abs(valor);
	          }
	        });
	      });
	      var valorRemanejado = debitos;
	      var valorTotalAlteracao = creditos;
	      var valorSuplementacao = valorTotalAlteracao - valorRemanejado;
	      this.$set(resumo, 'valorRemanejado', valorRemanejado);
	      this.$set(resumo, 'valorSuplementacao', valorSuplementacao);
	      this.$set(resumo, 'valorTotalAlteracao', valorTotalAlteracao);
	    },
	    imprimir: function imprimir() {
	      window.print();
	    },
	    buscaCidades: function buscaCidades() {
	      var _this2 = this;
	
	      var lista = _.uniq(_.map(this.proposta.municipalizacao, 'ds_cep'));
	      axiosLaravel.post('projeto/cidades', { 'referencia': 'CEP', 'lista': lista }).then(function (response) {
	        _this2.proposta.municipalizacao.forEach(function (municipio) {
	          var cidade = _.find(response.data, function (cid) {
	            return _.toNumber(municipio.ds_cep) >= _.toNumber(cid.nr_cep_inicio) && _.toNumber(municipio.ds_cep) <= _.toNumber(cid.nr_cep_final);
	          });
	          _.set(municipio, 'ds_uf', cidade.ds_uf);
	        });
	        if (!_this2.loading.tela && !_this2.propsSolicitacao) {
	          setTimeout(function () {
	            return _this2.imprimir();
	          }, 500);
	        }
	      }).catch(function (error) {
	        console.log('error cidades', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    emitir: function emitir(relatorio) {
	      var _this3 = this;
	
	      this.loading.tela = true;
	      var parametros = '<ECodEmp=1><ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '>';
	      if (relatorio === 222 || relatorio === 219) {
	        parametros += '<ESitPrj=ULT>';
	      } else if (relatorio === 248) {
	        parametros += '<ECodFor=>';
	      }
	      if (relatorio === 222) {
	        parametros += '<EMosDes=S>';
	      }
	      if (relatorio === 200 && _.has(this.analiseTributaria, 'nf') && '' + this.analiseTributaria.nf.SitNfc === '2') {
	        parametros = '<ECodFor=' + this.analiseTributaria.nf.CodFor + '><ENumNfc=' + this.analiseTributaria.nf.NumNfc + '><ECodSnf=' + this.analiseTributaria.nf.CodSnf + '><EForOrg=F><EPreCon=N>';
	      }
	      if (relatorio === 611) {
	        parametros = '<ECodFor=' + this.analiseTributaria.nf.CodFor + '><ENumTit="' + this.analiseTributaria.titulo.NumTit + '"><ETitBai=S>';
	      }
	      this.$snotify.clear();
	      var codigoRelatorio = (relatorio === 200 ? 'SRNF' : 'FJCF') + relatorio + '.GER';
	      if (relatorio === 611) codigoRelatorio = 'FPCP' + relatorio + '.GER';
	      this.$aguarde('Gerando relatório ' + relatorio + '. Por favor, aguarde...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': codigoRelatorio }, params: parametros }).then(function (response) {
	        _this3.relatorioSapiensSelecionado = null;
	        _this3.onDownload(response, relatorio, _this3);
	      }).catch(function (error) {
	        _this3.relatorioSapiensSelecionado = null;
	        _this3.$snotify.clear();
	        _this3.loading.tela = false;
	        _this3.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	
	      var tipoProcesso = '';
	      switch (vm.processo) {
	        case 'PAGAMENTO':
	          tipoProcesso = 'PG';
	          break;
	        case 'PRESTACAO_DE_CONTAS':
	          tipoProcesso = 'PC ' + this.proposta.ds_codigo_projeto_erp;
	          break;
	        case 'RESSARCIMENTO':
	          tipoProcesso = 'RE';
	          break;
	      }
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (relatorio !== 200) {
	        if (!ie) {
	          var blob = file;
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var _blob = file;
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	          _link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp;
	          _link.click();
	        }
	      } else {
	        if (!ie) {
	          var _blob2 = file;
	          var _link2 = document.createElement('a');
	          _link2.href = window.URL.createObjectURL(_blob2);
	          _link2.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + vm.id + ' ' + tipoProcesso;
	          document.body.appendChild(_link2);
	          _link2.click();
	          document.body.removeChild(_link2);
	        } else {
	          var _blob3 = file;
	          var _link3 = document.createElement('blob');
	          _link3.href = window.navigator.msSaveOrOpenBlob(_blob3, item.name);
	          _link3.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + vm.id + ' ' + tipoProcesso;
	          _link3.click();
	        }
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading.tela = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    buscaOcorrencias: function buscaOcorrencias() {
	      var _this4 = this;
	
	      this.loading.ocorrencias = true;
	      axiosLaravel.post('ocorrencia/busca', {
	        'informacao': 'SIMPLIFICADO',
	        'projeto': this.propostaBackup.ds_codigo_projeto_erp,
	        'nivel': [2, 3, 4],
	        'situacao': 'LIBERADO'
	      }).then(function (response) {
	        if (_.get(response.data, 'codigo', '') === 'OK') {
	          var lista = response.data.retorno || [];
	          _this4.ocorrencias = lista.filter(function (item) {
	            return item !== null && item !== undefined;
	          });
	        } else {
	          _this4.$snotify.error(response.data.mensagem);
	        }
	        _this4.$forceUpdate();
	        _this4.loading.ocorrencias = false;
	        console.log('ocorrencias', _this4.ocorrencias);
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    getTextoObservacao: function getTextoObservacao(item) {
	      if (!this.solicitacao || !this.solicitacao.processos) return '';
	      var lista = this.solicitacao.processos;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(lista), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var grupo = _step.value;
	
	          if (grupo.alteracao && Array.isArray(grupo.alteracao)) {
	            var achou = grupo.alteracao.find(function (a) {
	              return a.id === item.id && a.observacao;
	            });
	            if (achou) {
	              var valorAntigo = achou.observacao[0];
	              if (valorAntigo !== null && valorAntigo !== undefined && valorAntigo !== '') {
	                return valorAntigo;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return '';
	    },
	    getTextoObservacaoNova: function getTextoObservacaoNova(item) {
	      if (!this.solicitacao || !this.solicitacao.processos) return '';
	      var lista = this.solicitacao.processos;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(lista), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var grupo = _step2.value;
	
	          if (grupo.alteracao && Array.isArray(grupo.alteracao)) {
	            var achou = grupo.alteracao.find(function (a) {
	              return a.id === item.id && a.observacao;
	            });
	            if (achou) {
	              var valorNovo = achou.observacao[1];
	              if (valorNovo !== null && valorNovo !== undefined && valorNovo !== '') {
	                return valorNovo;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return '';
	    },
	    fecharModal: function fecharModal() {
	      if (this.$refs.alertaCancelamentoDialog) {
	        this.$refs.alertaCancelamentoDialog.close();
	      } else {
	        var dialog = document.getElementById('alertaCancelamentoDialog');
	        if (dialog) dialog.close();
	      }
	    }
	  }
	};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'tecnologiaSocial',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      paginaConsulta: 1,
	      tecnologiasCadastradas: [],
	      tecnologiasSociais: [],
	      cadastrando: false,
	      termoPesquisa: '',
	      totalRows: 0,
	      debounceTimer: null,
	      possuiTecnologiaSocial: '',
	      permiteEditar: true,
	      table: {
	        items: this.tecnologiasCadastradas,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'id', label: 'ID', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nome', label: 'Nome', sortable: true, thStyle: 'text-align: left', class: 'text-center' }, { key: 'url', label: 'Saiba Mais', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tsTable: {
	        items: this.tecnologiasSociais,
	        totalRows: 0,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        fields: [{ key: 'id', label: 'ID', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ano', label: 'Ano', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nome', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'url', label: 'Saiba Mais', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'tema', label: 'Tema', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      editar: false
	    };
	  },
	
	  props: ['proposta', 'fk_processo', 'telaProjeto', 'ehParceiroEstrategico'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    proposta: function proposta() {}
	  },
	  mounted: function mounted() {
	    this.consultaTecnologiasCadastradas();
	    this.permiteEditar = !this.telaProjeto;
	  },
	  methods: {
	    buscarTecnologiasSociais: function buscarTecnologiasSociais(carregarMais) {
	      var _this = this;
	
	      this.loading.show = true;
	      if (this.tecnologiasSociais.length > 0 && !carregarMais) {
	        this.tsTable.items = this.tecnologiasSociais;
	        this.tsTable.totalRows = this.tecnologiasSociais.length;
	        this.tsTable.currentPage = 1;
	        this.loading.show = false;
	        return;
	      }
	      this.loading.show = true;
	      var query = 'tecnologiasocial?page=' + this.paginaConsulta + '&perpage=100';
	      axiosLaravel.get(query).then(function (response) {
	        _this.tecnologiasSociais = response.data;
	        _this.tsTable.items = _this.tecnologiasSociais;
	        _this.tsTable.totalRows = _this.tecnologiasSociais.length;
	        _this.tsTable.currentPage = 1;
	        _this.loading.show = false;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loading.show = false;
	        _this.$forceUpdate();
	      });
	    },
	    filtrarTecnologias: function filtrarTecnologias() {
	      var _this2 = this;
	
	      this.loading.show = true;
	      var query = 'tecnologiasocial?page=1&perpage=100&search=' + this.termoPesquisa;
	      axiosLaravel.get(query).then(function (response) {
	        _this2.tecnologiasSociais = response.data;
	        _this2.tsTable.items = _this2.tecnologiasSociais;
	        _this2.tsTable.totalRows = _this2.tecnologiasSociais.length;
	        _this2.tsTable.currentPage = 1;
	        _this2.loading.show = false;
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.loading.show = false;
	        _this2.$forceUpdate();
	      });
	    },
	    ativarCadastro: function ativarCadastro() {
	      this.cadastrando = true;
	      this.buscarTecnologiasSociais(false);
	    },
	    carregarMais: function carregarMais() {
	      this.paginaConsulta += 1;
	      this.buscarTecnologiasSociais(true);
	    },
	    cancelar: function cancelar() {
	      this.paginaConsulta = 1;
	      this.tecnologiasSociais = [];
	      this.cadastrando = false;
	    },
	    debounceFiltro: function debounceFiltro() {
	      var _this3 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this3.filtrarTecnologias();
	      }, 500);
	    },
	    selecionaTecnologia: function selecionaTecnologia(row) {
	      var possuiItem = _.find(this.tecnologiasCadastradas, function (item) {
	        if (item.id === row.id) {
	          return item;
	        }
	      });
	      if (!_.isEmpty(possuiItem)) {
	        this.$snotify.warning(row.nome + ' - Já está cadastrado na lista.');
	        return;
	      }
	      this.tecnologiasCadastradas.push(row);
	      this.table.items = this.tecnologiasCadastradas;
	      this.table.totalRows = this.tecnologiasCadastradas.length;
	      this.table.perPage = this.tecnologiasCadastradas.length;
	      this.table.currentPage = 1;
	      this.cadastrando = false;
	    },
	    excluiTecnologia: function excluiTecnologia(row) {
	      this.table.items.splice(row.index, 1);
	      this.tecnologiasCadastradas = this.table.items;
	    },
	    salvarTecnologia: function salvarTecnologia() {
	      var _this4 = this;
	
	      var obj = {
	        proposta: this.proposta,
	        tecnologias: this.tecnologiasCadastradas,
	        processo: this.fk_processo,
	        usuario: this.usuarioLogado.id
	      };
	      this.loading.show = true;
	      axiosLaravel.post('/tecnologiasocial/salvarTecnologias/', obj).then(function (response) {
	        _this4.$snotify.success(response.data);
	        _this4.loading.show = false;
	        _this4.permiteEditar = !_this4.telaProjeto;
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	        _this4.loading.show = false;
	        _this4.$forceUpdate();
	      });
	    },
	    inputTecnologiaCheck: function inputTecnologiaCheck() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (_this5.possuiTecnologiaSocial) {
	                  _context.next = 10;
	                  break;
	                }
	
	                _this5.loading.show = true;
	                obj = {
	                  proposta: _this5.proposta,
	                  tecnologias: _this5.tecnologiasCadastradas,
	                  processo: _this5.fk_processo,
	                  usuario: _this5.usuarioLogado.id
	                };
	                _context.next = 5;
	                return axiosLaravel.post('/tecnologiasocial/apagarPorProposta', obj).then(function (response) {
	                  _this5.$snotify.success(response.data);
	                  _this5.loading.show = false;
	                  _this5.$forceUpdate();
	                }).catch(function (error) {
	                  _this5.$root.trataErro(error);
	                  _this5.loading.show = false;
	                  _this5.$forceUpdate();
	                });
	
	              case 5:
	                _this5.loading.show = false;
	                _this5.tecnologiasCadastradas = [];
	                _this5.table.items = [];
	                _this5.possuiTecnologiaSocial = false;
	                _this5.cadastrando = false;
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this5);
	      }))();
	    },
	    consultaTecnologiasCadastradas: function consultaTecnologiasCadastradas() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!(typeof _this6.proposta === 'undefined')) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	                console.log('entrou na consulta');
	                _this6.loading.show = true;
	                _context2.next = 6;
	                return axiosLaravel.get('/tecnologiasocial/consultarTecnologiaPorProposta/' + _this6.proposta).then(function (response) {
	                  if (response.data.length > 0) {
	                    _this6.tecnologiasCadastradas = response.data;
	                    _this6.possuiTecnologiaSocial = true;
	                    _this6.table.items = response.data;
	                    _this6.$forceUpdate();
	                  } else {
	                    axiosLaravel.get('/tecnologiasocial/consultarSePossuiTecnologiaProposta/' + _this6.proposta).then(function (response) {
	                      if (response.data.possui_ts === 'N') {
	                        _this6.possuiTecnologiaSocial = false;
	                        _this6.$forceUpdate();
	                      } else if (response.data.possui_ts === 'S') {
	                        _this6.possuiTecnologiaSocial = true;
	                        _this6.$forceUpdate();
	                      }
	                    }).catch(function (error) {
	                      _this6.$root.trataErro(error);
	                      _this6.loading.show = false;
	                      _this6.$forceUpdate();
	                    });
	                  }
	                  _this6.loading.show = false;
	                  _this6.$forceUpdate();
	                }).catch(function (error) {
	                  _this6.$root.trataErro(error);
	                  _this6.loading.show = false;
	                  _this6.$forceUpdate();
	                });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this6);
	      }))();
	    },
	    voltarDropDown: function voltarDropDown() {
	      this.possuiTecnologiaSocial = true;
	      this.$forceUpdate();
	    },
	    confirmarDialog: function confirmarDialog() {
	      var _this7 = this;
	
	      if (!this.possuiTecnologiaSocial && this.tecnologiasCadastradas.length > 0) {
	        this.$dialog.confirm('Confirma a Exclus\xE3o de <strong> todas tecnologais sociais cadastradas </strong> ? (Esta opera\xE7\xE3o n\xE3o poder\xE1 ser desfeita)', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	          _this7.inputTecnologiaCheck();
	        }).catch(function () {
	          _this7.voltarDropDown();
	          _this7.$snotify.warning('Operação não realizada.');
	        });
	      } else if (!this.possuiTecnologiaSocial) {
	        this.inputTecnologiaCheck();
	      }
	    }
	  }
	};

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'telefone',
	  data: function data() {
	    return {
	      perfis: {},
	      telefone: null
	    };
	  },
	
	  props: ['nomeCampo'],
	  watch: {
	    telefone: function telefone() {
	      var temp = null;
	      temp = this.telefone.replace(/[^0-9]+/g, '');
	      this.$emit('telefoneChanged', temp);
	    },
	    propsTelefone: function propsTelefone() {
	      this.profile = this.propsProfile;
	    }
	  }
	};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _cpf = __webpack_require__(178);
	
	var _cpf2 = _interopRequireDefault(_cpf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'testemunhas',
	  data: function data() {
	    return {
	      carregando: false,
	      editando: false,
	      gravando: false,
	      cpfInvalido: false,
	      emailInvalido: false,
	      testemunhaEdicao: {
	        id: null,
	        nome: '',
	        cpf: '',
	        email: ''
	      },
	      table: {
	        items: this.testemunhasCadastradas,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 50,
	        fields: [{ key: 'nome', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'cpf', label: 'CPF', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'email', label: 'E-mail', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      testemunhasCadastradas: []
	    };
	  },
	
	  props: ['idProposta'],
	  watch: {},
	  computed: {},
	  mounted: function mounted() {
	    this.buscarTestemunhasCadastradas();
	  },
	
	  methods: {
	    toggleEdicao: function toggleEdicao(valor) {
	      this.editando = valor;
	      this.cpfInvalido = false;
	      this.emailInvalido = false;
	      this.testemunhaEdicao = {
	        id: null,
	        nome: '',
	        cpf: '',
	        email: ''
	      };
	    },
	    adicionarTestemunha: function adicionarTestemunha() {
	      this.gravando = true;
	      if (this.testemunhasCadastradas.length === 2) {
	        this.$snotify.clear();
	        this.$snotify.error('Número de testemunhas máximo já encontra-se cadastrado. Favor Verificar.');
	        this.gravando = false;
	        return;
	      }
	      if (!this.verificaCampos()) {
	        this.gravando = false;
	        return;
	      }
	      this.$snotify.clear();
	      this.$aguarde('Gravando testemunha...');
	      this.gravaTestemunha();
	    },
	    confirmaExclusao: function confirmaExclusao(mensagem, acao) {
	      this.$dialog.confirm(mensagem).then(function () {
	        return acao();
	      }).catch(function () {});
	    },
	    excluirItem: function excluirItem(item) {
	      var index = this.table.items.indexOf(item);
	      if (index < 0) {
	        return;
	      }
	      this.$snotify.clear();
	      this.$aguarde('Excluindo testemunha...');
	      if (item.id !== null) {
	        this.gravando = true;
	        this.excluiTestemunha(item);
	      }
	      this.table.items.splice(index, 1);
	      this.testemunhasCadastradas = this.table.items;
	      this.$forceUpdate();
	    },
	    verificaTestemunhasCadastradas: function verificaTestemunhasCadastradas() {
	      if (this.testemunhasCadastradas.length < 2) {
	        this.$snotify.error('Cadastre ao menos duas testemunhas para assinatura do contrato antes de continuar.');
	        return false;
	      }
	      return true;
	    },
	    validaCPF: function validaCPF() {
	      var cpfCheck = _cpf2.default.validate(this.testemunhaEdicao.cpf);
	      if (!cpfCheck) {
	        this.cpfInvalido = true;
	      } else {
	        this.cpfInvalido = false;
	      }
	    },
	    validaEmail: function validaEmail() {
	      var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	      if (regex.test(this.testemunhaEdicao.email)) {
	        this.emailInvalido = false;
	      } else {
	        this.emailInvalido = true;
	      }
	    },
	    verificaCampos: function verificaCampos() {
	      var _this = this;
	
	      this.$snotify.clear();
	
	      var cpfExistente = this.testemunhasCadastradas.some(function (testemunha) {
	        return testemunha.cpf === _this.testemunhaEdicao.cpf;
	      });
	      if (cpfExistente) {
	        this.$snotify.error('CPF já cadastrado para esta proposta. Favor Verificar.');
	        return false;
	      }
	      if (this.cpfInvalido) {
	        this.$snotify.error('CPF inválido. Favor Verificar.');
	        return false;
	      }
	      if (this.emailInvalido) {
	        this.$snotify.error('Informe um e-mail válido. Favor Verificar.');
	        return false;
	      }
	      if (this.testemunhaEdicao.nome === '') {
	        this.$snotify.error('Preencha o nome antes de continuar. Favor Verificar.');
	        return false;
	      }
	      if (this.testemunhaEdicao.cpf === '') {
	        this.$snotify.error('Preencha o CPF antes de continuar. Favor Verificar.');
	        return false;
	      }
	      if (this.testemunhaEdicao.email === '') {
	        this.$snotify.error('Preencha o E-MAIL antes de continuar. Favor Verificar.');
	        return false;
	      }
	      if (this.testemunhaEdicao.email === '') {
	        this.$snotify.error('Preencha o E-MAIL antes de continuar. Favor Verificar.');
	        return false;
	      } else if (!this.testemunhaEdicao.email.includes('@')) {
	        this.$snotify.error('Informe um e-mail válido. Favor Verificar.');
	        return false;
	      }
	      return true;
	    },
	    gravaTestemunha: function gravaTestemunha() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(_this2.testemunhaEdicao.id !== null)) {
	                  _context.next = 2;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 2:
	                obj = {
	                  idProposta: _this2.idProposta,
	                  nome: _this2.testemunhaEdicao.nome,
	                  cpf: _this2.testemunhaEdicao.cpf,
	                  email: _this2.testemunhaEdicao.email
	                };
	                _context.next = 5;
	                return axiosLaravel.post('/testemunha/gravaTestemunha/', obj).then(function (response) {
	                  _this2.$snotify.clear();
	                  _this2.testemunhaEdicao.id = response.data.id;
	                  _this2.$snotify.success(response.data.message);
	                  console.log(response.data);
	                  _this2.testemunhasCadastradas.push(_this2.testemunhaEdicao);
	                  _this2.table.items = _this2.testemunhasCadastradas;
	                  _this2.gravando = false;
	                  _this2.toggleEdicao(false);
	                  _this2.$forceUpdate();
	                }).catch(function (error) {
	                  _this2.gravando = false;
	                  _this2.$snotify.clear();
	                  console.error(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    buscarTestemunhasCadastradas: function buscarTestemunhasCadastradas() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this3.carregando = true;
	                _context2.next = 3;
	                return axiosLaravel.get('/testemunha/getTestemunha/' + _this3.idProposta).then(function (response) {
	                  _this3.testemunhasCadastradas = response.data;
	                  _this3.table.items = _this3.testemunhasCadastradas;
	                  _this3.carregando = false;
	                  _this3.$forceUpdate();
	                }).catch(function (error) {
	                  _this3.carregando = false;
	                  _this3.$snotify.clear();
	                  console.error(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    },
	    excluiTestemunha: function excluiTestemunha(item) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (!(item.id === null)) {
	                  _context3.next = 2;
	                  break;
	                }
	
	                return _context3.abrupt('return');
	
	              case 2:
	                _context3.next = 4;
	                return axiosLaravel.post('/testemunha/excluiTestemunha/' + item.id).then(function (response) {
	                  _this4.$snotify.clear();
	                  _this4.$snotify.success(response.data);
	                  _this4.gravando = false;
	                  _this4.$forceUpdate();
	                }).catch(function (error) {
	                  _this4.gravando = false;
	                  _this4.$snotify.clear();
	                  console.error(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    }
	  }
	};

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'UIButtons'
	};

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'UIGeneral'
	};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'UIIcons'
	};

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'UIModals'
	};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'UISliders',
	  mounted: function mounted() {
	    __webpack_require__(1546);
	    __webpack_require__(890);
	    $(document).ready(function ($) {
	      $('.slider').slider();
	
	      $('#range_1').ionRangeSlider({
	        min: 0,
	        max: 5000,
	        from: 1000,
	        to: 4000,
	        type: 'double',
	        step: 1,
	        prefix: '$',
	        prettify: false,
	        hasGrid: true
	      });
	
	      $('#range_2').ionRangeSlider({
	        type: 'double'
	      });
	
	      $('#range_3').ionRangeSlider({
	        type: 'double',
	        postfix: ' miles',
	        step: 10000,
	        from: 25000000,
	        to: 35000000,
	        onChange: function onChange(obj) {
	          var t = '';
	          for (var prop in obj) {
	            t += prop + ': ' + obj[prop] + '\r\n';
	          }
	          $('#result').html(t);
	        },
	        onLoad: function onLoad(obj) {}
	      });
	
	      $('#range_4').ionRangeSlider({
	        type: 'single',
	        step: 100,
	        postfix: ' light years',
	        from: 55000,
	        hideMinMax: true,
	        hideFromTo: false
	      });
	
	      $('#range_5').ionRangeSlider({
	        min: 0,
	        max: 10,
	        type: 'single',
	        step: 0.1,
	        postfix: ' mm',
	        prettify: false,
	        hasGrid: true
	      });
	
	      $('#range_6').ionRangeSlider({
	        min: -50,
	        max: 50,
	        from: 0,
	        type: 'single',
	        step: 1,
	        postfix: '°',
	        prettify: false,
	        hasGrid: true
	      });
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'UITimeline'
	};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documento',
	  data: function data() {
	    return {
	      documentos: [],
	      tipoVinculo: null,
	      idVinculo: null,
	      listaVinculos: null,
	      loading: {
	        show: false
	      },
	      documento: {
	        ds_nome_arquivo: ''
	      },
	      dt_data_vigencia: '',
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      localUso: 'TODOS'
	    };
	  },
	
	  props: ['documentTypes', 'documentosObrigatorios', 'disable', 'listaProjetos', 'listaEntidades'],
	  watch: {
	    dt_data_vigencia: function dt_data_vigencia(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.documento.dt_data_vigencia = newdate.format('YYYY-MM-DD');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    this.carregaListaTiposDocumentos();
	    this.listaVinculos = this.listaProjetos;
	  },
	
	  methods: {
	    carregaListaTiposDocumentos: function carregaListaTiposDocumentos() {
	      var _this = this;
	
	      if (this.localUso === undefined) {
	        this.localUso = 'TODOS';
	      }
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this.documentos = _.sortBy(response.data, 'ds_tipo');
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	
	      if (_.isNull(this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	        axiosLaravel.get('configuracoes/').then(function (response) {
	          _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	            return item.ds_mime_type;
	          }).join('|');
	          _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	        });
	      } else {
	        this.tiposPermitidos = this.$store.state.uploadDocumentos.tiposPermitidos;
	        this.tamanhoPermitido = this.$store.state.uploadDocumentos.tamanhoPermitido;
	      }
	    },
	    vinculoSelecionado: function vinculoSelecionado(radio) {
	      this.idVinculo = null;
	      this.listaVinculos = this.tipoVinculo === 'Projeto' ? this.listaProjetos : _.sortBy(this.listaEntidades, 'ds_nome');
	      this.localUso = this.tipoVinculo === 'Projeto' ? 'TODOS' : 'CADASTRO_ENTIDADE';
	      this.carregaListaTiposDocumentos();
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this2.$validator.errors.all().length === 0) {
	          _this2.documento.dt_criado = new Date();
	          _this2.uploadArquivo();
	        }
	      });
	    },
	    onCancel: function onCancel() {
	      this.limparCampos('todos');
	      this.$emit('mostrarQuadroAdicionaDocumento', false);
	    },
	    limparCampos: function limparCampos(abrangencia) {
	      if (abrangencia === 'todos') {
	        this.idVinculo = '';
	        this.documento.tipo_documento = null;
	
	        this.errors.clear();
	      }
	      $('#file').val('');
	      this.documento.dt_data_vigencia = '';
	      this.dt_data_vigencia = '';
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this3 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.tipo_vinculo = this.tipoVinculo;
	      this.documento.id_vinculo = this.idVinculo;
	      this.documento.loaded = 'upload_direto';
	      this.documento.progress = 0;
	      this.documento.usuario = this.usuarioLogado;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.clear();
	      this.$snotify.info('Adicionando arquivo...', { timeout: 0 });
	      this.loading.show = true;
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this3.limparCampos();
	        _this3.loading.show = false;
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Arquivo incluído!');
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.loading.show = false;
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documento-movimento-diario',
	  data: function data() {
	    return {
	      documentos: [],
	      tipoVinculo: null,
	      idVinculo: null,
	      listaVinculos: null,
	      loading: {
	        show: false
	      },
	      documento: {
	        ds_nome_arquivo: ''
	      },
	      dt_data_vigencia: '',
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      localUso: 'TODOS'
	    };
	  },
	
	  props: ['documentTypes', 'documentosObrigatorios', 'disable', 'pasta'],
	  watch: {
	    dt_data_vigencia: function dt_data_vigencia(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.documento.dt_data_vigencia = newdate.format('YYYY-MM-DD');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    this.carregaListaTiposDocumentos();
	  },
	
	  methods: {
	    carregaListaTiposDocumentos: function carregaListaTiposDocumentos() {
	      var _this = this;
	
	      if (this.localUso === undefined) {
	        this.localUso = 'TODOS';
	      }
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this.documentos = _.sortBy(response.data, 'ds_tipo');
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	
	      if (_.isNull(this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	        axiosLaravel.get('configuracoes/').then(function (response) {
	          _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	            return item.ds_mime_type;
	          }).join('|');
	          _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	        });
	      } else {
	        this.tiposPermitidos = this.$store.state.uploadDocumentos.tiposPermitidos;
	        this.tamanhoPermitido = this.$store.state.uploadDocumentos.tamanhoPermitido;
	      }
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this2.$validator.errors.all().length === 0) {
	          _this2.documento.dt_criado = new Date();
	          _this2.uploadArquivo();
	        }
	      });
	    },
	    aviso: function aviso(retorno) {
	      if (_.has(retorno, 'codigo')) {
	        if (retorno.codigo !== 'OK') {
	          var mensagem = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : 'Erro de processamento. Não sei o que houve';
	          this.$snotify.clear();
	          this.$snotify.error(mensagem);
	        } else {
	          if (_.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem)) {
	            this.$snotify.success(retorno.mensagem, { timeout: 3000 });
	          }
	        }
	      }
	    },
	    cancelar: function cancelar() {
	      this.limparCampos();
	      this.$emit('mostrarQuadroAdicionaDocumento', false);
	      this.$emit('atualizarPasta', this.pasta);
	    },
	    limparCampos: function limparCampos() {
	      this.documento.tipo_documento = null;
	      this.errors.clear();
	      $('#file').val('');
	      this.documento.dt_data_vigencia = '';
	      this.dt_data_vigencia = '';
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this3 = this;
	
	      if (_.has(this.pasta, 'id')) {
	        var data = new FormData();
	        data.append('file', this.file);
	        this.documento.pk = this.documento.id ? this.documento.id : 0;
	        this.documento['id_pasta'] = this.pasta.id;
	        this.documento.loaded = 'upload_direto';
	        this.documento.progress = 0;
	        this.documento.usuario = this.usuarioLogado;
	        this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	        data.append('document', (0, _stringify2.default)(this.documento));
	        this.$snotify.clear();
	        this.$snotify.info('Adicionando arquivo...', { timeout: 0 });
	        this.loading.show = true;
	        axiosLaravel.post('pasta/adicionar/arquivo/', data, {
	          headers: { 'Content-Type': undefined, 'Accept': 'application/json' },
	          transformRequest: [function (data, headers) {
	            return data;
	          }]
	        }).then(function (response) {
	          _this3.$snotify.clear();
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this3.limparCampos();
	          }
	          _this3.aviso(response.data);
	          _this3.loading.show = false;
	        }).catch(function (error) {
	          console.log('error adicionando arquivo', error);
	          _this3.loading.show = false;
	          _this3.$snotify.clear();
	          _this3.$root.trataErro(error);
	        });
	      } else {
	        this.aviso({ 'codigo': 'ERRO', 'mensagem': 'Pasta não selecionada: sem id para esta pasta' });
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documentos',
	  data: function data() {
	    return {
	      showGrid: true,
	      documentos: [],
	      documento: {},
	      documentoTabela: {},
	      editando: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null
	    };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'documentosObrigatorios', 'disable'],
	  created: function created() {
	    var _this = this;
	
	    if (_.isEmpty(this.$store.state.uploadDocumentos.documentos)) {
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this.documentos = _this.$store.state.uploadDocumentos.documentos = response.data;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    } else {
	      this.documentos = this.$store.state.uploadDocumentos.documentos;
	    }
	
	    if (_.isNull(this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	          return item.ds_mime_type;
	        }).join('|');
	        _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    } else {
	      this.tiposPermitidos = this.$store.state.uploadDocumentos.tiposPermitidos;
	      this.tamanhoPermitido = this.$store.state.uploadDocumentos.tamanhoPermitido;
	    }
	  },
	
	  methods: {
	    onNew: function onNew() {
	      this.showGrid = !this.showGrid;
	      this.documento = {};
	    },
	    existeDocumento: function existeDocumento(documento) {
	      return this.propDocumentos.some(function (item) {
	        return documento.type === item.documentType.type;
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      axios.get('proxy/document/documents/' + documento.id + '/download', { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.contentType });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.fileName;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var _blob = new Blob([response.data], { type: documento.contentType });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.fileName);
	          _link.download = documento.fileName;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    handleFileUpload: function handleFileUpload() {
	      this.file = this.$refs.file.files[0];
	    },
	    onAdd: function onAdd() {
	      var _this3 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          _this3.uploadArquivo();
	        }
	      });
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.$forceUpdate();
	    },
	    onDelete: function onDelete(indexDocumento) {
	      this.propDocumentos.splice(indexDocumento, 1);
	      this.$forceUpdate();
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    onEdit: function onEdit(documento) {
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this4 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Subindo arquivo', { timeout: 0 });
	      axios.post('proxy/document/documents', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this4.documento = response.data.value;
	        if (_this4.editando === true) {
	          for (var i in _this4.documento) {
	            _this4.documentoTabela[i] = _this4.documento[i];
	          }_this4.documentoTabela = (0, _assign2.default)({}, _this4.documento);
	        } else {
	          _this4.propDocumentos.push(_this4.documento);
	        }
	        _this4.onCancel();
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Arquivo salvo com sucesso');
	      }).catch(function (error) {
	        console.log('error', error);
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documentos-chamado',
	  data: function data() {
	    return {
	      showGrid: true,
	      documentos: [],
	      documento: {
	        tipo_documento: {
	          id: 67,
	          ds_tipo: 'Anexo Chamado'
	        },
	        ds_nome_arquivo: ''
	      },
	      tipo_padrao: {
	        id: 67,
	        ds_tipo: 'Anexo Chamado'
	      },
	      documentoTabela: {},
	      editando: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      localUso: 'TODOS'
	    };
	  },
	
	  props: ['propDocumentos'],
	  created: function created() {
	    var _this = this;
	
	    if (_.isNull(this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	          return item.ds_mime_type;
	        }).join('|');
	        _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    } else {
	      this.tiposPermitidos = this.$store.state.uploadDocumentos.tiposPermitidos;
	      this.tamanhoPermitido = this.$store.state.uploadDocumentos.tamanhoPermitido;
	    }
	  },
	
	  methods: {
	    novoDocumento: function novoDocumento() {
	      this.showGrid = !this.showGrid;
	      this.documento = {};
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this3 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          _this3.documento.dt_criado = new Date();
	          if (_this3.editando === true) {
	            for (var i in _this3.documento) {
	              _this3.documentoTabela[i] = _this3.documento[i];
	            }_this3.documentoTabela = (0, _assign2.default)({}, _this3.documento);
	          } else {
	            _this3.propDocumentos.push(_this3.documento);
	          }
	          _this3.documento.tipo_documento = _this3.tipo_padrao;
	          _this3.onCancel();
	        }
	      });
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.$forceUpdate();
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento) {
	      this.propDocumentos.splice(indexDocumento, 1);
	      this.$forceUpdate();
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    editaDocumento: function editaDocumento(documento) {
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this4 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Subindo arquivo', { timeout: 0 });
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this4.documento = response.data.value;
	        if (_this4.editando === true) {
	          for (var i in _this4.documento) {
	            _this4.documentoTabela[i] = _this4.documento[i];
	          }_this4.documentoTabela = (0, _assign2.default)({}, _this4.documento);
	        } else {
	          _this4.propDocumentos.push(_this4.documento);
	        }
	        _this4.onCancel();
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Arquivo salvo com sucesso');
	      }).catch(function (error) {
	        console.log('error', error);
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documentos-php',
	  data: function data() {
	    return {
	      showGrid: true,
	      documentos: [],
	      documento: {
	        ds_nome_arquivo: ''
	      },
	      documentoTabela: {},
	      editando: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      localUso: 'TODOS'
	    };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'documentosObrigatorios', 'disable', 'localUso'],
	  created: function created() {
	    var _this = this;
	
	    if (_.isUndefined(this.localUso)) {
	      this.localUso = 'TODOS';
	    }
	    if (this.localUso === 'TODOS') {
	      if (_.isEmpty(this.$store.state.uploadDocumentos.documentos)) {
	        axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	          _this.documentos = _this.$store.state.uploadDocumentos.documentos = _.sortBy(response.data, [function (o) {
	            return o.ds_tipo;
	          }]);
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	        });
	      } else {
	        this.documentos = this.$store.state.uploadDocumentos.documentos;
	      }
	    } else {
	      axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	        _this.documentos = _.sortBy(response.data, [function (o) {
	          return o.ds_tipo;
	        }]);
	        console.log('this.documentos', _this.documentos);
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	
	    if (_.isNull(this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	          return item.ds_mime_type;
	        }).join('|');
	        _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    } else {
	      this.tiposPermitidos = this.$store.state.uploadDocumentos.tiposPermitidos;
	      this.tamanhoPermitido = this.$store.state.uploadDocumentos.tamanhoPermitido;
	    }
	  },
	
	  methods: {
	    novoDocumento: function novoDocumento() {
	      this.showGrid = !this.showGrid;
	      this.documento = {};
	    },
	    existeDocumento: function existeDocumento(documento) {
	      return this.propDocumentos.some(function (item) {
	        if (documento.tipo_documento) {
	          return documento.tipo_documento.ds_tipo === item.tipo_documento.ds_tipo;
	        }
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this3 = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          _this3.documento.dt_criado = new Date();
	          if (_this3.editando === true) {
	            for (var i in _this3.documento) {
	              _this3.documentoTabela[i] = _this3.documento[i];
	            }_this3.documentoTabela = (0, _assign2.default)({}, _this3.documento);
	          } else {
	            _this3.propDocumentos.push(_this3.documento);
	          }
	          _this3.onCancel();
	        }
	      });
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.$forceUpdate();
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento) {
	      this.propDocumentos.splice(indexDocumento, 1);
	      this.$forceUpdate();
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    editaDocumento: function editaDocumento(documento) {
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this4 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Subindo arquivo', { timeout: 0 });
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this4.documento = response.data.value;
	        if (_this4.editando === true) {
	          for (var i in _this4.documento) {
	            _this4.documentoTabela[i] = _this4.documento[i];
	          }_this4.documentoTabela = (0, _assign2.default)({}, _this4.documento);
	        } else {
	          _this4.propDocumentos.push(_this4.documento);
	        }
	        _this4.onCancel();
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Arquivo salvo com sucesso');
	      }).catch(function (error) {
	        console.log('error', error);
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _deepObjectDiff = __webpack_require__(83);
	
	var _downloadjs = __webpack_require__(119);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'upload-documentos-php-novo',
	  data: function data() {
	    return {
	      showGrid: true,
	      tamanho: 0,
	      contador: 0,
	      tamanhoFormatado: 0,
	      salvou: false,
	      acmTamanho: 0,
	      totalMb: 0,
	      documentos: [],
	      documento: {
	        ds_nome_arquivo: '',
	        ligacao_sub_type: ''
	      },
	      documentoTabela: {},
	      editando: false,
	      mostraInclusao: false,
	      mostraExclusao: false,
	      mostraAlteracao: false,
	      dt_data_vigencia: '',
	      indiceAlt: -1,
	      ocultaIcone: false,
	      file: {},
	      tiposPermitidos: '',
	      tamanhoPermitido: null,
	      image: '',
	      listaOrdenada: {},
	      mudancas: [],
	      conteudoAnterior: {},
	      table: {
	        items: this.propDocumentos,
	        filter: null,
	        hover: true,
	        bordered: true,
	        totalRows: 0,
	        currentPage: 1,
	        perPage: 100,
	        sortBy: 'dt_criado',
	        sortDesc: true,
	        fields: [{
	          key: 'tipo_documento.ds_tipo',
	          label: 'Tipo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 35%',
	          class: 'text-center'
	        }, {
	          key: 'ds_nome_arquivo',
	          label: 'Arquivo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 30%',
	          class: 'text-center'
	        }, { key: 'dt_criado', label: 'Inclusão', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, {
	          key: 'dt_data_validade',
	          label: 'Vigência',
	          sortable: true,
	          thStyle: 'text-align: center',
	          class: 'text-center'
	        }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['propDocumentos', 'documentTypes', 'documentosObrigatorios', 'disable', 'localUso', 'mudaDocumento', 'diferenca', 'analise', 'revisao', 'salvouOK', 'propsEtapa', 'faseProposta', 'editandoAlteracaoProjeto', 'editandoProrrogacao', 'ehParceiroEstrategico'],
	  watch: {
	    propDocumentos: function propDocumentos() {
	      this.table.items = this.propDocumentos;
	      this.table.totalRows = this.table.items.length;
	      if (this.disable === 'disable') {
	        this.desativado = this.disable;
	      }
	    },
	    diferenca: function diferenca() {
	      this.diferencaDoc = this.diferenca;
	    },
	    analise: function analise() {
	      if (this.analise) {
	        this.analiseDoc = this.analise.documentos;
	      }
	    },
	    dt_data_vigencia: function dt_data_vigencia(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.documento.dt_data_vigencia = newdate.format('YYYY-MM-DD');
	      }
	    },
	    revisao: function revisao() {
	      if (this.revisao) {
	        this.revisaoDoc = this.revisao.documentos;
	      }
	      this.mostraExclusao = false;
	      this.mostraInclusao = false;
	      if (this.analiseDoc && this.revisaoDoc) {
	        if (this.analiseDoc.length > this.revisaoDoc.length) {
	          this.mostraExclusao = true;
	          this.mostraInclusao = false;
	        } else {
	          this.mostraExclusao = true;
	        }
	        if (this.analiseDoc.length < this.revisaoDoc.length) {
	          this.mostraInclusao = true;
	          this.mostraExclusao = false;
	        } else {
	          this.mostraInclusao = false;
	        }
	        if (this.analiseDoc.length === this.revisaoDoc.length) {
	          this.mostraExclusao = false;
	        }
	      }
	      this.adicionados = (0, _deepObjectDiff.detailedDiff)(this.analise, this.revisao).added;
	
	      this.excluidos = _.differenceBy(this.analise.documentos, this.revisao.documentos, 'tipo_documento.ds_tipo');
	      this.atualizados = (0, _deepObjectDiff.detailedDiff)(this.analise.documentos, this.revisao.documentos).updated;
	
	      if (this.adicionados) {
	        if (this.adicionados.documentos) {
	          this.inclDoc = this.adicionados.documentos;
	          this.inclDocTexto = _.map(this.inclDoc, 'tipo_documento.ds_tipo');
	          this.naoExisteDoc = false;
	        } else {
	          this.naoExisteDoc = true;
	        }
	      }
	      if (this.excluidos) {
	        this.excDocTexto = _.map(this.excluidos, 'tipo_documento.ds_tipo');
	      }
	    },
	    mudaDocumento: function mudaDocumento() {
	      this.mudancas = this.mudaDocumento.documentos;
	      if (this.mudancas) {
	        if (_.findKey(this.mudancas, 'ds_nome_arquivo')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_nome_arquivo');
	        }
	        if (_.findKey(this.mudancas, 'ds_content_type')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_content_type');
	        }
	        if (_.findKey(this.mudancas, 'fk_tipo_documento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'fk_tipo_documento');
	        }
	        if (_.findKey(this.mudancas, 'dt_data_validade')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'dt_data_validade');
	        }
	        if (_.findKey(this.mudancas, 'tipo_documento')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'tipo_documento');
	        }
	        if (this.indiceAlt !== -1) {
	          this.mostraAlteracao = true;
	          this.texto = this.diferencaDoc.documentos[this.indiceAlt];
	        } else {
	          this.mostraAlteracao = false;
	        }
	      }
	    },
	    salvouOK: function salvouOK() {
	      this.salvou = this.salvouOK;
	      if (this.salvou === true) {
	        this.totalMb = 0;
	        this.acmTamanho = 0;
	      }
	    }
	  },
	  computed: {
	    progress: function progress() {
	      return (this.totalMb / 80 * 100).toFixed(2);
	    },
	    PropEditandoAlteracaoProjeto: function PropEditandoAlteracaoProjeto() {
	      if (this.editandoAlteracaoProjeto) {
	        return this.editandoAlteracaoProjeto;
	      } else {
	        return false;
	      }
	    },
	    PropProrrogacaoEdit: function PropProrrogacaoEdit() {
	      if (this.editandoProrrogacao) {
	        return this.editandoProrrogacao;
	      } else {
	        return false;
	      }
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (_this.localUso === undefined) {
	                _this.localUso = 'TODOS';
	              }
	
	              if (!(_this.localUso === 'TODOS')) {
	                _context.next = 11;
	                break;
	              }
	
	              if (!_.isEmpty(_this.$store.state.uploadDocumentos.documentos)) {
	                _context.next = 7;
	                break;
	              }
	
	              _context.next = 5;
	              return axiosLaravel.post('documentos/tipos/' + _this.localUso).then(function (response) {
	                _this.documentos = _this.$store.state.uploadDocumentos.documentos = _.sortBy(response.data, [function (o) {
	                  return o.ds_tipo;
	                }]);
	                _this.$forceUpdate();
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 5:
	              _context.next = 9;
	              break;
	
	            case 7:
	              _this.documentos = _this.$store.state.uploadDocumentos.documentos;
	              _this.$forceUpdate();
	
	            case 9:
	              _context.next = 13;
	              break;
	
	            case 11:
	              _context.next = 13;
	              return axiosLaravel.post('documentos/tipos/' + _this.localUso).then(function (response) {
	                _this.documentos = _.sortBy(response.data, [function (o) {
	                  return o.ds_tipo;
	                }]);
	                _this.$forceUpdate();
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 13:
	              if (_.isNull(_this.$store.state.uploadDocumentos.tiposPermitidos) || _.isNull(_this.$store.state.uploadDocumentos.tamanhoPermitido)) {
	                axiosLaravel.get('configuracoes/').then(function (response) {
	                  _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos = response.data.documento.tipo_arquivos.map(function (item) {
	                    return item.ds_mime_type;
	                  }).join('|');
	                  _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido = response.data.documento.dc_tamanho_arquivo * 1024;
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	              } else {
	                _this.tiposPermitidos = _this.$store.state.uploadDocumentos.tiposPermitidos;
	                _this.tamanhoPermitido = _this.$store.state.uploadDocumentos.tamanhoPermitido;
	              }
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    novoDocumento: function novoDocumento() {
	      this.ocultaIcone = true;
	      this.showGrid = !this.showGrid;
	
	      this.documento.dt_data_vigencia = '';
	    },
	    existeDocumento: function existeDocumento(documento) {
	      if (!_.isEmpty(this.propDocumentos) && !_.isEmpty(this.propDocumentos) && this.propDocumentos !== []) {
	        return this.propDocumentos.some(function (item) {
	          if (documento.id) {
	            return documento.id === item.tipo_documento.id;
	          }
	        });
	      }
	    },
	    onDownload: function onDownload(documento) {
	      var _this2 = this;
	
	      if (documento.file) {
	        (0, _downloadjs2.default)(documento.file, documento.ds_nome_arquivo, documento.ds_content_type);
	      } else {
	        axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	          var ie = !!window.MSInputMethodContext && !!document.documentMode;
	          if (!ie) {
	            var blob = new Blob([response.data], { type: documento.ds_content_type });
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = documento.ds_nome_arquivo;
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          } else {
	            var bytes = new Uint8Array(resultByte);
	            var _blob = new Blob([bytes], { type: documento.ds_content_type });
	            var _link = document.createElement('blob');
	            _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	            _link.download = documento.ds_nome_arquivo;
	            _link.click();
	          }
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    handleFileUpload: function handleFileUpload(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      this.tamanho = e.target.files[0].size;
	      this.tamanhoFormatado = (this.tamanho / Math.pow(1024, 2)).toFixed(2);
	
	      this.carregaArquivo(files[0]);
	
	      this.documento.ds_nome_arquivo = files[0].name;
	
	      this.documento.ds_content_type = files[0].type;
	    },
	    carregaArquivo: function carregaArquivo(file) {
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        vm.documento.file = e.target.result;
	      };
	      reader.readAsDataURL(file);
	    },
	    adicionaDocumento: function adicionaDocumento() {
	      var _this3 = this;
	
	      var totalParc = 0;
	      var aux = (this.acmTamanho + this.tamanho) / Math.pow(1024, 2);
	      var auxMb = aux.toFixed(2);
	      if (auxMb > 80) {
	        this.$snotify.error('O limite de envio é 80 MB por lote.\n' + 'Já utilizado: ' + this.totalMb + ' MB, e o arquivo possui: ' + this.tamanhoFormatado + ' MB ' + '\n. Favor salvar o formulário para poder incluir mais arquivos.');
	        return;
	      } else {
	        this.acmTamanho = this.acmTamanho + this.tamanho;
	        totalParc = this.acmTamanho / Math.pow(1024, 2);
	        this.totalMb = totalParc.toFixed(2);
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && _this3.$validator.errors.all().length === 0) {
	          _this3.documento.dt_criado = new Date();
	          _this3.documento.ligacao_sub_type = _this3.propsEtapa;
	          if (_this3.editando === true) {
	            for (var i in _this3.documento) {
	              _this3.documentoTabela[i] = _this3.documento[i];
	            }_this3.documentoTabela = (0, _assign2.default)({}, _this3.documento);
	          } else {
	            _this3.propDocumentos.push(_this3.documento);
	            _this3.contador += 1;
	          }
	          _this3.onCancel();
	        }
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.table.totalRows = this.table.items.length;
	      this.currentPage = 1;
	    },
	    onCancel: function onCancel() {
	      this.documento = (0, _assign2.default)({}, {});
	      this.documento.documentType = (0, _assign2.default)({}, {});
	      this.documento.documentType.type = (0, _assign2.default)({}, '');
	      this.file = null;
	      this.showGrid = true;
	      this.editando = false;
	      this.editandoIndex = '';
	      this.conteudoAnterior = (0, _assign2.default)({}, '');
	      if (this.contador === 0) {
	        this.totalMb = 0;
	      }
	      this.$forceUpdate();
	    },
	    deletaDocumento: function deletaDocumento(indexDocumento) {
	      var temp = 0;
	      if (this.propDocumentos[indexDocumento].file) {
	        this.byteLength = parseInt(this.propDocumentos[indexDocumento].file.replace(/=/g, '').length * 0.75);
	        temp = (this.byteLength / Math.pow(1024, 2)).toFixed(2);
	        this.totalMb = (this.totalMb - temp).toFixed(2);
	        this.contador = this.contador - 1;
	        this.acmTamanho = this.acmTamanho - parseInt(this.propDocumentos[indexDocumento].file.replace(/=/g, '').length * 0.75);
	      }
	      this.propDocumentos.splice(indexDocumento, 1);
	      this.$forceUpdate();
	    },
	    onAddFile: function onAddFile(pendente) {
	      this.documentos = {};
	      this.documentos[0] = (0, _assign2.default)({}, pendente);
	      this.documento.tipo_documento = (0, _assign2.default)({}, pendente);
	      this.documento.documentType = pendente;
	      this.showGrid = !this.showGrid;
	    },
	    editaDocumento: function editaDocumento(documento, indexDocumento) {
	      var _this4 = this;
	
	      this.ocultaIcone = false;
	      this.documento = (0, _assign2.default)({}, documento);
	      this.showGrid = !this.showGrid;
	      this.documentoTabela = documento;
	      this.editando = true;
	
	      this.editandoIndex = indexDocumento;
	      this.documento = (0, _assign2.default)({}, documento);
	      this.documentoTabela = documento;
	      if (this.documento.tipo_documento.pivot) {
	        this.documentos.forEach(function (doc) {
	          if (doc.id === _this4.documento.tipo_documento.id) {
	            _this4.documento.tipo_documento = (0, _assign2.default)({}, doc);
	          }
	        });
	      }
	      this.mudancas = _.cloneDeep(this.mudaDocumento.documentos[indexDocumento]);
	      if (this.mudancas.dt_data_vigencia) {
	        this.mudancas.dt_data_vigencia = (0, _moment2.default)(this.mudancas.dt_data_vigencia).format('DD/MM/YYYY');
	      }
	
	      if (_.hasIn(this.atualizados, indexDocumento)) {
	        this.conteudoAnterior = _.cloneDeep(this.atualizados[indexDocumento]);
	        if (this.conteudoAnterior.dt_data_vigencia) {
	          this.conteudoAnterior.dt_data_vigencia = (0, _moment2.default)(this.conteudoAnterior.dt_data_vigencia).format('DD/MM/YYYY');
	        }
	      } else {
	        this.conteudoAnterior = (0, _assign2.default)({}, {});
	      }
	
	      this.$forceUpdate();
	    },
	    uploadArquivo: function uploadArquivo() {
	      var _this5 = this;
	
	      var data = new FormData();
	      data.append('file', this.file);
	      this.documento.pk = this.documento.id ? this.documento.id : 0;
	      this.documento.loaded = 'upload';
	      this.documento.progress = 0;
	      this.documento.issueDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      data.append('document', (0, _stringify2.default)(this.documento));
	      this.$snotify.info('Subindo arquivo', { timeout: 0 });
	      axiosLaravel.post('documentos/upload', data, {
	        headers: {
	          'Content-Type': undefined,
	          'Accept': 'application/json'
	        },
	        transformRequest: [function (data, headers) {
	          return data;
	        }]
	      }).then(function (response) {
	        _this5.documento = response.data.value;
	        if (_this5.editando === true) {
	          for (var i in _this5.documento) {
	            _this5.documentoTabela[i] = _this5.documento[i];
	          }_this5.documentoTabela = (0, _assign2.default)({}, _this5.documento);
	        } else {
	          _this5.propDocumentos.push(_this5.documento);
	        }
	        _this5.onCancel();
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Arquivo salvo com sucesso');
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deepObjectDiff = __webpack_require__(83);
	
	exports.default = {
	  name: 'usuarios',
	  data: function data() {
	    return {
	      showgrid: true,
	      state: 'GRID',
	      users: [],
	      curIndex: 0,
	      bloqueioCampos: false,
	      statusEntidade: '',
	      usuario: {},
	      index: 0,
	      mudancas: [],
	      listaUsu: [],
	      verificandoLoginEmail: false,
	      jaExisteEmail: false,
	      jaExisteLogin: false,
	      editandoIndex: null,
	      inativosOcultados: true,
	      mostraInclusao: false,
	      mostraExclusao: false,
	      mostraAlteracao: false,
	      table: {
	        items: this.entUsuarios,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 50,
	        fields: [{ key: 'ds_nome_usuario', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_cpf', label: 'CPF', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_login', label: 'Login', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_telefone', label: 'Telefone', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_email', label: 'E-mail', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', thStyle: 'text-align: center; width: 7%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['entUsuarios', 'disable', 'mudaUsuario', 'diferenca', 'analise', 'revisao'],
	  watch: {
	    entUsuarios: function entUsuarios() {
	      this.table.items = this.entUsuarios;
	      if (this.mudaUsuario) {
	        this.mudancas = this.mudaUsuario;
	      }
	    },
	    'table.items': function tableItems() {
	      this.$emit('usuarioAdicionado', this.table.items);
	    },
	    diferenca: function diferenca() {
	      this.diferencaUsu = this.diferenca;
	    },
	    analise: function analise() {
	      if (this.analise) {
	        this.analiseUsu = this.analise.usuarios;
	      }
	    },
	    revisao: function revisao() {
	      if (this.revisao) {
	        this.revisaoUsu = this.revisao.usuarios;
	      }
	      this.mostraExclusao = false;
	      this.mostraInclusao = false;
	      if (this.analiseUsu && this.revisaoUsu) {
	        if (this.analiseUsu.length > this.revisaoUsu.length) {
	          this.mostraExclusao = true;
	          this.mostraInclusao = false;
	        } else {
	          this.mostraExclusao = true;
	        }
	        if (this.analiseUsu.length < this.revisaoUsu.length) {
	          this.mostraInclusao = true;
	          this.mostraExclusao = false;
	        } else {
	          this.mostraInclusao = false;
	        }
	        if (this.analiseUsu.length === this.revisaoUsu.length) {
	          this.mostraExclusao = false;
	        }
	      }
	      this.adicionados = (0, _deepObjectDiff.detailedDiff)(this.analise, this.revisao).added;
	      this.excluidos = _.differenceBy(this.analise.usuario, this.revisao.usuario, 'ds_nome_usuario');
	      if (this.adicionados) {
	        if (this.adicionados.usuarios) {
	          this.inclUsu = this.adicionados.usuarios;
	          this.inclUsuTexto = _.map(this.inclUsu, 'ds_nome_usuario');
	          this.naoExisteUsu = false;
	        } else {
	          this.naoExisteUsu = true;
	        }
	      }
	      if (this.excluidos) {
	        this.excUsuTexto = _.map(this.excluidos, 'ds_nome_usuario');
	      }
	      if (this.indiceAlt !== -1) {
	        this.mostraAlteracao = true;
	        this.texto = this.diferencaUsu.usuarios[this.indiceAlt];
	        if (this.isTrue(this.texto.bt_ativo)) {
	          this.texto.bt_ativo = 'Ativo';
	        } else {
	          this.texto.bt_ativo = 'Inativo';
	        }
	      } else {
	        this.texto = [];
	        this.mostraAlteracao = false;
	      }
	    },
	    mudaUsuario: function mudaUsuario() {
	      this.mudancas = this.mudaUsuario.usuarios;
	      if (this.mudancas) {
	        if (_.findKey(this.mudancas, 'ds_nome_usuario')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_nome_usuario');
	        }
	        if (_.findKey(this.mudancas, 'ds_telefone')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_telefone');
	        }
	        if (_.findKey(this.mudancas, 'ds_email')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_email');
	        }
	        if (_.findKey(this.mudancas, 'ds_login')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'ds_login');
	        }
	        if (_.findKey(this.mudancas, 'bt_ativo')) {
	          this.indiceAlt = _.findKey(this.mudancas, 'bt_ativo');
	        }
	        if (this.indiceAlt !== -1) {
	          this.mostraAlteracao = true;
	          this.texto = this.diferencaUsu.usuarios[this.indiceAlt];
	        } else {
	          this.mostraAlteracao = false;
	        }
	      }
	    }
	  },
	  computed: {
	    rows: function rows() {
	      return this.table.items.length;
	    }
	  },
	  created: function created() {},
	
	  methods: {
	    isTrue: function isTrue(v) {
	      return v === true || v === 1 || v === '1' || v === 'true';
	    },
	    inativosMostrarOcultar: function inativosMostrarOcultar(item) {
	      if (this.inativosOcultados) {
	        if (item.bt_ativo === 0 || item.bt_ativo === '0') return 'linha_ocultada';
	      } else {
	        if (!item.bt_ativo) return '';
	      }
	    },
	    onNew: function onNew() {
	      this.usuario = {};
	      this.state = 'FORM';
	      this.curIndex = -1;
	      this.editandoIndex = null;
	      this.bloqueioCampos = false;
	      this.jaExisteEmail = false;
	      this.jaExisteLogin = false;
	    },
	    onCancel: function onCancel() {
	      this.state = 'GRID';
	      this.curIndex = -1;
	      this.bloqueioCampos = false;
	    },
	    onAdd: function onAdd() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          if (_this.editandoIndex !== null) {
	            _this.table.items[_this.editandoIndex] = _this.usuario;
	
	            _this.$refs.tabelaUsuarios.refresh();
	          } else {
	            if (_this.jaExisteEmail === false && _this.jaExisteLogin === false) {
	              _this.table.items.push(_this.usuario);
	            } else {
	              if (_this.jaExisteEmail === true) {
	                _this.$snotify.error('O E-mail informado já existe. Favor verificar!');
	                return;
	              } else if (_this.jaExisteLogin === true) {
	                _this.$snotify.error('O Login já existe. Favor verificar!');
	                return;
	              }
	            }
	          }
	          _this.$forceUpdate();
	          _this.onCancel();
	        }
	      });
	    },
	    edita: function edita(row) {
	      if (this.$route.params.entidade) {
	        this.statusEntidade = this.$route.params.entidade.ds_status;
	      }
	      if (this.$route.params.parceiro) {
	        this.parceiro = this.$route.params.parceiro;
	      }
	      if (this.statusEntidade === 'COMPLETO' && row.item.id) {
	        this.bloqueioCampos = true;
	        this.$forceUpdate();
	      } else {
	        this.bloqueioCampos = false;
	        this.$forceUpdate();
	      }
	      if (this.parceiro) {
	        if (row.item.id) {
	          this.bloqueioCampos = true;
	          this.$forceUpdate();
	        }
	      }
	      if (row.item.id) {
	        this.bloqueioCampos = true;
	        this.$forceUpdate();
	      }
	      if (this.statusEntidade === 'INCOMPLETO') {
	        this.bloqueioCampos = false;
	      }
	      this.state = 'FORM';
	      this.editandoIndex = row.index;
	      this.usuario = _.cloneDeep(row.item);
	      if (this.mostraInclusao === true) {
	        this.mudancas = _.cloneDeep(this.usuarios[row.index]);
	      } else {
	        this.mudancas = _.cloneDeep(this.mudaUsuario.usuarios[row.index]);
	      }
	      this.$forceUpdate();
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	    },
	    verificaUsuario: function verificaUsuario(parametro, valor) {
	      var _this2 = this;
	
	      this.verificandoLoginEmail = true;
	      if (this.usuario.ds_login) {
	        axiosLaravel.post('/verifica-usuario/', { 'parametro': parametro, 'valor': valor }).then(function (response) {
	          if (response.data.length > 0) {
	            var campo = parametro === 'ds_login' ? 'login' : parametro === 'ds_email' ? 'email' : 'erro';
	            _this2.jaExisteLogin = true;
	            var field = _this2.$validator.fields.find({ name: campo });
	            field.setFlags({ invalid: true });
	            _this2.errors.add({ field: campo, msg: 'Este ' + campo + ' já esta sendo usado no sistema. Favor alterar.', id: field.id, scope: field.scope });
	          } else {
	            _this2.verificandoLoginEmail = false;
	            _this2.jaExisteLogin = false;
	          }
	          _this2.$forceUpdate();
	        }).catch(function (error) {
	          if (error) {
	            _this2.$root.trataErro(error);
	          }
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(109);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _html2pdf = __webpack_require__(140);
	
	var _html2pdf2 = _interopRequireDefault(_html2pdf);
	
	var _vuex = __webpack_require__(3);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'relatorio-analise',
	  components: {
	    PublicoAlvo: _publicoAlvo2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default
	  },
	  data: function data() {
	    return {
	      etapaCarga: [],
	      mostrarLogCarga: false,
	      mostrarAviso: false,
	      showgrid: true,
	      somenteLeitura: true,
	
	      riscoCalculado: '',
	      relatorioAnalise: {
	        itensFbb: [],
	        itensContrapartida: [],
	        itensParceiro: [],
	        dirigentes: [],
	        ds_regularidade_rating: {
	          ds_descricao: null
	        },
	        ds_indicadores_resultado: null,
	        ds_acoes_comunicacao: null,
	        ds_indicadores_publico: []
	      },
	      loading: {
	        show: false
	      },
	      contra: {
	        conta: {
	          obs: ''
	        }
	      },
	      editavel: false,
	      ds_regularidade_ratingSim: false,
	      ds_execucao_prazoSim: false,
	      ds_execucao_relatoriosSim: false,
	      ds_indicadores_participantesSim: false,
	      ds_enquadramento_fepSim: false,
	      adiantamento: [],
	      todasPropostas: [],
	      ds_indicadores_participantesCiente: false,
	      proposta: {},
	      projetoSuperior: '',
	      participantes: 0,
	      opcoes: ['Sim', 'Não', 'N/A'],
	      totalFBB: 0,
	      totalContrapartida: 0,
	      totalParceiro: 0,
	      meta: {},
	      perguntas: {},
	      metaIndex: [],
	      publicosAlvo: {},
	      publico: [],
	      formasContratacao: [],
	      editando: '',
	      contrapartida: [{
	        item: null,
	        valor: null
	      }],
	      faixasInvestimento: [{ faixa: 1, de: 0, para: 100000, alcada: 'Comitê de Desenvolvimento Social' }, { faixa: 2, de: 100000.01, para: 299999.99, alcada: 'Comitê de Desenvolvimento Social' }, { faixa: 3, de: 300000, para: 1000000000, alcada: 'Comitê Estratégico' }],
	      ehPIS: false,
	      ehVoluntariado: false,
	      ehEditalMN: false,
	      faixaDoProjeto: {},
	      formaJuridica: '',
	      atividadeForm: {
	        nr_periodo_final: null,
	        itens_orcamentos: [],
	        metas: {},
	        ds_nome: '',
	        nr_periodo_inicial: null,
	        ds_documento_comprobatorio: ''
	      },
	      atividadeTabela: {},
	      opcao_qtde_assinaturas: 3,
	      odsCadastrado: [],
	      odsSelecionado: [],
	      tecSocialCadastrado: [],
	      publicoAlvoCadastrado: [],
	      odsTodaBase: [],
	      tecnologiasCadastradas: [],
	      publicoAlvoPrevisto: [],
	      publicoAlvoDefinicoes: [],
	      definicaoPublicoAlvo: [],
	      possuiTecnologiaSocial: false,
	      questoesAvaliacao: [],
	      ehSimplificada: false
	    };
	  },
	
	  props: ['propsProposta'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    indicadoresResultadoLista: function indicadoresResultadoLista() {
	      var lista = this.proposta && this.proposta.dados ? this.proposta.dados.indicadores_resultado : null;
	      return Array.isArray(lista) ? lista : [];
	    },
	    parcelasAdiantamentoExibicao: function parcelasAdiantamentoExibicao() {
	      return this.consolidarParcelasAdiantamento(this.proposta.adiantamentos || []);
	    },
	    exibeDesdobramentoParcelas: function exibeDesdobramentoParcelas() {
	      return this.haParcelaMista(this.parcelasAdiantamentoExibicao);
	    },
	    totalParcelasAdiantamentoFundacao: function totalParcelasAdiantamentoFundacao() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_fbb');
	    },
	    totalParcelasAdiantamentoParceiro: function totalParcelasAdiantamentoParceiro() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_parc');
	    },
	    totalParcelasAdiantamentoGeral: function totalParcelasAdiantamentoGeral() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao);
	    },
	
	    dataFinalProjeto: function dataFinalProjeto() {
	      if (this.proposta.dt_assinatura_convenio) {
	        return (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(this.proposta.periodo_vigencia, 'M').format('MM/YYYY');
	      } else {
	        if (this.proposta.dt_data_inicial) {
	          return (0, _moment2.default)(this.proposta.dt_data_inicial).add(this.proposta.periodo_vigencia, 'M').format('MM/YYYY');
	        }
	      }
	    }
	  }),
	  watch: {
	    propsProposta: function propsProposta() {
	      this.proposta = this.propsProposta;
	    }
	  },
	  mounted: function mounted() {},
	
	  created: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return this.carregarRelatorio();
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function created() {
	      return _ref.apply(this, arguments);
	    }
	
	    return created;
	  }(),
	  methods: {
	    carregarRelatorio: function carregarRelatorio() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.loading.show = true;
	                _this.mostrarLogCarga = true;
	
	                _context2.prev = 2;
	                _context2.next = 5;
	                return _this.buscaPublicoAlvo();
	
	              case 5:
	                _context2.next = 10;
	                break;
	
	              case 7:
	                _context2.prev = 7;
	                _context2.t0 = _context2['catch'](2);
	                console.error('Erro em buscaPublicoAlvo', _context2.t0);
	
	              case 10:
	                _context2.prev = 10;
	                _context2.next = 13;
	                return _this.buscarBaseODS();
	
	              case 13:
	                _context2.next = 18;
	                break;
	
	              case 15:
	                _context2.prev = 15;
	                _context2.t1 = _context2['catch'](10);
	                console.error('Erro em buscarBaseODS', _context2.t1);
	
	              case 18:
	                _context2.prev = 18;
	                _context2.next = 21;
	                return _this.consultaTecnologiasCadastradas();
	
	              case 21:
	                _context2.next = 26;
	                break;
	
	              case 23:
	                _context2.prev = 23;
	                _context2.t2 = _context2['catch'](18);
	                console.error('Erro em consultaTecnologiasCadastradas', _context2.t2);
	
	              case 26:
	                _context2.prev = 26;
	                _context2.next = 29;
	                return _this.buscaDefinicaoPublicoAlvo();
	
	              case 29:
	                _context2.next = 34;
	                break;
	
	              case 31:
	                _context2.prev = 31;
	                _context2.t3 = _context2['catch'](26);
	                console.error('Erro em buscaDefinicaoPublicoAlvo', _context2.t3);
	
	              case 34:
	                _context2.prev = 34;
	                _context2.next = 37;
	                return _this.buscaIndicadorAvaliacao();
	
	              case 37:
	                _context2.next = 42;
	                break;
	
	              case 39:
	                _context2.prev = 39;
	                _context2.t4 = _context2['catch'](34);
	                console.error('Erro em buscaIndicadorAvaliacao', _context2.t4);
	
	              case 42:
	                _context2.prev = 42;
	                _context2.next = 45;
	                return _this.buscaPropostaSimplificada();
	
	              case 45:
	                _context2.next = 50;
	                break;
	
	              case 47:
	                _context2.prev = 47;
	                _context2.t5 = _context2['catch'](42);
	                console.error('Erro em buscaPropostaSimplificada', _context2.t5);
	
	              case 50:
	                _context2.prev = 50;
	                _context2.next = 53;
	                return _this.buscaProposta();
	
	              case 53:
	                _context2.next = 58;
	                break;
	
	              case 55:
	                _context2.prev = 55;
	                _context2.t6 = _context2['catch'](50);
	                console.error('Erro em buscaProposta', _context2.t6);
	
	              case 58:
	                _context2.prev = 58;
	                _context2.next = 61;
	                return _this.carregarProjetoDuplicador();
	
	              case 61:
	                _context2.next = 66;
	                break;
	
	              case 63:
	                _context2.prev = 63;
	                _context2.t7 = _context2['catch'](58);
	                console.error('Erro em carregarProjetoDuplicador', _context2.t7);
	
	              case 66:
	                _context2.prev = 66;
	                _context2.next = 69;
	                return _this.buscaEntidades();
	
	              case 69:
	                _context2.next = 74;
	                break;
	
	              case 71:
	                _context2.prev = 71;
	                _context2.t8 = _context2['catch'](66);
	                console.error('Erro em buscaEntidades', _context2.t8);
	
	              case 74:
	
	                if (_this.verificaErro()) {
	                  _this.mostrarLogCarga = true;
	                  _this.mostrarAviso = true;
	                } else {
	                  _this.mostrarLogCarga = false;
	                }
	
	              case 75:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this, [[2, 7], [10, 15], [18, 23], [26, 31], [34, 39], [42, 47], [50, 55], [58, 63], [66, 71]]);
	      }))();
	    },
	    closewindow: function closewindow() {
	      close();
	    },
	    gerenciaRequisicao: function gerenciaRequisicao(nome, status) {
	      var erro = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var existente = this.etapaCarga.find(function (item) {
	        return item.nome === nome;
	      });
	      if (existente) {
	        existente.status = status;
	        if (status === 'ERRO') {
	          existente.erro = erro;
	          this.mostrarLogCarga = true;
	          this.mostrarAviso = true;
	        }
	      } else {
	        this.etapaCarga.push({ nome: nome, status: status });
	      }
	    },
	    verificaErro: function verificaErro() {
	      return this.etapaCarga.some(function (objeto) {
	        return objeto.status === 'ERRO';
	      });
	    },
	    recarregarRelatorio: function recarregarRelatorio() {
	      window.location.reload();
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    haObjetivoMeta: function haObjetivoMeta(listaOrigem, vinculo, descricao) {
	      var c = 0;
	      _.forEach(_.map(listaOrigem, vinculo), function (o) {
	        _.forEach(o, function (d) {
	          c += _.has(d, 'ds_descricao') && d.ds_descricao === descricao || _.has(d, 'descricao') && d.descricao === descricao ? 1 : 0;
	        });
	      });
	      return c > 0;
	    },
	    buscaProposta: function buscaProposta() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this2.gerenciaRequisicao('Relatório de Análise', 'Carregando');
	                _this2.loading.show = true;
	                _context5.next = 4;
	                return axiosLaravel.get('propostas/' + _this2.$route.params.id).then(function () {
	                  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(response) {
	                    var metas, objetivosFormatado, objetivoGeral, objetivoEspecificoFinal, metasFormatado, metasFinal, itemFBB, itemParceria, agrupadoContasFBB, contasValorFBB, agrupadoContasParcerias, contasValorParcerias, somenteComContaFinanceira, ordenado, ordenadoAgrupado, key, myNewArray, i, totalProjeto;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            _this2.proposta = response.data;
	                            if (_this2.proposta.relatorio_analise) {
	                              _this2.relatorioAnalise = JSON.parse(_this2.proposta.relatorio_analise);
	                            }
	
	                            _context4.next = 4;
	                            return axiosLaravel.put('propostas/' + _this2.$route.params.id + '/calcula-risco').then(function () {
	                              var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(response) {
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        _this2.riscoCalculado = response.data;
	                                        _this2.$forceUpdate();
	
	                                      case 2:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref3.apply(this, arguments);
	                              };
	                            }());
	
	                          case 4:
	
	                            _this2.proposta['projetoAprovado'] = _.has(_this2.proposta, 'ds_situacao_erp') && !_.isNull(_this2.proposta.ds_situacao_erp) && !_.includes(['ANA', 'DEF', 'ANU', 'CAN', 'IND', 'ENC', 'DLG', 'JUD', 'OPE'], _this2.proposta.ds_situacao_erp);
	                            metas = [];
	                            objetivosFormatado = '';
	                            objetivoGeral = '';
	                            objetivoEspecificoFinal = '';
	                            metasFormatado = '';
	                            metasFinal = '';
	
	                            if (_this2.proposta.ds_indicadores_resultado) {
	                              _this2.relatorioAnalise.ds_indicadores_resultado = _.cloneDeep(_this2.proposta.ds_indicadores_resultado);
	                            }
	                            if (_this2.proposta.ds_acoes_comunicacao) {
	                              _this2.relatorioAnalise.ds_acoes_comunicacao = _.cloneDeep(_this2.proposta.ds_acoes_comunicacao);
	                            }
	                            if (_this2.proposta.questionario_respostas) {
	                              if (_this2.proposta.questionario_respostas.rating) {
	                                _this2.relatorioAnalise.ds_regularidade_rating = _this2.proposta.questionario_respostas.rating;
	                              }
	                            }
	                            if (_this2.proposta.ds_numero_fep) {
	                              _this2.relatorioAnalise.ds_enquadramento_fep = _this2.proposta.ds_numero_fep;
	                            }
	                            itemFBB = [];
	                            itemParceria = [];
	
	                            _this2.proposta.atividades.forEach(function (atividade) {
	                              if (atividade.itens_orcamentos) {
	                                atividade.itens_orcamentos.forEach(function (item) {
	                                  if ('' + item.origem === '1') {
	                                    _this2.relatorioAnalise.itensFbb.push(item);
	                                    itemFBB.push(item);
	                                    _this2.totalFBB += item.valor_unitario * item.quantidade;
	                                  }
	                                  if ('' + item.origem === '2') {
	                                    if (_this2.relatorioAnalise.itensContrapartida) {
	                                      _this2.relatorioAnalise.itensContrapartida.push(item);
	                                    } else {
	                                      for (var i = 0; i < _this2.relatorioAnalise.itensContrapartida.length; i++) {
	                                        if (_this2.relatorioAnalise.itensContrapartida[i].item.obs === null) {
	                                          _this2.relatorioAnalise.itensContrapartida[i].item.obs = '';
	                                        }
	                                      }
	                                    }
	                                    _this2.totalContrapartida += item.valor_unitario * item.quantidade;
	                                  }
	                                  if ('' + item.origem === '5') {
	                                    _this2.relatorioAnalise.itensParceiro.push(item);
	                                    itemParceria.push(item);
	                                    _this2.totalParceiro += item.valor_unitario * item.quantidade;
	                                  }
	                                });
	                              }
	                            });
	                            agrupadoContasFBB = _.groupBy(itemFBB, function (g) {
	                              return g.conta_financeira.descricao;
	                            });
	                            contasValorFBB = [];
	
	                            _.forEach(agrupadoContasFBB, function (conta, contaNome) {
	                              contasValorFBB.push({ 'conta': contaNome, 'valor': _.sumBy(conta, function (item) {
	                                  return parseFloat(parseFloat(item.quantidade) * parseFloat(item.valor_unitario));
	                                }) });
	                            });
	                            _this2.relatorioAnalise.itensFbb = contasValorFBB;
	                            agrupadoContasParcerias = _.groupBy(itemParceria, function (g) {
	                              return g.conta_financeira.descricao;
	                            });
	                            contasValorParcerias = [];
	
	                            _.forEach(agrupadoContasParcerias, function (conta, contaNome) {
	                              contasValorParcerias.push({ 'conta': contaNome, 'valor': _.sumBy(conta, function (item) {
	                                  return parseFloat(parseFloat(item.quantidade) * parseFloat(item.valor_unitario));
	                                }) });
	                            });
	                            _this2.relatorioAnalise.itensParceiro = contasValorParcerias;
	                            somenteComContaFinanceira = _.filter(_this2.relatorioAnalise.itensContrapartida, function (c) {
	                              return _.has(c.conta_financeira, 'numero_conta') && _.has(c.conta_financeira, 'descricao');
	                            });
	                            ordenado = _.sortBy(somenteComContaFinanceira, ['item.ds_code']);
	                            ordenadoAgrupado = _.groupBy(ordenado, function (value) {
	                              return value.conta_financeira.descricao;
	                            });
	
	                            for (key in ordenadoAgrupado) {
	                              ordenadoAgrupado[key] = ordenadoAgrupado[key].reduce(function (acc, curr) {
	                                acc[curr.item.ds_code + ' - ' + curr.item.ds_description] ? acc[curr.item.ds_code + ' - ' + curr.item.ds_description] += curr.valor_unitario * curr.quantidade : acc[curr.item.ds_code + ' - ' + curr.item.ds_description] = curr.valor_unitario * curr.quantidade;
	                                return acc;
	                              }, []);
	                            }
	                            myNewArray = [];
	
	                            myNewArray = _.map(ordenadoAgrupado, function (item, key) {
	                              return {
	                                conta: key,
	                                item: _.mapValues(item, function (value, key) {
	                                  return {
	                                    item: key,
	                                    valor: value
	                                  };
	                                })
	                              };
	                            });
	                            _this2.relatorioAnalise.itensContrapartida = _.cloneDeep(myNewArray);
	                            objetivosFormatado = _.map(_this2.proposta.objetivos, 'ds_descricao');
	                            objetivosFormatado = objetivosFormatado.join(',');
	                            objetivoEspecificoFinal = 'Objetivo(s) Específico(s): \n' + objetivosFormatado.split(',').join('\n');
	                            objetivoGeral = 'Objetivo Geral: \n' + _this2.proposta.ds_objetivo_geral;
	
	                            _this2.proposta.metas.forEach(function (meta) {
	                              metas.push(meta.ds_descricao);
	                            });
	                            metasFormatado = _.map(metas).join(',');
	                            metasFinal = 'Meta(s): \n' + metasFormatado.split(',').join('\n');
	
	                            _this2.relatorioAnalise.ds_indicadores_resumo = objetivoGeral + '\n\n' + objetivoEspecificoFinal + '\n\n' + metasFinal;
	                            if (_this2.proposta.publicos_alvo) {
	                              for (i = 0; i < _this2.proposta.publicos_alvo.length; i++) {
	                                _this2.participantes = _this2.participantes + _this2.proposta.publicos_alvo[i].nr_participantes_diretos;
	                              }
	                              _this2.relatorioAnalise.ds_indicadores_participantes = parseInt(_this2.participantes);
	                              _this2.relatorioAnalise.ds_indicadores_publico = _this2.proposta.publicos_alvo[0].fonte;
	                            }
	
	                            _this2.relatorioAnalise.ds_execucao_prazo = _this2.proposta.nr_periodos;
	                            _this2.relatorioAnalise.ds_execucao_relatorios = _this2.proposta.ds_periodicidade_formulario;
	                            if (_this2.proposta.ds_alcada) {
	                              _this2.relatorioAnalise.ds_alcada = _this2.proposta.ds_alcada;
	                            }
	                            totalProjeto = _this2.totalFBB + _this2.totalParceiro;
	
	                            _this2.faixaDoProjeto = _.find(_this2.faixasInvestimento, function (faixa) {
	                              return faixa.de <= totalProjeto && totalProjeto <= faixa.para;
	                            });
	
	                            if (_.includes([1, 2], _this2.faixaDoProjeto.faixa)) {
	                              _this2.riscoCalculado = 'C';
	                            }
	                            _this2.$forceUpdate();
	                            _this2.gerenciaRequisicao('Relatório de Análise', 'OK');
	                            _this2.loading.show = false;
	
	                          case 51:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this2.gerenciaRequisicao('Relatório de Análise', 'ERRO', error);
	                  _this2.loading.show = false;
	                  console.log('ERRO: ', error);
	                  _this2.$root.trataErro(error);
	                  console.log('ERRO: ', error);
	                });
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }))();
	    },
	    carregarProjetoDuplicador: function carregarProjetoDuplicador() {
	      var _this3 = this;
	
	      this.gerenciaRequisicao('Projeto Duplicador', 'Carregando');
	      axiosLaravel.get('projeto/sapiens/' + this.proposta.nr_projeto_duplicacao).then(function (response) {
	        _this3.proposta['duplicadorSapiens'] = response.data[0];
	        _this3.carregarProjetoSuperior();
	        _this3.gerenciaRequisicao('Projeto Duplicador', 'OK');
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.gerenciaRequisicao('Projeto Duplicador', 'ERRO', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    carregarProjetoSuperior: function carregarProjetoSuperior() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this4.gerenciaRequisicao('Projeto Superior', 'Carregando');
	                _context6.next = 3;
	                return axiosLaravel.get('projeto/sapiens/' + _this4.proposta.duplicadorSapiens.prjsup).then(function (response) {
	                  _this4.proposta['superiorSapiens'] = response.data[0];
	                  _this4.projetoSuperior = _this4.proposta.superiorSapiens.numprj + ' - ' + _this4.proposta.superiorSapiens.nomprj;
	
	                  _this4.ehPIS = _.includes(['15114', '15120', '15126', '15132', '15094', '15575', '18140', '18206'], '' + _this4.proposta.superiorSapiens.numprj);
	                  _this4.ehEditalMN = _.includes(['18286'], '' + _this4.proposta.superiorSapiens.numprj);
	                  _this4.ehVoluntariado = _.includes(['15577', '18182'], '' + _this4.proposta.superiorSapiens.numprj);
	                  _this4.gerenciaRequisicao('Projeto Superior', 'OK');
	                }).catch(function (error) {
	                  _this4.gerenciaRequisicao('Projeto Superior', 'ERRO', error);
	                  _this4.$snotify.clear();
	                  _this4.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this4);
	      }))();
	    },
	    buscarBaseODS: function buscarBaseODS() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this5.loading.show = true;
	                _this5.gerenciaRequisicao('ODS', 'Carregando');
	                _context7.next = 4;
	                return axiosLaravel.get('/ods').then(function (response) {
	                  _this5.initListaODS(response.data);
	                  _this5.carregarODS();
	
	                  _this5.$forceUpdate();
	                }).catch(function (error) {
	                  _this5.gerenciaRequisicao('ODS', 'ERRO', error);
	                  _this5.$root.trataErro(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this5);
	      }))();
	    },
	    buscaPropostaSimplificada: function buscaPropostaSimplificada() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this6.gerenciaRequisicao('Ver. Prop. Simplificada', 'Carregando');
	                _this6.loading.show = true;
	                console.log('BUSCA PROPOSTA SIMPLIFICADA');
	                _context8.next = 5;
	                return axiosLaravel.get('/simplificado/verificaPropostaSimplificada/' + _this6.$route.params.id).then(function (response) {
	                  _this6.ehSimplificada = response.data.simplificado === 1;
	                  console.log('ehSimplificada: ', _this6.ehSimplificada);
	                  _this6.$forceUpdate();
	                  _this6.gerenciaRequisicao('Ver. Prop. Simplificada', 'OK');
	                }).catch(function (error) {
	                  _this6.gerenciaRequisicao('Ver. Prop. Simplificada', 'ERRO', error);
	                  _this6.loading.show = false;
	                  _this6.$root.trataErro(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this6);
	      }))();
	    },
	    initListaODS: function initListaODS(lista) {
	      var _this7 = this;
	
	      var ods = lista;
	      ods.forEach(function (itemODS) {
	        var odsItem = {
	          odsId: itemODS.id,
	          ods: itemODS.descricao,
	          metas: []
	        };
	        itemODS.metas.forEach(function (meta) {
	          var metaItem = {
	            numeroMeta: meta.numero_meta,
	            descricao: meta.descricao,
	            odsFk: meta.ods_fk
	          };
	          odsItem.metas.push(metaItem);
	        });
	        _this7.odsTodaBase.push(odsItem);
	        _this7.$forceUpdate();
	      });
	    },
	    carregarODS: function carregarODS() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _context9.next = 2;
	                return axiosLaravel.get('/ods/getMetasODS/' + _this8.$route.params.id).then(function (response) {
	                  var cadastro = response.data;
	                  _this8.loading.show = true;
	                  if (cadastro.length > 0) {
	                    var idsODs = [].concat((0, _toConsumableArray3.default)(new _set2.default(cadastro.map(function (item) {
	                      return item.ods_fk;
	                    }))));
	                    idsODs.forEach(function (id) {
	                      var ods = {
	                        idOds: id,
	                        descricao: '',
	                        metas: ''
	                      };
	                      _this8.odsTodaBase.forEach(function (item) {
	                        if (item.odsId === Number(id)) {
	                          ods.descricao = item.ods;
	                        }
	                      });
	                      cadastro.forEach(function (selecionado) {
	                        if (selecionado.ods_fk === id) {
	                          ods.metas = ods.metas + ', ' + selecionado.numero_meta;
	                        }
	                      });
	                      ods.metas = ods.metas.substring(1);
	                      _this8.odsCadastrado.push(ods);
	                    });
	                    _this8.$forceUpdate();
	                    _this8.loading.show = true;
	                    _this8.odsCadastrado.forEach(function (ods) {
	                      var metas = ods.metas.split(', ');
	                      var metasDescricao = [];
	                      metas.forEach(function (meta) {
	                        var selecionado = {
	                          descricao: '',
	                          numeroMeta: '',
	                          odsFk: ods.idOds
	                        };
	                        selecionado.numeroMeta = meta.trim();
	                        _this8.odsTodaBase.forEach(function (ods) {
	                          ods.metas.forEach(function (meta) {
	                            if (meta.numeroMeta === selecionado.numeroMeta) {
	                              selecionado.descricao = meta.descricao;
	                            }
	                          });
	                        });
	                        metasDescricao.push(selecionado);
	                      });
	                      ods.metasDescricao = metasDescricao;
	                    });
	                  } else {
	                    _this8.odsCadastrado = [];
	                  }
	                  _this8.gerenciaRequisicao('ODS', 'OK');
	                }).catch(function (error) {
	                  _this8.gerenciaRequisicao('ODS', 'ERRO', error);
	                  _this8.$snotify.clear();
	                  _this8.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this8);
	      }))();
	    },
	    consultaTecnologiasCadastradas: function consultaTecnologiasCadastradas() {
	      var _this9 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _this9.loading.show = true;
	                _this9.gerenciaRequisicao('Tecnologias Sociais', 'Carregando');
	                _context10.next = 4;
	                return axiosLaravel.get('/tecnologiasocial/consultarTecnologiaPorProposta/' + _this9.$route.params.id).then(function (response) {
	                  _this9.tecnologiasCadastradas = response.data;
	                  if (response.data.length > 0) {
	                    _this9.possuiTecnologiaSocial = true;
	                  } else {
	                    _this9.possuiTecnologiaSocial = false;
	                  }
	
	                  _this9.gerenciaRequisicao('Tecnologias Sociais', 'OK');
	                  _this9.$forceUpdate();
	                }).catch(function (error) {
	                  _this9.gerenciaRequisicao('Tecnologias Sociais', 'ERRO', error);
	                  _this9.$root.trataErro(error);
	                  _this9.loading.show = false;
	                  _this9.$forceUpdate();
	                });
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this9);
	      }))();
	    },
	    buscaDefinicaoPublicoAlvo: function buscaDefinicaoPublicoAlvo() {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _this10.loading.show = true;
	                _this10.gerenciaRequisicao('Público-Alvo Previsto', 'Carregando');
	                _context11.next = 4;
	                return axiosLaravel.get('definicaoparticipante').then(function (response) {
	                  _this10.definicaoPublicoAlvo = response.data;
	                  _this10.buscaPublicoAlvoPrevisto();
	                }).catch(function (error) {
	                  _this10.gerenciaRequisicao('Público-Alvo Previsto', 'ERRO', error);
	                  _this10.$root.trataErro(error);
	                  _this10.loading.show = false;
	                });
	
	              case 4:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this10);
	      }))();
	    },
	    buscaPublicoAlvoPrevisto: function buscaPublicoAlvoPrevisto() {
	      var _this11 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _this11.loading.show = true;
	                _context12.next = 3;
	                return axiosLaravel.get('/definicaoparticipante/getPrevistosProjeto/' + _this11.$route.params.id).then(function (response) {
	                  _this11.publicoAlvoPrevisto = response.data;
	                  _this11.publicoAlvoPrevisto.forEach(function (item) {
	                    _this11.definicaoPublicoAlvo.forEach(function (definicao) {
	                      definicao.subgrupos.forEach(function (subgrupo) {
	                        if (subgrupo.id === item) {
	                          _this11.publicoAlvoDefinicoes.push(subgrupo.subgrupo);
	                        }
	                      });
	                    });
	                  });
	                  _this11.gerenciaRequisicao('Público-Alvo Previsto', 'OK');
	                  _this11.$forceUpdate();
	                }).catch(function (error) {
	                  _this11.gerenciaRequisicao('Público-Alvo Previsto', 'ERRO', error);
	                  _this11.$root.trataErro(error);
	                  _this11.loading.show = false;
	                  _this11.$forceUpdate();
	                });
	
	              case 3:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this11);
	      }))();
	    },
	    buscaIndicadorAvaliacao: function buscaIndicadorAvaliacao() {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _this12.loading.show = true;
	                _this12.gerenciaRequisicao('Indicadores de Avaliação', 'Carregando');
	                _context13.next = 4;
	                return axiosLaravel.get('/avaliacao/carregarRespostasRelatorioAnalise/' + _this12.$route.params.id).then(function (response) {
	                  _this12.questoesAvaliacao = response.data;
	
	                  _this12.gerenciaRequisicao('Indicadores de Avaliação', 'OK');
	                  _this12.$forceUpdate();
	                }).catch(function (error) {
	                  _this12.gerenciaRequisicao('Indicadores de Avaliação', 'ERRO', error);
	                  _this12.$root.trataErro(error);
	                  _this12.loading.show = false;
	                  _this12.$forceUpdate();
	                });
	
	              case 4:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this12);
	      }))();
	    },
	    buscaEntidades: function buscaEntidades() {
	      var _this13 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
	        var currentDate, hoje;
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _this13.gerenciaRequisicao('Entidade', 'Carregando');
	                currentDate = new Date();
	                hoje = (0, _moment2.default)(currentDate).format('YYYYMMDD');
	                _context14.next = 5;
	                return axiosLaravel.get('entidades/' + _this13.proposta.entidade.id).then(function (response) {
	                  console.log('BUSCA ENTIDADES', response.data);
	                  _this13.proposta.entidade = response.data;
	                  var codigo = _this13.proposta.entidade.fk_forma_juridica;
	                  var descricao = _this13.ehNulo(_.find(_this13.$store.state.formasJuridicas, ['codigo', codigo])['descricao'], '!');
	                  _this13.formaJuridica = codigo + ' - ' + descricao;
	                  var isTrue = function isTrue(v) {
	                    return v === true || v === 1 || v === '1' || v === 'true';
	                  };
	                  var array = _.filter(response.data.dirigentes, function (o) {
	                    if (isTrue(o.bt_assinatura_entidade) && isTrue(o.bt_ativo) && isTrue(o.bt_representante_legal) && isTrue(o.bt_assinatura_requerida)) {
	                      var dataInicial = (0, _moment2.default)(o.dt_inicio_mandato).format('YYYYMMDD');
	                      var dataFinal = (0, _moment2.default)(o.dt_fim_mandato).format('YYYYMMDD');
	                      if (dataInicial <= hoje && hoje <= dataFinal) {
	                        o.ds_cpf = ('00000000000' + o.ds_cpf).slice(-11);
	                        return o;
	                      }
	                    }
	                  });
	                  _this13.proposta.entidade.dirigentes = array;
	                  _this13.$forceUpdate();
	                }).catch(function (error) {
	                  if (error) {
	                    _this13.$snotify.clear();
	                    _this13.$root.trataErro(error);
	                    console.log('ERRO: ', error);
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this13);
	      }))();
	    },
	    buscaPublicoAlvo: function buscaPublicoAlvo() {
	      var _this14 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                _this14.gerenciaRequisicao('Público-Alvo Fonte', 'Carregando');
	                _context15.next = 3;
	                return axiosLaravel.get('publico-alvo-fonte').then(function (response) {
	                  _this14.publicosAlvo = response.data;
	                  _this14.gerenciaRequisicao('Público-Alvo Fonte', 'OK');
	                }).catch(function (error) {
	                  _this14.gerenciaRequisicao('Público-Alvo Fonte', 'ERRO', error);
	                  _this14.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this14);
	      }))();
	    },
	    buscaDadosProposta: function buscaDadosProposta() {
	      var _this15 = this;
	
	      if (this.proposta.entidade) {
	        var array = [];
	        axiosLaravel.get('/entidades/' + this.proposta.entidade.id + '/propostas').then(function (response) {
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].ds_codigo_projeto_erp !== null) {
	              array.push(response.data[i]);
	            }
	          }
	          _this15.todasPropostas = _.cloneDeep(array);
	          _this15.$forceUpdate();
	        }).catch(function (error) {
	          if (error) {
	            _this15.$snotify.clear();
	            _this15.$root.trataErro(error);
	          }
	        });
	      }
	    },
	    atualizaProposta: function atualizaProposta() {},
	    gravaRelatorio: function gravaRelatorio() {},
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    },
	    print: function print() {
	      var element = document.getElementById('relatorio_analise');
	      var opt = {
	        margin: 1,
	        filename: 'myfile.pdf',
	        image: { type: 'jpeg', quality: 0.98 },
	        html2canvas: { scale: 2 },
	        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
	      };
	      (0, _html2pdf2.default)(element, opt);
	    },
	    passaParams: function passaParams(data) {
	      for (var i = 0; i < this.relatorioAnalise.itensContrapartida.length; i++) {
	        if (data.conta === this.relatorioAnalise.itensContrapartida[i].conta) {
	          if (data.item.obs) {
	            this.relatorioAnalise.itensContrapartida[i].item.obs = data.item.obs;
	          }
	        }
	      }
	
	      this.$forceUpdate();
	    },
	    confirmacao: function confirmacao(event) {
	      if (event === true) {
	        this.$swal({
	          title: '<font color="red"><b>Confirmação!</b></font>',
	          html: '<div align="left"> Estou ciente do conteúdo retornado automaticamente pelo sistema.' + '</div>',
	          showCloseButton: true,
	          showCancelButton: false,
	          showLoaderOnConfirm: true,
	          focusConfirm: false
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'WidgetsIndex'
	};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ControlSidebar',
	  data: function data() {
	    return {
	      loading: true,
	      mesesDepois: 3,
	      agenda: [],
	      contador: {},
	      ocultarTipo: [],
	      usuariosLogados: [],
	      hoje: (0, _moment2.default)().format('YYYY-MM-DD'),
	      icones: { 'Mandato dirigente': 'fa-gavel', 'Acompanhamento': 'fa-pencil-square-o', 'Relatório de Execução': 'fa-calendar-check-o', 'Documento': 'fa-file-o' }
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    console.clear();
	    if (this.usuarioLogado.userType === 'FUNDACAO') {
	      axiosLaravel.get('vencimentos/listar/' + this.mesesDepois).then(function (response) {
	        _this.agenda = _.groupBy(response.data, 'data');
	        _this.contador = _.countBy(_.flatMap(_this.agenda), 'tipo');
	        _this.loading = false;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {
	    this.assinaUsuariosLogados();
	  },
	  methods: {
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    verificar: function verificar(item) {
	      if (item.tipo === 'Relatório de Execução') {
	        this.$router.push({ name: 'visualiza-relatorio-execucao', params: { id: item.proposta_id } });
	      } else if (_.includes(['Mandato dirigente', 'Documento'], item.tipo) && !_.isNull(item.entidade_id)) {
	        this.$router.push({ name: 'cadastro-entidade-edita', params: { id: item.entidade_id }, hash: item.tipo === 'Documento' ? '#documentos' : '#dirigentes' });
	      } else if (_.includes(['Acompanhamento', 'Documento'], item.tipo) && !_.isNull(item.projeto)) {
	        if (!_.isNaN(_.toNumber(item.projeto.substr(0, 5)))) {
	          this.$router.push({ name: 'projeto', params: { numero: item.projeto.substr(0, 5) } });
	        } else {
	          this.$router.push({ name: 'proposta-visualiza', params: { id: item.proposta_id } });
	        }
	      }
	      this.$refs.barraControle.classList.remove('control-sidebar-open');
	    },
	    filtrar: function filtrar(tipo) {
	      var op = void 0;
	      if (_.includes(this.ocultarTipo, tipo)) {
	        op = true;
	        _.remove(this.ocultarTipo, function (t) {
	          return t === tipo;
	        });
	      } else {
	        op = false;
	        this.ocultarTipo.push(tipo);
	      }
	      var map = _.flatMap(this.agenda);
	      _.forEach(map, function (i) {
	        if (i.tipo === tipo) {
	          _.set(i, 'mostrar', op);
	        }
	      });
	      this.contador = _.countBy(_.filter(map, function (m) {
	        return !_.has(map, 'mostrar') || map.mostrar;
	      }), 'tipo');
	      this.$forceUpdate();
	    },
	    origem: function origem(item) {
	      return item.tipo === 'Mandato dirigente' ? item.entidade : _.includes(['Relatório de Execução', 'Acompanhamento'], item.tipo) ? item.projeto : this.ehNulo(item.entidade, item.projeto);
	    },
	    dataFormat: function dataFormat(dt) {
	      return (0, _moment2.default)(dt).format('DD/MM/YYYY');
	    },
	    infoTooltip: function infoTooltip(item) {
	      var msg = this.origem(item) + '<hr>Em ' + this.dataFormat(item.data) + '<br/>';
	      msg += 'Vencimento de ' + (_.includes(['Documento', 'Acompanhamento'], item.tipo) ? item.subtipo : item.tipo === 'Mandato dirigente' ? 'mandato de ' + item.subtipo : item.tipo) + '<br/>';
	      msg += item.info + '</h5>';
	      return msg;
	    },
	    assinaUsuariosLogados: function assinaUsuariosLogados() {
	      var _this2 = this;
	
	      Echo.leave('usuarios-logados');
	      window.Echo.join('usuarios-logados').here(function (users) {
	        _this2.usuariosLogados = users;
	        _this2.$forceUpdate();
	      }).joining(function (user) {
	        _this2.usuariosLogados.push(user);
	      }).leaving(function (user) {
	        _this2.usuariosLogados.splice(_this2.usuariosLogados.findIndex(function (logado) {
	          return logado.id === user.id;
	        }), 1);
	      });
	    }
	  }
	};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DashboardFooter'
	};

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(124);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	var _laravelEcho = __webpack_require__(1559);
	
	var _laravelEcho2 = _interopRequireDefault(_laravelEcho);
	
	var _auth = __webpack_require__(146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.Pusher = __webpack_require__(1585);
	exports.default = {
	  name: 'DashboardHeader',
	  data: function data() {
	    return {
	      image: null,
	      usuarioLogado: JSON.parse(window.localStorage.usuario),
	      minutosRestanteNoPonto: 60
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var blob, reader, vm;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.conectaWebsocket();
	
	            case 2:
	              _this.conectaCanalGeral();
	              _this.conectaUsuariosLogados();
	              _this.conectaCanalUsuario();
	              _this.$forceUpdate();
	              blob = new Blob([_this.usuarioLogado.bl_foto], { type: 'image/png' });
	              reader = new FileReader();
	
	              reader.readAsDataURL(blob);
	              vm = _this;
	              _context.next = 12;
	              return function () {
	                var base64data = reader.result;
	                this.image = base64data;
	                vm.$forceUpdate();
	              };
	
	            case 12:
	              reader.onloadend = _context.sent;
	
	              _this.showAlertaPontoModal();
	              _context.next = 16;
	              return _this.atualizaLimitePonto();
	
	            case 16:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    buscaDadosJava: function buscaDadosJava() {
	      var _this2 = this;
	
	      axios.get('/proxy/account/principal').then(function (response) {
	        store.commit('SET_USER_DETAIL', response.data.value);
	        window.localStorage.setItem('user', (0, _stringify2.default)(response.data.value));
	      }).catch(function (error) {
	        _this2.error = error.response.data.responseInfo.reasons[0].detail;
	      });
	    },
	    barraAmbiente: function barraAmbiente() {
	      var url = window.location.href;
	      return _.includes(url, 'localhost') ? { 'cor': '#00ebd0', 'descricao': 'Ambiente de Testes' } : _.includes(url, 'sgphomologacao') ? { 'cor': '#54dcfc', 'descricao': 'Ambiente de Homologação' } : { 'cor': '#fcfc30', 'descricao': '' };
	    },
	
	    logout: function logout() {
	      var _this3 = this;
	
	      this.$store.commit('REMOVE_USER');
	      this.$store.commit('REMOVE_USER_DETAIL');
	
	      var encerraLocal = function encerraLocal() {
	        (0, _auth.limpaSessao)();
	        _this3.$router.push('/login');
	      };
	
	      axiosLaravel.get('auth/logout').then(encerraLocal).catch(encerraLocal);
	    },
	    conectaWebsocket: function conectaWebsocket() {
	      window.Echo = new _laravelEcho2.default({
	        broadcaster: 'pusher',
	        key: 'SGPkey',
	        wsHost: ("projetos.fbb.org.br"),
	        wsPort: 6001,
	        wssPort: 443,
	        disableStats: true,
	        authEndpoint: ("https://projetos.fbb.org.br:5443/api/") + 'broadcasting/auth',
	        auth: { headers: { Authorization: 'Bearer ' + window.localStorage.tokenLaravel } },
	        enabledTransports: ['ws', 'wss', 'websocket']
	      });
	    },
	    verificaUOR: function verificaUOR() {
	      var _this4 = this;
	
	      axiosLaravel.post('chamado/verificaUOR/').then(function (response) {
	        console.log('RLMB response.data', response.data);
	        _this4.usuarioLogado.uor = response.data[0];
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	        _this4.loading.show = false;
	      });
	    },
	    conectaCanalGeral: function conectaCanalGeral() {
	      var _this5 = this;
	
	      window.Echo.channel('Geral').listen('MensagemGeral', function (e) {
	        _this5.$snotify.warning(e.mensagem);
	      });
	    },
	    conectaUsuariosLogados: function conectaUsuariosLogados() {
	      window.Echo.join('usuarios-logados');
	    },
	    conectaCanalUsuario: function conectaCanalUsuario() {
	      var _this6 = this;
	
	      window.Echo.private('App.User.' + this.usuarioLogado.id).listen('NotificacaoUsuario', function (e) {
	        _this6.$snotify.warning(e.mensagem);
	      }).notification(function (notification) {
	        console.log('notification', notification);
	      });
	    },
	    verificarTempoRestante: function verificarTempoRestante(horaString) {
	      var horaAtual = new Date();
	
	      var _horaString$split = horaString.split(':'),
	          _horaString$split2 = (0, _slicedToArray3.default)(_horaString$split, 2),
	          hora = _horaString$split2[0],
	          minuto = _horaString$split2[1];
	
	      var horaAlvo = new Date(horaAtual.getFullYear(), horaAtual.getMonth(), horaAtual.getDate(), hora, minuto);
	
	      var diferencaEmMilissegundos = horaAlvo - horaAtual;
	
	      this.minutosRestanteNoPonto = parseInt(diferencaEmMilissegundos / 60 / 1000 + 1);
	      return parseInt(diferencaEmMilissegundos / 60 / 1000 + 1);
	    },
	    showAlertaPontoModal: function showAlertaPontoModal() {
	      var _this7 = this;
	
	      if (!this.usuarioLogado.sujeitoAPonto) {
	        return false;
	      }
	      window.setInterval(function () {
	        var minutosRestantes = _this7.verificarTempoRestante(_this7.usuarioLogado.limitePonto.slice(0, 5));
	        if (minutosRestantes <= 5) {
	          !_this7.$refs.alertaPontoDialog.open && _this7.$refs.alertaPontoDialog.showModal();
	        }
	        if (minutosRestantes < -5) {
	          _this7.logout();
	        }
	      }, 1000 * 60);
	    },
	    atualizaLimitePonto: function atualizaLimitePonto() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                window.setInterval(function () {
	                  if (new Date().getHours() < 13) {
	                    return true;
	                  }
	                  if (_this8.usuarioLogado.userType !== 'FUNDACAO' || !_this8.usuarioLogado.sujeitoAPonto) {
	                    return true;
	                  }
	                  axiosLaravel.get('usuario/atualiza_ponto').then(function (response) {
	                    _this8.usuarioLogado.limitePonto = response.data.limitePonto;
	                    _this8.usuarioLogado.sujeitoAPonto = response.data.sujeitoAPonto;
	                  });
	                }, 1000 * 3000);
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this8);
	      }))();
	    }
	  }
	};

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DashboardSidebar',
	  data: function data() {
	    return {
	      loading: {
	        propostas: false,
	        projetos: false
	      },
	      propostas: [],
	      projetos: [],
	      ativaGeracaoRemessa: true,
	      prestacaoSimplificada: false,
	      parametroRel: '',
	      parametroSol: '',
	      parametroProp: '',
	      parametroEnt: '',
	      parametroVi: '',
	      parametroPar: '',
	      parametroAval: '',
	      parametroOco: '',
	      parametroAltPrj: '',
	      parametroLicAmb: '',
	      rota: '/#/inicial',
	      ehParceiroEstrategico: false
	    };
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    validaRota: function validaRota() {}
	  }),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var temParceiroEstrategico;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.parametroRel = 'RELATORIO_DE_EXECUCAO';
	              _this.parametroSol = 'SOLICITACOES';
	              _this.parametroProp = 'PROPOSTAS';
	              _this.parametroEnt = 'ENTIDADES';
	              _this.parametroAval = 'AVALIACOES';
	              _this.parametroVi = 'VALIDACAO_INICIAL';
	              _this.parametroPar = 'PARCEIRO_ESTRATEGICO';
	              _this.parametroOco = 'OCORRENCIAS';
	              _this.parametroAltPrj = 'ALTERACOES_PROJETO';
	              _this.parametroLicAmb = 'LICENCIAMENTO AMBIENTAL';
	              temParceiroEstrategico = _this.usuarioLogado.perfis.some(function (perfil) {
	                return perfil.ds_nome === 'Parceiro Estratégico';
	              });
	
	              _this.ehParceiroEstrategico = temParceiroEstrategico;
	
	              if (!(_this.usuarioLogado.userType === 'ENTIDADE' && temParceiroEstrategico === false)) {
	                _context.next = 19;
	                break;
	              }
	
	              _context.next = 15;
	              return _this.buscaPropostas();
	
	            case 15:
	              _context.next = 17;
	              return _this.buscaProjetos();
	
	            case 17:
	              _context.next = 19;
	              return _this.buscaPropostaSimplificada();
	
	            case 19:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    buscaPropostas: function buscaPropostas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.loading.propostas = true;
	                _context2.next = 3;
	                return axiosLaravel.get('propostas').then(function (response) {
	                  _this2.propostas = response.data;
	                  if (typeof Storage !== 'undefined') window.localStorage.setItem('propostas', (0, _stringify2.default)({ 'atualizado': Math.floor(new Date().getTime()), 'lista': _this2.propostas }));
	                  _this2.loading.propostas = false;
	                  _this2.$forceUpdate();
	                }).catch(function (error) {
	                  _this2.loading.propostas = false;
	                  _this2.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    buscaProjetos: function buscaProjetos() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this3.loading.projetos = true;
	                _context3.next = 3;
	                return axiosLaravel.get('projetos').then(function (response) {
	                  _this3.projetos = response.data;
	                  if (typeof Storage !== 'undefined') window.localStorage.setItem('projetos', (0, _stringify2.default)({ 'atualizado': Math.floor(new Date().getTime()), 'lista': _this3.projetos }));
	                  _this3.loading.projetos = false;
	                  _this3.$forceUpdate();
	                }).catch(function (error) {
	                  _this3.loading.projetos = false;
	                  _this3.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    buscaPropostaSimplificada: function buscaPropostaSimplificada() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var i;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                console.log('buscaPropostaSimplificada');
	                _this4.prestacaoSimplificada = false;
	                _this4.loading.propostas = true;
	
	                console.log(_this4.propostas);
	                i = 0;
	
	              case 5:
	                if (!(i < _this4.propostas.length)) {
	                  _context4.next = 11;
	                  break;
	                }
	
	                _context4.next = 8;
	                return axiosLaravel.get('prestacaoSimplificada/verificaPropostaSimplificadaMenu/' + _this4.propostas[i].id).then(function (response) {
	                  console.log('response.data', response.data);
	                  if (response.data) {
	                    _this4.prestacaoSimplificada = true;
	                  }
	                  _this4.loading.propostas = false;
	                }).catch(function (error) {
	                  _this4.loading.propostas = false;
	                  _this4.$root.trataErro(error);
	                });
	
	              case 8:
	                i++;
	                _context4.next = 5;
	                break;
	
	              case 11:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this4);
	      }))();
	    }
	  }
	};

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'acertos-financeiros',
	  data: function data() {
	    return {
	      loading: {
	        carregando: false,
	        processando: false
	      },
	      mostrarListaItens: false,
	      acertos: [],
	      acertoAcao: '',
	      acertoEdicao: {},
	      itensRecomposiacaoEdicao: [],
	      formEditavel: true,
	      alteracoes: []
	    };
	  },
	
	  props: ['numeroProjeto', 'editavel', 'propsAtividades'],
	  watch: {},
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {
	    this.atualizarAcertos();
	  },
	
	  methods: {
	    limitaFaixaEntrada: function limitaFaixaEntrada(item, minimo, maximo) {
	      var valor = _.clone(item.Valor_solicitado);
	      if (_.isNil(valor) && _.isNull(valor) && _.isNaN(valor)) {
	        valor = minimo;
	        console.log('valor nulo', minimo);
	      } else {
	        valor = _.toNumber(('' + valor).replace(/[^.0-9]+/g, ''));
	        valor = valor <= minimo ? minimo : valor >= maximo ? maximo : valor;
	      }
	      this.$forceUpdate();
	      return valor;
	    },
	    itensRecomposiacao: function itensRecomposiacao(conta, fase, itensUsados) {
	      console.log('itensUsadosNaRecomposiacao', conta, fase, itensUsados);
	      var itensFiltrados = [];
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (('' + item.origem).substring(0, 1) === '' + fase && '' + item.conta_financeira.numero_conta === '' + conta) {
	              _.unset(item, 'Valor_solicitado');
	              if (itensUsados.length > 0) {
	                var itemOrcamento = _.filter(itensUsados, function (i) {
	                  return _.get(_.head(i.itens_orcamentos), 'id') === item.id;
	                });
	                if (itemOrcamento.length > 0) {
	                  item['Valor_solicitado'] = Math.abs(_.get(_.head(itemOrcamento), 'valor'));
	                }
	              }
	              itensFiltrados.push(item);
	            }
	          });
	        }
	      });
	      this.itensRecomposiacaoEdicao = itensFiltrados;
	    },
	    atualizarAcertos: function atualizarAcertos() {
	      var _this = this;
	
	      this.loading.carregando = true;
	      axiosLaravel.get('acertos/atualizar/' + this.numeroProjeto).then(function (response) {
	        if (response.data.codigo === 'OK') {
	          _this.acertos = response.data.retorno;
	        } else {
	          _this.acertoAcao = _.join(response.data.mensagem, '; ');
	        }
	        _this.loading.carregando = false;
	        _this.$snotify.clear();
	      }).catch(function (error) {
	        _this.loading.carregando = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    recomporSaldos: function recomporSaldos(titulo) {
	      this.acertoAcao = 'edicao';
	      this.acertoEdicao = _.clone(titulo);
	      this.itensRecomposiacao(this.acertoEdicao.numeroContaFinanceira, this.acertoEdicao.origem, _.filter(_.get(this.acertoEdicao, 'processo.documentosliberacao[0].itens_liberados'), ['tipo', 'BASE']));
	      this.mostrarListaItens = true;
	    },
	    visualizaRecomposicaoSaldos: function visualizaRecomposicaoSaldos(titulo) {
	      this.acertoAcao = 'visualizacao';
	      this.acertoEdicao = _.clone(titulo);
	      this.itensRecomposiacao(this.acertoEdicao.numeroContaFinanceira, this.acertoEdicao.origem, _.filter(_.get(this.acertoEdicao, 'processo.documentosliberacao[0].itens_liberados'), ['tipo', 'BASE']));
	      this.mostrarListaItens = true;
	    },
	    cancelarSolicitacao: function cancelarSolicitacao(titulo) {
	      var vm = this;
	      this.$dialog.confirm('Ao confirmar, o id ' + titulo['idSolicitacaoNF'] + ' da solicitação no SGP relacionado a este título no Sapiens ficará como CANCELADO no SGP', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        vm.$aguarde('Processando a cancelamento do id ' + titulo['idSolicitacaoNF'] + ' no SGP...');
	        vm.loading.processando = true;
	        axiosLaravel.get('acertos/cancela_nf/' + titulo['idSolicitacaoNF']).then(function (response) {
	          if (_.has(response.data, 'codigo')) {
	            if (response.data.codigo === 'OK') {
	              vm.$snotify.success(response.data.mensagem, { timeout: 2000 });
	              vm.$router.go(0);
	            } else {
	              vm.$snotify.error(response.data.mensagem);
	            }
	          }
	          vm.loading.processando = false;
	          vm.$snotify.clear();
	        }).catch(function (error) {
	          vm.loading.processando = false;
	          vm.$root.trataErro(error);
	        });
	      }).catch(function () {
	        console.log('Aviso de Confirmações fechado SEM confirmar cancelamento de processo');
	      });
	    },
	    ok: function ok() {
	      var _this2 = this;
	
	      var restricoesConcluir = [];
	      var itensRecomposicao = _.filter(this.itensRecomposiacaoEdicao, function (i) {
	        return _.has(i, 'Valor_solicitado') && i.Valor_solicitado > 0;
	      });
	      var totalInformado = _.sumBy(itensRecomposicao, 'Valor_solicitado');
	      if (totalInformado === 0) {
	        restricoesConcluir.push('Não foi adicionado valor em qualquer um dos itens para este acerto');
	      }
	      if (totalInformado > this.acertoEdicao.valor) {
	        restricoesConcluir.push('O total informado de R$ ' + totalInformado + ' está superior ao valor deste acerto de R$ ' + this.acertoEdicao.valor);
	      }
	
	      if (restricoesConcluir.length > 0) {
	        var mensagens = '<div class=avisoAlerta><li>' + _.join(restricoesConcluir, '<li>') + '</div>';
	        this.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && restricoesConcluir.length === 0) {
	          var vm = _this2;
	          _this2.$dialog.confirm('Ao confirmar, os saldos adicionados irão para os itens correspondentes no cronograma', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	            vm.$aguarde('Processando a recomposição de saldo...');
	            var registroProcessamento = { 'acerto': vm.acertoEdicao, 'itensRecomposicao': itensRecomposicao };
	            vm.loading.processando = true;
	            axiosLaravel.post('/acertos/recomposicao/', registroProcessamento).then(function (response) {
	              vm.$snotify.clear();
	              if (_.has(response.data, 'codigo')) {
	                if (response.data.codigo === 'OK') {
	                  vm.$snotify.success(response.data.mensagem, { timeout: 2000 });
	                  vm.$router.go(0);
	                } else {
	                  vm.$snotify.error(response.data.mensagem);
	                }
	              }
	              vm.loading.processando = false;
	            }).catch(function (error) {
	              vm.loading.processando = false;
	              vm.$root.trataErro(error);
	              vm.$snotify.clear();
	            });
	          }).catch(function () {
	            console.log('Aviso de Confirmações fechado SEM confirmar gravação de itens para recomposição de saldo de acerto');
	          });
	        }
	      });
	    },
	    cancelar: function cancelar() {
	      this.acertoAcao = '';
	      this.acertoEdicao = {};
	      this.itensRecomposiacaoEdicao = [];
	      this.mostrarListaItens = false;
	    }
	  }
	};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default
	  },
	  name: 'alteracoesPeriodoExecucao',
	  data: function data() {
	    return {
	      disabledDates: {
	        customPredictor: function customPredictor(date) {
	          if (date.getDate() < new Date().getDate()) {
	            return true;
	          }
	        }
	      },
	      highlighted: {
	        customPredictor: function customPredictor(date) {
	          var d1 = (0, _moment2.default)(date).format('YYYYMMDD');
	          var d2 = (0, _moment2.default)(new Date()).format('YYYYMMDD');
	          if (d1 === d2) {
	            return true;
	          }
	        }
	      },
	      loading: true,
	      numero: null,
	      projeto: [],
	      contador: 0,
	      objBackend: [],
	      atProp: [],
	      place: '',
	      mostraOcor: false,
	      editandoIndex: null,
	      alteracao: {
	        documentos: []
	      },
	      detalhamentoAnt: '',
	      salvouOK: false,
	      dadosTime: [],
	      documento: [],
	      showgrid: true,
	      table: {
	        items: [],
	        bloqueioCampos: false,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'dt_registro',
	        sortDesc: true,
	        alteracaoTable: [],
	        fields: [{
	          key: 'id',
	          label: 'id',
	          sortable: true,
	          thStyle: 'text-align: center; width: 50px',
	          class: 'text-center'
	        }, {
	          key: 'dt_registro',
	          label: 'Data',
	          sortable: true,
	          thStyle: 'text-align: center; width: 7%',
	          class: 'text-center'
	        }, { key: 'tipo', label: 'Tipo', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, {
	          key: 'detalhamento',
	          label: 'Detalhe',
	          sortable: true,
	          thStyle: 'text-align: left; width: 53%',
	          class: 'text-left'
	        }, {
	          key: 'motivo',
	          label: 'Motivo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 10%',
	          class: 'text-center'
	        }, {
	          key: 'responsavel.ds_nome_usuario',
	          label: 'Responsavel',
	          sortable: true,
	          thStyle: 'text-align: center; width: 10%',
	          class: 'text-center'
	        }, {
	          key: 'documentos',
	          label: 'Anexos',
	          sortable: true,
	          thStyle: 'text-align: center; width: 5%',
	          class: 'text-center'
	        }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 5%', class: 'text-center' }]
	      },
	      documentosObrigatorios: ['Súmula ou Nota Técnica', 'Termo Aditivo Assinado'],
	      vigenciaInicial: ''
	    };
	  },
	
	  props: ['ParmProjetos', 'ParmAlteracao', 'filtro', 'refreshTable', 'cancelar', 'editando', 'permiteConcluir', 'historicoAlteracaoPeriodo', 'editandoBloco', 'dataInicialAlteracao', 'nr_periodos', 'dt_data_final', 'periodo_vigencia', 'dt_data_vigencia'],
	  watch: {
	    ParmProjetos: function ParmProjetos() {
	      this.projeto = this.ParmProjetos;
	    },
	    filtro: function filtro() {
	      var _this = this;
	
	      this.table.filter = this.filtro;
	      this.$nextTick(function () {
	        _this.$parent.$refs['alteracoes'].scrollIntoView();
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {},
	  created: function created() {
	    console.log('ALT DOCS', this.alteracao.documentos);
	    this.vigenciaInicial = this.historicoAlteracaoPeriodo.periodo_vigencia;
	    console.log('VIGENCIA INICIAL', this.vigenciaInicial);
	    this.numero = this.$route.params.numero;
	    if (this.numero) {
	      this.projeto = this.ParmProjetos;
	      this.buscaAlteracaoProp();
	      this.buscaTipos();
	      this.alteracao.responsavel.ds_nome_usuario = this.usuarioLogado.userName;
	    }
	  },
	
	  methods: {
	    buscaTipos: function buscaTipos() {
	      var _this2 = this;
	
	      axiosLaravel.get('tipo-registros/').then(function (response) {
	        var arr = response.data;
	        _this2.tipos = _.filter(arr, function (o) {
	          if (o.grupo === 'ALTERACAO') return o;
	        });
	        _this2.motivos = _.filter(arr, function (o) {
	          if (o.grupo === 'ALTERACAO_MOTIVO') return o;
	        });
	        _this2.loading = false;
	        _this2.onNew();
	        _this2.showgrid = false;
	        console.log(_this2.tipos);
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    etiquetaTipos: function etiquetaTipos(option) {
	      return '' + option.descricao;
	    },
	    etiquetaMotivos: function etiquetaMotivos(option) {
	      return '' + option.descricao;
	    },
	    onSelect: function onSelect(selectedOption, tipos) {
	      this.place = 'Descreva de forma assertiva a justificativa para a alteração realizada.\n' + 'Exemplos: \n' + '1. O excesso de chuvas prejudicou a realização das oficinas de campo. Desse modo o prazo de execução será prorrogado em 4 meses para conclusão das atividades.\n' + '2. Tendo em vista a economicidade observada durante a execução do projeto, que resultou em sobra de recursos, elevamos de 80 para 90 a quantidade de barraginhas a serem implementadas.';
	    },
	    linha: function linha(data) {
	      var vm = this;
	      vm.eventData = data;
	      vm.$events.emit('linhaSelecionada', vm.eventData);
	    },
	    buscaAlteracaoProp: function buscaAlteracaoProp() {
	      var _this3 = this;
	
	      this.loading = true;
	      axiosLaravel.get('/alteracao/' + this.numero).then(function (response) {
	        _this3.atProp = response.data;
	        _this3.table.items = _this3.atProp;
	        _this3.table.totalRows = _this3.table.items.length;
	        _this3.loading = false;
	        _this3.$refs.tabelaAlteracao.refresh();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    onCancel: function onCancel() {
	      var _this4 = this;
	
	      this.alteracao = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	      this.mostraOcor = false;
	      this.$nextTick(function () {
	        _this4.$refs['form'].scrollIntoView();
	      });
	    },
	    onNew: function onNew() {
	      console.log('HISTORICO ', this.historicoAlteracaoPeriodo, this.editandoBloco);
	      this.alteracao.dt_registro = new Date();
	      this.alteracao.documentos = [];
	      this.alteracao.documentos = [];
	      this.alteracao.responsavel = {};
	      this.alteracao.responsavel.ds_nome_usuario = this.usuarioLogado.userName;
	      this.editandoIndex = null;
	      this.alteracao.detalhamento = '';
	      this.detalhamentoAnt = '';
	      this.alteracao.tipo = {
	        'id': 14,
	        'grupo': 'ALTERACAO',
	        'codigo': 'PRORROGACAO_DE_PRAZO',
	        'descricao': 'Prorrogação de prazo',
	        'created_at': '2019-10-25T12:28:52.823000Z',
	        'updated_at': '2019-10-25T12:28:52.823000Z',
	        'deleted_at': null
	      };
	      this.onSelect();
	    },
	    onAdd: function onAdd() {
	      var _this5 = this;
	
	      var currentDate = new Date();
	      var aux = this.usuarioLogado.userName;
	      var historico = 'Dados alterados de: <br> - Data Inicial: ' + (0, _moment2.default)(this.historicoAlteracaoPeriodo.dt_assinatura_convenio).format('DD/MM/YYYY') + ' - Data Final Execução: ' + this.historicoAlteracaoPeriodo.dt_data_final + '- Data Final Vigência: ' + (0, _moment2.default)(this.historicoAlteracaoPeriodo.dt_data_vigencia).format('DD/MM/YYYY') + '<br> - Número de Meses do Projeto: ' + this.historicoAlteracaoPeriodo.nr_periodos + '/ Número de Meses da Vigência: ' + this.historicoAlteracaoPeriodo.periodo_vigencia + '<br>';
	      var novoValor = 'Para: <br> - Data Inicial: ' + (0, _moment2.default)(this.dataInicialAlteracao).format('DD/MM/YYYY') + '- Data Final Execução: ' + this.dt_data_final + '- Data Final Vigência: ' + (0, _moment2.default)(this.dt_data_vigencia).format('DD/MM/YYYY') + '<br> - Número de Meses do Projeto: ' + this.nr_periodos + '/ Número de Meses da Vigência: ' + this.periodo_vigencia + '<br>';
	      var mensagemHistorico = historico + novoValor;
	      this.objBackend = [];
	      this.alteracao.responsavel.ds_nome_usuario = this.usuarioLogado.userName;
	      this.alteracao.fk_usuario_responsavel = this.usuarioLogado.id;
	      if (this.vigenciaInicial !== this.periodo_vigencia) {
	        this.documentosObrigatorios = ['Súmula ou Nota Técnica', 'Termo Aditivo Assinado'];
	      } else {
	        this.documentosObrigatorios = ['Súmula ou Nota Técnica'];
	      }
	      if (!this.verificaTipoDocumentos()) {
	        this.$snotify.error('Anexe os documentos obrigatórios antes de continuar.');
	        return;
	      }
	      if (this.alteracao.documentos.length <= 0) {
	        this.$snotify.error('Anexe os documentos obrigatórios antes de continuar.');
	        return;
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this5.alteracao.detalhamento = _this5.alteracao.detalhamento + '- <b>' + _this5.detalhamentoAnt + '</b><br><i>' + mensagemHistorico + '</i><br><i>(' + aux + ', ' + (0, _moment2.default)(currentDate).format('DD/MM/YYYY') + ')' + '</i><br>';
	
	          if (_this5.editandoIndex !== null) {
	            for (var i in _this5.alteracao) {
	              _this5.tabelaAlteracao[i] = _this5.alteracao[i];
	            }
	          } else {
	            _this5.table.items.push(_this5.alteracao);
	          }
	          _this5.objBackend.push(_this5.atProp);
	          _this5.objBackend.fk_proposta = _this5.projeto.proposta.id;
	          _this5.contador = _this5.contador + 1;
	          _this5.onCancel();
	          _this5.salvar();
	        } else {
	          _this5.$snotify.error('O formulário possui erros. Favor verificar!');
	        }
	      });
	    },
	    edita: function edita(row) {
	      var _this6 = this;
	
	      this.detalhamentoAnt = '';
	      this.$nextTick(function () {
	        _this6.$refs['form'].scrollIntoView();
	      });
	      this.editandoIndex = row.index;
	      this.alteracao = (0, _assign2.default)({}, row.item);
	      this.detalhamentoAnt = '';
	      this.tabelaAlteracao = row.item;
	      this.showgrid = false;
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	
	      this.objBackend.push(this.table.items);
	    },
	    irMetas: function irMetas() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        _this7.$parent.$refs['metas'].scrollIntoView();
	        if (_.has(_this7.$parent, 'mostrar')) _this7.$parent.mostrar.metas = true;
	      });
	    },
	    irAtividades: function irAtividades() {
	      var _this8 = this;
	
	      this.$nextTick(function () {
	        _this8.$parent.$refs['atividades'].scrollIntoView();
	        if (_.has(_this8.$parent, 'mostrar')) _this8.$parent.mostrar.atividades = true;
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this9 = this;
	
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this9.$root.trataErro(error);
	      });
	    },
	    salvar: function salvar() {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var arr;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                arr = _this10.objBackend;
	
	                arr = _.map(arr, function (o) {
	                  return _.extend({ fk_proposta: _this10.projeto.proposta.id }, o);
	                });
	                _this10.$aguarde('Salvando alteração do projeto. Por favor, aguarde...');
	                _context.next = 5;
	                return axiosLaravel.post('/alteracao/', arr).then(function (response) {
	                  _this10.salvouOK = true;
	                  _this10.buscaAlteracaoProp();
	                  _this10.$forceUpdate();
	                  _this10.$snotify.clear();
	                  _this10.$snotify.success('Alteração do projeto gravado com sucesso!');
	                  _this10.contador = 0;
	
	                  _this10.refreshTable();
	                  _this10.permiteConcluir('periodo_projeto');
	                }).catch(function (error) {
	                  _this10.$snotify.clear();
	                  console.log('error', error);
	                  _this10.$root.trataErro(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this10);
	      }))();
	    },
	    atualizarAlteracoes: function atualizarAlteracoes() {
	      this.refreshTable();
	    },
	    verificaTipoDocumentos: function verificaTipoDocumentos() {
	      var _this11 = this;
	
	      var documentosObrigatoriosPresentes = this.documentosObrigatorios.every(function (tipoDocumento) {
	        return _this11.alteracao.documentos.some(function (documento) {
	          return documento.tipo_documento.ds_tipo === tipoDocumento;
	        });
	      });
	      console.log('DOCUMENTOS OBRIGATÓRIOS PRESENTES?', documentosObrigatoriosPresentes);
	      return documentosObrigatoriosPresentes;
	    }
	  }
	};

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'visualiza-gantt',
	  data: function data() {
	    return {
	      atividades: [],
	      tipo_barra: 'declarado',
	      zoom: 1,
	      tamanho_nome_atividade: 400,
	      mostrar_execucao_financeira: false,
	      mostrar_execucao_declarada: true,
	      projeto: {},
	      relatorio_execucao_atividades: [],
	      mostrarOpcoes: false,
	      loadingShow: false,
	      dia_noite: 'fa fa-sun-o'
	    };
	  },
	
	  props: ['numeroProjeto', 'tipoBarra', 'mostrarExecFinanc', 'mostrarExecDeclarada', 'propsProposta'],
	  watch: {
	    'propsProposta.atividades': {
	      handler: function handler(after, before) {
	        this.carregaAtividades();
	      },
	      deep: true
	    }
	  },
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {
	    this.carregaAtividades();
	  },
	
	  methods: {
	    carregaAtividades: function carregaAtividades() {
	      var _this = this;
	
	      this.loadingShow = true;
	
	      if (this.numeroProjeto) {
	        axiosLaravel.get('atividade/gantt/' + this.numeroProjeto).then(function (response) {
	          _this.projeto = response.data.projeto[0];
	          _this.atividades = response.data.atividades;
	          _this.relatorio_execucao_atividades = response.data.relatorio_execucao_atividades;
	
	          _this.preparandoGantt();
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	          _this.loadingShow = false;
	        });
	      } else {
	        this.projeto['hoje_dias'] = null;
	        this.projeto['inicio'] = this.propsProposta.dt_data_inicial;
	        this.projeto['periodos'] = parseInt(this.propsProposta.nr_periodos);
	
	        this.atividades = this.propsProposta.atividades;
	        _.forEach(this.atividades, function (o) {
	          o['descricao'] = o['ds_nome'];
	          o['inicio'] = o['nr_periodo_inicial'];
	          o['termino'] = o['nr_periodo_final'];
	          o['executado'] = 0;
	          o['execucao'] = 0;
	          o['id'] = 0;
	          o['orcado'] = parseFloat(_.sumBy(o['itens_orcamentos'], function (i) {
	            return parseInt(i.quantidade) * i.valor_unitario;
	          }).toFixed(2));
	          o['dias_inicio'] = (o['inicio'] - 1) * 30;
	          o['dias_termino'] = o['termino'] * 30;
	        });
	        this.relatorio_execucao_atividades = [];
	        this.preparandoGantt();
	      }
	    },
	    preparandoGantt: function preparandoGantt() {
	      var _this2 = this;
	
	      if (!_.isEmpty(this.relatorio_execucao_atividades)) {
	        this.atividades.forEach(function (atividade) {
	          atividade['execucao'] = _this2.relatorio_execucao_atividades.find(function (exec) {
	            return exec.id === atividade.id;
	          }).execucao;
	        });
	      }
	      this.zoom = this.projeto.periodos > 20 ? 1 : 1.5;
	      this.tipo_barra = this.tipoBarra;
	      this.mostrar_execucao_financeira = this.mostrarExecFinanc;
	      this.mostrar_execucao_declarada = this.mostrarExecDeclarada;
	
	      if (new Date().getHours() >= 18) {
	        this.dia_noite = 'NOITE';
	      }
	      if (new Date().getHours() < 18 && new Date().getHours() >= 12) {
	        this.dia_noite = 'TARDE';
	      }
	      if (new Date().getHours() < 12 && new Date().getHours() >= 6) {
	        this.dia_noite = 'DIA';
	      }
	      this.loadingShow = false;
	    },
	    cor: function cor(situacao) {
	      return this.cores[situacao] === undefined ? this.cores['NAO_HA'] : this.cores[situacao];
	    },
	    percentualExecutado: function percentualExecutado(orcado, realizado) {
	      return parseFloat(realizado) / (parseFloat(orcado) === 0 ? 1 : parseFloat(orcado)) * 100;
	    }
	  }
	};

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'visualiza-gantt-old',
	  data: function data() {
	    return {
	      atividades: [],
	      tipo_barra: 'declarado',
	      zoom: 1,
	      tamanho_nome_atividade: 400,
	      mostrar_execucao_financeira: false,
	      mostrar_execucao_declarada: true,
	      projeto: {},
	      relatorio_execucao_atividades: [],
	      mostrarOpcoes: false,
	      loadingShow: false,
	      dia_noite: 'fa fa-sun-o'
	    };
	  },
	
	  props: ['idProjeto', 'tipoBarra', 'mostrarExecFinanc', 'mostrarExecDeclarada'],
	  watch: {},
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {
	    this.carregaAtividades();
	  },
	
	  methods: {
	    carregaAtividades: function carregaAtividades() {
	      var _this = this;
	
	      var idProjeto = '';
	      if (this.$route.params.idProjeto) {
	        idProjeto = this.$route.params.idProjeto;
	      }
	      if (this.$route.params.id) {
	        idProjeto = this.$route.params.id;
	      }
	      if (this.$route.params.numero_projeto) {
	        idProjeto = this.$route.params.numero_projeto;
	      }
	      this.loadingShow = true;
	      axiosLaravel.get('atividade/gantt/' + idProjeto).then(function (response) {
	        _this.projeto = response.data.projeto[0];
	        _this.atividades = response.data.atividades;
	        _this.relatorio_execucao_atividades = response.data.relatorio_execucao_atividades;
	
	        if (!_.isEmpty(_this.relatorio_execucao_atividades)) {
	          _this.atividades.forEach(function (atividade) {
	            atividade['execucao'] = _this.relatorio_execucao_atividades.find(function (exec) {
	              return exec.id === atividade.id;
	            }).execucao;
	          });
	        }
	        _this.zoom = _this.projeto.periodos > 20 ? 1 : 1.5;
	        _this.tipo_barra = _this.tipoBarra;
	        _this.mostrar_execucao_financeira = _this.mostrarExecFinanc;
	        _this.mostrar_execucao_declarada = _this.mostrarExecDeclarada;
	        _this.loadingShow = false;
	
	        if (new Date().getHours() >= 18) {
	          _this.dia_noite = 'NOITE';
	        }
	        if (new Date().getHours() < 18 && new Date().getHours() >= 12) {
	          _this.dia_noite = 'TARDE';
	        }
	        if (new Date().getHours() < 12 && new Date().getHours() >= 6) {
	          _this.dia_noite = 'DIA';
	        }
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	        _this.loadingShow = false;
	      });
	    },
	    cor: function cor(situacao) {
	      return this.cores[situacao] === undefined ? this.cores['NAO_HA'] : this.cores[situacao];
	    },
	    percentualExecutado: function percentualExecutado(orcado, realizado) {
	      return parseFloat(realizado) / (parseFloat(orcado) === 0 ? 1 : parseFloat(orcado)) * 100;
	    }
	  }
	};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _listaParticipantes = __webpack_require__(1716);
	
	var _listaParticipantes2 = _interopRequireDefault(_listaParticipantes);
	
	var _Atividades = __webpack_require__(256);
	
	var _Atividades2 = _interopRequireDefault(_Atividades);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _RelatorioImpressaoBNDES = __webpack_require__(1780);
	
	var _RelatorioImpressaoBNDES2 = _interopRequireDefault(_RelatorioImpressaoBNDES);
	
	var _html2pdf = __webpack_require__(140);
	
	var _html2pdf2 = _interopRequireDefault(_html2pdf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    RelatorioBNDES: _RelatorioImpressaoBNDES2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    listaParticipantes: _listaParticipantes2.default,
	
	    VisualizaGantt: _Atividades2.default
	  },
	  name: 'EditaRelExec',
	  data: function data() {
	    return {
	      listaAnexosZip: [],
	      data: [],
	      maxCount: 2000,
	      remainingCount: 2000,
	      message: '',
	      hasError: false,
	      salvouOK: false,
	      bloq: false,
	      documentosAtividade: {},
	      loading: {
	        tela: false,
	        listaOcorrencias: false,
	        projetoEntidadeOcorrencia: false
	      },
	      desabilitar: false,
	      ehVisualizacao: false,
	      sit: '',
	      mostrar_msg: false,
	      relatorio_execucao: {},
	      listaDocMetas: 'REL_METAS_ATIVIDADES',
	      listaDocParticipantes: 'REL_LISTA_PARTICIPANTES',
	      listaDocDiversos: 'REL_ANEXOS_DIVERSOS',
	      projeto: {},
	      atvGantt: [],
	      telaRelatorio: {
	        id_relatorio: null,
	        id_projeto: null,
	        proximaEtapa: '',
	        tarefa: {},
	        cabecalho: [],
	        usuario_enviou: {
	          id_usuario: null
	        },
	        aviso: {
	          conteudo: '',
	          situacao: '',
	          titulo: ''
	        },
	        alerta: {
	          conteudo: '',
	          situacao: '',
	          titulo: ''
	        },
	        contrapartida_comprovada: {
	          row: []
	        },
	        objetivos_projeto: {
	          row: []
	        },
	        anexos_diversos: {
	          row: []
	        },
	        metas: {
	          row: []
	        },
	        atividades: {
	          row: []
	        },
	        anexos: {},
	        ocorrencia: {},
	        contrapartida_comprovada_previsto: {},
	        comercializacao_producao: {
	          canal: {}
	        },
	        numero_participantes: {
	          anexo_lista_participantes: {
	            row: []
	          },
	          lista_participantes: []
	        },
	        consideracoes_gerais: {
	          valor: ''
	        },
	        entidade: {
	          codigo_sapiens: 0,
	          nome: '',
	          cnpj: '',
	          endereco: '',
	          complemento_endereco: '',
	          bairro: '',
	          cep: '',
	          municipio: '',
	          uf: ''
	        },
	        questionario: {
	          questao_1: {},
	          questao_2: {},
	          questao_3: {},
	          questao_4: {},
	          questao_5: {},
	          questao_6: {}
	        },
	        objeto_convenio: {
	          valor: ''
	        },
	        desenvolvimento_objeto_convenio: {},
	        resultados_alcancados: {},
	        depoimentos: {},
	        parecer_fbb: {
	          valor: ''
	        },
	        cronograma_conforme_previsto: {
	          resposta: ''
	        },
	        justificativa_devolucao: {
	          valor: ''
	        },
	        resultadoAprovacao: null,
	        comprovantes_enviados_fbb: {},
	        acoes_divulgacao_prevista: {},
	        objeto: '',
	        objetoJustificativa: '',
	        encaminhamento_notificacao_extrajudicial: '',
	        encaminhamento_email_agencia_parceiro: '',
	        encaminhamento_visita_agencia: '',
	        encaminhamento_monitoramento: '',
	        encaminhamento_registro_ocorrencia: 'NAO',
	        encaminhamento_restricao_cepim: 'NAO',
	        encaminhamento_restricao_cndt: 'NAO',
	
	        ocorrencia_descricao: '',
	        encaminhamento: {}
	      },
	      ocorrenciaModel: {
	        id: 0,
	        acao: 'SALVAR',
	        tipo: 'PROJETO',
	        alvo: null,
	        enquadramento: null,
	        observacao: '',
	        prazo: null,
	        anexos: []
	      },
	      projetoEntidadeOcorrencia: {},
	      ocorrenciaEditando: {},
	      listaTiposOcorrencias: [],
	      atividades: {
	        status: null
	      },
	      data2: [],
	      metas: {
	        meta: '',
	        prazo_regularizacao_meta: ''
	      },
	      proposta: [],
	      data4: {
	        id: '',
	        meta: '',
	        motivo: '',
	        providencia: '',
	        prazo_regularizacao_atividade: ''
	      },
	      verificar: null,
	      consultaAtividades: [],
	      consultaAtividades2: [],
	      consultaMetas: [],
	      colorFadeStyle: { color: '#c1c1c1' },
	      ativarDocumentos: false,
	      subArray: [],
	      headerTable: {
	        thead: [{
	          header: 'Metas',
	          subheaders: [{
	            title: 'Descrição',
	            width: '20%',
	            name: 'Descrição1'
	          }, {
	            title: 'Orçado',
	            width: '10%',
	            name: 'Orçado'
	          }, {
	            title: 'Realizado',
	            width: '15%',
	            name: 'Realizado'
	          }, {
	            title: 'Atingimento',
	            width: '5%',
	            name: 'Atingimento'
	          }]
	        }, {
	          header: 'Atividades',
	          subheaders: [{
	            title: 'Descrição',
	            width: '25%',
	            name: 'Descrição2'
	          }, {
	            title: 'Status',
	            width: '10%',
	            name: 'Status'
	          }, {
	            title: 'Execução',
	            width: '6%',
	            name: 'Execucao'
	          }, {
	            title: 'Anexo',
	            width: '10%',
	            name: 'Anexo'
	          }]
	        }] },
	      table: {
	        items: this.publicoAlvo,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 20,
	        fields: [{ key: 'fonte.ds_descricao', label: 'Público Alvo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_participantes_diretos', label: 'Participantes Diretos', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_jovens', label: 'Jovens atendidos', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nr_mulheres', label: 'Mulheres atendidas?', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      relatorio: {},
	      parametro: null,
	      historicoRelatorio: [],
	      existe: 0,
	      tipoUsu: null,
	      publicoAlvo: [],
	      totalizadoresListaParticipantes: {},
	      previstoPublicoAlvo: {
	        participantes: 0,
	        jovens: 0,
	        mulheres: 0
	      },
	      atividadesNaoExecutadas: [],
	      atividadesNaoExecutadas2: [],
	      store: this.$store,
	      atividadesProposta: [],
	      loadingProposta: false,
	      ehParceiroEstrategico: false
	    };
	  },
	
	  watch: {
	    consultaMetas: function consultaMetas(value, oldValue) {
	      var _this = this;
	
	      console.log('consultaMetas mudou!');
	      for (var i = 0; i < this.consultaMetas.length; i++) {
	        this.consultaMetas[i].atividades.row.forEach(function (item) {
	          if (item.motivo.length > 0 && item.status === 3) {
	            if (item.prazo_regularizacao_meta === '1900-01-01') {
	              item.prazo_regularizacao_meta = '';
	            }
	            _this.existe += 1;
	            _this.consultaAtividades.push(item);
	            _this.$forceUpdate();
	          }
	          if (item.motivo.length > 0 && item.status === 1) {
	            if (item.prazo_regularizacao_atividade === '1900-01-01') {
	              item.prazo_regularizacao_atividade = '';
	            }
	            _this.existe += 1;
	            _this.consultaAtividades2.push(item);
	            _this.$forceUpdate();
	          }
	        });
	      }
	    },
	    'ocorrenciaEditando.tipo': function ocorrenciaEditandoTipo() {
	      if (_.has(this.ocorrenciaEditando, 'tipo')) {
	        this.ocorrenciaEditando.enquadramento = null;
	      }
	      this.$forceUpdate();
	    }
	  },
	  mounted: function mounted() {
	    if (this.$route.params.row.item.acao === 'VISUALIZAR') {
	      this.desabilitar = true;
	    } else {
	      this.desabilitar = false;
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel']), {
	    naoexecutadas: function naoexecutadas() {
	      var atividades = this.consultaMetas.map(function (meta) {
	        return meta.atividades.row;
	      });
	
	      atividades = _.flatMapDeep(atividades);
	
	      return atividades.filter(function (atividade) {
	        return atividade.status === 3;
	      });
	    },
	    executadasparcial: function executadasparcial() {
	      var metas = this.consultaMetas.filter(function (meta) {
	        return parseInt(meta.realizado) < parseInt(meta.orcado);
	      });
	
	      var atividades = metas.map(function (meta) {
	        return meta.atividades.row;
	      });
	
	      atividades = _.flatMapDeep(atividades);
	
	      return atividades;
	    }
	  }),
	  created: function created() {
	    var _this2 = this;
	
	    this.loading.tela = true;
	    this.ehParceiroEstrategico = this.usuarioLogado.perfis.some(function (perfil) {
	      return perfil.ds_nome === 'Parceiro Estratégico';
	    });
	    axiosLaravel.get('propostas/' + (_.has(this.$route.params.row, 'item') ? this.$route.params.row.item.id_proposta : this.$route.params.row.id_proposta)).then(function (response) {
	      _this2.proposta = response.data;
	      _this2.publicoAlvo = response.data.publicos_alvo;
	      _this2.table.items = _this2.publicoAlvo;
	      _this2.contaParticipantes();
	      _this2.$forceUpdate();
	    }).catch(function (error) {
	      _this2.loading.tela = false;
	      _this2.$root.trataErro(error);
	    });
	
	    if (this.$route.params.acao) {
	      this.sit = this.$route.params.acao;
	    }
	    this.ehVisualizacao = _.get(this.$route, 'params.row.item.acao', true) === 'VISUALIZAR';
	
	    this.tipoUsu = this.usuarioLogado.userType;
	    this.buscaDados();
	    this.$forceUpdate();
	
	    this.headerTable.thead.forEach(function (header) {
	      header.subheaders.forEach(function (subheader) {
	        _this2.subArray.push(subheader);
	      });
	    });
	  },
	  methods: {
	    contaParticipantes: function contaParticipantes() {
	      this.previstoPublicoAlvo.participantes = _.sumBy(this.publicoAlvo, 'nr_participantes_diretos');
	      this.previstoPublicoAlvo.jovens = _.sumBy(this.publicoAlvo, 'nr_jovens');
	      this.previstoPublicoAlvo.mulheres = _.sumBy(this.publicoAlvo, 'nr_mulheres');
	    },
	    buscaDados: function buscaDados() {
	      var _this3 = this;
	
	      this.$aguarde('Buscando dados do Relatório. Por favor, aguarde...');
	      var objeto = {};
	      var parametro = '';
	      objeto.usuario_enviou = [];
	      objeto.usuario_enviou.nome = '';
	      if (this.$route.params.row.item) {
	        parametro = '';
	        parametro = this.$route.params.row.item.id_processo;
	      } else {
	        if (this.$route.params.row.item) {
	          parametro = '';
	          parametro = this.$route.params.row.id_processo;
	        } else {
	          parametro = '';
	          parametro = this.$route.params.row.id;
	        }
	      }
	      if (this.$route.params.row.item) {
	        if (this.$route.params.row.item.acao === 'PREENCHER' || this.$route.params.row.item.acao === 'REVISAR') {
	          parametro = '';
	          parametro = this.$route.params.row.item.id;
	        }
	      }
	      if (this.$route.params.acao === 'VALIDAR') {
	        if (this.$route.params.row) {
	          parametro = '';
	          parametro = this.$route.params.row.id_solicitacao;
	        }
	      }
	      if (this.$route.params.row.item) {
	        if (this.$route.params.row.item.acao === 'VISUALIZAR') {
	          parametro = '';
	          parametro = this.$route.params.row.item.id;
	        }
	      }
	      var endpoint = '/relatorio_execucao/cria/';
	      if (this.ehParceiroEstrategico) {
	        endpoint = 'parceiroEstrategico/abrirRelatorio/';
	      }
	
	      axiosLaravel.get(endpoint + parametro).then(function (response) {
	        _this3.listaAnexosZip = response.data.dados.lista_anexos_zip;
	        objeto = response.data.dados.relatorio_execucao;
	        _this3.parmGeral = parametro;
	        if (_this3.parmGeral) {
	          _this3.consultaHistorico();
	        }
	
	        _.set(objeto, 'encaminhamento_restricao_cepim', _.get(objeto, 'encaminhamento_restricao_cepim', _this3.telaRelatorio.encaminhamento_restricao_cepim));
	        _.set(objeto, 'encaminhamento_restricao_cndt', _.get(objeto, 'encaminhamento_restricao_cndt', _this3.telaRelatorio.encaminhamento_restricao_cndt));
	        _.set(objeto, 'ocorrencias', _.get(objeto, 'ocorrencias', []));
	        _.set(objeto, 'entidade', { codigo_sapiens: 0, nome: '', cnpj: '', endereco: '', complemento_endereco: '', bairro: '', cep: '', municipio: '', uf: '' });
	        _this3.telaRelatorio = objeto;
	
	        if (_this3.telaRelatorio.contrapartida_comprovada.row.length > 1) {
	          _this3.contrapartida = _this3.telaRelatorio.contrapartida_comprovada.row;
	        } else {
	          _this3.contrapartida = [_this3.telaRelatorio.contrapartida_comprovada.row];
	        }
	        _this3.telaRelatorio.encaminhamento_registro_ocorrencia = 'NAO';
	
	        _this3.consultaMetas = objeto.metas.row;
	
	        _this3.mostrar_msg = true;
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Relatório de Execução carregado com sucesso!');
	        _this3.loading.tela = false;
	
	        _this3.buscaPropostaAtividade();
	        if (_this3.tipoUsu === 'FUNDACAO' && _this3.sit === 'VALIDAR') {
	          _this3.carregarListaTiposOcorrencias();
	        }
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaAtividade: function buscaAtividade() {
	      var _this4 = this;
	
	      this.atvGantt = [];
	      var atividades = [];
	      var atividadesRel = [];
	      this.consultaMetas.forEach(function (meta) {
	        if (meta.atividades) {
	          meta.atividades.row.forEach(function (atividade) {
	            var atv = {};
	            atv['id'] = atividade.id;
	            atv['execucao'] = typeof atividade.execucao === 'undefined' ? 0 : atividade.execucao;
	            atividadesRel.push(atv);
	          });
	        }
	      });
	
	      if (this.proposta.objetivos) {
	        this.proposta.objetivos.forEach(function (objetivo) {
	          if (objetivo.metas && objetivo.bt_simbolico === 0) {
	            objetivo.metas.forEach(function (meta) {
	              if (meta.atividades && meta.bt_simbolico === 0) {
	                meta.atividades.forEach(function (atividade) {
	                  atividade['execucao'] = _.filter(atividadesRel, function (o) {
	                    if (o.id === atividade.id) return o;
	                  })[0].execucao;
	
	                  _this4.atvGantt.push(atividade);
	                  _this4.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    },
	    consultaHistorico: function consultaHistorico() {
	      var _this5 = this;
	
	      var parametroConsulta = '';
	      if (this.$route.params.row.item) {
	        parametroConsulta = this.$route.params.row.item.id_processo;
	      } else {
	        if (this.$route.params.row.item) {
	          parametroConsulta = this.$route.params.row.id_processo;
	        } else {
	          parametroConsulta = this.$route.params.row.id;
	        }
	      }
	
	      axiosLaravel.post('processos/consulta_historico/' + this.parmGeral).then(function (response) {
	        _this5.historicoRelatorio = response.data[0].dados.row;
	      }).catch(function (error) {
	        console.log('error', error);
	        console.log(parametroConsulta);
	        _this5.$root.trataErro(error);
	      });
	    },
	    carregarListaTiposOcorrencias: function carregarListaTiposOcorrencias() {
	      var _this6 = this;
	
	      this.loading.listaOcorrencias = true;
	      this.carregarProjetoEntidadeOcorrencia();
	      if (typeof Storage !== 'undefined') {
	        var listaTiposOcorrencias = JSON.parse(window.localStorage.getItem('codigos-ocorrencia'));
	
	        var diferenca = Math.floor(new Date().getTime() / 86400000 - _.get(listaTiposOcorrencias, 'atualizado', new Date('2023-01-01').getTime()) / 86400000);
	        if (diferenca >= 1) {
	          axiosLaravel.get('tipo-ocorrencia/').then(function (response) {
	            _this6.listaTiposOcorrencias = _.cloneDeep(response.data);
	            window.localStorage.setItem('codigos-ocorrencia', (0, _stringify2.default)({ 'atualizado': Math.floor(new Date().getTime()), 'lista': _this6.listaTiposOcorrencias }));
	            _this6.loading.listaOcorrencias = false;
	            _this6.$forceUpdate();
	          }).catch(function (error) {
	            _this6.loading.listaOcorrencias = false;
	            if (error) {
	              _this6.$root.trataErro(error);
	            }
	          });
	        } else {
	          this.listaTiposOcorrencias = _.cloneDeep(listaTiposOcorrencias.lista);
	          this.loading.listaOcorrencias = false;
	        }
	      }
	    },
	    atualizaComponente: function atualizaComponente() {
	      this.telaRelatorio.encaminhamento_notificacao_extrajudicial = 'NAO';
	      this.telaRelatorio.encaminhamento_email_agencia_parceiro = 'NAO';
	      this.telaRelatorio.encaminhamento_visita_agencia = 'NAO';
	      this.telaRelatorio.encaminhamento_monitoramento = 'NAO';
	      this.telaRelatorio.encaminhamento_registro_ocorrencia = 'NAO';
	      this.telaRelatorio.ocorrencia = '';
	      this.telaRelatorio.parecer_fbb.valor = '';
	      this.telaRelatorio.ocorrencia_descricao = '';
	    },
	    ativaDocumentos: function ativaDocumentos(data2) {
	      var _this7 = this;
	
	      this.documentosAtividade = data2;
	      this.ativarDocumentos = true;
	      this.$nextTick(function () {
	        _this7.$refs['doc'].scrollIntoView();
	      });
	    },
	    passaMetas: function passaMetas(data, data2) {
	      var _this8 = this;
	
	      this.errors.clear();
	      this.bloq = true;
	      data2.execucao = 0;
	      this.$nextTick(function () {
	        _this8.$refs['js2'].scrollIntoView();
	      });
	      this.buscaAtividade();
	    },
	    passaMetas2: function passaMetas2(data, data2) {
	      var _this9 = this;
	
	      this.errors.clear();
	      this.bloq = true;
	      data2.execucao = 100;
	      this.$nextTick(function () {
	        _this9.$refs['js1'].scrollIntoView();
	      });
	      this.buscaAtividade();
	    },
	    passaMetas3: function passaMetas3(data, data2) {
	      this.bloq = false;
	      data2.execucao = '';
	      this.buscaAtividade();
	    },
	    validaOpcao: function validaOpcao() {
	      if (this.telaRelatorio.encaminhamento_registro_ocorrencia === 'NAO') {
	        this.telaRelatorio.ocorrencia = '';
	        this.telaRelatorio.ocorrencia_descricao = '';
	        this.$forceUpdate();
	      }
	    },
	    mudaEstilo: function mudaEstilo(parm) {
	      if (parm.venda_na_propriedade === 'NAO' || parm.direto_ao_consumidor === 'NAO' || parm.programa_de_aquisição_de_alimentos_paa === 'NAO' || parm.feiras_livres === 'NAO' || parm.mercadinhos === 'NAO' || parm.programa_nacional_de_alimentação_escolar_pnae === 'NAO' || parm.feiras_agroecológicas === 'NAO' || parm.atravessadores === 'NAO' || parm.outros_canais_de_comercialização === 'NAO') {
	        this.$refs['com'].style.color = '#000000';
	      } else {
	        this.$refs['com'].style.color = '#fb2916';
	      }
	      if (this.telaRelatorio.comercializacao_producao.resposta === 'NAO') {
	        if (this.telaRelatorio.comercializacao_producao.justivicativa) {
	          if (this.telaRelatorio.comercializacao_producao.justificativa.length === 0) {
	            this.$refs['considera1'].style.color = '#fb2916';
	          } else {
	            this.$refs['considera1'].style.color = '#000000';
	          }
	        }
	      }
	    },
	    onlyNumber: function onlyNumber($event) {
	      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
	      if ((keyCode < 48 || keyCode > 57) && keyCode !== 44) {
	        $event.preventDefault();
	      }
	    },
	    validaDocPreenchidos: function validaDocPreenchidos() {
	      var _this10 = this;
	
	      if (this.telaRelatorio.numero_participantes.anexo_lista_participantes.row.length === 0) {
	        this.$nextTick(function () {
	          _this10.$refs['listPartc'].scrollIntoView();
	          _this10.$refs['listPartc'].style.color = '#fb2916';
	          _this10.$snotify.error('É obrigatório anexar a Lista de Participantes!');
	        });
	      } else {
	        this.$nextTick(function () {
	          _this10.$refs['listPartc'].style.color = '#000000';
	        });
	      }
	    },
	    salvaRelatorio: function salvaRelatorio() {
	      var _this11 = this;
	
	      this.loading.tela = true;
	
	      this.telaRelatorio.proximaEtapa = 'SALVAR';
	      if (this.$route.params.row.item) {
	        this.telaRelatorio.id_projeto = this.$route.params.row.item.id_projeto;
	      }
	      if (this.$route.params.row) {
	        this.telaRelatorio.id_solicitacao = this.$route.params.row.id_solicitacao;
	        this.telaRelatorio.id_projeto = this.$route.params.row.id_projeto;
	      }
	      this.telaRelatorio.usuario_enviou.id_usuario = this.usuarioLogado.id;
	      this.$aguarde('Salvando relatório. Por favor, aguarde...');
	      axiosLaravel.post('relatorio_execucao/', this.telaRelatorio).then(function (response) {
	        _this11.salvouOK = true;
	        _this11.$snotify.clear();
	
	        _this11.$snotify.success('Relatório de Execução salvo com sucesso');
	        _this11.loading.tela = false;
	      }).catch(function (error) {
	        _this11.loading.tela = false;
	        _this11.$snotify.clear();
	        console.log('error', error);
	        _this11.$root.trataErro(error);
	      });
	    },
	    permiteConcluir: function permiteConcluir() {
	      var mensagem = [];
	      var documentosObrigatorios = [{ 'codigo': 67, 'descricao': 'CNEP/CEPIM' }, { 'codigo': 40, 'descricao': 'CNDT' }];
	
	      if (this.tipoUsu === 'ENTIDADE' || this.tipoUsu === 'FUNDACAO' && this.telaRelatorio.resultadoAprovacao !== 'REVISAO') {
	        var codigoDocsObrigatoriosSemDataValidade = _.uniq(_.map(_.filter(this.telaRelatorio.anexos_diversos.row, function (anexo) {
	          return _.includes([67, 40], anexo.tipo_documento.id) && anexo.dt_data_vigencia === '';
	        }), 'tipo_documento.id'));
	        if (this.tipoUsu === 'FUNDACAO') {
	          if (codigoDocsObrigatoriosSemDataValidade.length > 0) {
	            mensagem.push('Falta data de validade: ' + _.join(_.map(_.filter(documentosObrigatorios, function (obr) {
	              return _.includes(codigoDocsObrigatoriosSemDataValidade, obr.codigo);
	            }), 'descricao'), ', '));
	          }
	        }
	
	        var codigosDocsAnexados = _.map(this.telaRelatorio.anexos_diversos.row, 'tipo_documento.id');
	        _.remove(documentosObrigatorios, function (obr) {
	          return _.includes(codigosDocsAnexados, obr.codigo);
	        });
	        if (documentosObrigatorios.length > 0) {
	          mensagem.push('Obrigatório anexar os documento: ' + _.join(_.map(documentosObrigatorios, 'descricao'), ', '));
	        }
	      }
	
	      var dataTermino = (0, _moment2.default)(this.telaRelatorio.cabecalho.termino, 'DD/MM/YYYY');
	      if ((0, _moment2.default)().isAfter(dataTermino, 'day', '[]')) {}
	      if (mensagem.length > 0) {
	        this.$dialog.alert('<ul><li>' + mensagem.join('</li><li>') + '</li></ul>', {
	          html: true,
	          animation: 'fade',
	          customClass: 'avisoAlerta'
	        });
	        return;
	      } else {
	        this.gravaRelatorio();
	      }
	    },
	    gravaRelatorio: function gravaRelatorio() {
	      var _this12 = this;
	
	      this.loading.tela = true;
	
	      if (this.$route.params.row.item) {
	        if (this.$route.params.row.item.acao === 'PREENCHER') {
	          this.telaRelatorio.tarefa = {
	            nome: 'SOLICITACAO',
	            tipo: 'USUARIO',
	            situacao: 'PADRAO'
	          };
	          this.telaRelatorio.processo = {
	            nome: 'RELATORIO_DE_EXECUCAO',
	            situacao: 'EM_EXECUCAO'
	          };
	          this.telaRelatorio.proximaEtapa = 'ANALISE';
	        }
	        if (this.$route.params.row.item.acao === 'REVISAR') {
	          this.telaRelatorio.tarefa = {
	            nome: 'REVISAR',
	            tipo: 'USUARIO',
	            situacao: 'PADRAO'
	          };
	          this.telaRelatorio.processo = {
	            nome: 'RELATORIO_DE_EXECUCAO',
	            situacao: 'EM_EXECUCAO'
	          };
	          this.telaRelatorio.proximaEtapa = 'ANALISE';
	        }
	      }
	      if (this.$route.params.acao === 'VALIDAR') {
	        this.telaRelatorio.tarefa = {
	          nome: 'ANALISE',
	          tipo: 'USUARIO',
	          situacao: 'PADRAO'
	        };
	        this.telaRelatorio.processo = {
	          nome: 'RELATORIO_DE_EXECUCAO',
	          situacao: 'EM_EXECUCAO'
	        };
	        if (this.telaRelatorio.resultadoAprovacao === 'APROVADO') {
	          this.telaRelatorio.proximaEtapa = 'CONCLUSAO';
	        }
	        if (this.telaRelatorio.resultadoAprovacao === 'REVISAO') {
	          this.telaRelatorio.proximaEtapa = 'REVISAO';
	        }
	      }
	      if (this.$route.params.row.item) {
	        this.telaRelatorio.id_projeto = this.$route.params.row.item.id_projeto;
	      }
	      if (this.$route.params.row) {
	        this.telaRelatorio.id_solicitacao = this.$route.params.row.id_solicitacao;
	        this.telaRelatorio.id_projeto = this.$route.params.row.id_projeto;
	      }
	      if (this.telaRelatorio.comercializacao_producao.resposta === 'SIM') {
	        if (this.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade === 'NAO' && this.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor === 'NAO' && this.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa === 'NAO' && this.telaRelatorio.comercializacao_producao.canal.feiras_livres === 'NAO' && this.telaRelatorio.comercializacao_producao.canal.mercadinhos === 'NAO' && this.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae === 'NAO' && this.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas === 'NAO' && this.telaRelatorio.comercializacao_producao.canal.atravessadores === 'NAO' && this.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização === 'NAO') {
	          this.verificar = 0;
	        } else {
	          this.verificar = 1;
	          this.$refs['com'].style.color = '#000000';
	          this.$forceUpdate();
	        }
	      }
	      if (this.telaRelatorio.comercializacao_producao.resposta === 'NAO') {
	        if (this.telaRelatorio.comercializacao_producao.resposta.justificativa) {
	          if (this.telaRelatorio.comercializacao_producao.resposta.justificativa.length === 0) {
	            this.$nextTick(function () {
	              _this12.$refs['considera1'].scrollIntoView();
	              _this12.$refs['considera1'].style.color = '#fb2916';
	              _this12.$snotify.error('O campo consideração é obrigatório, quando o campo comercialização é marcado como NÃO.');
	              _this12.loading.tela = false;
	            });
	          } else {
	            this.$refs['considera1'].style.color = '#000000';
	          }
	        }
	      }
	      this.validaDocPreenchidos();
	
	      var metaRel = this.telaRelatorio.metas.row;
	      for (var i = 0; i < metaRel.length; i++) {
	        if (parseInt(metaRel[i].realizado) >= parseInt(metaRel[i].orcado)) {
	          for (var j = 0; j < metaRel[i].atividades.row.length; j++) {
	            if (metaRel[i].atividades.row[j].anexos_atividades.row.length === 0) {
	              this.$snotify.error('É obrigatório anexar documentos comprobatórios quando o atingimento da meta está 100% concluída!');
	              this.loading.tela = false;
	              this.$nextTick(function () {
	                _this12.$refs['metAtv'].scrollIntoView();
	              });
	              return;
	            }
	          }
	        }
	      }
	      if (_.isEmpty(this.telaRelatorio.numero_participantes.lista_participantes) && this.sit !== 'VALIDAR') {
	        this.$snotify.error('É necessário preencher a lista de participantes!');
	        this.loading.tela = false;
	        return;
	      }
	
	      this.$validator.validateAll().then(function (result) {
	        if (_this12.verificar === 0) {
	          _this12.$nextTick(function () {
	            _this12.$refs['com'].scrollIntoView();
	            _this12.$refs['com'].style.color = '#fb2916';
	          });
	          if (_this12.telaRelatorio.comercializacao_producao.resposta === 'SIM') {
	            _this12.$snotify.error('Preencha ao menos um canal de Comercialização da Produção');
	          }
	        } else {
	          _this12.loading.tela = false;
	
	          _this12.$forceUpdate();
	        }
	        if (result) {
	          _.remove(_this12.telaRelatorio.ocorrencias, function (o) {
	            return o.enquadramento.codigo === 2422;
	          });
	
	          var certidoes = [{ 'codigo': 'CEPIM', 'descricao': 'CNEP/CEPIM' }, { 'codigo': 'CNDT', 'descricao': 'CNDT' }];
	          var restricoes = [];
	          certidoes.forEach(function (certidao) {
	            if (_.get(_this12.telaRelatorio, 'encaminhamento_restricao_' + _.toLower(certidao.codigo)) === 'SIM') {
	              restricoes.push(certidao.descricao);
	            }
	          });
	          if (restricoes.length > 0) {
	            var alvo = _.find(_this12.projetoEntidadeOcorrencia.projetos, ['ds_codigo_projeto_erp', '' + _this12.telaRelatorio.cabecalho.numero_projeto]);
	            _this12.telaRelatorio.ocorrencias.push({ 'id': 0, 'acao': 'SALVAR', 'alvo': alvo, 'tipo': 'PROJETO', 'enquadramento': { 'codigo': 2422, 'descricao': 'Certidão com restrição' }, 'descricao': '', 'observacao': _.join(restricoes, ', ') + ' com restricao' });
	          }
	          _this12.$aguarde('Enviando relatório. Por favor, aguarde...');
	          _this12.loading.tela = true;
	          axiosLaravel.post('relatorio_execucao/', _this12.telaRelatorio).then(function (response) {
	            _this12.salvouOK = true;
	            _this12.$snotify.clear();
	
	            _this12.$snotify.success('Relatório de Execução enviado com sucesso');
	            _this12.loading.tela = false;
	            setTimeout(function () {
	              _this12.$router.go(-1);
	            }, 1000);
	          }).catch(function (error) {
	            _this12.loading.tela = false;
	            console.log('error', error);
	            _this12.$snotify.clear();
	            _this12.$root.trataErro(error);
	          });
	        } else {
	          _this12.loading.tela = false;
	          _this12.$snotify.error('Verifique se todos os campos obrigatórios foram preenchidos!');
	        }
	      });
	    },
	    okOcorrencia: function okOcorrencia() {
	      var idx = _.get(this.ocorrenciaEditando, 'idx', -1);
	      var valor = _.clone(this.ocorrenciaEditando);
	      _.unset(valor, 'idx');
	      var alvo = {};
	      if (this.ocorrenciaEditando.tipo === 'PROJETO') {
	        alvo = _.find(this.projetoEntidadeOcorrencia.projetos, ['ds_codigo_projeto_erp', '' + this.telaRelatorio.cabecalho.numero_projeto]);
	      } else {
	        alvo = _.find(this.projetoEntidadeOcorrencia.entidades, ['ds_nome', this.telaRelatorio.cabecalho.entidade]);
	      }
	      if (_.isNil(alvo)) {
	        this.$snotify.error('Não consigo dados de ' + _.toLower(this.ocorrenciaEditando.tipo) + ' para prosseguir. Favor informar o administrador do sistema');
	      } else {
	        _.set(valor, 'alvo', alvo);
	        if (idx >= 0) {
	          this.telaRelatorio.ocorrencias[idx] = valor;
	        } else {
	          this.telaRelatorio.ocorrencias.push(valor);
	        }
	        this.cancelaOcorrencia();
	      }
	    },
	    cancelaOcorrencia: function cancelaOcorrencia() {
	      this.ocorrenciaEditando = {};
	      this.$forceUpdate();
	    },
	    excluiOcorrencia: function excluiOcorrencia(idx) {
	      this.telaRelatorio.ocorrencias.splice(idx, 1);
	      this.$forceUpdate();
	    },
	    editaOcorrencia: function editaOcorrencia(idx) {
	      this.ocorrenciaEditando = this.telaRelatorio.ocorrencias[idx];
	      _.set(this.ocorrenciaEditando, 'idx', idx);
	      this.$forceUpdate();
	    },
	    novaOcorrencia: function novaOcorrencia() {
	      this.ocorrenciaEditando = _.clone(this.ocorrenciaModel);
	      _.set(this.ocorrenciaEditando, 'idx', -1);
	      this.$forceUpdate();
	    },
	    carregarProjetoEntidadeOcorrencia: function carregarProjetoEntidadeOcorrencia() {
	      var _this13 = this;
	
	      this.loading.projetoEntidadeOcorrencia = true;
	      axiosLaravel.get('consulta/projetos-entidades/lista/').then(function (response) {
	        if (_.get(response.data, 'codigo', '') === 'OK') {
	          _this13.projetoEntidadeOcorrencia = response.data.retorno;
	        } else {
	          _this13.$snotify.error(response.data.mensagem);
	        }
	        _this13.loading.projetoEntidadeOcorrencia = false;
	        _this13.$forceUpdate();
	      }).catch(function (error) {
	        _this13.loading.projetoEntidadeOcorrencia = false;
	        if (error) {
	          _this13.$root.trataErro(error);
	        }
	      });
	    },
	    countdown: function countdown() {
	      this.remainingCount = this.maxCount - this.telaRelatorio.justificativa_devolucao.valor.length;
	      this.hasError = this.remainingCount < 0;
	    },
	    formataData: function formataData(data) {
	      return (0, _moment2.default)(data).format('DD/MM/YYYY');
	    },
	    buscaPropostaAtividade: function buscaPropostaAtividade() {
	      var _this14 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var endpoint;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this14.loadingProposta = true;
	                console.log('Proposta Atividade - ' + 'Numero Projeto: ' + _this14.telaRelatorio.cabecalho.numero_projeto);
	                endpoint = 'projeto/numero/';
	
	                if (_this14.ehParceiroEstrategico) {
	                  endpoint = 'parceiroEstrategico/visualizarProjeto/';
	                }
	                _context.next = 6;
	                return axiosLaravel.get(endpoint + _this14.telaRelatorio.cabecalho.numero_projeto).then(function (response) {
	                  _this14.atividadesProposta = response.data.atividades;
	                  _this14.buscaCronograma();
	                  console.log(_this14.atividadesProposta);
	                });
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this14);
	      }))();
	    },
	    buscaCronograma: function buscaCronograma() {
	      var _this15 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('id proposta: ', _.has(_this15.$route.params.row, 'item') ? _this15.$route.params.row.item.id_proposta : _this15.$route.params.row.id_proposta);
	                _context2.next = 3;
	                return axiosLaravel.post('processos/cronograma/projeto/', { 'proposta': _.has(_this15.$route.params.row, 'item') ? _this15.$route.params.row.item.id_proposta : _this15.$route.params.row.id_proposta, 'processo': 'PAGAMENTO', 'aglutinado': 'Completo', 'documento': 0 }).then(function (response) {
	                  var saldos = response.data;
	                  if (_.isUndefined(_this15.atividadesProposta)) {
	                    return 0;
	                  }
	                  _this15.atividadesProposta.forEach(function (atividade) {
	                    if (atividade.itens_orcamentos) {
	                      atividade.itens_orcamentos.forEach(function (item) {
	                        item['valorOrcado'] = _.sumBy(item.orcamentos_mensalizados, function (iVO) {
	                          return iVO.valor;
	                        });
	                        item['quantidadeOrcado'] = _.sumBy(item.orcamentos_mensalizados, function (iQO) {
	                          return iQO.quantidade;
	                        });
	
	                        item['valorSaldo'] = _.sumBy(saldos.itens, function (sVS) {
	                          return Number(item.id) === Number(sVS['Id_item']) ? sVS['Valor_saldo'] : 0;
	                        });
	                        item['quantidadeSaldo'] = _.sumBy(saldos.itens, function (sQS) {
	                          return Number(item.id) === Number(sQS['Id_item']) ? sQS['Qtde_saldo'] : 0;
	                        });
	
	                        item['contaFinanceiraDescricao'] = _.has(item, 'conta_financeira') && _.has(item.conta_financeira, 'descricao') ? item.conta_financeira.descricao : '';
	                        item['contaFinanceiraNumero'] = _.has(item, 'conta_financeira') && _.has(item.conta_financeira, 'numero_conta') ? item.conta_financeira.numero_conta : '';
	
	                        item['observacaoOriginal'] = item['observacao'];
	
	                        _.unset(item, 'observacaoNova');
	                        var valorOrcado = _.sumBy(saldos.itens, function (sVS) {
	                          return Number(item.id) === Number(sVS['Id_item']) ? sVS['Valor_orcado'] : 0;
	                        });
	                        item['valorOrcado'] = item['valorOrcado'] !== valorOrcado ? valorOrcado : item['valorOrcado'];
	
	                        var quantidadeOrcado = _.sumBy(saldos.itens, function (sVS) {
	                          return Number(item.id) === Number(sVS['Id_item']) ? sVS['Qtde_orcado'] : 0;
	                        });
	                        item['quantidadeOrcado'] = item['quantidadeOrcado'] !== quantidadeOrcado ? quantidadeOrcado : item['quantidadeOrcado'];
	
	                        item['percAtingimento'] = Math.ceil(('' + item.economicidade === '1' ? item['valorOrcado'] : item['valorOrcado'] - item['valorSaldo']) / item['valorOrcado'] * 100) / 100;
	                        item['percAtingimento'] = item['percAtingimento'] > 1 ? 1 : item['percAtingimento'] < 0 ? 0 : item['percAtingimento'];
	                      });
	                      atividade['valorOrcado'] = _.sumBy(atividade.itens_orcamentos, function (aVO) {
	                        return aVO.valorOrcado;
	                      });
	                      atividade['quantidadeOrcado'] = _.sumBy(atividade.itens_orcamentos, function (aQO) {
	                        return aQO.quantidadeOrcado;
	                      });
	
	                      atividade['valorSaldo'] = _.sumBy(atividade.itens_orcamentos, function (aVS) {
	                        return aVS.valorSaldo;
	                      });
	                      atividade['quantidadeSaldo'] = _.sumBy(atividade.itens_orcamentos, function (aQS) {
	                        return aQS.quantidadeSaldo;
	                      });
	
	                      atividade['percAtingimento'] = Math.ceil(('' + atividade.economicidade === '1' ? atividade['valorOrcado'] : atividade['valorOrcado'] - atividade['valorSaldo']) / atividade['valorOrcado'] * 100) / 100;
	                      atividade['percAtingimento'] = atividade['percAtingimento'] > 1 ? 1 : atividade['percAtingimento'] < 0 ? 0 : atividade['percAtingimento'];
	                    }
	                  });
	                  _this15.loadingProposta = false;
	                  _this15.$forceUpdate();
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this15.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this15);
	      }))();
	    },
	    imprimir: function imprimir() {
	      window.print();
	    },
	    forceRerender: function forceRerender() {
	      this.componentKey += 1;
	    },
	    mostrarRelatorio: function mostrarRelatorio(tipo) {
	      var element = document.getElementById('FundacaoCode12646546516581');
	      element.style.display = tipo;
	    },
	    print: function print() {
	      this.mostrarRelatorio('block');
	      this.forceRerender();
	      var element = document.getElementById('FundacaoCode12646546516581');
	      element.style.width = '750px';
	      this.$refs.relatorioBNDESChildRef.verificaTamanhos(element);
	      element.style.width = '100%';
	      var opt = {
	        margin: 0.3,
	        filename: 'relatorio_SGP.pdf',
	        image: { type: 'jpeg', quality: 0.98 },
	        html2canvas: { scale: 2 },
	        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
	      };
	      (0, _html2pdf2.default)(element, opt).then(function () {
	        element.style.display = 'none';
	      });
	    },
	    onDownloadZIP: function onDownloadZIP() {
	      var _this16 = this;
	
	      this.$forceUpdate();
	      this.$aguarde('Baixando arquivos. Por favor, aguarde...');
	      axiosLaravel.get('documentos/download_por_lista', {
	        responseType: 'blob',
	        params: {
	          lista: this.listaAnexosZip.map(function (item) {
	            return item.id;
	          }).join(',')
	        },
	        headers: {
	          'Content-Type': 'application/json'
	        }
	      }).then(function (response) {
	        var url = window.URL.createObjectURL(new Blob([response.data]));
	        var link = document.createElement('a');
	        link.href = url;
	        link.setAttribute('download', 'relatorio.zip');
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	        _this16.$snotify.clear();
	        _this16.$forceUpdate();
	      }).catch(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(error) {
	          var objetoJsonDoBlob;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  _this16.$snotify.clear();
	
	                  if (!(error.response && error.response.data)) {
	                    _context3.next = 10;
	                    break;
	                  }
	
	                  _context3.t0 = JSON;
	                  _context3.next = 5;
	                  return error.response.data.text();
	
	                case 5:
	                  _context3.t1 = _context3.sent;
	                  objetoJsonDoBlob = _context3.t0.parse.call(_context3.t0, _context3.t1);
	
	                  if (objetoJsonDoBlob.error) {
	                    _this16.$snotify.error(objetoJsonDoBlob.error, { bodyMaxLength: 1200 });
	                  }
	                  _context3.next = 11;
	                  break;
	
	                case 10:
	                  _this16.$root.trataErro(error);
	
	                case 11:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this16);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    }
	  }
	};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _emiteDocumento = __webpack_require__(270);
	
	var _emiteDocumento2 = _interopRequireDefault(_emiteDocumento);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'emissao-documentos',
	  data: function data() {
	    return {
	      titulo: 'Emissão de Documentos',
	      loading: false,
	      briefing: false,
	      dadosBriefing: [{ id: 'sobreProjeto', nome: '1. Sobre o Projeto', disabled: true }, { id: 'dadosEntidade', nome: '2. Dados da Entidade', disabled: false }, { id: 'dadosProjeto', nome: '3. Dados do Projeto', disabled: false }, { id: 'infosProjeto', nome: '4. Informações do Projeto', disabled: false }, { id: 'analiseProjeto', nome: '5. Análise do Projeto', disabled: false }, { id: 'relatoriosProjeto', nome: '6. Download Relatório 222', disabled: false }],
	      selecionadosBriefing: ['sobreProjeto'],
	      proposta: {},
	      listaCarteiras: [],
	      codigoCarteiraProjeto: null,
	      carteiraSelecionada: null,
	      totais: {
	        fbb: {
	          aprovado: 0,
	          atual: 0
	        },
	        contrapartida: {
	          aprovado: 0,
	          atual: 0
	        },
	        parceiro: {
	          aprovado: 0,
	          atual: 0
	        },
	        aprovado: 0,
	        atual: 0
	      },
	      relatorioAnalise: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.buscaProposta();
	
	            case 2:
	              console.clear();
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	
	  methods: {
	    buscaAnalise: function buscaAnalise() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return axiosLaravel.get('propostas/' + _this2.proposta.id).then(function (response) {
	                  _this2.relatorioAnalise = JSON.parse(response.data.relatorio_analise);
	                }).catch(function (error) {
	                  _this2.$snotify.clear();
	                  _this2.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    buscaProposta: function buscaProposta() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this3.loading = true;
	                _this3.$aguarde('Carregando dados do projeto...');
	                _context3.next = 4;
	                return axiosLaravel.get('projeto/numero/' + _this3.$route.params.numero).then(function (response) {
	                  _this3.proposta = response.data;
	                }).catch(function (error) {
	                  _this3.$snotify.clear();
	                  _this3.$root.trataErro(error);
	                });
	
	              case 4:
	                _context3.next = 6;
	                return _this3.buscaCarteiras();
	
	              case 6:
	                _context3.next = 8;
	                return _this3.buscaAnalise();
	
	              case 8:
	                if (_this3.relatorioAnalise === null || _this3.relatorioAnalise === undefined) {
	                  _this3.dadosBriefing.find(function (item) {
	                    if (item.id === 'analiseProjeto') {
	                      item.disabled = true;
	                    }
	                  });
	                }
	                _this3.$snotify.clear();
	                _this3.$forceUpdate();
	                _this3.$snotify.success('Projeto carregado!', { timeout: 2000 });
	                _this3.loading = false;
	
	              case 13:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    buscaCarteiras: function buscaCarteiras() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return axiosLaravel.get('carteira/projeto/' + _this4.$route.params.numero).then(function (response) {
	                  if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	                    _this4.listaCarteiras = response.data.retorno['carteiras'];
	                    _this4.codigoCarteiraProjeto = response.data.retorno['carteira_projeto']['usu_codcart'];
	                    _this4.carteiraSelecionada = _this4.listaCarteiras.find(function (carteira) {
	                      if (carteira.usu_codcart === _this4.codigoCarteiraProjeto) {
	                        return carteira.usu_nomcart;
	                      } else {
	                        return undefined;
	                      }
	                    });
	                  } else {
	                    _this4.$snotify.error(response.data.mensagem);
	                  }
	                }).catch(function (error) {
	                  _this4.loading.show = false;
	                  console.log('error', error);
	                  _this4.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this4);
	      }))();
	    },
	    botaoDocumento: function botaoDocumento(event) {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var dadosParaArquivo, dataHoje, i;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this5.loading = true;
	                _this5.$snotify.clear();
	                dadosParaArquivo = {};
	                dataHoje = (0, _moment2.default)().format('LL');
	                _context5.t0 = event.target.id;
	                _context5.next = _context5.t0 === 'atestado' ? 7 : _context5.t0 === 'notificacaoAviso' ? 12 : _context5.t0 === 'notificacaoFinal' ? 17 : _context5.t0 === 'relatorioMonitoramento' ? 22 : _context5.t0 === 'briefing' ? 28 : 30;
	                break;
	
	              case 7:
	                dadosParaArquivo = {
	                  entidade: _this5.proposta.entidade.ds_nome,
	                  cnpj_entidade: _this5.proposta.entidade.ds_cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'),
	                  data_inicial_projeto: (0, _moment2.default)(_this5.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').format('DD-MM-YYYY'),
	                  data_final_projeto: (0, _moment2.default)(_this5.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').add(_this5.proposta.nr_periodos, 'M').format('DD-MM-YYYY'),
	                  data_hoje: dataHoje
	                };
	                _emiteDocumento2.default.methods.geraDocumento(dadosParaArquivo, 'atestado');
	                _this5.$snotify.clear();
	                _this5.$snotify.success('Arquivo gerado com sucesso', { timeout: 1000 });
	                return _context5.abrupt('break', 31);
	
	              case 12:
	                dadosParaArquivo = _this5.salvaDadosNotificacao();
	                _emiteDocumento2.default.methods.geraDocumento(dadosParaArquivo, 'notificacaoAviso');
	                _this5.$snotify.clear();
	                _this5.$snotify.success('Arquivo gerado com sucesso', { timeout: 1000 });
	                return _context5.abrupt('break', 31);
	
	              case 17:
	                dadosParaArquivo = _this5.salvaDadosNotificacao();
	                _emiteDocumento2.default.methods.geraDocumento(dadosParaArquivo, 'notificacaoFinal');
	                _this5.$snotify.clear();
	                _this5.$snotify.success('Arquivo gerado com sucesso', { timeout: 1000 });
	                return _context5.abrupt('break', 31);
	
	              case 22:
	                for (i = 0; i < _this5.proposta.objetivos.length; i++) {
	                  (0, _assign2.default)(_this5.proposta.objetivos[i], { cont: i + 1 });
	                }
	                dadosParaArquivo = {
	                  numero_projeto: _this5.proposta.ds_codigo_projeto_erp,
	                  projeto_nome: _this5.proposta.ds_nome,
	                  data_inicial_projeto: (0, _moment2.default)(_this5.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').format('DD-MM-YYYY'),
	                  data_final_projeto: (0, _moment2.default)(_this5.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').add(_this5.proposta.nr_periodos, 'M').format('DD-MM-YYYY'),
	                  nome_entidade: _this5.proposta.entidade.ds_nome,
	                  email_contato: _this5.proposta.ds_email_coordenador,
	                  telefones_contato: _this5.proposta.ds_celular_coordenador,
	                  atividades: _this5.proposta.atividades,
	                  metas: _this5.proposta.metas,
	                  objetivo_geral: _this5.proposta.ds_objetivo_geral,
	                  objetivos: _this5.proposta.objetivos,
	                  data_hoje: dataHoje
	                };
	                _emiteDocumento2.default.methods.geraDocumento(dadosParaArquivo, 'relatorioMonitoramento');
	                _this5.$snotify.clear();
	                _this5.$snotify.success('Arquivo gerado com sucesso', { timeout: 1000 });
	                return _context5.abrupt('break', 31);
	
	              case 28:
	                _this5.briefing = !_this5.briefing;
	                return _context5.abrupt('break', 31);
	
	              case 30:
	                return _context5.abrupt('break', 31);
	
	              case 31:
	                _this5.loading = false;
	
	              case 32:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this5);
	      }))();
	    },
	    salvaDadosNotificacao: function salvaDadosNotificacao() {
	      var dataHoje = (0, _moment2.default)().format('LL');
	
	      var temComplemento = this.proposta.entidade.endereco[0].ds_complemento === null || this.proposta.entidade.endereco[0].ds_complemento.isEmpty ? false : true;
	      var dados = {
	        entidade: this.proposta.entidade.ds_nome,
	        cnpj_entidade: this.proposta.entidade.ds_cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'),
	        endereco_rua: this.proposta.entidade.endereco[0].ds_rua,
	        endereco_numero: this.proposta.entidade.endereco[0].ds_numero,
	        endereco_complemento: temComplemento ? this.proposta.entidade.endereco[0].ds_complemento : null,
	        endereco_bairro: this.proposta.entidade.endereco[0].ds_bairro,
	        endereco_cep: this.proposta.entidade.endereco[0].ds_cep,
	        endereco_cidade: this.proposta.entidade.endereco[0].ds_cidade,
	        endereco_estado: this.proposta.entidade.endereco[0].ds_estado,
	        numero_projeto: this.proposta.ds_codigo_projeto_erp,
	        projeto_nome: this.proposta.ds_nome,
	        data_hoje: dataHoje
	      };
	      return dados;
	    },
	    gerarBriefing: function gerarBriefing() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        var dadosBriefing, i, dados, temComplemento, _i;
	
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this6.$aguarde('Gerando arquivo de briefing...');
	                _this6.loading = true;
	                dadosBriefing = {
	                  temSobreProjeto: false,
	                  temDadosEntidade: false,
	                  temDadosProjeto: false,
	                  temInfosProjeto: false,
	                  temAnaliseProjeto: false,
	                  temRelatoriosProjeto: false,
	                  sobreProjeto: {},
	                  dadosEntidade: {},
	                  dadosProjeto: {},
	                  infosProjeto: {},
	                  analiseProjeto: {},
	                  relatoriosProjeto: {},
	                  data_hoje: (0, _moment2.default)().format('LL')
	                };
	                i = 0;
	
	              case 4:
	                if (!(i < _this6.selecionadosBriefing.length)) {
	                  _context6.next = 42;
	                  break;
	                }
	
	                dados = {};
	                _context6.t0 = _this6.selecionadosBriefing[i];
	                _context6.next = _context6.t0 === 'sobreProjeto' ? 9 : _context6.t0 === 'dadosEntidade' ? 13 : _context6.t0 === 'dadosProjeto' ? 18 : _context6.t0 === 'infosProjeto' ? 27 : _context6.t0 === 'analiseProjeto' ? 31 : _context6.t0 === 'relatoriosProjeto' ? 35 : 38;
	                break;
	
	              case 9:
	                dadosBriefing.temSobreProjeto = true;
	                dados = {
	                  nome_projeto: _this6.proposta.ds_nome,
	                  numero_projeto: _this6.proposta.ds_codigo_projeto_erp,
	                  status_projeto: _this6.proposta.ds_situacao_erp,
	                  data_inicial_projeto: (0, _moment2.default)(_this6.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').format('DD-MM-YYYY'),
	                  data_final_execucao_projeto: (0, _moment2.default)(_this6.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').add(_this6.proposta.nr_periodos, 'M').format('DD-MM-YYYY'),
	                  meses_projeto: _this6.proposta.nr_periodos,
	                  data_final_vigencia_projeto: (0, _moment2.default)(_this6.proposta.dt_data_vigencia, 'YYYY-MM-DD').format('DD-MM-YYYY'),
	                  meses_vigencia_projeto: _this6.proposta.periodo_vigencia,
	                  carteira_projeto: _this6.carteiraSelecionada ? _this6.carteiraSelecionada.usu_nomcart : 'Projeto não encarteirado',
	                  projeto_superior: _this6.proposta.ds_projeto_superior,
	                  origem_recurso_projeto: {
	                    total_FBB: _this6.$root.formataNumero(_this6.totalizar(1), 'moeda'),
	                    total_contrapartida: _this6.$root.formataNumero(_this6.totalizar(2), 'moeda'),
	                    total_parceiro: _this6.$root.formataNumero(_this6.totalizar(5), 'moeda'),
	                    total_projeto: _this6.$root.formataNumero(_this6.totalizar(0), 'moeda')
	                  }
	                };
	                (0, _assign2.default)(dadosBriefing.sobreProjeto, dados);
	                return _context6.abrupt('break', 39);
	
	              case 13:
	                dadosBriefing.temDadosEntidade = true;
	                temComplemento = _this6.proposta.entidade.endereco[0].ds_complemento === null || _this6.proposta.entidade.endereco[0].ds_complemento.isEmpty ? false : true;
	
	                dados = {
	                  nome_entidade: _this6.proposta.entidade.ds_nome,
	                  cnpj_entidade: _this6.proposta.entidade.ds_cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'),
	                  endereco_rua: _this6.proposta.entidade.endereco[0].ds_rua,
	                  endereco_numero: _this6.proposta.entidade.endereco[0].ds_numero,
	                  endereco_complemento: temComplemento ? _this6.proposta.entidade.endereco[0].ds_complemento : null,
	                  endereco_bairro: _this6.proposta.entidade.endereco[0].ds_bairro,
	                  endereco_cep: _this6.proposta.entidade.endereco[0].ds_cep,
	                  endereco_cidade: _this6.proposta.entidade.endereco[0].ds_cidade,
	                  endereco_estado: _this6.proposta.entidade.endereco[0].ds_estado,
	                  nome_coordenador: _this6.proposta.ds_nome_coordenador,
	                  telefone_coordenador: _this6.proposta.ds_celular_coordenador,
	                  email_coordenador: _this6.proposta.ds_email_coordenador
	                };
	                (0, _assign2.default)(dadosBriefing.dadosEntidade, dados);
	                return _context6.abrupt('break', 39);
	
	              case 18:
	                _context6.next = 20;
	                return _this6.buscaCronograma();
	
	              case 20:
	                _this6.proposta.municipalizacao.forEach(function (item) {
	                  switch (item.ds_fase) {
	                    case '1':
	                      item['origem'] = 'Fundação';
	                      break;
	                    case '2':
	                      item['origem'] = 'Contrapartidada';
	                      break;
	                    case '5':
	                      item['origem'] = 'Parceiro';
	                      break;
	                    default:
	                      break;
	                  }
	                });
	                dadosBriefing.temDadosProjeto = true;
	                for (_i = 0; _i < _this6.proposta.objetivos.length; _i++) {
	                  (0, _assign2.default)(_this6.proposta.objetivos[_i], { cont: _i + 1 });
	                }
	                _this6.proposta.municipalizacao.map(function (item) {
	                  item.dc_valor_municipio = _this6.$root.formataNumero(item.dc_valor_municipio, 'moeda');
	                });
	                dados = {
	                  objetivo_geral: _this6.proposta.ds_objetivo_geral,
	                  objetivos: _this6.proposta.objetivos,
	                  metas: _this6.proposta.metas,
	                  atividades: _this6.proposta.atividades,
	                  valor_aprovado: {
	                    projeto: _this6.$root.formataNumero(_this6.totais.aprovado, 'moeda'),
	                    fbb: _this6.$root.formataNumero(_this6.totais.fbb.aprovado, 'moeda'),
	                    contrapartida: _this6.$root.formataNumero(_this6.totais.contrapartida.aprovado, 'moeda'),
	                    parceiro: _this6.$root.formataNumero(_this6.totais.parceiro.aprovado, 'moeda')
	                  },
	                  valor_atual: {
	                    projeto: _this6.$root.formataNumero(_this6.totais.atual, 'moeda'),
	                    fbb: _this6.$root.formataNumero(_this6.totais.fbb.atual, 'moeda'),
	                    contrapartida: _this6.$root.formataNumero(_this6.totais.contrapartida.atual, 'moeda'),
	                    parceiro: _this6.$root.formataNumero(_this6.totais.parceiro.atual, 'moeda')
	                  },
	                  publico_alvo: _this6.proposta.publicos_alvo,
	                  local_execucao: _this6.proposta.municipalizacao
	                };
	                (0, _assign2.default)(dadosBriefing.dadosProjeto, dados);
	                return _context6.abrupt('break', 39);
	
	              case 27:
	                dadosBriefing.temInfosProjeto = true;
	                dados = {
	                  introducao: _this6.proposta.ds_introducao,
	                  apresentacao: _this6.proposta.ds_apresentacao,
	                  territorio: _this6.proposta.ds_territorio,
	                  justificativa: _this6.proposta.ds_justificativa,
	                  objetivo_geral: _this6.proposta.ds_objetivo_geral,
	                  resultados_esperados: _this6.proposta.ds_resultados,
	                  operacionalizacao: _this6.proposta.ds_operacao,
	                  parcerias: _this6.proposta.ds_parceria,
	                  resumo: _this6.proposta.ds_resumo,
	                  acoes_comunicacao: _this6.proposta.ds_acoes_comunicacao
	                };
	                (0, _assign2.default)(dadosBriefing.infosProjeto, dados);
	                return _context6.abrupt('break', 39);
	
	              case 31:
	                dadosBriefing.temAnaliseProjeto = true;
	                dados = {
	                  parecer: _this6.relatorioAnalise.ds_parecer,
	                  observacao_valores: _this6.relatorioAnalise.ds_valores_observacoes,
	                  observacao_regularidade: _this6.relatorioAnalise.ds_regularidade_observacoes,
	                  observacao_licenciamento: _this6.relatorioAnalise.ds_licenciamento_observacoes,
	                  indicadores_resultado: _this6.relatorioAnalise.ds_indicadores_resultado,
	                  acoes_comunicacao: _this6.relatorioAnalise.ds_acoes_comunicacao
	                };
	                (0, _assign2.default)(dadosBriefing.analiseProjeto, dados);
	                return _context6.abrupt('break', 39);
	
	              case 35:
	                _context6.next = 37;
	                return _this6.buscaRelatorioErp();
	
	              case 37:
	                return _context6.abrupt('break', 39);
	
	              case 38:
	                return _context6.abrupt('break', 39);
	
	              case 39:
	                i++;
	                _context6.next = 4;
	                break;
	
	              case 42:
	                _emiteDocumento2.default.methods.geraDocumento(dadosBriefing, 'briefingProjeto');
	                _this6.$snotify.clear();
	                _this6.$snotify.success('Arquivo gerado com sucesso', { timeout: 4000 });
	                _this6.loading = false;
	
	              case 46:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this6);
	      }))();
	    },
	    totalizar: function totalizar(origem) {
	      var t = 0;
	      _.forEach(this.proposta.atividades, function (a) {
	        t += _.sumBy(a.itens_orcamentos, function (i) {
	          return '' + origem === '0' ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : '' + origem === ('' + i.origem).substr(0, 1) ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : 0;
	        });
	      });
	      return t;
	    },
	    valorProjetoOrigem: function valorProjetoOrigem(origem) {
	      var valorAprovado = 0;
	      var valorAtual = 0;
	      this.proposta.atividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos.length !== 0) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (item.origem === origem) {
	              valorAprovado += parseFloat(item.valorOrcado);
	              valorAtual += parseFloat(item.valorSaldo);
	            }
	          });
	        }
	      });
	      return { aprovado: valorAprovado, atual: valorAtual };
	    },
	    calculaTotais: function calculaTotais() {
	      var fbb = this.valorProjetoOrigem(1);
	      var contrapartida = this.valorProjetoOrigem(2);
	      var parceiro = this.valorProjetoOrigem(5);
	      this.totais.fbb.aprovado = fbb.aprovado;
	      this.totais.fbb.atual = fbb.atual;
	      this.totais.contrapartida.aprovado = contrapartida.aprovado;
	      this.totais.contrapartida.atual = contrapartida.atual;
	      this.totais.parceiro.aprovado = parceiro.aprovado;
	      this.totais.parceiro.atual = parceiro.atual;
	      this.totais.aprovado = fbb.aprovado + contrapartida.aprovado + parceiro.aprovado;
	      this.totais.atual = fbb.atual + contrapartida.atual + parceiro.atual;
	    },
	    buscaCronograma: function buscaCronograma() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this7.loading = true;
	                _context7.next = 3;
	                return axiosLaravel.post('processos/cronograma/projeto/', {
	                  'proposta': _this7.proposta.id,
	                  'processo': 'PAGAMENTO',
	                  'aglutinado': 'Completo',
	                  'documento': 0 }).then(function (response) {
	                  var saldos = response.data;
	                  _this7.proposta.atividades.forEach(function (atividade) {
	                    if (atividade.itens_orcamentos.length !== 0) {
	                      atividade.itens_orcamentos.forEach(function (item) {
	                        item['valorOrcado'] = _.sumBy(item.orcamentos_mensalizados, function (vo) {
	                          return vo.valor;
	                        });
	
	                        item['valorSaldo'] = _.sumBy(saldos.itens, function (vs) {
	                          return item.id === vs['Id_item'] ? vs['Valor_saldo'] : 0;
	                        });
	
	                        var valorOrcado = _.sumBy(saldos.itens, function (i) {
	                          return item.id === i['Id_item'] ? i['Valor_orcado'] : 0;
	                        });
	                        item['valorOrcado'] = item['valorOrcado'] !== valorOrcado ? valorOrcado : item['valorOrcado'];
	                      });
	                    }
	                  });
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this7.$root.trataErro(error);
	                });
	
	              case 3:
	                _this7.calculaTotais();
	                _this7.loading = false;
	
	              case 5:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this7);
	      }))();
	    },
	    buscaRelatorioErp: function buscaRelatorioErp() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        var dadosSolicitacao;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this8.loading = true;
	
	                _this8.$aguarde('Gerando relatório. Por favor, aguarde...');
	                dadosSolicitacao = {
	                  erpReport: {
	                    ds_codigo: 'FJCF222.GER'
	                  },
	                  params: '<ENumPrj=' + _this8.proposta.ds_codigo_projeto_erp + '><ESitPrj=ULT>'
	                };
	                _context8.next = 5;
	                return axiosLaravel.post('relatorio-erp/emitir', dadosSolicitacao).then(function (response) {
	                  _this8.onDownload(response);
	                });
	
	              case 5:
	                _this8.loading = false;
	
	              case 6:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this8);
	      }))();
	    },
	    onDownload: function onDownload(response) {
	      this.item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      this.file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (!ie) {
	        var blob = this.file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'Numero do projeto-' + this.proposta.ds_codigo_projeto_erp + '/222_extrato_projetos_analitico';
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = this.file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, this.item.name);
	        _link.download = 'Numero do projeto-' + this.proposta.ds_codigo_projeto_erp + '/222_extrato_projetos_analitico';
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    }
	  }
	};

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'visualiza-gestao-atividades',
	  data: function data() {
	    return {
	      loading: {
	        carregando: false,
	        gantt: true,
	        processando: false
	      },
	      hoje: new Date(),
	      numeroProjeto: undefined,
	      projeto: {},
	      listaProjetos: [],
	      atividades: [],
	      periodosOrcamento: {},
	      modoEdicao: false,
	      configuracoes: {
	        carteiraSelecionada: null,
	        numeroProjetoSelecionado: null,
	        altura: 20,
	        espacamento: 5,
	        larguraPadrao: 40,
	        larguraCabecalho: 200,
	        mostrarGantt: true,
	        mostrarLegenda: false,
	        mostrarGrade: true,
	        mostrarHoje: true,
	        mostrarOrcadoMensal: false,
	        mostrarRecursoMensal: [1],
	        mostrarOpcoes: false,
	        mostrarInfoExterno: true
	      },
	      alteracao: {
	        alterados: [],
	        justificativa: null
	      },
	      atividadesBackup: [],
	      atividadeEditando: null,
	      itemAtividadeEditando: null,
	      atividadeDetalhando: null
	    };
	  },
	
	  props: ['propsNumeroProjeto', 'propsAtividades', 'editavel', 'itensLayout', 'atividadesAlteradas', 'proposta', 'atualizarGantt'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    'propsAtividades': {
	      handler: function handler(after, before) {
	        if (!_.isEqual(after, before)) {
	          this.atualizarGanttPelaProposta();
	        }
	      },
	      deep: true
	    },
	    editavel: function editavel() {
	      this.modoEdicaoEntrarSair(this.editavel);
	    },
	    atividadeEditando: function atividadeEditando() {
	      this.$emit('validacaoAtividadesGantt', { 'tag': 'atividadeEditandoGantt', 'ativo': !_.isEmpty(this.atividadeEditando), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Atividade em edição' });
	    },
	    'alteracao.justificativa': function alteracaoJustificativa() {
	      if (_.includes(this.itensLayout, 'justificativa')) {
	        this.$emit('validacaoAtividadesGantt', { 'tag': 'justificativaFaltando', 'ativo': _.isEmpty(this.alteracao.justificativa), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Não foi informada a justificativa para alteração' });
	      }
	    }
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    if (this.usuarioLogado.configuracoes.gantt_atividades) {
	      this.configuracoes = this.usuarioLogado.configuracoes.gantt_atividades;
	    }
	    this.numeroProjeto = this.propsNumeroProjeto;
	    if (this.numeroProjeto) {
	      if (_.isUndefined(this.atualizarGantt) || this.atualizarGantt) {
	        this.carregaAtividades();
	      } else {
	        this.atualizarGanttPelaProposta();
	      }
	    } else {
	      this.carregarListaProjetos();
	    }
	  },
	
	  methods: {
	    carregaAtividades: function carregaAtividades() {
	      var _this = this;
	
	      if (!this.loading.carregando) {
	        this.loading.carregando = true;
	        axiosLaravel.get('atividade/gestao/' + this.numeroProjeto).then(function (response) {
	          _this.$snotify.clear();
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this.projeto = response.data.retorno.projeto;
	            _this.atualizarGanttPelaProposta();
	            _this.atividadesBackup = _.cloneDeep(_this.atividades);
	            _this.$emit('atividadesGantt', _this.atividadesBackup);
	            if (_this.editavel) {
	              _this.modoEdicaoEntrarSair(true);
	            }
	            _this.$emit('atividadesAlteracoes', _this.alteracao);
	          } else {
	            _this.$snotify.error(response.data.mensagem);
	          }
	          _this.loading.carregando = false;
	        }).catch(function (error) {
	          _this.loading.carregando = false;
	          _this.$snotify.clear();
	          _this.$root.trataErro(error);
	        });
	      }
	    },
	    atualizarGanttPelaProposta: function atualizarGanttPelaProposta() {
	      var _this2 = this;
	
	      this.loading.processando = true;
	      if (_.isEmpty(this.projeto)) {
	        this.projeto = {
	          'inicio': this.proposta.dt_assinatura_convenio,
	          'termino': (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(this.proposta.nr_periodos, 'M').format('YYYY-MM-DD'),
	          'periodos': this.proposta.nr_periodos,
	          'numero': this.proposta.ds_codigo_projeto_erp,
	          'nome': this.proposta.ds_nome,
	          'situacao': this.proposta.ds_situacao_erp,
	          'id_projeto': this.proposta.id
	        };
	      }
	      if (this.propsAtividades) {
	        var atividades = [];
	        this.propsAtividades.forEach(function (atividade) {
	          var mensalizacao = {};
	          var itens = [];
	          _.get(atividade, 'itens_orcamentos', []).forEach(function (item) {
	            var origem = _.toNumber(('' + item.origem).slice(0, 1));
	            _.set(item, 'origem', origem);
	            _.set(item, 'periodo', [item.periodo_inicial, item.periodo_final]);
	            itens.push(_.pick(item, ['id', 'adiantavel', 'origem', 'fk_itens', 'observacao', 'valorOrcado', 'valorSaldo', 'percAtingimento', 'periodo_inicial', 'periodo_final', 'periodo']));
	
	            _.get(item, 'orcamentos_mensalizados', []).forEach(function (mensalizado) {
	              var periodoOrigemTotal = _.get(mensalizacao, [mensalizado.periodo, origem], 0);
	              var periodoTotal = _.get(mensalizacao, [mensalizado.periodo, 0], 0);
	              _.set(mensalizacao, [mensalizado.periodo, origem], periodoOrigemTotal + mensalizado.valor);
	              _.set(mensalizacao, [mensalizado.periodo, 0], periodoTotal + mensalizado.valor);
	            });
	          });
	          console.log('itens', itens);
	          var atividadeSimplificada = {
	            'id': atividade.id,
	            'inicio': atividade.nr_periodo_inicial,
	            'termino': atividade.nr_periodo_final,
	            'descricao': atividade.ds_nome,
	            'orcado': atividade.valorOrcado,
	            'executado': atividade.valorOrcado - atividade.valorSaldo,
	            'periodo': [atividade.nr_periodo_inicial, atividade.nr_periodo_final],
	            'mensalizacao': mensalizacao,
	            'itens': _.clone(itens),
	            'expandir': atividade.id === _.get(_this2.atividadeEditando, 'id', 0)
	          };
	          atividades.push(atividadeSimplificada);
	          if (_.get(_this2.atividadeEditando, 'id', 0) === atividadeSimplificada.id) {
	            _this2.atividadeEditando = _.cloneDeep(atividadeSimplificada);
	            if (_this2.atividadesAlteradas && _.includes(_this2.atividadesAlteradas, atividadeSimplificada.id)) {
	              _this2.okAlteracaoAtividade();
	            }
	          }
	        });
	        this.atividades = atividades;
	        this.$forceUpdate();
	        this.loading.processando = false;
	        this.calculaOrcamentoMensal();
	      }
	    },
	    calculaOrcamentoMensal: function calculaOrcamentoMensal() {
	      var periodosOrcamento = {};
	      this.propsAtividades.forEach(function (atividade) {
	        if (_.has(atividade, 'itens_orcamentos') && atividade.itens_orcamentos.length > 0) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (_.has(item, 'orcamentos_mensalizados') && item.orcamentos_mensalizados.length > 0) {
	              item.orcamentos_mensalizados.forEach(function (mensalizacao) {
	                var periodoOrigemTotal = _.get(periodosOrcamento, [item.origem, mensalizacao.periodo], 0);
	                _.set(periodosOrcamento, [item.origem, mensalizacao.periodo], periodoOrigemTotal + mensalizacao.valor);
	              });
	            }
	          });
	        }
	      });
	      this.periodosOrcamento = periodosOrcamento;
	      this.$forceUpdate();
	    },
	    periodoParaMesAno: function periodoParaMesAno(periodo, inicioProjeto, formato) {
	      return (0, _moment2.default)(inicioProjeto).add(periodo - 1, 'month').format(formato);
	    },
	    dataParaPeriodo: function dataParaPeriodo(data, inicio) {
	      var dataAjustada = (0, _moment2.default)(data).format('YYYY-MM-01');
	      var inicioAjustado = (0, _moment2.default)(inicio).format('YYYY-MM-01');
	      return (0, _moment2.default)(dataAjustada).diff((0, _moment2.default)(inicioAjustado), 'month') + 1;
	    },
	    modoEdicaoEntrarSair: function modoEdicaoEntrarSair(editavel) {
	      this.modoEdicao = editavel;
	      if (!this.modoEdicao) {
	        this.atividadeEditando = {};
	        this.itemAtividadeEditando = {};
	      } else {
	        this.atividadeEditando = _.find(this.atividades, ['expandir', true]) || {};
	      }
	    },
	    verificaAlteracaoPeriodoAtividadeItem: function verificaAlteracaoPeriodoAtividadeItem(id) {
	      var atividadeAtual = _.find(this.atividades, ['id', id]);
	      var atividadeBackup = _.find(this.atividadesBackup, ['id', id]);
	      var comparacaoPeriodoAtividade = _.isEqual(atividadeAtual.periodo, atividadeBackup.periodo);
	      var comparacaoPeriodoItens = _.isEqual(_.map(atividadeAtual.itens, 'periodo'), _.map(atividadeBackup.itens, 'periodo'));
	      return comparacaoPeriodoAtividade && comparacaoPeriodoItens;
	    },
	    reverterAlteracaoAtividade: function reverterAlteracaoAtividade(id) {
	      var atividadeIdx = _.findIndex(this.atividadesBackup, ['id', id]);
	      if (_.get(this.atividadeEditando, 'id', 0) === id) {
	        var expandir = this.atividadeEditando.expandir;
	        this.atividadeEditando = _.cloneDeep(this.atividadesBackup[atividadeIdx]);
	        _.set(this.atividadeEditando, 'expandir', expandir);
	      }
	      this.propsAtividades[atividadeIdx] = _.cloneDeep(this.atividadesBackup[atividadeIdx]);
	      this.atividades[atividadeIdx] = _.cloneDeep(this.atividadesBackup[atividadeIdx]);
	      this.$forceUpdate();
	    },
	    alterarAtividade: function alterarAtividade(atividade) {
	      if (this.modoEdicao && atividade.executado < atividade.orcado) {
	        this.atividadeEditando = _.clone(atividade);
	        this.atividadeEditando['periodo'] = [this.atividadeEditando.inicio, this.atividadeEditando.termino];
	      }
	    },
	    expandirAtividade: function expandirAtividade(atividade) {
	      var atividadeAtualExpandida = atividade.expandir;
	      this.atividades.forEach(function (atv) {
	        atv.expandir = false;
	      });
	      atividade.expandir = !atividadeAtualExpandida;
	      this.alterarAtividade(atividade);
	      this.$forceUpdate();
	    },
	    okAlteracaoAtividade: function okAlteracaoAtividade() {
	      var _this3 = this;
	
	      this.loading.processando = true;
	
	      _.set(this.atividadeEditando, 'inicio', this.atividadeEditando.periodo[0]);
	      _.set(this.atividadeEditando, 'termino', this.atividadeEditando.periodo[1]);
	
	      var atividadeAlterada = _.find(this.atividades, ['id', this.atividadeEditando.id]);
	      _.set(atividadeAlterada, 'inicio', this.atividadeEditando.inicio);
	      _.set(atividadeAlterada, 'termino', this.atividadeEditando.termino);
	
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.id === _this3.atividadeEditando.id) {
	          _.set(atividade, 'nr_periodo_inicial', _this3.atividadeEditando.inicio);
	          _.set(atividade, 'nr_periodo_final', _this3.atividadeEditando.termino);
	          if (_.has(atividade, 'itens_orcamentos')) {
	            atividade.itens_orcamentos.forEach(function (item) {
	              if (('' + item.origem).slice(0, 1) === '2') {
	                item.periodo_final = _this3.atividadeEditando.termino;
	                item.periodo_inicial = _this3.atividadeEditando.termino;
	              } else {
	                if (('' + item.fk_itens).slice(0, 1) === 'P') {
	                  item.periodo_inicial = _this3.atividadeEditando.inicio;
	                  item.periodo_final = _this3.atividadeEditando.inicio;
	                } else if (('' + item.fk_itens).slice(0, 1) === 'S') {
	                  item.periodo_inicial = _this3.atividadeEditando.inicio;
	                  item.periodo_final = _this3.atividadeEditando.termino;
	                } else {
	                  console.log('Item que não é produto nem serviço');
	                }
	              }
	
	              var orcamentosMensalizados = [];
	              var valor = item.valorOrcado / (item.periodo_final - item.periodo_inicial + 1);
	              for (var i = item.periodo_inicial; i <= item.periodo_final; i++) {
	                orcamentosMensalizados.push({ 'periodo': i, 'valor': valor });
	              }
	              item.orcamentos_mensalizados = orcamentosMensalizados;
	            });
	          }
	        }
	      });
	      this.itemAtividadeEditando = null;
	      this.$forceUpdate();
	      this.loading.processando = false;
	    },
	    okAlteracaoItem: function okAlteracaoItem() {
	      var _this4 = this;
	
	      this.loading.processando = true;
	
	      _.set(this.itemAtividadeEditando, 'inicio', this.itemAtividadeEditando.periodo[0]);
	      _.set(this.itemAtividadeEditando, 'termino', this.itemAtividadeEditando.periodo[1]);
	
	      var itemAlterado = _.find(_.find(this.atividades, ['id', this.atividadeEditando.id]), ['id', this.itemAtividadeEditando.id]);
	      _.set(itemAlterado, 'inicio', this.itemAtividadeEditando.inicio);
	      _.set(itemAlterado, 'termino', this.itemAtividadeEditando.termino);
	
	      this.propsAtividades.forEach(function (atividade) {
	        if (atividade.id === _this4.atividadeEditando.id) {
	          _.set(atividade, 'nr_periodo_inicial', _this4.atividadeEditando.inicio);
	          _.set(atividade, 'nr_periodo_final', _this4.atividadeEditando.termino);
	          if (_.has(atividade, 'itens_orcamentos')) {
	            atividade.itens_orcamentos.forEach(function (item) {
	              if (item.id === _this4.itemAtividadeEditando.id) {
	                item.periodo_inicial = _this4.itemAtividadeEditando.inicio;
	                item.periodo_final = _this4.itemAtividadeEditando.termino;
	              }
	
	              var orcamentosMensalizados = [];
	              var valor = item.valorOrcado / (item.periodo_final - item.periodo_inicial + 1);
	              for (var i = item.periodo_inicial; i <= item.periodo_final; i++) {
	                orcamentosMensalizados.push({ 'periodo': i, 'valor': valor });
	              }
	              item.orcamentos_mensalizados = orcamentosMensalizados;
	            });
	          }
	        }
	      });
	      this.$forceUpdate();
	      this.loading.processando = false;
	    },
	    cancelaAlteracao: function cancelaAlteracao() {
	      this.atividadeEditando = null;
	    },
	    carregarListaProjetos: function carregarListaProjetos() {
	      var _this5 = this;
	
	      this.loading.carregando = true;
	      axiosLaravel.post('carteira/lista_projetos/', { 'situacoesProjeto': ['APR', 'ENC', 'SO3'] }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this5.listaProjetos = response.data.retorno;
	          _this5.configuracoes.numeroProjetoSelecionado = _this5.listaProjetos[0]['ds_codigo_projeto_erp'] || null;
	          _this5.selecionaProjeto();
	        } else {
	          _this5.$snotify.error(response.data.mensagem);
	        }
	        _this5.loading.carregando = false;
	      }).catch(function (error) {
	        _this5.loading.carregando = false;
	        console.log('error', error);
	        _this5.$root.trataErro(error);
	      });
	    },
	    selecionaProjeto: function selecionaProjeto() {
	      this.numeroProjeto = this.configuracoes.numeroProjetoSelecionado;
	      this.atividadeEditando = null;
	      this.alteracao = { alterados: [], justificativa: null };
	      this.modoEdicao = false;
	      this.carregaAtividades();
	      this.salvarConfiguracoes();
	    },
	    percentual: function percentual(valor, base) {
	      var decimais = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var limitar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      var percentagem = parseFloat(base) === 0 ? 0 : parseFloat(valor) / parseFloat(base) * 100;
	      if (limitar) {
	        percentagem = percentagem < 0 ? 0 : percentagem > 100 ? 100 : percentagem;
	      }
	      return percentagem.toFixed(decimais);
	    },
	    moeda: function moeda(numero) {
	      numero = _.toNumber(numero);
	      return !isNaN(numero) ? numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }) : '';
	    },
	    configuracaoPadrao: function configuracaoPadrao() {
	      this.configuracoes = { carteiraSelecionada: null, projetoSelecionado: {}, altura: 20, espacamento: 5, larguraPadrao: 40, larguraCabecalho: 200, mostrarGrade: true, mostrarHoje: true, mostrarOpcoes: false, mostrarInfoExterno: true, mostrarGantt: true, mostrarOrcadoMensal: false, mostrarRecursoMensal: [1] };
	      this.salvarConfiguracoes();
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this6 = this;
	
	      _.set(this.usuarioLogado, 'configuracoes.gantt_atividades', this.configuracoes);
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {
	        console.log('Configurações salvas');
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this6.$root.trataErro(error);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _avaliacoesProjeto = __webpack_require__(512);
	
	var _avaliacoesProjeto2 = _interopRequireDefault(_avaliacoesProjeto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    AvaliacoesProjeto: _avaliacoesProjeto2.default
	  },
	  name: 'lista-projetos',
	  data: function data() {
	    return {
	      data: [],
	      loading: {
	        show: false
	      },
	      itemsProjetos: [],
	      items: [],
	      configuracoes: {
	        tela_projetos: {
	          codigoCarteira: null
	        }
	      },
	      listaCarteiras: [],
	      carteiraSelecionada: null,
	      pesquisa: '',
	      filtrosProjetos: {
	        createdAt: null
	      },
	      filtros: {
	        createdBy: null
	      },
	      fieldsProjetos: [{ key: 'ds_codigo_projeto_erp', label: 'Nº Projeto', thStyle: 'width: 100px; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'ds_nome', label: 'Projeto', thStyle: 'text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'usu_nomcart', label: 'Carteira', thStyle: 'width: 150px; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'actions', label: 'Acessar:', thStyle: 'width: 300px; text-align: center', 'class': 'text-center' }],
	      tableProjetos: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        filter: null,
	        bordered: true
	      },
	      ehParceiroEstrategico: false,
	      store: this.$store
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    mounted: function mounted() {}
	  }, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    if (this.usuarioLogado.userType !== 'FUNDACAO') {
	      _.remove(this.fieldsProjetos, function (campo) {
	        return campo.key === 'usu_nomcart';
	      });
	    }
	    this.ehParceiroEstrategico = this.usuarioLogado.perfis.some(function (perfil) {
	      return perfil.ds_nome === 'Parceiro Estratégico';
	    });
	    this.buscaProjetos();
	    this.$aguarde('Buscando projetos. Por favor, aguarde...');
	  },
	  methods: {
	    buscaProjetos: function buscaProjetos() {
	      var _this = this;
	
	      this.itemsProjetos = null;
	      this.loading.show = true;
	      var endpoint = 'projetos';
	      if (this.ehParceiroEstrategico) {
	        endpoint = 'parceiroEstrategico/projetos';
	      }
	      axiosLaravel.get(endpoint).then(function (response) {
	        _this.$snotify.clear();
	
	        var listaProjetos = response.data;
	        var acessosProjetos = _.get(_this.usuarioLogado, 'configuracoes.acesso_projetos');
	        if (acessosProjetos) {
	          acessosProjetos.forEach(function (projeto) {
	            if (_.find(projeto.acesso, ['codigo', 'SEM_ACESSO'])) {
	              _.remove(listaProjetos, ['ds_codigo_projeto_erp', projeto.numero]);
	            }
	          });
	        }
	        _this.itemsProjetos = listaProjetos;
	        _this.cleanItemsProjetos = _this.itemsProjetos;
	        _this.loading.show = false;
	        _this.tableProjetos.totalRows = _this.itemsProjetos.length;
	        if (_this.usuarioLogado.userType === 'FUNDACAO') {
	          _this.carregarListaCarteiras();
	        }
	        _this.$snotify.success('Projetos carregados com sucesso!', { timeout: 1000 });
	      }).catch(function (error) {
	        _this.$snotify.clear();
	        _this.$snotify.error(error);
	        _this.loading.show = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.tableProjetos.totalRows = filteredItems.length;
	      this.tableProjetos.currentPage = 1;
	    },
	    ajustaPesquisa: function ajustaPesquisa() {
	      this.tableProjetos.filter = _.isNull(this.pesquisa) || this.pesquisa === '' ? 'retornar_todos_projetos' : this.pesquisa;
	    },
	    filtroPorItem: function filtroPorItem(row, filter) {
	      var saida = true;
	      if (!_.isNull(this.carteiraSelecionada) && _.isNumber(this.carteiraSelecionada)) {
	        saida = row.usu_codcart === this.carteiraSelecionada;
	      }
	      if (filter !== 'retornar_todos_projetos') {
	        var termo = _.toLower(filter);
	        saida = saida && (_.toLower(row.ds_codigo_projeto_erp).indexOf(termo) !== -1 || _.toLower(row.ds_nome).indexOf(termo) !== -1);
	      }
	      return saida;
	    },
	    selecionaCarteira: function selecionaCarteira() {
	      var _this2 = this;
	
	      if (_.isNull(this.carteiraSelecionada)) {
	        this.itemsProjetos = this.cleanItemsProjetos;
	      } else {
	        this.itemsProjetos = this.cleanItemsProjetos.filter(function (item) {
	          return item.usu_ncodcart === _this2.carteiraSelecionada;
	        });
	      }
	      this.configuracoes.tela_projetos.codigoCarteira = this.carteiraSelecionada;
	      this.salvarConfiguracoes();
	    },
	    carregarListaCarteiras: function carregarListaCarteiras() {
	      var _this3 = this;
	
	      this.loading.show = true;
	      axiosLaravel.get('carteira/lista').then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this3.listaCarteiras = response.data.retorno;
	          _this3.configuracoes.tela_projetos.codigoCarteira = _.get(_this3.usuarioLogado, 'configuracoes.tela_projetos.codigoCarteira') || null;
	          console.log('carrega carteiras this.configuracoes', _this3.configuracoes);
	        } else {
	          _this3.$snotify.error(response.data.mensagem);
	        }
	        _this3.loading.show = false;
	      }).catch(function (error) {
	        _this3.loading.show = false;
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this4 = this;
	
	      _.set(this.usuarioLogado, 'configuracoes', this.configuracoes);
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {
	        console.log('configuracoes', _this4.usuarioLogado.configuracoes);
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this4.$root.trataErro(error);
	        }
	      });
	    },
	    onVisualizate: function onVisualizate(row) {}
	  }
	};

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaRelExec',
	  data: function data() {
	    return {
	      data: [],
	      titulo: 'SGP',
	      configuracoes: {
	        altura: 25,
	        zoom: 1,
	        mostrarGrade: true,
	        mostrarHoje: true,
	        mostrarExcluidos: false,
	        mostrarLegenda: true,
	        tutorial: {
	          concluido: false,
	          passo: 1
	        }
	      },
	      mostrarOpcoes: true,
	      hoje: new Date(),
	      relatorioEditando: null,
	      modoEdicao: false,
	      desabilitarDatas: {
	        from: new Date(),
	        to: new Date()
	      },
	      loading: {
	        carregando: false,
	        processando: false
	      },
	      relatorios: [],
	      relatoriosBackup: [],
	      alteracao: {
	        incluidos: [],
	        excluidos: [],
	        alterados: [],
	        justificativa: null
	      },
	      coresSituacao: [{ termo: 'aprovado', corTexto: '#008000', corFundo: '#00ff1c33' }, { termo: 'análise', corTexto: '#1d0fff', corFundo: '#0065ff33' }, { termo: 'pendente', corTexto: '#1d0fff', corFundo: '#0065ff33' }, { termo: 'devolvido', corTexto: '#1d0fff', corFundo: '#0065ff33' }, { termo: 'não apresentado', corTexto: '#ff0000', corFundo: '#ff000033' }, { termo: 'projeto encerrado', corTexto: '#ff0000', corFundo: '#ff000033' }, { termo: 'fora do período', corTexto: '#ff9e00', corFundo: 'transparent' }, { termo: 'excluído', corTexto: '#dd4b39', corFundo: '#f0f0f033' }],
	      validacaoPeriodos: [],
	      mostrarGantt: true,
	      formatter1: '',
	      relatorio: {},
	      filtro: {
	        createdAt: null
	      },
	      statusERP: [],
	      blockStatusERP: false,
	      projeto: {},
	      ativado: false,
	      fieldsRelatorios: [{ key: 'sequencia', label: 'Período do relatório', thStyle: 'width:6%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'final_ciclo', label: 'Final do Ciclo', thStyle: 'width: 10%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'apresentado_em', label: 'Apresentado em', thStyle: 'width: 10%; text-align: center', sortable: true, 'class': 'word-wrap:break-word text-center' }, { key: 'aprovado_em', label: 'Aprovado em', thStyle: 'width: 10%; text-align: center', sortable: true, 'class': 'text-center' }, { key: 'situacao', label: 'Situação', thStyle: 'width:  12%; text-align: center', 'class': 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'width: 5.7%; text-align: center', 'class': 'text-center' }],
	      tableRelatorios: {
	        currentPage: 1,
	        perPage: 20,
	        sortBy: 'sequencia',
	        sortDesc: false,
	        filter: null,
	        bordered: true
	      },
	      store: this.$store,
	      ehParceiroEstrategico: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    finPer: function finPer() {
	      return (0, _moment2.default)(this.relatorios.finPer).format('DD/MM/YYYY');
	    },
	    idProjeto: function idProjeto() {
	      return this.relatorios[0].id_projeto;
	    },
	    qtdeRelatoriosTela: function qtdeRelatoriosTela() {
	      var vm = this;
	      return _.countBy(vm.relatorios, function (r) {
	        return !_.includes(['Excluído via Sapiens', 'Excluído via SGP'], r.situacao) || vm.configuracoes.mostrarExcluidos && _.includes(['Excluído via Sapiens', 'Excluído via SGP'], r.situacao);
	      })['true'];
	    },
	    idProposta: function idProposta() {
	      return this.relatorios[0].id_proposta;
	    }
	  }),
	  created: function created() {
	    this.ehParceiroEstrategico = this.usuarioLogado.perfis.some(function (perfil) {
	      return perfil.ds_nome === 'Parceiro Estratégico';
	    });
	    if (_.has(this.usuarioLogado, 'configuracoes') && _.has(this.usuarioLogado.configuracoes, 'cronograma_relatorios_execucao')) {
	      this.configuracoes = this.usuarioLogado.configuracoes.cronograma_relatorios_execucao;
	    }
	    this.listaRelatorios();
	  },
	  methods: {
	    configuracaoPadrao: function configuracaoPadrao() {
	      this.configuracoes = { 'altura': 25, 'zoom': 1, 'mostrarGrade': true, 'mostrarHoje': true, 'mostrarExcluidos': false, 'mostrarLegenda': true, 'tutorial': { 'concluido': true, passo: 1 } };
	      this.salvarConfiguracoes();
	    },
	    listaRelatorios: function listaRelatorios() {
	      var _this = this;
	
	      if (!this.$route.params.id || this.$route.params.id === 'undefined') {
	        this.$router.go(-1);
	        return;
	      }
	      this.titulo = 'SGP Carregando Relatórios de Execução';
	      this.$aguarde('Lendo Cronograma de Relatórios de Execução...');
	      this.loading.carregando = true;
	      var endpoint = '/relatorio_execucao/busca_relatorios/';
	      if (this.ehParceiroEstrategico) {
	        endpoint = '/parceiroEstrategico/busca_relatorios/';
	      }
	      axiosLaravel.get(endpoint + this.$route.params.id).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          if (_.isEmpty(response.data.retorno) || response.data.retorno.length === 0) {
	            _this.$snotify.clear();
	            _this.$snotify.error('Este projeto não tem Relatórios de Execução no SGP');
	            _this.loading.carregando = false;
	            _this.titulo = 'SGP - Sem Relatórios de Execução';
	          } else {
	            _this.relatorios = response.data.retorno;
	            _this.relatoriosBackup = _.cloneDeep(response.data.retorno);
	
	            _this.projeto['nome'] = _this.relatorios[0].projeto;
	            _this.projeto['numero'] = _this.relatorios[0].numero;
	            _this.projeto['data_vigencia_projeto'] = _this.relatorios[0].data_vigencia_projeto;
	            _this.projeto['data_aprovacao_projeto'] = _this.relatorios[0].data_aprovacao_projeto;
	            _this.projeto['data_final_projeto'] = _this.relatorios[0].data_final_projeto;
	            _this.projeto['situacao_projeto'] = _this.relatorios[0].situacao_projeto;
	            if (_.includes(['ENC', 'ESE'], _this.projeto['situacao_projeto'])) {
	              _this.configuracoes.mostrarHoje = false;
	              _this.configuracoes.mostrarExcluidos = false;
	            }
	            var mesReferenciaAprovacao = (0, _moment2.default)(_this.projeto['data_aprovacao_projeto']).startOf('month');
	            _this.projeto['lista_meses'] = [];
	            var dataTerminoProjeto = (0, _moment2.default)(_this.projeto['data_final_projeto']);
	            do {
	              _this.projeto['lista_meses'].push(mesReferenciaAprovacao);
	              mesReferenciaAprovacao = (0, _moment2.default)(mesReferenciaAprovacao).add(1, 'month');
	            } while (dataTerminoProjeto.isAfter(mesReferenciaAprovacao));
	            _this.projeto['dias'] = {
	              'duracao': _this.dias(_this.projeto.data_aprovacao_projeto, _this.projeto.data_final_projeto),
	              'ateHoje': _this.dias(_this.projeto.data_aprovacao_projeto, _this.hoje)
	            };
	            _this.correcoesPeriodos();
	            _this.loading.carregando = false;
	            _this.$snotify.clear();
	            _this.$snotify.success('Cronograma carregado!', { timeout: 1000 });
	            _this.titulo = 'SGP - ' + _this.projeto.numero + ' - ' + _this.projeto.nome;
	          }
	        } else {
	          _this.$snotify.clear();
	          _this.$snotify.error(response.data.mensagem, { timeout: 1000 });
	        }
	      }).catch(function (error) {
	        console.log('error', error);
	        _this.$root.trataErro(error);
	        _this.$snotify.clear();
	      });
	    },
	    validandoPeriodos: function validandoPeriodos() {
	      var _this2 = this;
	
	      this.validacaoPeriodos = [];
	      var relatoriosAtivos = this.relatoriosAtivos();
	
	      relatoriosAtivos.forEach(function (relatorioPrazoMinimo) {
	        if (_this2.dias(relatorioPrazoMinimo['antes_30_final_ciclo'], relatorioPrazoMinimo['depois_30_final_ciclo']) < 60) {
	          console.log('Prazo minimo não observado');
	          _this2.validacaoPeriodos.push({ 'relatorio1': relatorioPrazoMinimo, 'relatorio2': relatorioPrazoMinimo, 'inicio': relatorioPrazoMinimo['antes_30_final_ciclo'], 'termino': relatorioPrazoMinimo['depois_30_final_ciclo'], 'tipo': 'Não tem prazo mínimo 60 dias' });
	        }
	      });
	
	      relatoriosAtivos.forEach(function (relatorio1) {
	        relatoriosAtivos.forEach(function (relatorio2) {
	          if (relatorio2.sequencia > relatorio1.sequencia) {
	            if ((0, _moment2.default)(relatorio1.termino_preenchimento).isAfter(relatorio2.inicio_preenchimento)) {
	              var tipo = 'Há sobreposição com o relatório nº ' + relatorio2.sequencia;
	              if ((0, _moment2.default)(relatorio1.inicio_preenchimento).isAfter(relatorio2.termino_preenchimento)) {
	                tipo = 'Começa depois de relatório nº ' + relatorio2.sequencia;
	              }
	              _this2.validacaoPeriodos.push({ 'relatorio1': relatorio1, 'relatorio2': relatorio2, 'inicio': relatorio2.inicio_preenchimento, 'termino': relatorio1.termino_preenchimento, 'tipo': tipo });
	            }
	          }
	        });
	      });
	    },
	    correcoesPeriodos: function correcoesPeriodos() {
	      var _this3 = this;
	
	      var relatoriosAtivos = this.relatoriosAtivos();
	      relatoriosAtivos.forEach(function (relatorio) {
	        relatorio['antes_30_final_ciclo'] = (0, _moment2.default)(relatorio.final_ciclo).subtract(30, 'days').format('YYYY-MM-DD');
	        relatorio['depois_30_final_ciclo'] = (0, _moment2.default)(relatorio.final_ciclo).add(30, 'days').format('YYYY-MM-DD');
	
	        var relatorioSeguinte = _.find(relatoriosAtivos, function (rel) {
	          return rel.sequencia > relatorio.sequencia;
	        });
	        relatorio['termino_preenchimento'] = relatorioSeguinte ? (0, _moment2.default)(relatorioSeguinte.inicio_preenchimento).subtract(1, 'days').format('YYYY-MM-DD') : _this3.projeto.data_final_projeto;
	
	        if (_this3.dias(relatorio['inicio_preenchimento'], relatorio['termino_preenchimento']) < 60) {
	          relatorio['termino_preenchimento'] = relatorio['depois_30_final_ciclo'];
	          relatorio['termino_concluir'] = relatorio['depois_30_final_ciclo'];
	        }
	      });
	
	      var ultimoRelatorio = _.last(relatoriosAtivos);
	      if (this.projeto.dias.ateHoje > this.projeto.dias.duracao) {
	        ultimoRelatorio['termino_preenchimento'] = ultimoRelatorio.aprovado_em === '1900-01-01' || _.isNull(ultimoRelatorio.aprovado_em) ? this.hoje : (0, _moment2.default)(ultimoRelatorio.aprovado_em).add(5, 'days').format('YYYY-MM-DD');
	        ultimoRelatorio['termino_concluir'] = ultimoRelatorio['termino_preenchimento'];
	      }
	      this.validandoPeriodos();
	    },
	    atualizaAlteracao: function atualizaAlteracao() {
	      var diasAlterado = this.relatorioEditando.alteracaoDias - this.dias(this.projeto.data_aprovacao_projeto, this.relatorioEditando.final_ciclo) - 1;
	      this.relatorioEditando.final_ciclo = (0, _moment2.default)(this.relatorioEditando.final_ciclo).add(diasAlterado, 'days').format('YYYY-MM-DD');
	      this.okEdicao();
	    },
	    limiteAlteracaoFinalCiclo: function limiteAlteracaoFinalCiclo() {
	      var vm = this;
	      this.relatorioEditando.minimo = 0;
	      this.relatorioEditando.maximo = this.projeto.dias.duracao + 1;
	      var relatoriosAtivos = this.relatoriosAtivos();
	      var relatorioAnterior = _.find(relatoriosAtivos, function (rel) {
	        return rel.sequencia < vm.relatorioEditando.sequencia;
	      });
	      this.relatorioEditando.minimo = relatorioAnterior ? this.dias(this.projeto.data_aprovacao_projeto, (0, _moment2.default)(relatorioAnterior.depois_30_final_ciclo).add(31, 'days').format('YYYY-MM-DD')) : 1;
	      this.relatorioEditando.alteracaoDias = this.dias(this.projeto.data_aprovacao_projeto, this.relatorioEditando.final_ciclo);
	      this.desabilitarDatas = { 'from': this.adicionaDias(this.projeto.data_aprovacao_projeto, this.relatorioEditando.maximo), 'to': this.adicionaDias(this.projeto.data_aprovacao_projeto, this.relatorioEditando.minimo) };
	    },
	    relatoriosAtivos: function relatoriosAtivos() {
	      return _.filter(this.relatorios, function (relatorio) {
	        return !_.includes(['Excluído via Sapiens', 'Excluído via SGP', 'Relatório será Excluído ao Concluir'], relatorio.situacao);
	      });
	    },
	    okEdicao: function okEdicao() {
	      if (_.has(this.relatorioEditando, 'id')) {
	        this.buscaLimpaRegistro({ 'id': this.relatorioEditando.id });
	        this.alteracao.alterados.push(_.cloneDeep(this.relatorioEditando));
	        var relatorioLista = _.find(this.relatorios, ['id', this.relatorioEditando.id]);
	        if (relatorioLista) {
	          relatorioLista.sequencia = this.relatorioEditando.sequencia;
	          relatorioLista.final_ciclo = this.relatorioEditando.final_ciclo;
	
	          relatorioLista['antes_30_final_ciclo'] = (0, _moment2.default)(this.relatorioEditando.final_ciclo).subtract(30, 'days').format('YYYY-MM-DD');
	          relatorioLista['depois_30_final_ciclo'] = (0, _moment2.default)(this.relatorioEditando.final_ciclo).add(30, 'days').format('YYYY-MM-DD');
	          relatorioLista['inicio_preenchimento'] = relatorioLista['antes_30_final_ciclo'];
	          relatorioLista['termino_preenchimento'] = relatorioLista['depois_30_final_ciclo'];
	          relatorioLista['inicio_concluir'] = relatorioLista['antes_30_final_ciclo'];
	          relatorioLista['termino_concluir'] = relatorioLista['depois_30_final_ciclo'];
	          relatorioLista['situacao'] = 'Relatório terá datas Alteradas ao Concluir';
	        }
	      } else {
	        this.relatorioEditando['antes_30_final_ciclo'] = (0, _moment2.default)(this.relatorioEditando.final_ciclo).subtract(30, 'days').format('YYYY-MM-DD');
	        this.relatorioEditando['depois_30_final_ciclo'] = (0, _moment2.default)(this.relatorioEditando.final_ciclo).add(30, 'days').format('YYYY-MM-DD');
	        this.relatorioEditando['inicio_preenchimento'] = this.relatorioEditando['antes_30_final_ciclo'];
	        this.relatorioEditando['termino_preenchimento'] = this.relatorioEditando['depois_30_final_ciclo'];
	        this.relatorioEditando['inicio_concluir'] = this.relatorioEditando['antes_30_final_ciclo'];
	        this.relatorioEditando['termino_concluir'] = this.relatorioEditando['depois_30_final_ciclo'];
	        this.relatorioEditando['situacao'] = 'Relatório será Adicionado ao Concluir';
	        this.buscaLimpaRegistro({ 'sequencia': this.relatorioEditando.sequencia });
	        _.pullAllBy(this.relatorios, [{ 'sequencia': this.relatorioEditando.sequencia }], 'sequencia');
	        this.alteracao.incluidos.push(this.relatorioEditando);
	        this.relatorios.push(this.relatorioEditando);
	      }
	      this.correcoesPeriodos();
	      this.$forceUpdate();
	      this.relatorioEditando = null;
	    },
	    cancelaEdicao: function cancelaEdicao() {
	      this.relatorioEditando = null;
	    },
	    editarRelatorio: function editarRelatorio(relatorio) {
	      this.relatorioEditando = _.cloneDeep(relatorio);
	      this.relatorioEditando['alteracaoDias'] = 0;
	      this.limiteAlteracaoFinalCiclo();
	    },
	    excluirRelatorio: function excluirRelatorio(relatorio) {
	      var vm = this;
	      this.$dialog.confirm('Deseja marcar o relatório nº ' + relatorio.sequencia + ' para excluir ao Concluir?', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	        vm.buscaLimpaRegistro({ 'sequencia': relatorio.sequencia });
	
	        var relatorioLista = _.find(vm.relatorios, ['sequencia', relatorio.sequencia]);
	        if (relatorioLista && _.has(relatorioLista, 'id')) {
	          relatorioLista['situacao'] = 'Relatório será Excluído ao Concluir';
	          relatorio['situacao'] = relatorioLista['situacao'];
	          relatorio.final_ciclo = _.get(_.find(vm.relatoriosBackup, ['id', relatorio.id]), 'final_ciclo');
	          vm.alteracao.excluidos.push(_.cloneDeep(relatorio));
	        } else {
	          _.pullAllBy(vm.relatorios, [{ 'sequencia': relatorio.sequencia }], 'sequencia');
	
	          var ultimoNumero = _.get(_.maxBy(vm.relatoriosBackup, 'sequencia'), 'sequencia');
	          vm.alteracao.incluidos.forEach(function (relatorio) {
	            _.set(relatorio, 'sequencia', ++ultimoNumero);
	          });
	        }
	        vm.correcoesPeriodos();
	        vm.cancelaEdicao();
	        vm.$forceUpdate();
	      });
	    },
	    novoRelatorio: function novoRelatorio() {
	      this.relatorioEditando = {};
	      this.relatorioEditando['sequencia'] = _.get(_.maxBy(this.relatorios, 'sequencia'), 'sequencia') + 1;
	      this.relatorioEditando['final_ciclo'] = this.projeto.data_final_projeto;
	      this.relatorioEditando['antes_30_final_ciclo'] = (0, _moment2.default)(this.relatorioEditando.final_ciclo).subtract(30, 'days').format('YYYY-MM-DD');
	      this.relatorioEditando['depois_30_final_ciclo'] = (0, _moment2.default)(this.relatorioEditando.final_ciclo).add(30, 'days').format('YYYY-MM-DD');
	      this.relatorioEditando['inicio_preenchimento'] = this.relatorioEditando['antes_30_final_ciclo'];
	      this.relatorioEditando['termino_preenchimento'] = this.relatorioEditando['depois_30_final_ciclo'];
	      this.relatorioEditando['inicio_concluir'] = this.relatorioEditando['antes_30_final_ciclo'];
	      this.relatorioEditando['termino_concluir'] = this.relatorioEditando['depois_30_final_ciclo'];
	      this.relatorioEditando['situacao'] = 'Relatório será Adicionado ao Concluir';
	      this.limiteAlteracaoFinalCiclo();
	      this.buscaLimpaRegistro({ 'sequencia': this.relatorioEditando.sequencia });
	      _.pullAllBy(this.relatorios, [{ 'sequencia': this.relatorioEditando.sequencia }], 'sequencia');
	      this.alteracao.incluidos.push(this.relatorioEditando);
	      this.relatorios.push(this.relatorioEditando);
	      this.clickAcaoBarra(this.relatorioEditando);
	    },
	    alterarListaRelatorios: function alterarListaRelatorios() {
	      this.modoEdicao = true;
	    },
	    cancelarAlteracaoListaRelatorios: function cancelarAlteracaoListaRelatorios() {
	      this.validacaoPeriodos = [];
	      this.alteracao = { incluidos: [], excluidos: [], alterados: [] };
	      this.cancelaEdicao();
	      this.modoEdicao = false;
	      this.relatorios = _.cloneDeep(this.relatoriosBackup);
	    },
	    concluirAlteracaoListaRelatorios: function concluirAlteracaoListaRelatorios() {
	      var _this4 = this;
	
	      var restricoesConcluir = [];
	      if (this.alteracao.incluidos.length === 0 && this.alteracao.excluidos.length === 0 && this.alteracao.alterados.length === 0) {
	        restricoesConcluir.push('Não foi feita nenhuma alteração nos relatórios');
	      }
	      if (!_.isNull(this.relatorioEditando)) {
	        restricoesConcluir.push('Caixa de edição de relatório aberta. Clique em OK ou Cancelar antes de Concluir as alterações');
	      }
	      if (this.validacaoPeriodos.length > 0) {
	        restricoesConcluir.push('Atenção, há ' + this.validacaoPeriodos.length + ' choques em relatórios que não permite concluir. Regularize primeiro.');
	      }
	      if (restricoesConcluir.length > 0) {
	        var mensagens = '<div class=avisoAlerta><li>' + _.join(restricoesConcluir, '<li>') + '</div>';
	        this.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result && restricoesConcluir.length === 0) {
	          _this4.$aguarde('Processando as alterações...');
	          var registroAlteracao = { 'fkProjeto': _this4.$route.params.id, 'antes': _this4.relatoriosBackup, 'depois': _this4.relatorios, 'alteracao': _this4.alteracao };
	          _this4.loading.processando = true;
	          axiosLaravel.post('/relatorio_execucao/alteracoes/', registroAlteracao).then(function (response) {
	            _this4.$snotify.clear();
	            _this4.loading.processando = false;
	            if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	              _this4.$snotify.success(response.data.mensagem, { timeout: 1000 });
	              _this4.$router.go(0);
	            } else {
	              _this4.$snotify.error(response.data);
	            }
	          }).catch(function (error) {
	            _this4.loading.processando = false;
	            console.log('error atualizando relatorios', error);
	            _this4.$root.trataErro(error);
	            _this4.$snotify.clear();
	          });
	          _this4.cancelaEdicao();
	        }
	      });
	    },
	    buscaLimpaRegistro: function buscaLimpaRegistro(busca) {
	      _.pullAllBy(this.alteracao.incluidos, [busca], _.head(_.keys(busca)));
	      _.pullAllBy(this.alteracao.excluidos, [busca], _.head(_.keys(busca)));
	      _.pullAllBy(this.alteracao.alterados, [busca], _.head(_.keys(busca)));
	    },
	    realceAlteracao: function realceAlteracao(relatorio) {
	      var realce = { 'class': '', 'cor': 'transparent', 'sombra': 'transparent' };
	      if (_.find(this.alteracao.alterados, { 'sequencia': relatorio.sequencia, 'id': relatorio.id })) {
	        realce = { 'class': 'info text-info', 'cor': '#d9edf7', 'sombra': '#d9edf7' };
	      } else if (_.find(this.alteracao.excluidos, { 'sequencia': relatorio.sequencia, 'id': relatorio.id })) {
	        realce = { 'class': 'active text-muted', 'cor': '#e8e5e5', 'sombra': '#e8e5e5' };
	      } else if (_.find(this.alteracao.incluidos, ['sequencia', relatorio.sequencia])) {
	        realce = { 'class': 'success text-success', 'cor': '#dff0d8', 'sombra': '#dff0d8' };
	      } else if (_.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao)) {
	        realce = { 'class': 'active text-muted', 'cor': '#transparent', 'sombra': 'transparent' };
	      }
	      return realce;
	    },
	    formataData: function formataData(data) {
	      return (0, _moment2.default)(data).format('DD/MM/YYYY');
	    },
	    formataDataDDMM: function formataDataDDMM(data) {
	      return (0, _moment2.default)(data).format('DD/MM');
	    },
	    dias: function dias(inicio, termino) {
	      inicio = _.isNull(inicio) ? (0, _moment2.default)() : _moment2.default.utc((0, _moment2.default)(inicio).format('YYYY-MM-DD'));
	      termino = _.isNull(termino) ? (0, _moment2.default)() : _moment2.default.utc((0, _moment2.default)(termino).format('YYYY-MM-DD'));
	      var dif = _moment2.default.duration(termino.diff(inicio));
	      var emDias = dif.asDays();
	      return _.toNumber(emDias);
	    },
	    adicionaDias: function adicionaDias(data, dias) {
	      dias = _.toNumber(dias);
	      var date = new Date(data);
	      date.setDate(date.getDate() + dias);
	      return date;
	    },
	    haRelatoriosPelasSituacoes: function haRelatoriosPelasSituacoes(listaSituacoes) {
	      var _this5 = this;
	
	      var achados = 0;
	      listaSituacoes.forEach(function (termo) {
	        if (_.find(_this5.relatorios, function (relatorio) {
	          return _.toLower(relatorio.situacao).includes(termo);
	        })) {
	          achados++;
	        }
	      });
	      return achados > 0;
	    },
	    cor: function cor(situacaoRelatorio, parametroRetorno) {
	      var corSituacao = _.find(this.coresSituacao, function (cor) {
	        return _.toLower(situacaoRelatorio).includes(_.toLower(cor.termo));
	      });
	      return corSituacao ? _.get(corSituacao, parametroRetorno) : parametroRetorno === 'corTexto' ? 'black' : 'transparent';
	    },
	    estaExcluido: function estaExcluido(relatorio) {
	      return _.toLower(relatorio.situacao).includes('exclu');
	    },
	    ehRelatorioEditavel: function ehRelatorioEditavel(relatorio) {
	      return _.includes(['Não apresentado', 'Fora do período de preenchimento', 'Pendente de preenchimento', 'Relatório terá datas Alteradas ao Concluir', 'Relatório será Adicionado ao Concluir', 'Relatório será Excluído ao Concluir'], relatorio.situacao);
	    },
	    clickAcaoBarra: function clickAcaoBarra(relatorio) {
	      if (this.ehParceiroEstrategico && relatorio.acao !== 'VISUALIZAR') {
	        this.$snotify.error('Sem acesso de edição de relatório, favor verificar.');
	        return;
	      }
	      if (this.modoEdicao) {
	        if (this.ehRelatorioEditavel(relatorio) || !_.has(relatorio, 'situacao')) {
	          this.editarRelatorio(relatorio);
	        }
	      } else {
	        if (relatorio.acao !== 'OCULTO') {
	          this.$router.push({ name: 'edita-relatorio-execucao', params: { id_proposta: this.idProposta, id: this.idProjeto, row: { item: relatorio } } });
	        }
	      }
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this6 = this;
	
	      _.set(this.usuarioLogado, 'configuracoes.cronograma_relatorios_execucao', this.configuracoes);
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {
	        console.log('configuracoes', _this6.usuarioLogado.configuracoes);
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this6.$root.trataErro(error);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trunc = __webpack_require__(108);
	
	var _trunc2 = _interopRequireDefault(_trunc);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'visualiza-pendencias-projeto',
	  data: function data() {
	    return {
	      loading: {
	        situacao: false,
	        carregandoProjetos: false,
	        pendencias: {
	          mandatos: true,
	          relatorios: true,
	          avaliacoes: true,
	          revisoes: true,
	          cadastro: true,
	          itensOrcamento: true
	        }
	      },
	      encerrado: false,
	      respostaDevolucaoCadastro: '',
	      hoje: new Date(),
	      numeroProjeto: undefined,
	      projeto: {},
	      listaProjetos: [],
	      configuracoes: {
	        numeroProjetoSelecionado: null
	      },
	      pendencias: {
	        mandatos: [],
	        relatorios: [],
	        avaliacoes: [],
	        tarefasRevisao: [],
	        cadastro: null,
	        itensOrcamento: []
	      }
	    };
	  },
	
	  props: ['propsNumeroProjeto'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {},
	  created: function created() {
	    if (_.has(this.usuarioLogado, 'configuracoes') && _.has(this.usuarioLogado.configuracoes, 'pendencias_projeto')) {
	      this.configuracoes = this.usuarioLogado.configuracoes.pendencias_projeto;
	    }
	    this.numeroProjeto = this.propsNumeroProjeto;
	    if (this.numeroProjeto) {
	      this.carregaPendencias();
	    } else {
	      this.carregarListaProjetos();
	    }
	  },
	
	  methods: {
	    carregaPendencias: function carregaPendencias() {
	      var _this = this;
	
	      if (typeof Storage !== 'undefined' && _.isEmpty(_.get(JSON.parse(window.localStorage.getItem('projetos')), 'lista', []))) {} else {
	        this.loading.pendencias.mandatos = true;
	        axiosLaravel.get('atividade/pendencias/mandatos/' + this.numeroProjeto).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this.pendencias.mandatos = response.data.retorno;
	          }
	          _this.loading.pendencias.mandatos = false;
	        }).catch(function (error) {
	          _this.loading.pendencias.mandatos = false;
	          _this.$root.trataErro(error);
	        });
	
	        this.loading.pendencias.relatorios = true;
	        axiosLaravel.get('atividade/pendencias/relatorios/' + this.numeroProjeto).then(function (response) {
	          if (_.has(response.data, 'situacao') && response.data.situacao === 'OK') {
	            _this.pendencias.relatorios = response.data.dados.row;
	          }
	          _this.loading.pendencias.relatorios = false;
	        }).catch(function (error) {
	          _this.loading.pendencias.relatorios = false;
	          _this.$root.trataErro(error);
	        });
	
	        this.loading.pendencias.avaliacoes = true;
	        axiosLaravel.get('atividade/pendencias/avaliacoes/' + this.numeroProjeto).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this.pendencias.avaliacoes = response.data.retorno;
	          }
	          _this.loading.pendencias.avaliacoes = false;
	        }).catch(function (error) {
	          _this.loading.pendencias.avaliacoes = false;
	          _this.$root.trataErro(error);
	        });
	
	        this.loading.pendencias.itensOrcamento = true;
	        axiosLaravel.get('atividade/pendencias/orcamento/' + this.numeroProjeto).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this.pendencias.itensOrcamento = response.data.retorno;
	            _this.pendencias.itensOrcamento.forEach(function (item) {
	              item['mostrar'] = false;
	            });
	          }
	          _this.loading.pendencias.itensOrcamento = false;
	        }).catch(function (error) {
	          _this.loading.pendencias.itensOrcamento = false;
	          _this.$root.trataErro(error);
	        });
	
	        this.loading.pendencias.cadastro = true;
	        console.log('resposta pendencia cadastro');
	        axiosLaravel.get('atividade/pendencias/cadastro/' + this.usuarioLogado.entidade.id).then(function (response) {
	          var responseData = null;
	          if (typeof response.data === 'string' && response.data.includes('HTTP/')) {
	            var jsonString = response.data.substring(response.data.indexOf('{'));
	            try {
	              responseData = JSON.parse(jsonString);
	            } catch (e) {
	              console.error('Falha ao fazer o parse do JSON extraído da resposta.', e);
	              _this.loading.pendencias.cadastro = false;
	              return;
	            }
	          } else {
	            responseData = response.data;
	            console.log('resposta pendencia cadastro resposta', response);
	          }
	          if (_.has(responseData, 'codigo') && responseData.codigo === 'OK') {
	            _this.pendencias.cadastro = responseData.retorno;
	            _this.respostaDevolucaoCadastro = responseData.retorno;
	            console.log('resposta pendencia cadastro', _this.pendencias.cadastro);
	          }
	          _this.loading.pendencias.revisoes = false;
	        }).catch(function (error) {
	          _this.loading.pendencias.revisoes = false;
	          console.error('Tipo: Erro de Resposta do Servidor');
	          console.error('Status HTTP:', error.response.status);
	          console.error('Dados da Resposta:', error.response.data);
	        });
	        this.loading.pendencias.revisoes = true;
	        axiosLaravel.get('atividade/pendencias/revisoes/' + this.numeroProjeto).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this.pendencias.tarefasRevisao = response.data.retorno;
	          }
	          _this.loading.pendencias.revisoes = false;
	        }).catch(function (error) {
	          _this.loading.pendencias.revisoes = false;
	          _this.$root.trataErro(error);
	        });
	
	        axiosLaravel.get('atividade/pendencias/projeto/' + this.numeroProjeto).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this.projeto = response.data.retorno[0];
	          }
	        }).catch(function (error) {
	          _this.$root.trataErro(error);
	        });
	      }
	    },
	    situacaoPendencia: function situacaoPendencia(data, tolerancia) {
	      var dias = (0, _trunc2.default)((0, _moment2.default)().diff((0, _moment2.default)(data)) / 86400000);
	      return dias;
	    },
	    mostraAtividade: function mostraAtividade(itens) {
	      itens.forEach(function (item) {
	        item['mostrar'] = !item['mostrar'];
	      });
	      this.$forceUpdate();
	    },
	    relatorioDisponivel: function relatorioDisponivel() {
	      var vm = this;
	      var relatoriosAbertos = _.filter(this.pendencias.relatorios, function (rel) {
	        return _.includes(['Pendente de pre', 'Não apresentado', 'Em análise pela', 'Devolvido para '], rel.situacao.substr(0, 15));
	      });
	      var relatoriosForaPeriodoFuturos = _.filter(this.pendencias.relatorios, function (rel) {
	        return _.includes(['Fora do período'], rel.situacao.substr(0, 15)) && vm.situacaoPendencia(rel.antes_30_final_ciclo) < 0;
	      });
	      var saida = [relatoriosAbertos.length > 0 ? _.head(relatoriosAbertos) : relatoriosForaPeriodoFuturos.length > 0 ? _.head(relatoriosForaPeriodoFuturos) : null];
	      return saida;
	    },
	    avaliacaoDisponivel: function avaliacaoDisponivel() {
	      var _this2 = this;
	
	      var saida = [];
	      this.pendencias.avaliacoes.forEach(function (avaliacao) {
	        if (avaliacao.processo.situacao === 'EM_EXECUCAO') {
	          var descricaoSituacao = 'XYZ';
	          if (avaliacao.processo.ultimaTarefa.nome === 'SOLICITACAO') {
	            descricaoSituacao = avaliacao.formulario.length === 0 ? 'Não iniciado' : 'Em preenchimento, mas não enviado ainda';
	          } else {
	            descricaoSituacao = avaliacao.processo.ultimaTarefa.nome === 'ANALISE' ? 'Em Análise na FBB' : avaliacao.processo.ultimaTarefa.nome === 'REVISAO' ? 'Em revisão da entidade parceira' : 'Situação não informada';
	          }
	
	          var limiteInicioProjeto = (0, _moment2.default)(_this2.projeto.inicio).add(_.toSafeInteger(avaliacao.cadastro.opcoes.periodicidade), 'month');
	          var limiteTerminoProjeto = (0, _moment2.default)(_this2.projeto.termino).subtract(_.toSafeInteger(avaliacao.cadastro.opcoes.periodicidade), 'month');
	          var infoPrazo = { texto: '', classe: '' };
	          if ((0, _moment2.default)().isBefore(limiteInicioProjeto)) {
	            infoPrazo.texto = 'Preencha o formulário de avaliação do projeto até ' + limiteInicioProjeto.format('DD/MM/YYYY');
	            infoPrazo.classe = 'vence_breve';
	          } else if ((0, _moment2.default)().isBefore(limiteTerminoProjeto)) {
	            infoPrazo.texto = 'Ainda não preencheu o formulário de avaliação do projeto, tem até ' + limiteTerminoProjeto.format('DD/MM/YYYY');
	            infoPrazo.classe = 'vence_hoje';
	          } else {
	            infoPrazo.texto = 'Este formulário de avaliação somente ficará disponível até ' + (0, _moment2.default)(_this2.projeto.termino).format('DD/MM/YYYY');
	            infoPrazo.classe = 'venchaveAcessocido';
	          }
	          var tipoFormularioAvaliacao = avaliacao.cadastro.tipo === 'AVALIACAO_APROVACAO' ? 'Marco zero' : avaliacao.cadastro.tipo === 'AVALIACAO_ENCERRAMENTO' ? 'Marco um' : avaliacao.cadastro.tipo === 'AVALIACAO_GENERICO' ? 'Genérico' : 'Participante';
	          var chaveAcesso = _.split(avaliacao.link_acesso, '-')[_.includes(['SOLICITACAO', 'REVISAO'], avaliacao.processo.ultimaTarefa.nome) ? avaliacao.formulario.length === 0 ? 0 : 1 : 2];
	          saida.push({ acesso: chaveAcesso, tipo: tipoFormularioAvaliacao, nome: avaliacao.cadastro.nome, situacao: descricaoSituacao, info: infoPrazo, tarefaAtual: avaliacao.processo.ultimaTarefa.nome });
	        }
	      });
	      return saida;
	    },
	    periodoParaMesAno: function periodoParaMesAno(periodo, inicioProjeto, formato) {
	      return (0, _moment2.default)(inicioProjeto).add(periodo - 1, 'month').format(formato);
	    },
	    dataParaPeriodo: function dataParaPeriodo(data, inicioProjeto) {
	      var dataAjustada = (0, _moment2.default)(data).format('YYYY-MM-01');
	      var inicioAjustado = (0, _moment2.default)(inicioProjeto).format('YYYY-MM-01');
	      return (0, _moment2.default)(dataAjustada).diff((0, _moment2.default)(inicioAjustado), 'month') + 1;
	    },
	    carregarListaProjetos: function carregarListaProjetos() {
	      var _this3 = this;
	
	      if (typeof Storage !== 'undefined' && _.isEmpty(_.get(JSON.parse(window.localStorage.getItem('projetos')), 'lista', []))) {} else {
	        this.loading.carregandoProjetos = true;
	        axiosLaravel.get('projetos').then(function (response) {
	          var listaProjetos = _.filter(response.data, function (projeto) {
	            return _.has(projeto, 'ds_codigo_projeto_erp') && !_.isNull(projeto.ds_codigo_projeto_erp) && projeto.sitprj !== 'ENC';
	          });
	          var acessosProjetos = _.get(_this3.usuarioLogado, 'configuracoes.acesso_projetos');
	          if (acessosProjetos) {
	            acessosProjetos.forEach(function (projeto) {
	              if (_.find(projeto.acesso, ['codigo', 'SEM_ACESSO'])) {
	                _.remove(listaProjetos, ['ds_codigo_projeto_erp', projeto.numero]);
	              }
	            });
	          }
	          _this3.listaProjetos = listaProjetos;
	
	          if (_.has(_this3.configuracoes, 'numeroProjetoSelecionado') && _.isNull(_this3.configuracoes.numeroProjetoSelecionado)) {
	            if (_.find(_this3.listaProjetos, ['ds_codigo_projeto_erp', _this3.configuracoes.numeroProjetoSelecionado])) {
	              _this3.configuracoes.numeroProjetoSelecionado = _.head(_.sortBy(_this3.listaProjetos, ['ds_codigo_projeto_erp']))['ds_codigo_projeto_erp'];
	            }
	          }
	          _this3.configuracoes.numeroProjetoSelecionado = _.head(_.sortBy(_this3.listaProjetos, ['ds_codigo_projeto_erp']))['ds_codigo_projeto_erp'];
	          _this3.loading.carregandoProjetos = false;
	          _this3.selecionaProjeto();
	        }).catch(function (error) {
	          _this3.loading.carregandoProjetos = false;
	          _this3.$root.trataErro(error);
	        });
	      }
	    },
	    selecionaProjeto: function selecionaProjeto() {
	      this.numeroProjeto = this.configuracoes.numeroProjetoSelecionado;
	      console.log('selecionaProjeto', this.numeroProjeto);
	      this.carregaPendencias();
	      this.salvarConfiguracoes();
	    },
	    percentual: function percentual(valor, base) {
	      var decimais = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var limitar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      var percentagem = parseFloat(base) === 0 ? 0 : parseFloat(valor) / parseFloat(base) * 100;
	      if (limitar) {
	        percentagem = percentagem < 0 ? 0 : percentagem > 100 ? 100 : percentagem;
	      }
	      return percentagem.toFixed(decimais);
	    },
	    configuracaoPadrao: function configuracaoPadrao() {
	      this.configuracoes = { numeroProjetoSelecionado: null };
	      this.salvarConfiguracoes();
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this4 = this;
	
	      _.set(this.usuarioLogado, 'configuracoes.pendencias_projeto', this.configuracoes);
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {
	        console.log('configuracoes', _this4.usuarioLogado.configuracoes);
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this4.$root.trataErro(error);
	        }
	      });
	    }
	  }
	
	};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trunc = __webpack_require__(108);
	
	var _trunc2 = _interopRequireDefault(_trunc);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _telefone = __webpack_require__(142);
	
	var _telefone2 = _interopRequireDefault(_telefone);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _parcelaAdiantamento = __webpack_require__(254);
	
	var _parcelaAdiantamento2 = _interopRequireDefault(_parcelaAdiantamento);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _extrato = __webpack_require__(517);
	
	var _extrato2 = _interopRequireDefault(_extrato);
	
	var _vuex = __webpack_require__(3);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _preAnaliseForm = __webpack_require__(175);
	
	var _preAnaliseForm2 = _interopRequireDefault(_preAnaliseForm);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	var _deferimento = __webpack_require__(173);
	
	var _deferimento2 = _interopRequireDefault(_deferimento);
	
	var _formalizacao = __webpack_require__(174);
	
	var _formalizacao2 = _interopRequireDefault(_formalizacao);
	
	var _aprovacao_OLD = __webpack_require__(531);
	
	var _aprovacao_OLD2 = _interopRequireDefault(_aprovacao_OLD);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _GestaoAtividades = __webpack_require__(257);
	
	var _GestaoAtividades2 = _interopRequireDefault(_GestaoAtividades);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _alteracoesProjetos = __webpack_require__(528);
	
	var _alteracoesProjetos2 = _interopRequireDefault(_alteracoesProjetos);
	
	var _AlteracoesPeriodoExecucao = __webpack_require__(1759);
	
	var _AlteracoesPeriodoExecucao2 = _interopRequireDefault(_AlteracoesPeriodoExecucao);
	
	var _Timeline = __webpack_require__(258);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _AcertosFinanceiros = __webpack_require__(1758);
	
	var _AcertosFinanceiros2 = _interopRequireDefault(_AcertosFinanceiros);
	
	var _avaliacoesProjeto = __webpack_require__(512);
	
	var _avaliacoesProjeto2 = _interopRequireDefault(_avaliacoesProjeto);
	
	var _brBankAccountValidator = __webpack_require__(125);
	
	var _brBankAccountValidator2 = _interopRequireDefault(_brBankAccountValidator);
	
	var _EditaOcorrencias = __webpack_require__(509);
	
	var _EditaOcorrencias2 = _interopRequireDefault(_EditaOcorrencias);
	
	var _publicoAlvoDescricao = __webpack_require__(522);
	
	var _publicoAlvoDescricao2 = _interopRequireDefault(_publicoAlvoDescricao);
	
	var _publicoAlvoDescricaoRealizado = __webpack_require__(1734);
	
	var _publicoAlvoDescricaoRealizado2 = _interopRequireDefault(_publicoAlvoDescricaoRealizado);
	
	var _tecnologiaSocial = __webpack_require__(525);
	
	var _tecnologiaSocial2 = _interopRequireDefault(_tecnologiaSocial);
	
	var _odsMarcacao = __webpack_require__(521);
	
	var _odsMarcacao2 = _interopRequireDefault(_odsMarcacao);
	
	var _licenciamentoAmbientalProjeto = __webpack_require__(1714);
	
	var _licenciamentoAmbientalProjeto2 = _interopRequireDefault(_licenciamentoAmbientalProjeto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    EditaOcorrencias: _EditaOcorrencias2.default,
	    AvaliacoesProjeto: _avaliacoesProjeto2.default,
	    AcertosFinanceiros: _AcertosFinanceiros2.default,
	
	    alteracoesProjetos: _alteracoesProjetos2.default,
	    AlteracoesPeriodoExecucao: _AlteracoesPeriodoExecucao2.default,
	    VisualizaTimeline: _Timeline2.default,
	    VisualizaGestaoAtividades: _GestaoAtividades2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    PreAnaliseForm: _preAnaliseForm2.default,
	    ParcelaAdiantamento: _parcelaAdiantamento2.default,
	    Analise: _analise2.default,
	    Deferimento: _deferimento2.default,
	    Formalizacao: _formalizacao2.default,
	    Aprovacao: _aprovacao_OLD2.default,
	    HistoricoProposta: _historicoProposta2.default,
	
	    licenciamentoAmbientalProjeto: _licenciamentoAmbientalProjeto2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Cronograma: _cronograma2.default,
	    Extrato: _extrato2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    Telefone: _telefone2.default,
	    PublicoAlvo: _publicoAlvo2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    publicoAlvoDescricao: _publicoAlvoDescricao2.default,
	    publicoAlvoDescricaoRealizado: _publicoAlvoDescricaoRealizado2.default,
	    tecnologiaSocial: _tecnologiaSocial2.default,
	    odsMarcacao: _odsMarcacao2.default },
	  name: 'projeto',
	  data: function data() {
	    return {
	      titulo: 'SGP',
	      restricaParaConcluir: [],
	      entidadeEhFundacao: false,
	      acProp: [],
	      atProp: [],
	      filtro_acompanhamento: '',
	      filtro_alteracoes: '',
	      atualizar_timeline: null,
	      editavel: false,
	      editando: '',
	      editandoBloco: {},
	      projeto: {
	        proposal: {
	          entity: {
	            active: true
	          }
	        }
	      },
	      ocorrenciaSelecionada: {
	        id: null,
	        ehVisualizacao: false
	      },
	
	      progressBar: {
	        stepAtual: null,
	        stepTotal: null,
	        tarefaAtual: null
	      },
	      loading: {
	        tela: false,
	        alteracoesProjeto: true
	      },
	      tel: '',
	      finalizou: false,
	      nulo: null,
	      array: [],
	      atvSemMetas: [],
	      metaNaoAchada: [],
	      camposOK: true,
	      verificaFilhos: false,
	      esconder: true,
	      esconderEntidade: false,
	      analise: {},
	      preAnalise: {},
	      deferimento: {},
	      formalizacao: {},
	      aprovacao: {},
	      fluxo: {},
	      filtro: [],
	      elementos: {
	        visivel: ''
	      },
	      projetoPeriodos: 0,
	      dataFinalExecucao: '',
	      historico_atualizado: [],
	      documentosProposta: [],
	      bloqueiaBotoes: false,
	
	      cronogramaAlteracoes: [],
	      listaCarteiras: [],
	      carteiraSelecionada: null,
	      proposta: {
	        entidade: {},
	
	        documentos: {
	          proposta: []
	        },
	        ds_projeto_duplicacao_descricao: ''
	      },
	      descricoesDiversas: { 'ALTERACAO_ATIVIDADES': 'Atividades', 'ALTERACAO_ATIVIDADES_GANTT': 'Atividades (via Gantt)', 'ALTERACAO_METAS': 'Metas', 'ALTERACAO_MUNICIPIOS': 'Municípios', 'ALTERACAO_PARCELAS_ADIANTAMENTO': 'Parcelas de Adiantamento', 'ALTERACAO_PERIODO_PROJETO': 'Prorrogação de Prazo', 'ALTERACOES_PROJETO': 'Alterações do Projeto', 'REMANEJAMENTO': 'Remanejamento', 'SUPLEMENTACAO': 'Suplementação', 'SOLICITACAO': 'Solicitação', 'ANALISE': 'Análise', 'AUTORIZACAO': 'Autorização', 'REVISAO': 'Revisão', 'FEITO': 'Feito', 'EM_EXECUCAO': 'Em Execução', 'CANCELADO': 'Cancelado' },
	      processosAlteracao: [],
	      filtroTabela: {
	        alteracoesProjeto: {
	          id: [],
	          solicitacao: [],
	          situacao: [],
	          etapa: [],
	          data: [1, 1]
	        }
	      },
	      mostrar: {
	        ocorrencias: false,
	        alteracoes: false,
	        consultaAlteracoesProjeto: false,
	        opcoesProjeto: false,
	        coordenador: false,
	        periodo: false,
	        carteira: false,
	        avaliacao: false,
	        entidade: false,
	        informacoesProjeto: false,
	        equipeProjeto: false,
	        projetoDuplicador: false,
	        objetivos: false,
	        metas: false,
	        atividades: false,
	        extratoProjeto: false,
	
	        contaAdiantamento: false,
	        parcelasAdiantamento: false,
	        municipios: false,
	        cursos: false,
	        documentos: false,
	        historico: false,
	        analiseProjeto: false,
	        publicoAlvo: false,
	        tecnologiaSocial: false,
	        ods: false,
	        licenciamentoAmbiental: false
	      },
	      componentKey: 0,
	      estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
	      messagemConfirmacao: {
	        'municipalizacao': 'Confirma a <b>Alteração dos Municípios</b> desse projeto?',
	        'metas': 'Confirma a <b>Alteração das Metas</b> desse projeto?',
	        'atividades': 'Confirma a <b>Alteração das Atividades</b> desse projeto?',
	        'coordenador': 'Confirma a <b>Alteração do Coordenador</b> desse projeto?',
	        'periodo_projeto': 'Confirma a <b>Alteração da Duração</b> desse projeto?',
	        'publicos_alvo': 'Confirma a <b>Alteração do Público-alvo</b> desse projeto?',
	        'cronograma': 'Confirma a <b>Alteração do Cronograma</b> desse projeto?',
	        'parcelas_adiantamento': 'Confirma a <b>Alteração da(s) Parcela(s) de Adiantamento</b> desse projeto?'
	      },
	      arvoreProjetos: [],
	
	      dadosBancariosAdiantamento: {
	        banco: '001',
	        agencia: '',
	        conta: '',
	        tipo: 1
	      },
	      listaBancos: [{ 'codigo': '001', 'nome': 'Banco do Brasil S.A.', 'caracteresConta': 8 }, { 'codigo': '033', 'nome': 'Banco Santander (Brasil) S.A.', 'caracteresConta': 8, 'digitoAgencia': false }, { 'codigo': '070', 'nome': 'BRB - Banco de Brasília S.A.' }, { 'codigo': '104', 'nome': 'Caixa Econômica Federal', 'digitoAgencia': false }, { 'codigo': '237', 'nome': 'Banco Bradesco S.A.', 'caracteresConta': 7 }, { 'codigo': '341', 'nome': 'Itaú Unibanco S.A.', 'caracteresConta': 5, 'digitoAgencia': false }, { 'codigo': '', 'nome': '', $isDisabled: true }, { 'codigo': '003', 'nome': 'BANCO DA AMAZONIA S.A.' }, { 'codigo': '004', 'nome': 'Banco do Nordeste do Brasil S.A.' }, { 'codigo': '007', 'nome': 'BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL' }, { 'codigo': '010', 'nome': 'CREDICOAMO CREDITO RURAL COOPERATIVA' }, { 'codigo': '011', 'nome': 'CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A' }, { 'codigo': '012', 'nome': 'Banco Inbursa S.A.' }, { 'codigo': '014', 'nome': 'STATE STREET BRASIL S.A. ? BANCO COMERCIAL' }, { 'codigo': '015', 'nome': 'UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { 'codigo': '016', 'nome': 'COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI' }, { 'codigo': '017', 'nome': 'BNY Mellon Banco S.A.' }, { 'codigo': '018', 'nome': 'Banco Tricury S.A.' }, { 'codigo': '021', 'nome': 'BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO' }, { 'codigo': '024', 'nome': 'Banco Bandepe S.A.' }, { 'codigo': '025', 'nome': 'Banco Alfa S.A.' }, { 'codigo': '029', 'nome': 'Banco Itaú Consignado S.A.' }, { 'codigo': '036', 'nome': 'Banco Bradesco BBI S.A.' }, { 'codigo': '037', 'nome': 'Banco do Estado do Pará S.A.' }, { 'codigo': '040', 'nome': 'Banco Cargill S.A.' }, { 'codigo': '041', 'nome': 'Banco do Estado do Rio Grande do Sul S.A.', 'caracteresConta': 9 }, { 'codigo': '047', 'nome': 'Banco do Estado de Sergipe S.A.' }, { 'codigo': '060', 'nome': 'Confidence Corretora de Câmbio S.A.' }, { 'codigo': '062', 'nome': 'Hipercard Banco Múltiplo S.A.' }, { 'codigo': '063', 'nome': 'Banco Bradescard S.A.' }, { 'codigo': '064', 'nome': 'GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.' }, { 'codigo': '065', 'nome': 'Banco AndBank (Brasil) S.A.' }, { 'codigo': '066', 'nome': 'BANCO MORGAN STANLEY S.A.' }, { 'codigo': '069', 'nome': 'Banco Crefisa S.A.' }, { 'codigo': '074', 'nome': 'Banco J. Safra S.A.' }, { 'codigo': '075', 'nome': 'Banco ABN Amro S.A.' }, { 'codigo': '076', 'nome': 'Banco KDB do Brasil S.A.' }, { 'codigo': '077', 'nome': 'Banco Inter S.A.' }, { 'codigo': '078', 'nome': 'Haitong Banco de Investimento do Brasil S.A.' }, { 'codigo': '079', 'nome': 'Banco Original do Agronegócio S.A.' }, { 'codigo': '080', 'nome': 'B&T CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '081', 'nome': 'BancoSeguro S.A.' }, { 'codigo': '082', 'nome': 'BANCO TOPÁZIO S.A.' }, { 'codigo': '083', 'nome': 'Banco da China Brasil S.A.' }, { 'codigo': '084', 'nome': 'UNIPRIME NORTE DO PARANÁ – COOPERATIVA DE CRÉDITO LTDA' }, { 'codigo': '085', 'nome': 'Cooperativa Central de Crédito – Ailos' }, { 'codigo': '088', 'nome': 'BANCO RANDON S.A.' }, { 'codigo': '089', 'nome': 'CREDISAN COOPERATIVA DE CRÉDITO' }, { 'codigo': '091', 'nome': 'CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S' }, { 'codigo': '092', 'nome': 'BRK S.A. Crédito, Financiamento e Investimento' }, { 'codigo': '093', 'nome': 'PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT' }, { 'codigo': '094', 'nome': 'Banco Finaxis S.A.' }, { 'codigo': '095', 'nome': 'Travelex Banco de Câmbio S.A.' }, { 'codigo': '096', 'nome': 'Banco B3 S.A.' }, { 'codigo': '097', 'nome': 'Credisis – Central de Cooperativas de Crédito Ltda.' }, { 'codigo': '098', 'nome': 'Credialiança Cooperativa de Crédito Rural' }, { 'codigo': '099', 'nome': 'UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.' }, { 'codigo': '100', 'nome': 'Planner Corretora de Valores S.A.' }, { 'codigo': '101', 'nome': 'RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '102', 'nome': 'XP INVESTIMENTOS CORRETORA DE CÂMBIO,TÍTULOS E VALORES MOBILIÁRIOS S/A' }, { 'codigo': '105', 'nome': 'Lecca Crédito, Financiamento e Investimento S/A' }, { 'codigo': '107', 'nome': 'Banco Bocom BBM S.A.' }, { 'codigo': '108', 'nome': 'PORTOCRED S.A. – CREDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '111', 'nome': 'OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.' }, { 'codigo': '113', 'nome': 'Magliano S.A. Corretora de Cambio e Valores Mobiliarios' }, { 'codigo': '114', 'nome': 'Central Cooperativa de Crédito no Estado do Espírito Santo – CECOOP' }, { 'codigo': '117', 'nome': 'ADVANCED CORRETORA DE CÂMBIO LTDA' }, { 'codigo': '119', 'nome': 'Banco Western Union do Brasil S.A.' }, { 'codigo': '120', 'nome': 'BANCO RODOBENS S.A.' }, { 'codigo': '121', 'nome': 'Banco Agibank S.A.' }, { 'codigo': '122', 'nome': 'Banco Bradesco BERJ S.A.' }, { 'codigo': '124', 'nome': 'Banco Woori Bank do Brasil S.A.' }, { 'codigo': '125', 'nome': 'Plural S.A. Banco Múltiplo' }, { 'codigo': '126', 'nome': 'BR Partners Banco de Investimento S.A.' }, { 'codigo': '127', 'nome': 'Codepe Corretora de Valores e Câmbio S.A.' }, { 'codigo': '128', 'nome': 'MS Bank S.A. Banco de Câmbio' }, { 'codigo': '129', 'nome': 'UBS Brasil Banco de Investimento S.A.' }, { 'codigo': '130', 'nome': 'CARUANA S.A. – SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '131', 'nome': 'TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA' }, { 'codigo': '132', 'nome': 'ICBC do Brasil Banco Múltiplo S.A.' }, { 'codigo': '133', 'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E' }, { 'codigo': '134', 'nome': 'BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '136', 'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. – UNICRED DO BRASI' }, { 'codigo': '138', 'nome': 'Get Money Corretora de Câmbio S.A.' }, { 'codigo': '139', 'nome': 'Intesa Sanpaolo Brasil S.A. – Banco Múltiplo' }, { 'codigo': '140', 'nome': 'Easynvest – Título Corretora de Valores SA' }, { 'codigo': '142', 'nome': 'Broker Brasil Corretora de Câmbio Ltda.' }, { 'codigo': '143', 'nome': 'Treviso Corretora de Câmbio S.A.' }, { 'codigo': '144', 'nome': 'BEXS BANCO DE CÂMBIO S/A' }, { 'codigo': '145', 'nome': 'LEVYCAM – CORRETORA DE CAMBIO E VALORES LTDA.' }, { 'codigo': '146', 'nome': 'GUITTA CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '149', 'nome': 'Facta Financeira S.A. – Crédito Financiamento e Investimento' }, { 'codigo': '157', 'nome': 'ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '159', 'nome': 'Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor' }, { 'codigo': '163', 'nome': 'Commerzbank Brasil S.A. – Banco Múltiplo' }, { 'codigo': '169', 'nome': 'BANCO OLÉ CONSIGNADO S.A.' }, { 'codigo': '173', 'nome': 'BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '174', 'nome': 'PEFISA S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '177', 'nome': 'Guide Investimentos S.A. Corretora de Valores' }, { 'codigo': '180', 'nome': 'CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '183', 'nome': 'SOCRED S.A. – SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P' }, { 'codigo': '184', 'nome': 'Banco Itaú BBA S.A.' }, { 'codigo': '188', 'nome': 'ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS, CÂMBIO E VALORES' }, { 'codigo': '189', 'nome': 'HS FINANCEIRA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' }, { 'codigo': '190', 'nome': 'SERVICOOP – COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN' }, { 'codigo': '191', 'nome': 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '194', 'nome': 'PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '196', 'nome': 'FAIR CORRETORA DE CAMBIO S.A.' }, { 'codigo': '197', 'nome': 'Stone Pagamentos S.A.' }, { 'codigo': '208', 'nome': 'Banco BTG Pactual S.A.' }, { 'codigo': '212', 'nome': 'Banco Original S.A.' }, { 'codigo': '213', 'nome': 'Banco Arbi S.A.' }, { 'codigo': '217', 'nome': 'Banco John Deere S.A.' }, { 'codigo': '218', 'nome': 'Banco BS2 S.A.' }, { 'codigo': '222', 'nome': 'BANCO CRÉDIT AGRICOLE BRASIL S.A.' }, { 'codigo': '224', 'nome': 'Banco Fibra S.A.' }, { 'codigo': '233', 'nome': 'Banco Cifra S.A.' }, { 'codigo': '241', 'nome': 'BANCO CLASSICO S.A.' }, { 'codigo': '243', 'nome': 'Banco Máxima S.A.' }, { 'codigo': '246', 'nome': 'Banco ABC Brasil S.A.' }, { 'codigo': '249', 'nome': 'Banco Investcred Unibanco S.A.' }, { 'codigo': '250', 'nome': 'BCV – BANCO DE CRÉDITO E VAREJO S.A.' }, { 'codigo': '253', 'nome': 'Bexs Corretora de Câmbio S/A' }, { 'codigo': '254', 'nome': 'PARANÁ BANCO S.A.' }, { 'codigo': '259', 'nome': 'MONEYCORP BANCO DE CÂMBIO S.A.' }, { 'codigo': '260', 'nome': 'Nu Pagamentos S.A.' }, { 'codigo': '265', 'nome': 'Banco Fator S.A.' }, { 'codigo': '266', 'nome': 'BANCO CEDULA S.A.' }, { 'codigo': '268', 'nome': 'BARI COMPANHIA HIPOTECÁRIA' }, { 'codigo': '269', 'nome': 'BANCO HSBC S.A.' }, { 'codigo': '270', 'nome': 'Sagitur Corretora de Câmbio Ltda.' }, { 'codigo': '271', 'nome': 'IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { 'codigo': '272', 'nome': 'AGK CORRETORA DE CAMBIO S.A.' }, { 'codigo': '273', 'nome': 'Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel' }, { 'codigo': '274', 'nome': 'MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT' }, { 'codigo': '276', 'nome': 'Senff S.A. – Crédito, Financiamento e Investimento' }, { 'codigo': '278', 'nome': 'Genial Investimentos Corretora de Valores Mobiliários S.A.' }, { 'codigo': '279', 'nome': 'COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' }, { 'codigo': '280', 'nome': 'Avista S.A. Crédito, Financiamento e Investimento' }, { 'codigo': '281', 'nome': 'Cooperativa de Crédito Rural Coopavel' }, { 'codigo': '283', 'nome': 'RB CAPITAL INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LIMITADA' }, { 'codigo': '285', 'nome': 'Frente Corretora de Câmbio Ltda.' }, { 'codigo': '286', 'nome': 'COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO' }, { 'codigo': '288', 'nome': 'CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '289', 'nome': 'DECYSEO CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '290', 'nome': 'Pagseguro Internet S.A.' }, { 'codigo': '292', 'nome': 'BS2 Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '293', 'nome': 'Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '296', 'nome': 'VISION S.A. CORRETORA DE CAMBIO' }, { 'codigo': '298', 'nome': 'Vip’s Corretora de Câmbio Ltda.' }, { 'codigo': '299', 'nome': 'SOROCRED   CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '300', 'nome': 'Banco de la Nacion Argentina' }, { 'codigo': '301', 'nome': 'BPP Instituição de Pagamento S.A.' }, { 'codigo': '306', 'nome': 'PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '307', 'nome': 'Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '309', 'nome': 'CAMBIONET CORRETORA DE CÂMBIO LTDA.' }, { 'codigo': '310', 'nome': 'VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '311', 'nome': 'DOURADA CORRETORA' }, { 'codigo': '312', 'nome': 'HSCM SCMEPP LTDA.' }, { 'codigo': '313', 'nome': 'AMAZÔNIA CORRETORA DE CÂMBIO LTDA.' }, { 'codigo': '315', 'nome': 'PI Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '318', 'nome': 'Banco BMG S.A.' }, { 'codigo': '319', 'nome': 'OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '320', 'nome': 'China Construction Bank (Brasil) Banco Múltiplo S/A' }, { 'codigo': '321', 'nome': 'CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT' }, { 'codigo': '322', 'nome': 'Cooperativa de Crédito Rural de Abelardo Luz – Sulcredi/Crediluz' }, { 'codigo': '323', 'nome': 'MERCADOPAGO.COM REPRESENTACOES LTDA.' }, { 'codigo': '324', 'nome': 'CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '325', 'nome': 'Órama Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '326', 'nome': 'PARATI – CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '329', 'nome': 'QI Sociedade de Crédito Direto S.A.' }, { 'codigo': '330', 'nome': 'BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.' }, { 'codigo': '331', 'nome': 'Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '332', 'nome': 'Acesso Soluções de Pagamento S.A.' }, { 'codigo': '335', 'nome': 'Banco Digio S.A.' }, { 'codigo': '336', 'nome': 'Banco C6 S.A.' }, { 'codigo': '340', 'nome': 'Super Pagamentos e Administração de Meios Eletrônicos S.A.' }, { 'codigo': '342', 'nome': 'Creditas Sociedade de Crédito Direto S.A.' }, { 'codigo': '343', 'nome': 'FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.' }, { 'codigo': '348', 'nome': 'Banco XP S.A.' }, { 'codigo': '349', 'nome': 'AL5 S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '350', 'nome': 'COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE' }, { 'codigo': '352', 'nome': 'TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '354', 'nome': 'NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES' }, { 'codigo': '355', 'nome': 'ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '358', 'nome': 'MIDWAY S.A. - SCFI' }, { 'codigo': '359', 'nome': 'ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A' }, { 'codigo': '360', 'nome': 'TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { 'codigo': '362', 'nome': 'CIELO S.A.' }, { 'codigo': '363', 'nome': 'SOCOPA SOCIEDADE CORRETORA PAULISTA S.A.' }, { 'codigo': '364', 'nome': 'GERENCIANET S.A.' }, { 'codigo': '365', 'nome': 'SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS' }, { 'codigo': '366', 'nome': 'BANCO SOCIETE GENERALE BRASIL S.A.' }, { 'codigo': '367', 'nome': 'VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { 'codigo': '368', 'nome': 'Banco CSF S.A.' }, { 'codigo': '370', 'nome': 'Banco Mizuho do Brasil S.A.' }, { 'codigo': '371', 'nome': 'WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.' }, { 'codigo': '373', 'nome': 'UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.' }, { 'codigo': '374', 'nome': 'REALIZE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '376', 'nome': 'BANCO J.P. MORGAN S.A.' }, { 'codigo': '377', 'nome': 'MS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA' }, { 'codigo': '378', 'nome': 'BBC LEASING S.A. – ARRENDAMENTO MERCANTIL' }, { 'codigo': '379', 'nome': 'COOPERFORTE – COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS FUNCIONÁRIOS DE INSTIT' }, { 'codigo': '380', 'nome': 'PICPAY SERVICOS S.A.' }, { 'codigo': '381', 'nome': 'BANCO MERCEDES-BENZ DO BRASIL S.A.' }, { 'codigo': '382', 'nome': 'FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L' }, { 'codigo': '383', 'nome': 'BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.' }, { 'codigo': '384', 'nome': 'GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO' }, { 'codigo': '386', 'nome': 'NU FINANCEIRA S.A. CFI' }, { 'codigo': '387', 'nome': 'Banco Toyota do Brasil S.A.' }, { 'codigo': '389', 'nome': 'Banco Mercantil do Brasil S.A.' }, { 'codigo': '390', 'nome': 'BANCO GM S.A.' }, { 'codigo': '391', 'nome': 'COOPERATIVA DE CREDITO RURAL DE IBIAM – SULCREDI/IBIAM' }, { 'codigo': '393', 'nome': 'Banco Volkswagen S.A.' }, { 'codigo': '394', 'nome': 'Banco Bradesco Financiamentos S.A.' }, { 'codigo': '395', 'nome': 'F D GOLD DTVM LTDA' }, { 'codigo': '396', 'nome': 'HUB PAGAMENTOS S.A' }, { 'codigo': '397', 'nome': 'LISTO SOCIEDADE DE CREDITO DIRETO S.A.' }, { 'codigo': '398', 'nome': 'IDEAL CTVM S.A.' }, { 'codigo': '399', 'nome': 'Kirton Bank S.A. – Banco Múltiplo' }, { 'codigo': '400', 'nome': 'CC POUP SER FIN CO' }, { 'codigo': '402', 'nome': 'COBUCCIO SCD S.A.' }, { 'codigo': '403', 'nome': 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '404', 'nome': 'SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '406', 'nome': 'ACCREDITO SCD S.A.' }, { 'codigo': '407', 'nome': 'ÍNDIGO INVESTIMENTOS DTVM LTDA.' }, { 'codigo': '408', 'nome': 'BÔNUSCRED SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '410', 'nome': 'PLANNER SCM S.A.' }, { 'codigo': '411', 'nome': 'VIA CERTA FINANCIADORA S.A. - CFI' }, { 'codigo': '412', 'nome': 'BANCO CAPITAL S.A.' }, { 'codigo': '419', 'nome': 'NUMBRS SCD S.A.' }, { 'codigo': '422', 'nome': 'Banco Safra S.A.' }, { 'codigo': '456', 'nome': 'Banco MUFG Brasil S.A.' }, { 'codigo': '464', 'nome': 'Banco Sumitomo Mitsui Brasileiro S.A.' }, { 'codigo': '473', 'nome': 'Banco Caixa Geral – Brasil S.A.' }, { 'codigo': '477', 'nome': 'Citibank N.A.' }, { 'codigo': '479', 'nome': 'Banco ItauBank S.A.' }, { 'codigo': '487', 'nome': 'DEUTSCHE BANK S.A. – BANCO ALEMAO' }, { 'codigo': '488', 'nome': 'JPMorgan Chase Bank, National Association' }, { 'codigo': '492', 'nome': 'ING Bank N.V.' }, { 'codigo': '495', 'nome': 'Banco de La Provincia de Buenos Aires' }, { 'codigo': '505', 'nome': 'Banco Credit Suisse (Brasil) S.A.' }, { 'codigo': '545', 'nome': 'SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A' }, { 'codigo': '600', 'nome': 'Banco Luso Brasileiro S.A.' }, { 'codigo': '604', 'nome': 'Banco Industrial do Brasil S.A.' }, { 'codigo': '610', 'nome': 'Banco VR S.A.' }, { 'codigo': '611', 'nome': 'Banco Paulista S.A.' }, { 'codigo': '612', 'nome': 'Banco Guanabara S.A.' }, { 'codigo': '613', 'nome': 'Omni Banco S.A.' }, { 'codigo': '623', 'nome': 'Banco Pan S.A.' }, { 'codigo': '626', 'nome': 'BANCO C6 CONSIGNADO S.A.' }, { 'codigo': '630', 'nome': 'Banco Smartbank S.A.' }, { 'codigo': '633', 'nome': 'Banco Rendimento S.A.' }, { 'codigo': '634', 'nome': 'BANCO TRIANGULO S.A.' }, { 'codigo': '637', 'nome': 'BANCO SOFISA S.A.' }, { 'codigo': '643', 'nome': 'Banco Pine S.A.' }, { 'codigo': '652', 'nome': 'Itaú Unibanco Holding S.A.' }, { 'codigo': '653', 'nome': 'BANCO INDUSVAL S.A.' }, { 'codigo': '654', 'nome': 'BANCO DIGIMAIS S.A.' }, { 'codigo': '655', 'nome': 'Banco Votorantim S.A.' }, { 'codigo': '707', 'nome': 'Banco Daycoval S.A.' }, { 'codigo': '712', 'nome': 'Banco Ourinvest S.A.' }, { 'codigo': '720', 'nome': 'BCO RNX S.A.' }, { 'codigo': '739', 'nome': 'Banco Cetelem S.A.' }, { 'codigo': '741', 'nome': 'BANCO RIBEIRAO PRETO S.A.' }, { 'codigo': '743', 'nome': 'Banco Semear S.A.' }, { 'codigo': '745', 'nome': 'Banco Citibank S.A.', 'caracteresConta': 8, 'digitoAgencia': false }, { 'codigo': '746', 'nome': 'Banco Modal S.A.' }, { 'codigo': '747', 'nome': 'Banco Rabobank International Brasil S.A.' }, { 'codigo': '748', 'nome': 'BANCO COOPERATIVO SICREDI S.A.' }, { 'codigo': '751', 'nome': 'Scotiabank Brasil S.A. Banco Múltiplo' }, { 'codigo': '752', 'nome': 'Banco BNP Paribas Brasil S.A.' }, { 'codigo': '753', 'nome': 'Novo Banco Continental S.A. – Banco Múltiplo' }, { 'codigo': '754', 'nome': 'Banco Sistema S.A.' }, { 'codigo': '755', 'nome': 'Bank of America Merrill Lynch Banco Múltiplo S.A.' }, { 'codigo': '756', 'nome': 'BANCO COOPERATIVO DO BRASIL S.A. – BANCOOB' }, { 'codigo': '757', 'nome': 'BANCO KEB HANA DO BRASIL S.A.' }],
	      codFor: '',
	      bancoContaInterna: '',
	      agenciaContaInterna: '',
	      contaInterna: '',
	      refreshAlt: 0,
	      historicoAlteracaoPeriodo: {},
	      acessoGerSolucoes: false,
	      ehParceiroEstrategico: false,
	      dataConvenio: null,
	      dataVigencia: null,
	      dataFim: null
	    };
	  },
	
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  watch: {
	    loading: function loading() {
	      this.titulo = this.loading.tela ? 'SGP Carregando ' + this.$route.params.numero : 'SGP - ' + this.$route.params.numero + ' - ' + this.proposta.ds_nome;
	    },
	
	    filtroTabela: {
	      handler: function handler() {
	        var _this = this;
	
	        console.log('filtroTabela');
	        this.processosAlteracao.forEach(function (solicitacao) {
	          var filtroId = _this.filtroTabela.alteracoesProjeto.id.length === 0 || _.includes(_this.filtroTabela.alteracoesProjeto.id, solicitacao.id);
	          var filtroSituacao = _this.filtroTabela.alteracoesProjeto.situacao.length === 0 || _.includes(_this.filtroTabela.alteracoesProjeto.situacao, solicitacao.situacao);
	          var filtroEtapa = _this.filtroTabela.alteracoesProjeto.etapa.length === 0 || _.includes(_this.filtroTabela.alteracoesProjeto.etapa, solicitacao.etapa);
	          var filtroSolicitacao = _this.filtroTabela.alteracoesProjeto.solicitacao.length === 0 || _.intersection(_this.filtroTabela.alteracoesProjeto.solicitacao, _.map(solicitacao.requisicao.processos, 'nome')).length > 0;
	          var filtroData = (0, _moment2.default)(solicitacao.inicio).isBetween(_this.periodoParaMesAno(_this.filtroTabela.alteracoesProjeto.data[0], _this.proposta.dt_assinatura_convenio, 'YYYY-MM-DD'), _this.periodoParaMesAno(_this.filtroTabela.alteracoesProjeto.data[1], _this.proposta.dt_assinatura_convenio, 'YYYY-MM-DD'), 'day');
	          console.log('  filtroSolicitacao', solicitacao.id, filtroSolicitacao);
	          console.log('     intersection', _.intersection(_this.filtroTabela.alteracoesProjeto.solicitacao, _.map(solicitacao.requisicao.processos, 'nome')), _this.filtroTabela.alteracoesProjeto.solicitacao, _.map(solicitacao.requisicao.processos, 'nome'));
	          _.set(solicitacao, 'mostrar', filtroId && filtroSituacao && filtroEtapa && filtroSolicitacao && filtroData);
	        });
	      },
	      deep: true
	    },
	    documentosProposta: function documentosProposta() {
	      if (this.documentosProposta) {
	        this.proposta.documentos.proposta = this.documentosProposta;
	      }
	    }
	  },
	  computed: (0, _extends3.default)({
	    dataFinalVigencia: function dataFinalVigencia() {
	      if (this.proposta.dt_assinatura_convenio) {
	        this.proposta.dt_data_vigencia = (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(parseInt(this.proposta.periodo_vigencia), 'M').format('YYYY-MM-DD');
	      } else {
	        if (this.proposta.dt_data_inicial) {
	          this.proposta.dt_data_vigencia = (0, _moment2.default)(this.proposta.dt_data_inicial).add(parseInt(this.proposta.periodo_vigencia), 'M').format('YYYY-MM-DD');
	        }
	      }
	    },
	
	    dataFinal: function dataFinal() {
	      if (this.proposta.dt_assinatura_convenio) {
	        this.dataFinalExecucao = (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(this.proposta.nr_periodos, 'M').format('DD/MM/YYYY');
	        return this.dataFinalExecucao;
	      }
	    },
	
	    telefone: function telefone() {
	      if (this.proposta.entidade.contato) {
	        var size = this.proposta.entidade.contato.ds_telefone.length;
	        if (size < 11) {
	          this.tel = '(' + this.proposta.entidade.contato.ds_telefone.substring(0, 2) + ') ' + this.proposta.entidade.contato.ds_telefone.substring(2, 6) + ' - ' + this.proposta.entidade.contato.ds_telefone.substring(6, 10);
	        } else {
	          this.tel = '(' + this.proposta.entidade.contato.ds_telefone.substring(0, 2) + ') ' + this.proposta.entidade.contato.ds_telefone.substring(2, 7) + ' - ' + this.proposta.entidade.contato.ds_telefone.substring(7, 11);
	        }
	        return this.tel;
	      }
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      this.$forceUpdate();
	    }
	  }),
	  destroyed: function destroyed() {
	    Echo.leave('Edita.Proposta.' + this.proposta.id);
	  },
	  created: function created() {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.clear();
	              _this2.ehParceiroEstrategico = _this2.usuarioLogado.perfis.some(function (perfil) {
	                return perfil.ds_nome === 'Parceiro Estratégico';
	              });
	              _this2.$aguarde('Carregando o projeto...');
	              _this2.consultaAcessoGerenteSolucoes();
	              _context.next = 6;
	              return _this2.buscaProposta();
	
	            case 6:
	              _this2.entidadeEhFundacao = _this2.proposta.entidade.ds_cnpj === '01641000000133';
	              _this2.assinaCanalProposta();
	
	              _this2.buscaArvoreProjeto();
	              _this2.editavel = _this2.$root.isFundacao(_this2.usuarioLogado);
	              _this2.consultaContaInterna();
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }))();
	  },
	
	  methods: {
	    adicionaRestricao: function adicionaRestricao(ev) {
	      if (!_.isNil(ev) && _.has(ev, 'tag')) {
	        _.remove(this.restricaParaConcluir, function (i) {
	          return i.tag === ev.tag;
	        });
	
	        this.restricaParaConcluir.push(ev);
	      }
	    },
	    permiteConcluir: function permiteConcluir(bloco) {
	      console.log(bloco);
	      if (this.restricaParaConcluir.length > 0 && _.filter(this.restricaParaConcluir, { 'ativo': true }).length > 0) {
	        var vm = this;
	
	        var restricoes = _.filter(this.restricaParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	        var informacoes = _.filter(this.restricaParaConcluir, { 'ativo': true, 'tipo': 'informacao' });
	        var confirmacoes = _.filter(this.restricaParaConcluir, { 'ativo': true, 'tipo': 'confirmacao' });
	        if (restricoes.length > 0) {
	          var mensagens = '<div class=avisoAlerta><li>' + _.join(_.map(restricoes, 'mensagem'), '<li>') + '</div>';
	          this.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	        } else {
	          if (informacoes.length > 0) {
	            var _mensagens = '<div class=avisoInfo><li>' + _.join(_.map(informacoes, 'mensagem'), '<li>') + '</div>';
	            this.$dialog.alert(_mensagens, { html: true, animation: 'fade', customClass: 'avisoInfo' }).then(function (dialog) {
	              _.forEach(vm.restricaParaConcluir, function (item) {
	                if (item.tipo === 'informacao') {
	                  _set(item, 'ativo', false);
	                }
	              });
	            });
	          } else if (confirmacoes.length > 0) {
	            var _mensagens2 = '<div class=avisoConfirmacao><li>' + _.join(_.map(confirmacoes, 'mensagem'), '<li>') + '</div>';
	            this.$dialog.confirm(_mensagens2, { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	              _.forEach(vm.restricaParaConcluir, function (item) {
	                if (item.tipo === 'confirmacao') {
	                  _set(item, 'ativo', false);
	                }
	              });
	            }).catch(function () {});
	
	            if (informacoes.length === 0 & confirmacoes.length === 0) {
	              this.concluir(bloco);
	            }
	          }
	        }
	      } else {
	        console.log('PERMITE CONCLUIR');
	        this.concluir(bloco);
	      }
	    },
	    assinaCanalProposta: function assinaCanalProposta() {
	      var _this3 = this;
	
	      Echo.join('Edita.Proposta.' + this.proposta.id).listen('PropostaEvents', function (e) {
	        if (!_.isEmpty(e) && !_.isNull(e)) {
	          _this3.progressBar.stepAtual = e.dados.stepAtual;
	          _this3.progressBar.stepTotal = e.dados.stepTotal;
	          _this3.progressBar.tarefaAtual = e.dados.tarefaAtual;
	        }
	      }).here(function (users) {
	        if (users.length > 1) {
	          _this3.$snotify.warning('Existe outro usuário acessando essa mesma proposta');
	        }
	      }).joining(function (user) {
	        _this3.$snotify.warning('Usuário ' + user.ds_nome_usuario + ' entrou para alterar essa proposta');
	      });
	    },
	    mostrarRef: function mostrarRef(ref) {
	      return _.filter(this.elementos, function (item) {
	        return item.nome === ref;
	      }).some(function (item) {
	        return item.visivel;
	      });
	    },
	    show: function show() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this4.$modal.show('visualizar');
	                _this4.$forceUpdate();
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this4);
	      }))();
	    },
	    hide: function hide() {
	      this.$modal.hide('visualizar');
	    },
	    retiraAspas: function retiraAspas($event) {
	      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
	      if (keyCode === 39 || keyCode === 34) {
	        $event.preventDefault();
	      }
	    },
	    buscaFluxo: function buscaFluxo() {
	      var _this5 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('fluxo/', { 'id_proposta': this.proposta.id, 'atividade': 'EXECUCAO' }).then(function (response) {
	        _this5.$snotify.clear();
	        _this5.fluxo = response.data;
	        _this5.elementos = _this5.fluxo.elementos;
	        _this5.loading.tela = false;
	
	        _this5.$forceUpdate();
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    buscaProposta: function buscaProposta() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var endpoint;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this6.loading.tela = true;
	                endpoint = 'projeto/numero/';
	
	                if (_this6.ehParceiroEstrategico) {
	                  endpoint = 'parceiroEstrategico/visualizarProjeto/';
	                }
	                _context3.next = 5;
	                return axiosLaravel.get(endpoint + _this6.$route.params.numero).then(function (response) {
	                  _this6.proposta = response.data;
	                  _this6.projeto['proposta'] = _this6.proposta;
	                  _this6.projetoPeriodos = _this6.proposta.nr_periodos;
	                  var mesesVigencia = Math.round((0, _moment2.default)(_this6.proposta.projetoSapiens['0']['usu_datfimvig']).diff((0, _moment2.default)(_this6.proposta.dt_assinatura_convenio), 'months', true));
	                  _this6.proposta.periodo_vigencia = _this6.ehNulo(_this6.proposta.periodo_vigencia, mesesVigencia);
	                  if (_this6.proposta.documentos) {
	                    if (_.isUndefined(_this6.proposta.documentos.proposta)) {
	                      if (_this6.proposta.documentos) {
	                        var documentosTemporarios = _this6.proposta.documentos;
	                        _this6.proposta.documentos = {
	                          proposta: documentosTemporarios
	                        };
	                        _this6.documentosProposta = _this6.proposta.documentos.proposta;
	                      } else {
	                        _this6.proposta.documentos = {
	                          proposta: []
	                        };
	                      }
	                    } else {
	                      _this6.documentosProposta = _this6.proposta.documentos.proposta;
	                    }
	                  }
	                  _this6.buscaEntidades();
	                  _this6.buscaFluxo();
	                  _this6.buscaArquivosEsperados();
	                  _this6.buscaCarteiras();
	                  _this6.verificaOpcoesProjeto();
	                  _this6.buscaContaAdiantamento();
	
	                  _this6.$forceUpdate();
	                }).catch(function (error) {
	                  _this6.$snotify.clear();
	                  _this6.$root.trataErro(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this6);
	      }))();
	    },
	    abrirLink: function abrirLink(caminho, novaJanela) {
	      window.open(location.protocol + '//' + location.host + caminho, novaJanela ? '_blank' : '_self');
	    },
	    periodoParaMesAno: function periodoParaMesAno(periodo, inicioProjeto, formato) {
	      return (0, _moment2.default)(inicioProjeto).add(periodo - 1, 'month').format(formato);
	    },
	    buscaContaAdiantamento: function buscaContaAdiantamento() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return axiosLaravel.get('conta-adiantamento/buscaConta', { params: { id: _this7.proposta.id } }).then(function (response) {
	                  if (!_.includes((0, _keys2.default)(response.data), 'codigo')) {
	                    var dadosBancarios = response.data;
	                    _this7.dadosBancariosAdiantamento.agencia = dadosBancarios.agencia;
	                    _this7.dadosBancariosAdiantamento.conta = dadosBancarios.conta;
	                    _this7.dadosBancariosAdiantamento.mci = dadosBancarios.mci;
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this7);
	      }))();
	    },
	    buscaEntidades: function buscaEntidades() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var currentDate, hoje;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this8.loading.tela = true;
	                currentDate = new Date();
	                hoje = (0, _moment2.default)(currentDate).format('YYYYMMDD');
	                _context5.next = 5;
	                return axiosLaravel.get('entidades/' + _this8.proposta.entidade.id).then(function (response) {
	                  _this8.proposta.entidade = response.data;
	                  var isTrue = function isTrue(v) {
	                    return v === true || v === 1 || v === '1' || v === 'true';
	                  };
	                  var representantesValidos = [];
	                  _.forEach(response.data.dirigentes, function (o) {
	                    if (isTrue(o.bt_assinatura_entidade) && isTrue(o.bt_ativo) && isTrue(o.bt_representante_legal) && isTrue(o.bt_assinatura_requerida)) {
	                      var dataInicial = (0, _moment2.default)(o.dt_inicio_mandato).format('YYYYMMDD');
	                      var dataFinal = (0, _moment2.default)(o.dt_fim_mandato).format('YYYYMMDD');
	                      if (dataInicial <= hoje && hoje <= dataFinal) {
	                        representantesValidos.push(o);
	                      }
	                    }
	                  });
	                  _this8.proposta.entidade.dirigentes = representantesValidos;
	                  _this8.loading.tela = false;
	                  _this8.$forceUpdate();
	                }).catch(function (error) {
	                  if (error) {
	                    _this8.$snotify.clear();
	                    _this8.$root.trataErro(error);
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this8);
	      }))();
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this9 = this;
	
	      axiosLaravel.get('projetos-duplicacao').then(function (response) {
	        _this9.arvoreProjetos = _.sortBy(response.data, 'numprj').reverse();
	        _this9.$snotify.success('Projeto carregado!', { timeout: 1000 });
	        _this9.loading.tela = false;
	      }).catch(function (error) {
	        _this9.$root.trataErro(error);
	      });
	    },
	    buscaCarteiras: function buscaCarteiras() {
	      var _this10 = this;
	
	      axiosLaravel.get('carteira/projeto/' + this.$route.params.numero).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this10.listaCarteiras = response.data.retorno['carteiras'];
	          _this10.carteiraSelecionada = response.data.retorno['carteira_projeto']['usu_codcart'];
	        } else {
	          _this10.$snotify.error(response.data.mensagem);
	        }
	        _this10.$forceUpdate;
	      }).catch(function (error) {
	        _this10.loading.show = false;
	        console.log('error', error);
	        _this10.$root.trataErro(error);
	      });
	    },
	    limpar: function limpar() {
	      this.proposta = (0, _assign2.default)({}, {
	        entidade: {
	          ds_nome: ''
	        },
	        ds_projeto_duplicacao_descricao: '' });
	    },
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this11 = this;
	
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this11.proposta.tipoDocumentos = response.data.configuracao_proposta.documentos_obrigatorios;
	        _this11.$forceUpdate();
	      }).catch(function (error) {
	        _this11.$root.trataErro(error);
	      });
	    },
	    salvar: function salvar() {
	      var _this12 = this;
	
	      this.loading.tela = true;
	      this.proposta.proximaEtapa = 'SALVAR';
	      this.$aguarde('Salvando proposta. Por favor, aguarde...');
	      axiosLaravel.put('propostas/' + this.proposta.id, this.proposta).then(function (response) {
	        _this12.$snotify.clear();
	        _this12.bloqueiaBotoes = false;
	        _this12.$snotify.success('Proposta atualizada com sucesso');
	        _this12.loading.tela = false;
	      }).catch(function (error) {
	        _this12.loading.tela = false;
	        _this12.$snotify.clear();
	        _this12.$root.trataErro(error);
	      });
	    },
	    isUploadingDocuments: function isUploadingDocuments() {
	      var documentosEsperados = this.proposta.documentTypes.map(function (item) {
	        return item.type;
	      });
	      var documentosCarregados = this.proposta.documents.map(function (item) {
	        return item.documentType.type;
	      });
	      return _.difference(documentosEsperados, documentosCarregados).length === 0;
	    },
	    validaObjetivos: function validaObjetivos() {
	      return this.proposta.objetivos.every(function (item) {
	        return item.metas ? item.metas.length > 0 : false;
	      });
	    },
	    toggleOpcoesProjeto: function toggleOpcoesProjeto() {
	      this.mostrar.opcoesProjeto = !this.mostrar.opcoesProjeto;
	      if (!this.proposta.opcoes) {
	        this.$forceUpdate();
	      }
	    },
	    verificaOpcoesProjeto: function verificaOpcoesProjeto() {
	      if (!this.proposta.opcoes) {
	        this.$forceUpdate();
	      }
	    },
	    validaMetas: function validaMetas() {
	      var metas = [];
	      this.proposta.objetivos.forEach(function (objetivo) {
	        if (objetivo.metas) {
	          objetivo.metas.forEach(function (meta) {
	            metas.push(meta);
	          });
	        }
	      });
	      return metas.every(function (meta) {
	        return meta.atividades ? meta.atividades.length > 0 : false;
	      });
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    editar: function editar(bloco) {
	      console.log('EDITANDO...');
	      this.editando = bloco;
	      if (bloco === '') {
	        this.editandoBloco = {};
	      }
	      if (bloco === 'coordenador') {
	        this.editandoBloco['ds_nome_coordenador'] = this.proposta.ds_nome_coordenador;
	        this.editandoBloco['ds_cpf_coordenador'] = this.proposta.ds_cpf_coordenador;
	        this.editandoBloco['ds_email_coordenador'] = this.proposta.ds_email_coordenador;
	        this.editandoBloco['ds_telefone_coordenador'] = this.proposta.ds_telefone_coordenador;
	        this.editandoBloco['ds_celular_coordenador'] = this.proposta.ds_celular_coordenador;
	      }
	      if (bloco === 'periodo_projeto') {
	        this.editandoBloco['nr_periodos'] = this.proposta.nr_periodos;
	        this.editandoBloco['dt_data_final'] = this.dataFinalExecucao;
	        this.editandoBloco['periodo_vigencia'] = this.proposta.periodo_vigencia;
	        this.editandoBloco['dt_data_vigencia'] = this.proposta.dt_data_vigencia;
	        this.proposta.periodo_vigencia = this.ehNulo(this.proposta.periodo_vigencia, parseInt(this.proposta.nr_periodos) + 12);
	
	        if (_.isEmpty(this.historicoAlteracaoPeriodo)) {
	          this.historicoAlteracaoPeriodo = {
	            dt_assinatura_convenio: this.proposta.dt_assinatura_convenio,
	            nr_periodos: this.proposta.nr_periodos,
	            dt_data_final: this.dataFinalExecucao,
	            periodo_vigencia: this.proposta.periodo_vigencia,
	            dt_data_vigencia: this.proposta.dt_data_vigencia
	          };
	        }
	        console.log('HistoricoAlteracaoObject: ', this.historicoAlteracaoPeriodo);
	      }
	      if (bloco === 'carteira_projeto') {
	        this.editandoBloco['carteira'] = _.clone(this.carteiraSelecionada);
	      }
	      if (bloco === 'publicos_alvo') {
	        this.editandoBloco['publicos_alvo'] = _.cloneDeep(this.proposta.publicos_alvo);
	      }
	      if (bloco === 'metas') {
	        this.editandoBloco['metas'] = _.cloneDeep(this.proposta.metas);
	      }
	      if (bloco === 'atividades') {
	        this.editandoBloco['atividades'] = _.cloneDeep(this.proposta.atividades);
	      }
	      if (bloco === 'gantt_atividades') {
	        this.editandoBloco['gantt_atividades'] = _.cloneDeep(this.proposta.gantt_atividades);
	      }
	      if (bloco === 'cronograma') {
	        this.editandoBloco['cronograma'] = _.cloneDeep(this.proposta.atividades);
	      }
	      if (bloco === 'parcelas_adiantamento') {
	        this.editandoBloco['parcelas_adiantamento'] = _.cloneDeep(this.proposta.adiantamentos);
	      }
	      if (bloco === 'municipalizacao') {
	        this.editandoBloco['municipalizacao'] = _.cloneDeep(this.proposta.municipalizacao);
	      }
	
	      if (bloco === 'conta_adiantamento') {
	        this.editandoBloco['conta_adiantamento'] = _.cloneDeep(this.dadosBancariosAdiantamento);
	      }
	      console.log('Editando ' + bloco, this.editandoBloco);
	    },
	    concluir: function concluir(bloco) {
	      var vm = this;
	      var msg = '';
	      var rota = '';
	      var post = {};
	
	      if (bloco === 'coordenador') {
	        msg = 'Alterando coordenador e atualizando o Sapiens...';
	        rota = 'projeto/atualiza/coordenador';
	        post = { 'projeto': this.proposta.ds_codigo_projeto_erp, 'antes': this.editandoBloco, 'alterado': { 'ds_nome_coordenador': this.proposta.ds_nome_coordenador, 'ds_cpf_coordenador': this.proposta.ds_cpf_coordenador, 'ds_email_coordenador': this.proposta.ds_email_coordenador, 'ds_telefone_coordenador': this.proposta.ds_telefone_coordenador, 'ds_celular_coordenador': this.proposta.ds_celular_coordenador } };
	        this.processarAlteracao(msg, rota, post);
	      }
	      if (bloco === 'carteira_projeto') {
	        msg = 'Movendo o Projeto de uma Carteira para outra e atualizando o Sapiens...';
	        rota = 'projeto/atualiza/carteira';
	        post = { 'projeto': this.proposta.ds_codigo_projeto_erp, 'antes': this.editandoBloco.carteira, 'alterado': this.carteiraSelecionada };
	        this.processarAlteracao(msg, rota, post);
	      }
	      if (bloco === 'periodo_projeto') {
	        msg = 'Prorrogando prazo/vigência do projeto e atualizando o Sapiens...';
	        rota = 'projeto/atualiza/prazo_projeto';
	
	        this.carregarDatas();
	
	        var periodicidades = [{ 'codigo': 'MENSAL', 'duracao': 1 }, { 'codigo': 'BIMESTRAL', 'duracao': 2 }, { 'codigo': 'TRIMESTRAL', 'duracao': 3 }, { 'codigo': 'QUADRIMESTRAL', 'duracao': 4 }, { 'codigo': 'SEMESTRAL', 'duracao': 6 }, { 'codigo': 'ANUAL', 'duracao': 12 }];
	        var periodicidadeMeses = _.get(_.find(periodicidades, ['codigo', this.proposta.ds_periodicidade_formulario]), 'duracao', 0);
	
	        var nrPeriodosNovo = parseInt(this.proposta.nr_periodos, 10) || 0;
	        var nrPeriodosAnterior = parseInt(this.editandoBloco.nr_periodos, 10) || 0;
	        var diferencaMeses = nrPeriodosNovo - nrPeriodosAnterior;
	
	        var qtdeRelatoriosNovos = periodicidadeMeses > 0 ? (0, _trunc2.default)(diferencaMeses / periodicidadeMeses) : 0;
	
	        var mensagem = 'Alterada duração da execução do projeto em <b>' + (diferencaMeses > 1 ? diferencaMeses + ' meses' : diferencaMeses === 1 ? diferencaMeses + ' mês' : ' nenhum mês') + '</b>.<br/><br/>' + 'A periodicidade de apresentação de relatório de execução é <b>' + this.proposta.ds_periodicidade_formulario + '</b> para este projeto.<br/><br/>' + (qtdeRelatoriosNovos > 1 ? 'Serão criados <b>' + qtdeRelatoriosNovos + ' relatórios de execução</b>' : qtdeRelatoriosNovos === 1 ? 'Será criado <b>' + qtdeRelatoriosNovos + ' relatório de execução</b>' : 'Nenhum relatório de execução será criado') + ' automaticamente ao concluir esta alteração.<br/><br/>' + 'Deseja continuar a alteração do período do projeto?';
	
	        this.$dialog.confirm(mensagem, { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	          console.log('Iniciando processamento do post', post);
	
	          vm.historicoAlteracaoPeriodo.dt_data_final = vm.parseData(vm.historicoAlteracaoPeriodo.dt_data_final);
	          post = {
	            'projeto': vm.proposta.ds_codigo_projeto_erp,
	            'antes': vm.editandoBloco,
	            'historico': vm.historicoAlteracaoPeriodo,
	            'alterado': {
	              'dt_assinatura_convenio': vm.dataConvenio,
	              'nr_periodos': vm.proposta.nr_periodos,
	              'dt_data_final': vm.dataFim,
	              'periodo_vigencia': vm.proposta.periodo_vigencia,
	              'dt_data_vigencia': vm.dataVigencia,
	              'qtde_relatorios_novos': qtdeRelatoriosNovos
	            }
	          };
	          vm.processarAlteracao(msg, rota, post);
	        });
	      }
	      if (bloco === 'publicos_alvo') {
	        msg = 'Alterando o Público-alvo do projeto e atualizando o Sapiens...';
	        rota = 'projeto/atualiza/publicos_alvo';
	        post = { 'projeto': this.proposta.ds_codigo_projeto_erp, 'antes': this.editandoBloco, 'alterado': { 'publicos_alvo': this.proposta.publicos_alvo } };
	        this.processarAlteracao(msg, rota, post);
	      }
	
	      if (bloco === 'metas') {
	        msg = 'Alterando as Metas do projeto...';
	        rota = 'projeto/atualiza/metas';
	        post = { 'projeto': this.proposta.ds_codigo_projeto_erp, 'antes': this.editandoBloco, 'alterado': { 'metas': this.proposta.metas } };
	        this.processarAlteracao(msg, rota, post);
	      }
	
	      if (bloco === 'atividades') {
	        msg = 'Alterando as Atividades do projeto...';
	        rota = 'projeto/atualiza/atividades';
	        post = { 'projeto': this.proposta.ds_codigo_projeto_erp, 'antes': this.editandoBloco, 'alterado': { 'atividades': this.proposta.atividades } };
	        this.processarAlteracao(msg, rota, post);
	      }
	
	      if (bloco === 'gantt_atividades') {
	        msg = 'Alterando o Gantt de Atividades do projeto...';
	        rota = 'projeto/atualiza/gantt_atividades';
	        post = { 'projeto': this.proposta.ds_codigo_projeto_erp, 'antes': this.editandoBloco, 'alterado': this.proposta.gantt_alterado.alterados, 'justificativa': this.proposta.gantt_alterado.justificativa };
	        this.processarAlteracao(msg, rota, post);
	      }
	
	      if (bloco === 'cronograma') {
	        msg = 'Alterando o Cronograma do projeto no SGP ...';
	        rota = 'projeto/atualiza/cronograma';
	        post = { 'projeto': this.proposta.ds_codigo_projeto_erp, 'antes': this.editandoBloco, 'alterado': { 'cronograma': this.cronogramaAlteracoes } };
	        this.processarAlteracao(msg, rota, post);
	      }
	
	      if (bloco === 'municipalizacao') {
	        msg = 'Alterando os Municípios do projeto...';
	        rota = 'projeto/atualiza/municipalizacao';
	
	        var idsAntes = _.map(this.editandoBloco.municipalizacao, 'id');
	        var idsDepois = _.map(this.proposta.municipalizacao, 'id');
	
	        var excluido = _.filter(this.editandoBloco.municipalizacao, function (a) {
	          return _.includes(_.difference(idsAntes, idsDepois), a.id);
	        });
	        post = { 'projeto': this.proposta.ds_codigo_projeto_erp, 'antes': this.editandoBloco, 'alterado': { 'municipalizacao': this.proposta.municipalizacao }, 'excluido': { 'municipalizacao': excluido } };
	        this.processarAlteracao(msg, rota, post);
	      }
	
	      if (bloco === 'conta_adiantamento') {
	        msg = 'Alterando Conta de adiantamento';
	        rota = 'conta-adiantamento/salvaConta';
	        post = {
	          id: this.proposta.id,
	          banco: this.dadosBancariosAdiantamento.banco,
	          tipo: this.dadosBancariosAdiantamento.tipo,
	          agencia: this.dadosBancariosAdiantamento.agencia,
	          conta: this.dadosBancariosAdiantamento.conta,
	          mci: this.dadosBancariosAdiantamento.mci
	        };
	
	        if (this.validandoDadosBancarios(this.dadosBancariosAdiantamento.agencia, this.dadosBancariosAdiantamento.conta)) {
	          this.processarAlteracao(msg, rota, post);
	        }
	      }
	    },
	    processarAlteracao: function processarAlteracao(msg, rota, post) {
	      var _this13 = this;
	
	      console.log('processarAlteracao', msg, rota, post);
	      if (msg !== '' && rota !== '') {
	        this.loading.tela = true;
	        this.$aguarde(msg);
	        axiosLaravel.post(rota, post).then(function (response) {
	          _this13.loading.tela = false;
	          _this13.$snotify.clear();
	          _this13.$snotify.success('Alteração realizada!', { timeout: 1000 });
	          console.log(bloco + ' atualizado :: ', response.data);
	          _this13.editar('');
	          _this13.$router.go(0);
	          _this13.$forceUpdate();
	          _this13.historicoAlteracaoPeriodo = {};
	        }).catch(function (error) {
	          _this13.loading.tela = false;
	          _this13.$snotify.clear();
	          _this13.editar('');
	          _this13.$root.trataErro(error);
	        });
	      }
	    },
	    cancelar: function cancelar(bloco) {
	      if (bloco === 'coordenador' && !_.isNull(this.editandoBloco)) {
	        this.proposta.ds_nome_coordenador = this.editandoBloco.ds_nome_coordenador;
	        this.proposta.ds_cpf_coordenador = this.editandoBloco.ds_cpf_coordenador;
	        this.proposta.ds_email_coordenador = this.editandoBloco.ds_email_coordenador;
	        this.proposta.ds_telefone_coordenador = this.editandoBloco.ds_telefone_coordenador;
	        this.proposta.ds_celular_coordenador = this.editandoBloco.ds_celular_coordenador;
	      }
	      if (bloco === 'periodo_projeto') {
	        this.proposta.nr_periodos = this.editandoBloco.nr_periodos;
	        this.dataFinalExecucao = this.editandoBloco.dt_data_final;
	        this.proposta.periodo_vigencia = this.editandoBloco.periodo_vigencia;
	        this.proposta.dt_data_vigencia = this.editandoBloco.dt_data_vigencia;
	      }
	      if (bloco === 'publicos_alvo') {
	        this.proposta.publicos_alvo = this.editandoBloco.publicos_alvo;
	      }
	      if (bloco === 'metas') {
	        this.proposta.metas = this.editandoBloco.metas;
	      }
	      if (bloco === 'atividades') {
	        this.proposta.atividades = this.editandoBloco.atividades;
	      }
	      if (bloco === 'cronograma') {
	        this.proposta.atividades = this.editandoBloco.cronograma;
	      }
	      if (bloco === 'parcelas_adiantamento') {
	        this.proposta.adiantamentos = this.editandoBloco['parcelas_adiantamento'];
	      }
	      if (bloco === 'municipalizacao') {
	        this.proposta.municipalizacao = this.editandoBloco['municipalizacao'];
	      }
	      console.log('Cancelar ' + bloco, this.editandoBloco);
	
	      this.editar('');
	    },
	    validaAtividades: function validaAtividades() {
	      var atividades = [];
	      this.proposta.objetivos.forEach(function (objetivo) {
	        if (objetivo.metas) {
	          objetivo.goals.forEach(function (meta) {
	            if (meta.atividades) {
	              meta.atividades.forEach(function (atividade) {
	                atividades.push(atividade);
	              });
	            }
	          });
	        }
	      });
	      return atividades.every(function (atividade) {
	        return atividade.items ? atividade.items.length > 0 : false;
	      });
	    },
	    emitir: function emitir(relatorio) {
	      var _this14 = this;
	
	      var mosDes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loading.tela = true;
	      var parametros = '<ECodEmp=1><ENumPrj=' + this.$route.params.numero + '>';
	      if (relatorio === 222 || relatorio === 219) {
	        parametros += '<ESitPrj=ULT>';
	      }
	      if (relatorio === 222) {
	        parametros += '<EMosDes=S>';
	      }
	      if (relatorio === 292) {
	        parametros = '<ENumPrj=' + this.$route.params.numero + '>' + '<EsitTit=LQ><ElsEnt=S><EassEnt=S>';
	      }
	
	      if (relatorio === 525) {
	        parametros = '<ENumPrj=' + this.$route.params.numero + '><EMosDes=' + mosDes + '>';
	      }
	      var identificacao = relatorio === 525 ? '525 - Extrato ' + (mosDes === 'S' ? 'Analítico' : 'Sintético') : relatorio;
	      this.$snotify.clear();
	      this.$aguarde('Gerando relatório ' + identificacao + '. Por favor, aguarde...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': 'FJCF' + relatorio + '.GER' }, params: parametros }).then(function (response) {
	        _this14.onDownload(response, identificacao, _this14);
	      }).catch(function (error) {
	        _this14.$snotify.clear();
	        _this14.loading.tela = false;
	        _this14.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (!ie) {
	        var blob = file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp + ' - ' + vm.proposta.ds_nome;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	        _link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp + ' - ' + vm.proposta.ds_nome;
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading.tela = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    validandoDadosBancarios: function validandoDadosBancarios(agenciaVal, contaVal) {
	      console.log('Validando dados bancários - conta adiantamento');
	      if (agenciaVal && contaVal) {
	        var banco = '001';
	        var conta = _.words(contaVal);
	        var digitosConta = _.get(_.head(_.filter(this.listaBancos, ['codigo', banco])), 'caracteresConta');
	        var contaSemDV = digitosConta ? _.padStart(conta[0], digitosConta, '0') : conta[0];
	        var contaDV = conta[1] || '';
	
	        var agencia = _.words(agenciaVal);
	        var agenciaSemDV = agencia[0] || '';
	        var agenciaDV = agencia[1] || '';
	        console.log(agencia, conta);
	        try {
	          _brBankAccountValidator2.default.validate({
	            bankNumber: banco,
	            agencyNumber: agenciaSemDV,
	            agencyCheckNumber: agenciaDV,
	            accountNumber: contaSemDV,
	            accountCheckNumber: contaDV
	          });
	          return true;
	        } catch (e) {
	          console.log('Erro na validação de dados bancários', e.message);
	          this.$snotify.error(e.message);
	          return false;
	        }
	      }
	      this.$snotify.error('Preencha o número da agência e conta corretamente antes de continuar ou clique em CANCELAR.');
	      return false;
	    },
	    limitarDigitosMCI: function limitarDigitosMCI() {
	      if (this.dadosBancariosAdiantamento.mci.length > 9) {
	        this.dadosBancariosAdiantamento.mci = this.dadosBancariosAdiantamento.mci.slice(0, 9);
	      }
	    },
	    consultaContaInterna: function consultaContaInterna() {
	      var _this15 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                console.log('CONSULTANDO CONTA INTERNA ', _this15.$route.params.numero);
	                _context6.next = 3;
	                return axiosLaravel.get('conta-adiantamento/buscaContaInterna', { params: { codigoProjeto: _this15.$route.params.numero } }).then(function (response) {
	                  var dadosFinanceiros = response.data[0];
	                  _this15.codFor = dadosFinanceiros.codfor;
	                  _this15.bancoContaInterna = dadosFinanceiros.codban;
	                  _this15.agenciaContaInterna = dadosFinanceiros.codage;
	                  _this15.contaInterna = dadosFinanceiros.ccbfor;
	                });
	
	              case 3:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this15);
	      }))();
	    },
	    refreshAlteracoes: function refreshAlteracoes() {
	      console.log('REFRESH ALTERACOES');
	      this.refreshAlt++;
	    },
	    consultaAcessoGerenteSolucoes: function consultaAcessoGerenteSolucoes() {
	      this.acessoGerSolucoes = false;
	      if (this.usuarioLogado && Array.isArray(this.usuarioLogado.perfis)) {
	        var perfis = this.usuarioLogado.perfis;
	        for (var i = 0; i < perfis.length; i++) {
	          if (perfis[i].id === 14) {
	            this.acessoGerSolucoes = true;
	          }
	        }
	      }
	      console.log('acesso GSOL: ', this.acessoGerSolucoes);
	    },
	    parseData: function parseData(data) {
	      if (!data) return null;
	      var formato = data.includes('/') ? 'DD/MM/YYYY' : 'YYYY-MM-DD';
	      var m = (0, _moment2.default)(data, formato, true);
	      return m.isValid() ? m.format('YYYY-MM-DD') : null;
	    },
	    carregarDatas: function carregarDatas() {
	      this.dataConvenio = this.parseData(this.proposta.dt_assinatura_convenio);
	      this.dataVigencia = this.parseData(this.proposta.dt_data_vigencia);
	      this.dataFim = this.parseData(this.dataFinalExecucao);
	    },
	    atualizaOpcoesAlteracoes: function atualizaOpcoesAlteracoes() {
	      var _this16 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('projeto/opcoes', { 'id': this.proposta.id, 'opcoes': _.get(this.proposta, 'opcoes', []) }).then(function (response) {
	        _this16.$snotify.clear();
	        _this16.$snotify.clear();
	        _this16.loading.tela = false;
	      }).catch(function (error) {
	        _this16.loading.tela = false;
	        _this16.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'visualiza-timeline',
	  data: function data() {
	    return {
	      loading: true,
	      eventos: [],
	      eventosBackup: [],
	      qdtEventos: 0,
	      projeto: {},
	      historicoSituacoes: {},
	      eventData: {},
	      temp: 0,
	      selecLinha: 0,
	      numero: null,
	      posicao: 'relativo',
	      zoom: 2,
	      tamanho: 1500,
	      distancia_centro: 10,
	      data_vertical: false,
	      mostrarOpcoes: false,
	      mostrarEscala: false,
	      mostrarSituacoesHistoricas: true,
	      mostrarTotalizador: false,
	      mostrarQuadro: false,
	      totalizador: {},
	      icones: {
	        'NAO_HA': 'fa fa-question',
	        'HOJE_DIA': 'fa fa-sun-o',
	        'HOJE_NOITE': 'fa fa-moon-o',
	        'PROJETO_APROVACAO': 'fa fa-check',
	        'ASSINATURA_CONVENIO': 'fa fa-pencil',
	        'PROJETO_INICIO': 'fa fa-rocket',
	        'PROJETO_TERMINO': 'fa fa-home',
	        'PROJETO_ENCERRAMENTO': 'fa fa-hourglass-end',
	        'RELATORIO_DE_EXECUCAO': 'fa fa-calendar-check-o',
	        'CONTATO': 'fa fa-phone',
	        'INFORMACAO': 'fa fa-info',
	        'DEMANDA_FBB': 'fa fa-file-text-o',
	        'DEMANDA_PARCEIRO': 'fa fa-file-text',
	        'OCORRENCIA_IMPEDITIVA': 'fa fa-ban',
	        'ALTERACAO_DE_METAS': 'fa fa-flag-checkered',
	        'ALTERACAO_CONTRAPARTIDA': 'fa fa-thumbs-o-up',
	        'AJUSTE_QUANTIDADE_ITENS_DE_DESPESA': 'fa fa-cubes',
	        'INCLUSAO_DE_ITENS_DE_DESPESA': 'fa fa-cart-plus',
	        'SUBSTITUICAO_DE_ITENS_DE_DESPESA': 'fa fa-cart-arrow-down',
	        'ALTERACAO_DA_LOCALIZACAO_DE_IMPLEMENTACAO_DO_PROJETO': 'fa fa-map-o',
	        'REMANEJAMENTO': 'fa fa-retweet',
	        'SUPLEMENTACAO_DE_RECURSOS': 'fa fa-plus',
	        'PRORROGACAO_DE_PRAZO': 'fa fa-calendar',
	        'ALTERACAO_DA_FORMA_DE_LIBERACAO_DOS_RECURSOS': 'fa fa-money',
	        'OUTRAS_ALTERACOES': 'fa fa-asterisk',
	        'EXTERNALIDADE': 'fa fa-sign-in',
	        'EFICIENCIA': 'fa fa-line-chart',
	        'FBB': 'fa fa-building',
	        'FALHA_PLANEJAMENTO': 'fa fa-bomb'
	      },
	      cores: {
	        'NORMAL': '#1565c0',
	        'ATENCAO': '#ff9900',
	        'EM_SER': '#c62828',
	        'EM_CONDUCAO': '#c62828',
	        'BAIXADA': '#808080',
	        'CONCLUIDO': '#808080',
	        'NAO_HA': '#808080',
	        'FEITO': '#2e7d32'
	      }
	    };
	  },
	
	  props: ['numeroProjeto', 'atualizar'],
	  watch: {
	    atualizar: function atualizar() {
	      this.carregaTimeline();
	    },
	    selecLinha: function selecLinha() {
	      var _this = this;
	
	      var i = 0;
	      if (this.eventos) {
	        for (i = 0; i < this.eventos.length; i++) {
	          if (this.eventos[i].id === this.selecLinha) {
	            this.$nextTick(function () {
	              _this.temp = _this.selecLinha;
	
	              _this.$refs[_this.selecLinha][0].scrollIntoView();
	            });
	          }
	        }
	      }
	    }
	  },
	  computed: {
	    ultimaReferencia: function ultimaReferencia() {
	      return this.eventos.length > 0 ? this.eventos[this.eventos.length - 1].referencia : 0;
	    }
	  },
	  mounted: function mounted() {
	    var vm = this;
	    vm.$events.listen('linhaSelecionada', function (eventData) {
	      vm.selecLinha = eventData.id;
	    });
	    this.selecLinha = vm.selecLinha;
	  },
	  created: function created() {
	    this.numero = this.$route.params.numero;
	    if (this.numero) {
	      this.carregaTimeline();
	    }
	  },
	
	  methods: {
	    carregaTimeline: function carregaTimeline() {
	      var _this2 = this;
	
	      this.loading = true;
	      axiosLaravel.get('timeline/' + this.numero).then(function (response) {
	        _this2.projeto = response.data.projeto[0];
	        _this2.eventos = _.sortBy(response.data.timeline, 'referencia');
	        _this2.qdtEventos = _this2.ultimaReferencia;
	
	        _this2.zoom = _this2.ultimaReferencia < 550 ? 2.5 : _this2.ultimaReferencia < 900 ? 2 : 1;
	        _this2.historicoSituacoes = _.sortBy(response.data.historico_situacoes, 'data').reverse();
	        _this2.eventosBackup = _this2.eventos;
	        _this2.totalizador['total_acompanhamento'] = response.data.total_acompanhamento;
	        _this2.totalizador['total_alteracoes'] = response.data.total_alteracoes;
	        _this2.totalizador['total_relatorios_execucao'] = response.data.total_relatorios_execucao;
	        _this2.loading = false;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    icone: function icone(tag) {
	      return this.icones[tag] === undefined ? this.icones['NAO_HA'] : this.icones[tag];
	    },
	    cor: function cor(situacao) {
	      return this.cores[situacao] === undefined ? this.cores['NAO_HA'] : this.cores[situacao];
	    },
	    filtrarGrids: function filtrarGrids(origem, id) {
	      if (origem === 'acompanhamento') {
	        this.$emit('idAcompanhamento', id);
	      } else if (origem === 'alteracoes') {
	        this.$emit('idAlteracoes', id);
	      } else if (origem === 'relatorio_execucao') {
	        var pagina = this.$router.resolve({ name: 'visualiza-relatorio-execucao', params: { id: this.numero } });
	        window.open(pagina.href, '_blank');
	      }
	    },
	    filtrarTimeline: function filtrarTimeline(filtro) {
	      if (this.eventos.length !== this.eventosBackup.length) {
	        this.voltarBackupEventos();
	      }
	      this.eventos = _.sortBy(_.union(_.filter(this.eventos, ['tag', filtro]), _.filter(this.eventosBackup, ['grupo', 'projeto'])), 'referencia');
	    },
	    haRegistros: function haRegistros(lista, filtro) {
	      var saida = false;
	      if (!_.isUndefined(lista)) {
	        if (_.isNull(filtro)) {
	          saida = lista.length > 0;
	        } else {
	          saida = _.filter(lista, function (o) {
	            return _.includes(filtro, o.codigo);
	          }).length > 0;
	        }
	      }
	      return saida;
	    },
	    voltarBackupEventos: function voltarBackupEventos() {
	      this.eventos = this.eventosBackup;
	    },
	    situacaoProjeto: function situacaoProjeto(data) {
	      var situacaoAlterada = _.find(this.historicoSituacoes, function (o) {
	        return o.data < data;
	      });
	      if (_.isUndefined(situacaoAlterada)) {
	        return 'conducao_normal';
	      }
	      return _.includes(['APR', 'DEF', 'ANA', 'ETO', 'ENC', 'ANU', 'CAN', 'ESE'], situacaoAlterada.situacao) ? 'conducao_normal' : 'conducao_suspenso';
	    },
	    diasData: function diasData(inicio, dias) {
	      var data = new Date(inicio);
	      data.setDate(data.getDate() + dias);
	      return data.toLocaleDateString('de', { year: '2-digit', month: '2-digit', day: '2-digit' });
	    },
	    moverParaHoje: function moverParaHoje() {
	      this.$refs['HOJE'][0].scrollIntoView();
	    }
	  }
	};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _telefone = __webpack_require__(142);
	
	var _telefone2 = _interopRequireDefault(_telefone);
	
	var _publicoAlvoOld = __webpack_require__(1735);
	
	var _publicoAlvoOld2 = _interopRequireDefault(_publicoAlvoOld);
	
	var _acompanhamentoProjetos = __webpack_require__(1767);
	
	var _acompanhamentoProjetos2 = _interopRequireDefault(_acompanhamentoProjetos);
	
	var _alteracoesProjetos = __webpack_require__(528);
	
	var _alteracoesProjetos2 = _interopRequireDefault(_alteracoesProjetos);
	
	var _equipeProjetoOld = __webpack_require__(1709);
	
	var _equipeProjetoOld2 = _interopRequireDefault(_equipeProjetoOld);
	
	var _objetivoEspecificoOld = __webpack_require__(1720);
	
	var _objetivoEspecificoOld2 = _interopRequireDefault(_objetivoEspecificoOld);
	
	var _metasOld = __webpack_require__(1717);
	
	var _metasOld2 = _interopRequireDefault(_metasOld);
	
	var _atividadesOld = __webpack_require__(1690);
	
	var _atividadesOld2 = _interopRequireDefault(_atividadesOld);
	
	var _cronogramaOld = __webpack_require__(1704);
	
	var _cronogramaOld2 = _interopRequireDefault(_cronogramaOld);
	
	var _vuex = __webpack_require__(3);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacaoOld = __webpack_require__(1718);
	
	var _municipalizacaoOld2 = _interopRequireDefault(_municipalizacaoOld);
	
	var _cursosOld = __webpack_require__(1705);
	
	var _cursosOld2 = _interopRequireDefault(_cursosOld);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoPropostaOld = __webpack_require__(1711);
	
	var _historicoPropostaOld2 = _interopRequireDefault(_historicoPropostaOld);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Timeline = __webpack_require__(258);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _AtividadesOld = __webpack_require__(1760);
	
	var _AtividadesOld2 = _interopRequireDefault(_AtividadesOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    VisualizaTimeline: _Timeline2.default,
	    VisualizaGanttOld: _AtividadesOld2.default,
	    HistoricoPropostaOld: _historicoPropostaOld2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    CursosOld: _cursosOld2.default,
	    MunicipalizacaoOld: _municipalizacaoOld2.default,
	    Gantt: _Gantt2.default,
	    acompanhamentoProjetos: _acompanhamentoProjetos2.default,
	    alteracoesProjetos: _alteracoesProjetos2.default,
	    CronogramaOld: _cronogramaOld2.default,
	    AtividadesOld: _atividadesOld2.default,
	    MetasOld: _metasOld2.default,
	    ObjetivoEspecificoOld: _objetivoEspecificoOld2.default,
	    Telefone: _telefone2.default,
	    PublicoAlvoOld: _publicoAlvoOld2.default,
	    EquipeProjetoOld: _equipeProjetoOld2.default
	  },
	  name: 'visualiza-projeto',
	  data: function data() {
	    return {
	      mostrarCabecalhoProjeto: false,
	      itensCronograma: [],
	      itensCronogramaContrapartida: [],
	      itensCronogramaFundacao: [],
	      atividadesCronograma: [],
	      loading: {
	        show: false
	      },
	      filtro_acompanhamento: '',
	      filtro_alteracoes: '',
	      atualizar_timeline: null,
	      alteracao: [],
	      acProp: [],
	      atProp: [],
	      mudarOrc: 0,
	      mudarCro: 0,
	      projeto: {
	        proposal: {
	          entity: {
	            active: true
	          }
	        }
	      },
	      blockCounterpart: false,
	      blockPayment: false,
	      blockRefund: false,
	      blockAdvance: false,
	      blockAccountability: false,
	      blockStatusERP: false,
	      warnAccountability: false,
	      objetivos: {},
	      changeFinPhy: 'ACTIVITIES',
	      proposta: {
	        periods: null,
	        entity: {
	          companyName: ''
	        },
	        duplicateProjectDescription: ''
	      },
	      fields: [{
	        key: 'plot',
	        label: 'Número da Parcela',
	        thStyle: 'width: 40%; text-align: center',
	        sortable: true,
	        'class': 'text-center'
	      }, {
	        key: 'period',
	        label: 'Período',
	        thStyle: 'width: 6%; text-align: center',
	        sortable: true,
	        'class': 'text-center'
	      }, {
	        key: 'value',
	        label: 'Valor Adiantável',
	        thStyle: 'width: 30%; text-align: center',
	        sortable: true,
	        'class': 'word-wrap:break-word text-center'
	      }],
	      table: {
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: false,
	        filter: null,
	        bordered: true
	      },
	      arvoreProjetos: []
	    };
	  },
	
	  watch: {
	    'proposta.duplicateProject': function propostaDuplicateProject() {
	      var _this = this;
	
	      if (this.arvoreProjetos.length) {
	        var projetoSelecionado = this.arvoreProjetos.find(function (projeto) {
	          return projeto.projectNumber === _this.proposta.duplicateProject;
	        });
	        this.projeto.proposal.duplicateProjectDescription = projetoSelecionado.projectName;
	      }
	    }
	  },
	  computed: (0, _extends3.default)({
	    parcelasAdiantamentoExibicao: function parcelasAdiantamentoExibicao() {
	      var parcelas = _.get(this, 'projeto.proposal.advancePlots', []) || [];
	      var grupos = _.groupBy(parcelas, function (p) {
	        return '' + _.get(p, 'plot');
	      });
	      var consolidadas = _.map(grupos, function (grupo) {
	        var linha = _.cloneDeep(_.head(grupo));
	        linha.value = _.round(_.sumBy(grupo, function (g) {
	          return _.toNumber(_.get(g, 'value', 0));
	        }), 2);
	        linha._mista = grupo.length > 1;
	        return linha;
	      });
	      return _.orderBy(consolidadas, [function (p) {
	        return _.toNumber(_.get(p, 'plot'));
	      }], ['asc']);
	    },
	
	    dataFinal: function dataFinal() {
	      return (0, _moment2.default)(this.projeto.proposal.initialDate).add(this.projeto.proposal.periods, 'M').format('DD/MM/YYYY');
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      if (this.projeto.proposal.objectives) {
	        return this.projeto.proposal.objectives.some(function (o) {
	          return o.goals.activities !== null;
	        });
	      }
	    },
	    totalFundacaoContratado: function totalFundacaoContratado() {
	      if (this.itensCronogramaFundacao.length > 0) {
	        return this.itensCronogramaFundacao.reduce(function (acumulador, objeto) {
	          return acumulador + objeto.Valor_orcado;
	        }, 0);
	      }
	      return 0;
	    },
	    totalFundacaoSaldo: function totalFundacaoSaldo() {
	      if (this.itensCronogramaFundacao.length > 0) {
	        return this.itensCronogramaFundacao.reduce(function (acumulador, objeto) {
	          return acumulador + objeto.Valor_saldo;
	        }, 0);
	      }
	      return 0;
	    },
	    totalFundacaoContratadoContrapartida: function totalFundacaoContratadoContrapartida() {
	      if (this.itensCronogramaContrapartida.length > 0) {
	        return this.itensCronogramaContrapartida.reduce(function (acumulador, objeto) {
	          return acumulador + objeto.Valor_orcado;
	        }, 0);
	      }
	      return 0;
	    },
	    totalFundacaoSaldoContrapartida: function totalFundacaoSaldoContrapartida() {
	      if (this.itensCronogramaContrapartida.length > 0) {
	        return this.itensCronogramaContrapartida.reduce(function (acumulador, objeto) {
	          return acumulador + objeto.Valor_saldo;
	        }, 0);
	      }
	      return 0;
	    },
	    atividades: function atividades() {
	      var _this2 = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this2.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  created: function created() {
	    var _this3 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this3.mudarOrc = 0;
	              _this3.mudarCro = 1;
	              _this3.proposta = {};
	              _context.next = 5;
	              return _this3.buscaProjeto();
	
	            case 5:
	              _this3.buscaCronograma();
	              _this3.buscaArvoreProjeto();
	              if (_this3.projeto && _this3.projeto.proposal.entity && !_this3.projeto.proposal.entity.active) {
	                _this3.blockPayment = true;
	                _this3.blockRefund = true;
	                _this3.blockAdvance = true;
	                _this3.blockStatusERP = true;
	                show.info = true;
	                show.message = 'Algumas solicitações não podem ser realizadas pois a entidade está inativa.';
	              }
	              if (_this3.projeto.proposal.statusERP === 'JUD' || _this3.projeto.proposal.statusERP === 'DLG' || _this3.projeto.proposal.statusERP === 'ETO' || _this3.projeto.proposal.statusERP === 'SPS' || _this3.projeto.proposal.statusERP === 'ENC') {
	                _this3.blockPayment = true;
	                _this3.blockRefund = true;
	                _this3.blockAdvance = true;
	                _this3.blockStatusERP = true;
	              }
	              if (_this3.projeto.proposal.statusERP === 'SAF' || _this3.projeto.proposal.statusERP === 'ESE') {
	                _this3.blockCounterpart = true;
	                _this3.blockAccountability = true;
	                _this3.blockPayment = true;
	                _this3.blockRefund = true;
	                _this3.blockAdvance = true;
	                _this3.blockStatusERP = true;
	              }
	              if (_this3.projeto.proposal.statusERP === 'SO3' || _this3.projeto.proposal.statusERP === 'SO4') {
	                _this3.warnAccountability = true;
	                _this3.blockPayment = true;
	                _this3.blockRefund = true;
	                _this3.blockAdvance = true;
	                _this3.blockStatusERP = true;
	              }
	              if (_this3.blockStatusERP) {
	                _this3.$swal({
	                  title: '<font color="red"><b>Atenção!</b></font>',
	                  html: '<div align="left"> Algumas solicitações não podem ser realizadas pois o projeto está em estado ' + '<b>' + _this3.projeto.proposal.statusERP + '' + '</div>'
	                });
	              }
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3);
	    }))();
	  },
	
	  methods: {
	    buscaProposta: function buscaProposta() {
	      var _this4 = this;
	
	      this.proposta = {};
	      this.loading.show = true;
	      axios.get('proxy/project/proposal/' + this.projeto.proposal.id).then(function (response) {
	        _this4.proposta = response.data.value;
	        _this4.loading.show = false;
	
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    buscaProjeto: function buscaProjeto() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return axios.get('proxy/project/project-management/' + _this5.$route.params.id).then(function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(response) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            _this5.projeto = response.data.value;
	                            console.log('this.projeto', _this5.projeto);
	                            _this5.objetivos = _this5.projeto.proposal.objectives;
	                            _this5.proposta = {};
	                            _context2.next = 6;
	                            return _this5.buscaProposta();
	
	                          case 6:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this5);
	                  }));
	
	                  return function (_x) {
	                    return _ref.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this5.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this5);
	      }))();
	    },
	    onRedirect: function onRedirect(type) {
	      if (type === 'COUNTERPART') {
	        this.$router.push('/solicitacao/contrapartida/');
	      }
	      if (type === 'PAYMENT') {
	        this.$router.push('/solicitacao/pagamento/');
	      }
	      if (type === 'ACCOUNTABILITY') {
	        this.$router.push('/solicitacao/prestacaocontas/');
	      }
	      if (type === 'DEVOLUTION') {
	        this.$router.push('/solicitacao/devolucao_adiantamento/');
	      }
	      if (type === 'ADVANCE') {
	        this.$router.push('/solicitacao/adiantamento/');
	      }
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this6 = this;
	
	      axios.get('/proxy/project/project-tree').then(function (response) {
	        _this6.arvoreProjetos = response.data.value;
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    mudaVisaoOrc: function mudaVisaoOrc() {
	      this.mudarOrc = 1;
	      this.mudarCro = 0;
	    },
	    mudaVisaoCro: function mudaVisaoCro() {
	      this.mudarOrc = 0;
	      this.mudarCro = 1;
	    },
	    buscaCronograma: function buscaCronograma() {
	      var _this7 = this;
	
	      axiosLaravel.post('/processos/cronograma/projeto/', {
	        'projeto': this.projeto.id,
	        'documento': 0,
	        'processo': 'PAGAMENTO',
	        'aglutinado': 'Completo'
	      }).then(function (response) {
	        _this7.itensCronograma = response.data.itens;
	        _this7.itensCronogramaContrapartida = response.data.itens.filter(function (item) {
	          return item.Item_Recurso === 'Contrapartida';
	        });
	        _this7.itensCronogramaFundacao = response.data.itens.filter(function (item) {
	          return item.Item_Recurso !== 'Contrapartida';
	        });
	        _this7.atividadesCronograma = response.data.itens;
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    formatarNumero: function formatarNumero(numero, formato) {
	      if (formato === 'moeda') {
	        return numero.toLocaleString('pt-BR', {
	          minimumFractionDigits: 2,
	          maximumFractionDigits: 2
	        });
	      } else if (formato === 'percentual') {
	        return (numero * 100).toLocaleString('pt-BR', {
	          minimumFractionDigits: 0,
	          maximumFractionDigits: 0
	        });
	      } else if (formato === 'inteiro') {
	        return numero.toLocaleString('pt-BR', {
	          minimumFractionDigits: 0,
	          maximumFractionDigits: 0
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _vueCarousel = __webpack_require__(1617);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Carousel: _vueCarousel.Carousel,
	    Slide: _vueCarousel.Slide,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default
	  },
	  name: 'acompanhamentoProjetos',
	  data: function data() {
	    return {
	      disabledDates: {
	        customPredictor: function customPredictor(date) {
	          if ((0, _moment2.default)(date).format('YYYYMMDD') < (0, _moment2.default)(new Date()).format('YYYYMMDD')) {
	            return true;
	          }
	        }
	      },
	      highlighted: {
	        customPredictor: function customPredictor(date) {
	          var d1 = (0, _moment2.default)(date).format('YYYYMMDD');
	          var d2 = (0, _moment2.default)(new Date()).format('YYYYMMDD');
	          if (d1 === d2) {
	            return true;
	          }
	        }
	      },
	      numero: null,
	      projeto: [],
	      contador: 0,
	      atualizar: 0,
	      temp: [],
	      loading: true,
	      eventData: {},
	      ocorrenciasImpeditiva: [],
	      ocorrenciasInformativa: [],
	      salvouOK: false,
	      libera: false,
	      renderComponent: true,
	      arr: [],
	      place: '',
	      colorFadeStyle: { color: '#c1c1c1' },
	      detalhamentoAnt: '',
	      objBackend: [],
	      acProp: [],
	      mostraOcor: false,
	      mostraStatus: false,
	      editandoIndex: null,
	      acompanhamento: {
	        detalhamento: '',
	        documentos: [],
	        dt_registro: null,
	        ocorrencia_sapiens: null,
	        responsavel: null,
	        tipo: null,
	        tipo_ocorrencia: null
	      },
	      steps: this.temp,
	      dadosTime: [],
	      documento: [],
	      showgrid: true,
	      timeline_description: '',
	      table: {
	        items: [],
	        bloqueioCampos: false,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        sortBy: 'dt_registro',
	        sortDesc: true,
	        perPage: 10,
	        acompanhamentoTable: [],
	        fields: [{
	          key: 'id',
	          label: 'id',
	          sortable: true,
	          thStyle: 'text-align: center; width: 50px',
	          class: 'text-center'
	        }, {
	          key: 'dt_registro',
	          label: 'Data',
	          sortable: true,
	          thStyle: 'text-align: center; width: 7%',
	          class: 'text-center'
	        }, { key: 'tipo', label: 'Tipo', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, {
	          key: 'detalhamento',
	          label: 'Detalhe',
	          sortable: true,
	          thStyle: 'text-align: left; width: 46%',
	          class: 'text-left'
	        }, {
	          key: 'status',
	          label: 'Status',
	          sortable: true,
	          thStyle: 'text-align: center; width: 10%',
	          class: 'text-center'
	        }, {
	          key: 'prazo',
	          label: 'Prazo',
	          sortable: true,
	          thStyle: 'text-align: center; width: 7%',
	          class: 'text-center'
	        }, {
	          key: 'responsavel.ds_nome_usuario',
	          label: 'Responsável',
	          sortable: true,
	          thStyle: 'text-align: center; width: 10%',
	          class: 'text-center'
	        }, {
	          key: 'documentos',
	          label: 'Anexos',
	          sortable: true,
	          thStyle: 'text-align: center; width: 5%',
	          class: 'text-center'
	        }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 5%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['ParmProjetos', 'ParmAcompanhamento', 'filtro'],
	  watch: {
	    ParmProjetos: function ParmProjetos() {
	      this.projeto = this.ParmProjetos;
	    },
	    filtro: function filtro() {
	      var _this = this;
	
	      this.table.filter = this.filtro;
	      this.$nextTick(function () {
	        _this.$parent.$refs['acompanhamento'].scrollIntoView();
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  mounted: function mounted() {},
	  created: function created() {
	    this.numero = this.$route.params.numero;
	    if (this.numero) {
	      this.projeto = this.ParmProjetos;
	      this.buscaAcompanhamentoProp();
	      this.buscaTipos();
	      this.buscaOcorrencias();
	    }
	  },
	
	  methods: {
	    forceRerender: function forceRerender() {
	      var _this2 = this;
	
	      this.renderComponent = false;
	      this.$nextTick(function () {
	        _this2.renderComponent = true;
	        _this2.atualizar += 1;
	        _this2.$forceUpdate();
	      });
	    },
	    linha: function linha(data) {
	      var vm = this;
	      vm.eventData = data;
	      vm.$events.emit('linhaSelecionada', vm.eventData);
	    },
	    buscaTipos: function buscaTipos() {
	      var _this3 = this;
	
	      axiosLaravel.get('tipo-registros/').then(function (response) {
	        var arr = response.data;
	        _this3.tipos = _.filter(arr, function (o) {
	          if (o.grupo === 'ACOMPANHAMENTO') return o;
	        });
	        _this3.tipoOcorrencia = _.filter(arr, function (o) {
	          if (o.grupo === 'TIPO_OCORRENCIA_ACOMPANHAMENTO') return o;
	        });
	        _this3.statusAcompanhamento = _.filter(arr, function (o) {
	          if (o.grupo === 'STATUS_ACOMPANHAMENTO') return o;
	        });
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaOcorrencias: function buscaOcorrencias() {
	      var _this4 = this;
	
	      console.log('buscaOcorrencias');
	      axiosLaravel.get('tipo-ocorrencia/').then(function (response) {
	        var arrOcr = response.data;
	        console.log('arrOcr', arrOcr);
	        _this4.ocorrenciasImpeditiva = _.filter(arrOcr, function (o) {
	          if (o.tipo_ocorrencia === 3 || o.tipo_ocorrencia === 4) return o;
	        });
	        console.log('this.ocorrenciasImpeditiva', _this4.ocorrenciasImpeditiva);
	        _this4.ocorrenciasInformativa = _.filter(arrOcr, function (o) {
	          if (o.tipo_ocorrencia === 1 || o.tipo_ocorrencia === 2) return o;
	        });
	        console.log('this.ocorrenciasInformativa', _this4.ocorrenciasInformativa);
	        _this4.ocorrenciasImpeditiva = _.sortBy(_this4.ocorrenciasImpeditiva, 'codigo');
	        _this4.ocorrenciasInformativa = _.sortBy(_this4.ocorrenciasInformativa, 'codigo');
	      }).catch(function (error) {
	        console.log('error', error);
	        _this4.$root.trataErro(error);
	      });
	    },
	    onSelect: function onSelect(selectedOption, tipos) {
	      if (selectedOption.codigo === 'OCORRENCIA_IMPEDITIVA' || selectedOption.codigo === 'INFORMACAO') {
	        this.mostraOcor = true;
	        this.tp = selectedOption.codigo;
	      } else {
	        this.tp = selectedOption.codigo;
	        this.mostraOcor = false;
	      }
	      if (selectedOption.codigo === 'INFORMACAO' || selectedOption.codigo === 'CONTATO' || selectedOption.codigo === 'OCORRENCIA_IMPEDITIVA') {
	        this.mostraStatus = false;
	      } else {
	        this.mostraStatus = true;
	        delete this.acompanhamento.tipo_ocorrencia;
	        delete this.acompanhamento.ocorrencia_sapiens;
	      }
	
	      if (selectedOption.codigo === 'INFORMACAO') {
	        this.place = 'Não utilizar para registrar envio de e-mail ou contatos com o parceiro.\n' + 'Registro de matérias publicadas sobre o projeto, mídias, imagens, denúncias recebidas, etc., informar o nome do veículo e meio de comunicação.';
	      }
	      if (selectedOption.codigo === 'CONTATO') {
	        this.place = 'Não utilizar para registrar envio de e-mail ou demandas.\n' + 'Informe o nome da pessoa e o resumo das tratativas efetuadas (dúvidas SGP, dúvidas quanto à execução do projeto, sistema, preenchimento de relatórios, informações sobre a execução do projeto etc.)';
	      }
	      if (selectedOption.codigo === 'DEMANDA_FBB') {
	        this.place = 'Informe objetivamente qual foi a solicitação e o nome da pessoa com quem o contato foi efetuado.\n' + 'Exemplos: envio de notificação extrajudicial, informações adicionais aos relatórios de execução, envio de documentos para atualização cadastral, etc.';
	      }
	      if (selectedOption.codigo === 'DEMANDA_PARCEIRO') {
	        this.place = 'Registre objetivamente as demandas recebidas.\n' + 'Exemplos: Solicitação de remanejamento, pedido de prorrogação de prazo, alteração de metas, substituição de contrapartida, envio de artes para aprovação, etc.';
	      }
	    },
	    etiquetaTipos: function etiquetaTipos(option) {
	      return '' + option.descricao;
	    },
	    etiquetaTipoOcor: function etiquetaTipoOcor(option) {
	      return '' + option.descricao;
	    },
	    etiquetaOcorrencia: function etiquetaOcorrencia(option) {
	      return '' + (option.codigo + ' - ' + option.descricao);
	    },
	    verificaData: function verificaData() {
	      var dtPrazoAux = (0, _moment2.default)(this.acompanhamento.prazo).format('YYYY/MM/DD');
	      var dtRegAux = (0, _moment2.default)(this.acompanhamento.dt_registro).format('YYYY/MM/DD');
	      var dtPrazo = dtPrazoAux.replace('/', '').replace('/', '');
	      var dtReg = dtRegAux.replace('/', '').replace('/', '');
	      if (dtPrazo < dtReg) {
	        this.$snotify.error('O prazo não pode ser menor que a data de registro. Favor verificar!');
	        this.acompanhamento.prazo = '';
	        return;
	      }
	    },
	    onCancel: function onCancel() {
	      this.acompanhamento = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	      this.mostraOcor = false;
	    },
	    onNew: function onNew() {
	      var _this5 = this;
	
	      this.acompanhamento = {};
	      this.acompanhamento.documentos = [];
	      this.acompanhamento.responsavel = {};
	      this.acompanhamento.responsavel.ds_nome_usuario = this.usuarioLogado.userName;
	      this.editandoIndex = null;
	      this.acompanhamento.detalhamento = '';
	      this.detalhamentoAnt = '';
	      this.acompanhamento.dt_registro = (0, _moment2.default)(this.acompanhamento.prazo).format('YYYY/MM/DD');
	      this.$emit('atualizarTimeline', this.i++);
	      this.$refs.tabelaAcompanhamento.refresh();
	      this.$nextTick(function () {
	        _this5.$parent.$refs['acompanhamento'].scrollIntoView();
	      });
	    },
	    onAdd: function onAdd() {
	      var _this6 = this;
	
	      var currentDate = new Date();
	      this.objBackend = [];
	      var aux = this.usuarioLogado.userName;
	      this.acompanhamento.responsavel.ds_nome_usuario = this.usuarioLogado.userName;
	      this.acompanhamento.fk_usuario_responsavel = this.usuarioLogado.id;
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this6.acompanhamento.detalhamento = _this6.acompanhamento.detalhamento + '- <b>' + _this6.detalhamentoAnt + '</b> <br><i>(' + aux + ', ' + (0, _moment2.default)(currentDate).format('DD/MM/YYYY') + ')' + '</i><br>';
	
	          if (_this6.editandoIndex !== null) {
	            for (var i in _this6.acompanhamento) {
	              _this6.tabelaAcompanhamento[i] = _this6.acompanhamento[i];
	            }
	          } else {
	            _this6.table.items.push(_this6.acompanhamento);
	          }
	          var array = [];
	          array = _.sortBy(_this6.temp, 'dt_registro');
	          _this6.temp = _.cloneDeep(array);
	          _this6.forceRerender();
	          _this6.$forceUpdate();
	          _this6.objBackend.push(_this6.acProp);
	          _this6.libera = false;
	          _this6.contador = _this6.contador + 1;
	          _this6.onCancel();
	        } else {
	          _this6.$snotify.error('O formulário possui erros. Favor verificar!');
	        }
	      });
	    },
	    edita: function edita(row) {
	      this.detalhamentoAnt = '';
	      this.editandoIndex = row.index;
	      this.acompanhamento = (0, _assign2.default)({}, row.item);
	      this.detalhamentoAnt = '';
	      this.tabelaAcompanhamento = row.item;
	      if (row.item.tipo.codigo === 'OCORRENCIA_IMPEDITIVA') {
	        this.mostraOcor = true;
	        this.tp = row.item.tipo.codigo;
	      }
	      if (row.item.tipo.codigo === 'INFORMACAO') {
	        this.mostraOcor = true;
	        this.tp = row.item.tipo.codigo;
	      }
	      if (row.item.tipo.codigo === 'INFORMACAO' || row.item.tipo.codigo === 'CONTATO' || row.item.tipo.codigo === 'OCORRENCIA_IMPEDITIVA') {
	        this.mostraStatus = false;
	      } else {
	        this.mostraStatus = true;
	      }
	      this.showgrid = false;
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	      this.acProp.splice(row.index, 1);
	      this.objBackend.push(this.acProp);
	    },
	    irMetas: function irMetas() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        _this7.$parent.$refs['metas'].scrollIntoView();
	        if (_.has(_this7.$parent, 'mostrar')) _this7.$parent.mostrar.metas = true;
	      });
	    },
	    irAtividades: function irAtividades() {
	      var _this8 = this;
	
	      this.$nextTick(function () {
	        _this8.$parent.$refs['atividades'].scrollIntoView();
	        if (_.has(_this8.$parent, 'mostrar')) _this8.$parent.mostrar.atividades = true;
	      });
	    },
	    buscaAcompanhamentoProp: function buscaAcompanhamentoProp() {
	      var _this9 = this;
	
	      axiosLaravel.get('/acompanhamento/' + this.numero).then(function (response) {
	        _this9.acProp = response.data;
	        _this9.table.items = _this9.acProp;
	        _this9.table.totalRows = _this9.table.items.length;
	        _this9.loading = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this9.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this10 = this;
	
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this10.$root.trataErro(error);
	      });
	    },
	    salvar: function salvar() {
	      var _this11 = this;
	
	      this.libera = false;
	      var arr = this.objBackend;
	      arr = _.map(arr, function (o) {
	        return _.extend({ fk_proposta: _this11.projeto.proposta.id }, o);
	      });
	      this.$aguarde('Salvando acompanhamento do projeto. Por favor, aguarde...');
	      axiosLaravel.post('/acompanhamento/', arr).then(function (response) {
	        _this11.salvouOK = true;
	        _this11.buscaAcompanhamentoProp();
	        _this11.$forceUpdate();
	        _this11.$snotify.clear();
	        _this11.$snotify.success('Acompanhamento do projeto gravado com sucesso!');
	        _this11.libera = true;
	        _this11.contador = 0;
	        _this11.$emit('atualizarTimeline', new Date());
	      }).catch(function (error) {
	        _this11.$snotify.clear();
	        console.log('error', error);
	        _this11.$root.trataErro(error);
	      });
	    },
	    refresh: function refresh() {
	      location.reload(true);
	    }
	  }
	};

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default
	  },
	  name: 'alteracoesProjetos',
	  data: function data() {
	    return {
	      disabledDates: {
	        customPredictor: function customPredictor(date) {
	          if (date.getDate() < new Date().getDate()) {
	            return true;
	          }
	        }
	      },
	      highlighted: {
	        customPredictor: function customPredictor(date) {
	          var d1 = (0, _moment2.default)(date).format('YYYYMMDD');
	          var d2 = (0, _moment2.default)(new Date()).format('YYYYMMDD');
	          if (d1 === d2) {
	            return true;
	          }
	        }
	      },
	      loading: true,
	      numero: null,
	      projeto: [],
	      contador: 0,
	      objBackend: [],
	      atProp: [],
	      place: '',
	      mostraOcor: false,
	      editandoIndex: null,
	      alteracao: {
	        documentos: []
	      },
	      detalhamentoAnt: '',
	      salvouOK: false,
	      dadosTime: [],
	      documento: [],
	      showgrid: true,
	      table: {
	        items: [],
	        bloqueioCampos: false,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        sortBy: 'dt_registro',
	        sortDesc: true,
	        alteracaoTable: [],
	        fields: [{ key: 'id', label: 'id', sortable: true, thStyle: 'text-align: center; width: 50px', class: 'text-center' }, { key: 'dt_registro', label: 'Data', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'tipo', label: 'Tipo', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'detalhamento', label: 'Detalhe', sortable: true, thStyle: 'text-align: left; width: 50%', class: 'text-left' }, { key: 'motivo', label: 'Motivo', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'responsavel.ds_nome_usuario', label: 'Responsavel', sortable: true, thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'id_processo', label: 'Processo', thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'documentos', label: 'Anexos', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 5%', class: 'text-center' }]
	      },
	      prorrogacaoEdit: false
	    };
	  },
	
	  props: ['ParmProjetos', 'ParmAlteracao', 'filtro'],
	  watch: {
	    ParmProjetos: function ParmProjetos() {
	      this.projeto = this.ParmProjetos;
	    },
	    filtro: function filtro() {
	      var _this = this;
	
	      this.table.filter = this.filtro;
	      this.$nextTick(function () {
	        _this.$parent.$refs['alteracoes'].scrollIntoView();
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    editandoItem: function editandoItem() {
	      if (this.editandoIndex != null) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }),
	  mounted: function mounted() {},
	  created: function created() {
	    this.numero = this.$route.params.numero;
	    if (this.numero) {
	      this.projeto = this.ParmProjetos;
	      this.buscaAlteracaoProp();
	      this.buscaTipos();
	      this.alteracao.responsavel.ds_nome_usuario = this.usuarioLogado.userName;
	    }
	  },
	
	  methods: {
	    buscaTipos: function buscaTipos() {
	      var _this2 = this;
	
	      axiosLaravel.get('tipo-registros/').then(function (response) {
	        _this2.tipos = _.filter(response.data, function (tipo) {
	          return tipo.grupo === 'ALTERACAO' && (tipo.codigo !== 'PRORROGACAO_DE_PRAZO' || _.includes(['ALTERACAO_DA_FORMA_DE_LIBERACAO_DOS_RECURSOS', 'OUTRAS_ALTERACOES'], tipo.codigo));
	        });
	        _this2.motivos = _.filter(response.data, ['grupo', 'ALTERACAO_MOTIVO']);
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    temId: function temId(detalhamento) {
	      return detalhamento.substr(0, 1) === '#' ? _.chain(detalhamento).split('#').nth(1).trim().value() : false;
	    },
	    abrirLink: function abrirLink(caminho, novaJanela) {
	      window.open(location.protocol + '//' + location.host + caminho, novaJanela ? '_blank' : '_self');
	    },
	    etiquetaTipos: function etiquetaTipos(option) {
	      return '' + option.descricao;
	    },
	    etiquetaMotivos: function etiquetaMotivos(option) {
	      return '' + option.descricao;
	    },
	    onSelect: function onSelect(selectedOption, tipos) {
	      this.place = 'Descreva de forma assertiva a justificativa para a alteração realizada.\n' + 'Exemplos: \n' + '1. O excesso de chuvas prejudicou a realização das oficinas de campo. Desse modo o prazo de execução será prorrogado em 4 meses para conclusão das atividades.\n' + '2. Tendo em vista a economicidade observada durante a execução do projeto, que resultou em sobra de recursos, elevamos de 80 para 90 a quantidade de barraginhas a serem implementadas.';
	    },
	    linha: function linha(data) {
	      var vm = this;
	      vm.eventData = data;
	      vm.$events.emit('linhaSelecionada', vm.eventData);
	    },
	    buscaAlteracaoProp: function buscaAlteracaoProp() {
	      var _this3 = this;
	
	      this.loading = true;
	      axiosLaravel.get('/alteracao/' + this.numero).then(function (response) {
	        _this3.atProp = response.data;
	        _this3.table.items = _this3.atProp;
	        _this3.table.totalRows = _this3.table.items.length;
	        _this3.loading = false;
	        _this3.$refs.tabelaAlteracao.refresh();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    onCancel: function onCancel() {
	      var _this4 = this;
	
	      this.alteracao = {};
	      this.showgrid = true;
	      this.editandoIndex = null;
	      this.mostraOcor = false;
	      this.$nextTick(function () {
	        _this4.$refs['form'].scrollIntoView();
	      });
	    },
	    onNew: function onNew() {
	      var _this5 = this;
	
	      this.alteracao = {};
	      this.alteracao.documentos = [];
	      this.alteracao.documentos = [];
	      this.alteracao.responsavel = {};
	      this.alteracao.responsavel.ds_nome_usuario = this.usuarioLogado.userName;
	      this.editandoIndex = null;
	      this.alteracao.detalhamento = '';
	      this.detalhamentoAnt = '';
	      this.$emit('atualizarTimeline', new Date());
	      this.$refs.tabelaAlteracao.refresh();
	      this.$nextTick(function () {
	        _this5.$parent.$refs['alteracoes'].scrollIntoView();
	      });
	    },
	    onAdd: function onAdd() {
	      var _this6 = this;
	
	      var currentDate = new Date();
	      var aux = this.usuarioLogado.userName;
	      this.objBackend = [];
	      this.alteracao.responsavel.ds_nome_usuario = this.usuarioLogado.userName;
	      this.alteracao.fk_usuario_responsavel = this.usuarioLogado.id;
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this6.alteracao.detalhamento = _this6.alteracao.detalhamento + '- <b>' + _this6.detalhamentoAnt + '</b> <br><i>(' + aux + ', ' + (0, _moment2.default)(currentDate).format('DD/MM/YYYY') + ')' + '</i><br>';
	
	          if (_this6.editandoIndex !== null) {
	            for (var i in _this6.alteracao) {
	              _this6.tabelaAlteracao[i] = _this6.alteracao[i];
	            }
	          } else {
	            _this6.table.items.push(_this6.alteracao);
	          }
	          _this6.objBackend.push(_this6.atProp);
	          _this6.objBackend.fk_proposta = _this6.projeto.proposta.id;
	          _this6.contador = _this6.contador + 1;
	          _this6.onCancel();
	        } else {
	          _this6.$snotify.error('O formulário possui erros. Favor verificar!');
	        }
	      });
	    },
	    edita: function edita(row) {
	      var _this7 = this;
	
	      this.detalhamentoAnt = '';
	      console.log('ROW', row.item.tipo.codigo);
	
	      if (row.item.tipo.codigo === 'PRORROGACAO_DE_PRAZO') {
	        this.prorrogacaoEdit = true;
	      } else {
	        this.prorrogacaoEdit = false;
	      }
	      this.$nextTick(function () {
	        _this7.$refs['form'].scrollIntoView();
	      });
	      this.editandoIndex = row.index;
	      this.alteracao = (0, _assign2.default)({}, row.item);
	      this.detalhamentoAnt = '';
	      this.tabelaAlteracao = row.item;
	      this.showgrid = false;
	    },
	    exclui: function exclui(row) {
	      this.table.items.splice(row.index, 1);
	
	      this.objBackend.push(this.table.items);
	    },
	    irMetas: function irMetas() {
	      var _this8 = this;
	
	      this.$nextTick(function () {
	        _this8.$parent.$refs['metas'].scrollIntoView();
	        if (_.has(_this8.$parent, 'mostrar')) _this8.$parent.mostrar.metas = true;
	      });
	    },
	    irAtividades: function irAtividades() {
	      var _this9 = this;
	
	      this.$nextTick(function () {
	        _this9.$parent.$refs['atividades'].scrollIntoView();
	        if (_.has(_this9.$parent, 'mostrar')) _this9.$parent.mostrar.atividades = true;
	      });
	    },
	    onDownload: function onDownload(documento) {
	      var _this10 = this;
	
	      axiosLaravel.get('documentos/download/' + documento.id, { responseType: 'arraybuffer' }).then(function (response) {
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = new Blob([response.data], { type: documento.ds_content_type });
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = documento.ds_nome_arquivo;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var bytes = new Uint8Array(resultByte);
	          var _blob = new Blob([bytes], { type: documento.ds_content_type });
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, documento.ds_nome_arquivo);
	          _link.download = documento.ds_nome_arquivo;
	          _link.click();
	        }
	      }).catch(function (error) {
	        _this10.$root.trataErro(error);
	      });
	    },
	    salvar: function salvar() {
	      var _this11 = this;
	
	      var arr = this.objBackend;
	      arr = _.map(arr, function (o) {
	        return _.extend({ fk_proposta: _this11.projeto.proposta.id }, o);
	      });
	      this.$aguarde('Salvando alteração do projeto. Por favor, aguarde...');
	      axiosLaravel.post('/alteracao/', arr).then(function (response) {
	        _this11.salvouOK = true;
	        _this11.buscaAlteracaoProp();
	        _this11.$forceUpdate();
	        _this11.$snotify.clear();
	        _this11.$snotify.success('Alteração do projeto gravado com sucesso!');
	        _this11.contador = 0;
	        _this11.$emit('atualizarTimeline', new Date());
	      }).catch(function (error) {
	        _this11.$snotify.clear();
	        console.log('error', error);
	        _this11.$root.trataErro(error);
	      });
	    },
	    abrirProcesso: function abrirProcesso(idProcesso) {
	      this.$router.push({ name: 'solicitacao-alteracoes-projeto', params: { id: idProcesso, visualizacao: true } });
	    }
	  }
	};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(76);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(124);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(884);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _telefone = __webpack_require__(142);
	
	var _telefone2 = _interopRequireDefault(_telefone);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _parcelaAdiantamento = __webpack_require__(254);
	
	var _parcelaAdiantamento2 = _interopRequireDefault(_parcelaAdiantamento);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _cronogramaCotacao = __webpack_require__(1697);
	
	var _cronogramaCotacao2 = _interopRequireDefault(_cronogramaCotacao);
	
	var _vuex = __webpack_require__(3);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _preAnaliseForm = __webpack_require__(175);
	
	var _preAnaliseForm2 = _interopRequireDefault(_preAnaliseForm);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	var _deferimento = __webpack_require__(173);
	
	var _deferimento2 = _interopRequireDefault(_deferimento);
	
	var _formalizacao = __webpack_require__(174);
	
	var _formalizacao2 = _interopRequireDefault(_formalizacao);
	
	var _aprovacao = __webpack_require__(1818);
	
	var _aprovacao2 = _interopRequireDefault(_aprovacao);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _Atividades = __webpack_require__(256);
	
	var _Atividades2 = _interopRequireDefault(_Atividades);
	
	var _publicoAlvoDescricaoProposta = __webpack_require__(1733);
	
	var _publicoAlvoDescricaoProposta2 = _interopRequireDefault(_publicoAlvoDescricaoProposta);
	
	var _tecnologiaSocial = __webpack_require__(525);
	
	var _tecnologiaSocial2 = _interopRequireDefault(_tecnologiaSocial);
	
	var _municipiosNovos = __webpack_require__(1719);
	
	var _municipiosNovos2 = _interopRequireDefault(_municipiosNovos);
	
	var _testemunhas = __webpack_require__(1743);
	
	var _testemunhas2 = _interopRequireDefault(_testemunhas);
	
	var _agenciaIndicativaContaProjeto = __webpack_require__(1688);
	
	var _agenciaIndicativaContaProjeto2 = _interopRequireDefault(_agenciaIndicativaContaProjeto);
	
	var _visualizacaoDocumentosCotacao = __webpack_require__(1702);
	
	var _visualizacaoDocumentosCotacao2 = _interopRequireDefault(_visualizacaoDocumentosCotacao);
	
	var _GerenciadorEdicaoProposta = __webpack_require__(1770);
	
	var _GerenciadorEdicaoProposta2 = _interopRequireDefault(_GerenciadorEdicaoProposta);
	
	var _NavegadorProposta = __webpack_require__(1776);
	
	var _NavegadorProposta2 = _interopRequireDefault(_NavegadorProposta);
	
	var _cadastroLicencas = __webpack_require__(252);
	
	var _cadastroLicencas2 = _interopRequireDefault(_cadastroLicencas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    VisualizaGantt: _Atividades2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    PreAnaliseForm: _preAnaliseForm2.default,
	    ParcelaAdiantamento: _parcelaAdiantamento2.default,
	    Analise: _analise2.default,
	    Deferimento: _deferimento2.default,
	    Formalizacao: _formalizacao2.default,
	    Aprovacao: _aprovacao2.default,
	    HistoricoProposta: _historicoProposta2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    cronogramaCotacao: _cronogramaCotacao2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    Telefone: _telefone2.default,
	    PublicoAlvo: _publicoAlvo2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    publicoAlvoDescricaoProposta: _publicoAlvoDescricaoProposta2.default,
	    tecnologiaSocial: _tecnologiaSocial2.default,
	    municipiosNovos: _municipiosNovos2.default,
	    testemunhas: _testemunhas2.default,
	    agenciaIndicativaContaProjeto: _agenciaIndicativaContaProjeto2.default,
	    visualizacaoDocumentosCotacao: _visualizacaoDocumentosCotacao2.default,
	    GerenciadorEdicaoProposta: _GerenciadorEdicaoProposta2.default,
	    NavegadorProposta: _NavegadorProposta2.default,
	    cadastroLicencas: _cadastroLicencas2.default
	  },
	  name: 'edita-proposta',
	  data: function data() {
	    return {
	      justificativaCancelamento: '',
	      titulo: 'SGP',
	      progressBar: {
	        stepAtual: null,
	        stepTotal: null,
	        tarefaAtual: null
	      },
	      poderes: [],
	      loading: {
	        show: false,
	        poderes: false
	      },
	      MunTotalParticipantes: 0,
	      enderecoEntidadePrincipal: [],
	      entidadeEhFundacao: false,
	      textoAlerta: 'É necessário preencher o projeto duplicador!',
	      documentosProposta: [],
	      tel: '',
	      finalizou: false,
	      nulo: null,
	      array: [],
	      atvSemMetas: [],
	      metaNaoAchada: [],
	      camposOK: true,
	      verificaFilhos: false,
	      esconder: true,
	      esconderAnalise: false,
	      esconderEntidade: false,
	      analise: {},
	      deferimento: {},
	      formalizacao: {},
	      aprovacao: {},
	      fluxo: {},
	      filtro: [],
	      elementos: {
	        visivel: ''
	      },
	      analiseUsuario: '',
	      analiseData: '',
	      mensagem: '',
	      historico_atualizado: [],
	      bloqueiaBotoes: false,
	      restricaParaConcluir: [],
	      projetoSuperior: '',
	      listaEditais: [],
	      numeroEdital: '',
	      editalSelecionado: '',
	      hoje: new Date(),
	      ehEdital: false,
	      editalAtivoVigente: false,
	      proposta: {
	        entidade: {},
	        documentos: {
	          proposta: [],
	          analise: [],
	          deferimento: [],
	          formalizacao: []
	        },
	        ds_projeto_duplicacao_descricao: ''
	      },
	      componentKey: 0,
	      estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
	      titulosAba: { 'SOLICITACAO': 'Cadastro', 'CADASTRO': 'Cadastro', 'REVISAO': 'Revisão pela entidade', 'ANALISE': 'Análise', 'DEFERIMENTO': 'Deferimento', 'FORMALIZACAO': 'Formalização', 'APROVACAO_PROJETO': 'Aprovação do projeto' },
	      arvoreProjetos: [],
	      possuiItensAdiantaveis: false,
	      restricoesAtivasEntidade: null,
	      restricoesAtivasProjetosDaEntidade: null,
	
	      situacaoRestricoes: 'carregando',
	      previewCotacao: false,
	
	      ehExcecao: false,
	      abrirVisualizacaoCotacao: false,
	      travarEdicao: false,
	      verificaSessao: true,
	      travaSessao: false,
	      carregaProposta: false,
	      idsNavegador: [{
	        id: 'inicio',
	        label: 'Inicio'
	      }, {
	        id: 'dadosEntidade',
	        label: 'Dados da Entidade'
	      }, {
	        id: 'informacoesProjeto',
	        label: 'Informações do Projeto'
	      }, {
	        id: 'publicoAlvo',
	        label: 'Público-Alvo'
	      }, {
	        id: 'tecnologiaSocial',
	        label: 'Tecnologia Social'
	      }, {
	        id: 'equipeProjeto',
	        label: 'Equipe do Projeto'
	      }, {
	        id: 'entidadeExecutora',
	        label: 'Entidade Executora'
	      }, {
	        id: 'projetoDuplicacao',
	        label: 'Projeto Duplicação'
	      }, {
	        id: 'edital',
	        label: 'Edital'
	      }, {
	        id: 'objetivoEspecifico',
	        label: 'Objetivo Específico'
	      }, {
	        id: 'metas',
	        label: 'Metas'
	      }, {
	        id: 'atividades',
	        label: 'Atividades'
	      }, {
	        id: 'cronograma',
	        label: 'Cronograma'
	      }, {
	        id: 'parcelaAdiantamento',
	        label: 'Parcela de Adiantamento'
	      }, {
	        id: 'abrangenciaNacional',
	        label: 'Abrangência Nacional'
	      }, {
	        id: 'municipiosExecucao',
	        label: 'Municípios - Locais de execução'
	      }, {
	        id: 'cursos',
	        label: 'Cursos'
	      }, {
	        id: 'testemunhas',
	        label: 'Testemunhas'
	      }, {
	        id: 'indicacaoAgencia',
	        label: 'Indicação de Agência'
	      }, {
	        id: 'anexos',
	        label: 'Documentos da Proposta'
	      }, {
	        id: 'historicoAprovacoes',
	        label: 'Histórico de Aprovações'
	      }, {
	        id: 'analise',
	        label: 'Análise'
	      }, {
	        id: 'fep',
	        label: 'FEP'
	      }, {
	        id: 'odsMarcacao',
	        label: 'Cadastro de ODS'
	      }, {
	        id: 'relatorioAnalise',
	        label: 'Relatório da Análise'
	      }, {
	        id: 'ratingEntidade',
	        label: 'Rating da Entidade'
	      }, {
	        id: 'questionarioRiscos',
	        label: 'Questionário de Riscos'
	      }, {
	        id: 'categorizadores',
	        label: 'Categorizadores'
	      }, {
	        id: 'periodicidadeRelatorio',
	        label: 'Perodicidade Relatório Execução'
	      }, {
	        id: 'parecerJuridico',
	        label: 'Parecer Jurídico'
	      }, {
	        id: 'documentosAnalise',
	        label: 'Documentos da Análise'
	      }, {
	        id: 'formalizacao',
	        label: 'Formalização'
	      }, {
	        id: 'deferimento',
	        label: 'Deferimento'
	      }, {
	        id: 'aprovacao',
	        label: 'Aprovação'
	      }],
	      propostaSimplificada: false
	    };
	  },
	
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  watch: {
	    documentosProposta: function documentosProposta() {
	      if (this.documentosProposta) {
	        this.proposta.documentos.proposta = this.documentosProposta;
	      }
	    },
	
	    'proposta.nr_periodos': function propostaNr_periodos(newVal, oldVal) {
	      console.log('nr_periodos mudou:', newVal);
	      console.log('ehpropostasimplificada?', this.propostaSimplificada);
	
	      if (this.propostaSimplificada) {
	        this.proposta.atividades.forEach(function (atividade) {
	          if (atividade.descricao === 'Resumo memória de cálculo') {
	            atividade.nr_periodo_final = newVal;
	          }
	        });
	      }
	    },
	    'proposta.entidade.id': function propostaEntidadeId() {
	      if (this.proposta.entidade.id) {
	        this.verificaSeExisteRestricoesAtivas();
	      }
	    }
	
	  },
	  computed: (0, _extends3.default)({
	    restricoesEntidade: function restricoesEntidade() {
	      return {
	        situacao: this.situacaoRestricoes,
	        entidade: this.restricoesAtivasEntidade,
	        projetos: this.restricoesAtivasProjetosDaEntidade
	      };
	    },
	    possuiAdiandamento: function possuiAdiandamento() {
	      var comAdiantamento = _.find(this.proposta.atividades, function (atv) {
	        return _.find(_.get(atv, 'itens_orcamentos', []), function (ite) {
	          return '' + ite.adiantavel === '1';
	        });
	      });
	      return !!comAdiantamento;
	    },
	    totalParticipantes: function totalParticipantes() {
	      var totalParticipantes = 0;
	      this.proposta.publicos_alvo.forEach(function (publico) {
	        totalParticipantes = parseInt(totalParticipantes) + parseInt(publico.nr_participantes_diretos);
	      });
	      return parseInt(totalParticipantes);
	    },
	    totalParticipantesMunicipios: function totalParticipantesMunicipios() {
	      var total = 0;
	      if (this.proposta.municipalizacao.length > 0) {
	        this.proposta.municipalizacao.forEach(function (item) {
	          total += parseInt(item.nr_total_participantes);
	        });
	      }
	      return parseInt(total);
	    },
	
	    datas: function datas() {
	      if (this.proposta.dt_assinatura_convenio) {
	        this.proposta.dt_data_vigencia = (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(parseInt(this.proposta.periodo_vigencia), 'M').format('DD/MM/YYYY');
	      } else {
	        if (this.proposta.dt_data_inicial) {
	          this.proposta.dt_data_vigencia = (0, _moment2.default)(this.proposta.dt_data_inicial).add(parseInt(this.proposta.periodo_vigencia), 'M').format('DD/MM/YYYY');
	        }
	      }
	    },
	    dataFinal: function dataFinal() {
	      if (this.proposta.dt_data_inicial) {
	        return (0, _moment2.default)(this.proposta.dt_data_inicial).add(this.proposta.nr_periodos, 'M').format('DD/MM/YYYY');
	      }
	    },
	
	    dataVigencia: function dataVigencia() {
	      if (this.proposta.dt_assinatura_convenio) {
	        return (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(this.proposta.periodo_vigencia, 'M').format('DD/MM/YYYY');
	      } else {
	        if (this.proposta.dt_data_inicial) {
	          return (0, _moment2.default)(this.proposta.dt_data_inicial).add(this.proposta.periodo_vigencia, 'M').format('DD/MM/YYYY');
	        }
	      }
	    },
	    telefone: function telefone() {
	      if (this.proposta.entidade.contato) {
	        if (this.proposta.entidade.contato.ds_telefone.substring(0, 1) !== '(') {
	          var size = this.proposta.entidade.contato.ds_telefone.length;
	          if (size < 11) {
	            this.tel = '(' + this.proposta.entidade.contato.ds_telefone.substring(0, 2) + ') ' + this.proposta.entidade.contato.ds_telefone.substring(2, 6) + ' - ' + this.proposta.entidade.contato.ds_telefone.substring(6, 10);
	          } else {
	            this.tel = '(' + this.proposta.entidade.contato.ds_telefone.substring(0, 2) + ') ' + this.proposta.entidade.contato.ds_telefone.substring(2, 7) + ' - ' + this.proposta.entidade.contato.ds_telefone.substring(7, 11);
	          }
	        } else {
	          this.tel = this.proposta.entidade.contato.ds_telefone;
	        }
	        return this.tel;
	      }
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      this.$forceUpdate();
	    }
	  }),
	  destroyed: function destroyed() {
	    Echo.leave('Edita.Proposta.' + this.proposta.id);
	  },
	  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
	    var widget = this.$refs.gerenciadorEdicao;
	    if (widget && typeof widget.encerrarSessao === 'function' && widget.podeEditar) {
	      widget.encerrarSessao();
	    }
	    next();
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var tabId;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (_this.verificaSessao) {
	                _context.next = 14;
	                break;
	              }
	
	              _this.loading.show = true;
	
	              if (!sessionStorage.getItem('tabId')) {
	                tabId = Date.now().toString() + Math.random().toString(36).substr(2);
	
	                sessionStorage.setItem('tabId', tabId);
	              }
	              if (_this.$route.params.processo === 'ANALISE' || _this.$route.params.processo === 'DEFERIMENTO' || _this.$route.params.processo === 'REVISAO' || _this.$route.params.processo === 'FORMALIZACAO' || _this.$route.params.processo === 'APROVACAO_PROJETO') {
	                _this.esconder = false;
	              }
	              _this.titulo = 'SGP' + (_.has(_this.$route.params, 'processo') && _.has(_this.titulosAba, _this.$route.params.processo) ? ' - ' + _.get(_this.titulosAba, _this.$route.params.processo) : '');
	              if (_this.$router.currentRoute.name === 'proposta-visualiza') {
	                _this.esconder = true;
	              }
	              _this.$aguarde('Buscando dados da proposta. Por favor, aguarde...');
	              axiosLaravel.post('processos/historico/', { 'id_proposta': _this.$route.params.id, 'tipo': 'USUARIO' }).then(function (response) {
	                var analise = _.last(_.sortBy(_.filter(response.data, function (t) {
	                  return t.nome === 'ANALISE';
	                }), ['id']));
	                if (analise.termino) {
	                  _this.analiseData = analise.termino;
	                }
	                _this.analiseUsuario = analise.usuario ? analise.usuario.ds_nome_usuario : null;
	                _this.proposta.periodo_vigencia = !_.has(_this.proposta, 'periodo_vigencia') || _.isNull(_this.proposta.periodo_vigencia) || _.isUndefined(_this.proposta.periodo_vigencia) ? parseInt(_this.proposta.nr_periodos) + 12 : _this.proposta.periodo_vigencia;
	                _this.$forceUpdate();
	              });
	              _context.next = 10;
	              return _this.buscaProposta();
	
	            case 10:
	              _this.entidadeEhFundacao = _this.proposta.entidade.ds_cnpj === '01641000000133';
	
	              _this.analise.proximaEtapa = null;
	              _this.analise.resultadoAprovacao = null;
	              _this.assinaCanalProposta();
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  mounted: function mounted() {
	    this.buscaArvoreProjeto();
	    if (!this.verificaSessao) {
	      this.buscaArvoreProjeto();
	
	      var bc = new BroadcastChannel('proposta-' + this.$route.params.id);
	      var vm = this;
	      bc.onmessage = function (e) {
	        var mensagem = e.data;
	        if ('' + mensagem.id === '' + vm.$route.params.id) {
	          if (mensagem.acao === 'salvarProposta') {
	            vm.salvar();
	          } else if (mensagem.acao === 'set') {
	            _.set(vm, '' + mensagem.objeto, mensagem.valor);
	            vm.$forceUpdate();
	          }
	        } else {}
	      };
	    }
	  },
	
	  methods: {
	    sessaoVerificada: function sessaoVerificada(edicaoAtiva) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.carregaProposta = true;
	                _this2.travaSessao = !edicaoAtiva;
	                console.log('travasessao', _this2.travaSessao);
	                _context2.next = 5;
	                return _this2.initProposta();
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    initProposta: function initProposta() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var tabId, bc, vm;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this3.loading.show = true;
	
	                if (!sessionStorage.getItem('tabId')) {
	                  tabId = Date.now().toString() + Math.random().toString(36).substr(2);
	
	                  sessionStorage.setItem('tabId', tabId);
	                }
	                if (_this3.$route.params.processo === 'ANALISE' || _this3.$route.params.processo === 'DEFERIMENTO' || _this3.$route.params.processo === 'REVISAO' || _this3.$route.params.processo === 'FORMALIZACAO' || _this3.$route.params.processo === 'APROVACAO_PROJETO') {
	                  _this3.esconder = false;
	                }
	                _this3.titulo = 'SGP' + (_.has(_this3.$route.params, 'processo') && _.has(_this3.titulosAba, _this3.$route.params.processo) ? ' - ' + _.get(_this3.titulosAba, _this3.$route.params.processo) : '');
	                if (_this3.$router.currentRoute.name === 'proposta-visualiza') {
	                  _this3.esconder = true;
	                }
	                _this3.$aguarde('Buscando dados da proposta. Por favor, aguarde...');
	                axiosLaravel.post('processos/historico/', { 'id_proposta': _this3.$route.params.id, 'tipo': 'USUARIO' }).then(function (response) {
	                  var analise = _.last(_.sortBy(_.filter(response.data, function (t) {
	                    return t.nome === 'ANALISE';
	                  }), ['id']));
	                  if (analise.termino) {
	                    _this3.analiseData = analise.termino;
	                  }
	                  _this3.analiseUsuario = analise.usuario ? analise.usuario.ds_nome_usuario : null;
	                  _this3.proposta.periodo_vigencia = !_.has(_this3.proposta, 'periodo_vigencia') || _.isNull(_this3.proposta.periodo_vigencia) || _.isUndefined(_this3.proposta.periodo_vigencia) ? parseInt(_this3.proposta.nr_periodos) + 12 : _this3.proposta.periodo_vigencia;
	                  _this3.$forceUpdate();
	                });
	                _context3.next = 9;
	                return _this3.verificaPropostaSimplificada();
	
	              case 9:
	                _context3.next = 11;
	                return _this3.buscaProposta();
	
	              case 11:
	                _this3.entidadeEhFundacao = _this3.proposta.entidade.ds_cnpj === '01641000000133';
	
	                _this3.analise.proximaEtapa = null;
	                _this3.analise.resultadoAprovacao = null;
	                _this3.assinaCanalProposta();
	                bc = new BroadcastChannel('proposta-' + _this3.$route.params.id);
	                vm = _this3;
	
	                bc.onmessage = function (e) {
	                  var mensagem = e.data;
	                  if ('' + mensagem.id === '' + vm.$route.params.id) {
	                    if (mensagem.acao === 'salvarProposta') {
	                      vm.salvar();
	                    } else if (mensagem.acao === 'set') {
	                      _.set(vm, '' + mensagem.objeto, mensagem.valor);
	                      vm.$forceUpdate();
	                    }
	                  } else {}
	                };
	
	              case 18:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    verificaUsuarioDirigente: function verificaUsuarioDirigente() {
	      var _this4 = this;
	
	      if (this.usuarioLogado.userType !== 'FUNDACAO' && !this.ehVisualizacao) {
	        this.loading.poderes = true;
	        axiosLaravel.get('projeto/usuario/dirigente').then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            if (!_.isNull(response.data.retorno)) {
	              _.remove(_this4.poderes, 'PERMITE_CONCLUIR');
	              _this4.adicionaRestricao({ 'tag': 'semPoderesParaConcluir', 'ativo': true, 'tipo': 'restricao', 'acao': null, 'mensagem': response.data.retorno + '. A conclusão e envio desta solicitação deverá ser realizada pelo representante legal ou designado.' });
	            } else {
	              _this4.poderes.push('PERMITE_CONCLUIR');
	            }
	            _this4.poderes = _.uniq(_this4.poderes);
	          } else {
	            _this4.$snotify.error(response.data.mensagem[0]);
	            _this4.ehVisualizacao = true;
	          }
	          _this4.loading.poderes = false;
	        }).catch(function (error) {
	          _this4.loading.poderes = false;
	          console.log('error', error);
	          _this4.$root.trataErro(error);
	        });
	      } else {
	        this.poderes.push('PERMITE_CONCLUIR');
	      }
	    },
	    buscaContaAdiantamento: function buscaContaAdiantamento() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return axiosLaravel.get('conta-adiantamento/buscaConta', { params: { id: _this5.proposta.id } }).then(function (response) {
	                  if (!_.includes((0, _keys2.default)(response.data), 'codigo')) {
	                    var dadosBancarios = response.data;
	                    _this5.proposta.ds_agencia_adiantamento = dadosBancarios.agencia;
	                    _this5.proposta.ds_conta_adiantamento = dadosBancarios.conta;
	                    _this5.proposta.mci = dadosBancarios.mci;
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this5);
	      }))();
	    },
	    verificaPropostaSimplificada: function verificaPropostaSimplificada() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return axiosLaravel.get('simplificado/getPropostaSimplificadaAnalise/' + _this6.$route.params.id).then(function (response) {
	                  _this6.propostaSimplificada = response.data;
	                  console.log('verificaPropostaSimplificada', response.data);
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this6.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this6);
	      }))();
	    },
	    verificaObsDuplicada: function verificaObsDuplicada() {
	      var observacoes = [];
	      _.map(this.proposta.atividades, function (atividade) {
	        return _.map(atividade.itens_orcamentos, function (item) {
	          return observacoes.push(item.observacao.trim());
	        });
	      });
	      var duplicadas = (0, _entries2.default)(_.countBy(observacoes)).reduce(function (acc, _ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            key = _ref2[0],
	            val = _ref2[1];
	
	        return val > 1 ? acc.concat(key) : acc;
	      }, []);
	      return duplicadas.length > 0 ? duplicadas : false;
	    },
	    adicionaRestricao: function adicionaRestricao(ev) {
	      if (!_.isNil(ev) && _.has(ev, 'tag')) {
	        _.remove(this.restricaParaConcluir, function (i) {
	          return i.tag === ev.tag;
	        });
	
	        this.restricaParaConcluir.push(ev);
	      }
	    },
	    confirmaConclusao: function confirmaConclusao() {
	      var _this7 = this;
	
	      if (this.usuarioLogado.userType !== 'FUNDACAO') {
	        this.$dialog.confirm('Voc\xEA est\xE1 enviando a sua proposta para <b>Funda\xE7\xE3o BB.</b> Caso deseje apenas salvar para preenchimento posterior, clique em <b>Salvar</b>. Confirma envio pelo <b>Representante Legal</b> da Entidade? ', { html: true, animation: 'fade' }).then(function (dialog) {
	          _this7.permiteConcluir();
	        }).catch(function () {
	          _this7.$snotify.warning('Operação não realizada.');
	        });
	      } else {
	        this.permiteConcluir();
	      }
	    },
	    confirmaSalvamento: function confirmaSalvamento() {
	      var _this8 = this;
	
	      if (this.usuarioLogado.userType !== 'FUNDACAO') {
	        this.$dialog.confirm('Voc\xEA est\xE1 salvando os dados para preenchimento posterior. Para enviar a proposta para <b>Funda\xE7\xE3o BB</b>, clique em <b>Concluir</b>. Confirma salvamento?', { html: true, animation: 'fade' }).then(function (dialog) {
	          _this8.salvar();
	        }).catch(function () {
	          _this8.$snotify.warning('Operação não realizada.');
	        });
	      } else {
	        this.salvar();
	      }
	    },
	    permiteConcluir: function permiteConcluir() {
	      if (this.proposta.ds_fase === 'ANALISE' && this.proposta.resultadoAprovacao === 'ENCAMINHAR_DEFERIMENTO') {
	        if (this.$refs.analise.verificaLicencas() === false) {
	          this.$snotify.error('Verifique o cadastro do licenciamento ambiental. Nenhuma licença ou indicativo encontrado. Favor Verificar.');
	          return;
	        }
	
	        if (this.$refs.analise.verificaTematicaProjeto && this.$refs.analise.verificaTematicaProjeto() === false) {
	          this.$snotify.error('Informe a Temática do Projeto na análise (se marcar "Outros", descreva a temática).');
	          return;
	        }
	
	        if (this.$refs.municipalizacao.existeMunicipioRepetido.length > 0) {
	          this.$snotify.error('Existem municípios cadastrados em duplicidade, regularize antes de continuar.');
	          return;
	        }
	
	        if (this.possuiAdiandamento && this.proposta.adiantamentos.length <= 0) {
	          this.$snotify.error('Existem itens adiantáveis sem parcela de adiantamento cadastrada. Favor verificar.');
	          return;
	        }
	      }
	
	      if (this.proposta.ds_fase === 'CADASTRO' || this.proposta.ds_fase === 'REVISAO') {
	        if (this.$refs.testemunhas.verificaTestemunhasCadastradas() === false) {
	          return;
	        }
	      }
	      if (this.proposta.ds_fase === 'CADASTRO' || this.proposta.ds_fase === 'REVISAO') {
	        if (this.$refs.agenciaIndicativa.verificaSelecaoAgencia() === false) {
	          return;
	        }
	      }
	
	      if (this.proposta.resultadoAprovacao === 'ENCAMINHAR_DEFERIMENTO' && this.ehExcecao === true) {
	        if (this.$refs.cronogramaCotacao.verificaPendentesDeValidacao() === false) {
	          this.$snotify.error('Itens de orçamento pendentes de validação.');
	          return;
	        }
	      }
	
	      if (this.usuarioLogado.userType === 'FUNDACAO' && (!_.isEmpty(this.restricoesAtivasEntidade) || !_.isEmpty(this.restricoesAtivasProjetosDaEntidade)) && _.includes(['ENCAMINHAR_DEFERIMENTO', 'INCLUIR_SAPIENS', 'APROVAR'], this.proposta.resultadoAprovacao)) {
	        this.$snotify.error('A Entidade possui restrições impeditivas');
	        return;
	      }
	
	      if (!this.verificaContaAdiamento() && this.proposta.ds_fase === 'FORMALIZACAO' && this.proposta.resultadoAprovacao !== 'VOLTAR_ANALISE') {
	        this.$snotify.error('Agência/Conta/MCI de adiantamento não preenchidos ou inválidos.');
	        return;
	      }
	      if (this.$refs.tecnologiaSocial.possuiTecnologiaSocial === '' && (this.proposta.ds_fase === 'CADASTRO' || this.proposta.ds_fase === 'ANALISE')) {
	        this.$snotify.error('Selecione se a proposta possui ou não Tecnologia Social Vinculada.');
	        return;
	      }
	      if (this.proposta.resultadoAprovacao !== 'VOLTAR_ANALISE' && this.proposta.resultadoAprovacao !== 'DEVOLVER_ENTIDADE' && this.restricaParaConcluir.length > 0 && _.filter(this.restricaParaConcluir, { 'ativo': true }).length > 0) {
	        var vm = this;
	
	        var restricoes = _.filter(this.restricaParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	        var informacoes = _.filter(this.restricaParaConcluir, { 'ativo': true, 'tipo': 'informacao' });
	        var confirmacoes = _.filter(this.restricaParaConcluir, { 'ativo': true, 'tipo': 'confirmacao' });
	        if (restricoes.length > 0) {
	          var mensagens = '<div class=avisoAlerta><li>' + _.join(_.map(restricoes, 'mensagem'), '<li>') + '</div>';
	          this.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	        } else {
	          if (informacoes.length > 0) {
	            var _mensagens = '<div class=avisoInfo><li>' + _.join(_.map(informacoes, 'mensagem'), '<li>') + '</div>';
	            this.$dialog.alert(_mensagens, { html: true, animation: 'fade', customClass: 'avisoInfo' }).then(function (dialog) {
	              _.forEach(vm.restricaParaConcluir, function (item) {
	                if (item.tipo === 'informacao') {
	                  _set(item, 'ativo', false);
	                }
	              });
	            });
	          } else if (confirmacoes.length > 0) {
	            var _mensagens2 = '<div class=avisoConfirmacao><li>' + _.join(_.map(confirmacoes, 'mensagem'), '<li>') + '</div>';
	            this.$dialog.confirm(_mensagens2, { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	              _.forEach(vm.restricaParaConcluir, function (item) {
	                if (item.tipo === 'confirmacao') {
	                  _set(item, 'ativo', false);
	                }
	              });
	            }).catch(function () {});
	
	            if (informacoes.length === 0 & confirmacoes.length === 0) {
	              this.concluir();
	            }
	          }
	        }
	      } else {
	        this.concluir();
	      }
	    },
	    duplicador: function duplicador() {
	      var _this9 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!_this9.proposta.nr_projeto_duplicacao) {
	                  _context6.next = 3;
	                  break;
	                }
	
	                _context6.next = 3;
	                return axiosLaravel.get('projeto/sapiens/' + _this9.proposta.nr_projeto_duplicacao).then(function (response) {
	                  _this9.proposta['duplicadorSapiens'] = response.data[0];
	                  _this9.carregarProjetoSuperior();
	                }).catch(function (error) {
	                  _this9.$snotify.clear();
	                  _this9.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this9);
	      }))();
	    },
	    carregarProjetoSuperior: function carregarProjetoSuperior() {
	      var _this10 = this;
	
	      this.projetoSuperior = 'Buscando...';
	      axiosLaravel.get('projeto/sapiens/' + this.proposta.duplicadorSapiens.prjsup).then(function (response) {
	        _this10.proposta['superiorSapiens'] = response.data[0];
	        _this10.projetoSuperior = _this10.proposta.superiorSapiens.numprj + ' - ' + _this10.proposta.superiorSapiens.nomprj;
	        _this10.proposta['ds_projeto_superior'] = _this10.projetoSuperior;
	      }).catch(function (error) {
	        _this10.projetoSuperior = '';
	        _this10.$snotify.clear();
	        _this10.$root.trataErro(error);
	      });
	    },
	    verificaNavegador: function verificaNavegador() {
	      console.log('Verifica Navegador...');
	      var ua = navigator.userAgent;
	      var navegador = '';
	      if (ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('OPR')) {
	        navegador = 'Chrome';
	      } else if (ua.includes('Firefox')) {
	        navegador = 'Firefox';
	      } else if (ua.includes('Safari') && !ua.includes('Chrome')) {
	        navegador = 'Safari';
	      } else if (ua.includes('Edg')) {
	        navegador = 'Edge';
	      } else if (ua.includes('OPR') || ua.includes('Opera')) {
	        navegador = 'Opera';
	      } else {
	        navegador = 'Desconhecido';
	      }
	      return navegador;
	    },
	    assinaCanalProposta: function assinaCanalProposta() {
	      var _this11 = this;
	
	      console.log('Assinando canal de proposta', this.$route.params.id);
	      Echo.join('Edita.Proposta.' + this.$route.params.id).listen('PropostaEvents', function (e) {
	        if (!_.isEmpty(e) && !_.isNull(e)) {
	          _this11.progressBar.stepAtual = e.dados.stepAtual;
	          _this11.progressBar.stepTotal = e.dados.stepTotal;
	          _this11.progressBar.tarefaAtual = e.dados.tarefaAtual;
	        }
	      }).here(function (users) {
	        if (users.length > 1) {
	          _this11.$snotify.warning('Existe outro usuário acessando essa mesma proposta');
	        }
	      }).joining(function (user) {
	        _this11.$snotify.warning('Usuário ' + user.ds_nome_usuario + ' entrou para alterar essa proposta');
	      });
	    },
	    mostrarRef: function mostrarRef(ref) {
	      return _.filter(this.elementos, function (item) {
	        return item.nome === ref;
	      }).some(function (item) {
	        return item.visivel;
	      });
	    },
	    show: function show() {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this12.$modal.show('visualizar');
	                _this12.$forceUpdate();
	
	              case 2:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this12);
	      }))();
	    },
	    hide: function hide() {
	      this.$modal.hide('visualizar');
	    },
	    retiraAspas: function retiraAspas($event) {
	      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
	      if (keyCode === 39 || keyCode === 34) {
	        $event.preventDefault();
	      }
	    },
	    carregaRating: function carregaRating() {
	      var _this13 = this;
	
	      axiosLaravel.post('rating/carregar/', { 'idProposta': this.proposta.id }).then(function () {
	        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(response) {
	          return _regenerator2.default.wrap(function _callee8$(_context8) {
	            while (1) {
	              switch (_context8.prev = _context8.next) {
	                case 0:
	                  if (!_.isNil(response.data) && !_.isEmpty(response.data)) {
	                    _.set(_this13.proposta, 'rating', response.data);
	                  }
	                  _this13.$forceUpdate();
	
	                case 2:
	                case 'end':
	                  return _context8.stop();
	              }
	            }
	          }, _callee8, _this13);
	        }));
	
	        return function (_x) {
	          return _ref3.apply(this, arguments);
	        };
	      }()).catch(function (error) {
	        _this13.$root.trataErro(error);
	      });
	    },
	    buscaFluxo: function buscaFluxo() {
	      var _this14 = this;
	
	      this.loading.show = true;
	      if (this.proposta.ds_fase === 'CADASTRO') {
	        this.$route.params.processo = 'SOLICITACAO';
	      }
	      if (this.$router.currentRoute.name === 'proposta-visualiza') {
	        this.$route.params.processo = this.proposta.ds_fase;
	      }
	      if (!this.$route.params.processo || this.$route.params.processo === undefined) {
	        this.$route.params.processo = this.proposta.ds_fase;
	        this.esconder = false;
	        this.$forceUpdate();
	      }
	      axiosLaravel.post('fluxo/', { 'id_proposta': this.proposta.id, 'atividade': this.$route.params.processo }).then(function (response) {
	        _this14.$snotify.clear();
	        _this14.fluxo = response.data;
	        _this14.elementos = _this14.fluxo.elementos;
	        _this14.loading.show = false;
	
	        _this14.$forceUpdate();
	      }).catch(function (error) {
	        _this14.$root.trataErro(error);
	      });
	    },
	    buscaProposta: function buscaProposta() {
	      var _this15 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _this15.loading.show = true;
	                _context9.next = 3;
	                return axiosLaravel.get('propostas/' + _this15.$route.params.id).then(function (response) {
	                  _this15.$snotify.clear();
	                  _this15.proposta = response.data;
	
	                  console.log('PROPOSTA: ', _this15.proposta);
	                  console.log('PROPOSTA LENGHT: ', _this15.proposta.atividades.length);
	                  if (_this15.proposta.atividades.length === 0 && _this15.propostaSimplificada) {
	                    _this15.gerarMetasAtividadesProcessoSimplificado();
	                  }
	                  if (_this15.proposta.documentos) {
	                    if (_.isUndefined(_this15.proposta.documentos.proposta)) {
	                      if (_this15.proposta.documentos) {
	                        var documentosTemporarios = _this15.proposta.documentos;
	                        _this15.proposta.documentos = {
	                          proposta: documentosTemporarios
	                        };
	                        _this15.documentosProposta = _this15.proposta.documentos.proposta;
	                      } else {
	                        _this15.proposta.documentos = {
	                          proposta: []
	                        };
	                      }
	                    } else {
	                      _this15.documentosProposta = _this15.proposta.documentos.proposta;
	                    }
	                  }
	                  _this15.ehEdital = _.has(_this15.proposta, 'edital.id');
	                  _this15.editalAtivoVigente = _this15.ehEdital && !_.isEmpty(_.get(_this15.proposta, 'edital.dt_data_final', null)) && new Date(_.get(_this15.proposta, 'edital.dt_data_final') + ' 00:00').getTime() > _this15.hoje.getTime();
	
	                  _this15.carregaRating();
	                  _this15.buscaTodosEditais();
	
	                  _this15.buscaFluxo();
	                  _this15.buscaContaAdiantamento();
	                  _this15.buscaArquivosEsperados();
	                  _this15.verificaItensAdiantaveis();
	                  _this15.buscaNumProjeto();
	                  _this15.verificaExcecaoCotacaoAutomatica();
	                  _this15.$snotify.success('Proposta carregada com sucesso!', { timeout: 1000 });
	                  _this15.$forceUpdate();
	                  if (_this15.proposta.ds_fase === 'REVISAO' && _this15.usuarioLogado.userType === 'FUNDACAO' && _this15.$router.currentRoute.name !== 'proposta-visualiza') {
	                    _this15.$swal({
	                      title: '<font color="red"><b>Atenção!</b></font>',
	                      html: '<div align="left" style="font-size: smaller"> A proposta ' + '<b>' + _this15.proposta.ds_nome + '</b>' + ', está ' + '<u>' + 'Em Revisão' + '</u>' + ' pela entidade ' + '<i>' + _this15.proposta.entidade.ds_nome + '</i>' + '</div>',
	                      showCloseButton: false,
	                      showCancelButton: false,
	                      cancelButtonText: 'OK',
	                      showLoaderOnConfirm: true,
	                      allowOutsideClick: false,
	                      focusConfirm: false
	                    });
	                  }
	                  if (_this15.ehEdital === true && _this15.ehEditalAtivoNaoFinalizado(_this15.proposta) === false && _this15.proposta.ds_fase === 'CADASTRO' && _this15.usuarioLogado.userType === 'ENTIDADE') {
	                    _this15.bloqueiaBotoes = true;
	
	                    if (_this15.proposta.edital.id === 12) {
	                      _this15.bloqueiaBotoes = false;
	                    }
	                  }
	
	                  _this15.duplicador();
	                  if (_this15.titulo === 'SGP') {
	                    _this15.titulo = 'SGP' + (_.has(_this15.proposta, 'ds_fase') && _.has(_this15.titulosAba, _this15.proposta.ds_fase) ? ' - ' + _.get(_this15.titulosAba, _this15.proposta.ds_fase) : '');
	                  }
	                }).catch(function (error) {
	                  _this15.$snotify.clear();
	                  _this15.$root.trataErro(error);
	                });
	
	              case 3:
	                _context9.next = 5;
	                return axiosLaravel.get('fep/consultaFepProposta/' + _this15.$route.params.id).then(function (response) {
	                  _this15.proposta.fep = response.data;
	                });
	
	              case 5:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this15);
	      }))();
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this16 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!_.isEmpty(_this16.$store.state.projetosDuplicacao)) {
	                  _context10.next = 5;
	                  break;
	                }
	
	                _context10.next = 3;
	                return axiosLaravel.get('projetos-duplicacao').then(function (response) {
	                  _this16.$store.commit('SET_PROJETOS_DUPLICACAO', response.data);
	                  _this16.arvoreProjetos = _.sortBy(_this16.$store.state.projetosDuplicacao, 'numprj').reverse();
	                }).catch(function (error) {
	                  _this16.$root.trataErro(error);
	                });
	
	              case 3:
	                _context10.next = 6;
	                break;
	
	              case 5:
	                _this16.arvoreProjetos = _.sortBy(_this16.$store.state.projetosDuplicacao, 'numprj').reverse();
	
	              case 6:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this16);
	      }))();
	    },
	    buscaNumProjeto: function buscaNumProjeto() {
	      var _this17 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
	        var url, response;
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                console.log('buscaNumProjeto');
	
	                if (!(!_this17.proposta.ds_codigo_projeto_erp || _this17.proposta.ds_codigo_projeto_erp.length === 0)) {
	                  _context11.next = 17;
	                  break;
	                }
	
	                console.log('Iniciando busca por número do projeto...');
	                _context11.prev = 3;
	                url = '/propostas/consultaNumeroProjetoERP/' + _this17.proposta.id;
	                _context11.next = 7;
	                return axiosLaravel.post(url);
	
	              case 7:
	                response = _context11.sent;
	
	                console.log('Projeto encontrado com sucesso:', response.data);
	                _this17.proposta.ds_codigo_projeto_erp = response.data;
	                _context11.next = 15;
	                break;
	
	              case 12:
	                _context11.prev = 12;
	                _context11.t0 = _context11['catch'](3);
	
	                console.error('Erro ao buscar o número do projeto ERP:', _context11.t0);
	
	              case 15:
	                _context11.next = 18;
	                break;
	
	              case 17:
	                console.log('Número do projeto já existe, busca não necessária.');
	
	              case 18:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this17, [[3, 12]]);
	      }))();
	    },
	    verificaExcecaoCotacaoAutomatica: function verificaExcecaoCotacaoAutomatica() {
	      var _this18 = this;
	
	      console.log('Verificando excecao cotacao', this.$route.params.id);
	      var obj = {
	        idProposta: this.$route.params.id,
	        idEdital: this.ehEdital ? this.proposta.edital.id : 0
	      };
	      axiosLaravel.post('/cotacao/verificaExcecao/', obj).then(function (response) {
	        console.log('excecao: ', response.data);
	        _this18.ehExcecao = response.data;
	      }).catch(function (error) {
	        console.error(error);
	      });
	    },
	    limpar: function limpar() {
	      this.proposta = (0, _assign2.default)({}, {
	        entidade: {
	          ds_nome: ''
	        },
	        ds_projeto_duplicacao_descricao: '' });
	    },
	    irTopo: function irTopo() {
	      var _this19 = this;
	
	      this.$nextTick(function () {
	        _this19.$refs['topo'].scrollIntoView();
	      });
	    },
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this20 = this;
	
	      if (!_.isEmpty(this.$store.state.configuracoes)) {
	        this.proposta.tipoDocumentos = this.$store.state.configuracoes.configuracao_proposta.documentos_obrigatorios;
	        this.$forceUpdate();
	      } else {
	        axiosLaravel.get('configuracoes/').then(function (response) {
	          _this20.$store.commit('SET_CONFIGURACOES', response.data);
	          _this20.proposta.tipoDocumentos = _this20.$store.state.configuracoes.configuracao_proposta.documentos_obrigatorios;
	          _this20.$forceUpdate();
	        }).catch(function (error) {
	          _this20.$root.trataErro(error);
	        });
	      }
	    },
	    salvar: function salvar() {
	      var _this21 = this;
	
	      this.loading.show = true;
	      this.proposta.proximaEtapa = '';
	      this.bloqueiaBotoes = true;
	
	      this.proposta.proximaEtapa = 'SALVAR';
	      if (_.includes(['ANALISE'], this.proposta.ds_fase)) {
	        this.$refs.analise.salvarAvaliacao(true);
	      }
	      if (this.proposta.documentos) {
	        if (_.isUndefined(this.proposta.documentos.proposta) || this.proposta.documentos.proposta.length <= 0) {
	          this.proposta.documentos.proposta = [];
	          this.proposta.documentos.proposta = this.documentosProposta;
	        } else {
	          this.documentosProposta = this.proposta.documentos.proposta;
	        }
	      }
	
	      this.proposta.proximaEtapa = 'SALVAR';
	      this.$aguarde('Salvando proposta. Por favor, aguarde...');
	      this.proposta.navegador = this.verificaNavegador();
	      this.proposta.usuarioSalvamento = this.usuarioLogado.ds_login + ' ' + this.usuarioLogado.ds_nome_usuario;
	      this.proposta.tabId = sessionStorage.getItem('tabId');
	      var vm = this;
	      axiosLaravel.put('propostas/' + this.proposta.id, this.proposta).then(function (response) {
	        axiosLaravel.post('conta-adiantamento/salvaConta', {
	          id: _this21.proposta.id,
	          banco: _this21.proposta.ds_agencia_banco,
	          agencia: _this21.proposta.ds_agencia_adiantamento,
	          conta: _this21.proposta.ds_conta_adiantamento,
	          mci: _this21.proposta.mci,
	          tipo: 1
	        });
	        _this21.$snotify.clear();
	        _this21.bloqueiaBotoes = false;
	        _this21.$snotify.success('Proposta atualizada com sucesso');
	        _this21.loading.show = false;
	
	        var bc = new BroadcastChannel('propostas');
	        bc.postMessage({ acao: 'notificarSalvamento', id: vm.proposta.id });
	      }).catch(function (error) {
	        _this21.loading.show = false;
	        _this21.$snotify.clear();
	        _this21.$root.trataErro(error);
	      });
	    },
	    concluir: function concluir() {
	      var _this22 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
	        var pulaVerificacao, faseBkp, metas, metasAtv, i, j, dif, verificaContas, atividadesSemItens, duplicadas, listaDuplicadas;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                pulaVerificacao = false;
	                faseBkp = _this22.proposta.ds_fase;
	
	                if (!_.includes(['ANALISE'], _this22.proposta.ds_fase)) {
	                  _context12.next = 8;
	                  break;
	                }
	
	                console.log('salvandopontuacao');
	
	                if (!(_this22.$refs.analise.salvarAvaliacao() === false)) {
	                  _context12.next = 8;
	                  break;
	                }
	
	                _this22.loading.show = false;
	                _this22.bloqueiaBotoes = false;
	                return _context12.abrupt('return');
	
	              case 8:
	                _this22.proposta.proximaEtapa = '';
	
	                if (faseBkp === 'SOLICITACAO') {
	                  faseBkp = _this22.proposta.ds_fase;
	                  _this22.proposta.proximaEtapa = 'ANALISE';
	                  _this22.proposta.ds_fase = 'ANALISE';
	                  _this22.verificaFilhos = false;
	                  pulaVerificacao = false;
	                }
	                if (faseBkp === 'CADASTRO') {
	                  faseBkp = _this22.proposta.ds_fase;
	                  _this22.proposta.proximaEtapa = 'ANALISE';
	                  _this22.proposta.ds_fase = 'ANALISE';
	                  _this22.verificaFilhos = false;
	                  pulaVerificacao = false;
	                }
	
	                if (faseBkp === 'REVISAO') {
	                  faseBkp = _this22.proposta.ds_fase;
	                  _this22.proposta.proximaEtapa = 'ANALISE';
	                  _this22.proposta.ds_fase = 'ANALISE';
	                  _this22.verificaFilhos === false;
	                }
	
	                if (!(faseBkp === 'ANALISE')) {
	                  _context12.next = 25;
	                  break;
	                }
	
	                _this22.verificaFilhos = true;
	
	                if (!(_this22.proposta.resultadoAprovacao === 'ENCAMINHAR_DEFERIMENTO')) {
	                  _context12.next = 22;
	                  break;
	                }
	
	                faseBkp = _this22.proposta.ds_fase;
	                _this22.proposta.proximaEtapa = 'DEFERIMENTO';
	                _this22.proposta.ds_fase = 'DEFERIMENTO';
	
	                if (!(_.isNull(_this22.proposta.fep) || !_this22.proposta.fep)) {
	                  _context12.next = 22;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário gerar o Número da FEP antes de aprovar a Análise ');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 22:
	                if (_this22.proposta.resultadoAprovacao === 'DEVOLVER_ENTIDADE') {
	                  faseBkp = _this22.proposta.ds_fase;
	                  _this22.proposta.proximaEtapa = 'REVISAO';
	                  _this22.proposta.ds_fase = 'REVISAO';
	                  pulaVerificacao = true;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'INCLUIR_SAPIENS') {
	                  faseBkp = _this22.proposta.ds_fase;
	                  _this22.proposta.proximaEtapa = 'INCLUIR_SAPIENS';
	                  _this22.proposta.ds_estado_proposta = 'ANA';
	                  _this22.proposta.ds_situacao_erp = 'ANA';
	                }
	                if (_this22.proposta.resultadoAprovacao === 'ANULAR_PROPOSTA') {
	                  faseBkp = _this22.proposta.ds_fase;
	                  _this22.proposta.ds_fase = 'ANULADO';
	                  _this22.proposta.proximaEtapa = 'ANULACAO';
	                }
	
	              case 25:
	                if (faseBkp === 'DEFERIMENTO') {
	                  _this22.verificaFilhos = true;
	
	                  if (_this22.proposta.resultadoAprovacao === 'APROVAR') {
	                    faseBkp = _this22.proposta.ds_fase;
	                    _this22.proposta.proximaEtapa = 'FORMALIZACAO';
	                    _this22.proposta.ds_fase = 'FORMALIZACAO';
	                    _this22.proposta.ds_estado_proposta = 'DEF';
	                    _this22.proposta.ds_situacao_erp = 'DEF';
	                  }
	                  if (_this22.proposta.resultadoAprovacao === 'INDEFERIR') {
	                    faseBkp = _this22.proposta.ds_fase;
	                    _this22.proposta.proximaEtapa = 'INDEFERIR';
	                    _this22.proposta.ds_fase = 'INDEFERIDO';
	                  }
	                  if (_this22.proposta.resultadoAprovacao === 'VOLTAR_ANALISE') {
	                    pulaVerificacao = true;
	                    _this22.verificaFilhos = false;
	                    faseBkp = _this22.proposta.ds_fase;
	                    _this22.proposta.proximaEtapa = 'ANALISE';
	                    _this22.proposta.ds_fase = 'ANALISE';
	                  }
	                }
	
	                if (faseBkp === 'FORMALIZACAO') {
	                  if (_this22.proposta.resultadoAprovacao === 'APROVAR') {
	                    faseBkp = _this22.proposta.ds_fase;
	                    _this22.proposta.proximaEtapa = 'APROVACAO_PROJETO';
	                    _this22.proposta.ds_fase = 'APROVACAO_PROJETO';
	                    _this22.proposta.ds_estado_proposta = 'APROVACAO_PROJETO';
	                  }
	                  if (_this22.proposta.resultadoAprovacao === 'VOLTAR_ANALISE') {
	                    pulaVerificacao = true;
	                    _this22.verificaFilhos = false;
	                    faseBkp = _this22.proposta.ds_fase;
	                    _this22.proposta.proximaEtapa = 'ANALISE';
	                    _this22.proposta.ds_fase = 'ANALISE';
	                    _this22.proposta.ds_situacao_erp = 'ANA';
	                    _this22.proposta.ds_estado_proposta = 'ANA';
	                  }
	                }
	
	                if (faseBkp === 'APROVACAO_PROJETO') {
	                  _this22.verificaFilhos = true;
	
	                  if (_this22.proposta.resultadoAprovacao === 'APROVAR') {
	                    faseBkp = _this22.proposta.ds_fase;
	                    _this22.proposta.proximaEtapa = 'CONCLUSAO';
	                    _this22.proposta.ds_fase = 'APROVADO';
	
	                    _this22.proposta.ds_situacao_erp = 'APR';
	                    _this22.proposta.ds_estado_proposta = 'APR';
	                  }
	                  if (_this22.proposta.resultadoAprovacao === 'VOLTAR_ANALISE') {
	                    _this22.proposta.proximaEtapa = 'ANALISE';
	                    _this22.proposta.ds_fase = 'ANALISE';
	
	                    _this22.proposta.ds_situacao_erp = 'ANA';
	                    _this22.proposta.ds_estado_proposta = 'ANA';
	                  }
	                  if (_this22.proposta.resultadoAprovacao === 'VOLTAR_FORMALIZACAO') {
	                    _this22.proposta.proximaEtapa = 'FORMALIZACAO';
	                    _this22.proposta.ds_fase = 'FORMALIZACAO';
	                  }
	                }
	
	                if (_this22.proposta.resultadoAprovacao === 'APROVAR' && _this22.proposta.ds_fase === 'ANALISE') {
	                  pulaVerificacao = false;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'APROVAR' && _this22.proposta.ds_fase === 'DEFERIMENTO') {
	                  pulaVerificacao = true;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'ENCAMINHAR_DEFERIMENTO') {
	                  pulaVerificacao = false;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'ENVIAR_REVISAO') {
	                  pulaVerificacao = true;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'REPROVAR') {
	                  pulaVerificacao = true;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'DEVOLVER_ENTIDADE') {
	                  pulaVerificacao = true;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'INCLUIR_SAPIENS') {
	                  pulaVerificacao = true;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'ENVIAR_PENDENCIAS') {
	                  pulaVerificacao = true;
	                }
	                if (_this22.proposta.resultadoAprovacao === 'ANULAR_PROPOSTA') {
	                  pulaVerificacao = true;
	                }
	                metas = _.map(_this22.proposta.metas, 'ds_descricao');
	                metasAtv = [];
	
	                if (!_.isUndefined(_this22.proposta.atividades)) {
	                  for (i = 0; i < _this22.proposta.atividades.length; i++) {
	                    if (_this22.proposta.atividades[i].metas) {
	                      for (j = 0; j < _this22.proposta.atividades[i].metas.length; j++) {
	                        metasAtv.push(_this22.proposta.atividades[i].metas[j]);
	                      }
	                    }
	                  }
	                }
	                _this22.array = _.chain(metasAtv).map('ds_descricao').uniq().value();
	                dif = _.differenceWith(metas, _this22.array, _.isEqual);
	
	                if (!_.isEmpty(dif)) {
	                  _this22.show();
	                }
	                _this22.atvSemMetas = dif;
	                _this22.$emit('dif', dif);
	
	                if (!(pulaVerificacao === false)) {
	                  _context12.next = 59;
	                  break;
	                }
	
	                console.log('VERIFICACAO');
	
	                if (!(_this22.verificaFilhos === true && faseBkp !== 'CADASTRO' && faseBkp !== 'ANALISE')) {
	                  _context12.next = 52;
	                  break;
	                }
	
	                _context12.next = 50;
	                return _this22.$refs.child.$validator.validateAll().then(function (result) {
	                  if (result === false) {
	                    _this22.camposOK = false;
	                    _this22.proposta.ds_fase = faseBkp;
	                    _this22.$forceUpdate();
	                  } else {
	                    _this22.camposOK = true;
	                    _this22.$forceUpdate();
	                  }
	                });
	
	              case 50:
	                _context12.next = 59;
	                break;
	
	              case 52:
	                if (!(faseBkp === 'ANALISE')) {
	                  _context12.next = 57;
	                  break;
	                }
	
	                _context12.next = 55;
	                return _this22.$refs.analise.$validator.validateAll().then(function (result) {
	                  if (result === false) {
	                    _this22.camposOK = false;
	                    _this22.proposta.ds_fase = faseBkp;
	                    _this22.$forceUpdate();
	                  } else {
	                    _this22.camposOK = true;
	                    _this22.$forceUpdate();
	                  }
	                });
	
	              case 55:
	                _context12.next = 59;
	                break;
	
	              case 57:
	                _context12.next = 59;
	                return _this22.$validator.validateAll().then(function (result) {
	                  if (result === false) {
	                    _this22.camposOK = false;
	                    _this22.proposta.ds_fase = faseBkp;
	                    _this22.$forceUpdate();
	                  } else {
	                    _this22.camposOK = true;
	                    _this22.$forceUpdate();
	                  }
	                });
	
	              case 59:
	                _this22.$forceUpdate();
	
	                if (!(pulaVerificacao === false)) {
	                  _context12.next = 121;
	                  break;
	                }
	
	                if (!(_this22.camposOK === true)) {
	                  _context12.next = 121;
	                  break;
	                }
	
	                if (!_.isEmpty(_this22.proposta.publicos_alvo)) {
	                  _context12.next = 66;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário preencher o Publico-alvo!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 66:
	                if (!(faseBkp === 'ANALISE' && _this22.proposta.atividades)) {
	                  _context12.next = 73;
	                  break;
	                }
	
	                verificaContas = 0;
	
	                if (_this22.proposta.atividades.length > 0) {
	                  _this22.proposta.atividades.forEach(function (atividade) {
	                    if (_.has(atividade, 'itens_orcamento') && atividade.itens_orcamentos.length > 0) {
	                      atividade.itens_orcamentos.forEach(function (item) {
	                        if (!item.conta_financeira) {
	                          verificaContas = verificaContas + 1;
	                        }
	                      });
	                    }
	                  });
	                }
	
	                if (!(verificaContas > 0)) {
	                  _context12.next = 73;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário preencher as contas financeiras no cronograma!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 73:
	                if (!(!_this22.entidadeEhFundacao && _.isEmpty(_this22.proposta.equipes))) {
	                  _context12.next = 77;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário preencher a Equipe do projeto!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 77:
	                if (!_.isEmpty(_this22.proposta.objetivos)) {
	                  _context12.next = 81;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário preencher o(s) Objetivo(s) do Projeto!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 81:
	                if (!_.isEmpty(_this22.proposta.metas)) {
	                  _context12.next = 85;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário preencher a(s) Meta(s) do Projeto!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 85:
	                if (!_.isEmpty(_this22.proposta.atividades)) {
	                  _context12.next = 89;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário preencher a(s) Atividade(s) do Projeto!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 89:
	                if (_.isEmpty(_this22.proposta.atividades)) {
	                  _context12.next = 102;
	                  break;
	                }
	
	                atividadesSemItens = _.sumBy(_this22.proposta.atividades, function (atv) {
	                  return !_.has(atv, 'itens_orcamentos') || atv.itens_orcamentos.length === 0 ? 1 : 0;
	                });
	
	                if (!(_this22.proposta.atividades.length === atividadesSemItens)) {
	                  _context12.next = 95;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário preencher o(s) Item(s) do Cronograma!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 95:
	                if (!_this22.verificaObsDuplicada()) {
	                  _context12.next = 102;
	                  break;
	                }
	
	                duplicadas = _this22.verificaObsDuplicada();
	                listaDuplicadas = '';
	
	                duplicadas.forEach(function (d) {
	                  listaDuplicadas += d;
	                  if (d !== duplicadas.at(-1)) {
	                    listaDuplicadas += ' / ';
	                  }
	                });
	                _this22.$snotify.error('Existem descrições de itens do cronograma em duplicidade: ' + listaDuplicadas);
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 102:
	                if (!(_this22.$route.params.processo === 'ANALISE' || _this22.$route.params.processo === 'DEFERIMENTO' || _this22.$route.params.processo === 'SOLICITACAO' || _this22.$route.params.processo === 'CADASTRO')) {
	                  _context12.next = 111;
	                  break;
	                }
	
	                if (!_.isEmpty(_this22.proposta.municipalizacao)) {
	                  _context12.next = 107;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário preencher o(s) Municípios(s) Atendido(s) do Projeto!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 107:
	                if (!(_this22.totalParticipantesMunicipios !== _this22.totalParticipantes)) {
	                  _context12.next = 111;
	                  break;
	                }
	
	                _this22.$snotify.error('A quantidade de participantes gerais não bate com o total de participantes nos municípios');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 111:
	                if (!((_this22.proposta.ds_fase === 'CADASTRO' || _this22.proposta.ds_fase === 'SOLICITACAO') && (_.isEmpty(_this22.proposta.documentos.proposta) || _this22.proposta.documentos.proposta.length === 0))) {
	                  _context12.next = 117;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário anexar o(s) Documento(s) Obrigatório(s)!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 117:
	                if (!((_this22.proposta.ds_fase === 'CADASTRO' || _this22.proposta.ds_fase === 'SOLICITACAO') && _this22.proposta.documentos.proposta.length < _this22.proposta.tipoDocumentos.length)) {
	                  _context12.next = 121;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário anexar todo(s) o(s) Documento(s) Obrigatório(s)!');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 121:
	                if (!(faseBkp === 'DEFERIMENTO' && _this22.proposta.resultadoAprovacao !== 'VOLTAR_ANALISE')) {
	                  _context12.next = 133;
	                  break;
	                }
	
	                if (_this22.proposta.documentos.deferimento) {
	                  _context12.next = 128;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário anexar o(s) documento(s) de Deferimento.');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 128:
	                if (!_this22.proposta.documentos.deferimento) {
	                  _context12.next = 133;
	                  break;
	                }
	
	                if (!(_this22.proposta.documentos.deferimento.length === 0)) {
	                  _context12.next = 133;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário anexar o(s) documento(s) de Deferimento.');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 133:
	                if (!(faseBkp === 'FORMALIZACAO' && _this22.proposta.resultadoAprovacao !== 'VOLTAR_ANALISE')) {
	                  _context12.next = 145;
	                  break;
	                }
	
	                if (_this22.proposta.documentos.formalizacao) {
	                  _context12.next = 140;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário anexar o(s) documento(s) de Formalização.');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 140:
	                if (!_this22.proposta.documentos.formalizacao) {
	                  _context12.next = 145;
	                  break;
	                }
	
	                if (!(_this22.proposta.documentos.formalizacao.length === 0)) {
	                  _context12.next = 145;
	                  break;
	                }
	
	                _this22.$snotify.error('É necessário anexar o(s) documento(s) de Formalização.');
	                _this22.proposta.ds_fase = faseBkp;
	                return _context12.abrupt('return');
	
	              case 145:
	                if (!(_this22.analise.proximaEtapa === 'INCLUIR_SAPIENS')) {
	                  _context12.next = 153;
	                  break;
	                }
	
	                if (!(!_this22.proposta.ds_fase === 'ANALISE')) {
	                  _context12.next = 151;
	                  break;
	                }
	
	                _context12.next = 149;
	                return _this22.$refs.child.$validator.validateAll().then(function (result) {
	                  if (result === false) {
	                    _this22.camposOK = false;
	                    pulaVerificacao = false;
	                    _this22.proposta.ds_fase = faseBkp;
	                    _this22.$forceUpdate();
	                  } else {
	                    _this22.camposOK = true;
	                    _this22.$forceUpdate();
	                  }
	                });
	
	              case 149:
	                _context12.next = 153;
	                break;
	
	              case 151:
	                _context12.next = 153;
	                return _this22.$refs.analise.$validator.validateAll().then(function (result) {
	                  if (result === false) {
	                    _this22.camposOK = false;
	                    pulaVerificacao = false;
	                    _this22.proposta.ds_fase = faseBkp;
	                    _this22.$forceUpdate();
	                  } else {
	                    _this22.camposOK = true;
	                    _this22.$forceUpdate();
	                  }
	                });
	
	              case 153:
	                if (_this22.camposOK === true || pulaVerificacao === true) {
	                  _this22.bloqueiaBotoes = true;
	
	                  _this22.$aguarde('Validando a proposta. Por favor, aguarde...');
	                  axiosLaravel.put('propostas/' + _this22.proposta.id, _this22.proposta).then(function (response) {
	                    axiosLaravel.post('conta-adiantamento/salvaConta', {
	                      id: _this22.proposta.id,
	                      banco: _this22.proposta.ds_agencia_banco,
	                      agencia: _this22.proposta.ds_agencia_adiantamento,
	                      conta: _this22.proposta.ds_conta_adiantamento,
	                      mci: _this22.proposta.mci,
	                      tipo: 1
	                    });
	                    _this22.$snotify.clear();
	                    _this22.$snotify.success('Proposta atualizada com sucesso');
	                    _this22.bloqueiaBotoes = false;
	                    _this22.finalizou = true;
	                    setTimeout(function () {
	                      _this22.$router.go(-1);
	                    }, 2000);
	                  }).catch(function (error) {
	                    _this22.bloqueiaBotoes = false;
	                    _this22.proposta.ds_fase = faseBkp;
	                    _this22.$snotify.clear();
	                    _this22.$root.trataErro(error);
	                  });
	                } else {
	                  _this22.proposta.ds_fase = faseBkp;
	                  _this22.$snotify.error('Existem campos obrigatórios que não foram preenchidos. Favor verificar');
	                  _this22.bloqueiaBotoes = false;
	                }
	
	              case 154:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this22);
	      }))();
	    },
	    isUploadingDocuments: function isUploadingDocuments() {
	      var documentosEsperados = this.proposta.documentTypes.map(function (item) {
	        return item.type;
	      });
	      var documentosCarregados = this.proposta.documents.map(function (item) {
	        return item.documentType.type;
	      });
	      return _.difference(documentosEsperados, documentosCarregados).length === 0;
	    },
	    editaEdital: function editaEdital() {
	      this.proposta.fk_edital = this.editalSelecionado;
	      this.$snotify.success('Edital selecionado com sucesso. Não esqueça de Salvar a Proposta.');
	    },
	    validaObjetivos: function validaObjetivos() {
	      return this.proposta.objetivos.every(function (item) {
	        return item.metas ? item.metas.length > 0 : false;
	      });
	    },
	    validaMetas: function validaMetas() {
	      var metas = [];
	      this.proposta.objetivos.forEach(function (objetivo) {
	        if (objetivo.metas) {
	          objetivo.metas.forEach(function (meta) {
	            metas.push(meta);
	          });
	        }
	      });
	      return metas.every(function (meta) {
	        return meta.atividades ? meta.atividades.length > 0 : false;
	      });
	    },
	    validaAtividades: function validaAtividades() {
	      var atividades = [];
	      this.proposta.objetivos.forEach(function (objetivo) {
	        if (objetivo.metas) {
	          objetivo.goals.forEach(function (meta) {
	            if (meta.atividades) {
	              meta.atividades.forEach(function (atividade) {
	                atividades.push(atividade);
	              });
	            }
	          });
	        }
	      });
	      return atividades.every(function (atividade) {
	        return atividade.items ? atividade.items.length > 0 : false;
	      });
	    },
	    verificaAbrangenciaNacional: function verificaAbrangenciaNacional() {
	      if (this.proposta.ds_fase === 'CADASTRO' && (this.proposta.bt_fep_abrangencia === 1 || this.proposta.bt_fep_abrangencia === '1')) {
	        this.preencheuAbrangencia = true;
	        if (this.proposta.entidade.endereco) {
	          var enderecoEntidade = this.proposta.entidade.endereco;
	          if (enderecoEntidade.length > 1) {
	            var entidadeFiltro = _.filter(enderecoEntidade, { 'bt_principal': 1 }).first();
	            this.enderecoEntidadePrincipal = entidadeFiltro[0];
	          } else {
	            this.enderecoEntidadePrincipal = this.proposta.entidade.endereco[0];
	          }
	
	          if (this.proposta.publicos_alvo && !_.isNull(this.proposta.publicos_alvo)) {
	            var publicos = this.proposta.publicos_alvo;
	            this.MunTotalParticipantes = _.sumBy(publicos, function (p) {
	              return parseInt(p.nr_participantes_diretos);
	            });
	          }
	
	          this.buscaCidadeMun();
	        }
	      }
	    },
	    buscaCidadeMun: function buscaCidadeMun() {
	      var _this23 = this;
	
	      axiosLaravel.get('municipios/cep/' + this.enderecoEntidadePrincipal.ds_cep).then(function (response) {
	        var retorno = response.data;
	        _this23.proposta.municipalizacao = [];
	        _this23.proposta.municipalizacao.push({
	          ds_cep: _this23.enderecoEntidadePrincipal.ds_cep,
	          ds_municipio: retorno.ds_nome,
	          ds_uf: retorno.ds_uf,
	          nr_total_participantes: _this23.MunTotalParticipantes
	        });
	        _this23.$forceUpdate();
	      }).catch(function (error) {
	        _this23.$root.trataErro(error);
	      });
	    },
	    buscaTodosEditais: function buscaTodosEditais() {
	      var _this24 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('edital/').then(function (response) {
	        _this24.listaEditais = response.data;
	
	        if (_this24.listaEditais.length === 0) {
	          alert('Não localizamos um edital ativo e vigente para o link informado. Entre em contato com a FBB!');
	        }
	
	        _this24.verificaTravaEdital();
	        _this24.loading.tela = false;
	        _this24.$forceUpdate();
	      }).catch(function (error) {
	        _this24.loading.tela = false;
	        _this24.$root.trataErro(error);
	      });
	    },
	    verificaTravaEdital: function verificaTravaEdital() {
	      if (this.proposta.fk_edital === null || this.proposta.fk_edital === undefined) {
	        return;
	      }
	      if (this.proposta.fk_edital !== null && this.proposta.fk_edital !== undefined) {
	        var edital = _.find(this.listaEditais, { 'id': this.proposta.fk_edital });
	        if (edital) {
	          if (edital.edicao === 'N' && this.usuarioLogado.userType === 'ENTIDADE' && (this.proposta.ds_fase === 'CADASTRO' || this.proposta.ds_fase === 'ANALISE')) {
	            this.travarEdicao = true;
	            this.$dialog.alert('<font color="red"><b>Atenção!</b></font><div align="left" style="font-size: smaller">Edição de proposta desabilitada pelo fim do prazo do Edital.</div>', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	            return;
	          }
	        }
	      }
	      this.travarEdicao = false;
	    },
	    cancelarProposta: function cancelarProposta() {
	      var _this25 = this;
	
	      this.$aguarde('Cancelando a proposta...');
	      this.$refs.alertaCancelamentoDialog.close();
	      this.loading.tela = true;
	      axiosLaravel.post('propostas/cancela-proposta/' + this.proposta.id, { 'id_proposta': this.proposta.id, 'fk_processo': this.proposta.fk_processo, 'fk_entidade': this.proposta.fk_entidade, 'fk_usuario': this.usuarioLogado.id, justificativa: this.justificativaCancelamento }).then(function (response) {
	        _this25.$snotify.success('Proposta cancelada com sucesso.');
	        _this25.loading.tela = false;
	        _this25.$snotify.clear();
	        _this25.$snotify.success('Proposta cancelada com sucesso!');
	
	        return new _promise2.default(function (resolve) {
	          return setTimeout(resolve, 3000);
	        }).then(function () {
	          _this25.$router.push('/proposta/lista');
	        });
	      }).catch(function () {
	        _this25.$snotify.clear();
	        _this25.$root.trataErro(error);
	        _this25.$snotify.warning('Operação não realizada.');
	      });
	    },
	    verificaItensAdiantaveis: function verificaItensAdiantaveis() {
	      console.log('VERIFICA ITENS ADIANTAVEIS', this.proposta.atividades);
	      var atividades = this.proposta.atividades;
	      var existeAdiantavel = atividades.some(function (atividade) {
	        return atividade.itens_orcamentos.some(function (item) {
	          return item.adiantavel === '1';
	        });
	      });
	      console.log('Existe item adiantavel? ', existeAdiantavel);
	      if (existeAdiantavel) {
	        this.possuiItensAdiantaveis = existeAdiantavel;
	      }
	    },
	    verificaContaAdiamento: function verificaContaAdiamento() {
	      if (!this.possuiItensAdiantaveis) {
	        return true;
	      }
	      if (typeof this.proposta.ds_agencia_adiantamento === 'undefined' || this.proposta.ds_agencia_adiantamento === '' || typeof this.proposta.ds_conta_adiantamento === 'undefined' || this.proposta.ds_conta_adiantamento === '' || typeof this.proposta.mci === 'undefined' || this.proposta.mci === '') {
	        console.log('As variáveis são undefined ou vazias');
	        return false;
	      } else {
	        console.log('As variáveis têm algum valor definido');
	        return true;
	      }
	    },
	    verificaSeExisteRestricoesAtivas: function verificaSeExisteRestricoesAtivas() {
	      var _this26 = this;
	
	      if (this.proposta.entidade.id === 1439) {
	        this.situacaoRestricoes = 'dispensada';
	        return false;
	      }
	      this.situacaoRestricoes = 'carregando';
	      var entidade = axiosLaravel.post('consulta/ocorrencias/entidade/', { 'id_entidade': this.proposta.entidade.id, 'tipo': 4, 'situacao_ocorrencia': 'vigentes' }).then(function (response) {
	        _this26.restricoesAtivasEntidade = response.data;
	      });
	      var projetos = axiosLaravel.post('consulta/ocorrencias/projeto/', { 'id_entidade': this.proposta.entidade.id, 'tipo': 3, 'situacao_ocorrencia': 'vigentes' }).then(function (response) {
	        _this26.restricoesAtivasProjetosDaEntidade = response.data;
	      });
	      _promise2.default.all([entidade, projetos]).then(function () {
	        _this26.situacaoRestricoes = 'concluida';
	      }).catch(function (error) {
	        _this26.situacaoRestricoes = 'erro';
	        _this26.$root.trataErro(error);
	      });
	    },
	    ehEditalAtivoNaoFinalizado: function ehEditalAtivoNaoFinalizado(proposta) {
	      var dataTerminoEdital = _.get(proposta, 'edital.dt_data_final');
	      var ldsTerminoEdital = new Date(dataTerminoEdital + ' 00:00:00').toLocaleDateString('en-US', { timeZone: 'America/Sao_Paulo' });
	      var ldsHojeBrasilia = new Date().toLocaleDateString('en-US', { timeZone: 'America/Sao_Paulo' });
	      return dataTerminoEdital && new Date(ldsHojeBrasilia).getTime() < new Date(ldsTerminoEdital).getTime();
	    },
	    setPropostaSimplificada: function setPropostaSimplificada(risco) {
	      var _this27 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                if (!(_this27.proposta.ds_fase === 'CADASTRO')) {
	                  _context13.next = 2;
	                  break;
	                }
	
	                return _context13.abrupt('return');
	
	              case 2:
	                console.log('SET RISCO CALCULADO ', risco);
	                _this27.proposta.ds_risco_calculado = risco;
	                _this27.proposta.ds_periodicidade_formulario = 'QUADRIMESTRAL';
	                if (typeof _this27.proposta.questionario_respostas === 'undefined') {
	                  _this27.proposta.questionario_respostas = {};
	                }
	
	                _this27.proposta.questionario_respostas.rating = {};
	                _this27.proposta.questionario_respostas.rating.fk_questao_codigo = '8';
	                _this27.proposta.questionario_respostas.rating.ds_codigo = '3';
	                _this27.proposta.questionario_respostas.rating.ds_descricao = 'C';
	                _this27.proposta.questionario_respostas.rating.dc_nota_resposta = '180';
	                _this27.proposta.questionario_respostas.rating.ds_id = '83';
	                console.log('RISCO QUESTIONARIO', _this27.proposta.questionario_respostas);
	                obj = {
	                  fk_proposta: _this27.$route.params.id,
	                  valor_fbb: 0
	                };
	                _context13.next = 16;
	                return axiosLaravel.post('simplificado/gravarSimplificada/', obj).then(function (response) {
	                  console.log(response.data);
	                }).catch(function (error) {
	                  _this27.$root.trataErro(error);
	                });
	
	              case 16:
	                _this27.$forceUpdate();
	
	              case 17:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this27);
	      }))();
	    },
	    gerarMetasAtividadesProcessoSimplificado: function gerarMetasAtividadesProcessoSimplificado() {
	      this.proposta.objetivos = [{
	        id: '001MC',
	        ds_descricao: 'Resumo memória de cálculo'
	      }];
	
	      this.proposta.metas = [{
	        ds_descricao: 'Resumo memória de cálculo',
	        nr_quantidade: '1',
	        ds_unidade_medida: 'Unidade',
	        ds_indicadores_execucao: 'Outros',
	        ds_descricao_outros: 'Resumo memória de cálculo',
	        objetivos: [{
	          id: '001MCO',
	          ds_descricao: 'Resumo memória de cálculo'
	        }],
	        id: '001MCM'
	      }];
	
	      this.proposta.atividades = [{
	        id: 0,
	        ds_nome: 'Resumo memória de cálculo',
	        ds_documento_comprobatorio: 'Comprovantes fiscais das despesas.',
	        nr_periodo_inicial: '1',
	        nr_periodo_final: '1',
	        descricao: 'Resumo memória de cálculo',
	        inicio: '0',
	        termino: '0',
	        executado: 0,
	        execucao: 0,
	        orcado: 0,
	        dias_inicio: 0,
	        dias_termino: 0,
	        metas: [{
	          ds_descricao: 'Resumo memória de cálculo',
	          nr_quantidade: '1',
	          ds_unidade_medida: 'Unidade',
	          ds_indicadores_execucao: 'Outros',
	          ds_descricao_outros: 'Resumo memória de cálculo',
	          objetivos: [{
	            ds_descricao: 'Resumo memória de cálculo',
	            id: '001MCM'
	          }],
	          id: '001MCA'
	        }],
	        itens_orcamentos: [{
	          observacao: 'Despesa de Pessoal',
	          origem: '1',
	          periodo_inicial: '1',
	          recurso: null,
	          adiantavel: '0',
	          unidade_medida: 'Unidades',
	          item: {
	            ds_code: 'S0632',
	            ds_description: 'Despesa de Pessoal',
	            ds_unidade_medida: 'UN',
	            ds_situacao: 'A',
	            ds_type: 'SERVICO',
	            contratacao: 1
	          },
	          quantidade: '0',
	          periodo_final: '1',
	          valorTotal: null,
	          valor_unitario: 0,
	          editando: false,
	          totalValue: null,
	          ds_type: 'SERVICO',
	          medida_outros: 'Serviço'
	        }, {
	          observacao: 'Material de Consumo',
	          origem: '1',
	          periodo_inicial: '1',
	          recurso: null,
	          adiantavel: '0',
	          unidade_medida: 'Unidades',
	          item: {
	            ds_code: 'P1158',
	            ds_description: 'Material de Consumo',
	            ds_unidade_medida: 'UN',
	            ds_situacao: 'A',
	            ds_type: 'PRODUTO',
	            contratacao: 1
	          },
	          quantidade: '0',
	          periodo_final: '1',
	          valorTotal: null,
	          valor_unitario: 0,
	          editando: false,
	          totalValue: null,
	          ds_type: 'PRODUTO',
	          medida_outros: 'Serviço'
	        }, {
	          observacao: 'Serviços de terceiros',
	          origem: '1',
	          periodo_inicial: '1',
	          recurso: null,
	          adiantavel: '0',
	          unidade_medida: 'Unidades',
	          item: {
	            ds_code: 'S0633',
	            ds_description: 'Serviços de Terceiros',
	            ds_unidade_medida: 'UN',
	            ds_situacao: 'A',
	            ds_type: 'SERVICO',
	            contratacao: 1
	          },
	          quantidade: '0',
	          periodo_final: '1',
	          valorTotal: null,
	          valor_unitario: 0,
	          editando: false,
	          totalValue: null,
	          ds_type: 'SERVICO',
	          medida_outros: 'Serviço'
	        }, {
	          observacao: 'Equipamentos e Material Permanente',
	          origem: '1',
	          periodo_inicial: '1',
	          recurso: null,
	          adiantavel: '0',
	          unidade_medida: 'Unidades',
	          item: {
	            ds_code: 'P1157',
	            ds_description: 'Equipamentos e Material Permanente',
	            ds_unidade_medida: 'UN',
	            ds_situacao: 'A',
	            ds_type: 'PRODUTO',
	            contratacao: 1
	          },
	          quantidade: '0',
	          periodo_final: '1',
	          valorTotal: null,
	          valor_unitario: 0,
	          editando: false,
	          totalValue: null,
	          ds_type: 'PRODUTO',
	          medida_outros: 'Serviço'
	        }, {
	          observacao: 'Obra Civil',
	          origem: '1',
	          periodo_inicial: '1',
	          recurso: null,
	          adiantavel: '0',
	          unidade_medida: 'Unidades',
	          item: {
	            ds_code: 'S0634',
	            ds_description: 'Obra Civil',
	            ds_unidade_medida: 'UN',
	            ds_situacao: 'A',
	            ds_type: 'SERVICO',
	            contratacao: 1
	          },
	          quantidade: '0',
	          periodo_final: '1',
	          valorTotal: null,
	          valor_unitario: 0,
	          editando: false,
	          totalValue: null,
	          ds_type: 'SERVICO',
	          medida_outros: 'Serviço'
	        }]
	      }];
	    }
	  }
	};

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'GerenciadorEdicaoProposta',
	  data: function data() {
	    return {
	      loading: false,
	      moment: _moment2.default,
	      intervalPing: null,
	      ultimaAtualizacao: '',
	      table: {
	        items: [],
	        currentPage: 1,
	        perPage: 55,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{ key: 'proposta_id', label: 'Proposta', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_fase', label: 'Fase Proposta', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'user_id', label: 'ID Usuário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'user_name', label: 'Usuário', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ultimo_ping', label: 'Ping', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'edicao_ativa', label: 'Ativo', sortable: true, thStyle: 'text-align: center', class: 'text-center', formatter: function formatter(value) {
	            return value === true || value === 1 || value === '1' ? 'Sim' : 'Não';
	          } }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['numeroProposta'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {},
	  mounted: function mounted() {
	    this.iniciarPing();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.intervalPing) {
	      clearInterval(this.intervalPing);
	    }
	  },
	  methods: {
	    iniciarPing: function iniciarPing() {
	      var _this = this;
	
	      if (this.intervalPing) {
	        clearInterval(this.intervalPing);
	      }
	      this.consultaLog();
	      this.intervalPing = setInterval(function () {
	        _this.consultaLog();
	      }, 60000);
	    },
	    consultaLog: function consultaLog() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('consultando log de sessoes ativas');
	                _context.next = 3;
	                return axiosLaravel.get('/gerenciadorEdicao/getLogs').then(function (response) {
	                  console.log(response.data);
	                  _this2.table.items = response.data;
	                  _this2.table.totalRows = response.data.length;
	                  _this2.ultimaAtualizacao = (0, _moment2.default)(new Date()).format('DD/MM/YYYY HH:mm:ss');
	                  _this2.$forceUpdate();
	                }).catch(function (error) {
	                  console.log(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    encerraSessao: function encerraSessao(item) {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var propostaId;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('Encerrando a sessao...', item);
	                propostaId = item.proposta_id;
	
	                _this3.$dialog.confirm('Deseja realmente encerrar essa sessão? Essa ação, caso mais de um usuário estiver com a proposta aberta, <b>poderá</b> acarretar em dados sobreescritos. Continuar?', {
	                  title: 'Encerrar sessão de edição',
	                  type: 'warning',
	                  confirmButtonText: 'Sim, encerrar sessão!',
	                  cancelButtonText: 'Cancelar'
	                }).then(function () {
	                  axiosLaravel.post('/gerenciadorEdicao/encerraSessao/' + propostaId).then(function (response) {
	                    _this3.$snotify.success(response.data.resultado);
	                    _this3.table.items = [];
	                    _this3.consultaLog();
	                  }).catch(function (error) {
	                    console.log(error);
	                  });
	                }).catch(function () {
	                  console.log('Exclusão cancelada');
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    }
	  }
	};

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'GerenciadorEdicaoProposta',
	  data: function data() {
	    return {
	      loading: false,
	      moment: _moment2.default,
	      decisaoEdicao: 'Pendente',
	      sessaoAtiva: {},
	      podeEditar: false,
	      intervalPing: null,
	      enderecoHome: 'https://projetos.fbb.org.br'
	    };
	  },
	
	  props: ['numeroProposta'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {
	    if (!sessionStorage.getItem('tabId')) {
	      var tabId = Date.now().toString() + Math.random().toString(36).substr(2);
	      sessionStorage.setItem('tabId', tabId);
	    }
	  },
	  mounted: function mounted() {
	    this.verificarSessaoAtiva();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.intervalPing) {
	      clearInterval(this.intervalPing);
	    }
	    if (this.podeEditar) {
	      window.removeEventListener('beforeunload', this.encerrarSessao);
	      this.encerrarSessao();
	    }
	  },
	  methods: {
	    verificarSessaoAtiva: function verificarSessaoAtiva() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('Verificando Sessao de Edição Ativa...');
	                _this.$aguarde('Verificando Sessão de Edição ativa...');
	                _this.loading = true;
	                obj = {
	                  proposta_id: _this.numeroProposta,
	                  user_id: _this.usuarioLogado.id,
	                  user_name: _this.usuarioLogado.ds_nome_usuario,
	                  uid_aba: sessionStorage.getItem('tabId'),
	                  navegador: _this.verificaNavegador()
	                };
	                _context.next = 6;
	                return axiosLaravel.post('/gerenciadorEdicao/verificarEdicaoPropostaAtiva/', obj).then(function (response) {
	                  _this.$snotify.clear();
	                  _this.decisaoEdicao = response.data.resultado;
	                  _this.sessaoAtiva = response.data.sessao;
	
	                  if (_this.decisaoEdicao === 'Edição Permitida') {
	                    _this.$snotify.success('Sessão Verificada: ' + response.data.resultado);
	                    _this.podeEditar = true;
	                    _this.iniciarPing();
	                    window.addEventListener('beforeunload', _this.encerrarSessao);
	                  } else {
	                    _this.podeEditar = false;
	                    var mensagem = 'Proposta em edi\xE7\xE3o pelo usu\xE1rio: ' + _this.sessaoAtiva.user_name + '. N\xE3o ser\xE1 poss\xEDvel salvar enquanto a sess\xE3o do usu\xE1rio nessa proposta estiver ativa. Deseja continuar para VISUALIZAR a proposta?';
	                    if (_this.usuarioLogado.ds_nome_usuario === _this.sessaoAtiva.user_name && _this.sessaoAtiva.navegador === _this.verificaNavegador()) {
	                      mensagem = 'Aten\xE7\xE3o: Proposta em edi\xE7\xE3o em outra aba. N\xE3o ser\xE1 poss\xEDvel salvar. Deseja continuar para VISUALIZAR a proposta nesta aba?';
	                    } else if (_this.usuarioLogado.ds_nome_usuario === _this.sessaoAtiva.user_name && _this.sessaoAtiva.navegador !== _this.verificaNavegador()) {
	                      mensagem = 'Aten\xE7\xE3o: Proposta em edi\xE7\xE3o em outro navegador. N\xE3o ser\xE1 poss\xEDvel salvar. Deseja continuar para VISUALIZAR a proposta nesta aba?';
	                    }
	                    _this.$dialog.confirm(mensagem, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	                      console.log('concordou');
	                    }).catch(function () {
	                      window.location.href = _this.enderecoHome;
	                    });
	                  }
	                  console.log(response.data);
	                }).catch(function (error) {
	                  console.log(error);
	                });
	
	              case 6:
	                _this.loading = false;
	                console.log('sessaoVerificada ', _this.decisaoEdicao);
	                _this.$emit('sessaoVerificada', _this.podeEditar);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    iniciarPing: function iniciarPing() {
	      var _this2 = this;
	
	      if (this.intervalPing) {
	        clearInterval(this.intervalPing);
	      }
	      this.intervalPing = setInterval(function () {
	        _this2.ping();
	      }, 60000);
	    },
	    ping: function ping() {
	      var _this3 = this;
	
	      console.log('Atualizando presença de edição...');
	      this.loading = true;
	      var obj = {
	        proposta_id: this.numeroProposta,
	        user_id: this.usuarioLogado.id,
	        user_name: this.usuarioLogado.ds_nome_usuario,
	        uid_aba: sessionStorage.getItem('tabId'),
	        navegador: this.verificaNavegador()
	      };
	      axiosLaravel.post('/gerenciadorEdicao/verificarEdicaoPropostaAtiva/', obj).then(function (response) {
	        console.log('ping edição:', response.data);
	        _this3.sessaoAtiva = response.data.sessao;
	      }).catch(function (error) {
	        console.log(error);
	      });
	      this.loading = false;
	    },
	    verificaNavegador: function verificaNavegador() {
	      var ua = navigator.userAgent;
	      var navegador = '';
	      if (ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('OPR')) {
	        navegador = 'Chrome';
	      } else if (ua.includes('Firefox')) {
	        navegador = 'Firefox';
	      } else if (ua.includes('Safari') && !ua.includes('Chrome')) {
	        navegador = 'Safari';
	      } else if (ua.includes('Edg')) {
	        navegador = 'Edge';
	      } else if (ua.includes('OPR') || ua.includes('Opera')) {
	        navegador = 'Opera';
	      } else {
	        navegador = 'Desconhecido';
	      }
	      return navegador;
	    },
	    encerrarSessao: function encerrarSessao() {
	      var propostaId = this.numeroProposta;
	      if (!propostaId) {
	        console.warn('[GerenciadorEdicao] encerrarSessao abortado: numeroProposta ausente');
	        return;
	      }
	
	      var base = (axiosLaravel.defaults && axiosLaravel.defaults.baseURL || '').replace(/\/+$/, '');
	      var url = base + '/gerenciadorEdicao/encerraSessao/' + propostaId;
	      var ok = navigator.sendBeacon(url);
	      if (!ok) {
	        console.warn('[GerenciadorEdicao] sendBeacon retornou false; aplicando fallback fetch keepalive');
	        try {
	          fetch(url, { method: 'POST', keepalive: true, credentials: 'include' });
	        } catch (e) {
	          console.warn('[GerenciadorEdicao] fallback fetch falhou', e);
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'GerenciadorPropostaSimplificada',
	  data: function data() {
	    return {
	      loading: false,
	      loadingPesquisa: false,
	      tabSelect: 'Proposta',
	      adicionarRegistro: false,
	      novoRegistro: {
	        tipo: '',
	        id: ''
	      },
	      termoPesquisa: '',
	      moment: _moment2.default,
	      table: {
	        items: [],
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Sem registros de propostas',
	        fields: [{ key: 'nome_proposta', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'text-left' }, { key: 'ds_fase', label: 'Fase', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'edital', label: 'Edital', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'simplificado', label: 'Simplificado?', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tableEdital: {
	        items: [],
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Sem registros de editais',
	        fields: [{ key: 'fk_edital', label: 'ID', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nome_edital', label: 'Edital', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'simplificado', label: 'Simplificado?', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      tablePesquisa: {
	        items: [],
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Sem registros de pesquisa',
	        fields: [{ key: 'identificador', label: 'ID', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'nome', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'text-left' }, { key: 'tipo', label: 'Tipo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['numeroProposta'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {},
	  mounted: function mounted() {
	    this.consultaPropostaSimplificada();
	  },
	  methods: {
	    handleTab: function handleTab(aba) {
	      this.tabSelect = aba;
	    },
	    consultaPropostaSimplificada: function consultaPropostaSimplificada() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('consultando propostas Simplificadas...');
	                _this.loading = true;
	                _context.next = 4;
	                return axiosLaravel.get('/simplificado/getPropostaSimplificada/').then(function (response) {
	                  console.log(response.data);
	                  _this.table.items = response.data.propostas;
	                  _this.tableEdital.items = response.data.editais;
	                  _this.table.currentPage = 1;
	                  _this.table.totalRows = response.data.propostas.length;
	                  _this.tableEdital.currentPage = 1;
	                  _this.tableEdital.totalRows = response.data.propostas.length;
	                  _this.$forceUpdate();
	                  _this.loading = false;
	                }).catch(function (error) {
	                  _this.loading = false;
	                  console.log(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    pesquisarNovoRegistro: function pesquisarNovoRegistro() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.loadingPesquisa = true;
	
	                if (!(_this2.termoPesquisa === '')) {
	                  _context2.next = 5;
	                  break;
	                }
	
	                _this2.$snotify.error('Atenção, informe um termo de pesquisa antes de continuar.');
	                _this2.loadingPesquisa = false;
	                return _context2.abrupt('return');
	
	              case 5:
	                obj = {
	                  termoPesquisa: _this2.termoPesquisa,
	                  tipo: _this2.tabSelect
	                };
	                _context2.next = 8;
	                return axiosLaravel.post('/simplificado/pesquisarRegistroParaCadastro', obj).then(function (response) {
	                  console.log(response.data);
	                  _this2.tablePesquisa.items = response.data;
	                  _this2.tablePesquisa.currentPage = 1;
	                  _this2.tablePesquisa.totalRows = response.data.length;
	                  _this2.$forceUpdate();
	                  _this2.loadingPesquisa = false;
	                }).catch(function (error) {
	                  _this2.loadingPesquisa = false;
	                  console.log(error);
	                });
	
	              case 8:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    toggleNovoRegistro: function toggleNovoRegistro(valor) {
	      this.adicionarRegistro = valor;
	      this.limparPesquisa();
	    },
	    limparPesquisa: function limparPesquisa() {
	      this.tablePesquisa.items = [];
	      this.termoPesquisa = '';
	    },
	    alteraProcessoSimplificado: function alteraProcessoSimplificado(item) {
	      var _this3 = this;
	
	      if (this.tabSelect === 'Proposta') {
	        this.$dialog.confirm('Confirma a altera\xE7\xE3o na proposta simplificada? <b>Aten\xE7\xE3o</b>: \xE9 de responsabilidade do usu\xE1rio o acompanhamento do cronograma e a an\xE1lise da proposta para adequa\xE7\xE3o, em sua ativa\xE7\xE3o e desativa\xE7\xE3o. Confirma?', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	          _this3.alterarProposta(item);
	        }).catch(function () {
	          _this3.$snotify.warning('Operação não realizada.');
	        });
	      } else {
	        this.$dialog.confirm('Confirma a altera\xE7\xE3o no edital simplificado? <b>Aten\xE7\xE3o</b>: <b>todas as propostas vinculadas</b> ao edital sofrer\xE3o altera\xE7\xE3o, sendo de responsabilidade do usu\xE1rio o acompanhamento do cronograma e da an\xE1lise para adequa\xE7\xE3o, em sua ativa\xE7\xE3o e desativa\xE7\xE3o. Confirma?', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	          _this3.alterarEdital(item);
	        }).catch(function () {
	          _this3.$snotify.warning('Operação não realizada.');
	        });
	      }
	    },
	    alterarProposta: function alterarProposta(item) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this4.loadingPesquisa = true;
	                _this4.$aguarde('Atualizando a proposta. Por favor, aguarde...');
	                obj = {
	                  idProposta: item.fk_proposta,
	                  usuario: _this4.usuarioLogado.ds_login + ' ' + _this4.usuarioLogado.ds_nome_usuario,
	                  alteracao: String(item.simplificado) === '0' ? '1' : '0'
	                };
	                _context3.next = 5;
	                return axiosLaravel.post('/simplificado/atualizarPropostaSimplificada', obj).then(function (response) {
	                  _this4.loadingPesquisa = false;
	                  if (response.data.codigo === 'ERRO') {
	                    _this4.$snotify.clear();
	                    _this4.$snotify.error(response.data.mensagem);
	                    return;
	                  }
	                  _this4.$snotify.clear();
	                  _this4.$snotify.success(response.data.mensagem);
	                  _this4.consultaPropostaSimplificada();
	                }).catch(function (error) {
	                  _this4.$snotify.clear();
	                  _this4.$snotify.error('Erro na alteracao da proposta. Tente novamente mais tarde.');
	                  _this4.loadingPesquisa = false;
	                  console.log(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    },
	    alterarEdital: function alterarEdital(item) {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this5.loadingPesquisa = true;
	                _this5.$aguarde('Atualizando a proposta. Por favor, aguarde...');
	                obj = {
	                  idEdital: item.fk_edital,
	                  usuario: _this5.usuarioLogado.ds_login + ' ' + _this5.usuarioLogado.ds_nome_usuario,
	                  alteracao: String(item.simplificado) === '0' ? '1' : '0'
	                };
	
	                console.log(item);
	                console.log('OBJ', obj);
	                _context4.next = 7;
	                return axiosLaravel.post('/simplificado/atualizarEditalSimplificado', obj).then(function (response) {
	                  _this5.loadingPesquisa = false;
	                  if (response.data.codigo === 'ERRO') {
	                    _this5.$snotify.clear();
	                    _this5.$snotify.error(response.data.mensagem);
	                    return;
	                  }
	                  _this5.$snotify.clear();
	                  _this5.$snotify.success(response.data.mensagem);
	                  _this5.consultaPropostaSimplificada();
	                }).catch(function (error) {
	                  _this5.$snotify.clear();
	                  _this5.$snotify.error('Erro na alteracao da proposta. Tente novamente mais tarde.');
	                  _this5.loadingPesquisa = false;
	                  console.log(error);
	                });
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this5);
	      }))();
	    },
	    confirmarAdicaoEdital: function confirmarAdicaoEdital(item) {
	      var _this6 = this;
	
	      this.$dialog.confirm('Confirma o cadastro do edital? Lembrando que ao confirmar, todas as propostas vinculadas a ele <b>entrar\xE3o no processo simplificado</b> e \xE9 de responsabilidade do usu\xE1rio <b>monitorar</b> e <b>adequar</b> as propostas que j\xE1 passaram em algum momento pela fase de <b>an\xE1lise</b> ou que j\xE1 possuem <b>cronograma</b> f\xEDsico financeiro registrado.', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	        _this6.cadastraEdital(item);
	      }).catch(function () {
	        _this6.$snotify.warning('Operação não realizada.');
	      });
	    },
	    cadastraRegistroSimplificado: function cadastraRegistroSimplificado(item) {
	      if (this.tabSelect === 'Proposta') {
	        this.cadastraProposta(item);
	      } else {
	        this.confirmarAdicaoEdital(item);
	      }
	    },
	    cadastraProposta: function cadastraProposta(item) {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this7.loadingPesquisa = true;
	
	                _this7.$aguarde('Inserindo a proposta no modelo simplificado. Por favor, aguarde...');
	                obj = {
	                  idProposta: item.identificador,
	                  numero_projeto: item.numero_projeto,
	                  usuario: _this7.usuarioLogado.ds_login + ' ' + _this7.usuarioLogado.ds_nome_usuario,
	                  tipo: _this7.tabSelect
	                };
	                _context5.next = 5;
	                return axiosLaravel.post('/simplificado/cadastrarPropostaSimplificada', obj).then(function (response) {
	                  _this7.loadingPesquisa = false;
	                  if (response.data.codigo === 'ERRO') {
	                    _this7.$snotify.clear();
	                    _this7.$snotify.error(response.data.mensagem);
	                    return;
	                  }
	                  _this7.$snotify.clear();
	                  _this7.$snotify.success(response.data.mensagem);
	                  _this7.limparPesquisa();
	                  _this7.toggleNovoRegistro(false);
	                  _this7.consultaPropostaSimplificada();
	                }).catch(function (error) {
	                  _this7.$snotify.clear();
	                  _this7.$snotify.error('Erro no cadastro da proposta. Tente novamente mais tarde.');
	                  _this7.loadingPesquisa = false;
	                  console.log(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this7);
	      }))();
	    },
	    cadastraEdital: function cadastraEdital(item) {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                console.log('Cadastro edital ', item);
	                _this8.loadingPesquisa = true;
	
	                _this8.$aguarde('Inserindo a edital e suas propostas no modelo simplificado. Por favor, aguarde...');
	                obj = {
	                  idEdital: item.identificador,
	                  nome: item.nome,
	                  usuario: _this8.usuarioLogado.ds_login + ' ' + _this8.usuarioLogado.ds_nome_usuario,
	                  tipo: _this8.tabSelect
	                };
	                _context6.next = 6;
	                return axiosLaravel.post('/simplificado/cadastrarEditalSimplificado', obj).then(function (response) {
	                  _this8.loadingPesquisa = false;
	                  if (response.data.codigo === 'ERRO') {
	                    _this8.$snotify.clear();
	                    _this8.$snotify.error(response.data.mensagem);
	                    return;
	                  }
	                  _this8.$snotify.clear();
	                  _this8.$snotify.success(response.data.mensagem);
	                  _this8.limparPesquisa();
	                  _this8.toggleNovoRegistro(false);
	                  _this8.consultaPropostaSimplificada();
	                }).catch(function (error) {
	                  _this8.$snotify.clear();
	                  _this8.$snotify.error('Erro no cadastro do edital. Tente novamente mais tarde.');
	                  _this8.loadingPesquisa = false;
	                  console.log(error);
	                });
	
	              case 6:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this8);
	      }))();
	    }
	  }
	};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HistoricoProposta: _historicoProposta2.default
	  },
	  name: 'imprimir-proposta',
	  data: function data() {
	    return {
	      progressBar: {
	        stepAtual: null,
	        stepTotal: null,
	        tarefaAtual: null
	      },
	      loading: {
	        show: false
	      },
	      tel: '',
	      array: [],
	      esconder: true,
	      fluxo: {},
	      elementos: {
	        visivel: ''
	      },
	      carregou: false,
	      dirigentes: [],
	      documentosProposta: [],
	      bloqueiaBotoes: false,
	      ganttZoom: 1,
	      proposta: {
	        dataFinal: '',
	        totalProjeto: 0,
	        totalFBB: 0,
	        totalParc: 0,
	        totalCtrp: 0,
	        entidade: {},
	        documentos: {
	          proposta: []
	        }
	      },
	      formaJuridica: '',
	      componentKey: 0,
	      ultimaTarefaEntidade: {},
	      estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO']
	    };
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    parcelasAdiantamentoExibicao: function parcelasAdiantamentoExibicao() {
	      return this.consolidarParcelasAdiantamento(_.get(this.proposta, 'adiantamentos', []));
	    },
	    exibeDesdobramentoParcelas: function exibeDesdobramentoParcelas() {
	      return this.haParcelaMista(this.parcelasAdiantamentoExibicao);
	    },
	    totalParcelasAdiantamentoFundacao: function totalParcelasAdiantamentoFundacao() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_fbb');
	    },
	    totalParcelasAdiantamentoParceiro: function totalParcelasAdiantamentoParceiro() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_parc');
	    },
	    totalParcelasAdiantamentoGeral: function totalParcelasAdiantamentoGeral() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao);
	    }
	  }),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.$aguarde('Abrindo a proposta. Por favor, aguarde...');
	              _context.next = 3;
	              return _this.$root.buscaFormasJuridicas(_this.$store);
	
	            case 3:
	              axiosLaravel.post('processos/historico/', { 'id_proposta': _this.$route.params.id, 'tipo': 'USUARIO' }).then(function (response) {
	                _this.ultimaTarefaEntidade = _.last(_.sortBy(_.filter(response.data, function (t) {
	                  return t.nome === 'SOLICITACAO' || t.nome === 'REVISAO';
	                }), ['id']));
	
	                var rotaProposta = _.isUndefined(_this.ultimaTarefaEntidade) || _.isNull(_this.ultimaTarefaEntidade.termino) ? 'propostas/' + _this.$route.params.id : 'processos/tarefas/buscahistorico/' + _this.ultimaTarefaEntidade.id;
	
	                console.log('ROTA', rotaProposta);
	                axiosLaravel.get('propostas/' + _this.$route.params.id).then(function (response) {
	                  _this.proposta = response.data;
	                  _this.buscaEntidades();
	                  _this.buscaFluxo();
	                  _this.proposta.totalProjeto = _this.totalizar(0);
	                  _this.proposta.totalFBB = _this.totalizar(1);
	                  _this.proposta.totalParc = _this.totalizar(5);
	                  _this.proposta.totalCtrp = _this.totalizar(2);
	                  _this.proposta.dataFinal = (0, _moment2.default)(_this.ehNulo(_this.proposta.dt_assinatura_convenio, _this.proposta.dt_data_inicial)).add(_this.proposta.nr_periodos, 'M').format('MM/YYYY');
	                  _this.ganttZoom = parseInt(_this.proposta.nr_periodos) > 24 ? 1 - (parseInt(_this.proposta.nr_periodos) - 24) * 0.035 : 1;
	                  _this.$forceUpdate();
	                  _this.carregou = true;
	                  _this.$snotify.clear();
	                  var codigo = _this.proposta.entidade.fk_forma_juridica;
	                  var descricao = _this.ehNulo(_.find(_this.$store.state.formasJuridicas, ['codigo', codigo])['descricao'], '!');
	                  _this.formaJuridica = codigo + ' - ' + descricao;
	                  setTimeout(function () {
	                    _this.$snotify.success('Proposta carregada com sucesso!', { timeout: 4000 });
	                  }, 4000);
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    closewindow: function closewindow() {
	      close();
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    haObjetivoMeta: function haObjetivoMeta(listaOrigem, vinculo, descricao) {
	      var c = 0;
	      _.forEach(_.map(listaOrigem, vinculo), function (o) {
	        _.forEach(o, function (d) {
	          c += _.has(d, 'ds_descricao') && d.ds_descricao === descricao || _.has(d, 'descricao') && d.descricao === descricao ? 1 : 0;
	        });
	      });
	      return c > 0;
	    },
	    totalizar: function totalizar(origem) {
	      var t = 0;
	      _.forEach(this.proposta.atividades, function (a) {
	        t += _.sumBy(a.itens_orcamentos, function (i) {
	          return '' + origem === '0' ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : '' + origem === ('' + i.origem).substr(0, 1) ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : 0;
	        });
	      });
	      return t;
	    },
	    mostrarRef: function mostrarRef(ref) {
	      return _.filter(this.elementos, function (item) {
	        return item.nome === ref;
	      }).some(function (item) {
	        return item.visivel;
	      });
	    },
	    buscaEntidades: function buscaEntidades() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var currentDate, hoje;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                currentDate = new Date();
	                hoje = (0, _moment2.default)(currentDate).format('YYYYMMDD');
	                _context3.next = 4;
	                return axiosLaravel.get('entidades/' + _this2.proposta.entidade.id).then(function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(response) {
	                    var representantesValidos;
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            _this2.proposta.entidade = response.data;
	                            representantesValidos = [];
	
	                            _.forEach(response.data.dirigentes, function (o) {
	                              if (o.bt_assinatura_entidade === 1 && o.bt_ativo === 1 && o.bt_representante_legal === 1 && o.bt_assinatura_requerida === 1) {
	                                var dataInicial = (0, _moment2.default)(o.dt_inicio_mandato).format('YYYYMMDD');
	                                var dataFinal = (0, _moment2.default)(o.dt_fim_mandato).format('YYYYMMDD');
	                                if (dataInicial <= hoje && hoje <= dataFinal) {
	                                  o.ds_cpf = ('00000000000' + o.ds_cpf).slice(-11);
	                                  representantesValidos.push(o);
	                                }
	                              }
	                            });
	                            _this2.proposta.entidade.dirigentes = representantesValidos;
	                            _this2.$forceUpdate;
	
	                          case 5:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  if (error) {
	                    _this2.$snotify.clear();
	                    _this2.$root.trataErro(error);
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }))();
	    },
	    buscaFluxo: function buscaFluxo() {
	      var _this3 = this;
	
	      axiosLaravel.post('fluxo/', { 'id_proposta': this.$route.params.id, 'atividade': 'SOLICITACAO' }).then(function (response) {
	        _this3.fluxo = response.data;
	        _this3.elementos = _this3.fluxo.elementos;
	        _this3.loading.show = false;
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    irTopo: function irTopo() {
	      var _this4 = this;
	
	      this.$nextTick(function () {
	        _this4.$refs['topo'].scrollIntoView();
	      });
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    },
	    onDownloadZIP: function onDownloadZIP() {
	      console.log('this.$route.params.id: ', this.$route.params.id);
	      var propostaEncodedBase64 = btoa(this.$route.params.id);
	      window.open('https://projetos.fbb.org.br:5443/edital/proposta/' + propostaEncodedBase64 + '/arquivos', '_blank');
	    }
	  }
	};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HistoricoProposta: _historicoProposta2.default
	  },
	  name: 'imprimir-proposta',
	  data: function data() {
	    return {
	      progressBar: {
	        stepAtual: null,
	        stepTotal: null,
	        tarefaAtual: null
	      },
	      loading: {
	        show: false
	      },
	      tel: '',
	      array: [],
	      esconder: true,
	      fluxo: {},
	      elementos: {
	        visivel: ''
	      },
	      carregou: false,
	      dirigentes: [],
	      documentosProposta: [],
	      bloqueiaBotoes: false,
	      ganttZoom: 1,
	      proposta: {
	        dataFinal: '',
	        totalProjeto: 0,
	        totalFBB: 0,
	        totalParc: 0,
	        totalCtrp: 0,
	        entidade: {},
	        documentos: {
	          proposta: []
	        }
	      },
	      formaJuridica: '',
	      componentKey: 0,
	      ultimaTarefaEntidade: {},
	      estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO']
	    };
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.$aguarde('Abrindo a proposta. Por favor, aguarde...');
	              _context.next = 3;
	              return _this.$root.buscaFormasJuridicas(_this.$store);
	
	            case 3:
	              axiosLaravel.post('apieditais/processos/historico/', { 'id_proposta': atob(_this.$route.params.id), 'tipo': 'USUARIO' }).then(function (response) {
	                _this.ultimaTarefaEntidade = _.last(_.sortBy(_.filter(response.data, function (t) {
	                  return t.nome === 'SOLICITACAO' || t.nome === 'REVISAO';
	                }), ['id']));
	
	                var rotaProposta = _.isUndefined(_this.ultimaTarefaEntidade) || _.isNull(_this.ultimaTarefaEntidade.termino) ? 'propostas/' + _this.$route.params.id : 'processos/tarefas/buscahistorico/' + _this.ultimaTarefaEntidade.id;
	
	                console.log('ROTA', rotaProposta);
	                axiosLaravel.get('apieditais/propostas/' + atob(_this.$route.params.id) + '?token=zy47ULqcilUO1MS3SJR43zGsukVDhUvZG6MzrImYyeYgbhthkmO33S9TuX1RR30f').then(function (response) {
	                  _this.proposta = response.data;
	                  _this.buscaEntidades();
	                  _this.buscaFluxo();
	                  _this.proposta.totalProjeto = _this.totalizar(0);
	                  _this.proposta.totalFBB = _this.totalizar(1);
	                  _this.proposta.totalParc = _this.totalizar(5);
	                  _this.proposta.totalCtrp = _this.totalizar(2);
	                  _this.proposta.dataFinal = (0, _moment2.default)(_this.ehNulo(_this.proposta.dt_assinatura_convenio, _this.proposta.dt_data_inicial)).add(_this.proposta.nr_periodos, 'M').format('MM/YYYY');
	                  _this.ganttZoom = parseInt(_this.proposta.nr_periodos) > 24 ? 1 - (parseInt(_this.proposta.nr_periodos) - 24) * 0.035 : 1;
	                  _this.$forceUpdate();
	                  _this.carregou = true;
	                  _this.$snotify.clear();
	                  var codigo = _this.proposta.entidade.fk_forma_juridica;
	                  var descricao = _this.ehNulo(_.find(_this.$store.state.formasJuridicas, ['codigo', codigo])['descricao'], '!');
	                  _this.formaJuridica = codigo + ' - ' + descricao;
	                  setTimeout(function () {
	                    _this.$snotify.success('Proposta carregada com sucesso!', { timeout: 4000 });
	                  }, 4000);
	                }).catch(function (error) {
	                  _this.$root.trataErro(error);
	                });
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    closewindow: function closewindow() {
	      close();
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    haObjetivoMeta: function haObjetivoMeta(listaOrigem, vinculo, descricao) {
	      var c = 0;
	      _.forEach(_.map(listaOrigem, vinculo), function (o) {
	        _.forEach(o, function (d) {
	          c += _.has(d, 'ds_descricao') && d.ds_descricao === descricao || _.has(d, 'descricao') && d.descricao === descricao ? 1 : 0;
	        });
	      });
	      return c > 0;
	    },
	    totalizar: function totalizar(origem) {
	      var t = 0;
	      _.forEach(this.proposta.atividades, function (a) {
	        t += _.sumBy(a.itens_orcamentos, function (i) {
	          return '' + origem === '0' ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : '' + origem === ('' + i.origem).substr(0, 1) ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : 0;
	        });
	      });
	      return t;
	    },
	    mostrarRef: function mostrarRef(ref) {
	      return _.filter(this.elementos, function (item) {
	        return item.nome === ref;
	      }).some(function (item) {
	        return item.visivel;
	      });
	    },
	    buscaEntidades: function buscaEntidades() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var currentDate, hoje;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                currentDate = new Date();
	                hoje = (0, _moment2.default)(currentDate).format('YYYYMMDD');
	                _context3.next = 4;
	                return axiosLaravel.get('apieditais/entidades/' + _this2.proposta.entidade.id + '?token=zy47ULqcilUO1MS3SJR43zGsukVDhUvZG6MzrImYyeYgbhthkmO33S9TuX1RR30f').then(function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(response) {
	                    var representantesValidos;
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            _this2.proposta.entidade = response.data;
	                            representantesValidos = [];
	
	                            _.forEach(response.data.dirigentes, function (o) {
	                              if (o.bt_assinatura_entidade === 1 && o.bt_ativo === 1 && o.bt_representante_legal === 1 && o.bt_assinatura_requerida === 1) {
	                                var dataInicial = (0, _moment2.default)(o.dt_inicio_mandato).format('YYYYMMDD');
	                                var dataFinal = (0, _moment2.default)(o.dt_fim_mandato).format('YYYYMMDD');
	                                if (dataInicial <= hoje && hoje <= dataFinal) {
	                                  o.ds_cpf = ('00000000000' + o.ds_cpf).slice(-11);
	                                  representantesValidos.push(o);
	                                }
	                              }
	                            });
	                            _this2.proposta.entidade.dirigentes = representantesValidos;
	                            _this2.$forceUpdate;
	
	                          case 5:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  if (error) {
	                    _this2.$snotify.clear();
	                    _this2.$root.trataErro(error);
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }))();
	    },
	    buscaFluxo: function buscaFluxo() {
	      var _this3 = this;
	
	      axiosLaravel.post('apieditais/fluxo/', { 'id_proposta': atob(this.$route.params.id), 'atividade': 'SOLICITACAO' }).then(function (response) {
	        _this3.fluxo = response.data;
	        _this3.elementos = _this3.fluxo.elementos;
	        _this3.loading.show = false;
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    irTopo: function irTopo() {
	      var _this4 = this;
	
	      this.$nextTick(function () {
	        _this4.$refs['topo'].scrollIntoView();
	      });
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    }
	  }
	};

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _arvoreProjeto = __webpack_require__(1689);
	
	var _arvoreProjeto2 = _interopRequireDefault(_arvoreProjeto);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ArvoreProjeto: _arvoreProjeto2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    'preProposta.dc_investimento': function prePropostaDc_investimento() {
	      if (this.preProposta.dc_investimento > 300000) {
	        this.preProposta.simplificado = false;
	      }
	    }
	  },
	  name: 'liberacao',
	  data: function data() {
	    return {
	      preProposta: {
	        tipo_documentos: [],
	        entidade: {
	          ds_nome: '',
	          ds_cnpj: ''
	        },
	        documentos: [],
	        ds_mensagem_entidades: '',
	        simplificado: false,
	        usuario: ''
	      },
	      loading: {
	        show: false
	      },
	      erro: false,
	      tipoDocumentos: [],
	      projetoDuplicacao: {},
	      restricoesAtivasEntidade: null,
	      restricoesAtivasProjetosDaEntidade: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loading.show = true;
	    axiosLaravel.get('entidades/' + this.$route.params.id).then(function (response) {
	      _this.preProposta.entidade = response.data;
	      _this.$forceUpdate();
	      _this.loading.show = false;
	      _this.verificaSeExisteRestricoesAtivas();
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	      _this.loading.show = false;
	    });
	    this.preProposta.ds_mensagem_entidades = 'Caro(a) parceiro(a),\n' + 'Comunicamos que, a partir deste momento, está autorizado o registro da proposta de projeto no Sistema de Gerenciamento de Projetos – SGP da Fundação BB.\n' + 'Lembrando que o acesso ao SGP é realizado por meio de login e senha e o registro da proposta somente é possível ser realizado por usuários previamente cadastrados (exceto o usuário vinculado ao CNPJ da instituição). \n' + '\n' + 'O registro dos dados da proposta deverá estar consonante com o acordado com a Fundação BB durante a fase de articulação do projeto.\n' + 'Deverão ser anexados no SGP:\n' + '•\t02 orçamentos de fornecedores distintos para cada item de despesa, inclusive das relativas à contrapartida. Os orçamentos deverão conter data da emissão, nome ou razão social, CPF ou CNPJ, endereço, telefone. Poderá ser aceito orçamento da internet, desde que os produtos não estejam em promoção e o documento apresente dados do site e data da consulta. \n' + '•\tNo caso de previsão de consultoria: anexar plano de trabalho, perfil do profissional e entregas previstas para o serviço a ser realizado. \n' + '•\tNo caso de previsão de obra civil: documento do terreno comprovando sua disponibilidade para a instituição proponente, planta baixa e memorial descritivo (assinados pelo profissional responsável pelo projeto de obra).\n' + '•\tNo caso de bens fixos de uso industrial: documento do terreno comprovando sua disponibilidade para a instituição proponente e declaração de que a estrutura é apropriada para a execução do projeto e instalação dos bens.\n' + '•\tDeclaração conforme modelo disponível no menu Manuais e Modelos do SGP.\n' + 'Estamos à disposição para esclarecimentos durante o preenchimento da proposta.\n\n' + 'Atenciosamente,\n' + 'Fundação Banco do Brasil\n' + 'Gerência de Análise e Avaliação\n';
	    this.preProposta.usuario = this.usuarioLogado.ds_login + ' ' + this.usuarioLogado.ds_nome_usuario;
	    if (this.localUso === undefined) {
	      this.localUso = 'TODOS';
	    }
	    axiosLaravel.post('documentos/tipos/' + this.localUso).then(function (response) {
	      _this.tipoDocumentos = response.data;
	      _this.buscaArquivosEsperados();
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this2 = this;
	
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this2.preProposta.tipo_documentos = response.data.configuracao_proposta.documentos_obrigatorios;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    atualizaProjetoDuplicacao: function atualizaProjetoDuplicacao(projeto) {
	      this.preProposta.nr_projeto_duplicacao = projeto.numprj;
	      this.preProposta.ds_projeto_duplicacao_descricao = projeto.nomprj;
	      this.$forceUpdate();
	    },
	    concluir: function concluir() {
	      var _this3 = this;
	
	      this.preProposta.ds_fase = 'CADASTRO';
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this3.$aguarde('Efetuando a liberação da proposta. Por favor, aguarde...');
	          axiosLaravel.post('/propostas/liberacao/', _this3.preProposta).then(function (response) {
	            _this3.$snotify.clear();
	            _this3.$snotify.success('Liberação da proposta efetuada com sucesso!');
	            setTimeout(function () {
	              _this3.$router.go(-1);
	            }, 2000);
	          }).catch(function (error) {
	            if (error) {
	              _this3.$snotify.clear();
	              _this3.$root.trataErro(error);
	            }
	          });
	        }
	      });
	    },
	    retiraAspas: function retiraAspas($event) {
	      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
	      if (keyCode === 39 || keyCode === 34) {
	        $event.preventDefault();
	      }
	    },
	    verificaSeExisteRestricoesAtivas: function verificaSeExisteRestricoesAtivas() {
	      var _this4 = this;
	
	      if (this.preProposta.entidade.id === 1439) {
	        return false;
	      }
	      axiosLaravel.post('consulta/ocorrencias/entidade/', { 'id_entidade': this.preProposta.entidade.id, 'tipo': 4, 'situacao_ocorrencia': 'vigentes' }).then(function (response) {
	        _this4.restricoesAtivasEntidade = response.data;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	      axiosLaravel.post('consulta/ocorrencias/projeto/', { 'id_entidade': this.preProposta.entidade.id, 'tipo': 3, 'situacao_ocorrencia': 'vigentes' }).then(function (response) {
	        _this4.restricoesAtivasProjetosDaEntidade = response.data;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFiltro = {
	  createdBy: null,
	  currentPage: 1,
	  pageSize: 20,
	  projectProposals: true
	};
	
	exports.default = {
	  name: 'lista-proposta',
	  data: function data() {
	    return {
	      loading: {
	        tela: false
	      },
	      hoje: new Date(),
	      enumeradores: { 'ANALISE': 'Análise', 'AUTORIZACAO': 'Autorização', 'REVISAO': 'Em Revisão - Análise', 'APROVADO': 'Aprovado', 'DEFERIMENTO': 'Deferimento', 'FORMALIZACAO': 'Formalização', 'APROVACAO_PROJETO': 'Aprovação', 'CADASTRO': 'Cadastro', '': 'Cadastro', 'ANULACAO': 'Anulado', 'ANULADO': 'Anulado' },
	      json_data: [],
	      json_fields: {
	        'CNPJ': 'ds_cnpj',
	        'Entidade': 'NomeEntidade',
	        'Nome da Proposta': 'ds_nome',
	        'Data de Inclusão': 'createdAt',
	        'Fase': 'ds_fase',
	        'Tipo': 'ds_numero_edital'
	      },
	      json_meta: [[{
	        'key': 'charset',
	        'value': 'utf-8'
	      }]],
	      filtro: defaultFiltro,
	      termoPesquisa: '',
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        table: 0,
	        currentPage: 1,
	        perPage: 20,
	        sortBy: 'id',
	        sortDesc: true,
	        fields: [{ key: 'NomeEntidade', label: 'Entidade', sortable: true, thStyle: 'text-align: left; width: 30%', class: 'text-left' }, { key: 'ds_nome', label: 'Proposta', sortable: true, thStyle: 'text-align: left; width: 30%', class: 'text-left' }, { key: 'dt_criado', label: 'Inclusão', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'ds_fase', label: 'Fase', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'ds_numero_edital', label: 'Tipo', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 225px !important', class: 'text-center' }]
	      },
	      simplificados: []
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    this.$snotify.clear();
	    this.filtro = {};
	  },
	  mounted: function mounted() {
	    this.$aguarde('Buscando propostas. Por favor, aguarde...');
	    this.pesquisaFiltro();
	  },
	
	  methods: {
	    onSearch: function onSearch() {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.get('propostas').then(function (response) {
	        _this.table.items = response.data;
	        _this.json_data = response.data.reverse();
	        _this.$forceUpdate();
	        _this.$snotify.clear();
	        _this.$snotify.success('Propostas carregadas com sucesso!', { timeout: 1000 });
	        for (var i = 0; i < _this.json_data.length; i++) {
	          _this.json_data[i].ds_cnpj = _this.json_data[i].ds_cnpj + ' ';
	          if (_this.json_data[i].ds_numero_edital === 'null') {
	            _this.json_data[i].createdAt = 'Prospecção Direta';
	          }
	          _this.json_data[i].createdAt = (0, _moment2.default)(_this.json_data[i].createdAt).format('DD/MM/YYYY');
	        }
	        _this.table.totalRows = _this.table.items.length;
	        _this.loading.tela = false;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    pesquisaFiltro: function pesquisaFiltro() {
	      var _this2 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('propostas/pesquisaFiltro/', { 'pesquisa': this.termoPesquisa }).then(function (response) {
	        _this2.table.items = response.data;
	        console.log('response.data', response.data);
	        _this2.json_data = response.data.reverse();
	        _this2.$forceUpdate();
	        _this2.$snotify.clear();
	        _this2.$snotify.success('Propostas carregadas com sucesso!', { timeout: 1000 });
	        for (var i = 0; i < _this2.json_data.length; i++) {
	          _this2.json_data[i].ds_cnpj = _this2.json_data[i].ds_cnpj + ' ';
	          if (_this2.json_data[i].ds_numero_edital === 'null') {
	            _this2.json_data[i].createdAt = 'Prospecção Direta';
	          }
	          _this2.json_data[i].createdAt = (0, _moment2.default)(_this2.json_data[i].createdAt).format('DD/MM/YYYY');
	        }
	        _this2.table.totalRows = _this2.table.items.length;
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    ehEdital: function ehEdital(proposta) {
	      return !_.isNil(proposta.idEdital);
	    },
	    ehEditalExcecao: function ehEditalExcecao(proposta) {
	      if (!_.isNil(proposta.idEdital)) {
	        if (proposta.idEdital === 12) {
	          return true;
	        }
	      } else {
	        return false;
	      }
	    },
	    editalComLimitacaoAcesso: function editalComLimitacaoAcesso(proposta) {
	      return _.get(proposta, 'opcoesEdital.acesso.antecipado', false);
	    },
	    ehEditalAtivoNaoFinalizado: function ehEditalAtivoNaoFinalizado(proposta) {
	      var dataTerminoEdital = _.get(proposta, 'dt_data_final');
	      if (proposta.bt_ativo !== 1 || !dataTerminoEdital) return false;
	
	      var termino = (0, _moment2.default)(dataTerminoEdital.substring(0, 10), 'YYYY-MM-DD').endOf('day');
	      return (0, _moment2.default)().isBefore(termino);
	    },
	    onCleanSearch: function onCleanSearch() {
	      this.filtro = {};
	      this.pesquisaFiltro();
	    },
	    editalParaRevisao: function editalParaRevisao(proposta) {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this3.loading.tela = true;
	                _context.next = 3;
	                return axiosLaravel.get('propostas/' + proposta.id).then(function (response) {
	                  _this3.$snotify.clear();
	                  console.log('proposta', response.data);
	                  var propostaObj = response.data;
	                  _this3.alteraTarefaPropostaEdital(propostaObj);
	                }).catch(function (error) {
	                  _this3.$snotify.clear();
	                  _this3.$root.trataErro(error);
	                  _this3.loading.tela = false;
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    alteraTarefaPropostaEdital: function alteraTarefaPropostaEdital(proposta) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var obj;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this4.loading.tela = true;
	                obj = {
	                  proximaEtapa: 'REVISAO',
	                  observacao: 'Voltando tarefa para revisão pela entidade',
	                  idProposta: proposta.id
	                };
	                _context2.next = 4;
	                return axiosLaravel.post('propostas/voltarRevisaoEdital/', obj).then(function (response) {
	                  _this4.$snotify.clear();
	                  console.log('resultado', response.data);
	                  _this4.$snotify.success(response.data);
	                  setTimeout(function () {
	                    window.location.reload();
	                  }, 5000);
	                  _this4.loading.tela = false;
	                }).catch(function (error) {
	                  _this4.$snotify.clear();
	                  _this4.$root.trataErro(error);
	                  _this4.loading.tela = false;
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this4);
	      }))();
	    }
	  }
	};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  components: {},
	  name: 'NavegadorProposta',
	  data: function data() {
	    return {
	      currentIndex: 0,
	      query: '',
	      io: null,
	      isSuggestOpen: false
	    };
	  },
	
	  props: {
	    ids: {
	      type: Array,
	      default: [{ id: 'teste', label: 'Teste' }],
	      required: true },
	    offset: {
	      type: String,
	      default: 0 },
	    behavior: {
	      type: String,
	      default: 'smooth',
	      validator: function validator(v) {
	        return ['smooth', 'auto'].includes(v);
	      }
	    }
	  },
	  computed: {
	    hasPrev: function hasPrev() {
	      return this.currentIndex > 0;
	    },
	    hasNext: function hasNext() {
	      return this.currentIndex < this.ids.length - 1;
	    },
	    suggestions: function suggestions() {
	      var q = (this.query || '').trim().toLowerCase();
	      if (!q) return [];
	
	      return this.ids.filter(function (x) {
	        return x.id.toLowerCase().includes(q) || x.label && x.label.toLowerCase().includes(q);
	      }).slice(0, 8);
	    }
	  },
	  created: function created() {
	    console.log('NAVEGADOR ON');
	  },
	  mounted: function mounted() {},
	  methods: {
	    onInput: function onInput() {
	      this.isSuggestOpen = !!this.query && this.suggestions.length > 0;
	    },
	    onSuggestionClick: function onSuggestionClick(item) {
	      var _this = this;
	
	      this.query = item.id;
	      this.isSuggestOpen = false;
	      this.$nextTick(function () {
	        return _this.goToQuery();
	      });
	    },
	    onEnterFromInput: function onEnterFromInput() {
	      var _this2 = this;
	
	      if (this.suggestions.length) {
	        var first = this.suggestions[0];
	        this.query = first.id;
	        this.isSuggestOpen = false;
	        this.$nextTick(function () {
	          return _this2.goToQuery();
	        });
	      } else {
	        this.isSuggestOpen = false;
	        this.goToQuery();
	      }
	    },
	    getElById: function getElById(id) {
	      return document.getElementById(id);
	    },
	    scrollToId: function scrollToId(id) {
	      var el = this.getElById(id);
	      if (!el) {
	        return;
	      }
	      var rect = el.getBoundingClientRect();
	      var top = window.pageYOffset + rect.top - this.offset;
	      window.scrollTo({
	        top: top,
	        behavior: this.behavior
	      });
	
	      var idx = this.ids.indexOf(id);
	      if (idx !== -1) this.currentIndex = idx;
	    },
	    home: function home() {
	      this.currentIndex = 0;
	      this.scrollToId(this.ids[this.currentIndex].id);
	      this.query = this.ids[this.currentIndex].label;
	    },
	    next: function next() {
	      if (!this.hasNext) return;
	      this.currentIndex += 1;
	      this.scrollToId(this.ids[this.currentIndex].id);
	      this.query = this.ids[this.currentIndex].label;
	    },
	    prev: function prev() {
	      if (!this.hasPrev) return;
	      this.currentIndex -= 1;
	      this.scrollToId(this.ids[this.currentIndex].id);
	      this.query = this.ids[this.currentIndex].label;
	    },
	    goToQuery: function goToQuery() {
	      if (!this.query) return;
	      var id = this.query;
	
	      var exact = this.ids.find(function (x) {
	        return x.id === id;
	      });
	      if (exact) {
	        this.scrollToId(exact.id);
	        this.query = exact.label;
	        var index = this.ids.findIndex(function (x) {
	          return x.id === exact.id;
	        });
	        this.currentIndex = index;
	        return;
	      }
	
	      var candidate = this.ids.find(function (x) {
	        return x.id.toLowerCase().startsWith(id.toLowerCase());
	      });
	      if (candidate) {
	        this.scrollToId(candidate.id);
	        this.query = candidate.label;
	        var _index = this.ids.findIndex(function (x) {
	          return x.id === candidate.id;
	        });
	        this.currentIndex = _index;
	      }
	    },
	    onKey: function onKey(e) {
	      var tag = e.target && e.target.tagName || '';
	      var isTyping = ['INPUT', 'TEXTAREA'].includes(tag);
	      if (isTyping && e.target !== this.$el.querySelector('.scroll-nav__input')) return;
	      if (e.key === 'ArrowDown') {
	        e.preventDefault();
	        this.next();
	      } else if (e.key === 'ArrowUp') {
	        e.preventDefault();
	        this.prev();
	      } else if (e.key === 'Enter') {
	        if (document.activeElement === this.$el.querySelector('.scroll-nav__input')) {
	          this.goToQuery();
	        }
	      }
	    },
	    setupObserver: function setupObserver() {
	      var _this3 = this;
	
	      if (!('IntersectionObserver' in window)) return;
	      try {
	        this.io = new IntersectionObserver(function (entries) {
	          var visible = entries.filter(function (en) {
	            return en.isIntersecting;
	          }).sort(function (a, b) {
	            return b.intersectionRatio - a.intersectionRatio;
	          })[0];
	          if (visible && visible.target && visible.target.id) {
	            var idx = _this3.ids.indexOf(visible.target.id);
	            if (idx !== -1) _this3.currentIndex = idx;
	          }
	        }, {
	          root: null,
	          rootMargin: '-' + this.offset + 'px 0px 0px 0px',
	          threshold: [0.25, 0.5, 0.75] });
	
	        this.ids.forEach(function (id) {
	          var el = _this3.getElById(id);
	          if (el) _this3.io.observe(el);
	        });
	      } catch (e) {
	        this.io = null;
	      }
	    },
	    teardownObserver: function teardownObserver() {
	      if (this.io) {
	        this.io.disconnect();
	        this.io = null;
	      }
	    }
	  }
	};

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HistoricoProposta: _historicoProposta2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default
	  },
	  name: 'plano-trabalho',
	  data: function data() {
	    return {
	      progressBar: {
	        stepAtual: null,
	        stepTotal: null,
	        tarefaAtual: null
	      },
	      loading: {
	        show: false
	      },
	      tel: '',
	      array: [],
	      esconder: true,
	      fluxo: {},
	      elementos: {
	        visivel: ''
	      },
	      carregou: false,
	      dirigentes: [],
	      documentosProposta: [],
	      bloqueiaBotoes: false,
	      ganttZoom: 1,
	      projetoPeriodos: 0,
	      proposta: {
	        projetoAprovado: false,
	        dataFinal: '',
	        totalProjeto: 0,
	        totalFBB: 0,
	        totalParc: 0,
	        totalCtrp: 0,
	        entidade: {},
	        documentos: {
	          proposta: []
	        }
	      },
	      formaJuridica: '',
	      componentKey: 0,
	      ultimaTarefaEntidade: {},
	      periodoMesAno: [],
	      estadoCivil: { 'SOLTEIRO': 'Solteiro(a)', 'CASADO': 'Casado(a)', 'DIVORCIADO': 'Divorciado(a)', 'VIUVO': 'Viúvo(a)' },
	      meses: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
	      estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
	
	      dataInicioExecucao: '',
	      dataFimExecucao: ''
	    };
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    parcelasAdiantamentoExibicao: function parcelasAdiantamentoExibicao() {
	      return this.consolidarParcelasAdiantamento(this.proposta.adiantamentos || []);
	    },
	    exibeDesdobramentoParcelas: function exibeDesdobramentoParcelas() {
	      return this.haParcelaMista(this.parcelasAdiantamentoExibicao);
	    },
	    totalParcelasAdiantamentoFundacao: function totalParcelasAdiantamentoFundacao() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_fbb');
	    },
	    totalParcelasAdiantamentoParceiro: function totalParcelasAdiantamentoParceiro() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_parc');
	    },
	    totalParcelasAdiantamentoGeral: function totalParcelasAdiantamentoGeral() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao);
	    }
	  }),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.$aguarde('Abrindo a proposta. Por favor, aguarde...');
	
	              axiosLaravel.get('projeto/id/' + _this.$route.params.id).then(function (response) {
	                _this.proposta = response.data;
	                _this.proposta['projetoAprovado'] = _.has(_this.proposta, 'ds_situacao_erp') && !_.isNull(_this.proposta.ds_situacao_erp) && !_.includes(['ANA', 'DEF', 'ANU', 'CAN', 'IND', 'ENC', 'DLG', 'JUD', 'OPE'], _this.proposta.ds_situacao_erp);
	
	                if (!_this.proposta['projetoAprovado'] && !_.isNull(response.data.snapshot)) {
	                  _this.proposta = response.data.snapshot;
	                }
	                _this.projetoPeriodos = _this.proposta.nr_periodos;
	                _this.buscaEntidades();
	                _this.buscaFluxo();
	                _this.proposta.totalFBB = _this.totalizar('1');
	                _this.proposta.totalParc = _this.totalizar('5');
	                _this.proposta.totalCtrp = _this.totalizar('2');
	                _this.proposta.totalProjeto = _this.proposta.totalFBB + _this.proposta.totalParc + _this.proposta.totalCtrp;
	
	                _this.dataInicioExecucao = _.includes(['ANA', 'DEF'], _this.proposta.ds_situacao_erp) ? _this.proposta.dt_data_inicial : _this.ehNulo(_this.proposta.dt_assinatura_convenio, _this.proposta.dt_data_inicial);
	                _this.dataFimExecucao = (0, _moment2.default)(_this.dataInicioExecucao).add(_this.proposta.nr_periodos, 'M').format('MM/YYYY');
	                _this.proposta.dataFinal = (0, _moment2.default)(_this.ehNulo(_this.proposta.dt_assinatura_convenio, _this.proposta.dt_data_inicial)).add(_this.proposta.nr_periodos, 'M').format('MM/YYYY');
	                _this.ganttZoom = parseInt(_this.proposta.nr_periodos) > 24 ? 1 - (parseInt(_this.proposta.nr_periodos) - 24) * 0.035 : 1;
	                _this.equivalenciaPeriodoMesAno();
	
	                for (var a in _this.proposta.atividades) {
	                  var atv = _this.proposta.atividades[a];
	                  if (_.has(atv, 'itens_orcamentos')) {
	                    for (var i in atv.itens_orcamentos) {
	                      var ite = atv.itens_orcamentos[i];
	
	                      if ('' + ite.origem === '2') {
	                        ite['orcamentos_mensalizados'] = [{
	                          'periodo': parseInt(ite.nr_periodo_final),
	                          'quantidade': parseFloat(ite.quantidade),
	                          'valor': parseFloat(ite.quantidade) * parseFloat(ite.valor_unitario)
	                        }];
	                      } else {
	                        if (ite.item['ds_type'] === 'PRODUTO') {
	                          ite['orcamentos_mensalizados'] = [{
	                            'periodo': parseInt(_.has(ite, 'periodo_inicial') ? ite.periodo_inicial : ite.nr_periodo_inicial),
	                            'quantidade': parseFloat(ite.quantidade),
	                            'valor': parseFloat(ite.quantidade) * parseFloat(ite.valor_unitario)
	                          }];
	                        } else {
	                          var meses = parseInt(_.has(ite, 'periodo_final') ? ite.periodo_final : ite.nr_periodo_final) - parseInt(_.has(ite, 'periodo_inicial') ? ite.periodo_inicial : ite.nr_periodo_inicial) + 1;
	                          var parcValor = parseInt(parseFloat(ite.quantidade) * parseFloat(ite.valor_unitario) / meses);
	                          var parcQtde = parseInt(parseFloat(ite.quantidade) / meses);
	                          var difValor = parseFloat(ite.quantidade) * parseFloat(ite.valor_unitario) - parcValor * meses;
	                          var difQtde = parseFloat(ite.quantidade) - parcQtde * meses;
	                          ite['orcamentos_mensalizados'] = [];
	                          for (var p = 1; p <= meses; p++) {
	                            var orcMes = {
	                              'periodo': parseInt(_.has(ite, 'periodo_inicial') ? ite.periodo_inicial : ite.nr_periodo_inicial) + p - 1,
	                              'quantidade': p === meses ? parcQtde + difQtde : parcQtde,
	                              'valor': p === meses ? parcValor + difValor : parcValor
	                            };
	                            ite.orcamentos_mensalizados.push(orcMes);
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	
	                _this.$forceUpdate();
	                _this.carregou = true;
	                _this.$snotify.clear();
	                setTimeout(function () {
	                  _this.$snotify.success('Proposta carregada com sucesso!', { timeout: 4000 });
	                  if (_this.$route.query.print) {
	                    _this.imprimirRelatorio();
	                  }
	                }, 4000);
	              }).catch(function (error) {
	                _this.$root.trataErro(error);
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    closewindow: function closewindow() {
	      close();
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    equivalenciaPeriodoMesAno: function equivalenciaPeriodoMesAno() {
	      var inicio = new Date(this.ehNulo(this.proposta.dt_assinatura_convenio, this.proposta.dt_data_inicial).toString());
	      var mes = parseInt(inicio.getMonth() + 1);
	      var ano = parseInt(inicio.getFullYear());
	      for (var p = 1; p <= parseInt(this.proposta.nr_periodos); p++) {
	        this.periodoMesAno.push({ 'periodo': p, 'ano': ano, 'mes': mes });
	        ano += mes === 12 ? 1 : 0;
	        mes += mes === 12 ? -11 : 1;
	      }
	    },
	    haObjetivoMeta: function haObjetivoMeta(listaOrigem, vinculo, descricao) {
	      var c = 0;
	      _.forEach(_.map(listaOrigem, vinculo), function (o) {
	        _.forEach(o, function (d) {
	          c += _.has(d, 'ds_descricao') && d.ds_descricao === descricao || _.has(d, 'descricao') && d.descricao === descricao ? 1 : 0;
	        });
	      });
	      return c > 0;
	    },
	    desembolsoMesAno: function desembolsoMesAno(obj, ano, mes, tipo) {
	      var mesAno = _.find(this.periodoMesAno, { 'ano': parseInt(ano), 'mes': parseInt(mes) });
	      if (_.isUndefined(mesAno)) {
	        return '-';
	      } else {
	        var itens = obj;
	        if (_.has(obj, 'itens_orcamentos')) {
	          itens = obj.itens_orcamentos;
	        }
	
	        if (_.isEmpty(itens) || itens.length === 0) {
	          return '*';
	        } else {
	          if (_.isArray(itens)) {
	            var total = _.sumBy(itens, function (ite) {
	              return _.sumBy(ite.orcamentos_mensalizados, function (iVQ) {
	                return iVQ.periodo === mesAno.periodo ? iVQ[tipo] : 0;
	              });
	            });
	            return total === 0 ? '-' : total;
	          } else {
	            var _total = _.sumBy(obj.orcamentos_mensalizados, function (iVQ) {
	              return iVQ.periodo === mesAno.periodo ? iVQ[tipo] : 0;
	            });
	            return _total === 0 ? '-' : _total;
	          }
	        }
	      }
	    },
	    totalizar: function totalizar(origem) {
	      var t = 0;
	      _.forEach(this.proposta.atividades, function (a) {
	        t += _.sumBy(a.itens_orcamentos, function (i) {
	          return origem === ('' + i.origem).substr(0, 1) ? _.has(i, 'orcamentos_mensalizados') ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : 0;
	        });
	      });
	      return t;
	    },
	    mostrarRef: function mostrarRef(ref) {
	      return _.filter(this.elementos, function (item) {
	        return item.nome === ref;
	      }).some(function (item) {
	        return item.visivel;
	      });
	    },
	    buscaEntidades: function buscaEntidades() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var isTrue, currentDate, hoje;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                isTrue = function isTrue(v) {
	                  return v === true || v === 1 || v === '1' || v === 'true';
	                };
	
	                currentDate = new Date();
	                hoje = (0, _moment2.default)(currentDate).format('YYYYMMDD');
	                _context2.next = 5;
	                return axiosLaravel.get('entidades/' + _this2.proposta.entidade.id).then(function (response) {
	                  _this2.proposta.entidade = response.data;
	                  var codigo = _this2.proposta.entidade.fk_forma_juridica;
	                  var descricao = _this2.ehNulo(_.find(_this2.$store.state.formasJuridicas, ['codigo', codigo])['descricao'], '!');
	                  _this2.formaJuridica = codigo + ' - ' + descricao;
	                  var array = _.filter(_this2.proposta.entidade.dirigentes, function (o) {
	                    if (isTrue(o.bt_assinatura_entidade) && isTrue(o.bt_ativo) && isTrue(o.bt_representante_legal) && isTrue(o.bt_assinatura_requerida)) {
	                      var dataInicial = (0, _moment2.default)(o.dt_inicio_mandato).format('YYYYMMDD');
	                      var dataFinal = (0, _moment2.default)(o.dt_fim_mandato).format('YYYYMMDD');
	                      if (dataInicial <= hoje && hoje <= dataFinal) {
	                        return o;
	                      }
	                    }
	                  });
	                  _this2.dirigentes = array;
	                  _this2.$forceUpdate;
	                }).catch(function (error) {
	                  if (error) {
	                    _this2.$snotify.clear();
	                    _this2.$root.trataErro(error);
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    buscaFluxo: function buscaFluxo() {
	      var _this3 = this;
	
	      axiosLaravel.post('fluxo/', { 'id_proposta': this.proposta.id, 'atividade': 'SOLICITACAO' }).then(function (response) {
	        _this3.fluxo = response.data;
	        _this3.elementos = _this3.fluxo.elementos;
	        _this3.loading.show = false;
	        _this3.$forceUpdate();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    irTopo: function irTopo() {
	      var _this4 = this;
	
	      this.$nextTick(function () {
	        _this4.$refs['topo'].scrollIntoView();
	      });
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    },
	    atualizarPrazoExecucao: function atualizarPrazoExecucao(e) {
	      if (e.target.value < this.projetoPeriodos) e.target.value = this.projetoPeriodos;
	      if (e.target.value > this.proposta.periodo_vigencia) e.target.value = this.proposta.periodo_vigencia;
	
	      this.proposta.nr_periodos = parseInt(e.target.value);
	      this.dataInicioExecucao = this.proposta.ds_situacao_erp !== 'ANA' || 'DEF' ? this.proposta.dt_data_inicial : this.ehNulo(this.proposta.dt_assinatura_convenio, this.proposta.dt_data_inicial);
	
	      this.dataFimExecucao = (0, _moment2.default)(this.dataInicioExecucao).add(this.proposta.nr_periodos, 'M').format('MM/YYYY');
	    }
	  }
	};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentos: _uploadDocumentos2.default,
	    PublicoAlvo: _publicoAlvo2.default },
	  name: 'simplificada',
	  data: function data() {
	    return {
	      entity: {},
	      procSelecionado: null,
	      processoSimplificado: null,
	      simplificados: [],
	      simplificado: [],
	      configuracoes: {},
	      propostaSimplificada: {
	        documents: [],
	        documentStatements: [],
	        audiences: []
	      },
	      filtros: {
	        beginAdded: null,
	        beginAddedDate: null,
	        endAddedDate: null,
	        beginInactivateDate: null,
	        endInactivateDate: null,
	        type: null
	      },
	      agencias: [],
	      processos: [],
	      processo: [],
	      agenciaSelecionada: null,
	      documentos: [],
	      documentosObrigatorios: ['Memória de cálculo', 'Declaração'],
	      adimplenciaObrigatoria: ['Declaração de Adimplência e Inexistência de outras fontes']
	    };
	  },
	  created: function created() {
	    this.buscaSimplificado();
	    this.buscaEntidade();
	    this.buscaConfiguracoes();
	    this.buscaAgencias();
	    this.buscaDocumentos();
	    this.buscaTodosDctos();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    agenciaSelecionada: function agenciaSelecionada() {
	      this.propostaSimplificada.agencyName = this.agenciaSelecionada.name;
	      this.buscaAgencia(this.agenciaSelecionada.code);
	    }
	  },
	  methods: {
	    buscaEntidade: function buscaEntidade() {
	      var _this = this;
	
	      axios.get('proxy/account/entities/' + this.$route.params.id).then(function (response) {
	        _this.entity = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaConfiguracoes: function buscaConfiguracoes() {
	      var _this2 = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this2.configuracoes = response.data.value;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscaAgencias: function buscaAgencias(searchQuery) {
	      var _this3 = this;
	
	      var filter = null;
	      if (searchQuery) {
	        filter = searchQuery;
	      }
	      axios.post('proxy/account/agencies/tiny/list', filter).then(function (response) {
	        _this3.agencias = response.data.value;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    numeroNomeAgencia: function numeroNomeAgencia(_ref) {
	      var code = _ref.code,
	          name = _ref.name;
	
	      return code + ' / ' + name;
	    },
	    selectFuncionario: function selectFuncionario(matricula) {
	      var _this4 = this;
	
	      axios.post('proxy/project/proposal/search/func/' + matricula).then(function (response) {
	        var funcionario = response.data.value[0];
	        _this4.propostaSimplificada.employeeName = funcionario.NomeFunc;
	        _this4.propostaSimplificada.employeePhone = funcionario.DddAge + funcionario.TelAge;
	        _this4.propostaSimplificada.employeeEmail = 'F' + funcionario.MatrFunc + '@bb.com.br';
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    buscaSimplificado: function buscaSimplificado() {
	      var _this5 = this;
	
	      axios.get('proxy/document/simplified/active/list').then(function (response) {
	        _this5.processos = response.data.value;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    escolhido: function escolhido() {
	      this.procSelecionado = this.processos.simplifiedNumber.simplifiedNumber;
	      this.propostaSimplificada.simplified = this.processos.simplifiedNumber.id;
	    },
	    buscaAgencia: function buscaAgencia(agencia) {
	      var _this6 = this;
	
	      axios.post('proxy/project/proposal/search/agencia/' + agencia).then(function (response) {
	        var agencia = response.data.value[0];
	        _this6.propostaSimplificada.agencyAddress = agencia.EndAge;
	        _this6.propostaSimplificada.agencyCNPJ = agencia.CnpjAge;
	        _this6.propostaSimplificada.agencyEmail = agencia.CodAge.substr(0, agencia.CodAge.indexOf('-')) + '@BB.COM.BR';
	        _this6.propostaSimplificada.agencyName = agencia.NomAge;
	        _this6.propostaSimplificada.agencyPhone = agencia.TelAge;
	        _this6.propostaSimplificada.managerCity = agencia.MunGer;
	        _this6.propostaSimplificada.managerCivilStatus = agencia.EcGer;
	        _this6.propostaSimplificada.managerCpf = agencia.CpfGer;
	        _this6.propostaSimplificada.managerName = agencia.NomGer;
	        _this6.propostaSimplificada.managerNationality = 'Brasileiro';
	        _this6.propostaSimplificada.managerOccupation = 'Bancário';
	        _this6.propostaSimplificada.managerRg = agencia.RgGer.split(' - ')[0];
	        _this6.propostaSimplificada.managerRgIssuer = agencia.RgGer.split(' - ')[1];
	        _this6.propostaSimplificada.managerRgUF = agencia.RgGer.split(' - ')[2].replace(/\s/g, '');
	        _this6.propostaSimplificada.managerUf = agencia.UfGer;
	
	        _this6.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this6.$root.trataErro(error);
	      });
	    },
	    buscaDocumentos: function buscaDocumentos() {
	      var _this7 = this;
	
	      axios.get('proxy/account/config/general-system-config').then(function (response) {
	        _this7.documentos = response.data.value.proposalConfig.documentTypes;
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    buscaTodosDctos: function buscaTodosDctos() {
	      var _this8 = this;
	
	      this.filtros.type = 'Declaração de Adimplência e Inexistência de outras fontes';
	      axios.post('proxy/document/documents/type/search', this.filtros).then(function (response) {
	        _this8.adimplencia = response.data.value;
	        _this8.totalRows = _this8.items.length;
	        _this8.loading.show = false;
	        _this8.filtros = {};
	      }).catch(function (error) {
	        _this8.$root.trataErro(error);
	      });
	    },
	    verificaDocumentosCarregados: function verificaDocumentosCarregados() {
	      if (this.propostaSimplificada.documents.length === this.documentos.length) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    validaPublicoAlvo: function validaPublicoAlvo() {
	      if (this.propostaSimplificada.audiences && this.propostaSimplificada.audiences.length > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    verificaDeclaracaoAdimplencia: function verificaDeclaracaoAdimplencia() {
	      if (this.propostaSimplificada.documentStatements.length > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    onConclude: function onConclude() {
	      var _this9 = this;
	
	      if (!this.verificaDeclaracaoAdimplencia()) {
	        this.$snotify.error('Existe Declaração de Adimplência pendentes!');
	        return;
	      }
	      if (!this.validaPublicoAlvo()) {
	        this.$snotify.error('É obrigatório o preenchimento do público-alvo!');
	        return;
	      }
	      if (!this.verificaDocumentosCarregados()) {
	        this.$snotify.error('Existem documentos pendentes');
	        return;
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this9.propostaSimplificada.documentTypes = _this9.documentos;
	          _this9.propostaSimplificada.createdBy = _this9.usuarioLogado;
	          _this9.propostaSimplificada.entity = _this9.entity;
	          _this9.propostaSimplificada.proposalPhase = 'CADASTRO';
	          axios.post('proxy/project/proposal/simplified', _this9.propostaSimplificada).then(function (response) {
	            _this9.$snotify.success('Proposta simplificada cadastrada com sucesso');
	            setTimeout(function () {
	              _this9.$router.push({ name: 'cadastro-entidade-lista' });
	            }, 2000);
	          }).catch(function (error) {
	            console.log('error', error);
	            _this9.$root.trataErro(error);
	          });
	        } else {
	          _this9.$snotify.error('Existem pendências no formulário. Favor verificar');
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _emiteDocumento = __webpack_require__(270);
	
	var _emiteDocumento2 = _interopRequireDefault(_emiteDocumento);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ImpressaoRel',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      totais: {
	        fbb: {
	          aprovado: 0,
	          atual: 0
	        },
	        contrapartida: {
	          aprovado: 0,
	          atual: 0
	        },
	        parceiro: {
	          aprovado: 0,
	          atual: 0
	        },
	        aprovado: 0,
	        atual: 0
	      },
	      relatorioAnalise: {},
	      briefing: false,
	      mostrarBriefing: false,
	      dadosBriefing: [{ id: 'sobreProjeto', nome: 'Sobre o Projeto', disabled: true }, { id: 'dadosEntidade', nome: 'Dados da Entidade', disabled: false }, { id: 'dadosProjeto', nome: 'Dados do Projeto', disabled: false }, { id: 'infosProjeto', nome: 'Informações do Projeto', disabled: false }, { id: 'analiseProjeto', nome: 'Análise do Projeto', disabled: false }],
	      selecionadosBriefing: ['sobreProjeto'],
	      botaoClicado: false,
	      titulo: '',
	      projetos: [],
	      proposta: {},
	      projetoSelecionado: null,
	      enderecoSnapshot: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    console.clear();
	    this.loading.show = true;
	    this.$aguarde('Listando propostas. Por favor, aguarde...');
	    axiosLaravel.get('propostas').then(function (response) {
	      _this.projetos = _.sortBy(response.data, 'ds_nome');
	
	      _this.$snotify.clear();
	      _this.loading.show = false;
	      _this.$forceUpdate();
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    etiquetaProjeto: function etiquetaProjeto(option) {
	      if (option.ds_codigo_projeto_erp === null) {
	        option.ds_codigo_projeto_erp = '00000';
	      }
	      return '' + (_.has(option, 'ds_codigo_projeto_erp') ? option.ds_codigo_projeto_erp + ' - ' : '') + option.ds_nome + ' | ' + option.ds_cnpj + ' - ' + option.NomeEntidade;
	    },
	    onSelect: function onSelect(evento) {
	      if (evento.relatorio_analise === null) {
	        this.titulo = 'A proposta não possui relatório de análise salvo no sistema.';
	      } else {
	        this.titulo = 'A proposta possui relatório de análise salvo no sistema.';
	      }
	    },
	    buscaSnapshot: function buscaSnapshot() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return axiosLaravel.post('propostas/snapshotProposta', { 'idEntidade': _this2.projetoSelecionado.idEntidade }).then(function (response) {
	                  _this2.proposta = JSON.parse(response.data.snapshot);
	                }).catch(function (error) {
	                  console.log(error);
	                  _this2.$snotify.clear();
	                  _this2.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    totalizar: function totalizar(origem) {
	      var t = 0;
	      _.forEach(this.proposta.atividades, function (a) {
	        t += _.sumBy(a.itens_orcamentos, function (i) {
	          return '' + origem === '0' ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : '' + origem === ('' + i.origem).substr(0, 1) ? parseFloat(i.quantidade) * parseFloat(i.valor_unitario) : 0;
	        });
	      });
	      return t;
	    },
	    buscaEndereco: function buscaEndereco() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return axiosLaravel.get('entidades/ultimosnapshot/' + _this3.projetoSelecionado.idEntidade);
	
	              case 3:
	                response = _context2.sent;
	
	                _this3.enderecoSnapshot = response.data.endereco;
	                _context2.next = 11;
	                break;
	
	              case 7:
	                _context2.prev = 7;
	                _context2.t0 = _context2['catch'](0);
	
	                _this3.$snotify.clear();
	                _this3.$root.trataErro(_context2.t0);
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3, [[0, 7]]);
	      }))();
	    },
	    buscaCronograma: function buscaCronograma() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this4.loading = true;
	                _context3.next = 3;
	                return axiosLaravel.post('processos/cronograma/projeto/', {
	                  'proposta': _this4.proposta.id,
	                  'processo': 'PAGAMENTO',
	                  'aglutinado': 'Completo',
	                  'documento': 0 }).then(function (response) {
	                  var saldos = response.data;
	                  _this4.proposta.atividades.forEach(function (atividade) {
	                    if (atividade.itens_orcamentos.length !== 0) {
	                      atividade.itens_orcamentos.forEach(function (item) {
	                        item['valorOrcado'] = _.sumBy(item.orcamentos_mensalizados, function (vo) {
	                          return vo.valor;
	                        });
	
	                        item['valorSaldo'] = _.sumBy(saldos.itens, function (vs) {
	                          return item.id === vs['Id_item'] ? vs['Valor_saldo'] : 0;
	                        });
	
	                        var valorOrcado = _.sumBy(saldos.itens, function (i) {
	                          return item.id === i['Id_item'] ? i['Valor_orcado'] : 0;
	                        });
	                        item['valorOrcado'] = item['valorOrcado'] !== valorOrcado ? valorOrcado : item['valorOrcado'];
	                      });
	                    }
	                  });
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this4.$root.trataErro(error);
	                });
	
	              case 3:
	                _this4.calculaTotais();
	                _this4.loading = false;
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    },
	    calculaTotais: function calculaTotais() {
	      var fbb = this.valorProjetoOrigem(1);
	      var contrapartida = this.valorProjetoOrigem(2);
	      var parceiro = this.valorProjetoOrigem(5);
	      this.totais.fbb.aprovado = fbb.aprovado;
	      this.totais.fbb.atual = fbb.atual;
	      this.totais.contrapartida.aprovado = contrapartida.aprovado;
	      this.totais.contrapartida.atual = contrapartida.atual;
	      this.totais.parceiro.aprovado = parceiro.aprovado;
	      this.totais.parceiro.atual = parceiro.atual;
	      this.totais.aprovado = fbb.aprovado + contrapartida.aprovado + parceiro.aprovado;
	      this.totais.atual = fbb.atual + contrapartida.atual + parceiro.atual;
	    },
	    valorProjetoOrigem: function valorProjetoOrigem(origem) {
	      var valorAprovado = 0;
	      var valorAtual = 0;
	      this.proposta.atividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos.length !== 0) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if (item.origem === origem) {
	              valorAprovado += parseFloat(item.valorOrcado);
	              valorAtual += parseFloat(item.valorSaldo);
	            }
	          });
	        }
	      });
	      return { aprovado: valorAprovado, atual: valorAtual };
	    },
	    buscaAnalise: function buscaAnalise() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return axiosLaravel.get('propostas/' + _this5.projetoSelecionado.id).then(function (response) {
	                  _this5.relatorioAnalise = JSON.parse(response.data.relatorio_analise);
	                }).catch(function (error) {
	                  _this5.$snotify.clear();
	                  _this5.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this5);
	      }))();
	    },
	    cancelarBriefing: function cancelarBriefing() {
	      this.botaoClicado = false;
	      this.mostrarBriefing = false;
	      this.selecionadosBriefing = ['sobreProjeto'];
	    },
	    gerarBriefing: function gerarBriefing() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var dadosBriefing, i, dados, endereco, temComplemento, _i;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this6.botaoClicado = true;
	                _this6.$aguarde('Gerando arquivo de briefing...');
	                _context5.next = 4;
	                return _this6.buscaSnapshot();
	
	              case 4:
	                _context5.next = 6;
	                return _this6.buscaAnalise();
	
	              case 6:
	                _this6.loading = true;
	                dadosBriefing = {
	                  temSobreProjeto: false,
	                  temDadosEntidade: false,
	                  temDadosProjeto: false,
	                  temInfosProjeto: false,
	                  temAnaliseProjeto: false,
	                  temRelatoriosProjeto: false,
	                  sobreProjeto: {},
	                  dadosEntidade: {},
	                  dadosProjeto: {},
	                  infosProjeto: {},
	                  analiseProjeto: {},
	                  relatoriosProjeto: {},
	                  data_hoje: (0, _moment2.default)().format('LL')
	                };
	                i = 0;
	
	              case 9:
	                if (!(i < _this6.selecionadosBriefing.length)) {
	                  _context5.next = 63;
	                  break;
	                }
	
	                dados = {};
	                _context5.t0 = _this6.selecionadosBriefing[i];
	                _context5.next = _context5.t0 === 'sobreProjeto' ? 14 : _context5.t0 === 'dadosEntidade' ? 18 : _context5.t0 === 'dadosProjeto' ? 39 : _context5.t0 === 'infosProjeto' ? 48 : _context5.t0 === 'analiseProjeto' ? 52 : _context5.t0 === 'relatoriosProjeto' ? 56 : 59;
	                break;
	
	              case 14:
	                dadosBriefing.temSobreProjeto = true;
	                dados = {
	                  nome_projeto: _this6.proposta.ds_nome,
	                  numero_projeto: _this6.proposta.ds_codigo_projeto_erp,
	                  status_projeto: _this6.proposta.ds_situacao_erp,
	                  data_inicial_projeto: (0, _moment2.default)(_this6.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').format('DD-MM-YYYY'),
	                  data_final_execucao_projeto: (0, _moment2.default)(_this6.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').add(_this6.proposta.nr_periodos, 'M').format('DD-MM-YYYY'),
	                  meses_projeto: _this6.proposta.nr_periodos,
	                  data_final_vigencia_projeto: (0, _moment2.default)(_this6.proposta.dt_data_vigencia, 'YYYY-MM-DD').format('DD-MM-YYYY'),
	                  meses_vigencia_projeto: _this6.proposta.periodo_vigencia,
	                  carteira_projeto: _this6.carteiraSelecionada ? _this6.carteiraSelecionada.usu_nomcart : 'Projeto não encarteirado',
	                  projeto_superior: _this6.proposta.ds_projeto_superior,
	                  origem_recurso_projeto: {
	                    total_FBB: _this6.$root.formataNumero(_this6.totalizar(1), 'moeda'),
	                    total_contrapartida: _this6.$root.formataNumero(_this6.totalizar(2), 'moeda'),
	                    total_parceiro: _this6.$root.formataNumero(_this6.totalizar(5), 'moeda'),
	                    total_projeto: _this6.$root.formataNumero(_this6.totalizar(0), 'moeda')
	                  }
	                };
	                (0, _assign2.default)(dadosBriefing.sobreProjeto, dados);
	                return _context5.abrupt('break', 60);
	
	              case 18:
	                dadosBriefing.temDadosEntidade = true;
	                _context5.prev = 19;
	                endereco = null;
	                temComplemento = false;
	
	                if (!(!_this6.proposta.entidade.endereco || !_this6.proposta.entidade.endereco[0])) {
	                  _context5.next = 28;
	                  break;
	                }
	
	                _context5.next = 25;
	                return _this6.buscaEndereco();
	
	              case 25:
	                endereco = _this6.enderecoSnapshot && _this6.enderecoSnapshot[0] ? _this6.enderecoSnapshot[0] : null;
	                _context5.next = 29;
	                break;
	
	              case 28:
	                endereco = _this6.proposta.entidade.endereco[0];
	
	              case 29:
	                temComplemento = endereco && endereco.ds_complemento ? endereco.ds_complemento.trim() !== '' : false;
	                dados = {
	                  nome_entidade: _this6.proposta.entidade.ds_nome,
	                  cnpj_entidade: _this6.proposta.entidade.ds_cnpj.replace(/^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})/, '$1.$2.$3/$4-$5'),
	                  endereco_rua: endereco ? endereco.ds_rua : 'não informado',
	                  endereco_numero: endereco ? endereco.ds_numero : 'não informado',
	                  endereco_complemento: temComplemento ? endereco.ds_complemento : 'não informado',
	                  endereco_bairro: endereco ? endereco.ds_bairro : 'não informado',
	                  endereco_cep: endereco ? endereco.ds_cep : 'não informado',
	                  endereco_cidade: endereco ? endereco.ds_cidade : 'não informado',
	                  endereco_estado: endereco ? endereco.ds_estado : 'não informado',
	                  nome_coordenador: _this6.proposta.ds_nome_coordenador,
	                  telefone_coordenador: _this6.proposta.ds_celular_coordenador,
	                  email_coordenador: _this6.proposta.ds_email_coordenador
	                };
	                _context5.next = 37;
	                break;
	
	              case 33:
	                _context5.prev = 33;
	                _context5.t1 = _context5['catch'](19);
	
	                _this6.$snotify.clear();
	                _this6.$root.trataErro(_context5.t1);
	
	              case 37:
	                (0, _assign2.default)(dadosBriefing.dadosEntidade, dados);
	                return _context5.abrupt('break', 60);
	
	              case 39:
	                _context5.next = 41;
	                return _this6.buscaCronograma();
	
	              case 41:
	                _this6.proposta.municipalizacao.forEach(function (item) {
	                  switch (item.ds_fase) {
	                    case '1':
	                      item['origem'] = 'Fundação';
	                      break;
	                    case '2':
	                      item['origem'] = 'Contrapartidada';
	                      break;
	                    case '5':
	                      item['origem'] = 'Parceiro';
	                      break;
	                    default:
	                      break;
	                  }
	                });
	                dadosBriefing.temDadosProjeto = true;
	                for (_i = 0; _i < _this6.proposta.objetivos.length; _i++) {
	                  (0, _assign2.default)(_this6.proposta.objetivos[_i], { cont: _i + 1 });
	                }
	                _this6.proposta.municipalizacao.map(function (item) {
	                  item.dc_valor_municipio = _this6.$root.formataNumero(item.dc_valor_municipio, 'moeda');
	                });
	                dados = {
	                  objetivo_geral: _this6.proposta.ds_objetivo_geral,
	                  objetivos: _this6.proposta.objetivos,
	                  metas: _this6.proposta.metas,
	                  atividades: _this6.proposta.atividades,
	                  valor_aprovado: {
	                    projeto: _this6.$root.formataNumero(_this6.totais.aprovado, 'moeda'),
	                    fbb: _this6.$root.formataNumero(_this6.totais.fbb.aprovado, 'moeda'),
	                    contrapartida: _this6.$root.formataNumero(_this6.totais.contrapartida.aprovado, 'moeda'),
	                    parceiro: _this6.$root.formataNumero(_this6.totais.parceiro.aprovado, 'moeda')
	                  },
	                  valor_atual: {
	                    projeto: _this6.$root.formataNumero(_this6.totais.atual, 'moeda'),
	                    fbb: _this6.$root.formataNumero(_this6.totais.fbb.atual, 'moeda'),
	                    contrapartida: _this6.$root.formataNumero(_this6.totais.contrapartida.atual, 'moeda'),
	                    parceiro: _this6.$root.formataNumero(_this6.totais.parceiro.atual, 'moeda')
	                  },
	                  publico_alvo: _this6.proposta.publicos_alvo,
	                  local_execucao: _this6.proposta.municipalizacao
	                };
	                (0, _assign2.default)(dadosBriefing.dadosProjeto, dados);
	                return _context5.abrupt('break', 60);
	
	              case 48:
	                dadosBriefing.temInfosProjeto = true;
	                dados = {
	                  introducao: _this6.proposta.ds_introducao,
	                  apresentacao: _this6.proposta.ds_apresentacao,
	                  territorio: _this6.proposta.ds_territorio,
	                  justificativa: _this6.proposta.ds_justificativa,
	                  objetivo_geral: _this6.proposta.ds_objetivo_geral,
	                  resultados_esperados: _this6.proposta.ds_resultados,
	                  operacionalizacao: _this6.proposta.ds_operacao,
	                  parcerias: _this6.proposta.ds_parceria,
	                  resumo: _this6.proposta.ds_resumo,
	                  acoes_comunicacao: _this6.proposta.ds_acoes_comunicacao
	                };
	                (0, _assign2.default)(dadosBriefing.infosProjeto, dados);
	                return _context5.abrupt('break', 60);
	
	              case 52:
	                dadosBriefing.temAnaliseProjeto = true;
	                dados = {
	                  parecer: _this6.relatorioAnalise.ds_parecer,
	                  observacao_valores: _this6.relatorioAnalise.ds_valores_observacoes,
	                  observacao_regularidade: _this6.relatorioAnalise.ds_regularidade_observacoes,
	                  observacao_licenciamento: _this6.relatorioAnalise.ds_licenciamento_observacoes,
	                  indicadores_resultado: _this6.relatorioAnalise.ds_indicadores_resultado,
	                  acoes_comunicacao: _this6.relatorioAnalise.ds_acoes_comunicacao
	                };
	                (0, _assign2.default)(dadosBriefing.analiseProjeto, dados);
	                return _context5.abrupt('break', 60);
	
	              case 56:
	                _context5.next = 58;
	                return _this6.buscaRelatorioErp();
	
	              case 58:
	                return _context5.abrupt('break', 60);
	
	              case 59:
	                return _context5.abrupt('break', 60);
	
	              case 60:
	                i++;
	                _context5.next = 9;
	                break;
	
	              case 63:
	                _emiteDocumento2.default.methods.geraDocumento(dadosBriefing, 'briefingProposta');
	                _this6.$snotify.clear();
	                _this6.$snotify.success('Arquivo gerado com sucesso', { timeout: 4000 });
	                _this6.loading = false;
	                _this6.botaoClicado = false;
	                _this6.mostrarBriefing = false;
	
	              case 69:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this6, [[19, 33]]);
	      }))();
	    }
	  }
	};

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'impressao-relatorio-modal',
	  data: function data() {
	    return {
	      loadingShow: false,
	      items: [],
	      tipoDoArquivo: 0,
	      relatorio: '',
	      projeto: {},
	      filtros: {
	        onlyIntegratedProposals: true,
	        projectProposals: false
	      }
	    };
	  },
	
	  props: ['propsAnalise'],
	  methods: {
	    onClean: function onClean() {
	      this.relatorio = null;
	      this.tipoDoArquivo = null;
	    },
	    onDownload: function onDownload() {
	      var _this = this;
	
	      this.loadingShow = true;
	      this.name = null;
	      this.file = null;
	      if (Number(this.tipoDoArquivo) === 1) {
	        this.rel = 'proxy/project/proposal/generate-report/pdf';
	      } else {
	        this.rel = 'proxy/project/proposal/generate-report/xls';
	      }
	      axios.post(this.rel, { proposal: String(this.propsAnalise.proposal.id), report: this.relatorio }, { responseType: 'arraybuffer', headers: { 'Content-Type': 'application/json' } }).then(function (response) {
	        _this.item = response.data.value;
	        if (Number(_this.tipoDoArquivo) === 1) {
	          _this.file = new Blob([response.data], { type: 'application/pdf' });
	        } else {
	          _this.file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
	        }
	        var ie = !!window.MSInputMethodContext && !!document.documentMode;
	        if (!ie) {
	          var blob = _this.file;
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = _this.propsAnalise.proposal.name;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var _blob = _this.file;
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, _this.item.name);
	          _link.download = _this.projeto.name;
	          _link.click();
	        }
	        _this.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this.$root.trataErro(error);
	        _this.loadingShow = false;
	      });
	    }
	  }
	};

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(181);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _RelatorioTitulo = __webpack_require__(1789);
	
	var _RelatorioTitulo2 = _interopRequireDefault(_RelatorioTitulo);
	
	var _RelatorioTextoDestaque = __webpack_require__(1788);
	
	var _RelatorioTextoDestaque2 = _interopRequireDefault(_RelatorioTextoDestaque);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'relatorioBNDES',
	  components: { RelatorioTextoDestaque: _RelatorioTextoDestaque2.default, RelatorioTitulo: _RelatorioTitulo2.default },
	  props: ['dadosRelatorio', 'previstoPublicoAlvo', 'totalizadores', 'executadasparcial', 'naoexecutadas', 'contrapartida'],
	  data: function data() {
	    return {
	      paginas: Array
	    };
	  },
	
	  methods: {
	    retornaSituacao: function retornaSituacao(situacao) {
	      if (situacao === 1) {
	        return 'Executada';
	      } else if (situacao === 2) {
	        return 'Em Execução';
	      } else if (situacao === 3) {
	        return 'Não Executada';
	      }
	      return '';
	    },
	    retornaAplicacao: function retornaAplicacao(situacao) {
	      if (situacao === 'NAO-SE-APLICA') {
	        return 'Não se aplica';
	      } else if (situacao === 'SIM') {
	        return 'Sim';
	      } else if (situacao === 'NÂO') {
	        return 'Não';
	      }
	      return '';
	    },
	    limpaCampo: function limpaCampo(campo) {
	      if (Array.isArray(campo) && campo.length === 0) {
	        return '';
	      }
	      return campo;
	    },
	    calculaTamanhoDePagina: function calculaTamanhoDePagina(atributo, lista) {
	      return lista.filter(function (item) {
	        return item.class === atributo;
	      }).reduce(function (accumulator, object) {
	        return accumulator + object.altura;
	      }, 0);
	    },
	    verificaTamanhos: function verificaTamanhos(elemento) {
	      var divs = (0, _from2.default)(elemento.childNodes).map(function (item) {
	        return {
	          'tipo': item.nodeName,
	          'largura': item.clientWidth,
	          'altura': item.clientHeight,
	          'class': item.classList && item.classList.length > 0 ? (0, _from2.default)(item.classList).filter(function (item) {
	            return String(item).includes('fbbpage');
	          })[0] : ''
	        };
	      }).filter(function (item) {
	        return item.tipo === 'DIV';
	      });
	      var listaTamanhosDePagina = [];
	      var altura = 0;
	      for (var i = 0; i < 20; i++) {
	        altura = this.calculaTamanhoDePagina('fbbpage' + (i < 10 ? '0' : '') + (i + 1), divs);
	        listaTamanhosDePagina.push({
	          'pagina': i + 1,
	          'altura': altura,
	          'largura': 750,
	          'quebra': altura > 900
	        });
	      }
	      this.paginas = listaTamanhosDePagina;
	    }
	  },
	  computed: {
	    contrapartidaConsolidada: function contrapartidaConsolidada() {
	      var somaInicial = this.contrapartida.reduce(function (accumulator, currentValue) {
	        return accumulator + parseFloat(String(currentValue.atingimento).replace('%', '').trim());
	      }, 0.0);
	      return somaInicial / this.contrapartida.length;
	    }
	  }
	};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'relatorioBi',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      relatorio: {},
	      relatorios: [],
	      show: null,
	      iframe: {
	        style: null,
	        wrapperStyle: null,
	        position: 'absolute'
	      }
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    axios.get('proxy/utility/bi-report').then(function (response) {
	      _this.relatorios = response.data.value;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	  methods: {
	    onShow: function onShow() {
	      this.show = true;
	    },
	    onClean: function onClean() {
	      this.show = false;
	      this.relatorio.descricao = null;
	    }
	  }
	};

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'CadastroRel',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      table: {
	        items: [],
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'active',
	        sortDesc: true,
	        fields: [{ key: 'code', label: 'Código do Relatório', sortable: true, thStyle: 'text-align: center; width: 3%', class: 'text-center' }, { key: 'title', label: 'Título do Relatório', sortable: true, thStyle: 'text-align: center; width: 5%', class: 'text-center' }, { key: 'reportOrder', label: 'Ordem do Relatório', thStyle: 'text-align: center; width: 0.2%', class: 'text-center' }, { key: 'active', label: 'Ativo', sortable: true, thStyle: 'text-align: center; width: 0.2%', class: 'text-center' }, { key: 'actions', label: 'Ações', sortable: true, thStyle: 'text-align: center; width: 1%', class: 'text-center' }]
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    axios.get('proxy/utility/erp-report').then(function (response) {
	      _this.table.items = response.data.value;
	      _this.table.totalRows = _this.table.items.length;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.currentPage = 1;
	    },
	    inativa: function inativa(item) {
	      var _this2 = this;
	
	      axios.get('proxy/utility/erp-report').then(function (response) {
	        item.active = !item.active;
	        _this2.$snotify.success('Relatório atualizado com sucesso');
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'EditaCadastroRel',
	  data: function data() {
	    return {
	      relatorio: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      axios.get('proxy/utility/erp-report').then(function (response) {
	        _this.relatorio = _this.$route.params.id;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this2 = this;
	
	      if (this.relatorio.id) {
	        axios.post('proxy/utility/erp-report/', this.relatorio).then(function (response) {
	          _this2.$snotify.success('Relatório salvo com sucesso');
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      } else {
	        axios.post('proxy/utility/erp-report/', this.relatorio).then(function (response) {
	          _this2.$snotify.success('Relatório gravado com sucesso');
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    },
	    onClean: function onClean() {
	      this.relatorio.code = '';
	      this.relatorio.active = '';
	      this.relatorio.title = '';
	      this.relatorio.fieldNames = '';
	      this.relatorio.codeNames = '';
	      this.relatorio.reportOrder = '';
	    }
	  }
	};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EmiteRelatorioERP',
	  data: function data() {
	    return {
	      loading: {
	        show: false
	      },
	      items: [],
	      relatorios: [],
	      relatorio: {},
	      item: {},
	      relatorioForm: [],
	      valores: [],
	      carregou: 0,
	      ehParceiroEstrategico: false
	    };
	  },
	
	  created: function created() {
	    this.ehParceiroEstrategico = this.usuarioLogado.perfis.some(function (perfil) {
	      return perfil.ds_nome === 'Parceiro Estratégico';
	    });
	    this.onSearch();
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    relatorio: function relatorio() {
	      var _this = this;
	
	      this.relatorioForm = [];
	      var campos = _.split(this.relatorio.ds_nome_campos, ';');
	      var camposNomes = _.split(this.relatorio.ds_codigo_campos, ';');
	      camposNomes.forEach(function (campoNome, index) {
	        var field = {
	          ds_codigo_campos: campoNome,
	          ds_titulo: campos[index],
	          value: null
	        };
	        _this.relatorioForm.push(field);
	        if (_this.relatorio.ds_codigo === 'FJCF222.GER') {
	          _this.relatorioForm.forEach(function (item) {
	            if (item.ds_codigo_campos === 'ESitPrj') {
	              item.value = 'ULT';
	            }
	          });
	        }
	
	        if (_this.relatorio.ds_codigo === 'FJCF525.GER' && _this.usuarioLogado.userType === 'ENTIDADE') {
	          _this.relatorioForm.forEach(function (item) {
	            if (item.ds_codigo_campos === 'EMosDes') {
	              item.value = 'S';
	            }
	          });
	        }
	        if (_this.relatorio.ds_codigo === 'FJCF248.GER') {
	          _this.relatorioForm.forEach(function (item) {
	            if (item.ds_codigo_campos === 'ECodFor') {
	              item.value = '';
	            }
	          });
	        }
	      });
	      this.$forceUpdate();
	    }
	  },
	  methods: {
	    criaParametro: function criaParametro() {
	      var temp = '';
	      this.relatorioForm.forEach(function (item) {
	        temp += '<' + item.ds_codigo_campos + '=' + (_.isNull(item.value) ? '' : item.value) + '>';
	      });
	      return temp;
	    },
	    onSearch: function onSearch() {
	      var _this2 = this;
	
	      var rel = [];
	      axiosLaravel.get('relatorio-erp').then(function (response) {
	        _this2.relatorios = response.data;
	        if (_this2.usuarioLogado.userType === 'ENTIDADE') {
	          for (var x = 0; x < _this2.relatorios.length; x++) {
	            if (_this2.relatorios[x].ds_codigo === 'FJCF219.GER' || _this2.relatorios[x].ds_codigo === 'FJCF525.GER') {
	              rel.push(_this2.relatorios[x]);
	            }
	          }
	          _this2.relatorios = rel;
	        } else {
	          _this2.relatorios = response.data;
	        }
	        _this2.buscaProjetos();
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    onClean: function onClean() {
	      this.relatorio = null;
	    },
	    onLoad: function onLoad() {
	      var _this3 = this;
	
	      this.$snotify.clear();
	      this.$aguarde('Gerando relatório. Por favor, aguarde...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: this.relatorio, params: this.criaParametro() }).then(function (response) {
	        _this3.onDownload(response);
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response) {
	      this.item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      this.file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      console.log('relatorioForm', this.relatorioForm);
	      console.log('relatorio', this.relatorio);
	      if (!ie) {
	        var blob = this.file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	
	        link.download = this.relatorioForm[0].ds_titulo + ' - ' + this.relatorioForm[0].value + ' / ' + this.relatorio.ds_titulo;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = this.file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, this.item.name);
	
	        _link.download = this.relatorioForm[0].ds_titulo + ' - ' + this.relatorioForm[0].value + ' / ' + this.relatorio.ds_titulo;
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	    },
	    buscaProjetos: function buscaProjetos() {
	      var _this4 = this;
	
	      this.loadingShow = true;
	      this.projetos = null;
	      this.loading.show = true;
	      var endpoint = 'projetos';
	      if (this.ehParceiroEstrategico) {
	        endpoint = 'parceiroEstrategico/projetos';
	      }
	      axiosLaravel.get(endpoint).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.projetos = response.data;
	        _this4.loading.show = false;
	        _this4.carregou = 1;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	
	    changeProjeto: function changeProjeto(projeto) {
	      this.relatorioForm[0].value = projeto.ds_codigo_projeto_erp;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    }
	  }
	};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _boletoUtils = __webpack_require__(176);
	
	var _boletoUtils2 = _interopRequireDefault(_boletoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GeracaoRemessa',
	  data: function data() {
	    return {
	      portadores: [],
	      portador: [],
	
	      remessas: [],
	      remessa: [],
	
	      titulos: [],
	      titulosBackup: [],
	      titulosSelecionados: [],
	      tituloEditando: null,
	
	      processamentoRemessa: [],
	      diretorioDestino: null,
	      loading: {
	        tela: false,
	        titulos: false,
	        portadores: false,
	        remessas: false
	      },
	      ordenacao: {
	        por: 'codfpg',
	        ordem: 'asc'
	      },
	      excelCampos: {
	        basico: {
	          'ID SGP': 'id',
	          'Situação Processo ': 'situacao',
	          'Projeto': 'numprj',
	          'Cód. Entidade': 'codfor',
	          'Título': 'numtit',
	          'Tipo Título': 'codtpt',
	          'Tipo de Pagamento': 'codfpg',
	          'Forma de Pagamento': 'tippgt',
	          'MCI Projeto': 'usu_mci',
	          'Conta Movimento': 'numcco',
	          'Banco': 'codban',
	          'Agencia': 'codage',
	          'Conta': 'ccbfor',
	          'Cód. de Barras': 'boleto.linhaDigitavel',
	          'Valor Original': 'vlrori',
	          'Valor Líquido': 'vlrliq'
	        },
	        posProcessamento: {
	          'Remessa': 'processamento.remessa'
	        }
	      },
	      excelMeta: [[{ 'key': 'charset', 'value': 'utf-8' }]],
	      enumeradores: { 'PAGAMENTO': 'Pagamento', 'PRESTACAO_DE_CONTAS': 'Prestação de Contas', 'LIQUIDACAO_FINANCEIRA': 'Liquidação Financeira', 'FEITO': 'Feito', 'EM_EXECUCAO': 'Em Execução', 'CANCELADO': 'Cancelado' },
	      tiposPagamento: {
	        principais: { 'CC': 'Crédito em Conta Corrente', 'CP': 'Crédito em Conta Poupança', 'DF': 'DARF', 'PO': 'Pagamento Concessionária', 'PS': 'Guia da Previdência Social', 'TN': 'Títulos não registrados', 'TO': 'TED - Outro Titular', 'TR': 'Títulos registrados' },
	        outros: { 'CA': 'Cheque administrativo', 'CH': 'Cheque', 'CS': ' Crédito em Conta Salário', 'DB': 'Débito em Conta Corrente', 'DC': 'Documento em Crédito - Mesmo Titular', 'DJ': 'DARJ', 'DO': 'Documento de Crédito - Outro Titular', 'DP': 'Débito em Conta Poupança', 'DS': 'DARF Simples', 'DV': 'DPVAT', 'EC': 'Extrato de Conta Corrente', 'FG': 'FGTS', 'GS': 'GARE-SP (ICMS/DR/ITCMD)', 'IP': 'IPVA', 'LC': 'LICENCIAMENTO', 'OP': 'Ordem de Pagamento', 'OU': 'Outros Pagamentos', 'PA': 'Pagamento com Autenticação', 'PC': 'Pagamento p/ Cartão', 'PQ': 'PIX QR Code', 'PT': 'Pagamento Tributos', 'PX': 'PIX Transferência', 'TE': 'TED - Mesmo Titular' }
	      },
	      alturaContentWrapper: window.innerHeight - 51,
	      filtroTituloAprovado: true,
	      listaVazia: false
	    };
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.buscarPortadores();
	              _this.buscarRemessas();
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    buscarPortadores: function buscarPortadores() {
	      var _this2 = this;
	
	      this.loading.portadores = true;
	      axiosLaravel.get('pagamento/portadores').then(function (response) {
	        console.log('Portadores: ', response.data);
	        var portadores = response.data;
	        portadores.unshift({ 'CodPor': 'Todos', 'DesPor': '', 'CodBan': '', 'CodAge': '', 'NumCco': '', 'DirPrm': '', 'DirPrt': '' });
	        portadores.unshift({ 'CodPor': 'Cabeçalho de portador', 'DesPor': '', 'CodBan': '', 'CodAge': '', 'NumCco': '', 'DirPrm': '', 'DirPrt': '', $isDisabled: true });
	        _this2.portadores = portadores;
	        _this2.loading.portadores = false;
	      }).catch(function (error) {
	        _this2.loading.portadores = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscarRemessas: function buscarRemessas() {
	      var _this3 = this;
	
	      var dias = 30;
	      this.loading.remessas = true;
	      axiosLaravel.post('pagamento/remessas', { 'faixa': '>=', 'corte': dias }).then(function (response) {
	        _this3.remessas = response.data;
	        _this3.remessas.unshift({ 'CodPor': 'Cabeçalho de remessa', 'DesPor': '', 'CodBan': '', 'CodAge': '', 'NumCco': '', 'DirPrm': '', 'DirPrt': '', $isDisabled: true });
	        _this3.loading.remessas = false;
	        _this3.remessas.push({ 'NumArb': 'Carregando remessas mais antigas', 'CodPor': '', 'DatPgt': '', 'QtdeRegistros': '<i class=\'fa fa-refresh fa-spin\'></i>', $isDisabled: true });
	        if (!_.isEmpty(_this3.remessa)) {
	          _this3.remessa = _.find(_this3.remessas, { 'CodPor': _this3.remessa.CodPor, 'NumArb': _this3.remessa.NumArb }) || [];
	        }
	
	        axiosLaravel.post('pagamento/remessas', { 'faixa': '<', 'corte': dias }).then(function (response) {
	          _.remove(_this3.remessas, { 'NumArb': 'Carregando remessas mais antigas' });
	          _this3.remessas = _.union(_this3.remessas, response.data);
	          if (!_.isEmpty(_this3.remessa)) {
	            _this3.remessa = _.find(_this3.remessas, { 'CodPor': _this3.remessa.CodPor, 'NumArb': _this3.remessa.NumArb }) || [];
	          }
	        }).catch(function (error) {
	          _this3.$root.trataErro(error);
	        });
	      }).catch(function (error) {
	        _this3.loading.remessas = false;
	        _this3.$root.trataErro(error);
	      });
	    },
	    inicializandoListas: function inicializandoListas() {
	      this.processamentoRemessa = [];
	      this.titulos = [];
	      this.titulosBackup = [];
	      this.titulosSelecionados = [];
	      this.tituloEditando = null;
	    },
	    portadorSelecionado: function portadorSelecionado() {
	      if (this.processamentoRemessa.length > 0) {
	        this.inicializandoListas();
	      }
	      var titulos = _.clone(this.titulosBackup);
	      this.titulos = this.portador.CodPor === 'Todos' ? titulos : _.filter(titulos, ['numcco', this.portador.NumCco]);
	      this.remessa = [];
	      this.selecionarTodosItens(this.processamentoRemessa.length > 0);
	    },
	    remessaSelecionada: function remessaSelecionada() {
	      this.inicializandoListas();
	      this.selecionarTodosItens(false);
	      this.portador = _.find(this.portadores, ['CodPor', !_.isEmpty(this.remessa) ? this.remessa.CodPor : 'Todos']);
	    },
	    buscarTitulos: function buscarTitulos(selecionaTudo) {
	      var _this4 = this;
	
	      this.loading.tela = true;
	      this.inicializandoListas();
	      axiosLaravel.post('pagamento/titulos', { 'remessa': _.isPlainObject(this.remessa) ? this.remessa : null }).then(function (response) {
	        console.log('Titulos para Remessa: ', response.data);
	        var titulos = response.data.retorno;
	        titulos.forEach(function (titulo) {
	          if (_.isEmpty(titulo.numcco) && !_.isEmpty(_this4.remessa)) {
	            _.set(titulo, 'numcco', _.get(_.find(_this4.portadores, ['CodPor', titulo.codpor]), 'NumCco', null));
	          }
	          titulo.boleto = _this4.jsonValido(titulo.boleto);
	          if (('' + titulo.codbar).length > 10) {
	            titulo.boleto = _boletoUtils2.default.validarBoleto(titulo.boleto.linhaDigitavel, _boletoUtils2.default.identificarTipoCodigo(titulo.codbar));
	            _.set(titulo.boleto, 'numeroInformadoTela', titulo.boleto.linhaDigitavel);
	          }
	
	          if (typeof titulo.boleto !== 'undefined' && titulo.codfpg === 4 && titulo.boleto.mens) {
	            console.log(titulo);
	
	            if (!_.isNull(titulo.boleto.codigoBarras) && titulo.boleto.codigoBarras.startsWith('001')) {
	              _.set(titulo, 'tippgt', 'TR');
	            } else {
	              if (!_.isNull(titulo.boleto.codigoBarras)) {
	                _.set(titulo, 'tippgt', 'TN');
	              }
	            }
	          }
	        });
	        _this4.titulos = titulos;
	
	        var selecaoTitulosProcessamentoRemessa = _this4.titulos.length === 0 ? [[]] : _.values(_.groupBy(_this4.titulos, function (chave) {
	          return chave.numcco;
	        }));
	        var qtdeTitulosProcessamentoRemessa = selecaoTitulosProcessamentoRemessa.length;
	        console.log('selecaoTitulosProcessamentoRemessa ', selecaoTitulosProcessamentoRemessa);
	        var contasSemPortador = [];
	        selecaoTitulosProcessamentoRemessa.forEach(function (titulosAgrupados) {
	          --qtdeTitulosProcessamentoRemessa;
	          var portador = _.find(_this4.portadores, ['NumCco', _.get(titulosAgrupados, '[0].numcco')]) || _.find(_this4.portadores, ['CodPor', _.get(_this4.remessa, 'CodPor')]);
	          var diretorio = _.isNull(_this4.diretorioDestino) ? _.has(portador, 'DirPrm') ? portador.DirPrm : null : _this4.diretorioDestino;
	          var remessa = _.isEmpty(_this4.remessa) ? null : _this4.remessa.NumArb;
	          if (portador && !_.isNull(portador)) {
	            axiosLaravel.post('pagamento/buscaTitulosRemessa', { 'portador': portador, 'diretorio': diretorio, 'titulos': titulosAgrupados, 'remessa': remessa, 'processar': false }).then(function (response) {
	              _this4.titulos.forEach(function (titulo) {
	                var tituloConsultado = _.find(response.data, function (consulta) {
	                  return consulta.numTit + consulta.codTpt + consulta.codFor === titulo.numtit + titulo.codtpt + titulo.codfor;
	                });
	
	                if (_.has(tituloConsultado, 'tipPgt') && _.has(tituloConsultado, 'vlrLiq')) {
	                  _.set(titulo, 'tippgt', tituloConsultado.tipPgt);
	                  if (!_.includes(['AMP', 'AMT'], tituloConsultado.codTpt)) {
	                    _.set(titulo, 'vlrliq', '' + tituloConsultado.vlrLiq);
	                  }
	                }
	
	                if (typeof titulo.boleto !== 'undefined' && titulo.codfpg === 4) {
	                  if (titulo.boleto.codigoBarras.startsWith('001')) {
	                    _.set(titulo, 'tippgt', 'TR');
	                  } else {
	                    _.set(titulo, 'tippgt', 'TN');
	                  }
	                }
	              });
	              _this4.titulosBackup = _.clone(_this4.titulos);
	              if (qtdeTitulosProcessamentoRemessa === 0) {
	                console.log('      Finalizado normal');
	                _this4.loading.tela = false;
	                _this4.selecionarTodosItens(selecionaTudo);
	              }
	
	              _this4.filtrarNaoAprovados(selecionaTudo);
	              console.log(titulos);
	              if (_.isEmpty(_this4.titulos)) {
	                _this4.listaVazia = true;
	              } else {
	                _this4.listaVazia = false;
	              }
	            }).catch(function (error) {
	              if (qtdeTitulosProcessamentoRemessa === 0) {
	                console.log('      Finalizado catch');
	                _this4.loading.tela = false;
	                _this4.selecionarTodosItens(selecionaTudo);
	              }
	              if (portador && !_.isNull(portador)) {
	                _this4.$root.trataErro(error);
	              }
	            });
	          } else {
	            if (qtdeTitulosProcessamentoRemessa === 0) {
	              console.log('      Finalizado else');
	              _this4.loading.tela = false;
	              _this4.selecionarTodosItens(selecionaTudo);
	            }
	            console.log('Portador nulo', portador);
	
	            if (!_.isEmpty(_.get(titulosAgrupados, '[0].numcco'))) {
	              contasSemPortador.push('Contate a GEFIC, é necessário cadastrar a conta ' + _.get(titulosAgrupados, '[0].numcco') + ' para Portador ou corrigir a conta do projeto ' + _.uniq(_.compact(_.map(titulosAgrupados, 'numprj'))).join(', '));
	            }
	          }
	        });
	        if (contasSemPortador.length > 0) {
	          _this4.$swal({
	            title: '<font color="red"><b>Atenção!</b></font>',
	            html: '<div align="left">' + contasSemPortador.join('<br/><br/>') + '</div>'
	          });
	        }
	      }).catch(function (error) {
	        _this4.loading.tela = false;
	        _this4.$root.trataErro(error);
	      });
	    },
	    gerarRemessa: function gerarRemessa() {
	      var _this5 = this;
	
	      this.loading.tela = true;
	
	      var selecaoTitulosProcessamentoRemessa = this.titulosSelecionados.length === 0 ? [[]] : _.values(_.groupBy(this.titulosSelecionados, this.chaveRemessa));
	      var qtdeRemessasParaProcessar = selecaoTitulosProcessamentoRemessa.length;
	
	      var excluidos = [];
	
	      this.titulosBackup.forEach(function (titulo) {
	        if (!_.find(_this5.titulosSelecionados, function (sel) {
	          return sel.numtit + sel.codtpt + sel.codfor === titulo.numtit + titulo.codtpt + titulo.codfor;
	        })) {
	          excluidos.push(titulo);
	        }
	      });
	      var contasSemPortador = [];
	      selecaoTitulosProcessamentoRemessa.forEach(function (titulos) {
	        var portador = _.find(_this5.portadores, ['NumCco', _.get(titulos, '[0].numcco')]) || _.find(_this5.portadores, ['CodPor', _.get(_this5.remessa, 'CodPor')]);
	
	        if (!portador) {
	          contasSemPortador.push('Contate a GEFIC, é necessário cadastrar a conta ' + _.get(titulos, '[0].numcco') + ' para Portador ou corrigir a conta do projeto ' + _.uniq(_.map(titulos, 'numprj')).join(', '));
	          if (--qtdeRemessasParaProcessar === 0) {
	            if (_this5.processamentoRemessa.length > 0) {
	              _this5.finalizaGeracaoRemessa();
	            } else {
	              _this5.loading.tela = false;
	            }
	          }
	          return;
	        }
	        var diretorio = _.isNull(_this5.diretorioDestino) ? portador.DirPrm : _this5.diretorioDestino;
	        var remessa = _.isEmpty(_this5.remessa) ? null : _this5.remessa.NumArb;
	        var data = _.isEmpty(_this5.remessa) ? null : _this5.remessa.DatPgt;
	        axiosLaravel.post('pagamento/gerarRemessa', { 'portador': portador, 'diretorio': diretorio, 'titulos': titulos, 'remessa': remessa, 'data': data, 'excluidos': excluidos }).then(function (response) {
	          var remessaResultado = response.data;
	          if (!_.isNull(remessaResultado.erroExecucao)) {
	            _this5.$snotify.error(remessaResultado.erroExecucao);
	          }
	          if (!_.isArray(remessaResultado.retorno)) {
	            remessaResultado.retorno = [remessaResultado.retorno];
	          }
	
	          remessaResultado.retorno.forEach(function (tituloProcessado) {
	            _.set(tituloProcessado, 'remessa', remessaResultado.remessa);
	            var tituloSelecionado = _.find(_this5.titulos, { 'numtit': tituloProcessado.numTit, 'codtpt': tituloProcessado.codTpt, 'codfor': tituloProcessado.codFor });
	            if (tituloSelecionado) {
	              if (_.has(tituloProcessado, 'detalhes') && !_.isArray(tituloProcessado.detalhes)) {
	                tituloProcessado.detalhes = [tituloProcessado.detalhes];
	              }
	              _.set(tituloSelecionado, 'processamento', tituloProcessado);
	            }
	          });
	          if (remessaResultado.retorno.length === 1 && _.isNull(remessaResultado.retorno[0]['numTit'])) {
	            remessaResultado.erroExecucao = remessaResultado.retorno[0]['detalhes']['msgRet'];
	          }
	          _.set(remessaResultado, 'portador', portador);
	          _this5.processamentoRemessa.push(remessaResultado);
	          if (--qtdeRemessasParaProcessar === 0) {
	            _this5.finalizaGeracaoRemessa();
	          }
	        }).catch(function (error) {
	          if (--qtdeRemessasParaProcessar === 0) {
	            _this5.finalizaGeracaoRemessa();
	          }
	          _this5.$root.trataErro(error);
	        });
	      });
	      if (contasSemPortador.length > 0) {
	        this.$swal({
	          title: '<font color="red"><b>Atenção!</b></font>',
	          html: '<div align="left">' + contasSemPortador.join('<br/><br/>') + '</div>'
	        });
	      }
	    },
	    chaveRemessa: function chaveRemessa(titulo) {
	      return titulo.numcco + titulo.tippgt + (this.ehRegra6(titulo) ? '|regra6' : '');
	    },
	    ehRegra6: function ehRegra6(titulo) {
	      return '' + titulo.prjsup === '18349';
	    },
	    finalizaGeracaoRemessa: function finalizaGeracaoRemessa() {
	      var _this6 = this;
	
	      this.$snotify.clear();
	      this.buscarRemessas();
	      this.processamentoRemessa = _.orderBy(this.processamentoRemessa, ['portador.CodPor', 'remessa'], ['asc', 'asc']);
	      this.titulos = _.orderBy(_.remove(this.titulos, function (t) {
	        return _.has(t, 'processamento');
	      }), ['numcco', 'processamento.remessa'], ['asc', 'asc']);
	      this.titulosBackup = _.clone(this.titulos);
	      this.loading.tela = false;
	      this.processamentoRemessa.forEach(function (remessa) {
	        if (remessa.remessa !== 0) {
	          _this6.emitir130(remessa.portador.CodPor, remessa.remessa);
	        }
	      });
	
	      this.moverArquivos();
	    },
	    editaTituloParaRemessa: function editaTituloParaRemessa(titulo) {
	      if (!titulo.boleto) {
	        titulo.boleto = { sucesso: false, mensagem: null, tipoCodigoInput: null, tipoBoleto: null, codigoBarras: null, linhaDigitavel: null, numeroInformadoTela: null, vencimento: null, valor: null };
	      }
	      this.tituloEditando = _.clone(titulo);
	    },
	    salvaEdicaoTituloParaRemessa: function salvaEdicaoTituloParaRemessa() {
	      if (!this.errors.first('código de barras') && !this.errors.first('conta')) {
	        var titulo = { 'numtit': this.tituloEditando.numtit, 'codtpt': this.tituloEditando.codtpt, 'codfor': this.tituloEditando.codfor };
	        this.titulos[_.findIndex(this.titulos, titulo)] = _.clone(this.tituloEditando);
	        this.titulosBackup[_.findIndex(this.titulosBackup, titulo)] = _.clone(this.tituloEditando);
	        this.titulosSelecionados[_.findIndex(this.titulosSelecionados, titulo)] = _.clone(this.tituloEditando);
	        this.tituloEditando = null;
	        this.$forceUpdate();
	      }
	    },
	    cancelaEdicaoTituloParaRemessa: function cancelaEdicaoTituloParaRemessa() {
	      this.tituloEditando = null;
	    },
	    validaAjustaCodigoBarras: function validaAjustaCodigoBarras() {
	      var numeroInformadoLimpo = ('' + this.tituloEditando.boleto.numeroInformadoTela).replace(/\D+/g, '');
	      if (numeroInformadoLimpo.length > 0 && ('' + this.tituloEditando.codfpg === '4' || _.isNull(this.tituloEditando.codfpg))) {
	        var tipo = _boletoUtils2.default.identificarTipoCodigo(numeroInformadoLimpo);
	        this.errors.remove('código de barras');
	        if (tipo === 'TAMANHO_INCORRETO' || !_.includes([44, 47, 48], numeroInformadoLimpo.length)) {
	          this.errors.add({ field: 'código de barras', msg: 'Tamanho do número incorreto!' });
	        } else {
	          var validacao = _boletoUtils2.default.validarBoleto(numeroInformadoLimpo, tipo);
	          if (validacao.sucesso) {
	            this.tituloEditando.boleto = validacao;
	            _.set(this.tituloEditando.boleto, 'numeroInformadoTela', numeroInformadoLimpo);
	          } else {
	            var mensagem = _.capitalize(tipo.replaceAll('_', ' ')) + ' acima está incorreto!';
	            this.errors.add({ field: 'código de barras', msg: mensagem });
	          }
	        }
	      }
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this7 = this;
	
	      var vm = this;
	      _.set(this.usuarioLogado, 'configuracoes.tela_liquidacao', {
	        'selecionado': vm.selecionado
	      });
	
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {
	        console.log('configuracoes', _this7.usuarioLogado.configuracoes);
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this7.$root.trataErro(error);
	        }
	      });
	    },
	    selecionarItem: function selecionarItem(item) {
	      var jaSelecionado = _.find(this.titulosSelecionados, function (sel) {
	        return sel.numtit + sel.codtpt + sel.codfor === item.numtit + item.codtpt + item.codfor;
	      });
	      if (jaSelecionado) {
	        _.remove(this.titulosSelecionados, jaSelecionado);
	      } else {
	        this.titulosSelecionados.push(item);
	      }
	      this.$forceUpdate();
	    },
	    selecionarTodosItens: function selecionarTodosItens() {
	      var _this8 = this;
	
	      var selecionaTudo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.titulosSelecionados = [];
	      if (selecionaTudo) {
	        this.titulos.forEach(function (titulo) {
	          if (!_.isEmpty(titulo.numcco) && !_.isEmpty(titulo.tippgt)) {
	            _this8.titulosSelecionados.push(titulo);
	          }
	        });
	      }
	      this.$forceUpdate();
	    },
	    segueReanalisarOuReativar: function segueReanalisarOuReativar(situacao, idProcesso, titulo) {
	      var vm = this;
	      var acao = _.includes(['FEITO', 'CANCELADO'], situacao) ? 'reativar' : 'reanalisar';
	      var numeroRemessa = _.get(titulo, 'numarb');
	      this.$dialog.confirm('Tem certeza que deseja ' + acao + ' esta solicitação de id <b>' + idProcesso + '</b>? ' + (numeroRemessa ? '<br/>Ao confirmar ele será excluída desta remessa ' + numeroRemessa : ''), { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        vm.loading.tela = true;
	        var rota = 'processos/' + acao + '/';
	        vm.$aguarde('Processando ação para ' + acao + ' esta solicitação...');
	        axiosLaravel.put(rota + idProcesso).then(function (response) {
	          console.log('acao > response', acao, response);
	          vm.$snotify.clear();
	          vm.$snotify.success('ID ' + idProcesso + ' movido para análise!');
	          _.remove(vm.titulos, ['id', idProcesso]);
	          _.remove(vm.titulosSelecionados, ['id', idProcesso]);
	          vm.titulosBackup = _.clone(vm.titulos);
	          vm.loading.tela = false;
	          if (!_.isNull(numeroRemessa)) {
	            vm.$aguarde('Excluído título ' + titulo.numtit + '/' + titulo.codtpt + '/' + titulo.codfor + ' da remessa ' + numeroRemessa + '...');
	            vm.gerarRemessa();
	          }
	        }).catch(function (error) {
	          vm.$snotify.clear();
	          vm.loading.tela = false;
	          vm.$root.trataErro(error);
	        });
	      }).catch(function () {});
	    },
	    atribuirFazer: function atribuirFazer(item) {
	      var _this9 = this;
	
	      console.log('atribuirFazer (item)', item);
	      console.log('  validacao de usuario', '' + item.id_usuario, '' + this.usuarioLogado.id);
	      if ('' + item.id_usuario !== '' + this.usuarioLogado.id) {
	        console.log('    usuario diferente', item.id_usuario, this.usuarioLogado.id);
	        axiosLaravel.put('processos/validacao/assumir/', { 'item': item, 'id_tarefa': item['id_tarefa_atual'] }).then(function (response) {
	          console.log('      Tarefa assumida', response);
	        }).catch(function (error) {
	          _this9.$root.trataErro(error);
	        });
	      }
	      this.$router.push({ name: 'solicitacao-pagamento', params: { id: item.id, row: item, acao: 'VALIDAR' } });
	    },
	    jsonValido: function jsonValido(json) {
	      try {
	        if (typeof json !== 'string' && (typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) !== 'object') {
	          json = undefined;
	        } else if (typeof json === 'string' && json.length > 0) {
	          json = JSON.parse(json);
	        } else if ((typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) === 'object') {
	          json = JSON.parse((0, _stringify2.default)(json));
	        } else {
	          json = undefined;
	        }
	        json = _.isObjectLike(json) ? json : undefined;
	      } catch (e) {
	        if (e instanceof SyntaxError) {
	          json = undefined;
	        }
	      }
	      return json;
	    },
	    emitir130: function emitir130(portador, remessa) {
	      var _this10 = this;
	
	      var dataPagamento = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      this.loading.tela = true;
	      var parametros = '<ECodPor=' + portador + '><ENumRem=' + remessa + '>' + (!_.isNull(dataPagamento) ? '<EDatPgt=' + dataPagamento + '>' : '');
	      this.$aguarde('Gerando relatório 130 para Portador ' + portador + ' e Remessa ' + remessa + ' ...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': 'FPCP130.GER' }, params: parametros }).then(function (response) {
	        _this10.onDownload(response, '130' + ' » ' + portador + ' » ' + remessa);
	        _this10.loading.tela = false;
	      }).catch(function (error) {
	        _this10.$snotify.clear();
	        _this10.loading.tela = false;
	        _this10.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (!ie) {
	        var blob = file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'Relatório ' + relatorio;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	        _link.download = 'Relatório ' + relatorio;
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading.tela = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    moverArquivos: function moverArquivos() {
	      var _this11 = this;
	
	      console.log('EXECUTANDO BATCH');
	      this.$snotify.warning('Organizando arquivos no servidor...');
	      axiosLaravel.get('/pagamento/moverArquivos').then(function (response) {
	        console.log(response.data);
	        _this11.$snotify.clear();
	        _this11.$forceUpdate();
	        _this11.$snotify.success('Organização de arquivos concluída com sucesso!');
	      }).catch(function (error) {
	        console.error(error);
	        _this11.$snotify.clear();
	      });
	    },
	    filtrarNaoAprovados: function filtrarNaoAprovados(buscaRemessa) {
	      if (buscaRemessa) {
	        return;
	      }
	      var titulosFiltrados = this.titulosBackup.filter(function (titulo) {
	        var datapr = _.get(titulo, 'datapr', '1900').substring(0, 4);
	        return datapr !== '1900';
	      });
	      this.titulos = titulosFiltrados;
	    },
	    limparFiltros: function limparFiltros() {
	      var titulosFiltrados = this.titulosBackup.filter(function (titulo) {
	        var datapr = _.get(titulo, 'datapr', '1900').substring(0, 4);
	        return datapr !== '1900';
	      });
	      this.titulos = titulosFiltrados;
	      this.filtroTituloAprovado = true;
	    },
	    consultaNaoAprovados: function consultaNaoAprovados() {
	      var titulosFiltrados = this.titulosBackup.filter(function (titulo) {
	        var datapr = _.get(titulo, 'datapr', '1900').substring(0, 4);
	        return datapr === '1900';
	      });
	      this.titulos = titulosFiltrados;
	      this.filtroTituloAprovado = false;
	    }
	  }
	};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaRemessaBNDES',
	  data: function data() {
	    return {
	      loading: {
	        tela: false
	      },
	      busca: '',
	      buscaTimer: null,
	      formIntervencao: {
	        numeroProjeto: null,
	        intervencao_bndes: null
	      },
	      table: {
	        bordered: true,
	        currentPage: 1,
	        perPage: 25,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        emptyText: 'Não tem nenhum registro para mostrar',
	        fields: [{
	          key: 'id_bndes',
	          label: 'ID do BNDES',
	          sortable: true,
	          thStyle: 'text-align: center; width: 10%',
	          class: 'text-center'
	        }, {
	          key: 'numero',
	          label: 'Numero da nota',
	          sortable: true,
	          thStyle: 'text-align: center; width: 10%',
	          class: 'text-center'
	        }, {
	          key: 'cnpj',
	          label: 'CNPJ emissor',
	          sortable: true,
	          thStyle: 'text-align: center; width: 15%',
	          class: 'text-center'
	        }, {
	          key: 'numero_projeto',
	          label: 'Numero do Projeto',
	          sortable: true,
	          thStyle: 'text-align: center; width: 10%',
	          class: 'text-center'
	        }, {
	          key: 'data_envio',
	          label: 'Data de envio',
	          sortable: true,
	          thStyle: 'text-align: center; width: 15%',
	          class: 'text-center'
	        }, {
	          key: 'status',
	          label: 'Status',
	          sortable: false,
	          thStyle: 'text-align: center; width: 20%',
	          class: 'text-center'
	        }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    busca: function busca() {
	      var _this = this;
	
	      clearTimeout(this.buscaTimer);
	      this.buscaTimer = setTimeout(function () {
	        if (_this.table.currentPage !== 1) {
	          _this.table.currentPage = 1;
	        } else {
	          _this.recarregar();
	        }
	      }, 400);
	    }
	  },
	  methods: {
	    provedorRemessas: function provedorRemessas(ctx) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var params, response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this2.loading.tela = true;
	                _context.prev = 1;
	                params = {
	                  page: ctx.currentPage,
	                  per_page: ctx.perPage,
	                  q: _this2.busca || '',
	                  sort_by: ctx.sortBy || 'id',
	                  sort_desc: ctx.sortDesc ? 1 : 0
	                };
	                _context.next = 5;
	                return axiosLaravel.get('/remessas/bndes', { params: params });
	
	              case 5:
	                response = _context.sent;
	
	                _this2.table.totalRows = response.data.total;
	                return _context.abrupt('return', response.data.data);
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](1);
	
	                if (_context.t0) {
	                  _this2.$root.trataErro(_context.t0);
	                }
	                _this2.table.totalRows = 0;
	                return _context.abrupt('return', []);
	
	              case 15:
	                _context.prev = 15;
	
	                _this2.loading.tela = false;
	                return _context.finish(15);
	
	              case 18:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[1, 10, 15, 18]]);
	      }))();
	    },
	    recarregar: function recarregar() {
	      if (this.$refs.tabelaRemessas) {
	        this.$refs.tabelaRemessas.refresh();
	      }
	    },
	    salvar: function salvar() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _this3.$validator.validateAll();
	
	              case 2:
	                if (!_context2.sent) {
	                  _context2.next = 5;
	                  break;
	                }
	
	                _this3.loading.tela = true;
	                axiosLaravel.post('/remessas/bndes/vincula', _this3.formIntervencao).then(function (response) {
	                  _this3.$snotify.success(response.data.mensagem);
	                  _this3.recarregar();
	                }).catch(function (error) {
	                  _this3.$snotify.error(error.response.data.error);
	                }).finally(function () {
	                  _this3.loading.tela = false;
	                });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    }
	  }
	};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _boletoUtils = __webpack_require__(176);
	
	var _boletoUtils2 = _interopRequireDefault(_boletoUtils);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TratamentoRetorno',
	  data: function data() {
	    return {
	      portadores: [],
	      portador: [],
	
	      remessas: [],
	      remessa: [],
	
	      retornos: [],
	      retorno: [],
	
	      titulos: [],
	      titulosBackup: [],
	      titulosSelecionados: [],
	      tituloEditando: null,
	
	      processamentoRetorno: [],
	      ocorrencias: [],
	
	      diretorioDestino: null,
	      loading: {
	        tela: false,
	        titulos: false,
	        retornos: false,
	        portadores: false,
	        remessas: false
	      },
	      ordenacao: {
	        por: 'processamento',
	        ordem: 'desc'
	      },
	      excelCampos: {
	        basico: {
	          'ID SGP': 'id',
	          'Situação Processo ': 'situacao',
	          'Projeto': 'numprj',
	          'Cód. Entidade': 'codfor',
	          'Título': 'numtit',
	          'Tipo Título': 'codtpt',
	          'Tipo de Pagamento': 'codfpg',
	          'Forma de Pagamento': 'tippgt',
	          'MCI Projeto': 'usu_mci',
	          'Conta Movimento': 'numcco',
	          'Banco': 'codban',
	          'Agencia': 'codage',
	          'Conta': 'ccbfor',
	          'Cód. de Barras': 'boleto.linhaDigitavel',
	          'Valor Original': 'vlrori',
	          'Valor Líquido': 'vlrabe'
	        },
	        posProcessamento: {
	          'Remessa': 'processamento.remessa'
	        }
	      },
	      excelMeta: [[{ 'key': 'charset', 'value': 'utf-8' }]],
	      enumeradores: { 'PAGAMENTO': 'Pagamento', 'PRESTACAO_DE_CONTAS': 'Prestação de Contas', 'LIQUIDACAO_FINANCEIRA': 'Liquidação Financeira', 'FEITO': 'Feito', 'EM_EXECUCAO': 'Em Execução', 'CANCELADO': 'Cancelado' },
	      tiposPagamento: { 'CA': 'Cheque administrativo', 'CC': 'Crédito em Conta Corrente', 'CH': 'Cheque', 'CP': 'Crédito em Conta Poupança', 'CS': ' Crédito em Conta Salário', 'DB': 'Débito em Conta Corrente', 'DC': 'Documento em Crédito - Mesmo Titular', 'DF': 'DARF', 'DJ': 'DARJ', 'DO': 'Documento de Crédito - Outro Titular', 'DP': 'Débito em Conta Poupança', 'DS': 'DARF Simples', 'DV': 'DPVAT', 'EC': 'Extrato de Conta Corrente', 'FG': 'FGTS', 'GS': 'GARE-SP (ICMS/DR/ITCMD)', 'IP': 'IPVA', 'LC': 'LICENCIAMENTO', 'OP': 'Ordem de Pagamento', 'OU': 'Outros Pagamentos', 'PA': 'Pagamento com Autenticação', 'PC': 'Pagamento p/ Cartão', 'PO': 'Pagamento Concessionária', 'PQ': 'PIX QR Code', 'PS': 'Guia da Previdência Social', 'PT': 'Pagamento Tributos', 'PX': 'PIX Transferência', 'TE': 'TED - Mesmo Titular', 'TN': 'Títulos não registrados', 'TO': 'TED - Outro Titular', 'TR': 'Títulos registrados' },
	      alturaContentWrapper: window.innerHeight - 51
	    };
	  },
	
	  watch: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.buscarArquivosRetornos();
	              _this.buscarListaOcorrenciasRetorno();
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    buscarArquivosRetornos: function buscarArquivosRetornos() {
	      var _this2 = this;
	
	      var dias = 3;
	      this.loading.retornos = true;
	      var numeradorTrackBy = 0;
	      var registros = [];
	      var cabecalho = { 'usu_datoco': 'Data do retorno', 'ArquivosRetorno': 'Arquivos', 'usu_tiparq': '', 'QtdeRegistros': 'Títulos', 'rotulo': '', $isDisabled: true };
	      var carregando = { 'usu_datoco': 'Carregando retornos mais antigos', 'ArquivosRetorno': '<i class=\'fa fa-refresh fa-spin\'></i>', 'usu_tiparq': '', 'QtdeRegistros': '<i class=\'fa fa-refresh fa-spin\'></i>', 'rotulo': '', $isDisabled: true };
	
	      var montaLista = function montaLista(rodape) {
	        var ordenados = _.orderBy(registros, [function (registro) {
	          return (0, _moment2.default)(registro.usu_datoco).valueOf();
	        }], ['desc']);
	        return _.isNil(rodape) ? _.concat([cabecalho], ordenados) : _.concat([cabecalho], ordenados, [rodape]);
	      };
	
	      var preparaRegistros = function preparaRegistros(dados) {
	        dados.forEach(function (registro) {
	          _.set(registro, 'numerador', ++numeradorTrackBy);
	          _.set(registro, 'rotulo', (0, _moment2.default)(registro.usu_datoco).format('DD/MM/YYYY') + ' ' + (0, _moment2.default)(registro.usu_datoco).format('YYYY-MM-DD'));
	        });
	        return dados;
	      };
	      axiosLaravel.post('pagamento/retornos/lista', { 'faixa': '>=', 'corte': dias, 'tipo': ['PREVIA'] }).then(function (response) {
	        registros = preparaRegistros(response.data);
	        _this2.retornos = montaLista(carregando);
	        _this2.loading.retornos = false;
	        if (!_.isEmpty(_this2.retorno)) {
	          _this2.retorno = _.find(_this2.retorno, { 'usu_datoco': _this2.retorno.usu_datoco }) || [];
	        }
	
	        axiosLaravel.post('pagamento/retornos/lista', { 'faixa': '<', 'corte': dias, 'tipo': ['PREVIA'] }).then(function (response) {
	          registros = _.union(registros, preparaRegistros(response.data));
	          if (!_.isEmpty(_this2.retorno)) {
	            _this2.retorno = _.find(_this2.retorno, { 'usu_datoco': _this2.retorno.usu_datoco }) || [];
	          }
	
	          _this2.retornos = montaLista();
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }).catch(function (error) {
	        _this2.loading.retornos = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscarConteudoArquivoRetorno: function buscarConteudoArquivoRetorno() {
	      var _this3 = this;
	
	      this.inicializandoListas();
	      var vm = this;
	      if (!_.isEmpty(this.retorno)) {
	        this.loading.tela = true;
	        axiosLaravel.post('pagamento/retornos/conteudo/', { 'data': this.retorno['usu_datoco'], 'tipo': this.retorno['usu_tiparq'] }).then(function (response) {
	          if (_.isEmpty(_this3.ocorrencias)) {
	            _this3.buscarListaOcorrenciasRetorno();
	          }
	          var retorno = response.data;
	          console.log('conteudoRetorno: ', retorno);
	
	          _this3.processamentoRetorno = _.filter(retorno, function (titulo) {
	            return !_.isNull(titulo.numarb);
	          });
	          _this3.$forceUpdate();
	
	          var titulosParaProcessar = _.filter(_this3.processamentoRetorno, function (titulo) {
	            return !_.isNull(titulo.id) && titulo.situacao === 'EM_EXECUCAO' && titulo.processamento === 1;
	          });
	          var qtdeTitulosParaProcessar = titulosParaProcessar.length;
	          if (qtdeTitulosParaProcessar > 0) {
	            vm.$aguarde('Concluindo ' + qtdeTitulosParaProcessar + (qtdeTitulosParaProcessar > 1 ? ' processos' : ' processo') + ' em execução...');
	            titulosParaProcessar.forEach(function (titulo, idx) {
	              --qtdeTitulosParaProcessar;
	              titulo['loading'] = { 'texto': 'Concluindo...', 'situacao': 'processando', 'classe': 'info' };
	              axiosLaravel.get('/pagamento/finaliza/processo/' + titulo.id).then(function (response) {
	                if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	                  titulo.loading = { 'texto': 'Finalizado!', 'situacao': 'feito', 'classe': 'success' };
	                  _.set(titulo, 'situacao', response.data.retorno.situacao);
	                } else {
	                  titulo.loading = { 'texto': 'Ocorreu erro', 'situacao': 'erro', 'classe': 'error' };
	                  _this3.$snotify.error('Erro ao finalizar id ' + titulo.id + ': ' + response.data.mensagem);
	                }
	                setTimeout(function () {
	                  _.unset(titulo, 'loading');
	                  vm.$forceUpdate();
	                  if (qtdeTitulosParaProcessar === 0) {
	                    vm.$snotify.clear();
	                    vm.loading.tela = false;
	                  }
	                }, 3000);
	              }).catch(function (error) {
	                titulo.loading = { 'texto': 'Ocorreu erro', 'situacao': 'erro', 'classe': 'error' };
	                if (qtdeTitulosParaProcessar === 0) {
	                  vm.$snotify.clear();
	                  vm.loading.tela = false;
	                }
	                _this3.$root.trataErro(error);
	              });
	            });
	          } else {
	            _this3.loading.tela = false;
	          }
	        }).catch(function (error) {
	          _this3.loading.tela = false;
	          _this3.$root.trataErro(error);
	        });
	      }
	    },
	    processarRetorno: function processarRetorno() {
	      var _this4 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('pagamento/retornos/processar/', { 'arquivo': this.processamentoRetorno[0]['usu_nomarq'] }).then(function (response) {
	        console.log('processarRetorno: ', response.data);
	        var listaTitulos = _.clone(_this4.processamentoRetorno);
	        listaTitulos.forEach(function (titulo) {
	          var retorno = _.filter(response.data.dadosGeraisLog, { RNumTit: titulo.usu_numtit, RCodTpt: titulo.usu_codtpt, RCodFor: titulo.usu_codfor });
	          titulo['retorno'] = _.orderBy(retorno, ['RSeqOco'], ['asc']);
	          titulo['processamento'] = _.some(retorno, function (r) {
	            return _.includes(_.toLower(r.RDesBan), 'erro');
	          }) ? 2 : 1;
	        });
	        _this4.processamentoRetorno = _.clone(listaTitulos);
	        _this4.loading.tela = false;
	      }).catch(function (error) {
	        _this4.loading.tela = false;
	        _this4.$root.trataErro(error);
	      });
	    },
	    buscarListaOcorrenciasRetorno: function buscarListaOcorrenciasRetorno() {
	      var _this5 = this;
	
	      axiosLaravel.get('pagamento/retornos/ocorrencias/').then(function (response) {
	        _this5.ocorrencias = response.data;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    buscarPortadores: function buscarPortadores() {
	      var _this6 = this;
	
	      this.loading.portadores = true;
	      axiosLaravel.get('pagamento/portadores').then(function (response) {
	        console.log('Portadores: ', response.data);
	        var portadores = response.data;
	
	        _this6.portadores = portadores;
	        _this6.loading.portadores = false;
	      }).catch(function (error) {
	        _this6.loading.portadores = false;
	        _this6.$root.trataErro(error);
	      });
	    },
	    inicializandoListas: function inicializandoListas() {
	      this.processamentoRetorno = [];
	      this.titulos = [];
	      this.titulosBackup = [];
	      this.titulosSelecionados = [];
	      this.tituloEditando = null;
	    },
	    portadorSelecionado: function portadorSelecionado() {
	      if (this.processamentoRetorno.length > 0) {
	        this.inicializandoListas();
	      }
	      var titulos = _.clone(this.titulosBackup);
	      this.titulos = this.portador.CodPor === 'Todos' ? titulos : _.filter(titulos, ['numcco', this.portador.NumCco]);
	      this.retorno = [];
	    },
	    arquivoRetornoSelecionado: function arquivoRetornoSelecionado() {
	      console.log('arquivoRetornoSelecionado');
	    },
	    remessaSelecionada: function remessaSelecionada() {
	      console.log('remessaSelecionada');
	      this.inicializandoListas();
	    },
	    editaTituloParaRemessa: function editaTituloParaRemessa(titulo) {
	      if (!titulo.boleto) {
	        titulo.boleto = { sucesso: false, mensagem: null, tipoCodigoInput: null, tipoBoleto: null, codigoBarras: null, linhaDigitavel: null, numeroInformadoTela: null, vencimento: null, valor: null };
	      }
	      this.tituloEditando = _.clone(titulo);
	    },
	    salvaEdicaoTituloParaRemessa: function salvaEdicaoTituloParaRemessa() {
	      console.log(this.errors.first('código de barras'));
	      if (!this.errors.first('código de barras') && _.get(this.tituloEditando, 'boleto.sucesso', false) && _.get(this.tituloEditando, 'boleto.linhaDigitavel', '').length > 5) {
	        this.titulos[_.findIndex(this.titulos, { numtit: this.tituloEditando.numtit, codtpt: this.tituloEditando.codtpt, codfor: this.tituloEditando.codfor })] = _.clone(this.tituloEditando);
	        this.tituloEditando = null;
	        this.$forceUpdate();
	      }
	    },
	    cancelaEdicaoTituloParaRemessa: function cancelaEdicaoTituloParaRemessa() {
	      this.tituloEditando = null;
	    },
	    validaAjustaCodigoBarras: function validaAjustaCodigoBarras() {
	      var numeroInformadoLimpo = ('' + this.tituloEditando.boleto.numeroInformadoTela).replace(/\D+/g, '');
	      if (numeroInformadoLimpo.length > 0 && '' + this.tituloEditando.codfpg === '4') {
	        var tipo = _boletoUtils2.default.identificarTipoCodigo(numeroInformadoLimpo);
	        this.errors.remove('código de barras');
	        if (tipo === 'TAMANHO_INCORRETO' || !_.includes([44, 47, 48], numeroInformadoLimpo.length)) {
	          this.errors.add({ field: 'código de barras', msg: 'Tamanho do número incorreto!' });
	        } else {
	          var validacao = _boletoUtils2.default.validarBoleto(numeroInformadoLimpo, tipo);
	          if (validacao.sucesso) {
	            this.tituloEditando.boleto = validacao;
	            _.set(this.tituloEditando.boleto, 'numeroInformadoTela', numeroInformadoLimpo);
	          } else {
	            var mensagem = _.capitalize(tipo.replaceAll('_', ' ')) + ' acima está incorreto!';
	            this.errors.add({ field: 'código de barras', msg: mensagem });
	          }
	        }
	      }
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this7 = this;
	
	      var vm = this;
	      _.set(this.usuarioLogado, 'configuracoes.tela_liquidacao', {
	        'selecionado': vm.selecionado
	      });
	
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {
	        console.log('configuracoes', _this7.usuarioLogado.configuracoes);
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this7.$root.trataErro(error);
	        }
	      });
	    },
	    selecionarItem: function selecionarItem(item) {
	      var jaSelecionado = _.find(this.titulosSelecionados, function (sel) {
	        return sel.numtit + sel.codtpt + sel.codfor === item.numtit + item.codtpt + item.codfor;
	      });
	      if (jaSelecionado) {
	        _.remove(this.titulosSelecionados, jaSelecionado);
	      } else {
	        this.titulosSelecionados.push(item);
	      }
	      this.$forceUpdate();
	    },
	    selecionarTodosItens: function selecionarTodosItens() {
	      var _this8 = this;
	
	      var selecionaTudo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.titulosSelecionados = [];
	      if (selecionaTudo) {
	        this.titulos.forEach(function (titulo) {
	          _this8.titulosSelecionados.push(titulo);
	        });
	      }
	      this.$forceUpdate();
	    },
	    excluirTituloArquivoRetorno: function excluirTituloArquivoRetorno(titulo) {
	      var _this9 = this;
	
	      console.log('excluirTituloArquivoRetorno titulo', titulo);
	
	      axiosLaravel.post('pagamento/remessas/excluir_titulo', { 'remessa': titulo.numarb, 'portador': titulo.usu_codpor, 'titulo': titulo }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _.remove(_this9.processamentoRetorno, { usu_numtit: titulo.usu_numtit, usu_codtpt: titulo.usu_codtpt, usu_codfor: titulo.usu_codfor });
	          --_this9.retorno.QtdeRegistros;
	          _this9.$forceUpdate();
	        } else {
	          _this9.$snotify.error('Erro ao finalizar id ' + titulo.id + ': ' + response.data.mensagem);
	        }
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this9.$root.trataErro(error);
	        }
	      });
	    },
	    segueReanalisarOuReativar: function segueReanalisarOuReativar(situacao, idProcesso) {
	      var vm = this;
	      var acao = _.includes(['FEITO', 'CANCELADO'], situacao) ? 'reativar' : 'reanalisar';
	      this.$dialog.confirm('Tem certeza que deseja ' + acao + ' esta solicitação de id <b>' + idProcesso + '</b>?', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	        vm.loading.tela = true;
	        var rota = 'processos/' + acao + '/';
	        vm.$aguarde('Processando ação para ' + acao + ' esta solicitação...');
	        axiosLaravel.put(rota + idProcesso).then(function (response) {
	          console.log('acao > response', acao, response);
	          vm.$snotify.clear();
	          vm.$snotify.success('ID ' + idProcesso + ' movido para análise!');
	          _.remove(vm.titulos, ['id', idProcesso]);
	          _.remove(vm.titulosSelecionados, ['id', idProcesso]);
	          vm.titulosBackup = _.clone(vm.titulos);
	          vm.loading.tela = false;
	        }).catch(function (error) {
	          vm.$snotify.clear();
	          vm.loading.tela = false;
	          vm.$root.trataErro(error);
	        });
	      }).catch(function () {});
	    },
	    atribuirFazer: function atribuirFazer(item) {
	      var _this10 = this;
	
	      console.log('atribuirFazer (item)', item);
	      console.log('  validacao de usuario', '' + item.id_usuario, '' + this.usuarioLogado.id);
	      if ('' + item.id_usuario !== '' + this.usuarioLogado.id) {
	        console.log('    usuario diferente', item.id_usuario, this.usuarioLogado.id);
	        axiosLaravel.put('processos/validacao/assumir/', { 'item': item, 'id_tarefa': item['id_tarefa_atual'] }).then(function (response) {
	          console.log('      Tarefa assumida', response);
	        }).catch(function (error) {
	          _this10.$root.trataErro(error);
	        });
	      }
	      this.$router.push({ name: 'solicitacao-pagamento', params: { id: item.id, row: item, acao: 'VALIDAR' } });
	    },
	    jsonValido: function jsonValido(json) {
	      try {
	        if (typeof json !== 'string' && (typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) !== 'object') {
	          json = undefined;
	        } else if (typeof json === 'string' && json.length > 0) {
	          json = JSON.parse(json);
	        } else if ((typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) === 'object') {
	          json = JSON.parse((0, _stringify2.default)(json));
	        } else {
	          json = undefined;
	        }
	        json = _.isObjectLike(json) ? json : undefined;
	      } catch (e) {
	        if (e instanceof SyntaxError) {
	          json = undefined;
	        }
	      }
	      return json;
	    },
	    emitir611: function emitir611(numeroTitulo, codigoFornecedor) {
	      var _this11 = this;
	
	      this.loading.tela = true;
	      var parametros = '<ECodEmp=1><ECodFil=1><ETitBai=S><ENumTit="' + numeroTitulo + '"><ECodFor=' + codigoFornecedor + '>';
	      this.$aguarde('Gerando comprovante do titulo ' + numeroTitulo + ' ...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': 'FPCP611.GER' }, params: parametros }).then(function (response) {
	        _this11.onDownload(response, 'Comprovante » ' + numeroTitulo + ' » ' + codigoFornecedor);
	        _this11.loading.tela = false;
	      }).catch(function (error) {
	        _this11.$snotify.clear();
	        _this11.loading.tela = false;
	        _this11.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (!ie) {
	        var blob = file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = relatorio;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	        _link.download = relatorio;
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Gerado com sucesso!');
	      this.loading.tela = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    }
	  }
	};

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['titulo', 'valor']
	};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['valor']
	};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _visualizar = __webpack_require__(1806);
	
	var _visualizar2 = _interopRequireDefault(_visualizar);
	
	var _uploadDocumentosPhp = __webpack_require__(85);
	
	var _uploadDocumentosPhp2 = _interopRequireDefault(_uploadDocumentosPhp);
	
	var _formValidacaoPagamento = __webpack_require__(1808);
	
	var _formValidacaoPagamento2 = _interopRequireDefault(_formValidacaoPagamento);
	
	var _formValidacaoContrapartida = __webpack_require__(1799);
	
	var _formValidacaoContrapartida2 = _interopRequireDefault(_formValidacaoContrapartida);
	
	var _historicoSolicitacaoPagamento = __webpack_require__(107);
	
	var _historicoSolicitacaoPagamento2 = _interopRequireDefault(_historicoSolicitacaoPagamento);
	
	var _historicoAntigo = __webpack_require__(106);
	
	var _historicoAntigo2 = _interopRequireDefault(_historicoAntigo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    visualizar: _visualizar2.default,
	    formValidacaoPagamento: _formValidacaoPagamento2.default,
	    formValidacaoContrapartida: _formValidacaoContrapartida2.default,
	    UploadDocumentosPhp: _uploadDocumentosPhp2.default,
	    HistoricoSolicitacaoPagamento: _historicoSolicitacaoPagamento2.default,
	    HistoricoAntigo: _historicoAntigo2.default
	  },
	  name: 'ListaSolicitacao',
	  data: function data() {
	    return {
	      idAdiantamento: null,
	      todasPropostasSimplificadas: true,
	      dadosBancariosAdiantamento: {
	        banco: null,
	        agencia: null,
	        conta: null,
	        tipo: null
	      },
	      dataCorte: '2020-12-10',
	      data: [],
	      dataMenor: false,
	      items: [],
	      pesquisa: '',
	      listaHistorico: [],
	      adt: {},
	      adiant: [],
	      nota: {},
	      validacao: {},
	      adiantamento: {},
	      montaCronograma: [],
	      esconderHistorico: false,
	      visibleForm: false,
	      filtros: {
	        createdAt: null,
	        createdAtDate: null,
	        entityId: null,
	        project: null,
	        requestType: null
	      },
	      dadosHistorico: {
	        fk_processo: null,
	        id: null,
	        fk_usuario: null,
	        nome: null,
	        situacao: 'PADRAO',
	        inicio: null,
	        termino: null,
	        data_edicao: null,
	        tipo: null,
	        proxima_etapa: null,
	        etapa_anterior: null,
	        observacao: null
	      },
	      prop: null,
	      num: null,
	      etapa: null,
	      etapaHist: null,
	      projeto: null,
	      textoTipo: null,
	      loading: {
	        show: false
	      },
	      historicoAnt: [],
	      historicoBack: [],
	      bordered: true,
	      fields: [{ key: 'id', label: 'ID', sortable: true, thStyle: 'width: 5%; text-align: center', class: 'text-center' }, { key: 'tipo_solicitacao', label: 'Tipo de Solicitação', sortable: true, thStyle: 'width: 6%; text-align: center', class: 'text-center' }, { key: 'projeto', label: 'Projeto', sortable: true, thStyle: 'width: 34%; text-align: center', class: 'centraliza' }, { key: 'data_solicitacao', label: 'Data de Solicitação', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'valor', label: 'Valor', thStyle: 'text-align: center', class: 'text-center' }, { key: 'etapa', label: 'Etapa', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'situacao', label: 'Situação', thStyle: 'text-align: center', class: 'text-center', sortable: true }, { key: 'actions', label: 'Ações', thStyle: 'width: 25%; text-align: center', class: 'text-center' }],
	      table: {
	        currentPage: 0,
	        perPage: 10,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: true,
	        filter: null,
	        emptyText: 'Não tem nenhum registro para mostrar'
	      },
	      store: this.$store,
	      breadcrumb: [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Solcitações',
	        active: true
	      }],
	      possuiProcessoEmRevisao: false,
	      situacaoFiltro: null,
	      listaBackupFiltro: [],
	      bancosMain: [{ value: '001', label: 'Banco do Brasil S.A.' }, { value: '033', label: 'BANCO SANTANDER (BRASIL) S.A.' }, { value: '070', label: 'BRB – BANCO DE BRASILIA S.A.' }, { value: '104', label: 'CAIXA ECONOMICA FEDERAL' }, { value: '237', label: 'Banco Bradesco S.A.' }, { value: '341', label: 'ITAÚ UNIBANCO S.A.' }],
	      bancos: [{ value: '332', label: 'Acesso Soluções de Pagamento S.A.' }, { value: '117', label: 'ADVANCED CORRETORA DE CÂMBIO LTDA' }, { value: '272', label: 'AGK CORRETORA DE CAMBIO S.A.' }, { value: '349', label: 'AL5 S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { value: '313', label: 'AMAZÔNIA CORRETORA DE CÂMBIO LTDA.' }, { value: '188', label: 'ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS, CÂMBIO E VALORES' }, { value: '280', label: 'Avista S.A. Crédito, Financiamento e Investimento' }, { value: '080', label: 'B&T CORRETORA DE CAMBIO LTDA.' }, { value: '246', label: 'Banco ABC Brasil S.A.' }, { value: '075', label: 'Banco ABN Amro S.A.' }, { value: '121', label: 'Banco Agibank S.A.' }, { value: '025', label: 'Banco Alfa S.A.' }, { value: '065', label: 'Banco AndBank (Brasil) S.A.' }, { value: '213', label: 'Banco Arbi S.A.' }, { value: '096', label: 'Banco B3 S.A.' }, { value: '024', label: 'Banco Bandepe S.A.' }, { value: '330', label: 'BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.' }, { value: '318', label: 'Banco BMG S.A.' }, { value: '752', label: 'Banco BNP Paribas Brasil S.A.' }, { value: '107', label: 'Banco Bocom BBM S.A.' }, { value: '063', label: 'Banco Bradescard S.A.' }, { value: '036', label: 'Banco Bradesco BBI S.A.' }, { value: '122', label: 'Banco Bradesco BERJ S.A.' }, { value: '394', label: 'Banco Bradesco Financiamentos S.A.' }, { value: '218', label: 'Banco BS2 S.A.' }, { value: '208', label: 'Banco BTG Pactual S.A.' }, { value: '626', label: 'BANCO C6 CONSIGNADO S.A.' }, { value: '336', label: 'Banco C6 S.A.' }, { value: '473', label: 'Banco Caixa Geral – Brasil S.A.' }, { value: '412', label: 'BANCO CAPITAL S.A.' }, { value: '040', label: 'Banco Cargill S.A.' }, { value: '266', label: 'BANCO CEDULA S.A.' }, { value: '739', label: 'Banco Cetelem S.A.' }, { value: '233', label: 'Banco Cifra S.A.' }, { value: '745', label: 'Banco Citibank S.A.' }, { value: '241', label: 'BANCO CLASSICO S.A.' }, { value: '756', label: 'BANCO COOPERATIVO DO BRASIL S.A. – BANCOOB' }, { value: '748', label: 'BANCO COOPERATIVO SICREDI S.A.' }, { value: '222', label: 'BANCO CRÉDIT AGRICOLE BRASIL S.A.' }, { value: '505', label: 'Banco Credit Suisse (Brasil) S.A.' }, { value: '069', label: 'Banco Crefisa S.A.' }, { value: '368', label: 'Banco CSF S.A.' }, { value: '003', label: 'BANCO DA AMAZONIA S.A.' }, { value: '083', label: 'Banco da China Brasil S.A.' }, { value: '707', label: 'Banco Daycoval S.A.' }, { value: '300', label: 'Banco de la Nacion Argentina' }, { value: '495', label: 'Banco de La Provincia de Buenos Aires' }, { value: '654', label: 'BANCO DIGIMAIS S.A.' }, { value: '335', label: 'Banco Digio S.A.' }, { value: '047', label: 'Banco do Estado de Sergipe S.A.' }, { value: '037', label: 'Banco do Estado do Pará S.A.' }, { value: '041', label: 'Banco do Estado do Rio Grande do Sul S.A.' }, { value: '004', label: 'Banco do Nordeste do Brasil S.A.' }, { value: '265', label: 'Banco Fator S.A.' }, { value: '224', label: 'Banco Fibra S.A.' }, { value: '094', label: 'Banco Finaxis S.A.' }, { value: '390', label: 'BANCO GM S.A.' }, { value: '612', label: 'Banco Guanabara S.A.' }, { value: '269', label: 'BANCO HSBC S.A.' }, { value: '012', label: 'Banco Inbursa S.A.' }, { value: '604', label: 'Banco Industrial do Brasil S.A.' }, { value: '653', label: 'BANCO INDUSVAL S.A.' }, { value: '077', label: 'Banco Inter S.A.' }, { value: '249', label: 'Banco Investcred Unibanco S.A.' }, { value: '184', label: 'Banco Itaú BBA S.A.' }, { value: '029', label: 'Banco Itaú Consignado S.A.' }, { value: '479', label: 'Banco ItauBank S.A.' }, { value: '074', label: 'Banco J. Safra S.A.' }, { value: '376', label: 'BANCO J.P. MORGAN S.A.' }, { value: '217', label: 'Banco John Deere S.A.' }, { value: '076', label: 'Banco KDB do Brasil S.A.' }, { value: '757', label: 'BANCO KEB HANA DO BRASIL S.A.' }, { value: '600', label: 'Banco Luso Brasileiro S.A.' }, { value: '243', label: 'Banco Máxima S.A.' }, { value: '389', label: 'Banco Mercantil do Brasil S.A.' }, { value: '381', label: 'BANCO MERCEDES-BENZ DO BRASIL S.A.' }, { value: '370', label: 'Banco Mizuho do Brasil S.A.' }, { value: '746', label: 'Banco Modal S.A.' }, { value: '066', label: 'BANCO MORGAN STANLEY S.A.' }, { value: '456', label: 'Banco MUFG Brasil S.A.' }, { value: '007', label: 'BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL' }, { value: '169', label: 'BANCO OLÉ CONSIGNADO S.A.' }, { value: '079', label: 'Banco Original do Agronegócio S.A.' }, { value: '212', label: 'Banco Original S.A.' }, { value: '712', label: 'Banco Ourinvest S.A.' }, { value: '623', label: 'Banco Pan S.A.' }, { value: '611', label: 'Banco Paulista S.A.' }, { value: '643', label: 'Banco Pine S.A.' }, { value: '747', label: 'Banco Rabobank International Brasil S.A.' }, { value: '088', label: 'BANCO RANDON S.A.' }, { value: '633', label: 'Banco Rendimento S.A.' }, { value: '741', label: 'BANCO RIBEIRAO PRETO S.A.' }, { value: '120', label: 'BANCO RODOBENS S.A.' }, { value: '422', label: 'Banco Safra S.A.' }, { value: '743', label: 'Banco Semear S.A.' }, { value: '754', label: 'Banco Sistema S.A.' }, { value: '630', label: 'Banco Smartbank S.A.' }, { value: '366', label: 'BANCO SOCIETE GENERALE BRASIL S.A.' }, { value: '637', label: 'BANCO SOFISA S.A.' }, { value: '464', label: 'Banco Sumitomo Mitsui Brasileiro S.A.' }, { value: '082', label: 'BANCO TOPÁZIO S.A.' }, { value: '387', label: 'Banco Toyota do Brasil S.A.' }, { value: '634', label: 'BANCO TRIANGULO S.A.' }, { value: '018', label: 'Banco Tricury S.A.' }, { value: '393', label: 'Banco Volkswagen S.A.' }, { value: '655', label: 'Banco Votorantim S.A.' }, { value: '610', label: 'Banco VR S.A.' }, { value: '119', label: 'Banco Western Union do Brasil S.A.' }, { value: '124', label: 'Banco Woori Bank do Brasil S.A.' }, { value: '348', label: 'Banco XP S.A.' }, { value: '081', label: 'BancoSeguro S.A.' }, { value: '021', label: 'BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO' }, { value: '755', label: 'Bank of America Merrill Lynch Banco Múltiplo S.A.' }, { value: '268', label: 'BARI COMPANHIA HIPOTECÁRIA' }, { value: '378', label: 'BBC LEASING S.A. – ARRENDAMENTO MERCANTIL' }, { value: '250', label: 'BCV – BANCO DE CRÉDITO E VAREJO S.A.' }, { value: '144', label: 'BEXS BANCO DE CÂMBIO S/A' }, { value: '253', label: 'Bexs Corretora de Câmbio S/A' }, { value: '134', label: 'BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '017', label: 'BNY Mellon Banco S.A.' }, { value: '383', label: 'BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.' }, { value: '408', label: 'BÔNUSCRED SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '301', label: 'BPP Instituição de Pagamento S.A.' }, { value: '126', label: 'BR Partners Banco de Investimento S.A.' }, { value: '092', label: 'BRK S.A. Crédito, Financiamento e Investimento' }, { value: '173', label: 'BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '142', label: 'Broker Brasil Corretora de Câmbio Ltda.' }, { value: '292', label: 'BS2 Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '309', label: 'CAMBIONET CORRETORA DE CÂMBIO LTDA.' }, { value: '288', label: 'CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { value: '324', label: 'CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '130', label: 'CARUANA S.A. – SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { value: '159', label: 'Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor' }, { value: '114', label: 'Central Cooperativa de Crédito no Estado do Espírito Santo – CECOOP' }, { value: '091', label: 'CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S' }, { value: '320', label: 'China Construction Bank (Brasil) Banco Múltiplo S/A' }, { value: '362', label: 'CIELO S.A.' }, { value: '477', label: 'Citibank N.A.' }, { value: '180', label: 'CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '127', label: 'Codepe Corretora de Valores e Câmbio S.A.' }, { value: '163', label: 'Commerzbank Brasil S.A. – Banco Múltiplo' }, { value: '133', label: 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E' }, { value: '136', label: 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. – UNICRED DO BRASI' }, { value: '060', label: 'Confidence Corretora de Câmbio S.A.' }, { value: '085', label: 'Cooperativa Central de Crédito – Ailos' }, { value: '016', label: 'COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI' }, { value: '281', label: 'Cooperativa de Crédito Rural Coopavel' }, { value: '322', label: 'Cooperativa de Crédito Rural de Abelardo Luz – Sulcredi/Crediluz' }, { value: '391', label: 'COOPERATIVA DE CREDITO RURAL DE IBIAM – SULCREDI/IBIAM' }, { value: '286', label: 'COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO' }, { value: '350', label: 'COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE' }, { value: '279', label: 'COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' }, { value: '273', label: 'Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel' }, { value: '379', label: 'COOPERFORTE – COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS FUNCIONÁRIOS DE INSTIT' }, { value: '403', label: 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '098', label: 'Credialiança Cooperativa de Crédito Rural' }, { value: '010', label: 'CREDICOAMO CREDITO RURAL COOPERATIVA' }, { value: '089', label: 'CREDISAN COOPERATIVA DE CRÉDITO' }, { value: '097', label: 'Credisis – Central de Cooperativas de Crédito Ltda.' }, { value: '011', label: 'CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A' }, { value: '342', label: 'Creditas Sociedade de Crédito Direto S.A.' }, { value: '321', label: 'CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT' }, { value: '289', label: 'DECYSEO CORRETORA DE CAMBIO LTDA.' }, { value: '487', label: 'DEUTSCHE BANK S.A. – BANCO ALEMAO' }, { value: '140', label: 'Easynvest – Título Corretora de Valores SA' }, { value: '149', label: 'Facta Financeira S.A. – Crédito Financiamento e Investimento' }, { value: '196', label: 'FAIR CORRETORA DE CAMBIO S.A.' }, { value: '343', label: 'FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.' }, { value: '382', label: 'FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L' }, { value: '331', label: 'Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '285', label: 'Frente Corretora de Câmbio Ltda.' }, { value: '278', label: 'Genial Investimentos Corretora de Valores Mobiliários S.A.' }, { value: '364', label: 'GERENCIANET S.A.' }, { value: '138', label: 'Get Money Corretora de Câmbio S.A.' }, { value: '384', label: 'GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO' }, { value: '064', label: 'GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.' }, { value: '177', label: 'Guide Investimentos S.A. Corretora de Valores' }, { value: '146', label: 'GUITTA CORRETORA DE CAMBIO LTDA.' }, { value: '078', label: 'Haitong Banco de Investimento do Brasil S.A.' }, { value: '062', label: 'Hipercard Banco Múltiplo S.A.' }, { value: '189', label: 'HS FINANCEIRA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' }, { value: '396', label: 'HUB PAGAMENTOS S.A' }, { value: '271', label: 'IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { value: '157', label: 'ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.' }, { value: '132', label: 'ICBC do Brasil Banco Múltiplo S.A.' }, { value: '492', label: 'ING Bank N.V.' }, { value: '139', label: 'Intesa Sanpaolo Brasil S.A. – Banco Múltiplo' }, { value: '652', label: 'Itaú Unibanco Holding S.A.' }, { value: '488', label: 'JPMorgan Chase Bank, National Association' }, { value: '399', label: 'Kirton Bank S.A. – Banco Múltiplo' }, { value: '293', label: 'Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { value: '105', label: 'Lecca Crédito, Financiamento e Investimento S/A' }, { value: '145', label: 'LEVYCAM – CORRETORA DE CAMBIO E VALORES LTDA.' }, { value: '397', label: 'LISTO SOCIEDADE DE CREDITO DIRETO S.A.' }, { value: '113', label: 'Magliano S.A. Corretora de Cambio e Valores Mobiliarios' }, { value: '323', label: 'MERCADOPAGO.COM REPRESENTACOES LTDA.' }, { value: '274', label: 'MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT' }, { value: '259', label: 'MONEYCORP BANCO DE CÂMBIO S.A.' }, { value: '128', label: 'MS Bank S.A. Banco de Câmbio' }, { value: '377', label: 'MS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA' }, { value: '354', label: 'NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES' }, { value: '191', label: 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.' }, { value: '753', label: 'Novo Banco Continental S.A. – Banco Múltiplo' }, { value: '260', label: 'Nu Pagamentos S.A.' }, { value: '111', label: 'OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.' }, { value: '319', label: 'OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '613', label: 'Omni Banco S.A.' }, { value: '325', label: 'Órama Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '355', label: 'ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '290', label: 'Pagseguro Internet S.A.' }, { value: '254', label: 'PARANÁ BANCO S.A.' }, { value: '326', label: 'PARATI – CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { value: '194', label: 'PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '174', label: 'PEFISA S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { value: '315', label: 'PI Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '380', label: 'PICPAY SERVICOS S.A.' }, { value: '100', label: 'Planner Corretora de Valores S.A.' }, { value: '125', label: 'Plural S.A. Banco Múltiplo' }, { value: '093', label: 'PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT' }, { value: '108', label: 'PORTOCRED S.A. – CREDITO, FINANCIAMENTO E INVESTIMENTO' }, { value: '306', label: 'PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { value: '329', label: 'QI Sociedade de Crédito Direto S.A.' }, { value: '283', label: 'RB CAPITAL INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LIMITADA' }, { value: '374', label: 'REALIZE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { value: '101', label: 'RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '270', label: 'Sagitur Corretora de Câmbio Ltda.' }, { value: '751', label: 'Scotiabank Brasil S.A. Banco Múltiplo' }, { value: '276', label: 'Senff S.A. – Crédito, Financiamento e Investimento' }, { value: '545', label: 'SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A' }, { value: '190', label: 'SERVICOOP – COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN' }, { value: '363', label: 'SOCOPA SOCIEDADE CORRETORA PAULISTA S.A.' }, { value: '183', label: 'SOCRED S.A. – SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P' }, { value: '365', label: 'SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS' }, { value: '299', label: 'SOROCRED   CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { value: '014', label: 'STATE STREET BRASIL S.A. ? BANCO COMERCIAL' }, { value: '197', label: 'Stone Pagamentos S.A.' }, { value: '404', label: 'SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '340', label: 'Super Pagamentos e Administração de Meios Eletrônicos S.A.' }, { value: '307', label: 'Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { value: '352', label: 'TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '095', label: 'Travelex Banco de Câmbio S.A.' }, { value: '143', label: 'Treviso Corretora de Câmbio S.A.' }, { value: '360', label: 'TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { value: '131', label: 'TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA' }, { value: '129', label: 'UBS Brasil Banco de Investimento S.A.' }, { value: '015', label: 'UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { value: '099', label: 'UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.' }, { value: '084', label: 'UNIPRIME NORTE DO PARANÁ – COOPERATIVA DE CRÉDITO LTDA' }, { value: '373', label: 'UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.' }, { value: '298', label: 'Vip’s Corretora de Câmbio Ltda.' }, { value: '296', label: 'VISION S.A. CORRETORA DE CAMBIO' }, { value: '367', label: 'VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { value: '310', label: 'VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { value: '371', label: 'WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.' }, { value: '102', label: 'XP INVESTIMENTOS CORRETORA DE CÂMBIO,TÍTULOS E VALORES MOBILIÁRIOS S/A' }, { value: '359', label: 'ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A' }],
	      acessoReativarLiberacaoRecursos: false,
	      ehParceiroEstrategico: false
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    sortOptions: function sortOptions() {
	      return this.fields.table.filter(function (f) {
	        return f.sortable;
	      }).map(function (f) {
	        return { text: f.label, value: f.key };
	      });
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    chiefActive: function chiefActive() {
	      return this.usuarioLogado.entity.chiefs.some(function (chefe) {
	        return chefe.active === true && (0, _moment2.default)(new Date()).isSameOrAfter((0, _moment2.default)(chefe.initialMandateDate)) && (0, _moment2.default)(new Date()).isSameOrBefore((0, _moment2.default)(chefe.endMandateDate));
	      });
	    }
	  }),
	  created: function created() {
	    if (!this.usuarioLogado) {
	      return;
	    }
	    this.ehParceiroEstrategico = Array.isArray(this.usuarioLogado.perfis) && this.usuarioLogado.perfis.some(function (perfil) {
	      return perfil.ds_nome === 'Parceiro Estratégico';
	    });
	    if (!this.ehParceiroEstrategico) {
	      this.verificaSimplificado();
	      this.consultaAcessoReativacaoLiberacaoRecursos();
	      if (this.usuarioLogado.userType !== 'FUNDACAO') {
	        _.set(this.fields, '[7].thStyle', 'width: 15%; text-align: center');
	        this.onSearch();
	      }
	      if (this.usuarioLogado.userType === 'FUNDACAO') {
	        this.todasPropostasSimplificadas = false;
	      }
	    }
	  },
	  mounted: function mounted() {},
	  methods: {
	    verificaSimplificado: function verificaSimplificado() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var idEntidade;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('verificaSimplificado');
	
	                if (!(_this.usuarioLogado.userType !== 'FUNDACAO')) {
	                  _context.next = 5;
	                  break;
	                }
	
	                idEntidade = _this.usuarioLogado.entity.id;
	                _context.next = 5;
	                return axiosLaravel.get('prestacaoSimplificada/ehPropostaSimplificada/' + idEntidade).then(function (response) {
	                  _this.todasPropostasSimplificadas = response.data;
	                  console.log('simplificado', _this.todasPropostasSimplificadas);
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this.$root.trataErro(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    buscaDadosBancariosAdiantamento: function buscaDadosBancariosAdiantamento(idSolicitacao) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                axiosLaravel.get('processos/dados_bancarios_adiantamento/' + idSolicitacao).then(function (response) {
	                  _this2.dadosBancariosAdiantamento.banco = response.data[0].banco;
	                  _this2.dadosBancariosAdiantamento.agencia = response.data[0].agencia;
	                  _this2.dadosBancariosAdiantamento.conta = response.data[0].conta;
	                  _this2.dadosBancariosAdiantamento.tipo = response.data[0].tipo;
	                  _this2.$forceUpdate();
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this2.$root.trataErro(error);
	                });
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    validaTipoFase: function validaTipoFase(request) {
	      var validate = true;
	      if (request.etapa === 'Revisão pela entidade' && request.situacao === 'Em Execução') {
	        this.possuiProcessoEmRevisao = true;
	      }
	
	      if (_.includes(['Pagamento', 'Ressarcimento', 'Contrapartida'], request.tipo_solicitacao)) {
	        if (request.situacao === 'Feito') {
	          validate = false;
	        } else if (request.situacao === 'Cancelado') {
	          validate = false;
	        }
	      }
	      if (request.tipo_solicitacao === 'Prestação de Contas') {
	        if (request.situacao === 'Cancelado' || request.etapa === 'Revisão pela entidade' || request.situacao === 'Feito') {
	          validate = false;
	        }
	      }
	      if (request.tipo_solicitacao === 'Adiantamento' || request.tipo_solicitacao === 'Devolução de Adiantamento') {
	        if (request.situacao === 'Cancelado' || request.etapa === 'Revisão pela entidade' || request.etapa === 'Análise Financeira' && request.situacao === 'Feito') {
	          validate = false;
	        }
	      }
	
	      return validate;
	    },
	    show: function show(row) {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (row.item.tipo_solicitacao === 'Pagamento') {
	                  _this3.$router.push({ name: 'solicitacao-pagamento', params: { id: row.item.id, visualizacao: true } });
	                } else if (row.item.tipo_solicitacao === 'Contrapartida') {
	                  _this3.$router.push({ name: 'solicitacao-contrapartida', params: { id: row.item.id, visualizacao: true } });
	                } else if (row.item.tipo_solicitacao === 'Prestação de Contas') {
	                  _this3.$router.push({ name: 'solicitacao-prestacaocontas', params: { id: row.item.id, visualizacao: true } });
	                } else if (row.item.tipo_solicitacao === 'Ressarcimento') {
	                  _this3.$router.push({ name: 'solicitacao-ressarcimento', params: { id: row.item.id, visualizacao: true } });
	                } else if (row.item.tipo_solicitacao === 'Adiantamento') {
	                  _this3.$router.push({ name: 'solicitacao-adiantamento', params: { id: row.item.id, visualizacao: true } });
	                } else if (row.item.tipo_solicitacao === 'Devolução de Adiantamento') {
	                  _this3.$router.push({ name: 'solicitacao-devolucao-adiantamento', params: { id: row.item.id, visualizacao: true } });
	                } else if (row.item.tipo_solicitacao === 'Alterações do Projeto') {
	                  _this3.$router.push({ name: 'solicitacao-alteracoes-projeto-visualizacao', params: { id: row.item.id, visualizacao: true } });
	                }
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    hide: function hide() {
	      this.prop = '';
	      this.num = '';
	      this.etapa = '';
	      this.documentos = {};
	      this.montaCronograma = [];
	      this.historicoBack = [];
	      this.historicoAnt = [];
	      this.$modal.hide('visualizar');
	    },
	    carregaTarefa: function carregaTarefa() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this4.prop = '';
	                _this4.num = '';
	                _this4.etapa = '';
	                _this4.serie = '';
	                _this4.numero = '';
	                _this4.emissao = '';
	                _this4.validade = '';
	                _this4.prioridade = '';
	                _this4.cep = '';
	                _this4.endereco = '';
	                _this4.identificador = '';
	                _this4.nomeFornecedor = '';
	                _this4.tipoPessoa = '';
	                _this4.forma = '';
	                _this4.textoTipo = '';
	                _this4.montaCronograma = [];
	                _context4.next = 18;
	                return _this4.buscaHistorico(_this4.row.item.id);
	
	              case 18:
	                _context4.next = 20;
	                return axiosLaravel.get('processos/' + _this4.row.item.id).then(function (response) {
	                  _this4.req = response.data;
	
	                  _this4.dataProcesso = (0, _moment2.default)(_this4.req.inicio);
	
	                  if ((0, _moment2.default)(_this4.dataProcesso).isSameOrBefore((0, _moment2.default)(_this4.dataCorte))) {
	                    _this4.dataMenor = true;
	                  } else {
	                    _this4.dataMenor = false;
	                  }
	                  _this4.$emit('historico', response.data.tarefas);
	
	                  _this4.etapa = _this4.req.tarefas[0].nome;
	                  _this4.textoTipo = _this4.req.nome;
	                  if (_this4.textoTipo === 'Adiantamento' || _this4.textoTipo === 'Devolução de Adiantamento') {
	                    _this4.prop = _this4.req.documentos_liberacao[0].itens_liberados[0].parcelas_adiantamentos[0].proposta.ds_nome;
	                    _this4.num = _this4.req.documentos_liberacao[0].itens_liberados[0].parcelas_adiantamentos[0].proposta.ds_codigo_projeto_erp;
	                    _this4.itemAdt = _this4.req.documentos_liberacao[0].itens_liberados[0].parcelas_adiantamentos;
	                    _this4.vlrAdt = _this4.req.documentos_liberacao[0].itens_liberados[0].valor;
	
	                    _this4.carregaAdiantamentos();
	                    _this4.$forceUpdate();
	                  } else {
	                    _this4.prop = _this4.req.documentos_liberacao[0].itens_liberados[0].itens_orcamentos[0].proposta.ds_nome;
	                    _this4.num = _this4.req.documentos_liberacao[0].itens_liberados[0].itens_orcamentos[0].proposta.ds_codigo_projeto_erp;
	                  }
	
	                  _this4.situacao = _this4.req.situacao;
	                  _this4.documentos = _this4.req.documentos_liberacao[0];
	                  if (_.includes(['Pagamento', 'Prestação de Contas', 'Ressarcimento'], _this4.textoTipo)) {
	                    _this4.serie = _this4.req.documentos_liberacao[0].serie;
	                    _this4.numero = _this4.req.documentos_liberacao[0].numero;
	                    _this4.emissao = _this4.req.documentos_liberacao[0].emissao;
	
	                    _this4.validade = _this4.req.documentos_liberacao[0].validade;
	                    _this4.formaPagamento = _this4.req.documentos_liberacao[0].forma_pagamento;
	                    if (_this4.req.documentos_liberacao[0].prioridade === 0) {
	                      _this4.prioridade = 'Não';
	                    } else {
	                      _this4.prioridade = 'Sim';
	                    }
	                    if (_.includes(['Pagamento', 'Prestação de Contas', 'Ressarcimento'], _this4.textoTipo)) {
	                      _this4.fornecedor = _this4.req.documentos_liberacao[0].dados_bancarios.fornecedor;
	                      _this4.cep = _this4.fornecedor.cep;
	                      _this4.endereco = _this4.fornecedor.endereco;
	                      _this4.identificador = _this4.fornecedor.identificador;
	                      _this4.nomeFornecedor = _this4.fornecedor.nome;
	                      _this4.banco = _this4.req.documentos_liberacao[0].dados_bancarios.banco;
	                      _this4.agencia = _this4.req.documentos_liberacao[0].dados_bancarios.agencia;
	                      _this4.conta = _this4.req.documentos_liberacao[0].dados_bancarios.conta;
	                    }
	                    if (_this4.textoTipo !== 'Contrapartida') {
	                      _this4.carregaAdiantamentos();
	                      _this4.$forceUpdate();
	                    }
	                    _this4.$forceUpdate();
	                    if (_this4.fornecedor.identificador.length > 11) {
	                      _this4.texto = 'CNPJ:';
	                      _this4.tipoPessoa = 'Pessoa Jurídica';
	                      _this4.mascara = '99.999.999/9999-99';
	                    } else {
	                      _this4.texto = 'CPF:';
	                      _this4.tipoPessoa = 'Pessoa Física';
	                      _this4.mascara = '999.999.999-99';
	                    }
	                    switch (_this4.formaPagamento) {
	                      case 1:
	                        _this4.forma = 'Dinheiro';
	                        break;
	                      case 2:
	                        _this4.forma = 'Crédito Conta Beneficiário';
	                        break;
	                      case 3:
	                        _this4.forma = 'Crédito Conta Fornecedor';
	                        break;
	                      case 4:
	                        _this4.forma = 'Docum. Código de Barras';
	                        break;
	                      case 5:
	                        _this4.forma = 'DDA - Débito direto autorizado';
	                        break;
	                      default:
	                        _this4.forma = '';
	                    }
	                  }
	                  if (_this4.textoTipo === 'Adiantamento' || _this4.textoTipo === 'Devolução de Adiantamento') {
	                    if (_.isNull(_this4.req.documentos_liberacao[0].documentos_adiantamento)) {
	                      _this4.documentosAnexo = _this4.req.documentos_liberacao[0].documentos_anexos_adiantamento;
	                    } else {
	                      _this4.documentosAnexo = _this4.req.documentos_liberacao[0].documentos_adiantamento;
	                    }
	                  } else {
	                    _this4.documentosAnexo = _this4.req.documentos_liberacao[0].documentos;
	                  }
	
	                  _this4.tarefas = _this4.req.tarefas;
	                  var array = [];
	                  for (var i = 0; i < _this4.tarefas.length; i++) {
	                    if (_this4.tarefas[i].tipo === 'Usuário') {
	                      array.push(_this4.tarefas[i]);
	                    }
	                  }
	                  _this4.listaHistorico = _.cloneDeep(array);
	                  for (var _i = 0; _i < _this4.listaHistorico.length; _i++) {
	                    if (_this4.listaHistorico[_i].usuario !== null) {
	                      _this4.usuario = _this4.listaHistorico[_i].usuario.ds_nome_usuario;
	                    }
	                  }
	                  var arrayAnt = _this4.listaHistorico.filter(function (item) {
	                    return item.tipo === 'Usuário' && !_.isNull(item.termino);
	                  });
	                  _this4.historicoAnt = arrayAnt;
	                  _this4.etapaHist = _this4.listaHistorico[0].nome;
	                  _this4.historico();
	                  _this4.$forceUpdate();
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this4.$root.trataErro(error);
	                });
	
	              case 20:
	                _this4.$forceUpdate();
	
	              case 21:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this4);
	      }))();
	    },
	    carregaAdiantamentos: function carregaAdiantamentos() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var totalSolicitation, proj, totalValue;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                totalSolicitation = 0;
	                proj = '';
	
	                _this5.montaCronograma = [];
	                if (_this5.textoTipo === 'Adiantamento' || _this5.textoTipo === 'Devolução de Adiantamento') {
	                  proj = _this5.req.documentos_liberacao[0].itens_liberados[0].parcelas_adiantamentos[0].proposta.id;
	                } else {
	                  proj = _this5.req.documentos_liberacao[0].itens_liberados[0].itens_orcamentos[0].proposta.id;
	                }
	                totalValue = 0;
	                _context5.next = 7;
	                return axiosLaravel.get('processos/adiantamento/recursos/' + proj).then(function (response) {
	                  if (_.includes(['Pagamento', 'Ressarcimento'], _this5.textoTipo)) {
	                    _this5.adiantamento = response.data.adiantamentos_concedidos.row;
	                  }
	                  if (_.includes(['Prestação de Contas', 'Adiantamento', 'Devolução de Adiantamento'], _this5.textoTipo)) {
	                    _this5.adiantamento = response.data.adiantamentos_concedidos.row[0];
	                  }
	                  _this5.$forceUpdate();
	                  _this5.parcelas = response.data.parcels.row;
	                  for (var _i2 = 0; _i2 < _this5.parcelas.length; _i2++) {
	                    totalSolicitation += _this5.parcelas[_i2].totalValueAdvanceRequest;
	
	                    totalValue += _this5.parcelas[_i2].totalValueAdvance;
	                  }
	                  _this5.totalSolicitation = totalSolicitation;
	                  _this5.totalValue = totalValue;
	                  _this5.balanceSolicitation = totalValue - _this5.totalSolicitation;
	                  _this5.adiantamento.limitDate = '';
	
	                  for (var i = 0; i < _this5.adiantamento.length; i++) {
	                    _this5.adiantamento[i].createDate = (0, _moment2.default)(_this5.adiantamento[i].data_solicitacao).format('DD/MM/YYYY');
	                    _this5.adiantamento[i].limitDate = (0, _moment2.default)(_this5.adiantamento[i].createDate, 'DD-MM-YYYY').add(90, 'days').format('DD/MM/YYYY');
	                    _this5.adiantamento[i].lastParcelDate = (0, _moment2.default)(_this5.adiantamento[i].accountabilityDate).format('DD/MM/YYYY');
	                  }
	                }).catch(function (error) {
	                  console.log('error', error);
	                  this.$root.trataErro(error);
	                });
	
	              case 7:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this5);
	      }))();
	    },
	    historico: function historico() {
	      var _this6 = this;
	
	      var id = 0;
	      this.historicoTarefas = [];
	      this.montaCronograma = [];
	      this.valorTotal = 0;
	      if (this.req.situacao === 'Feito') {
	        if (this.req.nome === 'Contrapartida') {
	          id = this.listaHistorico[0].id;
	        }
	      } else {
	        id = this.listaHistorico[1].id;
	      }
	      if (!id) {
	        id = this.listaHistorico[0].id;
	      }
	      axiosLaravel.get('processos/tarefas/buscahistorico/' + id).then(function (response) {
	        _this6.montaCronograma = response.data.cronogramaHistorico.dados.itens.row;
	        var array = [];
	        for (var i = 0; i < _this6.montaCronograma.length; i++) {
	          if (_this6.montaCronograma[i].Valor_solicitado > 0 && _this6.montaCronograma[i].Qtde_solicitado > 0) {
	            array.push(_this6.montaCronograma[i]);
	          }
	        }
	
	        _this6.montaCronograma = _.cloneDeep(array);
	
	        for (var j = 0; j < _this6.montaCronograma.length; j++) {
	          _this6.valorTotal += parseFloat(_this6.montaCronograma[j].Valor_solicitado);
	        }
	        _this6.$forceUpdate();
	      }).catch(function (error) {
	        this.$root.trataErro(error);
	      });
	      this.$forceUpdate();
	    },
	    showCancelCounterPartButton: function showCancelCounterPartButton(request) {
	      var validate = true;
	
	      if (request.requestType === 'COUNTERPART') {
	        if (request.approvalResult === 'CANCELED' || request.approvalResult === 'APPROVED' || request.approvalResult === 'RETURN_TO_ENTITY' || request.approvalResult === 'REVIEW' || request.eventType === 'COUNTERPART_REVIEW') {
	          validate = false;
	        }
	      }
	      return validate;
	    },
	    showCancelButton: function showCancelButton(request) {
	      var validate = true;
	
	      if (this.usuarioLogado.userType === 'ENTIDADE') {
	        if (request.situacao === 'Cancelado' || request.situacao === 'Feito' || request.etapa !== 'Revisão pela entidade') {
	          validate = false;
	        }
	      } else {
	        if (_.includes(['Pagamento', 'Ressarcimento', 'Contrapartida', 'Alterações do Projeto'], request.tipo_solicitacao)) {
	          if (request.situacao === 'Cancelado' || request.situacao === 'Feito' || request.etapa === 'Autorização' || request.etapa === 'Liquidação') {
	            validate = false;
	          }
	        }
	        if (request.tipo_solicitacao === 'Migração') {
	          validate = false;
	        }
	        if (request.tipo_solicitacao === 'Prestação de Contas') {
	          if (request.situacao === 'Cancelado' || request.situacao === 'Feito' || request.etapa === 'Autorização' || request.etapa === 'Liquidação') {
	            validate = false;
	          }
	        }
	        if (request.tipo_solicitacao === 'Adiantamento') {
	          if (request.situacao === 'Cancelado' || request.situacao === 'Feito') {
	            validate = false;
	          }
	        }
	        if (request.tipo_solicitacao === 'Devolução de Adiantamento') {
	          if (request.situacao === 'Cancelado' || request.situacao === 'Feito') {
	            validate = false;
	          }
	        }
	      }
	      return validate;
	    },
	    segueReativar: function segueReativar(processo) {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                console.log('segueReativar - processo: ' + processo.id);
	                _this7.$aguarde('Reativando solicitação. Por favor, aguarde...');
	                _context7.next = 4;
	                return axiosLaravel.put('processos/reativar/' + processo.id).then(function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(response) {
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            console.log('response.data RLMB', response.data);
	
	                            _this7.$snotify.clear();
	                            _this7.$snotify.success('Solicitação reativada com sucesso!');
	                            processo.situacao = 'Análise';
	                            _this7.$forceUpdate();
	
	                          case 5:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this7);
	                  }));
	
	                  return function (_x) {
	                    return _ref.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this7.$snotify.clear();
	                  _this7.$root.trataErro(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this7);
	      }))();
	    },
	    solicitacaoReativar: function solicitacaoReativar(processo) {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        var tipo, id, projeto, $message;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                tipo = processo.tipo_solicitacao;
	                id = processo.id;
	                projeto = processo.projeto;
	                $message = 'Deseja <b>REATIVAR</b> a solicitação de <font color=\'red\'>' + tipo + '</font>? <br><br> - ID: <i><font color=\'#00008b\'>' + id + '</font></i><br> - Projeto: <i><font color=\'#00008b\'>' + projeto + '</font></i></i>' + '</br></br></br> <form><font color="red"> Ao prosseguir com a solicitação declaro que informei a Gefic e estou ciente das implicações decorrentes desta reativação.</font></label></form></div>';
	
	                _this8.$dialog.confirm($message).then(function ($dialog) {
	                  _this8.segueReativar(processo);
	                }).catch(function (error) {
	                  this.$snotify.clear();
	                  this.$root.trataErro(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this8);
	      }))();
	    },
	    segueRetornarTarefa: function segueRetornarTarefa(retorno, processo) {
	      var _this9 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _this9.$aguarde('Retornando tarefa para a FBB. Por favor, aguarde...');
	                _context10.next = 3;
	                return axiosLaravel.put('processos/retornarFBB/' + processo.id).then(function () {
	                  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(response) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            console.log('response.data RLMB 1', response.data);
	
	                            _this9.$snotify.clear();
	                            _this9.$snotify.success('Solicitação retornada para a FBB!');
	                            processo.etapa = 'Análise';
	                            processo.situacao = 'Em Execução';
	                            _this9.$forceUpdate();
	
	                          case 6:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this9);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this9.$snotify.clear();
	                  _this9.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this9);
	      }))();
	    },
	    revisaoEntidadeTarefa: function revisaoEntidadeTarefa(retorno, processo) {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _this10.$aguarde('Encaminhando a tarefa para revisão pela Entidade. Por favor, aguarde...');
	                _context12.next = 3;
	                return axiosLaravel.put('processos/revisarEntidade/' + processo.id).then(function () {
	                  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(response) {
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            console.log('response.data revisaoEntidadeTarefa 1', response.data);
	
	                            _this10.$snotify.clear();
	                            _this10.$snotify.success('Solicitação retomada para revisão pela Entidade!');
	                            processo.etapa = 'Revisão pela entidade';
	                            processo.situacao = 'Em Execução';
	                            _this10.$forceUpdate();
	
	                          case 6:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this10);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this10.$snotify.clear();
	                  _this10.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this10);
	      }))();
	    },
	    gravaHistorico: function gravaHistorico(_parm) {},
	    segueReanalisar: function segueReanalisar(processo) {
	      var _this11 = this;
	
	      this.$aguarde('Encaminhando para reanálise da solicitação. Por favor, aguarde...');
	      axiosLaravel.put('processos/reanalisar/' + processo.id).then(function (response) {
	        _this11.$forceUpdate();
	        _this11.$snotify.clear();
	        _this11.$snotify.success('Solicitação devolvida para reanálise! Abrindo a tarefa. Aguarde...');
	        processo.etapa = 'Análise';
	        processo.situacao = 'Em Execução';
	        _this11.segueValidacao(processo);
	        _this11.$forceUpdate();
	      }).catch(function (error) {
	        _this11.$snotify.clear();
	        _this11.$root.trataErro(error);
	      });
	    },
	    onDownloadZIP: function onDownloadZIP(item) {
	      var _this12 = this;
	
	      _.set(item, 'downloading', '1');
	      this.$forceUpdate();
	      axiosLaravel.get('processos/documentos/download/' + item.id).then(function (response) {
	        var link = document.createElement('a');
	        link.href = response.data;
	        link.download = 'Arquivo não localizado';
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	        _.unset(item, 'downloading');
	        _this12.$forceUpdate();
	      }).catch(function (error) {
	        _this12.$root.trataErro(error);
	      });
	    },
	    buscaHistorico: function buscaHistorico(request) {
	      var _this13 = this;
	
	      axiosLaravel.post('historico-tarefas/lista', { 'parametro': request }).then(function (response) {
	        _this13.historicoBack = response.data;
	
	        if (!_.find(_this13.historicoBack, { proxima_etapa: 'Conclusão' }) && _this13.req.situacao === 'Feito') {
	          console.log('não encontrou no find');
	          _this13.historicoBack.push({ fk_processo: _this13.req.id, fk_tarefa: _this13.req.tarefas[0].id, fk_usuario: _this13.req.tarefas[0].usuario.id, nome: 'AUTORIZACAO', proxima_etapa: 'Conclusão', usuario: _this13.req.tarefas[0].usuario, data_edicao: _this13.req.tarefas[0].data_edicao, termino: _this13.req.tarefas[0].termino, observacao: _this13.req.tarefas[0].observacao });
	        }
	        if (!_this13.historicoBack) {
	          _this13.esconderHistorico = false;
	        } else if (_this13.historicoBack && !_.isNull(_this13.historicoBack) && !_.isEmpty(_this13.historicoBack)) {
	          _this13.esconderHistorico = false;
	        } else {
	          _this13.esconderHistorico = true;
	        }
	        _this13.$forceUpdate();
	        console.log('response historicoBack', response.data);
	      });
	    },
	    marcaAssumido: function marcaAssumido(_request) {},
	    marcaReativado: function marcaReativado(_request) {
	      var _this14 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this14);
	      }))();
	    },
	    marcaCancelado: function marcaCancelado(_request) {
	      var _this15 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this15);
	      }))();
	    },
	
	    segueValidacao: function segueValidacao(request) {
	      var _this16 = this;
	
	      if (this.autorizaValidacao(request)) {
	        if (request.id_usuario === null || request.id_usuario === 'null' || request.id_usuario !== this.usuarioLogado.id) {
	          var atual = request.id_tarefa_atual;
	          axiosLaravel.put('processos/validacao/assumir/', { 'id_tarefa': atual, 'item': request }).then(function (response) {
	            if (response.statusText === 'OK') {
	              _this16.goToApproval(request);
	            }
	          });
	        } else if (request.id_usuario === this.usuarioLogado.id) {
	          this.goToApproval(request);
	        } else {
	          var _atual = request.id_tarefa_atual;
	          axiosLaravel.put('processos/validacao/assumir/', { 'id_tarefa': _atual, 'item': request }).then(function (response) {
	            if (response.statusText === 'OK') {
	              _this16.goToApproval(request);
	            }
	          });
	        }
	      }
	    },
	    onValidate: function onValidate(request) {
	      var _this17 = this;
	
	      if (_.includes(['Adiantamento', 'Devolução de Adiantamento', 'Pagamento', 'Ressarcimento', 'Prestação de Contas', 'Contrapartida'], request.tipo_solicitacao)) {
	        this.segueValidacao(request);
	        return;
	      }
	      this.$aguarde('Buscando validação. Por favor, aguarde...');
	      axiosLaravel.get('processos/' + request.id).then(function (response) {
	        _this17.validacao = response.data;
	        _this17.validacao.processo = _.omit(response.data, ['documentos_liberacao', 'tarefas']);
	        _this17.historicoTarefas = _.cloneDeep(response.data.tarefas);
	        var array = _this17.historicoTarefas.filter(function (item) {
	          return item.tipo === 'Usuário';
	        });
	        _this17.historicoTarefas = _.cloneDeep(array);
	        for (var i = 0; i < _this17.historicoTarefas.length; i++) {
	          if (_this17.historicoTarefas.usuario !== null) {
	            _this17.usuario = _this17.historicoTarefas.usuario;
	          }
	        }
	        _this17.nota = _.cloneDeep(_this17.validacao.documentos_liberacao);
	        _this17.$forceUpdate();
	        _this17.textoTipo = _this17.validacao.nome;
	        if (_this17.autorizaValidacao(request)) {
	          if (request.id === null || request.id === 'null' || request.id !== _this17.usuarioLogado.id) {
	            _this17.onAssign(request, false);
	          } else if (request.id === _this17.usuarioLogado.id) {
	            _this17.visibleForm = !_this17.visibleForm;
	          } else {
	            _this17.onAssign(request, true);
	          }
	        }
	        _this17.$snotify.clear();
	        _this17.$snotify.success('Dados carregados com sucesso!');
	      }).catch(function (error) {
	        _this17.$snotify.clear();
	        console.log('error', error);
	        _this17.$root.trataErro(error);
	      });
	    },
	    revisar: function revisar(item) {
	      var _this18 = this;
	
	      var atual = item.id_tarefa_atual;
	      if (this.usuarioLogado.userType === 'ENTIDADE') {
	        if (item.tipo_solicitacao === 'Devolução de Adiantamento') {
	          this.$router.push('/solicitacao/devolucao_adiantamento/' + item.id);
	        }
	        if (item.tipo_solicitacao === 'Adiantamento') {
	          this.$router.push('/solicitacao/adiantamento/' + item.id);
	        }
	        if (item.tipo_solicitacao === 'Contrapartida') {
	          this.$router.push('/solicitacao/contrapartida/' + item.id);
	        }
	        if (item.tipo_solicitacao === 'Prestação de Contas') {
	          this.$router.push('/solicitacao/prestacaocontas/' + item.id);
	        }
	        if (item.tipo_solicitacao === 'Pagamento') {
	          this.$router.push('/solicitacao/pagamento/' + item.id);
	        }
	        if (item.tipo_solicitacao === 'Ressarcimento') {
	          this.$router.push({ path: '/solicitacao/ressarcimento/' + item.id });
	        }
	        if (item.tipo_solicitacao === 'Alterações do Projeto') {
	          this.$router.push({ name: 'solicitacao-alteracoes-projeto', params: { id: item.id } });
	        }
	      } else {
	        axiosLaravel.put('processos/validacao/assumir/', { 'id_tarefa': atual }).then(function (response) {
	          if (response.statusText === 'OK') {
	            if (item.tipo_solicitacao === 'Devolução de Adiantamento') {
	              _this18.$router.push('/solicitacao/devolucao_adiantamento/' + item.id);
	            }
	            if (item.tipo_solicitacao === 'Adiantamento') {
	              _this18.$router.push('/solicitacao/adiantamento/' + item.id);
	            }
	            if (item.tipo_solicitacao === 'Contrapartida') {
	              _this18.$router.push({ path: '/solicitacao/contrapartida/' + item.id });
	            }
	            if (item.tipo_solicitacao === 'Prestação de Contas') {
	              _this18.$router.push({ path: '/solicitacao/prestacaocontas/' + item.id });
	            }
	            if (item.tipo_solicitacao === 'Pagamento') {
	              _this18.$router.push({ path: '/solicitacao/pagamento/' + item.id });
	            }
	            if (item.tipo_solicitacao === 'Ressarcimento') {
	              _this18.$router.push({ path: '/solicitacao/ressarcimento/' + item.id });
	            }
	          }
	        });
	      }
	    },
	    onAssign: function onAssign(request) {
	      var _this19 = this;
	
	      var atual = request.id_tarefa_atual;
	      axiosLaravel.put('processos/validacao/assumir/', { 'id_tarefa': atual }).then(function (response) {
	        if (response.statusText === 'OK') {
	          _this19.visibleForm = !_this19.visibleForm;
	        }
	      });
	    },
	    goToApproval: function goToApproval(request) {
	      var path = '';
	      var typePhase = this.getTypePhase(request);
	      if (request.tipo_solicitacao === 'Pagamento' || typePhase === 'PAYMENT-MONITORING') {
	        if (request.tipo_solicitacao === 'Ressarcimento') {
	          this.$router.push({ path: '/solicitacao/ressarcimento/' + request.id });
	        } else {
	          this.$router.push({ path: '/solicitacao/pagamento/' + request.id });
	        }
	      } else if (request.tipo_solicitacao === 'Ressarcimento') {
	        this.$router.push({ path: '/solicitacao/ressarcimento/' + request.id });
	      } else if (request.tipo_solicitacao === 'Contrapartida') {
	        this.$router.push({ path: '/solicitacao/contrapartida/' + request.id });
	      } else if (request.tipo_solicitacao === 'Prestação de Contas' || typePhase === 'ACCOUNTABILITY-ANALYSIS' || typePhase === 'ACCOUNTABILITY-FINANCIAL_ANALYSIS') {
	        this.$router.push({ path: '/solicitacao/prestacaocontas/' + request.id });
	      } else if (request.tipo_solicitacao === 'Adiantamento') {
	        this.$router.push({ path: '/solicitacao/adiantamento/' + request.id });
	      } else if (request.tipo_solicitacao === 'Devolução de Adiantamento') {
	        this.$router.push({ path: '/solicitacao/devolucao_adiantamento/' + request.id });
	      } else if (typePhase === 'ADVANCE_APPROVAL') {
	        path += '/advance/do/accompany';
	      } else if (typePhase === 'ADVANCE_APPROVAL_FINANCIAL_ANALYSIS') {
	        path += '/advance/do';
	      } else if (typePhase === 'ADVANCE_REFUND_APPROVAL') {
	        path += '/advancerefund/do/analysis';
	      } else if (typePhase === 'ADVANCEREFUND_FINANCIAL_ANALYSIS') {
	        path += '/advancerefund/do';
	      }
	      this.$router.push(path);
	    },
	    authorizeEditRequest: function authorizeEditRequest(request) {
	      var auth = false;
	      if (this.usuarioLogado.entity) {
	        if (_.includes(['Pagamento', 'Ressarcimento'], request.tipo_solicitacao) && request.eventType === 'PAYMENT_REVIEW') {
	          auth = this.$root.authorize('solicitacao-pagamento-editar');
	        } else if (request.tipo_solicitacao === 'Contrapartida' && request.eventType === 'Revisão pela entidade') {
	          auth = this.$root.authorize('solicitacao-contrapartida-editar');
	        } else if (request.tipo_solicitacao === 'Adiantamento' && request.etapa === 'Revisão pela entidade') {
	          auth = this.$root.authorize('solicitacao-adiantamento-editar');
	        } else if (request.tipo_solicitacao === 'Devolução de Adiantamento' && request.etapa === 'Revisão pela entidade') {
	          auth = this.$root.authorize('solicitacao-devolucaoadiantamento-editar');
	        } else if (request.tipo_solicitacao === 'Prestação de Contas' && request.eventType === 'Revisão pela entidade') {
	          auth = this.$root.authorize('solicitacao-prestacaocontas-editar');
	        }
	      }
	      return auth;
	    },
	    autorizaValidacao: function autorizaValidacao(request) {
	      var auth = false;
	      if (_.includes(['Pagamento', 'Ressarcimento'], request.tipo_solicitacao) && _.includes(['Análise', 'Análise Tributária', 'Liquidação'], request.etapa)) {
	        auth = 'solicitacao-pagamento-analisar';
	      } else if (_.includes(['Pagamento', 'Ressarcimento'], request.tipo_solicitacao) && request.etapa === 'Autorização') {
	        auth = 'solicitacao-pagamento-acompanhar';
	      } else if (request.tipo_solicitacao === 'Contrapartida' && request.etapa === 'Análise') {
	        auth = 'solicitacao-contrapartida-analisar';
	      } else if (request.tipo_solicitacao === 'Contrapartida' && request.etapa === 'Autorização') {
	        auth = 'solicitacao-contrapartida-acompanhar';
	      } else if (request.tipo_solicitacao === 'Prestação de Contas' && _.includes(['Análise', 'Análise Tributária', 'Liquidação'], request.etapa)) {
	        auth = 'solicitacao-prestacaocontas-analisar';
	      } else if (request.tipo_solicitacao === 'Prestação de Contas' && request.etapa === 'Autorização') {
	        auth = 'solicitacao-prestacaocontas-analisefinanceira';
	      } else if (request.tipo_solicitacao === 'Adiantamento' && request.etapa === 'Análise') {
	        auth = 'solicitacao-adiantamento-analisar';
	      } else if (request.tipo_solicitacao === 'Adiantamento' && request.etapa === 'Autorização') {
	        auth = 'solicitacao-adiantamento-aprovar';
	      } else if (request.tipo_solicitacao === 'Adiantamento' && request.etapa === 'Análise Financeira') {
	        auth = 'solicitacao-adiantamento-analisefinanceira';
	      } else if (request.tipo_solicitacao === 'Devolução de Adiantamento' && request.etapa === 'Análise') {
	        auth = 'solicitacao-devolucaoadiantamento-analisar';
	      } else if (request.tipo_solicitacao === 'Devolução de Adiantamento' && request.etapa === 'Análise Financeira') {
	        auth = 'solicitacao-devolucaoadiantamento-analisefinanceira';
	      }
	      return auth && this.$root.authorize(auth);
	    },
	    getTypePhase: function getTypePhase(request) {
	      var typePhase = void 0;
	      if (_.includes(['Pagamento', 'Ressarcimento'], request.tipo_solicitacao) && request.etapa === 'Análise') {
	        typePhase = 'PAYMENT-ANALYSIS';
	      } else if (_.includes(['Pagamento', 'Ressarcimento'], request.tipo_solicitacao) && request.etapa === 'Autorização') {
	        typePhase = 'PAYMENT-MONITORING';
	      } else if (request.tipo_solicitacao === 'Contrapartida' && request.etapa === 'Análise') {
	        typePhase = 'COUNTERPART-ANALYSIS';
	      } else if (request.tipo_solicitacao === 'Prestação de Contas' && request.etapa === 'Análise') {
	        typePhase = 'ACCOUNTABILITY-ANALYSIS';
	      } else if (request.tipo_solicitacao === 'Prestação de Contas' && request.etapa === 'Autorização') {
	        typePhase = 'ACCOUNTABILITY-FINANCIAL_ANALYSIS';
	      } else if (_.includes(['Pagamento', 'Ressarcimento'], request.tipo_solicitacao) && request.etapa === 'Revisão pela entidade') {
	        typePhase = 'PAYMENT_REVIEW';
	      } else if (request.tipo_solicitacao === 'Adiantamento' && request.etapa === 'Revisão') {
	        typePhase = 'ADVANCE_REVIEW';
	      } else if (request.tipo_solicitacao === 'Adiantamento' && request.etapa === 'Autorização') {
	        typePhase = 'ADVANCE_APPROVAL';
	      } else if (request.tipo_solicitacao === 'Adiantamento' && request.etapa === 'Análise Financeira') {
	        typePhase = 'ADVANCE_APPROVAL_FINANCIAL_ANALYSIS';
	      } else if (request.tipo_solicitacao === 'Adiantamento' && request.etapa === 'Análise') {
	        typePhase = 'ADVANCE_APPROVAL_ANALYSIS';
	      } else if (request.tipo_solicitacao === 'Devolução de Adiantamento' && request.etapa === 'Análise') {
	        typePhase = 'ADVANCE_REFUND_APPROVAL';
	      } else if (request.tipo_solicitacao === 'Devolução de Adiantamento' && request.etapa === 'Análise Financeira') {
	        typePhase = 'ADVANCE_REFUND_FINANCIAL_ANALYSIS';
	      }
	      return typePhase;
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.table.totalRows = filteredItems.length;
	      this.table.currentPage = 1;
	    },
	    onSearch: function onSearch() {
	      var _this20 = this;
	
	      this.$forceUpdate();
	      if (this.usuarioLogado.userType === 'ENTIDADE') {
	        this.filtros.entityId = this.usuarioLogado.entity.id;
	      }
	      if (this.filtros.requestDate) {
	        this.filtros.requestDate = (0, _moment2.default)(this.filtros.requestDate).format();
	      }
	      this.items = null;
	      this.listaBackupFiltro = null;
	      this.loading.show = true;
	      this.pesquisa = this.usuarioLogado.userType !== 'FUNDACAO' && this.pesquisa.length === 0 ? null : this.pesquisa;
	
	      var filtroSituacao = '';
	      if (!_.isEmpty(this.situacaoFiltro)) {
	        filtroSituacao = this.situacaoFiltro;
	      }
	      var endpoint = 'processos/pesquisa/';
	      if (this.ehParceiroEstrategico) {
	        endpoint = 'parceiroEstrategico/pesquisaProcessos/';
	      }
	      axiosLaravel.post(endpoint, { 'termo': this.pesquisa, 'situacao': filtroSituacao }).then(function (response) {
	        var listaProjetos = response.data;
	        var acessosProjetos = _.get(_this20.usuarioLogado, 'configuracoes.acesso_projetos');
	        if (acessosProjetos) {
	          acessosProjetos.forEach(function (projeto) {
	            if (_.find(projeto.acesso, ['codigo', 'SEM_ACESSO'])) {
	              _.remove(listaProjetos, function (item) {
	                return _.includes(item.projeto, projeto.numero);
	              });
	            }
	          });
	        }
	        _this20.items = listaProjetos;
	        _this20.listaBackupFiltro = listaProjetos;
	        _this20.table.totalRows = response.data.length;
	        _this20.loading.show = false;
	        _this20.pesquisa = '';
	        _this20.situacaoFiltro = null;
	        _this20.$forceUpdate();
	      }).catch(function (error) {
	        if (error) {
	          _this20.$root.trataErro(error);
	        }
	      });
	    },
	    inativa: function inativa(item) {
	      var _this21 = this;
	
	      axios.put('/proxy/project/requests' + item.id, item).then(function (response) {
	        item.approvalResultDesc = !item.approvalResultDesc;
	      }).catch(function (error) {
	        if (error) {
	          _this21.$root.trataErro(error);
	        }
	      });
	    },
	    onNew: function onNew() {},
	    cancelar: function cancelar(retorno, processo) {
	      var _this22 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                _context15.next = 2;
	                return axiosLaravel.put('processos/cancelar/' + processo.id).then(function (response) {
	                  _this22.$forceUpdate();
	                  _this22.$snotify.success('Processo cancelado com sucesso');
	                  processo.situacao = 'Cancelado';
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this22.$root.trataErro(error);
	                });
	
	              case 2:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this22);
	      }))();
	    },
	    chamaRestante: function chamaRestante() {
	      var _this23 = this;
	
	      axiosLaravel.get('processos').then(function (response) {
	        _this23.items = response.data;
	        _this23.table.totalRows = response.data.length;
	        _this23.$forceUpdate();
	      }).catch(function (error) {
	        if (error) {
	          _this23.$root.trataErro(error);
	        }
	      });
	    },
	    solicitacaoReativarRemessa: function solicitacaoReativarRemessa(processo) {
	      var _this24 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16() {
	        var tipo, id, projeto, $message;
	        return _regenerator2.default.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                tipo = processo.tipo_solicitacao;
	                id = processo.id;
	                projeto = processo.projeto;
	                $message = 'Deseja <b>REATIVAR</b> a solicitação de <font color=\'red\'>' + tipo + '</font>? <br><br> - ID: <i><font color=\'#00008b\'>' + id + '</font></i><br> - Projeto: <i><font color=\'#00008b\'>' + projeto + '</font></i></i>';
	
	
	                _this24.$dialog.confirm($message).then(function ($dialog) {
	                  _this24.segueReativarRemessa(processo);
	                }).catch(function (error) {
	                  this.$snotify.clear();
	                  this.$root.trataErro(error);
	                });
	
	              case 5:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this24);
	      }))();
	    },
	    segueReativarRemessa: function segueReativarRemessa(processo) {
	      var _this25 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
	        return _regenerator2.default.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                console.log('egueReativarRemessa - processo: ' + processo.id);
	                _this25.$aguarde('Reativando solicitação. Por favor, aguarde...');
	                _context18.next = 4;
	                return axiosLaravel.put('processos/reativarPagamentoRemessa/' + processo.id).then(function () {
	                  var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17(response) {
	                    return _regenerator2.default.wrap(function _callee17$(_context17) {
	                      while (1) {
	                        switch (_context17.prev = _context17.next) {
	                          case 0:
	                            console.log('response.data RLMB', response.data);
	
	                            _this25.$snotify.clear();
	                            _this25.$snotify.success('Solicitação reativada com sucesso!');
	                            processo.situacao = 'Em execução';
	                            _this25.$forceUpdate();
	
	                          case 5:
	                          case 'end':
	                            return _context17.stop();
	                        }
	                      }
	                    }, _callee17, _this25);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  _this25.$snotify.clear();
	                  _this25.$root.trataErro(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this25);
	      }))();
	    },
	    filtrarSituacao: function filtrarSituacao() {
	      console.log(this.situacaoFiltro);
	      console.log(this.items);
	      var situacao = void 0;
	
	      if (this.situacaoFiltro === 'EM_EXECUCAO') {
	        situacao = 'Em Execução';
	      }
	      if (this.situacaoFiltro === 'FEITO') {
	        situacao = 'Feito';
	      }
	      if (this.situacaoFiltro === 'CANCELADO') {
	        situacao = 'Cancelado';
	      }
	
	      if (!_.isEmpty(this.items)) {
	        if (this.situacaoFiltro === 'TODOS') {
	          this.items = _.cloneDeep(this.listaBackupFiltro);
	          console.log('RESETA FILTRO');
	        } else {
	          console.log('FILTRA');
	          this.items = _.filter(this.listaBackupFiltro, { situacao: situacao });
	        }
	      }
	    },
	    consultaAcessoReativacaoLiberacaoRecursos: function consultaAcessoReativacaoLiberacaoRecursos() {
	      this.acessoReativarLiberacaoRecursos = false;
	      if (this.usuarioLogado && Array.isArray(this.usuarioLogado.perfis)) {
	        var perfis = this.usuarioLogado.perfis;
	        for (var i = 0; i < perfis.length; i++) {
	          if (perfis[i].id === 11 || perfis[i].id === 13 || perfis[i].id === 14 || perfis[i].id === 6) {
	            this.acessoReativarLiberacaoRecursos = true;
	          }
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadDocumentosPhp = __webpack_require__(85);
	
	var _uploadDocumentosPhp2 = _interopRequireDefault(_uploadDocumentosPhp);
	
	var _historicoSolicitacaoPagamento = __webpack_require__(107);
	
	var _historicoSolicitacaoPagamento2 = _interopRequireDefault(_historicoSolicitacaoPagamento);
	
	var _historicoAntigo = __webpack_require__(106);
	
	var _historicoAntigo2 = _interopRequireDefault(_historicoAntigo);
	
	var _brBankAccountValidator = __webpack_require__(125);
	
	var _brBankAccountValidator2 = _interopRequireDefault(_brBankAccountValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosPhp: _uploadDocumentosPhp2.default,
	    HistoricoSolicitacaoPagamento: _historicoSolicitacaoPagamento2.default,
	    HistoricoAntigo: _historicoAntigo2.default
	  },
	  name: 'main-solicitacao-adiantamentos',
	  data: function data() {
	    return {
	      id: null,
	      ativaGeracaoRemessa: true,
	      processo: 'ADIANTAMENTO',
	      etapa: 'Solicitação',
	      contasFinanceiras: [],
	      contasTesouraria: [],
	      historico: [],
	      projetoSuperior: 0,
	      mostrar_representantes: false,
	      mostrar_ocorrencias: false,
	      razaoSocial: '',
	      id_entidade: 0,
	      temOcorrencia: false,
	      projetoComAlteracaoEmAndamento: false,
	      ocorrencias: [],
	      dirigentes: [],
	      cod_cargo: 0,
	      cargos: ['', 'Presidente(a)', 'Vice-Presidente', 'Prefeito(a)', 'Diretor(a)', 'Diretor(a) Superintendente', 'Coordenador(a)', 'Outros', 'Reitor(a)', 'Secretário(a)', 'Tesoureiro(a)', 'Contato', 'Designado(a)', 'Procurador(a)'],
	      esconderHistorico: false,
	      data_edicao: '',
	      historicoTarefas: [],
	      historicoTarefasTela: [],
	      historicoBack: [],
	      loading: {
	        processo: false,
	        tarefa: false,
	        adiantamentos: false,
	        projetos: false,
	        suportesFbbAtivos: false,
	        tela: false
	      },
	      dataMenor: false,
	      dataCorte: '2020-12-10',
	      chamado: [],
	      listaProjetos: [],
	      projeto: {},
	      entidade: {},
	      adiantamentosConcecidos: [],
	      parcelasAtuais: [],
	      totaisLimites: {},
	      documentosLiberacao: [],
	      adiantamentoSolicitado: {
	        id: null,
	        idParcela: null,
	        projeto: {},
	        processo: null,
	        etapa: null,
	        proximaEtapa: null,
	        numeroTitulo: null,
	        serieTitulo: null,
	        observacao: null,
	        valor: 0,
	        fase: null,
	        contaFinanceira: null,
	        contaTesouraria: null,
	        seqBan: null,
	        dados_bancarios: {
	          banco: null,
	          agencia: null,
	          conta: null,
	          tipo: 1
	        },
	        anexos: [],
	        documentosAdiantamento: [],
	        parametrosDocumento: [],
	        suporteFbb: []
	      },
	      aprovacao: {},
	      totais: {
	        orcado: 0,
	        liberado: 0,
	        solicitado: 0,
	        emExecucao: 0,
	        pendenteComprovacao: 0,
	        comprovado: 0,
	        devolvido: 0,
	        projeto: {
	          fbb: {
	            adiantavel: 0,
	            liberado: 0,
	            limite: 0
	          },
	          parceiros: {
	            adiantavel: 0,
	            liberado: 0,
	            limite: 0
	          }
	        }
	      },
	      ultimaTarefaFeita: {},
	
	      restricaoParaInicializar: [],
	      restricaoParaConcluir: [],
	      ehVisualizacao: false,
	      validacao: {},
	      descricaoProcesso: { 'ADIANTAMENTO': 'Adiantamento', 'DEVOLUCAO_DE_ADIANTAMENTO': 'Devolução de Adiantamento' },
	      poderes: {
	        codigo: '',
	        mensagem: []
	      },
	      listaBancos: [{ 'codigo': '001', 'nome': 'Banco do Brasil S.A.', 'caracteresConta': 8 }, { 'codigo': '033', 'nome': 'Banco Santander (Brasil) S.A.', 'caracteresConta': 8, 'digitoAgencia': false }, { 'codigo': '070', 'nome': 'BRB - Banco de Brasília S.A.' }, { 'codigo': '104', 'nome': 'Caixa Econômica Federal', 'digitoAgencia': false }, { 'codigo': '237', 'nome': 'Banco Bradesco S.A.', 'caracteresConta': 7 }, { 'codigo': '341', 'nome': 'Itaú Unibanco S.A.', 'caracteresConta': 5, 'digitoAgencia': false }, { 'codigo': '', 'nome': '', $isDisabled: true }, { 'codigo': '003', 'nome': 'BANCO DA AMAZONIA S.A.' }, { 'codigo': '004', 'nome': 'Banco do Nordeste do Brasil S.A.' }, { 'codigo': '007', 'nome': 'BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL' }, { 'codigo': '010', 'nome': 'CREDICOAMO CREDITO RURAL COOPERATIVA' }, { 'codigo': '011', 'nome': 'CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A' }, { 'codigo': '012', 'nome': 'Banco Inbursa S.A.' }, { 'codigo': '014', 'nome': 'STATE STREET BRASIL S.A. ? BANCO COMERCIAL' }, { 'codigo': '015', 'nome': 'UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { 'codigo': '016', 'nome': 'COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI' }, { 'codigo': '017', 'nome': 'BNY Mellon Banco S.A.' }, { 'codigo': '018', 'nome': 'Banco Tricury S.A.' }, { 'codigo': '021', 'nome': 'BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO' }, { 'codigo': '024', 'nome': 'Banco Bandepe S.A.' }, { 'codigo': '025', 'nome': 'Banco Alfa S.A.' }, { 'codigo': '029', 'nome': 'Banco Itaú Consignado S.A.' }, { 'codigo': '036', 'nome': 'Banco Bradesco BBI S.A.' }, { 'codigo': '037', 'nome': 'Banco do Estado do Pará S.A.' }, { 'codigo': '040', 'nome': 'Banco Cargill S.A.' }, { 'codigo': '041', 'nome': 'Banco do Estado do Rio Grande do Sul S.A.', 'caracteresConta': 9 }, { 'codigo': '047', 'nome': 'Banco do Estado de Sergipe S.A.' }, { 'codigo': '060', 'nome': 'Confidence Corretora de Câmbio S.A.' }, { 'codigo': '062', 'nome': 'Hipercard Banco Múltiplo S.A.' }, { 'codigo': '063', 'nome': 'Banco Bradescard S.A.' }, { 'codigo': '064', 'nome': 'GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.' }, { 'codigo': '065', 'nome': 'Banco AndBank (Brasil) S.A.' }, { 'codigo': '066', 'nome': 'BANCO MORGAN STANLEY S.A.' }, { 'codigo': '069', 'nome': 'Banco Crefisa S.A.' }, { 'codigo': '074', 'nome': 'Banco J. Safra S.A.' }, { 'codigo': '075', 'nome': 'Banco ABN Amro S.A.' }, { 'codigo': '076', 'nome': 'Banco KDB do Brasil S.A.' }, { 'codigo': '077', 'nome': 'Banco Inter S.A.' }, { 'codigo': '078', 'nome': 'Haitong Banco de Investimento do Brasil S.A.' }, { 'codigo': '079', 'nome': 'Banco Original do Agronegócio S.A.' }, { 'codigo': '080', 'nome': 'B&T CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '081', 'nome': 'BancoSeguro S.A.' }, { 'codigo': '082', 'nome': 'BANCO TOPÁZIO S.A.' }, { 'codigo': '083', 'nome': 'Banco da China Brasil S.A.' }, { 'codigo': '084', 'nome': 'UNIPRIME NORTE DO PARANÁ – COOPERATIVA DE CRÉDITO LTDA' }, { 'codigo': '085', 'nome': 'Cooperativa Central de Crédito – Ailos' }, { 'codigo': '088', 'nome': 'BANCO RANDON S.A.' }, { 'codigo': '089', 'nome': 'CREDISAN COOPERATIVA DE CRÉDITO' }, { 'codigo': '091', 'nome': 'CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S' }, { 'codigo': '092', 'nome': 'BRK S.A. Crédito, Financiamento e Investimento' }, { 'codigo': '093', 'nome': 'PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT' }, { 'codigo': '094', 'nome': 'Banco Finaxis S.A.' }, { 'codigo': '095', 'nome': 'Travelex Banco de Câmbio S.A.' }, { 'codigo': '096', 'nome': 'Banco B3 S.A.' }, { 'codigo': '097', 'nome': 'Credisis – Central de Cooperativas de Crédito Ltda.' }, { 'codigo': '098', 'nome': 'Credialiança Cooperativa de Crédito Rural' }, { 'codigo': '099', 'nome': 'UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.' }, { 'codigo': '100', 'nome': 'Planner Corretora de Valores S.A.' }, { 'codigo': '101', 'nome': 'RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '102', 'nome': 'XP INVESTIMENTOS CORRETORA DE CÂMBIO,TÍTULOS E VALORES MOBILIÁRIOS S/A' }, { 'codigo': '105', 'nome': 'Lecca Crédito, Financiamento e Investimento S/A' }, { 'codigo': '107', 'nome': 'Banco Bocom BBM S.A.' }, { 'codigo': '108', 'nome': 'PORTOCRED S.A. – CREDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '111', 'nome': 'OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.' }, { 'codigo': '113', 'nome': 'Magliano S.A. Corretora de Cambio e Valores Mobiliarios' }, { 'codigo': '114', 'nome': 'Central Cooperativa de Crédito no Estado do Espírito Santo – CECOOP' }, { 'codigo': '117', 'nome': 'ADVANCED CORRETORA DE CÂMBIO LTDA' }, { 'codigo': '119', 'nome': 'Banco Western Union do Brasil S.A.' }, { 'codigo': '120', 'nome': 'BANCO RODOBENS S.A.' }, { 'codigo': '121', 'nome': 'Banco Agibank S.A.' }, { 'codigo': '122', 'nome': 'Banco Bradesco BERJ S.A.' }, { 'codigo': '124', 'nome': 'Banco Woori Bank do Brasil S.A.' }, { 'codigo': '125', 'nome': 'Plural S.A. Banco Múltiplo' }, { 'codigo': '126', 'nome': 'BR Partners Banco de Investimento S.A.' }, { 'codigo': '127', 'nome': 'Codepe Corretora de Valores e Câmbio S.A.' }, { 'codigo': '128', 'nome': 'MS Bank S.A. Banco de Câmbio' }, { 'codigo': '129', 'nome': 'UBS Brasil Banco de Investimento S.A.' }, { 'codigo': '130', 'nome': 'CARUANA S.A. – SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '131', 'nome': 'TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA' }, { 'codigo': '132', 'nome': 'ICBC do Brasil Banco Múltiplo S.A.' }, { 'codigo': '133', 'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E' }, { 'codigo': '134', 'nome': 'BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '136', 'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. – UNICRED DO BRASI' }, { 'codigo': '138', 'nome': 'Get Money Corretora de Câmbio S.A.' }, { 'codigo': '139', 'nome': 'Intesa Sanpaolo Brasil S.A. – Banco Múltiplo' }, { 'codigo': '140', 'nome': 'Easynvest – Título Corretora de Valores SA' }, { 'codigo': '142', 'nome': 'Broker Brasil Corretora de Câmbio Ltda.' }, { 'codigo': '143', 'nome': 'Treviso Corretora de Câmbio S.A.' }, { 'codigo': '144', 'nome': 'BEXS BANCO DE CÂMBIO S/A' }, { 'codigo': '145', 'nome': 'LEVYCAM – CORRETORA DE CAMBIO E VALORES LTDA.' }, { 'codigo': '146', 'nome': 'GUITTA CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '149', 'nome': 'Facta Financeira S.A. – Crédito Financiamento e Investimento' }, { 'codigo': '157', 'nome': 'ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '159', 'nome': 'Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor' }, { 'codigo': '163', 'nome': 'Commerzbank Brasil S.A. – Banco Múltiplo' }, { 'codigo': '169', 'nome': 'BANCO OLÉ CONSIGNADO S.A.' }, { 'codigo': '173', 'nome': 'BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '174', 'nome': 'PEFISA S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '177', 'nome': 'Guide Investimentos S.A. Corretora de Valores' }, { 'codigo': '180', 'nome': 'CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '183', 'nome': 'SOCRED S.A. – SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P' }, { 'codigo': '184', 'nome': 'Banco Itaú BBA S.A.' }, { 'codigo': '188', 'nome': 'ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS, CÂMBIO E VALORES' }, { 'codigo': '189', 'nome': 'HS FINANCEIRA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' }, { 'codigo': '190', 'nome': 'SERVICOOP – COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN' }, { 'codigo': '191', 'nome': 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '194', 'nome': 'PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '196', 'nome': 'FAIR CORRETORA DE CAMBIO S.A.' }, { 'codigo': '197', 'nome': 'Stone Pagamentos S.A.' }, { 'codigo': '208', 'nome': 'Banco BTG Pactual S.A.' }, { 'codigo': '212', 'nome': 'Banco Original S.A.' }, { 'codigo': '213', 'nome': 'Banco Arbi S.A.' }, { 'codigo': '217', 'nome': 'Banco John Deere S.A.' }, { 'codigo': '218', 'nome': 'Banco BS2 S.A.' }, { 'codigo': '222', 'nome': 'BANCO CRÉDIT AGRICOLE BRASIL S.A.' }, { 'codigo': '224', 'nome': 'Banco Fibra S.A.' }, { 'codigo': '233', 'nome': 'Banco Cifra S.A.' }, { 'codigo': '241', 'nome': 'BANCO CLASSICO S.A.' }, { 'codigo': '243', 'nome': 'Banco Máxima S.A.' }, { 'codigo': '246', 'nome': 'Banco ABC Brasil S.A.' }, { 'codigo': '249', 'nome': 'Banco Investcred Unibanco S.A.' }, { 'codigo': '250', 'nome': 'BCV – BANCO DE CRÉDITO E VAREJO S.A.' }, { 'codigo': '253', 'nome': 'Bexs Corretora de Câmbio S/A' }, { 'codigo': '254', 'nome': 'PARANÁ BANCO S.A.' }, { 'codigo': '259', 'nome': 'MONEYCORP BANCO DE CÂMBIO S.A.' }, { 'codigo': '260', 'nome': 'Nu Pagamentos S.A.' }, { 'codigo': '265', 'nome': 'Banco Fator S.A.' }, { 'codigo': '266', 'nome': 'BANCO CEDULA S.A.' }, { 'codigo': '268', 'nome': 'BARI COMPANHIA HIPOTECÁRIA' }, { 'codigo': '269', 'nome': 'BANCO HSBC S.A.' }, { 'codigo': '270', 'nome': 'Sagitur Corretora de Câmbio Ltda.' }, { 'codigo': '271', 'nome': 'IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { 'codigo': '272', 'nome': 'AGK CORRETORA DE CAMBIO S.A.' }, { 'codigo': '273', 'nome': 'Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel' }, { 'codigo': '274', 'nome': 'MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT' }, { 'codigo': '276', 'nome': 'Senff S.A. – Crédito, Financiamento e Investimento' }, { 'codigo': '278', 'nome': 'Genial Investimentos Corretora de Valores Mobiliários S.A.' }, { 'codigo': '279', 'nome': 'COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' }, { 'codigo': '280', 'nome': 'Avista S.A. Crédito, Financiamento e Investimento' }, { 'codigo': '281', 'nome': 'Cooperativa de Crédito Rural Coopavel' }, { 'codigo': '283', 'nome': 'RB CAPITAL INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LIMITADA' }, { 'codigo': '285', 'nome': 'Frente Corretora de Câmbio Ltda.' }, { 'codigo': '286', 'nome': 'COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO' }, { 'codigo': '288', 'nome': 'CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '289', 'nome': 'DECYSEO CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '290', 'nome': 'Pagseguro Internet S.A.' }, { 'codigo': '292', 'nome': 'BS2 Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '293', 'nome': 'Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '296', 'nome': 'VISION S.A. CORRETORA DE CAMBIO' }, { 'codigo': '298', 'nome': 'Vip’s Corretora de Câmbio Ltda.' }, { 'codigo': '299', 'nome': 'SOROCRED   CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '300', 'nome': 'Banco de la Nacion Argentina' }, { 'codigo': '301', 'nome': 'BPP Instituição de Pagamento S.A.' }, { 'codigo': '306', 'nome': 'PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '307', 'nome': 'Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '309', 'nome': 'CAMBIONET CORRETORA DE CÂMBIO LTDA.' }, { 'codigo': '310', 'nome': 'VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '311', 'nome': 'DOURADA CORRETORA' }, { 'codigo': '312', 'nome': 'HSCM SCMEPP LTDA.' }, { 'codigo': '313', 'nome': 'AMAZÔNIA CORRETORA DE CÂMBIO LTDA.' }, { 'codigo': '315', 'nome': 'PI Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '318', 'nome': 'Banco BMG S.A.' }, { 'codigo': '319', 'nome': 'OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '320', 'nome': 'China Construction Bank (Brasil) Banco Múltiplo S/A' }, { 'codigo': '321', 'nome': 'CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT' }, { 'codigo': '322', 'nome': 'Cooperativa de Crédito Rural de Abelardo Luz – Sulcredi/Crediluz' }, { 'codigo': '323', 'nome': 'MERCADOPAGO.COM REPRESENTACOES LTDA.' }, { 'codigo': '324', 'nome': 'CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '325', 'nome': 'Órama Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '326', 'nome': 'PARATI – CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '329', 'nome': 'QI Sociedade de Crédito Direto S.A.' }, { 'codigo': '330', 'nome': 'BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.' }, { 'codigo': '331', 'nome': 'Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '332', 'nome': 'Acesso Soluções de Pagamento S.A.' }, { 'codigo': '335', 'nome': 'Banco Digio S.A.' }, { 'codigo': '336', 'nome': 'Banco C6 S.A.' }, { 'codigo': '340', 'nome': 'Super Pagamentos e Administração de Meios Eletrônicos S.A.' }, { 'codigo': '342', 'nome': 'Creditas Sociedade de Crédito Direto S.A.' }, { 'codigo': '343', 'nome': 'FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.' }, { 'codigo': '348', 'nome': 'Banco XP S.A.' }, { 'codigo': '349', 'nome': 'AL5 S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '350', 'nome': 'COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE' }, { 'codigo': '352', 'nome': 'TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '354', 'nome': 'NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES' }, { 'codigo': '355', 'nome': 'ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '358', 'nome': 'MIDWAY S.A. - SCFI' }, { 'codigo': '359', 'nome': 'ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A' }, { 'codigo': '360', 'nome': 'TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { 'codigo': '362', 'nome': 'CIELO S.A.' }, { 'codigo': '363', 'nome': 'SOCOPA SOCIEDADE CORRETORA PAULISTA S.A.' }, { 'codigo': '364', 'nome': 'GERENCIANET S.A.' }, { 'codigo': '365', 'nome': 'SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS' }, { 'codigo': '366', 'nome': 'BANCO SOCIETE GENERALE BRASIL S.A.' }, { 'codigo': '367', 'nome': 'VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { 'codigo': '368', 'nome': 'Banco CSF S.A.' }, { 'codigo': '370', 'nome': 'Banco Mizuho do Brasil S.A.' }, { 'codigo': '371', 'nome': 'WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.' }, { 'codigo': '373', 'nome': 'UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.' }, { 'codigo': '374', 'nome': 'REALIZE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '376', 'nome': 'BANCO J.P. MORGAN S.A.' }, { 'codigo': '377', 'nome': 'MS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA' }, { 'codigo': '378', 'nome': 'BBC LEASING S.A. – ARRENDAMENTO MERCANTIL' }, { 'codigo': '379', 'nome': 'COOPERFORTE – COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS FUNCIONÁRIOS DE INSTIT' }, { 'codigo': '380', 'nome': 'PICPAY SERVICOS S.A.' }, { 'codigo': '381', 'nome': 'BANCO MERCEDES-BENZ DO BRASIL S.A.' }, { 'codigo': '382', 'nome': 'FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L' }, { 'codigo': '383', 'nome': 'BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.' }, { 'codigo': '384', 'nome': 'GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO' }, { 'codigo': '386', 'nome': 'NU FINANCEIRA S.A. CFI' }, { 'codigo': '387', 'nome': 'Banco Toyota do Brasil S.A.' }, { 'codigo': '389', 'nome': 'Banco Mercantil do Brasil S.A.' }, { 'codigo': '390', 'nome': 'BANCO GM S.A.' }, { 'codigo': '391', 'nome': 'COOPERATIVA DE CREDITO RURAL DE IBIAM – SULCREDI/IBIAM' }, { 'codigo': '393', 'nome': 'Banco Volkswagen S.A.' }, { 'codigo': '394', 'nome': 'Banco Bradesco Financiamentos S.A.' }, { 'codigo': '395', 'nome': 'F D GOLD DTVM LTDA' }, { 'codigo': '396', 'nome': 'HUB PAGAMENTOS S.A' }, { 'codigo': '397', 'nome': 'LISTO SOCIEDADE DE CREDITO DIRETO S.A.' }, { 'codigo': '398', 'nome': 'IDEAL CTVM S.A.' }, { 'codigo': '399', 'nome': 'Kirton Bank S.A. – Banco Múltiplo' }, { 'codigo': '400', 'nome': 'CC POUP SER FIN CO' }, { 'codigo': '402', 'nome': 'COBUCCIO SCD S.A.' }, { 'codigo': '403', 'nome': 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '404', 'nome': 'SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '406', 'nome': 'ACCREDITO SCD S.A.' }, { 'codigo': '407', 'nome': 'ÍNDIGO INVESTIMENTOS DTVM LTDA.' }, { 'codigo': '408', 'nome': 'BÔNUSCRED SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '410', 'nome': 'PLANNER SCM S.A.' }, { 'codigo': '411', 'nome': 'VIA CERTA FINANCIADORA S.A. - CFI' }, { 'codigo': '412', 'nome': 'BANCO CAPITAL S.A.' }, { 'codigo': '419', 'nome': 'NUMBRS SCD S.A.' }, { 'codigo': '422', 'nome': 'Banco Safra S.A.' }, { 'codigo': '456', 'nome': 'Banco MUFG Brasil S.A.' }, { 'codigo': '464', 'nome': 'Banco Sumitomo Mitsui Brasileiro S.A.' }, { 'codigo': '473', 'nome': 'Banco Caixa Geral – Brasil S.A.' }, { 'codigo': '477', 'nome': 'Citibank N.A.' }, { 'codigo': '479', 'nome': 'Banco ItauBank S.A.' }, { 'codigo': '487', 'nome': 'DEUTSCHE BANK S.A. – BANCO ALEMAO' }, { 'codigo': '488', 'nome': 'JPMorgan Chase Bank, National Association' }, { 'codigo': '492', 'nome': 'ING Bank N.V.' }, { 'codigo': '495', 'nome': 'Banco de La Provincia de Buenos Aires' }, { 'codigo': '505', 'nome': 'Banco Credit Suisse (Brasil) S.A.' }, { 'codigo': '545', 'nome': 'SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A' }, { 'codigo': '600', 'nome': 'Banco Luso Brasileiro S.A.' }, { 'codigo': '604', 'nome': 'Banco Industrial do Brasil S.A.' }, { 'codigo': '610', 'nome': 'Banco VR S.A.' }, { 'codigo': '611', 'nome': 'Banco Paulista S.A.' }, { 'codigo': '612', 'nome': 'Banco Guanabara S.A.' }, { 'codigo': '613', 'nome': 'Omni Banco S.A.' }, { 'codigo': '623', 'nome': 'Banco Pan S.A.' }, { 'codigo': '626', 'nome': 'BANCO C6 CONSIGNADO S.A.' }, { 'codigo': '630', 'nome': 'Banco Smartbank S.A.' }, { 'codigo': '633', 'nome': 'Banco Rendimento S.A.' }, { 'codigo': '634', 'nome': 'BANCO TRIANGULO S.A.' }, { 'codigo': '637', 'nome': 'BANCO SOFISA S.A.' }, { 'codigo': '643', 'nome': 'Banco Pine S.A.' }, { 'codigo': '652', 'nome': 'Itaú Unibanco Holding S.A.' }, { 'codigo': '653', 'nome': 'BANCO INDUSVAL S.A.' }, { 'codigo': '654', 'nome': 'BANCO DIGIMAIS S.A.' }, { 'codigo': '655', 'nome': 'Banco Votorantim S.A.' }, { 'codigo': '707', 'nome': 'Banco Daycoval S.A.' }, { 'codigo': '712', 'nome': 'Banco Ourinvest S.A.' }, { 'codigo': '720', 'nome': 'BCO RNX S.A.' }, { 'codigo': '739', 'nome': 'Banco Cetelem S.A.' }, { 'codigo': '741', 'nome': 'BANCO RIBEIRAO PRETO S.A.' }, { 'codigo': '743', 'nome': 'Banco Semear S.A.' }, { 'codigo': '745', 'nome': 'Banco Citibank S.A.', 'caracteresConta': 8, 'digitoAgencia': false }, { 'codigo': '746', 'nome': 'Banco Modal S.A.' }, { 'codigo': '747', 'nome': 'Banco Rabobank International Brasil S.A.' }, { 'codigo': '748', 'nome': 'BANCO COOPERATIVO SICREDI S.A.' }, { 'codigo': '751', 'nome': 'Scotiabank Brasil S.A. Banco Múltiplo' }, { 'codigo': '752', 'nome': 'Banco BNP Paribas Brasil S.A.' }, { 'codigo': '753', 'nome': 'Novo Banco Continental S.A. – Banco Múltiplo' }, { 'codigo': '754', 'nome': 'Banco Sistema S.A.' }, { 'codigo': '755', 'nome': 'Bank of America Merrill Lynch Banco Múltiplo S.A.' }, { 'codigo': '756', 'nome': 'BANCO COOPERATIVO DO BRASIL S.A. – BANCOOB' }, { 'codigo': '757', 'nome': 'BANCO KEB HANA DO BRASIL S.A.' }],
	      listaSuportes: [],
	      bancoSelecionado: null,
	      tiposConta: [{ 'codigo': 1, 'tipo': 'Conta Corrente' }, { 'codigo': 2, 'tipo': 'Conta Poupança' }],
	      tipoContaSelecionado: { 'codigo': 1, 'tipo': 'Conta Corrente' },
	      motivosDevolucao: [],
	      motivoDevolucao: null,
	      rotasProcesso: { 'ADIANTAMENTO': '/solicitacao/adiantamento', 'DEVOLUCAO_DE_ADIANTAMENTO': '/solicitacao/devolucao_adiantamento', 'PAGAMENTO': '/solicitacao/pagamento', 'PRESTACAO_DE_CONTAS': '/solicitacao/prestacaocontas', 'CONTRAPARTIDA': '/solicitacao/contrapartida', 'RESSARCIMENTO': '/solicitacao/ressarcimento' },
	      ehParceiroEstrategico: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    teste: function teste() {
	      return this;
	    },
	    observacaoAprovacaoObrigatoria: function observacaoAprovacaoObrigatoria() {
	      return this.etapa !== 'Autorização';
	    }
	  }),
	  watch: {},
	  mounted: function mounted() {
	    if (this.$route.params.id) {
	      this.verificaChamado();
	      this.buscaContasFinanceiras();
	    }
	    if (this.ehVisualizacao) {
	      this.restricaoParaInicializar = '';
	    }
	  },
	  created: function created() {
	    this.ehParceiroEstrategico = this.usuarioLogado.perfis.some(function (perfil) {
	      return perfil.ds_nome === 'Parceiro Estratégico';
	    });
	    this.data_edicao = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	    this.processo = this.$route.path.indexOf('devolucao_adiantamento') >= 0 ? 'DEVOLUCAO_DE_ADIANTAMENTO' : 'ADIANTAMENTO';
	
	    if (_.has(this.$route.params, 'visualizacao')) {
	      this.ehVisualizacao = this.$route.params.visualizacao;
	    }
	    if (_.has(this.$route.params, 'id')) {
	      this.id = this.$route.params.id;
	      this.buscaDados();
	    } else {
	      if (_.isEmpty(this.listaProjetos)) {
	        this.carregarListaProjetos();
	      }
	    }
	    var totalRestante = _.sumBy(this.parcelasAtuais, 'disponivel') - _.sumBy(this.parcelasAtuais, 'requisitado');
	    totalRestante = _.round(totalRestante, 2);
	    console.log('totalRestante = ', totalRestante);
	  },
	
	  methods: {
	    selecionaBanco: function selecionaBanco(banco) {
	      this.adiantamentoSolicitado.dados_bancarios.banco = banco.codigo;
	      this.$forceUpdate();
	    },
	    bancoNome: function bancoNome(option) {
	      return '' + (option.codigo + ' - ' + option.nome);
	    },
	    selecionaTipoConta: function selecionaTipoConta(tipoSelecionado) {
	      this.adiantamentoSolicitado.dados_bancarios.tipo = tipoSelecionado.codigo;
	      this.$forceUpdate();
	    },
	    tipoContaNome: function tipoContaNome(option) {
	      return '' + (option.codigo + ' - ' + option.tipo);
	    },
	    suporteNome: function suporteNome(option) {
	      return '' + (option.numero + ' - ' + option.problema);
	    },
	    motivoDevolucaoDescricao: function motivoDevolucaoDescricao(option) {
	      return '' + option.descricao;
	    },
	    buscaContasFinanceiras: function buscaContasFinanceiras() {
	      var _this = this;
	
	      axiosLaravel.get('busca_conta_financeira').then(function (response) {
	        _this.contasFinanceiras = response.data;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    buscaContasTesouraria: function buscaContasTesouraria() {
	      var _this2 = this;
	
	      axiosLaravel.get('busca_conta_tesouraria/' + this.projeto.Numero_projeto).then(function (response) {
	        _this2.contasTesouraria = response.data;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscaContaAdiantamento: function buscaContaAdiantamento() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return axiosLaravel.get('conta-adiantamento/buscaConta', { params: { id: _this3.projeto.Id_proposta } }).then(function (response) {
	                  _this3.bancoSelecionado = { 'codigo': '001', 'nome': 'Banco do Brasil S.A.', 'caracteresConta': 8 };
	                  if (!_.includes((0, _keys2.default)(response.data), 'codigo') && !_this3.ehVisualizacao && _this3.etapa !== 'Análise') {
	                    var dadosBancarios = response.data;
	                    _this3.adiantamentoSolicitado.dados_bancarios.agencia = dadosBancarios.agencia;
	                    _this3.adiantamentoSolicitado.dados_bancarios.conta = dadosBancarios.conta;
	                    _this3.bancoSelecionado = { 'codigo': '001', 'nome': 'Banco do Brasil S.A.', 'caracteresConta': 8 };
	                    _this3.adiantamentoSolicitado.dados_bancarios.tipo = dadosBancarios.tipo;
	                    _this3.adiantamentoSolicitado.dados_bancarios.mci = dadosBancarios.mci;
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    buscaDados: function buscaDados() {
	      var _this4 = this;
	
	      this.loading.tarefa = true;
	      axiosLaravel.get('pagamento/ultima/tarefa/' + this.id).then(function (response) {
	        _this4.projeto.Id_proposta = response.data[0]['id_projeto'];
	        _this4.projetoSuperior = response.data[0]['ds_projetoSuperior'];
	        _this4.razaoSocial = response.data[0]['ds_razao_social'];
	        _this4.projeto.Projeto = response.data[0]['projeto'];
	        _this4.projeto.Objetivo = response.data[0]['objetivo_geral'];
	        _this4.projeto.Status_ERP = response.data[0]['situacao_projeto_sapiens'];
	        _this4.entidade['ds_cnpj'] = response.data[0]['ds_cnpj'];
	        _this4.dirigentes = response.data['dirigentes'];
	        _this4.projeto.fk_entidade = response.data[0]['id_entidade'];
	        _this4.projeto.Numero_projeto = _.has(_this4.projeto, 'Numero_projeto') ? _this4.projeto['Numero_projeto'] : _this4.projeto.Projeto.substring(0, 5);
	        _this4.buscaOcorrencias();
	        _this4.carregarAdiantamentos();
	        _this4.buscaMotivosDevolucao();
	        _this4.buscaContasTesouraria();
	        _this4.loading.tarefa = false;
	      }).catch(function (error) {
	        _this4.loading.tarefa = false;
	        _this4.$root.trataErro(error);
	      });
	
	      this.loading.processo = true;
	      var endpoint = 'processos/';
	      if (this.ehParceiroEstrategico) {
	        endpoint = 'parceiroEstrategico/carregaProcesso/';
	      }
	      axiosLaravel.get(endpoint + this.id).then(function (response) {
	        _this4.dataProcesso = (0, _moment2.default)(response.data.inicio).format('DD/MM/YYYY');
	        if ((0, _moment2.default)(_this4.dataProcesso).isSameOrBefore((0, _moment2.default)(_this4.dataCorte))) {
	          _this4.dataMenor = true;
	        } else {
	          _this4.dataMenor = false;
	        }
	
	        _this4.historico = response.data.tarefas;
	        _this4.historicoTarefas = _.cloneDeep(response.data.tarefas);
	        _this4.historicoTarefasTela = _.cloneDeep(response.data.tarefas);
	        var array = _this4.historicoTarefas.filter(function (item) {
	          return item.tipo === 'Usuário' && !_.isNull(item.termino);
	        });
	        _this4.historicoTarefas = _.cloneDeep(array);
	        for (var i = 0; i < _this4.historicoTarefas.length; i++) {
	          if (_this4.historicoTarefas.usuario !== null) {
	            _this4.usuario = _this4.historicoTarefas.usuario;
	          }
	        }
	
	        _this4.ultimaTarefaFeita = _.chain(_.cloneDeep(_this4.historico)).filter(function (h) {
	          return h.tipo === 'Usuário' && !_.isNull(h.termino);
	        }).sortBy('id').last().value();
	
	        _this4.buscaHistorico(_this4.id);
	
	        _this4.etapa = _.chain(_.cloneDeep(_this4.historico)).remove(['tipo', 'Usuário']).sortBy('id').last().get('nome').value();
	        _this4.documentosLiberacao = response.data.documentos_liberacao;
	        _this4.validacao.processo = _.omit(response.data, ['documentos_liberacao', 'tarefas']);
	        _this4.adiantamentoSolicitado.anexos = _.get(_.head(_this4.documentosLiberacao), 'documentos_anexos_adiantamento');
	        _this4.adiantamentoSolicitado.documentosAdiantamento = _.get(_.head(_this4.documentosLiberacao), 'documentos_adiantamento');
	        var dadosBancarios = _.get(_.head(_this4.documentosLiberacao), 'dados_bancarios');
	
	        _this4.bancoSelecionado = _.filter(_this4.listaBancos, ['codigo', dadosBancarios.banco])[0];
	        _this4.adiantamentoSolicitado.dados_bancarios.banco = dadosBancarios.banco;
	        _this4.adiantamentoSolicitado.dados_bancarios.agencia = dadosBancarios.agencia;
	        _this4.adiantamentoSolicitado.dados_bancarios.conta = dadosBancarios.conta;
	        _this4.adiantamentoSolicitado.dados_bancarios.tipo = dadosBancarios.tipo;
	        _this4.tipoContaSelecionado = _.filter(_this4.tiposConta, ['codigo', dadosBancarios.tipo])[0];
	        _this4.adiantamentoSolicitado.pagamentoPrioritario = _.get(_.head(_this4.documentosLiberacao), 'prioridade');
	        if (_.includes(['Análise', 'Análise Financeira', 'Autorização', 'Liquidação'], _this4.etapa)) {
	          _this4.carregarSuportesFbb();
	        }
	
	        _this4.$forceUpdate();
	        _this4.loading.processo = false;
	      }).catch(function (error) {
	        _this4.loading.processo = false;
	        console.log('error', error);
	        _this4.$root.trataErro(error);
	      });
	    },
	    jsonValido: function jsonValido(json) {
	      try {
	        if (typeof json !== 'string' && (typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) !== 'object') {
	          json = undefined;
	        } else if (typeof json === 'string' && json.length > 0) {
	          json = JSON.parse(json);
	        } else if ((typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) === 'object') {
	          json = JSON.parse((0, _stringify2.default)(json));
	        } else {
	          json = undefined;
	        }
	        json = _.isObjectLike(json) ? json : undefined;
	      } catch (e) {
	        if (e instanceof SyntaxError) {
	          json = undefined;
	        }
	      }
	      return json;
	    },
	    carregarSuportesFbb: function carregarSuportesFbb() {
	      var _this5 = this;
	
	      this.loading.suportesFbbAtivos = true;
	
	      var suportes = this.carregarParametrosDocumento(_.get(_.head(this.documentosLiberacao), 'parametros_documento'), ['SUPORTE_FBB']);
	      this.adiantamentoSolicitado.suporteFbb = this.jsonValido(suportes) || [];
	
	      if (this.ehVisualizacao) {
	        this.listaSuportes = _.cloneDeep(this.adiantamentoSolicitado.suporteFbb);
	      } else {
	        axiosLaravel.get('pagamento/suportes/ativos').then(function (response) {
	          _this5.listaSuportes = _.union(_.isNull(response.data.retorno) ? [] : response.data.retorno, _this5.adiantamentoSolicitado.suporteFbb);
	          if (response.data.codigo === 'ERRO') {
	            _this5.$snotify.error(response.data.mensagem);
	          }
	          _this5.loading.suportesFbbAtivos = false;
	        }).catch(function (error) {
	          _this5.loading.suportesFbbAtivos = false;
	          console.log('error de carregamento de suportes', error);
	        });
	      }
	    },
	    buscaMotivosDevolucao: function buscaMotivosDevolucao() {
	      var _this6 = this;
	
	      axiosLaravel.post('motivos/ativos').then(function (response) {
	        _this6.motivosDevolucao = response.data;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this6.$root.trataErro(error);
	      });
	    },
	    buscaHistorico: function buscaHistorico(request) {
	      var _this7 = this;
	
	      axiosLaravel.post('historico-tarefas/lista', { 'parametro': request }).then(function (response) {
	        _this7.historicoBack = response.data;
	        var tar = _.find(_this7.historico, { nome: 'Solicitação' });
	        if (!_.isEmpty(_this7.historicoBack) && !_.find(_this7.historicoBack, { nome: 'SOLICITACAO' })) {
	          if (tar.nome === 'Solicitação' && _this7.dataMenor === false) {
	            _this7.historicoBack.push({
	              fk_processo: tar.fk_processo,
	              fk_tarefa: tar.id,
	              fk_usuario: tar.fk_usuario,
	              nome: 'SOLICITACAO',
	              proxima_etapa: '',
	              usuario: tar.usuario,
	              data_edicao: null,
	              inicio: tar.inicio,
	              termino: tar.termino,
	              observacao: tar.observacao
	            });
	          }
	        }
	
	        var tar2 = _.find(_this7.historicoBack, { nome: 'REVISAO', proxima_etapa: 'Revisão' });
	        var index = _.findIndex(_this7.historicoBack, { id: tar2.id });
	        _this7.historicoBack.splice(index, 1);
	      });
	    },
	    carregarParametrosDocumento: function carregarParametrosDocumento(parametrosCarregados, parametrosBusca) {
	      var parametros = _.filter(parametrosCarregados, function (p) {
	        return _.includes(parametrosBusca, p.parametro) || _.includes(parametrosBusca, p.valor);
	      });
	      if (parametros.length > 0) {
	        return _.last(_.sortBy(parametros, ['created_at']))['valor'];
	      } else {
	        return '';
	      }
	    },
	    verificaRestricoesAdiantamento: function verificaRestricoesAdiantamento() {
	      if (this.processo === 'ADIANTAMENTO') {
	        if (this.validandoDadosBancarios() !== true) {
	          this.restricaoParaInicializar.push('Esta solicitação não pode ser realizada pois a Conta de Adiantamento está inválida ou não foi cadastrada. Entre em contato com a equipe responsável para regularização.');
	        }
	
	        if (_.has(this.projeto, 'Status_ERP') && _.includes(['JUD', 'DLG', 'ETO', 'SPS', 'SO3', 'SO4', 'SAF', 'SPA', 'ENC', 'ESE'], this.projeto.Status_ERP)) {
	          this.restricaoParaInicializar.push('Esta solicitação não pode ser realizada pois o projeto está em estado "' + this.projeto.Status_ERP + '".');
	        }
	
	        if (_.includes(['Solicitação', 'Revisão'], this.etapa)) {
	          if (this.projeto.parcelas_contratadas === 1) {} else {
	            if (this.parcelasAtuais.length === 0) {
	              this.restricaoParaInicializar.push('Não há mais parcelas de adiantamento disponíveis neste projeto. A quantidade de solicitações de adiantamento não pode ser maior que a quantidade de parcelas disponíveis no cronograma físico-financeiro. O saldo residual pode ser solicitado através da Solicitação de Pagamento.');
	            }
	
	            if (_.has(this.adiantamentosConcecidos, '[0].id')) {
	              if (_.sumBy(this.parcelasAtuais, 'requisitado') > 0) {
	                if (this.etapa === 'Solicitação') {
	                  this.restricaoParaInicializar.push('Adiantamento já foi solicitado. Reveja as solicitações em andamento.');
	                }
	              }
	              this.adiantamentosConcecidos.some(function (item) {
	                return console.log(' item > ', item);
	              });
	
	              if (this.adiantamentosConcecidos.some(function (item) {
	                return item.atraso90dias;
	              })) {
	                this.restricaoParaInicializar.push('Os recursos da solicitação de adiantamento estão bloqueados devido à existência de prestações de contas em aberto em período superior ao previsto em convênio.');
	              }
	              if (this.adiantamentosConcecidos.some(function (item) {
	                return item.atraso180dias;
	              })) {
	                this.restricaoParaInicializar.push('Os recursos da solicitação de adiantamento estão bloqueados devido à existência de prestações de contas em aberto em período superior ao previsto em convênio.');
	              }
	
	              var adiantamentosConcecidosResumidos = {};
	              var propriedadesResumidas = ['requisitado', 'comprovado', 'em_execucao', 'devolvido', 'dias_corridos'];
	              this.adiantamentosConcecidos.forEach(function (adt) {
	                if (_.has(adiantamentosConcecidosResumidos, adt.parcela)) {
	                  propriedadesResumidas.forEach(function (p) {
	                    adiantamentosConcecidosResumidos[adt.parcela][p] += adt[p];
	                  });
	                } else {
	                  adiantamentosConcecidosResumidos[adt.parcela] = _.pick(adt, propriedadesResumidas);
	                }
	              });
	
	              _.forEach(adiantamentosConcecidosResumidos, function (adt) {
	                adt['percentual_comprovado'] = Math.round((adt.requisitado - (adt.requisitado - (adt.comprovado - adt.em_execucao) - adt.devolvido)) / adt.requisitado * 10000) / 10000;
	              });
	
	              var parcelas = _.sortBy(_.keys(adiantamentosConcecidosResumidos), [function (p) {
	                return _.toInteger(p);
	              }]);
	              if (parcelas.length > 0) {
	                if (adiantamentosConcecidosResumidos[_.last(parcelas)]['percentual_comprovado'] >= 0.8) {
	                  if (parcelas.length > 1 && adiantamentosConcecidosResumidos[_.nth(parcelas, -2)]['percentual_comprovado'] < 1) {
	                    this.restricaoParaInicializar.push('A próxima parcela de adiantamento só será liberada após a comprovação de 100% do valor da parcela anterior, via Solicitação da Prestação de Contas.');
	                  }
	                } else {
	                  this.restricaoParaInicializar.push('A próxima parcela de adiantamento só será liberada após a comprovação de 80% do valor da parcela anterior, via Solicitação de Prestação de Contas.');
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    carregarAdiantamentos: function carregarAdiantamentos() {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this8.loading.adiantamentos = true;
	                _context2.next = 3;
	                return _this8.buscaContaAdiantamento();
	
	              case 3:
	                axiosLaravel.get('processos/adiantamento/recursos/' + _this8.projeto['Id_proposta']).then(function (response) {
	                  _this8.adiantamentosConcecidos = response.data.adiantamentos_concedidos.row;
	                  _.set(_this8.totais, 'projeto', response.data.dados.recursos);
	                  _.assign(_this8.projeto, response.data.dados.projeto);
	                  _this8.parcelasAtuais = response.data.parcels.row;
	                  _this8.parcelasAtuais.forEach(function (parcela) {
	                    if (_this8.processo === 'DEVOLUCAO_DE_ADIANTAMENTO') {
	                      parcela.requisitado = 0;
	
	                      parcela.disponivel = _this8.arredondaDecimal(_.sumBy(_this8.adiantamentosConcecidos, function (adt) {
	                        return adt.recurso === parcela.resourceSource ? adt.requisitado - (adt.comprovado + adt.devolvido) : 0;
	                      }));
	
	                      _this8.documentosLiberacao.forEach(function (documento) {
	                        if (documento.itens_liberados[0].parcelas_adiantamentos[0].origem === 1 && parcela.resourceSource === 'FUNDACAO') {
	                          parcela.requisitado = Math.abs(documento.itens_liberados[0].valor);
	                        } else if (documento.itens_liberados[0].parcelas_adiantamentos[0].origem === 5 && parcela.resourceSource === 'PARCEIRO_ESTRATEGICO') {
	                          parcela.requisitado = Math.abs(documento.itens_liberados[0].valor);
	                        }
	                      });
	                    }
	
	                    if (_this8.processo === 'ADIANTAMENTO') {
	                      if (_this8.projeto.superior === 18182 && _this8.projeto.parcelas_contratadas === 1) {
	                        parcela.requisitado = parcela.disponivel;
	                      }
	                    }
	
	                    var documentoLiberacao = _.find(_this8.documentosLiberacao, ['id', parcela.id_documento_liberacao]);
	
	                    if (!_.has(parcela, 'numeroTitulo') || _.isEmpty(parcela.numeroTitulo)) {
	                      parcela.numeroTitulo = _.get(documentoLiberacao, 'numero', null);
	                    }
	
	                    var contaFinanceira = _this8.carregarParametrosDocumento(_.get(documentoLiberacao, 'parametros_documento', []), ['CONTA_FINANCEIRA']);
	                    if (contaFinanceira !== '') {
	                      parcela.contaFinanceira = contaFinanceira;
	                    } else if (!_.has(parcela, 'contaFinanceira') || _.isNull(parcela.contaFinanceira) || parcela.contaFinanceira.length < 4) {
	                      parcela.contaFinanceira = parcela.resourceSource === 'FUNDACAO' ? 10828 : 10829;
	                    }
	
	                    var contaTesouraria = _this8.carregarParametrosDocumento(_.get(documentoLiberacao, 'parametros_documento', []), ['CONTA_TESOURARIA']);
	                    if (contaTesouraria !== '') {
	                      parcela.contaTesouraria = contaTesouraria;
	                    } else if (!_.has(parcela, 'contaTesouraria') || _.isNull(parcela.contaTesouraria) || parcela.contaTesouraria.length < 4) {
	                      parcela.contaTesouraria = parcela.resourceSource === 'FUNDACAO' ? '402248-3' : '7020-3';
	                    }
	                  });
	                  _this8.verificaRestricoesAdiantamento();
	                  _this8.calcularTotaisAdiantamento();
	                  _this8.$forceUpdate();
	                  _this8.loading.adiantamentos = false;
	                }).catch(function (error) {
	                  _this8.loading.adiantamentos = false;
	                  console.log('error', error);
	                  _this8.$root.trataErro(error);
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this8);
	      }))();
	    },
	    limitaFaixaEntrada: function limitaFaixaEntrada(tipo, valor, minimo, maximo) {
	      if (_.isNil(valor) && _.isNull(valor) && _.isNaN(valor)) {
	        valor = minimo;
	      } else {
	        if (tipo === 'inteiro') {
	          valor = _.toSafeInteger(('' + valor).replace(/\D+/g, ''));
	        } else if (tipo === 'decimal') {
	          valor = _.toNumber(('' + valor).replace(/[^.0-9]+/g, ''));
	        }
	        valor = valor <= minimo ? minimo : valor >= maximo ? maximo : valor;
	      }
	      var saida = tipo === 'inteiro' ? parseInt(valor) : tipo === 'decimal' ? parseFloat(valor) : valor;
	      this.$forceUpdate();
	      return saida;
	    },
	    carregarListaProjetos: function carregarListaProjetos() {
	      var _this9 = this;
	
	      this.loading.projetos = true;
	
	      axiosLaravel.post('processos/projetos', { 'processo': this.processo, 'tipoBusca': 'simples' }).then(function (response) {
	        var listaProjetos = response.data;
	        var acessosProjetos = _.get(_this9.usuarioLogado, 'configuracoes.acesso_projetos');
	        if (acessosProjetos) {
	          var permissoesAcesso = ['INICIA_SOLICITACAO'];
	          acessosProjetos = _.map(_.filter(acessosProjetos, function (p) {
	            return _.find(p.acesso, function (a) {
	              return _.includes(permissoesAcesso, a.codigo);
	            });
	          }), 'numero');
	          listaProjetos = _.filter(listaProjetos, function (p) {
	            return _.includes(acessosProjetos, p['Numero_projeto']);
	          });
	        }
	        _this9.listaProjetos = listaProjetos;
	        _this9.loading.projetos = false;
	        _this9.$forceUpdate();
	        _this9.alertaRetorna();
	      }).catch(function (error) {
	        _this9.loading.projetos = false;
	        console.log('error', error);
	        _this9.$root.trataErro(error);
	      });
	    },
	    alertaRetorna: function alertaRetorna() {
	      var _this10 = this;
	
	      if (_.isEmpty(this.listaProjetos)) {
	        this.$snotify.error('Não há projetos para ' + this.descricaoProcesso[this.processo]);
	        setTimeout(function () {
	          _this10.$router.go(-1);
	        }, 1000);
	      } else if (this.listaProjetos.length === 1) {
	        this.projeto = _.head(this.listaProjetos);
	        this.selecionaProjeto();
	      }
	    },
	    selecionaProjeto: function selecionaProjeto() {
	      var _this11 = this;
	
	      this.loading.projetos = true;
	      axiosLaravel.post('pagamento/valida/solicitante', { 'projeto': this.projeto, 'processo': this.processo }).then(function (response) {
	        if (_.has(response.data, 'codigo')) {
	          if (response.data.codigo === 'ERRO') {
	            _this11.restricaoParaInicializar = _this11.processo === 'ADIANTAMENTO' && (_.has(response.data, 'mensagem') && !_.isNull(response.data.mensagem) && response.data.mensagem.length > 0 ? response.data.mensagem : ['Erro de processamento. Não sei o que houve']);
	          }
	          _this11.entidade = response.data.retorno;
	          _this11.buscaOcorrencias();
	          _this11.carregarAdiantamentos();
	          if (!_this11.ehParceiroEstrategico) {
	            _this11.consultaProjetosEmAlteracao();
	          }
	        }
	        _this11.loading.projetos = false;
	      }).catch(function (error) {
	        _this11.loading.projetos = false;
	        console.log('error', error);
	        _this11.$root.trataErro(error);
	      });
	    },
	    buscaOcorrencias: function buscaOcorrencias() {
	      var _this12 = this;
	
	      axiosLaravel.post('ocorrencia/busca', { 'informacao': 'SIMPLIFICADO', 'projeto': this.projeto.Numero_projeto, 'nivel': [2, 3, 4], 'situacao': 'LIBERADO' }).then(function (response) {
	        if (_.get(response.data, 'codigo', '') === 'OK') {
	          _this12.ocorrencias = response.data.retorno;
	          if (_this12.ocorrencias.length > 0) {
	            _this12.temOcorrencia = true;
	            if (_.find(_this12.ocorrencias, function (o) {
	              return _.includes([2201, 2202], o.codigo);
	            }) && _.includes(['ADIANTAMENTO'], _this12.processo)) {
	              _this12.restricaoParaInicializar.push('Possui ocorrência(s) que não permite liberar Parcela de Adiantamento');
	            }
	          }
	        } else {
	          _this12.$snotify.error(response.data.mensagem);
	        }
	        _this12.$forceUpdate();
	      }).catch(function (error) {
	        _this12.$snotify.clear();
	        _this12.$root.trataErro(error);
	      });
	    },
	    adicionaRestricao: function adicionaRestricao(ev) {
	      if (!_.isNil(ev) && _.has(ev, 'tag')) {
	        _.remove(this.restricaoParaConcluir, function (i) {
	          return i.tag === ev.tag;
	        });
	
	        this.restricaoParaConcluir.push(ev);
	      }
	    },
	    calcularTotaisAdiantamento: function calcularTotaisAdiantamento() {
	      this.totais.orcado = _.sumBy(this.adiantamentosConcecidos, 'contratado');
	
	      this.totais.liberado = this.arredondaDecimal(_.sumBy(this.adiantamentosConcecidos, 'requisitado'));
	      this.totais.emExecucao = _.sumBy(this.adiantamentosConcecidos, 'em_execucao');
	      this.totais.devolvido = _.sumBy(this.adiantamentosConcecidos, 'devolvido');
	      this.totais.comprovado = _.sumBy(this.adiantamentosConcecidos, 'comprovado');
	
	      this.totais.pendenteComprovacao = this.arredondaDecimal(this.totais.liberado - (this.totais.comprovado + this.totais.devolvido));
	      this.$forceUpdate();
	    },
	    arredondaDecimal: function arredondaDecimal(valor) {
	      return +(Math.round(valor + 'e+2') + 'e-2');
	    },
	    consultaProjetosEmAlteracao: function consultaProjetosEmAlteracao() {
	      var _this13 = this;
	
	      axiosLaravel.get('projeto/alteracoes/verificaAlteracaoEmAndamento/' + this.projeto.Numero_projeto).then(function (response) {
	        _this13.projetoComAlteracaoEmAndamento = response.data.alteracao_em_andamento;
	        if (_this13.projetoComAlteracaoEmAndamento === true) {
	          _this13.adicionaRestricao({ 'tag': 'projetoComAlteracaoEmAndamento', 'ativo': true, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Solicitação não disponível. Verificamos que há uma alteração de projetos em andamento.' });
	          var restricoes = _.filter(_this13.restricaoParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	          var mensagens = '<div class=avisoAlerta><li>' + _.join(_.map(restricoes, 'mensagem'), '<li>') + '</div>';
	          _this13.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	          _this13.msgErroProcessamento.push(mensagens);
	        }
	      }).catch(function (error) {
	        _this13.$snotify.clear();
	        _this13.loading.tela = false;
	        _this13.$root.trataErro(error);
	      });
	    },
	    aviso: function aviso(retorno) {
	      if (_.has(retorno, 'codigo')) {
	        var mensagem = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : 'Erro de processamento. Não sei o que houve';
	        if (retorno.codigo === 'ERRO') {
	          this.$snotify.clear();
	          this.$snotify.error(mensagem);
	        } else {
	          if (_.includes(['OK', 'AVISO'], retorno.codigo)) {
	            this.$snotify.success(mensagem, { timeout: 30000 });
	          }
	        }
	      }
	    },
	    salvar: function salvar() {
	      this.aprovacao.resultadoAprovacao = 'Salvar';
	      this.validarConclusao();
	    },
	    concluir: function concluir() {
	      this.aprovacao.resultadoAprovacao = _.includes(['Solicitação', 'Revisão'], this.etapa) ? 'Análise' : this.aprovacao.resultadoAprovacao;
	      this.validarConclusao();
	    },
	    validarConclusao: function validarConclusao() {
	      var _this14 = this;
	
	      this.adicionaRestricao({ 'tag': 'valorSolicitadoAcima', 'ativo': _.sumBy(this.parcelasAtuais, 'disponivel') - _.sumBy(this.parcelasAtuais, 'requisitado') < 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Valor solicitado ultrapassou do valor total. Verifique o saldo restante.' });
	
	      this.adicionaRestricao({ 'tag': 'nenhumValorInformado', 'ativo': _.sumBy(this.parcelasAtuais, 'requisitado') === 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Não há valor solicitado' });
	
	      this.adicionaRestricao({ 'tag': 'temAnexo', 'ativo': this.adiantamentoSolicitado.documentosAdiantamento.length === 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'É necessário anexar pelo menos um documento comprobatório' });
	
	      this.adicionaRestricao({ 'tag': 'semContaTesouraria', 'ativo': this.processo === 'ADIANTAMENTO' && this.etapa === 'Análise' && _.filter(this.parcelasAtuais, function (p) {
	          return p.requisitado > 0 && (!_.has(p, 'contaTesouraria') || _.isNull(p.contaTesouraria) || p.contaTesouraria.length < 2);
	        }).length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há conta tesouraria que não foi escolhida ainda' });
	
	      this.$validator.validateAll().then(function (validado) {
	        _this14.adicionaRestricao({ 'tag': 'camposPendentes', 'ativo': !validado, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Revise os campos:<li>' + _.join(_.uniq(_.map(_this14.$validator.errors.items, 'msg')), '<li>') });
	
	        var validacaoDadosBancarios = _this14.validandoDadosBancarios();
	        _this14.adicionaRestricao({ 'tag': 'dadosBancariosIncorretos', 'ativo': _.isString(validacaoDadosBancarios), 'tipo': 'restricao', 'acao': null, 'mensagem': validacaoDadosBancarios });
	
	        if (_this14.restricaoParaConcluir.length > 0 && _.filter(_this14.restricaoParaConcluir, { 'ativo': true }).length > 0) {
	          var restricoes = _.filter(_this14.restricaoParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	          if (restricoes.length > 0) {
	            var mensagens = '<div class=avisoAlerta><li>' + _.join(_.map(restricoes, 'mensagem'), '<li>') + '</div>';
	            _this14.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	          }
	        } else {
	          _this14.processarConclusao();
	        }
	      });
	    },
	    processarConclusao: function processarConclusao() {
	      this.adiantamentoSolicitado.id = this.id;
	      this.adiantamentoSolicitado.projeto = this.projeto;
	      this.adiantamentoSolicitado.processo = this.processo;
	      if (this.etapa === 'Análise Financeira') {
	        this.adiantamentoSolicitado.etapa = 'Acerto Contábil';
	      } else {
	        this.adiantamentoSolicitado.etapa = this.etapa;
	      }
	      this.adiantamentoSolicitado.data_edicao = this.data_edicao;
	      this.adiantamentoSolicitado.proximaEtapa = _.isNull(this.id) ? 'Análise' : this.aprovacao.resultadoAprovacao;
	      this.adiantamentoSolicitado.parcelasAtuais = this.parcelasAtuais;
	      if (this.aprovacao.resultadoAprovacao === 'Revisão' && !_.isNull(this.motivoDevolucao)) {
	        _.set(this.motivoDevolucao, 'fk_usuario', this.usuarioLogado.id);
	        this.adiantamentoSolicitado.parametrosDocumento.push({ 'fk_documentos_liberacao': this.id, 'parametro': 'MOTIVO_DEVOLUCAO', 'valor': (0, _stringify2.default)(this.motivoDevolucao) });
	      }
	      this.encaminharProximaTarefa();
	    },
	    encaminharProximaTarefa: function encaminharProximaTarefa() {
	      var _this15 = this;
	
	      if (this.aprovacao.resultadoAprovacao === 'Análise Financeira') {
	        this.$aguarde(this.aprovacao.resultadoAprovacao === 'Salvar' ? 'Salvando' : 'Encaminhando ' + this.descricaoProcesso[this.processo] + (_.isUndefined(this.aprovacao.resultadoAprovacao) ? '...' : ' para Acerto Contábil'));
	      } else {
	        this.$aguarde(this.aprovacao.resultadoAprovacao === 'Salvar' ? 'Salvando' : 'Encaminhando ' + this.descricaoProcesso[this.processo] + (_.isUndefined(this.aprovacao.resultadoAprovacao) ? '...' : ' para ' + this.aprovacao.resultadoAprovacao));
	      }
	      this.loading.processo = true;
	      this.$forceUpdate();
	      axiosLaravel.post('processos/encaminha/adiantamento', this.adiantamentoSolicitado).then(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(response) {
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  _this15.$snotify.clear();
	
	                  if (_.includes(['ADIANTAMENTO'], _this15.processo) && _this15.etapa === 'Análise' && _this15.aprovacao.resultadoAprovacao === 'Autorização') {
	                    _this15.emitir(199);
	                  }
	                  if (_this15.usuarioLogado.userType === 'FUNDACAO') {
	                    if (_this15.aprovacao.resultadoAprovacao === 'Salvar') {
	                      _this15.$router.push(_this15.rotasProcesso[_this15.processo] + '/' + response.data.id);
	                    } else {
	                      _this15.$router.go(-1);
	                    }
	                  } else {
	                    _this15.$router.push('/solicitacao/lista');
	                  }
	                  _this15.$snotify.success(_this15.aprovacao.resultadoAprovacao === 'Salvar' ? 'Gravado com sucesso. Relendo a solicitação...' : _this15.descricaoProcesso[_this15.processo] + ' validado com sucesso');
	                  _this15.loading.processo = false;
	
	                case 5:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this15);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }()).catch(function (error) {
	        _this15.loading.processo = false;
	        _this15.$snotify.clear();
	        _this15.$root.trataErro(error);
	      });
	    },
	    gravaHistorico: function gravaHistorico(_parm) {},
	    validandoDadosBancarios: function validandoDadosBancarios() {
	      if (this.adiantamentoSolicitado.dados_bancarios.agencia && this.adiantamentoSolicitado.dados_bancarios.conta && (this.adiantamentoSolicitado.dados_bancarios.tipo === 1 || this.tipoContaSelecionado.codigo === 1)) {
	        var banco = _.has(this.bancoSelecionado, 'codigo') ? this.bancoSelecionado.codigo : '000';
	
	        var conta = _.words(this.adiantamentoSolicitado.dados_bancarios.conta);
	        var digitosConta = _.get(_.head(_.filter(this.listaBancos, ['codigo', banco])), 'caracteresConta');
	        var contaSemDV = digitosConta ? _.padStart(conta[0], digitosConta, '0') : conta[0];
	        var contaDV = conta[1] || '';
	
	        var agencia = _.words(this.adiantamentoSolicitado.dados_bancarios.agencia);
	        var agenciaSemDV = agencia[0] || '';
	        var agenciaDV = agencia[1] || '';
	        try {
	          _brBankAccountValidator2.default.validate({
	            bankNumber: banco,
	            agencyNumber: agenciaSemDV,
	            agencyCheckNumber: agenciaDV,
	            accountNumber: contaSemDV,
	            accountCheckNumber: contaDV
	          });
	          return true;
	        } catch (e) {
	          console.log('Erro na validação de dados bancários', e.message);
	          return e.message;
	        }
	      }
	      return false;
	    },
	    emitir: function emitir(relatorio) {
	      var _this16 = this;
	
	      var mosDes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loading.processo = true;
	      this.projeto['Numero_projeto'] = _.has(this.projeto, 'Numero_projeto') ? this.projeto['Numero_projeto'] : this.projeto.Projeto.substring(0, 5);
	      if (!_.toSafeInteger(this.projeto['Numero_projeto']) > 0) {
	        this.$snotify.error('Há algum erro ao pegar o número deste projeto. Favor informar o administrador do sistema');
	        return;
	      }
	      var codigoRelatorio = (_.includes([200, 199], relatorio) ? 'SRNF' : 'FJCF') + relatorio + '.GER';
	      if (relatorio === 199) {
	        if (this.processo === 'ADIANTAMENTO') {
	          axiosLaravel.get('processos/' + this.id).then(function (response) {
	            response.data.documentos_liberacao.forEach(function (documento) {
	              var parcela = _.find(_this16.parcelasAtuais, ['id_documento_liberacao', documento.id]);
	              var ESeqBan = parseInt(_this16.carregarParametrosDocumento(documento.parametros_documento, ['SeqBan']));
	              var ENumprj = _this16.projeto.Numero_projeto;
	              var EVlrAdt = parcela.requisitado.toLocaleString('pt-Br', { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false });
	              var EPeriod = 90;
	              var ECodFpj = documento.serie === 'AMT' ? 'RT' : 'RP';
	              var ECtaFin = parcela.contaFinanceira;
	              var ECtaTesou = parcela.contaTesouraria;
	
	              var complementoObservacao = '';
	              if (response.data.documentos_liberacao.length > 1) {
	                var titulos = [];
	                response.data.documentos_liberacao.forEach(function (titulo) {
	                  titulos.push(titulo['numero'] + ' ' + titulo['serie']);
	                });
	                complementoObservacao = '{ID com ' + response.data.documentos_liberacao.length + ' titulos: ' + _.join(titulos, ', ') + '} ';
	              }
	              var EObservacao = '{Tarefa SGP (' + _this16.processo + '): ' + _this16.id + '} ' + complementoObservacao;
	
	              if (_this16.adiantamentoSolicitado.observacao != null) {
	                EObservacao += _this16.adiantamentoSolicitado.observacao;
	              }
	              var Etit = documento.numero == null ? 'Sem título' : documento.numero;
	
	              var parametros = '<ECodEmp=1><ENumPrj=' + ENumprj + '><EVlrAdt=' + EVlrAdt + '><EPeriod=' + EPeriod + '><ECodFpj=' + ECodFpj + '><ESeqBan=' + ESeqBan + '><ECtaFin=' + ECtaFin + '><ECtaTesou=' + ECtaTesou + '><EObs=' + EObservacao + '><Etit=' + Etit + '>';
	              _this16.$snotify.clear();
	              var textoAviso = response.data.documentos_liberacao.length > 1 ? 'Gerando ' + response.data.documentos_liberacao.length + ' relatórios ' : 'Gerando relatório ';
	              _this16.$aguarde(textoAviso + relatorio + '. Por favor, aguarde...');
	              axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': codigoRelatorio }, params: parametros }).then(function (response) {
	                _this16.onDownload(response, relatorio, _this16);
	              }).catch(function (error) {
	                _this16.$snotify.clear();
	                _this16.loading.processo = false;
	                _this16.$root.trataErro(error);
	              });
	            });
	          }).catch(function (error) {
	            console.log('error', error);
	            _this16.$root.trataErro(error);
	          });
	        } else {
	          this.$snotify.error('CI de Adiantamento (199) não pode ser emitido para ' + this.descricaoProcesso[this.processo]);
	        }
	      } else {
	        var parametros = '<ECodEmp=1><ENumPrj=' + this.projeto['Numero_projeto'] + '>';
	
	        if (relatorio === 219) {
	          parametros += '<ESitPrj=ULT>';
	        } else if (relatorio === 248) {
	          parametros += '<ECodFor=>';
	        }
	
	        if (relatorio === 525) {
	          parametros = '<ENumPrj=' + this.projeto['Numero_projeto'] + '><EMosDes=' + mosDes + '>';
	        }
	        this.$snotify.clear();
	        var identificacao = relatorio === 525 ? '525 - Extrato ' + (mosDes === 'S' ? 'Analítico' : 'Sintético') : relatorio;
	        this.$aguarde('Gerando relatório ' + identificacao + '. Por favor, aguarde...');
	        axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': codigoRelatorio }, params: parametros }).then(function (response) {
	          _this16.onDownload(response, identificacao, _this16);
	        }).catch(function (error) {
	          _this16.$snotify.clear();
	          _this16.loading.processo = false;
	          _this16.$root.trataErro(error);
	        });
	      }
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (relatorio !== 199) {
	        if (!ie) {
	          var blob = file;
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = 'Relatório ' + relatorio + ' » ' + vm.projeto.Projeto;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var _blob = file;
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	          _link.download = 'Relatório ' + relatorio + ' » ' + vm.projeto.Projeto;
	          _link.click();
	        }
	      } else {
	        var tipoProcesso = this.processo === 'ADIANTAMENTO' ? 'ADT' : 'DAT';
	        if (!ie) {
	          var _blob2 = file;
	          var _link2 = document.createElement('a');
	          _link2.href = window.URL.createObjectURL(_blob2);
	
	          _link2.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + vm.id + ' ' + tipoProcesso;
	
	          document.body.appendChild(_link2);
	          _link2.click();
	          document.body.removeChild(_link2);
	        } else {
	          var _blob3 = file;
	          var _link3 = document.createElement('blob');
	          _link3.href = window.navigator.msSaveOrOpenBlob(_blob3, item.name);
	
	          _link3.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + vm.id + ' ' + tipoProcesso;
	
	          _link3.click();
	        }
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading.processo = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    verificaChamado: function verificaChamado() {
	      var _this17 = this;
	
	      axiosLaravel.post('chamado/chamadoProcesso/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this17.chamado = response.data;
	      }).catch(function (error) {
	        _this17.$snotify.clear();
	        _this17.$root.trataErro(error);
	      });
	    },
	    onDownloadZIP: function onDownloadZIP() {
	      var _this18 = this;
	
	      this.$forceUpdate();
	      this.$aguarde('Baixando arquivos. Por favor, aguarde...');
	      axiosLaravel.get('processos/documentos/download/' + this.$route.params.id).then(function (response) {
	        var link = document.createElement('a');
	        link.href = response.data;
	        link.download = 'Arquivo não localizado';
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	        _this18.$snotify.clear();
	        _this18.$forceUpdate();
	      }).catch(function (error) {
	        _this18.$snotify.clear();
	        _this18.$root.trataErro(error);
	      });
	    },
	    abrirChamado: function abrirChamado() {
	      var urlString = '';
	      var projeto = this.projeto.Numero_projeto;
	      var processo = this.processo;
	      var idTarefa = null;
	
	      if (this.etapa === 'Revisão') {
	        idTarefa = this.validacao.fk_processos;
	      }
	      urlString = '/cadastro/chamado/criar?projeto=' + projeto + '&processo=' + processo + '&idTarefa=' + idTarefa;
	      window.open(urlString, '_blank');
	    }
	  }
	};

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'grid-solicitacao-adiantamento-concecida',
	  data: function data() {
	    return {};
	  },
	
	  props: ['propsProjeto'],
	  computed: {
	    dataLimite: function dataLimite() {
	      this.$forceUpdate();
	      return (0, _moment2.default)(this.propsProjeto.createDate).add(90, 'days').format('DD/MM/YYYY');
	    },
	    adiantamentos_concedidos: function adiantamentos_concedidos() {
	      return this.propsProjeto.adiantamentos_concedidos;
	    }
	  },
	  methods: {}
	};

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'listaBancos',
	  props: {
	    propsBanco: null
	  },
	  data: function data() {
	    return {
	      listaBancos: [{ 'codigo': '001', 'nome': 'Banco do Brasil S.A.', 'caracteresConta': 8 }, {
	        'codigo': '033',
	        'nome': 'Banco Santander (Brasil) S.A.',
	        'caracteresConta': 8,
	        'digitoAgencia': false
	      }, { 'codigo': '070', 'nome': 'BRB - Banco de Brasília S.A.' }, {
	        'codigo': '104',
	        'nome': 'Caixa Econômica Federal',
	        'digitoAgencia': false
	      }, { 'codigo': '237', 'nome': 'Banco Bradesco S.A.', 'caracteresConta': 7 }, {
	        'codigo': '341',
	        'nome': 'Itaú Unibanco S.A.',
	        'caracteresConta': 5,
	        'digitoAgencia': false
	      }, { 'codigo': '', 'nome': '', $isDisabled: true }, { 'codigo': '003', 'nome': 'BANCO DA AMAZONIA S.A.' }, {
	        'codigo': '004',
	        'nome': 'Banco do Nordeste do Brasil S.A.'
	      }, { 'codigo': '007', 'nome': 'BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL' }, {
	        'codigo': '010',
	        'nome': 'CREDICOAMO CREDITO RURAL COOPERATIVA'
	      }, { 'codigo': '011', 'nome': 'CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A' }, {
	        'codigo': '012',
	        'nome': 'Banco Inbursa S.A.'
	      }, { 'codigo': '014', 'nome': 'STATE STREET BRASIL S.A. ? BANCO COMERCIAL' }, {
	        'codigo': '015',
	        'nome': 'UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.'
	      }, {
	        'codigo': '016',
	        'nome': 'COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI'
	      }, { 'codigo': '017', 'nome': 'BNY Mellon Banco S.A.' }, {
	        'codigo': '018',
	        'nome': 'Banco Tricury S.A.'
	      }, { 'codigo': '021', 'nome': 'BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO' }, {
	        'codigo': '024',
	        'nome': 'Banco Bandepe S.A.'
	      }, { 'codigo': '025', 'nome': 'Banco Alfa S.A.' }, {
	        'codigo': '029',
	        'nome': 'Banco Itaú Consignado S.A.'
	      }, { 'codigo': '036', 'nome': 'Banco Bradesco BBI S.A.' }, {
	        'codigo': '037',
	        'nome': 'Banco do Estado do Pará S.A.'
	      }, { 'codigo': '040', 'nome': 'Banco Cargill S.A.' }, {
	        'codigo': '041',
	        'nome': 'Banco do Estado do Rio Grande do Sul S.A.',
	        'caracteresConta': 9
	      }, { 'codigo': '047', 'nome': 'Banco do Estado de Sergipe S.A.' }, {
	        'codigo': '060',
	        'nome': 'Confidence Corretora de Câmbio S.A.'
	      }, { 'codigo': '062', 'nome': 'Hipercard Banco Múltiplo S.A.' }, {
	        'codigo': '063',
	        'nome': 'Banco Bradescard S.A.'
	      }, { 'codigo': '064', 'nome': 'GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.' }, {
	        'codigo': '065',
	        'nome': 'Banco AndBank (Brasil) S.A.'
	      }, { 'codigo': '066', 'nome': 'BANCO MORGAN STANLEY S.A.' }, {
	        'codigo': '069',
	        'nome': 'Banco Crefisa S.A.'
	      }, { 'codigo': '074', 'nome': 'Banco J. Safra S.A.' }, {
	        'codigo': '075',
	        'nome': 'Banco ABN Amro S.A.'
	      }, { 'codigo': '076', 'nome': 'Banco KDB do Brasil S.A.' }, {
	        'codigo': '077',
	        'nome': 'Banco Inter S.A.'
	      }, { 'codigo': '078', 'nome': 'Haitong Banco de Investimento do Brasil S.A.' }, {
	        'codigo': '079',
	        'nome': 'Banco Original do Agronegócio S.A.'
	      }, { 'codigo': '080', 'nome': 'B&T CORRETORA DE CAMBIO LTDA.' }, {
	        'codigo': '081',
	        'nome': 'BancoSeguro S.A.'
	      }, { 'codigo': '082', 'nome': 'BANCO TOPÁZIO S.A.' }, {
	        'codigo': '083',
	        'nome': 'Banco da China Brasil S.A.'
	      }, { 'codigo': '084', 'nome': 'UNIPRIME NORTE DO PARANÁ – COOPERATIVA DE CRÉDITO LTDA' }, {
	        'codigo': '085',
	        'nome': 'Cooperativa Central de Crédito – Ailos'
	      }, { 'codigo': '088', 'nome': 'BANCO RANDON S.A.' }, {
	        'codigo': '089',
	        'nome': 'CREDISAN COOPERATIVA DE CRÉDITO'
	      }, {
	        'codigo': '091',
	        'nome': 'CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S'
	      }, { 'codigo': '092', 'nome': 'BRK S.A. Crédito, Financiamento e Investimento' }, {
	        'codigo': '093',
	        'nome': 'PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT'
	      }, { 'codigo': '094', 'nome': 'Banco Finaxis S.A.' }, {
	        'codigo': '095',
	        'nome': 'Travelex Banco de Câmbio S.A.'
	      }, { 'codigo': '096', 'nome': 'Banco B3 S.A.' }, {
	        'codigo': '097',
	        'nome': 'Credisis – Central de Cooperativas de Crédito Ltda.'
	      }, { 'codigo': '098', 'nome': 'Credialiança Cooperativa de Crédito Rural' }, {
	        'codigo': '099',
	        'nome': 'UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.'
	      }, { 'codigo': '100', 'nome': 'Planner Corretora de Valores S.A.' }, {
	        'codigo': '101',
	        'nome': 'RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA'
	      }, {
	        'codigo': '102',
	        'nome': 'XP INVESTIMENTOS CORRETORA DE CÂMBIO,TÍTULOS E VALORES MOBILIÁRIOS S/A'
	      }, { 'codigo': '105', 'nome': 'Lecca Crédito, Financiamento e Investimento S/A' }, {
	        'codigo': '107',
	        'nome': 'Banco Bocom BBM S.A.'
	      }, { 'codigo': '108', 'nome': 'PORTOCRED S.A. – CREDITO, FINANCIAMENTO E INVESTIMENTO' }, {
	        'codigo': '111',
	        'nome': 'OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.'
	      }, { 'codigo': '113', 'nome': 'Magliano S.A. Corretora de Cambio e Valores Mobiliarios' }, {
	        'codigo': '114',
	        'nome': 'Central Cooperativa de Crédito no Estado do Espírito Santo – CECOOP'
	      }, { 'codigo': '117', 'nome': 'ADVANCED CORRETORA DE CÂMBIO LTDA' }, {
	        'codigo': '119',
	        'nome': 'Banco Western Union do Brasil S.A.'
	      }, { 'codigo': '120', 'nome': 'BANCO RODOBENS S.A.' }, {
	        'codigo': '121',
	        'nome': 'Banco Agibank S.A.'
	      }, { 'codigo': '122', 'nome': 'Banco Bradesco BERJ S.A.' }, {
	        'codigo': '124',
	        'nome': 'Banco Woori Bank do Brasil S.A.'
	      }, { 'codigo': '125', 'nome': 'Plural S.A. Banco Múltiplo' }, {
	        'codigo': '126',
	        'nome': 'BR Partners Banco de Investimento S.A.'
	      }, { 'codigo': '127', 'nome': 'Codepe Corretora de Valores e Câmbio S.A.' }, {
	        'codigo': '128',
	        'nome': 'MS Bank S.A. Banco de Câmbio'
	      }, { 'codigo': '129', 'nome': 'UBS Brasil Banco de Investimento S.A.' }, {
	        'codigo': '130',
	        'nome': 'CARUANA S.A. – SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO'
	      }, { 'codigo': '131', 'nome': 'TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA' }, {
	        'codigo': '132',
	        'nome': 'ICBC do Brasil Banco Múltiplo S.A.'
	      }, {
	        'codigo': '133',
	        'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E'
	      }, {
	        'codigo': '134',
	        'nome': 'BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA'
	      }, {
	        'codigo': '136',
	        'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. – UNICRED DO BRASI'
	      }, { 'codigo': '138', 'nome': 'Get Money Corretora de Câmbio S.A.' }, {
	        'codigo': '139',
	        'nome': 'Intesa Sanpaolo Brasil S.A. – Banco Múltiplo'
	      }, { 'codigo': '140', 'nome': 'Easynvest – Título Corretora de Valores SA' }, {
	        'codigo': '142',
	        'nome': 'Broker Brasil Corretora de Câmbio Ltda.'
	      }, { 'codigo': '143', 'nome': 'Treviso Corretora de Câmbio S.A.' }, {
	        'codigo': '144',
	        'nome': 'BEXS BANCO DE CÂMBIO S/A'
	      }, { 'codigo': '145', 'nome': 'LEVYCAM – CORRETORA DE CAMBIO E VALORES LTDA.' }, {
	        'codigo': '146',
	        'nome': 'GUITTA CORRETORA DE CAMBIO LTDA.'
	      }, {
	        'codigo': '149',
	        'nome': 'Facta Financeira S.A. – Crédito Financiamento e Investimento'
	      }, {
	        'codigo': '157',
	        'nome': 'ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.'
	      }, {
	        'codigo': '159',
	        'nome': 'Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor'
	      }, { 'codigo': '163', 'nome': 'Commerzbank Brasil S.A. – Banco Múltiplo' }, {
	        'codigo': '169',
	        'nome': 'BANCO OLÉ CONSIGNADO S.A.'
	      }, {
	        'codigo': '173',
	        'nome': 'BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.'
	      }, { 'codigo': '174', 'nome': 'PEFISA S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, {
	        'codigo': '177',
	        'nome': 'Guide Investimentos S.A. Corretora de Valores'
	      }, {
	        'codigo': '180',
	        'nome': 'CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA'
	      }, {
	        'codigo': '183',
	        'nome': 'SOCRED S.A. – SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P'
	      }, { 'codigo': '184', 'nome': 'Banco Itaú BBA S.A.' }, {
	        'codigo': '188',
	        'nome': 'ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS, CÂMBIO E VALORES'
	      }, { 'codigo': '189', 'nome': 'HS FINANCEIRA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' }, {
	        'codigo': '190',
	        'nome': 'SERVICOOP – COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN'
	      }, {
	        'codigo': '191',
	        'nome': 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.'
	      }, {
	        'codigo': '194',
	        'nome': 'PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA'
	      }, { 'codigo': '196', 'nome': 'FAIR CORRETORA DE CAMBIO S.A.' }, {
	        'codigo': '197',
	        'nome': 'Stone Pagamentos S.A.'
	      }, { 'codigo': '208', 'nome': 'Banco BTG Pactual S.A.' }, {
	        'codigo': '212',
	        'nome': 'Banco Original S.A.'
	      }, { 'codigo': '213', 'nome': 'Banco Arbi S.A.' }, {
	        'codigo': '217',
	        'nome': 'Banco John Deere S.A.'
	      }, { 'codigo': '218', 'nome': 'Banco BS2 S.A.' }, {
	        'codigo': '222',
	        'nome': 'BANCO CRÉDIT AGRICOLE BRASIL S.A.'
	      }, { 'codigo': '224', 'nome': 'Banco Fibra S.A.' }, {
	        'codigo': '233',
	        'nome': 'Banco Cifra S.A.'
	      }, { 'codigo': '241', 'nome': 'BANCO CLASSICO S.A.' }, {
	        'codigo': '243',
	        'nome': 'Banco Máxima S.A.'
	      }, { 'codigo': '246', 'nome': 'Banco ABC Brasil S.A.' }, {
	        'codigo': '249',
	        'nome': 'Banco Investcred Unibanco S.A.'
	      }, { 'codigo': '250', 'nome': 'BCV – BANCO DE CRÉDITO E VAREJO S.A.' }, {
	        'codigo': '253',
	        'nome': 'Bexs Corretora de Câmbio S/A'
	      }, { 'codigo': '254', 'nome': 'PARANÁ BANCO S.A.' }, {
	        'codigo': '259',
	        'nome': 'MONEYCORP BANCO DE CÂMBIO S.A.'
	      }, { 'codigo': '260', 'nome': 'Nu Pagamentos S.A.' }, {
	        'codigo': '265',
	        'nome': 'Banco Fator S.A.'
	      }, { 'codigo': '266', 'nome': 'BANCO CEDULA S.A.' }, {
	        'codigo': '268',
	        'nome': 'BARI COMPANHIA HIPOTECÁRIA'
	      }, { 'codigo': '269', 'nome': 'BANCO HSBC S.A.' }, {
	        'codigo': '270',
	        'nome': 'Sagitur Corretora de Câmbio Ltda.'
	      }, { 'codigo': '271', 'nome': 'IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, {
	        'codigo': '272',
	        'nome': 'AGK CORRETORA DE CAMBIO S.A.'
	      }, {
	        'codigo': '273',
	        'nome': 'Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel'
	      }, {
	        'codigo': '274',
	        'nome': 'MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT'
	      }, { 'codigo': '276', 'nome': 'Senff S.A. – Crédito, Financiamento e Investimento' }, {
	        'codigo': '278',
	        'nome': 'Genial Investimentos Corretora de Valores Mobiliários S.A.'
	      }, { 'codigo': '279', 'nome': 'COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' }, {
	        'codigo': '280',
	        'nome': 'Avista S.A. Crédito, Financiamento e Investimento'
	      }, { 'codigo': '281', 'nome': 'Cooperativa de Crédito Rural Coopavel' }, {
	        'codigo': '283',
	        'nome': 'RB CAPITAL INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LIMITADA'
	      }, { 'codigo': '285', 'nome': 'Frente Corretora de Câmbio Ltda.' }, {
	        'codigo': '286',
	        'nome': 'COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO'
	      }, { 'codigo': '288', 'nome': 'CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, {
	        'codigo': '289',
	        'nome': 'DECYSEO CORRETORA DE CAMBIO LTDA.'
	      }, { 'codigo': '290', 'nome': 'Pagseguro Internet S.A.' }, {
	        'codigo': '292',
	        'nome': 'BS2 Distribuidora de Títulos e Valores Mobiliários S.A.'
	      }, {
	        'codigo': '293',
	        'nome': 'Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.'
	      }, { 'codigo': '296', 'nome': 'VISION S.A. CORRETORA DE CAMBIO' }, {
	        'codigo': '298',
	        'nome': 'Vip’s Corretora de Câmbio Ltda.'
	      }, { 'codigo': '299', 'nome': 'SOROCRED   CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, {
	        'codigo': '300',
	        'nome': 'Banco de la Nacion Argentina'
	      }, { 'codigo': '301', 'nome': 'BPP Instituição de Pagamento S.A.' }, {
	        'codigo': '306',
	        'nome': 'PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.'
	      }, {
	        'codigo': '307',
	        'nome': 'Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.'
	      }, { 'codigo': '309', 'nome': 'CAMBIONET CORRETORA DE CÂMBIO LTDA.' }, {
	        'codigo': '310',
	        'nome': 'VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.'
	      }, { 'codigo': '311', 'nome': 'DOURADA CORRETORA' }, {
	        'codigo': '312',
	        'nome': 'HSCM SCMEPP LTDA.'
	      }, { 'codigo': '313', 'nome': 'AMAZÔNIA CORRETORA DE CÂMBIO LTDA.' }, {
	        'codigo': '315',
	        'nome': 'PI Distribuidora de Títulos e Valores Mobiliários S.A.'
	      }, { 'codigo': '318', 'nome': 'Banco BMG S.A.' }, {
	        'codigo': '319',
	        'nome': 'OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA'
	      }, { 'codigo': '320', 'nome': 'China Construction Bank (Brasil) Banco Múltiplo S/A' }, {
	        'codigo': '321',
	        'nome': 'CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT'
	      }, {
	        'codigo': '322',
	        'nome': 'Cooperativa de Crédito Rural de Abelardo Luz – Sulcredi/Crediluz'
	      }, { 'codigo': '323', 'nome': 'MERCADOPAGO.COM REPRESENTACOES LTDA.' }, {
	        'codigo': '324',
	        'nome': 'CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.'
	      }, { 'codigo': '325', 'nome': 'Órama Distribuidora de Títulos e Valores Mobiliários S.A.' }, {
	        'codigo': '326',
	        'nome': 'PARATI – CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.'
	      }, { 'codigo': '329', 'nome': 'QI Sociedade de Crédito Direto S.A.' }, {
	        'codigo': '330',
	        'nome': 'BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.'
	      }, {
	        'codigo': '331',
	        'nome': 'Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.'
	      }, { 'codigo': '332', 'nome': 'Acesso Soluções de Pagamento S.A.' }, {
	        'codigo': '335',
	        'nome': 'Banco Digio S.A.'
	      }, { 'codigo': '336', 'nome': 'Banco C6 S.A.' }, {
	        'codigo': '340',
	        'nome': 'Super Pagamentos e Administração de Meios Eletrônicos S.A.'
	      }, { 'codigo': '342', 'nome': 'Creditas Sociedade de Crédito Direto S.A.' }, {
	        'codigo': '343',
	        'nome': 'FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.'
	      }, { 'codigo': '348', 'nome': 'Banco XP S.A.' }, {
	        'codigo': '349',
	        'nome': 'AL5 S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO'
	      }, {
	        'codigo': '350',
	        'nome': 'COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE'
	      }, { 'codigo': '352', 'nome': 'TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, {
	        'codigo': '354',
	        'nome': 'NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES'
	      }, { 'codigo': '355', 'nome': 'ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.' }, {
	        'codigo': '358',
	        'nome': 'MIDWAY S.A. - SCFI'
	      }, { 'codigo': '359', 'nome': 'ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A' }, {
	        'codigo': '360',
	        'nome': 'TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.'
	      }, { 'codigo': '362', 'nome': 'CIELO S.A.' }, {
	        'codigo': '363',
	        'nome': 'SOCOPA SOCIEDADE CORRETORA PAULISTA S.A.'
	      }, { 'codigo': '364', 'nome': 'GERENCIANET S.A.' }, {
	        'codigo': '365',
	        'nome': 'SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS'
	      }, { 'codigo': '366', 'nome': 'BANCO SOCIETE GENERALE BRASIL S.A.' }, {
	        'codigo': '367',
	        'nome': 'VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.'
	      }, { 'codigo': '368', 'nome': 'Banco CSF S.A.' }, {
	        'codigo': '370',
	        'nome': 'Banco Mizuho do Brasil S.A.'
	      }, { 'codigo': '371', 'nome': 'WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.' }, {
	        'codigo': '373',
	        'nome': 'UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.'
	      }, { 'codigo': '374', 'nome': 'REALIZE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, {
	        'codigo': '376',
	        'nome': 'BANCO J.P. MORGAN S.A.'
	      }, {
	        'codigo': '377',
	        'nome': 'MS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA'
	      }, { 'codigo': '378', 'nome': 'BBC LEASING S.A. – ARRENDAMENTO MERCANTIL' }, {
	        'codigo': '379',
	        'nome': 'COOPERFORTE – COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS FUNCIONÁRIOS DE INSTIT'
	      }, { 'codigo': '380', 'nome': 'PICPAY SERVICOS S.A.' }, {
	        'codigo': '381',
	        'nome': 'BANCO MERCEDES-BENZ DO BRASIL S.A.'
	      }, {
	        'codigo': '382',
	        'nome': 'FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L'
	      }, { 'codigo': '383', 'nome': 'BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.' }, {
	        'codigo': '384',
	        'nome': 'GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO'
	      }, { 'codigo': '386', 'nome': 'NU FINANCEIRA S.A. CFI' }, {
	        'codigo': '387',
	        'nome': 'Banco Toyota do Brasil S.A.'
	      }, { 'codigo': '389', 'nome': 'Banco Mercantil do Brasil S.A.' }, {
	        'codigo': '390',
	        'nome': 'BANCO GM S.A.'
	      }, { 'codigo': '391', 'nome': 'COOPERATIVA DE CREDITO RURAL DE IBIAM – SULCREDI/IBIAM' }, {
	        'codigo': '393',
	        'nome': 'Banco Volkswagen S.A.'
	      }, { 'codigo': '394', 'nome': 'Banco Bradesco Financiamentos S.A.' }, {
	        'codigo': '395',
	        'nome': 'F D GOLD DTVM LTDA'
	      }, { 'codigo': '396', 'nome': 'HUB PAGAMENTOS S.A' }, {
	        'codigo': '397',
	        'nome': 'LISTO SOCIEDADE DE CREDITO DIRETO S.A.'
	      }, { 'codigo': '398', 'nome': 'IDEAL CTVM S.A.' }, {
	        'codigo': '399',
	        'nome': 'Kirton Bank S.A. – Banco Múltiplo'
	      }, { 'codigo': '400', 'nome': 'CC POUP SER FIN CO' }, {
	        'codigo': '402',
	        'nome': 'COBUCCIO SCD S.A.'
	      }, { 'codigo': '403', 'nome': 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' }, {
	        'codigo': '404',
	        'nome': 'SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A.'
	      }, { 'codigo': '406', 'nome': 'ACCREDITO SCD S.A.' }, {
	        'codigo': '407',
	        'nome': 'ÍNDIGO INVESTIMENTOS DTVM LTDA.'
	      }, { 'codigo': '408', 'nome': 'BÔNUSCRED SOCIEDADE DE CRÉDITO DIRETO S.A.' }, {
	        'codigo': '410',
	        'nome': 'PLANNER SCM S.A.'
	      }, { 'codigo': '411', 'nome': 'VIA CERTA FINANCIADORA S.A. - CFI' }, {
	        'codigo': '412',
	        'nome': 'BANCO CAPITAL S.A.'
	      }, { 'codigo': '419', 'nome': 'NUMBRS SCD S.A.' }, {
	        'codigo': '422',
	        'nome': 'Banco Safra S.A.'
	      }, { 'codigo': '456', 'nome': 'Banco MUFG Brasil S.A.' }, {
	        'codigo': '464',
	        'nome': 'Banco Sumitomo Mitsui Brasileiro S.A.'
	      }, { 'codigo': '473', 'nome': 'Banco Caixa Geral – Brasil S.A.' }, {
	        'codigo': '477',
	        'nome': 'Citibank N.A.'
	      }, { 'codigo': '479', 'nome': 'Banco ItauBank S.A.' }, {
	        'codigo': '487',
	        'nome': 'DEUTSCHE BANK S.A. – BANCO ALEMAO'
	      }, { 'codigo': '488', 'nome': 'JPMorgan Chase Bank, National Association' }, {
	        'codigo': '492',
	        'nome': 'ING Bank N.V.'
	      }, { 'codigo': '495', 'nome': 'Banco de La Provincia de Buenos Aires' }, {
	        'codigo': '505',
	        'nome': 'Banco Credit Suisse (Brasil) S.A.'
	      }, { 'codigo': '545', 'nome': 'SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A' }, {
	        'codigo': '600',
	        'nome': 'Banco Luso Brasileiro S.A.'
	      }, { 'codigo': '604', 'nome': 'Banco Industrial do Brasil S.A.' }, {
	        'codigo': '610',
	        'nome': 'Banco VR S.A.'
	      }, { 'codigo': '611', 'nome': 'Banco Paulista S.A.' }, {
	        'codigo': '612',
	        'nome': 'Banco Guanabara S.A.'
	      }, { 'codigo': '613', 'nome': 'Omni Banco S.A.' }, {
	        'codigo': '623',
	        'nome': 'Banco Pan S.A.'
	      }, { 'codigo': '626', 'nome': 'BANCO C6 CONSIGNADO S.A.' }, {
	        'codigo': '630',
	        'nome': 'Banco Smartbank S.A.'
	      }, { 'codigo': '633', 'nome': 'Banco Rendimento S.A.' }, {
	        'codigo': '634',
	        'nome': 'BANCO TRIANGULO S.A.'
	      }, { 'codigo': '637', 'nome': 'BANCO SOFISA S.A.' }, {
	        'codigo': '643',
	        'nome': 'Banco Pine S.A.'
	      }, { 'codigo': '652', 'nome': 'Itaú Unibanco Holding S.A.' }, {
	        'codigo': '653',
	        'nome': 'BANCO INDUSVAL S.A.'
	      }, { 'codigo': '654', 'nome': 'BANCO DIGIMAIS S.A.' }, {
	        'codigo': '655',
	        'nome': 'Banco Votorantim S.A.'
	      }, { 'codigo': '707', 'nome': 'Banco Daycoval S.A.' }, {
	        'codigo': '712',
	        'nome': 'Banco Ourinvest S.A.'
	      }, { 'codigo': '720', 'nome': 'BCO RNX S.A.' }, {
	        'codigo': '739',
	        'nome': 'Banco Cetelem S.A.'
	      }, { 'codigo': '741', 'nome': 'BANCO RIBEIRAO PRETO S.A.' }, {
	        'codigo': '743',
	        'nome': 'Banco Semear S.A.'
	      }, {
	        'codigo': '745',
	        'nome': 'Banco Citibank S.A.',
	        'caracteresConta': 8,
	        'digitoAgencia': false
	      }, { 'codigo': '746', 'nome': 'Banco Modal S.A.' }, {
	        'codigo': '747',
	        'nome': 'Banco Rabobank International Brasil S.A.'
	      }, { 'codigo': '748', 'nome': 'BANCO COOPERATIVO SICREDI S.A.' }, {
	        'codigo': '751',
	        'nome': 'Scotiabank Brasil S.A. Banco Múltiplo'
	      }, { 'codigo': '752', 'nome': 'Banco BNP Paribas Brasil S.A.' }, {
	        'codigo': '753',
	        'nome': 'Novo Banco Continental S.A. – Banco Múltiplo'
	      }, { 'codigo': '754', 'nome': 'Banco Sistema S.A.' }, {
	        'codigo': '755',
	        'nome': 'Bank of America Merrill Lynch Banco Múltiplo S.A.'
	      }, { 'codigo': '756', 'nome': 'BANCO COOPERATIVO DO BRASIL S.A. – BANCOOB' }, {
	        'codigo': '757',
	        'nome': 'BANCO KEB HANA DO BRASIL S.A.'
	      }],
	      bancoSelecionado: null
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.bancoSelecionado = this.listaBancos.find(function (banco) {
	      return banco.codigo === _this.propsBanco;
	    });
	  },
	  methods: {
	    selecionaBanco: function selecionaBanco(banco) {
	      this.$emit('update:banco', banco);
	      this.$forceUpdate();
	    },
	    bancoNome: function bancoNome(option) {
	      return '' + (option.codigo + ' - ' + option.nome);
	    }
	  }
	};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'tipoConta',
	  props: {
	    propsTipo: null
	  },
	  data: function data() {
	    return {
	      tiposConta: [{ 'codigo': 1, 'tipo': 'Conta Corrente' }, { 'codigo': 2, 'tipo': 'Conta Poupança' }],
	      tipoContaSelecionado: null
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.tipoContaSelecionado = this.tiposConta.find(function (conta) {
	      return conta.codigo === _this.propsTipo;
	    });
	  },
	  methods: {
	    tipoContaNome: function tipoContaNome(option) {
	      return '' + (option.codigo + ' - ' + option.tipo);
	    },
	    selecionaTipoConta: function selecionaTipoConta(tipoSelecionado) {
	      this.$emit('update:tipo', tipoSelecionado);
	      this.$forceUpdate();
	    }
	  }
	};

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'alteracoes-projeto-aditivo',
	  data: function data() {
	    return {
	      id: null,
	      quillOptions: {
	        theme: 'bubble'
	      },
	      desabilitarEditor: true,
	      loading: {
	        tela: false
	      },
	      solicitacao: {
	        aditivo: {
	          modelo: {},
	          conteudo: ''
	        }
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {},
	  created: function created() {
	    console.clear();
	    if (_.has(this.$route.params, 'id')) {
	      this.carregarDados({ 'id': this.$route.params.id });
	    } else {
	      this.$snotify.error('Não foi informado ID do processo');
	      this.$router.go(-1);
	    }
	  },
	
	  methods: {
	    carregarDados: function carregarDados(requisicao) {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('projeto/alteracoes', requisicao).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var solicitacao = response.data.retorno.solicitacao;
	          if (!_.isEmpty(solicitacao)) {
	            _this.solicitacao = solicitacao.dados;
	            _this.id = solicitacao.processo.id;
	          }
	          _this.$forceUpdate();
	          _this.loading.tela = false;
	        } else {
	          _this.$snotify.error(response.data.mensagem);
	        }
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    imprimir: function imprimir() {
	      window.print();
	    }
	  }
	};

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trunc = __webpack_require__(108);
	
	var _trunc2 = _interopRequireDefault(_trunc);
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _extenso = __webpack_require__(359);
	
	var _extenso2 = _interopRequireDefault(_extenso);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _parcelaAdiantamento = __webpack_require__(254);
	
	var _parcelaAdiantamento2 = _interopRequireDefault(_parcelaAdiantamento);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _extrato = __webpack_require__(517);
	
	var _extrato2 = _interopRequireDefault(_extrato);
	
	var _GestaoAtividades = __webpack_require__(257);
	
	var _GestaoAtividades2 = _interopRequireDefault(_GestaoAtividades);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadDocumentosPhp = __webpack_require__(85);
	
	var _uploadDocumentosPhp2 = _interopRequireDefault(_uploadDocumentosPhp);
	
	var _UploadDocumentosOnline = __webpack_require__(508);
	
	var _UploadDocumentosOnline2 = _interopRequireDefault(_UploadDocumentosOnline);
	
	var _PlanoTrabalho = __webpack_require__(529);
	
	var _PlanoTrabalho2 = _interopRequireDefault(_PlanoTrabalho);
	
	var _sumula = __webpack_require__(524);
	
	var _sumula2 = _interopRequireDefault(_sumula);
	
	var _lodash = __webpack_require__(170);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PlanoTrabalho: _PlanoTrabalho2.default,
	    Metas: _metas2.default,
	    ParcelaAdiantamento: _parcelaAdiantamento2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Extrato: _extrato2.default,
	    VisualizaGestaoAtividades: _GestaoAtividades2.default,
	    Atividades: _atividades2.default,
	    UploadDocumentosOnline: _UploadDocumentosOnline2.default,
	    UploadDocumentosPhp: _uploadDocumentosPhp2.default,
	    Sumula: _sumula2.default
	  },
	  name: 'alteracoes-projeto',
	  data: function data() {
	    return {
	      justificativaCancelamento: '',
	      id: null,
	      processo: null,
	      etapa: 'Solicitação',
	      quillOptions: {
	        theme: 'snow'
	      },
	      historico: [],
	      dados: {
	        periodo: {
	          dt_assinatura_convenio: null,
	          nr_periodos: null,
	          periodo_vigencia: null,
	          dt_data_vigencia: null
	        }
	      },
	      loading: {
	        tela: false,
	        projeto: false,
	        motivosSolicitacao: false,
	        planoTrabalho: false,
	        notaTecnica: false,
	        aditivo: {
	          lista: false,
	          conteudo: false
	        },
	        historicos: {
	          periodos: false
	        },
	        ocorrencias: false,
	        poderes: false
	      },
	      mostrar: {
	        sumula: true,
	        aditivo: false,
	        planoTrabalho: false,
	        notaTecnica: false,
	        solicitacao: true,
	        anexos: true,
	        historicos: {
	          periodos: true,
	          tarefas: true
	        }
	      },
	      justificativa: null,
	      tarefas: [],
	      ultimaTarefa: {},
	      anexos: [],
	      proposta: {},
	      propostaBackup: {},
	      atvSemMetas: [],
	      criarAtividade: false,
	      tabela: {
	        historicos: {
	          periodos: {
	            bordered: true,
	            fields: [{ key: 'id', label: 'ID', thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'acao', label: 'Momento', thStyle: 'text-align: center; width: 15%', class: 'text-center' }, { key: 'periodo', label: 'Períodos', thStyle: 'text-align: center; width: 20%', class: 'text-center' }, { key: 'termino_alterado', label: 'Término do projeto', thStyle: 'text-align: center; width: 15%', class: 'text-center' }]
	          }
	        }
	      },
	      numeroAtualizacao: 0,
	      projetoPeriodos: 0,
	      dataFinalExecucao: '',
	
	      chamado: [],
	      listaProjetos: {
	        validos: [],
	        demais: []
	      },
	      projeto: {},
	      desabilitarDatasFuturas: {
	        from: new Date() },
	      desabilitarDatasPassadas: {
	        to: new Date() },
	      municipiosUf: [],
	      ehProjetoEspecial: false,
	
	      tipoAlteracaoCronograma: null,
	      decisao: {
	        encaminhamento: 'ANALISE'
	      },
	      analiseTributaria: {},
	      layoutExtrato: 'classico',
	      extratoFiltrosSelecionados: this.$route.name === 'solicitacao-contrapartida' ? ['saldos'] : ['saldos', 'fundacao'],
	      adiantamentosFiltrosSelecionados: ['adiantamento_pendente'],
	      sumarioQtdeAlteracoes: {},
	      totais: {
	        projeto: {
	          fbb: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          parceiros: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          contrapartida: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          total: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          }
	        },
	        adiantamento: {
	          fbb: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          parceiros: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          total: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          }
	        }
	      },
	      restricaoParaInicializar: [],
	      restricaoParaConcluir: [],
	      msgErroProcessamento: [],
	      solicitacao: {
	        instrumentosLidos: {
	          ok: false,
	          usuario: null,
	          data: null
	        },
	        justificativa: null,
	        motivosDevolucao: [],
	        anexos: [],
	        processos: [],
	        aditivo: {
	          modelo: {},
	          conteudo: ''
	        },
	        planoTrabalho: {
	          conteudo: {}
	        },
	        notaTecnica: {
	          conteudo: {}
	        },
	        sumula: {
	          textoAnalise: null,
	          textoProposta: null,
	          textoContexto: null,
	          textoSituacaoProblema: null,
	          textoParecer: null,
	          questionario: [],
	          parceriaEstrategica: null,
	          providencias: [],
	          resumoAlteracoes: {
	            metas: 0,
	            contrapartidas: 0,
	            substituicaoItens: 0,
	            ajusteQuantidade: 0,
	            novosItens: 0,
	            prorrogacaoExecucao: [0, 0],
	            prorrogacaoVigencia: [0, 0],
	            municipiosAlterados: 0,
	            percentualRemanejamentosConcedidos: 0,
	            percentualRemanejamentoSolicitado: 0,
	            percentualRemanejamentoAcumulado: 0,
	            valorSuplementacao: 0,
	            valorRemanejado: 0,
	            valorTotalAlteracao: 0,
	            valorTotalComSuplementacao: 0,
	            enquadramentoOrcamentarioFEP: null,
	            outrasAlteracoes: null
	          },
	          alcada: {}
	        }
	      },
	      opcoesVisualizacao: {
	        solicitacao: { expandir: true, modificacoes: 'RESUMIDO' },
	        periodo: { expandir: true, modificacoes: 'RESUMIDO' },
	        metas: { expandir: true, modificacoes: 'RESUMIDO' },
	        atividades: { expandir: true, modificacoes: 'RESUMIDO' },
	        extratoProjeto: { expandir: true, modificacoes: 'RESUMIDO' },
	        parcelasAdiantamento: { expandir: true, modificacoes: 'RESUMIDO' },
	        municipios: { expandir: true, modificacoes: 'RESUMIDO' },
	        historico: { expandir: true, modo: 'PADRAO' }
	      },
	      ehVisualizacao: false,
	      validacao: {},
	      registrosAlteracoes: [],
	      cronogramaAlteracoes: [],
	      ocorrencias: [],
	      listaProvidencias: [{ 'codigo': 'PLT', 'descricao': 'Plano de Trabalho' }, { 'codigo': 'ADT', 'descricao': 'Termo Aditivo' }, { 'codigo': 'NT', 'descricao': 'Nota Técnica' }, { 'codigo': 'SML', 'descricao': 'Súmula' }],
	      listaAlcadas: [{ 'codigo': 'DIRETOR_OU_GER_SOLUCOES', 'descricao': 'Um Membro da Diretoria Executiva ou um Gerente de Soluções' }, { 'codigo': '2_GER_SOLUCOES', 'descricao': '2 Gerentes de Solução da mesma Diretoria em conjunto' }, { 'codigo': 'DIRETOR_E_GER_SOLUCOES', 'descricao': 'Um membro da Diretoria Executiva, em Conjunto com um Gerente de Soluções' }, { 'codigo': 'CDS', 'descricao': 'Comitê de Desenvolvimento Social' }, { 'codigo': 'CE', 'descricao': 'Comitê Estratégico' }],
	      listaQuestionarioAnalise: [{ 'codigo': 'Q001', 'questao': 'Há concordância da convenente com a proposta de alteração quando de iniciativa da Fundação?', 'resposta': null }, { 'codigo': 'Q002', 'questao': 'Há alteração nos objetivos específicos, metas e indicadores previstos no projeto?', 'resposta': null }, { 'codigo': 'Q003', 'questao': 'Há impacto da alteração proposta no prazo de execução estabelecido?', 'resposta': null }, { 'codigo': 'Q004', 'questao': 'Há impacto da alteração proposta nos resultados esperados do projeto?', 'resposta': null }, { 'codigo': 'Q005', 'questao': 'Existem ocorrências restritivas para aprovação da alteração proposta, registrados no sistema informatizado da Fundação?', 'resposta': null }, { 'codigo': 'Q006', 'questao': 'Foram apresentados orçamentos ou há enquadramento dos valores orçados aos parâmetros operacionais estabelecidos pela Fundação? Em caso negativo, registre a(s) justificativa(s) para apoio superior ao previsto no campo "Análise".', 'resposta': null }, { 'codigo': 'Q009', 'questao': 'Há ajuste ou glosa realizados na proposta apresentada? Em caso afirmativo, registre a justificativa e itens alterados no campo "Análise".', 'resposta': null }, { 'codigo': 'Q010', 'questao': 'A alteração proposta demanda formalização de termo aditivo?', 'resposta': null }, { 'codigo': 'Q011', 'questao': 'Existem itens de despesas que não podem ser custeados, conforme as disposições gerais e as instruções específicas do SIC 13.3.7?', 'resposta': null }, { 'codigo': 'Q012', 'questao': 'As certidões estão válidas, quando previstas em instruções específicas do SIC 13.3.7?', 'resposta': null }, { 'codigo': 'Q013', 'questao': 'Consta autorização recebida do parceiro estratégico, conforme instruções específicas do SIC 13.3.7?', 'resposta': null }, { 'codigo': 'Q014', 'questao': 'Foram cumpridas outras exigências previstas em instruções específicas do SIC 13.3.7?', 'resposta': null }, { 'codigo': 'Q015', 'questao': 'Há compatibilidade da alteração proposta com os objetivos, as metas e as atividades do projeto?', 'resposta': null }],
	      listaMinutasAditivo: [],
	      listaIdsAtividadesAlteradas: [],
	      listaRelatoriosSapiens: [{ 'codigo': 248, 'descricao': '248 - Monitoramento Administrativo' }, { 'codigo': 300, 'descricao': '300 - Extrato de Projetos por Beneficiária' }],
	      tarefaNome: { 'ANALISE': 'Análise', 'AUTORIZACAO': 'Autorização', 'REVISAO': 'Revisão', 'SOLICITACAO': 'Solicitação', 'DELIBERACAO': 'Deliberação', 'PENDENCIAS': 'Pendências', 'CANCELADO': 'Processo Cancelado', 'CONCLUSAO': 'Conclusão', 'TAREFA_REATIVADA': 'Tarefa Reativada', 'TAREFA_ASSUMIDA': 'Tarefa Assumida', 'DEVOLVE_ATRIBUICAO': 'Devolvido para a Caixa', 'ENVIADO_ANALISE': 'Enviado para Análise', 'DEVOLVIDO_ANALISE': 'Devolvido para Análise', 'ENVIADO_REVISAO': 'Enviado para Revisão da Entidade', 'ENVIADO_AUTORIZACAO': 'Enviado para Autorização', 'DEVOLVIDO_AUTORIZACAO': 'Devolvido para Autorização', 'ENVIADO_DELIBERACAO': 'Enviado para Deliberação', 'DEVOLVIDO_DELIBERACAO': 'Devolvido para Deliberação', 'ENVIADO_PENDENCIAS': 'Enviado para Pendências', 'DEVOLVIDO_PENDENCIAS': 'Devolvido para Pendências', 'INCLUSAO_DOCUMENTO': 'Documento anexado', 'EXCLUSAO_DOCUMENTO': 'Documento excluído', 'RecPrv_at_com_senior_g5_co_mfi_prj_recursosprevistosgrid': 'Aprovação de Recurso', 'INSERINDO_RECURSOS_SAPIENS': 'Gravando Recurso', 'VISUALIZACAO': 'Visualizando a solicitação' },
	      descricaoProcesso: { 'PAGAMENTO': 'Pagamento', 'PRESTACAO_DE_CONTAS': 'Prestação de Contas', 'CONTRAPARTIDA': 'Contrapartida', 'RESSARCIMENTO': 'Ressarcimento' },
	      poderes: [],
	      motivosSolicitacao: [],
	      listMotivosDevolucao: [],
	      erroCronograma: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    dataInicialFormatada: function dataInicialFormatada() {
	      if (!this.proposta.dt_assinatura_convenio) return '';
	
	      return (0, _moment2.default)(this.proposta.dt_assinatura_convenio, 'YYYY-MM-DD').format('DD/MM/YYYY');
	    },
	
	    dataFinalVigencia: function dataFinalVigencia() {
	      if (this.proposta.dt_assinatura_convenio) {
	        this.proposta.dt_data_vigencia = (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(parseInt(this.proposta.periodo_vigencia), 'M').format('YYYY-MM-DD');
	      } else {
	        if (this.proposta.dt_data_inicial) {
	          this.proposta.dt_data_vigencia = (0, _moment2.default)(this.proposta.dt_data_inicial).add(parseInt(this.proposta.periodo_vigencia), 'M').format('YYYY-MM-DD');
	        }
	      }
	      return this.proposta.dt_data_vigencia;
	    },
	    dataFinal: function dataFinal() {
	      if (!this.proposta.dt_assinatura_convenio) return null;
	
	      return (0, _moment2.default)(this.proposta.dt_assinatura_convenio).add(Number(this.proposta.nr_periodos), 'M').format('DD/MM/YYYY');
	    },
	    dataFinalBackup: function dataFinalBackup() {
	      if (this.propostaBackup.dt_assinatura_convenio) {
	        return (0, _moment2.default)(this.propostaBackup.dt_assinatura_convenio).add(this.propostaBackup.nr_periodos, 'M').format('DD/MM/YYYY');
	      }
	    }
	  }),
	  watch: {
	    projeto: function projeto(newValue, oldValue) {
	      if (!this.$route.path.startsWith('/solicitacao/alteracoesprojeto/visualizacao') && _lodash2.default.has(this.projeto, 'ds_codigo_projeto_erp') && !_lodash2.default.isEmpty(this.projeto.ds_codigo_projeto_erp)) {
	        this.carregarDados({ 'numero': this.projeto.ds_codigo_projeto_erp });
	      }
	    },
	    tipoAlteracaoCronograma: function tipoAlteracaoCronograma() {
	      this.prepararSolicitacao();
	    },
	    'solicitacao.processos': {
	      handler: function handler(newValue, oldValue) {
	        if (_lodash2.default.isEqual(newValue, oldValue)) {
	          return;
	        }
	        this.numeroAtualizacao++;
	      },
	      deep: true
	    }
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    console.clear();
	    if (_lodash2.default.has(this.$route.params, 'visualizacao')) {
	      this.ehVisualizacao = this.$route.params.visualizacao;
	    }
	    this.ehVisualizacao = this.$route.path.startsWith('/solicitacao/alteracoesprojeto/visualizacao') ? true : this.ehVisualizacao;
	    if (this.usuarioLogado.userType !== 'FUNDACAO' || this.ehVisualizacao) {
	      _lodash2.default.forEach(this.opcoesVisualizacao, function (opc) {
	        _lodash2.default.set(opc, 'expandir', false);
	        _lodash2.default.set(opc, 'modificacoes', null);
	      });
	    } else {
	      var opcoesVisualizacao = _lodash2.default.merge(this.opcoesVisualizacao, _lodash2.default.get(this.usuarioLogado, 'configuracoes.alteracoes_projeto.opcoes'));
	      _lodash2.default.forEach(opcoesVisualizacao, function (opc) {
	        if (_lodash2.default.isNull(_lodash2.default.get(opc, 'modificacoes'))) {
	          _lodash2.default.set(opc, 'modificacoes', 'RESUMIDO');
	        }
	      });
	      this.opcoesVisualizacao = opcoesVisualizacao;
	    }
	
	    if (_lodash2.default.has(this.$route.params, 'id')) {
	      this.carregarDados({ 'id': this.$route.params.id });
	    }if (_lodash2.default.has(this.$route.params, 'numero')) {
	      this.carregarDados({ 'numero': this.$route.params.numero });
	    } else {
	      if (_lodash2.default.isEmpty(this.listaProjetos.validos)) {
	        this.carregarListaProjetos();
	      }
	    }
	    this.listaMotivosSolicitacao();
	  },
	
	  methods: {
	    carregarDados: function carregarDados(requisicao) {
	      var _this = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('projeto/alteracoes', requisicao).then(function (response) {
	        if (_lodash2.default.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var proposta = response.data.retorno.projeto;
	          _this.propostaBackup = _lodash2.default.cloneDeep(proposta);
	          _this.projeto = _lodash2.default.find(_this.listaProjetos.validos, ['ds_codigo_projeto_erp', '' + proposta.ds_codigo_projeto_erp]);
	          var solicitacao = response.data.retorno.solicitacao;
	          if (!_lodash2.default.isEmpty(solicitacao)) {
	            if (!_lodash2.default.isNil(solicitacao.dados)) {
	              _this.solicitacao = solicitacao.dados;
	            }
	            _this.processo = solicitacao.processo;
	            _this.id = _this.processo.id;
	            _this.ultimaTarefa = _lodash2.default.last(_lodash2.default.filter(solicitacao.tarefas, ['tipo', 'USUARIO']));
	            _this.tarefas = _lodash2.default.get(_lodash2.default.last(solicitacao.tarefas), 'tipo', 'USUARIO') === 'USUARIO' ? _lodash2.default.initial(solicitacao.tarefas) : solicitacao.tarefas;
	            _this.filtrarHistoricoPorModo();
	            _this.etapa = _this.tarefaNome[_this.ultimaTarefa['nome']];
	            if (!_this.ehVisualizacao) {
	              _this.ehVisualizacao = _lodash2.default.includes(['FEITO', 'CANCELADO'], _this.processo.situacao) || _this.usuarioLogado.userType !== 'FUNDACAO' && !_lodash2.default.includes(['Revisão', 'Solicitação'], _this.etapa);
	            }
	            if (!_lodash2.default.includes(['Solicitação', 'Revisão'], _this.etapa)) {
	              _this.decisao.encaminhamento = null;
	            }
	            _this.mostrar.solicitacao = !_lodash2.default.includes([''], _this.etapa) || _this.ehVisualizacao;
	            _this.mostrar.sumula = _lodash2.default.includes(['Autorização', 'Deliberação'], _this.etapa);
	            if (!_lodash2.default.includes(['FEITO', 'CANCELADO'], _this.processo.situacao)) {
	              var objetosRefProcesso = { 'ALTERACAO_METAS': 'metas', 'ALTERACAO_ATIVIDADES': 'atividades', 'ALTERACAO_PARCELAS_ADIANTAMENTO': 'adiantamentos', 'ALTERACAO_MUNICIPIOS': 'municipalizacao', 'ALTERACAO_PERIODO_PROJETO': '' };
	              _this.solicitacao.processos.forEach(function (processo) {
	                var exclusoes = _lodash2.default.get(processo, 'exclusao', []);
	                exclusoes.forEach(function (exclusao) {
	                  _lodash2.default.remove(_lodash2.default.get(proposta, objetosRefProcesso[processo.nome], []), ['id', exclusao]);
	                });
	
	                var alteracoes = _lodash2.default.get(processo, 'alteracao', []);
	                alteracoes.forEach(function (alteracao) {
	                  var registroAlterado = proposta;
	                  if (_lodash2.default.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], processo.nome)) {
	                    proposta.atividades.forEach(function (atividade) {
	                      var itemAlterado = _lodash2.default.find(_lodash2.default.get(atividade, 'itens_orcamentos', []), ['id', alteracao.id]);
	                      if (itemAlterado) {
	                        registroAlterado = itemAlterado;
	                      }
	                    });
	                  } else if (processo.nome !== 'ALTERACAO_PERIODO_PROJETO') {
	                    registroAlterado = _lodash2.default.find(_lodash2.default.get(proposta, objetosRefProcesso[processo.nome], []), ['id', alteracao.id]);
	                  }
	                  _lodash2.default.forIn(alteracao, function (value, key, obj) {
	                    if (key !== 'id') {
	                      var valor = _lodash2.default.isNaN(_lodash2.default.toNumber(value[1])) ? value[1] : _lodash2.default.toNumber(value[1]);
	                      _lodash2.default.set(registroAlterado, key, valor);
	                    }
	                  });
	                });
	
	                var inclusoes = _lodash2.default.get(processo, 'inclusao', []);
	                var lista = _lodash2.default.get(proposta, [objetosRefProcesso[processo.nome]], []);
	                inclusoes.forEach(function (inclusao) {
	                  if (_lodash2.default.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], processo.nome)) {
	                    lista = _lodash2.default.get(_lodash2.default.find(proposta.atividades, ['id', inclusao.atividade.id]), 'itens_orcamentos');
	                  }
	                  if (_lodash2.default.isArray(lista)) {
	                    lista.push(inclusao);
	                  }
	                });
	              });
	            }
	            _this.qteAlteracoes();
	            if (_lodash2.default.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _this.etapa)) {
	              if (_lodash2.default.isEmpty(_this.solicitacao.sumula.questionario)) {
	                _this.carregarQuestionario();
	              }
	              _this.buscaMotivosDevolucao();
	              _this.modelosDocumento(null, null, null);
	            }
	            if (_lodash2.default.includes(['Solicitação', 'Revisão'], _this.etapa)) {
	              _this.solicitacao.instrumentosLidos = { 'ok': false, 'usuario': null, 'data': null };
	            }
	          }
	
	          _this.solicitacao.motivosDevolucao = [];
	          _this.proposta = _lodash2.default.cloneDeep(proposta);
	          _this.projetoPeriodos = _this.propostaBackup.nr_periodos;
	          var alteracaoCronogramaRealizada = _lodash2.default.find(_lodash2.default.get(_this.solicitacao, 'processos', []), function (prc) {
	            return _lodash2.default.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome);
	          });
	
	          var tiposAlteracaoCronogramaPermitidos = alteracaoCronogramaRealizada ? [alteracaoCronogramaRealizada['nome']] : _lodash2.default.intersection(_lodash2.default.get(_this.proposta, 'opcoes.alteracoesPermitidas', []), ['remanejamento', 'suplementacao']);
	          _this.tipoAlteracaoCronograma = tiposAlteracaoCronogramaPermitidos.length === 1 ? _lodash2.default.toUpper(_lodash2.default.head(tiposAlteracaoCronogramaPermitidos)) : null;
	
	          _this.ocultaSinalizarDocumentosInternos();
	          _this.buscaCidades();
	          if (_lodash2.default.find(_this.solicitacao.processo, ['nome', 'ALTERACAO_PERIODO_PROJETO']) || !_this.id) {
	            _this.buscaHistoricos(_this.proposta.ds_codigo_projeto_erp);
	          }
	          _this.verificaUsuarioDirigente();
	          _this.resumoAlteracoesSumula();
	          _this.$forceUpdate();
	          _this.listaAtividadesAlteradas();
	          _this.acertarPeriodosAtividades();
	
	          _this.loading.tela = false;
	        } else {
	          _this.$snotify.error(response.data.mensagem);
	        }
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    acertarPeriodosAtividades: function acertarPeriodosAtividades() {
	      this.proposta.atividades.forEach(function (atividade) {
	        atividade.itens_orcamentos.forEach(function (item) {
	          if (item.periodo_final < item.periodo_inicial) {
	            var unique = _lodash2.default.map(_lodash2.default.uniqBy(item.orcamentos_mensalizados, 'periodo'), 'periodo');
	            var max = Math.max.apply(Math, (0, _toConsumableArray3.default)(unique));
	            item.periodo_final = max;
	          }
	        });
	      });
	    },
	    carregarListaProjetos: function carregarListaProjetos() {
	      var _this2 = this;
	
	      var numero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.loading.tela = true;
	      axiosLaravel.post('projeto/lista', { 'processo': 'ALTERACOES_PROJETO', 'numero': numero }).then(function (response) {
	        if (_lodash2.default.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          _this2.listaProjetos = response.data.retorno;
	          if (!_lodash2.default.isNull(numero)) {
	            var projeto = _lodash2.default.find(_this2.listaProjetos.validos, ['ds_codigo_projeto_erp', numero]);
	            if (projeto) {
	              _this2.projeto = projeto;
	              _this2.buscaHistoricos(numero);
	            } else {
	              _this2.$snotify.error('Este projeto não esta disponível para alterações');
	              _this2.$router.go(-1);
	            }
	          } else {
	            if (_this2.listaProjetos.validos.length === 1) {
	              _this2.projeto = _lodash2.default.head(_this2.listaProjetos.validos);
	            }
	          }
	        } else {
	          _this2.$snotify.error(response.data.mensagem[0]);
	          _this2.listaProjetos = { 'validos': [], 'demais': [] };
	        }
	        _this2.$forceUpdate();
	        _this2.loading.tela = false;
	      }).catch(function (error) {
	        _this2.loading.tela = false;
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    carregarQuestionario: function carregarQuestionario() {
	      this.solicitacao.sumula.questionario = _lodash2.default.cloneDeep(this.listaQuestionarioAnalise);
	      this.executarRegrasQuestoes(['Q001', 'Q002', 'Q003', 'Q004', 'Q005', 'Q006', 'Q010', 'Q012']);
	    },
	    verQuestao: function verQuestao(questao) {
	      var backup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var questionario = [];
	      if (backup) {
	        questionario = _lodash2.default.clone(this.listaQuestionarioAnalise);
	      } else {
	        questionario = _lodash2.default.clone(this.solicitacao.sumula.questionario);
	      }
	      return _lodash2.default.find(questionario, ['codigo', questao]);
	    },
	    alteraQuestao: function alteraQuestao(questao, pergunta) {
	      _lodash2.default.set(_lodash2.default.find(this.solicitacao.sumula.questionario, ['codigo', questao]), 'questao', pergunta);
	    },
	    respondeQuestao: function respondeQuestao(questao, resposta) {
	      _lodash2.default.set(_lodash2.default.find(this.solicitacao.sumula.questionario, ['codigo', questao]), 'resposta', resposta);
	    },
	    executarRegrasQuestoes: function executarRegrasQuestoes(questoes, opcoes) {
	      var _this3 = this;
	
	      questoes.forEach(function (questao) {
	        var q = _this3.verQuestao(questao);
	        var resposta = q['resposta'];
	
	        var perguntaBackup = _this3.verQuestao(questao, true)['questao'];
	        if (questao === 'Q001') {
	          if (_lodash2.default.get(_lodash2.default.find(_this3.tarefas, ['nome', 'SOLICITACAO']), 'ds_tipo_usuario') !== 'FUNDACAO') {
	            _lodash2.default.remove(_this3.solicitacao.sumula.questionario, ['codigo', 'Q001']);
	          }
	        } else if (questao === 'Q002') {
	          if (_lodash2.default.isNull(resposta)) {
	            if (_lodash2.default.find(_this3.solicitacao.processos, function (p) {
	              return _lodash2.default.includes(['ALTERACAO_METAS', 'ALTERACAO_ATIVIDADES'], p.nome);
	            })) {
	              _this3.respondeQuestao('Q002', 'sim');
	              _this3.executarRegrasQuestoes(['Q002']);
	            }
	          } else {
	            if (resposta === 'sim') {
	              _this3.alteraQuestao('Q002', perguntaBackup + '<span class=\'alertaQuestao\'>Em caso afirmativo, indique quais são no campo \'Análise\'</span>');
	            } else {
	              _this3.alteraQuestao('Q002', perguntaBackup);
	            }
	          }
	        } else if (questao === 'Q003') {
	          if (_lodash2.default.isNull(resposta)) {
	            if (_lodash2.default.find(_this3.solicitacao.processos, function (p) {
	              return _lodash2.default.includes(['ALTERACAO_PERIODO_PROJETO'], p.nome);
	            })) {
	              _this3.respondeQuestao('Q003', 'sim');
	              _this3.executarRegrasQuestoes(['Q003']);
	            }
	          } else {
	            if (resposta === 'sim') {
	              _this3.alteraQuestao('Q003', perguntaBackup + '<span class=\'alertaQuestao\'>Em caso afirmativo, indique novo prazo e os impactos identificados no campo \'Análise\'</span>');
	            } else {
	              _this3.alteraQuestao('Q003', perguntaBackup);
	            }
	          }
	        } else if (questao === 'Q004') {
	          if (resposta === 'sim') {
	            _this3.alteraQuestao('Q004', perguntaBackup + '<span class=\'alertaQuestao\'>Em caso afirmativo, indique os impactos identificados no campo \'Análise\'</span>');
	          } else {
	            _this3.alteraQuestao('Q004', perguntaBackup);
	          }
	        } else if (questao === 'Q005') {
	          if (opcoes && _lodash2.default.includes(['ATUALIZA_CONSULTA'], opcoes) || _lodash2.default.isNull(resposta)) {
	            if (_this3.usuarioLogado.userType === 'FUNDACAO' && !_this3.ehVisualizacao) {
	              _this3.alteraQuestao('Q005', perguntaBackup + '<span class=\'avisoQuestao\'><i class=\'fa fa-refresh fa-spin\'></i> Consultando ocorrências ...</span>');
	              _this3.loading.ocorrencias = true;
	              axiosLaravel.post('ocorrencia/busca', { 'informacao': 'SIMPLIFICADO', 'projeto': _this3.proposta.ds_codigo_projeto_erp, 'nivel': [2, 3, 4], 'situacao': 'LIBERADO' }).then(function (response) {
	                if (_lodash2.default.get(response.data, 'codigo', '') === 'OK') {
	                  var dataHoraPesquisa = ' (pesquisado em ' + (0, _moment2.default)().format('DD/MM/YYYY HH:mm') + ')';
	                  var ocorrencias = response.data.retorno;
	                  var qtdeOcorrenciasRestritivas = _lodash2.default.filter(ocorrencias, function (o) {
	                    return o.codigo > 3000;
	                  }).length;
	                  var qtdeOcorrenciasFlexibilizacao = _lodash2.default.filter(ocorrencias, function (o) {
	                    return _lodash2.default.includes([2200, 2201, 2202, 2203], o.codigo);
	                  }).length;
	                  if (ocorrencias.length > 0 && qtdeOcorrenciasRestritivas > 0 && qtdeOcorrenciasFlexibilizacao === 0) {
	                    _this3.respondeQuestao('Q005', 'sim');
	                    _this3.alteraQuestao('Q005', perguntaBackup + '<span class=\'alertaQuestao\'>Há ' + qtdeOcorrenciasRestritivas + (qtdeOcorrenciasRestritivas === 1 ? ' ocorrência' : ' ocorrências') + ' restritivas ativas' + dataHoraPesquisa + '</span>');
	                  } else {
	                    if (qtdeOcorrenciasRestritivas === 0) {
	                      _this3.alteraQuestao('Q005', perguntaBackup + '<span class=\'avisoQuestao\'>Não há ocorrências restritivas ativas' + dataHoraPesquisa + '</span>');
	                    } else if (qtdeOcorrenciasFlexibilizacao > 0) {
	                      _this3.alteraQuestao('Q005', perguntaBackup + '<span class=\'avisoQuestao\'>Há ocorrência(s) de flexibilização ativa' + dataHoraPesquisa + '</span>');
	                    } else {
	                      _this3.alteraQuestao('Q005', perguntaBackup + '<span class=\'alertaQuestao\'>Quantidade de ocorrências indisponível' + dataHoraPesquisa + '</span>');
	                    }
	                  }
	                } else {
	                  _this3.alteraQuestao('Q005', perguntaBackup);
	                  _this3.$snotify.error(response.data.mensagem);
	                }
	                _this3.loading.ocorrencias = false;
	                _this3.$forceUpdate();
	              }).catch(function (error) {
	                _this3.loading.ocorrencias = false;
	                _this3.alteraQuestao('Q005', perguntaBackup);
	                _this3.$root.trataErro(error);
	              });
	            }
	          }
	        } else if (questao === 'Q006') {
	          if (_lodash2.default.isNull(resposta)) {
	            if (_lodash2.default.find(_this3.solicitacao.anexos, ['fk_tipo_documento', 23])) {
	              _this3.respondeQuestao('Q006', 'sim');
	            }
	          }
	        } else if (questao === 'Q007') {} else if (questao === 'Q008') {} else if (questao === 'Q009') {} else if (questao === 'Q010') {
	          if (_lodash2.default.isNull(resposta)) {
	            if (_lodash2.default.find(_this3.solicitacao.processos, function (p) {
	              return _lodash2.default.includes(['ALTERACAO_PARCELAS_ADIANTAMENTO', 'SUPLEMENTACAO'], p.nome);
	            }) || _lodash2.default.has(_lodash2.default.find(_this3.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.periodo_vigencia')) {
	              _this3.respondeQuestao('Q010', 'sim');
	              _this3.executarRegrasQuestoes(['Q010']);
	            }
	          } else {
	            if (resposta === 'sim') {
	              _this3.alteraQuestao('Q010', perguntaBackup + '<span class=\'alertaQuestao\'>Em caso afirmativo, registre no campo \'Análise\' as informações sobre o parecer da Dijur e eventuais recomendações para a formalização de termo aditivo ao instrumento contratual.</span>');
	            } else {
	              _this3.alteraQuestao('Q010', perguntaBackup);
	            }
	          }
	        } else if (questao === 'Q011') {} else if (questao === 'Q012') {
	          var documentosObrigatorios = [{ 'tipo': 2, 'desc': 'Comprovante de CNPJ' }, { 'tipo': 67, 'desc': 'CNEP/CEPIM' }, { 'tipo': 6, 'desc': 'Certidão negativa de débitos relativos a créditos tributários federais e a dívida ativa da união' }, { 'tipo': 40, 'desc': 'CNDT' }];
	          var certidoesComDataValidade = _lodash2.default.filter(_this3.solicitacao.anexos, function (a) {
	            return !_lodash2.default.isEmpty(a.dt_data_validade) && (0, _moment2.default)(a.dt_data_validade).diff((0, _moment2.default)(), 'days', true) < 0 && _lodash2.default.includes(_lodash2.default.map(documentosObrigatorios, 'tipo'), a.fk_tipo_documento);
	          });
	          if (certidoesComDataValidade.length > 0) {
	            _this3.alteraQuestao('Q012', perguntaBackup + '<span class=\'alertaQuestao\'>Há ' + certidoesComDataValidade.length + ' ' + (certidoesComDataValidade.length > 1 ? 'certidões' : 'certidão') + ' em anexo expirando hoje ou vencida</span>');
	            _this3.respondeQuestao('Q012', 'sim');
	          }
	        } else if (questao === 'Q013') {} else if (questao === 'Q014') {} else if (questao === 'Q015') {}
	      });
	      this.$forceUpdate();
	    },
	    contagemParcelasAdiantamento: function contagemParcelasAdiantamento(prc) {
	      var vm = this;
	
	      var numeroDaParcela = function numeroDaParcela(id) {
	        var original = _lodash2.default.find(_lodash2.default.get(vm.propostaBackup, 'adiantamentos', []), ['id', id]);
	        return _lodash2.default.isNil(original) || _lodash2.default.isNil(original.parcela) ? 'sem-numero-' + id : '' + original.parcela;
	      };
	      var chaveInclusao = function chaveInclusao(p, indice) {
	        return _lodash2.default.isNil(_lodash2.default.get(p, 'parcela')) ? 'sem-numero-inclusao-' + indice : '' + p.parcela;
	      };
	
	      var porParcela = _lodash2.default.groupBy(_lodash2.default.get(prc, 'alteracao', []), function (a) {
	        return numeroDaParcela(a.id);
	      });
	      var qtdAlteracoes = _lodash2.default.sumBy(_lodash2.default.values(porParcela), function (grupo) {
	        return _lodash2.default.uniq(_lodash2.default.flatMap(grupo, function (a) {
	          return _lodash2.default.keys(_lodash2.default.omit(a, 'id'));
	        })).length;
	      });
	      var qtdInclusoes = _lodash2.default.uniq(_lodash2.default.map(_lodash2.default.get(prc, 'inclusao', []), chaveInclusao)).length;
	      var qtdExclusoes = _lodash2.default.uniq(_lodash2.default.map(_lodash2.default.get(prc, 'exclusao', []), numeroDaParcela)).length;
	      return { 'alteracao': qtdAlteracoes, 'inclusao': qtdInclusoes, 'exclusao': qtdExclusoes };
	    },
	    qteAlteracoes: function qteAlteracoes() {
	      var sumario = {};
	      var processos = _lodash2.default.get(this.solicitacao, 'processos', []);
	      var processoNew = _lodash2.default.cloneDeep(processos);
	      var vm = this;
	      processoNew.forEach(function (prc) {
	        if (Array.isArray(prc.alteracao)) {
	          prc.alteracao.forEach(function (a) {
	            if (a.valorAlteracao && (a.valorAlteracao[0] === null || a.valorAlteracao[0] === '' || _lodash2.default.isNull(a.valorAlteracao[0])) && a.valorAlteracao[1] === '0') {
	              delete a.valorAlteracao;
	            }
	          });
	        }
	        var desconsiderandoContagemParametros = _lodash2.default.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome) ? 2 : 1;
	        var qtdAlteracoes = _lodash2.default.sumBy(prc.alteracao, function (a) {
	          return _lodash2.default.keys(a).length - desconsiderandoContagemParametros;
	        });
	        var qtdInclusoes = _lodash2.default.get(prc, 'inclusao', []).length;
	        var qtdExclusoes = _lodash2.default.get(prc, 'exclusao', []).length;
	        if (prc.nome === 'ALTERACAO_PARCELAS_ADIANTAMENTO') {
	          var contagem = vm.contagemParcelasAdiantamento(prc);
	          qtdAlteracoes = contagem.alteracao;
	          qtdInclusoes = contagem.inclusao;
	          qtdExclusoes = contagem.exclusao;
	        }
	        _lodash2.default.set(sumario, [prc.nome, 'alteracao'], qtdAlteracoes);
	        _lodash2.default.set(sumario, [prc.nome, 'inclusao'], qtdInclusoes);
	        _lodash2.default.set(sumario, [prc.nome, 'exclusao'], qtdExclusoes);
	        _lodash2.default.set(sumario, [prc.nome, 'total'], qtdAlteracoes + qtdInclusoes + qtdExclusoes);
	      });
	      this.sumarioQtdeAlteracoes = sumario;
	    },
	    passarTotaisExtratoParaSumula: function passarTotaisExtratoParaSumula(totais) {
	      this.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoSolicitado = totais.solicitacao.percentual;
	
	      this.resumoAlteracoesSumula();
	      this.solicitacao.sumula.resumoAlteracoes.valorTotalComSuplementacao = totais.projeto.fbb.orcado + totais.projeto.parceiros.orcado + totais.projeto.contrapartida.orcado + this.solicitacao.sumula.resumoAlteracoes.valorSuplementacao;
	      this.numeroAtualizacao++;
	    },
	    resumoAlteracoesSumula: function resumoAlteracoesSumula() {
	      var vm = this;
	      var processos = _lodash2.default.get(this.solicitacao, 'processos', []);
	      var qtdeContrapartidas = 0;
	      var qtdeItensSubstituidos = 0;
	      var creditos = 0;
	      var debitos = 0;
	      processos.forEach(function (prc) {
	        if (prc.nome === 'ALTERACAO_METAS') {
	          vm.solicitacao.sumula.resumoAlteracoes.metas = _lodash2.default.get(prc, 'alteracao', []).length + _lodash2.default.get(prc, 'inclusao', []).length;
	        }
	        if (prc.nome === 'ALTERACAO_MUNICIPIOS') {
	          vm.solicitacao.sumula.resumoAlteracoes.municipiosAlterados = _lodash2.default.get(prc, 'alteracao', []).length + _lodash2.default.get(prc, 'inclusao', []).length;
	        }
	        if (prc.nome === 'ALTERACAO_PERIODO_PROJETO') {
	          vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao = _lodash2.default.get(prc, 'alteracao.0.nr_periodos', [0, 0]);
	          vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia = _lodash2.default.get(prc, 'alteracao.0.periodo_vigencia', [0, 0]);
	        }
	        if (_lodash2.default.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)) {
	          vm.solicitacao.sumula.resumoAlteracoes.novosItens = _lodash2.default.get(prc, 'inclusao', []).length;
	          qtdeContrapartidas += _lodash2.default.filter(_lodash2.default.get(prc, 'inclusao', []), ['origem', 2]).length;
	          var idsItensAlterados = _lodash2.default.map(_lodash2.default.get(prc, 'alteracao', []), 'id');
	          qtdeContrapartidas += _lodash2.default.filter(_lodash2.default.flatten(_lodash2.default.map(vm.proposta.atividades, 'itens_orcamentos')), function (i) {
	            return _lodash2.default.includes([idsItensAlterados], i.id) && _lodash2.default.includes(['2'], ('' + i.origem).substr(0, 1));
	          }).length;
	          qtdeItensSubstituidos += _lodash2.default.get(_lodash2.default.countBy(_lodash2.default.get(prc, 'alteracao', []), function (i) {
	            return _lodash2.default.get(i, 'substituicao.1');
	          }), 'true', 0) + _lodash2.default.get(_lodash2.default.countBy(_lodash2.default.get(prc, 'inclusao', []), function (i) {
	            return _lodash2.default.get(i, 'substituicao.1');
	          }), 'true', 0);
	
	          _lodash2.default.get(prc, 'alteracao', []).forEach(function (a) {
	            var delta = _lodash2.default.toNumber(_lodash2.default.get(a, 'valorAlteracao.1', 0));
	            if (delta > 0) {
	              creditos += delta;
	            }
	            if (delta < 0) {
	              debitos += Math.abs(delta);
	            }
	          });
	          _lodash2.default.get(prc, 'inclusao', []).forEach(function (i) {
	            var valor = _lodash2.default.toNumber(_lodash2.default.get(i, 'valorAlteracao', 0));
	            if (valor > 0) {
	              creditos += valor;
	            }
	            if (valor < 0) {
	              debitos += Math.abs(valor);
	            }
	          });
	        }
	        vm.solicitacao.sumula.resumoAlteracoes.contrapartidas = qtdeContrapartidas;
	        vm.solicitacao.sumula.resumoAlteracoes.substituicaoItens = qtdeItensSubstituidos;
	      });
	
	      vm.solicitacao.sumula.resumoAlteracoes.valorRemanejado = debitos;
	      vm.solicitacao.sumula.resumoAlteracoes.valorSuplementacao = creditos - debitos;
	      vm.solicitacao.sumula.resumoAlteracoes.valorTotalAlteracao = creditos;
	    },
	    listaAtividadesAlteradas: function listaAtividadesAlteradas() {
	      var ids = [];
	      var atividadesAlteradas = _lodash2.default.find(this.solicitacao.processo, ['nome', 'ALTERACAO_ATIVIDADES']);
	      var alteracoes = _lodash2.default.get(atividadesAlteradas, 'alteracao', []);
	      alteracoes.forEach(function (alteracao) {
	        if (_lodash2.default.get(alteracao, 'nr_periodo_inicial.0', null) !== _lodash2.default.get(alteracao, 'nr_periodo_final.0', null) || _lodash2.default.get(alteracao, 'nr_periodo_inicial.1', null) !== _lodash2.default.get(alteracao, 'nr_periodo_final.1', null)) {
	          ids.push(alteracao.id);
	        }
	      });
	      this.listaIdsAtividadesAlteradas = ids;
	    },
	    listaMotivosSolicitacao: function listaMotivosSolicitacao() {
	      var _this4 = this;
	
	      this.loading.motivosSolicitacao = true;
	      axiosLaravel.get('tipo-registros/').then(function (response) {
	        _this4.motivosSolicitacao = _lodash2.default.filter(response.data, ['grupo', 'ALTERACAO_MOTIVO']);
	        _this4.loading.motivosSolicitacao = false;
	      }).catch(function (error) {
	        _this4.loading.motivosSolicitacao = false;
	        _this4.$root.trataErro(error);
	      });
	    },
	    filtrarHistoricoPorModo: function filtrarHistoricoPorModo(opcao) {
	      var modo = opcao || 'PADRAO';
	      if (!opcao || _lodash2.default.get(this.opcoesVisualizacao, 'historico.modo', '') !== opcao) {
	        _lodash2.default.set(this.opcoesVisualizacao, 'historico.modo', modo);
	        var tarefas = _lodash2.default.cloneDeep(this.tarefas);
	        if (!opcao || modo === 'PADRAO') {
	          tarefas.forEach(function (tarefa) {
	            _lodash2.default.set(tarefa, 'mostrar', !_lodash2.default.includes(['INCLUSAO_DOCUMENTO', 'EXCLUSAO_DOCUMENTO', 'RecPrv_at_com_senior_g5_co_mfi_prj_recursosprevistosgrid', 'INSERINDO_RECURSOS_SAPIENS', 'VISUALIZACAO'], tarefa.nome));
	          });
	        } else if (modo === 'COMPLETO') {
	          tarefas.forEach(function (tarefa) {
	            _lodash2.default.set(tarefa, 'mostrar', true);
	          });
	        }
	        this.tarefas = _lodash2.default.cloneDeep(tarefas);
	        if (opcao) {
	          this.salvarConfiguracoes();
	        }
	      }
	    },
	    buscaHistoricos: function buscaHistoricos(numeroProjeto) {
	      var _this5 = this;
	
	      this.loading.historicos.periodos = true;
	      axiosLaravel.post('projeto/historicos', { 'numero': numeroProjeto }).then(function (response) {
	        var dataFinal = (0, _moment2.default)(_this5.ehNulo(_this5.proposta.dt_assinatura_convenio, _this5.proposta.dt_data_inicial)).add(_this5.proposta.nr_periodos, 'M').format('DD/MM/YYYY');
	        _lodash2.default.set(_this5.proposta, 'historicos.periodos', [{ 'id': _this5.proposta.fk_processo, 'acao': 'Contratação', 'inicio': _this5.proposta.dt_data_inicial, 'termino': dataFinal, 'periodos': _this5.proposta.nr_periodos, 'termino_alterado': null }]);
	        var historicosPeriodo = _lodash2.default.filter(response.data, ['nome', 'ALTERACAO_PERIODO_PROJETO']);
	        historicosPeriodo.forEach(function (historico, idx) {
	          var registroAlteracao = JSON.parse(historico.ultimaTarefa.requisicao);
	          if (idx === 0) {
	            _this5.proposta.historicos.periodos[0] = {
	              'id': _this5.proposta.fk_processo,
	              'acao': 'Contratação',
	              'periodo_inicial': registroAlteracao.antes.nr_periodos,
	              'periodo_final': registroAlteracao.alterado.nr_periodos,
	              'periodo_alterado': 0,
	              'termino_alterado': (0, _moment2.default)(registroAlteracao.antes.dt_data_final).format('DD/MM/YYYY')
	            };
	          }
	          _this5.proposta.historicos.periodos.push({
	            'id': historico.id,
	            'acao': 'Alteração',
	            'periodo_inicial': registroAlteracao.antes.nr_periodos,
	            'periodo_final': registroAlteracao.alterado.nr_periodos,
	            'periodo_alterado': registroAlteracao.alterado.nr_periodos - registroAlteracao.antes.nr_periodos,
	            'termino_alterado': new Date(registroAlteracao.alterado.dt_data_final)
	          });
	        });
	        _this5.loading.historicos.periodos = false;
	      }).catch(function (error) {
	        _this5.loading.historicos.periodos = false;
	        _this5.$root.trataErro(error);
	      });
	    },
	    buscaMotivosDevolucao: function buscaMotivosDevolucao() {
	      var _this6 = this;
	
	      if (this.usuarioLogado.userType === 'FUNDACAO' && !this.ehVisualizacao) {
	        axiosLaravel.post('motivos/lista', { 'grupos': ['ALTERACOES_PROJETOS'] }).then(function (response) {
	          if (_lodash2.default.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            _this6.listMotivosDevolucao = response.data.retorno;
	          } else {
	            _this6.$snotify.error(response.data.mensagem);
	          }
	        }).catch(function (error) {
	          console.log('error', error);
	          _this6.$root.trataErro(error);
	        });
	      }
	    },
	    buscaCidades: function buscaCidades() {
	      var _this7 = this;
	
	      var lista = _lodash2.default.uniq(_lodash2.default.map(this.proposta.municipalizacao, 'ds_cep'));
	      axiosLaravel.post('projeto/cidades', { 'referencia': 'CEP', 'lista': lista }).then(function (response) {
	        _this7.proposta.municipalizacao.forEach(function (municipio) {
	          var cidade = _lodash2.default.find(response.data, function (cid) {
	            return _lodash2.default.toNumber(municipio.ds_cep) >= _lodash2.default.toNumber(cid.nr_cep_inicio) && _lodash2.default.toNumber(municipio.ds_cep) <= _lodash2.default.toNumber(cid.nr_cep_final);
	          });
	          _lodash2.default.set(municipio, 'ds_uf', cidade.ds_uf);
	        });
	        _this7.propostaBackup.municipalizacao.forEach(function (municipio) {
	          var cidade = _lodash2.default.find(response.data, function (cid) {
	            return _lodash2.default.toNumber(municipio.ds_cep) >= _lodash2.default.toNumber(cid.nr_cep_inicio) && _lodash2.default.toNumber(municipio.ds_cep) <= _lodash2.default.toNumber(cid.nr_cep_final);
	          });
	          _lodash2.default.set(municipio, 'ds_uf', cidade.ds_uf);
	        });
	      }).catch(function (error) {
	        console.log('error', error);
	        _this7.$root.trataErro(error);
	      });
	    },
	    verificaUsuarioDirigente: function verificaUsuarioDirigente() {
	      var _this8 = this;
	
	      if (this.usuarioLogado.userType !== 'FUNDACAO' && !this.ehVisualizacao) {
	        this.loading.poderes = true;
	        axiosLaravel.get('projeto/usuario/dirigente').then(function (response) {
	          if (_lodash2.default.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            if (!_lodash2.default.isNull(response.data.retorno)) {
	              _lodash2.default.remove(_this8.poderes, 'PERMITE_CONCLUIR');
	              _this8.restricaoParaInicializar.push(response.data.retorno);
	              _this8.adicionaRestricao({ 'tag': 'semPoderesParaConcluir', 'ativo': true, 'tipo': 'restricao', 'acao': null, 'mensagem': response.data.retorno + '. A conclusão e envio desta solicitação deverá ser realizada pelo representante legal ou designado.' });
	            } else {
	              _this8.poderes.push('PERMITE_CONCLUIR');
	            }
	            _this8.poderes = _lodash2.default.uniq(_this8.poderes);
	          } else {
	            _this8.$snotify.error(response.data.mensagem[0]);
	            _this8.ehVisualizacao = true;
	          }
	          _this8.loading.poderes = false;
	        }).catch(function (error) {
	          _this8.loading.poderes = false;
	          console.log('error', error);
	          _this8.$root.trataErro(error);
	        });
	      } else {
	        this.poderes.push('PERMITE_CONCLUIR');
	      }
	    },
	    processarSolicitacao: function processarSolicitacao(acao) {
	      var abrirDocumento = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.msgErroProcessamento = [];
	      if (this.verificaParcelaAdiantadaParcial() === true) {
	        _lodash2.default.remove(this.restricaoParaConcluir, function (i) {
	          return i.tag === 'parcelasAcimaTotalAdiantavel';
	        });
	      }
	      if (this.verificaSeProjetoNaoPossuiAdiantamento() === true) {
	        _lodash2.default.remove(this.restricaoParaConcluir, function (i) {
	          return i.tag === 'parcelasAcimaTotalAdiantavel';
	        });
	      }
	      if (_lodash2.default.includes(['Análise', 'Solicitação', 'Revisão'], this.etapa)) {
	        this.prepararSolicitacao();
	      }
	      if (acao === 'ENCAMINHAR') {
	        this.verificaConclusao();
	      }
	      if (acao === 'SALVAR' || this.errors.items.length === 0 && _lodash2.default.filter(this.restricaoParaConcluir, { 'ativo': true }).length === 0) {
	        if (_lodash2.default.includes(['SALVAR', 'ENCAMINHAR'], acao)) {
	          if (this.decisao.encaminhamento === 'CONCLUSAO' && acao === 'ENCAMINHAR') {
	            this.concluirSolicitacao();
	          } else {
	            this.encaminharSolicitacao(acao, abrirDocumento);
	          }
	        }
	      }
	    },
	    verificaConclusao: function verificaConclusao() {
	      var _this9 = this;
	
	      var vm = this;
	      this.adicionaRestricao({ 'tag': 'decisaoEncaminhamento', 'ativo': _lodash2.default.isNull(this.decisao.encaminhamento), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Selecione qual a decisão de encaminhamento para esta solicitação' });
	      this.adicionaRestricao({ 'tag': 'nrPeriodos', 'ativo': _lodash2.default.isEmpty('' + this.proposta.nr_periodos), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Periodo do projeto em meses não informado' });
	      this.adicionaRestricao({ 'tag': 'justificativa', 'ativo': _lodash2.default.isEmpty(this.solicitacao.justificativa), 'tipo': 'restricao', 'acao': null, 'mensagem': 'A Justificativa não informada. Por favor preencha o campo' });
	      this.adicionaRestricao({ 'tag': 'projetoSituacaoAPR', 'ativo': this.decisao.encaminhamento === 'CONCLUSAO' && _lodash2.default.get(this.propostaBackup, 'projetoSapiens.sitprj', '') !== 'APR', 'tipo': 'restricao', 'acao': null, 'mensagem': 'Só é possível concluir a solicitação quando o projeto estiver com situação APR no Sapiens' });
	      if (this.etapa === 'Análise' && this.decisao.encaminhamento === 'AUTORIZACAO') {
	        this.adicionaRestricao({ 'tag': 'sumulaQuestionarioPreenchido', 'ativo': _lodash2.default.filter(this.solicitacao.sumula.questionario, function (q1) {
	            return !_lodash2.default.includes(['Q011', 'Q012', 'Q013', 'Q014'], q1.codigo) && _lodash2.default.isNull(q1.resposta);
	          }).length > 0 || _lodash2.default.isNull(this.solicitacao.sumula.parceriaEstrategica) || this.solicitacao.sumula.parceriaEstrategica === 'sim' && _lodash2.default.filter(this.solicitacao.sumula.questionario, function (q2) {
	            return _lodash2.default.includes(['Q011', 'Q012', 'Q013', 'Q014'], q2.codigo) && _lodash2.default.isNull(q2.resposta);
	          }).length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há questões na súmula que não foram respondidas. Preencha todos os campo' });
	        this.adicionaRestricao({ 'tag': 'sumulaAnaliseProposta', 'ativo': _lodash2.default.isNull(this.solicitacao.sumula.textoContexto) || _lodash2.default.isNull(this.solicitacao.sumula.textoSituacaoProblema) || _lodash2.default.isNull(this.solicitacao.sumula.textoParecer) || _lodash2.default.isNull(this.solicitacao.sumula.textoProposta), 'tipo': 'restricao', 'acao': null, 'mensagem': 'O Contexto, a Situação Problema, o Parecer e a Proposta devem estar preenchidos' });
	        this.adicionaRestricao({ 'tag': 'sumulaAlcadaSelecionada', 'ativo': _lodash2.default.isEmpty(this.solicitacao.sumula.alcada), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Selecione uma alçada decisória' });
	        this.adicionaRestricao({ 'tag': 'motivoAlteracaoSelecionado', 'ativo': _lodash2.default.isEmpty(_lodash2.default.get(this.solicitacao, 'motivoAlteracao', '')), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Selecione um motivo para esse conjunto de alterações' });
	        this.adicionaRestricao({ 'tag': 'q001HaArquivoAnexado', 'ativo': _lodash2.default.get(this.verQuestao('Q001'), 'resposta', '') === 'sim' && this.solicitacao.anexos.length === 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Anexe a concordância da entidade' });
	        this.adicionaRestricao({ 'tag': 'q010HaAditivoEmProvidencias', 'ativo': _lodash2.default.get(this.verQuestao('Q010'), 'resposta', '') === 'sim' && !_lodash2.default.find(this.solicitacao.sumula.providencias, ['codigo', 'ADT']), 'tipo': 'restricao', 'acao': null, 'mensagem': 'No campo de Providências, selecione a opção Termo Aditivo' });
	        this.adicionaRestricao({ 'tag': 'q013HaAutorizacaoParcEstratAnexado', 'ativo': _lodash2.default.get(this.verQuestao('Q013'), 'resposta', '') === 'sim' && !_lodash2.default.find(this.solicitacao.anexos, ['fk_tipo_documento', 76]), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Anexe Autorização – parceiro estratégico na solicitação' });
	      }
	      if (this.etapa === 'Pendências') {
	        this.adicionaRestricao({ 'tag': 'planoTrabalhoObrigatorioAnexado', 'ativo': this.decisao.encaminhamento === 'CONCLUSAO' && _lodash2.default.find(this.solicitacao.sumula.providencias, ['codigo', 'PLT']) && !_lodash2.default.find(this.solicitacao.anexos, ['fk_tipo_documento', 8]), 'tipo': 'restricao', 'acao': null, 'mensagem': 'É obrigatório anexar Plano de Trabalho' });
	        this.adicionaRestricao({ 'tag': 'sumulaObrigatorioAnexado', 'ativo': this.decisao.encaminhamento === 'CONCLUSAO' && _lodash2.default.find(this.solicitacao.sumula.providencias, ['codigo', 'SML']) && !_lodash2.default.find(this.solicitacao.anexos, ['fk_tipo_documento', 43]), 'tipo': 'restricao', 'acao': null, 'mensagem': 'É obrigatório anexar Súmula' });
	        this.adicionaRestricao({ 'tag': 'minutaObrigatoriaAnexado', 'ativo': this.decisao.encaminhamento === 'CONCLUSAO' && _lodash2.default.find(this.solicitacao.sumula.providencias, ['codigo', 'ADT']) && !_lodash2.default.find(this.solicitacao.anexos, ['fk_tipo_documento', 7]), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Minuta do termo aditivo não anexada' });
	      }
	      if (_lodash2.default.includes(['Solicitação', 'Revisão'], this.etapa) && this.decisao.encaminhamento === 'ANALISE' || _lodash2.default.includes(['Análise'], this.etapa) && this.decisao.encaminhamento === 'AUTORIZACAO') {
	        this.removeRestricao({ 'tag': 'docsObrigatoriosSuplementacao' });
	        if (this.proposta.projetoSapiens.codfor !== 18) {
	          var documentosObrigatorios = [{ 'tipo': 2, 'desc': 'Comprovante de CNPJ' }, { 'tipo': 67, 'desc': 'CNEP/CEPIM' }, { 'tipo': 6, 'desc': 'Certidão negativa de débitos relativos a créditos tributários federais e a dívida ativa da união' }, { 'tipo': 40, 'desc': 'CNDT' }];
	          if (this.etapa === 'Análise') {
	            var certidoesComDataValidade = _lodash2.default.filter(this.solicitacao.anexos, function (a) {
	              return !_lodash2.default.isEmpty(a.dt_data_validade) && (0, _moment2.default)(a.dt_data_validade).diff((0, _moment2.default)(), 'days', true) < 0;
	            });
	            this.adicionaRestricao({ 'tag': 'docsObrigSemValidadeOuVencido', 'ativo': !this.ehVisualizacao && certidoesComDataValidade.length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há ' + certidoesComDataValidade.length + ' ' + (certidoesComDataValidade.length > 1 ? 'certidões' : 'certidão') + ' em anexo expirando hoje ou vencida' });
	          }
	          if (_lodash2.default.find(this.solicitacao.processos, function (prc) {
	            return _lodash2.default.includes(['SUPLEMENTACAO'], prc.nome);
	          })) {
	            if (this.etapa === 'Análise') {
	              documentosObrigatorios.push({ 'tipo': 80, 'desc': 'CADIN' });
	            }
	            var tiposJaAnexados = _lodash2.default.map(this.solicitacao.anexos, 'fk_tipo_documento');
	            _lodash2.default.remove(documentosObrigatorios, function (obr) {
	              return _lodash2.default.includes(tiposJaAnexados, obr.tipo);
	            });
	            this.adicionaRestricao({ 'tag': 'docsObrigatoriosSuplementacao', 'ativo': documentosObrigatorios.length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há suplementação, neste caso' + (documentosObrigatorios.length > 1 ? ' são obrigatórios ' : ' falta ') + '<ul><li>' + _lodash2.default.join(_lodash2.default.map(documentosObrigatorios, 'desc'), '<li>') + '</ul>' });
	          }
	
	          this.adicionaRestricao({ 'tag': 'orcamentoObrigatorioEmSuplRemanejItemNovo', 'ativo': (_lodash2.default.find(this.solicitacao.processos, ['nome', 'SUPLEMENTACAO']) || _lodash2.default.get(_lodash2.default.find(this.solicitacao.processos, ['nome', 'REMANEJAMENTO']), 'inclusao', []).length > 0) && !_lodash2.default.find(this.solicitacao.anexos, ['fk_tipo_documento', 23]), 'tipo': 'restricao', 'acao': null, 'mensagem': (_lodash2.default.find(this.solicitacao.processos, ['nome', 'SUPLEMENTACAO']) ? 'Em suplementações' : 'Em remanejamentos com itens novos') + ' é obrigatório anexar orçamento(s)' });
	        }
	      }
	      if (_lodash2.default.includes(['Solicitação', 'Revisão'], this.etapa)) {
	        if (this.solicitacao.instrumentosLidos.ok) {
	          this.errors.removeById('instrumentosLidos');
	          if (_lodash2.default.isNull(this.solicitacao.instrumentosLidos.usuario)) {
	            this.solicitacao.instrumentosLidos = { 'ok': true, 'usuario': _lodash2.default.pick(this.usuarioLogado, ['id', 'ds_nome_usuario']), 'data': new Date() };
	          }
	        } else if (this.usuarioLogado.userType !== 'FUNDACAO') {
	          this.errors.add({ field: 'instrumentosLidos', rule: 'required' });
	          this.solicitacao.instrumentosLidos = { 'ok': false, 'usuario': null, 'data': null };
	        }
	      }
	      this.adicionaRestricao({ 'tag': 'instrumentosLidos', 'ativo': !this.solicitacao.instrumentosLidos.ok && this.usuarioLogado.userType !== 'FUNDACAO', 'tipo': 'restricao', 'acao': null, 'mensagem': 'Leia os instrumentos legais. Após isso selecione a opção \'Li e estou ciente das cláusulas ...\'' });
	      if (this.decisao.encaminhamento === 'REVISAO' || !_lodash2.default.includes(['Solicitação', 'Revisão'], this.etapa) && this.decisao.encaminhamento === 'ANALISE') {
	        this.restricaoParaConcluir = [];
	      }
	      var restricoes = _lodash2.default.filter(this.restricaoParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	      if (restricoes.length > 0) {
	        var mensagens = '<div class=avisoAlerta><li>' + _lodash2.default.join(_lodash2.default.map(restricoes, 'mensagem'), '<li>') + '</div>';
	        this.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	        this.msgErroProcessamento.push(mensagens);
	      }
	      if (this.errors.items.length === 0) {
	        this.$validator.validateAll().then(function (validado) {
	          if (validado && _this9.errors.items.length === 0) {} else {
	            var elementoErro = vm.$refs[_lodash2.default.get(_lodash2.default.head(vm.errors.items), 'field')];
	            elementoErro = _lodash2.default.isArray(elementoErro) ? elementoErro[0] : elementoErro;
	            if (elementoErro) elementoErro.scrollIntoView();
	          }
	        });
	      } else {
	        var elementoErro = vm.$refs[_lodash2.default.get(_lodash2.default.head(vm.errors.items), 'field')];
	        elementoErro = _lodash2.default.isArray(elementoErro) ? elementoErro[0] : elementoErro;
	        if (elementoErro) elementoErro.scrollIntoView();
	      }
	    },
	    prepararSolicitacao: function prepararSolicitacao() {
	      var _this10 = this;
	
	      if (this.processo !== null) {
	        if (_lodash2.default.includes(['FEITO', 'CANCELADO'], this.processo.situacao)) {
	          return;
	        }
	      }
	
	      var processos = [];
	      var alteracoesPeriodos = this.adicionaAlteracao(['nr_periodos', 'periodo_vigencia'], this.propostaBackup, this.proposta);
	      if (!_lodash2.default.isEmpty(alteracoesPeriodos)) {
	        processos.push({ 'nome': 'ALTERACAO_PERIODO_PROJETO', 'id': null, 'alteracao': [alteracoesPeriodos] });
	      }
	      this.registraAlteracaoInclusaoExclusao(processos, 'ALTERACAO_METAS', this.propostaBackup.metas, this.proposta.metas, ['nr_quantidade', 'ds_unidade_medida', 'ds_indicadores_execucao', 'ds_descricao']);
	      this.registraAlteracaoInclusaoExclusao(processos, 'ALTERACAO_ATIVIDADES', this.propostaBackup.atividades, this.proposta.atividades, ['ds_nome', 'ds_documento_comprobatorio', 'nr_periodo_final', 'nr_periodo_inicial']);
	      this.registraAlteracaoInclusaoExclusao(processos, 'ALTERACAO_PARCELAS_ADIANTAMENTO', this.propostaBackup.adiantamentos, this.proposta.adiantamentos, ['origem', 'valor', 'idx']);
	      this.registraAlteracaoInclusaoExclusao(processos, 'ALTERACAO_MUNICIPIOS', this.propostaBackup.municipalizacao, this.proposta.municipalizacao, ['ds_fase', 'ds_cep', 'ds_municipio', 'nr_total_participantes', 'dc_valor_municipio', 'ds_uf']);
	
	      var alteracoesItensDespesa = [];
	      var inclusoesItensDespesa = [];
	      this.propostaBackup.atividades.forEach(function (atividade) {
	        atividade.itens_orcamentos.forEach(function (item) {
	          var atividadeComItemAlterado = _lodash2.default.find(_this10.proposta.atividades, ['id', atividade.id]);
	          var itemAlterado = _lodash2.default.find(atividadeComItemAlterado.itens_orcamentos, ['id', item.id]);
	          if (!itemAlterado) {} else {
	            var alteracoesEmItem = _this10.adicionaAlteracao(['observacao', 'valorAlteracao', 'justificativa', 'adiantavel', 'substituicao'], item, itemAlterado);
	            if (!_lodash2.default.isEmpty(alteracoesEmItem)) {
	              alteracoesItensDespesa.push(alteracoesEmItem);
	            }
	          }
	        });
	      });
	      this.proposta.atividades.forEach(function (atividade) {
	        atividade.itens_orcamentos.forEach(function (item) {
	          if (_lodash2.default.includes('' + item.id, 'novo')) {
	            var itemNovo = _lodash2.default.cloneDeep(item);
	            _lodash2.default.set(itemNovo, 'atividade', { 'id': atividade.id, 'ds_nome': atividade.ds_nome });
	            inclusoesItensDespesa.push(itemNovo);
	          }
	        });
	      });
	      var registroExtrato = { 'nome': this.tipoAlteracaoCronograma, 'id': null };
	      if (alteracoesItensDespesa.length > 0) {
	        _lodash2.default.set(registroExtrato, 'alteracao', alteracoesItensDespesa);
	      }
	      if (inclusoesItensDespesa.length > 0) {
	        _lodash2.default.set(registroExtrato, 'inclusao', inclusoesItensDespesa);
	      }
	      if (_lodash2.default.keys(registroExtrato).length > 2) {
	        processos.push(registroExtrato);
	      }
	      _lodash2.default.set(this.solicitacao, 'processos', processos);
	      this.qteAlteracoes();
	      this.resumoAlteracoesSumula();
	    },
	    concluirSolicitacao: function concluirSolicitacao() {
	      var _this11 = this;
	
	      this.loading.tela = true;
	      var requisicaoProcessamento = [];
	      var solicitacaoBackup = _lodash2.default.cloneDeep(this.solicitacao);
	      this.solicitacao.processos.forEach(function (processo) {
	        var parametros = {};
	        if (processo.nome === 'ALTERACAO_PERIODO_PROJETO' && _lodash2.default.isNull(processo.id)) {
	          var formatosData = ['DD/MM/YYYY', 'YYYY-MM-DD'];
	
	          var mesesVigencia = parseInt(_this11.proposta.periodo_vigencia || 0, 10);
	          var mesesVigenciaBackup = parseInt(_this11.propostaBackup.periodo_vigencia || 0, 10);
	          var nrPeriodosAtual = parseInt(_this11.proposta.nr_periodos || 0, 10);
	          var nrPeriodosBackup = parseInt(_this11.propostaBackup.nr_periodos || 0, 10);
	
	          var dataConvenio = (0, _moment2.default)(_this11.proposta.dt_assinatura_convenio || '', formatosData, true);
	          dataConvenio = dataConvenio.isValid() ? dataConvenio.format('YYYY-MM-DD') : null;
	
	          var dataBaseVigencia = (0, _moment2.default)(_this11.proposta.dt_assinatura_convenio || _this11.proposta.dt_data_inicial || '', formatosData, true);
	
	          _this11.proposta.dt_data_vigencia = dataBaseVigencia.isValid() ? dataBaseVigencia.clone().add(mesesVigencia, 'M').format('YYYY-MM-DD') : null;
	
	          var dataFim = (0, _moment2.default)(_this11.dataFinalExecucao || '', formatosData, true);
	          dataFim = dataFim.isValid() ? dataFim.format('YYYY-MM-DD 00:00:00.000') : null;
	
	          var periodicidades = [{ codigo: 'MENSAL', duracao: 1 }, { codigo: 'BIMESTRAL', duracao: 2 }, { codigo: 'TRIMESTRAL', duracao: 3 }, { codigo: 'QUADRIMESTRAL', duracao: 4 }, { codigo: 'SEMESTRAL', duracao: 6 }, { codigo: 'ANUAL', duracao: 12 }];
	
	          var periodicidadeMeses = _lodash2.default.get(_lodash2.default.find(periodicidades, ['codigo', _this11.proposta.ds_periodicidade_formulario]), 'duracao', 0);
	
	          var diferencaMesesVigencia = mesesVigencia - mesesVigenciaBackup;
	          var diferencaMesesPrazo = nrPeriodosAtual - nrPeriodosBackup;
	          var qtdeRelatoriosNovos = periodicidadeMeses > 0 ? (0, _trunc2.default)(diferencaMesesPrazo / periodicidadeMeses) : 0;
	
	          parametros = {
	            'numeroProjeto': _this11.proposta.ds_codigo_projeto_erp,
	            'dt_assinatura_convenio': dataConvenio,
	            'nr_periodos': _this11.proposta.nr_periodos,
	            'datfpj': dataFim,
	            'periodo_vigencia': _this11.proposta.periodo_vigencia,
	            'usu_datfimvig': _this11.proposta.dt_data_vigencia,
	            'qtde_relatorios_novos': qtdeRelatoriosNovos,
	            'diferencaMesesPrazo': diferencaMesesPrazo,
	            'diferencaMesesVigencia': diferencaMesesVigencia
	          };
	        }
	        if (processo.nome === 'ALTERACAO_METAS' && _lodash2.default.isNull(processo.id)) {
	          parametros = { 'numeroProjeto': _this11.proposta.ds_codigo_projeto_erp, 'metas': _this11.proposta.metas };
	        }
	        if (processo.nome === 'ALTERACAO_ATIVIDADES' && _lodash2.default.isNull(processo.id)) {
	          parametros = { 'numeroProjeto': _this11.proposta.ds_codigo_projeto_erp, 'atividades': _this11.proposta.atividades };
	        }
	        if (processo.nome === 'ALTERACAO_PARCELAS_ADIANTAMENTO' && _lodash2.default.isNull(processo.id)) {
	          var idsAntes = _lodash2.default.map(_this11.propostaBackup.adiantamentos, 'id');
	          var idsDepois = _lodash2.default.map(_this11.proposta.adiantamentos, 'id');
	
	          var excluido = _lodash2.default.filter(_this11.propostaBackup.adiantamentos, function (a) {
	            return _lodash2.default.includes(_lodash2.default.difference(idsAntes, idsDepois), a.id);
	          });
	          var alterado = _lodash2.default.clone(_this11.proposta.adiantamentos);
	          _lodash2.default.forEach(alterado, function (p) {
	            _lodash2.default.unset(p, 'requisitado');
	            _lodash2.default.unset(p, 'percentual_comprovado');
	          });
	          parametros = { 'numeroProjeto': _this11.proposta.ds_codigo_projeto_erp, 'parcelas': alterado, 'excluido': excluido };
	        }
	        if (processo.nome === 'ALTERACAO_MUNICIPIOS' && _lodash2.default.isNull(processo.id)) {
	          var _idsAntes = _lodash2.default.map(_this11.propostaBackup.municipalizacao, 'id');
	          var _idsDepois = _lodash2.default.map(_this11.proposta.municipalizacao, 'id');
	
	          var _excluido = _lodash2.default.filter(_this11.propostaBackup.municipalizacao, function (a) {
	            return _lodash2.default.includes(_lodash2.default.difference(_idsAntes, _idsDepois), a.id);
	          });
	          parametros = { 'numeroProjeto': _this11.proposta.ds_codigo_projeto_erp, 'municipios': _this11.proposta.municipalizacao, 'excluido': _excluido };
	        }
	        if (_lodash2.default.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], processo.nome) && _lodash2.default.isNull(processo.id)) {
	          var processoAlteracao = _lodash2.default.cloneDeep(_lodash2.default.find(_this11.solicitacao.processos, ['nome', processo.nome]));
	          if (_lodash2.default.has(processoAlteracao, 'alteracao')) {
	            processoAlteracao.alteracao.forEach(function (alteracao) {
	              _this11.proposta.atividades.forEach(function (atividade) {
	                var itemAlterado = _lodash2.default.find(_lodash2.default.get(atividade, 'itens_orcamentos', []), ['id', alteracao.id]);
	                if (itemAlterado) {
	                  _lodash2.default.forIn(itemAlterado, function (value, key) {
	                    if (!_lodash2.default.has(alteracao, key)) {
	                      _lodash2.default.set(alteracao, key, value);
	                    }
	                  });
	                }
	              });
	            });
	          }
	          parametros = { 'numeroProjeto': _this11.proposta.ds_codigo_projeto_erp, 'modificacao': processoAlteracao, 'dataAssinaturaConvenio': _this11.proposta.projetoSapiens.usu_datcon, 'dataTerminoVigencia': _this11.proposta.dt_data_vigencia, 'mesesVigencia': _this11.proposta.periodo_vigencia };
	        }
	        requisicaoProcessamento.push({ 'nome': processo.nome, 'id': processo.id, 'parametros': parametros });
	      });
	      this.loading.tela = true;
	      var toast = this.$aguarde('Processando alterações do projeto...');
	      axiosLaravel.post('projeto/alteracoes/processar', { 'idSolicitacao': this.id, 'solicitacao': this.solicitacao, 'processos': requisicaoProcessamento, 'proposta': this.proposta }).then(function (response) {
	        _this11.$snotify.remove(toast.id);
	        if (_lodash2.default.get(response.data, 'codigo', '') === 'OK') {
	          _this11.$snotify.success('Projeto alterado', { timeout: 3000 });
	          _this11.$router.go(-1);
	        } else {
	          var msgErro = response.data.mensagem.replaceAll('\n', '<br/>');
	          _this11.$snotify.error(msgErro, { timeout: 20000 });
	          _this11.msgErroProcessamento.push(msgErro);
	        }
	        _this11.solicitacao = _lodash2.default.cloneDeep(solicitacaoBackup);
	        _this11.loading.tela = false;
	      }).catch(function (error) {
	        _this11.solicitacao = _lodash2.default.cloneDeep(solicitacaoBackup);
	        var erroMsg = _this11.$root.trataErro(error);
	        _this11.msgErroProcessamento.push(erroMsg.replaceAll('\n', '<br/>'));
	        _this11.loading.tela = false;
	        _this11.$snotify.remove(toast.id);
	      });
	    },
	    registraAlteracaoInclusaoExclusao: function registraAlteracaoInclusaoExclusao(processos, nome, antes, depois, verificacoes) {
	      var _this12 = this;
	
	      var alteracoes = [];
	      var exclusoes = [];
	      var inclusoes = [];
	      antes.forEach(function (original) {
	        var alterado = _lodash2.default.find(depois, ['id', original.id]);
	        if (!alterado) {
	          exclusoes.push(original.id);
	        } else {
	          var registroAlteracoes = _this12.adicionaAlteracao(verificacoes, original, alterado);
	          if (nome === 'ALTERACAO_MUNICIPIOS' && _lodash2.default.keys(registroAlteracoes).length === 2 && _lodash2.default.get(registroAlteracoes, 'ds_uf') === '') {
	            registroAlteracoes = {};
	          }
	          if (!_lodash2.default.isEmpty(registroAlteracoes)) {
	            alteracoes.push(registroAlteracoes);
	          }
	        }
	      });
	      if (_lodash2.default.includes(['ALTERACAO_METAS', 'ALTERACAO_ATIVIDADES'], nome)) {
	        inclusoes = _lodash2.default.filter(depois, function (item) {
	          return !_lodash2.default.isNumber(item.id);
	        });
	      } else if (_lodash2.default.includes(['ALTERACAO_PARCELAS_ADIANTAMENTO', 'ALTERACAO_MUNICIPIOS'], nome)) {
	        inclusoes = _lodash2.default.filter(depois, function (item) {
	          return !_lodash2.default.has(item, 'id');
	        });
	      }
	      var registroProcesso = { 'nome': nome, 'id': null };
	      if (alteracoes.length > 0) {
	        _lodash2.default.set(registroProcesso, 'alteracao', alteracoes);
	      }
	      if (inclusoes.length > 0) {
	        _lodash2.default.set(registroProcesso, 'inclusao', inclusoes);
	      }
	      if (exclusoes.length > 0) {
	        _lodash2.default.set(registroProcesso, 'exclusao', exclusoes);
	      }
	      if (_lodash2.default.keys(registroProcesso).length > 2) {
	        processos.push(registroProcesso);
	      }
	    },
	    encaminharSolicitacao: function encaminharSolicitacao(acao) {
	      var _this13 = this;
	
	      var abrirDocumento = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loading.tela = true;
	      axiosLaravel.post('projeto/alteracoes/encaminhar', { 'acao': acao, 'nrProjeto': this.proposta.ds_codigo_projeto_erp, 'idSolicitacao': this.id, 'solicitacao': this.solicitacao, 'decisao': this.decisao, 'etapa': this.etapa }).then(function (response) {
	        if (_lodash2.default.get(response.data, 'codigo', '') === 'OK') {
	          _this13.$snotify.success(response.data.mensagem, { timeout: 3000 });
	          _this13.id = response.data.retorno.id;
	          if (!_lodash2.default.isNull(abrirDocumento)) {
	            window.open(location.protocol + '//' + location.host + '/solicitacao/alteracoesprojeto/' + abrirDocumento + '/' + _this13.id, '_blank');
	          }
	          if (acao !== 'SALVAR') {
	            _this13.$router.go(-1);
	          }
	        } else {
	          _this13.msgErroProcessamento.push(response.data.mensagem.replaceAll('\n', '<br/>'));
	          _this13.$snotify.error(response.data.mensagem);
	        }
	        _this13.$forceUpdate();
	        _this13.loading.tela = false;
	      }).catch(function (error) {
	        _this13.loading.tela = false;
	        console.log('error', error);
	        var erroMsg = _this13.$root.trataErro(error);
	        _this13.msgErroProcessamento.push(erroMsg.replaceAll('\n', '<br/>'));
	      });
	    },
	    adicionaAlteracao: function adicionaAlteracao(parametros, antes, depois) {
	      var alteracoes = {};
	      parametros.forEach(function (parametro) {
	        if (parametro === 'observacao' && _lodash2.default.has(depois, 'observacaoNova')) {
	          var valorOriginal = '' + _lodash2.default.get(antes, 'observacaoOriginal', '');
	          var valorAtual = '' + _lodash2.default.get(depois, 'observacaoNova', '');
	          if (valorOriginal !== valorAtual) {
	            _lodash2.default.set(alteracoes, parametro, [valorOriginal, valorAtual]);
	          }
	          return;
	        }
	        var valorAntes = '' + _lodash2.default.get(antes, parametro, '');
	        var valorDepois = '' + _lodash2.default.get(depois, parametro, '');
	        if (valorAntes !== valorDepois) {
	          _lodash2.default.set(alteracoes, parametro, [valorAntes, valorDepois]);
	        }
	      });
	      if (!_lodash2.default.isEmpty(alteracoes)) {
	        _lodash2.default.set(alteracoes, 'id', antes['id']);
	      }
	      return alteracoes;
	    },
	    adicionaRestricao: function adicionaRestricao(ev) {
	      if (!_lodash2.default.isNil(ev) && _lodash2.default.has(ev, 'tag')) {
	        _lodash2.default.remove(this.restricaoParaConcluir, function (i) {
	          return i.tag === ev.tag;
	        });
	
	        this.restricaoParaConcluir.push(ev);
	      }
	    },
	    verificaParcelaAdiantadaParcial: function verificaParcelaAdiantadaParcial() {
	      var parcelas = _lodash2.default.get(this.proposta, 'adiantamentos', []);
	
	      var requisitadoMenorDisponibilizado = false;
	
	      parcelas.forEach(function (parcela) {
	        if (parcela.requisitado) {
	          if (parcela.valor > parcela.requisitado) {
	            requisitadoMenorDisponibilizado = true;
	          }
	        }
	      });
	
	      return requisitadoMenorDisponibilizado;
	    },
	    verificaSeProjetoNaoPossuiAdiantamento: function verificaSeProjetoNaoPossuiAdiantamento() {
	      var parcelas = _lodash2.default.get(this.proposta, 'adiantamentos', []);
	
	      var naoPossuiAdiantamento = true;
	
	      parcelas.forEach(function (parcela) {
	        if (parcela.requisitado) {
	          naoPossuiAdiantamento = false;
	        }
	      });
	
	      return naoPossuiAdiantamento;
	    },
	    removeRestricao: function removeRestricao(ev) {
	      _lodash2.default.remove(this.restricaoParaConcluir, function (i) {
	        return i.tag === ev.tag;
	      });
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _lodash2.default.isNull(valor) || _lodash2.default.isNil(valor) || _lodash2.default.isUndefined(valor) ? opcao : valor;
	    },
	    modelosDocumento: function modelosDocumento(id, grupo, tipo) {
	      var _this14 = this;
	
	      if (this.usuarioLogado.userType === 'FUNDACAO' && !this.ehVisualizacao) {
	        this.loading.aditivo.lista = true;
	        axiosLaravel.post('projeto/modelos/documento', { 'id': id, 'grupo': grupo, 'tipo': tipo }).then(function (response) {
	          if (_lodash2.default.get(response.data, 'codigo', '') === 'OK') {
	            _this14.listaMinutasAditivo = response.data.retorno;
	          } else {
	            _this14.$snotify.error(response.data.mensagem);
	          }
	          _this14.loading.aditivo.lista = false;
	        }).catch(function (error) {
	          _this14.loading.aditivo.lista = false;
	          _this14.$root.trataErro(error);
	        });
	      }
	    },
	    ocultaSinalizarDocumentosInternos: function ocultaSinalizarDocumentosInternos() {
	      var _this15 = this;
	
	      var inclusoes = _lodash2.default.filter(this.tarefas, ['nome', 'INCLUSAO_DOCUMENTO']);
	      inclusoes.forEach(function (tarefa) {
	        var id = tarefa.observacao.substr(tarefa.observacao.indexOf('#') + 1);
	        var anexo = _lodash2.default.find(_this15.solicitacao.anexos, ['id', _lodash2.default.toNumber(id)]);
	        if (anexo) {
	          if (_this15.usuarioLogado.userType === 'FUNDACAO') {
	            _lodash2.default.set(anexo, 'ds_tipo_usuario', tarefa.ds_tipo_usuario);
	            _lodash2.default.set(anexo, 'ds_nome_usuario', tarefa.ds_nome_usuario);
	          }
	          if (_this15.usuarioLogado.userType !== 'FUNDACAO' && tarefa.ds_tipo_usuario === 'FUNDACAO') {
	            _lodash2.default.set(anexo, 'mostrar', false);
	          }
	        }
	      });
	    },
	    verificaSeHaAditivoUsando: function verificaSeHaAditivoUsando(modelo) {
	      var vm = this;
	      if (!_lodash2.default.isEmpty(this.solicitacao.aditivo.conteudo) || !_lodash2.default.isEmpty(this.solicitacao.aditivo.modelo)) {
	        this.$dialog.confirm('Já foi selecionado um modelo. Se selecionar outro, as alterações no atual serão perdidas.', { html: true, animation: 'fade', customClass: 'avisoConfirmacao' }).then(function (dialog) {
	          if (!_lodash2.default.isEmpty(vm.solicitacao.anexos)) {
	            vm.$dialog.alert('Já foi anexado aditivo. Verifique se ele esta condizente com o modelo selecionado', { html: true, animation: 'fade', customClass: 'avisoInfo' });
	          }
	          vm.gerarAditivo(modelo);
	        }).catch(function () {});
	      } else {
	        vm.gerarAditivo(modelo);
	      }
	    },
	    numeroPorExtenso: function numeroPorExtenso(numero) {
	      var tipo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'INTEIRO';
	
	      var numeroExtenso = '';
	      if (tipo === 'MOEDA') {
	        numero = '' + _lodash2.default.toNumber(numero).toLocaleString('pt-BR');
	        numero += numero.indexOf(',') !== -1 ? '' : ',00';
	        numeroExtenso = (0, _extenso2.default)(numero, { mode: 'currency', number: { decimalSeparator: 'comma' } });
	      } else if (tipo === 'INTEIRO') {
	        numero = '' + _lodash2.default.toNumber(numero).toLocaleString('en-US');
	        numeroExtenso = (0, _extenso2.default)(numero);
	      }
	      return numeroExtenso;
	    },
	    gerarAditivo: function gerarAditivo(modelo) {
	      var _this16 = this;
	
	      var preencher = true;
	      this.loading.aditivo.conteudo = true;
	      var id = modelo.id;
	      axiosLaravel.post('projeto/modelos/documento', { 'id': id, 'grupo': null, 'tipo': 'COM_DADOS' }).then(function (response) {
	        if (_lodash2.default.get(response.data, 'codigo', '') === 'OK') {
	          var conteudo = _lodash2.default.get(response.data.retorno, '0.dados');
	          if (preencher) {
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_NOME»'], _this16.proposta.projetoSapiens.entidadeParceira.nomfor, 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_NUMERO»'], _this16.proposta.projetoSapiens.numprj, 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_NOME»'], _this16.proposta.projetoSapiens.nomprj, 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_ASSINATURA_CONVENIO»'], _this16.proposta.projetoSapiens.usu_datcon, 'DATA');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_PRAZO»'], _this16.proposta.nr_periodos, 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_PRAZO_EXTENSO»'], _this16.numeroPorExtenso(_this16.proposta.nr_periodos, 'INTEIRO'), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_VIGENCIA»'], _this16.proposta.periodo_vigencia, 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_VIGENCIA_EXTENSO»'], _this16.numeroPorExtenso(_this16.proposta.periodo_vigencia, 'INTEIRO'), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_TERMINO_EXECUCAO»'], _this16.dataFinal, 'TEXTO');
	            var itensOrcamento = _lodash2.default.flatten(_lodash2.default.map(_this16.proposta.atividades, 'itens_orcamentos'));
	            var totalProjeto = Math.round(_lodash2.default.sumBy(_lodash2.default.filter(itensOrcamento, function (i) {
	              return i.fk_itens !== 'CTR';
	            }), 'valor_total') * 100) / 100;
	            var totalFBB = Math.round(_lodash2.default.sumBy(_lodash2.default.filter(itensOrcamento, function (i) {
	              return _lodash2.default.includes(['1'], ('' + i.origem).substr(0, 1));
	            }), 'valor_total') * 100) / 100;
	            var totalContrapartida = Math.round(_lodash2.default.sumBy(_lodash2.default.filter(itensOrcamento, function (i) {
	              return !_lodash2.default.includes(['1', '5'], ('' + i.origem).substr(0, 1));
	            }), 'valor_total') * 100) / 100;
	            var totalSuplementacao = Math.round(_lodash2.default.sumBy(_lodash2.default.filter(itensOrcamento, function (i) {
	              return _lodash2.default.get(i, 'valorAlteracao', 0) > 0;
	            }), 'valorAlteracao') * 100) / 100;
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_VALOR_TOTAL»'], totalProjeto, 'MOEDA');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_FBB_TOTAL»'], totalFBB, 'MOEDA');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_CONTRAPARTIDA_TOTAL»'], totalContrapartida, 'MOEDA');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_SUPLEMENTACAO_TOTAL»'], totalSuplementacao, 'MOEDA');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_VALOR_TOTAL_EXTENSO»'], _this16.numeroPorExtenso(totalProjeto, 'MOEDA'), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_FBB_TOTAL_EXTENSO»'], _this16.numeroPorExtenso(totalFBB, 'MOEDA'), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_CONTRAPARTIDA_TOTAL_EXTENSO»'], _this16.numeroPorExtenso(totalContrapartida, 'MOEDA'), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_SUPLEMENTACAO_TOTAL_EXTENSO»'], _this16.numeroPorExtenso(totalSuplementacao, 'MOEDA'), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_CNPJ»'], _this16.proposta.projetoSapiens.entidadeParceira.cgccpf, 'CNPJ');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_SEDE_MUNICIPIO»'], _this16.proposta.projetoSapiens.entidadeParceira.cidfor, 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_ENDERECO»'], _this16.proposta.projetoSapiens.entidadeParceira.endfor, 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_CEP»'], _this16.proposta.projetoSapiens.entidadeParceira.cepfor, 'CEP');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_UF»'], _this16.proposta.projetoSapiens.entidadeParceira.sigufs, 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_REPRESENTANTE_LEGAL_CARGO»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.0.desniv', ''), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_REPRESENTANTE_LEGAL_NOME»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.0.nomcto', ''), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_REPRESENTANTE_LEGAL_PROFISSAO»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.0.carcto', ''), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_REPRESENTANTE_LEGAL_DOC_IDENTIFICACAO»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.0.usu_rgcto', ''), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_REPRESENTANTE_LEGAL_CPF»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.0.cpfcto', ''), 'CPF');
	            conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_REPRESENTANTE_LEGAL_MUNICIPIO»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.0.usu_cidcto', ''), 'TEXTO');
	            if (_lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes', []).length > 1) {
	              conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_2_REPRESENTANTE_LEGAL_CARGO»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.1.desniv', ''), 'TEXTO');
	              conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_2_REPRESENTANTE_LEGAL_NOME»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.1.nomcto', ''), 'TEXTO');
	              conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_2_REPRESENTANTE_LEGAL_PROFISSAO»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.1.carcto', ''), 'TEXTO');
	              conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_2_REPRESENTANTE_LEGAL_DOC_IDENTIFICACAO»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.1.usu_rgcto', ''), 'TEXTO');
	              conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_2_REPRESENTANTE_LEGAL_CPF»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.1.cpfcto', ''), 'CPF');
	              conteudo = _this16.trocarTexto(conteudo, ['«ENTIDADE_2_REPRESENTANTE_LEGAL_MUNICIPIO»'], _lodash2.default.get(_this16.proposta, 'projetoSapiens.entidadeParceira.dirigentes.1.usu_cidcto', ''), 'TEXTO');
	            }
	            conteudo = _this16.trocarTexto(conteudo, ['«AGENCIA_PREFIXO»'], _lodash2.default.get(_this16.proposta, 'ds_agencia_numero', ''), 'TEXTO');
	
	            if (id === '8') {
	              var listaParcAdt = _lodash2.default.get(_this16.proposta, 'adiantamentos', []);
	              conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_ADIANTAMENTO_PARCELAS»'], listaParcAdt.length, 'TEXTO');
	              var totalAdt = _lodash2.default.sumBy(listaParcAdt, 'valor');
	              conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_ADIANTAMENTO_TOTAL»'], totalAdt, 'MOEDA');
	              var conv = ('' + totalAdt).toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' });
	              var totalAdtExtenso = _this16.numeroPorExtenso(conv, 'MOEDA');
	              conteudo = _this16.trocarTexto(conteudo, ['«PROJETO_ADIANTAMENTO_TOTAL_EXTENSO»'], totalAdtExtenso, 'TEXTO');
	              var listaParcAdtTexto = '';
	              listaParcAdt.forEach(function (p) {
	                listaParcAdtTexto = listaParcAdtTexto + p.parcela + 'ª parcela: até R$ ' + p.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }) + ' (' + 'por extenso' + ');<br/>';
	              });
	              conteudo = _this16.trocarTexto(conteudo, ['1ª parcela'], listaParcAdtTexto, 'TEXTO');
	            }
	            conteudo = _this16.trocarTexto(conteudo, ['«LOCAL_DATA»'], 'Brasília (DF), ' + (0, _moment2.default)().format('DD [de] MMMM [de] YYYY'), 'TEXTO');
	            conteudo = _this16.trocarTexto(conteudo, ['&nbsp; &nbsp;'], '&nbsp;&nbsp;&nbsp;', 'TEXTO');
	          }
	          _this16.solicitacao.aditivo.conteudo = conteudo;
	          _this16.$forceUpdate();
	        } else {
	          _this16.$snotify.error(response.data.mensagem);
	        }
	        _this16.loading.aditivo.conteudo = false;
	      }).catch(function (error) {
	        _this16.loading.aditivo.conteudo = false;
	        _this16.$root.trataErro(error);
	      });
	    },
	    trocarTexto: function trocarTexto(conteudo, textosAtuais, valorNovo, formato) {
	      valorNovo = '' + valorNovo;
	      if (valorNovo && !_lodash2.default.isNil(valorNovo) && !_lodash2.default.isEmpty(valorNovo)) {
	        if (formato === 'MOEDA') {
	          valorNovo = _lodash2.default.toNumber(valorNovo).toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' });
	        } else if (formato === 'CNPJ') {
	          valorNovo = valorNovo.replace(/\D/g, '').replace(/(\d{2})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1/$2').replace(/(\d{4})(\d)/, '$1-$2').replace(/(-\d{2})\d+?$/, '$1');
	        } else if (formato === 'CPF') {
	          valorNovo = valorNovo.replace(/\D/g, '').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1-$2').replace(/(-\d{2})\d+?$/, '$1');
	        } else if (formato === 'CEP') {
	          valorNovo = valorNovo.replace(/\D/g, '').replace(/(\d{5})(\d)/, '$1-$2').replace(/(-\d{3})\d+?$/, '$1');
	        } else if (formato === 'DATA') {
	          valorNovo = (0, _moment2.default)(valorNovo).format('DD/MM/YYYY');
	        }
	        if (textosAtuais.length === 1) {
	          conteudo = conteudo.replaceAll(textosAtuais[0], valorNovo);
	        } else if (textosAtuais.length === 2) {
	          var i = conteudo.indexOf(textosAtuais[0]);
	          var f = conteudo.indexOf(textosAtuais[1], i);
	          conteudo = conteudo.replaceAll(conteudo.substring(i, f), valorNovo);
	        }
	      }
	      return conteudo;
	    },
	    alterarExpandirBloco: function alterarExpandirBloco(bloco) {
	      _lodash2.default.set(this.opcoesVisualizacao, [bloco, 'expandir'], !_lodash2.default.get(this.opcoesVisualizacao, [bloco, 'expandir']));
	      this.salvarConfiguracoes();
	    },
	    alterarModoModificacao: function alterarModoModificacao(bloco) {
	      var modoAlterado = _lodash2.default.get(this.opcoesVisualizacao, [bloco, 'modificacoes']) === 'RESUMIDO' ? 'DETALHADO' : 'RESUMIDO';
	      if (bloco === 'solicitacao') {
	        _lodash2.default.forEach(this.opcoesVisualizacao, function (opc) {
	          if (bloco !== 'solicitacoes') {
	            _lodash2.default.set(opc, 'modificacoes', modoAlterado);
	          }
	        });
	      } else {
	        _lodash2.default.set(this.opcoesVisualizacao, [bloco, 'modificacoes'], modoAlterado);
	      }
	      this.salvarConfiguracoes();
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this17 = this;
	
	      if (!this.ehVisualizacao) {
	        _lodash2.default.set(this.usuarioLogado, 'configuracoes.alteracoes_projeto.opcoes', this.opcoesVisualizacao);
	        axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {}).catch(function (error) {
	          if (error) {
	            _this17.$root.trataErro(error);
	          }
	        });
	      }
	    },
	    emitir: function emitir(relatorio) {
	      var _this18 = this;
	
	      var mosDes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loading.tela = true;
	      var parametros = '<ECodEmp=1><ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '>';
	
	      if (relatorio === 219) {
	        parametros += '<ESitPrj=ULT>';
	      } else if (relatorio === 248) {
	        parametros += '<ECodFor=>';
	      }
	
	      if (relatorio === 525) {
	        parametros = '<ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '><EMosDes=' + mosDes + '>';
	      }
	      if (relatorio === 200 && _lodash2.default.has(this.analiseTributaria, 'nf') && '' + this.analiseTributaria.nf.SitNfc === '2') {
	        parametros = '<ECodFor=' + this.analiseTributaria.nf.CodFor + '><ENumNfc=' + this.analiseTributaria.nf.NumNfc + '><ECodSnf=' + this.analiseTributaria.nf.CodSnf + '><EForOrg=F><EPreCon=N>';
	      }
	      if (relatorio === 611) {
	        parametros = '<ECodFor=' + this.analiseTributaria.nf.CodFor + '><ENumTit="' + this.analiseTributaria.titulo.NumTit + '"><ETitBai=S>';
	      }
	      this.$snotify.clear();
	      var codigoRelatorio = (relatorio === 200 ? 'SRNF' : 'FJCF') + relatorio + '.GER';
	      if (relatorio === 611) codigoRelatorio = 'FPCP' + relatorio + '.GER';
	      var identificacao = relatorio === 525 ? '525 - Extrato ' + (mosDes === 'S' ? 'Analítico' : 'Sintético') : relatorio;
	      this.$aguarde('Gerando relatório ' + identificacao + '. Por favor, aguarde...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': codigoRelatorio }, params: parametros }).then(function (response) {
	        _this18.onDownload(response, identificacao, _this18);
	      }).catch(function (error) {
	        _this18.$snotify.clear();
	        _this18.loading.tela = false;
	        _this18.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (relatorio !== 200) {
	        if (!ie) {
	          var blob = file;
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var _blob = file;
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	          _link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp;
	          _link.click();
	        }
	      } else {
	        if (!ie) {
	          var _blob2 = file;
	          var _link2 = document.createElement('a');
	          _link2.href = window.URL.createObjectURL(_blob2);
	          _link2.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + vm.id;
	          document.body.appendChild(_link2);
	          _link2.click();
	          document.body.removeChild(_link2);
	        } else {
	          var _blob3 = file;
	          var _link3 = document.createElement('blob');
	          _link3.href = window.navigator.msSaveOrOpenBlob(_blob3, item.name);
	          _link3.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + vm.id;
	          _link3.click();
	        }
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading.tela = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    consultaCronogramaProjeto: function consultaCronogramaProjeto(numeroProjeto) {
	      var _this19 = this;
	
	      axiosLaravel.get('projeto/alteracoes/verificaItensMensalizados/' + numeroProjeto).then(function (response) {
	        _this19.erroCronograma = response.data.erro_cronograma;
	        if (_this19.erroCronograma === true) {
	          _this19.adicionaRestricao({ 'tag': 'erroCronograma', 'ativo': true, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Erro na mensalização de itens do cronograma. Entre em contato com o administrador do sistema.' });
	          var restricoes = _lodash2.default.filter(_this19.restricaoParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	          var mensagens = '<div class=avisoAlerta><li>' + _lodash2.default.join(_lodash2.default.map(restricoes, 'mensagem'), '<li>') + '</div>';
	          _this19.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	          _this19.msgErroProcessamento.push(mensagens);
	        }
	      }).catch(function (error) {
	        _this19.$snotify.clear();
	        _this19.loading.tela = false;
	        _this19.$root.trataErro(error);
	      });
	    },
	    cancelarProcesso: function cancelarProcesso() {
	      var _this20 = this;
	
	      this.$aguarde('Cancelando o processo de alteração...');
	      this.$refs.alertaCancelamentoDialog.close();
	      this.loading.tela = true;
	      axiosLaravel.post('projeto/alteracoes/cancelar', { id: this.id, justificativa: this.justificativaCancelamento }).then(function (response) {
	        _this20.loading.tela = false;
	        _this20.$snotify.clear();
	        _this20.$snotify.success('Processo cancelado com sucesso!');
	        _this20.$router.go(-1);
	      }).catch(function (error) {
	        _this20.$snotify.clear();
	        _this20.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HistoricoProposta: _historicoProposta2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default
	  },
	  name: 'alteracoes-projeto-plano-trabalho',
	  data: function data() {
	    return {
	      progressBar: {
	        stepAtual: null,
	        stepTotal: null,
	        tarefaAtual: null
	      },
	      loading: {
	        tela: false,
	        cidade: false,
	        entidade: false,
	        fluxo: false
	      },
	      array: [],
	      esconder: true,
	      fluxo: {},
	      elementos: {
	        visivel: ''
	      },
	      carregou: false,
	      dirigentes: [],
	      documentosProposta: [],
	      bloqueiaBotoes: false,
	      ganttZoom: 1,
	      projetoPeriodos: 0,
	      proposta: {
	        projetoAprovado: false,
	        dataFinal: '',
	        totalProjeto: 0,
	        totalFBB: 0,
	        totalParc: 0,
	        totalCtrp: 0,
	        entidade: {},
	        documentos: {
	          proposta: []
	        }
	      },
	      id: null,
	      processo: null,
	      ehVisualizacao: false,
	      etapa: 'Solicitação',
	      tarefas: [],
	      ultimaTarefa: {},
	      tarefaNome: { 'ANALISE': 'Análise', 'AUTORIZACAO': 'Autorização', 'REVISAO': 'Revisão', 'SOLICITACAO': 'Solicitação', 'DELIBERACAO': 'Deliberação', 'PENDENCIAS': 'Pendências' },
	      propostaBackup: {},
	      solicitacao: {
	        instrumentosLidos: {
	          ok: false,
	          usuario: null,
	          data: null
	        },
	        justificativa: null,
	        motivosDevolucao: [],
	        anexos: [],
	        processos: [],
	        aditivo: {
	          modelo: {},
	          conteudo: '',
	          anexos: []
	        },
	        planoTrabalho: {
	          conteudo: {},
	          anexos: []
	        },
	        notaTecnica: {
	          conteudo: {},
	          anexos: []
	        },
	        sumula: {
	          textoAnalise: null,
	          textoProposta: null,
	          textoContexto: null,
	          textoSituacaoProblema: null,
	          textoParecer: null,
	          questionario: [],
	          parceriaEstrategica: null,
	          providencias: [],
	          anexos: [],
	          resumoAlteracoes: {
	            metas: 0,
	            contrapartidas: 0,
	            substituicaoItens: 0,
	            ajusteQuantidade: 0,
	            novosItens: 0,
	            prorrogacaoExecucao: [0, 0],
	            prorrogacaoVigencia: [0, 0],
	            municipiosAlterados: 0,
	            percentualRemanejamentosConcedidos: 0,
	            percentualRemanejamentoSolicitado: 0,
	            percentualRemanejamentoAcumulado: 0,
	            valorSuplementacao: 0,
	            valorTotalComSuplementacao: 0,
	            enquadramentoOrcamentarioFEP: null,
	            outrasAlteracoes: null
	          },
	          alcada: {}
	        }
	      },
	      formaJuridica: '',
	      componentKey: 0,
	      ultimaTarefaEntidade: {},
	      periodoMesAno: [],
	      estadoCivil: { 'SOLTEIRO': 'Solteiro(a)', 'CASADO': 'Casado(a)', 'DIVORCIADO': 'Divorciado(a)', 'VIUVO': 'Viúvo(a)' },
	      meses: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
	      estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
	
	      dataInicioExecucao: '',
	      dataFimExecucao: ''
	    };
	  },
	
	  watch: {
	    loading: {
	      deep: true,
	      handler: function handler(carregando) {
	        if (!carregando.cidade && !carregando.entidade && !carregando.fluxo) {
	          this.loading.tela = false;
	          this.$snotify.clear();
	          this.$snotify.success('Plano de Trabalho carregada com sucesso!', { timeout: 2000 });
	        }
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    parcelasAdiantamentoExibicao: function parcelasAdiantamentoExibicao() {
	      return this.consolidarParcelasAdiantamento(_.get(this.proposta, 'adiantamentos', []));
	    },
	    exibeDesdobramentoParcelas: function exibeDesdobramentoParcelas() {
	      return this.haParcelaMista(this.parcelasAdiantamentoExibicao);
	    },
	    totalParcelasAdiantamentoFundacao: function totalParcelasAdiantamentoFundacao() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_fbb');
	    },
	    totalParcelasAdiantamentoParceiro: function totalParcelasAdiantamentoParceiro() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao, 'valor_parc');
	    },
	    totalParcelasAdiantamentoGeral: function totalParcelasAdiantamentoGeral() {
	      return this.totalParcelasAdiantamento(this.parcelasAdiantamentoExibicao);
	    }
	  }),
	  created: function created() {
	    console.log('iniciando plano de trabalho');
	    if (_.has(this.$route.params, 'id')) {
	      this.id = this.$route.params;
	      this.carregarDados({ 'id': this.$route.params.id });
	    }
	  },
	
	  methods: {
	    carregarDados: function carregarDados(requisicao) {
	      var _this = this;
	
	      this.loading.tela = true;
	      this.loading.cidade = true;
	      this.loading.entidade = true;
	      this.loading.fluxo = true;
	      this.$aguarde('Carregando Plano de Trabalho. Por favor, aguarde...');
	      axiosLaravel.post('projeto/alteracoes', requisicao).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var proposta = response.data.retorno.projeto;
	          _this.propostaBackup = _.cloneDeep(proposta);
	          var solicitacao = response.data.retorno.solicitacao;
	          if (!_.isEmpty(solicitacao)) {
	            _this.solicitacao = solicitacao.dados;
	            _this.processo = solicitacao.processo;
	            _this.id = _this.processo.id;
	            _this.ultimaTarefa = _.last(_.filter(solicitacao.tarefas, ['tipo', 'USUARIO']));
	            _this.tarefas = _.get(_.last(solicitacao.tarefas), 'tipo', 'USUARIO') === 'USUARIO' ? _.initial(solicitacao.tarefas) : solicitacao.tarefas;
	            _this.etapa = _this.tarefaNome[_this.ultimaTarefa['nome']];
	            if (!_this.ehVisualizacao) {
	              _this.ehVisualizacao = _.includes(['FEITO', 'CANCELADO'], _this.processo.situacao) || _this.usuarioLogado.userType !== 'FUNDACAO' && !_.includes(['Revisão', 'Solicitação'], _this.etapa);
	            }
	            if (!_.includes(['FEITO', 'CANCELADO'], _this.processo.situacao)) {
	              var objetosRefProcesso = { 'ALTERACAO_METAS': 'metas', 'ALTERACAO_ATIVIDADES': 'atividades', 'ALTERACAO_PARCELAS_ADIANTAMENTO': 'adiantamentos', 'ALTERACAO_MUNICIPIOS': 'municipalizacao', 'ALTERACAO_PERIODO_PROJETO': '' };
	              _this.solicitacao.processos.forEach(function (processo) {
	                var exclusoes = _.get(processo, 'exclusao', []);
	                exclusoes.forEach(function (exclusao) {
	                  _.remove(_.get(proposta, objetosRefProcesso[processo.nome], []), ['id', exclusao]);
	                });
	
	                var alteracoes = _.get(processo, 'alteracao', []);
	                alteracoes.forEach(function (alteracao) {
	                  var registroAlterado = proposta;
	                  if (_.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], processo.nome)) {
	                    proposta.atividades.forEach(function (atividade) {
	                      var itemAlterado = _.find(_.get(atividade, 'itens_orcamentos', []), ['id', alteracao.id]);
	                      if (itemAlterado) {
	                        registroAlterado = itemAlterado;
	                      }
	                    });
	                  } else if (processo.nome !== 'ALTERACAO_PERIODO_PROJETO') {
	                    registroAlterado = _.find(_.get(proposta, objetosRefProcesso[processo.nome], []), ['id', alteracao.id]);
	                  }
	                  _.forIn(alteracao, function (value, key, obj) {
	                    if (key !== 'id') {
	                      var valor = _.isNaN(_.toNumber(value[1])) ? value[1] : _.toNumber(value[1]);
	                      _.set(registroAlterado, key, valor);
	                    }
	                  });
	                });
	
	                var inclusoes = _.get(processo, 'inclusao', []);
	                var lista = _.get(proposta, [objetosRefProcesso[processo.nome]], []);
	                inclusoes.forEach(function (inclusao) {
	                  if (_.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], processo.nome)) {
	                    lista = _.get(_.find(proposta.atividades, ['id', inclusao.atividade.id]), 'itens_orcamentos');
	                  }
	                  if (_.isArray(lista)) {
	                    lista.push(inclusao);
	                  }
	                });
	              });
	            }
	          }
	
	          _this.proposta = _.cloneDeep(proposta);
	          _this.projetoPeriodos = _this.propostaBackup.nr_periodos;
	          _this.ajustesDiversosDadosComplementares();
	
	          _this.$forceUpdate();
	        } else {
	          _this.loading.tela = false;
	          _this.$snotify.error(response.data.mensagem);
	        }
	      }).catch(function (error) {
	        _this.loading.tela = false;
	        _this.$root.trataErro(error);
	      });
	    },
	    ajustesDiversosDadosComplementares: function ajustesDiversosDadosComplementares() {
	      this.buscaCidades();
	      this.buscaEntidades();
	      this.buscaFluxo();
	      this.proposta['projetoAprovado'] = _.has(this.proposta, 'ds_situacao_erp') && !_.isNull(this.proposta.ds_situacao_erp) && !_.includes(['ANA', 'DEF', 'ANU', 'CAN', 'IND', 'ENC', 'DLG', 'JUD', 'OPE'], this.proposta.ds_situacao_erp);
	      this.projetoPeriodos = this.proposta.nr_periodos;
	      this.proposta.totalFBB = this.totalizar('1');
	      this.proposta.totalParc = this.totalizar('5');
	      this.proposta.totalCtrp = this.totalizar('2');
	      this.proposta.totalProjeto = this.proposta.totalFBB + this.proposta.totalParc + this.proposta.totalCtrp;
	      this.dataInicioExecucao = _.includes(['ANA', 'DEF'], this.proposta.ds_situacao_erp) ? this.proposta.dt_data_inicial : this.ehNulo(this.proposta.dt_assinatura_convenio, this.proposta.dt_data_inicial);
	      this.dataFimExecucao = (0, _moment2.default)(this.dataInicioExecucao).add(this.proposta.nr_periodos, 'M').format('MM/YYYY');
	      this.proposta.dataFinal = (0, _moment2.default)(this.ehNulo(this.proposta.dt_assinatura_convenio, this.proposta.dt_data_inicial)).add(this.proposta.nr_periodos, 'M').format('MM/YYYY');
	      this.ganttZoom = parseInt(this.proposta.nr_periodos) > 24 ? 1 - (parseInt(this.proposta.nr_periodos) - 24) * 0.035 : 1;
	      this.equivalenciaPeriodoMesAno();
	
	      for (var a in this.proposta.atividades) {
	        var atv = this.proposta.atividades[a];
	
	        if (_.has(atv, 'itens_orcamentos')) {
	          for (var i in atv.itens_orcamentos) {
	            var ite = atv.itens_orcamentos[i];
	
	            var valorTotal = ite.valor_total + (!_.includes(ite.id, 'novo') ? _.toNumber(_.get(ite, 'valorAlteracao', 0)) : 0);
	
	            var quantidadeTotal = Math.round(parseFloat(ite.quantidade));
	            if ('' + ite.origem === '2') {
	              ite['orcamentos_mensalizados'] = [{
	                'periodo': parseInt(ite.nr_periodo_final),
	                'quantidade': quantidadeTotal,
	                'valor': valorTotal
	              }];
	            } else {
	              if (ite.item['ds_type'] === 'PRODUTO') {
	                ite['orcamentos_mensalizados'] = [{
	                  'periodo': parseInt(_.get(ite, 'periodo_inicial', ite.nr_periodo_inicial)),
	                  'quantidade': quantidadeTotal,
	                  'valor': valorTotal
	                }];
	              } else {
	                var meses = parseInt(_.get(ite, 'periodo_final', ite.nr_periodo_final)) - parseInt(_.get(ite, 'periodo_inicial', ite.nr_periodo_inicial)) + 1;
	                var parcValor = valorTotal / meses;
	                var parcQtde = parseInt(quantidadeTotal / meses);
	                var difValor = valorTotal - parcValor * meses;
	                var difQtde = quantidadeTotal - parcQtde * meses;
	
	                ite['orcamentos_mensalizados'] = [];
	                for (var p = 1; p <= meses; p++) {
	                  var orcMes = {
	                    'periodo': parseInt(_.get(ite, 'periodo_inicial', ite.nr_periodo_inicial)) + p - 1,
	                    'quantidade': p === meses ? parcQtde + difQtde : parcQtde,
	                    'valor': p === meses ? parcValor + difValor : parcValor
	                  };
	                  ite.orcamentos_mensalizados.push(orcMes);
	                }
	              }
	            }
	          }
	        }
	      }
	      this.$forceUpdate();
	      this.carregou = true;
	    },
	    buscaCidades: function buscaCidades() {
	      var _this2 = this;
	
	      this.loading.cidade = true;
	      var lista = _.uniq(_.map(this.proposta.municipalizacao, 'ds_cep'));
	      axiosLaravel.post('projeto/cidades', { 'referencia': 'CEP', 'lista': lista }).then(function (response) {
	        _this2.proposta.municipalizacao.forEach(function (municipio) {
	          var cidade = _.find(response.data, function (cid) {
	            return _.toNumber(municipio.ds_cep) >= _.toNumber(cid.nr_cep_inicio) && _.toNumber(municipio.ds_cep) <= _.toNumber(cid.nr_cep_final);
	          });
	          _.set(municipio, 'ds_uf', cidade.ds_uf);
	        });
	        _this2.loading.cidade = false;
	      }).catch(function (error) {
	        _this2.loading.cidade = false;
	        _this2.$root.trataErro(error);
	      });
	    },
	    somarTotalAtividade: function somarTotalAtividade(atividade) {
	      var total = _.sumBy(atividade.itens_orcamentos, function (a) {
	        var valorItem = 0;
	        if (String(a.id).includes('novo')) {
	          valorItem = _.toNumber(_.get(a, 'valorAlteracao', 0));
	        } else {
	          valorItem = a.valor_total + _.toNumber(_.get(a, 'valorAlteracao', 0));
	        }
	        return valorItem;
	      });
	      return Math.abs(total);
	    },
	    buscaEntidades: function buscaEntidades() {
	      var _this3 = this;
	
	      this.loading.entidade = true;
	      var currentDate = new Date();
	      var hoje = (0, _moment2.default)(currentDate).format('YYYYMMDD');
	      axiosLaravel.get('entidades/' + this.proposta.fk_entidade).then(function (response) {
	        _this3.proposta.entidade = response.data;
	        var codigo = _this3.proposta.entidade.fk_forma_juridica;
	        var descricao = _this3.ehNulo(_.find(_this3.$store.state.formasJuridicas, ['codigo', codigo])['descricao'], '!');
	        _this3.formaJuridica = codigo + ' - ' + descricao;
	        var array = _.filter(response.data.dirigentes, function (o) {
	          if (o.bt_assinatura_entidade === 1 && o.bt_ativo === 1 && o.bt_representante_legal === 1 && o.bt_assinatura_requerida === 1) {
	            var dataInicial = (0, _moment2.default)(o.dt_inicio_mandato).format('YYYYMMDD');
	            var dataFinal = (0, _moment2.default)(o.dt_fim_mandato).format('YYYYMMDD');
	            if (dataInicial <= hoje && hoje <= dataFinal) {
	              return o;
	            }
	          }
	        });
	        _this3.dirigentes = array;
	        _this3.loading.entidade = false;
	        _this3.$forceUpdate;
	      }).catch(function (error) {
	        _this3.loading.entidade = false;
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaFluxo: function buscaFluxo() {
	      var _this4 = this;
	
	      this.loading.fluxo = true;
	      axiosLaravel.post('fluxo/', { 'id_proposta': this.proposta.id, 'atividade': 'SOLICITACAO' }).then(function (response) {
	        _this4.fluxo = response.data;
	        _this4.elementos = _this4.fluxo.elementos;
	        _this4.loading.fluxo = false;
	        _this4.$forceUpdate();
	      }).catch(function (error) {
	        _this4.loading.fluxo = false;
	        _this4.$root.trataErro(error);
	      });
	    },
	    closewindow: function closewindow() {
	      close();
	    },
	    ehNulo: function ehNulo(valor, opcao) {
	      return _.isNull(valor) || _.isNil(valor) || _.isUndefined(valor) ? opcao : valor;
	    },
	    equivalenciaPeriodoMesAno: function equivalenciaPeriodoMesAno() {
	      var inicio = new Date(this.ehNulo(this.proposta.dt_assinatura_convenio, this.proposta.dt_data_inicial).toString());
	      var mes = parseInt(inicio.getMonth() + 1);
	      var ano = parseInt(inicio.getFullYear());
	      for (var p = 1; p <= parseInt(this.proposta.nr_periodos); p++) {
	        this.periodoMesAno.push({ 'periodo': p, 'ano': ano, 'mes': mes });
	        ano += mes === 12 ? 1 : 0;
	        mes += mes === 12 ? -11 : 1;
	      }
	    },
	    haObjetivoMeta: function haObjetivoMeta(listaOrigem, vinculo, descricao) {
	      var c = 0;
	      _.forEach(_.map(listaOrigem, vinculo), function (o) {
	        _.forEach(o, function (d) {
	          c += _.has(d, 'ds_descricao') && d.ds_descricao === descricao || _.has(d, 'descricao') && d.descricao === descricao ? 1 : 0;
	        });
	      });
	      return c > 0;
	    },
	    desembolsoMesAno: function desembolsoMesAno(obj, ano, mes, tipo) {
	      var mesAno = _.find(this.periodoMesAno, { 'ano': parseInt(ano), 'mes': parseInt(mes) });
	      if (_.isUndefined(mesAno)) {
	        return '-';
	      } else {
	        var itens = obj;
	        if (_.has(obj, 'itens_orcamentos')) {
	          itens = obj.itens_orcamentos;
	        }
	
	        if (_.isEmpty(itens) || itens.length === 0) {
	          return '*';
	        } else {
	          if (_.isArray(itens)) {
	            var total = _.sumBy(itens, function (ite) {
	              return _.sumBy(ite.orcamentos_mensalizados, function (iVQ) {
	                return iVQ.periodo === mesAno.periodo ? iVQ[tipo] : 0;
	              });
	            });
	            return total === 0 ? '-' : total;
	          } else {
	            var _total = _.sumBy(obj.orcamentos_mensalizados, function (iVQ) {
	              return iVQ.periodo === mesAno.periodo ? iVQ[tipo] : 0;
	            });
	            return _total === 0 ? '-' : _total;
	          }
	        }
	      }
	    },
	    totalizar: function totalizar(origem) {
	      return this.proposta.atividades.reduce(function (total, atividade) {
	        var somaItens = atividade.itens_orcamentos.reduce(function (soma, item) {
	          if (String(item.id).includes('novo')) {
	            return soma;
	          }
	          return soma + (origem === String(item.origem).substring(0, 1) ? item.valor_total : 0);
	        }, 0);
	        return total + somaItens;
	      }, 0);
	    },
	    mostrarRef: function mostrarRef(ref) {
	      return _.filter(this.elementos, function (item) {
	        return item.nome === ref;
	      }).some(function (item) {
	        return item.visivel;
	      });
	    },
	    irTopo: function irTopo() {
	      var _this5 = this;
	
	      this.$nextTick(function () {
	        _this5.$refs['topo'].scrollIntoView();
	      });
	    },
	    imprimirRelatorio: function imprimirRelatorio() {
	      window.print();
	    },
	    atualizarPrazoExecucao: function atualizarPrazoExecucao(e) {
	      if (e.target.value < this.projetoPeriodos) e.target.value = this.projetoPeriodos;
	      if (e.target.value > this.proposta.periodo_vigencia) e.target.value = this.proposta.periodo_vigencia;
	
	      this.proposta.nr_periodos = parseInt(e.target.value);
	      this.dataInicioExecucao = this.proposta.ds_situacao_erp !== 'ANA' || 'DEF' ? this.proposta.dt_data_inicial : this.ehNulo(this.proposta.dt_assinatura_convenio, this.proposta.dt_data_inicial);
	
	      this.dataFimExecucao = (0, _moment2.default)(this.dataInicioExecucao).add(this.proposta.nr_periodos, 'M').format('MM/YYYY');
	    }
	  }
	};

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _sumula = __webpack_require__(524);
	
	var _sumula2 = _interopRequireDefault(_sumula);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Sumula: _sumula2.default
	  },
	  name: 'solicitacao-alteracoes-projeto-sumula',
	  data: function data() {
	    return {
	      id: null,
	      etapa: 'Solicitação',
	      loading: {
	        tela: false
	      },
	      ehVisualizacao: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {},
	  mounted: function mounted() {},
	  created: function created() {
	    console.clear();
	  },
	
	  methods: {
	    imprimir: function imprimir() {
	      window.print();
	    }
	  }
	};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _cronogramaSolicitacaoContrapartida = __webpack_require__(530);
	
	var _cronogramaSolicitacaoContrapartida2 = _interopRequireDefault(_cronogramaSolicitacaoContrapartida);
	
	var _uploadDocumentosPhp = __webpack_require__(85);
	
	var _uploadDocumentosPhp2 = _interopRequireDefault(_uploadDocumentosPhp);
	
	var _historicoSolicitacaoPagamento = __webpack_require__(107);
	
	var _historicoSolicitacaoPagamento2 = _interopRequireDefault(_historicoSolicitacaoPagamento);
	
	var _historicoAntigo = __webpack_require__(106);
	
	var _historicoAntigo2 = _interopRequireDefault(_historicoAntigo);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosPhp: _uploadDocumentosPhp2.default,
	    HistoricoSolicitacaoPagamento: _historicoSolicitacaoPagamento2.default,
	    CronogramaSolicitacaoContrapartida: _cronogramaSolicitacaoContrapartida2.default,
	    HistoricoAntigo: _historicoAntigo2.default
	  },
	  name: 'form-solicitacao-contrapartida',
	  data: function data() {
	    return {
	      loading: false,
	      loadingShow: false,
	      analiseAutorizacao: ['ANALYSIS', 'MONITORING'],
	      checkedNames: [],
	      validacao: {
	        tarefas: []
	      },
	      nota: {
	        opcoes: ''
	      },
	      item: {},
	      relat: {
	        id: 13,
	        createdAt: null,
	        code: 'FJCF248.GER',
	        codeNames: 'ENumPrj;ECodFor',
	        fieldNames: 'Projeto;Beneficiário/Fornecedor',
	        title: '248 - Monitoramento Administrativo'
	      },
	      data_edicao: '',
	      historicoAnt: [],
	      esconderHistorico: false,
	      etapa: 'Análise',
	      force: 0,
	      historicoTarefas: [],
	      historicoTarefasTela: [],
	      historicoBack: [],
	      proposta: {},
	      motivoDevolucao: '',
	      aprovacao: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    mostraParaValidacaoPagamento: function mostraParaValidacaoPagamento() {
	      return _.includes(this.analiseAutorizacao, this.validacao);
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  props: ['propsNota', 'propsValidacao', 'propsHistorico'],
	  watch: {
	    propsNota: function propsNota() {
	      this.nota = _.cloneDeep(this.propsNota);
	      this.proposta = this.nota.itens_liberados[0].itens_orcamentos[0].proposta;
	      this.numeroProjeto = this.proposta.ds_codigo_projeto_erp;
	    },
	    propsValidacao: function propsValidacao() {
	      this.validacao = _.cloneDeep(this.propsValidacao);
	      this.dataProcesso = (0, _moment2.default)(this.validacao.inicio).format('DD/MM/YYYY');
	      this.validacao.nome = 'CONTRAPARTIDA';
	      this.fase = this.validacao.tarefas[0].nome;
	      this.etapa = this.validacao.tarefas[0].nome;
	      if (this.validacao.documentosLiberacao && this.validacao.documentosLiberacao[0].length === 0) {
	        this.etapa = 'Solicitação';
	      }
	      if (this.validacao.tarefas[0].nome === 'Autorização') {
	        this.etapa = this.validacao.tarefas[0].nome;
	      }
	    },
	    propsHistorico: function propsHistorico() {
	      this.historicoTarefas = _.cloneDeep(this.propsHistorico);
	      this.historicoTarefasTela = _.cloneDeep(this.propsHistorico);
	      var array = this.historicoTarefas.filter(function (item) {
	        return item.tipo === 'Usuário' && !_.isNull(item.termino);
	      });
	      this.historicoTarefas = _.cloneDeep(array);
	      for (var i = 0; i < this.historicoTarefas.length; i++) {
	        if (this.historicoTarefas.usuario !== null) {
	          this.usuario = this.historicoTarefas.usuario;
	        }
	      }
	      var arrayAnt = this.historicoTarefas.filter(function (item) {
	        return item.tipo === 'Usuário' && !_.isNull(item.termino);
	      });
	      this.historicoAnt = arrayAnt;
	    }
	  },
	  created: function created() {
	    this.loadingShow = true;
	  },
	  mounted: function mounted() {
	    this.data_edicao = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	    this.loadingShow = true;
	    this.$snotify.clear();
	    this.force = 0;
	    this.buscaHistorico(this.$route.params.id);
	    this.nota = _.cloneDeep(this.propsNota[0]);
	    this.validacao = _.cloneDeep(this.propsValidacao);
	    var array = this.historicoTarefas.filter(function (item) {
	      return item.tipo === 'Usuário' && !_.isNull(item.termino);
	    });
	    this.historicoTarefas = _.cloneDeep(array);
	    for (var i = 0; i < this.historicoTarefas.length; i++) {
	      if (this.historicoTarefas.usuario !== null) {
	        this.usuario = this.historicoTarefas.usuario;
	      }
	    }
	    this.numeroProjeto = this.proposta.ds_codigo_projeto_erp;
	    this.force = 1;
	    this.loadingShow = false;
	    this.$forceUpdate();
	  },
	
	  methods: {
	    onSave: function onSave() {
	      var _this = this;
	
	      this.incluiMotivo();
	      this.validacao.processo.nome = 'CONTRAPARTIDA';
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this.aprovacao.nota = _this.nota;
	          _this.nota.resultadoAprovacao = _this.aprovacao.resultadoAprovacao;
	          if (_this.validacao.tarefas[0].nome === 'Solicitação') {
	            _this.validacao.proximaEtapa = 'Análise';
	          }
	          if (_this.validacao.tarefas[0].nome === 'Análise') {
	            if (_this.nota.resultadoAprovacao === 'Aprovado') {
	              _this.validacao.proximaEtapa = 'Conclusão';
	            }
	            if (_this.nota.resultadoAprovacao === 'Revisão') {
	              _this.validacao.tarefas[0].observacao = _this.aprovacao.justificativa;
	              _this.validacao.proximaEtapa = 'Revisão';
	            }
	            if (_this.nota.resultadoAprovacao === 'Retornar Análise') {
	              _this.validacao.proximaEtapa = 'Análise';
	            }
	          }
	          if (_this.validacao.tarefas[0].nome === 'Revisão') {
	            _this.validacao.proximaEtapa = 'Análise';
	          }
	
	          _.remove(_this.validacao.receiptApprovals, function (item) {
	            return item.receipt.id === _this.nota.id;
	          });
	
	          if (_this.aprovacao.nota.receiptItems) {
	            var x = 0;
	            var j = 0;
	            for (x = 0; x < _this.aprovacao.nota.itens_liberados.length; x++) {
	              for (j = 0; j < _this.aprovacao.nota.receiptItems.length; j++) {
	                if (_this.aprovacao.nota.itens_liberados[x].itens_orcamentos[0].fk_itens === _this.aprovacao.nota.receiptItems[j].Item) {
	                  _this.aprovacao.nota.itens_liberados[x].quantidade = _this.aprovacao.nota.receiptItems[j].quantityRequest;
	                  _this.aprovacao.nota.itens_liberados[x].valor = _this.aprovacao.nota.receiptItems[j].valueRequest;
	                }
	              }
	            }
	          }
	          _this.validacao.documentos_liberacao = _this.nota;
	          if (_this.validacao.documentos_liberacao.receiptItems) {
	            _this.validacao.documentos_liberacao.itens = _this.validacao.documentos_liberacao.receiptItems;
	          }
	          _this.validacao.proxima_etapa = _this.validacao.proximaEtapa;
	          _this.validacao.tarefas[0].data_edicao = _this.data_edicao;
	          _this.enviaBackEnd();
	        } else {
	          _this.$snotify.error('existem campos com erro favor verificar');
	        }
	      });
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this2 = this;
	
	      this.validacao.processo.nome = 'CONTRAPARTIDA';
	      this.$snotify.clear();
	      this.$aguarde('Validando Solicitação de Contrapartida. Por favor, aguarde...');
	      axiosLaravel.put('processos/tarefas/atualiza/', this.validacao).then(function (response) {
	        _this2.$snotify.clear();
	        if (_.hasIn(response, 'error')) {
	          _this2.$snotify.clear();
	          _this2.$snotify.error(response.data.value.error[0], '', 10000);
	        } else {
	          _this2.$snotify.clear();
	          _this2.$snotify.success('Validação de Contrapartida gravada com sucesso!');
	          setTimeout(function () {
	            _this2.$router.go(-1);
	          }, 2000);
	        }
	      }).catch(function (error) {
	        _this2.$snotify.clear();
	        _this2.$root.trataErro(error);
	      });
	    },
	    voltaPraSolicitacao: function voltaPraSolicitacao() {
	      this.$router.go(-1);
	    },
	    onLoad: function onLoad() {
	      var _this3 = this;
	
	      this.$snotify.clear();
	      this.$aguarde('Gerando relatório. Por favor, aguarde...');
	      axios.put('proxy/utility/erp-report/emit-report', { erpReport: this.relat, params: this.temp }).then(function (response) {
	        _this3.onDownload(response);
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    emitir: function emitir(relatorio) {
	      var _this4 = this;
	
	      var mosDes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loading = true;
	      var parametros = '<ECodEmp=1><ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '>';
	
	      if (relatorio === 219) {
	        parametros += '<ESitPrj=ULT>';
	      } else if (relatorio === 248) {
	        parametros += '<ECodFor=>';
	      }
	
	      if (relatorio === 525) {
	        parametros = '<ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '><EMosDes=' + mosDes + '>';
	      }
	      this.$snotify.clear();
	      console.log('parametros', parametros);
	      var identificacao = relatorio === 525 ? '525 - Extrato ' + (mosDes === 'S' ? 'Analítico' : 'Sintético') : relatorio;
	      this.$aguarde('Gerando relatório ' + identificacao + '. Por favor, aguarde...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': 'FJCF' + relatorio + '.GER' }, params: parametros }).then(function (response) {
	        _this4.onDownload(response, identificacao, _this4);
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.loading = false;
	        _this4.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (!ie) {
	        var blob = file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp + ' - ' + vm.proposta.ds_nome;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	        _link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp + ' - ' + vm.proposta.ds_nome;
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    buscaHistorico: function buscaHistorico(request) {
	      var _this5 = this;
	
	      console.log('caiu aqui historicoBack', request);
	      axiosLaravel.post('historico-tarefas/lista', { 'parametro': request }).then(function (response) {
	        _this5.historicoBack = response.data;
	        console.log('response historicoBack', response.data);
	      });
	    },
	    gravaHistorico: function gravaHistorico(_parm) {},
	    incluiMotivo: function incluiMotivo() {
	      if (this.aprovacao.resultadoAprovacao === 'Revisão') {
	        this.validacao.glosa = '#' + this.motivoDevolucao + '# ' + this.validacao.glosa;
	      }
	    }
	  }
	};

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'cronograma-solicitacao-pagamento',
	  data: function data() {
	    return {
	      itemsProjetoIgualNota: [],
	      itensProjeto: [],
	      componentKey: 0,
	      totais: {
	        valor_total_contratado: 0
	      },
	      total: 0
	    };
	  },
	
	  props: ['propsNota', 'propsProjeto', 'propsEtapa', 'propsValidacao'],
	  computed: {
	    saldoFinanceiroProjeto: function saldoFinanceiroProjeto() {
	      return this.itensProjeto.reduce(function (total, item) {
	        return total + (item.totalValue - item.totalvalorSolicitadoed);
	      }, 0);
	    }
	  },
	  created: function created() {
	    this.valorTotalSolicitacao();
	    this.forceRerender();
	  },
	
	  watch: {
	    propsProjeto: function propsProjeto() {
	      this.buscaItensProjetoBackEnd();
	    }
	  },
	  methods: {
	    valorTotalSolicitacao: function valorTotalSolicitacao() {
	      var total = 0;
	      if (this.itensProjeto) {
	        this.itensProjeto.forEach(function (item) {
	          if (item.valorSolicitado) {
	            total += item.valorSolicitado;
	          }
	        });
	      }
	      this.total = total;
	    },
	    forceRerender: function forceRerender() {
	      this.componentKey += 1;
	    },
	    cancelaEdicao: function cancelaEdicao(item) {
	      if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0' || item.quantidadeSolicitada === '') {
	        this.$snotify.error('Quantidade solicitada não pode ser 0!');
	        return;
	      }
	      if (item.valorSolicitado === 0 || item.valorSolicitado === '0' || item.valorSolicitado === '') {
	        this.$snotify.error('Valor solicitado não pode ser 0!');
	        return;
	      }
	      if (item.quantidadeSolicitada > item.Qtde_saldo) {
	        this.$snotify.error('Quantidade solicitada maior que o disponível!');
	        return;
	      }
	      if (item.valorSolicitado > item.Valor_saldo) {
	        this.$snotify.error('Valor solicitado maior que o disponível!');
	        return;
	      }
	      item.editing = false;
	      item = [];
	      this.$forceUpdate();
	    },
	    editItem: function editItem(item, parm) {
	      if (parm === 2) {
	        if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0' || item.quantidadeSolicitada === '') {
	          this.$snotify.error('Quantidade solicitada não pode ser 0!');
	          return;
	        }
	        if (item.valorSolicitado === 0 || item.valorSolicitado === '0' || item.valorSolicitado === '') {
	          this.$snotify.error('Valor solicitado não pode ser 0!');
	          return;
	        }
	      }
	      this.total = 0;
	      if (this.propsEtapa === 'Solicitação') {
	        if (item.quantidadeSolicitada > item.Qtde_saldo) {
	          this.$snotify.error('Quantidade solicitada maior que o disponível!');
	          item.quantidadeSolicitada = 0;
	        }
	        if (item.valorSolicitado > item.Valor_saldo) {
	          this.$snotify.error('Valor solicitado maior que o disponível!');
	          item.valorSolicitado = 0;
	        }
	        if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0') {
	          this.$snotify.error('Quantidade solicitada tem que ser maior que zero!');
	          return;
	        }
	        if (item.valorSolicitado === 0) {
	          this.$snotify.error('Valor solicitado tem que ser maior que zero!');
	          return;
	        }
	      }
	      if (!item.editing) {
	        item.editing = true;
	      } else {
	        item.editing = !item.editing;
	        if (!_.hasIn(this.propsNota, 'receiptItems')) {
	          this.propsNota.receiptItems = [];
	          this.propsNota.receiptItems.push(item);
	        }
	        if (this.propsNota.receiptItems.indexOf(item) === -1) this.propsNota.receiptItems.push(item);
	      }
	      if (this.propsNota.receiptItems) {
	        for (var j = 0; j < this.propsNota.receiptItems.length; j++) {
	          if (this.propsNota.receiptItems[j].valorSolicitado > 0) {
	            this.total = this.total + this.propsNota.receiptItems[j].valorSolicitado;
	          }
	        }
	      }
	      this.valorTotalSolicitacao();
	      this.$forceUpdate();
	      this.forceRerender();
	    },
	    apagaItem: function apagaItem(item) {
	      console.log(item);
	      item.quantidadeSolicitada = '';
	      item.valorSolicitado = '';
	      console.log(this.propsNota.receiptItems);
	      var pos = this.propsNota.receiptItems.indexOf(item);
	      console.log(this.propsNota.receiptItems.indexOf(item));
	      this.propsNota.receiptItems.splice(pos, 1);
	      console.log(this.propsNota.receiptItems);
	      this.valorTotalSolicitacao();
	    },
	    buscaItensProjetoBackEnd: function buscaItensProjetoBackEnd() {
	      var _this = this;
	
	      if (!this.propsProjeto.Id_projeto) {
	        this.propsProjeto.Id_projeto = this.propsProjeto.id;
	      }
	      this.buscaRecursos();
	      var documento = 0;
	      if (this.propsNota.id) {
	        documento = this.propsNota.id;
	      }
	      this.loadingShow = true;
	      this.$forceUpdate();
	      this.$aguarde('Carregando cronograma do projeto. Por favor, aguarde...');
	      var idProposta = _.isUndefined(this.propsProjeto.Id_proposta) ? this.propsProjeto.fk_proposta : this.propsProjeto.Id_proposta;
	      axiosLaravel.post('processos/cronograma/projeto/', { 'proposta': idProposta, 'processo': 'CONTRAPARTIDA', 'aglutinado': 'Não', 'documento': documento }).then(function (response) {
	        _this.itensProjeto = response.data.itens;
	        _this.$forceUpdate();
	        _this.loadingShow = false;
	        _this.$snotify.clear();
	        var projFiltro = [];
	        _this.totais = response.data.totais;
	        if (_this.propsEtapa) {
	          var i = 0;
	          var j = 0;
	          for (i = 0; i < _this.itensProjeto.length; i++) {
	            for (j = 0; j < _this.propsNota.itens_liberados.length; j++) {
	              if (_this.itensProjeto[i].Id_item === _this.propsNota.itens_liberados[j].itens_orcamentos[0].id) {
	                projFiltro[j] = _this.itensProjeto[i];
	              }
	            }
	          }
	          _this.itensProjeto = _.cloneDeep(projFiltro);
	        }
	        _this.$forceUpdate();
	        _this.preencheCronograma();
	        _this.valorTotalSolicitacao();
	        _this.$forceUpdate();
	        _this.forceRerender();
	        _this.$forceUpdate();
	        _this.loadingShow = false;
	        _this.$snotify.clear();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this.$root.trataErro(error);
	      });
	    },
	    marcaItem: function marcaItem(item) {
	      this.marcado = 1;
	      if (item.Economicidade === true) {
	        item.Economicidade = 1;
	      } else {
	        item.Economicidade = 0;
	      }
	    },
	    buscaRecursos: function buscaRecursos() {
	      var _this2 = this;
	
	      this.totalFBB = 0;
	      this.totalFaseFBB = 0;
	      this.adiantadoFaseFBB = 0;
	      this.saldoFaseFBB = 0;
	      this.totalPAR = 0;
	      this.totalFasePAR = 0;
	      this.adiantadoFasePAR = 0;
	      this.saldoFasePAR = 0;
	      var idProposta = _.isUndefined(this.propsProjeto.Id_proposta) ? this.propsProjeto.fk_proposta : this.propsProjeto.Id_proposta;
	      axiosLaravel.get('processos/adiantamento/recursos/' + idProposta).then(function (response) {
	        _this2.resultado = response.data.parcels.row;
	        for (var i = 0; i < _this2.resultado.length; i++) {
	          if (_this2.resultado[i].resourceSource === 'FUNDACAO') {
	            _this2.totalFBB = _this2.totalFBB + _this2.resultado[i].totalValue;
	            _this2.totalFaseFBB = _this2.totalFaseFBB + _this2.resultado[i].totalValueAdvance;
	            _this2.adiantadoFaseFBB = _this2.adiantadoFaseFBB + _this2.resultado[i].totalValueAdvanceRequested;
	            _this2.saldoFaseFBB = _this2.saldoFaseFBB + _this2.resultado[i].balanceAdvanceAccumulated;
	          }
	          if (_this2.resultado[i].resourceSource === 'PARCEIRO_ESTRATEGICO') {
	            _this2.totalPAR += parseFloat(_this2.resultado[i].totalValue);
	            _this2.totalFasePAR += parseFloat(_this2.resultado[i].totalValueAdvance);
	            _this2.adiantadoFasePAR += parseFloat(_this2.resultado[i].totalValueAdvanceRequested);
	            _this2.saldoFasePAR += parseFloat(_this2.resultado[i].balanceAdvanceAccumulated);
	          }
	        }
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    preencheCronograma: function preencheCronograma() {
	      var _this3 = this;
	
	      var i = 0;
	      var j = 0;
	      if (!_.isUndefined(this.propsNota.receiptItems)) {
	        this.itensProjeto.forEach(function (item, index) {
	          if (item.Item === _this3.propsNota.receiptItems[0].Item) {
	            _this3.itensProjeto[index] = _this3.propsNota.receiptItems[0];
	            _this3.$forceUpdate();
	          }
	        });
	      }
	      if (this.propsNota.itens_liberados) {
	        for (i = 0; i < this.itensProjeto.length; i++) {
	          for (j = 0; j < this.propsNota.itens_liberados.length; j++) {
	            if (this.propsNota.itens_liberados[j].itens_orcamentos[0].fk_itens === this.itensProjeto[i].Item) {
	              this.itensProjeto[i].quantidadeSolicitada = this.itensProjeto[i].Qtde_solicitado;
	              this.itensProjeto[i].valorSolicitado = this.itensProjeto[i].Valor_solicitado;
	            }
	          }
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cronograma-solicitacao-pagamento',
	  data: function data() {
	    return {
	      itemsProjetoIgualNota: [],
	      itensProjeto: [],
	      totais: []
	    };
	  },
	
	  props: ['propsNota', 'propsProjeto', 'propsEtapa', 'propsValidacao'],
	  computed: {
	    valorTotalSolicitacao: function valorTotalSolicitacao() {
	      var total = 0;
	      var i;
	      if (this.itensProjeto) {
	        for (i = 0; i < this.itensProjeto.length; i++) {
	          if (this.itensProjeto[i] !== null) {
	            if (this.itensProjeto[i].valorSolicitado) {
	              total = total + this.itensProjeto[i].valorSolicitado;
	            }
	          }
	        }
	      }
	      this.total = total;
	    },
	    saldoFinanceiroProjeto: function saldoFinanceiroProjeto() {
	      return this.itensProjeto.reduce(function (total, item) {
	        return total + (item.totalValue - item.totalvalorSolicitadoed);
	      }, 0);
	    }
	  },
	  watch: {
	    propsProjeto: function propsProjeto() {
	      this.buscaItensProjetoBackEnd();
	    }
	  },
	  methods: {
	    cancelaEdicao: function cancelaEdicao(item) {
	      if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0' || item.quantidadeSolicitada === '') {
	        this.$snotify.error('Quantidade solicitada não pode ser 0!');
	        return;
	      }
	      if (item.valorSolicitado === 0 || item.valorSolicitado === '0' || item.valorSolicitado === '') {
	        this.$snotify.error('Valor solicitado não pode ser 0!');
	        return;
	      }
	      if (item.quantidadeSolicitada > item.Qtde_saldo) {
	        this.$snotify.error('Quantidade solicitada maior que o disponível!');
	        return;
	      }
	      if (item.valorSolicitado > item.Valor_saldo) {
	        this.$snotify.error('Valor solicitado maior que o disponível!');
	        return;
	      }
	      item.editing = false;
	      item = [];
	      this.$forceUpdate();
	    },
	    editItem: function editItem(item, parm) {
	      if (parm === 2) {
	        if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0' || item.quantidadeSolicitada === '') {
	          this.$snotify.error('Quantidade solicitada não pode ser 0!');
	          return;
	        }
	        if (item.valorSolicitado === 0 || item.valorSolicitado === '0' || item.valorSolicitado === '') {
	          this.$snotify.error('Valor solicitado não pode ser 0!');
	          return;
	        }
	        this.$forceUpdate();
	      }
	      this.total = 0;
	      if (this.propsEtapa === 'Solicitação') {
	        if (item.quantidadeSolicitada > item.Qtde_saldo) {
	          this.$snotify.error('Quantidade solicitada maior que o disponível!');
	          item.quantidadeSolicitada = 0;
	        }
	        if (item.valorSolicitado > item.Valor_saldo) {
	          this.$snotify.error('Valor solicitado maior que o disponível!');
	          item.valorSolicitado = 0;
	        }
	        if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0' || item.quantidadeSolicitada === '') {
	          this.$snotify.error('Quantidade solicitada tem que ser maior que zero!');
	          return;
	        }
	        if (item.valorSolicitado === 0 || item.valorSolicitado === '') {
	          this.$snotify.error('Valor solicitado tem que ser maior que zero!');
	          return;
	        }
	      }
	      if (!item.editing) {
	        item.editing = true;
	      } else {
	        item.editing = !item.editing;
	        if (!_.hasIn(this.propsNota, 'receiptItems')) {
	          this.propsNota.receiptItems = [];
	          this.propsNota.receiptItems.push(item);
	        }
	        if (this.propsNota.receiptItems.indexOf(item) === -1) {
	          this.propsNota.receiptItems.push(item);
	        }
	      }
	      if (this.propsNota.receiptItems) {
	        for (var j = 0; j < this.propsNota.receiptItems.length; j++) {
	          if (this.propsNota.receiptItems[j].valorSolicitado > 0) {
	            this.total = this.total + this.propsNota.receiptItems[j].valorSolicitado;
	          }
	        }
	      }
	      this.$forceUpdate();
	    },
	    buscaItensProjetoBackEnd: function buscaItensProjetoBackEnd() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var documento, idProposta;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!_this.propsProjeto.Id_projeto) {
	                  _this.propsProjeto.Id_projeto = _this.propsProjeto.id;
	                }
	                _this.buscaRecursos();
	                documento = 0;
	
	
	                if (_this.propsNota.id) {
	                  documento = _this.propsNota.id;
	                }
	                _this.itensProjeto = [];
	                _this.loadingShow = true;
	                _this.$forceUpdate();
	                _this.$aguarde('Carregando cronograma do projeto. Por favor, aguarde...');
	                idProposta = _.isUndefined(_this.propsProjeto.Id_proposta) ? _this.propsProjeto.fk_proposta : _this.propsProjeto.Id_proposta;
	                _context.next = 11;
	                return axiosLaravel.post('processos/cronograma/projeto/', { 'proposta': idProposta, 'processo': 'PAGAMENTO', 'aglutinado': 'Não', 'documento': documento }).then(function (response) {
	                  _this.itensProjeto = response.data.itens;
	                  _this.propsValidacao.aglutinado = response.data.totais.aglutinado;
	                  _this.$forceUpdate();
	                  _this.loadingShow = false;
	                  if (_this.propsEtapa !== 'Solicitação') {
	                    _this.itensProjeto = _this.itensProjeto.filter(function (item) {
	                      return item.Valor_solicitado > 0;
	                    });
	                  }
	                  var projFiltro = [];
	                  _this.totais = response.data.totais;
	                  if (_this.propsEtapa) {
	                    for (var i = 0; i < _this.itensProjeto.length; i++) {
	                      for (var j = 0; j < _this.propsNota.itens_liberados.length; j++) {
	                        if (_this.itensProjeto[i].Id_item === _this.propsNota.itens_liberados[j].itens_orcamentos[0].id) {
	                          projFiltro[j] = _this.itensProjeto[i];
	                        }
	                      }
	                    }
	                    if (_this.totais.aglutinado === 'Não') {
	                      _this.itensProjeto = _.cloneDeep(projFiltro);
	                    }
	                  }
	
	                  _this.itensProjeto = _this.itensProjeto.map(function (item) {
	                    item.valorSolicitado = item.Valor_solicitado;
	                    item.quantidadeSolicitada = item.Qtde_solicitado;
	                    return item;
	                  });
	                  _this.valorTotalSolicitacao();
	                  _this.$forceUpdate();
	                  _this.$snotify.clear();
	                  _this.$snotify.success('Cronograma carregado com sucesso!');
	                }).catch(function (error) {
	                  _this.$snotify.clear();
	                  console.log('error', error);
	                  _this.$root.trataErro(error);
	                });
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    buscaRecursos: function buscaRecursos() {
	      var _this2 = this;
	
	      this.totalFBB = 0;
	      this.totalFaseFBB = 0;
	      this.adiantadoFaseFBB = 0;
	      this.saldoFaseFBB = 0;
	      this.totalPAR = 0;
	      this.totalFasePAR = 0;
	      this.adiantadoFasePAR = 0;
	      this.saldoFasePAR = 0;
	      var idProposta = _.isUndefined(this.propsProjeto.Id_proposta) ? this.propsProjeto.fk_proposta : this.propsProjeto.Id_proposta;
	      axiosLaravel.get('processos/adiantamento/recursos/' + idProposta).then(function (response) {
	        _this2.resultado = response.data.parcels.row;
	        for (var i = 0; i < _this2.resultado.length; i++) {
	          if (_this2.resultado[i].resourceSource === 'FUNDACAO') {
	            _this2.totalFBB = _this2.totalFBB + _this2.resultado[i].totalValue;
	            _this2.totalFaseFBB = _this2.totalFaseFBB + _this2.resultado[i].totalValueAdvance;
	            _this2.adiantadoFaseFBB = _this2.adiantadoFaseFBB + _this2.resultado[i].totalValueAdvanceRequested;
	            _this2.saldoFaseFBB = _this2.saldoFaseFBB + _this2.resultado[i].balanceAdvanceAccumulated;
	          }
	          if (_this2.resultado[i].resourceSource === 'PARCEIRO_ESTRATEGICO') {
	            _this2.totalPAR += parseFloat(_this2.resultado[i].totalValue);
	            _this2.totalFasePAR += parseFloat(_this2.resultado[i].totalValueAdvance);
	            _this2.adiantadoFasePAR += parseFloat(_this2.resultado[i].totalValueAdvanceRequested);
	            _this2.saldoFasePAR += parseFloat(_this2.resultado[i].balanceAdvanceAccumulated);
	          }
	        }
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    preencheCronograma: function preencheCronograma() {
	      var _this3 = this;
	
	      var i = 0;
	      var j = 0;
	      if (!_.isUndefined(this.propsNota.receiptItems)) {
	        this.itensProjeto.forEach(function (item, index) {
	          if (item.Item === _this3.propsNota.receiptItems[0].Item) {
	            _this3.itensProjeto[index] = _this3.propsNota.receiptItems[0];
	            _this3.$forceUpdate();
	          }
	        });
	      }
	      if (this.propsNota.itens_liberados) {
	        for (i = 0; i < this.itensProjeto.length; i++) {
	          for (j = 0; j < this.propsNota.itens_liberados.length; j++) {
	            if (this.propsNota.itens_liberados[j].itens_orcamentos[0].fk_itens === this.itensProjeto[i].Item) {
	              this.itensProjeto[i].quantidadeSolicitada = this.propsNota.itens_liberados[j].quantidade;
	              this.itensProjeto[i].valorSolicitado = this.propsNota.itens_liberados[j].valor;
	              if (_.isUndefined(this.propsNota.receiptItems)) {
	                this.propsNota.receiptItems = [];
	              }
	              this.propsNota.receiptItems.push(this.itensProjeto[i]);
	            }
	          }
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cronograma-solicitacao-prestacaocontas',
	  data: function data() {
	    return {
	      itemsProjetoIgualNota: [],
	      itensProjeto: [],
	      totais: []
	    };
	  },
	
	  props: ['propsNota', 'propsProjeto', 'propsEtapa', 'propsValidacao'],
	  computed: {
	    saldoFinanceiroProjeto: function saldoFinanceiroProjeto() {
	      return this.itensProjeto.reduce(function (total, item) {
	        return total + (item.totalValue - item.totalvalorSolicitadoed);
	      }, 0);
	    },
	    valorTotalSolicitacao: function valorTotalSolicitacao() {
	      var total = 0;
	      if (this.itensProjeto) {
	        this.itensProjeto.forEach(function (item) {
	          if (item.valorSolicitado) {
	            total += item.valorSolicitado;
	          }
	        });
	      }
	      return total.toFixed(2);
	    }
	  },
	  watch: {
	    propsProjeto: function propsProjeto() {
	      this.buscaItensProjetoBackEnd();
	    }
	  },
	  methods: {
	    cancelaEdicao: function cancelaEdicao(item) {
	      if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0' || item.quantidadeSolicitada === '') {
	        this.$snotify.error('Quantidade solicitada não pode ser 0!');
	        return;
	      }
	      if (item.valorSolicitado === 0 || item.valorSolicitado === '0' || item.valorSolicitado === '') {
	        this.$snotify.error('Valor solicitado não pode ser 0!');
	        return;
	      }
	      if (item.quantidadeSolicitada > item.Qtde_saldo) {
	        this.$snotify.error('Quantidade solicitada maior que o disponível!');
	        return;
	      }
	      if (item.valorSolicitado > item.Valor_saldo) {
	        this.$snotify.error('Valor solicitado maior que o disponível!');
	        return;
	      }
	      item.editing = false;
	      item = [];
	      this.$forceUpdate();
	    },
	    editItem: function editItem(item, parm) {
	      if (parm === 2) {
	        if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0' || item.quantidadeSolicitada === '') {
	          this.$snotify.error('Quantidade solicitada não pode ser 0!');
	          return;
	        }
	        if (item.valorSolicitado === 0 || item.valorSolicitado === '0' || item.valorSolicitado === '') {
	          this.$snotify.error('Valor solicitado não pode ser 0!');
	          return;
	        }
	      }
	      this.total = 0;
	      if (this.propsEtapa === 'Solicitação') {
	        if (item.quantidadeSolicitada > item.Qtde_saldo) {
	          this.$snotify.error('Quantidade solicitada maior que o disponível!');
	          return;
	        }
	        if (item.valorSolicitado > item.Valor_saldo) {
	          this.$snotify.error('Valor solicitado maior que o disponível!');
	          return;
	        }
	        if (item.quantidadeSolicitada === 0 || item.quantidadeSolicitada === '0' || item.quantidadeSolicitada === '') {
	          this.$snotify.error('Quantidade solicitada tem que ser maior que zero!');
	          return;
	        }
	        if (item.valorSolicitado === 0 || item.valorSolicitado === '') {
	          this.$snotify.error('Valor solicitado tem que ser maior que zero!');
	          return;
	        }
	      }
	      if (!item.editing) {
	        item.editing = true;
	      } else {
	        item.editing = !item.editing;
	        if (!_.hasIn(this.propsNota, 'receiptItems')) {
	          this.propsNota.receiptItems = [];
	          this.propsNota.receiptItems.push(item);
	        }
	        if (this.propsNota.receiptItems.indexOf(item) === -1) {
	          this.propsNota.receiptItems.push(item);
	        }
	      }
	      if (this.propsNota.receiptItems) {
	        for (var j = 0; j < this.propsNota.receiptItems.length; j++) {
	          if (this.propsNota.receiptItems[j].valorSolicitado > 0) {
	            this.total = this.total + this.propsNota.receiptItems[j].valorSolicitado;
	          }
	        }
	      }
	      this.$forceUpdate();
	    },
	    buscaItensProjetoBackEnd: function buscaItensProjetoBackEnd() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var documento, idProposta;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!_this.propsProjeto.Id_projeto) {
	                  _this.propsProjeto.Id_projeto = _this.propsProjeto.id;
	                }
	                _this.buscaRecursos();
	                documento = 0;
	
	
	                if (_this.propsNota.id) {
	                  documento = _this.propsNota.id;
	                }
	                _this.itensProjeto = [];
	                _this.loadingShow = true;
	                _this.$forceUpdate();
	                _this.$aguarde('Carregando cronograma do projeto. Por favor, aguarde...');
	                idProposta = _.isUndefined(_this.propsProjeto.Id_proposta) ? _this.propsProjeto.fk_proposta : _this.propsProjeto.Id_proposta;
	                _context.next = 11;
	                return axiosLaravel.post('processos/cronograma/projeto/', { 'proposta': idProposta, 'processo': 'PRESTACAO_DE_CONTAS', 'aglutinado': 'Não', 'documento': documento }).then(function (response) {
	                  _this.itensProjeto = response.data.itens;
	                  _this.propsValidacao.aglutinado = response.data.totais.aglutinado;
	                  _this.$forceUpdate();
	                  _this.loadingShow = false;
	                  if (_this.propsEtapa !== 'Solicitação') {
	                    _this.itensProjeto = _this.itensProjeto.filter(function (item) {
	                      return item.Valor_solicitado > 0;
	                    });
	                  }
	                  var projFiltro = [];
	                  _this.totais = response.data.totais;
	                  if (_this.propsEtapa) {
	                    for (var i = 0; i < _this.itensProjeto.length; i++) {
	                      for (var j = 0; j < _this.propsNota.itens_liberados.length; j++) {
	                        if (_this.itensProjeto[i].Id_item === _this.propsNota.itens_liberados[j].itens_orcamentos[0].id) {
	                          projFiltro[j] = _this.itensProjeto[i];
	                        }
	                      }
	                    }
	                    if (_this.totais.aglutinado === 'Não') {
	                      _this.itensProjeto = _.cloneDeep(projFiltro);
	                    }
	                  }
	
	                  _this.itensProjeto = _this.itensProjeto.map(function (item) {
	                    item.valorSolicitado = item.Valor_solicitado;
	                    item.quantidadeSolicitada = item.Qtde_solicitado;
	                    return item;
	                  });
	                  _this.$forceUpdate();
	                  _this.$snotify.clear();
	                  _this.$snotify.success('Cronograma carregado com sucesso!');
	                }).catch(function (error) {
	                  _this.$snotify.clear();
	                  console.log('error', error);
	                  _this.$root.trataErro(error);
	                });
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    buscaRecursos: function buscaRecursos() {
	      var _this2 = this;
	
	      this.totalFBB = 0;
	      this.totalFaseFBB = 0;
	      this.adiantadoFaseFBB = 0;
	      this.saldoFaseFBB = 0;
	      this.totalPAR = 0;
	      this.totalFasePAR = 0;
	      this.adiantadoFasePAR = 0;
	      this.saldoFasePAR = 0;
	      axiosLaravel.get('processos/adiantamento/recursos/' + this.propsProjeto.Id_proposta).then(function (response) {
	        _this2.resultado = response.data.parcels.row;
	        for (var i = 0; i < _this2.resultado.length; i++) {
	          if (_this2.resultado[i].resourceSource === 'FUNDACAO') {
	            _this2.totalFBB = _this2.totalFBB + _this2.resultado[i].totalValue;
	            _this2.totalFaseFBB = _this2.totalFaseFBB + _this2.resultado[i].totalValueAdvance;
	            _this2.adiantadoFaseFBB = _this2.adiantadoFaseFBB + _this2.resultado[i].totalValueAdvanceRequested;
	            _this2.saldoFaseFBB = _this2.saldoFaseFBB + _this2.resultado[i].balanceAdvanceAccumulated;
	          }
	          if (_this2.resultado[i].resourceSource === 'PARCEIRO_ESTRATEGICO') {
	            _this2.totalPAR += parseFloat(_this2.resultado[i].totalValue);
	            _this2.totalFasePAR += parseFloat(_this2.resultado[i].totalValueAdvance);
	            _this2.adiantadoFasePAR += parseFloat(_this2.resultado[i].totalValueAdvanceRequested);
	            _this2.saldoFasePAR += parseFloat(_this2.resultado[i].balanceAdvanceAccumulated);
	          }
	        }
	        _this2.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    preencheCronograma: function preencheCronograma() {
	      var _this3 = this;
	
	      var i = 0;
	      var j = 0;
	      if (!_.isUndefined(this.propsNota.receiptItems)) {
	        this.itensProjeto.forEach(function (item, index) {
	          if (item.Item === _this3.propsNota.receiptItems[0].Item) {
	            _this3.itensProjeto[index] = _this3.propsNota.receiptItems[0];
	            _this3.$forceUpdate();
	          }
	        });
	      }
	      if (this.propsNota.itens_liberados) {
	        for (i = 0; i < this.itensProjeto.length; i++) {
	          for (j = 0; j < this.propsNota.itens_liberados.length; j++) {
	            if (this.propsNota.itens_liberados[j].itens_orcamentos[0].fk_itens === this.itensProjeto[i].Item) {
	              this.itensProjeto[i].quantidadeSolicitada = this.propsNota.itens_liberados[j].quantidade;
	              this.itensProjeto[i].valorSolicitado = this.propsNota.itens_liberados[j].valor;
	              if (_.isUndefined(this.propsNota.receiptItems)) {
	                this.propsNota.receiptItems = [];
	              }
	              this.propsNota.receiptItems.push(this.itensProjeto[i]);
	            }
	          }
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dados-bancarios',
	  data: function data() {
	    return {
	      nota: {
	        dados_bancarios: {}
	      },
	      customTokens: {
	        '#': { pattern: /\d/ },
	        'X': { pattern: /[0-9x-xX-X]/, transform: function transform(v) {
	            return v.toUpperCase();
	          } }
	      },
	      bancosMain: [{ value: '001', label: 'Banco do Brasil S.A.' }, { value: '033', label: 'BANCO SANTANDER (BRASIL) S.A.' }, { value: '070', label: 'BRB – BANCO DE BRASILIA S.A.' }, { value: '104', label: 'CAIXA ECONOMICA FEDERAL' }, { value: '237', label: 'Banco Bradesco S.A.' }, { value: '341', label: 'ITAÚ UNIBANCO S.A.' }],
	      bancos: [{ value: '332', label: 'Acesso Soluções de Pagamento S.A.' }, { value: '117', label: 'ADVANCED CORRETORA DE CÂMBIO LTDA' }, { value: '272', label: 'AGK CORRETORA DE CAMBIO S.A.' }, { value: '349', label: 'AL5 S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { value: '313', label: 'AMAZÔNIA CORRETORA DE CÂMBIO LTDA.' }, { value: '188', label: 'ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS, CÂMBIO E VALORES' }, { value: '280', label: 'Avista S.A. Crédito, Financiamento e Investimento' }, { value: '080', label: 'B&T CORRETORA DE CAMBIO LTDA.' }, { value: '246', label: 'Banco ABC Brasil S.A.' }, { value: '075', label: 'Banco ABN Amro S.A.' }, { value: '121', label: 'Banco Agibank S.A.' }, { value: '025', label: 'Banco Alfa S.A.' }, { value: '065', label: 'Banco AndBank (Brasil) S.A.' }, { value: '213', label: 'Banco Arbi S.A.' }, { value: '096', label: 'Banco B3 S.A.' }, { value: '024', label: 'Banco Bandepe S.A.' }, { value: '330', label: 'BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.' }, { value: '318', label: 'Banco BMG S.A.' }, { value: '752', label: 'Banco BNP Paribas Brasil S.A.' }, { value: '107', label: 'Banco Bocom BBM S.A.' }, { value: '063', label: 'Banco Bradescard S.A.' }, { value: '036', label: 'Banco Bradesco BBI S.A.' }, { value: '122', label: 'Banco Bradesco BERJ S.A.' }, { value: '394', label: 'Banco Bradesco Financiamentos S.A.' }, { value: '218', label: 'Banco BS2 S.A.' }, { value: '208', label: 'Banco BTG Pactual S.A.' }, { value: '626', label: 'BANCO C6 CONSIGNADO S.A.' }, { value: '336', label: 'Banco C6 S.A.' }, { value: '473', label: 'Banco Caixa Geral – Brasil S.A.' }, { value: '412', label: 'BANCO CAPITAL S.A.' }, { value: '040', label: 'Banco Cargill S.A.' }, { value: '266', label: 'BANCO CEDULA S.A.' }, { value: '739', label: 'Banco Cetelem S.A.' }, { value: '233', label: 'Banco Cifra S.A.' }, { value: '745', label: 'Banco Citibank S.A.' }, { value: '241', label: 'BANCO CLASSICO S.A.' }, { value: '756', label: 'BANCO COOPERATIVO DO BRASIL S.A. – BANCOOB' }, { value: '748', label: 'BANCO COOPERATIVO SICREDI S.A.' }, { value: '222', label: 'BANCO CRÉDIT AGRICOLE BRASIL S.A.' }, { value: '505', label: 'Banco Credit Suisse (Brasil) S.A.' }, { value: '069', label: 'Banco Crefisa S.A.' }, { value: '368', label: 'Banco CSF S.A.' }, { value: '003', label: 'BANCO DA AMAZONIA S.A.' }, { value: '083', label: 'Banco da China Brasil S.A.' }, { value: '707', label: 'Banco Daycoval S.A.' }, { value: '300', label: 'Banco de la Nacion Argentina' }, { value: '495', label: 'Banco de La Provincia de Buenos Aires' }, { value: '654', label: 'BANCO DIGIMAIS S.A.' }, { value: '335', label: 'Banco Digio S.A.' }, { value: '047', label: 'Banco do Estado de Sergipe S.A.' }, { value: '037', label: 'Banco do Estado do Pará S.A.' }, { value: '041', label: 'Banco do Estado do Rio Grande do Sul S.A.' }, { value: '004', label: 'Banco do Nordeste do Brasil S.A.' }, { value: '265', label: 'Banco Fator S.A.' }, { value: '224', label: 'Banco Fibra S.A.' }, { value: '094', label: 'Banco Finaxis S.A.' }, { value: '390', label: 'BANCO GM S.A.' }, { value: '612', label: 'Banco Guanabara S.A.' }, { value: '269', label: 'BANCO HSBC S.A.' }, { value: '012', label: 'Banco Inbursa S.A.' }, { value: '604', label: 'Banco Industrial do Brasil S.A.' }, { value: '653', label: 'BANCO INDUSVAL S.A.' }, { value: '077', label: 'Banco Inter S.A.' }, { value: '249', label: 'Banco Investcred Unibanco S.A.' }, { value: '184', label: 'Banco Itaú BBA S.A.' }, { value: '029', label: 'Banco Itaú Consignado S.A.' }, { value: '479', label: 'Banco ItauBank S.A.' }, { value: '074', label: 'Banco J. Safra S.A.' }, { value: '376', label: 'BANCO J.P. MORGAN S.A.' }, { value: '217', label: 'Banco John Deere S.A.' }, { value: '076', label: 'Banco KDB do Brasil S.A.' }, { value: '757', label: 'BANCO KEB HANA DO BRASIL S.A.' }, { value: '600', label: 'Banco Luso Brasileiro S.A.' }, { value: '243', label: 'Banco Máxima S.A.' }, { value: '389', label: 'Banco Mercantil do Brasil S.A.' }, { value: '381', label: 'BANCO MERCEDES-BENZ DO BRASIL S.A.' }, { value: '370', label: 'Banco Mizuho do Brasil S.A.' }, { value: '746', label: 'Banco Modal S.A.' }, { value: '066', label: 'BANCO MORGAN STANLEY S.A.' }, { value: '456', label: 'Banco MUFG Brasil S.A.' }, { value: '007', label: 'BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL' }, { value: '169', label: 'BANCO OLÉ CONSIGNADO S.A.' }, { value: '079', label: 'Banco Original do Agronegócio S.A.' }, { value: '212', label: 'Banco Original S.A.' }, { value: '712', label: 'Banco Ourinvest S.A.' }, { value: '623', label: 'Banco Pan S.A.' }, { value: '611', label: 'Banco Paulista S.A.' }, { value: '643', label: 'Banco Pine S.A.' }, { value: '747', label: 'Banco Rabobank International Brasil S.A.' }, { value: '088', label: 'BANCO RANDON S.A.' }, { value: '633', label: 'Banco Rendimento S.A.' }, { value: '741', label: 'BANCO RIBEIRAO PRETO S.A.' }, { value: '120', label: 'BANCO RODOBENS S.A.' }, { value: '422', label: 'Banco Safra S.A.' }, { value: '743', label: 'Banco Semear S.A.' }, { value: '754', label: 'Banco Sistema S.A.' }, { value: '630', label: 'Banco Smartbank S.A.' }, { value: '366', label: 'BANCO SOCIETE GENERALE BRASIL S.A.' }, { value: '637', label: 'BANCO SOFISA S.A.' }, { value: '464', label: 'Banco Sumitomo Mitsui Brasileiro S.A.' }, { value: '082', label: 'BANCO TOPÁZIO S.A.' }, { value: '387', label: 'Banco Toyota do Brasil S.A.' }, { value: '634', label: 'BANCO TRIANGULO S.A.' }, { value: '018', label: 'Banco Tricury S.A.' }, { value: '393', label: 'Banco Volkswagen S.A.' }, { value: '655', label: 'Banco Votorantim S.A.' }, { value: '610', label: 'Banco VR S.A.' }, { value: '119', label: 'Banco Western Union do Brasil S.A.' }, { value: '124', label: 'Banco Woori Bank do Brasil S.A.' }, { value: '348', label: 'Banco XP S.A.' }, { value: '081', label: 'BancoSeguro S.A.' }, { value: '021', label: 'BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO' }, { value: '755', label: 'Bank of America Merrill Lynch Banco Múltiplo S.A.' }, { value: '268', label: 'BARI COMPANHIA HIPOTECÁRIA' }, { value: '378', label: 'BBC LEASING S.A. – ARRENDAMENTO MERCANTIL' }, { value: '250', label: 'BCV – BANCO DE CRÉDITO E VAREJO S.A.' }, { value: '144', label: 'BEXS BANCO DE CÂMBIO S/A' }, { value: '253', label: 'Bexs Corretora de Câmbio S/A' }, { value: '134', label: 'BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '017', label: 'BNY Mellon Banco S.A.' }, { value: '383', label: 'BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.' }, { value: '408', label: 'BÔNUSCRED SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '301', label: 'BPP Instituição de Pagamento S.A.' }, { value: '126', label: 'BR Partners Banco de Investimento S.A.' }, { value: '092', label: 'BRK S.A. Crédito, Financiamento e Investimento' }, { value: '173', label: 'BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '142', label: 'Broker Brasil Corretora de Câmbio Ltda.' }, { value: '292', label: 'BS2 Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '309', label: 'CAMBIONET CORRETORA DE CÂMBIO LTDA.' }, { value: '288', label: 'CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { value: '324', label: 'CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '130', label: 'CARUANA S.A. – SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { value: '159', label: 'Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor' }, { value: '114', label: 'Central Cooperativa de Crédito no Estado do Espírito Santo – CECOOP' }, { value: '091', label: 'CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S' }, { value: '320', label: 'China Construction Bank (Brasil) Banco Múltiplo S/A' }, { value: '362', label: 'CIELO S.A.' }, { value: '477', label: 'Citibank N.A.' }, { value: '180', label: 'CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '127', label: 'Codepe Corretora de Valores e Câmbio S.A.' }, { value: '163', label: 'Commerzbank Brasil S.A. – Banco Múltiplo' }, { value: '133', label: 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E' }, { value: '136', label: 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. – UNICRED DO BRASI' }, { value: '060', label: 'Confidence Corretora de Câmbio S.A.' }, { value: '085', label: 'Cooperativa Central de Crédito – Ailos' }, { value: '016', label: 'COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI' }, { value: '281', label: 'Cooperativa de Crédito Rural Coopavel' }, { value: '322', label: 'Cooperativa de Crédito Rural de Abelardo Luz – Sulcredi/Crediluz' }, { value: '391', label: 'COOPERATIVA DE CREDITO RURAL DE IBIAM – SULCREDI/IBIAM' }, { value: '286', label: 'COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO' }, { value: '350', label: 'COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE' }, { value: '279', label: 'COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' }, { value: '273', label: 'Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel' }, { value: '379', label: 'COOPERFORTE – COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS FUNCIONÁRIOS DE INSTIT' }, { value: '403', label: 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '098', label: 'Credialiança Cooperativa de Crédito Rural' }, { value: '010', label: 'CREDICOAMO CREDITO RURAL COOPERATIVA' }, { value: '089', label: 'CREDISAN COOPERATIVA DE CRÉDITO' }, { value: '097', label: 'Credisis – Central de Cooperativas de Crédito Ltda.' }, { value: '011', label: 'CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A' }, { value: '342', label: 'Creditas Sociedade de Crédito Direto S.A.' }, { value: '321', label: 'CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT' }, { value: '289', label: 'DECYSEO CORRETORA DE CAMBIO LTDA.' }, { value: '487', label: 'DEUTSCHE BANK S.A. – BANCO ALEMAO' }, { value: '140', label: 'Easynvest – Título Corretora de Valores SA' }, { value: '149', label: 'Facta Financeira S.A. – Crédito Financiamento e Investimento' }, { value: '196', label: 'FAIR CORRETORA DE CAMBIO S.A.' }, { value: '343', label: 'FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.' }, { value: '382', label: 'FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L' }, { value: '331', label: 'Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '285', label: 'Frente Corretora de Câmbio Ltda.' }, { value: '278', label: 'Genial Investimentos Corretora de Valores Mobiliários S.A.' }, { value: '364', label: 'GERENCIANET S.A.' }, { value: '138', label: 'Get Money Corretora de Câmbio S.A.' }, { value: '384', label: 'GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO' }, { value: '064', label: 'GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.' }, { value: '177', label: 'Guide Investimentos S.A. Corretora de Valores' }, { value: '146', label: 'GUITTA CORRETORA DE CAMBIO LTDA.' }, { value: '078', label: 'Haitong Banco de Investimento do Brasil S.A.' }, { value: '062', label: 'Hipercard Banco Múltiplo S.A.' }, { value: '189', label: 'HS FINANCEIRA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' }, { value: '396', label: 'HUB PAGAMENTOS S.A' }, { value: '271', label: 'IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { value: '157', label: 'ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.' }, { value: '132', label: 'ICBC do Brasil Banco Múltiplo S.A.' }, { value: '492', label: 'ING Bank N.V.' }, { value: '139', label: 'Intesa Sanpaolo Brasil S.A. – Banco Múltiplo' }, { value: '652', label: 'Itaú Unibanco Holding S.A.' }, { value: '488', label: 'JPMorgan Chase Bank, National Association' }, { value: '399', label: 'Kirton Bank S.A. – Banco Múltiplo' }, { value: '293', label: 'Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { value: '105', label: 'Lecca Crédito, Financiamento e Investimento S/A' }, { value: '145', label: 'LEVYCAM – CORRETORA DE CAMBIO E VALORES LTDA.' }, { value: '397', label: 'LISTO SOCIEDADE DE CREDITO DIRETO S.A.' }, { value: '113', label: 'Magliano S.A. Corretora de Cambio e Valores Mobiliarios' }, { value: '323', label: 'MERCADOPAGO.COM REPRESENTACOES LTDA.' }, { value: '274', label: 'MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT' }, { value: '259', label: 'MONEYCORP BANCO DE CÂMBIO S.A.' }, { value: '128', label: 'MS Bank S.A. Banco de Câmbio' }, { value: '377', label: 'MS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA' }, { value: '354', label: 'NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES' }, { value: '191', label: 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.' }, { value: '753', label: 'Novo Banco Continental S.A. – Banco Múltiplo' }, { value: '260', label: 'Nu Pagamentos S.A.' }, { value: '111', label: 'OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.' }, { value: '319', label: 'OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '613', label: 'Omni Banco S.A.' }, { value: '325', label: 'Órama Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '355', label: 'ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '290', label: 'Pagseguro Internet S.A.' }, { value: '254', label: 'PARANÁ BANCO S.A.' }, { value: '326', label: 'PARATI – CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { value: '194', label: 'PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '174', label: 'PEFISA S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { value: '315', label: 'PI Distribuidora de Títulos e Valores Mobiliários S.A.' }, { value: '380', label: 'PICPAY SERVICOS S.A.' }, { value: '100', label: 'Planner Corretora de Valores S.A.' }, { value: '125', label: 'Plural S.A. Banco Múltiplo' }, { value: '093', label: 'PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT' }, { value: '108', label: 'PORTOCRED S.A. – CREDITO, FINANCIAMENTO E INVESTIMENTO' }, { value: '306', label: 'PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { value: '329', label: 'QI Sociedade de Crédito Direto S.A.' }, { value: '283', label: 'RB CAPITAL INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LIMITADA' }, { value: '374', label: 'REALIZE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { value: '101', label: 'RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '270', label: 'Sagitur Corretora de Câmbio Ltda.' }, { value: '751', label: 'Scotiabank Brasil S.A. Banco Múltiplo' }, { value: '276', label: 'Senff S.A. – Crédito, Financiamento e Investimento' }, { value: '545', label: 'SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A' }, { value: '190', label: 'SERVICOOP – COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN' }, { value: '363', label: 'SOCOPA SOCIEDADE CORRETORA PAULISTA S.A.' }, { value: '183', label: 'SOCRED S.A. – SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P' }, { value: '365', label: 'SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS' }, { value: '299', label: 'SOROCRED   CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { value: '014', label: 'STATE STREET BRASIL S.A. ? BANCO COMERCIAL' }, { value: '197', label: 'Stone Pagamentos S.A.' }, { value: '404', label: 'SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { value: '340', label: 'Super Pagamentos e Administração de Meios Eletrônicos S.A.' }, { value: '307', label: 'Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { value: '352', label: 'TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { value: '095', label: 'Travelex Banco de Câmbio S.A.' }, { value: '143', label: 'Treviso Corretora de Câmbio S.A.' }, { value: '360', label: 'TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { value: '131', label: 'TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA' }, { value: '129', label: 'UBS Brasil Banco de Investimento S.A.' }, { value: '015', label: 'UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { value: '099', label: 'UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.' }, { value: '084', label: 'UNIPRIME NORTE DO PARANÁ – COOPERATIVA DE CRÉDITO LTDA' }, { value: '373', label: 'UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.' }, { value: '298', label: 'Vip’s Corretora de Câmbio Ltda.' }, { value: '296', label: 'VISION S.A. CORRETORA DE CAMBIO' }, { value: '367', label: 'VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { value: '310', label: 'VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { value: '371', label: 'WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.' }, { value: '102', label: 'XP INVESTIMENTOS CORRETORA DE CÂMBIO,TÍTULOS E VALORES MOBILIÁRIOS S/A' }, { value: '359', label: 'ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A' }]
	    };
	  },
	
	  props: ['propsNota'],
	  watch: {
	    propsNota: function propsNota() {
	      this.nota = this.propsNota;
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    this.nota = this.propsNota;
	  },
	
	  methods: {}
	};

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'documento-fiscal',
	  data: function data() {
	    return {
	      nota: {},
	      total: 0,
	      etapa: this.propsEtapa
	    };
	  },
	
	  props: ['propsNota', 'propsEtapa'],
	  watch: {
	    propsNota: function propsNota() {
	      this.nota = this.propsNota;
	
	      this.$forceUpdate();
	      this.valorTotalSolicitacao;
	      this.$forceUpdate();
	    },
	    propsEtapa: function propsEtapa() {
	      this.etapa = this.propsEtapa;
	    }
	  },
	  computed: {
	    valorTotalSolicitacao: function valorTotalSolicitacao() {
	      var total = 0;
	      var i = void 0;
	      if (this.itensProjeto) {
	        for (i = 0; i < this.itensProjeto.length; i++) {
	          if (this.itensProjeto[i] !== null) {
	            if (this.itensProjeto[i].valorSolicitado) {
	              total = total + this.itensProjeto[i].valorSolicitado;
	            }
	          }
	        }
	      }
	      if (this.propsNota.receiptItems) {
	        this.total = 0;
	        for (var j = 0; j < this.propsNota.receiptItems.length; j++) {
	          if (this.propsNota.receiptItems[j].valorSolicitado > 0) {
	            total = total + this.propsNota.receiptItems[j].valorSolicitado;
	          }
	        }
	      }
	      return total;
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {},
	
	  methods: {}
	};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'forma-pagamento',
	  data: function data() {
	    return {
	      nota: this.propsNota,
	      validacao: this.propsValidacao || {
	        processo: {
	          nome: null
	        }
	      }
	    };
	  },
	
	  props: ['propsNota', 'propsValidacao'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  watch: {
	    propsNota: function propsNota() {
	      this.nota = this.propsNota;
	      if (!_.has(this.nota, 'prioridade')) {
	        this.nota.prioridade = '0';
	      }
	    },
	    propsValidacao: function propsValidacao() {
	      console.log('entrou propsValidacao', this.propsValidacao);
	      this.validacao = this.propsValidacao;
	      if (this.validacao.processo.nome && (this.validacao.processo.nome === 'Prestação de Contas' || this.validacao.processo.nome === 'PRESTACAO_DE_CONTAS')) {
	        this.nota.forma_pagamento = 2;
	      }
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    if (this.validacao.processo.nome && (this.validacao.processo.nome === 'Prestação de Contas' || this.validacao.processo.nome === 'PRESTACAO_DE_CONTAS')) {
	      this.nota.forma_pagamento = 2;
	    }
	    this.$forceUpdate();
	  },
	
	  methods: {}
	};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cnpj = __webpack_require__(122);
	
	var _cnpj2 = _interopRequireDefault(_cnpj);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'fornecedor',
	  data: function data() {
	    return {
	      nota: {},
	      validacao: {},
	      validoCPF: true
	    };
	  },
	
	  props: ['propsNota', 'propsValidacao'],
	  watch: {
	    propsNota: function propsNota() {
	      this.nota = this.propsNota;
	    },
	    propsValidacao: function propsValidacao() {
	      var $cpfcnpjold = $('.cpfcnpj').val();
	      if ($cpfcnpjold) {
	        $cpfcnpjold = $cpfcnpjold.replaceAll('.', '').replaceAll('-', '');
	        if ($cpfcnpjold.length > 11) {
	          $cpfcnpjold = $cpfcnpjold.replaceAll('/', '');
	        }
	      }
	      if ($cpfcnpjold !== this.nota.dados_bancarios.fornecedor.identificador && $cpfcnpjold) {
	        console.log('CPF/CNPJ alterado');
	        return;
	      }
	      this.validacao = this.propsValidacao;
	      if (this.nota.dados_bancarios) {
	        if (this.nota.dados_bancarios.fornecedor) {
	          this.nota.enderecoFornecedor = this.nota.dados_bancarios.fornecedor.endereco;
	          this.nota.cepFornecedor = this.nota.dados_bancarios.fornecedor.cep;
	          this.nota.nomeFornecedor = this.nota.dados_bancarios.fornecedor.nome;
	          if (this.nota.dados_bancarios.fornecedor.identificador.length >= 14) {
	            this.nota.tipoFornecedor = 'Pessoa Jurídica';
	            this.nota.cnpjFornecedor = this.nota.dados_bancarios.fornecedor.identificador;
	            this.onBlurCpfCnpj(this.nota.cnpjFornecedor);
	          } else {
	            this.nota.tipoFornecedor = 'Pessoa Física';
	            this.nota.cpfFornecedor = this.nota.dados_bancarios.fornecedor.identificador;
	            this.onBlurCpfCnpj(this.nota.cpfFornecedor);
	          }
	        }
	      }
	
	      this.loadCityAndState();
	      this.$forceUpdate();
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    this.nota = _.cloneDeep(this.propsNota);
	    this.validacao = _.cloneDeep(this.propsValidacao);
	  },
	
	  methods: {
	    loadCityAndState: function loadCityAndState() {
	      var _this = this;
	
	      if (this.nota.cepFornecedor === '0') {
	        this.nota.cidadeFornecedor = 'CEP inválido.';
	        this.nota.estadoFornecedor = '';
	        this.$forceUpdate();
	      }
	      if (this.nota.cepFornecedor) {
	        axiosLaravel.get('municipios/cep/' + this.nota.cepFornecedor).then(function (response) {
	          if (!_.isEmpty(response.data)) {
	            if (_this.nota.cepFornecedor === '0') {
	              _this.nota.cidadeFornecedor = 'Atualize o CEP no cadastro do Fornecedor.';
	              _this.nota.estadoFornecedor = '';
	              _this.$snotify.warning('Atenção: CEP inválido. Por gentileza atualize o CEP no cadastro do fornecedor.');
	            } else {
	              _this.nota.cidadeFornecedor = response.data.ds_nome;
	              _this.nota.estadoFornecedor = response.data.ds_uf;
	            }
	            _this.$forceUpdate();
	          }
	        }).catch(function (error) {
	          if (_this.nota.cepFornecedor === 0) {
	            _this.nota.cidadeFornecedor = 'CEP inválido.';
	            _this.nota.estadoFornecedor = '';
	          } else {
	            _this.$root.trataErro(error);
	          }
	        });
	      } else {
	        this.nota.cidadeFornecedor = '';
	        this.nota.estadoFornecedor = '';
	        this.$forceUpdate();
	      }
	    },
	    onBlurCpfCnpj: function onBlurCpfCnpj(value) {
	      var _this2 = this;
	
	      if (_.isNull(value) || _.isEmpty(value) || _.isUndefined(value)) {
	        return;
	      } else {
	        if (value.length <= 11) {
	          this.validoCPF = cpf.isValid(value);
	        } else {
	          this.validoCPF = (0, _cnpj2.default)(value);
	        }
	      }
	      if (this.validoCPF === false) {
	        var field = this.$validator.fields.find({ name: 'cpf' });
	        field.setFlags({ invalid: true });
	        this.errors.add({
	          field: 'cpf',
	          msg: 'O campo CPF/CNPJ está incorreto.',
	          id: field.id,
	          scope: field.scope
	        });
	        this.$snotify.error('O campo CPF/CNPJ está incorreto.');
	      } else {
	        this.bloqueiaCampos = 0;
	        axiosLaravel.get('consulta/busca-fornecedor/' + value).then(function (response) {
	          if (!_.isEmpty(response.data)) {
	            _this2.nota.enderecoFornecedor = response.data.EndFor;
	            _this2.nota.nomeFornecedor = response.data.NomFor;
	            _this2.nota.cepFornecedor = response.data.CepFor;
	            _this2.bloqueiaCampos = 1;
	            _this2.$forceUpdate();
	          }
	        }).catch(function (error) {
	          _this2.$root.trataErro(error);
	        });
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'historico-antigo',
	  data: function data() {
	    return {
	      table: {
	        items: [],
	        listaHistorico: [],
	        totalRows: 0,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        sortBy: 'termino',
	        sortDesc: false,
	        perPage: 50,
	        fields: [{ key: 'inicio', label: 'Data Início', sortable: true, thStyle: 'text-align: center; width: 12%', class: 'text-center' }, { key: 'nome', label: 'Fase', sortable: true, thStyle: 'text-align: center; width: 12%', class: 'text-center' }, { key: 'usuario.ds_nome_usuario', label: 'Usuário Responsável', sortable: true, thStyle: 'text-align: center; width: 25%', class: 'text-center' }, { key: 'usuario.ds_tipo_usuario', label: 'FBB/Parceiro', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'observacao', label: 'Observação', sortable: true, thStyle: 'text-align: center; width: 30%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['propsValidacao', 'propsHistorico']
	};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _lodash = __webpack_require__(170);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'historico-solicitacao-pagamento',
	  data: function data() {
	    return {
	      meuStatus: 'ValorInicial',
	      table: {
	        items: [],
	        listaHistorico: [],
	        totalRows: null,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        sortBy: null,
	        sortDesc: false,
	        perPage: 20,
	        fields: [{ key: 'inicio', label: 'Data Início', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'termino', label: 'Data Término', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'nome', label: 'Fase', sortable: true, thStyle: 'text-align: center; width: 9%', class: 'text-center' }, { key: 'proxima_etapa', label: 'Status', sortable: true, thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'usuario.ds_nome_usuario', label: 'Usuário Responsável', sortable: true, thStyle: 'text-align: center; width: 18%', class: 'text-center' }, { key: 'usuario.ds_tipo_usuario', label: 'FBB/Parceiro', sortable: true, thStyle: 'text-align: center; width: 10%', class: 'text-center' }, { key: 'observacao', label: 'Observação', sortable: true, thStyle: 'text-align: center; width: 30%', class: 'text-center' }]
	      }
	    };
	  },
	
	  props: ['propsValidacao', 'propsHistorico'],
	  computed: {
	    linhas: function linhas() {
	      var _this = this;
	
	      return _lodash2.default.sortBy(_lodash2.default.map(this.propsHistorico, function (item) {
	        return _this.tarefaEmAndamento(item) ? _lodash2.default.assign({}, item, { _rowVariant: 'info' }) : item;
	      }), [function (item) {
	        return _this.tarefaEmAndamento(item) ? 1 : 0;
	      }, function (item) {
	        return _this.instante(item.termino || item.inicio);
	      }]);
	    }
	  },
	  watch: {
	    propsHistorico: function propsHistorico() {
	      this.historico = this.propsHistorico;
	      this.table.totalRows = this.propsHistorico.length;
	    }
	  },
	  created: function created() {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this2.processo = _this2.$route.path.indexOf('prestacaocontas') >= 0 ? 'PRESTACAO_DE_CONTAS' : _this2.$route.path.indexOf('contrapartida') >= 0 ? 'CONTRAPARTIDA' : _this2.$route.path.indexOf('adiantamento') >= 0 ? 'ADIANTAMENTO' : _this2.$route.path.indexOf('devolucaoAdiantamento') >= 0 ? 'DEVOLUCAO_DE_ADIANTAMENTO' : _this2.$route.path.indexOf('ressarcimento') >= 0 ? 'RESSARCIMENTO' : 'PAGAMENTO';
	              _context.next = 3;
	              return _this2.statusProcesso();
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }))();
	  },
	  mounted: function mounted() {
	    this.table.items = this.propsHistorico;
	    this.table.totalRows = this.propsHistorico.length;
	    this.$forceUpdate();
	  },
	
	  methods: {
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    tarefaEmAndamento: function tarefaEmAndamento(item) {
	      return item.origem === 'tarefa_atual' && (_lodash2.default.isNull(item.termino) || _lodash2.default.isUndefined(item.termino));
	    },
	    instante: function instante(valor) {
	      if (!valor) {
	        return 0;
	      }
	
	      var data = new Date(String(valor).replace(' ', 'T'));
	      return isNaN(data.getTime()) ? 0 : data.getTime();
	    },
	    rotuloFase: function rotuloFase(item) {
	      if (_lodash2.default.includes(['TAREFA_ASSUMIDA', 'TAREFA_ATRIBUIDA', 'DEVOLVE_ATRIBUICAO'], item.nome)) {
	        return this.dePara(item.etapa_anterior) || this.dePara(item.nome);
	      }
	      return this.dePara(item.nome);
	    },
	    dePara: function dePara(parametro) {
	      if (_lodash2.default.isNil(parametro) || parametro === '') {
	        return '';
	      }
	
	      var chave = _lodash2.default.deburr(String(parametro)).toUpperCase().replace(/\s+/g, '_');
	      var rotulos = {
	        'SOLICITACAO': 'Solicitação',
	        'ANALISE': 'Análise',
	        'AUTORIZACAO': 'Autorização',
	        'ANALISE_FINANCEIRA': 'Acerto Contábil',
	        'ANALISE_TRIBUTARIA': 'Análise Tributária',
	        'LIQUIDACAO_FINANCEIRA': 'Liquidação',
	        'LIQUIDACAO': 'Liquidação',
	        'REVISAO': 'Revisão',
	        'CONCLUSAO': 'Conclusão',
	        'DOCUMENTOS': 'Documentos',
	        'GED': 'GED',
	        'REABILITA': 'Reabilitação',
	        'TAREFA_ASSUMIDA': 'Tarefa Assumida',
	        'TAREFA_ATRIBUIDA': 'Tarefa Atribuída',
	        'DEVOLVE_ATRIBUICAO': 'Atribuição Devolvida',
	        'TAREFA_REATIVADA': 'Tarefa Reativada',
	        'CANCELADO': 'Processo Cancelado'
	      };
	
	      return rotulos[chave] || _lodash2.default.startCase(_lodash2.default.toLower(String(parametro).replace(/_/g, ' ')));
	    },
	    statusProcesso: function statusProcesso() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!_this3.$route.params.tipo) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                if (_lodash2.default.isNull(_this3.$route.params.tipo)) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                _context2.t0 = _this3.$route.params.tipo;
	                _context2.next = _context2.t0 === 'Adiantamento' ? 5 : _context2.t0 === 'Devolução de Adiantamento' ? 7 : 9;
	                break;
	
	              case 5:
	                _this3.meuStatus = 'Enviado para Liquidação';
	                return _context2.abrupt('break', 10);
	
	              case 7:
	                _this3.meuStatus = 'Devolução Liquidada';
	                return _context2.abrupt('break', 10);
	
	              case 9:
	                _this3.meuStatus = 'Enviado para Liquidação';
	
	              case 10:
	                _context2.next = 25;
	                break;
	
	              case 12:
	                _this3.meuStatus = _this3.processo;
	                _context2.t1 = _this3.processo;
	                _context2.next = _context2.t1 === 'PRESTACAO_DE_CONTAS' ? 16 : _context2.t1 === 'CONTRAPARTIDA' ? 18 : _context2.t1 === 'RESSARCIMENTO' ? 20 : _context2.t1 === 'PAGAMENTO' ? 22 : 24;
	                break;
	
	              case 16:
	                _this3.meuStatus = 'Liquidado';
	                return _context2.abrupt('break', 25);
	
	              case 18:
	                _this3.meuStatus = 'Contrapartida Aprovada';
	                return _context2.abrupt('break', 25);
	
	              case 20:
	                _this3.meuStatus = 'Enviado para Liquidação';
	                return _context2.abrupt('break', 25);
	
	              case 22:
	                _this3.meuStatus = 'Enviado para Liquidação';
	                return _context2.abrupt('break', 25);
	
	              case 24:
	                _this3.meuStatus = 'Enviado para Liquidação';
	
	              case 25:
	                _this3.$forceUpdate();
	
	              case 26:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    }
	  }
	};

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'visualizar',
	  data: function data() {
	    return {
	      data: [],
	      items: []
	    };
	  },
	
	  created: function created() {
	    this.carregaTarefa();
	  },
	  mounted: function mounted() {},
	  methods: {
	    carregaTarefa: function carregaTarefa() {
	      var _this = this;
	
	      axiosLaravel.get('processos', this.row.id).then(function (response) {
	        _this.req = response.data;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(76);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadDocumentosPhp = __webpack_require__(85);
	
	var _uploadDocumentosPhp2 = _interopRequireDefault(_uploadDocumentosPhp);
	
	var _historicoSolicitacaoPagamento = __webpack_require__(107);
	
	var _historicoSolicitacaoPagamento2 = _interopRequireDefault(_historicoSolicitacaoPagamento);
	
	var _historicoAntigo = __webpack_require__(106);
	
	var _historicoAntigo2 = _interopRequireDefault(_historicoAntigo);
	
	var _brBankAccountValidator = __webpack_require__(125);
	
	var _brBankAccountValidator2 = _interopRequireDefault(_brBankAccountValidator);
	
	var _cpfCnpjValidator = __webpack_require__(232);
	
	var _cnpj = __webpack_require__(122);
	
	var _cnpj2 = _interopRequireDefault(_cnpj);
	
	var _boletoUtils = __webpack_require__(176);
	
	var _boletoUtils2 = _interopRequireDefault(_boletoUtils);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosPhp: _uploadDocumentosPhp2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    HistoricoSolicitacaoPagamento: _historicoSolicitacaoPagamento2.default,
	    HistoricoAntigo: _historicoAntigo2.default
	  },
	  name: 'main-solicitacao-pagamentos',
	  data: function data() {
	    return {
	      id: null,
	      ativaGeracaoRemessa: true,
	      ehNFe: false,
	      processo: 'PAGAMENTO',
	      etapa: 'Solicitação',
	      historico: [],
	      objetoComDeclaracoes: [],
	      projetoSuperior: 0,
	      temOcorrencia: false,
	      razaoSocial: '',
	      id_entidade: 0,
	      mostrar_ocorrencias: false,
	      ocorrencias: [],
	      mostrar_representantes: false,
	      dirigentes: [],
	      cod_cargo: 0,
	      cargos: ['', 'Presidente(a)', 'Vice-Presidente', 'Prefeito(a)', 'Diretor(a)', 'Diretor(a) Superintendente', 'Coordenador(a)', 'Outros', 'Reitor(a)', 'Secretário(a)', 'Tesoureiro(a)', 'Contato', 'Designado(a)', 'Procurador(a)'],
	      esconderHistorico: false,
	      data_edicao: '',
	      dataFinalConvenio: '',
	      historicoTarefas: [],
	      historicoTarefasTela: [],
	      historicoBack: [],
	      restricao: false,
	      projetoComAlteracaoEmAndamento: false,
	      loading: {
	        tela: false,
	        cronograma: false,
	        adiantamentos: false,
	        analise_tributaria: false,
	        suportesFbbAtivos: false,
	        favorecido: false
	      },
	      dataMenor: false,
	      dataCorte: '2020-12-10',
	      chamado: [],
	      listaProjetos: [],
	      projeto: {},
	      entidade: {},
	      cronograma: [],
	      desabilitarDatasFuturas: {
	        from: new Date() },
	      desabilitarDatasPassadas: {
	        to: new Date() },
	      nota: {
	        numeroNota: null,
	        serieNota: null,
	        dataInclusao: null,
	        dataValidade: null,
	        observacao: null,
	        dados_bancarios: {
	          banco: null,
	          agencia: null,
	          conta: null,
	          tipo: 1
	        },
	        tipoFornecedor: null,
	        codigoFornecedor: '',
	        cpfFornecedor: '',
	        cnpjFornecedor: '',
	        nomeFornecedor: '',
	        enderecoFornecedor: '',
	        cepFornecedor: '',
	        simplesNacional: '',
	
	        anexos: [],
	        declaracaoCiencia: [],
	        forma_pagamento: null,
	        pagamentoPrioritario: 0,
	        bypass: '',
	        dadosComplementares: [],
	        suporteFbb: [],
	        tributacao: '',
	        valorTributado: '',
	        parametros_documento: [],
	        boleto: {
	          sucesso: false,
	          mensagem: null,
	          tipoCodigoInput: null,
	          tipoBoleto: null,
	          codigoBarras: null,
	          linhaDigitavel: null,
	          numeroInformadoTela: null,
	          vencimento: null,
	          valor: null
	        },
	        favorecido: {
	          CodBan: '',
	          CodAge: '',
	          CcbFav: '',
	          contas: [],
	          incluidos: [],
	          excluidos: [],
	          resultado: [],
	          dadosBancariosSelecionados: null
	        }
	      },
	      ehVoluntariado: null,
	      decisoesDaAnalise: [],
	      prjsup: null,
	      ehPrestacaoSimplificada: false,
	      cienteDeclaracoes: [],
	      declaracoes: [{ 'codigo': 'fornecedoresNaoLigadosDirigentes', 'texto': 'Declaro que esta liberação de recurso não será destinada ao pagamento de fornecedores de bens e serviços dos quais seu(s) proprietário(s), sócio(s) ou dirigente(s) seja(m) componentes da diretoria e conselhos da {{entidade.ds_nome}}' }, { 'codigo': 'recursosNaoDestinadosDirigentesParentes', 'texto': 'Declaro ainda que o recurso não será destinado a fornecedores de bens e serviços dos quais seu(s) proprietário(s), sócio(s) ou dirigente(s) seja(m) parente(s) consanguíneo(s) ou afins, em linha reta ou colateral, até o terceiro grau com dirigente(s) ou conselheiro(s) da {{entidade.ds_nome}}' }],
	      declaracoesEcoforte: [{ 'codigo': 'fornecedoresNaoLigadosDirigentes', 'texto': 'Declaro que esta liberação de recurso não será destinada ao pagamento de fornecedores de bens e serviços dos quais seu(s) proprietário(s), sócio(s) ou dirigente(s) seja(m) componentes da diretoria e conselhos da {{entidade.ds_nome}}' }],
	      municipiosUf: [],
	
	      projetosPovosTradicionais: [21810, 21833, 22181],
	      ehProjetosPovosTradicionais: false,
	      ehProjetoEcoforte: false,
	      ehProjetoEspecial: false,
	      mostrarDadosComplementares: false,
	      opcoesContasExistentesFavorecido: [],
	      nfe: {
	        xmlNfe: {},
	        validada: false,
	        protocoloValidacao: null,
	        chaveAcesso: null,
	        dataValidacao: null,
	        resultadoValidacao: null,
	        retornoValidacao: null,
	        idUsuarioConsulta: null
	      },
	
	      aprovacao: {},
	      analiseTributaria: {},
	      layoutExtrato: 'classico',
	
	      extratoFiltrosSelecionados: this.$route.name === 'solicitacao-contrapartida' ? ['saldos'] : ['saldos', 'fundacao'],
	      adiantamentosFiltrosSelecionados: ['adiantamento_pendente'],
	      totais: {
	        projeto: {
	          fbb: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          parceiros: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          contrapartida: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          total: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          }
	        },
	        adiantamento: {
	          fbb: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          parceiros: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          },
	          total: {
	            orcado: 0,
	            solicitado: 0,
	            saldo: 0
	          }
	        }
	      },
	      ultimaTarefaFeita: {},
	
	      bloqueiaCamposFornecedorExistente: false,
	      restricaoParaInicializar: [],
	      restricaoParaConcluir: [],
	      ehVisualizacao: false,
	      validacao: {},
	      descricaoProcesso: { 'PAGAMENTO': 'Pagamento', 'PRESTACAO_DE_CONTAS': 'Prestação de Contas', 'CONTRAPARTIDA': 'Contrapartida', 'RESSARCIMENTO': 'Ressarcimento' },
	      rotasProcesso: { 'PAGAMENTO': '/solicitacao/pagamento', 'PRESTACAO_DE_CONTAS': '/solicitacao/prestacaocontas', 'CONTRAPARTIDA': '/solicitacao/contrapartida', 'RESSARCIMENTO': '/solicitacao/ressarcimento' },
	      poderes: {
	        codigo: '',
	        mensagem: []
	      },
	      listaBancos: [{ 'codigo': '001', 'nome': 'Banco do Brasil S.A.', 'caracteresConta': 8 }, { 'codigo': '033', 'nome': 'Banco Santander (Brasil) S.A.', 'caracteresConta': 8, 'digitoAgencia': false }, { 'codigo': '070', 'nome': 'BRB - Banco de Brasília S.A.' }, { 'codigo': '104', 'nome': 'Caixa Econômica Federal', 'digitoAgencia': false }, { 'codigo': '237', 'nome': 'Banco Bradesco S.A.', 'caracteresConta': 7 }, { 'codigo': '341', 'nome': 'Itaú Unibanco S.A.', 'caracteresConta': 5, 'digitoAgencia': false }, { 'codigo': '', 'nome': '', $isDisabled: true }, { 'codigo': '003', 'nome': 'BANCO DA AMAZONIA S.A.' }, { 'codigo': '004', 'nome': 'Banco do Nordeste do Brasil S.A.' }, { 'codigo': '007', 'nome': 'BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL' }, { 'codigo': '010', 'nome': 'CREDICOAMO CREDITO RURAL COOPERATIVA' }, { 'codigo': '011', 'nome': 'CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A' }, { 'codigo': '012', 'nome': 'Banco Inbursa S.A.' }, { 'codigo': '014', 'nome': 'STATE STREET BRASIL S.A. ? BANCO COMERCIAL' }, { 'codigo': '015', 'nome': 'UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { 'codigo': '016', 'nome': 'COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI' }, { 'codigo': '017', 'nome': 'BNY Mellon Banco S.A.' }, { 'codigo': '018', 'nome': 'Banco Tricury S.A.' }, { 'codigo': '021', 'nome': 'BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO' }, { 'codigo': '024', 'nome': 'Banco Bandepe S.A.' }, { 'codigo': '025', 'nome': 'Banco Alfa S.A.' }, { 'codigo': '029', 'nome': 'Banco Itaú Consignado S.A.' }, { 'codigo': '036', 'nome': 'Banco Bradesco BBI S.A.' }, { 'codigo': '037', 'nome': 'Banco do Estado do Pará S.A.' }, { 'codigo': '040', 'nome': 'Banco Cargill S.A.' }, { 'codigo': '041', 'nome': 'Banco do Estado do Rio Grande do Sul S.A.', 'caracteresConta': 9 }, { 'codigo': '047', 'nome': 'Banco do Estado de Sergipe S.A.' }, { 'codigo': '060', 'nome': 'Confidence Corretora de Câmbio S.A.' }, { 'codigo': '062', 'nome': 'Hipercard Banco Múltiplo S.A.' }, { 'codigo': '063', 'nome': 'Banco Bradescard S.A.' }, { 'codigo': '064', 'nome': 'GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.' }, { 'codigo': '065', 'nome': 'Banco AndBank (Brasil) S.A.' }, { 'codigo': '066', 'nome': 'BANCO MORGAN STANLEY S.A.' }, { 'codigo': '069', 'nome': 'Banco Crefisa S.A.' }, { 'codigo': '074', 'nome': 'Banco J. Safra S.A.' }, { 'codigo': '075', 'nome': 'Banco ABN Amro S.A.' }, { 'codigo': '076', 'nome': 'Banco KDB do Brasil S.A.' }, { 'codigo': '077', 'nome': 'Banco Inter S.A.' }, { 'codigo': '078', 'nome': 'Haitong Banco de Investimento do Brasil S.A.' }, { 'codigo': '079', 'nome': 'Banco Original do Agronegócio S.A.' }, { 'codigo': '080', 'nome': 'B&T CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '081', 'nome': 'BancoSeguro S.A.' }, { 'codigo': '082', 'nome': 'BANCO TOPÁZIO S.A.' }, { 'codigo': '083', 'nome': 'Banco da China Brasil S.A.' }, { 'codigo': '084', 'nome': 'UNIPRIME NORTE DO PARANÁ – COOPERATIVA DE CRÉDITO LTDA' }, { 'codigo': '085', 'nome': 'Cooperativa Central de Crédito – Ailos' }, { 'codigo': '088', 'nome': 'BANCO RANDON S.A.' }, { 'codigo': '089', 'nome': 'CREDISAN COOPERATIVA DE CRÉDITO' }, { 'codigo': '091', 'nome': 'CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S' }, { 'codigo': '092', 'nome': 'BRK S.A. Crédito, Financiamento e Investimento' }, { 'codigo': '093', 'nome': 'PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT' }, { 'codigo': '094', 'nome': 'Banco Finaxis S.A.' }, { 'codigo': '095', 'nome': 'Travelex Banco de Câmbio S.A.' }, { 'codigo': '096', 'nome': 'Banco B3 S.A.' }, { 'codigo': '097', 'nome': 'Credisis – Central de Cooperativas de Crédito Ltda.' }, { 'codigo': '098', 'nome': 'Credialiança Cooperativa de Crédito Rural' }, { 'codigo': '099', 'nome': 'UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.' }, { 'codigo': '100', 'nome': 'Planner Corretora de Valores S.A.' }, { 'codigo': '101', 'nome': 'RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '102', 'nome': 'XP INVESTIMENTOS CORRETORA DE CÂMBIO,TÍTULOS E VALORES MOBILIÁRIOS S/A' }, { 'codigo': '105', 'nome': 'Lecca Crédito, Financiamento e Investimento S/A' }, { 'codigo': '107', 'nome': 'Banco Bocom BBM S.A.' }, { 'codigo': '108', 'nome': 'PORTOCRED S.A. – CREDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '111', 'nome': 'OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.' }, { 'codigo': '113', 'nome': 'Magliano S.A. Corretora de Cambio e Valores Mobiliarios' }, { 'codigo': '114', 'nome': 'Central Cooperativa de Crédito no Estado do Espírito Santo – CECOOP' }, { 'codigo': '117', 'nome': 'ADVANCED CORRETORA DE CÂMBIO LTDA' }, { 'codigo': '119', 'nome': 'Banco Western Union do Brasil S.A.' }, { 'codigo': '120', 'nome': 'BANCO RODOBENS S.A.' }, { 'codigo': '121', 'nome': 'Banco Agibank S.A.' }, { 'codigo': '122', 'nome': 'Banco Bradesco BERJ S.A.' }, { 'codigo': '124', 'nome': 'Banco Woori Bank do Brasil S.A.' }, { 'codigo': '125', 'nome': 'Plural S.A. Banco Múltiplo' }, { 'codigo': '126', 'nome': 'BR Partners Banco de Investimento S.A.' }, { 'codigo': '127', 'nome': 'Codepe Corretora de Valores e Câmbio S.A.' }, { 'codigo': '128', 'nome': 'MS Bank S.A. Banco de Câmbio' }, { 'codigo': '129', 'nome': 'UBS Brasil Banco de Investimento S.A.' }, { 'codigo': '130', 'nome': 'CARUANA S.A. – SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '131', 'nome': 'TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA' }, { 'codigo': '132', 'nome': 'ICBC do Brasil Banco Múltiplo S.A.' }, { 'codigo': '133', 'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E' }, { 'codigo': '134', 'nome': 'BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '136', 'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. – UNICRED DO BRASI' }, { 'codigo': '138', 'nome': 'Get Money Corretora de Câmbio S.A.' }, { 'codigo': '139', 'nome': 'Intesa Sanpaolo Brasil S.A. – Banco Múltiplo' }, { 'codigo': '140', 'nome': 'Easynvest – Título Corretora de Valores SA' }, { 'codigo': '142', 'nome': 'Broker Brasil Corretora de Câmbio Ltda.' }, { 'codigo': '143', 'nome': 'Treviso Corretora de Câmbio S.A.' }, { 'codigo': '144', 'nome': 'BEXS BANCO DE CÂMBIO S/A' }, { 'codigo': '145', 'nome': 'LEVYCAM – CORRETORA DE CAMBIO E VALORES LTDA.' }, { 'codigo': '146', 'nome': 'GUITTA CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '149', 'nome': 'Facta Financeira S.A. – Crédito Financiamento e Investimento' }, { 'codigo': '157', 'nome': 'ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '159', 'nome': 'Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor' }, { 'codigo': '163', 'nome': 'Commerzbank Brasil S.A. – Banco Múltiplo' }, { 'codigo': '169', 'nome': 'BANCO OLÉ CONSIGNADO S.A.' }, { 'codigo': '173', 'nome': 'BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '174', 'nome': 'PEFISA S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '177', 'nome': 'Guide Investimentos S.A. Corretora de Valores' }, { 'codigo': '180', 'nome': 'CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '183', 'nome': 'SOCRED S.A. – SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P' }, { 'codigo': '184', 'nome': 'Banco Itaú BBA S.A.' }, { 'codigo': '188', 'nome': 'ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS, CÂMBIO E VALORES' }, { 'codigo': '189', 'nome': 'HS FINANCEIRA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' }, { 'codigo': '190', 'nome': 'SERVICOOP – COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN' }, { 'codigo': '191', 'nome': 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '194', 'nome': 'PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '196', 'nome': 'FAIR CORRETORA DE CAMBIO S.A.' }, { 'codigo': '197', 'nome': 'Stone Pagamentos S.A.' }, { 'codigo': '208', 'nome': 'Banco BTG Pactual S.A.' }, { 'codigo': '212', 'nome': 'Banco Original S.A.' }, { 'codigo': '213', 'nome': 'Banco Arbi S.A.' }, { 'codigo': '217', 'nome': 'Banco John Deere S.A.' }, { 'codigo': '218', 'nome': 'Banco BS2 S.A.' }, { 'codigo': '222', 'nome': 'BANCO CRÉDIT AGRICOLE BRASIL S.A.' }, { 'codigo': '224', 'nome': 'Banco Fibra S.A.' }, { 'codigo': '233', 'nome': 'Banco Cifra S.A.' }, { 'codigo': '241', 'nome': 'BANCO CLASSICO S.A.' }, { 'codigo': '243', 'nome': 'Banco Máxima S.A.' }, { 'codigo': '246', 'nome': 'Banco ABC Brasil S.A.' }, { 'codigo': '249', 'nome': 'Banco Investcred Unibanco S.A.' }, { 'codigo': '250', 'nome': 'BCV – BANCO DE CRÉDITO E VAREJO S.A.' }, { 'codigo': '253', 'nome': 'Bexs Corretora de Câmbio S/A' }, { 'codigo': '254', 'nome': 'PARANÁ BANCO S.A.' }, { 'codigo': '259', 'nome': 'MONEYCORP BANCO DE CÂMBIO S.A.' }, { 'codigo': '260', 'nome': 'Nu Pagamentos S.A.' }, { 'codigo': '265', 'nome': 'Banco Fator S.A.' }, { 'codigo': '266', 'nome': 'BANCO CEDULA S.A.' }, { 'codigo': '268', 'nome': 'BARI COMPANHIA HIPOTECÁRIA' }, { 'codigo': '269', 'nome': 'BANCO HSBC S.A.' }, { 'codigo': '270', 'nome': 'Sagitur Corretora de Câmbio Ltda.' }, { 'codigo': '271', 'nome': 'IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { 'codigo': '272', 'nome': 'AGK CORRETORA DE CAMBIO S.A.' }, { 'codigo': '273', 'nome': 'Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel' }, { 'codigo': '274', 'nome': 'MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT' }, { 'codigo': '276', 'nome': 'Senff S.A. – Crédito, Financiamento e Investimento' }, { 'codigo': '278', 'nome': 'Genial Investimentos Corretora de Valores Mobiliários S.A.' }, { 'codigo': '279', 'nome': 'COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' }, { 'codigo': '280', 'nome': 'Avista S.A. Crédito, Financiamento e Investimento' }, { 'codigo': '281', 'nome': 'Cooperativa de Crédito Rural Coopavel' }, { 'codigo': '283', 'nome': 'RB CAPITAL INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LIMITADA' }, { 'codigo': '285', 'nome': 'Frente Corretora de Câmbio Ltda.' }, { 'codigo': '286', 'nome': 'COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO' }, { 'codigo': '288', 'nome': 'CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '289', 'nome': 'DECYSEO CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '290', 'nome': 'Pagseguro Internet S.A.' }, { 'codigo': '292', 'nome': 'BS2 Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '293', 'nome': 'Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '296', 'nome': 'VISION S.A. CORRETORA DE CAMBIO' }, { 'codigo': '298', 'nome': 'Vip’s Corretora de Câmbio Ltda.' }, { 'codigo': '299', 'nome': 'SOROCRED   CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '300', 'nome': 'Banco de la Nacion Argentina' }, { 'codigo': '301', 'nome': 'BPP Instituição de Pagamento S.A.' }, { 'codigo': '306', 'nome': 'PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '307', 'nome': 'Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '309', 'nome': 'CAMBIONET CORRETORA DE CÂMBIO LTDA.' }, { 'codigo': '310', 'nome': 'VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '311', 'nome': 'DOURADA CORRETORA' }, { 'codigo': '312', 'nome': 'HSCM SCMEPP LTDA.' }, { 'codigo': '313', 'nome': 'AMAZÔNIA CORRETORA DE CÂMBIO LTDA.' }, { 'codigo': '315', 'nome': 'PI Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '318', 'nome': 'Banco BMG S.A.' }, { 'codigo': '319', 'nome': 'OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '320', 'nome': 'China Construction Bank (Brasil) Banco Múltiplo S/A' }, { 'codigo': '321', 'nome': 'CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT' }, { 'codigo': '322', 'nome': 'Cooperativa de Crédito Rural de Abelardo Luz – Sulcredi/Crediluz' }, { 'codigo': '323', 'nome': 'MERCADOPAGO.COM REPRESENTACOES LTDA.' }, { 'codigo': '324', 'nome': 'CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '325', 'nome': 'Órama Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '326', 'nome': 'PARATI – CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '329', 'nome': 'QI Sociedade de Crédito Direto S.A.' }, { 'codigo': '330', 'nome': 'BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.' }, { 'codigo': '331', 'nome': 'Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '332', 'nome': 'Acesso Soluções de Pagamento S.A.' }, { 'codigo': '335', 'nome': 'Banco Digio S.A.' }, { 'codigo': '336', 'nome': 'Banco C6 S.A.' }, { 'codigo': '340', 'nome': 'Super Pagamentos e Administração de Meios Eletrônicos S.A.' }, { 'codigo': '342', 'nome': 'Creditas Sociedade de Crédito Direto S.A.' }, { 'codigo': '343', 'nome': 'FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.' }, { 'codigo': '348', 'nome': 'Banco XP S.A.' }, { 'codigo': '349', 'nome': 'AL5 S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '350', 'nome': 'COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE' }, { 'codigo': '352', 'nome': 'TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '354', 'nome': 'NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES' }, { 'codigo': '355', 'nome': 'ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '358', 'nome': 'MIDWAY S.A. - SCFI' }, { 'codigo': '359', 'nome': 'ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A' }, { 'codigo': '360', 'nome': 'TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { 'codigo': '362', 'nome': 'CIELO S.A.' }, { 'codigo': '363', 'nome': 'SOCOPA SOCIEDADE CORRETORA PAULISTA S.A.' }, { 'codigo': '364', 'nome': 'GERENCIANET S.A.' }, { 'codigo': '365', 'nome': 'SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS' }, { 'codigo': '366', 'nome': 'BANCO SOCIETE GENERALE BRASIL S.A.' }, { 'codigo': '367', 'nome': 'VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { 'codigo': '368', 'nome': 'Banco CSF S.A.' }, { 'codigo': '370', 'nome': 'Banco Mizuho do Brasil S.A.' }, { 'codigo': '371', 'nome': 'WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.' }, { 'codigo': '373', 'nome': 'UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.' }, { 'codigo': '374', 'nome': 'REALIZE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '376', 'nome': 'BANCO J.P. MORGAN S.A.' }, { 'codigo': '377', 'nome': 'MS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA' }, { 'codigo': '378', 'nome': 'BBC LEASING S.A. – ARRENDAMENTO MERCANTIL' }, { 'codigo': '379', 'nome': 'COOPERFORTE – COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS FUNCIONÁRIOS DE INSTIT' }, { 'codigo': '380', 'nome': 'PICPAY SERVICOS S.A.' }, { 'codigo': '381', 'nome': 'BANCO MERCEDES-BENZ DO BRASIL S.A.' }, { 'codigo': '382', 'nome': 'FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L' }, { 'codigo': '383', 'nome': 'BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.' }, { 'codigo': '384', 'nome': 'GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO' }, { 'codigo': '386', 'nome': 'NU FINANCEIRA S.A. CFI' }, { 'codigo': '387', 'nome': 'Banco Toyota do Brasil S.A.' }, { 'codigo': '389', 'nome': 'Banco Mercantil do Brasil S.A.' }, { 'codigo': '390', 'nome': 'BANCO GM S.A.' }, { 'codigo': '391', 'nome': 'COOPERATIVA DE CREDITO RURAL DE IBIAM – SULCREDI/IBIAM' }, { 'codigo': '393', 'nome': 'Banco Volkswagen S.A.' }, { 'codigo': '394', 'nome': 'Banco Bradesco Financiamentos S.A.' }, { 'codigo': '395', 'nome': 'F D GOLD DTVM LTDA' }, { 'codigo': '396', 'nome': 'HUB PAGAMENTOS S.A' }, { 'codigo': '397', 'nome': 'LISTO SOCIEDADE DE CREDITO DIRETO S.A.' }, { 'codigo': '398', 'nome': 'IDEAL CTVM S.A.' }, { 'codigo': '399', 'nome': 'Kirton Bank S.A. – Banco Múltiplo' }, { 'codigo': '400', 'nome': 'CC POUP SER FIN CO' }, { 'codigo': '402', 'nome': 'COBUCCIO SCD S.A.' }, { 'codigo': '403', 'nome': 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '404', 'nome': 'SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '406', 'nome': 'ACCREDITO SCD S.A.' }, { 'codigo': '407', 'nome': 'ÍNDIGO INVESTIMENTOS DTVM LTDA.' }, { 'codigo': '408', 'nome': 'BÔNUSCRED SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '410', 'nome': 'PLANNER SCM S.A.' }, { 'codigo': '411', 'nome': 'VIA CERTA FINANCIADORA S.A. - CFI' }, { 'codigo': '412', 'nome': 'BANCO CAPITAL S.A.' }, { 'codigo': '419', 'nome': 'NUMBRS SCD S.A.' }, { 'codigo': '422', 'nome': 'Banco Safra S.A.' }, { 'codigo': '456', 'nome': 'Banco MUFG Brasil S.A.' }, { 'codigo': '464', 'nome': 'Banco Sumitomo Mitsui Brasileiro S.A.' }, { 'codigo': '473', 'nome': 'Banco Caixa Geral – Brasil S.A.' }, { 'codigo': '477', 'nome': 'Citibank N.A.' }, { 'codigo': '479', 'nome': 'Banco ItauBank S.A.' }, { 'codigo': '487', 'nome': 'DEUTSCHE BANK S.A. – BANCO ALEMAO' }, { 'codigo': '488', 'nome': 'JPMorgan Chase Bank, National Association' }, { 'codigo': '492', 'nome': 'ING Bank N.V.' }, { 'codigo': '495', 'nome': 'Banco de La Provincia de Buenos Aires' }, { 'codigo': '505', 'nome': 'Banco Credit Suisse (Brasil) S.A.' }, { 'codigo': '545', 'nome': 'SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A' }, { 'codigo': '600', 'nome': 'Banco Luso Brasileiro S.A.' }, { 'codigo': '604', 'nome': 'Banco Industrial do Brasil S.A.' }, { 'codigo': '610', 'nome': 'Banco VR S.A.' }, { 'codigo': '611', 'nome': 'Banco Paulista S.A.' }, { 'codigo': '612', 'nome': 'Banco Guanabara S.A.' }, { 'codigo': '613', 'nome': 'Omni Banco S.A.' }, { 'codigo': '623', 'nome': 'Banco Pan S.A.' }, { 'codigo': '626', 'nome': 'BANCO C6 CONSIGNADO S.A.' }, { 'codigo': '630', 'nome': 'Banco Smartbank S.A.' }, { 'codigo': '633', 'nome': 'Banco Rendimento S.A.' }, { 'codigo': '634', 'nome': 'BANCO TRIANGULO S.A.' }, { 'codigo': '637', 'nome': 'BANCO SOFISA S.A.' }, { 'codigo': '643', 'nome': 'Banco Pine S.A.' }, { 'codigo': '652', 'nome': 'Itaú Unibanco Holding S.A.' }, { 'codigo': '653', 'nome': 'BANCO INDUSVAL S.A.' }, { 'codigo': '654', 'nome': 'BANCO DIGIMAIS S.A.' }, { 'codigo': '655', 'nome': 'Banco Votorantim S.A.' }, { 'codigo': '707', 'nome': 'Banco Daycoval S.A.' }, { 'codigo': '712', 'nome': 'Banco Ourinvest S.A.' }, { 'codigo': '720', 'nome': 'BCO RNX S.A.' }, { 'codigo': '739', 'nome': 'Banco Cetelem S.A.' }, { 'codigo': '741', 'nome': 'BANCO RIBEIRAO PRETO S.A.' }, { 'codigo': '743', 'nome': 'Banco Semear S.A.' }, { 'codigo': '745', 'nome': 'Banco Citibank S.A.', 'caracteresConta': 8, 'digitoAgencia': false }, { 'codigo': '746', 'nome': 'Banco Modal S.A.' }, { 'codigo': '747', 'nome': 'Banco Rabobank International Brasil S.A.' }, { 'codigo': '748', 'nome': 'BANCO COOPERATIVO SICREDI S.A.' }, { 'codigo': '751', 'nome': 'Scotiabank Brasil S.A. Banco Múltiplo' }, { 'codigo': '752', 'nome': 'Banco BNP Paribas Brasil S.A.' }, { 'codigo': '753', 'nome': 'Novo Banco Continental S.A. – Banco Múltiplo' }, { 'codigo': '754', 'nome': 'Banco Sistema S.A.' }, { 'codigo': '755', 'nome': 'Bank of America Merrill Lynch Banco Múltiplo S.A.' }, { 'codigo': '756', 'nome': 'BANCO COOPERATIVO DO BRASIL S.A. – BANCOOB' }, { 'codigo': '757', 'nome': 'BANCO KEB HANA DO BRASIL S.A.' }],
	      listaFormasPagamento: [{ 'CodFpg': '1', 'DesFpg': 'Dinheiro' }, { 'CodFpg': '2', 'DesFpg': 'Crédito Conta Beneficiário' }, { 'CodFpg': '3', 'DesFpg': 'Crédito Conta Fornecedor' }, { 'CodFpg': '4', 'DesFpg': 'Docum. Código de Barras' }, { 'CodFpg': '5', 'DesFpg': 'DDA - Débito direto autorizado' }, { 'CodFpg': '6', 'DesFpg': 'Recibo/Orpag' }, { 'CodFpg': '7', 'DesFpg': 'Em teste Pgto TED e DOC' }],
	      listaSuportes: [],
	      formasPagamentoPorProcesso: { 'PAGAMENTO': ['3', '4'], 'PRESTACAO_DE_CONTAS': ['2'], 'CONTRAPARTIDA': ['1'], 'RESSARCIMENTO': ['3'] },
	      bancoSelecionado: null,
	      tiposConta: [{ 'codigo': 1, 'tipo': 'Conta Corrente' }, { 'codigo': 2, 'tipo': 'Conta Poupança' }],
	      tipoContaSelecionado: { 'codigo': 1, 'tipo': 'Conta Corrente' },
	      motivosDevolucao: [],
	
	      motivoDevolucao: null,
	
	      mostrarIncluindoConta: false,
	
	      adiantamentosConcecidos: [],
	
	      dadosBancariosFornecedores: [],
	
	      wait: false,
	      botao_concluir_disabled: false,
	      tipoDocumento: 'boleto',
	      possuiNotaSapiens: null,
	      table: {
	        items: this.entDirigentes,
	        filter: null,
	        hover: true,
	        bordered: true,
	        currentPage: 1,
	        perPage: 50,
	        fields: [{ key: 'ds_nome', label: 'Nome', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'dt_inicio_mandato', label: 'Inicio do mandato', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'dt_fim_mandato', label: 'Vigência do mandato', sortable: true, thStyle: 'text-align: center', class: 'text-center' }, { key: 'bt_ativo', label: 'Ativo', thStyle: 'text-align: center; width: 13%', class: 'text-center' }, { key: 'actions', label: 'Ações', thStyle: 'text-align: center; width: 13%', class: 'text-center' }]
	      },
	      tituloMovimentado: null,
	      valorOriginal: null,
	      confirmaValorOriginalDiferente: null,
	      ehParceiroEstrategico: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    decisoesDaAnaliseVisiveis: function decisoesDaAnaliseVisiveis() {
	      return this.etapa === 'Análise' && !this.ehVoluntariado ? this.decisoesDaAnalise : [];
	    },
	    decisaoDaAnalise: function decisaoDaAnalise() {
	      return _.find(this.decisoesDaAnaliseVisiveis, ['chave', this.aprovacao.resultadoAprovacao]) || null;
	    },
	    proximaEtapaEscolhida: function proximaEtapaEscolhida() {
	      return this.decisaoDaAnalise ? this.decisaoDaAnalise.proxima_etapa : this.aprovacao.resultadoAprovacao;
	    },
	    exibeObservacaoAprovacao: function exibeObservacaoAprovacao() {
	      return this.etapa === 'Análise' && this.aprovacao.resultadoAprovacao === 'Análise Tributária' || this.etapa === 'Análise Tributária' && this.aprovacao.resultadoAprovacao === 'Autorização' || this.etapa === 'Autorização' && this.aprovacao.resultadoAprovacao === 'Conclusão' || this.etapa === 'Autorização' && this.aprovacao.resultadoAprovacao === 'Liquidação' || this.etapa === 'Análise' && this.aprovacao.resultadoAprovacao === 'Conclusão';
	    },
	    observacaoAprovacaoObrigatoria: function observacaoAprovacaoObrigatoria() {
	      return this.exibeObservacaoAprovacao && this.etapa !== 'Autorização';
	    },
	    codfavFormatado: function codfavFormatado() {
	      var codfav = '' + (_.get(this.nota, 'favorecido.codfav') || '');
	      if (codfav.length === 0) {
	        return '';
	      }
	      return codfav.length === 11 ? this.$options.filters.cpf(codfav) : this.$options.filters.cnpj(codfav);
	    }
	  }),
	  watch: {
	    loading: {
	      deep: true,
	      handler: function handler(carregando) {
	        var _this = this;
	
	        if (carregando.tela) {
	          this.botao_concluir_disabled = true;
	        }
	        if (!carregando.tela) {
	          setTimeout(function () {
	            if (!_this.loading.tela) _this.botao_concluir_disabled = false;
	          }, 5000);
	        }
	      }
	    },
	    adiantamentosFiltrosSelecionados: function adiantamentosFiltrosSelecionados() {
	      if (this.adiantamentosConcecidos.length > 0) {
	        this.filtrarAdiantamentosConcedidos();
	        this.calcularTotaisAdiantamento();
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.$route.params.id) {
	      this.verificaChamado();
	    }
	    if (this.ehVisualizacao) {
	      this.restricaoParaInicializar = [];
	    }
	  },
	  created: function created() {
	    var vm = this;
	    this.ehParceiroEstrategico = this.usuarioLogado.perfis.some(function (perfil) {
	      return perfil.ds_nome === 'Parceiro Estratégico';
	    });
	    console.clear();
	    this.verificaPoderes();
	    this.data_edicao = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	    this.processo = this.$route.path.indexOf('prestacaocontas') >= 0 ? 'PRESTACAO_DE_CONTAS' : this.$route.path.indexOf('contrapartida') >= 0 ? 'CONTRAPARTIDA' : this.$route.path.indexOf('ressarcimento') >= 0 ? 'RESSARCIMENTO' : 'PAGAMENTO';
	
	    if (_.has(this.$route.params, 'visualizacao')) {
	      this.ehVisualizacao = this.$route.params.visualizacao;
	    }
	
	    if (this.processo === 'CONTRAPARTIDA') {
	      this.ehNFe = false;
	    }
	    this.listaFormasPagamento = _.filter(this.listaFormasPagamento, function (f) {
	      return _.includes(vm.formasPagamentoPorProcesso[vm.processo], f.CodFpg);
	    });
	    this.nota.forma_pagamento = this.listaFormasPagamento.length === 1 ? this.listaFormasPagamento[0]['CodFpg'] : null;
	    if (_.has(this.$route.params, 'id')) {
	      this.id = this.$route.params.id;
	      this.buscaPrestacaoSimplificada();
	      this.buscaDados();
	    } else {
	      if (_.isEmpty(this.listaProjetos)) {
	        console.log('Carregar lista de projeto');
	        console.log('tarefa:', this.ultimaTarefaFeita);
	        this.carregarListaProjetos();
	      }
	    }
	  },
	
	  methods: {
	    filtrarPorOrigemRecurso: function filtrarPorOrigemRecurso(origem) {
	      _.pull(this.extratoFiltrosSelecionados, 'fundacao', 'parceiro');
	      _.uniq(this.extratoFiltrosSelecionados.push(origem));
	      this.filtrarExtrato();
	      this.calcularTotaisExtato();
	    },
	    selecionaBanco: function selecionaBanco(banco) {
	      this.nota.dados_bancarios.banco = banco.codigo;
	      if (_.has(this.nota, 'favorecido')) {
	        this.nota.favorecido.codban = banco.codigo;
	      }
	      this.$forceUpdate();
	    },
	    bancoNome: function bancoNome(option) {
	      return '' + (option.codigo + ' - ' + option.nome);
	    },
	    selecionaTipoConta: function selecionaTipoConta(tipoSelecionado) {
	      this.nota.dados_bancarios.tipo = tipoSelecionado.codigo;
	      this.$forceUpdate();
	    },
	    tipoContaNome: function tipoContaNome(option) {
	      return '' + (option.codigo + ' - ' + option.tipo);
	    },
	    suporteNome: function suporteNome(option) {
	      return '' + (option.numero + ' - ' + option.problema);
	    },
	    selecionaDadosBancariosFavorecido: function selecionaDadosBancariosFavorecido(item) {
	      this.nota.dados_bancarios.banco = item ? item.codban : '';
	      this.nota.dados_bancarios.agencia = item ? item.codage : '';
	      this.nota.dados_bancarios.conta = item ? item.ccbfav : '';
	      this.nota.dados_bancarios.tipo = item ? item.tiptcc : 1;
	      this.bancoSelecionado = item ? _.filter(this.listaBancos, ['codigo', this.nota.dados_bancarios.banco])[0] : null;
	      this.tipoContaSelecionado = item ? _.filter(this.tiposConta, ['codigo', this.nota.dados_bancarios.tipo])[0] : null;
	      this.$forceUpdate();
	    },
	    motivoDevolucaoDescricao: function motivoDevolucaoDescricao(option) {
	      return '' + option.descricao;
	    },
	    verificaPoderes: function verificaPoderes() {
	      var _this2 = this;
	
	      axiosLaravel.get('entidades/verificaPoderes/' + this.usuarioLogado.id).then(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(response) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (_.has(response.data, 'codigo')) {
	                    _this2.poderes = response.data;
	                  }
	                  _this2.$forceUpdate();
	
	                case 2:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }()).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    carregaMunicipios: function carregaMunicipios() {
	      var _this3 = this;
	
	      this.loading.municipios = true;
	      var listaMunicipios = [];
	      axiosLaravel.get('consulta/municipios/').then(function (response) {
	        var listaAgrupada = _.groupBy(response.data, 'sigufs');
	        _.forEach(listaAgrupada, function (municipios, uf) {
	          listaMunicipios.push({ 'uf': uf, 'municipios': municipios });
	        });
	        _this3.municipiosUf = _.sortBy(listaMunicipios, ['uf']);
	        _this3.loading.municipios = false;
	      });
	    },
	    buscaPrestacaoSimplificada: function buscaPrestacaoSimplificada() {
	      var _this4 = this;
	
	      this.loading.tela = true;
	      console.log('buscaPrestacaoSimplificada');
	      axiosLaravel.get('prestacaoSimplificada/ehPrestacaoSimplificada/' + this.id).then(function (response) {
	        _this4.ehPrestacaoSimplificada = response.data;
	      });
	    },
	    buscaDados: function buscaDados() {
	      var _this5 = this;
	
	      console.log('buscaDados');
	      this.loading.tela = true;
	      this.loading.cronograma = true;
	      var aguardaUltimaTarefa = axiosLaravel.get('pagamento/ultima/tarefa/' + this.id).then(function (response) {
	        _this5.id_entidade = response.data[0]['id_entidade'];
	        _this5.razaoSocial = response.data[0]['ds_razao_social'];
	        _this5.projeto.Id_proposta = response.data[0]['id_projeto'];
	        _this5.projeto.Projeto = response.data[0]['projeto'];
	        _this5.projeto.Objetivo = response.data[0]['objetivo_geral'];
	        _this5.projeto.Status_ERP = response.data[0]['situacao_projeto_sapiens'];
	        _this5.ehVoluntariado = _.includes(['15577'], '' + response.data[0]['projeto_superior_sapiens']);
	        _this5.projetoSuperior = response.data[0]['ds_projetoSuperior'];
	        _this5.projeto.fk_entidade = response.data[0]['id_entidade'];
	        _this5.entidade['ds_cnpj'] = response.data[0]['ds_cnpj'];
	        _this5.projeto.Numero_projeto = _.has(_this5.projeto, 'Numero_projeto') ? _this5.projeto['Numero_projeto'] : _this5.projeto.Projeto.substring(0, 5);
	        _this5.nota.id = response.data[0]['id_documento_liberacao'];
	        _this5.extratoFiltrosSelecionados.push('solicitados');
	        _this5.dirigentes = response.data['dirigentes'];
	        _this5.buscaOcorrencias();
	        _this5.verificaProjetoEcoforte();
	        _this5.buscaMotivosDevolucao();
	
	        _this5.verificaMunicipalizacao();
	
	        axiosLaravel.post('pagamento/valida/solicitante', { 'projeto': _this5.projeto, 'processo': _this5.processo }).then(function (response) {
	          if (_.get(response.data, 'codigo', 'ERRO') !== 'ERRO') {
	            _this5.entidade = response.data.retorno;
	          }
	        }).catch(function (error) {
	          console.log('error', error);
	          _this5.$root.trataErro(error);
	        });
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	      var endpoint = 'processos/';
	      if (this.ehParceiroEstrategico) {
	        endpoint = 'parceiroEstrategico/carregaProcesso/';
	      }
	
	      var aguardaProcesso = axiosLaravel.get(endpoint + this.id).then(function (response) {
	        _this5.dataProcesso = (0, _moment2.default)(response.data.inicio).format('DD/MM/YYYY');
	        if ((0, _moment2.default)(_this5.dataProcesso).isSameOrBefore((0, _moment2.default)(_this5.dataCorte))) {
	          _this5.dataMenor = true;
	        } else {
	          _this5.dataMenor = false;
	        }
	
	        _this5.historico = response.data.tarefas;
	        _this5.historicoTarefas = _.cloneDeep(response.data.tarefas);
	        _this5.historicoTarefasTela = _.cloneDeep(response.data.tarefas);
	        var array = _this5.historicoTarefas.filter(function (item) {
	          return item.tipo === 'Usuário' && !_.isNull(item.termino);
	        });
	        _this5.historicoTarefas = _.cloneDeep(array);
	        for (var i = 0; i < _this5.historicoTarefas.length; i++) {
	          if (_this5.historicoTarefas.usuario !== null) {
	            _this5.usuario = _this5.historicoTarefas.usuario;
	          }
	        }
	        var historicoDeclaracoes = _this5.historicoTarefas.find(function (item) {
	          return item.declaracoes !== null && item.declaracoes !== undefined;
	        });
	
	        if (historicoDeclaracoes && historicoDeclaracoes.declaracoes) {
	          _this5.objetoComDeclaracoes = JSON.parse(historicoDeclaracoes.declaracoes);
	        } else {
	          _this5.objetoComDeclaracoes = [];
	        }
	
	        _this5.ultimaTarefaFeita = _.chain(_.cloneDeep(_this5.historico)).filter(function (h) {
	          return h.tipo === 'Usuário' && !_.isNull(h.termino);
	        }).sortBy('id').last().value();
	
	        _this5.valorOriginal = response.data.valorOriginal;
	        _this5.buscaHistorico(_this5.id);
	
	        _this5.etapa = _.chain(_.cloneDeep(_this5.historico)).remove(['tipo', 'Usuário']).sortBy('id').last().get('nome').value();
	        if (_this5.etapa === 'Análise' && _this5.usuarioLogado.userType === 'FUNDACAO') {
	          _this5.buscaDecisoesDaAnalise();
	        }
	        _this5.validacao = response.data.documentos_liberacao[0];
	        _this5.validacao.processo = _.omit(response.data, ['documentos_liberacao', 'tarefas']);
	
	        _this5.possuiNotaSapiens = response.data.possuiNotaSapiens;
	        _this5.tituloMovimentado = response.data.tituloMovimentado;
	        _this5.nota.bypass = _this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['OPCOES', 'BYPASS']);
	        _this5.nota.tributacao = _this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['TRIBUTACAO']);
	        _this5.nota.tributacao = _this5.nota.tributacao === '' ? 'NAO_TRIBUTADO' : _this5.nota.tributacao;
	        _this5.nota.valorTributado = parseFloat(_this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['VALOR_TRIBUTADO']));
	        if (_this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['BOLETO']) !== '') {
	          _this5.nota.boleto = JSON.parse(_this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['BOLETO']));
	        }
	        _this5.cienteDeclaracoes = JSON.parse(_this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['DECLARACOES']));
	        _this5.nota.simplesNacional = _this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['SIMPLES_NACIONAL']);
	        if (_.includes(['PRESTACAO_DE_CONTAS'], _this5.processo) && _this5.ehVoluntariado) {
	          if (_this5.nota.codigoFornecedor !== '') {
	            _this5.verificaCpfCnpjSapiens(_this5.entidade.ds_cnpj);
	          }
	        }
	
	        if (_this5.ehProjetoEspecial) {
	          var dados = _this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['DADOS_COMPLEMENTARES']);
	          _this5.nota.dadosComplementares = dados === '' || _.isNull(dados) ? [] : JSON.parse(dados);
	        }
	        if (_this5.processo === 'RESSARCIMENTO') {
	          var favorecido = _this5.carregarParametrosDocumento(_this5.validacao.parametros_documento, ['FAVORECIDO']);
	
	          if (favorecido === '' || _.isNull(favorecido)) {
	            _this5.dadosFavorecido({ 'tipo': 'porIdProcesso', 'termo': _this5.id });
	          } else {
	            var favorecidoJson = JSON.parse(favorecido);
	            if (_.has(favorecidoJson, 'codfav') || _.has(favorecidoJson, 'resultado')) {
	              _this5.nota.favorecido = favorecidoJson;
	              _this5.nota.favorecido.incluidos = [];
	              _this5.nota.favorecido.excluidos = [];
	              _this5.nota.favorecido['dadosBancariosSelecionadosAnterior'] = _.clone(_this5.nota.favorecido.dadosBancariosSelecionados);
	              _this5.validacao.dados_bancarios.banco = _this5.nota.favorecido.dadosBancariosSelecionados.codban;
	              _this5.validacao.dados_bancarios.agencia = _this5.nota.favorecido.dadosBancariosSelecionados.codage;
	              _this5.validacao.dados_bancarios.conta = _this5.nota.favorecido.dadosBancariosSelecionados.ccbfav;
	              _this5.validacao.dados_bancarios.tipo = _this5.nota.favorecido.dadosBancariosSelecionados.tiptcc;
	              _this5.opcoesContasExistentesFavorecido = _this5.nota.favorecido.resultado;
	            } else {
	              _this5.dadosFavorecido({ 'tipo': 'porIdProcesso', 'termo': _this5.id });
	            }
	          }
	          _this5.nota.tributacao = 'NAO_TRIBUTADO';
	        }
	
	        var nfes = _.filter(_this5.validacao.parametros_documento, ['parametro', 'NFe']);
	        _this5.ehNFe = nfes.length > 0;
	        if (_this5.ehNFe) {
	          _this5.nfe = JSON.parse(_.last(_.sortBy(nfes, ['created_at']))['valor']);
	        }
	
	        _this5.nota.anexos = _this5.validacao.documentos;
	        _this5.nota.numeroNota = _this5.validacao.numero;
	        _this5.nota.serieNota = _this5.validacao.serie;
	        _this5.nota.dataInclusao = _this5.validacao.emissao;
	        _this5.nota.dataValidade = _this5.validacao.validade;
	        if (_this5.processo !== 'CONTRAPARTIDA') {
	          _this5.bancoSelecionado = _.filter(_this5.listaBancos, ['codigo', _this5.validacao.dados_bancarios.banco])[0];
	          _this5.nota.dados_bancarios.banco = _this5.validacao.dados_bancarios.banco;
	          _this5.nota.dados_bancarios.agencia = _this5.validacao.dados_bancarios.agencia;
	          _this5.nota.dados_bancarios.conta = _this5.validacao.dados_bancarios.conta;
	          _this5.nota.dados_bancarios.tipo = _this5.validacao.dados_bancarios.tipo;
	          _this5.tipoContaSelecionado = _.filter(_this5.tiposConta, ['codigo', _this5.nota.dados_bancarios.tipo])[0];
	          var fornecedor = _this5.validacao.dados_bancarios.fornecedor;
	          _this5.nota.tipoFornecedor = fornecedor.identificador.length === 14 ? 'Pessoa Jurídica' : 'Pessoa Física';
	          _this5.nota.cpfFornecedor = _this5.nota.tipoFornecedor === 'Pessoa Física' ? fornecedor.identificador : '';
	          _this5.nota.cnpjFornecedor = _this5.nota.tipoFornecedor === 'Pessoa Jurídica' ? fornecedor.identificador : '';
	          _this5.nota.nomeFornecedor = fornecedor.nome;
	          _this5.nota.enderecoFornecedor = fornecedor.endereco;
	          _this5.nota.cepFornecedor = fornecedor.cep;
	          _this5.verificaCpfCnpjSapiens(fornecedor.identificador);
	          _this5.procurandoCidadeUF();
	          _this5.nota.forma_pagamento = _this5.validacao.forma_pagamento;
	          _this5.nota.pagamentoPrioritario = _this5.validacao.prioridade;
	          if (_.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _this5.etapa)) {
	            _this5.dadosAnaliseTributaria();
	            _this5.carregarSuportesFbb();
	          }
	        } else {
	          if (_.includes(['Análise'], _this5.etapa)) {
	            _this5.carregarSuportesFbb();
	          }
	        }
	
	        _this5.$forceUpdate();
	        _this5.loading.tela = false;
	        _this5.periodoExecucao();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this5.$root.trataErro(error);
	      });
	
	      _promise2.default.all([aguardaUltimaTarefa, aguardaProcesso]).then(function () {
	        if (!_this5.idPropostaValido()) {
	          _this5.loading.cronograma = false;
	          return;
	        }
	
	        var cronograma = _this5.carregarCronograma();
	        if (_this5.processo === 'PRESTACAO_DE_CONTAS') {
	          _promise2.default.resolve(cronograma).then(function () {
	            _this5.carregarPrestacaoAdiantamento();
	          });
	        }
	      });
	    },
	    idPropostaValido: function idPropostaValido() {
	      var id = _.get(this.projeto, 'Id_proposta');
	      return !_.isNil(id) && id !== '' && !_.isNaN(Number(id));
	    },
	    verificaMunicipalizacao: function verificaMunicipalizacao() {
	      var _this6 = this;
	
	      if (!this.idPropostaValido()) {
	        console.warn('verificaMunicipalizacao: Id_proposta indisponível', _.get(this.projeto, 'Numero_projeto'));
	        return;
	      }
	      axiosLaravel.get('propostas/verifica_projeto_municipalizado/' + this.projeto.Id_proposta).then(function (response) {
	        _this6.ehProjetoEspecial = !!response.data;
	        if (_this6.ehProjetoEspecial) {
	          _this6.carregaMunicipios();
	        }
	        return !!response.data;
	      });
	    },
	    verificaProjetoPovosTradicionais: function verificaProjetoPovosTradicionais() {
	      var numeroProj = Number(this.projeto.Numero_projeto);
	      this.ehProjetosPovosTradicionais = this.projetosPovosTradicionais.includes(numeroProj);
	      if (this.ehProjetosPovosTradicionais) {
	        this.ciente('fornecedoresNaoLigadosDirigentes');
	        this.ciente('recursosNaoDestinadosDirigentesParentes');
	      }
	    },
	    verificaProjetoEcoforte: function verificaProjetoEcoforte() {
	      if (parseInt(this.prjsup) === 18295) {
	        this.ehProjetoEcoforte = true;
	        this.ciente('recursosNaoDestinadosDirigentesParentes');
	      }
	      console.log('ehEcoforte', this.ehProjetoEcoforte);
	    },
	    periodoExecucao: function periodoExecucao() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var response, datetimeInicial, datetimeFim;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (_this7.idPropostaValido()) {
	                  _context2.next = 3;
	                  break;
	                }
	
	                console.warn('periodoExecucao: Id_proposta indisponível', _.get(_this7.projeto, 'Numero_projeto'));
	                return _context2.abrupt('return');
	
	              case 3:
	                _context2.prev = 3;
	                _context2.next = 6;
	                return axiosLaravel.get('propostas/' + _this7.projeto.Id_proposta + '/periodo_execucao_sapiens');
	
	              case 6:
	                response = _context2.sent;
	                datetimeInicial = new Date(response.data.data_inicio_sapiens);
	                datetimeFim = new Date(response.data.data_final_sapiens);
	
	                _this7.dataFinalConvenio = new Date(response.data.data_fim_convenio);
	                _this7.projeto.data_inicial_formatada = datetimeInicial.toLocaleDateString('pt-BR');
	                _this7.projeto.data_final_formatada = datetimeFim.toLocaleDateString('pt-BR');
	                _this7.projeto.dateInicioSapiens = new Date(datetimeInicial.setDate(datetimeInicial.getDate() - 1));
	                _this7.projeto.dateFimSapiens = new Date(response.data.data_final_sapiens);
	                _this7.projeto.dateAprovacao = new Date(response.data.data_aprovacao);
	                _this7.ehVoluntariado = _.includes(['15577'], '' + response.data.projeto_superior);
	                _this7.prjsup = response.data.projeto_superior;
	                _context2.next = 22;
	                break;
	
	              case 19:
	                _context2.prev = 19;
	                _context2.t0 = _context2['catch'](3);
	
	                console.error('Erro ao buscar período de execução:', _context2.t0);
	
	              case 22:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this7, [[3, 19]]);
	      }))();
	    },
	    jsonValido: function jsonValido(json) {
	      try {
	        if (typeof json !== 'string' && (typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) !== 'object') {
	          json = undefined;
	        } else if (typeof json === 'string' && json.length > 0) {
	          json = JSON.parse(json);
	        } else if ((typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) === 'object') {
	          json = JSON.parse((0, _stringify2.default)(json));
	        } else {
	          json = undefined;
	        }
	        json = _.isObjectLike(json) ? json : undefined;
	      } catch (e) {
	        if (e instanceof SyntaxError) {
	          json = undefined;
	        }
	      }
	      return json;
	    },
	    carregarSuportesFbb: function carregarSuportesFbb() {
	      var _this8 = this;
	
	      this.loading.suportesFbbAtivos = true;
	
	      var suportes = this.carregarParametrosDocumento(this.validacao.parametros_documento, ['SUPORTE_FBB']);
	
	      this.nota.suporteFbb = this.jsonValido(suportes) || [];
	
	      if (this.ehVisualizacao) {
	        this.listaSuportes = _.cloneDeep(this.nota.suporteFbb);
	      } else {
	        axiosLaravel.get('pagamento/suportes/ativos').then(function (response) {
	          _this8.listaSuportes = _.union(_.isNull(response.data.retorno) ? [] : response.data.retorno, _this8.nota.suporteFbb);
	          if (response.data.codigo === 'ERRO') {
	            _this8.$snotify.error(response.data.mensagem);
	          }
	          _this8.loading.suportesFbbAtivos = false;
	        }).catch(function (error) {
	          _this8.loading.suportesFbbAtivos = false;
	          console.log('error de carregamento de suportes', error);
	        });
	      }
	    },
	    buscaMotivosDevolucao: function buscaMotivosDevolucao() {
	      var _this9 = this;
	
	      axiosLaravel.post('motivos/ativos').then(function (response) {
	        _this9.motivosDevolucao = response.data;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this9.$root.trataErro(error);
	      });
	    },
	    buscaHistorico: function buscaHistorico(request) {
	      var _this10 = this;
	
	      axiosLaravel.post('historico-tarefas/lista', { 'parametro': request }).then(function (response) {
	        _this10.historicoBack = response.data;
	        var tar = _.find(_this10.historico, { nome: 'Solicitação' });
	        if (!_.isEmpty(_this10.historicoBack) && !_.find(_this10.historicoBack, { nome: 'SOLICITACAO' })) {
	          if (tar && tar.nome === 'Solicitação' && _this10.dataMenor === false) {
	            _this10.historicoBack.push({
	              fk_processo: tar.fk_processo,
	              fk_tarefa: tar.id,
	              fk_usuario: tar.fk_usuario,
	              nome: 'SOLICITACAO',
	              proxima_etapa: '',
	              usuario: tar.usuario,
	              data_edicao: null,
	              inicio: tar.inicio,
	              termino: tar.termino,
	              observacao: tar.observacao,
	              cienciaDeclaracao: tar.dedeclaracoes
	            });
	          }
	        }
	
	        var tar2 = _.find(_this10.historicoBack, { nome: 'REVISAO', proxima_etapa: 'Revisão' });
	        if (tar2) {
	          var index = _.findIndex(_this10.historicoBack, { id: tar2.id });
	          _this10.historicoBack.splice(index, 1);
	        }
	      });
	    },
	    consultaProjetosEmAlteracao: function consultaProjetosEmAlteracao() {
	      var _this11 = this;
	
	      console.log('consultando se o projeto possui alteração em andamento', this.projeto.Numero_projeto);
	      axiosLaravel.get('projeto/alteracoes/verificaAlteracaoEmAndamento/' + this.projeto.Numero_projeto).then(function (response) {
	        console.log(response.data);
	        _this11.projetoComAlteracaoEmAndamento = response.data.alteracao_em_andamento;
	        if (_this11.projetoComAlteracaoEmAndamento === true) {
	          console.log('erro, projeto com alteração em andamento');
	          _this11.adicionaRestricao({ 'tag': 'projetoComAlteracaoEmAndamento', 'ativo': true, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Solicitação não disponível. Verificamos que há uma alteração de projetos em andamento.' });
	          var restricoes = _.filter(_this11.restricaoParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	          var mensagens = '<div class=avisoAlerta><li>' + _.join(_.map(restricoes, 'mensagem'), '<li>') + '</div>';
	          _this11.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	          _this11.msgErroProcessamento.push(mensagens);
	        }
	      }).catch(function (error) {
	        _this11.$snotify.clear();
	        _this11.loading.tela = false;
	        _this11.$root.trataErro(error);
	      });
	    },
	    carregarParametrosDocumento: function carregarParametrosDocumento(parametrosCarregados, parametrosBusca) {
	      var parametros = _.filter(parametrosCarregados, function (p) {
	        return _.includes(parametrosBusca, p.parametro) || _.includes(parametrosBusca, p.valor);
	      });
	      if (parametros.length > 0) {
	        return _.last(_.sortBy(parametros, ['created_at']))['valor'];
	      } else {
	        return _.includes(parametrosBusca, 'DECLARACOES') ? '[]' : '';
	      }
	    },
	    carregarPrestacaoAdiantamento: function carregarPrestacaoAdiantamento() {
	      var _this12 = this;
	
	      this.loading.adiantamentos = true;
	      axiosLaravel.get('processos/adiantamento/recursos/' + this.projeto['Id_proposta']).then(function (response) {
	        _this12.adiantamentosConcecidos = response.data.adiantamentos_concedidos.row;
	        _this12.calcularTotaisAdiantamento();
	        _this12.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this12.$root.trataErro(error);
	      }).then(function () {
	        _this12.loading.adiantamentos = false;
	      });
	    },
	    novoDadosComplementares: function novoDadosComplementares() {
	      this.nota.dadosComplementares.push({ municipio: {}, valor: 0, familias: 0, participantes: 0, destinacao: '' });
	    },
	    excluiDadosComplementares: function excluiDadosComplementares(index) {
	      _.pullAt(this.nota.dadosComplementares, index);
	      this.$forceUpdate();
	    },
	    limitaFaixaEntrada: function limitaFaixaEntrada(tipo, valor, minimo, maximo) {
	      if (_.isNil(valor) && _.isNull(valor) && _.isNaN(valor)) {
	        valor = minimo;
	      } else {
	        if (tipo === 'inteiro') {
	          valor = _.toSafeInteger(('' + valor).replace(/\D+/g, ''));
	        } else if (tipo === 'decimal') {
	          valor = _.toNumber(('' + valor).replace(/[^.0-9]+/g, ''));
	        }
	        valor = valor <= minimo ? minimo : valor >= maximo ? maximo : valor;
	      }
	      return tipo === 'inteiro' ? parseInt(valor) : tipo === 'decimal' ? parseFloat(valor) : valor;
	    },
	    carregarListaProjetos: function carregarListaProjetos() {
	      var _this13 = this;
	
	      this.loading.tela = true;
	      if (typeof Storage !== 'undefined') {
	        var listaProjetos = JSON.parse(window.localStorage.getItem('lista-projetos'));
	
	        var semCache = true;
	        if (semCache) {
	          axiosLaravel.post('processos/projetos', { 'processo': this.processo, 'tipoBusca': 'simples' }).then(function (response) {
	            var listaProjetos = response.data;
	            var acessosProjetos = _.get(_this13.usuarioLogado, 'configuracoes.acesso_projetos');
	            if (acessosProjetos) {
	              var permissoesAcesso = ['INICIA_SOLICITACAO'];
	              acessosProjetos = _.map(_.filter(acessosProjetos, function (p) {
	                return _.find(p.acesso, function (a) {
	                  return _.includes(permissoesAcesso, a.codigo);
	                });
	              }), 'numero');
	              listaProjetos = _.filter(listaProjetos, function (p) {
	                return _.includes(acessosProjetos, p['Numero_projeto']);
	              });
	            }
	            _this13.listaProjetos = listaProjetos;
	            _this13.alertaRetorna();
	            window.localStorage.setItem('lista-projetos', (0, _stringify2.default)({ 'atualizado': Math.floor(new Date().getTime()), 'lista': _this13.listaProjetos }));
	            _this13.$forceUpdate();
	            _this13.loading.tela = false;
	          }).catch(function (error) {
	            console.log('error', error);
	            _this13.$root.trataErro(error);
	          });
	        } else {
	          this.listaProjetos = _.cloneDeep(listaProjetos.lista);
	          this.alertaRetorna();
	          this.loading.tela = false;
	        }
	      }
	    },
	    alertaRetorna: function alertaRetorna() {
	      var _this14 = this;
	
	      if (_.isEmpty(this.listaProjetos)) {
	        this.$snotify.error('Não há projetos para ' + this.descricaoProcesso[this.processo]);
	        setTimeout(function () {
	          _this14.$router.go(-1);
	        }, 1000);
	      } else if (this.listaProjetos.length === 1) {
	        this.projeto = _.head(this.listaProjetos);
	        this.selecionaProjeto();
	      }
	    },
	    verificarTitulosDisponiveisPC: function verificarTitulosDisponiveisPC() {
	      var _this15 = this;
	
	      axiosLaravel.post('processos/verifica_titulos_adiantamento', { 'numeroProjeto': this.projeto.Numero_projeto }).then(function (response) {
	        console.log('verificarTitulosDisponiveisPC', response.data);
	        if (_.get(response.data, 'codigo', '') === 'ERRO') {
	          _this15.adicionaRestricao({ 'tag': 'adiantamentoNaoDisponivelParaPrestarContas', 'ativo': true, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Ainda não há título de adiantamento disponível para prestar contas' });
	        } else {
	          console.log('verificarTitulosDisponiveisPC ERRO', response.data);
	        }
	      }).catch(function (error) {
	        console.log('error', error);
	        _this15.$root.trataErro(error);
	      });
	    },
	    selecionaProjeto: function selecionaProjeto() {
	      var _this16 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this16.loading.tela = true;
	                _context3.next = 3;
	                return _this16.periodoExecucao();
	
	              case 3:
	                _this16.verificaMunicipalizacao();
	                _this16.consultaProjetosEmAlteracao();
	                _this16.verificaProjetoPovosTradicionais();
	                _this16.verificaProjetoEcoforte();
	
	                axiosLaravel.post('pagamento/valida/solicitante', { 'projeto': _this16.projeto, 'processo': _this16.processo }).then(function (response) {
	                  if (_.has(response.data, 'codigo')) {
	                    if (response.data.codigo === 'ERRO') {
	                      _this16.restricaoParaInicializar = _.has(response.data, 'mensagem') && !_.isNull(response.data.mensagem) && response.data.mensagem.length > 0 ? response.data.mensagem : ['Erro de processamento. Não sei o que houve'];
	                    } else {
	                      _this16.entidade = response.data.retorno;
	                      _this16.buscaOcorrencias();
	
	                      var cronograma = _this16.carregarCronograma();
	                      if (_this16.processo === 'PRESTACAO_DE_CONTAS') {
	                        _promise2.default.resolve(cronograma).then(function () {
	                          _this16.carregarPrestacaoAdiantamento();
	                        });
	                      }
	                      if (_this16.processo === 'RESSARCIMENTO') {
	                        if (_this16.projeto.Status_ERP !== 'APR') {
	                          _this16.bloqueiaCamposFornecedorExistente = true;
	                          _this16.ehVisualizacao = true;
	                          _this16.restricaoParaInicializar.push('Apenas projetos com Status APR estão aptos a solicitar ressarcimento.');
	                        }
	                        _this16.dadosFavorecido({ 'tipo': 'porCNPJ', 'termo': _this16.entidade.ds_cnpj });
	                      }
	                    }
	                  }
	                  _this16.loading.tela = false;
	                }).catch(function (error) {
	                  console.log('error', error);
	                  _this16.$root.trataErro(error);
	                });
	
	              case 8:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this16);
	      }))();
	    },
	    buscaOcorrencias: function buscaOcorrencias() {
	      var _this17 = this;
	
	      axiosLaravel.post('ocorrencia/busca', { 'informacao': 'SIMPLIFICADO', 'projeto': this.projeto.Numero_projeto, 'nivel': [2, 3, 4], 'situacao': 'LIBERADO' }).then(function (response) {
	        if (_.get(response.data, 'codigo', '') === 'OK') {
	          _this17.ocorrencias = response.data.retorno;
	          if (_this17.ocorrencias.length > 0) {
	            _this17.temOcorrencia = true;
	            if (_.find(_this17.ocorrencias, function (o) {
	              return _.includes([2201, 2202], o.codigo);
	            }) && _.includes(['PAGAMENTO', 'RESSARCIMENTO'], _this17.processo)) {
	              _this17.restricaoParaInicializar.push('Possui ocorrência(s) que não permite liberar Pagamentos nem Ressarcimentos');
	            }
	          }
	        } else {
	          _this17.$snotify.error(response.data.mensagem);
	        }
	        _this17.$forceUpdate();
	      }).catch(function (error) {
	        _this17.$snotify.clear();
	        _this17.$root.trataErro(error);
	      });
	    },
	    carregarCronograma: function carregarCronograma() {
	      var _this18 = this;
	
	      this.loading.cronograma = true;
	      var idDocumento = _.has(this.nota, 'id') ? this.nota.id : 1;
	      return axiosLaravel.post('processos/cronograma/projeto/', { 'proposta': this.projeto['Id_proposta'], 'processo': this.processo, 'aglutinado': 'Completo', 'documento': idDocumento }).then(function (response) {
	        _this18.cronograma = response.data;
	        if (_.has(_this18.validacao, 'itens_liberados')) {
	          _this18.validacao.itens_liberados.forEach(function (itemLiberado) {
	            _this18.cronograma.itens.forEach(function (itemOrcamento) {
	              if (itemOrcamento.Id_item === itemLiberado.itens_orcamentos[0]['id']) {
	                itemOrcamento.Qtde_saldo += itemLiberado.quantidade;
	                itemOrcamento.Valor_saldo += itemLiberado.valor;
	              }
	            });
	          });
	
	          _this18.filtrarPorOrigemRecurso(_.some(_.flatten(_.map(_.filter(_this18.validacao.itens_liberados, ['tipo', 'BASE']), 'itens_orcamentos')), { 'origem': 1 }) ? 'fundacao' : 'parceiro');
	        } else {
	          _this18.filtrarPorOrigemRecurso(_.find(_this18.cronograma.itens, function (i) {
	            return ('' + i.Item_Origem).substring(0, 1) === '1';
	          }) ? 'fundacao' : 'parceiro');
	        }
	
	        _this18.valoresProjeto();
	        if (_.includes(['PRESTACAO_DE_CONTAS'], _this18.processo) && _.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _this18.etapa) && _this18.usuarioLogado.userType === 'FUNDACAO') {
	          _this18.verificarTitulosDisponiveisPC();
	        }
	        _this18.loading.cronograma = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this18.$root.trataErro(error);
	      });
	    },
	    valoresProjeto: function valoresProjeto() {
	      var _this19 = this;
	
	      axiosLaravel.post('processos/valores/projeto/', { 'numeroProjeto': this.projeto['Numero_projeto'], 'processo': this.processo, 'etapa': this.etapa }).then(function (response) {
	        console.log('valoresProjeto >>> ', response.data);
	        if (_.get(response.data, 'codigo', '') === 'ERRO' && response.data.mensagem.length > 0) {
	          response.data.mensagem.forEach(function (msg) {
	            _this19.adicionaRestricao({ 'tag': 'valoresTotaisIncorretosProjeto_' + msg.codigo, 'ativo': true, 'tipo': 'restricao', 'acao': null, 'mensagem': msg.mensagem });
	          });
	        }
	      }).catch(function (error) {
	        console.log('error', error);
	        _this19.$root.trataErro(error);
	      });
	    },
	    filtrarExtrato: function filtrarExtrato() {
	      var _this20 = this;
	
	      var ehProjetoSemServico = this.ehProjetoComRestricaoPagamentoServico();
	      this.cronograma.itens.forEach(function (item) {
	        var selecionados = 0;
	
	        selecionados += _.includes(_this20.extratoFiltrosSelecionados, 'saldos') && _.has(item, 'Valor_saldo') && item.Valor_saldo > 0 ? 1 : 0;
	
	        selecionados += _.includes(_this20.extratoFiltrosSelecionados, 'fundacao') && _.has(item, 'Item_Origem') && item.Item_Origem === 1 ? 1 : 0;
	        selecionados += _.includes(_this20.extratoFiltrosSelecionados, 'parceiro') && _.has(item, 'Item_Origem') && item.Item_Origem === 5 ? 1 : 0;
	
	        selecionados += _.includes(_this20.extratoFiltrosSelecionados, 'solicitados') && _.has(item, 'Valor_solicitado') && item.Valor_solicitado > 0 && _.has(item, 'Qtde_solicitado') && item.Qtde_solicitado > 0 ? 1 : 0;
	        item['mostrar'] = _this20.processo === 'CONTRAPARTIDA' ? true : _this20.extratoFiltrosSelecionados.length === selecionados;
	        if (ehProjetoSemServico && item.Item_Tipo === 'SERVICO') {
	          item.mostrar = false;
	        }
	      });
	    },
	    filtrarAdiantamentosConcedidos: function filtrarAdiantamentosConcedidos() {
	      var _this21 = this;
	
	      this.adiantamentosConcecidos.forEach(function (item) {
	        var selecionados = 0;
	
	        selecionados += _.includes(_this21.adiantamentosFiltrosSelecionados, 'adiantamento_pendente') && item.pendente_comprovacao !== 0 ? 1 : 0;
	        item['mostrar'] = _this21.adiantamentosFiltrosSelecionados.length === selecionados;
	      });
	    },
	    adicionaRestricao: function adicionaRestricao(ev) {
	      if (!_.isNil(ev) && _.has(ev, 'tag')) {
	        _.remove(this.restricaoParaConcluir, function (i) {
	          return i.tag === ev.tag;
	        });
	
	        this.restricaoParaConcluir.push(ev);
	      }
	    },
	    removeRestricao: function removeRestricao(ev) {
	      _.remove(this.restricaoParaConcluir, function (i) {
	        return i.tag === ev.tag;
	      });
	    },
	    selecaoEconomicidade: function selecaoEconomicidade() {
	      this.verificaCorrigeDados();
	    },
	    verificaCorrigeDados: function verificaCorrigeDados() {
	      var _this22 = this;
	
	      this.$forceUpdate();
	      this.nota.itens = [];
	      this.cronograma.itens.forEach(function (item) {
	        item['valorSolicitado'] = item.Valor_solicitado;
	        item['quantidadeSolicitada'] = item.Qtde_solicitado;
	        if (parseFloat(item.Qtde_solicitado) > 0 && parseFloat(item.Valor_solicitado) > 0) {
	          _this22.nota.itens.push(item);
	        }
	      });
	    },
	    calcularTotaisExtato: function calcularTotaisExtato() {
	      this.verificaCorrigeDados();
	      var fbb = this.valorProjetoOrigem('1');
	      var contrapartida = this.valorProjetoOrigem('2');
	      var parceiro = this.valorProjetoOrigem('5');
	      this.totais.projeto.fbb.orcado = fbb.orcado;
	      this.totais.projeto.fbb.solicitado = fbb.solicitado;
	      this.totais.projeto.fbb.saldo = fbb.saldo;
	      this.totais.projeto.contrapartida.orcado = contrapartida.orcado;
	      this.totais.projeto.contrapartida.solicitado = contrapartida.solicitado;
	      this.totais.projeto.contrapartida.saldo = contrapartida.saldo;
	      this.totais.projeto.parceiros.orcado = parceiro.orcado;
	      this.totais.projeto.parceiros.solicitado = parceiro.solicitado;
	      this.totais.projeto.parceiros.saldo = parceiro.saldo;
	      this.totais.projeto.total.orcado = fbb.orcado + contrapartida.orcado + parceiro.orcado;
	
	      if (this.etapa === 'Solicitação') {
	        if (this.extratoFiltrosSelecionados.includes('fundacao')) {
	          parceiro.solicitado = 0;
	          this.cronograma.itens.forEach(function (item) {
	            if (item.Item_Origem === 5) {
	              item.Qtde_solicitado = 0;
	              item.Valor_solicitado = 0;
	            }
	          });
	        } else if (this.extratoFiltrosSelecionados.includes('parceiro')) {
	          fbb.solicitado = 0;
	          this.cronograma.itens.forEach(function (item) {
	            if (item.Item_Origem === 1) {
	              item.Qtde_solicitado = 0;
	              item.Valor_solicitado = 0;
	            }
	          });
	        }
	      }
	
	      this.totais.projeto.total.solicitado = fbb.solicitado + contrapartida.solicitado + parceiro.solicitado;
	      this.totais.projeto.total.saldo = fbb.saldo + contrapartida.saldo + parceiro.saldo;
	
	      this.totais.projeto.total.solicitado = Math.round(this.totais.projeto.total.solicitado * 100) / 100;
	      this.$forceUpdate();
	    },
	    valorDesteDocumentoPorOrigem: function valorDesteDocumentoPorOrigem() {
	      var estorno = { fbb: 0, parceiros: 0 };
	      if (this.processo !== 'PRESTACAO_DE_CONTAS' || !_.has(this.validacao, 'itens_liberados')) {
	        return estorno;
	      }
	      _.filter(this.validacao.itens_liberados, ['tipo', 'BASE']).forEach(function (itemLiberado) {
	        var origem = ('' + _.get(itemLiberado, 'itens_orcamentos[0].origem', '')).substring(0, 1);
	        var valor = parseFloat(itemLiberado.valor) || 0;
	        if (origem === '1') {
	          estorno.fbb += valor;
	        } else if (origem === '5') {
	          estorno.parceiros += valor;
	        }
	      });
	      return estorno;
	    },
	    calcularTotaisAdiantamento: function calcularTotaisAdiantamento() {
	      var estorno = this.valorDesteDocumentoPorOrigem();
	      this.totais.adiantamento.fbb.saldo = Math.round((_.sumBy(this.adiantamentosConcecidos, function (i) {
	        return i.recurso === 'FUNDACAO' ? i.pendente_comprovacao : 0;
	      }) + estorno.fbb) * 100) / 100;
	      this.totais.adiantamento.fbb.orcado = _.sumBy(this.adiantamentosConcecidos, function (i) {
	        return i.recurso === 'FUNDACAO' ? i.contratado : 0;
	      });
	      this.totais.adiantamento.fbb.solicitado = _.sumBy(this.adiantamentosConcecidos, function (i) {
	        return i.recurso === 'FUNDACAO' ? i.requisitado : 0;
	      });
	      this.totais.adiantamento.parceiros.saldo = Math.round((_.sumBy(this.adiantamentosConcecidos, function (i) {
	        return i.recurso === 'PARCEIRO_ESTRATEGICO' ? i.pendente_comprovacao : 0;
	      }) + estorno.parceiros) * 100) / 100;
	      this.totais.adiantamento.parceiros.orcado = _.sumBy(this.adiantamentosConcecidos, function (i) {
	        return i.recurso === 'PARCEIRO_ESTRATEGICO' ? i.contratado : 0;
	      });
	      this.totais.adiantamento.parceiros.solicitado = _.sumBy(this.adiantamentosConcecidos, function (i) {
	        return i.recurso === 'PARCEIRO_ESTRATEGICO' ? i.requisitado : 0;
	      });
	      this.totais.adiantamento.total.solicitado = this.totais.adiantamento.fbb.solicitado + this.totais.adiantamento.parceiros.solicitado;
	      this.totais.adiantamento.total.orcado = this.totais.adiantamento.fbb.orcado + this.totais.adiantamento.parceiros.orcado;
	      this.totais.adiantamento.total.saldo = this.totais.adiantamento.fbb.saldo + this.totais.adiantamento.parceiros.saldo;
	      this.$forceUpdate();
	
	      if (_.includes(['Solicitação', 'Revisão'], this.etapa) && _.has(this.cronograma, 'itens') && this.adiantamentosConcecidos.length !== _.uniq(_.map(this.adiantamentosConcecidos, function (p) {
	        return '' + p.numeroTitulo;
	      })).length) {
	        this.filtrarPorOrigemRecurso(this.totais.adiantamento.fbb.saldo > 0 ? 'fundacao' : 'parceiro');
	      }
	    },
	    valorProjetoOrigem: function valorProjetoOrigem(origem) {
	      var valorOrcado = 0;
	      var valorSolicitado = 0;
	      var valorSaldo = 0;
	      var valorAdiantavelOrcado = 0;
	      if (_.isEmpty(this.cronograma) || !_.has(this.cronograma, 'itens') || this.cronograma.itens.length === 0) {
	        return { orcado: 0, saldo: 0, solicitado: 0, adiantavel: 0 };
	      }
	      this.cronograma.itens.forEach(function (item) {
	        if (('' + item.Item_Origem).substring(0, 1) === origem) {
	          valorOrcado += parseFloat(item.Valor_orcado);
	          valorSolicitado += parseFloat(item.Valor_solicitado);
	          valorSaldo += parseFloat(item.Valor_saldo);
	          valorAdiantavelOrcado += '' + item.Adiantavel === '1' ? parseFloat(item.Valor_orcado) : 0;
	        }
	      });
	      return { orcado: valorOrcado, saldo: valorSaldo, solicitado: valorSolicitado, adiantavel: valorAdiantavelOrcado };
	    },
	    validaAjustaCodigoBarras: function validaAjustaCodigoBarras() {
	      var numeroInformadoLimpo = ('' + this.nota.boleto.numeroInformadoTela).replace(/\D+/g, '');
	      if (numeroInformadoLimpo.length > 0 && '' + this.nota.forma_pagamento === '4') {
	        var tipo = _boletoUtils2.default.identificarTipoCodigo(numeroInformadoLimpo);
	        this.errors.remove('código de barras');
	        if (tipo === 'TAMANHO_INCORRETO' || !_.includes([44, 47, 48], numeroInformadoLimpo.length)) {
	          this.errors.add({ field: 'código de barras', msg: 'Tamanho do número incorreto!' });
	        } else {
	          var validacao = _boletoUtils2.default.validarBoleto(numeroInformadoLimpo, tipo);
	          if (validacao.sucesso) {
	            this.nota.boleto = validacao;
	            _.set(this.nota.boleto, 'numeroInformadoTela', numeroInformadoLimpo);
	          } else {
	            var mensagem = _.capitalize(tipo.replaceAll('_', ' ')) + ' acima está incorreto!';
	            this.errors.add({ field: 'código de barras', msg: mensagem });
	          }
	        }
	      }
	    },
	    verificaCpfCnpjSapiens: function verificaCpfCnpjSapiens(CpfCnpj) {
	      var _this23 = this;
	
	      if (_.isNull(CpfCnpj) || _.isEmpty(CpfCnpj) || _.isUndefined(CpfCnpj)) {
	        return;
	      }
	      if (_.isString(this.validandoCpfCnpj())) {} else {
	        if (('' + this.entidade.ds_cnpj).toUpperCase().replace(/[^0-9A-Z]/g, '') === ('' + CpfCnpj).toUpperCase().replace(/[^0-9A-Z]/g, '') && _.includes(['PAGAMENTO', 'RESSARCIMENTO'], this.processo) && _.includes(['Solicitação', 'Revisão', 'Análise'], this.etapa)) {
	          var mensagem = this.processo === 'PAGAMENTO' ? 'O CNPJ inserido coincide com o da entidade.<br/>Se for solicitar <a href="./ressarcimento">Ressarcimento</a> favor escolher a opção correspondente em Nova Solicitação.' : 'O CNPJ inserido coincide com o da entidade.<br/>Favor inserir uma solicitação para cada documento conforme a numeração, CPF, CNPJ ou data.';
	          this.$dialog.alert(mensagem, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	        }
	        this.loading.tela = true;
	        axiosLaravel.get('consulta/busca-fornecedor/' + CpfCnpj).then(function (response) {
	          if (_.includes(['Solicitação'], _this23.etapa) && !_.includes(['PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _this23.processo)) {
	            _this23.limpaDadosBancarios();
	          }
	          if (!_.isEmpty(response.data)) {
	            _this23.nota.enderecoFornecedor = response.data.EndFor;
	            _this23.nota.nomeFornecedor = response.data.NomFor;
	            _this23.nota.cepFornecedor = response.data.CepFor;
	            _this23.nota.codigoFornecedor = response.data.CodFor;
	            _this23.bloqueiaCamposFornecedorExistente = true;
	            _this23.procurandoCidadeUF();
	            _this23.buscaDadosbancariosFornecedor(CpfCnpj);
	          }
	          if (_.isNull(_.get(_this23.projeto, 'edital', null)) && _this23.nota.tipoFornecedor === 'Pessoa Jurídica' && '' + _this23.entidade.nr_codigo_forn_erp !== '' + _this23.nota.codigoFornecedor && _.includes(['Solicitação', 'Revisão'], _this23.etapa)) {
	            _this23.verificaCnpjEmpresaLigada(CpfCnpj);
	          }
	          _this23.loading.tela = false;
	          _this23.$forceUpdate();
	        }).catch(function (error) {
	          _this23.loading.tela = false;
	          _this23.$snotify.clear();
	          _this23.$root.trataErro(error);
	        });
	
	        if (this.nota.tipoFornecedor === 'Pessoa Física') {
	          axiosLaravel.post('entidades/verificaDirigente', { 'cpf': CpfCnpj, 'cnpj': this.entidade.ds_cnpj, 'projeto': this.projeto.Numero_projeto }).then(function (response) {
	            var dirigenteVedado = _.get(response.data, 'codigo', 'OK') !== 'OK';
	            var mensagemVedacao = _.get(response.data, 'mensagem', 'Não foi possível validar o dirigente informado');
	            _this23.errors.remove('cpf vinculado a dirigente');
	            if (dirigenteVedado) {
	              _this23.$snotify.error(mensagemVedacao);
	              _this23.errors.add({ field: 'cpf vinculado a dirigente', rule: 'cpf_dirigente_vedado', msg: mensagemVedacao });
	            }
	            _this23.adicionaRestricao({ 'tag': 'cpfDirigenteVedado', 'ativo': dirigenteVedado, 'tipo': 'restricao', 'acao': null, 'mensagem': mensagemVedacao });
	            _this23.$forceUpdate();
	          }).catch(function (error) {
	            _this23.$snotify.clear();
	            _this23.$root.trataErro(error);
	          });
	        }
	      }
	    },
	    ciente: function ciente(codigo) {
	      console.log('codigo: ', codigo);
	      if (_.find(this.cienteDeclaracoes, ['codigo', codigo])) {
	        _.remove(this.cienteDeclaracoes, ['codigo', codigo]);
	      } else {
	        this.cienteDeclaracoes.push({ 'codigo': codigo, 'texto': _.get(_.find(this.declaracoes, ['codigo', codigo]), 'texto', ''), 'data': new Date(), 'usuario': { 'id': this.usuarioLogado.id, 'nome': this.usuarioLogado.ds_nome_usuario } });
	      }
	      this.$forceUpdate();
	    },
	    textoDeclaracao: function textoDeclaracao(texto) {
	      var _this24 = this;
	
	      var regex = /{{(.*?)}}/g;
	      var correspondencias = texto.match(regex);
	      correspondencias.forEach(function (correspondencia) {
	        var valor = _.get(_this24, correspondencia.replaceAll('{{', '').replaceAll('}}', ''));
	        valor = _.isUndefined(valor) || _.isNull(valor) || _.isEmpty(valor) ? '' : valor;
	        texto = _.replace(texto, '' + correspondencia, '' + valor);
	      });
	      return texto;
	    },
	    verificaCnpjEmpresaLigada: function verificaCnpjEmpresaLigada(cnpj) {
	      var _this25 = this;
	
	      this.loading.tela = true;
	      axiosLaravel.post('consulta/empresas-ligadas', { 'id': this.projeto.fk_entidade, 'cnpj': cnpj }).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	          var qtdeDirigentesEmpresasLigadas = response.data.retorno;
	          _this25.errors.remove('cnpj vinculado a dirigente');
	          if (qtdeDirigentesEmpresasLigadas > 0) {
	            _this25.errors.add({ field: 'cnpj vinculado a dirigente', rule: 'cnpj_empresa_ligada', msg: 'Não pode usar esse CNPJ, pois esta vinculado a ' + (qtdeDirigentesEmpresasLigadas + ' ' + (qtdeDirigentesEmpresasLigadas > 1 ? 'dirigentes' : 'dirigente')) });
	          }
	          _this25.adicionaRestricao({ 'tag': 'temEmpresaLigada', 'ativo': qtdeDirigentesEmpresasLigadas > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Não pode prosseguir com esse CNPJ, pois está vinculado a ' + (qtdeDirigentesEmpresasLigadas + ' ' + (qtdeDirigentesEmpresasLigadas > 1 ? 'dirigentes ativos' : 'dirigente ativo')) + ' a menos de 12 meses' });
	        } else {
	          _this25.$snotify.error(response.data.mensagem);
	        }
	        _this25.$forceUpdate();
	        _this25.loading.tela = false;
	      }).catch(function (error) {
	        _this25.loading.tela = false;
	        console.log('error', error);
	        _this25.$root.trataErro(error);
	      });
	    },
	    aviso: function aviso(retorno) {
	      if (_.has(retorno, 'codigo')) {
	        var mensagem = _.has(retorno, 'mensagem') && !_.isNull(retorno.mensagem) && !_.isEmpty(retorno.mensagem) ? retorno.mensagem : 'Erro ao processar a requisição';
	        if (retorno.codigo === 'ERRO') {
	          this.$snotify.clear();
	          this.$snotify.error(mensagem);
	        } else {
	          if (_.includes(['OK', 'AVISO'], retorno.codigo)) {
	            this.$snotify.success(mensagem, { timeout: 30000 });
	          }
	        }
	      }
	    },
	    validarChaveNFe: function validarChaveNFe() {
	      var _this26 = this;
	
	      this.$snotify.clear();
	
	      if (('' + this.nfe.chaveAcesso).length >= 0) {
	        this.nfe.chaveAcesso = this.nfe.chaveAcesso.replace(/\D+/g, '');
	      }
	
	      if (_.has(this.nfe.protocoloValidacao, 'infProt') && this.nfe.chaveAcesso === this.nfe.protocoloValidacao.infProt.chNFe) {
	        return;
	      }
	
	      if (('' + this.nfe.chaveAcesso).length === 44) {
	        this.loading.tela = true;
	        this.$aguarde('Validando chave de acesso...');
	
	        this.nfe.validada = false;
	        this.nfe.dataValidacao = null;
	        this.nfe.idUsuarioConsulta = null;
	
	        this.nfe.protocoloValidacao = null;
	
	        axiosLaravel.post('pagamento/valida/nfe', { 'tipo': 'NF-e', 'idProcesso': this.id, 'chave': this.nfe.chaveAcesso }).then(function (response) {
	          if (_.has(response.data, 'codigo') && response.data.codigo === 'OK') {
	            var retorno = response.data.retorno;
	            _this26.nfe.dataValidacao = Date.now();
	            _this26.nfe.idUsuarioConsulta = _this26.usuarioLogado.id;
	            _this26.nfe.xmlNfe = retorno.NFe;
	            _this26.nfe.protocoloValidacao = retorno.protocoloValidacao;
	            _this26.nfe.validada = true;
	            _this26.preenchendoSolicitacao();
	          }
	          _this26.$snotify.clear();
	          _this26.aviso(response.data.mensagem);
	          _this26.loading.tela = false;
	        }).catch(function (error) {
	          _this26.loading.tela = false;
	          _this26.$snotify.clear();
	          _this26.$root.trataErro(error);
	        });
	      } else if (_.isNull(this.nfe.chaveAcesso) || ('' + this.nfe.chaveAcesso).length !== 44) {
	        this.$snotify.clear();
	        this.limparSolicitacao();
	      }
	    },
	    limparSolicitacao: function limparSolicitacao() {
	      this.nota.numeroNota = '';
	      this.nota.dataInclusao = null;
	      this.nota.dataValidade = null;
	      this.nota.serieNota = null;
	      this.nota.tipoFornecedor = null;
	      this.nota.cpfFornecedor = '';
	      this.nota.cnpjFornecedor = '';
	      this.nota.nomeFornecedor = '';
	      this.nota.enderecoFornecedor = '';
	      this.nota.codigoFornecedor = '';
	      this.nota.cepFornecedor = '';
	      this.nota.serieNota = null;
	      this.nota.formaPagamento = null;
	      this.nota.dados_bancarios.banco = '';
	      this.nota.dados_bancarios.agencia = '';
	      this.nota.dados_bancarios.conta = '';
	      this.nota.dados_bancarios.tipo = 1;
	      this.nota.observacao = null;
	    },
	    preenchendoSolicitacao: function preenchendoSolicitacao() {
	      var info = this.nfe.xmlNfe.NFe.infNFe;
	      var emitente = this.nfe.xmlNfe.NFe.infNFe.emit;
	      var endereco = emitente.enderEmit;
	      this.nota.numeroNota = info.ide.nNF;
	      this.nota.dataInclusao = info.ide.dhEmi;
	      this.nota.serieNota = 'NOTA_FISCAL';
	      if (_.has(emitente, 'CNPJ')) {
	        this.nota.tipoFornecedor = 'Pessoa Jurídica';
	        this.nota.cpfFornecedor = '';
	        this.nota.cnpjFornecedor = emitente.CNPJ;
	        this.nota.nomeFornecedor = emitente.xNome.substring(0, 255);
	        var enderecoCompleto = endereco.xLgr + ', ' + endereco.nro + ', ' + endereco.xCpl + ', ' + endereco.xBairro;
	        this.nota.enderecoFornecedor = enderecoCompleto.substring(0, 255);
	        this.nota.cepFornecedor = endereco.CEP;
	        this.procurandoCidadeUF();
	      }
	      this.nota.serieNota = 'NOTA_FISCAL';
	      this.$validator.validateAll();
	    },
	    salvar: function salvar() {
	      var _this27 = this;
	
	      this.aprovacao.resultadoAprovacao = 'Salvar';
	
	      if (this.etapa === 'Autorização') {
	        var timer = Math.floor(Math.random() * 5000) + 10000;
	        this.loading.tela = true;
	        this.$aguarde('Analisando dados...');
	        setTimeout(function () {
	          _this27.$snotify.clear();
	          _this27.validarConclusao();
	        }, timer);
	      } else {
	        this.validarConclusao();
	      }
	    },
	    preconcluir: function preconcluir() {
	      var _this28 = this;
	
	      if (this.usuarioLogado.userType === 'FUNDACAO') {
	        if (!this.confirmaValorOriginalDiferente && this.processo === 'PRESTACAO_DE_CONTAS' && this.totais.projeto.total.solicitado !== this.valorOriginal && this.etapa !== 'Solicitação') {
	          this.$dialog.confirm('\u26A0\uFE0F O valor desta solicita\xE7\xE3o mudou em rela\xE7\xE3o ao que foi informado na etapa de solicita\xE7\xE3o (R$ ' + this.valorOriginal + ').', {
	            html: true,
	            animation: 'fade',
	            customClass: 'avisoAlerta',
	            type: 'warning',
	            confirmButtonText: 'Estou ciente, continuar!',
	            cancelButtonText: 'Cancelar e revisar'
	          }).then(function (dialog) {
	            _this28.concluir();
	          }).catch(function () {
	            _this28.$snotify.warning('Operação não realizada, revise os valores');
	          });
	        } else {
	          this.concluir();
	        }
	      } else {
	        this.concluir();
	      }
	    },
	    concluir: function concluir() {
	      var _this29 = this;
	
	      this.botao_concluir_disabled = true;
	
	      if (this.wait) {
	        return;
	      }
	      this.wait = true;
	
	      setTimeout(function () {
	        return _this29.wait = false;
	      }, 2000);
	
	      this.loading.tela = true;
	      this.aprovacao.resultadoAprovacao = _.includes(['Solicitação', 'Revisão'], this.etapa) ? 'Análise' : this.aprovacao.resultadoAprovacao;
	      this.validarConclusao();
	      this.loading.tela = false;
	    },
	    validarConclusao: function validarConclusao() {
	      var _this30 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var identificador, data, ehDevolucaoParaRevisao, ehDevolucaoParaAnalise, itensSolicitados, qtdeProdutos, qtdeServicos, itensSolicitadoSaldoNegativo;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (_this30.etapa === 'Solicitação' && ['PAGAMENTO'].includes(_this30.processo) && _this30.nota.forma_pagamento === '4') {
	                  _this30.adicionaRestricao({ 'tag': 'boletoInvalido', 'ativo': _.isEmpty(_this30.nota.boleto.numeroInformadoTela) && _this30.tipoDocumento === 'boleto', 'tipo': 'restricao', 'acao': null, 'mensagem': 'Código de Barras do Boleto não informado.' });
	                }
	                _this30.verificaCorrigeDados();
	
	                if (_this30.processo === 'PRESTACAO_DE_CONTAS' && _.includes(['Solicitação'], _this30.etapa)) {
	                  _this30.calcularTotaisExtato();
	                }
	
	                _this30.adicionaRestricao({ 'tag': 'nfeValidada', 'ativo': _this30.ehNFe && !_this30.nfe.validada, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Se é NF-e, informe uma chave válida' });
	
	                _this30.adicionaRestricao({ 'tag': 'cienteDeclaracoes', 'ativo': _this30.cienteDeclaracoes.length < 2 && _.includes(['Solicitação', 'Revisão'], _this30.etapa) && !_this30.ehVisualizacao && _this30.processo !== 'CONTRAPARTIDA' && !_this30.ehProjetosPovosTradicionais, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Deve confirmar que está ciente das declarações no final desta solicitação' });
	
	                _this30.adicionaRestricao({ 'tag': 'nenhumItemInformado', 'ativo': _this30.nota.itens.length === 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Não há item indicado no cronograma' });
	
	                if (!_this30.ehPrestacaoSimplificada) {
	                  _this30.adicionaRestricao({ 'tag': 'temAnexo', 'ativo': _this30.nota.anexos.length === 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'É necessário anexar pelo menos um documento comprobatório' });
	                }
	
	                if (!(_this30.etapa === 'Análise' && ['PRESTACAO_DE_CONTAS', 'PAGAMENTO', 'RESSARCIMENTO'].includes(_this30.processo))) {
	                  _context4.next = 13;
	                  break;
	                }
	
	                identificador = _this30.nota.cpfFornecedor;
	
	                if (_this30.nota.cpfFornecedor === '') {
	                  identificador = _this30.nota.cnpjFornecedor;
	                }
	                data = {
	                  numero: _this30.nota.numeroNota,
	                  identificador: identificador,
	                  serie: _this30.nota.serieNota,
	                  id: _this30.id
	                };
	                _context4.next = 13;
	                return axiosLaravel.post('processos/tarefas/validaDocumentoAnalisePrestacao', data).then(function (response) {}).catch(function (error) {
	                  _this30.$snotify.clear();
	                  _this30.$root.trataErro(error);
	                  console.log('ERRO');
	                  _this30.loading.tela = false;
	                  throw error;
	                });
	
	              case 13:
	                if (_this30.processo === 'PRESTACAO_DE_CONTAS' && (_.isNull(_this30.id) || _this30.etapa === 'Solicitação')) {
	                  _this30.adicionaRestricao({ 'tag': 'prestacaoAcimaSaldo', 'ativo': _this30.totais.projeto.total.solicitado > _this30.totais.adiantamento.total.saldo, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Solicitação superior ao pendente de prestação R$ ' + _this30.totais.adiantamento.total.saldo });
	
	                  _this30.adicionaRestricao({ 'tag': 'prestacaoContasComSaldoZerado', 'ativo': _this30.totais.adiantamento.fbb.saldo + _this30.totais.projeto.total.solicitado <= 0 && _this30.totais.adiantamento.parceiros.saldo + _this30.totais.projeto.total.solicitado <= 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Não há saldo disponível para solicitação de Prestação de Contas' });
	                }
	                if (_this30.processo === 'PRESTACAO_DE_CONTAS' && _this30.etapa !== 'Solicitação' && _this30.etapa !== 'Revisão') {
	                  _this30.adicionaRestricao({ 'tag': 'projeto diferente de APR', 'ativo': _.includes(['CAN', 'ENC'], _this30.projeto.Status_ERP), tipo: 'restricao', acao: null, mensagem: 'O projeto está em "' + _this30.projeto.Status_ERP + '" e não pode ser flexibilizado.' });
	                }
	                if (_this30.processo === 'PRESTACAO_DE_CONTAS' && _.includes(['Solicitação'], _this30.etapa)) {
	                  _this30.adicionaRestricao({ 'tag': 'solicitacaoAcimaSaldoDisponível', 'ativo': _this30.totais.projeto.total.solicitado > (_.includes(_this30.extratoFiltrosSelecionados, 'fundacao') ? _this30.totais.adiantamento.fbb.saldo : _this30.totais.adiantamento.parceiros.saldo), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Valor da solicitação superior ao saldo máximo disponível R$ ' + (_.includes(_this30.extratoFiltrosSelecionados, 'fundacao') ? _this30.totais.adiantamento.fbb.saldo : _this30.totais.adiantamento.parceiros.saldo) });
	                }
	                ehDevolucaoParaRevisao = _this30.aprovacao.resultadoAprovacao === 'Revisão';
	                ehDevolucaoParaAnalise = _this30.aprovacao.resultadoAprovacao === 'Análise' && _this30.etapa === 'Análise Tributária';
	
	                if (_.includes(['PRESTACAO_DE_CONTAS', 'PAGAMENTO', 'RESSARCIMENTO'], _this30.processo) && !ehDevolucaoParaRevisao && !ehDevolucaoParaAnalise) {
	                  itensSolicitados = _.filter(_this30.cronograma.itens, function (i) {
	                    return i.Qtde_solicitado > 0 && i.Valor_solicitado > 0;
	                  });
	                  qtdeProdutos = _.sumBy(itensSolicitados, function (i) {
	                    return i.Item_Tipo === 'PRODUTO' ? 1 : 0;
	                  });
	                  qtdeServicos = _.sumBy(itensSolicitados, function (i) {
	                    return i.Item_Tipo === 'SERVICO' ? 1 : 0;
	                  });
	
	                  _this30.adicionaRestricao({ 'tag': 'validaTributacao', 'ativo': _this30.nota.tributacao === 'TRIBUTADO' && (qtdeServicos > 1 || qtdeProdutos > 0), 'tipo': 'restricao', 'acao': null, 'mensagem': 'Está marcado com Tributado, mas tem ' + qtdeServicos + ' serviço(s) e ' + qtdeProdutos + ' produto(s)' });
	                  itensSolicitadoSaldoNegativo = [];
	
	                  _this30.nota.itens.forEach(function (item) {
	                    if (item.Valor_saldo - parseFloat(item.Valor_solicitado) < 0) {
	                      itensSolicitadoSaldoNegativo.push('#' + item.Id_item);
	                    }
	                  });
	                  _this30.adicionaRestricao({ 'tag': 'itemSolicitadoSaldoNegativo', 'ativo': itensSolicitadoSaldoNegativo.length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': (itensSolicitadoSaldoNegativo.length > 1 ? 'Itens' : 'Item') + ' com saldo negativo: ' + _.join(_.uniq(itensSolicitadoSaldoNegativo), ', ') });
	                }
	
	                if (_this30.ehProjetoEspecial && _this30.processo === 'PAGAMENTO' && _this30.etapa === 'Análise' && _this30.aprovacao.resultadoAprovacao !== 'Revisão') {
	                  _this30.adicionaRestricao({ 'tag': 'dadosComplementresValorAcima', 'ativo': _.sumBy(_this30.nota.dadosComplementares, 'valor') > _this30.totais.projeto.total.solicitado, 'tipo': 'restricao', 'acao': null, 'mensagem': 'O total informado nos dados complementares é superior ao total desta solicitação' });
	                  _this30.adicionaRestricao({ 'tag': 'dadosComplementresFaltandoProjetoEspecial', 'ativo': _this30.nota.dadosComplementares.length === 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Se trata de projeto especial que deve ter pelo menos um registro de dados complementares deste pagamento' });
	                  _this30.adicionaRestricao({ 'tag': 'dadosComplementresIncompletoMunicipio', 'ativo': _.filter(_this30.nota.dadosComplementares, function (d) {
	                      return _.isEmpty(d.municipio);
	                    }).length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há dados complementares que não tem município' });
	                  _this30.adicionaRestricao({ 'tag': 'dadosComplementresIncompletoValor', 'ativo': _.filter(_this30.nota.dadosComplementares, function (d) {
	                      return d.valor === 0;
	                    }).length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há dados complementares onde não foi informado valor' });
	                  _this30.adicionaRestricao({ 'tag': 'dadosComplementresIncompletoDestinacao', 'ativo': _.filter(_this30.nota.dadosComplementares, function (d) {
	                      return _.isEmpty(d.destinacao) || d.destinacao.length < 1;
	                    }).length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'A destinação em dados complementares é obrigatória' });
	                }
	
	                if (_this30.aprovacao.resultadoAprovacao === 'Revisão') {
	                  _this30.restricaoParaConcluir.forEach(function (erro) {
	                    if (erro.tag === 'adiantamentoNaoDisponivelParaPrestarContas' || _.includes(erro.tag, 'valoresTotaisIncorretosProjeto')) {
	                      _this30.removeRestricao({ 'tag': erro.tag });
	                    }
	                  });
	                }
	
	                if (_this30.processo === 'PRESTACAO_DE_CONTAS' && _.includes(['Solicitação'], _this30.etapa)) {
	                  if (!(_this30.totais.projeto.parceiros.solicitado > 0)) {
	                    _this30.removeRestricao({ 'tag': 'valoresTotaisIncorretosProjeto_PCT0013' });
	                  }
	                  if (!(_this30.totais.projeto.fbb.solicitado > 0)) {
	                    _this30.removeRestricao({ 'tag': 'valoresTotaisIncorretosProjeto_ORC0011' });
	                  }
	                }
	
	                _this30.$validator.validateAll().then(function (validado) {
	                  _this30.validaAjustaCodigoBarras();
	                  _this30.adicionaRestricao({ 'tag': 'camposPendentes', 'ativo': !validado || _this30.errors.items.length !== 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Revise os campos:<li>' + _.join(_.uniq(_.map(_this30.errors.items, 'msg')), '<li>') });
	
	                  var validacaoDadosBancarios = _this30.validandoDadosBancarios();
	                  _this30.adicionaRestricao({ 'tag': 'dadosBancariosIncorretos', 'ativo': _.isString(validacaoDadosBancarios), 'tipo': 'restricao', 'acao': null, 'mensagem': validacaoDadosBancarios });
	
	                  var validacaoCpfCnpj = _this30.validandoCpfCnpj();
	                  _this30.adicionaRestricao({ 'tag': 'invalidoCpfCnpj', 'ativo': _.isString(validacaoCpfCnpj), 'tipo': 'restricao', 'acao': null, 'mensagem': validacaoCpfCnpj });
	
	                  if (_this30.restricaoParaConcluir.length > 0 && _.filter(_this30.restricaoParaConcluir, { 'ativo': true }).length > 0) {
	                    var restricoes = _.filter(_this30.restricaoParaConcluir, { 'ativo': true, 'tipo': 'restricao' });
	                    if (restricoes.length > 0) {
	                      var mensagens = '<div class=avisoAlerta><li>' + _.join(_.map(restricoes, 'mensagem'), '<li>') + '</div>';
	                      _this30.$dialog.alert(mensagens, { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	                    }
	                  } else {
	                    _this30.processarConclusao();
	                  }
	                });
	
	              case 23:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this30);
	      }))();
	    },
	    processarConclusao: function processarConclusao() {
	      this.loading.tela = true;
	      if (this.nfe.validada) {
	        this.nota.opcoes = { 'parametro': 'NFe', 'valor': this.nfe };
	      }
	      if (this.processo === 'RESSARCIMENTO') {
	        this.verificarAlteracaoContasFavorecido();
	        this.nota.opcoes = { 'parametro': 'FAVORECIDO', 'valor': (0, _stringify2.default)(this.nota.favorecido) };
	        this.nota.numeroNota = _.isNil(this.nota.numeroNota) || _.isNaN(this.nota.numeroNota) || '' + this.nota.numeroNota === '0' || ('' + this.nota.numeroNota).length === 0 ? '0' : this.nota.numeroNota;
	      }
	      if ('' + this.nota.forma_pagamento === '4') {
	        this.nota.parametros_documento.push({ 'parametro': 'BOLETO', 'valor': this.nota.boleto });
	      }
	      if (_.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], this.processo) && _.includes(['Solicitação', 'Revisão'], this.etapa)) {
	        this.nota.parametros_documento.push({ 'parametro': 'DECLARACOES', 'valor': this.cienteDeclaracoes });
	      }
	      this.nota.valorTotal = _.sumBy(this.nota.itens, 'totalValue');
	
	      if (this.nota.tipoFornecedor === 'Pessoa Jurídica') {
	        _.unset(this.nota, 'cpfFornecedor');
	      } else if (this.nota.tipoFornecedor === 'Pessoa Física') {
	        _.unset(this.nota, 'cnpjFornecedor');
	      }
	      this.nota.projeto = this.projeto;
	      this.nota.banco = this.nota.dados_bancarios.banco;
	      this.nota.agencia = this.nota.dados_bancarios.agencia;
	      this.nota.conta = this.nota.dados_bancarios.conta;
	      this.nota.tipo = this.nota.dados_bancarios.tipo;
	
	      this.nota.processo = { 'nome': this.processo, 'situacao': 'EM_EXECUCAO' };
	      this.nota.tarefa = { 'nome': 'SOLICITACAO', 'tipo': 'USUARIO', 'situacao': 'PADRAO' };
	      if (this.cienteDeclaracoes) {
	        this.nota.declaracaoCiencia = this.cienteDeclaracoes;
	      }
	
	      if (_.isNull(this.id)) {
	        _.set(this.nota, 'proximaEtapa', this.aprovacao.resultadoAprovacao);
	
	        _.set(this.nota, 'proxima_etapa', this.aprovacao.resultadoAprovacao);
	        _.set(this.nota, 'data_edicao', this.data_edicao);
	        if (_.includes(['RESSARCIMENTO'], this.processo) && _.includes(['Solicitação', 'Revisão', 'Análise'], this.etapa)) {
	          this.gravarContasFavorecido();
	        }
	
	        this.criarSolicitacao(this.nota);
	      } else {
	        var doc = {};
	
	        _.set(doc, 'id', this.id);
	        _.set(doc, 'tarefas', this.historico);
	
	        _.set(doc, 'glosa', this.nota.observacao);
	
	        _.set(doc, 'proxima_etapa', this.aprovacao.resultadoAprovacao);
	        _.set(doc, 'data_edicao', this.data_edicao);
	
	        _.set(doc, 'documentos_liberacao', this.validacao);
	        _.set(doc, 'documentos_liberacao.numero', this.nota.numeroNota);
	        _.set(doc, 'documentos_liberacao.serie', this.nota.serieNota);
	        _.set(doc, 'documentos_liberacao.prioridade', this.nota.pagamentoPrioritario);
	        _.set(doc, 'documentos_liberacao.forma_pagamento', this.nota.forma_pagamento);
	        _.set(doc, 'documentos_liberacao.emissao', this.nota.dataInclusao);
	        _.set(doc, 'documentos_liberacao.validade', this.nota.dataValidade);
	        _.set(doc, 'documentos_liberacao.fk_dados_bancarios', this.validacao.fk_dados_bancarios);
	        _.set(doc, 'documentos_liberacao.dados_bancarios', this.nota.dados_bancarios);
	        _.set(doc, 'documentos_liberacao.dados_bancarios.fk_fornecedor', _.has(this.validacao.dados_bancarios, 'fk_fornecedor') ? this.validacao.dados_bancarios.fk_fornecedor : 0);
	        _.set(doc, 'documentos_liberacao.dados_bancarios.fornecedor.nome', this.nota.nomeFornecedor);
	        _.set(doc, 'documentos_liberacao.dados_bancarios.fornecedor.identificador', this.nota.tipoFornecedor === 'Pessoa Jurídica' ? this.nota.cnpjFornecedor : this.nota.cpfFornecedor);
	        _.set(doc, 'documentos_liberacao.dados_bancarios.fornecedor.cep', this.nota.cepFornecedor);
	        _.set(doc, 'documentos_liberacao.dados_bancarios.fornecedor.endereco', this.nota.enderecoFornecedor);
	
	        _.set(doc, 'documentos_liberacao.receiptItems', this.nota.itens);
	
	        this.validacao.parametros_documento = [];
	
	        if (this.nota.bypass !== '') {
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'OPCOES', 'valor': this.nota.bypass });
	        }
	        if ('' + this.nota.forma_pagamento === '4') {
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'BOLETO', 'valor': (0, _stringify2.default)(this.nota.boleto) });
	        }
	        if (this.nota.suporteFbb.length > 0) {
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'SUPORTE_FBB', 'valor': (0, _stringify2.default)(this.nota.suporteFbb) });
	        }
	        if (this.aprovacao.resultadoAprovacao === 'Revisão' && !_.isNull(this.motivoDevolucao)) {
	          _.set(this.motivoDevolucao, 'fk_usuario', this.usuarioLogado.id);
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'MOTIVO_DEVOLUCAO', 'valor': (0, _stringify2.default)(this.motivoDevolucao) });
	        }
	        if (this.processo !== 'CONTRAPARTIDA' && _.includes(['Análise', 'Análise Tributária'], this.etapa) && _.includes(['TRIBUTADO', 'NAO_TRIBUTADO'], this.nota.tributacao)) {
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'TRIBUTACAO', 'valor': this.nota.tributacao });
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'VALOR_TRIBUTADO', 'valor': _.isNull(this.nota.valorTributado) || this.nota.valorTributado === '' || this.nota.tributacao === 'NAO_TRIBUTADO' ? '0' : this.nota.valorTributado });
	        }
	        if (this.processo === 'RESSARCIMENTO') {
	          this.verificarAlteracaoContasFavorecido();
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'FAVORECIDO', 'valor': (0, _stringify2.default)(this.nota.favorecido) });
	        }
	        if (this.processo !== 'CONTRAPARTIDA' && this.ehNFe) {
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'NFe', 'valor': (0, _stringify2.default)(this.nfe) });
	        }
	        if (this.ehProjetoEspecial && this.processo === 'PAGAMENTO' && !_.isEmpty(this.nota.dadosComplementares)) {
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'DADOS_COMPLEMENTARES', 'valor': (0, _stringify2.default)(this.nota.dadosComplementares) });
	        }
	        if (_.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], this.processo) && _.includes(['Solicitação', 'Revisão'], this.etapa)) {
	          this.validacao.parametros_documento.push({ 'fk_documentos_liberacao': this.validacao.id, 'parametro': 'DECLARACOES', 'valor': (0, _stringify2.default)(this.cienteDeclaracoes) });
	        }
	        if (_.isEmpty(this.validacao.parametros_documento)) {
	          _.set(doc, 'documentos_liberacao.parametros_documento', this.validacao.parametros_documento);
	        }
	
	        _.set(doc, 'processo', this.validacao.processo);
	        _.set(doc, 'processo.nome', this.processo);
	        _.set(doc, 'proximaEtapa', this.aprovacao.resultadoAprovacao);
	        if (this.decisaoDaAnalise) {
	          _.set(doc, 'proximaEtapa', this.decisaoDaAnalise.proxima_etapa);
	          _.set(doc, 'proxima_etapa', this.decisaoDaAnalise.proxima_etapa);
	          _.forEach(this.decisaoDaAnalise.parametros, function (valor, campo) {
	            doc[campo] = valor;
	          });
	        }
	        if (_.includes(['Análise'], this.etapa)) {
	          _.set(doc, 'cienteDeclaracoes', this.cienteDeclaracoes);
	        }
	
	        if (_.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], this.processo)) {
	          if (_.includes(['Autorização', 'Liquidação'], this.etapa) && this.aprovacao.resultadoAprovacao === 'Análise') {
	            this.aprovacaoTitulo('D', doc);
	          } else if (_.includes(['Análise Tributária'], this.etapa) && this.aprovacao.resultadoAprovacao === 'Autorização') {
	            this.aprovacaoTitulo('A', doc);
	          } else if (_.includes(['PRESTACAO_DE_CONTAS'], this.processo) && _.includes(['Autorização'], this.etapa) && this.aprovacao.resultadoAprovacao === 'Conclusão') {
	            this.baixaTitulo(doc);
	          } else if (_.includes(['RESSARCIMENTO'], this.processo) && _.includes(['Solicitação', 'Revisão', 'Análise'], this.etapa)) {
	            this.gravarContasFavorecido(doc);
	          } else {
	            this.encaminharProximaTarefa(doc);
	          }
	        } else if (_.includes(['CONTRAPARTIDA'], this.processo)) {
	          this.encaminharProximaTarefa(doc);
	        } else {}
	      }
	    },
	    verificarAlteracaoContasFavorecido: function verificarAlteracaoContasFavorecido() {
	      var favorecido = _.clone(this.nota.favorecido);
	
	      var incluidosNaoExcluidos = _.differenceWith(this.nota.favorecido.incluidos, this.nota.favorecido.excluidos, _.isEqual);
	      var excluidosNaoIncluidos = _.differenceWith(this.nota.favorecido.excluidos, this.nota.favorecido.incluidos, _.isEqual);
	      favorecido['incluidos'] = incluidosNaoExcluidos;
	      favorecido['excluidos'] = excluidosNaoIncluidos;
	      favorecido['resultado'] = this.opcoesContasExistentesFavorecido;
	
	      this.nota.favorecido = _.clone(favorecido);
	    },
	    gravarContasFavorecido: function gravarContasFavorecido() {
	      var _this31 = this;
	
	      var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (this.nota.favorecido.incluidos.length > 0 || this.nota.favorecido.excluidos.length > 0 || !_.isEqual(this.nota.favorecido.dadosBancariosSelecionados, this.nota.favorecido.dadosBancariosSelecionadosAnterior)) {
	        this.$aguarde('Registrando alterações nas contas do Favorecido...');
	        axiosLaravel.post('pagamento/contas/favorecido/alteracao/', { 'alteracao': this.nota.favorecido }).then(function (response) {
	          if (_.has(response.data, 'codigo') && _.includes(['OK'], response.data.codigo)) {
	            if (!_.isNull(doc)) {
	              _this31.encaminharProximaTarefa(doc);
	            }
	          } else {
	            _this31.aviso(response.data);
	            if (response.data.codigo === 'ERRO') {
	              _this31.saiDaTela();
	            }
	          }
	        }).catch(function (error) {
	          _this31.$snotify.clear();
	          _this31.$root.trataErro(error);
	          _this31.loading.tela = false;
	        });
	      } else {
	        if (!_.isNull(doc)) {
	          this.encaminharProximaTarefa(doc);
	        }
	      }
	    },
	    baixaTitulo: function baixaTitulo(doc) {
	      var _this32 = this;
	
	      this.$aguarde('Baixando título de prestação contra adiantamento...');
	      this.loading.tela = true;
	      axiosLaravel.post('prestacao_contas/adiantamento/baixa/', { 'idProcesso': this.id, 'doc': doc }).then(function (response) {
	        _this32.aviso(response.data);
	        if (response.data.codigo === 'ERRO') {
	          _this32.saiDaTela();
	        }
	        if (_.has(response.data, 'codigo') && _.includes(['OK', 'AVISO'], response.data.codigo)) {
	          _this32.$snotify.clear();
	          _this32.encaminharProximaTarefa(doc);
	        }
	      }).catch(function (error) {
	        _this32.$snotify.clear();
	        _this32.$root.trataErro(error);
	        _this32.loading.tela = false;
	      });
	    },
	    aprovacaoTitulo: function aprovacaoTitulo(operacao, doc) {
	      var _this33 = this;
	
	      this.$aguarde('Processando ' + (operacao === 'A' ? 'aprovação' : 'desaprovação') + ' do título...');
	      this.loading.tela = true;
	      axiosLaravel.post('pagamento/titulo/aprovacao', { 'idProcesso': this.id, 'tipoOperacao': operacao }).then(function (response) {
	        _this33.$snotify.clear();
	        _this33.aviso(response.data);
	        if (response.data.codigo === 'ERRO') {
	          _this33.saiDaTela();
	        }
	        if (_.has(response.data, 'codigo') && _.includes(['OK', 'AVISO'], response.data.codigo)) {
	          _this33.encaminharProximaTarefa(doc);
	        }
	      }).catch(function (error) {
	        _this33.$snotify.clear();
	        _this33.loading.tela = false;
	        _this33.$root.trataErro(error);
	      });
	    },
	    criarSolicitacao: function criarSolicitacao(nota) {
	      var _this34 = this;
	
	      this.$aguarde((nota.proximaEtapa === 'Salvar' ? 'Salvando' : 'Encaminhando') + ' Solicitação de ' + this.descricaoProcesso[this.processo] + '. Por favor, aguarde...');
	      axiosLaravel.post('processos/grava', nota).then(function (response) {
	        _this34.$snotify.clear();
	        if (_.hasIn(response, 'error')) {
	          _this34.$snotify.clear();
	          _this34.$snotify.error(response.data.value.error[0], '', 10000);
	        } else {
	          _this34.$snotify.clear();
	          if (nota.proximaEtapa === 'Salvar') {
	            _this34.id = response.data.id;
	            _this34.$snotify.success('Gravado com sucesso. Relendo a solicitação...');
	            _this34.$router.push(_this34.rotasProcesso[_this34.processo] + '/' + _this34.id);
	          } else {
	            _this34.$snotify.success('Solicitação encaminhada com sucesso!');
	            _this34.$router.push('/solicitacao/lista');
	          }
	        }
	        _this34.loading.tela = false;
	      }).catch(function (error) {
	        _this34.loading.tela = false;
	        _this34.$snotify.clear();
	        _this34.$root.trataErro(error);
	      });
	    },
	    buscaDecisoesDaAnalise: function buscaDecisoesDaAnalise() {
	      var _this35 = this;
	
	      axiosLaravel.get('processos/' + this.id + '/decisoes-da-analise').then(function (response) {
	        _this35.decisoesDaAnalise = _.get(response, 'data.decisoes', []);
	      }).catch(function () {
	        _this35.decisoesDaAnalise = [];
	      });
	    },
	    encaminharProximaTarefa: function encaminharProximaTarefa(doc) {
	      var _this36 = this;
	
	      console.log('encaminharProximaTarefa (doc) >>>>', doc);
	      this.loading.tela = true;
	      var msgProcessando = 'Salvando a solicitação...';
	      var msgConclusao = 'Gravado com sucesso. Relendo a solicitação...';
	      var msgExclusaoNota = (this.aprovacao.resultadoAprovacao === 'Revisão' || this.aprovacao.resultadoAprovacao === 'Análise' && this.etapa !== 'Solicitação') && this.possuiNotaSapiens ? ' e excluindo notas do ERP' : '';
	      if (!_.isUndefined(this.aprovacao.resultadoAprovacao) && this.aprovacao.resultadoAprovacao !== 'Salvar') {
	        msgProcessando = 'Encaminhando ' + this.descricaoProcesso[this.processo] + (_.isUndefined(this.aprovacao.resultadoAprovacao) ? '...' : ' para ' + this.aprovacao.resultadoAprovacao + msgExclusaoNota);
	        msgConclusao = 'Encaminhado com sucesso!';
	      }
	      this.$aguarde(msgProcessando);
	      this.$forceUpdate();
	      axiosLaravel.put('processos/tarefas/atualiza/', doc).then(function (response) {
	        _this36.$snotify.clear();
	        if (_.hasIn(response, 'error')) {
	          _this36.$snotify.clear();
	          _this36.$snotify.error(response.data.value.error[0], '', 10000);
	        } else {
	          _this36.$snotify.clear();
	          _this36.$snotify.success(msgConclusao);
	          if (_.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _this36.processo) && _this36.etapa === 'Análise' && _this36.proximaEtapaEscolhida === 'Análise Tributária') {
	            _this36.dadosAnaliseTributaria({ 'acao': 'emitirRelatorio', 'parametros': [200] });
	          }
	          if (_.includes(['PRESTACAO_DE_CONTAS'], _this36.processo) && _this36.ehVoluntariado) {
	            if (_.get(doc, 'proximaEtapa', '') === 'Análise Tributária') {
	              _.set(doc, 'proximaEtapa', 'Autorização');
	              _.set(doc, 'proxima_etapa', 'Autorização');
	              _this36.aprovacaoTitulo('A', doc);
	            } else if (_.get(doc, 'proximaEtapa', '') === 'Autorização') {
	              _.set(doc, 'proximaEtapa', 'Conclusão');
	              _.set(doc, 'proxima_etapa', 'Conclusão');
	              _this36.baixaTitulo(doc);
	            } else if (_.get(doc, 'proximaEtapa', '') === 'Conclusão') {
	              _this36.$router.go(-1);
	            }
	          } else {
	            if (_.get(_this36.aprovacao, 'resultadoAprovacao', '') !== 'Salvar') {
	              if (_this36.usuarioLogado.userType === 'FUNDACAO') {
	                _this36.$router.go(-1);
	              } else {
	                _this36.$router.push('/solicitacao/lista');
	              }
	            }
	          }
	        }
	      }).catch(function (error) {
	        _this36.loading.tela = false;
	        _this36.$snotify.clear();
	        _this36.$root.trataErro(error);
	      });
	    },
	    gravaHistorico: function gravaHistorico(_parm) {},
	    validandoDadosBancarios: function validandoDadosBancarios() {
	      if (this.processo === 'PRESTACAO_DE_CONTAS' || !_.includes(['2', '3', '7'], '' + this.nota.forma_pagamento)) {
	        this.nota.dados_bancarios.banco = '000';
	        this.nota.dados_bancarios.agencia = '0';
	        this.nota.dados_bancarios.conta = '0';
	        this.nota.dados_bancarios.conta = 1;
	      } else {
	        if (this.nota.dados_bancarios.banco && this.nota.dados_bancarios.agencia && this.nota.dados_bancarios.conta && (this.nota.dados_bancarios.tipo === 1 || this.tipoContaSelecionado.codigo === 1)) {
	          var banco = _.has(this.bancoSelecionado, 'codigo') ? this.bancoSelecionado.codigo : '000';
	
	          var conta = _.words(this.nota.dados_bancarios.conta);
	          var digitosConta = _.get(_.head(_.filter(this.listaBancos, ['codigo', banco])), 'caracteresConta');
	          var contaSemDV = digitosConta ? _.padStart(conta[0], digitosConta, '0') : conta[0];
	          var contaDV = conta[1] || '';
	
	          var agencia = _.words(this.nota.dados_bancarios.agencia);
	          var agenciaSemDV = agencia[0] || '';
	          var agenciaDV = agencia[1] || '';
	          try {
	            _brBankAccountValidator2.default.validate({
	              bankNumber: banco,
	              agencyNumber: agenciaSemDV,
	              agencyCheckNumber: agenciaDV,
	              accountNumber: contaSemDV,
	              accountCheckNumber: contaDV
	            });
	            return true;
	          } catch (e) {
	            console.log('Erro na validação de dados bancários', e.message);
	            return e.message;
	          }
	        }
	        return false;
	      }
	    },
	    validaDadosBancariosFornecedor: function validaDadosBancariosFornecedor(bancoVer, agenciaVer, contaVer) {
	      var banco = bancoVer;
	
	      var conta = _.words(contaVer);
	      var digitosConta = _.get(_.head(_.filter(this.listaBancos, ['codigo', banco])), 'caracteresConta');
	      var contaSemDV = digitosConta ? _.padStart(conta[0], digitosConta, '0') : conta[0];
	      var contaDV = conta[1] || '';
	
	      var agencia = _.words(agenciaVer);
	      var agenciaSemDV = agencia[0] || '';
	      var agenciaDV = agencia[1] || '';
	
	      console.log('banco: ', banco);
	      console.log('digitosConta ', digitosConta);
	      console.log('contaSemDV ', contaSemDV);
	      console.log('contaDV ', contaDV);
	      console.log('agencia ', agencia);
	      console.log('agenciaSemDV ', agenciaSemDV);
	      console.log('agenciaDV ', agenciaDV);
	      try {
	        _brBankAccountValidator2.default.validate({
	          bankNumber: banco,
	          agencyNumber: agenciaSemDV,
	          agencyCheckNumber: agenciaDV,
	          accountNumber: contaSemDV,
	          accountCheckNumber: contaDV
	        });
	        console.log('Validado');
	        return true;
	      } catch (e) {
	        console.log('Conta incorreta');
	        return false;
	      }
	    },
	    validandoCpfCnpj: function validandoCpfCnpj() {
	      if (this.nota.tipoFornecedor === 'Pessoa Física') {
	        this.nota.cpfFornecedor = _.padStart(this.nota.cpfFornecedor, 11, '0');
	        return _cpfCnpjValidator.cpf.isValid(this.nota.cpfFornecedor) ? true : 'CPF inválido';
	      }
	      if (this.nota.tipoFornecedor === 'Pessoa Jurídica') {
	        this.nota.cnpjFornecedor = _.padStart(this.nota.cnpjFornecedor, 14, '0');
	        return (0, _cnpj2.default)(this.nota.cnpjFornecedor) ? true : 'CNPJ inválido';
	      }
	    },
	    procurandoCidadeUF: function procurandoCidadeUF() {
	      var _this37 = this;
	
	      if (this.nota.cepFornecedor) {
	        axiosLaravel.get('municipios/cep/' + this.nota.cepFornecedor).then(function (response) {
	          if (!_.isEmpty(response.data) && !_.isString(response.data)) {
	            _this37.nota.cidadeFornecedor = response.data.ds_nome;
	            _this37.nota.estadoFornecedor = response.data.ds_uf;
	            _this37.$forceUpdate();
	          }
	        }).catch(function (error) {
	          _this37.$root.trataErro(error);
	
	          _this37.$forceUpdate();
	        });
	      } else {
	        this.nota.cidadeFornecedor = '';
	        this.nota.estadoFornecedor = '';
	        this.$forceUpdate();
	      }
	    },
	    dadosAnaliseTributaria: function dadosAnaliseTributaria(executarAposOk) {
	      var _this38 = this;
	
	      this.loading.analise_tributaria = true;
	      axiosLaravel.get('pagamento/dados/tributacao/' + this.id).then(function (response) {
	        if (_.has(response.data, 'codigo') && response.data.codigo === 'ERRO') {
	          _this38.aviso(response.data);
	        } else if (_.has(response.data, 'retorno')) {
	          _this38.analiseTributaria = response.data.retorno;
	          if (!_.isUndefined(executarAposOk) && !('' + _this38.nota.forma_pagamento === '3' && ('' + _this38.nota.dados_bancarios.banco + _this38.nota.dados_bancarios.agencia + _this38.nota.dados_bancarios.conta).length < 6)) {
	            if (executarAposOk.acao === 'emitirRelatorio') {
	              console.log('Suporte 77788 - não emitir relatorio');
	              if (!(_.includes(['PRESTACAO_DE_CONTAS'], _this38.processo) && _this38.ehVoluntariado)) {
	                _this38.$router.go(-1);
	              }
	            }
	          }
	        }
	
	        _this38.nota.valorTributado = !_.isNaN(_this38.nota.valorTributado) && _.isNumber(_this38.nota.valorTributado) ? _this38.nota.valorTributado : 0;
	        _this38.loading.analise_tributaria = false;
	      }).catch(function (error) {
	        _this38.$snotify.clear();
	        _this38.loading.analise_tributaria = false;
	        _this38.$root.trataErro(error);
	      });
	    },
	    dadosFavorecido: function dadosFavorecido(busca) {
	      var _this39 = this;
	
	      this.loading.favorecido = true;
	      axiosLaravel.post('pagamento/dados/favorecido/', busca).then(function (response) {
	        if (_.has(response.data, 'retorno') && !_.isNull(response.data.retorno)) {
	          if (_.has(response.data, 'codigo') && _.includes(['OK'], response.data.codigo)) {
	            _this39.nota.favorecido = response.data.retorno;
	            var contaPrincipalFavorecido = _.trim(_this39.nota.favorecido.codban) !== '' ? [{ 'seqban': 0, 'codban': _this39.nota.favorecido.codban, 'codage': _this39.nota.favorecido.codage, 'ccbfav': _this39.nota.favorecido.ccbfav, 'tiptcc': _this39.nota.favorecido.tiptcc }] : [];
	            var todasOpcoes = _.concat(contaPrincipalFavorecido, _this39.nota.favorecido.contas);
	            todasOpcoes.forEach(function (opcao) {
	              if (!_.isEmpty(opcao)) {
	                _this39.opcoesContasExistentesFavorecido.push(_.pick(opcao, ['seqban', 'codban', 'codage', 'ccbfav', 'tiptcc']));
	              }
	            });
	            _.set(_this39.nota, 'favorecido.dadosBancariosSelecionados', contaPrincipalFavorecido[0]);
	            _this39.selecionaDadosBancariosFavorecido(contaPrincipalFavorecido[0]);
	          } else {
	            _this39.aviso(response.data);
	            if (response.data.codigo === 'ERRO') {
	              _this39.saiDaTela();
	            }
	          }
	        }
	        _this39.$forceUpdate();
	        _this39.loading.favorecido = false;
	      }).catch(function (error) {
	        _this39.$snotify.clear();
	        _this39.loading.favorecido = false;
	        _this39.$root.trataErro(error);
	      });
	    },
	    favorecidoDadosBancariosIncluir: function favorecidoDadosBancariosIncluir() {
	      this.mostrarIncluindoConta = true;
	      this.selecionaDadosBancariosFavorecido();
	    },
	    favorecidoDadosBancariosExcluir: function favorecidoDadosBancariosExcluir() {
	      var dadosSelecionados = this.nota.favorecido.dadosBancariosSelecionados;
	      _.remove(this.opcoesContasExistentesFavorecido, dadosSelecionados);
	      _.remove(this.nota.favorecido.excluidos, _.pick(dadosSelecionados, ['codban', 'codage', 'ccbfav', 'tiptcc']));
	      this.nota.favorecido.excluidos.push(dadosSelecionados);
	      this.selecionaDadosBancariosFavorecido();
	      this.nota.favorecido.dadosBancariosSelecionados = null;
	      this.$forceUpdate();
	    },
	    favorecidoDadosBancariosOk: function favorecidoDadosBancariosOk() {
	      this.$validator.validate('banco');
	      this.$validator.validate('agência');
	      this.$validator.validate('conta corrente');
	      var dadosPreenchidos = _.xor(['banco', 'agência', 'conta corrente'], _.uniq(_.map(this.$validator.errors.items, 'field')));
	      if (dadosPreenchidos < 3) {
	        this.$dialog.alert('Falta preencher: ' + _.join(dadosPreenchidos, ', '), { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {});
	      } else {
	        var dadosNovos = { 'codban': this.nota.dados_bancarios.banco, 'codage': this.nota.dados_bancarios.agencia, 'ccbfav': this.nota.dados_bancarios.conta, 'tiptcc': this.nota.dados_bancarios.tipo };
	        if (_.filter(this.opcoesContasExistentesFavorecido, dadosNovos).length === 0) {
	          this.opcoesContasExistentesFavorecido.push(dadosNovos);
	          _.remove(this.nota.favorecido.incluidos, dadosNovos);
	          this.nota.favorecido.incluidos.push(dadosNovos);
	          _.remove(this.nota.favorecido.excluidos, dadosNovos);
	        }
	        this.nota.favorecido.dadosBancariosSelecionados = dadosNovos;
	        this.selecionaDadosBancariosFavorecido(dadosNovos);
	        this.mostrarIncluindoConta = false;
	        this.$forceUpdate();
	      }
	    },
	    favorecidoDadosBancariosCancelar: function favorecidoDadosBancariosCancelar() {
	      this.mostrarIncluindoConta = false;
	      this.selecionaDadosBancariosFavorecido(this.nota.favorecido.dadosBancariosSelecionados);
	    },
	    emitir: function emitir(relatorio) {
	      var _this40 = this;
	
	      var mosDes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loading.tela = true;
	      this.projeto['Numero_projeto'] = _.has(this.projeto, 'Numero_projeto') ? this.projeto['Numero_projeto'] : this.projeto.Projeto.substring(0, 5);
	      if (!_.toSafeInteger(this.projeto['Numero_projeto']) > 0) {
	        this.$snotify.error('Há algum erro ao pegar o número deste projeto. Favor informar o administrador do sistema');
	        return;
	      }
	      var parametros = '<ECodEmp=1><ENumPrj=' + this.projeto['Numero_projeto'] + '>';
	
	      if (relatorio === 219) {
	        parametros += '<ESitPrj=ULT>';
	      } else if (relatorio === 248) {
	        parametros += '<ECodFor=>';
	      }
	
	      if (relatorio === 525) {
	        parametros = '<ENumPrj=' + this.projeto['Numero_projeto'] + '><EMosDes=' + mosDes + '>';
	      }
	      if (relatorio === 200 && _.has(this.analiseTributaria, 'nf') && '' + this.analiseTributaria.nf.SitNfc === '2') {
	        parametros = '<ECodFor=' + this.analiseTributaria.nf.CodFor + '><ENumNfc=' + this.analiseTributaria.nf.NumNfc + '><ECodSnf=' + this.analiseTributaria.nf.CodSnf + '><EForOrg=F><EPreCon=N>';
	      }
	      if (relatorio === 611) {
	        parametros = '<ECodFor=' + this.analiseTributaria.nf.CodFor + '><ENumTit="' + this.analiseTributaria.titulo.NumTit + '"><ETitBai=S>';
	      }
	      this.$snotify.clear();
	      var codigoRelatorio = (relatorio === 200 ? 'SRNF' : 'FJCF') + relatorio + '.GER';
	      if (relatorio === 611) codigoRelatorio = 'FPCP' + relatorio + '.GER';
	      var identificacao = relatorio === 525 ? '525 - Extrato ' + (mosDes === 'S' ? 'Analítico' : 'Sintético') : relatorio;
	      this.$aguarde('Gerando relatório ' + identificacao + '. Por favor, aguarde...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': codigoRelatorio }, params: parametros }).then(function (response) {
	        _this40.onDownload(response, identificacao, _this40);
	      }).catch(function (error) {
	        _this40.$snotify.clear();
	        _this40.loading.tela = false;
	        _this40.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	
	      var tipoProcesso = '';
	      switch (vm.processo) {
	        case 'PAGAMENTO':
	          tipoProcesso = 'PG';
	          break;
	        case 'PRESTACAO_DE_CONTAS':
	          tipoProcesso = 'PC ' + this.projeto.Numero_projeto;
	          break;
	        case 'RESSARCIMENTO':
	          tipoProcesso = 'RE';
	          break;
	      }
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (relatorio !== 200) {
	        if (!ie) {
	          var blob = file;
	          var link = document.createElement('a');
	          link.href = window.URL.createObjectURL(blob);
	          link.download = 'Relatório ' + relatorio + ' » ' + vm.projeto.Projeto;
	          document.body.appendChild(link);
	          link.click();
	          document.body.removeChild(link);
	        } else {
	          var _blob = file;
	          var _link = document.createElement('blob');
	          _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	          _link.download = 'Relatório ' + relatorio + ' » ' + vm.projeto.Projeto;
	          _link.click();
	        }
	      } else {
	        if (!ie) {
	          var _blob2 = file;
	          var _link2 = document.createElement('a');
	          _link2.href = window.URL.createObjectURL(_blob2);
	
	          _link2.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + vm.id + ' - ' + tipoProcesso + ' VALOR ' + vm.totais.projeto.total.solicitado;
	          document.body.appendChild(_link2);
	          _link2.click();
	          document.body.removeChild(_link2);
	        } else {
	          var _blob3 = file;
	          var _link3 = document.createElement('blob');
	          _link3.href = window.navigator.msSaveOrOpenBlob(_blob3, item.name);
	
	          _link3.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + vm.id + ' - ' + tipoProcesso + ' VALOR ' + vm.totais.projeto.total.solicitado;
	          _link3.click();
	        }
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading.tela = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    verificaChamado: function verificaChamado() {
	      var _this41 = this;
	
	      axiosLaravel.post('chamado/chamadoProcesso/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this41.chamado = response.data;
	      }).catch(function (error) {
	        _this41.$snotify.clear();
	        _this41.$root.trataErro(error);
	      });
	    },
	    onDownloadZIP: function onDownloadZIP() {
	      var _this42 = this;
	
	      this.$forceUpdate();
	      this.$aguarde('Baixando arquivos. Por favor, aguarde...');
	      axiosLaravel.get('processos/documentos/download/' + this.$route.params.id).then(function (response) {
	        var link = document.createElement('a');
	        link.href = response.data;
	        link.download = 'Arquivo não localizado';
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	        _this42.$snotify.clear();
	        _this42.$forceUpdate();
	      }).catch(function (error) {
	        _this42.$snotify.clear();
	        _this42.$root.trataErro(error);
	      });
	    },
	    buscaDadosbancariosFornecedor: function buscaDadosbancariosFornecedor(cpfcgc) {
	      var _this43 = this;
	
	      axiosLaravel.get('pagamento/dadosBancariosFornecedores/' + cpfcgc).then(function (response) {
	        var dadosBancarios = response.data;
	
	        var dadosBancariosFormat = dadosBancarios.map(function (item) {
	          item.banco = item.banco.replace(/^0+/, '');
	          item.banco = item.banco.padStart(3, '0');
	
	          if (item.banco === '104' && item.agencia.length > 4) {
	            item.agencia = item.agencia.slice(0, -1);
	          }
	          item.agencia = item.agencia.replace('-', '').toUpperCase();
	          item.conta = parseInt(item.conta.replace('-', ''), 10);
	          return item;
	        });
	
	        var arrayUnique = _.uniqBy(dadosBancariosFormat, function (_ref2) {
	          var agencia = _ref2.agencia,
	              conta = _ref2.conta;
	          return agencia + ':' + conta;
	        });
	
	        var dadosFormatados = arrayUnique.map(function (item) {
	          if (item.agencia.length > 4) {
	            item.agencia = item.agencia.substring(0, item.agencia.length - 1) + '-' + item.agencia.substring(item.agencia.length - 1);
	          }
	          item.conta = String(item.conta);
	          item.conta = item.conta.substring(0, item.conta.length - 1) + '-' + item.conta.substring(item.conta.length - 1);
	          return item;
	        });
	
	        for (var i = 0; i < dadosFormatados.length; i++) {
	          if (!_this43.validaDadosBancariosFornecedor(dadosFormatados[i].banco, dadosFormatados[i].agencia, dadosFormatados[i].conta)) {
	            console.log(dadosFormatados[i]);
	            dadosFormatados.splice(i, 1);
	          }
	        }
	
	        console.log('dados bancarios lenght: ', dadosBancarios.length);
	        console.log(dadosBancarios);
	        console.log('dados bancarios unicos lenght: ', dadosFormatados.length);
	        console.log(dadosFormatados);
	        _this43.dadosBancariosFornecedores = dadosFormatados;
	      }).catch(function (error) {
	        _this43.$snotify.clear();
	        _this43.$root.trataErro(error);
	      });
	    },
	    limpaDadosBancarios: function limpaDadosBancarios() {
	      this.nota.forma_pagamento = null;
	      this.nota.favorecido.dadosBancariosSelecionados = '';
	      this.dadosBancariosFornecedores = [];
	      this.nota.dados_bancarios.banco = '';
	      this.nota.dados_bancarios.agencia = '';
	      this.nota.dados_bancarios.conta = '';
	      this.nota.dados_bancarios.tipo = '';
	      this.bancoSelecionado = null;
	      this.tipoContaSelecionado = null;
	    },
	    selecionaDadosBancariosFornecedor: function selecionaDadosBancariosFornecedor(item) {
	      this.nota.dados_bancarios.banco = '';
	      this.nota.dados_bancarios.agencia = '';
	      this.nota.dados_bancarios.conta = '';
	      this.nota.dados_bancarios.tipo = '';
	      this.nota.dados_bancarios.banco = item ? item.banco : '';
	      this.nota.dados_bancarios.agencia = item ? item.agencia : '';
	      this.nota.dados_bancarios.conta = item ? item.conta : '';
	      this.nota.dados_bancarios.tipo = item ? item.tipo : 1;
	      this.bancoSelecionado = item ? _.filter(this.listaBancos, ['codigo', this.nota.dados_bancarios.banco])[0] : null;
	      this.tipoContaSelecionado = item ? _.filter(this.tiposConta, ['codigo', this.nota.dados_bancarios.tipo])[0] : null;
	      this.$forceUpdate();
	    },
	    verificaNotaDuplicada: function verificaNotaDuplicada(doc) {
	      var _this44 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                console.log('VERIFICA NOTA DUPLICADA');
	                data = {
	                  numero: doc.documentos_liberacao.numero,
	                  identificador: doc.documentos_liberacao.dados_bancarios.fornecedor.identificador,
	                  serie: doc.documentos_liberacao.serie,
	                  id: doc.id
	                };
	                _context5.next = 4;
	                return axiosLaravel.post('processos/tarefas/validaDocumentoAnalisePrestacao', data).then(function (response) {
	                  console.log('PASSOU');
	                }).catch(function (error) {
	                  _this44.$snotify.clear();
	                  _this44.$root.trataErro(error);
	                  console.log('ERRO');
	                });
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this44);
	      }))();
	    },
	    ehProjetoComRestricaoPagamentoServico: function ehProjetoComRestricaoPagamentoServico() {
	      var naoEhExecutadoPelaFundacaoBB = parseInt(this.projeto.fk_entidade) !== 1439;
	      var ehPagamento = this.processo === 'PAGAMENTO';
	      var projetoAprovadoAposRegra = this.projeto.dateAprovacao > new Date('2022-10-01');
	      return naoEhExecutadoPelaFundacaoBB && ehPagamento && projetoAprovadoAposRegra;
	    },
	    abrirChamado: function abrirChamado() {
	      var urlString = '';
	      var projeto = this.projeto.Numero_projeto;
	      var processo = this.processo;
	      var idTarefa = null;
	
	      if (this.etapa === 'Revisão') {
	        idTarefa = this.validacao.fk_processos;
	      }
	      urlString = '/cadastro/chamado/criar?projeto=' + projeto + '&processo=' + processo + '&idTarefa=' + idTarefa;
	      console.log('Abrindo chamado');
	      window.open(urlString, '_blank');
	    },
	    saiDaTela: function saiDaTela() {
	      if (this.usuarioLogado.userType === 'FUNDACAO') {
	        this.$router.go(-1);
	      } else {
	        this.$router.push('/solicitacao/lista');
	      }
	    },
	    mudarTipoDocumento: function mudarTipoDocumento(tipo) {
	      this.tipoDocumento = tipo;
	      this.$forceUpdate();
	    },
	    validaQuantidade: function validaQuantidade(event, item) {
	      var valorInput = event.target.value;
	      var valorNumerico = parseFloat(valorInput);
	      var saldo = parseFloat(item.Qtde_saldo);
	      if (!isNaN(valorNumerico) && valorNumerico > saldo) {
	        this.$set(item, 'qtdeError', true);
	        this.$snotify.error('A quantidade não pode ser maior que o saldo');
	      } else {
	        this.$set(item, 'qtdeError', false);
	      }
	      item.Qtde_solicitado = this.limitaFaixaEntrada('inteiro', valorInput, 0, saldo);
	    }
	  }
	};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cronogramaSolicitacaoPagamento = __webpack_require__(1800);
	
	var _cronogramaSolicitacaoPagamento2 = _interopRequireDefault(_cronogramaSolicitacaoPagamento);
	
	var _cronogramaSolicitacaoContrapartida = __webpack_require__(530);
	
	var _cronogramaSolicitacaoContrapartida2 = _interopRequireDefault(_cronogramaSolicitacaoContrapartida);
	
	var _cronogramaSolicitacaoPrestacaocontas = __webpack_require__(1801);
	
	var _cronogramaSolicitacaoPrestacaocontas2 = _interopRequireDefault(_cronogramaSolicitacaoPrestacaocontas);
	
	var _documentoFiscal = __webpack_require__(1803);
	
	var _documentoFiscal2 = _interopRequireDefault(_documentoFiscal);
	
	var _formaPagamento = __webpack_require__(1804);
	
	var _formaPagamento2 = _interopRequireDefault(_formaPagamento);
	
	var _fornecedor = __webpack_require__(1805);
	
	var _fornecedor2 = _interopRequireDefault(_fornecedor);
	
	var _uploadDocumentosPhp = __webpack_require__(85);
	
	var _uploadDocumentosPhp2 = _interopRequireDefault(_uploadDocumentosPhp);
	
	var _dadosBancarios = __webpack_require__(1802);
	
	var _dadosBancarios2 = _interopRequireDefault(_dadosBancarios);
	
	var _historicoSolicitacaoPagamento = __webpack_require__(107);
	
	var _historicoSolicitacaoPagamento2 = _interopRequireDefault(_historicoSolicitacaoPagamento);
	
	var _historicoAntigo = __webpack_require__(106);
	
	var _historicoAntigo2 = _interopRequireDefault(_historicoAntigo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DadosBancarios: _dadosBancarios2.default,
	    UploadDocumentosPhp: _uploadDocumentosPhp2.default,
	    Fornecedor: _fornecedor2.default,
	    FormaPagamento: _formaPagamento2.default,
	    DocumentoFiscal: _documentoFiscal2.default,
	    CronogramaSolicitacaoPrestacaocontas: _cronogramaSolicitacaoPrestacaocontas2.default,
	    CronogramaSolicitacaoContrapartida: _cronogramaSolicitacaoContrapartida2.default,
	    CronogramaSolicitacaoPagamento: _cronogramaSolicitacaoPagamento2.default,
	    HistoricoSolicitacaoPagamento: _historicoSolicitacaoPagamento2.default,
	    HistoricoAntigo: _historicoAntigo2.default
	  },
	  name: 'form-validacao-pagamento',
	  data: function data() {
	    return {
	      loading: false,
	      analiseAutorizacao: ['ANALYSIS', 'MONITORING'],
	      checkedNames: [],
	      validacao: {
	        documentos_liberacao: {
	          parametros_documento: {
	            valor: ''
	          }
	        },
	        nome: ''
	      },
	      esconderHistorico: false,
	      data_edicao: '',
	      historicoTarefas: [],
	      historicoTarefasTela: [],
	      historicoBack: [],
	      relatorioForm: [],
	      nota: {
	        zerar: '',
	        bypass: ''
	      },
	      item: {},
	      textoMotivo: [],
	      relatorios: [],
	      rel: [],
	      relat: {
	        id: 13,
	        createdAt: null,
	        code: 'FJCF248.GER',
	        codeNames: 'ENumPrj;ECodFor',
	        fieldNames: 'Projeto;Beneficiário/Fornecedor',
	        title: '248 - Monitoramento Administrativo'
	      },
	      etapa: 'Análise',
	      force: 0,
	      proposta: {},
	      projeto: {},
	      motivoDevolucao: '',
	      aprovacao: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraParaValidacaoPagamento: function mostraParaValidacaoPagamento() {
	      return _.includes(this.analiseAutorizacao, this.validacao);
	    }
	  }),
	  watch: {},
	  created: function created() {
	    this.data_edicao = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	    this.buscaDados();
	  },
	  methods: {
	    atualizaOpcoes: function atualizaOpcoes($opcao) {
	      if (_.isUndefined(this.nota.parametros_documento)) {
	        this.nota.parametros_documento = [];
	      }
	      var existe = this.nota.parametros_documento.some(function (item) {
	        return item.valor === $opcao;
	      });
	      if (existe) {
	        _.remove(this.nota.parametros_documento, function (item) {
	          return item.valor === $opcao;
	        });
	      } else {
	        this.nota.parametros_documento.push({
	          'parametro': 'OPCOES',
	          'valor': $opcao
	        });
	      }
	    },
	    onLoad: function onLoad() {
	      var _this = this;
	
	      this.$snotify.clear();
	      this.$aguarde('Gerando relatório. Por favor, aguarde...');
	      axios.put('proxy/utility/erp-report/emit-report', { erpReport: this.relat, params: this.temp }).then(function (response) {
	        _this.onDownload(response);
	      }).catch(function (error) {
	        _this.$snotify.clear();
	        _this.$root.trataErro(error);
	      });
	    },
	    preeencheMotivo: function preeencheMotivo(parm) {
	      this.validacao.glosa = this.textoMotivo + '\n';
	    },
	    onSave: function onSave() {
	      var _this2 = this;
	
	      this.incluiMotivo();
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this2.aprovacao.nota = _this2.nota;
	          _this2.nota.resultadoAprovacao = _this2.aprovacao.resultadoAprovacao;
	          if (_this2.validacao.tarefas[0].nome === 'Solicitação') {
	            _this2.validacao.proximaEtapa = 'Análise';
	          }
	          if (_this2.validacao.tarefas[0].nome === 'Revisão') {
	            _this2.validacao.proximaEtapa = 'Análise';
	          }
	          if (_this2.validacao.tarefas[0].nome === 'Análise') {
	            if (_this2.nota.resultadoAprovacao === 'Revisão') {
	              _this2.validacao.proximaEtapa = 'Revisão';
	            }
	            if (_this2.nota.resultadoAprovacao === 'Aprovado') {
	              _this2.validacao.proximaEtapa = 'Autorização';
	            }
	          }
	          if (_this2.validacao.tarefas[0].nome === 'Autorização') {
	            if (_this2.nota.resultadoAprovacao === 'Aprovado') {
	              _this2.validacao.proximaEtapa = 'Conclusão';
	            }
	            if (_this2.nota.resultadoAprovacao === 'Revisão') {
	              _this2.validacao.proximaEtapa = 'Revisão';
	            }
	            if (_this2.nota.resultadoAprovacao === 'Retornar Análise') {
	              _this2.validacao.proximaEtapa = 'Análise';
	            }
	          }
	
	          _.remove(_this2.validacao.receiptApprovals, function (item) {
	            return item.receipt.id === _this2.nota.id;
	          });
	
	          if (_this2.aprovacao.nota.receiptItems) {
	            var x = 0;
	            var j = 0;
	            for (x = 0; x < _this2.aprovacao.nota.itens_liberados.length; x++) {
	              for (j = 0; j < _this2.aprovacao.nota.receiptItems.length; j++) {
	                if (_this2.aprovacao.nota.itens_liberados[x].itens_orcamentos[0].fk_itens === _this2.aprovacao.nota.receiptItems[j].Item) {
	                  _this2.aprovacao.nota.itens_liberados[x].quantidade = _this2.aprovacao.nota.receiptItems[j].quantityRequest;
	                  _this2.aprovacao.nota.itens_liberados[x].valor = _this2.aprovacao.nota.receiptItems[j].valueRequest;
	                }
	              }
	            }
	          }
	          _this2.validacao.documentos_liberacao = _this2.nota;
	
	          _this2.validacao.proxima_etapa = _this2.validacao.proximaEtapa;
	          _this2.validacao.tarefas[0].data_edicao = _this2.data_edicao;
	
	          _this2.enviaBackEnd();
	        } else {
	          _this2.$snotify.error('existem campos com erro favor verificar');
	        }
	      });
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this3 = this;
	
	      this.validacao.processo.nome = 'PAGAMENTO';
	      this.validacao.aglutinado = 'Não';
	      console.log('this.validacao RLMB', this.validacao);
	      this.$aguarde('Enviando Validação de Pagamento. Por favor, aguarde...');
	      axiosLaravel.put('processos/tarefas/atualiza/', this.validacao).then(function (response) {
	        _this3.$snotify.clear();
	        if (_.hasIn(response, 'error')) {
	          _this3.$snotify.clear();
	          _this3.$snotify.error(response.data.value.error[0], '', 10000);
	        } else {
	          _this3.$snotify.clear();
	          _this3.$snotify.success('Solicitação gravada com sucesso!');
	          setTimeout(function () {
	            _this3.$router.go(-1);
	          }, 2000);
	        }
	      }).catch(function (error) {
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    gravaHistorico: function gravaHistorico(_parm) {},
	    voltaPraSolicitacao: function voltaPraSolicitacao() {
	      this.$router.go(-1);
	    },
	    buscaDados: function buscaDados() {
	      var _this4 = this;
	
	      this.buscaHistorico(this.$route.params.id);
	      this.force = 0;
	
	      this.loadingShow = true;
	      axiosLaravel.get('processos/' + this.$route.params.id).then(function (response) {
	        _this4.validacao = response.data;
	        _this4.dataProcesso = (0, _moment2.default)(_this4.validacao.inicio).format('DD/MM/YYYY');
	        _this4.validacao.processo = _.omit(response.data, ['documentos_liberacao', 'tarefas']);
	        _this4.historicoTarefas = _.cloneDeep(response.data.tarefas);
	        _this4.historicoTarefasTela = _.cloneDeep(response.data.tarefas);
	        var array = _this4.historicoTarefas.filter(function (item) {
	          return item.tipo === 'Usuário' && !_.isNull(item.termino);
	        });
	        _this4.historicoTarefas = _.cloneDeep(array);
	        for (var i = 0; i < _this4.historicoTarefas.length; i++) {
	          if (_this4.historicoTarefas.usuario !== null) {
	            _this4.usuario = _this4.historicoTarefas.usuario;
	          }
	        }
	        _this4.nota = _.cloneDeep(_this4.validacao.documentos_liberacao[0]);
	        _this4.nomeProjeto = _this4.validacao.documentos_liberacao[0].itens_liberados[0].itens_orcamentos[0].proposta.ds_codigo_projeto_erp + '-' + _this4.validacao.documentos_liberacao[0].itens_liberados[0].itens_orcamentos[0].proposta.ds_nome;
	        _this4.numeroProjeto = _this4.validacao.documentos_liberacao[0].itens_liberados[0].itens_orcamentos[0].proposta.ds_codigo_projeto_erp;
	        _this4.objetivoProjeto = _this4.validacao.documentos_liberacao[0].itens_liberados[0].itens_orcamentos[0].proposta.ds_objetivo_geral;
	        if (_this4.nota.parametros_documento.some(function (item) {
	          return item.valor === 'ZERAR_IMPOSTO';
	        })) {
	          _this4.nota.zerar = 'ZERAR_IMPOSTO';
	        }
	        if (_this4.nota.parametros_documento.some(function (item) {
	          return item.valor === 'BYPASS';
	        })) {
	          _this4.nota.bypass = 'BYPASS';
	        }
	
	        _this4.proposta = _this4.nota.itens_liberados[0].itens_orcamentos[0].proposta;
	        _this4.projeto = _this4.proposta.projeto;
	        _this4.validacao.nome = 'PAGAMENTO';
	        _this4.fase = _this4.validacao.tarefas[0].nome;
	        if (_this4.validacao.documentos_liberacao[0].length === 0) {
	          _this4.etapa = 'Solicitação';
	        }
	        if (_this4.validacao.tarefas[0].nome === 'Autorização') {
	          _this4.etapa = 'Autorização';
	        }
	        _this4.$root.$on('historico', function (dados) {
	          _this4.historicoTarefas = dados;
	        });
	        _this4.historicoTarefas = _this4.historicoTarefas.map(function (item) {
	          if (_.isNull(item.usuario)) {
	            item.nomeUsu = '-';
	          } else {
	            item.nomeUsu = item.usuario.ds_nome_usuario;
	          }
	          return item;
	        });
	
	        _this4.force = 1;
	        _this4.$forceUpdate();
	        _this4.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this4.$root.trataErro(error);
	      });
	    },
	    emitir: function emitir(relatorio) {
	      var _this5 = this;
	
	      var mosDes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loading = true;
	      var parametros = '<ECodEmp=1><ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '>';
	
	      if (relatorio === 219) {
	        parametros += '<ESitPrj=ULT>';
	      } else if (relatorio === 248) {
	        parametros += '<ECodFor=>';
	      }
	
	      if (relatorio === 525) {
	        parametros = '<ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '><EMosDes=' + mosDes + '>';
	      }
	      this.$snotify.clear();
	      console.log('parametros', parametros);
	      var identificacao = relatorio === 525 ? '525 - Extrato ' + (mosDes === 'S' ? 'Analítico' : 'Sintético') : relatorio;
	      this.$aguarde('Gerando relatório ' + identificacao + '. Por favor, aguarde...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': 'FJCF' + relatorio + '.GER' }, params: parametros }).then(function (response) {
	        _this5.onDownload(response, identificacao, _this5);
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.loading = false;
	        _this5.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (!ie) {
	        var blob = file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp + ' - ' + vm.proposta.ds_nome;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	        _link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp + ' - ' + vm.proposta.ds_nome;
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    buscaHistorico: function buscaHistorico(request) {
	      var _this6 = this;
	
	      console.log('caiu aqui historicoBack', request);
	      axiosLaravel.post('historico-tarefas/lista', { 'parametro': request }).then(function (response) {
	        _this6.historicoBack = response.data;
	        console.log('response historicoBack', response.data);
	      });
	    },
	    incluiMotivo: function incluiMotivo() {
	      if (this.aprovacao.resultadoAprovacao === 'Revisão') {
	        this.validacao.glosa = '#' + this.motivoDevolucao + '# ' + this.validacao.glosa;
	      }
	    }
	  }
	};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'lista-validacao-proposta',
	  data: function data() {
	    return {
	      quantidadesPorFase: {},
	      simplificados: [],
	      faseAtual: '',
	      descricaoFase: '',
	      filtro: {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        nomeProposta: null,
	        offset: 0,
	        preAnalysisApprovalType: 'FIRST_APPROVAL',
	        userId: null,
	        flowType: null
	      },
	      aprovacaoLista: [],
	      aprovacaoTotal: null,
	      loadingShow: false,
	      table: {
	        items: [],
	        totalRows: 0,
	        filter: null,
	        hover: false,
	        bordered: false,
	        currentPage: 1,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        perPage: 10,
	        fields: [{ key: 'favorite', label: '', thStyle: 'text-align: center; width: 3%', class: 'text-center' }, { key: 'proposta', label: '', thStyle: 'text-align: left; width: 60%', class: 'text-left' }, { key: 'userName', label: '', thStyle: 'font-weight: bold' }, { key: 'createdAt', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: '', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      table2: {
	        items: [],
	        totalRows: 0,
	        filter: null,
	        hover: false,
	        bordered: false,
	        currentPage: 1,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        perPage: 10,
	        fields: [{ key: 'favorite', label: '', thStyle: 'text-align: center; width: 3%', class: 'text-center' }, { key: 'proposta', label: '', thStyle: 'text-align: left; width: 60%', class: 'text-left' }, { key: 'userName', label: '', thStyle: 'font-weight: bold' }, { key: 'createdAt', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: '', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      rota1: '',
	      rota2: ''
	    };
	  },
	
	  watch: {
	    'filtro.favorite': function filtroFavorite() {
	      this.onSearch();
	    },
	    'filtro.userId': function filtroUserId() {
	      this.onSearch();
	    },
	    'faseAtual': function faseAtual() {
	      this.onSearch();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    this.buscaQuantidadePorFase();
	
	    axios.get('proxy/document/simplified/geral/list').then(function (response) {
	      _this.simplificados = response.data.value;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	  mounted: function mounted() {
	    this.onSearch();
	  },
	
	  methods: {
	    buscaQuantidadePorFase: function buscaQuantidadePorFase() {
	      var _this2 = this;
	
	      axios.get('proxy/project/proposal-approval/count').then(function (response) {
	        _this2.quantidadesPorFase = response.data.value;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    onFilteredRejeitados: function onFilteredRejeitados(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    onSearch: function onSearch() {
	      this.loadingShow = true;
	      this.filtro.flowType = null;
	      switch (this.faseAtual) {
	        case 'primeira':
	          this.filtro.preAnalysisApprovalType = 'FIRST_APPROVAL';
	          this.descricaoFase = 'Pré-Análise - Primeira Aprovação';
	          this.buscaBackEnd('proxy/project/approval-pre-analysis/search/sql');
	          this.rota1 = 'proposta-primeira-validacao';
	          break;
	        case 'segunda':
	          this.filtro.preAnalysisApprovalType = 'SECOND_APPROVAL';
	          this.descricaoFase = 'Pré-Análise - Segunda Aprovação';
	          this.buscaBackEnd('proxy/project/approval-pre-analysis/search/sql');
	          this.rota1 = 'proposta-primeira-validacao';
	          break;
	        case 'aceite':
	          this.descricaoFase = 'Aceite - Primeira Aprovação/Recusa';
	          this.buscaBackEnd('proxy/project/approval-acceptance/search');
	          this.rota1 = 'validacao-proposta-aceite';
	          break;
	        case 'analise':
	          this.descricaoFase = 'Análise - Aprovação';
	          this.buscaBackEnd('proxy/project/approval-analysis/search/sql');
	          this.buscaAnalisePendencia('pendência');
	          this.rota1 = 'validacao-proposta-analise';
	          this.rota2 = '';
	          break;
	        case 'deferimento':
	          this.descricaoFase = 'Deferimento - Aprovação';
	          this.buscaBackEnd('proxy/project/approval-grant/search/sql');
	          this.rota1 = 'validacao-proposta-deferimento';
	          break;
	        case 'preparacao':
	          this.descricaoFase = 'Preparação de Documentos - Aprovação';
	          this.buscaBackEnd('proxy/project/document-preparation/search/sql');
	          this.rota1 = 'validacao-proposta-preparacao-documento';
	          break;
	        case 'formalizacao':
	          this.descricaoFase = 'Formalizar Projetos - Aprovação';
	          this.buscaBackEnd('proxy/project/project-formalization/search/sql');
	          this.rota1 = 'validacao-proposta-formalizacao';
	          break;
	        default:
	          this.faseAtual = 'primeira';
	          this.filtro.preAnalysisApprovalType = 'FIRST_APPROVAL';
	          this.descricaoFase = 'Pré-Análise - Primeira Aprovação';
	          this.buscaBackEnd('proxy/project/approval-pre-analysis/search/sql');
	      }
	      this.buscaQuantidadePorFase();
	    },
	    buscaBackEnd: function buscaBackEnd(url) {
	      var _this3 = this;
	
	      axios.post(url, this.filtro).then(function (response) {
	        _this3.carregaTabela(response);
	        if (_this3.faseAtual === 'aceite') {
	          _this3.buscaAceiteRejeitados();
	        } else if (_this3.faseAtual === 'analise') {
	          _this3.buscaAnalisePendencia();
	        }
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaAceiteRejeitados: function buscaAceiteRejeitados() {
	      var _this4 = this;
	
	      this.filtro.flowType = 'REJECTED';
	      axios.post('proxy/project/approval-acceptance/search/sql', this.filtro).then(function (response) {
	        _this4.table2.items = response.data.value.list;
	        _this4.table2.totalRows = response.data.value.total;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    buscaAnalisePendencia: function buscaAnalisePendencia() {
	      var _this5 = this;
	
	      axios.post('proxy/project/approval-analysis-pendency/search/sql', this.filtro).then(function (response) {
	        _this5.table2.items = response.data.value.list;
	        _this5.table2.totalRows = response.data.value.total;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    carregaTabela: function carregaTabela(response) {
	      this.table.items = response.data.value.list;
	      this.table.totalRows = response.data.value.total;
	      this.loadingShow = false;
	    },
	    onFavorite: function onFavorite(item) {
	      var _this6 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/project/approval-pre-analysis/';
	          break;
	        case 'segunda':
	          url = 'proxy/project/approval-pre-analysis/';
	          break;
	        case 'aceite':
	          break;
	        case 'analise':
	          url = 'proxy/project/approval-analysis/';
	          break;
	        case 'deferimento':
	          url = 'proxy/project/approval-grant/';
	          break;
	        case 'preparacao':
	          url = 'proxy/project/document-preparation/';
	          break;
	        case 'formalizacao':
	          url = 'proxy/project/project-formalization/';
	          break;
	      }
	      axios.put(url + item.id + '/favorite', '').then(function (response) {
	        _this6.onSearch();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    onUnassign: function onUnassign(item) {
	      var _this7 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/project/approval-pre-analysis/';
	          break;
	        case 'segunda':
	          url = 'proxy/project/approval-pre-analysis/';
	          break;
	        case 'aceite':
	          url = 'proxy/project/approval-acceptance/';
	          break;
	        case 'analise':
	          url = 'proxy/project/approval-analysis/';
	          break;
	        case 'deferimento':
	          url = 'proxy/project/approval-grant/';
	          break;
	        case 'preparacao':
	          url = 'proxy/project/document-preparation/';
	          break;
	        case 'formalizacao':
	          url = 'proxy/project/project-formalization/';
	          break;
	      }
	      axios.put(url + item.id + '/unassign', '').then(function (response) {
	        _this7.onSearch();
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    onAssign: function onAssign(item) {
	      var _this8 = this;
	
	      var url = '';
	      console.log('this.faseAtual', this.faseAtual);
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/project/approval-pre-analysis/';
	          break;
	        case 'segunda':
	          url = 'proxy/project/approval-pre-analysis/';
	          break;
	        case 'aceite':
	          url = 'proxy/project/approval-acceptance/';
	          break;
	        case 'analise':
	          url = 'proxy/project/approval-analysis/';
	          break;
	        case 'deferimento':
	          url = 'proxy/project/approval-grant/';
	          break;
	        case 'preparacao':
	          url = 'proxy/project/document-preparation/';
	          break;
	        case 'formalizacao':
	          url = 'proxy/project/project-formalization/';
	          break;
	      }
	      axios.put(url + item.id + '/assign', '').then(function (response) {
	        _this8.onSearch();
	      }).catch(function (error) {
	        _this8.$root.trataErro(error);
	      });
	    },
	    onAssignAndDo: function onAssignAndDo(item) {
	      this.onAssign(item);
	      this.$router.push({ name: this.rota1, params: { id: item.id } });
	    }
	  }
	};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  name: 'DetalheValidaEntidade',
	  data: function data() {
	    return {
	      campoErro: null,
	      detalhe: {},
	      analise: {
	        approvalResult: '',
	        justify: ''
	      },
	      usuarios: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    dataCriacao: function dataCriacao() {
	      return (0, _moment2.default)(this.detalhe.createdAt).format('DD/MM/YYYY');
	    },
	    dataAtualizacao: function dataAtualizacao() {
	      return (0, _moment2.default)(this.detalhe.updatedAt).format('DD/MM/YYYY');
	    }
	  }),
	  created: function created() {
	    this.loadApproval();
	  },
	
	  methods: {
	    loadApproval: function loadApproval() {
	      var _this = this;
	
	      axios.get('/proxy/account/approval-entity/' + this.$route.params.id).then(function (response) {
	        _this.detalhe = response.data.value;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onUnassign: function onUnassign() {
	      var _this2 = this;
	
	      var url = 'proxy/account/approval-entity/';
	      axios.put(url + this.$route.params.id + '/unassign', '').then(function (response) {
	        _this2.onSearch();
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    onAssign: function onAssign() {
	      var _this3 = this;
	
	      var url = 'proxy/account/approval-entity/';
	      axios.put(url + this.$route.params.id + '/assign', '').then(function (response) {
	        _this3.onSearch();
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaValidacaoEntidade',
	  data: function data() {
	    return {
	      quantidadesPrimeiraAprov: '',
	      quantidadesSegundaAprov: '',
	      quantidadesFinalizadas: '',
	      simplificados: [],
	      faseAtual: '',
	      descricaoFase: '',
	      filtro: {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        approvalResult: null,
	        entityApprovalType: 'FIRST_APPROVAL',
	        userId: null
	      },
	      filtro2: {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        approvalResult: null,
	        entityApprovalType: 'SECOND_APPROVAL',
	        userId: null
	      },
	      filtro3: {
	        entityName: null,
	        eventStatus: 'DONE',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        entityApprovalType: 'SECOND_APPROVAL',
	        approvalResult: 'APPROVED',
	        userId: null
	      },
	      aprovacaoLista: [],
	      aprovacaoTotal: null,
	      loadingShow: false,
	      table: {
	        items: [],
	        totalRows: 0,
	        filter: null,
	        hover: false,
	        bordered: false,
	        currentPage: 1,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        perPage: 10,
	        fields: [{ key: 'favorite', label: '', thStyle: 'text-align: center; width: 3%', class: 'text-center' }, { key: 'entidade', label: '', thStyle: 'text-align: left; width: 60%', class: 'text-left' }, { key: 'userName', label: '', thStyle: 'font-weight: bold' }, { key: 'createdAt', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: '', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      rota1: 'validacao-entidades',
	      rota2: ''
	    };
	  },
	
	  watch: {
	    'filtro.favorite': function filtroFavorite() {
	      this.onSearch();
	    },
	    'filtro.userId': function filtroUserId() {
	      this.onSearch();
	    },
	    'faseAtual': function faseAtual() {
	      this.filtro.userId = null;
	      this.filtro.favorite = null;
	      this.filtro.eventStatus = 'OPEN';
	
	      this.onSearch();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    axios.get('proxy/document/simplified/geral/list').then(function (response) {
	      _this.simplificados = response.data.value;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	  mounted: function mounted() {
	    this.onSearch();
	  },
	
	  methods: {
	    quantidadePrimeiraFase: function quantidadePrimeiraFase() {
	      var _this2 = this;
	
	      var filtroQuantidade = {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        entityApprovalType: 'FIRST_APPROVAL',
	        userId: null
	      };
	
	      axios.post('proxy/account/approval-entity/search/sql', filtroQuantidade).then(function (response) {
	        _this2.quantidadesPrimeiraAprov = response.data.value.total;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    quantidadeSegundaFase: function quantidadeSegundaFase() {
	      var _this3 = this;
	
	      var filtroQuantidade2 = {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        entityApprovalType: 'SECOND_APPROVAL',
	        userId: null
	      };
	
	      axios.post('proxy/account/approval-entity/search/sql', filtroQuantidade2).then(function (response) {
	        _this3.quantidadesSegundaAprov = response.data.value.total;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    quantidadeFinalizadas: function quantidadeFinalizadas() {
	      var _this4 = this;
	
	      var filtroQuantidade3 = {
	        entityName: null,
	        eventStatus: 'DONE',
	        approvalResult: 'APPROVED',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        entityApprovalType: 'SECOND_APPROVAL',
	        userId: null
	      };
	
	      axios.post('proxy/account/approval-entity/search/sql', filtroQuantidade3).then(function (response) {
	        _this4.quantidadesFinalizadas = response.data.value.total;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    buscaBackEnd: function buscaBackEnd(url) {
	      var _this5 = this;
	
	      axios.post(url, this.filtro).then(function (response) {
	        _this5.carregaTabela(response);
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    carregaTabela: function carregaTabela(response) {
	      this.table.items = response.data.value.list;
	      this.table.totalRows = response.data.value.total;
	      this.loadingShow = false;
	    },
	    onSearch: function onSearch() {
	      this.loadingShow = true;
	      switch (this.faseAtual) {
	        case 'primeira':
	          this.filtro.entityApprovalType = 'FIRST_APPROVAL';
	          this.descricaoFase = 'Primeira Aprovação';
	          this.filtro.approvalResult = null;
	          this.buscaBackEnd('proxy/account/approval-entity/search/sql');
	          break;
	        case 'segunda':
	          this.filtro.entityApprovalType = 'SECOND_APPROVAL';
	          this.descricaoFase = 'Segunda Aprovação';
	          this.filtro.approvalResult = null;
	          this.buscaBackEnd('proxy/account/approval-entity/search/sql');
	          break;
	        case 'finalizada':
	          this.filtro.entityApprovalType = 'SECOND_APPROVAL';
	          this.descricaoFase = 'Finalizadas';
	          this.filtro.eventStatus = 'DONE';
	          this.filtro.approvalResult = 'APPROVED';
	          this.buscaBackEnd('proxy/account/approval-entity/search/sql');
	          break;
	        default:
	          this.faseAtual = 'primeira';
	          this.filtro.entityApprovalType = 'FIRST_APPROVAL';
	          this.filtro.approvalResult = null;
	          this.descricaoFase = 'Primeira Aprovação';
	          this.buscaBackEnd('proxy/account/approval-entity/search/sql');
	      }
	      this.quantidadePrimeiraFase();
	      this.quantidadeSegundaFase();
	      this.quantidadeFinalizadas();
	    },
	    onFavorite: function onFavorite(item) {
	      var _this6 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-entity/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-entity/';
	          break;
	      }
	      axios.put(url + item.id + '/favorite', '').then(function (response) {
	        _this6.onSearch();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    onAssign: function onAssign(item) {
	      var _this7 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-entity/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-entity/';
	          break;
	      }
	      axios.put(url + item.id + '/assign', '').then(function (response) {
	        _this7.onSearch();
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    onAssignAndDo: function onAssignAndDo(item) {
	      this.onAssign(item);
	      this.$router.push({ name: this.rota1, params: { id: item.id } });
	    },
	    onUnassign: function onUnassign(item) {
	      var _this8 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-entity/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-entity/';
	          break;
	      }
	      axios.put(url + item.id + '/unassign', '').then(function (response) {
	        _this8.onSearch();
	      }).catch(function (error) {
	        _this8.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _historicoEntidade = __webpack_require__(105);
	
	var _historicoEntidade2 = _interopRequireDefault(_historicoEntidade);
	
	var _vuex = __webpack_require__(3);
	
	var _deepObjectDiff = __webpack_require__(83);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    HistoricoEntidade: _historicoEntidade2.default,
	    Usuarios: _usuarios2.default
	  },
	  name: 'ValidaEntidades',
	  data: function data() {
	    return {
	      campoErro: null,
	      entidade: {
	        contato: [],
	        dirigentes: [],
	        documentos: [],
	        usuarios: [],
	        mudancas: {},
	        mostraHistorico: false,
	        proximaEtapa: '',
	        naoExisteRamo: false,
	        ramo_atividade: {}
	      },
	      loading: {
	        show: false
	      },
	      salvouOK: false,
	      exibeIcone: false,
	      mostraInclusao: false,
	      mostraExclusao: false,
	      mostraAlteracao: false,
	      componenteSuperior: 'validacao',
	      analise: [],
	      boqueia: false,
	      dirigentes: [],
	      ramoAtividade: [],
	      listaFormasJuridicas: [],
	      listaDocConstituicao: [],
	      listaRamosAtividade: [],
	      dt_data_expedicao_cnpj: '',
	      endereco: {},
	      historico: [],
	      historico_atualizado: [],
	      listaHistorico: [],
	      usuarios: {},
	      formasJuridicas: [],
	      inclRamoTexto: [],
	      tarefas: [],
	
	      possuiCmas: '',
	      possuiCebas: ''
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  watch: {
	    dt_data_expedicao_cnpj: function dt_data_expedicao_cnpj(val) {
	      var newdate = (0, _moment2.default)(val, 'DD/MM/YYYY', true);
	      if (newdate.isValid()) {
	        this.entidade.dt_data_expedicao_cnpj = newdate.format('YYYY-MM-DD');
	      }
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    this.$aguarde('Buscando dados da Entidade. Por favor, aguarde...');
	    if (this.$route.params.id) {
	      axiosLaravel.get('entidades/' + this.$route.params.id).then(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(response) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _this.entidade = response.data;
	                  _this.entidade.observacao = '';
	                  _this.$route.params.entidade = _this.entidade;
	                  _this.dt_data_expedicao_cnpj = (0, _moment2.default)(_this.entidade.dt_data_expedicao_cnpj).format('DD/MM/YYYY');
	                  _this.$forceUpdate();
	                  _context.next = 7;
	                  return _this.carregaListaFormasJuridicas();
	
	                case 7:
	                  _context.next = 9;
	                  return _this.carregaListaRamosAtividade();
	
	                case 9:
	                  _context.next = 11;
	                  return _this.carregaListaDocumentosConstituicao();
	
	                case 11:
	                  _context.next = 13;
	                  return _this.verMudancas();
	
	                case 13:
	                  _this.$forceUpdate();
	                  _this.$snotify.clear();
	                  _this.$snotify.success('Dados da Entidade recuperados com sucesso!', { timeout: 2000 });
	                  _this.processos = response.data.processos;
	                  _this.cnpj = _this.entidade.cnpj;
	                  _this.dirigentes = response.data.dirigentes;
	                  _this.tarefas = _this.processos.map(function (item) {
	                    return item.tarefas;
	                  });
	                  _this.historico = _this.tarefas;
	                  _this.historico = _.sortBy(_this.historico, 'id').reverse();
	                  _this.$snotify.clear();
	
	                  if (_this.entidade.tipos_documento.findIndex(function (e) {
	                    return e.id === 70;
	                  }) >= 0 || _this.entidade.documentos.findIndex(function (e) {
	                    return e.tipo_documento.id === 70;
	                  }) >= 0) {
	                    _this.possuiCmas = 'Sim';
	                  } else {
	                    _this.possuiCmas = 'Não';
	                  }
	                  if (_this.entidade.tipos_documento.findIndex(function (e) {
	                    return e.id === 71;
	                  }) >= 0 || _this.entidade.documentos.findIndex(function (e) {
	                    return e.tipo_documento.id === 71;
	                  }) >= 0) {
	                    _this.possuiCebas = 'Sim';
	                  } else {
	                    _this.possuiCebas = 'Não';
	                  }
	                  _this.$forceUpdate();
	
	                case 26:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }()).catch(function (error) {
	        if (error) {
	          _this.$snotify.clear();
	          _this.$root.trataErro(error);
	        }
	      });
	    }
	    this.formasJuridicas = [{ c: '101-5', d: 'Órgão Público do Poder Executivo Federal' }, { c: '102-3', d: 'Órgão Público do Poder Executivo Estadual ou do Distrito Federal' }, { c: '103-1', d: 'Órgão Público do Poder Executivo Municipal' }, { c: '110-4', d: 'Autarquia Federal' }, { c: '111-2', d: 'Autarquia Estadual ou do Distrito Federal' }, { c: '112-0', d: 'Autarquia Municipal' }, { c: '113-9', d: 'Fundação Pública de Direito Público Federal' }, { c: '114-7', d: 'Fundação Pública de Direito Público Estadual ou do Distrito Federal' }, { c: '115-5', d: 'Fundação Pública de Direito Público Municipal' }, { c: '116-3', d: 'Órgão Público Autônomo Federal' }, { c: '117-1', d: 'Órgão Público Autônomo Estadual ou do Distrito Federal' }, { c: '118-0', d: 'Órgão Público Autônomo Municipal' }, { c: '123-6', d: 'Estado ou Distrito Federal' }, { c: '124-4', d: 'Município' }, { c: '125-2', d: 'Fundação Pública de Direito Privado Federal' }, { c: '126-0', d: 'Fundação Pública de Direito Privado Estadual ou do Distrito Federal' }, { c: '127-9', d: 'Fundação Pública de Direito Privado Municipal' }, { c: '201-1', d: 'Empresa Pública' }, { c: '214-3', d: 'Cooperativa' }, { c: '227-5', d: 'Empresa Binacional' }, { c: '306-9', d: 'Fundação Privada' }, { c: '307-7', d: 'Serviço Social Autônomo' }, { c: '313-1', d: 'Entidade Sindical' }, { c: '320-4', d: 'Estabelecimento, no Brasil, de Fundação ou Associação Estrangeiras' }, { c: '321-2', d: 'Fundação ou Associação Domiciliada no Exterior' }, { c: '323-9', d: 'Comunidade Indígena' }, { c: '330-1', d: 'Organização Social (OS)' }, { c: '399-9', d: 'Associação Privada' }, { c: '501-0', d: 'Organização Internacional' }, { c: '502-9', d: 'Representação Diplomática Estrangeira' }, { c: '503-7', d: 'Outras Instituições Extraterritoriais' }, { c: '204-6', d: 'Sociedade Anônima Aberta' }, { c: '205-4', d: 'Sociedade Anônima Fechada' }];
	  },
	
	  methods: {
	    verMudancas: function verMudancas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var i;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.$snotify.clear();
	                _this2.$aguarde('Verificando alterações efetuadas no cadastro. Por favor, aguarde...');
	
	                _this2.exibeIcone = false;
	                for (i = 0; i < _this2.entidade.processos.length; i++) {
	                  if (_this2.entidade.processos[i].situacao === 'EM_EXECUCAO') {
	                    _this2.idProcesso = _this2.entidade.processos[i].id;
	                  }
	                }
	                _context2.next = 6;
	                return axiosLaravel.get('/entidades/' + _this2.entidade.id + '/alteracoes/', {}).then(function (response) {
	                  _this2.mudancas = response.data.diferenca;
	                  _this2.diferenca = response.data.diferencaAnaliseRevisao;
	                  _this2.analise = response.data.analise;
	                  _this2.revisao = response.data.revisao;
	                  _this2.$forceUpdate();
	                  if (_this2.analise && _this2.revisao) {
	                    if (_this2.analise.length > _this2.revisao.length) {
	                      _this2.mostraExclusao = true;
	                      _this2.mostraInclusao = false;
	                    } else {
	                      _this2.mostraExclusao = true;
	                    }
	                    if (_this2.analise.length < _this2.revisao.length) {
	                      _this2.mostraInclusao = true;
	                      _this2.mostraExclusao = false;
	                    } else {
	                      _this2.mostraInclusao = false;
	                    }
	                    if (_this2.analiseEnd === _this2.revisao.length) {
	                      _this2.mostraExclusao = false;
	                    }
	                  }
	                  _this2.adicionados = (0, _deepObjectDiff.detailedDiff)(_this2.analise, _this2.revisao).added;
	                  _this2.excluidos = (0, _deepObjectDiff.detailedDiff)(_this2.analise, _this2.revisao).deleted;
	                  if (_this2.adicionados) {
	                    if (_this2.adicionados.ramos_atividade) {
	                      _this2.inclRamo = _this2.adicionados.ramos_atividade;
	                      _this2.inclRamoTexto = _.map(_this2.inclRamo, 'ds_descricao');
	                      _this2.naoExisteRamo = false;
	                    } else {
	                      _this2.naoExisteRamo = true;
	                    }
	                  }
	                  if (_this2.excluidos) {
	                    _this2.exclRamo = _.values(_.keys(_this2.excluidos.ramos_atividade));
	                    if (_this2.exclRamo) {
	                      _this2.naoExisteRamo = false;
	                    } else {
	                      _this2.naoExisteRamo = true;
	                    }
	                  }
	                  if (_.hasIn(_this2.adicionados, 'ramos_atividade') && _this2.excluidos !== {}) {
	                    _this2.naoExisteRamo = false;
	                  } else {
	                    _this2.naoExisteRamo = true;
	                    _this2.altRamoTexto = _.map(_this2.analise.ramos_atividade, 'ds_descricao');
	                  }
	                }).catch(function (error) {
	                  _this2.$root.trataErro(error);
	                });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    etiquetaListaFormaJuridica: function etiquetaListaFormaJuridica(option) {
	      return '' + (option.codigo + ' / ' + option.descricao);
	    },
	    etiquetaListaRamosAtividade: function etiquetaListaRamosAtividade(option) {
	      return '' + (option.ds_codigo + '    ' + option.ds_descricao);
	    },
	    carregaListaFormasJuridicas: function carregaListaFormasJuridicas() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _this3.$root.buscaFormasJuridicas(_this3.$store);
	
	              case 2:
	                _this3.listaFormasJuridicas = _this3.$store.state.formasJuridicas;
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3);
	      }))();
	    },
	    carregaListaRamosAtividade: function carregaListaRamosAtividade() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return _this4.$root.buscaRamoAtividades(_this4.$store);
	
	              case 2:
	                _this4.listaRamosAtividade = _this4.$store.state.ramoAtividades;
	
	              case 3:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this4);
	      }))();
	    },
	    carregaListaDocumentosConstituicao: function carregaListaDocumentosConstituicao() {
	      var _this5 = this;
	
	      axiosLaravel.post('documentos/tipos/ENTIDADE_DOC_CONSTITUICAO').then(function (response) {
	        _this5.listaDocConstituicao = response.data;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    isEditable: function isEditable() {
	      return this.$root.authorize('entidade-editar') || this.$root.authorize('minha-entidade-editar');
	    },
	    customLabel: function customLabel(option) {
	      return '' + (option.c + ' / ' + option.d);
	    },
	    outrasValidacoes: function outrasValidacoes() {
	      if (!this.entidade.dirigentes || this.entidade.dirigentes === 0) {
	        this.$snotify.error('Os dados obrigatórios do dirigente devem ser preenchidos!');
	        return false;
	      }
	      return true;
	    },
	    salvaUsuarios: function salvaUsuarios() {
	      for (var i = 0; i < this.entidade.usuarios.length; i++) {
	        if (!this.entidade.usuarios[i].ds_tipo_usuario) {
	          this.entidade.usuarios[i].ds_tipo_usuario = 'ENTIDADE';
	
	          this.entidade.usuarios[i].fk_entidade = this.entidade.id;
	          this.entidade.usuarios[i].fk_usuario_criador = this.usuarioLogado.id;
	          this.entidade.usuarios[i].fk_preferencia = null;
	          this.entidade.usuarios[i].dt_data_inativacao = null;
	          this.entidade.usuarios[i].fk_agencia = null;
	          this.entidade.usuarios[i].fk_parceiro_estrategico = null;
	          this.entidade.usuarios[i].fk_superintendencia = null;
	        }
	      }
	    },
	    salva: function salva() {
	      if (this.entidade.id) {
	        this.atualiza();
	      } else {
	        this.grava();
	      }
	    },
	    conclui: function conclui() {
	      var _this6 = this;
	
	      if (this.entidade.resultadoAprovacao === 'Aprovar') {
	        this.entidade.proximaEtapa = 'CONCLUSAO';
	      }
	      if (this.entidade.resultadoAprovacao === 'Revisar') {
	        this.entidade.proximaEtapa = 'REVISAO';
	      }
	      if (this.entidade.resultadoAprovacao === 'Cancelar') {
	        this.entidade.proximaEtapa = 'CANCELAR';
	      }
	      var entidadeOK = true;
	      var aba = '';
	      if (_.isEmpty(this.entidade.endereco)) {
	        entidadeOK = false;
	        aba = 'Endereço';
	      }
	      if (_.isEmpty(this.entidade.dirigentes)) {
	        entidadeOK = false;
	        aba = 'Dirigentes';
	      }
	      if (entidadeOK === true) {
	        this.$validator.validateAll().then(function (result) {
	          if (result) {
	            _this6.boqueia = true;
	            _this6.outrasValidacoes();
	            if (_this6.entidade.id) {
	              if (_this6.resultadoAprovacao === 'Aprovar') {
	                _this6.entidade.observacao = '';
	              }
	              _this6.salvaUsuarios();
	              _this6.$aguarde('Gravando cadastro da entidade. Por favor, aguarde...');
	              axiosLaravel.put('entidades/' + _this6.entidade.id, _this6.entidade).then(function (response) {
	                if (response.data) {
	                  _this6.$snotify.clear();
	                  _this6.$snotify.success('Alteração cadastral concluída com sucesso!');
	                  _this6.boqueia = false;
	                  _this6.$router.go(-1);
	                }
	              }).catch(function (error) {
	                _this6.boqueia = false;
	                _this6.$snotify.clear();
	                _this6.$root.trataErro(error);
	              });
	            }
	          } else {
	            _this6.$snotify.error('O formulário de Dados da Entidade possui erros. Favor verificar!');
	          }
	        });
	      } else {
	        this.$snotify.error('Erros no preenchimento da aba ' + aba + '. Favor verificar.');
	      }
	    },
	    atualiza: function atualiza() {
	      var _this7 = this;
	
	      this.entidade.proximaEtapa = 'SALVAR';
	      this.salvaUsuarios();
	      this.$aguarde('Atualizando dados da entidade. Por favor, aguarde...');
	      axiosLaravel.put('entidades/' + this.entidade.id, this.entidade).then(function (response) {
	        _this7.$emit('salvou', 'OK');
	        _this7.salvouOK = true;
	        _this7.$snotify.clear();
	        _this7.$snotify.success('Entidade salva com sucesso!');
	      }).catch(function (error) {
	        _this7.$snotify.clear();
	        _this7.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this8 = this;
	
	      this.entidade.proximaEtapa = 'SALVAR';
	      this.$aguarde('Atualizando dados da entidade. Por favor, aguarde...');
	      this.entidade.users = this.usuarios;
	      axios.post('proxy/account/entities/temp/' + this.entidade).then(function (response) {
	        _this8.$emit('salvou', 'OK');
	        _this8.salvouOK = true;
	        _this8.$snotify.clear();
	        _this8.$snotify.success('Entidade salva com sucesso!');
	      }).catch(function (error) {
	        _this8.$snotify.clear();
	        _this8.$root.trataErro(error);
	      });
	    },
	    limpaObs: function limpaObs() {
	      this.entidade.observacao = '';
	    }
	  }
	};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaValidacaoParcEst',
	  data: function data() {
	    return {
	      quantidadesPrimeiraAprov: '',
	      quantidadesSegundaAprov: '',
	      quantidadesFinalizadas: '',
	      faseAtual: '',
	      descricaoFase: '',
	      filtro: {
	        strategicPartnerName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        strategicPartnerApprovalType: 'FIRST_APPROVAL',
	        userId: null
	      },
	      filtro2: {
	        strategicPartnerName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        strategicPartnerApprovalType: 'SECOND_APPROVAL',
	        userId: null
	      },
	      filtro3: {
	        strategicPartnerName: null,
	        eventStatus: 'DONE',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        strategicPartnerApprovalType: 'SECOND_APPROVAL',
	        approvalResult: 'APPROVED',
	        userId: null
	      },
	      aprovacaoLista: [],
	      aprovacaoTotal: null,
	      loadingShow: false,
	      table: {
	        items: [],
	        totalRows: 0,
	        filter: null,
	        hover: false,
	        bordered: false,
	        currentPage: 1,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        perPage: 10,
	        fields: [{ key: 'favorite', label: '', thStyle: 'text-align: center; width: 3%', class: 'text-center' }, { key: 'companyName', label: '', thStyle: 'text-align: left; width: 60%', class: 'text-left' }, { key: 'userName', label: '', thStyle: 'font-weight: bold' }, { key: 'createdAt', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: '', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      rota1: 'validacao-parceiro'
	    };
	  },
	
	  watch: {
	    'filtro.favorite': function filtroFavorite() {
	      this.onSearch();
	    },
	    'filtro.userId': function filtroUserId() {
	      this.onSearch();
	    },
	    'faseAtual': function faseAtual() {
	      this.filtro.userId = null;
	      this.filtro.favorite = null;
	      this.filtro.eventStatus = 'OPEN';
	      this.onSearch();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {},
	  mounted: function mounted() {
	    this.onSearch();
	  },
	
	  methods: {
	    quantidadePrimeiraFase: function quantidadePrimeiraFase() {
	      var _this = this;
	
	      var filtroQuantidade = {
	        strategicPartnerName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        strategicPartnerApprovalType: 'FIRST_APPROVAL',
	        userId: null
	      };
	
	      axios.post('proxy/account/approval-strategic-partner/search', filtroQuantidade).then(function (response) {
	        _this.quantidadesPrimeiraAprov = response.data.value.total;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    quantidadeSegundaFase: function quantidadeSegundaFase() {
	      var _this2 = this;
	
	      var filtroQuantidade2 = {
	        strategicPartnerName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        strategicPartnerApprovalType: 'SECOND_APPROVAL',
	        userId: null
	      };
	
	      axios.post('proxy/account/approval-strategic-partner/search', filtroQuantidade2).then(function (response) {
	        _this2.quantidadesSegundaAprov = response.data.value.total;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    quantidadeFinalizadas: function quantidadeFinalizadas() {
	      var _this3 = this;
	
	      var filtroQuantidade3 = {
	        strategicPartnerName: null,
	        eventStatus: 'DONE',
	        approvalResult: 'APPROVED',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        strategicPartnerApprovalType: 'SECOND_APPROVAL',
	        userId: null
	      };
	
	      axios.post('proxy/account/approval-strategic-partner/search', filtroQuantidade3).then(function (response) {
	        _this3.quantidadesFinalizadas = response.data.value.total;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    buscaBackEnd: function buscaBackEnd(url) {
	      var _this4 = this;
	
	      axios.post(url, this.filtro).then(function (response) {
	        _this4.carregaTabela(response);
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    carregaTabela: function carregaTabela(response) {
	      this.table.items = response.data.value.list;
	      this.table.totalRows = response.data.value.total;
	      this.loadingShow = false;
	    },
	    onSearch: function onSearch() {
	      this.loadingShow = true;
	      switch (this.faseAtual) {
	        case 'primeira':
	          this.filtro.strategicPartnerApprovalType = 'FIRST_APPROVAL';
	          this.descricaoFase = 'Primeira Aprovação';
	          this.filtro.eventStatus = 'OPEN';
	          this.buscaBackEnd('proxy/account/approval-strategic-partner/search');
	          break;
	        case 'segunda':
	          this.filtro.strategicPartnerApprovalType = 'SECOND_APPROVAL';
	          this.descricaoFase = 'Segunda Aprovação';
	          this.filtro.eventStatus = 'OPEN';
	          this.buscaBackEnd('proxy/account/approval-strategic-partner/search');
	          break;
	        case 'finalizada':
	          this.filtro.strategicPartnerApprovalType = 'SECOND_APPROVAL';
	          this.descricaoFase = 'Finalizadas';
	          this.filtro.eventStatus = 'DONE';
	          this.buscaBackEnd('proxy/account/approval-strategic-partner/search');
	          break;
	        default:
	          this.faseAtual = 'primeira';
	          this.filtro.strategicPartnerApprovalType = 'FIRST_APPROVAL';
	          this.descricaoFase = 'Primeira Aprovação';
	          this.filtro.eventStatus = 'OPEN';
	          this.buscaBackEnd('proxy/account/approval-strategic-partner/search');
	      }
	      this.quantidadePrimeiraFase();
	      this.quantidadeSegundaFase();
	      this.quantidadeFinalizadas();
	    },
	    onFavorite: function onFavorite(item) {
	      var _this5 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-strategic-partner/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-strategic-partner/';
	          break;
	      }
	      axios.put(url + item.id + '/favorite', '').then(function (response) {
	        _this5.onSearch();
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    onAssign: function onAssign(item) {
	      var _this6 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-strategic-partner/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-strategic-partner/';
	          break;
	      }
	      axios.put(url + item.id + '/assign', '').then(function (response) {
	        _this6.onSearch();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    onAssignAndDo: function onAssignAndDo(item) {
	      this.onAssign(item);
	      this.$router.push({ name: this.rota1, params: { id: item.id } });
	    },
	    onUnassign: function onUnassign(item) {
	      var _this7 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-strategic-partner/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-strategic-partner/';
	          break;
	      }
	      axios.put(url + item.id + '/unassign', '').then(function (response) {
	        _this7.onSearch();
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _projetos = __webpack_require__(1732);
	
	var _projetos2 = _interopRequireDefault(_projetos);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoParcEstrategico = __webpack_require__(1710);
	
	var _historicoParcEstrategico2 = _interopRequireDefault(_historicoParcEstrategico);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    projetos: _projetos2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    historicoParcEstrategico: _historicoParcEstrategico2.default,
	    Usuarios: _usuarios2.default
	  },
	  name: 'ValidaParceiro',
	  data: function data() {
	    return {
	      campoErro: null,
	      analise: {
	        approvalResult: '',
	        justify: ''
	      },
	      parceiro: {},
	      contato: [],
	      dirigentes: [],
	      projetos: {},
	      ramoAtividade: [],
	      endereco: {},
	      historico: {},
	      usuarios: {},
	      atividade: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      axios.get('proxy/account/approval-strategic-partner/' + this.$route.params.id).then(function (response) {
	        _this.parceiro = response.data.value;
	        _this.analise = response.data.value;
	        _this.dirigentes = _this.parceiro.strategicPartner.chiefs;
	        _this.contato = _this.parceiro.strategicPartner.contacts;
	        _this.endereco = _this.parceiro.strategicPartner.addresses;
	        _this.projetos = (0, _assign2.default)([], _this.parceiro.strategicPartner.projects);
	        _this.loadEntityActivity();
	        _this.loadEntityUser();
	        _this.loadHistory();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	
	  methods: {
	    isEditable: function isEditable() {
	      return this.$root.authorize('entidade-editar') || this.$root.authorize('minha-entidade-editar');
	    },
	    loadEntityActivity: function loadEntityActivity() {
	      var _this2 = this;
	
	      axios.get('proxy/project/entity-activity/').then(function (response) {
	        _this2.ramoAtividade = response.data.value;
	      });
	    },
	    loadHistory: function loadHistory() {
	      var _this3 = this;
	
	      axios.get('proxy/account/strategicpartners/' + this.parceiro.strategicPartner.id + '/history').then(function (response) {
	        _this3.historico = response.data.value;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    loadEntityUser: function loadEntityUser() {
	      var _this4 = this;
	
	      axios.get('proxy/account/strategicpartners/' + this.parceiro.strategicPartner.id + '/users').then(function (response) {
	        _this4.usuarios = response.data.value;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    salvaUsuarios: function salvaUsuarios() {
	      var _this5 = this;
	
	      axios.post('proxy/account/entities/' + this.parceiro.strategicPartner.id + '/users', this.usuarios).then(function (response) {
	        _this5.users = response.data.value;
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    salva: function salva() {
	      if (this.parceiro.strategicPartner.id) {
	        this.atualiza();
	      } else {
	        this.grava();
	      }
	    },
	    conclui: function conclui() {
	      var _this6 = this;
	
	      var entidadeOK = true;
	      var aba = '';
	      if (_.isEmpty(this.endereco)) {
	        entidadeOK = false;
	        aba = 'Endereço';
	      }
	      if (_.isEmpty(this.dirigentes)) {
	        entidadeOK = false;
	        aba = 'Dirigentes';
	      }
	      if (entidadeOK) {
	        this.$validator.validateAll().then(function (result) {
	          if (result) {
	            _this6.$snotify.clear();
	            _this6.$snotify.info('Atualizando Validação...', { timeout: 0 });
	            if (_this6.$route.params.id) {
	              axios.put('/proxy/account/approval-strategic-partner/' + _this6.$route.params.id, _this6.analise).then(function (response) {
	                _this6.salvaUsuarios();
	                if (_this6.parceiro.strategicPartner.active === false) {
	                  _this6.$snotify.clear();
	                  if (_this6.usuarioLogado.userType === 'FUNDACAO') {
	                    _this6.$snotify.success('Alteração cadastral concluída com sucesso!');
	                  } else {
	                    _this6.$snotify.success('Cadastro da entidade concluído com sucesso! Aguarde e-mail da Fundação Banco do brasil com as informações para dar continuidade ao processo !');
	                  }
	                  setTimeout(function () {
	                    _this6.$router.go(-1);
	                  }, 1000);
	                } else {
	                  _this6.$snotify.clear();
	                  _this6.$snotify.success('Alteração cadastral concluída com sucesso!');
	                  _this6.$router.go(-1);
	                }
	              }).catch(function (error) {
	                _this6.$snotify.clear();
	                _this6.$root.trataErro(error);
	              });
	            }
	          } else {
	            _this6.errors.items.forEach(function (item) {
	              _this6.campoErro = item.field;
	              if (_this6.campoErro === 'cnpjExpeditionTime') {
	                $('input[name="cnpjExpeditionTime"]').focus();
	              } else if (_this6.campoErro === 'CNPJ') {
	                $('input[name="CNPJ"]').focus();
	              } else {
	                _this6.$snotify.error(item.msg, '', _this6.$root._data.error, _this6.$refs[_this6.campoErro].focus());
	              }
	            });
	          }
	        });
	      } else {
	        this.$snotify.error('Erros no preenchimento da aba ' + aba + '. Favor verificar.');
	      }
	    },
	    atualiza: function atualiza() {
	      var _this7 = this;
	
	      this.parceiro.users = this.usuarios;
	      this.parceiro.strategicPartner.chiefs = this.dirigentes;
	      this.parceiro.strategicPartner.contacts = this.contato;
	      this.parceiro.strategicPartner.addresses = this.endereco;
	      this.parceiro.strategicPartner.projects = this.projetos;
	      axios.put('/proxy/account/strategicpartners/' + this.parceiro.strategicPartner.id + '/temp', this.parceiro.strategicPartner).then(function (response) {
	        _this7.salvaUsuarios();
	        _this7.$snotify.success('Parceiro salvo com sucesso!');
	      }).catch(function (error) {
	        _this7.$snotify.clear();
	        _this7.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this8 = this;
	
	      axios.post('proxy/account/strategicpartners/temp/' + this.parceiro.strategicPartner).then(function (response) {
	        _this8.$snotify.success('Parceiro salvo com sucesso!');
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _preAnaliseForm = __webpack_require__(175);
	
	var _preAnaliseForm2 = _interopRequireDefault(_preAnaliseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PreAnaliseForm: _preAnaliseForm2.default,
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    PublicoAlvo: _publicoAlvo2.default },
	  name: 'primeira-aprovacao',
	  data: function data() {
	    return {
	      loadingShow: false,
	      proposta: {
	        entity: {
	          companyName: ''
	        },
	        duplicateProjectDescription: ''
	      },
	      componentKey: 0,
	      preAnalise: {},
	      arvoreProjetos: [],
	      documentosObrigatorios: ['Memória de cálculo', 'Declaração']
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    dataFinal: function dataFinal() {
	      return (0, _moment2.default)(this.proposta.initialDate).add(this.proposta.periods, 'M').format('DD/MM/YYYY');
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      if (this.proposta.objectives) {
	        return this.proposta.objectives.some(function (o) {
	          return o.goals.activities !== null;
	        });
	      }
	    },
	    atividades: function atividades() {
	      var _this = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  created: function created() {
	    this.buscaProposta();
	    this.buscaArvoreProjeto();
	  },
	
	  watch: {
	    'proposta.duplicateProject': function propostaDuplicateProject() {
	      var _this2 = this;
	
	      if (this.arvoreProjetos.length) {
	        var projetoSelecionado = this.arvoreProjetos.find(function (projeto) {
	          return projeto.projectNumber === _this2.proposta.duplicateProject;
	        });
	        this.proposta.duplicateProjectDescription = projetoSelecionado.projectName;
	      }
	    }
	  },
	  methods: {
	    buscaProposta: function buscaProposta() {
	      var _this3 = this;
	
	      this.loadingShow = true;
	      axios.get('proxy/project/approval-pre-analysis/' + this.$route.params.id).then(function (response) {
	        _this3.proposta = response.data.value.proposal;
	        _this3.preAnalise = response.data.value;
	        _this3.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this4 = this;
	
	      axios.get('/proxy/project/project-tree').then(function (response) {
	        _this4.arvoreProjetos = response.data.value;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	var _formalizacao = __webpack_require__(174);
	
	var _formalizacao2 = _interopRequireDefault(_formalizacao);
	
	var _fav = __webpack_require__(84);
	
	var _fav2 = _interopRequireDefault(_fav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Fav: _fav2.default,
	    PreparacaoDocumento: _formalizacao2.default,
	    Analise: _analise2.default,
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    PublicoAlvo: _publicoAlvo2.default },
	  name: 'aceite',
	  data: function data() {
	    return {
	      loadingShow: false,
	      analistas: [],
	      razoes: [],
	      proposta: {
	        entity: {
	          companyName: ''
	        },
	        duplicateProjectDescription: ''
	      },
	      analise: {
	        motivoRejeicao: null,
	        approval: {
	          reasonToReject: null
	        }
	      },
	      aguardaEnviar: 0,
	      arvoreProjetos: [],
	      documentosObrigatorios: ['Memória de cálculo', 'Declaração']
	    };
	  },
	
	  watch: {
	    'analise.motivoRejeicao': function analiseMotivoRejeicao() {
	      this.analise.approval.reasonToReject = this.analise.motivoRejeicao;
	    }
	  },
	  computed: (0, _extends3.default)({
	    dataFinal: function dataFinal() {
	      return (0, _moment2.default)(this.proposta.initialDate).add(this.proposta.periods, 'M').format('DD/MM/YYYY');
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      if (this.proposta.objectives) {
	        return this.proposta.objectives.some(function (o) {
	          return o.goals.activities !== null;
	        });
	      }
	    },
	    atividades: function atividades() {
	      var _this = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  created: function created() {
	    this.buscaAnalise();
	    this.buscaArvoreProjeto();
	    this.buscaRazoes();
	    this.buscaAnalistas();
	  },
	
	  methods: {
	    buscaAnalise: function buscaAnalise() {
	      var _this2 = this;
	
	      this.loadingShow = true;
	      axios.get('proxy/project/approval-acceptance/' + this.$route.params.id).then(function (response) {
	        _this2.proposta = response.data.value.proposal;
	        _this2.analise = response.data.value;
	        _this2.analise.approval = {};
	        _this2.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscaAnalistas: function buscaAnalistas() {
	      var _this3 = this;
	
	      axios.get('proxy/project/approval-acceptance/analyst/list').then(function (response) {
	        _this3.analistas = response.data.value;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaRazoes: function buscaRazoes() {
	      var _this4 = this;
	
	      axios.get('proxy/project/standardized-reason/valid').then(function (response) {
	        _this4.razoes = response.data.value;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    onConclude: function onConclude() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this5.$root.verificaFormulario(_this5);
	
	              case 2:
	                if (!_context.sent) {
	                  _context.next = 5;
	                  break;
	                }
	
	                _this5.$snotify.error('Formulario possui erros favor verificar');
	                return _context.abrupt('return');
	
	              case 5:
	                _this5.$validator.validateAll().then(function (result) {
	                  if (!result) {
	                    _this5.$snotify.error('Formulario possui erros favor verificar');
	                  } else {
	                    _this5.enviaBackEnd();
	                  }
	                });
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this5);
	      }))();
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this6 = this;
	
	      this.aguardaEnviar = 1;
	      this.$aguarde('Validando proposta. Por favor, aguarde...');
	      axios.put('proxy/project//approval-acceptance/' + this.analise.id, this.analise).then(function (response) {
	        _this6.$snotify.clear();
	        _this6.$snotify.success('Validação atualizada com sucesso');
	        setTimeout(function () {
	          _this6.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this6.aguardaEnviar = 0;
	        _this6.$snotify.clear();
	        _this6.$root.trataErro(error);
	      });
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this7 = this;
	
	      axios.get('/proxy/project/project-tree').then(function (response) {
	        _this7.arvoreProjetos = response.data.value;
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(25);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(43);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(76);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _agenciaCondutoraProjeto = __webpack_require__(510);
	
	var _agenciaCondutoraProjeto2 = _interopRequireDefault(_agenciaCondutoraProjeto);
	
	var _relatorioAnalise = __webpack_require__(523);
	
	var _relatorioAnalise2 = _interopRequireDefault(_relatorioAnalise);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _fav = __webpack_require__(84);
	
	var _fav2 = _interopRequireDefault(_fav);
	
	var _questionarioRiscos = __webpack_require__(1737);
	
	var _questionarioRiscos2 = _interopRequireDefault(_questionarioRiscos);
	
	var _fep = __webpack_require__(518);
	
	var _fep2 = _interopRequireDefault(_fep);
	
	var _categorizadores = __webpack_require__(513);
	
	var _categorizadores2 = _interopRequireDefault(_categorizadores);
	
	var _rating = __webpack_require__(1738);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	var _odsMarcacao = __webpack_require__(521);
	
	var _odsMarcacao2 = _interopRequireDefault(_odsMarcacao);
	
	var _licenciamentoAmbientalAnalise = __webpack_require__(1713);
	
	var _licenciamentoAmbientalAnalise2 = _interopRequireDefault(_licenciamentoAmbientalAnalise);
	
	var _questoesAvaliacaoProjeto = __webpack_require__(1691);
	
	var _questoesAvaliacaoProjeto2 = _interopRequireDefault(_questoesAvaliacaoProjeto);
	
	var _checklistIndicadores = __webpack_require__(1693);
	
	var _checklistIndicadores2 = _interopRequireDefault(_checklistIndicadores);
	
	var _checklistAnalise = __webpack_require__(1692);
	
	var _checklistAnalise2 = _interopRequireDefault(_checklistAnalise);
	
	var _parecerJuridicoCampos = __webpack_require__(1722);
	
	var _parecerJuridicoCampos2 = _interopRequireDefault(_parecerJuridicoCampos);
	
	var _quadroRestricoesEntidade = __webpack_require__(1736);
	
	var _quadroRestricoesEntidade2 = _interopRequireDefault(_quadroRestricoesEntidade);
	
	var _checklistAnalise3 = __webpack_require__(269);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DIRECIONADOR_REALIDADES_LOCAIS = 'Conhecer as Realidades Locais';
	
	exports.default = {
	  name: 'analise',
	  components: {
	    Rating: _rating2.default,
	    QuestionarioRiscos: _questionarioRiscos2.default,
	    RelatorioAnalise: _relatorioAnalise2.default,
	    Fav: _fav2.default,
	    Categorizadores: _categorizadores2.default,
	    Fep: _fep2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    AgenciaCondutoraProjeto: _agenciaCondutoraProjeto2.default,
	    odsMarcacao: _odsMarcacao2.default,
	    licenciamentoAmbientalAnalise: _licenciamentoAmbientalAnalise2.default,
	    questoesAvaliacaoProjeto: _questoesAvaliacaoProjeto2.default,
	    ChecklistIndicadores: _checklistIndicadores2.default,
	    ChecklistAnalise: _checklistAnalise2.default,
	    ParecerJuridicoCampos: _parecerJuridicoCampos2.default,
	    QuadroRestricoesEntidade: _quadroRestricoesEntidade2.default
	  },
	  props: ['propsAnalise', 'propsFluxo', 'resultadoAprovacao', 'setPropostaSimplificada', 'restricoesEntidade'],
	  data: function data() {
	    return {
	      placeholderHistoricoProponente: 'Quantos anos de existência tem a proponente?\nCite as principais experiências de atuação na mesma temática do projeto.\nCite demais principais realizações e parcerias da proponente.\nInformar brevemente sobre a capacidade técnica e operacional da estrutura atual da proponente.',
	      placeholderAnalise: 'Construir um breve resumo, a partir das informações constantes na proposta, em que evidencie: o que será feito pela proponente para solucionar cada problema levantado, quais as parcerias serão firmadas para a execução do projeto, qual a importância desse projeto para a comunidade que será impactada, a sustentabilidade das ações do projeto e demais informações relevantes.',
	      numeroFepInformado: null,
	      resultadoVerificacaoFepExistente: '',
	      elementos: {
	        visivel: ''
	      },
	
	      questRiscKey: 0,
	      showModal: false,
	      rating: {},
	      notaRating: '',
	      ratingTemp: {},
	      preenchimentoRelatorio: '',
	      bloqueia: false,
	      reportPeriodicity: [{ id: 'SEMESTRAL', name: 'SEMESTRAL' }, { id: 'QUADRIMESTRAL', name: 'QUADRIMESTRAL' }, { id: 'TRIMESTRAL', name: 'TRIMESTRAL' }, { id: 'BIMESTRAL', name: 'BIMESTRAL' }, { id: 'MENSAL', name: 'MENSAL' }],
	      documentosAnalise: [],
	      approval: {},
	      analise: {
	        questionario_respostas: {},
	        ratingRelatorio: [],
	        documentos: {
	          analise: []
	        }
	      },
	      formalizacaoDcto: [],
	      dctos: [],
	      aguardaEnviar: 0,
	      requiredFormalizationDocumentsType: [],
	      defaultDocumentTypeWorkPlan: null,
	      defaultDocumentTypeDraft: null,
	      documentosObrigatorios: ['Minuta', 'Plano de Trabalho', 'CADIN', 'Certidão Negativa de Débitos Trabalhistas - CNDT'],
	      documentosObrigatoriosSimplificado: ['Minuta', 'Plano de Trabalho', 'CADIN', 'Certidão Negativa de Débitos Trabalhistas - CNDT', 'CND', 'Certidão junto a Controladoria Geral da União (CNEP/CEPIM)', 'Litígio com o BB (Portal Jurídico)'],
	      indicativoAvaliacao: '',
	      exibeQuestionario: '',
	
	      faixasInvestimento: [{ faixa: 1, de: 0, para: 100000, alcada: 'Comitê de Desenvolvimento Social' }, { faixa: 2, de: 100000.01, para: 300000, alcada: 'Comitê de Desenvolvimento Social' }, { faixa: 3, de: 300000.01, para: 1000000000, alcada: 'Comitê Estratégico' }],
	      totalFBB: 0,
	      totalContrapartida: 0,
	      totalParceiro: 0,
	      faixaDoProjeto: 0,
	      ehSimplificada: false,
	
	      direcionadoresEstrategicosOpcoes: ['Conhecer as Realidades Locais', 'Mudanças Climáticas', 'Priorização de Atuação', 'Diversidade em Todas as Esferas'],
	
	      direcionadoresEstrategicosAjuda: {
	        'Mudanças Climáticas': 'Ênfase em temáticas da descarbonização, da economia circular e da transição energética, enfrentamento da emergência climática, incluindo ações de Ajuda Humanitária (Enchentes), na preservação e recuperação dos biomas brasileiros, fortalecimento da resiliência das comunidades frente às mudanças climáticas.',
	        'Conhecer as Realidades Locais': 'Ênfase em comunidades, regiões e territórios onde ainda não atuamos. (Item selecionado de forma automática conforme municípios atendidos pelo projeto)',
	        'Diversidade em Todas as Esferas': 'Compreendemos que a inclusão de grupos sub-representados é fundamental para contribuir em uma mudança mais ampla e significativa da sociedade. Promovemos ativamente a diversidade e oferecemos oportunidades que visam minimizar as desigualdades sociais. (Tema transversal)',
	        'Priorização de Atuação': 'Eixos prioritários de atuação: Ênfase na redução das desigualdades, geração de renda, combate à insegurança alimentar, preservação e recuperação da biodiversidade de biomas, educação para o trabalho, inclusão digital, esporte, cultura, atenção à saúde, saneamento e acesso à água de qualidade.'
	      },
	
	      municipiosNovos: [],
	
	      indicadoresPorProgramaMapa: {},
	
	      planosComunicacao: {},
	
	      povosIndigenasOpcoes: [],
	      povosQuilombolasOpcoes: [],
	      caracteristicasGeograficasOpcoes: ['Rural', 'Urbana', 'Periurbana', 'Região costeira', 'Região ribeirinha'],
	      biomasOpcoes: ['Caatinga', 'Cerrado', 'Mata Atlântica', 'Pantanal', 'Pampa', 'Amazônia'],
	      tematicaProjetoOpcoes: ['Agroecologia', 'Povos Tradicionais', 'Agroindústria', 'Resíduos Sólidos', 'Economia Solidária', 'Transição Energética Justa', 'Empreendedorismo', 'Igualdade Racial', 'Combate à Violência de Gênero', 'Outros']
	    };
	  },
	
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    ehSimplificadaRelatorio: function ehSimplificadaRelatorio() {
	      return (this.totalFBB || 0) + (this.totalParceiro || 0) <= 300000;
	    },
	    possuiMunicipioNovo: function possuiMunicipioNovo() {
	      return this.municipiosNovos.length > 0;
	    },
	    tematicaOutrosSelecionado: function tematicaOutrosSelecionado() {
	      var selecionadas = this.analise && this.analise.dados && this.analise.dados.tematica_projeto || [];
	      return selecionadas.indexOf('Outros') !== -1;
	    },
	    opcoesIndicadores: function opcoesIndicadores() {
	      var programa = this.analise ? this.analise.ds_categ_programa : null;
	      if (programa === null || programa === undefined) {
	        return [];
	      }
	      return this.indicadoresPorProgramaMapa[programa] || [];
	    }
	  }),
	  watch: {
	    documentosAnalise: function documentosAnalise() {
	      if (this.documentosAnalise) {
	        this.analise.documentos.analise = this.documentosAnalise;
	      }
	    },
	    propsAnalise: function propsAnalise() {
	      this.analise = this.propsAnalise;
	      this.moveDados();
	      this.calculaTotaisEFaixaProjeto();
	      this.sincronizaRealidadesLocais();
	    },
	    propsFluxo: function propsFluxo() {
	      this.elementos = this.propsFluxo.elementos;
	    },
	
	    'analise.dt_data_cmj': 'preencheMinutaParecer',
	    'analise.ds_cmj': 'preencheMinutaParecer',
	    'analise.dt_data_parecer_juridico': 'preencheMinutaParecer',
	    'analise.ds_parecer_juridico': 'preencheMinutaParecer'
	  },
	  updated: function updated() {
	    if (this.$refs.questoesAvaliacao && !this.$refs.questoesAvaliacao._isEventListenerAdded) {
	      this.$refs.questoesAvaliacao.$on('indicativo-codigo-updated', this.updateCategAvaliacao);
	      this.$refs.questoesAvaliacao._isEventListenerAdded = true;
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.name === 'proposta-visualiza') {
	      this.bloqueia = true;
	    }
	    if (_.isEmpty(this.$store.state.configuracoes)) {
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this.$store.commit('SET_CONFIGURACOES', response.data);
	        _this.setConfiguracoes(_this.$store.state.configuracoes);
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    } else {
	      this.setConfiguracoes(this.$store.state.configuracoes);
	    }
	
	    if (!this.analise.questionario_respostas || this.analise.questionario_respostas.length === 0) {
	      this.analise.questionario_respostas = {};
	    }
	
	    this.carregaIndicadoresPorPrograma();
	
	    this.carregaPlanosComunicacao();
	
	    this.carregaPovos();
	
	    this.carregaMunicipiosNovos();
	  },
	  mounted: function mounted() {
	    this.recalcula();
	    this.analise = this.propsAnalise;
	    this.moveDados();
	    this.calculaTotaisEFaixaProjeto();
	    this.sincronizaRealidadesLocais();
	  },
	
	  methods: {
	    criaNovaFep: function criaNovaFep(numeroFepInformado) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this2.resultadoVerificacaoFepExistente = 'Verificando número da FEP...';
	                _context.next = 3;
	                return axiosLaravel.get('fep/verifica_numero/' + numeroFepInformado).then(function (response) {
	                  console.log('Verifica FEP - response.data: ', response.data);
	                  if (response.data.fepDisponivel === false) {
	                    _this2.resultadoVerificacaoFepExistente = 'Número FEP já existe para o ano vigente';
	                  } else {
	                    _this2.resultadoVerificacaoFepExistente = 'FEP disponível';
	                    _this2.$dialog.confirm('N\xFAmero de FEP dispon\xEDvel. Deseja gerar a FEP <b> ' + numeroFepInformado + '</b> para a proposta <b>' + _this2.analise.ds_nome + '</b>?', { html: true, animation: 'fade', customClass: 'avisoAlerta' }).then(function (dialog) {
	                      _this2.$aguarde('Criando FEP para a proposta...');
	                      axiosLaravel.post('fep', { 'fk_proposta': _this2.analise.id, 'numero': numeroFepInformado }).then(function (response) {
	                        console.log('post.NovaFep');
	                        console.log(_this2.analise);
	                        console.log('response', response);
	                        _this2.$snotify.clear();
	                        _this2.$snotify.success('FEP gerada com sucesso');
	                        return new _promise2.default(function (resolve) {
	                          return setTimeout(resolve, 1000);
	                        }).then(function () {
	                          _this2.$router.go();
	                        });
	                      }).catch(function (error) {
	                        _this2.$snotify.clear();
	                        _this2.$root.trataErro(error);
	                      });
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    moveDados: function moveDados() {
	      var _this3 = this;
	
	      if (!this.analise.dados || Array.isArray(this.analise.dados)) {
	        this.$set(this.analise, 'dados', {});
	      }
	
	      if (!Array.isArray(this.analise.dados.indicadores_resultado)) {
	        this.$set(this.analise.dados, 'indicadores_resultado', []);
	      }
	      if (!Array.isArray(this.analise.dados.povos_indigenas)) {
	        var legado = Array.isArray(this.analise.dados.povos_tradicionais_indigenas) ? this.analise.dados.povos_tradicionais_indigenas : [];
	        this.$set(this.analise.dados, 'povos_indigenas', [].concat((0, _toConsumableArray3.default)(legado)));
	      }
	      if (!Array.isArray(this.analise.dados.povos_quilombolas)) {
	        this.$set(this.analise.dados, 'povos_quilombolas', []);
	      }
	      if (typeof this.analise.dados.comunicadores_populares !== 'boolean') {
	        this.$set(this.analise.dados, 'comunicadores_populares', false);
	      }
	      if (typeof this.analise.dados.dirigente_indigena_quilombola !== 'boolean') {
	        this.$set(this.analise.dados, 'dirigente_indigena_quilombola', false);
	      }
	
	      if (typeof this.analise.dados.historico_proponente !== 'string') {
	        this.$set(this.analise.dados, 'historico_proponente', '');
	      }
	      if (typeof this.analise.dados.analise_tecnica !== 'string') {
	        this.$set(this.analise.dados, 'analise_tecnica', '');
	      }
	      if (typeof this.analise.dados.analise !== 'string') {
	        this.$set(this.analise.dados, 'analise', '');
	      }
	      if (typeof this.analise.dados.situacao_problema !== 'string') {
	        this.$set(this.analise.dados, 'situacao_problema', '');
	      }
	      if (typeof this.analise.dados.perfil_territorial !== 'string') {
	        this.$set(this.analise.dados, 'perfil_territorial', '');
	      }
	      if (typeof this.analise.dados.objeto_convenio !== 'string') {
	        this.$set(this.analise.dados, 'objeto_convenio', '');
	      }
	      if (!Array.isArray(this.analise.dados.contexto_caracteristicas_geograficas)) {
	        this.$set(this.analise.dados, 'contexto_caracteristicas_geograficas', []);
	      }
	      if (!Array.isArray(this.analise.dados.contexto_biomas)) {
	        this.$set(this.analise.dados, 'contexto_biomas', []);
	      }
	      if (!Array.isArray(this.analise.dados.tematica_projeto)) {
	        this.$set(this.analise.dados, 'tematica_projeto', []);
	      }
	      if (typeof this.analise.dados.tematica_projeto_outros !== 'string') {
	        this.$set(this.analise.dados, 'tematica_projeto_outros', '');
	      }
	      if (!Array.isArray(this.analise.dados.pontos_atencao_mitigadores) || !this.analise.dados.pontos_atencao_mitigadores.length) {
	        this.$set(this.analise.dados, 'pontos_atencao_mitigadores', [{ risco: '', mitigador: '' }]);
	      }
	      if (typeof this.analise.dados.condicionantes !== 'string') {
	        this.$set(this.analise.dados, 'condicionantes', '');
	      }
	      if (!Array.isArray(this.analise.dados.direcionadores_estrategicos)) {
	        this.$set(this.analise.dados, 'direcionadores_estrategicos', []);
	      }
	      if (typeof this.analise.dados.conclusao_analise !== 'string') {
	        this.$set(this.analise.dados, 'conclusao_analise', '');
	      }
	
	      if (this.analise.dados.conclusao_analise === '') {
	        var parecerLegado = this.analise.ds_relatorio_analise_parecer;
	        if (!parecerLegado && this.analise.relatorio_analise) {
	          try {
	            var ra = typeof this.analise.relatorio_analise === 'string' ? JSON.parse(this.analise.relatorio_analise) : this.analise.relatorio_analise;
	            parecerLegado = ra && ra.ds_parecer;
	          } catch (e) {
	            parecerLegado = null;
	          }
	        }
	        if (parecerLegado) {
	          this.$set(this.analise.dados, 'conclusao_analise', parecerLegado);
	        }
	      }
	
	      var respostasLegadas = (0, _checklistAnalise3.respostasLegadasParaImportar)(this.analise);
	      (0, _keys2.default)(respostasLegadas).forEach(function (chave) {
	        _this3.$set(_this3.analise.dados, chave, respostasLegadas[chave]);
	      });
	
	      this.preencheMinutaParecer();
	      if (this.analise.documentos) {
	        if (_.isUndefined(this.analise.documentos.analise) || this.analise.documentos.analise.length <= 0) {
	          var idTiposDocumentosAnalise = [7, 8];
	          var documentosAnalise = _.filter(this.propsAnalise.documentos.proposta, function (doc) {
	            return _.includes(idTiposDocumentosAnalise, doc.fk_tipo_documento);
	          });
	          this.analise.documentos.analise = documentosAnalise;
	        }
	        this.documentosAnalise = this.analise.documentos.analise;
	      }
	      this.$emit('analiseProposta', this.analise);
	
	      if (this.analise.relatorio_analise) {
	        if (!_.isNull(this.analise.relatorio_analise) && !_.isUndefined(this.analise.relatorio_analise)) {
	          this.relatorioAnalise = JSON.parse(this.analise.relatorio_analise);
	        }
	      }
	      var result = 0;
	      if (!_.isNull(this.relatorioAnalise) && !_.isUndefined(this.relatorioAnalise)) {
	        result = (0, _keys2.default)(this.relatorioAnalise).length;
	      }
	      var total = 63;
	      if (_.isEmpty(this.relatorioAnalise)) {
	        this.preenchimentoRelatorio = 'Não Preenchido';
	      }
	      if (result < total) {
	        this.preenchimentoRelatorio = 'Em Preenchimento';
	      }
	      if (result >= total) {
	        this.preenchimentoRelatorio = 'Preenchido';
	      }
	
	      this.approval = this.analise;
	
	      this.$emit('analiseProposta', this.analise);
	      this.$emit('etapa', this.analise.ds_fase);
	      this.$forceUpdate();
	    },
	    setConfiguracoes: function setConfiguracoes(data) {
	      var generalSystemConfig = data;
	      var minuta = data.configuracao_proposta.minuta;
	      var planoTrabalho = data.configuracao_proposta.plano_trabalho;
	      this.dctos.push(minuta, planoTrabalho);
	      if (generalSystemConfig.configuracao_proposta) {
	        this.requiredFormalizationDocumentsType = [];
	
	        if (generalSystemConfig.configuracao_proposta.minuta) {
	          this.requiredFormalizationDocumentsType.push(generalSystemConfig.configuracao_proposta.minuta);
	          this.defaultDocumentTypeDraft = generalSystemConfig.configuracao_proposta.minuta;
	        }
	        if (generalSystemConfig.configuracao_proposta.plano_trabalho) {
	          this.requiredFormalizationDocumentsType.push(generalSystemConfig.configuracao_proposta.plano_trabalho);
	          this.defaultDocumentTypeWorkPlan = generalSystemConfig.configuracao_proposta.plano_trabalho;
	        }
	      }
	    },
	    recalcula: function recalcula() {
	      var rat = {};
	      var bc = new BroadcastChannel('test_channel');
	      var self = this;
	      bc.onmessage = function (ev) {
	        rat = ev.data;
	        this.notaRating = rat.classificacao.nota;
	        self.ratingTemp = rat;
	        self.analise.ratingRelatorio = self.ratingTemp;
	      };
	      this.ratingTemp = self.ratingTemp;
	    },
	    mostrarRef: function mostrarRef(ref) {
	      return _.filter(this.elementos, function (item) {
	        return item.nome === ref;
	      }).some(function (item) {
	        return item.visivel;
	      });
	    },
	    onReturn: function onReturn() {
	      this.$router.go(-1);
	    },
	    carregaArquivos: function carregaArquivos() {
	      this.analise.formalizationDocuments = [];
	      if (this.analise.proposal.documentDraft) {
	        this.analise.formalizationDocuments.push(this.analise.proposal.documentDraft);
	      }
	      if (this.analise.proposal.documentWorkPlan) {
	        this.analise.formalizationDocuments.push(this.analise.proposal.documentWorkPlan);
	      }
	    },
	    Aprova: function Aprova() {
	      var _this4 = this;
	
	      if (!this.verificaDocumentosCarregados()) {
	        this.$snotify.error('Existem documentos pendentes');
	        return;
	      }
	
	      if (!this.$root.validaProposta(this.analise.proposal)) {
	        return;
	      }
	      this.$parent.$validator.validateAll().then(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(validado) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (validado) {
	                    _context2.next = 3;
	                    break;
	                  }
	
	                  _this4.$snotify.error('Formulario de proposta possui erros favor verificar');
	                  return _context2.abrupt('return');
	
	                case 3:
	                  _context2.next = 5;
	                  return _this4.$root.verificaFormulario(_this4);
	
	                case 5:
	                  if (!_context2.sent) {
	                    _context2.next = 8;
	                    break;
	                  }
	
	                  _this4.$snotify.error('Formulario possui erros favor verificar');
	                  return _context2.abrupt('return');
	
	                case 8:
	                  _this4.$validator.validateAll().then(function (validado) {
	                    if (!validado) {
	                      _this4.$snotify.error('Formulario possui erros favor verificar');
	                    } else {}
	                  });
	
	                case 9:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this4);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this5 = this;
	
	      this.aguardaEnviar = 1;
	      this.$aguarde('Validando proposta. Por favor, aguarde...');
	      axios.put('proxy/project/approval-analysis/' + this.approval.id + '/approve', this.approval).then(function (response) {
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Analise atualizada com sucesso');
	        setTimeout(function () {
	          _this5.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this5.aguardaEnviar = 0;
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    },
	    getTiposDocumentoSimplificado: function getTiposDocumentoSimplificado() {
	      var _this6 = this;
	
	      var obj = {
	        lista: this.documentosObrigatoriosSimplificado
	      };
	      axiosLaravel.post('/simplificado/retornarTipoDocumentoSimplificado/', obj).then(function (response) {
	        if (response.data) {
	          _this6.dctos = response.data;
	        }
	        _this6.$snotify.clear();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    validaContaFinanceira: function validaContaFinanceira() {
	      var _this7 = this;
	
	      var ITEM = null;
	      this.analise.proposal.objectives.forEach(function (objetivo) {
	        objetivo.goals.forEach(function (meta) {
	          meta.activities.forEach(function (atividade) {
	            atividade.items.forEach(function (item) {
	              if (!item.financialAccount || item.financialAccount === '') {
	                ITEM = item;
	                _this7.$snotify.warning('Falta conta financeira no item "' + ITEM.itemDescription + '"', { timeout: 10000 });
	              }
	            });
	          });
	        });
	      });
	      return ITEM;
	    },
	    validaMunicipalizacao: function validaMunicipalizacao() {
	      var _this8 = this;
	
	      var CIDADE = null;
	      this.analise.proposal.municipalizationResume.forEach(function (cidade) {
	        if (!cidade.phase || cidade.phase === '') {
	          CIDADE = cidade;
	          _this8.$snotify.warning('A Municipalização da cidade ' + cidade.name + ' é de preenchimento obrigatório!');
	        }
	      });
	      return CIDADE;
	    },
	    verificaDocumentosCarregados: function verificaDocumentosCarregados() {
	      if (!this.analise.formalizationDocuments) {
	        return false;
	      }
	      var documentosCarregados = this.analise.formalizationDocuments.map(function (item) {
	        return item.documentType.type;
	      });
	      return _.isEqual(this.documentosObrigatorios.sort(), documentosCarregados.sort());
	    },
	    limparInfo: function limparInfo() {
	      if (this.analise.resultadoAprovacao === 'ENCAMINHAR_DEFERIMENTO' || this.analise.resultadoAprovacao === 'INCLUIR_SAPIENS') {
	        this.analise.observacao = '';
	      }
	    },
	    moveDocumentosFormalizacao: function moveDocumentosFormalizacao() {
	      var _this9 = this;
	
	      delete this.analise.proposal.documentDraft;
	      delete this.analise.proposal.documentWorkPlan;
	
	      this.analise.formalizationDocuments.forEach(function (documento) {
	        if (documento.documentType.type === 'Minuta') {
	          _this9.analise.proposal.documentDraft = documento;
	        } else {
	          _this9.analise.proposal.documentWorkPlan = documento;
	        }
	      });
	    },
	    updateCategAvaliacao: function updateCategAvaliacao(newVal) {
	      console.log('UPDATE CATEG', newVal);
	      this.indicativoAvaliacao = newVal;
	    },
	    salvarAvaliacao: function salvarAvaliacao() {
	      var salvando = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!this.ehSimplificada && this.$refs.questoesAvaliacao) {
	        return this.$refs.questoesAvaliacao.salvarPontuacao(salvando);
	      }
	    },
	    verificaLicencas: function verificaLicencas() {
	      return this.$refs.licenciamentoAnalise.verificaLicencas();
	    },
	    montaMinutaParecer: function montaMinutaParecer() {
	      var cmj = (this.analise.ds_cmj || '').toString().trim();
	      var dataCmj = (this.analise.dt_data_cmj || '').toString().trim();
	      var parecer = (this.analise.ds_parecer_juridico || '').toString().trim();
	      var dataParecer = (this.analise.dt_data_parecer_juridico || '').toString().trim();
	      if (!cmj && !dataCmj && !parecer && !dataParecer) {
	        return '';
	      }
	      return 'Ser\xE1 utilizada minuta aprovada pela Diretoria Jur\xEDdica - DIJUR do Banco do Brasil S.A., por meio do Parecer Jur\xEDdico n\xBA ' + parecer + ' de ' + dataParecer + '. Data CMJ ' + dataCmj + '. N\xFAmero do CMJ: ' + cmj + '.';
	    },
	    preencheMinutaParecer: function preencheMinutaParecer() {
	      if (!this.analise || !this.analise.dados) {
	        return;
	      }
	      var atual = this.analise.dados.ds_enquadramento_observacoes;
	      if (atual !== null && atual !== undefined && atual !== '') {
	        return;
	      }
	      var minuta = this.montaMinutaParecer();
	      if (minuta) {
	        this.$set(this.analise.dados, 'ds_enquadramento_observacoes', minuta);
	      }
	    },
	    verificaTematicaProjeto: function verificaTematicaProjeto() {
	      var selecionadas = this.analise && this.analise.dados && this.analise.dados.tematica_projeto || [];
	      if (!selecionadas.length) {
	        return false;
	      }
	      if (selecionadas.indexOf('Outros') !== -1 && !(this.analise.dados.tematica_projeto_outros || '').trim()) {
	        return false;
	      }
	      return true;
	    },
	    carregaIndicadoresPorPrograma: function carregaIndicadoresPorPrograma() {
	      var _this10 = this;
	
	      axiosLaravel.get('indicadores-por-programa').then(function (response) {
	        var mapa = response.data;
	        if (typeof mapa === 'string') {
	          mapa = mapa ? JSON.parse(mapa) : {};
	        }
	        _this10.indicadoresPorProgramaMapa = mapa || {};
	      }).catch(function (error) {
	        _this10.$root.trataErro(error);
	      });
	    },
	    carregaPlanosComunicacao: function carregaPlanosComunicacao() {
	      var _this11 = this;
	
	      axiosLaravel.get('planos-comunicacao').then(function (response) {
	        _this11.planosComunicacao = response.data || {};
	
	        _this11.preencheAcoesComunicacao();
	      }).catch(function (error) {
	        _this11.$root.trataErro(error);
	      });
	    },
	    carregaMunicipiosNovos: function carregaMunicipiosNovos() {
	      var _this12 = this;
	
	      var id = this.$route.params.id;
	      if (!id) {
	        return;
	      }
	      axiosLaravel.get('propostas/' + id + '/municipios-novos').then(function (response) {
	        _this12.municipiosNovos = response.data && response.data.municipios_novos || [];
	        _this12.sincronizaRealidadesLocais();
	      }).catch(function () {
	        _this12.municipiosNovos = [];
	      });
	    },
	    ehDirecionadorAutomatico: function ehDirecionadorAutomatico(item) {
	      return item === DIRECIONADOR_REALIDADES_LOCAIS;
	    },
	    textoAjudaDirecionador: function textoAjudaDirecionador(item) {
	      return this.direcionadoresEstrategicosAjuda[item] || '';
	    },
	    sincronizaRealidadesLocais: function sincronizaRealidadesLocais() {
	      if (!this.analise || !this.analise.dados || !Array.isArray(this.analise.dados.direcionadores_estrategicos)) {
	        return;
	      }
	      var marcados = this.analise.dados.direcionadores_estrategicos;
	      for (var i = marcados.length - 1; i >= 0; i--) {
	        if (this.direcionadoresEstrategicosOpcoes.indexOf(marcados[i]) === -1) {
	          marcados.splice(i, 1);
	        }
	      }
	      var posicao = marcados.indexOf(DIRECIONADOR_REALIDADES_LOCAIS);
	      if (this.possuiMunicipioNovo && posicao === -1) {
	        marcados.push(DIRECIONADOR_REALIDADES_LOCAIS);
	      } else if (!this.possuiMunicipioNovo && posicao !== -1) {
	        marcados.splice(posicao, 1);
	      }
	    },
	    carregaPovos: function carregaPovos() {
	      var _this13 = this;
	
	      axiosLaravel.get('povos').then(function (response) {
	        _this13.povosIndigenasOpcoes = response.data && response.data.povos_indigenas || [];
	        _this13.povosQuilombolasOpcoes = response.data && response.data.povos_quilombolas || [];
	      }).catch(function (error) {
	        _this13.$root.trataErro(error);
	      });
	    },
	    adicionaPovo: function adicionaPovo(novoPovo, opcoes, selecionados) {
	      var povo = (novoPovo || '').trim();
	      if (!povo) {
	        return;
	      }
	      if (!opcoes.includes(povo)) {
	        opcoes.push(povo);
	      }
	      if (!selecionados.includes(povo)) {
	        selecionados.push(povo);
	      }
	    },
	    adicionaPovoIndigena: function adicionaPovoIndigena(novoPovo) {
	      this.adicionaPovo(novoPovo, this.povosIndigenasOpcoes, this.analise.dados.povos_indigenas);
	    },
	    adicionaPovoQuilombola: function adicionaPovoQuilombola(novoPovo) {
	      this.adicionaPovo(novoPovo, this.povosQuilombolasOpcoes, this.analise.dados.povos_quilombolas);
	    },
	    preencheAcoesComunicacao: function preencheAcoesComunicacao() {
	      if (!this.analise) {
	        return;
	      }
	      var atual = this.analise.ds_acoes_comunicacao;
	      if (atual !== null && atual !== undefined && atual !== '') {
	        return;
	      }
	      var totalProjeto = (this.totalFBB || 0) + (this.totalParceiro || 0);
	      var chave = void 0;
	      if (totalProjeto <= 300000) {
	        chave = 'plano_comunicacao_1';
	      } else if (totalProjeto <= 1000000) {
	        chave = 'plano_comunicacao_2';
	      } else if (totalProjeto <= 2000000) {
	        chave = 'plano_comunicacao_3';
	      } else {
	        chave = 'plano_comunicacao_4';
	      }
	      var texto = this.planosComunicacao[chave];
	      if (texto) {
	        this.$set(this.analise, 'ds_acoes_comunicacao', texto);
	      }
	    },
	    geraAnaliseTecnica: function geraAnaliseTecnica() {
	      var fmt = function fmt(v) {
	        return 'R$ ' + (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	      };
	      var linhas = (this.analise.atividades || []).map(function (atividade) {
	        var soma = 0;
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            soma += (Number(item.valor_unitario) || 0) * (Number(item.quantidade) || 0);
	          });
	        }
	        return (atividade.ds_nome || 'Atividade') + ' \u2014 ' + fmt(soma);
	      });
	      if (linhas.length) {
	        this.$set(this.analise.dados, 'analise_tecnica', linhas.join('\n'));
	      }
	    },
	    addRiscoMitigador: function addRiscoMitigador() {
	      this.analise.dados.pontos_atencao_mitigadores.push({ risco: '', mitigador: '' });
	    },
	    removeRiscoMitigador: function removeRiscoMitigador(index) {
	      if (this.analise.dados.pontos_atencao_mitigadores.length > 1) {
	        this.analise.dados.pontos_atencao_mitigadores.splice(index, 1);
	      }
	    },
	    calculaTotaisEFaixaProjeto: function calculaTotaisEFaixaProjeto() {
	      var _this14 = this;
	
	      console.log('calculaTotaisEFaixaProjeto');
	      this.totalFBB = 0;
	      this.totalContrapartida = 0;
	      this.totalParceiro = 0;
	      this.analise.atividades.forEach(function (atividade) {
	        if (atividade.itens_orcamentos) {
	          atividade.itens_orcamentos.forEach(function (item) {
	            if ('' + item.origem === '1') {
	              _this14.totalFBB += item.valor_unitario * item.quantidade;
	            }
	            if ('' + item.origem === '2') {
	              _this14.totalContrapartida += item.valor_unitario * item.quantidade;
	            }
	            if ('' + item.origem === '5') {
	              _this14.totalParceiro += item.valor_unitario * item.quantidade;
	            }
	          });
	        }
	      });
	      var totalProjeto = this.totalFBB + this.totalParceiro;
	      console.log('calculaTotaisEFaixaProjeto-total: ', totalProjeto);
	      this.faixaDoProjeto = _.find(this.faixasInvestimento, function (faixa) {
	        return faixa.de <= totalProjeto && totalProjeto <= faixa.para;
	      });
	      console.log('calculaTotaisEFaixaProjeto-faixa: ', this.faixaDoProjeto.faixa);
	      this.ehSimplificada = _.includes([1, 2], this.faixaDoProjeto.faixa);
	      if (this.analise.dados && !this.analise.dados.conclusao_analise) {
	        var fmt = function fmt(v) {
	          return 'R$ ' + (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	        };
	        this.$set(this.analise.dados, 'conclusao_analise', 'Propomos o deferimento de recursos financeiros no valor de ' + fmt(this.totalFBB) + ' conforme registros realizados no Sistema Corporativo da Funda\xE7\xE3o BB, com contrapartida no valor de ' + fmt(this.totalContrapartida) + ' necess\xE1rios para viabilizar a execu\xE7\xE3o das a\xE7\xF5es a serem desenvolvidas');
	      }
	
	      if (this.analise.dados && !this.analise.dados.analise_tecnica) {
	        this.geraAnaliseTecnica();
	      }
	      if (this.ehSimplificada) {
	        this.getTiposDocumentoSimplificado();
	        this.$emit('setPropostaSimplificada', 'C');
	
	        this.analise.ds_periodicidade_formulario = 'QUADRIMESTRAL';
	
	        this.questRiscKey++;
	      }
	
	      this.preencheAcoesComunicacao();
	    }
	  }
	};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Analise: _analise2.default,
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    PublicoAlvo: _publicoAlvo2.default },
	  name: 'analise-geral',
	  data: function data() {
	    return {
	      loadingShow: false,
	      proposta: {
	        entity: {
	          companyName: ''
	        },
	        advancePlots: [],
	        solemnizations: '',
	        duplicateProjectDescription: ''
	      },
	      fields: [{
	        key: 'plot',
	        label: 'Número da Parcela',
	        thStyle: 'width: 40%; text-align: center',
	        sortable: true,
	        'class': 'text-center'
	      }, {
	        key: 'period',
	        label: 'Período',
	        thStyle: 'width: 6%; text-align: center',
	        sortable: true,
	        'class': 'text-center'
	      }, {
	        key: 'value',
	        label: 'Valor Adiantável',
	        thStyle: 'width: 30%; text-align: center',
	        sortable: true,
	        'class': 'word-wrap:break-word text-center'
	      }],
	      table: {
	        currentPage: 1,
	        perPage: 50,
	        totalRows: 0,
	        sortBy: 'id',
	        sortDesc: false,
	        filter: null,
	        bordered: true
	      },
	      analise: {},
	      arvoreProjetos: [],
	      documentosObrigatorios: ['Memória de cálculo', 'Declaração']
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    dataFinal: function dataFinal() {
	      return (0, _moment2.default)(this.proposta.initialDate).add(this.proposta.periods, 'M').format('DD/MM/YYYY');
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      if (this.proposta.objectives) {
	        return this.proposta.objectives.some(function (o) {
	          return o.goals.activities !== null;
	        });
	      }
	    },
	    atualizaCronograma: function atualizaCronograma(objetivos) {
	      this.calculatePlots();
	    },
	    atividades: function atividades() {
	      var _this = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  created: function created() {
	    this.buscaAnalise();
	    this.buscaArvoreProjeto();
	  },
	
	  watch: {
	    'proposta.duplicateProject': function propostaDuplicateProject() {
	      var _this2 = this;
	
	      if (this.arvoreProjetos.length) {
	        var projetoSelecionado = this.arvoreProjetos.find(function (projeto) {
	          return projeto.projectNumber === _this2.proposta.duplicateProject;
	        });
	        this.proposta.duplicateProjectDescription = projetoSelecionado.projectName;
	      }
	    },
	    'atividades': function atividades() {
	      console.log('entrou no watch');
	    }
	  },
	  methods: {
	    buscaAnalise: function buscaAnalise() {
	      var _this3 = this;
	
	      this.loadingShow = true;
	      axios.get('proxy/project/approval-analysis/' + this.$route.params.id).then(function (response) {
	        _this3.proposta = response.data.value.proposal;
	        _this3.analise = response.data.value;
	        _this3.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this4 = this;
	
	      axios.get('/proxy/project/project-tree').then(function (response) {
	        _this4.arvoreProjetos = response.data.value;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    calculatePlots: function calculatePlots() {
	      var items = [];
	      var data = [];
	      for (var i = 0; i < this.atividades.length; i++) {
	        for (var j = 0; j < this.atividades[i].items.length; j++) {
	          if (this.atividades[i].items[j].foreseeable) {
	            items.push(this.atividades[i].items[j]);
	          }
	        }
	      }
	
	      for (var k = 0; k < items.length; k++) {
	        var item = items[k];
	        if (item.resourceSource === 'CONTRAPARTIDA') {
	          this.calcPlotItemValue(data, item.totalValue, item.finalPeriod);
	        } else if (item.type === 'PRODUTO') {
	          this.calcPlotItemValue(data, item.totalValue, item.startPeriod);
	        } else {
	          var parcelas = item.finalPeriod - item.startPeriod + 1;
	
	          var vlrParcelas = item.totalValue / parcelas;
	
	          vlrParcelas *= 100;
	
	          var vlrScale = parseInt(vlrParcelas);
	
	          vlrParcelas = vlrScale / 100;
	
	          var vlrResto = item.totalValue - vlrParcelas * parcelas;
	
	          for (var l = item.startPeriod; l <= item.finalPeriod; l++) {
	            if (l === item.finalPeriod) {
	              vlrParcelas += vlrResto;
	            }
	            this.calcPlotItemValue(data, vlrParcelas, l);
	          }
	        }
	      }
	      data.sort(function (a, b) {
	        return a.period - b.period;
	      });
	      data = data.filter(function (item) {
	        return item;
	      });
	      data = data.map(function (item, index) {
	        item.plot = index + 1;
	        return item;
	      });
	      this.proposta.advancePlots = data;
	      this.$forceUpdate();
	    },
	    calcPlotItemValue: function calcPlotItemValue(data, totalValue, period) {
	      var value = totalValue;
	      if (data[period]) {
	        value += data[period].value;
	      }
	
	      data[period] = {
	        period: period,
	        value: value
	      };
	    }
	  }
	};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fav = __webpack_require__(84);
	
	var _fav2 = _interopRequireDefault(_fav);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'aprovacao',
	  components: {
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    Analise: _analise2.default,
	    Fav: _fav2.default },
	  data: function data() {
	    return {
	      customTokens: {
	        '#': { pattern: /\d/ },
	        'X': { pattern: /[0-9x-xX-X]/, transform: function transform(v) {
	            return v.toUpperCase();
	          } }
	      },
	      requiredFormalizationDocumentsType: [],
	      documentosObrigatorios: ['Minuta', 'Plano de Trabalho'],
	      aprovacaoDocumentos: [],
	      aguardaEnviar: 0,
	      tiposDocumentos: [],
	      dataProposta: null,
	
	      dt_analise: null,
	      confirmou: false,
	      grantDate: null,
	      dt_assinatura_convenio: null,
	      dt_data_vigencia: null,
	      aprovacao: {
	        documentos: {
	          aprovacao: []
	        }
	      },
	      perguntasFAV: [{ 'nivel': 1, 'numero': '1', 'pergunta': 'DEFERIMENTO', 'resposta': null }, { 'nivel': 2, 'numero': '', 'pergunta': 'Pré-Comitê', 'resposta': null }, { 'nivel': 3, 'numero': '1.1', 'pergunta': 'Em projetos de valor igual ou acima de R$ 3,8 milhões foi aplicado, pela COI, previamente à deliberação da instância decisória competente, o Teste de Verificação de Conformidade?', 'resposta': null }, { 'nivel': 2, 'numero': '', 'pergunta': 'Pós-Comitê', 'resposta': null }, { 'nivel': 3, 'numero': '1.2', 'pergunta': 'O despacho contém todas as assinaturas e carimbos dos componentes da instância decisória competente?', 'resposta': null }, { 'nivel': 3, 'numero': '1.3', 'pergunta': 'O despacho está datado?', 'resposta': null }, { 'nivel': 1, 'numero': '2', 'pergunta': 'PRÉ-FORMALIZAÇÃO', 'resposta': null }, { 'nivel': 2, 'numero': '', 'pergunta': 'Procedimentos Gerais', 'resposta': null }, { 'nivel': 3, 'numero': '2.1', 'pergunta': 'Foram cumpridas as condicionantes estabelecidas na análise e no deferimento?', 'resposta': null }, { 'nivel': 3, 'numero': '2.2', 'pergunta': 'Existe consulta ao CADIN - Cadastro Informatizado de Créditos não Quitados do Setor Público Federal, sem registro de ocorrências?', 'resposta': null }, { 'nivel': 3, 'numero': '2.3', 'pergunta': 'Existe consulta ao CEPIM - Cadastro de Entidades Privadas sem fins Lucrativos Impeditivas para a entidade, sem registro de ocorrências?', 'resposta': null }, { 'nivel': 3, 'numero': '2.4', 'pergunta': 'Foi verificado se existe(m) ocorrência(s) impeditiva(s) da entidade proponente e de seu(s) representante(s) legal(is) no sistema informatizado da Fundação? (Relatório 268 Sapiens)', 'resposta': null }, { 'nivel': 3, 'numero': '2.5', 'pergunta': 'Existe Certidão Negativa de Débitos Relativos a Tributos Federais e à Dívida Ativa da União ou Certidão Conjunta Positiva com Efeitos de Negativa?', 'resposta': null }, { 'nivel': 3, 'numero': '2.6', 'pergunta': 'Na minuta de convênio foram foram incluídas as cláusulas específicas do programa estruturado e de adiantamento de recursos, se for o caso?', 'resposta': null }, { 'nivel': 3, 'numero': '2.7', 'pergunta': 'Foi indicada, na minuta de convênio, a periodicidade de apresentação dos relatórios parciais conforme definido no deferimento?', 'resposta': null }, { 'nivel': 3, 'numero': '2.8', 'pergunta': 'Foi indicada, na minuta de convênio, o prazo de execução do projeto conforme definido no deferimento?', 'resposta': null }, { 'nivel': 3, 'numero': '2.9', 'pergunta': 'A minuta de convênio observou as recomendações do parecer jurídico?', 'resposta': null }, { 'nivel': 3, 'numero': '2.10', 'pergunta': 'Os signatários estão qualificados corretamente?', 'resposta': null }, { 'nivel': 3, 'numero': '2.11', 'pergunta': 'Foi encaminhada correspondência à agência condutora, com cópia para a entidade e eventuais intervenientes, contendo documentos e orientações para a formalização?', 'resposta': null }, { 'nivel': 3, 'numero': '2.12', 'pergunta': 'O instrumento jurídico está datado, assinado e rubricado pelas partes em todas as páginas, bem como contém a assinatura e identificação de testemunhas e o número da conta específica do projeto?', 'resposta': null }, { 'nivel': 3, 'numero': '2.13', 'pergunta': 'Foram registrados a data de assinatura, datas de início e fim de execução, número da conta corrente específica e o códido MCI da instituição no sistema informatizado?', 'resposta': null }, { 'nivel': 3, 'numero': '2.14', 'pergunta': 'Foi providenciada a publicação do instrumento jurídico na imprensa oficial?', 'resposta': null }, { 'nivel': 3, 'numero': '2.15', 'pergunta': 'A documentação do projeto está devidamente arquivada, com as páginas numeradas e rubricadas?', 'resposta': null }, { 'nivel': 2, 'numero': '', 'pergunta': 'Em caso de Parcerias Estratégicas', 'resposta': null }, { 'nivel': 3, 'numero': '2.16', 'pergunta': 'Foram realizados os procedimentos para verificação de internalização de recursos de parcerias estratégias, se necessário?', 'resposta': null }, { 'nivel': 3, 'numero': '2.17', 'pergunta': 'Foi verificada a situação de regularidade da entidade em instâncias específicas (FGTS, CNDT, Serasa, SPC, etc), se necessário?', 'resposta': null }],
	
	      respostaFAV: [{ resposta: 'Sim', valor: 1 }, { resposta: 'Não', valor: 0 }, { resposta: 'N/A', valor: 2 }]
	    };
	  },
	
	  props: ['propsAprovacao'],
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  watch: {
	    propsAprovacao: function propsAprovacao() {
	      this.aprovacao = this.propsAprovacao;
	      if (this.propsAprovacao.perguntasFAV) {
	        this.perguntasFAV = this.propsAprovacao.perguntasFAV;
	      }
	      if (this.aprovacao.documentos) {
	        if (this.aprovacao.documentos.aprovacao.length <= 0) {
	          this.aprovacao.documentos.aprovacao = [];
	        } else {
	          this.aprovacaoDocumentos = this.aprovacao.documentos.aprovacao;
	        }
	      }
	
	      this.propsAprovacao.dt_data_vigencia = (0, _moment2.default)(this.propsAprovacao.dt_data_vigencia).format('YYYY-MM-DD');
	      this.$emit('aprovacaoProposta', this.aprovacao);
	      this.$forceUpdate();
	    },
	    aprovacaoDocumentos: function aprovacaoDocumentos() {
	      if (this.aprovacaoDocumentos) {
	        this.aprovacao.documentos.aprovacao = this.aprovacaoDocumentos;
	      }
	    }
	  },
	  computed: {},
	  created: function created() {
	    this.buscaArquivosEsperados();
	  },
	  mounted: function mounted() {
	    if (this.propsAprovacao.perguntasFAV) {
	      this.perguntasFAV = this.propsAprovacao.perguntasFAV;
	    }
	  },
	
	  methods: {
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this = this;
	
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this.tiposDocumentos.push(response.data.configuracao_proposta.minuta);
	        _this.tiposDocumentos.push(response.data.configuracao_proposta.plano_trabalho);
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    verificaDecisao: function verificaDecisao() {
	      var mensagem = '';
	      var ativo = false;
	      if (this.propsAprovacao.resultadoAprovacao === 'VOLTAR_ANALISE') {
	        mensagem = 'Devolver a proposta para ser reanalisada';
	      }
	      if (this.propsAprovacao.resultadoAprovacao === 'CANCELAR_PROJETO') {
	        mensagem = 'Cancelar esse projeto';
	        ativo = true;
	      }
	      this.$emit('validacaoAprovacao', { 'tag': 'aprovacaoProjeto', 'ativo': ativo, 'tipo': 'confirmacao', 'acao': null, 'mensagem': 'Você confirma que deseja <b>' + mensagem + '</b>' });
	    },
	    ajustaDatas: function ajustaDatas() {
	      this.aprovacao.dataProposta = (0, _moment2.default)(this.dataProposta, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
	      this.aprovacao.dt_analise = (0, _moment2.default)(this.dt_analise, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
	      this.aprovacao.grantDate = (0, _moment2.default)(this.grantDate, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
	      this.aprovacao.dt_assinatura_convenio = (0, _moment2.default)(this.dt_assinatura_convenio, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
	      this.aprovacao.dt_data_vigencia = (0, _moment2.default)(this.dt_data_vigencia, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
	      this.aprovacao.dataProposta = (0, _moment2.default)(this.dataProposta, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
	      this.aprovacao.analysisDate = (0, _moment2.default)(this.analysisDate, 'DD/MM/YYYY', true).toISOString();
	      this.aprovacao.grantDate = (0, _moment2.default)(this.grantDate, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
	      this.aprovacao.agreementAssignmentDate = (0, _moment2.default)(this.agreementAssignmentDate, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
	      this.$forceUpdate();
	    },
	    onReturn: function onReturn() {
	      this.$router.go(-1);
	    }
	  }
	};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fav = __webpack_require__(84);
	
	var _fav2 = _interopRequireDefault(_fav);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'aprovacao-projeto',
	  components: {
	    UploadDocumentos: _uploadDocumentos2.default,
	    Fav: _fav2.default
	  },
	  data: function data() {
	    return {
	      requiredFormalizationDocumentsType: [],
	      documentosObrigatorios: ['Minuta', 'Plano de Trabalho'],
	      approval: {},
	      analise: {
	        proposal: {}
	      }
	    };
	  },
	
	  props: ['propsAnalise'],
	  watch: {
	    propsAnalise: function propsAnalise() {
	      this.analise = this.propsAnalise;
	      this.preparaArquivos();
	      this.approval = this.analise;
	      this.$forceUpdate();
	    }
	  },
	  methods: {
	    onConclude: function onConclude() {
	      var _this = this;
	
	      this.$validator.errors.clear();
	
	      if (this.approval.projectFormalizationResult === 'SEND_COVENANT' && (!this.analise.documents || this.analise.documents.length < 1)) {
	        this.$validator.errors.add('envia documentos', 'Campo de documentos é obrigatório para envio dos mesmos');
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (!result) {
	          _this.$snotify.error('Formulario possui erros favor verificar');
	        } else {
	          _this.enviaBackEnd();
	        }
	      });
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this2 = this;
	
	      this.approval.proposal = this.analise.proposal;
	      this.$snotify.info('Atualizando Validação', { timeout: 0 });
	      axios.put('proxy/project/project-formalization/' + this.approval.id, this.approval).then(function (response) {
	        _this2.$snotify.clear();
	        _this2.$snotify.success('Formalização atualizada com sucesso');
	        setTimeout(function () {
	          _this2.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this2.$snotify.clear();
	        _this2.$root.trataErro(error);
	      });
	    },
	    preparaArquivos: function preparaArquivos() {
	      this.analise.documentDraft = [];
	      if (this.analise.proposal.documentDraft) {
	        this.analise.documentDraft.push(this.analise.proposal.documentDraft);
	      }
	      if (this.analise.proposal.documentWorkPlan) {
	        this.analise.documentDraft.push(this.analise.proposal.documentWorkPlan);
	      }
	    }
	  }
	};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fav = __webpack_require__(84);
	
	var _fav2 = _interopRequireDefault(_fav);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'aprovacao',
	  components: {
	    UploadDocumentos: _uploadDocumentos2.default,
	    Fav: _fav2.default },
	  data: function data() {
	    return {
	      requiredFormalizationDocumentsType: [],
	      documentosObrigatorios: ['Minuta', 'Plano de Trabalho'],
	      aprovacao: {},
	      aguardaEnviar: 0,
	      analise: {
	        proposal: []
	      },
	      customTokens: {
	        '#': { pattern: /\d/ },
	        'X': { pattern: /[0-9x-xX-X]/, transform: function transform(v) {
	            return v.toUpperCase();
	          } }
	      }
	    };
	  },
	
	  props: ['propsAprovacao'],
	  watch: {
	    propsAprovacao: function propsAprovacao() {
	      this.aprovacao = this.propsAprovacao;
	      console.log('this', this);
	      this.$emit('aprovacaoProposta', this.aprovacao);
	      this.preparaArquivos();
	      this.$forceUpdate();
	    }
	  },
	  methods: {
	    onSave: function onSave() {
	      var _this = this;
	
	      this.analise.approval.proposal = this.analise.proposal;
	      this.$snotify.info('Atualizando Validação', { timeout: 0 });
	      axios.post('proxy/document-preparation/', this.analise).then(function (response) {
	        console.log(response);
	        _this.$snotify.clear();
	        _this.$snotify.success('Validação salva com sucesso');
	      }).catch(function (error) {
	        _this.$snotify.clear();
	
	        _this.$root.trataErro(error);
	      });
	    },
	    onConclude: function onConclude() {
	      var _this2 = this;
	
	      this.$validator.errors.clear();
	
	      if (this.approval.projectFormalizationResult === 'SEND_COVENANT' && !this.analise.documents[0]) {
	        this.$snotify.error('Necessário anexar os Documentos de Formalização');
	        return;
	      }
	      this.$validator.validateAll().then(function (result) {
	        if (!result) {
	          _this2.$snotify.error('Formulario possui erros favor verificar');
	        } else {
	          _this2.enviaBackEnd();
	        }
	      });
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this3 = this;
	
	      this.approval.proposal = this.analise.proposal;
	      this.aguardaEnviar = 1;
	      this.$aguarde('Validando proposta. Por favor, aguarde...');
	      axios.put('proxy/project/project-formalization/' + this.approval.id, this.approval).then(function (response) {
	        console.log(response);
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Formalização atualizada com sucesso');
	        setTimeout(function () {
	          _this3.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this3.aguardaEnviar = 0;
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    preparaArquivos: function preparaArquivos() {
	      this.analise.documentDraft = [];
	      if (this.analise.proposal.documentDraft) {
	        this.analise.documentDraft.push(this.analise.proposal.documentDraft);
	      }
	      if (this.analise.proposal.documentWorkPlan) {
	        this.analise.documentDraft.push(this.analise.proposal.documentWorkPlan);
	      }
	    }
	  }
	};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fav = __webpack_require__(84);
	
	var _fav2 = _interopRequireDefault(_fav);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _ImpressaoRelModal = __webpack_require__(1779);
	
	var _ImpressaoRelModal2 = _interopRequireDefault(_ImpressaoRelModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'deferimento',
	  components: {
	    ImpressaoRelatorioModal: _ImpressaoRelModal2.default,
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    Fav: _fav2.default },
	  data: function data() {
	    return {
	      requiredFormalizationDocumentsType: [],
	      documentosObrigatorios: ['Minuta', 'Plano de Trabalho'],
	      approval: {},
	      aguardaEnviar: 0,
	      deferimentoDocumentos: [],
	      deferimento: {
	        questionario_respostas: {},
	        documentos: {
	          deferimento: []
	        }
	      }
	    };
	  },
	
	  props: ['propsDeferimento'],
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  watch: {
	    propsDeferimento: function propsDeferimento() {
	      this.deferimento = this.propsDeferimento;
	      if (this.deferimento.documentos) {
	        if (!_.isUndefined(this.deferimento.documentos.deferimento)) {
	          if (this.deferimento.documentos.deferimento.length <= 0) {
	            this.deferimento.documentos.deferimento = [];
	          } else {
	            this.deferimentoDocumentos = this.deferimento.documentos.deferimento;
	          }
	        }
	      }
	      this.$emit('deferimentoProposta', this.propsDeferimento);
	
	      this.$forceUpdate();
	    },
	    deferimentoDocumentos: function deferimentoDocumentos() {
	      if (this.deferimentoDocumentos) {
	        this.deferimento.documentos.deferimento = this.deferimentoDocumentos;
	      }
	      this.$emit('deferimentoProposta', this.deferimento);
	    }
	  },
	  methods: {
	    enviaBackEnd: function enviaBackEnd() {
	      var _this = this;
	
	      this.approval.proposal = this.analise.proposal;
	      this.aguardaEnviar = 1;
	      this.$aguarde('Validando proposta. Por favor, aguarde...');
	      axios.put('proxy/project/approval-grant/' + this.approval.id, this.approval).then(function (response) {
	        console.log(response);
	        _this.$snotify.clear();
	        _this.$snotify.success('Deferimento atualizado com sucesso');
	        setTimeout(function () {
	          _this.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this.aguardaEnviar = 0;
	        _this.$snotify.clear();
	        _this.$root.trataErro(error);
	      });
	    },
	    preparaArquivos: function preparaArquivos() {
	      this.analise.documentDraft = [];
	      if (this.analise.proposal.documentDraft) {
	        this.analise.documentDraft.push(this.analise.proposal.documentDraft);
	      }
	      if (this.analise.proposal.documentWorkPlan) {
	        this.analise.documentDraft.push(this.analise.proposal.documentWorkPlan);
	      }
	    },
	    openSgpReport: function openSgpReport() {
	      this.$modal.show('relatorio-sgp');
	    },
	    openErpReport: function openErpReport() {}
	  }
	};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _fav = __webpack_require__(84);
	
	var _fav2 = _interopRequireDefault(_fav);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _brBankAccountValidator = __webpack_require__(125);
	
	var _brBankAccountValidator2 = _interopRequireDefault(_brBankAccountValidator);
	
	var _geraMinuta = __webpack_require__(595);
	
	var _geraMinuta2 = _interopRequireDefault(_geraMinuta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formalizacao',
	  components: {
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    Fav: _fav2.default },
	  data: function data() {
	    return {
	      customTokens: {
	        '#': { pattern: /\d/ },
	        'X': { pattern: /[0-9x-xX-X]/, transform: function transform(v) {
	            return v.toUpperCase();
	          } }
	      },
	      minutaSimplificada: false,
	      minutaAdicional: '',
	      tipoMinutaEcoforte: '',
	      requiredFormalizationDocumentsType: [],
	      documentosObrigatorios: ['Minuta', 'Plano de Trabalho'],
	      formalizacaoDocumentos: [],
	      aguardaEnviar: 0,
	      tiposDocumentos: [],
	      dataProposta: null,
	      dt_analise: null,
	      grantDate: null,
	      dt_assinatura_convenio: null,
	      dt_data_vigencia: null,
	
	      editaisComMinuta: [9, 10, 12],
	      perguntasFAV: [{ 'nivel': 1, 'numero': '1', 'pergunta': 'DEFERIMENTO', 'resposta': null }, { 'nivel': 2, 'numero': '', 'pergunta': 'Pré-Comitê', 'resposta': null }, { 'nivel': 3, 'numero': '1.1', 'pergunta': 'Em projetos de valor igual ou acima de R$ 3,8 milhões foi aplicado, pela COI, previamente à deliberação da instância decisória competente, o Teste de Verificação de Conformidade?', 'resposta': null }, { 'nivel': 2, 'numero': '', 'pergunta': 'Pós-Comitê', 'resposta': null }, { 'nivel': 3, 'numero': '1.2', 'pergunta': 'O despacho contém todas as assinaturas e carimbos dos componentes da instância decisória competente?', 'resposta': null }, { 'nivel': 3, 'numero': '1.3', 'pergunta': 'O despacho está datado?', 'resposta': null }, { 'nivel': 1, 'numero': '2', 'pergunta': 'PRÉ-FORMALIZAÇÃO', 'resposta': null }, { 'nivel': 2, 'numero': '', 'pergunta': 'Procedimentos Gerais', 'resposta': null }, { 'nivel': 3, 'numero': '2.1', 'pergunta': 'Foram cumpridas as condicionantes estabelecidas na análise e no deferimento?', 'resposta': null }, { 'nivel': 3, 'numero': '2.2', 'pergunta': 'Existe consulta ao CADIN - Cadastro Informatizado de Créditos não Quitados do Setor Público Federal, sem registro de ocorrências?', 'resposta': null }, { 'nivel': 3, 'numero': '2.3', 'pergunta': 'Existe consulta ao CEPIM - Cadastro de Entidades Privadas sem fins Lucrativos Impeditivas para a entidade, sem registro de ocorrências?', 'resposta': null }, { 'nivel': 3, 'numero': '2.4', 'pergunta': 'Foi verificado se existe(m) ocorrência(s) impeditiva(s) da entidade proponente e de seu(s) representante(s) legal(is) no sistema informatizado da Fundação? (Relatório 268 Sapiens)', 'resposta': null }, { 'nivel': 3, 'numero': '2.5', 'pergunta': 'Existe Certidão Negativa de Débitos Relativos a Tributos Federais e à Dívida Ativa da União ou Certidão Conjunta Positiva com Efeitos de Negativa?', 'resposta': null }, { 'nivel': 3, 'numero': '2.6', 'pergunta': 'Na minuta de convênio foram foram incluídas as cláusulas específicas do programa estruturado e de adiantamento de recursos, se for o caso?', 'resposta': null }, { 'nivel': 3, 'numero': '2.7', 'pergunta': 'Foi indicada, na minuta de convênio, a periodicidade de apresentação dos relatórios parciais conforme definido no deferimento?', 'resposta': null }, { 'nivel': 3, 'numero': '2.8', 'pergunta': 'Foi indicada, na minuta de convênio, o prazo de execução do projeto conforme definido no deferimento?', 'resposta': null }, { 'nivel': 3, 'numero': '2.9', 'pergunta': 'A minuta de convênio observou as recomendações do parecer jurídico?', 'resposta': null }, { 'nivel': 3, 'numero': '2.10', 'pergunta': 'Os signatários estão qualificados corretamente?', 'resposta': null }, { 'nivel': 3, 'numero': '2.11', 'pergunta': 'Foi encaminhada correspondência à agência condutora, com cópia para a entidade e eventuais intervenientes, contendo documentos e orientações para a formalização?', 'resposta': null }, { 'nivel': 3, 'numero': '2.12', 'pergunta': 'O instrumento jurídico está datado, assinado e rubricado pelas partes em todas as páginas, bem como contém a assinatura e identificação de testemunhas e o número da conta específica do projeto?', 'resposta': null }, { 'nivel': 3, 'numero': '2.13', 'pergunta': 'Foram registrados a data de assinatura, datas de início e fim de execução, número da conta corrente específica e o códido MCI da instituição no sistema informatizado?', 'resposta': null }, { 'nivel': 3, 'numero': '2.14', 'pergunta': 'Foi providenciada a publicação do instrumento jurídico na imprensa oficial?', 'resposta': null }, { 'nivel': 3, 'numero': '2.15', 'pergunta': 'A documentação do projeto está devidamente arquivada, com as páginas numeradas e rubricadas?', 'resposta': null }, { 'nivel': 2, 'numero': '', 'pergunta': 'Em caso de Parcerias Estratégicas', 'resposta': null }, { 'nivel': 3, 'numero': '2.16', 'pergunta': 'Foram realizados os procedimentos para verificação de internalização de recursos de parcerias estratégias, se necessário?', 'resposta': null }, { 'nivel': 3, 'numero': '2.17', 'pergunta': 'Foi verificada a situação de regularidade da entidade em instâncias específicas (FGTS, CNDT, Serasa, SPC, etc), se necessário?', 'resposta': null }],
	
	      respostaFAV: [{ resposta: 'Sim', valor: 1 }, { resposta: 'Não', valor: 0 }, { resposta: 'N/A', valor: 2 }],
	      formalizacao: {
	        documentos: {
	          formalizacao: []
	        }
	      },
	      listaBancos: [{ 'codigo': '001', 'nome': 'Banco do Brasil S.A.', 'caracteresConta': 8 }, { 'codigo': '033', 'nome': 'Banco Santander (Brasil) S.A.', 'caracteresConta': 8, 'digitoAgencia': false }, { 'codigo': '070', 'nome': 'BRB - Banco de Brasília S.A.' }, { 'codigo': '104', 'nome': 'Caixa Econômica Federal', 'digitoAgencia': false }, { 'codigo': '237', 'nome': 'Banco Bradesco S.A.', 'caracteresConta': 7 }, { 'codigo': '341', 'nome': 'Itaú Unibanco S.A.', 'caracteresConta': 5, 'digitoAgencia': false }, { 'codigo': '', 'nome': '', $isDisabled: true }, { 'codigo': '003', 'nome': 'BANCO DA AMAZONIA S.A.' }, { 'codigo': '004', 'nome': 'Banco do Nordeste do Brasil S.A.' }, { 'codigo': '007', 'nome': 'BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL' }, { 'codigo': '010', 'nome': 'CREDICOAMO CREDITO RURAL COOPERATIVA' }, { 'codigo': '011', 'nome': 'CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A' }, { 'codigo': '012', 'nome': 'Banco Inbursa S.A.' }, { 'codigo': '014', 'nome': 'STATE STREET BRASIL S.A. ? BANCO COMERCIAL' }, { 'codigo': '015', 'nome': 'UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { 'codigo': '016', 'nome': 'COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI' }, { 'codigo': '017', 'nome': 'BNY Mellon Banco S.A.' }, { 'codigo': '018', 'nome': 'Banco Tricury S.A.' }, { 'codigo': '021', 'nome': 'BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO' }, { 'codigo': '024', 'nome': 'Banco Bandepe S.A.' }, { 'codigo': '025', 'nome': 'Banco Alfa S.A.' }, { 'codigo': '029', 'nome': 'Banco Itaú Consignado S.A.' }, { 'codigo': '036', 'nome': 'Banco Bradesco BBI S.A.' }, { 'codigo': '037', 'nome': 'Banco do Estado do Pará S.A.' }, { 'codigo': '040', 'nome': 'Banco Cargill S.A.' }, { 'codigo': '041', 'nome': 'Banco do Estado do Rio Grande do Sul S.A.', 'caracteresConta': 9 }, { 'codigo': '047', 'nome': 'Banco do Estado de Sergipe S.A.' }, { 'codigo': '060', 'nome': 'Confidence Corretora de Câmbio S.A.' }, { 'codigo': '062', 'nome': 'Hipercard Banco Múltiplo S.A.' }, { 'codigo': '063', 'nome': 'Banco Bradescard S.A.' }, { 'codigo': '064', 'nome': 'GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.' }, { 'codigo': '065', 'nome': 'Banco AndBank (Brasil) S.A.' }, { 'codigo': '066', 'nome': 'BANCO MORGAN STANLEY S.A.' }, { 'codigo': '069', 'nome': 'Banco Crefisa S.A.' }, { 'codigo': '074', 'nome': 'Banco J. Safra S.A.' }, { 'codigo': '075', 'nome': 'Banco ABN Amro S.A.' }, { 'codigo': '076', 'nome': 'Banco KDB do Brasil S.A.' }, { 'codigo': '077', 'nome': 'Banco Inter S.A.' }, { 'codigo': '078', 'nome': 'Haitong Banco de Investimento do Brasil S.A.' }, { 'codigo': '079', 'nome': 'Banco Original do Agronegócio S.A.' }, { 'codigo': '080', 'nome': 'B&T CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '081', 'nome': 'BancoSeguro S.A.' }, { 'codigo': '082', 'nome': 'BANCO TOPÁZIO S.A.' }, { 'codigo': '083', 'nome': 'Banco da China Brasil S.A.' }, { 'codigo': '084', 'nome': 'UNIPRIME NORTE DO PARANÁ – COOPERATIVA DE CRÉDITO LTDA' }, { 'codigo': '085', 'nome': 'Cooperativa Central de Crédito – Ailos' }, { 'codigo': '088', 'nome': 'BANCO RANDON S.A.' }, { 'codigo': '089', 'nome': 'CREDISAN COOPERATIVA DE CRÉDITO' }, { 'codigo': '091', 'nome': 'CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S' }, { 'codigo': '092', 'nome': 'BRK S.A. Crédito, Financiamento e Investimento' }, { 'codigo': '093', 'nome': 'PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT' }, { 'codigo': '094', 'nome': 'Banco Finaxis S.A.' }, { 'codigo': '095', 'nome': 'Travelex Banco de Câmbio S.A.' }, { 'codigo': '096', 'nome': 'Banco B3 S.A.' }, { 'codigo': '097', 'nome': 'Credisis – Central de Cooperativas de Crédito Ltda.' }, { 'codigo': '098', 'nome': 'Credialiança Cooperativa de Crédito Rural' }, { 'codigo': '099', 'nome': 'UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.' }, { 'codigo': '100', 'nome': 'Planner Corretora de Valores S.A.' }, { 'codigo': '101', 'nome': 'RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '102', 'nome': 'XP INVESTIMENTOS CORRETORA DE CÂMBIO,TÍTULOS E VALORES MOBILIÁRIOS S/A' }, { 'codigo': '105', 'nome': 'Lecca Crédito, Financiamento e Investimento S/A' }, { 'codigo': '107', 'nome': 'Banco Bocom BBM S.A.' }, { 'codigo': '108', 'nome': 'PORTOCRED S.A. – CREDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '111', 'nome': 'OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.' }, { 'codigo': '113', 'nome': 'Magliano S.A. Corretora de Cambio e Valores Mobiliarios' }, { 'codigo': '114', 'nome': 'Central Cooperativa de Crédito no Estado do Espírito Santo – CECOOP' }, { 'codigo': '117', 'nome': 'ADVANCED CORRETORA DE CÂMBIO LTDA' }, { 'codigo': '119', 'nome': 'Banco Western Union do Brasil S.A.' }, { 'codigo': '120', 'nome': 'BANCO RODOBENS S.A.' }, { 'codigo': '121', 'nome': 'Banco Agibank S.A.' }, { 'codigo': '122', 'nome': 'Banco Bradesco BERJ S.A.' }, { 'codigo': '124', 'nome': 'Banco Woori Bank do Brasil S.A.' }, { 'codigo': '125', 'nome': 'Plural S.A. Banco Múltiplo' }, { 'codigo': '126', 'nome': 'BR Partners Banco de Investimento S.A.' }, { 'codigo': '127', 'nome': 'Codepe Corretora de Valores e Câmbio S.A.' }, { 'codigo': '128', 'nome': 'MS Bank S.A. Banco de Câmbio' }, { 'codigo': '129', 'nome': 'UBS Brasil Banco de Investimento S.A.' }, { 'codigo': '130', 'nome': 'CARUANA S.A. – SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '131', 'nome': 'TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA' }, { 'codigo': '132', 'nome': 'ICBC do Brasil Banco Múltiplo S.A.' }, { 'codigo': '133', 'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E' }, { 'codigo': '134', 'nome': 'BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '136', 'nome': 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. – UNICRED DO BRASI' }, { 'codigo': '138', 'nome': 'Get Money Corretora de Câmbio S.A.' }, { 'codigo': '139', 'nome': 'Intesa Sanpaolo Brasil S.A. – Banco Múltiplo' }, { 'codigo': '140', 'nome': 'Easynvest – Título Corretora de Valores SA' }, { 'codigo': '142', 'nome': 'Broker Brasil Corretora de Câmbio Ltda.' }, { 'codigo': '143', 'nome': 'Treviso Corretora de Câmbio S.A.' }, { 'codigo': '144', 'nome': 'BEXS BANCO DE CÂMBIO S/A' }, { 'codigo': '145', 'nome': 'LEVYCAM – CORRETORA DE CAMBIO E VALORES LTDA.' }, { 'codigo': '146', 'nome': 'GUITTA CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '149', 'nome': 'Facta Financeira S.A. – Crédito Financiamento e Investimento' }, { 'codigo': '157', 'nome': 'ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '159', 'nome': 'Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor' }, { 'codigo': '163', 'nome': 'Commerzbank Brasil S.A. – Banco Múltiplo' }, { 'codigo': '169', 'nome': 'BANCO OLÉ CONSIGNADO S.A.' }, { 'codigo': '173', 'nome': 'BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '174', 'nome': 'PEFISA S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '177', 'nome': 'Guide Investimentos S.A. Corretora de Valores' }, { 'codigo': '180', 'nome': 'CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '183', 'nome': 'SOCRED S.A. – SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P' }, { 'codigo': '184', 'nome': 'Banco Itaú BBA S.A.' }, { 'codigo': '188', 'nome': 'ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS, CÂMBIO E VALORES' }, { 'codigo': '189', 'nome': 'HS FINANCEIRA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' }, { 'codigo': '190', 'nome': 'SERVICOOP – COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN' }, { 'codigo': '191', 'nome': 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '194', 'nome': 'PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '196', 'nome': 'FAIR CORRETORA DE CAMBIO S.A.' }, { 'codigo': '197', 'nome': 'Stone Pagamentos S.A.' }, { 'codigo': '208', 'nome': 'Banco BTG Pactual S.A.' }, { 'codigo': '212', 'nome': 'Banco Original S.A.' }, { 'codigo': '213', 'nome': 'Banco Arbi S.A.' }, { 'codigo': '217', 'nome': 'Banco John Deere S.A.' }, { 'codigo': '218', 'nome': 'Banco BS2 S.A.' }, { 'codigo': '222', 'nome': 'BANCO CRÉDIT AGRICOLE BRASIL S.A.' }, { 'codigo': '224', 'nome': 'Banco Fibra S.A.' }, { 'codigo': '233', 'nome': 'Banco Cifra S.A.' }, { 'codigo': '241', 'nome': 'BANCO CLASSICO S.A.' }, { 'codigo': '243', 'nome': 'Banco Máxima S.A.' }, { 'codigo': '246', 'nome': 'Banco ABC Brasil S.A.' }, { 'codigo': '249', 'nome': 'Banco Investcred Unibanco S.A.' }, { 'codigo': '250', 'nome': 'BCV – BANCO DE CRÉDITO E VAREJO S.A.' }, { 'codigo': '253', 'nome': 'Bexs Corretora de Câmbio S/A' }, { 'codigo': '254', 'nome': 'PARANÁ BANCO S.A.' }, { 'codigo': '259', 'nome': 'MONEYCORP BANCO DE CÂMBIO S.A.' }, { 'codigo': '260', 'nome': 'Nu Pagamentos S.A.' }, { 'codigo': '265', 'nome': 'Banco Fator S.A.' }, { 'codigo': '266', 'nome': 'BANCO CEDULA S.A.' }, { 'codigo': '268', 'nome': 'BARI COMPANHIA HIPOTECÁRIA' }, { 'codigo': '269', 'nome': 'BANCO HSBC S.A.' }, { 'codigo': '270', 'nome': 'Sagitur Corretora de Câmbio Ltda.' }, { 'codigo': '271', 'nome': 'IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.' }, { 'codigo': '272', 'nome': 'AGK CORRETORA DE CAMBIO S.A.' }, { 'codigo': '273', 'nome': 'Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel' }, { 'codigo': '274', 'nome': 'MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT' }, { 'codigo': '276', 'nome': 'Senff S.A. – Crédito, Financiamento e Investimento' }, { 'codigo': '278', 'nome': 'Genial Investimentos Corretora de Valores Mobiliários S.A.' }, { 'codigo': '279', 'nome': 'COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' }, { 'codigo': '280', 'nome': 'Avista S.A. Crédito, Financiamento e Investimento' }, { 'codigo': '281', 'nome': 'Cooperativa de Crédito Rural Coopavel' }, { 'codigo': '283', 'nome': 'RB CAPITAL INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LIMITADA' }, { 'codigo': '285', 'nome': 'Frente Corretora de Câmbio Ltda.' }, { 'codigo': '286', 'nome': 'COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO' }, { 'codigo': '288', 'nome': 'CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '289', 'nome': 'DECYSEO CORRETORA DE CAMBIO LTDA.' }, { 'codigo': '290', 'nome': 'Pagseguro Internet S.A.' }, { 'codigo': '292', 'nome': 'BS2 Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '293', 'nome': 'Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '296', 'nome': 'VISION S.A. CORRETORA DE CAMBIO' }, { 'codigo': '298', 'nome': 'Vip’s Corretora de Câmbio Ltda.' }, { 'codigo': '299', 'nome': 'SOROCRED   CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '300', 'nome': 'Banco de la Nacion Argentina' }, { 'codigo': '301', 'nome': 'BPP Instituição de Pagamento S.A.' }, { 'codigo': '306', 'nome': 'PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '307', 'nome': 'Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.' }, { 'codigo': '309', 'nome': 'CAMBIONET CORRETORA DE CÂMBIO LTDA.' }, { 'codigo': '310', 'nome': 'VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.' }, { 'codigo': '311', 'nome': 'DOURADA CORRETORA' }, { 'codigo': '312', 'nome': 'HSCM SCMEPP LTDA.' }, { 'codigo': '313', 'nome': 'AMAZÔNIA CORRETORA DE CÂMBIO LTDA.' }, { 'codigo': '315', 'nome': 'PI Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '318', 'nome': 'Banco BMG S.A.' }, { 'codigo': '319', 'nome': 'OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '320', 'nome': 'China Construction Bank (Brasil) Banco Múltiplo S/A' }, { 'codigo': '321', 'nome': 'CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT' }, { 'codigo': '322', 'nome': 'Cooperativa de Crédito Rural de Abelardo Luz – Sulcredi/Crediluz' }, { 'codigo': '323', 'nome': 'MERCADOPAGO.COM REPRESENTACOES LTDA.' }, { 'codigo': '324', 'nome': 'CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '325', 'nome': 'Órama Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '326', 'nome': 'PARATI – CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '329', 'nome': 'QI Sociedade de Crédito Direto S.A.' }, { 'codigo': '330', 'nome': 'BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.' }, { 'codigo': '331', 'nome': 'Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.' }, { 'codigo': '332', 'nome': 'Acesso Soluções de Pagamento S.A.' }, { 'codigo': '335', 'nome': 'Banco Digio S.A.' }, { 'codigo': '336', 'nome': 'Banco C6 S.A.' }, { 'codigo': '340', 'nome': 'Super Pagamentos e Administração de Meios Eletrônicos S.A.' }, { 'codigo': '342', 'nome': 'Creditas Sociedade de Crédito Direto S.A.' }, { 'codigo': '343', 'nome': 'FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.' }, { 'codigo': '348', 'nome': 'Banco XP S.A.' }, { 'codigo': '349', 'nome': 'AL5 S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO' }, { 'codigo': '350', 'nome': 'COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE' }, { 'codigo': '352', 'nome': 'TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA' }, { 'codigo': '354', 'nome': 'NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES' }, { 'codigo': '355', 'nome': 'ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '358', 'nome': 'MIDWAY S.A. - SCFI' }, { 'codigo': '359', 'nome': 'ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A' }, { 'codigo': '360', 'nome': 'TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { 'codigo': '362', 'nome': 'CIELO S.A.' }, { 'codigo': '363', 'nome': 'SOCOPA SOCIEDADE CORRETORA PAULISTA S.A.' }, { 'codigo': '364', 'nome': 'GERENCIANET S.A.' }, { 'codigo': '365', 'nome': 'SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS' }, { 'codigo': '366', 'nome': 'BANCO SOCIETE GENERALE BRASIL S.A.' }, { 'codigo': '367', 'nome': 'VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.' }, { 'codigo': '368', 'nome': 'Banco CSF S.A.' }, { 'codigo': '370', 'nome': 'Banco Mizuho do Brasil S.A.' }, { 'codigo': '371', 'nome': 'WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.' }, { 'codigo': '373', 'nome': 'UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.' }, { 'codigo': '374', 'nome': 'REALIZE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { 'codigo': '376', 'nome': 'BANCO J.P. MORGAN S.A.' }, { 'codigo': '377', 'nome': 'MS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA' }, { 'codigo': '378', 'nome': 'BBC LEASING S.A. – ARRENDAMENTO MERCANTIL' }, { 'codigo': '379', 'nome': 'COOPERFORTE – COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS FUNCIONÁRIOS DE INSTIT' }, { 'codigo': '380', 'nome': 'PICPAY SERVICOS S.A.' }, { 'codigo': '381', 'nome': 'BANCO MERCEDES-BENZ DO BRASIL S.A.' }, { 'codigo': '382', 'nome': 'FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L' }, { 'codigo': '383', 'nome': 'BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.' }, { 'codigo': '384', 'nome': 'GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO' }, { 'codigo': '386', 'nome': 'NU FINANCEIRA S.A. CFI' }, { 'codigo': '387', 'nome': 'Banco Toyota do Brasil S.A.' }, { 'codigo': '389', 'nome': 'Banco Mercantil do Brasil S.A.' }, { 'codigo': '390', 'nome': 'BANCO GM S.A.' }, { 'codigo': '391', 'nome': 'COOPERATIVA DE CREDITO RURAL DE IBIAM – SULCREDI/IBIAM' }, { 'codigo': '393', 'nome': 'Banco Volkswagen S.A.' }, { 'codigo': '394', 'nome': 'Banco Bradesco Financiamentos S.A.' }, { 'codigo': '395', 'nome': 'F D GOLD DTVM LTDA' }, { 'codigo': '396', 'nome': 'HUB PAGAMENTOS S.A' }, { 'codigo': '397', 'nome': 'LISTO SOCIEDADE DE CREDITO DIRETO S.A.' }, { 'codigo': '398', 'nome': 'IDEAL CTVM S.A.' }, { 'codigo': '399', 'nome': 'Kirton Bank S.A. – Banco Múltiplo' }, { 'codigo': '400', 'nome': 'CC POUP SER FIN CO' }, { 'codigo': '402', 'nome': 'COBUCCIO SCD S.A.' }, { 'codigo': '403', 'nome': 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '404', 'nome': 'SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '406', 'nome': 'ACCREDITO SCD S.A.' }, { 'codigo': '407', 'nome': 'ÍNDIGO INVESTIMENTOS DTVM LTDA.' }, { 'codigo': '408', 'nome': 'BÔNUSCRED SOCIEDADE DE CRÉDITO DIRETO S.A.' }, { 'codigo': '410', 'nome': 'PLANNER SCM S.A.' }, { 'codigo': '411', 'nome': 'VIA CERTA FINANCIADORA S.A. - CFI' }, { 'codigo': '412', 'nome': 'BANCO CAPITAL S.A.' }, { 'codigo': '419', 'nome': 'NUMBRS SCD S.A.' }, { 'codigo': '422', 'nome': 'Banco Safra S.A.' }, { 'codigo': '456', 'nome': 'Banco MUFG Brasil S.A.' }, { 'codigo': '464', 'nome': 'Banco Sumitomo Mitsui Brasileiro S.A.' }, { 'codigo': '473', 'nome': 'Banco Caixa Geral – Brasil S.A.' }, { 'codigo': '477', 'nome': 'Citibank N.A.' }, { 'codigo': '479', 'nome': 'Banco ItauBank S.A.' }, { 'codigo': '487', 'nome': 'DEUTSCHE BANK S.A. – BANCO ALEMAO' }, { 'codigo': '488', 'nome': 'JPMorgan Chase Bank, National Association' }, { 'codigo': '492', 'nome': 'ING Bank N.V.' }, { 'codigo': '495', 'nome': 'Banco de La Provincia de Buenos Aires' }, { 'codigo': '505', 'nome': 'Banco Credit Suisse (Brasil) S.A.' }, { 'codigo': '545', 'nome': 'SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A' }, { 'codigo': '600', 'nome': 'Banco Luso Brasileiro S.A.' }, { 'codigo': '604', 'nome': 'Banco Industrial do Brasil S.A.' }, { 'codigo': '610', 'nome': 'Banco VR S.A.' }, { 'codigo': '611', 'nome': 'Banco Paulista S.A.' }, { 'codigo': '612', 'nome': 'Banco Guanabara S.A.' }, { 'codigo': '613', 'nome': 'Omni Banco S.A.' }, { 'codigo': '623', 'nome': 'Banco Pan S.A.' }, { 'codigo': '626', 'nome': 'BANCO C6 CONSIGNADO S.A.' }, { 'codigo': '630', 'nome': 'Banco Smartbank S.A.' }, { 'codigo': '633', 'nome': 'Banco Rendimento S.A.' }, { 'codigo': '634', 'nome': 'BANCO TRIANGULO S.A.' }, { 'codigo': '637', 'nome': 'BANCO SOFISA S.A.' }, { 'codigo': '643', 'nome': 'Banco Pine S.A.' }, { 'codigo': '652', 'nome': 'Itaú Unibanco Holding S.A.' }, { 'codigo': '653', 'nome': 'BANCO INDUSVAL S.A.' }, { 'codigo': '654', 'nome': 'BANCO DIGIMAIS S.A.' }, { 'codigo': '655', 'nome': 'Banco Votorantim S.A.' }, { 'codigo': '707', 'nome': 'Banco Daycoval S.A.' }, { 'codigo': '712', 'nome': 'Banco Ourinvest S.A.' }, { 'codigo': '720', 'nome': 'BCO RNX S.A.' }, { 'codigo': '739', 'nome': 'Banco Cetelem S.A.' }, { 'codigo': '741', 'nome': 'BANCO RIBEIRAO PRETO S.A.' }, { 'codigo': '743', 'nome': 'Banco Semear S.A.' }, { 'codigo': '745', 'nome': 'Banco Citibank S.A.', 'caracteresConta': 8, 'digitoAgencia': false }, { 'codigo': '746', 'nome': 'Banco Modal S.A.' }, { 'codigo': '747', 'nome': 'Banco Rabobank International Brasil S.A.' }, { 'codigo': '748', 'nome': 'BANCO COOPERATIVO SICREDI S.A.' }, { 'codigo': '751', 'nome': 'Scotiabank Brasil S.A. Banco Múltiplo' }, { 'codigo': '752', 'nome': 'Banco BNP Paribas Brasil S.A.' }, { 'codigo': '753', 'nome': 'Novo Banco Continental S.A. – Banco Múltiplo' }, { 'codigo': '754', 'nome': 'Banco Sistema S.A.' }, { 'codigo': '755', 'nome': 'Bank of America Merrill Lynch Banco Múltiplo S.A.' }, { 'codigo': '756', 'nome': 'BANCO COOPERATIVO DO BRASIL S.A. – BANCOOB' }, { 'codigo': '757', 'nome': 'BANCO KEB HANA DO BRASIL S.A.' }]
	    };
	  },
	
	  props: ['propsFormalizacao', 'propsAdiantaveis'],
	  inject: ['$validator'],
	  provide: function provide() {
	    return {
	      $validator: this.$validator
	    };
	  },
	
	  computed: {
	    datas: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (this.formalizacao.dt_assinatura_convenio) {
	                  this.formalizacao.dt_data_vigencia = (0, _moment2.default)(this.formalizacao.dt_assinatura_convenio).add(parseInt(this.propsFormalizacao.periodo_vigencia), 'M');
	                  this.formalizacao.dt_data_vigencia = (0, _moment2.default)(this.formalizacao.dt_data_vigencia).format('YYYY-MM-DD HH:mm:ss');
	                  this.formalizacao.dt_assinatura_convenio = (0, _moment2.default)(this.formalizacao.dt_assinatura_convenio).format('YYYY-MM-DD HH:mm:ss');
	                } else {
	                  this.formalizacao.dt_data_vigencia = (0, _moment2.default)(this.formalizacao.dt_proposta).add(parseInt(this.propsFormalizacao.periodo_vigencia), 'M');
	                  this.formalizacao.dt_data_vigencia = (0, _moment2.default)(this.formalizacao.dt_data_vigencia).format('YYYY-MM-DD HH:mm:ss');
	                }
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function datas() {
	        return _ref.apply(this, arguments);
	      }
	
	      return datas;
	    }(),
	    codigoAgencia: function codigoAgencia() {
	      this.formalizacao.ds_agencia_numero = this.formalizacao.ds_agencia_nome;
	    }
	  },
	  watch: {
	    propsFormalizacao: {
	      immediate: true,
	      handler: function handler() {
	        this.formalizacao = this.propsFormalizacao;
	        if (this.formalizacao.perguntasFAV) {
	          this.perguntasFAV = this.formalizacao.perguntasFAV;
	        } else {
	          if (this.perguntasFAV) {
	            this.formalizacao.perguntasFAV = this.perguntasFAV;
	          }
	        }
	        this.verificarFAV();
	        this.formalizacao.ds_agencia_banco = '001';
	        this.initAgenciaSelecionada();
	
	        this.$forceUpdate();
	
	        if (this.formalizacao.documentos) {
	          if (this.formalizacao.documentos.formalizacao.length <= 0) {
	            this.formalizacao.documentos.formalizacao = [];
	          } else {
	            this.formalizacaoDocumentos = this.formalizacao.documentos.formalizacao;
	          }
	        }
	        this.$emit('formalizacaoProposta', this.formalizacao);
	
	        this.$forceUpdate();
	      }
	    },
	    formalizacaoDocumentos: function formalizacaoDocumentos() {
	      if (this.formalizacaoDocumentos) {
	        this.formalizacao.documentos.formalizacao = this.formalizacaoDocumentos;
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.datas();
	  },
	  created: function created() {
	    var vm = this;
	
	    this.$validator.extend('depoisDeferimento', {
	      getMessage: function getMessage(field, val) {
	        return 'data da assinatura de convênio deve ser igual ou posterior a data de deferimento';
	      },
	      validate: function validate(value, field) {
	        var dataAssinatura = (0, _moment2.default)(vm.formalizacao.dt_assinatura_convenio, 'YYYY-MM-DD-hh:mm:ss').format('DD/MM/YYYY');
	        console.log(dataAssinatura);
	        var dataDeferimento = (0, _moment2.default)(vm.formalizacao.dt_deferimento, 'YYYY-MM-DD-hh:mm:ss').format('DD/MM/YYYY');
	        console.log(dataDeferimento);
	
	        return (0, _moment2.default)(dataAssinatura, 'YYYY-MM-DD').isSameOrAfter((0, _moment2.default)(dataDeferimento, 'YYYY-MM-DD'));
	      }
	    });
	
	    this.$validator.extend('depoisAnalise', {
	      getMessage: function getMessage(field, val) {
	        return 'data da assinatura de convênio deve ser igual ou posterior a data de analise';
	      },
	      validate: function validate(value, field) {
	        var dataAssinatura = (0, _moment2.default)(vm.formalizacao.dt_assinatura_convenio, 'YYYY-MM-DD-hh:mm:ss').format('DD/MM/YYYY');
	        var dataAnalise = (0, _moment2.default)(vm.formalizacao.dt_analise, 'YYYY-MM-DD-hh:mm:ss').format('DD/MM/YYYY');
	
	        return (0, _moment2.default)(dataAssinatura, 'YYYY-MM-DD').isSameOrAfter((0, _moment2.default)(dataAnalise, 'YYYY-MM-DD'));
	      }
	    });
	    this.$validator.extend('hojeAnterior', {
	      getMessage: function getMessage(field, val) {
	        return 'data ' + field + ' deve ser igual ou anterior a data de hoje.';
	      },
	      validate: function validate(value, field) {
	        var newdate = (0, _moment2.default)(value, 'YYYY-MM-DD-hh:mm:ss');
	        if (newdate.isValid()) {
	          var datenow = (0, _moment2.default)();
	          return newdate.isSameOrBefore(datenow, 'date');
	        } else {
	          return false;
	        }
	      }
	    });
	    this.buscaArquivosEsperados();
	
	    this.verificarFAV();
	  },
	
	  methods: {
	    verificarFAV: function verificarFAV() {
	      var irregulares = _.filter(this.perguntasFAV, function (o) {
	        return o.nivel === 3 && o.resposta === 0;
	      });
	      var pendentes = _.filter(this.perguntasFAV, function (o) {
	        return o.nivel === 3 && _.isNull(o.resposta);
	      });
	      this.$emit('validacaoFormalizacao', { 'tag': 'formalizacaoProjetoFavNao', 'ativo': irregulares.length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há <b>' + irregulares.length + ' ' + (irregulares.length > 1 ? 'questões' : 'questão') + ' na FAV</b> que não permitem Concluir' });
	      this.$emit('validacaoFormalizacao', { 'tag': 'formalizacaoProjetoFavPendente', 'ativo': pendentes.length > 0, 'tipo': 'restricao', 'acao': null, 'mensagem': 'Há <b>' + pendentes.length + ' ' + (pendentes.length > 1 ? 'questões' : 'questão') + ' pendente de escolha na FAV</b>' });
	    },
	    buscaArquivosEsperados: function buscaArquivosEsperados() {
	      var _this = this;
	
	      axiosLaravel.get('configuracoes/').then(function (response) {
	        _this.tiposDocumentos.push(response.data.configuracao_proposta.minuta);
	        _this.tiposDocumentos.push(response.data.configuracao_proposta.plano_trabalho);
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    initAgenciaSelecionada: function initAgenciaSelecionada() {
	      console.log('INIT AGENCIA SELECIONADA');
	      if (!this.formalizacao.hasOwnProperty('agenciaSelecionada')) {
	        this.formalizacao.agenciaSelecionada = {
	          agencia: '0000',
	          nomeAgencia: 'NOME_AGENCIA',
	          emailAgencia: 'EMAIL_AGENCIA',
	          informacoesGerenteGeral: {
	            nome: 'NOME',
	            cpf: '00000000000',
	            estadoCivil: '',
	            municipioResidencia: 'MUNICIPIO_RESIDENCIA',
	            email: 'EMAIL_GERENTE',
	            rg: '000000000'
	          },
	          cnpj: '00000000'
	        };
	      }
	    },
	    buscaDatas: function buscaDatas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return axiosLaravel.post('processos/historico/', { 'id_proposta': _this2.$route.params.id, 'tipo': 'USUARIO' }).then(function (response) {
	                  var ultima = _.last(_.sortBy(_.filter(response.data, function (t) {
	                    return t.nome === 'SOLICITACAO' || t.nome === 'REVISAO';
	                  }), ['id']));
	                  if (!_.isUndefined(ultima)) {
	                    _this2.formalizacao.dt_proposta = ultima.termino;
	                  }
	                  _this2.$forceUpdate();
	                  var analise = _.last(_.sortBy(_.filter(response.data, function (t) {
	                    return t.nome === 'ANALISE';
	                  }), ['id']));
	                  _this2.formalizacao.dt_analise = analise.termino;
	                  _this2.$forceUpdate();
	
	                  var deferimento = _.last(_.sortBy(_.filter(response.data, function (t) {
	                    return t.nome === 'DEFERIMENTO';
	                  }), ['id']));
	                  _this2.formalizacao.dt_deferimento = deferimento.termino;
	                  _this2.$forceUpdate();
	                });
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    onReturn: function onReturn() {
	      this.$router.go(-1);
	    },
	    preparaArquivos: function preparaArquivos() {
	      this.analise.documentDraft = [];
	      if (this.analise.proposal.documentDraft) {
	        this.analise.documentDraft.push(this.analise.proposal.documentDraft);
	      }
	      if (this.analise.proposal.documentWorkPlan) {
	        this.analise.documentDraft.push(this.analise.proposal.documentWorkPlan);
	      }
	    },
	    validaDatas: function validaDatas() {
	      this.formalizacao.dt_proposta = (0, _moment2.default)(this.formalizacao.dt_proposta).format('YYYY-MM-DD HH:mm:ss');
	      this.formalizacao.dt_analise = (0, _moment2.default)(this.formalizacao.dt_analise).format('YYYY-MM-DD HH:mm:ss');
	      this.formalizacao.dt_deferimento = (0, _moment2.default)(this.formalizacao.dt_deferimento).format('YYYY-MM-DD HH:mm:ss');
	      if (this.formalizacao.dt_analise) {
	        if (this.formalizacao.dt_proposta) {
	          if (this.formalizacao.dt_analise < this.formalizacao.dt_proposta) {
	            this.$snotify.error('Data da análise não pode ser anterior a data da proposta.');
	            return;
	          }
	        }
	      }
	      if (this.formalizacao.dt_deferimento) {
	        if (this.formalizacao.dt_analise) {
	          if (this.formalizacao.dt_deferimento < this.formalizacao.dt_analisea) {
	            this.$snotify.error('Data do deferimento não pode ser anterior a data da análise.');
	            return;
	          }
	        }
	      }
	    },
	    verificarInputContaAdiantamento: function verificarInputContaAdiantamento() {
	      if (this.formalizacao.ds_agencia_adiantamento && this.formalizacao.ds_conta_adiantamento) {
	        this.validandoDadosBancarios(this.formalizacao.ds_agencia_adiantamento, this.formalizacao.ds_conta_adiantamento);
	      }
	    },
	    validandoDadosBancarios: function validandoDadosBancarios(agenciaVal, contaVal) {
	      console.log('Validando dados bancários - conta adiantamento');
	      if (agenciaVal && contaVal) {
	        var banco = '001';
	        var conta = _.words(contaVal);
	        var digitosConta = _.get(_.head(_.filter(this.listaBancos, ['codigo', banco])), 'caracteresConta');
	        var contaSemDV = digitosConta ? _.padStart(conta[0], digitosConta, '0') : conta[0];
	        var contaDV = conta[1] || '';
	
	        var agencia = _.words(agenciaVal);
	        var agenciaSemDV = agencia[0] || '';
	        var agenciaDV = agencia[1] || '';
	        console.log(agencia, conta, banco);
	        try {
	          _brBankAccountValidator2.default.validate({
	            bankNumber: banco,
	            agencyNumber: agenciaSemDV,
	            agencyCheckNumber: agenciaDV,
	            accountNumber: contaSemDV,
	            accountCheckNumber: contaDV
	          });
	          console.log('PASSOU');
	          return true;
	        } catch (e) {
	          console.log('Erro na validação de dados bancários', e.message);
	          this.$snotify.error(e.message);
	          this.formalizacao.ds_agencia_adiantamento = '';
	          this.formalizacao.ds_conta_adiantamento = '';
	          return e.message;
	        }
	      }
	      console.log('NÃO ENCONTROU DADOS PARA COMPARAR');
	      return false;
	    },
	    limitarDigitosMCI: function limitarDigitosMCI() {
	      if (this.formalizacao.mci.length > 9) {
	        this.formalizacao.mci = this.formalizacao.mci.slice(0, 9);
	      }
	    },
	    gerarMinutaAutomatica: function gerarMinutaAutomatica() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var fkEdital, url;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                fkEdital = _.includes(_this3.editaisComMinuta, _this3.formalizacao.fk_edital) ? _this3.formalizacao.fk_edital : 0;
	
	                _this3.$aguarde('Gerando Minuta. Por favor, aguarde...');
	                _context3.prev = 2;
	                _context3.next = 5;
	                return _geraMinuta2.default.methods.gerarMinuta(_this3.$route.params.id, _this3.minutaSimplificada, fkEdital, _this3.tipoMinutaEcoforte, _this3.minutaAdicional === 'POVOS_PRIORIZADOS');
	
	              case 5:
	                if (!_context3.sent) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                _this3.$snotify.clear();
	                _this3.$snotify.success('Minuta Gerada com sucesso!');
	                url = _this3.$router.resolve({
	                  name: 'plano-trabalho',
	                  params: { id: _this3.$route.params.id },
	                  query: { print: true }
	                }).href;
	
	                window.open(url, '_blank');
	                _context3.next = 14;
	                break;
	
	              case 12:
	                _this3.$snotify.clear();
	                _this3.$snotify.error('Modelo de minuta não cadastrada para o tipo de proposta.');
	
	              case 14:
	                _context3.next = 21;
	                break;
	
	              case 16:
	                _context3.prev = 16;
	                _context3.t0 = _context3['catch'](2);
	
	                console.log('Erro ao gerar a minuta:', _context3.t0);
	                _this3.$snotify.clear();
	                _this3.$snotify.error('Não foi possível gerar a minuta. Tente novamente.');
	
	              case 21:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3, [[2, 16]]);
	      }))();
	    }
	  }
	};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _aprovacaoProjeto = __webpack_require__(1819);
	
	var _aprovacaoProjeto2 = _interopRequireDefault(_aprovacaoProjeto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    AprovacaoProjeto: _aprovacaoProjeto2.default,
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    PublicoAlvo: _publicoAlvo2.default },
	  name: 'main-aprovacao-projeto',
	  data: function data() {
	    return {
	      loadingShow: false,
	      proposta: {
	        entity: {
	          companyName: ''
	        },
	        duplicateProjectDescription: ''
	      },
	      analise: {},
	      arvoreProjetos: [],
	      documentosObrigatorios: ['Memória de cálculo', 'Declaração']
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    dataFinal: function dataFinal() {
	      return (0, _moment2.default)(this.proposta.initialDate).add(this.proposta.periods, 'M').format('DD/MM/YYYY');
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      if (this.proposta.objectives) {
	        return this.proposta.objectives.some(function (o) {
	          return o.goals.activities !== null;
	        });
	      }
	    },
	    atividades: function atividades() {
	      var _this = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  created: function created() {
	    this.buscaAnalise();
	    this.buscaArvoreProjeto();
	  },
	
	  watch: {
	    'proposta.duplicateProject': function propostaDuplicateProject() {
	      var _this2 = this;
	
	      if (this.arvoreProjetos.length) {
	        var projetoSelecionado = this.arvoreProjetos.find(function (projeto) {
	          return projeto.projectNumber === _this2.proposta.duplicateProject;
	        });
	        this.proposta.duplicateProjectDescription = projetoSelecionado.projectName;
	      }
	    }
	  },
	  methods: {
	    buscaAnalise: function buscaAnalise() {
	      var _this3 = this;
	
	      this.loadingShow = true;
	      axios.get('proxy/project/project-formalization/' + this.$route.params.id).then(function (response) {
	        _this3.proposta = response.data.value.proposal;
	        _this3.analise = response.data.value;
	        _this3.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    onSave: function onSave() {
	      var _this4 = this;
	
	      this.proposta.proposalOrigin = 'COMPLETO';
	      this.$snotify.info('Salvando proposta', { timeout: 0 });
	      axios.post('proxy/project/proposal/temp', this.proposta).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Proposta atualizada com sucesso');
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    onConclude: function onConclude() {
	      var _this5 = this;
	
	      this.proposta.proposalOrigin = 'COMPLETO';
	      var propostaOK = true;
	      if (!this.isUploadingDocuments()) {
	        this.$snotify.error('Faltam documentos à serem adicionados');
	        propostaOK = false;
	      }
	      if (!this.validateParticipantsMunicipalization()) {
	        this.$snotify.error('Faltam participantes a serem adicionados aos municípios');
	        propostaOK = false;
	      }
	      if (!this.validaObjetivos()) {
	        this.$snotify.error('Faltam adicionar metas para todos os objetivos');
	        propostaOK = false;
	      } else if (!this.validaMetas()) {
	        this.$snotify.error('Faltam adicionar atividades para todos as metas');
	        propostaOK = false;
	      } else if (!this.validaAtividades()) {
	        this.$snotify.error('Faltam adicionar items para todas as atividades');
	        propostaOK = false;
	      } else if (!this.outrasValidacoes()) {
	        propostaOK = false;
	      }
	      if (propostaOK) {
	        axios.post('proxy/project/proposal', this.proposta).then(function (response) {
	          _this5.$snotify.success('Proposta atualizada com sucesso');
	          setTimeout(function () {
	            _this5.$router.go(-1);
	          }, 2000);
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	        });
	      }
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this6 = this;
	
	      axios.get('/proxy/project/project-tree').then(function (response) {
	        _this6.arvoreProjetos = response.data.value;
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	var _deferimento = __webpack_require__(173);
	
	var _deferimento2 = _interopRequireDefault(_deferimento);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Deferimento: _deferimento2.default,
	    Analise: _analise2.default,
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    PublicoAlvo: _publicoAlvo2.default },
	  name: 'main-deferimento',
	  data: function data() {
	    return {
	      loadingShow: false,
	      proposta: {
	        entity: {
	          companyName: ''
	        },
	        duplicateProjectDescription: ''
	      },
	      analise: {},
	      arvoreProjetos: [],
	      documentosObrigatorios: ['Memória de cálculo', 'Declaração']
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    dataFinal: function dataFinal() {
	      return (0, _moment2.default)(this.proposta.initialDate).add(this.proposta.periods, 'M').format('DD/MM/YYYY');
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      if (this.proposta.objectives) {
	        return this.proposta.objectives.some(function (o) {
	          return o.goals.activities !== null;
	        });
	      }
	    },
	    atividades: function atividades() {
	      var _this = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  created: function created() {
	    this.buscaAnalise();
	    this.buscaArvoreProjeto();
	  },
	
	  watch: {
	    'proposta.duplicateProject': function propostaDuplicateProject() {
	      var _this2 = this;
	
	      if (this.arvoreProjetos.length) {
	        var projetoSelecionado = this.arvoreProjetos.find(function (projeto) {
	          return projeto.projectNumber === _this2.proposta.duplicateProject;
	        });
	        this.proposta.duplicateProjectDescription = projetoSelecionado.projectName;
	      }
	    }
	  },
	  methods: {
	    buscaAnalise: function buscaAnalise() {
	      var _this3 = this;
	
	      this.loadingShow = true;
	      axios.get('proxy/project/approval-grant/' + this.$route.params.id).then(function (response) {
	        _this3.proposta = response.data.value.proposal;
	        _this3.analise = response.data.value;
	        _this3.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this4 = this;
	
	      axios.get('/proxy/project/project-tree').then(function (response) {
	        _this4.arvoreProjetos = response.data.value;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	var _aprovacao_OLD = __webpack_require__(531);
	
	var _aprovacao_OLD2 = _interopRequireDefault(_aprovacao_OLD);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Formalizacao: _aprovacao_OLD2.default,
	    Analise: _analise2.default,
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    PublicoAlvo: _publicoAlvo2.default },
	  name: 'main-formalizacao',
	  data: function data() {
	    return {
	      loadingShow: false,
	      proposta: {
	        entity: {
	          companyName: ''
	        },
	        duplicateProjectDescription: ''
	      },
	      esconder: false,
	      analise: {},
	      arvoreProjetos: [],
	      documentosObrigatorios: ['Memória de cálculo', 'Declaração']
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    dataFinal: function dataFinal() {
	      return (0, _moment2.default)(this.proposta.initialDate).add(this.proposta.periods, 'M').format('DD/MM/YYYY');
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      if (this.proposta.objectives) {
	        return this.proposta.objectives.some(function (o) {
	          return o.goals.activities !== null;
	        });
	      }
	    },
	    atividades: function atividades() {
	      var _this = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  created: function created() {
	    this.buscaAnalise();
	    this.buscaArvoreProjeto();
	  },
	
	  watch: {
	    'proposta.duplicateProject': function propostaDuplicateProject() {
	      var _this2 = this;
	
	      if (this.arvoreProjetos.length) {
	        var projetoSelecionado = this.arvoreProjetos.find(function (projeto) {
	          return projeto.projectNumber === _this2.proposta.duplicateProject;
	        });
	        this.proposta.duplicateProjectDescription = projetoSelecionado.projectName;
	      }
	    }
	  },
	  methods: {
	    buscaAnalise: function buscaAnalise() {
	      var _this3 = this;
	
	      this.loadingShow = true;
	      axios.get('proxy/project/project-formalization/' + this.$route.params.id).then(function (response) {
	        _this3.proposta = response.data.value.proposal;
	        _this3.analise = response.data.value;
	        _this3.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    onSave: function onSave() {
	      var _this4 = this;
	
	      this.proposta.proposalOrigin = 'COMPLETO';
	      this.$snotify.info('Salvando proposta', { timeout: 0 });
	      axios.post('proxy/project/proposal/temp', this.proposta).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Proposta atualizada com sucesso');
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    onConclude: function onConclude() {
	      var _this5 = this;
	
	      this.proposta.proposalOrigin = 'COMPLETO';
	      var propostaOK = true;
	      if (!this.isUploadingDocuments()) {
	        this.$snotify.error('Faltam documentos à serem adicionados');
	        propostaOK = false;
	      }
	      if (!this.validateParticipantsMunicipalization()) {
	        this.$snotify.error('Faltam participantes a serem adicionados aos municípios');
	        propostaOK = false;
	      }
	      if (!this.validaObjetivos()) {
	        this.$snotify.error('Faltam adicionar metas para todos os objetivos');
	        propostaOK = false;
	      } else if (!this.validaMetas()) {
	        this.$snotify.error('Faltam adicionar atividades para todos as metas');
	        propostaOK = false;
	      } else if (!this.validaAtividades()) {
	        this.$snotify.error('Faltam adicionar items para todas as atividades');
	        propostaOK = false;
	      } else if (!this.outrasValidacoes()) {
	        propostaOK = false;
	      }
	      if (propostaOK) {
	        axios.post('proxy/project/proposal', this.proposta).then(function (response) {
	          _this5.$snotify.success('Proposta atualizada com sucesso');
	          setTimeout(function () {
	            _this5.$router.go(-1);
	          }, 2000);
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	        });
	      }
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this6 = this;
	
	      axios.get('/proxy/project/project-tree').then(function (response) {
	        _this6.arvoreProjetos = response.data.value;
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _publicoAlvo = __webpack_require__(30);
	
	var _publicoAlvo2 = _interopRequireDefault(_publicoAlvo);
	
	var _equipeProjeto = __webpack_require__(51);
	
	var _equipeProjeto2 = _interopRequireDefault(_equipeProjeto);
	
	var _objetivoEspecifico = __webpack_require__(29);
	
	var _objetivoEspecifico2 = _interopRequireDefault(_objetivoEspecifico);
	
	var _metas = __webpack_require__(27);
	
	var _metas2 = _interopRequireDefault(_metas);
	
	var _atividades = __webpack_require__(34);
	
	var _atividades2 = _interopRequireDefault(_atividades);
	
	var _cronograma = __webpack_require__(65);
	
	var _cronograma2 = _interopRequireDefault(_cronograma);
	
	var _Gantt = __webpack_require__(64);
	
	var _Gantt2 = _interopRequireDefault(_Gantt);
	
	var _municipalizacao = __webpack_require__(52);
	
	var _municipalizacao2 = _interopRequireDefault(_municipalizacao);
	
	var _cursos = __webpack_require__(49);
	
	var _cursos2 = _interopRequireDefault(_cursos);
	
	var _solenizacao = __webpack_require__(66);
	
	var _solenizacao2 = _interopRequireDefault(_solenizacao);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoProposta = __webpack_require__(35);
	
	var _historicoProposta2 = _interopRequireDefault(_historicoProposta);
	
	var _analise = __webpack_require__(75);
	
	var _analise2 = _interopRequireDefault(_analise);
	
	var _formalizacao = __webpack_require__(174);
	
	var _formalizacao2 = _interopRequireDefault(_formalizacao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PreparacaoDocumento: _formalizacao2.default,
	    Analise: _analise2.default,
	    HistoricoProposta: _historicoProposta2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    Solenizacao: _solenizacao2.default,
	    Cursos: _cursos2.default,
	    Municipalizacao: _municipalizacao2.default,
	    Gantt: _Gantt2.default,
	    Cronograma: _cronograma2.default,
	    Atividades: _atividades2.default,
	    Metas: _metas2.default,
	    ObjetivoEspecifico: _objetivoEspecifico2.default,
	    EquipeProjeto: _equipeProjeto2.default,
	    PublicoAlvo: _publicoAlvo2.default },
	  name: 'main-preparacao-documento',
	  data: function data() {
	    return {
	      loadingShow: false,
	      proposta: {
	        entity: {
	          companyName: ''
	        },
	        solemnizations: [],
	        duplicateProjectDescription: ''
	      },
	      esconder: false,
	      analise: {
	        proposal: {
	          solemnizations: []
	        }
	      },
	      arvoreProjetos: [],
	      documentosObrigatorios: ['Memória de cálculo', 'Declaração']
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    dataFinal: function dataFinal() {
	      return (0, _moment2.default)(this.proposta.initialDate).add(this.proposta.periods, 'M').format('DD/MM/YYYY');
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    mostraCronograma: function mostraCronograma() {
	      if (this.proposta.objectives) {
	        return this.proposta.objectives.some(function (o) {
	          return o.goals.activities !== null;
	        });
	      }
	    },
	    atividades: function atividades() {
	      var _this = this;
	
	      var atividades = [];
	      if (this.proposta.objectives) {
	        this.proposta.objectives.forEach(function (objetivo) {
	          if (objetivo.goals) {
	            objetivo.goals.forEach(function (meta) {
	              if (meta.activities) {
	                meta.activities.forEach(function (atividade) {
	                  atividades.push(atividade);
	                  _this.$forceUpdate();
	                });
	              }
	            });
	          }
	        });
	      }
	      return atividades;
	    }
	  }),
	  created: function created() {
	    this.buscaAnalise();
	    this.buscaArvoreProjeto();
	  },
	
	  watch: {
	    'proposta.duplicateProject': function propostaDuplicateProject() {
	      var _this2 = this;
	
	      if (this.arvoreProjetos.length) {
	        var projetoSelecionado = this.arvoreProjetos.find(function (projeto) {
	          return projeto.projectNumber === _this2.proposta.duplicateProject;
	        });
	        this.proposta.duplicateProjectDescription = projetoSelecionado.projectName;
	      }
	    }
	  },
	  methods: {
	    buscaAnalise: function buscaAnalise() {
	      var _this3 = this;
	
	      this.loadingShow = true;
	      axios.get('proxy/project/document-preparation/' + this.$route.params.id).then(function (response) {
	        _this3.proposta = response.data.value.proposal;
	        _this3.analise = response.data.value;
	        _this3.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this3.$root.trataErro(error);
	      });
	    },
	    onSave: function onSave() {
	      var _this4 = this;
	
	      this.proposta.proposalOrigin = 'COMPLETO';
	      this.$snotify.info('Salvando proposta', { timeout: 0 });
	      axios.post('proxy/project/proposal/temp', this.proposta).then(function (response) {
	        _this4.$snotify.clear();
	        _this4.$snotify.success('Proposta atualizada com sucesso');
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        _this4.$root.trataErro(error);
	      });
	    },
	    onConclude: function onConclude() {
	      var _this5 = this;
	
	      this.proposta.proposalOrigin = 'COMPLETO';
	      var propostaOK = true;
	      if (!this.isUploadingDocuments()) {
	        this.$snotify.error('Faltam documentos à serem adicionados');
	        propostaOK = false;
	      }
	      if (!this.validateParticipantsMunicipalization()) {
	        this.$snotify.error('Faltam participantes a serem adicionados aos municípios');
	        propostaOK = false;
	      }
	      if (!this.validaObjetivos()) {
	        this.$snotify.error('Faltam adicionar metas para todos os objetivos');
	        propostaOK = false;
	      } else if (!this.validaMetas()) {
	        this.$snotify.error('Faltam adicionar atividades para todos as metas');
	        propostaOK = false;
	      } else if (!this.validaAtividades()) {
	        this.$snotify.error('Faltam adicionar items para todas as atividades');
	        propostaOK = false;
	      } else if (!this.outrasValidacoes()) {
	        propostaOK = false;
	      }
	      if (propostaOK) {
	        axios.post('proxy/project/proposal', this.proposta).then(function (response) {
	          _this5.$snotify.success('Proposta atualizada com sucesso');
	          setTimeout(function () {
	            _this5.$router.go(-1);
	          }, 2000);
	        }).catch(function (error) {
	          _this5.$root.trataErro(error);
	        });
	      }
	    },
	    buscaArvoreProjeto: function buscaArvoreProjeto() {
	      var _this6 = this;
	
	      axios.get('/proxy/project/project-tree').then(function (response) {
	        _this6.arvoreProjetos = response.data.value;
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(276);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _agenciaCondutoraProjeto = __webpack_require__(510);
	
	var _agenciaCondutoraProjeto2 = _interopRequireDefault(_agenciaCondutoraProjeto);
	
	var _fav = __webpack_require__(84);
	
	var _fav2 = _interopRequireDefault(_fav);
	
	var _fep = __webpack_require__(518);
	
	var _fep2 = _interopRequireDefault(_fep);
	
	var _categorizadores = __webpack_require__(513);
	
	var _categorizadores2 = _interopRequireDefault(_categorizadores);
	
	var _restricoes = __webpack_require__(1742);
	
	var _restricoes2 = _interopRequireDefault(_restricoes);
	
	var _uploadDocumentosPhpNovo = __webpack_require__(23);
	
	var _uploadDocumentosPhpNovo2 = _interopRequireDefault(_uploadDocumentosPhpNovo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UploadDocumentosPhpNovo: _uploadDocumentosPhpNovo2.default,
	    Restricoes: _restricoes2.default,
	    Categorizadores: _categorizadores2.default,
	    Fep: _fep2.default,
	    Fav: _fav2.default,
	    AgenciaCondutoraProjeto: _agenciaCondutoraProjeto2.default },
	  name: 'pre-analise-form',
	  props: ['propsPreAnalise', 'propsFluxo'],
	  data: function data() {
	    return {
	      elementos: {
	        visivel: ''
	      },
	      aguardaEnviar: 0,
	      preAnalise: {}
	    };
	  },
	  created: function created() {
	    this.buscaRisco();
	  },
	  mounted: function mounted() {
	    this.buscaRisco();
	    if (this.preAnalise) {
	      this.preAnalise.rating.id = 0;
	    }
	  },
	
	  watch: {
	    propsPreAnalise: function propsPreAnalise() {
	      this.preAnalise = this.propsPreAnalise;
	      this.$emit('preAnaliseProposta', this.preAnalise);
	    },
	    propsFluxo: function propsFluxo() {
	      this.elementos = this.propsFluxo.elementos;
	    }
	  },
	  methods: {
	    mostrarRef: function mostrarRef(ref) {
	      return _.filter(this.elementos, function (item) {
	        return item.nome === ref;
	      }).some(function (item) {
	        return item.visivel;
	      });
	    },
	    buscaRisco: function buscaRisco() {
	      var _this = this;
	
	      axios.get('proxy/project/risk-answer/get-by-risk-question-id/' + 8).then(function (response) {
	        console.log('response.data.value', response.data.value);
	        _this.rating = response.data.value;
	        _this.$forceUpdate();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    onConclude: function onConclude() {
	      var _this2 = this;
	
	      if (this.preAnalise.resultadoAprovacao === 'APROVAR') {
	        this.Aprova();
	      } else if (this.preAnalise.preAnalysisApprovalResult === 'REPROVED' || this.preAnalise.preAnalysisApprovalResult === 'REVIEW') {
	        this.$validator.validate('justificativa');
	        this.$validator.validate('preAnalysisApprovalResult');
	        if (this.$validator.errors.items.length > 0) {
	          this.$validator.errors.items.forEach(function (item) {
	            _this2.$snotify.error('campo ' + item.field + ' com erro. Favor verificar');
	          });
	        } else {
	          this.enviaBackEnd();
	        }
	      }
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this3 = this;
	
	      this.aguardaEnviar = 1;
	      this.$aguarde('Validando proposta. Por favor, aguarde...');
	      axios.put('proxy/project/approval-pre-analysis/' + this.preAnalise.id + '/approve', this.preAnalise).then(function (response) {
	        _this3.$snotify.clear();
	        _this3.$snotify.success('Validação atualizada com sucesso');
	        setTimeout(function () {
	          _this3.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this3.aguardaEnviar = 0;
	        _this3.$snotify.clear();
	        _this3.$root.trataErro(error);
	      });
	    },
	    Aprova: function Aprova() {
	      var _this4 = this;
	
	      if (!this.$root.validaProposta(this.preAnalise.proposal)) {
	        return;
	      }
	
	      this.$parent.$validator.validateAll().then(function (validado) {
	        if (!validado) {
	          _this4.$snotify.error('Formulario de proposta possui erros favor verificar');
	          return;
	        }
	
	        if (!_this4.$root.verificaFormulario(_this4)) {
	          _this4.$snotify.error('Formulario possui erros favor verificar');
	          return;
	        }
	
	        if (_this4.preAnalise.documents.length === 0) {
	          _this4.$snotify.error('Favor anexar documentos da Pré-Analise');
	          return;
	        }
	        _this4.$validator.validateAll().then(function (validado) {
	          if (!validado) {
	            _this4.$snotify.error('Formulario possui erros favor verificar');
	          } else {
	            _this4.enviaBackEnd();
	          }
	        });
	      });
	    },
	    verificaCadastroEntidadeOk: function verificaCadastroEntidadeOk() {
	      if (_.has(this.preAnalise.proposal, 'entity')) {
	        if (!(_.has(this.preAnalise.proposal.entity, 'codForERp') && (0, _isInteger2.default)(parseInt(this.preAnalise.proposal.entity.codForERp)))) {
	          return false;
	        }
	      }
	      return true;
	    },
	    onSave: function onSave() {
	      var _this5 = this;
	
	      if (!this.validaRating()) {
	        this.$snotify.error('Campo de calculo de Rating é obrigatório');
	        return;
	      }
	
	      if (!this.verificaCadastroEntidadeOk()) {
	        this.$snotify.warning('Esta entidade não tem o cadastro completo aprovado, portanto o seu cadastro ainda não foi integrado ao ERP.');
	      }
	      this.$aguarde('Salvando validação. Por favor, aguarde...');
	      axios.put('proxy/project/approval-pre-analysis/' + this.preAnalise.id, this.preAnalise).then(function (response) {
	        _this5.$snotify.clear();
	        _this5.$snotify.success('Validação salva com sucesso');
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    },
	    onReturn: function onReturn() {
	      this.$router.go(-1);
	    },
	    validaRating: function validaRating() {
	      if (this.preAnalise.proposal.rating.id <= 0) {
	        return false;
	      }
	      return true;
	    }
	  }
	};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaValidacaoRelExec',
	  data: function data() {
	    return {
	      quantidadesPrimeiraAprov: '',
	      quantidadesSegundaAprov: '',
	      faseAtual: '',
	      descricaoFase: '',
	      filtro: {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        userId: null
	      },
	      aprovacaoLista: [],
	      aprovacaoTotal: null,
	      loadingShow: false,
	      table: {
	        items: [],
	        totalRows: 0,
	        filter: null,
	        hover: false,
	        bordered: false,
	        currentPage: 1,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        perPage: 10,
	        fields: [{ key: 'favorite', label: '', thStyle: 'text-align: center; width: 3%', class: 'text-center' }, { key: 'projectName', label: '', thStyle: 'text-align: left; width: 60%', class: 'text-left' }, { key: 'reportSeq', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'userName', label: '', thStyle: 'font-weight: bold' }, { key: 'createdAt', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: '', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      table2: {
	        items: [],
	        totalRows: 0,
	        filter: null,
	        hover: false,
	        bordered: false,
	        currentPage: 1,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        perPage: 10,
	        fields: [{ key: 'favorite', label: '', thStyle: 'text-align: center; width: 3%', class: 'text-center' }, { key: 'projectName', label: '', thStyle: 'text-align: left; width: 60%', class: 'text-left' }, { key: 'reportSeq', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'userName', label: '', thStyle: 'font-weight: bold' }, { key: 'createdAt', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: '', thStyle: 'text-align: center', class: 'text-center' }]
	      }
	    };
	  },
	
	  watch: {
	    'filtro.favorite': function filtroFavorite() {
	      this.onSearch();
	    },
	    'filtro.userId': function filtroUserId() {
	      this.onSearch();
	    },
	    'faseAtual': function faseAtual() {
	      this.filtro.userId = null;
	      this.filtro.favorite = null;
	      this.onSearch();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    this.quantidadePrimeiraFase();
	    this.quantidadeSegundaFase();
	  },
	  mounted: function mounted() {
	    this.onSearch();
	  },
	
	  methods: {
	    quantidadePrimeiraFase: function quantidadePrimeiraFase() {
	      var _this = this;
	
	      axios.post('proxy/project/execution-report-approval/search', this.filtro).then(function (response) {
	        _this.quantidadesPrimeiraAprov = response.data.value.total;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    quantidadeSegundaFase: function quantidadeSegundaFase() {
	      var _this2 = this;
	
	      axios.post('proxy/project/execution-report-knowledge/search', this.filtro).then(function (response) {
	        _this2.quantidadesSegundaAprov = response.data.value.total;
	        console.log(response.data.value);
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    buscaAprovacaoPendencia: function buscaAprovacaoPendencia() {
	      var _this3 = this;
	
	      axios.post('proxy/project/execution-report-approval-pendency/search', this.filtro).then(function (response) {
	        _this3.table2.items = response.data.value.list;
	        _this3.table2.totalRows = response.data.value.total;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    buscaBackEnd: function buscaBackEnd(url) {
	      var _this4 = this;
	
	      axios.post(url, this.filtro).then(function (response) {
	        _this4.carregaTabela(response);
	        if (_this4.faseAtual === 'aprovacao') {
	          _this4.buscaAprovacaoPendencia();
	        }
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    carregaTabela: function carregaTabela(response) {
	      this.table.items = response.data.value.list;
	      this.table.totalRows = response.data.value.total;
	      this.loadingShow = false;
	    },
	    onSearch: function onSearch() {
	      this.loadingShow = true;
	      switch (this.faseAtual) {
	        case 'aprovacao':
	          this.descricaoFase = 'Relatório de Execução - Aprovação';
	          this.buscaBackEnd('proxy/project/execution-report-approval/search');
	          this.buscaAprovacaoPendencia();
	          break;
	        case 'conhecimento':
	          this.descricaoFase = 'Relatório de Execução - Para Conhecimento';
	          this.buscaBackEnd('proxy/project/execution-report-knowledge/search');
	          break;
	        default:
	          this.faseAtual = 'aprovacao';
	          this.descricaoFase = 'Relatório de Execução - Aprovação';
	          this.buscaBackEnd('proxy/project/execution-report-approval/search');
	      }
	      this.quantidadePrimeiraFase();
	      this.quantidadeSegundaFase();
	    },
	    onFavorite: function onFavorite(item) {
	      var _this5 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'aprovacao':
	          url = 'proxy/project/execution-report-approval/';
	          break;
	        case 'conhecimento':
	          url = 'proxy/project/execution-report-knowledge/';
	          break;
	      }
	      axios.put(url + item.id + '/favorite', '').then(function (response) {
	        _this5.onSearch();
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    onAssign: function onAssign(item) {
	      var _this6 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'aprovacao':
	          url = 'proxy/project/execution-report-approval/';
	          break;
	        case 'conhecimento':
	          url = 'proxy/project/execution-report-knowledge/';
	          break;
	      }
	      axios.put(url + item.id + '/assign', '').then(function (response) {
	        _this6.onSearch();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    onUnassign: function onUnassign(item) {
	      var _this7 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'aprovacao':
	          url = 'proxy/project/execution-report-approval/';
	          break;
	        case 'conhecimento':
	          url = 'proxy/project/execution-report-knowledge/';
	          break;
	      }
	      axios.put(url + item.id + '/unassign', '').then(function (response) {
	        _this7.onSearch();
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaValidacaoSolicitacoes',
	  data: function data() {
	    return {
	      carteiras: ['AABB Comunidade', 'Agroecologia', 'Agroindústria/MUTS', 'Educação para o Futuro', 'Estratégicos', 'Resíduos Sólidos/Água/BTS', 'Ajuda Humanitária', 'Meio Ambiente e Renda', 'Saúde e Bem-Estar', 'Voluntariado'],
	      ativaGeracaoRemessa: true,
	      filtroCarteiraContrapartida: '',
	      selecionarTodasTarefas: 'nao',
	      somenteComTarefas: 'nao',
	      meusFavoritados: 'nao',
	      minhasTarefas: 'nao',
	      comProjetos: 'nao',
	      minhaCarteira: '',
	      mapaCarteiras: {},
	      meusProcessos: '',
	      funcis: [],
	      ordenacao: {
	        por: 'data_solicitacao',
	        ordem: 'asc'
	      },
	      processos: [],
	      tarefas: [],
	      excel_campos: {
	        'ID': 'id_processo',
	        'Processo': 'nome_processo',
	        'Atividade': 'nome_tarefa',
	        'Entidade': 'entidade',
	        'Projeto': 'projeto',
	        'Atribuido': 'nome_usuario',
	        'Informacoes': 'info',
	        'Valor': 'valor',
	        'Data de Criação': 'data_solicitacao'
	      },
	      excel_meta: [[{ 'key': 'charset', 'value': 'utf-8' }]],
	      validacao: '',
	      mostraCarregando: true,
	      mostraProcessando: false,
	      showModal: false,
	      funcionarioBusca: '',
	      funcionarioEncontrado: null,
	      tarefasSelecionadas: [],
	      mostrarProcesso: [],
	      mostrarAtividade: [],
	      listaValidacoesBackup: {},
	      listaValidacoes: {
	        PAGAMENTO: {
	          ANALISE: [],
	          ANALISE_TRIBUTARIA: [],
	          AUTORIZACAO: [],
	          LIQUIDACAO_FINANCEIRA: []
	        },
	        RESSARCIMENTO: {
	          ANALISE: [],
	          ANALISE_TRIBUTARIA: [],
	          AUTORIZACAO: [],
	          LIQUIDACAO_FINANCEIRA: []
	        },
	        ADIANTAMENTO: {
	          ANALISE: [],
	          AUTORIZACAO: [],
	          LIQUIDACAO_FINANCEIRA: []
	        },
	        PRESTACAO_DE_CONTAS: {
	          ANALISE: [],
	          ANALISE_TRIBUTARIA: [],
	          AUTORIZACAO: []
	        },
	
	        DEVOLUCAO_DE_ADIANTAMENTO: {
	          ANALISE: [],
	          ANALISE_FINANCEIRA: []
	        },
	        CONTRAPARTIDA: {
	          ANALISE: []
	        },
	        RELATORIO_DE_EXECUCAO: {
	          ANALISE: [],
	          REVISAO: []
	        },
	        PROPOSTA_COMPLETA: {
	          ANALISE: [],
	          DEFERIMENTO: [],
	          FORMALIZACAO: [],
	          APROVACAO_PROJETO: [],
	          REVISAO: []
	        },
	        PROPOSTA_EDITAL: {
	          ANALISE: [],
	          DEFERIMENTO: [],
	          FORMALIZACAO: [],
	          APROVACAO_PROJETO: [],
	          REVISAO: []
	        },
	        CADASTRO_ENTIDADES: {
	          ANALISE: []
	        },
	        CADASTRO_ENTIDADES_COM_PROJETO: {
	          ANALISE: []
	        },
	        ALTERACOES_PROJETO: {
	          ANALISE: [],
	          AUTORIZACAO: [],
	          DELIBERACAO: [],
	          PENDENCIAS: [],
	          REVISAO: []
	        },
	        OCORRENCIA_PROJETO: {
	          AGUARDA_BAIXA: [],
	          AGUARDA_APROVACAO: []
	        },
	        OCORRENCIA_ENTIDADE: {
	          AGUARDA_BAIXA: [],
	          AGUARDA_APROVACAO: []
	        },
	        AVALIACAO_APROVACAO: {
	          SOLICITACAO: [],
	          REVISAO: [],
	          ANALISE: []
	        },
	        AVALIACAO_ENCERRAMENTO: {
	          SOLICITACAO: [],
	          REVISAO: [],
	          ANALISE: []
	        }
	      },
	      dadosHistorico: {
	        fk_processo: null,
	        id: null,
	        fk_usuario: null,
	        nome: null,
	        situacao: 'PADRAO',
	        inicio: null,
	        termino: null,
	        data_edicao: null,
	        tipo: null,
	        proxima_etapa: null,
	        etapa_anterior: null,
	        observacao: null
	      },
	      pesquisa: '',
	      opcoes: '',
	
	      enumeradores: { 'PROPOSTA_EDITAL': 'Editais', 'PROPOSTA_COMPLETA': 'Prospecção Direta', 'PAGAMENTO': 'Pagamento', 'RELATORIO_DE_EXECUCAO': 'Relatório de Execução', 'FLUXO_SIMPLIFICADO': 'Fluxo Simplificado', 'DEFERIMENTO': 'Deferimento', 'FORMALIZACAO': 'Formalização', 'APROVACAO_PROJETO': 'Aprovação de projetos', 'CONTRAPARTIDA': 'Contrapartida', 'ADIANTAMENTO': 'Adiantamento', 'DEVOLUCAO_DE_ADIANTAMENTO': 'Devolução de Adiantamento', 'PRESTACAO_DE_CONTAS': 'Prestação de Contas', 'CADASTRO_ENTIDADES': 'Cadastramento de Entidades', 'CADASTRO_ENTIDADES_COM_PROJETO': 'Entidades com projetos aprovados', 'ANALISE': 'Análise', 'PRIMEIRA_APROVACAO': 'Primeira Aprovação', 'SEGUNDA_APROVACAO': 'Segunda Aprovação', 'PENDENCIAS': 'Pendências', 'AUTORIZACAO': 'Autorização', 'ANALISE_FINANCEIRA': 'Acerto Contábil', 'ANALISE_TRIBUTARIA': 'Análise Tributária', 'LIQUIDACAO_FINANCEIRA': 'Liquidação', 'REVISAO': 'Revisão', 'APROVACAO': 'Aprovação', 'ENTIDADES': 'Entidades', 'PROPOSTAS': 'Contratação de projetos', 'SOLICITACOES': 'Execução financeira', 'RESSARCIMENTO': 'Ressarcimento', 'AVALIACOES': 'Avaliações de projeto', 'AVALIACAO_APROVACAO': 'Marco zero', 'AVALIACAO_ENCERRAMENTO': 'Marco um', 'SOLICITACAO': 'Em preenchimento', 'OCORRENCIAS': 'Ocorrências', 'OCORRENCIA_PROJETO': 'Ocorrência em projetos', 'OCORRENCIA_ENTIDADE': 'Ocorrência em entidade', 'AGUARDA_BAIXA': 'Baixa', 'AGUARDA_APROVACAO': 'Aprovação', 'FLEXIBILIZACAO': 'Flexibilização', 'ALTERACAO_ATIVIDADES': 'Atividades', 'ALTERACAO_ATIVIDADES_GANTT': 'Atividades (via Gantt)', 'ALTERACAO_METAS': 'Metas', 'ALTERACAO_MUNICIPIOS': 'Municípios', 'ALTERACAO_PARCELAS_ADIANTAMENTO': 'Parcelas de Adiantamento', 'ALTERACAO_PERIODO_PROJETO': 'Prorrogação de Prazo', 'ALTERACOES_PROJETO': 'Alterações do Projeto', 'REMANEJAMENTO': 'Remanejamento', 'SUPLEMENTACAO': 'Suplementação', 'FEITO': 'Feito', 'EM_EXECUCAO': 'Em Execução', 'CANCELADO': 'Cancelado', 'DELIBERACAO': 'Deliberação' },
	      processosPorValidacao: {
	        'RELATORIO_DE_EXECUCAO': ['RELATORIO_DE_EXECUCAO'],
	        'OCORRENCIAS': ['OCORRENCIA_PROJETO', 'OCORRENCIA_ENTIDADE'],
	        'SOLICITACOES': ['PAGAMENTO', 'CONTRAPARTIDA', 'ADIANTAMENTO', 'DEVOLUCAO_DE_ADIANTAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'],
	        'ENTIDADES': ['CADASTRO_ENTIDADES', 'CADASTRO_ENTIDADES_COM_PROJETO'],
	        'AVALIACOES': ['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'],
	        'ALTERACOES_PROJETO': ['ALTERACOES_PROJETO'],
	        'PROPOSTAS': ['PROPOSTA_COMPLETA', 'PROPOSTA_EDITAL'],
	        'PARCEIRO_ESTRATEGICO': []
	      },
	      alturaContentWrapper: window.innerHeight - 51,
	      filtroContrapartida: false
	    };
	  },
	
	  watch: {
	    selecionarTodasTarefas: function selecionarTodasTarefas() {
	      this.selecionarTarefas();
	    },
	    meusFavoritados: function meusFavoritados() {
	      this.filtrar();
	    },
	    minhasTarefas: function minhasTarefas() {
	      this.filtrar();
	    },
	    comProjetos: function comProjetos() {
	      this.filtrar();
	    },
	    somenteComTarefas: function somenteComTarefas() {
	      this.filtrar();
	    },
	    ordenacao: function ordenacao() {
	      this.salvarConfiguracoes();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!_this.ativaGeracaoRemessa) {
	                _.forEach(_this.listaValidacoes, function (processo) {
	                  _.unset(processo, 'LIQUIDACAO_FINANCEIRA');
	                });
	              }
	              _this.validacao = _this.$route.params.fase;
	              _context.next = 4;
	              return _this.listaProcessosEtapas();
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    onChangeFiltroCarteiraContrapartida: function onChangeFiltroCarteiraContrapartida() {
	      var filtro = this.filtroCarteiraContrapartida;
	      if (filtro === '') {
	        this.listaValidacoes.CONTRAPARTIDA.ANALISE = this.listaValidacoesBackup.CONTRAPARTIDA.ANALISE;
	      } else {
	        var itensFiltrados = _.filter(this.listaValidacoesBackup.CONTRAPARTIDA.ANALISE, function (e) {
	          return e.extra.carteira === filtro;
	        });
	        this.listaValidacoes.CONTRAPARTIDA.ANALISE = itensFiltrados;
	      }
	    },
	    selecionarTarefas: function selecionarTarefas() {
	      this.tarefasSelecionadas = [];
	      if (this.selecionarTodasTarefas === 'sim') {
	        var vm = this;
	        _.forEach(this.listaValidacoes, function (processo) {
	          _.forEach(processo, function (atividade) {
	            _.forEach(atividade, function (tarefa) {
	              vm.tarefasSelecionadas.push(tarefa);
	            });
	          });
	        });
	      }
	      this.$forceUpdate();
	    },
	    parametroStringToObject: function parametroStringToObject(listaParametros, parametro) {
	      var valorParametro = _.get(_.last(_.filter(listaParametros, ['parametro', parametro])), 'valor');
	      var valorComAspasDuplas = ('' + valorParametro).replaceAll('\'', '"');
	      return JSON.parse(valorComAspasDuplas);
	    },
	    sinalizaCor: function sinalizaCor(tarefa) {
	      var cor = 'transparent';
	      var dataSolicitacao = (0, _moment2.default)(tarefa.data_solicitacao);
	      var agora = (0, _moment2.default)();
	
	      if (dataSolicitacao.isoWeekday() === 6) {
	        dataSolicitacao.add(2, 'day');
	      } else if (dataSolicitacao.isoWeekday() === 7) {
	        dataSolicitacao.add(1, 'day');
	      } else {
	        dataSolicitacao.add(0, 'day');
	      }
	
	      var dias = agora.startOf('day').diff(dataSolicitacao.startOf('day'), 'days');
	      if (_.includes(['PAGAMENTO', 'ADIANTAMENTO', 'RESSARCIMENTO'], tarefa.nome_processo)) {
	        cor = dias < 4 ? 'var(--cor-verde)' : dias < 6 ? 'var(--cor-amarela)' : 'var(--cor-atencao-dark)';
	      } else if (_.includes(['PRESTACAO_DE_CONTAS', 'DEVOLUCAO_DE_ADIANTAMENTO'], tarefa.nome_processo)) {
	        cor = dias < 9 ? 'var(--cor-verde)' : dias < 13 ? 'var(--cor-amarela)' : 'var(--cor-atencao-dark)';
	      } else if (_.includes(['CONTRAPARTIDA'], tarefa.nomeProcesso)) {
	        cor = dias <= 5 ? 'var(--cor-verde)' : dias <= 15 ? 'var(--cor-amarela)' : 'var(--cor-atencao-dark)';
	      }
	      return cor;
	    },
	    totalTarefas: function totalTarefas(item) {
	      var vm = this;
	      if (_.isArray(item)) {
	        return item.length;
	      } else {
	        var total = 0;
	        _.forEach(_.keys(item), function (i) {
	          total += vm.totalTarefas(item[i]);
	        });
	        return total;
	      }
	    },
	    mostrar: function mostrar(secao, elemento) {
	      console.log(secao, elemento);
	      var mostrarSecao = secao === 'processo' ? this.mostrarProcesso : this.mostrarAtividade;
	      if (_.isUndefined(_.find(mostrarSecao, function (s) {
	        return s === elemento;
	      }))) {
	        if (elemento === 'CONTRAPARTIDA') {
	          this.filtroContrapartida = true;
	        }
	        mostrarSecao.push(elemento);
	      } else {
	        if (elemento === 'CONTRAPARTIDA') {
	          this.filtroContrapartida = false;
	        }
	        _.pull(mostrarSecao, elemento);
	      }
	      this.$forceUpdate();
	      this.salvarConfiguracoes();
	    },
	    listaTodosFuncis: function listaTodosFuncis() {
	      var _this2 = this;
	
	      axiosLaravel.post('chamado/listaFuncis').then(function (response) {
	        _this2.funcis = response.data;
	        console.log('all funcis: ', response.data);
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	        _this2.loading.show = false;
	      });
	    },
	    processaString: function processaString(str) {
	      if (str.charAt(0).toLowerCase() === 'f') {
	        str = str.substring(1);
	      }
	
	      str = str.replace(/^0+/, '');
	      return str;
	    },
	    formatarMatricula: function formatarMatricula(matricula) {
	      return 'F' + matricula.toString().padStart(7, '0');
	    },
	    removeAcentos: function removeAcentos(texto) {
	      return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	    },
	    confirmarAtribuicao: function confirmarAtribuicao() {
	      var _this3 = this;
	
	      this.atribuirTarefas();
	      this.funcionarioBusca = '';
	      this.funcionarioEncontrado = null;
	      this.showModal = false;
	      this.mensagemConfirmacao = 'Tarefas atribuídas com sucesso!';
	
	      setTimeout(function () {
	        _this3.mensagemConfirmacao = '';
	      }, 3000);
	    },
	    cancelarAtribuicao: function cancelarAtribuicao() {
	      this.funcionarioBusca = '';
	      this.funcionarioEncontrado = null;
	      this.showModal = false;
	    },
	    buscaFuncionario: function buscaFuncionario() {
	      var _this4 = this;
	
	      if (this.funcionarioBusca) {
	        var regexMatricula = /^f?\d+$/;
	        if (regexMatricula.test(this.funcionarioBusca)) {
	          this.funcionarioBusca = this.processaString(this.funcionarioBusca);
	          var funcionario = this.funcis.find(function (f) {
	            return f.CD_MTC_FUN === _this4.funcionarioBusca;
	          });
	          return funcionario ? { nome: funcionario.ds_nome_usuario, matricula: funcionario.CD_MTC_FUN, id: funcionario.id } : null;
	        } else {
	          this.funcionarioBusca = this.removeAcentos(this.funcionarioBusca);
	          console.log('funcionário sem acentos: ', this.funcionarioBusca);
	          var _funcionario = this.funcis.find(function (f) {
	            return f.ds_nome_usuario.toLowerCase().includes(_this4.funcionarioBusca.toLowerCase());
	          });
	          return _funcionario ? { nome: _funcionario.ds_nome_usuario, matricula: _funcionario.CD_MTC_FUN, id: _funcionario.id } : null;
	        }
	      }
	      return null;
	    },
	    buscarFuncionario: function buscarFuncionario() {
	      this.funcionarioEncontrado = this.buscaFuncionario(this.funcionarioBusca);
	      if (this.funcionarioEncontrado === null) {
	        this.mensagemErro = 'Funcionário não encontrado. Por favor, verifique a informação digitada e tente novamente.';
	        this.$snotify.error(this.mensagemErro);
	      } else {
	        this.mensagemErro = '';
	      }
	    },
	    jsonValido: function jsonValido(json) {
	      try {
	        if (typeof json !== 'string' && (typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) !== 'object') {
	          json = undefined;
	        } else if (typeof json === 'string' && json.length > 0) {
	          json = JSON.parse(json);
	        } else if ((typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) === 'object') {
	          json = JSON.parse((0, _stringify2.default)(json));
	        } else {
	          json = undefined;
	        }
	        json = _.isObjectLike(json) ? json : undefined;
	      } catch (e) {
	        if (e instanceof SyntaxError) {
	          json = undefined;
	        }
	      }
	      return json;
	    },
	    carregarMapaCarteiras: function carregarMapaCarteiras() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (_.isEmpty(_this5.mapaCarteiras)) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	                _context2.next = 4;
	                return axiosLaravel.get('carteira/mapa_projetos/').then(function (response) {
	                  if (_.get(response, 'data.codigo') === 'OK') {
	                    _this5.mapaCarteiras = response.data.retorno || {};
	                  }
	                }).catch(function () {
	                  _this5.mapaCarteiras = {};
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this5);
	      }))();
	    },
	    listaProcessosEtapas: function listaProcessosEtapas() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var vm;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this6.mostraCarregando = true;
	                vm = _this6;
	
	                if (!(_this6.validacao === 'RELATORIO_DE_EXECUCAO')) {
	                  _context4.next = 5;
	                  break;
	                }
	
	                _context4.next = 5;
	                return _this6.carregarMapaCarteiras();
	
	              case 5:
	                _context4.next = 7;
	                return axiosLaravel.get('/processos/totais_validacoes/' + _this6.validacao).then(function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(response) {
	                    var todasTarefas, configuracoes;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            todasTarefas = _.filter(response.data, function (t) {
	                              return _.includes(vm.processosPorValidacao[vm.validacao], t.nome_processo);
	                            });
	
	                            _.forEach(_this6.listaValidacoes, function (lv, key) {
	                              if (!_.includes(vm.processosPorValidacao[vm.validacao], key)) {
	                                _.unset(vm.listaValidacoes, key);
	                              }
	                            });
	                            todasTarefas.forEach(function (item) {
	                              var secao = _this6.listaValidacoes[item.nome_processo][item.nome_tarefa];
	                              if (!_.isUndefined(secao)) {
	                                item['extra'] = _this6.jsonValido(item.extra) || {};
	                                item['extra']['processos'] = _.map(_.get(item.extra.solicitacao, 'processos', []), 'nome');
	
	                                if (item.nome_processo === 'RELATORIO_DE_EXECUCAO') {
	                                  var numeroProjeto = (_.toString(item.projeto).match(/\d+/) || [''])[0];
	                                  item['extra']['carteira'] = vm.mapaCarteiras[numeroProjeto] || null;
	                                }
	                                secao.push(item);
	                              }
	                            });
	
	                            _this6.listaValidacoesBackup = _.cloneDeep(_this6.listaValidacoes);
	
	                            if (_.has(_this6.usuarioLogado, 'configuracoes') && _.has(_this6.usuarioLogado.configuracoes, 'tela_validacao')) {
	                              configuracoes = _this6.usuarioLogado.configuracoes.tela_validacao;
	
	                              _this6.pesquisa = configuracoes.pesquisa || '';
	                              _this6.mostrarProcesso = configuracoes.mostrarProcesso || [];
	                              _this6.mostrarAtividade = configuracoes.mostrarAtividade || [];
	                              _this6.somenteComTarefas = configuracoes.somenteComTarefas || 'nao';
	                              _this6.meusFavoritados = configuracoes.meusFavoritados || 'nao';
	                              _this6.minhasTarefas = configuracoes.minhasTarefas || 'nao';
	                              _this6.comProjetos = configuracoes.comProjetos || 'nao';
	                              _this6.ordenacao = configuracoes.ordenacao || { por: 'data_solicitacao', ordem: 'asc' };
	                              _this6.filtrar();
	                            }
	                            _this6.mostraCarregando = false;
	
	                          case 6:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this6);
	                  }));
	
	                  return function (_x) {
	                    return _ref.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  console.log('error', error);
	                  _this6.$root.trataErro(error);
	                  _this6.$snotify.clear();
	                });
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this6);
	      }))();
	    },
	    downloadLote: function downloadLote() {
	      var _this7 = this;
	
	      axiosLaravel.post('processos/download/lote', this.listarSelecionados()).then(function (response) {
	        _this7.$forceUpdate();
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    favoritarLote: function favoritarLote(favoritar) {
	      var _this8 = this;
	
	      this.mostraProcessando = true;
	      axiosLaravel.post('processos/validacao/favorito/lote', { 'lista': this.tarefasSelecionadas, 'favoritar': favoritar }).then(function (response) {
	        var vm = _this8;
	        var favorito = favoritar ? 'sim_fav' : 'nao_fav';
	        _.forEach(_this8.listaValidacoes, function (processo) {
	          _.forEach(processo, function (atividade) {
	            _.forEach(atividade, function (tarefa) {
	              if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                tarefa.favoritado = favorito;
	              }
	            });
	          });
	        });
	
	        _this8.tarefasSelecionadas = [];
	        _this8.selecionarTodasTarefas = 'nao';
	        _this8.mostraProcessando = false;
	        _this8.$forceUpdate();
	      }).catch(function (error) {
	        _this8.mostraProcessando = false;
	        _this8.$root.trataErro(error);
	      });
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this9 = this;
	
	      var vm = this;
	      _.set(this.usuarioLogado, 'configuracoes.tela_validacao', {
	        'pesquisa': vm.pesquisa,
	        'mostrarProcesso': _.uniq(vm.mostrarProcesso),
	        'mostrarAtividade': _.uniq(vm.mostrarAtividade),
	        'somenteComTarefas': vm.somenteComTarefas,
	        'meusFavoritados': vm.meusFavoritados,
	        'minhasTarefas': vm.minhasTarefas,
	        'comProjetos': vm.comProjetos,
	        'ordenacao': vm.ordenacao
	      });
	
	      this.listaTodosFuncis();
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {
	        console.log('configuracoes', _this9.usuarioLogado.configuracoes);
	      }).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this9.$root.trataErro(error);
	        }
	      });
	    },
	    filtrar: function filtrar() {
	      var vm = this;
	      this.mostraProcessando = true;
	      var lista = _.cloneDeep(this.listaValidacoesBackup);
	
	      lista = this.minhasTarefas === 'sim' ? this.buscarTermosCampos(lista, ['id_usuario'], [this.usuarioLogado.id]) : lista;
	      console.log(lista);
	      lista = this.meusFavoritados === 'sim' ? this.buscarTermosCampos(lista, ['favoritado'], ['sim_fav']) : lista;
	      lista = this.somenteComTarefas === 'sim' ? this.buscarTermosCampos(lista, [], []) : lista;
	
	      lista = this.minhaCarteira !== '' ? this.buscarTermosCampos(lista, ['extra.carteira'], [this.minhaCarteira]) : lista;
	      lista = this.meusProcessos !== '' ? this.buscarTermosCampos(lista, ['extra.processos'], [this.meusProcessos]) : lista;
	
	      var termos = _.split(_.lowerCase(this.pesquisa), ' ');
	
	      if (termos.length > 0 && _.trim(termos[0]) !== '') {
	        lista = this.buscarTermosCampos(lista, ['nome_processo', 'nome_usuario', 'entidade', 'projeto', 'id_tarefa_atual', 'id_processo', 'id_entidade', 'id_projeto', 'info', 'extra'], _.uniq(termos));
	      }
	      if (this.totalTarefas(lista) === 1) {
	        _.forEach(lista, function (processo, nomeProcesso) {
	          _.forEach(processo, function (atividade, nomeAtividade) {
	            if (atividade.length > 0) {
	              vm.mostrarProcesso.push(nomeProcesso);
	              vm.mostrarAtividade.push(nomeProcesso + '.' + nomeAtividade);
	            }
	          });
	        });
	      }
	
	      this.listaValidacoes = _.cloneDeep(lista);
	      this.mostraProcessando = false;
	      if (this.selecionarTodasTarefas === 'sim') {
	        this.tarefasSelecionadas = [];
	        this.selecionarTarefas();
	      }
	      this.$refs.caixaPesquisa.focus();
	      this.$forceUpdate();
	      this.salvarConfiguracoes();
	    },
	    buscarTermosCampos: function buscarTermosCampos(lista, campos, termos) {
	      var vm = this;
	      _.forEach(lista, function (processo, nomeProcesso) {
	        _.forEach(processo, function (atividade, nomeAtividade) {
	          if (campos.length === 0) {} else if (campos.length === 1) {
	            var busca = [campos[0], termos[0]];
	            processo[nomeAtividade] = _.filter(atividade, busca);
	          } else {
	            _.forEach(atividade, function (tarefa, idxTarefa) {
	              var contador = 0;
	              _.forEach(campos, function (campo) {
	                _.forEach(termos, function (palavra) {
	                  if (_.includes(_.lowerCase(tarefa[campo]), palavra)) {
	                    var idProcesso = lista[nomeProcesso][nomeAtividade][idxTarefa][campo] === lista[nomeProcesso][nomeAtividade][idxTarefa].id_processo;
	                    if (!idProcesso) {
	                      var padrao = new RegExp(palavra, 'gi');
	                      lista[nomeProcesso][nomeAtividade][idxTarefa][campo] = ('' + tarefa[campo]).replace(padrao, '<mark>$&</mark>');
	                    }
	                    contador++;
	                  }
	                });
	              });
	              atividade[idxTarefa]['ocorrenciasFiltro'] = contador++;
	            });
	            processo[nomeAtividade] = _.filter(atividade, function (tarefaFiltrada) {
	              return _.has(tarefaFiltrada, 'ocorrenciasFiltro') && tarefaFiltrada.ocorrenciasFiltro > 0;
	            });
	          }
	          if (vm.somenteComTarefas === 'sim' && _.isEmpty(processo[nomeAtividade])) {
	            _.unset(processo, nomeAtividade);
	          }
	        });
	        if (vm.somenteComTarefas === 'sim' && _.isEmpty(lista[nomeProcesso])) {
	          _.unset(lista, nomeProcesso);
	        }
	      });
	
	      return lista;
	    },
	    atribuirLote: function atribuirLote(atribuir) {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this10.mostraProcessando = true;
	                _context5.next = 3;
	                return axiosLaravel.post('processos/validacao/atribuir/lote', { 'lista': _this10.tarefasSelecionadas, 'atribuir': atribuir }).then(function (response) {
	                  var vm = _this10;
	                  var idUsuario = atribuir ? vm.usuarioLogado.id : null;
	                  var nomeUsuario = atribuir ? vm.usuarioLogado.userName : null;
	                  _.forEach(_this10.listaValidacoes, function (processo) {
	                    _.forEach(processo, function (atividade) {
	                      _.forEach(atividade, function (tarefa) {
	                        if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                          tarefa.id_usuario = idUsuario;
	                          tarefa.nome_usuario = nomeUsuario;
	                          console.log('Tarefa assumida', tarefa);
	                        }
	                      });
	                    });
	                  });
	
	                  _.forEach(_this10.listaValidacoesBackup, function (processo) {
	                    _.forEach(processo, function (atividade) {
	                      _.forEach(atividade, function (tarefa) {
	                        if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                          tarefa.id_usuario = idUsuario;
	                          tarefa.nome_usuario = nomeUsuario;
	                        }
	                      });
	                    });
	                  });
	
	                  _this10.tarefasSelecionadas = [];
	                  _this10.selecionarTodasTarefas = 'nao';
	                  _this10.mostraProcessando = false;
	                  _this10.$forceUpdate();
	                }).catch(function (error) {
	                  _this10.mostraProcessando = false;
	                  _this10.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this10);
	      }))();
	    },
	    atribuirAFunci: function atribuirAFunci(atribuir, matriculaFunci, nomeFunci, idFunci) {
	      var _this11 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this11.mostraProcessando = true;
	                _context6.next = 3;
	                return axiosLaravel.post('processos/validacao/atribuir/funci', { 'lista': _this11.tarefasSelecionadas, 'atribuir': atribuir, 'mat_funci': matriculaFunci, 'nome_funci': nomeFunci, 'id_funci': idFunci }).then(function (response) {
	                  var vm = _this11;
	                  _.forEach(_this11.listaValidacoes, function (processo) {
	                    _.forEach(processo, function (atividade) {
	                      _.forEach(atividade, function (tarefa) {
	                        if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                          tarefa.id_usuario = idFunci;
	                          tarefa.nome_usuario = nomeFunci;
	                          console.log('Tarefa atribuida ao funcionário:', tarefa);
	                        }
	                      });
	                    });
	                  });
	
	                  _.forEach(_this11.listaValidacoesBackup, function (processo) {
	                    _.forEach(processo, function (atividade) {
	                      _.forEach(atividade, function (tarefa) {
	                        if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                          tarefa.id_usuario = idFunci;
	                          tarefa.nome_usuario = nomeFunci;
	                        }
	                      });
	                    });
	                  });
	
	                  _this11.tarefasSelecionadas = [];
	                  _this11.selecionarTodasTarefas = 'nao';
	                  _this11.mostraProcessando = false;
	                  _this11.tarefasSelecionadas = [];
	                  _this11.$forceUpdate();
	                }).catch(function (error) {
	                  console.log(error);
	                  _this11.mostraProcessando = false;
	                  _this11.$root.trataErro(error);
	                });
	
	              case 3:
	                _this11.$forceUpdate();
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this11);
	      }))();
	    },
	    selecionarItem: function selecionarItem(item) {
	      if (_.find(this.tarefasSelecionadas, ['id_processo', item.id_processo])) {
	        _.remove(this.tarefasSelecionadas, function (i) {
	          return i['id_processo'] === item.id_processo;
	        });
	      } else {
	        this.tarefasSelecionadas.push(item);
	      }
	      this.$forceUpdate();
	    },
	    marcaAssumido: function marcaAssumido(_request) {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this12);
	      }))();
	    },
	    retiraAssumido: function retiraAssumido(_request) {
	      var _this13 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this13);
	      }))();
	    },
	    atribuir: function atribuir(item, deveFazer) {
	      var _this14 = this;
	
	      axiosLaravel.put('processos/validacao/assumir/', { 'id_tarefa': item.id_tarefa_atual, 'item': item }).then(function (response) {
	        console.log('Tarefa assumida', _.clone(item));
	        if (deveFazer) {
	          _this14.fazer(item);
	        }
	      }).catch(function (error) {
	        _this14.$root.trataErro(error);
	      });
	    },
	    fazer: function fazer(item) {
	      if (this.validacao === 'PROPOSTAS') {
	        this.$router.push({ name: 'proposta-edita', params: { id: item.id_projeto, row: item, acao: 'VALIDAR', processo: item.nome_tarefa, etapa: item.nome_tarefa } });
	      } else if (this.validacao === 'ENTIDADES') {
	        this.$router.push({ name: 'validacao-entidades', params: { id: item.id_entidade, row: item, acao: 'VALIDAR' } });
	      } else if (this.validacao === 'CADASTRO_PARCEIRO_ESTRATEGICO') {
	        this.$router.push({ name: 'validacao-parceiro', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (this.validacao === 'FLUXO_SIMPLIFICADO') {
	        this.$router.push({ name: 'validacao-inicial', params: { id: item.id_projeto, row: item, acao: 'VALIDAR', processo: item.nome, etapa: item.nome_tarefa } });
	      } else if (item.nome_processo === 'PAGAMENTO') {
	        this.$router.push({ name: 'solicitacao-pagamento', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'CONTRAPARTIDA') {
	        this.$router.push({ name: 'solicitacao-contrapartida', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'ADIANTAMENTO') {
	        this.$router.push({ name: 'solicitacao-adiantamento', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'DEVOLUCAO_DE_ADIANTAMENTO') {
	        this.$router.push({ name: 'solicitacao-devolucao-adiantamento', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'PRESTACAO_DE_CONTAS') {
	        this.$router.push({ name: 'solicitacao-prestacaocontas', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'ALTERACOES_PROJETO') {
	        this.$router.push({ name: 'solicitacao-alteracoes-projeto', params: { id: item.id_processo } });
	      } else if (item.nome_processo === 'RESSARCIMENTO') {
	        this.$router.push({ name: 'solicitacao-ressarcimento', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (this.validacao === 'AVALIACOES') {
	        this.$router.push({ name: 'preenche-formulario', params: { id: _.split(item.extra.link_acesso, '-')[0] } });
	      } else if (this.validacao === 'OCORRENCIAS') {
	        this.$router.push({ name: 'lista-ocorrencias', params: { id: item.id_processo, row: item, voltar: true } });
	      } else if (this.validacao === 'RELATORIO_DE_EXECUCAO') {
	        this.$route.params.idProjeto = item.id_projeto;
	
	        _.set(item, 'data_solicitacao_criada', item.data_solicitacao);
	        _.set(item, 'usuario_id', item.id_usuario);
	        _.set(item, 'id_projeto', item.id_projeto);
	        _.set(item, 'entidade_id', item.id_entidade);
	        _.set(item, 'id_solicitacao', item.id_processo);
	        _.set(item, 'id_tarefa', item.id_tarefa_atual);
	        _.set(item, 'projeto', item.projeto);
	        _.set(item, 'usuario_nome', item.nome_usuario);
	        _.set(item, 'entidade_nome', item.entidade);
	        _.set(item, 'item.numero', !_.isNull(item.projeto) && item.projeto.length > 5 ? item.projeto.substr(0, 5) : '0');
	        _.set(item, 'item.sequencia', 0);
	        _.set(item, 'item.id_proposta', item.id_proposta);
	        _.set(item, 'item.id_relatorio', item.id_relatorio);
	        this.$router.push({ name: 'edita-relatorio-execucao', params: { id: item.id_projeto, row: item, acao: 'VALIDAR' } });
	      } else {
	        this.$root.trataErro('Não é possível abrir essa tarefa. Entre em contato com o Administrador do sistema!');
	      }
	    },
	    atribuirTarefas: function atribuirTarefas() {
	      var _this15 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (_this15.funcionarioEncontrado) {
	                  _context9.next = 3;
	                  break;
	                }
	
	                alert('Por favor, selecione um funcionário válido antes de confirmar.');
	                return _context9.abrupt('return');
	
	              case 3:
	                _this15.atribuirAFunci(true, _this15.funcionarioEncontrado.matricula, _this15.funcionarioEncontrado.nome, _this15.funcionarioEncontrado.id);
	                _this15.showModal = false;
	                _this15.$forceUpdate();
	
	              case 6:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this15);
	      }))();
	    },
	    verificarAtribuicao: function verificarAtribuicao(item) {
	      var _this16 = this;
	
	      var copiaItem = _.cloneDeep(item);
	      var padrao = new RegExp('<(mark|/mark|br|p|/p)[^>]{0,}>', 'gi');
	      _.forEach(item, function (valor, parametro) {
	        item[parametro] = _.isNull(valor) ? null : ('' + valor).replace(padrao, '');
	      });
	      if (_.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO', 'OCORRENCIA_PROJETO', 'OCORRENCIA_ENTIDADE'], item.nome_processo)) {
	        item.extra = copiaItem.extra;
	      }
	      if (_.isNull(item.id_usuario) || '' + item.id_usuario === 'null') {
	        this.atribuir(item, true);
	      } else if ('' + item.id_usuario === '' + this.usuarioLogado.id) {
	        this.fazer(item);
	      } else if (!_.isNull(item.id_usuario) && '' + item.id_usuario !== 'null' && '' + item.id_usuario !== '' + this.usuarioLogado.id) {
	        this.$dialog.confirm('A tarefa será atribuída para <b>' + item.nome_usuario + '</b><br/>Deseja continuar ?', { html: true, animation: 'fade', customClass: 'avisoAlerta', okText: 'Sim', cancelText: 'Não' }).then(function (dialog) {
	          if (confirm) {
	            _this16.atribuir(item, true);
	          }
	        }).catch(function () {
	          console.log('Cancelou atribuição de tarefa com outro usuário');
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaValidacaoSolicitacoesFinanceiras',
	  data: function data() {
	    return {
	      processoSelecionadoCarregar: '',
	      carteiras: ['AABB Comunidade', 'Agroecologia', 'Agroindústria/MUTS', 'Educação para o Futuro', 'Estratégicos', 'Resíduos Sólidos/Água/BTS', 'Ajuda Humanitária', 'Meio Ambiente e Renda', 'Saúde e Bem-Estar', 'Voluntariado'],
	      ativaGeracaoRemessa: true,
	      filtroCarteiraContrapartida: '',
	      selecionarTodasTarefas: 'nao',
	      somenteComTarefas: 'nao',
	      meusFavoritados: 'nao',
	      minhasTarefas: 'nao',
	      comProjetos: 'nao',
	      minhaCarteira: '',
	      meusProcessos: '',
	      funcis: [],
	      ordenacao: {
	        por: 'data_solicitacao',
	        ordem: 'asc'
	      },
	      tiposProcessos: ['PAGAMENTO', 'RESSARCIMENTO', 'ADIANTAMENTO', 'PRESTACAO_DE_CONTAS', 'DEVOLUCAO_DE_ADIANTAMENTO', 'CONTRAPARTIDA'],
	      processos: [],
	      tarefas: [],
	      excel_campos: {
	        'ID': 'id_processo',
	        'Processo': 'nome_processo',
	        'Atividade': 'nome_tarefa',
	        'Entidade': 'entidade',
	        'Projeto': 'projeto',
	        'Atribuido': 'nome_usuario',
	        'Informacoes': 'info',
	        'Valor': 'valor',
	        'Data de Criação': 'data_solicitacao'
	      },
	      excel_meta: [[{ 'key': 'charset', 'value': 'utf-8' }]],
	      validacao: '',
	      mostraCarregando: true,
	      mostraProcessando: false,
	      showModal: false,
	      funcionarioBusca: '',
	      funcionarioEncontrado: null,
	      tarefasSelecionadas: [],
	      mostrarProcesso: [],
	      mostrarAtividade: [],
	      listaValidacoesBackup: {},
	      listaValidacoes: {
	        PAGAMENTO: {
	          ANALISE: [],
	          ANALISE_TRIBUTARIA: [],
	          AUTORIZACAO: [],
	          LIQUIDACAO_FINANCEIRA: []
	        },
	        RESSARCIMENTO: {
	          ANALISE: [],
	          ANALISE_TRIBUTARIA: [],
	          AUTORIZACAO: [],
	          LIQUIDACAO_FINANCEIRA: []
	        },
	        ADIANTAMENTO: {
	          ANALISE: [],
	          AUTORIZACAO: [],
	          LIQUIDACAO_FINANCEIRA: []
	        },
	        PRESTACAO_DE_CONTAS: {
	          ANALISE: [],
	          ANALISE_TRIBUTARIA: [],
	          AUTORIZACAO: []
	        },
	
	        DEVOLUCAO_DE_ADIANTAMENTO: {
	          ANALISE: [],
	          ANALISE_FINANCEIRA: []
	        },
	        CONTRAPARTIDA: {
	          ANALISE: []
	        }
	      },
	      dadosHistorico: {
	        fk_processo: null,
	        id: null,
	        fk_usuario: null,
	        nome: null,
	        situacao: 'PADRAO',
	        inicio: null,
	        termino: null,
	        data_edicao: null,
	        tipo: null,
	        proxima_etapa: null,
	        etapa_anterior: null,
	        observacao: null
	      },
	      pesquisa: '',
	      opcoes: '',
	
	      enumeradores: { 'PROPOSTA_EDITAL': 'Editais', 'PROPOSTA_COMPLETA': 'Prospecção Direta', 'PAGAMENTO': 'Pagamento', 'RELATORIO_DE_EXECUCAO': 'Relatório de Execução', 'FLUXO_SIMPLIFICADO': 'Fluxo Simplificado', 'DEFERIMENTO': 'Deferimento', 'FORMALIZACAO': 'Formalização', 'APROVACAO_PROJETO': 'Aprovação de projetos', 'CONTRAPARTIDA': 'Contrapartida', 'ADIANTAMENTO': 'Adiantamento', 'DEVOLUCAO_DE_ADIANTAMENTO': 'Devolução de Adiantamento', 'PRESTACAO_DE_CONTAS': 'Prestação de Contas', 'CADASTRO_ENTIDADES': 'Cadastramento de Entidades', 'CADASTRO_ENTIDADES_COM_PROJETO': 'Entidades com projetos aprovados', 'ANALISE': 'Análise', 'PRIMEIRA_APROVACAO': 'Primeira Aprovação', 'SEGUNDA_APROVACAO': 'Segunda Aprovação', 'PENDENCIAS': 'Pendências', 'AUTORIZACAO': 'Autorização', 'ANALISE_FINANCEIRA': 'Acerto Contábil', 'ANALISE_TRIBUTARIA': 'Análise Tributária', 'LIQUIDACAO_FINANCEIRA': 'Liquidação', 'REVISAO': 'Revisão', 'APROVACAO': 'Aprovação', 'ENTIDADES': 'Entidades', 'PROPOSTAS': 'Contratação de projetos', 'SOLICITACOES': 'Execução financeira', 'RESSARCIMENTO': 'Ressarcimento', 'AVALIACOES': 'Avaliações de projeto', 'AVALIACAO_APROVACAO': 'Marco zero', 'AVALIACAO_ENCERRAMENTO': 'Marco um', 'SOLICITACAO': 'Em preenchimento', 'OCORRENCIAS': 'Ocorrências', 'OCORRENCIA_PROJETO': 'Ocorrência em projetos', 'OCORRENCIA_ENTIDADE': 'Ocorrência em entidade', 'AGUARDA_BAIXA': 'Baixa', 'AGUARDA_APROVACAO': 'Aprovação', 'FLEXIBILIZACAO': 'Flexibilização', 'ALTERACAO_ATIVIDADES': 'Atividades', 'ALTERACAO_ATIVIDADES_GANTT': 'Atividades (via Gantt)', 'ALTERACAO_METAS': 'Metas', 'ALTERACAO_MUNICIPIOS': 'Municípios', 'ALTERACAO_PARCELAS_ADIANTAMENTO': 'Parcelas de Adiantamento', 'ALTERACAO_PERIODO_PROJETO': 'Prorrogação de Prazo', 'ALTERACOES_PROJETO': 'Alterações do Projeto', 'REMANEJAMENTO': 'Remanejamento', 'SUPLEMENTACAO': 'Suplementação', 'FEITO': 'Feito', 'EM_EXECUCAO': 'Em Execução', 'CANCELADO': 'Cancelado', 'DELIBERACAO': 'Deliberação' },
	      processosPorValidacao: {
	        'RELATORIO_DE_EXECUCAO': ['RELATORIO_DE_EXECUCAO'],
	        'OCORRENCIAS': ['OCORRENCIA_PROJETO', 'OCORRENCIA_ENTIDADE'],
	        'SOLICITACOES': ['PAGAMENTO', 'CONTRAPARTIDA', 'ADIANTAMENTO', 'DEVOLUCAO_DE_ADIANTAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'],
	        'ENTIDADES': ['CADASTRO_ENTIDADES', 'CADASTRO_ENTIDADES_COM_PROJETO'],
	        'AVALIACOES': ['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'],
	        'ALTERACOES_PROJETO': ['ALTERACOES_PROJETO'],
	        'PROPOSTAS': ['PROPOSTA_COMPLETA', 'PROPOSTA_EDITAL'],
	        'PARCEIRO_ESTRATEGICO': []
	      },
	      alturaContentWrapper: window.innerHeight - 51,
	      filtroContrapartida: false,
	      totalGeral: [],
	      carregamentoAutomatico: []
	    };
	  },
	
	  watch: {
	    selecionarTodasTarefas: function selecionarTodasTarefas() {
	      this.selecionarTarefas();
	    },
	    meusFavoritados: function meusFavoritados() {
	      this.filtrar();
	    },
	    minhasTarefas: function minhasTarefas() {
	      this.filtrar();
	    },
	    comProjetos: function comProjetos() {
	      this.filtrar();
	    },
	    somenteComTarefas: function somenteComTarefas() {
	      this.filtrar();
	    },
	    ordenacao: function ordenacao() {
	      this.salvarConfiguracoes();
	    }
	  },
	  computed: (0, _extends3.default)({
	    farolFinanceiroCurtoPrazo: function farolFinanceiroCurtoPrazo() {
	      return this.contarTarefasPorFaixa(['PAGAMENTO', 'RESSARCIMENTO', 'ADIANTAMENTO']);
	    },
	    farolFinanceiroLongoPrazo: function farolFinanceiroLongoPrazo() {
	      return this.contarTarefasPorFaixa(['PRESTACAO_DE_CONTAS', 'DEVOLUCAO_DE_ADIANTAMENTO']);
	    },
	    tituloFarolExecucaoFinanceira: function tituloFarolExecucaoFinanceira() {
	      return '' + '<h5 style="text-align:left">' + '<b>Pagamento, Ressarcimento e Adiantamento*</b><br>' + '<span style="text-align:left">' + '<p></p>' + '<p><i class="fa fa-square" style="color:#218D1E"></i> até 3 dias úteis (' + this.farolFinanceiroCurtoPrazo.verde + ' itens)</p>' + '<p><i class="fa fa-square" style="color:#DBC112"></i> de 4 a 5 dias úteis (' + this.farolFinanceiroCurtoPrazo.amarelo + ' itens)</p>' + '<p><i class="fa fa-square" style="color:#A3100F"></i> a partir do 6º dia útil (' + this.farolFinanceiroCurtoPrazo.vermelho + ' itens)</p>' + '<hr>' + '</span>' + '</h5>' + '<h5 style="text-align:left">' + '<b>Prestação de Contas e Devolução de Adiantamento*</b><br>' + '<span style="text-align:left">' + '<p></p>' + '<p><i class="fa fa-square" style="color:#218D1E"></i> até 6 dias úteis (' + this.farolFinanceiroLongoPrazo.verde + ' itens)</p>' + '<p><i class="fa fa-square" style="color:#DBC112"></i> de 7 a 10 dias úteis (' + this.farolFinanceiroLongoPrazo.amarelo + ' itens)</p>' + '<p><i class="fa fa-square" style="color:#A3100F"></i> a partir do 11º dia útil (' + this.farolFinanceiroLongoPrazo.vermelho + ' itens)</p>' + '<hr>' + '</span>' + '</h5>' + '<h5><p><b>*por limitações técnicas, os feriados são computados como dias úteis</b></p></h5>';
	    }
	  }, (0, _vuex.mapGetters)(['usuarioLogado', 'urlLaravel'])),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!_this.ativaGeracaoRemessa) {
	                _.forEach(_this.listaValidacoes, function (processo) {
	                  _.unset(processo, 'LIQUIDACAO_FINANCEIRA');
	                });
	              }
	              _this.validacao = _this.$route.params.fase;
	
	              _this.mostraCarregando = false;
	              _context.next = 5;
	              return _this.carregaTudo();
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    onChangeFiltroCarteiraContrapartida: function onChangeFiltroCarteiraContrapartida() {
	      var filtro = this.filtroCarteiraContrapartida;
	      if (filtro === '') {
	        this.listaValidacoes.CONTRAPARTIDA.ANALISE = this.listaValidacoesBackup.CONTRAPARTIDA.ANALISE;
	      } else {
	        var itensFiltrados = _.filter(this.listaValidacoesBackup.CONTRAPARTIDA.ANALISE, function (e) {
	          return e.extra.carteira === filtro;
	        });
	        this.listaValidacoes.CONTRAPARTIDA.ANALISE = itensFiltrados;
	      }
	    },
	    carregaAutomaticos: function carregaAutomaticos() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var i;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!(_this2.carregamentoAutomatico.length <= 0)) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	                i = 0;
	
	              case 3:
	                if (!(i < _this2.carregamentoAutomatico.length)) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                _this2.processoSelecionadoCarregar = _this2.carregamentoAutomatico[i];
	                _context2.next = 7;
	                return _this2.carregaTarefasProcesso();
	
	              case 7:
	                i++;
	                _context2.next = 3;
	                break;
	
	              case 10:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    toggleCarregamentoAutomatico: function toggleCarregamentoAutomatico(valor, checked) {
	      if (checked) {
	        this.adicionarCarregamentoAutomatico(valor);
	      } else {
	        this.removerCarregamentoAutomatico(valor);
	      }
	    },
	    adicionarCarregamentoAutomatico: function adicionarCarregamentoAutomatico(valor) {
	      if (!this.carregamentoAutomatico.includes(valor)) {
	        this.carregamentoAutomatico.push(valor);
	        this.salvarCarregamentoAutomatico();
	      }
	    },
	    hasCarregamentoAutomatico: function hasCarregamentoAutomatico(valor) {
	      return this.carregamentoAutomatico.includes(valor);
	    },
	    removerCarregamentoAutomatico: function removerCarregamentoAutomatico(valor) {
	      this.carregamentoAutomatico = this.carregamentoAutomatico.filter(function (v) {
	        return v !== valor;
	      });
	      this.salvarCarregamentoAutomatico();
	    },
	    inicializaCarregamentoAutomatico: function inicializaCarregamentoAutomatico() {
	      var salvo = localStorage.getItem('carregamentoAutomatico');
	      if (salvo) {
	        var parsed = JSON.parse(salvo);
	        if (Array.isArray(parsed) && parsed.length > 0) {
	          this.carregamentoAutomatico = parsed;
	          return;
	        }
	      }
	
	      localStorage.setItem('carregamentoAutomatico', (0, _stringify2.default)(this.carregamentoAutomatico));
	    },
	    salvarCarregamentoAutomatico: function salvarCarregamentoAutomatico() {
	      localStorage.setItem('carregamentoAutomatico', (0, _stringify2.default)(this.carregamentoAutomatico));
	    },
	    handleButtonCarregar: function handleButtonCarregar(tipoProcesso) {
	      if (this.existeLista(tipoProcesso)) {
	        this.processoSelecionadoCarregar = tipoProcesso;
	        this.carregaTarefasProcesso();
	      }
	      this.$forceUpdate();
	    },
	    existeLista: function existeLista(tipoProcesso) {
	      var index = this.tiposProcessos.indexOf(tipoProcesso);
	      if (index !== -1) {
	        return true;
	      }
	      return false;
	    },
	    selecionarTarefas: function selecionarTarefas() {
	      this.tarefasSelecionadas = [];
	      if (this.selecionarTodasTarefas === 'sim') {
	        var vm = this;
	        _.forEach(this.listaValidacoes, function (processo) {
	          _.forEach(processo, function (atividade) {
	            _.forEach(atividade, function (tarefa) {
	              vm.tarefasSelecionadas.push(tarefa);
	            });
	          });
	        });
	      }
	      this.$forceUpdate();
	    },
	    parametroStringToObject: function parametroStringToObject(listaParametros, parametro) {
	      var valorParametro = _.get(_.last(_.filter(listaParametros, ['parametro', parametro])), 'valor');
	      var valorComAspasDuplas = ('' + valorParametro).replaceAll('\'', '"');
	      return JSON.parse(valorComAspasDuplas);
	    },
	    totalTarefas: function totalTarefas(item) {
	      var vm = this;
	      if (_.isNil(item)) {
	        return 0;
	      }
	      if (_.isArray(item)) {
	        return item.length;
	      }
	      if (_.isObject(item)) {
	        var total = 0;
	        _.forEach(_.keys(item), function (chave) {
	          total += vm.totalTarefas(item[chave]);
	        });
	        return total;
	      }
	      return 0;
	    },
	    coletarTarefas: function coletarTarefas(item) {
	      var vm = this;
	      var tarefas = [];
	
	      if (_.isNil(item)) {
	        return tarefas;
	      }
	
	      if (_.isArray(item)) {
	        return item;
	      }
	
	      if (_.isObject(item)) {
	        _.forEach(_.keys(item), function (chave) {
	          tarefas = tarefas.concat(vm.coletarTarefas(item[chave]));
	        });
	      }
	
	      return tarefas;
	    },
	    listarTarefasPorProcessos: function listarTarefasPorProcessos(processos) {
	      var _this3 = this;
	
	      var tarefas = [];
	
	      _.forEach(processos, function (processo) {
	        var grupo = _.get(_this3, 'listaValidacoes.' + processo, {});
	        tarefas = tarefas.concat(_this3.coletarTarefas(grupo));
	      });
	
	      return tarefas;
	    },
	    obterDataBaseTarefa: function obterDataBaseTarefa(tarefa) {
	      var valorData = _.get(tarefa, 'data_solicitacao') || _.get(tarefa, 'inicio') || null;
	
	      if (!valorData) {
	        return null;
	      }
	
	      var formatos = ['YYYY-MM-DD HH:mm:ss.SSS', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD'];
	
	      var data = (0, _moment2.default)(valorData, formatos, true);
	
	      if (!data.isValid()) {
	        data = (0, _moment2.default)(valorData);
	      }
	
	      return data.isValid() ? data.startOf('day') : null;
	    },
	    classificaPrazo: function classificaPrazo(tarefa) {
	      var dataBase = this.obterDataBaseTarefa(tarefa);
	      var agora = (0, _moment2.default)().startOf('day');
	
	      if (!dataBase) {
	        return null;
	      }
	
	      var dataInicioPrazo = dataBase.clone().add(1, 'day');
	
	      if (dataInicioPrazo.isoWeekday() === 6) {
	        dataInicioPrazo.add(2, 'day');
	      }
	
	      if (dataInicioPrazo.isoWeekday() === 7) {
	        dataInicioPrazo.add(1, 'day');
	      }
	
	      var dias = agora.diff(dataInicioPrazo.clone().startOf('day'), 'days');
	
	      if (_.includes(['PAGAMENTO', 'ADIANTAMENTO', 'RESSARCIMENTO'], tarefa.nome_processo)) {
	        return dias < 4 ? 'verde' : dias < 6 ? 'amarelo' : 'vermelho';
	      } else if (_.includes(['PRESTACAO_DE_CONTAS', 'DEVOLUCAO_DE_ADIANTAMENTO'], tarefa.nome_processo)) {
	        return dias < 9 ? 'verde' : dias < 13 ? 'amarelo' : 'vermelho';
	      } else if (_.includes(['CONTRAPARTIDA'], tarefa.nome_processo)) {
	        return dias <= 5 ? 'verde' : dias <= 15 ? 'amarelo' : 'vermelho';
	      }
	
	      return null;
	    },
	    sinalizaCor: function sinalizaCor(tarefa) {
	      var faixa = this.classificaPrazo(tarefa);
	
	      if (faixa === 'verde') {
	        return 'var(--cor-verde)';
	      }
	
	      if (faixa === 'amarelo') {
	        return 'var(--cor-amarela)';
	      }
	
	      if (faixa === 'vermelho') {
	        return 'var(--cor-atencao-dark)';
	      }
	
	      return 'transparent';
	    },
	    contarTarefasPorFaixa: function contarTarefasPorFaixa(processos) {
	      var _this4 = this;
	
	      var totais = {
	        verde: 0,
	        amarelo: 0,
	        vermelho: 0
	      };
	
	      var tarefas = this.listarTarefasPorProcessos(processos);
	
	      _.forEach(tarefas, function (tarefa) {
	        var faixa = _this4.classificaPrazo(tarefa);
	        if (faixa === 'verde') {
	          totais.verde++;
	        } else if (faixa === 'amarelo') {
	          totais.amarelo++;
	        } else if (faixa === 'vermelho') {
	          totais.vermelho++;
	        } else {
	          totais.semData++;
	        }
	      });
	
	      return totais;
	    },
	    totalTarefasExecucaoFinanceira: function totalTarefasExecucaoFinanceira() {
	      var _this5 = this;
	
	      var total = 0;
	
	      var tipos = ['PAGAMENTO', 'RESSARCIMENTO', 'ADIANTAMENTO', 'PRESTACAO_DE_CONTAS', 'DEVOLUCAO_DE_ADIANTAMENTO'];
	
	      _.forEach(tipos, function (tipo) {
	        total += _this5.totalTarefas(_.get(_this5, 'listaValidacoes.' + tipo, {}));
	      });
	
	      return total;
	    },
	    totalTarefasGeral: function totalTarefasGeral(item) {
	      var total = 0;
	      if (this.totalGeral.length > 0) {
	        this.totalGeral.forEach(function (processo) {
	          if (item === processo.nome_processo) {
	            total = processo.total;
	          }
	        });
	      }
	      return total;
	    },
	    totalTarefasPrestacaoContasAte500: function totalTarefasPrestacaoContasAte500() {
	      var total500 = 0;
	      var grupos = _.get(this, 'listaValidacoes.PRESTACAO_DE_CONTAS', {});
	      var tipos = ['ANALISE', 'ANALISE_TRIBUTARIA', 'AUTORIZACAO'];
	      _.forEach(tipos, function (tipo) {
	        var lista = _.get(grupos, tipo, []);
	        if (_.isArray(lista)) {
	          _.forEach(lista, function (item) {
	            var valor = parseFloat(String(_.get(item, 'valor', 0)).replace(',', '.'));
	            if (!isNaN(valor) && valor <= 500) {
	              total500 += 1;
	            }
	          });
	        }
	      });
	      return total500;
	    },
	    contarSemaforoPorAtividade: function contarSemaforoPorAtividade(processo, atividade) {
	      var _this6 = this;
	
	      var totais = {
	        verde: 0,
	        amarelo: 0,
	        vermelho: 0
	      };
	
	      var tarefas = _.get(this, 'listaValidacoes.' + processo + '.' + atividade, []);
	
	      if (!_.isArray(tarefas)) {
	        return totais;
	      }
	
	      _.forEach(tarefas, function (tarefa) {
	        var faixa = _this6.classificaPrazo(tarefa);
	
	        if (faixa === 'verde') {
	          totais.verde++;
	        } else if (faixa === 'amarelo') {
	          totais.amarelo++;
	        } else if (faixa === 'vermelho') {
	          totais.vermelho++;
	        }
	      });
	
	      return totais;
	    },
	    montaResumoSemaforoAtividade: function montaResumoSemaforoAtividade(processo, atividade) {
	      var totais1 = this.contarSemaforoPorAtividade(processo, atividade);
	
	      return '<span style="margin-left: 15px;">Prazo</span>' + '<span style="margin-left: 6px; white-space: nowrap;">' + '<i class="fa fa-square" style="color:#218D1E; margin-left: 4px;"></i> ' + totais1.verde + '<i class="fa fa-square" style="color:#DBC112; margin-left: 8px;"></i> ' + totais1.amarelo + '<i class="fa fa-square" style="color:#A3100F; margin-left: 8px;"></i> ' + totais1.vermelho + '</span>';
	    },
	    mostrar: function mostrar(secao, elemento) {
	      var mostrarSecao = secao === 'processo' ? this.mostrarProcesso : this.mostrarAtividade;
	      if (_.isUndefined(_.find(mostrarSecao, function (s) {
	        return s === elemento;
	      }))) {
	        if (elemento === 'CONTRAPARTIDA') {
	          this.filtroContrapartida = true;
	        }
	        mostrarSecao.push(elemento);
	      } else {
	        if (elemento === 'CONTRAPARTIDA') {
	          this.filtroContrapartida = false;
	        }
	        _.pull(mostrarSecao, elemento);
	      }
	      this.$forceUpdate();
	      this.salvarConfiguracoes();
	    },
	    listaTodosFuncis: function listaTodosFuncis() {
	      var _this7 = this;
	
	      axiosLaravel.post('chamado/listaFuncis').then(function (response) {
	        _this7.funcis = response.data;
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	        _this7.loading.show = false;
	      });
	    },
	    processaString: function processaString(str) {
	      if (str.charAt(0).toLowerCase() === 'f') {
	        str = str.substring(1);
	      }
	
	      str = str.replace(/^0+/, '');
	      return str;
	    },
	    formatarMatricula: function formatarMatricula(matricula) {
	      return 'F' + matricula.toString().padStart(7, '0');
	    },
	    removeAcentos: function removeAcentos(texto) {
	      return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	    },
	    confirmarAtribuicao: function confirmarAtribuicao() {
	      var _this8 = this;
	
	      this.atribuirTarefas();
	      this.funcionarioBusca = '';
	      this.funcionarioEncontrado = null;
	      this.showModal = false;
	      this.mensagemConfirmacao = 'Tarefas atribuídas com sucesso!';
	
	      setTimeout(function () {
	        _this8.mensagemConfirmacao = '';
	      }, 3000);
	    },
	    cancelarAtribuicao: function cancelarAtribuicao() {
	      this.funcionarioBusca = '';
	      this.funcionarioEncontrado = null;
	      this.showModal = false;
	    },
	    buscaFuncionario: function buscaFuncionario() {
	      var _this9 = this;
	
	      if (this.funcionarioBusca) {
	        var regexMatricula = /^f?\d+$/;
	        if (regexMatricula.test(this.funcionarioBusca)) {
	          this.funcionarioBusca = this.processaString(this.funcionarioBusca);
	          var funcionario = this.funcis.find(function (f) {
	            return f.CD_MTC_FUN === _this9.funcionarioBusca;
	          });
	          return funcionario ? { nome: funcionario.ds_nome_usuario, matricula: funcionario.CD_MTC_FUN, id: funcionario.id } : null;
	        } else {
	          this.funcionarioBusca = this.removeAcentos(this.funcionarioBusca);
	
	          var _funcionario = this.funcis.find(function (f) {
	            return f.ds_nome_usuario.toLowerCase().includes(_this9.funcionarioBusca.toLowerCase());
	          });
	          return _funcionario ? { nome: _funcionario.ds_nome_usuario, matricula: _funcionario.CD_MTC_FUN, id: _funcionario.id } : null;
	        }
	      }
	      return null;
	    },
	    buscarFuncionario: function buscarFuncionario() {
	      this.funcionarioEncontrado = this.buscaFuncionario(this.funcionarioBusca);
	      if (this.funcionarioEncontrado === null) {
	        this.mensagemErro = 'Funcionário não encontrado. Por favor, verifique a informação digitada e tente novamente.';
	        this.$snotify.error(this.mensagemErro);
	      } else {
	        this.mensagemErro = '';
	      }
	    },
	    jsonValido: function jsonValido(json) {
	      try {
	        if (typeof json !== 'string' && (typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) !== 'object') {
	          json = undefined;
	        } else if (typeof json === 'string' && json.length > 0) {
	          json = JSON.parse(json);
	        } else if ((typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) === 'object') {
	          json = JSON.parse((0, _stringify2.default)(json));
	        } else {
	          json = undefined;
	        }
	        json = _.isObjectLike(json) ? json : undefined;
	      } catch (e) {
	        if (e instanceof SyntaxError) {
	          json = undefined;
	        }
	      }
	      return json;
	    },
	    carregaTarefasProcesso: function carregaTarefasProcesso() {
	      var _this10 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var vm;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this10.mostraCarregando = true;
	                vm = _this10;
	                _context4.next = 4;
	                return axiosLaravel.get('/totalValidacoesPorProcesso/' + _this10.processoSelecionadoCarregar).then(function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(response) {
	                    var todasTarefas, configuracoes, index;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            todasTarefas = _.filter(response.data, function (t) {
	                              return _.includes(vm.processosPorValidacao[vm.validacao], t.nome_processo);
	                            });
	
	                            _.forEach(_this10.listaValidacoes, function (lv, key) {
	                              if (!_.includes(vm.processosPorValidacao[vm.validacao], key)) {
	                                _.unset(vm.listaValidacoes, key);
	                              }
	                            });
	                            todasTarefas.forEach(function (item) {
	                              var secao = _this10.listaValidacoes[item.nome_processo][item.nome_tarefa];
	                              if (!_.isUndefined(secao)) {
	                                item['extra'] = _this10.jsonValido(item.extra) || {};
	                                item['extra']['processos'] = _.map(_.get(item.extra.solicitacao, 'processos', []), 'nome');
	                                secao.push(item);
	                              }
	                            });
	
	                            _this10.listaValidacoesBackup = _.cloneDeep(_this10.listaValidacoes);
	
	                            if (_.has(_this10.usuarioLogado, 'configuracoes') && _.has(_this10.usuarioLogado.configuracoes, 'tela_validacao')) {
	                              configuracoes = _this10.usuarioLogado.configuracoes.tela_validacao;
	
	                              _this10.pesquisa = configuracoes.pesquisa || '';
	                              _this10.mostrarProcesso = configuracoes.mostrarProcesso || [];
	                              _this10.mostrarAtividade = configuracoes.mostrarAtividade || [];
	                              _this10.somenteComTarefas = configuracoes.somenteComTarefas || 'nao';
	                              _this10.meusFavoritados = configuracoes.meusFavoritados || 'nao';
	                              _this10.minhasTarefas = configuracoes.minhasTarefas || 'nao';
	                              _this10.comProjetos = configuracoes.comProjetos || 'nao';
	                              _this10.ordenacao = configuracoes.ordenacao || { por: 'data_solicitacao', ordem: 'asc' };
	                              _this10.filtrar();
	                            }
	                            _this10.mostraCarregando = false;
	                            index = _this10.tiposProcessos.indexOf(_this10.processoSelecionadoCarregar);
	
	                            if (index !== -1) {
	                              _this10.tiposProcessos.splice(index, 1);
	                            }
	                            _this10.processoSelecionadoCarregar = '';
	
	                          case 9:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this10);
	                  }));
	
	                  return function (_x) {
	                    return _ref.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  console.log('error', error);
	                  _this10.$root.trataErro(error);
	                  _this10.$snotify.clear();
	                });
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this10);
	      }))();
	    },
	    carregaTudo: function carregaTudo() {
	      var _this11 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        var vm;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this11.mostraCarregando = true;
	                vm = _this11;
	                _context6.next = 4;
	                return axiosLaravel.get('/totalValidacoesTudo/').then(function () {
	                  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(response) {
	                    var todasTarefas, configuracoes, index;
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            todasTarefas = _.filter(response.data, function (t) {
	                              return _.includes(vm.processosPorValidacao[vm.validacao], t.nome_processo);
	                            });
	
	                            _.forEach(_this11.listaValidacoes, function (lv, key) {
	                              if (!_.includes(vm.processosPorValidacao[vm.validacao], key)) {
	                                _.unset(vm.listaValidacoes, key);
	                              }
	                            });
	                            todasTarefas.forEach(function (item) {
	                              var secao = _this11.listaValidacoes[item.nome_processo][item.nome_tarefa];
	                              if (!_.isUndefined(secao)) {
	                                item['extra'] = _this11.jsonValido(item.extra) || {};
	                                item['extra']['processos'] = _.map(_.get(item.extra.solicitacao, 'processos', []), 'nome');
	                                secao.push(item);
	                              }
	                            });
	
	                            _this11.listaValidacoesBackup = _.cloneDeep(_this11.listaValidacoes);
	
	                            if (_.has(_this11.usuarioLogado, 'configuracoes') && _.has(_this11.usuarioLogado.configuracoes, 'tela_validacao')) {
	                              configuracoes = _this11.usuarioLogado.configuracoes.tela_validacao;
	
	                              _this11.pesquisa = configuracoes.pesquisa || '';
	                              _this11.mostrarProcesso = configuracoes.mostrarProcesso || [];
	                              _this11.mostrarAtividade = configuracoes.mostrarAtividade || [];
	                              _this11.somenteComTarefas = configuracoes.somenteComTarefas || 'nao';
	                              _this11.meusFavoritados = configuracoes.meusFavoritados || 'nao';
	                              _this11.minhasTarefas = configuracoes.minhasTarefas || 'nao';
	                              _this11.comProjetos = configuracoes.comProjetos || 'nao';
	                              _this11.ordenacao = configuracoes.ordenacao || { por: 'data_solicitacao', ordem: 'asc' };
	                              _this11.filtrar();
	                            }
	                            _this11.mostraCarregando = false;
	                            index = _this11.tiposProcessos.indexOf(_this11.processoSelecionadoCarregar);
	
	                            if (index !== -1) {
	                              _this11.tiposProcessos.splice(index, 1);
	                            }
	                            _this11.processoSelecionadoCarregar = '';
	
	                          case 9:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this11);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  console.log('error', error);
	                  _this11.$root.trataErro(error);
	                  _this11.$snotify.clear();
	                });
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this11);
	      }))();
	    },
	    totalGeralProcessos: function totalGeralProcessos() {
	      var _this12 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this12.mostraCarregando = true;
	                _context8.next = 3;
	                return axiosLaravel.get('/totalValidacoesGeral/').then(function () {
	                  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(response) {
	                    return _regenerator2.default.wrap(function _callee7$(_context7) {
	                      while (1) {
	                        switch (_context7.prev = _context7.next) {
	                          case 0:
	                            _this12.totalGeral = response.data;
	                            _this12.mostraCarregando = false;
	
	                          case 2:
	                          case 'end':
	                            return _context7.stop();
	                        }
	                      }
	                    }, _callee7, _this12);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  console.log('error', error);
	                  _this12.$root.trataErro(error);
	                  _this12.$snotify.clear();
	                });
	
	              case 3:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this12);
	      }))();
	    },
	    downloadLote: function downloadLote() {
	      var _this13 = this;
	
	      axiosLaravel.post('processos/download/lote', this.listarSelecionados()).then(function (response) {
	        _this13.$forceUpdate();
	      }).catch(function (error) {
	        _this13.$root.trataErro(error);
	      });
	    },
	    favoritarLote: function favoritarLote(favoritar) {
	      var _this14 = this;
	
	      this.mostraProcessando = true;
	      axiosLaravel.post('processos/validacao/favorito/lote', { 'lista': this.tarefasSelecionadas, 'favoritar': favoritar }).then(function (response) {
	        var vm = _this14;
	        var favorito = favoritar ? 'sim_fav' : 'nao_fav';
	        _.forEach(_this14.listaValidacoes, function (processo) {
	          _.forEach(processo, function (atividade) {
	            _.forEach(atividade, function (tarefa) {
	              if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                tarefa.favoritado = favorito;
	              }
	            });
	          });
	        });
	
	        _this14.tarefasSelecionadas = [];
	        _this14.selecionarTodasTarefas = 'nao';
	        _this14.mostraProcessando = false;
	        _this14.$forceUpdate();
	      }).catch(function (error) {
	        _this14.mostraProcessando = false;
	        _this14.$root.trataErro(error);
	      });
	    },
	    salvarConfiguracoes: function salvarConfiguracoes() {
	      var _this15 = this;
	
	      var vm = this;
	      _.set(this.usuarioLogado, 'configuracoes.tela_validacao', {
	        'pesquisa': vm.pesquisa,
	        'mostrarProcesso': _.uniq(vm.mostrarProcesso),
	        'mostrarAtividade': _.uniq(vm.mostrarAtividade),
	        'somenteComTarefas': vm.somenteComTarefas,
	        'meusFavoritados': vm.meusFavoritados,
	        'minhasTarefas': vm.minhasTarefas,
	        'comProjetos': vm.comProjetos,
	        'ordenacao': vm.ordenacao
	      });
	
	      this.listaTodosFuncis();
	      axiosLaravel.post('/usuario/configuracoes', { 'configuracoes': this.usuarioLogado.configuracoes }).then(function (response) {}).catch(function (error) {
	        if (error) {
	          console.log('error', error);
	          _this15.$root.trataErro(error);
	        }
	      });
	    },
	    filtrar: function filtrar() {
	      var vm = this;
	      this.mostraProcessando = true;
	      var lista = _.cloneDeep(this.listaValidacoesBackup);
	
	      lista = this.minhasTarefas === 'sim' ? this.buscarTermosCampos(lista, ['id_usuario'], [this.usuarioLogado.id]) : lista;
	      lista = this.meusFavoritados === 'sim' ? this.buscarTermosCampos(lista, ['favoritado'], ['sim_fav']) : lista;
	      lista = this.somenteComTarefas === 'sim' ? this.buscarTermosCampos(lista, [], []) : lista;
	
	      lista = this.minhaCarteira !== '' ? this.buscarTermosCampos(lista, ['extra.carteira'], [this.minhaCarteira]) : lista;
	      lista = this.meusProcessos !== '' ? this.buscarTermosCampos(lista, ['extra.processos'], [this.meusProcessos]) : lista;
	
	      var termos = _.split(_.lowerCase(this.pesquisa), ' ');
	
	      if (termos.length > 0 && _.trim(termos[0]) !== '') {
	        lista = this.buscarTermosCampos(lista, ['nome_processo', 'nome_usuario', 'entidade', 'projeto', 'id_tarefa_atual', 'id_processo', 'id_entidade', 'id_projeto', 'info', 'extra'], _.uniq(termos));
	      }
	      if (this.totalTarefas(lista) === 1) {
	        _.forEach(lista, function (processo, nomeProcesso) {
	          _.forEach(processo, function (atividade, nomeAtividade) {
	            if (atividade.length > 0) {
	              vm.mostrarProcesso.push(nomeProcesso);
	              vm.mostrarAtividade.push(nomeProcesso + '.' + nomeAtividade);
	            }
	          });
	        });
	      }
	
	      this.listaValidacoes = _.cloneDeep(lista);
	      this.mostraProcessando = false;
	      if (this.selecionarTodasTarefas === 'sim') {
	        this.tarefasSelecionadas = [];
	        this.selecionarTarefas();
	      }
	      this.$refs.caixaPesquisa.focus();
	      this.$forceUpdate();
	      this.salvarConfiguracoes();
	    },
	    buscarTermosCampos: function buscarTermosCampos(lista, campos, termos) {
	      var vm = this;
	      _.forEach(lista, function (processo, nomeProcesso) {
	        _.forEach(processo, function (atividade, nomeAtividade) {
	          if (campos.length === 0) {} else if (campos.length === 1) {
	            var busca = [campos[0], termos[0]];
	            processo[nomeAtividade] = _.filter(atividade, busca);
	          } else {
	            _.forEach(atividade, function (tarefa, idxTarefa) {
	              var contador = 0;
	              _.forEach(campos, function (campo) {
	                _.forEach(termos, function (palavra) {
	                  if (_.includes(_.lowerCase(tarefa[campo]), palavra)) {
	                    var idProcesso = lista[nomeProcesso][nomeAtividade][idxTarefa][campo] === lista[nomeProcesso][nomeAtividade][idxTarefa].id_processo;
	                    if (!idProcesso) {
	                      var padrao = new RegExp(palavra, 'gi');
	                      lista[nomeProcesso][nomeAtividade][idxTarefa][campo] = ('' + tarefa[campo]).replace(padrao, '<mark>$&</mark>');
	                    }
	                    contador++;
	                  }
	                });
	              });
	              atividade[idxTarefa]['ocorrenciasFiltro'] = contador++;
	            });
	            processo[nomeAtividade] = _.filter(atividade, function (tarefaFiltrada) {
	              return _.has(tarefaFiltrada, 'ocorrenciasFiltro') && tarefaFiltrada.ocorrenciasFiltro > 0;
	            });
	          }
	          if (vm.somenteComTarefas === 'sim' && _.isEmpty(processo[nomeAtividade])) {
	            _.unset(processo, nomeAtividade);
	          }
	        });
	        if (vm.somenteComTarefas === 'sim' && _.isEmpty(lista[nomeProcesso])) {
	          _.unset(lista, nomeProcesso);
	        }
	      });
	
	      return lista;
	    },
	    atribuirLote: function atribuirLote(atribuir) {
	      var _this16 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _this16.mostraProcessando = true;
	                _context9.next = 3;
	                return axiosLaravel.post('processos/validacao/atribuir/lote', { 'lista': _this16.tarefasSelecionadas, 'atribuir': atribuir }).then(function (response) {
	                  var vm = _this16;
	
	                  var idUsuario = atribuir ? vm.usuarioLogado.id : null;
	                  var nomeUsuario = atribuir ? vm.usuarioLogado.userName : null;
	                  _.forEach(_this16.listaValidacoes, function (processo) {
	                    _.forEach(processo, function (atividade) {
	                      _.forEach(atividade, function (tarefa) {
	                        if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                          tarefa.id_usuario = idUsuario;
	                          tarefa.nome_usuario = nomeUsuario;
	                        }
	                      });
	                    });
	                  });
	
	                  _.forEach(_this16.listaValidacoesBackup, function (processo) {
	                    _.forEach(processo, function (atividade) {
	                      _.forEach(atividade, function (tarefa) {
	                        if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                          tarefa.id_usuario = idUsuario;
	                          tarefa.nome_usuario = nomeUsuario;
	                        }
	                      });
	                    });
	                  });
	
	                  _this16.tarefasSelecionadas = [];
	                  _this16.selecionarTodasTarefas = 'nao';
	                  _this16.mostraProcessando = false;
	                  _this16.$forceUpdate();
	                }).catch(function (error) {
	                  _this16.mostraProcessando = false;
	                  _this16.$root.trataErro(error);
	                });
	
	              case 3:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this16);
	      }))();
	    },
	    atribuirAFunci: function atribuirAFunci(atribuir, matriculaFunci, nomeFunci, idFunci) {
	      var _this17 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _this17.mostraProcessando = true;
	                _context10.next = 3;
	                return axiosLaravel.post('processos/validacao/atribuir/funci', { 'lista': _this17.tarefasSelecionadas, 'atribuir': atribuir, 'mat_funci': matriculaFunci, 'nome_funci': nomeFunci, 'id_funci': idFunci }).then(function (response) {
	                  var vm = _this17;
	                  _.forEach(_this17.listaValidacoes, function (processo) {
	                    _.forEach(processo, function (atividade) {
	                      _.forEach(atividade, function (tarefa) {
	                        if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                          tarefa.id_usuario = idFunci;
	                          tarefa.nome_usuario = nomeFunci;
	                        }
	                      });
	                    });
	                  });
	
	                  _.forEach(_this17.listaValidacoesBackup, function (processo) {
	                    _.forEach(processo, function (atividade) {
	                      _.forEach(atividade, function (tarefa) {
	                        if (_.includes(_.map(vm.tarefasSelecionadas, 'id_tarefa_atual'), tarefa.id_tarefa_atual)) {
	                          tarefa.id_usuario = idFunci;
	                          tarefa.nome_usuario = nomeFunci;
	                        }
	                      });
	                    });
	                  });
	
	                  _this17.tarefasSelecionadas = [];
	                  _this17.selecionarTodasTarefas = 'nao';
	                  _this17.mostraProcessando = false;
	                  _this17.tarefasSelecionadas = [];
	                  _this17.$forceUpdate();
	                }).catch(function (error) {
	                  console.log(error);
	                  _this17.mostraProcessando = false;
	                  _this17.$root.trataErro(error);
	                });
	
	              case 3:
	                _this17.$forceUpdate();
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this17);
	      }))();
	    },
	    selecionarItem: function selecionarItem(item) {
	      if (_.find(this.tarefasSelecionadas, ['id_processo', item.id_processo])) {
	        _.remove(this.tarefasSelecionadas, function (i) {
	          return i['id_processo'] === item.id_processo;
	        });
	      } else {
	        this.tarefasSelecionadas.push(item);
	      }
	      this.$forceUpdate();
	    },
	    marcaAssumido: function marcaAssumido(_request) {
	      var _this18 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this18);
	      }))();
	    },
	    retiraAssumido: function retiraAssumido(_request) {
	      var _this19 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this19);
	      }))();
	    },
	    atribuir: function atribuir(item, deveFazer) {
	      var _this20 = this;
	
	      axiosLaravel.put('processos/validacao/assumir/', { 'id_tarefa': item.id_tarefa_atual, 'item': item }).then(function (response) {
	        if (deveFazer) {
	          _this20.fazer(item);
	        }
	      }).catch(function (error) {
	        _this20.$root.trataErro(error);
	      });
	    },
	    fazer: function fazer(item) {
	      if (item.nome_processo === 'PAGAMENTO') {
	        this.$router.push({ name: 'solicitacao-pagamento', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'CONTRAPARTIDA') {
	        this.$router.push({ name: 'solicitacao-contrapartida', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'ADIANTAMENTO') {
	        this.$router.push({ name: 'solicitacao-adiantamento', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'DEVOLUCAO_DE_ADIANTAMENTO') {
	        this.$router.push({ name: 'solicitacao-devolucao-adiantamento', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'PRESTACAO_DE_CONTAS') {
	        this.$router.push({ name: 'solicitacao-prestacaocontas', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else if (item.nome_processo === 'RESSARCIMENTO') {
	        this.$router.push({ name: 'solicitacao-ressarcimento', params: { id: item.id_processo, row: item, acao: 'VALIDAR' } });
	      } else {
	        this.$root.trataErro('Não é possível abrir essa tarefa. Entre em contato com o Administrador do sistema!');
	      }
	    },
	    atribuirTarefas: function atribuirTarefas() {
	      var _this21 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                if (_this21.funcionarioEncontrado) {
	                  _context13.next = 3;
	                  break;
	                }
	
	                alert('Por favor, selecione um funcionário válido antes de confirmar.');
	                return _context13.abrupt('return');
	
	              case 3:
	                _this21.atribuirAFunci(true, _this21.funcionarioEncontrado.matricula, _this21.funcionarioEncontrado.nome, _this21.funcionarioEncontrado.id);
	                _this21.showModal = false;
	                _this21.$forceUpdate();
	
	              case 6:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this21);
	      }))();
	    },
	    verificarAtribuicao: function verificarAtribuicao(item) {
	      var _this22 = this;
	
	      var copiaItem = _.cloneDeep(item);
	      var padrao = new RegExp('<(mark|/mark|br|p|/p)[^>]{0,}>', 'gi');
	      _.forEach(item, function (valor, parametro) {
	        item[parametro] = _.isNull(valor) ? null : ('' + valor).replace(padrao, '');
	      });
	      if (_.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO', 'OCORRENCIA_PROJETO', 'OCORRENCIA_ENTIDADE'], item.nome_processo)) {
	        item.extra = copiaItem.extra;
	      }
	      if (_.isNull(item.id_usuario) || '' + item.id_usuario === 'null') {
	        this.atribuir(item, true);
	      } else if ('' + item.id_usuario === '' + this.usuarioLogado.id) {
	        this.fazer(item);
	      } else if (!_.isNull(item.id_usuario) && '' + item.id_usuario !== 'null' && '' + item.id_usuario !== '' + this.usuarioLogado.id) {
	        this.$dialog.confirm('A tarefa será atribuída para <b>' + item.nome_usuario + '</b><br/>Deseja continuar ?', { html: true, animation: 'fade', customClass: 'avisoAlerta', okText: 'Sim', cancelText: 'Não' }).then(function (dialog) {
	          if (confirm) {
	            _this22.atribuir(item, true);
	          }
	        }).catch(function () {
	          console.log('Cancelou atribuição de tarefa com outro usuário');
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cronograma-solicitacao-adiantamento-validacao',
	  data: function data() {
	    return {
	      itens: this.propsItens,
	      valorGuarda: 0,
	      valorTotalSolicitacao: 0,
	      contasFinanceiras: []
	    };
	  },
	
	  props: ['propsItens', 'propsEnable', 'propsFase'],
	  watch: {
	    'propsItens': function propsItens() {
	      this.itens = this.propsItens;
	    }
	  },
	  mounted: function mounted() {
	    this.buscaContasFinanceiras();
	    this.$forceUpdate();
	  },
	
	  computed: {
	    valorTotalDisponivel: function valorTotalDisponivel() {
	      if (this.propsItens) {
	        return this.propsItens.reduce(function (total, item) {
	          return total + item.parcelas_adiantamentos[0].valor;
	        }, 0);
	      }
	      return 0;
	    }
	  },
	  methods: {
	    buscaContasFinanceiras: function buscaContasFinanceiras() {
	      var _this = this;
	
	      axiosLaravel.get('busca_conta_financeira').then(function (response) {
	        _this.contasFinanceiras = response.data;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    calculaValorTotalSolicitado: function calculaValorTotalSolicitado() {
	      var total = 0;
	      if (this.propsItens) {
	        this.propsItens.forEach(function (item) {
	          if (!_.isUndefined(item.valor)) {
	            total = total + item.valor;
	          } else {
	            item.valor = 0;
	          }
	        });
	      }
	      this.valorTotalSolicitacao = total;
	    },
	    editItem: function editItem(item) {
	      if (item.valor > item.totalValueAdvance) {
	        if (this.$validator.fields.find({ name: 'valor' })) {
	          this.$snotify.error('valor pedido maior que permitido');
	        }
	        return;
	      } else {
	        this.valorGuarda = _.clone(item.valor);
	      }
	
	      item.editando = !item.editando;
	
	      this.calculaValorTotalSolicitado();
	
	      this.$forceUpdate();
	    },
	    atualizaCalculoGrid: function atualizaCalculoGrid(item) {
	      this.calculaValorTotalSolicitado();
	
	      this.$forceUpdate();
	    },
	    cancelaEdicao: function cancelaEdicao(item) {
	      item.valor = _.clone(this.valorGuarda);
	
	      item.editando = !item.editando;
	
	      this.$forceUpdate();
	    }
	  }
	};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(276);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cronogramaSolicitacaoAdiantamentoValidacao = __webpack_require__(1827);
	
	var _cronogramaSolicitacaoAdiantamentoValidacao2 = _interopRequireDefault(_cronogramaSolicitacaoAdiantamentoValidacao);
	
	var _uploadDocumentosPhp = __webpack_require__(85);
	
	var _uploadDocumentosPhp2 = _interopRequireDefault(_uploadDocumentosPhp);
	
	var _historicoSolicitacaoPagamento = __webpack_require__(107);
	
	var _historicoSolicitacaoPagamento2 = _interopRequireDefault(_historicoSolicitacaoPagamento);
	
	var _historicoAntigo = __webpack_require__(106);
	
	var _historicoAntigo2 = _interopRequireDefault(_historicoAntigo);
	
	var _listaBancos = __webpack_require__(1793);
	
	var _listaBancos2 = _interopRequireDefault(_listaBancos);
	
	var _tipoConta = __webpack_require__(1794);
	
	var _tipoConta2 = _interopRequireDefault(_tipoConta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'validacaoAdiantamento',
	  components: { UploadDocumentosPhp: _uploadDocumentosPhp2.default, CronogramaSolicitacaoAdiantamentoValidacao: _cronogramaSolicitacaoAdiantamentoValidacao2.default, HistoricoSolicitacaoPagamento: _historicoSolicitacaoPagamento2.default, HistoricoAntigo: _historicoAntigo2.default, listaBancos: _listaBancos2.default, tipoConta: _tipoConta2.default },
	  data: function data() {
	    return {
	      loading: false,
	      tipoTransacao: '',
	      show: {
	        info: false,
	        message: '' },
	      entidade: {
	        dirigentes: []
	      },
	      historicoTarefasTela: [],
	      resultadoAprovacao: '',
	      restricao: false,
	      form: new Form({
	        tarefas: [{ 'nome': '', 'proxima_etapa': '', 'data_edicao': '' }],
	        documentos_liberacao: []
	      }),
	      processo: {
	        nome: 'ADIANTAMENTO',
	        situacao: 'EM_EXECUCAO'
	      },
	      tarefa: {
	        'nome': 'ANALISE',
	        'tipo': 'USUARIO',
	        'situacao': 'PADRAO',
	        'proximaEtapa': ''
	      },
	      item: {},
	      esconderHistorico: false,
	      historicoBack: [],
	      historicoAnt: [],
	      chamado: [],
	      data_edicao: '',
	      relat: {
	        id: 13,
	        createdAt: null,
	        code: 'FJCF248.GER',
	        codeNames: 'ENumPrj;ECodFor',
	        fieldNames: 'Projeto;Beneficiário/Fornecedor',
	        title: '248 - Monitoramento Administrativo'
	      },
	      proposta: {
	        ds_codigo_projeto_erp: ''
	      },
	      motivoDevolucao: null,
	      motivosDevolucao: []
	    };
	  },
	  mounted: function mounted() {
	    if (this.$route.params.id) {
	      this.verificaChamado();
	    }
	    this.buscaMotivosDevolucao();
	  },
	  created: function created() {
	    this.tipoTransacao = 'ANALISE';
	    this.data_edicao = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	
	    this.buscaProcesso();
	  },
	
	  methods: {
	    buscaHistorico: function buscaHistorico(request) {
	      var _this = this;
	
	      console.log('caiu aqui historicoBack', request);
	      axiosLaravel.post('historico-tarefas/lista', { 'parametro': request }).then(function (response) {
	        _this.historicoBack = response.data;
	        console.log('response historicoBack', response.data);
	      });
	    },
	    gravaHistorico: function gravaHistorico(_parm) {},
	    atualizaOpcoes: function atualizaOpcoes($opcao) {
	      if (_.isUndefined(this.form.documentos_liberacao[0].parametros_documento)) {
	        this.form.documentos_liberacao[0].parametros_documento = [];
	      }
	      var existe = this.form.documentos_liberacao[0].parametros_documento.some(function (item) {
	        return item.valor === $opcao;
	      });
	      if (existe) {
	        _.remove(this.form.documentos_liberacao[0].parametros_documento, function (item) {
	          return item.valor === $opcao;
	        });
	      } else {
	        this.form.documentos_liberacao[0].parametros_documento.push({
	          'parametro': 'OPCOES',
	          'valor': $opcao
	        });
	      }
	      this.$forceUpdate();
	    },
	    buscaProcesso: function buscaProcesso() {
	      var _this2 = this;
	
	      console.log('caiu aqui');
	      this.buscaHistorico(this.$route.params.id);
	      this.loadingShow = true;
	      axiosLaravel.get('processos/' + this.$route.params.id).then(function (response) {
	        _this2.form = response.data;
	        _this2.dataProcesso = (0, _moment2.default)(_this2.form.inicio).format('DD/MM/YYYY');
	        console.log('this.form', _this2.form);
	        console.log('this.form.tarefas', _this2.form.tarefas);
	        _this2.historicoTarefasTela = _.cloneDeep(_this2.form.tarefas);
	
	        _this2.proposta = _this2.form.documentos_liberacao[0].itens_liberados[0].parcelas_adiantamentos[0].proposta;
	        if (_this2.form.tarefas[0].nome === 'Revisão') {
	          _this2.tarefa.proximaEtapa = 'Análise';
	        }
	        var arrayTemp = _this2.form.tarefas;
	        var array = arrayTemp.filter(function (item) {
	          return item.tipo === 'Usuário' && !_.isNull(item.termino);
	        });
	        _this2.historicoAnt = _.cloneDeep(array);
	        _this2.$forceUpdate();
	        _this2.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    concluir: function concluir() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var menssagem;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this3.incluiMotivo();
	
	                if (!(_this3.tarefa.proximaEtapa === 'Conclusão' || _this3.tarefa.proximaEtapa === 'Autorização' || _this3.tarefa.proximaEtapa === 'Análise Financeira')) {
	                  _context.next = 15;
	                  break;
	                }
	
	                _context.next = 4;
	                return _this3.$root.verificaFormulario(_this3);
	
	              case 4:
	                if (!_context.sent) {
	                  _context.next = 9;
	                  break;
	                }
	
	                menssagem = '';
	
	                _this3.$validator.errors.items.forEach(function (item) {
	                  menssagem = menssagem + '\n' + item.msg;
	                });
	                if (menssagem === '') {
	                  _this3.$snotify.error('Formulário possui erro favor verificar');
	                } else {
	                  _this3.$snotify.error(menssagem);
	                }
	                return _context.abrupt('return');
	
	              case 9:
	                if (_this3.validaItens()) {
	                  _context.next = 12;
	                  break;
	                }
	
	                _this3.$snotify.error('Valores das parcelas precisa ser maior que 0');
	                return _context.abrupt('return');
	
	              case 12:
	                if (_this3.validaDocumentos()) {
	                  _context.next = 15;
	                  break;
	                }
	
	                _this3.$snotify.error('Faltam documentos à serem adicionados');
	                return _context.abrupt('return');
	
	              case 15:
	                _this3.preparaObjeto();
	                _this3.$validator.validateAll().then(function (result) {
	                  if (!result) {
	                    _this3.$snotify.error('Formulario possui erros favor verificar');
	                  } else {
	                    _this3.enviaBackEnd();
	                  }
	                });
	
	              case 17:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this4 = this;
	
	      this.$snotify.info('Atualizando Validação', { timeout: 0 });
	
	      _.set(this.form, 'nr_projeto', this.proposta.ds_codigo_projeto_erp);
	      axiosLaravel.put('processos/adiantamento/atualiza', this.form).then(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(response) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  _this4.$snotify.clear();
	
	                  _this4.$snotify.success('Adiantamento validado com sucesso');
	
	                  if (!(_this4.tarefa.proximaEtapa === 'Autorização')) {
	                    _context2.next = 5;
	                    break;
	                  }
	
	                  _context2.next = 5;
	                  return _this4.emitir(199);
	
	                case 5:
	                  setTimeout(function () {
	                    _this4.$router.go(-1);
	                  }, 2000);
	
	                case 6:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this4);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }()).catch(function (error) {
	        _this4.$snotify.clear();
	        console.log('error', error);
	        _this4.$root.trataErro(error);
	      });
	    },
	    validaItens: function validaItens() {
	      return this.form.documentos_liberacao[0].itens_liberados.some(function (item) {
	        return item.valor > 0;
	      });
	    },
	    validaDocumentos: function validaDocumentos() {
	      return this.form.documentos_liberacao[0].documentos_adiantamento.length > 0;
	    },
	    preparaObjeto: function preparaObjeto() {
	      this.form.processo = this.processo;
	      this.form.tarefa = this.tarefa;
	
	      this.tarefa.proxima_etapa = this.tarefa.proximaEtapa;
	      this.tarefa.data_edicao = this.data_edicao;
	      this.form.tarefas[0].proxima_etapa = this.tarefa.proximaEtapa;
	      this.form.tarefas[0].data_edicao = this.data_edicao;
	      this.form.projeto = this.projeto;
	    },
	    onLoad: function onLoad() {
	      var _this5 = this;
	
	      this.$snotify.clear();
	      this.$aguarde('Gerando relatório. Por favor, aguarde...');
	      axios.put('proxy/utility/erp-report/emit-report', { erpReport: this.relat, params: this.temp }).then(function (response) {
	        _this5.onDownload(response);
	      }).catch(function (error) {
	        _this5.$snotify.clear();
	        _this5.$root.trataErro(error);
	      });
	    },
	    emitir: function emitir(relatorio) {
	      var _this6 = this;
	
	      var mosDes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var prefixo, parametros, codigoRelatorio;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this6.loading = true;
	                prefixo = 'FJCF';
	                parametros = '<ECodEmp=1><ENumPrj=' + _this6.proposta.ds_codigo_projeto_erp + '>';
	
	                if (relatorio === 219) {
	                  parametros += '<ESitPrj=ULT>';
	                } else if (relatorio === 248) {
	                  parametros += '<ECodFor=>';
	                }
	
	                if (relatorio === 525) {
	                  parametros = '<ENumPrj=' + _this6.proposta.ds_codigo_projeto_erp + '><EMosDes=' + mosDes + '>';
	                }
	                if (relatorio === 199) {
	                  console.log('rel 199');
	                  console.log('id', _this6.form.documentos_liberacao[0].id);
	                  prefixo = 'SRNF';
	                  axiosLaravel.get('processos/busca_seqban/' + _this6.form.documentos_liberacao[0].id).then(function (response) {
	                    var seqBan = response.data.valor;
	                    console.log('response', response);
	
	                    var strOrigem = 'RP';
	                    if (_this6.form.documentos_liberacao[0].itens_liberados[0].parcelas_adiantamentos[0].origem === 5) {
	                      strOrigem = 'RT';
	                    }
	                    _this6.$snotify.clear();
	                    var codigoRelatorio = prefixo + relatorio + '.GER';
	                    parametros += '<EVlrAdt=' + _this6.valorTotalSolicitacao + '><EPeriod=90><ECodFpj=' + strOrigem + '><ESeqBan=' + seqBan + '>';
	
	                    console.log('parametros', parametros);
	                    var identificacao = relatorio === 525 ? '525 - Extrato ' + (mosDes === 'S' ? 'Analítico' : 'Sintético') : relatorio;
	                    _this6.$aguarde('Gerando relatório ' + identificacao + '. Por favor, aguarde...');
	                    axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': codigoRelatorio }, params: parametros }).then(function (response) {
	                      _this6.onDownload(response, identificacao, _this6);
	                    }).catch(function (error) {
	                      _this6.$snotify.clear();
	                      _this6.loading = false;
	                      _this6.$root.trataErro(error);
	                    });
	                  }).catch(function (error) {
	                    console.log('error', error);
	                    _this6.$root.trataErro(error);
	                  });
	                }
	                if (relatorio !== 199) {
	                  _this6.$snotify.clear();
	                  codigoRelatorio = prefixo + relatorio + '.GER';
	
	                  _this6.$aguarde('Gerando relatório ' + relatorio + '. Por favor, aguarde...');
	                  axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': codigoRelatorio }, params: parametros }).then(function (response) {
	                    _this6.onDownload(response, relatorio, _this6);
	                  }).catch(function (error) {
	                    _this6.$snotify.clear();
	                    _this6.loading = false;
	                    _this6.$root.trataErro(error);
	                  });
	                }
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this6);
	      }))();
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	
	      var tipoProcesso = 'ADT ' + this.proposta.ds_codigo_projeto_erp;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (!ie) {
	        var blob = file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + this.form.id + ' ' + tipoProcesso;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	        _link.download = (0, _moment2.default)(vm.data_edicao).format('YYYYMMDD') + ' ID ' + this.form.id + ' ' + tipoProcesso;
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    incluiMotivo: function incluiMotivo() {
	      if (this.tarefa.proximaEtapa === 'Revisão') {
	        this.form.documentos_liberacao[0].parametros_documento = [];
	
	        this.tarefa.observacao = this.tarefa.observacao;
	        _.set(this.motivoDevolucao, 'fk_usuario', this.usuarioLogado.id);
	        this.form.documentos_liberacao[0].parametros_documento.push({ 'parametro': 'MOTIVO_DEVOLUCAO', 'valor': (0, _stringify2.default)(this.motivoDevolucao) });
	      }
	    },
	    verificaChamado: function verificaChamado() {
	      var _this7 = this;
	
	      axiosLaravel.post('chamado/chamadoProcesso/', { 'parametro': this.$route.params.id }).then(function (response) {
	        _this7.chamado = response.data;
	      }).catch(function (error) {
	        _this7.$snotify.clear();
	        _this7.$root.trataErro(error);
	      });
	    },
	    onDownloadZIP: function onDownloadZIP() {
	      var _this8 = this;
	
	      this.$forceUpdate();
	      this.$aguarde('Baixando arquivos. Por favor, aguarde...');
	      axiosLaravel.get('processos/documentos/download/' + this.$route.params.id).then(function (response) {
	        var link = document.createElement('a');
	        link.href = response.data;
	        link.download = 'Arquivo não localizado';
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	        _this8.$snotify.clear();
	        _this8.$forceUpdate();
	      }).catch(function (error) {
	        _this8.$snotify.clear();
	        _this8.$root.trataErro(error);
	      });
	    },
	    motivoDevolucaoDescricao: function motivoDevolucaoDescricao(option) {
	      return '' + option.descricao;
	    },
	    buscaMotivosDevolucao: function buscaMotivosDevolucao() {
	      var _this9 = this;
	
	      axiosLaravel.post('motivos/ativos').then(function (response) {
	        _this9.motivosDevolucao = response.data;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this9.$root.trataErro(error);
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']), {
	    valorTotalSolicitacao: function valorTotalSolicitacao() {
	      var resultado = this.form.documentos_liberacao[0].itens_liberados.reduce(function (acumulador, item) {
	        return acumulador + item.valor;
	      }, 0);
	      if ((0, _isInteger2.default)(resultado)) {
	        return resultado.toLocaleString('pt-BR') + ',00';
	      } else {
	        return resultado.toLocaleString('pt-BR', {
	          minimumFractionDigits: 2,
	          maximumFractionDigits: 2 });
	      }
	    }
	  })
	};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cronograma-solicitacao-devolucao-adiantamento-validacao',
	  data: function data() {
	    return {
	      itens: this.propsItens,
	      adiantamentosConcecidos: this.propsAdiantamentosConcedidos,
	      valorGuarda: 0,
	      valorTotalSolicitacao: 0,
	      contasFinanceiras: []
	    };
	  },
	
	  props: ['propsItens', 'propsEnable', 'propsFase', 'propsAdiantamentosConcedidos'],
	  mounted: function mounted() {
	    this.buscaContasFinanceiras();
	    this.itens = this.propsItens.map(function (item) {
	      item.valor = item.valor * -1;
	      return item;
	    });
	    this.$forceUpdate();
	  },
	
	  computed: {
	    valorTotalDisponivel: function valorTotalDisponivel() {
	      if (this.propsItens) {
	        return this.propsItens.reduce(function (total, item) {
	          return total + item.parcelas_adiantamentos[0].valor;
	        }, 0);
	      }
	      return 0;
	    }
	  },
	  methods: {
	    buscaContasFinanceiras: function buscaContasFinanceiras() {
	      var _this = this;
	
	      axiosLaravel.get('busca_conta_financeira').then(function (response) {
	        _this.contasFinanceiras = response.data;
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    },
	    calculaValorTotalSolicitado: function calculaValorTotalSolicitado() {
	      var total = 0;
	      if (this.propsItens) {
	        this.propsItens.forEach(function (item) {
	          if (!_.isUndefined(item.valor)) {
	            total = total + item.valor;
	          } else {
	            item.valor = 0;
	          }
	        });
	      }
	      this.valorTotalSolicitacao = total;
	    },
	    editItem: function editItem(item) {
	      if (item.valor > item.totalValueAdvance) {
	        if (this.$validator.fields.find({ name: 'valor' })) {
	          this.$snotify.error('valor pedido maior que permitido');
	        }
	        return;
	      } else {
	        this.valorGuarda = _.clone(item.valor);
	      }
	
	      item.editando = !item.editando;
	
	      this.calculaValorTotalSolicitado();
	
	      this.$forceUpdate();
	    },
	    cancelaEdicao: function cancelaEdicao(item) {
	      item.valor = _.clone(this.valorGuarda);
	
	      item.editando = !item.editando;
	
	      this.$forceUpdate();
	    }
	  }
	};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(6);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(5);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vuex = __webpack_require__(3);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _uploadDocumentosPhp = __webpack_require__(85);
	
	var _uploadDocumentosPhp2 = _interopRequireDefault(_uploadDocumentosPhp);
	
	var _cronogramaSolicitacaoDevolucaoAdiantamentoValidacao = __webpack_require__(1829);
	
	var _cronogramaSolicitacaoDevolucaoAdiantamentoValidacao2 = _interopRequireDefault(_cronogramaSolicitacaoDevolucaoAdiantamentoValidacao);
	
	var _historicoSolicitacaoPagamento = __webpack_require__(107);
	
	var _historicoSolicitacaoPagamento2 = _interopRequireDefault(_historicoSolicitacaoPagamento);
	
	var _historicoAntigo = __webpack_require__(106);
	
	var _historicoAntigo2 = _interopRequireDefault(_historicoAntigo);
	
	var _gridSolicitacaoAdiantamentoConcedidas = __webpack_require__(1792);
	
	var _gridSolicitacaoAdiantamentoConcedidas2 = _interopRequireDefault(_gridSolicitacaoAdiantamentoConcedidas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'validacaoDevolucaoAdiantamentoAnalise',
	  components: {
	    GridSolicitacaoAdiantamentoConcecida: _gridSolicitacaoAdiantamentoConcedidas2.default,
	    CronogramaSolicitacaoDevolucaoAdiantamentoValidacao: _cronogramaSolicitacaoDevolucaoAdiantamentoValidacao2.default,
	    HistoricoSolicitacaoPagamento: _historicoSolicitacaoPagamento2.default,
	    HistoricoAntigo: _historicoAntigo2.default,
	    UploadDocumentosPhp: _uploadDocumentosPhp2.default },
	  data: function data() {
	    return {
	      loading: false,
	      tipoTransacao: '',
	      show: {
	        info: false,
	        message: '' },
	      entidade: {
	        dirigentes: []
	      },
	      chamado: [],
	      historicoTarefasTela: [],
	      resultadoAprovacao: '',
	      esconderHistorico: false,
	      historicoBack: [],
	      historicoAnt: [],
	      data_edicao: '',
	      restricao: false,
	      adiantamentosConcecidos: {},
	      form: new Form({
	        processo: {
	          nome: 'DEVOLUCAO_DE_ADIANTAMENTO',
	          situacao: 'EM_EXECUCAO'
	        },
	        tarefas: [{ 'nome': '' }],
	        documentos_liberacao: []
	      }),
	      processo: {
	        nome: 'DEVOLUCAO_DE_ADIANTAMENTO',
	        situacao: 'EM_EXECUCAO'
	      },
	      tarefa: {
	        'nome': 'ANALISE',
	        'tipo': 'USUARIO',
	        'situacao': 'PADRAO',
	        'proximaEtapa': ''
	      },
	      proposta: {
	        ds_codigo_projeto_erp: '',
	        projeto: {}
	      },
	      item: {},
	      motivoDevolucao: null,
	      motivosDevolucao: []
	    };
	  },
	  mounted: function mounted() {
	    if (this.$route.params.id) {
	      this.verificaChamado();
	    }
	    this.buscaMotivosDevolucao();
	  },
	  created: function created() {
	    this.tipoTransacao = 'ANALISE';
	    this.data_edicao = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	
	    this.buscaProcesso();
	  },
	
	  methods: {
	    buscaHistorico: function buscaHistorico(request) {
	      var _this = this;
	
	      console.log('caiu aqui historicoBack', request);
	      axiosLaravel.post('historico-tarefas/lista', { 'parametro': request }).then(function (response) {
	        _this.historicoBack = response.data;
	        console.log('response historicoBack', response.data);
	      });
	    },
	    gravaHistorico: function gravaHistorico(_parm) {},
	    buscaProcesso: function buscaProcesso() {
	      var _this2 = this;
	
	      this.buscaHistorico(this.$route.params.id);
	      this.loadingShow = true;
	      axiosLaravel.get('processos/' + this.$route.params.id).then(function (response) {
	        _this2.form = response.data;
	        _this2.dataProcesso = (0, _moment2.default)(_this2.form.inicio).format('DD/MM/YYYY');
	        _this2.historicoTarefasTela = _.cloneDeep(_this2.form.tarefas);
	
	        _this2.proposta = _this2.form.documentos_liberacao[0].itens_liberados[0].parcelas_adiantamentos[0].proposta;
	
	        var arrayTemp = _this2.form.tarefas;
	        var array = arrayTemp.filter(function (item) {
	          return item.tipo === 'Usuário' && !_.isNull(item.termino);
	        });
	        _this2.historicoAnt = _.cloneDeep(array);
	        _this2.buscaAdiantamentosConcedidos(_this2.proposta);
	        _this2.$forceUpdate();
	        _this2.loadingShow = false;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this2.$root.trataErro(error);
	      });
	    },
	    concluir: function concluir() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var menssagem;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this3.incluiMotivo();
	
	                if (!(_this3.tarefa.proximaEtapa === 'Conclusão')) {
	                  _context.next = 9;
	                  break;
	                }
	
	                _context.next = 4;
	                return _this3.$root.verificaFormulario(_this3);
	
	              case 4:
	                if (!_context.sent) {
	                  _context.next = 9;
	                  break;
	                }
	
	                menssagem = '';
	
	                _this3.$validator.errors.items.forEach(function (item) {
	                  menssagem = menssagem + '\n' + item.msg;
	                });
	                if (menssagem === '') {
	                  _this3.$snotify.error('Formulário possui erro favor verificar');
	                } else {
	                  _this3.$snotify.error(menssagem);
	                }
	                return _context.abrupt('return');
	
	              case 9:
	                if (_this3.validaItens()) {
	                  _context.next = 12;
	                  break;
	                }
	
	                _this3.$snotify.error('Valores das parcelas precisa ser maior que 0');
	                return _context.abrupt('return');
	
	              case 12:
	                if (_this3.validaDocumentos()) {
	                  _context.next = 15;
	                  break;
	                }
	
	                _this3.$snotify.error('Faltam documentos à serem adicionados');
	                return _context.abrupt('return');
	
	              case 15:
	                _this3.preparaObjeto();
	                _this3.$validator.validateAll().then(function (result) {
	                  if (!result) {
	                    _this3.$snotify.error('Revise os campos: ' + _.join(_.uniq(_this3.$validator.errors.all()), ' '));
	                  } else {
	                    _this3.enviaBackEnd();
	                  }
	                });
	
	              case 17:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    enviaBackEnd: function enviaBackEnd() {
	      var _this4 = this;
	
	      this.$snotify.info('Atualizando Validação', { timeout: 0 });
	
	      axiosLaravel.put('processos/adiantamento/atualiza', this.form).then(function (response) {
	        _this4.$snotify.clear();
	
	        _this4.$snotify.success('Adiantamento validado com sucesso');
	        setTimeout(function () {
	          _this4.$router.go(-1);
	        }, 2000);
	      }).catch(function (error) {
	        _this4.$snotify.clear();
	        console.log('error', error);
	        _this4.$root.trataErro(error);
	      });
	    },
	    validaItens: function validaItens() {
	      return this.form.documentos_liberacao[0].itens_liberados.some(function (item) {
	        return item.valor > 0;
	      });
	    },
	    validaDocumentos: function validaDocumentos() {
	      return this.form.documentos_liberacao[0].documentos_adiantamento.length > 0;
	    },
	    preparaObjeto: function preparaObjeto() {
	      this.form.processo = this.processo;
	      this.form.tarefa = this.tarefa;
	      this.form.projeto = this.projeto;
	      this.tarefa.proxima_etapa = this.tarefa.proximaEtapa;
	      this.tarefa.data_edicao = this.data_edicao;
	      this.form.tarefas[0].proxima_etapa = this.tarefa.proximaEtapa;
	      this.form.tarefas[0].data_edicao = this.data_edicao;
	    },
	    buscaAdiantamentosConcedidos: function buscaAdiantamentosConcedidos(proposta) {
	      var _this5 = this;
	
	      console.log('buscaAdiantamentosConcedidos');
	      console.log('proposta', proposta);
	      axiosLaravel.get('processos/adiantamento/recursos/' + proposta.id, { entityId: null }).then(function (response) {
	        _this5.adiantamentosConcecidos = response.data.adiantamentos_concedidos.row;
	
	        _this5.$forceUpdate();
	      }).catch(function (error) {
	        console.log('error', error);
	        _this5.$root.trataErro(error);
	      });
	    },
	    emitir: function emitir(relatorio) {
	      var _this6 = this;
	
	      var mosDes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loading = true;
	      var parametros = '<ECodEmp=1><ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '>';
	
	      if (relatorio === 219) {
	        parametros += '<ESitPrj=ULT>';
	      } else if (relatorio === 248) {
	        parametros += '<ECodFor=>';
	      }
	
	      if (relatorio === 525) {
	        parametros = '<ENumPrj=' + this.proposta.ds_codigo_projeto_erp + '><EMosDes=' + mosDes + '>';
	      }
	      this.$snotify.clear();
	      console.log('parametros', parametros);
	      var identificacao = relatorio === 525 ? '525 - Extrato ' + (mosDes === 'S' ? 'Analítico' : 'Sintético') : relatorio;
	      this.$aguarde('Gerando relatório ' + identificacao + '. Por favor, aguarde...');
	      axiosLaravel.post('relatorio-erp/emitir', { erpReport: { 'ds_codigo': 'FJCF' + relatorio + '.GER' }, params: parametros }).then(function (response) {
	        _this6.onDownload(response, identificacao, _this6);
	      }).catch(function (error) {
	        _this6.$snotify.clear();
	        _this6.loading = false;
	        _this6.$root.trataErro(error);
	      });
	    },
	    onDownload: function onDownload(response, relatorio, vm) {
	      var item = response.data.arquivo;
	      var contentType = 'application/pdf';
	      var b64Data = response.data.arquivo;
	      var file = this.b64toBlob(b64Data, contentType);
	      var ie = !!window.MSInputMethodContext && !!document.documentMode;
	      if (!ie) {
	        var blob = file;
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp + ' - ' + vm.proposta.ds_nome;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      } else {
	        var _blob = file;
	        var _link = document.createElement('blob');
	        _link.href = window.navigator.msSaveOrOpenBlob(_blob, item.name);
	        _link.download = 'Relatório ' + relatorio + ' » ' + vm.proposta.ds_codigo_projeto_erp + ' - ' + vm.proposta.ds_nome;
	        _link.click();
	      }
	      this.$snotify.clear();
	      this.$snotify.success('Relatório gerado com sucesso!');
	      this.loading = false;
	    },
	    b64toBlob: function b64toBlob(b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    },
	    incluiMotivo: function incluiMotivo() {
	      if (this.tarefa.proximaEtapa === 'Revisão') {
	        console.log('caiu aqui');
	        this.form.documentos_liberacao[0].parametros_documento = [];
	
	        this.tarefa.observacao = this.tarefa.observacao;
	        _.set(this.motivoDevolucao, 'fk_usuario', this.usuarioLogado.id);
	        this.form.documentos_liberacao[0].parametros_documento.push({ 'parametro': 'MOTIVO_DEVOLUCAO', 'valor': (0, _stringify2.default)(this.motivoDevolucao) });
	        console.log('this.form>>>>', this.form);
	      }
	    },
	    verificaChamado: function verificaChamado() {
	      var _this7 = this;
	
	      axiosLaravel.post('chamado/chamadoProcesso/', { 'parametro': this.$route.params.id }).then(function (response) {
	        console.log('response.data RLMB', response.data);
	        _this7.chamado = response.data;
	      }).catch(function (error) {
	        _this7.$snotify.clear();
	        _this7.$root.trataErro(error);
	      });
	    },
	    onDownloadZIP: function onDownloadZIP() {
	      var _this8 = this;
	
	      this.$forceUpdate();
	      this.$aguarde('Baixando arquivos. Por favor, aguarde...');
	      axiosLaravel.get('processos/documentos/download/' + this.$route.params.id).then(function (response) {
	        var link = document.createElement('a');
	        link.href = response.data;
	        link.download = 'Arquivo não localizado';
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	        _this8.$snotify.clear();
	        _this8.$forceUpdate();
	      }).catch(function (error) {
	        _this8.$snotify.clear();
	        _this8.$root.trataErro(error);
	      });
	    },
	    motivoDevolucaoDescricao: function motivoDevolucaoDescricao(option) {
	      return '' + option.descricao;
	    },
	    buscaMotivosDevolucao: function buscaMotivosDevolucao() {
	      var _this9 = this;
	
	      axiosLaravel.post('motivos/ativos').then(function (response) {
	        _this9.motivosDevolucao = response.data;
	      }).catch(function (error) {
	        console.log('error', error);
	        _this9.$root.trataErro(error);
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado']))
	};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListaValidacaoInicial',
	  data: function data() {
	    return {
	      quantidadesPorFase: '',
	      quantidadeSegundaFase: '',
	      quantidadesFinalizadas: '',
	      simplificados: [],
	      faseAtual: '',
	      descricaoFase: '',
	      filtro: {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        entityApprovalType: 'FIRST_APPROVAL',
	        simplificado: null,
	        userId: null
	      },
	      filtro2: {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        entityApprovalType: 'SECOND_APPROVAL',
	        simplificado: null,
	        userId: null
	      },
	      filtro3: {
	        entityName: null,
	        eventStatus: 'DONE',
	        favorite: null,
	        limit: 50,
	        offset: 0,
	        entityApprovalType: 'SECOND_APPROVAL',
	        approvalResult: 'APPROVED',
	        simplificado: null,
	        userId: null
	      },
	      aprovacaoLista: [],
	      aprovacaoTotal: null,
	      loadingShow: false,
	      table: {
	        items: [],
	        totalRows: 0,
	        filter: null,
	        hover: false,
	        bordered: false,
	        currentPage: 1,
	        sortBy: 'createdAt',
	        sortDesc: true,
	        perPage: 10,
	        fields: [{ key: 'favorite', label: '', thStyle: 'text-align: center; width: 3%', class: 'text-center' }, { key: 'entidade', label: '', thStyle: 'text-align: left; width: 60%', class: 'text-left' }, { key: 'userName', label: '', thStyle: 'font-weight: bold' }, { key: 'createdAt', label: '', thStyle: 'text-align: center', class: 'text-center' }, { key: 'actions', label: '', thStyle: 'text-align: center', class: 'text-center' }]
	      },
	      rota1: 'validacao-inicial'
	    };
	  },
	
	  watch: {
	    'filtro.favorite': function filtroFavorite() {
	      this.onSearch();
	    },
	    'filtro.userId': function filtroUserId() {
	      this.onSearch();
	    },
	    'faseAtual': function faseAtual() {
	      this.filtro.userId = null;
	      this.filtro.favorite = null;
	      this.filtro.eventStatus = 'OPEN';
	      this.onSearch();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    axios.get('proxy/document/simplified/geral/list').then(function (response) {
	      _this.simplificados = response.data.value;
	    }).catch(function (error) {
	      _this.$root.trataErro(error);
	    });
	  },
	  mounted: function mounted() {
	    this.onSearch();
	  },
	
	  methods: {
	    QuantPrimeiraAprov: function QuantPrimeiraAprov() {
	      var _this2 = this;
	
	      var filtroQuantidade = {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        limit: 50,
	        simplificado: null,
	        offset: 0,
	        entityApprovalType: 'FIRST_APPROVAL',
	        userId: null
	      };
	
	      axios.post('proxy/account/approval-entity/search/sql', filtroQuantidade).then(function (response) {
	        _this2.quantidadesPorFase = response.data.value.total;
	      }).catch(function (error) {
	        _this2.$root.trataErro(error);
	      });
	    },
	    QuantSegundaAprov: function QuantSegundaAprov() {
	      var _this3 = this;
	
	      var filtroQuantidade2 = {
	        entityName: null,
	        eventStatus: 'OPEN',
	        favorite: null,
	        simplificado: null,
	        limit: 50,
	        offset: 0,
	        entityApprovalType: 'SECOND_APPROVAL',
	        userId: null
	      };
	      axios.post('proxy/account/approval-entity/search/sql', filtroQuantidade2).then(function (response) {
	        _this3.quantidadeSegundaFase = response.data.value.total;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    QuantFinalizadas: function QuantFinalizadas() {
	      var _this4 = this;
	
	      var filtroQuantidade3 = {
	        entityName: null,
	        eventStatus: 'DONE',
	        favorite: null,
	        limit: 50,
	        simplificado: null,
	        offset: 0,
	        approvalResult: 'APPROVED',
	        entityApprovalType: 'SECOND_APPROVAL',
	        userId: null
	      };
	
	      axios.post('proxy/account/approval-entity/search/sql', filtroQuantidade3).then(function (response) {
	        _this4.quantidadesFinalizadas = response.data.value.total;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    onFiltered: function onFiltered(filteredItems) {
	      this.totalRows = filteredItems.length;
	      this.currentPage = 1;
	    },
	    buscaBackEnd: function buscaBackEnd(url) {
	      var _this5 = this;
	
	      axios.post(url, this.filtro).then(function (response) {
	        _this5.carregaTabela(response);
	      }).catch(function (error) {
	        _this5.$root.trataErro(error);
	      });
	    },
	    carregaTabela: function carregaTabela(response) {
	      this.table.items = response.data.value.list;
	      this.table.totalRows = response.data.value.total;
	      this.loadingShow = false;
	    },
	    onSearch: function onSearch() {
	      this.loadingShow = true;
	      switch (this.faseAtual) {
	        case 'primeira':
	          this.filtro.entityApprovalType = 'FIRST_APPROVAL';
	          this.descricaoFase = 'Primeira Aprovação';
	          this.filtro.approvalResult = null;
	          this.buscaBackEnd('proxy/account/approval-entity/search/sql');
	          break;
	        case 'segunda':
	          this.filtro.entityApprovalType = 'SECOND_APPROVAL';
	          this.descricaoFase = 'Segunda Aprovação';
	          this.filtro.approvalResult = null;
	          this.buscaBackEnd('proxy/account/approval-entity/search/sql');
	          break;
	        case 'finalizada':
	          this.filtro.entityApprovalType = 'SECOND_APPROVAL';
	          this.descricaoFase = 'Finalizadas';
	          this.filtro.eventStatus = 'DONE';
	          this.filtro.approvalResult = 'APPROVED';
	          this.buscaBackEnd('proxy/account/approval-entity/search/sql');
	          break;
	        default:
	          this.faseAtual = 'primeira';
	          this.filtro.entityApprovalType = 'FIRST_APPROVAL';
	          this.descricaoFase = 'Primeira Aprovação';
	          this.filtro.approvalResult = null;
	          this.buscaBackEnd('proxy/account/approval-entity/search/sql');
	      }
	      this.QuantPrimeiraAprov();
	      this.QuantSegundaAprov();
	      this.QuantFinalizadas();
	    },
	    onFavorite: function onFavorite(item) {
	      var _this6 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-entity/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-entity/';
	          break;
	      }
	      axios.put(url + item.id + '/favorite', '').then(function (response) {
	        _this6.onSearch();
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    onAssign: function onAssign(item) {
	      var _this7 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-entity/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-entity/';
	          break;
	      }
	      axios.put(url + item.id + '/assign', '').then(function (response) {
	        _this7.onSearch();
	      }).catch(function (error) {
	        _this7.$root.trataErro(error);
	      });
	    },
	    onAssignAndDo: function onAssignAndDo(item) {
	      this.onAssign(item);
	      this.$router.push({ name: this.rota1, params: { id: item.id } });
	    },
	    onUnassign: function onUnassign(item) {
	      var _this8 = this;
	
	      var url = '';
	      switch (this.faseAtual) {
	        case 'primeira':
	          url = 'proxy/account/approval-entity/';
	          break;
	        case 'segunda':
	          url = 'proxy/account/approval-entity/';
	          break;
	      }
	      axios.put(url + item.id + '/unassign', '').then(function (response) {
	        _this8.onSearch();
	      }).catch(function (error) {
	        _this8.$root.trataErro(error);
	      });
	    }
	  }
	};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _endereco = __webpack_require__(71);
	
	var _endereco2 = _interopRequireDefault(_endereco);
	
	var _dirigentes = __webpack_require__(50);
	
	var _dirigentes2 = _interopRequireDefault(_dirigentes);
	
	var _usuarios = __webpack_require__(53);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _uploadDocumentos = __webpack_require__(22);
	
	var _uploadDocumentos2 = _interopRequireDefault(_uploadDocumentos);
	
	var _historicoEntidade = __webpack_require__(105);
	
	var _historicoEntidade2 = _interopRequireDefault(_historicoEntidade);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Endereco: _endereco2.default,
	    Dirigentes: _dirigentes2.default,
	    UploadDocumentos: _uploadDocumentos2.default,
	    HistoricoEntidade: _historicoEntidade2.default,
	    Usuarios: _usuarios2.default
	  },
	  name: 'ValidaInicial',
	  data: function data() {
	    return {
	      campoErro: null,
	      entidade: {},
	      analise: {
	        approvalResult: '',
	        justify: ''
	      },
	      proposta: {},
	      contato: [],
	      dirigentes: [],
	      ramoAtividade: [],
	      endereco: {},
	      historico: {},
	      usuarios: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usuarioLogado'])),
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      axios.get('proxy/account/approval-entity/' + this.$route.params.id).then(function (response) {
	        _this.entidade = response.data.value.entity;
	        _this.analise = response.data.value;
	        _this.proposta = response.data.value.proposal;
	        _this.dirigentes = _this.entidade.chiefs;
	        _this.contato = _this.entidade.contact;
	        _this.endereco = _this.entidade.address;
	
	        _this.loadEntityActivity();
	        _this.loadEntityUser();
	        _this.loadHistory();
	      }).catch(function (error) {
	        _this.$root.trataErro(error);
	      });
	    }
	  },
	
	  methods: {
	    isEditable: function isEditable() {
	      return this.$root.authorize('entidade-editar') || this.$root.authorize('minha-entidade-editar');
	    },
	    loadEntityActivity: function loadEntityActivity() {
	      var _this2 = this;
	
	      axios.get('proxy/project/entity-activity/').then(function (response) {
	        _this2.ramoAtividade = response.data.value;
	      });
	    },
	    loadEntityUser: function loadEntityUser() {
	      var _this3 = this;
	
	      axios.get('proxy/account/entities/' + this.entidade.id + '/users').then(function (response) {
	        _this3.usuarios = response.data.value;
	      }).catch(function (error) {
	        _this3.$root.trataErro(error);
	      });
	    },
	    salvaUsuarios: function salvaUsuarios() {
	      var _this4 = this;
	
	      axios.post('proxy/account/entities/' + this.entidade.id + '/users', this.usuarios).then(function (response) {
	        _this4.users = response.data.value;
	      }).catch(function (error) {
	        _this4.$root.trataErro(error);
	      });
	    },
	    salva: function salva() {
	      if (this.entidade.id) {
	        this.atualiza();
	      } else {
	        this.grava();
	      }
	    },
	    conclui: function conclui() {
	      var _this5 = this;
	
	      var entidadeOK = true;
	      var aba = '';
	      if (_.isEmpty(this.endereco)) {
	        entidadeOK = false;
	        aba = 'Endereço';
	      }
	      if (_.isEmpty(this.dirigentes)) {
	        entidadeOK = false;
	        aba = 'Dirigentes';
	      }
	      if (entidadeOK) {
	        this.$snotify.clear();
	        this.$snotify.info('Atualizando Validação...', { timeout: 0 });
	        if (this.$route.params.id) {
	          axios.put('/proxy/account/approval-entity/' + this.$route.params.id, this.analise).then(function (response) {
	            _this5.salvaUsuarios();
	            if (_this5.entidade.active === false) {
	              _this5.$snotify.clear();
	              if (_this5.usuarioLogado.userType === 'FUNDACAO') {
	                _this5.$snotify.success('Alteração cadastral concluída com sucesso!');
	              } else {
	                _this5.$snotify.success('Cadastro da entidade concluído com sucesso! Aguarde e-mail da Fundação Banco do brasil com as informações para dar continuidade ao processo !');
	              }
	              setTimeout(function () {
	                _this5.$router.go(-1);
	              }, 1000);
	            } else {
	              _this5.$snotify.clear();
	              _this5.$snotify.success('Alteração cadastral concluída com sucesso!');
	              _this5.$router.go(-1);
	            }
	          }).catch(function (error) {
	            _this5.$root.trataErro(error);
	          });
	        }
	      } else {
	        this.$snotify.error('Erros no preenchimento da aba ' + aba + '. Favor verificar.');
	      }
	    },
	    loadHistory: function loadHistory() {
	      var _this6 = this;
	
	      axios.get('/proxy/account/entities/' + this.entidade.id + '/history').then(function (response) {
	        _this6.historico = response.data.value;
	      }).catch(function (error) {
	        _this6.$root.trataErro(error);
	      });
	    },
	    atualiza: function atualiza() {
	      var _this7 = this;
	
	      this.entidade.users = this.usuarios;
	      axios.put('/proxy/account/entities/' + this.entidade.id + '/temp', this.entidade).then(function (response) {
	        _this7.salvaUsuarios();
	        _this7.$snotify.success('Entidade salva com sucesso!');
	      }).catch(function (error) {
	        _this7.$snotify.clear();
	        _this7.$root.trataErro(error);
	      });
	    },
	    grava: function grava() {
	      var _this8 = this;
	
	      axios.post('proxy/account/entities/temp/' + this.entidade).then(function (response) {
	        _this8.$snotify.success('Entidade salva com sucesso!');
	      });
	    }
	  }
	};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alert = __webpack_require__(180);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'alert-error',
	
	  extends: _Alert2.default,
	
	  props: {
	    message: {
	      type: String,
	      default: 'There were some problems with your input.'
	    }
	  }
	};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alert = __webpack_require__(180);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'alert-errors',
	
	  extends: _Alert2.default,
	
	  props: {
	    message: {
	      type: String,
	      default: 'There were some problems with your input.'
	    }
	  }
	};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alert = __webpack_require__(180);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'alert-success',
	
	  extends: _Alert2.default,
	
	  props: {
	    message: { type: String, default: '' }
	  }
	};

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'has-error',
	
	  props: {
	    form: {
	      type: Object,
	      required: true
	    },
	
	    field: {
	      type: String,
	      required: true
	    }
	  }
	};

/***/ }),
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */
/***/ (function(module, exports) {

	module.exports = {"ativo":"NAO","texto":"Prezado parceiro, <br> Estamos atravessando um momento difícil para todos. <br> A Fundação Banco do Brasil permanece trabalhando, entretanto, com algumas limitações a fim de garantir a saúde e integridade de seus colaboradores e parceiros. <br>Dessa forma, estamos atendendo por meio de mensagem eletrônica, no endereço implementacao@fbb.org.br. <br>Trazemos a você algumas questões para que possamos avaliar os impactos na execução dos nossos projetos: <br>- O projeto está em atividade ou foi paralisado?<br>- Há alguma previsão do impacto dessa paralisação no prazo de execução do projeto?<br>- Há avaliação/previsão do impacto dessa paralisação nos itens de despesa previstos para o projeto?<br>- Alguma outra consideração que julgue pertinente?Solicitamos que se manifestem por e-mail, informando o número do projeto, com a maior brevidade possível, inclusive na eventual mudança do cenário hora reportado, para que possamos nos preparar e juntos atravessarmos esse momento.<br>PS: Caso já tenha se reportado formalmente à FBB, favor desconsiderar essa mensagem."}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	module.exports = {"version":"2022e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 2en0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|LMT EST EDT EWT EPT|5R.4 50 40 40 40|0121234121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B66.U UFd6.U 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|LMT CST CDT CWT CPT|6i.g 60 50 50 50|0121234121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B5F.I UFdF.I 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|LMT CST EST EWT EPT EDT|5V 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-32B63 Avc3 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Iceland","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Indian/Christmas","Asia/Brunei|Asia/Kuching","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Reunion","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Antarctica/Vostok","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Berlin|Arctic/Longyearbyen","Europe/Berlin|Atlantic/Jan_Mayen","Europe/Berlin|Europe/Copenhagen","Europe/Berlin|Europe/Oslo","Europe/Berlin|Europe/Stockholm","Europe/Brussels|Europe/Amsterdam","Europe/Brussels|Europe/Luxembourg","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Kiev|Europe/Kyiv","Europe/Kiev|Europe/Uzhgorod","Europe/Kiev|Europe/Zaporozhye","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Paris|Europe/Monaco","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Maldives|Indian/Kerguelen","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Majuro","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Honolulu Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 362,
		"./af.js": 362,
		"./ar": 369,
		"./ar-dz": 363,
		"./ar-dz.js": 363,
		"./ar-kw": 364,
		"./ar-kw.js": 364,
		"./ar-ly": 365,
		"./ar-ly.js": 365,
		"./ar-ma": 366,
		"./ar-ma.js": 366,
		"./ar-sa": 367,
		"./ar-sa.js": 367,
		"./ar-tn": 368,
		"./ar-tn.js": 368,
		"./ar.js": 369,
		"./az": 370,
		"./az.js": 370,
		"./be": 371,
		"./be.js": 371,
		"./bg": 372,
		"./bg.js": 372,
		"./bm": 373,
		"./bm.js": 373,
		"./bn": 374,
		"./bn.js": 374,
		"./bo": 375,
		"./bo.js": 375,
		"./br": 376,
		"./br.js": 376,
		"./bs": 377,
		"./bs.js": 377,
		"./ca": 378,
		"./ca.js": 378,
		"./cs": 379,
		"./cs.js": 379,
		"./cv": 380,
		"./cv.js": 380,
		"./cy": 381,
		"./cy.js": 381,
		"./da": 382,
		"./da.js": 382,
		"./de": 385,
		"./de-at": 383,
		"./de-at.js": 383,
		"./de-ch": 384,
		"./de-ch.js": 384,
		"./de.js": 385,
		"./dv": 386,
		"./dv.js": 386,
		"./el": 387,
		"./el.js": 387,
		"./en-SG": 388,
		"./en-SG.js": 388,
		"./en-au": 389,
		"./en-au.js": 389,
		"./en-ca": 390,
		"./en-ca.js": 390,
		"./en-gb": 391,
		"./en-gb.js": 391,
		"./en-ie": 392,
		"./en-ie.js": 392,
		"./en-il": 393,
		"./en-il.js": 393,
		"./en-nz": 394,
		"./en-nz.js": 394,
		"./eo": 395,
		"./eo.js": 395,
		"./es": 398,
		"./es-do": 396,
		"./es-do.js": 396,
		"./es-us": 397,
		"./es-us.js": 397,
		"./es.js": 398,
		"./et": 399,
		"./et.js": 399,
		"./eu": 400,
		"./eu.js": 400,
		"./fa": 401,
		"./fa.js": 401,
		"./fi": 402,
		"./fi.js": 402,
		"./fo": 403,
		"./fo.js": 403,
		"./fr": 406,
		"./fr-ca": 404,
		"./fr-ca.js": 404,
		"./fr-ch": 405,
		"./fr-ch.js": 405,
		"./fr.js": 406,
		"./fy": 407,
		"./fy.js": 407,
		"./ga": 408,
		"./ga.js": 408,
		"./gd": 409,
		"./gd.js": 409,
		"./gl": 410,
		"./gl.js": 410,
		"./gom-latn": 411,
		"./gom-latn.js": 411,
		"./gu": 412,
		"./gu.js": 412,
		"./he": 413,
		"./he.js": 413,
		"./hi": 414,
		"./hi.js": 414,
		"./hr": 415,
		"./hr.js": 415,
		"./hu": 416,
		"./hu.js": 416,
		"./hy-am": 417,
		"./hy-am.js": 417,
		"./id": 418,
		"./id.js": 418,
		"./is": 419,
		"./is.js": 419,
		"./it": 421,
		"./it-ch": 420,
		"./it-ch.js": 420,
		"./it.js": 421,
		"./ja": 422,
		"./ja.js": 422,
		"./jv": 423,
		"./jv.js": 423,
		"./ka": 424,
		"./ka.js": 424,
		"./kk": 425,
		"./kk.js": 425,
		"./km": 426,
		"./km.js": 426,
		"./kn": 427,
		"./kn.js": 427,
		"./ko": 428,
		"./ko.js": 428,
		"./ku": 429,
		"./ku.js": 429,
		"./ky": 430,
		"./ky.js": 430,
		"./lb": 431,
		"./lb.js": 431,
		"./lo": 432,
		"./lo.js": 432,
		"./lt": 433,
		"./lt.js": 433,
		"./lv": 434,
		"./lv.js": 434,
		"./me": 435,
		"./me.js": 435,
		"./mi": 436,
		"./mi.js": 436,
		"./mk": 437,
		"./mk.js": 437,
		"./ml": 438,
		"./ml.js": 438,
		"./mn": 439,
		"./mn.js": 439,
		"./mr": 440,
		"./mr.js": 440,
		"./ms": 442,
		"./ms-my": 441,
		"./ms-my.js": 441,
		"./ms.js": 442,
		"./mt": 443,
		"./mt.js": 443,
		"./my": 444,
		"./my.js": 444,
		"./nb": 445,
		"./nb.js": 445,
		"./ne": 446,
		"./ne.js": 446,
		"./nl": 448,
		"./nl-be": 447,
		"./nl-be.js": 447,
		"./nl.js": 448,
		"./nn": 449,
		"./nn.js": 449,
		"./pa-in": 450,
		"./pa-in.js": 450,
		"./pl": 451,
		"./pl.js": 451,
		"./pt": 452,
		"./pt-br": 243,
		"./pt-br.js": 243,
		"./pt.js": 452,
		"./ro": 453,
		"./ro.js": 453,
		"./ru": 454,
		"./ru.js": 454,
		"./sd": 455,
		"./sd.js": 455,
		"./se": 456,
		"./se.js": 456,
		"./si": 457,
		"./si.js": 457,
		"./sk": 458,
		"./sk.js": 458,
		"./sl": 459,
		"./sl.js": 459,
		"./sq": 460,
		"./sq.js": 460,
		"./sr": 462,
		"./sr-cyrl": 461,
		"./sr-cyrl.js": 461,
		"./sr.js": 462,
		"./ss": 463,
		"./ss.js": 463,
		"./sv": 464,
		"./sv.js": 464,
		"./sw": 465,
		"./sw.js": 465,
		"./ta": 466,
		"./ta.js": 466,
		"./te": 467,
		"./te.js": 467,
		"./tet": 468,
		"./tet.js": 468,
		"./tg": 469,
		"./tg.js": 469,
		"./th": 470,
		"./th.js": 470,
		"./tl-ph": 471,
		"./tl-ph.js": 471,
		"./tlh": 472,
		"./tlh.js": 472,
		"./tr": 473,
		"./tr.js": 473,
		"./tzl": 474,
		"./tzl.js": 474,
		"./tzm": 476,
		"./tzm-latn": 475,
		"./tzm-latn.js": 475,
		"./tzm.js": 476,
		"./ug-cn": 477,
		"./ug-cn.js": 477,
		"./uk": 478,
		"./uk.js": 478,
		"./ur": 479,
		"./ur.js": 479,
		"./uz": 481,
		"./uz-latn": 480,
		"./uz-latn.js": 480,
		"./uz.js": 481,
		"./vi": 482,
		"./vi.js": 482,
		"./x-pseudo": 483,
		"./x-pseudo.js": 483,
		"./yo": 484,
		"./yo.js": 484,
		"./zh-cn": 485,
		"./zh-cn.js": 485,
		"./zh-hk": 486,
		"./zh-hk.js": 486,
		"./zh-tw": 487,
		"./zh-tw.js": 487
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1568;


/***/ }),
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1253)
	
	/* script */
	__vue_exports__ = __webpack_require__(608)
	
	/* template */
	var __vue_template__ = __webpack_require__(1840)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-00bd37db"
	
	module.exports = __vue_exports__


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1269)
	
	/* script */
	__vue_exports__ = __webpack_require__(609)
	
	/* template */
	var __vue_template__ = __webpack_require__(1855)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1292)
	__webpack_require__(1293)
	
	/* script */
	__vue_exports__ = __webpack_require__(610)
	
	/* template */
	var __vue_template__ = __webpack_require__(1877)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1431)
	
	/* script */
	__vue_exports__ = __webpack_require__(611)
	
	/* template */
	var __vue_template__ = __webpack_require__(2019)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1396)
	
	/* script */
	__vue_exports__ = __webpack_require__(612)
	
	/* template */
	var __vue_template__ = __webpack_require__(1985)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1344)
	
	/* script */
	__vue_exports__ = __webpack_require__(613)
	
	/* template */
	var __vue_template__ = __webpack_require__(1930)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(614)
	
	/* template */
	var __vue_template__ = __webpack_require__(1955)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1319)
	
	/* script */
	__vue_exports__ = __webpack_require__(615)
	
	/* template */
	var __vue_template__ = __webpack_require__(1905)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3719f1a6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1483)
	
	/* script */
	__vue_exports__ = __webpack_require__(616)
	
	/* template */
	var __vue_template__ = __webpack_require__(2070)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bf626e28"
	
	module.exports = __vue_exports__


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1355)
	
	/* script */
	__vue_exports__ = __webpack_require__(617)
	
	/* template */
	var __vue_template__ = __webpack_require__(1942)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1304)
	
	/* script */
	__vue_exports__ = __webpack_require__(618)
	
	/* template */
	var __vue_template__ = __webpack_require__(1888)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1316)
	
	/* script */
	__vue_exports__ = __webpack_require__(620)
	
	/* template */
	var __vue_template__ = __webpack_require__(1902)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-35df74a0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1420)
	
	/* script */
	__vue_exports__ = __webpack_require__(621)
	
	/* template */
	var __vue_template__ = __webpack_require__(2008)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7161b3a8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1357)
	
	/* script */
	__vue_exports__ = __webpack_require__(622)
	
	/* template */
	var __vue_template__ = __webpack_require__(1944)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1373)
	__webpack_require__(1372)
	
	/* script */
	__vue_exports__ = __webpack_require__(623)
	
	/* template */
	var __vue_template__ = __webpack_require__(1960)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-55285b83"
	
	module.exports = __vue_exports__


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1290)
	__webpack_require__(1289)
	
	/* script */
	__vue_exports__ = __webpack_require__(624)
	
	/* template */
	var __vue_template__ = __webpack_require__(1875)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1e7c637c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1518)
	
	/* script */
	__vue_exports__ = __webpack_require__(625)
	
	/* template */
	var __vue_template__ = __webpack_require__(2103)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f413b496"
	
	module.exports = __vue_exports__


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1435)
	
	/* script */
	__vue_exports__ = __webpack_require__(626)
	
	/* template */
	var __vue_template__ = __webpack_require__(2023)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-78c5ea08"
	
	module.exports = __vue_exports__


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1353)
	
	/* script */
	__vue_exports__ = __webpack_require__(627)
	
	/* template */
	var __vue_template__ = __webpack_require__(1940)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4aedabec"
	
	module.exports = __vue_exports__


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1341)
	
	/* script */
	__vue_exports__ = __webpack_require__(628)
	
	/* template */
	var __vue_template__ = __webpack_require__(1927)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4318ef5a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1306)
	
	/* script */
	__vue_exports__ = __webpack_require__(629)
	
	/* template */
	var __vue_template__ = __webpack_require__(1890)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-28aa0298"
	
	module.exports = __vue_exports__


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1381)
	
	/* script */
	__vue_exports__ = __webpack_require__(630)
	
	/* template */
	var __vue_template__ = __webpack_require__(1969)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5c49928c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1281)
	
	/* script */
	__vue_exports__ = __webpack_require__(631)
	
	/* template */
	var __vue_template__ = __webpack_require__(1867)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-198a3404"
	
	module.exports = __vue_exports__


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1494)
	
	/* script */
	__vue_exports__ = __webpack_require__(632)
	
	/* template */
	var __vue_template__ = __webpack_require__(2083)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d05b64a8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1360)
	
	/* script */
	__vue_exports__ = __webpack_require__(633)
	
	/* template */
	var __vue_template__ = __webpack_require__(1947)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4ec5b846"
	
	module.exports = __vue_exports__


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1513)
	
	/* script */
	__vue_exports__ = __webpack_require__(634)
	
	/* template */
	var __vue_template__ = __webpack_require__(2098)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1430)
	
	/* script */
	__vue_exports__ = __webpack_require__(635)
	
	/* template */
	var __vue_template__ = __webpack_require__(2018)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-76631c4d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1393)
	
	/* script */
	__vue_exports__ = __webpack_require__(636)
	
	/* template */
	var __vue_template__ = __webpack_require__(1981)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-642559e2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1337)
	
	/* script */
	__vue_exports__ = __webpack_require__(637)
	
	/* template */
	var __vue_template__ = __webpack_require__(1923)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-406d7d7b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1259)
	
	/* script */
	__vue_exports__ = __webpack_require__(638)
	
	/* template */
	var __vue_template__ = __webpack_require__(1846)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-02216ac4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1338)
	
	/* script */
	__vue_exports__ = __webpack_require__(639)
	
	/* template */
	var __vue_template__ = __webpack_require__(1924)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1271)
	
	/* script */
	__vue_exports__ = __webpack_require__(640)
	
	/* template */
	var __vue_template__ = __webpack_require__(1857)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0d089950"
	
	module.exports = __vue_exports__


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1479)
	
	/* script */
	__vue_exports__ = __webpack_require__(641)
	
	/* template */
	var __vue_template__ = __webpack_require__(2066)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-baa5bc28"
	
	module.exports = __vue_exports__


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1390)
	
	/* script */
	__vue_exports__ = __webpack_require__(642)
	
	/* template */
	var __vue_template__ = __webpack_require__(1978)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6160f02b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1285)
	
	/* script */
	__vue_exports__ = __webpack_require__(643)
	
	/* template */
	var __vue_template__ = __webpack_require__(1871)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1c357818"
	
	module.exports = __vue_exports__


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1427)
	
	/* script */
	__vue_exports__ = __webpack_require__(644)
	
	/* template */
	var __vue_template__ = __webpack_require__(2015)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-753232a8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1347)
	
	/* script */
	__vue_exports__ = __webpack_require__(645)
	
	/* template */
	var __vue_template__ = __webpack_require__(1933)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1385)
	
	/* script */
	__vue_exports__ = __webpack_require__(646)
	
	/* template */
	var __vue_template__ = __webpack_require__(1973)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1426)
	
	/* script */
	__vue_exports__ = __webpack_require__(647)
	
	/* template */
	var __vue_template__ = __webpack_require__(2014)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-75295c4f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1348)
	
	/* script */
	__vue_exports__ = __webpack_require__(648)
	
	/* template */
	var __vue_template__ = __webpack_require__(1934)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1331)
	
	/* script */
	__vue_exports__ = __webpack_require__(649)
	
	/* template */
	var __vue_template__ = __webpack_require__(1917)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3c8391e7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1439)
	
	/* script */
	__vue_exports__ = __webpack_require__(650)
	
	/* template */
	var __vue_template__ = __webpack_require__(2027)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7e08ccf1"
	
	module.exports = __vue_exports__


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1515)
	
	/* script */
	__vue_exports__ = __webpack_require__(652)
	
	/* template */
	var __vue_template__ = __webpack_require__(2100)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1388)
	
	/* script */
	__vue_exports__ = __webpack_require__(653)
	
	/* template */
	var __vue_template__ = __webpack_require__(1976)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-604dfe99"
	
	module.exports = __vue_exports__


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1272)
	
	/* script */
	__vue_exports__ = __webpack_require__(654)
	
	/* template */
	var __vue_template__ = __webpack_require__(1858)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0eeba1a6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1441)
	
	/* script */
	__vue_exports__ = __webpack_require__(655)
	
	/* template */
	var __vue_template__ = __webpack_require__(2029)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ff99bad"
	
	module.exports = __vue_exports__


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1437)
	
	/* script */
	__vue_exports__ = __webpack_require__(656)
	
	/* template */
	var __vue_template__ = __webpack_require__(2025)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7c332600"
	
	module.exports = __vue_exports__


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1413)
	
	/* script */
	__vue_exports__ = __webpack_require__(657)
	
	/* template */
	var __vue_template__ = __webpack_require__(2001)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6d230582"
	
	module.exports = __vue_exports__


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1273)
	
	/* script */
	__vue_exports__ = __webpack_require__(658)
	
	/* template */
	var __vue_template__ = __webpack_require__(1859)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0f18f562"
	
	module.exports = __vue_exports__


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1251)
	
	/* script */
	__vue_exports__ = __webpack_require__(659)
	
	/* template */
	var __vue_template__ = __webpack_require__(1838)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0031c03a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1398)
	
	/* script */
	__vue_exports__ = __webpack_require__(660)
	
	/* template */
	var __vue_template__ = __webpack_require__(1987)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-66b441db"
	
	module.exports = __vue_exports__


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1506)
	
	/* script */
	__vue_exports__ = __webpack_require__(661)
	
	/* template */
	var __vue_template__ = __webpack_require__(2092)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-debab4bc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1263)
	
	/* script */
	__vue_exports__ = __webpack_require__(662)
	
	/* template */
	var __vue_template__ = __webpack_require__(1851)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-09700554"
	
	module.exports = __vue_exports__


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1309)
	
	/* script */
	__vue_exports__ = __webpack_require__(663)
	
	/* template */
	var __vue_template__ = __webpack_require__(1894)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2b69a584"
	
	module.exports = __vue_exports__


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1482)
	
	/* script */
	__vue_exports__ = __webpack_require__(664)
	
	/* template */
	var __vue_template__ = __webpack_require__(2069)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bdd82824"
	
	module.exports = __vue_exports__


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1277)
	
	/* script */
	__vue_exports__ = __webpack_require__(665)
	
	/* template */
	var __vue_template__ = __webpack_require__(1862)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1254)
	
	/* script */
	__vue_exports__ = __webpack_require__(666)
	
	/* template */
	var __vue_template__ = __webpack_require__(1841)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1374)
	
	/* script */
	__vue_exports__ = __webpack_require__(667)
	
	/* template */
	var __vue_template__ = __webpack_require__(1962)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5799c3a0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1278)
	
	/* script */
	__vue_exports__ = __webpack_require__(668)
	
	/* template */
	var __vue_template__ = __webpack_require__(1863)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1352)
	
	/* script */
	__vue_exports__ = __webpack_require__(669)
	
	/* template */
	var __vue_template__ = __webpack_require__(1939)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1424)
	
	/* script */
	__vue_exports__ = __webpack_require__(670)
	
	/* template */
	var __vue_template__ = __webpack_require__(2012)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1459)
	
	/* script */
	__vue_exports__ = __webpack_require__(671)
	
	/* template */
	var __vue_template__ = __webpack_require__(2047)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a2ccccca"
	
	module.exports = __vue_exports__


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1323)
	
	/* script */
	__vue_exports__ = __webpack_require__(672)
	
	/* template */
	var __vue_template__ = __webpack_require__(1910)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3875c60b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1474)
	
	/* script */
	__vue_exports__ = __webpack_require__(675)
	
	/* template */
	var __vue_template__ = __webpack_require__(2061)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b66ce63a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1425)
	
	/* script */
	__vue_exports__ = __webpack_require__(676)
	
	/* template */
	var __vue_template__ = __webpack_require__(2013)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7450be7e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1519)
	
	/* script */
	__vue_exports__ = __webpack_require__(679)
	
	/* template */
	var __vue_template__ = __webpack_require__(2104)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f60caf14"
	
	module.exports = __vue_exports__


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1287)
	
	/* script */
	__vue_exports__ = __webpack_require__(680)
	
	/* template */
	var __vue_template__ = __webpack_require__(1873)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ce1470d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1310)
	
	/* script */
	__vue_exports__ = __webpack_require__(683)
	
	/* template */
	var __vue_template__ = __webpack_require__(1896)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2ead57f2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(684)
	
	/* template */
	var __vue_template__ = __webpack_require__(2074)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1288)
	
	/* script */
	__vue_exports__ = __webpack_require__(685)
	
	/* template */
	var __vue_template__ = __webpack_require__(1874)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1d79cb9e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1514)
	
	/* script */
	__vue_exports__ = __webpack_require__(687)
	
	/* template */
	var __vue_template__ = __webpack_require__(2099)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ec743260"
	
	module.exports = __vue_exports__


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1274)
	__webpack_require__(1275)
	
	/* script */
	__vue_exports__ = __webpack_require__(688)
	
	/* template */
	var __vue_template__ = __webpack_require__(1860)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0f4d4fe4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1487)
	
	/* script */
	__vue_exports__ = __webpack_require__(689)
	
	/* template */
	var __vue_template__ = __webpack_require__(2075)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c608dd7e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1417)
	
	/* script */
	__vue_exports__ = __webpack_require__(690)
	
	/* template */
	var __vue_template__ = __webpack_require__(2005)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6fe5a4a8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1283)
	
	/* script */
	__vue_exports__ = __webpack_require__(692)
	
	/* template */
	var __vue_template__ = __webpack_require__(1869)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1b6c08d7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1442)
	
	/* script */
	__vue_exports__ = __webpack_require__(693)
	
	/* template */
	var __vue_template__ = __webpack_require__(2030)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-80f95162"
	
	module.exports = __vue_exports__


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1491)
	
	/* script */
	__vue_exports__ = __webpack_require__(694)
	
	/* template */
	var __vue_template__ = __webpack_require__(2080)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cb4397a0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1339)
	
	/* script */
	__vue_exports__ = __webpack_require__(695)
	
	/* template */
	var __vue_template__ = __webpack_require__(1925)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-415ebe2c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1423)
	
	/* script */
	__vue_exports__ = __webpack_require__(696)
	
	/* template */
	var __vue_template__ = __webpack_require__(2011)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-728ce63c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1434)
	
	/* script */
	__vue_exports__ = __webpack_require__(698)
	
	/* template */
	var __vue_template__ = __webpack_require__(2022)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1299)
	
	/* script */
	__vue_exports__ = __webpack_require__(700)
	
	/* template */
	var __vue_template__ = __webpack_require__(1884)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2610308b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1280)
	
	/* script */
	__vue_exports__ = __webpack_require__(702)
	
	/* template */
	var __vue_template__ = __webpack_require__(1866)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-195ffda2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1468)
	
	/* script */
	__vue_exports__ = __webpack_require__(703)
	
	/* template */
	var __vue_template__ = __webpack_require__(2055)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b0768936"
	
	module.exports = __vue_exports__


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1305)
	
	/* script */
	__vue_exports__ = __webpack_require__(704)
	
	/* template */
	var __vue_template__ = __webpack_require__(1889)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-28a87cd9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1345)
	
	/* script */
	__vue_exports__ = __webpack_require__(709)
	
	/* template */
	var __vue_template__ = __webpack_require__(1931)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-449ea82e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1461)
	
	/* script */
	__vue_exports__ = __webpack_require__(714)
	
	/* template */
	var __vue_template__ = __webpack_require__(2049)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-aa323312"
	
	module.exports = __vue_exports__


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1260)
	
	/* script */
	__vue_exports__ = __webpack_require__(716)
	
	/* template */
	var __vue_template__ = __webpack_require__(1847)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-03544cd8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1386)
	
	/* script */
	__vue_exports__ = __webpack_require__(718)
	
	/* template */
	var __vue_template__ = __webpack_require__(1974)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5ea12190"
	
	module.exports = __vue_exports__


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1471)
	
	/* script */
	__vue_exports__ = __webpack_require__(719)
	
	/* template */
	var __vue_template__ = __webpack_require__(2058)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b5641088"
	
	module.exports = __vue_exports__


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1463)
	
	/* script */
	__vue_exports__ = __webpack_require__(720)
	
	/* template */
	var __vue_template__ = __webpack_require__(2051)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ab027708"
	
	module.exports = __vue_exports__


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1327)
	
	/* script */
	__vue_exports__ = __webpack_require__(721)
	
	/* template */
	var __vue_template__ = __webpack_require__(1914)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3b706ab0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1481)
	
	/* script */
	__vue_exports__ = __webpack_require__(724)
	
	/* template */
	var __vue_template__ = __webpack_require__(2068)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1402)
	
	/* script */
	__vue_exports__ = __webpack_require__(726)
	
	/* template */
	var __vue_template__ = __webpack_require__(1992)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-69918164"
	
	module.exports = __vue_exports__


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1415)
	
	/* script */
	__vue_exports__ = __webpack_require__(728)
	
	/* template */
	var __vue_template__ = __webpack_require__(2003)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6dedb889"
	
	module.exports = __vue_exports__


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1445)
	
	/* script */
	__vue_exports__ = __webpack_require__(729)
	
	/* template */
	var __vue_template__ = __webpack_require__(2033)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-83c40b24"
	
	module.exports = __vue_exports__


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1375)
	
	/* script */
	__vue_exports__ = __webpack_require__(731)
	
	/* template */
	var __vue_template__ = __webpack_require__(1963)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57e6d9ae"
	
	module.exports = __vue_exports__


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1325)
	
	/* script */
	__vue_exports__ = __webpack_require__(733)
	
	/* template */
	var __vue_template__ = __webpack_require__(1912)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3a193e6e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(736)
	
	/* template */
	var __vue_template__ = __webpack_require__(1936)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1359)
	
	/* script */
	__vue_exports__ = __webpack_require__(737)
	
	/* template */
	var __vue_template__ = __webpack_require__(1946)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1500)
	
	/* script */
	__vue_exports__ = __webpack_require__(738)
	
	/* template */
	var __vue_template__ = __webpack_require__(2088)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1511)
	
	/* script */
	__vue_exports__ = __webpack_require__(739)
	
	/* template */
	var __vue_template__ = __webpack_require__(2096)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1460)
	
	/* script */
	__vue_exports__ = __webpack_require__(740)
	
	/* template */
	var __vue_template__ = __webpack_require__(2048)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1314)
	
	/* script */
	__vue_exports__ = __webpack_require__(741)
	
	/* template */
	var __vue_template__ = __webpack_require__(1900)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1332)
	
	/* script */
	__vue_exports__ = __webpack_require__(742)
	
	/* template */
	var __vue_template__ = __webpack_require__(1918)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1450)
	
	/* script */
	__vue_exports__ = __webpack_require__(743)
	
	/* template */
	var __vue_template__ = __webpack_require__(2038)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1392)
	
	/* script */
	__vue_exports__ = __webpack_require__(744)
	
	/* template */
	var __vue_template__ = __webpack_require__(1980)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1478)
	
	/* script */
	__vue_exports__ = __webpack_require__(745)
	
	/* template */
	var __vue_template__ = __webpack_require__(2065)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1336)
	
	/* script */
	__vue_exports__ = __webpack_require__(748)
	
	/* template */
	var __vue_template__ = __webpack_require__(1922)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-406c0976"
	
	module.exports = __vue_exports__


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1524)
	
	/* script */
	__vue_exports__ = __webpack_require__(751)
	
	/* template */
	var __vue_template__ = __webpack_require__(2108)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ff571e30"
	
	module.exports = __vue_exports__


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1516)
	
	/* script */
	__vue_exports__ = __webpack_require__(752)
	
	/* template */
	var __vue_template__ = __webpack_require__(2101)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f2c8610e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1349)
	
	/* script */
	__vue_exports__ = __webpack_require__(753)
	
	/* template */
	var __vue_template__ = __webpack_require__(1935)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-459d9e9c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1399)
	
	/* script */
	__vue_exports__ = __webpack_require__(754)
	
	/* template */
	var __vue_template__ = __webpack_require__(1988)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-66b54c5a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1465)
	
	/* script */
	__vue_exports__ = __webpack_require__(755)
	
	/* template */
	var __vue_template__ = __webpack_require__(2053)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ae83f2c6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1351)
	
	/* script */
	__vue_exports__ = __webpack_require__(756)
	
	/* template */
	var __vue_template__ = __webpack_require__(1938)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4865b1f2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1404)
	__webpack_require__(1406)
	__webpack_require__(1405)
	
	/* script */
	__vue_exports__ = __webpack_require__(758)
	
	/* template */
	var __vue_template__ = __webpack_require__(1994)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b1b98de"
	
	module.exports = __vue_exports__


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1266)
	__webpack_require__(1268)
	__webpack_require__(1267)
	
	/* script */
	__vue_exports__ = __webpack_require__(759)
	
	/* template */
	var __vue_template__ = __webpack_require__(1854)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0b057bfa"
	
	module.exports = __vue_exports__


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1432)
	
	/* script */
	__vue_exports__ = __webpack_require__(760)
	
	/* template */
	var __vue_template__ = __webpack_require__(2020)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1387)
	
	/* script */
	__vue_exports__ = __webpack_require__(761)
	
	/* template */
	var __vue_template__ = __webpack_require__(1975)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-60354b7a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1295)
	
	/* script */
	__vue_exports__ = __webpack_require__(766)
	
	/* template */
	var __vue_template__ = __webpack_require__(1879)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(767)
	
	/* template */
	var __vue_template__ = __webpack_require__(1893)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1418)
	
	/* script */
	__vue_exports__ = __webpack_require__(768)
	
	/* template */
	var __vue_template__ = __webpack_require__(2006)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1456)
	
	/* script */
	__vue_exports__ = __webpack_require__(769)
	
	/* template */
	var __vue_template__ = __webpack_require__(2044)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1294)
	
	/* script */
	__vue_exports__ = __webpack_require__(770)
	
	/* template */
	var __vue_template__ = __webpack_require__(1878)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1504)
	__webpack_require__(1505)
	__webpack_require__(1503)
	
	/* script */
	__vue_exports__ = __webpack_require__(771)
	
	/* template */
	var __vue_template__ = __webpack_require__(2091)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(772)
	
	/* template */
	var __vue_template__ = __webpack_require__(1895)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1342)
	
	/* script */
	__vue_exports__ = __webpack_require__(773)
	
	/* template */
	var __vue_template__ = __webpack_require__(1928)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-43be472e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1480)
	
	/* script */
	__vue_exports__ = __webpack_require__(774)
	
	/* template */
	var __vue_template__ = __webpack_require__(2067)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-baf7250c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1329)
	__webpack_require__(1330)
	
	/* script */
	__vue_exports__ = __webpack_require__(780)
	
	/* template */
	var __vue_template__ = __webpack_require__(1916)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3c3c6639"
	
	module.exports = __vue_exports__


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(781)
	
	/* template */
	var __vue_template__ = __webpack_require__(1991)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1408)
	
	/* script */
	__vue_exports__ = __webpack_require__(782)
	
	/* template */
	var __vue_template__ = __webpack_require__(1996)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b6af7b9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1436)
	
	/* script */
	__vue_exports__ = __webpack_require__(783)
	
	/* template */
	var __vue_template__ = __webpack_require__(2024)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1317)
	
	/* script */
	__vue_exports__ = __webpack_require__(784)
	
	/* template */
	var __vue_template__ = __webpack_require__(1903)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(785)
	
	/* template */
	var __vue_template__ = __webpack_require__(1961)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1488)
	
	/* script */
	__vue_exports__ = __webpack_require__(786)
	
	/* template */
	var __vue_template__ = __webpack_require__(2076)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c6330a4c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1312)
	
	/* script */
	__vue_exports__ = __webpack_require__(787)
	
	/* template */
	var __vue_template__ = __webpack_require__(1898)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1512)
	
	/* script */
	__vue_exports__ = __webpack_require__(789)
	
	/* template */
	var __vue_template__ = __webpack_require__(2097)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1279)
	
	/* script */
	__vue_exports__ = __webpack_require__(790)
	
	/* template */
	var __vue_template__ = __webpack_require__(1865)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-17c2cf4f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1517)
	
	/* script */
	__vue_exports__ = __webpack_require__(791)
	
	/* template */
	var __vue_template__ = __webpack_require__(2102)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1350)
	
	/* script */
	__vue_exports__ = __webpack_require__(793)
	
	/* template */
	var __vue_template__ = __webpack_require__(1937)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-468ebce7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1367)
	
	/* script */
	__vue_exports__ = __webpack_require__(794)
	
	/* template */
	var __vue_template__ = __webpack_require__(1954)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1366)
	
	/* script */
	__vue_exports__ = __webpack_require__(796)
	
	/* template */
	var __vue_template__ = __webpack_require__(1953)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-51fd82b7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1462)
	
	/* script */
	__vue_exports__ = __webpack_require__(798)
	
	/* template */
	var __vue_template__ = __webpack_require__(2050)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-aaf7ade2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1400)
	
	/* script */
	__vue_exports__ = __webpack_require__(799)
	
	/* template */
	var __vue_template__ = __webpack_require__(1989)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1521)
	__webpack_require__(1522)
	
	/* script */
	__vue_exports__ = __webpack_require__(801)
	
	/* template */
	var __vue_template__ = __webpack_require__(2106)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f6fdc1fa"
	
	module.exports = __vue_exports__


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1255)
	
	/* script */
	__vue_exports__ = __webpack_require__(802)
	
	/* template */
	var __vue_template__ = __webpack_require__(1842)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1486)
	
	/* script */
	__vue_exports__ = __webpack_require__(803)
	
	/* template */
	var __vue_template__ = __webpack_require__(2073)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1343)
	
	/* script */
	__vue_exports__ = __webpack_require__(804)
	
	/* template */
	var __vue_template__ = __webpack_require__(1929)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1297)
	
	/* script */
	__vue_exports__ = __webpack_require__(805)
	
	/* template */
	var __vue_template__ = __webpack_require__(1881)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-255aac42"
	
	module.exports = __vue_exports__


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1469)
	
	/* script */
	__vue_exports__ = __webpack_require__(806)
	
	/* template */
	var __vue_template__ = __webpack_require__(2056)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b4761c18"
	
	module.exports = __vue_exports__


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1401)
	
	/* script */
	__vue_exports__ = __webpack_require__(807)
	
	/* template */
	var __vue_template__ = __webpack_require__(1990)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6740ae5a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1477)
	
	/* script */
	__vue_exports__ = __webpack_require__(808)
	
	/* template */
	var __vue_template__ = __webpack_require__(2064)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b8dca622"
	
	module.exports = __vue_exports__


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1457)
	
	/* script */
	__vue_exports__ = __webpack_require__(809)
	
	/* template */
	var __vue_template__ = __webpack_require__(2045)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9dccad92"
	
	module.exports = __vue_exports__


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1340)
	
	/* script */
	__vue_exports__ = __webpack_require__(811)
	
	/* template */
	var __vue_template__ = __webpack_require__(1926)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-428a6a6c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1270)
	
	/* script */
	__vue_exports__ = __webpack_require__(812)
	
	/* template */
	var __vue_template__ = __webpack_require__(1856)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0c909fcc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1489)
	
	/* script */
	__vue_exports__ = __webpack_require__(813)
	
	/* template */
	var __vue_template__ = __webpack_require__(2078)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c9fe5b3a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1412)
	
	/* script */
	__vue_exports__ = __webpack_require__(814)
	
	/* template */
	var __vue_template__ = __webpack_require__(2000)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6d220210"
	
	module.exports = __vue_exports__


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1261)
	
	/* script */
	__vue_exports__ = __webpack_require__(815)
	
	/* template */
	var __vue_template__ = __webpack_require__(1848)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-039c07be"
	
	module.exports = __vue_exports__


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1448)
	
	/* script */
	__vue_exports__ = __webpack_require__(816)
	
	/* template */
	var __vue_template__ = __webpack_require__(2036)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8985464e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1440)
	
	/* script */
	__vue_exports__ = __webpack_require__(817)
	
	/* template */
	var __vue_template__ = __webpack_require__(2028)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7feca3a0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1315)
	
	/* script */
	__vue_exports__ = __webpack_require__(818)
	
	/* template */
	var __vue_template__ = __webpack_require__(1901)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-35a26cd9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1395)
	
	/* script */
	__vue_exports__ = __webpack_require__(819)
	
	/* template */
	var __vue_template__ = __webpack_require__(1983)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-652c5561"
	
	module.exports = __vue_exports__


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1485)
	
	/* script */
	__vue_exports__ = __webpack_require__(820)
	
	/* template */
	var __vue_template__ = __webpack_require__(2072)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c0008598"
	
	module.exports = __vue_exports__


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1262)
	
	/* script */
	__vue_exports__ = __webpack_require__(821)
	
	/* template */
	var __vue_template__ = __webpack_require__(1850)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-06d9adf6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1296)
	
	/* script */
	__vue_exports__ = __webpack_require__(822)
	
	/* template */
	var __vue_template__ = __webpack_require__(1880)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-24eba5d6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1368)
	
	/* script */
	__vue_exports__ = __webpack_require__(823)
	
	/* template */
	var __vue_template__ = __webpack_require__(1956)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-52d3b592"
	
	module.exports = __vue_exports__


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1464)
	
	/* script */
	__vue_exports__ = __webpack_require__(824)
	
	/* template */
	var __vue_template__ = __webpack_require__(2052)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ae068130"
	
	module.exports = __vue_exports__


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1371)
	
	/* script */
	__vue_exports__ = __webpack_require__(825)
	
	/* template */
	var __vue_template__ = __webpack_require__(1959)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1318)
	
	/* script */
	__vue_exports__ = __webpack_require__(826)
	
	/* template */
	var __vue_template__ = __webpack_require__(1904)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-36e148c0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1475)
	
	/* script */
	__vue_exports__ = __webpack_require__(827)
	
	/* template */
	var __vue_template__ = __webpack_require__(2062)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b76f53b6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1363)
	
	/* script */
	__vue_exports__ = __webpack_require__(828)
	
	/* template */
	var __vue_template__ = __webpack_require__(1950)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4fae5ec5"
	
	module.exports = __vue_exports__


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1443)
	
	/* script */
	__vue_exports__ = __webpack_require__(829)
	
	/* template */
	var __vue_template__ = __webpack_require__(2031)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1361)
	
	/* script */
	__vue_exports__ = __webpack_require__(830)
	
	/* template */
	var __vue_template__ = __webpack_require__(1948)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1383)
	
	/* script */
	__vue_exports__ = __webpack_require__(831)
	
	/* template */
	var __vue_template__ = __webpack_require__(1971)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5e01e2ba"
	
	module.exports = __vue_exports__


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1449)
	
	/* script */
	__vue_exports__ = __webpack_require__(832)
	
	/* template */
	var __vue_template__ = __webpack_require__(2037)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8a56b9ba"
	
	module.exports = __vue_exports__


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1394)
	
	/* script */
	__vue_exports__ = __webpack_require__(833)
	
	/* template */
	var __vue_template__ = __webpack_require__(1982)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-64604eba"
	
	module.exports = __vue_exports__


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1421)
	
	/* script */
	__vue_exports__ = __webpack_require__(835)
	
	/* template */
	var __vue_template__ = __webpack_require__(2009)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-719df6ff"
	
	module.exports = __vue_exports__


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1391)
	
	/* script */
	__vue_exports__ = __webpack_require__(836)
	
	/* template */
	var __vue_template__ = __webpack_require__(1979)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-63d6efde"
	
	module.exports = __vue_exports__


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1444)
	
	/* script */
	__vue_exports__ = __webpack_require__(837)
	
	/* template */
	var __vue_template__ = __webpack_require__(2032)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8393327c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1354)
	
	/* script */
	__vue_exports__ = __webpack_require__(838)
	
	/* template */
	var __vue_template__ = __webpack_require__(1941)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4b75b33d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1333)
	
	/* script */
	__vue_exports__ = __webpack_require__(839)
	
	/* template */
	var __vue_template__ = __webpack_require__(1919)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f3af72e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1365)
	
	/* script */
	__vue_exports__ = __webpack_require__(840)
	
	/* template */
	var __vue_template__ = __webpack_require__(1952)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-51fc218a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1407)
	
	/* script */
	__vue_exports__ = __webpack_require__(843)
	
	/* template */
	var __vue_template__ = __webpack_require__(1995)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b653207"
	
	module.exports = __vue_exports__


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1403)
	
	/* script */
	__vue_exports__ = __webpack_require__(844)
	
	/* template */
	var __vue_template__ = __webpack_require__(1993)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1520)
	
	/* script */
	__vue_exports__ = __webpack_require__(845)
	
	/* template */
	var __vue_template__ = __webpack_require__(2105)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f63d218c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1452)
	
	/* script */
	__vue_exports__ = __webpack_require__(846)
	
	/* template */
	var __vue_template__ = __webpack_require__(2040)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-93cc172a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1523)
	
	/* script */
	__vue_exports__ = __webpack_require__(847)
	
	/* template */
	var __vue_template__ = __webpack_require__(2107)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f96e17ce"
	
	module.exports = __vue_exports__


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1508)
	
	/* script */
	__vue_exports__ = __webpack_require__(848)
	
	/* template */
	var __vue_template__ = __webpack_require__(2094)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e25f0c10"
	
	module.exports = __vue_exports__


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1379)
	
	/* script */
	__vue_exports__ = __webpack_require__(849)
	
	/* template */
	var __vue_template__ = __webpack_require__(1967)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5b4eeb62"
	
	module.exports = __vue_exports__


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1362)
	
	/* script */
	__vue_exports__ = __webpack_require__(850)
	
	/* template */
	var __vue_template__ = __webpack_require__(1949)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4f3eabb2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1380)
	
	/* script */
	__vue_exports__ = __webpack_require__(851)
	
	/* template */
	var __vue_template__ = __webpack_require__(1968)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5bc7f521"
	
	module.exports = __vue_exports__


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1438)
	
	/* script */
	__vue_exports__ = __webpack_require__(852)
	
	/* template */
	var __vue_template__ = __webpack_require__(2026)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7d5fa572"
	
	module.exports = __vue_exports__


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1389)
	
	/* script */
	__vue_exports__ = __webpack_require__(853)
	
	/* template */
	var __vue_template__ = __webpack_require__(1977)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-612ea33e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1324)
	
	/* script */
	__vue_exports__ = __webpack_require__(855)
	
	/* template */
	var __vue_template__ = __webpack_require__(1911)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-39ad9d06"
	
	module.exports = __vue_exports__


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1411)
	
	/* script */
	__vue_exports__ = __webpack_require__(856)
	
	/* template */
	var __vue_template__ = __webpack_require__(1999)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1433)
	
	/* script */
	__vue_exports__ = __webpack_require__(857)
	
	/* template */
	var __vue_template__ = __webpack_require__(2021)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-77b4615a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1252)
	
	/* script */
	__vue_exports__ = __webpack_require__(861)
	
	/* template */
	var __vue_template__ = __webpack_require__(1839)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-005ad9ac"
	
	module.exports = __vue_exports__


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1397)
	
	/* script */
	__vue_exports__ = __webpack_require__(862)
	
	/* template */
	var __vue_template__ = __webpack_require__(1986)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-66339272"
	
	module.exports = __vue_exports__


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1370)
	
	/* script */
	__vue_exports__ = __webpack_require__(863)
	
	/* template */
	var __vue_template__ = __webpack_require__(1958)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5378599a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1300)
	__webpack_require__(1301)
	
	/* script */
	__vue_exports__ = __webpack_require__(864)
	
	/* template */
	var __vue_template__ = __webpack_require__(1885)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2664b433"
	
	module.exports = __vue_exports__


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1384)
	
	/* script */
	__vue_exports__ = __webpack_require__(866)
	
	/* template */
	var __vue_template__ = __webpack_require__(1972)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5e5237ea"
	
	module.exports = __vue_exports__


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1507)
	
	/* script */
	__vue_exports__ = __webpack_require__(867)
	
	/* template */
	var __vue_template__ = __webpack_require__(2093)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1378)
	
	/* script */
	__vue_exports__ = __webpack_require__(868)
	
	/* template */
	var __vue_template__ = __webpack_require__(1966)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1326)
	
	/* script */
	__vue_exports__ = __webpack_require__(869)
	
	/* template */
	var __vue_template__ = __webpack_require__(1913)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3b2d2d90"
	
	module.exports = __vue_exports__


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1286)
	
	/* script */
	__vue_exports__ = __webpack_require__(870)
	
	/* template */
	var __vue_template__ = __webpack_require__(1872)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1c843ee9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1358)
	
	/* script */
	__vue_exports__ = __webpack_require__(871)
	
	/* template */
	var __vue_template__ = __webpack_require__(1945)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4d8f6905"
	
	module.exports = __vue_exports__


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1298)
	
	/* script */
	__vue_exports__ = __webpack_require__(872)
	
	/* template */
	var __vue_template__ = __webpack_require__(1882)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-25c82d0b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1502)
	
	/* script */
	__vue_exports__ = __webpack_require__(873)
	
	/* template */
	var __vue_template__ = __webpack_require__(2090)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-dd040532"
	
	module.exports = __vue_exports__


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1416)
	
	/* script */
	__vue_exports__ = __webpack_require__(874)
	
	/* template */
	var __vue_template__ = __webpack_require__(2004)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6dfa588b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(875)
	
	/* template */
	var __vue_template__ = __webpack_require__(1908)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(876)
	
	/* template */
	var __vue_template__ = __webpack_require__(1984)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(877)
	
	/* template */
	var __vue_template__ = __webpack_require__(2077)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(878)
	
	/* template */
	var __vue_template__ = __webpack_require__(1849)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(607)
	
	/* template */
	var __vue_template__ = __webpack_require__(1864)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', [_vm._v("Ratificações " + _vm._s(_vm.ehDoUsuario ? 'pendentes de aprovação' : '') + " ")]), _vm._v(" "), (!_vm.ehDoUsuario) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'edita-ratificacao'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Ratificação\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.ehDoUsuario) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'lista-ratificacao-pendentes'
	        })
	      }
	    }
	  }, [_vm._v("\n          Pendentes\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Remessa',
	        href: '#'
	      }, {
	        text: 'Lista de Ratificações',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaRatificacoes"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.listaRatificacoes,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.filtrar,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "id_processo",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "nome",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "data_solicitacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
	      }
	    }, {
	      key: "situacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "ultima_tarefa",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "resultado",
	      fn: function(row) {
	        return [(_vm.ehDoUsuario) ? _c('span', [(_vm._.includes(row.value, 'Sim')) ? _c('span', [_c('i', {
	          staticClass: "fa fa-check text-green",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Aprovado")]) : (_vm._.includes(row.value, 'Nao')) ? _c('span', [_c('i', {
	          staticClass: "fa fa-times text-red",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("Não aprovado")]) : _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v("Pendente")])]) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('span', [(row.item.ultima_tarefa === 'CONCLUSAO') ? _c('span', {
	          staticStyle: {
	            "color": "green"
	          }
	        }, [_vm._v("Aguarda conclusão"), _c('br'), _vm._v(_vm._s(row.value) + " assinatura(s)")]) : (row.item.ultima_tarefa === 'ASSINATURA_RATIFICACAO') ? _c('span', {
	          staticStyle: {
	            "color": "royalblue"
	          }
	        }, [_vm._v("Aguarda assinatura"), _c('br'), _vm._v(_vm._s(row.value) + " assinado(s)")]) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.item.ultima_tarefa]))])]) : _c('span', [_vm._v(" ")])])]
	      }
	    }, {
	      key: "acoes",
	      fn: function(row) {
	        return [(_vm.ehDoUsuario) ? _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo,
	                  assinar: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Abrir\n                          ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(row.item.resultado)) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo,
	                  visualizacao: true,
	                  assinar: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar\n                          ")]) : _vm._e()], 1) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar\n                          ")]) : _vm._e(), _vm._v(" "), (row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.cancelar(row.item.id_processo)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ban",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Cancelar\n                          ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo,
	                  visualizacao: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar\n                          ")])], 1)]
	      }
	    }])
	  })], 1)], 1)])])]), _vm._v(" "), (!_vm.ehDoUsuario) ? _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.listaRatificacoesConcluidas,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.filtrar,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "id_processo",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "data_solicitacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
	      }
	    }, {
	      key: "ultima_tarefa",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "situacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "nome",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "resultado",
	      fn: function(row) {
	        return [(_vm.ehDoUsuario) ? _c('span', [(_vm._.includes(row.value, 'Sim')) ? _c('span', [_c('i', {
	          staticClass: "fa fa-check text-green",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Aprovado")]) : (_vm._.includes(row.value, 'Nao')) ? _c('span', [_c('i', {
	          staticClass: "fa fa-times text-red",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("Não aprovado")]) : _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v("Pendente")])]) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('span', [(row.item.ultima_tarefa === 'CONCLUSAO') ? _c('span', {
	          staticStyle: {
	            "color": "green"
	          }
	        }, [_vm._v("Aguarda conclusão"), _c('br'), _vm._v(_vm._s(row.value) + " assinatura(s)")]) : (row.item.ultima_tarefa === 'ASSINATURA_RATIFICACAO') ? _c('span', {
	          staticStyle: {
	            "color": "royalblue"
	          }
	        }, [_vm._v("Aguarda assinatura"), _c('br'), _vm._v(_vm._s(row.value) + " assinado(s)")]) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.item.ultima_tarefa]))])]) : _c('span', [_vm._v(" ")])])]
	      }
	    }, {
	      key: "acoes",
	      fn: function(row) {
	        return [(_vm.ehDoUsuario) ? _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo,
	                  assinar: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Abrir\n                          ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(row.item.resultado)) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo,
	                  visualizacao: true,
	                  assinar: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar\n                          ")]) : _vm._e()], 1) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar\n                          ")]) : _vm._e(), _vm._v(" "), (row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.cancelar(row.item.id_processo)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ban",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Cancelar\n                          ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo,
	                  visualizacao: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar\n                          ")])], 1)]
	      }
	    }], null, false, 335110256)
	  })], 1)], 1)])])]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Em execução")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluídas e Canceladas")])])
	}]}

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Formalização',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ng-init": "check()"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.simplified),
	      expression: "proposta.simplified"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "hidden",
	      "name": "tipo",
	      "id": "tipo",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.proposta.simplified)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "simplified", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('NAME')"
	    }
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.idProjectErp),
	      expression: "proposta.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.name),
	      expression: "proposta.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorName),
	      expression: "proposta.coordinatorName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorCpf", $$v)
	      },
	      expression: "proposta.coordinatorCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorEmail),
	      expression: "proposta.coordinatorEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorPhone", $$v)
	      },
	      expression: "proposta.coordinatorPhone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorMobile", $$v)
	      },
	      expression: "proposta.coordinatorMobile"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Fax')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorFax", $$v)
	      },
	      expression: "proposta.coordinatorFax"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Fax')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.proposta.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                      " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                      " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                    ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.initialDate),
	      expression: "proposta.initialDate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control",
	      "type": "date",
	      "format": "DD/MM/YYYY",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.proposta.initialDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "initialDate", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periods),
	      expression: "proposta.periods"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.proposta.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.introduction),
	      expression: "proposta.introduction"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "introduction", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.presentation),
	      expression: "proposta.presentation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.territory),
	      expression: "proposta.territory"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.justification),
	      expression: "proposta.justification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.generalObjective),
	      expression: "proposta.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.summary),
	      expression: "proposta.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": this.proposta.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": this.proposta.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.teams = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.results),
	      expression: "proposta.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "results", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.operation),
	      expression: "proposta.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "operation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.partner),
	      expression: "proposta.partner"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "partner", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.proposta.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.proposta.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                ")])])]), _vm._v(" "), (_vm.proposta.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingName),
	      expression: "proposta.entityExecutingName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingProcurator),
	      expression: "proposta.entityExecutingProcurator"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|cnpj'),
	      expression: "'required:!proposta.entityIsExecutioner|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCNPJ", $$v)
	      },
	      expression: "proposta.entityExecutingCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingEmail),
	      expression: "proposta.entityExecutingEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|email'),
	      expression: "'required:!proposta.entityIsExecutioner|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingPhone", $$v)
	      },
	      expression: "proposta.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingMobile", $$v)
	      },
	      expression: "proposta.entityExecutingMobile"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingFax", $$v)
	      },
	      expression: "proposta.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.duplicateProject),
	      expression: "proposta.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber) + "/" + _vm._s(projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(7), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(9), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraCronograma),
	      expression: "mostraCronograma"
	    }],
	    staticClass: "col-md-12"
	  }, [_vm._m(10), _vm._v(" "), _c('cronograma', {
	    attrs: {
	      "proposta": _vm.proposta,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades,
	      "meses": _vm.proposta.periods,
	      "projeto-duplicacao": _vm.proposta.duplicateProject
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('gantt', {
	    attrs: {
	      "periodo": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades
	    }
	  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "proposta": _vm.proposta
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(12), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.careers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('solenizacao', {
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.proposta.solemnizations = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(14), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documents,
	      "documentTypes": _vm.proposta.documentTypes,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(15), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documentStatements,
	      "documentTypes": [],
	      "documentosObrigatorios": []
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(16), _vm._v(" "), _c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta
	    }
	  })], 1)], 1)])])]), _vm._v(" "), _c('aprovacao-projeto', {
	    attrs: {
	      "propsAnalise": _vm.analise
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                          outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	}]}

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "usuario"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.nome),
	      expression: "usuario.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "disabled": true,
	      "id": "nome",
	      "name": "nome",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.usuario.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O Nome do usuário é obrigatório')))]) : _vm._e()])]), _vm._v(" "), (_vm.usuario.tipo === 'ENTIDADE') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "cpf"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.cpf),
	      expression: "usuario.cpf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    },
	    attrs: {
	      "disabled": true,
	      "id": "cpf",
	      "name": "cpf",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.usuario.cpf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "cpf", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O CPF é obrigatório para esse usuário')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.email),
	      expression: "usuario.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    class: {
	      'has-error': _vm.errors.first('email')
	    },
	    attrs: {
	      "disabled": true,
	      "id": "email",
	      "name": "email",
	      "minlength": "1",
	      "maxlength": "255",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.usuario.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O E-mail é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Situação do usuário:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('b-form-group', [_c('b-form-radio-group', {
	    attrs: {
	      "id": "btn-radios-2",
	      "options": _vm.situacao_opcoes,
	      "size": "xg",
	      "name": "radio-btn-outline",
	      "button-variant": "inline-primary",
	      "buttons": ""
	    },
	    model: {
	      value: (_vm.usuario.ativo),
	      callback: function($$v) {
	        _vm.$set(_vm.usuario, "ativo", $$v)
	      },
	      expression: "usuario.ativo"
	    }
	  })], 1)], 1)])])]), _vm._v(" "), (this.$root.authorize('usuario-fundacao-atribuir-perfil')) ? _c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Perfis")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "items": _vm.table.items,
	      "hover": _vm.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.filter,
	      "current-page": _vm.table.currentPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Preencha o filtro acima!",
	      "table-layout:": "",
	      "fixed": "",
	      "tbody-tr-class": _vm.formatarLinhas
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "filtered": _vm.onFiltered
	    },
	    scopedSlots: _vm._u([{
	      key: "ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value == '1' ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "data_inicial",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "data_alteracao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "data_inativacao",
	      fn: function(row) {
	        return [_c('datepicker', {
	          directives: [{
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          attrs: {
	            "name": "data_inativar",
	            "id": "data_inativar",
	            "input-class": "form-control datepicker datapicker2",
	            "language": _vm.$datePickerPtBR,
	            "maxlength": "20",
	            "use-utc": true,
	            "placeholder": "__ /__ /____",
	            "open-date": new Date(),
	            "format": "dd/MM/yyyy"
	          },
	          on: {
	            "input": function($event) {
	              return _vm.alteradoPor(row.item)
	            }
	          },
	          model: {
	            value: (row.item.data_inativacao),
	            callback: function($$v) {
	              _vm.$set(row.item, "data_inativacao", $$v)
	            },
	            expression: "row.item.data_inativacao"
	          }
	        })]
	      }
	    }], null, false, 54454404)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal well well-sm",
	    attrs: {
	      "name": "novo_perfil"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3"
	  }, [_vm._v("Adicionar o perfil:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4",
	    class: {
	      'has-error': _vm.errors.first('perfil')
	    }
	  }, [_c('profiles', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    attrs: {
	      "name": "perfil",
	      "propsProfile": _vm.perfil_novo.perfil
	    },
	    on: {
	      "profileSelected": function($event) {
	        _vm.perfil_novo.perfil = $event
	      }
	    },
	    model: {
	      value: (_vm.perfil_novo.perfil),
	      callback: function($$v) {
	        _vm.$set(_vm.perfil_novo, "perfil", $$v)
	      },
	      expression: "perfil_novo.perfil"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('perfil')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('data_inicial')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "data_inicial"
	    }
	  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-1"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data_inicial",
	      "id": "data_inicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.perfil_novo.data_inicial),
	      callback: function($$v) {
	        _vm.$set(_vm.perfil_novo, "data_inicial", $$v)
	      },
	      expression: "perfil_novo.data_inicial"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('data_inicial')))])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "data_inativacao"
	    }
	  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-1"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "min": "2019-07-01",
	      "max": "2020-12-31",
	      "name": "data_inativacao",
	      "id": "data_inativacao",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "open-date": new Date(),
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.perfil_novo.data_inativacao),
	      callback: function($$v) {
	        _vm.$set(_vm.perfil_novo, "data_inativacao", $$v)
	      },
	      expression: "perfil_novo.data_inativacao"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-10 col-sm-offset-3"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "disabled": !_vm.$root.authorize('perfil-atribuir-usuario')
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.adicionaPerfil()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Incluir\n                      ")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.concluirAlteracoes($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro do usuário: ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin": "10px 0"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("- Para "), _c('b', [_vm._v("Retirar")]), _vm._v(" um acesso concedido, atribua uma data final ao perfil desejado na lista acima. Informando uma data menor que a atual, o acesso será interrompido de imediato.")]), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "darkblue"
	    }
	  }, [_vm._v("- Para "), _c('b', [_vm._v("Conceder")]), _vm._v(" um acesso, basta escolher abaixo um perfil da lista, informar a data da concessão e opcionalmente uma data de término")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "black"
	    }
	  }, [_c('i', [_vm._v("*Obs: A data 01/01/1900 é utilizada para identificar que o acesso em questão não tem vigência definida, portanto permanecerá ativo por tempo indeterminado.")])])])])
	}]}

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('div', {
	    staticClass: "content-wrapper column centered-start",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "column centered-start gerenciador-log-container"
	  }, [_c('div', {
	    staticClass: "column all-start log-title-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('i', {
	    staticClass: "fa fa-clock-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Última atualização: " + _vm._s(_vm.ultimaAtualizacao) + "\n          ")])]), _vm._v(" "), _c('b-container', {
	    staticClass: "table-log-container",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    key: _vm.tableDataKey,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": true,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "title": '<h5> Encerra Sessão de Edição. </h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.encerraSessao(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-close",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]
	      }
	    }, {
	      key: "ultimo_ping",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }], null, false, 53862275)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end prest-total-documentos"
	  }, [_c('div', [_vm._v("\n                    Total de Registros: "), _c('b', [_vm._v(_vm._s(_vm.table.items.length))])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "8",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "log-title row-flex centered-start"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                  Logs de Edição de Proposta\n          ")])
	}]}

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body municipalizacao"
	  }, [(_vm.travarMunicipios && _vm.existeMunicipioRepetido.length > 0) ? _c('div', {
	    staticClass: "column start-centered municipio-duplicidade-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', _vm._l((_vm.existeMunicipioRepetido), function(municipio) {
	    return _c('div', [_vm._v("\n        - " + _vm._s(municipio.ds_municipio) + " / " + _vm._s(municipio.ds_uf) + "\n      ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraGrid),
	      expression: "mostraGrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.formEditavel) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onNew
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Município")]), _vm._v(" "), (_vm.table.items.length > 0 && _vm._.includes(_vm.layout, 'COM_BOTOES_DISTRIBUICAO')) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "title": '<h5>Redistribuirá proporcionalmente, o total de <span class=\'realce\'>' + _vm.totais.participantes.projeto + '</span> participantes desse projeto nos <span class=\'realce\'>' + _vm.table.items.length + '</span> municípios abaixo (exceto contrapartidas)</h5>'
	    },
	    on: {
	      "click": _vm.distribuirParticipantes
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-server",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Participantes\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.table.items.length > 0 && _vm._.includes(_vm.layout, 'COM_BOTOES_DISTRIBUICAO')) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "title": '<h5>Redistribuirá proporcionalmente, o valor total de cada origem do recurso (fase) nos <span class=\'realce\'>' + _vm.table.items.length + '</span> municípios abaixo</h5>'
	    },
	    on: {
	      "click": _vm.distribuirValores
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-server",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Valores")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {}, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "max-height": "600px",
	      "overflow-y": "auto",
	      "overflow-x": "hidden",
	      "margin-bottom": "1rem"
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' ? _vm._.union(_vm.table.items, _vm._.filter(_vm.propsPropostaBackup.municipalizacao, function(m) {
	        return _vm._.includes(_vm._.get(_vm.processoSolicitacao, 'exclusao', []), m.id)
	      })) : _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "tbody-tr-class": _vm.modificacaoLinha,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([(!_vm.visaoReduzida) ? {
	      key: "ds_fase",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [(('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO') ? _c('span', {
	          staticClass: "pull-left"
	        }, [(_vm.ehItemNovo(row.item)) ? _c('span', {
	          staticClass: "label label-info"
	        }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), (_vm.ehItemExcluido(row.item)) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v("Excluído")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.etiquetaOrigemRecurso(row.value)))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_fase.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm.etiquetaOrigemRecurso('' + _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_fase.0', ''))) + "\n                  ")]) : _vm._e()])]
	      }
	    } : null, {
	      key: "ds_cep",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [_c('span', [_vm._v(_vm._s(_vm._f("cep")(('' + row.value))))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_cep.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._f("cep")(('' + _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_cep.0', '')))) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "ds_municipio",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [_c('span', [_vm._v(_vm._s(row.value) + " "), (_vm._.has(row.item, 'ds_uf')) ? _c('span', [_vm._v(" / " + _vm._s(row.item.ds_uf))]) : _vm._e()]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_municipio.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_municipio.0', '')) + "\n                  ")]) : _vm._e()])]
	      }
	    }, (!_vm.visaoReduzida) ? {
	      key: "dc_valor_municipio",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [_c('span', [_vm._v(_vm._s(_vm._f("real")(row.value)))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'dc_valor_municipio.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'dc_valor_municipio.0', ''))) + "\n                  ")]) : _vm._e()])]
	      }
	    } : null, {
	      key: "nr_total_participantes",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_total_participantes.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_total_participantes.0', '')) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(!_vm._.has(_vm.$route.params, 'numero') || _vm.formEditavel) ? _c('div', [(_vm.ehItemExcluido(row.item)) ? _c('span', [_c('b-button', {
	          staticClass: "btn btn-back btn-flat btn-sm",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.reincluir(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-refresh",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Desfazer")])], 1) : _c('span', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.confirmaExclusao(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir\n                    ")])], 1)]) : _vm._e()]
	      }
	    }], null, true)
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_c('tr', [(!_vm.visaoReduzida && _vm.totais.valor.projeto.fbb != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total Fundação")]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.parceiros != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.contrapartidas != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total Contrapartida")]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida) ? _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total do Projeto")]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Participantes")])]), _vm._v(" "), _c('tr', [(!_vm.visaoReduzida && _vm.totais.valor.projeto.fbb != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor",
	    attrs: {
	      "title": '<h5>Valor total da Fundação que já distribuiu em <span class=\'realce\'>' + (_vm._.countBy(_vm.table.items, function(m) {
	        return m.ds_fase === '1'
	      }))['true'] + '</span> município(s) acima</h5>'
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totais.valor.municipalizados.fbb)))])]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.parceiros != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor",
	    attrs: {
	      "title": '<h5>Valor total de Parceiro Estrtégico que já distribuiu em <span class=\'realce\'>' + (_vm._.countBy(_vm.table.items, function(m) {
	        return m.ds_fase === '5'
	      }))['true'] + '</span> município(s) acima</h5>'
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totais.valor.municipalizados.parceiros)))])]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.contrapartidas != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor",
	    attrs: {
	      "title": '<h5>Valor total de Contrapartida que já distribuiu em <span class=\'realce\'>' + (_vm._.countBy(_vm.table.items, function(m) {
	        return m.ds_fase === '2'
	      }))['true'] + '</span> município(s) acima</h5>'
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totais.valor.municipalizados.contrapartidas)))])]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida) ? _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor",
	    attrs: {
	      "title": '<h5>Valor total do projeto que já distribuiu em <span class=\'realce\'>' + _vm.table.items.length + '</span> registros(s) acima</h5>'
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")((_vm.totais.valor.municipalizados.fbb + _vm.totais.valor.municipalizados.parceiros + _vm.totais.valor.municipalizados.contrapartidas))))])]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor",
	    attrs: {
	      "title": '<h5>Total de participantes distribuídos em <span class=\'realce\'>' + _vm.table.items.length + '</span> registros(s) acima</h5>'
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.totais.participantes.municipalizados))])])]), _vm._v(" "), _c('tr', [(!_vm.visaoReduzida && _vm.totais.valor.projeto.fbb != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [(Math.abs(_vm.totais.valor.restantes.fbb) > 0.1) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor atencao",
	    attrs: {
	      "title": '<h5>' + (_vm.totais.valor.restantes.fbb < 0 ? 'Ultrapassou o valor máximo de R$ ' + _vm.totais.valor.projeto.fbb : 'Valor ainda Restante da Fundação que deve informar para qual município será destinado') + '</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor.restantes.fbb)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.parceiros != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [(Math.abs(_vm.totais.valor.restantes.parceiros) > 0.1) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor atencao",
	    attrs: {
	      "title": '<h5>' + (_vm.totais.valor.restantes.parceiros < 0 ? 'Ultrapassou o valor máximo de R$ ' + _vm.totais.valor.projeto.parceiros : 'Valor ainda Restante de Parceiro Estratégico que deve informar para qual município será destinado') + '</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor.restantes.parceiros)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.contrapartidas != 0) ? _c('td', {
	    staticClass: "centralizado"
	  }, [(Math.abs(_vm.totais.valor.restantes.contrapartidas) > 0.1) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor atencao",
	    attrs: {
	      "title": '<h5>' + (_vm.totais.valor.restantes.contrapartidas < 0 ? 'Ultrapassou o valor máximo de R$ ' + _vm.totais.valor.projeto.contrapartidas : 'Valor ainda Restante da Contrapartida que deve informar para qual município será destinado') + '</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor.restantes.contrapartidas)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida) ? _c('td', {
	    staticClass: "centralizado"
	  }, [(Math.abs(_vm.totais.valor.restantes.fbb + _vm.totais.valor.restantes.parceiros + _vm.totais.valor.restantes.contrapartidas) > 0.1) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor atencao",
	    attrs: {
	      "title": '<h5>Valor ainda Restante do projeto aguardando em qual município será destinado</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")((_vm.totais.valor.restantes.fbb + _vm.totais.valor.restantes.parceiros + _vm.totais.valor.restantes.contrapartidas))))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.participantes.restantes !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "valor atencao",
	    attrs: {
	      "title": '<h5>' + (_vm.totais.participantes.restantes < 0 ? 'Informou mais participantes do que há em publico-alvo<br/>Corrija e salve a proposta para continuar' : 'Total de participantes ainda Restante do projeto que deve informar a qual município faz parte') + '</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm.totais.participantes.restantes))]) : _vm._e()])])])])])], 1)])]), _vm._v(" "), (!_vm.mostraGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(!_vm.visaoReduzida) ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('origem')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cidade.ds_fase),
	      expression: "cidade.ds_fase"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "origem",
	      "aria-label": "Recurso"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.cidade, "ds_fase", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.selecionaFase]
	    }
	  }, [(_vm.temItemOrigem(1)) ? _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (_vm.temItemOrigem(2)) ? _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Contrapartida")]) : _vm._e(), _vm._v(" "), (_vm.temItemOrigem(5)) ? _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("Parceiro Estratégico")]) : _vm._e()])]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cep')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|max:8'),
	      expression: "'required|min:8|max:8'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cep",
	      "type": "text",
	      "disabled": _vm.loading.cepMunicipio,
	      "mask": "#####-###"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.buscaCidades([_vm.cidade])
	      }
	    },
	    model: {
	      value: (_vm.cidade.ds_cep),
	      callback: function($$v) {
	        _vm.$set(_vm.cidade, "ds_cep", $$v)
	      },
	      expression: "cidade.ds_cep"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "padding": "7px"
	    }
	  }, [(_vm.loading.cepMunicipio) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Consultando CEP ...")]) : (_vm.cidade.ds_municipio) ? _c('span', [_vm._v(_vm._s(_vm.cidade.ds_municipio) + " - " + _vm._s(_vm.cidade.ds_uf))]) : _vm._e()])]), _vm._v(" "), (!_vm.visaoReduzida) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('valor')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valor neste município:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:0|max_value:' + _vm.valorMaximo(_vm.cidade).toFixed(2)),
	      expression: "'required|min_value:0|max_value:' + valorMaximo(cidade).toFixed(2)"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "valor",
	      "type": "text",
	      "disabled": !_vm.cidade.ds_fase
	    },
	    model: {
	      value: (_vm.cidade.dc_valor_municipio),
	      callback: function($$v) {
	        _vm.$set(_vm.cidade, "dc_valor_municipio", $$v)
	      },
	      expression: "cidade.dc_valor_municipio"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('valor')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('número de participantes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Número de participantes:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addMunCtrl.approval",
	      "state": "addMunCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cidade.nr_total_participantes),
	      expression: "cidade.nr_total_participantes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        numeric: true
	      }),
	      expression: "{required: true, numeric: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "número de participantes",
	      "type": "number",
	      "min": "0",
	      "disabled": ('' + _vm.cidade.ds_fase === '2')
	    },
	    domProps: {
	      "value": (_vm.cidade.nr_total_participantes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cidade, "nr_total_participantes", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (('' + _vm.cidade.ds_fase === '2')) ? _c('span', {
	    staticClass: "alerta"
	  }, [_c('br'), _vm._v("Contrapartida não deve ter participantes")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('número de participantes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número de participantes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-md-offset-2"
	  }, [(!_vm.loading.cepMunicipio && (_vm._.isNil(_vm.processoSolicitacao) || _vm.cidade.dc_valor_municipio > 0)) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atenção, existe(m) município(s) cadastrado(s) em duplicidade, favor regularizar antes de criar o número do projeto")])
	}]}

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [(!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um dirigente",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onNew()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Oculta os dirigentes inativados ou mostra todos os dirigentes",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.inativosOcultados = !_vm.inativosOcultados
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.inativosOcultados ? 'Mostrar Inativos' : 'Somente Ativos'))])]), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_insercao",
	    attrs: {
	      "title": '<h5>Inclusões: ' + _vm.inclDirTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a inserção de novo(s) dirigentes(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_exclusao",
	    attrs: {
	      "title": '<h5>Exclusões: ' + _vm.excDirTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a exclusão de dirigentes(s)")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "tableDirigentes",
	    attrs: {
	      "how-empty": "",
	      "stacked": "md",
	      "id": "dirigentes-table",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "tbody-tr-class": _vm.inativosMostrarOcultar,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "ds_nome",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value) + "    "), _c('span', {
	          staticStyle: {
	            "color": "cornflowerblue"
	          }
	        }, [_vm._v(_vm._s(row.item.cargo.ds_descricao))])]
	      }
	    }, {
	      key: "dt_inicio_mandato",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "dt_fim_mandato",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.disable) ? _c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Detalhar")])], 1) : _c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-offset-0 fa-lg"
	        }, [(_vm.arr[0] == row.index || _vm.arr[1] == row.index || _vm.arr[2] == row.index || _vm.arr[3] == row.index || _vm.arr[4] == row.index || _vm.arr[5] == row.index || _vm.arr[6] == row.index || _vm.arr[7] == row.index || _vm.arr[8] == row.index) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'left'
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
	          }],
	          staticClass: "fa fa-warning",
	          staticStyle: {
	            "position": "relative",
	            "top": "8px",
	            "margin-left": "2px",
	            "color": "#fb2916"
	          },
	          attrs: {
	            "title": '<h5>Clique em editar para ver as mudanças.</h5>'
	          }
	        }) : _vm._e()])], 1)]
	      }
	    }, {
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.state === 'FORM'),
	      expression: "state === 'FORM'"
	    }],
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    },
	    attrs: {
	      "name": "frmAddChief"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": _vm.disable
	    }
	  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome do dirigente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nome') && _vm._.hasIn(_vm.texto, 'ds_nome')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_nome + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_nome),
	      expression: "dirigentes.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:5|max:255'),
	      expression: "'required|min:5|max:255'"
	    }],
	    ref: "Nome do dirigente",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome do dirigente",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    domProps: {
	      "value": (_vm.dirigentes.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes, "ds_nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome do dirigente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome do dirigente')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('active')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'bt_ativo') && _vm._.hasIn(_vm.texto, 'bt_ativo')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_ativo + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Status:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.dirigentes.bt_ativo),
	      expression: "dirigentes.bt_ativo",
	      modifiers: {
	        "number": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "active"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.dirigentes.bt_ativo, _vm._n(1))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.dirigentes, "bt_ativo", _vm._n(1))
	      }
	    }
	  }), _vm._v(" Ativo\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.dirigentes.bt_ativo),
	      expression: "dirigentes.bt_ativo",
	      modifiers: {
	        "number": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "active"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.dirigentes.bt_ativo, _vm._n(0))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.dirigentes, "bt_ativo", _vm._n(0))
	      }
	    }
	  }), _vm._v(" Inativo\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('active')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Status é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Estado civil')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Estado civil"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_estado_civil') && _vm._.hasIn(_vm.texto, 'ds_estado_civil')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_estado_civil + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Estado civil:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_estado_civil),
	      expression: "dirigentes.ds_estado_civil"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Estado civil",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Estado civil"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.dirigentes, "ds_estado_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "SOLTEIRO"
	    }
	  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CASADO"
	    }
	  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DIVORCIADO"
	    }
	  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "VIUVO"
	    }
	  }, [_vm._v("Viúvo(a)")])]), _vm._v(" "), (_vm.errors.first('Estado civil')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Estado Civil é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Data de nascimento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Data de nascimento"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'dt_data_nascimento') && _vm._.hasIn(_vm.texto, 'dt_data_nascimento')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.dt_data_nascimento + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Data de nascimento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dt_data_nascimento),
	      expression: "dt_data_nascimento"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast|date_format:dd/MM/yyyy|after:01/01/1900'),
	      expression: "'required|validdate|dateeqpast|date_format:dd/MM/yyyy|after:01/01/1900'"
	    }],
	    ref: "Data de nascimento",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "Data de nascimento",
	      "data-vv-as": "Data de nascimento",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.dt_data_nascimento)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dt_data_nascimento = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Data de nascimento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Data de nascimento')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Sexo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Sexo"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_gender') && _vm._.hasIn(_vm.texto, 'ds_gender')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_gender + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Gênero:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_gender),
	      expression: "dirigentes.ds_gender"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Sexo",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Sexo",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.dirigentes, "ds_gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "MASCULINO"
	    }
	  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "FEMININO"
	    }
	  }, [_vm._v("Feminino")])]), _vm._v(" "), (_vm.errors.first('Sexo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Sexo é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Profissão')
	    },
	    attrs: {
	      "disabled": _vm.bloqueioCampos === true
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Profissão"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_profissao') && _vm._.hasIn(_vm.texto, 'ds_profissao')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_profissao + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Profissão:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_profissao),
	      expression: "dirigentes.ds_profissao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:5|max:255'),
	      expression: "'required|min:5|max:255'"
	    }],
	    ref: "Profissão",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Profissão",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.dirigentes.ds_profissao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes, "ds_profissao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Profissão')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Profissão')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CPF')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "CPF"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_cpf') && _vm._.hasIn(_vm.texto, 'ds_cpf')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_cpf + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    ref: "CPF",
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.bloqueioCampos === true,
	      "name": "CPF",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.dirigentes.ds_cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.dirigentes, "ds_cpf", $$v)
	      },
	      expression: "dirigentes.ds_cpf"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CPF')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CPF do Dirigente é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nacionalidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nacionalidade"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nacionalidade') && _vm._.hasIn(_vm.texto, 'ds_nacionalidade')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_nacionalidade + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Nacionalidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_nacionalidade),
	      expression: "dirigentes.ds_nacionalidade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:5|max:255'),
	      expression: "'required|min:5|max:255'"
	    }],
	    ref: "Nacionalidade",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nacionalidade",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    domProps: {
	      "value": (_vm.dirigentes.ds_nacionalidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes, "ds_nacionalidade", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nacionalidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nacionalidade')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('RG')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "RG"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_rg') && _vm._.hasIn(_vm.texto, 'ds_rg')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_rg + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                RG:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_rg),
	      expression: "dirigentes.ds_rg"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:5||max:20'),
	      expression: "'required|min:5||max:20'"
	    }],
	    ref: "RG",
	    staticClass: "form-control",
	    attrs: {
	      "name": "RG",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    domProps: {
	      "value": (_vm.dirigentes.ds_rg)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes, "ds_rg", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('RG')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('RG')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.has('UF')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "placeOfBirth"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_naturalidade') && _vm._.hasIn(_vm.texto, 'ds_naturalidade')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_naturalidade + '</h5>'
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_uf') && _vm._.hasIn(_vm.texto, 'ds_uf')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_uf + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n\n                Naturalidade / UF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 junto"
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_naturalidade),
	      expression: "dirigentes.ds_naturalidade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('min:3|max:255'),
	      expression: "'min:3|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Naturalidade",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    domProps: {
	      "value": (_vm.dirigentes.ds_naturalidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes, "ds_naturalidade", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Naturalidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Naturalidade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_uf),
	      expression: "dirigentes.ds_uf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "UF",
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.dirigentes, "ds_uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.estados), function(uf) {
	    return _c('option', {
	      domProps: {
	        "value": uf
	      }
	    }, [_vm._v(_vm._s(uf))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.errors.has('UF')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.has('UF do RG')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "rgOrgaoEmissor"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_orgao_emissor') && _vm._.hasIn(_vm.texto, 'ds_orgao_emissor')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_orgao_emissor + '</h5>'
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_rg_uf') && _vm._.hasIn(_vm.texto, 'ds_rg_uf')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_rg_uf + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n\n                Org. Emissor / UF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 junto"
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_orgao_emissor),
	      expression: "dirigentes.ds_orgao_emissor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('min:2|max:20'),
	      expression: "'min:2|max:20'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "emissor",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    domProps: {
	      "value": (_vm.dirigentes.ds_orgao_emissor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes, "ds_orgao_emissor", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_rg_uf),
	      expression: "dirigentes.ds_rg_uf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "UF do RG",
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF do RG",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.dirigentes, "ds_rg_uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.estados), function(uf) {
	    return _c('option', {
	      domProps: {
	        "value": uf
	      }
	    }, [_vm._v(_vm._s(uf))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.errors.has('UF do RG')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF do RG')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  })]), _vm._v(" "), _c('fieldset', [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cep')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cep"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_cep') && _vm._.hasIn(_vm.texto, 'endereco.ds_cep')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_cep + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                CEP:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:9'),
	      expression: "'required|max:9'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cep",
	      "type": "text",
	      "mask": "#####-###"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.buscaCEP($event)
	      }
	    },
	    model: {
	      value: (_vm.dirigentes.endereco.ds_cep),
	      callback: function($$v) {
	        _vm.$set(_vm.dirigentes.endereco, "ds_cep", $$v)
	      },
	      expression: "dirigentes.endereco.ds_cep"
	    }
	  }), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CEP é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Cidade"
	    }
	  }, [_vm._v("\n                Cidade / UF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dirigentes.endereco.ds_cidade || _vm.dirigentes.endereco.ds_estado),
	      expression: "dirigentes.endereco.ds_cidade || dirigentes.endereco.ds_estado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    },
	    domProps: {
	      "innerHTML": _vm._s((_vm.dirigentes.endereco.ds_cidade || '') + ' / ' + (_vm.dirigentes.endereco.ds_estado || ''))
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Endereço')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Endereço"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_rua') && _vm._.hasIn(_vm.texto, 'endereco.ds_rua')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_rua + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Endereço:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.endereco.ds_rua),
	      expression: "dirigentes.endereco.ds_rua"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:5|max:60'),
	      expression: "'required|min:5|max:60'"
	    }],
	    ref: "Endereço",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.dirigentes.endereco.ds_rua)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes.endereco, "ds_rua", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Endereço')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Número')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Número"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_numero') && _vm._.hasIn(_vm.texto, 'endereco.ds_numero')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_numero + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Número:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.endereco.ds_numero),
	      expression: "dirigentes.endereco.ds_numero"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:7'),
	      expression: "'required|min:1|max:7'"
	    }],
	    ref: "Número",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Número",
	      "required": "",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.dirigentes.endereco.ds_numero)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes.endereco, "ds_numero", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Número')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Complemento"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_complemento') && _vm._.hasIn(_vm.texto, 'endereco.ds_complemento')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_complemento + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Complemento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.endereco.ds_complemento),
	      expression: "dirigentes.endereco.ds_complemento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:20'),
	      expression: "'max:20'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Complemento",
	      "maxlength": "20",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.dirigentes.endereco.ds_complemento)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes.endereco, "ds_complemento", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Complemento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Complemento')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Bairro"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_bairro') && _vm._.hasIn(_vm.texto, 'endereco.ds_bairro')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_bairro + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Bairro:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.endereco.ds_bairro),
	      expression: "dirigentes.endereco.ds_bairro"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:32'),
	      expression: "'max:32'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Bairro",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.dirigentes.endereco.ds_bairro)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes.endereco, "ds_bairro", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Bairro')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Bairro')))]) : _vm._e()])])])])]), _vm._v(" "), _c('fieldset', [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_telefone') && _vm._.hasIn(_vm.texto, 'contato.ds_telefone')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.contato.ds_telefone + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10|max:11'),
	      expression: "'required|min:10|max:11'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.dirigentes.contato.ds_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.dirigentes.contato, "ds_telefone", $$v)
	      },
	      expression: "dirigentes.contato.ds_telefone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Celular"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_celular') && _vm._.hasIn(_vm.texto, 'contato.ds_celular')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.contato.ds_celular + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Celular",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.dirigentes.contato.ds_celular),
	      callback: function($$v) {
	        _vm.$set(_vm.dirigentes.contato, "ds_celular", $$v)
	      },
	      expression: "dirigentes.contato.ds_celular"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Fax"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_fax') && _vm._.hasIn(_vm.texto, 'contato.ds_fax')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.contato.ds_fax + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Fax:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "fax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.dirigentes.contato.ds_fax),
	      callback: function($$v) {
	        _vm.$set(_vm.dirigentes.contato, "ds_fax", $$v)
	      },
	      expression: "dirigentes.contato.ds_fax"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('email do dirigente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email do dirigente"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_email') && _vm._.hasIn(_vm.texto, 'ds_email')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_email + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                E-mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.ds_email),
	      expression: "dirigentes.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do dirigente",
	      "data-vv-as": "E-mail",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.dirigentes.ds_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dirigentes, "ds_email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('email do dirigente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do dirigente')))]) : _vm._e()])])])])]), _vm._v(" "), _c('fieldset', [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Data Inicial"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'dt_inicio_mandato') && _vm._.hasIn(_vm.texto, 'dt_inicio_mandato')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + (_vm.texto.dt_inicio_mandato | _vm.moment('L')) + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Data Inicial:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dt_inicio_mandato),
	      expression: "dt_inicio_mandato"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast|date_format:dd/MM/yyyy|after:01/01/1900'),
	      expression: "'required|validdate|dateeqpast|date_format:dd/MM/yyyy|after:01/01/1900'"
	    }],
	    ref: "Data Inicial",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "Data Inicial",
	      "name": "Data Inicial",
	      "data-vv-as": "Data Inicial",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.dt_inicio_mandato)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dt_inicio_mandato = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Data Inicial')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Data Inicial')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Data Final')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Data Final"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'dt_fim_mandato') && _vm._.hasIn(_vm.texto, 'dt_fim_mandato')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + (_vm.texto.dt_fim_mandato | _vm.moment('L')) + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Data Final:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dt_fim_mandato),
	      expression: "dt_fim_mandato"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|date_format:dd/MM/yyyy|after:Data Inicial'),
	      expression: "'required|validdate|date_format:dd/MM/yyyy|after:Data Inicial'"
	    }],
	    ref: "Data Final",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "Data Final",
	      "name": "Data Final",
	      "data-vv-as": "Data Final",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.dt_fim_mandato)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dt_fim_mandato = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Data Final')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Data Final')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('positionMandate')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "positionMandate"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'cargo') && _vm._.hasIn(_vm.texto, 'cargo')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.cargo.ds_descricao + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Cargo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigentes.cargo),
	      expression: "dirigentes.cargo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "positionMandate",
	    staticClass: "form-control",
	    attrs: {
	      "name": "positionMandate"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.dirigentes, "cargo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.mandatos), function(mandato) {
	    return _c('option', {
	      domProps: {
	        "value": mandato
	      }
	    }, [_vm._v(_vm._s(mandato.ds_codigo + ' - ' + mandato.ds_descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('positionMandate')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Cargo é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('p', [_vm._v(" * Se o cargo for '12 - Designado(a)', incluir "), _c('a', {
	    attrs: {
	      "href": _vm.urlLaravel + '/docs/modelo_termo_de_designacao.docx'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Termo de Designação")]), _vm._v(" nos Anexos do Dirigente/Designado")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Assina pela entidade?')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Assina pela entidade?"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'bt_assinatura_entidade') && _vm._.hasIn(_vm.texto, 'bt_assinatura_entidade')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_assinatura_entidade + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Assina pela entidade?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.dirigentes.bt_assinatura_entidade),
	      expression: "dirigentes.bt_assinatura_entidade",
	      modifiers: {
	        "number": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "Assina pela entidade?"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.dirigentes.bt_assinatura_entidade, _vm._n(1))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.dirigentes, "bt_assinatura_entidade", _vm._n(1))
	      }
	    }
	  }), _vm._v(" Sim\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.dirigentes.bt_assinatura_entidade),
	      expression: "dirigentes.bt_assinatura_entidade",
	      modifiers: {
	        "number": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "Assina pela entidade?"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.dirigentes.bt_assinatura_entidade, _vm._n(0))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.dirigentes, "bt_assinatura_entidade", _vm._n(0))
	      }
	    }
	  }), _vm._v(" Não\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('Assina pela entidade?')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Assina pela entidade é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Assinatura é obrigatória?')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Assinatura é obrigatória?"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'bt_assinatura_requerida') && _vm._.hasIn(_vm.texto, 'bt_assinatura_requerida')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_assinatura_requerida + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                Assinatura é obrigatória?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.dirigentes.bt_assinatura_requerida),
	      expression: "dirigentes.bt_assinatura_requerida",
	      modifiers: {
	        "number": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "Assinatura é obrigatória?"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.dirigentes.bt_assinatura_requerida, _vm._n(1))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.dirigentes, "bt_assinatura_requerida", _vm._n(1))
	      }
	    }
	  }), _vm._v(" Sim\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.dirigentes.bt_assinatura_requerida),
	      expression: "dirigentes.bt_assinatura_requerida",
	      modifiers: {
	        "number": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "Assinatura é obrigatória?"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.dirigentes.bt_assinatura_requerida, _vm._n(0))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.dirigentes, "bt_assinatura_requerida", _vm._n(0))
	      }
	    }
	  }), _vm._v(" Não\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('Assinatura é obrigatória?')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Assinatura é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('É representante legal?')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "É representante legal?"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'bt_representante_legal') && _vm._.hasIn(_vm.texto, 'bt_representante_legal')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_representante_legal + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n                É representante legal?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.dirigentes.bt_representante_legal),
	      expression: "dirigentes.bt_representante_legal",
	      modifiers: {
	        "number": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "É representante legal?"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.dirigentes.bt_representante_legal, _vm._n(1))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.dirigentes, "bt_representante_legal", _vm._n(1))
	      }
	    }
	  }), _vm._v(" Sim\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.dirigentes.bt_representante_legal),
	      expression: "dirigentes.bt_representante_legal",
	      modifiers: {
	        "number": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "É representante legal?"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.dirigentes.bt_representante_legal, _vm._n(0))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.dirigentes, "bt_representante_legal", _vm._n(0))
	      }
	    }
	  }), _vm._v(" Não\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('É representante legal?')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Representante legal é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), (!_vm._.includes([12, 13], _vm._.get(_vm.dirigentes, 'cargo.ds_codigo', 0))) ? _c('fieldset', {
	    attrs: {
	      "id": "cadastroEmpresasLigadasDirigentes"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("\n              Adicione abaixo participação em empresa a qual faça parte. Se nenhuma empresa for adicionada será considerado que não está ligado a nenhuma empresa exceto "), _c('i', [_vm._v(_vm._s(_vm.entidadeParceira.ds_nome))])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "150px",
	      "text-align": "center"
	    }
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "150px",
	      "text-align": "center"
	    }
	  }, [_vm._v("Data Desligamento")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "180px",
	      "text-align": "center"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.adicionaEmpresaLigada(_vm.dirigentes)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Adiciona empresa")])])])]), _vm._v(" "), _c('tbody', [((_vm._.get(_vm.dirigentes, 'dados.empresas', [])).length === 0) ? [_vm._m(5)] : _vm._l((_vm._.get(_vm.dirigentes, 'dados.empresas', [])), function(empresa, idxEmpresa) {
	    return _c('tr', [(_vm._.isNull(empresa.inclusao)) ? [_c('td', [_c('div', {
	      staticClass: "required-field",
	      class: {
	        'has-error': _vm.errors.first('CNPJ_' + idxEmpresa)
	      }
	    }, [_c('the-mask', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required|min:14|max:14|cnpj'),
	        expression: "'required|min:14|max:14|cnpj'"
	      }],
	      staticClass: "form-control",
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "name": 'CNPJ_' + idxEmpresa,
	        "type": "text",
	        "mask": "NN.NNN.NNN/NNNN-##",
	        "tokens": _vm.$cnpjTokens
	      },
	      model: {
	        value: (empresa.cnpj),
	        callback: function($$v) {
	          _vm.$set(empresa, "cnpj", $$v)
	        },
	        expression: "empresa.cnpj"
	      }
	    }), _vm._v(" "), (_vm.errors.first('CNPJ_' + idxEmpresa)) ? _c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ_' + idxEmpresa)))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "required-field",
	      class: {
	        'has-error': _vm.errors.first('razao_social_empresa_' + idxEmpresa)
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (empresa.nome),
	        expression: "empresa.nome"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "name": 'razao_social_empresa_' + idxEmpresa,
	        "maxlength": "500"
	      },
	      domProps: {
	        "value": (empresa.nome)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(empresa, "nome", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (_vm.errors.first('razao_social_empresa_' + idxEmpresa)) ? _c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v(" Razão Social da empresa é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "input-group"
	    }, [_c('datepicker', {
	      ref: "data_desligamento",
	      refInFor: true,
	      attrs: {
	        "name": "data_desligamento",
	        "input-class": "form-control",
	        "language": _vm.$datePickerPtBR,
	        "maxlength": "20",
	        "placeholder": "__ /__ /____",
	        "format": "dd/MM/yyyy"
	      },
	      model: {
	        value: (empresa.desligamento),
	        callback: function($$v) {
	          _vm.$set(empresa, "desligamento", $$v)
	        },
	        expression: "empresa.desligamento"
	      }
	    }), _vm._v(" "), (!_vm._.isNull(empresa.desligamento)) ? _c('span', {
	      staticClass: "input-group-btn"
	    }, [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large'
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	      }],
	      staticClass: "btn btn-default btn-flat",
	      attrs: {
	        "type": "button",
	        "title": '<h5>Exclui data de desligamento</h5>'
	      },
	      on: {
	        "click": function($event) {
	          empresa.desligamento = null
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-danger btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.dirigentes.dados.empresas.splice(idxEmpresa, 1)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])])] : [_c('td', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_vm._v(_vm._s(_vm._f("cnpj")(empresa.cnpj)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(empresa.nome))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [(!_vm._.isNull(empresa.desligamento)) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm._f("moment")(empresa.desligamento, "L")) + "\n                    ")]) : _c('span', [_c('datepicker', {
	      ref: "data_desligamento",
	      refInFor: true,
	      attrs: {
	        "name": "data_desligamento",
	        "input-class": "form-control",
	        "language": _vm.$datePickerPtBR,
	        "maxlength": "20",
	        "placeholder": "__ /__ /____",
	        "format": "dd/MM/yyyy"
	      },
	      model: {
	        value: (empresa.desligamento),
	        callback: function($$v) {
	          _vm.$set(empresa, "desligamento", $$v)
	        },
	        expression: "empresa.desligamento"
	      }
	    }), _vm._v(" "), (!_vm._.isNull(empresa.desligamento)) ? _c('span', {
	      staticClass: "input-group-btn"
	    }, [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large'
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	      }],
	      staticClass: "btn btn-default btn-flat",
	      attrs: {
	        "type": "button",
	        "title": '<h5>Exclui data de desligamento</h5>'
	      },
	      on: {
	        "click": function($event) {
	          empresa.desligamento = null
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center",
	        "font-weight": "bold",
	        "color": "var(--cor-destaque)"
	      }
	    }, [_vm._v("Não pode ser excluído")])]], 2)
	  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_c('b', [_vm._v("  Anexos do Dirigente/Designado:")]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'documentos') && _vm._.hasIn(_vm.texto, 'documentos')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.dirigentes.documentos,
	      "documentTypes": '',
	      "disable": '',
	      "localUso": _vm.listaDocDirigentes,
	      "salvouOK": _vm.salvouOK
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.frmAddChief)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar Dirigente")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onCancel(_vm.frmAddChief)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("  Dados pessoais:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("  Endereço:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("  Contato:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("  Período do mandato:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v(" Participação em Empresas:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Não esta ou esteve ligado a nenhuma empresa nos últimos 12 meses")])])
	}]}

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h2', {
	    staticClass: "h4",
	    on: {
	      "click": function($event) {
	        _vm.mostrar = false
	      }
	    }
	  }, [_vm._v("Agência")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('agencia')
	    },
	    attrs: {
	      "uib-tooltip": "Prefixo da Agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "agencia"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar = false
	      }
	    }
	  }, [_vm._v("Agência:")]), _vm._v(" "), (_vm.propsProposta.ds_agencia_nome && _vm.mostrar === false) ? _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_agencia_nome),
	      expression: "proposta.ds_agencia_nome"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "prefixo",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_agencia_nome)
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar = true
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_agencia_nome", $event.target.value)
	      }
	    }
	  })]) : (_vm.mostrar === true) ? _c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticStyle: {
	      "font-size": "4px"
	    },
	    attrs: {
	      "options": _vm.agencias,
	      "custom-label": _vm.numeroNomeAgencia,
	      "placeholder": "Selecione uma agência",
	      "label": "type",
	      "track-by": "type",
	      "preselect-first": false,
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "selectedLabel": "",
	      "name": "agencia"
	    },
	    on: {
	      "open": _vm.buscaAgencias,
	      "select": _vm.buscaAgencia
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.agenciaSelecionada),
	      callback: function($$v) {
	        _vm.agenciaSelecionada = $$v
	      },
	      expression: "agenciaSelecionada"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ agência')
	    },
	    attrs: {
	      "uib-tooltip": "CNPJ da Agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "CNPJ agência"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255|cnpj'),
	      expression: "'required|max:255|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ agência",
	      "id": "CNPJ agência",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.ds_agencia_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_agencia_cnpj", $$v)
	      },
	      expression: "proposta.ds_agencia_cnpj"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('endereço da agência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "endereço da agência"
	    }
	  }, [_vm._v("Endereço da agência:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_agencia_endereco),
	      expression: "proposta.ds_agencia_endereco"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "endereço da agência",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_agencia_endereco)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_agencia_endereco", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('endereço da agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço da agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('telefone agência')
	    },
	    attrs: {
	      "uib-tooltip": "Telefone da agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "telefone agência"
	    }
	  }, [_vm._v("Telefone da agência:")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "telefone agência",
	      "id": "telefone agência",
	      "mask": ['####-####', '(##) ####-####', '(##) #####-####'],
	      "type": "text",
	      "maxlength": "255"
	    },
	    model: {
	      value: (_vm.proposta.ds_agencia_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_agencia_telefone", $$v)
	      },
	      expression: "proposta.ds_agencia_telefone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('telefone agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('email agência')
	    },
	    attrs: {
	      "uib-tooltip": "E-mail da agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "email agência"
	    }
	  }, [_vm._v("E-mail da agência:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_agencia_email),
	      expression: "proposta.ds_agencia_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255|email'),
	      expression: "'required|max:255|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email agência",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_agencia_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_agencia_email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email agência')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Gerente")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('nome gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Nome do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "nome gerente"
	    }
	  }, [_vm._v("Nome do Gerente:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_gerente_nome),
	      expression: "proposta.ds_gerente_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome gerente",
	      "id": "nome gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_gerente_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_gerente_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('profissão do gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Profissão do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "profissão do gerente"
	    }
	  }, [_vm._v("Profissão:")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.managerOccupation",
	      "approval": "propSimpleCtrl.approval",
	      "state": "propSimpleCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_gerente_profissao),
	      expression: "proposta.ds_gerente_profissao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "profissão do gerente",
	      "id": "profissão do gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_gerente_profissao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_gerente_profissao", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('profissão do gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('profissão do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('uf gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "uf gerente"
	    }
	  }, [_vm._v(" UF: ")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_gerente_uf),
	      expression: "proposta.ds_gerente_uf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "uf gerente",
	      "id": "uf gerente"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "ds_gerente_uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.proposta.ds_gerente_uf,
	      "selected": _vm.proposta.ds_gerente_uf
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.ds_gerente_uf))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('uf gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('uf gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('cidade do gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Cidade do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "cidade do gerente"
	    }
	  }, [_vm._v("Cidade:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_gerente_cidade),
	      expression: "proposta.ds_gerente_cidade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cidade do gerente",
	      "id": "cidade do gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_gerente_cidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_gerente_cidade", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('cidade do gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cidade do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('estado civil gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "estado civil gerente"
	    }
	  }, [_vm._v("Estado Civil:")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_gerente_estado_civil),
	      expression: "proposta.ds_gerente_estado_civil"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "estado civil gerente",
	      "id": "estado civil gerente"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "ds_gerente_estado_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.proposta.ds_gerente_estado_civil,
	      "selected": _vm.proposta.ds_gerente_estado_civil
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.ds_gerente_estado_civil))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOLTEIRO"
	    }
	  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CASADO"
	    }
	  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DIVORCIADO"
	    }
	  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "VIUVO"
	    }
	  }, [_vm._v("Viúvo(a)")])])]), _vm._v(" "), (_vm.errors.first('estado civil gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('estado civil gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CPF gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "managerCpf"
	    }
	  }, [_vm._v(" CPF: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:11|cpf'),
	      expression: "'required|max:11|cpf'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CPF gerente",
	      "id": "CPF gerente",
	      "mask": ['###.###.###-##']
	    },
	    model: {
	      value: (_vm.proposta.ds_gerente_cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_gerente_cpf", $$v)
	      },
	      expression: "proposta.ds_gerente_cpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CPF gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF gerente')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Funcionário agência")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('matrícula do funcionário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "matrícula do funcionário"
	    }
	  }, [_vm._v(" Matrícula do funcionário: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|length:7'),
	      expression: "'required|length:7'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "matrícula do funcionário",
	      "placeholder": "Insira a matricula. Somente números e sem dígito.",
	      "mask": '#######'
	    },
	    nativeOn: {
	      "change": function($event) {
	        return _vm.selectFuncionario(_vm.proposta.ds_funcionario_matricula)
	      }
	    },
	    model: {
	      value: (_vm.proposta.ds_funcionario_matricula),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_funcionario_matricula", $$v)
	      },
	      expression: "proposta.ds_funcionario_matricula"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('matrícula do funcionário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('matrícula do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('funcionário responsável')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "funcionário responsável"
	    }
	  }, [_vm._v(" Funcionário responsável pelo projeto: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_funcionario_nome),
	      expression: "proposta.ds_funcionario_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "funcionário responsável",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_funcionario_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_funcionario_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('funcionário responsável')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('funcionário responsável')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('telefone do funcionário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "telefone do funcionário"
	    }
	  }, [_vm._v(" Telefone fixo: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "name": "telefone do funcionário",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.proposta.ds_funcionario_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_funcionario_telefone", $$v)
	      },
	      expression: "proposta.ds_funcionario_telefone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('telefone do funcionário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "e-mail funcionário"
	    }
	  }, [_vm._v(" E-mail do funcionário: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_funcionario_email),
	      expression: "proposta.ds_funcionario_email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "e-mail funcionário",
	      "id": "e-mail funcionário",
	      "type": "email"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_funcionario_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_funcionario_email", $event.target.value)
	      }
	    }
	  })])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Agência condutora do projeto")])])
	}]}

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": _vm.titulo
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('fieldset', [_c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Razão social"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_nome),
	      expression: "entidade.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.entidade.ds_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
	      },
	      expression: "entidade.ds_cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpjExpeditionTime')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cnpjExpeditionTime"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.dt_data_expedicao_cnpj),
	      expression: "entidade.dt_data_expedicao_cnpj"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "date",
	      "format": _vm.formatDate
	    },
	    domProps: {
	      "value": (_vm.entidade.dt_data_expedicao_cnpj)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "dt_data_expedicao_cnpj", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome fantasia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome fantasia"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_nome_fantasia),
	      expression: "entidade.ds_nome_fantasia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Nome fantasia",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome fantasia",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_nome_fantasia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_nome_fantasia", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('forma_juridica')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "forma_jurídica"
	    }
	  }, [_vm._v(" Natureza jurídica: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaFormasJuridicas,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione uma Natureza Jurídica",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaListaFormaJuridica,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "forma_juridica",
	      "data-vv-as": "Natureza jurídica"
	    },
	    model: {
	      value: (_vm.entidade.forma_juridica),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "forma_juridica", $$v)
	      },
	      expression: "entidade.forma_juridica"
	    }
	  }), _vm._v(" "), (_vm.errors.first('forma_juridica')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma_juridica')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('ramos_atividade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "ramos_atividade"
	    }
	  }, [_vm._v(" Ramos de Atividade: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaRamosAtividade,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione os Ramos de Atividade",
	      "label": "ds_codigo",
	      "track-by": "ds_codigo",
	      "custom-label": _vm.etiquetaListaRamosAtividade,
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "ramos_atividade",
	      "data-vv-as": "Ramos de Atividade"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.ds_codigo))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.entidade.ramos_atividade),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "ramos_atividade", $$v)
	      },
	      expression: "entidade.ramos_atividade"
	    }
	  }), _vm._v(" "), (_vm.errors.first('ramos_atividade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('ramos_atividade')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('listaDocConstituicao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "listaDocConstituicao"
	    }
	  }, [_vm._v(" Documento de constituição: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaDocConstituicao,
	      "multiple": false,
	      "close-on-select": true,
	      "searchable": false,
	      "track-by": "id",
	      "label": "ds_tipo",
	      "placeholder": "Selecione um Documento de constituição",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "listaDocConstituicao",
	      "data-vv-as": "Documento de constituição"
	    },
	    model: {
	      value: (_vm.entidade.documento_constituicao),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "documento_constituicao", $$v)
	      },
	      expression: "entidade.documento_constituicao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('listaDocConstituicao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('listaDocConstituicao')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6",
	    attrs: {
	      "id": "contato"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [(_vm.entidade.contato) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.contato.ds_telefone),
	      expression: "entidade.contato.ds_telefone"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) ####-#####'),
	      expression: "'(##) ####-#####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1'),
	      expression: "'required|min:1'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "Telefone",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.contato.ds_telefone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade.contato, "ds_telefone", $event.target.value)
	      }
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "mobile"
	    }
	  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [(_vm.entidade.contato) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.contato.ds_celular),
	      expression: "entidade.contato.ds_celular"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) #####-#####'),
	      expression: "'(##) #####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "mobile",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.contato.ds_celular)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade.contato, "ds_celular", $event.target.value)
	      }
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_email),
	      expression: "entidade.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Email",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Email",
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo E-mail é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_website),
	      expression: "entidade.ds_website"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:255'),
	      expression: "'max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "website",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_website)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_website", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "possuiCebas"
	    }
	  }, [_vm._v("Possui CEBAS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiCebas),
	      expression: "possuiCebas"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "possuiCebas"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiCebas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "possuiCmas"
	    }
	  }, [_vm._v("Possui CMAS/CAS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiCmas),
	      expression: "possuiCmas"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "possuiCmas"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiCmas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(1), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.entidade.endereco,
	      "disable": _vm.disable
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.entidade.dirigentes,
	      "entidadeParceira": _vm.entidade,
	      "name": "dirigentes",
	      "disable": _vm.disable
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('assinaturaDirigentes', {
	    attrs: {
	      "visualiza": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('usuarios', {
	    attrs: {
	      "entUsuarios": _vm.entidade.usuarios,
	      "disable": _vm.disable
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.entidade.documentos,
	      "documentTypes": '',
	      "disable": _vm.disable,
	      "local-uso": 'TODOS'
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(6), _vm._v(" "), _c('historico-entidade', {
	    attrs: {
	      "entHistorico": _vm.historico
	    }
	  })], 1)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Entidade - Visualização")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Assina convênio com a Fundação BB:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Usuários da entidade:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico:")])])])
	}]}

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "eventDate",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm:ss")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              _vm.showModal = true, _vm.testFunc(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), (_vm.loadingShow) ? _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.showModal) ? _c('div', [_c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper",
	    on: {
	      "click": function($event) {
	        return _vm.$emit(_vm.showModal = false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Histórico")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ng-init": "check()"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.simplified),
	      expression: "proposta.simplified"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "hidden",
	      "name": "tipo",
	      "id": "tipo",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.proposta.simplified)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "simplified", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": "true"
	    }
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('NAME')"
	    }
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.idProjectErp),
	      expression: "snap.snapshot.proposal.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.name),
	      expression: "snap.snapshot.proposal.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "name", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": "true"
	    }
	  }, [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.coordinatorName),
	      expression: "snap.snapshot.proposal.coordinatorName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "coordinatorName", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [(this.$router.currentRoute.name === 'proposta-visualiza') ? _c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "coordinatorCpf", $$v)
	      },
	      expression: "snap.snapshot.proposal.coordinatorCpf"
	    }
	  }) : _vm._e(), _vm._v(" "), (this.$router.currentRoute.name !== 'proposta-visualiza') ? _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "coordinatorCpf", $$v)
	      },
	      expression: "snap.snapshot.proposal.coordinatorCpf"
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.coordinatorEmail),
	      expression: "snap.snapshot.proposal.coordinatorEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "coordinatorPhone", $$v)
	      },
	      expression: "snap.snapshot.proposal.coordinatorPhone"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "coordinatorMobile", $$v)
	      },
	      expression: "snap.snapshot.proposal.coordinatorMobile"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Fax')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "coordinatorFax", $$v)
	      },
	      expression: "snap.snapshot.proposal.coordinatorFax"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.snap.snapshot.proposal.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.snap.snapshot.proposal.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                          " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                          " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                        ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.snap.snapshot.proposal.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.initialDate),
	      expression: "snap.snapshot.proposal.initialDate"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-isolate-scope ng-valid-maxlength ng-valid-date ng-valid-mask ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "disabled": "true",
	      "name": "Data Inicial",
	      "type": "date",
	      "placeholder": "__/__/____",
	      "maxlength": "20"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.initialDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "initialDate", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('span', {
	    staticClass: "btn btn-default"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.periods),
	      expression: "snap.snapshot.proposal.periods"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "disabled": "true",
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.introduction),
	      expression: "snap.snapshot.proposal.introduction"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "disabled": "true",
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "introduction", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.presentation),
	      expression: "snap.snapshot.proposal.presentation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "disabled": "true",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.territory),
	      expression: "snap.snapshot.proposal.territory"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "disabled": "true",
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.justification),
	      expression: "snap.snapshot.proposal.justification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "disabled": "true",
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.generalObjective),
	      expression: "snap.snapshot.proposal.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "disabled": "true",
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.summary),
	      expression: "snap.snapshot.proposal.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "disabled": "true",
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])]), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": this.snap.snapshot.proposal.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.snap.snapshot.proposal.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])]), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": this.snap.snapshot.proposal.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.snap.snapshot.proposal.teams = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.results),
	      expression: "snap.snapshot.proposal.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "true",
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "results", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.operation),
	      expression: "snap.snapshot.proposal.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "true",
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "operation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.partner),
	      expression: "snap.snapshot.proposal.partner"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "true",
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "partner", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12",
	    attrs: {
	      "disabled": "true"
	    }
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.entityIsExecutioner),
	      expression: "snap.snapshot.proposal.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.snap.snapshot.proposal.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.snap.snapshot.proposal.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.snap.snapshot.proposal, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                    ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.entityIsExecutioner),
	      expression: "snap.snapshot.proposal.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.snap.snapshot.proposal.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.snap.snapshot.proposal.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.snap.snapshot.proposal, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                    ")])])]), _vm._v(" "), (_vm.snap.snapshot.proposal.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.entityExecutingName),
	      expression: "snap.snapshot.proposal.entityExecutingName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.entityExecutingProcurator),
	      expression: "snap.snapshot.proposal.entityExecutingProcurator"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|cnpj'),
	      expression: "'required:!proposta.entityIsExecutioner|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['##.###.###/####-##']
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingCNPJ", $$v)
	      },
	      expression: "snap.snapshot.proposal.entityExecutingCNPJ"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.entityExecutingEmail),
	      expression: "snap.snapshot.proposal.entityExecutingEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|email'),
	      expression: "'required:!proposta.entityIsExecutioner|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingPhone", $$v)
	      },
	      expression: "snap.snapshot.proposal.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingMobile", $$v)
	      },
	      expression: "snap.snapshot.proposal.entityExecutingMobile"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingFax", $$v)
	      },
	      expression: "snap.snapshot.proposal.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.snap.snapshot.proposal.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingCEP", $$v)
	      },
	      expression: "snap.snapshot.proposal.entityExecutingCEP"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.entityExecutingState),
	      expression: "snap.snapshot.proposal.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.entityExecutingCity),
	      expression: "snap.snapshot.proposal.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.entityExecutingAddress),
	      expression: "snap.snapshot.proposal.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.proposal.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.proposal, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.proposal.duplicateProject),
	      expression: "snap.snapshot.proposal.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "disabled": "true",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.snap.snapshot.proposal, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber + ' / ' + projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])]), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.snap.snapshot.proposal.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.snap.snapshot.proposal.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])]), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.snap.snapshot.proposal.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.snap.snapshot.proposal.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])]), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.snap.snapshot.proposal.periods,
	      "propsObjetivos": _vm.snap.snapshot.proposal.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.snap.snapshot.proposal.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraCronograma),
	      expression: "mostraCronograma"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])]), _vm._v(" "), _c('cronograma', {
	    attrs: {
	      "propsObjetivos": _vm.snap.snapshot.proposal.objectives,
	      "meses": _vm.snap.snapshot.proposal.periods,
	      "atividades": _vm.atividades,
	      "projeto-duplicacao": _vm.snap.snapshot.proposal.duplicateProject
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('gantt', {
	    attrs: {
	      "periodo": _vm.snap.snapshot.proposal.periods,
	      "propsObjetivos": _vm.snap.snapshot.proposal.objectives,
	      "atividades": _vm.atividades
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])]), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "snap": _vm.snap.snapshot.proposal
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.snap.snapshot.proposal = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])]), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.snap.snapshot.proposal.careers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])]), _vm._v(" "), _c('solenizacao', {
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.snap.snapshot.proposal.solemnizations = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])]), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.snap.snapshot.proposal.documents,
	      "documentTypes": _vm.snap.snapshot.proposal.documentTypes
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                              outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])]), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.snap.snapshot.proposal.documentStatements,
	      "documentTypes": []
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('br'), _vm._v(" "), _c('b-button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button",
	      "disabled": false
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Fechar ")])], 1)])])])])])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }]
	  }, [_c('pre', {
	    ref: "myDiv",
	    attrs: {
	      "id": "myDiv"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Relatórios BI'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
	    attrs: {
	      "name": "frmRegNotice",
	      "novalidate": "",
	      "_lpchecked": "1"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "tipoDoRelatorio"
	    }
	  }, [_vm._v("Relatório:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio),
	      expression: "relatorio"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "tipoRelatorio"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.relatorio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.relatorios), function(relatorio) {
	    return _c('option', {
	      domProps: {
	        "value": relatorio
	      }
	    }, [_vm._v(_vm._s(relatorio.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.show = !_vm.show
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Gerar ")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onClean($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")])], 1), _vm._v(" "), (_vm.show) ? _c('div', {
	    attrs: {
	      "id": "painel"
	    }
	  }, [_c('iframe', {
	    staticStyle: {
	      "height": "1000px",
	      "width": "10000px"
	    },
	    attrs: {
	      "src": _vm.relatorio.link,
	      "frameborder": "0",
	      "allowfullscreen": "true"
	    }
	  })]) : _vm._e()])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Relatórios")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-picture-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Relatórios BI")])])
	}]}

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.form.errors.has(_vm.field)) ? _c('div', {
	    staticClass: "help-block invalid-feedback",
	    domProps: {
	      "innerHTML": _vm._s(_vm.form.errors.get(_vm.field))
	    }
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "contentWrapper",
	    staticClass: "content-wrapper",
	    style: ('min-height: ' + _vm.alturaContentWrapper + 'px'),
	    attrs: {
	      "id": "liquidacoes"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Tratamento de Retorno'
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v(" Liquidação Financeira")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Retorno',
	        href: '#'
	      }, {
	        text: 'Tratamento de Retorno',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content",
	    staticStyle: {
	      "padding-top": "20px"
	    }
	  }, [_c('p', {
	    staticClass: "visible-sm visible-xs nao_imprimir"
	  }, [_vm._v(" ")]), _c('p', {
	    staticClass: "visible-xs nao_imprimir"
	  }, [_vm._v(" ")]), _c('p', {
	    staticClass: "visible-xs nao_imprimir"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget nao_imprimir"
	  }, [_vm._m(1), _vm._v(" "), _c('span', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay box box-widget",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm.loading.retornos) ? _c('div', {
	    staticClass: "col-lg-4"
	  }, [_vm._m(2)]) : _c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.retornos,
	      "multiple": false,
	      "placeholder": "Selecione um lote de arquivos de Retorno",
	      "label": "rotulo",
	      "track-by": "numerador",
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "retorno",
	      "value": _vm.usu_nomarq
	    },
	    on: {
	      "input": _vm.buscarConteudoArquivoRetorno
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [(props.option.usu_datoco === 'Data do retorno') ? _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "col-md-6"
	        }, [_vm._v(_vm._s(props.option.usu_datoco))]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-3 centralizar_elemento"
	        }, [_vm._v("Arquivos")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-3 centralizar_elemento"
	        }, [_vm._v("Registros")])]) : _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "col-md-6"
	        }, [_vm._v(_vm._s(_vm._f("moment")(props.option.usu_datoco, "L")))]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-3 centralizar_elemento"
	        }, [_c('div', {
	          staticClass: "contadorRegistros",
	          domProps: {
	            "innerHTML": _vm._s(props.option.ArquivosRetorno)
	          }
	        })]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-3 centralizar_elemento"
	        }, [_c('div', {
	          staticClass: "contadorRegistros",
	          domProps: {
	            "innerHTML": _vm._s(props.option.QtdeRegistros)
	          }
	        })])])]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "etiquetaRetorno"
	        }, [_c('span', {
	          staticClass: "text-bold"
	        }, [_vm._v(_vm._s(_vm._f("moment")(props.option.usu_datoco, 'L')))]), _vm._v(" Arquivos: "), _c('span', {
	          staticClass: "contadorRegistros"
	        }, [_vm._v(_vm._s(props.option.ArquivosRetorno) + " ")]), _vm._v(" Registros: "), _c('span', {
	          staticClass: "contadorRegistros"
	        }, [_vm._v(_vm._s(props.option.QtdeRegistros) + " ")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.retorno),
	      callback: function($$v) {
	        _vm.retorno = $$v
	      },
	      expression: "retorno"
	    }
	  }, [_c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1), _vm._v(" "), (_vm.processamentoRetorno.length > 0 && _vm._.get(_vm.retorno, 'usu_tiparq', 'PREVIA') !== 'PREVIA') ? _c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Processará o(s) <span class=\'realce\'>' + (_vm.retorno.ArquivosRetorno) + '</span> arquivo(s) abaixo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.processarRetorno()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" Processa retorno")])], 1) : _vm._e(), _vm._v(" "), (_vm.processamentoRetorno.length > 0) ? _c('span', [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._v(" ")]), _vm._v(" "), (_vm.processamentoRetorno.length > 0) ? _c('div', {}, [_c('div', {
	    staticClass: "col-xs-5"
	  }, [_c('div', {
	    staticClass: "btn-group dropdown",
	    staticStyle: {
	      "padding": "6px 0"
	    }
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('span', {
	    staticClass: "esmaecido",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("\n                      Resumo: "), _c('span', {
	    staticStyle: {
	      "color": "var(--cor-azul)",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s((_vm._.keys(_vm._.groupBy(_vm.processamentoRetorno, 'usu_nomarq'))).length))]), _vm._v(" arquivo(s) "), _c('i', {
	    staticClass: "fa fa-exclamation-circle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu"
	  }, [_c('table', {
	    staticClass: "table table-striped",
	    staticStyle: {
	      "width": "400px"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm._.groupBy(_vm.processamentoRetorno, 'usu_nomarq')), function(titulos, arquivo) {
	    return _c('tr', {
	      attrs: {
	        "role": "menuitem"
	      }
	    }, [_c('td', [_vm._v(_vm._s(arquivo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(titulos[0].usu_tiparq))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((_vm._.filter(titulos, ['processamento', 1])).length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((_vm._.filter(titulos, ['processamento', 2])).length))])])
	  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-style": "italic",
	      "color": "var(--cor-fraca)"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Total de "), _c('span', {
	    staticStyle: {
	      "color": "var(--cor-azul)"
	    }
	  }, [_vm._v(_vm._s(_vm.processamentoRetorno.length))]), _vm._v(" título(s)")]), _c('th', {
	    staticStyle: {
	      "color": "var(--cor-verde)"
	    }
	  }, [_vm._v(_vm._s((_vm._.filter(_vm.processamentoRetorno, ['processamento', 1])).length))]), _c('th', {
	    staticStyle: {
	      "color": "var(--cor-vermelha)"
	    }
	  }, [_vm._v(_vm._s((_vm._.filter(_vm.processamentoRetorno, ['processamento', 2])).length))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-7 pull-right"
	  }, [_c('span', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ordenacao.por),
	      expression: "ordenacao.por"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "auto",
	      "float": "left"
	    },
	    attrs: {
	      "title": '<h5>Selecione por qual critério deseja ordenar</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.ordenacao, "por", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "id"
	    }
	  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "processamento"
	    }
	  }, [_vm._v("Com ou Sem Erros")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "usu_octban"
	    }
	  }, [_vm._v("Código Retorno")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "usu_nomarq"
	    }
	  }, [_vm._v("Arquivo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "usu_numtit"
	    }
	  }, [_vm._v("Número do Título")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "numarb"
	    }
	  }, [_vm._v("Número da Remessa")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "vlrmov"
	    }
	  }, [_vm._v("Valor")])]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "btn btn-default btn-flat",
	    staticStyle: {
	      "float": "left"
	    },
	    attrs: {
	      "type": "button",
	      "title": '<h5>Clique para inverter a ordenação</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.ordenacao.ordem = _vm.ordenacao.ordem === 'asc' ? 'desc' : 'asc'
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-sort-alpha-' + _vm.ordenacao.ordem,
	    staticStyle: {
	      "font-size": "14px"
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-xs-12"
	  }, _vm._l((_vm.ordenacao.por === 'vlrmov' ?
	    _vm._.orderBy(_vm.processamentoRetorno, [function(termo) {
	      return parseFloat(termo[_vm.ordenacao.por])
	    }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
	    _vm._.orderBy(_vm.processamentoRetorno, [_vm.ordenacao.por], [_vm.ordenacao.ordem])), function(titulo) {
	    return _c('div', {
	      ref: titulo.usu_numtit + titulo.usu_codtpt + titulo.usu_codfor,
	      refInFor: true,
	      class: 'tarefa col-xs-12 ' + ('retornoProcessamento' + titulo.processamento)
	    }, [_c('div', {
	      staticClass: "col-lg-1 col-md-2 col-sm-3 col-xs-3",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('span', {
	      staticClass: "indicadores"
	    }, [_c('span', {
	      staticClass: "text-muted",
	      domProps: {
	        "innerHTML": _vm._s(titulo.id)
	      }
	    }), _vm._v(" "), (_vm._.has(titulo, 'loading')) ? _c('p', {
	      class: 'label label-' + titulo.loading.classe
	    }, [_vm._v(_vm._s(titulo.loading.texto))]) : _c('p', {
	      staticClass: "truncar",
	      class: titulo.situacao === 'EM_EXECUCAO' ? 'text-green' : 'text-blue'
	    }, [_vm._v(_vm._s(_vm.enumeradores[titulo.situacao]))])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-3 col-md-5 col-sm-9 col-xs-9",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('div', {
	      staticClass: "text-bold truncar"
	    }, [_vm._v(_vm._s(titulo.usu_octban) + " - " + _vm._s(_vm._.get(_vm._.find(_vm.ocorrencias, ['OctBan', titulo.usu_octban]), 'DesBan', '')))]), _vm._v(" "), _c('div', {
	      staticClass: "truncar"
	    }, [_vm._v(" " + _vm._s(titulo.usu_desban))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1 col-md-2 col-sm-3 col-xs-5 alinha_vertical",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('div', {}, [_vm._v(_vm._s(titulo.usu_numtit))]), _vm._v(" "), _c('div', [_c('span', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(titulo.usu_codtpt))]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(titulo.usu_codfor))])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-2 col-md-3 col-sm-4 col-xs-7 alinha_vertical",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('div', [_c('span', {
	      staticClass: "text-blue"
	    }, [_vm._v(_vm._s(titulo.numarb))]), _vm._v(" / " + _vm._s(titulo.numcco))]), _vm._v(" "), _c('div', {
	      staticClass: "truncar"
	    }, [_vm._v(_vm._s(titulo.tippgt) + " - " + _vm._s(_vm.tiposPagamento[titulo.tippgt]))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-2 col-md-4 col-sm-5 col-xs-5 alinha_vertical",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [(('' + titulo.codfpg) === '4') ? _c('div', {
	      staticClass: "truncar"
	    }, [_vm._v(_vm._s(titulo.codbar))]) : _c('div', [_vm._v(_vm._s(titulo.codban) + " "), _c('span', {
	      staticClass: "esmaecido"
	    }, [_vm._v("/")]), _vm._v(" " + _vm._s(titulo.codage) + " "), _c('span', {
	      staticClass: "esmaecido"
	    }, [_vm._v("/")]), _vm._v(" " + _vm._s(titulo.ccbfor))]), _vm._v(" "), _c('div', {
	      staticClass: "truncar"
	    }, [_vm._v(_vm._s(titulo.codfpg) + " - " + _vm._s(titulo.desfpg))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1 col-md-3 col-sm-3 col-xs-7 alinha_vertical text-center",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('div', {
	      staticClass: "esmaecido"
	    }, [_vm._v(_vm._s(titulo.sittit))]), _vm._v(" "), (titulo.sittit === 'LQ' && (!_vm._.isNull(titulo.usu_autbb) || (_vm._.trim(titulo.usu_autban)).length > 5)) ? _c('div', {
	      staticClass: "truncar"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay:[500, 0]}"
	      }],
	      staticClass: "label label-default clicavel",
	      attrs: {
	        "title": '<h5>Autenticação bancária. Clique para gerar comprovante</h5>'
	      },
	      on: {
	        "click": function($event) {
	          _vm.emitir611(_vm._.trim(titulo.usu_numtit), _vm._.trim(titulo.usu_codfor))
	        }
	      }
	    }, [_vm._v("\n                      " + _vm._s(!_vm._.isNull(titulo.usu_autbb) ? titulo.usu_autbb : (_vm._.trim(titulo.usu_autban)).length > 5 ? titulo.usu_autban : '') + "\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1 col-md-3 col-sm-4 col-xs-7",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('span', {
	      staticClass: "text-muted"
	    }, [_vm._v(_vm._s(_vm._f("real")(titulo.vlrmov)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("real")(titulo.vlrliq)))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1 col-md-2 col-sm-5 col-xs-5 text-right",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [(titulo.sittit !== 'LQ') ? _c('g-button-ujarak', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (false),
	        expression: "false"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss",
	        "title": '<h5>Excluirá este títulos da remessa</h5>'
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.excluirTituloArquivoRetorno(titulo)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-ban",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]) : _vm._e()], 1), _vm._v(" "), (_vm._.has(titulo, 'retorno')) ? _c('div', {
	      staticClass: "box-body"
	    }, _vm._l((_vm._.get(titulo, 'retorno', [])), function(detalhe) {
	      return _c('span', {
	        class: 'label ' + (_vm._.includes(_vm._.toLower(detalhe.RDesBan), 'erro') ? 'label-danger' : (_vm._.isEmpty(_vm._.trim(detalhe.ROctBan)) ? 'label-warning' : 'label-success'))
	      }, [_vm._v(_vm._s(detalhe.RDesBan)), _c('br')])
	    }), 0) : _vm._e()])
	  }), 0)])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "w100 imprimir"
	  }, [_c('tr', [_c('td', [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "direita"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "40px !important"
	    }
	  }, [_vm._v("Títulos Diversos")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-truck"
	  }), _vm._v(" Retorno de Pagamento Eletrônico")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Retornos...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('th', [_vm._v("Arquivo")]), _c('th', [_vm._v("Tipo")]), _c('th', [_c('i', {
	    staticClass: "fa fa-check",
	    staticStyle: {
	      "color": "var(--cor-verde)",
	      "font-weight": "bold"
	    }
	  })]), _c('th', [_c('i', {
	    staticClass: "fa fa-ban",
	    staticStyle: {
	      "color": "var(--cor-vermelha)",
	      "font-weight": "bold"
	    }
	  })])])])
	}]}

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Simplificado")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Simplificado',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
	    attrs: {
	      "name": "frmRegNotice",
	      "novalidate": "",
	      "_lpchecked": "1"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('numeroProcesso')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "noticeNumber"
	    }
	  }, [_vm._v("Número do Processo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.processo.simplifiedNumber),
	      expression: "processo.simplifiedNumber"
	    }],
	    staticClass: "form-control ng-pristine ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required ng-touched",
	    staticStyle: {
	      "background-image": "url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4EaVTO26DQBD1ohQWaS2lg9JybZ+AK7hNwx2oIoVf4UPQ0Lj1FdKktevIpel8AKNUkDcWMxpgSaIEaTVv3sx7uztiTdu2s/98DywOw3Dued4Who/M2aIx5lZV1aEsy0+qiwHELyi+Ytl0PQ69SxAxkWIA4RMRTdNsKE59juMcuZd6xIAFeZ6fGCdJ8kY4y7KAuTRNGd7jyEBXsdOPE3a0QGPsniOnnYMO67LgSQN9T41F2QGrQRRFCwyzoIF2qyBuKKbcOgPXdVeY9rMWgNsjf9ccYesJhk3f5dYT1HX9gR0LLQR30TnjkUEcx2uIuS4RnI+aj6sJR0AM8AaumPaM/rRehyWhXqbFAA9kh3/8/NvHxAYGAsZ/il8IalkCLBfNVAAAAABJRU5ErkJggg==\")",
	      "background-repeat": "no-repeat",
	      "background-attachment": "scroll",
	      "background-size": "16px 18px",
	      "background-position": "98% 50%"
	    },
	    attrs: {
	      "name": "numeroProcesso",
	      "type": "text",
	      "minlength": "1",
	      "ng-maxlength": "255",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.processo.simplifiedNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.processo, "simplifiedNumber", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('numeroProcesso')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('numeroProcesso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "active"
	    }
	  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.processo.active),
	      expression: "processo.active"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status",
	      "checked": "",
	      "value": "true"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.processo.active, true)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.processo, "active", true)
	      }
	    }
	  }), _vm._v(" Sim\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.processo.active),
	      expression: "processo.active"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status",
	      "value": "false"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.processo.active, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.processo, "active", false)
	      }
	    }
	  }), _vm._v(" Não\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('dataInicial')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "initialDate"
	    }
	  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.processo.initialDate),
	      callback: function($$v) {
	        _vm.$set(_vm.processo, "initialDate", $$v)
	      },
	      expression: "processo.initialDate"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('dataInicial')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataInicial')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('dataFinal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "endDate"
	    }
	  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataFinal",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.processo.endDate),
	      callback: function($$v) {
	        _vm.$set(_vm.processo, "endDate", $$v)
	      },
	      expression: "processo.endDate"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('dataFinal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataFinal')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.processo.id),
	      expression: "processo.id"
	    }],
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "createdAt"
	    }
	  }, [_vm._v("Data criação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "createdAt",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.processo.createdAt, 'DD-MM-YYYY HH:MM')
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "updatedAt"
	    }
	  }, [_vm._v("Data atualização:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "updatedAt",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.processo.updatedAt, 'DD-MM-YYYY HH:MM')
	    }
	  })])]), _vm._v(" "), (_vm.processo.id) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.processo.id && _vm.processo.inactivateDateTime),
	      expression: "processo.id && processo.inactivateDateTime"
	    }],
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "inactivateDateTime"
	    }
	  }, [_vm._v("Data inativação:")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.processo.id && _vm.processo.inactivateDateTime),
	      expression: "processo.id && processo.inactivateDateTime"
	    }],
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "inactivateDateTime",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.processo.inactivateDateTime, 'DD-MM-YYYY HH:MM')
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-md-2 ng-scope",
	    attrs: {
	      "for": "changedBy"
	    }
	  }, [_vm._v("Alterado por:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 ng-scope"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "changedBy",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.processo.changedBy
	    }
	  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.salva
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Simplificado")])])
	}]}

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first(_vm.nomeCampo)
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(_vm._s(_vm.nomeCampo))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telefone),
	      expression: "telefone"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: (['(##) ####-####', '(##) #####-####']),
	      expression: "['(##) ####-####', '(##) #####-####']"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": _vm.nomeCampo,
	      "type": "tel"
	    },
	    domProps: {
	      "value": (_vm.telefone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.telefone = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first(_vm.nomeCampo)) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first(_vm.nomeCampo)))]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), (!_vm.telaProjeto) ? _c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_vm._v("\n        Cadastro de ODS\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editando && !_vm.detalhamento) ? _c('div', {
	    staticClass: "ods-button-tag"
	  }, [_c('i', {
	    class: _vm.mostrarTodos ? 'fa fa-check-circle-o' : 'fa fa-star',
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(!_vm.mostrarTodos ? 'Favoritos Fundação BB' : 'Todos ODS') + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "ods-cadastro-container"
	  }, [(!_vm.editando && !_vm.detalhamento) ? _c('div', {
	    staticClass: "ods-button-alterar-container"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.abrirEdicao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                Editar Cadastro de ODS")]), _vm._v(" "), (this.odsCadastrado.length <= 0) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.buscarODSCadastro()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true",
	      "title": "Buscar ODS cadastrado"
	    }
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editando && !_vm.detalhamento) ? _c('div', {
	    staticClass: "ods-search-input"
	  }, [_c('multiselect', {
	    staticClass: "multiselect-ods",
	    attrs: {
	      "options": _vm.baseODS,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "custom-label": _vm.customLabel,
	      "show-labels": false,
	      "group-values": "metas",
	      "group-label": "ods",
	      "track-by": "descricao",
	      "label": "numeroMeta",
	      "placeholder": "Selecione ou Pesquise as Metas do ODS",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover"
	    },
	    scopedSlots: _vm._u([{
	      key: "selection",
	      fn: function(values) {
	        return [_c('div', {
	          staticClass: "ods-items-lista",
	          domProps: {
	            "innerHTML": _vm._s(_vm.customTag(values.values))
	          }
	        })]
	      }
	    }], null, false, 737918590),
	    model: {
	      value: (_vm.odsSelecionado),
	      callback: function($$v) {
	        _vm.odsSelecionado = $$v
	      },
	      expression: "odsSelecionado"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editando && !_vm.detalhamento) ? _c('b-container', {
	    staticClass: "ods-table",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "idOds",
	      fn: function(row) {
	        return [_c('div', {
	          class: 'cor-' + row.item.idOds
	        }, [_c('img', {
	          staticClass: "ods-img",
	          attrs: {
	            "src": _vm.getImageODS(row.item.idOds),
	            "alt": "ODS IMG"
	          }
	        })])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.detalharLinha(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Detalhar")])]
	      }
	    }], null, false, 54715329)
	  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.editando && !_vm.detalhamento) ? _c('div', {
	    staticClass: "ods-button-cadastro-container-m"
	  }, [(_vm.editando) ? _c('div', {
	    staticClass: "ods-button-filtro"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudarVisualizacao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrows",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.mostrarTodos ? 'Mostrar Favoritos FBB' : 'Mostrar Todos ODS'))])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.salvarODS()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n        Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelarEdicao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n        Cancelar")])]) : _vm._e(), _vm._v(" "), (_vm.detalhamento) ? _c('div', {
	    staticClass: "detalhamento-ods-container"
	  }, [_c('div', {
	    staticClass: "detalhamento-ods-titulo",
	    class: 'cor-' + this.itemDetalhamento.idOds
	  }, [_c('div', [_c('img', {
	    staticClass: "ods-img",
	    attrs: {
	      "src": _vm.getImageODS(this.itemDetalhamento.idOds),
	      "alt": "ODS IMG"
	    }
	  })]), _vm._v("\n        " + _vm._s(this.itemDetalhamento.ods) + "\n      ")]), _vm._v(" "), _vm._l((this.itemDetalhamento.metas), function(meta) {
	    return _c('div', {
	      staticClass: "detalhamento-ods-meta"
	    }, [_vm._v("\n        " + _vm._s(meta) + "\n      ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.detalhamento) ? _c('div', {
	    staticClass: "ods-button-cadastro-container-m"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.detalhamento = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n        Voltar")])]) : _vm._e(), _vm._v(" "), _c('vue-snotify')], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [(_vm.fep.id) ? _c('vue-headful', {
	    attrs: {
	      "title": 'SGP - FEP ' + _vm.fep.id
	    }
	  }) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "content-header ng-scope"
	  }, [(_vm.fep) ? _c('h1', [_vm._v("Ficha de Enquadramento de Projetos  -  FEP  Nº  " + _vm._s(_vm.fep.ano) + "/" + _vm._s(_vm.fep.numero) + "\n      "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "title": '<h5>Gera a FEP abaixo de forma resumida em Excel</h5>'
	    }
	  }, [_c('download-excel', {
	    attrs: {
	      "data": _vm.json_data,
	      "meta": _vm.json_meta,
	      "type": "xls",
	      "fields": _vm.json_fields,
	      "name": _vm.fepExcel
	    }
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)], 1), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Salvar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          path: '/cadastro/fep'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e(), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Validação',
	        href: '/'
	      }, {
	        text: 'Propostas',
	        href: '#'
	      }, {
	        text: 'FEP',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    attrs: {
	      "id": "relatorio_fep"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('table', {
	    staticClass: "table"
	  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "fep_titulo"
	  }, [_c('div', [_vm._v("Ficha de Enquadramento de projetos")]), _vm._v(" "), (_vm.fep.id) ? _c('div', [_vm._v("FEP - Nº "), _c('span', {
	    staticClass: "ressaltar titulo"
	  }, [_vm._v(" " + _vm._s(_vm.fep.ano) + "/" + _vm._s(_vm.fep.numero))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Título")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('nome projeto')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.nome_projeto),
	      expression: "fep.nome_projeto"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome projeto",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.fep.nome_projeto)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "nome_projeto", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome projeto')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Proponente")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('nome entidade')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.nome_entidade),
	      expression: "fep.nome_entidade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome entidade",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.fep.nome_entidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "nome_entidade", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome entidade')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpj_entidade')
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cnpj_entidade",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens,
	      "type": "text",
	      "maxlength": "20"
	    },
	    model: {
	      value: (_vm.fep.cnpj_entidade),
	      callback: function($$v) {
	        _vm.$set(_vm.fep, "cnpj_entidade", $$v)
	      },
	      expression: "fep.cnpj_entidade"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cnpj_entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj_entidade')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v(" Ano da Fep")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Ano Fep')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ano),
	      expression: "fep.ano"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:4'),
	      expression: "'required|max:4'"
	    }],
	    attrs: {
	      "type": "number",
	      "name": "Ano Fep",
	      "min": "1901"
	    },
	    domProps: {
	      "value": (_vm.fep.ano)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "ano", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Ano Fep')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Ano Fep')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v(" Número da Fep")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Numero Fep')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.numero),
	      expression: "fep.numero"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:3'),
	      expression: "'required|max:3'"
	    }],
	    attrs: {
	      "type": "number",
	      "name": "Numero Fep",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.fep.numero)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "numero", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Numero Fep')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Numero Fep')))]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Projeto Superior")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.nr_projeto_duplicacao),
	      expression: "fep.nr_projeto_duplicacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.fep, "nr_projeto_duplicacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "5004"
	    }
	  }, [_vm._v("5004 / ADMINISTRATIVOS (INTERNOS)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5006"
	    }
	  }, [_vm._v("5006 / COMUNICACAO INSTITUCIONAL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5012"
	    }
	  }, [_vm._v("5012 / CONV. MESA/GM 055/2003 - 402258-0 - ENCERRADO 21-11-2008")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5013"
	    }
	  }, [_vm._v("5013 / CONV. MTE/GM 01/03 - 402.252-1 - ENCERRADO 31.7.2008")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5014"
	    }
	  }, [_vm._v("5014 / CONV. MTE/SE 01/02 - 56.569-5 - ENCERRADO/CONCLUÍDO 29-12-2005")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5015"
	    }
	  }, [_vm._v("5015 / CONV MTE/SENAES 15/2004 - 402.265-3 - ENCERRADO EM 31/12/2009")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5016"
	    }
	  }, [_vm._v("5016 / CONV. MTUR/Embratur 120/2003 - 402259-9 - ENCERRADO EM 26-12-2008")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5017"
	    }
	  }, [_vm._v("5017 / CONV MTUR 010/03 - 402.255-6 - ENCERRADO EM 31/12/2009")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5018"
	    }
	  }, [_vm._v("5018 / CONV. MDS/SAIP 004/2005 - 405314-1 - ENCERRADO EM 27-12-2007")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5020"
	    }
	  }, [_vm._v("5020 / ASSISTÊNCIA SOCIAL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5021"
	    }
	  }, [_vm._v("5021 / DIVERSIDADE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5022"
	    }
	  }, [_vm._v("5022 / OUTROS PROJETOS - ASSISTÊNCIA SOCIAL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5024"
	    }
	  }, [_vm._v("5024 / BANCO DE TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5025"
	    }
	  }, [_vm._v("5025 / BIO CONSCIÊNCIA ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5026"
	    }
	  }, [_vm._v("5026 / OUTROS PROJETOS - CIÊNCIA E TECNOLOGIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5030"
	    }
	  }, [_vm._v("5030 / PROJETO MEMÓRIA - MECENATO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5033"
	    }
	  }, [_vm._v("5033 / AABB COMUNIDADE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5034"
	    }
	  }, [_vm._v("5034 / BANCO NA ESCOLA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5035"
	    }
	  }, [_vm._v("5035 / BB EDUCAR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5036"
	    }
	  }, [_vm._v("5036 / ESCOLA CAMPEÃ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5037"
	    }
	  }, [_vm._v("5037 / INCLUSÃO DIGITAL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5038"
	    }
	  }, [_vm._v("5038 / EDUCAÇÃO - PROJETOS INDEPENDENTES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5040"
	    }
	  }, [_vm._v("5040 / CRIANÇA E VIDA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5041"
	    }
	  }, [_vm._v("5041 / OUTROS PROJETOS - SAÚDE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5045"
	    }
	  }, [_vm._v("5045 / CADEIAS-APICULTURA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5046"
	    }
	  }, [_vm._v("5046 / CADEIAS-ARTESANATO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5047"
	    }
	  }, [_vm._v("5047 / CADEIAS-BIODIESEL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5048"
	    }
	  }, [_vm._v("5048 / CADEIAS-CAJUCULTURA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5049"
	    }
	  }, [_vm._v("5049 / CADEIAS-OVINOCAPRINOCULTURA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5050"
	    }
	  }, [_vm._v("5050 / CADEIAS-FRUTICULTURA TROPICAL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5051"
	    }
	  }, [_vm._v("5051 / CADEIAS-MANDIOCULTURA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5052"
	    }
	  }, [_vm._v("5052 / CADEIAS-RESÍDUOS SÓLIDOS ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5053"
	    }
	  }, [_vm._v("5053 / CADEIAS-OUTRAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5055"
	    }
	  }, [_vm._v("5055 / TEMÁTICOS-AGRICULTURA FAMILIAR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5056"
	    }
	  }, [_vm._v("5056 / TEMÁTICOS-ÁGUA DOCE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5057"
	    }
	  }, [_vm._v("5057 / DRLS-BERIMBAU")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5058"
	    }
	  }, [_vm._v("5058 / TEMÁTICOS-HORTAS COMUNITÁRIAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5060"
	    }
	  }, [_vm._v("5060 / TEMÁTICOS-TECBOR - BORRACHA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5061"
	    }
	  }, [_vm._v("5061 / DRLS-VALE DO URUCUIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5059"
	    }
	  }, [_vm._v("5059 / TEMÁTICOS-INCUBADORAS DE COOPERATIVAS ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5062"
	    }
	  }, [_vm._v("5062 / TEMÁTICOS-OUTROS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5064"
	    }
	  }, [_vm._v("5064 / INDEPENDENTES-CONTRAP.FBB CONV.MESA/GM 055/2003")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5065"
	    }
	  }, [_vm._v("5065 / INDEPENDENTES-CONTRAP.FBB CONV.MTE/SENAES 15/2004")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5067"
	    }
	  }, [_vm._v("5067 / INDEPENDENTES-PROJ.TERRA CIDADÃ VILA VINTEM II")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5068"
	    }
	  }, [_vm._v("5068 / INDEPENDENTES-PROJETOS N")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15120"
	    }
	  }, [_vm._v("15120 / RP FBB PIS/BB - Agroindústria")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "17160"
	    }
	  }, [_vm._v("17160 / RM FBB INSTITUTO VOTORANTIM PTAC IV")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15123"
	    }
	  }, [_vm._v("15123 / RP FBB AGROINDúSTRIA VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15126"
	    }
	  }, [_vm._v("15126 / RP FBB PIS/BB - Resíduos Sólidos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15129"
	    }
	  }, [_vm._v("15129 / RP FBB RESíDUOS SóLIDOS VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15149"
	    }
	  }, [_vm._v("15149 / RM FBB BNDES RIO DOCE FS 2015 PTAC 06/2015 - Água")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "17218"
	    }
	  }, [_vm._v("17218 / ACORDO COPASA PRO-MANANCIAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6013"
	    }
	  }, [_vm._v("6013 / TEMÁTICOS-DESENVOLVIMENTO DE ECONOMIA SOLIDARIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5158"
	    }
	  }, [_vm._v("5158 / DRLS-SÃO BARTOLOMEU")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8588"
	    }
	  }, [_vm._v("8588 / DRLS-PDTIS MATA DOS COCAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9370"
	    }
	  }, [_vm._v("9370 / RM FBB BNDES - CADEIAS - RESÍDUOS SÓLIDOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9372"
	    }
	  }, [_vm._v("9372 / RM FBB BNDES - CADEIAS - CAJUCULTURA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9374"
	    }
	  }, [_vm._v("9374 / RM FBB BNDES - CADEIAS-MANDIOCULTURA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8583"
	    }
	  }, [_vm._v("8583 / INDEPENDENTES-CONTRAPARTIDA FBB CONVÊNIO BID FUMIN BR - M1070")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5660"
	    }
	  }, [_vm._v("5660 / DRLS-OUTROS PROJETOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5661"
	    }
	  }, [_vm._v("5661 / TEMÁTICOS-VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5662"
	    }
	  }, [_vm._v("5662 / TEMÁTICOS-QUILOMBOLAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5668"
	    }
	  }, [_vm._v("5668 / CONVÊNIO MTE/SPPE/Codefat - 405.316-8 - ENCERRADO EM 31/12/2009")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5978"
	    }
	  }, [_vm._v("5978 / TEMÁTICOS-TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6004"
	    }
	  }, [_vm._v("6004 / INDEPENDENTES-OUTROS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5977"
	    }
	  }, [_vm._v("5977 / CADEIAS-AQUICULTURA E PESCA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6010"
	    }
	  }, [_vm._v("6010 / TEMÁTICOS-AGROECOLOGIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6558"
	    }
	  }, [_vm._v("6558 / REAPLICAÇÃO DE TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5144"
	    }
	  }, [_vm._v("5144 / DRLS-VALE DO RIO DOCE (WUF)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5160"
	    }
	  }, [_vm._v("5160 / CONV. MTE/SENAES 03/2007 - 405.319-2")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5161"
	    }
	  }, [_vm._v("5161 / RM FBB BID-FUMIN-DRS OUTROS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5189"
	    }
	  }, [_vm._v("5189 / DRLS-NOVOS TERRITÓRIOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5190"
	    }
	  }, [_vm._v("5190 / INDEPENDENTES-CONTRAPARTIDA FBB CONVÊNIO MTE/SENAES 003/2007")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8934"
	    }
	  }, [_vm._v("8934 / ACORDO BNDES - 5.585-9")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8940"
	    }
	  }, [_vm._v("8940 / INDEPENDENTES-CONTRAPARTIDA FBB CONVÊNIO BNDES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10675"
	    }
	  }, [_vm._v("10675 / RM FBB BNDES - TEMÁTICOS - AGRICULTURA FAMILIAR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9460"
	    }
	  }, [_vm._v("9460 / RM FBB BNDES - TEMÁTICOS - DESENV. DE ECONOMIA SOLIDÁRIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9462"
	    }
	  }, [_vm._v("9462 / RM FBB BNDES - CADEIAS - ARTESANATO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9388"
	    }
	  }, [_vm._v("9388 / RM FBB BNDES-DRLS-PDTIS ENTORNOS DE GRANDES PROJETOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9393"
	    }
	  }, [_vm._v("9393 / RM FBB BNDES - REAPLICAÇÃO DE TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9376"
	    }
	  }, [_vm._v("9376 / RM FBB BNDES - CADEIAS - APICULTURA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9380"
	    }
	  }, [_vm._v("9380 / RM FBB BNDES-DRLS-VALE DO URUCUIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9382"
	    }
	  }, [_vm._v("9382 / RM FBB BNDES-DRLS-VALE DO RIO DOCE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9384"
	    }
	  }, [_vm._v("9384 / RM FBB BNDES-DRLS-SÃO BARTOLOMEU")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9386"
	    }
	  }, [_vm._v("9386 / RM FBB BNDES-DRLS-PDTIS MATA DOS COCAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11214"
	    }
	  }, [_vm._v("11214 / RM FBB BNDES-DRLS-OUTROS PROJETOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11291"
	    }
	  }, [_vm._v("11291 / TEMÁTICOS-PROJETOS INOVADORES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11293"
	    }
	  }, [_vm._v("11293 / TEMÁTICOS-PRESERVAÇÃO DE BIOMAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11851"
	    }
	  }, [_vm._v("11851 / TEMÁTICOS-AGROEXTRATIVISMO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11671"
	    }
	  }, [_vm._v("11671 / RM FBB-BNDES - PROJETOS INDEPENDENTES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11595"
	    }
	  }, [_vm._v("11595 / RM FBB PETROBRAS CADEIAS - RESÍDUOS SÓLIDOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11745"
	    }
	  }, [_vm._v("11745 / RM FBB BNDES - DRLS NOVOS TERRITóRIOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12368"
	    }
	  }, [_vm._v("12368 / RM FBB BNDES-TEMÁTICOS-AGROEXTRATIVISMO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12390"
	    }
	  }, [_vm._v("12390 / RM FBB BNDES-TEMÁTICOS-AGROECOLOGIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12392"
	    }
	  }, [_vm._v("12392 / RM FBB BNDES-TEMÁTICOS-PROJETOS INOVADORES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12385"
	    }
	  }, [_vm._v("12385 / RM FBB BNDES-TEMÁTICOS-PROSPECÇÃO E PROJETOS INOVADORES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12371"
	    }
	  }, [_vm._v("12371 / RM FBB BNDES - ÁGUA DE PRODUÇÃO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12373"
	    }
	  }, [_vm._v("12373 / RM FBB BNDES-TEMÁTICOS-HORTAS COMUNITÁRIAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12375"
	    }
	  }, [_vm._v("12375 / RM FBB BNDES-TEMÁTICOS-INCUBADORAS DE COOPERATIVAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12377"
	    }
	  }, [_vm._v("12377 / RM FBB BNDES-TEMÁTICOS-TECBOR - BORRACHA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12379"
	    }
	  }, [_vm._v("12379 / RM FBB BNDES-TEMÁTICOS-OUTROS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12381"
	    }
	  }, [_vm._v("12381 / RM FBB BNDES-TEMÁTICOS-VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12383"
	    }
	  }, [_vm._v("12383 / RM FBB BNDES-TEMÁTICOS-QUILOMBOLAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12386"
	    }
	  }, [_vm._v("12386 / RM FBB BNDES-TEMÁTICOS-TECNOLOGIAS SOCIAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12439"
	    }
	  }, [_vm._v("12439 / RM FBB BNDES-CADEIAS-AQUICULTURA E PESCA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12366"
	    }
	  }, [_vm._v("12366 / RM FBB BNDES-TEMÁTICOS-PRESERVAÇÃO DE BIOMAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "17278"
	    }
	  }, [_vm._v("17278 / RM FBB BNDES - Fundo Social PTAC 2013 - Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "17293"
	    }
	  }, [_vm._v("17293 / RM FBB BNDES ECOFORTE REDES - FS 06/2015")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "17360"
	    }
	  }, [_vm._v("17360 / INDEPENDENTES EDUCAÇÃO - MINISTÉRIO DA DEFESA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18102"
	    }
	  }, [_vm._v("18102 / RP ENCHENTES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18104"
	    }
	  }, [_vm._v("18104 / RC ENCHENTES ESPÍRITO SANTO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18108"
	    }
	  }, [_vm._v("18108 / RC ENCHENTES MINAS GERAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15083"
	    }
	  }, [_vm._v("15083 / RP FBB OUTROS PROJETOS ÁGUA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15091"
	    }
	  }, [_vm._v("15091 / RM FBB BNDES Ecoforte Extrativismo - Fundo Amazônia 2014")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18118"
	    }
	  }, [_vm._v("18118 / RP COVID-19")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18120"
	    }
	  }, [_vm._v("18120 / RC COVID-19")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18122"
	    }
	  }, [_vm._v("18122 / RC COVID19-GOVERNO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18124"
	    }
	  }, [_vm._v("18124 / RC ALUÍZIO CAMPOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15034"
	    }
	  }, [_vm._v("15034 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2010")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15037"
	    }
	  }, [_vm._v("15037 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2011")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14819"
	    }
	  }, [_vm._v("14819 / RP FBB OUT PROJ AGROECOLOGIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14761"
	    }
	  }, [_vm._v("14761 / RP FBB  ECOFORTE REDES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15094"
	    }
	  }, [_vm._v("15094 / RP FBB PIS/BB - Demais Iniciativas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15096"
	    }
	  }, [_vm._v("15096 / RP FBB DEMAIS VOLUNTARIADO INTEGRAçãO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15098"
	    }
	  }, [_vm._v("15098 / BB EDUCAR INTEGRAÇÃO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15132"
	    }
	  }, [_vm._v("15132 / RP FBB PIS/BB - Água")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15135"
	    }
	  }, [_vm._v("15135 / RP FBB ÁGUA VOLUNTAR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14279"
	    }
	  }, [_vm._v("14279 / RM FBB BNDES  OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2012")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14281"
	    }
	  }, [_vm._v("14281 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14283"
	    }
	  }, [_vm._v("14283 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO AMAZÔNIA 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14266"
	    }
	  }, [_vm._v("14266 / RP FBB ÁGUA BRASIL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14294"
	    }
	  }, [_vm._v("14294 / RP FBB CISTERNAS AVALIAÇÃO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14270"
	    }
	  }, [_vm._v("14270 / RM FBB BNDES ECOFORTE REDES - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14273"
	    }
	  }, [_vm._v("14273 / RM FBB BNDES ECOFORTE REDES - FUNDO AMAZÔNIA 2012")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14275"
	    }
	  }, [_vm._v("14275 / RM FBB BNDES Ecoforte Extrativismo - Fundo Amazônia 2012")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14277"
	    }
	  }, [_vm._v("14277 / RM FBB BNDES MUNICÍPIOS VERDES - FUNDO AMAZÔNIA 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14301"
	    }
	  }, [_vm._v("14301 / RM FBB BNDES OUTROS PROJETOS AGROINDÚSTRIA - FUNDO AMAZÔNIA 2012")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14307"
	    }
	  }, [_vm._v("14307 / RP FBB OUTROS PROJETOS AGROINDÚSTRIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14315"
	    }
	  }, [_vm._v("14315 / RM FBB PETROBRAS CATAFORTE II CAMINHÕES - 2010")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14317"
	    }
	  }, [_vm._v("14317 / RM FBB BNDES OUTROS PROJETOS RESÍDUOS SÓLIDOS - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14290"
	    }
	  }, [_vm._v("14290 / RM FBB BNDES TERRAFORTE 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14292"
	    }
	  }, [_vm._v("14292 / RM FBB BNDES TERRAFORTE 2014")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14296"
	    }
	  }, [_vm._v("14296 / RM FBB BNDES OUTROS PROJETOS AGROINDÚSTRIA - FUNDO SOCIAL PTAC 2009")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14298"
	    }
	  }, [_vm._v("14298 / RM FBB BNDES OUTROS PROJETOS AGROINDÚSTRIA - FUNDO SOCIAL PTAC 2012")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14302"
	    }
	  }, [_vm._v("14302 / RM FBB BNDES OUTROS PROJETOS ÁGUA - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14344"
	    }
	  }, [_vm._v("14344 / RM FBB BNDES OUTROS PROJETOS AGROINDÚSTRIA - FUNDO AMAZÔNIA 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14324"
	    }
	  }, [_vm._v("14324 / RM FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14326"
	    }
	  }, [_vm._v("14326 / RM FBB BNDES OUTRAS INICIATIVAS FUNDO AMAZÔNIA 2012")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14328"
	    }
	  }, [_vm._v("14328 / RM FBB BID FUMIN OUTRAS INICIATIVAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14330"
	    }
	  }, [_vm._v("14330 / RP FBB OUTRAS INICIATIVAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14311"
	    }
	  }, [_vm._v("14311 / RM FBB MTE SENAES 2013 CATFORTE III BASES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14313"
	    }
	  }, [_vm._v("14313 / RM FBB BNDES  CATAFORTE III ESCRITÓRIO - FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14333"
	    }
	  }, [_vm._v("14333 / RM FBB BNDES DEMAIS INICIATIVAS DRS FUNDO SOCIAL PTAC 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14335"
	    }
	  }, [_vm._v("14335 / RP FBB DEMAIS INICIATIVAS DRS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14337"
	    }
	  }, [_vm._v("14337 / RP FBB DEMAIS INICIATIVAS VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15272"
	    }
	  }, [_vm._v("15272 / OUTROS PROJETOS DE EDUCAçãO RIO DOCE - BNDES PTAC 06/2015")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14473"
	    }
	  }, [_vm._v("14473 / FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2012")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14474"
	    }
	  }, [_vm._v("14474 / FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2011")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14475"
	    }
	  }, [_vm._v("14475 / FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2010")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14476"
	    }
	  }, [_vm._v("14476 / FBB BNDES OUTRAS INICIATIVAS FUNDO SOCIAL PTAC 2009")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14482"
	    }
	  }, [_vm._v("14482 / RM FBB BNDES OUTROS PROJETOS AGROINDúSTRIA - FUNDO SOCIAL PTAC 2010")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14517"
	    }
	  }, [_vm._v("14517 / RP FBB OUTROS PROJETOS RESÍDUOS SÓLIDOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15211"
	    }
	  }, [_vm._v("15211 / RP FBB RIO DOCE - AGROECOLOGIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15213"
	    }
	  }, [_vm._v("15213 / RM FBB BNDES RIO DOCE - AGROECOLOGIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15217"
	    }
	  }, [_vm._v("15217 / RP FBB RIO DOCE - AGROINDúSTRIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15219"
	    }
	  }, [_vm._v("15219 / RM FBB BNDES RIO DOCE - AGROINDúSTRIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15222"
	    }
	  }, [_vm._v("15222 / RP FBB RIO DOCE - RESíDUOS SóLIDOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15224"
	    }
	  }, [_vm._v("15224 / RM FBB BNDES RIO DOCE - RESíDUOS SóLIDOS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15160"
	    }
	  }, [_vm._v("15160 / OUTROS PROJETOS DE EDUCAçãO - Rio Doce")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14749"
	    }
	  }, [_vm._v("14749 / RM FBB BNDES JUVENTUDE RURAL - FUNDO SOCIAL 2013")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14519"
	    }
	  }, [_vm._v("14519 / RM FBB BNDES ÁGUA BRASIL - FUNDO SOCIAL PTAC 2009")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14522"
	    }
	  }, [_vm._v("14522 / RP FBB PNHU")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14540"
	    }
	  }, [_vm._v("14540 / RM FBB BNDES Outros Projetos Resíduos Sólidos - Fundo Social PTAC 2010")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14509"
	    }
	  }, [_vm._v("14509 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO AMAZÔNIA 2012")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15114"
	    }
	  }, [_vm._v("15114 / RP FBB PIS/BB - Agroecologia")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15117"
	    }
	  }, [_vm._v("15117 / RP FBB AGROECOLOGIA VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15141"
	    }
	  }, [_vm._v("15141 / EDUCAÇÃO - PROJETOS INDEPENDENTES - PIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15143"
	    }
	  }, [_vm._v("15143 / EDUCAÇÃO - PROJETOS INDEPENDENTES - VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15146"
	    }
	  }, [_vm._v("15146 / ÁGUA - RIO DOCE - RP FBB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15233"
	    }
	  }, [_vm._v("15233 / RP FBB RIO DOCE - DEMAIS INIICIATIVAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15235"
	    }
	  }, [_vm._v("15235 / RM FBB BNDES RIO DOCE - DEMAIS INICIATIVAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14947"
	    }
	  }, [_vm._v("14947 / RM FBB BNDES OUTROS PROJETOS AGROECOLOGIA - FUNDO SOCIAL PTAC 2009")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15476"
	    }
	  }, [_vm._v("15476 / RM FBB ÁGUA DE BEBER")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15561"
	    }
	  }, [_vm._v("15561 / PROJETO SUPERIOR - BB EDUCAR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15571"
	    }
	  }, [_vm._v("15571 / INCLUSãO DIGITAL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15557"
	    }
	  }, [_vm._v("15557 / AABB COMUNIDADE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15579"
	    }
	  }, [_vm._v("15579 / INDEP. EDUCA RIO DOCE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15586"
	    }
	  }, [_vm._v("15586 / Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15575"
	    }
	  }, [_vm._v("15575 / INDEPENDENTES EDUCAÇÃO - PIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15577"
	    }
	  }, [_vm._v("15577 / INDEP. EDUCAÇÃO - VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15581"
	    }
	  }, [_vm._v("15581 / INDEP EDUC RIO DOC PTAC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15591"
	    }
	  }, [_vm._v("15591 / MEMóRIA DOCUMENTAL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15595"
	    }
	  }, [_vm._v("15595 / PROJETO MEMóRIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15599"
	    }
	  }, [_vm._v("15599 / INDEPENDENTES CULTURA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15932"
	    }
	  }, [_vm._v("15932 / PROJETOS INDEPENDENTES EM EDUCAÇÃO - FBB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "16418"
	    }
	  }, [_vm._v("16418 / RM FBB BNDES ÁGUA DE PRODUÇÃO PTAC 06/2015")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "16520"
	    }
	  }, [_vm._v("16520 / RM FBB BNDES ECOFORTE REDES FA 2014")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15565"
	    }
	  }, [_vm._v("15565 / BB EDUCAR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15567"
	    }
	  }, [_vm._v("15567 / BB EDUCAR INTEGRAçãO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "16967"
	    }
	  }, [_vm._v("16967 / RM FBB BNDES - Fundo Social PTAC 2011 - Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "16969"
	    }
	  }, [_vm._v("16969 / RM FBB BNDES - Fundo Social PTAC 2012 - Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18126"
	    }
	  }, [_vm._v("18126 / RP APAGÃO AMAPÁ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18128"
	    }
	  }, [_vm._v("18128 / RC APADRINHE UM FUTURO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18132"
	    }
	  }, [_vm._v("18132 / RM FBB MUSEU DO IPIRANGA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18137"
	    }
	  }, [_vm._v("18137 / RM FBB PROSPECÇÃO DIRETA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18140"
	    }
	  }, [_vm._v("18140 / RM FBB PIS MEIO AMBIENTE E RENDA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18144"
	    }
	  }, [_vm._v("18144 / RM FBB PRÊMIO DE TECNOLOGIA SOCIAL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18147"
	    }
	  }, [_vm._v("18147 / RM FBB/COMPENSA CERRADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18152"
	    }
	  }, [_vm._v("18152 / RP COVID-19")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18154"
	    }
	  }, [_vm._v("18154 / RC COVID-19 FBB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18157"
	    }
	  }, [_vm._v("18157 / RM FBB DESAFIO TRANSFORMA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18160"
	    }
	  }, [_vm._v("18160 / RM FBB AABB COMUNIDADE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18163"
	    }
	  }, [_vm._v("18163 / RM FBB INSTITUTO VOTORANTIM PTAC 01-2021")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18166"
	    }
	  }, [_vm._v("18166 / RP ENCHENTES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18169"
	    }
	  }, [_vm._v("18169 / RC ENCHENTES ACRE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18171"
	    }
	  }, [_vm._v("18171 / RC ENCHENTES MINAS GERAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18173"
	    }
	  }, [_vm._v("18173 / RC COVID19-CNM PRATO CHEIO 2021")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18182"
	    }
	  }, [_vm._v("18182 / RM FBB VOLUNTARIADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18185"
	    }
	  }, [_vm._v("18185 / RM FBB ACORDO SUZANO PTAC 01/2021")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18188"
	    }
	  }, [_vm._v("18188 / RM FBB BNDES FS PTAC 2012 - REAPLICAÇÃO DE TS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18190"
	    }
	  }, [_vm._v("18190 / RM FBB BNDES FS PTAC 2013 - REAPLICAÇÃO DE TS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18192"
	    }
	  }, [_vm._v("18192 / RC COVID 19 GOVERNO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18192"
	    }
	  }, [_vm._v("18195 / RM FBB OUTROS PROJETOS DO PROGRAMA MEIO AMBIENTE E RENDA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18219"
	    }
	  }, [_vm._v("18219 / RM FBB BNDES OUTROS PROJETOS DE MEIO AMBIENTE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18268"
	    }
	  }, [_vm._v("18268 / RM FBB BNDES FSA CISTERNAS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18309"
	    }
	  }, [_vm._v("18309 / RM FBB AABB COMUNIDADE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20030"
	    }
	  }, [_vm._v("20030 / RP CICLONE BOMBA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20039"
	    }
	  }, [_vm._v("20039 / RC COVID19 MUNICÍPIOS PRATO CHEIO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20241"
	    }
	  }, [_vm._v("20241 / RECUPERA CERRADO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20260"
	    }
	  }, [_vm._v("20260 / RT MMFDH - SOLIDARIZE-SE")])]), _vm._v(" "), (_vm.errors.first('Projeto Duplicação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Projeto Duplicação')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Eixo de Atuação")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('eixo de atuação')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ds_categ_campo_atuacao),
	      expression: "fep.ds_categ_campo_atuacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "eixo de atuação",
	      "aria-hidden": "true",
	      "aria-required": "true",
	      "aria-invalid": "false"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.fep, "ds_categ_campo_atuacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Assistência a comunidades urbano-rurais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Assistência Social")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Ciência e Tecnologia")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Cultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("Educação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("Recreação e Desporto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("Saúde")])]), _vm._v(" "), (_vm.errors.first('eixo de atuação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('eixo de atuação')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Programa")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('programa')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ds_fep_programa),
	      expression: "fep.ds_fep_programa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "programa",
	      "aria-hidden": "true",
	      "aria-required": "true",
	      "aria-invalid": "false"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.fep, "ds_fep_programa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("AABB Comunidade")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Banco de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("BB Educar")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Inclusão Digital")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("Memória Documental")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("Projeto Memória")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("Reaplicação de Tecnologias Sociais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("Trabalho e Cidadania")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v("Independentes - Assist. a comun. urbano-rurais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("Independentes - Assistência Social")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11"
	    }
	  }, [_vm._v("Independentes - Ciência e Tecnologia")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12"
	    }
	  }, [_vm._v("Independentes - Cultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "13"
	    }
	  }, [_vm._v("Independentes - Educação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14"
	    }
	  }, [_vm._v("Independentes - Recreação e Desporto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15"
	    }
	  }, [_vm._v("Independentes - Saúde")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "16"
	    }
	  }, [_vm._v("Ajuda Humanitária")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "17"
	    }
	  }, [_vm._v("Meio Ambiente e Renda")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18"
	    }
	  }, [_vm._v("Voluntariado")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "19"
	    }
	  }, [_vm._v("Demais Iniciativas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20"
	    }
	  }, [_vm._v("Tecnologia Social")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "21"
	    }
	  }, [_vm._v("Educação para Futuro")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "22"
	    }
	  }, [_vm._v("Educação")])]), _vm._v(" "), (_vm.errors.first('programa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('programa')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Ação")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Ação')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ds_categ_acao),
	      expression: "fep.ds_categ_acao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Ação",
	      "aria-hidden": "true",
	      "aria-required": "true",
	      "aria-invalid": "false"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.fep, "ds_categ_acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Água de Produção")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Água Brasil")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("DRS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Voluntariado")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("Cataforte III - Escritório")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("Cataforte I")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("Cataforte II - Caminhões")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("Cataforte III - Bases")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("Ecoforte Redes")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11"
	    }
	  }, [_vm._v("Terra Forte")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12"
	    }
	  }, [_vm._v("Prêmio TS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "13"
	    }
	  }, [_vm._v("Outros Projetos Água")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14"
	    }
	  }, [_vm._v("Ecoforte Extrativismo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15"
	    }
	  }, [_vm._v("Municípios Verdes")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "16"
	    }
	  }, [_vm._v("Outros Projetos Agroecologia")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "17"
	    }
	  }, [_vm._v("Juventude Rural")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18"
	    }
	  }, [_vm._v("Outros Projetos Agroindústria")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "19"
	    }
	  }, [_vm._v("Outros Projetos Resíduos Sólidos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20"
	    }
	  }, [_vm._v("Outras Iniciativas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "21"
	    }
	  }, [_vm._v("PNHU")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "22"
	    }
	  }, [_vm._v("Cisternas Avaliação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "23"
	    }
	  }, [_vm._v("PIS-BB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "24"
	    }
	  }, [_vm._v("Rio Doce")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "25"
	    }
	  }, [_vm._v("Outros Projetos Educação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "26"
	    }
	  }, [_vm._v("Água de Beber")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "27"
	    }
	  }, [_vm._v("AABB Comunidade")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "28"
	    }
	  }, [_vm._v("BB Educar")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "29"
	    }
	  }, [_vm._v("BB Educar Integração")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "30"
	    }
	  }, [_vm._v("Inclusão Digital")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "31"
	    }
	  }, [_vm._v("Acordo Ministério da Defesa")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "32"
	    }
	  }, [_vm._v("Fatores Climáticos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "33"
	    }
	  }, [_vm._v("pandemias e Epidemias")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "34"
	    }
	  }, [_vm._v("Aluízio Campos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "35"
	    }
	  }, [_vm._v("Museu do Ipiranga")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "36"
	    }
	  }, [_vm._v("PIS - Novo Voluntariado - 2 sem")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "37"
	    }
	  }, [_vm._v("Suzano")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "38"
	    }
	  }, [_vm._v("Vale Pará")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "39"
	    }
	  }, [_vm._v("Voluntariado 2020 a 2021")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "40"
	    }
	  }, [_vm._v("Prospecção Direta")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "41"
	    }
	  }, [_vm._v("Hospital de Jaú")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "42"
	    }
	  }, [_vm._v("Desafio Transforma")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "43"
	    }
	  }, [_vm._v("Enel")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "44"
	    }
	  }, [_vm._v("Prêmio TS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "45"
	    }
	  }, [_vm._v("Votorantim")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "46"
	    }
	  }, [_vm._v("AABB Comunidade")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "47"
	    }
	  }, [_vm._v("AVSI - Vozes Daqui")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "48"
	    }
	  }, [_vm._v("Cisternas-Escolas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "49"
	    }
	  }, [_vm._v("Compensa Cerrado")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "50"
	    }
	  }, [_vm._v("Profesp")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "51"
	    }
	  }, [_vm._v("Reaplicação de TS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "52"
	    }
	  }, [_vm._v("Outros Projetos Educação para o Futuro")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "53"
	    }
	  }, [_vm._v("Outros Projetos Meio Ambiente e Renda")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "54"
	    }
	  }, [_vm._v("Outros Projetos Voluntariado")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "55"
	    }
	  }, [_vm._v("Projetos Estruturantes Arrecadação Solidária-Covid")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Não se aplica")])]), _vm._v(" "), (_vm.errors.first('Ação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Ação')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Parceria Estratégica (Vínculo)")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Parceria Estratégica')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.parc_estrategica),
	      expression: "fep.parc_estrategica"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria Estratégica",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.fep, "parc_estrategica", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2009 - 5.585-9")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2010 - 55.805-2")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2011 - 55.807-9")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2012 - 55.808-7")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("BNDES - 09.2.0708.1/2009 - FS/PTAC 2013 - 55.813-3")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("BNDES - 10.2.2029.1/2010 - CATAFORTE II - 55.806-0")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("PETROBRAS - 6000.0063847.10.4/2010 - CATAFORTE II - 402002-2")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("BID/FUMIN - 11818/2010 - 405.320-6")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v("MTE/SENAES - 03/2007 - CATAFORTE I E II - 405.319-2")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("WESTERN UNION - 405.400-8")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11"
	    }
	  }, [_vm._v("BNDES - 12.2.0435.1/2012 - FA/CONTRATO 2012 - 55.809-5")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12"
	    }
	  }, [_vm._v("BNDES - 12.2.0435.1/2012 - FA/CONTRATO 2014 - 55.812-5")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "13"
	    }
	  }, [_vm._v("BNDES - 13.2.0505.1/2013 - ÁGUA DE PRODUÇÃO - 55.811-7")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14"
	    }
	  }, [_vm._v("BNDES - 13.2.0047.1/2013 - TERRAFORTE 2013 - 55.810-9")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15"
	    }
	  }, [_vm._v("MTE/SENAES - 795775/2013 - CATAFORTE III - 6.551-X")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "16"
	    }
	  }, [_vm._v("BNDES - 13.2.0047.1/2013 - TERRAFORTE 2014 - 55.814-1")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18"
	    }
	  }, [_vm._v("BNDES - 15.2.0773.1/2015 - FS/PTAC 06/2015 - 55.816-8")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "28"
	    }
	  }, [_vm._v("BNDES - 21.2.0394.1 - FSA CISTERNAS - 55.818-4")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "19"
	    }
	  }, [_vm._v("INSTITUTO VOTORANTIM - PTAC 2018 - 55.823-0")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20"
	    }
	  }, [_vm._v("COPASA - 18.1247 - PROGRAMA PRO-MANANCIAIS - 55.820-6")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "85"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - ACTF FBB-BOLDRINI 01/2020")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "86"
	    }
	  }, [_vm._v("DOAÇÃO COND ESPÓLIO ALUÍSIO A CAMPOS 00101236520028150011")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "87"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - AÇÃO COVID19-GOVERN - NT PORT 2020/0154")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "88"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - AÇÃO COVID 19 - NT PORT 2020/0154")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "89"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - OPERAÇÃO ACOLHIDA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "90"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - CÃO GUIA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "91"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - MEIO AMBIENTE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "92"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - EDUCAÇÃO INCLUSIVA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "93"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - ENCHENTES RIO DE JANEIRO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "94"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - ENCHENTES MINAS GERAIS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "95"
	    }
	  }, [_vm._v("DOAÇÃO CONDICIONAL - ENCHENTES ESPÍRITO SANTO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "96"
	    }
	  }, [_vm._v("BB - BÔNUS AMBIENTAL - ISD - 402.248-3")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "97"
	    }
	  }, [_vm._v("BRASILCAP - TÍT. DE CAP. - ISD - 402.248-3")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "98"
	    }
	  }, [_vm._v("Desvinculado de parceria por ato decisório")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "99"
	    }
	  }, [_vm._v("Não vinculado a parcerias")])]), _vm._v(" "), (_vm.errors.first('Parceria Estratégica')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria Estratégica')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Tipo de Ação')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ds_fep_tipo_acao),
	      expression: "fep.ds_fep_tipo_acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo de Ação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.fep, "ds_fep_tipo_acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.tiposAcao), function(i) {
	    return _c('option', {
	      domProps: {
	        "value": i.code
	      }
	    }, [_vm._v(_vm._s(i.description))])
	  }), 0), _vm._v(" "), (_vm.errors.first('Tipo de Ação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Tipo de Ação')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Abrangência")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Abrangência')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.abrangencia),
	      expression: "fep.abrangencia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Abrangência",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.fep.abrangencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "abrangencia", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Abrangência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Abrangência')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v(" Participantes Diretos")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Participantes Diretos')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.publico_alvo),
	      expression: "fep.publico_alvo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "Participantes Diretos"
	    },
	    domProps: {
	      "value": (_vm.fep.publico_alvo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "publico_alvo", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Participantes Diretos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Participantes Diretos')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Prospecção")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Prospecção')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ds_categ_prospeccao),
	      expression: "fep.ds_categ_prospeccao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Prospecção",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.fep.ds_categ_prospeccao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "ds_categ_prospeccao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Prospecção')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Prospecção')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Se Seleção, Nº/Nome Processo")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Processo')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ds_categ_edital),
	      expression: "fep.ds_categ_edital"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Processo",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.fep.ds_categ_edital)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "ds_categ_edital", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Processo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Processo')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Cadeia Produtiva")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Cadeia Produtiva')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ds_categ_vetor),
	      expression: "fep.ds_categ_vetor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cadeia Produtiva",
	      "aria-hidden": "true",
	      "aria-required": "true",
	      "aria-invalid": "false"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.fep, "ds_categ_vetor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Apicultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Avicultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Bovinocultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Cafeicultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("Cajucultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("Floricultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("Mandiocultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("Ovinocapricultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v("Psicultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("Suinocultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11"
	    }
	  }, [_vm._v("Resíduos Sólidos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12"
	    }
	  }, [_vm._v("Artesanato")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "13"
	    }
	  }, [_vm._v("Fruticultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14"
	    }
	  }, [_vm._v("Turismo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15"
	    }
	  }, [_vm._v("Recuperação Ambiental")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "16"
	    }
	  }, [_vm._v("Assistência Técnica")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "17"
	    }
	  }, [_vm._v("Capacitação e Formação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "18"
	    }
	  }, [_vm._v("Comunicação / Mobilização")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "19"
	    }
	  }, [_vm._v("Articulação e Redes")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20"
	    }
	  }, [_vm._v("Horticultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "21"
	    }
	  }, [_vm._v("Silvicultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "22"
	    }
	  }, [_vm._v("Olericultura")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Não se aplica")])]), _vm._v(" "), (_vm.errors.first('Cadeia Produtiva')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cadeia Produtiva')))]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped orcamento"
	  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "required-fep"
	  }, [_vm._v("Próprios FBB")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('total fbb')
	    }
	  }, [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "total fbb",
	      "type": "text",
	      "maxlength": "255"
	    },
	    model: {
	      value: (_vm.fep.total_fbb),
	      callback: function($$v) {
	        _vm.$set(_vm.fep, "total_fbb", $$v)
	      },
	      expression: "fep.total_fbb"
	    }
	  }), _vm._v(" "), (_vm.errors.first('total fbb')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('total fbb')))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.fep.total_fbb / (_vm.fep.total_contrapartida + _vm.fep.total_fbb +
	    _vm.fep.total_parceiro))) + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "required-fep"
	  }, [_vm._v("Terceiros - Parcerias Estratégicas")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('total parceiro')
	    }
	  }, [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "total parceiro",
	      "type": "text",
	      "maxlength": "255"
	    },
	    model: {
	      value: (_vm.fep.total_parceiro),
	      callback: function($$v) {
	        _vm.$set(_vm.fep, "total_parceiro", $$v)
	      },
	      expression: "fep.total_parceiro"
	    }
	  }), _vm._v(" "), (_vm.errors.first('total parceiro')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('total parceiro')))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.fep.total_parceiro / (_vm.fep.total_contrapartida + _vm.fep.total_fbb +
	    _vm.fep.total_parceiro))) + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "required-fep"
	  }, [_vm._v("Contrapartida - Proponente")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "total_contrapartida",
	      "type": "text",
	      "maxlength": "255"
	    },
	    model: {
	      value: (_vm.fep.total_contrapartida),
	      callback: function($$v) {
	        _vm.$set(_vm.fep, "total_contrapartida", $$v)
	      },
	      expression: "fep.total_contrapartida"
	    }
	  })], 1), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.fep.total_contrapartida / (_vm.fep.total_contrapartida + _vm.fep.total_fbb +
	    _vm.fep.total_parceiro))) + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.fep.total_contrapartida + _vm.fep.total_fbb + _vm.fep.total_parceiro)) + "\n                      ")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")((_vm.fep.total_contrapartida + _vm.fep.total_fbb + _vm.fep.total_parceiro) /
	    (_vm.fep.total_contrapartida + _vm.fep.total_fbb + _vm.fep.total_parceiro))) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.ds_fep_observacao),
	      expression: "fep.ds_fep_observacao"
	    }, {
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_fep_observacao"
	    },
	    domProps: {
	      "value": (_vm.fep.ds_fep_observacao)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "ds_fep_observacao", $event.target.value)
	      }, _vm.resizable]
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(6), _vm._v(" "), _c('table', {
	    staticClass: "bloco"
	  }, [_c('tr', [_c('td', [_c('textarea', {
	    staticClass: "form-control"
	  }, [_vm._v("Enquadramento validado em " + _vm._s(_vm.hoje))])])]), _vm._v(" "), _vm._m(7)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "float"
	  })])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Dados do Projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Enquadramento na Árvore de Projetos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Orçamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Recursos")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("% Valor")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Observações")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Enquadramento Orçamentário")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_c('div', {
	    staticClass: "assinatura"
	  }, [_c('span', [_vm._v("Assessor Formalização - Orçamento")])])])])
	}]}

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-box"
	  }, [_c('div', {
	    staticClass: "login-logo yellow-bg"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "login-box-body"
	  }, [_c('p', {
	    staticClass: "login-box-msg"
	  }, [_vm._v("Faça seu acesso")]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.submit($event)
	      }
	    }
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "ng-binding"
	  }, [_vm._v("Alterar senha")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('novaSenha')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.novaSenha),
	      expression: "form.novaSenha"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }],
	    ref: "novaSenhaRef",
	    staticClass: "form-control",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('novaSenha')
	    },
	    attrs: {
	      "type": "password",
	      "placeholder": "Digite a Senha",
	      "name": "novaSenha",
	      "data-vv-as": "nova senha",
	      "vid": "novaSenha"
	    },
	    domProps: {
	      "value": (_vm.form.novaSenha)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "novaSenha", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('novaSenha')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('novaSenha')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback",
	    staticStyle: {
	      "font-size": "smaller",
	      "font-style": "italic"
	    }
	  }, [_vm._v("Pelo menos 6 caracteres (letras ou números)")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('confirmaSenha')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.confirmaSenha),
	      expression: "form.confirmaSenha"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|confirmed:novaSenhaRef'),
	      expression: "'required|confirmed:novaSenhaRef'"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('confirmaSenha')
	    },
	    attrs: {
	      "type": "password",
	      "placeholder": "confirme a senha",
	      "data-vv-as": "confirma senha",
	      "name": "confirmaSenha"
	    },
	    domProps: {
	      "value": (_vm.form.confirmaSenha)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "confirmaSenha", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('confirmaSenha')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('confirmaSenha')))]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.fbb.org.br/projetos/portal",
	      "target": "_"
	    }
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    }
	  }, [_vm._v(" Antigo SGP")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-block btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Alterar")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('div', {
	    staticClass: "center",
	    staticStyle: {
	      "color": "white",
	      "font-family": "verdana",
	      "font-size": "73%"
	    }
	  }, [_vm._v("\n      * Observação: se você não foi informado pela FBB de que o seu projeto foi migrado para nova versão, basta acessar abaixo:\n    ")])])
	}]}

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Relatórios da Proposta'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3"
	  }, [_vm._v("Selecione uma proposta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.projetos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "custom-label": _vm.etiquetaProjeto,
	      "placeholder": "Selecione uma proposta",
	      "label": "ds_nome",
	      "track-by": "id",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "projeto",
	      "data-vv-as": "projeto"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelect($event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.ds_nome))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.projetoSelecionado),
	      callback: function($$v) {
	        _vm.projetoSelecionado = $$v
	      },
	      expression: "projetoSelecionado"
	    }
	  })], 1)]), _vm._v(" "), (!_vm._.isEmpty(_vm.projetoSelecionado)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3"
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_vm._v("\n                        " + _vm._s(_vm.projetoSelecionado.ds_cnpj) + " - " + _vm._s(_vm.projetoSelecionado.NomeEntidade) + "\n                      ")])]), _vm._v(" "), (!_vm._.isEmpty(_vm.projetoSelecionado.ds_numero_edital)) ? _c('div', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3"
	  }, [_vm._v("Edital:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_vm._v("\n                          " + _vm._s(_vm.projetoSelecionado.ds_numero_edital) + "\n                        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3"
	  }, [_vm._v("Fase:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_vm._v("\n                        " + _vm._s(_vm.projetoSelecionado.ds_fase) + "\n                      ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9 col-md-offset-3 box-footer d-flex flex-wrap-nowrap"
	  }, [(_vm._.has(_vm.projetoSelecionado, 'id')) ? _c('div', [_c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'imprimir-proposta',
	        params: {
	          id: _vm.projetoSelecionado.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Versão para impressão da Proposta\n                    ")]), _vm._v(" "), (_vm._.includes(['ANALISE', 'DEFERIMENTO', 'FORMALIZACAO', 'APROVACAO_PROJETO', 'APROVADO'], _vm.projetoSelecionado.ds_fase)) ? _c('span', [_c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-fep',
	        params: {
	          id: _vm.projetoSelecionado.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  FEP\n                      ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-rating',
	        params: {
	          id: _vm.projetoSelecionado.id
	        },
	        query: {
	          entidade: _vm.projetoSelecionado.idEntidade
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v("  Rating da Entidade\n                      ")]), _vm._v(" "), (_vm.projetoSelecionado['relatorio_analise'] == null) ? _c('span', [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "disabled": _vm.projetoSelecionado['relatorio_analise'] == null,
	      "target": "_blank",
	      "title": _vm.titulo
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v("  Relatório de Análise\n                        ")])]) : _c('span', [_c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'visualiza-relatorio-analise',
	        params: {
	          id: _vm.projetoSelecionado.id,
	          projeto: _vm.projetoSelecionado.ds_codigo_projeto_erp
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v("  Relatório de Análise\n                        ")])], 1), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'plano-trabalho',
	        params: {
	          id: _vm.projetoSelecionado.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v("  Plano de Trabalho\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm._.includes(['ANALISE'], _vm.projetoSelecionado.ds_fase) && _vm.projetoSelecionado.ds_codigo_projeto_erp !== '00000') ? _c('span', [_c('button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrarBriefing = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v("  Relatório de Briefing\n                      ")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrarBriefing) ? _c('div', {
	    staticClass: "row mt-3"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b-card', {
	    staticClass: "mb-3",
	    attrs: {
	      "title": "Dados que devem constar no Briefing"
	    }
	  }, [_c('div', {
	    staticClass: "checkbox-block"
	  }, [_c('b-form-checkbox-group', {
	    staticClass: "mb-3",
	    attrs: {
	      "stacked": ""
	    },
	    model: {
	      value: (_vm.selecionadosBriefing),
	      callback: function($$v) {
	        _vm.selecionadosBriefing = $$v
	      },
	      expression: "selecionadosBriefing"
	    }
	  }, _vm._l((_vm.dadosBriefing), function(item) {
	    return _c('b-form-checkbox', {
	      key: item.id,
	      attrs: {
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "margin-left": "8px"
	      }
	    }, [_vm._v(_vm._s(item.nome))])])
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-flex justify-content-end mt-3"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    class: {
	      'btn-opaco': _vm.botaoClicado
	    },
	    attrs: {
	      "disabled": _vm.botaoClicado
	    },
	    on: {
	      "click": _vm.gerarBriefing
	    }
	  }, [_vm._v("  \n                          Gerar arquivo de Briefing  \n                        ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-sm btn-flat ml-2",
	    on: {
	      "click": _vm.cancelarBriefing
	    }
	  }, [_vm._v("  \n                          Cancelar  \n                        ")])])])], 1)]) : _vm._e()])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Relatórios")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Relatórios da Proposta")])])
	}]}

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("FAV")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-maxlength ng-valid-minlength ng-valid-mask ng-valid-parse ng-valid-date ng-valid-max ng-valid ng-valid-required",
	    attrs: {
	      "name": "user",
	      "novalidate": ""
	    }
	  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmRegUserFbb.$submitted && frmRegUserFbb.userName.$error.required }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fav.name),
	      expression: "fav.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "favName",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.fav.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fav, "name", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), (this.$root.authorize('perfil-novo')) ? _c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Cadastro de Perguntas")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onAdd($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atribuir ")])], 1)]), _vm._v(" "), (_vm.show) ? _c('div', {
	    staticClass: "well well-sm no-shadow animated fadeInDownOutUp ng-pristine ng-valid-mask ng-invalid ng-invalid-required ng-valid-maxlength ng-valid-max ng-valid-date ng-hide"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "questionNumber"
	    }
	  }, [_vm._v("Número da Pergunta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.questionNumber),
	      expression: "questao.questionNumber"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-isolate-scope ng-valid-mask ng-empty ng-valid-maxlength",
	    attrs: {
	      "name": "questionNumber",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.questao.questionNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.questao, "questionNumber", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "local"
	    }
	  }, [_vm._v("Local:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.local),
	      expression: "questao.local"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "local"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.questao, "local", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.listaLocais), function(local) {
	    return _c('option', {
	      domProps: {
	        "value": local
	      }
	    }, [_vm._v(_vm._s(local))])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmRegUserFbb.$submitted && frmRegUserFbb.userName.$error.required }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "pergunta"
	    }
	  }, [_vm._v("Pergunta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.question),
	      expression: "questao.question"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "favQuestion",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.questao.question)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.questao, "question", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "bt_conformidade"
	    }
	  }, [_vm._v("Respostas:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.conformityYes),
	      expression: "questao.conformityYes"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Sim"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.questao.conformityYes) ? _vm._i(_vm.questao.conformityYes, "Sim") > -1 : (_vm.questao.conformityYes)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.questao.conformityYes,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Sim",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.questao, "conformityYes", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.questao, "conformityYes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.questao, "conformityYes", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "conformityYes"
	    }
	  }, [_vm._v("Sim")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.conformityNo),
	      expression: "questao.conformityNo"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Não"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.questao.conformityNo) ? _vm._i(_vm.questao.conformityNo, "Não") > -1 : (_vm.questao.conformityNo)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.questao.conformityNo,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Não",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.questao, "conformityNo", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.questao, "conformityNo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.questao, "conformityNo", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "conformityNo"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.conformityNA),
	      expression: "questao.conformityNA"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "NA"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.questao.conformityNA) ? _vm._i(_vm.questao.conformityNA, "NA") > -1 : (_vm.questao.conformityNA)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.questao.conformityNA,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "NA",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.questao, "conformityNA", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.questao, "conformityNA", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.questao, "conformityNA", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "conformityNA"
	    }
	  }, [_vm._v("N/A")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-10 col-sm-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "items": _vm.table2.items,
	      "hover": _vm.table2.hover,
	      "fields": _vm.table2.fields,
	      "current-page": _vm.table2.currentPage,
	      "per-page": _vm.table2.perPage,
	      "sort-by": _vm.table2.sortBy,
	      "sort-desc": _vm.table2.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table2, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table2, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table2, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table2, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onEdit(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onDelete(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("Excluir")])], 1)]
	      }
	    }, {
	      key: "conformityYes",
	      fn: function(row) {
	        return [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (row.item.conformityYes),
	            expression: "row.item.conformityYes"
	          }],
	          attrs: {
	            "type": "checkbox",
	            "name": "conformityYes",
	            "disabled": true
	          },
	          domProps: {
	            "checked": Array.isArray(row.item.conformityYes) ? _vm._i(row.item.conformityYes, null) > -1 : (row.item.conformityYes)
	          },
	          on: {
	            "change": function($event) {
	              var $$a = row.item.conformityYes,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(row.item, "conformityYes", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(row.item, "conformityYes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(row.item, "conformityYes", $$c)
	              }
	            }
	          }
	        })]
	      }
	    }, {
	      key: "conformityNo",
	      fn: function(row) {
	        return [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (row.item.conformityNo),
	            expression: "row.item.conformityNo"
	          }],
	          attrs: {
	            "type": "checkbox",
	            "name": "conformityNo",
	            "disabled": true
	          },
	          domProps: {
	            "checked": Array.isArray(row.item.conformityNo) ? _vm._i(row.item.conformityNo, null) > -1 : (row.item.conformityNo)
	          },
	          on: {
	            "change": function($event) {
	              var $$a = row.item.conformityNo,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(row.item, "conformityNo", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(row.item, "conformityNo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(row.item, "conformityNo", $$c)
	              }
	            }
	          }
	        })]
	      }
	    }, {
	      key: "conformityNA",
	      fn: function(row) {
	        return [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (row.item.conformityNA),
	            expression: "row.item.conformityNA"
	          }],
	          attrs: {
	            "type": "checkbox",
	            "name": "conformityNA",
	            "disabled": true
	          },
	          domProps: {
	            "checked": Array.isArray(row.item.conformityNA) ? _vm._i(row.item.conformityNA, null) > -1 : (row.item.conformityNA)
	          },
	          on: {
	            "change": function($event) {
	              var $$a = row.item.conformityNA,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(row.item, "conformityNA", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(row.item, "conformityNA", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(row.item, "conformityNA", $$c)
	              }
	            }
	          }
	        })]
	      }
	    }], null, false, 3105640627)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onSave($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de uma FAV")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])
	}]}

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Parceiros Estratégicos'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Parceiros Estratégicos")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Parceiros Estratégicos',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4",
	    staticStyle: {
	      "margin-bottom": "1rem"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row col-sm-12"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "disabled": !this.$root.authorize('parceiro-estrategico-novo'),
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-parceiro-estrategico-novo'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Parceiro Estratégico ")])], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "ds_cnpj",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss",
	            "type": "button"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-parceiro-estrategico-edita',
	                params: {
	                  id: row.item.id,
	                  opcao: 'visualizar'
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Visualizar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-parceiro-estrategico-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta de Parceiros Estratégicos")])])
	}]}

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm.ehVisualizacao ? 'Visualização da' : (_vm.ehAssinatura ? 'Assinar a ' : _vm.enumeradores[_vm.etapa] + ' de ')) + " Ratificação " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]), _vm._v(" "), (!_vm.ehAssinatura) ? _c('span', [(!_vm.loading.tela && !_vm.ehVisualizacao || (_vm._.includes(['SOLICITACAO', 'CONCLUSAO'], _vm.etapa)) || (_vm.etapa === 'ASSINATURA_RATIFICACAO' && _vm.ehAssinatura && _vm.usuarioPodeAssinar)) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.permiteConcluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.ehAssinatura) ? _c('span', [(!_vm.loading.tela && !_vm.ehVisualizacao || (_vm._.includes(['SOLICITACAO', 'CONCLUSAO'], _vm.etapa)) || (_vm.etapa === 'ASSINATURA_RATIFICACAO' && _vm.ehAssinatura && _vm.usuarioPodeAssinar)) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.permiteConcluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Assinar ")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading.tela) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.voltar($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Remessa',
	        href: '#'
	      }, {
	        text: 'Lista de Ratificações',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela && !_vm.usuarioPodeAssinar && _vm.ehAssinatura),
	      expression: "!loading.tela && !usuarioPodeAssinar && ehAssinatura"
	    }],
	    staticClass: "alert alert-info mt-4",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("Você não é destinatário desta ratificação.")]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "edicaoRatificacao"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela || _vm.loading.usuarios),
	      expression: "loading.tela || loading.usuarios"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('assunto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "assunto_ratificacao"
	    }
	  }, [_vm._v("Assunto da ratificação?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ratificacao.assunto),
	      expression: "ratificacao.assunto"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "assunto",
	      "id": "assunto_ratificacao",
	      "aria-hidden": "true",
	      "disabled": _vm.ehVisualizacao || _vm.ehAssinatura || _vm.etapa !== 'SOLICITACAO'
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.ratificacao, "assunto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.selecaoAssunto]
	    }
	  }, _vm._l((_vm.listaAssuntos), function(item) {
	    return _c('option', {
	      domProps: {
	        "value": item.value
	      }
	    }, [_vm._v(_vm._s(item.name))])
	  }), 0), _vm._v(" "), (_vm.errors.first('assunto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('assunto')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('solicitação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "requerimento_ratificacao"
	    }
	  }, [_vm._v("Solicitação")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Descreva aqui a solicitação sobre o assunto selecionado",
	      "name": "solicitação",
	      "id": "requerimento_ratificacao",
	      "disabled": _vm.ehVisualizacao || _vm.ehAssinatura
	    },
	    model: {
	      value: (_vm.ratificacao.requerimento),
	      callback: function($$v) {
	        _vm.$set(_vm.ratificacao, "requerimento", $$v)
	      },
	      expression: "ratificacao.requerimento"
	    }
	  }), _vm._v(" "), (_vm.errors.first('solicitação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('solicitação')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('destinatario')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "alcada_ratificacao"
	    }
	  }, [_vm._v("Destinatário")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.loading.usuarios) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _c('span', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaUsuarios,
	      "multiple": true,
	      "value": _vm.ds_nome_usuario,
	      "disabled": _vm.ehVisualizacao || _vm.ehAssinatura || _vm.etapa !== 'SOLICITACAO',
	      "custom-label": _vm.nomeUsuario,
	      "placeholder": "Selecione um ou mais usuários",
	      "label": "ds_nome_usuario",
	      "track-by": "ds_nome_usuario",
	      "preselect-first": false,
	      "close-on-select": false,
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "selectedLabel": "",
	      "name": "destinatario",
	      "id": "alcada_ratificacao"
	    },
	    on: {
	      "input": _vm.selecionandoDestinatario
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.ds_nome_usuario))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.ratificacao.alcada),
	      callback: function($$v) {
	        _vm.$set(_vm.ratificacao, "alcada", $$v)
	      },
	      expression: "ratificacao.alcada"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('destinatario')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('destinatario')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'top'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	    }],
	    staticClass: "col-md-4",
	    attrs: {
	      "title": '<h5>Dos destinatários selecionados qual a quantidade mínima de assinaturas são necessárias para o processo retornar</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-9",
	    attrs: {
	      "for": "qtde_assinaturas_obrigatorias"
	    }
	  }, [_vm._v("Quantidade de assinaturas obrigatórias")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ratificacao.qtdeAssinaturasObrigatorias),
	      expression: "ratificacao.qtdeAssinaturasObrigatorias"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "qtde_assinaturas_obrigatorias",
	      "disabled": _vm.ehVisualizacao || _vm.ehAssinatura || _vm.etapa !== 'SOLICITACAO'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.ratificacao, "qtdeAssinaturasObrigatorias", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l(((_vm._.isNull(_vm.ratificacao.alcada) ? 1 : _vm.ratificacao.alcada.length)), function(qtde) {
	    return _c('option', {
	      domProps: {
	        "value": qtde
	      }
	    }, [_vm._v(_vm._s(qtde))])
	  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('upload-documentos-ratificacao', {
	    attrs: {
	      "foiAssinada": _vm.foiAssinada,
	      "processo_ratificacao": _vm.id,
	      "propDocumentos": _vm.ratificacao.anexos,
	      "documentTypes": '',
	      "disable": _vm.ehVisualizacao || _vm.ehAssinatura,
	      "local-uso": _vm.ratificacao.assunto.codigo
	    }
	  })], 1)]), _vm._v(" "), (!_vm._.isNull(_vm.id)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.historico), function(tarefa) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("moment")(tarefa.termino, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm.enumeradores[tarefa.nome]))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(tarefa.observacao))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [(tarefa.nome === 'ASSINATURA_RATIFICACAO') ? _c('span', [(_vm._.includes(tarefa.resultado, 'Sim')) ? _c('span', [_c('i', {
	      staticClass: "fa fa-check text-green",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]) : (_vm._.includes(tarefa.resultado, 'Nao')) ? _c('span', [_c('i', {
	      staticClass: "fa fa-times text-red",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]) : _c('span', {
	      staticClass: "text-blue"
	    }, [_vm._v("\n                            " + _vm._s(_vm.ratificacao.qtdeAssinaturasObrigatorias > _vm._.sumBy(_vm.historico, function(h) {
	      return h.nome === 'ASSINATURA_RATIFICACAO' && _vm._.includes(h.resultado, 'Sim') ? 1 : 0
	    }) ? 'Pendente' : '') + "\n                          ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(tarefa.ds_nome_usuario))])])
	  }), 0)])])])]) : _vm._e()])])]), _vm._v(" "), (_vm.ehAssinatura && _vm.usuarioPodeAssinar) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "decisoes_aprovação"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('aprovacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Aprovar solicitação?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ratificacao.aprovacao),
	      expression: "ratificacao.aprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "aprovacao",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": 'Sim',
	      "checked": _vm._q(_vm.ratificacao.aprovacao, 'Sim')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ratificacao, "aprovacao", 'Sim')
	      }
	    }
	  }), _vm._v(" Sim\n                                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ratificacao.aprovacao),
	      expression: "ratificacao.aprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "aprovacao",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": 'Nao',
	      "checked": _vm._q(_vm.ratificacao.aprovacao, 'Nao')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ratificacao, "aprovacao", 'Nao')
	      }
	    }
	  }), _vm._v(" Não\n                                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('aprovacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('aprovacao')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "observacao_decisao"
	    }
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ratificacao.observacao),
	      expression: "ratificacao.observacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao_decisao",
	      "id": "observacao_decisao",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.ratificacao.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.ratificacao, "observacao", $event.target.value)
	      }
	    }
	  })])])])])])])])])])])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Solicitação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(" Anexos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "width": "140px"
	    }
	  }, [_vm._v("Data de conclusão")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "140px"
	    }
	  }, [_vm._v("Fase")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "140px"
	    }
	  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "140px"
	    }
	  }, [_vm._v("Aprovação")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "140px"
	    }
	  }, [_vm._v("Usuário Responsável")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Decisões")])])
	}]}

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "w-100"
	  }, [(_vm.abrirBancoPrecos) ? _c('bancoPrecos', {
	    attrs: {
	      "gravaSelecaoItens": _vm.gravaSelecaoItens,
	      "toggleBancoPrecos": _vm.toggleBancoPrecos
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.abrirBancoPrecos) ? _c('div', {
	    staticClass: "box-body column centered-start cotacao-itens-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start cotacao-main-container"
	  }, [(_vm.abrirDetalheItem) ? _c('div', {
	    ref: "detalhamentoContainer",
	    staticClass: "column all-centered cotacao-detalhamento-item"
	  }, [_c('detalheItemLicitacao', {
	    attrs: {
	      "itemLicitacao": _vm.itemDetalheSelecionado,
	      "toggleDetalhe": _vm.toggleDetalhe
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticClass: "column centered-start cotacao-adicionar-container"
	  }, [_c('div', {
	    staticClass: "row centered-start w-100"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleBancoPrecos(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-cart",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Abrir Banco de Cotações  ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.limparSelecao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar ")])], 1)]), _vm._v(" "), _c('div', {
	    ref: "nomeItemCotacao",
	    staticClass: "column all-start cotacao-input-container"
	  }, [_c('label', {
	    staticClass: "f-required"
	  }, [_vm._v("Item de cotação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nomeItem),
	      expression: "nomeItem"
	    }],
	    staticClass: "form-control",
	    class: _vm.errorInput ? 'error-input' : '',
	    attrs: {
	      "type": "text",
	      "placeholder": "Digite o nome do item a ser cotado, ref. histórico do cronograma."
	    },
	    domProps: {
	      "value": (_vm.nomeItem)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.nomeItem = $event.target.value
	      }, function($event) {
	        _vm.errorInput = false
	      }]
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start cotacao-titulo-container"
	  }, [_c('div', {
	    staticClass: "cotacao-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle"
	  }), _vm._v(" Itens Selecionados\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between cotacao-subtitulo"
	  }, [_c('div', [_vm._v("Confira os (" + _vm._s(_vm.table.items.length) + ") itens que "), _c('b', [_vm._v("estão sendo utilizados")]), _vm._v(" para compor a cotação")])])]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.detalharItem(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]
	      }
	    }, {
	      key: "descricao_item",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-start banco-precos-table-descricao-container"
	        }, [_c('div', {
	          staticClass: "banco-precos-table-descricao",
	          attrs: {
	            "title": row.value
	          }
	        }, [_vm._v("\n                  [" + _vm._s(row.item.id) + "] " + _vm._s(row.value) + "\n                ")])])]
	      }
	    }, {
	      key: "valor_item",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(_vm._f("real")(row.value)) + "\n            ")]
	      }
	    }, {
	      key: "selecionado",
	      fn: function(row) {
	        return [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (row.item.selecionado),
	            expression: "row.item.selecionado"
	          }],
	          attrs: {
	            "type": "checkbox"
	          },
	          domProps: {
	            "checked": Array.isArray(row.item.selecionado) ? _vm._i(row.item.selecionado, null) > -1 : (row.item.selecionado)
	          },
	          on: {
	            "change": function($event) {
	              var $$a = row.item.selecionado,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(row.item, "selecionado", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(row.item, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(row.item, "selecionado", $$c)
	              }
	            }
	          }
	        })]
	      }
	    }, {
	      key: "data_resultado_licitacao",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(row.value !== '' ? _vm.moment.utc(row.value).format('MM/YYYY') : '-') + "\n            ")]
	      }
	    }, {
	      key: "sigla_uf",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(row.value !== '0' ? row.value : '-') + "\n            ")]
	      }
	    }], null, false, 2380468564)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), (_vm.tableSaneados.items.length > 0) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticClass: "column centered-start cotacao-titulo-container"
	  }, [_c('div', {
	    staticClass: "cotacao-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-recycle"
	  }), _vm._v(" Itens Saneados\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between cotacao-subtitulo"
	  }, [_c('div', [_vm._v("Confira os (" + _vm._s(_vm.tableSaneados.items.length) + ") itens que foram "), _c('b', [_vm._v("saneados")]), _vm._v(" do cálculo da cotação")])])]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableSaneados.bordered,
	      "items": _vm.tableSaneados.items,
	      "hover": _vm.tableSaneados.hover,
	      "fields": _vm.tableSaneados.fields,
	      "filter": _vm.tableSaneados.filter,
	      "current-page": _vm.tableSaneados.currentPage,
	      "per-page": _vm.tableSaneados.perPage,
	      "sort-by": _vm.tableSaneados.sortBy,
	      "sort-desc": _vm.tableSaneados.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableSaneados, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableSaneados, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableSaneados, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableSaneados, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.detalharItem(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]
	      }
	    }, {
	      key: "descricao_item",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-start"
	        }, [_c('div', {
	          staticClass: "banco-precos-table-descricao",
	          attrs: {
	            "title": row.value
	          }
	        }, [_vm._v("\n                  [" + _vm._s(row.item.id) + "] " + _vm._s(row.value) + "\n                ")])])]
	      }
	    }, {
	      key: "valor_item",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(_vm._f("real")(row.value)) + "\n            ")]
	      }
	    }, {
	      key: "diagnostico",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "cotacao-saneado-row"
	        }, [_c('i', {
	          class: 'fa ' + (parseFloat(row.item.valor_item) > _vm.calculoAmostral.LS ? 'fa-arrow-up' : ' fa-arrow-down')
	        }), _vm._v(" " + _vm._s(parseFloat(row.item.valor_item) > _vm.calculoAmostral.LS ? 'Acima do Limite Superior' : 'Abaixo do Limite Inferior') + "\n              ")])]
	      }
	    }], null, false, 2836757405)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.tableSaneados.items.length,
	      "per-page": _vm.tableSaneados.perPage
	    },
	    model: {
	      value: (_vm.tableSaneados.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tableSaneados, "currentPage", $$v)
	      },
	      expression: "tableSaneados.currentPage"
	    }
	  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tableContaminados.items.length > 0) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticClass: "column centered-start cotacao-titulo-container"
	  }, [_c('div', {
	    staticClass: "cotacao-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Itens contaminados\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between cotacao-subtitulo"
	  }, [_c('div', [_vm._v("Confira os (" + _vm._s(_vm.tableContaminados.items.length) + ") itens que foram "), _c('b', [_vm._v("removidos")]), _vm._v(" do cálculo da cotação por discrepância muito grande de valor")])])]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableContaminados.bordered,
	      "items": _vm.tableContaminados.items,
	      "hover": _vm.tableContaminados.hover,
	      "fields": _vm.tableContaminados.fields,
	      "filter": _vm.tableContaminados.filter,
	      "current-page": _vm.tableContaminados.currentPage,
	      "per-page": _vm.tableContaminados.perPage,
	      "sort-by": _vm.tableContaminados.sortBy,
	      "sort-desc": _vm.tableContaminados.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableContaminados, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableContaminados, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableContaminados, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableContaminados, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.detalharItem(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]
	      }
	    }, {
	      key: "descricao_item",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-start banco-precos-table-descricao-container"
	        }, [_c('div', {
	          staticClass: "banco-precos-table-descricao",
	          attrs: {
	            "title": row.value
	          }
	        }, [_vm._v("\n                  [" + _vm._s(row.item.id) + "] " + _vm._s(row.value) + "\n                ")])])]
	      }
	    }, {
	      key: "valor_item",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(_vm._f("real")(row.value)) + "\n            ")]
	      }
	    }, {
	      key: "diagnostico",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "cotacao-contaminado-row"
	        }, [_c('i', {
	          staticClass: "fa fa-warning",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(parseFloat(row.item.valor_item) > _vm.calculoAmostral.LS ? 'Muito Acima do Limite Superior' : 'Abaixo do Limite Inferior') + "\n              ")])]
	      }
	    }], null, false, 3502277068)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.tableContaminados.items.length,
	      "per-page": _vm.tableContaminados.perPage
	    },
	    model: {
	      value: (_vm.tableContaminados.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tableContaminados, "currentPage", $$v)
	      },
	      expression: "tableContaminados.currentPage"
	    }
	  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tableRemovidosManual.items.length > 0) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticClass: "column centered-start cotacao-titulo-container"
	  }, [_c('div', {
	    staticClass: "cotacao-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle"
	  }), _vm._v(" Itens Removidos Manualmente\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between cotacao-subtitulo"
	  }, [_c('div', [_vm._v("Confira os (" + _vm._s(_vm.tableRemovidosManual.items.length) + ") itens que foram "), _c('b', [_vm._v("removidos manualmente")]), _vm._v(" pelo usuário. (Pendente de Validação)")])])]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableRemovidosManual.bordered,
	      "items": _vm.tableRemovidosManual.items,
	      "hover": _vm.tableRemovidosManual.hover,
	      "fields": _vm.tableRemovidosManual.fields,
	      "filter": _vm.tableRemovidosManual.filter,
	      "current-page": _vm.tableRemovidosManual.currentPage,
	      "per-page": _vm.tableRemovidosManual.perPage,
	      "sort-by": _vm.tableRemovidosManual.sortBy,
	      "sort-desc": _vm.tableRemovidosManual.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableRemovidosManual, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableRemovidosManual, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableRemovidosManual, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableRemovidosManual, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.detalharItem(row.item.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]
	      }
	    }, {
	      key: "item.descricao_item",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-start banco-precos-table-descricao-container"
	        }, [_c('div', {
	          staticClass: "banco-precos-table-descricao",
	          attrs: {
	            "title": row.value
	          }
	        }, [_vm._v("\n                  [" + _vm._s(row.item.item.id) + "] " + _vm._s(row.value) + "\n                ")])])]
	      }
	    }, {
	      key: "item.valor_item",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(_vm._f("real")(row.value)) + "\n            ")]
	      }
	    }, {
	      key: "justificativa",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-centered cotacao-removido-manual-row"
	        }, [_c('i', {
	          staticClass: "fa fa-warning",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.value) + "\n              ")])]
	      }
	    }], null, false, 3871503153)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.tableRemovidosManual.items.length,
	      "per-page": _vm.tableRemovidosManual.perPage
	    },
	    model: {
	      value: (_vm.tableRemovidosManual.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tableRemovidosManual, "currentPage", $$v)
	      },
	      expression: "tableRemovidosManual.currentPage"
	    }
	  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.universoAmostral.length > 0) ? _c('div', {
	    staticClass: "row-flex centered-start cotacao-resumo-container"
	  }, [_c('i', {
	    staticClass: "fa fa-dollar"
	  }), _vm._v(" "), _c('b', [_vm._v("Resumo da Cotação")])]) : _vm._e(), _vm._v(" "), (_vm.universoAmostral.length > 0) ? _c('div', {
	    staticClass: "column all-centered cotacao-calculo-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered cotacao-calculo-tabela-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered cotacao-tabelas"
	  }, [_vm._m(1), _vm._v(" "), _c('tr', {
	    staticClass: "column centered-start cotacao-tabela"
	  }, [_c('td', {
	    staticClass: "cotacao-tabela-header"
	  }, [_vm._v("Universo Amostral Selecionado")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.media)))]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.DP)))]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm.calculoAmostral.CV) + "%")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.LS)))]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.LI)))])]), _vm._v(" "), _c('tr', {
	    staticClass: "column centered-start cotacao-tabela"
	  }, [_c('td', {
	    staticClass: "cotacao-tabela-header"
	  }, [_vm._v("Universo Amostral Saneado")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.calculoFinal.media)) + " (Média Saneada)")])]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_c('b', [_vm._v(_vm._s(_vm.calculoFinal.CV) + "% (CV Saneado)*")])]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("-")])])]), _vm._v(" "), _c('div', {
	    staticClass: "column all-centered cotacao-indicativo"
	  }, [_c('div', {
	    staticClass: "column all-centered cotacao-resumo"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "column all-end resumo-container"
	  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.table.items.length + _vm.tableSaneados.items.length) + " ")]), _vm._v(" Itens Encontrados\n              ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.tableSaneados.items.length) + " ")]), _vm._v(" Itens Saneados\n              ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.table.items.length) + " ")]), _vm._v(" Itens Cotados\n              ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.calculoFinal.CV) + "% ")]), _vm._v(" Coeficiente de Variação\n              ")])]), _vm._v(" "), (_vm.calculoFinal.CV <= 25 && _vm.calculoFinal.CV !== 0) ? _c('div', {
	    staticClass: "row-flex all-centered diagnostico-card diagnostico-ok"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-up"
	  }), _vm._v(" CV calculado indica razoável homogeneização do Valor.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.calculoFinal.CV > 25) ? _c('div', {
	    staticClass: "row-flex all-centered diagnostico-card diagnostico-atencao"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle"
	  }), _vm._v(" O CV calculado indica baixa homogeneização do Valor, atenção. Sujeito a análise.\n            ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between cotacao-media-saneada-container"
	  }, [_vm._v("\n        Preço referência da Amostra (Média Saneada):\n        "), _c('span', [_vm._v("\n          " + _vm._s(_vm._f("real")(_vm.calculoFinal.media)) + "\n        ")])]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start w-100 gap-5 button-cotacao-container"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarCotacaoItem()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar Cotação de Item ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleAdicionarItem(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")])], 1)]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start cotacao-header-container"
	  }, [_c('i', {
	    staticClass: "fa fa-dollar"
	  }), _vm._v(" "), _c('b', [_vm._v("Cotação de Preços")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    staticClass: "column centered-start cotacao-tabela"
	  }, [_c('td', {
	    staticClass: "cotacao-tabela-header"
	  }, [_vm._v("Variáveis")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Média")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Desvio Padrão (DP):")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Coeficiente de Variação (CV):")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Limite Superior (LS):")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Limite Inferior (LI):")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start cotacao-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-map-pin"
	  }), _vm._v(" Resumo:\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex all-end w-100"
	  }, [_c('i', [_vm._v("*CV menor que 25% indica razoável homogeneidade.")])])
	}]}

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.showGrid) ? _c('div', {
	    staticClass: "column all-start well well-sm no-shadow",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "column all-start prest-upload"
	  }, [_c('div', {
	    staticClass: "required-field prest-upload-input row-flex centered-start",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "f-required prest-upload-label",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento
	      }
	    }, [_vm._v(_vm._s(documento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "required-field prest-upload-input row-flex centered-start",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "f-required prest-upload-label",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: false,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: false, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file",
	      "accept": _vm.restricaoArquivo ? '.pdf, application/pdf' : '*'
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  }), _vm._v(" "), (_vm.analise.hasOwnProperty('analise')) ? _c('div', [_c('i', {
	    class: 'fa' + (_vm.analise.analise.RESPOSTA === 'SIM' ? ' fa-check text-success' : ' fa-times text-danger'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.analise.analise.RESPOSTA == 'NÃO' ? 'Arquivo não classificado como documento fiscal' : 'Arquivo válido'))]) : _vm._e(), _vm._v(" "), (_vm.analisandoArquivo) ? _c('div', [_c('i', {
	    staticClass: "fa fa-spinner fa-spin",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Analisando arquivo...")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "prest-upload-input row-flex centered-start",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('label', {
	    staticClass: "prest-upload-label",
	    attrs: {
	      "for": "expirationDate"
	    }
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', [_c('div', {
	    attrs: {
	      "ng-if": "!$ctrl.flagNovoDocumento",
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalStateForm"
	    }
	  }, [_c('datepicker', {
	    attrs: {
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.documento.expirationDate),
	      callback: function($$v) {
	        _vm.$set(_vm.documento, "expirationDate", $$v)
	      },
	      expression: "documento.expirationDate"
	    }
	  })], 1)])]), _vm._v(" "), (_vm.restricaoArquivo) ? _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("\n          Formato: "), _c('b', [_vm._v("PDF")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("\n          Tamanho máximo: "), _c('b', [_vm._v("4 MB")]), _vm._v(" "), (_vm.restricaoArquivo) ? _c('i', [_vm._v(" / 10 Mil Caracteres")]) : _vm._e()]), _vm._v(" "), (_vm.restricaoArquivo) ? _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("\n          *Atenção: envie um documento "), _c('b', [_vm._v("nítido, legível e sem cortes")]), _vm._v(". O arquivo será analisado automaticamente por OCR; documentos borrados, escuros, tortos, com baixa resolução ou parcialmente ilegíveis podem "), _c('b', [_vm._v("não ser reconhecidos corretamente pelo sistema")]), _vm._v(".\n        ")]) : _vm._e(), _vm._v(" "), (_vm.analise.analise) ? _c('div', {
	    staticClass: "prest-analise-ia-container row-flex centered-start"
	  }, [(_vm.analise.analise.RESPOSTA === 'NÃO') ? _c('div', {
	    staticClass: "prest-analise-ia-item row-flex centered-start"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Análise do arquivo: " + _vm._s(_vm.analise.analise.DESCRITIVO) + "\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-upload-button-container",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [(!_vm.restricaoArquivo) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n            ")]) : _vm._e(), _vm._v(" "), (_vm.restricaoArquivo && !_vm.analisandoArquivo && _vm.analise.hasOwnProperty('analise') && _vm.analise.analise.RESPOSTA === 'SIM') ? _c('div', [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n              ")])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), (!_vm.disableAdd) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.novoDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
	    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(pendente.type))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
	      staticStyle: {
	        "max-width": "135px",
	        "text-align": "center"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onAddFile(pendente)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Adicionar arquivo")]) : _vm._e()])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deletaDocumento(indexDocumento, documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")]) : _vm._e()]) : _vm._e()])
	  })], 2)])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "text-danger"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pendente")])])
	}]}

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Sumários Executivos'
	    }
	  }), _vm._v(" "), _c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Sumários Executivos")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Sumários Executivos',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaSumarioExecutivo"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Lista de Sumários Executivos "), (!_vm.loading.tela) ? _c('span', {
	    staticClass: "info_discreto"
	  }, [_vm._v(_vm._s(_vm.tabelaSumarioExecutivo.totalRows) + " localizado(s)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'edita-sumario-executivo',
	          params: {
	            id: null
	          }
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Sumário ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": _vm.ajustaPesquisa,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.tabelaSumarioExecutivo.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.tabelaSumarioExecutivo.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row box-body"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: 'tabelaDetalhe',
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "hover": "",
	      "bordered": _vm.tabelaSumarioExecutivo.bordered,
	      "items": _vm.sumarios,
	      "fields": _vm.camposSumarioExecutivo,
	      "filter": _vm.tabelaSumarioExecutivo.filter,
	      "filter-function": _vm.filtroPorItem,
	      "current-page": _vm.tabelaSumarioExecutivo.currentPage,
	      "per-page": _vm.tabelaSumarioExecutivo.perPage,
	      "sort-by": _vm.tabelaSumarioExecutivo.sortBy,
	      "sort-desc": _vm.tabelaSumarioExecutivo.sortDesc,
	      "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tabelaSumarioExecutivo, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tabelaSumarioExecutivo, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tabelaSumarioExecutivo, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tabelaSumarioExecutivo, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "id",
	      fn: function(row) {
	        return [_vm._v("\n                      " + _vm._s(row.value) + "\n                    ")]
	      }
	    }, {
	      key: "sumario.acao",
	      fn: function(row) {
	        return [_c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'top',
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              delay: [500, 0]
	            }),
	            expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	          }],
	          staticClass: "link_acesso",
	          attrs: {
	            "title": '<h5>Clique para copiar link para uso externo ao SGP</h5>'
	          },
	          on: {
	            "click": function($event) {
	              return _vm.copiaUrl(row)
	            }
	          }
	        }, [_vm._v("\n                        " + _vm._s(row.value) + "\n                        "), (_vm._.has(row.item, 'link_copia')) ? _c('span', {
	          class: _vm._.get(row.item, 'link_copia.classe')
	        }, [_vm._v(_vm._s(_vm._.get(row.item, 'link_copia.msg')))]) : _vm._e()])]
	      }
	    }, {
	      key: "sumario.data",
	      fn: function(row) {
	        return [_vm._v("\n                      " + _vm._s(_vm.moment(row.item.sumario.data).add(1, 'day').format('DD/MM/YYYY')) + "\n                      "), _c('br'), _vm._v("\n                      " + _vm._s(row.item.sumario.inicio) + " até " + _vm._s(row.item.sumario.termino) + "\n                    ")]
	      }
	    }, {
	      key: "sumario.local",
	      fn: function(row) {
	        return [_vm._v("\n                      " + _vm._s(row.item.sumario.local) + "\n                    ")]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-sumario-executivo',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-sumario-executivo',
	                params: {
	                  id: row.item.id,
	                  visualizacao: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Visualizar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.duplicarSumario(row.item.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-plus",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Duplicar")])]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.tabelaSumarioExecutivo.totalRows,
	      "per-page": _vm.tabelaSumarioExecutivo.perPage
	    },
	    model: {
	      value: (_vm.tabelaSumarioExecutivo.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tabelaSumarioExecutivo, "currentPage", $$v)
	      },
	      expression: "tabelaSumarioExecutivo.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa...",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSearch($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSearch
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "items": _vm.table.items,
	      "hover": _vm.hover,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Informe nome, login, e-mail ou tipo do usuário!",
	      "table-layout:": "",
	      "fixed": ""
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "filtered": _vm.onFiltered
	    },
	    scopedSlots: _vm._u([{
	      key: "ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value == '1' ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "data_criacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "email",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "acoes",
	      fn: function(row) {
	        return [_c('div', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-usuarios-altera',
	                params: {
	                  id: row.item.id_usuario
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Editar")])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Usuários")])])
	}]}

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": _vm.idName
	    },
	    on: {
	      "click": _vm.generate
	    }
	  }, [_vm._t("default", [_vm._v("\n\t\tDownload " + _vm._s(_vm.name) + "\n\t")])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1865 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Relatórios de Execução\n        "), _vm._v(" "), (!_vm.loading.tela) ? _c('span', [(!_vm.ehVisualizacao && _vm.telaRelatorio.alerta.restricao !== 'ENVIO_BLOQUEADO') ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.permiteConcluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvaRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.print($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" PDF")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5>Faz o download de todos os arquivos (zip)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onDownloadZIP()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v(" Baixar arquivos")])]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1) : _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Projetos',
	        href: '/projetos/lista'
	      }, {
	        text: 'Relatório de Execuação',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm.telaRelatorio.alerta.situacao !== 'OCULTO') ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrar_msg),
	      expression: "mostrar_msg"
	    }],
	    staticClass: "alert alert-dismissible alert-warning"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
	    staticClass: "fa fa fa-info"
	  }), _vm._v("  " + _vm._s(_vm.telaRelatorio.alerta.titulo))]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.telaRelatorio.alerta.conteudo)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.aviso.situacao !== 'OCULTO') ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrar_msg),
	      expression: "mostrar_msg"
	    }],
	    staticClass: "alert alert-dismissible alert-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
	    staticClass: "fa fa-info"
	  }), _vm._v("  " + _vm._s(_vm.telaRelatorio.aviso.titulo))]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.telaRelatorio.aviso.conteudo)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.tipoUsu === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "100px",
	      "padding": "0px"
	    }
	  }, [_c('RelatorioBNDES', {
	    key: _vm.componentKey,
	    ref: "relatorioBNDESChildRef",
	    attrs: {
	      "dadosRelatorio": _vm.telaRelatorio,
	      "previstoPublicoAlvo": _vm.previstoPublicoAlvo,
	      "totalizadores": _vm.totalizadoresListaParticipantes,
	      "executadasparcial": _vm.executadasparcial,
	      "naoexecutadas": _vm.naoexecutadas,
	      "contrapartida": _vm.telaRelatorio.contrapartida_comprovada.row
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('usuarioEnvioNome')
	    }
	  }, [_c('label', {
	    staticClass: "col control-label"
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col "
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.usuario_enviou.nome),
	      expression: "telaRelatorio.usuario_enviou.nome"
	    }],
	    staticClass: "form-control",
	    class: {
	      'has-error': _vm.errors.first('usuarioEnvioNome')
	    },
	    attrs: {
	      "disabled": true,
	      "id": "usuarioEnvioNome",
	      "name": "usuarioEnvioNome",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.usuario_enviou.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.usuario_enviou, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('usuarioEnvioNome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Usuário que enviou é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('usuarioEnvioCPF')
	    }
	  }, [_c('label', {
	    staticClass: "col control-label"
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.usuario_enviou.cpf),
	      expression: "telaRelatorio.usuario_enviou.cpf"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: (['###.###.###-##']),
	      expression: "['###.###.###-##']"
	    }],
	    staticClass: "form-control",
	    class: {
	      'has-error': _vm.errors.first('usuarioEnvioCPF')
	    },
	    attrs: {
	      "disabled": true,
	      "id": "usuarioEnvioCPF",
	      "name": "usuarioEnvioCPF",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.usuario_enviou.cpf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.usuario_enviou, "cpf", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('usuarioEnvioCPF')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CPF do usuário que enviou é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('usuarioEnvioEmail')
	    }
	  }, [_c('label', {
	    staticClass: "col control-label"
	  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.usuario_enviou.email),
	      expression: "telaRelatorio.usuario_enviou.email"
	    }],
	    staticClass: "form-control",
	    class: {
	      'has-error': _vm.errors.first('usuarioEnvioEmail')
	    },
	    attrs: {
	      "disabled": true,
	      "id": "usuarioEnvioEmail",
	      "name": "usuarioEnvioEmail",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.usuario_enviou.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.usuario_enviou, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('usuarioEnvioEmail')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Email do usuário que enviou é obrigatório')))]) : _vm._e()])])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-1"
	  }, [_c('label', [_vm._v("Nº do Projeto:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.numero_projeto),
	      expression: "telaRelatorio.cabecalho.numero_projeto"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "id": "repNumber",
	      "name": "repNumber",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.numero_projeto)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "numero_projeto", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-11"
	  }, [_c('label', {
	    staticClass: "col"
	  }, [_vm._v("Título do Projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.projeto),
	      expression: "telaRelatorio.cabecalho.projeto"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "id": "repTitle",
	      "name": "repTitle",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.projeto)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "projeto", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('label', {
	    staticClass: "col"
	  }, [_vm._v("Início de execução do projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.inicio),
	      expression: "telaRelatorio.cabecalho.inicio"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "id": "inicioProjeto",
	      "name": "inicioProjeto",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.inicio)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "inicio", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('label', {
	    staticClass: "col"
	  }, [_vm._v("Fim de execução do projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.termino),
	      expression: "telaRelatorio.cabecalho.termino"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "id": "terminoProjeto",
	      "name": "terminoProjeto",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.termino)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "termino", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('label', {
	    staticClass: "col"
	  }, [_vm._v("Percentual Financeiro Realizado:")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.percentual_liberacao),
	      expression: "telaRelatorio.cabecalho.percentual_liberacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "id": "percentualLiberacao",
	      "name": "percentualLiberacao",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.percentual_liberacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "percentual_liberacao", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('label', {
	    staticClass: "col"
	  }, [_vm._v("Percentual de tempo decorrido:")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.percentual_andamento),
	      expression: "telaRelatorio.cabecalho.percentual_andamento"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "id": "percentualAndamento",
	      "name": "percentualAndamento",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.percentual_andamento)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "percentual_andamento", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col"
	  }, [_vm._v("Convenente:")]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.entidade),
	      expression: "telaRelatorio.cabecalho.entidade"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "id": "contractor",
	      "name": "contractor",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.entidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "entidade", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('fieldset', [_c('div', {
	    staticClass: "row"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('mail')
	    }
	  }, [_c('div', {
	    staticClass: "col form-group required"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail de contato:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.email_contato),
	      expression: "telaRelatorio.cabecalho.email_contato"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    staticClass: "form-control",
	    class: {
	      'has-error': _vm.errors.first('mail')
	    },
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "id": "mail",
	      "name": "mail",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.email_contato)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "email_contato", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('mail')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('mail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('telefone1')
	    }
	  }, [_c('div', {
	    staticClass: "col form-group required"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone 1:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.telefone_contato_1),
	      expression: "telaRelatorio.cabecalho.telefone_contato_1"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) ####-#####'),
	      expression: "'(##) ####-#####'"
	    }],
	    staticClass: "form-control",
	    class: {
	      'has-error': _vm.errors.first('telefone1')
	    },
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "id": "telefone1",
	      "masked": _vm.masked,
	      "name": "telefone1",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.telefone_contato_1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "telefone_contato_1", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('telefone1')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Telefone é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 form-group"
	  }, [_c('div', {
	    staticClass: "col form-group"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone 2:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cabecalho.telefone_contato_2),
	      expression: "telaRelatorio.cabecalho.telefone_contato_2"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) ####-#####'),
	      expression: "'(##) ####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "id": "telefone2",
	      "masked": _vm.masked,
	      "name": "telefone2",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cabecalho.telefone_contato_2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cabecalho, "telefone_contato_2", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col form-group required",
	    class: {
	      'has-error': _vm.errors.first('relFinal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-right": "8px"
	    }
	  }, [_vm._v("É o relatório final do projeto?")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-2 form-group required",
	    class: {
	      'has-error': _vm.errors.first('relFinal')
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.tipo_relatorio),
	      expression: "telaRelatorio.tipo_relatorio"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "relFinal",
	      "value": "FINAL",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.tipo_relatorio, "FINAL")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio, "tipo_relatorio", "FINAL")
	      }
	    }
	  }), _vm._v(" Sim\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.tipo_relatorio),
	      expression: "telaRelatorio.tipo_relatorio"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "relFinal",
	      "value": "PARCIAL",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.tipo_relatorio, "PARCIAL")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio, "tipo_relatorio", "PARCIAL")
	      }
	    }
	  }), _vm._v(" Não\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('relFinal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Relatório final é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), (_vm.telaRelatorio.tipo_relatorio === 'FINAL') ? _c('div', {
	    class: {
	      'has-error': _vm.errors.first('objeto1')
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group"
	  }, [_c('label', {
	    staticClass: "form-group control-label",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "font-size": "12px"
	    }
	  }, [_vm._v("Indicadores de Execução")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "indicadoresResultado"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.indicadores_resultado),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "indicadores_resultado", $$v)
	      },
	      expression: "proposta.indicadores_resultado"
	    }
	  })], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-2 form-group required"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.objeto),
	      expression: "telaRelatorio.objeto"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "objeto1",
	      "value": "SIM"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.objeto, "SIM")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio, "objeto", "SIM")
	      }
	    }
	  }), _vm._v(" Sim\n                            "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.objeto),
	      expression: "telaRelatorio.objeto"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "objeto1",
	      "value": "NAO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.objeto, "NAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio, "objeto", "NAO")
	      }
	    }
	  }), _vm._v(" Não\n                            "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), (_vm.telaRelatorio.objeto === 'NAO') ? _c('div', {
	    staticClass: "col-md-6 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativaObjeto')
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group required"
	  }, [_c('label', {
	    staticClass: "form-group control-label",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "font-size": "12px"
	    }
	  }, [_vm._v("Justifique")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.objetoJustificativa),
	      expression: "telaRelatorio.objetoJustificativa"
	    }],
	    staticClass: "form-control",
	    class: {
	      'has-error': _vm.errors.first('justificativaObjeto')
	    },
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "name": "justificativaObjeto"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.objetoJustificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio, "objetoJustificativa", $event.target.value)
	      }
	    }
	  })])]) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    ref: "metAtv",
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', {
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, _vm._l((_vm.headerTable.thead), function(head) {
	    return _c('th', {
	      attrs: {
	        "colspan": 4
	      }
	    }, [_c('div', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_vm._v(_vm._s(head.header))])])
	  }), 0), _vm._v(" "), _c('tr', _vm._l((_vm.subArray), function(sub) {
	    return _c('th', {
	      attrs: {
	        "width": sub.width
	      }
	    }, [_c('span', [_c('div', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_vm._v(_vm._s(sub.title))])])])
	  }), 0)]), _vm._v(" "), _vm._l((_vm.telaRelatorio.metas.row), function(data) {
	    return _c('tbody', [_c('tr', [_c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "rowspan": data.atividades.row.length + 1
	      }
	    }, [_vm._v(_vm._s(data.meta))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "rowspan": data.atividades.row.length + 1
	      }
	    }, [_vm._v(_vm._s(data.orcado))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "rowspan": data.atividades.row.length + 1
	      }
	    }, [_c('div', {
	      staticClass: "col form-group required",
	      class: {
	        'has-error': _vm.errors.first('metaRealizado' + data.id)
	      }
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (data.realizado),
	        expression: "data.realizado"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required|min_value:0'),
	        expression: "'required|min_value:0'"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "disabled": _vm.ehVisualizacao,
	        "id": 'realizado' + data.id,
	        "name": 'metaRealizado' + data.id,
	        "type": "text"
	      },
	      domProps: {
	        "value": (data.realizado)
	      },
	      on: {
	        "keypress": _vm.onlyNumber,
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(data, "realizado", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "input-group-append"
	    }, [_vm._v(_vm._s(data.unidade))])])])]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "rowspan": data.atividades.row.length + 1
	      }
	    }, [(data.orcado > 0) ? _c('div', [(parseInt(data.realizado) >= parseInt(data.orcado)) ? _c('span', [_vm._v("100 %")]) : (parseInt(data.realizado) < parseInt(data.orcado)) ? _c('span', [_vm._v(_vm._s(_vm._f("percentage")(parseInt(data.realizado) / parseInt(data.orcado))))]) : _vm._e(), _vm._v(" "), _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (parseInt(data.realizado) < parseInt(data.orcado)),
	        expression: "parseInt(data.realizado) < parseInt(data.orcado)"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	      }],
	      staticClass: "fa fa-exclamation fa-3",
	      staticStyle: {
	        "color": "blue",
	        "margin-left": "10px",
	        "font-size": "large",
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true",
	        "title": '<h5>Necessário informar uma justificativa do não atigimento de meta.</h5>'
	      }
	    }), _vm._v(" "), _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (parseInt(data.realizado) / parseInt(data.orcado) > 1),
	        expression: "parseInt(data.realizado) / parseInt(data.orcado) > 1"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	      }],
	      staticClass: "fa fa-exclamation-triangle fa-3",
	      staticStyle: {
	        "color": "orange",
	        "margin-left": "10px",
	        "font-size": "large",
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true",
	        "title": '<h5>Atentar que o valor realizado está maior do que o orçado para a referida Meta.</h5>'
	      }
	    })]) : _c('div', [_vm._v("0 %\n                        "), _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (parseInt(data.realizado) < parseInt(data.orcado)),
	        expression: "parseInt(data.realizado) < parseInt(data.orcado)"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	      }],
	      staticClass: "fa fa-exclamation fa-3",
	      staticStyle: {
	        "color": "blue",
	        "margin-left": "10px",
	        "font-size": "large",
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true",
	        "title": '<h5>Necessário informar uma justificativa do não atigimento de meta.</h5>'
	      }
	    })])])]), _vm._l((data.atividades.row), function(data2) {
	      return _c('tr', [_c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	        }],
	        staticClass: "text-center",
	        attrs: {
	          "title": '<h5>Documentos comprobatórios: ' + data2.documento_comprobatorio + '</h5>'
	        }
	      }, [_vm._v(_vm._s(data2.atividade))]), _vm._v(" "), _c('td', {
	        staticClass: "text-left"
	      }, [_c('div', {
	        class: {
	          'has-error': _vm.errors.first('data2.id')
	        }
	      }, [_c('div', {
	        staticClass: "col form-group required",
	        class: {
	          'has-error': _vm.errors.first('atividadeStatus' + data2.id)
	        }
	      }, [_c('label', {
	        staticClass: "radio-inline new-control new-control-radio"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (data2.status),
	          expression: "data2.status"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        attrs: {
	          "type": "radio",
	          "name": 'atividadeStatus_meta' + data2.id + 'atvd' + data.id,
	          "id": 'atvdStatus_meta' + data2.id + 'atvd' + data.id,
	          "disabled": _vm.ehVisualizacao
	        },
	        domProps: {
	          "value": 1,
	          "checked": _vm._q(data2.status, 1)
	        },
	        on: {
	          "change": [function($event) {
	            return _vm.$set(data2, "status", 1)
	          }, function($event) {
	            return _vm.passaMetas2(data, data2)
	          }]
	        }
	      }), _vm._v(" Executada\n                              "), _c('div', {
	        staticClass: "new-control-indicator",
	        staticStyle: {
	          "top": "2px"
	        }
	      })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	        staticClass: "radio-inline new-control new-control-radio"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (data2.status),
	          expression: "data2.status"
	        }],
	        attrs: {
	          "type": "radio",
	          "name": 'atividadeStatus_meta' + data2.id + 'atvd' + data.id,
	          "id": 'execucao_meta' + data2.id + 'atvd' + data.id,
	          "disabled": _vm.ehVisualizacao,
	          "required": ""
	        },
	        domProps: {
	          "value": 2,
	          "checked": _vm._q(data2.status, 2)
	        },
	        on: {
	          "change": [function($event) {
	            return _vm.$set(data2, "status", 2)
	          }, function($event) {
	            return _vm.passaMetas3(data, data2)
	          }]
	        }
	      }), _vm._v(" Em execução\n                            "), _c('div', {
	        staticClass: "new-control-indicator",
	        staticStyle: {
	          "top": "2px"
	        }
	      })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	        staticClass: "radio-inline new-control new-control-radio"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (data2.status),
	          expression: "data2.status"
	        }],
	        attrs: {
	          "type": "radio",
	          "name": 'atividadeStatus_meta' + data2.id + 'atvd' + data.id,
	          "disabled": _vm.ehVisualizacao,
	          "required": ""
	        },
	        domProps: {
	          "value": 3,
	          "checked": _vm._q(data2.status, 3)
	        },
	        on: {
	          "change": [function($event) {
	            return _vm.$set(data2, "status", 3)
	          }, function($event) {
	            return _vm.passaMetas(data, data2)
	          }]
	        }
	      }), _vm._v(" Não executada\n                            "), _c('div', {
	        staticClass: "new-control-indicator",
	        staticStyle: {
	          "top": "2px"
	        }
	      })]), _vm._v(" "), _c('i', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (data2.status === 3),
	          expression: "data2.status === 3"
	        }, {
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	        }],
	        staticClass: "fa fa-exclamation fa-3",
	        staticStyle: {
	          "color": "red",
	          "margin-left": "10px",
	          "font-size": "large",
	          "cursor": "pointer"
	        },
	        attrs: {
	          "aria-hidden": "true",
	          "title": '<h5>Necessário informar uma justificativa da não execução da atividade.</h5>'
	        }
	      })])])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_c('div', {
	        staticClass: "input-group mb-3",
	        class: {
	          'has-error': _vm.errors.first('execucao' + data.id)
	        }
	      }, [_c('div', {
	        staticClass: "left"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (data2.execucao),
	          expression: "data2.execucao"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required|min_value:0|max_value:100|numeric'),
	          expression: "'required|min_value:0|max_value:100|numeric'"
	        }],
	        staticClass: "form-control",
	        staticStyle: {
	          "width": "65px"
	        },
	        attrs: {
	          "type": "number",
	          "min": "0",
	          "max": "100",
	          "disabled": _vm.ehVisualizacao || data2.execucao === 100 || data2.execucao === 0,
	          "id": 'execucao_meta' + data2.id + 'atvd' + data.id,
	          "maxlength": "3",
	          "name": 'execucao_meta' + data2.id + 'atvd' + data.id,
	          "data-vv-as": "percentual de execução"
	        },
	        domProps: {
	          "value": (data2.execucao)
	        },
	        on: {
	          "keypress": _vm.onlyNumber,
	          "change": _vm.buscaAtividade,
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(data2, "execucao", $event.target.value)
	          }
	        }
	      }), _vm._v(" "), _c('span', {
	        staticStyle: {
	          "color": "red"
	        }
	      }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('execucao_meta' + data2.id + 'atvd' + data.id)))])])]), _vm._v(" "), _c('span', {
	        staticStyle: {
	          "line-height": "35px"
	        }
	      }, [_vm._v("%")])])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_c('i', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	        }],
	        staticClass: "glyphicon glyphicon-duplicate",
	        staticStyle: {
	          "font-size": "large",
	          "cursor": "pointer"
	        },
	        style: ((data2.anexos_atividades.row.length === 0) ? _vm.colorFadeStyle : ''),
	        attrs: {
	          "aria-en": "true"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.ativaDocumentos(data2)
	          }
	        }
	      })])])
	    })], 2)
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.ativarDocumentos) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    ref: "doc",
	    staticClass: "box box-primary",
	    attrs: {
	      "name": "doc",
	      "id": "doc"
	    }
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Anexo de comprovação da atividade\n                        executada - " + _vm._s(_vm.documentosAtividade.atividade))])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [(_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.documentosAtividade.anexos_atividades.row,
	      "documentTypes": '',
	      "disable": 'true',
	      "localUso": _vm.listaDocMetas,
	      "salvouOK": _vm.salvouOK
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.documentosAtividade.anexos_atividades.row,
	      "documentTypes": '',
	      "disable": '',
	      "localUso": _vm.listaDocMetas,
	      "salvouOK": _vm.salvouOK
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "ng-if": "goalActExeRepCrtl.approval.status != 'REJECTED' && goalActExeRepCrtl.approval.status != 'APPROVED'"
	    },
	    on: {
	      "click": function($event) {
	        _vm.ativarDocumentos = false
	      }
	    }
	  }, [_vm._v("Fechar")])])])])]) : _vm._e()]), _vm._v(" "), ((_vm.executadasparcial.length)) ? _c('table', {
	    ref: "js1",
	    staticClass: "table table-condensed table-bordered table-striped",
	    attrs: {
	      "name": "js1",
	      "id": "js1"
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('thead', _vm._l((_vm.executadasparcial), function(data) {
	    return _c('tr', [_c('td', {
	      staticClass: "justificativa-meta"
	    }, [_vm._v("\n                    " + _vm._s(data.meta) + " "), _c('span', {
	      staticClass: "justificativa-atividade"
	    }, [_c('b', [_vm._v(_vm._s(data.atividade))])])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "form-group required",
	      class: {
	        'has-error': _vm.errors.first('metaMotivo' + data.id)
	      }
	    }, [_c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (data.motivo),
	        expression: "data.motivo"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      class: {
	        'has-error': _vm.errors.first('metaMotivo' + data.id)
	      },
	      attrs: {
	        "name": 'metaMotivo' + data.id,
	        "rows": "7",
	        "cols": "5",
	        "type": "text",
	        "minlength": "1",
	        "id": data.motivo + data.id,
	        "disabled": _vm.ehVisualizacao
	      },
	      domProps: {
	        "value": (data.motivo)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(data, "motivo", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "form-group required",
	      class: {
	        'has-error': _vm.errors.first('metaProvidencia' + data.id)
	      }
	    }, [_c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (data.providencia),
	        expression: "data.providencia"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control form-group required",
	      class: {
	        'has-error': _vm.errors.first('metaProvidencia' + data.id)
	      },
	      attrs: {
	        "name": 'metaProvidencia' + data.id,
	        "rows": "7",
	        "cols": "5",
	        "type": "text",
	        "minlength": "1",
	        "id": data.providencia + data.id,
	        "disabled": _vm.ehVisualizacao
	      },
	      domProps: {
	        "value": (data.providencia)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(data, "providencia", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('td', [_c('datepicker', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      class: {
	        'has-error': _vm.errors.first('metaPrazo_regularizacao' + data.id)
	      },
	      attrs: {
	        "type": "date",
	        "name": 'metaPrazo_regularizacao' + data.id,
	        "disabled": _vm.ehVisualizacao,
	        "input-class": "form-control datepicker",
	        "language": _vm.$datePickerPtBR,
	        "maxlength": "20",
	        "use-utc": true,
	        "placeholder": "__ /__ /____",
	        "format": "dd/MM/yyyy"
	      },
	      model: {
	        value: (data.prazo_regularizacao_meta),
	        callback: function($$v) {
	          _vm.$set(data, "prazo_regularizacao_meta", $$v)
	        },
	        expression: "data.prazo_regularizacao_meta"
	      }
	    })], 1)])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.naoexecutadas.length) ? _c('table', {
	    ref: "js2",
	    staticClass: "table table-condensed table-bordered table-striped",
	    attrs: {
	      "name": "js2",
	      "id": "js2"
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('thead', _vm._l((_vm.naoexecutadas), function(data) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(data.meta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.atividade))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "form-group required",
	      class: {
	        'has-error': _vm.errors.first('dataMotivo' + data.id)
	      }
	    }, [_c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (data.motivo),
	        expression: "data.motivo"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      class: {
	        'has-error': _vm.errors.first('dataMotivo' + data.id)
	      },
	      attrs: {
	        "name": 'dataMotivo' + data.id,
	        "rows": "8",
	        "cols": "6",
	        "type": "text",
	        "minlength": "1",
	        "id": data.motivo + data.id,
	        "disabled": _vm.ehVisualizacao
	      },
	      domProps: {
	        "value": (data.motivo)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(data, "motivo", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "form-group required",
	      class: {
	        'has-error': _vm.errors.first('dataProvidencia' + data.id)
	      }
	    }, [_c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (data.providencia),
	        expression: "data.providencia"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      class: {
	        'has-error': _vm.errors.first('dataProvidencia' + data.id)
	      },
	      attrs: {
	        "name": 'dataProvidencia' + data.id,
	        "rows": "8",
	        "cols": "5",
	        "type": "text",
	        "minlength": "1",
	        "id": data.providencia + data.id,
	        "disabled": _vm.ehVisualizacao
	      },
	      domProps: {
	        "value": (data.providencia)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(data, "providencia", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "form-group required",
	      class: {
	        'has-error': _vm.errors.first('metaPrazo_regularizacao1' + data.id)
	      }
	    }, [_c('datepicker', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      class: {
	        'has-error': _vm.errors.first('metaPrazo_regularizacao1' + data.id)
	      },
	      attrs: {
	        "type": "date",
	        "name": 'metaPrazo_regularizacao1' + data.id,
	        "disabled": _vm.ehVisualizacao,
	        "input-class": "form-control datepicker",
	        "language": _vm.$datePickerPtBR,
	        "maxlength": "20",
	        "use-utc": true,
	        "placeholder": "__ /__ /____",
	        "startDate": "1900-01-01",
	        "format": "dd/MM/yyyy"
	      },
	      model: {
	        value: (data.prazo_regularizacao_atividade),
	        callback: function($$v) {
	          _vm.$set(data, "prazo_regularizacao_atividade", $$v)
	        },
	        expression: "data.prazo_regularizacao_atividade"
	      }
	    })], 1)])])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('visualiza-gantt', {
	    attrs: {
	      "numeroProjeto": _vm._.has(_vm.$route.params.row, 'item') ? _vm.$route.params.row.item.numero : !_vm._.isEmpty(_vm.$route.params.row.projeto) ? _vm.$route.params.row.projeto.substring(0, 5) : '',
	      "tipoBarra": 'declarado',
	      "mostrarExecFinanc": false,
	      "mostrarExecDeclarada": true
	    }
	  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "box box-default"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table b-table table-hover table-bordered b-table-stacked-md"
	  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Participantes")]), _c('td', {
	    staticClass: "centro"
	  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.participantes))]), _c('td', {
	    staticClass: "centro"
	  }, [_vm._v(_vm._s(_vm.totalizadoresListaParticipantes.participantes))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Jovens")]), _c('td', {
	    staticClass: "centro"
	  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.jovens))]), _c('td', {
	    staticClass: "centro"
	  }, [_vm._v(_vm._s(_vm.totalizadoresListaParticipantes.jovens))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Mulheres")]), _c('td', {
	    staticClass: "centro"
	  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.mulheres))]), _c('td', {
	    staticClass: "centro"
	  }, [_vm._v(_vm._s(_vm.totalizadoresListaParticipantes.mulheres))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "box-header with-border col form-group required"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v(" Lista de Participantes: "), _c('label', {
	    staticClass: "control-label"
	  }, [_c('font', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v("*")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('listaParticipantes', {
	    attrs: {
	      "propsParticipantes": _vm.telaRelatorio.numero_participantes.lista_participantes,
	      "disable": _vm.desabilitar,
	      "propsRelatorio": _vm.telaRelatorio,
	      "usuarioLogado": _vm.tipoUsu,
	      "idRelatorio": this.$route.params.row.item.id,
	      "idProposta": this.proposta.id
	    },
	    on: {
	      "participantesAdicionado": function($event) {
	        _vm.telaRelatorio.numero_participantes.lista_participantes = $event
	      },
	      "totalizadores": function($event) {
	        _vm.totalizadoresListaParticipantes = $event
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col form-group required"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.consideracoes_gerais.valor),
	      expression: "telaRelatorio.consideracoes_gerais.valor"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Relate fatos relativos às metas e atividades, não contemplados no relatório, que você julgar importante para compreensão da situação atual do projeto',
	      "name": "dsConsGerais",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.consideracoes_gerais.valor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.consideracoes_gerais, "valor", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('execCronograma')
	    }
	  }, [_c('div', {
	    staticClass: "col form-group required"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("O cronograma físico-financeiro está sendo executado conforme previsto?")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-2 form-group required"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cronograma_conforme_previsto.resposta),
	      expression: "telaRelatorio.cronograma_conforme_previsto.resposta"
	    }],
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "type": "radio",
	      "name": "execCronograma",
	      "value": "SIM"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.cronograma_conforme_previsto.resposta, "SIM")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.cronograma_conforme_previsto, "resposta", "SIM")
	      }
	    }
	  }), _vm._v(" Sim\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cronograma_conforme_previsto.resposta),
	      expression: "telaRelatorio.cronograma_conforme_previsto.resposta"
	    }],
	    attrs: {
	      "type": "radio",
	      "disabled": _vm.ehVisualizacao,
	      "name": "execCronograma",
	      "value": "NAO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.cronograma_conforme_previsto.resposta, "NAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.cronograma_conforme_previsto, "resposta", "NAO")
	      }
	    }
	  }), _vm._v(" Não\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]), _vm._v(" "), (_vm.telaRelatorio.cronograma_conforme_previsto.resposta === 'NAO') ? _c('div', [_c('div', {
	    staticClass: "col-md-12 form-group required",
	    class: {
	      'has-error': _vm.errors.first('justificativaCronograma')
	    }
	  }, [_c('label', {
	    staticClass: "form-group control-label",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "font-size": "12px"
	    }
	  }, [_vm._v("Justifique")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.cronograma_conforme_previsto.justificativa),
	      expression: "telaRelatorio.cronograma_conforme_previsto.justificativa"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "name": "justificativaCronograma"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.cronograma_conforme_previsto.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.cronograma_conforme_previsto, "justificativa", $event.target.value)
	      }
	    }
	  })])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header with-border form-group required"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v("Contrapartida (em " + _vm._s(this.formataData(this.$route.params.row.item.apresentado_em)) + "):")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped text-center"
	  }, [_vm._m(9), _vm._v(" "), _c('thead', _vm._l((_vm.contrapartida), function(contra) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(contra.item) + " - " + _vm._s(contra.item_descricao))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(contra.orcado))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(contra.realizado))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(contra.atingimento))])])
	  }), 0)])])]), _vm._v(" "), (_vm.tipoUsu === 'FUNDACAO') ? _c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header with-border form-group required"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v("Contrapartida (em " + _vm._s(this.formataData(new Date)) + "):")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped text-center"
	  }, [_vm._m(10), _vm._v(" "), _vm._l((this.atividadesProposta), function(atividade) {
	    return (!this.loadingProposta) ? _c('thead', _vm._l((atividade.itens_orcamentos), function(item) {
	      return (item.origem == 2) ? _c('tr', [_c('td', {
	        staticClass: "text-center"
	      }, [_vm._v("(" + _vm._s(item.item.ds_type) + ") " + _vm._s(item.item.ds_code) + " - " + _vm._s(item.item.ds_description))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v("R$ " + _vm._s(_vm._f("decimal2")(item.valorOrcado)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v("R$ " + _vm._s(_vm._f("decimal2")(item.valorSaldo)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v(_vm._s(_vm._f("percentage")(item.percAtingimento)))])]) : _vm._e()
	    }), 0) : _vm._e()
	  })], 2), _vm._v(" "), (this.loadingProposta) ? _c('div', {
	    staticClass: "contrapartida-loading"
	  }, [_vm._v("\n                  carregando... "), _c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col control-label "
	  }, [_vm._v(" a) A contrapartida está sendo comprovada de acordo com o previsto no Plano de Trabalho?")]), _vm._v(" "), _c('div', {
	    staticClass: "col form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('enumContApr')
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta),
	      expression: "telaRelatorio.contrapartida_comprovada_previsto.resposta"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "enumContApr",
	      "value": "SIM",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta, "SIM")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.contrapartida_comprovada_previsto, "resposta", "SIM")
	      }
	    }
	  }), _vm._v(" Sim\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta),
	      expression: "telaRelatorio.contrapartida_comprovada_previsto.resposta"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "enumContApr",
	      "value": "NAO",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta, "NAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.contrapartida_comprovada_previsto, "resposta", "NAO")
	      }
	    }
	  }), _vm._v(" Não\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta),
	      expression: "telaRelatorio.contrapartida_comprovada_previsto.resposta"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "enumContApr",
	      "value": "PARCIALMENTE",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta, "PARCIALMENTE")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.contrapartida_comprovada_previsto, "resposta", "PARCIALMENTE")
	      }
	    }
	  }), _vm._v(" Parcialmente\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.first('enumContApr')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Comprovação de contrapartida é obrigatório')))]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta !== 'SIM') ? _c('div', [_c('div', {
	    staticClass: "col form-group required",
	    class: {
	      'has-error': _vm.errors.first('justContra')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "font-size": "12px"
	    }
	  }, [_vm._v("Justifique")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.contrapartida_comprovada_previsto.justificativa),
	      expression: "telaRelatorio.contrapartida_comprovada_previsto.justificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "name": "justContra",
	      "id": "justContra",
	      "rows": "7",
	      "cols": "5"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.contrapartida_comprovada_previsto.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.contrapartida_comprovada_previsto, "justificativa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justContra')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Número de participantes é obrigatório')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "col control-label",
	    attrs: {
	      "for": "telaRelatorio.comprovantes_enviados_fbb.resposta"
	    }
	  }, [_vm._v("b) Os comprovantes disponíveis foram enviados à Fundação BB?")]), _vm._v(" "), _c('div', {
	    staticClass: "col form-group required",
	    class: {
	      'has-error': _vm.errors.first('contCompr')
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comprovantes_enviados_fbb.resposta),
	      expression: "telaRelatorio.comprovantes_enviados_fbb.resposta"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "contCompr",
	      "value": "SIM",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.comprovantes_enviados_fbb.resposta, "SIM")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.comprovantes_enviados_fbb, "resposta", "SIM")
	      }
	    }
	  }), _vm._v(" Sim\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comprovantes_enviados_fbb.resposta),
	      expression: "telaRelatorio.comprovantes_enviados_fbb.resposta"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "contCompr",
	      "value": "NAO",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.comprovantes_enviados_fbb.resposta, "NAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.comprovantes_enviados_fbb, "resposta", "NAO")
	      }
	    }
	  }), _vm._v(" Não\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.first('contCompr')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Comprovantes disponíveis é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default required"
	  }, [_vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "row "
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('justDivulgacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label required"
	  }, [_vm._v("Descrição das ações:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.acoes_divulgacao_prevista.justificativa),
	      expression: "telaRelatorio.acoes_divulgacao_prevista.justificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "required": "",
	      "name": "justDivulgacao"
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.acoes_divulgacao_prevista.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.acoes_divulgacao_prevista, "justificativa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justDivulgacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Divulgações realizadas é obrigatório')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-group required",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "box-body required-field",
	    class: {
	      'has-error': _vm.errors.first('comercializacao')
	    },
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("O Projeto contribui para a Comercialização da Produção?")]), _vm._v(" "), _c('h5', [_vm._v("Caso a resposta tenha sido \"SIM\" marque abaixo o(os) canal(is) utilizado(os);")]), _vm._v(" "), _c('h5', [_vm._v("Caso a resposta tenha sido \"NÃO\" justifique;")]), _vm._v(" "), _c('h5', [_vm._v("Caso não esteja prevista a comercialização de produtos do empreendimento, marque a opção \"NÃO SE APLICA\".")]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.resposta),
	      expression: "telaRelatorio.comercializacao_producao.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "SIM",
	      "disabled": _vm.ehVisualizacao,
	      "name": "comercializacao",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.comercializacao_producao.resposta, "SIM")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.comercializacao_producao, "resposta", "SIM")
	      }
	    }
	  }), _vm._v(" Sim\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.resposta),
	      expression: "telaRelatorio.comercializacao_producao.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "NAO",
	      "disabled": _vm.ehVisualizacao,
	      "name": "comercializacao",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.comercializacao_producao.resposta, "NAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.comercializacao_producao, "resposta", "NAO")
	      }
	    }
	  }), _vm._v(" Não\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.resposta),
	      expression: "telaRelatorio.comercializacao_producao.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "NAO-SE-APLICA",
	      "disabled": _vm.ehVisualizacao,
	      "name": "comercializacao",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.comercializacao_producao.resposta, "NAO-SE-APLICA")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.comercializacao_producao, "resposta", "NAO-SE-APLICA")
	      }
	    }
	  }), _vm._v(" Não se aplica\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.first('comercializacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Comercialização é obrigatório')))]) : _vm._e()]), _vm._v(" "), (_vm.telaRelatorio.comercializacao_producao.resposta === 'SIM') ? _c('div', {
	    staticClass: "col-md-12 form-group required-field",
	    staticStyle: {
	      "display": "inline-grid",
	      "margin-top": "10px"
	    }
	  }, [_c('div', {
	    ref: "com",
	    staticClass: "col-md-8 required-field",
	    class: {
	      'has-error': _vm.errors.first('acao')
	    },
	    attrs: {
	      "id": "com"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade),
	      expression: "telaRelatorio.comercializacao_producao.canal.venda_na_propriedade"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM',
	      "name": "acao"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade, 'SIM')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
	      },
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "venda_na_propriedade", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "venda_na_propriedade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "venda_na_propriedade", $$c)
	        }
	      }
	    }
	  }), _vm._v("Venda na Propriedade\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor),
	      expression: "telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor, 'SIM')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
	      },
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "direto_ao_consumidor", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "direto_ao_consumidor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "direto_ao_consumidor", $$c)
	        }
	      }
	    }
	  }), _vm._v("Direito ao Consumidor\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa),
	      expression: "telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa, 'SIM')
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_de_aquisição_de_alimentos_paa", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_de_aquisição_de_alimentos_paa", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_de_aquisição_de_alimentos_paa", $$c)
	        }
	      }
	    }
	  }), _vm._v("Programa de Aquisição de Alimentos - PAA\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.feiras_livres),
	      expression: "telaRelatorio.comercializacao_producao.canal.feiras_livres"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.feiras_livres) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.feiras_livres, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.feiras_livres, 'SIM')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
	      },
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.feiras_livres,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_livres", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_livres", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_livres", $$c)
	        }
	      }
	    }
	  }), _vm._v("Feiras Livres\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox",
	    staticStyle: {
	      "margin-left": "69px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.mercadinhos),
	      expression: "telaRelatorio.comercializacao_producao.canal.mercadinhos"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.mercadinhos) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.mercadinhos, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.mercadinhos, 'SIM')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
	      },
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.mercadinhos,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "mercadinhos", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "mercadinhos", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "mercadinhos", $$c)
	        }
	      }
	    }
	  }), _vm._v("Mercadinhos\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox",
	    staticStyle: {
	      "margin-left": "68px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae),
	      expression: "telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae, 'SIM')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
	      },
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_nacional_de_alimentação_escolar_pnae", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_nacional_de_alimentação_escolar_pnae", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_nacional_de_alimentação_escolar_pnae", $$c)
	        }
	      }
	    }
	  }), _vm._v("Programa Nacional de Alimentação Escolar -PNAE\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas),
	      expression: "telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas, 'SIM')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
	      },
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_agroecológicas", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_agroecológicas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_agroecológicas", $$c)
	        }
	      }
	    }
	  }), _vm._v("Feiras Agroecológicas\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox",
	    staticStyle: {
	      "margin-left": "13px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.atravessadores),
	      expression: "telaRelatorio.comercializacao_producao.canal.atravessadores"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.atravessadores) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.atravessadores, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.atravessadores, 'SIM')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
	      },
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.atravessadores,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "atravessadores", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "atravessadores", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "atravessadores", $$c)
	        }
	      }
	    }
	  }), _vm._v("Atravessadores\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox",
	    staticStyle: {
	      "margin-left": "55px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização),
	      expression: "telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.ehVisualizacao,
	      "false-value": 'NAO',
	      "true-value": 'SIM'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização, 'SIM')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
	      },
	      "change": function($event) {
	        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('SIM') : ('NAO');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "outros_canais_de_comercialização", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "outros_canais_de_comercialização", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "outros_canais_de_comercialização", $$c)
	        }
	      }
	    }
	  }), _vm._v("Outros canais de comercialização\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.comercializacao_producao.resposta === 'NAO') ? _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('considera1')
	    }
	  }, [_c('h5', {
	    staticClass: "control-label"
	  }, [_vm._v("Considerações :")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.comercializacao_producao.justificativa),
	      expression: "telaRelatorio.comercializacao_producao.justificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "considera1",
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "considera1",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.comercializacao_producao.justificativa)
	    },
	    on: {
	      "change": _vm.mudaEstilo,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.comercializacao_producao, "justificativa", $event.target.value)
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 ",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-solid box-default required"
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "box box-default form-group required",
	    class: {
	      'has-error': _vm.errors.first('questao1')
	    }
	  }, [_vm._m(14), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('questao1')
	    },
	    staticStyle: {
	      "padding-top": "1px"
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
	      expression: "telaRelatorio.questionario.questao_1.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao1",
	      "value": "1",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "1")
	      }
	    }
	  }), _vm._v(" 1\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
	      expression: "telaRelatorio.questionario.questao_1.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao1",
	      "value": "2",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "2")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "2")
	      }
	    }
	  }), _vm._v(" 2\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
	      expression: "telaRelatorio.questionario.questao_1.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao1",
	      "value": "3",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "3")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "3")
	      }
	    }
	  }), _vm._v(" 3\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
	      expression: "telaRelatorio.questionario.questao_1.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao1",
	      "value": "4",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "4")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "4")
	      }
	    }
	  }), _vm._v(" 4\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
	      expression: "telaRelatorio.questionario.questao_1.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao1",
	      "value": "5",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "5")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "5")
	      }
	    }
	  }), _vm._v(" 5\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('consideracaoQ1')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_1.consideracoes),
	      expression: "telaRelatorio.questionario.questao_1.consideracoes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Comente sobre as ações desenvolvidas visando o aprimoramento e/ou o desenvolvimento de novas capacidades.',
	      "name": "consideracaoQ1",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.questionario.questao_1.consideracoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.questionario.questao_1, "consideracoes", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-default required"
	  }, [_vm._m(15), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('questao2')
	    },
	    staticStyle: {
	      "padding-top": "1px"
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
	      expression: "telaRelatorio.questionario.questao_2.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao2",
	      "value": "1",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "1")
	      }
	    }
	  }), _vm._v(" 1\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
	      expression: "telaRelatorio.questionario.questao_2.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao2",
	      "value": "2",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "2")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "2")
	      }
	    }
	  }), _vm._v(" 2\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
	      expression: "telaRelatorio.questionario.questao_2.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao2",
	      "value": "3",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "3")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "3")
	      }
	    }
	  }), _vm._v(" 3\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
	      expression: "telaRelatorio.questionario.questao_2.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao2",
	      "value": "4",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "4")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "4")
	      }
	    }
	  }), _vm._v(" 4\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
	      expression: "telaRelatorio.questionario.questao_2.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao2",
	      "value": "5",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "5")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "5")
	      }
	    }
	  }), _vm._v(" 5\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('consideracaoQ2')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_2.consideracoes),
	      expression: "telaRelatorio.questionario.questao_2.consideracoes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Comente sobre as ações desenvolvidas que contribuem para o protagonismo de mulheres e jovens ou relate sobre as dificuldades encontradas.',
	      "name": "consideracaoQ2",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.questionario.questao_2.consideracoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.questionario.questao_2, "consideracoes", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-default required"
	  }, [_vm._m(16), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('questao3')
	    },
	    staticStyle: {
	      "padding-top": "1px"
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
	      expression: "telaRelatorio.questionario.questao_3.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao3",
	      "value": "1",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "1")
	      }
	    }
	  }), _vm._v(" 1\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
	      expression: "telaRelatorio.questionario.questao_3.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao3",
	      "value": "2",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "2")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "2")
	      }
	    }
	  }), _vm._v(" 2\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
	      expression: "telaRelatorio.questionario.questao_3.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao3",
	      "value": "3",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "3")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "3")
	      }
	    }
	  }), _vm._v(" 3\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
	      expression: "telaRelatorio.questionario.questao_3.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao3",
	      "value": "4",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "4")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "4")
	      }
	    }
	  }), _vm._v(" 4\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
	      expression: "telaRelatorio.questionario.questao_3.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao3",
	      "value": "5",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "5")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "5")
	      }
	    }
	  }), _vm._v(" 5\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('consideracaoQ3')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_3.consideracoes),
	      expression: "telaRelatorio.questionario.questao_3.consideracoes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Comente sobre as ações desenvolvidas visando novas parcerias ou relate sobre as dificuldades encontradas',
	      "name": "consideracaoQ3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.questionario.questao_3.consideracoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.questionario.questao_3, "consideracoes", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-default required"
	  }, [_vm._m(17), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('questao4')
	    },
	    staticStyle: {
	      "padding-top": "1px"
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
	      expression: "telaRelatorio.questionario.questao_4.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao4",
	      "value": "1",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "1")
	      }
	    }
	  }), _vm._v(" 1\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
	      expression: "telaRelatorio.questionario.questao_4.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao4",
	      "value": "2",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "2")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "2")
	      }
	    }
	  }), _vm._v(" 2\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
	      expression: "telaRelatorio.questionario.questao_4.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao4",
	      "value": "3",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "3")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "3")
	      }
	    }
	  }), _vm._v(" 3\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
	      expression: "telaRelatorio.questionario.questao_4.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao4",
	      "value": "4",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "4")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "4")
	      }
	    }
	  }), _vm._v(" 4\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
	      expression: "telaRelatorio.questionario.questao_4.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao4",
	      "value": "5",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "5")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "5")
	      }
	    }
	  }), _vm._v(" 5\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('consideracaoQ4')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_4.consideracoes),
	      expression: "telaRelatorio.questionario.questao_4.consideracoes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Comente sobre as novas oportunidades, a quantidade de pessoas e as áreas de atuação, ou relate as dificuldades.',
	      "name": "consideracaoQ4",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.questionario.questao_4.consideracoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.questionario.questao_4, "consideracoes", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-default required"
	  }, [_vm._m(18), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('questao5')
	    },
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
	      expression: "telaRelatorio.questionario.questao_5.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao5",
	      "value": "1",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "1")
	      }
	    }
	  }), _vm._v(" 1\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
	      expression: "telaRelatorio.questionario.questao_5.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao5",
	      "value": "2",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "2")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "2")
	      }
	    }
	  }), _vm._v(" 2\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
	      expression: "telaRelatorio.questionario.questao_5.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao5",
	      "value": "3",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "3")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "3")
	      }
	    }
	  }), _vm._v(" 3\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
	      expression: "telaRelatorio.questionario.questao_5.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao5",
	      "value": "4",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "4")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "4")
	      }
	    }
	  }), _vm._v(" 4\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
	      expression: "telaRelatorio.questionario.questao_5.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao5",
	      "value": "5",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "5")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "5")
	      }
	    }
	  }), _vm._v(" 5\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group",
	    class: {
	      'has-error': _vm.errors.first('consideracaoQ5')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_5.consideracoes),
	      expression: "telaRelatorio.questionario.questao_5.consideracoes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Comente sobre as práticas adotadas e os resultados alcançados, ou relate as dificuldades',
	      "name": "consideracaoQ5",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.questionario.questao_5.consideracoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.questionario.questao_5, "consideracoes", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-default required"
	  }, [_vm._m(19), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('questao6')
	    },
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
	      expression: "telaRelatorio.questionario.questao_6.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao6",
	      "value": "1",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "1")
	      }
	    }
	  }), _vm._v(" 1\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
	      expression: "telaRelatorio.questionario.questao_6.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao6",
	      "value": "2",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "2")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "2")
	      }
	    }
	  }), _vm._v(" 2\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
	      expression: "telaRelatorio.questionario.questao_6.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao6",
	      "value": "3",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "3")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "3")
	      }
	    }
	  }), _vm._v(" 3\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
	      expression: "telaRelatorio.questionario.questao_6.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao6",
	      "value": "4",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "4")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "4")
	      }
	    }
	  }), _vm._v(" 4\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
	      expression: "telaRelatorio.questionario.questao_6.resposta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "questao6",
	      "value": "5",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "5")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "5")
	      }
	    }
	  }), _vm._v(" 5\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required",
	    class: {
	      'has-error': _vm.errors.first('consideracaoQ6')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.questionario.questao_6.consideracoes),
	      expression: "telaRelatorio.questionario.questao_6.consideracoes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Comente sobre as ações realizadas contra a discriminação, desigualdade de gênero, trabalho escravo ou infantil, exploração sexual, etc, ou relate as dificuldades encontradas.',
	      "name": "consideracaoQ6",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.questionario.questao_6.consideracoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.questionario.questao_6, "consideracoes", $event.target.value)
	      }
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_vm._m(20), _vm._v(" "), (_vm.telaRelatorio.objeto_convenio.valor.length > 0) ? _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col"
	  }, [_vm._v(_vm._s(_vm.telaRelatorio.objeto_convenio.valor))])]) : _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col"
	  }, [_vm._v("Objeto não cadastrado")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 required",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default required-field"
	  }, [_c('div', {
	    staticClass: "box-header with-border form-group required-field"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v("Informar como está o desenvolvimento do Objeto do Convênio: "), _c('label', [_c('font', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v("*")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col form-group required",
	    class: {
	      'has-error': _vm.errors.first('objetoConvenioTexto')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.desenvolvimento_objeto_convenio.valor),
	      expression: "telaRelatorio.desenvolvimento_objeto_convenio.valor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "objetoConvenioTexto",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.desenvolvimento_objeto_convenio.valor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.desenvolvimento_objeto_convenio, "valor", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header with-border form-group required"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v("Informar sobre o alcance dos Objetivos do projeto:"), _c('label', [_c('font', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v(" *")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped text-center"
	  }, [_vm._m(21), _vm._v(" "), _c('thead', _vm._l((_vm.telaRelatorio.objetivos_projeto.row), function(objProj) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "data-title": "'Item'",
	        "sortable": "'item'",
	        "width": "20%"
	      }
	    }, [_vm._v(_vm._s(objProj.item))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "data-title": "'Descrição'",
	        "sortable": "'description'",
	        "width": "40%"
	      }
	    }, [_vm._v(_vm._s(objProj.descricao))]), _vm._v(" "), _c('td', {
	      attrs: {
	        "data-title": "'Realizado'",
	        "sortable": "'realizado'",
	        "width": "40%"
	      }
	    }, [_c('div', {
	      staticClass: "form-group required",
	      class: {
	        'has-error': _vm.errors.first('descRealizado')
	      }
	    }, [_c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (objProj.realizado),
	        expression: "objProj.realizado"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "name": "descRealizado",
	        "disabled": _vm.ehVisualizacao,
	        "rows": "5",
	        "cols": "5",
	        "type": "text",
	        "minlength": "1",
	        "required": ""
	      },
	      domProps: {
	        "value": (objProj.realizado)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(objProj, "realizado", $event.target.value)
	        }
	      }
	    })])])])
	  }), 0), _vm._v(" "), _c('tr', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm.telaRelatorio.objetivos_projeto.row.length === 0)),
	      expression: "(telaRelatorio.objetivos_projeto.row.length === 0)"
	    }]
	  }, [_c('td', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "7"
	    }
	  }, [_vm._v("Nenhum registro encontrado!")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header with-border form-group required"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v("Resultados alcançados até o momento:"), _c('label', [_c('font', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v(" *")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col form-group required",
	    class: {
	      'has-error': _vm.errors.first('dsResultado')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.resultados_alcancados.valor),
	      expression: "telaRelatorio.resultados_alcancados.valor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Informar os benefícios aos participantes que já podem ser mensurados.',
	      "name": "dsResultado",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.resultados_alcancados.valor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.resultados_alcancados, "valor", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header with-border form-group required"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v("Depoimentos:"), _c('label', [_c('font', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v(" *")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col form-group required",
	    class: {
	      'has-error': _vm.errors.first('dsDepoimentos')
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.depoimentos.valor),
	      expression: "telaRelatorio.depoimentos.valor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": 'Insira aqui depoimentos sobre os resultados e impactos do projeto, outros aspectos considerados relevantes, prestados por beneficiários, parceiros ou membros da equipe responsável pelo projeto. Esses depoimentos (ou trechos) poderão ser utilizados pela Fundação para divulgação interna e externa.',
	      "name": "dsDepoimentos",
	      "disabled": _vm.ehVisualizacao,
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.depoimentos.valor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.depoimentos, "valor", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Modelos de documentos:")]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('ul', {
	    staticStyle: {
	      "list-style": "none"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": _vm.urlLaravel + '/docs/modelo_cursos_e_capacitacoes.xls',
	      "download": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cursos e Capacitações")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.urlLaravel + '/docs/modelo_relacao_de_bens.doc',
	      "download": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Relação de Bens")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.urlLaravel + '/docs/modelo_termo_de_designacao.docx'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Termo de Designação")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.urlLaravel + '/docs/modelo_termo_de_recebimento_de_obra_civil.docx'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Termo de Recebimento de Obra Civil")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Anexos diversos:\n                        "), (!_vm.ehVisualizacao) ? _c('span', {
	    staticStyle: {
	      "font-size": "14px",
	      "font-style": "italic",
	      "margin-left": "10px",
	      "color": "var(--cor-atencao-dark)"
	    }
	  }, [_vm._v("Obrigatório anexar e informar data de vigência dos documentos: CNEP/CEPIM e CNDT")]) : _vm._e()]), _vm._v(" "), (_vm.ehVisualizacao) ? _c('div', [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.telaRelatorio.anexos_diversos.row,
	      "documentTypes": '',
	      "disable": 'true',
	      "localUso": _vm.listaDocDiversos,
	      "salvouOK": _vm.salvouOK
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('div', [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.telaRelatorio.anexos_diversos.row,
	      "documentTypes": '',
	      "disable": '',
	      "localUso": _vm.listaDocDiversos,
	      "salvouOK": _vm.salvouOK
	    }
	  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.tipoUsu === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Histórico:")]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped text-center"
	  }, [_vm._m(22), _vm._v(" "), _c('thead', _vm._l((_vm.historicoRelatorio), function(hist) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(hist.etapa))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(hist.concluído_em))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(hist.justificativa))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(hist.usuário))])])
	  }), 0)])])])]) : _vm._e()])])]), _vm._v(" "), ((_vm.tipoUsu === 'FUNDACAO' && _vm.sit === 'VALIDAR') || _vm.ehVisualizacao) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.tipoUsu === 'FUNDACAO') ? _c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(23), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group required",
	    class: {
	      'has-error': _vm.errors.first('conclusao')
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.resultadoAprovacao),
	      expression: "telaRelatorio.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "conclusao",
	      "value": "APROVADO",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.resultadoAprovacao, "APROVADO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.telaRelatorio, "resultadoAprovacao", "APROVADO")
	      }
	    }
	  }), _vm._v(" Aprovar\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.resultadoAprovacao),
	      expression: "telaRelatorio.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "conclusao",
	      "value": "REVISAO",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.telaRelatorio.resultadoAprovacao, "REVISAO")
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.telaRelatorio, "resultadoAprovacao", "REVISAO")
	      }, _vm.atualizaComponente]
	    }
	  }), _vm._v(" Enviar para Revisão\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]), _vm._v(" "), (_vm.telaRelatorio.resultadoAprovacao != undefined && _vm.telaRelatorio.resultadoAprovacao != 'APROVADO') ? _c('div', {
	    staticClass: "col-md-12 form-group required",
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_c('label', {
	    staticClass: "col control-label",
	    attrs: {
	      "uib-tooltip": "Informe aqui as considerações da decisão acima"
	    }
	  }, [_vm._v("Considerações (para a entidade)")]), _vm._v(" "), _c('em', {
	    staticClass: "text-light"
	  }, [_vm._v(" (Limitado a 2.000 caracteres)")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.justificativa_devolucao.valor),
	      expression: "telaRelatorio.justificativa_devolucao.valor"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "maxlength": "2000",
	      "name": "dsReportApr",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.justificativa_devolucao.valor)
	    },
	    on: {
	      "keyup": _vm.countdown,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.justificativa_devolucao, "valor", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "text-right text-small",
	    class: {
	      'text-danger': _vm.hasError
	    }
	  }, [_vm._v(_vm._s(_vm.remainingCount))])]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.resultadoAprovacao === 'APROVADO' && _vm.telaRelatorio.resultadoAprovacao != undefined) ? _c('div', {
	    staticClass: "col-md-12 form-group required",
	    class: {
	      'has-error': _vm.errors.first('dsObsFbb')
	    },
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_c('label', {
	    staticClass: "col control-label",
	    attrs: {
	      "uib-tooltip": "Informe aqui as considerações da decisão acima"
	    }
	  }, [_vm._v("Parecer Fundação BB:"), _c('font', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v(" *")])], 1), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.telaRelatorio.parecer_fbb.valor),
	      expression: "telaRelatorio.parecer_fbb.valor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "dsObsFbb",
	      "maxlength": "700",
	      "placeholder": 'Insira seu parecer elencando as dificuldades e suas causas, destaques positivos quanto às metas e aos resultados e outros aspectos considerados relevantes',
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.telaRelatorio.parecer_fbb.valor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.telaRelatorio.parecer_fbb, "valor", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.telaRelatorio.resultadoAprovacao === 'APROVADO' && _vm.telaRelatorio.resultadoAprovacao != undefined && _vm.tipoUsu === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-12 form-group"
	  }, [_vm._m(24), _vm._v(" "), _c('div', {
	    staticClass: "indicadores-cb-inline"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v("\n                        Há restrição em:\n                        "), _c('div', {
	    staticStyle: {
	      "margin": "0 10px"
	    }
	  }, [(_vm.ehVisualizacao) ? _c('i', {
	    class: _vm.telaRelatorio.encaminhamento_restricao_cepim === 'NAO' ? 'fa fa-square-o' : 'fa fa-check-square-o',
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  }) : _c('i', {
	    class: _vm.telaRelatorio.encaminhamento_restricao_cepim === 'SIM' ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.telaRelatorio.encaminhamento_restricao_cepim = (_vm.telaRelatorio.encaminhamento_restricao_cepim === 'SIM' ? 'NAO' : 'SIM')
	      }
	    }
	  }), _vm._v("\n                          CNEP/CEPIM\n                        ")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin": "0 10px"
	    }
	  }, [(_vm.ehVisualizacao) ? _c('i', {
	    class: _vm.telaRelatorio.encaminhamento_restricao_cndt === 'NAO' ? 'fa fa-square-o' : 'fa fa-check-square-o',
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  }) : _c('i', {
	    class: _vm.telaRelatorio.encaminhamento_restricao_cndt === 'SIM' ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.telaRelatorio.encaminhamento_restricao_cndt = (_vm.telaRelatorio.encaminhamento_restricao_cndt === 'SIM' ? 'NAO' : 'SIM')
	      }
	    }
	  }), _vm._v("\n                          CNDT\n                        ")]), _vm._v(" "), (!_vm.ehVisualizacao && (_vm.telaRelatorio.encaminhamento_restricao_cepim === 'SIM' || _vm.telaRelatorio.encaminhamento_restricao_cndt === 'SIM')) ? _c('div', {
	    staticStyle: {
	      "margin": "0 10px"
	    }
	  }, [_c('label', {
	    staticClass: "label label-warning"
	  }, [_vm._v("Será encaminhado e-mail, registrada a anotação 2422 - Certidão com restrição e aberto chamado para acompanhamento da ocorrência")])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(25), _vm._v(" "), (_vm.tipoUsu === 'FUNDACAO' && (_vm.telaRelatorio.resultadoAprovacao === 'APROVADO' || _vm.telaRelatorio.resultadoAprovacao === 'REVISAO')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Registrar ocorrência no projeto referente à análise do relatório:\n                          "), (_vm.telaRelatorio.resultadoAprovacao === 'REVISAO') ? _c('span', [_vm._v("Revisão")]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.resultadoAprovacao === 'APROVADO') ? _c('span', [_vm._v("Aprovado")]) : _vm._e()])]), _vm._v(" "), (_vm.loading.projetoEntidadeOcorrencia || _vm.loading.listaOcorrencias) ? _c('span', [_vm._m(26)]) : _c('span', [(_vm._.isEmpty(_vm.ocorrenciaEditando)) ? _c('div', {}, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.novaOcorrencia($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Ocorrência")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Observação")]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Ação")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.telaRelatorio.ocorrencias.length > 0) ? _vm._l((_vm.telaRelatorio.ocorrencias), function(ocorrencia, idx) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-bold centralizado",
	      staticStyle: {
	        "width": "100px"
	      }
	    }, [_vm._v(_vm._s(ocorrencia.id))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "200px"
	      }
	    }, [_c('div', {
	      staticClass: "truncar",
	      staticStyle: {
	        "width": "200px"
	      }
	    }, [_vm._v("\n                                      " + _vm._s(ocorrencia.enquadramento.codigo) + " - " + _vm._s(ocorrencia.enquadramento.descricao) + "\n                                    ")])]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado",
	      staticStyle: {
	        "width": "100px"
	      }
	    }, [_vm._v(_vm._s(ocorrencia.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ocorrencia.observacao))]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('td', {
	      staticClass: "centralizado",
	      staticStyle: {
	        "width": "170px"
	      }
	    }, [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editaOcorrencia(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.excluiOcorrencia(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _vm._e()])
	  }) : [_vm._m(27)]], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  })]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.ocorrenciaEditando)) ? _c('div', {
	    staticClass: "col-md-12 well"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrenciaEditando.tipo),
	      expression: "ocorrenciaEditando.tipo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tipoOcorrencia",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": 'PROJETO',
	      "checked": _vm._q(_vm.ocorrenciaEditando.tipo, 'PROJETO')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrenciaEditando, "tipo", 'PROJETO')
	      }
	    }
	  }), _vm._v(" Projeto\n                                "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrenciaEditando.tipo),
	      expression: "ocorrenciaEditando.tipo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tipoOcorrencia",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": 'ENTIDADE',
	      "checked": _vm._q(_vm.ocorrenciaEditando.tipo, 'ENTIDADE')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrenciaEditando, "tipo", 'ENTIDADE')
	      }
	    }
	  }), _vm._v(" Entidade\n                                "), _c('span', {
	    staticClass: "pull-right text-blue"
	  }, [(_vm.ocorrenciaEditando.tipo === 'PROJETO') ? _c('span', [_vm._v(" Essa ocorrência será registrada no projeto "), _c('strong', [_vm._v(_vm._s(_vm.telaRelatorio.cabecalho.numero_projeto))])]) : _vm._e(), _vm._v(" "), (_vm.ocorrenciaEditando.tipo === 'ENTIDADE') ? _c('span', [_vm._v(" Essa ocorrência será registrada na entidade "), _c('strong', [_vm._v(_vm._s(_vm.telaRelatorio.cabecalho.entidade))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('codigo_ocorrencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Código:")]), _vm._v(" "), (_vm.loading.listaOcorrencias) ? _c('div', {
	    staticClass: "col-md-10"
	  }, [_vm._m(28)]) : _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm._.orderBy(_vm._.filter(_vm.listaTiposOcorrencias, function(o) {
	        return o.criar === 1 && o.automatico === 0 && _vm._.includes((_vm.ocorrenciaEditando.tipo === 'PROJETO' ? ['1', '2', '3'] : ['1', '2', '4']), ('' + o.codigo).substr(0, 1))
	      }), ['codigo'], ['asc']),
	      "custom-label": function (option) {
	        return ("" + (option.codigo + ' ' + option.descricao))
	      },
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "track-by": "codigo",
	      "placeholder": "Selecione uma ocorrência",
	      "name": "codigo_ocorrencia"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('strong', [_vm._v(_vm._s(props.option.codigo))]), _vm._v(" " + _vm._s(props.option.descricao))]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "truncar"
	        }, [_c('span', {
	          staticClass: "identificadorIDProjeto"
	        }, [_vm._v(_vm._s(props.option.codigo))]), _vm._v(" " + _vm._s(props.option.descricao))])]
	      }
	    }], null, false, 1494732627),
	    model: {
	      value: (_vm.ocorrenciaEditando.enquadramento),
	      callback: function($$v) {
	        _vm.$set(_vm.ocorrenciaEditando, "enquadramento", $$v)
	      },
	      expression: "ocorrenciaEditando.enquadramento"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('codigo_ocorrencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve selecionar o código da ocorrência desejada na lista")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('descricao_ocorrencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Informe o detalhamento da situação que gerou a ocorrência",
	      "name": "descricao_ocorrencia",
	      "id": "descricao_ocorrencia",
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.ocorrenciaEditando.observacao),
	      callback: function($$v) {
	        _vm.$set(_vm.ocorrenciaEditando, "observacao", $$v)
	      },
	      expression: "ocorrenciaEditando.observacao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('descricao_ocorrencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Informe o quê se refere essa ocorrência")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.loading.listaOcorrencias && !_vm._.isEmpty(_vm.ocorrenciaEditando.enquadramento) && !_vm._.isEmpty(_vm.ocorrenciaEditando.observacao)) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.okOcorrencia
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancelaOcorrencia
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])]) : _vm._e()])]) : _vm._e()])])]) : _vm._e()]) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Usuário que enviou o relatório")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dados do projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col form-group required"
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-right": "8px"
	    }
	  }, [_vm._v("O objeto foi cumprido?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border form-group required"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v("Metas e Atividades")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticStyle: {
	      "background-color": "#BBDEFB"
	    }
	  }, [_c('th', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation fa-3",
	    staticStyle: {
	      "color": "blue",
	      "margin-left": "10px",
	      "font-size": "large",
	      "cursor": "pointer"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Justificativa pelo não atingimento de meta")])])]), _vm._v(" "), _c('tr', [_c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Meta")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Motivo")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Providências")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Prazo para regularização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticStyle: {
	      "background-color": "#FFCDD2"
	    }
	  }, [_c('th', {
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation fa-3",
	    staticStyle: {
	      "color": "red",
	      "margin-left": "10px",
	      "font-size": "large",
	      "cursor": "pointer"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Justificativa pela não execução da atividade")])])]), _vm._v(" "), _c('tr', [_c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Meta")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Atividade")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Motivo")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Providências")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Prazo para regularização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(" Público-alvo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Publico")]), _c('th', {
	    staticClass: "centro"
	  }, [_vm._v("Previsto")]), _c('th', {
	    staticClass: "centro"
	  }, [_vm._v("Realizado")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col form-group"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Considerações:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Item")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Realizado")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Atingimento")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Item")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Saldo")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Atingimento")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border form-group required"
	  }, [_c('h3', {
	    staticClass: "box-title control-label"
	  }, [_vm._v("Quais foram as ações de divulgação realizadas no Projeto?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Sustentabilidade do Projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border required"
	  }, [_c('h5', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('b', [_vm._v("RESPONDA AS QUESTÕES ABAIXO ATRIBUINDO A SEGUINTE ESCALA DE PONTUAÇÃO:")])]), _vm._v(" "), _c('h5', {
	    staticClass: "control-label",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('b', [_vm._v("(1) Nem um Pouco (2) Um Pouco (3) Razoavelmente (4) Bastante (5) Totalmente")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border form-group required-field",
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("\n                        O Projeto contribui para o desenvolvimento de novos conhecimentos/habilidades?\n                      ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border form-group required-field",
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("\n                        O Projeto contribui para o envolvimento de mulheres e jovens?\n                      ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border form-group required-field",
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("O Projeto contribui para a formação de novas parcerias além da Fundação Banco do Brasil?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border form-group required-field",
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("O Projeto contribui para o surgimento de novas oportunidades de trabalho e/ou renda?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border form-group required",
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("O Projeto contribui para a preservação do meio ambiente e o cuidado ambiental?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border form-group required",
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("O Projeto contribui para a valorização de questões relativas a direitos humanos?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objeto do Convênio:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, [_c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Item")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "centro control-label",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Realizado")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticClass: "text-center"
	  }, [_c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Nome da Tarefa")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Data da execução da tarefa")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Justificativa em caso de devolução")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Usuário que executou a tarefa")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h6', {
	    staticClass: "box-title",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Conclusão do relatório")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Encaminhamentos:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('hr')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando dados de projeto, entidade e lista de ocorrências...")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Nenhuma ocorrência para ser gerada!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando lista de ocorrências...")])
	}]}

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "fundao"
	  }, [(new Date() < new Date('2024-10-17 00:00')) ? _c('div', {
	    staticStyle: {
	      "margin": "20px 0",
	      "padding": "20px",
	      "border": "1px solid #b8bdc2",
	      "border-radius": "10px"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _c('div', {
	    staticClass: "main-container"
	  }, [_vm._m(2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "font-size": "22px",
	      "font-weight": "bolder",
	      "text-align": "center",
	      "color": "#002d48"
	    }
	  }, [_c('p', [_vm._v("Chamada Pública nº 2024/008")]), _vm._v(" "), _c('p', [_vm._v("Edital Novo Cataforte ")]), _vm._v(" "), _c('p', [_vm._v("COMUNICADO - PRORROGAÇÃO")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('p', {
	    staticStyle: {
	      "font-size": "16px",
	      "color": "#002D4B"
	    }
	  }, [_vm._v("Informamos que as inscrições para o Edital Novo Cataforte encerram-se às 23h e 59 min do dia 16/10/2024 (quarta-feira).")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-content"
	  }, [_c('div', {
	    staticClass: "header-container"
	  }, [_c('div', {
	    staticClass: "title-header"
	  }, [_c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atualizações no sistema!")])])]), _vm._v(" "), _c('div', {
	    staticClass: "texto-principal"
	  }, [_c('p', [_vm._v("Prezado parceiro, "), _c('br'), _vm._v("\n                Informamos que foram realizadas alterações de aprimoramento de processos no Sistema de Gerenciamento de Projetos (SGP).\n                Seguem as mudanças realizadas.\n\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "item-mudanca"
	  }, [_c('div', [_c('strong', [_vm._v("1.\tRelatório de execução:")])]), _vm._v(" "), _c('div', {
	    staticClass: "paragrafo-item"
	  }, [_vm._v("\n                        Para a conclusão e envio do Relatório de Execução para a Fundação BB será necessário anexar as  certidões abaixo, informando  as respectivas  datas de vigência: "), _c('br'), _vm._v("\n                        As  certidões são emitidas online gratuitamente conforme endereços indicados abaixo.\n                    ")]), _vm._v(" "), _c('div', {
	    staticClass: "item-lista"
	  }, [_c('div', [_vm._v("•\tCNDT - Certidão Negativa de Débitos Trabalhistas. Emitir em: "), _c('a', {
	    attrs: {
	      "href": "https://www.tst.jus.br/certidao1",
	      "target": "_blank"
	    }
	  }, [_vm._v("Certidão Negativa de Débitos Trabalhistas - TST")])]), _vm._v(" "), _c('div', [_vm._v("•\tCNEP/CEPIM - Cadastro Nacional de Empresas Punidas – CNEP e Cadastro de Entidades Privadas sem Fins Lucrativos Impedidas – CEPIM e (Lei Anticorrupção nº 12.846/2013). Emitir em: "), _c('a', {
	    attrs: {
	      "href": "https://certidoes.cgu.gov.br/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Certidões (cgu.gov.br)")])])]), _vm._v(" "), _c('div', {
	    staticClass: "paragrafo-item"
	  }, [_vm._v("\n                        Informamos que a existência de restrição em qualquer certidão não impedirá a conclusão e o  envio do Relatório. \n                        No entanto, a instituição deverá adotar os procedimentos visando a regularização das pendências identificadas. As pendências  não regularizadas em até 30 dias resultarão no bloqueio no projeto, incluindo a liberação de recursos.\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "item-mudanca"
	  }, [_c('div', [_c('strong', [_vm._v("2.\tCadastro dos dirigentes :")])]), _vm._v(" "), _c('div', {
	    staticClass: "paragrafo-item"
	  }, [_vm._v("\n                        Caso algum dirigente esteja vinculado a outras empresas (como proprietário, participante ou dirigente), será necessário adicionar em seu cadastro, no SGP, o CNPJ de todas as empresas às quais ele esteja vinculado e, também o CNPJ das empresas que tenha se desvinculado há menos de 1 ano.\n                    ")])])]), _vm._v(" "), _c('div', [_vm._v("Para esclarecimento de dúvidas favor utilizar o canal: "), _c('strong', [_vm._v("Chamados")]), _vm._v(". "), _c('br'), _vm._v("Agradecemos a parceria.")]), _vm._v(" "), _c('br')])
	}]}

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - ' + (_vm._.isUndefined(_vm.edital.ds_numero_edital) ? 'Abrindo edital' : 'Edital de ' + _vm.edital.ds_numero_edital)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Edital")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Edital',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('numeroEdital')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Edital:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.ds_numero_edital),
	      expression: "edital.ds_numero_edital"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "numeroEdital",
	      "type": "text",
	      "minlength": "1",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.edital.ds_numero_edital)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.edital, "ds_numero_edital", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('numeroEdital')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('numeroEdital')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('parametroEdital')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Parâmetro da url:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.parametro),
	      expression: "edital.parametro"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "parametroEdital",
	      "type": "text",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.edital.parametro)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.edital, "parametro", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('parametroEdital')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('parametroEdital')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('acesso antecipado')
	    }
	  }, [_c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "title": '<h5>Se escolhido:<br/><span class=\'realce\'>Sim</span> Usuários da FBB poderão acessar a proposta a qualquer tempo<br/><span class=\'realce\'>Não</span> Usuários da FBB não poderão acessar a proposta antes do término do prazo ou edital inativado</h5>'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle text-muted"
	  }), _vm._v(" Acessar FBB:\n                    ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.opcoes.acesso.antecipado),
	      expression: "edital.opcoes.acesso.antecipado"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "acesso antecipado"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.edital.opcoes.acesso.antecipado, true)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.edital.opcoes.acesso, "antecipado", true)
	      }
	    }
	  }), _vm._v(" Sim\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.opcoes.acesso.antecipado),
	      expression: "edital.opcoes.acesso.antecipado"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "acesso antecipado",
	      "checked": "checked"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.edital.opcoes.acesso.antecipado, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.edital.opcoes.acesso, "antecipado", false)
	      }
	    }
	  }), _vm._v(" Não\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('acesso antecipado')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Escolha uma opção acima")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('status')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.bt_ativo),
	      expression: "edital.bt_ativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "checked": "",
	      "value": "1"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.edital.bt_ativo, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.edital, "bt_ativo", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.bt_ativo),
	      expression: "edital.bt_ativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "value": "0"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.edital.bt_ativo, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.edital, "bt_ativo", 0)
	      }
	    }
	  }), _vm._v(" Não\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('dataInicial')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data inicial: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.dt_data_inicial),
	      expression: "edital.dt_data_inicial"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|date_format:dd/MM/yyyy'),
	      expression: "'required|validdate|date_format:dd/MM/yyyy'"
	    }],
	    ref: "dtInicial",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "dataInicial",
	      "data-vv-as": "Data Inicial",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.edital.dt_data_inicial)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.edital, "dt_data_inicial", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('dataInicial')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataInicial')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('dataFinal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.dt_data_final),
	      expression: "edital.dt_data_final"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqfuture|date_format:dd/MM/yyyy|after:dtInicial'),
	      expression: "'required|validdate|dateeqfuture|date_format:dd/MM/yyyy|after:dtInicial'"
	    }],
	    ref: "Data Final",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "dataFinal",
	      "data-vv-as": "Data Inicial",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.edital.dt_data_final)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.edital, "dt_data_final", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('dataFinal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataFinal')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Edição Ativa para Entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.edital.edicao),
	      expression: "edital.edicao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "projeto",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.edital, "edicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "S"
	    }
	  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "N"
	    }
	  }, [_vm._v("Desabilitado")])])])]), _vm._v(" "), (_vm.edital.id) ? _c('span', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data criação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "createdAt",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.edital.dt_criado, 'DD/MM/YYYY HH:MM')
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data atualização:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "updatedAt",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.edital.dt_criado, 'DD/MM/YYYY HH:MM')
	    }
	  })]), _vm._v(" "), _c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.edital.dt_data_inativacao),
	      expression: "edital.dt_data_inativacao"
	    }],
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data inativação:")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.edital.dt_data_inativacao),
	      expression: "edital.dt_data_inativacao"
	    }],
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "inactivateDateTime",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.edital.dt_data_inativacao, 'DD/MM/YYYY HH:MM')
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Alterado por:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "changedBy",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.edital.ds_alterado_por
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-offset-2"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])], 1)])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Editando Cadastro de Edital")])])
	}]}

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.layout === 'LISTA') ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [(!_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.novoDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {}, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), _c('td', [_vm._v("Vigência")]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return (_vm._.get(documento, 'mostrar', true)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('td', [_vm._v("\n                " + _vm._s(documento.tipo_documento.ds_tipo) + "\n                "), (_vm._.has(documento, 'ds_tipo_usuario') && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          placement: 'top',
	          animation: 'perspective',
	          distance: '1',
	          size: 'large'
	        }),
	        expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
	      }],
	      staticStyle: {
	        "color": "var(--cor-destaque)",
	        "font-size": "10px",
	        "margin-left": "15px"
	      },
	      attrs: {
	        "title": '<h5>' + documento.ds_nome_usuario + '</h5>'
	      }
	    }, [_vm._v("\n                " + _vm._s(documento.ds_tipo_usuario) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm._f("moment")(documento.dt_data_validade, 'DD/MM/YYYY')) + "\n                "), (_vm.idsVerificaVencimento && !_vm._.isNull(_vm.idsVerificaVencimento) && (_vm.idsVerificaVencimento.length === 0 || _vm._.includes(_vm.idsVerificaVencimento, _vm._.get(documento, 'tipo_documento.id', 0)))) ? _c('span', [(!_vm._.isEmpty(documento.dt_data_validade) && ((new Date(documento.dt_data_validade) - new Date()) / 86400000) < -1) ? _c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v("vencido")]) : (!_vm._.isEmpty(documento.dt_data_validade) && ((new Date(documento.dt_data_validade) - new Date()) / 86400000) < 0) ? _c('span', {
	      staticClass: "label label-warning"
	    }, [_vm._v("vencendo")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('td', [(!_vm.ehVisualizacao) ? _c('button', {
	      directives: [{
	        name: "confirm",
	        rawName: "v-confirm",
	        value: ({
	          ok: function (retorno) { return _vm.deletaDocumento(indexDocumento, documento); },
	          cancel: _vm.doNothing,
	          message: ("Deseja <b>excluir</b> o documento " + (documento.ds_nome_arquivo) + "? Essa ação é irreversível.")
	        }),
	        expression: "{ok: retorno => deletaDocumento(indexDocumento, documento), cancel: doNothing,\n                           message: `Deseja <b>excluir</b> o documento ${documento.ds_nome_arquivo}? Essa ação é irreversível.`}"
	      }],
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")]) : _vm._e()]) : _vm._e()]) : _vm._e()
	  }), 0)])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['EDICAO'], _vm.layout)) ? _c('div', {
	    staticClass: "form-group well"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('uploadArquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "uploadArquivo",
	      "id": "file"
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })]), _vm._v(" "), (_vm.errors.first('uploadArquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Selecione um arquivo")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('uploadTipoDocumento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "uploadTipoDocumento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), (_vm.loading.usosDocumento) ? _c('div', {
	    staticClass: "col-md-4 etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando tipos de documentos disponíveis ...")]) : _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "uploadTipoDocumento",
	      "id": "uploadTipoDocumento"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }]
	    }
	  }, _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento
	      }
	    }, [_vm._v(_vm._s(documento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('uploadTipoDocumento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve classificar o documento em um dos tipos da lista")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    class: _vm._.includes(_vm.idsVigenciaObrigatoria, _vm._.get(_vm.documento, 'tipo_documento.id', 0)) ? ('required-field ' + (_vm.errors.first('uploadDataVigencia') ? 'has-error' : '')) : ''
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm._.includes(_vm.idsVigenciaObrigatoria, _vm._.get(_vm.documento, 'tipo_documento.id', 0)) ? 'required' : ''),
	      expression: "_.includes(idsVigenciaObrigatoria, _.get(documento, 'tipo_documento.id', 0)) ? 'required' : ''"
	    }],
	    attrs: {
	      "input-class": "form-control datepicker",
	      "id": "uploadDataVigencia",
	      "name": "uploadDataVigencia",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$forceUpdate()
	      }
	    },
	    model: {
	      value: (_vm.documento.dt_data_validade),
	      callback: function($$v) {
	        _vm.$set(_vm.documento, "dt_data_validade", $$v)
	      },
	      expression: "documento.dt_data_validade"
	    }
	  }), _vm._v(" "), (_vm._.has(_vm.documento, 'dt_data_validade')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, placement:'right', animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "input-group-btn",
	    attrs: {
	      "title": '<h5>Limpar essa data</h5>'
	    }
	  }, [_c('button', {
	    staticClass: "btn",
	    staticStyle: {
	      "background": "white",
	      "border-color": "rgb(210, 214, 222)",
	      "border-width": "1px 0px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm._.unset(_vm.documento, 'dt_data_validade');
	        _vm.$forceUpdate()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  })])]) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('uploadDataVigencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Para este tipo de documento é obrigatório informar a data que expira sua validade")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && _vm._.has(_vm.documento, 'tipo_documento') && _vm._.has(_vm.documento, 'file') &&
	    !_vm._.find(_vm.errors.items, function(e) {
	      return _vm._.includes(['uploadArquivo', 'uploadDataVigencia', 'uploadTipoDocumento'], e.field)
	    }) &&
	    (!_vm._.includes(_vm.idsVigenciaObrigatoria, _vm._.get(_vm.documento, 'tipo_documento.id', 0)) || (_vm._.has(_vm.documento, 'dt_data_validade') && _vm._.includes(_vm.idsVigenciaObrigatoria, _vm._.get(_vm.documento, 'tipo_documento.id', 0))))) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "~click": function($event) {
	        return _vm.cancela($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.adicionando || _vm.loading.alterando || _vm.loading.excluindo),
	      expression: "loading.adicionando || loading.alterando || loading.excluindo"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column start-centered item-detalhe-container"
	  }, [_c('div', {
	    staticClass: "row-flex centered-start item-detalhe-titulo"
	  }, [_c('i', {
	    staticClass: "item-detalhe-icone fa",
	    class: _vm.icone
	  }), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.titulo) + "\n      ")])]), _vm._v(" "), (!_vm.formatarValor) ? _c('div', {
	    staticClass: "item-detalhe-valor"
	  }, [_vm._v("\n      " + _vm._s(_vm.value) + " "), (_vm.link) ? _c('i', {
	    staticClass: "fa fa-external-link"
	  }) : _vm._e()]) : _c('div', {
	    staticClass: "item-detalhe-valor"
	  }, [_vm._v("\n      " + _vm._s(_vm._f("real")(_vm.value)) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.showGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [(_vm.editando) ? _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento.ds_tipo),
	      expression: "documento.tipo_documento.ds_tipo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.documento.tipo_documento.ds_tipo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.documento.tipo_documento, "ds_tipo", $event.target.value)
	      }
	    }
	  })]) : _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento",
	      "disabled": _vm.desativado || _vm.editando
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(tipoDocumento) {
	    return _c('option', {
	      key: _vm.documento.id,
	      domProps: {
	        "value": tipoDocumento
	      }
	    }, [_vm._v(_vm._s(tipoDocumento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'tipo_documento') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'tipo_documento') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.tipo_documento.ds_tipo + '</h5>'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [(_vm.editando) ? _c('div', [_c('a', {
	    staticClass: "ng-binding",
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onDownload(_vm.documento)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.documento.ds_nome_arquivo))])]) : _c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file",
	      "disabled": _vm.desativado
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })])]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_nome_arquivo') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "margin-left": "-50px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'ds_nome_arquivo') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "margin-left": "-50px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.ds_nome_arquivo + '</h5>'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Vigencia')
	    },
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-16"
	  }, [(_vm._.hasIn(_vm.mudancas, 'dt_data_vigencia') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "-10px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'dt_data_vigencia') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "-10px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.dt_data_vigencia + '</h5>'
	    }
	  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), (_vm.editando) ? _c('span', [_vm._v("Ok")]) : _c('span', [_vm._v("Adicionar Documento")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('br'), _vm._v(" "), (_vm.faseProposta !== 'FORMALIZACAO' && _vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO') ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [(_vm.propDocumentos.length < _vm.maxFiles) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.novoDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento ")]) : _vm._e(), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "1px",
	      "color": "#048019"
	    },
	    attrs: {
	      "title": '<h5>Inclusões: ' + _vm.inclDocTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a inserção de novo(s) documento(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true && _vm.mostraExclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "1px",
	      "color": "#808080"
	    },
	    attrs: {
	      "title": '<h5>Exclusões: ' + _vm.excDocTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a exclusão de documento(s)")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
	    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(pendente.ds_tipo))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
	      staticStyle: {
	        "max-width": "135px",
	        "text-align": "center"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onAddFile(pendente)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("\n                  Adicionar arquivo\n                ")]) : _vm._e()])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      key: indexDocumento,
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "value": documento
	      }
	    }, [(documento.tipo_documento) ? _c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]) : _c('td'), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(!_vm.disable && !_vm.PropProrrogacaoEdit) ? _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO'),
	        expression: "faseProposta !== 'APROVACAO_PROJETO' && faseProposta !== 'APROVACAO'"
	      }],
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editaDocumento(documento, indexDocumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.disable && !_vm.PropEditandoAlteracaoProjeto) ? _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.faseProposta !== 'FORMALIZACAO' && _vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO'),
	        expression: "faseProposta !== 'FORMALIZACAO' && faseProposta !== 'APROVACAO_PROJETO' && faseProposta !== 'APROVACAO'"
	      }, {
	        name: "confirm",
	        rawName: "v-confirm",
	        value: ({
	          ok: function (retorno) { return _vm.deletaDocumento(indexDocumento); },
	          cancel: _vm.doNothing,
	          message: 'Deseja <b>APAGAR</b> a documento ' + documento.ds_nome_arquivo + ' ?'
	        }),
	        expression: "{ok: retorno => deletaDocumento(indexDocumento), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> a documento ' + documento.ds_nome_arquivo + ' ?'}"
	      }],
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-sm-offset-1 fa-lg"
	    }, [(_vm._.hasIn(_vm.atualizados, indexDocumento)) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          placement: 'left'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
	      }],
	      staticClass: "fa fa-warning",
	      staticStyle: {
	        "position": "relative",
	        "top": "8px",
	        "margin-left": "2px",
	        "color": "#fb2916"
	      },
	      attrs: {
	        "title": '<h5>Clique em editar para ver as mudanças.</h5>'
	      }
	    }) : _vm._e()])]) : _vm._e()])
	  })], 2)])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "text-danger"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pendente")])])
	}]}

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - ' + (_vm._.isNull(_vm.fep.id) ? 'FEP' : 'FEP nº ' + _vm.fep.id)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("FEP")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Edital',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
	    attrs: {
	      "name": "frmRegNotice",
	      "novalidate": "",
	      "_lpchecked": "1"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('projeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "initialDate"
	    }
	  }, [_vm._v("Propostas: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.projetos,
	      "multiple": false,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione uma Proposta",
	      "label": "ds_nome",
	      "track-by": "id",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "proposta",
	      "data-vv-as": "Propostas",
	      "options-limit": 1500
	    },
	    on: {
	      "select": function($event) {
	        return _vm.moveObjeto($event)
	      },
	      "remove": function($event) {
	        return _vm.removeObjeto()
	      }
	    },
	    model: {
	      value: (_vm.fep.proposta),
	      callback: function($$v) {
	        _vm.$set(_vm.fep, "proposta", $$v)
	      },
	      expression: "fep.proposta"
	    }
	  })], 1)]), _vm._v(" "), (_vm.errors.first('projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('numeroEdital')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "numeroFep"
	    }
	  }, [_vm._v("Número da FEP:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fep.id),
	      expression: "fep.id"
	    }],
	    staticClass: "form-control ng-pristine ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "numeroFep",
	      "disabled": true,
	      "type": "text",
	      "minlength": "1",
	      "ng-maxlength": "255",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.fep.id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fep, "id", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.fep.id > 0 || _vm.selecionado === false
	    },
	    on: {
	      "click": _vm.grava
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Gerar Número")])]), _vm._v(" "), (_vm.errors.first('numeroEdital')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('numeroFep')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar ")])], 1)])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de FEP")])])
	}]}

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content-wrapper ",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope "
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Análise   \n            "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }]
	  }, [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>199 - Comunicado Interno</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(199)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 199\n              ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(219)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 219\n              ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'S')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525A\n              ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'N')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525S\n              ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>248 - Monitoramento Administrativo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(248)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 248\n              ")]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && _vm.etapa !== 'Solicitação') ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5>Faz o download de todos os arquivos da solicitação (zip)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onDownloadZIP()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v(" Baixar arquivos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Validação',
	        href: '#'
	      }, {
	        text: 'Adiantamento',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.concluir($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [(!_vm._.isEmpty(_vm.chamado) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v("* Atenção: O processo que será analisado possui chamado vinculado - "), _c('b', _vm._l((_vm.chamado), function(c, index) {
	    return _c('span', [_c('router-link', {
	      attrs: {
	        "target": "_blank",
	        "to": {
	          name: 'cadastro-chamado-edita',
	          params: {
	            id: c.id
	          }
	        }
	      }
	    }, [_vm._v(" " + _vm._s(c.id) + " "), (_vm.chamado.length > 1 && index === 0) ? _c('span', [_vm._v(",  ")]) : _vm._e()])], 1)
	  }), 0), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), ((_vm.historicoTarefasTela.length > 0 && _vm.historicoTarefasTela[1].observacao != null && _vm.historicoTarefasTela[1].observacao !== '')) ? _c('div', {
	    staticClass: "alert alert-dismissible alert-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.historicoTarefasTela[1].observacao)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Validação de Adiantamento - "), _c('i', [_c('font', {
	    attrs: {
	      "color": "black",
	      "size": "3"
	    }
	  }, [_vm._v("ID: " + _vm._s(_vm.form.id) + " - Projeto: ")]), _c('font', {
	    attrs: {
	      "color": "black",
	      "size": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-if": "$ctrl.approvalState != 'DEFAULT'"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmSearch",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Objetivo Geral: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.proposta.ds_objetivo_geral))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _vm._m(1)])])])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', [(_vm.form.documentos_liberacao.length) ? _c('cronograma-solicitacao-adiantamento-validacao', {
	    attrs: {
	      "props-fase": _vm.form.tarefas[0].nome,
	      "props-enable": _vm.form.tarefas[0].nome === 'Análise' || _vm.form.tarefas[0].nome === 'Revisão',
	      "props-itens": _vm.form.documentos_liberacao[0].itens_liberados
	    },
	    on: {
	      "parcelaAdicionada": function($event) {
	        _vm.form.documentos_liberacao[0].itens_liberados = $event
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.form.documentos_liberacao[0].dados_bancarios)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('banco')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('lista-bancos', {
	    attrs: {
	      "propsBanco": _vm.form.documentos_liberacao[0].dados_bancarios.banco,
	      "banco": _vm.form.documentos_liberacao[0].dados_bancarios.banco,
	      "disabled": _vm.usuarioLogado.userType !== 'FUNDACAO'
	    },
	    on: {
	      "update:banco": function($event) {
	        return _vm.$set(_vm.form.documentos_liberacao[0].dados_bancarios, "banco", $event)
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('agência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5> ' + (_vm._.has(_vm.form.documentos_liberacao[0].dados_bancarios.banco, 'digitoAgencia') && !_vm.form.documentos_liberacao[0].dados_bancarios.banco.digitoAgencia ? 'Informe a agência com 4 número sem dígito verificador. Exemplo: <span class=\'realce\'>1234</span>' : 'Informe a agência com 4 número e o dígito verificador. Exemplo: <span class=\'realce\'>1234-5</span>') + ' </h5>'
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "agência",
	      "disabled": this.form.tarefas[0].nome !== 'Análise',
	      "type": "text",
	      "mask": _vm._.has(_vm.form.documentos_liberacao[0].dados_bancarios.banco, 'digitoAgencia') && !_vm.form.documentos_liberacao[0].dados_bancarios.banco.digitoAgencia ? '####' : '####-X',
	      "masked": ""
	    },
	    model: {
	      value: (_vm.form.documentos_liberacao[0].dados_bancarios.agencia),
	      callback: function($$v) {
	        _vm.$set(_vm.form.documentos_liberacao[0].dados_bancarios, "agencia", $$v)
	      },
	      expression: "form.documentos_liberacao[0].dados_bancarios.agencia"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('conta corrente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Conta " + _vm._s(_vm.form.documentos_liberacao[0].dados_bancarios.tipo === 1 ? 'Corrente' : (_vm.form.documentos_liberacao[0].dados_bancarios.tipo === 2 ? 'Poupança' : '')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "conta corrente",
	      "type": "text",
	      "mask": ['#-X', '##-X', '###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X', '##########-X', '###########-X'],
	      "masked": "",
	      "disabled": this.form.tarefas[0].nome !== 'Análise'
	    },
	    model: {
	      value: (_vm.form.documentos_liberacao[0].dados_bancarios.conta),
	      callback: function($$v) {
	        _vm.$set(_vm.form.documentos_liberacao[0].dados_bancarios, "conta", $$v)
	      },
	      expression: "form.documentos_liberacao[0].dados_bancarios.conta"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()])]), _vm._v(" "), _c('tipo-conta', {
	    attrs: {
	      "propsTipo": _vm.form.documentos_liberacao[0].dados_bancarios.tipo,
	      "tipo": _vm.form.documentos_liberacao[0].dados_bancarios.tipo,
	      "disabled": this.form.tarefas[0].nome !== 'Análise'
	    },
	    on: {
	      "update:tipo": function($event) {
	        return _vm.$set(_vm.form.documentos_liberacao[0].dados_bancarios, "tipo", $event)
	      }
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.form.documentos_liberacao.length) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('upload-documentos-php', {
	    attrs: {
	      "propDocumentos": _vm.form.documentos_liberacao[0].documentos_adiantamento,
	      "documentTypes": '',
	      "disable": _vm.form.tarefas[0].nome === 'Autorização'
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.documentos_liberacao.length) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('upload-documentos-php', {
	    attrs: {
	      "propDocumentos": _vm.form.documentos_liberacao[0].documentos_anexos_adiantamento,
	      "documentTypes": '',
	      "disable": _vm.form.tarefas[0].nome === 'Autorização'
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
	    key: _vm.historicoBack.length,
	    attrs: {
	      "propsValidacao": _vm.form,
	      "propsHistorico": _vm.historicoBack
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (!_vm.historicoBack) ? _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderHistorico === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && !_vm.historicoBack) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), (!_vm._.isUndefined(_vm.historicoAnt)) ? _c('historico-solicitacao-pagamento', {
	    attrs: {
	      "propsValidacao": _vm.form,
	      "propsHistorico": _vm.historicoAnt
	    }
	  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.form.tarefas[0].nome === 'Análise Financeira') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group full",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Opções para este documento:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: " new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bypass),
	      expression: "bypass"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "checkbox",
	      "false-value": '',
	      "true-value": 'BYPASS',
	      "name": "acao"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.bypass) ? _vm._i(_vm.bypass, null) > -1 : _vm._q(_vm.bypass, 'BYPASS')
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.bypass,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('BYPASS') : ('');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.bypass = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.bypass = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.bypass = $$c
	        }
	      }, function($event) {
	        return _vm.atualizaOpcoes('BYPASS')
	      }]
	    }
	  }), _vm._v("Não integrar com Sapiens\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('resultadoAprovacao')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    ref: "resultadoAprovacao",
	    staticClass: "control-label",
	    attrs: {
	      "for": "resultadoAprovacao"
	    }
	  }, [_vm._v("Aprovar solicitação?")]), _vm._v(" "), _c('div', [(_vm.form.tarefas[0].nome === 'Análise' || _vm.form.tarefas[0].nome === 'ANALISE') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-binding"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Autorização"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Autorização")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Autorização")
	      }
	    }
	  }), _vm._v(" Aprovar solicitação de adiantamento\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : (_vm.form.tarefas[0].nome === 'Autorização') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-binding"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Análise Financeira"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Análise Financeira")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Análise Financeira")
	      }
	    }
	  }), _vm._v(" Aprovar solicitação de adiantamento\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : (_vm.form.tarefas[0].nome === 'Análise Financeira') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-binding"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Conclusão"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Conclusão")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Conclusão")
	      }
	    }
	  }), _vm._v(" Aprovar solicitação de adiantamento\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : _vm._e(), _vm._v(" "), (_vm.form.tarefas[0].nome === 'Análise' || _vm.form.tarefas[0].nome === 'Autorização' || _vm.form.tarefas[0].nome === 'Análise Financeira') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-scope"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Revisão"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Revisão")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Revisão")
	      }
	    }
	  }), _vm._v(" Encaminhar para revisão da entidade\n                                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : _vm._e(), _vm._v(" "), (_vm.form.tarefas[0].nome === 'Autorização' || _vm.form.tarefas[0].nome === 'Análise Financeira' || _vm.form.tarefas[0].nome === 'Revisão') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-scope"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Análise"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Análise")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Análise")
	      }
	    }
	  }), _vm._v(" Retornar para análise\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : _vm._e(), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-scope"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Cancelar"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Cancelar")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Cancelar")
	      }
	    }
	  }), _vm._v(" Cancelar Solicitação\n                                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Revisão') ? _c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "motivo de devolucao"
	    }
	  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.motivosDevolucao,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Selecione um motivo de Devolução para a entidade",
	      "custom-label": _vm.motivoDevolucaoDescricao,
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "motivo de devolucao",
	      "data-vv-as": "motivo de devolucao",
	      "option-height": 30,
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.motivoDevolucao),
	      callback: function($$v) {
	        _vm.motivoDevolucao = $$v
	      },
	      expression: "motivoDevolucao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa) ? _c('div', {
	    staticClass: "form-group full",
	    class: [{
	      'has-error': _vm.errors.first('observacao')
	    }, {
	      'required-field': _vm.tarefa.proximaEtapa !== 'Autorização'
	    }],
	    staticStyle: {
	      "margin-right": "0px",
	      "margin-left": "0px"
	    }
	  }, [(_vm.tarefa.proximaEtapa === 'Revisão') ? _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao"
	    }
	  }, [_vm._v("Motivo para revisão:")]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Autorização') ? _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao"
	    }
	  }, [_vm._v("Observação:")]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Cancelar') ? _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao"
	    }
	  }, [_vm._v("Motivo para cancelamento:")]) : _vm._e(), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.observacao),
	      expression: "tarefa.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required_if:resultadoAprovacao,Revisão'),
	      expression: "'required_if:resultadoAprovacao,Revisão'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "observacao",
	      "id": "observacao",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.tarefa.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.tarefa, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('observacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('observacao')))]) : _vm._e()]) : _vm._e()])])])])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.restricao || _vm.tarefa.proximaEtapa === '' || _vm.form.busy
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa fa-info"
	  }), _vm._v("   Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('dd', [_c('span', [_vm._v("Em Execução")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dados Bancários")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos do Adiantamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Anexos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de solicitação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico Antigo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Aprovação da solicitação de adiantamento")])])
	}]}

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-widget"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Indicador de Projeto para Avaliação")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), (_vm.questoes.length > 0) ? _c('div', {
	    staticClass: "column all-centered questoes-container"
	  }, [_c('div', {
	    staticClass: "column start-centered questoes-itens-container"
	  }, _vm._l((_vm.questoes), function(item) {
	    return _c('div', {
	      staticClass: "questoes-itens-detail"
	    }, [_c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          placement: 'right',
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	      }],
	      staticClass: "fa fa-exclamation-circle icon-obs",
	      attrs: {
	        "aria-hidden": "true",
	        "title": item.pergunta.obs
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "control-label f-required questao-item"
	    }, [_vm._v(_vm._s(item.pergunta.id) + " - " + _vm._s(item.pergunta.questao))]), _vm._v(" "), _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.respostasProposta[item.pergunta.id - 1]),
	        expression: "respostasProposta[item.pergunta.id - 1]"
	      }],
	      staticClass: "form-control questao-select",
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(_vm.respostasProposta, item.pergunta.id - 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "",
	        "disabled": ""
	      }
	    }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((item.respostas), function(resposta) {
	      return _c('option', {
	        domProps: {
	          "value": item.pergunta.id === 7 ? resposta.resposta : resposta.pontuacao
	        },
	        on: {
	          "click": function($event) {
	            return _vm.handleRespostas(resposta, item.pergunta.id - 1)
	          }
	        }
	      }, [_vm._v(_vm._s(resposta.resposta))])
	    })], 2)])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "row start-centered questoes-indicado-container",
	    class: _vm.statusClass(_vm.indicativo)
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" (" + _vm._s(_vm.pontuacaoTotal) + ")  Projeto indicado para avaliação? "), _c('b', [_vm._v(_vm._s(_vm.indicativo))])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body column centered-start banco-precos-main-container"
	  }, [_c('div', {
	    ref: "topo",
	    staticClass: "row-flex centered-start banco-precos-header-container"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes"
	  }), _vm._v(" "), _c('b', [_vm._v("BUSCA PREÇO")])]), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start banco-precos-filtro-container"
	  }, [_c('div', {
	    staticClass: "column centered-start banco-precos-base-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start w-100 gap-5"
	  }, [_c('div', {
	    staticClass: "form-item-container"
	  }, [_vm._m(1), _vm._v(" "), _c('multiselect', {
	    staticClass: "select-container-sm",
	    attrs: {
	      "options": _vm.selectOptions.tipoItem,
	      "searchable": false,
	      "close-on-select": true,
	      "show-labels": false,
	      "placeholder": "Selecione o Tipo de Item"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.clearClassificadores()
	      }
	    },
	    model: {
	      value: (_vm.selecaoTipoItens),
	      callback: function($$v) {
	        _vm.selecaoTipoItens = $$v
	      },
	      expression: "selecaoTipoItens"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-item-container"
	  }, [_vm._m(2), _vm._v(" "), _c('multiselect', {
	    staticClass: "select-container-sm",
	    attrs: {
	      "options": _vm.selectOptions.uf,
	      "searchable": false,
	      "close-on-select": true,
	      "show-labels": false,
	      "placeholder": "Selecione o UF"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.clearClassificadores()
	      }
	    },
	    model: {
	      value: (_vm.selecaoUfs),
	      callback: function($$v) {
	        _vm.selecaoUfs = $$v
	      },
	      expression: "selecaoUfs"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-start w-100 gap-5 banco-precos-aparecer banco-precos-aviso-filtro"
	  }, [_vm._m(3), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.abrirFiltrosAvancados),
	      expression: "abrirFiltrosAvancados"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.abrirFiltrosAvancados) ? _vm._i(_vm.abrirFiltrosAvancados, null) > -1 : (_vm.abrirFiltrosAvancados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.abrirFiltrosAvancados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.abrirFiltrosAvancados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.abrirFiltrosAvancados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.abrirFiltrosAvancados = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), (_vm.abrirFiltrosAvancados) ? _c('div', {
	    staticClass: "row-flex centered-start banco-precos-aparecer banco-precos-filtros-avancados-container"
	  }, [_c('div', {
	    staticClass: "form-item-container"
	  }, [_vm._m(4), _vm._v(" "), _c('money', {
	    staticClass: "form-control",
	    model: {
	      value: (_vm.valorMaximo),
	      callback: function($$v) {
	        _vm.valorMaximo = $$v
	      },
	      expression: "valorMaximo"
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start banco-precos-refinadores-container"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-start w-100 gap-5 banco-precos-aparecer banco-precos-aviso"
	  }, [_c('label', [_c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "title": "Filtros específicos"
	    }
	  }), _vm._v(" Pesquisar por categorizadores ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.procuraCategorizadores),
	      expression: "procuraCategorizadores"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.procuraCategorizadores) ? _vm._i(_vm.procuraCategorizadores, null) > -1 : (_vm.procuraCategorizadores)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.procuraCategorizadores,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.procuraCategorizadores = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.procuraCategorizadores = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.procuraCategorizadores = $$c
	        }
	      }, function($event) {
	        return _vm.handleCategorizadores()
	      }]
	    }
	  })]), _vm._v(" "), (!_vm.procuraIndividual) ? _c('div', {
	    staticClass: "column centered-start w-100 gap-5"
	  }, [_c('div', {
	    staticClass: "row-flex centered-start w-100 gap-5 banco-precos-aparecer"
	  }, [_c('div', {
	    staticClass: "form-item-container"
	  }, [_c('label', [_vm._v("I - Categoria (Seleção Múltipla):")]), _vm._v(" "), _c('multiselect', {
	    staticClass: "select-container-md",
	    attrs: {
	      "options": _vm.selectOptions.categoria,
	      "searchable": true,
	      "multiple": true,
	      "close-on-select": true,
	      "show-labels": true,
	      "hide-selected": true,
	      "max": 5,
	      "loading": _vm.loading.categoria,
	      "placeholder": "Pesquisar, a categoria geral do item desejado (Ex: MATERIAL, MEDICAMENTO, MAQUINAS, INFORMATICA, etc.)"
	    },
	    on: {
	      "search-change": function($event) {
	        return _vm.debounceFiltro($event, 'categoria')
	      },
	      "input": function($event) {
	        return _vm.consultarGrupoItem()
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "maxElements",
	      fn: function() {
	        return [_vm._v("\n             Número máximo de elementos selecionados. Primeiro remova algum para adicionar novamente.\n           ")]
	      },
	      proxy: true
	    }, {
	      key: "noOptions",
	      fn: function() {
	        return [_vm._v("\n             Lista Vazia, utilize os controles para pesquisar ou digite.\n           ")]
	      },
	      proxy: true
	    }, {
	      key: "noResult",
	      fn: function() {
	        return [_vm._v("\n             Termo não encontrado, tente outro termo ou utilize os controladores para refazer a pesquisa.\n           ")]
	      },
	      proxy: true
	    }], null, false, 1769692805),
	    model: {
	      value: (_vm.selecaoCategoria),
	      callback: function($$v) {
	        _vm.selecaoCategoria = $$v
	      },
	      expression: "selecaoCategoria"
	    }
	  })], 1)]), _vm._v(" "), (_vm.selectOptions.grupo.length > 0) ? _c('div', {
	    staticClass: "row-flex centered-start w-100 gap-5 banco-precos-aparecer"
	  }, [_c('div', {
	    staticClass: "form-item-container"
	  }, [_c('label', [_vm._v("II - Grupo (Seleção Múltipla):")]), _vm._v(" "), _c('multiselect', {
	    staticClass: "select-container-md",
	    attrs: {
	      "options": _vm.selectOptions.grupo,
	      "searchable": true,
	      "multiple": true,
	      "close-on-select": true,
	      "show-labels": true,
	      "hide-selected": true,
	      "max": 5,
	      "loading": _vm.loading.grupo,
	      "placeholder": "O grupo no qual o item pertence (Ex: CONSTRUCAO, HOSPITALAR, INDUSTRIAL, ACESSORIOS, etc.)"
	    },
	    on: {
	      "search-change": function($event) {
	        return _vm.debounceFiltro($event, 'grupo')
	      },
	      "input": function($event) {
	        return _vm.consultarClassificacaoItem()
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "maxElements",
	      fn: function() {
	        return [_vm._v("\n             Número máximo de elementos selecionados. Primeiro remova algum para adicionar novamente.\n           ")]
	      },
	      proxy: true
	    }, {
	      key: "noOptions",
	      fn: function() {
	        return [_vm._v("\n             Lista Vazia, utilize os controles para pesquisar ou digite.\n           ")]
	      },
	      proxy: true
	    }, {
	      key: "noResult",
	      fn: function() {
	        return [_vm._v("\n             Termo não encontrado, tente outro termo ou utilize os controladores para refazer a pesquisa.\n           ")]
	      },
	      proxy: true
	    }], null, false, 1769692805),
	    model: {
	      value: (_vm.selecaoGrupos),
	      callback: function($$v) {
	        _vm.selecaoGrupos = $$v
	      },
	      expression: "selecaoGrupos"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectOptions.classificacao.length > 0) ? _c('div', {
	    staticClass: "row-flex centered-start w-100 gap-5 banco-precos-aparecer"
	  }, [_c('div', {
	    staticClass: "form-item-container"
	  }, [_c('label', [_vm._v("III - Classificação (Seleção Múltipla):")]), _vm._v(" "), _c('multiselect', {
	    staticClass: "select-container-md",
	    attrs: {
	      "options": _vm.selectOptions.classificacao,
	      "searchable": true,
	      "multiple": true,
	      "close-on-select": true,
	      "show-labels": true,
	      "hide-selected": true,
	      "max": 5,
	      "loading": _vm.loading.classificacao,
	      "placeholder": "Classificação mais específica do item."
	    },
	    on: {
	      "search-change": function($event) {
	        return _vm.debounceFiltro($event, 'classificacao')
	      },
	      "input": function($event) {
	        return _vm.consultarItens()
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "maxElements",
	      fn: function() {
	        return [_vm._v("\n             Número máximo de elementos selecionado. Primeiro remova algum para adicionar novamente.\n           ")]
	      },
	      proxy: true
	    }, {
	      key: "noOptions",
	      fn: function() {
	        return [_vm._v("\n             Lista Vazia, utilize os controles para pesquisar ou digite.\n           ")]
	      },
	      proxy: true
	    }, {
	      key: "noResult",
	      fn: function() {
	        return [_vm._v("\n             Termo não encontrado, tente outro termo ou utilize os controladores para refazer a pesquisa.\n           ")]
	      },
	      proxy: true
	    }], null, false, 3695275958),
	    model: {
	      value: (_vm.selecaoClassificacoes),
	      callback: function($$v) {
	        _vm.selecaoClassificacoes = $$v
	      },
	      expression: "selecaoClassificacoes"
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selecaoCategoria.length > 0 || _vm.procuraIndividual) ? _c('div', {
	    staticClass: "column centered-start banco-precos-item-container banco-precos-aparecer"
	  }, [_c('div', {
	    staticClass: "row-flex centered-start w-100 gap-5"
	  }, [_c('div', {
	    staticClass: "form-item-container"
	  }, [_vm._m(6), _vm._v(" "), _c('multiselect', {
	    staticClass: "select-container-xl",
	    attrs: {
	      "options": _vm.selectOptions.item,
	      "loading": _vm.loading.item,
	      "searchable": true,
	      "multiple": true,
	      "close-on-select": true,
	      "show-labels": true,
	      "hide-selected": true,
	      "max": 5,
	      "placeholder": "Pesquisar o Item"
	    },
	    on: {
	      "search-change": function($event) {
	        return _vm.debounceFiltro($event, 'item')
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "maxElements",
	      fn: function() {
	        return [_vm._v("\n             Número máximo de elementos selecionado. Primeiro remova algum para adicionar novamente.\n           ")]
	      },
	      proxy: true
	    }, {
	      key: "noOptions",
	      fn: function() {
	        return [_vm._v("\n             Lista Vazia, utilize os controles para pesquisar ou digite.\n           ")]
	      },
	      proxy: true
	    }, {
	      key: "noResult",
	      fn: function() {
	        return [_vm._v("\n             Termo não encontrado, tente outro termo ou utilize os controladores para refazer a pesquisa.\n           ")]
	      },
	      proxy: true
	    }], null, false, 3695275958),
	    model: {
	      value: (_vm.selecaoItems),
	      callback: function($$v) {
	        _vm.selecaoItems = $$v
	      },
	      expression: "selecaoItems"
	    }
	  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [(_vm.selecaoItems.length > 0 || (_vm.selecaoCategoria.length > 0)) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.consultarItensLicitacao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-database",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pesquisar ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.clearTipoSelection()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar Filtros ")])], 1)]), _vm._v(" "), (_vm.resultadoItems.length > 0) ? _c('div', {
	    staticClass: "column all-centered w-100 banco-precos-inferior-container"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "row-flex start-centered w-100 gap-5"
	  }, [_c('div', {
	    staticClass: "column centered-start banco-precos-caracteristicas-container"
	  }, [_vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start banco-precos-titulo-container"
	  }, [(_vm.mostrarFiltroDetalhe) ? _c('div', {
	    staticClass: "column all-start banco-precos-filtro-caracteristica-container banco-precos-aparecer"
	  }, [_c('div', {
	    staticClass: "row-flex all-start form-item-container gap-10"
	  }, [_c('label', [_vm._v("Tipo de Filtro: ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-start"
	  }, [_c('span', {
	    staticClass: "row-flex all-centered span-filtro"
	  }, [_c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "title": "As características selecionadas serão"
	    }
	  }), _vm._v("Inclusivo ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoFiltroCaracteristica),
	      expression: "tipoFiltroCaracteristica"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "INCLUSIVO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tipoFiltroCaracteristica, "INCLUSIVO")
	    },
	    on: {
	      "change": function($event) {
	        _vm.tipoFiltroCaracteristica = "INCLUSIVO"
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-start"
	  }, [_c('span', {
	    staticClass: "row-flex all-centered span-filtro"
	  }, [_c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "title": "Os resultados podem ser genéricos"
	    }
	  }), _vm._v("Exclusivo ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoFiltroCaracteristica),
	      expression: "tipoFiltroCaracteristica"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "EXCLUSIVO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tipoFiltroCaracteristica, "EXCLUSIVO")
	    },
	    on: {
	      "change": function($event) {
	        _vm.tipoFiltroCaracteristica = "EXCLUSIVO"
	      }
	    }
	  })])]), _vm._v(" "), _vm._m(9)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "banco-precos-caracteristicas-items-container"
	  }, _vm._l((_vm.filtroItensCaracteristica), function(items, key) {
	    return _c('div', {
	      key: key,
	      staticClass: "column all-start w-100"
	    }, [_c('div', {
	      staticClass: "row-flex centered-between banco-precos-item-tipo-caracteristica",
	      class: _vm.isSelected(key) ? 'banco-precos-item-tipo-caracteristica-selecionada' : '',
	      on: {
	        "click": function($event) {
	          return _vm.toggleVisibility(key)
	        }
	      }
	    }, [_c('div', {
	      on: {
	        "click": [function($event) {
	          $event.stopPropagation();
	        }, function($event) {
	          return _vm.toggleTodasCaracteristicas(key)
	        }]
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-power-off",
	      class: _vm.isSelected(key) ? 'icon-selected' : 'icon-deselected'
	    }), _vm._v(" " + _vm._s(key.replace(/_/g, ' ')) + " (" + _vm._s(items.length) + ")\n             ")]), _vm._v(" "), _c('i', {
	      staticClass: "fa",
	      class: _vm.isVisible(key) ? 'fa-caret-down' : 'fa-caret-left'
	    })]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.isVisible(key)),
	        expression: "isVisible(key)"
	      }],
	      staticClass: "column banco-precos-selecao-caracteristicas-container"
	    }, _vm._l((items), function(item, index) {
	      return _c('div', {
	        key: (key + "-" + (item.caracteristica) + "-" + index),
	        staticClass: "row-flex centered-end banco-precos-caracteristica",
	        class: item.selecionado ? 'banco-precos-caracteristica-selecionada' : '',
	        on: {
	          "click": function($event) {
	            return _vm.atualizarSelecaoCaracteristicas(key, item, index)
	          }
	        }
	      }, [_vm._v("\n               " + _vm._s(item.caracteristica) + " "), _c('i', {
	        staticClass: "fa fa-power-off",
	        class: item.selecionado ? 'icon-selected' : 'icon-deselected'
	      })])
	    }), 0)])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start banco-precos-resultados-container"
	  }, [_c('div', {
	    staticClass: "column centered-start banco-precos-titulo-container"
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between banco-precos-subtitulo"
	  }, [_vm._v("\n           Confira os (" + _vm._s(_vm.table.items.length) + ") itens encontrados a partir dos filtros\n           "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.resetarItensTabela()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar Seleção ")])], 1)]), _vm._v(" "), _c('b-container', {
	    ref: "itemsEncontrados",
	    staticClass: "column centered-start w-100 gap-10 banco-precos-table-container",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    staticClass: "banco-precos-tabela",
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.detalharItem(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]
	      }
	    }, {
	      key: "descricao_item",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-start banco-precos-table-descricao-container"
	        }, [_c('div', {
	          staticClass: "banco-precos-table-descricao",
	          attrs: {
	            "title": row.value
	          }
	        }, [_vm._v("\n                   [" + _vm._s(row.item.id) + "] " + _vm._s(row.value) + "\n                 ")])])]
	      }
	    }, {
	      key: "valor_item",
	      fn: function(row) {
	        return [_vm._v("\n                 " + _vm._s(_vm._f("real")(row.value)) + "\n             ")]
	      }
	    }, {
	      key: "selecionado",
	      fn: function(row) {
	        return [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (row.item.selecionado),
	            expression: "row.item.selecionado"
	          }],
	          key: row.item.id,
	          attrs: {
	            "type": "checkbox"
	          },
	          domProps: {
	            "checked": Array.isArray(row.item.selecionado) ? _vm._i(row.item.selecionado, null) > -1 : (row.item.selecionado)
	          },
	          on: {
	            "change": [function($event) {
	              var $$a = row.item.selecionado,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(row.item, "selecionado", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(row.item, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(row.item, "selecionado", $$c)
	              }
	            }, function($event) {
	              return _vm.verificaExclusaoManual(row.item)
	            }]
	          }
	        })]
	      }
	    }, {
	      key: "data_resultado_licitacao",
	      fn: function(row) {
	        return [_vm._v("\n                 " + _vm._s(row.value !== '' ? _vm.moment.utc(row.value).format('MM/YYYY') : '-') + "\n             ")]
	      }
	    }, {
	      key: "sigla_uf",
	      fn: function(row) {
	        return [_vm._v("\n                 " + _vm._s(row.value !== '0' ? row.value : '-') + "\n             ")]
	      }
	    }], null, false, 2871997631)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "w-100"
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1), _vm._v(" "), (_vm.abrirJustificativa) ? _c('div', {
	    staticClass: "column all-centered banco-precos-justificativa-modal",
	    on: {
	      "click": function($event) {
	        return _vm.cancelaRemocaoManual(_vm.itemJustificativa)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column all-centered banco-precos-justificativa-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-item-container"
	  }, [_c('label', [_c('i', {
	    staticClass: "fa fa-cube"
	  }), _vm._v(" Selecione o Motivo para desconsiderar o item:")]), _vm._v(" "), _c('multiselect', {
	    staticClass: "select-container-xl",
	    attrs: {
	      "options": _vm.selectJustificativa,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Selecione o Motivo"
	    },
	    model: {
	      value: (_vm.selecaoJustificativa),
	      callback: function($$v) {
	        _vm.selecaoJustificativa = $$v
	      },
	      expression: "selecaoJustificativa"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gravaRemocaoManual(_vm.itemJustificativa)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Confirmar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelaRemocaoManual(_vm.itemJustificativa)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")])], 1)])]) : _vm._e()], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.loading.show) ? _c('div', {
	    ref: "loadingItems",
	    staticClass: "column all-centered w-100 banco-precos-inferior-container"
	  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.abrirDetalheItem) ? _c('div', {
	    ref: "detalhamentoContainer",
	    staticClass: "column all-centered banco-precos-detalhamento-item"
	  }, [_c('detalheItemLicitacao', {
	    attrs: {
	      "itemLicitacao": _vm.itemDetalheSelecionado,
	      "toggleDetalhe": _vm.toggleDetalhe
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gravarResultado()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Utilizar Resultado ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleBancoPrecos(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-between banco-precos-titulo"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered gap-5"
	  }, [_c('i', {
	    staticClass: "fa fa-filter"
	  }), _vm._v(" "), _c('label', [_vm._v("Filtros (Comece por aqui)")])]), _vm._v(" "), _c('div', {
	    staticClass: "column all-centered"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "f-required"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes"
	  }), _vm._v(" Tipo de Item:")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('i', {
	    staticClass: "fa fa-map-o"
	  }), _vm._v(" UF (opcional):")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('i', {
	    staticClass: "fa fa-bell"
	  }), _vm._v(" Filtros Avançados ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('i', {
	    staticClass: "fa fa-hand-o-up"
	  }), _vm._v(" Valor máximo:")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-between banco-precos-titulo"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered gap-5"
	  }, [_c('i', {
	    staticClass: "fa fa-tags"
	  }), _vm._v(" "), _c('label', [_vm._v("Classificadores (Utilize as opções abaixo para afunilar sua pesquisa, selecione até 5 tags de cada tipo)")])]), _vm._v(" "), _c('div', {
	    staticClass: "column all-centered"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('i', {
	    staticClass: "fa fa-cube"
	  }), _vm._v(" Item (Seleção Múltipla):")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start banco-precos-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-paperclip"
	  }), _vm._v(" "), _c('label', [_vm._v("Resultados")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column centered-start banco-precos-titulo-container"
	  }, [_c('div', {
	    staticClass: "banco-precos-titulo-resultado"
	  }, [_c('i', {
	    staticClass: "fa fa-barcode"
	  }), _vm._v(" Explorador de caracteristicas\n         ")]), _vm._v(" "), _c('div', {
	    staticClass: "banco-precos-subtitulo"
	  }, [_vm._v("\n           Selecione uma ou mais características para refinar sua pesquisa\n         ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex all-centered form-item-container gap-10"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquise uma caracteristica aqui."
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "banco-precos-filtro-carecteristica-button",
	    attrs: {
	      "title": "Limpar Filtro"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "banco-precos-titulo-resultado"
	  }, [_c('i', {
	    staticClass: "fa fa-feed"
	  }), _vm._v(" Itens encontrados\n         ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex all-centered banco-precos-titulo"
	  }, [_vm._v("\n     Pesquisando Items... \n     "), _c('i', {
	    staticClass: "fa fa-hourglass-end banco-precos-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  })])
	}]}

/***/ }),
/* 1875 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.ehAcessoExterno ? 'container' : 'content-wrapper',
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP'
	    }
	  }), _vm._v(" "), (_vm.acao !== 'novo') ? _c('div', [_c('section', {
	    staticClass: "content-header",
	    style: (_vm.ehAcessoExterno ? 'background: #ecf0f5; margin-top: 10px;' : '')
	  }, [(_vm.ehAcessoExterno) ? _c('div', {
	    staticClass: "login-logo yellow-bg",
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('h1', [_c('span', [(_vm.formularioCadastrado.opcoes.abrir.acao !== 'FORCA_SOMENTE_LEITURA') ? _c('span', [_vm._v("\n              " + _vm._s(_vm.acao === 'impressao' ? 'Formulário em Branco para Impressão' : (_vm.acao === 'visualizacao' ? 'Visualizando Formulário' : (_vm.ultimaTarefa.nome === 'SOLICITACAO' ? 'Preencha o formulário' : (_vm.ultimaTarefa.nome === 'REVISAO' ? 'Revise o formulário' : (_vm.ultimaTarefa.nome === 'ANALISE' ? 'Análise do formulário' : ''))))) + "\n              " + _vm._s(_vm.formularioPreenchimento.fk_processo) + "\n            ")]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), (_vm.formularioCadastrado.opcoes.abrir.acao !== 'FORCA_SOMENTE_LEITURA') ? _c('span', [(!_vm._.includes(['impressao', 'visualizacao'], _vm.acao)) ? _c('span', [(!_vm.loading.tela && _vm.acao === 'edicao' && _vm._.has(_vm.formularioPreenchimento, 'fk_formulario')) ? _c('span', [(_vm.salvaFormulario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
	    staticClass: "button--moema warning",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 50px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-borda-dark) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Salvando")]) : (_vm.salvaFormulario.statusSalvamento === 'FEITO') ? _c('span', {
	    staticClass: "button--moema success",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 10px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-verde) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" Formulário salvo")]) : _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarPreenchimento(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar alterações")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading.tela) ? _c('span', [_c('g-button-moema', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "color": "success",
	      "type": "button",
	      "title": '<h5>' + (_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.ultimaTarefa.nome) ? 'Clique para enviar seu formulário para a Fundação BB' : 'Clique para concluir sua análise') + '</h5>',
	      "aria-hidden": "true"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.validaConclusao($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), (_vm.ehSubFormulario) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.replace('/#/inicial')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Fechar")])], 1) : _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.$router.go(-1) || _vm.$router.push('/#/inicial')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading.tela && false) ? _c('span', {
	    staticClass: "indicadores-cb-inline"
	  }, [_c('div', {
	    staticClass: "juntos"
	  }, [_c('i', {
	    class: (_vm.salvaFormulario.salvamentoAutomaticoAtivo ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.salvaFormulario.salvamentoAutomaticoAtivo = !_vm.salvaFormulario.salvamentoAutomaticoAtivo
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.salvaFormulario.salvamentoAutomaticoAtivo ? 'selecionado' : ''
	  }, [_vm._v(_vm._s(_vm.salvaFormulario.statusSalvamento))])])]) : _vm._e()]) : _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1), _vm._v(" "), (_vm.acao === 'impressao') ? _c('span', [_c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading.tela && _vm.acao !== 'impressao' && !_vm.ehSubFormulario && !_vm.ehAcessoExterno) ? _c('span', [_c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.exportarExcel($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Exportar Excel")])], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
	    staticClass: "content",
	    style: (_vm.ehAcessoExterno ? ' background: #ecf0f5; margin-top: 0;' : '')
	  }, [(_vm._.has(_vm.ultimaTarefa, 'observacao') && !_vm._.isNull(_vm.ultimaTarefa.observacao) && !_vm.ehSubFormulario && _vm.ultimaTarefa.nome !== 'SOLICITACAO') ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible hidden-print"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.ultimaTarefa.observacao)
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [(_vm.formularioCadastrado.opcoes.abrir.acao !== 'FORCA_SOMENTE_LEITURA') ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    staticClass: "w100 imprimir",
	    staticStyle: {
	      "visibility": "hidden"
	    }
	  }, [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', {}, [_c('div', {
	    staticStyle: {
	      "font-size": "35px !important",
	      "font-family": "sans-serif",
	      "margin-left": "20px"
	    }
	  }, [_vm._v(_vm._s(_vm.formularioCadastrado.nome))])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('span', {
	    staticClass: "hidden-print"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.formularioCadastrado.nome))]), _vm._v(" "), _c('hr')])]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "corpo_formulario"
	    }
	  }, _vm._l((_vm.formularioPreenchimento.formulario), function(controle, idx) {
	    return (controle.mostrar) ? _c('div', {
	      staticClass: "box-body"
	    }, [(_vm._.includes(['CONTROLE', 'PERSONALIZADO'], controle.grupo)) ? _c('div', {
	      ref: controle.id,
	      refInFor: true,
	      class: controle.obrigatorio ? 'required-field' + (_vm.errors.first(controle.id) || (_vm.errors.first(controle.id + '-INICIO') || _vm.errors.first(controle.id + '-TERMINO')) ? ' has-error' : '') : ''
	    }, [_c('label', {
	      staticClass: "control-label col-md-12 tituloControle"
	    }, [(!_vm._.isNull(_vm.formularioCadastrado.opcoes.numeracao) && _vm._.has(controle, 'numeracao')) ? _c('span', {
	      staticClass: "text-gray"
	    }, [_vm._v(_vm._s(controle.numeracao) + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm._.isEmpty(controle.titulo) ? 'Tílulo da questão não encontrado!!!' : controle.titulo)
	      }
	    }), _vm._v(" "), (!_vm._.isEmpty(controle.descricao)) ? _c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-question-circle hidden-print",
	      attrs: {
	        "title": '<h5>' + (controle.descricao) + '</h5>',
	        "aria-hidden": "true"
	      }
	    }) : _vm._e()]), _vm._v(" "), _c('span', {
	      staticClass: "visible-print",
	      staticStyle: {
	        "font-style": "italic"
	      },
	      domProps: {
	        "innerHTML": _vm._s(controle.descricao)
	      }
	    }), _vm._v(" "), (controle.elemento === 'NUMERO') ? _c('div', {
	      class: _vm._.includes(['TELEFONE', 'CNPJ', 'CPF'], controle.configuracao.formato) ? 'col-md-4' : 'col-md-3'
	    }, [(controle.configuracao.formato === 'CPF') ? _c('span', [_c('the-mask', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "mask": ['###.###.###-##'],
	        "type": "text",
	        "placeholder": "000.000.000-00",
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "name": controle.id
	      },
	      nativeOn: {
	        "blur": function($event) {
	          controle.valor = !_vm._.isEmpty(controle.valor) ? _vm._.padStart(controle.valor, 11, '0') : null;
	          _vm.validacaoElementoChave(idx);
	          _vm.validaCpfCnpj(idx)
	        }
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    })], 1) : (controle.configuracao.formato === 'CNPJ') ? _c('span', [_c('the-mask', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "mask": ['NN.NNN.NNN/NNNN-##'],
	        "tokens": _vm.$cnpjTokens,
	        "type": "text",
	        "placeholder": "00.000.000/0000-00",
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "name": controle.id
	      },
	      nativeOn: {
	        "blur": function($event) {
	          controle.valor = !_vm._.isEmpty(controle.valor) ? _vm._.padStart(controle.valor, 14, '0') : null;
	          _vm.validacaoElementoChave(idx);
	          _vm.validacaoElementoChave(idx);
	          _vm.validaCpfCnpj(idx)
	        }
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    })], 1) : (controle.configuracao.formato === 'TELEFONE') ? _c('span', [_c('the-mask', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "mask": ['(##) ####-####', '(##) #####-####'],
	        "type": "text",
	        "placeholder": "(00) 00000-0000",
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "name": controle.id
	      },
	      nativeOn: {
	        "blur": function($event) {
	          controle.valor = !_vm._.isEmpty(controle.valor) ? _vm._.padStart(controle.valor, 11, '9') : null;
	          _vm.validacaoElementoChave(idx)
	        }
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    })], 1) : (controle.configuracao.formato === 'CEP') ? _c('span', [_c('the-mask', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "mask": ['#####-###'],
	        "type": "text",
	        "placeholder": "00000-000",
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "name": controle.id
	      },
	      nativeOn: {
	        "blur": function($event) {
	          controle.valor = !_vm._.isEmpty(controle.valor) ? _vm._.padEnd(controle.valor, 8, '0') : null;
	          _vm.validacaoElementoChave(idx)
	        }
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    })], 1) : (controle.configuracao.formato === 'MOEDA') ? _c('span', [_c('money', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "name": controle.id
	      },
	      nativeOn: {
	        "blur": function($event) {
	          _vm.executarRegras();
	          _vm.validacaoElementoChave(idx)
	        }
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    })], 1) : (controle.configuracao.formato === 'INTEIRO') ? _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "number",
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "max": !_vm._.isNull(controle.configuracao.maximo) ? controle.configuracao.maximo : 999999999999,
	        "min": !_vm._.isNull(controle.configuracao.minimo) ? controle.configuracao.minimo : 0,
	        "name": controle.id
	      },
	      domProps: {
	        "value": (controle.valor)
	      },
	      on: {
	        "blur": function($event) {
	          _vm.executarRegras();
	          _vm.validacaoElementoChave(idx)
	        },
	        "keyup": function($event) {
	          controle.valor = _vm._.toSafeInteger(('' + controle.valor).replace(/\D+/g, ''))
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle, "valor", $event.target.value)
	        }
	      }
	    })]) : (controle.configuracao.formato === 'DECIMAL') ? _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "max": !_vm._.isNull(controle.configuracao.maximo) ? controle.configuracao.maximo : 999999999999,
	        "min": !_vm._.isNull(controle.configuracao.minimo) ? controle.configuracao.minimo : 0,
	        "name": controle.id
	      },
	      domProps: {
	        "value": (controle.valor)
	      },
	      on: {
	        "blur": function($event) {
	          _vm.executarRegras();
	          _vm.validacaoElementoChave(idx)
	        },
	        "keyup": function($event) {
	          controle.valor = _vm._.toNumber(('' + controle.valor).replace(/[^.0-9]+/g, ''))
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle, "valor", $event.target.value)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'duplicidade')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(" " + _vm._s(_vm.errors.firstByRule(controle.id, 'duplicidade')))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'max_value')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v("Número maior que o limite de " + _vm._s(controle.configuracao.maximo))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'min_value')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v("Número menor que o limite de " + _vm._s(controle.configuracao.minimo))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'cpf_digito')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(" " + _vm._s(_vm.errors.firstByRule(controle.id, 'cpf_digito')))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'cnpj_digito')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(" " + _vm._s(_vm.errors.firstByRule(controle.id, 'cnpj_digito')))]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.loading.duplicidade) && controle.id === _vm.loading.duplicidade) ? _c('span', [_c('i', {
	      staticClass: "etiquetaCarregando fa fa-refresh fa-spin"
	    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'TEXTO_SIMPLES') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "maxlength": _vm._.toSafeInteger(controle.configuracao.maximo) === 0 ? 250 : _vm._.toSafeInteger(controle.configuracao.maximo),
	        "name": controle.id
	      },
	      domProps: {
	        "value": (controle.valor)
	      },
	      on: {
	        "blur": function($event) {
	          _vm.executarRegras();
	          _vm.validacaoElementoChave(idx)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle, "valor", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'duplicidade')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(" " + _vm._s(_vm.errors.firstByRule(controle.id, 'duplicidade')))]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.loading.duplicidade) && controle.id === _vm.loading.duplicidade) ? _c('span', [_c('i', {
	      staticClass: "etiquetaCarregando fa fa-refresh fa-spin"
	    })]) : _vm._e(), _vm._v(" "), (_vm._.toSafeInteger(controle.configuracao.maximo) > 1) ? _c('i', {
	      staticStyle: {
	        "float": "right",
	        "color": "silver"
	      }
	    }, [_vm._v("Até " + _vm._s(_vm._.toSafeInteger(controle.configuracao.maximo)) + " caracteres")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'TEXTO_LONGO') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [(_vm._.isNull(controle.configuracao.formato) || controle.configuracao.formato === 'SOMENTE_TEXTO') ? _c('span', [_c('textarea', {
	      directives: [{
	        name: "resizable",
	        rawName: "v-resizable"
	      }, {
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "maxlength": _vm._.toSafeInteger(controle.configuracao.maximo) === 0 ? 250 : _vm._.toSafeInteger(controle.configuracao.maximo),
	        "name": controle.id
	      },
	      domProps: {
	        "value": (controle.valor)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.executarRegras()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle, "valor", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (_vm._.toSafeInteger(controle.configuracao.maximo) > 1) ? _c('i', {
	      staticStyle: {
	        "float": "right",
	        "color": "silver"
	      }
	    }, [_vm._v("Até " + _vm._s(_vm._.toSafeInteger(controle.configuracao.maximo)) + " caracteres")]) : _vm._e()]) : _c('span', [_c('quill-editor', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      ref: "refQuillEditor",
	      refInFor: true,
	      attrs: {
	        "disabled": controle.grupo === 'PERSONALIZADO',
	        "options": _vm.quillOptions,
	        "name": controle.id
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    })], 1), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SELECAO_SIMPLES') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [(controle.configuracao.formato === 'AUTOCOMPLETE') ? _c('span', [_c('multiselect', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "hidden-print",
	      attrs: {
	        "options": _vm._.map(controle.configuracao.conteudo.linhas, 'descricao'),
	        "placeholder": "Selecione uma opção",
	        "selectedLabel": "Selecionado",
	        "selectLabel": "",
	        "deselectLabel": "",
	        "name": controle.id,
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
	      },
	      on: {
	        "select": function($event) {
	          return _vm.executarRegras()
	        }
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    })], 1) : _c('span', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "form-control hidden-print",
	      attrs: {
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "name": controle.id
	      },
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(controle, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.executarRegras()
	        }]
	      }
	    }, _vm._l((controle.configuracao.conteudo.linhas), function(item) {
	      return (item.mostrar) ? _c('option', {
	        domProps: {
	          "value": item.valor || item.descricao
	        }
	      }, [_vm._v(_vm._s(item.descricao))]) : _vm._e()
	    }), 0)]), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.take(controle.configuracao.conteudo.linhas, 50)), function(item) {
	      return (item.mostrar) ? _c('p', {
	        staticClass: "col-md-12 visible-print"
	      }, [_c('i', {
	        staticClass: "fa fa-circle-thin"
	      }), _vm._v(" " + _vm._s(item.descricao) + "\n                      ")]) : _vm._e()
	    }), _vm._v(" "), (controle.configuracao.conteudo.linhas.length > 50) ? _c('p', {
	      staticClass: "col-md-12 text-bold visible-print"
	    }, [_vm._v("\n                        ..."), _c('br'), _vm._v("\n                        Observação: Tem " + _vm._s(controle.configuracao.conteudo.linhas.length) + " elementos nesta lista."), _c('br'), _vm._v("\n                        Informe aqui, qual resposta para localizarmos o mais próximo quando for digitado este texto no sistema\n                        "), _c('input', {
	      staticClass: "form-control",
	      attrs: {
	        "type": "text"
	      }
	    })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (controle.elemento === 'SELECAO_MULTIPLA') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('multiselect', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "hidden-print",
	      attrs: {
	        "options": _vm._.map(controle.configuracao.conteudo.linhas, 'descricao'),
	        "placeholder": "Selecione uma ou mais opções",
	        "selectedLabel": "Selecionado",
	        "selectLabel": "",
	        "deselectLabel": "",
	        "close-on-select": false,
	        "multiple": true,
	        "name": controle.id,
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
	      },
	      on: {
	        "select": function($event) {
	          return _vm.executarRegras()
	        }
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    }), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _vm._l((controle.configuracao.conteudo.linhas), function(item) {
	      return (item.mostrar) ? _c('p', {
	        staticClass: "col-md-12 visible-print"
	      }, [_c('i', {
	        staticClass: "fa fa-square-o"
	      }), _vm._v(" " + _vm._s(item.descricao) + "\n                      ")]) : _vm._e()
	    })], 2) : _vm._e(), _vm._v(" "), (controle.elemento === 'BOOLEANO') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('span', [_c('label', {
	      staticClass: "radio-inline new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "7px"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": controle.id,
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
	      },
	      domProps: {
	        "value": controle.configuracao.conteudo.linhas[0].descricao,
	        "checked": _vm._q(controle.valor, controle.configuracao.conteudo.linhas[0].descricao)
	      },
	      on: {
	        "change": [function($event) {
	          return _vm.$set(controle, "valor", controle.configuracao.conteudo.linhas[0].descricao)
	        }, function($event) {
	          return _vm.executarRegras()
	        }]
	      }
	    }), _vm._v(" " + _vm._s(controle.configuracao.conteudo.linhas[0].descricao) + " "), _c('div', {
	      staticClass: "new-control-indicator"
	    })]), _vm._v(" "), _c('label', {
	      staticClass: "radio-inline new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "7px"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": controle.id,
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
	      },
	      domProps: {
	        "value": controle.configuracao.conteudo.linhas[1].descricao,
	        "checked": _vm._q(controle.valor, controle.configuracao.conteudo.linhas[1].descricao)
	      },
	      on: {
	        "change": [function($event) {
	          return _vm.$set(controle, "valor", controle.configuracao.conteudo.linhas[1].descricao)
	        }, function($event) {
	          return _vm.executarRegras()
	        }]
	      }
	    }), _vm._v(" " + _vm._s(controle.configuracao.conteudo.linhas[1].descricao) + " "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])]), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'DATA') ? _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('datepicker', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      attrs: {
	        "input-class": "form-control datepicker",
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "value": controle.valor || null,
	        "language": _vm.$datePickerPtBR,
	        "maxlength": "20",
	        "use-utc": true,
	        "placeholder": "__ /__ /____",
	        "format": "dd/MM/yyyy",
	        "name": controle.id
	      },
	      on: {
	        "input": function($event) {
	          return _vm.valorPrimitivoElemento(idx, $event)
	        }
	      }
	    }), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (controle.elemento === 'PERIODO') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_vm._m(3, true), _vm._v(" "), _c('datepicker', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (('date_format:dd/MM/yyyy|before:' + controle.id + '-TERMINO, true') + (controle.obrigatorio ? '|required' : '')),
	        expression: "('date_format:dd/MM/yyyy|before:' + controle.id + '-TERMINO, true') + (controle.obrigatorio ? '|required' : '')"
	      }],
	      ref: controle.id + '-INICIO',
	      refInFor: true,
	      attrs: {
	        "input-class": "form-control datepicker",
	        "language": _vm.$datePickerPtBR,
	        "maxlength": "20",
	        "use-utc": false,
	        "placeholder": "__ /__ /____",
	        "format": "dd/MM/yyyy",
	        "value": _vm._.get(controle.valor, 'inicio', null),
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "name": controle.id + '-INICIO'
	      },
	      on: {
	        "input": function($event) {
	          return _vm.valorArrayElemento(idx, 'inicio', $event)
	        }
	      }
	    }), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'before')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(" " + _vm._s(_vm.msgErroPreenchimento['antes']))]) : _vm._e(), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('datepicker', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (('date_format:dd/MM/yyyy|after:' + controle.id + '-INICIO, true') + (controle.obrigatorio ? '|required' : '')),
	        expression: "('date_format:dd/MM/yyyy|after:' + controle.id + '-INICIO, true') + (controle.obrigatorio ? '|required' : '')"
	      }],
	      ref: controle.id + '-TERMINO',
	      refInFor: true,
	      attrs: {
	        "input-class": "form-control datepicker",
	        "language": _vm.$datePickerPtBR,
	        "maxlength": "20",
	        "use-utc": false,
	        "placeholder": "__ /__ /____",
	        "format": "dd/MM/yyyy",
	        "value": _vm._.get(controle.valor, 'termino', null),
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "name": controle.id + '-TERMINO'
	      },
	      on: {
	        "input": function($event) {
	          return _vm.valorArrayElemento(idx, 'termino', $event)
	        }
	      }
	    })], 1), _vm._v(" "), (_vm.errors.firstByRule(controle.id + '-INICIO', 'after') || _vm.errors.firstByRule(controle.id + '-TERMINO', 'after')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(" " + _vm._s(_vm.msgErroPreenchimento['depois']))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id + '-INICIO', 'before') || _vm.errors.firstByRule(controle.id + '-TERMINO', 'before')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(" " + _vm._s(_vm.msgErroPreenchimento['antes']))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id + '-INICIO', 'required') || _vm.errors.firstByRule(controle.id + '-TERMINO', 'required') || _vm.errors.firstByRule(controle.id + '-INICIO', 'date_format') || _vm.errors.firstByRule(controle.id + '-TERMINO', 'date_format')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorios']))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'UF_MUNICIPIO') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('multiselect', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: (controle.obrigatorio ? 'required' : ''),
	        expression: "controle.obrigatorio ? 'required' : ''"
	      }],
	      staticClass: "hidden-print",
	      attrs: {
	        "options": _vm.municipiosUf,
	        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
	        "placeholder": "Nome do município",
	        "label": "nomcid",
	        "group-values": "municipios",
	        "group-label": "uf",
	        "track-by": "codrai",
	        "preselect-first": false,
	        "close-on-select": true,
	        "selectLabel": "Selecionar",
	        "deselectLabel": "Desselecionar",
	        "selectedLabel": "",
	        "name": controle.id
	      },
	      on: {
	        "select": function($event) {
	          return _vm.executarRegras()
	        }
	      },
	      model: {
	        value: (controle.valor),
	        callback: function($$v) {
	          _vm.$set(controle, "valor", $$v)
	        },
	        expression: "controle.valor"
	      }
	    }), _vm._v(" "), (_vm._.has(controle.valor, 'nomcid')) ? _c('p', {
	      staticClass: "col-md-12 visible-print"
	    }, [_vm._v(_vm._s(controle.valor.nomcid) + " / " + _vm._s(controle.valor.sigufs))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (controle.elemento === 'CLASSIFICACAO') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [(controle.configuracao.formato === 'NUMEROS') ? _c('span', _vm._l((_vm._.range(_vm._.toSafeInteger(controle.configuracao.minimo), _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
	      return _c('span', {
	        class: (_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? '' : 'elemento_classificacao') + ' classificacao_numeral fa fa-stack fa-2x ',
	        on: {
	          "click": function($event) {
	            !_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? _vm.valorPrimitivoElemento(idx, _vm.valorPrimitivoElemento(idx) === n ? -1 : n) : false
	          }
	        }
	      }, [_c('i', {
	        class: 'fa fa-solid fa-stack-1x ' + (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-circle' : 'fa-circle-thin text-gray')
	      }), _vm._v(" "), _c('span', {
	        class: 'fa fa-stack-1x ' + (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-inverse' : '')
	      }, [_vm._v(_vm._s(n))])])
	    }), 0) : _c('span', _vm._l((_vm._.range(_vm._.toSafeInteger(controle.configuracao.minimo), _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
	      return _c('i', {
	        class: (_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? '' : 'elemento_classificacao') + ' fa fa-2x ' +
	          (_vm._.isNull(controle.configuracao.formato) ||
	            controle.configuracao.formato === 'ESTRELA' ? (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-star' : 'fa-star-o text-gray') :
	            (controle.configuracao.formato === 'CIRCULO' ? (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-circle' : 'fa-circle-thin text-gray') :
	              (controle.configuracao.formato === 'LIKE' ? (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-thumbs-o-up' : 'fa-thumbs-up text-gray') :
	                (controle.configuracao.formato === 'EMOJI' ? (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-smile-o' : 'fa-meh-o text-gray') :
	                  '')))),
	        on: {
	          "click": function($event) {
	            !_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? _vm.valorPrimitivoElemento(idx, _vm.valorPrimitivoElemento(idx) === n ? -1 : n) : false
	          }
	        }
	      })
	    }), 0), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required') && _vm._.isNull(controle.valor)) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (_vm._.isNull(controle.valor) && controle.obrigatorio ? 'required' : ''),
	        expression: "_.isNull(controle.valor) && controle.obrigatorio ? 'required' : ''"
	      }],
	      attrs: {
	        "type": "hidden",
	        "name": controle.id
	      },
	      domProps: {
	        "value": (controle.valor)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle, "valor", $event.target.value)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'NPS') ? _c('div', {
	      staticClass: "col-md-12 control-label"
	    }, [_c('table', {
	      class: _vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? 'elemento_NPS_escala_inativo' : 'elemento_NPS_escala',
	      attrs: {
	        "border": "1"
	      }
	    }, [_c('tr', _vm._l((_vm._.range(1, _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
	      return _c('td', {
	        class: 'text-center ' + (n === _vm._.toSafeInteger(controle.valor) ? 'bg-black' : ''),
	        on: {
	          "click": function($event) {
	            !_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? _vm.valorPrimitivoElemento(idx, n) : false
	          }
	        }
	      }, [_vm._v(" " + _vm._s(n) + " ")])
	    }), 0)]), _vm._v(" "), _c('table', {
	      staticClass: "elemento_NPS_limites"
	    }, [_c('tr', [_c('td', {
	      staticClass: "truncar"
	    }, [_vm._v(_vm._s(controle.configuracao.conteudo.linhas[0].descricao))]), _c('td', {
	      staticClass: "text-right truncar"
	    }, [_vm._v(_vm._s(controle.configuracao.conteudo.linhas[1].descricao))])])]), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required') && _vm._.isNull(controle.valor)) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: (_vm._.isNull(controle.valor) && controle.obrigatorio ? 'required' : ''),
	        expression: "_.isNull(controle.valor) && controle.obrigatorio ? 'required' : ''"
	      }],
	      attrs: {
	        "type": "hidden",
	        "name": controle.id
	      },
	      domProps: {
	        "value": (controle.valor)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle, "valor", $event.target.value)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LIKERT') ? _c('div', {
	      staticClass: "col-md-12 control-label"
	    }, [_c('table', {
	      staticClass: "elemento_likert_matrix table-hover"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "w30"
	    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.colunas), function(coluna) {
	      return (coluna.mostrar) ? _c('th', {
	        staticClass: "elemento_likert_cabecalho_coluna"
	      }, [_vm._v(_vm._s(coluna.descricao))]) : _vm._e()
	    })], 2)]), _vm._v(" "), _c('tbody', _vm._l((controle.configuracao.conteudo.linhas), function(linha, idxLinha) {
	      return _c('tr', [_c('td', {
	        staticClass: "elemento_likert_pergunta"
	      }, [_vm._v(_vm._s(_vm._.isEmpty(linha.descricao) ? 'Informe uma questão ...' : linha.descricao))]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.colunas), function(coluna, idxColuna) {
	        return (coluna.mostrar) ? _c('td', {
	          staticClass: "elemento_likert_opcoes"
	        }, [_c('i', {
	          class: 'fa fa-2x ' + (_vm.valorArrayElemento(idx, linha.descricao) === coluna.descricao ? 'fa-circle' : 'fa-circle-thin'),
	          on: {
	            "click": function($event) {
	              !_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? _vm.valorArrayElemento(idx, linha.descricao, coluna.descricao) : false
	            }
	          }
	        })]) : _vm._e()
	      })], 2)
	    }), 0)]), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required') && _vm._.isNull(controle.valor)) ? _c('span', {
	      staticClass: "label label-danger hidden-print"
	    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.valor),
	        expression: "controle.valor"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ((_vm._.isNull(controle.valor) || controle.configuracao.conteudo.linhas.length > (_vm._.keys(controle.valor)).length) && controle.obrigatorio ? 'required' : ''),
	        expression: "(_.isNull(controle.valor) || controle.configuracao.conteudo.linhas.length > (_.keys(controle.valor)).length) && controle.obrigatorio ? 'required' : ''"
	      }],
	      attrs: {
	        "type": "hidden",
	        "name": controle.id
	      },
	      domProps: {
	        "value": (controle.valor)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle, "valor", $event.target.value)
	        }
	      }
	    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['LAYOUT'], controle.grupo)) ? _c('div', [(controle.elemento === 'TEXTO_FIXO') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('div', {
	      domProps: {
	        "innerHTML": _vm._s(controle.titulo)
	      }
	    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LINHA_HORIZONTAL') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('hr')]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LOGOMARCA_FBB') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [(!_vm._.isEmpty(controle.descricao)) ? _c('div', [_c('a', {
	      attrs: {
	        "href": controle.descricao
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": _vm._.get(controle.configuracao, 'formato', 'LOGO_HORIZONTAL') === 'LOGO_HORIZONTAL' ? '/static/img/logo-login.png' : '/static/img/logo-vertical.png',
	        "alt": controle.titulo
	      }
	    })])]) : _c('div', [_c('img', {
	      attrs: {
	        "src": _vm._.get(controle.configuracao, 'formato', 'LOGO_HORIZONTAL') === 'LOGO_HORIZONTAL' ? '/static/img/logo-login.png' : '/static/img/logo-vertical.png',
	        "alt": controle.titulo
	      }
	    })])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SECAO') ? _c('div', {
	      class: ('secao_' + (_vm._.isEmpty(controle.configuracao) ? 'padrao' : _vm._.toLower(controle.configuracao.formato))) + ' col-md-12',
	      style: (!_vm._.isNull(_vm.editandoFormulario) ? 'color: black !important' : '')
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(controle.titulo)
	      }
	    }), _vm._v(" "), (_vm._.has(controle, 'descricao') && !_vm._.isEmpty(controle.descricao)) ? _c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-question-circle hidden-print",
	      attrs: {
	        "title": '<h5>' + (controle.descricao) + '</h5>',
	        "aria-hidden": "true"
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(controle.descricao)) ? _c('span', {
	      staticClass: "visible-print"
	    }, [_c('span', {
	      staticStyle: {
	        "font-size": "small !important",
	        "font-style": "italic"
	      }
	    }, [_vm._v(_vm._s(controle.descricao))])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.grupo === 'FORMULARIO' && !_vm._.isNull(controle.configuracao.conteudo)) ? _c('div', {
	      staticClass: "hidden-print"
	    }, [_c('label', {
	      staticClass: "control-label col-md-12 tituloControle"
	    }, [(!_vm._.isNull(_vm.formularioCadastrado.opcoes.numeracao) && _vm._.has(controle, 'numeracao')) ? _c('span', {
	      staticClass: "text-gray"
	    }, [_vm._v(_vm._s(controle.numeracao) + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm._.isEmpty(controle.titulo) ? 'Tílulo não encontrado!!!' : controle.titulo)
	      }
	    }), _vm._v(" "), (!_vm._.isEmpty(controle.descricao)) ? _c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-question-circle hidden-print",
	      attrs: {
	        "title": '<h5>' + (controle.descricao) + '</h5>',
	        "aria-hidden": "true"
	      }
	    }) : _vm._e()]), _vm._v(" "), _c('span', {
	      staticClass: "visible-print",
	      staticStyle: {
	        "font-style": "italic"
	      },
	      domProps: {
	        "innerHTML": _vm._s(controle.descricao)
	      }
	    }), _vm._v(" "), (_vm._.includes(['edicao', 'visualizacao'], _vm.acao)) ? _c('span', [(!_vm._.includes(['SOMENTE_LINK'], controle.configuracao.formato)) ? _c('span', [(_vm._.includes(['COMPLETO_COM_LINK', 'COMPLETO_SEM_LINK'], controle.configuracao.formato) && !_vm.loading.link) ? _c('div', {
	      staticClass: "col-md-3"
	    }, [(!_vm._.includes(['visualizacao', 'impressao'], _vm.acao)) ? _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "type": "button"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.abreFormulario(controle.configuracao.padrao[0])
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  Adicionar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "type": "button"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.carregaDadosSubForm(idx, controle.configuracao.padrao[0])
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-refresh",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.configuracao.conteudo.filter),
	        expression: "controle.configuracao.conteudo.filter"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "placeholder": "Pesquisa..."
	      },
	      domProps: {
	        "value": (controle.configuracao.conteudo.filter)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle.configuracao.conteudo, "filter", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (!_vm._.isNull(controle.configuracao.conteudo.filter) && controle.configuracao.conteudo.filter.length > 0) ? _c('span', {
	      staticClass: "info_discreto"
	    }, [_vm._v(_vm._s(controle.configuracao.conteudo.totalRows) + " localizado(s)")]) : _vm._e()]), _vm._v(" "), (_vm._.includes(controle.configuracao.formato, 'COM_LINK')) ? _c('div', {
	      staticClass: "col-md-5"
	    }, [(!_vm._.includes(['visualizacao', 'impressao'], _vm.acao)) ? _c('span', [(_vm.loading.link) ? _c('span', {
	      staticClass: "etiquetaCarregando"
	    }, [_c('i', {
	      staticClass: "fa fa-refresh fa-spin"
	    }), _vm._v(" Gerando link ...")]) : _c('span', [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          placement: 'top',
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	      }],
	      staticClass: "link_acesso",
	      staticStyle: {
	        "display": "flex"
	      },
	      attrs: {
	        "title": '<h5>Clique para copiar link para uso externo ao SGP</h5>'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copiaUrlSubFormulario(controle)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "truncar"
	    }, [_vm._v(_vm._s(controle.configuracao.padrao[0]))]), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-clone"
	    }), _vm._v(" "), (_vm._.has(controle.configuracao, 'link_copia')) ? _c('span', {
	      class: _vm._.get(controle.configuracao, 'link_copia.classe')
	    }, [_vm._v(_vm._s(_vm._.get(controle.configuracao, 'link_copia.msg')))]) : _vm._e()]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "font-size": "small",
	        "color": "var(--cor-alerta-dark)"
	      }
	    }, [_vm._v(_vm._s(controle.informacao))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-md-12"
	    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {}, [_c('b-container', {
	      attrs: {
	        "fluid": ""
	      }
	    }, [_c('b-table', {
	      ref: controle.id + '(' + _vm.numeroAtualizacao + ')',
	      refInFor: true,
	      attrs: {
	        "show-empty": "",
	        "stacked": "md",
	        "striped": "",
	        "bordered": controle.configuracao.conteudo.bordered,
	        "items": controle.valor,
	        "fields": controle.configuracao.conteudo.colunas,
	        "current-page": controle.configuracao.conteudo.currentPage,
	        "per-page": controle.configuracao.conteudo.perPage,
	        "filter": controle.configuracao.conteudo.filter,
	        "filter-function": _vm.filtroPorItem,
	        "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
	        "empty-text": "Nenhum registro encontrado",
	        "sort-by": controle.configuracao.conteudo.sortBy,
	        "sort-desc": controle.configuracao.conteudo.sortDesc
	      },
	      on: {
	        "filtered": _vm.onFiltered,
	        "update:sortBy": function($event) {
	          return _vm.$set(controle.configuracao.conteudo, "sortBy", $event)
	        },
	        "update:sort-by": function($event) {
	          return _vm.$set(controle.configuracao.conteudo, "sortBy", $event)
	        },
	        "update:sortDesc": function($event) {
	          return _vm.$set(controle.configuracao.conteudo, "sortDesc", $event)
	        },
	        "update:sort-desc": function($event) {
	          return _vm.$set(controle.configuracao.conteudo, "sortDesc", $event)
	        }
	      },
	      scopedSlots: _vm._u([(!_vm._.includes(controle.configuracao.formato, 'MINIMO')) ? {
	        key: "actions",
	        fn: function(row) {
	          return [(_vm._.get(row.item, '_rowVariant', '') === 'form-salvando') ? _c('span', [_vm._v("Salvando...")]) : (_vm._.get(row.item, '_rowVariant', '') === 'form-fechando') ? _c('span', [_vm._v("Fechando...")]) : (!_vm._.includes(['visualizacao', 'impressao'], _vm.acao)) ? _c('span', [(!_vm._.get(row.item, '_rowVariant')) ? _c('span', [(_vm._.includes(controle.configuracao.formato, 'COMPLETO')) ? _c('g-button-ujarak', {
	            attrs: {
	              "color": "primary",
	              "size": "button--size-ss"
	            },
	            nativeOn: {
	              "click": function($event) {
	                return _vm.abreFormulario(row.item.editar)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-pencil-square-o",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          }), _vm._v(" Editar")]) : _vm._e()], 1) : _c('span', [_vm._v("Em uso agora!")]), _vm._v(" "), _c('g-button-ujarak', {
	            attrs: {
	              "color": "success",
	              "size": "button--size-ss"
	            },
	            nativeOn: {
	              "click": function($event) {
	                return _vm.abreFormulario(row.item.visualizar)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-search",
	            attrs: {
	              "aria-label": "false"
	            }
	          }), _vm._v(" Visualizar")]), _vm._v(" "), (_vm._.includes(controle.configuracao.formato, 'COMPLETO')) ? _c('g-button-ujarak', {
	            attrs: {
	              "color": "error",
	              "size": "button--size-ss"
	            },
	            nativeOn: {
	              "click": function($event) {
	                return _vm.excluirItemSubFormulario(idx, controle.configuracao.padrao[0], row.item.excluir)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-trash",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          }), _vm._v(" Excluir")]) : _vm._e(), _vm._v(" "), _c('span', {
	            staticStyle: {
	              "font-size": "small",
	              "color": "steelblue"
	            }
	          }, [_vm._v(_vm._s(_vm._.get(row.item, 'andamento', '')))])], 1) : _c('span', [_vm._v(" ")])]
	        }
	      } : null], null, true)
	    }), _vm._v(" "), _c('b-row', {
	      staticStyle: {
	        "display": "flex",
	        "align-items": "center"
	      }
	    }, [_c('b-col', {
	      staticClass: "my-1",
	      staticStyle: {
	        "margin-top": "0"
	      },
	      attrs: {
	        "md": "6",
	        "right": ""
	      }
	    }, [(!_vm._.isNull(controle.valor) && controle.valor.length > 0 && controle.configuracao.conteudo.totalRows > controle.configuracao.conteudo.perPage) ? _c('span', [_c('b-pagination', {
	      staticClass: "my-3",
	      attrs: {
	        "total-rows": controle.configuracao.conteudo.totalRows,
	        "per-page": controle.configuracao.conteudo.perPage
	      },
	      model: {
	        value: (controle.configuracao.conteudo.currentPage),
	        callback: function($$v) {
	          _vm.$set(controle.configuracao.conteudo, "currentPage", $$v)
	        },
	        expression: "controle.configuracao.conteudo.currentPage"
	      }
	    })], 1) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('b-col', {
	      staticClass: "text-right",
	      attrs: {
	        "md": "6",
	        "right": ""
	      }
	    }, [_vm._v("\n                                Total de "), _c('strong', [_vm._v(_vm._s(controle.valor.length))]), _vm._v(" registro(s)\n                              ")])], 1)], 1)], 1)]) : _c('span', [_c('div', {
	      staticClass: "col-md-12"
	    }, [(_vm.loading.link) ? _c('span', {
	      staticClass: "etiquetaCarregando"
	    }, [_c('i', {
	      staticClass: "fa fa-refresh fa-spin"
	    }), _vm._v(" Gerando link ...")]) : _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "type": "button"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.carregaDadosSubForm(idx, controle.configuracao.padrao[0])
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-refresh",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]), _vm._v("\n                            Link de acesso para este formulário. Repasse para quem for preencher ele: "), _c('br'), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          placement: 'top',
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	      }],
	      staticClass: "link_acesso",
	      attrs: {
	        "title": '<h5>Clique para copiar link para uso externo ao SGP</h5>'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copiaUrlSubFormulario(controle)
	        }
	      }
	    }, [_vm._v("\n                              " + _vm._s(controle.configuracao.padrao[0]) + "\n                              "), _c('i', {
	      staticClass: "fa fa-clone"
	    }), _vm._v(" "), (_vm._.has(controle.configuracao, 'link_copia')) ? _c('span', {
	      class: _vm._.get(controle.configuracao, 'link_copia.classe')
	    }, [_vm._v(_vm._s(_vm._.get(controle.configuracao, 'link_copia.msg')))]) : _vm._e()])], 1)])])]) : _c('span', {
	      staticClass: "col-md-12"
	    }, [_vm._v("\n                      Total de "), _c('strong', [_vm._v(_vm._s(controle.valor.length))]), _vm._v(" formulários preenchidos\n                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((2), function(n) {
	      return (controle.mostrar) ? _c('br', {
	        staticClass: "visible-print"
	      }) : _vm._e()
	    })], 2) : _vm._e()
	  }), 0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])]), _vm._v(" "), (!_vm._.isNull(_vm.processo) && _vm._.has(_vm.processo, 'tarefas') && _vm.processo.tarefas.length > 1 && (_vm.formularioCadastrado.opcoes.historico === 'TODOS' || (!_vm.ehAcessoExterno && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.formularioCadastrado.opcoes.historico === 'SOMENTE_FBB'))) ? _c('div', {
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border secaoRetratil",
	    on: {
	      "click": function($event) {
	        _vm.mostrarHistorico = !_vm.mostrarHistorico
	      }
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('span', [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrarHistorico ? 'up' : 'down')
	  })])]), _vm._v(" "), (_vm.mostrarHistorico) ? _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 table-responsive"
	  }, [_c('div', {}, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm._.filter(_vm.processo.tarefas, ['tipo', 'USUARIO'])), function(tarefa) {
	    return _c('tr', {
	      staticClass: "text-center"
	    }, [_c('td', [_vm._v(_vm._s(_vm._f("moment")(tarefa.inicio, 'DD/MM/YYYY hh:mm')))]), _vm._v(" "), _c('td', [(_vm._.isNull(tarefa.termino)) ? _c('span', [_vm._v("Pendente")]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(tarefa.termino, 'DD/MM/YYYY hh:mm')))])]), _c('td', [_vm._v(_vm._s(_vm.nomesTarefas[tarefa.nome]))]), _vm._v(" "), _c('td', [(_vm._.isNull(tarefa.termino)) ? _c('span', [_vm._v(" ")]) : _c('span', [_vm._v(_vm._s(tarefa.observacao))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tarefa.usuario.ds_nome_usuario))])])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.processo.situacao === 'EM_EXECUCAO') ? _c('span', [_vm._v("\n                        Processo "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold",
	      "color": "var(--cor-destaque)"
	    }
	  }, [_vm._v("Em Execução")]), _vm._v(" desde "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.processo.inicio, 'DD/MM/YYYY hh:mm')))])]) : _vm._e(), _vm._v(" "), (_vm.processo.situacao === 'FEITO') ? _c('span', [_vm._v("\n                        Processo foi "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold",
	      "color": "var(--cor-sucesso)"
	    }
	  }, [_vm._v("Concluído")]), _vm._v(" em "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.processo.termino, 'DD/MM/YYYY hh:mm')))])]) : _vm._e(), _vm._v(" "), (_vm.processo.situacao === 'CANCELADO') ? _c('span', [_vm._v("\n                        Processo foi "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold",
	      "color": "var(--cor-atencao)"
	    }
	  }, [_vm._v("Cancelado")]), _vm._v(" em "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.processo.termino, 'DD/MM/YYYY hh:mm')))])]) : _vm._e()])])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.ultimaTarefa.nome) && !_vm.ehAcessoExterno && !_vm.ehSubFormulario && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    ref: "decisão",
	    staticClass: "form-group required col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "CONCLUSAO",
	      "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "CONCLUSAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "CONCLUSAO")
	      }
	    }
	  }), _vm._v(" Aprovar formulário\n                            "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "REVISAO",
	      "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "REVISAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "REVISAO")
	      }
	    }
	  }), _vm._v(" Encaminhar para revisão\n                            "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('decisão')) ? _c('div', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('decisão')))]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.formularioCadastrado.opcoes.observacao)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm._.includes(['CONCLUSAO', 'REVISAO'], _vm.aprovacao.resultadoAprovacao)) ? _c('div', {
	    class: (_vm.aprovacao.resultadoAprovacao === 'REVISAO' ? 'required-field' : '') + ' col-md-12 ' + (_vm.errors.first('observacao') ? 'has-error' : '')
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao"
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm.aprovacao.resultadoAprovacao === 'REVISAO' ? 'Motivo para revisão' : 'Observação') + ":\n                            ")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.observacao),
	      expression: "aprovacao.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.aprovacao.resultadoAprovacao === 'REVISAO' ? 'required' : ''),
	      expression: "aprovacao.resultadoAprovacao === 'REVISAO' ? 'required' : ''"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao",
	      "rows": "3",
	      "id": "observacao",
	      "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
	    },
	    domProps: {
	      "value": (_vm.aprovacao.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.aprovacao, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('observacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('observacao')))]) : _vm._e()]) : _vm._e()]) : _vm._e()])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.formularioCadastrado.opcoes.observacao === 'TODOS' && !_vm.ehSubFormulario && ((!_vm.ehAcessoExterno && _vm.usuarioLogado.userType !== 'FUNDACAO') || _vm.ehAcessoExterno)) ? _c('div', {
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Opcionalmente pode adicionar informação sobre este formulário")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.observacao),
	      expression: "aprovacao.observacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "3",
	      "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
	    },
	    domProps: {
	      "value": (_vm.aprovacao.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.aprovacao, "observacao", $event.target.value)
	      }
	    }
	  })])])])])])]) : _vm._e()])]) : (!_vm.loading.tela) ? _c('div', [_c('section', {
	    staticClass: "content-header",
	    style: (_vm.ehAcessoExterno ? 'background: #ecf0f5; margin-top: 10px;' : '')
	  }, [(_vm.ehAcessoExterno) ? _c('div', {
	    staticClass: "login-logo yellow-bg",
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.formularioCadastrado.nome))])]), _vm._v(" "), _c('section', {
	    staticClass: "content",
	    style: (_vm.ehAcessoExterno ? ' background: #ecf0f5; margin-top: 0;' : '')
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gerarNovoFormularioPreenchimento($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sim")]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.replace('/#/inicial')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-ban",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Não")])], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "w30"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/logo-vertical.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticStyle: {
	      "height": "50px"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(" ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('span', {
	    staticClass: "btn",
	    staticStyle: {
	      "cursor": "default"
	    }
	  }, [_vm._v("De")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('span', {
	    staticClass: "btn",
	    staticStyle: {
	      "cursor": "default"
	    }
	  }, [_vm._v("Até")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Histórico")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticClass: "text-center text-bold"
	  }, [_c('td', {
	    staticClass: "w15"
	  }, [_vm._v("Enviado em")]), _vm._v(" "), _c('td', {
	    staticClass: "w15"
	  }, [_vm._v("Concluído em")]), _vm._v(" "), _c('td', {
	    staticClass: "w10"
	  }, [_vm._v("Fase")]), _vm._v(" "), _c('td', {
	    staticClass: "w40"
	  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
	    staticClass: "w20"
	  }, [_vm._v("Usuário Responsável")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Decisão")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Observação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h5', [_vm._v("\n                    Esta abrindo um formulário novo. "), _c('br'), _vm._v("\n                    Se continuar, então abrirá um novo link para que possa preencher, salvar e enviar o formulário para FBB.\n                    "), _c('br'), _c('br'), _vm._v("\n                    Deseja continuar?\n                    "), _c('br'), _c('br')])])
	}]}

/***/ }),
/* 1876 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [(!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Adiciona um usuário",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onNew()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo usuário")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Oculta usuários sem acesso ao sistema ou mostra todos os usuários",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.inativosOcultados = !_vm.inativosOcultados
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.inativosOcultados ? 'Mostrar Inativos' : 'Somente Ativos'))])]), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_insercao",
	    attrs: {
	      "title": '<h5>Inclusões: ' + _vm.inclUsuTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a inserção de novo(s) usuario(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_exclusao",
	    attrs: {
	      "title": '<h5>Exclusões: ' + _vm.excUsuTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a exclusão de usuario(s)")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "tabelaUsuarios",
	    attrs: {
	      "how-empty": "",
	      "stacked": "md",
	      "id": "usuarios-table",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "tbody-tr-class": _vm.inativosMostrarOcultar,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "ds_telefone",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "ds_cpf",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("cpf")(row.value)))]
	      }
	    }, {
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: _vm.isTrue(row.value) ? 'fa fa-circle text-green' : 'fa fa-circle text-red',
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(!_vm.disable) ? _c('div', [(row.item.ds_cpf !== null) ? _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-offset-0 fa-lg"
	        }, [(_vm.indiceAlt == row.index && _vm.mostraAlteracao === true && _vm.mostraInclusao === false) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'left'
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
	          }],
	          staticClass: "fa fa-warning",
	          staticStyle: {
	            "position": "relative",
	            "top": "8px",
	            "margin-left": "2px",
	            "color": "#fb2916"
	          },
	          attrs: {
	            "title": '<h5>Clique em editar para ver as mudanças.</h5>'
	          }
	        }) : _vm._e()])], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), (_vm.table.items && (_vm.table.items.length > _vm.table.perPage)) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)])]), _vm._v(" "), (_vm.state === 'FORM') ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    },
	    attrs: {
	      "name": "frmAddUser"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('div', {
	    staticClass: "control-label col-md-2"
	  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_nome_usuario),
	      expression: "usuario.ds_nome_usuario"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:100'),
	      expression: "'required|min:1|max:100'"
	    }],
	    ref: "ds_nome_usuario",
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true || _vm.disable
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_nome_usuario)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_nome_usuario", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nome_usuario')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_nome_usuario + '</h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome do Usuário é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "cpf"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf",
	      "data-vv-as": "CPF",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true,
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.usuario.ds_cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.usuario, "ds_cpf", $$v)
	      },
	      expression: "usuario.ds_cpf"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_cpf')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_cpf + '</h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('login')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "login"
	    }
	  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_login),
	      expression: "usuario.ds_login"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "login",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_login)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.verificaUsuario('ds_login', _vm.usuario.ds_login)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_login", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_login')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_login + '</h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('login')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('login')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10|max:11'),
	      expression: "'required|min:10|max:11'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "text",
	      "masked": false,
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.usuario.ds_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.usuario, "ds_telefone", $$v)
	      },
	      expression: "usuario.ds_telefone"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_telefone')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_telefone + '</h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_email),
	      expression: "usuario.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "data-vv-as": "E-Mail",
	      "type": "text",
	      "disabled": _vm.bloqueioCampos === true
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_email)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.verificaUsuario('ds_email', _vm.usuario.ds_email)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_email')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_email + '</h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('status')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "active"
	    }
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.bt_ativo),
	      expression: "usuario.bt_ativo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "status"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.usuario, "bt_ativo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Inativo")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [(_vm._.hasIn(_vm.mudancas, 'bt_ativo')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + (_vm.texto.bt_ativo | 'Ativo') + '</h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('status')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Status do Usuário é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-offset-2 col-md-4"
	  }, [(!_vm.verificandoLoginEmail) ? _c('span', [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "uib-tooltip": "Salva o cadastro",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.frmAddUser)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar Usuário")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "type": "button",
	      "uib-tooltip": "Cancela a edição"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onCancel(_vm.frmAddUser)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])]) : _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }), _vm._v("  Verificando se já existe...\n        ")])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('strong', [_vm._v("Cadastre abaixo o usuário que utilizará o sistema pela entidade")])])
	}]}

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container-edital"
	  }, [(_vm.mostrarCriarProposta) ? _c('div', {
	    staticClass: "edital-modal-container column all-centered"
	  }, [_c('div', {
	    staticClass: "edital-modal-mensagem column centered-start"
	  }, [_vm._m(0), _vm._v(" "), (_vm.entidadesExistentes.length > 0 && _vm._.has(_vm.entidadesExistentes[0], 'ds_nome') && !_vm._.isNull(_vm.entidadesExistentes[0].ds_nome)) ? _c('div', {
	    staticClass: "edital-content-container column all-centered"
	  }, [_c('span', {
	    staticClass: "edital-subtitulo"
	  }, [_vm._v("Ótimo! Verificamos que a entidade tem um cadastro na Fundação BB.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.entidadesExistentes), function(entidade) {
	    return _c('p', {
	      staticClass: "edital-link"
	    }, [_c('router-link', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          placement: 'right',
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	      }],
	      attrs: {
	        "title": '<h5>Clique aqui para atualizar o cadastro da entidade</h5>',
	        "to": {
	          name: 'cadastro-entidade-edita',
	          params: {
	            id: entidade.id
	          }
	        },
	        "target": "_blank"
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm._f("cnpj")(entidade.ds_cnpj)) + " -\n                  " + _vm._s(entidade.ds_nome) + "\n                  (" + _vm._s(entidade.ds_nome_fantasia) + ")\n                  "), _c('i', {
	      staticClass: "fa fa-external-link"
	    })])], 1)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "column all-centered email-edital-container"
	  }, [_c('div', [_vm._v("\n                  Atenção, caso o e-mail de acesso "), _c('b', [_vm._v("não")]), _vm._v(" seja nenhum desses listados abaixo, entre em contato com a Fundação BB pelo e-mail "), _c('b', [_vm._v(_vm._s(_vm.listaEditais[0].ds_numero_edital === 'ECOFORTE REDES 2024' ? 'ecoforte@fbb.org.br' : 'cataforte@fbb.org.br'))]), _vm._v(", constando o assunto: "), _c('b', [_vm._v(_vm._s(_vm.listaEditais[0].ds_numero_edital === 'ECOFORTE REDES 2024' ? 'SGP – CHAMADA PÚBLICA Nº 2024/007' : 'SGP – CHAMADA PÚBLICA Nº 2024/008'))]), _vm._v(". Você deverá anexar "), _c('b', [_vm._v("cópia da ata de eleição e posse")]), _vm._v(", "), _c('b', [_vm._v("documento do representante legal")]), _vm._v(" e informar o "), _c('b', [_vm._v("novo e-mail da entidade")]), _vm._v(", para que seu acesso possa ser regularizado. \n                ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.emailsEntidades), function(email) {
	    return _c('div', {
	      staticClass: "edital-titulo"
	    }, [_vm._v("\n                  " + _vm._s(email) + "\n                ")])
	  })], 2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered botao-edital-container"
	  }, [((_vm.mostrarForm && !_vm.mostrarArquivo && _vm.mostrarCriarProposta) && !_vm.gravando) ? _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.criaPropostaEdital()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Criar Proposta ")]) : _vm._e(), _vm._v(" "), ((_vm.mostrarForm && !_vm.mostrarArquivo && _vm.mostrarCriarProposta)) ? _c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelarEnvioEntidadeCadastrada()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")]) : _vm._e()], 1)], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "login-box",
	    staticStyle: {
	      "width": "60%",
	      "height": "auto"
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "login-box-body"
	  }, [_c('div', {
	    staticClass: "box box-widget col-md-14",
	    staticStyle: {
	      "border": "none",
	      "box-shadow": "none"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.telaTodosEditais) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "edital_selecao"
	    }
	  }, [_vm._v(_vm._s(_vm.rotuloSelecaoEdital))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editalAtivoSelecionado),
	      expression: "editalAtivoSelecionado"
	    }],
	    attrs: {
	      "name": "select",
	      "placeholder": "Selecione um Edital Ativo"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.editalAtivoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.selecionaAtivo()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione um Edital Ativo")]), _vm._v(" "), _vm._l((_vm.listaEditais), function(edital) {
	    return _c('option', {
	      domProps: {
	        "value": edital.parametro
	      }
	    }, [_vm._v(_vm._s(edital.ds_numero_edital))])
	  })], 2)])])]) : _vm._e(), _vm._v(" "), (!_vm.telaTodosEditais) ? _c('div', {
	    staticClass: "box-body form-horizontal",
	    attrs: {
	      "ssm-lte-loading": "loading-info"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "edital_selecao"
	    }
	  }, [_vm._v(_vm._s(_vm.rotuloSelecaoEdital))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaEditais,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Edital",
	      "label": "ds_numero_edital",
	      "track-by": "ds_numero_edital",
	      "custom-label": _vm.etiquetaEdital,
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "editais",
	      "data-vv-as": "Editais",
	      "preselect-first": true,
	      "disabled": _vm.desabilitaListaEditais
	    },
	    on: {
	      "select": function($event) {
	        return _vm.selecionado($event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.ds_numero_edital))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 3121837327),
	    model: {
	      value: (_vm.entidade.proposta.edital),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade.proposta, "edital", $$v)
	      },
	      expression: "entidade.proposta.edital"
	    }
	  })], 1)]), _vm._v(" "), (_vm.mostrarForm && _vm.mostrarArquivo) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Anexe a planilha de cadastro da entidade para preenchimento automático dos dados abaixo:")]), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('importacao-excel', {
	    attrs: {
	      "modelo": 'cadastro_entidade'
	    },
	    on: {
	      "analiseExcel": function($event) {
	        _vm.validacaoArquivo = $event
	      },
	      "objetoExcel": function($event) {
	        _vm.excel = $event
	      }
	    }
	  })], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.mostrarForm === true) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-horizontal col-md-14",
	    attrs: {
	      "name": "frmAutoRegister"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cnpj|min:14|max:14'),
	      expression: "'required|cnpj|min:14|max:14'"
	    }],
	    ref: "CNPJ",
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "data-vv-as": "CNPJ",
	      "type": "text",
	      "title": 'Informe o CNPJ da sua entidade.',
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.verificaCNPJEntidade($event)
	      }
	    },
	    model: {
	      value: (_vm.entidade.ds_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
	      },
	      expression: "entidade.ds_cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ')))]) : _vm._e()], 1), _vm._v(" "), (_vm.entidadesExistentes.length > 0 && _vm._.has(_vm.entidadesExistentes[0], 'ds_nome') && !_vm._.isNull(_vm.entidadesExistentes[0].ds_nome)) ? _c('div', {
	    staticClass: "col-md-offset-4 col-md-9"
	  }, [_c('span', {
	    staticClass: "label label-success"
	  }, [_vm._v("Ótimo! Verificamos que a entidade tem um cadastro na Fundação BB.")]), _vm._v(" "), _c('span', {
	    staticClass: "label label-success"
	  }, [_vm._v("Clique no link abaixo para acessar e atualizar as informações .")]), _vm._v(" "), _vm._l((_vm.entidadesExistentes), function(entidade) {
	    return _c('p', [_c('router-link', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          placement: 'right',
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	      }],
	      attrs: {
	        "title": '<h5>Clique aqui para atualizar o cadastro da entidade</h5>',
	        "to": {
	          name: 'cadastro-entidade-edita',
	          params: {
	            id: entidade.id
	          }
	        },
	        "target": "_blank"
	      }
	    }, [_vm._v("\n                            " + _vm._s(_vm._f("cnpj")(entidade.ds_cnpj)) + " -\n                            " + _vm._s(entidade.ds_nome) + "\n                            (" + _vm._s(entidade.ds_nome_fantasia) + ")\n                            "), _c('i', {
	      staticClass: "fa fa-external-link"
	    })])], 1)
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-warning"
	  }, [_vm._v("Para inscrever sua proposta clique no botão Criar Proposta no rodapé dessa página.")]), _vm._v(" "), _c('span', {
	    staticClass: "label label-warning"
	  }, [_vm._v("Nesse caso não é necessário preencher os dados da Entidade e nem do representante legal.")])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_nome),
	      expression: "entidade.ds_nome"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "title": 'Informe a Razão Social da sua entidade.',
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_email),
	      expression: "entidade.ds_email"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "Email",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Email",
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "title": 'Informe o E-mail da sua entidade.',
	      "type": "text",
	      "delivery": "account"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_email)
	    },
	    on: {
	      "change": _vm.verificaEmailEntidade,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Email')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email && _vm.usuario.ds_email) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais!')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('emailConfirmacaoEnt')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "emailConfirmacaoEnt"
	    }
	  }, [_vm._v("Confirmar E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.emailConfirmacaoEnt),
	      expression: "emailConfirmacaoEnt"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "emailConfirmacaoEnt",
	    staticClass: "form-control",
	    attrs: {
	      "name": "emailConfirmacaoEnt",
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "title": 'Confirme o E-mail da sua entidade.',
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.emailConfirmacaoEnt)
	    },
	    on: {
	      "paste": function($event) {
	        $event.preventDefault();
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.emailConfirmacaoEnt = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('emailConfirmacaoEnt')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo confirmação do e-mail da entidade é obrigatório')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email !== _vm.emailConfirmacaoEnt && _vm.emailConfirmacaoEnt.length > 0) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails informados não são iguais!')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Representante Legal:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_nome_usuario),
	      expression: "usuario.ds_nome_usuario"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "title": 'Informe o Nome do Usuário da sua entidade.',
	      "name": "Nome",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_nome_usuario)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_nome_usuario", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "name": "Cpf",
	      "type": "text",
	      "data-vv-as": "CPF",
	      "title": 'Informe o CPF do Usuário da sua entidade.',
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.usuario.ds_cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.usuario, "ds_cpf", $$v)
	      },
	      expression: "usuario.ds_cpf"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Cpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cpf')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Login')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome"
	    }
	  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_login),
	      expression: "usuario.ds_login"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Login",
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "title": 'Crie um login para o seu usuário.',
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_login)
	    },
	    on: {
	      "change": _vm.verificaUsuario,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_login", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Login')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Login')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_cnpj === _vm.usuario.ds_login && _vm.entidade.ds_cnpj) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O login do usuário não pode ser o número do CNPJ da entidade.')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10|max:11'),
	      expression: "'required|min:10|max:11'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "text",
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "title": 'Informe o telefone do usuário.',
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.usuario.ds_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.usuario, "ds_telefone", $$v)
	      },
	      expression: "usuario.ds_telefone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('userEmail')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "userEmail"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_email),
	      expression: "usuario.ds_email"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "userEmail",
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "title": 'Informe o E-mail do Usuário da sua entidade.',
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_email)
	    },
	    on: {
	      "change": _vm.verificaEmailUsuario,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('userEmail')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('userEmail')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais.')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('emailConfirmacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "emailConfirmacao"
	    }
	  }, [_vm._v("Confirmar E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.emailConfirmacao),
	      expression: "emailConfirmacao"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "emailConfirmacao",
	    staticClass: "form-control",
	    attrs: {
	      "name": "emailConfirmacao",
	      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
	      "title": 'Confirme o E-mail do Usuário da sua entidade.',
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.emailConfirmacao)
	    },
	    on: {
	      "paste": function($event) {
	        $event.preventDefault();
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.emailConfirmacao = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('emailConfirmacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo confirmação do e-mail da entidade é obrigatório')))]) : _vm._e(), _vm._v(" "), (_vm.usuario.ds_email !== _vm.emailConfirmacao && _vm.emailConfirmacao.length > 0) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails informados não são iguais!')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email && _vm.usuario.ds_email) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais!')))]) : _vm._e()])])])])])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), (_vm.mostrarForm === true && !_vm.telaTodosEditais) ? _c('div', {
	    staticClass: "box-footer"
	  }, [((_vm.mostrarForm && !_vm.mostrarArquivo && !_vm.mostrarCriarProposta && _vm.entidadesVoluntariadoDump.length <= 0) && !_vm.gravando) ? _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.grava()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), ((_vm.mostrarForm && _vm.mostrarArquivo && _vm.validacaoArquivo)) ? _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gravaViaArquivo()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-logo yellow-bg logo-container-edital",
	    staticStyle: {
	      "margin-top": "0"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#/"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/img/logo-login.png"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "edital-subtitulo"
	  }, [_c('b', [_vm._v("Clique no link abaixo")]), _vm._v(" para acessar e atualizar as informações .")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('b', [_vm._v("ATENÇÃO")]), _vm._v(": os documentos apresentados serão utilizados "), _c('b', [_vm._v("apenas para fins de atualização do cadastro")]), _vm._v(" e "), _c('b', [_vm._v("NÃO")]), _vm._v(" serão utilizados para análise da proposta.\n                ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "edital-subtitulo"
	  }, [_vm._v("Após atualizar o seu cadastro, clique no botão "), _c('b', [_vm._v("Criar Proposta")]), _vm._v(" abaixo.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "edital-subtitulo"
	  }, [_vm._v("Nesse caso "), _c('b', [_vm._v("não é necessário")]), _vm._v(" preencher os dados da Entidade e nem do representante legal.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-logo yellow-bg",
	    staticStyle: {
	      "margin-top": "0"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#/"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/img/logo-login.png"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('b', {
	    staticStyle: {
	      "color": "dimgrey"
	    }
	  }, [_vm._v("SGP - Autocredenciamento")])])])
	}]}

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Modals\n      "), _c('small', [_vm._v("new")])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Modals")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "callout callout-info"
	  }, [_c('h4', [_vm._v("Reminder!")]), _vm._v("\n      Instructions for how to use modals are available on the\n      "), _c('a', {
	    attrs: {
	      "href": "http://getbootstrap.com/javascript/#modals"
	    }
	  }, [_vm._v("Bootstrap documentation")])]), _vm._v(" "), _c('div', {
	    staticClass: "example-modal"
	  }, [_c('div', {
	    staticClass: "modal"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Fechar"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Default Modal")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', [_vm._v("One fine body…")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default pull-left",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Save changes")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "example-modal"
	  }, [_c('div', {
	    staticClass: "modal modal-primary"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Fechar"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Primary Modal")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', [_vm._v("One fine body…")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-outline pull-left",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-outline",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Save changes")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "example-modal"
	  }, [_c('div', {
	    staticClass: "modal modal-info"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Fechar"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Info Modal")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', [_vm._v("One fine body…")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-outline pull-left",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-outline",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Save changes")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "example-modal"
	  }, [_c('div', {
	    staticClass: "modal modal-warning"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Fechar"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Warning Modal")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', [_vm._v("One fine body…")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-outline pull-left",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-outline",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Save changes")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "example-modal"
	  }, [_c('div', {
	    staticClass: "modal modal-success"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Fechar"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Success Modal")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', [_vm._v("One fine body…")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-outline pull-left",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-outline",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Save changes")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "example-modal"
	  }, [_c('div', {
	    staticClass: "modal modal-danger"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Fechar"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Danger Modal")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', [_vm._v("One fine body…")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-outline pull-left",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-outline",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Save changes")])])])])])])])])
	}]}

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column start-centered testemunha-container"
	  }, [_c('div', [_vm._v("Indique 2 (duas) testemunhas para assinatura da minuta para formalização do projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(!this.editando && !this.gravando && !this.carregando) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona uma Testemunha",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleEdicao(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova testemunha")]) : _vm._e()]), _vm._v(" "), (!this.editando && !this.gravando && !this.carregando) ? _c('b-container', {
	    staticClass: "column centered-start w-100 gap-10",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "error"
	          },
	          nativeOn: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Confirma Exclusão da Testemunha?', function () { return _vm.excluirItem(row.item); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])]
	      }
	    }], null, false, 2270866021)
	  })], 1) : _vm._e(), _vm._v(" "), (this.editando && !this.gravando) ? _c('div', {
	    staticClass: "column start-centered testemunha-cadastro-container"
	  }, [_c('b', [_vm._v("Cadastro de Testemunha")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start testemunha-form"
	  }, [_c('label', {
	    staticClass: "control-label testemunha-label f-required",
	    attrs: {
	      "for": "título do curso"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.testemunhaEdicao.nome),
	      expression: "testemunhaEdicao.nome"
	    }],
	    staticClass: "form-control testemunha-input",
	    attrs: {
	      "name": "título do curso",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.testemunhaEdicao.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.testemunhaEdicao, "nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start testemunha-form"
	  }, [_c('label', {
	    staticClass: "control-label testemunha-label f-required",
	    attrs: {
	      "for": "título do curso"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('the-mask', {
	    staticClass: "form-control testemunha-input",
	    class: _vm.cpfInvalido ? 'campo-invalido' : '',
	    attrs: {
	      "name": "título do curso",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    on: {
	      "input": function($event) {
	        return _vm.validaCPF()
	      }
	    },
	    model: {
	      value: (_vm.testemunhaEdicao.cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.testemunhaEdicao, "cpf", $$v)
	      },
	      expression: "testemunhaEdicao.cpf"
	    }
	  }), _vm._v(" "), (_vm.cpfInvalido) ? _c('span', {
	    staticClass: "span-invalido"
	  }, [_vm._v("CPF inválido.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start testemunha-form"
	  }, [_c('label', {
	    staticClass: "control-label testemunha-label f-required",
	    attrs: {
	      "for": "título do curso"
	    }
	  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.testemunhaEdicao.email),
	      expression: "testemunhaEdicao.email"
	    }],
	    staticClass: "form-control testemunha-input",
	    class: _vm.emailInvalido ? 'campo-invalido' : '',
	    attrs: {
	      "name": "título do curso",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.testemunhaEdicao.email)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.testemunhaEdicao, "email", $event.target.value)
	      }, function($event) {
	        return _vm.validaEmail()
	      }]
	    }
	  }), _vm._v(" "), (_vm.emailInvalido) ? _c('span', {
	    staticClass: "span-invalido"
	  }, [_vm._v("EMAIL inválido.")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row centered-start testemunha-botao"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "tooltip": "Adiciona uma Testemunha",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.adicionarTestemunha()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Adicionar Testemunha")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "tooltip": "Cancela Procedimento",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleEdicao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")])])]) : _vm._e(), _vm._v(" "), (this.gravando) ? _c('div', {
	    staticClass: "column all-centered testemunha-cadastro-container"
	  }, [_vm._v("\n        Gravando... "), _c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), (this.carregando) ? _c('div', {
	    staticClass: "column all-centered testemunha-cadastro-container"
	  }, [_vm._v("\n        Carregando Testemunhas Cadastradas... "), _c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1880 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "124568189198"
	    }
	  }, [_c('span', {
	    staticClass: "titulo-texto"
	  }, [_vm._v(_vm._s(_vm.titulo) + ":")]), _vm._v(" "), _c('span', {
	    staticClass: "valor-texto"
	  }, [_vm._v(_vm._s(_vm.valor))])])
	},staticRenderFns: []}

/***/ }),
/* 1881 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": "SGP - Impressão da Proposta"
	    }
	  }), _vm._v(" "), _c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Impressão da Proposta\n        "), _vm._v(" "), (_vm.bloqueiaBotoes === false) ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "disabled": false,
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "info",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onDownloadZIP($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Baixar documentos ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.closewindow($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '/proposta/lista'
	      }, {
	        text: 'Imprime',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    attrs: {
	      "id": "proposta"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.ultimaTarefaEntidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [(_vm._.isUndefined(_vm.ultimaTarefaEntidade) || _vm._.isNull(_vm.ultimaTarefaEntidade.termino)) ? _c('span', {
	    staticClass: "ressaltar atencao"
	  }, [_vm._v("Essa proposta ainda não foi enviada para Fundação BB")]) : _c('span', [_vm._v("\n                  Essa proposta foi enviada por\n                  "), (_vm.ultimaTarefaEntidade.usuario) ? _c('span', {
	    staticClass: "ressaltar atencao"
	  }, [_vm._v(_vm._s(_vm.ultimaTarefaEntidade.usuario.ds_nome_usuario))]) : _vm._e(), _vm._v(" em\n                  "), _c('span', {
	    staticClass: "ressaltar atencao"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ultimaTarefaEntidade.termino, "DD/MM/YYYY")))]), _vm._v(" às\n                  "), _c('span', {
	    staticClass: "ressaltar atencao"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ultimaTarefaEntidade.termino, "HH:mm")))])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Resumo do Projeto")]), _vm._v(" "), _c('div', [(_vm._.isString(_vm.proposta.ds_codigo_projeto_erp)) ? _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Número do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp))])])])]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Nome do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.ds_nome))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Período de Realização do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ehNulo(_vm.proposta.dt_assinatura_convenio, _vm.proposta.dt_data_inicial), 'MM/YYYY')) + "  a  " + _vm._s(_vm.proposta.dataFinal) + "  (" + _vm._s(_vm.proposta.nr_periodos) + " meses)")])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalProjeto)))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalCtrp)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalParc)))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
	    return m.ds_municipio + '/' + m.ds_uf
	  })), function(municipio) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(municipio[0].ds_municipio))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(municipio[0].ds_uf))])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta && _vm.parcelasAdiantamentoExibicao.length > 0) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Parcelas de Adiantamento")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho",
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '10%' : '15%'))
	  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho",
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '30%' : '45%'))
	  }, [_vm._v("Origem")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('th', {
	    staticClass: "cabecalho",
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('th', {
	    staticClass: "cabecalho",
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho",
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '20%' : '40%'))
	  }, [_vm._v("Valor Adiantável")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parcelasAdiantamentoExibicao), function(adiantamento) {
	    return _c('tr', {
	      key: 'adiantamento-' + adiantamento.parcela + '-' + adiantamento.origem
	    }, [_c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(_vm.rotuloOrigemParcela(adiantamento.origem)))]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "ressaltar direita"
	    }, [(!_vm._.isNil(adiantamento.valor_fbb)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_fbb)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "ressaltar direita"
	    }, [(!_vm._.isNil(adiantamento.valor_parc)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_parc)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar direita"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor)))])])
	  }), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Total adiantável")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "ressaltar direita"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoFundacao)) + "\n                        "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoFundacao / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "ressaltar direita"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoParceiro)) + "\n                        "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoParceiro / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar direita"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoGeral)) + "\n                        "), ((_vm._.toNumber(_vm.proposta.totalFBB || 0) + _vm._.toNumber(_vm.proposta.totalParc || 0)) > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoGeral / (_vm._.toNumber(_vm.proposta.totalFBB || 0) + _vm._.toNumber(_vm.proposta.totalParc || 0))))) + ")")]) : _vm._e()])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Entidade Proponente")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s((_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato)) ? (_vm.ehNulo(_vm.proposta.entidade.contato.ds_telefone, _vm.proposta.entidade.contato.ds_celular) | _vm.telefone) : ''))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('thead', [_c('tr', [(_vm.proposta.entidade.endereco) ? _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Endereço" + _vm._s((_vm.proposta.entidade.endereco.length > 1 ? 's' : '')))]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Complemento")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("CEP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_rua))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_numero))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_bairro))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_complemento))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_cidade))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(endereco.ds_estado))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(_vm._f("cep")(endereco.ds_cep)))])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)")]), _vm._v(" "), _vm._l((_vm.proposta.entidade.dirigentes), function(dirigente) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered lista"
	    }, [_c('tbody', [(dirigente.cargo) ? _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w30"
	    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cargo")]), _vm._v(" "), (dirigente.cargo.ds_descricao) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Final do Mandato")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]) : _vm._e(), _vm._v(" "), (dirigente.contato) ? _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_rg) + " - " + _vm._s(dirigente.ds_orgao_emissor) + "/" + _vm._s(dirigente.ds_uf))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_estado_civil))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Profissão")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_profissao))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Telefone")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("telefone")(dirigente.contato.ds_telefone)))])]) : _vm._e(), _vm._v(" "), (dirigente.endereco) ? _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Endereço")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.endereco.ds_rua) + ", " + _vm._s(dirigente.endereco.ds_numero) + ", " + _vm._s(dirigente.endereco.ds_bairro) + ", " + _vm._s(dirigente.endereco.ds_complemento))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("CEP")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("cep")(dirigente.endereco.ds_cep)))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cidade/UF")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.endereco.ds_cidade) + " / " + _vm._s(dirigente.endereco.ds_uf))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.contato.ds_email))])]) : _vm._e()])])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.ds_nome_coordenador))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar centralizado"
	  }, [_vm._v(_vm._s(_vm._f("cpf")(_vm.proposta.ds_cpf_coordenador)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar centralizado"
	  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.ehNulo(_vm.proposta.ds_telefone_coordenador, _vm.proposta.ds_celular_coordenador))))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar centralizado"
	  }, [_vm._v(_vm._s(_vm.proposta.ds_email_coordenador))])])])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Apresentação da Entidade Proponente")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_apresentacao)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Informação sobre Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_territorio)
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_justificativa)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_operacao)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Relacionamento com a Comunidade e Parcerias")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_parceria)
	    }
	  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Público-alvo do projeto")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.publicos_alvo), function(publico) {
	    return _c('tr', [(publico.fonte.ds_descricao) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(publico.fonte.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(publico.nr_participantes_diretos))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(publico.nr_jovens))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(publico.nr_mulheres))])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
	    }
	  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos, Metas e Atividades")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed m0 obj_met_atv"
	  }, [_c('tbody', [_vm._l((_vm.proposta.objetivos), function(objetivo, idxObjetivo) {
	    return [_c('tr', {
	      staticClass: "objetivo"
	    }, [(objetivo.ds_descricao) ? _c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('span', {
	      staticClass: "tag"
	    }, [_vm._v("objetivo")]), _vm._v(_vm._s(objetivo.ds_descricao))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.proposta.metas), function(meta, idxMeta) {
	      return (_vm._.find(meta.objetivos, function(o) {
	        return o.ds_descricao === objetivo.ds_descricao
	      })) ? [_c('tr', {
	        staticClass: "meta"
	      }, [(meta.ds_descricao) ? _c('td', [_c('span', {
	        staticClass: "tag vertical"
	      }, [_vm._v("meta")]), _vm._v(_vm._s(meta.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
	        staticClass: "ressaltar"
	      }, [_vm._v(_vm._s(meta.nr_quantidade) + " " + _vm._s(meta.ds_unidade_medida))]), _vm._v(" e indicar a execução como "), _c('span', {
	        staticClass: "ressaltar"
	      }, [_vm._v(_vm._s(meta.ds_indicadores_execucao))])])]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade, idxAtividade) {
	        return (_vm._.find(atividade.metas, function(m) {
	          return m.ds_descricao === meta.ds_descricao
	        })) ? [_c('tr', {
	          staticClass: "atividade"
	        }, [(atividade.descricao) ? _c('td', [_c('span', {
	          staticClass: "tag vertical"
	        }, [_vm._v("atividade")]), _vm._v(_vm._s(atividade.descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Executar\n                              "), (atividade.inicio === atividade.termino) ? _c('span', [_vm._v(" no " + _vm._s(atividade.inicio) + "º ")]) : _c('span', [_vm._v(" do " + _vm._s(atividade.inicio) + "º  ao  " + _vm._s(atividade.termino) + "º ")]), _vm._v("\n                              mês e comprovar com "), _c('span', {
	          staticClass: "ressaltar"
	        }, [_vm._v(_vm._s(atividade.ds_documento_comprobatorio))])])])] : _vm._e()
	      }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.atividades, 'metas', meta.ds_descricao)) ? [_c('tr', {
	        staticClass: "atividade atencao"
	      }, [_c('td', {
	        attrs: {
	          "colspan": "2"
	        }
	      }, [_vm._v("* Não há atividades para a Meta acima")])])] : _vm._e()] : _vm._e()
	    }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.metas, 'objetivos', objetivo.ds_descricao)) ? [_c('tr', {
	      staticClass: "meta atencao"
	    }, [_c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("* Não há metas para o Objetivo acima")])])] : _vm._e()]
	  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cronograma de Execução das Atividades")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho w40 b1 b4"
	  }, [_vm._v("Atividade")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho direita w10 b1"
	  }, [_vm._v("Valor total")]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(mes) {
	    return _c('th', {
	      staticClass: "centralizado b1 b2 b4",
	      style: ('zoom:' + _vm.ganttZoom)
	    }, [_vm._v(_vm._s(mes + 1))])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.atividades), function(atividade) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar b3 b4"
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "direita b3"
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
	      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
	    }))))]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(m) {
	      return _c('td', {
	        staticClass: "centralizado b2 b3 b4",
	        style: ((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1)) ? 'background: gray !important' : '')
	      }, [((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1))) ? _c('span', {
	        style: ('zoom:' + _vm.ganttZoom + '; color: gray')
	      }, [_c('i', {
	        staticClass: "fa fa-circle"
	      })]) : _c('span', [_vm._v(" ")])])
	    })], 2)
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cursos")]), _vm._v(" "), _vm._l((_vm.proposta.cursos), function(curso) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered lista"
	    }, [_c('tbody', [_c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Título")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(curso.ds_titulo))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v("Alunos inscritos em outros cursos deste projeto?")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(('' + curso.outroCurso) === '0' ? 'Não' : 'Sim'))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Carga Horária")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(curso.nr_carga_horaria))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Qtde Educadores")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(curso.nr_qt_educadores))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Qtde de Turmas")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(curso.nr_qt_turmas))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Qtde Alunos por Turma")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(curso.nr_qt_alunos_turma))])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_c('span', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Público-alvo")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_publico_alvo))])])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_c('span', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Conteúdo Programárico")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_conteudo))])])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_c('span', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Detalhamento do perfil/experiência/qualificação dos profissionais a serem contratados")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_perfil_profissional))])])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_c('span', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Especificação dos serviços a serem prestados")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_especificacao_servico))])])])])])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Equipe do projeto")]), _vm._v(" "), _vm._l((_vm.proposta.equipes), function(equipe) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered lista"
	    }, [_c('tbody', [_c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cargo no projeto")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(equipe.ds_cargo))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Quantidade")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(equipe.nr_quantidade))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("É remunerado pelo projeto?")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(('' + equipe.bt_remunerado) === '0' ? 'Não' : 'Sim'))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Forma de contratação")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(equipe.ds_forma_contratacao))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Perfil profissional pretendido")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar",
	      attrs: {
	        "colspan": "5"
	      }
	    }, [_vm._v(_vm._s(equipe.ds_perfil_desejado))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Carga horária semanal")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(equipe.dc_carga_horaria) + " horas")])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Resumo das atividades")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar",
	      attrs: {
	        "colspan": "7"
	      }
	    }, [_vm._v(_vm._s(equipe.ds_resumo_atividades))])])])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_resultados)
	    }
	  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Orçamento do projeto - por atividade")]), _vm._v(" "), _c('table', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_vm._l((_vm.proposta.atividades), function(atividade) {
	    return [_c('tr', {
	      staticStyle: {
	        "font-weight": "bold"
	      }
	    }, [_c('td', {
	      staticClass: "esquerda nome_atividade bl1 bl3 bl4"
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado bl1 bl3"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado bl1 bl3"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
	      staticClass: "direita bl1 bl2 bl3",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
	      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
	    }))))])]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item) {
	      return _c('tr', [(!item.editando) ? [_c('td', {
	        staticClass: "bl4 b3"
	      }, [_c('span', {}, [(('' + item.origem).substr(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substr(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substr(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel).substr(0, 1) === '1') ? _c('span', {
	        staticClass: "adiantavel"
	      }, [_vm._v(" (Adiantável)")]) : _vm._e()]), _vm._v(" "), _c('span', {
	        staticClass: "esmaecido"
	      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('div', {
	        staticClass: "observacao esquerda"
	      }, [_vm._v(_vm._s(item.observacao))])]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3"
	      }, [_vm._v(_vm._s(item.periodo_inicial))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3"
	      }, [_vm._v(_vm._s(item.periodo_final))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3"
	      }, [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_unitario)))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3 bl2"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.quantidade * item.valor_unitario)))])] : _vm._e()], 2)
	    })]
	  })], 2)])]) : _vm._e()])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "table imprimir"
	  }, [_c('tr', [_c('td', [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "direita"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "40px !important"
	    }
	  }, [_vm._v("Proposta")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Fundação")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Proponente")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Terceiros")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("E-mail")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Público-alvo")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Participantes diretos")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Jovens atendidos")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Mulheres atendidas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Atividade / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Valor Total")])])])
	}]}

/***/ }),
/* 1882 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content-wrapper ",
	    staticStyle: {
	      "min-height": "793px"
	    }
	  }, [_c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Análise   \n          "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }]
	  }, [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(219)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 219\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'S')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525A\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'N')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525S\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>248 - Monitoramento Administrativo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(248)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 248\n            ")]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && _vm.etapa !== 'Solicitação') ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5>Faz o download de todos os arquivos da solicitação (zip)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onDownloadZIP()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v(" Baixar arquivos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Validação',
	        href: '#'
	      }, {
	        text: 'Devolução de Adiantamento',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.concluir($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', [(!_vm._.isEmpty(_vm.chamado) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v("* Atenção: O processo que será analisado possui chamado vinculado - "), _c('b', _vm._l((_vm.chamado), function(c, index) {
	    return _c('span', [_c('router-link', {
	      attrs: {
	        "target": "_blank",
	        "to": {
	          name: 'cadastro-chamado-edita',
	          params: {
	            id: c.id
	          }
	        }
	      }
	    }, [_vm._v(" " + _vm._s(c.id) + " "), (_vm.chamado.length > 1 && index === 0) ? _c('span', [_vm._v(",  ")]) : _vm._e()])], 1)
	  }), 0), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), ((_vm.historicoTarefasTela.length > 0 && _vm.historicoTarefasTela[1].observacao != null && _vm.historicoTarefasTela[1].observacao !== '')) ? _c('div', {
	    staticClass: "alert alert-dismissible alert-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.historicoTarefasTela[1].observacao)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Validação de Devolução de Adiantamento - "), _c('i', [_c('font', {
	    attrs: {
	      "color": "black",
	      "size": "3"
	    }
	  }, [_vm._v("ID: " + _vm._s(_vm.form.id) + " - Projeto: ")]), _c('font', {
	    attrs: {
	      "color": "black",
	      "size": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Objetivo Geral: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.proposta.ds_objetivo_geral))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', [(_vm.editaForm && !_vm._.isEmpty(_vm.projeto.adiantamentos_concedidos[0])) ? _c('grid-solicitacao-adiantamento-concecida', {
	    attrs: {
	      "props-projeto": _vm.projeto
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.form.documentos_liberacao.length) ? _c('cronograma-solicitacao-devolucao-adiantamento-validacao', {
	    attrs: {
	      "props-adiantamentos-concedidos": _vm.adiantamentosConcecidos,
	      "props-fase": _vm.form.tarefas[0].nome,
	      "props-enable": _vm.form.tarefas[0].nome === 'Análise' || _vm.form.tarefas[0].nome === 'Revisão',
	      "props-itens": _vm.form.documentos_liberacao[0].itens_liberados
	    },
	    on: {
	      "parcelaAdicionada": function($event) {
	        _vm.form.documentos_liberacao[0].itens_liberados = $event
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), (_vm.form.documentos_liberacao.length) ? _c('upload-documentos-php', {
	    attrs: {
	      "propDocumentos": _vm.form.documentos_liberacao[0].documentos_adiantamento,
	      "documentTypes": '',
	      "disable": _vm.form.tarefas[0].nome === 'Autorização'
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(3), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
	    key: _vm.historicoBack.length,
	    attrs: {
	      "propsValidacao": _vm.form,
	      "propsHistorico": _vm.historicoBack
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (!_vm.historicoBack) ? _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderHistorico === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && !_vm.historicoBack) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), (!_vm._.isUndefined(_vm.historicoAnt)) ? _c('historico-solicitacao-pagamento', {
	    attrs: {
	      "propsValidacao": _vm.form,
	      "propsHistorico": _vm.historicoAnt
	    }
	  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('resultadoAprovacao')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Aprovar solicitação?")]), _vm._v(" "), _c('div', [(_vm.form.tarefas[0].nome === 'Análise') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-binding"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Análise Financeira"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Análise Financeira")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Análise Financeira")
	      }
	    }
	  }), _vm._v(" Aprovar solicitação devolução de adiantamento\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : (_vm.form.tarefas[0].nome === 'Análise Financeira') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-binding"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Conclusão"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Conclusão")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Conclusão")
	      }
	    }
	  }), _vm._v(" Aprovar solicitação devolução de adiantamento\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : _vm._e(), _vm._v(" "), (_vm.form.tarefas[0].nome === 'Análise' || _vm.form.tarefas[0].nome === 'Autorização' || _vm.form.tarefas[0].nome === 'Análise Financeira') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-scope"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Revisão"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Revisão")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Revisão")
	      }
	    }
	  }), _vm._v(" Encaminhar para revisão da entidade\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : _vm._e(), _vm._v(" "), (_vm.form.tarefas[0].nome === 'Autorização' || _vm.form.tarefas[0].nome === 'Análise Financeira' || _vm.form.tarefas[0].nome === 'Revisão') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-scope"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Análise"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Análise")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Análise")
	      }
	    }
	  }), _vm._v(" Retornar para análise\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : _vm._e(), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio ng-scope"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.proximaEtapa),
	      expression: "tarefa.proximaEtapa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Cancelar"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Cancelar")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.tarefa, "proximaEtapa", "Cancelar")
	      }
	    }
	  }), _vm._v(" Cancelar Solicitação\n                                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Revisão') ? _c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "motivo de devolucao"
	    }
	  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.motivosDevolucao,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Selecione um motivo de Devolução para a entidade",
	      "custom-label": _vm.motivoDevolucaoDescricao,
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "motivo de devolucao",
	      "data-vv-as": "motivo de devolucao",
	      "option-height": 30,
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.motivoDevolucao),
	      callback: function($$v) {
	        _vm.motivoDevolucao = $$v
	      },
	      expression: "motivoDevolucao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa !== '') ? _c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('observacao')
	    },
	    staticStyle: {
	      "margin-right": "0px",
	      "margin-left": "0px"
	    }
	  }, [(_vm.tarefa.proximaEtapa === 'Revisão') ? _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao"
	    }
	  }, [_vm._v("Motivo para revisão:")]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Cancelar') ? _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao"
	    }
	  }, [_vm._v("Motivo para cancelamento:")]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Revisão' || _vm.tarefa.proximaEtapa === 'Cancelar') ? _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.observacao),
	      expression: "tarefa.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "observacao",
	      "id": "observacao",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.tarefa.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.tarefa, "observacao", $event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Financeira', 'Conclusão', 'Análise'], _vm.tarefa.proximaEtapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('observação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao_decisao"
	    }
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefa.observacao),
	      expression: "tarefa.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:13'),
	      expression: "'required|min:13'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observação",
	      "id": "observacao_decisao",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.tarefa.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.tarefa, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('observação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('observação')))]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "help-block"
	  }, [_vm._v("Informe no mínimo 13 caracteres.")])]) : _vm._e(), _vm._v(" "), (_vm.errors.first('observacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('observacao')))]) : _vm._e()]) : _vm._e()])])])])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.restricao || _vm.tarefa.proximaEtapa === '' || _vm.form.busy
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa fa-info"
	  }), _vm._v("   Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('dd', [_c('span', [_vm._v("Em Execução")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos de solicitação de pagamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de solicitação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico Antigo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Aprovação da solicitação de adiantamento")])])
	}]}

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "error-page"
	  }, [_c('h2', {
	    staticClass: "headline text-yellow"
	  }, [_vm._v(" 404")]), _vm._v(" "), _c('div', {
	    staticClass: "error-content"
	  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n                    We could not find the page you were looking for.\n                    Meanwhile, you may "), _c('router-link', {
	    attrs: {
	      "to": "/dashboard"
	    }
	  }, [_vm._v("return to dashboard")]), _vm._v(" or try using the search form.\n                ")], 1), _vm._v(" "), _vm._m(2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n            404 Error Page\n        ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("404 error")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', [_c('i', {
	    staticClass: "fa fa-warning text-yellow"
	  }), _vm._v(" Oops! Page not found.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    staticClass: "search-form"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "search",
	      "placeholder": "Search"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "submit",
	      "name": "submit"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])
	}]}

/***/ }),
/* 1884 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-show": "$ctrl.isNewAvaiable()"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova equipe")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "youngs",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
	      }
	    }, {
	      key: "women",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.exclui(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }])
	  })], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('título do curso')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "título do curso"
	    }
	  }, [_vm._v("Título do curso:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.title),
	      expression: "curso.title"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "título do curso",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.curso.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "title", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('título do curso')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('título do curso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade de educadores')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantidade de educadores"
	    }
	  }, [_vm._v(" Quantidade de educadores: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.educators),
	      expression: "curso.educators"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "quantidade de educadores",
	      "id": "quantidade de educadores",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.curso.educators)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "educators", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade de educadores')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de educadores')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('carga horaria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "carga horaria"
	    }
	  }, [_vm._v("Carga horária semanal:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "career.workload.null",
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.workload),
	      expression: "curso.workload"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control text-right ng-pristine ng-scope ng-not-empty ng-valid-max ng-valid-required ng-invalid ng-invalid-min ng-touched",
	    attrs: {
	      "name": "carga horaria",
	      "id": "carga horaria",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.curso.workload)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "workload", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("Horas")])]), _vm._v(" "), (_vm.errors.first('carga horaria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('carga horaria')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade de turmas')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantidade de turmas"
	    }
	  }, [_vm._v("Quantidade de turmas:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.classes),
	      expression: "curso.classes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "quantidade de turmas",
	      "id": "quantidade de turmas",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.curso.classes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "classes", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade de turmas')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de turmas')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade de alunos por turma')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantidade de alunos por turma"
	    }
	  }, [_vm._v("Quantidade de alunos por turma:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.studentsPerClass),
	      expression: "curso.studentsPerClass"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "quantidade de alunos por turma",
	      "id": "quantidade de alunos por turma",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.curso.studentsPerClass)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "studentsPerClass", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade de alunos por turma')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de alunos por turma')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('público-alvo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "título do curso"
	    }
	  }, [_vm._v("Público-alvo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.targetAudience),
	      expression: "curso.targetAudience"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-empty ng-invalid ng-invalid-required ng-touched",
	    attrs: {
	      "name": "público-alvo",
	      "id": "público-alvo",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.curso.targetAudience)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "targetAudience", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('público-alvo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('conteúdo programático mínimo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "conteúdo programático mínimo"
	    }
	  }, [_vm._v("Conteúdo programático mínimo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.content),
	      expression: "curso.content"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-empty ng-invalid ng-invalid-required ng-touched",
	    attrs: {
	      "name": "conteúdo programático mínimo",
	      "id": "conteúdo programático mínimo",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.curso.content)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "content", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('conteúdo programático mínimo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('conteúdo programático mínimo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('perfil dos profissionais a serem contratados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "perfil dos profissionais a serem contratados"
	    }
	  }, [_vm._v("Perfil dos profissionais a serem contratados:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.professionalProfile),
	      expression: "curso.professionalProfile"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-empty ng-invalid ng-invalid-required ng-touched",
	    attrs: {
	      "name": "perfil dos profissionais a serem contratados",
	      "id": "perfil dos profissionais a serem contratados",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.curso.professionalProfile)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "professionalProfile", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('perfil dos profissionais a serem contratados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('perfil dos profissionais a serem contratados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('especificação dos serviços')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "especificação dos serviços"
	    }
	  }, [_vm._v("Especificação dos serviços:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.serviceSpecification),
	      expression: "curso.serviceSpecification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-empty ng-invalid ng-invalid-required ng-touched",
	    attrs: {
	      "name": "especificação dos serviços",
	      "id": "especificação dos serviços",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.curso.serviceSpecification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "serviceSpecification", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('especificação dos serviços')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('especificação dos serviços')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-team-add"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-team-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1885 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Analise',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconder === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconder = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar o projeto "), _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.idProjectErp) + " - " + _vm._s(_vm.proposta.name))])]) : _vm._e(), _vm._v(" "), (_vm.esconder === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconder = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar o projeto "), _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.idProjectErp) + " - " + _vm._s(_vm.proposta.name))])]) : _vm._e()])]), _vm._v(" "), (_vm.esconder === true) ? _c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ng-init": "check()"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.simplified),
	      expression: "proposta.simplified"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "hidden",
	      "name": "tipo",
	      "id": "tipo",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.proposta.simplified)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "simplified", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('NAME')"
	    }
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.idProjectErp),
	      expression: "proposta.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.name),
	      expression: "proposta.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorName),
	      expression: "proposta.coordinatorName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorCpf", $$v)
	      },
	      expression: "proposta.coordinatorCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorEmail),
	      expression: "proposta.coordinatorEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorPhone", $$v)
	      },
	      expression: "proposta.coordinatorPhone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorMobile", $$v)
	      },
	      expression: "proposta.coordinatorMobile"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Fax')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorFax", $$v)
	      },
	      expression: "proposta.coordinatorFax"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Fax')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.proposta.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                      " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                      " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                    ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.initialDate),
	      expression: "proposta.initialDate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control",
	      "type": "date",
	      "format": "DD/MM/YYYY",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.proposta.initialDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "initialDate", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periods),
	      expression: "proposta.periods"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.proposta.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.introduction),
	      expression: "proposta.introduction"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "introduction", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.presentation),
	      expression: "proposta.presentation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.territory),
	      expression: "proposta.territory"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.justification),
	      expression: "proposta.justification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.generalObjective),
	      expression: "proposta.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.summary),
	      expression: "proposta.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": this.proposta.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": this.proposta.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.teams = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.results),
	      expression: "proposta.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "results", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.operation),
	      expression: "proposta.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "operation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.partner),
	      expression: "proposta.partner"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "partner", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.proposta.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.proposta.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                ")])])]), _vm._v(" "), (_vm.proposta.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingName),
	      expression: "proposta.entityExecutingName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingProcurator),
	      expression: "proposta.entityExecutingProcurator"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|cnpj'),
	      expression: "'required:!proposta.entityIsExecutioner|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCNPJ", $$v)
	      },
	      expression: "proposta.entityExecutingCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingEmail),
	      expression: "proposta.entityExecutingEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|email'),
	      expression: "'required:!proposta.entityIsExecutioner|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingPhone", $$v)
	      },
	      expression: "proposta.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingMobile", $$v)
	      },
	      expression: "proposta.entityExecutingMobile"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingFax", $$v)
	      },
	      expression: "proposta.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.duplicateProject),
	      expression: "proposta.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber) + "/" + _vm._s(projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(7), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(9), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraCronograma),
	      expression: "mostraCronograma"
	    }],
	    staticClass: "col-md-12"
	  }, [_vm._m(10), _vm._v(" "), _c('cronograma', {
	    attrs: {
	      "proposta": _vm.proposta,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades,
	      "meses": _vm.proposta.periods,
	      "projeto-duplicacao": _vm.proposta.duplicateProject
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('gantt', {
	    attrs: {
	      "periodo": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades
	    }
	  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "proposta": _vm.proposta
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(12), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.careers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('solenizacao', {
	    attrs: {
	      "propsSolenizacao": _vm.proposta.solemnizations
	    },
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.proposta.solemnizations = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(14), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documents,
	      "documentTypes": _vm.proposta.documentTypes,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(15), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documentStatements,
	      "documentTypes": [],
	      "documentosObrigatorios": []
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(16), _vm._v(" "), _c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta
	    }
	  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('formalizacao', {
	    attrs: {
	      "propsAnalise": _vm.analise
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                          outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	}]}

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.showGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file"
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.novoDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editaDocumento(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deletaDocumento(indexDocumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")]) : _vm._e()]) : _vm._e()])
	  }), 0)])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1887 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "ods-cadastro-main-container"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "ods-cadastro-content-container"
	  }, [(_vm.editando == false) ? _c('div', {
	    staticClass: "ods-button-alterar-container"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.editando = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                Editar Cadastro de Favoritos ODS")])]) : _vm._e(), _vm._v(" "), (_vm.editando == false) ? _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "idOds",
	      fn: function(row) {
	        return [_c('div', {
	          class: 'cor-' + row.item.idOds
	        }, [_c('img', {
	          staticClass: "ods-img",
	          attrs: {
	            "src": _vm.getImageODS(row.item.idOds),
	            "alt": "ODS IMG"
	          }
	        })])]
	      }
	    }], null, false, 703124086)
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editando == true) ? _c('div', {
	    staticClass: "ods-check-main-container"
	  }, [_vm._m(0), _vm._v(" "), _vm._l((this.baseODS), function(ods) {
	    return _c('div', {
	      staticClass: "ods-base"
	    }, [_c('div', {
	      staticClass: "base-ods-row"
	    }, [_c('div', {
	      staticClass: "base-ods-content",
	      on: {
	        "click": function($event) {
	          return _vm.toggleMeta(ods.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "ods-text-container",
	      class: 'cor-' + ods.id
	    }, [_c('div', {
	      staticClass: "ods-id"
	    }, [_vm._v("\n                        " + _vm._s(ods.id) + "\n                    ")]), _vm._v(" "), _c('div', {
	      staticClass: "ods-descricao"
	    }, [_vm._v("\n                        " + _vm._s(ods.descricao) + "\n                    ")])]), _vm._v(" "), _c('div', {
	      staticClass: "ods-img-container",
	      class: 'cor-' + ods.id
	    }, [_c('img', {
	      staticClass: "ods-img",
	      attrs: {
	        "src": _vm.getImageODS(ods.id),
	        "alt": "ODS IMG"
	      }
	    }), _vm._v(" "), _c('img', {
	      staticClass: "ods-carret",
	      class: {
	        'ods-indicador': ods.abrirMeta
	      },
	      attrs: {
	        "src": _vm.getImageODS('caret'),
	        "alt": "ODS IMG"
	      }
	    })])])]), _vm._v(" "), (ods.abrirMeta) ? _c('div', {
	      staticClass: "ods-metas-indicador"
	    }, [_c('i', {
	      staticClass: "fa fa-check-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Metas\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((ods.metas), function(meta) {
	      return (ods.abrirMeta) ? _c('div', {
	        staticClass: "ods-meta-base"
	      }, [_c('div', {
	        staticClass: "base-ods-row"
	      }, [_c('div', {
	        staticClass: "base-ods-content",
	        on: {
	          "click": function($event) {
	            return _vm.toggleIndicador(ods.id, meta.id)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "ods-meta-text-container",
	        class: 'cor-' + ods.id
	      }, [_vm._v("\n                      " + _vm._s(meta.descricao) + "\n                    ")]), _vm._v(" "), _c('label', {
	        staticClass: "ods-check-container",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	          }
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (meta.selecionado),
	          expression: "meta.selecionado"
	        }],
	        staticClass: "ods-check",
	        attrs: {
	          "type": "checkbox"
	        },
	        domProps: {
	          "checked": Array.isArray(meta.selecionado) ? _vm._i(meta.selecionado, null) > -1 : (meta.selecionado)
	        },
	        on: {
	          "change": function($event) {
	            var $$a = meta.selecionado,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = null,
	                $$i = _vm._i($$a, $$v);
	              if ($$el.checked) {
	                $$i < 0 && (_vm.$set(meta, "selecionado", $$a.concat([$$v])))
	              } else {
	                $$i > -1 && (_vm.$set(meta, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	              }
	            } else {
	              _vm.$set(meta, "selecionado", $$c)
	            }
	          }
	        }
	      })])])])]) : _vm._e()
	    })], 2)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "ods-button-cadastro-container"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": _vm.salvarODS
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.editando = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                Cancelar")])])], 2) : _vm._e()], 1), _vm._v(" "), _c('vue-snotify')], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ods-input-container"
	  }, [_vm._v("\n             Selecione as Metas e clique em "), _c('strong', [_vm._v("Salvar")]), _vm._v(" abaixo para definir os favoritos.\n          ")])
	}]}

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Articulações'
	    }
	  }), _vm._v(" "), _c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Parcerias Estratégicas")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Parcerias Estratégicas',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaArticulacoes"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Lista de Instituições "), (!_vm.loading.tela) ? _c('span', {
	    staticClass: "info_discreto"
	  }, [_vm._v(_vm._s(_vm.tabelaArticulacao.totalRows) + " localizado(s)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'edita-articulacao',
	          params: {
	            id: null
	          }
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Instituição ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": _vm.ajustaPesquisa,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.tabelaArticulacao.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.tabelaArticulacao.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 text-right"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.exportarExcel()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Exportar Excel ")])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row box-body"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "hover": "",
	      "bordered": _vm.tabelaArticulacao.bordered,
	      "items": _vm.articulacoes,
	      "fields": _vm.camposArticulacao,
	      "filter": _vm.tabelaArticulacao.filter,
	      "filter-function": _vm.filtroPorItem,
	      "current-page": _vm.tabelaArticulacao.currentPage,
	      "per-page": _vm.tabelaArticulacao.perPage,
	      "sort-by": _vm.tabelaArticulacao.sortBy,
	      "sort-desc": _vm.tabelaArticulacao.sortDesc,
	      "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tabelaArticulacao, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tabelaArticulacao, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tabelaArticulacao, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tabelaArticulacao, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "id",
	      fn: function(row) {
	        return [_vm._v("\n                      " + _vm._s(row.value) + "\n                    ")]
	      }
	    }, {
	      key: "nome",
	      fn: function(row) {
	        return [_vm._v("\n                        " + _vm._s(row.item.dados.nome) + "\n                    ")]
	      }
	    }, {
	      key: "alertas",
	      fn: function(row) {
	        return [(row.value.instrumetosVencer.length === 0 && row.value.instrumentosVencidos.length === 0) ? _c('div', {
	          staticClass: "text-muted"
	        }, [_vm._v("Sem alertas")]) : _c('div', [(row.value.instrumetosVencer.length > 0) ? _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "label label-warning",
	          attrs: {
	            "title": '<h5>Vecimentos em (dias):<li>' + _vm._.join(_vm._.sortBy(_vm._.map(row.value.instrumetosVencer, 'dias')), '<li>') + '</h5>'
	          }
	        }, [_vm._v("\n                          " + _vm._s(row.value.instrumetosVencer.length) + " à vencer\n                        ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), (row.value.instrumentosVencidos.length > 0) ? _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "label label-danger",
	          attrs: {
	            "title": '<h5>Vecidos a (dias):<li>' + _vm._.join(_vm._.sortBy(_vm._.map(row.value.instrumentosVencidos, 'dias')), '<li>') + '</h5>'
	          }
	        }, [_vm._v("\n                          " + _vm._s(row.value.instrumentosVencidos.length) + " vencido " + _vm._s(row.value.instrumentosVencidos.length > 1 ? 's' : '') + "\n                        ")]) : _vm._e()])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-articulacao',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-articulacao',
	                params: {
	                  id: row.item.id,
	                  visualizacao: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Visualizar")])]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.tabelaArticulacao.totalRows,
	      "per-page": _vm.tabelaArticulacao.perPage
	    },
	    model: {
	      value: (_vm.tabelaArticulacao.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tabelaArticulacao, "currentPage", $$v)
	      },
	      expression: "tabelaArticulacao.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "fundao"
	  }, [_c('div', {
	    staticClass: "main-container"
	  }, [_c('div', {
	    staticClass: "main-content"
	  }, [_c('div', {
	    staticClass: "header-container"
	  }, [_c('div', {
	    staticClass: "title-header"
	  }, [_vm._v("\n                        Bem-vindo ao SGP!\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "texto-principal"
	  }, [_c('p', [_vm._v("Parceiro, seu trabalho permite que nosso propósito de "), _c('strong', [_vm._v("“Promover coletivamente caminhos para\ntransformação social e relação sustentável\ncom a Natureza”")]), _vm._v(" de fato se realize! A Fundação BB possui "), _c('b', [_vm._v("Programa de "), _c('b', {
	    staticClass: "compliance"
	  }, [_vm._v("Compliance")]), _vm._v(" e Integridade")]), _vm._v(", embasado na Lei\n                        12.846/2013, e "), _c('strong', [_vm._v("Código  de Ética")]), _vm._v(", que contém balizadores das melhores práticas de ética, compliance e gestão de riscos. Como forma de colaborarmos com seu trabalho e atuarmos na construção de um\n                        país ético e solidário, sugerimos que acesse e conheça estes documentos institucionais e que busque a realização dos treinamentos abaixo.\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "diretoria"
	  }, [_vm._v("Diretoria Executiva da Fundação BB")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('div', {
	    staticClass: "title-button-container"
	  }, [_c('p', {
	    staticClass: "conheca"
	  }, [_vm._v("Conheça nossos documentos institucionais:")]), _vm._v(" "), _c('div', {
	    staticClass: "cta-container"
	  }, [_c('a', {
	    staticClass: "botaoazul",
	    attrs: {
	      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Programa_de_Compliance_e_Integridade_Fundacao_BB.pdf",
	      "target": "_blank"
	    }
	  }, [_c('div', [_vm._v("Programa de "), _c('i', [_vm._v("Compliance")]), _vm._v(" e Integridade")]), _vm._v(" "), _c('img', {
	    staticClass: "icon",
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_integridade.png"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "botaoamarelo",
	    attrs: {
	      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Codigo_de_Etica_Fundacao_BB.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Código de Ética\n                                "), _c('img', {
	    staticClass: "icon",
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_etica.png"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "botaoamarelo",
	    attrs: {
	      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Codigo-de-Governanca-Fundacao-BB.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Código de Governança\n                                "), _c('i', {
	    staticClass: "fa fa-file"
	  })])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "cursos-content"
	  }, [_c('div', {
	    staticClass: "cursosEscolas"
	  }, [_c('div', {
	    staticClass: "containerUnibb"
	  }, [_c('div', {
	    staticStyle: {
	      "background-color": "#002D4B",
	      "width": "300px",
	      "border-radius": "5px"
	    }
	  }, [_c('img', {
	    staticClass: "logo-img",
	    attrs: {
	      "src": "\\static\\img\\DI\\logo_unibb.png"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "blocoCursos"
	  }, [_c('div', {
	    staticClass: "cursos cursoLilas"
	  }, [_c('div', {
	    staticClass: "descricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso"
	  }, [_vm._v("Prevenção e Combate à Corrupção ")]), _vm._v(" "), _c('div', {
	    staticClass: "texto-curso"
	  }, [_vm._v("Identificar situações ou negócios que configurem indícios de corrupção, utilizando a definição dos atos lesivos praticados contra a administração pública, em conformidade com as exigências legais.")])]), _vm._v(" "), _c('a', {
	    staticClass: "botoesCursos",
	    attrs: {
	      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/27/lesson/27/1",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "cursos cursoVerde"
	  }, [_c('div', {
	    staticClass: "descricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso"
	  }, [_vm._v("Empresas e a Prevenção à Corrupção")]), _vm._v(" "), _c('div', {
	    staticClass: "texto-curso"
	  }, [_vm._v("Identificar elementos que compõe os diversos aspectos de integridade nas empresas e mecanismos para fortalecê-los dentro da cultura corporativa.\n                               ")])]), _vm._v(" "), _c('a', {
	    staticClass: "botoesCursos",
	    attrs: {
	      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/35/lesson/35/1",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "cursos cursoRosa"
	  }, [_c('div', {
	    staticClass: "descricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso"
	  }, [_vm._v("Ação Voluntária: Gestão Financeira")]), _vm._v(" "), _c('div', {
	    staticClass: "texto-curso"
	  }, [_vm._v("Identificar conceitos e instrumentos de gestão financeira que serão utilizadas em organizações do Terceiro Setor.")])]), _vm._v(" "), _c('a', {
	    staticClass: "botoesCursos",
	    attrs: {
	      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/46/lesson/46/1",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "cursos cursoLilas"
	  }, [_c('div', {
	    staticClass: "descricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso"
	  }, [_vm._v("Ação Voluntária: Elaboração e Gestão de Projetos Sociais e Captação de Recursos")]), _vm._v(" "), _c('div', {
	    staticClass: "texto-curso"
	  }, [_vm._v("Identificar a metodologia de elaboração de projetos, assim como as estratégias de captação de recursos para o Terceiro Setor. ")])]), _vm._v(" "), _c('a', {
	    staticClass: "botoesCursos",
	    attrs: {
	      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/45/lesson/45/1",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "cursos cursoCinza"
	  }, [_c('div', {
	    staticClass: "descricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso"
	  }, [_vm._v("Introdução a Mercados de Carbono")]), _vm._v(" "), _c('div', {
	    staticClass: "texto-curso"
	  }, [_vm._v("Entender conceitos básicos de mudança do clima e mercados de carbono no contexto de mitigação climática.")])]), _vm._v(" "), _c('a', {
	    staticClass: "botoesCursos",
	    attrs: {
	      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/66/lesson/66/1",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "containerEscola"
	  }, [_c('div', {
	    staticClass: "titulos"
	  }, [_c('img', {
	    staticClass: "logo-escola",
	    attrs: {
	      "src": "\\static\\img\\DI\\outros_cursos_logo.png"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "blocoCursos"
	  }, [_c('div', {
	    staticClass: "escola-aberta-cursos"
	  }, [_c('div', {
	    staticClass: "escola escolaLilas"
	  }, [_c('div', {
	    staticClass: "escolaDescricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso-escola"
	  }, [_vm._v("Governança no Terceiro Setor")])]), _vm._v(" "), _c('a', {
	    staticClass: "botaoEscola",
	    attrs: {
	      "href": "https://www.sebrades.com.br/sebrades-cursos/governanca-no-terceiro-setor/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "escola escolaRosa"
	  }, [_c('div', {
	    staticClass: "escolaDescricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso-escola"
	  }, [_vm._v("ESG e os Objetivos do Desenvolvimento Sustentável")])]), _vm._v(" "), _c('a', {
	    staticClass: "botaoEscola",
	    attrs: {
	      "href": "https://www.escolaaberta3setor.org.br/sebrades-cursos/esg-e-os-objetivos-do-desenvolvimento-sustentavel/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "escola cursoVerde"
	  }, [_c('div', {
	    staticClass: "escolaDescricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso-escola"
	  }, [_vm._v("ESG, o que todo profissional deve saber")])]), _vm._v(" "), _c('a', {
	    staticClass: "botaoEscola",
	    attrs: {
	      "href": "https://inbs.com.br/cursos/esg-o-que-todo-profissional-deve-saber/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "escola cursoCinza"
	  }, [_c('div', {
	    staticClass: "escolaDescricao"
	  }, [_c('div', {
	    staticClass: "titulo-curso-escola"
	  }, [_vm._v("Prevenção à lavagem de dinheiro e ao financiamento do terrorismo")])]), _vm._v(" "), _c('a', {
	    staticClass: "botaoEscola",
	    attrs: {
	      "href": "https://www.escolavirtual.gov.br/curso/217",
	      "target": "_blank"
	    }
	  }, [_vm._v("Acessar "), _c('img', {
	    attrs: {
	      "src": "\\static\\img\\DI\\icone_acessar.png"
	    }
	  })])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "aviso"
	  }, [_c('div', [_vm._v("Clique nos cursos acima e efetue o treinamento. Encaminhe sua experiência sobre os treinamentos para nosso e-mail: "), _c('a', {
	    attrs: {
	      "href": "mailto:controles@fbb.org.br",
	      "target": "_blank"
	    }
	  }, [_vm._v("controles@fbb.org.br.")])]), _vm._v(" "), _c('div', [_vm._v("Canal de Denúncias BB, Fale Conosco e LGPD: "), _c('a', {
	    attrs: {
	      "href": "https://fbb.org.br/pt-br/falaconosco2",
	      "target": "_blank"
	    }
	  }, [_vm._v("clique aqui.")])])])])])
	}]}

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Tipo de Documentos")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Documentos',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
	    attrs: {
	      "name": "frmRegNotice",
	      "novalidate": "",
	      "_lpchecked": "1"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('nomeDocumento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nomeDocumento"
	    }
	  }, [_vm._v("Nome do Documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.ds_tipo),
	      expression: "documento.ds_tipo"
	    }],
	    staticClass: "form-control ng-pristine ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required ng-touched",
	    staticStyle: {
	      "background-image": "url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4EaVTO26DQBD1ohQWaS2lg9JybZ+AK7hNwx2oIoVf4UPQ0Lj1FdKktevIpel8AKNUkDcWMxpgSaIEaTVv3sx7uztiTdu2s/98DywOw3Dued4Who/M2aIx5lZV1aEsy0+qiwHELyi+Ytl0PQ69SxAxkWIA4RMRTdNsKE59juMcuZd6xIAFeZ6fGCdJ8kY4y7KAuTRNGd7jyEBXsdOPE3a0QGPsniOnnYMO67LgSQN9T41F2QGrQRRFCwyzoIF2qyBuKKbcOgPXdVeY9rMWgNsjf9ccYesJhk3f5dYT1HX9gR0LLQR30TnjkUEcx2uIuS4RnI+aj6sJR0AM8AaumPaM/rRehyWhXqbFAA9kh3/8/NvHxAYGAsZ/il8IalkCLBfNVAAAAABJRU5ErkJggg==\")",
	      "background-repeat": "no-repeat",
	      "background-attachment": "scroll",
	      "background-size": "16px 18px",
	      "background-position": "98% 50%"
	    },
	    attrs: {
	      "name": "nomeDocumento",
	      "type": "text",
	      "minlength": "1",
	      "ng-maxlength": "255",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.documento.ds_tipo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.documento, "ds_tipo", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nomeDocumento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nomeDocumento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('dataInicial')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "dataInicial"
	    }
	  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.documento.dt_data_inclusao),
	      callback: function($$v) {
	        _vm.$set(_vm.documento, "dt_data_inclusao", $$v)
	      },
	      expression: "documento.dt_data_inclusao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('dataInicial')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataInicial')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "dataFinal"
	    }
	  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataFinal",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.documento.dt_data_vigencia),
	      callback: function($$v) {
	        _vm.$set(_vm.documento, "dt_data_vigencia", $$v)
	      },
	      expression: "documento.dt_data_vigencia"
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Documentos")])])
	}]}

/***/ }),
/* 1891 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [(!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Adiciona um endereço",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onNew()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo endereço")]), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_insercao",
	    attrs: {
	      "title": '<h5>Inclusões: ' + _vm.inclEndTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a inserção de novo(s) endereço(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_exclusao",
	    attrs: {
	      "title": '<h5>Exclusões: ' + _vm.excEndTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a exclusão de endereço(s)")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    ref: "listagem",
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "bt_principal",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-star ', row.value ? 'text-yellow' : 'text-gray'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "ds_cep",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("cep")(row.value)))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.disable) ? _c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Detalhar")])], 1) : _c('div', [(_vm.indiceAlt == row.index && _vm.mostraAlteracao === true && _vm.mostraInclusao === false) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'left'
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
	          }],
	          staticClass: "fa fa-warning indicador_alteracao",
	          attrs: {
	            "title": '<h5>Clique em editar para ver as mudanças.</h5>'
	          }
	        }) : _vm._e(), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.exclui(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }])
	  })], 1)], 1)])])]), _vm._v(" "), (_vm.state === 'FORM') ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    },
	    attrs: {
	      "name": "frmAddAddress"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CEP')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_cep')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_cep + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n          CEP:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|max:8'),
	      expression: "'required|min:8|max:8'"
	    }],
	    ref: "CEP",
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP",
	      "type": "text",
	      "mask": "#####-###",
	      "disabled": _vm.disable
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.buscaCEP($event)
	      }
	    },
	    model: {
	      value: (_vm.endereco.ds_cep),
	      callback: function($$v) {
	        _vm.$set(_vm.endereco, "ds_cep", $$v)
	      },
	      expression: "endereco.ds_cep"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP')))]) : _vm._e(), _vm._v(" "), (_vm.endereco.name) ? _c('div', {
	    staticClass: "col-md-4 col-lg-3",
	    staticStyle: {
	      "padding": "7px"
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Endereço')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Endereço"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_rua')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_rua + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n          Endereço:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.endereco.ds_rua),
	      expression: "endereco.ds_rua"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:100'),
	      expression: "'required|min:1|max:100'"
	    }],
	    ref: "Endereço",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço",
	      "type": "text",
	      "disabled": _vm.disable
	    },
	    domProps: {
	      "value": (_vm.endereco.ds_rua)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.endereco, "ds_rua", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Endereço é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Número"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_numero')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_numero + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n          Número:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.endereco.ds_numero),
	      expression: "endereco.ds_numero"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:26'),
	      expression: "'max:26'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Número",
	      "type": "text",
	      "disabled": _vm.disable
	    },
	    domProps: {
	      "value": (_vm.endereco.ds_numero)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.endereco, "ds_numero", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('number')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Limite de 26 caracteres excedido')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Complemento"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_complemento') || _vm._.hasIn(_vm.mudancas, '0.ds_complemento')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_complemento + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n          Complemento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.endereco.ds_complemento),
	      expression: "endereco.ds_complemento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:200'),
	      expression: "'max:200'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Complemento",
	      "type": "text",
	      "disabled": _vm.disable
	    },
	    domProps: {
	      "value": (_vm.endereco.ds_complemento)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.endereco, "ds_complemento", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Complemento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Limite de 200 caracteres excedido')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Bairro"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_bairro')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_bairro + '</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n          Bairro:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.endereco.ds_bairro),
	      expression: "endereco.ds_bairro"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:75'),
	      expression: "'max:75'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Bairro",
	      "type": "text",
	      "disabled": _vm.disable
	    },
	    domProps: {
	      "value": (_vm.endereco.ds_bairro)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.endereco, "ds_bairro", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Bairro')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Limite de 75 caracteres excedido')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "city"
	    }
	  }, [_vm._v("Cidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.endereco.ds_cidade),
	      expression: "endereco.ds_cidade"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "city",
	      "type": "text",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.endereco.ds_cidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.endereco, "ds_cidade", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "state"
	    }
	  }, [_vm._v("UF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.endereco.ds_estado),
	      expression: "endereco.ds_estado"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:2'),
	      expression: "'max:2'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "state",
	      "type": "text",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.endereco.ds_estado)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.endereco, "ds_estado", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('label', {
	    staticClass: "new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.endereco.bt_principal),
	      expression: "endereco.bt_principal"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.disable,
	      "value": "true"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.endereco.bt_principal) ? _vm._i(_vm.endereco.bt_principal, "true") > -1 : (_vm.endereco.bt_principal)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.endereco.bt_principal,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "true",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.endereco, "bt_principal", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.endereco, "bt_principal", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.endereco, "bt_principal", $$c)
	        }
	      }, function($event) {
	        return _vm.verificaPrincipal(_vm.endereco)
	      }]
	    }
	  }), _vm._v("Endereço principal\n            "), _c('div', {
	    staticClass: "fa-lg"
	  }, [(_vm._.hasIn(_vm.mudancas, 'bt_principal')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_principal + '</h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "disabled": _vm.jaExiste === 1,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.frmAddAddress)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar Endereço")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onCancel(_vm.frmAddAddress)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    class: _vm.propsNumeroProjeto ? '' : 'box',
	    attrs: {
	      "id": "gestao_atividades"
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.carregando),
	      expression: "loading.carregando"
	    }],
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando barras de tempo das atividades...")]), _vm._v(" "), (!_vm.propsNumeroProjeto) ? _c('div', {
	    staticClass: "box-header"
	  }, [(_vm.listaProjetos.length > 1) ? _c('span', [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.numeroProjetoSelecionado),
	      expression: "configuracoes.numeroProjetoSelecionado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "projeto",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.configuracoes, "numeroProjetoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.selecionaProjeto]
	    }
	  }, _vm._l((_vm.listaProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.ds_codigo_projeto_erp,
	        "selected": projeto.ds_codigo_projeto_erp === _vm.configuracoes.numeroProjetoSelecionado
	      }
	    }, [_vm._v(_vm._s(projeto.ds_codigo_projeto_erp) + " - " + _vm._s(projeto.ds_nome) + " ("), _c('b', [_vm._v(_vm._s(projeto.ds_situacao_erp))]), _vm._v(")")])
	  }), 0)])])])]) : (_vm.listaProjetos.length === 1) ? _c('span', [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.listaProjetos[0].numero) + " - " + _vm._s(_vm.listaProjetos[0].nome))])]) : _c('span', [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Carregando projeto(s) ...")])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.projeto)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.processando),
	      expression: "loading.processando"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "z-index": "2000",
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (!_vm.loading.carregando) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    attrs: {
	      "id": "gantt"
	    }
	  }, [_c('div', {
	    style: ('height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + (58 + 30) + ((_vm._.get(_vm._.find(_vm.atividades, ['expandir', true]), 'itens', [])).length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px;'),
	    attrs: {
	      "id": "secao_gantt"
	    }
	  }, [(_vm.configuracoes.mostrarGrade) ? _c('div', {
	    style: ('margin-left: ' + (_vm.configuracoes.larguraCabecalho + 5) + 'px;' +
	      'width: ' + ((_vm.configuracoes.larguraPadrao * _vm.projeto.periodos) + 150) + 'px;' +
	      'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 30) + 'px;'),
	    attrs: {
	      "id": "grade_meses"
	    }
	  }, [(_vm.configuracoes.mostrarHoje && _vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) <= (_vm.projeto.periodos + 1)) ? _c('div', {
	    ref: "HOJE",
	    staticClass: "linha_hoje",
	    style: ('margin-left: ' + (((_vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) - 1) * _vm.configuracoes.larguraPadrao) + ((_vm.configuracoes.larguraPadrao * _vm.hoje.getDate()) / 30)) + 'px;' +
	      'height:' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 20 + ((_vm._.get(_vm._.find(_vm.atividades, ['expandir', true]), 'itens', [])).length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px')
	  }, [_c('i', {
	    staticClass: "fa fa-sun-o"
	  }), _vm._v(" Hoje\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.projeto.periodos), function(p) {
	    return _c('div', {
	      staticClass: "periodo_mes",
	      style: ('width: ' + (_vm.configuracoes.larguraPadrao) + 'px;' +
	        'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 30 + ((_vm._.get(_vm._.find(_vm.atividades, ['expandir', true]), 'itens', [])).length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px;' +
	        'margin-left: ' + ((p - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        (p === 1 ? 'border-left: 1px solid var(--cor-borda);' : ''))
	    }, [(_vm.configuracoes.mostrarGanttPorMes && (_vm.pendenciasPorPeriodo(p)).length > 0 && !_vm.modoEdicao) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: false,
	          duration: 0,
	          animation: 'fade',
	          size: 'large',
	          arrow: true,
	          theme: 'light',
	          placement: 'bottom',
	          followCursor: true,
	          distance: 40
	        }),
	        expression: "{inertia: false, duration: 0, animation: 'fade', size: 'large', arrow: true, theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
	      }],
	      staticClass: "periodo_mes_selecionado",
	      attrs: {
	        "title": '<h5>Previsto para <b>' + _vm.periodoParaMesAno(p, _vm.projeto.inicio, 'MMMM/YYYY') + '</b>' +
	          '<hr/>' +
	          _vm.exibirInformacaoSeHouver('Mandato', 'Mandatos', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
	            return m.grupo === 'Mandato' ? 1 : 0
	          })) +
	          _vm.exibirInformacaoSeHouver('Relatório de Execução', 'Relatórios de Execução', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
	            return m.grupo === 'Relatório de Execução' ? 1 : 0
	          })) +
	          _vm.exibirInformacaoSeHouver('Item do Orçamento previsto', 'Itens do Orçamento previstos', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
	            return m.grupo === 'Item Orçamento' ? 1 : 0
	          })) +
	
	          '<hr/>' +
	          _vm.exibirInformacaoSeHouver('Orçado', 'Orçado', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
	            return m.grupo === 'Item Orçamento' ? parseFloat(m.info3) : 0
	          })) +
	          _vm.exibirInformacaoSeHouver('Executado', 'Executado', _vm._.sumBy(_vm.pendenciasPorPeriodo(p), function(m) {
	            return m.grupo === 'Item Orçamento' ? parseFloat(m.info4) : 0
	          })) +
	          '</h5>'
	      },
	      on: {
	        "click": function($event) {
	          _vm.mostrarPendenciaAnoMes(_vm.periodoParaMesAno(p, _vm.projeto.inicio, 'YYYY'), _vm.periodoParaMesAno(p, _vm.projeto.inicio, 'MM - MMMM'))
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      style: ('width: ' + (_vm.configuracoes.larguraPadrao) + 'px;' +
	        (_vm.configuracoes.mostrarGanttPorMes && (_vm.pendenciasPorPeriodo(p)).length > 0 ? 'font-weight: bold;' : ''))
	    }, [_vm._v("\n                    " + _vm._s(p) + "\n                  ")])])
	  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.configuracoes.mostrarRecursoMensal), function(origem) {
	    return (_vm.configuracoes.mostrarOrcadoMensal) ? _c('div', [(_vm.propsAtividades && !_vm._.isEmpty(_vm.periodosOrcamento) && true) ? _c('div', {
	      style: ('margin-left: ' + (_vm.configuracoes.larguraCabecalho + 5) + 'px;' +
	        'width: ' + ((_vm.configuracoes.larguraPadrao * _vm.projeto.periodos) + 150) + 'px;' +
	        'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 30) + 'px;' +
	        'position: absolute; z-index: 1000; top: 20px;')
	    }, _vm._l((_vm.projeto.periodos), function(p) {
	      return _c('div', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: false,
	            arrow: true,
	            duration: 0,
	            animation: 'fade',
	            size: 'large',
	            theme: 'light',
	            placement: 'top',
	            distance: 10
	          }),
	          expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'top', distance: 10}"
	        }],
	        class: 'recurso_' + origem + '_mes',
	        style: ('width: ' + (_vm.configuracoes.larguraPadrao) + 'px;' +
	          'height: ' + (parseInt(((_vm._.get(_vm.periodosOrcamento, [origem, p], 0) * (_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) / _vm._.max(_vm._.get(_vm.periodosOrcamento, [origem], 0))))) + 'px;' +
	          'margin-left: ' + ((p - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	          (p === 1 ? 'border-left: 1px solid var(--cor-borda);' : '')),
	        attrs: {
	          "title": '<h5>R$ ' + (parseInt(_vm._.get(_vm.periodosOrcamento, [origem, p], 0) / 1000)) + ' mil</h5>'
	        }
	      })
	    }), 0) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), _c('div', {
	    style: ('width: ' + (_vm.configuracoes.larguraCabecalho) + 'px;' +
	      'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px;'),
	    attrs: {
	      "id": "cabecalho_atividades"
	    }
	  }, _vm._l((_vm.atividades), function(atividade) {
	    return _c('div', {
	      staticClass: "nome_atividade truncar",
	      style: ('height: ' + (_vm.configuracoes.altura + (atividade.expandir ? (atividade.itens.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) : 0)) + 'px;' +
	        (_vm.configuracoes.altura < 20 ? 'font-size: x-small;' : '') +
	        'padding-top: ' + ((_vm.configuracoes.altura / 4) - 5) + 'px;' +
	        'margin-bottom: ' + (_vm.configuracoes.espacamento) + 'px;')
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: false,
	          arrow: true,
	          duration: 0,
	          animation: 'fade',
	          size: 'large',
	          theme: 'light',
	          placement: 'bottom',
	          followCursor: true,
	          distance: 40
	        }),
	        expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
	      }],
	      style: ('margin-bottom: ' + (_vm.configuracoes.altura / 4) + 'px;'),
	      attrs: {
	        "title": '<h5>' + atividade.descricao + '</h5>'
	      }
	    }, [_vm._v("\n                    " + _vm._s(atividade.descricao) + "\n                  ")]), _vm._v(" "), _vm._l((atividade.itens), function(item) {
	      return (atividade.expandir) ? _c('div', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: false,
	            arrow: true,
	            duration: 0,
	            animation: 'fade',
	            size: 'large',
	            theme: 'light',
	            placement: 'bottom',
	            followCursor: true,
	            distance: 40
	          }),
	          expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
	        }],
	        staticClass: "nome_item_despesa truncar",
	        style: ('height: ' + (_vm.configuracoes.altura) + 'px;' +
	          (_vm.configuracoes.altura < 20 ? 'font-size: x-small;' : '') +
	          'padding-top: ' + ((_vm.configuracoes.altura / 4) - 5) + 'px;' +
	          'margin-bottom: ' + (_vm.configuracoes.espacamento) + 'px;'),
	        attrs: {
	          "title": '<h5>' + item.fk_itens + '<br/>' + item.observacao + '</h5>'
	        }
	      }, [(_vm._.includes(('' + item.id), 'novo')) ? _c('span', {
	        staticClass: "label label-info"
	      }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), _c('span', {
	        style: ((!_vm._.includes(('' + item.id), 'novo') ? 'margin-left: 35px;' : '') + (_vm._.get(_vm.itemAtividadeEditando, 'id', 0) === item.id ? 'color: red' : ''))
	      }, [_vm._v(_vm._s(item.fk_itens) + " - " + _vm._s(item.observacao))])]) : _vm._e()
	    })], 2)
	  }), 0), _vm._v(" "), _c('div', {
	    style: ('margin-left: ' + (_vm.configuracoes.larguraCabecalho + 5) + 'px;' +
	      'width: ' + (_vm.configuracoes.larguraPadrao * _vm.projeto.periodos) + 'px;' +
	      'height: ' + ((_vm.atividades.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + ((_vm._.get(_vm._.find(_vm.atividades, ['expandir', true]), 'itens', [])).length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento))) + 'px'),
	    attrs: {
	      "id": "grafico_gantt"
	    }
	  }, _vm._l((_vm.atividades), function(atividade) {
	    return _c('div', {
	      staticClass: "atividade_projeto",
	      style: ('height: ' + (_vm.configuracoes.altura + (atividade.expandir ? (atividade.itens.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) : 0)) + 'px;' +
	        'margin-bottom: ' + (_vm.configuracoes.espacamento) + 'px;')
	    }, [(!atividade.expandir) ? _c('div', {
	      staticClass: "barra_execucao",
	      style: ('width: ' + (
	          ((atividade.termino - atividade.inicio + 1) * _vm.configuracoes.larguraPadrao) *
	          (atividade.executado / atividade.orcado)
	        ) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura) + 'px;' +
	        'margin-left: ' + ((atividade.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;')
	    }) : _vm._e(), _vm._v(" "), (!atividade.expandir) ? _c('div', {
	      staticClass: "barra_orcado",
	      style: ('width: ' + ((atividade.termino - atividade.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura) + 'px;' +
	        'margin-left: ' + ((atividade.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        (atividade.orcado > 0 && _vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) > atividade.termino && _vm.percentual(atividade.executado, atividade.orcado) < 100 ? 'background: #ffc8c8;' : ''))
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "info_externo",
	      style: ('margin-left: ' + ((atividade.termino) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        (_vm.configuracoes.altura < 20 ? 'font-size: x-small;' : '') +
	        'padding-top: ' + ((_vm.configuracoes.altura / 4) - 5) + 'px;')
	    }, [(_vm.modoEdicao) ? _c('span', [(false) ? _c('span', {
	      staticClass: "botao_acao_desfazer",
	      on: {
	        "click": function($event) {
	          return _vm.reverterAlteracaoAtividade(atividade.id)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-refresh"
	    }), _vm._v("\n                          " + _vm._s(_vm.verificaAlteracaoPeriodoAtividadeItem(atividade.id)) + "\n                        ")]) : _vm._e()]) : (_vm.configuracoes.mostrarInfoExterno) ? _c('span', [_vm._v("\n                      " + _vm._s(atividade.orcado > 0 ? _vm.percentual(atividade.executado, atividade.orcado) + '%' : '') + "\n                    ")]) : _vm._e()]), _vm._v(" "), (!atividade.expandir) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: false,
	          arrow: true,
	          duration: 0,
	          animation: 'fade',
	          size: 'large',
	          theme: 'light',
	          placement: 'bottom',
	          followCursor: true,
	          distance: 40
	        }),
	        expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
	      }],
	      staticClass: "barra_atividade",
	      style: ('width: ' + ((atividade.termino - atividade.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura) + 'px;' +
	        'margin-left: ' + ((atividade.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        (_vm.modoEdicao && !atividade.expandir && _vm._.find(_vm.atividades, ['expandir', true]) ? 'background: rgba(255, 255, 255, 0.75);' : '') +
	        (_vm.modoEdicao ? 'cursor: pointer;' : '')),
	      attrs: {
	        "title": '<h5>' + atividade.descricao + '<br/>' +
	          (atividade.orcado > 0 ?
	            '<hr/>' +
	            'Orçado <b>' + (_vm.moeda(atividade.orcado)) + '</b><br/><br/>' +
	            'Executado <b>' + (_vm.moeda(atividade.executado)) + '</b><br/><br/>' +
	            '% liberado de <b>' + (_vm.percentual(atividade.executado, atividade.orcado)) + '%</b>' : '') +
	          '</h5>'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.expandirAtividade(atividade)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (atividade.expandir) ? _c('div', {
	      staticClass: "barra_detalhamento",
	      style: ('width: ' + ((atividade.termino - atividade.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura + (atividade.expandir ? (atividade.itens.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) : 0)) + 'px;' +
	        'margin-left: ' + ((atividade.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        (_vm.modoEdicao ? 'cursor: pointer;' : '')),
	      on: {
	        "click": function($event) {
	          return _vm.expandirAtividade(atividade)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "barra_grafico_totais_periodo",
	      style: ('height: ' + _vm.configuracoes.altura + 'px;')
	    }, _vm._l((_vm._.range(atividade.inicio, atividade.termino + 1)), function(ctp) {
	      return _c('div', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: false,
	            arrow: true,
	            duration: 0,
	            animation: 'fade',
	            size: 'large',
	            theme: 'light',
	            placement: 'bottom',
	            followCursor: true,
	            distance: 40
	          }),
	          expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
	        }],
	        staticClass: "coluna_totais_periodo",
	        style: ('width: ' + _vm.configuracoes.larguraPadrao + 'px;' +
	          'height: ' + _vm.configuracoes.altura + 'px;'),
	        attrs: {
	          "title": '<h5>Período <b>' + ctp + '</b> ( ' + _vm.periodoParaMesAno(ctp, _vm.projeto.inicio, 'MMMM/YYYY') + ' )<br/><br/>' +
	            (_vm._.get(atividade, ['mensalizacao', ctp, 1], 0) === 0 ? '' : 'Recursos FBB <b>' + (_vm.moeda(_vm._.get(atividade, ['mensalizacao', ctp, 1], 0))) + '</b><br/><br/>') +
	            (_vm._.get(atividade, ['mensalizacao', ctp, 2], 0) === 0 ? '' : 'Contrapartida <b>' + (_vm.moeda(_vm._.get(atividade, ['mensalizacao', ctp, 2], 0))) + '</b><br/><br/>') +
	            (_vm._.get(atividade, ['mensalizacao', ctp, 1], 0) > 0 && _vm._.get(atividade, ['mensalizacao', ctp, 2], 0) > 0 ? 'Total <b>' + (_vm.moeda(_vm._.get(atividade, ['mensalizacao', ctp, 0], 0))) + '</b>' : '') +
	            '</h5>'
	        }
	      }, [_c('div', {
	        staticClass: "acumulado_periodo_contrapartida",
	        style: ('height: ' + (Math.ceil(Math.abs((_vm._.get(atividade, ['mensalizacao', ctp, 2], 0) / atividade.orcado) * _vm.configuracoes.altura))) + 'px;')
	      }), _vm._v(" "), _c('div', {
	        staticClass: "acumulado_periodo_fbb",
	        style: ('height: ' + (Math.ceil(Math.abs((_vm._.get(atividade, ['mensalizacao', ctp, 1], 0) / atividade.orcado) * _vm.configuracoes.altura))) + 'px;')
	      })])
	    }), 0)]) : _vm._e(), _vm._v(" "), (atividade.expandir) ? _c('div', {
	      staticClass: "itens_atividade",
	      style: ('height: ' + (atividade.itens.length * (_vm.configuracoes.altura + _vm.configuracoes.espacamento)) + 'px;' +
	        'margin-top: ' + (_vm.configuracoes.altura + 2) + 'px;')
	    }, _vm._l((atividade.itens), function(item) {
	      return _c('div', [_c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm._.get(_vm.itemAtividadeEditando, 'id', 0) !== item.id),
	          expression: "_.get(itemAtividadeEditando, 'id', 0) !== item.id"
	        }, {
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: false,
	            arrow: true,
	            duration: 0,
	            animation: 'fade',
	            size: 'large',
	            theme: 'light',
	            placement: 'bottom',
	            followCursor: true,
	            distance: 40
	          }),
	          expression: "{inertia: false, arrow: true, duration: 0, animation: 'fade', size: 'large', theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
	        }],
	        class: 'truncar barra_item ' + ('' + item.origem === '2' ? 'item_contrapartida' : 'item_produto_servico'),
	        style: ('width: ' + ((item.periodo_final - item.periodo_inicial + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	          'height: ' + (_vm.configuracoes.altura) + 'px;' +
	          'margin-left: ' + ((item.periodo_inicial - 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	          (_vm.configuracoes.altura < 20 ? 'font-size: x-small;' : '') +
	          (_vm.modoEdicao ? 'cursor: pointer;' : '') +
	          (item.valorSaldo <= 0 ? ('' + item.origem === '2' ? 'background: mediumseagreen;' : 'background: cornflowerblue;') : '') +
	          'padding-top: ' + ((_vm.configuracoes.altura / 4) - 5) + 'px;' +
	          'margin-bottom: ' + (_vm.configuracoes.espacamento) + 'px;'),
	        attrs: {
	          "title": '<h5>' + item.fk_itens + ' - ' + item.observacao + '<br/><br/>' +
	            'Orçado <b>' + (_vm.moeda(item.valorOrcado)) + '</b><br/><br/>' +
	            'Saldo <b>' + (_vm.moeda(item.valorSaldo)) + '</b><br/><br/>' +
	            '% liberado de <b>' + (_vm.percentual(item.valorOrcado - item.valorSaldo, item.valorOrcado)) + '%</b>' +
	            '</h5>'
	        },
	        on: {
	          "click": function($event) {
	            _vm.itemAtividadeEditando = _vm.modoEdicao && atividade.executado < atividade.orcado ? _vm._.clone(item) : {}
	          }
	        }
	      }, [_vm._v("\n\n                        " + _vm._s(item.fk_itens) + " - " + _vm._s(item.observacao) + "\n                      ")]), _vm._v(" "), (_vm.modoEdicao && !_vm._.isNull(_vm.itemAtividadeEditando) && _vm.itemAtividadeEditando.id === item.id) ? _c('div', {
	        staticClass: "slider_alteracao_item_atividade",
	        style: ('width: ' + ((_vm.atividadeEditando.termino - _vm.atividadeEditando.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	          'height: ' + (_vm.configuracoes.altura) + 'px;' +
	          'margin-left: ' + ((_vm.atividadeEditando.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;')
	      }, [_c('div', {
	        staticClass: "barra_editando",
	        style: ('width: ' + ((_vm.atividadeEditando.termino - _vm.atividadeEditando.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	          'height: ' + (_vm.configuracoes.altura) + 'px;' +
	          'margin-left: ' + ((_vm.atividadeEditando.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;')
	      }), _vm._v(" "), _c('vue-slider', {
	        attrs: {
	          "lazy": true,
	          "process": true,
	          "adsorb": true,
	          "enable-cross": false,
	          "tooltip": 'always',
	          "tooltip-formatter": function (periodo) { return _vm.periodoParaMesAno(periodo, _vm.projeto.inicio, 'MMMM/YYYY'); },
	          "min": _vm.atividadeEditando.inicio,
	          "max": _vm.atividadeEditando.termino
	        },
	        on: {
	          "change": _vm.okAlteracaoItem
	        },
	        model: {
	          value: (_vm.itemAtividadeEditando.periodo),
	          callback: function($$v) {
	            _vm.$set(_vm.itemAtividadeEditando, "periodo", $$v)
	          },
	          expression: "itemAtividadeEditando.periodo"
	        }
	      })], 1) : _vm._e()])
	    }), 0) : _vm._e(), _vm._v(" "), (_vm.modoEdicao && !_vm._.isNull(_vm.atividadeEditando) && _vm.atividadeEditando.id === atividade.id) ? _c('div', {
	      staticClass: "slider_alteracao_atividade",
	      style: ('height: ' + (_vm.configuracoes.altura) + 'px;')
	    }, [_c('div', {
	      staticClass: "barra_editando",
	      style: ('width: ' + ((_vm.atividadeEditando.termino - _vm.atividadeEditando.inicio + 1) * _vm.configuracoes.larguraPadrao) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura) + 'px;' +
	        'margin-left: ' + ((_vm.atividadeEditando.inicio - 1) * _vm.configuracoes.larguraPadrao) + 'px;')
	    }), _vm._v(" "), _c('vue-slider', {
	      attrs: {
	        "lazy": true,
	        "process": false,
	        "adsorb": true,
	        "enable-cross": false,
	        "tooltip": 'always',
	        "tooltip-formatter": function (periodo) { return _vm.periodoParaMesAno(periodo, _vm.projeto.inicio, 'MMMM/YYYY'); },
	        "min": 1,
	        "max": _vm.projeto.periodos
	      },
	      on: {
	        "change": _vm.okAlteracaoAtividade
	      },
	      model: {
	        value: (_vm.atividadeEditando.periodo),
	        callback: function($$v) {
	          _vm.$set(_vm.atividadeEditando, "periodo", $$v)
	        },
	        expression: "atividadeEditando.periodo"
	      }
	    })], 1) : _vm._e()])
	  }), 0)], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.mostrarLegenda && !_vm.loading.carregando) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', [_c('tr', [_c('td', {
	    staticClass: "legenda_etiqueta realce"
	  }, [_vm._v("Legendas")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "background": "#dfe4eb"
	    },
	    attrs: {
	      "title": '<h5>Barra que representa o início e término da atividade do projeto</h5>'
	    }
	  }, [_vm._v("Atividade do projeto")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "background": "var(--cor-destaque)"
	    },
	    attrs: {
	      "title": '<h5>Esta cor na barra representa o percentual já liberado em recursos financeiros dos itens da atividade</h5>'
	    }
	  }, [_vm._v("Liberado")])])])]) : _vm._e(), _vm._v(" "), (_vm.modoEdicao) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [( false) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "row well well-sm no-shadow"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Atividade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_vm._v(_vm._s(_vm.atividadeEditando.descricao))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Alterar período para:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.atividadeEditando.inicio))]), _vm._v(" até\n                  "), _c('strong', [_vm._v(_vm._s(_vm.atividadeEditando.termino))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.okAlteracaoAtividade
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancelaAlteracao
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'justificativa')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "row well well-sm no-shadow"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.alteracao.justificativa),
	      expression: "alteracao.justificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa",
	      "placeholder": "Descreva justificativa",
	      "rows": "3",
	      "data-vv-as": "Justificativa"
	    },
	    domProps: {
	      "value": (_vm.alteracao.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.alteracao, "justificativa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-offset-2 col-md-10"
	  }, [(_vm.alteracao.alterados.length > 0) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.alteracao.alterados.length))]), _vm._v(" atividades alteradas\n                  ")]) : _vm._e()])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'opcoes') && !_vm.loading.carregando) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "opcoes",
	    on: {
	      "click": function($event) {
	        _vm.configuracoes.mostrarOpcoes = !_vm.configuracoes.mostrarOpcoes;
	        _vm.salvarConfiguracoes()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" Opções\n        ")]), _vm._v(" "), (_vm.editavel) ? _c('div', {
	    staticClass: "opcoes",
	    on: {
	      "click": function($event) {
	        return _vm.modoEdicaoEntrarSair(!_vm.modoEdicao)
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-' + (!_vm.modoEdicao ? 'pencil-square-o' : 'eye')
	  }), _vm._v(" " + _vm._s(!_vm.modoEdicao ? 'Editar' : 'Visualizar') + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.configuracoes.mostrarOpcoes),
	      expression: "configuracoes.mostrarOpcoes"
	    }],
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Zoom períodos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('vue-slider', {
	    attrs: {
	      "min": 20,
	      "max": 60,
	      "interval": 1,
	      "hide-label": true,
	      "tooltip": 'none',
	      "drag-on-click": true
	    },
	    on: {
	      "drag-end": _vm.salvarConfiguracoes
	    },
	    scopedSlots: _vm._u([{
	      key: "process",
	      fn: function() {
	        return [_c('div', {
	          staticClass: "escalaZoom"
	        })]
	      },
	      proxy: true
	    }], null, false, 4023097680),
	    model: {
	      value: (_vm.configuracoes.larguraPadrao),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracoes, "larguraPadrao", $$v)
	      },
	      expression: "configuracoes.larguraPadrao"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Altura da barra:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('vue-slider', {
	    attrs: {
	      "data": [{
	        tamanho: 10,
	        nome: 'Estreita'
	      }, {
	        tamanho: 20,
	        nome: 'Normal'
	      }, {
	        tamanho: 30,
	        nome: 'Larga'
	      }, {
	        tamanho: 40,
	        nome: 'Extra'
	      }],
	      "data-value": 'tamanho',
	      "data-label": 'nome',
	      "drag-on-click": true
	    },
	    on: {
	      "drag-end": _vm.salvarConfiguracoes
	    },
	    model: {
	      value: (_vm.configuracoes.altura),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracoes, "altura", $$v)
	      },
	      expression: "configuracoes.altura"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Largura do Cabeçalho:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('vue-slider', {
	    attrs: {
	      "min": 0,
	      "max": 600,
	      "interval": 10,
	      "hide-label": true,
	      "tooltip": 'none',
	      "drag-on-click": true
	    },
	    on: {
	      "drag-end": _vm.salvarConfiguracoes
	    },
	    model: {
	      value: (_vm.configuracoes.larguraCabecalho),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracoes, "larguraCabecalho", $$v)
	      },
	      expression: "configuracoes.larguraCabecalho"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Mostrar Grade:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarGrade),
	      expression: "configuracoes.mostrarGrade"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarGrade"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.configuracoes.mostrarGrade, true)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarGrade", true)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarGrade),
	      expression: "configuracoes.mostrarGrade"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarGrade"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.configuracoes.mostrarGrade, false)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarGrade", false)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [(_vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) > _vm.projeto.periodos) ? _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-exclamation-circle text-gray",
	    attrs: {
	      "title": '<h5>Já passou do término do projeto, por isso não mostra a marcação de ´hoje´ neste gráfico</h5>'
	    }
	  }) : _vm._e(), _vm._v("\n              Mostrar Hoje:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarHoje),
	      expression: "configuracoes.mostrarHoje"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarHoje"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.configuracoes.mostrarHoje, true)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarHoje", true)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarHoje),
	      expression: "configuracoes.mostrarHoje"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarHoje"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.configuracoes.mostrarHoje, false)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarHoje", false)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("\n              Mostrar Orçado Mensal:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarOrcadoMensal),
	      expression: "configuracoes.mostrarOrcadoMensal"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarOrcadoMensal"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.configuracoes.mostrarOrcadoMensal, true)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarOrcadoMensal", true)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarOrcadoMensal),
	      expression: "configuracoes.mostrarOrcadoMensal"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarOrcadoMensal"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.configuracoes.mostrarOrcadoMensal, false)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarOrcadoMensal", false)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.configuracoes.mostrarOrcadoMensal) ? _c('span', [_c('i', {
	    staticClass: "fa fa-arrow-right",
	    staticStyle: {
	      "margin": "0 20px"
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarRecursoMensal),
	      expression: "configuracoes.mostrarRecursoMensal"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarRecursoMensal"
	    },
	    domProps: {
	      "value": [1],
	      "checked": _vm._q(_vm.configuracoes.mostrarRecursoMensal, [1])
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarRecursoMensal", [1])
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" FBB "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarRecursoMensal),
	      expression: "configuracoes.mostrarRecursoMensal"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarRecursoMensal"
	    },
	    domProps: {
	      "value": [2],
	      "checked": _vm._q(_vm.configuracoes.mostrarRecursoMensal, [2])
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarRecursoMensal", [2])
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Contrapartida "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat col-md-offset-2",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.configuracaoPadrao
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-repeat",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar ao padrão")])])])])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Buttons\n      "), _c('small', [_vm._v("Control panel")])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Buttons")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Buttons")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body pad table-responsive"
	  }, [_c('p', [_vm._v("Various types of buttons. Using the base class "), _c('code', [_vm._v(".btn")])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-bordered text-center"
	  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Normal")]), _vm._v(" "), _c('th', [_vm._v("Large "), _c('code', [_vm._v(".btn-lg")])]), _vm._v(" "), _c('th', [_vm._v("Small "), _c('code', [_vm._v(".btn-sm")])]), _vm._v(" "), _c('th', [_vm._v("X-Small "), _c('code', [_vm._v(".btn-xs")])]), _vm._v(" "), _c('th', [_vm._v("Flat "), _c('code', [_vm._v(".btn-flat")])]), _vm._v(" "), _c('th', [_vm._v("Disabled "), _c('code', [_vm._v(".disabled")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
	    staticClass: "btn btn-block btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-default btn-lg",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-default disabled",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Default")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
	    staticClass: "btn btn-block btn-primary",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-primary btn-lg",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-primary btn-sm",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-primary btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-primary disabled",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Primary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
	    staticClass: "btn btn-block btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-success btn-lg",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-success btn-sm",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-success btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-success disabled",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Success")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
	    staticClass: "btn btn-block btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-info btn-lg",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-info btn-sm",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-info btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-info disabled",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Info")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
	    staticClass: "btn btn-block btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-danger btn-lg",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-danger btn-sm",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-danger btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-danger disabled",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Danger")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
	    staticClass: "btn btn-block btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-warning btn-lg",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-warning btn-sm",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-warning btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-warning btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-warning disabled",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Warning")])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Block Buttons")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-block",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn-block")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-block btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn-block .btn-flat")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-block btn-sm",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn-block .btn-sm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Horizontal Button Group")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body table-responsive pad"
	  }, [_c('p', [_vm._v("\n              Horizontal button groups are easy to create with bootstrap. Just add your buttons\n              inside "), _c('code', [_vm._v("<div class=\"btn-group\"></div>")])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Button")]), _vm._v(" "), _c('th', [_vm._v("Icons")]), _vm._v(" "), _c('th', [_vm._v("Flat")]), _vm._v(" "), _c('th', [_vm._v("Dropdown")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-info dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-danger dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-warning dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-success dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Button Addon")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', [_vm._v("With dropdown")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group margin"
	  }, [_c('div', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_vm._v("Action\n                  "), _c('span', {
	    staticClass: "fa fa-caret-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("Normal")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group margin"
	  }, [_c('div', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("Flat")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group margin"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Go!")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Split buttons")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', [_vm._v("Normal split buttons:")]), _vm._v(" "), _c('div', {
	    staticClass: "margin"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])])]), _vm._v(" "), _c('p', [_vm._v("Flat split buttons:")]), _vm._v(" "), _c('div', {
	    staticClass: "margin"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-flat dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-flat dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-flat dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Social Buttons (By "), _c('a', {
	    attrs: {
	      "href": "https://github.com/lipis/bootstrap-social"
	    }
	  }, [_vm._v("Lipis")]), _vm._v(")\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('a', {
	    staticClass: "btn btn-block btn-social btn-bitbucket"
	  }, [_c('i', {
	    staticClass: "fa fa-bitbucket"
	  }), _vm._v(" Sign in with Bitbucket\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-dropbox"
	  }, [_c('i', {
	    staticClass: "fa fa-dropbox"
	  }), _vm._v(" Sign in with Dropbox\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-facebook"
	  }, [_c('i', {
	    staticClass: "fa fa-facebook"
	  }), _vm._v(" Sign in with Facebook\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-flickr"
	  }, [_c('i', {
	    staticClass: "fa fa-flickr"
	  }), _vm._v(" Sign in with Flickr\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-foursquare"
	  }, [_c('i', {
	    staticClass: "fa fa-foursquare"
	  }), _vm._v(" Sign in with Foursquare\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-github"
	  }, [_c('i', {
	    staticClass: "fa fa-github"
	  }), _vm._v(" Sign in with GitHub\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-google"
	  }, [_c('i', {
	    staticClass: "fa fa-google-plus"
	  }), _vm._v(" Sign in with Google\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-instagram"
	  }, [_c('i', {
	    staticClass: "fa fa-instagram"
	  }), _vm._v(" Sign in with Instagram\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-linkedin"
	  }, [_c('i', {
	    staticClass: "fa fa-linkedin"
	  }), _vm._v(" Sign in with LinkedIn\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-tumblr"
	  }, [_c('i', {
	    staticClass: "fa fa-tumblr"
	  }), _vm._v(" Sign in with Tumblr\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-twitter"
	  }, [_c('i', {
	    staticClass: "fa fa-twitter"
	  }), _vm._v(" Sign in with Twitter\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-vk"
	  }, [_c('i', {
	    staticClass: "fa fa-vk"
	  }), _vm._v(" Sign in with VK\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('a', {
	    staticClass: "btn btn-social-icon btn-bitbucket"
	  }, [_c('i', {
	    staticClass: "fa fa-bitbucket"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-dropbox"
	  }, [_c('i', {
	    staticClass: "fa fa-dropbox"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-facebook"
	  }, [_c('i', {
	    staticClass: "fa fa-facebook"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-flickr"
	  }, [_c('i', {
	    staticClass: "fa fa-flickr"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-foursquare"
	  }, [_c('i', {
	    staticClass: "fa fa-foursquare"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-github"
	  }, [_c('i', {
	    staticClass: "fa fa-github"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-google"
	  }, [_c('i', {
	    staticClass: "fa fa-google-plus"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-instagram"
	  }, [_c('i', {
	    staticClass: "fa fa-instagram"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-linkedin"
	  }, [_c('i', {
	    staticClass: "fa fa-linkedin"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-tumblr"
	  }, [_c('i', {
	    staticClass: "fa fa-tumblr"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-twitter"
	  }, [_c('i', {
	    staticClass: "fa fa-twitter"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-social-icon btn-vk"
	  }, [_c('i', {
	    staticClass: "fa fa-vk"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Application Buttons")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', [_vm._v("Add the classes "), _c('code', [_vm._v(".btn.btn-app")]), _vm._v(" to an "), _c('code', [_vm._v("<a>")]), _vm._v(" tag to achieve the following:")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  }), _vm._v(" Edit\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('i', {
	    staticClass: "fa fa-play"
	  }), _vm._v(" Play\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('i', {
	    staticClass: "fa fa-repeat"
	  }), _vm._v(" Repeat\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('i', {
	    staticClass: "fa fa-pause"
	  }), _vm._v(" Pause\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('i', {
	    staticClass: "fa fa-save"
	  }), _vm._v(" Save\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('span', {
	    staticClass: "badge bg-yellow"
	  }, [_vm._v("3")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-bullhorn"
	  }), _vm._v(" Notifications\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('span', {
	    staticClass: "badge bg-green"
	  }, [_vm._v("300")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-barcode"
	  }), _vm._v(" Products\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('span', {
	    staticClass: "badge bg-purple"
	  }, [_vm._v("891")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-users"
	  }), _vm._v(" Users\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('span', {
	    staticClass: "badge bg-teal"
	  }, [_vm._v("67")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-inbox"
	  }), _vm._v(" Orders\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('span', {
	    staticClass: "badge bg-aqua"
	  }, [_vm._v("12")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-envelope"
	  }), _vm._v(" Inbox\n            ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-app"
	  }, [_c('span', {
	    staticClass: "badge bg-red"
	  }, [_vm._v("531")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-heart-o"
	  }), _vm._v(" Likes\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Different colors")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', [_vm._v("Mix and match with various background colors. Use base class "), _c('code', [_vm._v(".btn")]), _vm._v(" and add any available\n              "), _c('code', [_vm._v(".bg-*")]), _vm._v(" class")]), _vm._v(" "), _c('p', [_c('button', {
	    staticClass: "btn bg-maroon btn-flat margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-maroon.btn-flat")]), _vm._v(" "), _c('button', {
	    staticClass: "btn bg-purple btn-flat margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-purple.btn-flat")]), _vm._v(" "), _c('button', {
	    staticClass: "btn bg-navy btn-flat margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-navy.btn-flat")]), _vm._v(" "), _c('button', {
	    staticClass: "btn bg-orange btn-flat margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-orange.btn-flat")]), _vm._v(" "), _c('button', {
	    staticClass: "btn bg-olive btn-flat margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-olive.btn-flat")])]), _vm._v(" "), _c('p', [_c('button', {
	    staticClass: "btn bg-maroon margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-maroon")]), _vm._v(" "), _c('button', {
	    staticClass: "btn bg-purple margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-purple")]), _vm._v(" "), _c('button', {
	    staticClass: "btn bg-navy margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-navy")]), _vm._v(" "), _c('button', {
	    staticClass: "btn bg-orange margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-orange")]), _vm._v(" "), _c('button', {
	    staticClass: "btn bg-olive margin",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(".btn.bg-olive")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Vertical Button Group")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body table-responsive pad"
	  }, [_c('p', [_vm._v("\n              Vertical button groups are easy to create with bootstrap. Just add your buttons\n              inside "), _c('code', [_vm._v("<div class=\"btn-group-vertical\"></div>")])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Button")]), _vm._v(" "), _c('th', [_vm._v("Icons")]), _vm._v(" "), _c('th', [_vm._v("Flat")]), _vm._v(" "), _c('th', [_vm._v("Dropdown")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-info dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-danger dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-warning dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "btn-group-vertical"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-success dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Dropdown link")])])])])])])])])])])])])])])])
	}]}

/***/ }),
/* 1894 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Processos Simplificados")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Lista',
	        href: '#'
	      }, {
	        text: 'Simplificado',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "to": {
	        name: 'cadastro-simplificado-edita'
	      },
	      "disabled": !this.$root.authorize('edital-novo'),
	      "id": "new-register"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Processo\n                ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-8 col-sm-4",
	    staticStyle: {
	      "margin-bottom": "1rem"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "active",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "endDate",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "updatedAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "to": {
	              name: 'cadastro-simplificado-edita',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.inativa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.active ? 'Inativar' : 'Ativar'))])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Processos")])])
	}]}

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n        Timeline\n        "), _c('small', [_vm._v("example")])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Timeline")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('ul', {
	    staticClass: "timeline"
	  }, [_c('li', {
	    staticClass: "time-label"
	  }, [_c('span', {
	    staticClass: "bg-red"
	  }, [_vm._v("\n                    10 Feb. 2014\n                  ")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-envelope bg-blue"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "timeline-item"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" 12:05")]), _vm._v(" "), _c('h3', {
	    staticClass: "timeline-header"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Support Team")]), _vm._v(" sent you an email")]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-body"
	  }, [_vm._v("\n                  Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles,\n                  weebly ning heekya handango imeem plugg dopplr jibjab, movity\n                  jajah plickers sifteo edmodo ifttt zimbra. Babblely odeo kaboodle\n                  quora plaxo ideeli hulu weebly balihoo...\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-footer"
	  }, [_c('a', {
	    staticClass: "btn btn-primary btn-xs"
	  }, [_vm._v("Read more")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-danger btn-xs"
	  }, [_vm._v("Delete")])])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-user bg-aqua"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "timeline-item"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" 5 mins ago")]), _vm._v(" "), _c('h3', {
	    staticClass: "timeline-header no-border"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Sarah Young")]), _vm._v(" accepted your friend request")])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-comments bg-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "timeline-item"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" 27 mins ago")]), _vm._v(" "), _c('h3', {
	    staticClass: "timeline-header"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Jay White")]), _vm._v(" commented on your post")]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-body"
	  }, [_vm._v("\n                  Take me to your leader!\n                  Switzerland is small and neutral!\n                  We are more like Germany, ambitious and misunderstood!\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-footer"
	  }, [_c('a', {
	    staticClass: "btn btn-warning btn-flat btn-xs"
	  }, [_vm._v("View comment")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "time-label"
	  }, [_c('span', {
	    staticClass: "bg-green"
	  }, [_vm._v("\n                    3 Jan. 2014\n                  ")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-camera bg-purple"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "timeline-item"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" 2 days ago")]), _vm._v(" "), _c('h3', {
	    staticClass: "timeline-header"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Mina Lee")]), _vm._v(" uploaded new photos")]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-body"
	  }, [_c('img', {
	    staticClass: "margin",
	    attrs: {
	      "src": "http://placehold.it/150x100",
	      "alt": "..."
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "margin",
	    attrs: {
	      "src": "http://placehold.it/150x100",
	      "alt": "..."
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "margin",
	    attrs: {
	      "src": "http://placehold.it/150x100",
	      "alt": "..."
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "margin",
	    attrs: {
	      "src": "http://placehold.it/150x100",
	      "alt": "..."
	    }
	  })])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-video-camera bg-maroon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "timeline-item"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" 5 days ago")]), _vm._v(" "), _c('h3', {
	    staticClass: "timeline-header"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Mr. Doe")]), _vm._v(" shared a video")]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-body"
	  }, [_c('div', {
	    staticClass: "embed-responsive embed-responsive-16by9"
	  }, [_c('iframe', {
	    staticClass: "embed-responsive-item",
	    attrs: {
	      "src": "https://www.youtube.com/embed/tMWkeBIohBs",
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-footer"
	  }, [_c('a', {
	    staticClass: "btn btn-xs bg-maroon",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("See comments")])])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-clock-o bg-gray"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-code"
	  }), _vm._v(" Timeline Markup")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('pre', {
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }, [_vm._v("<ul class=\"timeline\">\n\n    <!-- timeline time label -->\n    <li class=\"time-label\">\n        <span class=\"bg-red\">\n            10 Feb. 2014\n        </span>\n    </li>\n    <!-- /.timeline-label -->\n\n    <!-- timeline item -->\n    <li>\n        <!-- timeline icon -->\n        <i class=\"fa fa-envelope bg-blue\"></i>\n        <div class=\"timeline-item\">\n            <span class=\"time\"><i class=\"fa fa-clock-o\"></i> 12:05</span>\n\n            <h3 class=\"timeline-header\"><a href=\"#\">Support Team</a> ...</h3>\n\n            <div class=\"timeline-body\">\n                ...\n                Content goes here\n            </div>\n\n            <div class=\"timeline-footer\">\n                <a class=\"btn btn-primary btn-xs\">...</a>\n            </div>\n        </div>\n    </li>\n    <!-- END timeline item -->\n\n    ...\n\n</ul>\n                  ")])])])])])])])
	}]}

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chk"
	  }, [_vm._l((_vm.grupos), function(grupo) {
	    return [(grupo.titulo === 'Enquadramento e Parecer Jurídico') ? _vm._t("antes-enquadramento") : _vm._e(), _vm._v(" "), _c('section', {
	      key: grupo.titulo,
	      staticClass: "chk-secao"
	    }, [_c('div', {
	      staticClass: "chk-titulo"
	    }, [_vm._v(_vm._s(grupo.titulo))]), _vm._v(" "), (grupo.titulo === 'Regularidade da Proposta e da Proponente') ? _vm._t("inicio-regularidade") : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "chk-card"
	    }, [_vm._l((grupo.itens), function(item) {
	      return [(item.texto) ? _c('div', {
	        key: item.chave,
	        staticClass: "chk-row chk-row--texto",
	        class: {
	          'chk-row--ok': _vm.respondido(item.chave)
	        }
	      }, [_c('label', {
	        staticClass: "chk-q"
	      }, [_vm._v(_vm._s(item.pergunta))]), _vm._v(" "), _c('input', {
	        staticClass: "chk-input",
	        attrs: {
	          "type": "text",
	          "maxlength": "255",
	          "disabled": _vm.disabled
	        },
	        domProps: {
	          "value": _vm.dados[item.chave]
	        },
	        on: {
	          "input": function($event) {
	            return _vm.atualiza(item.chave, $event.target.value)
	          }
	        }
	      })]) : _c('div', {
	        key: item.chave,
	        staticClass: "chk-row",
	        class: {
	          'chk-row--ok': _vm.respondido(item.chave)
	        }
	      }, [_c('span', {
	        staticClass: "chk-q"
	      }, [_vm._v(_vm._s(item.pergunta))]), _vm._v(" "), _c('div', {
	        staticClass: "chk-seg",
	        attrs: {
	          "role": "group"
	        }
	      }, _vm._l((_vm.opcoes), function(opcao) {
	        return _c('button', {
	          key: opcao,
	          staticClass: "chk-seg-btn",
	          class: _vm.classeOpcao(item.chave, opcao),
	          attrs: {
	            "type": "button",
	            "disabled": _vm.disabled
	          },
	          on: {
	            "click": function($event) {
	              return _vm.alterna(item.chave, opcao)
	            }
	          }
	        }, [_vm._v(_vm._s(opcao))])
	      }), 0)])]
	    }), _vm._v(" "), (grupo.observacaoChave) ? _c('div', {
	      staticClass: "chk-row chk-row--texto",
	      class: {
	        'chk-row--ok': _vm.respondido(grupo.observacaoChave)
	      }
	    }, [_c('label', {
	      staticClass: "chk-q"
	    }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
	      staticClass: "chk-input",
	      attrs: {
	        "rows": "3",
	        "disabled": _vm.disabled
	      },
	      domProps: {
	        "value": _vm.dados[grupo.observacaoChave]
	      },
	      on: {
	        "input": function($event) {
	          return _vm.atualiza(grupo.observacaoChave, $event.target.value)
	        }
	      }
	    })]) : _vm._e()], 2)], 2)]
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.showGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento
	      }
	    }, [_vm._v(_vm._s(documento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file"
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "expirationDate"
	    }
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    attrs: {
	      "ng-if": "!$ctrl.flagNovoDocumento",
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalStateForm"
	    }
	  }, [_c('datepicker', {
	    attrs: {
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.documento.expirationDate),
	      callback: function($$v) {
	        _vm.$set(_vm.documento, "expirationDate", $$v)
	      },
	      expression: "documento.expirationDate"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.novoDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), _c('td', [_vm._v("Vigência")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
	    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(pendente.type))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
	      staticStyle: {
	        "max-width": "135px",
	        "text-align": "center"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onAddFile(pendente)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Adicionar arquivo")]) : _vm._e()])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_data_validade, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editaDocumento(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deletaDocumento(indexDocumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")]) : _vm._e()]) : _vm._e()])
	  })], 2)])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "text-danger"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pendente")])])
	}]}

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "form",
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "form-horizontal row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "margin": "0px"
	    },
	    attrs: {
	      "name": "frmAddAt"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "titulo-periodo"
	  }, [_vm._v("\r\n            Justificativa (Será salvo em Alterações no Projeto)\r\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('data')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "data"
	    }
	  }, [_vm._v("Data:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [(_vm.alteracao.id) ? _c('div', [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "data",
	    attrs: {
	      "name": "data",
	      "input-class": "form-control",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "placeholder": "__ /__ /____",
	      "highlighted": _vm.highlighted,
	      "disabled": "",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.alteracao.dt_registro),
	      callback: function($$v) {
	        _vm.$set(_vm.alteracao, "dt_registro", $$v)
	      },
	      expression: "alteracao.dt_registro"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.alteracao.id) ? _c('div', [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "data",
	    attrs: {
	      "name": "data",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "placeholder": "__ /__ /____",
	      "highlighted": _vm.highlighted,
	      "disabled": "",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.alteracao.dt_registro),
	      callback: function($$v) {
	        _vm.$set(_vm.alteracao, "dt_registro", $$v)
	      },
	      expression: "alteracao.dt_registro"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.errors.first('data')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "tipo"
	    }
	  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    attrs: {
	      "options": _vm.tipos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Tipo de Alteração",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaTipos,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "tipo",
	      "disabled": "",
	      "data-vv-as": "Tipo de alteração"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelect($event, _vm.alteracao.tipo)
	      }
	    },
	    model: {
	      value: (_vm.alteracao.tipo),
	      callback: function($$v) {
	        _vm.$set(_vm.alteracao, "tipo", $$v)
	      },
	      expression: "alteracao.tipo"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('tipo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('detalhamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "detalhamento"
	    }
	  }, [_vm._v("Detalhe:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.detalhamentoAnt),
	      expression: "detalhamentoAnt"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": _vm.place,
	      "name": "detalhamento",
	      "type": "text",
	      "maxlength": "1000",
	      "cols": "10",
	      "rows": "8"
	    },
	    domProps: {
	      "value": (_vm.detalhamentoAnt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.detalhamentoAnt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('detalhamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('detalhamento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('motivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "motivo"
	    }
	  }, [_vm._v("Motivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.motivos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Motivo",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaMotivos,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "tipo",
	      "data-vv-as": "Motivo da alteração"
	    },
	    model: {
	      value: (_vm.alteracao.motivo),
	      callback: function($$v) {
	        _vm.$set(_vm.alteracao, "motivo", $$v)
	      },
	      expression: "alteracao.motivo"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('motivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo')))]) : _vm._e()]), _vm._v(" "), (_vm.alteracao.responsavel.ds_nome_usuario) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "responsavel"
	    }
	  }, [_vm._v("Responsável:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.alteracao.responsavel.ds_nome_usuario),
	      expression: "alteracao.responsavel.ds_nome_usuario"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "responsavel",
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.alteracao.responsavel.ds_nome_usuario)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.alteracao.responsavel, "ds_nome_usuario", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('anexo')
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', [_vm._v("\r\n                Para realizar a alteração do prazo, os documentos "), _c('strong', [_vm._v("obrigatórios")]), _vm._v(" devem ser anexados:\r\n                "), _vm._m(1), _vm._v(" "), _c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.alteracao.documentos,
	      "documentTypes": '',
	      "disable": '',
	      "localUso": 'ALTERACAO_PERIODO_EXECUCAO',
	      "salvouOK": _vm.salvouOK
	    }
	  })], 1)]), _vm._v(" "), (_vm.errors.first('anexo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('anexo')))]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.frmAddAt)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelar(_vm.editando)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])], 1)])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "responsavel"
	    }
	  }, [_vm._v("Anexos: "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ol', {
	    attrs: {
	      "type": "1"
	    }
	  }, [_c('li', [_vm._v("Súmula ou Nota Técnica.")]), _vm._v(" "), _c('li', [_vm._v("Termo Aditivo assinado, quando o "), _c('strong', [_vm._v("prazo de vigência")]), _vm._v(" for alterado.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('br'), _c('br')])
	}]}

/***/ }),
/* 1899 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.somenteLeitura !== false) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.formEditavel) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Objetivo Específico")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('table', {
	    staticClass: "table b-table table-hover table-bordered b-table-stacked-md",
	    attrs: {
	      "role": "table",
	      "aria-busy": "false",
	      "aria-colcount": "2",
	      "aria-rowcount": "-1"
	    }
	  }, [_c('thead', {}, [_c('tr', [_c('th', {
	    staticClass: "sorting sorting_asc text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "1",
	      "aria-label": "Click to sort Descending",
	      "aria-sort": "ascending"
	    }
	  }, [_vm._v("Objetivo específico")]), _vm._v(" "), (_vm.formEditavel) ? _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "13%"
	    },
	    attrs: {
	      "aria-colindex": "2"
	    }
	  }, [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
	    attrs: {
	      "role": "rowgroup"
	    }
	  }, _vm._l((_vm.table.items), function(item, index) {
	    return _c('tr', {
	      attrs: {
	        "aria-rowindex": "1",
	        "role": "row"
	      }
	    }, [_c('td', {
	      staticClass: "text-left",
	      attrs: {
	        "aria-colindex": "1",
	        "data-label": "Objetivo específico",
	        "role": "cell"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(item.ds_descricao))])]), _vm._v(" "), (_vm.formEditavel) ? _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "aria-colindex": "2",
	        "data-label": "Ações",
	        "role": "cell"
	      }
	    }, [(_vm.somenteLeitura !== false) ? _c('div', [_c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "type": "button",
	        "disabled": false
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.edita(item, index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button",
	        "disabled": false
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.exclui(item, index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])]) : _vm._e()]) : _vm._e()])
	  }), 0)])])])])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('descrição')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "description"
	    }
	  }, [_vm._v("Descrição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addSpeObjCtrl.approval",
	      "state": "addSpeObjCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.objetivos.ds_descricao),
	      expression: "objetivos.ds_descricao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "descrição",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.objetivos.ds_descricao)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onAdd($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.objetivos, "ds_descricao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.objetivos.id),
	      expression: "objetivos.id"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "id",
	      "type": "hidden"
	    },
	    domProps: {
	      "value": (_vm.objetivos.id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.objetivos, "id", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('descrição')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('descrição')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body prest-upload-container"
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start"
	  }, [_c('b-button', {
	    directives: [{
	      name: "b-toggle",
	      rawName: "v-b-toggle.historico",
	      modifiers: {
	        "historico": true
	      }
	    }],
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.toggleHistorico(!_vm.mostrarHistorico)
	      }
	    }
	  }, [_c('i', {
	    class: _vm.mostrarHistorico ? 'fa fa-caret-up' : 'fa fa-caret-down'
	  }), _vm._v("\n                Mostrar\n            ")])], 1)]), _vm._v(" "), (_vm.mostrarHistorico) ? _c('div', {
	    staticClass: "column all-start prest-complementar-container"
	  }, [_c('b-container', {
	    staticClass: "prest-table",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "created_at",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(_vm.moment(row.value).format('DD/MM/YYYY HH:mm')))])]
	      }
	    }], null, false, 406047439)
	  })], 1)], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Histórico"), _c('i', {
	    staticClass: "fa fa-clock-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Impressão de Relatórios'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
	    attrs: {
	      "name": "frmRegNotice",
	      "novalidate": "",
	      "_lpchecked": "1"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "projetos"
	    }
	  }, [_vm._v("Relatório:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio),
	      expression: "relatorio"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "relatorio"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show = true
	      },
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.relatorio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.campo]
	    }
	  }, _vm._l((_vm.relatorios), function(relatorio) {
	    return _c('option', {
	      domProps: {
	        "value": relatorio
	      }
	    }, [_vm._v(_vm._s(relatorio.ds_codigo + ' - ' + relatorio.ds_titulo))])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "box box-widget"
	  }, [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box-header with-border"
	  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group"
	  }, _vm._l((_vm.relatorioForm), function(item) {
	    return _c('div', {
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "control-label col-sm-2"
	    }, [_vm._v(_vm._s(item.ds_titulo) + ":")]), _vm._v(" "), _c('div', {
	      staticClass: "col-sm-2"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.value),
	        expression: "item.value"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "required": "",
	        "name": item.ds_codigo
	      },
	      domProps: {
	        "value": (item.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "value", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.valores[item.ds_codigo]))])])])
	  }), 0) : _vm._e(), _vm._v(" "), (this.usuarioLogado.userType === 'ENTIDADE') ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required",
	    attrs: {
	      "disabled": _vm.trava === 1
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto),
	      expression: "projeto"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "projeto",
	      "disabled": _vm.carregou !== 1,
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.changeProjeto(_vm.projeto)
	      }]
	    }
	  }, _vm._l((_vm.projetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto
	      }
	    }, [_vm._v(_vm._s(projeto.ds_codigo_projeto_erp) + " - " + _vm._s(projeto.ds_nome))])
	  }), 0), _vm._v(" "), (_vm.carregou !== 1) ? _c('div', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando listagem de projetos....\n                                ")]) : _vm._e()])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)"
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onLoad($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Emitir Relatório")])], 1)])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Relatórios")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-ds_titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Impressão de Relatórios")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "box-ds_titulo"
	  }, [_c('b', [_vm._v("Campos do Relatório: ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-label col-xs-4 col-sm-3 col-lg-2",
	    attrs: {
	      "for": "projeto"
	    }
	  }, [_c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v("Projeto:")])])
	}]}

/***/ }),
/* 1902 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Assunto")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Assunto',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmRegNotice",
	      "novalidate": "",
	      "_lpchecked": "1"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('numeroEdital')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "assunto"
	    }
	  }, [_vm._v("Assunto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.assunto.assunto),
	      expression: "assunto.assunto"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "name": "assunto",
	      "type": "text",
	      "minlength": "1",
	      "ng-maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.assunto.assunto)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.assunto, "assunto", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('numeroEdital')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('assunto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('area_responsavel')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "area_responsavel"
	    }
	  }, [_vm._v("Área Responsável:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.areas,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione uma área",
	      "custom-label": _vm.etiquetaArea,
	      "preselect-first": false,
	      "selectLabel": "",
	      "label": "nome",
	      "track-by": "nome",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "area_responsavel",
	      "data-vv-as": "area_responsavel",
	      "disabled": false
	    },
	    on: {
	      "select": function($event) {
	        return _vm.changeArea($event)
	      }
	    },
	    model: {
	      value: (_vm.assunto.area_responsavel),
	      callback: function($$v) {
	        _vm.$set(_vm.assunto, "area_responsavel", $$v)
	      },
	      expression: "assunto.area_responsavel"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('parametroEdital')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('parametroEdital')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('status')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "bt_ativo"
	    }
	  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.assunto.bt_ativo),
	      expression: "assunto.bt_ativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status",
	      "checked": "",
	      "value": "1"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.assunto.bt_ativo, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.assunto, "bt_ativo", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.assunto.bt_ativo),
	      expression: "assunto.bt_ativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status",
	      "value": "0"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.assunto.bt_ativo, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.assunto, "bt_ativo", 0)
	      }
	    }
	  }), _vm._v(" Não\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar ")])], 1)])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Editando Cadastro de Assunto")])])
	}]}

/***/ }),
/* 1903 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "main-header"
	  }, [_c('router-link', {
	    staticClass: "logo",
	    attrs: {
	      "to": "/dashboard"
	    }
	  }, [_c('span', {
	    staticClass: "logo-mini"
	  }, [_c('b', [_vm._v("A")]), _vm._v("LT")]), _vm._v(" "), _c('span', {
	    staticClass: "logo-lg"
	  }, [_c('img', {
	    attrs: {
	      "src": "",
	      "alt": ""
	    }
	  })])]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-static-top",
	    style: ('background: ' + _vm._.get(_vm.barraAmbiente(), 'cor'))
	  }, [_vm._m(0), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "x-large",
	      "line-height": "45px"
	    }
	  }, [_vm._v(_vm._s(_vm._.get(_vm.barraAmbiente(), 'descricao')))]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-custom-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.usuarioLogado.sujeitoAPonto) ? _c('li', {
	    staticStyle: {
	      "padding": "15px 15px"
	    },
	    attrs: {
	      "data-title": _vm.minutosRestanteNoPonto > 5 ? 'Horário previsto para saída' : _vm.minutosRestanteNoPonto > 0 ? 'Sua jornada de trabalho está se encerrando' : 'Fim da jornada de trabalho'
	    }
	  }, [_c('span', {
	    class: _vm.minutosRestanteNoPonto > 10 ? 'ponto-normal' : _vm.minutosRestanteNoPonto > 0 ? 'ponto-alerta' : 'ponto-perigo',
	    staticStyle: {
	      "font-weight": "bold",
	      "padding": "8px 10px",
	      "border-radius": "20px",
	      "cursor": "default"
	    }
	  }, [_c('svg', {
	    staticStyle: {
	      "vertical-align": "middle",
	      "width": "25px",
	      "height": "25px",
	      "display": "inline"
	    },
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 20 20",
	      "fill": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z",
	      "clip-rule": "evenodd"
	    }
	  })]), _vm._v("\n            " + _vm._s(_vm.usuarioLogado.limitePonto.slice(0, 2)) + "h" + _vm._s(_vm.usuarioLogado.limitePonto.slice(3, 5)) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "dropdown user user-menu"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown"
	    }
	  }, [(_vm._.isNull(_vm.usuarioLogado.bl_foto)) ? _c('img', {
	    staticClass: "user-image",
	    attrs: {
	      "src": '/static/img/nouser.png',
	      "alt": "User Image pequeno"
	    }
	  }) : _c('img', {
	    staticClass: "user-image",
	    attrs: {
	      "src": _vm.usuarioLogado.bl_foto,
	      "alt": "User Image pequeno"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "hidden-xs"
	  }, [_vm._v(_vm._s(_vm.usuarioLogado.ds_nome_usuario))])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "user-header"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": _vm.usuarioLogado.bl_foto ? _vm.usuarioLogado.bl_foto : '/static/img/nouser.png',
	      "alt": "User Image grande"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.usuarioLogado.userName) + "\n                "), _c('small', [_vm._v("Criado em: " + _vm._s(_vm._f("moment")(_vm.usuarioLogado.dt_criado, "DD-MM-YYYY")))])])]), _vm._v(" "), _c('li', {
	    staticClass: "user-footer"
	  }, [_c('div', {
	    staticClass: "pull-left"
	  }, [_c('router-link', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "to": {
	        name: 'preferencias'
	      },
	      "uib-tooltip": "",
	      "type": "button"
	    }
	  }, [_c('i', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Preferências")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('a', {
	    staticClass: "btn btn-default btn-flat",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.logout($event)
	      }
	    }
	  }, [_vm._v("Sair")])])])])]), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario === 'FUNDACAO') ? _c('li', [_vm._m(1)]) : _vm._e()])])]), _vm._v(" "), _c('vue-snotify'), _vm._v(" "), _c('dialog', {
	    ref: "alertaPontoDialog",
	    attrs: {
	      "id": "alertaPontoDialog"
	    }
	  }, [_vm._m(2), _vm._v(" "), (_vm.minutosRestanteNoPonto <= 0) ? _c('p', {
	    staticStyle: {
	      "margin": "25px 0"
	    }
	  }, [_vm._v("\n      Jornada de trabalho encerrada.\n    ")]) : _c('p', {
	    staticStyle: {
	      "margin": "25px 0"
	    }
	  }, [_vm._v("\n      Em breve sua jornada de trabalho se encerrará.\n    ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-neutral",
	    attrs: {
	      "onclick": "alertaPontoDialog.close()"
	    }
	  }, [_vm._v("Fechar")])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "sidebar-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "offcanvas",
	      "role": "button"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#",
	      "data-toggle": "control-sidebar"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("Atenção!")])])
	}]}

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.adiantamentos_concedidos), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.projectName) + " - " + _vm._s(_vm._f("moment")(item.createDate, 'L')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.totalValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.totalValueBalance)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataLimite))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.accountabilityDate, 'L')))])])
	  }), 0)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Adiantamentos Concedidos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Processo de solicitação em andamento")]), _vm._v(" "), _c('th', [_vm._v("Valor liberado")]), _vm._v(" "), _c('th', [_vm._v("Valor não solicitado")]), _vm._v(" "), _c('th', [_vm._v("Data limite para prestação de contas")]), _vm._v(" "), _c('th', [_vm._v("Data da última prestação de contas")])])])
	}]}

/***/ }),
/* 1905 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Manuais e Modelos'
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('documentos-por-tipo', {
	    attrs: {
	      "tipo": 45
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('documentos-por-tipo', {
	    attrs: {
	      "tipo": 46
	    }
	  })], 1)])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('i', {
	    staticClass: "fa fa-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Manuais e Modelos")])])
	}]}

/***/ }),
/* 1906 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.showGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', {
	    attrs: {
	      "ng-if": "!$ctrl.flagNovoDocumento",
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalStateForm"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.documentType),
	      expression: "documento.documentType"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "documentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento
	      }
	    }, [_vm._v(_vm._s(documento.type))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file"
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "expirationDate"
	    }
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    attrs: {
	      "ng-if": "!$ctrl.flagNovoDocumento",
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalStateForm"
	    }
	  }, [_c('datepicker', {
	    attrs: {
	      "name": "expirationDate",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.documento.expirationDate),
	      callback: function($$v) {
	        _vm.$set(_vm.documento, "expirationDate", $$v)
	      },
	      expression: "documento.expirationDate"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Adiciona um documento",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onNew
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
	    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(pendente.type))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
	      staticStyle: {
	        "max-width": "135px",
	        "text-align": "center"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onAddFile(pendente)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Adicionar arquivo")]) : _vm._e()])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [(_vm._.has(documento.documentType, 'type')) ? _c('td', [_vm._v(_vm._s(documento.documentType.type))]) : _c('td'), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }, [_vm._v(" " + _vm._s(documento.fileName))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.createdAt, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.expirationDate, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onEdit(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDelete(indexDocumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")]) : _vm._e()])])
	  })], 2)])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), _c('td', [_vm._v("Vigência")]), _vm._v(" "), _c('td', [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "text-danger"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pendente")])])
	}]}

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Oculta ou Mostra o histórico de alterações da Entidade",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostraHistorico = !_vm.mostraHistorico
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eye",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.mostraHistorico ? 'Ocultar histórico' : 'Mostrar histórico'))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraHistorico),
	      expression: "mostraHistorico"
	    }],
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "items": _vm.historicoGridItems,
	      "bordered": _vm.table.bordered,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "inicio",
	      fn: function(row) {
	        return [_vm._v("\n              " + _vm._s(row.value ? _vm.$moment(row.value, 'YYYY-MM-DD HH:mm:ss.SSS').format('L HH:mm:ss') : '') + "\n            ")]
	      }
	    }, {
	      key: "termino",
	      fn: function(row) {
	        return [_vm._v("\n              " + _vm._s(row.value ? _vm.$moment(row.value, 'YYYY-MM-DD HH:mm:ss.SSS').format('L HH:mm:ss') : '') + "\n            ")]
	      }
	    }, {
	      key: "observacao",
	      fn: function(row) {
	        return [(row.value && String(row.value).trim().length) ? _c('span', [_vm._v("\n                " + _vm._s(row.value) + "\n              ")]) : _c('span', {
	          staticClass: "text-muted"
	        }, [_vm._v("\n                —\n              ")])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [(row.item.termino !== null) ? _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              _vm.showModal = true, _vm.testFunc(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]) : _vm._e()], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.historicoGridItems.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.showModal) ? _c('div', [_c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper",
	    on: {
	      "click": function($event) {
	        return _vm.$emit(_vm.showModal = false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Histórico")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Entidade")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_nome),
	      expression: "snap.ds_nome"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "companyName",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_nome", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "cnpj",
	      "type": "text",
	      "disabled": "true",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.snap.ds_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "ds_cnpj", $$v)
	      },
	      expression: "snap.ds_cnpj"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "dt_cnpj"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    attrs: {
	      "name": "cnpjExpeditionTime",
	      "use-utc": true,
	      "input-class": "form-control",
	      "language": _vm.$datePickerPtBR,
	      "format": "dd/MM/yyyy",
	      "disabled": "true"
	    },
	    model: {
	      value: (this.snap.dt_data_expedicao_cnpj),
	      callback: function($$v) {
	        _vm.$set(this.snap, "dt_data_expedicao_cnpj", $$v)
	      },
	      expression: "this.snap.dt_data_expedicao_cnpj"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "businessName"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_nome_fantasia),
	      expression: "snap.ds_nome_fantasia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "businessName",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_nome_fantasia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_nome_fantasia", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "legalType"
	    }
	  }, [_vm._v("Natureza jurídica:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaFormasJuridicas,
	      "multiple": false,
	      "disabled": true,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione uma Natureza Jurídica",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaListaFormaJuridica,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "forma_juridica"
	    },
	    model: {
	      value: (_vm.snap.forma_juridica),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "forma_juridica", $$v)
	      },
	      expression: "snap.forma_juridica"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "activity"
	    }
	  }, [_vm._v("Ramo atividade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaRamosAtividade,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "disabled": true,
	      "preserve-search": true,
	      "placeholder": "Selecione os Ramos de Atividade",
	      "label": "ds_codigo",
	      "track-by": "ds_codigo",
	      "custom-label": _vm.etiquetaListaRamosAtividade,
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "ramos_atividade"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.ds_codigo))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 2912667078),
	    model: {
	      value: (_vm.snap.ramos_atividade),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "ramos_atividade", $$v)
	      },
	      expression: "snap.ramos_atividade"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "constitutionDocument"
	    }
	  }, [_vm._v("Doc. constituição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaDocConstituicao,
	      "multiple": false,
	      "close-on-select": true,
	      "searchable": false,
	      "disabled": true,
	      "track-by": "id",
	      "label": "ds_tipo",
	      "placeholder": "Selecione um Documento de constituição",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "listaDocConstituicao"
	    },
	    model: {
	      value: (_vm.snap.documento_constituicao),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "documento_constituicao", $$v)
	      },
	      expression: "snap.documento_constituicao"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6",
	    attrs: {
	      "id": "contato"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "phone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.contato.ds_telefone),
	      expression: "snap.contato.ds_telefone"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) ####-#####'),
	      expression: "'(##) ####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "phone",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.contato.ds_telefone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.contato, "ds_telefone", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "mobile"
	    }
	  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.contato.ds_celular),
	      expression: "snap.contato.ds_celular"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) #####-#####'),
	      expression: "'(##) #####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "mobile",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.contato.ds_celular)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.contato, "ds_celular", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_email),
	      expression: "snap.ds_email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_email", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_website),
	      expression: "snap.ds_website"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "website",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_website)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_website", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])]), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.histEndereco,
	      "disable": _vm.disable
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes:")])])]), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.histDirigente,
	      "disable": _vm.disable
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Usuários:")])])]), _vm._v(" "), _c('usuarios', {
	    attrs: {
	      "entUsuarios": _vm.histUsuario,
	      "disable": _vm.disable
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.histDocumento,
	      "documentTypes": '',
	      "disable": _vm.disable,
	      "local-uso": 'TODOS'
	    }
	  })], 1)])])])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('br'), _vm._v(" "), _c('b-button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button",
	      "disabled": false
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Fechar ")])], 1)])])])])])])])])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }]
	  }, [_c('pre', {
	    ref: "myDiv",
	    attrs: {
	      "id": "myDiv"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.form.errors.any()) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [(_vm.dismissible) ? _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": _vm.dismiss
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _vm._t("default", [(_vm.form.errors.has('error')) ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.form.errors.get('error'))
	    }
	  }) : _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.message)
	    }
	  })])], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body extratoff"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.cronograma),
	      expression: "loading.cronograma"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(false) ? _c('b-button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.buscaCronograma($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atualizar")]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm._.includes(['ANALISE', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "col-md-6",
	    attrs: {
	      "title": '<h5>Veja os itens em cada atividade a que pertente ou agrupado por recursos da Fundação e Contrapartidas</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-5"
	  }, [_vm._v("Layout agrupado por: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.layoutExtrato),
	      expression: "layoutExtrato"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.layoutExtrato = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "classico"
	    }
	  }, [_vm._v("Atividades")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "porOrigem"
	    }
	  }, [_vm._v("Origem do Recurso")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "porConta"
	    }
	  }, [_vm._v("Contas Financeiras")])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'filtroItens')) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    class: !_vm._.includes(['ANALISE', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso) ? 'col-md-6' : 'col-md-12',
	    attrs: {
	      "title": '<h5>' + (_vm.layoutFiltrosSelecionados.length === 0 ? 'Mostrar o(s) item(ns) que contém o que for selecionado' : (_vm.layoutFiltrosSelecionados.length === 1 ? ('Somente mostrando os que tem ' + _vm.layoutFiltrosSelecionados[0]) : ('No cronograma filtrando os itens ao mesmo tempo por: ' + _vm._.join(_vm.layoutFiltrosSelecionados, ', ')))) + '<br/>Obs.: Filtros não alteram totais</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3"
	  }, [_vm._v("Mostrar item: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.layoutFiltrosSelecionados),
	      expression: "layoutFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "saldos"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "saldos") > -1 : (_vm.layoutFiltrosSelecionados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.layoutFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "saldos",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.layoutFiltrosSelecionados = $$c
	        }
	      }
	    }
	  }), _vm._v(" Com saldo "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.layoutFiltrosSelecionados),
	      expression: "layoutFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "produtos"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "produtos") > -1 : (_vm.layoutFiltrosSelecionados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.layoutFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "produtos",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.layoutFiltrosSelecionados = $$c
	        }
	      }
	    }
	  }), _vm._v(" Produtos "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.layoutFiltrosSelecionados),
	      expression: "layoutFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "servicos"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "servicos") > -1 : (_vm.layoutFiltrosSelecionados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.layoutFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "servicos",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.layoutFiltrosSelecionados = $$c
	        }
	      }
	    }
	  }), _vm._v(" Serviços "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.layoutFiltrosSelecionados),
	      expression: "layoutFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "contrapartidas"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "contrapartidas") > -1 : (_vm.layoutFiltrosSelecionados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.layoutFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "contrapartidas",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.layoutFiltrosSelecionados = $$c
	        }
	      }
	    }
	  }), _vm._v(" Contrapartidas "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.totais.adiantavel.total.orcado !== 0),
	      expression: "totais.adiantavel.total.orcado !== 0"
	    }],
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.layoutFiltrosSelecionados),
	      expression: "layoutFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "adiantaveis"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "adiantaveis") > -1 : (_vm.layoutFiltrosSelecionados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.layoutFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "adiantaveis",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.layoutFiltrosSelecionados = $$c
	        }
	      }
	    }
	  }), _vm._v(" Adiantáveis "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm._.includes(['SUPLEMENTACAO', 'REMANEJAMENTO'], _vm.layoutSolicitacao) && _vm.totais.solicitacao.percentual !== 0) || _vm.alteracoes.length > 0 || _vm.inclusoes.length > 0 || !_vm.solicitacao),
	      expression: "(_.includes(['SUPLEMENTACAO', 'REMANEJAMENTO'], layoutSolicitacao) && totais.solicitacao.percentual !== 0) || alteracoes.length > 0 || inclusoes.length > 0 || !solicitacao"
	    }],
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.layoutFiltrosSelecionados),
	      expression: "layoutFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "solicitados"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "solicitados") > -1 : (_vm.layoutFiltrosSelecionados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.layoutFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "solicitados",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.layoutFiltrosSelecionados = $$c
	        }
	      }
	    }
	  }), _vm._v(" Solicitado "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.etapaProcesso != 'VISUALIZACAO' && _vm.formEditavel && !_vm._.isNull(_vm.layoutSolicitacao)) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.irAtividades
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Atividade")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed"
	  }, [(_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('thead', [_c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "2",
	      "title": '<h5>Valor total contratado no projeto por Atividade e Item</h5>'
	    }
	  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "2",
	      "title": '<h5>Saldo restante de cada Atividade e Item</h5>'
	    }
	  }, [_vm._v("Saldo")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v(" ")]), _vm._v(" "), (_vm.formEditavel) ? _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm.rotuloAgrupamentoExtrato) + " / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "title": '<h5>Percentual aproximado já liberado<br/>Não considera Economicidade</h5>'
	    }
	  }, [_vm._v("Atingimento")]), _vm._v(" "), (_vm.formEditavel) ? _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v(" ")]) : _vm._e()])]) : _c('thead', [_c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm.rotuloAgrupamentoExtrato) + " / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Saldo")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "title": '<h5>Percentual aproximado já liberado<br/>Não considera Economicidade</h5>'
	    }
	  }, [_vm._v("Atingimento")]), _vm._v(" "), (_vm.formEditavel) ? _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v(" ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l(((
	    _vm.layoutExtrato === 'porConta' ?
	    _vm.contas :
	    (_vm.layoutExtrato === 'classico' ?
	      [
	        ['1', '2', '5']
	      ] :
	      (_vm.layoutExtrato === 'porOrigem') ?
	      [
	        ['1', '5'],
	        ['2']
	      ] :
	      [
	        []
	      ]
	    )
	  )), function(grupo) {
	    return [(_vm.layoutExtrato === 'porOrigem') ? _c('tr', [_c('td', {
	      staticClass: "atividade",
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm._.includes(grupo, '2') ? 'Recursos de Contrapartida' : 'Recursos da Fundação BB') + "\n                ")])]) : (_vm.layoutExtrato === 'porConta' && (_vm.extratoPorContaFinanceira[grupo] || []).length) ? _c('tr', {
	      staticClass: "atividade"
	    }, [_c('td', {
	      staticClass: "esquerda celula b1 b3 b4 nome_atividade",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("\n                  " + _vm._s(grupo === 'SEM_CONTA' ? 'Total - Sem Conta' : ('Conta ' + grupo)) + "\n                ")]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
	      staticClass: "centralizado celula b1 b3 b4"
	    }, [_vm._v("\n                  " + _vm._s((_vm.totaisPorContaFinanceira[grupo] || {}).quantidadeOrcado || 0) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "centralizado celula b1 b3"
	    }, [_vm._v("\n                  " + _vm._s(_vm._f("decimal2")(((_vm.totaisPorContaFinanceira[grupo] || {}).valorOrcado || 0))) + "\n                ")]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
	      staticClass: "centralizado celula b1 b3 b4"
	    }, [_vm._v("\n                  " + _vm._s((_vm.totaisPorContaFinanceira[grupo] || {}).quantidadeSaldo || 0) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "centralizado celula b1 b3"
	    }, [_vm._v("\n                  " + _vm._s(_vm._f("decimal2")(((_vm.totaisPorContaFinanceira[grupo] || {}).valorSaldo || 0))) + "\n                ")]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado celula b1 b3 b2"
	    }, [_vm._v("\n                  " + _vm._s(_vm._f("percentage")(((_vm.totaisPorContaFinanceira[grupo] || {}).percAtingimento || 0))) + "\n                ")]), _vm._v(" "), (_vm.etapaProcesso === 'VISUALIZACAO') ? _c('td', {
	      staticClass: "centralizado celula b1 b3 b2"
	    }, [_vm._v("\n                  -\n                ")]) : _vm._e(), _vm._v(" "), (_vm.formEditavel) ? _c('td', {
	      staticClass: "centralizado celula b1 b3 b2"
	    }, [_vm._v("\n                   \n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.propsAtividades), function(atividade, atividadeIndex) {
	      return [(_vm.layoutExtrato === 'classico') ? _c('tr', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm._.get(_vm.processoSolicitacao, 'processo.situacao', 'EM_EXECUCAO') === 'EM_EXECUCAO' || (_vm._.includes(['FEITO', 'CANCELADO'], _vm.processoSolicitacao.processo.situacao) && _vm._.countBy(atividade.itens_orcamentos, 'mostrar')['true'])),
	          expression: "_.get(processoSolicitacao, 'processo.situacao', 'EM_EXECUCAO') === 'EM_EXECUCAO' || (_.includes(['FEITO', 'CANCELADO'], processoSolicitacao.processo.situacao) && _.countBy(atividade.itens_orcamentos, 'mostrar')['true'])"
	        }],
	        staticClass: "atividade"
	      }, [_c('td', {
	        staticClass: "esquerda celula b1 b3 b4 nome_atividade",
	        attrs: {
	          "colspan": "2"
	        }
	      }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
	        staticClass: "centralizado celula b1 b3 b4"
	      }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3"
	      }, [_vm._v(_vm._s(_vm._f("decimal2")(atividade.valorOrcado)))]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
	        staticClass: "centralizado celula b1 b3 b4"
	      }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3"
	      }, [_vm._v(_vm._s(_vm._f("decimal2")(atividade.valorSaldo)))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b2"
	      }, [_vm._v(_vm._s(_vm._f("percentage")(atividade.percAtingimento)))]), _vm._v(" "), (_vm.formEditavel) ? _c('td', {
	        staticClass: "centralizado celula b1 b3 b2"
	      }, [(_vm._.isEmpty(_vm.itemEditando) && !_vm._.isNull(_vm.layoutSolicitacao) && _vm.etapaProcesso !== 'VISUALIZACAO') ? _c('button', {
	        staticClass: "btn btn-primary btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.adicionaItem(atividade, atividadeIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-plus-circle",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Adicionar Novo Item")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item, itemIndex) {
	        return (_vm.layoutExtrato === 'porConta' ?
	          ('' + _vm._.get(item, 'conta_financeira.numero_conta', '') === '' + grupo) :
	          _vm._.includes(grupo, ('' + item.origem).substring(0, 1))) ? [(!_vm._.has(item, 'mostrar') || item.mostrar) ? [_c('tr', {
	          class: ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm.ehItemNovo(item) ? 'modificacaoInclusao' : '',
	          attrs: {
	            "prefix": "activityItem",
	            "suffix": "item.id",
	            "row": "item"
	          }
	        }, [(_vm._.isEmpty(_vm.itemEditando) || (!_vm._.isEmpty(_vm.itemEditando) && _vm.itemEditando.item.id !== item.id)) ? [_c('td', {
	          staticClass: "centralizado celula b3 b4"
	        }, [(('' + item.origem).substring(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substring(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substring(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.alteracoes, function(a) {
	          return _vm.alteracoes.length > 0 && a.id === item.id && a.alteracao === 'adiantavel'
	        })) ? _c('span', {
	          staticClass: "alteracao"
	        }, [_c('br'), _vm._v(" "), (_vm._.find(_vm.alteracoes, function(a) {
	          return a.id === item.id && a.alteracao === 'adiantavel' && ('' + a.depois) === '1'
	        })) ? _c('span', [_vm._v("Será adiantável")]) : _c('span', [_vm._v("Era adiantável")])]) : _vm._e(), _vm._v(" "), (_vm.getTextoAdiantamento(item)) ? _c('span', {
	          staticClass: "alteracao"
	        }, [_c('br'), _vm._v("\n                          " + _vm._s(_vm.getTextoAdiantamento(item)) + "\n                        ")]) : _c('span', {
	          staticClass: "adiantavel"
	        }, [(item.adiantavel === '1' || item.adiantavel === 1 || item.adiantavel === true) ? _c('span', [_c('br'), _vm._v("Adiantável")]) : _vm._e()])]), _vm._v(" "), _c('td', {
	          staticClass: "celula b3 b4"
	        }, [(!_vm._.isNull(item.item)) ? _c('div', {
	          staticClass: "item"
	        }, [_c('div', {
	          staticClass: "item_despesa esquerda",
	          style: ((!_vm._.includes(_vm.itensLayout, 'quantidade')) ? 'width: 100%' : '')
	        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'contaFinanceira')) ? _c('div', {
	          staticClass: "conta_financeira direita"
	        }, [_vm._v(_vm._s(item.contaFinanceiraNumero) + " / " + _vm._s(item.contaFinanceiraDescricao))]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "observacao esquerda"
	        }, [_c('span', {
	          staticClass: "id_item"
	        }, [_vm._v("#" + _vm._s(item.id) + " ")]), _vm._v(" "), (item.hasOwnProperty('observacaoOriginal')) ? _c('div', {
	          staticClass: "column start-centered"
	        }, [_c('span', [_vm._v(_vm._s(item.observacaoOriginal == 'undefined' ? '-' : item.observacaoOriginal))]), _vm._v(" "), (item.hasOwnProperty('observacaoNova') && item.observacaoNova !== '') ? _c('div', {
	          staticClass: "row-flex centered-start",
	          staticStyle: {
	            "gap": "5px"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          staticStyle: {
	            "color": "#2E7D32"
	          }
	        }), (item.hasOwnProperty('observacaoNova') && item.observacaoNova !== '') ? _c('span', {
	          staticClass: "alteracao",
	          domProps: {
	            "innerHTML": _vm._s(item.observacaoNova)
	          }
	        }) : _vm._e()]) : _vm._e()]) : _c('div', [_c('span', [_vm._v(_vm._s(item.observacao == 'undefined' ? '-' : item.observacao))])])])]) : _vm._e()]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	          }],
	          staticClass: "centralizado celula b3 b4",
	          attrs: {
	            "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
	          }
	        }, [_c('span', {
	          class: (_vm._.find(_vm.alteracoes, function(a) {
	            return _vm.alteracoes.length > 0 && a.id === item.id && a.alteracao === 'quantidadeOrcado'
	          }) ? 'alteracao' : '')
	        }, [_vm._v(_vm._s(item.quantidadeOrcado))])]) : _vm._e(), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3"
	        }, [_c('span', {
	          class: (_vm._.find(_vm.alteracoes, function(a) {
	            return _vm.alteracoes.length > 0 && a.id === item.id && a.alteracao === 'valorOrcado'
	          }) ? 'alteracao' : '')
	        }, [_vm._v(_vm._s(_vm._f("decimal2")((_vm.ehItemNovo(item) && _vm._.get(item, 'valorAlteracao', 0) !== 0 ? item.valorAlteracao : item.valorOrcado))))])]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	          }],
	          staticClass: "centralizado celula b3 b4",
	          attrs: {
	            "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
	          }
	        }, [_vm._v("\n                      " + _vm._s(item.quantidadeSaldo) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3"
	        }, [_vm._v("\n                      " + _vm._s(_vm._f("decimal2")((_vm.ehItemNovo(item) && _vm._.get(item, 'valorAlteracao', 0) !== 0 ? item.valorAlteracao : item.valorSaldo))) + "\n                      "), (_vm._.get(item, 'valorAlteracao', 0) !== 0) ? _c('span', [_c('br'), _vm._v(" "), _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	          }],
	          attrs: {
	            "title": '<h5>' + item.justificativa + '</h5>'
	          }
	        }, [_c('span', {
	          class: 'valor_alterado' + (_vm.layoutSolicitacao === 'SUPLEMENTACAO' && item.valorAlteracao < 0 ? ' label-danger' : '') + (item.valorAlteracao > 0 ? ' acrescimo_valor' : (item.valorAlteracao < 0 ? ' diminuicao_valor' : ''))
	        }, [_c('i', {
	          class: (item.valorAlteracao > 0 ? 'fa fa-plus-circle' : (item.valorAlteracao < 0 ? 'fa fa-minus-circle' : ''))
	        }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(item.valorAlteracao))) + "\n                        ")])])]) : _vm._e()]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b2"
	        }, [(_vm.ehItemNovo(item)) ? _c('span', {
	          staticClass: "label label-info"
	        }, [_vm._v("Novo")]) : _c('span', [_vm._v("\n                      " + _vm._s(_vm._f("percentage")(item.percAtingimento)) + "\n                      "), (('' + item.economicidade) === '1') ? _c('i', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "fa fa-dollar economicidade",
	          attrs: {
	            "title": '<h5>Comprovado com Economicidade</h5>'
	          }
	        }) : _vm._e()])]), _vm._v(" "), (_vm.etapaProcesso === 'VISUALIZACAO') ? _c('td', {
	          staticClass: "centralizado celula b3 b2"
	        }, [(!_vm._.isNull(item.fk_cotacao)) ? _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          attrs: {
	            "title": "Abrir Cotação"
	          }
	        }, [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          on: {
	            "click": function($event) {
	              return _vm.consultarAbrirCotacao(item.fk_cotacao)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-dollar",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1) : _c('div', [_vm._v(" - ")])]) : _vm._e(), _vm._v(" "), (_vm.formEditavel) ? _c('td', {
	          staticClass: "celula b2 b3"
	        }, [(_vm._.isEmpty(_vm.itemEditando)) ? _c('div', {
	          staticClass: "centralizado"
	        }, [(_vm.formEditavel && !_vm._.isNull(_vm.layoutSolicitacao)) ? _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.editar(item, itemIndex, atividade, atividadeIndex)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]) : _vm._e()], 1) : _vm._e()]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm._.includes(['inserindo', 'editando'], _vm.itemEditando.acao) && !_vm._.has(_vm.listaSolicitacoes, 'processos') && _vm.itemEditando.itemIndex === itemIndex && _vm.itemEditando.atividadeIndex === atividadeIndex) ? _c('tr', [(!_vm._.isEmpty(_vm.itemEditando) && _vm.itemEditando.item.id === item.id) ? [_c('td', {
	          staticStyle: {
	            "padding": "0"
	          },
	          attrs: {
	            "colspan": _vm.formEditavel ? 8 : 7
	          }
	        }, [_c('div', {
	          staticClass: "quadroEdicaoItem"
	        }, [_c('div', {
	          staticClass: "form-horizontal"
	        }, [_c('div', {
	          staticClass: "form-group"
	        }, [(_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('origem')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-4"
	        }, [_c('select', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item.origem),
	            expression: "itemEditando.item.origem"
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "name": "origem",
	            "aria-label": "origem"
	          },
	          on: {
	            "change": [function($event) {
	              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	                return o.selected
	              }).map(function(o) {
	                var val = "_value" in o ? o._value : o.value;
	                return val
	              });
	              _vm.$set(_vm.itemEditando.item, "origem", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	            }, function($event) {
	              return _vm.zeraAdiantamento()
	            }]
	          }
	        }, [_c('option', {
	          attrs: {
	            "value": "1"
	          }
	        }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	          attrs: {
	            "value": "2"
	          }
	        }, [_vm._v("Contrapartida")]), _vm._v(" "), (_vm.totais.projeto.parceiros.orcado !== 0) ? _c('option', {
	          attrs: {
	            "value": "5"
	          }
	        }, [_vm._v("P.Estratégico")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('inicio')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Início:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-1"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model.number",
	            value: (_vm.itemEditando.item.periodo_inicial),
	            expression: "itemEditando.item.periodo_inicial",
	            modifiers: {
	              "number": true
	            }
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          ref: "periodo_inicial",
	          refInFor: true,
	          staticClass: "form-control text-right",
	          attrs: {
	            "type": "number",
	            "name": "inicio",
	            "maxlength": "2",
	            "aria-label": "Inicio do período",
	            "min": atividade.inicio,
	            "max": atividade.termino
	          },
	          domProps: {
	            "value": (_vm.itemEditando.item.periodo_inicial)
	          },
	          on: {
	            "change": _vm.validaPeriodo,
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.itemEditando.item, "periodo_inicial", _vm._n($event.target.value))
	            },
	            "blur": function($event) {
	              return _vm.$forceUpdate()
	            }
	          }
	        }), _vm._v(" "), (_vm.errors.first('inicio')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('inicio')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	          staticClass: "required-field"
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Fim:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-1"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model.number",
	            value: (_vm.itemEditando.item.periodo_final),
	            expression: "itemEditando.item.periodo_final",
	            modifiers: {
	              "number": true
	            }
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          ref: "periodo_final",
	          refInFor: true,
	          staticClass: "form-control text-right",
	          attrs: {
	            "type": "number",
	            "name": "fim",
	            "maxlength": "2",
	            "aria-label": "Fim do período",
	            "min": atividade.inicio,
	            "max": atividade.termino
	          },
	          domProps: {
	            "value": (_vm.itemEditando.item.periodo_final)
	          },
	          on: {
	            "change": _vm.validaPeriodo,
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.itemEditando.item, "periodo_final", _vm._n($event.target.value))
	            },
	            "blur": function($event) {
	              return _vm.$forceUpdate()
	            }
	          }
	        }), _vm._v(" "), (_vm.errors.first('fim')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('fim')))]) : _vm._e()])])]), _vm._v(" "), (_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('div', {
	          staticClass: "form-group"
	        }, [_c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('item')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Item de despesa:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-10"
	        }, [_c('multiselect', {
	          directives: [{
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          attrs: {
	            "name": "item",
	            "custom-label": function (ref) {
	              var ds_code = ref.ds_code;
	              var ds_description = ref.ds_description;
	
	              return (ds_code + " / " + ds_description)
	            },
	            "searchable": true,
	            "options": _vm.items,
	            "close-on-select": true,
	            "hide-selected": true,
	            "preserve-search": false,
	            "placeholder": "Escolha um item",
	            "disabled": _vm.itemEditando.item.origem === null,
	            "label": "ds_description",
	            "track-by": "ds_code",
	            "preselect-first": false
	          },
	          on: {
	            "select": function($event) {
	              return _vm.buscaContasFinanceiras($event)
	            }
	          },
	          scopedSlots: _vm._u([{
	            key: "option",
	            fn: function(props) {
	              return [_c('div', {
	                staticClass: "option__desc"
	              }, [_c('span', {
	                staticClass: "option__title"
	              }, [_vm._v(_vm._s(props.option.ds_code) + " / " + _vm._s(props.option.ds_description))])])]
	            }
	          }], null, true),
	          model: {
	            value: (_vm.itemEditando.item.item),
	            callback: function($$v) {
	              _vm.$set(_vm.itemEditando.item, "item", $$v)
	            },
	            expression: "itemEditando.item.item"
	          }
	        }, [_vm._v(" "), _c('span', {
	          attrs: {
	            "slot": "noResult"
	          },
	          slot: "noResult"
	        }, [_c('font', {
	          attrs: {
	            "color": "red"
	          }
	        }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('item')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('item')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.ehItemNovo(_vm.itemEditando.item)) ? [_c('div', {
	          staticClass: "form-group required-field",
	          class: {
	            'has-error': _vm.errors.first('descrição item')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Descrição do item:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-10"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item.observacao),
	            expression: "itemEditando.item.observacao"
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "text",
	            "name": "descrição item",
	            "maxlength": "255"
	          },
	          domProps: {
	            "value": (_vm.itemEditando.item.observacao)
	          },
	          on: {
	            "input": [function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.itemEditando.item, "observacao", $event.target.value)
	            }, function($event) {
	              return _vm.bloquearAspas($event, _vm.itemEditando.item, 'observacao')
	            }]
	          }
	        }), _vm._v(" "), (_vm.errors.first('descrição item')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(_vm._s(_vm.errors.first('descrição item')))]) : _vm._e()])])] : (_vm.etapaProcesso !== 'VISUALIZACAO') ? [_c('div', {
	          staticClass: "form-group"
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Descrição atual do item:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-10"
	        }, [_c('span', {
	          staticStyle: {
	            "font-weight": "normal"
	          },
	          domProps: {
	            "innerHTML": _vm._s(_vm.itemEditando.item.observacao)
	          }
	        })])]), _vm._v(" "), _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "form-group",
	          attrs: {
	            "title": '<h5>Deixe em branco para manter a descrição atual</h5>'
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Nova Descrição:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-10"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item['observacaoNova']),
	            expression: "itemEditando.item['observacaoNova']"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "text",
	            "name": "nova descrição item",
	            "maxlength": "255"
	          },
	          domProps: {
	            "value": (_vm.itemEditando.item['observacaoNova'])
	          },
	          on: {
	            "keyup": _vm.atualizaComponente,
	            "input": [function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.itemEditando.item, 'observacaoNova', $event.target.value)
	            }, function($event) {
	              return _vm.bloquearAspas($event, _vm.itemEditando.item, 'observacaoNova')
	            }]
	          }
	        })])])] : _vm._e(), _vm._v(" "), (_vm.ehFBB || _vm.ehItemNovo(_vm.itemEditando.item)) ? _c('div', {
	          staticClass: "form-group"
	        }, [(_vm.ehItemNovo(_vm.itemEditando.item) || _vm.etapaProcesso === 'VISUALIZACAO') ? _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('quantidade')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-1"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model.number",
	            value: (_vm.itemEditando.item.quantidadeOrcado),
	            expression: "itemEditando.item.quantidadeOrcado",
	            modifiers: {
	              "number": true
	            }
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required|min_value:' + (_vm.ehItemNovo(_vm.itemEditando.item) ? 0 : _vm._.get(_vm.itemEditando, 'item.quantidadeMinima', 0))),
	            expression: "'required|min_value:' + (ehItemNovo(itemEditando.item) ? 0 : _.get(itemEditando, 'item.quantidadeMinima', 0))"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "type": "number",
	            "name": "quantidade",
	            "min": "1",
	            "maxlength": "6"
	          },
	          domProps: {
	            "value": (_vm.itemEditando.item.quantidadeOrcado)
	          },
	          on: {
	            "change": function($event) {
	              return _vm.$forceUpdate()
	            },
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.itemEditando.item, "quantidadeOrcado", _vm._n($event.target.value))
	            },
	            "blur": function($event) {
	              return _vm.$forceUpdate()
	            }
	          }
	        }), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v("Deve ser maior que " + _vm._s(_vm._.get(_vm.itemEditando, 'item.quantidadeMinima', 0)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.ehItemNovo(_vm.itemEditando.item) || _vm.etapaProcesso === 'VISUALIZACAO') ? _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('unidade de medida')
	          }
	        }, [_c('div', {
	          staticClass: "col-sm-2"
	        }, [_c('select', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item.unidade_medida),
	            expression: "itemEditando.item.unidade_medida"
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }, {
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "name": "unidade de medida",
	            "title": '<h5>Unidade de medida</h5>'
	          },
	          on: {
	            "change": [function($event) {
	              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	                return o.selected
	              }).map(function(o) {
	                var val = "_value" in o ? o._value : o.value;
	                return val
	              });
	              _vm.$set(_vm.itemEditando.item, "unidade_medida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	            }, _vm.atualizaComponente]
	          }
	        }, _vm._l((_vm.medidas), function(unidade_medida) {
	          return _c('option', {
	            domProps: {
	              "value": unidade_medida
	            }
	          }, [_vm._v(_vm._s(unidade_medida))])
	        }), 0), _vm._v(" "), (_vm.errors.first('unidade de medida')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('unidade de medida')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-3"
	        }, [(_vm.itemEditando.item.unidade_medida === 'Outros') ? _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('medida outros')
	          }
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item.medida_outros),
	            expression: "itemEditando.item.medida_outros"
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }, {
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "type": "text",
	            "name": "medida outros",
	            "maxlength": "255",
	            "aria-label": "Outros",
	            "title": '<h5>Qual essa outra unidade de medida?</h5>'
	          },
	          domProps: {
	            "value": (_vm.itemEditando.item.medida_outros)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.itemEditando.item, "medida_outros", $event.target.value)
	            }
	          }
	        }), _vm._v(" "), (_vm.errors.first('medida outros')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('medida outros')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('valor unitário')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Valor Unitário:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-2"
	        }, [_c('money', {
	          directives: [{
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required|min_value:1'),
	            expression: "'required|min_value:1'"
	          }, {
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "name": "valor unitário",
	            "title": '<h5>Valor unitário do item de despesa de acordo com orçamentos</h5>'
	          },
	          nativeOn: {
	            "change": function($event) {
	              return _vm.$forceUpdate()
	            }
	          },
	          model: {
	            value: (_vm.itemEditando.item.valor_unitario),
	            callback: function($$v) {
	              _vm.$set(_vm.itemEditando.item, "valor_unitario", $$v)
	            },
	            expression: "itemEditando.item.valor_unitario"
	          }
	        }), _vm._v(" "), (_vm.errors.first('valor unitário')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" Deve ser maior que R$ 1,00")]) : _vm._e()], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.etapaProcesso !== 'VISUALIZACAO') ? _c('div', {
	          staticClass: "form-group"
	        }, [(_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('span', [_c('label', {
	          staticClass: "control-label col-sm-offset-8 col-sm-2"
	        }, [_vm._v("Valor Total:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-2"
	        }, [_c('div', {
	          staticStyle: {
	            "padding": "6px 0"
	          }
	        }, [_vm._v("\n                                  " + _vm._s(_vm._f("real")((_vm._.toNumber(_vm.itemEditando.item.valor_unitario) * _vm._.toNumber(_vm.itemEditando.item.quantidadeOrcado)))) + "\n                                ")])])]) : _c('span', [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Saldo Atual:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-1 col-lg-2"
	        }, [_c('div', {
	          staticStyle: {
	            "padding": "6px 0"
	          }
	        }, [_vm._v(_vm._s(_vm._f("real")(_vm.itemEditando.item.valorSaldo)))])]), _vm._v(" "), _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('valor alterado')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v(_vm._s(_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'Remanejamento' : 'Suplementação') + ":")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-4 col-lg-3"
	        }, [_c('div', {
	          staticClass: "input-group"
	        }, [(_vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
	          staticClass: "input-group-btn sinalValorAlterado"
	        }, [_c('button', {
	          staticClass: "btn",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              _vm.itemEditando.item.valorAlteracao = Math.abs(_vm.itemEditando.item.valorAlteracao);
	              _vm.$forceUpdate()
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-plus-circle",
	          style: ((_vm.itemEditando.item.valorAlteracao > 0 ? 'color: var(--cor-sucesso)' : ''))
	        })]), _vm._v(" "), _c('button', {
	          staticClass: "btn",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              _vm.itemEditando.item.valorAlteracao = Math.abs(_vm.itemEditando.item.valorAlteracao) * -1;
	              _vm.$forceUpdate()
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-minus-circle",
	          style: ((_vm.itemEditando.item.valorAlteracao < 0 ? 'color: var(--cor-atencao)' : ''))
	        })])]) : _vm._e(), _vm._v(" "), _c('money', {
	          directives: [{
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required|min_value:' + (_vm.layoutSolicitacao === 'REMANEJAMENTO' ? (_vm._.toNumber(_vm.itemEditando.item.valorSaldo) * -1) : (_vm.layoutSolicitacao === 'SUPLEMENTACAO' ? 0.01 : 0))),
	            expression: "'required|min_value:' + (layoutSolicitacao === 'REMANEJAMENTO' ? (_.toNumber(itemEditando.item.valorSaldo) * -1) : (layoutSolicitacao === 'SUPLEMENTACAO' ? 0.01 : 0))"
	          }, {
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	          }],
	          staticClass: "form-control",
	          style: ('color:' + (_vm.itemEditando.item.valorAlteracao > 0 ? 'var(--cor-verde)' : (_vm.itemEditando.item.valorAlteracao < 0 ? 'var(--cor-vermelha)' : ''))),
	          attrs: {
	            "name": "valor alterado",
	            "title": '<h5>' + (_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'Valor que será remanejado, informe valor positivo ou negativo diferente de zero.<br/>Exemplos: 580,00  ou  -346,20.</br>Para alterar apenas a descrição do item deixe o valor igual a R$ 0,00.' : 'Valor que será suplementado, informe valor positivo maior que zero.<br/>Exemplos: 620,00.</br>Para alterar apenas a descrição do item deixe o valor igual a R$ 0,00.') + '</h5>'
	          },
	          nativeOn: {
	            "change": function($event) {
	              return _vm.atualizaComponente($event)
	            }
	          },
	          model: {
	            value: (_vm.itemEditando.item.valorAlteracao),
	            callback: function($$v) {
	              _vm.$set(_vm.itemEditando.item, "valorAlteracao", $$v)
	            },
	            expression: "itemEditando.item.valorAlteracao"
	          }
	        })], 1), _vm._v(" "), (_vm.errors.first('valor alterado')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'Remanejamentos, o item não pode ser 0,00 nem menor que ' + (_vm._.toNumber(_vm.itemEditando.item.valorSaldo) * -1) : 'Suplementação, o item não pode ser 0,00 nem negativo. Cancele ou desfaça alteração deste item'))]) : _vm._e()])]), _vm._v(" "), _c('label', {
	          staticClass: "control-label col-sm-1 col-lg-1"
	        }, [_vm._v("Saldo final:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-2"
	        }, [_c('div', {
	          staticStyle: {
	            "padding": "6px 0"
	          }
	        }, [_vm._v("\n                                  " + _vm._s(_vm._f("real")((_vm._.toNumber(_vm.itemEditando.item.valorSaldo) + _vm._.toNumber(_vm.itemEditando.item.valorAlteracao)))) + "\n                                ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "form-group"
	        }, [(_vm._.includes(['SOLICITACAO', 'REVISAO', 'ANALISE', 'AUTORIZACAO'], _vm.etapaProcesso)) ? _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('adiantavel')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Adiantável:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-2"
	        }, [_c('select', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item.adiantavel),
	            expression: "itemEditando.item.adiantavel"
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "disabled": _vm.itemEditando.item.origem === '2' || _vm.itemEditando.item.origem === 2,
	            "name": "adiantavel"
	          },
	          on: {
	            "change": [function($event) {
	              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	                return o.selected
	              }).map(function(o) {
	                var val = "_value" in o ? o._value : o.value;
	                return val
	              });
	              _vm.$set(_vm.itemEditando.item, "adiantavel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	            }, _vm.atualizaComponente]
	          }
	        }, [_c('option', {
	          attrs: {
	            "value": "0"
	          }
	        }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	          attrs: {
	            "value": "1"
	          }
	        }, [_vm._v("Sim")])]), _vm._v(" "), (_vm.errors.first('adiantavel')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('adiantavel')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['ANALISE', 'AUTORIZACAO'], _vm.etapaProcesso)) ? _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('conta financeira')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Conta Financeira:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-6"
	        }, [_c('multiselect', {
	          directives: [{
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          attrs: {
	            "disabled": true,
	            "name": "conta financeira",
	            "custom-label": _vm.contaCodigo,
	            "options": _vm.contasFinanceiras,
	            "close-on-select": true,
	            "hide-selected": true,
	            "preserve-search": false,
	            "placeholder": "Escolha um item",
	            "label": "numero_conta",
	            "track-by": "numero_conta",
	            "preselect-first": false
	          },
	          on: {
	            "select": _vm.selecionaConta
	          },
	          scopedSlots: _vm._u([{
	            key: "option",
	            fn: function(props) {
	              return [_c('div', {
	                staticClass: "option__desc"
	              }, [_c('span', {
	                staticClass: "option__title"
	              }, [_vm._v(_vm._s(props.option.numero_conta) + " / " + _vm._s(props.option.descricao))])])]
	            }
	          }], null, true),
	          model: {
	            value: (_vm.itemEditando.item.conta_financeira),
	            callback: function($$v) {
	              _vm.$set(_vm.itemEditando.item, "conta_financeira", $$v)
	            },
	            expression: "itemEditando.item.conta_financeira"
	          }
	        }, [_vm._v(" "), _c('span', {
	          attrs: {
	            "slot": "noResult"
	          },
	          slot: "noResult"
	        }, [_c('font', {
	          attrs: {
	            "color": "red"
	          }
	        }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('conta financeira')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('conta financeira')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.etapaProcesso !== 'VISUALIZACAO') ? _c('div', {
	          staticClass: "form-group"
	        }, [(('' + _vm._.get(_vm.itemEditando, 'item.adiantavel', '')) === ('' + _vm._.get(_vm.propsAtividades, [_vm.itemEditando.atividadeIndex, 'itens_orcamentos', _vm.itemEditando.itemIndex, 'adiantavel'], '')) &&
	          Math.abs(_vm._.toNumber(_vm._.get(_vm.itemEditando, ['item', 'valorAlteracao'], 0))) === 0 && (_vm._.get(_vm.itemEditando, ['item', 'observacaoNova'], '')).length === 0) ? _c('div', [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-10"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item.justificativa),
	            expression: "itemEditando.item.justificativa"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "text",
	            "name": "justificativa item",
	            "maxlength": "400"
	          },
	          domProps: {
	            "value": (_vm.itemEditando.item.justificativa)
	          },
	          on: {
	            "keyup": _vm.atualizaComponente,
	            "input": [function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.itemEditando.item, "justificativa", $event.target.value)
	            }, function($event) {
	              return _vm.bloquearAspas($event, _vm.itemEditando.item, 'justificativa')
	            }]
	          }
	        }), _vm._v(" "), _c('i', {
	          staticClass: "text-muted"
	        }, [_vm._v(" " + _vm._s((_vm._.get(_vm.itemEditando, 'item.justificativa', '')).length) + " até 400 caracteres")])])]) : _c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('justificativa item')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-sm-2"
	        }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-10"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item.justificativa),
	            expression: "itemEditando.item.justificativa"
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "text",
	            "name": "justificativa item",
	            "maxlength": "400"
	          },
	          domProps: {
	            "value": (_vm.itemEditando.item.justificativa)
	          },
	          on: {
	            "keyup": _vm.atualizaComponente,
	            "input": [function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.itemEditando.item, "justificativa", $event.target.value)
	            }, function($event) {
	              return _vm.bloquearAspas($event, _vm.itemEditando.item, 'justificativa')
	            }]
	          }
	        }), _vm._v(" "), _c('i', {
	          staticClass: "text-muted"
	        }, [_vm._v(" " + _vm._s((_vm._.get(_vm.itemEditando, 'item.justificativa', '')).length) + " até 400 caracteres")]), _vm._v(" "), (_vm.errors.first('justificativa item')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa item')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "form-group"
	        }, [_c('div', {
	          staticClass: "col-sm-10 col-sm-offset-2"
	        }, [_c('div', {
	          staticClass: "col-md-4"
	        }, [_c('button', {
	          staticClass: "btn btn-confirm btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.ok()
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-check",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	          staticClass: "btn btn-back btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.cancelar(atividade)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-times-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Cancelar")])]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-4"
	        }, [(_vm._.includes(_vm.itensLayout, 'substituicaoItem')) ? _c('span', [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.itemEditando.item['substituicao']),
	            expression: "itemEditando.item['substituicao']"
	          }],
	          attrs: {
	            "type": "checkbox"
	          },
	          domProps: {
	            "value": true,
	            "checked": Array.isArray(_vm.itemEditando.item['substituicao']) ? _vm._i(_vm.itemEditando.item['substituicao'], true) > -1 : (_vm.itemEditando.item['substituicao'])
	          },
	          on: {
	            "change": function($event) {
	              var $$a = _vm.itemEditando.item['substituicao'],
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = true,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(_vm.itemEditando.item, 'substituicao', $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(_vm.itemEditando.item, 'substituicao', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(_vm.itemEditando.item, 'substituicao', $$c)
	              }
	            }
	          }
	        }), _vm._v(" Este item é substituição de algum outro?")]) : _vm._e()]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-4"
	        }, [(_vm.ehItemNovo(_vm.itemEditando.item) && _vm.itemEditando.acao === 'editando') ? _c('button', {
	          staticClass: "btn btn-danger btn-flat fr",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              _vm.itemEditando.acao = 'excluindo';
	              _vm.cancelar(atividade)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir Item Novo")]) : _vm._e(), _vm._v(" "), (!_vm.ehItemNovo(_vm.itemEditando.item) && _vm._.find(_vm.alteracoes, ['id', _vm.itemEditando.item.id])) ? _c('button', {
	          staticClass: "btn btn-primary btn-flat fr",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.desfazerAlteracao(_vm.itemEditando.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-refresh",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Desfazer Alterações")]) : _vm._e()])])])], 2)])])] : _vm._e()], 2) : _vm._e()] : _vm._e()] : _vm._e()
	      })]
	    })]
	  })], 2)])])]), _vm._v(" "), (_vm.abrirCotacao && _vm.cotacaoForm.itemCotacao.length > 0) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "animated fadeInDownOutUp modal-container"
	  }, [(_vm.abrirCotacao && _vm.cotacaoForm.itemCotacao.length > 0) ? _c('cotacaoItens', {
	    attrs: {
	      "idProposta": _vm.proposta.id,
	      "fk_cotacao": _vm.cotacaoForm.id,
	      "cotacaoGravada": _vm.cotacaoForm.itemCotacao,
	      "cotacaoManualGravada": _vm.cotacaoForm.itemCotacaoManual,
	      "validandoCotacao": true,
	      "visualizandoCotacao": true,
	      "telaProjeto": true,
	      "cotacaoValidada": _vm.cotacaoForm.itemCotacaoValidado,
	      "toggleCotacao": _vm.toggleCotacao,
	      "fecharValidacao": _vm.toggleCotacao
	    }
	  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(!_vm.loading.cronograma) ? _c('table', {
	    class: 'totais ' + (_vm._.includes(['SUPLEMENTACAO', 'REMANEJAMENTO'], _vm._.get(_vm.solicitacao, 'nome', null)) ? 'solicitacao_total_' + (_vm.layoutSolicitacao === 'SUPLEMENTACAO' && _vm.totais.solicitacao.percentual > 0.25 ? 'atencao' : 'ok') : '')
	  }, [_c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', [_vm._v("Total Contrapartida")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.adiantavel.total.orcado !== 0) ? _c('span', [_vm._v("Total Adiantável")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.solicitacao.fbb > 0 || _vm.totais.solicitacao.parceiros > 0 || _vm.totais.solicitacao.contrapartida > 0) ? _c('span', [_vm._v(_vm._s(_vm.layoutSolicitacao === 'SUPLEMENTACAO' ? 'Total da Suplementação' : 'Total dos itens Remanejados'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado com recursos da Fundação</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb.orcado)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado com recursos de Parceiro Estratégico</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros.orcado)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado com recursos da Contrapartida</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida.orcado)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.adiantavel.total.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado para Adiantamento</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.adiantavel.total.orcado)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado para este projeto</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.orcado)))])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) > 0 || _vm.inclusoes.length > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
	    }],
	    attrs: {
	      "title": '<h5>Total ' + (_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'remanejado' : 'suplementado') + ' nesta solicitação</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida))))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo dos recursos da Fundação com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.fbb.saldo / _vm.totais.projeto.fbb.orcado) * 100)) | _vm.percentage) + '%</span> de atingimento</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo dos recursos de Parceiro Estratégico com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.parceiros.saldo / _vm.totais.projeto.parceiros.orcado) * 100)) | _vm.percentage) + '%</span> de atingimento</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo dos recursos da Contrapartida com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.contrapartida.saldo / _vm.totais.projeto.contrapartida.orcado) * 100)) | _vm.percentage) + '%</span> de atingimento</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.adiantavel.total.orcado !== 0 && false) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo dos Adiantamento não solicitados ainda</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.adiantavel.total.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.total.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo total do projeto com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.total.saldo / _vm.totais.projeto.total.orcado) * 100)) | _vm.percentage) + '%</span> de atingimento</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.solicitacao.percentual > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
	    }],
	    attrs: {
	      "title": '<h5>Percentual ' + (_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'remanejado' : 'suplementado') + ' referente ao total orçado em recursos próprios</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("percentage")(_vm.totais.solicitacao.percentual)))]) : _vm._e()])]), _vm._v(" "), (_vm._.get(_vm.solicitacao, 'nome', null) === 'SUPLEMENTACAO' && (_vm.totais.solicitacao.fbb !== 0 || _vm.totais.solicitacao.parceiros !== 0 || _vm.totais.solicitacao.contrapartida !== 0 || _vm.totais.solicitacao.total !== 0 || _vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0)) ? [_c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.solicitacao.fbb !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' para Fundação BB</h5>'
	    }
	  }, [_c('span', {
	    class: 'valor_alterado ' + (_vm.totais.solicitacao.fbb > 0 ? 'acrescimo_valor' : (_vm.totais.solicitacao.fbb < 0 ? 'diminuicao_valor' : ''))
	  }, [_c('i', {
	    class: (_vm.totais.solicitacao.fbb > 0 ? 'fa fa-plus-circle' : (_vm.totais.solicitacao.fbb < 0 ? 'fa fa-minus-circle' : ''))
	  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.solicitacao.fbb))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.solicitacao.parceiros !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' para Parceiros Estratégicos</h5>'
	    }
	  }, [_c('span', {
	    class: 'valor_alterado ' + (_vm.totais.solicitacao.parceiros > 0 ? 'acrescimo_valor' : (_vm.totais.solicitacao.parceiros < 0 ? 'diminuicao_valor' : ''))
	  }, [_c('i', {
	    class: (_vm.totais.solicitacao.parceiros > 0 ? 'fa fa-plus-circle' : (_vm.totais.solicitacao.parceiros < 0 ? 'fa fa-minus-circle' : ''))
	  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.solicitacao.parceiros))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.solicitacao.contrapartida !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' para Contrapartida</h5>'
	    }
	  }, [_c('span', {
	    class: 'valor_alterado ' + (_vm.totais.solicitacao.contrapartida > 0 ? 'acrescimo_valor' : (_vm.totais.solicitacao.contrapartida < 0 ? 'diminuicao_valor' : ''))
	  }, [_c('i', {
	    class: (_vm.totais.solicitacao.contrapartida > 0 ? 'fa fa-plus-circle' : (_vm.totais.solicitacao.contrapartida < 0 ? 'fa fa-minus-circle' : ''))
	  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.solicitacao.contrapartida))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.solicitacao.adiantavel > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' em itens Adiantáveis</h5>'
	    }
	  }, [_c('span', {
	    class: 'valor_alterado ' + (_vm.totais.solicitacao.adiantavel > 0 ? 'acrescimo_valor' : (_vm.totais.solicitacao.adiantavel < 0 ? 'diminuicao_valor' : ''))
	  }, [_c('i', {
	    class: (_vm.totais.solicitacao.adiantavel > 0 ? 'fa fa-plus-circle' : (_vm.totais.solicitacao.adiantavel < 0 ? 'fa fa-minus-circle' : ''))
	  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.solicitacao.adiantavel))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.layoutSolicitacao === 'SUPLEMENTACAO') ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' neste projeto</h5>'
	    }
	  }, [_c('span', {
	    class: 'valor_alterado ' + ((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) > 0 ? 'acrescimo_valor' : ((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) < 0 ? 'diminuicao_valor' : ''))
	  }, [_c('i', {
	    class: ((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) > 0 ? 'fa fa-plus-circle' : ((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) < 0 ? 'fa fa-minus-circle' : ''))
	  }), _vm._v(" " + _vm._s(_vm._f("real")((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  })]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor b1 atividade"
	  }, [(_vm.totais.solicitacao.fbb !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total Fundação BB após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.fbb.orcado + _vm.totais.solicitacao.fbb))) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor b1 atividade"
	  }, [(_vm.totais.solicitacao.parceiros !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total em Parceiros Estratégicos após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.parceiros.orcado + _vm.totais.solicitacao.parceiros))) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor b1 atividade"
	  }, [(_vm.totais.solicitacao.contrapartida !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total de Contrapartida após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.contrapartida.orcado + _vm.totais.solicitacao.contrapartida))) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor b1 atividade"
	  }, [(_vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total de itens Adiantáveis após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.adiantavel.total.orcado + _vm.totais.adiantavel.total.alterado))) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor b1 atividade"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Total do projeto após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida + _vm.totais.projeto.total.orcado))) + "\n                ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.solicitacao.percentual > 0.25) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v("Acima de 25%")]) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.layoutSolicitacao === 'REMANEJAMENTO' && (_vm.totais.projeto.fbb.alterado !== 0 || _vm.totais.projeto.parceiros.alterado !== 0 || _vm.totais.projeto.contrapartida.alterado !== 0 || _vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0)) ? _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.fbb.alterado !== 0 && _vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": (_vm.totais.projeto.fbb.alterado > 0 ? '<h5>O total alterado esta com diferença positiva de <span class=\'realce\'>' + _vm.totais.projeto.fbb.alterado + '</span> e precisa ser ´zerado´ subtraindo este valor de um ou mais itens para permitir o remanejamento' :
	        (_vm.totais.projeto.fbb.alterado < 0 ? '<h5>O total alterado esta com diferença de negativa de <span class=\'realce\'>' + _vm.totais.projeto.fbb.alterado + '</span> e precisa ser ´zerado´ acrescendo este valor em um ou mais itens ou criando itens novos para permitir o remanejamento' : ''))
	    }
	  }, [_c('span', {
	    class: 'valor_alterado label-danger'
	  }, [_c('i', {
	    class: (_vm.totais.projeto.fbb.alterado > 0 ? 'fa fa-plus' : (_vm.totais.projeto.fbb.alterado < 0 ? 'fa fa-minus' : ''))
	  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.fbb.alterado))) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.parceiros.alterado !== 0 && _vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": (_vm.totais.projeto.parceiros.alterado > 0 ? '<h5>O total alterado esta com diferença positiva de <span class=\'realce\'>' + _vm.totais.projeto.parceiros.alterado + '</span> e precisa ser ´zerado´ subtraindo este valor de um ou mais itens para permitir o remanejamento' :
	        (_vm.totais.projeto.parceiros.alterado < 0 ? '<h5>O total alterado esta com diferença de negativa de <span class=\'realce\'>' + _vm.totais.projeto.parceiros.alterado + '</span> e precisa ser ´zerado´ acrescendo este valor em um ou mais itens ou criando itens novos para permitir o remanejamento' : ''))
	    }
	  }, [_c('span', {
	    class: 'valor_alterado label-danger'
	  }, [_c('i', {
	    class: (_vm.totais.projeto.parceiros.alterado > 0 ? 'fa fa-plus' : (_vm.totais.projeto.parceiros.alterado < 0 ? 'fa fa-minus' : ''))
	  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.parceiros.alterado))) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.contrapartida.alterado !== 0 && _vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": (_vm.totais.projeto.contrapartida.alterado > 0 ? '<h5>O total alterado esta com diferença positiva de <span class=\'realce\'>' + _vm.totais.projeto.contrapartida.alterado + '</span> e precisa ser ´zerado´ subtraindo este valor de um ou mais itens para permitir o remanejamento</h5>' :
	        (_vm.totais.projeto.contrapartida.alterado < 0 ? '<h5>O total alterado esta com diferença de negativa de <span class=\'realce\'>' + _vm.totais.projeto.contrapartida.alterado + '</span> e precisa ser ´zerado´ acrescendo este valor em um ou mais itens ou criando itens novos para permitir o remanejamento</h5>' : ''))
	    }
	  }, [_c('span', {
	    class: 'valor_alterado label-danger'
	  }, [_c('i', {
	    class: (_vm.totais.projeto.contrapartida.alterado > 0 ? 'fa fa-plus' : (_vm.totais.projeto.contrapartida.alterado < 0 ? 'fa fa-minus' : ''))
	  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.contrapartida.alterado))) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [((_vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0) && _vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": (_vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0 ? '<h5>O total alterado nos Itens Adiantáveis esta com diferença. ' +
	        (_vm.totais.adiantavel.fbb.alterado !== 0 ? '<br/>Nos recursos Fundação BB a diferença é de <span class=\'realce\'>' + _vm.totais.adiantavel.fbb.alterado + '</span> e precisa ser ´zerado´ ajustando o valor somente em <i>itens adiantáveis</i> nesse remanejamento' : '') +
	        (_vm.totais.adiantavel.parceiros.alterado !== 0 ? '<br/>Nos recursos de Parc. Estratégico a diferença é de <span class=\'realce\'>' + _vm.totais.adiantavel.parceiros.alterado + '</span> e precisa ser ´zerado´ ajustando o valor somente em <i>itens adiantáveis</i> nesse remanejamento' : '') : '') + '</h5>'
	    }
	  }, [_c('span', {
	    class: 'valor_alterado label-danger'
	  }, [(_vm.totais.adiantavel.fbb.alterado !== 0) ? _c('span', [_c('i', {
	    class: (_vm.totais.adiantavel.fbb.alterado > 0 ? 'fa fa-plus' : (_vm.totais.adiantavel.fbb.alterado < 0 ? 'fa fa-minus' : ''))
	  }), _vm._v("\n                    " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.adiantavel.fbb.alterado))) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.totais.adiantavel.fbb.alterado !== 0 && _vm.totais.adiantavel.parceiros.alterado !== 0) ? _c('span', [_vm._v(" e ")]) : _vm._e(), _vm._v(" "), (_vm.totais.adiantavel.parceiros.alterado !== 0) ? _c('span', [_c('i', {
	    class: (_vm.totais.adiantavel.parceiros.alterado > 0 ? 'fa fa-plus' : (_vm.totais.adiantavel.parceiros.alterado < 0 ? 'fa fa-minus' : ''))
	  }), _vm._v("\n                    " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.adiantavel.parceiros.alterado))) + "\n                  ")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  })]) : _vm._e()], 2) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - E-mails Enviados'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Configurações")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row collapse in",
	    staticStyle: {
	      "width": "inherit",
	      "height": "auto"
	    },
	    attrs: {
	      "aria-expanded": "true",
	      "aria-hidden": "false"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "busy": _vm.isBusy,
	      "bordered": _vm.bordered,
	      "items": _vm.items,
	      "hover": _vm.hover,
	      "fields": _vm.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado",
	      "table-layout:": "",
	      "fixed": ""
	    },
	    on: {
	      "update:busy": function($event) {
	        _vm.isBusy = $event
	      },
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "ds_desc_erro",
	      fn: function(row) {
	        return [(row.item.DescErro === 'null') ? _c('div', [_vm._v("-")]) : _c('div', [_vm._v(_vm._s(row.value))])]
	      }
	    }, {
	      key: "dt_criado",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "ds_sucesso",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    on: {
	      "change": _vm.onSearch
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Log's de Email")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  })])
	}]}

/***/ }),
/* 1911 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Analise',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ng-init": "check()"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.simplified),
	      expression: "proposta.simplified"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "hidden",
	      "name": "tipo",
	      "id": "tipo",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.proposta.simplified)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "simplified", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('NAME')"
	    }
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.idProjectErp),
	      expression: "proposta.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.name),
	      expression: "proposta.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorName),
	      expression: "proposta.coordinatorName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorCpf", $$v)
	      },
	      expression: "proposta.coordinatorCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorEmail),
	      expression: "proposta.coordinatorEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorPhone", $$v)
	      },
	      expression: "proposta.coordinatorPhone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorMobile", $$v)
	      },
	      expression: "proposta.coordinatorMobile"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Fax')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorFax", $$v)
	      },
	      expression: "proposta.coordinatorFax"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Fax')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.proposta.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                      " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                      " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                    ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required-field",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope ",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.proposta.initialDate),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "initialDate", $$v)
	      },
	      expression: "proposta.initialDate"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periods),
	      expression: "proposta.periods"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.proposta.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.introduction),
	      expression: "proposta.introduction"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "introduction", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.presentation),
	      expression: "proposta.presentation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.territory),
	      expression: "proposta.territory"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.justification),
	      expression: "proposta.justification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.generalObjective),
	      expression: "proposta.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.summary),
	      expression: "proposta.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": this.proposta.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": this.proposta.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.teams = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.results),
	      expression: "proposta.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "results", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.operation),
	      expression: "proposta.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "operation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group  required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.partner),
	      expression: "proposta.partner"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "partner", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.proposta.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.proposta.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                ")])])]), _vm._v(" "), (_vm.proposta.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingName),
	      expression: "proposta.entityExecutingName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingProcurator),
	      expression: "proposta.entityExecutingProcurator"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|cnpj'),
	      expression: "'required:!proposta.entityIsExecutioner|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCNPJ", $$v)
	      },
	      expression: "proposta.entityExecutingCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingEmail),
	      expression: "proposta.entityExecutingEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|email'),
	      expression: "'required:!proposta.entityIsExecutioner|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingPhone", $$v)
	      },
	      expression: "proposta.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingMobile", $$v)
	      },
	      expression: "proposta.entityExecutingMobile"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingFax", $$v)
	      },
	      expression: "proposta.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.duplicateProject),
	      expression: "proposta.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber) + "/" + _vm._s(projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(7), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(9), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraCronograma),
	      expression: "mostraCronograma"
	    }],
	    staticClass: "col-md-12"
	  }, [_vm._m(10), _vm._v(" "), _c('cronograma', {
	    attrs: {
	      "proposta": _vm.proposta,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades,
	      "meses": _vm.proposta.periods,
	      "projeto-duplicacao": _vm.proposta.duplicateProject
	    },
	    on: {
	      "itemAdicionado": _vm.atualizaCronograma
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('gantt', {
	    attrs: {
	      "periodo": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(11), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.careers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(12), _vm._v(" "), _c('solenizacao', {
	    attrs: {
	      "propsSolenizacao": _vm.proposta.solemnizations
	    },
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.proposta.solemnizations = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documents,
	      "documentTypes": _vm.proposta.documentTypes,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(14), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documentStatements,
	      "documentTypes": [],
	      "documentosObrigatorios": []
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(15), _vm._v(" "), _c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta,
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  })], 1)])])])]), _vm._v(" "), _c('analise', {
	    attrs: {
	      "propsAnalise": _vm.analise
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                          outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	}]}

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "content-wrapper ods-main-container"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Registro de ODS Fundação BB'
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'ODS',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "ods-content"
	  }, [_c('odsCadastro')], 1), _vm._v(" "), _c('vue-snotify')], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('span', [_vm._v("Objetivos de Desenvolvimento Sustentável (ODS) - Favoritos Fundação BB")])])
	}]}

/***/ }),
/* 1913 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('fieldset', [_c('table', {
	    staticClass: "table table-condensed table-bordered",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Parcela")]), _vm._v(" "), _c('th', [_vm._v("Recurso")]), _vm._v(" "), _c('th', [_vm._v("Fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total por fase")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar por fase")]), _vm._v(" "), _c('th', [_vm._v("Saldo restante por fase")]), _vm._v(" "), (_vm.propsFase === 'Análise Financeira') ? _c('th', [_vm._v("Número título")]) : _vm._e(), _vm._v(" "), (_vm.propsFase === 'Análise Financeira') ? _c('th', [_vm._v("Conta Financeira")]) : _vm._e(), _vm._v(" "), (_vm.propsFase !== 'Análise Financeira') ? _c('th', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itens), function(item) {
	    return _c('tr', {
	      attrs: {
	        "disabled": "true"
	      }
	    }, [_c('td', [_vm._v(_vm._s(item.parcelas_adiantamentos[0].parcela))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rotuloOrigemParcela(item.parcelas_adiantamentos[0].origem)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.parcelas_adiantamentos[0].origem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.parcelas_adiantamentos[0].valor)))]), _vm._v(" "), (item.editando === false || !item.editando) ? _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valor ? item.valor : 0)))]) : _vm._e(), _vm._v(" "), (item.editando === true) ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('money', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control text-right",
	      class: {
	        'has-error': _vm.errors.first('valor')
	      },
	      attrs: {
	        "name": "valor",
	        "type": "text",
	        "disabled": item.totalValueRequested > 0 || !_vm.propsEnable
	      },
	      model: {
	        value: (item.valor),
	        callback: function($$v) {
	          _vm.$set(item, "valor", $$v)
	        },
	        expression: "item.valor"
	      }
	    })], 1) : _vm._e(), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.parcelas_adiantamentos[0].valor - (item.valor ? item.valor : 0))))]), _vm._v(" "), (_vm.propsFase === 'Análise Financeira') ? _c('td', {
	      staticClass: "text-right"
	    }, [_c('div', {
	      staticClass: "input-group",
	      class: {
	        'has-error': _vm.errors.first('Número título')
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.numeroTitulo),
	        expression: "item.numeroTitulo"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "type": "number",
	        "name": "Número título"
	      },
	      domProps: {
	        "value": (item.numeroTitulo)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "numeroTitulo", $event.target.value)
	        }
	      }
	    })])]) : _vm._e(), _vm._v(" "), (_vm.propsFase === 'Análise Financeira') ? _c('td', {
	      staticClass: "text-right form-group required-field"
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.contaFinanceira),
	        expression: "item.contaFinanceira"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      class: {
	        'has-error': _vm.errors.first('conta financeira')
	      },
	      attrs: {
	        "name": "conta financeira",
	        "aria-hidden": "true"
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(item, "contaFinanceira", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((_vm.contasFinanceiras), function(conta) {
	      return _c('option', {
	        domProps: {
	          "value": conta.ctared
	        }
	      }, [_vm._v(_vm._s(conta.ctared) + " / " + _vm._s(conta.descta))])
	    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propsFase !== 'Análise Financeira') ? _c('td', {
	      staticClass: "text-center"
	    }, [(!item.editando && _vm.propsEnable) ? _c('i', {
	      staticClass: "fa fa-edit",
	      staticStyle: {
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editando) ? _c('i', {
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green",
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editando) ? _c('i', {
	      staticClass: "fa fa-times",
	      staticStyle: {
	        "color": "red",
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.cancelaEdicao(item)
	        }
	      }
	    }) : _vm._e()]) : _vm._e()])
	  }), 0), _vm._v(" "), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', {
	    directives: [{
	      name: "default",
	      rawName: "v-default",
	      value: (_vm.atualizaCalculoGrid(_vm.item)),
	      expression: "atualizaCalculoGrid(item)"
	    }]
	  }, [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Total valor solicitado:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalSolicitacao)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor disponível para solicitação nesta parcela:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalDisponivel - _vm.valorTotalSolicitacao)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor total liberado para solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalDisponivel)))])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Parcelas Adiantáveis")])])
	}]}

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper container-licencas",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "column all-centered container-validacao box-body"
	  }, [_c('validacaoLicencas', {
	    attrs: {
	      "idProposta": null,
	      "nomeProjeto": null,
	      "numeroProjeto": null,
	      "todasLicencas": true
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-primary",
	    attrs: {
	      "id": "formalizacao"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Formalização"), (_vm.propsFormalizacao.ds_codigo_projeto_erp) ? _c('span', [_vm._v("  do projeto "), _c('b', [_vm._v(_vm._s(_vm.propsFormalizacao.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "cmptDocPreparationForm",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('legend', [_vm._v("Conta Impessoal (Transitória - DEB)")]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Banco")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "banco",
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.formalizacao.ds_agencia_banco) + " - Banco do Brasil")])])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('agencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Agência")]), _vm._v(" "), _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|agency'),
	      expression: "'required|agency'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "agencia",
	      "mask": ['####-X'],
	      "tokens": _vm.customTokens,
	      "masked": true
	    },
	    model: {
	      value: (_vm.formalizacao.ds_agencia_nome),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao, "ds_agencia_nome", $$v)
	      },
	      expression: "formalizacao.ds_agencia_nome"
	    }
	  }), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('conta corrente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Conta Corrente")]), _vm._v(" "), _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|contacorrente'),
	      expression: "'required|contacorrente'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "tokens": _vm.customTokens,
	      "name": "conta corrente",
	      "masked": true,
	      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X']
	    },
	    model: {
	      value: (_vm.formalizacao.ds_agencia_conta_corrente),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao, "ds_agencia_conta_corrente", $$v)
	      },
	      expression: "formalizacao.ds_agencia_conta_corrente"
	    }
	  }), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4",
	    class: {
	      'required-field': _vm.propsAdiantaveis
	    }
	  }, [_c('legend', [_vm._v("Conta Corrente (Adiantamento)")]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Banco")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "banco",
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.formalizacao.ds_agencia_banco) + " - Banco do Brasil")])])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('agencia de adiantamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Agência")]), _vm._v(" "), _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('agency'),
	      expression: "'agency'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "agencia de adiantamento",
	      "mask": ['####-X'],
	      "tokens": _vm.customTokens,
	      "masked": true
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.verificarInputContaAdiantamento($event)
	      }
	    },
	    model: {
	      value: (_vm.formalizacao.ds_agencia_adiantamento),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao, "ds_agencia_adiantamento", $$v)
	      },
	      expression: "formalizacao.ds_agencia_adiantamento"
	    }
	  }), _vm._v(" "), (_vm.errors.first('agencia de adiantamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia de adiantamento')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('conta corrente de adiantamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Conta Corrente")]), _vm._v(" "), _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('contacorrente'),
	      expression: "'contacorrente'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "tokens": _vm.customTokens,
	      "name": "conta corrente de adiantamento",
	      "masked": true,
	      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X']
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.verificarInputContaAdiantamento($event)
	      }
	    },
	    model: {
	      value: (_vm.formalizacao.ds_conta_adiantamento),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao, "ds_conta_adiantamento", $$v)
	      },
	      expression: "formalizacao.ds_conta_adiantamento"
	    }
	  }), _vm._v(" "), (_vm.errors.first('conta corrente de adiantamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('conta corrente de adiantamento')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("MCI")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.mci),
	      expression: "formalizacao.mci"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.formalizacao.mci)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formalizacao, "mci", $event.target.value)
	      }, _vm.limitarDigitosMCI]
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('legend', [_vm._v("Datas")]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field-field",
	    class: {
	      'has-error': _vm.errors.first('data proposta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data da Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data proposta",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": false,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": _vm.validaDatas
	    },
	    model: {
	      value: (_vm.formalizacao.dt_proposta),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao, "dt_proposta", $$v)
	      },
	      expression: "formalizacao.dt_proposta"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data proposta')))]) : _vm._e()])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data análise')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de análise")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data análise",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": false,
	      "placeholder": "__/__/____",
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": _vm.validaDatas
	    },
	    model: {
	      value: (_vm.formalizacao.dt_analise),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao, "dt_analise", $$v)
	      },
	      expression: "formalizacao.dt_analise"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data análise')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data análise')))]) : _vm._e()])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data deferimento')
	    },
	    attrs: {
	      "uib-tooltip": "Data de deferimento"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de deferimento")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data deferimento",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": false,
	      "placeholder": "__/__/____",
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": _vm.validaDatas
	    },
	    model: {
	      value: (_vm.propsFormalizacao.dt_deferimento),
	      callback: function($$v) {
	        _vm.$set(_vm.propsFormalizacao, "dt_deferimento", $$v)
	      },
	      expression: "propsFormalizacao.dt_deferimento"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data deferimento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data deferimento')))]) : _vm._e()])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data assinatura')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de assinatura do convênio")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data assinatura",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "use-utc": false,
	      "format": "dd/MM/yyyy",
	      "placeholder": "__/__/____"
	    },
	    on: {
	      "change": _vm.datas
	    },
	    model: {
	      value: (_vm.formalizacao.dt_assinatura_convenio),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao, "dt_assinatura_convenio", $$v)
	      },
	      expression: "formalizacao.dt_assinatura_convenio"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data assinatura')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data assinatura')))]) : _vm._e(), _vm._v(" "), _c('span', [_c('i', [_c('font', {
	    attrs: {
	      "size": "1"
	    }
	  }, [_vm._v("* Data de assinatura do convênio deve ser igual ou posterior a Data de deferimento")])], 1)])])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data vigência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de Vigência do Projeto")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.formalizacao.dt_data_vigencia, "L")))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.formalizacao.hasOwnProperty('agenciaSelecionada')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Dados Complementares (Salve antes de gerar a minuta)")]), _vm._v(" "), _c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Agência: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.agenciaSelecionada.agencia),
	      expression: "formalizacao.agenciaSelecionada.agencia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Número da Agência"
	    },
	    domProps: {
	      "value": (_vm.formalizacao.agenciaSelecionada.agencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formalizacao.agenciaSelecionada, "agencia", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome da Agência: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.agenciaSelecionada.nomeAgencia),
	      expression: "formalizacao.agenciaSelecionada.nomeAgencia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Nome da Agência"
	    },
	    domProps: {
	      "value": (_vm.formalizacao.agenciaSelecionada.nomeAgencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formalizacao.agenciaSelecionada, "nomeAgencia", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Agência CNPJ: ")]), _vm._v(" "), _c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "CNPJ da Agência",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.formalizacao.agenciaSelecionada.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao.agenciaSelecionada, "cnpj", $$v)
	      },
	      expression: "formalizacao.agenciaSelecionada.cnpj"
	    }
	  })], 1)]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome Gerente: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.nome),
	      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.nome"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Nome do Gerente Geral"
	    },
	    domProps: {
	      "value": (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "nome", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Estado Civil Gerente: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.estadoCivil),
	      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.estadoCivil"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "estadoCivil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "[ESTADO CIVIL GERENTE]"
	    }
	  }, [_vm._v("Estado Civil do Gerente Geral")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "solteiro"
	    }
	  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "casado"
	    }
	  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "divorciado"
	    }
	  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "viuvo"
	    }
	  }, [_vm._v("Viúvo(a)")])])])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("RG Gerente: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.rg),
	      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.rg"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "RG do Gerente Geral"
	    },
	    domProps: {
	      "value": (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.rg)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "rg", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF Gerente: ")]), _vm._v(" "), _c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "CPF do Gerente Geral",
	      "mask": "###.###.###-##"
	    },
	    model: {
	      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "cpf", $$v)
	      },
	      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.cpf"
	    }
	  })], 1)]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Município Gerente: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.municipioResidencia),
	      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.municipioResidencia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Município de Residencia do Gerente Geral"
	    },
	    domProps: {
	      "value": (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.municipioResidencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "municipioResidencia", $event.target.value)
	      }
	    }
	  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Documentos de Deferimento")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "disable": true,
	      "propDocumentos": _vm.formalizacao.documentos.deferimento,
	      "documentTypes": '',
	      "documentosObrigatorios": '',
	      "localUso": 'PROPOSTA_DEFERIMENTO'
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Documentos da Formalização")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(0), _vm._v(" "), (!_vm._.includes(_vm.editaisComMinuta, _vm.formalizacao.fk_edital)) ? _c('div', {
	    staticClass: "row-flex all-start gap-10"
	  }, [_c('label', [_vm._v("Minuta para Proposta Simplificada:")]), _vm._v(" " + _vm._s(_vm.formalizacao.fk_edital) + "\n                  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.minutaSimplificada),
	      expression: "minutaSimplificada"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.minutaAdicional !== ''
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.minutaSimplificada) ? _vm._i(_vm.minutaSimplificada, null) > -1 : (_vm.minutaSimplificada)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.minutaSimplificada,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.minutaSimplificada = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.minutaSimplificada = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.minutaSimplificada = $$c
	        }
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.formalizacao.fk_edital) ? _c('div', {
	    staticClass: "row-flex all-start gap-10",
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_c('label', [_vm._v("Minuta adicional (opcional):")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.minutaAdicional),
	      expression: "minutaAdicional"
	    }],
	    staticClass: "form-control respostaFav",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.minutaAdicional = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Padrão (pela regra do projeto)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "POVOS_PRIORIZADOS"
	    }
	  }, [_vm._v("Povos Priorizados e Dirigentes")])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.editaisComMinuta, _vm.formalizacao.fk_edital)) ? _c('div', {
	    staticStyle: {
	      "color": "red",
	      "margin-bottom": "10px"
	    }
	  }, [_vm._v("\n                *Edital com minuta exclusiva\n              ")]) : _vm._e(), _vm._v(" "), (_vm.formalizacao.fk_edital == 9) ? _c('div', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoMinutaEcoforte),
	      expression: "tipoMinutaEcoforte"
	    }],
	    staticClass: "form-control respostaFav",
	    attrs: {
	      "disabled": _vm.minutaAdicional !== ''
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.tipoMinutaEcoforte = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Edital Ecoforte: Selecione o tipo de minuta que será gerada.")]), _vm._v(" "), _c('option', {
	    domProps: {
	      "value": 1
	    }
	  }, [_vm._v("Ecoforte: BNDES (Sudeste, Sul, Centro-Oeste e Nordeste)")]), _vm._v(" "), _c('option', {
	    domProps: {
	      "value": 2
	    }
	  }, [_vm._v("Ecoforte: Fundo Amazônia")])])]) : _vm._e(), _vm._v(" "), (_vm.formalizacao.fk_edital == 9) ? _c('div', [(_vm.tipoMinutaEcoforte !== '' || _vm.minutaAdicional !== '') ? _c('g-button-ujarak', {
	    attrs: {
	      "type": "button",
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gerarMinutaAutomatica()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Gerar Minuta")]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    ref: "planoTrabalhoLink",
	    staticClass: "btn btn-primary btn-sm btn-flat botao-plano",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'plano-trabalho',
	        params: {
	          id: _vm.$route.params.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v("  Plano de Trabalho")])], 1) : _c('div', [_c('g-button-ujarak', {
	    attrs: {
	      "type": "button",
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gerarMinutaAutomatica()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Gerar Minuta")]), _vm._v(" "), _c('router-link', {
	    ref: "planoTrabalhoLink",
	    staticClass: "btn btn-primary btn-sm btn-flat botao-plano",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'plano-trabalho',
	        params: {
	          id: _vm.$route.params.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v("  Plano de Trabalho")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.formalizacaoDocumentos,
	      "documentTypes": _vm.tiposDocumentos,
	      "documentosObrigatorios": '',
	      "local-uso": 'TODOS',
	      "faseProposta": _vm.propsFormalizacao.ds_fase
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v(" Ficha de Auto Verificação")]), _vm._v(" "), _vm._l((_vm.perguntasFAV), function(item) {
	    return _c('div', [(item.nivel === 3) ? _c('label', {
	      staticClass: "control-label col-md-10",
	      class: 'favNivel' + item.nivel
	    }, [_vm._v(_vm._s(item.numero) + " " + _vm._s(item.pergunta))]) : _vm._e(), _vm._v(" "), (item.nivel !== 3) ? _c('span', {
	      staticClass: "control-label col-md-10",
	      class: 'favNivel' + item.nivel
	    }, [_vm._v(_vm._s(item.pergunta))]) : _vm._e(), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	      }],
	      staticClass: "col-md-1",
	      staticStyle: {
	        "alignment": "left"
	      },
	      attrs: {
	        "title": '<h5>Pergunta <span class=\'realce\'>' + item.numero + '</span></h5>'
	      }
	    }, [(item.nivel === 3) ? _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.resposta),
	        expression: "item.resposta"
	      }],
	      staticClass: "form-control respostaFav",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(item, "resposta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.verificarFAV]
	      }
	    }, _vm._l((_vm.respostaFAV), function(opcao) {
	      return _c('option', {
	        domProps: {
	          "value": opcao.valor
	        }
	      }, [_vm._v(_vm._s(opcao.resposta))])
	    }), 0) : _vm._e()])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('aprovacao')
	    },
	    attrs: {
	      "uib-tooltip": "Decisões da preparação de documentos"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.resultadoAprovacao),
	      expression: "formalizacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "aprovacao",
	      "value": "APROVAR"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.formalizacao.resultadoAprovacao, "APROVAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.formalizacao, "resultadoAprovacao", "APROVAR")
	      }
	    }
	  }), _vm._v("\n                  Formalizar o Projeto\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.resultadoAprovacao),
	      expression: "formalizacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "aprovacao",
	      "value": "VOLTAR_ANALISE",
	      "id": "msgDef"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.formalizacao.resultadoAprovacao, "VOLTAR_ANALISE")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.formalizacao, "resultadoAprovacao", "VOLTAR_ANALISE")
	      }
	    }
	  }), _vm._v("\n                  Devolver para Reanálise\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('aprovacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('aprovacao')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.formalizacao.resultadoAprovacao === 'VOLTAR_ANALISE') ? _c('div', {
	    staticClass: "form-group full col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formalizacao.justificativa),
	      expression: "formalizacao.justificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa"
	    },
	    domProps: {
	      "value": (_vm.formalizacao.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formalizacao, "justificativa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "help-block",
	    staticStyle: {
	      "background-color": "#e7f3ff",
	      "padding": "10px",
	      "border-radius": "5px",
	      "margin-bottom": "15px"
	    }
	  }, [_vm._v("\n                *Antes de gerar a minuta, certifique-se de que o "), _c('b', [_vm._v("cadastro da entidade está concluído")]), _vm._v(" e que os representantes "), _c('b', [_vm._v("estejam selecionados")]), _vm._v(".\n              ")])
	}]}

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Visualizar Relatório de Análise\n        "), (!_vm.loading.show) ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.closewindow($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sair do relatório ")])], 1) : _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.proposta.ds_codigo_projeto_erp == null) ? _c('span', {
	    staticClass: "alertaCamposPendentes"
	  }, [_vm._v(" " + _vm._s(_vm.proposta.ds_codigo_projeto_erp) + "ALERTA: Após o preenchimento da proposta e geração do número de projeto o relatório disponibilizará todos os seus efetivos campos.")]) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Validação',
	        href: '/'
	      }, {
	        text: 'Propostas',
	        href: '#'
	      }, {
	        text: 'Relatório de Análise',
	        active: true
	      }]
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "column all-centered etapa-carga-log-button",
	    attrs: {
	      "title": '<h5>Verificar Log de Carregamento</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrarLogCarga = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-warning"
	  })])], 1), _vm._v(" "), (_vm.mostrarLogCarga) ? _c('div', {
	    staticClass: "column centered-start etapa-carga-container"
	  }, [(_vm.mostrarAviso) ? _c('div', {
	    staticClass: "column all-centered etapa-aviso-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row-flex start-centered etapa-aviso-button-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered etapa-button-ok",
	    on: {
	      "click": function($event) {
	        _vm.mostrarLogCarga = false
	      }
	    }
	  }, [_vm._v("\n            Estou Ciente, continuar.\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered etapa-button-reload",
	    on: {
	      "click": function($event) {
	        return _vm.recarregarRelatorio()
	      }
	    }
	  }, [_vm._v("\n            Recarregar Relatório.\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start etapa-carga-content"
	  }, [_c('div', {
	    staticClass: "column all-end etapa-close-container"
	  }, [_c('i', {
	    staticClass: "fa fa-close etapa-close-button",
	    on: {
	      "click": function($event) {
	        _vm.mostrarLogCarga = false
	      }
	    }
	  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.etapaCarga), function(etapa, index) {
	    return _c('div', {
	      staticClass: "column all-centered etapa-carga-info"
	    }, [_c('div', {
	      staticClass: "row-flex centered-between etapa-carga-row"
	    }, [_c('div', {
	      staticClass: "row-flex etapa-carga-nome"
	    }, [_vm._v("\n              " + _vm._s(index + 1) + " - " + _vm._s(etapa.nome) + "\n            ")]), _vm._v(" "), _c('div', {
	      staticClass: "row-flex all-centered etapa-carga-status",
	      class: etapa.status === 'OK' ? 'status-ok' : etapa.status === 'Carregando' ? 'status-carregando' : 'status-erro'
	    }, [_vm._v("\n              " + _vm._s(etapa.status) + " "), (etapa.status === 'Carregando') ? _c('i', {
	      staticClass: "fa fa-refresh ga-spin"
	    }) : _vm._e(), _vm._v(" "), (etapa.status === 'OK') ? _c('i', {
	      staticClass: "fa fa-check-circle"
	    }) : _vm._e(), _vm._v(" "), (etapa.status === 'ERRO') ? _c('i', {
	      staticClass: "fa fa-warning"
	    }) : _vm._e()])]), _vm._v(" "), (etapa.erro) ? _c('div', {
	      staticClass: "column start-centered etapa-carga-erro-container"
	    }, [(etapa.erro.response) ? _c('div', [_vm._v("\n              " + _vm._s(etapa.nome) + " | " + _vm._s(etapa.erro.response.data.message) + "\n            ")]) : _c('div', [_vm._v("\n              " + _vm._s(etapa.nome) + " | " + _vm._s(etapa.erro) + "\n            ")])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    attrs: {
	      "id": "relatorio_analise"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": _vm.proposta.ds_fase !== 'ANALISE'
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('table', {
	    staticClass: "w100"
	  }, [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
	    staticClass: "w50"
	  }, [_c('h4', {
	    staticClass: "titulo ressaltar"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "20px !important",
	      "font-family": "sans-serif"
	    }
	  }, [_vm._v("RELATÓRIO DE ANÁLISE")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.ehVoluntariado) ? _c('span', [_vm._v("Alçada do Comitê de Desenvolvimento Social")]) : _c('span', [_vm._v("Alçada do " + _vm._s(_vm.faixaDoProjeto.alcada))])])]), _vm._v(" "), (_vm.proposta.ds_codigo_projeto_erp) ? _c('td', {
	    staticClass: "w20"
	  }, [_c('h4', {
	    staticClass: "ressaltar text-right",
	    staticStyle: {
	      "font-size": "28px !important",
	      "text-transform": "uppercase"
	    }
	  }, [_vm._v("Projeto nº " + _vm._s(_vm.proposta.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), (!_vm.ehSimplificada) ? _c('div', [_c('div', {
	    staticClass: "titulo nao_imprimir alertaCamposPendentes"
	  }, [_vm._v("Modelo de Relatório de Análise para projetos " + _vm._s(_vm.ehPIS ? 'do PIS' : (_vm.ehVoluntariado ? 'de Voluntariado' : '')) + " entre " + _vm._s(_vm._f("real")(_vm.faixaDoProjeto.de)) + " à " + _vm._s(_vm._f("real")(_vm.faixaDoProjeto.para)))])]) : _vm._e(), _vm._v(" "), (_vm.ehSimplificada) ? _c('div', [_c('div', {
	    staticClass: "titulo nao_imprimir alertaCamposPendentes"
	  }, [_vm._v("Modelo de Relatório de Análise para projetos até R$ 300.000,00")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Projetos da Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.todasPropostas), function(projetos) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(projetos.ds_codigo_projeto_erp))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(projetos.ds_nome))]), _vm._v(" "), (projetos.ds_situacao_erp !== null) ? _c('td', {
	      staticClass: "situacao_projeto text-center"
	    }, [_vm._v(_vm._s(projetos.ds_situacao_erp))]) : _vm._e(), _vm._v(" "), (projetos.ds_situacao_erp === null) ? _c('td', {
	      staticClass: "situacao_projeto text-center"
	    }, [_vm._v("Não aprovado, fase de\n                            "), (projetos.ds_fase === 'ANALISE') ? _c('span', [_vm._v("Análise")]) : _vm._e(), _vm._v(" "), (projetos.ds_fase === 'DEFERIMENTO') ? _c('span', [_vm._v("Deferimento")]) : _vm._e(), _vm._v(" "), (projetos.ds_fase === 'FORMALIZACAO') ? _c('span', [_vm._v("Formalização")]) : _vm._e()]) : _vm._e()])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])]), _vm._v(" "), (_vm.proposta.nr_projeto_duplicacao) ? _c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Projeto Superior")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.projetoSuperior))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm._.has(_vm.proposta, 'ds_fep_tipo_acao') ? (_vm.proposta.ds_fep_tipo_acao === 'AT' ? 'AT - Ação Tática' : (_vm.proposta.ds_fep_tipo_acao === 'AF' ? 'AF - Ação Finalística' : (_vm.proposta.ds_fep_tipo_acao === 'ISD' ? 'ISD - Investimento Social Direto' : 'Ação não informada'))) : 'Ação não informada'))])]), _vm._v(" "), (_vm.proposta) ? _c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Abrangência Nacional")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.bt_fep_abrangencia === '1' ? 'S - Sim' : 'N - Não'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Período Início e Fim Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ehNulo(_vm.proposta.dt_assinatura_convenio, _vm.proposta.dt_data_inicial), "MM/YYYY")) + "  a  " + _vm._s(_vm.dataFinalProjeto))]), _vm._v(" "), _c('td', [_vm._v("Prazo de execução")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.nr_periodos) + " meses")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('th', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)) + " ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida)) + " ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "34%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalParceiro)) + " ")])])]), _vm._v(" "), (_vm.ehVoluntariado || _vm.ehEditalMN) ? _c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("*A contrapartida corresponde a " + _vm._s(this.$root.formataNumero((_vm.totalContrapartida / _vm.totalFBB), 'percentual')) + "% do valor aportado pela FBB.")])]) : _c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("*A contrapartida corresponde a " + _vm._s(this.$root.formataNumero((_vm.totalContrapartida / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)), 'percentual')) + "% do valor total do projeto.")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Entidade Proponente")]), _vm._v(" "), _c('div', [(_vm.proposta.entidade) ? _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [(_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato) && _vm._.has(_vm.proposta.entidade.contato, 'ds_telefone') && !_vm._.isEmpty(_vm.proposta.entidade.contato.ds_telefone)) ? _c('span', [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_telefone)) + "  ")]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato) && _vm._.has(_vm.proposta.entidade.contato, 'ds_celular') && !_vm._.isEmpty(_vm.proposta.entidade.contato.ds_celular)) ? _c('span', [_vm._v("celular: " + _vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_celular)))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Endereço(s)")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [(_vm.proposta.entidade.endereco) ? _c('span', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
	    return (endereco.bt_principal === 1) ? _c('p', {
	      staticClass: "ressaltar"
	    }, [_vm._v("\n                              " + _vm._s(endereco.ds_rua) + ", " + _vm._s(endereco.ds_numero) + ", " + _vm._s(endereco.ds_bairro) + ", " + _vm._s(endereco.ds_complemento) + ", " + _vm._s(endereco.ds_cidade) + " / " + _vm._s(endereco.ds_estado) + ", CEP: " + _vm._s(_vm._f("cep")(endereco.ds_cep)) + "\n                            ")]) : _vm._e()
	  }), 0) : _vm._e()])])])]) : _vm._e()])]), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante Legal da Entidade")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered lista"
	  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.dirigentes), function(dirigente) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")) + " até " + _vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [(_vm.proposta.municipalizacao) ? _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, _vm._l((_vm.municipios = _vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
	    return m.ds_municipio + '/' + m.ds_uf
	  })), function(municipio, key, index) {
	    return _c('span', [_vm._v("\n                              " + _vm._s(municipio[0].ds_municipio + (_vm._.isUndefined(municipio[0].ds_uf) ? '' : '/' + municipio[0].ds_uf) + (index != Object.keys(_vm.municipios).length - 1 ? ',' : '.')) + "\n                            ")])
	  }), 0)])])]) : _vm._e()]), _vm._v(" "), (_vm.ehPIS) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Apresentação da entidade proponente")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao_entidade')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "",
	      "name": "ds_problemas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.apresentacao_entidade),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "apresentacao_entidade", $$v)
	      },
	      expression: "relatorioAnalise.apresentacao_entidade"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.apresentacao_entidade)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) || _vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Qual(is) problema(s) a proponente quer resolver ?")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_problemas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "De forma sucinta, descreva a(s) situação(ões)-problema destacada(s) pela proponente.",
	      "name": "ds_problemas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_problemas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_problemas", $$v)
	      },
	      expression: "relatorioAnalise.ds_problemas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_problemas)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) || _vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("O que a proponente pretende fazer para solucionar o(s) problema(s) ?")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_solucao_problemas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "De forma sucinta, descreva o que a instituição propõe executar para solucionar o(s) problema(s) e os gastos previstos.",
	      "name": "ds_solucao_problemas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_solucao_problemas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_solucao_problemas", $$v)
	      },
	      expression: "relatorioAnalise.ds_solucao_problemas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_solucao_problemas)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.ehPIS) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(" Como a organização pretende operacionalizar as atividades propostas?")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('operacionalizacao_atividades')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "",
	      "name": "ds_problemas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.operacionalizacao_atividades),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "operacionalizacao_atividades", $$v)
	      },
	      expression: "relatorioAnalise.operacionalizacao_atividades"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.operacionalizacao_atividades)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && !_vm.ehVoluntariado && !_vm.ehSimplificada) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Quais os resultados esperados por meio da ação proposta ?")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_resultados_esperados')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "De forma sucinta, discorra sobre a efetividade da ação proposta, descrevendo os impactos e transformações esperados no cotidiano dos participantes por meio da implementação do projeto.",
	      "name": "ds_resultados_esperados"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_resultados_esperados),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_resultados_esperados", $$v)
	      },
	      expression: "relatorioAnalise.ds_resultados_esperados"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_resultados_esperados)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && (!_vm.ehPIS && !_vm.ehVoluntariado && !_vm.ehSimplificada)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Principais aspectos positivos da proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_aspectos_positivos')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "De forma sucinta, discorra sobre os principais aspectos positivos da proposta, considerando pontos relacionados à metodologia apresentada pela proponente, ao grau de envolvimento do público participante e ao potencial de continuidade das ações após a execução das atividades (sustentabilidade do projeto).",
	      "name": "ds_aspectos_positivos"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_aspectos_positivos),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_aspectos_positivos", $$v)
	      },
	      expression: "relatorioAnalise.ds_aspectos_positivos"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_aspectos_positivos)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && (!_vm.ehPIS && !_vm.ehVoluntariado && !_vm.ehSimplificada)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Principais preocupações em relação à proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_preocupacoes')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "Se for o caso, discorra de forma sucinta sobre os principais aspectos que demandam cuidados em relação à proposta, considerando riscos relacionados às lacunas na metodologia, à qualidade das atividades propostas, aos possíveis impactos ambientais ou sociais negativos, à falta de participação da comunidade, à possível descontinuidade das ações e à ausência de parcerias/acordos com outras instituições.",
	      "name": "ds_preocupacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_preocupacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_preocupacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_preocupacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_preocupacoes)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Análise das condições internas da proponente")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Pontos Positivos:")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_condicoes_internas_positivas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "De forma sucinta, descreva os aspectos positivos sobre o ambiente INTERNO da proponente, destacando pontos como: infraestrutura, capacidade técnica, grau de organização/articulação social, etc.",
	      "name": "ds_condicoes_internas_positivas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_condicoes_internas_positivas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_internas_positivas", $$v)
	      },
	      expression: "relatorioAnalise.ds_condicoes_internas_positivas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_internas_positivas)
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_vm._v("Pontos de Atenção:")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_condicoes_internas_negativas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "De forma sucinta, descreva os aspectos negativos sobre o ambiente INTERNO da proponente, destacando pontos como: infraestrutura, capacidade técnica, grau de organização/articulação social, etc.",
	      "name": "ds_condicoes_internas_negativas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_condicoes_internas_negativas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_internas_negativas", $$v)
	      },
	      expression: "relatorioAnalise.ds_condicoes_internas_negativas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_internas_negativas)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Análise das condições externas da proponente")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Pontos Positivos:")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_condicoes_externas_positivas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "De forma sucinta, descreva os aspectos positivos e negativos sobre o ambiente EXTERNO da proponente, destacando pontos como: relacionamento com a gestão pública, mercado local, logística do município, fatores climáticos, stakeholders, etc.",
	      "name": "ds_condicoes_externas_positivas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_condicoes_externas_positivas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_externas_positivas", $$v)
	      },
	      expression: "relatorioAnalise.ds_condicoes_externas_positivas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_externas_positivas)
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_vm._v("Pontos de Atenção:")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_condicoes_externas_negativas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "De forma sucinta, descreva os aspectos negativos sobre o ambiente EXTERNO da proponente, destacando pontos como: relacionamento com a gestão pública, mercado local, logística do município, fatores climáticos, stakeholders, etc.",
	      "name": "ds_condicoes_externas_negativas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_condicoes_externas_negativas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_externas_negativas", $$v)
	      },
	      expression: "relatorioAnalise.ds_condicoes_externas_negativas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_externas_negativas)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.publicos_alvo), function(publico) {
	    return _c('tr', [(publico.fonte.ds_descricao) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(publico.fonte.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_participantes_diretos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_jovens))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_mulheres))])])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos e Metas")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("O objetivo geral da proposta define o que se pretende com a implementação do projeto ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_geral),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_geral"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_indicadores_objetivo_geral"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_geral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Os objetivos específicos e as metas do projeto propiciam o atingimento do objetivo geral ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_especifico),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_especifico"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_indicadores_objetivo_especifico"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_especifico", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes estatutárias da FBB?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_compativel),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_compativel"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_indicadores_objetivo_compativel"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_compativel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), (!_vm.ehPIS && !_vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes de programa estruturado (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_estruturado),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_estruturado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_indicadores_objetivo_estruturado"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_estruturado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.ehPIS || _vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Existe alguma crítica em relação aos objetivos, metas e indicadores apresentados pela proponente?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.existe_critica_objetivos_metas_indicadores),
	      expression: "relatorioAnalise.existe_critica_objetivos_metas_indicadores"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "existe_critica_objetivos_metas_indicadores"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "existe_critica_objetivos_metas_indicadores", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), ((_vm._.has(_vm.relatorioAnalise, 'existe_critica_objetivos_metas_indicadores') && _vm.relatorioAnalise.existe_critica_objetivos_metas_indicadores === 'Sim')) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "rows": "7",
	      "name": "critica_objetivos_metas_indicadores"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.critica_objetivos_metas_indicadores),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "critica_objetivos_metas_indicadores", $$v)
	      },
	      expression: "relatorioAnalise.critica_objetivos_metas_indicadores"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.critica_objetivos_metas_indicadores)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehPIS && !_vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes do plano de trabalho firmado no âmbito de parcerias estratégicas (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_estrategico),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_estrategico"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_indicadores_objetivo_estrategico"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_estrategico", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivo Geral")]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "data-vv-as": "Objetivo Geral do Projeto",
	      "name": "objetivo Geral",
	      "rows": "4",
	      "disabled": true
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_objetivo_geral),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_objetivo_geral", $$v)
	      },
	      expression: "proposta.ds_objetivo_geral"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos Específicos e Metas")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.objetivos), function(objetivo) {
	    return _c('tr', [_c('td', {
	      staticStyle: {
	        "border-bottom": "2px solid silver !important"
	      }
	    }, [_vm._v(_vm._s(objetivo.ds_descricao))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "border-bottom": "2px solid silver !important"
	      }
	    }, [_c('table', _vm._l((_vm._.filter(_vm.proposta.metas, function(m) {
	      return _vm._.includes(_vm._.map(m.objetivos, 'ds_descricao'), objetivo.ds_descricao)
	    })), function(meta) {
	      return _c('tr', [_c('td', {
	        staticStyle: {
	          "border": "none",
	          "border-bottom": "1px solid silver"
	        }
	      }, [_vm._v(_vm._s(meta.ds_descricao))])])
	    }), 0)])])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Indicadores de Resultado")]), _vm._v(" "), (_vm.indicadoresResultadoLista.length) ? _c('ul', {
	    staticStyle: {
	      "margin-top": "8px",
	      "padding-left": "20px"
	    }
	  }, _vm._l((_vm.indicadoresResultadoLista), function(indicador, idx) {
	    return _c('li', {
	      key: 'indicador-' + idx
	    }, [_vm._v(_vm._s(indicador.descricao))])
	  }), 0) : _c('div', {
	    staticStyle: {
	      "color": "#a8a8a8"
	    }
	  }, [_vm._v("Nenhum indicador selecionado.")]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir",
	    staticStyle: {
	      "color": "#a8a8a8",
	      "font-size": "13px"
	    }
	  }, [_vm._v("Os indicadores são informados na aba Análise da proposta.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Divulgação do projeto")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [(_vm.ehSimplificada) ? _c('tr', [_c('td', [_vm._v("Os recursos para realização das ações contidas no Plano de Comunicação foram previstos na memoria de cálculo?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_acoes_comunicacao_memoria_calculo),
	      expression: "relatorioAnalise.ds_acoes_comunicacao_memoria_calculo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_divulgacao_identificacao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_acoes_comunicacao_memoria_calculo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificada) ? _c('tr', [_c('td', [_vm._v("Foi previsto no projeto o uso de banner obrigatório indicativo do apoio da Fundação ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_divulgacao_banner),
	      expression: "relatorioAnalise.ds_divulgacao_banner"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_divulgacao_banner"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_banner", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && !_vm.ehSimplificada) ? _c('tr', [_c('td', [_vm._v("Foi prevista a identificação de veículos a serem adquiridos com recursos financeiros do projeto (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_divulgacao_identificacao),
	      expression: "relatorioAnalise.ds_divulgacao_identificacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_divulgacao_identificacao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_identificacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && !_vm.ehSimplificada) ? _c('tr', [_c('td', [_vm._v("Foi prevista a instalação de placa provisória e definitiva em obras civis a serem realizadas com recursos financeiros do projeto (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_divulgacao_placa),
	      expression: "relatorioAnalise.ds_divulgacao_placa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_divulgacao_placa"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_placa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && !_vm.ehSimplificada) ? _c('tr', [_c('td', [_vm._v("Foi prevista no cronograma físico a realização de atividades relativa à solenização de assinatura de convênio ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_divulgacao_solenizacao),
	      expression: "relatorioAnalise.ds_divulgacao_solenizacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_divulgacao_solenizacao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_solenizacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "data-vv-as": "Ações",
	      "name": "acoes",
	      "rows": "4",
	      "disabled": true
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_acoes_comunicacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_acoes_comunicacao", $$v)
	      },
	      expression: "proposta.ds_acoes_comunicacao"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_acoes_comunicacao)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Valores e contrapartida")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('th', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)))])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)) + "  ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida)) + "  ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "34%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalParceiro)) + "  ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Recursos da Fundação")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(10), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensFbb), function(conta) {
	    return _c('tbody', [(conta.valor > 0) ? _c('tr', {
	      staticClass: "conta"
	    }, [_c('td', [_vm._v(_vm._s(conta.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(conta.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((conta.valor) / (_vm.totalFBB))))])]) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(11), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensContrapartida), function(contra) {
	    return _c('tbody', [(contra.conta) ? _c('tr', {
	      staticClass: "conta"
	    }, [_c('td', [_vm._v(_vm._s(contra.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.values(contra.item), function(i) {
	      return i.valor
	    }))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((_vm._.sumBy(_vm._.values(contra.item), function(i) {
	      return i.valor
	    })) / (_vm.totalContrapartida))))])]) : _vm._e()])
	  })], 2)]), _vm._v(" "), (_vm.totalParceiro > 0) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Recursos de Parcerias")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensParceiro), function(conta) {
	    return _c('tbody', [(conta.valor > 0) ? _c('tr', {
	      staticClass: "conta"
	    }, [_c('td', [_vm._v(_vm._s(conta.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(conta.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((conta.valor) / (_vm.totalParceiro))))])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Os itens de despesa propostos são compatíveis com os objetivos, metas e atividades do projeto ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_itens),
	      expression: "relatorioAnalise.ds_valores_itens"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_valores_itens"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_itens", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A contrapartida proposta atende aos critérios específicos definidos para projetos abaixo de R$ 100 mil?' :
	    'A contrapartida proposta atende aos critérios definidos nos normativos vigentes?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_contrapartida),
	      expression: "relatorioAnalise.ds_valores_contrapartida"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_valores_contrapartida"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_contrapartida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), (!_vm.ehPIS && !_vm.ehSimplificada) ? _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'Os valores apresentados na memória de cálculo estão de acordo com os preços praticados no mercado ou com os parâmetros operacionais estabelecidos pela FBB?' :
	    'Os valores orçados na proposta, inclusive contrapartida, estão de acordo com os praticados no mercado, conforme orçamentos apresentados ?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_deacordo),
	      expression: "relatorioAnalise.ds_valores_deacordo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_valores_deacordo"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_deacordo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && !_vm.ehSimplificada) ? _c('tr', [_c('td', [_vm._v("Os itens de despesa, cujos orçamentos não foram apresentados, enquandram-se nas diretrizes de dispensa ou nos parâmetros estabelecidos pela Fundação ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_enquadrados),
	      expression: "relatorioAnalise.ds_valores_enquadrados"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_valores_enquadrados"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_enquadrados", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observadas as vedações de itens de despesa, conforme norma vigente ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_vedacoes),
	      expression: "relatorioAnalise.ds_valores_vedacoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_valores_vedacoes"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_vedacoes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observados os itens necessários para propostas que envolvam obra civil e/ou aquisição de bens fixos de uso industrial ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_industrial),
	      expression: "relatorioAnalise.ds_valores_industrial"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_valores_industrial"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_industrial", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observados os itens necessários para propostas que envolvam ações de formação, capacitação e/ou consultorias ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_formacao),
	      expression: "relatorioAnalise.ds_valores_formacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_valores_formacao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_formacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.ehPIS) ? _c('tr', [_c('td', [_vm._v("Foi verificado conformidade específica para obra civil?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.conforme_obra_civil),
	      expression: "relatorioAnalise.conforme_obra_civil"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "conforme_obra_civil"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "conforme_obra_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Foi realizado algum ajuste nos valores apresentados ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_ajustes),
	      expression: "relatorioAnalise.ds_valores_ajustes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_valores_ajustes"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_ajustes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "Descreva a seguir as observações e ajustes realizados nos valores, bem como demais justificativas pertinentes.",
	      "name": "ds_valores_observacoes"
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_valores_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_valores_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_valores_observacoes)
	    }
	  })]), _vm._v(" "), (!_vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Liberação de recursos")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Os parâmetros para concessão da modalidade de adiantamento de recursos foram atendidos conforme normativos vigentes ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_liberacao_adiantamentos),
	      expression: "relatorioAnalise.ds_liberacao_adiantamentos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_liberacao_adiantamentos"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_liberacao_adiantamentos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "Descreva a seguir, se for o caso, justificativa pela concessão de adiantamento.",
	      "name": "ds_liberacao_observacoes"
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_liberacao_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_liberacao_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_liberacao_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_liberacao_observacoes)
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Parcelas de Adiantamento")]), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [(_vm.proposta.adiantamentos) ? _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '10%' : '15%'))
	  }, [_c('b', [_vm._v("Parcela")])]), _vm._v(" "), _c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '30%' : '45%'))
	  }, [_c('b', [_vm._v("Origem")])]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_c('b', [_vm._v("Fundação")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_c('b', [_vm._v("Parceiro Estratégico")])]) : _vm._e(), _vm._v(" "), _c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '20%' : '40%'))
	  }, [_c('b', [_vm._v("Valor")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parcelasAdiantamentoExibicao), function(adiantamento) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm.rotuloOrigemParcela(adiantamento.origem)))]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "text-right"
	    }, [(!_vm._.isNil(adiantamento.valor_fbb)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_fbb)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "text-right"
	    }, [(!_vm._.isNil(adiantamento.valor_parc)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_parc)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor)))])])
	  }), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Total adiantável")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoFundacao)) + "\n                            "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoFundacao / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoParceiro)) + "\n                            "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoParceiro / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoGeral)) + "\n                            "), ((_vm.totalFBB + _vm.totalParceiro) > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoGeral / (_vm.totalFBB + _vm.totalParceiro)))) + ")")]) : _vm._e()])])], 2), _vm._v(" "), (_vm.parcelasAdiantamentoExibicao.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "100%"
	    }
	  }, [_vm._v("Nenhuma parcela de adiantamento cadastrada.")])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de execução e periodicidade de relatórios")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Há compatibilidade entre o prazo de execução indicado na proposta e as atividades a serem realizadas ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_execucao_compatibilidade),
	      expression: "relatorioAnalise.ds_execucao_compatibilidade"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_execucao_compatibilidade"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_execucao_compatibilidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual o prazo de execução do projeto ?\n                        ")]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_execucao_prazo),
	      expression: "relatorioAnalise.ds_execucao_prazo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_titulo",
	      "disabled": true,
	      "id": "ds_execucao_prazo",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.relatorioAnalise.ds_execucao_prazo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorioAnalise, "ds_execucao_prazo", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual o prazo de vigência do projeto?")]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periodo_vigencia),
	      expression: "proposta.periodo_vigencia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_titulo",
	      "disabled": true,
	      "id": "prazo_vigencia",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.periodo_vigencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Qual a periodicidade dos relatórios de execução ?\n                        ")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "145px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_execucao_relatorios),
	      expression: "relatorioAnalise.ds_execucao_relatorios"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_execucao_relatorios",
	      "id": "ds_execucao_relatorios",
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.relatorioAnalise.ds_execucao_relatorios)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorioAnalise, "ds_execucao_relatorios", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "Informe observações relevantes referente ao prazo de execução do projeto.",
	      "name": "ds_execucao_observacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_execucao_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_execucao_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_execucao_observacoes"
	    }
	  })], 1), _vm._v(" "), (!_vm.ehVoluntariado) ? _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_execucao_observacoes)
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Regularidade da proposta e da proponente")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("A proposta é compatível com os objetivos estatutários e regimentais da entidade proponente?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_objetivos),
	      expression: "relatorioAnalise.ds_regularidade_objetivos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_regularidade_objetivos"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_objetivos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A proponente apresentou toda a documentação exigida para a análise de projetos abaixo de R$ 100 mil?' :
	    'A proponente apresentou toda a documentação exigida para a análise de projetos?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_documentação),
	      expression: "relatorioAnalise.ds_regularidade_documentação"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_regularidade_documentação"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_documentação", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A proponente encontra-se em regularidade cadastral, de acordo com as exigências específicas para projetos abaixo de R$ 100 mil?' :
	    'A proponente encontra-se em regularidade cadastral?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_cadastral),
	      expression: "relatorioAnalise.ds_regularidade_cadastral"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_regularidade_cadastral"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_cadastral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('tr', [_c('td', [_vm._v("A proponente encontra-se em conformidade (fiscal e documental) e relação a exigências específicas no âmbito de parceria estratégica (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_fiscal),
	      expression: "relatorioAnalise.ds_regularidade_fiscal"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_regularidade_fiscal"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_fiscal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("A proponente já executou projetos com a FBB ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_projetos),
	      expression: "relatorioAnalise.ds_regularidade_projetos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_regularidade_projetos"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_projetos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("A proponente encontra-se em regularidades junto à FBB (inexistência de ocorrências impeditivas) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_ocorrencias),
	      expression: "relatorioAnalise.ds_regularidade_ocorrencias"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_regularidade_ocorrencias"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_ocorrencias", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), (!_vm.ehSimplificada) ? _c('tr', [_vm._m(13), _vm._v(" "), (_vm.relatorioAnalise.ds_regularidade_rating) ? _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_rating.ds_descricao),
	      expression: "relatorioAnalise.ds_regularidade_rating.ds_descricao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_titulo",
	      "id": "ds_regularidade_rating",
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.relatorioAnalise.ds_regularidade_rating.ds_descricao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorioAnalise.ds_regularidade_rating, "ds_descricao", $event.target.value)
	      }
	    }
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(14), _vm._v(" "), (_vm.ehSimplificada) ? _c('td', [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": "C"
	    }
	  })]) : _c('td', [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": !_vm.riscoCalculado ? 'Risco ainda não calculado' : _vm.riscoCalculado
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "Descreva a seguir possíveis comentários acerca da regularidade da proposta, proponente e condicionantes, se for o caso.",
	      "name": "ds_regularidade_observacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_regularidade_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_regularidade_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_regularidade_observacoes)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Licenciamento ambiental")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("As atividades propostas para o projeto são passíveis de dispensa, ou licenciamento ambiental (conforme Anexo I da Resolução CONAMA n° 237 - IN-BB 671) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_licenciamento_conforme),
	      expression: "relatorioAnalise.ds_licenciamento_conforme"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_licenciamento_conforme"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_conforme", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual documentação foi apresentada (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_licenciamento_documentacao),
	      expression: "relatorioAnalise.ds_licenciamento_documentacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_titulo",
	      "id": "ds_licenciamento_documentacao",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.relatorioAnalise.ds_licenciamento_documentacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_documentacao", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "Descreva qual a documentação apresentada, inexigibilidade ou dispensa, conforme o caso.",
	      "name": "ds_licenciamento_observacoes"
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_licenciamento_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_licenciamento_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_licenciamento_observacoes)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Enquadramento e Parecer jurídico")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("A proposta foi enquadrada no controle orçamentário da FBB ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_enquadramento_orcamento),
	      expression: "relatorioAnalise.ds_enquadramento_orcamento"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_enquadramento_orcamento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_orcamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Número da FEP?\n                        ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [(_vm._.has(_vm.proposta, 'fep') && _vm._.has(_vm.proposta.fep, 'numero') && _vm._.has(_vm.proposta.fep, 'ano')) ? _c('span', {
	    staticClass: "form-control",
	    staticStyle: {
	      "border": "none"
	    },
	    attrs: {
	      "name": "ds_enquadramento_fep",
	      "id": "ds_enquadramento_fep"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.fep.ano + "/" + _vm.proposta.fep.numero))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'Foi utilizada a minuta padrão aprovada para projetos abaixo de R$ 100 mil?' :
	    'Foi utilizada a minuta padrão aprovada que contemple as necessidades do projeto ?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_enquadramento_minuta),
	      expression: "relatorioAnalise.ds_enquadramento_minuta"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "name": "ds_enquadramento_minuta"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_minuta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "placeholder": "Informe o embasamento jurídico, parecer e/ou minuta padrão utilizados para amparo legal da minuta de convênio.",
	      "name": "ds_enquadramento_observacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_enquadramento_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_enquadramento_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_enquadramento_observacoes)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos de Desenvolvimento Sustentável (ODS)")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [(_vm.odsCadastrado.length > 0) ? _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, _vm._l((_vm.odsCadastrado), function(ods) {
	    return _c('div', [_vm._v("\n                            " + _vm._s(ods.descricao) + "\n                            "), _vm._l((ods.metasDescricao), function(meta) {
	      return _c('div', [_c('i', [_vm._v("Meta " + _vm._s(meta.descricao))])])
	    })], 2)
	  }), 0) : _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_vm._v("\n                          Não Possui ODS cadastrado.\n                        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Tecnologia Social")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [(_vm.possuiTecnologiaSocial) ? _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, _vm._l((_vm.tecnologiasCadastradas), function(tecnologia) {
	    return _c('div', [_vm._v("\n                          " + _vm._s(tecnologia.nome) + "\n                        ")])
	  }), 0) : _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_vm._v("\n                        Não possui Tecnologias cadastradas.\n                      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Público-Alvo Previsto")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [(_vm.publicoAlvoDefinicoes.length > 0) ? _c('div', {
	    staticClass: "column  all-start gap-5 container-padding"
	  }, _vm._l((_vm.publicoAlvoDefinicoes), function(definicao) {
	    return _c('div', [_vm._v("\n                           - " + _vm._s(definicao) + "\n                        ")])
	  }), 0) : _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_vm._v("\n                        Não possui Público-Alvo Previsto cadastrado.\n                      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Avaliação do Projeto")]), _vm._v(" "), (_vm.questoesAvaliacao.length > 0) ? _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_c('b', [_vm._v(_vm._s(_vm.questoesAvaliacao[0].resposta))])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.questoesAvaliacao), function(questao, index) {
	    return (index > 0) ? _c('tr', {
	      key: index
	    }, [_c('td', [_vm._v(_vm._s(questao.questao || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(questao.resposta))])]) : _vm._e()
	  }), 0)])]) : _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_vm._v("\n                      -\n                    ")])]), _vm._v(" "), (_vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body juntos"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Considerações finais")]), _vm._v(" "), _c('table', {
	    staticClass: "bloco"
	  }, [_c('tr', [_c('td', [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "rows": "7",
	      "name": "ds_consideracoes_finais"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_consideracoes_finais),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_consideracoes_finais", $$v)
	      },
	      expression: "relatorioAnalise.ds_consideracoes_finais"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_consideracoes_finais)
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(16), _vm._v(" "), _c('table', {
	    staticClass: "bloco"
	  }, [_c('tr', [_c('td', [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "rows": "7",
	      "name": "ds_parecer"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_parecer),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_parecer", $$v)
	      },
	      expression: "relatorioAnalise.ds_parecer"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_parecer)
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [(_vm.ehVoluntariado) ? _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Despacho dos Gerentes de Divisão")]) : _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Despacho do " + _vm._s(_vm.faixaDoProjeto.alcada))])]), _vm._v(" "), _c('table', {
	    staticClass: "bloco"
	  }, [_c('tr', [_c('td', [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "rows": "7",
	      "name": "ds_despacho_observacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_despacho_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_despacho_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_despacho_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_despacho_observacoes)
	    }
	  })])])])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" AVISO: Existem dados que não foram carregados para o relatório de análise conforme log abaixo. O que pode ocorrer nos casos em que a proposta ainda não possui projeto vinculado ou está com seu preenchimento incompleto. Revise o Log e caso necessário, entre em contato com o administrador do sistema ou recarregue o relatório.\n        ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start etapa-carga-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-user-secret"
	  }), _vm._v(" Status de Carga do Relatório de Análise")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "w30"
	  }, [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', {
	    staticClass: "w10"
	  }, [_c('b', [_vm._v("N° Projeto")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Nome")])]), _vm._v(" "), _c('td', {
	    staticClass: "situacao_projeto w20"
	  }, [_c('b', [_vm._v("Situação do Projeto")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Fundação")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contrapartida*")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Parcerias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "w30"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "width": "15%",
	      "text-align": "center"
	    }
	  }, [_vm._v("Cargo")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "width": "15%",
	      "text-align": "center"
	    }
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
	    staticClass: "w30 text-center",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Mandato")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Público-alvo")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho w20"
	  }, [_vm._v("Participantes Diretos")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho w20"
	  }, [_vm._v("Jovens")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho w20"
	  }, [_vm._v("Mulheres")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "w30"
	  }, [_vm._v("Objetivos Específicos")]), _vm._v(" "), _c('th', [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Fundação")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contrapartida")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Parcerias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-left"
	  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w20"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w10"
	  }, [_vm._v("% Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-left"
	  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w20"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w10"
	  }, [_vm._v("% Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-left"
	  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w20"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w10"
	  }, [_vm._v("% Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', [_vm._v("Rating calculado para a proponente")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', [_vm._v("Risco Calculado do Projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Questão")]), _vm._v(" "), _c('th', [_vm._v("Resposta")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Proposta")])])
	}]}

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Motivos de Devolução")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Motivos de Devolução',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Editando Motivos de Devolução"), (_vm.motivos && _vm.motivos.codigo) ? _c('span', [_vm._v(" (Código: " + _vm._s(_vm.motivos.codigo) + " )")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "motivos",
	      "novalidate": "",
	      "_lpchecked": "1"
	    }
	  }, [(_vm.motivos && !_vm.motivos.id) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('codigo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "codigo"
	    }
	  }, [_vm._v("Código:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.motivos.codigo),
	      expression: "motivos.codigo"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "name": "codigo",
	      "type": "text",
	      "minlength": "1",
	      "ng-maxlength": "255",
	      "placeholder": "Informe um identificador para o motivo, no padrão, como por exemplo SEM_DOCUMENTO"
	    },
	    domProps: {
	      "value": (_vm.motivos.codigo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.motivos, "codigo", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('codigo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('codigo')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('descricao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "descricao"
	    }
	  }, [_vm._v("Descrição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.motivos.descricao),
	      expression: "motivos.descricao"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "name": "descricao",
	      "type": "text",
	      "minlength": "1",
	      "ng-maxlength": "255",
	      "placeholder": "Informe uma descrição para o motivo, condizente como código acima informado"
	    },
	    domProps: {
	      "value": (_vm.motivos.descricao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.motivos, "descricao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('descricao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('descricao')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('status')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "bt_ativo"
	    }
	  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.motivos.bt_ativo),
	      expression: "motivos.bt_ativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status",
	      "checked": "",
	      "value": "1"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.motivos.bt_ativo, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.motivos, "bt_ativo", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.motivos.bt_ativo),
	      expression: "motivos.bt_ativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status",
	      "value": "0"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.motivos.bt_ativo, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.motivos, "bt_ativo", 0)
	      }
	    }
	  }), _vm._v(" Não\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar ")])], 1)])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "prest-log-email-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "column all-start prest-complementar-container"
	  }, [_c('b-container', {
	    staticClass: "prest-table",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "created_at",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(_vm.moment(row.value).format('DD/MM/YYYY HH:mm')))])]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', {
	    staticClass: "row-flex all-end"
	  }, [_vm._v("\n                " + _vm._s(_vm.table.totalRows) + " registro(s) encontrado(s).\n              ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "8",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered prest-fechar-email-button",
	    on: {
	      "click": _vm.fecharEmails
	    }
	  }, [_vm._v("\n        Fechar "), _c('i', {
	    staticClass: "fa fa-times",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-between"
	  }, [_c('h4', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Log de e-mails"), _c('i', {
	    staticClass: "fa fa-clock-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])
	}]}

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "ng-form": "payTypSolicForm"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('forma de pagamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "forma de pagamento"
	    }
	  }, [_vm._v("Forma de pagamento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 "
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.forma_pagamento),
	      expression: "nota.forma_pagamento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.validacao.processo.nome === 'Prestação de Contas' || _vm.validacao.processo.nome === 'PRESTACAO_DE_CONTAS',
	      "name": "forma de pagamento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "forma_pagamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [(_vm.validacao.processo.nome === 'Prestação de Contas' || _vm.validacao.processo.nome === 'PRESTACAO_DE_CONTAS') ? _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Crédito Conta Beneficiário")]) : _vm._e(), _vm._v(" "), (_vm.validacao.processo.nome !== 'Prestação de Contas' && _vm.validacao.processo.nome !== 'PRESTACAO_DE_CONTAS') ? _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Crédito Conta Fornecedor")]) : _vm._e(), _vm._v(" "), (_vm.validacao.processo.nome !== 'Prestação de Contas' && _vm.validacao.processo.nome !== 'PRESTACAO_DE_CONTAS') ? _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Docum. Código de Barras")]) : _vm._e()])]), _vm._v(" "), (_vm.errors.first('forma de pagamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma de pagamento')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('pagamento prioritário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "pagamento prioritário"
	    }
	  }, [_vm._v("Pagamento Prioritário:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.prioridade),
	      expression: "nota.prioridade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "pagamento prioritário"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "prioridade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('pagamento prioritário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('pagamento prioritário')))]) : _vm._e()])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Forma de pagamento")])])
	}]}

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.propsHistorico,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "inicio",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
	      }
	    }, {
	      key: "usuario.ds_tipo_usuario",
	      fn: function(row) {
	        return [(row.value === 'ENTIDADE') ? _c('span', [_vm._v("Parceiro")]) : _vm._e(), _vm._v(" "), (row.value === 'FUNDACAO') ? _c('span', [_vm._v("FBB")]) : _vm._e()]
	      }
	    }])
	  })], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Oculta ou Mostra o histórico de alterações da Entidade",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostraHistorico = !_vm.mostraHistorico
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eye",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.mostraHistorico ? 'Ocultar histórico' : 'Mostrar histórico'))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraHistorico),
	      expression: "mostraHistorico"
	    }],
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "inicio",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
	      }
	    }, {
	      key: "termino",
	      fn: function(row) {
	        return [(row.value !== null) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]) : (row.value === null) ? _c('span', [_vm._v("-")]) : _vm._e()]
	      }
	    }, {
	      key: "nome",
	      fn: function(row) {
	        return [(row.value === 'SOLICITACAO') ? _c('span', [_vm._v("Solicitação")]) : _vm._e(), _vm._v(" "), (row.value === 'REVISAO') ? _c('span', [_vm._v("Em Revisão")]) : _vm._e(), _vm._v(" "), (row.value === 'ANALISE') ? _c('span', [_vm._v("Análise")]) : _vm._e(), _vm._v(" "), (row.value === 'ANULACAO') ? _c('span', [_vm._v("Anulação")]) : _vm._e(), _vm._v(" "), (row.value === 'DEFERIMENTO') ? _c('span', [_vm._v("Deferimento")]) : _vm._e(), _vm._v(" "), (row.value === 'FORMALIZACAO') ? _c('span', [_vm._v("Formalização")]) : _vm._e(), _vm._v(" "), (row.value === 'APROVACAO') ? _c('span', [_vm._v("Aprovação")]) : _vm._e()]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [(row.item.termino) ? _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              _vm.showModal = true, _vm.testFunc(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]) : _vm._e()], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), (_vm.loadingShow) ? _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.showModal) ? _c('div', [_c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper",
	    on: {
	      "click": function($event) {
	        return _vm.$emit(_vm.showModal = false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Histórico")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-10 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('div', [(_vm.snap.ds_codigo_projeto_erp) ? _c('div', [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_codigo_projeto_erp),
	      expression: "proposta.ds_codigo_projeto_erp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_codigo_projeto_erp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_codigo_projeto_erp", $event.target.value)
	      }
	    }
	  })])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_nome),
	      expression: "snap.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "data-vv-as": "Nome da Proposta",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_nome_coordenador),
	      expression: "snap.ds_nome_coordenador"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "data-vv-as": "Nome do Coordenador",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_nome_coordenador)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_nome_coordenador", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf"
	    }
	  }, [(this.$router.currentRoute.name === 'proposta-visualiza') ? _c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "data-vv-as": "CPF do Coordenador",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.snap.ds_cpf_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "ds_cpf_coordenador", $$v)
	      },
	      expression: "snap.ds_cpf_coordenador"
	    }
	  }) : _vm._e(), _vm._v(" "), (this.$router.currentRoute.name !== 'proposta-visualiza') ? _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.snap.ds_cpf_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "ds_cpf_coordenador", $$v)
	      },
	      expression: "snap.ds_cpf_coordenador"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_email_coordenador),
	      expression: "snap.ds_email_coordenador"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "data-vv-as": "E-mail do Coordenador",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_email_coordenador)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_email_coordenador", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "data-vv-as": "Telefone do Coordenador",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.snap.ds_telefone_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "ds_telefone_coordenador", $$v)
	      },
	      expression: "snap.ds_telefone_coordenador"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "data-vv-as": "Celular do Coordenador",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.snap.ds_celular_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "ds_celular_coordenador", $$v)
	      },
	      expression: "snap.ds_celular_coordenador"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('legend', [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate"
	    }
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "data-vv-as": "Data Inicial",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.snap.dt_data_inicial),
	      callback: function($$v) {
	        _vm.$set(_vm.snap, "dt_data_inicial", $$v)
	      },
	      expression: "snap.dt_data_inicial"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.nr_periodos),
	      expression: "snap.nr_periodos"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "data-vv-as": "Número de Meses do Projeto",
	      "lang": "pt-br",
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.snap.nr_periodos)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "nr_periodos", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderEntidade === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderEntidade = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar dados da Entidade - "), _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]) : _vm._e(), _vm._v(" "), (_vm.esconderEntidade === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderEntidade = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar dados da Entidade - "), _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]) : _vm._e()]), _vm._v(" "), (_vm.esconderEntidade === true) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('legend', [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "title": 'Ir para o Cadastro da entidade',
	      "to": {
	        name: 'cadastro-entidade-visualiza',
	        params: {
	          id: _vm.proposta.entidade.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.proposta.entidade.ds_nome) + "  "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })])], 1), _vm._v(" "), _c('dt', [_vm._v("CNPJ")]), _vm._v(" "), _c('dd', [_vm._v("\n                                    " + _vm._s(_vm._f("cnpj")(_vm.snap.entidade.ds_cnpj)) + "\n                                  ")]), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.snap.entidade.ds_email))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), (_vm.snap.entidade.endereco) ? _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.snap.entidade.endereco[0].ds_rua) + ", " + _vm._s(_vm.snap.entidade.endereco[0].ds_numero) + " -\n                                    " + _vm._s(_vm.snap.entidade.endereco[0].ds_bairro) + ", " + _vm._s(_vm.snap.entidade.endereco[0].ds_cidade) + " - " + _vm._s(_vm.snap.entidade.endereco[0].ds_estado) + "\n                                  ")]) : _vm._e(), _vm._v(" "), _c('dt', [_vm._v("Telefone")]), _vm._v(" "), _c('dd', {
	    attrs: {
	      "id": "phone"
	    }
	  }, [_vm._v("\n                                    " + _vm._s(_vm.telefone) + "\n                                  ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações do Projeto")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_introducao),
	      expression: "snap.ds_introducao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "name": "introducao",
	      "data-vv-as": "Informações Introdutórias do Projeto",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_introducao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_introducao", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_apresentacao),
	      expression: "snap.ds_apresentacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "data-vv-as": "Apresentação do Projeto",
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_apresentacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_apresentacao", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_territorio),
	      expression: "snap.ds_territorio"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "data-vv-as": "Território de Desenvolvimento do Projeto",
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_territorio)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_territorio", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_justificativa),
	      expression: "snap.ds_justificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "data-vv-as": "Justificativa do Projeto",
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_justificativa", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_objetivo_geral),
	      expression: "snap.ds_objetivo_geral"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "data-vv-as": "Objetivo Geral do Projeto",
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_objetivo_geral)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_objetivo_geral", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_resultados),
	      expression: "snap.ds_resultados"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "data-vv-as": "Resultados Esperados do Projeto",
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_resultados)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_resultados", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_operacao),
	      expression: "snap.ds_operacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "data-vv-as": "Operacionalização do Projeto",
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_operacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_operacao", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_parceria),
	      expression: "snap.ds_parceria"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "data-vv-as": "Parceria do Projeto",
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_parceria)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_parceria", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.ds_resumo),
	      expression: "snap.ds_resumo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "placeholder": "Ver texto padrão com a GEPRO...",
	      "data-vv-as": "Resumo do Projeto",
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.snap.ds_resumo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap, "ds_resumo", $event.target.value)
	      }
	    }
	  })])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])]), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": _vm.snap.publicos_alvo
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.snap.publicos_alvo = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])]), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": _vm.snap.equipes
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.snap.equipes = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.nr_projeto_duplicacao),
	      expression: "snap.nr_projeto_duplicacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.snap, "nr_projeto_duplicacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber + ' / ' + projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])]), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.snap.objetivos
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.snap.objetivos = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])]), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.snap.objetivos,
	      "propsMetas": _vm.snap.metas
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.snap.metas = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])]), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.snap.nr_periodos,
	      "propsMetas": _vm.snap.metas,
	      "propsAtividades": _vm.snap.atividades
	    },
	    on: {
	      "atividadeAdicionada": function($event) {
	        _vm.snap.atividades = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])]), _vm._v(" "), _c('cronograma', {
	    key: _vm.componentKey,
	    attrs: {
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsAtividades": _vm.proposta.atividades,
	      "metas": _vm.proposta.metas,
	      "proposta": _vm.proposta,
	      "meses": _vm.proposta.nr_periodos,
	      "projeto-duplicacao": _vm.proposta.nr_projeto_duplicacao
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.atividades = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Parcela de Adiantamento")])]), _vm._v(" "), _c('parcela-adiantamento', {
	    attrs: {
	      "propsParcelas": _vm.snap.adiantamentos,
	      "propsAtividades": _vm.snap.atividades
	    },
	    on: {
	      "parcelaAdicionada": function($event) {
	        _vm.snap.adiantamentos = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])]), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "proposta": _vm.snap
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.snap.municipalizacao = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])]), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.snap.cursos
	    }
	  })], 1)], 1)])]), _vm._v(" "), (_vm.fase === 'PRE_ANALISE' && _vm.termino !== null) ? _c('fieldset', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('pre-analise-form', {
	    attrs: {
	      "propsPreAnalise": _vm.snap
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.fase === 'ANALISE' && _vm.termino !== null) ? _c('fieldset', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('analise', {
	    attrs: {
	      "propsAnalise": _vm.snap
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.fase === 'DEFERIMENTO' && _vm.termino !== null) ? _c('fieldset', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('deferimento', {
	    attrs: {
	      "propsDeferimento": _vm.snap
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('br'), _vm._v(" "), _c('b-button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button",
	      "disabled": false
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Fechar ")])], 1)])])])])])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }]
	  }, [_c('pre', {
	    ref: "myDiv",
	    attrs: {
	      "id": "myDiv"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Adiciona seu respectivo projeto",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onNew()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Projeto")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "how-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.exclui(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }, {
	      key: "proposal.entity.cnpj",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))]
	      }
	    }])
	  })], 1)], 1)])]), _vm._v(" "), (_vm.state === 'FORM') ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    },
	    attrs: {
	      "name": "frmAddPrj"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "Projeto"
	    }
	  }, [_vm._v("Projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projetoNome),
	      expression: "projetoNome"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "projetoNome",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.projetoNome = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.escolhido(_vm.projetoNome)
	      }]
	    }
	  }, _vm._l((_vm.projetoNome), function(i) {
	    return _c('option', {
	      attrs: {
	        "label": i.proposal.idProjectErp + ' - ' + i.proposal.name
	      },
	      domProps: {
	        "value": i.id
	      }
	    })
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tabela.entity),
	      expression: "tabela.entity"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "disabled": true,
	      "id": "nome",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tabela.entity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.tabela, "entity", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "cnpj"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "cnpj",
	      "id": "cnpj",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.tabela.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.tabela, "cnpj", $$v)
	      },
	      expression: "tabela.cnpj"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-offset-2 col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Salva o cadastro",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.frmAddPrj)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "uib-tooltip": "Cancela a edição"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onCancel(_vm.frmAddPrj)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancel")])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1923 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ssm-lte-loading": "cmptSimpleRegisterEntityForm",
	      "ng-hide": "$ctrl.entity.status === 'PENDENTE_APROVACAO'  ||  $ctrl.entity.status === 'COMPLETO' || $ctrl.entity.status =='INCOMPLETO'"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.processos.simplifiedNumber),
	      expression: "processos.simplifiedNumber"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "id": "processo",
	      "name": "processo"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.processos, "simplifiedNumber", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.escolhido]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.processos), function(processo) {
	    return _c('option', {
	      domProps: {
	        "value": processo
	      }
	    }, [_vm._v(_vm._s(processo.simplifiedNumber))])
	  })], 2)])]), _vm._v(" "), (_vm.procSelecionado) ? _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.companyName),
	      expression: "entidade.companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "companyName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.entidade.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "cnpj", $$v)
	      },
	      expression: "entidade.cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpjExpeditionTime')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "cnpjExpeditionTime"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "cnpjExpeditionTime",
	    attrs: {
	      "name": "cnpjExpeditionTime",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.entidade.cnpjExpeditionTime),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "cnpjExpeditionTime", $$v)
	      },
	      expression: "entidade.cnpjExpeditionTime"
	    }
	  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome fantasia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "Nome fantasia"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.businessName),
	      expression: "entidade.businessName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Nome fantasia",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome fantasia",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.businessName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "businessName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-7",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Telefone: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    attrs: {
	      "name": "Telefone"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.entidade.contact.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade.contact, "phone", $$v)
	      },
	      expression: "entidade.contact.phone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-7",
	    class: {
	      'has-error': _vm.errors.first('email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    attrs: {
	      "name": "email"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.email),
	      expression: "entidade.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.entidade.email)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "email", $event.target.value)
	      }, function($event) {
	        _vm.entidade.email = $event.target.value.toLowerCase()
	      }]
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.entidade.address
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.entidade.chiefs,
	      "name": "dirigentes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.entidade.documents,
	      "documentTypes": _vm.docs,
	      "documentosObrigatorios": _vm.docs
	    }
	  })], 1)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.conclui()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Processo: ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Entidade: Simplificado")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	}]}

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Entidades Parceiras'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row collapse in",
	    staticStyle: {
	      "width": "inherit",
	      "height": "auto"
	    },
	    attrs: {
	      "uib-collapse": "isSearchCollapsed",
	      "aria-expanded": "true",
	      "aria-hidden": "false"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtro),
	      expression: "filtro"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa...",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.filtro)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.busca($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filtro = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.filtro,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.busca()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group col-sm-12",
	    attrs: {
	      "uib-dropdown": ""
	    }
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "disabled": this.$root.authorize('!entidade-credenciar'),
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'entidade-credenciamento'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Nova Entidade ")]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "items": _vm.snap,
	      "striped": "",
	      "hover": "",
	      "bordered": _vm.bordered,
	      "fields": _vm.fields,
	      "current-page": _vm.items.currentPage,
	      "per-page": _vm.items.per_page,
	      "filter": _vm.filter,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado",
	      "table-layout:": "",
	      "fixed": ""
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "ds_status",
	      fn: function(row) {
	        return [(row.value === 'COMPLETO') ? _c('div', [_c('div', {
	          staticStyle: {
	            "color": "green"
	          }
	        }, [_vm._v("Cadastro aprovado")])]) : _vm._e(), _vm._v(" "), (row.value === 'EM_REVISAO_PELA_ENTIDADE') ? _c('div', [_c('div', {
	          staticStyle: {
	            "color": "#344cff"
	          }
	        }, [_vm._v("Em revisão pela entidade")])]) : _vm._e(), _vm._v(" "), (row.value === 'PENDENTE_APROVACAO') ? _c('div', [_c('div', {
	          staticStyle: {
	            "color": "red"
	          }
	        }, [_vm._v("Aguardando validação")])]) : _vm._e(), _vm._v(" "), (row.value === 'INCOMPLETO') ? _c('div', [_c('div', {
	          staticStyle: {
	            "color": "orange"
	          }
	        }, [_vm._v("Cadastro não enviado")])]) : _vm._e()]
	      }
	    }, {
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "dt_criado",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "ds_cnpj",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "btn-group"
	        }, [_c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss",
	            "type": "button"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-entidade-visualiza',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  "), _c('font', {
	          domProps: {
	            "innerHTML": _vm._s(_vm.textoVisualizar)
	          }
	        })], 1)], 1), _vm._v(" "), _c('div', {
	          staticClass: "btn-group"
	        }, [(row.item.ds_status !== 'PENDENTE_APROVACAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-entidade-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  "), _c('font', {
	          domProps: {
	            "innerHTML": _vm._s(_vm.textoEditar)
	          }
	        })], 1) : _vm._e(), _vm._v(" "), (row.item.ds_status === 'PENDENTE_APROVACAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'validacao-entidades',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-check",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Validar"), _c('br'), _vm._v("Cadastro")]) : _vm._e()], 1), _vm._v(" "), (row.item.ds_status === 'COMPLETO') ? _c('div', {
	          staticClass: "btn-group"
	        }, [_c('g-button-ujarak', {
	          attrs: {
	            "id": 'entity-new-proposal-' + row.item.id,
	            "color": "warning",
	            "size": "button--size-ss",
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'proposta-liberacao',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-book",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  "), _c('font', {
	          domProps: {
	            "innerHTML": _vm._s(_vm.textoProposta)
	          }
	        })], 1)], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.items.total,
	      "per-page": _vm.items.per_page
	    },
	    on: {
	      "change": _vm.recarrega
	    },
	    model: {
	      value: (_vm.items.current_page),
	      callback: function($$v) {
	        _vm.$set(_vm.items, "current_page", $$v)
	      },
	      expression: "items.current_page"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta de Entidades")])])
	}]}

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column centered-start cotacao-manual-main-container"
	  }, [_c('div', {
	    staticClass: "column start-centered cotacao-manual-anexo-container"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Anexos da Cotação:")]), _vm._v(" "), (!_vm.carregandoAnexos) ? _c('uploadCotacaoManualVisualizacao', {
	    staticClass: "w-100",
	    attrs: {
	      "propDocumentos": _vm.anexos,
	      "localUso": "COTACAO_MANUAL",
	      "maxFiles": 3,
	      "disable": this.visualizacao
	    }
	  }) : _c('div', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  }), _vm._v("\n            Carregando Anexos...\n          ")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Proposta Simplificada ")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Perfis',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.processos.simplifiedNumber),
	      expression: "processos.simplifiedNumber"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "id": "processo",
	      "name": "processo"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.processos, "simplifiedNumber", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.escolhido]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.processos), function(processo) {
	    return _c('option', {
	      domProps: {
	        "value": processo
	      }
	    }, [_vm._v(_vm._s(processo.simplifiedNumber))])
	  })], 2), _vm._v(" "), (_vm.errors.first('simplificado')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('simplificado')))]) : _vm._e()])])]), _vm._v(" "), (_vm.procSelecionado) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('nome da proposta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "nome da proposta"
	    }
	  }, [_vm._v("Nome do Projeto:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.name),
	      expression: "propostaSimplificada.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome da proposta",
	      "id": "nome da proposta",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome da proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da proposta')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('investimento previsto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "investimento previsto"
	    }
	  }, [_vm._v("Investimento Previsto:")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "investimento previsto",
	      "approval": "propSimpleCtrl.approval",
	      "state": "propSimpleCtrl.approvalState"
	    }
	  }, [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "investimento previsto",
	      "id": "investimento previsto",
	      "maxlength": "20",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.propostaSimplificada.investment),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "investment", $$v)
	      },
	      expression: "propostaSimplificada.investment"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('investimento previsto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('investimento previsto')))]) : _vm._e()])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Agência condutora do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Agência")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('agencia')
	    },
	    attrs: {
	      "uib-tooltip": "Prefixo da Agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "agencia"
	    }
	  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticStyle: {
	      "font-size": "4px"
	    },
	    attrs: {
	      "options": _vm.agencias,
	      "custom-label": _vm.numeroNomeAgencia,
	      "placeholder": "Selecione uma agência",
	      "label": "type",
	      "track-by": "type",
	      "preselect-first": false,
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "selectedLabel": "",
	      "name": "agencia"
	    },
	    on: {
	      "search-change": _vm.buscaAgencias
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.buscaAgencia(_vm.agenciaSelecionada.code)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 579952095),
	    model: {
	      value: (_vm.agenciaSelecionada),
	      callback: function($$v) {
	        _vm.agenciaSelecionada = $$v
	      },
	      expression: "agenciaSelecionada"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ agência')
	    },
	    attrs: {
	      "uib-tooltip": "CNPJ da Agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "CNPJ agência"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255|cnpj'),
	      expression: "'required|max:255|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ agência",
	      "id": "CNPJ agência",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.propostaSimplificada.agencyCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "agencyCNPJ", $$v)
	      },
	      expression: "propostaSimplificada.agencyCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('endereço da agência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "endereço da agência"
	    }
	  }, [_vm._v("Endereço da agência:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.agencyAddress),
	      expression: "propostaSimplificada.agencyAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "endereço da agência",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.agencyAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "agencyAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('endereço da agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço da agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('telefone agência')
	    },
	    attrs: {
	      "uib-tooltip": "Telefone da agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "telefone agência"
	    }
	  }, [_vm._v("Telefone da agência:")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "telefone agência",
	      "id": "telefone agência",
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "type": "text",
	      "maxlength": "255"
	    },
	    model: {
	      value: (_vm.propostaSimplificada.agencyPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "agencyPhone", $$v)
	      },
	      expression: "propostaSimplificada.agencyPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('telefone agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('email agência')
	    },
	    attrs: {
	      "uib-tooltip": "E-mail da agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "email agência"
	    }
	  }, [_vm._v("E-mail da agência:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.agencyEmail),
	      expression: "propostaSimplificada.agencyEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255|email'),
	      expression: "'required|max:255|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email agência",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.agencyEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "agencyEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email agência')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Gerente")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('nome gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Nome do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "nome gerente"
	    }
	  }, [_vm._v("Nome do Gerente:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerName),
	      expression: "propostaSimplificada.managerName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome gerente",
	      "id": "nome gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('nacionalidade do gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Nacionalidade do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "nacionalidade do gerente"
	    }
	  }, [_vm._v("Nacionalidade:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerNationality),
	      expression: "propostaSimplificada.managerNationality"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nacionalidade do gerente",
	      "id": "nacionalidade do gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerNationality)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerNationality", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nacionalidade do gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nacionalidade do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('profissão do gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Profissão do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "profissão do gerente"
	    }
	  }, [_vm._v("Profissão:")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.managerOccupation",
	      "approval": "propSimpleCtrl.approval",
	      "state": "propSimpleCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerOccupation),
	      expression: "propostaSimplificada.managerOccupation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "profissão do gerente",
	      "id": "profissão do gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerOccupation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerOccupation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('profissão do gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('profissão do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('uf gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "uf gerente"
	    }
	  }, [_vm._v(" UF: ")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerUf),
	      expression: "propostaSimplificada.managerUf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "uf gerente",
	      "id": "uf gerente"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propostaSimplificada, "managerUf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.propostaSimplificada.managerUf,
	      "selected": _vm.propostaSimplificada.managerUf
	    }
	  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerUf))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('uf gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('uf gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('cidade do gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Cidade do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "cidade do gerente"
	    }
	  }, [_vm._v("Cidade:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerCity),
	      expression: "propostaSimplificada.managerCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cidade do gerente",
	      "id": "cidade do gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('cidade do gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cidade do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('estado civil gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "estado civil gerente"
	    }
	  }, [_vm._v("Estado Civil:")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerCivilStatus),
	      expression: "propostaSimplificada.managerCivilStatus"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "estado civil gerente",
	      "id": "estado civil gerente"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propostaSimplificada, "managerCivilStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.propostaSimplificada.managerCivilStatus,
	      "selected": _vm.propostaSimplificada.managerCivilStatus
	    }
	  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerCivilStatus))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOLTEIRO"
	    }
	  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CASADO"
	    }
	  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DIVORCIADO"
	    }
	  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "VIUVO"
	    }
	  }, [_vm._v("Viúvo(a)")])])]), _vm._v(" "), (_vm.errors.first('estado civil gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('estado civil gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CPF gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "managerCpf"
	    }
	  }, [_vm._v(" CPF: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:11|cpf'),
	      expression: "'required|max:11|cpf'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CPF gerente",
	      "id": "CPF gerente",
	      "mask": ['###.###.###-##']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.managerCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "managerCpf", $$v)
	      },
	      expression: "propostaSimplificada.managerCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CPF gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF gerente')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('número rg')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "número rg"
	    }
	  }, [_vm._v(" Número do RG: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerRg),
	      expression: "propostaSimplificada.managerRg"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "número rg",
	      "id": "número rg",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerRg)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerRg", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('número rg')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número rg')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('orgão emissor')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "orgão emissor"
	    }
	  }, [_vm._v(" Orgão Emissor: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerRgIssuer),
	      expression: "propostaSimplificada.managerRgIssuer"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "orgão emissor",
	      "id": "orgão emissor",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerRgIssuer)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerRgIssuer", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('orgão emissor')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('orgão emissor')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('uf RG')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "uf RG"
	    }
	  }, [_vm._v(" UF: ")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerRgUF),
	      expression: "propostaSimplificada.managerRgUF"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "uf RG",
	      "id": "uf RG"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propostaSimplificada, "managerRgUF", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.propostaSimplificada.managerRgUF,
	      "selected": _vm.propostaSimplificada.managerRgUF
	    }
	  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerRgUF))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('uf RG')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('uf RG')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Funcionário agência")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('matrícula do funcionário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "matrícula do funcionário"
	    }
	  }, [_vm._v(" Matrícula do funcionário: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|length:7'),
	      expression: "'required|length:7'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "matrícula do funcionário",
	      "placeholder": "Insira a matricula. Somente números e sem dígito.",
	      "mask": '#######'
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.selectFuncionario(_vm.propostaSimplificada.employeeRegistration)
	      }
	    },
	    model: {
	      value: (_vm.propostaSimplificada.employeeRegistration),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "employeeRegistration", $$v)
	      },
	      expression: "propostaSimplificada.employeeRegistration"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('matrícula do funcionário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('matrícula do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('funcionário responsável')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "funcionário responsável"
	    }
	  }, [_vm._v(" Funcionário responsável pelo projeto: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.employeeName),
	      expression: "propostaSimplificada.employeeName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "funcionário responsável",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.employeeName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "employeeName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('funcionário responsável')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('funcionário responsável')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('telefone do funcionário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "telefone do funcionário"
	    }
	  }, [_vm._v(" Telefone fixo: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "name": "telefone do funcionário",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.propostaSimplificada.employeePhone),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "employeePhone", $$v)
	      },
	      expression: "propostaSimplificada.employeePhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('telefone do funcionário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('e-mail funcionário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "e-mail funcionário"
	    }
	  }, [_vm._v(" E-mail do funcionário: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.employeeEmail),
	      expression: "propostaSimplificada.employeeEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255|email'),
	      expression: "'required|max:255|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "employeeEmail",
	      "id": "e-mail funcionário",
	      "type": "email"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.employeeEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "employeeEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('e-mail funcionário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('e-mail funcionário')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Informações")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('locais de execução do projeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "locais de execução do projeto"
	    }
	  }, [_vm._v(" Locais de execução do projeto: ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.executePlaces),
	      expression: "propostaSimplificada.executePlaces"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "locais de execução do projeto",
	      "id": "locais de execução do projeto",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.executePlaces)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "executePlaces", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('locais de execução do projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('locais de execução do projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('objetivo geral')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "objetivo geral"
	    }
	  }, [_vm._v(" Objetivo Geral: ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.generalObjective),
	      expression: "propostaSimplificada.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "objetivo geral",
	      "id": "objetivo geral",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "generalObjective", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('objetivo geral')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo geral')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('objetivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "infoObjectives"
	    }
	  }, [_vm._v(" Objetivo: ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.infoObjectives),
	      expression: "propostaSimplificada.infoObjectives"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "name": "objetivo",
	      "id": "objetivo",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.infoObjectives)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "infoObjectives", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('objetivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('resumo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "resumo"
	    }
	  }, [_vm._v(" Resumo: ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.summary),
	      expression: "propostaSimplificada.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "resumo",
	      "id": "resumo",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "summary", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('resumo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resumo')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Número de Participantes")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('participantes diretos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "participantes diretos"
	    }
	  }, [_vm._v(" Participantes diretos: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.participants),
	      expression: "propostaSimplificada.participants"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "participantes diretos",
	      "id": "participantes diretos",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.participants)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "participants", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_vm._m(2), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": _vm.propostaSimplificada.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.propostaSimplificada.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_vm._m(3), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.propostaSimplificada.documents,
	      "documentTypes": _vm.documentos,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    },
	    on: {
	      "documentoAtualizado": function($event) {
	        _vm.propostaSimplificada.documents = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_vm._m(4), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.propostaSimplificada.documentStatements,
	      "documentTypes": _vm.adimplencia,
	      "documentosObrigatorios": ''
	    },
	    on: {
	      "documentoAtualizado": function($event) {
	        _vm.propostaSimplificada.documentStatements = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onConclude($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)]) : _vm._e()])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Proposta Simplificada")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Processo: ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])])])
	}]}

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Chamados - Relatório'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Relatório',
	        href: '#'
	      }, {
	        text: 'Chamados',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    attrs: {
	      "id": "painel"
	    }
	  }, [_c('iframe', {
	    staticStyle: {
	      "height": "800px",
	      "width": "9000px"
	    },
	    attrs: {
	      "src": _vm.link,
	      "frameborder": "0",
	      "allowfullscreen": "true"
	    }
	  })])])])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1928 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2"
	  }, [_vm._v("Adicionar documento em:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('label', {
	    staticClass: "new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoVinculo),
	      expression: "tipoVinculo"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "vinculo",
	      "value": "Projeto"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tipoVinculo, "Projeto")
	    },
	    on: {
	      "change": [function($event) {
	        _vm.tipoVinculo = "Projeto"
	      }, _vm.vinculoSelecionado]
	    }
	  }), _vm._v(" Projeto\n              "), _c('span', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoVinculo),
	      expression: "tipoVinculo"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "vinculo",
	      "value": "Entidade"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tipoVinculo, "Entidade")
	    },
	    on: {
	      "change": [function($event) {
	        _vm.tipoVinculo = "Entidade"
	      }, _vm.vinculoSelecionado]
	    }
	  }), _vm._v(" Entidade\n              ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('vinculo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "vinculo"
	    }
	  }, [_vm._v(_vm._s(this.tipoVinculo === null ? 'Escolha acima onde adicionará o documento' : this.tipoVinculo) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.idVinculo),
	      expression: "idVinculo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "vinculo",
	      "id": "vinculo"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.idVinculo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_vm._l((_vm.listaVinculos), function(item) {
	    return (_vm.tipoVinculo === 'Projeto') ? _c('option', {
	      domProps: {
	        "value": item.id
	      }
	    }, [_vm._v(_vm._s(item.ds_codigo_projeto_erp) + " - " + _vm._s(item.ds_nome))]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.listaVinculos), function(item) {
	    return (_vm.tipoVinculo === 'Entidade') ? _c('option', {
	      domProps: {
	        "value": item.id
	      }
	    }, [_vm._v(_vm._s(item.ds_nome))]) : _vm._e()
	  })], 2)]), _vm._v(" "), (_vm.errors.first('vinculo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('vinculo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento
	      }
	    }, [_vm._v(_vm._s(documento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-3"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file"
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })])]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Vigencia')
	    },
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "expirationDate"
	    }
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-3"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dt_data_vigencia),
	      expression: "dt_data_vigencia"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('validdate'),
	      expression: "'validdate'"
	    }],
	    ref: "Vigencia",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "Vigencia",
	      "data-vv-as": "Vigencia",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.dt_data_vigencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dt_data_vigencia = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Vigencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Vigencia')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('div', {
	    staticClass: "content-wrapper column centered-start",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Processo Simplificado")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Proposta Simplificada',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    staticClass: "column all-centered prop-simp-container"
	  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Carregando...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "column centered-start prop-simp-container"
	  }, [_vm._m(1), _vm._v(" "), (!_vm.adicionarRegistro) ? _c('div', {
	    staticClass: "row-flex start-centered prop-simp-navbar-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered",
	    class: _vm.tabSelect == 'Proposta' ? 'prop-simp-button-selected' : 'prop-simp-button',
	    on: {
	      "click": function($event) {
	        return _vm.handleTab('Proposta')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Propostas\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered",
	    class: _vm.tabSelect == 'Edital' ? 'prop-simp-button-selected' : 'prop-simp-button',
	    on: {
	      "click": function($event) {
	        return _vm.handleTab('Edital')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Editais\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.adicionarRegistro) ? _c('div', {
	    staticClass: "column centered-start prop-simp-cadastro-container"
	  }, [_c('div', {
	    staticClass: "column all-start log-title-container"
	  }, [_c('h3', {
	    staticClass: "log-title row-flex centered-start"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                  Adicionar novo registro de " + _vm._s(_vm.tabSelect) + "\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prop-simp-aviso"
	  }, [_vm._m(2), _vm._v(" "), (_vm.tabSelect == 'Proposta') ? _c('div', [_vm._v("\n              AVISO: as propostas adicionadas "), _c('b', [_vm._v("manualmente")]), _vm._v(" ficam "), _c('b', [_vm._v("pendentes")]), _vm._v(" de "), _c('b', [_vm._v("acertos manuais")]), _vm._v(" por "), _c('b', [_vm._v("parte do usuário")]), _vm._v(", tanto no "), _c('b', [_vm._v("cronograma")]), _vm._v(" quanto na "), _c('b', [_vm._v("análise")]), _vm._v(", a depender do seu "), _c('b', [_vm._v("status")]), _vm._v(". Para propostas já aprovadas, será habilitado apenas a "), _c('b', [_vm._v("prestação de contas")]), _vm._v(" do processo simplificado e os acertos de cronograma, caso necessário, devem ser feitos através da ferramenta de "), _c('b', [_vm._v("alteração de projetos")]), _vm._v(".\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tabSelect == 'Edital') ? _c('div', [_vm._v("\n              AVISO: para propostas de editais que já estão em fase de Análise, informamos que caso seja necessário, o acerto do cronograma deve ser feito manualmente. Para propostas já aprovadas, o cronograma, caso seja necessário, deverá ser alterado pela funcionalidade de alteração de projetos.\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered prop-simp-pesquisa-container"
	  }, [(_vm.tabSelect == 'Proposta') ? _c('div', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.tabSelect == 'Edital') ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prop-simp-pesquisa"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.termoPesquisa),
	      expression: "termoPesquisa"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty prop-simp-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisar..."
	    },
	    domProps: {
	      "value": (_vm.termoPesquisa)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.pesquisarNovoRegistro()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.termoPesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.pesquisarNovoRegistro()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pesquisar")])], 1)]), _vm._v(" "), (_vm.loadingPesquisa) ? _c('div', {
	    staticClass: "column all-centered log-title-container"
	  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Pesquisando...")])]) : _vm._e(), _vm._v(" "), (!_vm.loadingPesquisa) ? _c('b-container', {
	    staticClass: "table-simp-container",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    key: _vm.tableDataKey,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": true,
	      "items": _vm.tablePesquisa.items,
	      "fields": _vm.tablePesquisa.fields,
	      "current-page": _vm.tablePesquisa.currentPage,
	      "per-page": _vm.tablePesquisa.perPage,
	      "filter": _vm.tablePesquisa.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.tablePesquisa.sortBy,
	      "sort-desc": _vm.tablePesquisa.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tablePesquisa, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tablePesquisa, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tablePesquisa, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tablePesquisa, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss",
	            "title": '<h5> Adiciona registro no processo simplificado. </h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.cadastraRegistroSimplificado(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-check",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]
	      }
	    }, {
	      key: "nome",
	      fn: function(row) {
	        return [(row.item.numero_projeto) ? _c('span', {
	          staticClass: "prop-simp-span-proj"
	        }, [_c('b', [_vm._v("[ " + _vm._s(row.item.numero_projeto) + " ]")])]) : _vm._e(), _vm._v(" " + _vm._s(row.value) + " "), (row.item.numero_projeto) ? _c('router-link', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'right',
	              animation: 'perspective',
	              distance: '1',
	              size: 'small',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
	          }],
	          attrs: {
	            "title": '<h5>Ir para a página do Projeto</h5>',
	            "to": {
	              name: 'projeto',
	              params: {
	                numero: row.item.numero_projeto
	              }
	            },
	            "target": "_blank"
	          }
	        }, [_vm._v(" "), _c('i', {
	          staticClass: "fa fa-external-link"
	        })]) : _vm._e()]
	      }
	    }], null, false, 674082884)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end prest-total-documentos"
	  }, [_c('div', [_vm._v("\n                      Total de Registros: "), _c('b', [_vm._v(_vm._s(_vm.tablePesquisa.items.length))])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "8",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.tablePesquisa.items.length,
	      "per-page": _vm.tablePesquisa.perPage
	    },
	    model: {
	      value: (_vm.tablePesquisa.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tablePesquisa, "currentPage", $$v)
	      },
	      expression: "tablePesquisa.currentPage"
	    }
	  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end prest-simp-busca-botoes"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleNovoRegistro(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.tabSelect == 'Proposta' && !_vm.adicionarRegistro) ? _c('b-container', {
	    staticClass: "table-simp-container",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticClass: "row-flex all-centered prop-simp-input-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty prop-simp-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa propostas..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleNovoRegistro(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Adicionar Proposta")])], 1), _vm._v(" "), _c('b-table', {
	    key: _vm.tableDataKey,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": true,
	      "bordered": true,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "simplificado",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": row.value == 0 ? 'warning' : 'success',
	            "size": "button--size-ss",
	            "title": row.value == 0 ? '<h5> Ativa processo simplificado. </h5>' : '<h5> Desativa processo simplificado. </h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.alteraProcessoSimplificado(row.item)
	            }
	          }
	        }, [_c('i', {
	          class: row.value == 0 ? 'fa fa-warning' : 'fa fa-check',
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.value == 0 ? 'Inativo' : 'Ativo'))])]
	      }
	    }, {
	      key: "nome_proposta",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "column start-centered"
	        }, [_c('div', [_c('span', {
	          staticClass: "prop-simp-span-id"
	        }, [_vm._v("["), _c('b', [_vm._v(_vm._s(row.item.fk_proposta))]), _vm._v("] ")]), _vm._v("  " + _vm._s(row.value) + " "), (row.item.ds_codigo_projeto_erp) ? _c('span', {
	          staticClass: "prop-simp-span-proj"
	        }, [_c('b', [_vm._v("(" + _vm._s(row.item.ds_codigo_projeto_erp) + ")"), _c('router-link', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'right',
	              animation: 'perspective',
	              distance: '1',
	              size: 'small',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
	          }],
	          attrs: {
	            "title": '<h5>Ir para a página do Projeto</h5>',
	            "to": {
	              name: 'projeto',
	              params: {
	                numero: row.item.ds_codigo_projeto_erp
	              }
	            },
	            "target": "_blank"
	          }
	        }, [_vm._v(" "), _c('i', {
	          staticClass: "fa fa-external-link"
	        })])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	          staticClass: "row-flex all-end prop-simp-entidade-container break"
	        }, [_c('div', {
	          staticClass: "row-flex"
	        }, [_vm._v("\n                                " + _vm._s(row.item.nome_entidade) + "\n                              ")]), _vm._v(" "), _c('div', {
	          staticClass: "row-flex gap-5"
	        }, [_vm._v("\n                                [ " + _vm._s(_vm._f("cnpj")(row.item.ds_cnpj)) + " ] "), _c('b', [_c('router-link', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'right',
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }],
	          attrs: {
	            "title": '<h5>Ir para o Cadastro da entidade</h5>',
	            "to": {
	              name: 'cadastro-entidade-visualiza',
	              params: {
	                id: row.item.id_entidade
	              }
	            },
	            "target": "_blank"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user"
	        })])], 1)])])])]
	      }
	    }, {
	      key: "valor_fbb",
	      fn: function(row) {
	        return [_vm._v("\n                            " + _vm._s(_vm._f("real")(row.value)) + "\n                        ")]
	      }
	    }, {
	      key: "edital",
	      fn: function(row) {
	        return [(row.item.id_edital) ? _c('div', [_vm._v("\n                            (" + _vm._s(row.item.id_edital) + ") " + _vm._s(row.value) + "\n                          ")]) : _c('div', [_vm._v("\n                            Prospecção Direta\n                          ")])]
	      }
	    }], null, false, 2953825950)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end prest-total-documentos"
	  }, [_c('div', [_vm._v("\n                    Total de Registros: "), _c('b', [_vm._v(_vm._s(_vm.table.items.length))])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "8",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tabSelect == 'Edital' && !_vm.adicionarRegistro) ? _c('b-container', {
	    staticClass: "table-simp-container",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticClass: "row-flex all-centered prop-simp-input-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tableEdital.filter),
	      expression: "tableEdital.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa editais..."
	    },
	    domProps: {
	      "value": (_vm.tableEdital.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.tableEdital, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleNovoRegistro(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Adicionar Edital")])], 1), _vm._v(" "), _c('b-table', {
	    key: _vm.tableDataKey,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": true,
	      "items": _vm.tableEdital.items,
	      "fields": _vm.tableEdital.fields,
	      "current-page": _vm.tableEdital.currentPage,
	      "per-page": _vm.tableEdital.perPage,
	      "filter": _vm.tableEdital.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.tableEdital.sortBy,
	      "sort-desc": _vm.tableEdital.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableEdital, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableEdital, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableEdital, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableEdital, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "simplificado",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": row.value == 0 ? 'warning' : 'success',
	            "size": "button--size-ss",
	            "title": row.value == 0 ? '<h5> Ativa processo simplificado. </h5>' : '<h5> Desativa processo simplificado. </h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.alteraProcessoSimplificado(row.item)
	            }
	          }
	        }, [_c('i', {
	          class: row.value == 0 ? 'fa fa-warning' : 'fa fa-check',
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.value == 0 ? 'Inativo' : 'Ativo'))])]
	      }
	    }], null, false, 3723868672)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end prest-total-documentos"
	  }, [_c('div', [_vm._v("\n                    Total de Registros: "), _c('b', [_vm._v(_vm._s(_vm.tableEdital.items.length))])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "8",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.tableEdital.items.length,
	      "per-page": _vm.tableEdital.perPage
	    },
	    model: {
	      value: (_vm.tableEdital.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tableEdital, "currentPage", $$v)
	      },
	      expression: "tableEdital.currentPage"
	    }
	  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "box-body text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh sa-spin"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column all-start log-title-container"
	  }, [_c('h3', {
	    staticClass: "log-title row-flex centered-start"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                  Gerenciador de Proposta Simplificada\n            ")]), _vm._v(" "), _c('span', {
	    staticClass: "prop-simp-span"
	  }, [_vm._v("Atenção: as propostas vinculadas a editais aparecerão aqui conforme "), _c('b', [_vm._v("análise")]), _vm._v(" (propostas já cadastradas no sistema), conforme "), _c('b', [_vm._v("liberação de propostas")]), _vm._v(" (novas propostas liberadas pelo usuário) e/ou conforme "), _c('b', [_vm._v(" autocredenciamento")]), _vm._v(".")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column all-centered prest-declaracoes-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('i', [_vm._v("Pesquise por "), _c('b', [_vm._v("número de projeto")]), _vm._v(", "), _c('b', [_vm._v("número da proposta")]), _vm._v(" ou "), _c('b', [_vm._v("nome do projeto")]), _vm._v(" e clique em Pesquisar.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('i', [_vm._v("Pesquise por "), _c('b', [_vm._v("número do edital")]), _vm._v(" ou "), _c('b', [_vm._v("nome do edital")]), _vm._v(" e clique em Pesquisar.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "box-body text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh sa-spin"
	  })])
	}]}

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.mostrarMensagem === 'SIM') ? _c('div', {
	    staticClass: "alert alert-dismissible alert-warning",
	    attrs: {
	      "id": "quandroAviso"
	    }
	  }, [_c('h4', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_vm._v("COMUNICADO FBB")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.mensagem)
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "pagina-login pagina-novembro-azul"
	  }, [_c('div', {
	    staticClass: "login-box"
	  }, [_c('div', {
	    staticClass: "login-logo yellow-bg"
	  }, [_c('router-link', {
	    staticClass: "marca-novembro-azul",
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('img', {
	    staticClass: "marca",
	    attrs: {
	      "src": "/static/img/logo-login.png",
	      "alt": "Fundação BB"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "laco",
	    attrs: {
	      "src": "/static/img/laco-novembro-azul.svg",
	      "alt": "Novembro Azul",
	      "title": "Novembro Azul: prevenção ao câncer de próstata"
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "login-box-body"
	  }, [_c('p', {
	    staticClass: "login-box-msg"
	  }, [_vm._v("Entre com suas credenciais")]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.login($event)
	      },
	      "keydown": function($event) {
	        return _vm.form.onKeydown($event)
	      }
	    }
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.form.errors.has('ds_login')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.ds_login),
	      expression: "form.ds_login"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Informe seu Login ou E-mail",
	      "name": "usuario"
	    },
	    domProps: {
	      "value": (_vm.form.ds_login)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "ds_login", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('has-error', {
	    attrs: {
	      "form": _vm.form,
	      "field": "ds_login"
	    }
	  }), _vm._v(" "), (_vm.errors.first('usuario')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('usuario')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.form.errors.has('senha')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.senha),
	      expression: "senha"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('senha')
	    },
	    attrs: {
	      "type": "password",
	      "placeholder": "Senha",
	      "name": "senha"
	    },
	    domProps: {
	      "value": (_vm.senha)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.senha = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('senha')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('senha')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary-login btn-block btn-flat",
	    attrs: {
	      "disabled": _vm.form.busy,
	      "type": "submit"
	    }
	  }, [_vm._v("Acessar")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-snotify'), _vm._v(" "), _vm._m(2)], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('a', {
	    attrs: {
	      "id": "recupera-senha",
	      "href": "/esqueci-minha-senha"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#465eff",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Esqueci minha senha")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('a', {
	    attrs: {
	      "id": "recupera-senha-msg",
	      "href": "\\static\\img\\help_senha_sgp.jpg",
	      "target": "_"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#465eff"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-question-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Como recuperar minha senha?")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "color": "white",
	      "text-align": "center",
	      "padding": "10px",
	      "background-color": "#465eff",
	      "width": "360px",
	      "margin": "0 auto 0 auto"
	    }
	  }, [_c('p', [_vm._v("Ao acessar o SGP, você está concordando com o "), _c('a', {
	    staticStyle: {
	      "color": "#fff",
	      "font-weight": "bold",
	      "text-decoration": "underline"
	    },
	    attrs: {
	      "target": "_blank",
	      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Programa_de_Compliance_e_Integridade_Fundacao_BB.pdf"
	    }
	  }, [_vm._v("Programa de "), _c('i', [_vm._v("Compliance")]), _vm._v(" e Integridade")]), _vm._v(" e o "), _c('a', {
	    staticStyle: {
	      "color": "#fff",
	      "font-weight": "bold",
	      "text-decoration": "underline"
	    },
	    attrs: {
	      "target": "_blank",
	      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Codigo_de_Etica_Fundacao_BB.pdf"
	    }
	  }, [_vm._v("Código de Ética")]), _vm._v(" da Fundação BB.")])])
	}]}

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-show": "$ctrl.isNewAvaiable()"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova equipe")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "remunerated",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.exclui(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    },
	    attrs: {
	      "ng-disable": "!$ctrl.show.form",
	      "ng-form": "frmAddProjectTeam",
	      "ssm-isolated-form": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantity"
	    }
	  }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.quantity),
	      expression: "equipe.quantity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "quantidade",
	      "type": "number",
	      "min": "1",
	      "max": "2147483647"
	    },
	    domProps: {
	      "value": (_vm.equipe.quantity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "quantity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cargo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v("Cargo no projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.role),
	      expression: "equipe.role"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cargo",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.equipe.role)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "role", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('cargo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cargo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('perfil profissional pretendido')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "desiredProfile"
	    }
	  }, [_vm._v("Perfil profissional pretendido:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.desiredProfile),
	      expression: "equipe.desiredProfile"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "perfil profissional pretendido",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.equipe.desiredProfile)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "desiredProfile", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('perfil profissional pretendido')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('perfil profissional pretendido')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('forma de contratação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "hiringMethod"
	    }
	  }, [_vm._v("Forma de contratação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.hiringMethod),
	      expression: "equipe.hiringMethod"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "forma de contratação"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.equipe, "hiringMethod", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.formasContratacao), function(forma) {
	    return _c('option', {
	      domProps: {
	        "value": forma.name
	      }
	    }, [_vm._v(_vm._s(forma.description))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('forma de contratação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma de contratação')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('carga horaria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "workload"
	    }
	  }, [_vm._v("Carga horária semanal:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.workload),
	      expression: "equipe.workload"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "carga horaria",
	      "type": "number",
	      "min": "1",
	      "max": "2147483647"
	    },
	    domProps: {
	      "value": (_vm.equipe.workload)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "workload", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("Horas")])]), _vm._v(" "), (_vm.errors.first('carga horaria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('carga horaria')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('remunerado pelo projeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "remunerated"
	    }
	  }, [_vm._v("É remunerado pelo projeto?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.remunerated),
	      expression: "equipe.remunerated"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "remunerado pelo projeto"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.equipe, "remunerated", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "false"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "true"
	    }
	  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('remunerado pelo projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('remunerado pelo projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Resudo das atividades')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "activityResume"
	    }
	  }, [_vm._v("Resumo das atividades:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.activityResume),
	      expression: "equipe.activityResume"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resudo das atividades",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.equipe.activityResume)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "activityResume", $event.target.value)
	      }
	    }
	  }, [_vm._v("              " + _vm._s(_vm.equipe.activityResume) + "\n            ")])]), _vm._v(" "), (_vm.errors.first('Resudo das atividades')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resudo das atividades')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-team-add"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-team-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body cronogramaff"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    directives: [{
	      name: "confirm",
	      rawName: "v-confirm",
	      value: ({
	        ok: function (retorno) { return _vm.deleteTodos('ok'); },
	        cancel: _vm.doNothing,
	        message: 'Deseja <b>APAGAR</b> todos os itens ?'
	      }),
	      expression: "{ok: retorno => deleteTodos('ok'), cancel: doNothing, message: 'Deseja <b>APAGAR</b> todos os itens ?'}"
	    }],
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Apagar todos os itens do cronograma\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.propostaSimplificada) ? _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "background-color": "#465EFF",
	      "box-sizing": "border-box",
	      "padding": "10px 30px",
	      "border-radius": "20px",
	      "color": "#FFFFFF"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Proposta Simplificada\n      ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.propostaSimplificada && _vm.propostaSimplificadaForaPadrao) ? _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "background-color": "#C62828",
	      "box-sizing": "border-box",
	      "padding": "10px 30px",
	      "border-radius": "20px",
	      "color": "#FFFFFF",
	      "margin-top": "10px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-warning",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atenção: Proposta Simplificada com cronograma "), _c('b', [_vm._v("fora dos padrões")]), _vm._v(" previstos em nota técnica.\n      ")]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.propsAtividades), function(atividade, atividadeIndex) {
	    return [_c('tr', {
	      staticClass: "atividade"
	    }, [_c('td', {
	      staticClass: "esquerda borda nome_atividade",
	      attrs: {
	        "colspan": _vm.proposta.ds_fase === 'ANALISE' ? 2 : 2
	      }
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado borda"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado borda"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
	      staticClass: "direita borda",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm.somaTotal(atividade.itens_orcamentos))))]), _vm._v(" "), (!_vm.propostaSimplificada || _vm.usuarioLogado.ds_tipo_usuario === 'FUNDACAO') ? _c('td', {
	      staticClass: "centralizado borda"
	    }, [(!_vm.editando && !_vm.adicionando) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "disable": _vm.bloqueiaBotoes,
	        "type": "button",
	        "id": "financial-physical-activity-0f"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.addItem(atividade, atividadeIndex)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Adicionar\n                  ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.propostaSimplificada) ? _c('td', {
	      staticClass: "centralizado borda"
	    }, [(!_vm.editando && !_vm.adicionando && ((atividade.ds_nome == 'Resumo memória de cálculo' && !_vm.propostaSimplificadaForaPadrao) || _vm.propostaSimplificadaForaPadrao)) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "disable": _vm.bloqueiaBotoes,
	        "type": "button",
	        "id": "financial-physical-activity-0f"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.addItem(atividade, atividadeIndex)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Adicionar\n                  ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item, itemIndex) {
	      return _c('tr', {
	        attrs: {
	          "prefix": "activityItem",
	          "suffix": "item.id",
	          "row": "item"
	        }
	      }, [(!item.editando) ? [_c('td', {
	        staticClass: "centralizado borda w10"
	      }, [(('' + item.origem) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem) === '5') ? _c('span', [_vm._v("Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel) === '1') ? _c('span', {
	        staticClass: "adiantavel"
	      }, [_c('br'), _vm._v("Adiantável")]) : _vm._e()]), _vm._v(" "), _c('td', {
	        staticClass: "borda"
	      }, [_c('div', {
	        staticClass: "item"
	      }, [_c('div', {
	        class: (_vm.propostaDentroFbb && item.conta_financeira ? 'w50' : 'w100') + ' item_despesa esquerda'
	      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), (_vm.propostaDentroFbb && item.conta_financeira) ? _c('div', {
	        staticClass: "conta_financeira direita"
	      }, [_vm._v(_vm._s(item.conta_financeira.numero_conta) + " / " + _vm._s(item.conta_financeira.descricao))]) : _vm._e(), _vm._v(" "), _c('div', {
	        staticClass: "observacao esquerda"
	      }, [_vm._v(_vm._s(item.observacao))])])]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w5"
	      }, [_vm._v(_vm._s(item.periodo_inicial))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w5"
	      }, [_vm._v(_vm._s(item.periodo_final))]), _vm._v(" "), _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	        }],
	        staticClass: "centralizado borda w5",
	        attrs: {
	          "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
	        }
	      }, [_vm._v("\n                    " + _vm._s(item.quantidade) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w10"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_unitario)))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w10"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.quantidade * item.valor_unitario)))]), _vm._v(" "), _c('td', {
	        staticClass: "borda w15"
	      }, [(!_vm.editando && !_vm.adicionando) ? _c('div', {
	        staticClass: "centralizado"
	      }, [_c('b-button', {
	        staticClass: "btn btn-primary btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.bloqueiaBotoes ? null : _vm.editaItem(atividade, atividadeIndex, item, itemIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-pencil-square-o",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	        directives: [{
	          name: "confirm",
	          rawName: "v-confirm",
	          value: ({
	            ok: function (retorno) { return _vm.deleteItem(atividade, atividadeIndex, item, itemIndex); },
	            cancel: _vm.doNothing,
	            message: 'Deseja <b>APAGAR</b> o item ' + item.item.ds_code + '-' + item.item.ds_description + ', da atividade ' + atividade.ds_nome + ' ?'
	          }),
	          expression: "{ok: retorno => deleteItem(atividade, atividadeIndex, item, itemIndex), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> o item ' + item.item.ds_code + '-' + item.item.ds_description + ', da atividade ' + atividade.ds_nome + ' ?'}"
	        }],
	        staticClass: "btn btn-danger btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": _vm.bloqueiaBotoes
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-trash",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Excluir")])], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), (item.editando) ? [_c('td', {
	        attrs: {
	          "colspan": "10"
	        }
	      }, [_c('div', {
	        staticClass: "animated fadeInDownOutUp edicaoItem"
	      }, [_c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('origem')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-5"
	      }, [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.origem),
	          expression: "itemForm.origem"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "name": "origem",
	          "aria-label": "origem"
	        },
	        on: {
	          "change": [function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.itemForm, "origem", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }, function($event) {
	            _vm.zeraAdiantamento();
	            _vm.buscaContasFinanceiras(item)
	          }]
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "1"
	        }
	      }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "2"
	        }
	      }, [_vm._v("Contrapartida")]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('option', {
	        attrs: {
	          "value": "5"
	        }
	      }, [_vm._v("P.Estratégico")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-1"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('inicio')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-1"
	      }, [_vm._v("Início:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-1"
	      }, [_c('div', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.periodo_inicial),
	          expression: "itemForm.periodo_inicial"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        ref: "periodo_inicial",
	        refInFor: true,
	        staticClass: "form-control text-right",
	        attrs: {
	          "type": "number",
	          "name": "inicio",
	          "maxlength": "2",
	          "aria-label": "Inicio do período",
	          "min": atividade.inicio,
	          "max": atividade.termino
	        },
	        domProps: {
	          "value": (_vm.itemForm.periodo_inicial)
	        },
	        on: {
	          "change": _vm.validaPeriodo,
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "periodo_inicial", $event.target.value)
	          }
	        }
	      })]), _vm._v(" "), (_vm.errors.first('inicio')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('inicio')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('fim')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-1"
	      }, [_vm._v("Fim:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-1"
	      }, [_c('div', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.periodo_final),
	          expression: "itemForm.periodo_final"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        ref: "periodo_final",
	        refInFor: true,
	        staticClass: "form-control text-right",
	        attrs: {
	          "type": "number",
	          "name": "fim",
	          "maxlength": "2",
	          "aria-label": "Fim do período",
	          "min": atividade.inicio,
	          "max": atividade.termino
	        },
	        domProps: {
	          "value": (_vm.itemForm.periodo_final)
	        },
	        on: {
	          "change": _vm.validaPeriodo,
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "periodo_final", $event.target.value)
	          }
	        }
	      })]), _vm._v(" "), (_vm.errors.first('fim')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('fim')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('item')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Item de despesa:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-10"
	      }, [_c('div', {
	        attrs: {
	          "approval": "finPhySchFormCtrl.approval",
	          "state": "finPhySchFormCtrl.approvalState"
	        }
	      }, [_c('multiselect', {
	        directives: [{
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        attrs: {
	          "name": "item",
	          "custom-label": _vm.itemCodigo,
	          "searchable": true,
	          "options": _vm.propostaSimplificada ? _vm.itemsFiltradosProcessoSimplificado : _vm.items,
	          "close-on-select": true,
	          "hide-selected": true,
	          "preserve-search": false,
	          "placeholder": "Escolha um item",
	          "disabled": _vm.itemForm.origem === null || (_vm.editando && _vm.propostaSimplificada),
	          "label": "ds_description",
	          "track-by": "ds_code",
	          "preselect-first": false
	        },
	        on: {
	          "select": function($event) {
	            return _vm.buscaContasFinanceiras($event)
	          }
	        },
	        scopedSlots: _vm._u([{
	          key: "option",
	          fn: function(props) {
	            return [_c('div', {
	              staticClass: "option__desc"
	            }, [_c('span', {
	              staticClass: "option__title"
	            }, [_vm._v(_vm._s(props.option.ds_code) + " / " + _vm._s(props.option.ds_description))])])]
	          }
	        }], null, true),
	        model: {
	          value: (_vm.itemForm.item),
	          callback: function($$v) {
	            _vm.$set(_vm.itemForm, "item", $$v)
	          },
	          expression: "itemForm.item"
	        }
	      }, [_vm._v(" "), _c('span', {
	        attrs: {
	          "slot": "noResult"
	        },
	        slot: "noResult"
	      }, [_c('font', {
	        attrs: {
	          "color": "red"
	        }
	      }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('item')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('item')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('descrição item')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Descrição Item:")]), _vm._v(" "), _c('div', [_c('div', {
	        staticClass: "col-md-10"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.observacao),
	          expression: "itemForm.observacao"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "type": "text",
	          "name": "descrição item",
	          "maxlength": "255",
	          "aria-label": "Descrição do item"
	        },
	        domProps: {
	          "value": (_vm.itemForm.observacao)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "observacao", $event.target.value)
	          }
	        }
	      }), _vm._v(" "), (_vm.errors.first('descrição item')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('descrição item')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('quantidade')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-1"
	      }, [_c('div', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.quantidade),
	          expression: "itemForm.quantidade"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required|min_value:1'),
	          expression: "'required|min_value:1'"
	        }],
	        staticClass: "form-control text-right",
	        attrs: {
	          "type": "number",
	          "name": "quantidade",
	          "min": "1",
	          "maxlength": "6",
	          "aria-label": "Quantidade do recurso"
	        },
	        domProps: {
	          "value": (_vm.itemForm.quantidade)
	        },
	        on: {
	          "change": function($event) {
	            return _vm.valorTotal(_vm.itemForm)
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "quantidade", $event.target.value)
	          }
	        }
	      })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "col-sm-2"
	      }, [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.unidade_medida),
	          expression: "itemForm.unidade_medida"
	        }],
	        staticClass: "form-control",
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.itemForm, "unidade_medida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, _vm._l((_vm.medidas), function(unidade_medida) {
	        return _c('option', {
	          domProps: {
	            "value": unidade_medida
	          }
	        }, [_vm._v(_vm._s(unidade_medida))])
	      }), 0)]), _vm._v(" "), (_vm.itemForm.unidade_medida === 'Outros') ? _c('div', {
	        staticClass: "col-md-2 required-field",
	        class: {
	          'has-error': _vm.errors.first('medida outros')
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.medida_outros),
	          expression: "itemForm.medida_outros"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }, {
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	        }],
	        staticClass: "form-control text-right",
	        attrs: {
	          "type": "text",
	          "name": "medida outros",
	          "maxlength": "255",
	          "aria-label": "Outros",
	          "title": '<h5>Qual essa outra unidade de medida?</h5>'
	        },
	        domProps: {
	          "value": (_vm.itemForm.medida_outros)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "medida_outros", $event.target.value)
	          }
	        }
	      }), _vm._v(" "), (_vm.errors.first('medida outros')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('medida outros')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('valor unitario')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-1"
	      }, [_vm._v("Valor Unitário:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-2"
	      }, [_c('div', [_c('money', {
	        directives: [{
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required|min_value:0.01'),
	          expression: "'required|min_value:0.01'"
	        }],
	        staticClass: "form-control text-right",
	        attrs: {
	          "name": "valor unitario"
	        },
	        on: {
	          "change": function($event) {
	            return _vm.valorTotal(_vm.itemForm)
	          }
	        },
	        model: {
	          value: (_vm.itemForm.valor_unitario),
	          callback: function($$v) {
	            _vm.$set(_vm.itemForm, "valor_unitario", $$v)
	          },
	          expression: "itemForm.valor_unitario"
	        }
	      })], 1), _vm._v(" "), (_vm.errors.first('valor unitario')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('valor unitario')))]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Valor Total: " + _vm._s(_vm._f("real")((_vm.itemForm.quantidade * _vm.itemForm.valor_unitario))))])])]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [(_vm.proposta.ds_fase === 'ANALISE') ? _c('div', {
	        staticClass: " required",
	        class: {
	          'has-error': _vm.errors.first('adiantavel')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Adiantável:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-2"
	      }, [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.adiantavel),
	          expression: "itemForm.adiantavel"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "disabled": _vm.itemForm.origem === '2' || _vm.itemForm.origem === 2,
	          "name": "adiantavel",
	          "required": ""
	        },
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.itemForm, "adiantavel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "0"
	        }
	      }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "1"
	        }
	      }, [_vm._v("Sim")])]), _vm._v(" "), (_vm.errors.first('adiantavel')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('adiantavel')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.propostaDentroFbb()) ? _c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('conta financeira')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Conta Financeira:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-6"
	      }, [(_vm.buscandoContaFinanceira) ? _c('span', {
	        staticStyle: {
	          "color": "red"
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-refresh fa-spin"
	      }), _vm._v(" buscando contas financeiras, aguarde...\n                          ")]) : _vm._e(), _vm._v(" "), _c('multiselect', {
	        directives: [{
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        attrs: {
	          "disabled": _vm.blockSelect === true,
	          "name": "conta financeira",
	          "custom-label": _vm.contaCodigo,
	          "options": _vm.contasFinanceiras,
	          "close-on-select": true,
	          "hide-selected": true,
	          "preserve-search": false,
	          "placeholder": "Escolha um item",
	          "label": "numero_conta",
	          "track-by": "numero_conta",
	          "preselect-first": false
	        },
	        on: {
	          "select": _vm.selecionaConta
	        },
	        scopedSlots: _vm._u([{
	          key: "option",
	          fn: function(props) {
	            return [_c('div', {
	              staticClass: "option__desc"
	            }, [_c('span', {
	              staticClass: "option__title"
	            }, [_vm._v(_vm._s(props.option.numero_conta) + " / " + _vm._s(props.option.descricao))])])]
	          }
	        }], null, true),
	        model: {
	          value: (_vm.itemForm.conta_financeira),
	          callback: function($$v) {
	            _vm.$set(_vm.itemForm, "conta_financeira", $$v)
	          },
	          expression: "itemForm.conta_financeira"
	        }
	      }, [_vm._v(" "), _c('span', {
	        attrs: {
	          "slot": "noResult"
	        },
	        slot: "noResult"
	      }, [_c('font', {
	        attrs: {
	          "color": "red"
	        }
	      }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('conta financeira')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('conta financeira')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "col-md-10 col-md-offset-2"
	      }, [_c('button', {
	        ref: "financial-physical-save-item",
	        refInFor: true,
	        staticClass: "btn btn-confirm btn-flat",
	        class: {
	          disabled: _vm.submitDisabled
	        },
	        attrs: {
	          "id": "financial-physical-save-item",
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onAdd(atividade, item, itemIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-check",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	        staticClass: "btn btn-back btn-flat",
	        attrs: {
	          "id": "financial-physical-cancel-item",
	          "type": "button"
	        },
	        on: {
	          "~click": function($event) {
	            return _vm.cancelaItem(atividade, item, itemIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-times-circle",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Cancelar")])])])])])] : _vm._e()], 2)
	    })]
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.contrapartida !== 0) ? _c('span', [_vm._v("Total Contrapartida")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.adiantavel.total !== 0) ? _c('span', [_vm._v("Total Adiantável")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total do Projeto")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total da Fundação R$ <span class=\'realce\'>' + (_vm.totais.projeto.fbb).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.fbb + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.fbb / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total de Parceiro Estratégico R$ <span class=\'realce\'>' + (_vm.totais.projeto.parceiros).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.parceiros + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.parceiros / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.contrapartida !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total da Contrapartida R$ <span class=\'realce\'>' + (_vm.totais.projeto.contrapartida).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.contrapartida + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.contrapartida / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.adiantavel.total !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total Adiantável R$ <span class=\'realce\'>' + _vm.totais.adiantavel.total + '</span>, sendo R$ <span class=\'realce\'>' + _vm.totais.adiantavel.fbb + '</span> da Fundação e R$ <span class=\'realce\'>' + _vm.totais.adiantavel.parceiros + '</span> de Parc. Estratégico</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.adiantavel.total)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Investimento: <span class=\'realce\'>' + ((_vm.totalInvestimento / (_vm.totalInvestimento + _vm.totalCusteio)) * 100).toFixed(1) + '%</span> Custeio: <span class=\'realce\'>' + (_vm.totalCusteio / (_vm.totalCusteio + _vm.totalInvestimento) * 100).toFixed(1) + '%</span></h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.total)))])])])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('table', {
	    staticClass: "totais",
	    staticStyle: {
	      "margin": "10px 0"
	    }
	  }, [_c('tr', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_c('td', {
	    staticStyle: {
	      "padding": "1px",
	      "text-align": "center",
	      "vertical-align": "baseline"
	    }
	  }, [_c('p', [_c('span', [_vm._v(" Investimento "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-info-circle",
	    attrs: {
	      "title": "Produtos, obra civil, seguros e IPVA"
	    }
	  })])]), _vm._v(" "), _c('p', [_c('span', [_c('strong', [_vm._v(" " + _vm._s((_vm.totalInvestimento / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")])])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(" " + _vm._s(_vm._f("real")(_vm.totalInvestimento)) + " ")])])]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "padding": "1px",
	      "text-align": "center",
	      "vertical-align": "baseline"
	    }
	  }, [_c('p', [_c('span', [_vm._v(" Custeio "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-info-circle",
	    attrs: {
	      "title": "O que não for investimento"
	    }
	  })])]), _vm._v(" "), _c('p', [_c('span', [_c('strong', [_vm._v(" " + _vm._s((_vm.totalCusteio / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")])])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(" " + _vm._s(_vm._f("real")(_vm.totalCusteio)) + " ")])]), _vm._v(" "), _c('p', [_vm._v("\n              Capacitação e assessoria\n              "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(((_vm.totalCapacitacao + _vm.totalAssessoria) / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")]), _vm._v("\n              (" + _vm._s(_vm._f("real")(_vm.totalCapacitacao + _vm.totalAssessoria)) + ")\n            ")])])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Atividade / Itens do Cronograma")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
	}]}

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - GED'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("GED")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ged"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-11"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "type": "button",
	      "disabled": _vm.botaoAdicionarDocumento
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.mostrarAdicionarDocumento = !_vm.mostrarAdicionarDocumento
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Adicionar documento ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('upload-documento', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarAdicionarDocumento),
	      expression: "mostrarAdicionarDocumento"
	    }],
	    attrs: {
	      "documentTypes": '',
	      "lista-projetos": _vm.projetos,
	      "lista-entidades": _vm.entidades
	    },
	    on: {
	      "mostrarQuadroAdicionaDocumento": function($event) {
	        _vm.mostrarAdicionarDocumento = $event
	      }
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        interactive: true,
	        theme: 'light',
	        position: 'top'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', position: 'top'}"
	    }],
	    staticClass: "col-md-1 legenda",
	    attrs: {
	      "title": '<table class=\'legenda_tabela\'>' +
	        '<tr><td class=\'DEF\'><i class=\'fa fa-folder\'></i></td><td>Não contratado (ANA, DEF)</td></tr>' +
	        '<tr><td class=\'APR\'><i class=\'fa fa-folder\'></i></td><td>Aprovado e regular (APR)</td></tr>' +
	        '<tr><td class=\'SO3\'><i class=\'fa fa-folder\'></i></td><td>Aprovado e irregular (SO3, SO4, DLG, SPS etc)</td></tr>' +
	        '<tr><td class=\'ENC\'><i class=\'fa fa-folder\'></i></td><td>Encerrado ou quase (ETO, ENC)</td></tr>' +
	        '<tr><td style=\'color: #777\'><i class=\'fa fa-folder\'></i></td><td>Cancelado ou situação não definida</td></tr>' +
	        '<tr><td class=\'text-bold\'>!</td><td>Informação não foi encontrada</td></tr>' +
	        '</table>' +
	        '<br/><br/>' +
	        '<table class=\'legenda_tabela\'>' +
	        '<tr><td>Liberação de recursos</td><td>Id ... Situação ... Valor total</td></tr>' +
	        '<tr><td>Proposta</td><td>Início do projeto ... Duração dele</td></tr>' +
	        '<tr><td>Dirigentes</td><td>Cargo ... Nome ... Mandato ... Situação</td></tr>' +
	        '<tr><td>Entidade</td><td>CNPJ ... Razão Social</td></tr>' +
	        '<tr><td>Relatório de Execução</td><td>Número ref. ... Situação ... apresentação ... aprovação</td></tr>' +
	        '</table>' +
	        '<br/><br/>' +
	        '<table class=\'legenda_tabela\'>' +
	        '<tr><td class=\'text-bold\'>Situação</td><td>&nbsp;</td></tr>' +
	        '<tr><td class=\'text-bold text-right\'>  FEITO</td><td>Ação que foi concluída</td></tr>' +
	        '<tr><td class=\'text-bold text-right\'>  EM_EXECUCAO</td><td>Ação que está em andamento</td></tr>' +
	        '<tr><td class=\'text-bold text-right\'>  CANCELADO</td><td>Ação excluída/não processada</td></tr>' +
	        '</table>' +
	        '<br/><br/>' +
	        '<table class=\'legenda_tabela\'>' +
	        '<tr><td class=\'text-gray\'><i class=\'fa fa-refresh\'></i></td><td>Indica que pode clicar oara atualizar a pasta</td></tr>' +
	        '<tr><td style=\'color: steelblue\'><i class=\'fa fa-download\'></i></td><td>Indica que pode fazer download do arquivo</td></tr>' +
	        '<tr><td style=\'background:#b41904;\'>&nbsp;</td><td>Indica que a data de validade expirou</td></tr>' +
	        '</table>'
	    }
	  }, [_vm._v("Legenda")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "sidebar"
	  }, [_c('div', {
	    staticClass: "arvore_projetos"
	  }, [_c('li', {
	    staticClass: "treeview",
	    attrs: {
	      "data-widget": "tree"
	    }
	  }, [_vm._m(1), _vm._v(" "), (!_vm._.isNil(_vm.projetos) && _vm.projetos.length > 0) ? _c('ul', {
	    staticClass: "treeview-menu"
	  }, _vm._l((_vm.projetos), function(projeto) {
	    return _c('li', {
	      staticClass: "treeview projeto",
	      attrs: {
	        "data-widget": "tree"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.carregarPastas(projeto.id)
	        }
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [_c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large',
	          interactive: true,
	          theme: 'dark',
	          position: 'top'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'dark', position: 'top'}"
	      }],
	      class: 'fa fa-folder ' + projeto.situacao,
	      attrs: {
	        "title": '<h5>' + projeto.situacao + '</h5>'
	      }
	    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(projeto.ds_codigo_projeto_erp + ' - ' + projeto.ds_nome))])]), _vm._v(" "), (!_vm._.isNil(projeto.pastas) && projeto.pastas.length > 0) ? _c('ul', {
	      staticClass: "treeview-menu",
	      staticStyle: {
	        "display": "none"
	      }
	    }, _vm._l((projeto.pastas), function(pasta) {
	      return _c('li', {
	        staticClass: "treeview pasta",
	        attrs: {
	          "data-widget": "tree"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.carregarArquivos(pasta.id, projeto.id, false)
	          }
	        }
	      }, [_c('a', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'fade',
	            distance: '1',
	            size: 'large',
	            interactive: true,
	            theme: 'dark',
	            position: 'top'
	          }),
	          expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'dark', position: 'top'}"
	        }],
	        attrs: {
	          "href": "#",
	          "title": "<h5>Clique para descobrir/buscar arquivos</h5>"
	        }
	      }, [_c('i', {
	        class: 'fa ' + pasta.icone
	      }), _vm._v(" "), _c('span', [_vm._v("\n                                " + _vm._s(pasta.nome) + "\n                                "), _c('span', {
	        staticClass: "contador"
	      }, [_vm._v("\n                                  " + _vm._s((_vm._.isNil(pasta.arquivos) ? '' : (pasta.arquivos.length > 0 ? pasta.arquivos.length + ' arquivo' + (pasta.arquivos.length > 1 ? 's' : '') : 'nenhum arquivo'))) + "\n                                  "), (!_vm._.isNil(pasta.arquivos)) ? _c('i', {
	        staticClass: "fa fa-refresh",
	        on: {
	          "click": function($event) {
	            return _vm.carregarArquivos(pasta.id, projeto.id, true)
	          }
	        }
	      }) : _vm._e()])])]), _vm._v(" "), (!_vm._.isNil(pasta.arquivos) && pasta.arquivos.length > 0) ? _c('ul', {
	        staticClass: "treeview-menu"
	      }, _vm._l((_vm._.values(_vm._.groupBy(pasta.arquivos, 'grupo'))), function(agrupado) {
	        return _c('li', {
	          staticClass: "treeview pasta",
	          attrs: {
	            "data-widget": "tree"
	          }
	        }, [_c('a', {
	          attrs: {
	            "href": "#"
	          }
	        }, [_c('span', [_vm._v(_vm._s(agrupado[0].grupo) + "\n                                    "), _c('span', {
	          staticClass: "contador"
	        }, [_vm._v("\n                                    " + _vm._s((_vm._.isNil(agrupado) ? '' : (agrupado.length > 0 ? agrupado.length + ' arquivo' + (agrupado.length > 1 ? 's' : '') : 'nenhum arquivo'))) + "\n                                    "), (!_vm._.isNil(agrupado)) ? _c('i', {
	          staticClass: "fa fa-external-link",
	          on: {
	            "click": function($event) {
	              return _vm.irPara(agrupado[0].link)
	            }
	          }
	        }) : _vm._e()])])]), _vm._v(" "), _c('ul', {
	          staticClass: "treeview-menu",
	          style: ('display: ' + (_vm._.values(_vm._.groupBy(pasta.arquivos, 'grupo')).length === 1 ? 'block' : 'none'))
	        }, [_c('table', {
	          staticClass: "arquivos"
	        }, [_c('tbody', _vm._l((_vm._.sortBy(agrupado, 'ds_tipo')), function(arquivo) {
	          return _c('tr', [_c('td', {
	            style: (arquivo.ds_tipo.length > 57 ? 'width: 540px' : '')
	          }, [_vm._v(_vm._s(arquivo.ds_tipo))]), _vm._v(" "), _c('td', [_c('a', {
	            staticClass: "ng-binding",
	            attrs: {
	              "href": "javascript:void(0)"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.onDownload(arquivo)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-download",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          }), _vm._v(" " + _vm._s(arquivo.ds_nome_arquivo))])]), _vm._v(" "), _c('td', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'fade',
	                distance: '1',
	                size: 'large',
	                interactive: true,
	                theme: 'dark',
	                position: 'top'
	              }),
	              expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'dark', position: 'top'}"
	            }],
	            staticClass: "data_incluido",
	            attrs: {
	              "title": _vm._.isNil(arquivo.incluido) ? '' : '<h6>Data de inclusão</h6>'
	            }
	          }, [_vm._v(_vm._s(arquivo.incluido))]), _vm._v(" "), _c('td', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'fade',
	                distance: '1',
	                size: 'large',
	                interactive: true,
	                theme: 'dark',
	                position: 'top'
	              }),
	              expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'dark', position: 'top'}"
	            }],
	            class: 'data_validade ' + (_vm.dataExpirada(arquivo.validade) ? 'data_expirada' : ''),
	            attrs: {
	              "title": _vm._.isNil(arquivo.validade) ? '' : '<h6>Data de validade</h6>'
	            }
	          }, [_vm._v(_vm._s(arquivo.validade))])])
	        }), 0)])])])
	      }), 0) : _vm._e()])
	    }), 0) : _vm._e()])
	  }), 0) : _vm._e()])])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta de Documentos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-folder-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Projetos")])])
	}]}

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row form-horizontal form_importacao"
	  }, [_c('div', {
	    staticClass: "col-sm-12 form-group"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.analise.length === 0),
	      expression: "analise.length === 0"
	    }]
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2"
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    ref: "fileUpload",
	    attrs: {
	      "type": "file",
	      "id": "fileUpload"
	    },
	    on: {
	      "change": _vm.arquivoAlterado
	    }
	  })])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.analise.length > 0),
	      expression: "analise.length > 0"
	    }]
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.limparArquivo($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa fa-repeat",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Trocar o arquivo")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10 nome_arquivo"
	  }, [_vm._v(_vm._s(_vm.nomeArquivo))])])]), _vm._v(" "), (_vm.analise.length > 0) ? _c('div', {
	    staticClass: "col-sm-12 resultado_importacao"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2"
	  }, [_vm._v("Resultado:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.verificacaoExcel)
	    }
	  }), _vm._v(" "), (_vm.acaoComplementar && _vm.contadorErrosGerais === 0) ? _c('div', [_c('div', {
	    staticClass: "verificacaoALERTA"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.textoAcaoComplementar)
	    }
	  }), _vm._v(" "), _c('span', {
	    ref: "respostaAcaoComplementar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.opcaoAcaoComplementar(true)
	      }
	    }
	  }, [_vm._v("Sim")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.opcaoAcaoComplementar(false)
	      }
	    }
	  }, [_vm._v("Não")])], 1)])]) : _vm._e()])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraGridPublicoAlvo),
	      expression: "mostraGridPublicoAlvo"
	    }]
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-show": "$ctrl.isNewAvaiable()"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostraGridPublicoAlvo = !_vm.mostraGridPublicoAlvo
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Público alvo")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "youngs",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
	      }
	    }, {
	      key: "women",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.exclui(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }])
	  })], 1)], 1)])]), _vm._v(" "), (!_vm.mostraGridPublicoAlvo) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    },
	    attrs: {
	      "disabled": _vm.mostraGridPublicoAlvo,
	      "ng-form": "frmAddTargetAudience",
	      "ssm-isolated-form": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Público-alvo')
	    },
	    attrs: {
	      "ng-if": "$ctrl.isAval('AUDIENCE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "audience"
	    }
	  }, [_vm._v("Público-alvo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.audience),
	      expression: "publicoAlvo.audience"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "Público-alvo"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.publicoAlvo, "audience", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.publicosAlvo), function(publico) {
	    return _c('option', {
	      domProps: {
	        "value": publico
	      }
	    }, [_vm._v(_vm._s(publico.description))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('Público-alvo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Tipo público-alvo')
	    },
	    attrs: {
	      "ng-if": "$ctrl.isAval('AUDIENCETYPE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "audienceType"
	    }
	  }, [_vm._v("Tipo público-alvo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.audienceType),
	      expression: "publicoAlvo.audienceType"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo público-alvo"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.publicoAlvo, "audienceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("Outros")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20"
	    }
	  }, [_vm._v("Agricultores familiares")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "30"
	    }
	  }, [_vm._v("Assentados da reforma agrária")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "40"
	    }
	  }, [_vm._v("Extrativistas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "50"
	    }
	  }, [_vm._v("Indígenas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "60"
	    }
	  }, [_vm._v("Catadores de materiais recicláveis")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "70"
	    }
	  }, [_vm._v("Associados")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "80"
	    }
	  }, [_vm._v("Jovens de 18 a 24 anos (ambos os sexos) do Programa Jovem Aprendiz no Campo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "90"
	    }
	  }, [_vm._v("Estudantes Ensino Superior Público (UFOB) da Área de alimentos (18 a 24 anos - ambos os sexos)")])])]), _vm._v(" "), (_vm.errors.first('Tipo público-alvo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Tipo público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('participantes diretos')
	    },
	    attrs: {
	      "ng-if": "$ctrl.isAval('DIRECTPARTICIPANTS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "directParticipants"
	    }
	  }, [_vm._v("Participantes diretos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.directParticipants),
	      expression: "publicoAlvo.directParticipants"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "participantes diretos",
	      "min": "1",
	      "max": "2147483647",
	      "type": "number",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.publicoAlvo.directParticipants)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.publicoAlvo, "directParticipants", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('participantes Indiretos')
	    },
	    attrs: {
	      "ng-if": "$ctrl.isAval('INDIRECTPARTICIPANTS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "indirectParticipants"
	    }
	  }, [_vm._v("Participantes indiretos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.indirectParticipants),
	      expression: "publicoAlvo.indirectParticipants"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max_value:2147483647'),
	      expression: "'max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "participantes Indiretos",
	      "type": "number",
	      "max": "2147483647"
	    },
	    domProps: {
	      "value": (_vm.publicoAlvo.indirectParticipants)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.publicoAlvo, "indirectParticipants", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('participantes Indiretos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes Indiretos')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Atende jovens')
	    },
	    attrs: {
	      "ng-if": "$ctrl.isAval('YOUNGSBOOL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "youngsBool"
	    }
	  }, [_vm._v("Atende jovens?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.youngsBool),
	      expression: "youngsBool"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Atende jovens"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.youngsBool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Sim"
	    },
	    domProps: {
	      "selected": _vm.publicoAlvo.youngs
	    }
	  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Não"
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), (_vm.errors.first('Atende jovens')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Atende jovens')))]) : _vm._e()])]), _vm._v(" "), (_vm.youngsBool === 'Sim') ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Número de jovens atendidos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "youngs"
	    }
	  }, [_vm._v("Número de jovens atendidos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.youngs),
	      expression: "publicoAlvo.youngs"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.youngsBool === 'Sim'
	      }),
	      expression: "{required: youngsBool === 'Sim'}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Número de jovens atendidos",
	      "type": "number",
	      "min": "1",
	      "max": _vm.publicoAlvo.indirectParticipants + _vm.publicoAlvo.directParticipants
	    },
	    domProps: {
	      "value": (_vm.publicoAlvo.youngs)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.publicoAlvo, "youngs", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Número de jovens atendidos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número de jovens atendidos')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Atende mulheres')
	    },
	    attrs: {
	      "ng-if": "$ctrl.isAval('WOMENBOOL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "womenBool"
	    }
	  }, [_vm._v("Atende mulheres?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.womenBool),
	      expression: "womenBool"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Atende mulheres"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.womenBool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Sim"
	    }
	  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Não"
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), (_vm.errors.first('Atende mulheres')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Atende mulheres')))]) : _vm._e()])]), _vm._v(" "), (_vm.womenBool === 'Sim') ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Número de mulheres atendidas')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "women"
	    }
	  }, [_vm._v("Número de mulheres atendidas:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.women),
	      expression: "publicoAlvo.women"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.womenBool == 'Sim'
	      }),
	      expression: "{required: womenBool=='Sim'}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Número de mulheres atendidas",
	      "type": "number",
	      "min": "1",
	      "max": _vm.publicoAlvo.indirectParticipants + _vm.publicoAlvo.directParticipants
	    },
	    domProps: {
	      "value": (_vm.publicoAlvo.women)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.publicoAlvo, "women", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Número de mulheres atendidas')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número de mulheres atendidas')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-audience-add"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-audience-cancel"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelaPublico()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e(), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-3 required-field",
	    class: {
	      'has-error': _vm.errors.first('data CMJ')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data do CMJ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [(this.$router.currentRoute.name === 'projeto') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dt_data_cmj),
	      expression: "analise.dt_data_cmj"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|dateeqpast'),
	      expression: "'required|dateeqpast'"
	    }],
	    ref: "dataCMJ",
	    staticClass: "form-control ",
	    attrs: {
	      "type": "date",
	      "name": "data do CMJ",
	      "data-vv-as": "data do CMJ"
	    },
	    domProps: {
	      "value": (_vm.analise.dt_data_cmj)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "dt_data_cmj", $event.target.value)
	      }
	    }
	  }) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dt_data_cmj),
	      expression: "analise.dt_data_cmj"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|dateeqpast|date_format:dd/MM/yyyy'),
	      expression: "'required|dateeqpast|date_format:dd/MM/yyyy'"
	    }],
	    ref: "dataCMJ",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "data do CMJ",
	      "placeholder": "__ /__ /____",
	      "data-vv-as": "data do CMJ"
	    },
	    domProps: {
	      "value": (_vm.analise.dt_data_cmj)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "dt_data_cmj", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('data do CMJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data do CMJ')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-3 required-field",
	    class: {
	      'has-error': _vm.errors.first('cmj')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número do CMJ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.ds_cmj),
	      expression: "analise.ds_cmj"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cmj",
	      "type": "text",
	      "maxlength": "255",
	      "placeholder": "Número do CMJ"
	    },
	    domProps: {
	      "value": (_vm.analise.ds_cmj)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "ds_cmj", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cmj')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cmj')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-3 required-field",
	    class: {
	      'has-error': _vm.errors.first('data parecer')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data do parecer jurídico")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [(this.$router.currentRoute.name === 'projeto') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dt_data_parecer_juridico),
	      expression: "analise.dt_data_parecer_juridico"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|dateeqpast'),
	      expression: "'required|dateeqpast'"
	    }],
	    ref: "dataParecerJuridico",
	    staticClass: "form-control",
	    attrs: {
	      "type": "date",
	      "name": "data do parecer juridico",
	      "data-vv-as": "data do parecer juridico"
	    },
	    domProps: {
	      "value": (_vm.analise.dt_data_parecer_juridico)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "dt_data_parecer_juridico", $event.target.value)
	      }
	    }
	  }) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dt_data_parecer_juridico),
	      expression: "analise.dt_data_parecer_juridico"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|dateeqpast|date_format:dd/MM/yyyy|after:dataCMJ,true'),
	      expression: "'required|dateeqpast|date_format:dd/MM/yyyy|after:dataCMJ,true'"
	    }],
	    ref: "dataParecerJuridico",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "data do parecer juridico",
	      "placeholder": "__ /__ /____",
	      "data-vv-as": "data do parecer juridico"
	    },
	    domProps: {
	      "value": (_vm.analise.dt_data_parecer_juridico)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "dt_data_parecer_juridico", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('data do parecer juridico')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data do parecer juridico')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-3 required-field",
	    class: {
	      'has-error': _vm.errors.first('número do parecer jurídico')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número do parecer jurídico")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.ds_parecer_juridico),
	      expression: "analise.ds_parecer_juridico"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "número do parecer jurídico",
	      "type": "text",
	      "placeholder": "Número do parecer jurídico"
	    },
	    domProps: {
	      "value": (_vm.analise.ds_parecer_juridico)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "ds_parecer_juridico", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('número do parecer jurídico')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número do parecer jurídico')))]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Projetos'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Projetos")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Projeto',
	        href: '#'
	      }, {
	        text: 'Lista',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-rocket",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Projetos "), (!_vm.loading.show) ? _c('span', {
	    staticStyle: {
	      "font-size": "small",
	      "color": "var(--cor-fraca)"
	    }
	  }, [_vm._v(_vm._s(_vm.tableProjetos.totalRows) + " localizado(s)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    class: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'col-md-offset-3 col-md-5' : 'col-md-offset-4 col-md-5')
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": _vm.ajustaPesquisa,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.tableProjetos.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.tableProjetos.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Carteira:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.carteiraSelecionada),
	      expression: "carteiraSelecionada"
	    }],
	    staticClass: "form-control",
	    domProps: {
	      "value": _vm.configuracoes.tela_projetos.codigoCarteira
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.carteiraSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.selecionaCarteira]
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Todos os projetos")]), _vm._v(" "), _vm._l((_vm.listaCarteiras), function(carteira) {
	    return _c('option', {
	      domProps: {
	        "value": carteira.usu_codcart
	      }
	    }, [_vm._v(_vm._s(carteira.usu_nomcart))])
	  })], 2)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableProjetos.bordered,
	      "items": _vm.itemsProjetos,
	      "fields": _vm.fieldsProjetos,
	      "current-page": _vm.tableProjetos.currentPage,
	      "per-page": _vm.tableProjetos.perPage,
	      "filter": _vm.tableProjetos.filter,
	      "filter-function": _vm.filtroPorItem,
	      "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.tableProjetos.sortBy,
	      "sort-desc": _vm.tableProjetos.sortDesc
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableProjetos, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableProjetos, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableProjetos, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableProjetos, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'projeto',
	                params: {
	                  numero: row.item.ds_codigo_projeto_erp
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-rocket",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Projeto")]), _vm._v(" "), (!_vm.ehParceiroEstrategico) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'visualiza-relatorio-execucao',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-calendar-check-o",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Relatório")]) : _vm._e(), _vm._v(" "), (!_vm.ehParceiroEstrategico) ? _c('g-button-ujarak', {
	          attrs: {
	            "title": "Gerar documentos",
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'emissao-documentos',
	                params: {
	                  numero: row.item.ds_codigo_projeto_erp
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-file",
	          attrs: {
	            "aria-label": "false"
	          }
	        })]) : _vm._e(), _vm._v(" "), (!_vm.ehParceiroEstrategico && row.item.qtdeAvaliacoesProjeto > 0) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return row.toggleDetails()
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v("\n                        " + _vm._s(row.item.qtdeAvaliacoesProjeto) + " " + _vm._s(row.item.qtdeAvaliacoesProjeto > 1 ? 'Avaliações' : 'Avaliação') + "\n                      ")]) : _vm._e()]
	      }
	    }, {
	      key: "row-details",
	      fn: function(row) {
	        return [_c('avaliacoes-projeto', {
	          attrs: {
	            "numeroProjeto": row.item.ds_codigo_projeto_erp,
	            "editavel": true
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.tableProjetos.totalRows,
	      "per-page": _vm.tableProjetos.perPage
	    },
	    model: {
	      value: (_vm.tableProjetos.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tableProjetos, "currentPage", $$v)
	      },
	      expression: "tableProjetos.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "rating"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.edicaoCalculo),
	      expression: "!edicaoCalculo"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.calculando),
	      expression: "calculando"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-1"
	  }, [_c('g-button-moema', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.calculando),
	      expression: "!calculando"
	    }],
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.edicaoCalculo = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Editar")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('table', {
	    staticClass: "table table-condensed ratingCalculos"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Representa a situação da entidade e de seus dirigentes com relação a prestação de contas e ao cumprimento de seus compromisssos</h5>'
	    }
	  }, [_vm._v("CD")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Reflete de maneira indireta as condições economico-financeiras da entidade</h5>'
	    }
	  }, [_vm._v("RFP")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Sinaliza a capacidade de articulação da entidade considerando que quanto maior o investimento da FBB maior interesse , disposição e compentência em apresentar propostas</h5>'
	    }
	  }, [_vm._v("IS")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Evidencia o aspecto social da atuação da entidade por meio da quantidade de participantes diretos atendidos</h5>'
	    }
	  }, [_vm._v("PD")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Reflete a experiência da entidade com base em seu tempo de constituição</h5>'
	    }
	  }, [_vm._v("HIS 1")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Experiência em projetos e o modus operandi da Fundação</h5>'
	    }
	  }, [_vm._v("HIS 2")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Reflete as ocorrências vigentes da entidade</h5>'
	    }
	  }, [_vm._v("OC 1")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Ocorrências registradas para projetos em execução</h5>'
	    }
	  }, [_vm._v("OC 2")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Ocorrências registradas para projetos encerrado</h5>'
	    }
	  }, [_vm._v("OC 3")])])]), _vm._v(" "), _c('tr', {
	    staticClass: "dado"
	  }, [_c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.CD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.RFP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.IS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.PD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC3))])]), _vm._v(" "), _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "9"
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.formula) + " = "), _c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.total))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 ratingCalculos"
	  }, [(!_vm.calculando) ? _c('span', {
	    staticClass: "dado ratingNota"
	  }, [_vm._v(_vm._s(_vm.rating.classificacao.nota))]) : _c('span', {
	    staticClass: "dado ratingNota"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.edicaoCalculo),
	      expression: "edicaoCalculo"
	    }],
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-11"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Convenente:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.dadosGerais.entidade.ds_nome))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Código:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.dadosGerais.entidade.nr_codigo_forn_erp))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.dadosGerais.entidade.ds_cnpj)))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data de abertura:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dadosGerais.entidade.dt_data_expedicao_cnpj, "L")))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Tempo de abertura:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dadosGerais.entidade.dt_data_expedicao_cnpj, "from", "now")))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-bordered text-center"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dadosGerais.entidade.dirigentes), function(dirigente) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(dirigente.ds_nome) + "    "), _c('span', {
	      staticStyle: {
	        "color": "cornflowerblue"
	      }
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dirigente.ds_cpf))]), _vm._v(" "), _c('td', [_c('money', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "onchange": _vm.totalSerasaDirigentes,
	        "name": "serasa_dirigente",
	        "type": "text"
	      },
	      model: {
	        value: (dirigente.serasa),
	        callback: function($$v) {
	          _vm.$set(dirigente, "serasa", $$v)
	        },
	        expression: "dirigente.serasa"
	      }
	    })], 1), _vm._v(" "), _c('td', [_c('money', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "onchange": _vm.totalSCPCDirigentes,
	        "name": "scpc_dirigente",
	        "type": "text"
	      },
	      model: {
	        value: (dirigente.scpc),
	        callback: function($$v) {
	          _vm.$set(dirigente, "scpc", $$v)
	        },
	        expression: "dirigente.scpc"
	      }
	    })], 1), _vm._v(" "), _c('td', [(dirigente.cadin !== 0) ? _c('div', {
	      staticClass: "data"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (dirigente.cadin),
	        expression: "dirigente.cadin"
	      }, {
	        name: "mask",
	        rawName: "v-mask",
	        value: ('##/##/####'),
	        expression: "'##/##/####'"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required|validdate|dateeqfuture'),
	        expression: "'required|validdate|dateeqfuture'"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "onchange": _vm.cadinDirigente,
	        "data-vv-as": _vm.cadin_dirigente,
	        "masked": _vm.masked
	      },
	      domProps: {
	        "value": (dirigente.cadin)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(dirigente, "cadin", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (_vm.errors.first('cadin_dirigente')) ? _c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin_dirigente')))]) : _vm._e()]) : _c('div', {
	      staticClass: "nada_consta dado"
	    }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	      }],
	      staticClass: "bt_nada_consta",
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss",
	        "title": '<h5>' + (dirigente.cadin === 0 ? 'Se houver certidão, clique para informar a data de validade' : 'Clique para Nada Consta no Cadin!') + '</h5>'
	      },
	      nativeOn: {
	        "click": function($event) {
	          dirigente.cadin = (dirigente.cadin === 0 ? null : 0)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-exclamation",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))]), _vm._v(" "), _c('td', [_c('i', {
	      class: ['fa fa-circle ', dirigente.bt_ativo ? 'text-green' : 'text-red'],
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])
	  }), 0)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-md-offset-1 col-md-8"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('SERASA da entidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "serasa_entidade",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.rating.consultas.serasa.entidade),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.serasa, "entidade", $$v)
	      },
	      expression: "rating.consultas.serasa.entidade"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SERASA da entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SERASA da entidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('SERASA de dirigentes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "disabled": true,
	      "name": "serasa_dirigentes",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.rating.consultas.serasa.dirigentes),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.serasa, "dirigentes", $$v)
	      },
	      expression: "rating.consultas.serasa.dirigentes"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SERASA de dirigentes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SERASA de dirigentes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('SERASA de dirigentes coobrigação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "serasa_coobrigacao",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.rating.consultas.serasa.coobrigacao),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.serasa, "coobrigacao", $$v)
	      },
	      expression: "rating.consultas.serasa.coobrigacao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SERASA de dirigentes coobrigação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SERASA de dirigentes coobrigação')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Cepim')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6",
	    attrs: {
	      "for": "Cepim"
	    }
	  }, [_vm._v("Cepim:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.rating.consultas.certidoes.Cepim !== 0) ? _c('div', {
	    staticClass: "data"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.Cepim),
	      expression: "rating.consultas.certidoes.Cepim"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqfuture'),
	      expression: "'required|validdate|dateeqfuture'"
	    }],
	    ref: "Cepim",
	    staticClass: "form-control",
	    attrs: {
	      "id": "Cepim",
	      "type": "text",
	      "name": "Cepim",
	      "data-vv-as": "Cepim",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.certidoes.Cepim)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.certidoes, "Cepim", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Cepim')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cepim')))]) : _vm._e()]) : _c('div', {
	    staticClass: "nada_consta dado"
	  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
	    }],
	    staticClass: "bt_nada_consta",
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>' + (_vm.rating.consultas.certidoes.Cepim === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.rating.consultas.certidoes.Cepim = (_vm.rating.consultas.certidoes.Cepim === 0 ? null : 0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CND')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6",
	    attrs: {
	      "for": "CND"
	    }
	  }, [_vm._v("CND ou CPD-EN:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.rating.consultas.certidoes.CND !== 0) ? _c('div', {
	    staticClass: "data"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.CND),
	      expression: "rating.consultas.certidoes.CND"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqfuture'),
	      expression: "'required|validdate|dateeqfuture'"
	    }],
	    ref: "CND",
	    staticClass: "form-control",
	    attrs: {
	      "id": "CND",
	      "type": "text",
	      "name": "CND",
	      "data-vv-as": "CND",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.certidoes.CND)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.certidoes, "CND", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('CND')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CND')))]) : _vm._e()]) : _c('div', {
	    staticClass: "nada_consta dado"
	  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
	    }],
	    staticClass: "bt_nada_consta",
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>' + (_vm.rating.consultas.certidoes.CND === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.rating.consultas.certidoes.CND = (_vm.rating.consultas.certidoes.CND === 0 ? null : 0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CRF')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6",
	    attrs: {
	      "for": "CRF"
	    }
	  }, [_vm._v("CRF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.rating.consultas.certidoes.CRF !== 0) ? _c('div', {
	    staticClass: "data"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.CRF),
	      expression: "rating.consultas.certidoes.CRF"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqfuture'),
	      expression: "'required|validdate|dateeqfuture'"
	    }],
	    ref: "CRF",
	    staticClass: "form-control",
	    attrs: {
	      "id": "CRF",
	      "type": "text",
	      "name": "CRF",
	      "data-vv-as": "CRF",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.certidoes.CRF)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.certidoes, "CRF", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('CRF')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CRF')))]) : _vm._e()]) : _c('div', {
	    staticClass: "nada_consta dado"
	  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
	    }],
	    staticClass: "bt_nada_consta",
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>' + (_vm.rating.consultas.certidoes.CRF === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.rating.consultas.certidoes.CRF = (_vm.rating.consultas.certidoes.CRF === 0 ? null : 0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNDT')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6",
	    attrs: {
	      "for": "CNDT"
	    }
	  }, [_vm._v("CNDT:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.rating.consultas.certidoes.CNDT !== 0) ? _c('div', {
	    staticClass: "data"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.CNDT),
	      expression: "rating.consultas.certidoes.CNDT"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqfuture'),
	      expression: "'required|validdate|dateeqfuture'"
	    }],
	    ref: "CNDT",
	    staticClass: "form-control",
	    attrs: {
	      "id": "CNDT",
	      "type": "text",
	      "name": "CNDT",
	      "data-vv-as": "CNDT",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.certidoes.CNDT)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.certidoes, "CNDT", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNDT')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNDT')))]) : _vm._e()]) : _c('div', {
	    staticClass: "nada_consta dado"
	  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
	    }],
	    staticClass: "bt_nada_consta",
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>' + (_vm.rating.consultas.certidoes.CNDT === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.rating.consultas.certidoes.CNDT = (_vm.rating.consultas.certidoes.CNDT === 0 ? null : 0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-offset-1 col-md-8"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('SCPC da entidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "scpc_entidade",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.rating.consultas.scpc.entidade),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.scpc, "entidade", $$v)
	      },
	      expression: "rating.consultas.scpc.entidade"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SCPC da entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC da entidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('SCPC de dirigentes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "disabled": true,
	      "name": "scpc_dirigentes",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.rating.consultas.scpc.dirigentes),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.scpc, "dirigentes", $$v)
	      },
	      expression: "rating.consultas.scpc.dirigentes"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SCPC de dirigentes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC de dirigentes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('SCPC de dirigentes coobrigação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "scpc_coobrigacao",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.rating.consultas.scpc.coobrigacao),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.scpc, "coobrigacao", $$v)
	      },
	      expression: "rating.consultas.scpc.coobrigacao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SCPC de dirigentes coobrigação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC de dirigentes coobrigação')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CADIN da entidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6",
	    attrs: {
	      "for": "cadin_entidade"
	    }
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.rating.consultas.cadin.entidade !== 0) ? _c('div', {
	    staticClass: "data"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.cadin.entidade),
	      expression: "rating.consultas.cadin.entidade"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqfuture'),
	      expression: "'required|validdate|dateeqfuture'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cadin_entidade",
	      "type": "text",
	      "name": "cadin_entidade",
	      "data-vv-as": "cadin_entidade",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.cadin.entidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.cadin, "entidade", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('CADIN da entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CADIN da entidade')))]) : _vm._e()]) : _c('div', {
	    staticClass: "nada_consta dado"
	  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
	    }],
	    staticClass: "bt_nada_consta",
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>' + (_vm.rating.consultas.cadin.entidade === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.rating.consultas.cadin.entidade = (_vm.rating.consultas.cadin.entidade === 0 ? null : 0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CADIN de dirigentes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.rating.consultas.cadin.dirigentes !== 0) ? _c('div', {
	    staticClass: "nada_consta dado"
	  }, [_vm._v("CONSTA")]) : _c('div', {
	    staticClass: "nada_consta dado"
	  }, [_vm._v("NADA CONSTA")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CADIN de dirigentes coobrigação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-6",
	    attrs: {
	      "for": "cadin_dirigentes_coobrigacao"
	    }
	  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.rating.consultas.cadin.coobrigacao !== 0) ? _c('div', {
	    staticClass: "data"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.cadin.coobrigacao),
	      expression: "rating.consultas.cadin.coobrigacao"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqfuture'),
	      expression: "'required|validdate|dateeqfuture'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cadin_dirigentes_coobrigacao",
	      "type": "text",
	      "name": "cadin_dirigentes_coobrigacao",
	      "data-vv-as": "cadin_dirigentes_coobrigacao",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.cadin.coobrigacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.cadin, "coobrigacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('CADIN de dirigentes coobrigação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CADIN de dirigentes coobrigação')))]) : _vm._e()]) : _c('div', {
	    staticClass: "nada_consta dado"
	  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
	    }],
	    staticClass: "bt_nada_consta",
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>' + (_vm.rating.consultas.cadin.coobrigacao === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.rating.consultas.cadin.coobrigacao = (_vm.rating.consultas.cadin.coobrigacao === 0 ? null : 0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-offset-1 col-md-8"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Total Geral:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('money', {
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "total_scpc_serasa",
	      "type": "text",
	      "disabled": true
	    },
	    model: {
	      value: (_vm.rating.consultas.totalGeral),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas, "totalGeral", $$v)
	      },
	      expression: "rating.consultas.totalGeral"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-6",
	    attrs: {
	      "for": "pep"
	    }
	  }, [_vm._v("Quantidade de Pessoas Politicamente Expostas (PEP):")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.PEP),
	      expression: "rating.consultas.PEP"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "pep",
	      "type": "text",
	      "name": "pep"
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.PEP)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas, "PEP", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v("\n          As restrições que apresentam SCPC e SERASA para a mesma ocorrência são consideradas somente uma única vez no cálculo\n        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Investimento Social (ISD, últimos 3 anos):")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado",
	    attrs: {
	      "title": '<h5>Refere-se a soma dos valores contratados e suplementados no projeto</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.rating.experiencia.investimentoAte3Anos)) + "\n            ")])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Participantes Diretos (ISD, últimos 3 anos):")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado",
	    attrs: {
	      "title": '<h5>Refere-se a quantidade total de participantes dos projetos contratados</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.rating.experiencia.participantesAte3Anos) + "\n            ")])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Nº Projetos com a FBB:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado",
	    attrs: {
	      "title": '<h5>É a quantidade de projetos contratados dessa entidade</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.rating.experiencia.qtdeProjeto) + "\n            ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "col-md-offset-1 col-md-8"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._m(10), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Ocorr. Peso 2:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo2)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.entidadeOcorrenciaTipo2,
	        _vm.calcularRating
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo2.length))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo3)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.entidadeOcorrenciaTipo3,
	        _vm.calcularRating
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo3.length))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo4)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.entidadeOcorrenciaTipo4,
	        _vm.calcularRating
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo4.length))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._m(11), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Qtd Executando:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.qtde))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Ocorr. Peso 2:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo2)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.projetosExecutandoOcorrenciaTipo2,
	        _vm.calcularRating
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo2.length))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo3)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.projetosExecutandoOcorrenciaTipo3,
	        _vm.calcularRating
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo3.length))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo4)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.projetosExecutandoOcorrenciaTipo4,
	        _vm.calcularRating
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo4.length))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Qtd Peso 3:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.qtdeTipo3))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("% com Peso 3:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.rating.ocorrencias.projetosExecutando.percTipo3)))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._m(12), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Qtd Executado:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.qtde))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosEncerrados.tipo3)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.projetosEncerradosOcorrenciaTipo3,
	        _vm.calcularRating
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.tipo3.length))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosEncerrados.tipo4)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.projetosEncerradosOcorrenciaTipo4,
	        _vm.calcularRating
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.tipo4.length))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("Qtd Peso 3:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.qtdeTipo3))])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-6"
	  }, [_vm._v("% com Peso 3:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.rating.ocorrencias.projetosEncerrados.percTipo3)))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.calcularRating($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Recalcular Rating")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('table', {
	    staticClass: "table table-condensed ratingCalculos"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Representa a situação da entidade e de seus dirigentes com relação a prestação de contas e ao cumprimento de seus compromisssos</h5>'
	    }
	  }, [_vm._v("CD")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Reflete de maneira indireta as condições economico-financeiras da entidade</h5>'
	    }
	  }, [_vm._v("RFP")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Sinaliza a capacidade de articulação da entidade considerando que quanto maior o investimento da FBB maior interesse , disposição e compentência em apresentar propostas</h5>'
	    }
	  }, [_vm._v("IS")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Evidencia o aspecto social da atuação da entidade por meio da quantidade de participantes diretos atendidos</h5>'
	    }
	  }, [_vm._v("PD")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Reflete a experiência da entidade com base em seu tempo de constituição</h5>'
	    }
	  }, [_vm._v("HIS 1")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Experiência em projetos e o modus operandi da Fundação</h5>'
	    }
	  }, [_vm._v("HIS 2")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Reflete as ocorrências vigentes da entidade</h5>'
	    }
	  }, [_vm._v("OC 1")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Ocorrências registradas para projetos em execução</h5>'
	    }
	  }, [_vm._v("OC 2")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Ocorrências registradas para projetos encerrado</h5>'
	    }
	  }, [_vm._v("OC 3")])])]), _vm._v(" "), _c('tr', {
	    staticClass: "dado"
	  }, [_c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.CD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.RFP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.IS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.PD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC3))])]), _vm._v(" "), _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "9"
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.formula) + " = "), _c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.total))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 ratingCalculos"
	  }, [_vm._v("\n          Rating Entidade "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "dado ratingNota"
	  }, [_vm._v(_vm._s(_vm.rating.classificacao.nota))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvar($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" OK")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelar($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Rating da Entidade")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_c('b', [_vm._v("Dados da entidade:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', {
	    staticClass: "requerido"
	  }, [_vm._v("SERASA")]), _vm._v(" "), _c('th', {
	    staticClass: "requerido"
	  }, [_vm._v("SCPC")]), _vm._v(" "), _c('th', {
	    staticClass: "requerido"
	  }, [_vm._v("CADIN")]), _vm._v(" "), _c('th', [_vm._v("Início do Mandato")]), _vm._v(" "), _c('th', [_vm._v("Vigência do Mandato")]), _vm._v(" "), _c('th', [_vm._v("Ativo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_c('b', [_vm._v("Consultas cadastrais e regularidade fiscal e previdenciária:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("SERASA:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("CEPIM e Certidões:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("SCPC:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("CADIN:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_c('b', [_vm._v("Experiência com a FBB:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_c('b', [_vm._v("Ocorrências:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("Entidade:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("Projetos em Execução, ETO, SPS:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("Projetos Encerrados (3 anos):")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', [_c('b', [_vm._v("Rating:")])])
	}]}

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row collapse in",
	    staticStyle: {
	      "width": "inherit",
	      "height": "auto"
	    },
	    attrs: {
	      "aria-expanded": "true",
	      "aria-hidden": "false"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid ng-valid-mask ng-valid-maxlength ng-valid-date",
	    attrs: {
	      "name": "frmSearch",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "userType"
	    }
	  }, [_vm._v("Tipo de usuário:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtros.userType),
	      expression: "filtros.userType"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "userType"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.filtros, "userType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [(this.$root.authorize('usuario-entidade-visualizar')) ? _c('option', {
	    staticClass: "ng-scope",
	    attrs: {
	      "value": ""
	    }
	  }) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-entidade-visualizar')) ? _c('option', {
	    staticClass: "ng-scope",
	    attrs: {
	      "value": "ENTIDADE"
	    }
	  }, [_vm._v("Entidade")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-agencia-visualizar')) ? _c('option', {
	    staticClass: "ng-scope",
	    attrs: {
	      "value": "AGENCIA"
	    }
	  }, [_vm._v("Agência")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-estrategico-visualizar')) ? _c('option', {
	    staticClass: "ng-scope",
	    attrs: {
	      "value": "PARCEIRO_ESTRATEGICO"
	    }
	  }, [_vm._v("Parceiro estratégico")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-superintendencia-visualizar')) ? _c('option', {
	    staticClass: "ng-scope",
	    attrs: {
	      "value": "SUPERINTENDENCIA"
	    }
	  }, [_vm._v("Superintendência")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-fundacao-visualizar')) ? _c('option', {
	    staticClass: "ng-scope",
	    attrs: {
	      "value": "FUNDACAO"
	    }
	  }, [_vm._v("Fundação")]) : _vm._e()])]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-sm-1",
	    attrs: {
	      "for": "login"
	    }
	  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtros.login),
	      expression: "filtros.login"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "login",
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.filtros.login)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSearch($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.filtros, "login", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-sm-1",
	    attrs: {
	      "for": "profiles"
	    }
	  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('profiles', {
	    attrs: {
	      "propsProfile": _vm.filtros.profile
	    },
	    on: {
	      "profileSelected": function($event) {
	        _vm.filtros.profile = $event
	      }
	    },
	    model: {
	      value: (_vm.filtros.profile),
	      callback: function($$v) {
	        _vm.$set(_vm.filtros, "profile", $$v)
	      },
	      expression: "filtros.profile"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtros.name),
	      expression: "filtros.name"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.filtros.name)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSearch($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.filtros, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-sm-1",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtros.email),
	      expression: "filtros.email"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "email",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.filtros.email)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSearch($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.filtros, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-sm-1",
	    attrs: {
	      "for": "createdAt"
	    }
	  }, [_vm._v("Data de inclusão:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtros.createdAt),
	      expression: "filtros.createdAt"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "date"
	    },
	    domProps: {
	      "value": (_vm.filtros.createdAt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.filtros, "createdAt", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "status"
	    }
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 "
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtros.active),
	      expression: "filtros.active"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "status"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.filtros, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "? undefined:undefined ?"
	    }
	  }), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "true"
	    }
	  }, [_vm._v("Ativa")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "false"
	    }
	  }, [_vm._v("Inativa")])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "btn-group dropdown"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Novo Usuário ")]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [(this.$root.authorize('usuario-agencia-novo')) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-entidade-novo')) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-estrategico-novo')) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-superintendencia-novo')) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_vm._m(4)]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onSearch()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pesquisar\n                ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onCleanSearch()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar\n                ")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "items": _vm.items,
	      "hover": _vm.hover,
	      "fields": _vm.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.filter,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Preencha o filtro acima!",
	      "table-layout:": "",
	      "fixed": ""
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "filtered": _vm.onFiltered
	    },
	    scopedSlots: _vm._u([{
	      key: "active",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value == 'true' ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-usuarios-edita',
	                params: row.item
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "warning",
	            "size": "button--size-ss",
	            "disabled": !_vm.authorizeDeleteUser(row.item)
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.inativa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.active === 'true' ? ' Inativar' : ' Ativar'))])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta de Usuários")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "ng-click": "onNew('AGENCIA')",
	      "href": "javascript:void(0)"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Agência")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "ng-click": "onNew('ENTIDADE')",
	      "href": "javascript:void(0)"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Entidade")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "ng-click": "onNew('PARCEIRO_ESTRATEGICO')",
	      "href": "javascript:void(0)"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Parceiro Estratégico")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "ng-click": "onNew('SUPERINTENDENCIA')",
	      "href": "javascript:void(0)"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Superintendência")])
	}]}

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Consulta de Chamados'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Lista',
	        href: '#'
	      }, {
	        text: 'Chamados',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-offset-3 col-sm-5"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-3",
	    staticStyle: {
	      "z-index": "9"
	    }
	  }, [_vm._v("\n                    Status:\n                    "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.listaStatus),
	      expression: "listaStatus"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "abrangencia"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.listaStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Aguardando Atendimento")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Em Atendimento")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Aguardando Avaliação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Chamado Avaliado")])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "z-index": "9"
	    }
	  }, [_vm._v("\n                    Área Responsável:\n                    "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.areaResponsavel),
	      expression: "areaResponsavel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "abrangencia"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.areaResponsavel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.areas), function(area) {
	    return _c('option', {
	      domProps: {
	        "value": area.area_responsavel
	      }
	    }, [_vm._v(_vm._s(area.area_responsavel))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "z-index": "9"
	    }
	  }, [_vm._v("\n                    Carteira:\n                    "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.carteira),
	      expression: "carteira"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "carteira"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.carteira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.carteiras), function(carteira) {
	    return _c('option', {
	      domProps: {
	        "value": carteira
	      }
	    }, [_vm._v(" " + _vm._s(carteira))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "z-index": "9"
	    }
	  }, [_vm._v("\n                    Analista:\n                    "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuarioSelecionado),
	      expression: "usuarioSelecionado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "usuario"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.usuarioSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.usuarios), function(usu) {
	    return _c('option', {
	      domProps: {
	        "value": usu.id
	      }
	    }, [_vm._v(_vm._s(usu.ds_nome_usuario))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "alinhar"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\" }"
	    }],
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'> Limpar todos os filtros </span> </h5>'
	    },
	    on: {
	      "click": _vm.limpaFiltros
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-sm-3",
	    staticStyle: {
	      "position": "relative",
	      "right": "-50px",
	      "top": "-15px"
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "opacity": "0.8"
	    },
	    attrs: {
	      "width": "90%",
	      "height": "80%",
	      "id": "table-delegate"
	    }
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.quantidadeChamadosResult), function(chamado) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "text-align": "center",
	        "width": "13%"
	      }
	    }, [_vm._v(_vm._s(chamado.status))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "text-align": "center",
	        "width": "13%"
	      }
	    }, [_vm._v(_vm._s(chamado.quantidade))])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.meusChamados === false) ? _c('div', {
	    staticClass: "col-sm-6",
	    staticStyle: {
	      "position": "relative",
	      "right": "-50px",
	      "top": "-140px"
	    }
	  }, [_c('div', [_c('br'), _vm._v("\n                    Olá, "), _c('b', [_vm._v(_vm._s(this.usuarioLogado.ds_nome_usuario))]), _vm._v(".\n                    "), _c('br'), _vm._v("\n                    Você tem "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_c('b', [_vm._v(" " + _vm._s(_vm.qtdMeusChamados) + " ")])]), _vm._v(" "), (_vm.qtdMeusChamados === 1) ? _c('span', [_vm._v("chamado ")]) : _c('span', [_vm._v("chamados ")]), _vm._v(" em seu nome.\n                    "), _c('br'), _vm._v(" "), _c('div', [_c('span', {
	    staticStyle: {
	      "color": "#0a568c",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.filtraMeusChamados
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v("   Mostrar Meus Chamados")])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.meusChamados === true) ? _c('div', {
	    staticClass: "col-sm-6",
	    staticStyle: {
	      "position": "relative",
	      "right": "-50px",
	      "top": "-140px"
	    }
	  }, [_c('div', [_c('br'), _vm._v("\n                    Olá, "), _c('b', [_vm._v(_vm._s(this.usuarioLogado.ds_nome_usuario))]), _vm._v(".\n                    "), _c('br'), _vm._v("\n                    Você tem "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_c('b', [_vm._v(" " + _vm._s(_vm.qtdMeusChamados) + " ")])]), _vm._v(" "), (_vm.qtdMeusChamados === 1) ? _c('span', [_vm._v("chamado ")]) : _c('span', [_vm._v("chamados ")]), _vm._v(" em seu nome.\n                    "), _c('br'), _vm._v(" "), _c('div', [_c('span', {
	    staticStyle: {
	      "color": "#0a568c",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.filtraMeusChamados
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v("   Mostrar Meus Chamados")])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-sm-12",
	    staticStyle: {
	      "position": "relative",
	      "top": "-50px"
	    }
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "table",
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.itemsFiltrados,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "data_inclusao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "projeto",
	      fn: function(row) {
	        return [(row.item.processo_id) ? _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: "perspective",
	              distance: "1",
	              size: "large",
	              interactive: true,
	              theme: "dark",
	              placement: "left"
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : \"perspective\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"left\" }"
	          }],
	          attrs: {
	            "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'ID:  ' + '</span>' + row.item.processo_id + '</h5>'
	          }
	        }, [_vm._v("\n                          " + _vm._s(row.value) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!row.item.processo_id) ? _c('div', [_vm._v("\n                          " + _vm._s(row.value) + "\n                        ")]) : _vm._e()]
	      }
	    }, {
	      key: "status.status",
	      fn: function(row) {
	        return [(row.value === 'Aguardando Atendimento') ? _c('span', {
	          staticStyle: {
	            "color": "#f40022"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Em Atendimento') ? _c('span', {
	          staticStyle: {
	            "color": "#67af6a"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Aguardando Avaliação') ? _c('span', {
	          staticStyle: {
	            "color": "#00569f"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Chamado Avaliado') ? _c('span', {
	          staticStyle: {
	            "color": "#000c9f"
	          }
	        }, [_vm._v(_vm._s(row.value)), _c('br'), _c('span', {
	          staticStyle: {
	            "color": "#a0a0a0",
	            "font-size": "small"
	          }
	        }, [_vm._v("(Aguardando Encerramento)")])]) : _vm._e(), _vm._v(" "), (row.value === 'Chamado Encerrado') ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: "perspective",
	              distance: "1",
	              size: "large",
	              interactive: true,
	              theme: "dark",
	              placement: "left"
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : \"perspective\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"left\" }"
	          }],
	          staticStyle: {
	            "color": "#020202"
	          },
	          attrs: {
	            "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Data de Encerramento:  ' + '</span>' + _vm.formata(row.item.data_encerramento) + '</h5>'
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _vm._e()]
	      }
	    }, {
	      key: "descricao",
	      fn: function(row) {
	        return [_c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: "perspective",
	              distance: "1",
	              size: "large",
	              interactive: true,
	              theme: "dark",
	              placement: "left"
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : \"perspective\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"left\" }"
	          }],
	          attrs: {
	            "title": '<h5>' + row.value + '</h5>'
	          }
	        }, [(row.value.length > 50) ? _c('span', [_vm._v(_vm._s(row.value.substring(0, 50) + "..."))]) : _c('span', [_vm._v(_vm._s(row.value))])])]
	      }
	    }, {
	      key: "data_encerramento",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "dt_atualizado",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "to": {
	              name: 'cadastro-chamado-edita',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Entrar")])], 1)]
	      }
	    }], null, false, 1041045201)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.itemsFiltrados.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE') ? _c('div', {
	    staticClass: "col-sm-12",
	    staticStyle: {
	      "position": "relative",
	      "top": "30px"
	    }
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "table",
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.itemsFiltrados,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "data_inclusao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "projeto",
	      fn: function(row) {
	        return [(row.item.processo_id) ? _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: "scale",
	              distance: "1",
	              size: "large",
	              interactive: true,
	              theme: "dark",
	              placement: "right"
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\" }"
	          }],
	          attrs: {
	            "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'ID:  ' + '</span>' + row.item.processo_id + '</h5>'
	          }
	        }, [_vm._v("\n                          " + _vm._s(row.value) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!row.item.processo_id) ? _c('div', [_vm._v("\n                          " + _vm._s(row.value) + "\n                        ")]) : _vm._e()]
	      }
	    }, {
	      key: "carteira",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "status.status",
	      fn: function(row) {
	        return [(row.value === 'Aguardando Atendimento') ? _c('span', {
	          staticStyle: {
	            "color": "#f40022"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Em Atendimento') ? _c('span', {
	          staticStyle: {
	            "color": "#67af6a"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Aguardando Avaliação') ? _c('span', {
	          staticStyle: {
	            "color": "#00569f"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Chamado Avaliado') ? _c('span', {
	          staticStyle: {
	            "color": "#000c9f"
	          }
	        }, [_vm._v(_vm._s(row.value)), _c('br'), _c('span', {
	          staticStyle: {
	            "color": "#a0a0a0",
	            "font-size": "small"
	          }
	        }, [_vm._v("(Aguardando Encerramento)")])]) : _vm._e(), _vm._v(" "), (row.value === 'Chamado Encerrado') ? _c('span', {
	          staticStyle: {
	            "color": "#020202"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _vm._e()]
	      }
	    }, {
	      key: "descricao",
	      fn: function(row) {
	        return [_c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: "scale",
	              distance: "1",
	              size: "large",
	              interactive: true,
	              theme: "dark",
	              placement: "right"
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\" }"
	          }],
	          attrs: {
	            "title": '<h5>' + row.value + '</h5>'
	          }
	        }, [(row.value.length > 50) ? _c('span', [_vm._v(_vm._s(row.value.substring(0, 50) + "..."))]) : _c('span', [_vm._v(_vm._s(row.value))])])]
	      }
	    }, {
	      key: "data_encerramento",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "dt_atualizado",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "to": {
	              name: 'cadastro-chamado-edita',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Entrar")])], 1)]
	      }
	    }], null, false, 1752874914)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.itemsFiltrados.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1) : _vm._e()])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta de Chamados")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('caption', {
	    staticStyle: {
	      "text-align": "center",
	      "color": "#0f7b9f"
	    }
	  }, [_c('b', [_vm._v("Total de Chamados por Status")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "13%"
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "13%"
	    }
	  }, [_vm._v("Quantidade de Chamados")])])])
	}]}

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('número da nota')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "número da nota"
	    }
	  }, [_vm._v("Número nota fiscal:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 "
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "número da nota",
	      "type": "text",
	      "mask": ['#########'],
	      "min": "1"
	    },
	    model: {
	      value: (_vm.nota.numero),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "numero", $$v)
	      },
	      expression: "nota.numero"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('data de emissão')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "data de emissão"
	    }
	  }, [_vm._v("Data de emissão do documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data de emissao",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.nota.emissao),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "emissao", $$v)
	      },
	      expression: "nota.emissao"
	    }
	  })], 1)]), _vm._v(" "), (_vm.errors.first('data de emissão')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data de emissão')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('série')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "série"
	    }
	  }, [_vm._v("Série:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.serie),
	      expression: "nota.serie"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "série"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "serie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "NOTA_FISCAL"
	    }
	  }, [_vm._v("1 - Nota fiscal")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RECIBO_PAGAMENTO_AUTONOMO"
	    }
	  }, [_vm._v("10 - Recibo de pagamento a autônomo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DOCUMENTO_NAO_FISCAL"
	    }
	  }, [_vm._v("DNF - Documento não fiscal")])])]), _vm._v(" "), (_vm.errors.first('série')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('série')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "data de validade"
	    }
	  }, [_vm._v("Data de validade do documento: (Somente informe se possuir a data)")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    attrs: {
	      "name": "data de validade",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "clear-button": true,
	      "clear-button-icon": "fa fa-times-circle-o",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.nota.validade),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "validade", $$v)
	      },
	      expression: "nota.validade"
	    }
	  })], 1)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documento fiscal")])])
	}]}

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    style: ('min-height: ' + _vm.alturaContentWrapper + 'px')
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Edição de Instituição Parceira'
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm._.isNull(_vm.id) ? 'Novo Parceiro' : (_vm.ehVisualizacao ? 'Visualiza' : 'Edição de') + ' Parceiro Estratégico '))]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('span', [(_vm._.isNull(_vm.id)) ? _c('span', [(_vm.salvaParceiro.statusSalvamento !== 'PROCESSANDO') ? _c('g-button-moema', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    attrs: {
	      "color": "primary",
	      "type": "button",
	      "title": '<h5>Ao clicar ele criará este parceiro no sistema para uso. Então antes de fazê-lo verifique se não existe este parceiro ou semelhante já criado</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cria novo parceiro")]) : _vm._e(), _vm._v(" "), (_vm.salvaParceiro.statusSalvamento === 'PROCESSANDO') ? _c('span', {
	    staticClass: "button--moema warning",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 50px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-borda-dark) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Criando Parceiro ...")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.id)) ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm.editando)),
	      expression: "_.isEmpty(editando)"
	    }]
	  }, [(_vm.salvaParceiro.statusSalvamento === 'PROCESSANDO') ? _c('span', {
	    staticClass: "button--moema warning",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 50px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-borda-dark) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Salvando")]) : (_vm.salvaParceiro.statusSalvamento === 'FEITO') ? _c('span', {
	    staticClass: "button--moema success",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 10px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-verde) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" Cadastro salvo")]) : _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar alterações")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'lista-articulacoes'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1)])]), _vm._v(" "), _c('section', {
	    staticClass: "content",
	    attrs: {
	      "id": "parceiro"
	    }
	  }, [_c('div', {
	    staticClass: "row nao_imprimir"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('acao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome do parceiro")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.nome),
	      expression: "parceiro.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "nome_parceiro",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome_parceiro",
	      "disabled": _vm.ehVisualizacao || !_vm._.isEmpty(_vm.editando),
	      "title": '<h5>Nome do parceiro, preferencialmente completo tal como no CNPJ</h5>'
	    },
	    domProps: {
	      "value": (_vm.parceiro.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome_parceiro')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O nome da instituição parceira é obrigatório")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm.editando)),
	      expression: "_.isEmpty(editando)"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {
	    class: {
	      'has-error': _vm.errors.first('parceiro_cnpj')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cnpj'),
	      expression: "'cnpj'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    class: {
	      'has-error': _vm.errors.first('parceiro_cnpj')
	    },
	    attrs: {
	      "name": "parceiro_cnpj",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens,
	      "disabled": _vm.ehVisualizacao,
	      "type": "text",
	      "title": '<h5>CNPJ da intituição estratégica para parcerias</h5>'
	    },
	    model: {
	      value: (_vm.parceiro.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro, "cnpj", $$v)
	      },
	      expression: "parceiro.cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('parceiro_cnpj')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('parceiro_cnpj')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('sede')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-1"
	  }, [_vm._v("Sede")]), _vm._v(" "), (_vm.loading.abrangencia) ? _c('div', {
	    staticClass: "col-lg-3"
	  }, [_vm._m(0)]) : _c('div', {
	    staticClass: "col-lg-3"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaAbrangencias[3].lista,
	      "disabled": _vm.ehVisualizacao,
	      "multiple": false,
	      "placeholder": "Selecione a sede",
	      "label": "descricao",
	      "track-by": "codigo",
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "sede"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('div', {
	          domProps: {
	            "innerHTML": _vm._s(props.option.descricao)
	          }
	        })]
	      }
	    }]),
	    model: {
	      value: (_vm.parceiro.sede),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro, "sede", $$v)
	      },
	      expression: "parceiro.sede"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('sede')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve ser informada a sede da organização")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "indicadores-cb-inline"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3"
	  }, [_vm._v("Cliente Dicor?\n                    "), (!_vm.ehVisualizacao) ? _c('div', [_c('i', {
	    class: !_vm.parceiro.dicor ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado',
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.parceiro.dicor = !_vm.parceiro.dicor
	      }
	    }
	  })]) : _c('div', {
	    staticClass: "text-muted selecionado"
	  }, [_vm._v("\n                      " + _vm._s(_vm.parceiro.dicor ? 'Sim' : 'Não') + "\n                    ")])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm.editando)),
	      expression: "_.isEmpty(editando)"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('abrangencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Abrangência")]), _vm._v(" "), (_vm.loading.abrangencia) ? _c('div', {
	    staticClass: "col-lg-10"
	  }, [_vm._m(1)]) : _c('div', {
	    staticClass: "col-lg-10"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaAbrangencias,
	      "disabled": _vm.ehVisualizacao,
	      "multiple": true,
	      "placeholder": "Selecione a abrangência",
	      "label": "descricao",
	      "group-values": "lista",
	      "group-label": "grupo",
	      "track-by": "codigo",
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "abrangencia"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [(_vm._.has(props.option, '$groupLabel')) ? _c('div', {
	          staticClass: "text-bold",
	          domProps: {
	            "innerHTML": _vm._s(props.option.$groupLabel)
	          }
	        }) : _c('div', {
	          staticStyle: {
	            "margin-left": "1em"
	          },
	          domProps: {
	            "innerHTML": _vm._s(props.option.descricao)
	          }
	        })]
	      }
	    }]),
	    model: {
	      value: (_vm.parceiro.abrangencias),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro, "abrangencias", $$v)
	      },
	      expression: "parceiro.abrangencias"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('abrangencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" A abrangência da parceria é obrigatória")]) : _vm._e()], 1)])]), _vm._v(" "), (false) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm.editando)),
	      expression: "_.isEmpty(editando)"
	    }],
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valores")]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-10"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', {}, [_c('tr', {}, [_c('td', [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "valorFBB",
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.parceiro.orcamento.fbb),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro.orcamento, "fbb", $$v)
	      },
	      expression: "parceiro.orcamento.fbb"
	    }
	  })], 1), _vm._v(" "), _c('td', [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "valorFBB",
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.parceiro.orcamento.parceiro),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro.orcamento, "parceiro", $$v)
	      },
	      expression: "parceiro.orcamento.parceiro"
	    }
	  })], 1), _vm._v(" "), _c('td', {
	    staticClass: "text-bold text-center"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.parceiro.orcamento.fbb) + _vm._.toNumber(_vm.parceiro.orcamento.parceiro))) + "\n                      ")])])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.id)) ? _c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm.editando) || _vm._.has(_vm.editando, 'contato')),
	      expression: "_.isEmpty(editando) || _.has(editando, 'contato')"
	    }],
	    staticClass: "box-body"
	  }, [_vm._m(3), _vm._v(" "), (_vm._.isEmpty(_vm.editando) || (!_vm._.isEmpty(_vm.editando) && !_vm._.has(_vm.editando, 'contato'))) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Contato")]), _vm._v(" "), _c('th', [_vm._v("Cargo")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "140px",
	      "text-align": "center"
	    }
	  }, [_vm._v("Telefone(s)")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', {
	    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.edita(_vm.editando, 'contato', _vm._.cloneDeep(_vm.contato), -1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.parceiro.contatos.length === 0) ? _c('tbody', {}, [_vm._m(4)]) : _c('tbody', {}, _vm._l((_vm.parceiro.contatos), function(contato, idxContato) {
	    return _c('tr', {}, [_c('td', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(contato.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contato.cargo))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v("\n                            " + _vm._s(_vm._f("telefone")(contato.telefone)) + "\n                            "), (!_vm._.isNull(contato.telefone)) ? _c('span', [_c('br'), _vm._v(_vm._s(_vm._f("telefone")(contato.telefone2)))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contato.email))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center",
	        "max-width": "200px"
	      }
	    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'contato', contato, idxContato)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplica(_vm.parceiro.contatos, idxContato)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.remove(_vm.parceiro.contatos, idxContato)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "success",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'contato', contato, idxContato)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-search",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Visualizar")])], 1)])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'contato')) ? _c('div', {
	    staticClass: "col-md-12 well"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('nome_contato')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.contato.nome),
	      expression: "editando.contato.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "nome_contato",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome_contato",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Nome do contato na instituição parceira</h5>'
	    },
	    domProps: {
	      "value": (_vm.editando.contato.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editando.contato, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome_contato')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O nome do contato é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Cargo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.contato.cargo),
	      expression: "editando.contato.cargo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "cargo_contato",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "cargo_contato",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Cargo dele na instituição ou o equivalente ao cargo. Em geral (Presidente, Diretor, Coordenador de projeto, Contato, etc) </h5>'
	    },
	    domProps: {
	      "value": (_vm.editando.contato.cargo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editando.contato, "cargo", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.contato.email),
	      expression: "editando.contato.email"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('email|min:1|max:255'),
	      expression: "'email|min:1|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "type": "text",
	      "title": '<h5>Diite um e-mail pessoal ou corporativo para o contato, se tiver</h5>',
	      "name": "email_contato"
	    },
	    domProps: {
	      "value": (_vm.editando.contato.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editando.contato, "email", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "type": "text",
	      "placeholder": "(00) 00000-0000",
	      "title": '<h5>Informe um telefone ou celular para entrar em contato com esta pessoa</h5>',
	      "disabled": _vm.ehVisualizacao,
	      "name": "telefone_contato"
	    },
	    model: {
	      value: (_vm.editando.contato.telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.contato, "telefone", $$v)
	      },
	      expression: "editando.contato.telefone"
	    }
	  })], 1)]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("2º Telefone")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "type": "text",
	      "placeholder": "(00) 00000-0000",
	      "title": '<h5>Informe um outro telefone ou celular para contato caso haja</h5>',
	      "disabled": _vm.ehVisualizacao,
	      "name": "telefone_contato_2"
	    },
	    model: {
	      value: (_vm.editando.contato.telefone2),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.contato, "telefone2", $$v)
	      },
	      expression: "editando.contato.telefone2"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('nome_contato') || _vm.errors.first('telefone_contato')))) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.ok(_vm.editando, 'contato', _vm.parceiro.contatos)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "~click": function($event) {
	        return _vm.cancela(_vm.editando, 'contato')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm.editando) || _vm._.has(_vm.editando, 'historico')),
	      expression: "_.isEmpty(editando) || _.has(editando, 'historico')"
	    }],
	    staticClass: "box-body"
	  }, [_vm._m(5), _vm._v(" "), (_vm._.isEmpty(_vm.editando) || (!_vm._.isEmpty(_vm.editando) && !_vm._.has(_vm.editando, 'historico'))) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Informação")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Usuário")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "120px"
	    }
	  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
	    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.edita(_vm.editando, 'historico', _vm._.cloneDeep(_vm.historico), -1);
	        _vm.editando.historico.data = new Date()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.parceiro.historicos.length === 0) ? _c('tbody', {}, [_vm._m(6)]) : _c('tbody', {}, _vm._l((_vm.parceiro.historicos), function(historico, idxHistorico) {
	    return _c('tr', {}, [_c('td', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(_vm._.get(_vm._.find(_vm.listaTipos, ['codigo', historico.tipo]), 'descricao')))]), _vm._v(" "), _c('td', [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(historico.conteudo)
	      }
	    })]), _vm._v(" "), _c('td', [(_vm._.has(historico, 'usuario.ds_nome_usuario')) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	      }],
	      staticClass: "truncar",
	      staticStyle: {
	        "width": "100px"
	      },
	      attrs: {
	        "title": '<h5>' + historico.usuario.ds_nome_usuario + ' (id: ' + historico.usuario.id + ')</h5>'
	      }
	    }, [_vm._v("\n                              " + _vm._s(historico.usuario.ds_nome_usuario) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v("\n                            " + _vm._s(_vm._f("moment")(historico.data, "L")) + "\n                            "), (!_vm._.isNull(historico.prazo)) ? _c('span', [_c('p', {
	      staticClass: "label label-warning"
	    }, [_vm._v(_vm._s(_vm._f("moment")(historico.prazo, "L")))])]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center",
	        "max-width": "200px"
	      }
	    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'historico', historico, idxHistorico)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplica(_vm.parceiro.historicos, idxHistorico)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.remove(_vm.parceiro.historicos, idxHistorico)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "success",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'historico', historico, idxHistorico)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-fa-search",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Visualizar")])], 1)])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'historico')) ? _c('div', {
	    staticClass: "col-md-12 well"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo_historico')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.historico.tipo),
	      expression: "editando.historico.tipo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "tipo_historico",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "tipo_historico",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>O tipo do histórico permite definir ações de cobrança, lembrete, auditagem etc</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.editando.historico, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.listaTipos), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.codigo
	      }
	    }, [_vm._v(_vm._s(tipo.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('tipo_historico')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O tipo do histórico é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-1"
	  }, [_vm._v("Data")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (''),
	      expression: "''"
	    }],
	    attrs: {
	      "name": "data_historico",
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehVisualizacao,
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    model: {
	      value: (_vm.editando.historico.data),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.historico, "data", $$v)
	      },
	      expression: "editando.historico.data"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-1"
	  }, [_vm._v("Prazo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (''),
	      expression: "''"
	    }],
	    attrs: {
	      "name": "prazo_historico",
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehVisualizacao,
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "disabled-dates": {
	        to: new Date(_vm.editando.historico.data)
	      },
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    model: {
	      value: (_vm.editando.historico.prazo),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.historico, "prazo", $$v)
	      },
	      expression: "editando.historico.prazo"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('conteudo_historico')
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('quill-editor', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "conteudo_historico",
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "options": _vm.quillOptionsCompleto,
	      "title": '<h5>Descreva o que foi feito ou que será feito, seja um contato, reunião, assinatura de instrumento etc</h5>',
	      "name": "conteudo_historico"
	    },
	    model: {
	      value: (_vm.editando.historico.conteudo),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.historico, "conteudo", $$v)
	      },
	      expression: "editando.historico.conteudo"
	    }
	  }), _vm._v(" "), (_vm.errors.first('tipo_historico')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Registre algum conteúdo para histórico")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('conteudo_historico') || _vm.errors.first('tipo_historico')))) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dadosUsuarioHistorico(_vm.editando.historico);
	        _vm.ok(_vm.editando, 'historico', _vm.parceiro.historicos)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "~click": function($event) {
	        return _vm.cancela(_vm.editando, 'historico')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm.editando)),
	      expression: "_.isEmpty(editando)"
	    }],
	    staticClass: "box-body"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(8), _vm._v(" "), (_vm.loading.dependenciasBB) ? _c('tbody', [_vm._m(9)]) : _c('tbody', [_c('tr', [_c('td', [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaDependenciasBB,
	      "disabled": _vm.ehVisualizacao,
	      "multiple": false,
	      "placeholder": "Selecione a dependência",
	      "label": "nome",
	      "track-by": "prefixo",
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "dependenciaBB"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_vm._v(_vm._s(props.option.prefixo) + " - " + _vm._s(props.option.nome))]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('strong', [_vm._v(_vm._s(props.option.prefixo))]), _vm._v(" " + _vm._s(props.option.nome))]
	      }
	    }], null, false, 3779099504),
	    model: {
	      value: (_vm.parceiro.bb),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro, "bb", $$v)
	      },
	      expression: "parceiro.bb"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.bb.contato),
	      expression: "parceiro.bb.contato"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "bbContato",
	    staticClass: "form-control",
	    attrs: {
	      "name": "bbContato",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Nome do gerente ou do contato na dependência</h5>'
	    },
	    domProps: {
	      "value": (_vm.parceiro.bb.contato)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.bb, "contato", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.bb.telefone),
	      expression: "parceiro.bb.telefone"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "bbTelefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "bbTelefone",
	      "disabled": _vm.ehVisualizacao,
	      "type": "tel",
	      "title": '<h5>Telefone do contato ou número principal da dependência</h5>'
	    },
	    domProps: {
	      "value": (_vm.parceiro.bb.telefone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.bb, "telefone", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.bb.email),
	      expression: "parceiro.bb.email"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "bbContato",
	    staticClass: "form-control",
	    attrs: {
	      "name": "bbContato",
	      "disabled": _vm.ehVisualizacao,
	      "type": "email",
	      "title": '<h5>E-mail do contato na dependência</h5>'
	    },
	    domProps: {
	      "value": (_vm.parceiro.bb.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.bb, "email", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm.editando) || _vm._.has(_vm.editando, 'parceria')),
	      expression: "_.isEmpty(editando) || _.has(editando, 'parceria')"
	    }],
	    staticClass: "box-body"
	  }, [_vm._m(10), _vm._v(" "), (_vm._.isEmpty(_vm.editando) || (!_vm._.isEmpty(_vm.editando) && !_vm._.has(_vm.editando, 'parceria'))) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "300px"
	    }
	  }, [_vm._v("Valores")]), _vm._v(" "), _c('th', {
	    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.edita(_vm.editando, 'parceria', _vm._.cloneDeep(_vm.parceria), -1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.parceiro.parcerias.length === 0) ? _c('tbody', [_vm._m(11)]) : _c('tbody', _vm._l((_vm.parceiro.parcerias), function(parceria, idxParceria) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(parceria.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._.get(_vm._.find(_vm.situacoesParceria, ['codigo', parceria.situacao]), 'descricao')))]), _vm._v(" "), _c('td', [_c('table', {
	      staticStyle: {
	        "width": "100%"
	      }
	    }, [_c('tr', [_c('td', [_vm._v("Parceria")]), _c('td', [_vm._v(_vm._s(_vm._f("real")(parceria.orcamento.fbb)))]), _c('td', [_vm._v(_vm._s(_vm._f("real")(parceria.orcamento.parceiro)))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(parceria.projetos.length + ' projeto' + (parceria.projetos.length > 1 ? 's' : '')))]), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(parceria.projetos, 'orcamento.fbb'))))]), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(parceria.projetos, 'orcamento.parceiro'))))])])])]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center",
	        "max-width": "225px"
	      }
	    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'parceria', parceria, idxParceria)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplica(_vm.parceiro.parcerias, idxParceria)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.remove(_vm.parceiro.parcerias, idxParceria)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "success",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'parceria', parceria, idxParceria)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-search",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Visualizar")])], 1)])])
	  }), 0)])])]) : _vm._e()]), _vm._v(" "), (_vm._.has(_vm.editando, 'parceria')) ? _c('div', {
	    staticClass: "col-md-12 well"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('nome_parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome da parceria")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.parceria.nome),
	      expression: "editando.parceria.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "nome_parceria",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome_parceria",
	      "disabled": _vm.ehVisualizacao || (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length > 1),
	      "title": '<h5>Nome da parceria, preferencialmente o nome que constará em instrumentos futuros</h5>'
	    },
	    domProps: {
	      "value": (_vm.editando.parceria.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editando.parceria, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome_parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O nome da parceria é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Situação")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.parceria.situacao),
	      expression: "editando.parceria.situacao"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "parceria_situacao",
	      "disabled": _vm.ehVisualizacao || (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length > 1),
	      "title": '<h5>Situação em que se encontra a parceria atualmente</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.editando.parceria, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.situacoesParceria), function(situacao) {
	    return _c('option', {
	      domProps: {
	        "value": situacao.codigo
	      }
	    }, [_vm._v(_vm._s(situacao.descricao))])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length === 1),
	      expression: "_.has(editando, 'parceria') && _.keys(editando).length === 1"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Abrangência")]), _vm._v(" "), (_vm.loading.abrangencia) ? _c('div', {
	    staticClass: "col-lg-10"
	  }, [_vm._m(12)]) : _c('div', {
	    staticClass: "col-lg-10"
	  }, [_c('multiselect', {
	    ref: 'ABRANGENCIA-PARCERIA-' + _vm.numeroAtualizacao,
	    attrs: {
	      "options": _vm.listaAbrangencias,
	      "disabled": _vm.ehVisualizacao,
	      "multiple": true,
	      "placeholder": "Selecione a abrangência",
	      "label": "descricao",
	      "group-values": "lista",
	      "group-label": "grupo",
	      "track-by": "codigo",
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "abrangencia_parceria"
	    },
	    on: {
	      "select": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [(_vm._.has(props.option, '$groupLabel')) ? _c('div', {
	          staticClass: "text-bold",
	          domProps: {
	            "innerHTML": _vm._s(props.option.$groupLabel)
	          }
	        }) : _c('div', {
	          staticStyle: {
	            "margin-left": "1em"
	          },
	          domProps: {
	            "innerHTML": _vm._s(props.option.descricao)
	          }
	        })]
	      }
	    }], null, false, 3485813107),
	    model: {
	      value: (_vm.editando.parceria.abrangencias),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceria, "abrangencias", $$v)
	      },
	      expression: "editando.parceria.abrangencias"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length === 1),
	      expression: "_.has(editando, 'parceria') && _.keys(editando).length === 1"
	    }],
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valores")]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-10"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(13), _vm._v(" "), _c('tbody', {}, [_c('tr', {}, [_c('td', {
	    staticStyle: {
	      "width": "30%"
	    }
	  }, [_c('money', {
	    staticClass: "form-control text-center",
	    attrs: {
	      "name": "valorFBB",
	      "disabled": _vm.ehVisualizacao
	    },
	    nativeOn: {
	      "blur": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    model: {
	      value: (_vm.editando.parceria.orcamento.fbb),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceria.orcamento, "fbb", $$v)
	      },
	      expression: "editando.parceria.orcamento.fbb"
	    }
	  })], 1), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "30%"
	    }
	  }, [_c('money', {
	    staticClass: "form-control text-center",
	    attrs: {
	      "name": "valorFBB",
	      "disabled": _vm.ehVisualizacao
	    },
	    nativeOn: {
	      "blur": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    model: {
	      value: (_vm.editando.parceria.orcamento.parceiro),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceria.orcamento, "parceiro", $$v)
	      },
	      expression: "editando.parceria.orcamento.parceiro"
	    }
	  })], 1), _vm._v(" "), _c('td', {
	    ref: 'TOTAL-PARCERIA-' + _vm.numeroAtualizacao,
	    staticClass: "text-bold text-center"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.editando.parceria.orcamento.fbb) + _vm._.toNumber(_vm.editando.parceria.orcamento.parceiro))) + "\n                          ")])])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm._.keys(_vm.editando).length === 1 && _vm._.has(_vm.editando, 'parceria')) || (_vm._.keys(_vm.editando).length > 1 && _vm._.has(_vm.editando, 'parceriaInstrumento'))),
	      expression: "(_.keys(editando).length === 1 && _.has(editando, 'parceria')) || (_.keys(editando).length > 1 && _.has(editando, 'parceriaInstrumento'))"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(14), _vm._v(" "), (!_vm._.has(_vm.editando, 'parceriaInstrumento')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "100px"
	    }
	  }, [_vm._v("Assinatura")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "100px"
	    }
	  }, [_vm._v("Vigência")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "150px"
	    }
	  }, [_vm._v("Valores")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "100px"
	    }
	  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "100px"
	    }
	  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
	    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.edita(_vm.editando, 'parceriaInstrumento', _vm._.cloneDeep(_vm.instrumento), -1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), ((_vm._.get(_vm.editando, 'parceria.instrumentos', [])).length === 0) ? _c('tbody', {}, [_vm._m(15)]) : _c('tbody', {}, _vm._l((_vm._.get(_vm.editando, 'parceria.instrumentos', [])), function(instrumento, idxInstrumento) {
	    return _c('tr', {}, [_c('td', [_vm._v("\n                                " + _vm._s(instrumento.nome.descricao) + "\n                              ")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v("\n                                " + _vm._s(_vm._f("moment")(instrumento.dataAssinatura, "L")) + "\n                              ")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v("\n                                " + _vm._s(_vm._f("moment")(instrumento.dataVigencia, "L")) + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v("\n                                FBB: " + _vm._s(_vm._f("real")(instrumento.orcamento.fbb))), _c('br'), _vm._v("\n                                Parc.: " + _vm._s(_vm._f("real")(instrumento.orcamento.parceiro)) + "\n                              ")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(instrumento.orcamento.fbb + instrumento.orcamento.parceiro)) + "\n                              ")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_c('span', {
	      class: (_vm.situacaoInstrumento(instrumento)).classe
	    }, [_vm._v(_vm._s((_vm.situacaoInstrumento(instrumento)).texto))])]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'parceriaInstrumento', instrumento, idxInstrumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplica(_vm.editando.parceria.instrumentos, idxInstrumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.remove(_vm.editando.parceria.instrumentos, idxInstrumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "success",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'parceriaInstrumento', instrumento, idxInstrumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-search",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Visualizar")])], 1)])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 extratoff"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_vm._m(16), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.editando, 'parceria.instrumentos', []).length))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.instrumentos', []), function(p) {
	    return _vm._.toNumber(_vm._.get(p, 'orcamento.fbb', 0))
	  }))))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.instrumentos', []), function(p) {
	    return _vm._.toNumber(_vm._.get(p, 'orcamento.parceiro', 0))
	  }))))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.instrumentos', []), function(p) {
	    return _vm._.toNumber(_vm._.get(p, 'orcamento.fbb', 0)) + _vm._.toNumber(_vm._.get(p, 'orcamento.parceiro', 0))
	  }))))])])])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'parceriaInstrumento')) ? _c('div', {
	    staticClass: "col-md-12 well"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('nome_instrumento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Instrumento")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: 'INSTRUMENTO-PARCERIA-' + _vm.numeroAtualizacao,
	    attrs: {
	      "options": _vm.listaInstrumentos,
	      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo'),
	      "multiple": false,
	      "placeholder": "Selecione",
	      "label": "descricao",
	      "track-by": "codigo",
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "instrumento_parceria"
	    },
	    on: {
	      "select": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_vm._v("\n                                  " + _vm._s(props.option.descricao) + "\n                                ")]
	      }
	    }], null, false, 4289602459),
	    model: {
	      value: (_vm.editando.parceriaInstrumento.nome),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaInstrumento, "nome", $$v)
	      },
	      expression: "editando.parceriaInstrumento.nome"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('nome_instrumento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O instrumento é obrigatório")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data da Assinatura")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (''),
	      expression: "''"
	    }],
	    attrs: {
	      "name": "instrumento_data_assinatura",
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo'),
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    model: {
	      value: (_vm.editando.parceriaInstrumento.dataAssinatura),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaInstrumento, "dataAssinatura", $$v)
	      },
	      expression: "editando.parceriaInstrumento.dataAssinatura"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data da Vigência")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (''),
	      expression: "''"
	    }],
	    attrs: {
	      "name": "instrumento_data_vigencia",
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo'),
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy",
	      "disabled-dates": {
	        to: new Date(_vm.editando.parceriaInstrumento.dataAssinatura)
	      }
	    },
	    on: {
	      "input": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    model: {
	      value: (_vm.editando.parceriaInstrumento.dataVigencia),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaInstrumento, "dataVigencia", $$v)
	      },
	      expression: "editando.parceriaInstrumento.dataVigencia"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
	    ref: 'SITUACAO-PARCERIA-' + _vm.numeroAtualizacao,
	    staticClass: "control-label col-md-2"
	  }, [_c('span', {
	    class: (_vm.situacaoInstrumento(_vm.editando.parceriaInstrumento)).classe
	  }, [_vm._v(_vm._s((_vm.situacaoInstrumento(_vm.editando.parceriaInstrumento)).texto))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valores")]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-10"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(17), _vm._v(" "), (_vm._.has(_vm.editando, 'parceriaInstrumento.orcamento.fbb')) ? _c('tbody', {}, [_c('tr', {}, [_c('td', [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "valorFBB",
	      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo')
	    },
	    model: {
	      value: (_vm.editando.parceriaInstrumento.orcamento.fbb),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaInstrumento.orcamento, "fbb", $$v)
	      },
	      expression: "editando.parceriaInstrumento.orcamento.fbb"
	    }
	  })], 1), _vm._v(" "), _c('td', [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "valorParceiro",
	      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo')
	    },
	    model: {
	      value: (_vm.editando.parceriaInstrumento.orcamento.parceiro),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaInstrumento.orcamento, "parceiro", $$v)
	      },
	      expression: "editando.parceriaInstrumento.orcamento.parceiro"
	    }
	  })], 1), _vm._v(" "), _c('td', {
	    staticClass: "text-bold text-center"
	  }, [_vm._v("\n                                  " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.editando.parceriaInstrumento.orcamento.fbb) + _vm._.toNumber(_vm.editando.parceriaInstrumento.orcamento.parceiro))) + "\n                                ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-online', {
	    attrs: {
	      "idProcesso": _vm.idCriacao,
	      "propDocumentos": _vm.editando.parceriaInstrumento.anexos,
	      "documentTypes": '',
	      "ehVisualizacao": _vm.ehVisualizacao,
	      "secaoOrigem": 'PARCERIA_INSTRUMENTO',
	      "local-uso": 'TODOS'
	    },
	    on: {
	      "arquivoAnexado": function($event) {
	        return _vm.editando.parceriaInstrumento.anexos.push($event)
	      },
	      "arquivoExcluido": function($event) {
	        return _vm._.remove(_vm.editando.parceriaInstrumento.anexos, ['id', $event.id])
	      },
	      "layoutAtual": function($event) {
	        $event === 'LISTA' ? _vm.cancela(_vm.editando, 'parceriaInstrumentoAnexo') : _vm.edita(_vm.editando, 'parceriaInstrumentoAnexo', _vm._.cloneDeep(_vm.anexo), -1)
	      },
	      "acaoSalvar": _vm.salvarEdicao,
	      "acaoOk": function($event) {
	        _vm.ok(_vm.editando, 'parceriaInstrumento', _vm.editando.parceria.instrumentos, false);
	        _vm.ok(_vm.editando, 'parceria', _vm.parceiro.parcerias, false)
	      },
	      "acaoCancelar": function($event) {
	        return _vm.cancela(_vm.editando, 'parceriaInstrumentoAnexo')
	      },
	      "acaoProcessamento": function($event) {
	        _vm.loading.tela = true
	      },
	      "acaoAguardando": function($event) {
	        _vm.loading.tela = false
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm._.has(_vm.editando, 'parceriaInstrumentoAnexo')),
	      expression: "!_.has(editando, 'parceriaInstrumentoAnexo')"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.ok(_vm.editando, 'parceriaInstrumento', _vm.editando.parceria.instrumentos)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "~click": function($event) {
	        return _vm.cancela(_vm.editando, 'parceriaInstrumento')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm._.keys(_vm.editando).length === 1 && _vm._.has(_vm.editando, 'parceria')) || (_vm._.keys(_vm.editando).length > 1 && _vm._.has(_vm.editando, 'parceriaProjeto'))),
	      expression: "(_.keys(editando).length === 1 && _.has(editando, 'parceria')) || (_.keys(editando).length > 1 && _.has(editando, 'parceriaProjeto'))"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(18), _vm._v(" "), (!_vm._.has(_vm.editando, 'parceriaProjeto')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Projeto")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Valores")]), _vm._v(" "), _c('th', {
	    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.edita(_vm.editando, 'parceriaProjeto', _vm._.cloneDeep(_vm.projeto), -1);
	        _vm.projetoSelecionado = null
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), ((_vm._.get(_vm.editando, 'parceria.projetos', [])).length === 0) ? _c('tbody', {}, [_vm._m(19)]) : _c('tbody', {}, _vm._l((_vm._.get(_vm.editando, 'parceria.projetos', [])), function(projetoSocial, idxProjeto) {
	    return _c('tr', {}, [_c('td', [(!_vm._.isEmpty(projetoSocial.numero)) ? _c('span', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(projetoSocial.numero) + " - ")]) : _vm._e(), _vm._v(_vm._s(projetoSocial.nome) + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(_vm._.get(_vm._.find(_vm.situacoesProjeto, ['codigo', projetoSocial.situacao]), 'descricao')) + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(_vm._f("real")(projetoSocial.orcamento.fbb + projetoSocial.orcamento.parceiro))), _c('br'), _vm._v("\n                                " + _vm._s(_vm._f("real")(projetoSocial.execucao.fbb + projetoSocial.execucao.parceiro)) + "\n                              ")]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center",
	        "max-width": "200px"
	      }
	    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          _vm.edita(_vm.editando, 'parceriaProjeto', projetoSocial, idxProjeto);
	          _vm.projetoSelecionado = _vm._.find(_vm.listaProjetosSociais, ['numero', projetoSocial.numero])
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplica(_vm.editando.parceria.projetos, idxProjeto)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.remove(_vm.editando.parceria.projetos, idxProjeto)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "success",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          _vm.edita(_vm.editando, 'parceriaProjeto', _vm.projeto, idxProjeto);
	          _vm.projetoSelecionado = _vm._.find(_vm.listaProjetosSociais, ['numero', projetoSocial.numero])
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-search",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Visualizar")])], 1)])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 extratoff"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_vm._m(20), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.editando, 'parceria.projetos', []).length))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.projetos', []), function(p) {
	    return _vm._.toNumber(_vm._.get(p, 'orcamento.fbb', 0))
	  }))))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.projetos', []), function(p) {
	    return _vm._.toNumber(_vm._.get(p, 'orcamento.parceiro', 0))
	  }))))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.projetos', []), function(p) {
	    return _vm._.toNumber(_vm._.get(p, 'orcamento.fbb', 0)) + _vm._.toNumber(_vm._.get(p, 'orcamento.parceiro', 0))
	  }))))])])])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'parceriaProjeto')) ? _c('div', {
	    staticClass: "col-md-12 well"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Número")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2",
	    attrs: {
	      "id": "numero_projeto_parceria"
	    }
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaProjetosSociais,
	      "disabled": _vm.ehVisualizacao,
	      "multiple": false,
	      "placeholder": "Selecione",
	      "label": "numero",
	      "track-by": "numero",
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "numero_projeto_parceria"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('div', [_c('span', {
	          staticClass: "text-muted"
	        }, [_vm._v(_vm._s(props.option.situacao))]), _vm._v("  " + _vm._s(props.option.numero) + " - " + _vm._s(props.option.nome))])]
	      }
	    }], null, false, 3607906466),
	    model: {
	      value: (_vm.projetoSelecionado),
	      callback: function($$v) {
	        _vm.projetoSelecionado = $$v
	      },
	      expression: "projetoSelecionado"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('nome_projeto_parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.parceriaProjeto.nome),
	      expression: "editando.parceriaProjeto.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "nome_projeto_parceria",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome_projeto_parceria",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero),
	      "title": '<h5>Nome do projeto. Se já existir, ao informar o número o SGP trará o nome e outras informações. Se não existir o projeto, use este campo para dar um nome qualquer ao projeto até sua criação</h5>'
	    },
	    domProps: {
	      "value": (_vm.editando.parceriaProjeto.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editando.parceriaProjeto, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome_projeto_parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O nome para o projeto é obrigatório seja ele existente ou sugestão para nome quando for criado")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Situação")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.parceriaProjeto.situacao),
	      expression: "editando.parceriaProjeto.situacao"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "situacao_projeto_parceria",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero),
	      "title": '<h5>Situação em que se encontra o parceiro</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.editando.parceriaProjeto, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.situacoesProjeto), function(situacao) {
	    return _c('option', {
	      domProps: {
	        "value": situacao.codigo
	      }
	    }, [_vm._v(_vm._s(situacao.descricao))])
	  }), 0)]), _vm._v(" "), (!_vm._.isEmpty(_vm.projetoSelecionado)) ? _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-control",
	    staticStyle: {
	      "font-weight": "bold",
	      "border": "0",
	      "background": "none"
	    }
	  }, [_vm._v(_vm._s(_vm.projetoSelecionado.situacao))])]) : _vm._e()]), _vm._v(" "), (_vm.loading.investimentoProjeto) ? _c('div', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando dados do projeto " + _vm._s(_vm.editando.parceriaProjeto.numero) + "...")]) : (_vm._.has(_vm.projetoSelecionado, 'cadastro')) ? _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-1"
	  }, [_vm._v("Assinatura")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-control",
	    staticStyle: {
	      "border": "0",
	      "background": "none"
	    }
	  }, [(_vm._.get(_vm.projetoSelecionado, 'cadastro.usu_datcon', '1900').indexOf('1900') === -1) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.projetoSelecionado.cadastro.usu_datcon, "L")))]) : _c('span', [_vm._v("sem data")])])]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-md-1"
	  }, [_vm._v("Término")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-control",
	    staticStyle: {
	      "border": "0",
	      "background": "none"
	    }
	  }, [(_vm._.get(_vm.projetoSelecionado, 'cadastro.datfpj', '1900').indexOf('1900') === -1) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.projetoSelecionado.cadastro.datfpj, "L")))]) : _c('span', [_vm._v("sem data")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', {}, [_c('tr', [_c('th', {
	    staticClass: "col-md-3"
	  }, [(_vm.loading.investimentoProjeto) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando valores do " + _vm._s(_vm.editando.parceriaProjeto.numero) + "...")]) : _vm._e()]), _vm._v(" "), _c('th', {
	    staticClass: "col-md-3"
	  }, [_vm._v("Fundação BB")]), _vm._v(" "), _c('th', {
	    staticClass: "col-md-3"
	  }, [_vm._v("Parceiro")]), _vm._v(" "), _c('th', {
	    staticClass: "col-md-3"
	  }, [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', [_c('tr', {}, [_c('td', {
	    staticClass: "text-bold"
	  }, [_vm._v("Orçado")]), _vm._v(" "), _c('td', [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "orcadoFBB",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero)
	    },
	    model: {
	      value: (_vm.editando.parceriaProjeto.orcamento.fbb),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.orcamento, "fbb", $$v)
	      },
	      expression: "editando.parceriaProjeto.orcamento.fbb"
	    }
	  })], 1), _vm._v(" "), _c('td', [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "orcadoParceiro",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero)
	    },
	    model: {
	      value: (_vm.editando.parceriaProjeto.orcamento.parceiro),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.orcamento, "parceiro", $$v)
	      },
	      expression: "editando.parceriaProjeto.orcamento.parceiro"
	    }
	  })], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("real")((_vm.editando.parceriaProjeto.orcamento.fbb + _vm.editando.parceriaProjeto.orcamento.parceiro))))])])]), _vm._v(" "), _c('tr', {}, [_c('td', {
	    staticClass: "text-bold"
	  }, [_vm._v("Executado")]), _vm._v(" "), _c('td', [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "executadoFBB",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero)
	    },
	    model: {
	      value: (_vm.editando.parceriaProjeto.execucao.fbb),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.execucao, "fbb", $$v)
	      },
	      expression: "editando.parceriaProjeto.execucao.fbb"
	    }
	  })], 1), _vm._v(" "), _c('td', [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "executadoParceiro",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero)
	    },
	    model: {
	      value: (_vm.editando.parceriaProjeto.execucao.parceiro),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.execucao, "parceiro", $$v)
	      },
	      expression: "editando.parceriaProjeto.execucao.parceiro"
	    }
	  })], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("real")((_vm.editando.parceriaProjeto.execucao.fbb + _vm.editando.parceriaProjeto.execucao.parceiro))))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução\n                              "), (_vm.loading.investimentoProjeto) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando dados de municípios ...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "max-height": "600px",
	      "overflow-y": "auto",
	      "overflow-x": "hidden",
	      "margin-bottom": "1rem"
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "per-page": 5,
	      "bordered": true,
	      "current-page": _vm.tabelaMunicipios.currentPage,
	      "items": _vm.editando.parceriaProjeto.municipios,
	      "fields": _vm.tabelaMunicipios.fields,
	      "empty-text": "Nenhum recurso/município cadastrado"
	    },
	    scopedSlots: _vm._u([{
	      key: "fase",
	      fn: function(row) {
	        return [_vm._v("\n                                    " + _vm._s(('' + row.value).substr(0, 1) === '1' ? 'Fundação BB' : ('' + row.value).substr(0, 1) === '5' ? 'Parceiro' : 'Contrapartida') + "\n                                  ")]
	      }
	    }, {
	      key: "cidade",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value) + " / " + _vm._s(row.item.uf))]
	      }
	    }, {
	      key: "valor",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("real")(row.value)))]
	      }
	    }], null, false, 115768954)
	  }), _vm._v(" "), (_vm.editando.parceriaProjeto.municipios.length > 5) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.editando.parceriaProjeto.municipios.length,
	      "per-page": 5
	    },
	    model: {
	      value: (_vm.tabelaMunicipios.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tabelaMunicipios, "currentPage", $$v)
	      },
	      expression: "tabelaMunicipios.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(21), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'ACAO']),
	      "disabled": _vm.ehVisualizacao,
	      "placeholder": "Ação Estratégica",
	      "label": "descricao",
	      "track-by": "codigo",
	      "name": "acao_estrategica_projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return undefined
	      }
	    }], null, false, 4207429160),
	    model: {
	      value: (_vm.editando.parceriaProjeto.enquadramento.acaoEstrategica),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "acaoEstrategica", $$v)
	      },
	      expression: "editando.parceriaProjeto.enquadramento.acaoEstrategica"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'TIPO_ACAO']),
	      "disabled": _vm.ehVisualizacao,
	      "placeholder": "Tipo da Ação",
	      "label": "descricao",
	      "track-by": "codigo",
	      "name": "tipo_acao_projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return undefined
	      }
	    }], null, false, 4207429160),
	    model: {
	      value: (_vm.editando.parceriaProjeto.enquadramento.tipoAcao),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "tipoAcao", $$v)
	      },
	      expression: "editando.parceriaProjeto.enquadramento.tipoAcao"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'PROGRAMA']),
	      "disabled": _vm.ehVisualizacao,
	      "placeholder": "Programa Estruturado",
	      "label": "descricao",
	      "track-by": "codigo",
	      "name": "programa_estruturado_projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return undefined
	      }
	    }], null, false, 4207429160),
	    model: {
	      value: (_vm.editando.parceriaProjeto.enquadramento.programaEstruturado),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "programaEstruturado", $$v)
	      },
	      expression: "editando.parceriaProjeto.enquadramento.programaEstruturado"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'ACAO']),
	      "disabled": _vm.ehVisualizacao,
	      "placeholder": "Projeto Superior",
	      "label": "descricao",
	      "track-by": "codigo",
	      "name": "projeto_superior_projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return undefined
	      }
	    }], null, false, 4207429160),
	    model: {
	      value: (_vm.editando.parceriaProjeto.enquadramento.projetoSuperior),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "projetoSuperior", $$v)
	      },
	      expression: "editando.parceriaProjeto.enquadramento.projetoSuperior"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'CADEIAS_PRODUTIVAS']),
	      "disabled": _vm.ehVisualizacao,
	      "placeholder": "Cadeia Produtiva",
	      "label": "descricao",
	      "track-by": "codigo",
	      "name": "cadeia_produtiva_projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return undefined
	      }
	    }], null, false, 4207429160),
	    model: {
	      value: (_vm.editando.parceriaProjeto.enquadramento.cadeiaProdutiva),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "cadeiaProdutiva", $$v)
	      },
	      expression: "editando.parceriaProjeto.enquadramento.cadeiaProdutiva"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'AREA_ESTRATEGICA']),
	      "disabled": _vm.ehVisualizacao,
	      "placeholder": "Eixo de Atuacao",
	      "label": "descricao",
	      "track-by": "codigo",
	      "name": "eixo_atuacao_projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return undefined
	      }
	    }], null, false, 4207429160),
	    model: {
	      value: (_vm.editando.parceriaProjeto.enquadramento.eixoAtuacao),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "eixoAtuacao", $$v)
	      },
	      expression: "editando.parceriaProjeto.enquadramento.eixoAtuacao"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('conteudo_historico') || _vm.errors.first('tipo_historico')))) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.ok(_vm.editando, 'parceriaProjeto', _vm.editando.parceria.projetos)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "~click": function($event) {
	        return _vm.cancela(_vm.editando, 'parceriaProjeto')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm._.keys(_vm.editando).length === 1 && _vm._.has(_vm.editando, 'parceria')) || (_vm._.keys(_vm.editando).length > 1 && _vm._.has(_vm.editando, 'parceriaHistorico'))),
	      expression: "(_.keys(editando).length === 1 && _.has(editando, 'parceria')) || (_.keys(editando).length > 1 && _.has(editando, 'parceriaHistorico'))"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(22), _vm._v(" "), (!_vm._.has(_vm.editando, 'parceriaHistorico')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Informação")]), _vm._v(" "), _c('th', [_vm._v("Usuário")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "120px"
	    }
	  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
	    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.edita(_vm.editando, 'parceriaHistorico', _vm._.cloneDeep(_vm.historico), -1);
	        _vm.editando.parceriaHistorico.data = new Date()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), ((_vm._.get(_vm.editando, 'parceria.historicos', [])).length === 0) ? _c('tbody', {}, [_vm._m(23)]) : _c('tbody', {}, _vm._l((_vm._.get(_vm.editando, 'parceria.historicos', [])), function(historico, idxHistorico) {
	    return _c('tr', {}, [_c('td', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(_vm._.get(_vm._.find(_vm.listaTipos, ['codigo', historico.tipo]), 'descricao')))]), _vm._v(" "), _c('td', [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(historico.conteudo)
	      }
	    })]), _vm._v(" "), _c('td', [(_vm._.has(historico, 'usuario.ds_nome_usuario')) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	      }],
	      staticClass: "truncar",
	      staticStyle: {
	        "width": "100px"
	      },
	      attrs: {
	        "title": '<h5>' + historico.usuario.ds_nome_usuario + ' (id: ' + historico.usuario.id + ')</h5>'
	      }
	    }, [_vm._v("\n                                  " + _vm._s(historico.usuario.ds_nome_usuario) + "\n                                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v("\n                                " + _vm._s(_vm._f("moment")(historico.data, "L")) + "\n                                "), (!_vm._.isNull(historico.prazo)) ? _c('span', [_c('p', {
	      staticClass: "label label-warning"
	    }, [_vm._v(_vm._s(_vm._f("moment")(historico.prazo, "L")))])]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "center",
	        "max-width": "200px"
	      }
	    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'parceriaHistorico', historico, idxHistorico)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplica(_vm.editando.parceria.historicos, idxHistorico)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.remove(_vm.editando.parceria.historicos, idxHistorico)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "success",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edita(_vm.editando, 'parceriaHistorico', historico, idxHistorico)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-search",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Visualizar")])], 1)])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'parceriaHistorico')) ? _c('div', {
	    staticClass: "col-md-12 well"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo_historico_parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editando.parceriaHistorico.tipo),
	      expression: "editando.parceriaHistorico.tipo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "tipo_historico_parceria",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "tipo_historico_parceria",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>O tipo do histórico permite definir ações de cobrança, lembrete, auditagem etc</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.editando.parceriaHistorico, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.listaTipos), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.codigo
	      }
	    }, [_vm._v(_vm._s(tipo.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('tipo_historico_parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O tipo do histórico dessa parceria é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-1"
	  }, [_vm._v("Data")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (''),
	      expression: "''"
	    }],
	    attrs: {
	      "name": "data_historico_parceria",
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehVisualizacao,
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    model: {
	      value: (_vm.editando.parceriaHistorico.data),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaHistorico, "data", $$v)
	      },
	      expression: "editando.parceriaHistorico.data"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-1"
	  }, [_vm._v("Prazo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (''),
	      expression: "''"
	    }],
	    attrs: {
	      "name": "prazo_historico_parceria",
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehVisualizacao,
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "disabled-dates": {
	        to: new Date(_vm.editando.parceriaHistorico.data)
	      },
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": function($event) {
	        _vm.numeroAtualizacao++
	      }
	    },
	    model: {
	      value: (_vm.editando.parceriaHistorico.prazo),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaHistorico, "prazo", $$v)
	      },
	      expression: "editando.parceriaHistorico.prazo"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('conteudo_historico_parceria')
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('quill-editor', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "conteudo_historico_parceria",
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "options": _vm.quillOptionsCompleto,
	      "title": '<h5>Descreva o que foi feito ou que será feito, seja um contato, reunião, assinatura de instrumento etc</h5>',
	      "name": "conteudo_historico_parceria"
	    },
	    model: {
	      value: (_vm.editando.parceriaHistorico.conteudo),
	      callback: function($$v) {
	        _vm.$set(_vm.editando.parceriaHistorico, "conteudo", $$v)
	      },
	      expression: "editando.parceriaHistorico.conteudo"
	    }
	  }), _vm._v(" "), (_vm.errors.first('conteudo_historico_parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Registre algum conteúdo para histórico da parceria")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('conteudo_historico') || _vm.errors.first('tipo_historico')))) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.ok(_vm.editando, 'parceriaHistorico', _vm.editando.parceria.historicos)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "~click": function($event) {
	        return _vm.cancela(_vm.editando, 'parceriaHistorico')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length === 1),
	      expression: "_.has(editando, 'parceria') && _.keys(editando).length === 1"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('nome_parceria') || _vm.errors.first('parceria_situacao')))) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.ok(_vm.editando, 'parceria', _vm.parceiro.parcerias)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "~click": function($event) {
	        return _vm.cancela(_vm.editando, 'parceria')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e()]) : _c('div', {
	    staticClass: "text-danger"
	  }, [_vm._v("\n                Crie o parceiro para poder cadastrar demais dados\n              ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando municípios...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando abrangência...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', [_vm._v("Fundação BB")]), _vm._v(" "), _c('th', [_vm._v("Parceiro")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Contatos com a Instituição")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Nenhum contato adicionado ainda!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico do parceiro")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Nenhum histórico adicionado ainda!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dependência BB de relacionamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "30%"
	    }
	  }, [_vm._v("Dependência BB")]), _vm._v(" "), _c('th', [_vm._v("Contato")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("E-mail")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando dependências BB...")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Parcerias / Ações")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Nenhuma parceria ainda!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando abrangência...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Fundação BB")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(" Parceiro")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Instrumentos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Nenhum instrumento adicionado ainda!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde Instrumentos")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total Fundação BB")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total Parceiros")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', [_vm._v("Fundação BB")]), _vm._v(" "), _c('th', [_vm._v("Parceiro")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projetos da parceria")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Nenhum projeto foi informado ainda!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde Projetos")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total Fundação BB")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total Parceiros")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Enquadramento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico da parceria")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Nenhum histórico adicionado ainda!")])])
	}]}

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('font', {
	    staticStyle: {
	      "color": "#048019"
	    }
	  }, [_vm._v("Pré-Análise da Proposta")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [(_vm.mostrarRef('agencia_condutora_agencia')) ? _c('agencia-condutora-projeto', {
	    attrs: {
	      "propsProposta": _vm.preAnalise
	    },
	    on: {
	      "agenciaSelecionada": _vm.preAnalise.agencia
	    }
	  }) : _vm._e(), _vm._v(" "), _c('fep', {
	    attrs: {
	      "propsPreAnalise": _vm.preAnalise
	    }
	  }), _vm._v(" "), _c('categorizadores', {
	    attrs: {
	      "propsPreAnalise": _vm.preAnalise
	    }
	  }), _vm._v(" "), (_vm.mostrarRef('restricoes')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 required"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('calculo de rating')
	    },
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cálculo de rating")]), _vm._v(" "), _c('div', _vm._l((_vm.rating), function(r) {
	    return _c('div', {
	      staticClass: "col-sm-2"
	    }, [_c('label', {
	      staticClass: "new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "8px",
	        "margin-left": "15px"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.preAnalise.rating),
	        expression: "preAnalise.rating"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "calculo de rating"
	      },
	      domProps: {
	        "value": r.id,
	        "checked": _vm._q(_vm.preAnalise.rating, r.id)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.$set(_vm.preAnalise, "rating", r.id)
	        }
	      }
	    }), _vm._v("\n                        " + _vm._s(r.description) + "\n                        "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('calculo de rating')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('calculo de rating')))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Documentos da Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.preAnalise.documentos,
	      "documentTypes": '',
	      "documentosObrigatorios": '',
	      "localUso": _vm.listaDocEntidades
	    }
	  })], 1)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Aprovação")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required full",
	    class: {
	      'has-error': _vm.errors.first('resultado pre-analise')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "resultado pre-analise"
	    }
	  }, [_vm._v("Ação sobre a proposta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio\n"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.resultadoAprovacao),
	      expression: "preAnalise.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado pre-analise",
	      "id": "resultado pre-analise",
	      "data-vv-as": "Resultado da Pré-análise",
	      "value": "APROVAR"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.preAnalise.resultadoAprovacao, "APROVAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "resultadoAprovacao", "APROVAR")
	      }
	    }
	  }), _vm._v(" Aprovar\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.resultadoAprovacao),
	      expression: "preAnalise.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado pre-analise",
	      "data-vv-as": "Resultado da Pré-análise",
	      "value": "ENVIAR_REVISAO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.preAnalise.resultadoAprovacao, "ENVIAR_REVISAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "resultadoAprovacao", "ENVIAR_REVISAO")
	      }
	    }
	  }), _vm._v(" Revisão\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.resultadoAprovacao),
	      expression: "preAnalise.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado pre-analise",
	      "data-vv-as": "Resultado da Pré-análise",
	      "value": "REPROVAR"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.preAnalise.resultadoAprovacao, "REPROVAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "resultadoAprovacao", "REPROVAR")
	      }
	    }
	  }), _vm._v(" Reprovado\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), (_vm.errors.first('resultado pre-analise')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultado pre-analise')))]) : _vm._e(), _vm._v(" "), (_vm.preAnalise.resultadoAprovacao && _vm.preAnalise.resultadoAprovacao !== 'APROVAR') ? _c('div', {
	    staticClass: "form-group required full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa"
	    }
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.preAnaliseJustificativa),
	      expression: "preAnalise.preAnaliseJustificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justificativa",
	      "id": "justificativa"
	    },
	    domProps: {
	      "value": (_vm.preAnalise.preAnaliseJustificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preAnalise, "preAnaliseJustificativa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cálculo de Rating")])])
	}]}

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Cadastro de Formulários'
	    }
	  }), _vm._v(" "), _c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Cadastro de Formulários")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Formulários',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaFormularios"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de formulários "), (!_vm.loading.tela) ? _c('span', {
	    staticClass: "info_discreto"
	  }, [_vm._v(_vm._s(_vm.tabelaFormularios.totalRows) + " localizado(s)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'edita-formulario',
	          params: {
	            id: null
	          }
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo formulário ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": _vm.ajustaPesquisa,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.tabelaFormularios.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.tabelaFormularios.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row box-body"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: 'tabelaDetalhe',
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "hover": "",
	      "bordered": _vm.tabelaFormularios.bordered,
	      "items": _vm.formularios,
	      "fields": _vm.camposFormularios,
	      "filter": _vm.tabelaFormularios.filter,
	      "filter-function": _vm.filtroPorItem,
	      "current-page": _vm.tabelaFormularios.currentPage,
	      "per-page": _vm.tabelaFormularios.perPage,
	      "sort-by": _vm.tabelaFormularios.sortBy,
	      "sort-desc": _vm.tabelaFormularios.sortDesc,
	      "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tabelaFormularios, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tabelaFormularios, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tabelaFormularios, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tabelaFormularios, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "id",
	      fn: function(row) {
	        return [_c('span', {
	          staticStyle: {
	            "cursor": "pointer"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.mostrarDetalhes(row)
	            }
	          }
	        }, [_vm._v(_vm._s(row.value))])]
	      }
	    }, {
	      key: "criacao",
	      fn: function(row) {
	        return [_c('span', {
	          staticStyle: {
	            "cursor": "pointer"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.mostrarDetalhes(row)
	            }
	          }
	        }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")((_vm._.has(row.item.cadastro, 'inicio') ? row.item.cadastro.inicio : row.item.created_at), "DD/MM/YYYY  HH:mm")) + "\n                      ")])]
	      }
	    }, {
	      key: "nome",
	      fn: function(row) {
	        return [_c('span', {
	          staticStyle: {
	            "cursor": "pointer"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.mostrarDetalhes(row)
	            }
	          }
	        }, [_vm._v("\n                        " + _vm._s(row.value) + "\n                        "), (row.item.opcoes.vinculo.programas.length > 0) ? _c('span', {
	          staticStyle: {
	            "font-size": "x-small",
	            "color": "var(--cor-atencao)"
	          }
	        }, [_c('br'), _vm._v(_vm._s(_vm._.join(_vm._.map(row.item.opcoes.vinculo.programas, 'descricao'), ' | ')) + "\n                        ")]) : _vm._e()]), _vm._v(" "), (!_vm._.isEmpty(row.item.link_acesso)) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'top',
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              delay: [500, 0]
	            }),
	            expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	          }],
	          staticClass: "link_acesso",
	          attrs: {
	            "title": '<h5>Clique para copiar link para uso externo ao SGP</h5>'
	          },
	          on: {
	            "click": function($event) {
	              return _vm.copiaUrl(row)
	            }
	          }
	        }, [_c('br'), _vm._v(_vm._s(_vm._.split(row.item.link_acesso, '-')[0]) + "\n                        "), _c('i', {
	          staticClass: "fa fa-clone"
	        }), _vm._v(" "), (_vm._.has(row.item, 'link_copia')) ? _c('span', {
	          class: _vm._.get(row.item, 'link_copia.classe')
	        }, [_vm._v(_vm._s(_vm._.get(row.item, 'link_copia.msg')))]) : _vm._e()]) : _vm._e()]
	      }
	    }, {
	      key: "tipo",
	      fn: function(row) {
	        return [_c('span', {
	          staticStyle: {
	            "cursor": "pointer"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.mostrarDetalhes(row)
	            }
	          }
	        }, [_vm._v("\n                        " + _vm._s(_vm._.find(_vm.tipoFormulario, ['codigo', row.value])['descricao']) + "\n                      ")])]
	      }
	    }, {
	      key: "situacao",
	      fn: function(row) {
	        return [(_vm._.includes(['Inativo', 'Ativo'], row.item.situacao)) ? _c('span', [_c('div', {
	          staticClass: "indicadores-cb-inline"
	        }, [(_vm._.has(row.item, 'situacao')) ? _c('div', {
	          staticClass: "juntos"
	        }, [_c('i', {
	          class: (row.item.situacao === 'Ativo' ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.alteraConfiguracaoFormulario(row.item, {
	                situacao: row.item.situacao === 'Ativo' ? 'Inativo' : 'Ativo'
	              })
	            }
	          }
	        }), _vm._v(" "), _c('span', {
	          class: row.item.situacao === 'Ativo' ? 'selecionado' : 'Inativo'
	        }, [_vm._v(_vm._s(row.item.situacao))])]) : _vm._e(), _vm._v(" "), (_vm._.has(row.item, 'opcoes.bi') && _vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], row.item.tipo)) ? _c('div', {
	          staticClass: "juntos"
	        }, [_c('i', {
	          class: (row.item.opcoes.bi ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.alteraConfiguracaoFormulario(row.item, {
	                'opcoes.bi': !row.item.opcoes.bi
	              })
	            }
	          }
	        }), _vm._v(" "), _c('span', {
	          class: row.item.opcoes.bi ? 'selecionado' : 'Inativo'
	        }, [_vm._v("BI")])]) : _vm._e()])]) : _c('span', {
	          staticStyle: {
	            "color": "var(--cor-atencao)"
	          }
	        }, [_vm._v("Erro")])]
	      }
	    }, {
	      key: "uso",
	      fn: function(row) {
	        return [_vm._v("\n                        " + _vm._s(_vm._.has(_vm.detalhamentoFormulario[row.item.id], 'listaProjetosDisponiveis') ?
	          (_vm._.filter(_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []), function(f) {
	            return _vm._.includes(['FEITO', 'EM_EXECUCAO'], f.processo.situacao) && f.andamento !== 'Não iniciado'
	          })).length :
	          row.item.uso) + "\n                    ")]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [((_vm._.has(_vm.detalhamentoFormulario[row.item.id], 'listaProjetosDisponiveis') ?
	          (_vm._.filter(_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []), function(f) {
	            return _vm._.includes(['FEITO', 'EM_EXECUCAO'], f.processo.situacao) && f.andamento !== 'Não iniciado'
	          })).length :
	          row.item.uso) === 0) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-formulario',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Ativo', 'Inativo'], row.item.situacao)) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-formulario',
	                params: {
	                  id: row.item.id,
	                  visualizacao: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-label": "false"
	          }
	        }), _vm._v(" Visualizar")]) : _vm._e()]
	      }
	    }, {
	      key: "row-details",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row detalhamentoFormulario"
	        }, [_c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (_vm.loading.detalhes),
	            expression: "loading.detalhes"
	          }],
	          staticClass: "overlay",
	          staticStyle: {
	            "position": "absolute",
	            "top": "0px",
	            "left": "0px",
	            "width": "100%",
	            "height": "100%",
	            "display": "block"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-refresh fa-spin"
	        })]), _vm._v(" "), (true) ? _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "col-md-12"
	        }, [(!_vm._.has(_vm.detalhamentoFormulario[row.item.id], 'listaProjetosDisponiveis')) ? _c('span', [_c('div', {
	          staticClass: "box-header"
	        }, [_c('i', {
	          staticClass: "fa fa-refresh fa-spin"
	        }), _vm._v(" Projetos que podem receber este formulário ...")])]) : _c('span', [((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosDisponiveis'], [])).length === 0) ? _c('div', {
	          staticClass: "box-header bg-info"
	        }, [_vm._v("\n                                Não há projetos disponíveis para enviar este formulário\n                              ")]) : _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'top',
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              delay: [500, 0]
	            }),
	            expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	          }],
	          staticClass: "col-sm-8",
	          attrs: {
	            "title": '<h5>Se desejar enviar este formulário para um projeto, então selecione o projeto desejado e clique em Enviar</h5>'
	          }
	        }, [_c('multiselect', {
	          attrs: {
	            "options": _vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosDisponiveis'], []),
	            "multiple": false,
	            "close-on-select": true,
	            "placeholder": 'Projetos disponíveis para este formulário',
	            "custom-label": function (option) {
	              return ("" + (option.ds_codigo_projeto_erp + ' - ' + option.ds_nome))
	            },
	            "selectedLabel": "selecionado",
	            "selectLabel": "",
	            "deselectLabel": "",
	            "track-by": "ds_codigo_projeto_erp",
	            "label": "ds_nome",
	            "name": "projetos_disponiveis",
	            "data-vv-as": "projetos_disponiveis"
	          },
	          scopedSlots: _vm._u([{
	            key: "option",
	            fn: function(props) {
	              return [_c('div', [_c('strong', [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v("  " + _vm._s(props.option.ds_nome) + " "), _c('span', {
	                staticClass: "text-gray"
	              }, [_vm._v(" " + _vm._s(props.option.ds_situacao_erp) + " ")])])]
	            }
	          }, {
	            key: "noResult",
	            fn: function(props) {
	              return [_vm._v("\n                                      Não encontrei nesta lista de projetos disponíveis\n                                    ")]
	            }
	          }], null, true),
	          model: {
	            value: (_vm.projetoSelecionadoEnvioManual[row.item.id]),
	            callback: function($$v) {
	              _vm.$set(_vm.projetoSelecionadoEnvioManual, row.item.id, $$v)
	            },
	            expression: "projetoSelecionadoEnvioManual[row.item.id]"
	          }
	        })], 1), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-2"
	        }, [(_vm.projetoSelecionadoEnvioManual[row.item.id]) ? _c('span', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.vincularFormularioAoProjeto(row.item.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-list-alt",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Enviar")])], 1) : _c('span', {
	          staticClass: "info_discreto"
	        }, [_vm._v("\n                                    " + _vm._s((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosDisponiveis'], [])).length) + " projeto(s)\n                                  ")])]), _vm._v(" "), ((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], [])).length > 0) ? _c('div', {
	          staticClass: "col-sm-2"
	        }, [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'top',
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss",
	            "title": '<h5>Ao clicar será gerado um Excel com todos os <span class=\'realce\'>' + ((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], [])).length) + '</span> formulário(s) preenchido(s) deste modelo</h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              _vm.exportarExcel(_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []))
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excel")])], 1) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm._.has(_vm.detalhamentoFormulario[row.item.id], 'listaProjetosVinculadosFormulario')) ? _c('span', [_c('div', {
	          staticClass: "box-header"
	        }, [_c('i', {
	          staticClass: "fa fa-refresh fa-spin"
	        }), _vm._v(" Projetos que tem este formulário ...")])]) : _c('span', [((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], [])).length > 0) ? _c('div', {
	          staticClass: "row"
	        }, [_c('b-container', {
	          attrs: {
	            "fluid": ""
	          }
	        }, [_c('b-table', {
	          ref: 'DETALHAMENTO-' + row.item.id + '(' + _vm.numeroAtualizacao + ')',
	          attrs: {
	            "show-empty": "",
	            "striped": "",
	            "bordered": _vm.tabelaDetalhamento.bordered,
	            "items": _vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []),
	            "fields": _vm.camposDetalhamento,
	            "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
	            "empty-text": "Nenhum registro encontrado",
	            "sort-by": _vm.tabelaDetalhamento.sortBy,
	            "sort-desc": _vm.tabelaDetalhamento.sortDesc,
	            "current-page": _vm.tabelaDetalhamento.currentPage,
	            "per-page": _vm.tabelaDetalhamento.perPage,
	            "filter": _vm.tabelaDetalhamento.filter
	          },
	          on: {
	            "update:sortBy": function($event) {
	              return _vm.$set(_vm.tabelaDetalhamento, "sortBy", $event)
	            },
	            "update:sort-by": function($event) {
	              return _vm.$set(_vm.tabelaDetalhamento, "sortBy", $event)
	            },
	            "update:sortDesc": function($event) {
	              return _vm.$set(_vm.tabelaDetalhamento, "sortDesc", $event)
	            },
	            "update:sort-desc": function($event) {
	              return _vm.$set(_vm.tabelaDetalhamento, "sortDesc", $event)
	            }
	          },
	          scopedSlots: _vm._u([{
	            key: "processo",
	            fn: function(row) {
	              return [_vm._v("\n                                  " + _vm._s(row.item.processo.id) + "\n                                ")]
	            }
	          }, {
	            key: "projeto",
	            fn: function(row) {
	              return [(_vm._.has(row.item, 'projeto')) ? _c('span', [_vm._v("\n                                    " + _vm._s(row.item.projeto['ds_codigo_projeto_erp'] + ' - ' + row.item.projeto['ds_nome']) + " ( " + _vm._s(row.item.projeto.ds_situacao_erp) + " )\n                                    "), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', [_c('span', {
	                directives: [{
	                  name: "tippy",
	                  rawName: "v-tippy",
	                  value: ({
	                    inertia: true,
	                    arrow: true,
	                    placement: 'top',
	                    animation: 'perspective',
	                    distance: '1',
	                    size: 'large',
	                    arrow: true,
	                    delay: [500, 0]
	                  }),
	                  expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	                }],
	                staticClass: "link_acesso",
	                attrs: {
	                  "title": '<h5>Clique para copiar link do formulário para preenchido</h5>'
	                },
	                on: {
	                  "click": function($event) {
	                    return _vm.copiaUrl(row)
	                  }
	                }
	              }, [_vm._v("\n                                      " + _vm._s(row.item['link_externo']) + "\n                                      "), _c('i', {
	                staticClass: "fa fa-clone"
	              }), _vm._v(" "), (_vm._.has(row.item, 'link_copia')) ? _c('span', {
	                class: _vm._.get(row.item, 'link_copia.classe')
	              }, [_vm._v(_vm._s(_vm._.get(row.item, 'link_copia.msg')))]) : _vm._e()])])]
	            }
	          }, {
	            key: "situacao",
	            fn: function(row) {
	              return [(row.item.processo.situacao === 'CANCELADO') ? _c('span', {
	                staticClass: "text-danger"
	              }, [_vm._v("Cancelado")]) : (row.item.processo.situacao === 'FEITO') ? _c('span', {
	                staticClass: "text-success"
	              }, [_vm._v("Concluído")]) : (row.item.processo.situacao === 'EM_EXECUCAO') ? _c('span', {
	                staticClass: "text-blue"
	              }, [_vm._v("Em Execução")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	                class: row.item.andamento === 'Não iniciado' ? 'text-gray' : 'text-bold'
	              }, [_vm._v("\n                                    " + _vm._s(row.item.andamento) + "\n                                  ")])]
	            }
	          }, {
	            key: "actions",
	            fn: function(row) {
	              return [(_vm._.get(row.item, '_rowVariant', '') === 'form-salvando') ? _c('span', [_vm._v("Salvando...")]) : (_vm._.get(row.item, '_rowVariant', '') === 'form-fechando') ? _c('span', [_vm._v("Fechando...")]) : _c('span', [(!_vm._.get(row.item, '_rowVariant')) ? _c('span', [(row.item.processo.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	                attrs: {
	                  "color": "primary",
	                  "type": "button"
	                },
	                nativeOn: {
	                  "click": function($event) {
	                    return _vm.abreFormulario(row.item['link_edicao'])
	                  }
	                }
	              }, [_c('i', {
	                staticClass: "fa fa-pencil",
	                attrs: {
	                  "aria-hidden": "true"
	                }
	              }), _vm._v(" Preencher")]) : _vm._e()], 1) : _c('span', [_vm._v("Em uso agora!")]), _vm._v(" "), _c('g-button-ujarak', {
	                attrs: {
	                  "color": "success",
	                  "type": "button"
	                },
	                nativeOn: {
	                  "click": function($event) {
	                    return _vm.abreFormulario(row.item['link_visualizacao'])
	                  }
	                }
	              }, [_c('i', {
	                staticClass: "fa fa-search",
	                attrs: {
	                  "aria-hidden": "true"
	                }
	              }), _vm._v(" Visualizar")]), _vm._v(" "), (row.item.processo.situacao !== 'CANCELADO') ? _c('g-button-ujarak', {
	                directives: [{
	                  name: "confirm",
	                  rawName: "v-confirm",
	                  value: ({
	                    ok: function (retorno) { return _vm.cancelaProcessoPreenchimento(row); },
	                    cancel: _vm.doNothing,
	                    message: '<span class=\'avisoAlerta\'>Deseja <b>Cancelar</b> este preenchimento?</span>'
	                  }),
	                  expression: "{ok: retorno => cancelaProcessoPreenchimento(row), cancel: doNothing, message: '<span class=\\'avisoAlerta\\'>Deseja <b>Cancelar</b> este preenchimento?</span>'}"
	                }, {
	                  name: "tippy",
	                  rawName: "v-tippy",
	                  value: ({
	                    inertia: true,
	                    arrow: true,
	                    placement: 'top',
	                    animation: 'perspective',
	                    distance: '1',
	                    size: 'large',
	                    arrow: true
	                  }),
	                  expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true}"
	                }],
	                attrs: {
	                  "color": "error",
	                  "type": "button",
	                  "title": '<h5>Utilize essa opção para cancelar a vinculação</h5>'
	                }
	              }, [_c('i', {
	                staticClass: "fa fa-ban",
	                attrs: {
	                  "aria-hidden": "true"
	                }
	              }), _vm._v(" Cancelar")]) : _vm._e()], 1)]
	            }
	          }], null, true)
	        }), _vm._v(" "), _c('b-row', {
	          staticStyle: {
	            "display": "flex",
	            "align-items": "center"
	          }
	        }, [_c('b-col', {
	          staticClass: "my-1",
	          attrs: {
	            "md": "6",
	            "right": ""
	          }
	        }, [_c('b-pagination', {
	          staticClass: "my-3",
	          attrs: {
	            "total-rows": _vm.tabelaDetalhamento.totalRows,
	            "per-page": _vm.tabelaDetalhamento.perPage
	          },
	          model: {
	            value: (_vm.tabelaDetalhamento.currentPage),
	            callback: function($$v) {
	              _vm.$set(_vm.tabelaDetalhamento, "currentPage", $$v)
	            },
	            expression: "tabelaDetalhamento.currentPage"
	          }
	        })], 1), _vm._v(" "), _c('b-col', {
	          attrs: {
	            "md": "6",
	            "right": ""
	          }
	        }, [_c('strong', [_vm._v(_vm._s((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], [])).length))]), _vm._v(" formulário(s) disponibilizado(s) sendo: "), _c('br'), _vm._v(" "), _vm._l((_vm._.groupBy(_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []), 'processo.situacao')), function(forms, situacao) {
	          return _c('span', [(situacao === 'CANCELADO') ? _c('span', {
	            staticClass: "text-danger"
	          }, [_c('strong', [_vm._v(_vm._s(forms.length))]), _vm._v(" cancelado(s)  ")]) : _vm._e(), _vm._v(" "), (situacao === 'FEITO') ? _c('span', {
	            staticClass: "text-success"
	          }, [_c('strong', [_vm._v(_vm._s(forms.length))]), _vm._v(" concluído(s)  ")]) : _vm._e(), _vm._v(" "), (situacao === 'EM_EXECUCAO') ? _c('span', {
	            staticClass: "text-blue"
	          }, [_c('strong', [_vm._v(_vm._s(forms.length))]), _vm._v(" em execução(s)  ")]) : _vm._e()])
	        })], 2)], 1)], 1)], 1) : _c('div', [_vm._v("\n                            Não há prenchimento para este formulário\n                          ")])])])])]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.tabelaFormularios.totalRows,
	      "per-page": _vm.tabelaFormularios.perPage
	    },
	    model: {
	      value: (_vm.tabelaFormularios.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tabelaFormularios, "currentPage", $$v)
	      },
	      expression: "tabelaFormularios.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('fieldset', [_c('table', {
	    staticClass: "table table-condensed table-bordered",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Recurso")]), _vm._v(" "), _c('th', [_vm._v("Fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total pendente")]), _vm._v(" "), _c('th', [_vm._v("Valor a devolver")]), _vm._v(" "), _c('th', [_vm._v("Saldo restante")]), _vm._v(" "), (_vm.propsFase !== 'Análise Financeira') ? _c('th', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itens), function(item) {
	    return _c('tr', {
	      attrs: {
	        "disabled": "true"
	      }
	    }, [_c('td', [_vm._v(_vm._s(_vm.propsAdiantamentosConcedidos[0].recurso))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.parcelas_adiantamentos[0].origem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm.propsAdiantamentosConcedidos[0].pendente_comprovacao)))]), _vm._v(" "), (item.editando === false || !item.editando) ? _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valor ? item.valor : 0)))]) : _vm._e(), _vm._v(" "), (item.editando === true) ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('money', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control text-right",
	      class: {
	        'has-error': _vm.errors.first('valor')
	      },
	      attrs: {
	        "name": "valor",
	        "type": "text",
	        "disabled": item.totalValueRequested > 0 || !_vm.propsEnable
	      },
	      model: {
	        value: (item.valor),
	        callback: function($$v) {
	          _vm.$set(item, "valor", $$v)
	        },
	        expression: "item.valor"
	      }
	    })], 1) : _vm._e(), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm.propsAdiantamentosConcedidos[0].pendente_comprovacao - (item.valor ? item.valor : 0))))]), _vm._v(" "), (_vm.propsFase !== 'Análise Financeira') ? _c('td', {
	      staticClass: "text-center"
	    }, [(!item.editando && _vm.propsEnable) ? _c('i', {
	      staticClass: "fa fa-edit",
	      staticStyle: {
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editando) ? _c('i', {
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green",
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editando) ? _c('i', {
	      staticClass: "fa fa-times",
	      staticStyle: {
	        "color": "red",
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.cancelaEdicao(item)
	        }
	      }
	    }) : _vm._e()]) : _vm._e()])
	  }), 0), _vm._v(" "), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Total valor solicitado:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalSolicitacao)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor disponível para solicitação nesta parcela:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalDisponivel - _vm.valorTotalSolicitacao)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor total liberado para solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalDisponivel)))])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Valor da Devolução")])])
	}]}

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body prest-upload-container"
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex start-between"
	  }, [_vm._m(0), _vm._v(" "), (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        followCursor: true,
	        theme: 'light'
	      }),
	      expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5> Baixar Todos os Anexos Complementares </h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onDownloadZIPComplementar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cloud-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e()], 1), _vm._v(" "), (!_vm.editando) ? _c('b-button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.toggleCadastro(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle"
	  }), _vm._v(" Novo Registro")]) : _vm._e(), _vm._v(" "), (!_vm.editando) ? _c('div', {
	    staticClass: "column all-start prest-complementar-container"
	  }, [_c('b-container', {
	    staticClass: "prest-table",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-centered prest-button-row"
	        }, [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "title": '<h5> Baixar Documento </h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.downloadAnexo(row.item.documento)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]), _vm._v(" "), _c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss",
	            "title": "'<h5> Excluir Documento </h5>'"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.apagarAnexoComplementar(row.item.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1)]
	      }
	    }, {
	      key: "documento.ds_nome_arquivo",
	      fn: function(row) {
	        return [_c('a', {
	          attrs: {
	            "href": "#"
	          },
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.downloadAnexo(row.item.documento)
	            }
	          }
	        }, [_vm._v(_vm._s(row.item.documento.ds_nome_arquivo))])]
	      }
	    }, {
	      key: "documento.dt_criado",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row.item.documento.dt_criado, "L")))])]
	      }
	    }], null, false, 3098741170)
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editando) ? _c('div', {
	    staticClass: "column start-centered prest-complementar-upload-container"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "column all-start prest-complementar-upload-form"
	  }, [_c('label', {
	    staticClass: "f-required",
	    attrs: {
	      "for": "observacao"
	    }
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.observacoes),
	      expression: "observacoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "observacao",
	      "placeholder": "Motivo da inclusão do documento complementar",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.observacoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.observacoes = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "prest-table"
	  }, [_c('uploadDocumentosPhpPrestacao', {
	    attrs: {
	      "propDocumentos": _vm.anexo,
	      "documentTypes": '',
	      "local-uso": 'SOLICITACAO_PAGAMENTO',
	      "disableAdd": _vm.anexo.length > 0,
	      "restricaoArquivo": false
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('b-button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.salvarAnexo()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save"
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('b-button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        _vm.editando = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  }), _vm._v(" Cancelar")])], 1)]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Documentos Complementares "), _c('i', {
	    staticClass: "fa fa-paperclip",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastrando novo Registro")])
	}]}

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Entidades\n        "), _vm._v(" "), (!_vm.loading) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.conclui()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")])], 1) : _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.limpar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_nome),
	      expression: "entidade.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "data-vv-as": "Razão Social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('Razão social')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cnpj|min:14|max:14'),
	      expression: "'required|cnpj|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "data-vv-as": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.verificaCNPJEntidade($event)
	      }
	    },
	    model: {
	      value: (_vm.entidade.ds_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
	      },
	      expression: "entidade.ds_cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ')))]) : _vm._e()], 1), _vm._v(" "), (_vm.entidadesExistentes.length > 0 && _vm._.has(_vm.entidadesExistentes[0], 'ds_nome') && !_vm._.isNull(_vm.entidadesExistentes[0].ds_nome)) ? _c('div', {
	    staticClass: "col-md-offset-3 col-md-9"
	  }, [_c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" CNPJ já cadastrado no sistema.")]), _vm._v(" "), _vm._l((_vm.entidadesExistentes), function(entidade) {
	    return _c('p', [_c('router-link', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          placement: 'right',
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	      }],
	      attrs: {
	        "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
	        "to": {
	          name: 'cadastro-entidade-edita',
	          params: {
	            id: entidade.id
	          }
	        },
	        "target": "_blank"
	      }
	    }, [_vm._v("\n                        " + _vm._s(_vm._f("cnpj")(entidade.ds_cnpj)) + " -\n                        " + _vm._s(entidade.ds_nome) + "\n                        (" + _vm._s(entidade.ds_nome_fantasia) + ")\n                          "), _c('i', {
	      staticClass: "fa fa-external-link"
	    })])], 1)
	  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('EmailEnt')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_email),
	      expression: "entidade.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "EmailEnt",
	    staticClass: "form-control",
	    attrs: {
	      "name": "EmailEnt",
	      "type": "text",
	      "data-vv-as": "E-Mail",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_email)
	    },
	    on: {
	      "change": _vm.verificaEmailEntidade,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email && _vm.usuario.ds_email) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais!')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('EmailEnt')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('EmailEnt')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('emailConfirmacaoEnt')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "userEmail"
	    }
	  }, [_vm._v("Confirmar E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.emailConfirmacaoEnt),
	      expression: "emailConfirmacaoEnt"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "emailConfirmacaoEnt",
	    staticClass: "form-control",
	    attrs: {
	      "name": "emailConfirmacaoEnt",
	      "data-vv-as": "Confirmar E-Mail",
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.emailConfirmacaoEnt)
	    },
	    on: {
	      "paste": function($event) {
	        $event.preventDefault();
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.emailConfirmacaoEnt = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('emailConfirmacaoEnt')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('emailConfirmacaoEnt')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email !== _vm.emailConfirmacaoEnt && _vm.emailConfirmacaoEnt.length > 0) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails informados não são iguais!')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "possuiCebas"
	    }
	  }, [_vm._v("Possui CEBAS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiCebas),
	      expression: "possuiCebas"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "possuiCebas"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiCebas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.onChangeCebasCmas($event)
	      }]
	    }
	  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "possuiCmas"
	    }
	  }, [_vm._v("Possui CMAS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiCmas),
	      expression: "possuiCmas"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "possuiCmas"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiCmas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.onChangeCebasCmas($event)
	      }]
	    }
	  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Representante Legal:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('userName')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8 col-md-9"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_nome_usuario),
	      expression: "usuario.ds_nome_usuario"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "userName",
	      "data-vv-as": "Nome",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_nome_usuario)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_nome_usuario", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('userName')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('userName')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label  col-sm-4 col-md-3",
	    attrs: {
	      "for": "cpf"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7 col-md-6 col-lg-5"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf",
	      "type": "text",
	      "data-vv-as": "CPF",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.usuario.ds_cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.usuario, "ds_cpf", $$v)
	      },
	      expression: "usuario.ds_cpf"
	    }
	  }), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Login')
	    }
	  }, [_c('label', {
	    staticClass: "control-label  col-sm-4 col-md-3",
	    attrs: {
	      "for": "Login"
	    }
	  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7 col-md-6 col-lg-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_login),
	      expression: "usuario.ds_login"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Login",
	      "data-vv-as": "Login",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_login)
	    },
	    on: {
	      "change": _vm.verificaUsuario,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_login", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Login')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Login')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label  col-sm-4 col-md-3",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7 col-md-6 col-lg-5"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10|max:11'),
	      expression: "'required|min:10|max:11'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "data-vv-as": "Telefone",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.usuario.ds_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.usuario, "ds_telefone", $$v)
	      },
	      expression: "usuario.ds_telefone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('userEmail')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "userEmail"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuario.ds_email),
	      expression: "usuario.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "userEmail",
	    staticClass: "form-control",
	    attrs: {
	      "name": "userEmail",
	      "data-vv-as": "E-mail",
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.usuario.ds_email)
	    },
	    on: {
	      "change": _vm.verificaEmailUsuario,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuario, "ds_email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais.')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('userEmail')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('userEmail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('emailConfirmacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "userEmail"
	    }
	  }, [_vm._v("Confirmar E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.emailConfirmacao),
	      expression: "emailConfirmacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "emailConfirmacao",
	    staticClass: "form-control",
	    attrs: {
	      "name": "emailConfirmacao",
	      "data-vv-as": "Confirmar E-Mail",
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.emailConfirmacao)
	    },
	    on: {
	      "paste": function($event) {
	        $event.preventDefault();
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.emailConfirmacao = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('emailConfirmacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('emailConfirmacao')))]) : _vm._e(), _vm._v(" "), (_vm.usuario.ds_email !== _vm.emailConfirmacao && _vm.emailConfirmacao.length > 0) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Os e-mails informados não são iguais!')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 required-field"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('documentos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(" Documentos anexos obrigatórios: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.tiposArquivos,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um perfil",
	      "label": "ds_tipo",
	      "track-by": "ds_tipo",
	      "preselect-first": true,
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "selectedLabel": "Selecionado",
	      "name": "documentos",
	      "data-vv-as": "Documentos anexos obrigatórios"
	    },
	    on: {
	      "remove": _vm.removeDocumento
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.entidade.tipoDocumentos),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "tipoDocumentos", $$v)
	      },
	      expression: "entidade.tipoDocumentos"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('documentos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('documentos')))]) : _vm._e()])])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Credenciamento da Entidade")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('fieldset', [_c('legend', [_vm._v(" Documentos:")])])
	}]}

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - ' + (_vm._.isEmpty(_vm.proposta) && _vm.loading.tela ? 'Carregando ...' : (_vm.ehVisualizacao ? 'Visualizando ' + (!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : '') : _vm.etapa + ' da Alteração ' + (!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : '')))
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', {
	    staticClass: "col-md-5"
	  }, [(_vm._.isEmpty(_vm.proposta) && _vm.loading.tela) ? _c('span', [_vm._v("Carregando projeto ...")]) : _c('span', [(_vm.ehVisualizacao) ? _c('span', [_vm._v("Visualizar " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]) : _c('span', [_vm._v(_vm._s(_vm.etapa) + " da Alteração em Projeto " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))])])]), _vm._v(" "), (!_vm.loading.tela || _vm.ehVisualizacao) ? _c('span', {
	    staticClass: "col-md-4 bloco_botoes"
	  }, [_c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1), _vm._v(" "), ((!_vm._.isEmpty(_vm.proposta) || !_vm._.isNull(_vm.id)) && !_vm.ehVisualizacao) ? _c('span', [(true && _vm.erroCronograma === false) ? _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.processarSolicitacao('SALVAR')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), (!_vm.loading.poderes && _vm._.includes(_vm.poderes, 'PERMITE_CONCLUIR') && _vm.erroCronograma === false) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.processarSolicitacao('ENCAMINHAR')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")])], 1) : (_vm.loading.poderes) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((!_vm._.isEmpty(_vm.proposta) || !_vm._.isNull(_vm.id)) && !_vm.loading.tela && !_vm.ehVisualizacao) ? _c('span', [((_vm.usuarioLogado.userType === 'FUNDACAO' && _vm._.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) || (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm._.includes(['Solicitação'], _vm.etapa))) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "onclick": "alertaCancelamentoDialog.showModal()",
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar  \n                ")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "btn-group dropdown"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Relatórios "), _c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.emitir(219)
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(" 219 - Adiantamento de Projetos")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.emitir(525, 'S')
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(" 525A - Extrato de Projetos Analítico")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.emitir(525, 'N')
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(" 525S - Extrato de Projetos Sintético")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.emitir(248)
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(" 248 - Monitoramento Administrativo")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.emitir(268)
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(" 268 - Relatório de Ocorrências")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.emitir(300)
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(" 300 - Extrato de Projetos por Beneficiária")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": 'alteracoesprojeto/sumula/' + _vm.id,
	      "target": "_blank"
	    }
	  }, [_vm._v("Visualizar Sumula")])])])], 1)])]) : _vm._e(), _vm._v(" "), ((!_vm.loading.tela || _vm.ehVisualizacao) && !_vm._.isEmpty(_vm.sumarioQtdeAlteracoes)) ? _c('span', {
	    staticClass: "col-md-3",
	    staticStyle: {
	      "margin": "7px 0px",
	      "display": "flex",
	      "justify-content": "space-between",
	      "align-items": "center"
	    }
	  }, [_c('span', {
	    staticClass: "bloco_resumo_alteracao",
	    on: {
	      "click": function($event) {
	        return _vm.alterarModoModificacao('solicitacao')
	      }
	    }
	  }, [(_vm.opcoesVisualizacao.solicitacao.modificacoes === 'RESUMIDO') ? _c('span', {
	    staticClass: "modificacaoResumido"
	  }, [_c('span', [_vm._v(_vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'total')) + " " + _vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'total') > 1 ? 'modificações' : 'modificação'))])]) : (_vm.opcoesVisualizacao.solicitacao.modificacoes === 'DETALHADO') ? _c('span', {
	    staticClass: "modificacaoDetalhado"
	  }, [(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'exclusao')) ? _c('span', {
	    staticClass: "modificacaoTotalExclusao"
	  }, [_vm._v(_vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'exclusao')) + " " + _vm._s((_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'exclusao') > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'inclusao')) ? _c('span', {
	    staticClass: "modificacaoTotalInclusao"
	  }, [_vm._v(_vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'inclusao')) + " " + _vm._s((_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'inclusao') > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'alteracao')) ? _c('span', {
	    staticClass: "modificacaoTotalAlteracao"
	  }, [_vm._v(_vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'alteracao')) + " " + _vm._s((_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'alteracao') > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm._.isEmpty(_vm.msgErroProcessamento)) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        delay: [1000, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [1000, 0]}"
	    }],
	    staticClass: "icon iconeAlerta pulsingAlerta",
	    attrs: {
	      "title": '<h5>Mensagens de erro e alertas mais recentes</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.$dialog.alert('<p>' + _vm._.join(_vm.msgErroProcessamento, '</p>'), {
	          html: true,
	          animation: 'fade',
	          customClass: 'avisoAlerta'
	        }).then(function(dialog) {})
	      }
	    }
	  }, [_c('span', [_vm._v("!")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [(_vm._.isEmpty(_vm.proposta) && _vm._.isNull(_vm.id) && _vm.ehVisualizacao && _vm.loading.tela) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-body",
	    staticStyle: {
	      "height": "200px"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm._.isEmpty(_vm.proposta) && _vm._.isNull(_vm.id) && !_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaProjetos"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.listaProjetos.length === 0),
	      expression: "listaProjetos.length === 0"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('span', {
	    ref: "listaProjetosAlteraveis"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaProjetos.validos,
	      "disabled": _vm.ehVisualizacao,
	      "multiple": false,
	      "placeholder": "Selecione um projeto",
	      "track-by": "ds_codigo_projeto_erp",
	      "label": "ds_nome",
	      "custom-label": function (option) {
	        return ("" + (option.ds_codigo_projeto_erp + option.ds_nome + option.ds_situacao_erp))
	      },
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('strong', [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" " + _vm._s(props.option.ds_nome))]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "identificadorIDProjeto"
	        }, [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" " + _vm._s(props.option.ds_nome))]
	      }
	    }], null, false, 1965450868),
	    model: {
	      value: (_vm.projeto),
	      callback: function($$v) {
	        _vm.projeto = $$v
	      },
	      expression: "projeto"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum projeto localizado!")])], 2)], 1)])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.propostaBackup) || !_vm._.isNull(_vm.id)) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "alteracao_projeto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("\n              " + _vm._s(_vm.propostaBackup.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.propostaBackup.ds_nome) + "\n              "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela) ? _c('span', [_vm._v("("), _c('strong', [_vm._v(_vm._s(_vm._.get(_vm.propostaBackup, 'projetoSapiens.sitprj', '')))]), _vm._v(")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Objetivo Geral:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.propostaBackup.ds_objetivo_geral))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Período de execução:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propostaBackup.dt_assinatura_convenio, "L")) + " a " + _vm._s(_vm.dataFinalBackup))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome da Instituição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.propostaBackup, 'projetoSapiens.entidadeParceira.nomfor', '')) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valor do projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.map(_vm._.filter(_vm._.flatten(_vm._.map(_vm.propostaBackup.atividades, 'itens_orcamentos')), function(i) {
	    return _vm._.includes(['1', '5'], ('' + i.origem).substr(0, 1))
	  }), 'valor_total')))))])]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valor de contrapartida:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.map(_vm._.filter(_vm._.flatten(_vm._.map(_vm.propostaBackup.atividades, 'itens_orcamentos')), function(i) {
	    return _vm._.includes(['2'], ('' + i.origem).substr(0, 1))
	  }), 'valor_total')))))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Municipios atendidos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm._.join(_vm._.uniq(_vm._.map(_vm.propostaBackup.municipalizacao, function(m) {
	    return m.ds_municipio + (_vm._.isNil(m.ds_uf) ? '' : ' (' + m.ds_uf + ')')
	  })), ', ')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Projeto superior:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "form-control-static truncar"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.propostaBackup, 'projetoSapiens.projetoSuperior.numprj', '')) + " - " + _vm._s(_vm._.get(_vm.propostaBackup, 'projetoSapiens.projetoSuperior.nomprj', '')))])])]), _vm._v(" "), _c('div', {
	    ref: "justificativa",
	    staticClass: "col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Qual a justificativa para esta solicitação de alteração de projeto",
	      "min-height": 72,
	      "autosize": true,
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
	      "name": "justificativa",
	      "rows": "3"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.solicitacao.justificativa),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao, "justificativa", $$v)
	      },
	      expression: "solicitacao.justificativa"
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [(_vm._.get(_vm.ultimaTarefa, 'observacao', false)) ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.ultimaTarefa.observacao)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length > 0) ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm._.uniq(_vm.restricaoParaInicializar)), function(restricao) {
	    return _c('p', [_vm._v(_vm._s(restricao))])
	  })], 2) : _vm._e(), _vm._v(" "), (!_vm.ehVisualizacao && _vm.usuarioLogado.userType !== 'FUNDACAO') ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("As alterações solicitadas podem gerar aditivo para assinatura futura")])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.proposta) && _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('div', {
	    staticClass: "row box-header",
	    staticStyle: {
	      "font-size": "16px"
	    }
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.solicitacao = !_vm.mostrar.solicitacao
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.solicitacao ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar Solicitação")])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.proposta)) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrar.solicitacao),
	      expression: "mostrar.solicitacao"
	    }],
	    staticClass: "form-horizontal"
	  }, [(_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PERIODO_PROJETO') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'periodoProjeto') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))) ? _c('div', [_c('div', {
	    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PERIODO_PROJETO') ? 'bloco_com_alteracao' : '')
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        return _vm.alterarExpandirBloco('periodo')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.periodo.expandir ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Período de execução do projeto")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PERIODO_PROJETO')) ? _c('span', {
	    staticClass: "bloco_resumo_alteracao",
	    on: {
	      "click": function($event) {
	        return _vm.alterarModoModificacao('periodo')
	      }
	    }
	  }, [(_vm.opcoesVisualizacao.periodo.modificacoes === 'RESUMIDO') ? _c('span', {
	    staticClass: "modificacaoResumido"
	  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.periodo.modificacoes === 'DETALHADO') ? _c('span', {
	    staticClass: "modificacaoDetalhado"
	  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'exclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalExclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'inclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalInclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'alteracao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalAlteracao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.opcoesVisualizacao.periodo.expandir) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.dataInicialFormatada))])])]), _vm._v(" "), _c('div', {
	    staticClass: "required-field col-md-4 required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "display": "inline-table"
	    }
	  }, [_c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.nr_periodos),
	      expression: "proposta.nr_periodos"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:' + _vm.projetoPeriodos + '|max_value:' + _vm.proposta.periodo_vigencia),
	      expression: "'required|min_value:' + projetoPeriodos + '|max_value:' + proposta.periodo_vigencia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Número de Meses do Projeto",
	      "lang": "pt-br",
	      "name": "periodo",
	      "type": "number",
	      "min": "1",
	      "max": _vm.proposta.periodo_vigencia,
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)
	    },
	    domProps: {
	      "value": (_vm.proposta.nr_periodos)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.prepararSolicitacao()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "nr_periodos", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.opcoesVisualizacao.periodo.modificacoes === 'DETALHADO' && _vm._.get(_vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.nr_periodos.0')) ? _c('span', {
	    staticClass: "input-group-addon valorAlterado",
	    staticStyle: {
	      "width": "50%"
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm._.get(_vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.nr_periodos.0', 0)) + "\n                      ")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data final de execução")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "required-field col-md-4 required",
	    class: {
	      'has-error': _vm.errors.first('periodoVigencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses de Vigência")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "display": "inline-table"
	    }
	  }, [_c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periodo_vigencia),
	      expression: "proposta.periodo_vigencia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:' + _vm.proposta.nr_periodos),
	      expression: "'required|min_value:' + proposta.nr_periodos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Período Vigência",
	      "lang": "pt-br",
	      "name": "periodoVigencia",
	      "type": "number",
	      "max": "72",
	      "min": _vm.proposta.nr_periodos,
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)
	    },
	    domProps: {
	      "value": (_vm.proposta.periodo_vigencia)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.prepararSolicitacao()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.opcoesVisualizacao.periodo.modificacoes === 'DETALHADO' && _vm._.get(_vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.periodo_vigencia.0')) ? _c('span', {
	    staticClass: "input-group-addon valorAlterado",
	    staticStyle: {
	      "width": "50%"
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm._.get(_vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.periodo_vigencia.0', 0)) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('periodoVigencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodoVigencia')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data final da vigência")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dataFinalVigencia, "L")))])])])])]), _vm._v(" "), (('' + _vm.proposta.nr_periodos) !== ('' + _vm.propostaBackup.nr_periodos) && _vm._.includes(['Análise', 'Autorização'], _vm.etapa) && !_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "col-md-3 text-red"
	  }, [_vm._v("\n              Atenção: o período foi alterado!"), _c('br'), _vm._v("Passou de " + _vm._s(_vm.propostaBackup.nr_periodos) + " meses para " + _vm._s(_vm.proposta.nr_periodos) + " meses"), _c('br'), _c('br'), _vm._v("\n              Verifique se as atividades estão de acordo com o novo período.\n            ")]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.proposta, 'historicos.periodos')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), _vm._v(" "), (_vm.loading.historicos.periodos) ? _c('span', [_vm._m(3)]) : _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.historicos.periodos = !_vm.mostrar.historicos.periodos
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.historicos.periodos ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                Histórico de alterações de término do projeto\n              ")]), _vm._v(" "), (_vm.mostrar.historicos.periodos) ? _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "stacked": "md",
	      "items": _vm.proposta.historicos.periodos,
	      "bordered": _vm.tabela.historicos.periodos.bordered,
	      "fields": _vm.tabela.historicos.periodos.fields
	    },
	    scopedSlots: _vm._u([{
	      key: "id",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "acao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "periodo",
	      fn: function(row) {
	        return [(row.item.acao === 'Contratação') ? _c('span', [_vm._v(_vm._s(row.item.periodo_inicial) + " meses")]) : _c('span', {
	          staticClass: "text-muted"
	        }, [_c('span', {
	          staticClass: "text-green"
	        }, [_vm._v(_vm._s(row.item.periodo_alterado >= 0 ? '+' : '') + _vm._s(row.item.periodo_alterado))]), _vm._v(" para " + _vm._s(row.item.periodo_final) + " meses\n                      ")])]
	      }
	    }, {
	      key: "termino_alterado",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))])]
	      }
	    }], null, false, 136229566)
	  })], 1)], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_METAS') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'metas') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))) ? _c('div', [_c('div', {
	    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_METAS') ? 'bloco_com_alteracao' : '')
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        return _vm.alterarExpandirBloco('metas')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.metas.expandir ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Metas")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_METAS')) ? _c('span', {
	    staticClass: "bloco_resumo_alteracao",
	    on: {
	      "click": function($event) {
	        return _vm.alterarModoModificacao('metas')
	      }
	    }
	  }, [(_vm.opcoesVisualizacao.metas.modificacoes === 'RESUMIDO') ? _c('span', {
	    staticClass: "modificacaoResumido"
	  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.metas.modificacoes === 'DETALHADO') ? _c('span', {
	    staticClass: "modificacaoDetalhado"
	  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'exclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalExclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'inclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalInclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'alteracao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalAlteracao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.opcoesVisualizacao.metas.expandir) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('metas', {
	    attrs: {
	      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsMetas": _vm.proposta.metas,
	      "propsProposta": _vm.proposta,
	      "propsPropostaBackup": _vm.propostaBackup,
	      "atvSemMetas": _vm.atvSemMetas,
	      "processo-solicitacao": _vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_METAS']),
	      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.metas.modificacoes
	    },
	    on: {
	      "acaoAtualizaSolicitacoes": function($event) {
	        return _vm.prepararSolicitacao()
	      },
	      "metaAdicionada": function($event) {
	        _vm.proposta.metas = $event
	      },
	      "validacaoMetas": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_ATIVIDADES') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'atividades') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))) ? _c('div', {
	    ref: "atividades"
	  }, [_c('div', {
	    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_ATIVIDADES') ? 'bloco_com_alteracao' : '')
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        return _vm.alterarExpandirBloco('atividades')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.atividades.expandir ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atividades")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_ATIVIDADES')) ? _c('span', {
	    staticClass: "bloco_resumo_alteracao",
	    on: {
	      "click": function($event) {
	        return _vm.alterarModoModificacao('atividades')
	      }
	    }
	  }, [(_vm.opcoesVisualizacao.atividades.modificacoes === 'RESUMIDO') ? _c('span', {
	    staticClass: "modificacaoResumido"
	  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.atividades.modificacoes === 'DETALHADO') ? _c('span', {
	    staticClass: "modificacaoDetalhado"
	  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'exclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalExclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'inclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalInclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'alteracao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalAlteracao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.opcoesVisualizacao.atividades.expandir) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('atividades', {
	    attrs: {
	      "novaAtividade": _vm.criarAtividade,
	      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
	      "meses": _vm.proposta.nr_periodos,
	      "propsMetas": _vm.proposta.metas,
	      "propsAtividades": _vm.proposta.atividades,
	      "propsProposta": _vm.proposta,
	      "propsPropostaBackup": _vm.propostaBackup,
	      "atualizar": _vm.numeroAtualizacao,
	      "processo-solicitacao": _vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_ATIVIDADES']),
	      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.atividades.modificacoes
	    },
	    on: {
	      "acaoAtualizaSolicitacoes": function($event) {
	        return _vm.prepararSolicitacao()
	      },
	      "atividadeAdicionada": function($event) {
	        _vm.proposta.atividades = $event
	      },
	      "validacaoAtividades": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm._.has(_vm.sumarioQtdeAlteracoes, 'REMANEJAMENTO') || _vm._.has(_vm.sumarioQtdeAlteracoes, 'SUPLEMENTACAO') || (_vm._.intersection(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), ['remanejamento', 'suplementacao'])).length > 0 && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))) ? _c('div', [_c('div', {
	    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'REMANEJAMENTO') || _vm._.has(_vm.sumarioQtdeAlteracoes, 'SUPLEMENTACAO') ? 'bloco_com_alteracao' : '')
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block",
	      "z-index": "700"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "space-between"
	    }
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        return _vm.alterarExpandirBloco('extratoProjeto')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.extratoProjeto.expandir ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Extrato do cronograma")]), _vm._v(" "), _c('span', [(_vm.ehVisualizacao || _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('span', {
	    staticClass: "text-blue"
	  }, [_vm._v("\n                    " + _vm._s(_vm.tipoAlteracaoCronograma === 'REMANEJAMENTO' ? 'Remanejamento' : 'Suplementação') + "\n                  ")]) : _c('span', [((_vm._.intersection(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), ['remanejamento', 'suplementacao'])).length > 1) ? _c('span', [_c('span', {
	    staticStyle: {
	      "font-size": "small",
	      "color": "var(--cor-fraca-dark)"
	    }
	  }, [_c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "new-control new-control-radio",
	    style: ('padding-top: 10px;' + (_vm.tipoAlteracaoCronograma === 'REMANEJAMENTO' ? 'color: var(--cor-azul);' : '')),
	    attrs: {
	      "title": '<h5>Remanejamento permite alterar o cronograma aumentando e subtraindo valores desde que a soma final seja zero</h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoAlteracaoCronograma),
	      expression: "tipoAlteracaoCronograma"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tipoAlteracaoCronograma"
	    },
	    domProps: {
	      "value": 'REMANEJAMENTO',
	      "checked": _vm._q(_vm.tipoAlteracaoCronograma, 'REMANEJAMENTO')
	    },
	    on: {
	      "change": function($event) {
	        _vm.tipoAlteracaoCronograma = 'REMANEJAMENTO'
	      }
	    }
	  }), _vm._v(" Remanejamento"), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "new-control new-control-radio",
	    style: ('padding-top: 10px;' + (_vm.tipoAlteracaoCronograma === 'SUPLEMENTACAO' ? 'color: var(--cor-azul);' : '') + 'margin-left: 20px'),
	    attrs: {
	      "title": '<h5>Suplemetação permite aumentar o valor do projeto, aumentando orçamento de itens ou criando novos</h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoAlteracaoCronograma),
	      expression: "tipoAlteracaoCronograma"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tipoAlteracaoCronograma"
	    },
	    domProps: {
	      "value": 'SUPLEMENTACAO',
	      "checked": _vm._q(_vm.tipoAlteracaoCronograma, 'SUPLEMENTACAO')
	    },
	    on: {
	      "change": function($event) {
	        _vm.tipoAlteracaoCronograma = 'SUPLEMENTACAO'
	      }
	    }
	  }), _vm._v(" Suplementação"), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]) : _c('span')])]), _vm._v(" "), (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'suplementacao') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('span', {
	    staticClass: "text-danger",
	    staticStyle: {
	      "font-size": "small"
	    }
	  }, [_vm._v(_vm._s(_vm.tipoAlteracaoCronograma === 'SUPLEMENTACAO' ? 'A suplementação não deve ultrapassar 25%' : ''))]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'REMANEJAMENTO') || _vm._.has(_vm.sumarioQtdeAlteracoes, 'SUPLEMENTACAO')) ? _c('span', {
	    staticClass: "bloco_resumo_alteracao",
	    on: {
	      "click": function($event) {
	        return _vm.alterarModoModificacao('extratoProjeto')
	      }
	    }
	  }, [(_vm.opcoesVisualizacao.extratoProjeto.modificacoes === 'RESUMIDO') ? _c('span', {
	    staticClass: "modificacaoResumido"
	  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'total'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'total'], ''))) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'total'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'total'], 0)) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.extratoProjeto.modificacoes === 'DETALHADO') ? _c('span', {
	    staticClass: "modificacaoDetalhado"
	  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'exclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'exclusao'], 0)) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalExclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'exclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'exclusao']))) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'exclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'exclusao'], 0)) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'inclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'inclusao'], 0)) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalInclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'inclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'inclusao']))) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'inclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'inclusao'], 0)) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'alteracao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'alteracao'], 0)) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalAlteracao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'alteracao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'alteracao']))) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'alteracao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'alteracao'], 0)) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.opcoesVisualizacao.extratoProjeto.expandir),
	      expression: "opcoesVisualizacao.extratoProjeto.expandir"
	    }],
	    staticClass: "box-body"
	  }, [_c('extrato', {
	    ref: "extratoCronograma",
	    attrs: {
	      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
	      "etapa": 'SOLICITACAO',
	      "tipo-solicitacao": _vm.tipoAlteracaoCronograma,
	      "layout": 'classico',
	      "itensLayout": _vm.etapa === 'Análise' ? ['filtroItens', 'substituicaoItem'] : [],
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsAtividades": _vm.proposta.atividades,
	      "metas": _vm.proposta.metas,
	      "proposta": _vm.proposta,
	      "meses": _vm.proposta.nr_periodos,
	      "projetoDuplicacao": _vm.proposta.nr_projeto_duplicacao,
	      "filtro-inicial": _vm.ehVisualizacao ? ['solicitados'] : (_vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], _vm._.map(_vm.solicitacao.processos, 'nome')) && _vm._.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _vm.etapa) ? ['solicitados'] : []),
	      "processo-solicitacao": {
	        'processo': _vm.processo,
	        'solicitacao': _vm._.find(_vm.solicitacao.processos, ['nome', _vm.tipoAlteracaoCronograma])
	      },
	      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.extratoProjeto.modificacoes,
	      "atualizar-extrato": !_vm._.includes(['FEITO', 'CANCELADO'], _vm._.get(_vm.processo, 'situacao', '')),
	      "processoSolicitacao": _vm.solicitacao
	    },
	    on: {
	      "acaoOk": function($event) {
	        return _vm.prepararSolicitacao()
	      },
	      "acaoTotaisAtualizados": function($event) {
	        return _vm.passarTotaisExtratoParaSumula($event)
	      },
	      "cronogramaAtividades": function($event) {
	        _vm.proposta.atividades = $event
	      },
	      "alteracoesCronograma": function($event) {
	        _vm.cronogramaAlteracoes = $event
	      },
	      "validacaoCronograma": function($event) {
	        return _vm.adicionaRestricao($event)
	      },
	      "criacaoAtividade": function($event) {
	        _vm.criarAtividade = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', [_c('visualiza-gestao-atividades', {
	    key: 'GANTT-' + _vm.numeroAtualizacao,
	    attrs: {
	      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
	      "itensLayout": ['opcoes'],
	      "propsNumeroProjeto": _vm.proposta.ds_codigo_projeto_erp,
	      "propsAtividades": _vm.proposta.atividades,
	      "atividades-alteradas": _vm.listaIdsAtividadesAlteradas,
	      "proposta": _vm.proposta,
	      "atualizar-gantt": !_vm._.includes(['FEITO', 'CANCELADO'], _vm._.get(_vm.processo, 'situacao', ''))
	    },
	    on: {
	      "atividadesProposta": function($event) {
	        _vm.proposta.atividades = $event
	      },
	      "atividadesGantt": function($event) {
	        _vm.proposta.gantt_atividades = $event
	      },
	      "atividadesAlteracoes": function($event) {
	        _vm.proposta.gantt_alterado = $event
	      },
	      "validacaoAtividadesGantt": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PARCELAS_ADIANTAMENTO') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'parcelasAdiantamento') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))),
	      expression: "_.has(sumarioQtdeAlteracoes, 'ALTERACAO_PARCELAS_ADIANTAMENTO') || (_.includes(_.get(proposta, 'opcoes.alteracoesPermitidas', []), 'parcelasAdiantamento') && !ehVisualizacao && !_.includes(['Autorização', 'Deliberação', 'Pendências'], etapa))"
	    }]
	  }, [_c('div', {
	    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PARCELAS_ADIANTAMENTO') ? 'bloco_com_alteracao' : '')
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        return _vm.alterarExpandirBloco('parcelasAdiantamento')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.parcelasAdiantamento.expandir ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Parcelas de Adiantamento")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PARCELAS_ADIANTAMENTO')) ? _c('span', {
	    staticClass: "bloco_resumo_alteracao",
	    on: {
	      "click": function($event) {
	        return _vm.alterarModoModificacao('parcelasAdiantamento')
	      }
	    }
	  }, [(_vm.opcoesVisualizacao.parcelasAdiantamento.modificacoes === 'RESUMIDO') ? _c('span', {
	    staticClass: "modificacaoResumido"
	  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.parcelasAdiantamento.modificacoes === 'DETALHADO') ? _c('span', {
	    staticClass: "modificacaoDetalhado"
	  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'exclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalExclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'inclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalInclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'alteracao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalAlteracao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.opcoesVisualizacao.parcelasAdiantamento.expandir),
	      expression: "opcoesVisualizacao.parcelasAdiantamento.expandir"
	    }],
	    staticClass: "box-body"
	  }, [_c('parcela-adiantamento', {
	    attrs: {
	      "alteracaoProjeto": true,
	      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
	      "propsProposta": _vm.proposta,
	      "propsPropostaBackup": _vm.propostaBackup,
	      "propsParcelas": _vm._.get(_vm.proposta, 'adiantamentos', []),
	      "propsLayout": 'EXECUCAO',
	      "propsAtividades": _vm.proposta.atividades,
	      "atualizar": _vm.numeroAtualizacao,
	      "processo-solicitacao": _vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PARCELAS_ADIANTAMENTO']),
	      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.parcelasAdiantamento.modificacoes
	    },
	    on: {
	      "acaoAtualizaSolicitacoes": function($event) {
	        return _vm.prepararSolicitacao()
	      },
	      "parcelaAdicionada": function($event) {
	        _vm.proposta.adiantamentos = $event
	      },
	      "validacaoParcelasAdiantamento": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_MUNICIPIOS') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'municipios') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))),
	      expression: "_.has(sumarioQtdeAlteracoes, 'ALTERACAO_MUNICIPIOS') || (_.includes(_.get(proposta, 'opcoes.alteracoesPermitidas', []), 'municipios') && !ehVisualizacao && !_.includes(['Autorização', 'Deliberação', 'Pendências'], etapa))"
	    }]
	  }, [_c('div', {
	    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_MUNICIPIOS') ? 'bloco_com_alteracao' : '')
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        return _vm.alterarExpandirBloco('municipios')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.municipios.expandir ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Municípios - Locais de execução")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_MUNICIPIOS')) ? _c('span', {
	    staticClass: "bloco_resumo_alteracao",
	    on: {
	      "click": function($event) {
	        return _vm.alterarModoModificacao('municipios')
	      }
	    }
	  }, [(_vm.opcoesVisualizacao.municipios.modificacoes === 'RESUMIDO') ? _c('span', {
	    staticClass: "modificacaoResumido"
	  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.municipios.modificacoes === 'DETALHADO') ? _c('span', {
	    staticClass: "modificacaoDetalhado"
	  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'exclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalExclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'inclusao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalInclusao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'alteracao'], 0) > 0) ? _c('span', {
	    staticClass: "modificacaoTotalAlteracao"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.opcoesVisualizacao.municipios.expandir),
	      expression: "opcoesVisualizacao.municipios.expandir"
	    }],
	    staticClass: "box-body"
	  }, [_c('municipalizacao', {
	    attrs: {
	      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
	      "etapa": _vm.etapa,
	      "propsProposta": _vm.proposta,
	      "propsPropostaBackup": _vm.propostaBackup,
	      "propsLayout": _vm._.includes(['Análise'], _vm.etapa) ? ['COM_BOTOES_DISTRIBUICAO'] : ['SEM_BOTOES_DISTRIBUICAO'],
	      "atualizar": _vm.numeroAtualizacao,
	      "processo-solicitacao": _vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_MUNICIPIOS']),
	      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.municipios.modificacoes
	    },
	    on: {
	      "acaoAtualizaSolicitacoes": function($event) {
	        return _vm.prepararSolicitacao()
	      },
	      "municipioAdicionado": function($event) {
	        _vm.proposta.municipalizacao = $event
	      },
	      "validacaoMunicipio": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1)])]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'FUNDACAO' && (_vm._.includes(_vm.poderes, 'PERMITE_CONCLUIR') || !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa))) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    ref: "instrumentosLidos",
	    class: 'col-md-12 alert alert-dismissible ' + (_vm.solicitacao.instrumentosLidos.ok ? 'alert-success' : (_vm._.find(_vm.errors.items, ['field', 'instrumentosLidos']) ? 'alert-danger' : 'alert-warning')),
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    class: 'col-md-' + (!_vm._.isNull(_vm.solicitacao.instrumentosLidos.usuario) ? '8' : '12')
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [(_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('span', [_c('i', {
	    class: (_vm.solicitacao.instrumentosLidos.ok ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.solicitacao.instrumentosLidos.ok = !_vm.solicitacao.instrumentosLidos.ok;
	        _vm._.remove(_vm.errors.items, ['field', 'instrumentosLidos'])
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('span', {
	    class: _vm.solicitacao.instrumentosLidos.ok ? 'selecionado' : ''
	  }, [_vm._v(" Li e estou ciente das cláusulas do instrumento e seus aditivos")])])]), _vm._v(" "), (!_vm._.isNull(_vm.solicitacao.instrumentosLidos.usuario)) ? _c('div', {
	    staticClass: "col-md-4 text-right"
	  }, [_vm._v("\n                " + _vm._s(_vm.solicitacao.instrumentosLidos.usuario.ds_nome_usuario)), _c('br'), _vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.solicitacao.instrumentosLidos.data, 'DD/MM/YYYY HH:MM:SS')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.errors.items, ['field', 'instrumentosLidos'])) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve ler os instrumentos legais. Após isso selecione a opção acima")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.proposta)) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.anexos = !_vm.mostrar.anexos
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.anexos ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              Anexos\n            ")])])]), _vm._v(" "), (_vm.mostrar.anexos) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal col-md-12"
	  }, [_c('upload-documentos-online', {
	    attrs: {
	      "idProcesso": _vm.id,
	      "propDocumentos": _vm.solicitacao.anexos,
	      "documentTypes": '',
	      "ehVisualizacao": _vm.ehVisualizacao,
	      "secaoOrigem": 'ALTERACOES_PROJETO',
	      "local-uso": _vm.etapa === 'Deliberação' ? 'ALTERACOES_PROJETOS_NT_SML' : (_vm.etapa === 'Pendências' ? 'ALTERACOES_PROJETOS_ADT_PLT' : 'ALTERACOES_PROJETOS_ANEXOS'),
	      "vigencia-obrigatoria": [2, 6, 40, 67],
	      "docs-informa-vencimento": [2, 6, 40, 67]
	    },
	    on: {
	      "arquivoAnexado": function($event) {
	        return _vm.solicitacao.anexos.push($event)
	      },
	      "arquivoExcluido": function($event) {
	        return _vm._.remove(_vm.solicitacao.anexos, ['id', $event.id])
	      },
	      "layoutAtual": function($event) {},
	      "acaoSalvar": function($event) {
	        return _vm.processarSolicitacao('SALVAR')
	      },
	      "acaoOk": function($event) {},
	      "acaoCancelar": function($event) {},
	      "acaoProcessamento": function($event) {
	        _vm.loading.tela = true
	      },
	      "acaoAguardando": function($event) {
	        _vm.loading.tela = false
	      }
	    }
	  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.etapa !== 'Solicitação') ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.historicos.tarefas = !_vm.mostrar.historicos.tarefas
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.historicos.tarefas ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Históricos tarefas")])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	    staticClass: "bloco_resumo_alteracao"
	  }, [_c('div', {
	    staticClass: "btn-group dropdown"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticStyle: {
	      "border": "0",
	      "background": "transparent"
	    },
	    attrs: {
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v(" Modo " + _vm._s(_vm._.get(this.opcoesVisualizacao, 'historico.modo', 'PADRAO') === 'PADRAO' ? 'Padrão' : 'Completo') + " "), _c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.filtrarHistoricoPorModo('PADRAO')
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(" Padrão")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.filtrarHistoricoPorModo('COMPLETO')
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(" Completo")])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.mostrar.historicos.tarefas) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    ref: "historico_solicitacao",
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(5), _vm._v(" "), _c('tbody', {}, _vm._l((_vm.tarefas), function(tarefa) {
	    return (_vm._.get(tarefa, 'mostrar', true)) ? _c('tr', {
	      class: _vm._.includes(['INCLUSAO_DOCUMENTO', 'EXCLUSAO_DOCUMENTO', 'RecPrv_at_com_senior_g5_co_mfi_prj_recursosprevistosgrid', 'INSERINDO_RECURSOS_SAPIENS', 'VISUALIZACAO'], tarefa.nome) ? 'text-muted' : (_vm._.get(_vm.opcoesVisualizacao, 'historico.modo', 'PADRAO') === 'PADRAO' ? '' : 'bg-gray-light')
	    }, [_c('td', {
	      staticClass: "col-md-2"
	    }, [_vm._v(_vm._s(_vm._.get(_vm.tarefaNome, tarefa.nome, '!')))]), _vm._v(" "), _c('td', {
	      staticClass: "col-md-2 text-center"
	    }, [_vm._v(_vm._s(_vm._f("moment")(tarefa.termino, 'DD/MM/YYYY HH:MM')))]), _vm._v(" "), _c('td', {
	      staticClass: "col-md-3 truncar",
	      staticStyle: {
	        "width": "100px"
	      }
	    }, [_vm._v(_vm._s(tarefa.ds_nome_usuario))]), _vm._v(" "), _c('td', {
	      staticClass: "col-md-5"
	    }, [_vm._v(_vm._s(tarefa.observacao))])]) : _vm._e()
	  }), 0)])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.isEmpty(_vm.proposta) && _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('span', [_c('div', {
	    staticClass: "row box-header",
	    staticStyle: {
	      "font-size": "16px"
	    }
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.sumula = !_vm.mostrar.sumula
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.sumula ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar Súmula")])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrar.sumula),
	      expression: "mostrar.sumula"
	    }],
	    staticClass: "form-horizontal"
	  }, [_c('sumula', {
	    attrs: {
	      "id-processo": _vm.id,
	      "props-proposta": _vm.proposta,
	      "props-solicitacao": _vm.solicitacao
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.isEmpty(_vm.proposta) && !_vm._.isNull(_vm.id) && _vm._.includes(['Pendências'], _vm.etapa) && _vm._.find(_vm.solicitacao.sumula.providencias, function(p) {
	    return _vm._.includes(['PLT', 'ADT'], p.codigo)
	  })) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela || _vm.loading.aditivo.conteudo),
	      expression: "loading.tela || loading.aditivo.conteudo"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.aditivo = !_vm.mostrar.aditivo
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.aditivo ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm._.join(_vm._.map(_vm._.filter(_vm.solicitacao.sumula.providencias, function(p) {
	    return _vm._.includes(['PLT', 'ADT'], p.codigo)
	  }), 'descricao'), ' e ')) + "\n            ")])])]), _vm._v(" "), (_vm.mostrar.aditivo) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Modelo de minuta:")]), _vm._v(" "), _c('div', {
	    ref: "lista aditivo",
	    staticClass: "col-md-6"
	  }, [(_vm.loading.aditivo.lista) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando lista com modelos de minutas disponíveis...")]) : _c('span', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaMinutasAditivo,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": 'Selecione um modelo de minuta dentre os disponíveis',
	      "track-by": "id",
	      "custom-label": function (option) {
	        return ("" + (option.nome))
	      },
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "lista aditivo",
	      "disabled": _vm.ehVisualizacao
	    },
	    on: {
	      "select": function($event) {
	        return _vm.verificaSeHaAditivoUsando($event)
	      }
	    },
	    model: {
	      value: (_vm.solicitacao.aditivo.modelo),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.aditivo, "modelo", $$v)
	      },
	      expression: "solicitacao.aditivo.modelo"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("Nenhum registro localizado!")])])]), _vm._v(" "), (_vm.errors.first('lista aditivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve selecionar um modelo de minuta")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [(!_vm.loading.aditivo.lista) ? _c('g-button-moema', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "color": "warning",
	      "title": '<h5>Salva a minuta atual e abre ela para impressão em nova guia</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.processarSolicitacao('SALVAR', 'aditivo')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Visualizar Minuta")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
	    staticClass: "pull-right",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.processarSolicitacao('SALVAR', 'plano-trabalho')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Plano de Trabalho")])], 1)]), _vm._v(" "), (!_vm._.isEmpty(_vm.solicitacao.aditivo.modelo)) ? _c('div', {
	    staticClass: "col-md-12 form-group"
	  }, [(_vm.loading.aditivo.conteudo) ? _c('div', {
	    staticClass: "col-md-12 etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando modelo do documento...")]) : _c('div', {
	    ref: 'refQuillEditor_' + _vm.quillOptions.theme,
	    staticClass: "col-md-11",
	    attrs: {
	      "id": "modeloMinutaEdicao"
	    }
	  }, [_c('quill-editor', {
	    attrs: {
	      "disabled": _vm.ehVisualizacao,
	      "theme": _vm.barra,
	      "options": _vm.quillOptions
	    },
	    model: {
	      value: (_vm.solicitacao.aditivo.conteudo),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.aditivo, "conteudo", $$v)
	      },
	      expression: "solicitacao.aditivo.conteudo"
	    }
	  })], 1)]) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.isEmpty(_vm.proposta) && _vm._.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _vm.etapa) && !_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.etapa === 'Análise' ? 'Análise da Proposta' : 'Decisão') + "\n              "), (_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('span', {
	    staticStyle: {
	      "margin-left": "30px",
	      "height": "0"
	    }
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.processarSolicitacao('SALVAR', 'sumula')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Súmula")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12"
	  }, [_c('div', {
	    ref: "decisão",
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.decisao.encaminhamento),
	      expression: "decisao.encaminhamento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": _vm.etapa === 'Análise' ? 'AUTORIZACAO' : (
	        _vm.etapa === 'Autorização' ?
	        (_vm.solicitacao.sumula.alcada.codigo === 'DIRETOR_OU_GER_SOLUCOES' ?
	          (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : 'DELIBERACAO') : (
	          _vm.etapa === 'Deliberação' ?
	          (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : (
	            _vm.etapa === 'Pendências' ? 'CONCLUSAO' : ''))),
	      "checked": _vm._q(_vm.decisao.encaminhamento, _vm.etapa === 'Análise' ? 'AUTORIZACAO' : (
	        _vm.etapa === 'Autorização' ?
	        (_vm.solicitacao.sumula.alcada.codigo === 'DIRETOR_OU_GER_SOLUCOES' ?
	          (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : 'DELIBERACAO') : (
	          _vm.etapa === 'Deliberação' ?
	          (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : (
	            _vm.etapa === 'Pendências' ? 'CONCLUSAO' : ''))))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.decisao, "encaminhamento", _vm.etapa === 'Análise' ? 'AUTORIZACAO' : (
	          _vm.etapa === 'Autorização' ?
	          (_vm.solicitacao.sumula.alcada.codigo === 'DIRETOR_OU_GER_SOLUCOES' ?
	            (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : 'DELIBERACAO') : (
	            _vm.etapa === 'Deliberação' ?
	            (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : (
	              _vm.etapa === 'Pendências' ? 'CONCLUSAO' : ''))))
	      }
	    }
	  }), _vm._v("\n                         " + _vm._s(_vm.etapa === 'Análise' ? 'Registro de Parecer' : 'Aprovar') + "\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  }), _vm._v(" "), (_vm._.includes(['DELIBERACAO', 'PENDENCIAS', 'CONCLUSAO'], _vm.decisao.encaminhamento)) ? _c('span', {
	    staticStyle: {
	      "font-weight": "normal",
	      "font-style": "italic"
	    }
	  }, [(_vm._.includes(['CONCLUSAO'], _vm.decisao.encaminhamento)) ? _c('span', [_vm._v(" (concluir e finalizar o processo)")]) : _c('span', [_vm._v(" (encaminhar para " + _vm._s(_vm.tarefaNome[_vm.decisao.encaminhamento]) + ")")])]) : _vm._e()]), _vm._v(" "), (_vm.decisao.encaminhamento === 'PENDENCIAS' || _vm.decisao.encaminhamento === 'DELIBERACAO') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa_aprovacao"
	    }
	  }, [_vm._v("Observação Opcional:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.decisao.observacao),
	      expression: "decisao.observacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao_aprovacao",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.decisao.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.decisao, "observacao", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), ((_vm.etapa === 'Análise' && _vm.decisao.encaminhamento === 'AUTORIZACAO')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "sumula_formulario"
	  }, [_vm._l((_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
	    return !_vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
	  })), function(pergunta, idx) {
	    return _c('tr', {
	      staticClass: "sumula_pergunta"
	    }, [_c('td', {
	      staticClass: "sumula_codigo"
	    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', {
	      staticClass: "sumula_questao"
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(pergunta.questao)
	      }
	    }), _vm._v(" "), (!_vm.loading.ocorrencias && _vm._.includes(['Q005'], pergunta.codigo)) ? _c('span', {
	      staticClass: "link_acesso pad10",
	      on: {
	        "click": function($event) {
	          return _vm.executarRegrasQuestoes([pergunta.codigo], 'ATUALIZA_CONSULTA')
	        }
	      }
	    }, [_vm._v("atualiza!")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "sumula_resposta"
	    }, [_c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (pergunta.resposta),
	        expression: "pergunta.resposta"
	      }],
	      attrs: {
	        "value": "sim",
	        "type": "radio",
	        "name": 'respostaSumulaQuestao' + pergunta.codigo
	      },
	      domProps: {
	        "checked": _vm._q(pergunta.resposta, "sim")
	      },
	      on: {
	        "change": [function($event) {
	          return _vm.$set(pergunta, "resposta", "sim")
	        }, function($event) {
	          return _vm.executarRegrasQuestoes([pergunta.codigo])
	        }]
	      }
	    }), _vm._v(" Sim")]), _vm._v(" "), _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (pergunta.resposta),
	        expression: "pergunta.resposta"
	      }],
	      attrs: {
	        "value": "nao",
	        "type": "radio",
	        "name": 'respostaSumulaQuestao' + pergunta.codigo
	      },
	      domProps: {
	        "checked": _vm._q(pergunta.resposta, "nao")
	      },
	      on: {
	        "change": [function($event) {
	          return _vm.$set(pergunta, "resposta", "nao")
	        }, function($event) {
	          return _vm.executarRegrasQuestoes([pergunta.codigo])
	        }]
	      }
	    }), _vm._v(" Não")]), _vm._v(" "), _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (pergunta.resposta),
	        expression: "pergunta.resposta"
	      }],
	      attrs: {
	        "value": "pre",
	        "type": "radio",
	        "name": 'respostaSumulaQuestao' + pergunta.codigo
	      },
	      domProps: {
	        "checked": _vm._q(pergunta.resposta, "pre")
	      },
	      on: {
	        "change": [function($event) {
	          return _vm.$set(pergunta, "resposta", "pre")
	        }, function($event) {
	          return _vm.executarRegrasQuestoes([pergunta.codigo])
	        }]
	      }
	    }), _vm._v(" Prej.")])])])
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "sumula_cabecalho_questoes"
	  }, [_c('td', {
	    staticClass: "sumula_codigo"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td', {
	    ref: "parceriaEstrategica",
	    staticClass: "sumula_resposta"
	  }, [_c('span', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('parceriaEstrategica')
	    }
	  }, [_c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.solicitacao.sumula.parceriaEstrategica),
	      expression: "solicitacao.sumula.parceriaEstrategica"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "value": "sim",
	      "type": "radio",
	      "name": "parceriaEstrategica"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.solicitacao.sumula.parceriaEstrategica, "sim")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.solicitacao.sumula, "parceriaEstrategica", "sim")
	      }
	    }
	  }), _vm._v(" Sim")]), _vm._v(" "), _c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.solicitacao.sumula.parceriaEstrategica),
	      expression: "solicitacao.sumula.parceriaEstrategica"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "value": "nao",
	      "type": "radio",
	      "name": "parceriaEstrategica"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.solicitacao.sumula.parceriaEstrategica, "nao")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.solicitacao.sumula, "parceriaEstrategica", "nao")
	      }
	    }
	  }), _vm._v(" Não")])]), _vm._v(" "), (_vm.errors.first('parceriaEstrategica')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Selecione uma opção")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
	    return _vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
	  })), function(pergunta, idx) {
	    return (_vm.solicitacao.sumula.parceriaEstrategica === 'sim') ? _c('tr', {
	      staticClass: "sumula_pergunta"
	    }, [_c('td', {
	      staticClass: "sumula_codigo"
	    }, [_vm._v(_vm._s(idx + (_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
	      return !_vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
	    })).length + 1))]), _vm._v(" "), _c('td', {
	      staticClass: "sumula_questao",
	      domProps: {
	        "innerHTML": _vm._s(pergunta.questao)
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "sumula_resposta"
	    }, [_c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (pergunta.resposta),
	        expression: "pergunta.resposta"
	      }],
	      attrs: {
	        "value": "sim",
	        "type": "radio",
	        "name": 'respostaSumulaQuestao' + pergunta.codigo
	      },
	      domProps: {
	        "checked": _vm._q(pergunta.resposta, "sim")
	      },
	      on: {
	        "change": [function($event) {
	          return _vm.$set(pergunta, "resposta", "sim")
	        }, function($event) {
	          return _vm.executarRegrasQuestoes([pergunta.codigo])
	        }]
	      }
	    }), _vm._v(" Sim")]), _vm._v(" "), _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (pergunta.resposta),
	        expression: "pergunta.resposta"
	      }],
	      attrs: {
	        "value": "nao",
	        "type": "radio",
	        "name": 'respostaSumulaQuestao' + pergunta.codigo
	      },
	      domProps: {
	        "checked": _vm._q(pergunta.resposta, "nao")
	      },
	      on: {
	        "change": [function($event) {
	          return _vm.$set(pergunta, "resposta", "nao")
	        }, function($event) {
	          return _vm.executarRegrasQuestoes([pergunta.codigo])
	        }]
	      }
	    }), _vm._v(" Não")]), _vm._v(" "), _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (pergunta.resposta),
	        expression: "pergunta.resposta"
	      }],
	      attrs: {
	        "value": "pre",
	        "type": "radio",
	        "name": 'respostaSumulaQuestao' + pergunta.codigo
	      },
	      domProps: {
	        "checked": _vm._q(pergunta.resposta, "pre")
	      },
	      on: {
	        "change": [function($event) {
	          return _vm.$set(pergunta, "resposta", "pre")
	        }, function($event) {
	          return _vm.executarRegrasQuestoes([pergunta.codigo])
	        }]
	      }
	    }), _vm._v(" Prej.")])])]) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "sumula_cabecalho_questoes"
	  }, [_c('td', {
	    staticClass: "sumula_codigo"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('td', {
	    ref: "ajusteQuantidade",
	    staticClass: "sumula_resposta"
	  }, [_c('span', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('parceriaEstrategica')
	    }
	  }, [_c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade),
	      expression: "solicitacao.sumula.resumoAlteracoes.ajusteQuantidade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "value": "1",
	      "type": "radio",
	      "name": "ajusteQuantidade"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "ajusteQuantidade", "1")
	      }
	    }
	  }), _vm._v(" Sim")]), _vm._v(" "), _c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade),
	      expression: "solicitacao.sumula.resumoAlteracoes.ajusteQuantidade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "value": "0",
	      "type": "radio",
	      "name": "ajusteQuantidade"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade, "0")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "ajusteQuantidade", "0")
	      }
	    }
	  }), _vm._v(" Não")])]), _vm._v(" "), (_vm.errors.first('ajusteQuantidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Indique se houve esse ajuste")]) : _vm._e()])]), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, [_vm.nome, 'REMANEJAMENTO'])) ? _c('tr', {
	    staticClass: "sumula_cabecalho_questoes"
	  }, [_c('td', {
	    staticClass: "sumula_codigo"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('td', {
	    ref: "percentualRemanejamentosConcedidos",
	    staticClass: "sumula_resposta"
	  }, [_c('span', {
	    staticClass: "indicadores-cb-inline",
	    staticStyle: {
	      "display": "flex",
	      "align-items": "center"
	    }
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('percentualRemanejamentosConcedidos')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos),
	      expression: "solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:0|max:100'),
	      expression: "'required|min:0|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "value": "0",
	      "type": "number",
	      "name": "percentualRemanejamentosConcedidos",
	      "min": "0",
	      "max": "100"
	    },
	    domProps: {
	      "value": (_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "percentualRemanejamentosConcedidos", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v("%")])]), _vm._v(" "), (_vm.errors.first('percentualRemanejamentosConcedidos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Percentual deve estar entre 0 e 100")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, [_vm.nome, 'SUPLEMENTACAO'])) ? _c('tr', {
	    staticClass: "sumula_cabecalho_questoes"
	  }, [_c('td', {
	    staticClass: "sumula_codigo"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('td', {
	    ref: "enquadramentoOrcamentarioFEP",
	    staticClass: "sumula_resposta"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.solicitacao.sumula.resumoAlteracoes.enquadramentoOrcamentarioFEP),
	      expression: "solicitacao.sumula.resumoAlteracoes.enquadramentoOrcamentarioFEP"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "value": "0",
	      "type": "number",
	      "name": "enquadramentoOrcamentarioFEP"
	    },
	    domProps: {
	      "value": (_vm.solicitacao.sumula.resumoAlteracoes.enquadramentoOrcamentarioFEP)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "enquadramentoOrcamentarioFEP", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('tr', {
	    staticClass: "sumula_cabecalho_questoes"
	  }, [_c('td', {
	    staticClass: "sumula_codigo"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "sumula_questao",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('label', {
	    staticClass: "control-label pull-left"
	  }, [_vm._v("Outras alterações")]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right",
	    staticStyle: {
	      "width": "80%",
	      "margin-right": "-10px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.solicitacao.sumula.resumoAlteracoes.outrasAlteracoes),
	      expression: "solicitacao.sumula.resumoAlteracoes.outrasAlteracoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "value": "",
	      "type": "text",
	      "name": "outrasAlteracoes"
	    },
	    domProps: {
	      "value": (_vm.solicitacao.sumula.resumoAlteracoes.outrasAlteracoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "outrasAlteracoes", $event.target.value)
	      }
	    }
	  })])])])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    ref: "sumula_contexto",
	    staticClass: "col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('sumula_contexto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Contexto:")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": 'Informe o Contexto da análise ref. este ID ' + _vm.id,
	      "min-height": 72,
	      "autosize": true,
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
	      "name": "sumula_contexto",
	      "rows": "3"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.solicitacao.sumula.textoContexto),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.sumula, "textoContexto", $$v)
	      },
	      expression: "solicitacao.sumula.textoContexto"
	    }
	  }), _vm._v(" "), (_vm.errors.first('sumula_contexto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Informe o contexto da análise")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    ref: "sumula_situacao_problema",
	    staticClass: "col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('sumula_situacao_problema')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Situação Problema:")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": 'Informe a Situação Problema que será analisada ref. este ID ' + _vm.id,
	      "min-height": 72,
	      "autosize": true,
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
	      "name": "sumula_situacao_problema",
	      "rows": "3"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.solicitacao.sumula.textoSituacaoProblema),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.sumula, "textoSituacaoProblema", $$v)
	      },
	      expression: "solicitacao.sumula.textoSituacaoProblema"
	    }
	  }), _vm._v(" "), (_vm.errors.first('sumula_situacao_problema')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Descreva a situação problema para esta solicitação")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    ref: "sumula_parecer",
	    staticClass: "col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('sumula_parecer')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Parecer:")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": 'Informe o Parecer para deliberação ref. este ID ' + _vm.id,
	      "min-height": 72,
	      "autosize": true,
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
	      "name": "sumula_parecer",
	      "rows": "3"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.solicitacao.sumula.textoParecer),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.sumula, "textoParecer", $$v)
	      },
	      expression: "solicitacao.sumula.textoParecer"
	    }
	  }), _vm._v(" "), (_vm.errors.first('sumula_parecer')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Informe o parecer desta análise")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    ref: "sumula_proposta",
	    staticClass: "col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('sumula_proposta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Proposta:")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": 'Informe sua proposta para deliberação ref. este ID ' + _vm.id,
	      "min-height": 72,
	      "autosize": true,
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
	      "name": "sumula_proposta",
	      "rows": "3"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.solicitacao.sumula.textoProposta),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.sumula, "textoProposta", $$v)
	      },
	      expression: "solicitacao.sumula.textoProposta"
	    }
	  }), _vm._v(" "), (_vm.errors.first('sumula_proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Informe a proposta para a solicitação")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    ref: "providencias",
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Providências:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaProvidencias,
	      "multiple": true,
	      "close-on-select": false,
	      "placeholder": 'Selecione uma ou mais providências para efetivação desta solicitação ID ' + _vm.id,
	      "track-by": "codigo",
	      "custom-label": function (option) {
	        return ("" + (option.descricao))
	      },
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "providencias",
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	    },
	    model: {
	      value: (_vm.solicitacao.sumula.providencias),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.sumula, "providencias", $$v)
	      },
	      expression: "solicitacao.sumula.providencias"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("Nenhum registro localizado!")])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    ref: "alcada",
	    staticClass: "col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('alcada')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Alçada:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaAlcadas,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": 'Selecione a alçada para esta solicitação ID ' + _vm.id,
	      "track-by": "codigo",
	      "custom-label": function (option) {
	        return ("" + (option.descricao))
	      },
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "alcada",
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	    },
	    model: {
	      value: (_vm.solicitacao.sumula.alcada),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.sumula, "alcada", $$v)
	      },
	      expression: "solicitacao.sumula.alcada"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("Nenhum registro localizado!")])])]), _vm._v(" "), (_vm.errors.first('alcada')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve selecionar a alçada")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    ref: "motivo alteracao",
	    staticClass: "col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('motivo alteracao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Motivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [(_vm.loading.motivosSolicitacao) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando lista de motivos para este conjunto de alterações...")]) : _c('span', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.motivosSolicitacao,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": 'Selecione um enquadramento para as alterações dessa solicitação ID ' + _vm.id,
	      "track-by": "codigo",
	      "custom-label": function (option) {
	        return ("" + (option.descricao))
	      },
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "motivo alteracao",
	      "data-vv-as": "Motivo da alteração",
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.solicitacao.motivoAlteracao),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao, "motivoAlteracao", $$v)
	      },
	      expression: "solicitacao.motivoAlteracao"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("Nenhum registro localizado!")])])]), _vm._v(" "), (_vm.errors.first('motivo alteracao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve selecionar um motivo para este conjunto de alterações")]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa) && _vm.decisao.encaminhamento === 'CONCLUSAO')) ? _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [(_vm._.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "control-label",
	    attrs: {
	      "title": '<h5>Observação opcional. Algo escrito aqui ficará no histórico público do processo</h5>'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle text-muted"
	  }), _vm._v(" Observação:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.decisao.observacao),
	      expression: "decisao.observacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao_decisao",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.decisao.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.decisao, "observacao", $event.target.value)
	      }
	    }
	  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm._.includes(['Pendências'], _vm.etapa)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.decisao.encaminhamento),
	      expression: "decisao.encaminhamento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "AUTORIZACAO",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.decisao.encaminhamento, "AUTORIZACAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.decisao, "encaminhamento", "AUTORIZACAO")
	      }
	    }
	  }), _vm._v(" " + _vm._s('Devolver para autorização') + "\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.decisao.encaminhamento),
	      expression: "decisao.encaminhamento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "ANALISE",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.decisao.encaminhamento, "ANALISE")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.decisao, "encaminhamento", "ANALISE")
	      }
	    }
	  }), _vm._v(" " + _vm._s('Devolver para ajuste do analista') + "\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.decisao.encaminhamento === 'ANALISE') ? _c('div', {
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('justificativa reanalise')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa_reanalise"
	    }
	  }, [_vm._v("Motivo para reanalisar:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.decisao.observacao),
	      expression: "decisao.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa reanalise",
	      "rows": "3",
	      "id": "justificativa_reanalise",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.decisao.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.decisao, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa reanalise')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa reanalise')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.etapa === 'Análise') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.decisao.encaminhamento),
	      expression: "decisao.encaminhamento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "REVISAO",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.decisao.encaminhamento, "REVISAO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.decisao, "encaminhamento", "REVISAO")
	      }
	    }
	  }), _vm._v(" Devolver para revisão da entidade\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.decisao.encaminhamento === 'REVISAO') ? _c('div', {
	    ref: "motivo de devolucao",
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('motivo de devolucao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listMotivosDevolucao,
	      "multiple": true,
	      "close-on-select": true,
	      "placeholder": "Selecione um ou mais motivos para Devolução da solicitação à entidade",
	      "custom-label": function (option) {
	        return ("" + (option.descricao))
	      },
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "motivo de devolucao",
	      "data-vv-as": "motivo de devolucao",
	      "option-height": 30,
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.solicitacao.motivosDevolucao),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao, "motivosDevolucao", $$v)
	      },
	      expression: "solicitacao.motivosDevolucao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.decisao.encaminhamento === 'REVISAO') ? _c('div', {
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Observação para revisão:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.decisao.observacao),
	      expression: "decisao.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "motivo para revisão",
	    staticClass: "form-control",
	    attrs: {
	      "name": "motivo para revisão",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.decisao.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.decisao, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('motivo para revisão')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo para revisão')))]) : _vm._e()]) : _vm._e()])])]) : _vm._e()])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('dialog', {
	    ref: "alertaCancelamentoDialog",
	    attrs: {
	      "id": "alertaCancelamentoDialog"
	    }
	  }, [_vm._m(11), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin": "25px 0"
	    }
	  }, [_vm._v("\n      Confirma o cancelamento da solicitação de alteração?\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Justificativa (obrigatório)\n    ")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.justificativaCancelamento),
	      expression: "justificativaCancelamento"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border": "none",
	      "padding": "10px",
	      "margin": "0 0 10px 0",
	      "color": "#222"
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Escreva a justificativa (min. 10 caracteres)"
	    },
	    domProps: {
	      "value": (_vm.justificativaCancelamento)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.justificativaCancelamento = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-neutral",
	    staticStyle: {
	      "margin": "0 10px"
	    },
	    attrs: {
	      "onclick": "alertaCancelamentoDialog.close()"
	    }
	  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "disabled": _vm.justificativaCancelamento.length < 10
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelarProcesso()
	      }
	    }
	  }, [_vm._v("Sim, cancelar o processo")])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando histórico de alterações em períodos de execução do projeto...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', [_vm._v("Etapa")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "120px"
	    }
	  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Usuário")]), _vm._v(" "), _c('th', [_vm._v("Observação")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "sumula_questao"
	  }, [_c('label', [_vm._v("Parceria Estratégica?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "sumula_questao"
	  }, [_c('label', [_vm._v("Houve ajustes nas quantidades dos itens de despesa?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "sumula_questao"
	  }, [_c('label', [_vm._v("Percentual dos Remanejamentos Concedidos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "sumula_questao"
	  }, [_c('label', [_vm._v("Enquadramento orçamentário (FEP)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('h4', {
	    staticClass: "box-title"
	  }, [_vm._v(" Análise:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("Atenção!")])])
	}]}

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Validação de Parceiro Estratégico")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Aprovação de Parceiro Estratégico',
	        href: '#'
	      }, {
	        text: 'Primeira Aprovação',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "validaProp"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroPre"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'primeira'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'primeira'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Primeira Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPrimeiraAprov))])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.faseAtual === 'segunda'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'segunda'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-peace-o"
	  }), _vm._v("Segunda Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesSegundaAprov))])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.faseAtual === 'finalizada'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'finalizada'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-flag-checkered"
	  }), _vm._v("Finalizadas "), _c('span', {
	    staticClass: "badge"
	  }, [_vm._v(_vm._s(_vm.quantidadesFinalizadas))])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.descricaoFase))]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative"
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative",
	      "margin-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('div', {
	    staticClass: "mailbox-controls"
	  }, [(_vm.faseAtual !== 'finalizada') ? _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.favorite = !_vm.filtro.favorite
	      }
	    },
	    model: {
	      value: (_vm.filtro.favorite),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "favorite", $$v)
	      },
	      expression: "filtro.favorite"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
	      }
	    },
	    model: {
	      value: (_vm.filtro.userId),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "userId", $$v)
	      },
	      expression: "filtro.userId"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSearch
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  })]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "favorite",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onFavorite(row.item)
	            }
	          }
	        })]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "userName",
	      fn: function(row) {
	        return [(row.value) ? _c('span', {
	          staticStyle: {
	            "font-weight": "bold"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('div', {
	          staticClass: "btn-group"
	        }, [_c('button', {
	          staticClass: "btn btn-default",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ellipsis-h"
	        })]), _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu dropdown-menu-right",
	          attrs: {
	            "role": "menu",
	            "aria-labelledby": "new-register"
	          }
	        }, [_c('li', [_c('a', {
	          attrs: {
	            "href": "#"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ver mais")])]), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssignAndDo(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onUnassign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user-times",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', {
	          staticClass: "divider",
	          attrs: {
	            "role": "separator"
	          }
	        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: _vm.rota1,
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-play-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo da conta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Tipo da Conta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    attrs: {
	      "options": _vm.tiposConta,
	      "multiple": false,
	      "close-on-select": true,
	      "preselect-first": true,
	      "allow-empty": false,
	      "custom-label": _vm.tipoContaNome,
	      "placeholder": "Selecione um tipo de conta",
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "name": "tipo da conta",
	      "data-vv-as": "tipo da conta",
	      "disabled": _vm.$attrs.disabled
	    },
	    on: {
	      "select": _vm.selecionaTipoConta
	    },
	    model: {
	      value: (_vm.tipoContaSelecionado),
	      callback: function($$v) {
	        _vm.tipoContaSelecionado = $$v
	      },
	      expression: "tipoContaSelecionado"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('tipo da conta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('tipo da conta')))]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), (_vm.telaProjeto && _vm.definicoes.length === 0) ? _c('div', [_vm._m(0)]) : _c('div', {
	    staticClass: "publico-alvo-previsto-container"
	  }, [_c('div', {
	    staticClass: "publico-alvo-descritivo"
	  }, [_vm._v("\n      Descrição de Público-alvo.\n      "), (!_vm.editar && _vm.permiteEditar && !_vm.telaProjeto) ? _c('g-button-moema', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n        Alterar")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "publico-alvo-content"
	  }, [_c('div', {
	    staticClass: "publico-alvo-definicao-container"
	  }, _vm._l((_vm.definicaoPublicoAlvo), function(item, index) {
	    return (!(item.tipo === 'Sociedade em geral' && _vm.telaParticipante)) ? _c('div', {
	      staticClass: "publico-alvo-item-container",
	      class: {
	        'adjust-height': item.aberto
	      },
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.toogleItem(index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "publico-alvo-titulo",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.toogleItem(index)
	        }
	      }
	    }, [_c('strong', [_vm._v(_vm._s(item.tipo))]), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-caret-right",
	      class: {
	        'rotate-icon': item.aberto
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]), _vm._v(" "), (item.aberto) ? _c('div', {
	      staticClass: "divider",
	      class: {
	        'show-item': item.aberto
	      }
	    }) : _vm._e(), _vm._v(" "), (item.aberto) ? _c('div', {
	      staticClass: "publico-alvo-content-container"
	    }, _vm._l((item.subgrupos), function(detalhamento) {
	      return (item.aberto) ? _c('div', {
	        staticClass: "publico-alvo-items",
	        class: {
	          'show-item': item.aberto
	        },
	        attrs: {
	          "title": detalhamento.descricao
	        }
	      }, [_c('label', {
	        staticClass: "conjunto-item"
	      }, [_vm._v("\n                " + _vm._s(detalhamento.subgrupo) + " "), _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (detalhamento.selecionado),
	          expression: "detalhamento.selecionado"
	        }],
	        staticClass: "publico-check",
	        attrs: {
	          "disabled": !_vm.editar,
	          "type": "checkbox"
	        },
	        domProps: {
	          "checked": Array.isArray(detalhamento.selecionado) ? _vm._i(detalhamento.selecionado, null) > -1 : (detalhamento.selecionado)
	        },
	        on: {
	          "change": [function($event) {
	            var $$a = detalhamento.selecionado,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = null,
	                $$i = _vm._i($$a, $$v);
	              if ($$el.checked) {
	                $$i < 0 && (_vm.$set(detalhamento, "selecionado", $$a.concat([$$v])))
	              } else {
	                $$i > -1 && (_vm.$set(detalhamento, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	              }
	            } else {
	              _vm.$set(detalhamento, "selecionado", $$c)
	            }
	          }, function($event) {
	            return _vm.updateSelecao(detalhamento.id, detalhamento.selecionado, item.tipo)
	          }]
	        }
	      })])]) : _vm._e()
	    }), 0) : _vm._e()]) : _vm._e()
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "publico-alvo-acoes-container"
	  }, [(_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar Edição")]) : _vm._e(), _vm._v(" "), (_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.limparSelecao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")]) : _vm._e(), _vm._v(" "), (_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarSelecao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n        Salvar")]) : _vm._e()], 1)]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "publico-alvo-descritivo"
	  }, [_vm._v("Sem dados cadastrados de público-alvo "), _c('strong', [_vm._v("previsto")]), _vm._v(".")])
	}]}

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de pessoa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "tipo de pessoa"
	    }
	  }, [_vm._v("Tipo de pessoa:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 "
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.tipoFornecedor),
	      expression: "nota.tipoFornecedor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "tipo de pessoa",
	      "name": "tipo de pessoa"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "tipoFornecedor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.bloqueiaCampos = 0, _vm.nota.nomeFornecedor = '', _vm.nota.cepFornecedor = '', _vm.nota.enderecoFornecedor = ''
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Pessoa Física"
	    }
	  }, [_vm._v("Pessoa Física")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Pessoa Jurídica"
	    }
	  }, [_vm._v("Pessoa Jurídica")])])]), _vm._v(" "), (_vm.errors.first('tipo de pessoa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de pessoa')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 "
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.nomeFornecedor),
	      expression: "nota.nomeFornecedor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "nome",
	      "disabled": _vm.bloqueiaCampos === 1,
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.nota.nomeFornecedor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "nomeFornecedor", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field row",
	    class: {
	      'has-error': _vm.errors.first('cep')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cep"
	    }
	  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 "
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cep",
	      "name": "cep",
	      "mask": ['#####-###'],
	      "disabled": _vm.bloqueiaCampos === 1
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.loadCityAndState($event)
	      }
	    },
	    model: {
	      value: (_vm.nota.cepFornecedor),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "cepFornecedor", $$v)
	      },
	      expression: "nota.cepFornecedor"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()]), _vm._v(" "), (_vm.nota.cepFornecedor) ? _c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "padding": "7px"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.nota.cidadeFornecedor) + " " + _vm._s((_vm.nota.estadoFornecedor) ? '/ ' + _vm.nota.estadoFornecedor : '') + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.nota.tipoFornecedor === 'Pessoa Jurídica') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpj')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cnpj"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cnpj'),
	      expression: "'required|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cnpj",
	      "disabled": _vm.bloqueiaCampos === 1,
	      "name": "cnpj",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens,
	      "type": "text"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.onBlurCpfCnpj(_vm.nota.cnpjFornecedor)
	      }
	    },
	    model: {
	      value: (_vm.nota.cnpjFornecedor),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "cnpjFornecedor", $$v)
	      },
	      expression: "nota.cnpjFornecedor"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cnpj')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nota.tipoFornecedor === 'Pessoa Física') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cpf"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 "
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cpf",
	      "name": "cpf",
	      "disabled": _vm.bloqueiaCampos === 1,
	      "mask": ['###.###.###-##'],
	      "type": "text"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.onBlurCpfCnpj(_vm.nota.cpfFornecedor)
	      }
	    },
	    model: {
	      value: (_vm.nota.cpfFornecedor),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "cpfFornecedor", $$v)
	      },
	      expression: "nota.cpfFornecedor"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('endereço')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "endereço"
	    }
	  }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 "
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.enderecoFornecedor),
	      expression: "nota.enderecoFornecedor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "endereço",
	      "disabled": _vm.bloqueiaCampos === 1,
	      "name": "endereço",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.nota.enderecoFornecedor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "enderecoFornecedor", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('endereço ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço')))]) : _vm._e()])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Fornecedor")])])
	}]}

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": _vm.titulo
	    }
	  }), _vm._v(" "), _c('div', {}, [_c('section', {
	    staticClass: "content-header "
	  }, [(!_vm.editavel || _vm.editando === '') ? _c('h1', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticStyle: {
	      "display": "flex"
	    },
	    attrs: {
	      "title": _vm.$route.params.numero + ' - ' + _vm.proposta.ds_nome
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "max-width": "60%",
	      "white-space": "nowrap",
	      "overflow": "hidden",
	      "text-overflow": "ellipsis"
	    }
	  }, [_vm._v("Projeto " + _vm._s(_vm.$route.params.numero) + " - " + _vm._s(_vm.proposta.ds_nome))]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela) ? _c('span', [_vm._v("("), _c('span', {
	    staticClass: "text-bold"
	  }, [_vm._v(_vm._s(_vm._.get(_vm.proposta, 'projetoSapiens.0.sitprj', '')))]), _vm._v(")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editavel && _vm.editando !== '') ? _c('h1', [_vm._v("Alterando " + _vm._s(_vm.editando.replace('_', ' ')) + "\n          "), (_vm.editando !== 'periodo_projeto') ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }]
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.permiteConcluir(_vm.editando)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelar(_vm.editando)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm._.find(_vm.mostrar, function(k) {
	    return k === true
	  })) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-caret-down opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Abre todas as seções</h5>'
	    },
	    on: {
	      "click": function($event) {
	        Object.keys(_vm.mostrar).forEach(function (m) {
	          _vm.mostrar[m] = true
	        });
	        _vm.$refs['proposta'].scrollIntoView()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.mostrar, function(k) {
	    return k === true
	  })) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-caret-up opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Fecha todas as seções</h5>'
	    },
	    on: {
	      "click": function($event) {
	        Object.keys(_vm.mostrar).forEach(function (m) {
	          _vm.mostrar[m] = false
	        });
	        _vm.$refs['proposta'].scrollIntoView()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-angle-double-up opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Vai para o topo da página</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs['topo'].scrollIntoView()
	      }
	    }
	  }), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-print opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>248 - Monitoramento Administrativo (PDF)</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.emitir(248)
	      }
	    }
	  }, [_c('span', [_vm._v("Monitoramento Administrativo")])]) : _vm._e(), _vm._v(" "), (this.ehParceiroEstrategico) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-print opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>292 - Prestação de Contas de Parcerias Estratégicas (PDF)</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.emitir(292)
	      }
	    }
	  }, [_c('span', [_vm._v("Prestação de Contas")])]) : _vm._e(), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-print opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": this.$root.isFundacao(this.usuarioLogado) ? '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>' : '<h5>Extrato de Projeto (PDF)</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.emitir(525, 'S')
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(this.$root.isFundacao(this.usuarioLogado) ? 'Extrato Analítico' : 'Extrato de Projeto'))])]), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-print opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.emitir(525, 'N')
	      }
	    }
	  }, [_c('span', [_vm._v("Extrato Sintético")])]) : _vm._e(), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-print opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.emitir(219)
	      }
	    }
	  }, [_c('span', [_vm._v("Adiantamentos")])]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-external-link opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Abrirá a tela de Relatórios de Execução desse projeto</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'visualiza-relatorio-execucao',
	          params: {
	            id: _vm.projeto.proposta.projeto.id
	          }
	        })
	      }
	    }
	  }, [_c('span', [_vm._v("Relatórios de Execução")])]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela && !_vm.ehParceiroEstrategico),
	      expression: "!loading.tela && !ehParceiroEstrategico"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-external-link opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Vai para tela de Alterações deste Projeto</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'solicitacao-alteracoes-projeto',
	          params: {
	            numero: _vm.proposta.ds_codigo_projeto_erp
	          }
	        })
	      }
	    }
	  }, [_c('span', [_vm._v("Alterações de Projeto")])]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Projeto',
	        href: '#'
	      }, {
	        text: String(_vm.$route.params.numero),
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    ref: "topo",
	    staticClass: "content projetoAprovado"
	  }, [_c('br'), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('visualiza-timeline', {
	    attrs: {
	      "numeroProjeto": _vm.$route.params.numero,
	      "atualizar": _vm.atualizar_timeline
	    },
	    on: {
	      "idAcompanhamento": function($event) {
	        _vm.filtro_acompanhamento = $event
	      },
	      "idAlteracoes": function($event) {
	        _vm.filtro_alteracoes = $event
	      }
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
	    ref: "ocorrencias",
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.ocorrencias = !(_vm.mostrar.ocorrencias)
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.ocorrencias ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocorrências do Projeto ")])])]), _vm._v(" "), (_vm.mostrar.ocorrencias) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('edita-ocorrencias', {
	    attrs: {
	      "numeroProjeto": _vm.$route.params.numero,
	      "itensLayout": ['botaoNovo', 'botaoExportarExcel', 'filtroNivelOcorrencia', 'filtroCodigoOcorrencia', 'filtroSituacaoOcorrencia', 'totalizador', 'colunaCodigo', 'colunaObservacao', 'colunaUsuarioCriador', 'colunaSituacao', 'colunaDataCriacao', 'colunaAcoes']
	    },
	    on: {
	      "acaoOcorrencia": function($event) {
	        _vm.ocorrenciaSelecionada = $event
	      },
	      "acaoProcessamento": function($event) {
	        _vm.loading = true
	      },
	      "acaoAguardando": function($event) {
	        _vm.loading = false
	      },
	      "acaoCancelar": function($event) {
	        _vm.ocorrenciaSelecionada.id = null
	      },
	      "acaoOk": function($event) {
	        _vm.loading = false
	      }
	    }
	  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
	    ref: "alteracoes"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.alteracoes = !_vm.mostrar.alteracoes
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.alteracoes ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Alterações no Projeto")])])]), _vm._v(" "), (_vm.mostrar.alteracoes) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('alteracoesProjetos', {
	    attrs: {
	      "ParmProjetos": _vm.projeto,
	      "ParmAlteracao": _vm.atProp,
	      "filtro": _vm.filtro_alteracoes
	    },
	    on: {
	      "atualizarTimeline": function($event) {
	        _vm.atualizar_timeline = $event
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
	    ref: "opcoesProjeto"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        return _vm.toggleOpcoesProjeto()
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.opcoesProjeto ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Opções das alterações do projeto")])])]), _vm._v(" "), (_vm.mostrar.opcoesProjeto) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Passíveis de solicitação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-11"
	  }, [_c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.opcoes.alteracoesPermitidas),
	      expression: "proposta.opcoes.alteracoesPermitidas"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "periodoProjeto"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "periodoProjeto") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "periodoProjeto",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
	        }
	      }, function($event) {
	        return _vm.atualizaOpcoesAlteracoes()
	      }]
	    }
	  }), _vm._v(" Prorrogação de Prazo"), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.opcoes.alteracoesPermitidas),
	      expression: "proposta.opcoes.alteracoesPermitidas"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "metas"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "metas") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "metas",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
	        }
	      }, function($event) {
	        return _vm.atualizaOpcoesAlteracoes()
	      }]
	    }
	  }), _vm._v(" Metas"), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.opcoes.alteracoesPermitidas),
	      expression: "proposta.opcoes.alteracoesPermitidas"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "atividades"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "atividades") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "atividades",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
	        }
	      }, function($event) {
	        return _vm.atualizaOpcoesAlteracoes()
	      }]
	    }
	  }), _vm._v(" Atividades"), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.opcoes.alteracoesPermitidas),
	      expression: "proposta.opcoes.alteracoesPermitidas"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "remanejamento"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "remanejamento") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "remanejamento",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
	        }
	      }, function($event) {
	        return _vm.atualizaOpcoesAlteracoes()
	      }]
	    }
	  }), _vm._v(" Remanejamento"), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.opcoes.alteracoesPermitidas),
	      expression: "proposta.opcoes.alteracoesPermitidas"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "suplementacao"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "suplementacao") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "suplementacao",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
	        }
	      }, function($event) {
	        return _vm.atualizaOpcoesAlteracoes()
	      }]
	    }
	  }), _vm._v(" Suplementação"), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.opcoes.alteracoesPermitidas),
	      expression: "proposta.opcoes.alteracoesPermitidas"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "parcelasAdiantamento",
	      "disabled": _vm.proposta.adiantamentos.length === 0
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "parcelasAdiantamento") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "parcelasAdiantamento",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
	        }
	      }
	    }
	  }), _vm._v(" Parcelas de Adiantamento"), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.opcoes.alteracoesPermitidas),
	      expression: "proposta.opcoes.alteracoesPermitidas"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "municipios"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.proposta.opcoes.alteracoesPermitidas) ? _vm._i(_vm.proposta.opcoes.alteracoesPermitidas, "municipios") > -1 : (_vm.proposta.opcoes.alteracoesPermitidas)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.proposta.opcoes.alteracoesPermitidas,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "municipios",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.proposta.opcoes, "alteracoesPermitidas", $$c)
	        }
	      }, function($event) {
	        return _vm.atualizaOpcoesAlteracoes()
	      }]
	    }
	  }), _vm._v(" Municípios atendidos"), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    ref: "proposta"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-horizontal"
	  }, [(false) ? _c('div', [_vm._v("\n                   Dados do Projeto\n\n                  "), _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.mostrarRef('projeto_numero')) ? _c('div', [_c('div', [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nº do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposta.ds_codigo_projeto_erp"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_codigo_projeto_erp),
	      expression: "proposta.ds_codigo_projeto_erp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "number",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_codigo_projeto_erp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_codigo_projeto_erp", $event.target.value)
	      }
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_nome')) ? _c('div', [_c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_nome),
	      expression: "proposta.ds_nome"
	    }],
	    staticClass: "form-control col",
	    attrs: {
	      "name": "nome",
	      "data-vv-as": "Nome da Proposta",
	      "type": "text",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_nome", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439) ? _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.entidade = !_vm.mostrar.entidade
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.entidade ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Dados da Entidade")])])]), _vm._v(" "), (_vm.mostrar.entidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome da entidade")]), _vm._v(" "), _c('div', [(!_vm.ehParceiroEstrategico) ? _c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
	      "to": {
	        name: 'cadastro-entidade-visualiza',
	        params: {
	          id: _vm.proposta.entidade.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.proposta.entidade.ds_nome) + "  "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })])], 1) : _c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v("\n                           " + _vm._s(_vm.proposta.entidade.ds_nome) + "\n                        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', [(_vm.proposta.entidade.endereco) ? _c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.endereco[0].ds_rua) + ", " + _vm._s(_vm.proposta.entidade.endereco[0].ds_numero) + " -\n                          " + _vm._s(_vm.proposta.entidade.endereco[0].ds_bairro) + ", " + _vm._s(_vm.proposta.entidade.endereco[0].ds_cidade) + " - " + _vm._s(_vm.proposta.entidade.endereco[0].ds_estado))]) : _c('div', [_vm._v("Sem endereço! Verificar o cadastro da entidade")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.telefone))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)")]), _vm._v(" "), _vm._l((_vm.proposta.entidade.dirigentes), function(dirigente) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered listaDirigentes"
	    }, [_c('tbody', [_c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w30"
	    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cargo")]), _vm._v(" "), (dirigente.cargo.ds_descricao) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Final do Mandato")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_rg) + " - " + _vm._s(dirigente.ds_orgao_emissor) + "/" + _vm._s(dirigente.ds_uf))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_estado_civil))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Profissão")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_profissao))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Telefone")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("telefone")(dirigente.contato.ds_telefone)))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Endereço")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.endereco.ds_rua) + ", " + _vm._s(dirigente.endereco.ds_numero) + ", " + _vm._s(dirigente.endereco.ds_bairro) + ", " + _vm._s(dirigente.endereco.ds_complemento))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("CEP")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("cep")(dirigente.endereco.ds_cep)))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cidade/UF")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.endereco.ds_cidade) + " / " + _vm._s(dirigente.endereco.ds_uf))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.contato.ds_email))])])])])])
	  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'periodo_projeto') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.periodo = !_vm.mostrar.periodo
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.periodo ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Período de execução do projeto")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Período de execução do projeto")])])]), _vm._v(" "), (_vm.mostrar.periodo) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.mostrarRef('projeto_data_inicial')) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial")]), _vm._v(" "), (_vm.editando === 'periodo_projeto' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>(!)Data de Assinatura do Convênio <br/></h5>'
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.dt_assinatura_convenio),
	      expression: "proposta.dt_assinatura_convenio"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:' + _vm.projetoPeriodos + '|max_value:' + _vm.proposta.periodo_vigencia),
	      expression: "'required|min_value:' + projetoPeriodos + '|max_value:' + proposta.periodo_vigencia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Data Inicial do Projeto",
	      "lang": "pt-br",
	      "name": "periodo",
	      "type": "date",
	      "disabled": (_vm.editando !== 'periodo_projeto' && _vm.usuarioLogado.userType === 'FUNDACAO' || !_vm.acessoGerSolucoes)
	    },
	    domProps: {
	      "value": (_vm.proposta.dt_assinatura_convenio)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.dataFinalVigencia()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "dt_assinatura_convenio", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', {
	    staticClass: "required-field col-md-3 required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses de Execução do Projeto")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.nr_periodos),
	      expression: "proposta.nr_periodos"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:' + _vm.projetoPeriodos + '|max_value:' + _vm.proposta.periodo_vigencia),
	      expression: "'required|min_value:' + projetoPeriodos + '|max_value:' + proposta.periodo_vigencia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Número de Meses do Projeto",
	      "lang": "pt-br",
	      "name": "periodo",
	      "type": "number",
	      "min": "1",
	      "disabled": _vm.editando !== 'periodo_projeto'
	    },
	    domProps: {
	      "value": (_vm.proposta.nr_periodos)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "nr_periodos", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodos') && _vm.mostrarRef('projeto_data_inicial')) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data final de execução")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses de Vigência")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periodo_vigencia),
	      expression: "proposta.periodo_vigencia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:' + _vm.proposta.nr_periodos),
	      expression: "'required|min_value:' + proposta.nr_periodos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Período Vigência",
	      "lang": "pt-br",
	      "name": "periodoVigencia",
	      "type": "number",
	      "max": "72",
	      "min": _vm.proposta.nr_periodos,
	      "disabled": _vm.editando !== 'periodo_projeto'
	    },
	    domProps: {
	      "value": (_vm.proposta.periodo_vigencia)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.dataFinalVigencia()
	      },
	      "keyup": function($event) {
	        return _vm.dataFinalVigencia()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodos') && _vm.mostrarRef('projeto_data_inicial')) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data final da vigência")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.proposta.dt_data_vigencia, "L")))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editando === 'periodo_projeto') ? _c('div', [_c('alteracoesPeriodoExecucao', {
	    attrs: {
	      "ParmProjetos": _vm.projeto,
	      "ParmAlteracao": _vm.atProp,
	      "filtro": _vm.filtro_alteracoes,
	      "refreshTable": _vm.refreshAlteracoes,
	      "cancelar": _vm.cancelar,
	      "editando": _vm.editando,
	      "permiteConcluir": _vm.permiteConcluir,
	      "historicoAlteracaoPeriodo": _vm.historicoAlteracaoPeriodo,
	      "editandoBloco": _vm.editandoBloco,
	      "dataInicialAlteracao": _vm.proposta.dt_assinatura_convenio,
	      "nr_periodos": _vm.proposta.nr_periodos,
	      "dt_data_final": _vm.dataFinalExecucao,
	      "periodo_vigencia": _vm.proposta.periodo_vigencia,
	      "dt_data_vigencia": _vm.proposta.dt_data_vigencia
	    },
	    on: {
	      "atualizarTimeline": function($event) {
	        _vm.atualizar_timeline = $event
	      }
	    }
	  })], 1) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'carteira_projeto') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.carteira = !_vm.mostrar.carteira
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.carteira ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Carteira")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Período de execução do projeto")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'carteira_projeto' && _vm.mostrar.carteira) ? _c('span', {
	    staticClass: "opcaoAlterar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.editar('carteira_projeto')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Será possível atribuir ou alterar a carteira deste projeto (somente disponível para Fundação)</h5>'
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.carteira) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Carteira Atual")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.carteiraSelecionada),
	      expression: "carteiraSelecionada"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": !_vm.editavel || _vm.editando !== 'carteira_projeto'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.carteiraSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Não encarteirado")]), _vm._v(" "), _vm._l((_vm.listaCarteiras), function(carteira) {
	    return _c('option', {
	      domProps: {
	        "value": carteira.usu_codcart
	      }
	    }, [_vm._v(_vm._s(carteira.usu_codcart) + " - " + _vm._s(carteira.usu_nomcart))])
	  })], 2)])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.ehParceiroEstrategico) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.avaliacao = !_vm.mostrar.avaliacao
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.avaliacao ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Avaliação de Projeto")])])]), _vm._v(" "), (_vm.mostrar.avaliacao) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('avaliacoes-projeto', {
	    attrs: {
	      "numeroProjeto": _vm.$route.params.numero,
	      "editavel": _vm.editavel
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('objetivo_especifico')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.objetivos = !_vm.mostrar.objetivos
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.objetivos ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Objetivo Específico")])])]), _vm._v(" "), (_vm.mostrar.objetivos) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objetivos = $event
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('metas')) ? _c('div', {
	    ref: "metas"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.metas = !_vm.mostrar.metas
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.metas ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Metas")])])]), _vm._v(" "), (_vm.mostrar.metas) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('metas', {
	    attrs: {
	      "editavel": false,
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsMetas": _vm.proposta.metas,
	      "propsProposta": _vm.proposta,
	      "atvSemMetas": _vm.atvSemMetas
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.metas = $event
	      },
	      "validacaoMetas": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('atividades')) ? _c('div', {
	    ref: "atividades"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.atividades = !_vm.mostrar.atividades
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.atividades ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atividades")])])]), _vm._v(" "), (_vm.mostrar.atividades) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('atividades', {
	    attrs: {
	      "editavel": false,
	      "meses": _vm.proposta.nr_periodos,
	      "propsMetas": _vm.proposta.metas,
	      "propsAtividades": _vm.proposta.atividades,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "atividadeAdicionada": function($event) {
	        _vm.proposta.atividades = $event
	      },
	      "validacaoAtividades": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cronograma_fisicofinanceiro')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'cronograma') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.extratoProjeto = !_vm.mostrar.extratoProjeto
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.extratoProjeto ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Extrato do cronograma")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Extrato do cronograma")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'cronograma' && _vm.mostrar.extratoProjeto) ? _c('span', {
	    staticClass: "opcaoAlterar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.editar('cronograma')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Pode aumentar a quantidade de um item<br/>Essas alterações no SGP não alterarão o Sapiens</h5>'
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.extratoProjeto) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('extrato', {
	    key: _vm.componentKey,
	    attrs: {
	      "editavel": _vm.editavel && _vm.editando === 'cronograma',
	      "propsObjetivos": _vm.proposta.objetivos,
	      "layout": 'classico',
	      "etapa": 'VISUALIZACAO',
	      "itensLayout": ['quantidade', 'contaFinanceira', 'idItem', 'filtroItens'],
	      "propsAtividades": _vm.proposta.atividades,
	      "metas": _vm.proposta.metas,
	      "proposta": _vm.proposta,
	      "meses": _vm.proposta.nr_periodos,
	      "projetoDuplicacao": _vm.proposta.nr_projeto_duplicacao
	    },
	    on: {
	      "cronogramaAtividades": function($event) {
	        _vm.proposta.atividades = $event
	      },
	      "alteracoesCronograma": function($event) {
	        _vm.cronogramaAlteracoes = $event
	      },
	      "validacaoCronograma": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  }), _vm._v(" "), _c('acertos-financeiros', {
	    attrs: {
	      "editavel": _vm.editavel && _vm.editando === 'acertos_financeiros',
	      "numeroProjeto": this.$route.params.numero,
	      "propsAtividades": _vm.proposta.atividades
	    },
	    on: {
	      "alteracoesAcertosFinenceiros": function($event) {
	        _vm.acertosFinanceirosAlteracoes = $event
	      },
	      "validacaoAcertosFinenceiros": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  }), _vm._v(" "), (_vm.mostrarRef('gantt')) ? _c('div', [_c('visualiza-gestao-atividades', {
	    attrs: {
	      "editavel": _vm.editavel && _vm.editando === 'gantt_atividades',
	      "itensLayout": ['justificativa', 'opcoes'],
	      "propsNumeroProjeto": _vm.$route.params.numero,
	      "propsAtividades": _vm.proposta.atividades
	    },
	    on: {
	      "atividadesProposta": function($event) {
	        _vm.proposta.atividades = $event
	      },
	      "atividadesGantt": function($event) {
	        _vm.proposta.gantt_atividades = $event
	      },
	      "atividadesAlteracoes": function($event) {
	        _vm.proposta.gantt_alterado = $event
	      },
	      "validacaoAtividadesGantt": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'conta_adiantamento') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.contaAdiantamento = !_vm.mostrar.contaAdiantamento
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.contaAdiantamento ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                          Contas do Projeto")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hiden": "true"
	    }
	  }), _vm._v(" Contas do Projeto")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'conta_adiantamento' && _vm.mostrar.contaAdiantamento) ? _c('span', {
	    staticClass: "opcaoAlterar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.editar('conta_adiantamento')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>A conta de adiantamento pode ser alterada</h5>'
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.contaAdiantamento) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Agência (Para Adiantamento)")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|agency'),
	      expression: "'required|agency'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": true,
	      "name": "agencia de adiantamento",
	      "mask": ['####-X'],
	      "disabled": !_vm.editavel || _vm.editando !== 'conta_adiantamento'
	    },
	    model: {
	      value: (_vm.dadosBancariosAdiantamento.agencia),
	      callback: function($$v) {
	        _vm.$set(_vm.dadosBancariosAdiantamento, "agencia", $$v)
	      },
	      expression: "dadosBancariosAdiantamento.agencia"
	    }
	  }), _vm._v(" "), (_vm.errors.first('agencia de adiantamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia de adiantamento')) + "\n                          ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Conta de Adiantamento")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|contacorrente'),
	      expression: "'required|contacorrente'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": true,
	      "name": "conta corrente de adiantamento",
	      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X'],
	      "disabled": !_vm.editavel || _vm.editando !== 'conta_adiantamento'
	    },
	    model: {
	      value: (_vm.dadosBancariosAdiantamento.conta),
	      callback: function($$v) {
	        _vm.$set(_vm.dadosBancariosAdiantamento, "conta", $$v)
	      },
	      expression: "dadosBancariosAdiantamento.conta"
	    }
	  }), _vm._v(" "), (_vm.errors.first('conta corrente de adiantamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('conta corrente de adiantamento')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("MCI")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dadosBancariosAdiantamento.mci),
	      expression: "dadosBancariosAdiantamento.mci"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": !_vm.editavel || _vm.editando !== 'conta_adiantamento',
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.dadosBancariosAdiantamento.mci)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dadosBancariosAdiantamento, "mci", $event.target.value)
	      }, _vm.limitarDigitosMCI]
	    }
	  }), _vm._v(" "), (_vm.errors.first('conta corrente de adiantamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('mci')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.contaAdiantamento) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Agência (Conta Interna)")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|agency'),
	      expression: "'required|agency'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": true,
	      "name": "agencia de adiantamento",
	      "mask": ['####-X'],
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.agenciaContaInterna),
	      callback: function($$v) {
	        _vm.agenciaContaInterna = $$v
	      },
	      expression: "agenciaContaInterna"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Conta Interna")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|contacorrente'),
	      expression: "'required|contacorrente'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": true,
	      "name": "conta corrente de adiantamento",
	      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X'],
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.contaInterna),
	      callback: function($$v) {
	        _vm.contaInterna = $$v
	      },
	      expression: "contaInterna"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Código Fornecedor")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.codFor),
	      expression: "codFor"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.codFor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.codFor = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.proposta.intervencao_bndes) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número Intervenção BNDES")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.intervencao_bndes),
	      expression: "proposta.intervencao_bndes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.intervencao_bndes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "intervencao_bndes", $event.target.value)
	      }
	    }
	  })])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('parcelas_adiantamento')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.parcelasAdiantamento = !_vm.mostrar.parcelasAdiantamento
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.parcelasAdiantamento ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Parcelas de Adiantamento")])])]), _vm._v(" "), (_vm.mostrar.parcelasAdiantamento) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('parcela-adiantamento', {
	    attrs: {
	      "editavel": false,
	      "propsProposta": _vm.proposta,
	      "propsParcelas": _vm.proposta.adiantamentos,
	      "propsAtividades": _vm.proposta.atividades,
	      "propsLayout": 'EXECUCAO'
	    },
	    on: {
	      "parcelaAdicionada": function($event) {
	        _vm.proposta.adiantamentos = $event
	      },
	      "validacaoParcelasAdiantamento": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'publicos_alvo') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.publicoAlvo = !_vm.mostrar.publicoAlvo
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.publicoAlvo ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Público-alvo")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Público-alvo")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'publicos_alvo' && _vm.mostrar.publicoAlvo) ? _c('span', {
	    staticClass: "opcaoAlterar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.editar('publicos_alvo')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Público-alvo pode ser acrescentado, mas não alterado o que foi contratado para não divergir do informado em relatórios de atividades anteriores<br/>Ao concluir o SGP alterará o Sapiens também</h5>'
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.publicoAlvo) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('publico-alvo', {
	    attrs: {
	      "editavel": _vm.editavel && _vm.editando === 'publicos_alvo',
	      "propsPublicosGrid": _vm.proposta.publicos_alvo
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.publicos_alvo = $event
	      },
	      "validacaoPublicoAlvo": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrar.publicoAlvo) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(3), _vm._v(" "), _c('publicoAlvoDescricao', {
	    ref: "publicoAlvoDescricao",
	    attrs: {
	      "proposta": _vm.proposta.id,
	      "fixado": false,
	      "permiteEditar": true,
	      "abrirAbas": true,
	      "telaProjeto": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrar.publicoAlvo) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(4), _vm._v(" "), _c('publicoAlvoDescricaoRealizado', {
	    ref: "publicoAlvoDescricaoRealizado",
	    attrs: {
	      "proposta": _vm.proposta.id,
	      "fixado": false,
	      "abrirAbas": false
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'municipalizacao') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.tecnologiaSocial = !_vm.mostrar.tecnologiaSocial
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.tecnologiaSocial ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Tecnologia Social")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Tecnologia Social")])])]), _vm._v(" "), (_vm.mostrar.tecnologiaSocial) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('tecnologiaSocial', {
	    ref: "tecnologiaSocial",
	    attrs: {
	      "proposta": _vm.proposta.id,
	      "fk_processo": _vm.proposta.fk_processo,
	      "telaProjeto": true,
	      "ehParceiroEstrategico": _vm.ehParceiroEstrategico
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo') && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'municipalizacao') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.ods = !_vm.mostrar.ods
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.ods ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" ODS - Objetivos de Desenvolvimento Sustentável ")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" ODS - Objetivos de Desenvolvimento Sustentável")])])]), _vm._v(" "), (_vm.mostrar.ods) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('odsMarcacao', {
	    attrs: {
	      "proposta": _vm.proposta.id,
	      "telaProjeto": true
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'municipalizacao') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.licenciamentoAmbiental = !_vm.mostrar.licenciamentoAmbiental
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.licenciamentoAmbiental ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Licenciamento Ambiental ")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Licenciamento Ambiental ")])])]), _vm._v(" "), (_vm.mostrar.licenciamentoAmbiental) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('licenciamentoAmbientalProjeto', {
	    attrs: {
	      "tipoUsuario": _vm.usuarioLogado.userType,
	      "idProposta": _vm.proposta.id,
	      "numeroProjeto": this.$route.params.numero,
	      "nomeProjeto": _vm.proposta.ds_nome
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('municipios')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.municipios = !_vm.mostrar.municipios
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.municipios ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Municípios - Locais de execução")])])]), _vm._v(" "), (_vm.mostrar.municipios) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('municipalizacao', {
	    attrs: {
	      "editavel": false,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta.municipalizacao = $event
	      },
	      "validacaoMunicipio": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.editando !== 'coordenador') ? _c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.coordenador = !_vm.mostrar.coordenador
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.coordenador ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Responsável pela Proposta")]) : _c('span', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Responsável pela Proposta")])]), _vm._v(" "), (_vm.editavel && _vm.editando !== 'coordenador' && _vm.mostrar.coordenador) ? _c('span', {
	    staticClass: "opcaoAlterar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.editar('coordenador')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Alterar")]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Qualquer informação abaixo relativo ao Responsável pela Proposta pode ser alterado<br/><br/>Após Concluir, Esta alteração será enviada automaticamente ao Sapiens</h5>'
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrar.coordenador) ? _c('div', {
	    staticClass: "box-body form-group"
	  }, [(_vm.mostrarRef('coordenador_nome')) ? _c('div', {
	    staticClass: "required-field col-md-8 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_nome_coordenador),
	      expression: "proposta.ds_nome_coordenador"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "data-vv-as": "Nome do Coordenador",
	      "maxlength": "100",
	      "disabled": _vm.editando !== 'coordenador'
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_nome_coordenador)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_nome_coordenador", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_cpf')) ? _c('div', {
	    staticClass: "required-field col-md-4 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf"
	    }
	  }, [(this.$router.currentRoute.name === 'proposta-visualiza') ? _c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "data-vv-as": "CPF do Coordenador",
	      "disabled": _vm.editando !== 'coordenador',
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.ds_cpf_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_cpf_coordenador", $$v)
	      },
	      expression: "proposta.ds_cpf_coordenador"
	    }
	  }) : _vm._e(), _vm._v(" "), (this.$router.currentRoute.name !== 'proposta-visualiza') ? _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "disabled": _vm.editando !== 'coordenador',
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.ds_cpf_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_cpf_coordenador", $$v)
	      },
	      expression: "proposta.ds_cpf_coordenador"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_email')) ? _c('div', {
	    staticClass: "required-field col-md-6 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_email_coordenador),
	      expression: "proposta.ds_email_coordenador"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.editando !== 'coordenador',
	      "name": "ds_email_coordenador",
	      "type": "email",
	      "data-vv-as": "E-mail do Coordenador",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_email_coordenador)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_email_coordenador", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_telefone')) ? _c('div', {
	    staticClass: "col-md-3 required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "data-vv-as": "Telefone do Coordenador",
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "disabled": _vm.editando !== 'coordenador'
	    },
	    model: {
	      value: (_vm.proposta.ds_telefone_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_telefone_coordenador", $$v)
	      },
	      expression: "proposta.ds_telefone_coordenador"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_celular')) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "data-vv-as": "Celular do Coordenador",
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "disabled": _vm.editando !== 'coordenador'
	    },
	    model: {
	      value: (_vm.proposta.ds_celular_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_celular_coordenador", $$v)
	      },
	      expression: "proposta.ds_celular_coordenador"
	    }
	  })], 1)]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cursos')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.cursos = !_vm.mostrar.cursos
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.cursos ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cursos")])])]), _vm._v(" "), (_vm.mostrar.cursos) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.cursos
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('equipe_do_projeto')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.equipeProjeto = !_vm.mostrar.equipeProjeto
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.equipeProjeto ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Equipe do Projeto")])])]), _vm._v(" "), (_vm.mostrar.equipeProjeto) ? _c('div', {
	    staticClass: "box-body"
	  }, [(_vm.entidadeEhFundacao) ? _c('span', {
	    staticClass: "col-md-12 entidadeEhFundacao"
	  }, [_vm._v("\n                          Dispensado registro pela proponente Fundação BB\n                        ")]) : _c('span', [_c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": _vm.proposta.equipes
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.equipes = $event
	      }
	    }
	  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.informacoesProjeto = !_vm.mostrar.informacoesProjeto
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.informacoesProjeto ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Informações do Projeto")])])]), _vm._v(" "), (_vm.mostrar.informacoesProjeto) ? _c('div', {
	    staticClass: "box-body"
	  }, [(_vm.mostrarRef('informacoes_introdutorias_introducao')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "introducao",
	      "data-vv-as": "Informações Introdutórias do Projeto",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_introducao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_introducao", $$v)
	      },
	      expression: "proposta.ds_introducao"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_apresentacao')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "Apresentação do Projeto",
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_apresentacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_apresentacao", $$v)
	      },
	      expression: "proposta.ds_apresentacao"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_territorio')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "Território de Desenvolvimento do Projeto",
	      "name": "territorio",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_territorio),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_territorio", $$v)
	      },
	      expression: "proposta.ds_territorio"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_justificativa')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "Justificativa do Projeto",
	      "name": "justificativa",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_justificativa),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_justificativa", $$v)
	      },
	      expression: "proposta.ds_justificativa"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_objetivo_geral')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "Objetivo Geral do Projeto",
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_objetivo_geral),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_objetivo_geral", $$v)
	      },
	      expression: "proposta.ds_objetivo_geral"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_resultados')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "Resultados Esperados do Projeto",
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_resultados),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_resultados", $$v)
	      },
	      expression: "proposta.ds_resultados"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_operacionalizacao')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "Operacionalização do Projeto",
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_operacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_operacao", $$v)
	      },
	      expression: "proposta.ds_operacao"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_parceria')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "Parceria do Projeto",
	      "name": "Parceria",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_parceria),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_parceria", $$v)
	      },
	      expression: "proposta.ds_parceria"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_resumo')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "Resumo do Projeto",
	      "name": "sumario",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_resumo),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_resumo", $$v)
	      },
	      expression: "proposta.ds_resumo"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_acoes')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "disabled": true,
	      "data-vv-as": "indicadores",
	      "name": "acoes",
	      "rows": "4"
	    },
	    model: {
	      value: (_vm.proposta.ds_acoes_comunicacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_acoes_comunicacao", $$v)
	      },
	      expression: "proposta.ds_acoes_comunicacao"
	    }
	  })], 1)]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.analiseProjeto = !_vm.mostrar.analiseProjeto
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.analiseProjeto ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Análise do Projeto")])])]), _vm._v(" "), (_vm.mostrar.analiseProjeto) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('analise', {
	    ref: "child",
	    attrs: {
	      "propsAnalise": _vm.proposta,
	      "propsFluxo": _vm.fluxo
	    },
	    on: {
	      "analiseProposta": function($event) {
	        _vm.analise = $event
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('documentos')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.documentos = !_vm.mostrar.documentos
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.documentos ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Documentos da Proposta")])])]), _vm._v(" "), (_vm.mostrar.documentos) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.documentosProposta,
	      "documentTypes": _vm.proposta.tipoDocumentos,
	      "localUso": 'PROPOSTA_COMPLETA_DOCUMENTOS_ANEXOS',
	      "propsEtapa": _vm.nulo,
	      "ehParceiroEstrategico": _vm.ehParceiroEstrategico
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('historico')) ? _c('div', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "grupoMostrarOcultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrar.historico = !_vm.mostrar.historico
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar.historico ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Histórico")])])]), _vm._v(" "), (_vm.mostrar.historico) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta
	    },
	    on: {
	      "historico_itens": function($event) {
	        _vm.historico_atualizado = $event
	      }
	    }
	  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), ( false) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }]
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.bt_entidade_executora),
	      expression: "proposta.bt_entidade_executora"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.proposta.entityIsExecutioner === 'true',
	      "disabled": true
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.bt_entidade_executora, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "bt_entidade_executora", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                            ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.bt_entidade_executora),
	      expression: "proposta.bt_entidade_executora"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.proposta.entityIsExecutioner === 'false',
	      "disabled": true
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.bt_entidade_executora, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "bt_entidade_executora", "false")
	      }
	    }
	  }), _vm._v(" Não\n                            ")])])]), _vm._v(" "), (_vm.proposta.bt_entidade_executora === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12",
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_entidade_nome),
	      expression: "proposta.ds_entidade_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_entidade_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_entidade_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_entidade_representante_legal),
	      expression: "proposta.ds_entidade_representante_legal"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_representante_legal'),
	      expression: "'required:!proposta.ds_entidade_representante_legal'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_entidade_representante_legal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_entidade_representante_legal", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_cnpj|cnpj'),
	      expression: "'required:!proposta.ds_entidade_cnpj|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.ds_entidade_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_entidade_cnpj", $$v)
	      },
	      expression: "proposta.ds_entidade_cnpj"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12",
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_entidade_email),
	      expression: "proposta.ds_entidade_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_email|email'),
	      expression: "'required:!proposta.ds_entidade_email|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_entidade_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_entidade_email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_telefone'),
	      expression: "'required:!proposta.ds_entidade_telefone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.ds_entidade_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_entidade_telefone", $$v)
	      },
	      expression: "proposta.ds_entidade_telefone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_celular'),
	      expression: "'required:!proposta.ds_entidade_celular'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.ds_entidade_celular),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_entidade_celular", $$v)
	      },
	      expression: "proposta.ds_entidade_celular"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12",
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.estados), function(uf) {
	    return _c('option', {
	      domProps: {
	        "value": uf
	      }
	    }, [_vm._v(_vm._s(uf))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]) : _vm._e()])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Timeline")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Banco (Para Adiantamento)")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v("001 - Banco do Brasil")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Banco (Conta Interna)")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v("001 - Banco do Brasil")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Detalhamento do Público-alvo "), _c('strong', [_vm._v("Previsto")]), _vm._v(":")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Detalhamento do Público-alvo "), _c('strong', [_vm._v("Realizado")]), _vm._v(":")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	}]}

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper relatorio_execucao",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": _vm.titulo
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.modoEdicao ? 'Editando os Relatórios de Execução' : 'Relatórios de Execução') + "\n\n        "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.carregando && !_vm.loading.processando && _vm.relatorios.length > 0) ? _c('span', [(_vm.modoEdicao) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.concluirAlteracaoListaRelatorios($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelarAlteracaoListaRelatorios($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])], 1) : _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.alterarListaRelatorios($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-tasks",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Alterar Cronograma")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('g-button-moema', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5>Vai para a tela deste Projeto</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'projeto',
	          params: {
	            numero: _vm.projeto.numero
	          }
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-rocket",
	    attrs: {
	      "aria-label": "false"
	    }
	  }), _vm._v(" Projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm.relatorios.length > 0) ? _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle icone_ajuda",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Clique aqui para iniciar o tutorial</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.configuracoes.tutorial.concluido = false;
	        _vm.configuracoes.tutorial.passo = 1
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Projeto',
	        href: '#'
	      }, {
	        text: 'Relatório de execução',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [(!_vm.configuracoes.tutorial.concluido && _vm.relatorios.length > 0) ? _c('div', {
	    staticClass: "row tutorial"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('vue-slider', {
	    attrs: {
	      "min": 1,
	      "max": _vm.usuarioLogado.userType === 'FUNDACAO' ? 13 : 7,
	      "adsorb": true,
	      "marks": true,
	      "tooltip": 'none',
	      "drag-on-click": true
	    },
	    on: {
	      "drag-end": _vm.salvarConfiguracoes
	    },
	    scopedSlots: _vm._u([{
	      key: "step",
	      fn: function(ref) {
	        var label = ref.label;
	        var active = ref.active;
	
	        return [_c('div', {
	          class: ['passo', {
	            active: active
	          }]
	        })]
	      }
	    }], null, false, 1904824845),
	    model: {
	      value: (_vm.configuracoes.tutorial.passo),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracoes.tutorial, "passo", $$v)
	      },
	      expression: "configuracoes.tutorial.passo"
	    }
	  })], 1), _vm._v(" "), (_vm.configuracoes.tutorial.passo < (_vm.usuarioLogado.userType === 'FUNDACAO' ? 13 : 7)) ? _c('div', {
	    staticClass: "col-md-1 btn btn-default",
	    on: {
	      "click": function($event) {
	        _vm.configuracoes.tutorial.passo++;
	        _vm.salvarConfiguracoes()
	      }
	    }
	  }, [_vm._v("Próximo "), _c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo !== (_vm.usuarioLogado.userType === 'FUNDACAO' ? 13 : 7)) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "col-md-1 btn btn-default",
	    attrs: {
	      "title": '<h5>Ao clicar você fecha este tutorial sem concluí-lo.<br/>Para reabrí-lo basta clicar em <i class=\'fa fa-question-circle icone_ajuda\'></i> </h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.configuracoes.tutorial.concluido = true;
	        _vm.salvarConfiguracoes()
	      }
	    }
	  }, [_vm._v("Pular "), _c('i', {
	    staticClass: "fa fa-ban",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === (_vm.usuarioLogado.userType === 'FUNDACAO' ? 13 : 7)) ? _c('div', {
	    staticClass: "col-md-2 btn btn-success",
	    on: {
	      "click": function($event) {
	        _vm.configuracoes.tutorial.concluido = true;
	        _vm.salvarConfiguracoes()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Entendi"), _c('br'), _vm._v("Clique para concluir")]) : _vm._e()])]), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 1) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 2) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 3) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 4) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 5) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 6) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 7) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 8) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 9) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 10) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 11) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 12) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 13) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(13)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": _vm.blockStatusERP === true
	    }
	  }, [(_vm.configuracoes.tutorial.concluido) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.processando),
	      expression: "loading.processando"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), (_vm.loading.carregando) ? _c('span', [_vm._v("Carregando relatórios de execução...")]) : _c('span', [(_vm.relatorios.length === 0) ? _c('span', [_vm._v("Este projeto não tem Relatórios de Execução no SGP")]) : _vm._e(), _vm._v(" "), (_vm.relatorios.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.projeto.numero) + " - " + _vm._s(_vm.projeto.nome) + " "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('b', [_vm._v(_vm._s('(' + _vm.projeto.situacao_projeto + ')'))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (false) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        interactive: true,
	        theme: 'light',
	        position: 'bottom',
	        maxWidth: '600px'
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'fade', distance: '1', size: 'large', interactive: true, theme: 'light', position: 'bottom', maxWidth: '600px'}"
	    }],
	    staticClass: "legenda",
	    attrs: {
	      "title": (_vm.modoEdicao ?
	        '<table class=\'table legenda_tabela borderless\'>' +
	        '<tr><td style=\'font-weight: bold; background: #f5f5f5\'>Modo de Edição ativado:</td></tr>' +
	        '<tr><td style=\' background: #f5f5f5\'>' +
	        '<table class=\'table\'>' +
	        '<tr><td style=\'background: #fbfbff\'>Relatório que não pode ser alterados</td></tr>' +
	        '<tr><td class=\'success text-success\'>Relatório será Adicionado ao Concluir</td></tr>' +
	        '<tr><td class=\'info text-info\'>Relatório terá datas Alteradas ao Concluir</td></tr>' +
	        '<tr><td class=\'text-muted\' style=\'background: #e8e5e5\'>Relatório será Excluído ao Concluir</td></tr>' +
	        '</table>' +
	        '</td></tr>' +
	        '</table>' :
	        '<table class=\'table legenda_tabela\'>' +
	        '<tr><td style=\'background: #f0f0ff\'>Fora do período de preenchimento</td></tr>' +
	        '<tr><td style=\'background: ' + _vm.cor('pendente', 'corFundo') + '\'>No período e Pendente, em Análise ou Devolvido</td></tr>' +
	        '<tr><td style=\'background: ' + _vm.cor('aprovado', 'corFundo') + '\'>Relatório aprovado</td></tr>' +
	        '<tr><td style=\'background: ' + _vm.cor('não apresentado', 'corFundo') + '\'>Não apresentado no prazo</td></tr>' +
	        (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.configuracoes.mostrarExcluidos ? '<tr><td style=\'background: ' + _vm.cor('excluído', 'corFundo') + '\'>Reatório excluído</td></tr>' : '') +
	        '</table>'
	      )
	    }
	  }, [_vm._v("\n                    Legenda\n                  ")]) : _vm._e()]), _vm._v(" "), (_vm.modoEdicao) ? _c('span', [_c('span', {
	    staticClass: "col-md-10"
	  }, [_c('br'), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.novoRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-o",
	    attrs: {
	      "aria-label": "true"
	    }
	  }), _vm._v(" Incluir novo relatório")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [(!_vm.loading.carregando && _vm.mostrarGantt && _vm.relatorios.length > 0) ? _c('div', {
	    attrs: {
	      "id": "gantt_relatorios"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12",
	    style: ('margin-bottom: 10px; ' + (_vm.modoEdicao ? 'background: #f5f5f5;' : ''))
	  }, [_c('div', {
	    style: ('width: ' + ((_vm.projeto.dias.duracao * _vm.configuracoes.zoom) + 35) + 'px;'),
	    attrs: {
	      "id": "bloco_relatorios"
	    }
	  }, [_c('div', {
	    style: ('width: ' + ((_vm.projeto.dias.duracao * _vm.configuracoes.zoom) + 10) + 'px;'),
	    attrs: {
	      "id": "limites_projeto"
	    }
	  }, [_c('span', [_vm._v("Início em " + _vm._s(_vm.formataData(_vm.projeto.data_aprovacao_projeto)))]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_vm._v("Término em " + _vm._s(_vm.formataData(_vm.projeto.data_final_projeto)))])]), _vm._v(" "), (_vm.configuracoes.mostrarGrade) ? _c('div', {
	    style: ('height: ' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 70) + 'px'),
	    attrs: {
	      "id": "grade_meses"
	    }
	  }, _vm._l((_vm.projeto.lista_meses), function(p) {
	    return _c('div', {
	      staticClass: "secao_periodo",
	      style: ('margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, p) * _vm.configuracoes.zoom) + 'px; height: ' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 70) + 'px')
	    }, [_c('div', {
	      staticClass: "texto_vertical"
	    }, [_vm._v(_vm._s(_vm._f("moment")(p, 'MMM/YY')))])])
	  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
	    style: ('height: ' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 70) + 'px'),
	    attrs: {
	      "id": "grafico_relatorio"
	    }
	  }, [_vm._l((_vm.validacaoPeriodos), function(faixa) {
	    return (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.projeto.dias.ateHoje <= (_vm.projeto.dias.duracao + 5)) ? _c('div', {
	      staticClass: "validacao_periodo",
	      style: ('margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, faixa.inicio) * _vm.configuracoes.zoom) + 'px;' +
	        'width:' + (_vm.dias(faixa.inicio, faixa.termino) * _vm.configuracoes.zoom) + 'px;' +
	        'height:' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 50) + 'px')
	    }) : _vm._e()
	  }), _vm._v(" "), (_vm.configuracoes.mostrarHoje) ? _c('div', {
	    ref: "HOJE",
	    staticClass: "linha_hoje",
	    style: ('margin-left: ' + (_vm.projeto.dias.ateHoje * _vm.configuracoes.zoom) + 'px; height:' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 50) + 'px')
	  }, [_vm._v("\n                            Hoje " + _vm._s(_vm.projeto.dias.ateHoje > _vm.projeto.dias.duracao ? 'após ' + (_vm.projeto.dias.ateHoje - _vm.projeto.dias.duracao) + ' dia(s) do término do projeto' : '') + "\n                          ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "barras_relatorios"
	  }, _vm._l((_vm.relatorios), function(relatorio, indexRelatorio) {
	    return (!_vm._.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao) || (_vm.configuracoes.mostrarExcluidos && _vm._.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao))) ? _c('div', {
	      staticClass: "relatorio",
	      style: ('height: ' + (_vm.configuracoes.altura) + 'px;' +
	        'background: ' + _vm.realceAlteracao(relatorio)['cor'] + ';')
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          size: 'large',
	          arrow: true,
	          theme: 'light',
	          placement: 'bottom',
	          followCursor: true,
	          distance: 40
	        }),
	        expression: "{inertia: true, arrow: true, animation: 'perspective', size: 'large', arrow: true, theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
	      }],
	      staticClass: "info_acao",
	      style: ('height: ' + (_vm.configuracoes.altura - 5) + 'px;' +
	        'width: ' + (_vm._.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao) ? (60 * _vm.configuracoes.zoom) : (_vm.dias(relatorio.inicio_preenchimento, relatorio.termino_preenchimento) * _vm.configuracoes.zoom)) + 'px;' +
	        'margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.inicio_preenchimento) * _vm.configuracoes.zoom) + 'px;' +
	        ((!_vm.modoEdicao && _vm._.includes(['PREENCHER', 'REVISAR', 'VISUALIZAR'], relatorio.acao) || (_vm.modoEdicao && _vm.ehRelatorioEditavel(relatorio))) ? 'cursor: pointer;' : '') +
	
	        (_vm.estaExcluido(relatorio) ? 'background: rgb(240, 240, 240, 0.8); z-index:400; border:1px solid white;' :
	          (_vm.modoEdicao && !_vm.ehRelatorioEditavel(relatorio) ? 'background: rgb(255, 255, 255, 0.75); z-index:400;' :
	            'background: ' + _vm.cor(relatorio.situacao, 'corFundo')))),
	      attrs: {
	        "title": '<h5>Relatório ' + relatorio.tipo + ' nº <b>' + relatorio.sequencia + '</b>' +
	          '<br/><span style=\'font-weight: bold; background: ' + _vm.realceAlteracao(relatorio)['cor'] + '; color: ' + (_vm.cor(relatorio.situacao, 'corTexto')) + '\'>' + (relatorio.situacao).replace('ajustes:', 'ajustes<br/><br/>') + '</span>' +
	          '<hr/>' +
	          'Prazo de entrega<br/><span class=\'data_periodo_entre\'>' + _vm.formataData(relatorio.final_ciclo) + '</span>' +
	          '<br/><br/>' +
	          'Período disponível para análise<br/><span class=\'data_final_ciclo_em\'>' + _vm.formataDataDDMM(relatorio.antes_30_final_ciclo) + ' e ' + _vm.formataData(relatorio.depois_30_final_ciclo) + '</span>' +
	          (_vm._.has(relatorio, 'apresentado_em') && (relatorio.apresentado_em !== '1900-01-01' && !_vm._.isNull(relatorio.apresentado_em)) ? '<br/><br/>Apresentado em<br/><span class=\'data_apresentado_em\'>' + _vm.formataData(relatorio.apresentado_em) + '</span>' : '') +
	          (_vm._.has(relatorio, 'aprovado_em') && (relatorio.aprovado_em !== '1900-01-01' && !_vm._.isNull(relatorio.aprovado_em)) ? '<br/><br/>Aprovado em<br/><span class=\'data_aprovado_em\'>' + _vm.formataData(relatorio.aprovado_em) + '</span>' : '') +
	
	          '<hr/><b>' +
	          (
	            !_vm.modoEdicao ? (relatorio.acao !== 'OCULTO' ? 'Clique para ' + _vm._.toLower(relatorio.acao) : '') :
	            (_vm._.includes(['Não apresentado', 'Fora do período de preenchimento', 'Pendente de preenchimento', 'Relatório terá datas Alteradas ao Concluir', 'Relatório será Adicionado ao Concluir', 'Relatório será Excluído ao Concluir'], relatorio.situacao) || !_vm._.has(relatorio, 'situacao') ? 'Clique para alterar ou excluir cronograma' : '')
	          ) + '</b>' +
	          '</h5>'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.clickAcaoBarra(relatorio)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "faixa_preenchimento",
	      style: ('height: ' + (_vm.configuracoes.altura - 5) + 'px;' +
	        'width: ' + (_vm._.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao) ? (_vm.dias(relatorio.antes_30_final_ciclo, relatorio.depois_30_final_ciclo) * _vm.configuracoes.zoom) : (_vm.dias(relatorio.inicio_preenchimento, relatorio.termino_preenchimento) * _vm.configuracoes.zoom)) + 'px;' +
	        'margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.inicio_preenchimento) * _vm.configuracoes.zoom) + 'px;')
	    }), _vm._v(" "), _c('div', {
	      staticClass: "faixa_regular",
	      style: ('height: ' + (_vm.configuracoes.altura - 5) + 'px;' +
	        'width: ' + (_vm.dias(relatorio.antes_30_final_ciclo, relatorio.depois_30_final_ciclo) * _vm.configuracoes.zoom) + 'px;' +
	        'margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.antes_30_final_ciclo) * _vm.configuracoes.zoom) + 'px')
	    }), _vm._v(" "), (_vm.modoEdicao && !_vm._.isNull(_vm.relatorioEditando) && _vm.relatorioEditando.sequencia === relatorio.sequencia) ? _c('div', {
	      staticClass: "slider_alteracao_final_ciclo",
	      style: ('margin-left: ' + (_vm.relatorioEditando.minimo * _vm.configuracoes.zoom) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura) + 'px;' +
	        'padding-top: ' + (_vm.configuracoes.altura / 5) + 'px;' +
	        'width: ' + ((_vm.relatorioEditando.maximo - _vm.relatorioEditando.minimo) * _vm.configuracoes.zoom) + 'px;')
	    }, [_c('vue-slider', {
	      attrs: {
	        "process": false,
	        "lazy": true,
	        "tooltip-formatter": function (diasCorridos) { return _vm.formataData(_vm.adicionaDias(_vm.projeto.data_aprovacao_projeto, diasCorridos)); },
	        "min": _vm.relatorioEditando.minimo,
	        "max": _vm.relatorioEditando.maximo
	      },
	      on: {
	        "drag-end": _vm.atualizaAlteracao,
	        "blur": _vm.cancelaEdicao
	      },
	      model: {
	        value: (_vm.relatorioEditando.alteracaoDias),
	        callback: function($$v) {
	          _vm.$set(_vm.relatorioEditando, "alteracaoDias", $$v)
	        },
	        expression: "relatorioEditando.alteracaoDias"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          theme: 'light'
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, theme:'light'}"
	      }],
	      staticClass: "data_final_ciclo",
	      style: ('margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.final_ciclo) * _vm.configuracoes.zoom) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura - 5) + 'px;'),
	      attrs: {
	        "title": '<h5>Final de ciclo em<br/><span style=\'color: var(--cor-atencao-dark); font-weight: bold\'>' + _vm.formataData(relatorio.final_ciclo) + '</span></h5>'
	      }
	    }, [_vm._v(" ")]), _vm._v(" "), (_vm._.has(relatorio, 'apresentado_em') && (relatorio.apresentado_em !== '1900-01-01' && !_vm._.isNull(relatorio.apresentado_em))) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          theme: 'light'
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, theme:'light'}"
	      }],
	      staticClass: "data_apresentacao",
	      style: ('margin-left: ' + ((_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.apresentado_em) * _vm.configuracoes.zoom) + 2) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura - 5) + 'px;'),
	      attrs: {
	        "title": '<h5>Apresentado em<br/><span style=\'color: var(--cor-destaque-dark); font-weight: bold\'>' + _vm.formataData(relatorio.apresentado_em) + '</span></h5>'
	      }
	    }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm._.has(relatorio, 'aprovado_em') && (relatorio.aprovado_em !== '1900-01-01' && !_vm._.isNull(relatorio.aprovado_em))) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          theme: 'light'
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, theme:'light'}"
	      }],
	      staticClass: "data_aprovacao",
	      style: ('margin-left: ' + ((_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.aprovado_em) * _vm.configuracoes.zoom) + 4) + 'px;' +
	        'height: ' + (_vm.configuracoes.altura - 5) + 'px;'),
	      attrs: {
	        "title": '<h5>Aprovado em<br/><span style=\'color: var(--cor-sucesso-dark); font-weight: bold\'>' + _vm.formataData(relatorio.aprovado_em) + '</span></h5>'
	      }
	    }, [_vm._v(" ")]) : _vm._e()]) : _vm._e()
	  }), 0)], 2)])])]), _vm._v(" "), (_vm.configuracoes.mostrarLegenda) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', [_c('tr', [_c('td', {
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Legendas")]), _vm._v(" "), (_vm.haRelatoriosPelasSituacoes(['fora do período'])) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "background": "#f0f0ff"
	    },
	    attrs: {
	      "title": '<h5>Relatório que ainda não abriu o período de preenchimento</h5>'
	    }
	  }, [_vm._v("Fora do período")]) : _vm._e(), _vm._v(" "), (_vm.haRelatoriosPelasSituacoes(['pendente', 'análise', 'devolvido'])) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "background": "#c0d4ff"
	    },
	    attrs: {
	      "title": '<h5>Esta dentro do período e está Pendente de preenchimento ou em Análise ou está Devolvido para ajustes</h5>'
	    }
	  }, [_vm._v("No período")]) : _vm._e(), _vm._v(" "), (_vm.haRelatoriosPelasSituacoes(['aprovado'])) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "background": "#c0f3d2"
	    },
	    attrs: {
	      "title": '<h5>Relatório registrado como aprovado</h5>'
	    }
	  }, [_vm._v("Aprovado")]) : _vm._e(), _vm._v(" "), (_vm.haRelatoriosPelasSituacoes(['não apresentado'])) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "background": "#f3c0cc"
	    },
	    attrs: {
	      "title": '<h5>Não apresentado e ainda disponível para preenchimento, mas que passou do prazo no período regular</h5>'
	    }
	  }, [_vm._v("Não apresentado")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.configuracoes.mostrarExcluidos && _vm.haRelatoriosPelasSituacoes(['excluído'])) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "background": "#e3e7ec"
	    },
	    attrs: {
	      "title": '<h5>Foi excluído via Sapiens ou SGP e não é mais visível para entidade</h5>'
	    }
	  }, [_vm._v("Excluído")]) : _vm._e()]), _vm._v(" "), (_vm.modoEdicao) ? _c('tr', [_c('td', {
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Modo de Edição")]), _vm._v(" "), (_vm._.find(_vm.relatorios, function(rel) {
	    return !_vm.ehRelatorioEditavel(rel)
	  })) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "legenda_etiqueta",
	    staticStyle: {
	      "background": "#fbfbff"
	    },
	    attrs: {
	      "title": '<h5>Relatório que não pode ser alterados</h5>'
	    }
	  }, [_vm._v("Não pode ser alterado")]) : _vm._e(), _vm._v(" "), (_vm.alteracao.incluidos.length > 0) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "success legenda_etiqueta",
	    staticStyle: {
	      "background": "#dff0d8"
	    },
	    attrs: {
	      "title": '<h5>Relatório será Adicionado ao Concluir</h5>'
	    }
	  }, [_vm._v("Será Incluído")]) : _vm._e(), _vm._v(" "), (_vm.alteracao.alterados.length > 0) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "info legenda_etiqueta",
	    staticStyle: {
	      "background": "#d9edf7"
	    },
	    attrs: {
	      "title": '<h5>Relatório terá datas Alteradas ao Concluir</h5>'
	    }
	  }, [_vm._v("Será Alterada Data")]) : _vm._e(), _vm._v(" "), (_vm.alteracao.excluidos.length > 0) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "text-muted legenda_etiqueta",
	    staticStyle: {
	      "background": "#e8e5e5"
	    },
	    attrs: {
	      "title": '<h5>Relatório será Excluído ao Concluir</h5>'
	    }
	  }, [_vm._v("Será Excluído")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.validacaoPeriodos.length > 0) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    staticStyle: {
	      "background": "rgba(202, 123, 73, 0.38)"
	    }
	  }, [_vm._v("Atenção:")]), _vm._v(" "), _vm._l((_vm.validacaoPeriodos), function(faixa) {
	    return _c('p', [_vm._v("Relatório nº "), _c('b', [_vm._v(_vm._s(faixa.relatorio1.sequencia))]), _vm._v(" - " + _vm._s(faixa.tipo) + " ( " + _vm._s(_vm.formataData(faixa.inicio)) + "  a  " + _vm._s(_vm.formataData(faixa.termino)) + ")")])
	  })], 2) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.relatorioEditando)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "row well well-sm no-shadow"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('final do ciclo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v(_vm._s(_vm._.has(_vm.relatorioEditando, 'id') ? 'Editando relatório ' + _vm.relatorioEditando.sequencia : 'Incluindo relatório novo') + " informe a data de Final do Ciclo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "final do ciclo",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": false,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy",
	      "disabled-dates": _vm.desabilitarDatas
	    },
	    model: {
	      value: (_vm.relatorioEditando.final_ciclo),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioEditando, "final_ciclo", $$v)
	      },
	      expression: "relatorioEditando.final_ciclo"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('final do ciclo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('final do ciclo')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.okEdicao
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancelaEdicao
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.excluirRelatorio(_vm.relatorioEditando)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-label": "true"
	    }
	  }), _vm._v(" Excluir")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 col-md-offset-2"
	  }, [_vm._v("\n                          Limitado a data de término do projeto de " + _vm._s(_vm.formataData(_vm.projeto.data_final_projeto)) + "\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modoEdicao) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "row well well-sm no-shadow"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Justificativa " + _vm._s(_vm.alteracao.incluidos.length + _vm.alteracao.excluidos.length + _vm.alteracao.alterados.length > 1 ? 'das alterações' : 'da alteração') + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.alteracao.justificativa),
	      expression: "alteracao.justificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa",
	      "placeholder": "Descreva justificativa",
	      "rows": "3",
	      "data-vv-as": "Justificativa"
	    },
	    domProps: {
	      "value": (_vm.alteracao.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.alteracao, "justificativa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-offset-2 col-md-10"
	  }, [(_vm.alteracao.incluidos.length > 0 || _vm.alteracao.excluidos.length > 0 || _vm.alteracao.alterados.length > 0) ? _c('span', [_vm._v("\n                          Relatórios: " + _vm._s(_vm.alteracao.incluidos.length) + " incluído(s), " + _vm._s(_vm.alteracao.excluidos.length) + " excluídos(s), " + _vm._s(_vm.alteracao.alterados.length) + " alterados(s)\n                        ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "opcoes",
	    on: {
	      "click": function($event) {
	        _vm.mostrarOpcoes = !_vm.mostrarOpcoes
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" Opções\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarOpcoes),
	      expression: "mostrarOpcoes"
	    }],
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Mostrar Excluídos:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarExcluidos),
	      expression: "configuracoes.mostrarExcluidos"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarExcluidos"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.configuracoes.mostrarExcluidos, true)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarExcluidos", true)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarExcluidos),
	      expression: "configuracoes.mostrarExcluidos"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarExcluidos"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.configuracoes.mostrarExcluidos, false)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarExcluidos", false)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Zoom períodos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('vue-slider', {
	    attrs: {
	      "min": 1,
	      "max": 3,
	      "interval": .1,
	      "hide-label": true,
	      "tooltip": 'none',
	      "drag-on-click": true
	    },
	    on: {
	      "drag-end": _vm.salvarConfiguracoes
	    },
	    scopedSlots: _vm._u([{
	      key: "process",
	      fn: function() {
	        return [_c('div', {
	          staticClass: "escalaZoom"
	        })]
	      },
	      proxy: true
	    }], null, false, 4023097680),
	    model: {
	      value: (_vm.configuracoes.zoom),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracoes, "zoom", $$v)
	      },
	      expression: "configuracoes.zoom"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Altura da barra:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('vue-slider', {
	    attrs: {
	      "data": [{
	        tamanho: 25,
	        nome: 'Pequeno'
	      }, {
	        tamanho: 35,
	        nome: 'Médio'
	      }, {
	        tamanho: 45,
	        nome: 'Grande'
	      }, {
	        tamanho: 55,
	        nome: 'Extra'
	      }],
	      "data-value": 'tamanho',
	      "data-label": 'nome',
	      "drag-on-click": true
	    },
	    on: {
	      "drag-end": _vm.salvarConfiguracoes
	    },
	    model: {
	      value: (_vm.configuracoes.altura),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracoes, "altura", $$v)
	      },
	      expression: "configuracoes.altura"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Mostrar Grade:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarGrade),
	      expression: "configuracoes.mostrarGrade"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarGrade"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.configuracoes.mostrarGrade, true)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarGrade", true)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarGrade),
	      expression: "configuracoes.mostrarGrade"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarGrade"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.configuracoes.mostrarGrade, false)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarGrade", false)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Mostrar Hoje:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarHoje),
	      expression: "configuracoes.mostrarHoje"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarHoje"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.configuracoes.mostrarHoje, true)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarHoje", true)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarHoje),
	      expression: "configuracoes.mostrarHoje"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarHoje"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.configuracoes.mostrarHoje, false)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarHoje", false)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Mostrar Legenda:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarLegenda),
	      expression: "configuracoes.mostrarLegenda"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarLegenda"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.configuracoes.mostrarLegenda, true)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarLegenda", true)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.mostrarLegenda),
	      expression: "configuracoes.mostrarLegenda"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "mostrarLegenda"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.configuracoes.mostrarLegenda, false)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.configuracoes, "mostrarLegenda", false)
	      }, _vm.salvarConfiguracoes]
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat col-md-offset-2",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.configuracaoPadrao
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-repeat",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar ao padrão")])])])]) : _vm._e()]) : _vm._e()])])])]) : _vm._e()])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Tutorial\n              ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\xanjyjeekdpghr5dgap4.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\o1hiqwks07hifa6aj1sz.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\ddjwqe25q3tphkgefoqj.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\jtoywuy44dq2zqzmtn5q.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\auxeh01iknrmk563kspi.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\f75fr57g1cf7h7jgk97p.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\m8ebsjo3k1lg1eou5an4.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\gq2b2bzvxje0raavrl72.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\zazzystmj2e41rktbkwo.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\t0dymw64se3jbv1373a2.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\pwdjofu0yqtgjb4ab5tv.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\yhxmo5y38646lwxf2v6d.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('img', {
	    attrs: {
	      "src": "\\static\\img\\tutoriais\\gv3ws0odkz1hak5bg6ql.png"
	    }
	  })])
	}]}

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Preferências")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Preferências',
	        href: '#'
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body box-profile"
	  }, [_c('div', {
	    attrs: {
	      "id": "preview"
	    }
	  }, [_c('img', {
	    staticClass: "profile-user-img img-responsive img-circle",
	    attrs: {
	      "alt": "User profile picture",
	      "src": _vm.usuarioLogado.bl_foto || '/static/img/nouser.png'
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (true),
	      expression: "true"
	    }],
	    staticClass: "text-center",
	    staticStyle: {
	      "margin": "10px 0"
	    }
	  }, [_c('input', {
	    staticClass: "hidden",
	    attrs: {
	      "id": "files",
	      "type": "file",
	      "Alterar": "",
	      "Foto": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onFileChange($event)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "btn btn-default btn-xs btn-flat",
	    attrs: {
	      "for": "files"
	    }
	  }, [_vm._v("Alterar")]), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "opacity": "0",
	      "height": "1px"
	    },
	    attrs: {
	      "type": "file",
	      "id": "photo",
	      "accept": ".png,.jpg"
	    }
	  })]), _vm._v(" "), _c('h3', {
	    staticClass: "profile-username text-center"
	  }, [_vm._v(_vm._s(_vm.usuarioLogado.ds_nome_usuario))]), _vm._v(" "), _c('ul', {
	    staticClass: "list-group list-group-unbordered"
	  }, [_c('li', {
	    staticClass: "list-group-item"
	  }, [_c('b', [_vm._v("E-mail")]), _vm._v(" "), _c('a', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm.usuarioLogado.ds_email))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "nav-tabs-custom"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    attrs: {
	      "uib-collapse": "authBox.isCollapsed"
	    }
	  }, [_c('form', {
	    attrs: {
	      "name": "frmChangePassword"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.usuarioLogado.ds_tipo_usuario !== 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v("Alterar Senha ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback",
	    class: {
	      'has-error': _vm.errors.first('senhaAtual')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password.senhaAtual),
	      expression: "password.senhaAtual"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "senhaAtual",
	      "name": "senhaAtual",
	      "type": "password",
	      "placeholder": "Informe a senha atual"
	    },
	    domProps: {
	      "value": (_vm.password.senhaAtual)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.password, "senhaAtual", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-lock form-control-feedback"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.first('senhaAtual')),
	      expression: "errors.first('senhaAtual')"
	    }],
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Campo requerido')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback",
	    class: {
	      'has-error': _vm.errors.first('novaSenha')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password.novaSenha),
	      expression: "password.novaSenha"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "novaSenha",
	      "name": "novaSenha",
	      "type": "password",
	      "placeholder": "Informe a nova senha"
	    },
	    domProps: {
	      "value": (_vm.password.novaSenha)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.password, "novaSenha", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-lock form-control-feedback"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.first('novaSenha')),
	      expression: "errors.first('novaSenha')"
	    }],
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Campo requerido')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback",
	    class: {
	      'has-error': _vm.errors.first('confirmaSenha')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password.confirmaSenha),
	      expression: "password.confirmaSenha"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "confirmaSenha",
	      "name": "confirmaSenha",
	      "type": "password",
	      "placeholder": "Confirme a nova senha"
	    },
	    domProps: {
	      "value": (_vm.password.confirmaSenha)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.password, "confirmaSenha", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-lock form-control-feedback"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.first('confirmaSenha')),
	      expression: "errors.first('confirmaSenha')"
	    }],
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('Campo requerido')))]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isValidPassword()),
	      expression: "!isValidPassword()"
	    }],
	    staticClass: "label label-danger"
	  }, [_vm._v("As senhas devem ser iguais")])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario == 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', [_vm._v("Alterar Senha ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()])]), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario !== 'FUNDACAO') ? _c('div', {
	    staticClass: "box-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onChangePassword(_vm.password)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Alterar Senha\n                  ")])]) : _vm._e()])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(" Autenticação ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "callout callout-warning",
	    staticStyle: {
	      "margin-bottom": "0!important"
	    }
	  }, [_c('h4', [_vm._v("Atenção")]), _vm._v("\n                        Contacte o administrador da rede para efetuar a alteração de sua senha.\n                      ")])
	}]}

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('span', {
	    staticClass: "titulo-especial"
	  }, [_vm._v(_vm._s(_vm.valor))])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Quantidade Orçada")]), _vm._v(" "), _c('th', [_vm._v("Valor Orçado")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('th', [_vm._v("Economicidade")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Quantidade disponível")]), _vm._v(" "), _c('th', [_vm._v("Valor disponível")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itensProjeto), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao)), _c('br'), _vm._v("#" + _vm._s(item.Id_item) + " " + _vm._s(item.Item_Observacao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Item_Tipo))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado)))]), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.quantidadeSolicitada))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.quantidadeSolicitada),
	        expression: "item.quantidadeSolicitada"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "quantidade a solicitar",
	        "type": "text"
	      },
	      domProps: {
	        "value": (item.quantidadeSolicitada)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "quantidadeSolicitada", $event.target.value)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.valorSolicitado)))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('money', {
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "valor a solicitar",
	        "type": "text"
	      },
	      model: {
	        value: (item.valorSolicitado),
	        callback: function($$v) {
	          _vm.$set(item, "valorSolicitado", $$v)
	        },
	        expression: "item.valorSolicitado"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('label', {
	      staticClass: "checkbox-inline new-control new-control-checkbox",
	      staticStyle: {
	        "margin-bottom": "10px"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.Economicidade),
	        expression: "item.Economicidade"
	      }],
	      attrs: {
	        "disabled": _vm.propsEtapa !== 'Análise' || item.editing === false || _vm._.isUndefined(item.editing),
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": Array.isArray(item.Economicidade) ? _vm._i(item.Economicidade, null) > -1 : (item.Economicidade)
	      },
	      on: {
	        "change": [function($event) {
	          var $$a = item.Economicidade,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(item, "Economicidade", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(item, "Economicidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(item, "Economicidade", $$c)
	          }
	        }, function($event) {
	          return _vm.marcaItem(item)
	        }]
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_saldo))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_saldo - (item.quantidadeSolicitada ? item.quantidadeSolicitada : 0)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo - (item.valorSolicitado ? item.valorSolicitado : 0))))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [(item.editing === false || !item.editing) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização' && item.Valor_saldo > 0),
	        expression: "propsEtapa !== 'Autorização' && item.Valor_saldo > 0"
	      }],
	      staticClass: "fa fa-edit",
	      staticStyle: {
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.editItem(item, 1)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editing === false && _vm.propsEtapa === 'Solicitação' && item.quantidadeSolicitada > 0) ? _c('i', {
	      staticClass: "fa fa-times",
	      staticStyle: {
	        "color": "red",
	        "margin-left": "5px",
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.apagaItem(item)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green",
	        "margin-left": "5px",
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item, 2)
	        }
	      }
	    }) : _vm._e()])])
	  }), 0), _vm._v(" "), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Valor total de recursos contratados: ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "5",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v("Valor total da solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.total)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Saldo restante do projeto:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado - _vm.total)))]), _vm._v(" "), _c('td')])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])
	}]}

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Formalização',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconder === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconder = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar o projeto "), _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.idProjectErp) + " - " + _vm._s(_vm.proposta.name))])]) : _vm._e(), _vm._v(" "), (_vm.esconder === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconder = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar o projeto "), _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.idProjectErp) + " - " + _vm._s(_vm.proposta.name))])]) : _vm._e()])]), _vm._v(" "), (_vm.esconder === true) ? _c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ng-init": "check()"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.simplified),
	      expression: "proposta.simplified"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "hidden",
	      "name": "tipo",
	      "id": "tipo",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.proposta.simplified)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "simplified", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('NAME')"
	    }
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.idProjectErp),
	      expression: "proposta.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.name),
	      expression: "proposta.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorName),
	      expression: "proposta.coordinatorName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorCpf", $$v)
	      },
	      expression: "proposta.coordinatorCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorEmail),
	      expression: "proposta.coordinatorEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorPhone", $$v)
	      },
	      expression: "proposta.coordinatorPhone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorMobile", $$v)
	      },
	      expression: "proposta.coordinatorMobile"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Fax')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorFax", $$v)
	      },
	      expression: "proposta.coordinatorFax"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Fax')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.proposta.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                      " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                      " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                    ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.initialDate),
	      expression: "proposta.initialDate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control",
	      "type": "date",
	      "format": "DD/MM/YYYY",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.proposta.initialDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "initialDate", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periods),
	      expression: "proposta.periods"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.proposta.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.introduction),
	      expression: "proposta.introduction"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "introduction", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.presentation),
	      expression: "proposta.presentation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.territory),
	      expression: "proposta.territory"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.justification),
	      expression: "proposta.justification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.generalObjective),
	      expression: "proposta.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.summary),
	      expression: "proposta.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": this.proposta.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": this.proposta.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.teams = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.results),
	      expression: "proposta.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "results", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.operation),
	      expression: "proposta.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "operation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.partner),
	      expression: "proposta.partner"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "partner", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.proposta.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.proposta.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                ")])])]), _vm._v(" "), (_vm.proposta.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingName),
	      expression: "proposta.entityExecutingName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingProcurator),
	      expression: "proposta.entityExecutingProcurator"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|cnpj'),
	      expression: "'required:!proposta.entityIsExecutioner|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCNPJ", $$v)
	      },
	      expression: "proposta.entityExecutingCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingEmail),
	      expression: "proposta.entityExecutingEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|email'),
	      expression: "'required:!proposta.entityIsExecutioner|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingPhone", $$v)
	      },
	      expression: "proposta.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingMobile", $$v)
	      },
	      expression: "proposta.entityExecutingMobile"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingFax", $$v)
	      },
	      expression: "proposta.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.duplicateProject),
	      expression: "proposta.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber) + "/" + _vm._s(projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(7), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(9), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraCronograma),
	      expression: "mostraCronograma"
	    }],
	    staticClass: "col-md-12"
	  }, [_vm._m(10), _vm._v(" "), _c('cronograma', {
	    attrs: {
	      "proposta": _vm.proposta,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades,
	      "meses": _vm.proposta.periods,
	      "projeto-duplicacao": _vm.proposta.duplicateProject
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('gantt', {
	    attrs: {
	      "periodo": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades
	    }
	  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "proposta": _vm.proposta
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(12), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.careers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('solenizacao', {
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.proposta.solemnizations = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(14), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documents,
	      "documentTypes": _vm.proposta.documentTypes,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(15), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documentStatements,
	      "documentTypes": [],
	      "documentosObrigatorios": []
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(16), _vm._v(" "), _c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta
	    }
	  })], 1)], 1)])])]) : _vm._e()]), _vm._v(" "), _c('formalizacao', {
	    attrs: {
	      "propsAnalise": _vm.analise
	    }
	  })], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                          outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	}]}

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [(_vm.ehVisualizacao) ? _c('span', [_vm._v("Visualizar " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]) : (_vm.etapa === 'Análise Financeira') ? _c('span', [_vm._v("Acerto Contábil de " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]) : _c('span', [_vm._v(_vm._s(_vm.etapa) + " de " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), ((!_vm.loading.processo && !_vm.loading.tarefa && !_vm.loading.adiantamentos && !_vm.loading.projetos) || _vm.ehVisualizacao) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id)) && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((!_vm.loading.processo && !_vm.loading.tarefa && !_vm.loading.adiantamentos && !_vm.loading.projetos)),
	      expression: "(!loading.processo && !loading.tarefa && !loading.adiantamentos && !loading.projetos)"
	    }]
	  }, [(!_vm._.isNull(_vm.id) && _vm.processo === 'ADIANTAMENTO') ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>199 - Comunicado Interno de Adiantamento (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(199)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 199\n        ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(219)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 219\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'S')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525A\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'N')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525S\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>248 - Monitoramento Administrativo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(248)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 248\n        ")]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && _vm.etapa !== 'Solicitação') ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5>Faz o download de todos os arquivos da solicitação (zip)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onDownloadZIP()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v(" Baixar arquivos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), ((!_vm.loading.processo && !_vm.loading.tarefa && !_vm.loading.adiantamentos && !_vm.loading.projetos) && !_vm._.isEmpty(_vm.projeto) && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5>' + (_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) ? 'Ao Concluir esta solicitação será encaminhada para Análise da Fundação BB' : (_vm.aprovacao.resultadoAprovacao ? 'Será encaminhado para ' + _vm.aprovacao.resultadoAprovacao : 'Aguadando decisão')) + '</h5>'
	    }
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.concluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")])], 1) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela && !_vm.loading.cronograma && !_vm._.isEmpty(_vm.projeto) && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5>Salva esta solicitação<br/>Para encaminhá-la deve-se usar o botão de Concluir' + (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm.poderes.codigo !== 'DIRIGENTE_SEM_RESTRICAO' ? '<br/>Somente dirigentes estão habilitados para concluir solicitações' : (_vm.poderes.mensagem.length > 0 ? '<br/>Restrições:<br/>' + _vm._.join(_vm.poderes.mensagem, ', ') : '')) + '</h5>'
	    }
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvar($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (!_vm.loading.tela && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0 && (_vm.etapa === 'Solicitação' || _vm.etapa === 'Revisão') && !_vm._.isEmpty(_vm.projeto)) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5> Abrir Chamado referente a solicitação atual</h5>'
	    }
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.abrirChamado($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa  fa-comment-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Abrir Chamado")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: (_vm._.isNull(_vm.id) ? 'Solicitações' : 'Validação'),
	        href: '#'
	      }, {
	        text: _vm.descricaoProcesso[_vm.processo],
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [(_vm._.isEmpty(_vm.projeto) && _vm._.isNull(_vm.id) && !_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaProjetos"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    class: _vm.ehVisualizacao ? 'fa fa-caret-right' : 'fa fa-pencil',
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Selecione o projeto")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.projetos),
	      expression: "loading.projetos"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto),
	      expression: "projeto"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "projeto",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.selecionaProjeto()
	      }]
	    }
	  }, _vm._l((_vm.listaProjetos), function(projetoDisponivel) {
	    return _c('option', {
	      domProps: {
	        "value": projetoDisponivel
	      }
	    }, [_vm._v(_vm._s(projetoDisponivel.Projeto))])
	  }), 0)])])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id)) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "solicitacao"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.processo || _vm.loading.tarefa || _vm.loading.adiantamentos || _vm.loading.projetos),
	      expression: "loading.processo || loading.tarefa || loading.adiantamentos || loading.projetos"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (!_vm._.isEmpty(_vm.chamado) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v(" * Atenção: O processo que será analisado possui chamado vinculado - "), _c('b', _vm._l((_vm.chamado), function(c, index) {
	    return _c('span', [_c('router-link', {
	      attrs: {
	        "target": "_blank",
	        "to": {
	          name: 'cadastro-chamado-edita',
	          params: {
	            id: c.id
	          }
	        }
	      }
	    }, [_vm._v(" " + _vm._s(c.id) + " "), (_vm.chamado.length > 1 && index === 0) ? _c('span', [_vm._v(",  ")]) : _vm._e()])], 1)
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.adiantamentoSolicitado.suporteFbb.length > 0 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('p', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v("\n            ** Atenção: Este processo possui " + _vm._s(_vm.adiantamentoSolicitado.suporteFbb.length > 1 ? 'os seguintes suportes vinculados' : 'este suportes vinculado') + ":\n            "), _vm._l((_vm.adiantamentoSolicitado.suporteFbb), function(suporte) {
	    return _c('a', {
	      staticStyle: {
	        "font-weight": "bold",
	        "padding-left": "10px"
	      },
	      attrs: {
	        "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(suporte.numero))])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.adiantamentoSolicitado.suporteFbb.length > 0 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('p', {
	    staticStyle: {
	      "color": "red",
	      "font-size": "medium"
	    }
	  }, [_vm._v("\n            ** Atenção: Este processo possui " + _vm._s(_vm.adiantamentoSolicitado.suporteFbb.length > 1 ? 'os seguintes suportes vinculados' : 'este suportes vinculado') + ":\n            "), _vm._l((_vm.adiantamentoSolicitado.suporteFbb), function(suporte) {
	    return _c('a', {
	      staticStyle: {
	        "font-weight": "bold",
	        "padding-left": "10px"
	      },
	      attrs: {
	        "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(suporte.numero))])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm._.includes(['PRESTACAO_DE_CONTAS', 'PAGAMENTO', 'ADIANTAMENTO', 'RESSARCIMENTO'], _vm.processo) && _vm._.includes(['Solicitação'], _vm.etapa) && _vm.projetoComAlteracaoEmAndamento) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Solicitação não disponível. Verificamos que há uma alteração de projetos em andamento.")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.projeto.Projeto) + "\n              "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm._.has(_vm.projeto, 'Status_ERP')) ? _c('span', [_vm._v("\n                ("), _c('strong', [_vm._v(_vm._s(_vm.projeto.Status_ERP))]), _vm._v(")\n                  "), _c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'small',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Ir para a página do Projeto</h5>',
	      "to": {
	        name: 'projeto',
	        params: {
	          numero: _vm.projeto.Numero_projeto
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [(_vm.restricaoParaInicializar.length > 0) ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.restricaoParaInicializar), function(restricao) {
	    return _c('p', [_vm._v(_vm._s(restricao))])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.ultimaTarefaFeita, 'observacao') && !_vm._.isNull(_vm.ultimaTarefaFeita.observacao)) ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ultimaTarefaFeita.observacao))])]) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Solicitação'], _vm.etapa)) ? _c('div', [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome da entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [(!_vm.ehParceiroEstrategico) ? _c('p', {
	    staticClass: "form-control-static"
	  }, [_c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
	      "to": {
	        name: 'cadastro-entidade-visualiza',
	        params: {
	          id: _vm.projeto.fk_entidade
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.razaoSocial) + "  "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.ehParceiroEstrategico) ? _c('p', {
	    staticClass: "form-control-static"
	  }, [_vm._v("\n                        " + _vm._s(_vm.razaoSocial) + "\n                      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.entidade.ds_cnpj)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Projeto Superior:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.projetoSuperior))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    on: {
	      "click": function($event) {
	        _vm.mostrar_representantes = !_vm.mostrar_representantes
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar_representantes ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Representantes Legais:")]), _vm._v(" "), (_vm.mostrar_representantes) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.dirigentes), function(dirigente) {
	    return (dirigente.bt_ativo && dirigente.bt_assinatura_entidade) ? _c('tr', [_c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm.cargos[dirigente.fk_cargo_mandato]))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]) : _vm._e()
	  }), 0)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    on: {
	      "click": function($event) {
	        _vm.mostrar_ocorrencias = !_vm.mostrar_ocorrencias
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar_ocorrencias ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocorrências:")]), _vm._v(" "), (_vm.temOcorrencia) ? _c('div', [(_vm.mostrar_ocorrencias) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.ocorrencias), function(ocorrencia) {
	    return _c('tr', [_c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(ocorrencia.codigo) + " " + _vm._s(ocorrencia.descricao))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("moment")(ocorrencia.inicio, "L")))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(ocorrencia.observacao))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(ocorrencia.etapa))])])
	  }), 0)])])])]) : _vm._e()]) : _c('div', [_vm._m(5)])])]) : _vm._e(), _vm._v(" "), (_vm.adiantamentosConcecidos.length > 0 && _vm._.has(_vm.adiantamentosConcecidos[0], 'id')) ? _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "adiantamentosConcedidos"
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda w10",
	    attrs: {
	      "title": '<h5>Id da solicitação de adiantamento</h5>'
	    }
	  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda w15",
	    attrs: {
	      "title": '<h5>Número da parcela (ordem) do adiantamento</h5>'
	    }
	  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda w15",
	    attrs: {
	      "title": '<h5>Data quando foi feita a solicitação de liberação do adiantamento</h5>'
	    }
	  }, [_vm._v("Data da solicitação")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda w15",
	    attrs: {
	      "title": '<h5>Valor da parcela no instrumento legal</h5>'
	    }
	  }, [_vm._v("Valor previsto")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda w15",
	    attrs: {
	      "title": '<h5>% Comprovada da parcela, considerando somente prestações de contas efetivamente aprovadas pela Fundação</h5>'
	    }
	  }, [_vm._v("% Comprov.")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda w15",
	    attrs: {
	      "title": '<h5>Valor solicitado dentro do limite total da parcela</h5>'
	    }
	  }, [_vm._v("Valor adiantado")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda w15",
	    attrs: {
	      "title": '<h5>Data limite para realizar as Prestações de Contas para esta parcela</h5>'
	    }
	  }, [_vm._v("Data limite para prestação")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda w15",
	    attrs: {
	      "title": '<h5>Data da última Prestação de Contas solicitda para esta parcela</h5>'
	    }
	  }, [_vm._v("Data da última prestação")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.adiantamentosConcecidos), function(adiantamento) {
	    return [_c('tr', [_c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v("\n                              " + _vm._s(adiantamento.id) + "\n\n                              "), _vm._v(" "), (false) ? _c('router-link', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          placement: 'right',
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia:true, placement:'right', animation:'perspective', distance:'1', size: 'large', arrow:true }"
	      }],
	      attrs: {
	        "title": '<h5>Clique aqui para abrir este processo de solicitação de adiantamento realizado</h5>',
	        "to": {
	          name: 'solicitacao-adiantamento',
	          params: {
	            id: adiantamento.id,
	            visualizacao: true
	          }
	        },
	        "target": "_blank"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-external-link"
	    })]) : _vm._e()], 1), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v("\n                              " + _vm._s(adiantamento.parcela) + " "), _c('span', {
	      staticStyle: {
	        "color": "var(--cor-destaque)",
	        "font-size": "x-small"
	      }
	    }, [_vm._v(_vm._s(adiantamento.recurso))])]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("moment")(adiantamento.data_solicitacao, "L")))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.contratado)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_c('span', {
	      style: ((((adiantamento.requisitado - (adiantamento.em_execucao + adiantamento.pendente_comprovacao)) / adiantamento.requisitado)) < 0.8 ? 'color: var(--cor-vermelha)' : '')
	    }, [_vm._v(_vm._s((((adiantamento.requisitado - (adiantamento.em_execucao + adiantamento.pendente_comprovacao)) / adiantamento.requisitado) * 100).toFixed(2)) + " %")])]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.requisitado)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("moment")(adiantamento.data_limite_prestacao, "L")))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("moment")(adiantamento.data_ultima_prestacao, "L")))])])]
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_vm._m(7), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor",
	    staticStyle: {
	      "padding": "10px",
	      "font-size": "2rem"
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total já solicitado de adiantamento para esta projeto</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.liberado)) + "\n                            ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor",
	    staticStyle: {
	      "padding": "10px",
	      "font-size": "2rem"
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total de prestações de contas Em Execução (solicitadas mas ainda não aprovadas pela Fundação BB)</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.emExecucao)) + "\n                            ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor",
	    staticStyle: {
	      "padding": "10px",
	      "font-size": "2rem"
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total pendente de prestação de contas é o total de adiantamento solicitado subtraindo prestações solicitadas e adicionando devoluções realizadas</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.pendenteComprovacao)) + "\n                            ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length === 0 && _vm.parcelasAtuais.length > 0) ? _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "parcelasAdiantamentoDisponiveis"
	    }
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? (_vm.projeto.parcelas_contratadas > 1 ? 'Parcelas Adiantáveis' : 'Parcela Adiantável') : 'Valor para Devolução'))]), _vm._v(" "), (_vm.projeto.superior === 18182 && _vm.projeto.parcelas_contratadas === 1) ? _c('span', {
	    staticStyle: {
	      "color": "var(--cor-destaque)"
	    }
	  }, [_vm._v("Este projeto tem parcela única e deve ser liberado integralmente")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [(_vm.processo === 'ADIANTAMENTO') ? _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Número da parcela (ordem) do adiantamento</h5>'
	    }
	  }, [_vm._v("Parcela")]) : _vm._e(), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Origem do recurso financeiro</h5>'
	    }
	  }, [_vm._v("Recurso")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Total orçado do recurso nesta parcela' : 'É o total do valor adiantado que ainda não foi prestado contas nem devolvido') + '</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Valor total' : 'Total pendente'))]), _vm._v(" "), (_vm.parcelasAtuais.length > 1 && _vm.processo === 'ADIANTAMENTO' && _vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'top'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Total disponível do recurso nesta parcela considerando os totais do projeto' : 'É o total do valor adiantado disponível que ainda não foi prestado contas nem devolvido') + '</h5>'
	    }
	  }, [_vm._v("Valor disponível")]) : _vm._e(), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Valor solicitado dentro do limite total da parcela' : 'Limite que pode devolver nesta solicitação') + '</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Valor solicitado' : 'Valor para devolução'))]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Total não solicitado nesta parcela' : 'Valor pendente de devolução ou prestação de contas') + '</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Saldo restante' : 'Total Restante'))]), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Número do título que será gerado no Sapiens</h5>'
	    }
	  }, [_vm._v("Número do Título")]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Conta financeira de adiantamento ao qual o projeto esta vinculado</h5>'
	    }
	  }, [_vm._v("Conta Financeira")]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Conta de tesouraria ao qual o projeto esta vinculado</h5>'
	    }
	  }, [_vm._v("Conta de Tesouraria")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parcelasAtuais), function(parcela, idx) {
	    return [_c('tr', [(_vm.processo === 'ADIANTAMENTO') ? _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(parcela.parcela))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(parcela.resourceSource))]), _vm._v(" "), (idx === 0) ? _c('td', {
	      class: 'celula centralizado borda ' + (_vm.processo === 'ADIANTAMENTO' ? 'w15' : 'w20'),
	      attrs: {
	        "rowspan": _vm.parcelasAtuais.length
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(parcela.disponivel)))]) : _vm._e(), _vm._v(" "), (_vm.parcelasAtuais.length > 1 && _vm.processo === 'ADIANTAMENTO' && _vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('td', {
	      staticClass: "celula centralizado borda w15"
	    }, [((parcela.resourceSource === 'FUNDACAO' ? _vm.totais.projeto.fbb.limite : _vm.totais.projeto.parceiros.limite) < parcela.disponivel) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "atencao",
	      staticStyle: {
	        "background": "steelblue !important"
	      },
	      attrs: {
	        "title": '<h5>Este é o valor restante no projeto em recursos de ' + parcela.resourceSource + '</h5>'
	      }
	    }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm._.round((parcela.resourceSource === 'FUNDACAO' ? _vm.totais.projeto.fbb.limite : _vm.totais.projeto.parceiros.limite) - parcela.requisitado, 2))) + "\n                              ")]) : _c('span', [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm._.round(parcela.disponivel - parcela.requisitado, 2))) + "\n                              ")])]) : _vm._e(), _vm._v(" "), _c('td', {
	      class: 'celula centralizado borda ' + (_vm.processo === 'ADIANTAMENTO' ? 'w15' : 'w20')
	    }, [((_vm.processo === 'ADIANTAMENTO')) ? _c('money', {
	      staticClass: "form-control valorSolicitacao",
	      attrs: {
	        "name": "valor a solicitar",
	        "type": "text",
	        "disabled": _vm.ehVisualizacao || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa) || (_vm.projeto.superior === 18182 && _vm.projeto.parcelas_contratadas === 1)
	      },
	      nativeOn: {
	        "keyup": function($event) {
	          parcela.requisitado = _vm.limitaFaixaEntrada('decimal', parcela.requisitado, 0,
	            ((parcela.resourceSource === 'FUNDACAO' ? _vm.totais.projeto.fbb.limite : _vm.totais.projeto.parceiros.limite) < parcela.disponivel) ?
	            (parcela.resourceSource === 'FUNDACAO' ? _vm.totais.projeto.fbb.limite : _vm.totais.projeto.parceiros.limite) : parcela.disponivel)
	        },
	        "blur": function($event) {
	          return _vm.calcularTotaisAdiantamento($event)
	        }
	      },
	      model: {
	        value: (parcela.requisitado),
	        callback: function($$v) {
	          _vm.$set(parcela, "requisitado", $$v)
	        },
	        expression: "parcela.requisitado"
	      }
	    }) : _vm._e(), _vm._v(" "), ((_vm.processo === 'DEVOLUCAO_DE_ADIANTAMENTO')) ? _c('money', {
	      staticClass: "form-control valorSolicitacao",
	      attrs: {
	        "name": "valor a solicitar",
	        "type": "text",
	        "disabled": _vm.ehVisualizacao || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)
	      },
	      nativeOn: {
	        "blur": function($event) {
	          return _vm.calcularTotaisAdiantamento($event)
	        }
	      },
	      model: {
	        value: (parcela.requisitado),
	        callback: function($$v) {
	          _vm.$set(parcela, "requisitado", $$v)
	        },
	        expression: "parcela.requisitado"
	      }
	    }) : _vm._e()], 1), _vm._v(" "), (_vm.parcelasAtuais.length === 1) ? _c('td', {
	      class: 'celula centralizado borda ' + (_vm.processo === 'ADIANTAMENTO' ? 'w15' : 'w20')
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.round((parcela.disponivel - parcela.requisitado), 2))))]) : (idx === 0) ? _c('td', {
	      class: 'celula centralizado borda ' + (_vm.processo === 'ADIANTAMENTO' ? 'w15' : 'w20'),
	      attrs: {
	        "rowspan": _vm.parcelasAtuais.length
	      }
	    }, [_c('span', {
	      class: _vm._.round(((_vm._.sumBy(_vm.parcelasAtuais, 'disponivel')) - _vm._.sumBy(_vm.parcelasAtuais, 'requisitado')), 2) < 0 ? 'atencao' : ''
	    }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm._.round((_vm._.sumBy(_vm.parcelasAtuais, 'disponivel') - _vm._.sumBy(_vm.parcelasAtuais, 'requisitado')), 2))) + "\n                              ")])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('td', {
	      staticClass: "celula centralizado borda w15"
	    }, [(parcela.requisitado > 0) ? _c('span', {
	      class: {
	        'has-error': _vm.errors.first('número do título da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource)
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (parcela.numeroTitulo),
	        expression: "parcela.numeroTitulo"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control valorSolicitacao",
	      attrs: {
	        "name": 'número do título da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource,
	        "type": "number",
	        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	      },
	      domProps: {
	        "value": (parcela.numeroTitulo)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(parcela, "numeroTitulo", $event.target.value)
	        }
	      },
	      nativeOn: {
	        "keyup": function($event) {
	          parcela.numeroTitulo = _vm.limitaFaixaEntrada('inteiro', parcela.numeroTitulo, 0, 99999999)
	        }
	      }
	    })]) : _c('span', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('td', {
	      staticClass: "celula centralizado borda w20"
	    }, [(parcela.requisitado > 0) ? _c('span', {
	      class: {
	        'has-error': _vm.errors.first('conta financeira da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource)
	      }
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (parcela.contaFinanceira),
	        expression: "parcela.contaFinanceira"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "name": 'conta financeira da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource,
	        "aria-hidden": "true",
	        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(parcela, "contaFinanceira", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((_vm.contasFinanceiras), function(conta) {
	      return _c('option', {
	        domProps: {
	          "value": conta.ctared
	        }
	      }, [_vm._v(_vm._s(conta.ctared) + " / " + _vm._s(conta.descta))])
	    }), 0)]) : _c('span', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('td', {
	      staticClass: "celula centralizado borda w20"
	    }, [(parcela.requisitado > 0) ? _c('span', {
	      class: {
	        'has-error': _vm.errors.first('conta tesouraria da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource)
	      }
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (parcela.contaTesouraria),
	        expression: "parcela.contaTesouraria"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "name": 'conta tesouraria da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource,
	        "aria-hidden": "true",
	        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(parcela, "contaTesouraria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((_vm.contasTesouraria), function(conta) {
	      return _c('option', {
	        domProps: {
	          "value": conta.numcco
	        }
	      }, [_vm._v(_vm._s(conta.numcco) + " / " + _vm._s(conta.descco))])
	    }), 0)]) : _c('span', [_vm._v(" ")])]) : _vm._e()])]
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_c('tr', [_c('td', {
	    staticClass: "centralizado w30"
	  }, [_c('span', [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Valor orçado para esta parcela' : 'Total Pendente'))])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado w30"
	  }, [_c('span', [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Total valor solicitado' : 'Total para devolução'))])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado w30"
	  }, [_c('span', [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Valor disponível para solicitação nesta parcela' : 'Valor ainda não comprovado nem devolvido'))])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Valor total disponível nesta parcela do projeto' : 'Soma dos valores em aberto dos adiantamento concedidos que podem ser devolvidos') + '</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm._.round(_vm._.sumBy(_vm.parcelasAtuais, 'disponivel'), 2))) + "\n                            ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor solicitado neste pedido de ' + _vm._.toLower(_vm.descricaoProcesso[_vm.processo]) + '</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm._.sumBy(_vm.parcelasAtuais, 'requisitado'))) + "\n                            ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor disponível que não foi solicitado</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm._.round(((_vm._.sumBy(_vm.parcelasAtuais, 'disponivel')) - _vm._.sumBy(_vm.parcelasAtuais, 'requisitado')), 2))) + "\n                            ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['ADIANTAMENTO'], _vm.processo) && (!_vm.loading.processo && !_vm.loading.tarefa && !_vm.loading.adiantamentos && !_vm.loading.projetos) && _vm.restricaoParaInicializar.length === 0) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', [_c('div', [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('banco')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.adiantamentoSolicitado.formaPagamento !== 4
	      }),
	      expression: "{required: adiantamentoSolicitado.formaPagamento !== 4}"
	    }],
	    attrs: {
	      "options": _vm.listaBancos,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Selecione um banco",
	      "custom-label": _vm.bancoNome,
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "banco",
	      "data-vv-as": "banco",
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.restricaoParaInicializar.length > 0 || _vm.bancoSelecionado
	    },
	    on: {
	      "select": _vm.selecionaBanco
	    },
	    model: {
	      value: (_vm.bancoSelecionado),
	      callback: function($$v) {
	        _vm.bancoSelecionado = $$v
	      },
	      expression: "bancoSelecionado"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('banco')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('agência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5> ' + (_vm._.has(_vm.bancoSelecionado, 'digitoAgencia') && !_vm.bancoSelecionado.digitoAgencia ? 'Caso existam divergência nos dados bancários informados, gentileza <span class=\'realce\'>abrir um chamado</span>.' : 'Caso existam divergência nos dados bancários informados, gentileza <span class=\'realce\'>abrir um chamado</span>.') + ' </h5>'
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "agência",
	      "type": "text",
	      "mask": _vm._.has(_vm.bancoSelecionado, 'digitoAgencia') && !_vm.bancoSelecionado.digitoAgencia ? '####' : '####-X',
	      "tokens": _vm.agenciaTokens,
	      "disabled": "",
	      "masked": ""
	    },
	    model: {
	      value: (_vm.adiantamentoSolicitado.dados_bancarios.agencia),
	      callback: function($$v) {
	        _vm.$set(_vm.adiantamentoSolicitado.dados_bancarios, "agencia", $$v)
	      },
	      expression: "adiantamentoSolicitado.dados_bancarios.agencia"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('conta corrente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Conta " + _vm._s(_vm.adiantamentoSolicitado.dados_bancarios.tipo === 1 ? 'Corrente' : (_vm.adiantamentoSolicitado.dados_bancarios.tipo === 2 ? 'Poupança' : '')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "conta corrente",
	      "type": "text",
	      "mask": ['#-X', '##-X', '###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X', '##########-X', '###########-X'],
	      "tokens": _vm.customTokens,
	      "disabled": "",
	      "masked": ""
	    },
	    model: {
	      value: (_vm.adiantamentoSolicitado.dados_bancarios.conta),
	      callback: function($$v) {
	        _vm.$set(_vm.adiantamentoSolicitado.dados_bancarios, "conta", $$v)
	      },
	      expression: "adiantamentoSolicitado.dados_bancarios.conta"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo da conta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Tipo da Conta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.adiantamentoSolicitado.formaPagamento !== 4
	      }),
	      expression: "{required: adiantamentoSolicitado.formaPagamento !== 4}"
	    }],
	    attrs: {
	      "options": _vm.tiposConta,
	      "multiple": false,
	      "close-on-select": true,
	      "preselect-first": true,
	      "allow-empty": false,
	      "custom-label": _vm.tipoContaNome,
	      "placeholder": "Selecione um tipo de conta",
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "name": "tipo da conta",
	      "data-vv-as": "tipo da conta",
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.processo === 'PRESTACAO_DE_CONTAS' || _vm.restricaoParaInicializar.length || _vm.contaAdiantamento > 0 || _vm.adiantamentoSolicitado.dados_bancarios.tipo
	    },
	    on: {
	      "select": _vm.selecionaTipoConta
	    },
	    model: {
	      value: (_vm.tipoContaSelecionado),
	      callback: function($$v) {
	        _vm.tipoContaSelecionado = $$v
	      },
	      expression: "tipoContaSelecionado"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('tipo da conta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('tipo da conta')))]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length === 0) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos de solicitação de " + _vm._s(_vm._.toLower(_vm.descricaoProcesso[_vm.processo])) + " "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold",
	      "color": "#e32"
	    }
	  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php', {
	    attrs: {
	      "propDocumentos": _vm.adiantamentoSolicitado.documentosAdiantamento,
	      "documentTypes": '',
	      "disable": _vm.ehVisualizacao || _vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa),
	      "local-uso": 'SOLICITACAO_PAGAMENTO'
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length === 0) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php', {
	    attrs: {
	      "propDocumentos": _vm.adiantamentoSolicitado.anexos,
	      "documentTypes": '',
	      "disable": _vm.ehVisualizacao || _vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa),
	      "local-uso": 'SOLICITACAO_PAGAMENTO'
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Revisão', 'Análise', 'Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.ehVisualizacao) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_vm._m(10), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
	    key: _vm.historicoBack.length,
	    attrs: {
	      "propsValidacao": _vm._.head(_vm.documentosLiberacao),
	      "propsHistorico": _vm.historicoBack
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack))) ? _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderHistorico === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack))) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_vm._m(11), _vm._v(" "), _c('historico-antigo', {
	    key: _vm.historicoTarefas.length,
	    attrs: {
	      "propsValidacao": _vm._.head(_vm.documentosLiberacao),
	      "propsHistorico": _vm.historicoTarefas
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && _vm.usuarioLogado.userType !== 'FUNDACAO' && _vm.restricaoParaInicializar.length === 0)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adiantamentoSolicitado.observacao),
	      expression: "adiantamentoSolicitado.observacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao_opcional",
	      "id": "observacao_opcional",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.adiantamentoSolicitado.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.adiantamentoSolicitado, "observacao", $event.target.value)
	      }
	    }
	  })])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise', 'Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "decisoes_aprovação"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.processo || _vm.loading.tarefa || _vm.loading.adiantamentos || _vm.loading.projetos),
	      expression: "loading.processo || loading.tarefa || loading.adiantamentos || loading.projetos"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": _vm.etapa === 'Análise' ? (_vm.processo === 'DEVOLUCAO_DE_ADIANTAMENTO' ? 'Análise Financeira' : 'Autorização') : (_vm.etapa === 'Autorização' ? (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão') : (_vm.etapa === 'Liquidação' || _vm.etapa === 'Análise Financeira' ? 'Conclusão' : '')),
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, _vm.etapa === 'Análise' ? (_vm.processo === 'DEVOLUCAO_DE_ADIANTAMENTO' ? 'Análise Financeira' : 'Autorização') : (_vm.etapa === 'Autorização' ? (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão') : (_vm.etapa === 'Liquidação' || _vm.etapa === 'Análise Financeira' ? 'Conclusão' : '')))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.aprovacao, "resultadoAprovacao", _vm.etapa === 'Análise' ? (_vm.processo === 'DEVOLUCAO_DE_ADIANTAMENTO' ? 'Análise Financeira' : 'Autorização') : (_vm.etapa === 'Autorização' ? (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão') : (_vm.etapa === 'Liquidação' || _vm.etapa === 'Análise Financeira' ? 'Conclusão' : '')))
	      }
	    }
	  }), _vm._v(_vm._s(_vm.etapa === 'Liquidação' ? 'Concluir processo manualmente' : 'Aprovar solicitação') + "\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação', 'Conclusão'], _vm.aprovacao.resultadoAprovacao) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-12",
	    class: {
	      'required-field': _vm.observacaoAprovacaoObrigatoria, 'has-error': _vm.errors.first('observação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao_decisao"
	    }
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adiantamentoSolicitado.observacao),
	      expression: "adiantamentoSolicitado.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.observacaoAprovacaoObrigatoria ? 'required|min:13' : ''),
	      expression: "observacaoAprovacaoObrigatoria ? 'required|min:13' : ''"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observação",
	      "id": "observacao_decisao",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.adiantamentoSolicitado.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.adiantamentoSolicitado, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('observação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('observação')))]) : _vm._e(), _vm._v(" "), (_vm.observacaoAprovacaoObrigatoria) ? _c('p', {
	    staticClass: "help-block"
	  }, [_vm._v("Informe no mínimo 13 caracteres.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.etapa === 'Análise' || _vm.etapa === 'Análise Financeira') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "Revisão",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Revisão")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Revisão")
	      }
	    }
	  }), _vm._v(" Encaminhar para revisão da entidade\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group required-field full col-md-12",
	    class: {
	      'has-error': _vm.errors.first('motivo de devolucao')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.motivosDevolucao,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Selecione um motivo de Devolução para a entidade",
	      "custom-label": _vm.motivoDevolucaoDescricao,
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "motivo de devolucao",
	      "data-vv-as": "motivo de devolucao",
	      "option-height": 30,
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.motivoDevolucao),
	      callback: function($$v) {
	        _vm.motivoDevolucao = $$v
	      },
	      expression: "motivoDevolucao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.aprovacao.resultadoAprovacao === 'Revisão' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa_revisão"
	    }
	  }, [_vm._v("Motivo para revisão:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adiantamentoSolicitado.observacao),
	      expression: "adiantamentoSolicitado.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "motivo para revisão",
	      "rows": "3",
	      "id": "justificativa_revisão",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.adiantamentoSolicitado.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.adiantamentoSolicitado, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('motivo para revisão')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo para revisão')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "Análise",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Análise")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Análise")
	      }
	    }
	  }), _vm._v(" Retornar para análise\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.aprovacao.resultadoAprovacao === 'Análise' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('justificativa reanalise')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa_reanalise"
	    }
	  }, [_vm._v("Motivo para reanalisar:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adiantamentoSolicitado.observacao),
	      expression: "adiantamentoSolicitado.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa reanalise",
	      "rows": "3",
	      "id": "justificativa_reanalise",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.adiantamentoSolicitado.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.adiantamentoSolicitado, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa reanalise')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa reanalise')))]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), (_vm._.includes(['Análise', 'Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [(_vm.loading.suportesFbbAtivos) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando Suportes não encerrados...")]) : _c('span', [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaSuportes,
	      "multiple": true,
	      "max": 3,
	      "close-on-select": true,
	      "placeholder": 'Neste id ' + _vm.id + ' pode ter vinculado opcionalmente de um a três Suportes desta lista de chamados não encerrados',
	      "custom-label": _vm.suporteNome,
	      "track-by": "numero",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "suporte_fbb",
	      "data-vv-as": "suporte_fbb",
	      "disabled": _vm.ehVisualizacao
	    },
	    scopedSlots: _vm._u([{
	      key: "maxElements",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "text-red"
	        }, [_vm._v("Já escolheu o limite de três suportes que pode vincular a este ID")])]
	      }
	    }], null, false, 1318475097),
	    model: {
	      value: (_vm.adiantamentoSolicitado.suporteFbb),
	      callback: function($$v) {
	        _vm.$set(_vm.adiantamentoSolicitado, "suporteFbb", $$v)
	      },
	      expression: "adiantamentoSolicitado.suporteFbb"
	    }
	  })], 1)])])]) : _vm._e()])])])])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Cargo")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Final do Mandato")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Ocorrência")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Data")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Situação")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v("Não há ocorrências ativas")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Adiantamentos Concedidos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "centralizado",
	    staticStyle: {
	      "padding": "10px",
	      "font-size": "1.5rem"
	    }
	  }, [_c('span', [_vm._v("Total de adiantamento já liberado")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado",
	    staticStyle: {
	      "padding": "10px",
	      "font-size": "1.5rem"
	    }
	  }, [_c('span', [_vm._v("Total de Prestação de contas em execução")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado",
	    staticStyle: {
	      "padding": "10px",
	      "font-size": "1.5rem"
	    }
	  }, [_c('span', [_vm._v("Total Pendente de Prestação de contas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dados Bancários")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Anexos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de solicitação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico Antigo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Observação Opcional")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Decisão")])])
	}]}

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    style: ('min-height: ' + _vm.alturaContentWrapper + 'px')
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Edição de Formulário'
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm._.isNull(_vm.formularioCarregado.id) ? 'Novo Formulário' : (_vm.ehVisualizacao ? 'Visualiza' : 'Edição de') + ' formulário  ID ' + _vm.formularioCarregado.id))]), _vm._v(" "), (!_vm.loading.tela && !_vm.ehVisualizacao) ? _c('span', [(_vm._.isNull(_vm.formularioCarregado.id)) ? _c('span', [(_vm.salvaFormulario.statusSalvamento !== 'PROCESSANDO') ? _c('g-button-moema', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    attrs: {
	      "color": "primary",
	      "type": "button",
	      "title": '<h5>Ao clicar ele criará este formulário no sistema para uso. Então antes de fazê-lo verifique se não existe um formulário desejado já criado</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cria novo formulário")]) : _vm._e(), _vm._v(" "), (_vm.salvaFormulario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
	    staticClass: "button--moema warning",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 50px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-borda-dark) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Criando o formulário")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.formularioCarregado.id)) ? _c('span', [(_vm.salvaFormulario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
	    staticClass: "button--moema warning",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 50px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-borda-dark) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Salvando")]) : (_vm.salvaFormulario.statusSalvamento === 'FEITO') ? _c('span', {
	    staticClass: "button--moema success",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 10px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-verde) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" Formulário salvo")]) : _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar alterações")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading.tela) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-formulario'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (!_vm._.isNull(_vm.formularioCarregado.id)) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.abreFormulario(_vm._.split(_vm.formularioCarregado.link_acesso, '-')[3])
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link-square",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Visualizar form em branco")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.abreFormulario(_vm._.split(_vm.formularioCarregado.link_acesso, '-')[2])
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link-square",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Visualização")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: _vm._.isNull(_vm.formularioCarregado.id) ? 'Novo' : (_vm.ehVisualizacao ? 'Visualização' : 'Edição'),
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarTitulo),
	      expression: "mostrarTitulo"
	    }],
	    staticClass: "box-body form-horizontal"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Título do Formulário")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.nome),
	      expression: "formularioCarregado.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "nome",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>O nome do formulário aparecerá como título ao preencher.<br/>O SGP não permitirá duplicidade de nomes.</h5>'
	    },
	    domProps: {
	      "value": (_vm.formularioCarregado.nome)
	    },
	    on: {
	      "blur": _vm.verificaNomeJaExiste,
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        return _vm.fecharEdicao($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formularioCarregado, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Nome do formulário é obrigatório e não deve ser repetir")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('nome_existe')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome_existe')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.tipo),
	      expression: "formularioCarregado.tipo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "tipo",
	    staticClass: "form-control",
	    attrs: {
	      "name": "tipo",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>O tipo do formulário define seu fluxo e tratamento pelo sistema: <span style=\'text-align: left\'>' +
	        '<p><span class=\'realce\'>Marco 0</span> ou <span class=\'realce\'>Marco 1</span> são enviados menualmente pela FBB ou automaticamente pelo SGP, aparecem para Validação (Análise) e podem ser devolvidos para Revisão</p>' +
	        '<p><span class=\'realce\'>Genérico</span> é enviado só manualmente, não possui Validação (é encerrado ao Concluir) e pode ser usado como sub formulário</p>' +
	        '<p><span class=\'realce\'>Participante</span> é iguai ao Genérico, mas é usado no cálculo de amostragem quando está como um sub formulário em outro do tipo Marco 0 ou 1</p>' +
	        '</span></h5>'
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.formularioCarregado.opcoes.periodicidade = null;
	        _vm.formularioCarregado.opcoes.bi = !_vm._.includes(['AVALIACAO_GENERICO', 'AVALIACAO_PARTICIPANTE'], _vm.formularioCarregado.tipo)
	      }]
	    }
	  }, _vm._l((_vm.tipoFormulario), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.codigo
	      }
	    }, [_vm._v(_vm._s(tipo.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('tipo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('tipo_programa_existe')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo_programa_existe')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarTitulo),
	      expression: "mostrarTitulo"
	    }],
	    staticClass: "box-body form-horizontal"
	  }, [(_vm.loading.programas) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando programas ...")]) : _vm._e(), _vm._v(" "), (!_vm.loading.programas) ? _c('span', [_c('div', {
	    class: (_vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo) ? 'required-field' : '') + (_vm.errors.first('programas_sociais') ? ' has-error' : '')
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Programas")]), _vm._v(" "), _c('div', {
	    class: _vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo) ? 'col-md-6' : 'col-md-10'
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo) ? 'required' : false),
	      expression: "_.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], formularioCarregado.tipo) ? 'required' : false"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "programas_sociais",
	    attrs: {
	      "options": _vm.programasSociais,
	      "multiple": true,
	      "close-on-select": true,
	      "placeholder": 'Pode vincular opcionalmente programas a este formulário',
	      "track-by": "id",
	      "custom-label": function (option) {
	        return ("" + (option.id + ' - ' + option.descricao))
	      },
	      "label": "descricao",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Clique ou ENTER para selecionar",
	      "deselectLabel": "Clique ou ENTER para remover",
	      "name": "programas_sociais",
	      "data-vv-as": "programas_sociais",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>' + (_vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo) ?
	          'É obrigatório quando o tipo for Marco 0 ou 1<br/> Deve escolher somente um programa neste caso' :
	          'É opcional quando o tipo for Genérico ou Particiapnte. Pode deixar em branco ou escolher um ou mais programas') +
	        '<p>O(s) programa(s) escolhido(s) limitam quais projetos do SGP podem ser vinculados ao formulário que será preenchido</p>' +
	        '</h5>'
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "text-gray"
	        }, [_vm._v(_vm._s(props.option.id) + " ")]), _vm._v(" " + _vm._s(props.option.descricao) + "\n                      ")]
	      }
	    }], null, false, 1030773195),
	    model: {
	      value: (_vm.formularioCarregado.opcoes.vinculo.programas),
	      callback: function($$v) {
	        _vm.$set(_vm.formularioCarregado.opcoes.vinculo, "programas", $$v)
	      },
	      expression: "formularioCarregado.opcoes.vinculo.programas"
	    }
	  }), _vm._v(" "), (_vm.errors.first('programas_sociais')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('programas_sociais')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo)) ? _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Prazo resposta")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.periodicidade),
	      expression: "formularioCarregado.opcoes.periodicidade"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "periodicidade",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Definir prazo para cobrança de preenchimento da entidade</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado.opcoes, "periodicidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Sem aviso")]), _vm._v(" "), _vm._l((12), function(n) {
	    return _c('option', {
	      domProps: {
	        "value": n
	      }
	    }, [_vm._v(_vm._s(n) + " " + _vm._s(n > 1 ? 'meses' : 'mês'))])
	  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarTitulo),
	      expression: "mostrarTitulo"
	    }],
	    staticClass: "box-body form-horizontal"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': (_vm.errors.first('apos abrir'))
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Após abrir")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.abrir.acao),
	      expression: "formularioCarregado.opcoes.abrir.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "apos abrir",
	    staticClass: "form-control",
	    attrs: {
	      "name": "apos abrir",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Logo que um formulário abrir para preenchimento ele pode estar:<span style=\'text-align: left\'>' +
	        '<p><span class=\'realce\'>Normal</span> onde todos os campos e funcionalidades estarão disponíveis</p>' +
	        '<p><span class=\'realce\'>Somente Leitura</span> força para que todo o conteúdo não possa ser alterado. Ideal para formulários (telas) de <b>agradecimento</b></p>' +
	        '</span></h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado.opcoes.abrir, "acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.acoesAposAbrir), function(acao) {
	    return _c('option', {
	      domProps: {
	        "value": acao.codigo
	      }
	    }, [_vm._v(_vm._s(acao.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('apos abrir')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('apos abrir')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('elemento chave')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Elemento chave")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.elemento_chave),
	      expression: "formularioCarregado.opcoes.elemento_chave"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "elemento chave",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Nesta lista aparecerão todos os elementos do tipo <i>TEXTO_SIMPLES</i> ou <i>NUMERO</i> que constam no formulário<br/><br/>' +
	        '<p>Se um elemento desta lista for escolhido como chave, o sistema não permitirá durante o preenchimento que o formulário seja concluído se já houver outro entregue antes com o mesmo valor informado</p>' +
	        '<p>Ideal para campos como CPF em formulários tipo Participante, por exemplo</p>' +
	        '</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado.opcoes, "elemento_chave", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Não há")]), _vm._v(" "), _vm._l((_vm._.filter(_vm.editandoFormulario, function(c) {
	    return _vm._.includes(['NUMERO', 'TEXTO_SIMPLES'], c.elemento)
	  })), function(controle, idx) {
	    return _c('option', {
	      domProps: {
	        "value": controle.id
	      }
	    }, [_vm._v("(" + _vm._s(controle.id) + ") " + _vm._s(_vm.removerTagHtmlString(controle.titulo)))])
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarTitulo),
	      expression: "mostrarTitulo"
	    }],
	    staticClass: "box-body form-horizontal"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': (_vm.errors.first('apos concluir') || _vm.errors.first('concluir_url') || _vm.errors.first('concluir_formulario'))
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Após Concluir")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.concluir.acao),
	      expression: "formularioCarregado.opcoes.concluir.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "apos concluir",
	    staticClass: "form-control",
	    attrs: {
	      "name": "apos concluir",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Logo que o preenchimento de um formulário for concluído, o SGP:<span style=\'text-align: left\'>' +
	        '<p><span class=\'realce\'>Sai da tela</span> de preenchimento e vai para a tela inicial ou SGP (comportamento padrão)</p>' +
	        '<p><span class=\'realce\'>Abre o formulário</span> já criado para que inicie outro preenchimento (útil para <b>agradecimentos</b> ou encadeamento de formulários diferentes)</p>' +
	        '<p><span class=\'realce\'>Vai para o endereço</span> defindo, por exemplo a página oficial da FBB ou outra url (útil para agregar valor ao formulário com outro site)</p>' +
	        '</span></h5>'
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado.opcoes.concluir, "acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.formularioCarregado.opcoes.concluir.parametro = null
	      }]
	    }
	  }, _vm._l((_vm.acoesAposConcluir), function(acao) {
	    return _c('option', {
	      domProps: {
	        "value": acao.codigo
	      }
	    }, [_vm._v(_vm._s(acao.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('apos concluir')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Escolha um item da lista")]) : _vm._e()]), _vm._v(" "), (_vm.formularioCarregado.opcoes.concluir.acao === 'ABRIR_URL') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.concluir.parametro),
	      expression: "formularioCarregado.opcoes.concluir.parametro"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "concluir_url",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "concluir_url",
	      "disabled": _vm.ehVisualizacao,
	      "placeholder": "https://www.fbb.org.br",
	      "title": '<h5>Informe um url válida, exemplo <i>https://www.fbb.org.br</i><br/> que o SGP irá, logo após o preenchimento seja concluído pelo usuário<br/><br/>' +
	        'Útil para complementar informação direcionando para páginas de parceiros ou notícias ou agradecimentos ou outro formulário (do SGP ou não) etc</h5>'
	    },
	    domProps: {
	      "value": (_vm.formularioCarregado.opcoes.concluir.parametro)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formularioCarregado.opcoes.concluir, "parametro", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('concluir_url')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Informe um endereço web para o qual o usuário que estiver preenchedo será direcionado após concluir")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.formularioCarregado.opcoes.concluir.acao === 'ABRIR_FORMULARIO') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.concluir.parametro),
	      expression: "formularioCarregado.opcoes.concluir.parametro"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "concluir_formulario",
	    staticClass: "form-control",
	    attrs: {
	      "name": "concluir_formulario",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Escolha nesta lista, um dos formulário ativos já cadastrados no SGP<br/><br/>' +
	        '<p>Logo após o preenchimento seja concluído pelo usuário, o SGP abrirá o formulário selecionado</p>' +
	        '<p>Atente que: o formulário novo aberto não faz parte do fluxo do formulário anterior</p>' +
	        '<p>Assim, o novo não terá informações sensíveis ao processo anterior, que é útil para telas de agradecimento ou quando se quer separar informações e fluxos bem distintos (como um formulário sendo de proposta e outro de cadastro de entidade, por exemplo)</p>' +
	        '</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado.opcoes.concluir, "parametro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.controles, ['grupo', 'FORMULARIO'])), function(formulario) {
	    return _c('option', {
	      domProps: {
	        "value": formulario.configuracao.padrao[0]
	      }
	    }, [_vm._v(_vm._s(formulario.informacao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('concluir_formulario')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve informar um formulário que abrirá logo após concluir preenchimento deste formulário")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarTitulo),
	      expression: "mostrarTitulo"
	    }],
	    staticClass: "box-body form-horizontal"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Numeração automática")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.numeracao),
	      expression: "formularioCarregado.opcoes.numeracao"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "numeracao automatica",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Selecione a opção desejada quanto numeração das questões do form.</p>' +
	        '<p>Atente que a numeração é atribuída a todos os elementos (exceto de layout), independentemente do elemento estar visível ou ocultado, ou seja,<br/>' +
	        'se um formulário tiver elementos ocultos, a numeração vai aparentar que está \'quebrada\' ou não sequencial</p></h5>'
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado.opcoes, "numeracao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.numeracaoAutomatica]
	    }
	  }, _vm._l((_vm.opcoesNumeracaoAutomatica), function(acao) {
	    return _c('option', {
	      domProps: {
	        "value": acao.codigo
	      }
	    }, [_vm._v(_vm._s(acao.descricao))])
	  }), 0)])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Permitir observações")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.observacao),
	      expression: "formularioCarregado.opcoes.observacao"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Se desejar que haja um campo de observação opcional para o usuário fazer apontamentos, mas que não devem constar nos dados do formulário (não irão para O BI nem para o Excel), então escolha uma das opções abaixo de quem pode usar este campo</p>' +
	        '<p>Atente para o que for informado neste campo ficará em destaque no topo do formulário preenchido e no histórico do fluxo do processo</p></h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado.opcoes, "observacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoesObservacao), function(acao) {
	    return _c('option', {
	      domProps: {
	        "value": acao.codigo
	      }
	    }, [_vm._v(_vm._s(acao.descricao))])
	  }), 0)])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Exibir histórico")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formularioCarregado.opcoes.historico),
	      expression: "formularioCarregado.opcoes.historico"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "historico",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>O fluxo do processo gera um histórico de etapas concluídas (solicitação, revisão, análise etc) que podem ser vistos <b>por todos</b>, <b>só pela FBB</b> ou não exibidos</p>' +
	        '<p>Observação: mesmo que o histórico não seja exibido, ele é gerado e guardado para conferência e auditoria, se necessário</p></h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.formularioCarregado.opcoes, "historico", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoesHistorico), function(acao) {
	    return _c('option', {
	      domProps: {
	        "value": acao.codigo
	      }
	    }, [_vm._v(_vm._s(acao.descricao))])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-9 alca_mostrar_ocultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrarTitulo = !_vm.mostrarTitulo
	      }
	    }
	  }, [_c('div'), _c('i', {
	    class: 'fa fa-chevron-' + (_vm.mostrarTitulo ? 'up' : 'down'),
	    staticStyle: {
	      "padding": "2px"
	    }
	  }), _vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 alca_mostrar_ocultar",
	    on: {
	      "click": function($event) {
	        _vm.mostrarComponentes = !_vm.mostrarComponentes
	      }
	    }
	  }, [_c('div'), _c('i', {
	    class: 'fa fa-chevron-' + (_vm.mostrarComponentes ? 'right' : 'left'),
	    staticStyle: {
	      "padding": "2px 4px"
	    }
	  }), _vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    class: _vm.mostrarComponentes ? 'col-md-9' : 'col-md-12',
	    style: ('overflow-y: auto; height: ' + (_vm.alturaContentWrapper - (_vm.mostrarTitulo ? 372 : 94)) + 'px;'),
	    attrs: {
	      "id": "edicao_formulario"
	    }
	  }, [(_vm.editandoFormulario.length === 0) ? _c('span', [_c('draggable', _vm._b({
	    staticClass: "list-group",
	    attrs: {
	      "tag": "div",
	      "handle": ".handle",
	      "group": "edicao",
	      "list": _vm.editandoFormulario
	    },
	    on: {
	      "start": function($event) {
	        _vm.dragging = true
	      },
	      "end": function($event) {
	        _vm.dragging = false
	      }
	    }
	  }, 'draggable', {
	    animation: 200,
	    group: 'edicao',
	    disabled: false,
	    ghostClass: 'ghost'
	  }, false), [_c('p', {
	    staticStyle: {
	      "margin": "20px",
	      "font-style": "italic",
	      "color": "var(--cor-destaque)"
	    }
	  }, [(_vm.errors.first('edicao_formulario')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('edicao_formulario')))]) : _c('span', [_vm._v("Conteúdo do formulário aqui"), _c('br'), _vm._v("Arraste para cá ou Clique num dos controles à direta")])])])], 1) : _c('span', [_c('draggable', _vm._b({
	    staticClass: "list-group",
	    attrs: {
	      "tag": "div",
	      "handle": ".handle",
	      "group": "edicao",
	      "list": _vm.editandoFormulario
	    },
	    on: {
	      "start": function($event) {
	        _vm.dragging = true
	      },
	      "end": function($event) {
	        _vm.dragging = false
	      }
	    }
	  }, 'draggable', {
	    animation: 200,
	    group: 'edicao',
	    disabled: false,
	    ghostClass: 'ghost'
	  }, false), _vm._l((_vm.editandoFormulario), function(controle, idx) {
	    return _c('div', {
	      class: 'box-body elemento' + (!controle.mostrar ? ' marcar_oculto' : '') +
	        (!_vm._.isNull(_vm.editandoElemento) ? (_vm.editandoElemento.id !== controle.id ? ' controle_esmaecido' : ' caixa_propriedades') : '')
	    }, [_c('div', {
	      staticClass: "botoes_acao_elemento"
	    }, [_c('span', {
	      staticStyle: {
	        "color": "var(--cor-fraca)",
	        "padding": "0 5px",
	        "cursor": "default"
	      }
	    }, [_vm._v(_vm._s(controle.id))]), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id),
	        expression: "!_.isNull(editandoElemento) && editandoElemento.id === controle.id"
	      }],
	      staticClass: "botao_acao_elemento elemento_fechar",
	      on: {
	        "click": _vm.fecharEdicao
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-close"
	    })]), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (idx > 0),
	        expression: "idx > 0"
	      }],
	      staticClass: "botao_acao_elemento elemento_mover",
	      on: {
	        "click": function($event) {
	          return _vm.moveElemento(idx, -1, _vm.editandoFormulario)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-arrow-up"
	    })]), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (idx < _vm.editandoFormulario.length - 1),
	        expression: "idx < editandoFormulario.length - 1"
	      }],
	      staticClass: "botao_acao_elemento elemento_mover",
	      on: {
	        "click": function($event) {
	          return _vm.moveElemento(idx, 1, _vm.editandoFormulario)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-arrow-down"
	    })]), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm._.find(_vm.editandoFormulario, ['id', controle.bi])),
	        expression: "!_.find(editandoFormulario, ['id', controle.bi])"
	      }],
	      staticClass: "botao_acao_elemento elemento_duplicar",
	      on: {
	        "click": function($event) {
	          return _vm.duplicaElemento(idx, controle)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-files-o"
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "botao_acao_elemento elemento_excluir",
	      on: {
	        "click": function($event) {
	          return _vm.removeElemento(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])]), _vm._v(" "), (_vm._.includes(['CONTROLE', 'PERSONALIZADO'], controle.grupo)) ? _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!(!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id && !_vm.dragging)),
	        expression: "!(!_.isNull(editandoElemento) && editandoElemento.id === controle.id && !dragging)"
	      }],
	      on: {
	        "click": function($event) {
	          return _vm.editaElemento(idx)
	        }
	      }
	    }, [_c('div', {
	      ref: controle.id,
	      refInFor: true,
	      class: 'row handle' + (controle.obrigatorio ? ' required-field' : ''),
	      attrs: {
	        "id": controle.id
	      }
	    }, [_c('label', {
	      staticClass: "control-label col-md-12 tituloControle"
	    }, [(!_vm._.isNull(_vm.formularioCarregado.opcoes.numeracao) && _vm._.has(controle, 'numeracao')) ? _c('span', {
	      staticClass: "text-gray"
	    }, [_vm._v(_vm._s(controle.numeracao) + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm._.isEmpty(controle.titulo) ? 'Informe o tílulo' : controle.titulo)
	      }
	    }), _vm._v(" "), (_vm._.has(controle, 'descricao') && !_vm._.isEmpty(controle.descricao)) ? _c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-question-circle",
	      attrs: {
	        "title": '<h5>' + (controle.descricao) + '</h5>',
	        "aria-hidden": "true"
	      }
	    }) : _vm._e()]), _vm._v(" "), (controle.elemento === 'NUMERO') ? _c('div', {
	      class: _vm._.includes(['TELEFONE', 'CNPJ', 'CPF'], controle.configuracao.formato) ? 'col-md-4' : 'col-md-3'
	    }, [_c('input', {
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "disabled": true,
	        "placeholder": controle.configuracao.formato === 'CPF' ? '000.000.000-00' : (controle.configuracao.formato === 'CNPJ' ? '00.000.000/0000-00' :
	          (controle.configuracao.formato === 'TELEFONE' ? '(00) 0000-0000' :
	            (controle.configuracao.formato === 'INTEIRO' ? '0' :
	              (controle.configuracao.formato === 'CEP' ? '00000-000' :
	                (controle.configuracao.formato === 'DECIMAL' ? '0,0000' : 'R$ 0,00')))))
	      }
	    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'TEXTO_SIMPLES') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('input', {
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "disabled": true,
	        "maxlength": _vm._.toSafeInteger(controle.configuracao.maximo) === 0 ? 250 : _vm._.toSafeInteger(controle.configuracao.maximo)
	      }
	    }), _vm._v(" "), (_vm._.toSafeInteger(controle.configuracao.maximo) > 1) ? _c('i', {
	      staticStyle: {
	        "float": "right",
	        "color": "silver"
	      }
	    }, [_vm._v("Até " + _vm._s(_vm._.toSafeInteger(controle.configuracao.maximo)) + " caracteres")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'TEXTO_LONGO') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('textarea', {
	      directives: [{
	        name: "resizable",
	        rawName: "v-resizable"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "disabled": true
	      }
	    }), _vm._v(" "), (_vm._.toSafeInteger(controle.configuracao.maximo) > 1 && controle.configuracao.formato === 'SOMENTE_TEXTO') ? _c('i', {
	      staticStyle: {
	        "float": "right",
	        "color": "silver"
	      }
	    }, [_vm._v("Até " + _vm._s(_vm._.toSafeInteger(controle.configuracao.maximo)) + " caracteres")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SELECAO_SIMPLES') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('select', {
	      staticClass: "form-control",
	      attrs: {
	        "disabled": true
	      }
	    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SELECAO_MULTIPLA') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('select', {
	      staticClass: "form-control",
	      attrs: {
	        "disabled": true
	      }
	    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'BOOLEANO') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('span', [_c('label', {
	      staticClass: "radio-inline new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "7px"
	      }
	    }, [_c('input', {
	      attrs: {
	        "type": "radio",
	        "disabled": true
	      }
	    }), _vm._v(" " + _vm._s(controle.configuracao.conteudo.linhas[0].descricao) + " "), _c('div', {
	      staticClass: "new-control-indicator"
	    })]), _vm._v(" "), _c('label', {
	      staticClass: "radio-inline new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "7px"
	      }
	    }, [_c('input', {
	      attrs: {
	        "type": "radio",
	        "disabled": true
	      }
	    }), _vm._v(" " + _vm._s(controle.configuracao.conteudo.linhas[1].descricao) + " "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'CLASSIFICACAO') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [(controle.configuracao.formato === 'NUMEROS') ? _c('span', _vm._l((_vm._.range(_vm._.toSafeInteger(controle.configuracao.minimo), _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
	      return _c('span', {
	        staticClass: "fa fa-stack fa-2x elemento_classificacao classificacao_numeral"
	      }, [_c('i', {
	        staticClass: "fa fa-solid fa-circle-thin fa-stack-1x"
	      }), _vm._v(" "), _c('span', {
	        staticClass: "fa fa-stack-1x"
	      }, [_vm._v(_vm._s(n))])])
	    }), 0) : _c('span', _vm._l((_vm._.range(_vm._.toSafeInteger(controle.configuracao.minimo), _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
	      return _c('i', {
	        class: 'elemento_classificacao fa fa-2x ' + (_vm._.isNull(controle.configuracao.formato) || controle.configuracao.formato === 'ESTRELA' ? 'fa-star-o' : (controle.configuracao.formato === 'CIRCULO' ? 'fa-circle-thin' : (controle.configuracao.formato === 'LIKE' ? 'fa-thumbs-o-up' : 'fa-smile-o')))
	      })
	    }), 0)]) : _vm._e(), _vm._v(" "), (controle.elemento === 'DATA') ? _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('input', {
	      staticClass: "form-control",
	      attrs: {
	        "type": "date",
	        "disabled": true
	      }
	    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'PERIODO') ? _c('div', {
	      staticClass: "col-md-8"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('span', {
	      staticClass: "input-group-btn"
	    }, [_c('span', {
	      staticClass: "btn",
	      staticStyle: {
	        "cursor": "default"
	      }
	    }, [_vm._v("De")])]), _vm._v(" "), _c('input', {
	      staticClass: "form-control",
	      attrs: {
	        "type": "date",
	        "disabled": true
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "input-group-btn"
	    }, [_c('span', {
	      staticClass: "btn",
	      staticStyle: {
	        "cursor": "default"
	      }
	    }, [_vm._v("Até")])]), _vm._v(" "), _c('input', {
	      staticClass: "form-control",
	      attrs: {
	        "type": "date",
	        "disabled": true
	      }
	    })])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'NPS') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('table', {
	      staticClass: "elemento_NPS_escala",
	      attrs: {
	        "border": "1"
	      }
	    }, [_c('tr', _vm._l((_vm._.range(1, _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
	      return _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v(" " + _vm._s(n) + " ")])
	    }), 0)]), _vm._v(" "), _c('table', {
	      staticClass: "elemento_NPS_limites"
	    }, [_c('tr', [_c('td', {
	      staticClass: "truncar"
	    }, [_vm._v(_vm._s(controle.configuracao.conteudo.linhas[0].descricao))]), _c('td', {
	      staticClass: "text-right truncar"
	    }, [_vm._v(_vm._s(controle.configuracao.conteudo.linhas[1].descricao))])])])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LIKERT') ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('table', {
	      staticClass: "elemento_likert_matrix table-hover"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "w30"
	    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.colunas), function(coluna) {
	      return (coluna.mostrar) ? _c('th', {
	        staticClass: "elemento_likert_cabecalho_coluna"
	      }, [_vm._v(_vm._s(coluna.descricao))]) : _vm._e()
	    })], 2)]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.linhas), function(linha) {
	      return _c('tr', [_c('td', {
	        staticClass: "elemento_likert_pergunta"
	      }, [_vm._v(_vm._s(_vm._.isEmpty(linha.descricao) ? 'Informe uma questão ...' : linha.descricao))]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.colunas), function(coluna) {
	        return (coluna.mostrar) ? _c('td', {
	          staticClass: "elemento_likert_opcoes"
	        }, [_c('i', {
	          staticClass: "fa fa-circle-thin fa-2x"
	        })]) : _vm._e()
	      })], 2)
	    })], 2)]) : _vm._e(), _vm._v(" "), (controle.elemento === 'UF_MUNICIPIO') ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('multiselect', {
	      attrs: {
	        "placeholder": "Nome do município",
	        "options": [],
	        "disabled": true
	      }
	    })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['LAYOUT'], controle.grupo)) ? _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!(!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id && !_vm.dragging)),
	        expression: "!(!_.isNull(editandoElemento) && editandoElemento.id === controle.id && !dragging)"
	      }],
	      on: {
	        "click": function($event) {
	          return _vm.editaElemento(idx)
	        }
	      }
	    }, [(controle.elemento === 'TEXTO_FIXO') ? _c('div', {
	      staticClass: "row handle"
	    }, [_c('div', {
	      staticClass: "col-md-12",
	      domProps: {
	        "innerHTML": _vm._s(controle.titulo)
	      }
	    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LINHA_HORIZONTAL') ? _c('div', {
	      staticClass: "row handle"
	    }, [_c('hr')]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LOGOMARCA_FBB') ? _c('div', {
	      staticClass: "row handle"
	    }, [(!_vm._.isEmpty(controle.descricao)) ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('a', {
	      attrs: {
	        "href": controle.descricao
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": _vm._.get(controle.configuracao, 'formato', 'LOGO_HORIZONTAL') === 'LOGO_HORIZONTAL' ? '/static/img/logo-login.png' : '/static/img/logo-vertical.png',
	        "alt": controle.titulo
	      }
	    })])]) : _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm._.get(controle.configuracao, 'formato', 'LOGO_HORIZONTAL') === 'LOGO_HORIZONTAL' ? '/static/img/logo-login.png' : '/static/img/logo-vertical.png',
	        "alt": controle.titulo
	      }
	    })])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SECAO') ? _c('div', {
	      class: ('secao_' + (_vm._.isEmpty(controle.configuracao) ? 'padrao' : _vm._.toLower(controle.configuracao.formato))) + ' row handle',
	      style: (!_vm._.isNull(_vm.editandoFormulario) ? 'color: black !important' : '')
	    }, [_c('div', {
	      staticClass: "col-md-12"
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(controle.titulo)
	      }
	    }), _vm._v(" "), (_vm._.has(controle, 'descricao') && !_vm._.isEmpty(controle.descricao)) ? _c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-question-circle",
	      attrs: {
	        "title": '<h5>' + (controle.descricao) + '</h5>',
	        "aria-hidden": "true"
	      }
	    }) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.grupo === 'FORMULARIO') ? _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!(!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id && !_vm.dragging)),
	        expression: "!(!_.isNull(editandoElemento) && editandoElemento.id === controle.id && !dragging)"
	      }],
	      on: {
	        "click": function($event) {
	          return _vm.editaElemento(idx)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "row handle"
	    }, [_c('label', {
	      staticClass: "control-label col-md-12"
	    }, [(!_vm._.isNull(_vm.formularioCarregado.opcoes.numeracao) && _vm._.has(controle, 'numeracao')) ? _c('span', {
	      staticClass: "text-gray"
	    }, [_vm._v(_vm._s(controle.numeracao) + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm._.isEmpty(controle.titulo) ? 'Informe o tílulo' : controle.titulo)
	      }
	    }), _vm._v(" "), (_vm._.has(controle, 'descricao') && !_vm._.isEmpty(controle.descricao)) ? _c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-question-circle",
	      attrs: {
	        "title": '<h5>' + (controle.descricao) + '</h5>',
	        "aria-hidden": "true"
	      }
	    }) : _vm._e()]), _vm._v(" "), (!_vm._.includes(['SOMENTE_LINK'], controle.configuracao.formato)) ? _c('span', [(_vm._.includes(['COMPLETO_COM_LINK', 'COMPLETO_SEM_LINK'], controle.configuracao.formato)) ? _c('div', {
	      staticClass: "col-md-2"
	    }, [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "type": "button"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  Adicionar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('input', {
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "placeholder": "Pesquisa...",
	        "disabled": true
	      }
	    })]), _vm._v(" "), (_vm._.includes(controle.configuracao.formato, 'COM_LINK')) ? _c('div', {
	      staticClass: "col-md-6"
	    }, [_vm._v("\n                                  Link para este formulário: "), _c('br'), _vm._v(" "), _c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(_vm.urlLaravel + '/formulario/' + controle.configuracao.padrao[0]))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-md-12"
	    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {}, [_c('b-container', {
	      attrs: {
	        "fluid": ""
	      }
	    }, [_c('b-table', {
	      attrs: {
	        "show-empty": "",
	        "stacked": "md",
	        "striped": "",
	        "bordered": controle.configuracao.conteudo.bordered,
	        "items": controle.valor,
	        "fields": controle.configuracao.conteudo.colunas,
	        "current-page": controle.configuracao.conteudo.currentPage,
	        "per-page": controle.configuracao.conteudo.perPage,
	        "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
	        "empty-text": "Nenhum registro encontrado",
	        "sort-by": controle.configuracao.conteudo.sortBy,
	        "sort-desc": controle.configuracao.conteudo.sortDesc
	      },
	      on: {
	        "update:sortBy": function($event) {
	          return _vm.$set(controle.configuracao.conteudo, "sortBy", $event)
	        },
	        "update:sort-by": function($event) {
	          return _vm.$set(controle.configuracao.conteudo, "sortBy", $event)
	        },
	        "update:sortDesc": function($event) {
	          return _vm.$set(controle.configuracao.conteudo, "sortDesc", $event)
	        },
	        "update:sort-desc": function($event) {
	          return _vm.$set(controle.configuracao.conteudo, "sortDesc", $event)
	        }
	      },
	      scopedSlots: _vm._u([(!_vm._.includes(controle.configuracao.formato, 'MINIMO')) ? {
	        key: "actions",
	        fn: function(row) {
	          return [(_vm._.includes(controle.configuracao.formato, 'COMPLETO')) ? _c('g-button-ujarak', {
	            attrs: {
	              "color": "primary",
	              "size": "button--size-ss"
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-pencil-square-o",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm._.includes(controle.configuracao.formato, 'COMPLETO')) ? _c('g-button-ujarak', {
	            attrs: {
	              "color": "error",
	              "size": "button--size-ss"
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-trash",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          }), _vm._v(" Excluir")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	            attrs: {
	              "color": "success",
	              "size": "button--size-ss"
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-search",
	            attrs: {
	              "aria-label": "false"
	            }
	          }), _vm._v(" Visualizar")])]
	        }
	      } : null], null, true)
	    }), _vm._v(" "), _c('b-row', [_c('b-col', {
	      staticClass: "my-1",
	      attrs: {
	        "md": "6",
	        "right": ""
	      }
	    }, [_c('b-pagination', {
	      staticClass: "my-3",
	      attrs: {
	        "total-rows": controle.configuracao.conteudo.totalRows,
	        "per-page": controle.configuracao.conteudo.perPage
	      },
	      model: {
	        value: (controle.configuracao.conteudo.currentPage),
	        callback: function($$v) {
	          _vm.$set(controle.configuracao.conteudo, "currentPage", $$v)
	        },
	        expression: "controle.configuracao.conteudo.currentPage"
	      }
	    })], 1)], 1)], 1)], 1)]) : _c('span', [_c('div', {
	      staticClass: "col-md-12"
	    }, [_vm._v("\n                                  Link de acesso para este formulário. Repasse para quem for preencher ele: "), _c('br'), _vm._v(" "), _c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(_vm.urlLaravel + '/formulario/' + controle.configuracao.padrao[0]))])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id && !_vm.dragging) ? _c('div', {
	      staticClass: "elemento_propriedades well-sm form-horizontal"
	    }, [_c('div', {
	      staticClass: "form-group required-field"
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v(_vm._s(controle.elemento === 'TEXTO_FIXO' ? 'Texto' : 'Título'))]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-10"
	    }, [_c('quill-editor', {
	      ref: "refQuillEditor",
	      refInFor: true,
	      attrs: {
	        "disabled": controle.grupo === 'PERSONALIZADO',
	        "options": controle.elemento === 'TEXTO_FIXO' ? _vm.quillOptionsCompleto : _vm.quillOptionsTitulo
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          return _vm.fecharEdicao($event)
	        }
	      },
	      model: {
	        value: (controle.titulo),
	        callback: function($$v) {
	          _vm.$set(controle, "titulo", $$v)
	        },
	        expression: "controle.titulo"
	      }
	    })], 1)]), _vm._v(" "), (controle.elemento !== 'TEXTO_FIXO') ? _c('div', {
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Ajuda")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-10"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.descricao),
	        expression: "controle.descricao"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (controle.descricao)
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          return _vm.fecharEdicao($event)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle, "descricao", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (!_vm._.isEmpty(controle.descricao) || controle.grupo !== 'PERSONALIZADO') ? _c('span', {
	      staticClass: "input-group-btn"
	    }, [_c('button', {
	      staticClass: "btn",
	      staticStyle: {
	        "background": "white",
	        "border-color": "#d2d6de",
	        "border-width": "1px 1px 1px 0px"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          controle.descricao = null
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-remove"
	    })])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Opções")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-10 indicadores-cb-inline"
	    }, [(_vm._.includes(['CONTROLE', 'PERSONALIZADO'], controle.grupo)) ? _c('div', {
	      staticClass: "juntos"
	    }, [_c('i', {
	      class: (controle.obrigatorio ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          controle.obrigatorio = !controle.obrigatorio
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      class: controle.obrigatorio ? 'selecionado' : ''
	    }, [_vm._v(" Obrigatório")])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "juntos"
	    }, [(controle.elemento === 'SECAO') ? _c('span', [_c('i', {
	      class: (controle.mostrar ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.mostraOcultaElemento(idx)
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      class: controle.mostrar ? 'selecionado' : ''
	    }, [_vm._v(" " + _vm._s('Mostrará ou Ocultará ' + (_vm.elementosSecao(idx).length === 0 ? 'esta seção' : 'os elementos nesta seção')))])]) : _c('span', [(_vm._.isNull(_vm.elementosSecao(idx)) || _vm._.get(_vm.elementosSecao(idx), 'mostrar')) ? _c('span', [_c('i', {
	      class: (controle.mostrar ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.mostraOcultaElemento(idx)
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      class: controle.mostrar ? 'selecionado' : ''
	    }, [_vm._v(" Mostrar")])]) : _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      attrs: {
	        "title": '<h5>Este elemento está em uma seção oculta, então não pode ser mostrado isoladamente</h5>'
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-square"
	    }), _vm._v(" Seção ocultada\n                                    ")])])])])]), _vm._v(" "), (!_vm._.isEmpty(controle.configuracao)) ? _c('span', [(_vm._.includes(['NUMERO', 'LOGOMARCA_FBB', 'CLASSIFICACAO', 'TEXTO_LONGO', 'SUB_FORMULARIO', 'SELECAO_SIMPLES', 'SECAO'], controle.elemento)) ? _c('div', {
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Formato")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.configuracao.formato),
	        expression: "controle.configuracao.formato"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "disabled": controle.grupo === 'PERSONALIZADO'
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(controle.configuracao, "formato", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((_vm._.get(_vm._.find(_vm.formatoValores, ['elemento', controle.elemento]), 'formatos')), function(item) {
	      return _c('option', {
	        domProps: {
	          "value": item.valor
	        }
	      }, [_vm._v(_vm._s(item.descricao) + " ")])
	    }), 0)]), _vm._v(" "), (controle.grupo === 'FORMULARIO') ? _c('span', [_vm._v("\n                                  " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm._.find(_vm.formatoValores, ['elemento', 'SUB_FORMULARIO']), 'formatos'), ['valor', controle.configuracao.formato]), 'info')) + "\n                                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['TEXTO_SIMPLES', 'CLASSIFICACAO', 'NPS'], controle.elemento) || (controle.elemento === 'NUMERO' && _vm._.includes(['INTEIRO', 'DECIMAL', 'MOEDA'], controle.configuracao.formato)) || (controle.elemento === 'TEXTO_LONGO' && _vm._.includes(['SOMENTE_TEXTO'], controle.configuracao.formato))) ? _c('div', {
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Quantidade")]), _vm._v(" "), (_vm._.includes(['CLASSIFICACAO', 'NPS'], controle.elemento)) ? _c('div', {
	      staticClass: "col-md-10"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.configuracao.padrao),
	        expression: "controle.configuracao.padrao"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "number",
	        "min": controle.configuracao.minimo,
	        "max": controle.configuracao.maximo,
	        "disabled": controle.grupo === 'PERSONALIZADO',
	        "title": '<h5>Limite de <b>' + controle.configuracao.minimo + '</b> até <b>' + controle.configuracao.maximo + '</b></h5>'
	      },
	      domProps: {
	        "value": (controle.configuracao.padrao)
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          return _vm.fecharEdicao($event)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle.configuracao, "padrao", $event.target.value)
	        }
	      }
	    })]) : (_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO'], controle.elemento)) ? _c('div', {
	      staticClass: "col-md-10"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.configuracao.maximo),
	        expression: "controle.configuracao.maximo"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "number",
	        "min": controle.configuracao.minimo,
	        "max": "2147483647",
	        "disabled": controle.grupo === 'PERSONALIZADO',
	        "title": '<h5>' + (_vm._.toSafeInteger(controle.configuracao.maximo) === 0 ? 'Sem limite de caracteres' : (_vm._.toSafeInteger(controle.configuracao.maximo) > 1 ? 'Limitado a ' + _vm._.toSafeInteger(controle.configuracao.maximo) + ' caracteres' : '1 caractere somente')) + '</h5>'
	      },
	      domProps: {
	        "value": (controle.configuracao.maximo)
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          return _vm.fecharEdicao($event)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle.configuracao, "maximo", $event.target.value)
	        }
	      }
	    })]) : ((controle.elemento === 'NUMERO' && _vm._.includes(['INTEIRO', 'DECIMAL', 'MOEDA'], controle.configuracao.formato))) ? _c('div', {
	      staticClass: "col-md-10"
	    }, [_c('div', {
	      staticClass: "col-md-1"
	    }, [_vm._v("De")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.configuracao.minimo),
	        expression: "controle.configuracao.minimo"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "number",
	        "min": "0",
	        "max": controle.configuracao.maximo,
	        "disabled": controle.grupo === 'PERSONALIZADO'
	      },
	      domProps: {
	        "value": (controle.configuracao.minimo)
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          return _vm.fecharEdicao($event)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle.configuracao, "minimo", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2"
	    }, [_vm._v("Até")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (controle.configuracao.maximo),
	        expression: "controle.configuracao.maximo"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "number",
	        "min": controle.configuracao.minimo,
	        "max": "2147483647",
	        "disabled": controle.grupo === 'PERSONALIZADO'
	      },
	      domProps: {
	        "value": (controle.configuracao.maximo)
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          return _vm.fecharEdicao($event)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(controle.configuracao, "maximo", $event.target.value)
	        }
	      }
	    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SELECAO_SIMPLES', 'SELECAO_MULTIPLA', 'BOOLEANO', 'NPS', 'LIKERT'], controle.elemento) && !_vm._.isNull(controle.configuracao.conteudo)) ? _c('div', [(!_vm._.isNull(controle.configuracao.conteudo.linhas)) ? _c('div', {
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Conteúdo")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-10"
	    }, [_c('table', {
	      class: 'table table-condensed ' + (controle.grupo === 'PERSONALIZADO' ? '' : 'table-hover')
	    }, [(controle.configuracao.formato === 'CONTEUDO_FIXO') ? _vm._l((controle.configuracao.conteudo.linhas), function(item, idx) {
	      return _c('tr', [_c('td', {
	        staticStyle: {
	          "width": "40%"
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (item.descricao),
	          expression: "item.descricao"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "type": "text",
	          "disabled": controle.grupo === 'PERSONALIZADO'
	        },
	        domProps: {
	          "value": (item.descricao)
	        },
	        on: {
	          "keydown": function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            return _vm.fecharEdicao($event)
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(item, "descricao", $event.target.value)
	          }
	        }
	      })]), _vm._v(" "), (!_vm._.isNull(item.valor) && item.valor !== '') ? _c('td', {
	        staticStyle: {
	          "width": "20%"
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (item.valor),
	          expression: "item.valor"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "type": "text",
	          "disabled": controle.grupo === 'PERSONALIZADO'
	        },
	        domProps: {
	          "value": (item.valor)
	        },
	        on: {
	          "keydown": function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            return _vm.fecharEdicao($event)
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(item, "valor", $event.target.value)
	          }
	        }
	      })]) : _vm._e(), _vm._v(" "), _c('td')])
	    }) : [_c('draggable', _vm._b({
	      attrs: {
	        "group": "lista_conteudo",
	        "disabled": controle.grupo === 'PERSONALIZADO',
	        "tag": "tbody"
	      },
	      model: {
	        value: (controle.configuracao.conteudo.linhas),
	        callback: function($$v) {
	          _vm.$set(controle.configuracao.conteudo, "linhas", $$v)
	        },
	        expression: "controle.configuracao.conteudo.linhas"
	      }
	    }, 'draggable', {
	      animation: 200,
	      group: 'lista_conteudo',
	      disabled: false,
	      ghostClass: 'ghost'
	    }, false), _vm._l((controle.configuracao.conteudo.linhas), function(item, idx) {
	      return _c('tr', {
	        class: controle.grupo !== 'PERSONALIZADO' ? 'item_conteudo handle_conteudo' : ''
	      }, [_c('td', {
	        staticClass: "w40",
	        style: (!item.mostrar ? 'border-left: 5px solid slategray;' : '')
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (item.descricao),
	          expression: "item.descricao"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "type": "text",
	          "disabled": controle.grupo === 'PERSONALIZADO'
	        },
	        domProps: {
	          "value": (item.descricao)
	        },
	        on: {
	          "keydown": function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            return _vm.fecharEdicao($event)
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(item, "descricao", $event.target.value)
	          }
	        }
	      })]), _vm._v(" "), (!_vm._.isNull(item.valor) && item.valor !== '') ? _c('td', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (item.valor),
	          expression: "item.valor"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "type": "text",
	          "disabled": controle.grupo === 'PERSONALIZADO'
	        },
	        domProps: {
	          "value": (item.valor)
	        },
	        on: {
	          "keydown": function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            return _vm.fecharEdicao($event)
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(item, "valor", $event.target.value)
	          }
	        }
	      })]) : _vm._e(), _vm._v(" "), (false) ? _c('td', {
	        staticClass: "text-left indicadores-cb-inline w20",
	        staticStyle: {
	          "padding": "0 10px"
	        }
	      }, [_c('i', {
	        class: (item.mostrar ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	        attrs: {
	          "aria-hidden": "true"
	        },
	        on: {
	          "click": function($event) {
	            item.mostrar = !item.mostrar
	          }
	        }
	      }), _vm._v(" "), _c('span', {
	        class: controle.mostrar ? 'selecionado' : ''
	      }, [_vm._v(" Mostrar")])]) : _vm._e(), _vm._v(" "), _c('td', {
	        staticClass: "text-right w40"
	      }, [(controle.grupo !== 'PERSONALIZADO') ? _c('div', {
	        staticClass: "botoes_acao_conteudo"
	      }, [_c('span', {
	        staticClass: "botao_acao_conteudo elemento_duplicar",
	        on: {
	          "click": function($event) {
	            controle.configuracao.conteudo.linhas.splice(idx, 0, {
	              descricao: '' + (controle.configuracao.conteudo.linhas.length + 1),
	              valor: null,
	              mostrar: true
	            })
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-plus"
	      })]), _vm._v(" "), _c('span', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (idx > 0),
	          expression: "idx > 0"
	        }],
	        staticClass: "botao_acao_elemento elemento_mover",
	        on: {
	          "click": function($event) {
	            return _vm.moveElemento(idx, -1, controle.configuracao.conteudo.linhas)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-arrow-up"
	      })]), _vm._v(" "), _c('span', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (idx < controle.configuracao.conteudo.linhas.length - 1),
	          expression: "idx < controle.configuracao.conteudo.linhas.length - 1"
	        }],
	        staticClass: "botao_acao_elemento elemento_mover",
	        on: {
	          "click": function($event) {
	            return _vm.moveElemento(idx, 1, controle.configuracao.conteudo.linhas)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-arrow-down"
	      })]), _vm._v(" "), (controle.configuracao.conteudo.linhas.length > 1) ? _c('span', {
	        staticClass: "botao_acao_conteudo elemento_excluir",
	        on: {
	          "click": function($event) {
	            return controle.configuracao.conteudo.linhas.splice(idx, 1)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-trash"
	      })]) : _vm._e()]) : _c('div', [_vm._v(" ")])])])
	    }), 0)]], 2)])]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(controle.configuracao.conteudo.colunas)) ? _c('div', {
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Colunas")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-10"
	    }, [_c('table', {
	      class: 'table table-condensed ' + (controle.grupo === 'PERSONALIZADO' ? '' : 'table-hover')
	    }, [
	      [_c('draggable', _vm._b({
	        attrs: {
	          "group": "lista_conteudo",
	          "disabled": controle.grupo === 'PERSONALIZADO',
	          "tag": "tbody"
	        },
	        model: {
	          value: (controle.configuracao.conteudo.colunas),
	          callback: function($$v) {
	            _vm.$set(controle.configuracao.conteudo, "colunas", $$v)
	          },
	          expression: "controle.configuracao.conteudo.colunas"
	        }
	      }, 'draggable', {
	        animation: 200,
	        group: 'lista_conteudo',
	        disabled: false,
	        ghostClass: 'ghost'
	      }, false), _vm._l((controle.configuracao.conteudo.colunas), function(item, idx) {
	        return _c('tr', {
	          class: controle.grupo !== 'PERSONALIZADO' ? 'item_conteudo handle_conteudo' : ''
	        }, [_c('td', {
	          staticClass: "w40",
	          style: (!item.mostrar ? 'border-left: 5px solid slategray;' : '')
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (item.descricao),
	            expression: "item.descricao"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "text",
	            "disabled": controle.grupo === 'PERSONALIZADO'
	          },
	          domProps: {
	            "value": (item.descricao)
	          },
	          on: {
	            "keydown": function($event) {
	              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	              return _vm.fecharEdicao($event)
	            },
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(item, "descricao", $event.target.value)
	            }
	          }
	        })]), _vm._v(" "), (!_vm._.isNull(item.valor) && item.valor !== '') ? _c('td', [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (item.valor),
	            expression: "item.valor"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "text",
	            "disabled": controle.grupo === 'PERSONALIZADO'
	          },
	          domProps: {
	            "value": (item.valor)
	          },
	          on: {
	            "keydown": function($event) {
	              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	              return _vm.fecharEdicao($event)
	            },
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(item, "valor", $event.target.value)
	            }
	          }
	        })]) : _vm._e(), _vm._v(" "), (false) ? _c('td', {
	          staticClass: "text-left indicadores-cb-inline w20",
	          staticStyle: {
	            "padding": "0 10px"
	          }
	        }, [_c('i', {
	          class: (item.mostrar ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              item.mostrar = !item.mostrar
	            }
	          }
	        }), _vm._v(" "), _c('span', {
	          class: controle.mostrar ? 'selecionado' : ''
	        }, [_vm._v(" Mostrar")])]) : _vm._e(), _vm._v(" "), _c('td', {
	          staticClass: "text-right w40"
	        }, [(controle.grupo !== 'PERSONALIZADO') ? _c('div', {
	          staticClass: "botoes_acao_conteudo"
	        }, [_c('span', {
	          staticClass: "botao_acao_conteudo elemento_duplicar",
	          on: {
	            "click": function($event) {
	              return controle.configuracao.conteudo.colunas.splice(idx, 0, {
	                descricao: 'Item novo ...',
	                valor: null,
	                mostrar: true
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-plus"
	        })]), _vm._v(" "), _c('span', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (idx > 0),
	            expression: "idx > 0"
	          }],
	          staticClass: "botao_acao_elemento elemento_mover",
	          on: {
	            "click": function($event) {
	              return _vm.moveElemento(idx, -1, controle.configuracao.conteudo.colunas)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-arrow-up"
	        })]), _vm._v(" "), _c('span', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (idx < controle.configuracao.conteudo.colunas.length - 1),
	            expression: "idx < controle.configuracao.conteudo.colunas.length - 1"
	          }],
	          staticClass: "botao_acao_elemento elemento_mover",
	          on: {
	            "click": function($event) {
	              return _vm.moveElemento(idx, 1, controle.configuracao.conteudo.colunas)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-arrow-down"
	        })]), _vm._v(" "), (controle.configuracao.conteudo.colunas.length > 1) ? _c('span', {
	          staticClass: "botao_acao_conteudo elemento_excluir",
	          on: {
	            "click": function($event) {
	              return controle.configuracao.conteudo.colunas.splice(idx, 1)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash"
	        })]) : _vm._e()]) : _c('div', [_vm._v(" ")])])])
	      }), 0)]
	    ], 2)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SUB_FORMULARIO') ? _c('div', [_c('div', {
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Colunas")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-10"
	    }, [_c('table', {
	      staticClass: "table table-condensed table-hover"
	    }, [_c('draggable', _vm._b({
	      attrs: {
	        "group": "lista_conteudo",
	        "tag": "tbody"
	      },
	      model: {
	        value: (controle.configuracao.conteudo.colunas),
	        callback: function($$v) {
	          _vm.$set(controle.configuracao.conteudo, "colunas", $$v)
	        },
	        expression: "controle.configuracao.conteudo.colunas"
	      }
	    }, 'draggable', {
	      animation: 200,
	      group: 'lista_conteudo',
	      disabled: false,
	      ghostClass: 'ghost'
	    }, false), [(_vm._.isEmpty(_vm.editandoColunaSubFormulario)) ? [_vm._l((_vm._.filter(controle.configuracao.conteudo.colunas, function(c) {
	      return c.key != 'actions'
	    })), function(item, idx) {
	      return _c('tr', {
	        staticClass: "item_conteudo handle_conteudo"
	      }, [_c('td', {
	        staticClass: "w30 truncar"
	      }, [_c('span', {
	        staticStyle: {
	          "color": "var(--cor-destaque)"
	        }
	      }, [_vm._v(_vm._s(item.key))]), _vm._v(" " + _vm._s(_vm.removerTagHtmlString(item.label)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-right w20"
	      }, [(controle.configuracao.conteudo.colunas.length > 1) ? _c('div', {
	        staticClass: "botoes_acao_conteudo"
	      }, [_c('span', {
	        staticClass: "botao_acao_elemento elemento_fechar",
	        on: {
	          "click": function($event) {
	            _vm.editandoColunaSubFormulario = controle.configuracao.conteudo.colunas[idx]
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-pencil"
	      })]), _vm._v(" "), _c('span', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (idx > 0),
	          expression: "idx > 0"
	        }],
	        staticClass: "botao_acao_elemento elemento_mover",
	        on: {
	          "click": function($event) {
	            return _vm.moveElemento(idx, -1, controle.configuracao.conteudo.colunas)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-arrow-up"
	      })]), _vm._v(" "), _c('span', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (idx < controle.configuracao.conteudo.colunas.length - 1),
	          expression: "idx < controle.configuracao.conteudo.colunas.length - 1"
	        }],
	        staticClass: "botao_acao_elemento elemento_mover",
	        on: {
	          "click": function($event) {
	            return _vm.moveElemento(idx, 1, controle.configuracao.conteudo.colunas)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-arrow-down"
	      })]), _vm._v(" "), (controle.configuracao.conteudo.colunas.length > 1) ? _c('span', {
	        staticClass: "botao_acao_conteudo elemento_excluir",
	        on: {
	          "click": function($event) {
	            return controle.configuracao.conteudo.colunas.splice(idx, 1)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-trash"
	      })]) : _vm._e()]) : _vm._e()])])
	    }), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "adicionaComponente",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.colunaParaAdicionarSubFormulario),
	        expression: "colunaParaAdicionarSubFormulario"
	      }],
	      staticClass: "form-control",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.colunaParaAdicionarSubFormulario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, function($event) {
	          return _vm.adicionaColunaSubFormulario(idx)
	        }]
	      }
	    }, _vm._l((controle.configuracao.conteudo.formulario), function(item) {
	      return (_vm._.includes(['CONTROLE', 'PERSONALIZADO'], item.grupo)) ? _c('option', {
	        domProps: {
	          "value": item
	        }
	      }, [_vm._v("\n                                                    (" + _vm._s(item.id) + ") " + _vm._s(_vm.removerTagHtmlString(item.titulo)) + "\n                                                  ")]) : _vm._e()
	    }), 0)])])] : _vm._e()], 2), _vm._v(" "), (!_vm._.isEmpty(_vm.editandoColunaSubFormulario)) ? [_c('tr', [_c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.editandoColunaSubFormulario.label),
	        expression: "editandoColunaSubFormulario.label"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.editandoColunaSubFormulario.label)
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          _vm.editandoColunaSubFormulario = {}
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.editandoColunaSubFormulario, "label", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('span', {
	      staticClass: "botao_acao_elemento elemento_fechar",
	      on: {
	        "click": function($event) {
	          _vm.editandoColunaSubFormulario = {}
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-close"
	    })])])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("Muda o nome da coluna acima. Isto só altera a coluna, não o titulo da questão no formulário.")])])] : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO', 'SELECAO_SIMPLES', 'SELECAO_MULTIPLA', 'BOOLEANO', 'CLASSIFICACAO', 'NPS', 'LIKERT'], controle.elemento) || (controle.elemento === 'NUMERO' && _vm._.includes(['INTEIRO', 'DECIMAL', 'MOEDA'], controle.configuracao.formato))) ? _c('div', {
	      attrs: {
	        "id": "regras_formulario"
	      }
	    }, [_c('div', {
	      class: 'col-md-12' + (_vm._.sumBy(controle.configuracao.regras, function(r) {
	        return _vm._.isNull(r.valor) || r.valor === '' || r.id.length === 0 ? 1 : 0
	      }) > 0 ? ' regras_erro' : (controle.configuracao.regras.length > 0 ? ' regras_ok' : ''))
	    }, [_c('div', {
	      staticClass: "btn-primary cabecalho_regras"
	    }, [_c('span', {
	      staticClass: "text-bold"
	    }, [(controle.configuracao.regras.length === 0) ? _c('span', [_vm._v("Nenhuma Regra")]) : _c('span', [_vm._v("\n                                        Há " + _vm._s(controle.configuracao.regras.length) + " regra(s)\n\n                                        "), (_vm._.sumBy(controle.configuracao.regras, function(r) {
	      return _vm._.isNull(r.valor) || r.valor === '' ? 1 : 0
	    }) > 0) ? _c('span', {
	      staticClass: "text-danger"
	    }, [_c('div', {
	      staticClass: "espacamento_botoes"
	    }), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-exclamation-circle"
	    }), _vm._v(" " + _vm._s(_vm._.sumBy(controle.configuracao.regras, function(r) {
	      return _vm._.isNull(r.valor) || r.valor === '' ? 1 : 0
	    })) + " sem valor informado\n                                        ")]) : _vm._e(), _vm._v(" "), (_vm._.sumBy(controle.configuracao.regras, function(r) {
	      return r.id.length === 0 ? 1 : 0
	    }) > 0) ? _c('span', {
	      staticClass: "text-danger"
	    }, [_c('div', {
	      staticClass: "espacamento_botoes"
	    }), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-exclamation-circle"
	    }), _vm._v(" " + _vm._s(_vm._.sumBy(controle.configuracao.regras, function(r) {
	      return r.id.length === 0 ? 1 : 0
	    })) + " sem destino da ação selecionado\n                                        ")]) : _vm._e()])]), _vm._v(" "), _c('span', {
	      staticClass: "botoes_acao_conteudo",
	      staticStyle: {
	        "display": "block"
	      }
	    }, [_c('span', {
	      staticClass: "botao_acao_conteudo elemento_duplicar",
	      on: {
	        "click": function($event) {
	          controle.configuracao.regras.push({
	            condicao: (_vm._.includes(['NUMERO'], controle.elemento) ? 'IGUAL' : (_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO'], controle.elemento) ? 'CONTEM' : 'ITEM_SELECIONADO')),
	            valor: null,
	            acao: 'MOSTRAR',
	            id: []
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus"
	    })]), _vm._v(" "), (controle.configuracao.regras.length > 0) ? _c('span', {
	      staticClass: "botao_acao_conteudo elemento_excluir",
	      on: {
	        "click": function($event) {
	          controle.configuracao.regras = []
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })]) : _vm._e()])]), _vm._v(" "), (controle.configuracao.regras.length > 0) ? _c('table', {
	      staticClass: "table lista_regras"
	    }, _vm._l((controle.configuracao.regras), function(regra, idxRegra) {
	      return _c('tr', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '20',
	            size: 'large',
	            arrow: true,
	            followCursor: true
	          }),
	          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'20', size:'large', arrow:true, followCursor:true}"
	        }],
	        attrs: {
	          "title": _vm._.isNull(regra.valor) || regra.valor === '' || regra.id.length === 0 ?
	            '<h5>Regra inválida. Complete ou exclua ela</h5>' :
	
	            '<h5>Se a resposta da questão ' +
	            (_vm._.includes(['CONTEM', 'NAO_CONTEM'], regra.condicao) ? '' : (_vm._.includes(['VAZIO', 'NAO_VAZIO', 'ENTRE'], regra.condicao) ? 'está' : (_vm._.includes(['ITEM_SELECIONADO', 'ITEM_NAO_SELECIONADO'], regra.condicao) ? 'tem o' : 'é'))) + ' ' +
	            '<span class=\'realce\'>' + (_vm._.toLower(_vm._.replace(regra.condicao, '_', ' '))) + '</span> ' +
	            (_vm._.includes(['CONTEM', 'NAO_CONTEM'], regra.condicao) ? 'o valor' : (_vm._.includes(['VAZIO', 'NAO_VAZIO', 'ENTRE'], regra.condicao) ? '' : (_vm._.includes(['ITEM_SELECIONADO', 'ITEM_NAO_SELECIONADO'], regra.condicao) ? 'com a opção' : (regra.condicao === 'IGUAL' ? 'a' : (regra.condicao === 'DIFERENTE' ? 'de' : 'que'))))) + ' ' +
	            '<span class=\'realce\'>' + ((_vm._.includes(['VAZIO', 'NAO_VAZIO'], regra.condicao) ? '' : regra.valor) + (regra.condicao === 'ENTRE' ? ' e ' + regra.valor2 : '')) + '</span>' + (controle.elemento === 'LIKERT' ? ' para a pergunta <span class=\'realce\'>' + regra.valor2 + '</span>' : '') + ', ' +
	            'então deve <span class=\'realce\'>' + _vm._.toLower(regra.acao) + '</span> ' + (regra.id.length > 1 ? 'estes' : 'este') + '<span class=\'realce\'> ' + regra.id.length + ' </span>' + (regra.id.length > 1 ? 'elementos' : 'elemento') + '</h5>'
	        }
	      }, [_c('td', {
	        staticClass: "w20"
	      }, [(_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO'], controle.elemento)) ? _c('span', [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.condicao),
	          expression: "regra.condicao"
	        }],
	        staticClass: "form-control b0",
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(regra, "condicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "CONTEM"
	        }
	      }, [_vm._v("Contém")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "NAO_CONTEM"
	        }
	      }, [_vm._v("Não contém")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "VAZIO"
	        }
	      }, [_vm._v("Vazio")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "NAO_VAZIO"
	        }
	      }, [_vm._v("Não vazio")])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['CLASSIFICACAO', 'NPS', 'NUMERO'], controle.elemento)) ? _c('span', [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.condicao),
	          expression: "regra.condicao"
	        }],
	        staticClass: "form-control b0",
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(regra, "condicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "VAZIO"
	        }
	      }, [_vm._v("Está vazio")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "NAO_VAZIO"
	        }
	      }, [_vm._v("Não está vazio")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "ENTRE"
	        }
	      }, [_vm._v("Entre")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "IGUAL"
	        }
	      }, [_vm._v("Igual")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "DIFERENTE"
	        }
	      }, [_vm._v("Diferente")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "MAIOR"
	        }
	      }, [_vm._v("Maior que")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "MAIOR_IGUAL"
	        }
	      }, [_vm._v("Maior ou igual que")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "MENOR"
	        }
	      }, [_vm._v("Menor que")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "MENOR_IGUAL"
	        }
	      }, [_vm._v("Menor ou igual que")])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SELECAO_SIMPLES', 'SELECAO_MULTIPLA', 'BOOLEANO', 'LIKERT'], controle.elemento)) ? _c('span', [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.condicao),
	          expression: "regra.condicao"
	        }],
	        staticClass: "form-control b0",
	        attrs: {
	          "disabled": true
	        },
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(regra, "condicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "ITEM_SELECIONADO"
	        }
	      }, [_vm._v("Se selecionado")]), _vm._v(" "), (false) ? _c('option', {
	        attrs: {
	          "value": "ITEM_NAO_SELECIONADO"
	        }
	      }, [_vm._v("Se Não selecionado")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('td', {
	        staticClass: "w20",
	        class: (_vm._.isNull(regra.valor) || regra.valor === '') || (_vm._.has(regra, 'valor2') && (_vm._.isNull(regra.valor2) || regra.valor2 === '')) ? 'has-error' : ''
	      }, [(!_vm._.includes(['VAZIO', 'NAO_VAZIO'], regra.condicao)) ? _c('span', [(_vm._.includes(['CLASSIFICACAO', 'NPS', 'NUMERO'], controle.elemento)) ? _c('span', {
	        staticClass: "regraEntre"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.valor),
	          expression: "regra.valor"
	        }],
	        staticClass: "form-control b0",
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": (regra.valor)
	        },
	        on: {
	          "keyup": function($event) {
	            regra.valor = _vm._.toSafeInteger(('' + regra.valor).replace(/\D+/g, ''))
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(regra, "valor", $event.target.value)
	          }
	        }
	      }), _vm._v(" "), (regra.condicao === 'ENTRE') ? _c('span', [_vm._v(" e ")]) : _vm._e(), _vm._v(" "), (regra.condicao === 'ENTRE') ? _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.valor2),
	          expression: "regra.valor2"
	        }],
	        staticClass: "form-control b0",
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": (regra.valor2)
	        },
	        on: {
	          "keyup": function($event) {
	            regra.valor2 = _vm._.toSafeInteger(('' + regra.valor2).replace(/\D+/g, ''))
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(regra, "valor2", $event.target.value)
	          }
	        }
	      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO'], controle.elemento)) ? _c('span', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.valor),
	          expression: "regra.valor"
	        }],
	        staticClass: "form-control b0",
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": (regra.valor)
	        },
	        on: {
	          "keyup": function($event) {
	            regra.valor = _vm._.toLower(regra.valor)
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(regra, "valor", $event.target.value)
	          }
	        }
	      })]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SELECAO_SIMPLES', 'SELECAO_MULTIPLA', 'BOOLEANO'], controle.elemento)) ? _c('span', [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.valor),
	          expression: "regra.valor"
	        }],
	        staticClass: "form-control b0",
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(regra, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, _vm._l((controle.configuracao.conteudo.linhas), function(item) {
	        return _c('option', [_vm._v(_vm._s(item.descricao))])
	      }), 0)]) : _vm._e(), _vm._v(" "), (_vm._.includes(['LIKERT'], controle.elemento)) ? _c('span', [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.valor2),
	          expression: "regra.valor2"
	        }],
	        staticClass: "form-control b0",
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(regra, "valor2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, _vm._l((controle.configuracao.conteudo.linhas), function(item) {
	        return _c('option', [_vm._v(_vm._s(item.descricao))])
	      }), 0), _vm._v(" "), _c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (regra.valor),
	          expression: "regra.valor"
	        }],
	        staticClass: "form-control b0",
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(regra, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, _vm._l((controle.configuracao.conteudo.colunas), function(item) {
	        return _c('option', [_vm._v(_vm._s(item.descricao))])
	      }), 0)]) : _vm._e()]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('td', [_c('i', {
	        class: (regra.acao === 'MOSTRAR' ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	        staticStyle: {
	          "color": "var(--cor-destaque)",
	          "cursor": "pointer",
	          "text-align": "center"
	        },
	        attrs: {
	          "aria-hidden": "true"
	        },
	        on: {
	          "click": function($event) {
	            regra.acao = regra.acao === 'MOSTRAR' ? 'OCULTAR' : 'MOSTRAR'
	          }
	        }
	      })]), _vm._v(" "), _c('td', {
	        class: regra.id.length === 0 ? 'regra_error' : ''
	      }, [_c('multiselect', {
	        attrs: {
	          "options": _vm._.filter(_vm.editandoFormulario, function(o) {
	            return o.id !== controle.id
	          }),
	          "multiple": true,
	          "close-on-select": true,
	          "placeholder": 'Selecione ao menos um elemento',
	          "track-by": "id",
	          "label": "id",
	          "selectedLabel": "",
	          "selectLabel": "",
	          "deselectLabel": "",
	          "name": "id_elementos",
	          "data-vv-as": "id_elementos"
	        },
	        scopedSlots: _vm._u([{
	          key: "option",
	          fn: function(props) {
	            return [_c('span', {
	              staticClass: "text-gray"
	            }, [_vm._v(_vm._s(props.option.id))]), _vm._v(" "), _c('span', {
	              staticClass: "ocultarLinhaAdicionalQuill",
	              domProps: {
	                "innerHTML": _vm._s(props.option.titulo)
	              }
	            })]
	          }
	        }], null, true),
	        model: {
	          value: (regra.id),
	          callback: function($$v) {
	            _vm.$set(regra, "id", $$v)
	          },
	          expression: "regra.id"
	        }
	      })], 1), _vm._v(" "), _c('td', [_c('div', {
	        staticClass: "botoes_acao_conteudo",
	        staticStyle: {
	          "display": "block"
	        }
	      }, [_c('span', {
	        staticClass: "botao_acao_conteudo elemento_duplicar",
	        on: {
	          "click": function($event) {
	            controle.configuracao.regras.splice(idxRegra, 0, _vm._.clone(controle.configuracao.regras[idxRegra]))
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-files-o"
	      })]), _vm._v(" "), _c('span', {
	        staticClass: "botao_acao_conteudo elemento_excluir",
	        on: {
	          "click": function($event) {
	            return controle.configuracao.regras.splice(idxRegra, 1)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-trash"
	      })])])])])
	    }), 0) : _vm._e()])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
	  }), 0)], 1)]), _vm._v(" "), (_vm.mostrarComponentes) ? _c('div', {
	    staticClass: "col-md-3",
	    style: ('overflow-y: auto; height: ' + (_vm.alturaContentWrapper - (_vm.mostrarTitulo ? 372 : 94)) + 'px;'),
	    attrs: {
	      "id": "componentes_formulario"
	    }
	  }, [(_vm.loading.componentes) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando banco de questões ...")]) : _vm._e(), _vm._v(" "), (!_vm.loading.componentes) ? _c('span', [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa.termo),
	      expression: "pesquisa.termo"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "pesquisaControle",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa...",
	      "title": '<h5>Digite algo</h5>'
	    },
	    domProps: {
	      "value": (_vm.pesquisa.termo)
	    },
	    on: {
	      "keyup": _vm.filtrar,
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        _vm.pesquisa.termo = ''
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.pesquisa, "termo", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.pesquisa.termo.length > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "input-group-btn",
	    attrs: {
	      "title": '<h5>Limpar essa pesquisa [ESC]</h5>'
	    }
	  }, [_c('button', {
	    staticClass: "btn",
	    staticStyle: {
	      "background": "white",
	      "border-color": "#d2d6de",
	      "border-width": "1px 0px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pesquisa.termo = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  })])]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    class: 'btn btn-default btn-flat' + (_vm.pesquisa.personalizado ? ' bg-gray' : ''),
	    attrs: {
	      "type": "button",
	      "title": '<h5>Questões fechadas/personalizadas da FBB</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.pesquisa.personalizado = !_vm.pesquisa.personalizado
	      }
	    }
	  }, [_c('i', {
	    class: _vm.pesquisa.personalizado ? 'fa fa-file-text fa-inverse' : 'fa fa-file-text'
	  })])]), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    class: 'btn btn-default btn-flat' + (_vm.pesquisa.formulario ? ' bg-gray' : ''),
	    attrs: {
	      "type": "button",
	      "title": '<h5>Formulários genéricos ou participantes</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.pesquisa.formulario = !_vm.pesquisa.formulario
	      }
	    }
	  }, [_c('i', {
	    class: _vm.pesquisa.formulario ? 'fa fa-list-alt fa-inverse' : 'fa fa-list-alt'
	  })])])])])])]), _vm._v(" "), _vm._l((_vm._.groupBy(_vm._.filter(_vm._.orderBy(_vm.controles, ['informacao'], ['asc']), {
	    'mostrar': true
	  }), 'grupo')), function(controlesLista, grupo) {
	    return [_c('div', {
	      staticClass: "text-muted text-bold"
	    }, [_vm._v(_vm._s(_vm.gruposControles[grupo])), _c('span', {
	      staticClass: "contador"
	    }, [_vm._v(_vm._s(controlesLista.length))])]), _vm._v(" "), _c('draggable', {
	      staticClass: "list-group",
	      attrs: {
	        "tag": "ul",
	        "list": controlesLista,
	        "group": {
	          name: 'edicao',
	          pull: 'clone',
	          put: false
	        },
	        "clone": _vm.clonarControle,
	        "move": _vm.mover
	      }
	    }, _vm._l((controlesLista), function(controle) {
	      return _c('li', {
	        class: 'list-group-item ' + (_vm._.find(_vm.editandoFormulario, ['id', controle.bi]) ? 'bi_repetido' : ''),
	        on: {
	          "click": function($event) {
	            return _vm.adicionaControle(controle)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "truncar"
	      }, [(controle.bi) ? _c('i', {
	        staticClass: "fa fa-pie-chart"
	      }) : _vm._e(), _vm._v(" "), _c('i', {
	        class: 'text-gray fa ' + (controle.grupo === 'FORMULARIO' ? _vm.icones[controle.configuracao.conteudo.tipo] : (controle.elemento === 'NUMERO' ? _vm.icones[controle.configuracao.formato] : _vm.icones[controle.elemento]))
	      }), _vm._v("\n                            " + _vm._s(controle.informacao) + "\n                          ")]), _vm._v(" "), (!_vm._.isEmpty(controle.descricao)) ? _c('i', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: 15,
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{inertia:true, arrow:true, animation:'perspective', distance: 15, size:'large', arrow:true}"
	        }],
	        staticClass: "fa fa-question-circle text-gray",
	        staticStyle: {
	          "margin-left": "5px"
	        },
	        attrs: {
	          "title": '<h5>' + (_vm._.find(_vm.editandoFormulario, ['id', controle.bi]) ? '<span class=\'realce\'>Elementos de BI com este só podem ter um no formulário</span><br/>' : '') + controle.descricao + '</h5>'
	        }
	      }) : _vm._e()])
	    }), 0)]
	  }), _vm._v(" "), (!_vm._.find(_vm.controles, {
	    'mostrar': true
	  })) ? _c('p', {
	    staticClass: "text-muted font-italic"
	  }, [_vm._v("Não encontrei!")]) : _vm._e()], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    staticClass: "main-sidebar"
	  }, [_c('section', {
	    staticClass: "sidebar",
	    staticStyle: {
	      "overflow-y": "auto",
	      "height": "100vh",
	      "padding-bottom": "100px"
	    }
	  }, [_c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "header",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("SGP - MENU")]), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": _vm.rota
	    },
	    on: {
	      "click": _vm.validaRota
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-home"
	  }), _vm._v(" "), _c('span', [_vm._v("Inicial")])])], 1), _vm._v(" "), (this.$root.authorize('perfil-visualizar')) ? _c('li', {
	    staticClass: "treeview",
	    attrs: {
	      "data-widget": "tree"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li'), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-editais-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Editais")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('entidade-visualizar|entidade-visualizar-por-mim')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-entidade-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Entidades")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('fav-editar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-fep-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" FEP")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-formulario'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Formulários")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-ged'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" GED")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('motivo-devolucao-criar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-motivos-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Motivos de Devolução (Gepac)")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lista-articulacoes'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Parcerias Estratégicas")]) : _vm._e()], 1), _vm._v(" "), (false) ? _c('li', [(this.$root.authorize('parceiro-estrategico-visualizar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-parceiro-estrategico-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Parceiros Estratégicos")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', [(this.$root.authorize('permissao-editar')) ? _c('a', {
	    attrs: {
	      "href": this.$store.state.laravelurl + '/nova/resources/perfils',
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Perfis")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('permissao-editar')) ? _c('a', {
	    attrs: {
	      "href": this.$store.state.laravelurl + '/nova/resources/permissaos',
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Permissões")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('permissao-editar')) ? _c('a', {
	    attrs: {
	      "href": this.$store.state.laravelurl + '/nova/resources/tipo-documentos',
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Tipos de documentos")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('permissao-editar')) ? _c('a', {
	    attrs: {
	      "href": this.$store.state.laravelurl + '/nova/resources/users',
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Usuários")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lista-sumario-executivo'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Sumário Executivo")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'projetos-usuarios'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Usuários por Projeto")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lista-ocorrencias'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Ocorrências")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lista-ods-fundacao'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" ODS ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lista-cotacao-automatica-excecoes'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Cotação Automática ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'propostas-simplificadas'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Processo Simplificado ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439 && !_vm.ehParceiroEstrategico) ? _c('li', [(this.$root.authorize('minha-entidade-visualizar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-entidade-edita',
	        params: {
	          id: _vm.usuarioLogado.entidade.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Dados Cadastrais")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar') && _vm.usuarioLogado.strategicPartner) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-ged'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o"
	  }), _vm._v(" "), _c('span', [_vm._v("GED")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('meu-parceiro-estrategico-visualizar')) ? _c('router-link', {
	    attrs: {
	      "to": "/dashboard"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-money"
	  }), _vm._v(" "), _c('span', [_vm._v("Dados Cadastrais")])]) : _vm._e()], 1), _vm._v(" "), (_vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439 || _vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.propostas))) ? _c('li', [(this.$root.authorize('proposta-visualizar-por-mim|proposta-visualizar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'proposta-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt"
	  }), _vm._v(" "), _c('span', [_vm._v("Propostas")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.ehParceiroEstrategico && _vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439 || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.propostas))) ? _c('li', [(this.$root.authorize('minha-proposta-visualizar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'proposta-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt"
	  }), _vm._v(" "), _c('span', [_vm._v("Minhas propostas")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos)) || _vm.ehParceiroEstrategico) ? _c('li', [(this.$root.authorize('projeto-visualizar|projeto-visualizar-por-mim|meu-projeto-visualizar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lista-projetos'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-rocket"
	  }), _c('span', [_vm._v(" Projetos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos)) || _vm.ehParceiroEstrategico) ? _c('li', [(this.$root.authorize('solicitacao-pagamento-editar|solicitacao-contrapartida-editar|solicitacao-adiantamento-editar|solicitacao-prestacaocontas-editar|solicitacao-devolucaoadiantamento-editar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'solicitacao-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-money"
	  }), _vm._v(" "), _c('span', [_vm._v("Solicitações")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos) && _vm.prestacaoSimplificada)) ? _c('li', [(this.$root.authorize('solicitacao-pagamento-editar|solicitacao-contrapartida-editar|solicitacao-adiantamento-editar|solicitacao-prestacaocontas-editar|solicitacao-devolucaoadiantamento-editar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'prestacao-contas-simplificada'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calculator"
	  }), _vm._v(" "), _c('span', [_vm._v("Prestação de Contas")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.$root.authorize('entidade-validar|pre-analise-primeira-aprovacao-validar|pre-analise-segunda-aprovacao-validar|aceite-proposta-validar|analise-aprovacao-validar|analise-pendencia-aprovacao-validar|deferimento-aprovacao-validar|preparacao-documentos-aprovacao-validar|formalizacao-projetos-aprovacao-validar|relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia|solicitacao-pagamento-analisar|solicitacao-pagamento-acompanhar|solicitacao-contrapartida-analisar|solicitacao-adiantamento-analisar|solicitacao-adiantamento-aprovar|solicitacao-adiantamento-analisefinanceira|solicitacao-devolucaoadiantamento-analisar|solicitacao-devolucaoadiantamento-analisefinanceira|solicitacao-prestacaocontas-analisar|solicitacao-prestacaocontas-analisefinanceira|parceiro-estrategico-validar')) ? _c('li', {
	    staticClass: "treeview",
	    attrs: {
	      "data-widget": "tree"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [(this.$root.authorize('entidade-validar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'validacao-solicitacoes-lista',
	        params: {
	          fase: _vm.parametroEnt
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Entidades")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('pre-analise-primeira-aprovacao-validar|pre-analise-segunda-aprovacao-validar|aceite-proposta-validar|analise-aprovacao-validar|analise-pendencia-aprovacao-validar|deferimento-aprovacao-validar|preparacao-documentos-aprovacao-validar|formalizacao-projetos-aprovacao-validar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'validacao-solicitacoes-lista',
	        params: {
	          fase: _vm.parametroProp
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" "), _c('span', [_vm._v("Propostas")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'validacao-solicitacoes-lista',
	        params: {
	          fase: _vm.parametroRel
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Relatório de Execução")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('solicitacao-pagamento-analisar|solicitacao-pagamento-acompanhar|solicitacao-contrapartida-analisar|solicitacao-adiantamento-analisar|solicitacao-adiantamento-aprovar|solicitacao-adiantamento-analisefinanceira|solicitacao-devolucaoadiantamento-analisar|solicitacao-devolucaoadiantamento-analisefinanceira|solicitacao-prestacaocontas-analisar|solicitacao-prestacaocontas-analisefinanceira')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'validacao-solicitacoes-financeiras-lista',
	        params: {
	          fase: _vm.parametroSol
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Execução financeira")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO' && this.$root.authorize('solicitacao-pagamento-analisar|solicitacao-pagamento-acompanhar|solicitacao-contrapartida-analisar|solicitacao-adiantamento-analisar|solicitacao-adiantamento-aprovar|solicitacao-adiantamento-analisefinanceira|solicitacao-devolucaoadiantamento-analisar|solicitacao-devolucaoadiantamento-analisefinanceira|solicitacao-prestacaocontas-analisar|solicitacao-prestacaocontas-analisefinanceira')) ? _c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.abreLaravelAutenticado('/sgp/esteira-automatica')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Esteira Automática "), _c('i', {
	    staticClass: "fa fa-external-link",
	    staticStyle: {
	      "font-size": "10px"
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'validacao-solicitacoes-lista',
	        params: {
	          fase: _vm.parametroAval
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Avaliação de projetos")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'validacao-solicitacoes-lista',
	        params: {
	          fase: _vm.parametroOco
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Ocorrências")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'validacao-solicitacoes-lista',
	        params: {
	          fase: _vm.parametroAltPrj
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Alterações de projetos")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'validacao-licencas',
	        params: {
	          fase: _vm.parametroLicAmb
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Licenciamento Ambiental")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-agencia-configurar|usuario-fundacao-configurar|usuario-entidade-configurar|usuario-estrategico-configurar|usuario-superintendencia-configurar|entidade-configurar|proposta-configurar')) ? _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(2), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [(this.$root.authorize('usuario-agencia-configurar|usuario-fundacao-configurar|usuario-entidade-configurar|usuario-estrategico-configurar|usuario-superintendencia-configurar|entidade-configurar|proposta-configurar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'impressao-relatorio'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Relatórios da Proposta")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.abreLaravelAutenticado('/sgp/relatorios/extrato-bndes?menu=oculto')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  }), _vm._v(" Prestação de Contas - BNDES")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('solicitacao-ratificacao')) ? _c('a', {
	    attrs: {
	      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/e-mails%20FBB?rs:embed=true",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  }), _vm._v(" BI - Acompanhamento de E-mails")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('solicitacao-ratificacao')) ? _c('a', {
	    attrs: {
	      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/SGP%20-%20Estat%C3%ADsticas%20de%20Processos?rs:embed=true",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  }), _vm._v(" BI - Estatística de Processos")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('geracao-remessa-pagamento|movimento-diario|solicitacao-ratificacao|bi-baixa-prestacao')) ? _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(3), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [(_vm.ativaGeracaoRemessa) ? _c('li', [(this.$root.authorize('geracao-remessa-pagamento')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'geracao-remessa'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Geração de Remessa")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ativaGeracaoRemessa) ? _c('li', [(this.$root.authorize('geracao-remessa-pagamento')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'tratamento-retorno'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Tratamento de Retorno")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', [(this.$root.authorize('movimento-diario')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'movimento-diario'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Movimento Diário")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('solicitacao-ratificacao')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lista-ratificacao'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Ratificações")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('controle_bndes_pagamentos')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lista-remessa-bndes'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Remessas BNDES")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('bi-baixa-prestacao')) ? _c('a', {
	    attrs: {
	      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/Baixas%20de%20Presta%C3%A7%C3%A3o%20de%20Contas?rs:embed=true",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  }), _vm._v(" BI - Baixa de Prestações")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.abreLaravelAutenticado('/sgp/relatorios/retornos-pe?menu=oculto')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  }), _vm._v(" BI - Relatório Remessas")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('relatorio-erp-novo|relatorio-erp-editar|relatorio-erp-excluir|relatorio-erp-visualizar|relatorio-erp-emissao') || _vm.ehParceiroEstrategico) ? _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(4), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [(this.$root.authorize('relatorio-erp-visualizar|relatorio-erp-novo|relatorio-erp-editar|relatorio-erp-excluir')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-relatorio'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Cadastro")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-erp-emissao') || _vm.ehParceiroEstrategico) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'emite-relatorio'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Emissão")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), ((_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.$root.authorize('chamado-visualizar')) || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos))) ? _c('li', {
	    staticClass: "treeview",
	    attrs: {
	      "data-widget": "tree"
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [(this.$root.authorize('chamado-novo')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'abrir-chamado'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Abrir Chamado")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('chamado-visualizar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-chamado-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Listar Chamados")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('chamado-visualizar-assunto')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cadastro-assunto-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Gestão de Assuntos")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('chamado-relatorios')) ? _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/BI%20-%20Chamados%20DQ?rs:embed=true"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Relatórios")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('chamado-visualizar')) ? _c('a', {
	    attrs: {
	      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/Chamados%20Encerrados?rs:embed=true",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  }), _vm._v(" BI - Chamados Encerrados")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-agencia-configurar|usuario-fundacao-configurar|usuario-entidade-configurar|usuario-estrategico-configurar|usuario-superintendencia-configurar|entidade-configurar|proposta-configurar')) ? _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(6), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [(this.$root.authorize('usuario-agencia-configurar|usuario-fundacao-configurar|usuario-entidade-configurar|usuario-estrategico-configurar|usuario-superintendencia-configurar|entidade-configurar|proposta-configurar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'conf-gerais'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Configurações Gerais")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'log-edicao-proposta'
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Análise Logs")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('perfil-visualizar')) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'logs-email'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Log de E-mails Enviados")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || _vm.ehParceiroEstrategico || !_vm._.isEmpty(_vm.projetos)) ? _c('li', {
	    staticClass: "treeview"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'manuais'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-newspaper-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Manuais e Modelos")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.usuarioLogado.strategicPartner && _vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439 && (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos)))) ? _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.propostas || _vm.loading.projetos),
	      expression: "loading.propostas || loading.projetos"
	    }],
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando menu ...")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-folder"
	  }), _vm._v(" "), _c('span', [_vm._v("Cadastro")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gavel"
	  }), _vm._v(" "), _c('span', [_vm._v("Validação")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-share-square-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Remessa")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text"
	  }), _vm._v(" "), _c('span', [_vm._v("Relatórios ERP")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Chamados")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" "), _c('span', [_vm._v("Configurações")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "http://www.fbb.org.br/projetos/portal",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out"
	  }), _vm._v(" "), _c('span', [_vm._v("Antigo SGP")])])
	}]}

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-maxlength ng-valid-minlength ng-valid-mask ng-valid-parse ng-valid-date ng-valid-max ng-valid ng-valid-required",
	    attrs: {
	      "name": "user",
	      "novalidate": ""
	    }
	  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmRegUserFbb.$submitted && frmRegUserFbb.userName.$error.required }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.userName),
	      expression: "user.userName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "userName",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.user.userName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "userName", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), (_vm.user.userType === 'ENTIDADE') ? _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "cpf"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.cpf),
	      expression: "user.cpf"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('###.###.###-##'),
	      expression: "'###.###.###-##'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        cpf: true
	      }),
	      expression: "{cpf: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.user.cpf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "cpf", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-isolate-scope ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "minlength": "1",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "email", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), (this.$root.authorize('usuario-fundacao-atribuir-perfil')) ? _c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Perfis")]), _vm._v(" "), _c('div', {
	    staticClass: "well well-sm no-shadow animated fadeInDownOutUp ng-pristine ng-valid-mask ng-invalid ng-invalid-required ng-valid-maxlength ng-valid-max ng-valid-date ng-hide"
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2"
	  }, [_vm._v("Adicionar o perfil:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4",
	    class: {
	      'has-error': _vm.errors.first('profile')
	    }
	  }, [_c('profiles', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    attrs: {
	      "name": "profile",
	      "propsProfile": _vm.profileConstraint.profile
	    },
	    on: {
	      "profileSelected": function($event) {
	        _vm.profileConstraint.profile = $event
	      }
	    },
	    model: {
	      value: (_vm.profileConstraint.profile),
	      callback: function($$v) {
	        _vm.$set(_vm.profileConstraint, "profile", $$v)
	      },
	      expression: "profileConstraint.profile"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('profile')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('initialDate')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "dt_inicial"
	    }
	  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profileConstraint.initialDate),
	      expression: "profileConstraint.initialDate"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "date",
	      "name": "initialDate"
	    },
	    domProps: {
	      "value": (_vm.profileConstraint.initialDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.profileConstraint, "initialDate", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('initialDate')))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "dt_final"
	    }
	  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profileConstraint.inactivateDate),
	      expression: "profileConstraint.inactivateDate"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "inactivateDate",
	      "type": "date"
	    },
	    domProps: {
	      "value": (_vm.profileConstraint.inactivateDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.profileConstraint, "inactivateDate", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-10 col-sm-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onAdd()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onCancel()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "items": _vm.items,
	      "hover": _vm.hover,
	      "fields": _vm.fields,
	      "filter": _vm.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Preencha o filtro acima!",
	      "table-layout:": "",
	      "fixed": ""
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "filtered": _vm.onFiltered
	    },
	    scopedSlots: _vm._u([{
	      key: "active",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value == 'true' ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "profile.createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "disabled": !_vm.$root.authorize('perfil-atribuir-usuario')
	          },
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.onEdit(_vm.p)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Editar\n                              ")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "warning",
	            "size": "button--size-ss",
	            "disabled": !_vm.$root.authorize('perfil-atribuir-usuario')
	          },
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.onDelete(_vm.p)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }, [_vm._v(" Excluir")])])], 1)]
	      }
	    }], null, false, 2408969140)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onSave($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onClean($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "to": {
	        name: 'cadastro-usuarios-lista'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])]), _vm._v("\n'"), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de usuário: Fundação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])
	}]}

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-show": "$ctrl.isNewAvaiable()"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Objetivo Específico")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('table', {
	    staticClass: "table b-table table-hover table-bordered b-table-stacked-md",
	    attrs: {
	      "role": "table",
	      "aria-busy": "false",
	      "aria-colcount": "2",
	      "aria-rowcount": "-1"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
	    attrs: {
	      "role": "rowgroup"
	    }
	  }, _vm._l((_vm.table.items), function(item, index) {
	    return _c('tr', {
	      attrs: {
	        "aria-rowindex": "1",
	        "role": "row"
	      }
	    }, [_c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "aria-colindex": "1",
	        "data-label": "Objetivo específico",
	        "role": "cell"
	      }
	    }, [_c('div', [_vm._v(_vm._s(item.description))])]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "aria-colindex": "2",
	        "data-label": "Ações",
	        "role": "cell"
	      }
	    }, [_c('div', [_c('div', [_c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "type": "button",
	        "disabled": false
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.edita(item, index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button",
	        "disabled": false
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.exclui(item, index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])])])])])
	  }), 0)])])])])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('descrição')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "description"
	    }
	  }, [_vm._v("Descrição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addSpeObjCtrl.approval",
	      "state": "addSpeObjCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.objective.description),
	      expression: "objective.description"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "descrição",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.objective.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.objective, "description", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('descrição')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('descrição')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-team-add"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-team-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', {
	    staticClass: "sorting sorting_asc text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "1",
	      "aria-label": "Click to sort Descending",
	      "aria-sort": "ascending"
	    }
	  }, [_vm._v("Objetivo específico")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "13%"
	    },
	    attrs: {
	      "aria-colindex": "2"
	    }
	  }, [_vm._v("Ações")])])])
	}]}

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box box-primary",
	    attrs: {
	      "id": "analise"
	    }
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('font', {
	    staticStyle: {
	      "color": "#048019"
	    }
	  }, [_vm._v("Análise da Proposta")])], 1), (_vm.analise.ds_codigo_projeto_erp) ? _c('span', {
	    staticStyle: {
	      "color": "#a8a8a8"
	    }
	  }, [_vm._v(" -  N°Projeto: "), _c('b', [_vm._v(_vm._s(_vm.analise.ds_codigo_projeto_erp))])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.ehSimplificada) ? _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("\n      Proposta Simplificada\n    ")]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": _vm.bloqueia === true
	    }
	  }, [(_vm._.isNull(_vm.analise.fep) || _vm._.isUndefined(_vm.analise.fep) || _vm._.isEmpty(_vm.analise.fep) || _vm.analise.fep === '') ? _c('div', [_c('span', {
	    staticClass: "mensagem naoPreenchido"
	  }, [_vm._v("FEP ainda não gerada no sistema. É necessário informar o número da FEP")]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.numeroFepInformado),
	      expression: "numeroFepInformado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "placeholder": "Qual vai ser o número da FEP?",
	      "min": "0",
	      "max": "999",
	      "step": "1"
	    },
	    domProps: {
	      "value": (_vm.numeroFepInformado)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.numeroFepInformado = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._v(_vm._s(_vm.resultadoVerificacaoFepExistente))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "disabled": _vm._.isNull(_vm.numeroFepInformado) || _vm._.isEmpty(_vm.numeroFepInformado) || (+_vm.numeroFepInformado < 1 || +_vm.numeroFepInformado > 999),
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.criaNovaFep(_vm.numeroFepInformado)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Gerar FEP")])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE',
	      "id": "fep"
	    }
	  }, [(!_vm._.isNull(_vm.analise) && !_vm._.isEmpty(_vm.analise)) ? _c('fep', {
	    attrs: {
	      "propsAnalise": _vm.propsAnalise
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('fieldset', [_c('odsMarcacao', {
	    attrs: {
	      "proposta": this.$route.params.id,
	      "telaProjeto": false,
	      "id": "odsMarcacao"
	    }
	  })], 1), _vm._v(" "), _c('fieldset', [_c('licenciamentoAmbientalAnalise', {
	    ref: "licenciamentoAnalise",
	    attrs: {
	      "idProposta": this.$route.params.id,
	      "novaCarga": _vm.novaCarga
	    }
	  })], 1), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": _vm.bloqueia === true,
	      "id": "relatorioAnalise"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('legend', {
	    attrs: {
	      "disabled": false
	    }
	  }, [(_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', [_c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-analise',
	        params: {
	          id: _vm.analise.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v(" Preencher Relatório")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-success btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'visualiza-relatorio-analise',
	        params: {
	          id: _vm.analise.id,
	          projeto: _vm.analise.ds_codigo_projeto_erp
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Visualizar Relatório")])], 1) : _c('fieldset', [_c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-analise',
	        params: {
	          id: _vm.analise.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Visualizar Relatório")])], 1)])]), _vm._v(" "), (_vm._.isNull(_vm.analise.relatorio_analise)) ? _c('span', {
	    staticClass: "mensagem naoPreenchido"
	  }, [_vm._v(" Relatório da Análise não preenchido ainda")]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.showModal) ? _c('div', {
	    attrs: {
	      "id": "modal4"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "modal",
	      "id": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask",
	    attrs: {
	      "id": "modal3"
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper",
	    attrs: {
	      "id": "modal1"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit(_vm.showModal = true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "id": "modal2"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Relatório da Análise")])]), _vm._v(" "), _c('relatorio-analise', {
	    attrs: {
	      "propsProposta": _vm.analise
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('b-button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button",
	      "disabled": false
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Salvar ")]), _vm._v(" "), _c('b-button', {
	    staticClass: "btn btn-warning btn-sm btn-flat",
	    attrs: {
	      "type": "button",
	      "disabled": false
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Fechar ")])], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('br')])], 1)])])])])], 1) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.ehSimplificada) ? _c('div', {
	    staticClass: "box box-widget",
	    attrs: {
	      "id": "ratingEntidade"
	    }
	  }, [_c('div', {
	    staticClass: " with-border"
	  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', [(!_vm.ehSimplificada) ? _c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-rating',
	        params: {
	          id: _vm.analise.id
	        },
	        query: {
	          entidade: _vm.analise.entidade.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v(" Calcular o Rating da Entidade")]) : _vm._e()], 1) : _c('fieldset', [(!_vm.ehSimplificada) ? _c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-rating',
	        params: {
	          id: _vm.analise.id
	        },
	        query: {
	          entidade: _vm.analise.entidade.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Visualizar o Rating da Entidade")]) : _vm._e()], 1)]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.analise.ds_fase !== 'CADASTRO') ? _c('questionario-riscos', {
	    key: _vm.questRiscKey,
	    ref: "child",
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE',
	      "propsAnalise": _vm.propsAnalise,
	      "ehSimplificada": _vm.ehSimplificada,
	      "id": "questionarioRiscos"
	    },
	    on: {
	      "questionario": function($event) {
	        _vm.analise.questionario_respostas = (Array.isArray($event) && $event.length === 0) ? {} : $event
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.analise) ? _c('categorizadores', {
	    attrs: {
	      "propsAnalise": _vm.propsAnalise,
	      "indicativoAvaliacao": _vm.indicativoAvaliacao,
	      "ehSimplificada": _vm.ehSimplificada
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.analise.edital === null) ? _c('span', [(!_vm.ehSimplificada) ? _c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE'
	    }
	  }, [_c('questoesAvaliacaoProjeto', {
	    ref: "questoesAvaliacao",
	    attrs: {
	      "idProposta": _vm.analise.id,
	      "resultadoAprovacao": _vm.propsAnalise.resultadoAprovacao,
	      "proximaEtapa": _vm.propsAnalise.proximaEtapa
	    }
	  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE'
	    }
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "disabled": _vm.bloqueia === true
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Indicadores de Resultado")]), _vm._v(" "), _c('checklist-indicadores', {
	    attrs: {
	      "opcoes": _vm.opcoesIndicadores,
	      "disabled": _vm.bloqueia === true
	    },
	    model: {
	      value: (_vm.analise.dados.indicadores_resultado),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.dados, "indicadores_resultado", $$v)
	      },
	      expression: "analise.dados.indicadores_resultado"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    attrs: {
	      "disabled": _vm.bloqueia === true
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('acoes')
	    },
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "acoes"
	    }
	  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.ds_acoes_comunicacao),
	      expression: "analise.ds_acoes_comunicacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-height": "150px",
	      "resize": "vertical"
	    },
	    attrs: {
	      "placeholder": "Informe as acões de comunicação",
	      "data-vv-as": "Ações",
	      "name": "acoes",
	      "rows": "6"
	    },
	    domProps: {
	      "value": (_vm.analise.ds_acoes_comunicacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "ds_acoes_comunicacao", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('acoes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('acoes')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": _vm.bloqueia === true,
	      "id": "periodicidadeRelatorio"
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('periodicidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Periodicidade da apresentação dos relatórios de execução")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.ds_periodicidade_formulario),
	      expression: "analise.ds_periodicidade_formulario"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "periodicidade",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.analise, "ds_periodicidade_formulario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.reportPeriodicity), function(i) {
	    return _c('option', {
	      domProps: {
	        "value": i.id
	      }
	    }, [_vm._v(_vm._s(i.name))])
	  }), 0), _vm._v(" "), (_vm.errors.first('periodicidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodicidade')))]) : _vm._e()])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('fieldset', {
	    attrs: {
	      "disabled": _vm.bloqueia === true,
	      "id": "camposEstrategicos"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Temática do Projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0",
	      "margin-top": "6px"
	    }
	  }, _vm._l((_vm.tematicaProjetoOpcoes), function(item, idx) {
	    return _c('div', {
	      key: idx,
	      staticClass: "col-md-4",
	      staticStyle: {
	        "padding": "3px 15px"
	      }
	    }, [_c('label', {
	      staticClass: "new-control new-control-checkbox",
	      staticStyle: {
	        "padding-top": "4px",
	        "font-weight": "normal",
	        "cursor": "pointer"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.analise.dados.tematica_projeto),
	        expression: "analise.dados.tematica_projeto"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": item,
	        "checked": Array.isArray(_vm.analise.dados.tematica_projeto) ? _vm._i(_vm.analise.dados.tematica_projeto, item) > -1 : (_vm.analise.dados.tematica_projeto)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.analise.dados.tematica_projeto,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = item,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.analise.dados, "tematica_projeto", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.analise.dados, "tematica_projeto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.analise.dados, "tematica_projeto", $$c)
	          }
	        }
	      }
	    }), _vm._v("\n                   " + _vm._s(item) + "\n                  "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])
	  }), 0), _vm._v(" "), (_vm.tematicaOutrosSelecionado) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0",
	      "margin-top": "6px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.tematica_projeto_outros),
	      expression: "analise.dados.tematica_projeto_outros"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "maxlength": "255",
	      "placeholder": "Descreva a(s) outra(s) temática(s)"
	    },
	    domProps: {
	      "value": (_vm.analise.dados.tematica_projeto_outros)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise.dados, "tematica_projeto_outros", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#a8a8a8",
	      "font-size": "13px"
	    }
	  }, [_vm._v("Preenchimento obrigatório para concluir a análise.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "4px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Ação Estratégica")]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0",
	      "margin-top": "6px"
	    }
	  }, _vm._l((_vm.direcionadoresEstrategicosOpcoes), function(item, idx) {
	    return _c('div', {
	      key: idx,
	      staticClass: "col-md-4",
	      staticStyle: {
	        "padding": "3px 15px"
	      }
	    }, [_c('label', {
	      staticClass: "new-control new-control-checkbox",
	      staticStyle: {
	        "padding-top": "4px",
	        "font-weight": "normal"
	      },
	      style: ({
	        cursor: _vm.ehDirecionadorAutomatico(item) ? 'not-allowed' : 'pointer'
	      })
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.analise.dados.direcionadores_estrategicos),
	        expression: "analise.dados.direcionadores_estrategicos"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "disabled": _vm.ehDirecionadorAutomatico(item)
	      },
	      domProps: {
	        "value": item,
	        "checked": Array.isArray(_vm.analise.dados.direcionadores_estrategicos) ? _vm._i(_vm.analise.dados.direcionadores_estrategicos, item) > -1 : (_vm.analise.dados.direcionadores_estrategicos)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.analise.dados.direcionadores_estrategicos,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = item,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.analise.dados, "direcionadores_estrategicos", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.analise.dados, "direcionadores_estrategicos", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.analise.dados, "direcionadores_estrategicos", $$c)
	          }
	        }
	      }
	    }), _vm._v("\n                   " + _vm._s(item) + "\n                  "), _c('div', {
	      staticClass: "new-control-indicator"
	    })]), _vm._v(" "), (_vm.textoAjudaDirecionador(item)) ? _c('span', {
	      staticClass: "ajuda-direcionador",
	      class: {
	        'ajuda-direcionador-esquerda': (idx % 3) === 2
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-question-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "ajuda-direcionador-texto"
	    }, [_vm._v(_vm._s(_vm.textoAjudaDirecionador(item)))])]) : _vm._e()])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "4px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Comunicadores Populares")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "6px"
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-checkbox",
	    staticStyle: {
	      "padding-top": "4px",
	      "font-weight": "normal",
	      "cursor": "pointer"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.comunicadores_populares),
	      expression: "analise.dados.comunicadores_populares"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.analise.dados.comunicadores_populares) ? _vm._i(_vm.analise.dados.comunicadores_populares, null) > -1 : (_vm.analise.dados.comunicadores_populares)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.analise.dados.comunicadores_populares,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.analise.dados, "comunicadores_populares", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.analise.dados, "comunicadores_populares", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.analise.dados, "comunicadores_populares", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n                 O projeto possui Comunicadores Populares\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "4px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Histórico da Proponente")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.historico_proponente),
	      expression: "analise.dados.historico_proponente"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-height": "150px",
	      "resize": "vertical"
	    },
	    attrs: {
	      "rows": "6",
	      "placeholder": _vm.placeholderHistoricoProponente
	    },
	    domProps: {
	      "value": (_vm.analise.dados.historico_proponente)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise.dados, "historico_proponente", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "4px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Perfil Territorial")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.perfil_territorial),
	      expression: "analise.dados.perfil_territorial"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-height": "150px",
	      "resize": "vertical"
	    },
	    attrs: {
	      "rows": "6",
	      "placeholder": "Informações sobre o território, dados sobre a atuação da entidade e se já atua em rede"
	    },
	    domProps: {
	      "value": (_vm.analise.dados.perfil_territorial)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise.dados, "perfil_territorial", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "4px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objeto do Convênio")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.objeto_convenio),
	      expression: "analise.dados.objeto_convenio"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-height": "150px",
	      "resize": "vertical"
	    },
	    attrs: {
	      "rows": "6",
	      "placeholder": "Descreva o objeto do convênio"
	    },
	    domProps: {
	      "value": (_vm.analise.dados.objeto_convenio)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise.dados, "objeto_convenio", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "4px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Dirigente Indígena ou Quilombola")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "6px"
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-checkbox",
	    staticStyle: {
	      "padding-top": "4px",
	      "font-weight": "normal",
	      "cursor": "pointer"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.dirigente_indigena_quilombola),
	      expression: "analise.dados.dirigente_indigena_quilombola"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.analise.dados.dirigente_indigena_quilombola) ? _vm._i(_vm.analise.dados.dirigente_indigena_quilombola, null) > -1 : (_vm.analise.dados.dirigente_indigena_quilombola)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.analise.dados.dirigente_indigena_quilombola,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.analise.dados, "dirigente_indigena_quilombola", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.analise.dados, "dirigente_indigena_quilombola", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.analise.dados, "dirigente_indigena_quilombola", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n                 A entidade possui dirigente indígena ou quilombola\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "4px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Povos Indígenas abrangidos")]), _vm._v(" "), _c('multiselect', {
	    attrs: {
	      "options": _vm.povosIndigenasOpcoes,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": false,
	      "preserve-search": true,
	      "searchable": true,
	      "taggable": true,
	      "tag-placeholder": "Pressione enter para adicionar este povo",
	      "disabled": _vm.bloqueia === true,
	      "placeholder": "Busque e selecione os povos indígenas abrangidos (se houver)",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado"
	    },
	    on: {
	      "tag": _vm.adicionaPovoIndigena
	    },
	    model: {
	      value: (_vm.analise.dados.povos_indigenas),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.dados, "povos_indigenas", $$v)
	      },
	      expression: "analise.dados.povos_indigenas"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_vm._v("Nenhum povo localizado. Digite e pressione enter para adicionar.")]), _vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_vm._v("Nenhum povo cadastrado. Digite e pressione enter para adicionar.")])]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#a8a8a8",
	      "font-size": "13px"
	    }
	  }, [_vm._v("Deixe em branco caso o projeto não abranja povos indígenas.")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "4px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Povos Quilombolas abrangidos")]), _vm._v(" "), _c('multiselect', {
	    attrs: {
	      "options": _vm.povosQuilombolasOpcoes,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": false,
	      "preserve-search": true,
	      "searchable": true,
	      "taggable": true,
	      "tag-placeholder": "Pressione enter para adicionar este povo",
	      "disabled": _vm.bloqueia === true,
	      "placeholder": "Busque e selecione os povos quilombolas abrangidos (se houver)",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado"
	    },
	    on: {
	      "tag": _vm.adicionaPovoQuilombola
	    },
	    model: {
	      value: (_vm.analise.dados.povos_quilombolas),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.dados, "povos_quilombolas", $$v)
	      },
	      expression: "analise.dados.povos_quilombolas"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_vm._v("Nenhum povo localizado. Digite e pressione enter para adicionar.")]), _vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_vm._v("Nenhum povo cadastrado. Digite e pressione enter para adicionar.")])]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#a8a8a8",
	      "font-size": "13px"
	    }
	  }, [_vm._v("Deixe em branco caso o projeto não abranja povos quilombolas.")])], 1)]), _vm._v(" "), _c('fieldset', {
	    staticStyle: {
	      "margin-top": "12px"
	    },
	    attrs: {
	      "id": "contextoTerritorial"
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0",
	      "margin-top": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-bottom": "6px"
	    }
	  }, [_vm._v("I) Características Geográficas")]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0"
	    }
	  }, _vm._l((_vm.caracteristicasGeograficasOpcoes), function(item, idx) {
	    return _c('div', {
	      key: idx,
	      staticClass: "col-md-4",
	      staticStyle: {
	        "padding": "3px 15px"
	      }
	    }, [_c('label', {
	      staticClass: "new-control new-control-checkbox",
	      staticStyle: {
	        "padding-top": "4px",
	        "font-weight": "normal",
	        "cursor": "pointer"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.analise.dados.contexto_caracteristicas_geograficas),
	        expression: "analise.dados.contexto_caracteristicas_geograficas"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": item,
	        "checked": Array.isArray(_vm.analise.dados.contexto_caracteristicas_geograficas) ? _vm._i(_vm.analise.dados.contexto_caracteristicas_geograficas, item) > -1 : (_vm.analise.dados.contexto_caracteristicas_geograficas)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.analise.dados.contexto_caracteristicas_geograficas,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = item,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.analise.dados, "contexto_caracteristicas_geograficas", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.analise.dados, "contexto_caracteristicas_geograficas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.analise.dados, "contexto_caracteristicas_geograficas", $$c)
	          }
	        }
	      }
	    }), _vm._v("\n                     " + _vm._s(item) + "\n                    "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0",
	      "margin-top": "12px",
	      "margin-bottom": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-bottom": "6px"
	    }
	  }, [_vm._v("II) Biomas")]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0"
	    }
	  }, _vm._l((_vm.biomasOpcoes), function(item, idx) {
	    return _c('div', {
	      key: idx,
	      staticClass: "col-md-4",
	      staticStyle: {
	        "padding": "3px 15px"
	      }
	    }, [_c('label', {
	      staticClass: "new-control new-control-checkbox",
	      staticStyle: {
	        "padding-top": "4px",
	        "font-weight": "normal",
	        "cursor": "pointer"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.analise.dados.contexto_biomas),
	        expression: "analise.dados.contexto_biomas"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": item,
	        "checked": Array.isArray(_vm.analise.dados.contexto_biomas) ? _vm._i(_vm.analise.dados.contexto_biomas, item) > -1 : (_vm.analise.dados.contexto_biomas)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.analise.dados.contexto_biomas,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = item,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.analise.dados, "contexto_biomas", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.analise.dados, "contexto_biomas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.analise.dados, "contexto_biomas", $$c)
	          }
	        }
	      }
	    }), _vm._v("\n                     " + _vm._s(item) + "\n                    "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])
	  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('fieldset', {
	    attrs: {
	      "disabled": _vm.bloqueia === true,
	      "id": "analiseDetalhada"
	    }
	  }, [(!_vm.ehSimplificadaRelatorio) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "12px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Situação Problema")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.situacao_problema),
	      expression: "analise.dados.situacao_problema"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-height": "200px",
	      "resize": "vertical"
	    },
	    attrs: {
	      "rows": "10",
	      "placeholder": "Descreva a situação problema que o projeto pretende enfrentar"
	    },
	    domProps: {
	      "value": (_vm.analise.dados.situacao_problema)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise.dados, "situacao_problema", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Proposta de Solução e Sustentabilidade")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.analise),
	      expression: "analise.dados.analise"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-height": "200px",
	      "resize": "vertical"
	    },
	    attrs: {
	      "rows": "10",
	      "placeholder": _vm.placeholderAnalise
	    },
	    domProps: {
	      "value": (_vm.analise.dados.analise)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise.dados, "analise", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "display": "flex",
	      "align-items": "center",
	      "justify-content": "space-between",
	      "gap": "8px",
	      "margin-bottom": "5px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_vm._v("Distribuição e Informações dos Recursos")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "confirm",
	      rawName: "v-confirm",
	      value: ({
	        ok: function (retorno) { return _vm.geraAnaliseTecnica(); },
	        cancel: function () {},
	        message: 'O texto atual da <b>Distribuição e Informações dos Recursos</b> será substituído pela lista de atividades e valores. Deseja continuar?'
	      }),
	      expression: "{ok: retorno => geraAnaliseTecnica(), cancel: () => {}, message: 'O texto atual da <b>Distribuição e Informações dos Recursos</b> será substituído pela lista de atividades e valores. Deseja continuar?'}"
	    }],
	    staticClass: "btn btn-default btn-sm btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  }), _vm._v(" Gerar novamente\n              ")])]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.dados.analise_tecnica),
	      expression: "analise.dados.analise_tecnica"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-height": "200px",
	      "resize": "vertical"
	    },
	    attrs: {
	      "rows": "10",
	      "placeholder": "Descreva a distribuição dos recursos por atividade e as informações relevantes"
	    },
	    domProps: {
	      "value": (_vm.analise.dados.analise_tecnica)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise.dados, "analise_tecnica", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
	    staticStyle: {
	      "margin-top": "12px"
	    },
	    attrs: {
	      "id": "checklistAnalise"
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('checklist-analise', {
	    attrs: {
	      "dados": _vm.analise.dados,
	      "disabled": _vm.bloqueia === true
	    }
	  }, [(_vm.restricoesEntidade) ? _c('template', {
	    slot: "inicio-regularidade"
	  }, [_c('quadro-restricoes-entidade', {
	    attrs: {
	      "restricoes": _vm.restricoesEntidade
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('template', {
	    slot: "antes-enquadramento"
	  }, [_c('fieldset', {
	    staticStyle: {
	      "margin-bottom": "12px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Parecer jurídico")])]), _vm._v(" "), _c('parecer-juridico-campos', {
	    attrs: {
	      "analise": _vm.analise
	    }
	  })], 1)])], 2)], 1), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('fieldset', {
	    staticStyle: {
	      "margin-top": "12px"
	    },
	    attrs: {
	      "id": "pontosAtencaoMitigadores"
	    }
	  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._l((_vm.analise.dados.pontos_atencao_mitigadores), function(item, idx) {
	    return _c('div', {
	      key: idx,
	      staticStyle: {
	        "display": "flex",
	        "gap": "16px",
	        "align-items": "flex-start",
	        "margin-bottom": "8px"
	      }
	    }, [_c('div', {
	      staticStyle: {
	        "flex": "1"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.risco),
	        expression: "item.risco"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "placeholder": "Descreva o ponto de atenção",
	        "maxlength": "255"
	      },
	      domProps: {
	        "value": (item.risco)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "risco", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "flex": "1"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.mitigador),
	        expression: "item.mitigador"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "placeholder": "Descreva o elemento mitigador",
	        "maxlength": "255"
	      },
	      domProps: {
	        "value": (item.mitigador)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "mitigador", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "52px",
	        "flex": "none"
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button",
	        "disabled": _vm.analise.dados.pontos_atencao_mitigadores.length === 1
	      },
	      on: {
	        "click": function($event) {
	          return _vm.removeRiscoMitigador(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])])])
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "8px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addRiscoMitigador()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Adicionar Ponto de Atenção/Mitigador\n            ")])])], 2) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "12px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Condicionantes")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "120px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "condicionantes",
	      "placeholder": "Informe os requisitos que devem ser cumpridos antes da execução do projeto"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.analise.dados.condicionantes),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.dados, "condicionantes", $$v)
	      },
	      expression: "analise.dados.condicionantes"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "12px",
	      "margin-bottom": "12px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "margin-right": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Proposta")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-height": "80px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "propostaTexto"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.analise.dados.conclusao_analise),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.dados, "conclusao_analise", $$v)
	      },
	      expression: "analise.dados.conclusao_analise"
	    }
	  })], 1)]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "id": "novoRelatorioAnalise"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "margin": "8px 0"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.abreLaravelAutenticado('/sgp/propostas/' + _vm.$route.params.id + '/relatorio')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Visualizar Novo Relatório de Análise\n            ")])])])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": _vm.bloqueia === true,
	      "id": "documentosAnalise"
	    }
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.documentosAnalise,
	      "propsEtapa": _vm.analise.ds_fase,
	      "documentTypes": _vm.dctos,
	      "documentosObrigatorios": '',
	      "local-uso": 'TODOS'
	    }
	  })], 1)])]), _vm._v(" "), (_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', {
	    attrs: {
	      "disabled": _vm.bloqueia === true
	    }
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('resultadoAprovacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.resultadoAprovacao),
	      expression: "analise.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "ENCAMINHAR_DEFERIMENTO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ENCAMINHAR_DEFERIMENTO")
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.analise, "resultadoAprovacao", "ENCAMINHAR_DEFERIMENTO")
	      }, function($event) {
	        return _vm.limparInfo()
	      }]
	    }
	  }), _vm._v(" Encaminhar para deferimento\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.resultadoAprovacao),
	      expression: "analise.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "DEVOLVER_ENTIDADE"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.resultadoAprovacao, "DEVOLVER_ENTIDADE")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "resultadoAprovacao", "DEVOLVER_ENTIDADE")
	      }
	    }
	  }), _vm._v(" Devolver à entidade para ajustes\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.resultadoAprovacao),
	      expression: "analise.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "INCLUIR_SAPIENS"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.resultadoAprovacao, "INCLUIR_SAPIENS")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "resultadoAprovacao", "INCLUIR_SAPIENS")
	      }
	    }
	  }), _vm._v(" Criar projeto e retornar para análise\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.resultadoAprovacao),
	      expression: "analise.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "ENVIAR_PENDENCIAS"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ENVIAR_PENDENCIAS")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "resultadoAprovacao", "ENVIAR_PENDENCIAS")
	      }
	    }
	  }), _vm._v(" Enviar para pendências\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.resultadoAprovacao),
	      expression: "analise.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "ANULAR_PROPOSTA"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ANULAR_PROPOSTA")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "resultadoAprovacao", "ANULAR_PROPOSTA")
	      }
	    }
	  }), _vm._v(" Anular proposta\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]), _vm._v(" "), (_vm.errors.first('resultadoAprovacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('É necessário preencher uma decisão da Análise!')))]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'ENVIAR_PENDENCIAS') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Motivo da pendência")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justificativa"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.analise.observacao),
	      callback: function($$v) {
	        _vm.$set(_vm.analise, "observacao", $$v)
	      },
	      expression: "analise.observacao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'DEVOLVER_ENTIDADE') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Motivo da pendência")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justificativa"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.analise.observacao),
	      callback: function($$v) {
	        _vm.$set(_vm.analise, "observacao", $$v)
	      },
	      expression: "analise.observacao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'ANULAR_PROPOSTA') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Justificativa para reprovação")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justificativa"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.analise.observacao),
	      callback: function($$v) {
	        _vm.$set(_vm.analise, "observacao", $$v)
	      },
	      expression: "analise.observacao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_c('legend', [_vm._v(" Relatório da Análise")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-horizontal",
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', {
	    staticClass: "box-title"
	  }, [_vm._v(" Rating da Entidade")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Periodicidade da apresentação dos relatórios de execução")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Informações Estratégicas")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC",
	      "margin-top": "10px"
	    }
	  }, [_c('legend', [_vm._v(" Priorização de Público")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Contexto Territorial")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Checklist da Análise")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Pontos de Atenção e Elementos Mitigadores")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "gap": "16px",
	      "margin-bottom": "6px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "flex": "1",
	      "margin": "0",
	      "text-align": "left"
	    }
	  }, [_vm._v("Ponto de Atenção")]), _vm._v(" "), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "flex": "1",
	      "margin": "0",
	      "text-align": "left"
	    }
	  }, [_vm._v("Elemento Mitigador")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "52px",
	      "flex": "none"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Documentos da Análise")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Decisões da análise da proposta")])])
	}]}

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-form": "frmCategorizers"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('vetor')
	    },
	    attrs: {
	      "title": '<h5>Definido pelo projeto duplicador ' + this.propsAnalise.duplicadorSapiens.numprj + ' selecionado</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Vetor")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_vetor),
	      expression: "propsAnalise.ds_categ_vetor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "vetor",
	      "aria-hidden": "true",
	      "disabled": !_vm._.isEmpty(_vm._.trim(_vm.propsAnalise.duplicadorSapiens.usu_prjvet))
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_vetor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'VETOR'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('vetor')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('vetor')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('ação')
	    },
	    attrs: {
	      "title": '<h5>Definido pelo projeto duplicador ' + this.propsAnalise.duplicadorSapiens.numprj + ' selecionado</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Ação")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_acao),
	      expression: "propsAnalise.ds_categ_acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "vetor",
	      "aria-hidden": "true",
	      "disabled": !_vm._.isEmpty(_vm._.trim(_vm.propsAnalise.duplicadorSapiens.usu_acao))
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'ACAO'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('ação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('ação')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('tecnologia')
	    },
	    attrs: {
	      "title": '<h5>Definido pelo projeto duplicador ' + this.propsAnalise.duplicadorSapiens.numprj + ' selecionado</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Tecnologia")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_tecnologia),
	      expression: "propsAnalise.ds_categ_tecnologia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "tecnologia",
	      "aria-hidden": "true",
	      "disabled": !_vm._.isEmpty(_vm._.trim(_vm.propsAnalise.duplicadorSapiens.usu_tecno))
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_tecnologia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'TECNOLOGIA'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('tecnologia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tecnologia')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('campo de atuação')
	    },
	    attrs: {
	      "title": '<h5>Definido pelo projeto duplicador ' + this.propsAnalise.duplicadorSapiens.numprj + ' selecionado</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Campo de Atuação")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_campo_atuacao),
	      expression: "propsAnalise.ds_categ_campo_atuacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "campo de atuação",
	      "aria-hidden": "true",
	      "disabled": !_vm._.isEmpty(_vm._.trim(_vm.propsAnalise.duplicadorSapiens.usu_campatu))
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_campo_atuacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'CAMPOS_DE_ATUACAO'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('campo de atuação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('campo de atuação')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('prospecção')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prospecção")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_prospeccao),
	      expression: "propsAnalise.ds_categ_prospeccao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "prospecção",
	      "aria-hidden": "true",
	      "disabled": false
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_prospeccao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'PROSPECCAO'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('prospecção')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('prospecção')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [(!_vm.ehSimplificada) ? _c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('avaliação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Avaliação")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.indicativoAvaliacao),
	      expression: "indicativoAvaliacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "prospecção",
	      "aria-hidden": "true",
	      "disabled": true
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.indicativoAvaliacao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }, [_vm._v("Preencha o questionário abaixo")]), _vm._v(" "), _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'AVALIACAO'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  })], 2), _vm._v(" "), (_vm.errors.first('avaliação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('avaliação')))]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('programa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Programa")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_programa),
	      expression: "propsAnalise.ds_categ_programa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "programa",
	      "aria-hidden": "true",
	      "disabled": false
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_programa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'PROGRAMA'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('programa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('programa')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('instrumento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Instrumento")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_instrumento),
	      expression: "propsAnalise.ds_categ_instrumento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "instrumento",
	      "aria-hidden": "true",
	      "disabled": false
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_instrumento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'INSTRUMENTO'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('instrumento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('instrumento')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('atividades')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cadeias Produtivas/Atividades")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_atividade),
	      expression: "propsAnalise.ds_categ_atividade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "atividades",
	      "aria-hidden": "true",
	      "disabled": false
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_atividade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'CADEIAS_PRODUTIVAS'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('atividades')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('atividades')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('edital')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Edital")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_categ_edital),
	      expression: "propsAnalise.ds_categ_edital"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "edital",
	      "aria-hidden": "true",
	      "disabled": false
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_categ_edital", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'EDITAL'])), function(categorizador) {
	    return _c('option', {
	      domProps: {
	        "value": categorizador.valor
	      }
	    }, [_vm._v(_vm._s(categorizador.descricao))])
	  }), 0), _vm._v(" "), (_vm.errors.first('edital')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('edital')))]) : _vm._e()])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Categorizadores")])])
	}]}

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "contentWrapper",
	    staticClass: "content-wrapper",
	    style: ('min-height: ' + _vm.alturaContentWrapper + 'px'),
	    attrs: {
	      "id": "validacoes"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - ' + _vm.enumeradores[_vm.validacao]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('p', {
	    staticClass: "visible-xs"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('h1', {
	    staticClass: "col-lg-5 col-md-6 col-sm-12 text-left"
	  }, [_vm._v("\n        " + _vm._s(_vm.enumeradores[_vm.validacao]) + "\n\n        "), (_vm.mostrarProcesso.length === 0) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostraCarregando),
	      expression: "!mostraCarregando"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-caret-down opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Abre as seções principais</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrarProcesso = _vm._.keys(_vm.listaValidacoes);
	        _vm.$refs['contentWrapper'].scrollIntoView()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.mostrarProcesso.length > 0 || _vm.mostrarAtividade.length > 0) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostraCarregando),
	      expression: "!mostraCarregando"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-caret-up opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Fecha todas as seções</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrarProcesso = [];
	        _vm.mostrarAtividade = [];
	        _vm.$refs['contentWrapper'].scrollIntoView()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.enumeradores[_vm.validacao] === 'Execução financeira') ? _c('img', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        delay: [500, 0],
	        placement: 'right'
	      }),
	      expression: "{\n              inertia:true,\n              arrow:true,\n              animation:'perspective',\n              distance:'1',\n              size:'large',\n              delay: [500, 0],\n              placement: 'right'}"
	    }],
	    staticClass: "semaforo",
	    attrs: {
	      "src": __webpack_require__(507),
	      "title": _vm.tituloFarolExecucaoFinanceira
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-7 col-md-6 col-sm-5"
	  }, [_c('div', {
	    staticClass: "col-md-8 pull-right"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    ref: "caixaPesquisa",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa...",
	      "title": '<h5>Digite uma palavra ou número e pressione Enter</h5>'
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filtrar()
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.pesquisa.length > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "input-group-btn",
	    attrs: {
	      "title": '<h5>Limpar essa pesquisa</h5>'
	    }
	  }, [_c('button', {
	    staticClass: "btn",
	    staticStyle: {
	      "background": "white",
	      "border-color": "#d2d6de",
	      "border-width": "1px 0px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pesquisa = '';
	        _vm.filtrar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  })])]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.pesquisa,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filtrar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-4 col-md-3 col-sm-7 text-lg-left"
	  }, [_c('div', {
	    staticClass: "truncar",
	    staticStyle: {
	      "padding-top": "5px",
	      "font-size": "18px",
	      "color": "darkgray"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "margin-left": "5px",
	      "color": "firebrick",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.totalTarefas(_vm.listaValidacoes)))]), _vm._v(" tarefas, das quais\n          "), _c('span', {
	    staticStyle: {
	      "margin-left": "5px",
	      "color": "firebrick",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.totalTarefasPrestacaoContasAte500()))]), _vm._v("  com valor de até R$ 500,00\n          "), (_vm.tarefasSelecionadas.length > 0) ? _c('span', [_c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }), _c('span', {
	    staticStyle: {
	      "margin-left": "5px",
	      "color": "var(--cor-azul)",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.tarefasSelecionadas.length))]), _vm._v(" tarefa" + _vm._s(_vm.tarefasSelecionadas.length > 1 ? 's' : '') + " selecionada" + _vm._s(_vm.tarefasSelecionadas.length > 1 ? 's' : ''))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-8 col-md-9 col-sm-12 text-right",
	    staticStyle: {
	      "line-height": "2em"
	    }
	  }, [_c('span', {
	    staticClass: "indicadores-cb-inline"
	  }, [_c('div', {
	    staticClass: "juntos",
	    attrs: {
	      "disabled": _vm.mostraProcessando
	    }
	  }, [_c('i', {
	    class: (_vm.selecionarTodasTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.selecionarTodasTarefas = (_vm.selecionarTodasTarefas === 'nao') ? 'sim' : 'nao'
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.selecionarTodasTarefas === 'nao' ? '' : 'selecionado'
	  }, [_vm._v("Selecionar tudo")])]), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [_c('i', {
	    class: (_vm.meusFavoritados === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.meusFavoritados = (_vm.meusFavoritados === 'nao') ? 'sim' : 'nao'
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.meusFavoritados === 'nao' ? '' : 'selecionado'
	  }, [_vm._v("Favoritos")])]), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [_c('i', {
	    class: (_vm.minhasTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.minhasTarefas = (_vm.minhasTarefas === 'nao') ? 'sim' : 'nao'
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.minhasTarefas === 'nao' ? '' : 'selecionado'
	  }, [_vm._v("Minhas Tarefas")])]), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [_c('i', {
	    class: (_vm.somenteComTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.somenteComTarefas = (_vm.somenteComTarefas === 'nao') ? 'sim' : 'nao'
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.somenteComTarefas === 'nao' ? '' : 'selecionado'
	  }, [_vm._v("Somente com Tarefas")])]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ordenacao.por),
	      expression: "ordenacao.por"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "auto",
	      "float": "left"
	    },
	    attrs: {
	      "title": '<h5>Selecione por qual critério deseja ordenar</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.ordenacao, "por", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "id_processo"
	    }
	  }, [_vm._v("ID")]), _vm._v(" "), (!_vm._.includes(['ENTIDADES', 'PARCEIRO_ESTRATEGICO'], _vm.validacao)) ? _c('option', {
	    attrs: {
	      "value": "projeto"
	    }
	  }, [_vm._v("Projeto")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('option', {
	    attrs: {
	      "value": "extra.situacao_projeto"
	    }
	  }, [_vm._v("Situação do Projeto")]) : _vm._e(), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "entidade"
	    }
	  }, [_vm._v("Entidade")]), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('option', {
	    attrs: {
	      "value": "valor"
	    }
	  }, [_vm._v("Valor")]) : _vm._e(), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "data_solicitacao"
	    }
	  }, [_vm._v("Data da Solicitação*")]), _vm._v(" "), (_vm._.includes(['OCORRENCIAS'], _vm.validacao)) ? _c('option', {
	    attrs: {
	      "value": "codigo_ocorrencia"
	    }
	  }, [_vm._v("Código da Ocorrência")]) : _vm._e()]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "btn btn-default btn-flat",
	    staticStyle: {
	      "float": "left"
	    },
	    attrs: {
	      "type": "button",
	      "title": '<h5>Clique para inverter a ordenação por ' + _vm._.replace(_vm.ordenacao.por, '_', ' ') + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.ordenacao.ordem = _vm.ordenacao.ordem === 'asc' ? 'desc' : 'asc'
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-sort-alpha-' + _vm.ordenacao.ordem,
	    staticStyle: {
	      "font-size": "14px"
	    }
	  })])])])])]), _vm._v(" "), (_vm.tarefasSelecionadas.length > 0) ? _c('div', {
	    staticClass: "col-xs-12 text-left"
	  }, [(!_vm.mostraProcessando) ? _c('span', [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5>Favoritar todos os selecionados</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.favoritarLote(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  }), _vm._v(" Favoritar\n          ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Desfavoritar todos os selecionados</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.favoritarLote(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star-o"
	  }), _vm._v(" Desfavoritar\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5>Atribuir a mim todos os selecionado</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.atribuirLote(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" Assumir\n          ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Desatribuir todos os selecionado</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.atribuirLote(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user-times"
	  }), _vm._v(" Desatribuir\n          ")]), _vm._v(" "), (this.usuarioLogado.perfis.some(function (perfil) { return perfil.ds_nome === 'Gerentes'; })) ? _c('span', [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true }"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5>Atribuir as tarefas selecionadas a funcionário</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.showModal = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user-plus"
	  }), _vm._v(" Atribuir\n            ")]), _vm._v(" "), (_vm.showModal) ? _c('div', {
	    staticClass: "modal-overlay"
	  }, [_c('div', {
	    staticClass: "modal-container",
	    staticStyle: {
	      "display": "flex",
	      "flex-direction": "column",
	      "align-items": "center"
	    }
	  }, [_c('button', {
	    staticClass: "btn-close",
	    on: {
	      "click": _vm.cancelarAtribuicao
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.funcionarioBusca),
	      expression: "funcionarioBusca"
	    }],
	    staticStyle: {
	      "display": "inline-block",
	      "margin-bottom": "10px",
	      "margin-right": "10px"
	    },
	    attrs: {
	      "type": "text",
	      "id": "searchFuncionario",
	      "placeholder": "Digite o nome ou a matrícula do funcionário"
	    },
	    domProps: {
	      "value": (_vm.funcionarioBusca)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.buscarFuncionario($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.funcionarioBusca = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn-confirm",
	    staticStyle: {
	      "display": "inline-block"
	    },
	    on: {
	      "click": _vm.buscarFuncionario
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), (_vm.funcionarioEncontrado) ? _c('div', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_c('p', [_c('strong', [_vm._v("Funcionário:")]), _vm._v(" " + _vm._s(_vm.funcionarioEncontrado.nome))]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-top": "-15px"
	    }
	  }, [_c('strong', [_vm._v("Matrícula:")]), _vm._v(" " + _vm._s(_vm.formatarMatricula(_vm.funcionarioEncontrado.matricula)))])]) : _vm._e(), _vm._v(" "), (_vm.funcionarioEncontrado) ? _c('div', [_c('p', [_vm._v("Deseja realmente atribuir as tarefas selecionadas?")]), _vm._v(" "), _c('div', {
	    staticClass: "modal-actions"
	  }, [_c('button', {
	    staticClass: "btn-confirm",
	    on: {
	      "click": _vm.confirmarAtribuicao
	    }
	  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn-cancel",
	    on: {
	      "click": _vm.cancelarAtribuicao
	    }
	  }, [_vm._v("Cancelar")])])]) : _vm._e()])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "title": '<h5>Baixar <span class=\'realce\'>' + _vm.tarefasSelecionadas.length + '</span> item(ns) selecionado(s) em Excel</h5>'
	    }
	  }, [_c('download-excel', {
	    attrs: {
	      "data": _vm.tarefasSelecionadas,
	      "meta": _vm.excel_meta,
	      "fields": _vm.excel_campos,
	      "type": "xls",
	      "name": "validacoes.xls"
	    }
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Baixar planilha\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mostraProcessando) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh ga-spin"
	  })]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
	    staticClass: "content",
	    staticStyle: {
	      "padding-top": "60px"
	    }
	  }, [_c('p', {
	    staticClass: "visible-sm visible-xs"
	  }, [_vm._v(" ")]), _c('p', {
	    staticClass: "visible-xs"
	  }, [_vm._v(" ")]), _c('p', {
	    staticClass: "visible-xs"
	  }, [_vm._v(" ")]), _vm._v(" "), (_vm.mostraCarregando) ? _c('h4', {
	    staticClass: "box-body text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh ga-spin"
	  })]) : _vm._e(), _vm._v(" "), (_vm.somenteComTarefas === 'sim' && _vm.totalTarefas(_vm.listaValidacoes) === 0) ? _c('h4', {
	    staticClass: "box-body"
	  }, [_vm._v("Não há tarefas para o filtro selecionado")]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.keysIn(_vm.listaValidacoes)), function(processo) {
	    return _c('div', {
	      staticClass: "box box-widget"
	    }, [_c('div', {
	      staticClass: "box-header"
	    }, [_c('h3', {
	      staticClass: "box-title"
	    }, [_c('span', {
	      staticClass: "grupoMostrarOcultar",
	      on: {
	        "click": function($event) {
	          return _vm.mostrar('processo', processo)
	        }
	      }
	    }, [_c('i', {
	      class: 'fa fa-caret-' + (!_vm._.isUndefined(_vm._.find(_vm.mostrarProcesso, function(p) {
	        return p === processo
	      })) ? 'up' : 'down'),
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.enumeradores[processo])), _c('span', {
	      staticClass: "contador"
	    }, [_vm._v(_vm._s(_vm.totalTarefas(_vm.listaValidacoes[processo])))])])]), _vm._v(" "), (processo === 'CONTRAPARTIDA' && _vm.filtroContrapartida) ? _c('div', {
	      staticStyle: {
	        "margin-top": "20px"
	      }
	    }, [_c('div', {
	      staticClass: "filtroCarteira mt-5"
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.filtroCarteiraContrapartida),
	        expression: "filtroCarteiraContrapartida"
	      }],
	      staticClass: "form-control",
	      staticStyle: {
	        "width": "auto",
	        "float": "left"
	      },
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.filtroCarteiraContrapartida = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, function($event) {
	          return _vm.onChangeFiltroCarteiraContrapartida()
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": "",
	        "value": ""
	      }
	    }, [_vm._v("Filtrar por carteira")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": ""
	      }
	    }, [_vm._v("Todas as carteiras")]), _vm._v(" "), _vm._l((_vm.carteiras), function(carteira) {
	      return _c('option', {
	        domProps: {
	          "value": carteira
	        }
	      }, [_vm._v("\n                " + _vm._s(carteira) + "\n              ")])
	    })], 2)])]) : _vm._e(), _vm._v(" "), (processo === 'ALTERACOES_PROJETO') ? _c('span', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          placement: 'top',
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', delay: [500, 0]}"
	      }],
	      staticClass: "pull-right",
	      attrs: {
	        "title": '<h5>Lista com processos de alteração de projeto nas tarefas listadas abaixo</h5>'
	      }
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.meusProcessos),
	        expression: "meusProcessos"
	      }],
	      staticClass: "form-control",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.meusProcessos = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, _vm.filtrar]
	      }
	    }, [_c('option', {
	      staticStyle: {
	        "color": "var(--cor-destaque)"
	      },
	      attrs: {
	        "value": "",
	        "selected": ""
	      }
	    }, [_vm._v(_vm._s(_vm.meusProcessos === '' ? 'Processos' : 'Limpar Filtro'))]), _vm._v(" "), _vm._l((_vm._.uniq(_vm._.flatten(_vm._.map(_vm._.flatten(_vm._.valuesIn(_vm.listaValidacoes.ALTERACOES_PROJETO)), 'extra.processos')))), function(prc) {
	      return _c('option', {
	        domProps: {
	          "value": prc
	        }
	      }, [_vm._v(_vm._s(_vm.enumeradores[prc]))])
	    })], 2)]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          placement: 'top',
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', delay: [500, 0]}"
	      }],
	      staticClass: "pull-right",
	      staticStyle: {
	        "margin": "0px 10px"
	      },
	      attrs: {
	        "title": '<h5>Lista com as carteiras nas tarefas listadas abaixo</h5>'
	      }
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.minhaCarteira),
	        expression: "minhaCarteira"
	      }],
	      staticClass: "form-control",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.minhaCarteira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, _vm.filtrar]
	      }
	    }, [_c('option', {
	      staticStyle: {
	        "color": "var(--cor-destaque)"
	      },
	      attrs: {
	        "value": "",
	        "selected": ""
	      }
	    }, [_vm._v(_vm._s(_vm.minhaCarteira === '' ? 'Carteiras' : 'Limpar Filtro'))]), _vm._v(" "), _vm._l((_vm._.uniq(_vm._.map(_vm._.flatten(_vm._.valuesIn(_vm.listaValidacoes.ALTERACOES_PROJETO)), 'extra.carteira'))), function(carteira) {
	      return _c('option', {
	        domProps: {
	          "value": carteira
	        }
	      }, [_vm._v(_vm._s(carteira))])
	    })], 2)])]) : _vm._e()]), _vm._v(" "), (!_vm._.isUndefined(_vm._.find(_vm.mostrarProcesso, function(p) {
	      return p === processo
	    }))) ? _c('div', {
	      staticClass: "box-body"
	    }, _vm._l((_vm._.keysIn(_vm.listaValidacoes[processo])), function(atividade) {
	      return _c('div', {
	        staticClass: "box box-widget"
	      }, [_c('div', {
	        staticClass: "box-header"
	      }, [_c('h3', {
	        staticClass: "box-title"
	      }, [_c('span', {
	        staticClass: "grupoMostrarOcultar",
	        on: {
	          "click": function($event) {
	            _vm.mostrar('atividade', (processo + '.' + atividade))
	          }
	        }
	      }, [_c('i', {
	        class: 'fa fa-caret-' + (!_vm._.isUndefined(_vm._.find(_vm.mostrarAtividade, function(p) {
	          return p === (processo + '.' + atividade)
	        })) ? 'up' : 'down'),
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v("\n                " + _vm._s(_vm.enumeradores[atividade]) + "\n                "), _c('span', {
	        staticClass: "contador"
	      }, [_vm._v("\n                  " + _vm._s(_vm.totalTarefas(_vm.listaValidacoes[processo][atividade])) + "\n                  "), _c('span', {
	        staticClass: "edital",
	        staticStyle: {
	          "font-weight": "normal",
	          "font-size": "12px",
	          "vertical-align": "middle"
	        },
	        domProps: {
	          "innerHTML": _vm._s(_vm.montaResumoSemaforoAtividade(processo, atividade))
	        }
	      })])])])]), _vm._v(" "), (!_vm._.isUndefined(_vm._.find(_vm.mostrarAtividade, function(p) {
	        return p === (processo + '.' + atividade)
	      }))) ? _c('div', {
	        ref: processo + '.' + atividade,
	        refInFor: true,
	        staticClass: "box-body"
	      }, [_c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm.mostraProcessando),
	          expression: "mostraProcessando"
	        }],
	        staticClass: "overlay box box-widget",
	        staticStyle: {
	          "position": "absolute",
	          "top": "0px",
	          "left": "0px",
	          "width": "100%",
	          "height": "100%",
	          "display": "block"
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-refresh ga-spin"
	      })]), _vm._v(" "), (true) ? _c('div', [_c('b-container', {
	        attrs: {
	          "fluid": ""
	        }
	      }, _vm._l(((_vm._.includes(['projeto', 'entidade'], _vm.ordenacao.por) ?
	        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [function(termo) {
	          return _vm._.lowerCase(termo[_vm.ordenacao.por])
	        }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
	        _vm._.includes(['valor'], _vm.ordenacao.por) ? // se for um valor deve converter primeiro antes de ordenar
	        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [function(termo) {
	          return parseFloat(termo[_vm.ordenacao.por])
	        }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
	        _vm._.includes(['codigo_ocorrencia'], _vm.ordenacao.por) ? // se código de oorrência deve pegar no 'extra'
	        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], ['extra.codigo_ocorrencia'], [_vm.ordenacao.ordem]) :
	        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [_vm.ordenacao.por], [_vm.ordenacao.ordem]))), function(tarefa) {
	        return _c('div', {
	          staticClass: "row tarefa",
	          style: ('border-left: 10px solid ' + (_vm.sinalizaCor(tarefa)))
	        }, [_c('div', {
	          staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12",
	          staticStyle: {
	            "height": "46px"
	          }
	        }, [_c('div', {
	          staticClass: "col-xs-2",
	          staticStyle: {
	            "padding": "2px 0"
	          }
	        }, [_c('span', {
	          staticClass: "indicadores"
	        }, [_c('i', {
	          class: (_vm._.find(_vm.tarefasSelecionadas, ['id_processo', tarefa.id_processo]) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' selecao',
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.selecionarItem(tarefa)
	            }
	          }
	        }), _vm._v(" "), _c('i', {
	          class: (tarefa.favoritado === 'sim_fav' ? 'fa fa-star favorito' : 'fa fa-star-o'),
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), (Number(tarefa.tem_produto) === 1) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          staticClass: "tipo_item produto",
	          attrs: {
	            "title": '<h5>Demanda libera item de <span class=\'realce\'>Produto</span></h5>'
	          }
	        }, [_vm._v("P")]) : _vm._e(), _vm._v(" "), (Number(tarefa.tem_servico) === 1) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          staticClass: "tipo_item servico",
	          attrs: {
	            "title": '<h5>Demanda libera item de <span class=\'realce\'>Serviço</span></h5>'
	          }
	        }, [_vm._v("S")]) : _vm._e(), _vm._v(" "), (Number(tarefa.eh_bndes) === 1) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          staticClass: "tipo_item bndes",
	          attrs: {
	            "title": '<h5>Projeto com recursos <span class=\'realce\'>BNDES</span></h5>'
	          }
	        }, [_vm._v("BNDES")]) : _vm._e(), _vm._v(" "), ((_vm._.get(tarefa.extra, 'chamados', [])).length === 1) ? _c('span', _vm._l((_vm._.get(tarefa.extra, 'chamados', [])), function(chamado) {
	          return _c('a', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'perspective',
	                distance: '1',
	                size: 'large',
	                placement: 'top',
	                interactive: true
	              }),
	              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', interactive:true}"
	            }],
	            attrs: {
	              "href": _vm.urlLaravel + '/cadastro/chamado/edita/' + chamado.id,
	              "target": "_blank",
	              "title": '<h5 class=\'text-left\'>Chamado SGP <span class=\'realce\'>' + chamado.id + '</span><br/>' + ((chamado.descricao).substr(0, 50) + (chamado.descricao.length > 50 ? '...' : '')) + '</h5>'
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-comments-o",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          })])
	        }), 0) : _vm._e(), _vm._v(" "), ((_vm._.get(tarefa.extra, 'chamados', [])).length > 1) ? _c('span', {
	          staticClass: "dropup menu_chamados"
	        }, [_c('span', {
	          staticClass: "balao_chamado dropdown",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('span', [_c('i', {
	          staticClass: "fa fa-comments-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]), _vm._v(" "), _c('span', {
	          staticClass: "contador_chamado"
	        }, [_vm._v(_vm._s((_vm._.get(tarefa.extra, 'chamados', [])).length))])]), _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu"
	        }, _vm._l((_vm._.get(tarefa.extra, 'chamados', [])), function(chamado) {
	          return _c('li', {
	            attrs: {
	              "role": "menuitem"
	            }
	          }, [_c('a', {
	            staticClass: "item_chamado",
	            attrs: {
	              "href": _vm.urlLaravel + '/cadastro/chamado/edita/' + chamado.id,
	              "target": "_blank"
	            }
	          }, [_vm._v("\n                                                      Chamado SGP "), _c('span', {
	            staticClass: "realce"
	          }, [_vm._v(_vm._s(chamado.id))]), _vm._v(" "), _c('i', {
	            staticClass: "fa fa-external-link"
	          }), _c('br'), _vm._v(_vm._s(((chamado.descricao).substr(0, 50) + (chamado.descricao.length > 50 ? '...' : ''))))])])
	        }), 0)]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'parametros') && _vm._.find(tarefa.extra.parametros, ['parametro', 'SUPORTE_FBB'])) ? _c('span', _vm._l((_vm.parametroStringToObject(tarefa.extra.parametros, 'SUPORTE_FBB')), function(suporte) {
	          return _c('span', [_c('a', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'perspective',
	                distance: '1',
	                size: 'large',
	                arrow: true,
	                placement: 'top'
	              }),
	              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	            }],
	            attrs: {
	              "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
	              "target": "_blank",
	              "title": '<h5>Suporte FBB <span class=\'realce\'>' + suporte.numero + '</span><br/>' + suporte.local + ' para ' + suporte.areaoper + '<br/>' + suporte.problema + '</h5>'
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-commenting-o",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          })])])
	        }), 0) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	          staticClass: "text-muted",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.id_processo)
	          }
	        })]), _vm._v(" "), _c('div', {
	          staticClass: "col-xs-10"
	        }, [_c('div', {
	          staticClass: "projeto truncar",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.projeto)
	          }
	        }), _vm._v(" "), _c('div', {
	          staticClass: "entidade truncar",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.entidade)
	          }
	        })])]), _vm._v(" "), _c('div', {
	          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-6 text-center",
	          staticStyle: {
	            "height": "46px",
	            "padding": "2px 0"
	          }
	        }, [(_vm._.includes(['ALTERACOES_PROJETO'], processo)) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top'}"
	          }],
	          attrs: {
	            "title": '<h5>' +
	              ((_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length === 0 ? ((_vm._.get(tarefa, 'extra.solicitacao.justificativa', '')).substr(0, 100) + '...') :
	                (_vm._.join(_vm._.orderBy(_vm._.uniq(_vm._.map(_vm._.get(tarefa.extra.solicitacao, 'processos', []), function(p) {
	                  return _vm.enumeradores[p.nome]
	                })), null, ['asc']), ', '))) + '</h5>'
	          }
	        }, [_vm._v("\n                      " + _vm._s((_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length > 1 ? (_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length + ' processos' : '1 processo') + "\n                    ")]) : (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('span', [(!_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'situacao_projeto')) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          style: ('font-weight: bold; color:' + (tarefa.extra.situacao_projeto === 'APR' ? 'var(--cor-destaque)' : 'var(--cor-atencao)')),
	          attrs: {
	            "title": '<h5>' + tarefa.extra.descricao_situacao + '</h5>'
	          }
	        }, [_vm._v("\n                        " + _vm._s(tarefa.extra.situacao_projeto) + "\n                      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.has(tarefa.extra, 'codigo_ocorrencia')) ? _c('span', {
	          staticClass: "text-bold"
	        }, _vm._l(([(_vm._.get(tarefa, 'extra.codigo_ocorrencia')).substr(0, 1)]), function(nivel) {
	          return _c('span', {
	            style: ('color: var(--cor-' + (nivel === '4' ? 'atencao' : (nivel === '3' ? 'alerta' : (nivel === '2' ? 'destaque' : 'fraca'))) + ')')
	          }, [_vm._v("\n                        " + _vm._s(_vm._.get(tarefa, 'extra.codigo_ocorrencia')) + "\n                      ")])
	        }), 0) : _c('span', {
	          domProps: {
	            "innerHTML": _vm._s(tarefa.info)
	          }
	        })]), _vm._v(" "), _c('div', {
	          class: (_vm._.includes(['SOLICITACOES'], _vm.validacao) ? 'col-lg-2 col-md-4 col-sm-4 col-xs-6' : 'col-lg-2 col-md-6 col-sm-5 col-xs-6') + ' text-center',
	          staticStyle: {
	            "height": "46px"
	          }
	        }, [(atividade === 'FINALIZADAS') ? _c('div', {
	          staticClass: "aprovado_por usuario"
	        }, [_vm._v("Aprovado por"), _c('br'), _c('div', {
	          staticClass: "truncar",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.nome_usuario)
	          }
	        })]) : _c('div', [(tarefa.nome_usuario) ? _c('div', {
	          staticClass: "usuario",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.nome_usuario)
	          }
	        }) : _c('div', {
	          staticClass: "text-muted"
	        }, [_vm._v("Aguardando atendimento")])])]), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('div', {
	          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-4 text-left",
	          staticStyle: {
	            "height": "46px"
	          }
	        }, [(_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], processo)) ? _c('span', [(_vm._.includes(['AUTORIZACAO', 'ANALISE_TRIBUTARIA', 'LIQUIDACAO_FINANCEIRA'], atividade)) ? _c('span', [_c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          attrs: {
	            "title": '<h5>Tributado: <span class=\'realce\'>' + (_vm._.get(_vm._.last(_vm._.filter(tarefa.extra.parametros, ['parametro', 'TRIBUTACAO'])), 'valor') === 'TRIBUTADO' ? 'Sim' : 'Não') + '</span></h5>'
	          }
	        }, [_vm._v("\n                          " + _vm._s(_vm._f("real")(tarefa.valor)) + "\n                        ")]), _vm._v(" "), (atividade === 'AUTORIZACAO' && !_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'parametros') && _vm._.find(tarefa.extra.parametros, ['parametro', 'VALOR_TRIBUTADO'])) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          staticStyle: {
	            "color": "var(--cor-destaque)"
	          },
	          attrs: {
	            "title": '<h5>Valor Líquido</h5>'
	          }
	        }, [_c('br'), _vm._v(_vm._s(_vm._f("real")(tarefa.valor - (_vm._.toNumber(_vm._.get(_vm._.last(_vm._.filter(tarefa.extra.parametros, ['parametro', 'VALOR_TRIBUTADO'])), 'valor'))))) + "\n                        ")]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(_vm._f("real")(tarefa.valor)))])]) : _c('span', [_vm._v(_vm._s(_vm._f("real")(tarefa.valor)))])]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-4 text-right",
	          staticStyle: {
	            "height": "46px"
	          }
	        }, [(_vm._.isNull(tarefa.data_solicitacao)) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(tarefa.inicio, "DD/MM/YYYY HH:mm")))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(tarefa.data_solicitacao, "DD/MM/YYYY HH:mm")))])]), _vm._v(" "), _c('div', {
	          class: (_vm._.includes(['SOLICITACOES'], _vm.validacao) ? 'col-lg-1 col-md-2 col-sm-2 col-xs-4' : 'col-lg-2 col-md-2 col-sm-3 col-xs-8') + ' text-right',
	          staticStyle: {
	            "height": "46px",
	            "padding": "2px 0"
	          }
	        }, [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }],
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "title": '<h5>Assumir e Fazer</h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.verificarAtribuicao(tarefa)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1)])
	      }), 0)], 1) : _vm._e()]) : _vm._e()])
	    }), 0) : _vm._e()])
	  })], 2)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticStyle: {
	      "margin-bottom": "30px"
	    }
	  }, [_c('strong', [_vm._v("Selecione o funcionário:")])])
	}]}

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [((_vm.historico_atualizado.length > 0 && _vm.historico_atualizado[0] && _vm.historico_atualizado[0].termino == null && _vm.historico_atualizado[1].observacao != null && _vm.historico_atualizado[1].observacao != '')) ? _c('div', {
	    staticClass: "alert alert-dismissible alert-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.historico_atualizado[1].observacao)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Validação da Entidade    "), _c('a', {
	    attrs: {
	      "href": _vm.urlLaravel + '/docs/manual_cadastro_entidade_dirigentes_usuarios_v1.pdf',
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Manual")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": _vm.boqueia === true
	    }
	  }, [_c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": !_vm.isEditable() || _vm.boqueia === true
	    }
	  }, [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Razão social"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nome')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_nome
	    }
	  }) : _vm._e(), _vm._v("\n                          Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_nome),
	      expression: "entidade.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "ds_nome",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_cnpj')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_cnpj
	    }
	  }) : _vm._e(), _vm._v("\n                          CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    ref: "ds_cnpj",
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens,
	      "disabled": "true"
	    },
	    model: {
	      value: (_vm.entidade.ds_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
	      },
	      expression: "entidade.ds_cnpj"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpjExpeditionTime')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cnpjExpeditionTime"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'dt_data_expedicao_cnpj')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": _vm._f("moment")('Conteúdo anterior: ' + _vm.diferenca.dt_data_expedicao_cnpj, 'L')
	    }
	  }) : _vm._e(), _vm._v("\n                          Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dt_data_expedicao_cnpj),
	      expression: "dt_data_expedicao_cnpj"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast'),
	      expression: "'required|validdate|dateeqpast'"
	    }],
	    ref: "cnpjExpeditionTime",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "cnpjExpeditionTime",
	      "data-vv-as": "Expedição CNPJ",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.dt_data_expedicao_cnpj)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dt_data_expedicao_cnpj = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome fantasia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome fantasia"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nome_fantasia')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_nome_fantasia
	    }
	  }) : _vm._e(), _vm._v("\n                          Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_nome_fantasia),
	      expression: "entidade.ds_nome_fantasia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "ds_nome_fantasia",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome fantasia",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_nome_fantasia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_nome_fantasia", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Natureza jurídica')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "forma_jurídica"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'forma_juridica') && _vm.diferenca.forma_juridica) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.forma_juridica.descricao
	    }
	  }) : _vm._e(), _vm._v("\n                          Natureza jurídica: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaFormasJuridicas,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione uma Natureza Jurídica",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaListaFormaJuridica,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "forma_juridica"
	    },
	    model: {
	      value: (_vm.entidade.forma_juridica),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "forma_juridica", $$v)
	      },
	      expression: "entidade.forma_juridica"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('Natureza jurídica')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Natureza jurídica')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Ramo atividade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Ramo atividade"
	    }
	  }, [(_vm.inclRamo && _vm.naoExisteRamo === false) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_insercao",
	    attrs: {
	      "title": 'Inclusões: ' + _vm.inclRamoTexto
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.exclRamo && _vm.exclRamo.length > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_exclusao"
	  }) : _vm._e(), _vm._v("\n                          Ramos de Atividade: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaRamosAtividade,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione os Ramos de Atividade",
	      "label": "ds_codigo",
	      "track-by": "ds_codigo",
	      "custom-label": _vm.etiquetaListaRamosAtividade,
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "ramos_atividade",
	      "options-limit": 1500
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.ds_codigo))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.entidade.ramos_atividade),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "ramos_atividade", $$v)
	      },
	      expression: "entidade.ramos_atividade"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('Ramo atividade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Ramo atividade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Doc. constituição')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "constitutionDocument"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'documento_constituicao') && _vm.diferenca.documento_constituicao) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.documento_constituicao.ds_tipo
	    }
	  }) : _vm._e(), _vm._v("\n                          Documento de constituição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaDocConstituicao,
	      "multiple": false,
	      "close-on-select": true,
	      "track-by": "id",
	      "label": "ds_tipo",
	      "placeholder": "Selecione um Documento de constituição",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "listaDocConstituicao"
	    },
	    model: {
	      value: (_vm.entidade.documento_constituicao),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "documento_constituicao", $$v)
	      },
	      expression: "entidade.documento_constituicao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Doc. constituição')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Doc. constituição é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6",
	    attrs: {
	      "id": "contato"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_telefone') && _vm.diferenca.contato) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.contato.ds_telefone
	    }
	  }) : _vm._e(), _vm._v("\n                          Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10|max:11'),
	      expression: "'required|min:10|max:11'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "data-vv-as": "Telefone",
	      "type": "text",
	      "masked": false,
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.entidade.contato.ds_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade.contato, "ds_telefone", $$v)
	      },
	      expression: "entidade.contato.ds_telefone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "mobile"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_celular') && _vm.diferenca.contato) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.contato.ds_celular
	    }
	  }) : _vm._e(), _vm._v("\n                          Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('min:10|max:11'),
	      expression: "'min:10|max:11'"
	    }],
	    ref: "mobile",
	    staticClass: "form-control",
	    attrs: {
	      "name": "mobile",
	      "data-vv-as": "Celular",
	      "type": "text",
	      "masked": false,
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.entidade.contato.ds_celular),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade.contato, "ds_celular", $$v)
	      },
	      expression: "entidade.contato.ds_celular"
	    }
	  }), _vm._v(" "), (_vm.errors.first('mobile')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('mobile')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_email')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_email
	    }
	  }) : _vm._e(), _vm._v("\n                          E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_email),
	      expression: "entidade.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "ds_email",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Email",
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo E-mail é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [(_vm._.hasIn(_vm.mudancas, 'ds_website')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning indicador_alteracao",
	    attrs: {
	      "title": 'Conteúdo anterior: ' + _vm.diferenca.ds_website
	    }
	  }) : _vm._e(), _vm._v("\n                          Site:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_website),
	      expression: "entidade.ds_website"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:255'),
	      expression: "'max:255'"
	    }],
	    ref: "ds_website",
	    staticClass: "form-control",
	    attrs: {
	      "name": "website",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_website)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_website", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "possuiCebas"
	    }
	  }, [_vm._v("Possui CEBAS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiCebas),
	      expression: "possuiCebas"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "possuiCebas",
	      "disabled": true
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiCebas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "possuiCmas"
	    }
	  }, [_vm._v("Possui CMAS/CAS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiCmas),
	      expression: "possuiCmas"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "possuiCmas",
	      "disabled": true
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiCmas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.entidade.endereco,
	      "mudaEndereco": _vm.mudancas,
	      "analise": _vm.analise,
	      "revisao": _vm.revisao,
	      "diferenca": _vm.diferenca
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.entidade.dirigentes,
	      "entidadeParceira": _vm.entidade,
	      "componenteSuperior": _vm.componenteSuperior,
	      "mudaDirigente": _vm.mudancas,
	      "analise": _vm.analise,
	      "revisao": _vm.revisao,
	      "diferenca": _vm.diferenca,
	      "name": "dirigentes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('usuarios', {
	    attrs: {
	      "entUsuarios": _vm.entidade.usuarios,
	      "mudaUsuario": _vm.mudancas,
	      "componenteSuperior": _vm.componenteSuperior,
	      "analise": _vm.analise,
	      "revisao": _vm.revisao,
	      "diferenca": _vm.diferenca
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.entidade.documentos,
	      "documentTypes": _vm.entidade.tipos_documento,
	      "disable": '',
	      "local-uso": 'CADASTRO_ENTIDADE',
	      "mudaDocumento": _vm.mudancas,
	      "analise": _vm.analise,
	      "revisao": _vm.revisao,
	      "diferenca": _vm.diferenca,
	      "salvouOK": _vm.salvouOK
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('historico-entidade', {
	    attrs: {
	      "entHistorico": _vm.historico
	    },
	    on: {
	      "historico_itens": function($event) {
	        _vm.historico_atualizado = $event
	      }
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-12"
	  }, [_c('legend', [_vm._v("Análise da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required full",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "approvalResult"
	    }
	  }, [_vm._v("Decisões:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.resultadoAprovacao),
	      expression: "entidade.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado",
	      "id": "resultado",
	      "value": "Aprovar"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.entidade.resultadoAprovacao, "Aprovar")
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.entidade, "resultadoAprovacao", "Aprovar")
	      }, _vm.limpaObs]
	    }
	  }), _vm._v(" Aprovar\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.resultadoAprovacao),
	      expression: "entidade.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado",
	      "value": "Revisar"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.entidade.resultadoAprovacao, "Revisar")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.entidade, "resultadoAprovacao", "Revisar")
	      }
	    }
	  }), _vm._v(" Devolver para ajustes\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.resultadoAprovacao),
	      expression: "entidade.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado",
	      "value": "Cancelar"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.entidade.resultadoAprovacao, "Cancelar")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.entidade, "resultadoAprovacao", "Cancelar")
	      }
	    }
	  }), _vm._v(" Cancelar Alteração\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.entidade.resultadoAprovacao === 'Cancelar' || _vm.entidade.resultadoAprovacao === 'Revisar') ? _c('div', {
	    staticClass: "form-group required full required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa"
	    }
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.observacao),
	      expression: "entidade.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justificativa",
	      "id": "justificativa"
	    },
	    domProps: {
	      "value": (_vm.entidade.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])])])])]), _vm._v(" "), (_vm.boqueia === false) ? _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "disabled": !_vm.isEditable()
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.conclui(_vm.frmCommonRegister)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva(_vm.frmCommonRegister)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa fa-info"
	  }), _vm._v("   Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 box-body"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('span', {
	    staticClass: "fa fa-warning indicador_alteracao"
	  }), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("  Dados alterados pela entidade")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('span', {
	    staticClass: "fa fa-warning indicador_insercao"
	  }), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("  Dados novos inseridos pela entidade")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('span', {
	    staticClass: "fa fa-warning indicador_exclusao"
	  }), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("  Dados excluídos pela entidade")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes/Designados:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Usuários do sistema:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos anexos:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico:")])])])
	}]}

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Validação de Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": !_vm.isEditable()
	    }
	  }, [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Razão social"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.companyName),
	      expression: "parceiro.strategicPartner.companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.parceiro.strategicPartner.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.strategicPartner, "companyName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.parceiro.strategicPartner.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro.strategicPartner, "cnpj", $$v)
	      },
	      expression: "parceiro.strategicPartner.cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpjExpeditionTime')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cnpjExpeditionTime"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "cnpjExpeditionTime",
	    attrs: {
	      "name": "cnpjExpeditionTime",
	      "input-class": "form-control",
	      "language": _vm.$datePickerPtBR,
	      "format": "dd/MM/yyyy",
	      "placeholder": _vm.dataPlaceholder
	    },
	    model: {
	      value: (_vm.parceiro.strategicPartner.cnpjExpeditionTime),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro.strategicPartner, "cnpjExpeditionTime", $$v)
	      },
	      expression: "parceiro.strategicPartner.cnpjExpeditionTime"
	    }
	  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome fantasia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome fantasia"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.businessName),
	      expression: "parceiro.strategicPartner.businessName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Nome fantasia",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome fantasia",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.parceiro.strategicPartner.businessName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.strategicPartner, "businessName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Natureza jurídica')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Natureza jurídica"
	    }
	  }, [_vm._v("Natureza jurídica:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.legalType),
	      expression: "parceiro.strategicPartner.legalType"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Natureza jurídica",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Natureza jurídica"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.parceiro.strategicPartner, "legalType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ASSOCIAÇÃO"
	    }
	  }, [_vm._v("Associação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "COOPERATIVA"
	    }
	  }, [_vm._v("Cooperativa")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "EMPRESA_PUBLICA"
	    }
	  }, [_vm._v("Empresa pública")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "FUNDACAO"
	    }
	  }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ORGAO_PUBLICO_EXECUTIVO_ESTADUAL"
	    }
	  }, [_vm._v("Orgão público executivo estadual")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ORGAO_PUBLICO_EXECUTIVO_MUNICIPAL"
	    }
	  }, [_vm._v("Orgão público executivo municipal")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SEM_FINS_LUCRATIVOS"
	    }
	  }, [_vm._v("Sem fins lucrativos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SERVICO_SOCIAL_AUTONOMO"
	    }
	  }, [_vm._v("Serviço social autônomo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOCIEDADE_LTDA"
	    }
	  }, [_vm._v("Sociedade ltda")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOCIEDADE_POR_ACOES"
	    }
	  }, [_vm._v("Sociedade por Ações")])]), _vm._v(" "), (_vm.errors.first('Natureza jurídica')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Natureza jurídica é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Ramo atividade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Ramo atividade"
	    }
	  }, [_vm._v("Ramo atividade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.activity),
	      expression: "parceiro.strategicPartner.activity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Ramo atividade",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Ramo atividade"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.parceiro.strategicPartner, "activity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.ramoAtividade), function(ramoAtividade) {
	    return _c('option', {
	      attrs: {
	        "label": ramoAtividade.code + ' - ' + ramoAtividade.description
	      },
	      domProps: {
	        "value": ramoAtividade
	      }
	    }, [_vm._v(_vm._s(ramoAtividade.code + ' - ' + ramoAtividade.description))])
	  }), 0), _vm._v(" "), (_vm.errors.first('Ramo atividade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Ramo atividade é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Doc. constituição')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "constitutionDocument"
	    }
	  }, [_vm._v("Doc. constituição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.constitutionDocument),
	      expression: "parceiro.strategicPartner.constitutionDocument"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Doc. constituição",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Doc. constituição"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.parceiro.strategicPartner, "constitutionDocument", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ATA_CONSTITUICAO"
	    }
	  }, [_vm._v("Ata constituição")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CONTRATO_SOCIAL"
	    }
	  }, [_vm._v("Contrato social")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ESTATUTO"
	    }
	  }, [_vm._v("Estatuto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "LEI_ORGANICA_MUNICIPAL"
	    }
	  }, [_vm._v("Lei orgânica municipal")])]), _vm._v(" "), (_vm.errors.first('Doc. constituição')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Doc. constituição é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6",
	    attrs: {
	      "id": "contato"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.phone),
	      expression: "parceiro.strategicPartner.phone"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) ####-#####'),
	      expression: "'(##) ####-#####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1'),
	      expression: "'required|min:1'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "Telefone",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.parceiro.strategicPartner.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.strategicPartner, "phone", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Telefone é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "mobile"
	    }
	  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.mobile),
	      expression: "parceiro.strategicPartner.mobile"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) #####-#####'),
	      expression: "'(##) #####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "mobile",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.parceiro.strategicPartner.mobile)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.strategicPartner, "mobile", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.email),
	      expression: "parceiro.strategicPartner.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Email",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Email",
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.parceiro.strategicPartner.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.strategicPartner, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo E-mail é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.strategicPartner.website),
	      expression: "parceiro.strategicPartner.website"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:255'),
	      expression: "'max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "website",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.parceiro.strategicPartner.website)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro.strategicPartner, "website", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(1), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.endereco
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.dirigentes,
	      "name": "dirigentes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('usuarios', {
	    attrs: {
	      "entUsuarios": _vm.parceiro.strategicPartner.usuarios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.parceiro.strategicPartner.documents,
	      "documentTypes": _vm.parceiro.strategicPartner.documentTypes
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(5), _vm._v(" "), _c('projetos', {
	    attrs: {
	      "ParcProjetos": _vm.projetos
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(6), _vm._v(" "), _c('historicoParcEstrategico', {
	    attrs: {
	      "parcHistorico": _vm.historico
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Validação:")]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "approvalResult"
	    }
	  }, [_vm._v("Aprovar cadastro:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approvalResult),
	      expression: "analise.approvalResult"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "approvalResult",
	      "value": "APPROVED",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.approvalResult, "APPROVED")
	    },
	    on: {
	      "click": function($event) {
	        _vm.showJustify = false
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "approvalResult", "APPROVED")
	      }
	    }
	  }), _vm._v(" Sim\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approvalResult),
	      expression: "analise.approvalResult"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "approvalResult",
	      "value": "REJECTED",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.approvalResult, "REJECTED")
	    },
	    on: {
	      "click": function($event) {
	        _vm.showJustify = true
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "approvalResult", "REJECTED")
	      }
	    }
	  }), _vm._v(" Não\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('resultado')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultado')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.analise.approvalResult === 'REJECTED') ? _c('div', {
	    staticClass: "form-group required full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justify"
	    }
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.justify),
	      expression: "analise.justify"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justify",
	      "id": "justify"
	    },
	    domProps: {
	      "value": (_vm.analise.justify)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "justify", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justify')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justify')))]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "uib-tooltip": "Conclui o cadastro",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.conclui(_vm.frmCommonRegister)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "uib-tooltip": "Apenas salva o cadastro",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.salva(_vm.frmCommonRegister)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          path: '/validacao/validacao-parceiro-estrategico/lista'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Parceiro Estratégico")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Usuários da entidade:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projetos:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico:")])])])
	}]}

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Tipo de Documentos")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Tipo de Documentos',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-date ng-valid ng-valid-max"
	  }, [_c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "disabled": !this.$root.authorize('tipo-documento-novo'),
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-documentos-edita'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Tipo de Documento ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('br'), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.bordered,
	      "items": _vm.items,
	      "hover": _vm.hover,
	      "fields": _vm.fields,
	      "filter": _vm.filter,
	      "current-page": _vm.currentPage,
	      "per-page": _vm.perPage,
	      "sort-by": _vm.sortBy,
	      "sort-desc": _vm.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        _vm.sortBy = $event
	      },
	      "update:sort-by": function($event) {
	        _vm.sortBy = $event
	      },
	      "update:sortDesc": function($event) {
	        _vm.sortDesc = $event
	      },
	      "update:sort-desc": function($event) {
	        _vm.sortDesc = $event
	      },
	      "filtered": _vm.onFiltered
	    },
	    scopedSlots: _vm._u([{
	      key: "dt_data_inclusao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, 'L')))]
	      }
	    }, {
	      key: "dt_data_vigencia",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, 'L')))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-documentos-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Editar")])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Lista de Tipo de Documentos")])])
	}]}

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-show": "$ctrl.isNewAvaiable()"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.formEditavel) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo curso")]) : _vm._e()])]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.formEditavel) ? _c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.exclui(row); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>APAGAR</b> o curso ' + row.item.ds_titulo + ' ?'
	            }),
	            expression: "{ok: retorno => exclui(row), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> o curso ' + row.item.ds_titulo + ' ?'}"
	          }],
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('título do curso')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "título do curso"
	    }
	  }, [_vm._v("Título do curso:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.ds_titulo),
	      expression: "curso.ds_titulo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "título do curso",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.curso.ds_titulo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "ds_titulo", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('título do curso')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('título do curso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade de educadores')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantidade de educadores"
	    }
	  }, [_vm._v(" Quantidade de educadores: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.nr_qt_educadores),
	      expression: "curso.nr_qt_educadores"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "quantidade de educadores",
	      "id": "quantidade de educadores",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.curso.nr_qt_educadores)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "nr_qt_educadores", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade de educadores')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de educadores')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('carga horaria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "carga horaria"
	    }
	  }, [_vm._v("Carga horária total por turma:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    attrs: {
	      "name": "career.workload.null"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.nr_carga_horaria),
	      expression: "curso.nr_carga_horaria"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "carga horaria",
	      "id": "carga horaria",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.curso.nr_carga_horaria)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "nr_carga_horaria", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("Horas")])]), _vm._v(" "), (_vm.errors.first('carga horaria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('carga horaria')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade de turmas')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantidade de turmas"
	    }
	  }, [_vm._v("Quantidade de turmas:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.nr_qt_turmas),
	      expression: "curso.nr_qt_turmas"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "quantidade de turmas",
	      "id": "quantidade de turmas",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.curso.nr_qt_turmas)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "nr_qt_turmas", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade de turmas')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de turmas')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade de alunos por turma')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantidade de alunos por turma"
	    }
	  }, [_vm._v("Quantidade de alunos por turma:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-xs-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.nr_qt_alunos_turma),
	      expression: "curso.nr_qt_alunos_turma"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "quantidade de alunos por turma",
	      "id": "quantidade de alunos por turma",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.curso.nr_qt_alunos_turma)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "nr_qt_alunos_turma", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade de alunos por turma')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de alunos por turma')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('público-alvo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "título do curso"
	    }
	  }, [_vm._v("Público-alvo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.ds_publico_alvo),
	      expression: "curso.ds_publico_alvo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "público-alvo",
	      "id": "público-alvo",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.curso.ds_publico_alvo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "ds_publico_alvo", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('público-alvo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('conteúdo programático mínimo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "conteúdo programático mínimo"
	    }
	  }, [_vm._v("Conteúdo programático mínimo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.ds_conteudo),
	      expression: "curso.ds_conteudo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "conteúdo programático mínimo",
	      "id": "conteúdo programático mínimo",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.curso.ds_conteudo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "ds_conteudo", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('conteúdo programático mínimo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('conteúdo programático mínimo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('perfil dos profissionais a serem contratados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "perfil dos profissionais a serem contratados"
	    }
	  }, [_vm._v("Perfil dos profissionais a serem contratados:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.ds_perfil_profissional),
	      expression: "curso.ds_perfil_profissional"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "perfil dos profissionais a serem contratados",
	      "id": "perfil dos profissionais a serem contratados",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.curso.ds_perfil_profissional)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "ds_perfil_profissional", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('perfil dos profissionais a serem contratados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('perfil dos profissionais a serem contratados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('especificação dos serviços')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "especificação dos serviços"
	    }
	  }, [_vm._v("Especificação dos serviços:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.ds_especificacao_servico),
	      expression: "curso.ds_especificacao_servico"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "especificação dos serviços",
	      "id": "especificação dos serviços",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.curso.ds_especificacao_servico)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.curso, "ds_especificacao_servico", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('especificação dos serviços')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('especificação dos serviços')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('outroCurso')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "outroCurso"
	    }
	  }, [_vm._v("Os alunos deste curso estarão inscritos em outros cursos deste projeto?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.curso.outroCurso),
	      expression: "curso.outroCurso"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "outroCurso"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.curso, "outroCurso", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('outroCurso')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('outroCurso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n        Plano de Trabalho\n        "), (!_vm.loading.tela) ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.closewindow($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e()])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "planoTrabalho"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaDadosCadastrais"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Dados Cadastrais")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s((_vm._.has(_vm.proposta, 'ds_codigo_projeto_erp') && !_vm._.isNull(_vm.proposta.ds_codigo_projeto_erp) ? _vm.proposta.ds_codigo_projeto_erp + ' - ' : ' ') + _vm.proposta.ds_nome))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalProjeto)))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalCtrp)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalParc)))])])])]), _vm._v(" "), (_vm.loading.cidade) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando municípios ...")]) : _c('span', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
	    return m.ds_municipio + '/' + m.ds_uf
	  })), function(municipio) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(municipio[0].ds_municipio))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(municipio[0].ds_uf))])])
	  }), 0)]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Número de Participantes Diretos do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar w10"
	  }, [_vm._v(_vm._s(_vm._.sumBy(_vm.proposta.publicos_alvo, function(p) {
	    return parseInt(p.nr_participantes_diretos)
	  })) + " pessoas")])])])])])])]), _vm._v(" "), (_vm.loading.entidade) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_vm._m(3)]) : _c('span', [(_vm._.has(_vm.proposta, 'entidade')) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Convenente")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), (_vm.proposta.entidade.contato) ? _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contato")]), _vm._v(" "), (_vm.proposta.entidade && !_vm._.isEmpty(_vm.proposta.entidade.contato)) ? _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('span', {
	    attrs: {
	      "proposta.entidade.contato.ds_telefone": ""
	    }
	  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_telefone)))]), _vm._v("    "), _c('span', {
	    attrs: {
	      "proposta.entidade.contato.ds_celular": ""
	    }
	  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_celular)))])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('thead', [_c('tr', [(_vm.proposta.entidade.endereco) ? _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Endereço" + _vm._s((_vm.proposta.entidade.endereco.length > 1 ? 's' : '')))]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Complemento")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("CEP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_rua))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_numero))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_bairro))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_complemento))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_cidade))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(endereco.ds_estado))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(_vm._f("cep")(endereco.ds_cep)))])])
	  }), 0)])])]) : _vm._e()]), _vm._v(" "), (_vm.loading.entidade) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_vm._m(4)]) : _c('span', [_c('div', {
	    staticClass: "box-body m0"
	  }, [_c('div', {
	    staticClass: "w100 m0"
	  }, [_vm._v("\n                  Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)\n                ")]), _vm._v(" "), _vm._l((_vm.dirigentes), function(dirigente) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered lista w100 m0"
	    }, [(dirigente.cargo) ? _c('tbody', [_c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w30"
	    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cargo")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Final do Mandato")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_rg) + " - " + _vm._s(dirigente.ds_orgao_emissor) + "/" + _vm._s(dirigente.ds_uf))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._.has(dirigente, 'ds_estado_civil') ? _vm._.get(_vm.estadoCivil, dirigente.ds_estado_civil) : ''))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Profissão")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_profissao))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Telefone")]), _vm._v(" "), (dirigente.contato) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("telefone")(dirigente.contato.ds_telefone)))]) : _vm._e()])]) : _vm._e()])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objeto")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de Execução / Previsão de Início e Fim da Execução do Objeto")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("moment")(this.dataInicioExecucao, 'MM/YYYY')) + "  a  " + _vm._s(this.dataFimExecucao) + "  (" + _vm._s(_vm.proposta.nr_periodos) + " meses)\n                    ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaMetas"
	    }
	  }, [(_vm.loading.tela) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_vm._m(5)]) : _c('span', [(_vm.proposta.projetoAprovado) ? _c('div', {
	    staticClass: "nao_imprimir"
	  }, [(_vm.mostrarRef('objetivo_especifico')) ? _c('div', {
	    ref: "objetivos"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('objetivo-especifico', {
	    attrs: {
	      "editavel": false,
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objetivos = $event
	      }
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('metas')) ? _c('div', {
	    ref: "metas"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsMetas": _vm.proposta.metas,
	      "propsProposta": _vm.proposta,
	      "atvSemMetas": _vm.atvSemMetas
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.metas = $event
	      }
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('atividades')) ? _c('div', {
	    ref: "atividades"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.nr_periodos,
	      "propsMetas": _vm.proposta.metas,
	      "propsAtividades": _vm.proposta.atividades,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "atividadeAdicionada": function($event) {
	        _vm.proposta.atividades = $event
	      }
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    class: _vm.proposta.projetoAprovado ? 'imprimir' : ''
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos, Metas e Atividades")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed m0 obj_met_atv"
	  }, [_c('tbody', [_vm._l((_vm.proposta.objetivos), function(objetivo, idxObjetivo) {
	    return [_c('tr', {
	      staticClass: "objetivo"
	    }, [(objetivo.ds_descricao) ? _c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('span', {
	      staticClass: "tag"
	    }, [_vm._v("objetivo")]), _vm._v(_vm._s(objetivo.ds_descricao))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.proposta.metas), function(meta, idxMeta) {
	      return (_vm._.find(meta.objetivos, function(o) {
	        return o.ds_descricao === objetivo.ds_descricao
	      })) ? [_c('tr', {
	        staticClass: "meta"
	      }, [(meta.ds_descricao) ? _c('td', [_c('span', {
	        staticClass: "tag vertical"
	      }, [_vm._v("meta")]), _vm._v(_vm._s(meta.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
	        staticClass: "ressaltar"
	      }, [_vm._v(_vm._s(meta.nr_quantidade) + " " + _vm._s(meta.ds_unidade_medida))]), _vm._v(" e indicar a execução como "), _c('span', {
	        staticClass: "ressaltar"
	      }, [_vm._v(_vm._s(meta.ds_indicadores_execucao))])])]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade, idxAtividade) {
	        return (_vm._.find(atividade.metas, function(m) {
	          return m.ds_descricao === meta.ds_descricao
	        })) ? [_c('tr', {
	          staticClass: "atividade"
	        }, [(atividade.descricao) ? _c('td', [_c('span', {
	          staticClass: "tag vertical"
	        }, [_vm._v("atividade")]), _vm._v(_vm._s(atividade.descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Executar\n                                  "), (atividade.inicio === atividade.termino) ? _c('span', [_vm._v(" no " + _vm._s(atividade.inicio) + "º ")]) : _c('span', [_vm._v(" do " + _vm._s(atividade.inicio) + "º  ao  " + _vm._s(atividade.termino) + "º ")]), _vm._v("\n                                  mês e comprovar com "), _c('span', {
	          staticClass: "ressaltar"
	        }, [_vm._v(_vm._s(atividade.ds_documento_comprobatorio))])])])] : _vm._e()
	      }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.atividades, 'metas', meta.ds_descricao)) ? [_c('tr', {
	        staticClass: "atividade atencao"
	      }, [_c('td', {
	        attrs: {
	          "colspan": "2"
	        }
	      }, [_vm._v("* Não há atividades para a Meta acima")])])] : _vm._e()] : _vm._e()
	    }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.metas, 'objetivos', objetivo.ds_descricao)) ? [_c('tr', {
	      staticClass: "meta atencao"
	    }, [_c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("* Não há metas para o Objetivo acima")])])] : _vm._e()]
	  })], 2)])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaCronogramaAtividades"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cronograma de Execução das Atividades")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho w40 b1 b4"
	  }, [_vm._v("Atividade")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho direita w10 b1"
	  }, [_vm._v("Valor total")]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], (_vm.proposta.nr_periodos || 0), [_vm.step = 1])), function(mes) {
	    return _c('th', {
	      staticClass: "centralizado b1 b2 b4",
	      style: ('zoom:' + _vm.ganttZoom)
	    }, [_vm._v(_vm._s(mes + 1))])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm._.get(_vm.proposta, 'atividades', [])), function(atividade) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar b3 b4"
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "direita b3"
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm.somarTotalAtividade(atividade))))]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(m) {
	      return _c('td', {
	        staticClass: "centralizado b2 b3 b4",
	        style: ((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1)) ? 'background: gray !important' : '')
	      }, [((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1))) ? _c('span', {
	        style: ('zoom:' + _vm.ganttZoom + '; color: gray')
	      }, [_c('i', {
	        staticClass: "fa fa-circle"
	      })]) : _c('span', [_vm._v(" ")])])
	    })], 2)
	  }), 0)]), _vm._v(" "), (_vm.periodoMesAno.length > 0) ? _c('div', [_vm._v("\n                  Referência: 1º mês do projeto em "), _c('span', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._.head(_vm.periodoMesAno)['mes'] + '/' + _vm._.head(_vm.periodoMesAno)['ano']))]), _vm._v("\n                  e " + _vm._s(_vm.periodoMesAno.length) + "º (último) mês do projeto em "), _c('span', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._.last(_vm.periodoMesAno)['mes'] + '/' + _vm._.last(_vm.periodoMesAno)['ano']))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm._.get(_vm.proposta, 'ds_operacao', ''))
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaRecursosFinanceiros"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Plano de Aplicação dos Recursos Financeiros")]), _vm._v(" "), _c('table', {
	    staticClass: "w100"
	  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_vm._l((_vm.proposta.atividades), function(atividade) {
	    return [_c('tr', {
	      staticStyle: {
	        "font-weight": "bold"
	      }
	    }, [_c('td', {
	      staticClass: "esquerda nome_atividade bl1 bl3 bl4"
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado bl1 bl3"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado bl1 bl3"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
	      staticClass: "direita bl1 bl2 bl3",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm.somarTotalAtividade(atividade))))])]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item) {
	      return _c('tr', [
	        [_c('td', {
	          staticClass: "bl4 b3"
	        }, [_c('span', {}, [(('' + item.origem).substr(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substr(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substr(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel).substr(0, 1) === '1') ? _c('span', {
	          staticClass: "adiantavel"
	        }, [_vm._v(" (Adiantável)")]) : _vm._e()]), _vm._v(" "), _c('span', {
	          staticClass: "esmaecido"
	        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('div', {
	          staticClass: "observacao esquerda"
	        }, [_vm._v(_vm._s(item.observacao == 'undefined' ? '-' : item.observacao))])]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3"
	        }, [_vm._v(_vm._s(item.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3"
	        }, [_vm._v(_vm._s(item.nr_periodo_final))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3"
	        }, [_vm._v(_vm._s(Math.round(item.quantidade)))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3"
	        }, [_vm._v(_vm._s(_vm._f("real")((_vm._.includes(item.id, 'novo') ? _vm._.toNumber(_vm._.get(item, 'valorAlteracao', 0)) : (item.valor_total + _vm._.toNumber(_vm._.get(item, 'valorAlteracao', 0))).toFixed(2)) / item.quantidade)))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3 bl2"
	        }, [_vm._v(_vm._s(_vm._f("real")((_vm._.includes(item.id, 'novo') ? _vm._.toNumber(_vm._.get(item, 'valorAlteracao', 0)) : (item.valor_total + _vm._.toNumber(_vm._.get(item, 'valorAlteracao', 0))).toFixed(2)))))])]
	      ], 2)
	    })]
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaDesembolso"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "zoom": "1"
	    }
	  }, [_vm._v("Cronograma de Desembolso (Cronograma Físico-financeiro)")]), _vm._v(" "), _vm._l((_vm._.keys(_vm._.groupBy(_vm.periodoMesAno, 'ano'))), function(ano) {
	    return [_c('div', {
	      staticClass: "anoDesembolso"
	    }, [_vm._v(_vm._s(ano))]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade) {
	      return [_c('table', {
	        staticClass: "w100 juntos"
	      }, [_c('caption', [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
	        staticClass: "b3",
	        attrs: {
	          "rowspan": "2"
	        }
	      }, [_vm._v("Item")]), _vm._v(" "), _vm._l((12), function(c) {
	        return _c('th', {
	          staticClass: "b3",
	          attrs: {
	            "colspan": "2"
	          }
	        }, [_vm._v(_vm._s(_vm.meses[c - 1]))])
	      })], 2), _vm._v(" "), _c('tr', [_vm._l((12), function(d) {
	        return [_c('th', {
	          staticClass: "b3"
	        }, [_vm._v("Qtde")]), _c('th', {
	          staticClass: "b3"
	        }, [_vm._v("Valor")])]
	      })], 2)]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	        staticClass: "b3"
	      }, [_vm._v("Total da atividade")]), _vm._v(" "), _vm._l((12), function(mesAtv) {
	        return [_c('td', {
	          staticClass: "b3"
	        }, [_vm._v(_vm._s(_vm.desembolsoMesAno(atividade, ano, mesAtv, 'quantidade')))]), _vm._v(" "), _c('td', {
	          staticClass: "b3"
	        }, [_vm._v(_vm._s(_vm._f("decimal2")(_vm.desembolsoMesAno(atividade, ano, mesAtv, 'valor'))))])]
	      })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((atividade.itens_orcamentos), function(item) {
	        return [_c('tr', [_c('td', {
	          staticClass: "b3"
	        }, [_vm._v("(" + _vm._s(item.item.ds_type) + ") " + _vm._s(item.item.ds_description))]), _vm._v(" "), _vm._l((12), function(mesIte) {
	          return [_c('td', {
	            staticClass: "b3"
	          }, [_vm._v(_vm._s(_vm.desembolsoMesAno(item, ano, mesIte, 'quantidade')))]), _vm._v(" "), _c('td', {
	            staticClass: "b3 direita"
	          }, [_vm._v(_vm._s(_vm._f("decimal2")(_vm.desembolsoMesAno(item, ano, mesIte, 'valor'))))])]
	        })], 2)]
	      })], 2)])]
	    })]
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaParcelasAdiantamento"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Parcelas de Adiantamento")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho centralizado b1 b4",
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '10%' : '20%'))
	  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado b1",
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '30%' : '40%'))
	  }, [_vm._v("Origem Recurso")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('th', {
	    staticClass: "cabecalho centralizado b1",
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('th', {
	    staticClass: "cabecalho centralizado b1",
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado b1 b2",
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '20%' : '40%'))
	  }, [_vm._v("Valor Adiantável")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parcelasAdiantamentoExibicao), function(adiantamento) {
	    return _c('tr', {
	      key: 'adiantamento-' + adiantamento.parcela + '-' + adiantamento.origem
	    }, [_c('td', {
	      staticClass: "centralizado b3 b4"
	    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado b3"
	    }, [_vm._v(_vm._s(_vm.rotuloOrigemParcela(adiantamento.origem)))]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "direita b3"
	    }, [(!_vm._.isNil(adiantamento.valor_fbb)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_fbb)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "direita b3"
	    }, [(!_vm._.isNil(adiantamento.valor_parc)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_parc)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "direita ressaltar b3 b2"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor)))])])
	  }), _vm._v(" "), (_vm.parcelasAdiantamentoExibicao.length > 0) ? _c('tr', [_c('td', {
	    staticClass: "b3 b4",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Total adiantável")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "direita ressaltar b3"
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoFundacao)) + "\n                      "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoFundacao / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "direita ressaltar b3"
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoParceiro)) + "\n                      "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoParceiro / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "direita ressaltar b3 b2"
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoGeral)) + "\n                      "), ((_vm._.toNumber(_vm.proposta.totalFBB || 0) + _vm._.toNumber(_vm.proposta.totalParc || 0)) > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoGeral / (_vm._.toNumber(_vm.proposta.totalFBB || 0) + _vm._.toNumber(_vm.proposta.totalParc || 0))))) + ")")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.parcelasAdiantamentoExibicao.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "centralizado b3 b4 b2",
	    attrs: {
	      "colspan": "100%"
	    }
	  }, [_vm._v("Nenhuma parcela de adiantamento cadastrada.")])]) : _vm._e()], 2)])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "w100 imprimir"
	  }, [_c('tr', [_c('td', [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "direita"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "40px !important"
	    }
	  }, [_vm._v("Plano de Trabalho")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Fundação")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Proponente")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Terceiros")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando entidade ...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando representante legal ...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando Objetivos, Metas e Atividades ...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Atividade / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Valor Total")])])])
	}]}

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Validação do Relatório de Execução")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Aprovação de Parceiro Estratégico',
	        href: '#'
	      }, {
	        text: 'Aprovação',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "validaProp"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', [_vm._v("Aprovação")]), _vm._v(" "), _c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroPre"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'aprovacao'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'aprovacao'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPrimeiraAprov))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', [_vm._v("Para Conhecimento")]), _vm._v(" "), _c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroAceite"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'conhecimento'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'conhecimento'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesSegundaAprov))])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.descricaoFase))]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative"
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative",
	      "margin-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('div', {
	    staticClass: "mailbox-controls"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.favorite = !_vm.filtro.favorite
	      }
	    },
	    model: {
	      value: (_vm.filtro.favorite),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "favorite", $$v)
	      },
	      expression: "filtro.favorite"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
	      }
	    },
	    model: {
	      value: (_vm.filtro.userId),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "userId", $$v)
	      },
	      expression: "filtro.userId"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSearch
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  })]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "favorite",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onFavorite(row.item)
	            }
	          }
	        })]
	      }
	    }, {
	      key: "reportSeq",
	      fn: function(row) {
	        return [_vm._v("\n                    Período - " + _vm._s(row.item.reportSeq) + "\n                  ")]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "userName",
	      fn: function(row) {
	        return [(row.value) ? _c('span', {
	          staticStyle: {
	            "font-weight": "bold"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('div', {
	          staticClass: "btn-group"
	        }, [_c('button', {
	          staticClass: "btn btn-default",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ellipsis-h"
	        })]), _vm._v("\n                        " + _vm._s(row) + "\n                        "), _c('ul', {
	          staticClass: "dropdown-menu dropdown-menu-right",
	          attrs: {
	            "role": "menu",
	            "aria-labelledby": "new-register"
	          }
	        }, [_c('li', [_c('a', {
	          attrs: {
	            "href": "#"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ver mais")])]), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssignAndDo(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onUnassign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user-times",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', {
	          staticClass: "divider",
	          attrs: {
	            "role": "separator"
	          }
	        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: '',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-play-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)]), _vm._v(" "), (_vm.faseAtual === 'aprovacao') ? _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.faseAtual === 'aprovacao' ? 'Relatório de Execução - Pendências' : 'Error'))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative",
	      "margin-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('div', {
	    staticClass: "mailbox-controls"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.favorite = !_vm.filtro.favorite
	      }
	    },
	    model: {
	      value: (_vm.filtro.favorite),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "favorite", $$v)
	      },
	      expression: "filtro.favorite"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
	      }
	    },
	    model: {
	      value: (_vm.filtro.userId),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "userId", $$v)
	      },
	      expression: "filtro.userId"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSearch
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  })]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table2.bordered,
	      "items": _vm.table2.items,
	      "fields": _vm.table2.fields,
	      "filter": _vm.table2.filter,
	      "current-page": _vm.table2.currentPage,
	      "per-page": _vm.table2.perPage,
	      "sort-by": _vm.table2.sortBy,
	      "sort-desc": _vm.table2.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFilteredRejeitados,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table2, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table2, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table2, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table2, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "favorite",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onFavorite(row.item)
	            }
	          }
	        })]
	      }
	    }, {
	      key: "reportSeq",
	      fn: function(row) {
	        return [_vm._v("\n                    Período - " + _vm._s(row.item.reportSeq) + "\n                  ")]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "userName",
	      fn: function(row) {
	        return [(row.value) ? _c('span', {
	          staticStyle: {
	            "font-weight": "bold"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('div', {
	          staticClass: "btn-group"
	        }, [_c('button', {
	          staticClass: "btn btn-default",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ellipsis-h"
	        })]), _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu dropdown-menu-right",
	          attrs: {
	            "role": "menu",
	            "aria-labelledby": "new-register"
	          }
	        }, [_c('li', [_c('a', {
	          attrs: {
	            "href": "#"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ver mais")])]), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssignAndDo(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onUnassign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user-times",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', {
	          staticClass: "divider",
	          attrs: {
	            "role": "separator"
	          }
	        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: '',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-play-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
	      }
	    }], null, false, 2752734201)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table2.totalRows,
	      "per-page": _vm.table2.perPage
	    },
	    model: {
	      value: (_vm.table2.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table2, "currentPage", $$v)
	      },
	      expression: "table2.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)]) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  })])
	}]}

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Movimento Diário'
	    }
	  }), _vm._v(" "), _c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', {
	    staticClass: "col-md-7"
	  }, [_vm._v("Movimento Diário")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "col-md-8 pull-right"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    ref: "caixaPesquisa",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisar em todas as pastas...",
	      "title": '<h5>Digite uma palavra e pressione Enter</h5>'
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.pesquisar()
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.pesquisa.length > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "input-group-btn",
	    attrs: {
	      "title": '<h5>Limpar essa pesquisa</h5>'
	    }
	  }, [_c('button', {
	    staticClass: "btn",
	    staticStyle: {
	      "background": "white",
	      "border-color": "#d2d6de",
	      "border-width": "1px 0px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.limparPesquisa()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  })])]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.pesquisa,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.pesquisar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content ged"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-4",
	    attrs: {
	      "id": "pastas"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pastas),
	      expression: "loading.pastas"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('tree', {
	    ref: "tree",
	    attrs: {
	      "data": _vm.arvore,
	      "options": _vm.opts,
	      "filter": _vm.filter
	    },
	    on: {
	      "node:selected": _vm.selecionaPasta
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var node = ref.node;
	
	        return _c('div', {
	          staticClass: "node-container"
	        }, [_c('div', {
	          staticClass: "node-text"
	        }, [_vm._v(_vm._s(node.text) + "\n                          "), _c('span', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (_vm._.isEmpty(_vm._.find(_vm.usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))),
	            expression: "_.isEmpty(_.find(usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))"
	          }],
	          staticClass: "edicao"
	        }, [(node.data.renomear) ? _c('a', {
	          attrs: {
	            "href": "#"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.renomearPasta(node)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil"
	        })]) : _vm._e(), _vm._v(" "), (node.data.excluir) ? _c('a', {
	          attrs: {
	            "href": "#"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.excluirPasta(node)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash"
	        })]) : _vm._e(), _vm._v(" "), (node.data.criar) ? _c('a', {
	          attrs: {
	            "href": "#"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.adicionarPasta(node)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-plus"
	        })]) : _vm._e()])])])
	      }
	    }]),
	    model: {
	      value: (_vm.pastaSelecionada),
	      callback: function($$v) {
	        _vm.pastaSelecionada = $$v
	      },
	      expression: "pastaSelecionada"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    attrs: {
	      "id": "conteudo"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.arquivos),
	      expression: "loading.arquivos"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostrarAdicionarDocumento),
	      expression: "!mostrarAdicionarDocumento"
	    }],
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.modo === 'pesquisa') ? _c('span', [_vm._v("Resultado da pesquisa")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.pastaSelecionada) && _vm.modo === 'pasta') ? _c('span', [_c('i', {
	    staticClass: "fa fa-folder-o"
	  }), _vm._v("  " + _vm._s(_vm.pastaSelecionada.data.text) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "contadorArqivos"
	  }, [(_vm.arquivos.length > 0) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.arquivos.length) + " " + _vm._s(_vm.arquivos.length === 1 ? 'arquivo' : 'arquivos') + "\n                              ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm.arquivosSelecionados.length > 0) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.arquivosSelecionados.length) + " " + _vm._s(_vm.arquivosSelecionados.length === 1 ? 'selecionado' : 'selecionados') + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm.arquivos.length > 0) ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm._.find(_vm.usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))),
	      expression: "_.isEmpty(_.find(usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))"
	    }],
	    staticClass: "indicadores-cb-inline"
	  }, [_c('i', {
	    class: (_vm.arquivosSelecionados.length !== _vm.arquivos.length ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": _vm.selecionarTodosArquivos
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.arquivosSelecionados.length !== _vm.arquivos.length ? '' : 'selecionado'
	  }, [_vm._v("Selecionar tudo")])]) : _vm._e()]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.isEmpty(_vm._.find(_vm.usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))),
	      expression: "_.isEmpty(_.find(usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))"
	    }],
	    staticStyle: {
	      "float": "right"
	    }
	  }, [(_vm.arquivosSelecionados.length > 0) ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.excluirArquivos($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print"
	  }), _vm._v(" Excluir")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm._.has(_vm.pastaSelecionada, 'data') && _vm._.has(_vm.pastaSelecionada.data, 'adicionar') && _vm.pastaSelecionada.data.adicionar === 1 && _vm.modo === 'pasta') ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.mostrarAdicionarDocumento = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Adicionar")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostrarAdicionarDocumento),
	      expression: "!mostrarAdicionarDocumento"
	    }],
	    staticClass: "box-body"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "items": _vm.arquivos,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.filter,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": _vm.modo === 'pasta' ? 'Sem arquivo nesta pasta!' : 'A pesquisa não retornou arquivos',
	      "table-layout:": "",
	      "fixed": ""
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "filtered": _vm.filtrarArquivos
	    },
	    scopedSlots: _vm._u([{
	      key: "nome",
	      fn: function(row) {
	        return [_c('span', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (_vm._.isEmpty(_vm._.find(_vm.usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))),
	            expression: "_.isEmpty(_.find(usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))"
	          }],
	          staticClass: "indicadores"
	        }, [_c('i', {
	          class: (_vm._.find(_vm.arquivosSelecionados, ['id', row.item.id]) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' selecao',
	          staticStyle: {
	            "margin-right": "20px"
	          },
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.selecionarArquivo(row.item)
	            }
	          }
	        })]), _vm._v(" "), _c('a', {
	          staticClass: "ng-binding",
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.downloadArquivo(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.ds_nome_arquivo))]), _vm._v(" "), (_vm._.has(row.item, 'pasta') && _vm.modo === 'pesquisa') ? _c('span', [_c('br'), _c('i', {
	          staticClass: "fa fa-folder-o"
	        }), _vm._v(" " + _vm._s(row.item.pasta.nome))]) : _vm._e()]
	      }
	    }, {
	      key: "dt_criado",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm:ss")))]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarAdicionarDocumento),
	      expression: "mostrarAdicionarDocumento"
	    }],
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('upload-documento-movimento-diario', {
	    attrs: {
	      "documentTypes": '',
	      "pasta": _vm.pastaSelecionada
	    },
	    on: {
	      "mostrarQuadroAdicionaDocumento": function($event) {
	        _vm.mostrarAdicionarDocumento = $event
	      },
	      "atualizarPasta": function($event) {
	        return _vm.selecionaPasta($event)
	      }
	    }
	  })], 1)])])])])])])])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body w-100"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), (!_vm.visualizarLicenca && !_vm.enviarLicenca) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-paper-plane",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Envio de Licenças\n         ")]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-success btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": _vm.verificarStatusAnexo(row.item),
	            "data-cy": "edita-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.abrirAnexoLicenca(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-check-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Anexar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.visualizaLicenca(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Visualizar")])], 1)]
	      }
	    }, {
	      key: "prazo_apresentacao",
	      fn: function(row) {
	        return [_vm._v("\n             " + _vm._s(row.value == '' ? '-' : _vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n           ")]
	      }
	    }, {
	      key: "data_apresentacao",
	      fn: function(row) {
	        return [(row.value == '') ? _c('div', [_c('b', [_vm._v("Não Apresentado")])]) : _c('div', [_vm._v("\n               " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")])]
	      }
	    }, {
	      key: "status",
	      fn: function(row) {
	        return [_c('span', {
	          class: _vm.statusClass(row.value)
	        }, [_vm._v("\n               " + _vm._s(row.value) + "\n             ")])]
	      }
	    }], null, false, 2688540759)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end w-100"
	  }, [_vm._v("\n           (" + _vm._s(_vm.table.items.length) + ") Licenças Encontradas\n         ")])], 1) : _vm._e(), _vm._v(" "), (_vm.enviarLicenca || _vm.visualizarLicenca) ? _c('div', {
	    staticClass: "envio-container column start-centered"
	  }, [_c('legend', [_vm._v("\n           Envio de Licenças\n       ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start gap-10 w-100"
	  }, [_c('div', {
	    staticClass: "w-80"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto:")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "0000 Nome do Projeto",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.numeroProjeto + ' ' + _vm.nomeProjeto
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.status),
	      expression: "licencaTemplate.status"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Status",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.status)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "status", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Fase:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.fase_proposta),
	      expression: "licencaTemplate.fase_proposta"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Fase",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.fase_proposta)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "fase_proposta", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start gap-10 w-100"
	  }, [_c('div', {
	    staticClass: "w-70"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Tipo de Licença:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.licenca),
	      expression: "licencaTemplate.licenca"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Tipo de Licença",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.licenca)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "licenca", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "w-10"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Data de Validade:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy",
	      "disabled": _vm.visualizarLicenca
	    },
	    model: {
	      value: (_vm.licencaTemplate.validade),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaTemplate, "validade", $$v)
	      },
	      expression: "licencaTemplate.validade"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de Apresentação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.prazo_apresentacao),
	      expression: "licencaTemplate.prazo_apresentacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Prazo de Apresentação",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.prazo_apresentacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "prazo_apresentacao", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Apresentado em:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.data_apresentacao),
	      expression: "licencaTemplate.data_apresentacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Prazo de Apresentação",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.data_apresentacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "data_apresentacao", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.observacoes),
	      expression: "licencaTemplate.observacoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Tipo de Licença",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.observacoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "observacoes", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
	    staticClass: "w-100",
	    attrs: {
	      "propDocumentos": _vm.licencaTemplate.anexo,
	      "localUso": "LICENCIAMENTO_AMBIENTAL",
	      "maxFiles": 1,
	      "disable": _vm.visualizarLicenca
	    }
	  })], 1), _vm._v(" "), _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('legend', [_vm._v("\n           Histórico\n         ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.showTable),
	      expression: "loading.showTable"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableHistorico.bordered,
	      "items": _vm.tableHistorico.items,
	      "hover": _vm.tableHistorico.hover,
	      "fields": _vm.tableHistorico.fields,
	      "filter": _vm.tableHistorico.filter,
	      "current-page": _vm.tableHistorico.currentPage,
	      "per-page": _vm.tableHistorico.perPage,
	      "sort-by": _vm.tableHistorico.sortBy,
	      "sort-desc": _vm.tableHistorico.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableHistorico, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableHistorico, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableHistorico, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableHistorico, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "created_at",
	      fn: function(row) {
	        return [_vm._v("\n           " + _vm._s(_vm.moment(row.value).format('DD/MM/YYYY HH:mm:ss')) + "\n         ")]
	      }
	    }], null, false, 1735301358)
	  })], 1), _vm._v(" "), (_vm.enviarLicenca) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEnvio(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gravaLicenca()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Enviar Licença ")])], 1) : _vm._e(), _vm._v(" "), (_vm.visualizarLicenca) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleVisualizacao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Voltar ")])], 1) : _vm._e()], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('serasa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "serasa"
	    }
	  }, [_vm._v("Serasa/SPC")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "height": "34px"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_serasa),
	      expression: "preAnalise.bt_serasa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "serasa",
	      "id": "serasa"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.preAnalise.bt_serasa, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_serasa", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_serasa),
	      expression: "preAnalise.bt_serasa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "serasa"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.preAnalise.bt_serasa, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_serasa", 0)
	      }
	    }
	  }), _vm._v(" Não\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('serasa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('serasa')))]) : _vm._e()]), _vm._v(" "), (_vm.preAnalise.bt_serasa === 1) ? _c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('valor monetário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "valor monetário"
	    }
	  }, [_vm._v("Valor monetário")]), _vm._v(" "), _c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "valor monetário",
	      "name": "valor monetário",
	      "type": "text",
	      "placeholder": "Valor Monetário",
	      "maxlength": "255"
	    },
	    model: {
	      value: (_vm.preAnalise.ds_valor_monetario),
	      callback: function($$v) {
	        _vm.$set(_vm.preAnalise, "ds_valor_monetario", $$v)
	      },
	      expression: "preAnalise.ds_valor_monetario"
	    }
	  }), _vm._v(" "), (_vm.errors.first('valor monetário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor monetário')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "serasa"
	    }
	  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.ds_serasa),
	      expression: "preAnalise.ds_serasa"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "100px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "serasa"
	    },
	    domProps: {
	      "value": (_vm.preAnalise.ds_serasa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preAnalise, "ds_serasa", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('cadin')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "cadin"
	    }
	  }, [_vm._v("Cadin")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "height": "34px"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_cadin),
	      expression: "preAnalise.bt_cadin"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "cadin",
	      "id": "cadin"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.preAnalise.bt_cadin, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_cadin", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_cadin),
	      expression: "preAnalise.bt_cadin"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "cadin"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.preAnalise.bt_cadin, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_cadin", 0)
	      }
	    }
	  }), _vm._v(" Não\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('cadin')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observação cadin"
	    }
	  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.ds_cadin),
	      expression: "preAnalise.ds_cadin"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "100px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "observação cadin"
	    },
	    domProps: {
	      "value": (_vm.preAnalise.ds_cadin)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preAnalise, "ds_cadin", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('cepim')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "cepim"
	    }
	  }, [_vm._v("Cepim")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "height": "34px"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_cepim),
	      expression: "preAnalise.bt_cepim"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "cepim",
	      "id": "cepim"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.preAnalise.bt_cepim, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_cepim", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_cepim),
	      expression: "preAnalise.bt_cepim"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "cepim"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.preAnalise.bt_cepim, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_cepim", 0)
	      }
	    }
	  }), _vm._v(" Não\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('cepim')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cepim')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observação cepim"
	    }
	  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.ds_cepim),
	      expression: "preAnalise.ds_cepim"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "100px",
	      "resize": "none"
	    },
	    attrs: {
	      "id": "observação cepim",
	      "name": "observação cepim"
	    },
	    domProps: {
	      "value": (_vm.preAnalise.ds_cepim)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preAnalise, "ds_cepim", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CND')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "CND"
	    }
	  }, [_vm._v("CND ou CPD-EM")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "height": "34px"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_cnd),
	      expression: "preAnalise.bt_cnd"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "CND",
	      "id": "CND"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.preAnalise.bt_cnd, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_cnd", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_cnd),
	      expression: "preAnalise.bt_cnd"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "CND"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.preAnalise.bt_cnd, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_cnd", 0)
	      }
	    }
	  }), _vm._v(" Não\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('CND')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CND')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observação CND"
	    }
	  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.ds_cnd),
	      expression: "preAnalise.ds_cnd"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "100px",
	      "resize": "none"
	    },
	    attrs: {
	      "id": "observação CND",
	      "name": "observação CND"
	    },
	    domProps: {
	      "value": (_vm.preAnalise.ds_cnd)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preAnalise, "ds_cnd", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNDT')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "CNDT"
	    }
	  }, [_vm._v("CNDT")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "height": "34px"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_cndt),
	      expression: "preAnalise.bt_cndt"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "CNDT",
	      "id": "CNDT"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.preAnalise.bt_cndt, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_cndt", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_cndt),
	      expression: "preAnalise.bt_cndt"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "CNDT"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.preAnalise.bt_cndt, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_cndt", 0)
	      }
	    }
	  }), _vm._v(" Não\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('CNDT')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNDT')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observação CNDT"
	    }
	  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.ds_cndt),
	      expression: "preAnalise.ds_cndt"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "100px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "observação CNDT",
	      "id": "observação CNDT"
	    },
	    domProps: {
	      "value": (_vm.preAnalise.ds_cndt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preAnalise, "ds_cndt", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('crf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "crf"
	    }
	  }, [_vm._v("CRF")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "height": "34px"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_crf),
	      expression: "preAnalise.bt_crf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "crf",
	      "id": "crf"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.preAnalise.bt_crf, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_crf", 1)
	      }
	    }
	  }), _vm._v(" Sim\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.bt_crf),
	      expression: "preAnalise.bt_crf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "crf"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.preAnalise.bt_crf, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.preAnalise, "bt_crf", 0)
	      }
	    }
	  }), _vm._v(" Não\n                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('crf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('crf')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observação crf"
	    }
	  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.ds_crf),
	      expression: "preAnalise.ds_crf"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "100px",
	      "resize": "none"
	    },
	    attrs: {
	      "id": "observação crf",
	      "name": "observação crf"
	    },
	    domProps: {
	      "value": (_vm.preAnalise.ds_crf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preAnalise, "ds_crf", $event.target.value)
	      }
	    }
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Restrições")])])
	}]}

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Parceiros Estratégicos")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": this.$route.params.opcao === 'visualizar'
	    }
	  }, [_c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": !_vm.isEditable()
	    }
	  }, [_c('legend', [_vm._v("Dados do parceiro estratégico:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "Razão social"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.ds_nome),
	      expression: "parceiro.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.parceiro.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro, "ds_nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.parceiro.ds_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro, "ds_cnpj", $$v)
	      },
	      expression: "parceiro.ds_cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('vinculo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "vinculo"
	    }
	  }, [_vm._v(" Vínculos: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.vinculos,
	      "name": "vinculo",
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione os vínculos do Parceiro",
	      "track-by": "id",
	      "custom-label": _vm.customLabel,
	      "preselect-first": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.desc_vinculo))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.parceiro.vinculos),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro, "vinculos", $$v)
	      },
	      expression: "parceiro.vinculos"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('vinculo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('vinculo')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6",
	    attrs: {
	      "id": "contato"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10|max:11'),
	      expression: "'required|min:10|max:11'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "data-vv-as": "Telefone",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.parceiro.contato.ds_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro.contato, "ds_telefone", $$v)
	      },
	      expression: "parceiro.contato.ds_telefone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "celular"
	    }
	  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('min:10|max:11'),
	      expression: "'min:10|max:11'"
	    }],
	    ref: "mobile",
	    staticClass: "form-control",
	    attrs: {
	      "name": "mobile",
	      "data-vv-as": "Celular",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.parceiro.contato.ds_celular),
	      callback: function($$v) {
	        _vm.$set(_vm.parceiro.contato, "ds_celular", $$v)
	      },
	      expression: "parceiro.contato.ds_celular"
	    }
	  }), _vm._v(" "), (_vm.errors.first('mobile')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('mobile')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.ds_email),
	      expression: "parceiro.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "Email",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Email",
	      "type": "text",
	      "data-vv-as": "E-Mail",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.parceiro.ds_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro, "ds_email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "website"
	    }
	  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parceiro.ds_website),
	      expression: "parceiro.ds_website"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:255'),
	      expression: "'max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "website",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.parceiro.ds_website)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.parceiro, "ds_website", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(1), _vm._v(" "), _c('usuarios', {
	    attrs: {
	      "entUsuarios": _vm.parceiro.usuarios
	    }
	  })], 1)])])])])]), _vm._v(" "), (this.$route.params.opcao !== 'visualizar') ? _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salva(_vm.frmCommonRegister)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1) : _vm._e(), _vm._v(" "), (this.$route.params.opcao === 'visualizar') ? _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1) : _vm._e()])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Parceiro Estratégico")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Usuários do parceiro estratégico:")])])])
	}]}

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Aceite',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ng-init": "check()"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.simplified),
	      expression: "proposta.simplified"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "hidden",
	      "name": "tipo",
	      "id": "tipo",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.proposta.simplified)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "simplified", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('NAME')"
	    }
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.idProjectErp),
	      expression: "proposta.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.name),
	      expression: "proposta.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorName),
	      expression: "proposta.coordinatorName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorCpf", $$v)
	      },
	      expression: "proposta.coordinatorCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorEmail),
	      expression: "proposta.coordinatorEmail"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorPhone", $$v)
	      },
	      expression: "proposta.coordinatorPhone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorMobile", $$v)
	      },
	      expression: "proposta.coordinatorMobile"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Fax')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorFax", $$v)
	      },
	      expression: "proposta.coordinatorFax"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Fax')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.proposta.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                      " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                      " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                    ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('datepicker', {
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control",
	      "use-utc": true,
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.proposta.initialDate),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "initialDate", $$v)
	      },
	      expression: "proposta.initialDate"
	    }
	  })], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periods),
	      expression: "proposta.periods"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.proposta.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.introduction),
	      expression: "proposta.introduction"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "introduction", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.presentation),
	      expression: "proposta.presentation"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.territory),
	      expression: "proposta.territory"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.justification),
	      expression: "proposta.justification"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.generalObjective),
	      expression: "proposta.generalObjective"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.summary),
	      expression: "proposta.summary"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": this.proposta.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": this.proposta.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.teams = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.results),
	      expression: "proposta.results"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "results", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.operation),
	      expression: "proposta.operation"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "operation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.partner),
	      expression: "proposta.partner"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "partner", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.proposta.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.proposta.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                ")])])]), _vm._v(" "), (_vm.proposta.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingName),
	      expression: "proposta.entityExecutingName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingProcurator),
	      expression: "proposta.entityExecutingProcurator"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCNPJ", $$v)
	      },
	      expression: "proposta.entityExecutingCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingEmail),
	      expression: "proposta.entityExecutingEmail"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingPhone", $$v)
	      },
	      expression: "proposta.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingMobile", $$v)
	      },
	      expression: "proposta.entityExecutingMobile"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingFax", $$v)
	      },
	      expression: "proposta.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.duplicateProject),
	      expression: "proposta.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber) + "/" + _vm._s(projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(9), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(10), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraCronograma),
	      expression: "mostraCronograma"
	    }],
	    staticClass: "col-md-12"
	  }, [_vm._m(11), _vm._v(" "), _c('cronograma', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades,
	      "meses": _vm.proposta.periods,
	      "projeto-duplicacao": _vm.proposta.duplicateProject
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('gantt', {
	    attrs: {
	      "periodo": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades
	    }
	  })], 1), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "proposta": _vm.proposta
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.careers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(14), _vm._v(" "), _c('solenizacao', {
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.proposta.solemnizations = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(15), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documents,
	      "documentTypes": _vm.proposta.documentTypes,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(16), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documentStatements,
	      "documentTypes": [],
	      "documentosObrigatorios": []
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(17), _vm._v(" "), _c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(18), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(19), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "frmAcceptance",
	      "novalidate": ""
	    }
	  }, [_c('fieldset', [_c('fav', {
	    attrs: {
	      "propsPreAnalise": _vm.analise,
	      "fase": "Aceite"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('resultado aceite')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "resultadoAceite"
	    }
	  }, [_vm._v("Proposta aceita pela Gepro?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approval.acceptanceApprovalResult),
	      expression: "analise.approval.acceptanceApprovalResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado aceite",
	      "value": "APPROVED"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.approval.acceptanceApprovalResult, "APPROVED")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise.approval, "acceptanceApprovalResult", "APPROVED")
	      }
	    }
	  }), _vm._v(" Sim\n                                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approval.acceptanceApprovalResult),
	      expression: "analise.approval.acceptanceApprovalResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado aceite",
	      "value": "REJECTED"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.approval.acceptanceApprovalResult, "REJECTED")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise.approval, "acceptanceApprovalResult", "REJECTED")
	      }
	    }
	  }), _vm._v(" Não\n                                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('resultado aceite')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultado aceite')))]) : _vm._e()]), _vm._v(" "), (_vm.analise.approval.acceptanceApprovalResult === 'REJECTED') ? _c('div', {
	    staticClass: "form-group required-field full ng-hide",
	    class: {
	      'has-error': _vm.errors.first('motivo')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "motivo"
	    }
	  }, [_vm._v("Motivo de devolver para Geate:")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.motivoRejeicao),
	      expression: "analise.motivoRejeicao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "motivo"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.analise, "motivoRejeicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Outro"
	    }
	  }, [_vm._v("Outro")]), _vm._v(" "), _vm._l((_vm.razoes), function(razao) {
	    return _c('option', {
	      domProps: {
	        "value": razao
	      }
	    }, [_vm._v(_vm._s(razao))])
	  })], 2), _vm._v(" "), (_vm.errors.first('motivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.analise.approval.reasonToReject === 'Outro') ? _c('div', {
	    staticClass: "form-group required-field full ng-hide",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa"
	    }
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approval.justify),
	      expression: "analise.approval.justify"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.analise.approval.justify)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise.approval, "justify", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "analyst"
	    }
	  }, [_vm._v("Analista responsável:")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approval.analyst),
	      expression: "analise.approval.analyst"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "analyst"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.analise.approval, "analyst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.analistas), function(analista) {
	    return _c('option', {
	      domProps: {
	        "value": analista
	      }
	    }, [_vm._v(_vm._s(analista.userName))])
	  }), 0)])])], 1)])])])]), _vm._v(" "), (_vm.aguardaEnviar === 0) ? _c('div', {
	    staticClass: "box-footer"
	  }, [(_vm.analise.approval.acceptanceApprovalResult) ? _c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onConclude
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])]) : _vm._e()])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('span', {
	    staticClass: "btn btn-default"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                          outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Aceite da Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])
	}]}

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("FAV")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-maxlength ng-valid-minlength ng-valid-mask ng-valid-parse ng-valid-date ng-valid-max ng-valid ng-valid-required",
	    attrs: {
	      "name": "user",
	      "novalidate": ""
	    }
	  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmRegUserFbb.$submitted && frmRegUserFbb.userName.$error.required }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fav.name),
	      expression: "fav.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "favName",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.fav.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fav, "name", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), (this.$root.authorize('perfil-novo')) ? _c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Cadastro de Perguntas")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.$root.authorize('perfil-novo')),
	      expression: "this.$root.authorize('perfil-novo')"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atribuir")])])]), _vm._v(" "), (_vm.show) ? _c('div', {
	    staticClass: "well well-sm no-shadow animated fadeInDownOutUp ng-pristine ng-valid-mask ng-invalid ng-invalid-required ng-valid-maxlength ng-valid-max ng-valid-date ng-hide"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "questionNumber"
	    }
	  }, [_vm._v("Número da Pergunta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.questionNumber),
	      expression: "questao.questionNumber"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-isolate-scope ng-valid-mask ng-empty ng-valid-maxlength",
	    attrs: {
	      "name": "questionNumber",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.questao.questionNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.questao, "questionNumber", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "local"
	    }
	  }, [_vm._v("Local:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.local),
	      expression: "questao.local"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "local"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.questao, "local", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.listaLocais), function(local) {
	    return _c('option', {
	      domProps: {
	        "value": local
	      }
	    }, [_vm._v(_vm._s(local))])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmRegUserFbb.$submitted && frmRegUserFbb.userName.$error.required }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "pergunta"
	    }
	  }, [_vm._v("Pergunta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.question),
	      expression: "questao.question"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "favQuestion",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.questao.question)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.questao, "question", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "bt_conformidade"
	    }
	  }, [_vm._v("Respostas:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.conformityYes),
	      expression: "questao.conformityYes"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Sim"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.questao.conformityYes) ? _vm._i(_vm.questao.conformityYes, "Sim") > -1 : (_vm.questao.conformityYes)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.questao.conformityYes,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Sim",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.questao, "conformityYes", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.questao, "conformityYes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.questao, "conformityYes", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "conformityYes"
	    }
	  }, [_vm._v("Sim")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.conformityNo),
	      expression: "questao.conformityNo"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Não"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.questao.conformityNo) ? _vm._i(_vm.questao.conformityNo, "Não") > -1 : (_vm.questao.conformityNo)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.questao.conformityNo,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Não",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.questao, "conformityNo", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.questao, "conformityNo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.questao, "conformityNo", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "conformityNo"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.questao.conformityNA),
	      expression: "questao.conformityNA"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "NA"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.questao.conformityNA) ? _vm._i(_vm.questao.conformityNA, "NA") > -1 : (_vm.questao.conformityNA)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.questao.conformityNA,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "NA",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.questao, "conformityNA", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.questao, "conformityNA", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.questao, "conformityNA", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "conformityNA"
	    }
	  }, [_vm._v("N/A")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-10 col-sm-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "items": _vm.table2.items,
	      "hover": _vm.table2.hover,
	      "fields": _vm.table2.fields,
	      "current-page": _vm.table2.currentPage,
	      "per-page": _vm.table2.perPage,
	      "sort-by": _vm.table2.sortBy,
	      "sort-desc": _vm.table2.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table2, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table2, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table2, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table2, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onEdit(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onDelete(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("Excluir")])], 1)]
	      }
	    }, {
	      key: "conformityYes",
	      fn: function(row) {
	        return [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (row.item.conformityYes),
	            expression: "row.item.conformityYes"
	          }],
	          attrs: {
	            "type": "checkbox",
	            "name": "conformityYes",
	            "disabled": true
	          },
	          domProps: {
	            "checked": Array.isArray(row.item.conformityYes) ? _vm._i(row.item.conformityYes, null) > -1 : (row.item.conformityYes)
	          },
	          on: {
	            "change": function($event) {
	              var $$a = row.item.conformityYes,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(row.item, "conformityYes", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(row.item, "conformityYes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(row.item, "conformityYes", $$c)
	              }
	            }
	          }
	        })]
	      }
	    }, {
	      key: "conformityNo",
	      fn: function(row) {
	        return [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (row.item.conformityNo),
	            expression: "row.item.conformityNo"
	          }],
	          attrs: {
	            "type": "checkbox",
	            "name": "conformityNo",
	            "disabled": true
	          },
	          domProps: {
	            "checked": Array.isArray(row.item.conformityNo) ? _vm._i(row.item.conformityNo, null) > -1 : (row.item.conformityNo)
	          },
	          on: {
	            "change": function($event) {
	              var $$a = row.item.conformityNo,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(row.item, "conformityNo", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(row.item, "conformityNo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(row.item, "conformityNo", $$c)
	              }
	            }
	          }
	        })]
	      }
	    }, {
	      key: "conformityNA",
	      fn: function(row) {
	        return [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (row.item.conformityNA),
	            expression: "row.item.conformityNA"
	          }],
	          attrs: {
	            "type": "checkbox",
	            "name": "conformityNA",
	            "disabled": true
	          },
	          domProps: {
	            "checked": Array.isArray(row.item.conformityNA) ? _vm._i(row.item.conformityNA, null) > -1 : (row.item.conformityNA)
	          },
	          on: {
	            "change": function($event) {
	              var $$a = row.item.conformityNA,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(row.item, "conformityNA", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(row.item, "conformityNA", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(row.item, "conformityNA", $$c)
	              }
	            }
	          }
	        })]
	      }
	    }], null, false, 3105640627)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSave($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onClean
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")]), _vm._v(" "), _vm._m(2)])])]) : _vm._e()])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de uma FAV")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:history.go(-1)"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])])
	}]}

/***/ }),
/* 1979 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm.totais.aglutinado === 'Sim') ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('table', {
	    ref: "tabelaCronogramaAglutinado",
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.itensProjeto), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.Item_Descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Item_Tipo))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado)))]), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.quantidadeSolicitada))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.quantidadeSolicitada),
	        expression: "item.quantidadeSolicitada"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "quantidade a solicitar",
	        "type": "text"
	      },
	      domProps: {
	        "value": (item.quantidadeSolicitada)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "quantidadeSolicitada", $event.target.value)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.valorSolicitado)))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('money', {
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "valor a solicitar",
	        "type": "text"
	      },
	      model: {
	        value: (item.valorSolicitado),
	        callback: function($$v) {
	          _vm.$set(item, "valorSolicitado", $$v)
	        },
	        expression: "item.valorSolicitado"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_orcado - item.quantidadeSolicitada - item.Qtde_liberado || 0))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_saldo - (item.quantidadeSolicitada ? item.quantidadeSolicitada : 0)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado - item.valorSolicitado - item.Valor_liberado)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo - (item.valorSolicitado ? item.valorSolicitado : 0))))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [(item.editing === false || !item.editing) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-edit",
	      staticStyle: {
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.editItem(item, 1)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green",
	        "margin-left": "5px",
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item, 2)
	        }
	      }
	    }) : _vm._e()])])
	  }), 0), _vm._v(" "), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor total de recursos contratados: ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v("Valor total da solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.total)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Saldo restante do projeto:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado - _vm.total)))]), _vm._v(" "), _c('td')])])])])]) : _vm._e(), _vm._v(" "), (_vm.totais.aglutinado === 'Não') ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.itensProjeto), function(item) {
	    return _c('tbody', [_c('tr', {
	      staticStyle: {
	        "background-color": "rgb(223, 228, 235)"
	      }
	    }, [_c('td', {
	      attrs: {
	        "colspan": "9"
	      }
	    }, [_c('b', [_vm._v("Atividade:")]), _vm._v(" " + _vm._s(item.Atividade_nome) + "\n            ")])]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao)), _c('br'), _vm._v("#" + _vm._s(item.Id_item) + " " + _vm._s(item.Item_Observacao))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Item_Tipo))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado)))]), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.quantidadeSolicitada))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.quantidadeSolicitada),
	        expression: "item.quantidadeSolicitada"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "quantidade a solicitar",
	        "type": "text"
	      },
	      domProps: {
	        "value": (item.quantidadeSolicitada)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "quantidadeSolicitada", $event.target.value)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(item.valorSolicitado)))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_c('money', {
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "valor a solicitar",
	        "type": "text"
	      },
	      model: {
	        value: (item.valorSolicitado),
	        callback: function($$v) {
	          _vm.$set(item, "valorSolicitado", $$v)
	        },
	        expression: "item.valorSolicitado"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Qtde_orcado - item.quantidadeSolicitada - item.Qtde_liberado || 0))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Qtde_saldo - (item.quantidadeSolicitada ? item.quantidadeSolicitada : 0)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado - item.valorSolicitado - item.Valor_liberado)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo - (item.valorSolicitado ? item.valorSolicitado : 0))))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [(item.editing === false || !item.editing) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-edit",
	      staticStyle: {
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.editItem(item, 1)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green",
	        "margin-left": "5px",
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item, 2)
	        }
	      }
	    }) : _vm._e()])])
	  }), _vm._v(" "), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor total de recursos contratados: ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v("Valor total da solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalSolicitacao)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Saldo restante do projeto:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado - _vm.valorTotalSolicitacao)))]), _vm._v(" "), _c('td')])])], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-striped table-bordered",
	    staticStyle: {
	      "min-width": "750px"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.totalFBB > 0 || _vm.totalFaseFBB > 0) ? _c('tr', [_c('td', [_vm._v("Fundação")]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFaseFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantadoFaseFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.saldoFaseFBB)))])]) : _vm._e(), _vm._v(" "), (_vm.totalPAR > 0 || _vm.totalFasePAR > 0) ? _c('tr', [_c('td', [_vm._v("Parceiro Estratégico")]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalPAR)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFasePAR)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantadoFasePAR)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.saldoFasePAR)))])]) : _vm._e()])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Valor a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "7%"
	    }
	  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "12%"
	    }
	  }, [_vm._v("Quantidade a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Valor a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Recurso")]), _vm._v(" "), _c('th', [_vm._v("Fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total da fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total de adiantamento por fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total já adiantado")]), _vm._v(" "), _c('th', [_vm._v("Saldo de adiantamento restante por fase")])])])
	}]}

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "prest-modulo-container",
	    attrs: {
	      "id": "cronogramaPagamento"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "solicitacao"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "1",
	      "title": '<h5>Valor total contratado no projeto por Atividade e Item</h5>'
	    }
	  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "1",
	      "title": '<h5>Informe o que consta no documento (quantidade e valor)</h5>'
	    }
	  }, [_vm._v("Valor Documentos")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "1",
	      "title": '<h5>Saldo restante de cada Atividade e Item</h5>'
	    }
	  }, [_vm._v("Saldo")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('tbody', [_vm._l(((_vm.layoutExtrato === 'classico' ? [
	    ['1', '5', '2']
	  ] : (_vm.layoutExtrato === 'porOrigem') ? [
	    ['1', '5']
	  ] : [
	    ['2']
	  ])), function(origem) {
	    return [(_vm.layoutExtrato === 'porOrigem') ? _c('tr', [_c('td', {
	      staticClass: "atividade",
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_vm._v(_vm._s((_vm._.includes(origem, '2')) ? 'Recursos de Contrapartida' : 'Recursos da Fundação BB'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cronograma.atividades), function(atividade) {
	      return ((_vm._.filter(_vm.cronograma.itens, function(i) {
	        return i.Atividade_nome === atividade.Nome && _vm._.includes((_vm.processo === 'CONTRAPARTIDA' ? ['2'] : ['1', '5']), ('' + i.Item_Origem).substring(0, 1)) && (!_vm._.has(i, 'mostrar') || i.mostrar)
	      })).length > 0) ? [(_vm.layoutExtrato === 'classico') ? _c('tr', {
	        staticClass: "atividade"
	      }, [_c('td', {
	        staticClass: "esquerda celula b1 b3 b4 nome_atividade"
	      }, [_vm._v(_vm._s(atividade.Nome))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b4"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b4"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3"
	      }, [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.filter(_vm.cronograma.itens, {
	        'Atividade_nome': atividade.Nome
	      })), function(item) {
	        return (_vm._.includes((_vm.processo === 'CONTRAPARTIDA' ? ['2'] : ['1', '5']), ('' + item.Item_Origem).substring(0, 1)) && _vm.contasFinanceiras.includes(item.Item)) ? [(!_vm._.has(item, 'mostrar') || item.mostrar) ? [_c('tr', [_c('td', {
	          staticClass: "celula b3 b4"
	        }, [_c('div', {
	          staticClass: "item",
	          style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 80%; float: left;' : '')
	        }, [_c('div', {
	          staticClass: "item_despesa esquerda"
	        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.Item_Tipo))) + ")  " + _vm._s(item.Item + ' / ' + item.Item_Descricao))]), _vm._v(" "), _c('div', {
	          staticClass: "observacao esquerda",
	          domProps: {
	            "innerHTML": _vm._s('<span class=id_item>#' + item.Id_item + '</span>  ' + item.Item_Observacao + '</span>')
	          }
	        })]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	          staticStyle: {
	            "width": "20%",
	            "text-align": "right",
	            "float": "right",
	            "color": "var(--cor-fraca)"
	          }
	        }, [_vm._v(_vm._s(item.Item_Conta))]) : _vm._e()]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b4"
	        }, [_vm._v("\n                          " + _vm._s(_vm._f("decimal2")(item.Valor_orcado)) + "\n                        ")]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b4 valorSolicitacao"
	        }, [_c('money', {
	          staticClass: "form-control text-right valorSolicitacao",
	          attrs: {
	            "name": "valor a solicitar",
	            "type": "text",
	            "disabled": true
	          },
	          nativeOn: {
	            "keyup": function($event) {
	              item.Valor_solicitado = _vm.limitaFaixaEntrada('decimal', item.Valor_solicitado, 0, item.Valor_saldo)
	            }
	          },
	          model: {
	            value: (item.Valor_solicitado),
	            callback: function($$v) {
	              _vm.$set(item, "Valor_solicitado", $$v)
	            },
	            expression: "item.Valor_solicitado"
	          }
	        })], 1), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b2 b3 b4"
	        }, [_vm._v("\n                          " + _vm._s(_vm._f("decimal2")(item.Valor_saldo - parseFloat(item.Valor_solicitado))) + "\n                        ")]), _vm._v(" "), (_vm.usuarioLogado.userType == 'ENTIDADE') ? _c('td', {
	          staticClass: "centralizado celula b2 b3 b4"
	        }, [(parseFloat(item.Valor_saldo - item.Valor_solicitado) > 0) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'bottom'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	          }],
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "title": '<h5>Clique para Inserir um Novo Documento Fiscal</h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.toggleEdicao(true, item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-plus-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Inserir\n                          ")]) : _c('div', {
	          staticClass: "prest-max-solicitado"
	        }, [_c('i', [_vm._v("Valores totais já informados.")])])], 1) : _vm._e()])] : _vm._e()] : _vm._e()
	      })] : _vm._e()
	    })]
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end prest-valor-total"
	  }, [_c('div', {
	    staticClass: "row-flex all-end"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    staticClass: "prest-valor-total"
	  }, [_vm._v("Valor total do cronograma: "), _c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.cronograma.totais.valor_total_contratado)))])])])])])])])]), _vm._v(" "), (_vm.editando) ? _c('div', {
	    staticClass: "column all-start prest-fade",
	    class: _vm.editandoNotaCadastrada ? 'prest-edicao-nota-container' : 'prest-cadastro-nota-container',
	    attrs: {
	      "id": "solicitacao"
	    }
	  }, [(_vm.loading.documentos) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "prest-title",
	    attrs: {
	      "id": "cadastroDocumento"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.editandoNotaCadastrada ? 'Edição de Nota' : 'Cadastro de Nota') + " "), _c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.nota.fornecedor_tipo) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start prest-nota-atividade-container"
	  }, [_c('div', {
	    staticClass: "prest-atividade-row"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark"
	  }), _vm._v(" " + _vm._s(this.nota.itemOrcamento.Atividade_nome) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-atividade-row"
	  }, [_c('span', {
	    staticClass: "prest-id-item"
	  }, [_vm._v("#" + _vm._s(this.nota.itemOrcamento.Id_item))]), _vm._v("\n            [" + _vm._s(this.nota.itemOrcamento.Item) + "] " + _vm._s(this.nota.itemOrcamento.Item_Descricao) + " - " + _vm._s(this.nota.itemOrcamento.Item_Observacao) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-atividade-row"
	  }, [_c('b', [_vm._v("Valor Orçado:")]), _vm._v(" " + _vm._s(_vm._f("real")(this.nota.itemOrcamento.Valor_orcado)) + "\n            "), _c('u', [_c('b', [_vm._v("Saldo Restante:")]), _vm._v(" " + _vm._s(_vm._f("real")((this.nota.itemOrcamento.Valor_saldo - this.nota.itemOrcamento.Valor_solicitado) - this.nota.valor_documento)))])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-atividade-row"
	  }, [_vm._v("\n            Período Execução do Projeto: \n            "), _c('b', [_vm._v("Inicio:")]), _vm._v(" " + _vm._s(_vm.dataInicial) + " \n            e\n            "), _c('b', [_vm._v("Fim:")]), _vm._v(" " + _vm._s(_vm.dataFinal) + "\n          ")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "row-flex w-100"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: (_vm.errors.first('número da nota') ? ' has-error' : '')
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Descreva o Item do Documento:\n                ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.item),
	      expression: "nota.item"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "maxlength": "70"
	    },
	    domProps: {
	      "value": (_vm.nota.item)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "item", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("\n                    " + _vm._s(_vm.nota.item ? _vm.nota.item.length : 0) + "/70 caracteres\n                ")]), _vm._v(" "), (_vm.nota.item && _vm.nota.item.length === 70) ? _c('span', {
	    staticClass: "label label-warning"
	  }, [_vm._v("\n    Limite máximo de 70 caracteres atingido.\n")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: (_vm.errors.first('número da nota') ? ' has-error' : '')
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Valor:\n                ")]), _vm._v(" "), _c('money', {
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "valorNota",
	      "type": "text"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        _vm.nota.valor_documento = _vm.limitaFaixaEntradaInput('decimal', _vm.nota.valor_documento, 0, (_vm.nota.itemOrcamento.Valor_saldo - _vm.nota.itemOrcamento.Valor_solicitado))
	      }
	    },
	    model: {
	      value: (_vm.nota.valor_documento),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "valor_documento", $$v)
	      },
	      expression: "nota.valor_documento"
	    }
	  }), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex w-100"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: (_vm.errors.first('número da nota') ? ' has-error' : '')
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número do Documento (apenas números):\n                ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.numero_documento),
	      expression: "nota.numero_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "número da nota",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.nota.numero_documento)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "numero_documento", $event.target.value)
	      }, _vm.formatarNumeroDocumento]
	    }
	  }), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('série')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Série:")]), _vm._v(" "), _c('div', [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.serie_documento),
	      expression: "nota.serie_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "série"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "serie_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "NOTA_FISCAL"
	    }
	  }, [_vm._v("1 - Nota fiscal")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RECIBO_PAGAMENTO_AUTONOMO"
	    }
	  }, [_vm._v("10 - Recibo de pagamento a autônomo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DOCUMENTO_NAO_FISCAL"
	    }
	  }, [_vm._v("DNF - Documento não fiscal")])])]), _vm._v(" "), (_vm.errors.first('série')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('série')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex w-100"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('data de emissão')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de emissão do documento:")]), _vm._v(" "), _c('div', [_c('div', [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data de emissão",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "disabled-dates": {
	        to: new Date(_vm.dataInicioSapiens),
	        from: new Date()
	      },
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.nota.data_emissao_documento),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "data_emissao_documento", $$v)
	      },
	      expression: "nota.data_emissao_documento"
	    }
	  })], 1)]), _vm._v(" "), (_vm.errors.first('data de emissão')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data de emissão')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de validade do documento: (Somente informe se possuir a data)")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    attrs: {
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.nota.data_validade_documento),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "data_validade_documento", $$v)
	      },
	      expression: "nota.data_validade_documento"
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "column all-start prest-cadastro-nota-container",
	    attrs: {
	      "id": "solicitacao"
	    }
	  }, [_vm._m(4), _vm._v(" "), (_vm.loading.tela) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex w-100"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de pessoa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Tipo de pessoa:")]), _vm._v(" "), _c('div', [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.fornecedor_tipo),
	      expression: "nota.fornecedor_tipo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "tipo de pessoa",
	      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "fornecedor_tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.bloqueiaCamposFornecedorExistente = false, _vm.nota.fornecedor_nome = '', _vm.nota.fornecedor_cep = '', _vm.nota.fornecedor_endereco = '', _vm.nota.fornecedor_cpf_cnpj = '', _vm.nota.fornecedor_codigo = ''
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Pessoa Física"
	    }
	  }, [_vm._v("Pessoa Física")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Pessoa Jurídica"
	    }
	  }, [_vm._v("Pessoa Jurídica")])])]), _vm._v(" "), (_vm.errors.first('tipo de pessoa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de pessoa')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex w-100"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.nota.fornecedor_tipo === 'Pessoa Jurídica') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpj')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "row-flex"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "form-control",
	    style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 65%; float: left' : ''),
	    attrs: {
	      "name": "cnpj",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens,
	      "disabled": _vm.bloqueiaCamposFornecedorExistente,
	      "type": "text"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.verificaCpfCnpjSapiens(_vm.nota.fornecedor_cpf_cnpj)
	      }
	    },
	    model: {
	      value: (_vm.nota.fornecedor_cpf_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "fornecedor_cpf_cnpj", $$v)
	      },
	      expression: "nota.fornecedor_cpf_cnpj"
	    }
	  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('input', {
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "35%",
	      "float": "left",
	      "margin-left": "1%"
	    },
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.nota.fornecedor_codigo
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cnpj')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('cnpj vinculado a dirigente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj vinculado a dirigente')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nota.fornecedor_tipo === 'Pessoa Física') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "form-control",
	    style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 65%; float: left' : ''),
	    attrs: {
	      "name": "cpf",
	      "mask": ['###.###.###-##'],
	      "disabled": _vm.bloqueiaCamposFornecedorExistente,
	      "type": "text"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.verificaCpfCnpjSapiens(_vm.nota.fornecedor_cpf_cnpj)
	      }
	    },
	    model: {
	      value: (_vm.nota.fornecedor_cpf_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "fornecedor_cpf_cnpj", $$v)
	      },
	      expression: "nota.fornecedor_cpf_cnpj"
	    }
	  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('input', {
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "30%",
	      "float": "left",
	      "margin-left": "5%"
	    },
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.nota.codigoFornecedor
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm._.has(_vm.nota, 'fornecedor_tipo') && !_vm._.isNull(_vm.nota.fornecedor_tipo)) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.fornecedor_nome),
	      expression: "nota.fornecedor_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        regex: /^[A-Za-zÀ-ÿ0-9\s.\-\/()&$*'\x22]+$/
	      }),
	      expression: "{ required: true, regex: /^[A-Za-zÀ-ÿ0-9\\s.\\-\\/()&$*'\\x22]+$/ }"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "disabled": _vm.bloqueiaCamposFornecedorExistente,
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.nota.fornecedor_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "fornecedor_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex w-100"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm._.has(_vm.nota, 'fornecedor_tipo') && !_vm._.isNull(_vm.nota.fornecedor_tipo)) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('endereço')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.fornecedor_endereco),
	      expression: "nota.fornecedor_endereco"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "endereço",
	      "type": "text",
	      "disabled": _vm.bloqueiaCamposFornecedorExistente
	    },
	    domProps: {
	      "value": (_vm.nota.fornecedor_endereco)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "fornecedor_endereco", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('endereço ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm._.has(_vm.nota, 'fornecedor_tipo') && !_vm._.isNull(_vm.nota.fornecedor_tipo)) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cep')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cep",
	      "mask": ['#####-###'],
	      "disabled": _vm.bloqueiaCamposFornecedorExistente
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.procurandoCidadeUF($event)
	      }
	    },
	    model: {
	      value: (_vm.nota.fornecedor_cep),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "fornecedor_cep", $$v)
	      },
	      expression: "nota.fornecedor_cep"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.nota.cidadeFornecedor) ? _c('div', {
	    staticClass: "prest-municipio"
	  }, [_c('i', {
	    staticClass: "fa fa-map-marker",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" \n              " + _vm._s(_vm.nota.cidadeFornecedor) + " " + _vm._s((_vm.nota.estadoFornecedor) ? ' / ' + _vm.nota.estadoFornecedor : '') + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body prest-upload-container"
	  }, [_vm._m(5), _vm._v(" "), _c('uploadDocumentosPhpPrestacao', {
	    attrs: {
	      "propDocumentos": _vm.nota.anexos,
	      "documentTypes": '',
	      "local-uso": 'SOLICITACAO_PAGAMENTO',
	      "desvinculaAnexo": _vm.desvinculaAnexo,
	      "restricaoArquivo": true
	    }
	  })], 1)]), _vm._v(" "), (_vm.notaJaCadastradaNestaPrestacao) ? _c('div', {
	    staticClass: "column start-centered prest-aviso-repetido-container"
	  }, [_c('div', {
	    staticClass: "row-flex start-between prest-aviso-close"
	  }, [_vm._m(6), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-close",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.notaJaCadastrada = false
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("\n              Atenção! Este documento já foi lançado anteriormente:\n              "), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-checkbox-container"
	  }, [_c('div', {
	    staticClass: "f-required"
	  }, [_vm._v("\n                   Há necessidade de lançar novamente:\n                  ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.notaRepetida.necessidade),
	      expression: "notaRepetida.necessidade"
	    }],
	    staticClass: "form-check-input",
	    attrs: {
	      "type": "checkbox",
	      "id": "notaJaCadastrada",
	      "name": "notaJaCadastrada"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.notaRepetida.necessidade) ? _vm._i(_vm.notaRepetida.necessidade, null) > -1 : (_vm.notaRepetida.necessidade)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.notaRepetida.necessidade,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.notaRepetida, "necessidade", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.notaRepetida, "necessidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.notaRepetida, "necessidade", $$c)
	        }
	      }, function($event) {
	        return _vm.verificaValidacao()
	      }]
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-checkbox-container"
	  }, [_c('div', {
	    staticClass: "f-required"
	  }, [_vm._v("\n                   Está ciente da responsabilidade pelas informações prestadas:\n                  ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.notaRepetida.responsabilidade),
	      expression: "notaRepetida.responsabilidade"
	    }],
	    staticClass: "form-check-input",
	    attrs: {
	      "type": "checkbox",
	      "id": "notaJaCadastrada",
	      "name": "notaJaCadastrada"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.notaRepetida.responsabilidade) ? _vm._i(_vm.notaRepetida.responsabilidade, null) > -1 : (_vm.notaRepetida.responsabilidade)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.notaRepetida.responsabilidade,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.notaRepetida, "responsabilidade", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.notaRepetida, "responsabilidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.notaRepetida, "responsabilidade", $$c)
	        }
	      }, function($event) {
	        return _vm.verificaValidacao()
	      }]
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("\n                *Informe apenas o valor do ITEM da nota fiscal.\n               ")]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-button-container"
	  }, [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": _vm.editandoNotaCadastrada ? 'primary' : 'success',
	      "size": "button--size-ss",
	      "title": _vm.editandoNotaCadastrada ? '<h5>Clique para Salvar Edição</h5>' : '<h5>Clique para Adicionar a Nota</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarNota()
	      }
	    }
	  }, [_c('i', {
	    class: _vm.editandoNotaCadastrada ? 'fa fa-save' : 'fa fa-plus-circle',
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.editandoNotaCadastrada ? 'Salvar Edição' : 'Adicionar') + "\n          ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Clique para Cancelar</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(false, null, true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])], 1)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Cronograma "), _c('i', {
	    staticClass: "fa fa-calendar-check-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v("\n        Encontre o item do cronograma que deseja vincular o documento fiscal e clique em "), _c('b', [_vm._v("Inserir")]), _vm._v(".\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', [_vm._v("Atividade / Recursos (itens do cronograma)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dados do Documento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Fornecedor")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Documento Fiscal "), _c('i', {
	    staticClass: "fa fa-paperclip",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', [_c('strong', [_c('i', {
	    staticClass: "fa fa-exclamation-triangle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atenção")])])
	}]}

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.entidadeUsu.companyName),
	      expression: "!entidadeUsu.companyName"
	    }],
	    staticClass: "box-header with-border",
	    attrs: {
	      "ssm-lte-loading": "cmptSimpleRegisterEntityForm",
	      "ng-hide": "$ctrl.entity.status === 'PENDENTE_APROVACAO'  ||  $ctrl.entity.status === 'COMPLETO' || $ctrl.entity.status =='INCOMPLETO'"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeEdital.noticeNumber),
	      expression: "entidadeEdital.noticeNumber"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidadeEdital.noticeNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidadeEdital, "noticeNumber", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "Entidade"
	    }
	  }, [(_vm.procSelecionado) ? _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeUsu.companyName),
	      expression: "entidadeUsu.companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidadeUsu.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidadeUsu, "companyName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.entidadeUsu.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidadeUsu, "cnpj", $$v)
	      },
	      expression: "entidadeUsu.cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpjExpeditionTime')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "cnpjExpeditionTime"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeUsu.cnpjExpeditionTime),
	      expression: "entidadeUsu.cnpjExpeditionTime"
	    }],
	    ref: "cnpjExpeditionTime",
	    staticClass: "form-control",
	    attrs: {
	      "name": "cnpjExpeditionTime",
	      "type": "date",
	      "format": "DD/MM/YYYY"
	    },
	    domProps: {
	      "value": (_vm.entidadeUsu.cnpjExpeditionTime)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidadeUsu, "cnpjExpeditionTime", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome fantasia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "Nome fantasia"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeUsu.businessName),
	      expression: "entidadeUsu.businessName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Nome fantasia",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome fantasia",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidadeUsu.businessName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidadeUsu, "businessName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Natureza jurídica')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "Natureza jurídica"
	    }
	  }, [_vm._v("Natureza jurídica:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeUsu.legalType),
	      expression: "entidadeUsu.legalType"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Natureza jurídica",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Natureza jurídica"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.entidadeUsu, "legalType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ASSOCIAÇÃO"
	    }
	  }, [_vm._v("Associação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "COOPERATIVA"
	    }
	  }, [_vm._v("Cooperativa")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "EMPRESA_PUBLICA"
	    }
	  }, [_vm._v("Empresa pública")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "FUNDACAO"
	    }
	  }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ORGAO_PUBLICO_EXECUTIVO_ESTADUAL"
	    }
	  }, [_vm._v("Orgão público executivo estadual")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ORGAO_PUBLICO_EXECUTIVO_MUNICIPAL"
	    }
	  }, [_vm._v("Orgão público executivo municipal")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SEM_FINS_LUCRATIVOS"
	    }
	  }, [_vm._v("Sem fins lucrativos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SERVICO_SOCIAL_AUTONOMO"
	    }
	  }, [_vm._v("Serviço social autônomo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOCIEDADE_LTDA"
	    }
	  }, [_vm._v("Sociedade ltda")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOCIEDADE_POR_ACOES"
	    }
	  }, [_vm._v("Sociedade por Ações")])]), _vm._v(" "), (_vm.errors.first('Natureza jurídica')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Natureza jurídica é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Ramo atividade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "Ramo atividade"
	    }
	  }, [_vm._v("Ramo atividade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeUsu.activity),
	      expression: "entidadeUsu.activity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Ramo atividade",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Ramo atividade"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.entidadeUsu, "activity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.ramoAtividade), function(ramoAtividade) {
	    return _c('option', {
	      attrs: {
	        "label": ramoAtividade.code + ' - ' + ramoAtividade.description
	      },
	      domProps: {
	        "value": ramoAtividade
	      }
	    }, [_vm._v(_vm._s(ramoAtividade.code + ' - ' + ramoAtividade.description))])
	  }), 0), _vm._v(" "), (_vm.errors.first('Ramo atividade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Ramo atividade é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Doc. constituição')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "constitutionDocument"
	    }
	  }, [_vm._v("Doc. constituição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeUsu.constitutionDocument),
	      expression: "entidadeUsu.constitutionDocument"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Doc. constituição",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Doc. constituição"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.entidadeUsu, "constitutionDocument", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ATA_CONSTITUICAO"
	    }
	  }, [_vm._v("Ata constituição")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CONTRATO_SOCIAL"
	    }
	  }, [_vm._v("Contrato social")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ESTATUTO"
	    }
	  }, [_vm._v("Estatuto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "LEI_ORGANICA_MUNICIPAL"
	    }
	  }, [_vm._v("Lei orgânica municipal")])]), _vm._v(" "), (_vm.errors.first('Doc. constituição')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Doc. constituição é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-7",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Telefone Fixo: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    attrs: {
	      "name": "Telefone"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.entidadeUsu.contact.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.entidadeUsu.contact, "phone", $$v)
	      },
	      expression: "entidadeUsu.contact.phone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-7"
	  }, [_c('label', {
	    staticClass: "col-md-4",
	    attrs: {
	      "for": "mobile"
	    }
	  }, [_vm._v("Telefone Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    attrs: {
	      "name": "celular"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeUsu.contact.mobile),
	      expression: "entidadeUsu.contact.mobile"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) #####-#####'),
	      expression: "'(##) #####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "mobile",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidadeUsu.contact.mobile)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidadeUsu.contact, "mobile", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-7",
	    class: {
	      'has-error': _vm.errors.first('email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    attrs: {
	      "name": "email"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidadeUsu.contact.email),
	      expression: "entidadeUsu.contact.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.entidadeUsu.contact.email)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidadeUsu.contact, "email", $event.target.value)
	      }, function($event) {
	        _vm.entidadeUsu.contact.email = $event.target.value.toLowerCase()
	      }]
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.entidadeUsu.address
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.entidadeUsu.chiefs,
	      "name": "dirigentes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.entidadeUsu.documents,
	      "documentTypes": _vm.documentosObrigatorios,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1)])])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "Proposta"
	    }
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('nome da proposta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "nome da proposta"
	    }
	  }, [_vm._v("Nome do Projeto:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.name),
	      expression: "propostaSimplificada.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome da proposta",
	      "id": "nome da proposta",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome da proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da proposta')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.coordinatorName),
	      expression: "propostaSimplificada.coordinatorName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "coordinatorName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.propostaSimplificada.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "coordinatorCpf", $$v)
	      },
	      expression: "propostaSimplificada.coordinatorCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.coordinatorEmail),
	      expression: "propostaSimplificada.coordinatorEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "coordinatorPhone", $$v)
	      },
	      expression: "propostaSimplificada.coordinatorPhone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "coordinatorMobile", $$v)
	      },
	      expression: "propostaSimplificada.coordinatorMobile"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "coordinatorFax", $$v)
	      },
	      expression: "propostaSimplificada.coordinatorFax"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6",
	    attrs: {
	      "form-horizontal": ""
	    }
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.propostaSimplificada.initialDate),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "initialDate", $$v)
	      },
	      expression: "propostaSimplificada.initialDate"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.periods),
	      expression: "propostaSimplificada.periods"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "lang": "pt-br",
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Informações introdutórias")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12",
	    staticStyle: {
	      "z-index": "10"
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('presentation')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v(" Apresentação ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.presentation),
	      expression: "propostaSimplificada.presentation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "presentation",
	      "id": "presentation",
	      "rows": "5",
	      "cols": "12",
	      "placeholder": 'DESCREVA, DE FORMA SUCINTA, A ÁREA DE ATUAÇÃO E AÇÕES DESENVOLVIDAS PELA ENTIDADE.'
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "presentation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('presentation')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('presentation')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12",
	    staticStyle: {
	      "z-index": "10"
	    }
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('objetivo geral')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "objetivo geral"
	    }
	  }, [_vm._v(" Objetivo Geral ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.generalObjective),
	      expression: "propostaSimplificada.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "objetivo geral",
	      "id": "objetivo geral",
	      "rows": "5",
	      "cols": "10",
	      "placeholder": 'Defina de forma sucinta o que se pretende alcançar com o projeto. O objetivo geral deve refletir a transformação desejada pela sua organização, levando em consideração o problema apresentado e a solução proposta. Ele deve ser passível de ser alcançado por meio dos objetivos específicos e as atividades propostas. O objetivo deve ser iniciado com um verbo no infinitivo, exemplo: elevar, aprimorar, fortalecer, transformar, etc.'
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "generalObjective", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('objetivo geral')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo geral')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12",
	    staticStyle: {
	      "z-index": "10"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('resumo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "resumo"
	    }
	  }, [_vm._v(" Justificativa ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.justification),
	      expression: "propostaSimplificada.justification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justification",
	      "id": "resumo",
	      "rows": "5",
	      "cols": "10",
	      "placeholder": 'QUAL O PROBLEMA QUE A SUA ORGANIZAÇÃO QUER RESOLVER? Descreva aqui o problema que a sua organização quer solucionar. Utilize os tópicos abaixo para orientar seu texto: - Qual é a situação-problema a ser solucionado? - Quais as suas origens? - Quais os fatores sociais, políticos, ambientais e culturais que o agravam? - Quais são as consequências desse problema para a região e para o público alvo da proposta?  - Quem serão as pessoas atendidas pelo projeto?\\n\\n O QUE A SUA ORGANIZAÇÃO PRETENDE FAZER PARA SOLUCIONAR O PROBLEMA APRESENTADO?\\n\\n Descreva aqui o que a sua organização apresenta como alternativa de solução. Utilize os tópicos abaixo para orientar seu texto:\\n \\n - O quê sua instituição propõe como solução?\\n - Quais são as atividades propostas?\\n - Como as atividades propostas contribuem para a solução do problema?'
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "justification", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('resumo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resumo')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_vm._m(7), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": _vm.propostaSimplificada.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.propostaSimplificada.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": _vm.propostaSimplificada.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.propostaSimplificada.teams = $event
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.results),
	      expression: "propostaSimplificada.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "results", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.operation),
	      expression: "propostaSimplificada.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "operation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.partner),
	      expression: "propostaSimplificada.partner"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "partner", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('label', [_vm._v("Listagem de Tecnologias Sociais, conforme mencionado no campo operacionalização, acima.")]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "font-weight": "bold"
	    },
	    attrs: {
	      "target": "_blank",
	      "href": "https://projetos.fbb.org.br/docs/ListaTS.xlsx"
	    }
	  }, [_vm._v("Lista de Tecnolias Sociais")]), _vm._v(" - (Faça o download do arquivo.)\n          "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.entityIsExecutioner),
	      expression: "propostaSimplificada.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true"
	    },
	    domProps: {
	      "value": 'true',
	      "checked": _vm._q(_vm.propostaSimplificada.entityIsExecutioner, 'true')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.propostaSimplificada, "entityIsExecutioner", 'true')
	      }
	    }
	  }), _vm._v(" Sim\n                      ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.entityIsExecutioner),
	      expression: "propostaSimplificada.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false"
	    },
	    domProps: {
	      "value": 'false',
	      "checked": _vm._q(_vm.propostaSimplificada.entityIsExecutioner, 'false')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.propostaSimplificada, "entityIsExecutioner", 'false')
	      }
	    }
	  }), _vm._v(" Não\n                      ")])])]), _vm._v(" "), (_vm.propostaSimplificada.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.entityExecutingName),
	      expression: "propostaSimplificada.entityExecutingName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.entityExecutingProcurator),
	      expression: "propostaSimplificada.entityExecutingProcurator"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner|cnpj'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.propostaSimplificada.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingCNPJ", $$v)
	      },
	      expression: "propostaSimplificada.entityExecutingCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.entityExecutingEmail),
	      expression: "propostaSimplificada.entityExecutingEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner|email'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingPhone", $$v)
	      },
	      expression: "propostaSimplificada.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingMobile", $$v)
	      },
	      expression: "propostaSimplificada.entityExecutingMobile"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingFax", $$v)
	      },
	      expression: "propostaSimplificada.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingCEP", $$v)
	      },
	      expression: "propostaSimplificada.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.entityExecutingState),
	      expression: "propostaSimplificada.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.entityExecutingCity),
	      expression: "propostaSimplificada.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.entityExecutingAddress),
	      expression: "propostaSimplificada.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!propostaSimplificada.entityIsExecutioner'),
	      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(11), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.propostaSimplificada.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.propostaSimplificada.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(12), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.propostaSimplificada.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.propostaSimplificada.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.propostaSimplificada.periods,
	      "propsObjetivos": _vm.propostaSimplificada.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.propostaSimplificada.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "proposta": _vm.propostaSimplificada
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.propostaSimplificada = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(14), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.propostaSimplificada.careers
	    }
	  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "teste"
	    }
	  }, [_c('legend', [_vm._v("Declaração")]), _vm._v(" "), _c('label', [_vm._v("Preencha a Declaração com os dados da entidade proponente conforme item 12.1.2 da Chamada.")]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "font-weight": "bold"
	    },
	    attrs: {
	      "target": "_blank",
	      "href": "https://projetos.fbb.org.br/docs/declaracao.pdf"
	    }
	  }, [_vm._v("Baixar Declaração")]), _vm._v(" - (Faça o download do arquivo e após assinar, anexe no campo abaixo.)\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.propostaSimplificada.documents,
	      "documentTypes": '',
	      "documentosObrigatorios": ''
	    }
	  })], 1)])])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.conclui()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.atualiza()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Processo: ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills"
	  }, [_c('li', [_c('a', {
	    staticClass: "btn btn-flat active",
	    attrs: {
	      "id": "tabEntidade",
	      "href": "#Entidade",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v(" Entidade ")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "btn btn-flat",
	    attrs: {
	      "href": "#Proposta",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v(" Proposta ")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Entidade: ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Proposta: ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('br')])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	}]}

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.fase) + "   \n        "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }]
	  }, [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(219)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 219\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'S')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525A\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'N')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525S\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>248 - Monitoramento Administrativo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(248)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 248\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Solicitações',
	        href: '#'
	      }, {
	        text: 'Contrapartida',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [((_vm.historicoTarefasTela.length > 0 && _vm.historicoTarefasTela[1].observacao != null && _vm.historicoTarefasTela[1].observacao !== '')) ? _c('div', {
	    staticClass: "alert alert-dismissible alert-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.historicoTarefasTela[1].observacao)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Validação de Contrapartida - "), _c('i', [_c('font', {
	    attrs: {
	      "color": "black",
	      "size": "3"
	    }
	  }, [_vm._v("ID: " + _vm._s(_vm.validacao.id) + " - Projeto: ")]), _c('font', {
	    attrs: {
	      "color": "black",
	      "size": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-if": "$ctrl.approvalState != 'DEFAULT'"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmSearch",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Objetivo Geral: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.proposta.ds_objetivo_geral))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _vm._m(1)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": _vm.fase === 'Autorização'
	    }
	  }, [_c('cronograma-solicitacao-contrapartida', {
	    ref: "childComponentA",
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsProjeto": _vm.proposta.projeto,
	      "propsEtapa": _vm.etapa
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('upload-documentos-php', {
	    attrs: {
	      "propDocumentos": _vm.nota.documentos,
	      "documentTypes": '',
	      "disable": ''
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(3), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
	    key: _vm.historicoBack.length,
	    attrs: {
	      "propsValidacao": _vm.validacao,
	      "propsHistorico": _vm.historicoBack
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.dataProcesso < '10/12/2020') ? _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderHistorico === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataProcesso < '10/12/2020') ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('historico-antigo', {
	    key: _vm.historicoTarefas.length,
	    attrs: {
	      "propsValidacao": _vm.validacao,
	      "propsHistorico": _vm.historicoTarefas
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Análise deste documento para Contrapartida")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group required full",
	    class: {
	      'has-error': _vm.errors.first('resultadoAprovacao')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "resultadoAprovacao"
	    }
	  }, [_vm._v("Decisão:")]), _vm._v(" "), (_vm.etapa !== 'Revisão') ? _c('div', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Aprovado",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Aprovado")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Aprovado")
	      }
	    }
	  }), _vm._v(" Aprovar documento\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Revisão",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Revisão")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Revisão")
	      }
	    }
	  }), _vm._v(" Encaminhar para revisão\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.fase === 'Autorização') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Retornar Análise",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Retornar Análise")
	    },
	    on: {
	      "click": function($event) {
	        _vm.showJustify = 'Retonar Análise'
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Retornar Análise")
	      }
	    }
	  }), _vm._v(" Retornar para análise\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('resultadoAprovacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultadoAprovacao')))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão') ? _c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "motivo de devolucao"
	    }
	  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.motivoDevolucao),
	      expression: "motivoDevolucao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "motivo de devolucao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.motivoDevolucao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Limpar dados do motivo de devolução")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v("--------------------------------------------------------------------------")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ausência de Relatório"
	    }
	  }, [_vm._v("Ausência de Relatório")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ausência de documento - documento fiscal / holerite / ofício"
	    }
	  }, [_vm._v("Ausência de documento - documento fiscal / holerite / ofício")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ausência de fotos/imagens comprobatórias"
	    }
	  }, [_vm._v("Ausência de fotos/imagens comprobatórias")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ausência ou divergência de documentos de obra civil (termo de medição, contrato, ART ou RRT)"
	    }
	  }, [_vm._v("Ausência ou divergência de documentos de obra civil (termo de medição, contrato, ART ou RRT)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ausência ou divergência do número do acordo BNDES "
	    }
	  }, [_vm._v("Ausência ou divergência do número do acordo BNDES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Cadastro desatualizado "
	    }
	  }, [_vm._v("Cadastro desatualizado")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Comprovante de pagamento ausente, divergente ou ilegível "
	    }
	  }, [_vm._v("Comprovante de pagamento ausente, divergente ou ilegível")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Documento fiscal ilegível ou divergente"
	    }
	  }, [_vm._v("Documento fiscal ilegível ou divergente")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Existência de ocorrência impeditiva"
	    }
	  }, [_vm._v("Existência de ocorrência impeditiva")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Itens da nota fiscal divergentes do cronograma físico-financeiro"
	    }
	  }, [_vm._v("Itens da nota fiscal divergentes do cronograma físico-financeiro")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Pendência de prestação de contas"
	    }
	  }, [_vm._v("Pendência de prestação de contas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Recolhimento de tributos ausente ou divergente"
	    }
	  }, [_vm._v("Recolhimento de tributos ausente ou divergente")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Outros"
	    }
	  }, [_vm._v("Outros")])])]), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Aprovado') ? _c('div', {
	    staticClass: "form-group full",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observação"
	    }
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.validacao.glosa),
	      expression: "validacao.glosa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observação",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.validacao.glosa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.validacao, "glosa", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão' || _vm.aprovacao.resultadoAprovacao === 'Retornar Análise') ? _c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa"
	    }
	  }, [_vm._v("Motivo para revisão:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.validacao.glosa),
	      expression: "validacao.glosa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.validacao.glosa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.validacao, "glosa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [(_vm.aprovacao.resultadoAprovacao || _vm.etapa === 'Revisão') ? _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onSave($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.voltaPraSolicitacao($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa fa-info"
	  }), _vm._v("   Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('dd', [_c('span', [_vm._v("Em Execução")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos de solicitação de contrapartida")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de solicitação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico Antigo")])])
	}]}

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "contentWrapper",
	    staticClass: "content-wrapper",
	    style: ('min-height: ' + _vm.alturaContentWrapper + 'px'),
	    attrs: {
	      "id": "liquidacoes"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Geração de Remessa'
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v(" Liquidação Financeira")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Remessa',
	        href: '#'
	      }, {
	        text: 'Geração de Remessa',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content",
	    staticStyle: {
	      "padding-top": "20px"
	    }
	  }, [_c('p', {
	    staticClass: "visible-sm visible-xs nao_imprimir"
	  }, [_vm._v(" ")]), _c('p', {
	    staticClass: "visible-xs nao_imprimir"
	  }, [_vm._v(" ")]), _c('p', {
	    staticClass: "visible-xs nao_imprimir"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget nao_imprimir"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [(_vm._.isEmpty(_vm.remessa)) ? _c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar-check-o"
	  }), _vm._v(" Preparação de Remessas de Pagamento Eletrônico")]) : _c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v(" Consulta e Alteração de Remessas")])]), _vm._v(" "), _c('span', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay box box-widget",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm.loading.portadores) ? _c('div', {
	    staticClass: "col-lg-4"
	  }, [_vm._m(1)]) : _c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.portadores,
	      "multiple": false,
	      "placeholder": "Selecione um Portador",
	      "preselect-first": true,
	      "label": "DesPor",
	      "track-by": "DesPor",
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "portador",
	      "value": _vm.DesPor,
	      "disabled": !_vm._.isEmpty(_vm.remessa)
	    },
	    on: {
	      "input": _vm.portadorSelecionado
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [(props.option.CodPor === 'Cabeçalho de portador') ? _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "etiquetaPortador"
	        }, [_c('span', [_vm._v("Portador")]), _c('span', [_vm._v("Agência e Conta")])])]) : _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "etiquetaPortador"
	        }, [_c('span', [_c('strong', [_vm._v(_vm._s(props.option.CodPor))]), _c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(props.option.DesPor))])]), _c('span', {
	          staticClass: "esmaecido"
	        }, [_vm._v(_vm._s(props.option.CodPor === 'Todos' ? '' : props.option.CodAge + ' / ' + props.option.NumCco))])])])]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "etiquetaPortador"
	        }, [_c('span', [_c('strong', [_vm._v(_vm._s(props.option.CodPor))]), _c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(props.option.DesPor))])]), _c('span', {
	          staticClass: "esmaecido"
	        }, [_vm._v(_vm._s(props.option.CodPor === 'Todos' ? '' : props.option.CodAge + ' / ' + props.option.NumCco))])])]
	      }
	    }]),
	    model: {
	      value: (_vm.portador),
	      callback: function($$v) {
	        _vm.portador = $$v
	      },
	      expression: "portador"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1), _vm._v(" "), (_vm.loading.remessas) ? _c('div', {
	    staticClass: "col-lg-3"
	  }, [_vm._m(2)]) : _c('div', {
	    staticClass: "col-lg-3",
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm._.isEmpty(_vm.portador) || _vm.portador.CodPor === 'Todos' ? _vm.remessas : _vm._.filter(_vm.remessas, ['CodPor', _vm.portador.CodPor]),
	      "multiple": false,
	      "placeholder": (_vm._.isEmpty(_vm.portador) || _vm.portador.CodPor === 'Todos' ? _vm.remessas : _vm._.filter(_vm.remessas, ['CodPor', _vm.portador.CodPor])).length + ' remessa(s)',
	      "label": "NumArb",
	      "track-by": "NumArb",
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "numero da remessa",
	      "value": _vm.NumArb
	    },
	    on: {
	      "input": _vm.remessaSelecionada
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [(props.option.CodPor === 'Cabeçalho de remessa') ? _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "etiquetaPortador"
	        }, [_c('span', [_vm._v("Portador")]), _c('span', [_vm._v("Remessa")]), _c('span', [_vm._v("Pagto.")]), _c('span', [_vm._v("Títulos")])])]) : _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "etiquetaRemessa"
	        }, [_c('span', {
	          staticClass: "text-muted"
	        }, [_vm._v(" " + _vm._s(props.option.CodPor))]), _vm._v(" "), _c('span', {
	          staticClass: "text-bold"
	        }, [_vm._v(_vm._s(props.option.NumArb))]), _vm._v(" "), _c('span', {
	          staticClass: "text-muted"
	        }, [_vm._v(_vm._s(props.option.DatPgt))]), _vm._v(" "), _c('span', {
	          staticClass: "contadorRegistros",
	          domProps: {
	            "innerHTML": _vm._s(props.option.QtdeRegistros)
	          }
	        })])])]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "etiquetaRemessa"
	        }, [_c('span', {
	          staticClass: "text-muted"
	        }, [_vm._v(" " + _vm._s(props.option.CodPor))]), _vm._v(" "), _c('span', {
	          staticClass: "text-bold"
	        }, [_vm._v(_vm._s(props.option.NumArb))]), _vm._v(" "), _c('span', {
	          staticClass: "text-muted"
	        }, [_vm._v(_vm._s(props.option.DatPgt))]), _vm._v(" "), _c('span', {
	          staticClass: "contadorRegistros",
	          domProps: {
	            "innerHTML": _vm._s(props.option.QtdeRegistros)
	          }
	        })])]
	      }
	    }]),
	    model: {
	      value: (_vm.remessa),
	      callback: function($$v) {
	        _vm.remessa = $$v
	      },
	      expression: "remessa"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (!_vm._.isEmpty(_vm.remessa)) ? _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    staticStyle: {
	      "height": "40px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.remessa = [];
	        _vm.remessaSelecionada()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-5"
	  }, [(_vm._.isEmpty(_vm.remessa)) ? _c('span', [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5>Procura títulos em aberto para compor nova remessa</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.buscarTitulos(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Buscar Títulos")]), _vm._v(" "), ((!_vm._.isEmpty(_vm.titulos) && _vm.filtroTituloAprovado) || (_vm.listaVazia && _vm.filtroTituloAprovado)) ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Mostra títulos Não-Aprovados</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.consultaNaoAprovados()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle"
	  }), _vm._v(" Mostrar Não Aprovados")]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.titulos) && _vm.filtroTituloAprovado == false) ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5>Limpa filtro de títulos Não-Aprovados</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.limparFiltros()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  }), _vm._v(" Limpar Filtro")]) : _vm._e(), _vm._v(" "), (_vm.titulos.length > 0 && _vm.titulosSelecionados.length > 0 && _vm._.isEmpty(_vm.remessa) && _vm.processamentoRemessa.length === 0 && _vm._.isEmpty(_vm.tituloEditando)) ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5>Cria arquivo(s) de remessa com <span class=\'realce\'>' + _vm.titulosSelecionados.length + '</span> item(ns) selecionado(s) abaixo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gerarRemessa()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gear"
	  }), _vm._v(" Gerar Remessas")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.remessa) && !_vm.loading.remessas) ? _c('span', [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Consultar a remessa <span class=\'realce\'>' + _vm.remessa.NumArb + '</span> e mostra seu conteúdo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.buscarTitulos(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Consulta Remessa")]), _vm._v(" "), (_vm.titulos.length > 0 && _vm.processamentoRemessa.length === 0) ? _c('span', [(_vm.titulosSelecionados.length === 0) ? _c('span', [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss",
	      "title": '<h5>Excluirá a remessa <span class=\'realce\'>' + _vm.remessa.NumArb + '</span></h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gerarRemessa()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  }), _vm._v(" Excluir Remessa")])], 1) : _c('span', [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Altera a remessa <span class=\'realce\'>' + _vm.remessa.NumArb + '</span> que conterá o(s) <span class=\'realce\'>' + _vm.titulosSelecionados.length + '</span> item(ns) selecionado(s) abaixo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gerarRemessa()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" Alterar Remessa")])], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "pull-right",
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [(!_vm._.isEmpty(_vm.remessa)) ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5>Gerar PDF do relatório 130 da remessa <span class=\'realce\'>' + _vm.remessa.NumArb + '</span></h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir130(_vm.remessa.CodPor, _vm.remessa.NumArb)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print"
	  }), _vm._v(" Relatório 130")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm.titulos.length > 0 && _vm.titulosSelecionados.length > 0) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Baixar <span class=\'realce\'>' + _vm.titulosSelecionados.length + '</span> item(ns) selecionado(s) em Excel</h5>'
	    }
	  }, [_c('download-excel', {
	    attrs: {
	      "data": _vm.titulosSelecionados,
	      "meta": _vm.excelMeta,
	      "fields": _vm.processamentoRemessa.length > 0 ? _vm._.assign(_vm.excelCampos.basico, _vm.excelCampos.posProcessamento) : _vm.excelCampos.basico,
	      "type": "xls",
	      "name": "Títulos Selecionados.xls"
	    }
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Baixar planilha")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.titulos.length > 0) ? _c('div', {
	    staticClass: "col-lg-12"
	  }, [_c('div', {
	    staticClass: "col-lg-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-2"
	  }, [_c('span', {
	    staticClass: "indicadores-cb-inline",
	    attrs: {
	      "disabled": _vm.loading.tela
	    }
	  }, [(_vm.processamentoRemessa.length === 0) ? _c('div', [_c('i', {
	    class: (_vm._.filter(_vm.titulos, function(t) {
	      return !_vm._.isEmpty(t.numcco) && !_vm._.isEmpty(t.tippgt)
	    }).length === _vm.titulosSelecionados.length && _vm.titulos.length > 0 ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.selecionarTodosItens(!(_vm._.filter(_vm.titulos, function(t) {
	          return !_vm._.isEmpty(t.numcco) && !_vm._.isEmpty(t.tippgt)
	        }).length === _vm.titulosSelecionados.length && _vm.titulos.length > 0))
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm._.filter(_vm.titulos, function(t) {
	      return !_vm._.isEmpty(t.numcco) && !_vm._.isEmpty(t.tippgt)
	    }).length === _vm.titulosSelecionados.length && _vm.titulos.length > 0 ? 'selecionado' : ''
	  }, [_vm._v("Selecionar tudo ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-2"
	  }, [(_vm.titulosSelecionados.length > 0 && _vm.processamentoRemessa.length === 0) ? _c('span', {
	    staticClass: "esmaecido"
	  }, [_c('span', {
	    staticStyle: {
	      "color": "var(--cor-azul)",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.titulosSelecionados.length))]), _vm._v(" selecionado" + _vm._s(_vm.titulosSelecionados.length > 1 ? 's' : '') + " de ")]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.titulos.length))]), _vm._v(" "), _c('span', {
	    staticClass: "esmaecido"
	  }, [_vm._v(" títulos")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3"
	  }, [(_vm.titulosSelecionados.length > 0 && _vm.processamentoRemessa.length === 0) ? _c('span', {
	    staticClass: "esmaecido"
	  }, [_c('span', {
	    staticStyle: {
	      "color": "var(--cor-azul)",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm.titulosSelecionados, function(titulo) {
	    return _vm._.toNumber(titulo.vlrliq)
	  }))))]), _vm._v(" do ")]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "esmaecido"
	  }, [_vm._v("Total líquido ")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm.titulos, function(titulo) {
	    return _vm._.toNumber(titulo.vlrliq)
	  }))))])]), _vm._v(" "), (_vm.titulosSelecionados.length > 0 && _vm.processamentoRemessa.length === 0) ? _c('div', {
	    staticClass: "col-lg-2"
	  }, [_c('div', {
	    staticClass: "btn-group dropdown"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('span', {
	    staticClass: "esmaecido",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("\n                    Previsão de "), _c('span', {
	    staticStyle: {
	      "color": "var(--cor-azul)",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s((_vm._.keys(_vm._.groupBy(_vm.titulosSelecionados, _vm.chaveRemessa))).length))]), _vm._v("\n                    remessa(s) "), _c('i', {
	    staticClass: "fa fa-exclamation-circle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu"
	  }, [_c('table', {
	    staticClass: "table table-striped",
	    staticStyle: {
	      "width": "400px"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm._.values(_vm._.groupBy(_vm.titulosSelecionados, _vm.chaveRemessa))), function(remessa) {
	    return _c('tr', {
	      attrs: {
	        "role": "menuitem"
	      }
	    }, [_c('td', [_vm._v(_vm._s(remessa[0].numcco))]), _c('td', [_vm._v(_vm._s(remessa[0].tippgt))]), _c('td', [_vm._v(_vm._s(remessa.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(remessa, function(t) {
	      return _vm._.toNumber(t.vlrliq)
	    }))))])])
	  }), 0)])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 pull-right"
	  }, [_c('span', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ordenacao.por),
	      expression: "ordenacao.por"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "auto",
	      "float": "left"
	    },
	    attrs: {
	      "title": '<h5>Selecione por qual critério deseja ordenar</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.ordenacao, "por", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "id"
	    }
	  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "tippgt"
	    }
	  }, [_vm._v("Tipo de Pagamento")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "vlrliq"
	    }
	  }, [_vm._v("Valor Líquido")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "numtit"
	    }
	  }, [_vm._v("Número do Título")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "codtpt"
	    }
	  }, [_vm._v("Tipo do Título")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "codfpg"
	    }
	  }, [_vm._v("Forma de Pagamento")])]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "btn btn-default btn-flat",
	    staticStyle: {
	      "float": "left"
	    },
	    attrs: {
	      "type": "button",
	      "title": '<h5>Clique para inverter a ordenação</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.ordenacao.ordem = _vm.ordenacao.ordem === 'asc' ? 'desc' : 'asc'
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-sort-alpha-' + _vm.ordenacao.ordem,
	    staticStyle: {
	      "font-size": "14px"
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processamentoRemessa.length > 0) ? _c('span', [_vm._m(4), _vm._v(" "), _vm._l((_vm.processamentoRemessa), function(remessa) {
	    return _c('span', {
	      staticClass: "row"
	    }, [(!_vm._.isNull(remessa.erroExecucao)) ? _c('span', [_c('div', {
	      staticClass: "col-lg-12"
	    }, [_c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v(_vm._s(remessa.erroExecucao))])])]) : (_vm._.get(remessa, 'retorno[0].tipRet')) ? _c('span', [_c('div', {
	      staticClass: "col-lg-2"
	    }, [(remessa.remessa === 0) ? _c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v(" Remessa não gerada")]) : _vm._e(), _vm._v(" "), (remessa.remessa > 0 && (_vm._.filter(remessa.retorno, ['tipRet', 2])).length === 0) ? _c('span', {
	      staticClass: "label label-success"
	    }, [_vm._v(" Remessa " + _vm._s(_vm._.isEmpty(remessa) ? 'gerada' : 'alterada') + " com sucesso ")]) : _vm._e(), _vm._v(" "), (remessa.remessa > 0 && (_vm._.filter(remessa.retorno, ['tipRet', 2])).length > 0) ? _c('span', {
	      staticClass: "label label-warning"
	    }, [_vm._v(" Remessa gerada com erros")]) : _vm._e()]), _vm._v(" "), _c('span', {
	      class: remessa.remessa === 0 || (remessa.remessa > 0 && (_vm._.filter(remessa.retorno, ['tipRet', 2])).length > 0) ? 'esmaecido' : ''
	    }, [_c('div', {
	      staticClass: "col-lg-1"
	    }, [_vm._v("Portador: "), _c('b', [_vm._v(_vm._s(remessa.portador.CodPor))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1"
	    }, [_vm._v("Remessa: "), _c('b', [_vm._v(_vm._s(remessa.remessa))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1"
	    }, [_c('div', {
	      staticClass: "contadorRegistros"
	    }, [_vm._v(_vm._s(remessa.retorno.length))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-7"
	    }, [_vm._v("Arquivo: "), _c('b', [_vm._v(_vm._s(_vm._.isNull(remessa.arquivoGerado) ? 'nenhum' : remessa.arquivoGerado))])])])]) : _vm._e()])
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-lg-12"
	  }, _vm._l((_vm.ordenacao.por === 'vlrliq' ?
	    _vm._.orderBy(_vm.titulos, [function(termo) {
	      return parseFloat(termo[_vm.ordenacao.por])
	    }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
	    _vm._.orderBy(_vm.titulos, [_vm.ordenacao.por], [_vm.ordenacao.ordem])), function(titulo) {
	    return _c('div', {
	      class: 'row tarefa ' +
	        (_vm._.has(titulo, 'processamento.tipRet') ? ' retornoProcessamento' + _vm._.get(titulo, 'processamento.tipRet', '') : (_vm._.find(_vm.titulosSelecionados, function(sel) {
	          return sel.numtit + sel.codtpt + sel.codfor === titulo.numtit + titulo.codtpt + titulo.codfor
	        }) ? 'selecionada' : ''))
	    }, [_c('div', {
	      staticClass: "col-lg-1 col-md-1 col-sm-1 col-xs-1",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('span', {
	      staticClass: "indicadores"
	    }, [(!_vm._.isEmpty(titulo.numcco) && !_vm._.isEmpty(titulo.tippgt)) ? _c('span', [(_vm._.get(titulo, 'processamento.tipRet', '') === 1) ? _c('span', {
	      staticClass: "label label-success"
	    }, [_vm._v(_vm._s(titulo.processamento.remessa))]) : (_vm.processamentoRemessa.length === 0) ? _c('span', [_c('i', {
	      staticClass: "nao_imprimir",
	      class: (_vm._.find(_vm.titulosSelecionados, function(sel) {
	        return sel.numtit + sel.codtpt + sel.codfor === titulo.numtit + titulo.codtpt + titulo.codfor
	      }) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' selecao',
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selecionarItem(titulo)
	        }
	      }
	    })]) : _vm._e()]) : _c('span', [_c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-exclamation-triangle",
	      staticStyle: {
	        "color": "var(--cor-atencao-light)"
	      },
	      attrs: {
	        "title": '<h5>' + (_vm._.isEmpty(_vm.remessa) ? 'Não pode incluir na remessa título' : 'Nesta remessa esse título está') + ' sem conta ou sem tipo de pagamento</h5>'
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "text-muted"
	    }, [_vm._v(_vm._s(titulo.id))]), _vm._v(" "), _c('p', {
	      staticClass: "truncar",
	      class: titulo.situacao === 'EM_EXECUCAO' ? 'text-green' : 'text-blue'
	    }, [_vm._v(_vm._s(_vm.enumeradores[titulo.situacao]))])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-3 col-md-10 col-sm-10 col-xs-10",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('div', {
	      staticClass: "projeto truncar"
	    }, [_vm._v(_vm._s(titulo.numprj) + " - " + _vm._s(titulo.nomprj))]), _vm._v(" "), _c('div', {
	      staticClass: "fornecedor truncar"
	    }, [_vm._v(_vm._s(titulo.codfor) + " - " + _vm._s(titulo.nomfor))])]), _vm._v(" "), _c('div', {
	      staticClass: "visible-xs col-xs-2",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('span', [_vm._v(_vm._s(titulo.numtit))]), _vm._v(" "), (_vm._.get(titulo, 'datapr', '1900').substring(0, 4) === '1900') ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      attrs: {
	        "title": '<h5>Título não aprovado</h5>'
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-exclamation-triangle",
	      staticStyle: {
	        "color": "var(--cor-alerta-light)"
	      }
	    })]) : _vm._e(), _vm._v(" "), (titulo.remessaAnterior === 'SIM' && _vm._.isEmpty(_vm.remessa)) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      attrs: {
	        "title": '<h5>(!)Passou por remessa anteriormente</h5>'
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-exclamation-circle",
	      staticStyle: {
	        "color": "var(--cor-destaque)"
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(titulo.codtpt))]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(titulo.codfor))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3",
	      staticStyle: {
	        "height": "46px",
	        "display": "flex",
	        "align-items": "center"
	      }
	    }, [(!_vm._.isEmpty(_vm.remessa)) ? _c('span', [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay:[500, 0]}"
	      }],
	      attrs: {
	        "title": '<h5>' + (_vm.tiposPagamento.principais[titulo.tippgt] || _vm.tiposPagamento.outros[titulo.tippgt]) + '</h5>'
	      }
	    }, [_vm._v(_vm._s(titulo.tippgt))])]) : _c('span', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (titulo.tippgt),
	        expression: "titulo.tippgt"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay:[500, 0]}"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "disabled": _vm.processamentoRemessa.length > 0 || !_vm._.isEmpty(_vm.tituloEditando),
	        "title": '<h5>' + (_vm.tiposPagamento.principais[titulo.tippgt] || _vm.tiposPagamento.outros[titulo.tippgt]) + '</h5>'
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(titulo, "tippgt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, [_vm._l((_vm.tiposPagamento.principais), function(descricao, codigo) {
	      return _c('option', {
	        domProps: {
	          "value": codigo
	        }
	      }, [_vm._v(_vm._s(codigo) + " - " + _vm._s(descricao))])
	    }), _vm._v(" "), _c('option', {
	      staticClass: "bg-gray",
	      attrs: {
	        "disabled": ""
	      },
	      domProps: {
	        "value": null
	      }
	    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.tiposPagamento.outros), function(descricao, codigo) {
	      return _c('option', {
	        domProps: {
	          "value": codigo
	        }
	      }, [_vm._v(_vm._s(codigo) + " - " + _vm._s(descricao))])
	    })], 2)])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [(!_vm._.includes(['AMT', 'AMP', 'MIS', 'MIX'], titulo.codtpt)) ? _c('span', {
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.processamentoRemessa.length === 0 ? _vm.editaTituloParaRemessa(titulo) : false
	        }
	      }
	    }, [(_vm._.isNull(titulo.numcco)) ? _c('span', {
	      staticClass: "label label-danger"
	    }, [_c('i', {
	      staticClass: "fa fa-pencil"
	    }), _vm._v(" sem conta")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(titulo.numcco)) ? _c('span', {
	      staticClass: "link_acesso",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.processamentoRemessa.length === 0 ? _vm.editaTituloParaRemessa(titulo) : false
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil"
	    }), _vm._v(" " + _vm._s(titulo.numcco))]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(titulo.numcco))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(titulo.usu_mci))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-5",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [(('' + titulo.codfpg) === '4' || _vm._.isNull(titulo.codfpg)) ? _c('div', {
	      staticClass: "truncar"
	    }, [_c('span', {
	      class: _vm.processamentoRemessa.length === 0 ? 'link_acesso' : '',
	      on: {
	        "click": function($event) {
	          _vm.processamentoRemessa.length === 0 ? _vm.editaTituloParaRemessa(titulo) : false
	        }
	      }
	    }, [(_vm._.get(titulo, 'boleto.sucesso', false)) ? _c('span', [_c('i', {
	      staticClass: "fa fa-pencil"
	    }), _vm._v(" " + _vm._s(titulo.boleto.linhaDigitavel))]) : _c('span', {
	      staticClass: "label label-danger"
	    }, [_c('i', {
	      staticClass: "fa fa-pencil"
	    }), _vm._v(" sem código de barras")])])]) : _c('div', [_vm._v(_vm._s(titulo.codban) + " "), _c('span', {
	      staticClass: "esmaecido"
	    }, [_vm._v("/")]), _vm._v(" " + _vm._s(titulo.codage) + " "), _c('span', {
	      staticClass: "esmaecido"
	    }, [_vm._v("/")]), _vm._v(" " + _vm._s(titulo.ccbfor))]), _vm._v(" "), _c('div', {
	      staticClass: "truncar"
	    }, [_vm._v(_vm._s(titulo.codfpg) + " - " + _vm._s(titulo.desfpg))])]), _vm._v(" "), _c('div', {
	      staticClass: "visible-xs col-xs-2",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3",
	      staticStyle: {
	        "height": "46px"
	      }
	    }, [_c('span', {
	      staticClass: "text-muted"
	    }, [_vm._v(_vm._s(_vm._f("real")(titulo.vlrori)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("real")(titulo.vlrliq)))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-1 col-md-1 col-sm-1 col-xs-3 text-right",
	      staticStyle: {
	        "height": "46px",
	        "padding": "2px 0"
	      }
	    }, [(!_vm._.isNull(titulo.id) && _vm._.isEmpty(_vm.tituloEditando)) ? _c('span', [(titulo.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss",
	        "title": '<h5>Assumir e Fazer</h5>'
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.atribuirFazer(titulo)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]) : _c('g-button-ujarak', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss",
	        "title": '<h5>Está ' + _vm.enumeradores[titulo.situacao] + '. Clique para ' + (titulo.situacao === 'EM_EXECUCAO' ? 'Reanalisar' : 'Reativar') + ' este processo e devolver para Análise ' + (!_vm._.isNull(titulo.numarb) ? '(será retirado desta remessa ' + titulo.numarb + ')' : '') + '</h5>'
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.segueReanalisarOuReativar(titulo.situacao, titulo.id, titulo)
	        }
	      }
	    }, [_c('i', {
	      class: 'fa fa-' + (titulo.situacao === 'EM_EXECUCAO' ? 'undo' : 'play'),
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])], 1) : _vm._e()]), _vm._v(" "), (!_vm._.isEmpty(_vm.tituloEditando) && (_vm.tituloEditando.numtit + _vm.tituloEditando.codtpt + _vm.tituloEditando.codfor === titulo.numtit + titulo.codtpt + titulo.codfor)) ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('div', {
	      staticClass: "box-body well form-horizontal"
	    }, [(('' + _vm.tituloEditando.codfpg) === '4' || _vm._.isNull(_vm.tituloEditando.codfpg)) ? _c('div', {
	      staticClass: "form-group required-field",
	      class: {
	        'has-error': _vm.errors.first('código de barras')
	      }
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Código de Barras:")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-5"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.tituloEditando.boleto.numeroInformadoTela),
	        expression: "tituloEditando.boleto.numeroInformadoTela"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "name": "código de barras"
	      },
	      domProps: {
	        "value": (_vm.tituloEditando.boleto.numeroInformadoTela)
	      },
	      on: {
	        "keyup": _vm.validaAjustaCodigoBarras,
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.tituloEditando.boleto, "numeroInformadoTela", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (_vm.errors.first('código de barras')) ? _c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v(_vm._s(_vm.errors.first('código de barras')))]) : (_vm.tituloEditando.boleto.sucesso) ? _c('span', {
	      staticClass: "label label-success"
	    }, [_vm._v("\n                          " + _vm._s(_vm._.capitalize((_vm.tituloEditando.boleto.tipoCodigoInput + ' de ' + _vm.tituloEditando.boleto.tipoBoleto).replaceAll('_', ' ')) + ' correto!') + "\n                        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "form-group required-field",
	      class: {
	        'has-error': _vm.errors.first('conta')
	      }
	    }, [_c('label', {
	      staticClass: "control-label col-md-2"
	    }, [_vm._v("Conta:")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2"
	    }, [_c('multiselect', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      attrs: {
	        "options": _vm._.map(_vm._.filter(_vm.portadores, function(p) {
	          return p.CodPor !== 'Todos'
	        }), 'NumCco'),
	        "placeholder": "Selecione uma conta",
	        "selectLabel": "",
	        "deselectLabel": "",
	        "selectedLabel": "",
	        "name": "conta"
	      },
	      model: {
	        value: (_vm.tituloEditando.numcco),
	        callback: function($$v) {
	          _vm.$set(_vm.tituloEditando, "numcco", $$v)
	        },
	        expression: "tituloEditando.numcco"
	      }
	    }, [_c('template', {
	      slot: "noResult"
	    }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('conta')) ? _c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v(_vm._s(_vm.errors.first('conta')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "form-group"
	    }, [_c('div', {
	      staticClass: "col-md-10 col-md-offset-2"
	    }, [_c('button', {
	      staticClass: "btn btn-confirm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.salvaEdicaoTituloParaRemessa()
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-check",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-back btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.cancelaEdicaoTituloParaRemessa()
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), (_vm._.get(titulo, 'processamento.tipRet', '') === 2) ? _c('div', {
	      staticClass: "box-body"
	    }, _vm._l((_vm._.get(titulo, 'processamento.detalhes', [])), function(detalhe) {
	      return _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(_vm._s(detalhe.msgRet)), _c('br')])
	    }), 0) : _vm._e()])
	  }), 0)])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "w100 imprimir"
	  }, [_c('tr', [_c('td', [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "direita"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "40px !important"
	    }
	  }, [_vm._v("Títulos Diversos")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Portadores...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Remessas...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('th', [_vm._v("Conta")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Títulos")]), _c('th', [_vm._v("Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-lg-12"
	  }, [_c('hr')])
	}]}

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.form.errors.any()) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [(_vm.dismissible) ? _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": _vm.dismiss
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.message)
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.form.errors.flatten()), function(error) {
	    return _c('li', {
	      domProps: {
	        "innerHTML": _vm._s(error)
	      }
	    })
	  }), 0)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-box"
	  }, [_c('div', {
	    staticClass: "login-logo yellow-bg"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "login-box-body"
	  }, [_c('p', {
	    staticClass: "login-box-msg"
	  }, [_vm._v("Lembrar senha")]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onValidate($event)
	      }
	    }
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.form.errors.has('ds_login')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.ds_login),
	      expression: "form.ds_login"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Informe seu Login ou E-mail",
	      "name": "login"
	    },
	    domProps: {
	      "value": (_vm.form.ds_login)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "ds_login", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('has-error', {
	    attrs: {
	      "form": _vm.form,
	      "field": "ds_login"
	    }
	  }), _vm._v(" "), (_vm.errors.first('login')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('login')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-block btn-flat",
	    attrs: {
	      "disabled": _vm.form.busy,
	      "type": "submit"
	    }
	  }, [_vm._v("Recuperar senha")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "id": "login",
	      "href": "/"
	    }
	  }, [_vm._v("Voltar para Login")])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Deferimento',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": true
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ng-init": "check()"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.simplified),
	      expression: "proposta.simplified"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "hidden",
	      "name": "tipo",
	      "id": "tipo",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.proposta.simplified)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "simplified", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('NAME')"
	    }
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.idProjectErp),
	      expression: "proposta.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.name),
	      expression: "proposta.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorName),
	      expression: "proposta.coordinatorName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorCpf", $$v)
	      },
	      expression: "proposta.coordinatorCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorEmail),
	      expression: "proposta.coordinatorEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorPhone", $$v)
	      },
	      expression: "proposta.coordinatorPhone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorMobile", $$v)
	      },
	      expression: "proposta.coordinatorMobile"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Fax')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorFax", $$v)
	      },
	      expression: "proposta.coordinatorFax"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Fax')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.proposta.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                      " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                      " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                    ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial aqui")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.initialDate),
	      expression: "proposta.initialDate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control",
	      "type": "date",
	      "format": "DD/MM/YYYY",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.proposta.initialDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "initialDate", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periods),
	      expression: "proposta.periods"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.proposta.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.introduction),
	      expression: "proposta.introduction"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "introduction", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.presentation),
	      expression: "proposta.presentation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.territory),
	      expression: "proposta.territory"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.justification),
	      expression: "proposta.justification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.generalObjective),
	      expression: "proposta.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.summary),
	      expression: "proposta.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": this.proposta.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": this.proposta.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.teams = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.results),
	      expression: "proposta.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "results", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.operation),
	      expression: "proposta.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "operation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.partner),
	      expression: "proposta.partner"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "partner", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.proposta.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.proposta.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                ")])])]), _vm._v(" "), (_vm.proposta.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingName),
	      expression: "proposta.entityExecutingName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingProcurator),
	      expression: "proposta.entityExecutingProcurator"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|cnpj'),
	      expression: "'required:!proposta.entityIsExecutioner|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCNPJ", $$v)
	      },
	      expression: "proposta.entityExecutingCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingEmail),
	      expression: "proposta.entityExecutingEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|email'),
	      expression: "'required:!proposta.entityIsExecutioner|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingPhone", $$v)
	      },
	      expression: "proposta.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingMobile", $$v)
	      },
	      expression: "proposta.entityExecutingMobile"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingFax", $$v)
	      },
	      expression: "proposta.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.duplicateProject),
	      expression: "proposta.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber) + "/" + _vm._s(projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(7), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(9), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraCronograma),
	      expression: "mostraCronograma"
	    }],
	    staticClass: "col-md-12"
	  }, [_vm._m(10), _vm._v(" "), _c('cronograma', {
	    attrs: {
	      "proposta": _vm.proposta,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades,
	      "meses": _vm.proposta.periods,
	      "projeto-duplicacao": _vm.proposta.duplicateProject
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('gantt', {
	    attrs: {
	      "periodo": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades
	    }
	  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "proposta": _vm.proposta
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(12), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.careers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('solenizacao', {
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.proposta.solemnizations = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(14), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documents,
	      "documentTypes": _vm.proposta.documentTypes,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(15), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documentStatements,
	      "documentTypes": [],
	      "documentosObrigatorios": []
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(16), _vm._v(" "), _c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta
	    }
	  })], 1)])]), _vm._v(" "), _c('deferimento', {
	    attrs: {
	      "propsAnalise": _vm.analise
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                          outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	}]}

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'lista-ratificacao'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Todas as ratificações ")]), _vm._v(" "), _c('span', [_vm._v("Ratificações pendentes")])], 1), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Remessa',
	        href: '#'
	      }, {
	        text: 'Lista de Ratificações',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaRatificacoes"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.listaRatificacoes,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.filtrar,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "id_processo",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "nome",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "data_solicitacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
	      }
	    }, {
	      key: "situacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "assinatura",
	      fn: function(row) {
	        return _vm._l((row.value), function(item) {
	          return _c('span', {
	            staticStyle: {
	              "color": "#0073b7"
	            }
	          }, [_c('p', {
	            staticStyle: {
	              "line-height": "10px"
	            }
	          }, [_vm._v(_vm._s(item))])])
	        })
	      }
	    }, {
	      key: "ultima_tarefa",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
	      }
	    }, {
	      key: "resultado",
	      fn: function(row) {
	        return [(_vm.ehDoUsuario) ? _c('span', [(_vm._.includes(row.value, 'Sim')) ? _c('span', [_c('i', {
	          staticClass: "fa fa-check text-green",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Aprovado")]) : (_vm._.includes(row.value, 'Nao')) ? _c('span', [_c('i', {
	          staticClass: "fa fa-times text-red",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("Não aprovado")]) : _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v("Pendente")])]) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('span', [(row.item.ultima_tarefa === 'CONCLUSAO') ? _c('span', {
	          staticStyle: {
	            "color": "green"
	          }
	        }, [_vm._v("Aguarda conclusão"), _c('br'), _vm._v(_vm._s(row.value) + " assinatura(s)")]) : (row.item.ultima_tarefa === 'ASSINATURA_RATIFICACAO') ? _c('span', {
	          staticStyle: {
	            "color": "royalblue"
	          }
	        }, [_vm._v("Aguarda assinatura"), _c('br'), _vm._v(_vm._s(row.value) + " assinado(s)")]) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.item.ultima_tarefa]))])]) : _c('span', [_vm._v(" ")])])]
	      }
	    }, {
	      key: "acoes",
	      fn: function(row) {
	        return [_c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo,
	                  assinar: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar\n                          ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(row.item.resultado)) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-ratificacao',
	                params: {
	                  id: row.item.id_processo,
	                  visualizacao: true,
	                  assinar: true
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar\n                          ")]) : _vm._e()], 1)]
	      }
	    }])
	  })], 1)], 1)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Em execução")])])
	}]}

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "qre",
	    class: 'qre--' + _vm.tom,
	    attrs: {
	      "role": "status"
	    }
	  }, [_c('p', {
	    staticClass: "qre-titulo"
	  }, [_c('i', {
	    staticClass: "fa",
	    class: _vm.icone,
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n    " + _vm._s(_vm.titulo) + "\n  ")]), _vm._v(" "), (_vm.situacao === 'erro') ? _c('p', {
	    staticClass: "qre-texto"
	  }, [_vm._v("Confira as ocorrências da entidade no Sapiens antes de responder a regularidade.")]) : _vm._e(), _vm._v(" "), (_vm.situacao === 'concluida' && _vm.total > 0) ? _c('ul', {
	    staticClass: "qre-lista"
	  }, [_vm._l((_vm.entidade), function(ocorrencia, i) {
	    return _c('li', {
	      key: 'e' + i
	    }, [_c('span', {
	      staticClass: "qre-origem"
	    }, [_vm._v("Entidade")]), _vm._v("\n      " + _vm._s(ocorrencia.codoco) + " - " + _vm._s(ocorrencia.desroc) + "\n      "), (ocorrencia.datger) ? _c('span', {
	      staticClass: "qre-data"
	    }, [_vm._v("desde " + _vm._s(_vm._f("moment")(ocorrencia.datger, 'L')))]) : _vm._e()])
	  }), _vm._v(" "), _vm._l((_vm.projetos), function(ocorrencia, i) {
	    return _c('li', {
	      key: 'p' + i
	    }, [_c('span', {
	      staticClass: "qre-origem"
	    }, [_vm._v("Projeto " + _vm._s(ocorrencia.numprj))]), _vm._v("\n      " + _vm._s(ocorrencia.codoco) + " - " + _vm._s(ocorrencia.desroc) + "\n      "), (ocorrencia.datger) ? _c('span', {
	      staticClass: "qre-data"
	    }, [_vm._v("desde " + _vm._s(_vm._f("moment")(ocorrencia.datger, 'L')))]) : _vm._e()])
	  })], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": '<h5>Ir para Metas</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": _vm.irMetas
	    }
	  }, [_c('i', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Metas")])]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": '<h5>Ir para Atividades</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": _vm.irAtividades
	    }
	  }, [_c('i', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Atividades")])]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": '<h5>Ir para Relatórios de Execução deste projeto</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'visualiza-relatorio-execucao',
	          params: {
	            id: _vm.projeto.proposta.projeto.id
	          }
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar-check-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Relatórios")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4",
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "disabled": _vm.contador === 0,
	      "title": '<h5>Salvar</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": _vm.salvar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Salvar")])]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "title": '<h5>Novo registro</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": [function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }, function($event) {
	        $event.stopPropagation();
	        return _vm.onNew($event)
	      }]
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Novo registro")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "tabelaAcompanhamento",
	    attrs: {
	      "id": "tabelaAcompanhamento",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "row-clicked": _vm.linha
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('div', [_c('button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")])])])]
	      }
	    }, {
	      key: "tipo",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(row.value.descricao) + "\n                  "), (row.item.situacao_descricao) ? _c('p', {
	          staticClass: "situacao_ocorrencia_sapiens"
	        }, [_vm._v(_vm._s(row.item.situacao_descricao))]) : _vm._e()])]
	      }
	    }, {
	      key: "status",
	      fn: function(row) {
	        return [(row.item.tipo.codigo === 'OCORRENCIA_IMPEDITIVA') ? _c('span', [_vm._v(_vm._s(row.item.tipo_ocorrencia.descricao))]) : _c('span', [_vm._v(_vm._s(row.value.descricao))])]
	      }
	    }, {
	      key: "responsavel.ds_nome_usuario",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(row.value))])]
	      }
	    }, {
	      key: "documentos",
	      fn: function(row) {
	        return [(row.item.documentos.length > 0) ? _c('i', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }],
	          staticClass: "glyphicon glyphicon-duplicate",
	          staticStyle: {
	            "font-size": "large"
	          },
	          attrs: {
	            "title": '<h5>Existe(m) ' + '<b>' + row.item.documentos.length + '</b>' + ' documento(s) em anexo. Clique em editar para visualizar o(s) documento(s).</h5>',
	            "aria-en": "true"
	          }
	        }) : _vm._e()]
	      }
	    }, {
	      key: "detalhamento",
	      fn: function(row) {
	        return [_c('span', {
	          domProps: {
	            "innerHTML": _vm._s(row.value)
	          }
	        })]
	      }
	    }, {
	      key: "dt_registro",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "prazo",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }], null, false, 2589171187)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    ref: "form",
	    staticClass: "form-horizontal row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "margin": "0px"
	    },
	    attrs: {
	      "name": "frmAddAc"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('data')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "data"
	    }
	  }, [_vm._v("Data:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [(_vm.acompanhamento.id) ? _c('div', [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "data",
	    attrs: {
	      "name": "data",
	      "input-class": "form-control",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "placeholder": "__ /__ /____",
	      "disabled": _vm.acompanhamento.id,
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.acompanhamento.dt_registro),
	      callback: function($$v) {
	        _vm.$set(_vm.acompanhamento, "dt_registro", $$v)
	      },
	      expression: "acompanhamento.dt_registro"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.acompanhamento.id) ? _c('div', [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "data",
	    attrs: {
	      "name": "data",
	      "input-class": "form-control",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "placeholder": "__ /__ /____",
	      "disabled": true,
	      "highlighted": _vm.highlighted,
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.acompanhamento.dt_registro),
	      callback: function($$v) {
	        _vm.$set(_vm.acompanhamento, "dt_registro", $$v)
	      },
	      expression: "acompanhamento.dt_registro"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.errors.first('data')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "tipo"
	    }
	  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.tipos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Tipo de Acompanhamento",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaTipos,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "tipo",
	      "data-vv-as": "",
	      "disabled": _vm.acompanhamento.id
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelect($event, _vm.acompanhamento.tipo)
	      }
	    },
	    model: {
	      value: (_vm.acompanhamento.tipo),
	      callback: function($$v) {
	        _vm.$set(_vm.acompanhamento, "tipo", $$v)
	      },
	      expression: "acompanhamento.tipo"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.acompanhamento.situacao_descricao) ? _c('span', {
	    staticClass: "situacao_ocorrencia_sapiens"
	  }, [_vm._v(_vm._s(_vm.acompanhamento.situacao_descricao) + " no Sapiens")]) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('tipo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo')))]) : _vm._e()])]), _vm._v(" "), (_vm.mostraOcor === true) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "tipoOcor"
	    }
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    attrs: {
	      "options": _vm.tipoOcorrencia,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Tipo de Ocorrência",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaTipoOcor,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "tipoOcor"
	    },
	    model: {
	      value: (_vm.acompanhamento.tipo_ocorrencia),
	      callback: function($$v) {
	        _vm.$set(_vm.acompanhamento, "tipo_ocorrencia", $$v)
	      },
	      expression: "acompanhamento.tipo_ocorrencia"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostraOcor === true && _vm.tp === 'OCORRENCIA_IMPEDITIVA') ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "tipoOcor"
	    }
	  }, [_vm._v("Lista de Ocorrência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    class: {
	      'has-error': _vm.errors.first('tipoOcor')
	    }
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.ocorrenciasImpeditiva,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione uma Ocorrência",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaOcorrencia,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "disabled": _vm.acompanhamento.id,
	      "selectedLabel": "Selecionado",
	      "data-vv-as": "ocorrência",
	      "name": "tipoOcor"
	    },
	    model: {
	      value: (_vm.acompanhamento.ocorrencia_sapiens),
	      callback: function($$v) {
	        _vm.$set(_vm.acompanhamento, "ocorrencia_sapiens", $$v)
	      },
	      expression: "acompanhamento.ocorrencia_sapiens"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('tipoOcor')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipoOcor')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mostraOcor === true && _vm.tp === 'INFORMACAO') ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "tipoOcor"
	    }
	  }, [_vm._v("Lista de Ocorrência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    class: {
	      'has-error': _vm.errors.first('tipoOcor')
	    }
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.ocorrenciasInformativa,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione uma Ocorrência",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaOcorrencia,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "data-vv-as": "ocorrência",
	      "selectedLabel": "Selecionado",
	      "name": "tipoOcor"
	    },
	    model: {
	      value: (_vm.acompanhamento.ocorrencia_sapiens),
	      callback: function($$v) {
	        _vm.$set(_vm.acompanhamento, "ocorrencia_sapiens", $$v)
	      },
	      expression: "acompanhamento.ocorrencia_sapiens"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('tipoOcor')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipoOcor')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "detalhamentoBloq"
	    }
	  }, [_vm._v("Histórico Detalhe:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('font', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.acompanhamento.detalhamento)
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('detalhamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "detalhamento"
	    }
	  }, [_vm._v("Detalhe:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.detalhamentoAnt),
	      expression: "detalhamentoAnt"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": _vm.place,
	      "name": "detalhamento",
	      "type": "text",
	      "maxlength": "250",
	      "cols": "10",
	      "rows": "6"
	    },
	    domProps: {
	      "value": (_vm.detalhamentoAnt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.detalhamentoAnt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('detalhamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('detalhamento')))]) : _vm._e()])]), _vm._v(" "), (_vm.mostraStatus === true) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('status')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "status"
	    }
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.statusAcompanhamento,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Status",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaTipoOcor,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "status"
	    },
	    model: {
	      value: (_vm.acompanhamento.status),
	      callback: function($$v) {
	        _vm.$set(_vm.acompanhamento, "status", $$v)
	      },
	      expression: "acompanhamento.status"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('status')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('status')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('prazo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "prazo"
	    }
	  }, [_vm._v("Prazo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "prazo",
	    attrs: {
	      "name": "prazo",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "placeholder": "__ /__ /____",
	      "disabled-dates": _vm.disabledDates,
	      "highlighted": _vm.highlighted,
	      "format": "dd/MM/yyyy"
	    },
	    on: {
	      "input": _vm.verificaData
	    },
	    model: {
	      value: (_vm.acompanhamento.prazo),
	      callback: function($$v) {
	        _vm.$set(_vm.acompanhamento, "prazo", $$v)
	      },
	      expression: "acompanhamento.prazo"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('prazo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('prazo')))]) : _vm._e()])]), _vm._v(" "), (_vm.acompanhamento.responsavel.ds_nome_usuario) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Responsável:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.acompanhamento.responsavel.ds_nome_usuario),
	      expression: "acompanhamento.responsavel.ds_nome_usuario"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "responsavel",
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.acompanhamento.responsavel.ds_nome_usuario)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.acompanhamento.responsavel, "ds_nome_usuario", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Anexos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.acompanhamento.documentos,
	      "documentTypes": '',
	      "disable": '',
	      "localUso": 'TODOS',
	      "salvouOK": _vm.salvouOK
	    }
	  })], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.frmAddAc)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onCancel(_vm.frmAddAc)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])], 1)])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('br'), _c('br')])
	}]}

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Liberação")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Liberação Proposta',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), ((!_vm._.isEmpty(this.restricoesAtivasEntidade) || !_vm._.isEmpty(this.restricoesAtivasProjetosDaEntidade))) ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible",
	    staticStyle: {
	      "margin": "10px"
	    }
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((this.restricoesAtivasEntidade), function(restricaoEntidade) {
	    return _c('p', [_vm._v("\n              " + _vm._s(restricaoEntidade.codoco) + " - " + _vm._s(restricaoEntidade.desroc) + "\n            ")])
	  }), _vm._v(" "), _vm._l((this.restricoesAtivasProjetosDaEntidade), function(restricaoProjeto) {
	    return _c('p', [_vm._v("\n              " + _vm._s(restricaoProjeto.codoco) + " - " + _vm._s(restricaoProjeto.desroc) + "\n            ")])
	  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal col-md-12",
	    attrs: {
	      "name": "frmProposalReleaseRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('dl', {}, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_c('font', {
	    staticStyle: {
	      "color": "dimgrey"
	    }
	  }, [_vm._v(" Nome: " + _vm._s(_vm.preProposta.entidade.ds_nome))])], 1), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_c('font', {
	    staticStyle: {
	      "color": "dimgrey"
	    }
	  }, [_vm._v("  CNPJ: " + _vm._s(_vm._f("cnpj")(_vm.preProposta.entidade.ds_cnpj)))])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('titulo da proposta')
	    },
	    attrs: {
	      "uib-tooltip": "Título da proposta"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "titulo da proposta"
	    }
	  }, [_vm._v(" Título da proposta: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preProposta.ds_nome),
	      expression: "preProposta.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:150'),
	      expression: "'required|max:150'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "titulo da proposta",
	      "data-vv-as": "Título da proposta",
	      "maxlength": "150",
	      "id": "titulo da proposta",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.preProposta.ds_nome)
	    },
	    on: {
	      "keypress": _vm.retiraAspas,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preProposta, "ds_nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('titulo da proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('titulo da proposta')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('documentos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(" Documentos anexos obrigatórios: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.tipoDocumentos,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um documento",
	      "label": "ds_tipo",
	      "track-by": "ds_tipo",
	      "preselect-first": true,
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "selectedLabel": "Selecionado",
	      "name": "documentos",
	      "data-vv-as": "Documentos anexos obrigatórios"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.preProposta.tipo_documentos),
	      callback: function($$v) {
	        _vm.$set(_vm.preProposta, "tipo_documentos", $$v)
	      },
	      expression: "preProposta.tipo_documentos"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('documentos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('documentos')))]) : _vm._e()]), _vm._v(" "), (_vm.preProposta.dc_investimento <= 300000) ? _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(" Ref. Processo Simplificado: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preProposta.simplificado),
	      expression: "preProposta.simplificado"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.preProposta.simplificado) ? _vm._i(_vm.preProposta.simplificado, null) > -1 : (_vm.preProposta.simplificado)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.preProposta.simplificado,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.preProposta, "simplificado", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.preProposta, "simplificado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.preProposta, "simplificado", $$c)
	        }
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('investimento previsto')
	    },
	    attrs: {
	      "uib-tooltip": "Investimento previsto"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "investimento previsto"
	    }
	  }, [_vm._v(" Investimento previsto: ")]), _vm._v(" "), _c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20|between:0.01,9999999999999'),
	      expression: "'required|max:20|between:0.01,9999999999999'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "investimento previsto",
	      "id": "investimento previsto",
	      "data-vv-as": "Investimento previsto",
	      "maxlength": "20",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.preProposta.dc_investimento),
	      callback: function($$v) {
	        _vm.$set(_vm.preProposta, "dc_investimento", $$v)
	      },
	      expression: "preProposta.dc_investimento"
	    }
	  }), _vm._v(" "), (_vm.errors.first('investimento previsto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s('o campo Investimento Previsto está com valor zerado ou incorreto.'))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('mensagem')
	    },
	    attrs: {
	      "uib-tooltip": "Mensagem a ser encaminhada para as entidades"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "mensagem"
	    }
	  }, [_vm._v(" Mensagem a ser encaminhada para as entidades: ")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preProposta.ds_mensagem_entidades),
	      expression: "preProposta.ds_mensagem_entidades"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Mensagem a ser encaminhada",
	      "name": "mensagem",
	      "id": "mensagem",
	      "rows": "10"
	    },
	    domProps: {
	      "value": (_vm.preProposta.ds_mensagem_entidades)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.preProposta, "ds_mensagem_entidades", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('mensagem')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('mensagem')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [((_vm._.isEmpty(this.restricoesAtivasEntidade) && _vm._.isEmpty(this.restricoesAtivasProjetosDaEntidade))) ? _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.concluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Liberação da Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("A Entidade possui restrições que impedem a liberação da proposta.")])])
	}]}

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Widgets\n      "), _c('small', [_vm._v("Preview page")])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Widgets")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [_c('span', {
	    staticClass: "info-box-icon bg-aqua"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Messages")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("1,410")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [_c('span', {
	    staticClass: "info-box-icon bg-green"
	  }, [_c('i', {
	    staticClass: "fa fa-flag-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Bookmarks")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("410")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [_c('span', {
	    staticClass: "info-box-icon bg-yellow"
	  }, [_c('i', {
	    staticClass: "fa fa-files-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Uploads")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("13,648")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [_c('span', {
	    staticClass: "info-box-icon bg-red"
	  }, [_c('i', {
	    staticClass: "fa fa-star-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Likes")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("93,139")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box bg-aqua"
	  }, [_c('span', {
	    staticClass: "info-box-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Bookmarks")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "progress-description"
	  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box bg-green"
	  }, [_c('span', {
	    staticClass: "info-box-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Likes")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "progress-description"
	  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box bg-yellow"
	  }, [_c('span', {
	    staticClass: "info-box-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Events")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "progress-description"
	  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box bg-red"
	  }, [_c('span', {
	    staticClass: "info-box-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-comments-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Comments")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "progress-description"
	  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-aqua"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v("150")]), _vm._v(" "), _c('p', [_vm._v("New Orders")])]), _vm._v(" "), _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-cart"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "small-box-footer",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("\n            More info "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-green"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v("53"), _c('sup', {
	    staticStyle: {
	      "font-size": "20px"
	    }
	  }, [_vm._v("%")])]), _vm._v(" "), _c('p', [_vm._v("Bounce Rate")])]), _vm._v(" "), _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "ion ion-stats-bars"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "small-box-footer",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("\n            More info "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-yellow"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v("44")]), _vm._v(" "), _c('p', [_vm._v("User Registrations")])]), _vm._v(" "), _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "ion ion-person-add"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "small-box-footer",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("\n            More info "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-red"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v("65")]), _vm._v(" "), _c('p', [_vm._v("Unique Visitors")])]), _vm._v(" "), _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "ion ion-pie-graph"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "small-box-footer",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("\n            More info "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-default collapsed-box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Expandable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-success"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Removable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-warning"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Collapsable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-danger"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Loading state")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "overlay"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-default collapsed-box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Expandable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-success box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Removable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-warning box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Collapsable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-danger box-solid"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Loading state")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "overlay"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-primary direct-chat direct-chat-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('span', {
	    staticClass: "badge bg-light-blue",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "3 New Messages"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Contacts",
	      "data-widget": "chat-pane-toggle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "direct-chat-messages"
	  }, [_c('div', {
	    staticClass: "direct-chat-msg"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-left"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-right"
	  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-msg right"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-right"
	  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-left"
	  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-contacts"
	  }, [_c('ul', {
	    staticClass: "contacts-list"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "contacts-list-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contacts-list-info"
	  }, [_c('span', {
	    staticClass: "contacts-list-name"
	  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
	    staticClass: "contacts-list-date pull-right"
	  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
	    staticClass: "contacts-list-msg"
	  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "message",
	      "placeholder": "Type Message ..."
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-success direct-chat direct-chat-success"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('span', {
	    staticClass: "badge bg-green",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "3 New Messages"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Contacts",
	      "data-widget": "chat-pane-toggle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "direct-chat-messages"
	  }, [_c('div', {
	    staticClass: "direct-chat-msg"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-left"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-right"
	  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-msg right"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-right"
	  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-left"
	  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-contacts"
	  }, [_c('ul', {
	    staticClass: "contacts-list"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "contacts-list-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contacts-list-info"
	  }, [_c('span', {
	    staticClass: "contacts-list-name"
	  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
	    staticClass: "contacts-list-date pull-right"
	  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
	    staticClass: "contacts-list-msg"
	  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "message",
	      "placeholder": "Type Message ..."
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-warning direct-chat direct-chat-warning"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('span', {
	    staticClass: "badge bg-yellow",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "3 New Messages"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Contacts",
	      "data-widget": "chat-pane-toggle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "direct-chat-messages"
	  }, [_c('div', {
	    staticClass: "direct-chat-msg"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-left"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-right"
	  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-msg right"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-right"
	  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-left"
	  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-contacts"
	  }, [_c('ul', {
	    staticClass: "contacts-list"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "contacts-list-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contacts-list-info"
	  }, [_c('span', {
	    staticClass: "contacts-list-name"
	  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
	    staticClass: "contacts-list-date pull-right"
	  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
	    staticClass: "contacts-list-msg"
	  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "message",
	      "placeholder": "Type Message ..."
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-danger direct-chat direct-chat-danger"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('span', {
	    staticClass: "badge bg-red",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "3 New Messages"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Contacts",
	      "data-widget": "chat-pane-toggle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "direct-chat-messages"
	  }, [_c('div', {
	    staticClass: "direct-chat-msg"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-left"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-right"
	  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-msg right"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-right"
	  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-left"
	  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-contacts"
	  }, [_c('ul', {
	    staticClass: "contacts-list"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "contacts-list-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contacts-list-info"
	  }, [_c('span', {
	    staticClass: "contacts-list-name"
	  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
	    staticClass: "contacts-list-date pull-right"
	  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
	    staticClass: "contacts-list-msg"
	  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "message",
	      "placeholder": "Type Message ..."
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])])])])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Social Widgets")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-widget widget-user-2"
	  }, [_c('div', {
	    staticClass: "widget-user-header bg-yellow"
	  }, [_c('div', {
	    staticClass: "widget-user-image"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user7-128x128.jpg",
	      "alt": "User Avatar"
	    }
	  })]), _vm._v(" "), _c('h3', {
	    staticClass: "widget-user-username"
	  }, [_vm._v("Nadia Carmichael")]), _vm._v(" "), _c('h5', {
	    staticClass: "widget-user-desc"
	  }, [_vm._v("Lead Developer")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-stacked"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Projects "), _c('span', {
	    staticClass: "pull-right badge bg-blue"
	  }, [_vm._v("31")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Tasks "), _c('span', {
	    staticClass: "pull-right badge bg-aqua"
	  }, [_vm._v("5")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Completed Projects "), _c('span', {
	    staticClass: "pull-right badge bg-green"
	  }, [_vm._v("12")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Followers "), _c('span', {
	    staticClass: "pull-right badge bg-red"
	  }, [_vm._v("842")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-widget widget-user"
	  }, [_c('div', {
	    staticClass: "widget-user-header bg-aqua-active"
	  }, [_c('h3', {
	    staticClass: "widget-user-username"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('h5', {
	    staticClass: "widget-user-desc"
	  }, [_vm._v("Founder & CEO")])]), _vm._v(" "), _c('div', {
	    staticClass: "widget-user-image"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Avatar"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 border-right"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("3,200")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("SALES")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 border-right"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("13,000")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("FOLLOWERS")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("35")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("PRODUCTS")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-widget widget-user"
	  }, [_c('div', {
	    staticClass: "widget-user-header bg-black",
	    staticStyle: {
	      "background": "url('/static/img/photo1.png') center center"
	    }
	  }, [_c('h3', {
	    staticClass: "widget-user-username"
	  }, [_vm._v("Elizabeth Pierce")]), _vm._v(" "), _c('h5', {
	    staticClass: "widget-user-desc"
	  }, [_vm._v("Web Designer")])]), _vm._v(" "), _c('div', {
	    staticClass: "widget-user-image"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "User Avatar"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 border-right"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("3,200")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("SALES")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 border-right"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("13,000")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("FOLLOWERS")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("35")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("PRODUCTS")])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "user-block"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "username"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Jonathan Burke Jr.")])]), _vm._v(" "), _c('span', {
	    staticClass: "description"
	  }, [_vm._v("Shared publicly - 7:30 PM Today")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Mark as read"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('img', {
	    staticClass: "img-responsive pad",
	    attrs: {
	      "src": "/static/img/photo2.png",
	      "alt": "Photo"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("I took this photo this morning. What do you guys think?")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-share"
	  }), _vm._v(" Share")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Like")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right text-muted"
	  }, [_vm._v("127 likes - 3 comments")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer box-comments"
	  }, [_c('div', {
	    staticClass: "box-comment"
	  }, [_c('img', {
	    staticClass: "img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "comment-text"
	  }, [_c('span', {
	    staticClass: "username"
	  }, [_vm._v("\n                      Maria Gonzales\n                      "), _c('span', {
	    staticClass: "text-muted pull-right"
	  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-comment"
	  }, [_c('img', {
	    staticClass: "img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user4-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "comment-text"
	  }, [_c('span', {
	    staticClass: "username"
	  }, [_vm._v("\n                      Luna Stark\n                      "), _c('span', {
	    staticClass: "text-muted pull-right"
	  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('img', {
	    staticClass: "img-responsive img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user4-128x128.jpg",
	      "alt": "Alt Text"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "img-push"
	  }, [_c('input', {
	    staticClass: "form-control input-sm",
	    attrs: {
	      "type": "text",
	      "placeholder": "Press enter to post comment"
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "user-block"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "username"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Jonathan Burke Jr.")])]), _vm._v(" "), _c('span', {
	    staticClass: "description"
	  }, [_vm._v("Shared publicly - 7:30 PM Today")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Mark as read"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', [_vm._v("Far far away, behind the word mountains, far from the\n              countries Vokalia and Consonantia, there live the blind\n              texts. Separated they live in Bookmarksgrove right at")]), _vm._v(" "), _c('p', [_vm._v("the coast of the Semantics, a large language ocean.\n              A small river named Duden flows by their place and supplies\n              it with the necessary regelialia. It is a paradisematic\n              country, in which roasted parts of sentences fly into\n              your mouth.")]), _vm._v(" "), _c('div', {
	    staticClass: "attachment-block clearfix"
	  }, [_c('img', {
	    staticClass: "attachment-img",
	    attrs: {
	      "src": "/static/img/photo1.png",
	      "alt": "Attachment Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "attachment-pushed"
	  }, [_c('h4', {
	    staticClass: "attachment-heading"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.lipsum.com/"
	    }
	  }, [_vm._v("Lorem ipsum text generator")])]), _vm._v(" "), _c('div', {
	    staticClass: "attachment-text"
	  }, [_vm._v("\n                  Description about the attachment can be placed here.\n                  Lorem Ipsum is simply dummy text of the printing and typesetting industry... "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("more")])])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-share"
	  }), _vm._v(" Share")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Like")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right text-muted"
	  }, [_vm._v("45 likes - 2 comments")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer box-comments"
	  }, [_c('div', {
	    staticClass: "box-comment"
	  }, [_c('img', {
	    staticClass: "img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "comment-text"
	  }, [_c('span', {
	    staticClass: "username"
	  }, [_vm._v("\n                      Maria Gonzales\n                      "), _c('span', {
	    staticClass: "text-muted pull-right"
	  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-comment"
	  }, [_c('img', {
	    staticClass: "img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user5-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "comment-text"
	  }, [_c('span', {
	    staticClass: "username"
	  }, [_vm._v("\n                      Nora Havisham\n                      "), _c('span', {
	    staticClass: "text-muted pull-right"
	  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                The point of using Lorem Ipsum is that it has a more-or-less\n                normal distribution of letters, as opposed to using\n                'Content here, content here', making it look like readable English.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('img', {
	    staticClass: "img-responsive img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user4-128x128.jpg",
	      "alt": "Alt Text"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "img-push"
	  }, [_c('input', {
	    staticClass: "form-control input-sm",
	    attrs: {
	      "type": "text",
	      "placeholder": "Press enter to post comment"
	    }
	  })])])])])])])])])
	}]}

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-show": "$ctrl.isNewAvaiable()"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Meta")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table b-table table-hover table-bordered b-table-stacked-md",
	    attrs: {
	      "role": "table",
	      "aria-busy": "false",
	      "aria-colcount": "7",
	      "aria-rowcount": "-1"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
	    attrs: {
	      "role": "rowgroup"
	    }
	  }, [_vm._l((_vm.propsObjetivos), function(objetivo, objetivoIndex) {
	    return _vm._l((objetivo.goals), function(meta, metaIndex) {
	      return _c('tr', {
	        attrs: {
	          "role": "row"
	        }
	      }, [_c('td', {
	        staticClass: "text-center",
	        attrs: {
	          "aria-colindex": "1",
	          "data-label": "Objetivo",
	          "role": "cell"
	        }
	      }, [_c('div', [_vm._v("\n                    " + _vm._s(objetivo.description) + "\n                  ")])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center",
	        attrs: {
	          "aria-colindex": "2",
	          "data-label": "Meta do Projeto",
	          "role": "cell"
	        }
	      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.description) + "\n                  ")])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center",
	        attrs: {
	          "aria-colindex": "3",
	          "data-label": "Meta Orçada",
	          "role": "cell"
	        }
	      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.quantity) + "\n                  ")])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center",
	        attrs: {
	          "aria-colindex": "4",
	          "data-label": "Meta Orçada",
	          "role": "cell"
	        }
	      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.measurementUnit) + "\n                  ")])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center",
	        attrs: {
	          "aria-colindex": "5",
	          "data-label": "Meta Orçada",
	          "role": "cell"
	        }
	      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.duration) + "\n                  ")])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center",
	        attrs: {
	          "aria-colindex": "6",
	          "data-label": "Meta Orçada",
	          "role": "cell"
	        }
	      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.performanceIndicators) + "\n                  ")])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center",
	        attrs: {
	          "aria-colindex": "6",
	          "data-label": "Meta Orçada",
	          "role": "cell"
	        }
	      }, [_c('div', [_c('button', {
	        staticClass: "btn btn-primary btn-sm btn-flat",
	        attrs: {
	          "type": "button",
	          "disabled": false
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.edita(objetivoIndex, meta)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-pencil-square-o",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Editar")]), _vm._v(" "), _c('button', {
	        staticClass: "btn btn-danger btn-sm btn-flat",
	        attrs: {
	          "type": "button",
	          "disabled": false
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.exclui(objetivo, metaIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-trash",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Excluir")])])])])
	    })
	  })], 2)])])])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('objetivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "objective"
	    }
	  }, [_vm._v("Objetivo Específico:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.objetivoIndex),
	      expression: "objetivoIndex"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "objetivo",
	      "ng-options": "objective.description for objective in proposta.specificObjectives"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.objetivoIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.propsObjetivos), function(objetivo, index) {
	    return _c('option', {
	      domProps: {
	        "value": index
	      }
	    }, [_vm._v(_vm._s(objetivo.description))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('objetivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('O que')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "description"
	    }
	  }, [_vm._v("O que? ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.description),
	      expression: "meta.description"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "O que",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.meta.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.meta, "description", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('O que')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('O que')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantity"
	    }
	  }, [_vm._v("Quanto?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.quantity),
	      expression: "meta.quantity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "quantidade",
	      "type": "number",
	      "min": "1",
	      "max": "2147483647"
	    },
	    domProps: {
	      "value": (_vm.meta.quantity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.meta, "quantity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('unidade de medida')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "measurementUnit"
	    }
	  }, [_vm._v("Unidade de medida:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.measurementUnit),
	      expression: "meta.measurementUnit"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "unidade de medida",
	      "type": "text",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.meta.measurementUnit)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.meta, "measurementUnit", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('unidade de medida')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('unidade de medida')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Quanto tempo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "duration"
	    }
	  }, [_vm._v("Quanto tempo?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.duration),
	      expression: "meta.duration"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "Quanto tempo",
	      "type": "number",
	      "min": "1",
	      "max": "2147483647"
	    },
	    domProps: {
	      "value": (_vm.meta.duration)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.meta, "duration", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Quanto tempo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Quanto tempo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Indicadores de execução')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "performanceIndicators"
	    }
	  }, [_vm._v("Indicadores de execução:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.performanceIndicators),
	      expression: "meta.performanceIndicators"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Indicadores de execução",
	      "ng-options": "indicator for indicator in listIndicators"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.meta, "performanceIndicators", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.listIndicators), function(indicador, index) {
	    return _c('option', {
	      domProps: {
	        "value": indicador
	      }
	    }, [_vm._v(_vm._s(indicador))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('Indicadores de execução')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Indicadores de execução')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-goal-add"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-goal-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "1"
	    }
	  }, [_vm._v("Objetivo")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "2"
	    }
	  }, [_vm._v("Meta do Projeto")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "3"
	    }
	  }, [_vm._v("Meta Orçada")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "4"
	    }
	  }, [_vm._v("Unidade de medida")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "5"
	    }
	  }, [_vm._v("Duração")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "6"
	    }
	  }, [_vm._v("Indicador")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "13%"
	    },
	    attrs: {
	      "aria-colindex": "7"
	    }
	  }, [_vm._v("Ações")])])])
	}]}

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [(_vm.ehVisualizacao) ? _c('span', [_vm._v("Visualizar " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]) : _c('span', [_vm._v(_vm._s(_vm.etapa) + " de " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (!_vm.loading.tela || _vm.ehVisualizacao) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), ((!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id))) ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }]
	  }, [((_vm.processo === 'PAGAMENTO') && _vm._.includes(['Autorização', 'Liquidação'], _vm.ultimaTarefaFeita.nome)) ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>611 - Comprovante de Pagamento (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(611)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 611\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id))) ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.tela),
	      expression: "!loading.tela"
	    }]
	  }, [(_vm._.has(_vm.analiseTributaria, 'nf') && ('' + _vm.analiseTributaria.nf.SitNfc === '2') && !(('' + _vm.nota.forma_pagamento) === '3' && ('' + _vm.nota.dados_bancarios.banco + _vm.nota.dados_bancarios.agencia + _vm.nota.dados_bancarios.conta).length < 6)) ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>200 - Comunicado Interno (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(200)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 200\n        ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(219)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 219\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'S')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525A\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'N')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525S\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>248 - Monitoramento Administrativo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(248)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 248\n        ")]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && _vm.etapa !== 'Solicitação') ? _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5>Faz o download de todos os arquivos da solicitação (zip)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onDownloadZIP()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v(" Baixar arquivos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (!_vm.loading.tela && !_vm.loading.cronograma && !_vm._.isEmpty(_vm.projeto) && !_vm._.isNull(_vm.ehNFe) && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5>' + (_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) ? 'Ao Concluir esta solicitação será encaminhada para Análise da Fundação BB' : (_vm.aprovacao.resultadoAprovacao ? 'Será encaminhado para ' + _vm.aprovacao.resultadoAprovacao : 'Aguardando decisão (aprovar, devolver etc)')) + '</h5>'
	    }
	  }, [(_vm._.includes(['Análise', 'Análise Tributária'], _vm.etapa)) ? _c('button', {
	    staticClass: "success",
	    attrs: {
	      "id": "botao_concluir",
	      "disabled": _vm.botao_concluir_disabled || (!_vm.aprovacao.resultadoAprovacao),
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.preconcluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.preconcluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")])], 1) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela && !_vm.loading.cronograma && !_vm._.isEmpty(_vm.projeto) && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5>Salva esta solicitação<br/>Para encaminhá-la deve-se usar o botão de Concluir' + (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm.poderes.codigo !== 'DIRIGENTE_SEM_RESTRICAO' ? '<br/>Somente dirigentes estão habilitados para concluir solicitações' : (_vm.poderes.mensagem.length > 0 ? '<br/>Restrições:<br/>' + _vm._.join(_vm.poderes.mensagem, ', ') : '')) + '</h5>'
	    }
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvar($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (!_vm.loading.tela && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0 && (_vm.etapa === 'Solicitação' || _vm.etapa === 'Revisão') && !_vm._.isEmpty(_vm.projeto)) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5> Abrir Chamado referente a solicitação atual</h5>'
	    }
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.abrirChamado($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa  fa-comment-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Abrir Chamado")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: (_vm._.isNull(_vm.id) ? 'Solicitações' : 'Validação'),
	        href: '#'
	      }, {
	        text: _vm.descricaoProcesso[_vm.processo],
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [(_vm._.isEmpty(_vm.projeto) && _vm._.isNull(_vm.id) && !_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaProjetos"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    class: _vm.ehVisualizacao ? 'fa fa-caret-right' : 'fa fa-pencil',
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Selecione o projeto")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.listaProjetos.length === 0),
	      expression: "listaProjetos.length === 0"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto),
	      expression: "projeto"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "projeto",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.selecionaProjeto()
	      }]
	    }
	  }, _vm._l((_vm.listaProjetos), function(projetoDisponivel) {
	    return _c('option', {
	      domProps: {
	        "value": projetoDisponivel
	      }
	    }, [_vm._v(_vm._s(projetoDisponivel.Projeto))])
	  }), 0)])])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id)) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "solicitacao"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (!_vm._.isEmpty(_vm.chamado) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("* Atenção: O processo que será analisado possui " + _vm._s(_vm.chamado.length > 1 ? 'chamados vinculados' : 'chamado vinculado') + ": ")]), _vm._v(" "), _vm._l((_vm.chamado), function(c, index) {
	    return _c('span', [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          placement: 'top',
	          interactive: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', interactive:true}"
	      }],
	      staticClass: "text-bold",
	      attrs: {
	        "title": '<h5 class=\'text-left\'>Chamado SGP <span class=\'realce\'>' + c.id + '</span><br/>' + ((c.descricao).substr(0, 200) + (c.descricao.length > 200 ? '...' : '')) + '</h5>'
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "target": "_blank",
	        "to": {
	          name: 'cadastro-chamado-edita',
	          params: {
	            id: c.id
	          }
	        }
	      }
	    }, [_vm._v(_vm._s(c.id))])], 1), _vm._v("\n                            " + _vm._s(index < _vm.chamado.length - 1 ? ', ' : '') + "\n            ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.nota.suporteFbb.length > 0 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('p', [_c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("** Atenção: Este processo possui " + _vm._s(_vm.nota.suporteFbb.length > 1 ? 'os seguintes suportes vinculados' : 'este suportes vinculado') + ":")]), _vm._v(" "), _vm._l((_vm.nota.suporteFbb), function(suporte, index) {
	    return _c('a', {
	      staticClass: "text-bold",
	      attrs: {
	        "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
	        "target": "_blank"
	      }
	    }, [_vm._v("\n                            " + _vm._s(suporte.numero) + _vm._s(index < _vm.nota.suporteFbb.length - 1 ? ', ' : '') + "\n            ")])
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.projeto.Projeto) + "\n              "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela) ? _c('span', [_vm._v("\n                ("), _c('strong', [_vm._v(_vm._s(_vm.projeto.Status_ERP))]), _vm._v(")\n                "), _c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'small',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Ir para a página do Projeto</h5>',
	      "to": {
	        name: 'projeto',
	        params: {
	          numero: _vm.projeto.Numero_projeto
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })]), _c('p')], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [((_vm._.filter(_vm.restricaoParaConcluir, function(erro) {
	    return (erro.tag).indexOf('valoresTotaisIncorretosProjeto') !== -1
	  })).length > 0) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm._.filter(_vm.restricaoParaConcluir, function(erro) {
	    return (erro.tag).indexOf('valoresTotaisIncorretosProjeto') !== -1
	  })), function(restricao) {
	    return _c('p', [_vm._v(_vm._s(restricao.mensagem) + " "), _c('span', {
	      staticClass: "font-italic font-light"
	    }, [_vm._v("(" + _vm._s((restricao.tag).substr(-7)) + ")")])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (_vm._.filter(_vm.restricaoParaConcluir, ['tag', 'adiantamentoNaoDisponivelParaPrestarContas'])).length > 0) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("Ainda não há título de adiantamento disponível para prestar contas")])]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length > 0) ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.restricaoParaInicializar), function(restricao) {
	    return _c('p', [_vm._v(_vm._s(restricao))])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.ultimaTarefaFeita, 'observacao') && !_vm._.isNull(_vm.ultimaTarefaFeita.observacao)) ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ultimaTarefaFeita.observacao))])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PRESTACAO_DE_CONTAS', 'PAGAMENTO', 'ADIANTAMENTO', 'RESSARCIMENTO', 'CONTRAPARTIDA'], _vm.processo) && _vm._.includes(['Solicitação'], _vm.etapa) && _vm.projetoComAlteracaoEmAndamento) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Solicitação não disponível. Verificamos que há uma alteração de projetos em andamento.")])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PRESTACAO_DE_CONTAS'], _vm.processo) && _vm.ehVoluntariado && _vm.etapa === 'Análise') ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("Projeto de Voluntariado com processo simplificado - após a conclusão da análise, a tarefa será finalizada.")])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PRESTACAO_DE_CONTAS'], _vm.processo) && _vm.ehPrestacaoSimplificada && _vm.etapa === 'Análise') ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("Projeto em processo simplificado.")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Período de execução:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('p', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.projeto.data_inicial_formatada) + " a " + _vm._s(_vm.projeto.data_final_formatada))])])]), _vm._v(" "), (!_vm._.includes(['Solicitação'], _vm.etapa)) ? _c('div', [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome da entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [(!_vm.ehParceiroEstrategico) ? _c('p', {
	    staticClass: "form-control-static"
	  }, [_c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
	      "to": {
	        name: 'cadastro-entidade-visualiza',
	        params: {
	          id: _vm.projeto.fk_entidade
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.razaoSocial) + "  "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.ehParceiroEstrategico) ? _c('p', {
	    staticClass: "form-control-static"
	  }, [_vm._v("\n                        " + _vm._s(_vm.razaoSocial) + "\n                      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.entidade.ds_cnpj)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Projeto Superior:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.projetoSuperior))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    on: {
	      "click": function($event) {
	        _vm.mostrar_representantes = !_vm.mostrar_representantes
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar_representantes ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Representantes Legais:")]), _vm._v(" "), (_vm.mostrar_representantes) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)")]), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.dirigentes), function(dirigente) {
	    return (dirigente.bt_ativo && dirigente.bt_assinatura_entidade) ? _c('tr', [_c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm.cargos[dirigente.fk_cargo_mandato]))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]) : _vm._e()
	  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    on: {
	      "click": function($event) {
	        _vm.mostrar_ocorrencias = !_vm.mostrar_ocorrencias
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrar_ocorrencias ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocorrências:")]), _vm._v(" "), (_vm.temOcorrencia) ? _c('div', [(_vm.mostrar_ocorrencias) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.ocorrencias), function(ocorrencia) {
	    return _c('tr', [_c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(ocorrencia.codigo) + " " + _vm._s(ocorrencia.descricao))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("moment")(ocorrencia.inicio, "L")))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(ocorrencia.observacao))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(ocorrencia.etapa))])])
	  }), 0)])])])]) : _vm._e()]) : _c('div', [_vm._m(9)])])])]) : _vm._e()]), _vm._v(" "), (false) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("É uma NF-e?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ehNFe),
	      expression: "ehNFe"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "ehNfe",
	      "disabled": !_vm._.includes(['Solicitação', 'Análise'], _vm.etapa) || _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.ehNFe, true)
	    },
	    on: {
	      "change": function($event) {
	        _vm.ehNFe = true
	      }
	    }
	  }), _vm._v(" Sim\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ehNFe),
	      expression: "ehNFe"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "ehNfe",
	      "disabled": !_vm._.includes(['Solicitação', 'Análise'], _vm.etapa) || _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.ehNFe, false)
	    },
	    on: {
	      "change": function($event) {
	        _vm.ehNFe = false
	      }
	    }
	  }), _vm._v(" Não\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.ehNFe) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('chave de acesso')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Chave de Acesso da NF-e:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nfe.chaveAcesso),
	      expression: "nfe.chaveAcesso"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:44|max:44'),
	      expression: "'required|min:44|max:44'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "chave de acesso",
	      "id": "chave de acesso",
	      "type": "text",
	      "maxlength": "80",
	      "disabled": _vm.loading.tela || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.nfe.chaveAcesso)
	    },
	    on: {
	      "keyup": _vm.validarChaveNFe,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nfe, "chaveAcesso", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('chave de acesso')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('chave de acesso')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [(_vm._.has(_vm.nfe.protocoloValidacao, 'infProt') && !_vm._.isNull(_vm.nfe.protocoloValidacao.infProt)) ? _c('div', {
	    class: _vm.nfe.protocoloValidacao.infProt.cStat === '100' ? 'text-green' : 'text-red'
	  }, [_vm._v(" Protocolo nº " + _vm._s(_vm.nfe.protocoloValidacao.infProt.nProt) + ", " + _vm._s(_vm.nfe.protocoloValidacao.infProt.xMotivo) + " em " + _vm._s(_vm._f("moment")(_vm.nfe.protocoloValidacao.infProt.dhRecbto, 'DD/MM/YYYY HH:MM')))]) : _vm._e()])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.ehNFe)) ? _c('div', [(_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _vm.processo) || (_vm.processo === 'CONTRAPARTIDA' && _vm.ehNFe)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: (_vm.processo !== 'RESSARCIMENTO' ? 'required-field' : '') + (_vm.errors.first('número da nota') ? ' has-error' : '')
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Número do Documento:\n                          "), (_vm.processo === 'RESSARCIMENTO' && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)) ? _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'top'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	    }],
	    staticClass: "fa fa-question-circle text-gray",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Informe o número quando se tratar de documento fiscal ou um RPA com numeração<br/>Se for um documento sem numeração fiscal, como contra-cheque etc, pode deixar em branco</h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ((_vm.processo !== 'RESSARCIMENTO' ? 'required|' : '') + 'max:9'),
	      expression: "(processo !== 'RESSARCIMENTO' ? 'required|' : '') + 'max:9'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "número da nota",
	      "type": "text",
	      "mask": '#########',
	      "maxlength": "9",
	      "min": "1",
	      "max": "2147483647",
	      "inputmode": "numeric",
	      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	    },
	    on: {
	      "input": function($event) {
	        _vm.nota.numeroNota = (_vm.nota.numeroNota || '').toString().slice(0, 9)
	      }
	    },
	    model: {
	      value: (_vm.nota.numeroNota),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "numeroNota", $$v)
	      },
	      expression: "nota.numeroNota"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('série')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Série:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.serieNota),
	      expression: "nota.serieNota"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "série",
	      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "serieNota", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "NOTA_FISCAL"
	    }
	  }, [_vm._v("1 - Nota fiscal")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RECIBO_PAGAMENTO_AUTONOMO"
	    }
	  }, [_vm._v("10 - Recibo de pagamento a autônomo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DOCUMENTO_NAO_FISCAL"
	    }
	  }, [_vm._v("DNF - Documento não fiscal")])])]), _vm._v(" "), (_vm.errors.first('série')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('série')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('data de emissão')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Data de emissão do documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data de emissão",
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "disabled-dates": {
	        to: new Date(_vm.projeto.dateInicioSapiens),
	        from: (new Date() < _vm.dataFinalConvenio) ? new Date() : _vm.dataFinalConvenio
	      },
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.nota.dataInclusao),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "dataInclusao", $$v)
	      },
	      expression: "nota.dataInclusao"
	    }
	  })], 1)]), _vm._v(" "), (_vm.errors.first('data de emissão')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data de emissão')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Data de validade do documento: (Somente informe se possuir a data)")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    attrs: {
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "disabled-dates": _vm.desabilitarDatasPassadas,
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.nota.dataValidade),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "dataValidade", $$v)
	      },
	      expression: "nota.dataValidade"
	    }
	  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _vm.processo) || (_vm.processo === 'CONTRAPARTIDA' && _vm.ehNFe)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de pessoa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Tipo de pessoa:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.tipoFornecedor),
	      expression: "nota.tipoFornecedor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "tipo de pessoa",
	      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "tipoFornecedor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.bloqueiaCamposFornecedorExistente = false, _vm.nota.nomeFornecedor = '', _vm.nota.cepFornecedor = '', _vm.nota.enderecoFornecedor = '', _vm.nota.cnpjFornecedor = '', _vm.nota.cpfFornecedor = '', _vm.nota.codigoFornecedor = '', _vm.nota.simplesNacional = ''
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Pessoa Física"
	    }
	  }, [_vm._v("Pessoa Física")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Pessoa Jurídica"
	    }
	  }, [_vm._v("Pessoa Jurídica")])])]), _vm._v(" "), (_vm.errors.first('tipo de pessoa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de pessoa')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.nota.tipoFornecedor === 'Pessoa Jurídica') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpj')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 65%; float: left' : ''),
	    attrs: {
	      "name": "cnpj",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens,
	      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
	      "type": "text"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.verificaCpfCnpjSapiens(_vm.nota.cnpjFornecedor)
	      }
	    },
	    model: {
	      value: (_vm.nota.cnpjFornecedor),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "cnpjFornecedor", $$v)
	      },
	      expression: "nota.cnpjFornecedor"
	    }
	  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('input', {
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "30%",
	      "float": "left",
	      "margin-left": "5%"
	    },
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.nota.codigoFornecedor
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cnpj')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('cnpj vinculado a dirigente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj vinculado a dirigente')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nota.tipoFornecedor === 'Pessoa Física') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 65%; float: left' : ''),
	    attrs: {
	      "name": "cpf",
	      "mask": ['###.###.###-##'],
	      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
	      "type": "text"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.verificaCpfCnpjSapiens(_vm.nota.cpfFornecedor)
	      }
	    },
	    model: {
	      value: (_vm.nota.cpfFornecedor),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "cpfFornecedor", $$v)
	      },
	      expression: "nota.cpfFornecedor"
	    }
	  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('input', {
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "30%",
	      "float": "left",
	      "margin-left": "5%"
	    },
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.nota.codigoFornecedor
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('cpf vinculado a dirigente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf vinculado a dirigente')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.has(_vm.nota, 'tipoFornecedor') && !_vm._.isNull(_vm.nota.tipoFornecedor)) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.nomeFornecedor),
	      expression: "nota.nomeFornecedor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.nota.nomeFornecedor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "nomeFornecedor", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.has(_vm.nota, 'tipoFornecedor') && !_vm._.isNull(_vm.nota.tipoFornecedor)) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('endereço')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.enderecoFornecedor),
	      expression: "nota.enderecoFornecedor"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "endereço",
	      "type": "text",
	      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	    },
	    domProps: {
	      "value": (_vm.nota.enderecoFornecedor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "enderecoFornecedor", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('endereço ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nota.tipoFornecedor === 'Pessoa Jurídica' && _vm._.includes(['S', 'N'], _vm.nota.simplesNacional)) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Simples Nacional:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_vm._v("\n                          " + _vm._s(_vm.nota.simplesNacional === 'S' ? 'Optante' : 'Não optante') + "\n                          "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("(consultado na Receita pelo sistema)")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm._.has(_vm.nota, 'tipoFornecedor') && !_vm._.isNull(_vm.nota.tipoFornecedor)) ? _c('div', {
	    staticClass: "form-group required-field row",
	    class: {
	      'has-error': _vm.errors.first('cep')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cep",
	      "mask": ['#####-###'],
	      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.procurandoCidadeUF($event)
	      }
	    },
	    model: {
	      value: (_vm.nota.cepFornecedor),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "cepFornecedor", $$v)
	      },
	      expression: "nota.cepFornecedor"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()]), _vm._v(" "), (_vm.nota.cepFornecedor) ? _c('div', {
	    staticClass: "col-md-5",
	    staticStyle: {
	      "padding": "7px"
	    }
	  }, [_vm._v("\n                          " + _vm._s(_vm.nota.cidadeFornecedor) + " " + _vm._s((_vm.nota.estadoFornecedor) ? ' / ' + _vm.nota.estadoFornecedor : '') + "\n                        ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _vm.processo)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dados Bancários " + _vm._s(_vm.processo === 'RESSARCIMENTO' ? ' de Beneficiário' : '') + " "), (_vm.loading.favorecido) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.processo === 'RESSARCIMENTO' && !_vm.loading.favorecido) ? _c('div', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.codfavFormatado
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.favorecido.nomfav),
	      expression: "nota.favorecido.nomfav"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": (_vm.nota.favorecido.nomfav)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota.favorecido, "nomfav", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && _vm.processo !== 'RESSARCIMENTO')) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('forma de pagamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Forma de pagamento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.forma_pagamento),
	      expression: "nota.forma_pagamento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "forma de pagamento",
	      "disabled": _vm._.includes(['PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _vm.processo) || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "forma_pagamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.listaFormasPagamento), function(fp) {
	    return _c('option', {
	      domProps: {
	        "value": fp.CodFpg
	      }
	    }, [_vm._v(_vm._s(fp.DesFpg))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('forma de pagamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma de pagamento')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {}, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('pagamento prioritário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Pagamento Prioritário:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.pagamentoPrioritario),
	      expression: "nota.pagamentoPrioritario"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "pagamento prioritário",
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota, "pagamentoPrioritario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('pagamento prioritário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('pagamento prioritário')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'PAGAMENTO' && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa) && !_vm.mostrarIncluindoConta && !_vm.ehVisualizacao && (_vm.nota.forma_pagamento === 3 || _vm.nota.forma_pagamento === '3')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Contas Cadastradas Fornecedor:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    key: _vm.dadosBancariosFornecedores.length,
	    attrs: {
	      "options": _vm.dadosBancariosFornecedores,
	      "searchable": false,
	      "close-on-select": true,
	      "show-labels": false,
	      "allow-empty": false,
	      "placeholder": "Selecione um dado bancário da lista ou inclua um novo",
	      "name": "contas já cadastradas",
	      "disabled": _vm.ehVisualizacao
	    },
	    on: {
	      "select": _vm.selecionaDadosBancariosFornecedor
	    },
	    scopedSlots: _vm._u([{
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v("Banco: " + _vm._s(props.option.banco))]), _vm._v(" | "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v("Agência: " + _vm._s(props.option.agencia))]), _vm._v(" | "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v("Conta: " + _vm._s(props.option.conta))]), _vm._v(" | "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.ccbfav))]), _vm._v(" "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(('' + props.option.tipo) === '1' ? 'Conta Corrente' : ('' + props.option.tipo) === '2' ? 'Conta Poupança' : 'Tipo de conta não definido'))])]
	      }
	    }, {
	      key: "noOptions",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "text-red"
	        }, [_vm._v("Nenhum dado bancário encontrado.")])]
	      }
	    }, {
	      key: "option",
	      fn: function(props) {
	        return [_vm._v("\n                                    Banco: "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.banco) + "  ")]), _vm._v("\n                                    Agência: "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.agencia) + "  ")]), _vm._v("\n                                    Conta: "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.conta))]), _vm._v("\n                                    Tipo: "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(('' + props.option.tipo) === '1' ? 'Conta Corrente' : ('' + props.option.tipo) === '2' ? 'Conta Poupança' : 'Tipo de conta não definido'))])]
	      }
	    }], null, false, 1623321423),
	    model: {
	      value: (_vm.nota.favorecido.dadosBancariosSelecionados),
	      callback: function($$v) {
	        _vm.$set(_vm.nota.favorecido, "dadosBancariosSelecionados", $$v)
	      },
	      expression: "nota.favorecido.dadosBancariosSelecionados"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('contas já cadastradas')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('contas já cadastradas')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'PAGAMENTO' && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa) && !_vm.mostrarIncluindoConta && !_vm.ehVisualizacao && (_vm.nota.forma_pagamento === 3 || _vm.nota.forma_pagamento === '3')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_vm._m(13), _vm._v(" "), _vm._m(14)]) : _vm._e()]), _vm._v(" "), (('' + _vm.nota.forma_pagamento) === '4' && _vm._.includes(['PAGAMENTO', 'RESSARCIMENTO'], _vm.processo)) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "required control-label col-md-4"
	  }, [_vm._v("Tipo Documento:")]), _vm._v(" "), (('' + _vm.nota.forma_pagamento) === '4' && _vm._.includes(['PAGAMENTO', 'RESSARCIMENTO'], _vm.processo)) ? _c('div', {
	    staticClass: "col-md-6 form-group required-field"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status",
	      "checked": "true"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudarTipoDocumento('boleto')
	      }
	    }
	  }), _vm._v(" Boleto\n                                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mudarTipoDocumento('imposto')
	      }
	    }
	  }), _vm._v(" Imposto\n                                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (('' + _vm.nota.forma_pagamento) === '4' && _vm._.includes(['PAGAMENTO', 'RESSARCIMENTO'], _vm.processo)) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [(this.tipoDocumento === 'boleto') ? _c('span', {
	    staticStyle: {
	      "color": "red",
	      "margin-right": "2px"
	    }
	  }, [_vm._v("*")]) : _vm._e(), _vm._v("Código de Barras:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.boleto.numeroInformadoTela),
	      expression: "nota.boleto.numeroInformadoTela"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "código de barras",
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização'], _vm.etapa)
	    },
	    domProps: {
	      "value": (_vm.nota.boleto.numeroInformadoTela)
	    },
	    on: {
	      "keyup": _vm.validaAjustaCodigoBarras,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota.boleto, "numeroInformadoTela", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('código de barras')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('código de barras')))]) : (_vm.nota.boleto.sucesso) ? _c('span', {
	    staticClass: "label label-success"
	  }, [_vm._v("\n                            " + _vm._s(_vm._.capitalize((_vm.nota.boleto.tipoCodigoInput + ' de ' + _vm.nota.boleto.tipoBoleto).replaceAll('_', ' ')) + ' correto!') + "\n                          ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.nota.forma_pagamento === 3 || _vm.nota.forma_pagamento === '3' || _vm._.includes(['RESSARCIMENTO'], _vm.processo)) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [(!_vm.loading.favorecido && !_vm.loading.tela) ? _c('div', [(_vm._.includes(['RESSARCIMENTO'], _vm.processo) && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostrarIncluindoConta && !_vm.ehVisualizacao),
	      expression: "!mostrarIncluindoConta && !ehVisualizacao"
	    }],
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('contas já cadastradas')
	    },
	    attrs: {
	      "disabled": _vm.nota.favorecido.dadosBancariosSelecionados
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Contas já cadastradas:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.nota.formaPagamento !== 4
	      }),
	      expression: "{required: nota.formaPagamento !== 4}"
	    }],
	    key: _vm.opcoesContasExistentesFavorecido.length,
	    attrs: {
	      "options": _vm.opcoesContasExistentesFavorecido,
	      "searchable": false,
	      "close-on-select": true,
	      "show-labels": false,
	      "allow-empty": false,
	      "placeholder": "Selecione um dado bancário da lista ou inclua um novo",
	      "name": "contas já cadastradas",
	      "disabled": _vm.ehVisualizacao
	    },
	    on: {
	      "select": _vm.selecionaDadosBancariosFavorecido
	    },
	    scopedSlots: _vm._u([{
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.codban))]), _vm._v(" | "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.codage))]), _vm._v(" | "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.ccbfav))]), _vm._v(" | "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(('' + props.option.tiptcc) === '1' ? 'Conta Corrente' : ('' + props.option.tiptcc) === '2' ? 'Conta Poupança' : 'Tipo de conta não definido'))])]
	      }
	    }, {
	      key: "noOptions",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "text-red"
	        }, [_vm._v("Nenhum dado bancário cadastrado. Favor Incluir banco, agência e conta")])]
	      }
	    }, {
	      key: "option",
	      fn: function(props) {
	        return [_vm._v("\n                                  Banco: "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.codban) + "  ")]), _vm._v("\n                                  Agência: "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.codage) + "  ")]), _vm._v("\n                                  Conta " + _vm._s(('' + props.option.tiptcc) === '1' ? 'Corrente' : ('' + props.option.tiptcc) === '2' ? 'Poupança' : 'não definida') + ": "), _c('span', {
	          staticClass: "text-blue"
	        }, [_vm._v(_vm._s(props.option.ccbfav))])]
	      }
	    }], null, false, 465316643),
	    model: {
	      value: (_vm.nota.favorecido.dadosBancariosSelecionados),
	      callback: function($$v) {
	        _vm.$set(_vm.nota.favorecido, "dadosBancariosSelecionados", $$v)
	      },
	      expression: "nota.favorecido.dadosBancariosSelecionados"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('contas já cadastradas')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('contas já cadastradas')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'RESSARCIMENTO' && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa) && !_vm.mostrarIncluindoConta && !_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [(!_vm.loading.tela || _vm.ehVisualizacao) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5>Permite incluir na lista novo conjunto de dados bancários</h5>'
	    }
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.favorecidoDadosBancariosIncluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")])], 1) : _vm._e(), _vm._v(" "), (_vm.opcoesContasExistentesFavorecido.length > 0 && !_vm._.isNull(_vm.nota.favorecido.dadosBancariosSelecionados)) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5>Exclui da lista os dados bancário selecionados</h5>'
	    }
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.favorecidoDadosBancariosExcluir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Excluir")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS'], _vm.processo) || (_vm.processo === 'RESSARCIMENTO' && (!_vm._.isEmpty(_vm.nota.favorecido.dadosBancariosSelecionados) || _vm.mostrarIncluindoConta))),
	      expression: "_.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS'], processo) || (processo === 'RESSARCIMENTO' && (!_.isEmpty(nota.favorecido.dadosBancariosSelecionados) || mostrarIncluindoConta))"
	    }]
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('banco')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.nota.formaPagamento !== 4
	      }),
	      expression: "{required: nota.formaPagamento !== 4}"
	    }],
	    attrs: {
	      "options": _vm.listaBancos,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Selecione um banco",
	      "custom-label": _vm.bancoNome,
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "banco",
	      "data-vv-as": "banco",
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || (_vm.processo === 'RESSARCIMENTO' && !_vm.mostrarIncluindoConta)
	    },
	    on: {
	      "select": _vm.selecionaBanco
	    },
	    model: {
	      value: (_vm.bancoSelecionado),
	      callback: function($$v) {
	        _vm.bancoSelecionado = $$v
	      },
	      expression: "bancoSelecionado"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('banco')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('agência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "title": '<h5> ' + (_vm._.has(_vm.bancoSelecionado, 'digitoAgencia') && !_vm.bancoSelecionado.digitoAgencia ? 'Informe a agência com 4 número sem dígito verificador. Exemplo: <span class=\'realce\'>1234</span>' : 'Informe a agência com 4 número e o dígito verificador. Exemplo: <span class=\'realce\'>1234-5</span>') + ' </h5>'
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "agência",
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || (_vm.processo === 'RESSARCIMENTO' && !_vm.mostrarIncluindoConta),
	      "type": "text",
	      "mask": _vm._.has(_vm.bancoSelecionado, 'digitoAgencia') && !_vm.bancoSelecionado.digitoAgencia ? '####' : '####-X',
	      "tokens": _vm.agenciaTokens,
	      "masked": ""
	    },
	    model: {
	      value: (_vm.nota.dados_bancarios.agencia),
	      callback: function($$v) {
	        _vm.$set(_vm.nota.dados_bancarios, "agencia", $$v)
	      },
	      expression: "nota.dados_bancarios.agencia"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('conta corrente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Conta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "conta corrente",
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || (_vm.processo === 'RESSARCIMENTO' && !_vm.mostrarIncluindoConta),
	      "type": "text",
	      "mask": ['#-X', '##-X', '###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X', '##########-X', '###########-X'],
	      "tokens": _vm.customTokens,
	      "masked": ""
	    },
	    model: {
	      value: (_vm.nota.dados_bancarios.conta),
	      callback: function($$v) {
	        _vm.$set(_vm.nota.dados_bancarios, "conta", $$v)
	      },
	      expression: "nota.dados_bancarios.conta"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo da conta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Tipo da Conta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.nota.formaPagamento !== 4
	      }),
	      expression: "{required: nota.formaPagamento !== 4}"
	    }],
	    attrs: {
	      "options": _vm.tiposConta,
	      "multiple": false,
	      "close-on-select": true,
	      "preselect-first": true,
	      "allow-empty": false,
	      "custom-label": _vm.tipoContaNome,
	      "placeholder": "Selecione um tipo de conta",
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "name": "tipo da conta",
	      "data-vv-as": "tipo da conta",
	      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.processo === 'PRESTACAO_DE_CONTAS' || (_vm.processo === 'RESSARCIMENTO' && !_vm.mostrarIncluindoConta)
	    },
	    on: {
	      "select": _vm.selecionaTipoConta
	    },
	    model: {
	      value: (_vm.tipoContaSelecionado),
	      callback: function($$v) {
	        _vm.tipoContaSelecionado = $$v
	      },
	      expression: "tipoContaSelecionado"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('tipo da conta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('tipo da conta')))]) : _vm._e()])])]), _vm._v(" "), _vm._m(15), _vm._v(" "), (_vm.mostrarIncluindoConta) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.favorecidoDadosBancariosOk($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.favorecidoDadosBancariosCancelar($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])], 1)]) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'PRESTACAO_DE_CONTAS') ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (true),
	      expression: "true"
	    }],
	    staticClass: "box-body",
	    attrs: {
	      "id": "adiantamentosConcedidos"
	    }
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Adiantamentos Concedidos "), (_vm.loading.adiantamentos) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (!_vm.loading.adiantamentos) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "title": '<h5>Filtros não alteram o total</h5>'
	    }
	  }, [_vm._v("Mostrar adiantamentos: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "checkbox-inline",
	    attrs: {
	      "title": '<h5>Mostrar o(s) adiantmentos com prestações pendentes</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adiantamentosFiltrosSelecionados),
	      expression: "adiantamentosFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "adiantamento_pendente"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.adiantamentosFiltrosSelecionados) ? _vm._i(_vm.adiantamentosFiltrosSelecionados, "adiantamento_pendente") > -1 : (_vm.adiantamentosFiltrosSelecionados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.adiantamentosFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "adiantamento_pendente",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.adiantamentosFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.adiantamentosFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.adiantamentosFiltrosSelecionados = $$c
	        }
	      }
	    }
	  }), _vm._v(" Pendente de prestação de contas "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive parcelasAdiantamento"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', [_c('tr', [_c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Número da parcela (ordem) do adiantamento</h5>'
	    }
	  }, [_vm._v("Parcela")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Origem do recurso da parcela</h5>'
	    }
	  }, [_vm._v("Origem do recurso")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Valor da parcela no instrumento legal</h5>'
	    }
	  }, [_vm._v("Valor previsto")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Valor solicitado dentro do limite total da parcela</h5>'
	    }
	  }, [_vm._v("Valor adiantado")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Total das prestações de contas realizadas para o valor adiantado</h5>'
	    }
	  }, [_vm._v("Valor Pendente")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado borda",
	    attrs: {
	      "title": '<h5>Percentual das prestações de contas realizadas para o valor adiantado</h5>'
	    }
	  }, [_vm._v("% Comprov.")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.adiantamentosConcecidos), function(adiantamento) {
	    return [(!_vm._.has(adiantamento, 'mostrar') || adiantamento.mostrar) ? [_c('tr', [_c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(adiantamento.recurso === 'FUNDACAO' ? 'Fundação BB' : (adiantamento.recurso === 'PARCEIRO_ESTRATEGICO' ? 'Parceiro Estratégico' : adiantamento.recurso)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.contratado)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.requisitado)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.pendente_comprovacao)))]), _vm._v(" "), _c('td', {
	      class: 'celula centralizado borda ' + (adiantamento.percentual_comprovado >= 1 ? 'atingido100' : (adiantamento.percentual_comprovado >= 0.8 ? 'atingido80' : 'nao_atingido'))
	    }, [_vm._v(_vm._s(_vm._f("percentage")(adiantamento.percentual_comprovado)))])])] : _vm._e()]
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm._.keys(_vm._.groupBy(_vm.adiantamentosConcecidos, 'recurso')).length === 2) ? _c('table', {
	    staticClass: "totais"
	  }, [_vm._m(16), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total já solicitado de adiantamento para esta projeto em parcela(s) com recursos da Fundação BB</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.fbb.solicitado)) + "\n                            ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total pendente de prestação de contas de acordo com total de adiantamento solicitado com recursos da Fundação BB</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.fbb.saldo)) + "\n                            ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total já solicitado de adiantamento para esta projeto em parcela(s) com recursos de Parceiros Estratégicos</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.parceiros.solicitado)) + "\n                            ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total pendente de prestação de contas de acordo com total de adiantamento solicitado com recursos de Parceiros Estratégicos</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.parceiros.saldo)) + "\n                            ")])])])]) : _c('table', {
	    staticClass: "totais"
	  }, [_vm._m(17), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total já solicitado de adiantamento para esta projeto</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.total.solicitado)) + "\n                            ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total pendente de prestação de contas de acordo com total de adiantamento solicitado</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.total.saldo)) + "\n                            ")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.processo !== 'CONTRAPARTIDA' && _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "calculoImposto"
	    }
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cálculo de Impostos "), (_vm.loading.analise_tributaria) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Tributado?")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.tributacao),
	      expression: "nota.tributacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tributacao",
	      "disabled": _vm.ehVisualizacao || (_vm._.includes(['TRIBUTADO', 'NAO_TRIBUTADO'], _vm.nota.tributacao) && !_vm._.includes(['Análise', 'Análise Tributária'], _vm.etapa)) || _vm.processo === 'RESSARCIMENTO'
	    },
	    domProps: {
	      "value": 'TRIBUTADO',
	      "checked": _vm._q(_vm.nota.tributacao, 'TRIBUTADO')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.nota, "tributacao", 'TRIBUTADO')
	      }
	    }
	  }), _vm._v(" Sim\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.tributacao),
	      expression: "nota.tributacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tributacao",
	      "disabled": _vm.ehVisualizacao || (_vm._.includes(['TRIBUTADO', 'NAO_TRIBUTADO'], _vm.nota.tributacao) && !_vm._.includes(['Análise', 'Análise Tributária'], _vm.etapa)) || _vm.processo === 'RESSARCIMENTO'
	    },
	    domProps: {
	      "value": 'NAO_TRIBUTADO',
	      "checked": _vm._q(_vm.nota.tributacao, 'NAO_TRIBUTADO')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.nota, "tributacao", 'NAO_TRIBUTADO')
	      }
	    }
	  }), _vm._v(" Não\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('tributacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tributacao')))]) : _vm._e()])]), _vm._v(" "), (!_vm.loading.analise_tributaria && !_vm._.isEmpty(_vm.analiseTributaria) && _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)) ? _c('div', [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(18), _vm._v(" "), _c('tbody', [_vm._l((_vm.analiseTributaria.produtos), function(produto) {
	    return _c('tr', [_c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "celula centralizado borda",
	      attrs: {
	        "title": '<h5>' + produto.CplPro + '</h5>'
	      }
	    }, [_vm._v(_vm._s(produto.CodPro) + " / " + _vm._s(produto.DesPro))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(0))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(0 / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrCrt))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerCof / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrPit))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerPit / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrCsl))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerCsl / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrIrf))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerIrf / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(0))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(0 / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrOur))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerOur / 100)))])])
	  }), _vm._v(" "), _vm._l((_vm.analiseTributaria.servicos), function(servico) {
	    return _c('tr', [_c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          placement: 'top',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', placement:'top', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "celula centralizado borda",
	      staticStyle: {
	        "width": "25%",
	        "font-weight": "bold"
	      },
	      attrs: {
	        "title": '<h5>' + servico.CplSer + '</h5>'
	      }
	    }, [_vm._v("\n                              " + _vm._s(servico.CodSer) + " / " + _vm._s(servico.DesSer) + "\n                            ")]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrIss))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerIss / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrCrt))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerCof / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrPit))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerPit / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrCsl))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerCsl / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrIrf))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerIrf / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrIns))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerIns / 100)))]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrOur))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerOur / 100)))])])
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total desta Solicitação")]), _vm._v(" "), (_vm.nota.tributacao === 'TRIBUTADO') ? _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total de Tributação")]) : _vm._e(), _vm._v(" "), (_vm.nota.tributacao === 'TRIBUTADO') ? _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total Líquido")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.analiseTributaria.nf.VlrInf)))]), _vm._v(" "), (_vm.nota.tributacao === 'TRIBUTADO') ? _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('money', {
	    staticClass: "form-control text-center",
	    staticStyle: {
	      "width": "60%",
	      "margin-left": "20%"
	    },
	    attrs: {
	      "name": "Total valorTributado",
	      "type": "text",
	      "disabled": !_vm._.includes(['Análise Tributária'], _vm.etapa)
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        _vm.nota.valorTributado = _vm.limitaFaixaEntrada('decimal', _vm.nota.valorTributado, 0, _vm.analiseTributaria.nf.VlrInf)
	      }
	    },
	    model: {
	      value: (_vm.nota.valorTributado),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "valorTributado", $$v)
	      },
	      expression: "nota.valorTributado"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.nota.tributacao === 'TRIBUTADO') ? _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(_vm._s(_vm._f("real")((parseFloat(_vm.analiseTributaria.nf.VlrInf) - _vm.nota.valorTributado))))]) : _vm._e()])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "cronogramaPagamento"
	    }
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma "), (_vm.loading.cronograma) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (!_vm.loading.cronograma) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "title": '<h5>Filtros não alteram o total</h5>'
	    }
	  }, [_vm._v("Mostrar item: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "checkbox-inline",
	    attrs: {
	      "title": '<h5>Mostrar o(s) item(ns) que ainda contém saldo</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.extratoFiltrosSelecionados),
	      expression: "extratoFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "saldos",
	      "disabled": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.extratoFiltrosSelecionados) ? _vm._i(_vm.extratoFiltrosSelecionados, "saldos") > -1 : (_vm.extratoFiltrosSelecionados)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.extratoFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "saldos",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.extratoFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.extratoFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.extratoFiltrosSelecionados = $$c
	        }
	      }
	    }
	  }), _vm._v(" Com saldo "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm._.has(_vm.validacao, 'itens_liberados')) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "checkbox-inline",
	    attrs: {
	      "title": '<h5>Mostrar somente o(s) item(ns) que foram solicitados</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "checkbox-inline new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.extratoFiltrosSelecionados),
	      expression: "extratoFiltrosSelecionados"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "solicitados",
	      "disabled": _vm.ehVisualizacao || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.extratoFiltrosSelecionados) ? _vm._i(_vm.extratoFiltrosSelecionados, "solicitados") > -1 : (_vm.extratoFiltrosSelecionados)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.extratoFiltrosSelecionados,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "solicitados",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.extratoFiltrosSelecionados = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.extratoFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.extratoFiltrosSelecionados = $$c
	        }
	      }, function($event) {
	        _vm.filtrarExtrato();
	        _vm.calcularTotaisExtato()
	      }]
	    }
	  }), _vm._v(" Somente solicitado "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm.totais.projeto.fbb.orcado > 0 && _vm.totais.projeto.parceiros.orcado > 0) ? _c('span', [_c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    },
	    attrs: {
	      "title": '<h5>' + (_vm.processo === 'PRESTACAO_DE_CONTAS' && _vm.totais.adiantamento.fbb.saldo <= 0 ? 'Não há pendência de prestação de contas com recursos da Fundação BB' : 'Mostrar o(s) item(ns) relacionados a Fundação BB') + '</h5>'
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "filtro_origem_recurso",
	      "disabled": _vm.ehVisualizacao || (_vm.processo === 'PRESTACAO_DE_CONTAS' && _vm.totais.adiantamento.fbb.saldo <= 0) || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)
	    },
	    domProps: {
	      "checked": _vm._.includes(_vm.extratoFiltrosSelecionados, 'fundacao')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filtrarPorOrigemRecurso('fundacao')
	      }
	    }
	  }), _vm._v(" Fundação "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    },
	    attrs: {
	      "title": '<h5>' + (_vm.processo === 'PRESTACAO_DE_CONTAS' && _vm.totais.adiantamento.parceiros.saldo <= 0 ? 'Não há pendência de prestação de contas com recursos de Parceiro Estratégico' : 'Mostrar o(s) item(ns) relacionados ao Parceiro Estratégico') + '</h5>'
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "filtro_origem_recurso",
	      "disabled": _vm.ehVisualizacao || (_vm.processo === 'PRESTACAO_DE_CONTAS' && _vm.totais.adiantamento.parceiros.saldo <= 0) || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)
	    },
	    domProps: {
	      "checked": _vm._.includes(_vm.extratoFiltrosSelecionados, 'parceiro')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filtrarPorOrigemRecurso('parceiro')
	      }
	    }
	  }), _vm._v(" Parceiro Estratégico "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e()])])]), _vm._v(" "), (_vm.totais.projeto.fbb.orcado > 0 && _vm.totais.projeto.parceiros.orcado > 0) ? _c('div', {
	    staticClass: "col-md-offset-2 col-md-10",
	    staticStyle: {
	      "color": "var(--cor-destaque)",
	      "margin-top": "-10px"
	    }
	  }, [_vm._v("\n                        Atenção: Selecione os itens relacionados a Fundação "), _c('strong', [_vm._v("OU")]), _vm._v(" ao Parceiro Estratégico\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "2",
	      "title": '<h5>Valor total contratado no projeto por Atividade e Item</h5>'
	    }
	  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "2",
	      "title": '<h5>Saldo restante de cada Atividade e Item</h5>'
	    }
	  }, [_vm._v("Saldo")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "2",
	      "title": '<h5>Informe o que consta no documento (quantidade e valor)</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm.processo === 'CONTRAPARTIDA' ? 'Comprovação' : 'Solicitação'))]), _vm._v(" "), (_vm.processo === 'CONTRAPARTIDA' && _vm._.includes(['Análise'], _vm.etapa)) ? _c('th') : _vm._e()]), _vm._v(" "), _c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', [_vm._v(_vm._s((_vm.layoutExtrato === 'porOrigem' ? 'Origem do Recurso' : 'Atividade')) + " / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor")]), _vm._v(" "), (_vm.processo === 'CONTRAPARTIDA' && _vm._.includes(['Análise'], _vm.etapa)) ? _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Economicidade")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l(((_vm.layoutExtrato === 'classico' ? [
	    ['1', '5', '2']
	  ] : (_vm.layoutExtrato === 'porOrigem') ? [
	    ['1', '5']
	  ] : [
	    ['2']
	  ])), function(origem) {
	    return [(_vm.layoutExtrato === 'porOrigem') ? _c('tr', [_c('td', {
	      staticClass: "atividade",
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_vm._v(_vm._s((_vm._.includes(origem, '2')) ? 'Recursos de Contrapartida' : 'Recursos da Fundação BB'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cronograma.atividades), function(atividade) {
	      return ((_vm._.filter(_vm.cronograma.itens, function(i) {
	        return i.Atividade_nome === atividade.Nome && _vm._.includes((_vm.processo === 'CONTRAPARTIDA' ? ['2'] : ['1', '5']), ('' + i.Item_Origem).substring(0, 1)) && (!_vm._.has(i, 'mostrar') || i.mostrar)
	      })).length > 0) ? [(_vm.layoutExtrato === 'classico') ? _c('tr', {
	        staticClass: "atividade"
	      }, [_c('td', {
	        staticClass: "esquerda celula b1 b3 b4 nome_atividade"
	      }, [_vm._v(_vm._s(atividade.Nome))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b4"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b4"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b4"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b2"
	      }, [_vm._v(" ")]), _vm._v(" "), (_vm.processo === 'CONTRAPARTIDA' && _vm._.includes(['Análise'], _vm.etapa)) ? _c('td', {
	        staticClass: "centralizado celula b1 b3 b2"
	      }, [_vm._v(" ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.filter(_vm.cronograma.itens, {
	        'Atividade_nome': atividade.Nome
	      })), function(item) {
	        return (_vm._.includes((_vm.processo === 'CONTRAPARTIDA' ? ['2'] : ['1', '5']), ('' + item.Item_Origem).substring(0, 1))) ? [(!_vm._.has(item, 'mostrar') || item.mostrar) ? [_c('tr', [_c('td', {
	          staticClass: "celula b3 b4"
	        }, [_c('div', {
	          staticClass: "item",
	          style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 80%; float: left;' : '')
	        }, [_c('div', {
	          staticClass: "item_despesa esquerda"
	        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.Item_Tipo))) + ")  " + _vm._s(item.Item + ' / ' + item.Item_Descricao))]), _vm._v(" "), _c('div', {
	          staticClass: "observacao esquerda",
	          domProps: {
	            "innerHTML": _vm._s('<span class=id_item>#' + item.Id_item + '</span>  ' + item.Item_Observacao + '</span>')
	          }
	        })]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	          staticStyle: {
	            "width": "20%",
	            "text-align": "right",
	            "float": "right",
	            "color": "var(--cor-fraca)"
	          }
	        }, [_vm._v(_vm._s(item.Item_Conta))]) : _vm._e()]), _vm._v(" "), _c('td', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado celula b3 b4",
	          attrs: {
	            "title": '<h5>' + (!_vm._.has(item, 'Item_Unidade_medida') || _vm._.isNull(item.Item_Unidade_medida) ? 'Sem unid. de medida' : (item.Item_Unidade_medida === 'Outros' && _vm._.has(item, 'Item_Unidade_medida_outros') && !_vm._.isNull(item.Item_Unidade_medida_outros) ? ('Outros:<br/>' + item.Item_Unidade_medida_outros) : item.Item_Unidade_medida)) + '</h5>'
	          }
	        }, [_vm._v("\n                                      " + _vm._s(item.Qtde_orcado) + "\n                                    ")]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3"
	        }, [_vm._v("\n                                      " + _vm._s(_vm._f("decimal2")(item.Valor_orcado)) + "\n                                    ")]), _vm._v(" "), _c('td', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado celula b3 b4",
	          attrs: {
	            "title": '<h5>' + (!_vm._.has(item, 'Item_Unidade_medida') || _vm._.isNull(item.Item_Unidade_medida) ? 'Sem unid. de medida' : (item.Item_Unidade_medida === 'Outros' && _vm._.has(item, 'Item_Unidade_medida_outros') && !_vm._.isNull(item.Item_Unidade_medida_outros) ? ('Outros:<br/>' + item.Item_Unidade_medida_outros) : item.Item_Unidade_medida)) + '</h5>'
	          }
	        }, [_vm._v("\n                                      " + _vm._s(item.Qtde_saldo - parseFloat(item.Qtde_solicitado)) + "\n                                    ")]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b2 b3"
	        }, [_vm._v("\n                                      " + _vm._s(_vm._f("decimal2")(item.Valor_saldo - parseFloat(item.Valor_solicitado))) + "\n                                    ")]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b4 qtdeSolicitacao",
	          class: parseFloat(item.Qtde_solicitado) === 0 && parseFloat(item.Valor_solicitado) !== 0 ? 'qtde_pendente' : ''
	        }, [_c('input', {
	          staticClass: "form-control text-right qtdeSolicitacao",
	          attrs: {
	            "name": "quantidade a solicitar",
	            "type": "text",
	            "disabled": parseFloat(item.Qtde_saldo) <= 0 || parseFloat(item.Valor_saldo) <= 0 || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	          },
	          domProps: {
	            "value": item.Qtde_solicitado
	          },
	          on: {
	            "input": function($event) {
	              return _vm.validaQuantidade($event, item)
	            },
	            "blur": _vm.verificaCorrigeDados
	          }
	        })]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 valorSolicitacao",
	          class: parseFloat(item.Qtde_solicitado) !== 0 && parseFloat(item.Valor_solicitado) === 0 ? 'valor_pendente' : ''
	        }, [_c('money', {
	          staticClass: "form-control text-right valorSolicitacao",
	          attrs: {
	            "name": "valor a solicitar",
	            "type": "text",
	            "disabled": parseFloat(item.Qtde_saldo) <= 0 || parseFloat(item.Valor_saldo) <= 0 || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
	          },
	          nativeOn: {
	            "keyup": function($event) {
	              item.Valor_solicitado = _vm.limitaFaixaEntrada('decimal', item.Valor_solicitado, 0, item.Valor_saldo)
	            },
	            "blur": function($event) {
	              return _vm.calcularTotaisExtato($event)
	            }
	          },
	          model: {
	            value: (item.Valor_solicitado),
	            callback: function($$v) {
	              _vm.$set(item, "Valor_solicitado", $$v)
	            },
	            expression: "item.Valor_solicitado"
	          }
	        })], 1), _vm._v(" "), (_vm.processo === 'CONTRAPARTIDA' && _vm._.includes(['Análise'], _vm.etapa)) ? _c('td', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado celula b2 b3 b4",
	          attrs: {
	            "title": '<h5>Seleciona aqui se o item está comprovado com economicidade</h5>'
	          }
	        }, [_c('label', {
	          staticClass: "checkbox-inline new-control new-control-checkbox",
	          staticStyle: {
	            "vertical-align": "top"
	          }
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (item.Economicidade),
	            expression: "item.Economicidade"
	          }],
	          attrs: {
	            "type": "checkbox",
	            "false-value": 0,
	            "true-value": 1,
	            "disabled": parseFloat(item.Qtde_solicitado) === 0 && parseFloat(item.Valor_solicitado) === 0 || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.ehVisualizacao
	          },
	          domProps: {
	            "checked": Array.isArray(item.Economicidade) ? _vm._i(item.Economicidade, null) > -1 : _vm._q(item.Economicidade, 1)
	          },
	          on: {
	            "change": [function($event) {
	              var $$a = item.Economicidade,
	                $$el = $event.target,
	                $$c = $$el.checked ? (1) : (0);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(item, "Economicidade", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(item, "Economicidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(item, "Economicidade", $$c)
	              }
	            }, _vm.selecaoEconomicidade]
	          }
	        }), _vm._v(" "), _c('div', {
	          staticClass: "new-control-indicator"
	        })])]) : _vm._e()])] : _vm._e()] : _vm._e()
	      })] : _vm._e()
	    })]
	  })], 2)])])]), _vm._v(" "), (!_vm.loading.cronograma) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', [_vm._v("Total Contrapartida")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.adiantamento.total.orcado !== 0) ? _c('span', [_vm._v("Total Adiantável")]) : _vm._e()]), _vm._v(" "), (_vm.processo === 'PRESTACAO_DE_CONTAS') ? _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Limite pendente")]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total desta Solicitação")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado com recursos da Fundação</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb.orcado)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado com recursos de Parceiro Estratégico</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros.orcado)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado com recursos da Contrapartida</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida.orcado)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado para este projeto</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.orcado)) + "\n                              ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.adiantamento.total.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total orçado para Adiantamento</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.total.orcado)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), (_vm.processo === 'PRESTACAO_DE_CONTAS') ? _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm._.includes(_vm.extratoFiltrosSelecionados, 'fundacao')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Saldo máximo disponível sobre o(s) adiantamento(s) liberados(s) com recursos da <span class=\'realce\'>Fundação</span> para prestar contas ou devolver</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.adiantamento.fbb.saldo)))]) : (_vm._.includes(_vm.extratoFiltrosSelecionados, 'parceiro')) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Saldo máximo disponível sobre o(s) adiantamento(s) liberados(s) com recursos de <span class=\'realce\'>Parceiro Estratégicos</span> para prestar contas ou devolver</h5>'
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.adiantamento.parceiros.saldo)))]) : _c('span', {
	    staticClass: "realce"
	  }, [_vm._v("Deve selecionar Fundação ou Parceiro no filtro")])]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor",
	    attrs: {
	      "rowspan": "2"
	    }
	  }, [(_vm.processo === 'PRESTACAO_DE_CONTAS' && (
	    (_vm._.includes(_vm.extratoFiltrosSelecionados, 'fundacao') && _vm.totais.projeto.fbb.solicitado > _vm.totais.adiantamento.fbb.saldo) ||
	    (_vm._.includes(_vm.extratoFiltrosSelecionados, 'parceiro') && _vm.totais.projeto.parceiros.solicitado > _vm.totais.adiantamento.parceiros.saldo))) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "label label-danger",
	    staticStyle: {
	      "font-style": "unset"
	    },
	    attrs: {
	      "title": '<h5>O total desta solicitação ultrapassou o limite pendente (saldo máximo disponível) para prestar contas</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.solicitado)) + "\n                              ")]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total desta solicitação</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.solicitado)) + "\n                              ")])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo dos recursos da Fundação com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.fbb.saldo / _vm.totais.projeto.fbb.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb.saldo)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo dos recursos de Parceiro Estratégico com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.parceiros.saldo / _vm.totais.projeto.parceiros.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros.saldo)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo dos recursos da Contrapartida com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.contrapartida.saldo / _vm.totais.projeto.contrapartida.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida.saldo)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo total do projeto com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.total.saldo / _vm.totais.projeto.total.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.saldo)) + "\n                              ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.adiantamento.total.orcado !== 0 && false) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "saldo",
	    attrs: {
	      "title": '<h5>Saldo dos Adiantamento não solicitados ainda</h5>'
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.total.saldo)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_vm._v(" ")])])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.ehNFe && !_vm._.isNull(_vm.nfe.xmlNfe) && !_vm._.isNull(_vm.nfe.protocoloValidacao)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(19), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed"
	  }, [_vm._m(20), _vm._v(" "), _c('tbody', _vm._l((_vm._.isPlainObject(_vm.nfe.xmlNfe.NFe.infNFe.det) ? [_vm.nfe.xmlNfe.NFe.infNFe.det] : _vm.nfe.xmlNfe.NFe.infNFe.det), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item['@nItem']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.prod.xProd) + " "), (_vm._.has(item.prod, 'DI')) ? _c('span', {
	      staticStyle: {
	        "color": "var(--cor-atencao)",
	        "font-weight": "bold"
	      }
	    }, [_vm._v(" (importado)")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("decimal2")(item.prod.qCom)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.prod.vUnCom)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.prod.vProd)))])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_vm._m(21), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Quantidade de itens que consta nesta NF-e</h5>'
	    }
	  }, [_vm._v("\n                            " + _vm._s((_vm._.isPlainObject(_vm.nfe.xmlNfe.NFe.infNFe.det) ? [_vm.nfe.xmlNfe.NFe.infNFe.det] : _vm.nfe.xmlNfe.NFe.infNFe.det).length) + "\n                          ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total bruto desta NF-e</h5>'
	    }
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm._.sumBy((_vm._.isPlainObject(_vm.nfe.xmlNfe.NFe.infNFe.det) ? [_vm.nfe.xmlNfe.NFe.infNFe.det] : _vm.nfe.xmlNfe.NFe.infNFe.det), function(i) {
	    return (i.prod.indTot === '1' ? parseFloat(i.prod.vProd) : 0)
	  }))) + "\n                          ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.ehProjetoEspecial && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.processo === 'PAGAMENTO' && _vm.aprovacao.resultadoAprovacao !== 'Revisão') ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.mostrarDadosComplementares = !_vm.mostrarDadosComplementares
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrarDadosComplementares ? 'up' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "cursor": "pointer"
	    }
	  }, [_vm._v("Dados complementares")]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'top'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	    }],
	    staticClass: "fa fa-question-circle text-gray",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Projetos Especiais (Enchentes, Covid, BPB etc) nescessitam de dados complementares como qual o município, valor e quantidade de participantes os quais são destinados este pagamento</h5>'
	    }
	  }), _vm._v(" "), (_vm.loading.municipios) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _vm._e()])])]), _vm._v(" "), (_vm.mostrarDadosComplementares) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.etapa === 'Análise') ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.novoDadosComplementares($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir\n                      ")]), _vm._v(" "), _c('br'), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "centralizado w20"
	  }, [_vm._v("Município")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado w15"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado w30"
	  }, [_vm._v("Destinação")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado w10"
	  }, [_vm._v("Famílias")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado w10"
	  }, [_vm._v("Participantes")]), _vm._v(" "), (_vm.etapa === 'Análise') ? _c('th', {
	    staticClass: "centralizado w10"
	  }, [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.nota.dadosComplementares), function(item, index) {
	    return (_vm.nota.dadosComplementares.length > 0) ? _c('tr', {
	      key: index + item.municipio
	    }, [_c('td', {
	      staticClass: "centralizado"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	      }],
	      attrs: {
	        "title": '<h5>' + (_vm._.has(item.municipio, 'nomcid') ? item.municipio.nomcid + ' / ' + item.municipio.sigufs : 'Selecione um município') + '</h5>'
	      }
	    }, [_c('multiselect', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      attrs: {
	        "options": _vm.municipiosUf,
	        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
	        "placeholder": "Nome do município",
	        "label": "nomcid",
	        "group-values": "municipios",
	        "group-label": "uf",
	        "track-by": "codrai",
	        "preselect-first": false,
	        "close-on-select": true,
	        "selectLabel": "Selecionar",
	        "deselectLabel": "Desselecionar",
	        "selectedLabel": "",
	        "name": "municipio"
	      },
	      model: {
	        value: (item.municipio),
	        callback: function($$v) {
	          _vm.$set(item, "municipio", $$v)
	        },
	        expression: "item.municipio"
	      }
	    })], 1)]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado"
	    }, [_c('money', {
	      staticClass: "form-control text-center",
	      attrs: {
	        "name": "valor em dado complementar",
	        "type": "text",
	        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	      },
	      nativeOn: {
	        "keyup": function($event) {
	          item.valor = _vm.limitaFaixaEntrada('decimal', item.valor, 0, _vm.totais.projeto.total.solicitado)
	        }
	      },
	      model: {
	        value: (item.valor),
	        callback: function($$v) {
	          _vm.$set(item, "valor", $$v)
	        },
	        expression: "item.valor"
	      }
	    })], 1), _vm._v(" "), _c('td', {
	      staticClass: "centralizado"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.destinacao),
	        expression: "item.destinacao"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "name": "destinacao em dado complementar",
	        "type": "text",
	        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	      },
	      domProps: {
	        "value": (item.destinacao)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "destinacao", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.familias),
	        expression: "item.familias"
	      }],
	      staticClass: "form-control text-center",
	      attrs: {
	        "name": "familias em dado complementar",
	        "type": "text",
	        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	      },
	      domProps: {
	        "value": (item.familias)
	      },
	      on: {
	        "keyup": function($event) {
	          item.familias = _vm.limitaFaixaEntrada('inteiro', item.familias, 0, 9999999)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "familias", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.participantes),
	        expression: "item.participantes"
	      }],
	      staticClass: "form-control text-center",
	      attrs: {
	        "name": "participantes em dado complementar",
	        "type": "text",
	        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
	      },
	      domProps: {
	        "value": (item.participantes)
	      },
	      on: {
	        "keyup": function($event) {
	          item.participantes = _vm.limitaFaixaEntrada('inteiro', item.participantes, 0, 9999999)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "participantes", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), (_vm.etapa === 'Análise') ? _c('td', {
	      staticClass: "centralizado"
	    }, [_c('g-button-moema', {
	      attrs: {
	        "color": "error",
	        "type": "button"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.excluiDadosComplementares(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _vm._e()]) : _vm._e()
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarDadosComplementares) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.nota.dadosComplementares.length > 0) ? _c('table', {
	    staticClass: "totais"
	  }, [_vm._m(22), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Se trata da quantidade registros de dados complementares que há acima</h5>'
	    }
	  }, [_vm._v("\n                            " + _vm._s(_vm.nota.dadosComplementares.length) + "\n                          ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Valor total discriminado nos registros destes dados complementares<br/><br/>Não pode exceder o limite do solicitado nesta ID de<br/>R$ ' + (_vm.totais.projeto.total.solicitado) + '</h5>'
	    }
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
	    return parseFloat(d.valor)
	  }))) + "\n                            "), (_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
	    return parseFloat(d.valor)
	  }) > _vm.totais.projeto.total.solicitado) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v("Ultrapassou " + _vm._s(_vm._f("real")((_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
	    return parseFloat(d.valor)
	  }) - _vm.totais.projeto.total.solicitado))))]) : _vm._e()])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Quantidde total de famílias beneficiadas informadas nestes dados complementares</h5>'
	    }
	  }, [_vm._v("\n                            " + _vm._s(_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
	    return parseInt(d.familias)
	  })) + "\n                          ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Quantidde total de participantes beneficiários informados nestes dados complementares</h5>'
	    }
	  }, [_vm._v("\n                            " + _vm._s(_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
	    return parseInt(d.participantes)
	  })) + "\n                          ")])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "infoProjetoObservacoes"
	    }
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações do Projeto "), (_vm.loading.analise_tributaria) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (!_vm._.isEmpty(_vm.analiseTributaria)) ? _c('div', [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(23), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "celula centralizado borda"
	  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.codban))]), _vm._v(" "), _c('td', {
	    staticClass: "celula centralizado borda"
	  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.codage))]), _vm._v(" "), _c('td', {
	    staticClass: "celula centralizado borda"
	  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.ccbfor))]), _vm._v(" "), _c('td', {
	    staticClass: "celula centralizado borda"
	  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.usu_mci))]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "celula centralizado borda",
	    attrs: {
	      "title": '<h5>' + _vm.analiseTributaria.contas_projeto.DesCco + '</h5>'
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm.analiseTributaria.contas_projeto.NumCco) + "\n                            ")]), _vm._v(" "), _c('td', {
	    staticClass: "celula centralizado borda"
	  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.codtpj))])])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "observacaoCI"
	    }
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Observação do Documento Fiscal "), (_vm.loading.analise_tributaria) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (!_vm._.isEmpty(_vm.analiseTributaria)) ? _c('div', [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao_nf",
	      "rows": "3",
	      "disabled": true
	    },
	    model: {
	      value: (_vm.analiseTributaria.nf.ObsNfc),
	      callback: function($$v) {
	        _vm.$set(_vm.analiseTributaria.nf, "ObsNfc", $$v)
	      },
	      expression: "analiseTributaria.nf.ObsNfc"
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(24), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.nota.anexos,
	      "documentTypes": '',
	      "disable": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
	      "local-uso": 'SOLICITACAO_PAGAMENTO'
	    }
	  })], 1)]), _vm._v(" "), (_vm._.includes(['Revisão', 'Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.ehVisualizacao) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de solicitação "), (_vm.loading.cronograma) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
	    key: _vm.historicoBack.length,
	    attrs: {
	      "propsValidacao": _vm.validacao,
	      "propsHistorico": _vm.historicoBack
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack)) && !_vm.loading.cronograma) ? _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderHistorico === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack)) && !_vm.loading.cronograma) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_vm._m(25), _vm._v(" "), _c('historico-antigo', {
	    key: _vm.historicoTarefas.length,
	    attrs: {
	      "propsValidacao": _vm.validacao,
	      "propsHistorico": _vm.historicoTarefas
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && _vm.usuarioLogado.userType !== 'FUNDACAO')) ? _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(26), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.observacao),
	      expression: "nota.observacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao_opcional",
	      "id": "observacao_opcional",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.nota.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "observacao", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.entidade) && !_vm.loading.tela && _vm.processo !== 'CONTRAPARTIDA' && !_vm.ehProjetosPovosTradicionais && !_vm.ehProjetoEcoforte) ? _c('div', {
	    staticClass: "box-body ciente_declaracoes"
	  }, [(_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && !_vm.ehVisualizacao) ? _c('div', _vm._l((_vm.declaracoes), function(declaracao) {
	    return _c('div', {
	      class: 'alert alert-dismissible alert-' + (_vm._.find(_vm.cienteDeclaracoes, ['codigo', declaracao.codigo]) ? 'success' : 'warning')
	    }, [_vm._m(27, true), _vm._v(" "), _c('p', [_c('i', {
	      class: _vm._.find(_vm.cienteDeclaracoes, ['codigo', declaracao.codigo]) ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.ciente(declaracao.codigo)
	        }
	      }
	    }), _vm._v("\n                        " + _vm._s(_vm.textoDeclaracao(declaracao.texto)) + "\n                      ")])])
	  }), 0) : _c('div', {
	    staticClass: "col-md-12"
	  }, _vm._l((_vm.cienteDeclaracoes), function(declaracao) {
	    return _c('div', {
	      staticClass: "form-group well"
	    }, [_c('div', {
	      staticClass: "col-md-9"
	    }, [_vm._v(_vm._s(_vm.textoDeclaracao(declaracao.texto)))]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3 text-right"
	    }, [_vm._v("\n                        " + _vm._s(declaracao.usuario.nome)), _c('br'), _vm._v("\n                        " + _vm._s(_vm._f("moment")(declaracao.data, 'DD/MM/YYYY HH:mm')) + "\n                      ")])])
	  }), 0), _vm._v(" "), (_vm.objetoComDeclaracoes) ? _c('span', [(_vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.ehVisualizacao) ? _c('div', _vm._l((_vm.objetoComDeclaracoes), function(declaracao) {
	    return _c('div', {
	      staticClass: "form-group well"
	    }, [_c('div', {
	      staticClass: "col-md-9"
	    }, [_vm._v(_vm._s(_vm.textoDeclaracao(declaracao.texto)))]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3 text-right"
	    }, [_vm._v("\n                          " + _vm._s(declaracao.usuario.nome)), _c('br'), _vm._v("\n                          " + _vm._s(_vm._f("moment")(declaracao.data, 'DD/MM/YYYY HH:mm')) + "\n                        ")])])
	  }), 0) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.entidade) && !_vm.loading.tela && _vm.processo !== 'CONTRAPARTIDA' && _vm.ehProjetoEcoforte) ? _c('div', {
	    staticClass: "box-body ciente_declaracoes"
	  }, [(_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && !_vm.ehVisualizacao) ? _c('div', _vm._l((_vm.declaracoesEcoforte), function(declaracao) {
	    return _c('div', {
	      class: 'alert alert-dismissible alert-' + (_vm._.find(_vm.cienteDeclaracoes, ['codigo', declaracao.codigo]) ? 'success' : 'warning')
	    }, [_vm._m(28, true), _vm._v(" "), _c('p', [_c('i', {
	      class: _vm._.find(_vm.cienteDeclaracoes, ['codigo', declaracao.codigo]) ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.ciente(declaracao.codigo)
	        }
	      }
	    }), _vm._v("\n                        " + _vm._s(_vm.textoDeclaracao(declaracao.texto)) + "\n                      ")])])
	  }), 0) : _c('div', {
	    staticClass: "col-md-12"
	  }, _vm._l((_vm.cienteDeclaracoes), function(declaracao) {
	    return _c('div', {
	      staticClass: "form-group well"
	    }, [_c('div', {
	      staticClass: "col-md-9"
	    }, [_vm._v(_vm._s(_vm.textoDeclaracao(declaracao.texto)))]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3 text-right"
	    }, [_vm._v("\n                        " + _vm._s(declaracao.usuario.nome)), _c('br'), _vm._v("\n                        " + _vm._s(_vm._f("moment")(declaracao.data, 'DD/MM/YYYY HH:mm')) + "\n                      ")])])
	  }), 0), _vm._v(" "), (_vm.objetoComDeclaracoes) ? _c('span', [(_vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.ehVisualizacao) ? _c('div', [_vm._l((_vm.objetoComDeclaracoes), function(declaracao) {
	    return [(declaracao.codigo === 'fornecedoresNaoLigadosDirigentes') ? _c('div', {
	      staticClass: "form-group well"
	    }, [_c('div', {
	      staticClass: "col-md-9"
	    }, [_vm._v(_vm._s(_vm.textoDeclaracao(declaracao.texto)))]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3 text-right"
	    }, [_vm._v("\n                          " + _vm._s(declaracao.usuario.nome)), _c('br'), _vm._v("\n                          " + _vm._s(_vm._f("moment")(declaracao.data, 'DD/MM/YYYY HH:mm')) + "\n                        ")])]) : _vm._e()]
	  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.ehVisualizacao) ? _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "decisoes_aprovação"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": _vm.etapa === 'Análise' ? (_vm.processo === 'CONTRAPARTIDA' ? 'Conclusão' : 'Análise Tributária') : (_vm.etapa === 'Análise Tributária' ? 'Autorização' : (_vm.etapa === 'Autorização' ? (_vm.processo === 'PRESTACAO_DE_CONTAS' ? 'Conclusão' : (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão')) : (_vm.etapa === 'Liquidação' ? 'Conclusão' : ''))),
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, _vm.etapa === 'Análise' ? (_vm.processo === 'CONTRAPARTIDA' ? 'Conclusão' : 'Análise Tributária') : (_vm.etapa === 'Análise Tributária' ? 'Autorização' : (_vm.etapa === 'Autorização' ? (_vm.processo === 'PRESTACAO_DE_CONTAS' ? 'Conclusão' : (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão')) : (_vm.etapa === 'Liquidação' ? 'Conclusão' : ''))))
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.aprovacao, "resultadoAprovacao", _vm.etapa === 'Análise' ? (_vm.processo === 'CONTRAPARTIDA' ? 'Conclusão' : 'Análise Tributária') : (_vm.etapa === 'Análise Tributária' ? 'Autorização' : (_vm.etapa === 'Autorização' ? (_vm.processo === 'PRESTACAO_DE_CONTAS' ? 'Conclusão' : (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão')) : (_vm.etapa === 'Liquidação' ? 'Conclusão' : ''))))
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.etapa === 'Liquidação' ? 'Concluir processo manualmente' : 'Aprovar solicitação') + "\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _vm._l((_vm.decisoesDaAnaliseVisiveis), function(decisao) {
	    return _c('div', {
	      key: decisao.chave
	    }, [_c('label', {
	      staticClass: "new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "8px"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.aprovacao.resultadoAprovacao),
	        expression: "aprovacao.resultadoAprovacao"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "decisão",
	        "disabled": _vm.ehVisualizacao
	      },
	      domProps: {
	        "value": decisao.chave,
	        "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, decisao.chave)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.$set(_vm.aprovacao, "resultadoAprovacao", decisao.chave)
	        }
	      }
	    }), _vm._v(" " + _vm._s(decisao.rotulo) + "\n                          "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])
	  }), _vm._v(" "), (_vm.processo !== 'CONTRAPARTIDA' && ((_vm.etapa === 'Análise' && _vm.proximaEtapaEscolhida === 'Análise Tributária') || (_vm.etapa === 'Análise Tributária' && _vm.aprovacao.resultadoAprovacao === 'Autorização') || (_vm.etapa === 'Autorização' && _vm.aprovacao.resultadoAprovacao === 'Conclusão') || (_vm.etapa === 'Autorização' && _vm.aprovacao.resultadoAprovacao === 'Liquidação'))) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Integrar com Sapiens?")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.bypass),
	      expression: "nota.bypass"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "bypass",
	      "disabled": _vm.etapa !== 'Análise' || _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": '',
	      "checked": _vm._q(_vm.nota.bypass, '')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.nota, "bypass", '')
	      }
	    }
	  }), _vm._v(" Sim\n                                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.bypass),
	      expression: "nota.bypass"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "bypass",
	      "disabled": _vm.etapa !== 'Análise' || _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": 'BYPASS',
	      "checked": _vm._q(_vm.nota.bypass, 'BYPASS')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.nota, "bypass", 'BYPASS')
	      }
	    }
	  }), _vm._v(" Não\n                                "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.exibeObservacaoAprovacao) ? _c('div', {
	    staticClass: "col-md-12",
	    class: {
	      'required-field': _vm.observacaoAprovacaoObrigatoria, 'has-error': _vm.errors.first('observação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao_decisao"
	    }
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.observacao),
	      expression: "nota.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.observacaoAprovacaoObrigatoria ? 'required|min:13' : ''),
	      expression: "observacaoAprovacaoObrigatoria ? 'required|min:13' : ''"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observação",
	      "id": "observacao_decisao",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.nota.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('observação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('observação')))]) : _vm._e(), _vm._v(" "), (_vm.observacaoAprovacaoObrigatoria) ? _c('p', {
	    staticClass: "help-block"
	  }, [_vm._v("Informe no mínimo 13 caracteres.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.decisaoDaAnalise) ? _c('div', {
	    staticClass: "col-md-12",
	    class: {
	      'required-field': _vm.decisaoDaAnalise.motivo.obrigatorio, 'has-error': _vm.errors.first('motivo da decisão')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "motivo_decisao_analise"
	    }
	  }, [_vm._v(_vm._s(_vm.decisaoDaAnalise.motivo.rotulo))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.observacao),
	      expression: "nota.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.decisaoDaAnalise.motivo.obrigatorio ? 'required' : ''),
	      expression: "decisaoDaAnalise.motivo.obrigatorio ? 'required' : ''"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "motivo da decisão",
	      "id": "motivo_decisao_analise",
	      "rows": "3",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.nota.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('motivo da decisão')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo da decisão')))]) : _vm._e(), _vm._v(" "), (_vm.decisaoDaAnalise.ajuda) ? _c('p', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.decisaoDaAnalise.ajuda))]) : _vm._e()]) : _vm._e()])], 2), _vm._v(" "), (_vm.etapa === 'Análise') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "Revisão",
	      "disabled": _vm.ehVisualizacao || (_vm._.includes(['PAGAMENTO', 'RESSARCIMENTO', 'PRESTACAO_DE_CONTAS'], this.processo) && ((_vm.projeto.Status_ERP !== 'APR' && _vm.possuiNotaSapiens) || _vm.tituloMovimentado))
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Revisão")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Revisão")
	      }
	    }
	  }), _vm._v(" Encaminhar para revisão da entidade\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm._.includes(['PAGAMENTO', 'RESSARCIMENTO', 'PRESTACAO_DE_CONTAS'], this.processo)) ? _c('div', [(_vm.projeto.Status_ERP !== 'APR' && _vm.possuiNotaSapiens) ? _c('p', {
	    staticClass: "col-md-12 text-danger"
	  }, [_c('strong', [_vm._v(" Atenção:")]), _vm._v(" Não é possível devolver para a entidade pois o projeto está com status diferente de APR e com nota no Sapiens.")]) : _vm._e(), _vm._v(" "), (_vm.tituloMovimentado) ? _c('p', {
	    staticClass: "col-md-12 text-danger"
	  }, [_c('strong', [_vm._v(" Atenção:")]), _vm._v(" Não é possível devolver para a entidade pois a nota possui movimento contábil.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group required-field full col-md-12",
	    class: {
	      'has-error': _vm.errors.first('motivo de devolucao')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.motivosDevolucao,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Selecione um motivo de Devolução para a entidade",
	      "custom-label": _vm.motivoDevolucaoDescricao,
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "motivo de devolucao",
	      "data-vv-as": "motivo de devolucao",
	      "option-height": 30,
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.motivoDevolucao),
	      callback: function($$v) {
	        _vm.motivoDevolucao = $$v
	      },
	      expression: "motivoDevolucao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.aprovacao.resultadoAprovacao === 'Revisão' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa_revisão"
	    }
	  }, [_vm._v("Motivo para revisão:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.observacao),
	      expression: "nota.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "motivo para revisão",
	      "rows": "3",
	      "id": "justificativa_revisão",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.nota.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('motivo para revisão')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo para revisão')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "Análise",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Análise")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Análise")
	      }
	    }
	  }), _vm._v(" Retornar para análise\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.aprovacao.resultadoAprovacao === 'Análise' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('justificativa reanalise')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa_reanalise"
	    }
	  }, [_vm._v("Motivo para reanalisar:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.observacao),
	      expression: "nota.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa reanalise",
	      "rows": "3",
	      "id": "justificativa_reanalise",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.nota.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa reanalise')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa reanalise')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Autorização'], _vm.etapa)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "Análise Tributária",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Análise Tributária")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Análise Tributária")
	      }
	    }
	  }), _vm._v(" Retornar para Análise Tributária\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.aprovacao.resultadoAprovacao === 'Análise Tributária' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('justificativa encaminhar analise tributaria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa_reanalise"
	    }
	  }, [_vm._v("Motivo para devolver para Análise Tributária:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.observacao),
	      expression: "nota.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa reanalise",
	      "rows": "3",
	      "id": "justificativa_encaminhar_analise_tributaria",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.nota.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nota, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa encaminhar analise tributaria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa encaminhar analise tributaria')))]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), (_vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [(_vm.loading.suportesFbbAtivos) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando Supotes não encerrados...")]) : _c('span', [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaSuportes,
	      "multiple": true,
	      "max": 3,
	      "close-on-select": true,
	      "placeholder": 'Neste id ' + _vm.id + ' pode ter vinculado opcionalmente de um a três Suportes desta lista de chamados não encerrados',
	      "custom-label": _vm.suporteNome,
	      "track-by": "numero",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "suporte_fbb",
	      "data-vv-as": "suporte_fbb",
	      "disabled": _vm.ehVisualizacao
	    },
	    scopedSlots: _vm._u([{
	      key: "maxElements",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "text-red"
	        }, [_vm._v("Já escolheu o limite de três suportes que pode vincular a este ID")])]
	      }
	    }], null, false, 1318475097),
	    model: {
	      value: (_vm.nota.suporteFbb),
	      callback: function($$v) {
	        _vm.$set(_vm.nota, "suporteFbb", $$v)
	      },
	      expression: "nota.suporteFbb"
	    }
	  })], 1)])])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('dialog', {
	    ref: "alertaValorOriginal",
	    staticStyle: {
	      "width": "500px",
	      "max-width": "100%",
	      "padding": "20px"
	    },
	    attrs: {
	      "id": "alertaValorOriginal"
	    }
	  }, [_vm._m(30), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin": "20px 0"
	    }
	  }, [_vm._v("\n        ⚠️ O valor desta solicitação mudou em relação ao que foi informado na etapa de solicitação (" + _vm._s(_vm._f("real")(_vm.valorOriginal)) + ").\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        _vm.$refs.alertaValorOriginal.close();
	        _vm.botao_concluir_disabled = false
	      }
	    }
	  }, [_vm._v("Cancelar e revisar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-neutral",
	    on: {
	      "click": function($event) {
	        _vm.confirmaValorOriginalDiferente = true;
	        _vm.$refs.alertaValorOriginal.close();
	        _vm.concluir()
	      }
	    }
	  }, [_vm._v("Estou ciente, continuar")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-exclamation"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Cargo")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Final do Mandato")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Ocorrência")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Data")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Situação")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-control-static"
	  }, [_vm._v("Não há ocorrências ativas")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Nota Fiscal Eletrônica")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dados do Documento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Fornecedor")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-label col-md-4",
	    staticStyle: {
	      "color": "#FF9900"
	    }
	  }, [_c('strong', [_vm._v("*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#FF9900"
	    }
	  }, [_vm._v("Caso as informações bancárias do fornecedor "), _c('strong', [_vm._v("não sejam encontradas ")]), _vm._v(" no menu acima, preencha os dados ao lado para cadastrar uma nova conta. Se houver agências/contas iguais com "), _c('strong', [_vm._v("digitos diferentes")]), _vm._v(", favor atentar ao escolher a opção correta. ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("OBS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#1565C0",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Favor atentar para que os dados bancários sejam da mesma titularidade do CPF/CNPJ informado no quadro anterior (Fornecedor), caso contrário o pagamento será devolvido.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', [_vm._v("Total Solicitado Fundação BB")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', [_vm._v("Total Pendente Fundação BB")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', [_vm._v("Total Solicitado Parceiros Estratégicos")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', [_vm._v("Total Pendente Parceiros Estratégicos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', [_vm._v("Total de adiantamento solicitado")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', [_vm._v("Total Pendente de Prestação de contas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Item")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Transação")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("ISS")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("COFINS")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("PIS")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("CSLL")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("IRRF")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("INSS")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Outros")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Itens da NF-e")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Ordem")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Qtde")]), _vm._v(" "), _c('th', [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', [_vm._v("Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Quantidade de itens")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total desta NF-e")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Registros")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Famílias")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Participantes")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Conta Interna do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Outras Informações")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Banco")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Agência")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Conta")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("MCI")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Conta Movimento")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda"
	  }, [_vm._v("Tipo do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Anexos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico Antigo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Observação Opcional")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Decisão")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("Informação relevante")])])
	}]}

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [(_vm.proposta.fep && _vm.proposta.fep.id) ? _c('vue-headful', {
	    attrs: {
	      "title": 'SGP - FEP ' + _vm.proposta.fep.ano + '/' + _vm.proposta.fep.numero
	    }
	  }) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "content-header ng-scope"
	  }, [(_vm.proposta.fep) ? _c('h1', [_vm._v("Ficha de Enquadramento de Projetos  -  FEP  Nº  " + _vm._s(_vm.proposta.fep.ano) + "/" + _vm._s(_vm.proposta.fep.numero) + "\n      "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "title": '<h5>Gera a FEP abaixo de forma resumida em Excel</h5>'
	    }
	  }, [_c('download-excel', {
	    attrs: {
	      "data": _vm.json_data,
	      "meta": _vm.json_meta,
	      "type": "xls",
	      "fields": _vm.json_fields,
	      "name": _vm.fepExcel
	    }
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)], 1), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvaFep($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Salvar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.closewindow($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e(), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Validação',
	        href: '/'
	      }, {
	        text: 'Propostas',
	        href: '#'
	      }, {
	        text: 'FEP',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    attrs: {
	      "id": "relatorio_fep"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('table', {
	    staticClass: "table"
	  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "fep_titulo"
	  }, [_c('div', [_vm._v("Ficha de Enquadramento de projetos")]), _vm._v(" "), (_vm.proposta.fep.id) ? _c('div', [_vm._v("FEP - Nº "), _c('span', {
	    staticClass: "ressaltar titulo"
	  }, [_vm._v(" " + _vm._s(_vm.proposta.fep.ano) + "/" + _vm._s(_vm.proposta.fep.numero))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Título")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.nome))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Proponente")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.nomeEntidade))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Ano da Fep")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('ano')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.fep.ano),
	      expression: "proposta.fep.ano"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "number",
	      "name": "ano"
	    },
	    domProps: {
	      "value": (_vm.proposta.fep.ano)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta.fep, "ano", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('ano')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('ano')))]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho required-fep"
	  }, [_vm._v("Número da Fep")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('numero')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.fep.numero),
	      expression: "proposta.fep.numero"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "number",
	      "name": "numero"
	    },
	    domProps: {
	      "value": (_vm.proposta.fep.numero)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta.fep, "numero", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('numero')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('numero')))]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Projeto Superior")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.projetoSuperior))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Eixo de Atuação")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.troca('CAMPOS_DE_ATUACAO', _vm.proposta.ds_categ_campo_atuacao)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Programa")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.troca('PROGRAMA', _vm.proposta.ds_fep_programa)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Ação")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.troca('ACAO', _vm.proposta.ds_categ_acao)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Parceria Estratégica (Vínculo)")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.vinculoParcerias))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.troca('TIPO_ACAO', _vm.proposta.ds_fep_tipo_acao)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Abrangência")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.abrangencia))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Participantes Diretos")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.publicoAlvo))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Prospecção")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.troca('PROSPECCAO', _vm.proposta.ds_categ_prospeccao)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Se Seleção, Nº/Nome Processo")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.troca('EDITAL', _vm.proposta.ds_categ_edital)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Cadeia Produtiva")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.troca('CADEIAS_PRODUTIVAS', _vm.proposta.ds_categ_atividade)))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped orcamento"
	  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Próprios FBB")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.totalFBB / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Terceiros - Parcerias Estratégicas")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalParceiro)))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.totalParceiro / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contrapartida - Proponente")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida)))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.totalContrapartida / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contrapartida - Outros Parceiros")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("real")(0)))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(0 / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)))]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")((_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro) / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro))))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_fep_observacao),
	      expression: "proposta.ds_fep_observacao"
	    }, {
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "ds_fep_observacao"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_fep_observacao)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_fep_observacao", $event.target.value)
	      }, _vm.resizable]
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_fep_observacao)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_vm._m(6), _vm._v(" "), _c('table', {
	    staticClass: "bloco"
	  }, [_c('tr', [_c('td', [_c('textarea', {
	    staticClass: "form-control"
	  }, [_vm._v("Enquadramento validado em " + _vm._s(_vm.hoje))])])]), _vm._v(" "), _vm._m(7)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "float"
	  })])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Dados do Projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Enquadramento na Árvore de Projetos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Orçamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Recursos")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("% Valor")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Observações")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Enquadramento Orçamentário")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_c('div', {
	    staticClass: "assinatura"
	  }, [_c('span', [_vm._v("Assessor Gerência de Análise e  Avaliação - Orçamento")])])])])
	}]}

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "visualizar",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "exampleModalLabel",
	      "aria-hidden": "true"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta: Solicitação de " + _vm._s(_vm.textoTipo))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmSearch",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-md-offset-1"
	  }, [_c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Projeto: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.nomeProjeto))]), _vm._v(" "), _c('dt', [_vm._v("Tipo de Solicitação:")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(_vm.textoTipo))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Etapa: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.etapa))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(_vm.situacao))])])])])])])])])])]), _vm._v(" "), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-secondary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")])])
	}]}

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('aside', {
	    ref: "barraControle",
	    staticClass: "control-sidebar control-sidebar-light barraControle",
	    staticStyle: {
	      "position": "fixed"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "tab-agenda"
	    }
	  }, [_c('h3', {
	    staticClass: "agendaTitulo"
	  }, [_vm._v("\n          Agenda de Vencimentos\n          "), _c('div', {
	    staticClass: "agendaFiltros"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Mandato de Dirigentes</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filtrar('Mandato dirigente')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa ' + _vm.icones['Mandato dirigente'] + (_vm._.includes(this.ocultarTipo, 'Mandato dirigente') ? ' filtroAtivo' : '')
	  }), _vm._v(" "), _c('span', {
	    staticClass: "agendaContador"
	  }, [_vm._v(_vm._s(_vm.ehNulo(_vm.contador['Mandato dirigente'], 0)))])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Acompanhamento de projeto</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filtrar('Acompanhamento')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa ' + _vm.icones['Acompanhamento'] + (_vm._.includes(this.ocultarTipo, 'Acompanhamento') ? ' filtroAtivo' : '')
	  }), _vm._v(" "), _c('span', {
	    staticClass: "agendaContador"
	  }, [_vm._v(_vm._s(_vm.ehNulo(_vm.contador['Acompanhamento'], 0)))])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Relatórios de Execução</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filtrar('Relatório de Execução')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa ' + _vm.icones['Relatório de Execução'] + (_vm._.includes(this.ocultarTipo, 'Relatório de Execução') ? ' filtroAtivo' : '')
	  }), _vm._v(" "), _c('span', {
	    staticClass: "agendaContador"
	  }, [_vm._v(" " + _vm._s(_vm.ehNulo(_vm.contador['Relatório de Execução'], 0)))])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Documentos diversos</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filtrar('Documento')
	      }
	    }
	  }, [_c('i', {
	    class: 'fa ' + _vm.icones['Documento'] + (_vm._.includes(this.ocultarTipo, 'Documento') ? ' filtroAtivo' : '')
	  }), _vm._v(" "), _c('span', {
	    staticClass: "agendaContador"
	  }, [_vm._v(" " + _vm._s(_vm.ehNulo(_vm.contador['Documento'], 0)))])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "title": '<h5>Período de vencimentos de<br/>' + _vm.dataFormat(_vm._.head(_vm._.keys(_vm.agenda))) + ' (semana anterior)<br/>até ' + _vm.dataFormat(_vm._.last(_vm._.keys(_vm.agenda))) + ' (' + _vm.mesesDepois + ' meses)</h5>'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-question"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "listaVencimentos",
	    style: ('height: 450px;')
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "top": "20px",
	      "left": "50%",
	      "position": "relative",
	      "font-size": "20px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._l((_vm._.keys(_vm.agenda)), function(data) {
	    return [_c('ul', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: ((_vm._.filter(_vm.agenda[data], function(i) {
	          return !_vm._.has(i, 'mostrar') || i.mostrar
	        })).length > 0),
	        expression: "(_.filter(agenda[data], function (i) { return !_.has(i, 'mostrar') || i.mostrar })).length > 0"
	      }]
	    }, [_c('div', {
	      staticClass: "agendaData"
	    }, [_vm._v(_vm._s(_vm._f("moment")(data, "LL")) + "\n                "), (data === _vm.hoje) ? _c('span', {
	      staticClass: "agendaHoje"
	    }, [_vm._v("hoje")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.agenda[data]), function(item) {
	      return [_c('li', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (!_vm._.has(item, 'mostrar') || item.mostrar),
	          expression: "!_.has(item, 'mostrar') || item.mostrar"
	        }, {
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            delay: 800,
	            duration: 0,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{inertia:true, arrow:true, delay:800, duration:0, animation:'perspective', distance:'1', size:'large', arrow:true}"
	        }],
	        attrs: {
	          "title": '<h5>' + _vm.infoTooltip(item) + '</h5>'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.verificar(item)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "agendaGrupo"
	      }, [_c('i', {
	        class: 'fa ' + _vm.icones[item.tipo]
	      })]), _vm._v(" "), _c('div', {
	        staticClass: "agendaOrigem"
	      }, [_vm._v(_vm._s(_vm.origem(item)) + " ")]), _vm._v(" "), _c('div', {
	        staticClass: "agendaDetalhe"
	      }, [_c('span', {
	        staticClass: "infoSubtipo"
	      }, [_vm._v(_vm._s(item.subtipo))]), _vm._v(" " + _vm._s(item.info) + "\n                  ")])])]
	    })], 2)]
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "tab-chat"
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "control-sidebar-heading"
	  }, [_vm._v("Usuários logados")]), _vm._v(" "), _c('ul', [_vm._l((_vm.usuariosLogados), function(usuario) {
	    return [_c('li', [_c('p', [_vm._v("Nome: " + _vm._s(usuario.ds_nome_usuario))]), _vm._v(" "), _c('p', [_vm._v("Login: " + _vm._s(usuario.ds_login))]), _vm._v(" "), _c('p', [_vm._v("E-mail: " + _vm._s(usuario.ds_email))]), _vm._v(" "), _c('p', [_vm._v("Tipo: " + _vm._s(usuario.ds_tipo_usuario))])])]
	  })], 2)])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
	    staticClass: "control-sidebar-bg"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "nav nav-tabs nav-justified control-sidebar-tabs"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#tab-agenda",
	      "data-toggle": "tab",
	      "aria-expanded": "true"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "tab-configuracao"
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "control-sidebar-heading"
	  }, [_vm._v("Configurações")])])])
	}]}

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraGridPublicoAlvo),
	      expression: "mostraGridPublicoAlvo"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.somenteLeitura !== false) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.formEditavel) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "uib-tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostraGridPublicoAlvo = !_vm.mostraGridPublicoAlvo
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Público alvo")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.somenteLeitura !== false) ? _c('div', [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "nr_jovens",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "nr_mulheres",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, (_vm.somenteLeitura !== false && _vm.formEditavel) ? {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.exclui(row); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>APAGAR</b> o item ' + row.item.fonte.ds_descricao + ' ?'
	            }),
	            expression: "{ok: retorno => exclui(row), cancel: doNothing,\n                           message: 'Deseja <b>APAGAR</b> o item ' + row.item.fonte.ds_descricao + ' ?'}"
	          }],
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "data-cy": "exclui-publico-alvo"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    } : null], null, true)
	  })], 1)], 1) : _vm._e()])]), _vm._v(" "), (!_vm.mostraGridPublicoAlvo) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    },
	    attrs: {
	      "disabled": _vm.mostraGridPublicoAlvo
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Público-alvo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Público-alvo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.fonte),
	      expression: "publicoAlvo.fonte"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Público-alvo",
	      "data-vv-as": "Descrição do Público-alvo",
	      "data-cy": "fonte"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.publicoAlvo, "fonte", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.publicosAlvo), function(publico) {
	    return _c('option', {
	      domProps: {
	        "value": publico
	      }
	    }, [_vm._v(_vm._s(publico.ds_descricao))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('Público-alvo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Tipo público-alvo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Tipo público-alvo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.ds_tipo_publico_alvo),
	      expression: "publicoAlvo.ds_tipo_publico_alvo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-cy": "ds_tipo_publico_alvo",
	      "data-vv-as": "Tipo do Público-alvo",
	      "name": "Tipo público-alvo"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.publicoAlvo, "ds_tipo_publico_alvo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("Outros")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "20"
	    }
	  }, [_vm._v("Agricultores familiares")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "30"
	    }
	  }, [_vm._v("Assentados da reforma agrária")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "40"
	    }
	  }, [_vm._v("Extrativistas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "50"
	    }
	  }, [_vm._v("Indígenas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "60"
	    }
	  }, [_vm._v("Catadores de materiais recicláveis")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "70"
	    }
	  }, [_vm._v("Associados")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "80"
	    }
	  }, [_vm._v("Jovens de 18 a 24 anos (ambos os sexos) do Programa Jovem Aprendiz no Campo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "90"
	    }
	  }, [_vm._v("Estudantes Ensino Superior Público (UFOB) da Área de alimentos (18 a 24 anos - ambos os sexos)")])])]), _vm._v(" "), (_vm.errors.first('Tipo público-alvo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Tipo público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('participantes diretos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Participantes diretos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.nr_participantes_diretos),
	      expression: "publicoAlvo.nr_participantes_diretos"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:2147483647'),
	      expression: "'required|min_value:1|max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-cy": "nr_participantes_diretos",
	      "name": "participantes diretos",
	      "data-vv-as": "Participantes Diretos",
	      "min": "1",
	      "max": "2147483647",
	      "type": "number",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.publicoAlvo.nr_participantes_diretos)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.publicoAlvo, "nr_participantes_diretos", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (false) ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('participantes Indiretos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Participantes indiretos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [(false) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.nr_participantes_indiretos),
	      expression: "publicoAlvo.nr_participantes_indiretos"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max_value:2147483647'),
	      expression: "'max_value:2147483647'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-cy": "nr_participantes_indiretos",
	      "name": "participantes Indiretos",
	      "data-vv-as": "Participantes Indiretos",
	      "type": "number",
	      "max": "2147483647"
	    },
	    domProps: {
	      "value": (_vm.publicoAlvo.nr_participantes_indiretos)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.publicoAlvo, "nr_participantes_indiretos", $event.target.value)
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('participantes Indiretos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes Indiretos')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticStyle: {
	      "color": "red",
	      "margin-bottom": "10px"
	    }
	  }, [_vm._v("* Dentre os participantes diretos informe, se houver, quantos são Jovens e/ou Mulheres")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Atende jovens')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Atende jovens?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.jovensBool),
	      expression: "jovensBool"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-cy": "jovensBool",
	      "name": "Atende jovens"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.jovensBool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.alteraJovens]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Sim"
	    },
	    domProps: {
	      "selected": _vm.publicoAlvo.nr_jovens
	    }
	  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Não"
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), (_vm.errors.first('Atende jovens')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Atende jovens')))]) : _vm._e()])]), _vm._v(" "), (_vm.jovensBool === 'Sim') ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Número de jovens atendidos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Número de jovens atendidos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.nr_jovens),
	      expression: "publicoAlvo.nr_jovens"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.jovensBool === 'Sim'
	      }),
	      expression: "{required: jovensBool === 'Sim'}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Número de jovens atendidos",
	      "type": "number",
	      "min": "1",
	      "max": _vm.publicoAlvo.nr_participantes_diretos
	    },
	    domProps: {
	      "value": (_vm.publicoAlvo.nr_jovens)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.publicoAlvo, "nr_jovens", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Número de jovens atendidos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número de jovens atendidos')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Atende mulheres')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Atende mulheres?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mulheresBool),
	      expression: "mulheresBool"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-cy": "mulheresBool",
	      "name": "Atende mulheres"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mulheresBool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.alteraMulheres]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Sim"
	    }
	  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Não"
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), (_vm.errors.first('Atende mulheres')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Atende mulheres')))]) : _vm._e()])]), _vm._v(" "), (_vm.mulheresBool === 'Sim') ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Número de mulheres atendidas')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Número de mulheres atendidas:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.publicoAlvo.nr_mulheres),
	      expression: "publicoAlvo.nr_mulheres"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.mulheresBool == 'Sim'
	      }),
	      expression: "{required: mulheresBool=='Sim'}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Número de mulheres atendidas",
	      "type": "number",
	      "min": "1",
	      "max": _vm.publicoAlvo.nr_participantes_diretos
	    },
	    domProps: {
	      "value": (_vm.publicoAlvo.nr_mulheres)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.publicoAlvo, "nr_mulheres", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Número de mulheres atendidas')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número de mulheres atendidas')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-4 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "data-cy": "adiciona-publico",
	      "id": "proposal-audience-add",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "id": "proposal-audience-cancel",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancelaPublico
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('span', {
	    staticClass: "message",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(" * Os relatórios de execução do projeto, exigirão os dados dos participantes diretos.")])])
	}]}

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": "SGP - Plano de Trabalho"
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "planoTrabalho"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Plano de Trabalho\n          "), _vm._v(" "), (_vm.bloqueiaBotoes === false) ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.closewindow($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "textoAlerta"
	  }, [_vm._v("O Plano de Trabalho é somente para impressão. Alterações realizadas não serão salvas!")])]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '/proposta/lista'
	      }, {
	        text: 'Imprime',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaDadosCadastrais"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Dados Cadastrais")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s((_vm._.has(_vm.proposta, 'ds_codigo_projeto_erp') && !_vm._.isNull(_vm.proposta.ds_codigo_projeto_erp) ? _vm.proposta.ds_codigo_projeto_erp + ' - ' : ' ') + _vm.proposta.ds_nome))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalProjeto)))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalCtrp)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalParc)))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
	    return m.ds_municipio + '/' + m.ds_uf
	  })), function(municipio) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(municipio[0].ds_municipio))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(municipio[0].ds_uf))])])
	  }), 0)]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Número de Participantes Diretos do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar w10"
	  }, [_vm._v(_vm._s(_vm._.sumBy(_vm.proposta.publicos_alvo, function(p) {
	    return parseInt(p.nr_participantes_diretos)
	  })) + " pessoas")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Convenente")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), (_vm.proposta.entidade.contato) ? _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contato")]), _vm._v(" "), (_vm.proposta.entidade && !_vm._.isEmpty(_vm.proposta.entidade.contato)) ? _c('td', {
	    staticClass: "ressaltar"
	  }, [_c('span', {
	    attrs: {
	      "proposta.entidade.contato.ds_telefone": ""
	    }
	  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_telefone)))]), _vm._v("    "), _c('span', {
	    attrs: {
	      "proposta.entidade.contato.ds_celular": ""
	    }
	  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_celular)))])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('thead', [_c('tr', [(_vm.proposta.entidade.endereco) ? _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Endereço" + _vm._s((_vm.proposta.entidade.endereco.length > 1 ? 's' : '')))]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Complemento")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("CEP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_rua))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_numero))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_bairro))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_complemento))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_cidade))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(endereco.ds_estado))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(_vm._f("cep")(endereco.ds_cep)))])])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body m0"
	  }, [_c('div', {
	    staticClass: "w100 m0"
	  }, [_vm._v("\n                      Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)\n                    ")]), _vm._v(" "), _vm._l((_vm.dirigentes), function(dirigente) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered lista w100 m0"
	    }, [(dirigente.cargo) ? _c('tbody', [_c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w30"
	    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cargo")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Final do Mandato")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_rg) + " - " + _vm._s(dirigente.ds_orgao_emissor) + "/" + _vm._s(dirigente.ds_uf))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._.has(dirigente, 'ds_estado_civil') ? _vm._.get(_vm.estadoCivil, dirigente.ds_estado_civil) : ''))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Profissão")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_profissao))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Telefone")]), _vm._v(" "), (dirigente.contato) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("telefone")(dirigente.contato.ds_telefone)))]) : _vm._e()])]) : _vm._e()])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objeto")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de Execução / Previsão de Início e Fim da Execução do Objeto")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(this.dataInicioExecucao, 'MM/YYYY')) + "  a  " + _vm._s(this.dataFimExecucao) + "  (" + _vm._s(_vm.proposta.nr_periodos) + " meses)\n                      ")]), _vm._v(" "), (_vm.proposta.projetoAprovado) ? _c('td', [(_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.nr_periodos),
	      expression: "proposta.nr_periodos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Número de Meses do Projeto",
	      "name": "periodo",
	      "type": "number",
	      "min": _vm.projetoPeriodos,
	      "max": _vm.proposta.periodo_vigencia
	    },
	    domProps: {
	      "value": (_vm.proposta.nr_periodos)
	    },
	    on: {
	      "change": _vm.atualizarPrazoExecucao,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "nr_periodos", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "esmaecido"
	  }, [_vm._v("* mínimo de " + _vm._s(_vm.projetoPeriodos) + " meses e máximo (vigência) de " + _vm._s(_vm.proposta.periodo_vigencia) + " meses")])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaMetas"
	    }
	  }, [(_vm.proposta.projetoAprovado) ? _c('div', {
	    staticClass: "nao_imprimir"
	  }, [(_vm.mostrarRef('objetivo_especifico')) ? _c('div', {
	    ref: "objetivos"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('objetivo-especifico', {
	    attrs: {
	      "editavel": false,
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objetivos = $event
	      }
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('metas')) ? _c('div', {
	    ref: "metas"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsMetas": _vm.proposta.metas,
	      "propsProposta": _vm.proposta,
	      "atvSemMetas": _vm.atvSemMetas
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.metas = $event
	      }
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('atividades')) ? _c('div', {
	    ref: "atividades"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.nr_periodos,
	      "propsMetas": _vm.proposta.metas,
	      "propsAtividades": _vm.proposta.atividades,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "atividadeAdicionada": function($event) {
	        _vm.proposta.atividades = $event
	      }
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    class: _vm.proposta.projetoAprovado ? 'imprimir' : ''
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos, Metas e Atividades")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed m0 obj_met_atv"
	  }, [_c('tbody', [_vm._l((_vm.proposta.objetivos), function(objetivo, idxObjetivo) {
	    return [_c('tr', {
	      staticClass: "objetivo"
	    }, [(objetivo.ds_descricao) ? _c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('span', {
	      staticClass: "tag"
	    }, [_vm._v("objetivo")]), _vm._v(_vm._s(objetivo.ds_descricao))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.proposta.metas), function(meta, idxMeta) {
	      return (_vm._.find(meta.objetivos, function(o) {
	        return o.ds_descricao === objetivo.ds_descricao
	      })) ? [_c('tr', {
	        staticClass: "meta"
	      }, [(meta.ds_descricao) ? _c('td', [_c('span', {
	        staticClass: "tag vertical"
	      }, [_vm._v("meta")]), _vm._v(_vm._s(meta.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
	        staticClass: "ressaltar"
	      }, [_vm._v(_vm._s(meta.nr_quantidade) + " " + _vm._s(meta.ds_unidade_medida))]), _vm._v(" e indicar a execução como "), _c('span', {
	        staticClass: "ressaltar"
	      }, [_vm._v(_vm._s(meta.ds_indicadores_execucao))])])]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade, idxAtividade) {
	        return (_vm._.find(atividade.metas, function(m) {
	          return m.ds_descricao === meta.ds_descricao
	        })) ? [_c('tr', {
	          staticClass: "atividade"
	        }, [(atividade.descricao) ? _c('td', [_c('span', {
	          staticClass: "tag vertical"
	        }, [_vm._v("atividade")]), _vm._v(_vm._s(atividade.descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Executar\n                                    "), (atividade.inicio === atividade.termino) ? _c('span', [_vm._v(" no " + _vm._s(atividade.inicio) + "º ")]) : _c('span', [_vm._v(" do " + _vm._s(atividade.inicio) + "º  ao  " + _vm._s(atividade.termino) + "º ")]), _vm._v("\n                                    mês e comprovar com "), _c('span', {
	          staticClass: "ressaltar"
	        }, [_vm._v(_vm._s(atividade.ds_documento_comprobatorio))])])])] : _vm._e()
	      }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.atividades, 'metas', meta.ds_descricao)) ? [_c('tr', {
	        staticClass: "atividade atencao"
	      }, [_c('td', {
	        attrs: {
	          "colspan": "2"
	        }
	      }, [_vm._v("* Não há atividades para a Meta acima")])])] : _vm._e()] : _vm._e()
	    }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.metas, 'objetivos', objetivo.ds_descricao)) ? [_c('tr', {
	      staticClass: "meta atencao"
	    }, [_c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("* Não há metas para o Objetivo acima")])])] : _vm._e()]
	  })], 2)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaCronogramaAtividades"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cronograma de Execução das Atividades")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho w40 b1 b4"
	  }, [_vm._v("Atividade")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho direita w10 b1"
	  }, [_vm._v("Valor total")]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(mes) {
	    return _c('th', {
	      staticClass: "centralizado b1 b2 b4",
	      style: ('zoom:' + _vm.ganttZoom)
	    }, [_vm._v(_vm._s(mes + 1))])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.atividades), function(atividade) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar b3 b4"
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "direita b3"
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
	      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
	    }))))]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(m) {
	      return _c('td', {
	        staticClass: "centralizado b2 b3 b4",
	        style: ((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1)) ? 'background: gray !important' : '')
	      }, [((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1))) ? _c('span', {
	        style: ('zoom:' + _vm.ganttZoom + '; color: gray')
	      }, [_c('i', {
	        staticClass: "fa fa-circle"
	      })]) : _c('span', [_vm._v(" ")])])
	    })], 2)
	  }), 0)]), _vm._v(" "), _c('div', [_vm._v("\n                      Referência: 1º mês do projeto em "), _c('span', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._.head(_vm.periodoMesAno)['mes'] + '/' + _vm._.head(_vm.periodoMesAno)['ano']))]), _vm._v("\n                      e " + _vm._s(_vm.periodoMesAno.length) + "º (último) mês do projeto em "), _c('span', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._.last(_vm.periodoMesAno)['mes'] + '/' + _vm._.last(_vm.periodoMesAno)['ano']))])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_operacao)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_acoes_comunicacao)
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaRecursosFinanceiros"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Plano de Aplicação dos Recursos Financeiros")]), _vm._v(" "), _c('table', {
	    staticClass: "w100"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.proposta.atividades), function(atividade) {
	    return [_c('tr', {
	      staticStyle: {
	        "font-weight": "bold"
	      }
	    }, [_c('td', {
	      staticClass: "esquerda nome_atividade bl1 bl3 bl4"
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado bl1 bl3"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado bl1 bl3"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
	      staticClass: "direita bl1 bl2 bl3",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
	      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
	    }))))])]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item) {
	      return _c('tr', [
	        [_c('td', {
	          staticClass: "bl4 b3"
	        }, [_c('span', {}, [(('' + item.origem).substr(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substr(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substr(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel).substr(0, 1) === '1') ? _c('span', {
	          staticClass: "adiantavel"
	        }, [_vm._v(" (Adiantável)")]) : _vm._e()]), _vm._v(" "), _c('span', {
	          staticClass: "esmaecido"
	        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('div', {
	          staticClass: "observacao esquerda"
	        }, [_vm._v(_vm._s(item.observacao))])]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3"
	        }, [_vm._v(_vm._s(item.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3"
	        }, [_vm._v(_vm._s(item.nr_periodo_final))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3"
	        }, [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3"
	        }, [_vm._v(_vm._s(_vm._f("real")(item.valor_unitario)))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado b3 bl2"
	        }, [_vm._v(_vm._s(_vm._f("real")(item.quantidade * item.valor_unitario)))])]
	      ], 2)
	    })]
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Parcelas de Adiantamento")]), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [(_vm.parcelasAdiantamentoExibicao) ? _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '10%' : '15%'))
	  }, [_c('b', [_vm._v("Parcela")])]), _vm._v(" "), _c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '30%' : '45%'))
	  }, [_c('b', [_vm._v("Origem")])]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_c('b', [_vm._v("Fundação")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_c('b', [_vm._v("Parceiro Estratégico")])]) : _vm._e(), _vm._v(" "), _c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '20%' : '40%'))
	  }, [_c('b', [_vm._v("Valor")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parcelasAdiantamentoExibicao), function(adiantamento) {
	    return _c('tr', {
	      key: 'adiantamento-' + adiantamento.parcela + '-' + adiantamento.origem
	    }, [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm.rotuloOrigemParcela(adiantamento.origem)))]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "text-right"
	    }, [(!_vm._.isNil(adiantamento.valor_fbb)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_fbb)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "text-right"
	    }, [(!_vm._.isNil(adiantamento.valor_parc)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_parc)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor)))])])
	  }), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Total adiantável")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoFundacao)) + "\n                            "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoFundacao / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoParceiro)) + "\n                            "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoParceiro / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoGeral)) + "\n                            "), ((_vm._.toNumber(_vm.proposta.totalFBB || 0) + _vm._.toNumber(_vm.proposta.totalParc || 0)) > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoGeral / (_vm._.toNumber(_vm.proposta.totalFBB || 0) + _vm._.toNumber(_vm.proposta.totalParc || 0))))) + ")")]) : _vm._e()])]), _vm._v(" "), (_vm.parcelasAdiantamentoExibicao.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "100%"
	    }
	  }, [_vm._v("Nenhuma parcela de adiantamento cadastrada.")])]) : _vm._e()], 2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaCronogramaAtividades"
	    }
	  }, [_c('div', {
	    staticClass: "quebraPagina"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "guiaDesembolso"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "zoom": "1"
	    }
	  }, [_vm._v("Cronograma de Desembolso (Cronograma Físico-financeiro)")]), _vm._v(" "), _vm._l((_vm._.keys(_vm._.groupBy(_vm.periodoMesAno, 'ano'))), function(ano) {
	    return [_c('div', {
	      staticClass: "anoDesembolso"
	    }, [_vm._v(_vm._s(ano))]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade) {
	      return [_c('table', {
	        staticClass: "w100 juntos"
	      }, [_c('caption', [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
	        staticClass: "b3",
	        attrs: {
	          "rowspan": "2"
	        }
	      }, [_vm._v("Item")]), _vm._v(" "), _vm._l((12), function(c) {
	        return _c('th', {
	          staticClass: "b3",
	          attrs: {
	            "colspan": "2"
	          }
	        }, [_vm._v(_vm._s(_vm.meses[c - 1]))])
	      })], 2), _vm._v(" "), _c('tr', [_vm._l((12), function(d) {
	        return [_c('th', {
	          staticClass: "b3"
	        }, [_vm._v("Qtde")]), _c('th', {
	          staticClass: "b3"
	        }, [_vm._v("Valor")])]
	      })], 2)]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	        staticClass: "b3"
	      }, [_vm._v("Total da atividade")]), _vm._v(" "), _vm._l((12), function(mesAtv) {
	        return [_c('td', {
	          staticClass: "b3"
	        }, [_vm._v(_vm._s(_vm.desembolsoMesAno(atividade, ano, mesAtv, 'quantidade')))]), _vm._v(" "), _c('td', {
	          staticClass: "b3"
	        }, [_vm._v(_vm._s(_vm._f("decimal2")(_vm.desembolsoMesAno(atividade, ano, mesAtv, 'valor'))))])]
	      })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((atividade.itens_orcamentos), function(item) {
	        return [_c('tr', [_c('td', {
	          staticClass: "b3"
	        }, [_vm._v("(" + _vm._s(item.item.ds_type) + ") " + _vm._s(item.item.ds_description))]), _vm._v(" "), _vm._l((12), function(mesIte) {
	          return [_c('td', {
	            staticClass: "b3"
	          }, [_vm._v(_vm._s(_vm.desembolsoMesAno(item, ano, mesIte, 'quantidade')))]), _vm._v(" "), _c('td', {
	            staticClass: "b3 direita"
	          }, [_vm._v(_vm._s(_vm._f("decimal2")(_vm.desembolsoMesAno(item, ano, mesIte, 'valor'))))])]
	        })], 2)]
	      })], 2)])]
	    })]
	  })], 2)])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "w100 imprimir"
	  }, [_c('tr', [_c('td', [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "direita"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "40px !important"
	    }
	  }, [_vm._v("Plano de Trabalho")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Fundação")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Proponente")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Terceiros")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Atividade / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Valor Total")])])])
	}]}

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-primary",
	    attrs: {
	      "id": "aprovacao"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Aprovação"), (_vm.aprovacao.ds_codigo_projeto_erp) ? _c('span', [_vm._v(" do projeto "), _c('b', [_vm._v(_vm._s(_vm.aprovacao.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "cmptDocPreparationForm",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('legend', [_vm._v("Datas")]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data proposta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data da Proposta")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_proposta, "L")))])])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data análise')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de análise")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_analise, "L")))])])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data deferimento')
	    },
	    attrs: {
	      "uib-tooltip": "Data de deferimento"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de deferimento")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_deferimento, "L")))])])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de assinatura do convênio")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_assinatura_convenio, "L")))])])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data vigência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de Vigência do Projeto")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_data_vigencia, "L")))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Documentos da Formalização")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": this.propsAprovacao.documentos.formalizacao,
	      "documentTypes": _vm.tiposDocumentos,
	      "documentosObrigatorios": '',
	      "local-uso": 'TODOS',
	      "faseProposta": _vm.propsAprovacao.ds_fase
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v(" Ficha de Auto Verificação")]), _vm._v(" "), _vm._l((_vm.perguntasFAV), function(item) {
	    return _c('div', [(item.nivel === 3) ? _c('label', {
	      staticClass: "control-label col-md-10",
	      class: 'favNivel' + item.nivel
	    }, [_vm._v(_vm._s(item.numero) + " " + _vm._s(item.pergunta))]) : _vm._e(), _vm._v(" "), (item.nivel !== 3) ? _c('span', {
	      staticClass: "control-label col-md-10",
	      class: 'favNivel' + item.nivel
	    }, [_vm._v(_vm._s(item.pergunta))]) : _vm._e(), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	      }],
	      staticClass: "col-md-1",
	      staticStyle: {
	        "alignment": "left"
	      },
	      attrs: {
	        "title": '<h5>Pergunta <span class=\'realce\'>' + item.numero + '</span></h5>'
	      }
	    }, [(item.nivel === 3) ? _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.resposta),
	        expression: "item.resposta"
	      }],
	      staticClass: "form-control respostaFav",
	      attrs: {
	        "disabled": "disabled"
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(item, "resposta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((_vm.respostaFAV), function(opcao) {
	      return _c('option', {
	        domProps: {
	          "value": opcao.valor
	        }
	      }, [_vm._v(_vm._s(opcao.resposta))])
	    }), 0) : _vm._e()])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('aprovacao')
	    },
	    attrs: {
	      "uib-tooltip": "Decisões da preparação de documentos"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAprovacao.resultadoAprovacao),
	      expression: "propsAprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "aprovacao",
	      "value": "APROVAR"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.propsAprovacao.resultadoAprovacao, "APROVAR")
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.propsAprovacao, "resultadoAprovacao", "APROVAR")
	      }, _vm.verificaDecisao]
	    }
	  }), _vm._v("\n                    Aprovar o Projeto (APR)\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAprovacao.resultadoAprovacao),
	      expression: "propsAprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "aprovacao",
	      "value": "VOLTAR_ANALISE",
	      "id": "msgDef"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.propsAprovacao.resultadoAprovacao, "VOLTAR_ANALISE")
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.propsAprovacao, "resultadoAprovacao", "VOLTAR_ANALISE")
	      }, _vm.verificaDecisao]
	    }
	  }), _vm._v("\n                    Devolver para Reanálise\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAprovacao.resultadoAprovacao),
	      expression: "propsAprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "aprovacao",
	      "value": "VOLTAR_FORMALIZACAO",
	      "id": "formalizacao"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.propsAprovacao.resultadoAprovacao, "VOLTAR_FORMALIZACAO")
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.propsAprovacao, "resultadoAprovacao", "VOLTAR_FORMALIZACAO")
	      }, _vm.verificaDecisao]
	    }
	  }), _vm._v("\n                    Devolver para Formalização\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAprovacao.resultadoAprovacao),
	      expression: "propsAprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "aprovacao",
	      "value": "CANCELAR_PROJETO",
	      "id": "cancelar"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.propsAprovacao.resultadoAprovacao, "CANCELAR_PROJETO")
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.propsAprovacao, "resultadoAprovacao", "CANCELAR_PROJETO")
	      }, _vm.verificaDecisao]
	    }
	  }), _vm._v("\n                    Cancelar o Projeto (CAN)\n                    "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('aprovacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('aprovacao')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.propsAprovacao.resultadoAprovacao === 'VOLTAR_FORMALIZACAO') ? _c('div', {
	    staticClass: "form-group full col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAprovacao.observacao),
	      expression: "propsAprovacao.observacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa"
	    },
	    domProps: {
	      "value": (_vm.propsAprovacao.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propsAprovacao, "observacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.propsAprovacao.resultadoAprovacao === 'VOLTAR_ANALISE' || _vm.propsAprovacao.resultadoAprovacao === 'CANCELAR_PROJETO') ? _c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('anexo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Anexo obrigatório")]), _vm._v(" "), _c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.aprovacaoDocumentos,
	      "documentTypes": '',
	      "documentosObrigatorios": '',
	      "local-uso": 'APROVACAO_PROJETO_RESTRICAO'
	    }
	  }), _vm._v(" "), (_vm.errors.first('anexo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('anexo')))]) : _vm._e()], 1) : _vm._e()])])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "FundacaoCode12646546516581"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage01",
	    attrs: {
	      "valor": "Dados do Projeto"
	    }
	  }, [_c('div', {
	    staticClass: "fbb-grid"
	  }, [_c('div', {
	    staticClass: "fbb-col-span-12"
	  }, [_c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Título do projeto",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.projeto)
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Convenente",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.entidade)
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "fbb-col-span-6"
	  }, [_c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Número do projeto",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.numero_projeto)
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Início de execução do projeto",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.inicio)
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Percentual financeiro realizado",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.percentual_liberacao)
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "E-mail de contato",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.email_contato)
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Telefone 01",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.telefone_contato_1)
	    }
	  }), _vm._v(" "), (_vm.dadosRelatorio.objeto.length > 0) ? _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Objeto cumprido?",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.objeto)
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "fbb-col-span-6"
	  }, [_c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Tipo de relatório",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.tipo_relatorio)
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Fim de execução do projeto",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.termino)
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Percentual de tempo decorrido",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.percentual_andamento)
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Contrapartida Executada",
	      "valor": ((_vm.contrapartidaConsolidada.toFixed(2)) + " %")
	    }
	  }), _vm._v(" "), _c('RelatorioTextoDestaque', {
	    attrs: {
	      "titulo": "Telefone 02",
	      "valor": _vm.limpaCampo(_vm.dadosRelatorio.cabecalho.telefone_contato_2)
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage02",
	    attrs: {
	      "valor": "Metas e Atividades"
	    }
	  }, [_c('div', {
	    staticClass: "fbb-grid"
	  }, [_c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "titulo-tabela"
	  }, [_vm._v("metas")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela"
	  }, [_vm._v("atividades")])]), _vm._v(" "), _c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "titulo-tabela-2",
	    staticStyle: {
	      "width": "30%"
	    }
	  }, [_vm._v("Descrição")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela-2",
	    staticStyle: {
	      "width": "5%"
	    }
	  }, [_vm._v("Orçado")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela-2",
	    staticStyle: {
	      "width": "7%"
	    }
	  }, [_vm._v("Realizado")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela-2",
	    staticStyle: {
	      "width": "8%"
	    }
	  }, [_vm._v("Atingimento")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela-2",
	    staticStyle: {
	      "width": "25%"
	    }
	  }, [_vm._v("Descricão")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela-2",
	    staticStyle: {
	      "width": "12.5%"
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela-2",
	    staticStyle: {
	      "width": "12.5%"
	    }
	  }, [_vm._v("Execução")])]), _vm._v(" "), _vm._l((_vm.dadosRelatorio.metas.row), function(meta) {
	    return _c('div', {
	      staticClass: "fbb-col-span-12 fbb-flex"
	    }, [_c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "30%"
	      }
	    }, [_vm._v(_vm._s(meta.meta))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "5%"
	      }
	    }, [_vm._v(_vm._s(meta.orcado))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "7%"
	      }
	    }, [_vm._v(_vm._s(meta.realizado))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "8%"
	      }
	    }, [_vm._v(_vm._s(_vm._f("percentage")((meta.realizado / meta.orcado))))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "50%",
	        "height": "100%"
	      }
	    }, _vm._l((meta.atividades.row), function(atividade) {
	      return _c('div', {
	        staticStyle: {
	          "width": "100%",
	          "height": "auto"
	        }
	      }, [_c('div', {
	        staticClass: "fbb-flex"
	      }, [_c('div', {
	        staticClass: "tabela-body",
	        staticStyle: {
	          "width": "50%"
	        }
	      }, [_vm._v(_vm._s(atividade.atividade))]), _vm._v(" "), _c('div', {
	        staticClass: "tabela-body",
	        staticStyle: {
	          "width": "25%"
	        }
	      }, [_vm._v(_vm._s(_vm.retornaSituacao(atividade.status)))]), _vm._v(" "), _c('div', {
	        staticClass: "tabela-body",
	        staticStyle: {
	          "width": "25%"
	        }
	      }, [_vm._v(_vm._s(atividade.execucao) + " %")])]), _vm._v(" "), _c('div', {
	        staticClass: "titulo-tabela",
	        staticStyle: {
	          "width": "100%"
	        }
	      }, [_vm._v("Arquivos")]), _vm._v(" "), _vm._l((atividade.anexos_atividades.row), function(anexo) {
	        return _c('div', [_vm._v(_vm._s(anexo.ds_nome_arquivo))])
	      })], 2)
	    }), 0)])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage03",
	    attrs: {
	      "valor": "Justificativa pelo não atingimento de meta"
	    }
	  }, [_c('div', {
	    staticClass: "fbb-grid"
	  }, [_c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "30%"
	    }
	  }, [_vm._v("Meta / Atividade")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "30%"
	    }
	  }, [_vm._v("Objetivo")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "30%"
	    }
	  }, [_vm._v("Providência")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Prazo")])]), _vm._v(" "), _vm._l((_vm.executadasparcial.filter(function (item) { return item.providencia != ''; })), function(executadaParcial) {
	    return (_vm.executadasparcial && _vm.executadasparcial.length > 0) ? _c('div', {
	      staticClass: "fbb-col-span-12 fbb-flex"
	    }, [_c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "30%",
	        "text-align": "justify"
	      }
	    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.limpaCampo(executadaParcial.meta)))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.limpaCampo(executadaParcial.atividade)))])]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "30%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(_vm.limpaCampo(executadaParcial.motivo)))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "30%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(_vm.limpaCampo(executadaParcial.providencia)))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "10%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(_vm._f("formataData")(executadaParcial.prazo_regularizacao_meta)) + "\n          ")])]) : _vm._e()
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]), _vm._v(" "), (_vm.executadasparcial && _vm.naoexecutadas.length > 0) ? _c('RelatorioTitulo', {
	    staticClass: "fbbpage04",
	    attrs: {
	      "valor": "Justificativa pela não execução da atividade"
	    }
	  }, [_c('div', {
	    staticClass: "fbb-grid"
	  }, [_c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "22.5%"
	    }
	  }, [_vm._v("Meta")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "22.5%"
	    }
	  }, [_vm._v("Atividade")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "22.5%"
	    }
	  }, [_vm._v("Motivo")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "22.5%"
	    }
	  }, [_vm._v("Providências")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Prazo")])]), _vm._v(" "), _vm._l((_vm.naoexecutadas), function(naoexecutada) {
	    return _c('div', {
	      staticClass: "fbb-col-span-12 fbb-flex"
	    }, [_c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "22.5%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(_vm.limpaCampo(naoexecutada.meta)))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "22.5%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(_vm.limpaCampo(naoexecutada.atividade)))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "22.5%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(_vm.limpaCampo(naoexecutada.motivo)))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "22.5%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(_vm.limpaCampo(naoexecutada.providencia)))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "10%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(_vm._f("formataData")(naoexecutada.prazo_regularizacao_atividade)) + "\n          ")])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]) : _vm._e(), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage04",
	    attrs: {
	      "valor": "Número de participantes envolvidos atualmente no projeto"
	    }
	  }, [_c('div', {
	    staticClass: "fbb-grid"
	  }, [_c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "titulo-tabela"
	  }, [_vm._v("Público")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela"
	  }, [_vm._v("Previsto")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela"
	  }, [_vm._v("Realizado")])]), _vm._v(" "), _c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v("Participantes")]), _vm._v(" "), _c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.participantes))]), _vm._v(" "), _c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v(_vm._s(_vm.totalizadores.participantes))])]), _vm._v(" "), _c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v("Jovens")]), _vm._v(" "), _c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.jovens))]), _vm._v(" "), _c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v(_vm._s(_vm.totalizadores.jovens))])]), _vm._v(" "), _c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v("Mulheres")]), _vm._v(" "), _c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.mulheres))]), _vm._v(" "), _c('div', {
	    staticClass: "tabela-body",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._v(_vm._s(_vm.totalizadores.mulheres))])])])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage05",
	    attrs: {
	      "valor": "O cronograma físico-financeiro está sendo executado conforme previsto?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.retornaAplicacao(_vm.dadosRelatorio.cronograma_conforme_previsto.resposta)) + "\n      ")])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage05",
	    attrs: {
	      "valor": "A contrapartida está sendo comprovada de acordo com o previsto no Plano de Trabalho?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v("\n        " + _vm._s(_vm.retornaAplicacao(_vm.dadosRelatorio.contrapartida_comprovada_previsto.resposta)) + "\n      ")])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage05",
	    attrs: {
	      "valor": "Foram realizadas as ações de divulgação previstas no Projeto?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.acoes_divulgacao_prevista.justificativa))]), _vm._v(" "), (_vm.paginas[4] && _vm.paginas[4].quebra) ? _c('div', {
	    staticClass: "html2pdf__page-break"
	  }) : _vm._e()]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage05",
	    attrs: {
	      "valor": "Informar como está o desenvolvimento do Objeto do Convênio:"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.desenvolvimento_objeto_convenio.valor))]), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage06",
	    attrs: {
	      "valor": "Informar sobre o alcance dos Objetivos do projeto:"
	    }
	  }, [_c('div', {
	    staticClass: "fbb-grid"
	  }, [_c('div', {
	    staticClass: "fbb-col-span-12 fbb-flex"
	  }, [_c('div', {
	    staticClass: "titulo-tabela"
	  }, [_vm._v("Item")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela"
	  }, [_vm._v("Descrição")]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-tabela"
	  }, [_vm._v("Realizado")])]), _vm._v(" "), _vm._l((_vm.dadosRelatorio.objetivos_projeto.row), function(objProj) {
	    return _c('div', {
	      staticClass: "fbb-col-span-12 fbb-flex"
	    }, [_c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "100%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(objProj.item))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "100%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(objProj.descricao))]), _vm._v(" "), _c('div', {
	      staticClass: "tabela-body",
	      staticStyle: {
	        "width": "100%",
	        "text-align": "justify"
	      }
	    }, [_vm._v(_vm._s(objProj.realizado))])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage07",
	    attrs: {
	      "valor": "Resultados alcançados até o momento:"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.resultados_alcancados.valor))])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage07",
	    attrs: {
	      "valor": "Depoimentos:"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.depoimentos.valor))])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage07",
	    attrs: {
	      "valor": "O Projeto contribui para a comercialização da produção?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.retornaAplicacao(_vm.dadosRelatorio.comercializacao_producao.resposta)) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage08",
	    attrs: {
	      "valor": "O Projeto contribui para o desenvolvimento de novos conhecimentos/habilidades?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_c('span', {
	    staticClass: "negrito"
	  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_1.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_1.consideracoes))])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage08",
	    attrs: {
	      "valor": "O Projeto contribui para o envolvimento de mulheres e jovens?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_c('span', {
	    staticClass: "negrito"
	  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v("\n        " + _vm._s(_vm.dadosRelatorio.questionario.questao_2.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_2.consideracoes))])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage08",
	    attrs: {
	      "valor": "O Projeto contribui para a formação de novas parcerias além da Fundação Banco do Brasil?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_c('span', {
	    staticClass: "negrito"
	  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v("\n        " + _vm._s(_vm.dadosRelatorio.questionario.questao_3.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_3.consideracoes))]), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage08",
	    attrs: {
	      "valor": "O Projeto contribui para o surgimento de novas oportunidades de trabalho e/ou renda?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_c('span', {
	    staticClass: "negrito"
	  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v("\n        " + _vm._s(_vm.dadosRelatorio.questionario.questao_4.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_4.consideracoes))])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage09",
	    attrs: {
	      "valor": "O Projeto contribui para a preservação do meio ambiente e o cuidado ambiental?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_c('span', {
	    staticClass: "negrito"
	  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_5.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_5.consideracoes))])]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage09",
	    attrs: {
	      "valor": "O Projeto contribui para a valorização de questões relativas a direitos humanos?"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_c('span', {
	    staticClass: "negrito"
	  }, [_vm._v("Nível de 1 a 5:  ")]), _vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_6.resposta) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.questionario.questao_6.consideracoes))]), _vm._v(" "), _c('div', {
	    staticClass: "html2pdf__page-break"
	  })]), _vm._v(" "), _c('RelatorioTitulo', {
	    staticClass: "fbbpage09",
	    attrs: {
	      "valor": "Conclusão do relatório"
	    }
	  }, [_c('div', {
	    staticClass: "area-de-texto-impressao"
	  }, [_vm._v(_vm._s(_vm.dadosRelatorio.parecer_fbb.valor))])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "fbbpage01 fbb-cabecalho-relatorio"
	  }, [_c('div', [_c('img', {
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "titulo-relatorio"
	  }, [_vm._v("\n        Relatório de Execução\n      ")])])
	}]}

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Permissão")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Permissões',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('form', {
	    staticClass: "ng-pristine ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "authForm"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-6"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-1"
	  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('profiles', {
	    attrs: {
	      "propsProfile": _vm.profile
	    },
	    on: {
	      "profileSelected": function($event) {
	        _vm.profile = $event
	      }
	    },
	    model: {
	      value: (_vm.profile),
	      callback: function($$v) {
	        _vm.profile = $$v
	      },
	      expression: "profile"
	    }
	  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, _vm._l((_vm.auths), function(item, index) {
	    return _c('div', {
	      staticClass: "col-lg-6 col-md-2 col-sm-12"
	    }, [_c('div', {
	      staticClass: "box box-default box-solid"
	    }, [_c('div', {
	      staticClass: "box-header with-border"
	    }, [_c('h3', {
	      staticClass: "box-title ng-binding"
	    }, [_vm._v(_vm._s(_vm.$t('authority.register.' + index)))]), _vm._v(" "), _c('div', {
	      staticClass: "pull-right"
	    }, [_c('label', {
	      staticClass: "checkbox-inline new-control new-control-checkbox",
	      staticStyle: {
	        "margin-top": "-20px"
	      }
	    }, [_c('input', {
	      staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
	      attrs: {
	        "disabled": !_vm.$root.authorize('permissao-editar') && Object.keys(_vm.profile).length < 1,
	        "type": "checkbox",
	        "name": "selectAll",
	        "ng-model": "selectAll",
	        "ng-change": "change(item, selectAll)"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])]), _vm._v(" "), _c('div', {
	      staticClass: "box-body permission-list"
	    }, _vm._l((item), function(authority) {
	      return _c('div', {
	        staticClass: "ng-scope"
	      }, [_c('div', {
	        staticClass: "checkbox-inline col-md-6 col-sm-12"
	      }, [_c('label', {
	        staticClass: "checkbox-inline new-control new-control-checkbox ng-binding"
	      }, [_c('input', {
	        staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
	        attrs: {
	          "disabled": _vm.$root.authorize('permissao-editar') && Object.keys(_vm.profile).length < 1,
	          "type": "checkbox"
	        },
	        domProps: {
	          "checked": _vm.verifica(authority.name)
	        },
	        on: {
	          "change": function($event) {
	            return _vm.adiciona(authority)
	          }
	        }
	      }), _vm._v(_vm._s(_vm.$t('authority.register.' + authority.name)) + "\n                              "), _c('div', {
	        staticClass: "new-control-indicator"
	      })])])])
	    }), 0)])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "disabled": !_vm.$root.authorize('permissao-editar') && Object.keys(_vm.profile).length < 1,
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.saveAuthoritiesToProfile(_vm.profileSelected)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")])], 1)])])]), _vm._v(" "), (_vm.profile.id !== 2) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', [_c('div', {}, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('form', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show.userForm),
	      expression: "show.userForm"
	    }],
	    staticClass: "form-horizontal well well-sm no-shadow",
	    attrs: {
	      "name": "formUsuario"
	    }
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('usuarios')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "usersProfile"
	    }
	  }, [_vm._v("Usuários:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "input-group borda",
	    class: {
	      'has-error': _vm.errors.first('usuarios')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usersAdicionar),
	      expression: "usersAdicionar"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "abc"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.usersAdicionar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.usuariosPesquisa2), function(usuA) {
	    return _c('option', {
	      domProps: {
	        "value": usuA
	      }
	    }, [_vm._v(_vm._s(usuA.nome_usuario))])
	  }), 0)]), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('usuarios')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('dataInicial')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "dataInicial"
	    }
	  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profileConstraint.initialDate),
	      expression: "profileConstraint.initialDate"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "dataInicial",
	      "id": "datep",
	      "refs": "datep",
	      "type": "date"
	    },
	    domProps: {
	      "value": (_vm.profileConstraint.initialDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.profileConstraint, "initialDate", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('dataInicial')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "datafinal"
	    }
	  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profileConstraint.inactivateDate),
	      expression: "profileConstraint.inactivateDate"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "dataInicial",
	      "id": "inactivateDate",
	      "refs": "inactivateDate",
	      "type": "date"
	    },
	    domProps: {
	      "value": (_vm.profileConstraint.inactivateDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.profileConstraint, "inactivateDate", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-10 col-sm-offset-2 ng-binding"
	  }, [_c('span', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.adicionaUsuario($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('span', {
	    staticClass: "btn btn-default btn-flat",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onCancelUserToProfile($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.bordered,
	      "items": _vm.users,
	      "hover": _vm.hover,
	      "fields": _vm.fields,
	      "filter": _vm.filter,
	      "current-page": _vm.currentPage,
	      "per-page": 5,
	      "sort-by": _vm.sortBy,
	      "sort-desc": _vm.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        _vm.sortBy = $event
	      },
	      "update:sort-by": function($event) {
	        _vm.sortBy = $event
	      },
	      "update:sortDesc": function($event) {
	        _vm.sortDesc = $event
	      },
	      "update:sort-desc": function($event) {
	        _vm.sortDesc = $event
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "active",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "updatedAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": _vm.profile.name === 'Administrador',
	            "to": {
	              name: 'cadastro-usuarios-altera',
	              params: {
	                id: row.item.user.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": _vm.profile.name === 'Administrador'
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.deleteUser(row.item.user.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }], null, false, 1356077681)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])]) : _vm._e()])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Permissões do Perfil")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', [_vm._v("Usuários com estas permissões")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('div', {
	    staticClass: "form-group"
	  })])
	}]}

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "form",
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": '<h5>Ir para Metas</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": _vm.irMetas
	    }
	  }, [_c('i', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Metas")])]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": '<h5>Ir para Atividades</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": _vm.irAtividades
	    }
	  }, [_c('i', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Atividades")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4",
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "disabled": _vm.contador === 0,
	      "title": '<h5>Salvar</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": _vm.salvar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Salvar")])]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "title": '<h5>Novo registro</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": [function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }, function($event) {
	        $event.stopPropagation();
	        return _vm.onNew($event)
	      }]
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Novo registro")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "tabelaAlteracao",
	    attrs: {
	      "id": "tabelaAlteracao",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "row-clicked": _vm.linha
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [(!_vm.temId(row.item.detalhamento)) ? _c('div', [_c('button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")])]) : _vm._e()])]
	      }
	    }, {
	      key: "tipo",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(row.value.descricao))])]
	      }
	    }, {
	      key: "motivo",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(row.value.descricao))])]
	      }
	    }, {
	      key: "responsavel.ds_nome_usuario",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(row.value))])]
	      }
	    }, {
	      key: "documentos",
	      fn: function(row) {
	        return [(row.item.documentos.length > 0) ? _c('i', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }],
	          staticClass: "glyphicon glyphicon-duplicate",
	          staticStyle: {
	            "font-size": "large"
	          },
	          attrs: {
	            "title": '<h5>Existe(m) ' + '<b>' + row.item.documentos.length + '</b>' + ' documento(s) em anexo. Clique em editar para visualizar o(s) documento(s).</h5>',
	            "aria-en": "true"
	          }
	        }) : _vm._e()]
	      }
	    }, {
	      key: "detalhamento",
	      fn: function(row) {
	        return [(_vm.temId(row.item.detalhamento)) ? _c('span', {
	          staticClass: "grupoMostrarOcultar",
	          on: {
	            "click": function($event) {
	              _vm.abrirLink('/solicitacao/alteracoesprojeto/' + _vm.temId(row.item.detalhamento), true)
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.temId(row.item.detalhamento)) + " "), _c('i', {
	          staticClass: "fa fa-external-link"
	        })]) : _vm._e(), _vm._v(" "), _c('span', {
	          domProps: {
	            "innerHTML": _vm._s((row.item.detalhamento).replace('#' + _vm.temId(row.item.detalhamento) + '# ', ''))
	          }
	        })]
	      }
	    }, {
	      key: "dt_registro",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "prazo",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "id_processo",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "linkProcesso"
	        }, [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'solicitacao-alteracoes-projeto-visualizacao',
	              params: {
	                id: row.value
	              }
	            }
	          }
	        }, [_vm._v(_vm._s(row.value))])], 1)]
	      }
	    }], null, false, 2460787272)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "form-horizontal row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "margin": "0px"
	    },
	    attrs: {
	      "name": "frmAddAt"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('data')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "data"
	    }
	  }, [_vm._v("Data:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [(_vm.alteracao.id) ? _c('div', [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "data",
	    attrs: {
	      "name": "data",
	      "input-class": "form-control",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "placeholder": "__ /__ /____",
	      "highlighted": _vm.highlighted,
	      "disabled": _vm.alteracao.id,
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.alteracao.dt_registro),
	      callback: function($$v) {
	        _vm.$set(_vm.alteracao, "dt_registro", $$v)
	      },
	      expression: "alteracao.dt_registro"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.alteracao.id) ? _c('div', [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "data",
	    attrs: {
	      "name": "data",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "placeholder": "__ /__ /____",
	      "highlighted": _vm.highlighted,
	      "disabled": _vm.alteracao.id,
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.alteracao.dt_registro),
	      callback: function($$v) {
	        _vm.$set(_vm.alteracao, "dt_registro", $$v)
	      },
	      expression: "alteracao.dt_registro"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.errors.first('data')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "tipo"
	    }
	  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.tipos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Tipo de Alteração",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaTipos,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "tipo",
	      "disabled": _vm.alteracao.id,
	      "data-vv-as": "Tipo de alteração"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelect($event, _vm.alteracao.tipo)
	      }
	    },
	    model: {
	      value: (_vm.alteracao.tipo),
	      callback: function($$v) {
	        _vm.$set(_vm.alteracao, "tipo", $$v)
	      },
	      expression: "alteracao.tipo"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('tipo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "detalhamentoBloq"
	    }
	  }, [_vm._v("Histórico Detalhe:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('font', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.alteracao.detalhamento)
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('detalhamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "detalhamento"
	    }
	  }, [_vm._v("Detalhe:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.detalhamentoAnt),
	      expression: "detalhamentoAnt"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": _vm.place,
	      "name": "detalhamento",
	      "type": "text",
	      "maxlength": "1000",
	      "cols": "10",
	      "rows": "8"
	    },
	    domProps: {
	      "value": (_vm.detalhamentoAnt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.detalhamentoAnt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('detalhamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('detalhamento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('motivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "motivo"
	    }
	  }, [_vm._v("Motivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.motivos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Motivo",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaMotivos,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "tipo",
	      "data-vv-as": "Motivo da alteração",
	      "disabled": _vm.prorrogacaoEdit
	    },
	    model: {
	      value: (_vm.alteracao.motivo),
	      callback: function($$v) {
	        _vm.$set(_vm.alteracao, "motivo", $$v)
	      },
	      expression: "alteracao.motivo"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('motivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo')))]) : _vm._e()]), _vm._v(" "), (_vm.alteracao.responsavel.ds_nome_usuario) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "responsavel"
	    }
	  }, [_vm._v("Responsável:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.alteracao.responsavel.ds_nome_usuario),
	      expression: "alteracao.responsavel.ds_nome_usuario"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "responsavel",
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.alteracao.responsavel.ds_nome_usuario)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.alteracao.responsavel, "ds_nome_usuario", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "responsavel"
	    }
	  }, [_vm._v("Anexos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.alteracao.documentos,
	      "documentTypes": '',
	      "disable": '',
	      "localUso": 'TODOS',
	      "salvouOK": _vm.salvouOK,
	      "editandoAlteracaoProjeto": _vm.editandoItem,
	      "editandoProrrogacao": _vm.prorrogacaoEdit
	    }
	  })], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.frmAddAt)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onCancel(_vm.frmAddAt)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])], 1)])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('br'), _c('br')])
	}]}

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraGrid),
	      expression: "mostraGrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onNew
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Município")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.redistributeParticipants
	    }
	  }, [_c('i', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Distribuir Participantes Proporcionalmente")]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.redistributeValues
	    }
	  }, [_c('i', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Distribuir Valores Proporcionalmente")]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center",
	      "font-weight": "bold"
	    }
	  }, [_c('tr', [(_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v("Fase")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("CEP")]), _vm._v(" "), _c('td', [_vm._v("Município")]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v("Valor das ativ. por município")]) : _vm._e(), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v("% das ativ. por município")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Número de participantes por município")]), _vm._v(" "), _c('td', [_vm._v("% participantes por municípios")]), _vm._v(" "), _c('td', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, _vm._l((_vm.table.items), function(item, index) {
	    return _c('tr', [(_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v(_vm._s(item.phase))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cep))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valueByActivity)))]) : _vm._e(), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v(_vm._s(_vm._f("percentage")(item.percentageByActivity)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalParticipants))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(item.percentage)))]), _vm._v(" "), _c('td', [_c('div', [_c('b-button', {
	      class: ['btn btn-flat btn-sm', _vm.proposta.proposalPhase === 'CADASTRO' || _vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE' ? 'btn-primary' : 'btn-default'],
	      attrs: {
	        "type": "button",
	        "disabled": _vm.proposta.proposalPhase !== 'CADASTRO' && _vm.proposta.proposalPhase !== 'ANALISE' && _vm.proposta.proposalPhase !== 'PRE_ANALISE'
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.edita(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button",
	        "disabled": false
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.exclui(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1)])])
	  }), 0)])]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [(_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('table', {
	    staticClass: "table b-table table-bordered b-table-stacked-md",
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Total Fundação: " + _vm._s(_vm._f("real")(_vm.calculaValorAtividadeporFase('FUNDACAO'))))]), _vm._v(" "), _c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Total Fundação Restante: " + _vm._s(_vm._f("real")(_vm.calculaValorPermitidoAtividadeporFase('FUNDACAO'))))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Total Contrapartida: " + _vm._s(_vm._f("real")(_vm.calculaValorAtividadeporFase('CONTRAPARTIDA'))))]), _vm._v(" "), _c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Total Contrapartida Restante: " + _vm._s(_vm._f("real")(_vm.calculaValorPermitidoAtividadeporFase('CONTRAPARTIDA'))))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Total Parceiro Estratégico: " + _vm._s(_vm._f("real")(_vm.calculaValorAtividadeporFase('PARCEIRO_ESTRATEGICO'))))]), _vm._v(" "), _c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Total Parceiro Estratégico Restante: " + _vm._s(_vm._f("real")(_vm.calculaValorPermitidoAtividadeporFase('PARCEIRO_ESTRATEGICO'))))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Total do Projeto: " + _vm._s(_vm._f("real")(_vm.calculaValorAtividadeporFase('PARCEIRO_ESTRATEGICO') + _vm.calculaValorAtividadeporFase('CONTRAPARTIDA') + _vm.calculaValorAtividadeporFase('FUNDACAO'))))]), _vm._v(" "), _c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Total  Parceiro Estratégico Restante: " + _vm._s(_vm._f("real")(_vm.calculaValorPermitidoAtividadeporFase('PARCEIRO_ESTRATEGICO') + _vm.calculaValorPermitidoAtividadeporFase('CONTRAPARTIDA') + _vm.calculaValorPermitidoAtividadeporFase('FUNDACAO'))))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Total Participantes: " + _vm._s(_vm.totalParticipantes))]), _vm._v(" "), _c('td', {
	    staticClass: "text-center",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Total  Parceiro Estratégico Restante: " + _vm._s(_vm.totalParticipantes - _vm.totalParticipantesMunicipios))])])])]) : _vm._e()])], 1)])]), _vm._v(" "), (!_vm.mostraGrid) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6 well"
	  }, [(_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('fase')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "phase"
	    }
	  }, [_vm._v("Fase:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cidade.phase),
	      expression: "cidade.phase"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "fase",
	      "aria-label": "Recurso"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.cidade, "phase", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.selecionaFase]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "FUNDACAO"
	    }
	  }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CONTRAPARTIDA"
	    }
	  }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PARCEIRO_ESTRATEGICO"
	    }
	  }, [_vm._v("P.Estratégico")])])]), _vm._v(" "), (_vm.errors.first('fase')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('fase')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cep')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cep"
	    }
	  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addMunCtrl.approval",
	      "state": "addMunCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|max:8'),
	      expression: "'required|min:8|max:8'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cep",
	      "type": "text",
	      "mask": "#####-###"
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.loadCityAndState($event)
	      }
	    },
	    model: {
	      value: (_vm.cidade.cep),
	      callback: function($$v) {
	        _vm.$set(_vm.cidade, "cep", $$v)
	      },
	      expression: "cidade.cep"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-lg-3",
	    staticStyle: {
	      "padding": "7px"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.cidade.name) + "\n        ")])]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('valor')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "valueByActivity"
	    }
	  }, [_vm._v("Valor das atividades por município:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addMunCtrl.approval",
	      "state": "addMunCtrl.approvalState"
	    }
	  }, [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max_value:' + _vm.valorPermitidoAtividade),
	      expression: "'required|max_value:' + valorPermitidoAtividade"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "valor",
	      "type": "text",
	      "ng-change": "addMunCtrl.onChangeValueByActivity(cidade)",
	      "ng-blur": "addMunCtrl.onChangeMunicipalizationValues()",
	      "disabled": !_vm.cidade.phase
	    },
	    model: {
	      value: (_vm.cidade.valueByActivity),
	      callback: function($$v) {
	        _vm.$set(_vm.cidade, "valueByActivity", $$v)
	      },
	      expression: "cidade.valueByActivity"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('valor')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('porcentagem das atividades')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "percentageByActivity"
	    }
	  }, [_vm._v("Porcentagem das atividades por município:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "porcentagem das atividades",
	      "type": "text",
	      "mask": ['###,##%', '##,##%', '#,##%']
	    },
	    model: {
	      value: (_vm.porcentagemAtividade),
	      callback: function($$v) {
	        _vm.porcentagemAtividade = $$v
	      },
	      expression: "porcentagemAtividade"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('porcentagem das atividades')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('porcentagem das atividades')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('número de participantes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "totalParticipants"
	    }
	  }, [_vm._v("Número de participantes:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addMunCtrl.approval",
	      "state": "addMunCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cidade.totalParticipants),
	      expression: "cidade.totalParticipants"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        numeric: true
	      }),
	      expression: "{required: true, numeric: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "número de participantes",
	      "type": "number",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.cidade.totalParticipants)
	    },
	    on: {
	      "change": _vm.onChangeTotalParticipants,
	      "keyup": _vm.onChangeTotalParticipants,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cidade, "totalParticipants", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('número de participantes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número de participantes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('porcentagem de participantes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "porcentagem de participantes"
	    }
	  }, [_vm._v("Porcentagem de participantes")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addMunCtrl.approval",
	      "state": "addMunCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "porcentagem de participantes",
	      "mask": ['###,##%', '##,##%', '#,##%'],
	      "type": "text"
	    },
	    model: {
	      value: (_vm.porcentagemParticipantes),
	      callback: function($$v) {
	        _vm.porcentagemParticipantes = $$v
	      },
	      expression: "porcentagemParticipantes"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('porcentagem de participantes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('porcentagem de participantes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-municipalization-add"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-municipalization-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Validação Inicial")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": !_vm.isEditable()
	    }
	  }, [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Razão social"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.companyName),
	      expression: "entidade.companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "companyName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.entidade.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "cnpj", $$v)
	      },
	      expression: "entidade.cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpjExpeditionTime')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cnpjExpeditionTime"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "cnpjExpeditionTime",
	    attrs: {
	      "name": "cnpjExpeditionTime",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.entidade.cnpjExpeditionTime),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "cnpjExpeditionTime", $$v)
	      },
	      expression: "entidade.cnpjExpeditionTime"
	    }
	  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome fantasia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome fantasia"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.businessName),
	      expression: "entidade.businessName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Nome fantasia",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome fantasia",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.businessName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "businessName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), (!_vm.entidade.simplified) ? _c('fieldset', [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Natureza jurídica')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Natureza jurídica"
	    }
	  }, [_vm._v("Natureza jurídica:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.legalType),
	      expression: "entidade.legalType"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Natureza jurídica",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Natureza jurídica"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.entidade, "legalType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ASSOCIAÇÃO"
	    }
	  }, [_vm._v("Associação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "COOPERATIVA"
	    }
	  }, [_vm._v("Cooperativa")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "EMPRESA_PUBLICA"
	    }
	  }, [_vm._v("Empresa pública")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "FUNDACAO"
	    }
	  }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ORGAO_PUBLICO_EXECUTIVO_ESTADUAL"
	    }
	  }, [_vm._v("Orgão público executivo estadual")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ORGAO_PUBLICO_EXECUTIVO_MUNICIPAL"
	    }
	  }, [_vm._v("Orgão público executivo municipal")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SEM_FINS_LUCRATIVOS"
	    }
	  }, [_vm._v("Sem fins lucrativos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SERVICO_SOCIAL_AUTONOMO"
	    }
	  }, [_vm._v("Serviço social autônomo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOCIEDADE_LTDA"
	    }
	  }, [_vm._v("Sociedade ltda")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOCIEDADE_POR_ACOES"
	    }
	  }, [_vm._v("Sociedade por Ações")])]), _vm._v(" "), (_vm.errors.first('Natureza jurídica')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Natureza jurídica é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Ramo atividade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Ramo atividade"
	    }
	  }, [_vm._v("Ramo atividade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.activity),
	      expression: "entidade.activity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Ramo atividade",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Ramo atividade"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.entidade, "activity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.ramoAtividade), function(ramoAtividade) {
	    return _c('option', {
	      attrs: {
	        "label": ramoAtividade.code + ' - ' + ramoAtividade.description
	      },
	      domProps: {
	        "value": ramoAtividade
	      }
	    }, [_vm._v(_vm._s(ramoAtividade.code + ' - ' + ramoAtividade.description))])
	  }), 0), _vm._v(" "), (_vm.errors.first('Ramo atividade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Ramo atividade é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Doc. constituição')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "constitutionDocument"
	    }
	  }, [_vm._v("Doc. constituição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.constitutionDocument),
	      expression: "entidade.constitutionDocument"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "Doc. constituição",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Doc. constituição"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.entidade, "constitutionDocument", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ATA_CONSTITUICAO"
	    }
	  }, [_vm._v("Ata constituição")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CONTRATO_SOCIAL"
	    }
	  }, [_vm._v("Contrato social")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ESTATUTO"
	    }
	  }, [_vm._v("Estatuto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "LEI_ORGANICA_MUNICIPAL"
	    }
	  }, [_vm._v("Lei orgânica municipal")])]), _vm._v(" "), (_vm.errors.first('Doc. constituição')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Doc. constituição é obrigatório')))]) : _vm._e()])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6",
	    attrs: {
	      "id": "contato"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.contact.phone),
	      expression: "entidade.contact.phone"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) ####-#####'),
	      expression: "'(##) ####-#####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1'),
	      expression: "'required|min:1'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "Telefone",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.contact.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade.contact, "phone", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Telefone é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "mobile"
	    }
	  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.contact.mobile),
	      expression: "entidade.contact.mobile"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) #####-#####'),
	      expression: "'(##) #####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "mobile",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.contact.mobile)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade.contact, "mobile", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.email),
	      expression: "entidade.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Email",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Email",
	      "type": "text",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.entidade.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo E-mail é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.website),
	      expression: "entidade.website"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:255'),
	      expression: "'max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "website",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.website)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "website", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(1), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.endereco
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.dirigentes,
	      "name": "dirigentes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('usuarios', {
	    attrs: {
	      "entUsuarios": _vm.usuarios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.entidade.documents,
	      "documentTypes": _vm.entidade.documentTypes
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(5), _vm._v(" "), _c('historico-entidade', {
	    attrs: {
	      "entHistorico": _vm.historico
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-12"
	  }, [_c('legend', [_vm._v("Decisões da análise da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required full",
	    class: {
	      'has-error': _vm.errors.first('resultado')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "approvalResult"
	    }
	  }, [_vm._v("Decisões:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approvalResult),
	      expression: "analise.approvalResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado",
	      "id": "resultado",
	      "value": "APPROVED"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.approvalResult, "APPROVED")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "approvalResult", "APPROVED")
	      }
	    }
	  }), _vm._v(" Aprovar\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approvalResult),
	      expression: "analise.approvalResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado",
	      "value": "REVIEW_OPENED"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.approvalResult, "REVIEW_OPENED")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "approvalResult", "REVIEW_OPENED")
	      }
	    }
	  }), _vm._v(" Devolver para ajustes\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.approvalResult),
	      expression: "analise.approvalResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultado",
	      "value": "CANCELED"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.analise.approvalResult, "CANCELED")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.analise, "approvalResult", "CANCELED")
	      }
	    }
	  }), _vm._v(" Reprovar\n                        "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('resultado')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultado')))]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.analise.approvalResultt === 'REJECTED' || _vm.analise.approvalResult === 'REVIEW_OPENED') ? _c('div', {
	    staticClass: "form-group required full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa"
	    }
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.analise.justify),
	      expression: "analise.justify"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justificativa",
	      "id": "justificativa"
	    },
	    domProps: {
	      "value": (_vm.analise.justify)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.analise, "justify", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "uib-tooltip": "Conclui o cadastro",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.conclui(_vm.frmCommonRegister)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "uib-tooltip": "Apenas salva o cadastro",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.salva(_vm.frmCommonRegister)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          path: '/validacao/validacaoInicial/lista'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Entidade")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Usuários da entidade:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico:")])])])
	}]}

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column centered-start detalhe-item-container"
	  }, [_c('div', {
	    staticClass: "row-flex centered-between detalhe-titulo"
	  }, [_vm._m(0), _vm._v(" "), _c('i', {
	    staticClass: "item-detalhe-icone button-icone fa fa-remove",
	    on: {
	      "click": function($event) {
	        return _vm.toggleDetalharItem(false)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between detalhe-titulo-sessao"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-end detalhe-mostrar-button",
	    on: {
	      "click": function($event) {
	        _vm.showAll = !_vm.showAll
	      }
	    }
	  }, [(!_vm.showAll) ? _c('div', [_c('i', {
	    staticClass: "fa fa-folder"
	  }), _vm._v(" Detalhar Tudo\n        ")]) : _c('div', [_c('i', {
	    staticClass: "fa fa-folder-open"
	  }), _vm._v(" Esconder Detalhes\n        ")])])]), _vm._v(" "), _vm._l((_vm.itemCotacao['cotacao']), function(item, index) {
	    return _c('div', {
	      staticClass: "column all-centered detalhe-item-cotacao-container"
	    }, [_c('detalheItemLicitacao', {
	      attrs: {
	        "itemLicitacao": item,
	        "relatorioCotacao": true,
	        "index": index + 1,
	        "total": _vm.itemCotacao['cotacao'].length,
	        "showAll": _vm.showAll
	      }
	    })], 1)
	  }), _vm._v(" "), (_vm.itemCotacao.remocaoManual.length > 0) ? _c('div', {
	    staticClass: "row-flex centered-start detalhe-titulo-sessao"
	  }, [_c('i', {
	    staticClass: "fa fa-user-times"
	  }), _vm._v(" Itens Removidos Manualmente Pelo Usuário\n  ")]) : _vm._e(), _vm._v(" "), (_vm.itemCotacao.remocaoManual.length > 0) ? _c('div', {
	    staticClass: "column all-centered detalhe-item-remocao-manual-container"
	  }, _vm._l((_vm.itemCotacao.remocaoManual), function(item, index) {
	    return _c('div', {
	      staticClass: "column start-centered w-100"
	    }, [_c('div', {
	      staticClass: "detalhe-justificativa-divider"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "row-flex centered-start detalhe-justificativa"
	    }, [_c('i', {
	      staticClass: "fa fa-exclamation-circle"
	    }), _vm._v(" Justificativa: "), _c('b', [_vm._v(_vm._s(item.justificativa))])]), _vm._v(" "), _c('div', {
	      staticClass: "row-flex centered-start detalhe-justificativa"
	    }, [_c('i', {
	      staticClass: "fa fa-user"
	    }), _vm._v(" Responsável: "), _c('b', [_vm._v(_vm._s(item.responsavel))])]), _vm._v(" "), _c('detalheItemLicitacao', {
	      attrs: {
	        "itemLicitacao": item.item,
	        "relatorioCotacao": true,
	        "index": index + 1,
	        "total": _vm.itemCotacao.remocaoManual.length,
	        "showAll": _vm.showAll,
	        "removidoManual": true
	      }
	    })], 1)
	  }), 0) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "column all-centered cotacao-calculo-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered cotacao-calculo-tabela-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered cotacao-tabelas"
	  }, [_vm._m(3), _vm._v(" "), _c('tr', {
	    staticClass: "column centered-start cotacao-tabela"
	  }, [_c('td', {
	    staticClass: "cotacao-tabela-header"
	  }, [_vm._v("Universo Amostral Selecionado")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.media)))]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.DP)))]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm.calculoAmostral.CV) + "%")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.LS)))]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.LI)))])]), _vm._v(" "), _c('tr', {
	    staticClass: "column centered-start cotacao-tabela"
	  }, [_c('td', {
	    staticClass: "cotacao-tabela-header"
	  }, [_vm._v("Universo Amostral Saneado")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.calculoFinal.media)) + " (Média Saneada)")])]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_c('b', [_vm._v(_vm._s(_vm.calculoFinal.CV) + "% (CV Saneado)*")])]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("-")])])]), _vm._v(" "), _c('div', {
	    staticClass: "column all-centered cotacao-indicativo"
	  }, [_c('div', {
	    staticClass: "column all-centered cotacao-resumo"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "column all-end resumo-container"
	  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.itemCotacao.cotacao.length + _vm.itemCotacao.universoAmostralSaneado.length) + " ")]), _vm._v(" Itens Encontrados\n                  ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.itemCotacao.universoAmostralSaneado.length) + " ")]), _vm._v(" Itens Saneados\n                  ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.itemCotacao.cotacao.length) + " ")]), _vm._v(" Itens Cotados\n                  ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.calculoFinal.CV) + "% ")]), _vm._v(" Coeficiente de Variação\n                  ")])]), _vm._v(" "), (_vm.calculoFinal.CV <= 25 && _vm.calculoFinal.CV !== 0) ? _c('div', {
	    staticClass: "row-flex all-centered diagnostico-card diagnostico-ok"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-up"
	  }), _vm._v(" CV calculado indica razoável homogeneização do Valor.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.calculoFinal.CV > 25) ? _c('div', {
	    staticClass: "row-flex all-centered diagnostico-card diagnostico-atencao"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle"
	  }), _vm._v(" O CV calculado indica baixa homogeneização do Valor, atenção. Sujeito a análise.\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between preco-referencia-container"
	  }, [_c('div', {
	    staticClass: "column start-centered"
	  }, [_c('div', {
	    staticClass: "preco-referencia-titulo"
	  }, [_vm._v("Preço de Referência:")]), _vm._v(" "), _c('div', {
	    staticClass: "preco-referencia-subtitulo"
	  }, [_vm._v("Universo Amostral: " + _vm._s(_vm.itemCotacao.cotacao.length + _vm.itemCotacao.universoAmostralSaneado.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "preco-referencia-calculo-final"
	  }, [_vm._v("\n            " + _vm._s(_vm._f("real")(_vm.calculoFinal.media)) + "\n          ")])])])], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start gap-10"
	  }, [_c('i', {
	    staticClass: "item-detalhe-icone fa fa-dollar"
	  }), _vm._v(" Detalhamento de Cotação de Item de Despesa\n    ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', {
	    staticClass: "fa fa-object-ungroup"
	  }), _vm._v(" Composição da Cotação\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start detalhe-titulo-sessao"
	  }, [_c('i', {
	    staticClass: "fa fa-calculator"
	  }), _vm._v(" Detalhamento do Calculo\n  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    staticClass: "column centered-start cotacao-tabela"
	  }, [_c('td', {
	    staticClass: "cotacao-tabela-header"
	  }, [_vm._v("Variáveis")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Média")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Desvio Padrão (DP):")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Coeficiente de Variação (CV):")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Limite Superior (LS):")]), _vm._v(" "), _c('td', {
	    staticClass: "cotacao-tabela-linha"
	  }, [_vm._v("Limite Inferior (LI):")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start cotacao-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-map-pin"
	  }), _vm._v(" Resumo:\n              ")])
	}]}

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      General UI\n      "), _c('small', [_vm._v("Preview of UI elements")])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("General")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box box-default color-palette-box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-tag"
	  }), _vm._v(" Color Palette")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Primary")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-light-blue disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-light-blue color-palette"
	  }, [_c('span', [_vm._v("#3c8dbc")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-light-blue-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Info")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-aqua disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-aqua color-palette"
	  }, [_c('span', [_vm._v("#00c0ef")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-aqua-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Success")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-green disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-green color-palette"
	  }, [_c('span', [_vm._v("#00a65a")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-green-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Warning")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-yellow disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-yellow color-palette"
	  }, [_c('span', [_vm._v("#f39c12")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-yellow-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Danger")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-red disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-red color-palette"
	  }, [_c('span', [_vm._v("#f56954")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-red-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Gray")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-gray disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-gray color-palette"
	  }, [_c('span', [_vm._v("#d2d6de")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-gray-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Navy")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-navy disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-navy color-palette"
	  }, [_c('span', [_vm._v("#001F3F")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-navy-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Teal")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-teal disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-teal color-palette"
	  }, [_c('span', [_vm._v("#39CCCC")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-teal-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Purple")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-purple disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-purple color-palette"
	  }, [_c('span', [_vm._v("#605ca8")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-purple-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Orange")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-orange disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-orange color-palette"
	  }, [_c('span', [_vm._v("#ff851b")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-orange-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Maroon")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-maroon disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-maroon color-palette"
	  }, [_c('span', [_vm._v("#D81B60")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-maroon-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Black")]), _vm._v(" "), _c('div', {
	    staticClass: "color-palette-set"
	  }, [_c('div', {
	    staticClass: "bg-black disabled color-palette"
	  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-black color-palette"
	  }, [_c('span', [_vm._v("#111111")])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-black-active color-palette"
	  }, [_c('span', [_vm._v("Active")])])])])])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Alerts and Callouts")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Alerts")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
	    staticClass: "icon fa fa-ban"
	  }), _vm._v(" Alert!")]), _vm._v("\n              Danger alert preview. This alert is dismissable. A wonderful serenity has taken possession of my entire\n              soul, like these sweet mornings of spring which I enjoy with my whole heart.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-info alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
	    staticClass: "icon fa fa-info"
	  }), _vm._v(" Alert!")]), _vm._v("\n              Info alert preview. This alert is dismissable.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-warning alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alert!")]), _vm._v("\n              Warning alert preview. This alert is dismissable.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-success alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
	    staticClass: "icon fa fa-check"
	  }), _vm._v(" Alert!")]), _vm._v("\n              Success alert preview. This alert is dismissable.\n            ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-bullhorn"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Callouts")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "callout callout-danger"
	  }, [_c('h4', [_vm._v("I am a danger callout!")]), _vm._v(" "), _c('p', [_vm._v("There is a problem that we need to fix. A wonderful serenity has taken possession of my entire soul,\n                like these sweet mornings of spring which I enjoy with my whole heart.")])]), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-info"
	  }, [_c('h4', [_vm._v("I am an info callout!")]), _vm._v(" "), _c('p', [_vm._v("Follow the steps to continue to payment.")])]), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-warning"
	  }, [_c('h4', [_vm._v("I am a warning callout!")]), _vm._v(" "), _c('p', [_vm._v("This is a yellow callout.")])]), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-success"
	  }, [_c('h4', [_vm._v("I am a success callout!")]), _vm._v(" "), _c('p', [_vm._v("This is a green callout.")])])])])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("AdminLTE Custom Tabs")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "nav-tabs-custom"
	  }, [_c('ul', {
	    staticClass: "nav nav-tabs"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#tab_1",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Tab 1")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#tab_2",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Tab 2")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#tab_3",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Tab 3")])]), _vm._v(" "), _c('li', {
	    staticClass: "dropdown"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown",
	      "href": "#"
	    }
	  }, [_vm._v("\n                Dropdown "), _c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "role": "menuitem",
	      "tabindex": "-1",
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "role": "menuitem",
	      "tabindex": "-1",
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "role": "menuitem",
	      "tabindex": "-1",
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "presentation"
	    }
	  }), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "role": "menuitem",
	      "tabindex": "-1",
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "pull-right"
	  }, [_c('a', {
	    staticClass: "text-muted",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gear"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "tab_1"
	    }
	  }, [_c('b', [_vm._v("How to use:")]), _vm._v(" "), _c('p', [_vm._v("Exactly like the original bootstrap tabs except you should use\n                the custom wrapper "), _c('code', [_vm._v(".nav-tabs-custom")]), _vm._v(" to achieve this style.")]), _vm._v("\n              A wonderful serenity has taken possession of my entire soul,\n              like these sweet mornings of spring which I enjoy with my whole heart.\n              I am alone, and feel the charm of existence in this spot,\n              which was created for the bliss of souls like mine. I am so happy,\n              my dear friend, so absorbed in the exquisite sense of mere tranquil existence,\n              that I neglect my talents. I should be incapable of drawing a single stroke\n              at the present moment; and yet I feel that I never was a greater artist than now.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "tab_2"
	    }
	  }, [_vm._v("\n              The European languages are members of the same family. Their separate existence is a myth.\n              For science, music, sport, etc, Europe uses the same vocabulary. The languages only differ\n              in their grammar, their pronunciation and their most common words. Everyone realizes why a\n              new common language would be desirable: one could refuse to pay expensive translators. To\n              achieve this, it would be necessary to have uniform grammar, pronunciation and more common\n              words. If several languages coalesce, the grammar of the resulting language is more simple\n              and regular than that of the individual languages.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "tab_3"
	    }
	  }, [_vm._v("\n              Lorem Ipsum is simply dummy text of the printing and typesetting industry.\n              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,\n              when an unknown printer took a galley of type and scrambled it to make a type specimen book.\n              It has survived not only five centuries, but also the leap into electronic typesetting,\n              remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset\n              sheets containing Lorem Ipsum passages, and more recently with desktop publishing software\n              like Aldus PageMaker including versions of Lorem Ipsum.\n            ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "nav-tabs-custom"
	  }, [_c('ul', {
	    staticClass: "nav nav-tabs pull-right"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#tab_1-1",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Tab 1")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#tab_2-2",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Tab 2")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#tab_3-2",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Tab 3")])]), _vm._v(" "), _c('li', {
	    staticClass: "dropdown"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown",
	      "href": "#"
	    }
	  }, [_vm._v("\n                Dropdown "), _c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "role": "menuitem",
	      "tabindex": "-1",
	      "href": "#"
	    }
	  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "role": "menuitem",
	      "tabindex": "-1",
	      "href": "#"
	    }
	  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "role": "menuitem",
	      "tabindex": "-1",
	      "href": "#"
	    }
	  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "presentation"
	    }
	  }), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "role": "menuitem",
	      "tabindex": "-1",
	      "href": "#"
	    }
	  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "pull-left header"
	  }, [_c('i', {
	    staticClass: "fa fa-th"
	  }), _vm._v(" Custom Tabs")])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "tab_1-1"
	    }
	  }, [_c('b', [_vm._v("How to use:")]), _vm._v(" "), _c('p', [_vm._v("Exactly like the original bootstrap tabs except you should use\n                the custom wrapper "), _c('code', [_vm._v(".nav-tabs-custom")]), _vm._v(" to achieve this style.")]), _vm._v("\n              A wonderful serenity has taken possession of my entire soul,\n              like these sweet mornings of spring which I enjoy with my whole heart.\n              I am alone, and feel the charm of existence in this spot,\n              which was created for the bliss of souls like mine. I am so happy,\n              my dear friend, so absorbed in the exquisite sense of mere tranquil existence,\n              that I neglect my talents. I should be incapable of drawing a single stroke\n              at the present moment; and yet I feel that I never was a greater artist than now.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "tab_2-2"
	    }
	  }, [_vm._v("\n              The European languages are members of the same family. Their separate existence is a myth.\n              For science, music, sport, etc, Europe uses the same vocabulary. The languages only differ\n              in their grammar, their pronunciation and their most common words. Everyone realizes why a\n              new common language would be desirable: one could refuse to pay expensive translators. To\n              achieve this, it would be necessary to have uniform grammar, pronunciation and more common\n              words. If several languages coalesce, the grammar of the resulting language is more simple\n              and regular than that of the individual languages.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "tab_3-2"
	    }
	  }, [_vm._v("\n              Lorem Ipsum is simply dummy text of the printing and typesetting industry.\n              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,\n              when an unknown printer took a galley of type and scrambled it to make a type specimen book.\n              It has survived not only five centuries, but also the leap into electronic typesetting,\n              remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset\n              sheets containing Lorem Ipsum passages, and more recently with desktop publishing software\n              like Aldus PageMaker including versions of Lorem Ipsum.\n            ")])])])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Progress Bars")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Progress Bars Different Sizes")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', [_c('code', [_vm._v(".progress")])]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-primary progress-bar-striped",
	    staticStyle: {
	      "width": "40%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "40",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("40% Complete (success)")])])]), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".sm")])]), _vm._v(" "), _c('div', {
	    staticClass: "progress progress-sm active"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-success progress-bar-striped",
	    staticStyle: {
	      "width": "20%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "20",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("20% Complete")])])]), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".xs")])]), _vm._v(" "), _c('div', {
	    staticClass: "progress progress-xs"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-warning progress-bar-striped",
	    staticStyle: {
	      "width": "60%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "60",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("60% Complete (warning)")])])]), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".xxs")])]), _vm._v(" "), _c('div', {
	    staticClass: "progress progress-xxs"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-danger progress-bar-striped",
	    staticStyle: {
	      "width": "60%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "60",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("60% Complete (warning)")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Progress bars")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-green",
	    staticStyle: {
	      "width": "40%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "40",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("40% Complete (success)")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-aqua",
	    staticStyle: {
	      "width": "20%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "20",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("20% Complete")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-yellow",
	    staticStyle: {
	      "width": "60%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "60",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("60% Complete (warning)")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-red",
	    staticStyle: {
	      "width": "80%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "80",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("80% Complete")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Vertical Progress Bars Different Sizes")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body text-center"
	  }, [_c('p', [_vm._v("By adding the class "), _c('code', [_vm._v(".vertical")]), _vm._v(" and "), _c('code', [_vm._v(".progress-sm")]), _vm._v(", "), _c('code', [_vm._v(".progress-xs")]), _vm._v(" or\n              "), _c('code', [_vm._v(".progress-xxs")]), _vm._v(" we achieve:")]), _vm._v(" "), _c('div', {
	    staticClass: "progress vertical active"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-primary progress-bar-striped",
	    staticStyle: {
	      "height": "40%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "40",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("40%")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress vertical progress-sm"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-success",
	    staticStyle: {
	      "height": "100%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "20",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("100%")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress vertical progress-xs"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-warning progress-bar-striped",
	    staticStyle: {
	      "height": "60%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "60",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("60%")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress vertical progress-xxs"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-info progress-bar-striped",
	    staticStyle: {
	      "height": "60%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "60",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("60%")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Vertical Progress bars")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body text-center"
	  }, [_c('p', [_vm._v("By adding the class "), _c('code', [_vm._v(".vertical")]), _vm._v(" we achieve:")]), _vm._v(" "), _c('div', {
	    staticClass: "progress vertical"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-green",
	    staticStyle: {
	      "height": "40%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "40",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("40%")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress vertical"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-aqua",
	    staticStyle: {
	      "height": "20%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "20",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("20%")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress vertical"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-yellow",
	    staticStyle: {
	      "height": "60%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "60",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("60%")])])]), _vm._v(" "), _c('div', {
	    staticClass: "progress vertical"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-red",
	    staticStyle: {
	      "height": "80%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "80",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("80%")])])])])])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Bootstrap Accordion & Carousel")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Collapsible Accordion")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-group",
	    attrs: {
	      "id": "accordion"
	    }
	  }, [_c('div', {
	    staticClass: "panel box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h4', {
	    staticClass: "box-title"
	  }, [_c('a', {
	    attrs: {
	      "data-toggle": "collapse",
	      "data-parent": "#accordion",
	      "href": "#collapseOne"
	    }
	  }, [_vm._v("\n                      Collapsible Group Item #1\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel-collapse collapse in",
	    attrs: {
	      "id": "collapseOne"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3\n                    wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum\n                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla\n                    assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred\n                    nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer\n                    farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus\n                    labore sustainable VHS.\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel box box-danger"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h4', {
	    staticClass: "box-title"
	  }, [_c('a', {
	    attrs: {
	      "data-toggle": "collapse",
	      "data-parent": "#accordion",
	      "href": "#collapseTwo"
	    }
	  }, [_vm._v("\n                      Collapsible Group Danger\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel-collapse collapse",
	    attrs: {
	      "id": "collapseTwo"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3\n                    wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum\n                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla\n                    assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred\n                    nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer\n                    farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus\n                    labore sustainable VHS.\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel box box-success"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h4', {
	    staticClass: "box-title"
	  }, [_c('a', {
	    attrs: {
	      "data-toggle": "collapse",
	      "data-parent": "#accordion",
	      "href": "#collapseThree"
	    }
	  }, [_vm._v("\n                      Collapsible Group Success\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel-collapse collapse",
	    attrs: {
	      "id": "collapseThree"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3\n                    wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum\n                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla\n                    assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred\n                    nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer\n                    farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus\n                    labore sustainable VHS.\n                  ")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Carousel")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "carousel slide",
	    attrs: {
	      "id": "carousel-example-generic",
	      "data-ride": "carousel"
	    }
	  }, [_c('ol', {
	    staticClass: "carousel-indicators"
	  }, [_c('li', {
	    staticClass: "active",
	    attrs: {
	      "data-target": "#carousel-example-generic",
	      "data-slide-to": "0"
	    }
	  }), _vm._v(" "), _c('li', {
	    attrs: {
	      "data-target": "#carousel-example-generic",
	      "data-slide-to": "1"
	    }
	  }), _vm._v(" "), _c('li', {
	    attrs: {
	      "data-target": "#carousel-example-generic",
	      "data-slide-to": "2"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "carousel-inner"
	  }, [_c('div', {
	    staticClass: "item active"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://placehold.it/900x500/39CCCC/ffffff&text=I+Love+Bootstrap",
	      "alt": "First slide"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "carousel-caption"
	  }, [_vm._v("\n                    First Slide\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://placehold.it/900x500/3c8dbc/ffffff&text=I+Love+Bootstrap",
	      "alt": "Second slide"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "carousel-caption"
	  }, [_vm._v("\n                    Second Slide\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://placehold.it/900x500/f39c12/ffffff&text=I+Love+Bootstrap",
	      "alt": "Third slide"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "carousel-caption"
	  }, [_vm._v("\n                    Third Slide\n                  ")])])]), _vm._v(" "), _c('a', {
	    staticClass: "left carousel-control",
	    attrs: {
	      "href": "#carousel-example-generic",
	      "data-slide": "prev"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-angle-left"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "right carousel-control",
	    attrs: {
	      "href": "#carousel-example-generic",
	      "data-slide": "next"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-angle-right"
	  })])])])])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Headlines")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h1', [_vm._v("h1. Bootstrap heading")]), _vm._v(" "), _c('h2', [_vm._v("h2. Bootstrap heading")]), _vm._v(" "), _c('h3', [_vm._v("h3. Bootstrap heading")]), _vm._v(" "), _c('h4', [_vm._v("h4. Bootstrap heading")]), _vm._v(" "), _c('h5', [_vm._v("h5. Bootstrap heading")]), _vm._v(" "), _c('h6', [_vm._v("h6. Bootstrap heading")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Text Emphasis")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', {
	    staticClass: "lead"
	  }, [_vm._v("Lead to emphasize importance")]), _vm._v(" "), _c('p', {
	    staticClass: "text-green"
	  }, [_vm._v("Text green to emphasize success")]), _vm._v(" "), _c('p', {
	    staticClass: "text-aqua"
	  }, [_vm._v("Text aqua to emphasize info")]), _vm._v(" "), _c('p', {
	    staticClass: "text-light-blue"
	  }, [_vm._v("Text light blue to emphasize info (2)")]), _vm._v(" "), _c('p', {
	    staticClass: "text-red"
	  }, [_vm._v("Text red to emphasize danger")]), _vm._v(" "), _c('p', {
	    staticClass: "text-yellow"
	  }, [_vm._v("Text yellow to emphasize warning")]), _vm._v(" "), _c('p', {
	    staticClass: "text-muted"
	  }, [_vm._v("Text muted to emphasize general")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Block Quotes")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('blockquote', [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('small', [_vm._v("Someone famous in "), _c('cite', {
	    attrs: {
	      "title": "Source Title"
	    }
	  }, [_vm._v("Source Title")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Block Quotes Pulled Right")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body clearfix"
	  }, [_c('blockquote', {
	    staticClass: "pull-right"
	  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('small', [_vm._v("Someone famous in "), _c('cite', {
	    attrs: {
	      "title": "Source Title"
	    }
	  }, [_vm._v("Source Title")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Unordered List")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('ul', [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n                "), _c('ul', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Ordered Lists")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('ol', [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n                "), _c('ol', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Unstyled List")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('ul', {
	    staticClass: "list-unstyled"
	  }, [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n                "), _c('ul', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Description")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('dl', [_c('dt', [_vm._v("Description lists")]), _vm._v(" "), _c('dd', [_vm._v("A description list is perfect for defining terms.")]), _vm._v(" "), _c('dt', [_vm._v("Euismod")]), _vm._v(" "), _c('dd', [_vm._v("Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.")]), _vm._v(" "), _c('dd', [_vm._v("Donec id elit non mi porta gravida at eget metus.")]), _vm._v(" "), _c('dt', [_vm._v("Malesuada porta")]), _vm._v(" "), _c('dd', [_vm._v("Etiam porta sem malesuada magna mollis euismod.")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Description Horizontal")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('dl', {
	    staticClass: "dl-horizontal"
	  }, [_c('dt', [_vm._v("Description lists")]), _vm._v(" "), _c('dd', [_vm._v("A description list is perfect for defining terms.")]), _vm._v(" "), _c('dt', [_vm._v("Euismod")]), _vm._v(" "), _c('dd', [_vm._v("Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.")]), _vm._v(" "), _c('dd', [_vm._v("Donec id elit non mi porta gravida at eget metus.")]), _vm._v(" "), _c('dt', [_vm._v("Malesuada porta")]), _vm._v(" "), _c('dd', [_vm._v("Etiam porta sem malesuada magna mollis euismod.")]), _vm._v(" "), _c('dt', [_vm._v("Felis euismod semper eget lacinia")]), _vm._v(" "), _c('dd', [_vm._v("Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo\n                sit amet risus.\n              ")])])])])])])])])
	}]}

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [(!_vm.disable && !_vm.visualiza) ? _c('div', {
	    staticClass: "row"
	  }, [(!_vm.adicionando) ? _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um dirigente / designado para Assinar o Convênio com a Fundação BB",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onNew()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Adicionar Dirigente / Designado ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.adicionando) ? _c('div', {
	    staticClass: "column all-start adicionar-dirigente-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-start required-field w-100"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 w-100",
	    attrs: {
	      "for": "forma_jurídica"
	    }
	  }, [_vm._v(" Dirigente/Designado: ")]), _vm._v(" "), _c('div', {
	    staticClass: "w-100"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dirigenteSelecionado),
	      expression: "dirigenteSelecionado"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.dirigenteSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione um Dirigente / Designado:")]), _vm._v(" "), _vm._l((_vm.dirigentesParaAdicionar), function(dirigente) {
	    return _c('option', {
	      domProps: {
	        "value": dirigente
	      }
	    }, [_vm._v(_vm._s(dirigente.ds_nome))])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um dirigente / designado para Assinar o Convênio com a Fundação BB",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onAdd()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Adicionar ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um dirigente / designado para Assinar o Convênio com a Fundação BB",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.adicionando = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "tableDirigentes",
	    attrs: {
	      "how-empty": "",
	      "stacked": "md",
	      "id": "dirigentes-table",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "tbody-tr-class": _vm.inativosMostrarOcultar,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "ds_nome",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value) + "    "), _c('span', {
	          staticStyle: {
	            "color": "cornflowerblue"
	          }
	        }, [_vm._v(_vm._s(row.item.cargo.ds_descricao))])]
	      }
	    }, {
	      key: "dt_inicio_mandato",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "dt_fim_mandato",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(!_vm.disable && !_vm.visualiza) ? _c('div', [_c('b-button', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.exclui(row); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>APAGAR</b> o dirigente / designado ' + row.item.ds_nome + ' ?'
	            }),
	            expression: "{ok: retorno => exclui(row), cancel: doNothing,\n                            message: 'Deseja <b>APAGAR</b> o dirigente / designado ' + row.item.ds_nome + ' ?'}"
	          }],
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1) : _c('div', [_vm._v("\n                  -\n                ")])]
	      }
	    }, {
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Lista Assuntos de Chamado'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Lista',
	        href: '#'
	      }, {
	        text: 'Assunto',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [(this.$root.authorize('chamado-criar-assunto')) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-assunto-edita'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Assunto ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.computedFields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "data_inclusao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "to": {
	              name: 'cadastro-assunto-edita',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.inativa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.bt_ativo ? 'Inativar' : 'Ativar'))])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Lista Assuntos de Chamado")])])
	}]}

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm.totais.aglutinado === 'Sim') ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('table', {
	    ref: "tabelaCronogramaAglutinado",
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.itensProjeto), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.Item_Descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Item_Tipo))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado)))]), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.quantidadeSolicitada))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.quantidadeSolicitada),
	        expression: "item.quantidadeSolicitada"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "quantidade a solicitar",
	        "type": "text"
	      },
	      domProps: {
	        "value": (item.quantidadeSolicitada)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "quantidadeSolicitada", $event.target.value)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.valorSolicitado)))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center"
	    }, [_c('money', {
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "valor a solicitar",
	        "type": "text"
	      },
	      model: {
	        value: (item.valorSolicitado),
	        callback: function($$v) {
	          _vm.$set(item, "valorSolicitado", $$v)
	        },
	        expression: "item.valorSolicitado"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_orcado - item.quantidadeSolicitada - item.Qtde_liberado || 0))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(item.Qtde_saldo - (item.quantidadeSolicitada ? item.quantidadeSolicitada : 0)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado - item.valorSolicitado - item.Valor_liberado)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo - (item.valorSolicitado ? item.valorSolicitado : 0))))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [(item.editing === false || !item.editing) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-edit",
	      staticStyle: {
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.editItem(item, 1)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green",
	        "margin-left": "5px",
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item, 2)
	        }
	      }
	    }) : _vm._e()])])
	  }), 0), _vm._v(" "), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor total de recursos contratados (+ Suplementado - Cancelado): ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado)))]), _vm._v(" "), _c('td')])]), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Saldo restante: ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.saldo_restante_projeto - _vm.total)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor total liberado: ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado - _vm.totais.saldo_restante_projeto)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v("Valor total da solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.total)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Saldo restante do projeto após solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.saldo_restante_projeto - _vm.total)))]), _vm._v(" "), _c('td')])])])])]) : _vm._e(), _vm._v(" "), (_vm.totais.aglutinado === 'Não') ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.itensProjeto), function(item) {
	    return _c('tbody', [_c('tr', {
	      staticStyle: {
	        "background-color": "rgb(223, 228, 235)"
	      }
	    }, [_c('td', {
	      attrs: {
	        "colspan": "9"
	      }
	    }, [_c('b', [_vm._v("Atividade:")]), _vm._v(" " + _vm._s(item.Atividade_nome) + "\n            ")])]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao)), _c('br'), _vm._v("#" + _vm._s(item.Id_item) + " " + _vm._s(item.Item_Observacao))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Item_Tipo))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado)))]), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.quantidadeSolicitada))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.quantidadeSolicitada),
	        expression: "item.quantidadeSolicitada"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "quantidade a solicitar",
	        "type": "text"
	      },
	      domProps: {
	        "value": (item.quantidadeSolicitada)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "quantidadeSolicitada", $event.target.value)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(item.valorSolicitado)))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_c('money', {
	      staticClass: "form-control text-right",
	      attrs: {
	        "name": "valor a solicitar",
	        "type": "text"
	      },
	      model: {
	        value: (item.valorSolicitado),
	        callback: function($$v) {
	          _vm.$set(item, "valorSolicitado", $$v)
	        },
	        expression: "item.valorSolicitado"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Qtde_orcado - item.quantidadeSolicitada - item.Qtde_liberado || 0))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(item.Qtde_saldo - (item.quantidadeSolicitada ? item.quantidadeSolicitada : 0)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado - item.valorSolicitado - item.Valor_liberado)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo - (item.valorSolicitado ? item.valorSolicitado : 0))))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      staticStyle: {
	        "border-right": "0.5px solid lavender"
	      }
	    }, [(item.editing === false || !item.editing) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-edit",
	      staticStyle: {
	        "margin-left": "5px"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.editItem(item, 1)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('i', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.propsEtapa !== 'Autorização'),
	        expression: "propsEtapa !== 'Autorização'"
	      }],
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green",
	        "margin-left": "5px",
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editItem(item, 2)
	        }
	      }
	    }) : _vm._e()])])
	  }), _vm._v(" "), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor total de recursos contratados (+ Suplementado - Cancelado): ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Valor total liberado: ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado - _vm.totais.saldo_restante_projeto)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Saldo restante: ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.saldo_restante_projeto)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v("Valor total da solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4",
	      "bgcolor": "#F0F8FF"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.total)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "border-right": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Saldo restante do projeto após solicitação:\t")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.saldo_restante_projeto - _vm.total)))]), _vm._v(" "), _c('td')])])], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-striped table-bordered",
	    staticStyle: {
	      "min-width": "750px"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.totalFBB > 0 || _vm.totalFaseFBB > 0) ? _c('tr', [_c('td', [_vm._v("Fundação")]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFaseFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantadoFaseFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.saldoFaseFBB)))])]) : _vm._e(), _vm._v(" "), (_vm.totalPAR > 0 || _vm.totalFasePAR > 0) ? _c('tr', [_c('td', [_vm._v("Parceiro Estratégico")]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalPAR)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFasePAR)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantadoFasePAR)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.saldoFasePAR)))])]) : _vm._e()])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Valor a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "7%"
	    }
	  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "12%"
	    }
	  }, [_vm._v("Quantidade a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Valor a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Recurso")]), _vm._v(" "), _c('th', [_vm._v("Fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total da fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total de adiantamento por fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total já adiantado")]), _vm._v(" "), _c('th', [_vm._v("Saldo de adiantamento restante por fase")])])])
	}]}

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget",
	    staticStyle: {
	      "min-height": "200px"
	    }
	  }, [(_vm.loading.tela) ? _c('div', [_vm._m(0)]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "width": "100%",
	      "font-weight": "bold",
	      "font-size": "18px"
	    }
	  }, [_vm._v("Súmula de Alteração em Projeto")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "right",
	      "width": "100%"
	    }
	  }, [_vm._v("Dides / Alteração em Projetos ID "), _c('strong', [_vm._v(_vm._s(this.id))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "right",
	      "width": "100%"
	    }
	  }, [_vm._v("Brasília (DF),\t" + _vm._s((new Date()).getDate()) + " de " + _vm._s((new Date()).toLocaleString('pt-br', {
	    month: 'long'
	  })) + " de " + _vm._s((new Date()).getFullYear()))]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "right",
	      "width": "100%",
	      "font-style": "italic"
	    }
	  }, [_vm._v("#interna")])]), _vm._v(" "), (!_vm._.isEmpty(_vm.propostaBackup)) ? _c('div', {
	    staticClass: "secao_sumula"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('tr', [_c('td', {
	    staticClass: "b3 pad10",
	    staticStyle: {
	      "width": "200px"
	    }
	  }, [_vm._v("Número e Título do projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista",
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(_vm._s(_vm.propostaBackup.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.propostaBackup.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Nome da Instituição")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista",
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(_vm._s(_vm.propostaBackup.projetoSapiens.entidadeParceira.nomfor))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Objetivo Geral")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista",
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(_vm._s(_vm.propostaBackup.ds_objetivo_geral))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Municípios Atendidos")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista",
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(_vm._s(_vm._.join(_vm._.uniq(_vm._.map(_vm.propostaBackup.municipalizacao, function(m) {
	    return m.ds_municipio + (_vm._.isNil(m.ds_uf) ? '' : ' (' + m.ds_uf + ')')
	  })), ', ')))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Valor do projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.map(_vm._.filter(_vm._.flatten(_vm._.map(_vm.propostaBackup.atividades, 'itens_orcamentos')), function(i) {
	    return _vm._.includes(['1', '5'], ('' + i.origem).substr(0, 1))
	  }), 'valor_total')))))]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.map(_vm._.filter(_vm._.flatten(_vm._.map(_vm.propostaBackup.atividades, 'itens_orcamentos')), function(i) {
	    return _vm._.includes(['2'], ('' + i.origem).substr(0, 1))
	  }), 'valor_total')))))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Data de Deferimento")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propostaBackup.projetoSapiens.usu_datdef, "L")))]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Fim do Prazo de Execução")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista"
	  }, [_vm._v(_vm._s(_vm.dataFinal))]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Fim de Vigência")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dataFinalVigencia, "L")))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Projeto superior")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista",
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(_vm._s(_vm.propostaBackup.projetoSapiens.projetoSuperior.numprj) + " - " + _vm._s(_vm.propostaBackup.projetoSapiens.projetoSuperior.nomprj))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista",
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(_vm._s(_vm.solicitacao.justificativa))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "secao_sumula"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("Tipo de alteração a ser efetuada no projeto")]), _vm._v(" "), _c('div', {}, [_c('table', {
	    staticClass: "table"
	  }, [(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.metas) > 0) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Alteração de metas")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.contrapartidas) > 0) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Alteração da contrapartida aprovada")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade) !== 0) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Ajustes nas quantidades dos itens de despesa")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[1]) > 0 || _vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[1]) > 0) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Prorrogação de prazo(s)")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[0]) !== _vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[1])) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("Prazo de Execução")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 text-right"
	  }, [_vm._v("\n                  De "), _c('span', {
	    staticClass: "valor_lista"
	  }, [_vm._v(_vm._s(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[0]))]), _vm._v(" meses para "), _c('span', {
	    staticClass: "valor_lista"
	  }, [_vm._v(_vm._s(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[1]))]), _vm._v(" meses\n                ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[0]) !== _vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[1])) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("Prazo de Vigência")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 text-right"
	  }, [_vm._v("\n                  De "), _c('span', {
	    staticClass: "valor_lista"
	  }, [_vm._v(_vm._s(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[0]))]), _vm._v(" meses para "), _c('span', {
	    staticClass: "valor_lista"
	  }, [_vm._v(_vm._s(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[1]))]), _vm._v(" meses\n                ")])]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, function(prc) {
	    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
	  })) ? [_c('tr', [_c('td', {
	    staticClass: "b3 pad10"
	  }, [_vm._v("Alteração de Cronograma físico-financeiro")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v(_vm._s(_vm._.join(_vm._.map(_vm._.filter(_vm.solicitacao.processos, function(prc) {
	    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
	  }), 'nome'), ', ')))])]), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.novosItens) > 0) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Inclusão de novos itens no projeto\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm.solicitacao.sumula.resumoAlteracoes.novosItens) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.substituicaoItens) > 0) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Substituição de itens de despesas constantes do projeto\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm.solicitacao.sumula.resumoAlteracoes.substituicaoItens) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos) > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'REMANEJAMENTO'])) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Percentual dos Remanejamentos Concedidos\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("percentage")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos) / 100)) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoSolicitado) > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'REMANEJAMENTO'])) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Remanejamento Solicitado (Valor e Percentual)\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorRemanejado || 0))) + "\n                    "), _c('span', {
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v("\n                      ( " + _vm._s(_vm._f("percentage")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoSolicitado))) + " )\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, function(prc) {
	    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
	  })) ? [_c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20",
	    staticStyle: {
	      "width": "50%",
	      "vertical-align": "top"
	    }
	  }, [_c('p', {
	    staticClass: "text-bold"
	  }, [_vm._v("Débitos")]), _vm._v(" "), _vm._l((_vm._.get(_vm._.find(_vm.solicitacao.processos, function(prc) {
	    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
	  }), 'alteracao', [])), function(alteracao) {
	    return (_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0)) < 0) ? _c('div', _vm._l(([_vm.itemExtrato(alteracao.id)]), function(item) {
	      return _c('span', [_c('div', {
	        staticClass: "itemExtrato"
	      }, [_c('span', {
	        staticClass: "itemInformacao"
	      }, [_c('span', [_c('span', {
	        staticClass: "text-muted"
	      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('span', {
	        staticClass: "itemDescricao"
	      }, [_vm._v(" - " + _vm._s(item.observacao))])]), _vm._v(" "), (alteracao.justificativa) ? _c('span', {
	        staticClass: "text-bold"
	      }, [_vm._v(_vm._s(alteracao.justificativa[1] ? alteracao.justificativa[1] : ""))]) : _vm._e(), _vm._v(" "), (alteracao.adiantavel && (alteracao.adiantavel[0] === '1' && alteracao.adiantavel[1] === '0')) ? _c('span', [_vm._v(" Item adiantável")]) : _vm._e(), _vm._v(" "), (alteracao.adiantavel && (alteracao.adiantavel[0] === '0' && alteracao.adiantavel === '1')) ? _c('span', [_vm._v(" Item não adiantável")]) : _vm._e(), _vm._v(" "), _c('span', {
	        staticClass: "itemValores"
	      }, [_c('span', {
	        staticClass: "itemOrcado"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total)))]), _vm._v(" "), _c('span', {
	        staticClass: "itemValorAlteracao text-red"
	      }, [_vm._v(_vm._s(_vm._f("real")(_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0)))))]), _vm._v(" "), _c('span', {
	        staticClass: "itemOrcadoAlterado"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total + (_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0))))))])])])])])
	    }), 0) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm._.get(_vm._.find(_vm.solicitacao.processos, function(prc) {
	    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
	  }), 'alteracao', [])), function(alteracao) {
	    return (_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0)) === 0) ? _c('div', _vm._l(([_vm.itemExtrato(alteracao.id)]), function(item) {
	      return _c('span', [_c('div', {
	        staticClass: "itemExtrato"
	      }, [_c('span', {
	        staticClass: "itemInformacao"
	      }, [_c('span', [_c('span', {
	        staticClass: "text-muted"
	      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('span', {
	        staticClass: "itemDescricao"
	      }, [_vm._v(" - " + _vm._s(item.observacao))])]), _vm._v(" "), (alteracao.justificativa) ? _c('span', {
	        staticClass: "text-bold"
	      }, [_vm._v(_vm._s(alteracao.justificativa[1] ? alteracao.justificativa[1] : ""))]) : _vm._e(), _vm._v(" "), (alteracao.adiantavel && (alteracao.adiantavel[0] === '1' && alteracao.adiantavel[1] === '0')) ? _c('span', [_vm._v(" Item adiantável")]) : _vm._e(), _vm._v(" "), (alteracao.adiantavel && (alteracao.adiantavel[0] === '0' && alteracao.adiantavel === '1')) ? _c('span', [_vm._v(" Item não adiantável")]) : _vm._e(), _vm._v(" "), (_vm.getTextoObservacao(item)) ? _c('span', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Observação anterior:")]), _vm._v(" " + _vm._s(_vm.getTextoObservacao(item)) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', {
	        staticClass: "itemValores"
	      }, [_c('span', {
	        staticClass: "itemOrcado"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total)))]), _vm._v(" "), _c('span', {
	        staticClass: "itemValorAlteracao text-red"
	      }, [_vm._v(_vm._s(_vm._f("real")(_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0)))))]), _vm._v(" "), _c('span', {
	        staticClass: "itemOrcadoAlterado"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total + (_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0))))))])])])])])
	    }), 0) : _vm._e()
	  })], 2), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 pL20",
	    staticStyle: {
	      "width": "50%",
	      "vertical-align": "top"
	    }
	  }, [_c('p', {
	    staticClass: "text-bold"
	  }, [_vm._v("Créditos")]), _vm._v(" "), _vm._l((_vm._.get(_vm._.find(_vm.solicitacao.processos, function(prc) {
	    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
	  }), 'alteracao', [])), function(alteracao) {
	    return (_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0)) >= 0) ? _c('div', _vm._l(([_vm.itemExtrato(alteracao.id)]), function(item) {
	      return _c('span', [_c('div', {
	        staticClass: "itemExtrato"
	      }, [_c('span', {
	        staticClass: "itemInformacao"
	      }, [_c('span', [_c('span', {
	        staticClass: "text-muted"
	      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('span', {
	        staticClass: "itemDescricao"
	      }, [_vm._v(" - " + _vm._s(item.observacao))])]), _vm._v(" "), (alteracao.justificativa) ? _c('span', {
	        staticClass: "text-bold"
	      }, [_vm._v(_vm._s(alteracao.justificativa[1] ? alteracao.justificativa[1] : ""))]) : _vm._e(), _vm._v(" "), (alteracao.adiantavel && (alteracao.adiantavel[0] === '1' && alteracao.adiantavel[1] === '0')) ? _c('span', [_vm._v(" Item não adiantável")]) : _vm._e(), _vm._v(" "), (alteracao.adiantavel && (alteracao.adiantavel[0] === '0' && alteracao.adiantavel === '1')) ? _c('span', [_vm._v(" Item adiantável")]) : _vm._e(), _vm._v(" "), (_vm.getTextoObservacao(item) && _vm.getTextoObservacaoNova(item)) ? _c('span', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Observação Nova:")]), _vm._v(" " + _vm._s(_vm.getTextoObservacaoNova(item)) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', {
	        staticClass: "itemValores"
	      }, [_c('span', {
	        staticClass: "itemOrcado"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total)))]), _vm._v(" "), _c('span', {
	        staticClass: "itemValorAlteracao text-green"
	      }, [_vm._v("+ " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0)))))]), _vm._v(" "), _c('span', {
	        staticClass: "itemOrcadoAlterado"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total + (_vm._.toNumber(_vm._.get(alteracao, 'valorAlteracao.1', 0))))))])])])])])
	    }), 0) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm._.get(_vm._.find(_vm.solicitacao.processos, function(prc) {
	    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
	  }), 'inclusao', [])), function(alteracao) {
	    return _c('div', _vm._l(([_vm.itemExtrato(alteracao.id)]), function(item) {
	      return _c('span', [_c('div', {
	        staticClass: "itemExtrato"
	      }, [_c('span', {
	        staticClass: "itemInformacao"
	      }, [_c('span', [_c('span', {
	        staticClass: "label label-info"
	      }, [_vm._v("Novo")]), _vm._v(" "), _c('span', {
	        staticClass: "text-muted"
	      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('span', {
	        staticClass: "itemDescricao"
	      }, [_vm._v(" - " + _vm._s(item.observacao))])]), _vm._v(" "), _c('span', {
	        staticClass: "text-bold"
	      }, [_vm._v(_vm._s(item.justificativa))]), _vm._v(" "), _c('span', {
	        staticClass: "itemValores"
	      }, [_c('span', {
	        staticClass: "itemOrcado"
	      }, [_vm._v("-")]), _vm._v(" "), _c('span', {
	        staticClass: "itemValorAlteracao text-blue"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valorAlteracao)))]), _vm._v(" "), _c('span', {
	        staticClass: "itemOrcadoAlterado"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valorAlteracao)))])])])])])
	    }), 0)
	  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoAcumulado > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'REMANEJAMENTO'])) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Percentual Acumulado\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("percentage")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoAcumulado))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm._.get(_vm.solicitacao.sumula.resumoAlteracoes, 'valorRemanejado', 0)) > 0 && _vm._.find(_vm.solicitacao.processos, function(prc) {
	    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
	  })) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Total de Remanejamento\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm._.get(_vm.solicitacao.sumula.resumoAlteracoes, 'valorRemanejado', 0)))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorSuplementacao) > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'SUPLEMENTACAO'])) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Valor solicitado de suplementação\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorSuplementacao))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorTotalComSuplementacao) > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'SUPLEMENTACAO'])) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Valor do projeto após suplementação\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorTotalComSuplementacao))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm._.get(_vm.solicitacao.sumula.resumoAlteracoes, 'valorTotalAlteracao', 0)) > 0) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Total da Alteração\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm._.get(_vm.solicitacao.sumula.resumoAlteracoes, 'valorTotalAlteracao', 0)))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, ['nome', 'SUPLEMENTACAO'])) ? _c('tr', [_c('td', {
	    staticClass: "b3 pad10 pL20"
	  }, [_vm._v("\n                    Enquadramento orçamentário (FEP)\n                  ")]), _vm._v(" "), _c('td', {
	    staticClass: "b3 pad10 valor_lista text-right"
	  }, [_vm._v("\n                    " + _vm._s(_vm.solicitacao.sumula.resumoAlteracoes.enquadramentoOrcamentarioFEP) + "\n                  ")])]) : _vm._e()] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "secao_sumula"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("Verificação de conformidade")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "sumula_formulario"
	  }, [_vm._l((_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
	    return !_vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
	  })), function(pergunta, idx) {
	    return _c('tr', {
	      staticClass: "sumula_pergunta"
	    }, [_c('td', {
	      staticClass: "sumula_codigo"
	    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', {
	      staticClass: "sumula_questao",
	      domProps: {
	        "innerHTML": _vm._s(pergunta.questao)
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "sumula_resposta text-center"
	    }, [_c('span', {
	      staticClass: "valor_lista"
	    }, [_vm._v(_vm._s((pergunta.resposta === 'sim' ? 'Sim' : (pergunta.resposta === 'nao' ? 'Não' : (pergunta.resposta === 'pre' ? 'Prejudicado' : '-')))))])]), _vm._v(" "), _c('td', {
	      staticClass: "sumula_questao"
	    }, [(!_vm.loading.ocorrencias && _vm._.includes(['Q005'], pergunta.codigo)) ? _c('span', {
	      staticClass: "link_acesso pad10",
	      on: {
	        "click": function($event) {
	          return _vm.$refs.alertaCancelamentoDialog.showModal()
	        }
	      }
	    }, [_vm._v("Consultar Ocorrências")]) : _vm._e()])])
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "sumula_cabecalho_questoes"
	  }, [_c('td', {
	    staticClass: "sumula_codigo"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
	    staticClass: "sumula_resposta text-center"
	  }, [_c('span', {
	    staticClass: "valor_lista"
	  }, [_vm._v(_vm._s((_vm.solicitacao.sumula.parceriaEstrategica === 'sim' ? 'Sim' : (_vm.solicitacao.sumula.parceriaEstrategica === 'nao' ? 'Não' : '-'))))])])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
	    return _vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
	  })), function(pergunta, idx) {
	    return (_vm.solicitacao.sumula.parceriaEstrategica === 'sim') ? _c('tr', {
	      staticClass: "sumula_pergunta"
	    }, [_c('td', {
	      staticClass: "sumula_codigo"
	    }, [_vm._v(_vm._s(idx + (_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
	      return !_vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
	    })).length + 1))]), _vm._v(" "), _c('td', {
	      staticClass: "sumula_questao",
	      domProps: {
	        "innerHTML": _vm._s(pergunta.questao)
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "sumula_resposta text-center"
	    }, [_c('span', {
	      staticClass: "valor_lista"
	    }, [_vm._v(_vm._s((pergunta.resposta === 'sim' ? 'Sim' : (pergunta.resposta === 'nao' ? 'Não' : (pergunta.resposta === 'pre' ? 'Prejudicado' : '-')))))])])]) : _vm._e()
	  })], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "secao_sumula"
	  }, [_c('div', {
	    staticClass: "pad10"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("Contexto:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.textoContexto))])]), _vm._v(" "), _c('div', {
	    staticClass: "pad10"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("Situação Problema:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.textoSituacaoProblema))])]), _vm._v(" "), _c('div', {
	    staticClass: "pad10"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("Parecer:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.textoParecer))])]), _vm._v(" "), _c('div', {
	    staticClass: "pad10"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("Proposta:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.textoProposta))])]), _vm._v(" "), (_vm._.has(_vm.solicitacao, 'motivoAlteracao.codigo')) ? _c('div', {
	    staticClass: "pad10"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("Motivo:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.motivoAlteracao.codigo.replace('_', ' ')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "secao_sumula"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("Providências:")]), _vm._v(" "), _c('div', [(_vm.solicitacao.sumula.providencias.length === 0) ? _c('span', [_vm._v("Sem providências")]) : _c('span', [_vm._v(_vm._s(_vm._.join(_vm._.map(_vm.solicitacao.sumula.providencias, 'descricao'), ', ')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "secao_sumula"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v("\n            Competências e Alçadas (SIC 1.4.5.1) - Resolução de Competências e Alçadas Direx 2023_00388 de 11.12.2023\n          ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.alcada.descricao))])])])]), _vm._v(" "), _c('dialog', {
	    ref: "alertaCancelamentoDialog",
	    attrs: {
	      "id": "alertaCancelamentoDialog"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "min-width": "60vw"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "max-height": "400px",
	      "overflow-y": "auto",
	      "margin": "20px 0"
	    }
	  }, [(_vm.ocorrencias && _vm.ocorrencias.length > 0) ? _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.ocorrencias), function(ocorrencia, index) {
	    return _c('tr', {
	      key: index
	    }, [_c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v("\n              " + _vm._s(ocorrencia.codigo) + " - " + _vm._s(ocorrencia.descricao) + "\n            ")]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v("\n              " + _vm._s(_vm._f("moment")(ocorrencia.inicio, "L")) + "\n            ")]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v("\n              " + _vm._s(ocorrencia.observacao) + "\n            ")]), _vm._v(" "), _c('td', {
	      staticClass: "celula centralizado borda"
	    }, [_vm._v("\n              " + _vm._s(ocorrencia.etapa) + "\n            ")])])
	  }), 0)]) : _c('p', {
	    staticStyle: {
	      "text-align": "center",
	      "padding": "20px",
	      "color": "#777"
	    }
	  }, [_vm._v("\n        Nenhuma ocorrência encontrada para este projeto.\n      ")])]), _vm._v(" "), _vm._m(5)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "sumula_questao"
	  }, [_c('label', [_vm._v("Parceria Estratégica?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "secao_sumula"
	  }, [_c('div', {
	    staticClass: "titulo_secao_sumula"
	  }, [_vm._v(" Análise:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("Lista de Ocorrências")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "centralizado borda",
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Ocorrência")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda",
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Data")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda",
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado borda",
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Situação")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_c('form', {
	    attrs: {
	      "method": "dialog"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-neutral"
	  }, [_vm._v("Fechar")])])])
	}]}

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "content-wrapper cotacao-main-container"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('vue-headful', {
	    attrs: {
	      "title": 'SGP - GERENCIAMENTO DE ACESSO DE COTAÇÃO AUTOMÁTICA'
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'ODS',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column all-centered cotacao-content"
	  }, [_c('div', {
	    staticClass: "row-flex centered-start button-row"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleEdicao(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          Autorizar Acesso")])]), _vm._v(" "), (_vm.editando) ? _c('div', {
	    staticClass: "column start-centered cotacao-restricao"
	  }, [_c('div', {
	    staticClass: "restricao-row"
	  }, [_c('label', [_vm._v(" Selecione o Escopo do Acesso: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoSelecionado),
	      expression: "tipoSelecionado"
	    }],
	    staticClass: "form-control hidden-print",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.tipoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.buscaOptions()
	      }]
	    }
	  }, _vm._l((_vm.tipos), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo
	      }
	    }, [_vm._v(_vm._s(tipo))])
	  }), 0)]), _vm._v(" "), (_vm.tipoSelecionado === 'EDITAL') ? _c('div', {
	    staticClass: "restricao-row"
	  }, [_c('label', [_vm._v(" Selecione o Edital: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editalSelecionado),
	      expression: "editalSelecionado"
	    }],
	    staticClass: "form-control hidden-print",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.editalSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {}]
	    }
	  }, _vm._l((_vm.editais), function(edital) {
	    return _c('option', {
	      domProps: {
	        "value": edital
	      }
	    }, [_vm._v(_vm._s(edital.id) + " | " + _vm._s(edital.ds_numero_edital))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.tipoSelecionado === 'PROPOSTA') ? _c('div', {
	    staticClass: "restricao-row"
	  }, [_c('label', [_vm._v(" Selecione a Proposta: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSelecionada),
	      expression: "propostaSelecionada"
	    }],
	    staticClass: "form-control hidden-print",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.propostaSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {}]
	    }
	  }, _vm._l((_vm.propostas), function(proposta) {
	    return _c('option', {
	      domProps: {
	        "value": proposta
	      }
	    }, [_vm._v(_vm._s(proposta.id) + " | " + _vm._s(proposta.ds_nome))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.tipoSelecionado === 'EXCECAO EDITAL') ? _c('div', {
	    staticClass: "restricao-row"
	  }, [_c('label', [_vm._v(" Selecione a Proposta: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSelecionada),
	      expression: "propostaSelecionada"
	    }],
	    staticClass: "form-control hidden-print",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.propostaSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {}]
	    }
	  }, _vm._l((_vm.propostas), function(proposta) {
	    return _c('option', {
	      domProps: {
	        "value": proposta
	      }
	    }, [_vm._v(_vm._s(proposta.id) + " | " + _vm._s(proposta.ds_nome))])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "restricao-row"
	  }, [_c('label', [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.justificativa),
	      expression: "justificativa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "descricao"
	    },
	    domProps: {
	      "value": (_vm.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.justificativa = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start button-row"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gravaRestricao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              Salvar\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "color": "error"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleEdicao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              Cancelar\n            ")])])]) : _vm._e(), _vm._v(" "), _c('b-container', {
	    staticClass: "tabela-restricao",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          staticStyle: {
	            "cursor": "pointer"
	          },
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.ativaDesativaRestricao(row.item)
	            }
	          }
	        })]
	      }
	    }, {
	      key: "updated_at",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(_vm._f("moment")(row.value, "L")) + "\n            ")]
	      }
	    }], null, false, 2617057919)
	  })], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('span', [_vm._v("Gerenciamento de Acesso - Cotação Automática")])])
	}]}

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', [_vm._v("Usuários por Projeto")]), _vm._v(" "), (!_vm.loading.tela && _vm._.isEmpty(_vm.usuarioEditando) && _vm.listaUsuarios.length > 0) ? _c('span', [_c('g-button-moema', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [500, 0]}"
	    }],
	    attrs: {
	      "color": "success",
	      "title": '<h5>Grava todas as alterações realizadas nos usuários do projeto <span class=\'realce\'>' + _vm.projetoSelecionado.ds_codigo_projeto_erp + ' - ' + _vm.projetoSelecionado.ds_nome + '</span></h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.permiteConcluir()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Usuários por projeto',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm._.isEmpty(_vm.usuarioEditando)) ? _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal",
	    attrs: {
	      "id": "listaProjetos"
	    }
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "listagemProjetos",
	    attrs: {
	      "options": _vm.listaProjetos,
	      "multiple": false,
	      "placeholder": "Selecione um projeto",
	      "track-by": "id",
	      "label": "ds_nome",
	      "custom-label": function (option) {
	        return ("" + (option.ds_codigo_projeto_erp + option.ds_nome + option.ds_situacao_erp))
	      },
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('strong', [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" " + _vm._s(props.option.ds_nome) + " (" + _vm._s(props.option.ds_situacao_erp) + ")\n                ")]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "identificadorIDProjeto"
	        }, [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" " + _vm._s(props.option.ds_nome) + " (" + _vm._s(props.option.ds_situacao_erp) + ")\n                ")]
	      }
	    }], null, false, 2541572116),
	    model: {
	      value: (_vm.projetoSelecionado),
	      callback: function($$v) {
	        _vm.projetoSelecionado = $$v
	      },
	      expression: "projetoSelecionado"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum projeto localizado!")])], 2)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [(_vm.restricaoParaInicializar.length > 0) ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.restricaoParaInicializar), function(restricao) {
	    return _c('p', [_vm._v(_vm._s(restricao))])
	  })], 2) : _vm._e()])]), _vm._v(" "), (!_vm._.isEmpty(_vm.listaUsuarios)) ? _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "alteracao_usuarios_entidade"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('g-button-moema', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [500, 0]}"
	    }],
	    attrs: {
	      "color": "primary",
	      "type": "button",
	      "title": '<h5>Clicar para iniciar cadastro de novo usuário que será vinculado ao projeto <span class=\'realce\'>' + _vm.projetoSelecionado.ds_codigo_projeto_erp + ' - ' + _vm.projetoSelecionado.ds_nome + '</span></h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.novoUsuario()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo usuário\n                  ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": _vm.ajustaPesquisa,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [(_vm.pesquisa.length > 0) ? _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.tabelaUsuarios.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pesquisa = '';
	        _vm.tabelaUsuarios.filter = null
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close"
	  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 text-muted text-left"
	  }, [_vm._v(_vm._s(_vm.pesquisa.length > 0 ? _vm.tabelaUsuarios.totalRows + ' localizado(s)' : ' '))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        placement: 'left'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', placement:'left'}"
	    }],
	    staticClass: "col-md-2 text-muted text-right",
	    staticStyle: {
	      "cursor": "default"
	    },
	    attrs: {
	      "title": '<h5>Há três níveis de acesso aos projetos: <div class=\'legendas_acessos\'>' +
	        '<p class=\'tag_sem_acesso\'>Podem entrar no SGP, se estiver ativo,<br> mas não terá acesso a este projeto</p>' +
	        '<p class=\'tag_visualizacao_projeto\'>Terá acesso para ver o projeto e<br> acompanhar suas ações sem intervir</p>' +
	        '<p class=\'tag_inicia_solicitacao\'>Acesso completo. Permite pedir <br>liberação de recursos, alteração de projeto etc</p>' +
	        '</div></h5>'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation"
	  }), _vm._v("nformações\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    key: 'tabelaUsuarios_' + _vm.tabelaUsuarios.numeroAtualizacao,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "hover": "",
	      "bordered": _vm.tabelaUsuarios.bordered,
	      "items": _vm.listaUsuarios,
	      "fields": _vm.tabelaUsuarios.fields,
	      "current-page": _vm.tabelaUsuarios.currentPage,
	      "per-page": _vm.tabelaUsuarios.perPage,
	      "sort-by": _vm.tabelaUsuarios.sortBy,
	      "sort-desc": _vm.tabelaUsuarios.sortDesc,
	      "filter": _vm.tabelaUsuarios.filter,
	      "filter-function": _vm.filtroPorItem,
	      "empty-filtered-text": 'Não encontrei nada relacionado a ´' + _vm.pesquisa + '´ na pesquisa',
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tabelaUsuarios, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tabelaUsuarios, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tabelaUsuarios, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tabelaUsuarios, "sortDesc", $event)
	      },
	      "filtered": _vm.onFiltered
	    },
	    scopedSlots: _vm._u([{
	      key: "ds_nome_usuario",
	      fn: function(row) {
	        return [_c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              delay: [500, 0]
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [500, 0]}"
	          }],
	          staticClass: "truncar",
	          staticStyle: {
	            "width": "150px"
	          },
	          attrs: {
	            "title": '<h5>' + row.value + '</h5>'
	          }
	        }, [_vm._v(_vm._s(row.value))]), _vm._v(" "), (row.item.id === 0) ? _c('div', {
	          staticClass: "text-green"
	        }, [_vm._v("\n                      usuário novo\n                      "), _c('i', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	          }],
	          staticClass: "fa fa-close botao_excluir_usuario_novo",
	          attrs: {
	            "title": '<h5>Exclue esse usuário novo, que ainda não foi consta nesse projeto</h5>'
	          },
	          on: {
	            "click": function($event) {
	              return _vm.excluirUsuarioNovo(row.item.tempId)
	            }
	          }
	        })]) : _vm._e()]
	      }
	    }, {
	      key: "ds_email",
	      fn: function(row) {
	        return [_c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              delay: [500, 0]
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [500, 0]}"
	          }],
	          staticClass: "truncar",
	          staticStyle: {
	            "max-width": "200px"
	          },
	          attrs: {
	            "title": '<h5>' + row.value + '</h5>'
	          }
	        }, [_vm._v(_vm._s(row.value))])]
	      }
	    }, {
	      key: "ds_telefone",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("telefone")(row.value)))]
	      }
	    }, {
	      key: "ds_cpf",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("cpf")(row.value)))]
	      }
	    }, {
	      key: "acessos",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "required-field",
	          class: {
	            'has-error': _vm.errors.first('acesso_' + row.item.tempId)
	          }
	        }, [_c('multiselect', {
	          directives: [{
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          attrs: {
	            "options": _vm.listaAcessos,
	            "multiple": true,
	            "placeholder": "",
	            "track-by": "codigo",
	            "label": "descricao",
	            "preselect-first": false,
	            "close-on-select": true,
	            "max": 1,
	            "disabled": row.item.ds_cpf === null,
	            "selectLabel": "",
	            "deselectLabel": "",
	            "selectedLabel": "",
	            "name": 'acesso_' + row.item.tempId
	          },
	          scopedSlots: _vm._u([{
	            key: "option",
	            fn: function(props) {
	              return [_vm._v(_vm._s(props.option.descricao))]
	            }
	          }, {
	            key: "singleLabel",
	            fn: function(props) {
	              return [_c('strong', [_vm._v(_vm._s(props.option.descricao))])]
	            }
	          }, {
	            key: "maxElements",
	            fn: function(props) {
	              return [_vm._v("Se quiser trocar, exclua antes")]
	            }
	          }, {
	            key: "tag",
	            fn: function(props) {
	              return [_c('span', {
	                class: 'tag_acessos tag_' + _vm._.toLower(props.option.codigo)
	              }, [_c('span', [_vm._v(_vm._s(props.option.descricao))]), _vm._v(" "), _c('span', {
	                staticClass: "multiselect__tag-icon",
	                on: {
	                  "click": function($event) {
	                    return props.remove(props.option)
	                  }
	                }
	              })])]
	            }
	          }], null, true),
	          model: {
	            value: (row.item.acessos),
	            callback: function($$v) {
	              _vm.$set(row.item, "acessos", $$v)
	            },
	            expression: "row.item.acessos"
	          }
	        }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
	          slot: "noResult"
	        }, [_vm._v("Nenhuma acesso localizada!")])], 2), _vm._v(" "), (_vm.errors.first('acesso_' + row.item.tempId)) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" Deve selecionar um acesso")]) : _vm._e()], 1)]
	      }
	    }, {
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'fade',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large'}"
	          }],
	          class: ('' + row.value) === '0' ? 'fa fa-circle text-red' : 'fa fa-circle text-green',
	          staticStyle: {
	            "cursor": "pointer"
	          },
	          attrs: {
	            "aria-hidden": "true",
	            "title": '<h5>Situação do usuário: <div class=\'legendas_acessos text-left\'>' +
	              '<p><i class=\'fa fa-circle text-red\'></i> <span class=' + (('' + row.value) === '0' ? 'realce' : '') + '>Inativo</span>: Não pode entrar no SGP</p>' +
	              '<p><i class=\'fa fa-circle text-green\'></i> <span class=' + (('' + row.value) === '1' ? 'realce' : '') + '>Ativo</span>: Pode entrar no SGP</p>' +
	              '<p>Clique para alterar para <b>' + (('' + row.value) === '0' ? 'ATIVO' : 'INATIVO') + '</b>,<br/> depois conclua as alterações</p></div></h5>'
	          },
	          on: {
	            "click": function($event) {
	              row.item.bt_ativo = ('' + row.value) === '0' ? 1 : 0
	            }
	          }
	        })]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(row.item.ds_cpf !== null) ? _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.editaUsuario(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]) : _vm._e()]
	      }
	    }], null, false, 3439086163)
	  }), _vm._v(" "), (!_vm._.isEmpty(_vm.listaUsuarios) && _vm.listaUsuarios.length > _vm.tabelaUsuarios.perPage && _vm.tabelaUsuarios.totalRows > _vm.tabelaUsuarios.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.listaUsuarios.length,
	      "per-page": _vm.tabelaUsuarios.perPage
	    },
	    model: {
	      value: (_vm.tabelaUsuarios.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tabelaUsuarios, "currentPage", $$v)
	      },
	      expression: "tabelaUsuarios.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.usuarioEditando)) ? _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm._.isNull(_vm.usuarioEditando.id) ? 'Criando usuário para' : (_vm.usuarioEditando.id === 0 ? 'Alterando usuário novo de ' : 'Editando usuário de'))), _c('b', [_vm._v(" " + _vm._s(_vm.projetoSelecionado.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.projetoSelecionado.ds_nome))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-12 well"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuarioEditando.ds_nome_usuario),
	      expression: "usuarioEditando.ds_nome_usuario"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:100'),
	      expression: "'required|min:1|max:100'"
	    }],
	    ref: "ds_nome_usuario",
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "id": "nome",
	      "type": "text",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.usuarioEditando.ds_nome_usuario)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuarioEditando, "ds_nome_usuario", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome do Usuário é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cpf')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cpf"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf",
	      "data-vv-as": "CPF",
	      "id": "cpf",
	      "type": "text",
	      "disabled": _vm.ehVisualizacao,
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.usuarioEditando.ds_cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.usuarioEditando, "ds_cpf", $$v)
	      },
	      expression: "usuarioEditando.ds_cpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('login')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "login"
	    }
	  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuarioEditando.ds_login),
	      expression: "usuarioEditando.ds_login"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:5|max:14'),
	      expression: "'required|min:5|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "login",
	      "id": "login",
	      "type": "text",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.usuarioEditando.ds_login)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.verificaLoginJaCadastrado()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuarioEditando, "ds_login", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('login')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('login')))]) : _vm._e()]), _vm._v(" "), (_vm.loading.verifica.login) ? _c('span', {
	    staticClass: "text-blue"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" verificando...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10|max:11'),
	      expression: "'required|min:10|max:11'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "id": "telefone",
	      "type": "text",
	      "masked": false,
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.usuarioEditando.ds_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.usuarioEditando, "ds_telefone", $$v)
	      },
	      expression: "usuarioEditando.ds_telefone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuarioEditando.ds_email),
	      expression: "usuarioEditando.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "id": "email",
	      "data-vv-as": "E-Mail",
	      "type": "text",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "value": (_vm.usuarioEditando.ds_email)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.verificaLoginJaCadastrado()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.usuarioEditando, "ds_email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), (_vm.loading.verifica.email) ? _c('span', {
	    staticClass: "text-blue float-right"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" verificando...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('status')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "active"
	    }
	  }, [_vm._v("Situação:")]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuarioEditando.bt_ativo),
	      expression: "usuarioEditando.bt_ativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "status"
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.usuarioEditando.bt_ativo, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.usuarioEditando, "bt_ativo", 1)
	      }
	    }
	  }), _vm._v(" Ativo "), _c('i', {
	    staticClass: "fa fa-circle text-green"
	  }), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "margin-left": "15%"
	    }
	  }, [_vm._v(" ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuarioEditando.bt_ativo),
	      expression: "usuarioEditando.bt_ativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "status"
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.usuarioEditando.bt_ativo, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.usuarioEditando, "bt_ativo", 0)
	      }
	    }
	  }), _vm._v(" Inativo "), _c('i', {
	    staticClass: "fa fa-circle text-red"
	  }), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('status')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Status do Usuário é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('acesso_' + _vm.usuarioEditando.tempId)
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Acesso:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaAcessos,
	      "multiple": true,
	      "placeholder": "",
	      "track-by": "codigo",
	      "label": "descricao",
	      "preselect-first": false,
	      "close-on-select": true,
	      "max": 1,
	      "disabled": _vm.usuarioEditando.ds_cpf === null,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": 'acesso_' + _vm.usuarioEditando.tempId
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_vm._v(_vm._s(props.option.descricao))]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('strong', [_vm._v(_vm._s(props.option.descricao))])]
	      }
	    }, {
	      key: "maxElements",
	      fn: function(props) {
	        return [_vm._v("Se quiser trocar, exclua antes")]
	      }
	    }, {
	      key: "tag",
	      fn: function(props) {
	        return [_c('span', {
	          class: 'tag_acessos tag_' + _vm._.toLower(props.option.codigo)
	        }, [_c('span', [_vm._v(_vm._s(props.option.descricao))]), _vm._v(" "), _c('span', {
	          staticClass: "multiselect__tag-icon",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        })])]
	      }
	    }], null, false, 3180611249),
	    model: {
	      value: (_vm.usuarioEditando.acessos),
	      callback: function($$v) {
	        _vm.$set(_vm.usuarioEditando, "acessos", $$v)
	      },
	      expression: "usuarioEditando.acessos"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhuma acesso localizada!")])], 2), _vm._v(" "), (_vm.errors.first('acesso_' + _vm.usuarioEditando.tempId)) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve selecionar um acesso")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2 text-red"
	  }, [_vm._v("\n                      Após concluir, este usuário novo será vinculado a este projeto e outro(s) " + _vm._s(_vm.listaProjetosEntidade.length - 1) + " projeto(s) desta entidade."), _c('br'), _c('br'), _vm._v("Para o(s) outro(s) projeto(s), este usuário estará "), _c('b', [_vm._v("Sem Acesso")]), _vm._v(" até que entre no projeto específico e conceda o acesso\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(_vm.errors.items.length === 0 && _vm._.keys(_vm.usuarioEditando).length >= 7 && !_vm.loading.verifica.login && !_vm.loading.verifica.email) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm._.isNull(_vm.usuarioEditando.id) ? _vm.adicionaUsuario() : _vm.alteraUsuario()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "~click": function($event) {
	        _vm.usuarioEditando = {}
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])])]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	}]}

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('div', {
	      staticClass: "tree-collapsed",
	      staticStyle: {
	        "cursor": "pointer"
	      }
	    }, [_c('i', {
	      staticClass: "tree-branch-head fa fa-plus-square",
	      staticStyle: {
	        "margin-right": "0.2em"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.mostraFilhos(projeto)
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      class: _vm.projetoSelecionado.projectNumber === projeto.projectNumber ? 'tree-selected' : '',
	      on: {
	        "click": function($event) {
	          return _vm.selecionaPai(projeto)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(projeto.projectNumber) + " - " + _vm._s(projeto.projectName))]), _vm._v(" "), _vm._l((projeto.children), function(filho) {
	      return _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (projeto.show),
	          expression: "projeto.show"
	        }],
	        staticStyle: {
	          "cursor": "pointer"
	        }
	      }, [_c('li', {
	        class: _vm.projetoSelecionado.projectNumber === filho.projectNumber ? 'tree-selected' : '',
	        on: {
	          "click": function($event) {
	            return _vm.selecionaFilho(filho)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-file"
	      }), _vm._v("\n        " + _vm._s(filho.projectNumber) + " - " + _vm._s(filho.projectName) + "\n      ")])])
	    })], 2)
	  }), _vm._v(" "), _c('br')], 2)
	},staticRenderFns: []}

/***/ }),
/* 2014 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row collapse in",
	    staticStyle: {
	      "width": "inherit",
	      "height": "auto"
	    },
	    attrs: {
	      "aria-expanded": "true",
	      "aria-hidden": "false"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "width": "95%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarInclusao),
	      expression: "mostrarInclusao"
	    }],
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "form-horizontal box-body well well-sm"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "id": "file",
	      "name": "arquivo"
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })])]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('descricao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3"
	  }, [_vm._v("Nome do " + _vm._s(_vm.tipoDocumento) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.descricao),
	      expression: "descricao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "descricao"
	    },
	    domProps: {
	      "value": (_vm.descricao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.descricao = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.errors.first('descricao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('descricao')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancelar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("Após clicar no OK, esse " + _vm._s(_vm.tipoDocumento) + " estará público para download")])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostrarInclusao),
	      expression: "!mostrarInclusao"
	    }],
	    staticClass: "row box-header"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.mostrarInclusao = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo " + _vm._s(_vm.tipoDocumento) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-md-offset-1"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tabela.filter),
	      expression: "tabela.filter"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": 'Pesquise ' + _vm.tipoDocumento + '...'
	    },
	    domProps: {
	      "value": (_vm.tabela.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.tabela, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostrarInclusao),
	      expression: "!mostrarInclusao"
	    }],
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "how-empty": "",
	      "stacked": "md",
	      "bordered": _vm.tabela.bordered,
	      "items": _vm.tabela.items,
	      "hover": _vm.tabela.hover,
	      "fields": _vm.tabela.fields,
	      "filter": _vm.tabela.filter,
	      "current-page": _vm.tabela.currentPage,
	      "per-page": _vm.tabela.perPage,
	      "sort-by": _vm.tabela.sortBy,
	      "sort-desc": _vm.tabela.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tabela, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tabela, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tabela, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tabela, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "link",
	      fn: function(row) {
	        return [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onDownload(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.descricao))])]
	      }
	    }, {
	      key: "data",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.item.dt_data_emissao, "L")))]
	      }
	    }, (_vm.usuarioLogado.userType === 'FUNDACAO') ? {
	      key: "actions",
	      fn: function(row) {
	        return [_c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.excluirDocumento(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("Excluir")])]
	      }
	    } : null], null, true)
	  })], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Cadastro de FEP'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("FEP")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Lista',
	        href: '#'
	      }, {
	        text: 'Editais',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "disabled": !this.$root.authorize('edital-novo'),
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'relatorio-fep-aberto'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Gerar FEP Manual")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "created_at",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "updated_at",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [(!_vm._.isNull(row.item.fep)) ? _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "to": {
	              name: 'relatorio-fep-aberto',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]) : _vm._e()], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de FEP")])])
	}]}

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.somenteLeitura !== false) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.formEditavel) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona uma meta",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Meta")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {}, [_c('div', {
	    key: _vm.altera,
	    ref: "tabelaMetas",
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' ? _vm._.union(_vm.table.items, _vm._.filter(_vm.propsPropostaBackup.metas, function(m) {
	        return _vm._.includes(_vm._.get(_vm.processoSolicitacao, 'exclusao', []), m.id)
	      })) : _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "tbody-tr-class": _vm.modificacaoLinha,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "objetivos",
	      fn: function(row) {
	        return _vm._l((row.value), function(obj) {
	          return _c('div', [_c('span', [_vm._v(_vm._s(obj.ds_descricao))])])
	        })
	      }
	    }, {
	      key: "ds_descricao",
	      fn: function(row) {
	        return [_c('div', {
	          staticStyle: {
	            "display": "flex",
	            "justify-content": "space-evenly",
	            "align-items": "center"
	          }
	        }, [(('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO') ? _c('span', {
	          staticClass: "pull-left"
	        }, [(_vm.ehItemNovo(row.item)) ? _c('span', {
	          staticClass: "label label-info"
	        }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), (_vm.ehItemExcluido(row.item)) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v("Excluído")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-block"
	          }
	        }, [_c('span', [_c('strong', [_vm._v(_vm._s(row.value))])]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_descricao.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado",
	          staticStyle: {
	            "text-align": "left"
	          }
	        }, [_vm._v("\n                      " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_descricao.0')) + "\n                    ")]) : _vm._e()])])]
	      }
	    }, {
	      key: "nr_quantidade",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-block"
	          }
	        }, [_c('span', {
	          staticClass: "text-bold"
	        }, [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_quantidade.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_quantidade.0', '0')) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "ds_unidade_medida",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-block"
	          }
	        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_unidade_medida.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_unidade_medida.0', '0')) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "ds_indicadores_execucao",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-block",
	            "max-width": "380px"
	          }
	        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_indicadores_execucao.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_indicadores_execucao.0', '0')) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.ehItemExcluido(row.item)) ? _c('span', [_c('b-button', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (false),
	            expression: "false"
	          }],
	          staticClass: "btn btn-warning btn-sm btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm._.remove(_vm.processoSolicitacao.exclusao, row.item.id);
	              _vm.$forceUpdate()
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-refresh",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Reincluir")])], 1) : (_vm.somenteLeitura !== false) ? _c('span', [(_vm.formEditavel) ? _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm.formEditavel) ? _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.exclui(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")]) : _vm._e()], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('objetivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Objetivo Específico:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticStyle: {
	      "font-size": "4px"
	    },
	    attrs: {
	      "options": _vm.propsObjetivos,
	      "multiple": true,
	      "placeholder": "Selecione um ou mais objetivos",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "selectedLabel": "",
	      "name": "objetivo",
	      "value": _vm.objetivoIndex
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 579952095),
	    model: {
	      value: (_vm.objetivoIndex),
	      callback: function($$v) {
	        _vm.objetivoIndex = $$v
	      },
	      expression: "objetivoIndex"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('objetivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('O que')
	    },
	    attrs: {
	      "title": '<h5>A meta deve ser algo quantificado</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Qual a meta e quanto ela realizará? ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.ds_descricao),
	      expression: "meta.ds_descricao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "O que",
	      "type": "text",
	      "maxlength": "255",
	      "placeholder": "Descreva a meta e quanto pretende realizar com ela"
	    },
	    domProps: {
	      "value": (_vm.meta.ds_descricao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.meta, "ds_descricao", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('O que')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('O que')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "quantidade"
	    }
	  }, [_vm._v("Quanto?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.nr_quantidade),
	      expression: "meta.nr_quantidade"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "quantidade",
	      "id": "quantidade",
	      "type": "number",
	      "min": "1",
	      "max": "2147483647",
	      "step": "1",
	      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57",
	      "title": '<h5>Informe o número a que se refere a quantidade da meta acima</h5>'
	    },
	    domProps: {
	      "value": (_vm.meta.nr_quantidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.meta, "nr_quantidade", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('unidade de medida')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "unidade de medida"
	    }
	  }, [_vm._v("Unidade de medida:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.ds_unidade_medida),
	      expression: "meta.ds_unidade_medida"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "unidade de medida",
	      "id": "unidade de medida",
	      "type": "text",
	      "maxlength": "50",
	      "title": '<h5>O número ao lado é medido em qual unidade?  Exemplos:<br/>Caixas,<br/>Reais,<br/>Unidades,<br/>Metros Quadrados etc</h5>'
	    },
	    domProps: {
	      "value": (_vm.meta.ds_unidade_medida)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.meta, "ds_unidade_medida", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('unidade de medida')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('unidade de medida')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Indicadores de execução')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Indicadores de execução:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.ds_indicadores_execucao),
	      expression: "meta.ds_indicadores_execucao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Indicadores de execução"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.meta, "ds_indicadores_execucao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.listaIndicadores), function(indicador, index) {
	    return _c('option', {
	      domProps: {
	        "value": indicador
	      }
	    }, [_vm._v(_vm._s(indicador))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('Indicadores de execução')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Indicadores de execução')))]) : _vm._e()])]), _vm._v(" "), (_vm.meta.ds_indicadores_execucao === 'Outros') ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('outros')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Descrição do indicador:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta.ds_descricao_outros),
	      expression: "meta.ds_descricao_outros"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "outros",
	      "type": "text",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.meta.ds_descricao_outros)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.meta, "ds_descricao_outros", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('outros')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('outros')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2017 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile),
	      expression: "profile"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "profiles"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.profile = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.perfis), function(perfil) {
	    return _c('option', {
	      domProps: {
	        "value": perfil
	      }
	    }, [_vm._v(_vm._s(perfil.name))])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2018 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), (!_vm.entidade.notice) ? _c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ssm-lte-loading": "cmptSimpleRegisterEntityForm",
	      "ng-hide": "$ctrl.entity.status === 'PENDENTE_APROVACAO'  ||  $ctrl.entity.status === 'COMPLETO' || $ctrl.entity.status =='INCOMPLETO'"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.processos.simplifiedNumber),
	      expression: "processos.simplifiedNumber"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "id": "processo",
	      "name": "processo"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.processos, "simplifiedNumber", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.escolhido]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.processos), function(processo) {
	    return _c('option', {
	      domProps: {
	        "value": processo
	      }
	    }, [_vm._v(_vm._s(processo.simplifiedNumber))])
	  })], 2)])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "Entidade"
	    }
	  }, [(_vm.procSelecionado || ((_vm.entidade.notice) && (_vm.entidade.active === false))) ? _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.companyName),
	      expression: "entidade.companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "companyName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.entidade.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "cnpj", $$v)
	      },
	      expression: "entidade.cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpjExpeditionTime')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "cnpjExpeditionTime"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "cnpjExpeditionTime",
	    attrs: {
	      "name": "cnpjExpeditionTime",
	      "use-utc": true,
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "format": "dd/MM/yyyy",
	      "placeholder": _vm.dataPlaceholder,
	      "placeholder": "__ /__ /____"
	    },
	    model: {
	      value: (_vm.entidade.cnpjExpeditionTime),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "cnpjExpeditionTime", $$v)
	      },
	      expression: "entidade.cnpjExpeditionTime"
	    }
	  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome fantasia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-4 col-md-3",
	    attrs: {
	      "for": "Nome fantasia"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.businessName),
	      expression: "entidade.businessName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Nome fantasia",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome fantasia",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.businessName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "businessName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-7",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Telefone: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    attrs: {
	      "name": "Telefone"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.entidade.contact.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade.contact, "phone", $$v)
	      },
	      expression: "entidade.contact.phone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-7",
	    class: {
	      'has-error': _vm.errors.first('email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8",
	    attrs: {
	      "name": "email"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.email),
	      expression: "entidade.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.entidade.email)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "email", $event.target.value)
	      }, function($event) {
	        _vm.entidade.email = $event.target.value.toLowerCase()
	      }]
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.entidade.address
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.entidade.chiefs,
	      "name": "dirigentes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.entidade.documents,
	      "documentTypes": _vm.docs,
	      "documentosObrigatorios": _vm.docs
	    }
	  })], 1)])])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "Proposta"
	    }
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('nome da proposta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "nome da proposta"
	    }
	  }, [_vm._v("Nome do Projeto:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.name),
	      expression: "propostaSimplificada.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome da proposta",
	      "id": "nome da proposta",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome da proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da proposta')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('investimento previsto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "investimento previsto"
	    }
	  }, [_vm._v("Investimento Previsto:")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "investimento previsto",
	      "approval": "propSimpleCtrl.approval",
	      "state": "propSimpleCtrl.approvalState"
	    }
	  }, [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "investimento previsto",
	      "id": "investimento previsto",
	      "maxlength": "20",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.propostaSimplificada.investment),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "investment", $$v)
	      },
	      expression: "propostaSimplificada.investment"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('investimento previsto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('investimento previsto')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Agência condutora do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Agência")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('agencia')
	    },
	    attrs: {
	      "uib-tooltip": "Prefixo da Agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "agencia"
	    }
	  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticStyle: {
	      "font-size": "4px"
	    },
	    attrs: {
	      "options": _vm.agencias,
	      "custom-label": _vm.numeroNomeAgencia,
	      "placeholder": "Selecione uma agência",
	      "label": "type",
	      "track-by": "type",
	      "preselect-first": false,
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "selectedLabel": "",
	      "name": "agencia",
	      "value": _vm.valor
	    },
	    on: {
	      "search-change": _vm.buscaAgencias
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.buscaAgencia(_vm.agenciaSelecionada.code)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.agenciaSelecionada),
	      callback: function($$v) {
	        _vm.agenciaSelecionada = $$v
	      },
	      expression: "agenciaSelecionada"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ agência')
	    },
	    attrs: {
	      "uib-tooltip": "CNPJ da Agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "CNPJ agência"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255|cnpj'),
	      expression: "'required|max:255|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ agência",
	      "id": "CNPJ agência",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.propostaSimplificada.agencyCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "agencyCNPJ", $$v)
	      },
	      expression: "propostaSimplificada.agencyCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('endereço da agência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "endereço da agência"
	    }
	  }, [_vm._v("Endereço da agência:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.agencyAddress),
	      expression: "propostaSimplificada.agencyAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "endereço da agência",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.agencyAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "agencyAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('endereço da agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço da agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('telefone agência')
	    },
	    attrs: {
	      "uib-tooltip": "Telefone da agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "telefone agência"
	    }
	  }, [_vm._v("Telefone da agência:")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "telefone agência",
	      "id": "telefone agência",
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "type": "text",
	      "maxlength": "255"
	    },
	    model: {
	      value: (_vm.propostaSimplificada.agencyPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "agencyPhone", $$v)
	      },
	      expression: "propostaSimplificada.agencyPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('telefone agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('email agência')
	    },
	    attrs: {
	      "uib-tooltip": "E-mail da agência"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "email agência"
	    }
	  }, [_vm._v("E-mail da agência:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.agencyEmail),
	      expression: "propostaSimplificada.agencyEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255|email'),
	      expression: "'required|max:255|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email agência",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.agencyEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "agencyEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email agência')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Gerente")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('nome gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Nome do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "nome gerente"
	    }
	  }, [_vm._v("Nome do Gerente:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerName),
	      expression: "propostaSimplificada.managerName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome gerente",
	      "id": "nome gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('nacionalidade do gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Nacionalidade do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "nacionalidade do gerente"
	    }
	  }, [_vm._v("Nacionalidade:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerNationality),
	      expression: "propostaSimplificada.managerNationality"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nacionalidade do gerente",
	      "id": "nacionalidade do gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerNationality)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerNationality", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nacionalidade do gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nacionalidade do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('profissão do gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Profissão do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "profissão do gerente"
	    }
	  }, [_vm._v("Profissão:")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.managerOccupation",
	      "approval": "propSimpleCtrl.approval",
	      "state": "propSimpleCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerOccupation),
	      expression: "propostaSimplificada.managerOccupation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "profissão do gerente",
	      "id": "profissão do gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerOccupation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerOccupation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('profissão do gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('profissão do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('uf gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "uf gerente"
	    }
	  }, [_vm._v(" UF: ")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerUf),
	      expression: "propostaSimplificada.managerUf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "uf gerente",
	      "id": "uf gerente"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propostaSimplificada, "managerUf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.propostaSimplificada.managerUf,
	      "selected": _vm.propostaSimplificada.managerUf
	    }
	  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerUf))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('uf gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('uf gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('cidade do gerente')
	    },
	    attrs: {
	      "uib-tooltip": "Cidade do Gerente"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "cidade do gerente"
	    }
	  }, [_vm._v("Cidade:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerCity),
	      expression: "propostaSimplificada.managerCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cidade do gerente",
	      "id": "cidade do gerente",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('cidade do gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cidade do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('estado civil gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "estado civil gerente"
	    }
	  }, [_vm._v("Estado Civil:")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerCivilStatus),
	      expression: "propostaSimplificada.managerCivilStatus"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "estado civil gerente",
	      "id": "estado civil gerente"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propostaSimplificada, "managerCivilStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.propostaSimplificada.managerCivilStatus,
	      "selected": _vm.propostaSimplificada.managerCivilStatus
	    }
	  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerCivilStatus))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOLTEIRO"
	    }
	  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CASADO"
	    }
	  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DIVORCIADO"
	    }
	  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "VIUVO"
	    }
	  }, [_vm._v("Viúvo(a)")])])]), _vm._v(" "), (_vm.errors.first('estado civil gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('estado civil gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CPF gerente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "managerCpf"
	    }
	  }, [_vm._v(" CPF: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:11|cpf'),
	      expression: "'required|max:11|cpf'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CPF gerente",
	      "id": "CPF gerente",
	      "mask": ['###.###.###-##']
	    },
	    model: {
	      value: (_vm.propostaSimplificada.managerCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "managerCpf", $$v)
	      },
	      expression: "propostaSimplificada.managerCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CPF gerente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF gerente')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('número rg')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "número rg"
	    }
	  }, [_vm._v(" Número do RG: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerRg),
	      expression: "propostaSimplificada.managerRg"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "número rg",
	      "id": "número rg",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerRg)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerRg", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('número rg')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número rg')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('orgão emissor')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "orgão emissor"
	    }
	  }, [_vm._v(" Orgão Emissor: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerRgIssuer),
	      expression: "propostaSimplificada.managerRgIssuer"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "orgão emissor",
	      "id": "orgão emissor",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.managerRgIssuer)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "managerRgIssuer", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('orgão emissor')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('orgão emissor')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('uf RG')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "uf RG"
	    }
	  }, [_vm._v(" UF: ")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.managerRgUF),
	      expression: "propostaSimplificada.managerRgUF"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "uf RG",
	      "id": "uf RG"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propostaSimplificada, "managerRgUF", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.propostaSimplificada.managerRgUF,
	      "selected": _vm.propostaSimplificada.managerRgUF
	    }
	  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerRgUF))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('uf RG')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('uf RG')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Funcionário agência")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('matrícula do funcionário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "matrícula do funcionário"
	    }
	  }, [_vm._v(" Matrícula do funcionário: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|length:7'),
	      expression: "'required|length:7'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "matrícula do funcionário",
	      "placeholder": "Insira a matricula. Somente números e sem dígito.",
	      "mask": '#######'
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.selectFuncionario(_vm.propostaSimplificada.employeeRegistration)
	      }
	    },
	    model: {
	      value: (_vm.propostaSimplificada.employeeRegistration),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "employeeRegistration", $$v)
	      },
	      expression: "propostaSimplificada.employeeRegistration"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('matrícula do funcionário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('matrícula do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('funcionário responsável')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "funcionário responsável"
	    }
	  }, [_vm._v(" Funcionário responsável pelo projeto: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.employeeName),
	      expression: "propostaSimplificada.employeeName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "funcionário responsável",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.employeeName)
	    },
	    on: {
	      "keydown": function($event) {
	        return _vm.selectFuncionario()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "employeeName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('funcionário responsável')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('funcionário responsável')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('telefone do funcionário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "telefone do funcionário"
	    }
	  }, [_vm._v(" Telefone fixo: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "name": "telefone do funcionário",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.propostaSimplificada.employeePhone),
	      callback: function($$v) {
	        _vm.$set(_vm.propostaSimplificada, "employeePhone", $$v)
	      },
	      expression: "propostaSimplificada.employeePhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('telefone do funcionário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('e-mail funcionário')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "e-mail funcionário"
	    }
	  }, [_vm._v(" E-mail do funcionário: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.employeeEmail),
	      expression: "propostaSimplificada.employeeEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255|email'),
	      expression: "'required|max:255|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "employeeEmail",
	      "id": "e-mail funcionário",
	      "type": "email"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.employeeEmail)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "employeeEmail", $event.target.value)
	      }, function($event) {
	        _vm.propostaSimplificada.employeeEmail = $event.target.value.toLowerCase()
	      }]
	    }
	  })]), _vm._v(" "), (_vm.errors.first('e-mail funcionário')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('e-mail funcionário')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Informações")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('locais de execução do projeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "locais de execução do projeto"
	    }
	  }, [_vm._v(" Locais de execução do projeto: ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.executePlaces),
	      expression: "propostaSimplificada.executePlaces"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "locais de execução do projeto",
	      "id": "locais de execução do projeto",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.executePlaces)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "executePlaces", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('locais de execução do projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('locais de execução do projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('objetivo geral')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "objetivo geral"
	    }
	  }, [_vm._v(" Objetivo Geral: ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.generalObjective),
	      expression: "propostaSimplificada.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "objetivo geral",
	      "id": "objetivo geral",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "generalObjective", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('objetivo geral')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo geral')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('objetivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "infoObjectives"
	    }
	  }, [_vm._v(" Objetivo: ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.infoObjectives),
	      expression: "propostaSimplificada.infoObjectives"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "name": "objetivo",
	      "id": "objetivo",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.infoObjectives)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "infoObjectives", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('objetivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('resumo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "resumo"
	    }
	  }, [_vm._v(" Resumo: ")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.summary),
	      expression: "propostaSimplificada.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "resumo",
	      "id": "resumo",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "summary", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('resumo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resumo')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Número de Participantes")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group required col-md-12",
	    class: {
	      'has-error': _vm.errors.first('participantes diretos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "participantes diretos"
	    }
	  }, [_vm._v(" Participantes diretos: ")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propostaSimplificada.participants),
	      expression: "propostaSimplificada.participants"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "participantes diretos",
	      "id": "participantes diretos",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.propostaSimplificada.participants)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propostaSimplificada, "participants", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_vm._m(7), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": _vm.propostaSimplificada.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.propostaSimplificada.audiences = $event
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_vm._m(8), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.propostaSimplificada.documents,
	      "documentTypes": _vm.documentosProp,
	      "documentosObrigatorios": _vm.documentosObrigatoriosProp
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_vm._m(9), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.propostaSimplificada.documentStatements,
	      "documentTypes": _vm.adimplencia,
	      "documentosObrigatorios": _vm.adimplenciaObrig
	    }
	  })], 1)])])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.conclui()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Processo: ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills"
	  }, [_c('li', [_c('a', {
	    staticClass: "btn btn-flat active",
	    attrs: {
	      "id": "tabEntidade",
	      "href": "#Entidade",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v(" Entidade ")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "btn btn-flat",
	    attrs: {
	      "href": "#Proposta",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v(" Proposta ")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Entidade: Simplificado")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Proposta Simplificada")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('br')])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])])])
	}]}

/***/ }),
/* 2019 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('app-header'), _vm._v(" "), _c('app-sidebar'), _vm._v(" "), _c('router-view', {
	    key: _vm.$route.fullPath
	  }), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('control-sidebar')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": "SGP - Rating da Entidade"
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Rating da Entidade:\n\n      "), (_vm.rating.classificacao) ? _c('span', [_vm._v(_vm._s(_vm.rating.classificacao.nota) + " ")]) : _vm._e(), _vm._v(" "), (_vm.calculando) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  })]) : _c('span', [(!_vm.somenteLeitura && !_vm.temDataErrada) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarRating($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.closewindow($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Sair do relatório ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tudoPreenchido > 0) ? _c('span', {
	    staticClass: "alertaCamposPendentes"
	  }, [_vm._v("Ainda falta preencher "), _c('b', [_vm._v(_vm._s(_vm.tudoPreenchido))]), _vm._v(" campos de Certidões ou Cadin")]) : _vm._e(), _vm._v(" "), (_vm.temDataErrada) ? _c('span', {
	    staticClass: "alertaCamposPendentes"
	  }, [(_vm.tudoPreenchido > 0) ? _c('br') : _vm._e(), _vm._v("Tem data errada! Favor verifique-as.")]) : _vm._e(), _vm._v(" "), (_vm.pendenciasCadastro.total > 0) ? _c('span', {
	    staticClass: "alertaCamposPendentes atualizavel",
	    on: {
	      "click": function($event) {
	        return _vm.$modal.show('avisoCadastro')
	      }
	    }
	  }, [(_vm.tudoPreenchido > 0 || _vm.temDataErrada) ? _c('br') : _vm._e(), _c('i', {
	    staticClass: "fa fa-exclamation-triangle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da entidade incompleto: "), _c('b', [_vm._v(_vm._s(_vm.pendenciasCadastro.total))]), _vm._v(" " + _vm._s(_vm.pendenciasCadastro.total === 1 ? 'item' : 'itens') + ". Clique para ver.")]) : _vm._e()], 1)]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Validação',
	        href: '/'
	      }, {
	        text: 'Propostas',
	        href: '#'
	      }, {
	        text: 'Rating da Entidade',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "rating"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.calculando),
	      expression: "calculando"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table m0"
	  }, [_c('tr', [_c('td', {
	    staticClass: "etiquetas w10"
	  }, [_vm._v("Convenente:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores",
	    attrs: {
	      "colspan": "7"
	    }
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.dadosGerais.entidade.ds_nome))])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Código:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.dadosGerais.entidade.nr_codigo_forn_erp))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.dadosGerais.entidade.ds_cnpj)))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Data de abertura:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dadosGerais.entidade.dt_data_expedicao_cnpj, "L")))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Tempo de abertura:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dadosGerais.entidade.dt_data_expedicao_cnpj, "from", "now")))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Dirigentes:")]), _vm._v(" "), (_vm.rating.dirigentes) ? _c('table', {
	    staticClass: "table table-bordered text-center nao_imprimir m0"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.rating.dirigentes), function(dirigente) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(dirigente.ds_nome) + "    "), _c('span', {
	      staticStyle: {
	        "color": "cornflowerblue"
	      }
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dirigente.ds_cpf))]), _vm._v(" "), _c('td', [_c('money', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "onchange": _vm.totalSerasaDirigentes,
	        "disabled": _vm.somenteLeitura,
	        "name": "serasa_dirigente",
	        "type": "text"
	      },
	      model: {
	        value: (dirigente.serasa),
	        callback: function($$v) {
	          _vm.$set(dirigente, "serasa", $$v)
	        },
	        expression: "dirigente.serasa"
	      }
	    })], 1), _vm._v(" "), _c('td', [_c('money', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "form-control text-right",
	      attrs: {
	        "onchange": _vm.totalSCPCDirigentes,
	        "disabled": _vm.somenteLeitura,
	        "name": "scpc_dirigente",
	        "type": "text"
	      },
	      model: {
	        value: (dirigente.scpc),
	        callback: function($$v) {
	          _vm.$set(dirigente, "scpc", $$v)
	        },
	        expression: "dirigente.scpc"
	      }
	    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))]), _vm._v(" "), _c('td', [_c('i', {
	      class: ['fa fa-circle ', dirigente.bt_ativo ? 'text-green' : 'text-red'],
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.rating.dirigentes) ? _c('table', {
	    staticClass: "table table-bordered text-center imprimir"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.rating.dirigentes), function(dirigente) {
	    return _c('tr', [_c('td', [_c('span', {
	      staticClass: "fl"
	    }, [_vm._v("\n                      " + _vm._s(dirigente.ds_nome) + "  \n                      "), _c('span', {
	      staticStyle: {
	        "color": "cornflowerblue"
	      }
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))])]), _vm._v(" "), _c('span', {
	      staticClass: "fr"
	    }, [_vm._v("CPF: " + _vm._s(dirigente.ds_cpf))])]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")) + " à " + _vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")) + "\n                  ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("real")(dirigente.serasa)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("real")(dirigente.scpc)))])])])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.rating.consultas) ? _c('table', {
	    staticClass: "tabela_consultas"
	  }, [_vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w20"
	  }, [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "serasa_entidade",
	      "type": "text",
	      "disabled": _vm.somenteLeitura
	    },
	    model: {
	      value: (_vm.rating.consultas.serasa.entidade),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.serasa, "entidade", $$v)
	      },
	      expression: "rating.consultas.serasa.entidade"
	    }
	  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td', {
	    staticClass: "valores w30"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        placement: 'left'
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
	    }],
	    staticClass: "data w40",
	    attrs: {
	      "title": '<h5>Informe a Data da Consulta do Cepim</h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.dataCepim),
	      expression: "rating.consultas.certidoes.dataCepim"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast'),
	      expression: "'required|validdate|dateeqpast'"
	    }],
	    ref: "Cepim",
	    staticClass: "form-control",
	    attrs: {
	      "id": "Cepim",
	      "type": "text",
	      "name": "Cepim",
	      "disabled": _vm.somenteLeitura,
	      "data-vv-as": "Cepim",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.certidoes.dataCepim)
	    },
	    on: {
	      "blur": _vm.verificaData,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.certidoes, "dataCepim", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Cepim')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cepim')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "textoLigacao w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "listaSituacao w50"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.Cepim),
	      expression: "rating.consultas.certidoes.Cepim"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.somenteLeitura
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.rating.consultas.certidoes, "Cepim", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.calcularRating]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Com Restrição")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Nada Consta")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('money', {
	    staticClass: "form-control text-right",
	    attrs: {
	      "disabled": true,
	      "name": "serasa_dirigentes",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.rating.consultas.serasa.dirigentes),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.serasa, "dirigentes", $$v)
	      },
	      expression: "rating.consultas.serasa.dirigentes"
	    }
	  })], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        placement: 'left'
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
	    }],
	    staticClass: "data w40",
	    attrs: {
	      "title": '<h5>Informe a Data de Validade da PGFN</h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.dataCND),
	      expression: "rating.consultas.certidoes.dataCND"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate'),
	      expression: "'required|validdate'"
	    }],
	    ref: "CND",
	    staticClass: "form-control",
	    attrs: {
	      "id": "CND",
	      "type": "text",
	      "name": "CND",
	      "disabled": _vm.somenteLeitura,
	      "data-vv-as": "CND",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.certidoes.dataCND)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.certidoes, "dataCND", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('CND')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CND')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "textoLigacao w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "listaSituacao w50"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.CND),
	      expression: "rating.consultas.certidoes.CND"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.somenteLeitura
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.rating.consultas.certidoes, "CND", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.calcularRating]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Vencida")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Vigente")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "serasa_coobrigacao",
	      "type": "text",
	      "disabled": _vm.somenteLeitura
	    },
	    model: {
	      value: (_vm.rating.consultas.serasa.coobrigacao),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.serasa, "coobrigacao", $$v)
	      },
	      expression: "rating.consultas.serasa.coobrigacao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SERASA de dirigentes coobrigação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SERASA de dirigentes coobrigação')))]) : _vm._e()]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        placement: 'left'
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
	    }],
	    staticClass: "data w40",
	    attrs: {
	      "title": '<h5>Informe a data de Validade da CRF</h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.dataCRF),
	      expression: "rating.consultas.certidoes.dataCRF"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate'),
	      expression: "'required|validdate'"
	    }],
	    ref: "CRF",
	    staticClass: "form-control",
	    attrs: {
	      "id": "CRF",
	      "type": "text",
	      "name": "CRF",
	      "disabled": _vm.somenteLeitura,
	      "data-vv-as": "CRF",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.certidoes.dataCRF)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.certidoes, "dataCRF", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('CRF')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CRF')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "textoLigacao w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "listaSituacao w50"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.CRF),
	      expression: "rating.consultas.certidoes.CRF"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.somenteLeitura
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.rating.consultas.certidoes, "CRF", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.calcularRating]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Vencida")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Vigente")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        placement: 'left'
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
	    }],
	    staticClass: "data w40",
	    attrs: {
	      "title": '<h5>Informe a data de Validade da CNDT</h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.dataCNDT),
	      expression: "rating.consultas.certidoes.dataCNDT"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate'),
	      expression: "'required|validdate'"
	    }],
	    ref: "CNDT",
	    staticClass: "form-control",
	    attrs: {
	      "id": "CNDT",
	      "type": "text",
	      "name": "CNDT",
	      "disabled": _vm.somenteLeitura,
	      "data-vv-as": "CNDT",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.certidoes.dataCNDT)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.certidoes, "dataCNDT", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNDT')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNDT')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "textoLigacao w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "listaSituacao w50"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.certidoes.CNDT),
	      expression: "rating.consultas.certidoes.CNDT"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.somenteLeitura
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.rating.consultas.certidoes, "CNDT", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.calcularRating]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Vencida")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Vigente")])])])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "scpc_entidade",
	      "type": "text",
	      "disabled": _vm.somenteLeitura
	    },
	    model: {
	      value: (_vm.rating.consultas.scpc.entidade),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.scpc, "entidade", $$v)
	      },
	      expression: "rating.consultas.scpc.entidade"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SCPC da entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC da entidade')))]) : _vm._e()]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        placement: 'left'
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
	    }],
	    staticClass: "data w40",
	    attrs: {
	      "title": '<h5>Informe a Data da Consulta do CADIN da Entidade</h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.cadin.dataEntidade),
	      expression: "rating.consultas.cadin.dataEntidade"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast'),
	      expression: "'required|validdate|dateeqpast'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cadin_entidade",
	      "type": "text",
	      "name": "cadin_entidade",
	      "disabled": _vm.somenteLeitura,
	      "data-vv-as": "cadin_entidade",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.cadin.dataEntidade)
	    },
	    on: {
	      "blur": _vm.verificaData,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.cadin, "dataEntidade", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cadin_entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin_entidade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "textoLigacao w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "listaSituacao w50"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.cadin.entidade),
	      expression: "rating.consultas.cadin.entidade"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.somenteLeitura
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.rating.consultas.cadin, "entidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.calcularRating]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Com Restrição")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Nada Consta")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "disabled": true,
	      "name": "scpc_dirigentes",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.rating.consultas.scpc.dirigentes),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.scpc, "dirigentes", $$v)
	      },
	      expression: "rating.consultas.scpc.dirigentes"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SCPC de dirigentes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC de dirigentes')))]) : _vm._e()]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        placement: 'left'
	      }),
	      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
	    }],
	    staticClass: "data w40",
	    attrs: {
	      "title": '<h5>Informe a data da Consulta do CADIN dos Dirigentes</h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.cadin.dataDirigentes),
	      expression: "rating.consultas.cadin.dataDirigentes"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast'),
	      expression: "'required|validdate|dateeqpast'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cadin_dirigentes",
	      "type": "text",
	      "name": "cadin_dirigentes",
	      "disabled": _vm.somenteLeitura,
	      "data-vv-as": "cadin_dirigentes",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.cadin.dataDirigentes)
	    },
	    on: {
	      "blur": _vm.verificaData,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.cadin, "dataDirigentes", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cadin_dirigentes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin_dirigentes')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "textoLigacao w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "listaSituacao w50"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.cadin.dirigentes),
	      expression: "rating.consultas.cadin.dirigentes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.somenteLeitura
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.rating.consultas.cadin, "dirigentes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.calcularRating]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Com Restrição")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Nada Consta")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "scpc_coobrigacao",
	      "type": "text",
	      "disabled": _vm.somenteLeitura
	    },
	    model: {
	      value: (_vm.rating.consultas.scpc.coobrigacao),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas.scpc, "coobrigacao", $$v)
	      },
	      expression: "rating.consultas.scpc.coobrigacao"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('SCPC de dirigentes coobrigação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC de dirigentes coobrigação')))]) : _vm._e()]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('td', {
	    staticClass: "valores"
	  }, [(_vm.rating.consultas.cadin.dataCoobrigacao !== 0) ? _c('div', {
	    staticClass: "data w40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.cadin.dataCoobrigacao),
	      expression: "rating.consultas.cadin.dataCoobrigacao"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast'),
	      expression: "'required|validdate|dateeqpast'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cadin_dirigentes_coobrigacao",
	      "type": "text",
	      "name": "cadin_dirigentes_coobrigacao",
	      "disabled": _vm.somenteLeitura,
	      "data-vv-as": "cadin_dirigentes_coobrigacao",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.cadin.dataCoobrigacao)
	    },
	    on: {
	      "blur": _vm.verificaData,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas.cadin, "dataCoobrigacao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cadin_dirigentes_coobrigacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin_dirigentes_coobrigacao')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "textoLigacao w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "listaSituacao w50"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.cadin.coobrigacao),
	      expression: "rating.consultas.cadin.coobrigacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.somenteLeitura
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.rating.consultas.cadin, "coobrigacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.calcularRating]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Com Restrição")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Nada Consta")])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.rating.consultas) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "tabela_consultas"
	  }, [_c('tr', [_c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Total Geral:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w20"
	  }, [_c('money', {
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "total_scpc_serasa",
	      "type": "text",
	      "disabled": true
	    },
	    model: {
	      value: (_vm.rating.consultas.totalGeral),
	      callback: function($$v) {
	        _vm.$set(_vm.rating.consultas, "totalGeral", $$v)
	      },
	      expression: "rating.consultas.totalGeral"
	    }
	  })], 1), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w50"
	  }, [_vm._v("Quantidade de Pessoas Politicamente Expostas (PEP):")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating.consultas.PEP),
	      expression: "rating.consultas.PEP"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "pep",
	      "type": "text",
	      "name": "pep",
	      "disabled": _vm.somenteLeitura
	    },
	    domProps: {
	      "value": (_vm.rating.consultas.PEP)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.rating.consultas, "PEP", $event.target.value)
	      }
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "tabela_consultas"
	  }, [_c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Investimento Social (ISD, últimos 3 anos):")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w20"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado",
	    attrs: {
	      "title": '<h5>Refere-se a soma dos valores contratados e suplementados no projeto</h5>'
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.rating.experiencia.investimentoAte3Anos)) + "\n                    ")])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w20"
	  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Participantes Diretos (ISD, últimos 3 anos):")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w20"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado",
	    attrs: {
	      "title": '<h5>Refere-se a quantidade total de participantes dos projetos contratados</h5>'
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.rating.experiencia.participantesAte3Anos) + "\n                    ")])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w20"
	  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Nº Projetos com a FBB:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w20"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado",
	    attrs: {
	      "title": '<h5>Refere-se a quantidade total de participantes dos projetos contratados</h5>'
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.rating.experiencia.qtdeProjeto) + "\n                    ")])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w20"
	  }, [_vm._v(" ")])])])]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "tabela_consultas"
	  }, [_c('tr', [_c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Projetos em Execução, ETO, SPS:")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Projetos Encerrados (3 anos):")])]), _vm._v(" "), _c('tr', [_c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Ocorr. Peso 2:")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "valores w10"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo2)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": _vm.entidadeOcorrenciaTipo2
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo2.length))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Qtd Executando:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.qtde))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Qtd Executado:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.qtde))])])]), _vm._v(" "), _c('tr', [_c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "valores w10"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo3)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": _vm.entidadeOcorrenciaTipo3
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo3.length))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Ocorr. Peso 2:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo2)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": _vm.projetosExecutandoOcorrenciaTipo2
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo2.length))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosEncerrados.tipo3)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": _vm.projetosEncerradosOcorrenciaTipo3
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.tipo3.length))])])]), _vm._v(" "), _c('tr', [_c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "valores w10"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo4)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": _vm.entidadeOcorrenciaTipo4
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo4.length))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo3)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": _vm.projetosExecutandoOcorrenciaTipo3
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo3.length))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosEncerrados.tipo4)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": _vm.projetosEncerradosOcorrenciaTipo4
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.tipo4.length))])])]), _vm._v(" "), _c('tr', [_c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "etiquetas w20"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "valores w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo4)) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    staticClass: "dado atualizavel",
	    attrs: {
	      "title": '<h5>Atualizar consulta</h5>'
	    },
	    on: {
	      "click": _vm.projetosExecutandoOcorrenciaTipo4
	    }
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo4.length))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Qtd Peso 3:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.qtdeTipo3))])])]), _vm._v(" "), _c('tr', [_c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "etiquetas w20"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "valores w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("Qtd Peso 3:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.qtdeTipo3))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("% com Peso 3:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.rating.ocorrencias.projetosEncerrados.percTipo3)))])])]), _vm._v(" "), _c('tr', [_c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "etiquetas w20"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "valores w10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v("% com Peso 3:")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10"
	  }, [_c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.rating.ocorrencias.projetosExecutando.percTipo3)))])]), _vm._v(" "), _c('td', {
	    staticClass: "etiquetas w20"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	    staticClass: "valores w10 w10"
	  }, [_vm._v(" ")])])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('tr', [_c('td', [_c('table', {
	    staticClass: "table table-condensed ratingCalculos"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Representa a situação da entidade e de seus dirigentes com relação a prestação de contas e ao cumprimento de seus compromisssos</h5>'
	    }
	  }, [_vm._v("CD")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Reflete de maneira indireta as condições economico-financeiras da entidade</h5>'
	    }
	  }, [_vm._v("RFP")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Sinaliza a capacidade de articulação da entidade considerando que quanto maior o investimento da FBB maior interesse , disposição e compentência em apresentar propostas</h5>'
	    }
	  }, [_vm._v("IS")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Evidencia o aspecto social da atuação da entidade por meio da quantidade de participantes diretos atendidos</h5>'
	    }
	  }, [_vm._v("PD")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Reflete a experiência da entidade com base em seu tempo de constituição</h5>'
	    }
	  }, [_vm._v("HIS 1")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Experiência em projetos e o modus operandi da Fundação</h5>'
	    }
	  }, [_vm._v("HIS 2")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Ocorrências registradas para projetos em execução</h5>'
	    }
	  }, [_vm._v("OC 1")]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
	    }],
	    attrs: {
	      "title": '<h5>Ocorrências registradas para projetos encerrado</h5>'
	    }
	  }, [_vm._v("OC 2")])])]), _vm._v(" "), _c('tr', {
	    staticClass: "dado"
	  }, [_c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.CD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.RFP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.IS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.PD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC3))])]), _vm._v(" "), _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "9"
	    }
	  }, [_c('span', {
	    staticClass: "formula"
	  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.formula) + " = ")]), _c('span', {
	    staticClass: "dado"
	  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.total))])])])])]), _vm._v(" "), _c('td', {
	    staticClass: "ratingNota"
	  }, [_vm._v("Rating Entidade"), _c('br'), _c('span', {
	    class: 'dado rating' + _vm.rating.classificacao.nota
	  }, [_vm._v(_vm._s(_vm.rating.classificacao.nota))])])])])])])])]), _vm._v(" "), _c('modal', {
	    staticClass: "topo modal-wrapper nao_imprimir",
	    attrs: {
	      "name": "avisoCadastro",
	      "width": "60%",
	      "height": "auto",
	      "scrollable": true
	    }
	  }, [_c('div', {
	    staticClass: "box-header with-border cabecalhoAviso"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da entidade incompleto\n          ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('b-button', {
	    staticClass: "btn btn-warning btn-sm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$modal.hide('avisoCadastro')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Fechar")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "avisoCadastro"
	    }
	  }, [_c('p', [_vm._v("\n            O rating foi calculado com as informações disponíveis. Os itens abaixo estão\n            faltando no cadastro da entidade e devem ser completados para que a nota seja confiável.\n          ")]), _vm._v(" "), (_vm.pendenciasCadastro.obrigatorias.length > 0) ? _c('div', [_c('div', {
	    staticClass: "secao"
	  }, [_vm._v("Obrigatórios — afetam a nota:")]), _vm._v(" "), _c('ul', {
	    staticClass: "listaPendencias"
	  }, _vm._l((_vm.pendenciasCadastro.obrigatorias), function(pendencia) {
	    return _c('li', [_c('b', [_vm._v(_vm._s(pendencia.titulo))]), _vm._v(" — " + _vm._s(pendencia.efeito) + "\n              ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.pendenciasCadastro.opcionais.length > 0) ? _c('div', [_c('div', {
	    staticClass: "secao"
	  }, [_vm._v("Não obrigatórios — não alteram a nota:")]), _vm._v(" "), _c('ul', {
	    staticClass: "listaPendencias"
	  }, _vm._l((_vm.pendenciasCadastro.opcionais), function(pendencia) {
	    return _c('li', [_c('b', [_vm._v(_vm._s(pendencia.titulo))]), _vm._v(" — " + _vm._s(pendencia.efeito) + "\n              ")])
	  }), 0)]) : _vm._e()])])], 1)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "imprimir"
	  }, [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "tituloRating"
	  }, [_vm._v("Rating da Entidade")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "secao"
	  }, [_vm._v("Dados da entidade:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "25%"
	    }
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
	    staticClass: "requerido",
	    staticStyle: {
	      "width": "14%"
	    }
	  }, [_vm._v("SERASA")]), _vm._v(" "), _c('th', {
	    staticClass: "requerido",
	    staticStyle: {
	      "width": "14%"
	    }
	  }, [_vm._v("SCPC")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Início do Mandato")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Vigência do Mandato")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "3%"
	    }
	  }, [_vm._v("Ativo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "w50 p0"
	  }, [_vm._v("Dirigente")]), _vm._v(" "), _c('th', {
	    staticClass: "w20 p0"
	  }, [_vm._v("Mandato")]), _vm._v(" "), _c('th', {
	    staticClass: "w10 p0"
	  }, [_vm._v("SERASA")]), _vm._v(" "), _c('th', {
	    staticClass: "w10 p0"
	  }, [_vm._v("SCPC")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "secao"
	  }, [_vm._v("Consultas cadastrais e regularidade fiscal e previdenciária:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "cabecalho b",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("SERASA:")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho b",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("CEPIM e Certidões:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "etiquetas w30"
	  }, [_vm._v("Cepim"), _c('span', {
	    staticClass: "dataConsulta"
	  }), _vm._v(":")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("PGFN"), _c('span', {
	    staticClass: "dataValidade"
	  }), _vm._v(":")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("CRF"), _c('span', {
	    staticClass: "dataValidade"
	  }), _vm._v(":")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("CNDT"), _c('span', {
	    staticClass: "dataValidade"
	  }), _vm._v(":")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    staticClass: "cabecalho b",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("SCPC:")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho b",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("CADIN:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Entidade"), _c('span', {
	    staticClass: "dataConsulta"
	  }), _vm._v(":")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Dirigentes"), _c('span', {
	    staticClass: "dataConsulta"
	  }), _vm._v(":")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "etiquetas"
	  }, [_vm._v("Dirigentes Coobrigação"), _c('span', {
	    staticClass: "dataConsulta"
	  }), _vm._v(":")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "secao"
	  }, [_vm._v("Experiência com a FBB:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "secao"
	  }, [_vm._v("Ocorrências:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "secao"
	  }, [_vm._v("Rating:")])])
	}]}

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "cmptDocPreparationForm",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-2 required-field",
	    class: {
	      'has-error': _vm.errors.first('data de proposta')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data da Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data de proposta",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.analise.proposal.dataProposta),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.proposal, "dataProposta", $$v)
	      },
	      expression: "analise.proposal.dataProposta"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data de proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data de proposta')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-2 required-field",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    },
	    attrs: {
	      "ng-class": "{'has-error': cmptProFormalizatinForm.$submitted && cmptProFormalizatinForm.analysisDate.$error.required }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de análise")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data da análise",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.analise.proposal.analysisDate),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.proposal, "analysisDate", $$v)
	      },
	      expression: "analise.proposal.analysisDate"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data da análise')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data da análise')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-2 required-field",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    },
	    attrs: {
	      "ng-class": "{'has-error': cmptProFormalizatinForm.$submitted && cmptProFormalizatinForm.grantDate.$error.required }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de deferimento")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data de deferimento",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.analise.proposal.grantDate),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.proposal, "grantDate", $$v)
	      },
	      expression: "analise.proposal.grantDate"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('introducao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('introducao')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-2",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de assinatura do convênio")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    attrs: {
	      "name": "data de assinatura",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.analise.proposal.agreementAssignmentDate),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.proposal, "agreementAssignmentDate", $$v)
	      },
	      expression: "analise.proposal.agreementAssignmentDate"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-2",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de Vigência do Projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    attrs: {
	      "name": "data de emissao",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.analise.proposal.validityDate),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.proposal, "validityDate", $$v)
	      },
	      expression: "analise.proposal.validityDate"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.analise.documentDraft,
	      "documentTypes": _vm.requiredFormalizationDocumentsType,
	      "documentosObrigatorios": _vm.documentosObrigatorios,
	      "disable": true
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('actionApproval')
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.approval.projectFormalizationResult),
	      expression: "approval.projectFormalizationResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "actionApproval",
	      "value": "APPROVED"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.approval.projectFormalizationResult, "APPROVED")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.approval, "projectFormalizationResult", "APPROVED")
	      }
	    }
	  }), _vm._v("\n                      Aprovar o projeto\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.approval.projectFormalizationResult),
	      expression: "approval.projectFormalizationResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "actionApproval",
	      "value": "DEVOLVIDO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.approval.projectFormalizationResult, "DEVOLVIDO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.approval, "projectFormalizationResult", "DEVOLVIDO")
	      }
	    }
	  }), _vm._v("\n                      Devolver para Formalização\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.approval.projectFormalizationResult),
	      expression: "approval.projectFormalizationResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "actionApproval",
	      "value": "REJECTED",
	      "id": "msgDef"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.approval.projectFormalizationResult, "REJECTED")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.approval, "projectFormalizationResult", "REJECTED")
	      }
	    }
	  }), _vm._v("\n                      Retornar para análise\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.approval.projectFormalizationResult),
	      expression: "approval.projectFormalizationResult"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "actionApproval",
	      "value": "CANCELED"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.approval.projectFormalizationResult, "CANCELED")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.approval, "projectFormalizationResult", "CANCELED")
	      }
	    }
	  }), _vm._v("\n                      Cancelar o projeto\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('actionApproval')))]) : _vm._e()]), _vm._v(" "), (_vm.approval.projectFormalizationResult !== 'APPROVED' && 'projectFormalizationResult' in _vm.approval) ? _c('div', {
	    staticClass: "form-group full required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justify"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.approval.justify),
	      expression: "approval.justify"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justificativa"
	    },
	    domProps: {
	      "value": (_vm.approval.justify)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.approval, "justify", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.approval.projectFormalizationResult) ? _c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onConclude
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista\n        ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Minuta / Plano de Trabalho")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Aprovação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "col",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "font-size": "12px"
	    }
	  }, [_vm._v("Decisões:")])])
	}]}

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule",
	    staticStyle: {
	      "min-width": "1155px"
	    }
	  }, [_c('table', {
	    staticClass: "table table-condensed table-striped table-bordered"
	  }, [_c('thead', [_c('tr', [(_vm.proposta.proposalPhase !== 'ANALISE' && _vm.proposta.proposalPhase !== 'PENDENTE_EM_ANALISE') ? _c('th', {
	    staticClass: "ng-scope",
	    staticStyle: {
	      "width": "50%"
	    },
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Atividade")]) : _vm._e(), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('th', {
	    staticClass: "ng-scope",
	    staticStyle: {
	      "width": "50%"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Atividade")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Período")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.propsObjetivos), function(objetivo) {
	    return [_vm._l((objetivo.goals), function(meta) {
	      return [_vm._l((meta.activities), function(atividade, atividadeIndex) {
	        return [_c('tr', {
	          staticClass: "ng-scope",
	          staticStyle: {
	            "background-color": "rgb(223, 228, 235)"
	          }
	        }, [_c('td', {
	          staticClass: "ng-binding ng-scope",
	          attrs: {
	            "colspan": _vm.proposta.proposalPhase === 'ANALISE' ? 5 : 4
	          }
	        }, [_vm._v(_vm._s(atividade.name))]), _vm._v(" "), _c('td', {
	          staticClass: "text-center ng-binding"
	        }, [_vm._v(_vm._s(atividade.startPeriod))]), _vm._v(" "), _c('td', {
	          staticClass: "text-center ng-binding"
	        }, [_vm._v(_vm._s(atividade.finalPeriod))]), _vm._v(" "), _c('td', {
	          staticClass: "text-right ng-binding",
	          attrs: {
	            "colspan": "3"
	          }
	        }, [_vm._v(_vm._s(_vm._f("real")(_vm.somaTotal(atividade.items))))]), _vm._v(" "), _c('td', {
	          staticClass: "ng-scope"
	        }, [_c('button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "disable": _vm.bloqueiaBotoes,
	            "type": "button",
	            "id": "financial-physical-activity-0"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.addItem(atividade)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-plus-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Adicionar\n                  ")])])]), _vm._v(" "), (_vm._.has(atividade, 'items') && atividade.items.length > 0) ? _c('tr', {
	          staticClass: "ng-scope",
	          staticStyle: {
	            "background-color": "#ECF0F5",
	            "font-weight": "bold"
	          }
	        }, [_c('th', [_vm._v("Recurso")]), _vm._v(" "), (_vm.proposta.proposalPhase !== 'PRE_ANALISE') ? _c('th', [_vm._v("Adiantável")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', {
	          staticStyle: {
	            "width": "15%"
	          }
	        }, [_vm._v("Descrição Item")]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('th', {
	          staticStyle: {
	            "width": "15%"
	          }
	        }, [_vm._v("Conta Financeira")]) : _vm._e(), _vm._v(" "), _c('th', {
	          staticClass: "text-center",
	          staticStyle: {
	            "min-width": "55px"
	          }
	        }, [_vm._v("Início")]), _vm._v(" "), _c('th', {
	          staticClass: "text-center",
	          staticStyle: {
	            "min-width": "55px"
	          }
	        }, [_vm._v("Fim")]), _vm._v(" "), _c('th', {
	          staticClass: "text-center"
	        }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Ações")])]) : _vm._e(), _vm._v(" "), _vm._l((atividade.items), function(item, itemIndex) {
	          return _c('tr', {
	            staticClass: "ng-scope",
	            attrs: {
	              "prefix": "activityItem",
	              "suffix": "item.id",
	              "row": "item"
	            }
	          }, [(!item.editando) ? [_c('td', [(item.resourceSource === 'FUNDACAO') ? _c('span', [_vm._v("\n                    Fundação\n                  ")]) : (item.resourceSource === 'CONTRAPARTIDA') ? _c('span', [_vm._v("\n                    Contrapartida\n                  ")]) : _c('span', [_vm._v("\n                    " + _vm._s(item.resourceSource) + "\n                  ")])]), _vm._v(" "), (_vm.proposta.proposalPhase !== 'PRE_ANALISE') ? _c('td', {
	            staticClass: "ng-binding"
	          }, [(item.foreseeable == 'false' || item.foreseeable == false || item.resourceSource === 'CONTRAPARTIDA') ? _c('span', [_vm._v("Não")]) : _c('span', [_vm._v("Sim")])]) : _vm._e(), _vm._v(" "), _c('td', {
	            staticClass: "ng-binding"
	          }, [_vm._v(_vm._s(item.item.type))]), _vm._v(" "), _c('td', {
	            staticClass: "ng-binding"
	          }, [_vm._v(_vm._s(item.item.code + '/' + item.item.description))]), _vm._v(" "), _c('td', {
	            staticClass: "ng-binding"
	          }, [_vm._v(_vm._s(item.itemDescription))]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', {
	            staticClass: "ng-binding"
	          }, [_vm._v(_vm._s(item.financialAccount) + " - " + _vm._s(item.financialAccountDescription))]) : _vm._e(), _vm._v(" "), _c('td', {
	            staticClass: "text-center ng-binding"
	          }, [_vm._v(_vm._s(item.startPeriod))]), _vm._v(" "), _c('td', {
	            staticClass: "text-center ng-binding"
	          }, [_vm._v(_vm._s(item.finalPeriod))]), _vm._v(" "), _c('td', {
	            staticClass: "text-center ng-binding"
	          }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
	            staticClass: "text-center ng-binding"
	          }, [_vm._v(_vm._s(_vm._f("real")(item.unitaryValue)))]), _vm._v(" "), _c('td', {
	            staticClass: "text-center ng-binding"
	          }, [_vm._v(_vm._s(_vm._f("real")(item.totalValue)))]), _vm._v(" "), _c('td', [_c('i', {
	            staticClass: "fa fa-edit disabled",
	            staticStyle: {
	              "margin-left": "5px"
	            },
	            attrs: {
	              "id": "financial-physical-edit-item-0"
	            },
	            on: {
	              "click": function($event) {
	                _vm.bloqueiaBotoes ? null : _vm.editaItem(atividade, atividadeIndex, item, itemIndex)
	              }
	            }
	          }), _vm._v(" "), _c('i', {
	            staticClass: "fa fa-trash ng-scope",
	            staticStyle: {
	              "margin-left": "5px"
	            },
	            attrs: {
	              "id": "financial-physical-delete-item-0"
	            },
	            on: {
	              "click": function($event) {
	                _vm.bloqueiaBotoes ? null : _vm.deleteItem(atividade, itemIndex)
	              }
	            }
	          })])] : _vm._e(), _vm._v(" "), (item.editando) ? [_c('td', {
	            staticStyle: {
	              "padding": "0 15px",
	              "margin-bottom": "10px"
	            },
	            attrs: {
	              "colspan": "10"
	            }
	          }, [_c('div', {
	            staticClass: "box-header with-border"
	          }, [_c('h3', {
	            staticClass: "box-title",
	            staticStyle: {
	              "color": "cornflowerblue"
	            }
	          }, [_vm._v(" " + _vm._s(_vm.itemForm.itemDescription))])]), _vm._v(" "), _c('div', {
	            staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	            staticStyle: {
	              "padding-left": "0"
	            }
	          }, [_c('div', {
	            staticClass: "row"
	          }, [_c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('recurso')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Recurso:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('select', {
	            directives: [{
	              name: "model",
	              rawName: "v-model",
	              value: (_vm.itemForm.resourceSource),
	              expression: "itemForm.resourceSource"
	            }, {
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            staticClass: "form-control",
	            attrs: {
	              "name": "recurso",
	              "aria-label": "recurso"
	            },
	            on: {
	              "change": function($event) {
	                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	                  return o.selected
	                }).map(function(o) {
	                  var val = "_value" in o ? o._value : o.value;
	                  return val
	                });
	                _vm.$set(_vm.itemForm, "resourceSource", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	              }
	            }
	          }, [_c('option', {
	            attrs: {
	              "value": "FUNDACAO"
	            }
	          }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	            attrs: {
	              "value": "CONTRAPARTIDA"
	            }
	          }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('option', {
	            attrs: {
	              "value": "PARCEIRO_ESTRATEGICO"
	            }
	          }, [_vm._v("P.Estratégico")])]), _vm._v(" "), (_vm.errors.first('recurso')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('recurso')))]) : _vm._e()])]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE') ? _c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('adiantavel')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Adiantável:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('select', {
	            directives: [{
	              name: "model",
	              rawName: "v-model",
	              value: (_vm.itemForm.foreseeable),
	              expression: "itemForm.foreseeable"
	            }, {
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            staticClass: "form-control",
	            attrs: {
	              "disabled": _vm.itemForm.resourceSource === 'CONTRAPARTIDA',
	              "name": "adiantavel",
	              "required": ""
	            },
	            on: {
	              "change": function($event) {
	                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	                  return o.selected
	                }).map(function(o) {
	                  var val = "_value" in o ? o._value : o.value;
	                  return val
	                });
	                _vm.$set(_vm.itemForm, "foreseeable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	              }
	            }
	          }, [_c('option', {
	            attrs: {
	              "value": "false"
	            }
	          }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	            attrs: {
	              "value": "true"
	            }
	          }, [_vm._v("Sim")])]), _vm._v(" "), (_vm.errors.first('adiantavel')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('adiantavel')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
	            staticClass: "row"
	          }, [_c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('tipo do recurso')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('div', [_c('select', {
	            directives: [{
	              name: "model",
	              rawName: "v-model",
	              value: (_vm.itemForm.item.type),
	              expression: "itemForm.item.type"
	            }, {
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            staticClass: "form-control",
	            attrs: {
	              "name": "tipo do recurso",
	              "aria-label": "tipo recurso"
	            },
	            on: {
	              "change": [function($event) {
	                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	                  return o.selected
	                }).map(function(o) {
	                  var val = "_value" in o ? o._value : o.value;
	                  return val
	                });
	                _vm.$set(_vm.itemForm.item, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	              }, _vm.buscaItems]
	            }
	          }, [_c('option', {
	            attrs: {
	              "value": "PRODUTO"
	            }
	          }, [_vm._v("Produto")]), _vm._v(" "), _c('option', {
	            attrs: {
	              "value": "SERVICO"
	            }
	          }, [_vm._v("Serviço")])])]), _vm._v(" "), (_vm.errors.first('tipo do recurso')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo do recurso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('item')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Item:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('div', {
	            attrs: {
	              "approval": "finPhySchFormCtrl.approval",
	              "state": "finPhySchFormCtrl.approvalState"
	            }
	          }, [_c('multiselect', {
	            directives: [{
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            attrs: {
	              "name": "item",
	              "custom-label": _vm.itemCodigo,
	              "options": _vm.items,
	              "close-on-select": true,
	              "hide-selected": true,
	              "preserve-search": false,
	              "placeholder": "Escolha um item",
	              "label": "description",
	              "track-by": "code",
	              "preselect-first": true
	            },
	            on: {
	              "open": _vm.buscaItems
	            },
	            scopedSlots: _vm._u([{
	              key: "option",
	              fn: function(props) {
	                return [_c('div', {
	                  staticClass: "option__desc"
	                }, [_c('span', {
	                  staticClass: "option__title"
	                }, [_vm._v(_vm._s(props.option.code) + " / " + _vm._s(props.option.description))])])]
	              }
	            }], null, true),
	            model: {
	              value: (_vm.itemForm.item),
	              callback: function($$v) {
	                _vm.$set(_vm.itemForm, "item", $$v)
	              },
	              expression: "itemForm.item"
	            }
	          })], 1), _vm._v(" "), (_vm.errors.first('item')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('item')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	            staticClass: "row"
	          }, [_c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('descrição item')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Descrição Item:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('div', [_c('input', {
	            directives: [{
	              name: "model",
	              rawName: "v-model",
	              value: (_vm.itemForm.itemDescription),
	              expression: "itemForm.itemDescription"
	            }, {
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            staticClass: "form-control",
	            attrs: {
	              "type": "text",
	              "name": "descrição item",
	              "maxlength": "255",
	              "aria-label": "Descrição do item"
	            },
	            domProps: {
	              "value": (_vm.itemForm.itemDescription)
	            },
	            on: {
	              "input": function($event) {
	                if ($event.target.composing) { return; }
	                _vm.$set(_vm.itemForm, "itemDescription", $event.target.value)
	              }
	            }
	          })]), _vm._v(" "), (_vm.errors.first('descrição item')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('descrição item')))]) : _vm._e()])]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('conta financeira')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Conta Financeira:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('multiselect', {
	            directives: [{
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            attrs: {
	              "name": "conta financeira",
	              "custom-label": _vm.itemCodigo,
	              "options": _vm.contasFinanceiras,
	              "close-on-select": true,
	              "hide-selected": true,
	              "preserve-search": false,
	              "placeholder": "Escolha um item",
	              "label": "description",
	              "track-by": "code",
	              "preselect-first": false
	            },
	            on: {
	              "select": _vm.selecionaConta,
	              "close": function($event) {
	                delete this.itemForm.financialAccountObject
	              }
	            },
	            scopedSlots: _vm._u([{
	              key: "option",
	              fn: function(props) {
	                return [_c('div', {
	                  staticClass: "option__desc"
	                }, [_c('span', {
	                  staticClass: "option__title"
	                }, [_vm._v(_vm._s(props.option.code) + " / " + _vm._s(props.option.description))])])]
	              }
	            }], null, true),
	            model: {
	              value: (_vm.financialAccountObject),
	              callback: function($$v) {
	                _vm.financialAccountObject = $$v
	              },
	              expression: "financialAccountObject"
	            }
	          }), _vm._v(" "), (_vm.errors.first('conta financeira')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('conta financeira')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	            staticClass: "row"
	          }, [_c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('inicio')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Início:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('div', [_c('input', {
	            directives: [{
	              name: "model",
	              rawName: "v-model",
	              value: (_vm.itemForm.startPeriod),
	              expression: "itemForm.startPeriod"
	            }, {
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            staticClass: "form-control text-right",
	            attrs: {
	              "type": "number",
	              "name": "inicio",
	              "maxlength": "2",
	              "aria-label": "Inicio do período",
	              "min": atividade.startPeriod,
	              "max": atividade.finalPeriod,
	              "ng-change": "finPhySchFormCtrl.onChangePeriod(finPhySchForm.startPeriod, finPhySchForm.finalPeriod)"
	            },
	            domProps: {
	              "value": (_vm.itemForm.startPeriod)
	            },
	            on: {
	              "input": function($event) {
	                if ($event.target.composing) { return; }
	                _vm.$set(_vm.itemForm, "startPeriod", $event.target.value)
	              }
	            }
	          })]), _vm._v(" "), (_vm.errors.first('inicio')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('inicio')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('fim')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Fim:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('div', [_c('input', {
	            directives: [{
	              name: "model",
	              rawName: "v-model",
	              value: (_vm.itemForm.finalPeriod),
	              expression: "itemForm.finalPeriod"
	            }, {
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            staticClass: "form-control text-right",
	            attrs: {
	              "type": "number",
	              "name": "fim",
	              "maxlength": "2",
	              "aria-label": "Fim do período",
	              "min": atividade.startPeriod,
	              "max": atividade.finalPeriod
	            },
	            domProps: {
	              "value": (_vm.itemForm.finalPeriod)
	            },
	            on: {
	              "input": function($event) {
	                if ($event.target.composing) { return; }
	                _vm.$set(_vm.itemForm, "finalPeriod", $event.target.value)
	              }
	            }
	          })]), _vm._v(" "), (_vm.errors.first('fim')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('fim')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	            staticClass: "row"
	          }, [_c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('quantidade')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('div', [_c('input', {
	            directives: [{
	              name: "model",
	              rawName: "v-model",
	              value: (_vm.itemForm.quantity),
	              expression: "itemForm.quantity"
	            }, {
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required'),
	              expression: "'required'"
	            }],
	            staticClass: "form-control text-right",
	            attrs: {
	              "type": "number",
	              "name": "quantidade",
	              "min": "1",
	              "maxlength": "6",
	              "aria-label": "Quantidade do recurso"
	            },
	            domProps: {
	              "value": (_vm.itemForm.quantity)
	            },
	            on: {
	              "change": function($event) {
	                return _vm.valorTotal(_vm.itemForm)
	              },
	              "input": function($event) {
	                if ($event.target.composing) { return; }
	                _vm.$set(_vm.itemForm, "quantity", $event.target.value)
	              }
	            }
	          })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	            staticClass: "form-group required col-md-6",
	            class: {
	              'has-error': _vm.errors.first('valor unitario')
	            }
	          }, [_c('label', {
	            staticClass: "control-label col-md-4"
	          }, [_vm._v("Valor Unitário:")]), _vm._v(" "), _c('div', {
	            staticClass: "col-md-8"
	          }, [_c('div', [_c('money', {
	            directives: [{
	              name: "validate",
	              rawName: "v-validate",
	              value: ('required|min_value:1'),
	              expression: "'required|min_value:1'"
	            }],
	            staticClass: "form-control text-right",
	            attrs: {
	              "name": "valor unitario"
	            },
	            on: {
	              "change": function($event) {
	                return _vm.valorTotal(_vm.itemForm)
	              }
	            },
	            model: {
	              value: (_vm.itemForm.unitaryValue),
	              callback: function($$v) {
	                _vm.$set(_vm.itemForm, "unitaryValue", $$v)
	              },
	              expression: "itemForm.unitaryValue"
	            }
	          })], 1), _vm._v(" "), (_vm.errors.first('valor unitario')) ? _c('span', {
	            staticClass: "label label-danger"
	          }, [_vm._v(" " + _vm._s(_vm.errors.first('valor unitario')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	            staticClass: "form-group",
	            staticStyle: {
	              "margin-bottom": "0"
	            }
	          }, [_c('div', {
	            staticClass: "col-md-8 col-md-offset-4"
	          }, [_c('button', {
	            staticClass: "btn btn-primary btn-flat",
	            attrs: {
	              "type": "button",
	              "id": "financial-physical-save-item"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.onAdd(atividade, item, itemIndex)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-check",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          }), _vm._v(" Ok\n                          ")]), _vm._v(" "), _c('span', {
	            staticClass: "btn btn-default btn-flat",
	            attrs: {
	              "type": "button",
	              "id": "financial-physical-cancel-item"
	            },
	            on: {
	              "~click": function($event) {
	                return _vm.cancelaItem(atividade, item, itemIndex)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-times-circle",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          }), _vm._v(" Cancelar\n                        ")])])])])])] : _vm._e()], 2)
	        })]
	      })]
	    })]
	  })], 2), _vm._v(" "), _c('tfoot', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_c('tr', {
	    staticClass: "ng-scope",
	    attrs: {
	      "ng-if": "finPhySchFormCtrl.showApprovalField != 'TRUE'"
	    }
	  }, [_c('td', {
	    attrs: {
	      "colspan": "6"
	    }
	  }, [_vm._v("Total Fundação")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right ng-binding",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFundacao())))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
	    staticClass: "ng-scope",
	    attrs: {
	      "ng-if": "finPhySchFormCtrl.showApprovalField != 'TRUE'"
	    }
	  }, [_c('td', {
	    attrs: {
	      "colspan": "6"
	    }
	  }, [_vm._v("Total Contrapartida")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right ng-binding",
	    staticStyle: {
	      "border-left": "none"
	    },
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContraPartida())))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
	    staticClass: "ng-scope",
	    attrs: {
	      "ng-if": "finPhySchFormCtrl.showApprovalField != 'TRUE'"
	    }
	  }, [_c('td', {
	    attrs: {
	      "colspan": "6"
	    }
	  }, [_vm._v("Total do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right ng-binding",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFundacao() + _vm.totalContraPartida())))]), _vm._v(" "), _c('td')])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - ' + (_vm._.isUndefined(_vm.chamado.id) ? 'Abrindo chamado' : 'Chamado de n° ' + _vm.chamado.id)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Chamados',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "row1"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderDados === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderDados = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar detalhes do Chamado - "), (_vm.chamado.id) ? _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.chamado.id) + " (" + _vm._s(_vm.chamado.status.status) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderDados === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderDados = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar detalhes do Chamado")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm.esconderDados === true) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7",
	    attrs: {
	      "id": "column1"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "id"
	    }
	  }, [_vm._v("N° Chamado:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.id),
	      expression: "chamado.id"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "numerochamado",
	      "disabled": true,
	      "type": "text",
	      "minlength": "1",
	      "ng-maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.chamado.id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado, "id", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.diasEmAberto >= 0 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.chamado.status.id !== 5) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "position": "relative",
	      "top": "5px",
	      "color": "#0f7b9f"
	    }
	  }, [_vm._v(" Aberto há: "), _c('b', [_vm._v(_vm._s(_vm.diasEmAberto))]), _vm._v(" "), (_vm.diasEmAberto > 1) ? _c('span', [_vm._v("dias")]) : _c('span', [_vm._v("dia")]), _vm._v(", "), _c('b', [_vm._v(_vm._s(_vm.horasEmAberto))]), _vm._v("h "), _c('b', [_vm._v(_vm._s(_vm.minutosEmAberto))]), _vm._v(" min\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Descrição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.descricao),
	      expression: "chamado.descricao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "200px",
	      "resize": "none",
	      "border": "1px solid #a8a3a5"
	    },
	    attrs: {
	      "name": "descricao",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.descricao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado, "descricao", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [(_vm.chamado.projeto || _vm.chamado.processo_id) ? _c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "projeto"
	    }
	  }, [_vm._v("Projeto / ID:")]) : _vm._e(), _vm._v(" "), (_vm.chamado.projeto || _vm.chamado.processo_id) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.projeto),
	      expression: "chamado.projeto"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "usuarioNome",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.projeto)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado, "projeto", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.chamado.projeto || _vm.chamado.processo_id) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.processo_id),
	      expression: "chamado.processo_id"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "processo",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.processo_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado, "processo_id", $event.target.value)
	      }
	    }
	  })])]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (_vm.chamado.projeto || _vm.chamado.processo_id)) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "carteira"
	    }
	  }, [_vm._v("Carteira:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.carteira),
	      expression: "carteira"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "usuarioNome",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.carteira)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.carteira = $event.target.value
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Aberto por:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.usuarioNome),
	      expression: "usuarioNome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "usuarioNome",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.usuarioNome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.usuarioNome = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.chamado.usuario_abertura && !_vm._.isNull(_vm.chamado.usuario_abertura.fk_entidade)) ? _c('label', {
	    staticClass: "col-md-3",
	    staticStyle: {
	      "position": "relative",
	      "top": "5px"
	    },
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Representante Legal?")]) : _vm._e(), _vm._v(" "), (_vm.chamado.usuario_abertura && !_vm._.isNull(_vm.chamado.usuario_abertura.fk_entidade)) ? _c('div', {
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "right": "70px",
	      "color": "#0f7b9f"
	    }
	  }, [(_vm.chamado.dirigente && _vm.chamado.dirigente.bt_representante_legal === 1) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticStyle: {
	      "color": "#0a568c"
	    },
	    attrs: {
	      "title": '<h5><span style=\'color: #7adddd\'>Início Mandato: </span>' + _vm.formata(_vm.chamado.dirigente.dt_inicio_mandato) + '</h5>' +
	        '<h5><span style=\'color: #7adddd\'>&nbsp&nbsp&nbspFim Mandato: </span>' + _vm.formata(_vm.chamado.dirigente.dt_fim_mandato) + '</h5>'
	    }
	  }, [_c('b', [_vm._v("Sim")])]) : _vm._e(), _vm._v(" "), (_vm.chamado.dirigente && _vm.chamado.dirigente.bt_representante_legal === 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticStyle: {
	      "color": "#0a568c"
	    },
	    attrs: {
	      "title": '<h5><span style=\'color: #7adddd\'>Início Mandato: </span>' + _vm.formata(_vm.chamado.dirigente.dt_inicio_mandato) + '</h5>' +
	        '<h5><span style=\'color: #7adddd\'>&nbsp&nbsp&nbspFim Mandato: </span>' + _vm.formata(_vm.chamado.dirigente.dt_fim_mandato) + '</h5>'
	    }
	  }, [_c('b', [_vm._v("Não")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.chamado.entidade) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.entidade.ds_nome),
	      expression: "chamado.entidade.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "entidade",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.entidade.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado.entidade, "ds_nome", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('dataInicial')
	    }
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "data_inclusao"
	    }
	  }, [_vm._v("Data abertura: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.data_inclusao),
	      expression: "chamado.data_inclusao"
	    }],
	    ref: "dtInicial",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "dataInicial",
	      "data-vv-as": "Data Inclusão",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.data_inclusao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado, "data_inclusao", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('dataInicial')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataInicial')))]) : _vm._e()])]), _vm._v(" "), (_vm.chamado.usuario_atendimento) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Em atendimento por:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.usuario_atendimento.ds_nome_usuario),
	      expression: "chamado.usuario_atendimento.ds_nome_usuario"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "usuarioNome",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.usuario_atendimento.ds_nome_usuario)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado.usuario_atendimento, "ds_nome_usuario", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.data_atendimento) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "data_atendimento"
	    }
	  }, [_vm._v("Inicio atendimento: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.data_atendimento),
	      expression: "chamado.data_atendimento"
	    }],
	    ref: "dtInicial",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "dataInicial",
	      "data-vv-as": "Data Atendimento",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.data_atendimento)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado, "data_atendimento", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.data_encerramento) ? _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('dataFinal')
	    }
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "data_encerramento"
	    }
	  }, [_vm._v("Data Encerramento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.data_encerramento),
	      expression: "chamado.data_encerramento"
	    }],
	    ref: "Data Final",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "dataFinal",
	      "data-vv-as": "Data Final",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.data_encerramento)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado, "data_encerramento", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Assunto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.assuntos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um assunto",
	      "custom-label": _vm.etiquetaAssunto,
	      "preselect-first": false,
	      "selectLabel": "",
	      "label": "assunto",
	      "track-by": "id",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "assunto",
	      "data-vv-as": "assunto",
	      "disabled": _vm.habilita === false
	    },
	    on: {
	      "select": function($event) {
	        return _vm.changeAssunto($event)
	      }
	    },
	    model: {
	      value: (_vm.chamado.assunto),
	      callback: function($$v) {
	        _vm.$set(_vm.chamado, "assunto", $$v)
	      },
	      expression: "chamado.assunto"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.habilita === true) ? _c('span', {
	    staticClass: "arrow blueArrow margemAssunto"
	  }) : _vm._e()])]), _vm._v(" "), (_vm.chamado.assunto.area_responsavel) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Área Responsável:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.assunto.area_responsavel),
	      expression: "chamado.assunto.area_responsavel"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "assunto",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.assunto.area_responsavel)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado.assunto, "area_responsavel", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "status"
	    }
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [(_vm.chamado.status.status === 'Aguardando Atendimento') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.status.status),
	      expression: "chamado.status.status"
	    }],
	    staticClass: "form-control bordaAguardandoAtendimento",
	    attrs: {
	      "name": "status",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.status.status)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado.status, "status", $event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chamado.status.status === 'Em Atendimento') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.status.status),
	      expression: "chamado.status.status"
	    }],
	    staticClass: "form-control bordaEmAtendimento",
	    attrs: {
	      "name": "status",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.status.status)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado.status, "status", $event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chamado.status.status === 'Aguardando Avaliação') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.status.status),
	      expression: "chamado.status.status"
	    }],
	    staticClass: "form-control bordaAguardandoAvaliacao",
	    attrs: {
	      "name": "status",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.status.status)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado.status, "status", $event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chamado.status.status === 'Chamado Avaliado') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.status.status),
	      expression: "chamado.status.status"
	    }],
	    staticClass: "form-control bordaChamadoAvaliado",
	    attrs: {
	      "name": "status",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.status.status)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado.status, "status", $event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chamado.status.status === 'Chamado Encerrado') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamado.status.status),
	      expression: "chamado.status.status"
	    }],
	    staticClass: "form-control bordaChamadoEncerrado",
	    attrs: {
	      "name": "status",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.chamado.status.status)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamado.status, "status", $event.target.value)
	      }
	    }
	  }) : _vm._e()])])]), _vm._v(" "), (_vm.chamado.documento) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "col-md-2",
	    attrs: {
	      "for": "status"
	    }
	  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onDownload(_vm.chamado.documento)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.chamado.documento.ds_nome_arquivo))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "column2"
	    }
	  }, [(_vm.chamado.status.id !== 5) ? _c('fieldset', [_c('legend', [_vm._v("\n                      Opções do chamado:\n                    ")]), _vm._v(" "), (_vm.chamado.status.id === 1 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn btn-flat relevo",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#048019"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'O atendimento do chamado será iniciado.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.iniciarAtendimento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass-1",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Iniciar Atendimento")])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id == 2 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#048019"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'O chamado será devolvido para o status Aguardando Atendimento.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.devolveAguardandoAtendimento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-backward",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Devolver para Aguardando Atendimento")])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 3 && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.habilitaSalvarReclassificacao === false && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#af8760"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Haverá a reclassificação do assunto do chamado.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.reclassificarAssunto()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Reclassificar Assunto")])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 1 && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.botaoSalvaAnalista === false) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#020202"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Ocorrerá a mudança do analista responsável pelo atendimento do chamado.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mostraAlterarAnalista()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Alterar Analista")])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 1 && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#000099"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Será aberto novo suporte referente ao chamado.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.mostraTextoNovoSuporte()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bug",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Criar Suporte FBB")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.mostraTextoSuporte === true) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('label', {
	    staticClass: "col-md-7",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Selecione o problema:")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.problemas,
	      "label": "problema",
	      "track-by": "prob_id",
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "Selecione um problema"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelecionaProblema($event)
	      }
	    },
	    model: {
	      value: (this.problemaSelecionado),
	      callback: function($$v) {
	        _vm.$set(this, "problemaSelecionado", $$v)
	      },
	      expression: "this.problemaSelecionado"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.mostraTextoSuporte === true) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('br'), _vm._v(" "), _c('label', {
	    staticClass: "col-md-7",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Descrição do problema:")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.descricaoSuporte),
	      expression: "descricaoSuporte"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "200px",
	      "resize": "both",
	      "border": "1px solid #a8a3a5"
	    },
	    attrs: {
	      "name": "resolucao"
	    },
	    domProps: {
	      "value": (_vm.descricaoSuporte)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.descricaoSuporte = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "mt-2 d-flex gap-2",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onOkDescricao
	    }
	  }, [_vm._v("\n                            OK\n                          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-secondary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancelarDescricao
	    }
	  }, [_vm._v("\n                            Cancelar\n                          ")])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.botaoSalvaAnalista === true) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    staticClass: "btn btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#020202"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.salvaNovoAnalista()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Salva Troca Analista")])]), _vm._v(" "), _c('span', {
	    staticClass: "arrow redArrow margemTrocaAnalista"
	  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn  btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#f40022"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'O chamado será encerrado mesmo sem a avaliação do usuário e estará disponível somente para consulta.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.encerrarAtendimentoSemAvaliacao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-square-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Encerrar Atendimento Sem Avaliação")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow blueArrow margemEncerraSemAvaliacao"
	  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.mostraListaUsuarios === true) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('label', {
	    staticClass: "col-md-7",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Selecione um usuário:")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.usuarios,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um assunto",
	      "custom-label": _vm.etiquetaUsuario,
	      "preselect-first": false,
	      "selectLabel": "",
	      "label": "usuarioAlterado",
	      "track-by": "id",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "usuarioAlterado",
	      "data-vv-as": "usuarioAlterado"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.changeUsuario($event)
	      }
	    },
	    model: {
	      value: (_vm.usuarioAlterado),
	      callback: function($$v) {
	        _vm.usuarioAlterado = $$v
	      },
	      expression: "usuarioAlterado"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 3 && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.habilitaSalvarReclassificacao === true && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#af8760"
	    },
	    attrs: {
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Confirma a reclassificação do chamado' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.salvaReclassificacao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Salvar Reclassificação")])]), _vm._v(" "), _c('span', {
	    staticClass: "arrow redArrow margemTrocaAnalista"
	  }), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 4 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn  btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#f40022"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'O chamado será encerrado e estará disponível somente para consulta.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.encerrarAtendimento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-square-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Encerrar Atendimento")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow blueArrow margemTrocaAnalista"
	  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.usuarioLogado.userType === 'ENTIDADE') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('legend', [_vm._v("\n                        O seu problema foi solucionado?\n                      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-2 form-group required",
	    class: {
	      'has-error': _vm.errors.first('problemaSN')
	    }
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.problemaResolvido),
	      expression: "problemaResolvido"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "problemaSN",
	      "value": "SIM"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.problemaResolvido, "SIM")
	    },
	    on: {
	      "change": function($event) {
	        _vm.problemaResolvido = "SIM"
	      }
	    }
	  }), _vm._v(" Sim\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.problemaResolvido),
	      expression: "problemaResolvido"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "problemaSN",
	      "value": "NAO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.problemaResolvido, "NAO")
	    },
	    on: {
	      "change": function($event) {
	        _vm.problemaResolvido = "NAO"
	      }
	    }
	  }), _vm._v(" Não\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('problemaSN')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo acima deve ser marcado com Sim ou Não')))]) : _vm._e()])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.rating === 0 && _vm.problemaResolvido === 'NAO') ? _c('div', {
	    staticClass: "col-md-7 form-group required-field"
	  }, [_c('b', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("Informe o que faltou para a resolução:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.resolucaoNOK),
	      expression: "resolucaoNOK"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "200px",
	      "resize": "both",
	      "border": "1px solid #a8a3a5"
	    },
	    attrs: {
	      "name": "resolucao",
	      "placeholder": _vm.place
	    },
	    domProps: {
	      "value": (_vm.resolucaoNOK)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.resolucaoNOK = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('resolucaoNOK')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resolucaoNOK')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.rating === 0 && _vm.problemaResolvido === 'NAO' && _vm.resolucaoNOK.length > 0) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    staticClass: "btn  btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#001eff"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.devolverChamado()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-backward",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Devolver Chamado")])]), _vm._v(" "), (_vm.problemaResolvido === 'NAO' && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5) ? _c('span', {
	    staticClass: "arrow redArrow margemTrocaAnalista"
	  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.rating === 0 && _vm.problemaResolvido === 'SIM') ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn  btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#001eff"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Após a FBB informar que o chamado foi solucionado, clique aqui para efetuar a avaliação.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.avaliarChamado()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Avaliar Chamado")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [(_vm.chamado.status.id === 3 && _vm.rating > 0 && _vm.mostraAvaliacao === true && _vm.problemaResolvido === 'SIM') ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn  btn-flat",
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#001eff"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Após efetuar a avaliação, seu chamado será encaminhado para encerramento da FBB.' + '</span>' + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.enviarAvaliacaoEEncerrar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Avaliar e enviar para encerramento")]) : _vm._e(), _vm._v(" "), (_vm.problemaResolvido === 'SIM' && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5) ? _c('span', {
	    staticClass: "arrow redArrow margemEncerramento"
	  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.mostraAvaliacao === true && _vm.problemaResolvido === 'SIM') ? _c('div', [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.mostraAvaliacao === true && _vm.problemaResolvido === 'SIM') ? _c('star-rating', {
	    attrs: {
	      "text-class": "custom-text",
	      "active-color": ['red', '#ff6600', '#eead2d', '#74B72E', 'green'],
	      "animate": "true"
	    },
	    on: {
	      "update:rating": _vm.setRating
	    },
	    model: {
	      value: (_vm.rating),
	      callback: function($$v) {
	        _vm.rating = $$v
	      },
	      expression: "rating"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (((_vm.chamado.status.id === 5 || _vm.chamado.status.id === 4) && (_vm.chamado.nota && _vm.chamado.nota.nota && !_vm._.isNull(_vm.chamado.nota.nota)))) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#3d3d3d",
	      "font-weight": "bolder"
	    }
	  }, [_vm._v("Chamado avaliado:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.chamado.status.id === 5 || _vm.chamado.status.id === 4) ? _c('star-rating', {
	    staticClass: "custom-text",
	    attrs: {
	      "active-color": ['red', '#ff6600', '#eead2d', '#74B72E', 'green'],
	      "read-only": true
	    },
	    model: {
	      value: (_vm.chamado.nota.nota),
	      callback: function($$v) {
	        _vm.$set(_vm.chamado.nota, "nota", $$v)
	      },
	      expression: "chamado.nota.nota"
	    }
	  }) : _vm._e()], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [(_vm.table.totalRows > 0 && _vm.table.totalRows < 2) ? _c('span', [_vm._v(" O chamado possui "), _c('b', [_vm._v(" " + _vm._s(_vm.table.totalRows) + " ")]), _vm._v(" assentamento ")]) : (_vm.table.totalRows > 0) ? _c('span', [_vm._v(" O chamado possui "), _c('b', [_vm._v(" " + _vm._s(_vm.table.totalRows) + " ")]), _vm._v(" assentamentos ")]) : _vm._e()])]), _vm._v(" "), (_vm.chamado.status.id !== 5 && _vm.apertouSalvar === false) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "disabled": _vm.chamado.status.id == 1 && _vm.usuarioLogado.userType === 'FUNDACAO',
	      "uib-tooltip": "Inclui um evento na tabela abaixo",
	      "type": "button"
	    },
	    on: {
	      "click": [function($event) {
	        _vm.mostraNovo = true
	      }, function($event) {
	        $event.preventDefault();
	        return _vm.irAte()
	      }]
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir Assentamento")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "table",
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "data_inclusao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, 'DD/MM/YYYY HH:mm:ss')))]
	      }
	    }, {
	      key: "descricao",
	      fn: function(row) {
	        return [_c('span', {
	          domProps: {
	            "innerHTML": _vm._s(row.value)
	          }
	        })]
	      }
	    }, {
	      key: "usuario.ds_nome_usuario",
	      fn: function(row) {
	        return [(row.item.usuario && row.item.usuario.ds_tipo_usuario === 'ENTIDADE') ? _c('span', [_vm._v(" " + _vm._s(row.value) + " "), _c('br'), _vm._v(" "), (_vm.chamado.entidade) ? _c('span', {
	          staticStyle: {
	            "font-style": "italic",
	            "color": "#0a568c"
	          }
	        }, [_vm._v("(" + _vm._s(_vm.chamado.entidade.ds_nome) + ")")]) : _vm._e()]) : (row.item.usuario && row.item.usuario.ds_tipo_usuario === 'FUNDACAO') ? _c('span', [_vm._v(" " + _vm._s(row.value) + " "), _c('br'), _vm._v(" "), _c('span', {
	          staticStyle: {
	            "font-style": "italic",
	            "color": "#0a568c"
	          }
	        }, [_vm._v("(Fundação Banco do Brasil)")])]) : _vm._e()]
	      }
	    }, {
	      key: "anexos",
	      fn: function(row) {
	        return [(row.value && row.value.length > 0) ? _c('div', _vm._l((row.value), function(documento) {
	          return _c('div', {
	            key: documento.id,
	            staticClass: "documento-item"
	          }, [_c('a', {
	            attrs: {
	              "href": "javascript:void(0)"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.onDownload(documento)
	              }
	            }
	          }, [(documento.ds_nome_arquivo) ? _c('span', [_c('i', {
	            staticClass: "fa fa-download",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo) + "\n                              ")]) : _c('span')])])
	        }), 0) : _c('span', [_vm._v("\n                          Nenhum anexo\n                        ")])]
	      }
	    }])
	  }, [_c('template', {
	    slot: "empty"
	  }, [(_vm.carregou === false) ? _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])]) : _vm._e()])], 2), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.mostraNovo === true) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('assentamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "parametro"
	    }
	  }, [_vm._v("Assentamento:")]), _vm._v(" "), (_vm.mostraNovo === true) ? _c('div', {
	    ref: "assentamentoNovo",
	    staticClass: "col-md-4"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.assentamento.descricao),
	      expression: "assentamento.descricao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "200px",
	      "resize": "none",
	      "border": "1px solid #a8a3a5"
	    },
	    attrs: {
	      "name": "assentamento",
	      "placeholder": _vm.placeAssentamento
	    },
	    domProps: {
	      "value": (_vm.assentamento.descricao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.assentamento, "descricao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('assentamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('assentamento')))]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('br'), _vm._v(" "), _c('label', [_vm._v("Deixar visível para a Entidade?")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.assentamento.visivel_entidade),
	      expression: "assentamento.visivel_entidade"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "visivel_entidade"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.assentamento, "visivel_entidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Sim")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('upload-documentos-chamado', {
	    attrs: {
	      "propDocumentos": _vm.assentamento.anexos
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostraNovo === true) ? _c('button', {
	    staticClass: "btn btn-success btn-flat",
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento na tabela abaixo",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.adicionaAssentamento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Salvar")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.mostraNovo === true) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento na tabela abaixo",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.fechaAssentamento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Fechar")]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 2 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: "scale",
	        distance: "1",
	        size: "large",
	        interactive: true,
	        theme: "dark",
	        placement: "right"
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
	    }],
	    staticClass: "btn  btn-flat",
	    class: {
	      'botao-desabilitado': !_vm.assentamento.descricao
	    },
	    staticStyle: {
	      "margin-top": "10px",
	      "color": "#001eff"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento",
	      "type": "button",
	      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Após ter solucionado o problema, preencha o assentamento e envie o chamado para avaliação do usuário.' + '</span>' + '</h5>',
	      "disabled": !_vm.assentamento.descricao
	    },
	    on: {
	      "click": function($event) {
	        return _vm.enviarAvaliacao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Salvar e Enviar para Avaliação")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-chamado-lista'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar ")])], 1)])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Editando Chamado")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', [_vm._v("Sua opinião é muito importante! Avalie este atendimento.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticStyle: {
	      "font-size": "x-small"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "red"
	    }
	  }), _vm._v(": Muito ruim | "), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#ff6600"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#ff6600"
	    }
	  }), _vm._v(": Ruim | "), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#eead2d"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#eead2d"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#eead2d"
	    }
	  }), _vm._v(": Regular | "), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#74B72E"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#74B72E"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#74B72E"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#74B72E"
	    }
	  }), _vm._v(": Bom | "), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _vm._v(": Ótimo.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    staticStyle: {
	      "font-size": "x-small"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "red"
	    }
	  }), _vm._v(": Muito ruim | "), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#ff6600"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#ff6600"
	    }
	  }), _vm._v(": Ruim | "), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#eead2d"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#eead2d"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#eead2d"
	    }
	  }), _vm._v(": Regular | "), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#74B72E"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#74B72E"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#74B72E"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "#74B72E"
	    }
	  }), _vm._v(": Bom | "), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-star",
	    staticStyle: {
	      "color": "green"
	    }
	  }), _vm._v(": Ótimo.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Retorno para a Entidade")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Anexo")])])
	}]}

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "main-footer"
	  }, [_vm._m(0), _vm._v(" "), _c('strong', [_vm._v("Copyright © " + _vm._s((new Date()).getFullYear()) + " - "), _c('a', {
	    attrs: {
	      "href": "http://www.fbb.org.br"
	    }
	  }, [_vm._v("Fundação Banco do Brasil")]), _vm._v(".")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-right hidden-xs"
	  }, [_c('b', [_vm._v("Versão")]), _vm._v(" 3.1.3\n  ")])
	}]}

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Perfis")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Perfis',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope",
	    attrs: {
	      "ng-if": "show.grid"
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row collapse in",
	    staticStyle: {
	      "width": "inherit",
	      "height": "auto"
	    },
	    attrs: {
	      "aria-expanded": "true",
	      "aria-hidden": "false"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-perfis-edita'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Perfil ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.bordered,
	      "items": _vm.items,
	      "hover": _vm.hover,
	      "fields": _vm.fields,
	      "filter": _vm.filter,
	      "current-page": _vm.currentPage,
	      "per-page": 10,
	      "sort-by": _vm.sortBy,
	      "sort-desc": _vm.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        _vm.sortBy = $event
	      },
	      "update:sort-by": function($event) {
	        _vm.sortBy = $event
	      },
	      "update:sortDesc": function($event) {
	        _vm.sortDesc = $event
	      },
	      "update:sort-desc": function($event) {
	        _vm.sortDesc = $event
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "active",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "updatedAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(!row.item.admin) ? _c('div', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "disabled": !_vm.verificaAcesso('perfil-editar')
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-perfis-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "warning",
	            "size": "button--size-ss",
	            "disabled": !_vm.verificaAcesso('perfil-ativar-inativar')
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.inativa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.active ? ' Inativar' : ' Ativar'))])], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta de Perfis")])])
	}]}

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Edita',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    attrs: {
	      "ng-init": "check()"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.simplified),
	      expression: "proposta.simplified"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "hidden",
	      "name": "tipo",
	      "id": "tipo",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.proposta.simplified)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "simplified", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('NAME')"
	    }
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.idProjectErp),
	      expression: "proposta.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "text",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.name),
	      expression: "proposta.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorName),
	      expression: "proposta.coordinatorName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.proposta.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorCpf", $$v)
	      },
	      expression: "proposta.coordinatorCpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('email do coordenador')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.coordinatorEmail),
	      expression: "proposta.coordinatorEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorPhone", $$v)
	      },
	      expression: "proposta.coordinatorPhone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Telefone Celular')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorMobile", $$v)
	      },
	      expression: "proposta.coordinatorMobile"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "coordinatorFax", $$v)
	      },
	      expression: "proposta.coordinatorFax"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.proposta.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                      " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                      " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                    ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.proposta.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.proposta.initialDate),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "initialDate", $$v)
	      },
	      expression: "proposta.initialDate"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periods),
	      expression: "proposta.periods"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.proposta.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periods", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field required-field col-md-12 ng-scope",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.introduction),
	      expression: "proposta.introduction"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "introduction", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.presentation),
	      expression: "proposta.presentation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.territory),
	      expression: "proposta.territory"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.justification),
	      expression: "proposta.justification"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.generalObjective),
	      expression: "proposta.generalObjective"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 ng-scope required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.summary),
	      expression: "proposta.summary"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": this.proposta.audiences
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.audiences = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": this.proposta.teams
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.teams = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.results),
	      expression: "proposta.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "results", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.operation),
	      expression: "proposta.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "operation", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.partner),
	      expression: "proposta.partner"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.proposta.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "partner", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.proposta.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityIsExecutioner),
	      expression: "proposta.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.proposta.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                ")])])]), _vm._v(" "), (_vm.proposta.entityIsExecutioner === false) ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingName),
	      expression: "proposta.entityExecutingName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingProcurator),
	      expression: "proposta.entityExecutingProcurator"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|cnpj'),
	      expression: "'required:!proposta.entityIsExecutioner|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCNPJ", $$v)
	      },
	      expression: "proposta.entityExecutingCNPJ"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingEmail),
	      expression: "proposta.entityExecutingEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner|email'),
	      expression: "'required:!proposta.entityIsExecutioner|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingPhone", $$v)
	      },
	      expression: "proposta.entityExecutingPhone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingMobile", $$v)
	      },
	      expression: "proposta.entityExecutingMobile"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingFax", $$v)
	      },
	      expression: "proposta.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.duplicateProject),
	      expression: "proposta.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber) + "/" + _vm._s(projeto.projectName))])
	  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(7), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('metas', {
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(9), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "meses": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.objectives = $event
	      },
	      "atv": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostraCronograma),
	      expression: "mostraCronograma"
	    }],
	    staticClass: "col-md-12"
	  }, [_vm._m(10), _vm._v(" "), _c('cronograma', {
	    attrs: {
	      "proposta": _vm.proposta,
	      "propsObjetivos": _vm.proposta.objectives,
	      "meses": _vm.proposta.periods,
	      "atividades": _vm.atividades,
	      "componentKey": _vm.componentKey,
	      "projeto-duplicacao": _vm.proposta.duplicateProject
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('gantt', {
	    attrs: {
	      "periodo": _vm.proposta.periods,
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades
	    }
	  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('municipalizacao', {
	    attrs: {
	      "proposta": _vm.proposta
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta = $event
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(12), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.careers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(13), _vm._v(" "), _c('solenizacao', {
	    attrs: {
	      "propsSolenizacao": _vm.proposta.solemnizations
	    },
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.proposta.solemnizations = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(14), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documents,
	      "documentTypes": _vm.proposta.documentTypes,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(15), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.proposta.documentStatements,
	      "documentTypes": [],
	      "documentosObrigatorios": []
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(16), _vm._v(" "), _c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta
	    }
	  })], 1)], 1)])]), _vm._v(" "), _c('pre-analise-form', {
	    attrs: {
	      "propsPreAnalise": _vm.preAnalise
	    }
	  })], 1)])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                          outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	}]}

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Lista Motivos de Devolução'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Motivos de Devolução")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Lista',
	        href: '#'
	      }, {
	        text: 'Motivos de Devolução',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [(this.$root.authorize('motivo-devolucao-criar')) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-motivos-edita'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Motivo de Devolução ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "data_inclusao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "to": {
	              name: 'cadastro-motivos-edita',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.inativa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.bt_ativo ? 'Inativar' : 'Ativar'))])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Lista Motivos de Devolução")])])
	}]}

/***/ }),
/* 2028 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Cadastro de um Relatório ERP")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Relatório ERP',
	        href: '#'
	      }, {
	        text: 'Edita',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-maxlength ng-valid-minlength ng-valid-validate-unique ng-valid ng-valid-required",
	    attrs: {
	      "submit": _vm.onSubmit,
	      "name": "frmCadastroRel",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('codigo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Código do Relatório:  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        max: 255
	      }),
	      expression: "{required: true, max: 255}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio.code),
	      expression: "relatorio.code"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-isolate-scope ng-valid-maxlength ng-valid-minlength ng-valid-validate-unique ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "codigo",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.relatorio.code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorio, "code", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('codigo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('codigo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('titulo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Título do Relatório:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        max: 255
	      }),
	      expression: "{required: true, max: 255}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio.title),
	      expression: "relatorio.title"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-isolate-scope ng-valid-maxlength ng-valid-minlength ng-valid-validate-unique ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "titulo",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.relatorio.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorio, "title", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('titulo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('titulo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('campos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome dos campos do Relatório:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio.fieldNames),
	      expression: "relatorio.fieldNames"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    staticStyle: {
	      "height": "150px"
	    },
	    attrs: {
	      "name": "campos",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.relatorio.fieldNames)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorio, "fieldNames", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('campos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('campos')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('codCampos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Código dos campos do Relatório:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio.codeNames),
	      expression: "relatorio.codeNames"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    staticStyle: {
	      "height": "150px"
	    },
	    attrs: {
	      "name": "codeNames",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.relatorio.codeNames)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorio, "codeNames", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('codCampos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('codCampos')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('ordem')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Ordem do Relatório:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        max: 255
	      }),
	      expression: "{required: true, max: 255}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio.reportOrder),
	      expression: "relatorio.reportOrder"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-isolate-scope ng-valid-maxlength ng-valid-minlength ng-valid-validate-unique ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "ordem",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.relatorio.reportOrder)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorio, "reportOrder", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('ordem')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('repoordemrtOrder')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    class: {
	      'has-error': _vm.errors.first('ativo')
	    },
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio.active),
	      expression: "relatorio.active"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "ativo"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.relatorio.active, true)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.relatorio, "active", true)
	      }
	    }
	  }), _vm._v(" Sim\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio.active),
	      expression: "relatorio.active"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "ativo"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.relatorio.active, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.relatorio, "active", false)
	      }
	    }
	  }), _vm._v(" Não\n                          "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio.active),
	      expression: "relatorio.active"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "ativo"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.relatorio.active, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.relatorio, "active", false)
	      }
	    }
	  }), _vm._v(" Não\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('active')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('ativo')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onSubmit($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onClean($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Relatório ")])])
	}]}

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Perfis")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Perfis',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-maxlength ng-valid-minlength ng-valid-validate-unique ng-valid ng-valid-required",
	    attrs: {
	      "submit": _vm.onSubmit,
	      "name": "frmRegProfileEntity",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome do perfil:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        max: 255
	      }),
	      expression: "{required: true, max: 255}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile.name),
	      expression: "profile.name"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-isolate-scope ng-valid-maxlength ng-valid-minlength ng-valid-validate-unique ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "nome",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.profile.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.profile, "name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    class: {
	      'has-error': _vm.errors.first('status')
	    },
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile.active),
	      expression: "profile.active"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.profile.active, true)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.profile, "active", true)
	      }
	    }
	  }), _vm._v(" Sim\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile.active),
	      expression: "profile.active"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "id": "status"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.profile.active, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.profile, "active", false)
	      }
	    }
	  }), _vm._v(" Não\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('status')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('status')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('descricao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Descrição do perfil:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile.description),
	      expression: "profile.description"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
	    staticStyle: {
	      "height": "150px"
	    },
	    attrs: {
	      "name": "descricao",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.profile.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.profile, "description", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('descricao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('descricao')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.profile.id),
	      expression: "profile.id"
	    }],
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "createdAt"
	    }
	  }, [_vm._v("Data criação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "createdAt",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.profile.createdAt, 'DD/MM/YYYY HH:mm')
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "updatedAt"
	    }
	  }, [_vm._v("Data atualização:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "updatedAt",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.profile.updatedAt, 'DD/MM/YYYY HH:mm')
	    }
	  })])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.profile.id && _vm.profile.inactivateDateTime),
	      expression: "profile.id && profile.inactivateDateTime"
	    }],
	    staticClass: "form-group ng-hide"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Data inativação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._f("moment")(_vm.profile.inactivateDateTime, 'DD/MM/YYYY HH:mm')
	    }
	  })])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onSubmit($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onClean($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")]), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Perfil")])])
	}]}

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('b', [_vm._v("(Adicione os documentos referentes ao item abaixo)")]), _vm._v(" "), (!_vm.showGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [(_vm.editando) ? _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento.ds_tipo),
	      expression: "documento.tipo_documento.ds_tipo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.documento.tipo_documento.ds_tipo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.documento.tipo_documento, "ds_tipo", $event.target.value)
	      }
	    }
	  })]) : _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento",
	      "disabled": _vm.desativado || _vm.editando
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(tipoDocumento) {
	    return _c('option', {
	      key: _vm.documento.id,
	      domProps: {
	        "value": tipoDocumento
	      }
	    }, [_vm._v(_vm._s(tipoDocumento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'tipo_documento') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'tipo_documento') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.tipo_documento.ds_tipo + '</h5>'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [(_vm.editando) ? _c('div', [_c('a', {
	    staticClass: "ng-binding",
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onDownload(_vm.documento)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.documento.ds_nome_arquivo))])]) : _c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file",
	      "disabled": _vm.desativado
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })])]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_nome_arquivo') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "margin-left": "-50px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'ds_nome_arquivo') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "margin-left": "-50px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.ds_nome_arquivo + '</h5>'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Vigencia')
	    },
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-16"
	  }, [(_vm._.hasIn(_vm.mudancas, 'dt_data_vigencia') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "-10px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'dt_data_vigencia') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "-10px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.dt_data_vigencia + '</h5>'
	    }
	  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), (_vm.editando) ? _c('span', [_vm._v("Ok")]) : _c('span', [_vm._v("Adicionar Documento")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('br'), _vm._v(" "), (_vm.faseProposta !== 'FORMALIZACAO' && _vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO') ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [(_vm.propDocumentos.length < _vm.maxFiles) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.novoDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento ")]) : _vm._e(), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "1px",
	      "color": "#048019"
	    },
	    attrs: {
	      "title": '<h5>Inclusões: ' + _vm.inclDocTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a inserção de novo(s) documento(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true && _vm.mostraExclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "1px",
	      "color": "#808080"
	    },
	    attrs: {
	      "title": '<h5>Exclusões: ' + _vm.excDocTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a exclusão de documento(s)")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
	    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(pendente.ds_tipo))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
	      staticStyle: {
	        "max-width": "135px",
	        "text-align": "center"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onAddFile(pendente)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("\n                  Adicionar arquivo\n                ")]) : _vm._e()])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      key: indexDocumento,
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "value": documento
	      }
	    }, [(documento.tipo_documento) ? _c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]) : _c('td'), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(!_vm.disable && !_vm.PropProrrogacaoEdit) ? _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO'),
	        expression: "faseProposta !== 'APROVACAO_PROJETO' && faseProposta !== 'APROVACAO'"
	      }],
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editaDocumento(documento, indexDocumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.disable && !_vm.PropEditandoAlteracaoProjeto) ? _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.faseProposta !== 'FORMALIZACAO' && _vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO'),
	        expression: "faseProposta !== 'FORMALIZACAO' && faseProposta !== 'APROVACAO_PROJETO' && faseProposta !== 'APROVACAO'"
	      }, {
	        name: "confirm",
	        rawName: "v-confirm",
	        value: ({
	          ok: function (retorno) { return _vm.deletaDocumento(indexDocumento); },
	          cancel: _vm.doNothing,
	          message: 'Deseja <b>APAGAR</b> a documento ' + documento.ds_nome_arquivo + ' ?'
	        }),
	        expression: "{ok: retorno => deletaDocumento(indexDocumento), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> a documento ' + documento.ds_nome_arquivo + ' ?'}"
	      }],
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-sm-offset-1 fa-lg"
	    }, [(_vm._.hasIn(_vm.atualizados, indexDocumento)) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          placement: 'left'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
	      }],
	      staticClass: "fa fa-warning",
	      staticStyle: {
	        "position": "relative",
	        "top": "8px",
	        "margin-left": "2px",
	        "color": "#fb2916"
	      },
	      attrs: {
	        "title": '<h5>Clique em editar para ver as mudanças.</h5>'
	      }
	    }) : _vm._e()])]) : _vm._e()])
	  })], 2)])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "text-danger"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pendente")])])
	}]}

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": _vm.loading.tela ? 'Carregando aditivo' : 'Aditivo ' + (!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : '')
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', {
	    staticClass: "col-md-5"
	  }, [_vm._v(_vm._s(_vm.loading.tela ? 'Carregando aditivo...' : 'Aditivo ' + (!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : '')))]), _vm._v(" "), _c('span', [(!_vm.loading.tela) ? _c('span', {
	    staticClass: "col-md-7 bloco_botoes"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Visualizar")])], 1) : _vm._e()])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box box-widget",
	    staticStyle: {
	      "min-height": "200px"
	    }
	  }, [(_vm.loading.tela || _vm._.isEmpty(_vm.solicitacao.aditivo.conteudo)) ? _c('div', [_vm._m(0)]) : _c('div', [_c('div', {
	    staticClass: "box-header with-border hidden-print"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.solicitacao.aditivo.modelo.nome))])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "editorAditivo"
	    }
	  }, [_c('quill-editor', {
	    attrs: {
	      "disabled": _vm.desabilitarEditor,
	      "options": _vm.quillOptions
	    },
	    model: {
	      value: (_vm.solicitacao.aditivo.conteudo),
	      callback: function($$v) {
	        _vm.$set(_vm.solicitacao.aditivo, "conteudo", $$v)
	      },
	      expression: "solicitacao.aditivo.conteudo"
	    }
	  })], 1)])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])
	}]}

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('banco')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "banco"
	    }
	  }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.dados_bancarios.banco),
	      expression: "nota.dados_bancarios.banco"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "banco",
	      "for": "banco"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.nota.dados_bancarios, "banco", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v("Escolha um banco")]), _vm._v(" "), _vm._l((_vm.bancosMain), function(banco) {
	    return _c('option', {
	      domProps: {
	        "value": banco.value
	      }
	    }, [_vm._v(_vm._s(banco.value + ' - ' + banco.label))])
	  }), _vm._v(" "), _c('option', {
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v("--------------------------------------------------------------------------")]), _vm._v(" "), _vm._l((_vm.bancos), function(banco) {
	    return _c('option', {
	      domProps: {
	        "value": banco.value
	      }
	    }, [_vm._v(_vm._s(banco.value + ' - ' + banco.label))])
	  })], 2), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('banco')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('conta corrente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "conta corrente"
	    }
	  }, [_vm._v("Conta Corrente:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "conta corrente",
	      "type": "text",
	      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X'],
	      "tokens": _vm.customTokens,
	      "masked": ""
	    },
	    model: {
	      value: (_vm.nota.dados_bancarios.conta),
	      callback: function($$v) {
	        _vm.$set(_vm.nota.dados_bancarios, "conta", $$v)
	      },
	      expression: "nota.dados_bancarios.conta"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('agência')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "agência"
	    }
	  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|agency'),
	      expression: "'required|agency'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "agência",
	      "type": "text",
	      "mask": ['####-X'],
	      "tokens": _vm.customTokens,
	      "masked": ""
	    },
	    model: {
	      value: (_vm.nota.dados_bancarios.agencia),
	      callback: function($$v) {
	        _vm.$set(_vm.nota.dados_bancarios, "agencia", $$v)
	      },
	      expression: "nota.dados_bancarios.agencia"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('agência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('agência')))]) : _vm._e()])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dados bancários")])])
	}]}

/***/ }),
/* 2033 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.novosMunicipios.length > 0) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "municipios-container"
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.novosMunicipios), function(municipio) {
	    return _c('div', {
	      staticClass: "municipios-novo"
	    }, [_vm._v("\n      - "), _c('strong', [_vm._v(" " + _vm._s(municipio.nome) + " ")])])
	  })], 2), _vm._v(" "), _c('vue-snotify')], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Municípios Encontrados em que a Fundação BB ainda não possui projetos aprovados:\n    ")])
	}]}

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.linhas,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "inicio",
	      fn: function(row) {
	        return [(row.item.data_edicao) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.item.data_edicao, "DD/MM/YYYY HH:mm")))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))])]
	      }
	    }, {
	      key: "termino",
	      fn: function(row) {
	        return [(row.value) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]) : _c('span', [_vm._v("—")])]
	      }
	    }, {
	      key: "nome",
	      fn: function(row) {
	        return [_c('span', [_vm._v(_vm._s(_vm.rotuloFase(row.item)))])]
	      }
	    }, {
	      key: "proxima_etapa",
	      fn: function(row) {
	        return [(_vm.tarefaEmAndamento(row.item)) ? _c('span', [_vm._v("Em andamento")]) : (!_vm._.isNull(row.item.termino) && !_vm._.isUndefined(row.item.termino)) ? _c('span', [(row.item.nome === 'TAREFA_ASSUMIDA') ? _c('span', [_vm._v(" Tarefa Assumida")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'TAREFA_ATRIBUIDA') ? _c('span', [_vm._v(" Tarefa Atribuída")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'DEVOLVE_ATRIBUICAO') ? _c('span', [_vm._v(" Devolvido para a Caixa")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'Reabilita' || row.item.nome === 'REABILITA') ? _c('span', [_vm._v(" Tarefa Reabilitada")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['ANALISE', 'Análise'], row.item.proxima_etapa) && _vm._.includes(['AUTORIZACAO', 'Autorização', 'ANALISE_TRIBUTARIA', 'Análise Tributária', 'ANALISE_FINANCEIRA', 'LIQUIDACAO_FINANCEIRA', 'Liquidação'], row.item.nome)) ? _c('span', [_vm._v(" Devolvido para Análise")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'REVISAO' || row.item.proxima_etapa === 'Revisão') ? _c('span', [_vm._v(" Enviado para Revisão da Entidade")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'AUTORIZACAO' || row.item.proxima_etapa === 'Autorização') ? _c('span', [_vm._v(" Enviado para Autorização")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'ANALISE_FINANCEIRA' || row.item.proxima_etapa === 'Análise Financeira') ? _c('span', [_vm._v(" Enviado para Acerto Contábil")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'ANALISE_TRIBUTARIA' || row.item.proxima_etapa === 'Análise Tributária') ? _c('span', [_vm._v(" Enviado para Análise Tributária")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'LIQUIDACAO_FINANCEIRA' || row.item.proxima_etapa === 'Liquidação') ? _c('span', [_vm._v(" Enviado para Liquidação")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'CONCLUSAO' || row.item.proxima_etapa === 'Conclusão') ? _c('span', [_vm._v(" " + _vm._s(_vm.meuStatus))]) : _vm._e(), _vm._v(" "), (row.item.nome === 'Solicitação') ? _c('span', [_vm._v(" Enviado para Análise")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'SOLICITACAO') ? _c('span', [_vm._v(" Enviado para Análise")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'Revisão' || row.item.nome === 'REVISAO') ? _c('span', [_vm._v(" Enviado para Análise")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'TAREFA_REATIVADA') ? _c('span', [_vm._v(" Enviado para Análise")]) : _vm._e()]) : _vm._e()]
	      }
	    }, {
	      key: "usuario.ds_nome_usuario",
	      fn: function(row) {
	        return [(row.value) ? _c('span', [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("—")])]
	      }
	    }, {
	      key: "usuario.ds_tipo_usuario",
	      fn: function(row) {
	        return [(row.value === 'ENTIDADE') ? _c('span', [_vm._v("Parceiro")]) : (row.value === 'FUNDACAO') ? _c('span', [_vm._v("FBB")]) : (row.value === 'AGENCIA') ? _c('span', [_vm._v("Agência")]) : _c('span', [_vm._v("—")])]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('font', {
	    staticStyle: {
	      "color": "#048019"
	    }
	  }, [_vm._v("Aprovação da Proposta")])], 1)]), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "cmptDocPreparationForm",
	      "novalidate": ""
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('banco')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Banco")]), _vm._v(" "), _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "banco",
	      "mask": ['###']
	    },
	    model: {
	      value: (_vm.aprovacao.ds_agencia_banco),
	      callback: function($$v) {
	        _vm.$set(_vm.aprovacao, "ds_agencia_banco", $$v)
	      },
	      expression: "aprovacao.ds_agencia_banco"
	    }
	  }), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('banco')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('agencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Agência")]), _vm._v(" "), _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "agencia",
	      "mask": ['####-X']
	    },
	    model: {
	      value: (_vm.analise.proposal.agencyNumber),
	      callback: function($$v) {
	        _vm.$set(_vm.analise.proposal, "agencyNumber", $$v)
	      },
	      expression: "analise.proposal.agencyNumber"
	    }
	  }), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('conta corrente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Conta Corrente")]), _vm._v(" "), _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "conta corrente",
	      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X']
	    },
	    model: {
	      value: (_vm.aprovacao.ds_agencia_conta_corrente),
	      callback: function($$v) {
	        _vm.$set(_vm.aprovacao, "ds_agencia_conta_corrente", $$v)
	      },
	      expression: "aprovacao.ds_agencia_conta_corrente"
	    }
	  }), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('dl', [_c('div', {
	    staticClass: "form-group col-md-12 required-field-field",
	    class: {
	      'has-error': _vm.errors.first('data proposta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data da Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data proposta",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.aprovacao.dt_proposta),
	      callback: function($$v) {
	        _vm.$set(_vm.aprovacao, "dt_proposta", $$v)
	      },
	      expression: "aprovacao.dt_proposta"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data proposta')))]) : _vm._e()])]), _vm._v(" "), _c('dl', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data análise')
	    },
	    attrs: {
	      "uib-tooltip": "Data de análise"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de análise")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data análise",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "use-utc": true,
	      "format": "dd/MM/yyyy",
	      "placeholder": "__/__/____"
	    },
	    model: {
	      value: (_vm.aprovacao.dt_analise),
	      callback: function($$v) {
	        _vm.$set(_vm.aprovacao, "dt_analise", $$v)
	      },
	      expression: "aprovacao.dt_analise"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data análise')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data análise')))]) : _vm._e()])]), _vm._v(" "), _c('dl', [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data deferimento')
	    },
	    attrs: {
	      "uib-tooltip": "Data de deferimento"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de deferimento")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data deferimento",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "use-utc": true,
	      "format": "dd/MM/yyyy",
	      "placeholder": "__/__/____"
	    },
	    model: {
	      value: (_vm.aprovacao.dt_deferimento),
	      callback: function($$v) {
	        _vm.$set(_vm.aprovacao, "dt_deferimento", $$v)
	      },
	      expression: "aprovacao.dt_deferimento"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data deferimento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data deferimento')))]) : _vm._e()])]), _vm._v(" "), _c('dl', [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de assinatura do convênio")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    attrs: {
	      "name": "data assinatura",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "use-utc": true,
	      "format": "dd/MM/yyyy",
	      "placeholder": "__/__/____"
	    },
	    model: {
	      value: (_vm.aprovacao.dt_assinatura_convenio),
	      callback: function($$v) {
	        _vm.$set(_vm.aprovacao, "dt_assinatura_convenio", $$v)
	      },
	      expression: "aprovacao.dt_assinatura_convenio"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data assinatura')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data assinatura')))]) : _vm._e()])]), _vm._v(" "), _c('dl', [_c('div', {
	    staticClass: "form-group col-md-12 required-field"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de Vigência do Projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "data vigência",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "use-utc": true,
	      "format": "dd/MM/yyyy",
	      "placeholder": "__/__/____"
	    },
	    model: {
	      value: (_vm.aprovacao.dt_data_vigencia),
	      callback: function($$v) {
	        _vm.$set(_vm.aprovacao, "dt_data_vigencia", $$v)
	      },
	      expression: "aprovacao.dt_data_vigencia"
	    }
	  }), _vm._v(" "), (_vm.errors.first('data vigência')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data vigência')))]) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.analise.documentDraft,
	      "documentTypes": _vm.requiredFormalizationDocumentsType,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('enviaEmail')
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.enviaEmail),
	      expression: "aprovacao.enviaEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "enviaEmail",
	      "value": "true"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.enviaEmail, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "enviaEmail", "true")
	      }
	    }
	  }), _vm._v("\n                      Sim\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.enviaEmail),
	      expression: "aprovacao.enviaEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "enviaEmail",
	      "value": "false"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.enviaEmail, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "enviaEmail", "false")
	      }
	    }
	  }), _vm._v("\n                      Não\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('enviaEmail')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('enviaEmail')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Documentos de formalização")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.aprovacao.documents,
	      "documentTypes": _vm.requiredFormalizationDocumentsType,
	      "documentosObrigatorios": _vm.documentosObrigatorios
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('actionApproval')
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "actionApproval",
	      "value": "APROVAR"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "APROVAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "APROVAR")
	      }
	    }
	  }), _vm._v("\n                      Aprovar o projeto\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "actionApproval",
	      "value": "ENVIAR_CONVENIO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "ENVIAR_CONVENIO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "ENVIAR_CONVENIO")
	      }
	    }
	  }), _vm._v("\n                      Enviar Convênio\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "actionApproval",
	      "value": "REJEITAR",
	      "id": "msgDef"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "REJEITAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "REJEITAR")
	      }
	    }
	  }), _vm._v("\n                      Retornar para análise\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "actionApproval",
	      "value": "CANCELAR"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "CANCELAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "CANCELAR")
	      }
	    }
	  }), _vm._v("\n                      Cancelar o projeto\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('actionApproval')))]) : _vm._e()]), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'REJEITAR' || _vm.aprovacao.resultadoAprovacao === 'CANCELAR') ? _c('div', {
	    staticClass: "form-group full",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justify"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.justificativa),
	      expression: "aprovacao.justificativa"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "justify"
	    },
	    domProps: {
	      "value": (_vm.aprovacao.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.aprovacao, "justificativa", $event.target.value)
	      }
	    }
	  })]) : _vm._e()])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Agência condutora do projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Minuta / Plano de Trabalho")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Envio de E-mail")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "col",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "font-size": "12px"
	    }
	  }, [_vm._v("Deseja enviar e-mail para entidade?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Aprovação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "col",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "font-size": "12px"
	    }
	  }, [_vm._v("Decisões:")])])
	}]}

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Cadastros de Relatórios Sapiens'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Cadastro de Relatórios ERP")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Relatórios ERP',
	        href: '#'
	      }, {
	        text: 'Cadastro',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'edita-relatorio'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Relatório ")])], 1), _vm._v("\n                 \n                "), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "active",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "disabled": false
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'edita-relatorio',
	                params: {
	                  id: row.item
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "warning",
	            "size": "button--size-ss",
	            "disabled": false
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.inativa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.active ? ' Inativar' : ' Ativar'))])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta de Relatórios ERP")])])
	}]}

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": _vm.loading.tela ? 'Carregando súmula' : 'Súmula ' + (!_vm._.isNull(this.$route.params.id) ? this.$route.params.id : '')
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', {
	    staticClass: "col-md-5"
	  }, [_vm._v(_vm._s(_vm.loading.tela ? 'Carregando súmula...' : 'Súmula ' + (!_vm._.isNull(this.$route.params.id) ? 'ID ' + this.$route.params.id : '')))]), _vm._v(" "), (!_vm.loading.tela || _vm.ehVisualizacao) ? _c('span', {
	    staticClass: "col-md-7 bloco_botoes"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimir($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir")])], 1) : _vm._e()])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('sumula', {
	    attrs: {
	      "idProcesso": this.$route.params.id
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Solicitações'
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (Object.keys(_vm.parcelaSelecionada).length > 0) ? _c('div', {
	    staticClass: "row-flex all-start prest-button-container"
	  }, [(!_vm.loading.show) ? _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading.show && _vm.totalPorcentagem >= 80 && _vm.usuarioLogado.userType == 'ENTIDADE' && _vm.chiefActive()),
	      expression: "!loading.show && totalPorcentagem >= 80 && usuarioLogado.userType == 'ENTIDADE' && chiefActive()"
	    }]
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.concluir()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")])], 1), _vm._v(" "), (!_vm.loading.show && _vm.usuarioLogado.userType == 'ENTIDADE' && !_vm.chiefActive() && _vm.totalPorcentagem >= 80) ? _c('span', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  })]) : _vm._e(), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), (_vm.loading.show) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v("\n     [" + _vm._s(_vm.mensagemLoading) + "]\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.loading.show) ? _c('div', {
	    staticClass: "column start-centered prest-section-container"
	  }, [(_vm.mensagemAviso.length > 0) ? _c('div', {
	    staticClass: "column all-start prest-main-container-ged"
	  }, _vm._l((_vm.mensagemAviso), function(aviso) {
	    return _c('div', {
	      key: aviso,
	      staticClass: "row-flex centered-start prest-declaracoes-container-aviso"
	    }, [_vm._m(2, true), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(aviso) + "\n        ")])])
	  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column all-start prest-main-container-ged"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.dadosComplementares.numeroProjeto) + " - " + _vm._s(_vm.dadosComplementares.projeto) + "\n            "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela) ? _c('span', [_vm._v("\n              ("), _c('strong', [_vm._v(_vm._s(_vm.dadosComplementares.statusERP))]), _vm._v(")\n              "), _c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'small',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Ir para a página do Projeto</h5>',
	      "to": {
	        name: 'projeto',
	        params: {
	          numero: _vm.dadosComplementares.numeroProjeto
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered prest-entidade-info-container"
	  }, [_c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
	      "to": {
	        name: 'cadastro-entidade-visualiza',
	        params: {
	          id: _vm.dadosComplementares.fk_entidade
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.dadosComplementares.nome_entidade) + "  "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-label-info"
	  }, [_c('b', [_vm._v("Período de execução:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dadosComplementares.data_inicial) + " a " + _vm._s(_vm.dadosComplementares.data_final))])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start prest-label-info"
	  }, [_c('b', [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("cnpj")(_vm.dadosComplementares.cnpj_entidade)))])]), _vm._v(" "), (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('div', {
	    staticClass: "row-flex centered-start prest-label-info"
	  }, [_c('b', [_vm._v("Projeto Superior:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dadosComplementares.ds_projeto_superior))])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "column all-start prest-main-container-ged"
	  }, [_vm._m(3), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parcelaSelecionada),
	      expression: "parcelaSelecionada"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "projeto",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.parcelaSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.buscaDados()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "selected": ""
	    },
	    domProps: {
	      "value": []
	    }
	  }, [_vm._v("Selecione a Parcela de Adiantamento")]), _vm._v(" "), _vm._l((_vm.parcelasAdiantamento), function(parcelaAdiantamento) {
	    return _c('option', {
	      domProps: {
	        "value": parcelaAdiantamento
	      }
	    }, [_vm._v("Parcela " + _vm._s(parcelaAdiantamento.parcela) + " - Valor Adiantado: " + _vm._s(_vm._f("real")(parcelaAdiantamento.valor_parcela)) + " (" + _vm._s(parseFloat(parcelaAdiantamento.valor_gravado * 100 / parcelaAdiantamento.valor_parcela).toFixed()) + "% comprovado)")])
	  })], 2)]), _vm._v(" "), (Object.keys(_vm.parcelaSelecionada).length > 0) ? _c('div', {
	    staticClass: "column all-start prest-main-container-ged"
	  }, [(_vm.loading.documentos) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v("\n        [" + _vm._s(_vm.mensagemLoading) + "]\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.loading.documentos) ? _c('div', {
	    staticClass: "column all-start prest-w-100"
	  }, [_c('cronogramaGED', {
	    ref: "cronograma",
	    attrs: {
	      "cronograma": _vm.cronograma,
	      "setNota": _vm.setNota,
	      "dataInicioSapiens": _vm.dadosComplementares.data_inicio_sapiens,
	      "dataInicial": _vm.dadosComplementares.data_inicial,
	      "dataFinal": _vm.dadosComplementares.data_final,
	      "idEntidade": _vm.dadosComplementares.fk_entidade,
	      "cnpjEntidade": _vm.dadosComplementares.cnpj_entidade,
	      "fkPrestacaoSimplificada": _vm.parcelaSelecionada.id,
	      "notasCadastradas": _vm.notasCadastradas,
	      "acertoValoresCancelamentoEdicaoCronograma": _vm.acertoValoresCancelamentoEdicaoCronograma
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "column end-centered prest-total-container"
	  }, [_c('div', [_vm._v("\n            Total Registrado: "), _c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.parcelaSelecionada.valor_gravado)))])]), _vm._v(" "), _c('div', [_vm._v("\n            Total Pendente: "), _c('b', [_vm._v(_vm._s(_vm._f("real")(parseFloat(_vm.parcelaSelecionada.valor_parcela) - parseFloat(_vm.parcelaSelecionada.valor_gravado))) + " ")])]), _vm._v(" "), (_vm.existeProcesso.length > 0) ? _c('div', {
	    staticClass: "column end-centered prest-total-container-processo"
	  }, [_c('div', [_vm._v("\n              Total em Processo de Baixa/Baixado: "), _c('b', {
	    staticStyle: {
	      "font-size": "2rem"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalProcesso)))])]), _vm._v(" "), _c('div', [_vm._v("\n              Total registrado pendente de Baixa: "), _c('b', {
	    staticStyle: {
	      "color": "#FF9900",
	      "font-size": "2rem"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalSemProcesso)))])])]) : _vm._e(), _vm._v(" "), _c('b-progress', {
	    staticClass: "prest-progress-bar",
	    attrs: {
	      "max": 100,
	      "animated": true
	    }
	  }, [_c('b-progress-bar', {
	    staticClass: "prest-progress-bar-internal",
	    class: _vm.totalPorcentagem >= 80 ? 'prest-progress-valid' : '',
	    attrs: {
	      "value": _vm.totalPorcentagem,
	      "max": 100,
	      "animated": true
	    }
	  }, [_c('b', [_vm._v(_vm._s(_vm.totalPorcentagem) + "%")])])], 1), _vm._v(" "), _vm._m(4)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading.documentos) ? _c('div', {
	    staticClass: "box-body prest-notas-cadastradas-container"
	  }, [_c('div', {
	    staticClass: "row-flex start-between"
	  }, [_vm._m(5), _vm._v(" "), (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('div', {
	    staticClass: "row-flex all-ceentered prest-action-notas-container"
	  }, [_c('download-excel', {
	    attrs: {
	      "data": _vm.formattedItems,
	      "meta": _vm.excelMeta,
	      "fields": _vm.excelCampos.basico,
	      "type": "xls",
	      "name": ((_vm.moment().format('DDMMYYYYhhmmss')) + " Documentos Fiscais " + (_vm.dadosComplementares.numeroProjeto) + "(Parcela Adiantamento " + (_vm.parcelaSelecionada.parcela) + ").xls")
	    }
	  }, [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        followCursor: true,
	        theme: 'light'
	      }),
	      expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5> Baixar Planilha com os Documentos Cadastrados </h5>'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-excel-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        followCursor: true,
	        theme: 'light'
	      }),
	      expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "title": '<h5> Baixar Todos os Anexos </h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onDownloadZIP()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cloud-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1) : _vm._e()]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    key: _vm.tableDataKey,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "data_emissao_documento",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "valor_documento",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("real")(row.value)))]
	      }
	    }, {
	      key: "serie_documento",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value.replace('_', ' ')))]
	      }
	    }, {
	      key: "item",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "fornecedor_cpf_cnpj",
	      fn: function(row) {
	        return [(row.value.length < 12) ? _c('span', [_vm._v(_vm._s(_vm._f("cpf")(row.value)))]) : _c('span', [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(!_vm.editandoNota) ? _c('div', {
	          staticClass: "row-flex all-centered prest-button-row"
	        }, [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss",
	            "title": '<h5> Detalhar Documento </h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.toggleDetalheNota(true, row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]), _vm._v(" "), (_vm.usuarioLogado.userType == 'ENTIDADE' && (!row.item.hasOwnProperty('fk_processo') || _vm._.isNull(row.item.fk_processo))) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "title": '<h5> Editar Documento </h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.editarNota(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType == 'ENTIDADE' && (!row.item.hasOwnProperty('fk_processo') || _vm._.isNull(row.item.fk_processo))) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss",
	            "title": "'<h5> Excluir Documento </h5>'"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.excluirNota(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]) : _vm._e(), _vm._v(" "), (row.item.fk_processo && _vm.usuarioLogado.userType == 'ENTIDADE') ? _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          staticClass: "prest-label-info-button",
	          attrs: {
	            "title": '<h5> Documentos vinculados a um processo de baixa não podem ser editados ou excluídos. </h5>'
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-exclamation-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Baixa de título: " + _vm._s(row.item.fk_processo) + "\n                          ")]) : _vm._e()], 1) : _c('div', {
	          staticClass: "column all-centered prest-button-row"
	        }, [_c('div', {
	          staticClass: "prest-label-info-button"
	        }, [_vm._v("\n                            Nota em Edição\n                          ")])])]
	      }
	    }, {
	      key: "status",
	      fn: function(row) {
	        return [_c('span', {
	          class: _vm.getClassStatus(row.value)
	        }, [_c('b', [_vm._v(_vm._s(row.value))])])]
	      }
	    }, {
	      key: "anexos",
	      fn: function(row) {
	        return [_c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              followCursor: true,
	              theme: 'light'
	            }),
	            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
	          }],
	          staticClass: "row-flex all-centered prest-anexo-container",
	          attrs: {
	            "title": '<h5> Clique para ver os Anexos </h5>'
	          },
	          on: {
	            "click": function($event) {
	              return _vm.toggleAnexos(true, row.value)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-paperclip",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]
	      }
	    }], null, false, 1863037478)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end prest-total-documentos"
	  }, [_c('div', [_vm._v("\n                    Total de Documentos: "), _c('b', [_vm._v(_vm._s(_vm.table.items.length))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end prest-total-container"
	  }, [_c('div', [_vm._v("\n                    Total Registrado: "), _c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.parcelaSelecionada.valor_gravado)))]), _vm._v(" (" + _vm._s(_vm.totalPorcentagem) + "%)\n                ")])])], 1), _vm._v(" "), (_vm.mostrarAnexos) ? _c('div', {
	    staticClass: "column all-centered prest-modal",
	    on: {
	      "click": function($event) {
	        return _vm.toggleAnexos(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column all-start prest-content-modal",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._l((_vm.anexosNotaModal), function(anexo) {
	    return _c('a', {
	      key: anexo.id,
	      staticClass: "prest-modal-link",
	      on: {
	        "click": function($event) {
	          return _vm.downloadAnexo(anexo)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" [" + _vm._s(_vm._f("moment")(anexo.dt_criado, 'DD/MM/YYYY HH:mm')) + "] " + _vm._s(anexo.ds_nome_arquivo) + " \n              ")])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.mostrarDetalheNota) ? _c('div', {
	    staticClass: "column all-centered prest-modal",
	    on: {
	      "click": function($event) {
	        return _vm.toggleDetalheNota(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column all-start prest-content-modal-detalhes",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_vm._m(8), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Número do Documento:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.numero_documento))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Série do Documento:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.serie_documento.replace('_', ' ')))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Data de Emissão:")]), _vm._v(" " + _vm._s(_vm._f("dataUtc")(_vm.detalhesNotaModal.data_emissao_documento, 'DD/MM/YYYY')) + " ")]), _vm._v(" "), (_vm.detalhesNotaModal.data_validade_documento) ? _c('li', [_c('strong', [_vm._v("Data de Validade:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.detalhesNotaModal.data_validade_documento, 'DD/MM/YYYY HH:mm')))]) : _vm._e(), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Valor do Documento:")]), _vm._v(" " + _vm._s(_vm._f("real")(_vm.detalhesNotaModal.valor_documento)))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Tipo de Fornecedor:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.fornecedor_tipo))]), _vm._v(" "), (_vm.detalhesNotaModal.fornecedor_tipo == 'Pessoa Jurídica') ? _c('li', [_c('strong', [_vm._v("CNPJ do Fornecedor:")]), _vm._v(" " + _vm._s(_vm._f("cnpj")(_vm.detalhesNotaModal.fornecedor_cpf_cnpj)))]) : _vm._e(), _vm._v(" "), (_vm.detalhesNotaModal.fornecedor_tipo == 'Pessoa Física') ? _c('li', [_c('strong', [_vm._v("CPF do Fornecedor:")]), _vm._v(" " + _vm._s(_vm._f("cpf")(_vm.detalhesNotaModal.fornecedor_cpf_cnpj)))]) : _vm._e(), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Nome do Fornecedor:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.fornecedor_nome))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Endereço do Fornecedor:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.fornecedor_endereco))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("CEP do Fornecedor:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.fornecedor_cep))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Item:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.item))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Item Cronograma:")]), _vm._v(" "), _c('i', {
	    staticStyle: {
	      "color": "#6495ED"
	    }
	  }, [_vm._v("[#" + _vm._s(_vm.detalhesNotaModal.fk_item_cronograma) + "]")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.item_cronograma))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Gravado em:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.detalhesNotaModal.created_at, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Atualizado em:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.detalhesNotaModal.updated_at, 'DD/MM/YYYY HH:mm')))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._l((_vm.detalhesNotaModal.anexos), function(anexo) {
	    return _c('a', {
	      key: anexo.id,
	      staticClass: "prest-modal-link",
	      on: {
	        "click": function($event) {
	          return _vm.downloadAnexo(anexo)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" [" + _vm._s(_vm._f("moment")(anexo.dt_criado, 'DD/MM/YYYY HH:mm')) + "] " + _vm._s(anexo.ds_nome_arquivo) + " \n              ")])
	  })], 2)]) : _vm._e()], 1) : _vm._e()]) : _c('div', {
	    staticClass: "column all-start prest-main-container-ged"
	  }, [_vm._m(10)]), _vm._v(" "), _c('div', {
	    staticClass: "column all-start prest-main-container-ged"
	  }, [_c('AnexosComplementares', {
	    attrs: {
	      "dadosComplementares": _vm.dadosComplementares
	    }
	  }), _vm._v(" "), (Object.keys(_vm.parcelaSelecionada).length > 0) ? _c('PrestacaoDeclaracoes', {
	    ref: "prestacaoDeclaracoes",
	    attrs: {
	      "dadosComplementares": _vm.dadosComplementares,
	      "idPrestacao": _vm.parcelaSelecionada.id,
	      "parcelaSelecionada": _vm.parcelaSelecionada,
	      "infoParcelasAdiantamento": _vm.infoParcelasAdiantamento
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('PrestacaoHistorico') : _vm._e()], 1)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('i', {
	    staticClass: "fa fa-file-pdf-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Prestação de Contas | Gerenciador de Documentos Fiscais")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start prest-declaracoes-container-aviso-small"
	  }, [_c('div', {
	    staticClass: "column all-centered prest-declaracoes-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("\n            Aviso: Já é possível solicitar a "), _c('b', [_vm._v("baixa do título de adiantamento")]), _vm._v(". "), _c('i', [_vm._v("*Apenas "), _c('b', [_vm._v("representantes legais")]), _vm._v(" podem concluir a prestação de contas.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column all-centered prest-declaracoes-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Selecione a Parcela de Adiantamento para Vinculação dos Documentos "), _c('i', {
	    staticClass: "fa fa-dollar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', [_vm._v("*Ao chegar a 80% de comprovação, será possível encaminhar a prestação de contas para a Fundação Banco do Brasil, ciente de que o processo de prestação de contas deverá continuar até que se alcance 100% do recurso adiantado.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Documentos Cadastrados "), _c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Detalhe dos Anexos: "), _c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_vm._v("Clique no link para fazer o "), _c('b', [_vm._v("download")]), _vm._v(" do anexo:")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Detalhe do Documento Fiscal: "), _c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_vm._v("Clique no link para fazer o "), _c('b', [_vm._v("download")]), _vm._v(" do anexo:")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start prest-declaracoes-container-aviso"
	  }, [_c('div', {
	    staticClass: "column all-centered prest-declaracoes-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("\n          Selecione uma parcela de Adiantamento para carregar os documentos fiscais vinculados.\n        ")])])
	}]}

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 financial-physical-schedule"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "gantt unselectable ng-isolate-scope"
	  }, [_c('table', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Atividades")]), _vm._v(" "), _vm._l((_vm.periodo), function(mes) {
	    return _c('th', [_vm._v(_vm._s(mes))])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.atividades), function(atividade) {
	    return _c('tr', [_c('td', {
	      staticStyle: {
	        "width": "30%"
	      }
	    }, [_vm._v(_vm._s(atividade.name))]), _vm._v(" "), _vm._l((_vm.periodo), function(mes) {
	      return _c('td', [_c('div', {
	        style: (mes >= atividade.startPeriod && mes <= atividade.finalPeriod ? 'background-color: #0038a8' : ''),
	        attrs: {
	          "id": "teste"
	        }
	      }, [_vm._v(" ")])])
	    })], 2)
	  }), 0)])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Validação da Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Validação de Proposta',
	        href: '#'
	      }, {
	        text: 'Primeira Aprovação',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "validaProp"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', [_vm._v("Pré-Análise")]), _vm._v(" "), _c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroPre"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'primeira'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'primeira'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Primeira Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.preAnalysisFirstApproval))])])]), _vm._v(" "), (this.$root.authorize('pre-analise-segunda-aprovacao-validar')) ? _c('li', {
	    class: {
	      'active': _vm.faseAtual === 'segunda'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'segunda'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-peace-o"
	  }), _vm._v("Segunda Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.preAnalysisSecondApproval))])])]) : _vm._e()])])])])]), _vm._v(" "), (this.$root.authorize('aceite-proposta-validar')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', [_vm._v("Aceite")]), _vm._v(" "), _c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroAceite"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'aceite'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'aceite'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.acceptanceApproval))])])])])])])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('analise-aprovacao-validar|analise-pendencia-aprovacao-validar')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', [_vm._v("Análise")]), _vm._v(" "), _c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroAnalise"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'analise'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'analise'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.analysisApproval + _vm.quantidadesPorFase.analysisPendency))])])])])])])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('deferimento-aprovacao-validar')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', [_vm._v("Deferimento")]), _vm._v(" "), _c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroDef"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'deferimento'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'deferimento'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.grantApproval))])])])])])])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('preparacao-documentos-aprovacao-validar')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', [_vm._v("Preparação de Documentos")]), _vm._v(" "), _c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroPrep"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'preparacao'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'preparacao'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.documentPreparationApproval))])])])])])])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('formalizacao-projetos-aprovacao-validar')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', [_vm._v("Formalizar Projetos")]), _vm._v(" "), _c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroForm"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'formalizacao'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'formalizacao'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.projectFormalizationApproval))])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.descricaoFase))]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative"
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative",
	      "margin-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('div', {
	    staticClass: "mailbox-controls"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.favorite = !_vm.filtro.favorite
	      }
	    },
	    model: {
	      value: (_vm.filtro.favorite),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "favorite", $$v)
	      },
	      expression: "filtro.favorite"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
	      }
	    },
	    model: {
	      value: (_vm.filtro.userId),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "userId", $$v)
	      },
	      expression: "filtro.userId"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSearch
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  })]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "favorite",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onFavorite(row.item)
	            }
	          }
	        })]
	      }
	    }, {
	      key: "proposta",
	      fn: function(row) {
	        return [_c('div', {}, [(row.item.simplificado > '0') ? _c('div', [_c('b', [_vm._v(_vm._s(row.item.simplificado))]), _c('br')]) : _vm._e(), _vm._v("\n                          " + _vm._s(row.item.companyName) + "\n                        "), _c('div', [_vm._v("\n                          " + _vm._s(row.item.nomeProposta) + "\n                        ")])])]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "userName",
	      fn: function(row) {
	        return [(row.value) ? _c('span', {
	          staticStyle: {
	            "font-weight": "bold"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('div', {
	          staticClass: "btn-group"
	        }, [_c('button', {
	          staticClass: "btn btn-default",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ellipsis-h"
	        })]), _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu dropdown-menu-right",
	          attrs: {
	            "role": "menu",
	            "aria-labelledby": "new-register"
	          }
	        }, [_c('li', [_c('a', {
	          attrs: {
	            "href": "#"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ver mais")])]), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssignAndDo(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-arrow-circle-right",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onUnassign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user-times",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', {
	          staticClass: "divider",
	          attrs: {
	            "role": "separator"
	          }
	        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: _vm.rota1,
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-play-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)]), _vm._v(" "), (_vm.faseAtual === 'aceite' || _vm.faseAtual === 'analise') ? _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.faseAtual === 'aceite' ? 'Aceite - Recusadas para Ajustes' : 'Análise - Pendências'))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative",
	      "margin-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('div', {
	    staticClass: "mailbox-controls"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.favorite = !_vm.filtro.favorite
	      }
	    },
	    model: {
	      value: (_vm.filtro.favorite),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "favorite", $$v)
	      },
	      expression: "filtro.favorite"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
	      }
	    },
	    model: {
	      value: (_vm.filtro.userId),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "userId", $$v)
	      },
	      expression: "filtro.userId"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSearch
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  })]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table2.bordered,
	      "items": _vm.table2.items,
	      "fields": _vm.table2.fields,
	      "filter": _vm.table2.filter,
	      "current-page": _vm.table2.currentPage,
	      "per-page": _vm.table2.perPage,
	      "sort-by": _vm.table2.sortBy,
	      "sort-desc": _vm.table2.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFilteredRejeitados,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table2, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table2, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table2, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table2, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "favorite",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onFavorite(row.item)
	            }
	          }
	        })]
	      }
	    }, {
	      key: "proposta",
	      fn: function(row) {
	        return [_c('div', {}, [(row.item.simplificado > '0') ? _c('div', [_c('b', [_vm._v(_vm._s(row.item.simplificado))]), _c('br')]) : _vm._e(), _vm._v("\n                          " + _vm._s(row.item.companyName) + "\n                          "), _c('div', [_vm._v("\n                            " + _vm._s(row.item.nomeProposta) + "\n                          ")])])]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "userName",
	      fn: function(row) {
	        return [(row.value) ? _c('span', {
	          staticStyle: {
	            "font-weight": "bold"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('div', {
	          staticClass: "btn-group"
	        }, [_c('button', {
	          staticClass: "btn btn-default",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ellipsis-h"
	        })]), _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu dropdown-menu-right",
	          attrs: {
	            "role": "menu",
	            "aria-labelledby": "new-register"
	          }
	        }, [_c('li', [_c('a', {
	          attrs: {
	            "href": "#"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ver mais")])]), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssignAndDo(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onUnassign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user-times",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', {
	          staticClass: "divider",
	          attrs: {
	            "role": "separator"
	          }
	        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'primeira-aprovacao',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-play-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
	      }
	    }], null, false, 3903324717)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table2.totalRows,
	      "per-page": _vm.table2.perPage
	    },
	    model: {
	      value: (_vm.table2.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table2, "currentPage", $$v)
	      },
	      expression: "table2.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)]) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  })])
	}]}

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column centered-start",
	    class: _vm.relatorioCotacao ? 'detalhe-item-container-cotacao' : 'detalhe-item-container'
	  }, [_c('div', {
	    staticClass: "row-flex centered-between detalhe-titulo",
	    class: _vm.removidoManual ? 'detalhe-titulo-removido-manual' : ''
	  }, [_c('div', {
	    staticClass: "row-flex centered-start gap-10"
	  }, [_c('i', {
	    staticClass: "item-detalhe-icone fa fa-arrow-circle-right"
	  }), _vm._v(" Detalhamento de Item de Licitação [" + _vm._s(_vm.itemLicitacao['id']) + "]\n    ")]), _vm._v(" "), (!_vm.relatorioCotacao) ? _c('i', {
	    staticClass: "item-detalhe-icone button-icone fa fa-remove",
	    on: {
	      "click": function($event) {
	        return _vm.toggleDetalhe(false)
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.itemLicitacao['descricao_lote'] !== '0' && _vm.showAll) ? _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Descrição Lote",
	      "value": _vm.itemLicitacao['descricao_lote'],
	      "icone": "fa-bars"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Produto",
	      "value": _vm.itemLicitacao['descricao_item'],
	      "icone": "fa-cube"
	    }
	  })], 1), _vm._v(" "), (_vm.showAll) ? _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Descrição Adicional",
	      "value": _vm.itemLicitacao['descricao_simplificada_item'],
	      "icone": "fa-cubes"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Valor do Item",
	      "value": _vm.itemLicitacao['valor_item'],
	      "formatarValor": true,
	      "icone": "fa-dollar"
	    }
	  })], 1), _vm._v(" "), (_vm.showAll) ? _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Quantidade Aprovada",
	      "value": _vm.itemLicitacao['quantidade_item_aprovado'],
	      "icone": "fa-tags"
	    }
	  }), _vm._v(" "), _c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Valor do Lote",
	      "value": _vm.itemLicitacao['valor_total_lote_item'],
	      "formatarValor": true,
	      "icone": "fa-money"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Licitação",
	      "value": _vm.itemLicitacao['codigo_licitacao'],
	      "icone": "fa-balance-scale"
	    }
	  }), _vm._v(" "), _c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Data Licitação",
	      "value": _vm.moment.utc(_vm.itemLicitacao['data_resultado_licitacao']).format('MM/YYYY'),
	      "icone": "fa-calendar"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.itemLicitacao['sigla_uf'] !== '0' && _vm.showAll) ? _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "UF",
	      "value": _vm.itemLicitacao['sigla_uf'],
	      "icone": "fa-map"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('a', {
	    staticClass: "row-flex start-centered detalhe-item-row",
	    attrs: {
	      "href": _vm.linkLicitacao(_vm.itemLicitacao['nome_fonte_dado']),
	      "target": "_blank"
	    }
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Fonte de Dados",
	      "value": _vm.itemLicitacao['nome_fonte_dado'],
	      "icone": "fa-commenting",
	      "link": ""
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Fornecedor",
	      "value": _vm.itemLicitacao['nome_fornecedor'],
	      "icone": "fa-cog"
	    }
	  }), _vm._v(" "), _c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "CNPJ Fornecedor",
	      "value": _vm.itemLicitacao['codigo_cnpj_fornecedor'],
	      "icone": "fa-cogs"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [_c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Comprador",
	      "value": _vm.itemLicitacao['nome_orgao_comprador'],
	      "icone": "fa-shopping-cart"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAll) ? _c('div', {
	    staticClass: "row-flex start-centered detalhe-item-row"
	  }, [(_vm.itemLicitacao['nome_setor_item'] !== '0') ? _c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Setor",
	      "value": _vm.itemLicitacao['nome_setor_item'],
	      "icone": "fa-object-group"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.itemLicitacao['nome_categoria_item'] !== '0') ? _c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Categoria",
	      "value": _vm.itemLicitacao['nome_categoria_item'],
	      "icone": "fa-sliders"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.itemLicitacao['nome_grupo_item'] !== '0') ? _c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Grupo",
	      "value": _vm.itemLicitacao['nome_grupo_item'],
	      "icone": "fa-sort-alpha-asc"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.itemLicitacao['nome_classificacao_item'] !== '0') ? _c('itemDetalheLicitacao', {
	    attrs: {
	      "titulo": "Classificação",
	      "value": _vm.itemLicitacao['nome_classificacao_item'],
	      "icone": "fa-tasks"
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioCotacao) ? _c('div', {
	    staticClass: "row-flex all-end detalhe-rodape"
	  }, [_vm._v("\n    0" + _vm._s(_vm.index) + " / 0" + _vm._s(_vm.total) + "\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body w-100"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "column all-centered table-container"
	  }, [(!_vm.visualizarLicenca && !_vm.validarLicenca && !_vm.editarLicenca) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-paste",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Validação de Licenças\n             ")]), _vm._v(" "), (_vm.todasLicencas) ? _c('div', {
	    staticClass: "row-flex all-start gap-10 w-100"
	  }, [_c('div', {
	    staticClass: "filtro-container w-80"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Selecione um projeto: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtroProjetoSelecionado),
	      expression: "filtroProjetoSelecionado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto",
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.filtroProjetoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.aplicarFiltros()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TODOS"
	    }
	  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filtroProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto
	      }
	    }, [_vm._v(_vm._s(projeto))])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "filtro-container w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Status: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtroStatusSelecionado),
	      expression: "filtroStatusSelecionado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto",
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.filtroStatusSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.aplicarFiltros()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TODOS"
	    }
	  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filtroStatus), function(status) {
	    return _c('option', {
	      domProps: {
	        "value": status
	      }
	    }, [_vm._v(_vm._s(status))])
	  })], 2)])]) : _vm._e(), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-centered",
	          staticStyle: {
	            "gap": "5px"
	          }
	        }, [(_vm.verificarStatusValidacao(row.item)) ? _c('b-button', {
	          staticClass: "btn btn-success btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "edita-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.abrirAnexoLicenca(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-check-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Validar")]) : _vm._e(), _vm._v(" "), (_vm.verificarStatusEdicao(row.item)) ? _c('b-button', {
	          staticClass: "btn btn-warning btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.editaLicenca(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Editar")]) : _vm._e(), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.visualizaLicenca(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Visualizar")]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.todasLicencas) ? _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Atenção, este procedimento não poderá ser desfeito. Confirma Exclusão?', function () { return _vm.preparaExclusao(row.item); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")]) : _vm._e()], 1)]
	      }
	    }, {
	      key: "prazo_apresentacao",
	      fn: function(row) {
	        return [(row.value == '') ? _c('span', [_vm._v("\n                   -\n                 ")]) : _c('span', [(_vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
	          staticClass: "badge badge-danger",
	          attrs: {
	            "title": "Vencida"
	          }
	        }, [_vm._v("\n                     Prazo vencido em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                   ")]) : (row.value) ? _c('span', {
	          staticClass: "badge badge-success",
	          attrs: {
	            "title": "Dentro da validade"
	          }
	        }, [_vm._v("\n                     " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                   ")]) : _vm._e()])]
	      }
	    }, {
	      key: "data_apresentacao",
	      fn: function(row) {
	        return [(row.value == '') ? _c('div', [_c('b', [_vm._v("Não Apresentado")])]) : _c('div', [_vm._v("\n                   " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                 ")])]
	      }
	    }, {
	      key: "validade",
	      fn: function(row) {
	        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
	          staticClass: "badge badge-danger",
	          attrs: {
	            "title": "Vencida"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-warning",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Vencida em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                   ")]) : (row.value) ? _c('span', {
	          staticClass: "badge badge-success",
	          attrs: {
	            "title": "Dentro da validade"
	          }
	        }, [_vm._v("\n                     " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                   ")]) : _c('span', [_vm._v("\n                     -\n                   ")])]
	      }
	    }, {
	      key: "status",
	      fn: function(row) {
	        return [_c('span', {
	          class: _vm.statusClass(row.value)
	        }, [_vm._v("\n                   " + _vm._s(row.value) + "\n                 ")])]
	      }
	    }, {
	      key: "tipo_licenca",
	      fn: function(row) {
	        return [_vm._v("\n                   " + _vm._s(row.value.replace('_', ' ')) + "\n               ")]
	      }
	    }], null, false, 2785024838)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-10"
	  }, [_c('div', [_vm._v("\n                 (" + _vm._s(_vm.table.items.length) + ") Licenças Encontradas\n               ")]), _vm._v(" "), (_vm.todasLicencas) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.limparFiltros()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-repeat",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.validarLicenca || _vm.visualizarLicenca || _vm.editarLicenca) ? _c('div', {
	    staticClass: "envio-container column start-centered"
	  }, [_c('legend', [_vm._v("\n           Validação de Licença\n       ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start gap-10 w-100"
	  }, [_c('div', {
	    staticClass: "w-80"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto:")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "0000 Nome do Projeto",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.licencaTemplate.projeto
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.status),
	      expression: "licencaTemplate.status"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Status",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.status)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "status", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Fase:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.fase_proposta),
	      expression: "licencaTemplate.fase_proposta"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Fase",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.fase_proposta)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "fase_proposta", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start gap-10 w-100"
	  }, [_c('div', {
	    staticClass: "w-70"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Tipo de Licença:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.licenca),
	      expression: "licencaTemplate.licenca"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Tipo de Licença",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.licenca)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "licenca", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "w-10"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de Validade:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.licencaTemplate.validade),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaTemplate, "validade", $$v)
	      },
	      expression: "licencaTemplate.validade"
	    }
	  })], 1), _vm._v(" "), (!_vm.editarLicenca) ? _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de Apresentação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.prazo_apresentacao),
	      expression: "licencaTemplate.prazo_apresentacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Prazo de Apresentação",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.prazo_apresentacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "prazo_apresentacao", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.editarLicenca) ? _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de Apresentação:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaTemplate.prazo_apresentacao),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaTemplate, "prazo_apresentacao", $$v)
	      },
	      expression: "licencaTemplate.prazo_apresentacao"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Apresentado em:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.data_apresentacao),
	      expression: "licencaTemplate.data_apresentacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Prazo de Apresentação",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.data_apresentacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "data_apresentacao", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.observacoes),
	      expression: "licencaTemplate.observacoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Observações Adicionais",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.observacoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "observacoes", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
	    staticClass: "w-100",
	    attrs: {
	      "propDocumentos": _vm.licencaTemplate.anexo,
	      "localUso": "LICENCIAMENTO_AMBIENTAL",
	      "maxFiles": 1,
	      "disable": true
	    }
	  })], 1), _vm._v(" "), _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('legend', [_vm._v("\n           Histórico\n         ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.showTable),
	      expression: "loading.showTable"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableHistorico.bordered,
	      "items": _vm.tableHistorico.items,
	      "hover": _vm.tableHistorico.hover,
	      "fields": _vm.tableHistorico.fields,
	      "filter": _vm.tableHistorico.filter,
	      "current-page": _vm.tableHistorico.currentPage,
	      "per-page": _vm.tableHistorico.perPage,
	      "sort-by": _vm.tableHistorico.sortBy,
	      "sort-desc": _vm.tableHistorico.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableHistorico, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableHistorico, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableHistorico, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableHistorico, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "created_at",
	      fn: function(row) {
	        return [_vm._v("\n           " + _vm._s(_vm.moment(row.value).format('DD/MM/YYYY HH:mm:ss')) + "\n         ")]
	      }
	    }], null, false, 1735301358)
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "w-100 column centered-start gap-10"
	  }, [(_vm.validarLicenca) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Decisão:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.decisao),
	      expression: "licencaTemplate.decisao"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "Validado"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.licencaTemplate.decisao, "Validado")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.licencaTemplate, "decisao", "Validado")
	      }
	    }
	  }), _vm._v(" Validar\n                 "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.decisao),
	      expression: "licencaTemplate.decisao"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "Devolvido para Ajustes"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.licencaTemplate.decisao, "Devolvido para Ajustes")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.licencaTemplate, "decisao", "Devolvido para Ajustes")
	      }
	    }
	  }), _vm._v(" Devolver para Ajustes\n                 "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.validarLicenca || _vm.editarLicenca) ? _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplate.justificativaDecisao),
	      expression: "licencaTemplate.justificativaDecisao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Justificativa da decisão aqui"
	    },
	    domProps: {
	      "value": (_vm.licencaTemplate.justificativaDecisao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplate, "justificativaDecisao", $event.target.value)
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), (_vm.validarLicenca) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleValidacao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.validaLicenca()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Atualizar Status Licença ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicenca) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.atualizaPrazoLicenca()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Atualizar Prazo de Apresentação ")])], 1) : _vm._e(), _vm._v(" "), (_vm.visualizarLicenca) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleVisualizacao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Voltar ")])], 1) : _vm._e()], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column centered-start modal-overlay"
	  }, [_c('div', {
	    staticClass: "column all-start cotacao-itens-main-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [(!_vm.abrirCotacaoPrecos && !_vm.abrirDetalheItem && !_vm.abrirCotacaoManual) ? _c('div', {
	    staticClass: "box-body column centered-start cotacao-itens-container"
	  }, [_c('div', {
	    staticClass: "row-flex centered-start cotacao-header-container"
	  }, [_c('i', {
	    staticClass: "fa fa-dollar"
	  }), _vm._v(" [" + _vm._s(_vm.idProposta) + "] "), _c('i', [_vm._v("#" + _vm._s(_vm.idCotacao))]), _vm._v(" Resumo da cotação\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between cotacao-adicionar-container"
	  }, [_vm._m(0), _vm._v(" "), (this.itensCotacaoManual.length !== 0 || this.itensCotacao.length !== 0 && !_vm.validandoCotacao) ? _c('div', [(this.itensCotacaoManual.length === 0 && !_vm.visualizandoCotacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "title": "Abre o Busca Preço, sistema de banco de dados de preços de Licitações."
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleAdicionarItem(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-cart",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cotação Automática ")]) : _vm._e(), _vm._v(" "), (this.itensCotacao.length === 0 && !_vm.visualizandoCotacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "title": "Não encontrou o item desejado, ou conseguiu um preço melhor? Cadastre aqui."
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.novaCotacaoManual(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-files-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cotação Manual ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.showTable),
	      expression: "loading.showTable"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), (this.itensCotacaoManual.length === 0 && this.itensCotacao.length === 0) ? _c('div', {
	    staticClass: "descricao-cotacao-container column all-centered gap-5"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered w-100 gap-5"
	  }, [(this.itensCotacaoManual.length === 0) ? _c('div', {
	    staticClass: "row-flex all-centered button-cotacao button-azul",
	    attrs: {
	      "title": "Abre o Banco de Cotações, sistema de banco de dados de preços de Licitações."
	    },
	    on: {
	      "mouseover": function($event) {
	        _vm.textoInstrucao = 'Abre o Busca Preço, sistema de banco de dados de preços de Licitações.'
	      },
	      "mouseleave": function($event) {
	        _vm.textoInstrucao = 'Selecione uma opção para começar o cadastro da cotação.'
	      },
	      "click": function($event) {
	        return _vm.toggleAdicionarItem(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-cart",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cotação Automática ")]) : _vm._e(), _vm._v(" "), (this.itensCotacao.length === 0) ? _c('div', {
	    staticClass: "row-flex all-centered button-cotacao button-amarelo",
	    attrs: {
	      "title": "Não encontrou o item desejado, ou conseguiu um preço melhor? Cadastre aqui."
	    },
	    on: {
	      "mouseover": function($event) {
	        _vm.textoInstrucao = 'Não encontrou o item desejado, ou conseguiu um preço melhor? Cadastre aqui.'
	      },
	      "mouseleave": function($event) {
	        _vm.textoInstrucao = 'Selecione uma opção para começar o cadastro da cotação.'
	      },
	      "click": function($event) {
	        return _vm.novaCotacaoManual(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-files-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cotação Manual ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered gap-10 cotacao-texto-instrucao"
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  }), _vm._v(" " + _vm._s(_vm.textoInstrucao) + "\n        ")])]) : _vm._e(), _vm._v(" "), (this.itensCotacaoManual.length !== 0 || this.itensCotacao.length !== 0) ? _c('div', {
	    staticClass: "descricao-cotacao-container"
	  }, [_vm._m(1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.descricaoCotacao),
	      expression: "descricaoCotacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Descrição da Cotação (Será gerada automaticamente, mas você pode editar)",
	      "disabled": _vm.validandoCotacao
	    },
	    domProps: {
	      "value": (_vm.descricaoCotacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.descricaoCotacao = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (this.itensCotacaoManual.length > 0 || this.itensCotacao.length > 0) ? _c('div', {
	    staticClass: "column all-centered cotacao-table-container"
	  }, [(this.itensCotacaoManual.length === 0) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('label', [_c('i', {
	    staticClass: "fa fa-bar-chart"
	  }), _vm._v("  Banco de Cotações:\n                ")]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [(!_vm.validandoCotacao) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.removerItem(row.item); },
	              cancel: _vm.doNothing,
	              message: 'Confirma Exclusão do Produto/Serviço: ' + row.item.descricao + ' ?'
	            }),
	            expression: "{ok: retorno => removerItem(row.item), cancel: doNothing,\n                              message: 'Confirma Exclusão do Produto/Serviço: ' + row.item.descricao + ' ?'}"
	          }],
	          attrs: {
	            "color": "error"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-close",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.detalharItem(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Detalhe ")])]
	      }
	    }, {
	      key: "descricao",
	      fn: function(row) {
	        return [_vm._v("\n                    #" + _vm._s(row.item.id) + " " + _vm._s(row.value) + "\n                ")]
	      }
	    }, {
	      key: "valorMedio",
	      fn: function(row) {
	        return [_vm._v("\n                    " + _vm._s(_vm._f("real")(row.value)) + "\n                ")]
	      }
	    }, {
	      key: "CV",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "row-flex all-centered gap-5",
	          class: row.value > 25 ? 'cv-atencao' : 'cv-ok'
	        }, [_c('i', {
	          staticClass: "fa",
	          class: row.value > 25 ? 'fa-exclamation-circle' : 'fa-thumbs-up'
	        }), _vm._v(" " + _vm._s(row.value) + "%\n                  ")])]
	      }
	    }], null, false, 3674501315)
	  })], 1) : _vm._e(), _vm._v(" "), (this.itensCotacao.length === 0) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('label', [_c('i', {
	    staticClass: "fa fa-bar-chart"
	  }), _vm._v("  Orçamento Manual:\n                ")]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableManual.bordered,
	      "items": _vm.tableManual.items,
	      "hover": _vm.tableManual.hover,
	      "fields": _vm.tableManual.fields,
	      "filter": _vm.tableManual.filter,
	      "current-page": _vm.tableManual.currentPage,
	      "per-page": _vm.tableManual.perPage,
	      "sort-by": _vm.tableManual.sortBy,
	      "sort-desc": _vm.tableManual.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableManual, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableManual, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableManual, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableManual, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [(!_vm.validandoCotacao) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "error"
	          },
	          nativeOn: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Confirma Exclusão do Produto/Serviço: ' + row.item.descricao + ' ?', function () { return _vm.removerItem(row.item, true); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-close",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.detalharItemManual(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Detalhe ")])]
	      }
	    }, {
	      key: "descricao",
	      fn: function(row) {
	        return [_vm._v("\n                    #" + _vm._s(row.item.id) + " " + _vm._s(row.value) + "\n                ")]
	      }
	    }, {
	      key: "valorMedio",
	      fn: function(row) {
	        return [_vm._v("\n                    " + _vm._s(_vm._f("real")(row.value)) + "\n                ")]
	      }
	    }], null, false, 2745685335)
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered cotacao-status-container"
	  }, [(_vm.itemCotacaoResponsavelValidacao !== '' && !_vm._.isNull(_vm.itemCotacaoResponsavelValidacao)) ? _c('div', [_vm._v("\n              Responsável: "), _c('b', [_vm._v(_vm._s(_vm.itemCotacaoResponsavelValidacao))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-between resumo-container"
	  }, [_c('b', [_vm._v("Total:")]), _vm._v("  " + _vm._s(_vm._f("real")(_vm.totalItens)) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start w-100 gap-5 button-cotacao-container"
	  }, [(!_vm.validandoCotacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarCotacao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar Cotação ")]) : _vm._e(), _vm._v(" "), (_vm.validandoCotacao && !_vm.itemCotacaoValidado && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.telaProjeto) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.validarCotacao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Validar Cotação ")]) : _vm._e(), _vm._v(" "), (_vm.validandoCotacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Fechar ")]) : _vm._e(), _vm._v(" "), (!_vm.validandoCotacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "error"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.abrirCotacaoPrecos) ? _c('div', {
	    staticClass: "box-body column centered-start cotacao-itens-container"
	  }, [_c('cotacaoPrecos', {
	    attrs: {
	      "toggleAdicionarItem": _vm.toggleAdicionarItem,
	      "adicionarItem": _vm.adicionarItem
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.abrirCotacaoManual) ? _c('div', {
	    staticClass: "box-body column centered-start cotacao-itens-container"
	  }, [_c('cotacaoManual', {
	    attrs: {
	      "toggleCotacaoManual": _vm.toggleCotacaoManual,
	      "adicionarItemManual": _vm.adicionarItemManual,
	      "visualizacao": _vm.visualizacaoManual,
	      "itemVisualizacao": _vm.itemSelecionadoDetalhe
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.abrirDetalheItem) ? _c('div', {
	    staticClass: "box-body column centered-start cotacao-itens-container"
	  }, [_c('detalheItemCotacao', {
	    attrs: {
	      "itemCotacao": _vm.itemSelecionadoDetalhe,
	      "toggleDetalharItem": _vm.toggleDetalharItem
	    }
	  })], 1) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', [_c('i', {
	    staticClass: "fa fa-cubes"
	  }), _vm._v(" Itens cadastrados para cotação")]), _vm._v(" "), _c('div', [_vm._v("\n            *Caso o produto ou serviço tenha mais de um item contido nele, ex: '"), _c('i', [_vm._v("P1115/Ferramentas (pode ter uma furadeira, uma parafusadeira, etc.)")]), _vm._v("'\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-label"
	  }, [_c('i', {
	    staticClass: "fa fa-send"
	  }), _vm._v(" Descrição da Cotação:")])
	}]}

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Icons\n      "), _c('small', [_vm._v("a set of beautiful icons")])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Icons")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "nav-tabs-custom"
	  }, [_c('ul', {
	    staticClass: "nav nav-tabs"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#fa-icons",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Font Awesome")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#glyphicons",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Glyphicons")])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "fa-icons"
	    }
	  }, [_c('section', {
	    attrs: {
	      "id": "new"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("66 New Icons in 4.4")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-500px"
	  }), _vm._v(" fa-500px")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-amazon"
	  }), _vm._v(" fa-amazon")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-balance-scale"
	  }), _vm._v(" fa-balance-scale")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-0"
	  }), _vm._v(" fa-battery-0\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-1"
	  }), _vm._v(" fa-battery-1\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-2"
	  }), _vm._v(" fa-battery-2\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-3"
	  }), _vm._v(" fa-battery-3\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-4"
	  }), _vm._v(" fa-battery-4\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-empty"
	  }), _vm._v(" fa-battery-empty")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-full"
	  }), _vm._v(" fa-battery-full")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-half"
	  }), _vm._v(" fa-battery-half")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-quarter"
	  }), _vm._v(" fa-battery-quarter")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-three-quarters"
	  }), _vm._v("\n                    fa-battery-three-quarters\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-black-tie"
	  }), _vm._v(" fa-black-tie")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-check-o"
	  }), _vm._v(" fa-calendar-check-o\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-minus-o"
	  }), _vm._v(" fa-calendar-minus-o\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-plus-o"
	  }), _vm._v(" fa-calendar-plus-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-times-o"
	  }), _vm._v(" fa-calendar-times-o\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-diners-club"
	  }), _vm._v(" fa-cc-diners-club")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-jcb"
	  }), _vm._v(" fa-cc-jcb")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chrome"
	  }), _vm._v(" fa-chrome")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-clone"
	  }), _vm._v(" fa-clone")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-commenting"
	  }), _vm._v(" fa-commenting")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-commenting-o"
	  }), _vm._v(" fa-commenting-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-contao"
	  }), _vm._v(" fa-contao")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-creative-commons"
	  }), _vm._v(" fa-creative-commons\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-expeditedssl"
	  }), _vm._v(" fa-expeditedssl")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-firefox"
	  }), _vm._v(" fa-firefox")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fonticons"
	  }), _vm._v(" fa-fonticons")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-genderless"
	  }), _vm._v(" fa-genderless")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-get-pocket"
	  }), _vm._v(" fa-get-pocket")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gg"
	  }), _vm._v(" fa-gg")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gg-circle"
	  }), _vm._v(" fa-gg-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-grab-o"
	  }), _vm._v(" fa-hand-grab-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-lizard-o"
	  }), _vm._v(" fa-hand-lizard-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-paper-o"
	  }), _vm._v(" fa-hand-paper-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-peace-o"
	  }), _vm._v(" fa-hand-peace-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-pointer-o"
	  }), _vm._v(" fa-hand-pointer-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-rock-o"
	  }), _vm._v(" fa-hand-rock-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-scissors-o"
	  }), _vm._v(" fa-hand-scissors-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-spock-o"
	  }), _vm._v(" fa-hand-spock-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-stop-o"
	  }), _vm._v(" fa-hand-stop-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass"
	  }), _vm._v(" fa-hourglass")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-1"
	  }), _vm._v(" fa-hourglass-1\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-2"
	  }), _vm._v(" fa-hourglass-2\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-3"
	  }), _vm._v(" fa-hourglass-3\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-end"
	  }), _vm._v(" fa-hourglass-end")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-half"
	  }), _vm._v(" fa-hourglass-half")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-o"
	  }), _vm._v(" fa-hourglass-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-start"
	  }), _vm._v(" fa-hourglass-start")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-houzz"
	  }), _vm._v(" fa-houzz")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-i-cursor"
	  }), _vm._v(" fa-i-cursor")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-industry"
	  }), _vm._v(" fa-industry")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-internet-explorer"
	  }), _vm._v(" fa-internet-explorer\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map"
	  }), _vm._v(" fa-map")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map-o"
	  }), _vm._v(" fa-map-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map-pin"
	  }), _vm._v(" fa-map-pin")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map-signs"
	  }), _vm._v(" fa-map-signs")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mouse-pointer"
	  }), _vm._v(" fa-mouse-pointer")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-object-group"
	  }), _vm._v(" fa-object-group")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-object-ungroup"
	  }), _vm._v(" fa-object-ungroup")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-odnoklassniki"
	  }), _vm._v(" fa-odnoklassniki")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-odnoklassniki-square"
	  }), _vm._v("\n                    fa-odnoklassniki-square\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-opencart"
	  }), _vm._v(" fa-opencart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-opera"
	  }), _vm._v(" fa-opera")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-optin-monster"
	  }), _vm._v(" fa-optin-monster")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-registered"
	  }), _vm._v(" fa-registered")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-safari"
	  }), _vm._v(" fa-safari")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sticky-note"
	  }), _vm._v(" fa-sticky-note")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sticky-note-o"
	  }), _vm._v(" fa-sticky-note-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-television"
	  }), _vm._v(" fa-television")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-trademark"
	  }), _vm._v(" fa-trademark")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tripadvisor"
	  }), _vm._v(" fa-tripadvisor")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tv"
	  }), _vm._v(" fa-tv\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-vimeo"
	  }), _vm._v(" fa-vimeo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wikipedia-w"
	  }), _vm._v(" fa-wikipedia-w")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-y-combinator"
	  }), _vm._v(" fa-y-combinator")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-yc"
	  }), _vm._v(" fa-yc\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "web-application"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Web Application Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-adjust"
	  }), _vm._v(" fa-adjust")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-anchor"
	  }), _vm._v(" fa-anchor")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-archive"
	  }), _vm._v(" fa-archive")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-area-chart"
	  }), _vm._v(" fa-area-chart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrows"
	  }), _vm._v(" fa-arrows")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrows-h"
	  }), _vm._v(" fa-arrows-h")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrows-v"
	  }), _vm._v(" fa-arrows-v")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-asterisk"
	  }), _vm._v(" fa-asterisk")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-at"
	  }), _vm._v(" fa-at")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-automobile"
	  }), _vm._v(" fa-automobile\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-balance-scale"
	  }), _vm._v(" fa-balance-scale")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ban"
	  }), _vm._v(" fa-ban")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bank"
	  }), _vm._v(" fa-bank "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bar-chart"
	  }), _vm._v(" fa-bar-chart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bar-chart-o"
	  }), _vm._v(" fa-bar-chart-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-barcode"
	  }), _vm._v(" fa-barcode")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bars"
	  }), _vm._v(" fa-bars")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-0"
	  }), _vm._v(" fa-battery-0\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-1"
	  }), _vm._v(" fa-battery-1\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-2"
	  }), _vm._v(" fa-battery-2\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-3"
	  }), _vm._v(" fa-battery-3\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-4"
	  }), _vm._v(" fa-battery-4\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-empty"
	  }), _vm._v(" fa-battery-empty")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-full"
	  }), _vm._v(" fa-battery-full")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-half"
	  }), _vm._v(" fa-battery-half")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-quarter"
	  }), _vm._v(" fa-battery-quarter")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-battery-three-quarters"
	  }), _vm._v("\n                    fa-battery-three-quarters\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bed"
	  }), _vm._v(" fa-bed")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-beer"
	  }), _vm._v(" fa-beer")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bell"
	  }), _vm._v(" fa-bell")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bell-o"
	  }), _vm._v(" fa-bell-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bell-slash"
	  }), _vm._v(" fa-bell-slash")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bell-slash-o"
	  }), _vm._v(" fa-bell-slash-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bicycle"
	  }), _vm._v(" fa-bicycle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-binoculars"
	  }), _vm._v(" fa-binoculars")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-birthday-cake"
	  }), _vm._v(" fa-birthday-cake")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bolt"
	  }), _vm._v(" fa-bolt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bomb"
	  }), _vm._v(" fa-bomb")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-book"
	  }), _vm._v(" fa-book")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bookmark"
	  }), _vm._v(" fa-bookmark")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bookmark-o"
	  }), _vm._v(" fa-bookmark-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-briefcase"
	  }), _vm._v(" fa-briefcase")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bug"
	  }), _vm._v(" fa-bug")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-building"
	  }), _vm._v(" fa-building")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-building-o"
	  }), _vm._v(" fa-building-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bullhorn"
	  }), _vm._v(" fa-bullhorn")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bullseye"
	  }), _vm._v(" fa-bullseye")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bus"
	  }), _vm._v(" fa-bus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cab"
	  }), _vm._v(" fa-cab "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calculator"
	  }), _vm._v(" fa-calculator")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar"
	  }), _vm._v(" fa-calendar")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-check-o"
	  }), _vm._v(" fa-calendar-check-o\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-minus-o"
	  }), _vm._v(" fa-calendar-minus-o\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-o"
	  }), _vm._v(" fa-calendar-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-plus-o"
	  }), _vm._v(" fa-calendar-plus-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-calendar-times-o"
	  }), _vm._v(" fa-calendar-times-o\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-camera"
	  }), _vm._v(" fa-camera")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-camera-retro"
	  }), _vm._v(" fa-camera-retro")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-car"
	  }), _vm._v(" fa-car")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-square-o-down"
	  }), _vm._v("\n                    fa-caret-square-o-down\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-square-o-left"
	  }), _vm._v("\n                    fa-caret-square-o-left\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-square-o-right"
	  }), _vm._v("\n                    fa-caret-square-o-right\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-square-o-up"
	  }), _vm._v(" fa-caret-square-o-up\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cart-arrow-down"
	  }), _vm._v(" fa-cart-arrow-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cart-plus"
	  }), _vm._v(" fa-cart-plus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc"
	  }), _vm._v(" fa-cc")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-certificate"
	  }), _vm._v(" fa-certificate")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-check"
	  }), _vm._v(" fa-check")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-check-circle"
	  }), _vm._v(" fa-check-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-check-circle-o"
	  }), _vm._v(" fa-check-circle-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-check-square"
	  }), _vm._v(" fa-check-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-check-square-o"
	  }), _vm._v(" fa-check-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-child"
	  }), _vm._v(" fa-child")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-circle"
	  }), _vm._v(" fa-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-circle-o"
	  }), _vm._v(" fa-circle-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-circle-o-notch"
	  }), _vm._v(" fa-circle-o-notch")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-circle-thin"
	  }), _vm._v(" fa-circle-thin")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-clock-o"
	  }), _vm._v(" fa-clock-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-clone"
	  }), _vm._v(" fa-clone")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-close"
	  }), _vm._v(" fa-close "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cloud"
	  }), _vm._v(" fa-cloud")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cloud-download"
	  }), _vm._v(" fa-cloud-download")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cloud-upload"
	  }), _vm._v(" fa-cloud-upload")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-code"
	  }), _vm._v(" fa-code")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-code-fork"
	  }), _vm._v(" fa-code-fork")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-coffee"
	  }), _vm._v(" fa-coffee")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cog"
	  }), _vm._v(" fa-cog")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cogs"
	  }), _vm._v(" fa-cogs")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-comment"
	  }), _vm._v(" fa-comment")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-comment-o"
	  }), _vm._v(" fa-comment-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-commenting"
	  }), _vm._v(" fa-commenting")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-commenting-o"
	  }), _vm._v(" fa-commenting-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-comments"
	  }), _vm._v(" fa-comments")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-comments-o"
	  }), _vm._v(" fa-comments-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-compass"
	  }), _vm._v(" fa-compass")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-copyright"
	  }), _vm._v(" fa-copyright")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-creative-commons"
	  }), _vm._v(" fa-creative-commons\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-credit-card"
	  }), _vm._v(" fa-credit-card")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-crop"
	  }), _vm._v(" fa-crop")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-crosshairs"
	  }), _vm._v(" fa-crosshairs")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cube"
	  }), _vm._v(" fa-cube")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cubes"
	  }), _vm._v(" fa-cubes")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cutlery"
	  }), _vm._v(" fa-cutlery")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-dashboard"
	  }), _vm._v(" fa-dashboard\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-database"
	  }), _vm._v(" fa-database")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-desktop"
	  }), _vm._v(" fa-desktop")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-diamond"
	  }), _vm._v(" fa-diamond")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-dot-circle-o"
	  }), _vm._v(" fa-dot-circle-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-download"
	  }), _vm._v(" fa-download")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-edit"
	  }), _vm._v(" fa-edit "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ellipsis-h"
	  }), _vm._v(" fa-ellipsis-h")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ellipsis-v"
	  }), _vm._v(" fa-ellipsis-v")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-envelope"
	  }), _vm._v(" fa-envelope")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-envelope-o"
	  }), _vm._v(" fa-envelope-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-envelope-square"
	  }), _vm._v(" fa-envelope-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-eraser"
	  }), _vm._v(" fa-eraser")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-exchange"
	  }), _vm._v(" fa-exchange")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-exclamation"
	  }), _vm._v(" fa-exclamation")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-exclamation-circle"
	  }), _vm._v(" fa-exclamation-circle\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-exclamation-triangle"
	  }), _vm._v("\n                    fa-exclamation-triangle\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-external-link"
	  }), _vm._v(" fa-external-link")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-external-link-square"
	  }), _vm._v("\n                    fa-external-link-square\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-eye"
	  }), _vm._v(" fa-eye")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-eye-slash"
	  }), _vm._v(" fa-eye-slash")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-eyedropper"
	  }), _vm._v(" fa-eyedropper")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fax"
	  }), _vm._v(" fa-fax")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-feed"
	  }), _vm._v(" fa-feed "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-female"
	  }), _vm._v(" fa-female")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fighter-jet"
	  }), _vm._v(" fa-fighter-jet")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-archive-o"
	  }), _vm._v(" fa-file-archive-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-audio-o"
	  }), _vm._v(" fa-file-audio-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-code-o"
	  }), _vm._v(" fa-file-code-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-excel-o"
	  }), _vm._v(" fa-file-excel-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-image-o"
	  }), _vm._v(" fa-file-image-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-movie-o"
	  }), _vm._v(" fa-file-movie-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-pdf-o"
	  }), _vm._v(" fa-file-pdf-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-photo-o"
	  }), _vm._v(" fa-file-photo-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-picture-o"
	  }), _vm._v(" fa-file-picture-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-powerpoint-o"
	  }), _vm._v(" fa-file-powerpoint-o\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-sound-o"
	  }), _vm._v(" fa-file-sound-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-video-o"
	  }), _vm._v(" fa-file-video-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-word-o"
	  }), _vm._v(" fa-file-word-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-zip-o"
	  }), _vm._v(" fa-file-zip-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-film"
	  }), _vm._v(" fa-film")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-filter"
	  }), _vm._v(" fa-filter")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fire"
	  }), _vm._v(" fa-fire")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fire-extinguisher"
	  }), _vm._v(" fa-fire-extinguisher\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-flag"
	  }), _vm._v(" fa-flag")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-flag-checkered"
	  }), _vm._v(" fa-flag-checkered")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-flag-o"
	  }), _vm._v(" fa-flag-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-flash"
	  }), _vm._v(" fa-flash "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-flask"
	  }), _vm._v(" fa-flask")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-folder"
	  }), _vm._v(" fa-folder")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-folder-o"
	  }), _vm._v(" fa-folder-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-folder-open"
	  }), _vm._v(" fa-folder-open")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-folder-open-o"
	  }), _vm._v(" fa-folder-open-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-frown-o"
	  }), _vm._v(" fa-frown-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-futbol-o"
	  }), _vm._v(" fa-futbol-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gamepad"
	  }), _vm._v(" fa-gamepad")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gavel"
	  }), _vm._v(" fa-gavel")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gear"
	  }), _vm._v(" fa-gear "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gears"
	  }), _vm._v(" fa-gears "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gift"
	  }), _vm._v(" fa-gift")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-glass"
	  }), _vm._v(" fa-glass")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-globe"
	  }), _vm._v(" fa-globe")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-graduation-cap"
	  }), _vm._v(" fa-graduation-cap")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-group"
	  }), _vm._v(" fa-group "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-grab-o"
	  }), _vm._v(" fa-hand-grab-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-lizard-o"
	  }), _vm._v(" fa-hand-lizard-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-paper-o"
	  }), _vm._v(" fa-hand-paper-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-peace-o"
	  }), _vm._v(" fa-hand-peace-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-pointer-o"
	  }), _vm._v(" fa-hand-pointer-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-rock-o"
	  }), _vm._v(" fa-hand-rock-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-scissors-o"
	  }), _vm._v(" fa-hand-scissors-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-spock-o"
	  }), _vm._v(" fa-hand-spock-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-stop-o"
	  }), _vm._v(" fa-hand-stop-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hdd-o"
	  }), _vm._v(" fa-hdd-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-headphones"
	  }), _vm._v(" fa-headphones")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-heart"
	  }), _vm._v(" fa-heart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-heart-o"
	  }), _vm._v(" fa-heart-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-heartbeat"
	  }), _vm._v(" fa-heartbeat")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-history"
	  }), _vm._v(" fa-history")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-home"
	  }), _vm._v(" fa-home")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hotel"
	  }), _vm._v(" fa-hotel "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass"
	  }), _vm._v(" fa-hourglass")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-1"
	  }), _vm._v(" fa-hourglass-1\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-2"
	  }), _vm._v(" fa-hourglass-2\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-3"
	  }), _vm._v(" fa-hourglass-3\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-end"
	  }), _vm._v(" fa-hourglass-end")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-half"
	  }), _vm._v(" fa-hourglass-half")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-o"
	  }), _vm._v(" fa-hourglass-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hourglass-start"
	  }), _vm._v(" fa-hourglass-start")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-i-cursor"
	  }), _vm._v(" fa-i-cursor")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-image"
	  }), _vm._v(" fa-image "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-inbox"
	  }), _vm._v(" fa-inbox")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-industry"
	  }), _vm._v(" fa-industry")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-info"
	  }), _vm._v(" fa-info")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-info-circle"
	  }), _vm._v(" fa-info-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-institution"
	  }), _vm._v(" fa-institution\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-key"
	  }), _vm._v(" fa-key")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-keyboard-o"
	  }), _vm._v(" fa-keyboard-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-language"
	  }), _vm._v(" fa-language")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-laptop"
	  }), _vm._v(" fa-laptop")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-leaf"
	  }), _vm._v(" fa-leaf")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-legal"
	  }), _vm._v(" fa-legal "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-lemon-o"
	  }), _vm._v(" fa-lemon-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-level-down"
	  }), _vm._v(" fa-level-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-level-up"
	  }), _vm._v(" fa-level-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-life-bouy"
	  }), _vm._v(" fa-life-bouy\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-life-buoy"
	  }), _vm._v(" fa-life-buoy\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-life-ring"
	  }), _vm._v(" fa-life-ring")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-life-saver"
	  }), _vm._v(" fa-life-saver\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-lightbulb-o"
	  }), _vm._v(" fa-lightbulb-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-line-chart"
	  }), _vm._v(" fa-line-chart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-location-arrow"
	  }), _vm._v(" fa-location-arrow")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-lock"
	  }), _vm._v(" fa-lock")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-magic"
	  }), _vm._v(" fa-magic")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-magnet"
	  }), _vm._v(" fa-magnet")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mail-forward"
	  }), _vm._v(" fa-mail-forward\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mail-reply"
	  }), _vm._v(" fa-mail-reply\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mail-reply-all"
	  }), _vm._v(" fa-mail-reply-all\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-male"
	  }), _vm._v(" fa-male")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map"
	  }), _vm._v(" fa-map")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map-marker"
	  }), _vm._v(" fa-map-marker")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map-o"
	  }), _vm._v(" fa-map-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map-pin"
	  }), _vm._v(" fa-map-pin")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-map-signs"
	  }), _vm._v(" fa-map-signs")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-meh-o"
	  }), _vm._v(" fa-meh-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-microphone"
	  }), _vm._v(" fa-microphone")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-microphone-slash"
	  }), _vm._v(" fa-microphone-slash\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-minus"
	  }), _vm._v(" fa-minus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-minus-circle"
	  }), _vm._v(" fa-minus-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-minus-square"
	  }), _vm._v(" fa-minus-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-minus-square-o"
	  }), _vm._v(" fa-minus-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mobile"
	  }), _vm._v(" fa-mobile")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mobile-phone"
	  }), _vm._v(" fa-mobile-phone\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-money"
	  }), _vm._v(" fa-money")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-moon-o"
	  }), _vm._v(" fa-moon-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mortar-board"
	  }), _vm._v(" fa-mortar-board\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-motorcycle"
	  }), _vm._v(" fa-motorcycle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mouse-pointer"
	  }), _vm._v(" fa-mouse-pointer")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-music"
	  }), _vm._v(" fa-music")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-navicon"
	  }), _vm._v(" fa-navicon\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-newspaper-o"
	  }), _vm._v(" fa-newspaper-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-object-group"
	  }), _vm._v(" fa-object-group")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-object-ungroup"
	  }), _vm._v(" fa-object-ungroup")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paint-brush"
	  }), _vm._v(" fa-paint-brush")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paper-plane"
	  }), _vm._v(" fa-paper-plane")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paper-plane-o"
	  }), _vm._v(" fa-paper-plane-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paw"
	  }), _vm._v(" fa-paw")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pencil"
	  }), _vm._v(" fa-pencil")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pencil-square"
	  }), _vm._v(" fa-pencil-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pencil-square-o"
	  }), _vm._v(" fa-pencil-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-phone"
	  }), _vm._v(" fa-phone")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-phone-square"
	  }), _vm._v(" fa-phone-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-photo"
	  }), _vm._v(" fa-photo "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-picture-o"
	  }), _vm._v(" fa-picture-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pie-chart"
	  }), _vm._v(" fa-pie-chart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plane"
	  }), _vm._v(" fa-plane")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plug"
	  }), _vm._v(" fa-plug")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plus"
	  }), _vm._v(" fa-plus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plus-circle"
	  }), _vm._v(" fa-plus-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plus-square"
	  }), _vm._v(" fa-plus-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plus-square-o"
	  }), _vm._v(" fa-plus-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-power-off"
	  }), _vm._v(" fa-power-off")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-print"
	  }), _vm._v(" fa-print")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-puzzle-piece"
	  }), _vm._v(" fa-puzzle-piece")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-qrcode"
	  }), _vm._v(" fa-qrcode")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-question"
	  }), _vm._v(" fa-question")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-question-circle"
	  }), _vm._v(" fa-question-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-quote-left"
	  }), _vm._v(" fa-quote-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-quote-right"
	  }), _vm._v(" fa-quote-right")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-random"
	  }), _vm._v(" fa-random")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-recycle"
	  }), _vm._v(" fa-recycle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-refresh"
	  }), _vm._v(" fa-refresh")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-registered"
	  }), _vm._v(" fa-registered")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-remove"
	  }), _vm._v(" fa-remove\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-reorder"
	  }), _vm._v(" fa-reorder\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-reply"
	  }), _vm._v(" fa-reply")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-reply-all"
	  }), _vm._v(" fa-reply-all")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-retweet"
	  }), _vm._v(" fa-retweet")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-road"
	  }), _vm._v(" fa-road")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rocket"
	  }), _vm._v(" fa-rocket")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rss"
	  }), _vm._v(" fa-rss")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rss-square"
	  }), _vm._v(" fa-rss-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-search"
	  }), _vm._v(" fa-search")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-search-minus"
	  }), _vm._v(" fa-search-minus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-search-plus"
	  }), _vm._v(" fa-search-plus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-send"
	  }), _vm._v(" fa-send "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-send-o"
	  }), _vm._v(" fa-send-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-server"
	  }), _vm._v(" fa-server")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-share"
	  }), _vm._v(" fa-share")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-share-alt"
	  }), _vm._v(" fa-share-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-share-alt-square"
	  }), _vm._v(" fa-share-alt-square\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-share-square"
	  }), _vm._v(" fa-share-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-share-square-o"
	  }), _vm._v(" fa-share-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-shield"
	  }), _vm._v(" fa-shield")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ship"
	  }), _vm._v(" fa-ship")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-shopping-cart"
	  }), _vm._v(" fa-shopping-cart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sign-in"
	  }), _vm._v(" fa-sign-in")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sign-out"
	  }), _vm._v(" fa-sign-out")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-signal"
	  }), _vm._v(" fa-signal")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sitemap"
	  }), _vm._v(" fa-sitemap")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sliders"
	  }), _vm._v(" fa-sliders")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-smile-o"
	  }), _vm._v(" fa-smile-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-soccer-ball-o"
	  }), _vm._v(" fa-soccer-ball-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort"
	  }), _vm._v(" fa-sort")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-alpha-asc"
	  }), _vm._v(" fa-sort-alpha-asc")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-alpha-desc"
	  }), _vm._v(" fa-sort-alpha-desc")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-amount-asc"
	  }), _vm._v(" fa-sort-amount-asc")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-amount-desc"
	  }), _vm._v(" fa-sort-amount-desc\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-asc"
	  }), _vm._v(" fa-sort-asc")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-desc"
	  }), _vm._v(" fa-sort-desc")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-down"
	  }), _vm._v(" fa-sort-down\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-numeric-asc"
	  }), _vm._v(" fa-sort-numeric-asc\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-numeric-desc"
	  }), _vm._v(" fa-sort-numeric-desc\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sort-up"
	  }), _vm._v(" fa-sort-up\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-space-shuttle"
	  }), _vm._v(" fa-space-shuttle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-spinner"
	  }), _vm._v(" fa-spinner")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-spoon"
	  }), _vm._v(" fa-spoon")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-square"
	  }), _vm._v(" fa-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-square-o"
	  }), _vm._v(" fa-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-star"
	  }), _vm._v(" fa-star")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-star-half"
	  }), _vm._v(" fa-star-half")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-star-half-empty"
	  }), _vm._v(" fa-star-half-empty\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-star-half-full"
	  }), _vm._v(" fa-star-half-full\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-star-half-o"
	  }), _vm._v(" fa-star-half-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-star-o"
	  }), _vm._v(" fa-star-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sticky-note"
	  }), _vm._v(" fa-sticky-note")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sticky-note-o"
	  }), _vm._v(" fa-sticky-note-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-street-view"
	  }), _vm._v(" fa-street-view")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-suitcase"
	  }), _vm._v(" fa-suitcase")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sun-o"
	  }), _vm._v(" fa-sun-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-support"
	  }), _vm._v(" fa-support\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tablet"
	  }), _vm._v(" fa-tablet")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tachometer"
	  }), _vm._v(" fa-tachometer")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tag"
	  }), _vm._v(" fa-tag")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tags"
	  }), _vm._v(" fa-tags")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tasks"
	  }), _vm._v(" fa-tasks")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-taxi"
	  }), _vm._v(" fa-taxi")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-television"
	  }), _vm._v(" fa-television")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-terminal"
	  }), _vm._v(" fa-terminal")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumb-tack"
	  }), _vm._v(" fa-thumb-tack")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumbs-down"
	  }), _vm._v(" fa-thumbs-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumbs-o-down"
	  }), _vm._v(" fa-thumbs-o-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumbs-o-up"
	  }), _vm._v(" fa-thumbs-o-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumbs-up"
	  }), _vm._v(" fa-thumbs-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ticket"
	  }), _vm._v(" fa-ticket")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-times"
	  }), _vm._v(" fa-times")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-times-circle"
	  }), _vm._v(" fa-times-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-times-circle-o"
	  }), _vm._v(" fa-times-circle-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tint"
	  }), _vm._v(" fa-tint")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-down"
	  }), _vm._v(" fa-toggle-down\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-left"
	  }), _vm._v(" fa-toggle-left\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-off"
	  }), _vm._v(" fa-toggle-off")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-on"
	  }), _vm._v(" fa-toggle-on")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-right"
	  }), _vm._v(" fa-toggle-right\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-up"
	  }), _vm._v(" fa-toggle-up\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-trademark"
	  }), _vm._v(" fa-trademark")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-trash"
	  }), _vm._v(" fa-trash")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-trash-o"
	  }), _vm._v(" fa-trash-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tree"
	  }), _vm._v(" fa-tree")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-trophy"
	  }), _vm._v(" fa-trophy")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-truck"
	  }), _vm._v(" fa-truck")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tty"
	  }), _vm._v(" fa-tty")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tv"
	  }), _vm._v(" fa-tv\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-umbrella"
	  }), _vm._v(" fa-umbrella")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-university"
	  }), _vm._v(" fa-university")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-unlock"
	  }), _vm._v(" fa-unlock")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-unlock-alt"
	  }), _vm._v(" fa-unlock-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-unsorted"
	  }), _vm._v(" fa-unsorted\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-upload"
	  }), _vm._v(" fa-upload")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-user"
	  }), _vm._v(" fa-user")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-user-plus"
	  }), _vm._v(" fa-user-plus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-user-secret"
	  }), _vm._v(" fa-user-secret")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-user-times"
	  }), _vm._v(" fa-user-times")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-users"
	  }), _vm._v(" fa-users")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-video-camera"
	  }), _vm._v(" fa-video-camera")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-volume-down"
	  }), _vm._v(" fa-volume-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-volume-off"
	  }), _vm._v(" fa-volume-off")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-volume-up"
	  }), _vm._v(" fa-volume-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-warning"
	  }), _vm._v(" fa-warning\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wheelchair"
	  }), _vm._v(" fa-wheelchair")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wifi"
	  }), _vm._v(" fa-wifi")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wrench"
	  }), _vm._v(" fa-wrench")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "hand"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Hand Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-grab-o"
	  }), _vm._v(" fa-hand-grab-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-lizard-o"
	  }), _vm._v(" fa-hand-lizard-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-o-down"
	  }), _vm._v(" fa-hand-o-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-o-left"
	  }), _vm._v(" fa-hand-o-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-o-right"
	  }), _vm._v(" fa-hand-o-right")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-o-up"
	  }), _vm._v(" fa-hand-o-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-paper-o"
	  }), _vm._v(" fa-hand-paper-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-peace-o"
	  }), _vm._v(" fa-hand-peace-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-pointer-o"
	  }), _vm._v(" fa-hand-pointer-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-rock-o"
	  }), _vm._v(" fa-hand-rock-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-scissors-o"
	  }), _vm._v(" fa-hand-scissors-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-spock-o"
	  }), _vm._v(" fa-hand-spock-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-stop-o"
	  }), _vm._v(" fa-hand-stop-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumbs-down"
	  }), _vm._v(" fa-thumbs-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumbs-o-down"
	  }), _vm._v(" fa-thumbs-o-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumbs-o-up"
	  }), _vm._v(" fa-thumbs-o-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-thumbs-up"
	  }), _vm._v(" fa-thumbs-up")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "transportation"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Transportation Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ambulance"
	  }), _vm._v(" fa-ambulance")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-automobile"
	  }), _vm._v(" fa-automobile\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bicycle"
	  }), _vm._v(" fa-bicycle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bus"
	  }), _vm._v(" fa-bus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cab"
	  }), _vm._v(" fa-cab "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-car"
	  }), _vm._v(" fa-car")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fighter-jet"
	  }), _vm._v(" fa-fighter-jet")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-motorcycle"
	  }), _vm._v(" fa-motorcycle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plane"
	  }), _vm._v(" fa-plane")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rocket"
	  }), _vm._v(" fa-rocket")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ship"
	  }), _vm._v(" fa-ship")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-space-shuttle"
	  }), _vm._v(" fa-space-shuttle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-subway"
	  }), _vm._v(" fa-subway")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-taxi"
	  }), _vm._v(" fa-taxi")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-train"
	  }), _vm._v(" fa-train")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-truck"
	  }), _vm._v(" fa-truck")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wheelchair"
	  }), _vm._v(" fa-wheelchair")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "gender"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Gender Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-genderless"
	  }), _vm._v(" fa-genderless")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-intersex"
	  }), _vm._v(" fa-intersex\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mars"
	  }), _vm._v(" fa-mars")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mars-double"
	  }), _vm._v(" fa-mars-double")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mars-stroke"
	  }), _vm._v(" fa-mars-stroke")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mars-stroke-h"
	  }), _vm._v(" fa-mars-stroke-h")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mars-stroke-v"
	  }), _vm._v(" fa-mars-stroke-v")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-mercury"
	  }), _vm._v(" fa-mercury")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-neuter"
	  }), _vm._v(" fa-neuter")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-transgender"
	  }), _vm._v(" fa-transgender")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-transgender-alt"
	  }), _vm._v(" fa-transgender-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-venus"
	  }), _vm._v(" fa-venus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-venus-double"
	  }), _vm._v(" fa-venus-double")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-venus-mars"
	  }), _vm._v(" fa-venus-mars")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "file-type"
	    }
	  }, [_c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("File Type Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file"
	  }), _vm._v(" fa-file")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-archive-o"
	  }), _vm._v(" fa-file-archive-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-audio-o"
	  }), _vm._v(" fa-file-audio-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-code-o"
	  }), _vm._v(" fa-file-code-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-excel-o"
	  }), _vm._v(" fa-file-excel-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-image-o"
	  }), _vm._v(" fa-file-image-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-movie-o"
	  }), _vm._v(" fa-file-movie-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-o"
	  }), _vm._v(" fa-file-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-pdf-o"
	  }), _vm._v(" fa-file-pdf-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-photo-o"
	  }), _vm._v(" fa-file-photo-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-picture-o"
	  }), _vm._v(" fa-file-picture-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-powerpoint-o"
	  }), _vm._v(" fa-file-powerpoint-o\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-sound-o"
	  }), _vm._v(" fa-file-sound-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-text"
	  }), _vm._v(" fa-file-text")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-text-o"
	  }), _vm._v(" fa-file-text-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-video-o"
	  }), _vm._v(" fa-file-video-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-word-o"
	  }), _vm._v(" fa-file-word-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-zip-o"
	  }), _vm._v(" fa-file-zip-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "spinner"
	    }
	  }, [_c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Spinner Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-circle-o-notch"
	  }), _vm._v(" fa-circle-o-notch")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cog"
	  }), _vm._v(" fa-cog")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gear"
	  }), _vm._v(" fa-gear "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-refresh"
	  }), _vm._v(" fa-refresh")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-spinner"
	  }), _vm._v(" fa-spinner")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "form-control"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Form Control Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-check-square"
	  }), _vm._v(" fa-check-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-check-square-o"
	  }), _vm._v(" fa-check-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-circle"
	  }), _vm._v(" fa-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-circle-o"
	  }), _vm._v(" fa-circle-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-dot-circle-o"
	  }), _vm._v(" fa-dot-circle-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-minus-square"
	  }), _vm._v(" fa-minus-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-minus-square-o"
	  }), _vm._v(" fa-minus-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plus-square"
	  }), _vm._v(" fa-plus-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plus-square-o"
	  }), _vm._v(" fa-plus-square-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-square"
	  }), _vm._v(" fa-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-square-o"
	  }), _vm._v(" fa-square-o")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "payment"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Payment Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-amex"
	  }), _vm._v(" fa-cc-amex")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-diners-club"
	  }), _vm._v(" fa-cc-diners-club")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-discover"
	  }), _vm._v(" fa-cc-discover")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-jcb"
	  }), _vm._v(" fa-cc-jcb")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-mastercard"
	  }), _vm._v(" fa-cc-mastercard")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-paypal"
	  }), _vm._v(" fa-cc-paypal")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-stripe"
	  }), _vm._v(" fa-cc-stripe")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-visa"
	  }), _vm._v(" fa-cc-visa")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-credit-card"
	  }), _vm._v(" fa-credit-card")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-google-wallet"
	  }), _vm._v(" fa-google-wallet")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paypal"
	  }), _vm._v(" fa-paypal")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "chart"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Chart Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-area-chart"
	  }), _vm._v(" fa-area-chart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bar-chart"
	  }), _vm._v(" fa-bar-chart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bar-chart-o"
	  }), _vm._v(" fa-bar-chart-o\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-line-chart"
	  }), _vm._v(" fa-line-chart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pie-chart"
	  }), _vm._v(" fa-pie-chart")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "currency"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Currency Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bitcoin"
	  }), _vm._v(" fa-bitcoin\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btc"
	  }), _vm._v(" fa-btc")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cny"
	  }), _vm._v(" fa-cny "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-dollar"
	  }), _vm._v(" fa-dollar\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-eur"
	  }), _vm._v(" fa-eur")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-euro"
	  }), _vm._v(" fa-euro "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gbp"
	  }), _vm._v(" fa-gbp")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gg"
	  }), _vm._v(" fa-gg")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gg-circle"
	  }), _vm._v(" fa-gg-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ils"
	  }), _vm._v(" fa-ils")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-inr"
	  }), _vm._v(" fa-inr")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-jpy"
	  }), _vm._v(" fa-jpy")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-krw"
	  }), _vm._v(" fa-krw")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-money"
	  }), _vm._v(" fa-money")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rmb"
	  }), _vm._v(" fa-rmb "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rouble"
	  }), _vm._v(" fa-rouble\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rub"
	  }), _vm._v(" fa-rub")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ruble"
	  }), _vm._v(" fa-ruble "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rupee"
	  }), _vm._v(" fa-rupee "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-shekel"
	  }), _vm._v(" fa-shekel\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sheqel"
	  }), _vm._v(" fa-sheqel\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-try"
	  }), _vm._v(" fa-try")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-turkish-lira"
	  }), _vm._v(" fa-turkish-lira\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-usd"
	  }), _vm._v(" fa-usd")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-won"
	  }), _vm._v(" fa-won "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-yen"
	  }), _vm._v(" fa-yen "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "text-editor"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Text Editor Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-align-center"
	  }), _vm._v(" fa-align-center")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-align-justify"
	  }), _vm._v(" fa-align-justify")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-align-left"
	  }), _vm._v(" fa-align-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-align-right"
	  }), _vm._v(" fa-align-right")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bold"
	  }), _vm._v(" fa-bold")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chain"
	  }), _vm._v(" fa-chain "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chain-broken"
	  }), _vm._v(" fa-chain-broken")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-clipboard"
	  }), _vm._v(" fa-clipboard")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-columns"
	  }), _vm._v(" fa-columns")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-copy"
	  }), _vm._v(" fa-copy "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cut"
	  }), _vm._v(" fa-cut "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-dedent"
	  }), _vm._v(" fa-dedent\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-eraser"
	  }), _vm._v(" fa-eraser")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file"
	  }), _vm._v(" fa-file")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-o"
	  }), _vm._v(" fa-file-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-text"
	  }), _vm._v(" fa-file-text")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-file-text-o"
	  }), _vm._v(" fa-file-text-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-files-o"
	  }), _vm._v(" fa-files-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-floppy-o"
	  }), _vm._v(" fa-floppy-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-font"
	  }), _vm._v(" fa-font")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-header"
	  }), _vm._v(" fa-header")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-indent"
	  }), _vm._v(" fa-indent")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-italic"
	  }), _vm._v(" fa-italic")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-link"
	  }), _vm._v(" fa-link")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-list"
	  }), _vm._v(" fa-list")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-list-alt"
	  }), _vm._v(" fa-list-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-list-ol"
	  }), _vm._v(" fa-list-ol")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-list-ul"
	  }), _vm._v(" fa-list-ul")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-outdent"
	  }), _vm._v(" fa-outdent")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paperclip"
	  }), _vm._v(" fa-paperclip")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paragraph"
	  }), _vm._v(" fa-paragraph")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paste"
	  }), _vm._v(" fa-paste "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-repeat"
	  }), _vm._v(" fa-repeat")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rotate-left"
	  }), _vm._v(" fa-rotate-left\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rotate-right"
	  }), _vm._v(" fa-rotate-right\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-save"
	  }), _vm._v(" fa-save "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-scissors"
	  }), _vm._v(" fa-scissors")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-strikethrough"
	  }), _vm._v(" fa-strikethrough")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-subscript"
	  }), _vm._v(" fa-subscript")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-superscript"
	  }), _vm._v(" fa-superscript")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-table"
	  }), _vm._v(" fa-table")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-text-height"
	  }), _vm._v(" fa-text-height")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-text-width"
	  }), _vm._v(" fa-text-width")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-th"
	  }), _vm._v(" fa-th")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-th-large"
	  }), _vm._v(" fa-th-large")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-th-list"
	  }), _vm._v(" fa-th-list")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-underline"
	  }), _vm._v(" fa-underline")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-undo"
	  }), _vm._v(" fa-undo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-unlink"
	  }), _vm._v(" fa-unlink\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "directional"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Directional Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angle-double-down"
	  }), _vm._v(" fa-angle-double-down\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angle-double-left"
	  }), _vm._v(" fa-angle-double-left\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angle-double-right"
	  }), _vm._v(" fa-angle-double-right\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angle-double-up"
	  }), _vm._v(" fa-angle-double-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angle-down"
	  }), _vm._v(" fa-angle-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angle-left"
	  }), _vm._v(" fa-angle-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angle-right"
	  }), _vm._v(" fa-angle-right")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angle-up"
	  }), _vm._v(" fa-angle-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-circle-down"
	  }), _vm._v(" fa-arrow-circle-down\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-circle-left"
	  }), _vm._v(" fa-arrow-circle-left\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-circle-o-down"
	  }), _vm._v("\n                    fa-arrow-circle-o-down\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-circle-o-left"
	  }), _vm._v("\n                    fa-arrow-circle-o-left\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-circle-o-right"
	  }), _vm._v("\n                    fa-arrow-circle-o-right\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-circle-o-up"
	  }), _vm._v(" fa-arrow-circle-o-up\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-circle-right"
	  }), _vm._v(" fa-arrow-circle-right\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-circle-up"
	  }), _vm._v(" fa-arrow-circle-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-down"
	  }), _vm._v(" fa-arrow-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-left"
	  }), _vm._v(" fa-arrow-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-right"
	  }), _vm._v(" fa-arrow-right")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrow-up"
	  }), _vm._v(" fa-arrow-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrows"
	  }), _vm._v(" fa-arrows")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrows-alt"
	  }), _vm._v(" fa-arrows-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrows-h"
	  }), _vm._v(" fa-arrows-h")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrows-v"
	  }), _vm._v(" fa-arrows-v")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-down"
	  }), _vm._v(" fa-caret-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-left"
	  }), _vm._v(" fa-caret-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-right"
	  }), _vm._v(" fa-caret-right")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-square-o-down"
	  }), _vm._v("\n                    fa-caret-square-o-down\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-square-o-left"
	  }), _vm._v("\n                    fa-caret-square-o-left\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-square-o-right"
	  }), _vm._v("\n                    fa-caret-square-o-right\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-square-o-up"
	  }), _vm._v(" fa-caret-square-o-up\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-caret-up"
	  }), _vm._v(" fa-caret-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chevron-circle-down"
	  }), _vm._v("\n                    fa-chevron-circle-down\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chevron-circle-left"
	  }), _vm._v("\n                    fa-chevron-circle-left\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chevron-circle-right"
	  }), _vm._v("\n                    fa-chevron-circle-right\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chevron-circle-up"
	  }), _vm._v(" fa-chevron-circle-up\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chevron-down"
	  }), _vm._v(" fa-chevron-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chevron-left"
	  }), _vm._v(" fa-chevron-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chevron-right"
	  }), _vm._v(" fa-chevron-right")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chevron-up"
	  }), _vm._v(" fa-chevron-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-exchange"
	  }), _vm._v(" fa-exchange")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-o-down"
	  }), _vm._v(" fa-hand-o-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-o-left"
	  }), _vm._v(" fa-hand-o-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-o-right"
	  }), _vm._v(" fa-hand-o-right")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hand-o-up"
	  }), _vm._v(" fa-hand-o-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-long-arrow-down"
	  }), _vm._v(" fa-long-arrow-down")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-long-arrow-left"
	  }), _vm._v(" fa-long-arrow-left")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-long-arrow-right"
	  }), _vm._v(" fa-long-arrow-right\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-long-arrow-up"
	  }), _vm._v(" fa-long-arrow-up")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-down"
	  }), _vm._v(" fa-toggle-down\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-left"
	  }), _vm._v(" fa-toggle-left\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-right"
	  }), _vm._v(" fa-toggle-right\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-toggle-up"
	  }), _vm._v(" fa-toggle-up\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "video-player"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Video Player Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-arrows-alt"
	  }), _vm._v(" fa-arrows-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-backward"
	  }), _vm._v(" fa-backward")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-compress"
	  }), _vm._v(" fa-compress")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-eject"
	  }), _vm._v(" fa-eject")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-expand"
	  }), _vm._v(" fa-expand")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fast-backward"
	  }), _vm._v(" fa-fast-backward")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fast-forward"
	  }), _vm._v(" fa-fast-forward")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-forward"
	  }), _vm._v(" fa-forward")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pause"
	  }), _vm._v(" fa-pause")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-play"
	  }), _vm._v(" fa-play")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-play-circle"
	  }), _vm._v(" fa-play-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-play-circle-o"
	  }), _vm._v(" fa-play-circle-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-random"
	  }), _vm._v(" fa-random")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-step-backward"
	  }), _vm._v(" fa-step-backward")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-step-forward"
	  }), _vm._v(" fa-step-forward")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-stop"
	  }), _vm._v(" fa-stop")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-youtube-play"
	  }), _vm._v(" fa-youtube-play")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "brand"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Brand Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('ul', {
	    staticClass: "margin-bottom-none padding-left-lg"
	  }, [_c('li', [_vm._v("All brand icons are trademarks of their respective owners.")]), _vm._v(" "), _c('li', [_vm._v("The use of these trademarks does not indicate endorsement of the trademark holder by Font\n                      Awesome, nor vice versa.\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row fontawesome-icon-list"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-500px"
	  }), _vm._v(" fa-500px")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-adn"
	  }), _vm._v(" fa-adn")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-amazon"
	  }), _vm._v(" fa-amazon")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-android"
	  }), _vm._v(" fa-android")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-angellist"
	  }), _vm._v(" fa-angellist")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-apple"
	  }), _vm._v(" fa-apple")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-behance"
	  }), _vm._v(" fa-behance")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-behance-square"
	  }), _vm._v(" fa-behance-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bitbucket"
	  }), _vm._v(" fa-bitbucket")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bitbucket-square"
	  }), _vm._v(" fa-bitbucket-square\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bitcoin"
	  }), _vm._v(" fa-bitcoin\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-black-tie"
	  }), _vm._v(" fa-black-tie")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btc"
	  }), _vm._v(" fa-btc")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-buysellads"
	  }), _vm._v(" fa-buysellads")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-amex"
	  }), _vm._v(" fa-cc-amex")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-diners-club"
	  }), _vm._v(" fa-cc-diners-club")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-discover"
	  }), _vm._v(" fa-cc-discover")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-jcb"
	  }), _vm._v(" fa-cc-jcb")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-mastercard"
	  }), _vm._v(" fa-cc-mastercard")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-paypal"
	  }), _vm._v(" fa-cc-paypal")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-stripe"
	  }), _vm._v(" fa-cc-stripe")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-cc-visa"
	  }), _vm._v(" fa-cc-visa")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-chrome"
	  }), _vm._v(" fa-chrome")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-codepen"
	  }), _vm._v(" fa-codepen")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-connectdevelop"
	  }), _vm._v(" fa-connectdevelop")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-contao"
	  }), _vm._v(" fa-contao")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-css3"
	  }), _vm._v(" fa-css3")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-dashcube"
	  }), _vm._v(" fa-dashcube")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-delicious"
	  }), _vm._v(" fa-delicious")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-deviantart"
	  }), _vm._v(" fa-deviantart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-digg"
	  }), _vm._v(" fa-digg")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-dribbble"
	  }), _vm._v(" fa-dribbble")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-dropbox"
	  }), _vm._v(" fa-dropbox")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-drupal"
	  }), _vm._v(" fa-drupal")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-empire"
	  }), _vm._v(" fa-empire")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-expeditedssl"
	  }), _vm._v(" fa-expeditedssl")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-facebook"
	  }), _vm._v(" fa-facebook")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-facebook-f"
	  }), _vm._v(" fa-facebook-f\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-facebook-official"
	  }), _vm._v(" fa-facebook-official\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-facebook-square"
	  }), _vm._v(" fa-facebook-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-firefox"
	  }), _vm._v(" fa-firefox")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-flickr"
	  }), _vm._v(" fa-flickr")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-fonticons"
	  }), _vm._v(" fa-fonticons")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-forumbee"
	  }), _vm._v(" fa-forumbee")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-foursquare"
	  }), _vm._v(" fa-foursquare")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ge"
	  }), _vm._v(" fa-ge\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-get-pocket"
	  }), _vm._v(" fa-get-pocket")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gg"
	  }), _vm._v(" fa-gg")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gg-circle"
	  }), _vm._v(" fa-gg-circle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-git"
	  }), _vm._v(" fa-git")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-git-square"
	  }), _vm._v(" fa-git-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-github"
	  }), _vm._v(" fa-github")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-github-alt"
	  }), _vm._v(" fa-github-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-github-square"
	  }), _vm._v(" fa-github-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gittip"
	  }), _vm._v(" fa-gittip\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-google"
	  }), _vm._v(" fa-google")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-google-plus"
	  }), _vm._v(" fa-google-plus")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-google-plus-square"
	  }), _vm._v(" fa-google-plus-square\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-google-wallet"
	  }), _vm._v(" fa-google-wallet")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-gratipay"
	  }), _vm._v(" fa-gratipay")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hacker-news"
	  }), _vm._v(" fa-hacker-news")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-houzz"
	  }), _vm._v(" fa-houzz")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-html5"
	  }), _vm._v(" fa-html5")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-instagram"
	  }), _vm._v(" fa-instagram")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-internet-explorer"
	  }), _vm._v(" fa-internet-explorer\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ioxhost"
	  }), _vm._v(" fa-ioxhost")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-joomla"
	  }), _vm._v(" fa-joomla")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-jsfiddle"
	  }), _vm._v(" fa-jsfiddle")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-lastfm"
	  }), _vm._v(" fa-lastfm")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-lastfm-square"
	  }), _vm._v(" fa-lastfm-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-leanpub"
	  }), _vm._v(" fa-leanpub")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-linkedin"
	  }), _vm._v(" fa-linkedin")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-linkedin-square"
	  }), _vm._v(" fa-linkedin-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-linux"
	  }), _vm._v(" fa-linux")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-maxcdn"
	  }), _vm._v(" fa-maxcdn")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-meanpath"
	  }), _vm._v(" fa-meanpath")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-medium"
	  }), _vm._v(" fa-medium")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-odnoklassniki"
	  }), _vm._v(" fa-odnoklassniki")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-odnoklassniki-square"
	  }), _vm._v("\n                    fa-odnoklassniki-square\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-opencart"
	  }), _vm._v(" fa-opencart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-openid"
	  }), _vm._v(" fa-openid")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-opera"
	  }), _vm._v(" fa-opera")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-optin-monster"
	  }), _vm._v(" fa-optin-monster")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pagelines"
	  }), _vm._v(" fa-pagelines")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-paypal"
	  }), _vm._v(" fa-paypal")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pied-piper"
	  }), _vm._v(" fa-pied-piper")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pied-piper-alt"
	  }), _vm._v(" fa-pied-piper-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pinterest"
	  }), _vm._v(" fa-pinterest")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pinterest-p"
	  }), _vm._v(" fa-pinterest-p")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-pinterest-square"
	  }), _vm._v(" fa-pinterest-square\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-qq"
	  }), _vm._v(" fa-qq")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ra"
	  }), _vm._v(" fa-ra\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-rebel"
	  }), _vm._v(" fa-rebel")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-reddit"
	  }), _vm._v(" fa-reddit")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-reddit-square"
	  }), _vm._v(" fa-reddit-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-renren"
	  }), _vm._v(" fa-renren")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-safari"
	  }), _vm._v(" fa-safari")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-sellsy"
	  }), _vm._v(" fa-sellsy")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-share-alt"
	  }), _vm._v(" fa-share-alt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-share-alt-square"
	  }), _vm._v(" fa-share-alt-square\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-shirtsinbulk"
	  }), _vm._v(" fa-shirtsinbulk")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-simplybuilt"
	  }), _vm._v(" fa-simplybuilt")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-skyatlas"
	  }), _vm._v(" fa-skyatlas")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-skype"
	  }), _vm._v(" fa-skype")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-slack"
	  }), _vm._v(" fa-slack")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-slideshare"
	  }), _vm._v(" fa-slideshare")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-soundcloud"
	  }), _vm._v(" fa-soundcloud")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-spotify"
	  }), _vm._v(" fa-spotify")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-stack-exchange"
	  }), _vm._v(" fa-stack-exchange")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-stack-overflow"
	  }), _vm._v(" fa-stack-overflow")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-steam"
	  }), _vm._v(" fa-steam")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-steam-square"
	  }), _vm._v(" fa-steam-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-stumbleupon"
	  }), _vm._v(" fa-stumbleupon")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-stumbleupon-circle"
	  }), _vm._v(" fa-stumbleupon-circle\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tencent-weibo"
	  }), _vm._v(" fa-tencent-weibo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-trello"
	  }), _vm._v(" fa-trello")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tripadvisor"
	  }), _vm._v(" fa-tripadvisor")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tumblr"
	  }), _vm._v(" fa-tumblr")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-tumblr-square"
	  }), _vm._v(" fa-tumblr-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-twitch"
	  }), _vm._v(" fa-twitch")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-twitter"
	  }), _vm._v(" fa-twitter")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-twitter-square"
	  }), _vm._v(" fa-twitter-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-viacoin"
	  }), _vm._v(" fa-viacoin")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-vimeo"
	  }), _vm._v(" fa-vimeo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-vimeo-square"
	  }), _vm._v(" fa-vimeo-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-vine"
	  }), _vm._v(" fa-vine")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-vk"
	  }), _vm._v(" fa-vk")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wechat"
	  }), _vm._v(" fa-wechat\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-weibo"
	  }), _vm._v(" fa-weibo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-weixin"
	  }), _vm._v(" fa-weixin")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-whatsapp"
	  }), _vm._v(" fa-whatsapp")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wikipedia-w"
	  }), _vm._v(" fa-wikipedia-w")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-windows"
	  }), _vm._v(" fa-windows")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wordpress"
	  }), _vm._v(" fa-wordpress")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-xing"
	  }), _vm._v(" fa-xing")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-xing-square"
	  }), _vm._v(" fa-xing-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-y-combinator"
	  }), _vm._v(" fa-y-combinator")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-y-combinator-square"
	  }), _vm._v("\n                    fa-y-combinator-square "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-yahoo"
	  }), _vm._v(" fa-yahoo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-yc"
	  }), _vm._v(" fa-yc\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-yc-square"
	  }), _vm._v(" fa-yc-square\n                    "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-yelp"
	  }), _vm._v(" fa-yelp")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-youtube"
	  }), _vm._v(" fa-youtube")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-youtube-play"
	  }), _vm._v(" fa-youtube-play")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-youtube-square"
	  }), _vm._v(" fa-youtube-square")])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "medical"
	    }
	  }, [_c('h4', {
	    staticClass: "page-header"
	  }, [_vm._v("Medical Icons")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-ambulance"
	  }), _vm._v(" fa-ambulance")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-h-square"
	  }), _vm._v(" fa-h-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-heart"
	  }), _vm._v(" fa-heart")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-heart-o"
	  }), _vm._v(" fa-heart-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-heartbeat"
	  }), _vm._v(" fa-heartbeat")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-hospital-o"
	  }), _vm._v(" fa-hospital-o")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-medkit"
	  }), _vm._v(" fa-medkit")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-plus-square"
	  }), _vm._v(" fa-plus-square")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-stethoscope"
	  }), _vm._v(" fa-stethoscope")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-user-md"
	  }), _vm._v(" fa-user-md")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-wheelchair"
	  }), _vm._v(" fa-wheelchair")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "glyphicons"
	    }
	  }, [_c('ul', {
	    staticClass: "bs-glyphicons"
	  }, [_c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-asterisk"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-asterisk")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-plus"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-plus")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-euro"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-euro")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-eur"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-eur")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-minus"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-minus")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-cloud"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-cloud")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-envelope"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-envelope")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-pencil"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-pencil")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-glass"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-glass")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-music"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-music")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-search"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-search")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-heart"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-heart")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-star"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-star")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-star-empty"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-star-empty")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-user"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-user")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-film"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-film")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-th-large"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-th-large")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-th"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-th")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-th-list"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-th-list")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-ok"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-ok")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-remove"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-remove")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-zoom-in"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-zoom-in")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-zoom-out"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-zoom-out")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-off"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-off")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-signal"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-signal")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-cog"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-cog")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-trash"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-trash")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-home"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-home")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-file"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-file")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-time"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-time")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-road"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-road")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-download-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-download-alt")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-download"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-download")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-upload"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-upload")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-inbox"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-inbox")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-play-circle"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-play-circle")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-repeat"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-repeat")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-refresh"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-refresh")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-list-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-list-alt")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-lock"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-lock")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-flag"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-flag")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-headphones"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-headphones")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-volume-off"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-volume-off")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-volume-down"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-volume-down")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-volume-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-volume-up")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-qrcode"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-qrcode")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-barcode"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-barcode")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-tag"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-tag")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-tags"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-tags")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-book"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-book")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-bookmark"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-bookmark")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-print"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-print")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-camera"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-camera")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-font"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-font")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-bold"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-bold")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-italic"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-italic")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-text-height"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-text-height")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-text-width"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-text-width")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-align-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-align-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-align-center"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-align-center")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-align-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-align-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-align-justify"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-align-justify")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-list"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-list")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-indent-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-indent-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-indent-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-indent-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-facetime-video"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-facetime-video")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-picture"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-picture")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-map-marker"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-map-marker")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-adjust"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-adjust")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-tint"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-tint")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-edit"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-edit")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-share"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-share")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-check")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-move"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-move")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-step-backward"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-step-backward")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-fast-backward"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-fast-backward")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-backward"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-backward")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-play"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-play")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-pause"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-pause")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-stop"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-stop")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-forward"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-forward")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-fast-forward"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-fast-forward")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-step-forward"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-step-forward")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-eject"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-eject")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-chevron-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-chevron-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-chevron-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-chevron-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-plus-sign"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-plus-sign")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-minus-sign"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-minus-sign")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-remove-sign"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-remove-sign")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-ok-sign"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-ok-sign")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-question-sign"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-question-sign")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-info-sign"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-info-sign")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-screenshot"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-screenshot")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-remove-circle"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-remove-circle")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-ok-circle"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-ok-circle")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-ban-circle"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-ban-circle")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-arrow-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-arrow-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-arrow-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-arrow-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-arrow-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-arrow-up")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-arrow-down"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-arrow-down")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-share-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-share-alt")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-resize-full"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-resize-full")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-resize-small"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-resize-small")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-exclamation-sign"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-exclamation-sign")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-gift"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-gift")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-leaf"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-leaf")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-fire"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-fire")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-eye-open"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-eye-open")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-eye-close"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-eye-close")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-warning-sign"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-warning-sign")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-plane"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-plane")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-calendar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-calendar")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-random"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-random")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-comment"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-comment")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-magnet"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-magnet")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-chevron-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-chevron-up")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-chevron-down"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-chevron-down")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-retweet"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-retweet")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-shopping-cart"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-shopping-cart")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-folder-close"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-folder-close")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-folder-open"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-folder-open")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-resize-vertical"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-resize-vertical")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-resize-horizontal"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-resize-horizontal")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-hdd"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-hdd")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-bullhorn"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-bullhorn")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-bell"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-bell")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-certificate"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-certificate")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-thumbs-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-thumbs-up")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-thumbs-down"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-thumbs-down")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-hand-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-hand-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-hand-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-hand-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-hand-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-hand-up")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-hand-down"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-hand-down")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-circle-arrow-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-circle-arrow-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-circle-arrow-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-circle-arrow-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-circle-arrow-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-circle-arrow-up")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-circle-arrow-down"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-circle-arrow-down")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-globe"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-globe")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-wrench"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-wrench")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-tasks"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-tasks")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-filter"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-filter")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-briefcase"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-briefcase")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-fullscreen"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-fullscreen")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-dashboard"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-dashboard")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-paperclip"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-paperclip")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-heart-empty"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-heart-empty")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-link"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-link")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-phone"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-phone")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-pushpin"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-pushpin")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-usd"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-usd")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-gbp"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-gbp")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sort"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sort")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sort-by-alphabet"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sort-by-alphabet")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sort-by-alphabet-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sort-by-alphabet-alt")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sort-by-order"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sort-by-order")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sort-by-order-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sort-by-order-alt")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sort-by-attributes"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sort-by-attributes")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sort-by-attributes-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sort-by-attributes-alt")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-unchecked"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-unchecked")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-expand"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-expand")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-collapse-down"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-collapse-down")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-collapse-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-collapse-up")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-log-in"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-log-in")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-flash"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-flash")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-log-out"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-log-out")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-new-window"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-new-window")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-record"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-record")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-save"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-save")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-open"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-open")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-saved"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-saved")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-import"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-import")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-export"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-export")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-send"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-send")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-floppy-disk"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-floppy-disk")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-floppy-saved"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-floppy-saved")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-floppy-remove"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-floppy-remove")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-floppy-save"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-floppy-save")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-floppy-open"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-floppy-open")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-credit-card"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-credit-card")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-transfer"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-transfer")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-cutlery"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-cutlery")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-header"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-header")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-compressed"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-compressed")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-earphone"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-earphone")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-phone-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-phone-alt")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-tower"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-tower")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-stats"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-stats")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sd-video"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sd-video")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-hd-video"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-hd-video")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-subtitles"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-subtitles")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sound-stereo"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sound-stereo")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sound-dolby"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sound-dolby")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sound-5-1"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sound-5-1")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sound-6-1"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sound-6-1")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sound-7-1"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sound-7-1")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-copyright-mark"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-copyright-mark")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-registration-mark"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-registration-mark")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-cloud-download"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-cloud-download")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-cloud-upload"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-cloud-upload")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-tree-conifer"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-tree-conifer")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-tree-deciduous"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-tree-deciduous")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-cd"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-cd")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-save-file"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-save-file")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-open-file"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-open-file")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-level-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-level-up")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-copy"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-copy")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-paste"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-paste")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-alert"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-alert")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-equalizer"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-equalizer")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-king"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-king")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-queen"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-queen")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-pawn"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-pawn")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-bishop"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-bishop")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-knight"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-knight")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-baby-formula"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-baby-formula")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-tent"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-tent")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-blackboard"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-blackboard")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-bed"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-bed")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-apple"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-apple")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-erase"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-erase")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-hourglass"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-hourglass")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-lamp"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-lamp")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-duplicate"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-duplicate")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-piggy-bank"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-piggy-bank")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-scissors"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-scissors")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-bitcoin"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-bitcoin")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-btc"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-btc")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-xbt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-xbt")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-yen"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-yen")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-jpy"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-jpy")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-ruble"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-ruble")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-rub"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-rub")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-scale"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-scale")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-ice-lolly"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-ice-lolly")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-ice-lolly-tasted"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-ice-lolly-tasted")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-education"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-education")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-option-horizontal"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-option-horizontal")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-option-vertical"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-option-vertical")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-hamburger"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-menu-hamburger")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-modal-window"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-modal-window")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-oil"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-oil")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-grain"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-grain")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-sunglasses"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-sunglasses")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-text-size"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-text-size")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-text-color"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-text-color")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-text-background"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-text-background")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-object-align-top"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-object-align-top")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-object-align-bottom"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-object-align-bottom")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-object-align-horizontal"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-object-align-horizontal")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-object-align-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-object-align-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-object-align-vertical"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-object-align-vertical")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-object-align-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-object-align-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-triangle-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-triangle-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-triangle-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-triangle-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-triangle-bottom"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-triangle-bottom")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-triangle-top"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-triangle-top")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-console"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-console")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-superscript"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-superscript")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-subscript"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-subscript")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-left"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-menu-left")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-right"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-menu-right")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-menu-down")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon-class"
	  }, [_vm._v("glyphicon glyphicon-menu-up")])])])])])])])])])])
	}]}

/***/ }),
/* 2045 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "scroll-nav"
	  }, [_c('div', {
	    staticClass: "row-flex centered-between"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered scroll-nav__row"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.query),
	      expression: "query",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "scroll-nav__input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Ir para…"
	    },
	    domProps: {
	      "value": (_vm.query)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.query = $event.target.value.trim()
	      }, _vm.onInput],
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onEnterFromInput($event)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.isSuggestOpen && _vm.suggestions.length) ? _c('div', {
	    staticClass: "scroll-nav__suggestions"
	  }, [_c('ul', {
	    staticClass: "scroll-nav__suggestions-list"
	  }, _vm._l((_vm.suggestions), function(item, i) {
	    return _c('li', {
	      key: item.id,
	      staticClass: "scroll-nav__suggestion",
	      on: {
	        "mousedown": function($event) {
	          $event.preventDefault();
	          return _vm.onSuggestionClick(item)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "scroll-nav__suggestion-label"
	    }, [_vm._v(_vm._s(item.label))])])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "scroll-nav__btn",
	    attrs: {
	      "disabled": !_vm.hasPrev,
	      "title": _vm.hasPrev ? '<h5> ir para: #' + _vm.ids[_vm.currentIndex - 1].id + '</h5>' : ''
	    },
	    on: {
	      "click": _vm.prev
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "scroll-nav__btn",
	    attrs: {
	      "disabled": !_vm.hasNext,
	      "title": _vm.hasNext ? '<h5> ir para: #' + _vm.ids[_vm.currentIndex + 1].id + '</h5>' : ''
	    },
	    on: {
	      "click": _vm.next
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "scroll-nav__btn-home",
	    attrs: {
	      "title": "<h5> Voltar ao início </h5>"
	    },
	    on: {
	      "click": _vm.home
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-home",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-primary",
	    attrs: {
	      "id": "deferimento"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
	    }
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Deferimento"), (_vm.deferimento.ds_codigo_projeto_erp) ? _c('span', [_vm._v(" do projeto "), _c('b', [_vm._v(_vm._s(_vm.deferimento.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('legend', [_vm._v("Datas")]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('data deferimento')
	    },
	    attrs: {
	      "uib-tooltip": "Data de deferimento"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data do deferimento pelo comitê")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast'),
	      expression: "'required|validdate|dateeqpast'"
	    }],
	    attrs: {
	      "name": "data deferimento",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "use-utc": false,
	      "format": "dd/MM/yyyy",
	      "placeholder": "__/__/____"
	    },
	    model: {
	      value: (_vm.deferimento.dt_deferimento),
	      callback: function($$v) {
	        _vm.$set(_vm.deferimento, "dt_deferimento", $$v)
	      },
	      expression: "deferimento.dt_deferimento"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('data deferimento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('data deferimento')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Documentos do Deferimento")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.deferimentoDocumentos,
	      "documentTypes": '',
	      "documentosObrigatorios": '',
	      "localUso": 'PROPOSTA_DEFERIMENTO'
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('resultadoAprovacao')
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.deferimento.resultadoAprovacao),
	      expression: "deferimento.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "APROVAR"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.deferimento.resultadoAprovacao, "APROVAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.deferimento, "resultadoAprovacao", "APROVAR")
	      }
	    }
	  }), _vm._v("\n                  Deferir o Projeto (DEF)\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.deferimento.resultadoAprovacao),
	      expression: "deferimento.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "INDEFERIR"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.deferimento.resultadoAprovacao, "INDEFERIR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.deferimento, "resultadoAprovacao", "INDEFERIR")
	      }
	    }
	  }), _vm._v("\n                  Indeferir o Projeto (IND)\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.deferimento.resultadoAprovacao),
	      expression: "deferimento.resultadoAprovacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "VOLTAR_ANALISE"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.deferimento.resultadoAprovacao, "VOLTAR_ANALISE")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.deferimento, "resultadoAprovacao", "VOLTAR_ANALISE")
	      }
	    }
	  }), _vm._v("\n                  Devolver para Reanálise\n                  "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.errors.first('aprovacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('aprovacao')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.deferimento.resultadoAprovacao && _vm.deferimento.resultadoAprovacao !== 'APROVAR') ? _c('div', {
	    staticClass: "form-group full col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.deferimento.justificativa),
	      expression: "deferimento.justificativa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa"
	    },
	    domProps: {
	      "value": (_vm.deferimento.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.deferimento, "justificativa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Configurações Gerais'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Configurações Gerais")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show === true),
	      expression: "loading.show === true"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "MóduloUsuáriosLogados"
	    }
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('span', [_vm._v(" Usuários Logados no sistema: ")]), _vm._v(" " + _vm._s(_vm.usuariosLogados.length) + "\n                  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped text-center"
	  }, [_vm._m(1), _vm._v(" "), _c('thead', _vm._l((_vm.usuariosLogados), function(usuario) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "data-title": "'nome'",
	        "sortable": "'item'",
	        "width": "20%"
	      }
	    }, [_vm._v(_vm._s(usuario.ds_nome_usuario))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "data-title": "'login'",
	        "sortable": "'login'",
	        "width": "20%"
	      }
	    }, [_vm._v(_vm._s(usuario.ds_login))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "data-title": "'email'",
	        "sortable": "'email'",
	        "width": "20%"
	      }
	    }, [_vm._v(_vm._s(usuario.ds_email))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "data-title": "'tipo'",
	        "sortable": "'tipo'",
	        "width": "20%"
	      }
	    }, [_vm._v(_vm._s(usuario.ds_tipo_usuario) + "\n                        ")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "data-title": "'email'",
	        "sortable": "'email'",
	        "width": "20%"
	      }
	    }, [(usuario.ds_tipo_usuario === 'ENTIDADE' && usuario.entidade && !_vm._.isNull(usuario.entidade)) ? _c('div', [_vm._v(_vm._s(usuario.entidade.ds_nome) + " - " + _vm._s(_vm._f("cnpj")(usuario.entidade.ds_cnpj)))]) : (usuario.ds_tipo_usuario === 'FUNDACAO') ? _c('div', [_vm._v("-")]) : _vm._e()])])
	  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "MóduloUsuario"
	    }
	  }, [(_vm.$root.authorize('usuario-entidade-configurar')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default pull-right",
	    attrs: {
	      "type": "button",
	      "uib-tooltip": "Editar"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmEntityUserOpen = !_vm.mostrar.isFrmEntityUserOpen
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("Edita comportamentos relativos ao cadastro de usuário entidade.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmEntityUserOpen) ? _c('div', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmEntityUser",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('defaultProfile')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "active"
	    }
	  }, [_vm._v("Perfil padrão usuário CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected),
	      expression: "selected"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "defaultProfile"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.perfis), function(perfil) {
	    return _c('option', {
	      domProps: {
	        "value": perfil.ds_nome
	      }
	    }, [_vm._v(_vm._s(perfil.ds_nome))])
	  })], 2), _vm._v(" "), (_vm.errors.first('defaultProfile')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('defaultProfile')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('defaultProfile')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "active"
	    }
	  }, [_vm._v("Perfil padrão usuário CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedCpf),
	      expression: "selectedCpf"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "defaultProfileCpf"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedCpf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.perfis), function(perfil) {
	    return _c('option', {
	      domProps: {
	        "value": perfil.ds_nome
	      }
	    }, [_vm._v(_vm._s(perfil.ds_nome))])
	  })], 2), _vm._v(" "), (_vm.errors.first('defaultProfileCpf')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('defaultProfileCpf')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.salva
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmEntityUserOpen = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('usuario-entidade-configurar')) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.$root.authorize('usuario-agencia-configurar')) ? _c('div', {
	    staticClass: "form-group"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "MóduloAcoes"
	    }
	  }, [(_vm.$root.authorize('perfil-atribuido-configurar')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default pull-right",
	    attrs: {
	      "type": "button",
	      "uib-tooltip": "Editar"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmAssignedProfileOpen = !_vm.mostrar.isFrmAssignedProfileOpen
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("Edita comportamentos relativos à atribuição de perfil.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmAssignedProfileOpen) ? _c('div', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmAssignedProfile",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Perfis de Gerência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.perfis,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": true,
	      "preserve-search": true,
	      "placeholder": "Selecione um perfil",
	      "label": "ds_nome",
	      "track-by": "ds_nome",
	      "preselect-first": true
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.name))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 3413081920),
	    model: {
	      value: (_vm.configuracao.assignedProfileConfig.managerProfiles),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracao.assignedProfileConfig, "managerProfiles", $$v)
	      },
	      expression: "configuracao.assignedProfileConfig.managerProfiles"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.salva
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmAssignedProfileOpen = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "MóduloEntidade"
	    }
	  }, [(_vm.$root.authorize('entidade-configurar')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default pull-right",
	    attrs: {
	      "type": "button",
	      "uib-tooltip": "Editar"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmCredentialOpen = !_vm.mostrar.isFrmCredentialOpen
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Edita comportamentos relativos ao credenciamento.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmCredentialOpen) ? _c('div', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmAssignedProfile",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
	  }, [_c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('isSendEmail')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "active"
	    }
	  }, [_vm._v("Enviar e-mail?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracao.configuracao_entidade.bt_send_email),
	      expression: "configuracao.configuracao_entidade.bt_send_email"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "isSendEmail",
	      "required": ""
	    },
	    domProps: {
	      "value": 1,
	      "checked": _vm._q(_vm.configuracao.configuracao_entidade.bt_send_email, 1)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.configuracao.configuracao_entidade, "bt_send_email", 1)
	      }
	    }
	  }), _vm._v(" Sim"), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracao.configuracao_entidade.bt_send_email),
	      expression: "configuracao.configuracao_entidade.bt_send_email"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "isSendEmail",
	      "required": ""
	    },
	    domProps: {
	      "value": 0,
	      "checked": _vm._q(_vm.configuracao.configuracao_entidade.bt_send_email, 0)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.configuracao.configuracao_entidade, "bt_send_email", 0)
	      }
	    }
	  }), _vm._v(" Não\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('isSendEmail')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('isSendEmail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "rg"
	    }
	  }, [_vm._v("Conteúdo do e-mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('vue-editor', {
	    attrs: {
	      "rows": "10",
	      "cols": "105"
	    },
	    model: {
	      value: (_vm.configuracao.configuracao_entidade.ds_email_content),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracao.configuracao_entidade, "ds_email_content", $$v)
	      },
	      expression: "configuracao.configuracao_entidade.ds_email_content"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Documentos obrigatórios:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.documentos,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": true,
	      "preserve-search": true,
	      "placeholder": "Selecione um documento",
	      "label": "ds_tipo",
	      "track-by": "ds_tipo"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 579952095),
	    model: {
	      value: (_vm.configuracao.configuracao_entidade.documentos_obrigatorios),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracao.configuracao_entidade, "documentos_obrigatorios", $$v)
	      },
	      expression: "configuracao.configuracao_entidade.documentos_obrigatorios"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.salva
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmCredentialOpen = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "MóduloProposta"
	    }
	  }, [(_vm.$root.authorize('proposta-configurar')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default pull-right",
	    attrs: {
	      "type": "button",
	      "uib-tooltip": "Editar"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmProposalOpen = !_vm.mostrar.isFrmProposalOpen
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("Edita comportamentos relativos a proposta.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmProposalOpen) ? _c('div', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmProposal",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "defaultDocumentTypeDraft"
	    }
	  }, [_vm._v("Tipo de documento padrão Minuta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracao.configuracao_proposta.minuta.ds_tipo),
	      expression: "configuracao.configuracao_proposta.minuta.ds_tipo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "defaultDocumentTypeDraft"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.configuracao.configuracao_proposta.minuta, "ds_tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento.ds_tipo
	      }
	    }, [_vm._v(_vm._s(documento.ds_tipo))])
	  })], 2), _vm._v(" "), (_vm.errors.first('defaultDocumentTypeDraft')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('defaultDocumentTypeDraft')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "defaultDocumentTypeWorkPlan"
	    }
	  }, [_vm._v("Tipo de documento padrão Plano de Trabalho:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracao.configuracao_proposta.plano_trabalho.ds_tipo),
	      expression: "configuracao.configuracao_proposta.plano_trabalho.ds_tipo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "defaultDocumentTypeDraft"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.configuracao.configuracao_proposta.plano_trabalho, "ds_tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento.ds_tipo
	      }
	    }, [_vm._v(_vm._s(documento.ds_tipo))])
	  })], 2), _vm._v(" "), (_vm.errors.first('defaultDocumentTypeWorkPlan')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('defaultDocumentTypeWorkPlan')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Documentos obrigatórios:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.documentos,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": true,
	      "preserve-search": true,
	      "placeholder": "Selecione um documento",
	      "label": "ds_tipo",
	      "track-by": "ds_tipo"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 579952095),
	    model: {
	      value: (_vm.configuracao.configuracao_proposta.documentos_obrigatorios),
	      callback: function($$v) {
	        _vm.$set(_vm.configuracao.configuracao_proposta, "documentos_obrigatorios", $$v)
	      },
	      expression: "configuracao.configuracao_proposta.documentos_obrigatorios"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.salva
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmProposalOpen = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "MóduloDocumentos"
	    }
	  }, [(_vm.$root.authorize('documento-configurar')) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default pull-right",
	    attrs: {
	      "type": "button",
	      "uib-tooltip": "Editar"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmDocumentOpen = !_vm.mostrar.isFrmDocumentOpen
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("Permite escolher os tipos de documentos permitidos e o tamanho dos mesmos.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrar.isFrmDocumentOpen) ? _c('div', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmRequest",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "well well-sm no-shadow animated fadeInDownOutUp"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2 required",
	    attrs: {
	      "for": "fileSize"
	    }
	  }, [_vm._v("Tamanho máximo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-lg-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracao.documento.dc_tamanho_arquivo),
	      expression: "configuracao.documento.dc_tamanho_arquivo"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "type": "number",
	      "step": "1",
	      "name": "fileSize",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.configuracao.documento.dc_tamanho_arquivo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.configuracao.documento, "dc_tamanho_arquivo", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("MB")])]), _vm._v(" "), (_vm.errors.first('fileSize')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('fileSize')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2 required"
	  }, [_vm._v("Tipos de arquivos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-3"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.configuracao.documento.tipo_arquivos,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": true,
	      "preserve-search": true,
	      "placeholder": "Adicionar tipo",
	      "label": "ds_tipo_de_documento",
	      "track-by": "ds_tipo_de_documento"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 1823440105),
	    model: {
	      value: (_vm.mimeTypes),
	      callback: function($$v) {
	        _vm.mimeTypes = $$v
	      },
	      expression: "mimeTypes"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('mime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('mime')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.salva
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrar.isFrmDocumentOpen = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "nav nav-pills"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#MóduloUsuáriosLogados",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Usuários Logados no Sistema")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#MóduloUsuario",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Módulo Usuário")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#MóduloAcoes",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Módulo Ações e proprietário")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#MóduloEntidade",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Módulo Entidade")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#MóduloProposta",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Módulo Proposta")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#MóduloDocumentos",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Módulo Documentos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticStyle: {
	      "background-color": "#F2F3F4"
	    }
	  }, [_c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Nome do usuário")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Login do usuário")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("E-mail do usuário")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Tipo do Usuário")]), _vm._v(" "), _c('th', {
	    staticClass: "centro",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Entidade")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-sidebar-subheading"
	  }, [_c('strong', [_vm._v("Cadastro de usuário entidade")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-sidebar-subheading"
	  }, [_c('strong', [_vm._v("Configuração de perfil atribuído")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-sidebar-subheading"
	  }, [_c('strong', [_vm._v("Configuração de credenciamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-sidebar-subheading"
	  }, [_c('strong', [_vm._v("Configuração de proposta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-sidebar-subheading"
	  }, [_c('strong', [_vm._v("Configuração de documentos anexos")])])
	}]}

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column all-centered prest-declaracao-container"
	  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.declaracoes), function(item) {
	    return (!item.declaracao.includes('AVISO DE CONCLUSÃO') || (item.declaracao.includes('AVISO DE CONCLUSÃO') && _vm.ehUltimaParcela)) ? _c('div', {
	      staticClass: "column all-start prest-item-declaracao",
	      class: item.aceito == 'S' ? (item.declaracao.includes('AVISO DE CONCLUSÃO') ? 'prest-aceito-conclusao' : 'prest-aceito') : (item.declaracao.includes('AVISO DE CONCLUSÃO') ? 'prest-neutro-conclusao' : 'prest-neutro')
	    }, [_c('div', {
	      staticClass: "row-flex all-start prest-declaracao"
	    }, [(_vm.usuarioLogado.userType === 'ENTIDADE' && _vm.chiefActive()) ? _c('i', {
	      staticClass: "fa",
	      class: item.aceito == 'S' ? 'fa-check-square-o' : 'fa-square-o',
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.aceitarDeclaracao(item)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      domProps: {
	        "innerHTML": _vm._s(item.declaracao)
	      }
	    })]), _vm._v(" "), (item.usuario && item.aceito == 'S') ? _c('div', {
	      staticClass: "row-flex all-start prest-declaracao-usuario"
	    }, [_c('span', {
	      staticClass: "prest-declaracao-usuario"
	    }, [_c('i', {
	      staticClass: "fa fa-user",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("\n          Aceito por: \n          "), _c('b', [_vm._v(_vm._s(item.usuario) + " " + _vm._s(_vm._f("moment")(item.updated_at, 'DD/MM/YYYY HH:mm')))])])]) : _vm._e(), _vm._v(" "), (item.aceito == 'N') ? _c('div', {
	      staticClass: "row-flex all-start prest-declaracao-usuario"
	    }, [_vm._m(1, true)]) : _vm._e()]) : _vm._e()
	  })], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex all-start w-100"
	  }, [_c('h3', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("\n      Declarações\n      "), _c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "prest-declaracao-usuario row-flex all-centered"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("Pendente de adesão para parcela de adiantamento. (representante legal)")])])
	}]}

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "how-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "eventDate",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm:ss")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              _vm.showModal = true, _vm.testFunc(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.showModal) ? _c('div', [_c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper",
	    on: {
	      "click": function($event) {
	        return _vm.$emit(_vm.showModal = false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Histórico")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Parceiro Estratégico")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Dados do parceiro estratégico:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.companyName),
	      expression: "snap.snapshot.companyName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "companyName",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot, "companyName", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "cnpj",
	      "type": "text",
	      "disabled": "true",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.snap.snapshot.cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.snap.snapshot, "cnpj", $$v)
	      },
	      expression: "snap.snapshot.cnpj"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "dt_cnpj"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    attrs: {
	      "name": "cnpjExpeditionTime",
	      "use-utc": true,
	      "input-class": "form-control",
	      "language": _vm.$datePickerPtBR,
	      "format": "dd/MM/yyyy",
	      "disabled": "true"
	    },
	    model: {
	      value: (this.snap.snapshot.cnpjExpeditionTime),
	      callback: function($$v) {
	        _vm.$set(this.snap.snapshot, "cnpjExpeditionTime", $$v)
	      },
	      expression: "this.snap.snapshot.cnpjExpeditionTime"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "businessName"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.businessName),
	      expression: "snap.snapshot.businessName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "businessName",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.businessName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot, "businessName", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "legalType"
	    }
	  }, [_vm._v("Natureza jurídica:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.legalType),
	      expression: "snap.snapshot.legalType"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "legalType",
	      "disabled": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.snap.snapshot, "legalType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ASSOCIAÇÃO"
	    }
	  }, [_vm._v("Associação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "COOPERATIVA"
	    }
	  }, [_vm._v("Cooperativa")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "EMPRESA_PUBLICA"
	    }
	  }, [_vm._v("Empresa pública")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "FUNDACAO"
	    }
	  }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ORGAO_PUBLICO_EXECUTIVO_ESTADUAL"
	    }
	  }, [_vm._v("Orgão público executivo estadual")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ORGAO_PUBLICO_EXECUTIVO_MUNICIPAL"
	    }
	  }, [_vm._v("Orgão público executivo municipal")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SEM_FINS_LUCRATIVOS"
	    }
	  }, [_vm._v("Sem fins lucrativos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SERVICO_SOCIAL_AUTONOMO"
	    }
	  }, [_vm._v("Serviço social autônomo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOCIEDADE_LTDA"
	    }
	  }, [_vm._v("Sociedade ltda")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SOCIEDADE_POR_ACOES"
	    }
	  }, [_vm._v("Sociedade por Ações")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "activity"
	    }
	  }, [_vm._v("Ramo atividade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.activity.description),
	      expression: "snap.snapshot.activity.description"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "activity",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.activity.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.activity, "description", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "constitutionDocument"
	    }
	  }, [_vm._v("Doc. constituição:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.constitutionDocument),
	      expression: "snap.snapshot.constitutionDocument"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "constitutionDocument",
	      "disabled": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.snap.snapshot, "constitutionDocument", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ATA_CONSTITUICAO"
	    }
	  }, [_vm._v("Ata constituição")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CONTRATO_SOCIAL"
	    }
	  }, [_vm._v("Contrato social")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ESTATUTO"
	    }
	  }, [_vm._v("Estatuto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "LEI_ORGANICA_MUNICIPAL"
	    }
	  }, [_vm._v("Lei orgânica municipal")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6",
	    attrs: {
	      "id": "contato"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "phone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.contacts.phone),
	      expression: "snap.snapshot.contacts.phone"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) ####-#####'),
	      expression: "'(##) ####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "phone",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.contacts.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.contacts, "phone", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "mobile"
	    }
	  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.contacts.mobile),
	      expression: "snap.snapshot.contacts.mobile"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('(##) #####-#####'),
	      expression: "'(##) #####-#####'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "masked": _vm.masked,
	      "name": "mobile",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.contacts.mobile)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.contacts, "mobile", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.snap.snapshot.contacts.email),
	      expression: "snap.snapshot.contacts.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": (_vm.snap.snapshot.contacts.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.snap.snapshot.contacts, "email", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])]), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.histEndereco,
	      "disable": _vm.disable
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes:")])])]), _vm._v(" "), _c('dirigentes', {
	    attrs: {
	      "entDirigentes": _vm.histDirigente,
	      "disable": _vm.disable
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.histDocumento,
	      "documentTypes": _vm.snap.snapshot.documentTypes,
	      "disable": _vm.disable
	    }
	  })], 1)]), _vm._v(" "), (!_vm.disable) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico:")])])]), _vm._v(" "), _c('historicoParcEstrategico', {
	    attrs: {
	      "parcHistorico": _vm.historico
	    }
	  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('br'), _vm._v(" "), _c('b-button', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button",
	      "disabled": false
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Fechar ")])], 1)])])])])])])])])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }]
	  }, [_c('pre', {
	    ref: "myDiv",
	    attrs: {
	      "id": "myDiv"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Projetos")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Projetos',
	        href: '#'
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title cursor_pointer",
	    on: {
	      "click": function($event) {
	        _vm.mostrarCabecalhoProjeto = !_vm.mostrarCabecalhoProjeto
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-caret-' + (_vm.mostrarCabecalhoProjeto ? 'right' : 'down'),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Projeto "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostrarCabecalhoProjeto),
	      expression: "!mostrarCabecalhoProjeto"
	    }]
	  }, [_vm._v(_vm._s(_vm.projeto.proposal.idProjectErp) + " - " + _vm._s(_vm.projeto.proposal.name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarCabecalhoProjeto),
	      expression: "mostrarCabecalhoProjeto"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_c('legend', [_vm._v("Projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "idProjectErp",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.idProjectErp),
	      expression: "projeto.proposal.idProjectErp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.idProjectErp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "idProjectErp", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {}, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.name),
	      expression: "projeto.proposal.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "name", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.coordinatorName),
	      expression: "projeto.proposal.coordinatorName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.coordinatorName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "coordinatorName", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 required"
	  }, [_c('label', {}, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.projeto.proposal.coordinatorCpf),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "coordinatorCpf", $$v)
	      },
	      expression: "projeto.proposal.coordinatorCpf"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {}, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.coordinatorEmail),
	      expression: "projeto.proposal.coordinatorEmail"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email do coordenador",
	      "type": "email"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.coordinatorEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "coordinatorEmail", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {}, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.projeto.proposal.coordinatorPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "coordinatorPhone", $$v)
	      },
	      expression: "projeto.proposal.coordinatorPhone"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {}, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.projeto.proposal.coordinatorMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "coordinatorMobile", $$v)
	      },
	      expression: "projeto.proposal.coordinatorMobile"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {}, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Fax",
	      "type": "tel",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.projeto.proposal.coordinatorFax),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "coordinatorFax", $$v)
	      },
	      expression: "projeto.proposal.coordinatorFax"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-1"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.projeto.proposal.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.projeto.proposal.entity.address), function(addr) {
	    return _c('address', {
	      staticClass: "ng-binding ng-scope"
	    }, [_vm._v("\n                                        " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                        " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                      ")])
	  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.projeto.proposal.entity.email))])]), _vm._v(" "), _c('h2', {
	    staticClass: "h4"
	  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: " col-md-12 ng-scope",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('label', {}, [_vm._v("Data inicial")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.initialDate",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.initialDate),
	      expression: "projeto.proposal.initialDate"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-isolate-scope ng-valid-maxlength ng-valid-date ng-valid-mask ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "Data Inicial",
	      "type": "date",
	      "placeholder": "__/__/____"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.initialDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "initialDate", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12 ng-scope"
	  }, [_c('label', {}, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.periods",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.periods),
	      expression: "projeto.proposal.periods"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
	    attrs: {
	      "name": "periodo",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.periods)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "periods", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
	    staticClass: "ng-binding"
	  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [(this.$root.isFundacao(this.usuarioLogado)) ? _c('visualiza-timeline', {
	    attrs: {
	      "numeroProjeto": _vm.projeto.proposal.idProjectErp,
	      "atualizar": _vm.atualizar_timeline
	    },
	    on: {
	      "idAcompanhamento": function($event) {
	        _vm.filtro_acompanhamento = $event
	      },
	      "idAlteracoes": function($event) {
	        _vm.filtro_alteracoes = $event
	      }
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
	    ref: "acompanhamento",
	    staticClass: "col-md-12"
	  }, [_vm._m(0), _vm._v(" "), _c('acompanhamentoProjetos', {
	    attrs: {
	      "ParmProjetos": _vm.projeto,
	      "ParmAcompanhamento": _vm.acProp,
	      "filtro": _vm.filtro_acompanhamento
	    },
	    on: {
	      "atualizarTimeline": function($event) {
	        _vm.atualizar_timeline = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
	    ref: "alteracoes",
	    staticClass: "col-md-12"
	  }, [_vm._m(1), _vm._v(" "), _c('alteracoesProjetos', {
	    attrs: {
	      "ParmProjetos": _vm.projeto,
	      "ParmAlteracao": _vm.atProp,
	      "filtro": _vm.filtro_alteracoes
	    },
	    on: {
	      "atualizarTimeline": function($event) {
	        _vm.atualizar_timeline = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 ng-scope",
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
	    }
	  }, [_c('label', {
	    staticClass: " ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.introduction",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.introduction),
	      expression: "projeto.proposal.introduction"
	    }],
	    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
	    attrs: {
	      "name": "introducao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.introduction)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "introduction", $event.target.value)
	      }
	    }
	  }, [_vm._v("<!---->\n                                    ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 ng-scope"
	  }, [_c('label', {
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.presentation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.presentation),
	      expression: "projeto.proposal.presentation"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.presentation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "presentation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 ng-scope"
	  }, [_c('label', {
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.territory",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.territory),
	      expression: "projeto.proposal.territory"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "territorio",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.territory)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "territory", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 ng-scope"
	  }, [_c('label', {
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.justification",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.justification),
	      expression: "projeto.proposal.justification"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "justificativa",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.justification)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "justification", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 ng-scope"
	  }, [_c('label', {
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.generalObjective",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.generalObjective),
	      expression: "projeto.proposal.generalObjective"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "objetivo Geral",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.generalObjective)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "generalObjective", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 ng-scope"
	  }, [_c('label', {
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "ng-isolate-scope",
	    attrs: {
	      "name": "proposal.summary",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.summary),
	      expression: "projeto.proposal.summary"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
	    attrs: {
	      "name": "sumario",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.summary)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "summary", $event.target.value)
	      }
	    }
	  })])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('publicoAlvoOld', {
	    attrs: {
	      "propsPublicosGrid": this.projeto.proposal.audiences
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('equipe-projetoOld', {
	    attrs: {
	      "propsEquipes": this.projeto.proposal.teams
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.results),
	      expression: "projeto.proposal.results"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resultados esperados",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.results)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "results", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.operation),
	      expression: "projeto.proposal.operation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Operacionalização",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.operation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "operation", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.partner),
	      expression: "projeto.proposal.partner"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Parceria",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.partner)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "partner", $event.target.value)
	      }
	    }
	  })])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.entityIsExecutioner),
	      expression: "projeto.proposal.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "true",
	      "selected": _vm.projeto.proposal.entityIsExecutioner === 'true'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.projeto.proposal.entityIsExecutioner, "true")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.projeto.proposal, "entityIsExecutioner", "true")
	      }
	    }
	  }), _vm._v(" Sim\n                                  ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.entityIsExecutioner),
	      expression: "projeto.proposal.entityIsExecutioner"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "false",
	      "selected": _vm.projeto.proposal.entityIsExecutioner === 'false'
	    },
	    domProps: {
	      "checked": _vm._q(_vm.projeto.proposal.entityIsExecutioner, "false")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.projeto.proposal, "entityIsExecutioner", "false")
	      }
	    }
	  }), _vm._v(" Não\n                                  ")])])]), _vm._v(" "), (_vm.projeto.proposal.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group   col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.entityExecutingName),
	      expression: "projeto.proposal.entityExecutingName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.entityExecutingName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "entityExecutingName", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.entityExecutingProcurator),
	      expression: "projeto.proposal.entityExecutingProcurator"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.entityExecutingProcurator)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "entityExecutingProcurator", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.projeto.proposal.entityExecutingCNPJ),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "entityExecutingCNPJ", $$v)
	      },
	      expression: "projeto.proposal.entityExecutingCNPJ"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.entityExecutingEmail),
	      expression: "projeto.proposal.entityExecutingEmail"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.entityExecutingEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "entityExecutingEmail", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.projeto.proposal.entityExecutingPhone),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "entityExecutingPhone", $$v)
	      },
	      expression: "projeto.proposal.entityExecutingPhone"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.projeto.proposal.entityExecutingMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "entityExecutingMobile", $$v)
	      },
	      expression: "projeto.proposal.entityExecutingMobile"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingFax",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "entityExecutingFax",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.projeto.proposal.entityExecutingFax),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "entityExecutingFax", $$v)
	      },
	      expression: "projeto.proposal.entityExecutingFax"
	    }
	  })], 1)])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.projeto.proposal.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.projeto.proposal, "entityExecutingCEP", $$v)
	      },
	      expression: "projeto.proposal.entityExecutingCEP"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.entityExecutingState),
	      expression: "projeto.proposal.entityExecutingState"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.projeto.proposal, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("TO")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.entityExecutingCity),
	      expression: "projeto.proposal.entityExecutingCity"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    },
	    attrs: {
	      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.entityExecutingAddress),
	      expression: "projeto.proposal.entityExecutingAddress"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.projeto.proposal.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.projeto.proposal, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    },
	    attrs: {
	      "uib-tooltip": "Projeto de duplicação"
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject",
	      "approval": "regComProFormCtrl.approval",
	      "state": "regComProFormCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projeto.proposal.duplicateProject),
	      expression: "projeto.proposal.duplicateProject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.projeto.proposal, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.projectNumber
	      }
	    }, [_vm._v(_vm._s(projeto.projectNumber + ' / ' +
	      projeto.projectName) + "\n                                      ")])
	  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_vm._m(8), _vm._v(" "), _c('objetivoEspecificoOld', {
	    attrs: {
	      "propsObjetivos": _vm.projeto.proposal.objectives
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    ref: "metas",
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto',
	      "name": "metas",
	      "id": "metas"
	    }
	  }, [_vm._m(9), _vm._v(" "), _c('metasOld', {
	    attrs: {
	      "propsObjetivos": _vm.projeto.proposal.objectives
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    ref: "atividades",
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto',
	      "name": "atividades",
	      "id": "atividades"
	    }
	  }, [_vm._m(10), _vm._v(" "), _c('atividadesOld', {
	    attrs: {
	      "meses": _vm.projeto.proposal.periods,
	      "propsObjetivos": _vm.projeto.proposal.objectives
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "text-align": "right",
	      "padding-right": "10px"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "text-align": "right",
	      "padding-right": "18px"
	    }
	  }, [(_vm.mudarCro === 1) ? _c('button', {
	    staticClass: "btn btn-bitbucket btn-flat",
	    staticStyle: {
	      "float": "right",
	      "margin-right": "5px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.mudaVisaoOrc
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Orçamento\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mudarOrc === 1) ? _c('button', {
	    staticClass: "btn btn-bitbucket btn-flat",
	    staticStyle: {
	      "float": "right",
	      "margin-right": "5px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.mudaVisaoCro
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cronograma\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.mudarOrc === 1) ? _c('div', {
	    staticClass: "col-md-12 box-body",
	    attrs: {
	      "id": "grid_cronograma"
	    }
	  }, [_c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', [_c('td', {
	    staticClass: "text-left linha-abaixo-larga",
	    staticStyle: {
	      "width": "70%"
	    }
	  }, [_c('div', {
	    staticClass: "texto-azul cabecalho",
	    staticStyle: {
	      "float": "left"
	    }
	  }, [_vm._v("Recurso da Fundação e Parceiros\n                              Estratégicos\n                            ")]), _vm._v(" "), _c('div', {
	    staticClass: "div-esquerda ng-binding"
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totalFundacaoContratado))), _c('br'), _c('span', {
	    staticClass: "texto-esmaecido"
	  }, [_vm._v("Total contratado")])]), _vm._v(" "), _c('div', {
	    staticClass: "div-esquerda ng-binding"
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totalFundacaoSaldo))), _c('br'), _c('span', {
	    staticClass: "texto-esmaecido"
	  }, [_vm._v("Saldo disponível")])]), _vm._v(" "), _c('div', {
	    staticClass: "div-esquerda ng-binding"
	  }, [_vm._v(_vm._s(_vm._f("percentage")((_vm.totalFundacaoContratado - _vm.totalFundacaoSaldo) / _vm.totalFundacaoContratado))), _c('br'), _c('span', {
	    staticClass: "texto-esmaecido"
	  }, [_vm._v("Percentual executado")])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('td', {
	    staticClass: "a_direita texto-claro realcado linha-abaixo-larga",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Atingimento\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itensCronogramaFundacao), function(item) {
	    return _c('tr', {
	      attrs: {
	        "title": "Previsto do " + item.Item_Periodo_Inicio + "º ao " + item.Item_Periodo_Inicio + "º mês do projeto. Contratado:  Quantidade " + item.Qtde_orcado + "  e  Valor Total  R$ " + _vm.formatarNumero(item.Valor_orcado, "moeda")
	      }
	    }, [_c('td', {
	      staticClass: "linha-abaixo-larga"
	    }, [_c('span', {
	      staticClass: "texto-claro ng-binding"
	    }, [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao))]), _c('br'), _c('span', {
	      staticClass: "ng-binding"
	    }, [_vm._v("#" + _vm._s(item.Id_item) + "   - " + _vm._s(item.Item_Observacao))])]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado linha-abaixo-larga ng-binding"
	    }, [_vm._v(_vm._s(item.Qtde_saldo))]), _vm._v(" "), _c('td', {
	      staticClass: "a_direita linha-abaixo-larga ng-binding"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo)) + "\n                          ")]), _vm._v(" "), _c('td', {
	      staticClass: "a_direita linha-abaixo-larga"
	    }, [_c('span', {
	      staticClass: "percentual ng-binding"
	    }, [_vm._v(_vm._s(_vm._f("percentage")(((item.Valor_orcado - item.Valor_saldo) / item.Valor_orcado))))]), (((item.Valor_orcado - item.Valor_saldo) / item.Valor_orcado) > 0.99) ? _c('span', {
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green"
	      }
	    }) : _vm._e()])])
	  }), 0)]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', [_c('td', {
	    staticClass: "text-left linha-abaixo-larga",
	    staticStyle: {
	      "width": "70%"
	    }
	  }, [_c('div', {
	    staticClass: "texto-azul cabecalho",
	    staticStyle: {
	      "float": "left"
	    }
	  }, [_vm._v("Recurso de Contrapartida de Entidade\n                            ")]), _vm._v(" "), _c('div', {
	    staticClass: "div-esquerda ng-binding"
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totalFundacaoContratadoContrapartida))), _c('br'), _c('span', {
	    staticClass: "texto-esmaecido"
	  }, [_vm._v("Total contratado")])]), _vm._v(" "), _c('div', {
	    staticClass: "div-esquerda ng-binding"
	  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totalFundacaoSaldoContrapartida))), _c('br'), _c('span', {
	    staticClass: "texto-esmaecido"
	  }, [_vm._v("Saldo disponível")])]), _vm._v(" "), _c('div', {
	    staticClass: "div-esquerda ng-binding"
	  }, [_vm._v(_vm._s(_vm._f("percentage")((_vm.totalFundacaoContratadoContrapartida - _vm.totalFundacaoSaldoContrapartida) / _vm.totalFundacaoContratadoContrapartida))), _c('br'), _c('span', {
	    staticClass: "texto-esmaecido"
	  }, [_vm._v("Percentual executado")])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('td', {
	    staticClass: "a_direita texto-claro realcado linha-abaixo-larga",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Atingimento\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itensCronogramaContrapartida), function(item) {
	    return _c('tr', {
	      attrs: {
	        "title": "Previsto do " + item.Item_Periodo_Inicio + "º ao " + item.Item_Periodo_Inicio + "º mês do projeto. Contratado:  Quantidade " + item.Qtde_orcado + "  e  Valor Total  R$ " + _vm.formatarNumero(item.Valor_orcado, "moeda")
	      }
	    }, [_c('td', {
	      staticClass: "linha-abaixo-larga"
	    }, [_c('span', {
	      staticClass: "texto-claro ng-binding"
	    }, [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao))]), _c('br'), _c('span', {
	      staticClass: "ng-binding"
	    }, [_vm._v("#" + _vm._s(item.Id_item) + "   - " + _vm._s(item.Item_Observacao))])]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado linha-abaixo-larga ng-binding"
	    }, [_vm._v(_vm._s(item.Qtde_saldo))]), _vm._v(" "), _c('td', {
	      staticClass: "a_direita linha-abaixo-larga ng-binding"
	    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo)) + "\n                          ")]), _vm._v(" "), _c('td', {
	      staticClass: "a_direita linha-abaixo-larga"
	    }, [_c('span', {
	      staticClass: "percentual ng-binding"
	    }, [_vm._v(_vm._s(_vm._f("percentage")(((item.Valor_orcado - item.Valor_saldo) / item.Valor_orcado))))]), (((item.Valor_orcado - item.Valor_saldo) / item.Valor_orcado) > 0.99) ? _c('span', {
	      staticClass: "fa fa-check",
	      staticStyle: {
	        "color": "green"
	      }
	    }) : _vm._e()])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.mudarCro === 1) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_vm._m(15), _vm._v(" "), _c('cronogramaOld', {
	    key: _vm.componentKey,
	    attrs: {
	      "propsObjetivos": _vm.proposta.objectives,
	      "atividades": _vm.atividades,
	      "proposta": _vm.proposta,
	      "meses": _vm.proposta.periods,
	      "projeto-duplicacao": _vm.proposta.duplicateProject,
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.objectives = $event
	      }
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('visualiza-gantt-old', {
	    attrs: {
	      "idProjeto": _vm.proposta.idProjectErp,
	      "tipoBarra": 'financeiro',
	      "mostrarExecFinanc": true,
	      "mostrarExecDeclarada": false
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "text-align": "right",
	      "padding-right": "10px"
	    }
	  }, [_c('br'), _vm._v(" "), (this.$root.authorize('solicitacao-contrapartida-editar')) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "disabled": _vm.blockCounterpart,
	      "uib-tooltip": "Redireciona para a tela de Solicitação de contrapartida",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onRedirect('COUNTERPART')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pie-chart",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Comprovar contrapartida\n                      ")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('solicitacao-pagamento-editar')) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    staticStyle: {
	      "float": "right",
	      "margin-right": "5px"
	    },
	    attrs: {
	      "disabled": _vm.blockPayment,
	      "uib-tooltip": "Redireciona para a tela de Solicitação de pagamento/ressarcimento",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onRedirect('PAYMENT')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-usd",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Solicitar pagamento/ressarcimento\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(16), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.parcelasAdiantamentoExibicao,
	      "fields": _vm.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "plot",
	      fn: function(row) {
	        return [_vm._v("\n                            " + _vm._s(row.item.plot) + "\n                            "), (row.item._mista) ? _c('span', {
	          staticStyle: {
	            "display": "block",
	            "font-size": "x-small"
	          }
	        }, [_vm._v("Parcela Mista")]) : _vm._e()]
	      }
	    }, {
	      key: "value",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value.toLocaleString('pt-BR', _vm.formato)))]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group col-md-12",
	    staticStyle: {
	      "text-align": "right",
	      "padding-right": "10px"
	    }
	  }, [(this.$root.authorize('solicitacao-prestacaocontas-editar')) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "uib-tooltip": "Redireciona para a tela de Solicitação de prestação de contas",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onRedirect('ACCOUNTABILITY')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Realizar prestação de contas\n                      ")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('solicitacao-devolucaoadiantamento-editar')) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    staticStyle: {
	      "float": "right",
	      "margin-right": "5px"
	    },
	    attrs: {
	      "ng-disabled": "blockRefund",
	      "uib-tooltip": "Redireciona para a tela de Solicitação de devolução de adiantamento",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onRedirect('DEVOLUTION')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-reply-all",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Solicitar devolução de adiantamento\n                      ")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('solicitacao-adiantamento-editar')) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    staticStyle: {
	      "float": "right",
	      "margin-right": "5px"
	    },
	    attrs: {
	      "ng-disabled": "blockAdvance",
	      "uib-tooltip": "Redireciona para a tela de Solicitação de adiantamento",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onRedirect('ADVANCE')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-money",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Solicitar adiantamento\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('municipalizacaoOld', {
	    attrs: {
	      "proposta": _vm.projeto.proposal
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta = $event
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_vm._m(18), _vm._v(" "), _c('cursosOld', {
	    attrs: {
	      "propsCursos": _vm.projeto.proposal.careers
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_vm._m(19), _vm._v(" "), _c('solenizacao', {
	    attrs: {
	      "propsSolenizacao": _vm.proposta.solemnizations
	    },
	    on: {
	      "solenizacaoAdicionada": function($event) {
	        _vm.proposta.solemnizations = $event
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_vm._m(20), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.projeto.proposal.documents,
	      "documentTypes": []
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
	    }
	  }, [_vm._m(21), _vm._v(" "), _c('upload-documentos', {
	    attrs: {
	      "propDocumentos": _vm.projeto.proposal.documentStatements,
	      "documentTypes": []
	    }
	  })], 1)]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'PARCEIRO_ESTRATEGICO') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "id": "teste",
	      "name": "teste"
	    }
	  }, [_vm._m(22), _vm._v(" "), _c('historico-proposta-old', {
	    attrs: {
	      "proposta": _vm.proposta
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(this.$router.currentRoute.name === 'visualiza-projeto') ? _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista de\n                      projetos\n                    ")]) : _vm._e()])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Acompanhamento do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Alterações no Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações introdutórias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações Gerais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "centralizado texto-claro realcado linha-abaixo-larga",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Quantidade"), _c('br'), _vm._v("Saldo\n                          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "centralizado realcado linha-abaixo-larga",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_c('span', {
	    staticClass: "texto-claro"
	  }, [_vm._v("Saldo"), _c('br'), _vm._v("Financeiro")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "centralizado texto-claro realcado linha-abaixo-larga",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Quantidade"), _c('br'), _vm._v("Saldo\n                          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "centralizado realcado linha-abaixo-larga",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_c('span', {
	    staticClass: "texto-claro"
	  }, [_vm._v("Saldo"), _c('br'), _vm._v("Financeiro")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Parcela de Adiantamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Solenização")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos Upload")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à\n                            Fundação Banco do Brasil, não contar com\n                            outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil\n                            neste projeto.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	}]}

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [(!_vm.editarLicencas && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n    Editar Cadastro de Licenças ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n      Fechar Edição (Não esqueça de Salvar) ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('div', {
	    staticStyle: {
	      "color": "red",
	      "margin-top": "5px"
	    }
	  }, [_vm._v("\n      * Estoque é salvo automaticamente\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('cadastroLicencas', {
	    attrs: {
	      "idProposta": _vm.idProposta,
	      "telaProjeto": true
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.editarLicencas && _vm.usuarioLogado.userType === 'ENTIDADE') ? _c('envioLicencas', {
	    attrs: {
	      "idProposta": _vm.idProposta
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.editarLicencas && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('validacaoLicencas', {
	    attrs: {
	      "idProposta": _vm.idProposta,
	      "nomeProjeto": _vm.nomeProjeto,
	      "numeroProjeto": _vm.numeroProjeto
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.visibleForm) ? _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Solicitações'
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("Solicitações")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(((_vm.usuarioLogado.userType !== 'FUNDACAO') && _vm.possuiProcessoEmRevisao)) ? _c('div', {
	    staticClass: "alert alert-warning",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row collapse in",
	    staticStyle: {
	      "width": "inherit",
	      "height": "auto"
	    },
	    attrs: {
	      "aria-expanded": "true",
	      "aria-hidden": "false"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "btn-group dropdown"
	  }, [(_vm._.find(_vm._.get(_vm.usuarioLogado, 'configuracoes.acesso_projetos', [{
	    'acesso': [{
	      'codigo': 'INICIA_SOLICITACAO'
	    }]
	  }]), function(p) {
	    return _vm._.find(p.acesso, function(a) {
	      return _vm._.includes(['INICIA_SOLICITACAO'], a.codigo)
	    })
	  })) ? _c('div', {
	    staticClass: "btn-group"
	  }, [(!_vm.ehParceiroEstrategico) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Nova Solicitação ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [(_vm.$root.authorize('solicitacao-pagamento-editar') && !_vm.todasPropostasSimplificadas) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'solicitacao-pagamento',
	        params: {
	          visualizacao: false
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Pagamento")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-pagamento-editar') && !_vm.todasPropostasSimplificadas) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'solicitacao-ressarcimento',
	        params: {
	          visualizacao: false
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Ressarcimento")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-adiantamento-editar')) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'solicitacao-adiantamento'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Adiantamento")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-prestacaocontas-editar') && !_vm.todasPropostasSimplificadas) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'solicitacao-prestacaocontas',
	        params: {
	          visualizacao: false
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Prestação de Contas")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-devolucaoadiantamento-editar')) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'solicitacao-devolucao-adiantamento'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Devolução de Adiantamento")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-contrapartida-editar')) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'solicitacao-contrapartida',
	        params: {
	          visualizacao: false
	        }
	      },
	      "href": "javascript:void(0)"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Contrapartida")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-contrapartida-editar')) ? _c('li', {
	    staticClass: "ng-scope",
	    attrs: {
	      "role": "menuitem"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'solicitacao-alteracoes-projeto',
	        params: {
	          visualizacao: false
	        }
	      },
	      "href": "javascript:void(0)"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" Alterações em projeto")])], 1) : _vm._e()])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-1 col-sm-4",
	    staticStyle: {
	      "margin-bottom": "1rem"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        placement: 'top'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	    }],
	    staticClass: "input-group",
	    attrs: {
	      "title": '<h5 class=\'text-left\'>Pesquise por partes da informação ou combinação deles. Exemplos:<ul><li>Número ou parte do nome do projeto<li>Um ou mais tipos de solicitação<li>Situação da solicitação<li>Data, valor etc</ul></h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa...",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSearch($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onSearch()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" ")])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.situacaoFiltro),
	      expression: "situacaoFiltro"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.situacaoFiltro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.filtrarSituacao]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": ""
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Situação")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "FEITO"
	    }
	  }, [_vm._v("Feito")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CANCELADO"
	    }
	  }, [_vm._v("Cancelado")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "EM_EXECUCAO"
	    }
	  }, [_vm._v("Em Execução")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TODOS"
	    }
	  }, [_vm._v("Todos")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-1"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        interactive: true,
	        theme: 'light',
	        position: 'top',
	        maxWidth: '600px'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', position: 'top', maxWidth: '600px'}"
	    }],
	    staticClass: "legenda",
	    attrs: {
	      "title": '<table>' +
	        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-gavel\'></i> Validar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Atribui o processo a você e abre a solicitação para validação da tarefa.</td></tr>' +
	        '<tr><td style=\'padding: 10px\'><span class=\'button--moema warning\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-pencil-square-o\'></i> Revisar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Disponível a entidade para que revise a solicitação</td></tr>' +
	        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-undo\'></i> Reanalisar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Volta o processo para Análise se ele estiver na Autorização, mas ainda não atribuído ao gerente.</td></tr>' +
	        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-repeat\'></i> Retornar tarefa FBB</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Volta o processo para Análise FBB quando ele está Em Revisão pela Entidade.</td></tr>' +
	        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-backward\'></i> Retornar Entidade</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Volta o processo para Revisão pela Entidade quando ele está em Análise pela FBB.</td></tr>' +
	        '<tr><td style=\'padding: 10px\'><span class=\'btn-danger\'  style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-times-circle\'></i> Cancelar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Cancela o processo atual e ele não será considerado no saldo do projeto</td></tr>' +
	        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'button--moema warning\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-play\'></i> Reativar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Se a solicitação estiver concluída, ela voltará para a execução na tarefa de Análise.</td></tr>' +
	        '<tr><td style=\'padding: 10px\'><span class=\'button--moema success\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-search\'></i> Visualizar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Abre janela para visualizar a solicitação feita ou cancelada</td></tr>' +
	        '<tr class=\'' + ((_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm.ehParceiroEstrategico) ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 40px;float: right;\'><i class=\'fa fa-download\'></i></span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Fará download de um arquivo ZIP contendo todos os arquivos anexados na solicitação.</td></tr>' +
	        '<tr><td style=\'padding: 10px\'><span class=\'info\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 50px;float: right; color: #fff;\'>NF-e</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Indica qual processo contém uma NF-e e permite fazer download em formato JSON</td></tr>' +
	        '</table>'
	    }
	  }, [_vm._v("\n                Legenda\n              ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.bordered,
	      "items": _vm.items,
	      "striped": "",
	      "hover": "",
	      "fields": _vm.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Faça uma pesquisa acima",
	      "table-layout:": "",
	      "fixed": ""
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "filtered": _vm.onFiltered
	    },
	    scopedSlots: _vm._u([{
	      key: "data_solicitacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "valor",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("real")(parseFloat(row.value))))]
	      }
	    }, {
	      key: "situacao",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value) + " "), _c('br'), _c('span', {
	          domProps: {
	            "innerHTML": _vm._s(row.item.info)
	          }
	        })]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(row.item.id && !_vm.ehParceiroEstrategico) ? _c('div', [(row.item.situacao !== 'Cancelado' && row.item.situacao !== 'Feito' && row.item.etapa === 'Revisão pela entidade') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "warning",
	            "size": "button--size-ss",
	            "disabled": !_vm.authorizeEditRequest(row.item) || row.item.etapa !== 'Devolvido' || !_vm.chiefActive
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.revisar(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Revisar\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && row.item.situacao !== 'Cancelado' && row.item.situacao !== 'Feito' && row.item.etapa === 'Análise' && row.item.id_usuario === null) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large'}"
	          }, {
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.revisaoEntidadeTarefa(retorno, row.item); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>Revisar </b> a solicitação de ' + '<font color=red>' + row.item.tipo_solicitacao + '</font>?' + '<br><br>' +
	                '- ID: ' + '<i><font color=#00008b>' + row.item.id + '</font></i>' + '<br>' + '- Projeto: ' + '<i><font color=#00008b>' + row.item.projeto + '</font></i>'
	            }),
	            expression: "{ok: retorno => revisaoEntidadeTarefa(retorno, row.item), cancel: doNothing, \n                          message: 'Deseja <b>Revisar </b> a solicitação de ' + '<font color=red>' + row.item.tipo_solicitacao + '</font>?' + '<br><br>'\n                          + '- ID: ' + '<i><font color=#00008b>' + row.item.id + '</font></i>' + '<br>' + '- Projeto: ' + '<i><font color=#00008b>' + row.item.projeto + '</font></i>'}"
	          }],
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "disabled": !_vm.authorizeEditRequest(row.item) || (row.item.etapa !== 'Devolvido' && row.item.etapa !== 'Análise') || !_vm.chiefActive,
	            "type": "button",
	            "title": '<h6 style=\'text-align: left\'>A tarefa será encaminhada para Revisão pela Entidade</h6>'
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-backward",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Retornar Entidade\n                      ")]) : _vm._e(), _vm._v(" "), (row.item.situacao === 'Em Execução' && row.item.etapa === 'Solicitação') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.revisar(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && row.item.etapa === 'Revisão pela entidade' && row.item.situacao != 'Cancelado' && !_vm._.includes(['Alterações do Projeto'], row.item.tipo_solicitacao)) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }, {
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.segueRetornarTarefa(retorno, row.item); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>Retornar para a FBB</b> a solicitação de ' + '<font color=' + 'red' + '>' + row.item.tipo_solicitacao + '</font>' + '? <br><br> - ID: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.id + '</font>' + '</i>' +
	                '<br> - Projeto: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.projeto + '</font>' + '</i>' + '</i>'
	            }),
	            expression: "{ok: retorno => segueRetornarTarefa(retorno, row.item), cancel: doNothing,\n                                        message: 'Deseja <b>Retornar para a FBB</b> a solicitação de ' + '<font color=' + 'red' + '>' + row.item.tipo_solicitacao + '</font>' + '? <br><br> - ID: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.id + '</font>' + '</i>'\n                                         + '<br> - Projeto: ' + '<i>'  + '<font color=' + '#00008b' + '>' + row.item.projeto + '</font>' + '</i>' + '</i>'}"
	          }],
	          attrs: {
	            "color": "dark-primary",
	            "size": "button--size-ss",
	            "type": "button",
	            "title": '<h6 style=\'text-align: left\'>' + 'A tarefa está Em Revisão pela entidade e será retornada para Análise da FBB' + '</h6>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.segueRetornarTarefa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-repeat",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Retornar tarefa FBB\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.showCancelButton(row.item)) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.cancelar(retorno, row.item); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>CANCELAR</b> a solicitação de ' + '<font color=' + 'red' + '>' + row.item.tipo_solicitacao + '</font>' + '? <br><br> - ID: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.id + '</font>' + '</i>' +
	                '<br> - Projeto: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.projeto + '</font>' + '</i>' + '</i>'
	            }),
	            expression: "{ok: retorno => cancelar(retorno, row.item), cancel: doNothing,\n                                        message: 'Deseja <b>CANCELAR</b> a solicitação de ' + '<font color=' + 'red' + '>' + row.item.tipo_solicitacao + '</font>' + '? <br><br> - ID: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.id + '</font>' + '</i>'\n                                         + '<br> - Projeto: ' + '<i>'  + '<font color=' + '#00008b' + '>' + row.item.projeto + '</font>' + '</i>' + '</i>'}"
	          }],
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss",
	            "type": "button"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-times-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Cancelar\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.validaTipoFase(row.item) && _vm.autorizaValidacao(row.item) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "type": "button"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.onValidate(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-gavel",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Validar\n                        ")]), _vm._v(" "), ((_vm._.has(row.item, 'id_usuario') && _vm._.isNull(row.item.id_usuario)) && row.item.etapa === 'Autorização' && row.item.situacao === 'Em Execução') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "type": "button"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.segueReanalisar(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-undo",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Reanalisar\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Pagamento', 'Prestação de Contas', 'Adiantamento', 'Devolução de Adiantamento', 'Contrapartida', 'Ressarcimento'], row.item.tipo_solicitacao) && row.item.situacao === 'Feito') && _vm.usuarioLogado.userType == 'FUNDACAO' && _vm.acessoReativarLiberacaoRecursos) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "warning",
	            "size": "button--size-ss",
	            "type": "button"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.solicitacaoReativar(row.item)
	            }
	          },
	          model: {
	            value: (row.item.id),
	            callback: function($$v) {
	              _vm.$set(row.item, "id", $$v)
	            },
	            expression: "row.item.id"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-play",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Reativar\n                      ")]) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Pagamento', 'Adiantamento', 'Ressarcimento'], row.item.tipo_solicitacao) && row.item.situacao === 'Feito') && _vm.usuarioLogado.userType == 'FUNDACAO' && _vm.acessoReativarLiberacaoRecursos) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "dark-primary",
	            "size": "button--size-ss",
	            "type": "button"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.solicitacaoReativarRemessa(row.item)
	            }
	          },
	          model: {
	            value: (row.item.id),
	            callback: function($$v) {
	              _vm.$set(row.item, "id", $$v)
	            },
	            expression: "row.item.id"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-repeat",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Reativar Liquidação\n                      ")]) : _vm._e(), _vm._v(" "), (row.item.tipo_solicitacao !== 'Migração') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss",
	            "type": "button"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.show(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && !_vm._.isNull(_vm._.get(row.item, 'arquivos', null))) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }],
	          attrs: {
	            "color": (_vm._.has(row.item, 'downloading') ? 'light' : 'dark') + '-primary',
	            "size": "button--size-ss",
	            "title": '<h6 style=\'text-align: left\'>' + row.item.arquivos + '</h6>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              _vm._.has(row.item, 'downloading') || _vm.onDownloadZIP(row.item)
	            }
	          }
	        }, [(_vm._.has(row.item, 'downloading')) ? _c('i', {
	          staticClass: "fa fa-refresh fa-spin"
	        }) : _c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (row.item.id && _vm.ehParceiroEstrategico) ? _c('div', [(row.item.tipo_solicitacao !== 'Migração') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss",
	            "type": "button"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.show(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar\n                      ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm._.get(row.item, 'arquivos', null))) ? _c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }],
	          attrs: {
	            "color": (_vm._.has(row.item, 'downloading') ? 'light' : 'dark') + '-primary',
	            "size": "button--size-ss",
	            "title": '<h6 style=\'text-align: left\'>' + row.item.arquivos + '</h6>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              _vm._.has(row.item, 'downloading') || _vm.onDownloadZIP(row.item)
	            }
	          }
	        }, [(_vm._.has(row.item, 'downloading')) ? _c('i', {
	          staticClass: "fa fa-refresh fa-spin"
	        }) : _c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "modal-content",
	          staticStyle: {
	            "z-index": "10000"
	          }
	        }, [_c('modal', {
	          staticClass: "topo modal-wrapper",
	          attrs: {
	            "name": "visualizar",
	            "width": "70%",
	            "height": "auto",
	            "scrollable": true
	          }
	        }, [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_c('i', {
	          staticClass: "fa fa-caret-right",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Consulta: Solicitação de " + _vm._s(_vm.textoTipo))]), _vm._v(" "), _c('div', {
	          attrs: {
	            "align": "right"
	          }
	        }, [_c('b-button', {
	          staticClass: "btn btn-warning btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-dismiss": "alert",
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.hide()
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-close",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Fechar ")])], 1)]), _vm._v(" "), _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "col-sm-12"
	        }, [_c('form', {
	          attrs: {
	            "name": "frmSearch",
	            "novalidate": ""
	          }
	        }, [_c('div', {
	          staticClass: "form-group required"
	        }, [_c('div', {
	          staticClass: "col-md-6 col-md-offset-1"
	        }, [_c('dl', {
	          staticClass: "proposal-definition-list"
	        }, [_c('dt', [_vm._v("Projeto: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.num) + " - " + _vm._s(_vm.prop))]), _vm._v(" "), _c('dt', [_vm._v("Tipo de Solicitação:")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(_vm.textoTipo))])])])]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-5"
	        }, [_c('dl', {
	          staticClass: "proposal-definition-list"
	        }, [_c('dt', [_vm._v("Etapa: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.etapaHist))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(_vm.situacao))])])])])])])])]), _vm._v(" "), (_vm.textoTipo === 'Adiantamento' && _vm.situacao !== 'Cancelado') ? _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "col-sm-12"
	        }, [_c('form', {
	          attrs: {
	            "name": "frmSearch",
	            "novalidate": ""
	          }
	        }, [_c('div', {
	          staticClass: "form-group required"
	        }, [_c('div', {
	          staticClass: "col-md-6 col-md-offset-1"
	        }, [_c('dl', {
	          staticClass: "proposal-definition-list"
	        }, [_c('dt', [_vm._v("Dados Bancários: ")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("Banco: " + _vm._s(_vm.dadosBancariosAdiantamento.banco))])]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("Agência/Conta: " + _vm._s(_vm.dadosBancariosAdiantamento.agencia) + " / " + _vm._s(_vm.dadosBancariosAdiantamento.conta))])]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("Tipo de Conta: " + _vm._s(_vm.dadosBancariosAdiantamento.tipo == 1 ? 'Conta Corrente' : 'Conta Poupança'))])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "box-body"
	        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Contrapartida' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Cronograma Físico-Financeiro")])]) : _vm._e(), _vm._v(" "), (_vm.textoTipo === 'Devolução de Adiantamento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Solicitações concedidas")])]), _vm._v(" "), _c('div', {
	          staticClass: "col-sm-12"
	        }, [_c('div', {
	          staticClass: "table-responsive"
	        }, [_c('table', {
	          staticClass: "table table-condensed table-bordered table-striped"
	        }, [_c('thead', {
	          staticStyle: {
	            "text-align": "center"
	          }
	        }, [_c('tr', [_c('td', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v("Processo de solicitação em andamento")]), _vm._v(" "), _c('td', [_vm._v("Valor liberado")]), _vm._v(" "), _c('td', [_vm._v("Valor não solicitado")]), _vm._v(" "), _c('td', [_vm._v("Data limite para prestação de contas")]), _vm._v(" "), _c('td', [_vm._v("Data da última prestação de contas")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
	          directives: [{
	            name: "repeat",
	            rawName: "v-repeat",
	            value: (_vm.adiantamento),
	            expression: "adiantamento"
	          }]
	        }, [_c('td', {
	          staticClass: "text-center"
	        }, [_vm._v(_vm._s(_vm.adiantamento.id))]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "data-title": "'Processo de solicitação em andamento'",
	            "sortable": "'projectName'"
	          }
	        }, [_vm._v(_vm._s(_vm.adiantamento.projectName + ' - ' + _vm.adiantamento.createDate))]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "data-title": "'Valor liberado'",
	            "sortable": "'valueReleased'"
	          }
	        }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantamento.totalValue)))]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "data-title": "'Valor não solicitado'",
	            "sortable": "'totalValueBalance'"
	          }
	        }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantamento.totalValueBalance)))]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "data-title": "'Data limite para prestação de contas'",
	            "sortable": "'datLimAcc'"
	          }
	        }, [_vm._v(_vm._s(_vm.adiantamento.limitDate))]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "data-title": "'Data da última prestação de contas'",
	            "sortable": "'lastDatLimAcc'"
	          }
	        }, [_vm._v(_vm._s(_vm.adiantamento.lastParcelDate || _vm.adiantamento.data_ultima_prestacao))])])]), _vm._v(" "), _c('tr', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: ((_vm.adiantamento.length === 0)),
	            expression: "(adiantamento.length === 0)"
	          }]
	        }, [_c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "colspan": "100%"
	          }
	        }, [_vm._v("Nenhum registro encontrado!")])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "row",
	          staticStyle: {
	            "overflow": "auto"
	          }
	        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Contrapartida' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', {
	          staticClass: "col-md-12 financial-physical-schedule",
	          attrs: {
	            "align": "center"
	          }
	        }, [_c('table', {
	          staticClass: "table table-condensed table-bordered"
	        }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento') ? _c('th', [_vm._v("Tipo")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), (_vm.textoTipo == 'Contrapartida') ? _c('th', [_vm._v("Economicidade")]) : _vm._e(), _vm._v(" "), _c('th', {
	          attrs: {
	            "uib-tooltip": "Quantidade a comprovar calculada a partir do somatório de todas as solicitações aprovadas ou em andamento",
	            "tooltip-append-to-body": "true"
	          }
	        }, [_vm._v("Quantidade a comprovar")]), _vm._v(" "), _c('th', {
	          attrs: {
	            "uib-tooltip": "Valor a comprovar calculado a partir do somatório de todas as solicitações aprovadas ou em andamento",
	            "tooltip-append-to-body": "true"
	          }
	        }, [_vm._v("Valor a comprovar")])])]), _vm._v(" "), _c('tbody', {
	          staticClass: "overlay"
	        }, _vm._l((_vm.montaCronograma), function(item, index) {
	          return _c('tr', {
	            key: index,
	            attrs: {
	              "item": item
	            }
	          }, [_c('td', [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao)), _c('br'), _c('div', [_vm._v("#" + _vm._s(item.Id_item) + " " + _vm._s(item.Item_Observacao))])]), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento') ? _c('td', [_vm._v(_vm._s(item.Item_Tipo))]) : _vm._e(), _vm._v(" "), _c('td', {
	            staticClass: "text-right"
	          }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
	            staticClass: "text-right"
	          }, [_vm._v(_vm._s(_vm._f("real")(parseFloat(item.Valor_orcado))))]), _vm._v(" "), _c('td', {
	            staticClass: "text-right"
	          }, [_vm._v(_vm._s(item.Qtde_solicitado))]), _vm._v(" "), _c('td', {
	            staticClass: "text-right"
	          }, [_vm._v(_vm._s(_vm._f("real")(parseFloat(item.Valor_solicitado))))]), _vm._v(" "), (_vm.textoTipo == 'Contrapartida') ? _c('td', {
	            staticClass: "text-center"
	          }, [_c('label', {
	            staticClass: "checkbox-inline new-control new-control-checkbox",
	            staticStyle: {
	              "margin-bottom": "10px"
	            }
	          }, [_c('input', {
	            directives: [{
	              name: "model",
	              rawName: "v-model",
	              value: (item.Economicidade),
	              expression: "item.Economicidade"
	            }],
	            attrs: {
	              "disabled": true,
	              "type": "checkbox",
	              "true-value": 1
	            },
	            domProps: {
	              "checked": Array.isArray(item.Economicidade) ? _vm._i(item.Economicidade, null) > -1 : _vm._q(item.Economicidade, 1)
	            },
	            on: {
	              "change": function($event) {
	                var $$a = item.Economicidade,
	                  $$el = $event.target,
	                  $$c = $$el.checked ? (1) : (false);
	                if (Array.isArray($$a)) {
	                  var $$v = null,
	                    $$i = _vm._i($$a, $$v);
	                  if ($$el.checked) {
	                    $$i < 0 && (_vm.$set(item, "Economicidade", $$a.concat([$$v])))
	                  } else {
	                    $$i > -1 && (_vm.$set(item, "Economicidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                  }
	                } else {
	                  _vm.$set(item, "Economicidade", $$c)
	                }
	              }
	            }
	          }), _vm._v(" "), _c('div', {
	            staticClass: "new-control-indicator"
	          })])]) : _vm._e(), _vm._v(" "), _c('td', {
	            staticClass: "text-right"
	          }, [_vm._v(_vm._s(item.Qtde_saldo))]), _vm._v(" "), _c('td', {
	            staticClass: "text-right"
	          }, [_vm._v(_vm._s(_vm._f("real")(parseFloat(item.Valor_saldo))))])])
	        }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	          staticStyle: {
	            "border-right": "none"
	          },
	          attrs: {
	            "colspan": "4"
	          }
	        }, [_vm._v("Valor total da solicitação: ")]), _vm._v(" "), _c('td', {
	          staticClass: "text-right",
	          staticStyle: {
	            "border-left": "none"
	          },
	          attrs: {
	            "colspan": "4"
	          }
	        }, [_vm._v(_vm._s(_vm._f("real")(parseFloat(_vm.valorTotal))))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.textoTipo === 'Adiantamento') ? _c('div', {
	          staticClass: "row",
	          staticStyle: {
	            "overflow": "auto"
	          }
	        }, [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v(" Solicitação de Adiantamento\n                                  ")])]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-12 financial-physical-schedule"
	        }, [_c('table', {
	          staticClass: "table table-condensed table-bordered",
	          attrs: {
	            "align": "center"
	          }
	        }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Parcela")]), _vm._v(" "), _c('th', [_vm._v("Recurso")]), _vm._v(" "), _c('th', [_vm._v("Fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total por fase")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar por fase")]), _vm._v(" "), _c('th', [_vm._v("Saldo restante por fase")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemAdt), function(item, index) {
	          return _c('tr', {
	            key: index,
	            attrs: {
	              "disabled": "true"
	            }
	          }, [_c('td', [_vm._v(_vm._s(item.parcela))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.origem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.origem === 1 ? 'FUNDACAO' : 'PARCEIRO ESTRATÉGICO'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm.vlrAdt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valor - (_vm.vlrAdt))))])])
	        }), 0)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', [_c('div', {
	          staticClass: "box-body"
	        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('fieldset', {
	          attrs: {
	            "disabled": "true"
	          }
	        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Documento fiscal")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "numero"
	          }
	        }, [_vm._v("Número nota fiscal:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.numero),
	            expression: "numero"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "numero",
	            "name": "numero",
	            "type": "text",
	            "maxlength": "20",
	            "disabled": "true"
	          },
	          domProps: {
	            "value": (_vm.numero)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.numero = $event.target.value
	            }
	          }
	        })])])]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "id": "emissao",
	            "for": "emissao"
	          }
	        }, [_vm._v("Data de emissão do documento:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.emissao),
	            expression: "emissao"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "name": "emissao",
	            "type": "date"
	          },
	          domProps: {
	            "value": (_vm.emissao)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.emissao = $event.target.value
	            }
	          }
	        })])])]), _vm._v(" "), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "serie"
	          }
	        }, [_vm._v("Série:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('select', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.serie),
	            expression: "serie"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "id": "serie",
	            "name": "serie",
	            "required": ""
	          },
	          on: {
	            "change": function($event) {
	              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	                return o.selected
	              }).map(function(o) {
	                var val = "_value" in o ? o._value : o.value;
	                return val
	              });
	              _vm.serie = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	            }
	          }
	        }, [_c('option', {
	          attrs: {
	            "value": "NOTA_FISCAL"
	          }
	        }, [_vm._v("1 - Nota fiscal")]), _vm._v(" "), _c('option', {
	          attrs: {
	            "value": "RECIBO_PAGAMENTO_AUTONOMO"
	          }
	        }, [_vm._v("10 - Recibo de pagamento a autônomo")]), _vm._v(" "), _c('option', {
	          attrs: {
	            "value": "DOCUMENTO_NAO_FISCAL"
	          }
	        }, [_vm._v("DNF - Documento não fiscal")])])])])]), _vm._v(" "), (_vm.validade) ? _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "validade"
	          }
	        }, [_vm._v("Data de validade do documento:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.validade),
	            expression: "validade"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "id": "validade",
	            "name": "expirationDate",
	            "type": "date"
	          },
	          domProps: {
	            "value": (_vm.validade)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.validade = $event.target.value
	            }
	          }
	        })])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('fieldset', {
	          attrs: {
	            "disabled": "true"
	          }
	        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Forma de Pagamento")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "forma"
	          }
	        }, [_vm._v("Forma de pagamento:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.forma),
	            expression: "forma"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "forma",
	            "name": "forma",
	            "type": "text",
	            "maxlength": "20",
	            "disabled": "true"
	          },
	          domProps: {
	            "value": (_vm.forma)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.forma = $event.target.value
	            }
	          }
	        })])])]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "prioridade"
	          }
	        }, [_vm._v("Pagamento Prioritário:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.prioridade),
	            expression: "prioridade"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "prioridade",
	            "name": "prioridade",
	            "type": "text",
	            "maxlength": "20",
	            "ng-disabled": "true"
	          },
	          domProps: {
	            "value": (_vm.prioridade)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.prioridade = $event.target.value
	            }
	          }
	        })])])])])]) : _vm._e()]), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('fieldset', {
	          attrs: {
	            "disabled": "true"
	          }
	        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Fornecedor")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "tipoPessoa"
	          }
	        }, [_vm._v("Tipo de pessoa:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.tipoPessoa),
	            expression: "tipoPessoa"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "tipoPessoa",
	            "name": "fornecedorTipo",
	            "type": "text",
	            "maxlength": "20"
	          },
	          domProps: {
	            "value": (_vm.tipoPessoa)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.tipoPessoa = $event.target.value
	            }
	          }
	        })])])]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4"
	        }, [_vm._v(_vm._s(_vm.texto))]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [(_vm.fornecedor.identificador.length > 11) ? _c('span', [_vm._v(_vm._s(_vm._f("cnpj")(_vm.fornecedor.identificador)))]) : _c('span', [_vm._v(_vm._s(_vm._f("cpf")(_vm.fornecedor.identificador)))])])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "nomeFornecedor"
	          }
	        }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.nomeFornecedor),
	            expression: "nomeFornecedor"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "nomeFornecedor",
	            "name": "nomeFornecedor",
	            "type": "text",
	            "maxlength": "20",
	            "disabled": "true"
	          },
	          domProps: {
	            "value": (_vm.nomeFornecedor)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.nomeFornecedor = $event.target.value
	            }
	          }
	        })])])]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "endereco"
	          }
	        }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.endereco),
	            expression: "endereco"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "endereco",
	            "name": "endereco",
	            "type": "text",
	            "maxlength": "20",
	            "disabled": "true"
	          },
	          domProps: {
	            "value": (_vm.endereco)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.endereco = $event.target.value
	            }
	          }
	        })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "cep"
	          }
	        }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.cep),
	            expression: "cep"
	          }, {
	            name: "mask",
	            rawName: "v-mask",
	            value: (['#####-###']),
	            expression: "['#####-###']"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "cep",
	            "name": "cep",
	            "type": "text",
	            "maxlength": "20",
	            "disabled": "true"
	          },
	          domProps: {
	            "value": (_vm.cep)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.cep = $event.target.value
	            }
	          }
	        })])])])])]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('fieldset', {
	          attrs: {
	            "disabled": "true"
	          }
	        }, [(_vm._.includes(['Pagamento', 'Ressarcimento'], _vm.textoTipo) && (_vm.banco !== 0)) ? _c('div', [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Dados bancários")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "row"
	        }, [_c('div', {
	          staticClass: "col-md-6"
	        }, [_c('label', {
	          staticClass: "control-label col-md-4"
	        }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('select', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.banco),
	            expression: "banco"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "name": "banco",
	            "for": "banco"
	          },
	          on: {
	            "change": function($event) {
	              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	                return o.selected
	              }).map(function(o) {
	                var val = "_value" in o ? o._value : o.value;
	                return val
	              });
	              _vm.banco = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	            }
	          }
	        }, [_c('option', {
	          attrs: {
	            "disabled": ""
	          }
	        }, [_vm._v("Escolha um banco")]), _vm._v(" "), _vm._l((_vm.bancosMain), function(banco) {
	          return _c('option', {
	            domProps: {
	              "value": banco.value
	            }
	          }, [_vm._v(_vm._s(banco.value + ' - ' + banco.label))])
	        }), _vm._v(" "), _c('option', {
	          attrs: {
	            "disabled": ""
	          }
	        }, [_vm._v("--------------------------------------------------------------------------")]), _vm._v(" "), _vm._l((_vm.bancos), function(banco) {
	          return _c('option', {
	            domProps: {
	              "value": banco.value
	            }
	          }, [_vm._v(_vm._s(banco.value + ' - ' + banco.label))])
	        })], 2)])]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "agencia"
	          }
	        }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.agencia),
	            expression: "agencia"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "agencia",
	            "name": "agencia",
	            "pattern": "/[0-9]{4}\\-{1}[0-9X]/",
	            "type": "text",
	            "maxlength": "20",
	            "ng-disabled": "true"
	          },
	          domProps: {
	            "value": (_vm.agencia)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.agencia = $event.target.value
	            }
	          }
	        })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "col-md-6"
	        }, [_c('div', [_c('label', {
	          staticClass: "control-label col-md-4",
	          attrs: {
	            "for": "conta"
	          }
	        }, [_vm._v("Conta Corrente:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-7 "
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.conta),
	            expression: "conta"
	          }],
	          staticClass: "form-control text-right",
	          attrs: {
	            "id": "conta",
	            "name": "conta",
	            "pattern": "/[0-9]{1,11}\\-{1}([0-9]{1,2}$|\\X{1}$)/",
	            "type": "text",
	            "maxlength": "20",
	            "ng-disabled": "true"
	          },
	          domProps: {
	            "value": (_vm.conta)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.conta = $event.target.value
	            }
	          }
	        })])])])])]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm._.includes(['Pagamento', 'Ressarcimento', 'Prestação de Contas', 'Contrapartida'], _vm.textoTipo)) ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Pagamento', 'Ressarcimento', 'Prestação de Contas', 'Contrapartida'], _vm.textoTipo)) ? _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('fieldset', {
	          attrs: {
	            "disabled": "true"
	          }
	        }, [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Documentos de solicitação de " + _vm._s(_vm.textoTipo))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "row"
	        }, [_c('upload-documentos-php', {
	          attrs: {
	            "name": "declaracao",
	            "propDocumentos": _vm.documentosAnexo,
	            "documentTypes": []
	          }
	        })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.textoTipo === 'Adiantamento' || _vm.textoTipo === 'Devolução de Adiantamento') ? _c('div', {
	          staticClass: "col-md-12 financial-physical-schedule"
	        }, [_c('fieldset', {
	          attrs: {
	            "disabled": "true"
	          }
	        }, [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Documentos de solicitação de " + _vm._s(_vm.textoTipo))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	          staticClass: "row"
	        }, [_c('upload-documentos-php', {
	          attrs: {
	            "name": "declaracao",
	            "propDocumentos": _vm.documentosAnexo,
	            "documentTypes": []
	          }
	        })], 1)]), _vm._v(" "), _c('div', {
	          attrs: {
	            "align": "center"
	          }
	        })]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "col-md-12"
	        }, [(_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('div', {
	          staticClass: "box box-widget"
	        }, [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Histórico de solicitação")])]), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
	          key: _vm.historicoBack.length,
	          attrs: {
	            "propsValidacao": _vm.validacao,
	            "propsHistorico": _vm.historicoBack
	          }
	        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack))) ? _c('div', {
	          staticClass: "text-left box-header"
	        }, [(_vm.esconderHistorico === false) ? _c('a', {
	          attrs: {
	            "href": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              _vm.esconderHistorico = true
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-caret-down",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
	          attrs: {
	            "href": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              _vm.esconderHistorico = false
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-caret-up",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack))) ? _c('div', {
	          staticClass: "col-md-8"
	        }, [_c('div', {
	          staticClass: "box box-widget"
	        }, [_c('div', {
	          staticClass: "box-header with-border"
	        }, [_c('h3', {
	          staticClass: "box-title"
	        }, [_vm._v("Histórico Antigo")])]), _vm._v(" "), _c('historico-antigo', {
	          key: _vm.historicoAnt.length,
	          attrs: {
	            "propsValidacao": _vm.validacao,
	            "propsHistorico": _vm.historicoAnt
	          }
	        })], 1)]) : _vm._e()])])])], 1)]
	      }
	    }], null, false, 432091264)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "8",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])]) : (_vm.visibleForm) ? _c('div', [(_vm._.includes(['Pagamento', 'Ressarcimento'], _vm.textoTipo)) ? _c('fieldset', [_c('form-validacao-pagamento', {
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsValidacao": _vm.validacao,
	      "propsHistorico": _vm.historicoTarefas
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.textoTipo === 'Contrapartida') ? _c('fieldset', [_c('form-validacao-contrapartida', {
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsValidacao": _vm.validacao
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.textoTipo === 'Prestação de Contas') ? _c('fieldset', [_c('form-validacao-prestacao-contas', {
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsValidacao": _vm.validacao
	    }
	  })], 1) : _vm._e()]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('i', {
	    staticClass: "fa fa-icon-warning-sign",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('strong', [_vm._v("Atenção:")]), _vm._v(" as solicitações que estão em revisão pela entidade e não tiverem retorno para a Fundação BB serão canceladas automaticamente após 30 (trinta) dias a contar da data de devolução para revisão.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Consulta de Solicitações")])])
	}]}

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.propsAnalise.questionario_respostas) ? _c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('origem da Proposta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Origem da Proposta")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.origemProposta,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "origem da Proposta",
	      "data-vv-as": "origem da Proposta",
	      "disabled": false
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectOrigem($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.origem_proposta),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "origem_proposta", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.origem_proposta"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('origem da Proposta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('origem da Proposta')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('número de municípios atendidos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de municípios atendidos")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.municipiosAtendidos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "número de municípios atendidos",
	      "data-vv-as": "número de municípios atendidos",
	      "disabled": true
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectMunicipios($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.municipios_atendidos),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "municipios_atendidos", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.municipios_atendidos"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('número de municípios atendidos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('número de municípios atendidos')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('prazo de execução do projeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de execução do projeto")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.prazoExecucao,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "prazo de execução do projeto",
	      "data-vv-as": "prazo de execução do projeto",
	      "disabled": true
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectPrazos($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.prazo_execucao),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "prazo_execucao", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.prazo_execucao"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('prazo de execução do projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('prazo de execução do projeto')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('natureza dos dispêndios')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Natureza dos dispêndios")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.natureza,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "natureza dos dispêndios",
	      "data-vv-as": "natureza dos dispêndios"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectNatureza($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.natureza_dispendios),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "natureza_dispendios", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.natureza_dispendios"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('natureza dos dispêndios')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('natureza dos dispêndios')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('região')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Região geográfica predominante dos municípios atendidos")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.regiaoGeografica,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "região",
	      "data-vv-as": "região",
	      "disabled": true
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectRegiao($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.regiao_predominante),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "regiao_predominante", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.regiao_predominante"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('região')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('região')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('investimento social por número de participantes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Investimento social RP+RT por número de participantes")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.investimentoSocial,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "investimento social por número de participantes",
	      "data-vv-as": "investimento social por número de participantes",
	      "disabled": false
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectInvestimento($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.investimento_social_participantes),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "investimento_social_participantes", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.investimento_social_participantes"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('investimento social por número de participantes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('investimento social por número de participantes')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('valor do investimento da FBB')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Valor do investimento da FBB (RP+RT)")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.valorInvestimento,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "valor do investimento da FBB",
	      "data-vv-as": "valor do investimento da FBB",
	      "disabled": true
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectValor($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.valor_investimento),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "valor_investimento", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.valor_investimento"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('valor do investimento da FBB')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor do investimento da FBB')))]) : _vm._e()], 1), _vm._v(" "), (_vm.propsAnalise.rating && _vm.propsAnalise.rating.classificacao && !_vm.ehSimplificada) ? _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Rating da entidade")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.rating,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "disabled": true,
	      "selectedLabel": "Selecionado",
	      "name": "rating",
	      "data-vv-as": "rating"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectRating($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.rating),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "rating", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.rating"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('reaplicacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Realização de TS certificado e/ou metodologia padronizada")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.reaplicacaoTS,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "reaplicacao",
	      "data-vv-as": "reaplicacao"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectReaplicacao($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.realizacao_ts),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "realizacao_ts", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.realizacao_ts"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('reaplicacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('reaplicacao')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('adiantamento de recursos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Adiantamento de recursos")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.adiantamento,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "adiantamento de recursos",
	      "data-vv-as": "adiantamento de recursos",
	      "disabled": true
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectAdiantamento($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.adiantamento_recursos),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "adiantamento_recursos", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.adiantamento_recursos"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('adiantamento de recursos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('adiantamento de recursos')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('utilização de recursos de terceiros')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Utilização de recursos de terceiros")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.recursosTerceiros,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "utilização de recursos de terceiros",
	      "data-vv-as": "utilização de recursos de terceiros",
	      "disabled": true
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectRT($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.recursos_terceiros),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "recursos_terceiros", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.recursos_terceiros"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('utilização de recursos de terceiros')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('utilização de recursos de terceiros')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('observância')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Observância de legislação ambiental")]), _vm._v(" "), _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.legislacaoAmbiental,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione a resposta para o item",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "observância",
	      "data-vv-as": "observância"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.onSelectLA($event)
	      }
	    },
	    model: {
	      value: (_vm.propsAnalise.questionario_respostas.legislacao_ambiental),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.questionario_respostas, "legislacao_ambiental", $$v)
	      },
	      expression: "propsAnalise.questionario_respostas.legislacao_ambiental"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('observância')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('observância')))]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.propsAnalise.ds_fase === 'ANALISE') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [(_vm._.has(_vm.propsAnalise.questionario_respostas, 'rating')) ? _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.recalcular($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Calcular Risco")]) : _vm._e(), _vm._v(" "), (_vm.riscoCalculado) ? _c('span', {
	    staticClass: "riscoCalculado"
	  }, [_vm._v("\n          Risco Calculado: "), _c('span', {
	    class: 'dado riscoNota risco' + _vm.riscoCalculado
	  }, [_vm._v(_vm._s(_vm.riscoCalculado))])]) : (_vm._.has(_vm.propsAnalise.questionario_respostas, 'rating')) ? _c('span', {
	    staticClass: "riscoCalculado riscoE"
	  }, [_vm._v(" Risco não calculado ainda")]) : _c('span', {
	    staticClass: "riscoCalculado riscoD"
	  }, [_vm._v(" Rating da Entidade não preenchido ainda")])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('legend', [_vm._v(" Questionário de riscos")])])
	}]}

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_vm._v("\n         Licenciamento Ambiental\n   ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group box-body"
	  }, [_c('div', {
	    staticClass: "column start-centered"
	  }, [_c('label', {
	    staticClass: "control-label f-required label-head"
	  }, [_vm._v("1 - As atividades propostas para o projeto são passíveis de licenciamento ambiental obrigatório?")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex centered-start indicativo-container"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.indicativo),
	      expression: "indicativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "Sim"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.indicativo, "Sim")
	    },
	    on: {
	      "change": function($event) {
	        _vm.indicativo = "Sim"
	      }
	    }
	  }), _vm._v(" Sim\n           "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.indicativo),
	      expression: "indicativo"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "Não"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.indicativo, "Não")
	    },
	    on: {
	      "input": function($event) {
	        return _vm.changeIndicativo()
	      },
	      "change": function($event) {
	        _vm.indicativo = "Não"
	      }
	    }
	  }), _vm._v(" Não\n           "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.indicativo === 'Não') ? _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.justificativaIndicativo),
	      expression: "justificativaIndicativo"
	    }],
	    staticClass: "form-control col",
	    attrs: {
	      "placeholder": "Justificativa da Seleção",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.justificativaIndicativo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.justificativaIndicativo = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.indicativo === 'Sim') ? _c('div', {
	    staticClass: "w-100 column start-centered gap-10"
	  }, [(!_vm.editarLicencaInformativa) ? _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Selecione:")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaInformativa.licenca),
	      expression: "licencaInformativa.licenca"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo de Ação",
	      "disabled": !_vm._.isEmpty(_vm.tableInformativa.items) && !_vm.cadastroProposta,
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.licencaInformativa, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.changeLicencaInformativa()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposInformativa), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.licenca
	      }
	    }, [_vm._v(_vm._s(tipo.licenca))])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Licença' && !_vm.editarLicencaInformativa) ? _c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Selecione o Tipo de Licença:")]) : _vm._e(), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Licença' && !_vm.editarLicencaInformativa) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaInformativa.licencaSelecao),
	      expression: "licencaInformativa.licencaSelecao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo de Ação",
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.licencaInformativa, "licencaSelecao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.changeLicencaInformativaSelecao()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposSelecaoInformativa), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.licenca
	      }
	    }, [_vm._v(_vm._s(tipo.licenca))])
	  })], 2) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Obrigatório durante o prazo de execução do projeto', 'Licença', ''], _vm.licencaInformativa.licenca) && !_vm.editarLicencaInformativa && _vm._.isEmpty(_vm.tableInformativa.items)) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleInformativo(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                 " + _vm._s(_vm.textoAnexoInformativo) + "\n             ")])], 1) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Obrigatório durante o prazo de execução do projeto', 'Licença', ''], _vm.licencaInformativa.licenca) && !_vm.editarLicencaInformativa && _vm.cadastroProposta) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleInformativo(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                 " + _vm._s(_vm.textoAnexoInformativo) + "\n             ")])], 1) : _vm._e(), _vm._v(" "), (_vm._.includes(['Licença'], _vm.licencaInformativa.licenca) && (!_vm._.includes(['Prévia (LP)', 'Instalação (LI)', 'Licença de Alteração (LA)', ''], _vm.licencaInformativa.licencaSelecao)) && !_vm.editarLicencaInformativa && !_vm.cadastroProposta && _vm._.isEmpty(_vm.tableInformativa.items)) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleInformativo(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                 " + _vm._s(_vm.textoAnexoInformativo) + "\n             ")])], 1) : _vm._e(), _vm._v(" "), (_vm._.includes(['Licença'], _vm.licencaInformativa.licenca) && (!_vm._.includes(['Prévia (LP)', 'Instalação (LI)', 'Licença de Alteração (LA)', ''], _vm.licencaInformativa.licencaSelecao)) && !_vm.editarLicencaInformativa && _vm.cadastroProposta && _vm._.isEmpty(_vm.tableInformativa.items)) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleInformativo(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                 " + _vm._s(_vm.textoAnexoInformativo) + "\n             ")])], 1) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Obrigatório durante o prazo de execução do projeto', ''], _vm.licencaInformativa.licenca) && !_vm.editarLicencaInformativa) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Documento cadastrado:")]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableInformativa.bordered,
	      "items": _vm.tableInformativa.items,
	      "hover": _vm.tableInformativa.hover,
	      "fields": _vm.tableInformativa.fields,
	      "filter": _vm.tableInformativa.filter,
	      "current-page": _vm.tableInformativa.currentPage,
	      "per-page": _vm.tableInformativa.perPage,
	      "sort-by": _vm.tableInformativa.sortBy,
	      "sort-desc": _vm.tableInformativa.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableInformativa, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableInformativa, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableInformativa, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableInformativa, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "edita-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.toggleInformativo(true, true)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluiInformativa(row.item); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }, {
	      key: "validade",
	      fn: function(row) {
	        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
	          staticClass: "badge badge-danger",
	          attrs: {
	            "title": "Vencida"
	          }
	        }, [_vm._v("\n                 Vencida em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
	          staticClass: "badge badge-success",
	          attrs: {
	            "title": "Dentro da validade"
	          }
	        }, [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : _vm._e()]
	      }
	    }, {
	      key: "inclusao",
	      fn: function(row) {
	        return [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]
	      }
	    }, {
	      key: "anexo",
	      fn: function(row) {
	        return [_c('a', {
	          staticClass: "ng-binding",
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onDownload(row.value[0])
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.value[0].ds_nome_arquivo))])]
	      }
	    }], null, false, 2781322628)
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaInformativa) ? _c('div', {
	    staticClass: "column start-centered edicao-container"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
	    staticClass: "w-100",
	    attrs: {
	      "propDocumentos": _vm.licencaInformativa.anexo,
	      "localUso": "LICENCIAMENTO_AMBIENTAL",
	      "maxFiles": 1
	    }
	  }), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Isento com base em legislação estadual/municipal') ? _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data da Vigência:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaInformativa.validade),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaInformativa, "validade", $$v)
	      },
	      expression: "licencaInformativa.validade"
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Embasamento Legal:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaInformativa.observacoes),
	      expression: "licencaInformativa.observacoes"
	    }],
	    staticClass: "form-control col",
	    attrs: {
	      "placeholder": "Embasamento da legislação local",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.licencaInformativa.observacoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaInformativa, "observacoes", $event.target.value)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Dispensa com base na legislação estadual/municipal') ? _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Vigência da Dispensa:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaInformativa.validade),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaInformativa, "validade", $$v)
	      },
	      expression: "licencaInformativa.validade"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Licença') ? _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de Vigência:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaInformativa.validade),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaInformativa, "validade", $$v)
	      },
	      expression: "licencaInformativa.validade"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaInformativa) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleInformativo(false, true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                   Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.adicionaInformativa()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                   Salvar ")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.mostrarDemaisLicencas && !_vm.telaProjeto) ? _c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_vm._v("\n     Procedimentos\n   ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas && !_vm.telaProjeto) ? _c('label', {
	    staticClass: "control-label f-required label-head"
	  }, [_vm._v("2 - Procedimento(s) de Licença(s) Ambiental(is) apresentada(s) na fase de análise (se houver condicionante de publicação para validade, esta comprovação deve ser anexada conjuntamente):")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas && !_vm.telaProjeto) ? _c('div', {
	    staticClass: "column all-centered w-100 gap-10"
	  }, [(!_vm.editarLicencaProcedimentos) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleProcedimento(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n           Adicionar Procedimento \n         ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editarLicencaProcedimentos) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableProcedimento.bordered,
	      "items": _vm.tableProcedimento.items,
	      "hover": _vm.tableProcedimento.hover,
	      "fields": _vm.tableProcedimento.fields,
	      "filter": _vm.tableProcedimento.filter,
	      "current-page": _vm.tableProcedimento.currentPage,
	      "per-page": _vm.tableProcedimento.perPage,
	      "sort-by": _vm.tableProcedimento.sortBy,
	      "sort-desc": _vm.tableProcedimento.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableProcedimento, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableProcedimento, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableProcedimento, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableProcedimento, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "edita-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.editaProcedimento(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluiProcedimento(row.item); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }, {
	      key: "validade",
	      fn: function(row) {
	        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
	          staticClass: "badge badge-danger",
	          attrs: {
	            "title": "Vencida"
	          }
	        }, [_vm._v("\n                 Vencida em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
	          staticClass: "badge badge-success",
	          attrs: {
	            "title": "Dentro da validade"
	          }
	        }, [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : _vm._e()]
	      }
	    }, {
	      key: "anexo",
	      fn: function(row) {
	        return [_c('a', {
	          staticClass: "ng-binding",
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onDownload(row.value[0])
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.value[0].ds_nome_arquivo))])]
	      }
	    }], null, false, 3601985519)
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaProcedimentos) ? _c('div', {
	    staticClass: "column start-centered edicao-container"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cadastro de procedimento ")]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("2 - Selecione o Procedimento: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplateProcedimento.licenca),
	      expression: "licencaTemplateProcedimento.licenca"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo de Ação",
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.licencaTemplateProcedimento, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposProcedimento), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.licenca
	      }
	    }, [_vm._v(_vm._s(tipo.licenca))])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Tipo de Procedimento: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplateProcedimento.tipo_procedimento),
	      expression: "licencaTemplateProcedimento.tipo_procedimento"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo de Ação",
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.licencaTemplateProcedimento, "tipo_procedimento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Monitoramento e Alteração"
	    }
	  }, [_vm._v("Monitoramento e Alteração")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Tipo de Licença"
	    }
	  }, [_vm._v("Tipo de Licença")])])]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
	    staticClass: "w-100",
	    attrs: {
	      "propDocumentos": _vm.licencaTemplateProcedimento.anexo,
	      "localUso": "LICENCIAMENTO_AMBIENTAL",
	      "maxFiles": 1
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered w-100 gap-10"
	  }, [_c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaTemplateProcedimento.validade),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaTemplateProcedimento, "validade", $$v)
	      },
	      expression: "licencaTemplateProcedimento.validade"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "w-80"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplateProcedimento.observacoes),
	      expression: "licencaTemplateProcedimento.observacoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Justificativa da seleção"
	    },
	    domProps: {
	      "value": (_vm.licencaTemplateProcedimento.observacoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplateProcedimento, "observacoes", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), (_vm.editarLicencaProcedimentos && !_vm.editandoLinhaProcedimento) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleProcedimento(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.adicionarProcedimento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Adicionar ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaProcedimentos && _vm.editandoLinhaProcedimento) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleProcedimento(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicaoProcedimento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Salvar Edição ")])], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_vm._v("\n         Licenças (no decorrer ou no final do projeto)\n   ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('label', {
	    staticClass: "control-label f-required label-head"
	  }, [_vm._v("3 - Quais Licenças Ambientais devem ser apresentadas no decorrer ou ao final da execução do projeto?")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('div', {
	    staticClass: "column all-centered w-100 gap-10"
	  }, [(!_vm.editarLicencaAmbiental) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleLicencaAmbiental(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n           Adicionar Licença \n         ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editarLicencaAmbiental) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableLicencaAmbiental.bordered,
	      "items": _vm.tableLicencaAmbiental.items,
	      "hover": _vm.tableLicencaAmbiental.hover,
	      "fields": _vm.tableLicencaAmbiental.fields,
	      "filter": _vm.tableLicencaAmbiental.filter,
	      "current-page": _vm.tableLicencaAmbiental.currentPage,
	      "per-page": _vm.tableLicencaAmbiental.perPage,
	      "sort-by": _vm.tableLicencaAmbiental.sortBy,
	      "sort-desc": _vm.tableLicencaAmbiental.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableLicencaAmbiental, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableLicencaAmbiental, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableLicencaAmbiental, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableLicencaAmbiental, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "edita-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.editaLicencaAmbiental(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluirLicencaAmbiental(row.item); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }, {
	      key: "prazo_apresentacao",
	      fn: function(row) {
	        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
	          staticClass: "badge badge-danger",
	          attrs: {
	            "title": "Vencida"
	          }
	        }, [_vm._v("\n                 Prazo vencido em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
	          staticClass: "badge badge-success",
	          attrs: {
	            "title": "Dentro da validade"
	          }
	        }, [_vm._v("\n               " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]) : _vm._e()]
	      }
	    }, {
	      key: "prazo_renovacao",
	      fn: function(row) {
	        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
	          staticClass: "badge badge-danger",
	          attrs: {
	            "title": "Vencida"
	          }
	        }, [_vm._v("\n                 Prazo renovação vencido em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
	          staticClass: "badge badge-success",
	          attrs: {
	            "title": "Dentro da validade"
	          }
	        }, [_vm._v("\n               " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]) : _vm._e()]
	      }
	    }, {
	      key: "anexo",
	      fn: function(row) {
	        return [_c('a', {
	          staticClass: "ng-binding",
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onDownload(row.value[0])
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.value[0].ds_nome_arquivo))])]
	      }
	    }], null, false, 4058477465)
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaAmbiental) ? _c('div', {
	    staticClass: "column start-centered edicao-container"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cadastro de Licença ")]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("2 - Selecione a Licença: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaAmbientalTemplate.licenca),
	      expression: "licencaAmbientalTemplate.licenca"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo de Ação",
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.licencaAmbientalTemplate, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposAmbientais), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.licenca
	      }
	    }, [_vm._v(_vm._s(tipo.licenca))])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered w-100 gap-10"
	  }, [_c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaAmbientalTemplate.prazo_apresentacao),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaAmbientalTemplate, "prazo_apresentacao", $$v)
	      },
	      expression: "licencaAmbientalTemplate.prazo_apresentacao"
	    }
	  })], 1), _vm._v(" "), (_vm.licencaAmbientalTemplate.licenca === 'Licença de Operação (LO)') ? _c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de Renovação:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaAmbientalTemplate.prazo_renovacao),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaAmbientalTemplate, "prazo_renovacao", $$v)
	      },
	      expression: "licencaAmbientalTemplate.prazo_renovacao"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-80"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Período de apresentação:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaAmbientalTemplate.periodo_apresentacao),
	      expression: "licencaAmbientalTemplate.periodo_apresentacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "Ao decorrer do projeto"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.licencaAmbientalTemplate.periodo_apresentacao, "Ao decorrer do projeto")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.licencaAmbientalTemplate, "periodo_apresentacao", "Ao decorrer do projeto")
	      }
	    }
	  }), _vm._v(" No decorrer do projeto\n                 "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaAmbientalTemplate.periodo_apresentacao),
	      expression: "licencaAmbientalTemplate.periodo_apresentacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "Ao final do projeto"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.licencaAmbientalTemplate.periodo_apresentacao, "Ao final do projeto")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.licencaAmbientalTemplate, "periodo_apresentacao", "Ao final do projeto")
	      }
	    }
	  }), _vm._v(" No final do projeto\n                 "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]), _vm._v(" "), (_vm.editarLicencaAmbiental && !_vm.editandoLinhaLicencaAmbiental) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleLicencaAmbiental(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.adicionarLicencaAmbiental()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Adicionar ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaAmbiental && _vm.editandoLinhaLicencaAmbiental) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleLicencaAmbiental(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicaoLicencaAmbiental()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Salvar Edição ")])], 1) : _vm._e(), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_vm._v("\n         Outros documentos obrigatórios\n   ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('label', {
	    staticClass: "control-label label-head"
	  }, [_vm._v("4 - Outros licenciamentos ou autorizações ou certificações a serem apresentados no decorrer ou ao final da execução do projeto:")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('div', {
	    staticClass: "column all-centered w-100 gap-10"
	  }, [(!_vm.editarLicencaOutras) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleLicencaOutras(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n           Adicionar Licença ou Autorização\n         ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editarLicencaOutras) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableLicencaOutra.bordered,
	      "items": _vm.tableLicencaOutra.items,
	      "hover": _vm.tableLicencaOutra.hover,
	      "fields": _vm.tableLicencaOutra.fields,
	      "filter": _vm.tableLicencaOutra.filter,
	      "current-page": _vm.tableLicencaOutra.currentPage,
	      "per-page": _vm.tableLicencaOutra.perPage,
	      "sort-by": _vm.tableLicencaOutra.sortBy,
	      "sort-desc": _vm.tableLicencaOutra.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableLicencaOutra, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableLicencaOutra, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableLicencaOutra, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableLicencaOutra, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "edita-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.editaLicencaOutras(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluirLicencaOutro(row.item); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }, {
	      key: "prazo_apresentacao",
	      fn: function(row) {
	        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
	          staticClass: "badge badge-danger",
	          attrs: {
	            "title": "Vencida"
	          }
	        }, [_vm._v("\n                 Prazo vencido em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
	          staticClass: "badge badge-success",
	          attrs: {
	            "title": "Dentro da validade"
	          }
	        }, [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : _vm._e()]
	      }
	    }, {
	      key: "anexo",
	      fn: function(row) {
	        return [_c('a', {
	          staticClass: "ng-binding",
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onDownload(row.value[0])
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.value[0].ds_nome_arquivo))])]
	      }
	    }], null, false, 3995632641)
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaOutras) ? _c('div', {
	    staticClass: "column start-centered edicao-container"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cadastro de outros documentos obrigatórios ou autorizações ")]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("2 - Selecione a Licença ou Autorização: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaOutrasTemplate.licenca),
	      expression: "licencaOutrasTemplate.licenca"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo de Ação",
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.licencaOutrasTemplate, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposOutras), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.licenca
	      }
	    }, [_vm._v(_vm._s(tipo.licenca))])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered w-100 gap-10"
	  }, [_c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Data de Apresentação do documento:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaOutrasTemplate.prazo_apresentacao),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaOutrasTemplate, "prazo_apresentacao", $$v)
	      },
	      expression: "licencaOutrasTemplate.prazo_apresentacao"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-80"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Período de apresentação:")]), _vm._v(" "), _c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaOutrasTemplate.periodo_apresentacao),
	      expression: "licencaOutrasTemplate.periodo_apresentacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "Ao decorrer do projeto"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.licencaOutrasTemplate.periodo_apresentacao, "Ao decorrer do projeto")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.licencaOutrasTemplate, "periodo_apresentacao", "Ao decorrer do projeto")
	      }
	    }
	  }), _vm._v(" No decorrer do projeto\n                 "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaOutrasTemplate.periodo_apresentacao),
	      expression: "licencaOutrasTemplate.periodo_apresentacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "Ao final do projeto"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.licencaOutrasTemplate.periodo_apresentacao, "Ao final do projeto")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.licencaOutrasTemplate, "periodo_apresentacao", "Ao final do projeto")
	      }
	    }
	  }), _vm._v(" No final do projeto\n                 "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaOutrasTemplate.observacoes),
	      expression: "licencaOutrasTemplate.observacoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Justificativa da seleção"
	    },
	    domProps: {
	      "value": (_vm.licencaOutrasTemplate.observacoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaOutrasTemplate, "observacoes", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.editarLicencaOutras && !_vm.editandoLinhaLicencaOutras) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleLicencaOutras(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.adicionarLicencaOutra()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Adicionar ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaOutras && _vm.editandoLinhaLicencaOutras) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleLicencaOutras(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicaoLicencaOutros()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Salvar Edição ")])], 1) : _vm._e(), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.cadastroProposta && _vm.telaProjeto) ? _c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_vm._v("\n     Estoque\n   ")]) : _vm._e(), _vm._v(" "), (!_vm.cadastroProposta && _vm.telaProjeto) ? _c('label', {
	    staticClass: "control-label label-head"
	  }, [_vm._v("5 - Estoque Passivo GEIMP:")]) : _vm._e(), _vm._v(" "), (_vm.telaProjeto) ? _c('div', {
	    staticClass: "column all-centered w-100 gap-10"
	  }, [(!_vm.editarLicencaEstoque && !_vm.cadastroProposta) ? _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEstoque(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n           Adicionar Licença Estoque \n         ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editarLicencaEstoque && !_vm.cadastroProposta) ? _c('b-container', {
	    staticClass: "w-100",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.tableEstoque.bordered,
	      "items": _vm.tableEstoque.items,
	      "hover": _vm.tableEstoque.hover,
	      "fields": _vm.tableEstoque.fields,
	      "filter": _vm.tableEstoque.filter,
	      "current-page": _vm.tableEstoque.currentPage,
	      "per-page": _vm.tableEstoque.perPage,
	      "sort-by": _vm.tableEstoque.sortBy,
	      "sort-desc": _vm.tableEstoque.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tableEstoque, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tableEstoque, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tableEstoque, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tableEstoque, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "edita-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.editaEstoque(row.item, row.index)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluiEstoque(row.item); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }, {
	      key: "validade",
	      fn: function(row) {
	        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
	          staticClass: "badge badge-danger",
	          attrs: {
	            "title": "Vencida"
	          }
	        }, [_vm._v("\n               Vencida em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]) : (row.value) ? _c('span', {
	          staticClass: "badge badge-success",
	          attrs: {
	            "title": "Dentro da validade"
	          }
	        }, [_vm._v("\n               " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]) : _vm._e()]
	      }
	    }, {
	      key: "anexo",
	      fn: function(row) {
	        return [_c('a', {
	          staticClass: "ng-binding",
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onDownload(row.value)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.value.ds_nome_arquivo))])]
	      }
	    }], null, false, 4176265519)
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaEstoque) ? _c('div', {
	    staticClass: "column start-centered edicao-container"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cadastro de procedimento ")]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Selecione o Documento: ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplateEstoque.licenca),
	      expression: "licencaTemplateEstoque.licenca"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Tipo de Ação",
	      "placeholder": "Selecione",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.licencaTemplateEstoque, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposLicencaTodos), function(tipo) {
	    return _c('option', {
	      domProps: {
	        "value": tipo.licenca
	      }
	    }, [_vm._v(_vm._s(tipo.licenca))])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered w-100"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
	    staticClass: "w-100",
	    attrs: {
	      "propDocumentos": _vm.licencaTemplateEstoque.anexo,
	      "localUso": "LICENCIAMENTO_AMBIENTAL",
	      "maxFiles": 1
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered w-100 gap-10"
	  }, [_c('div', {
	    staticClass: "w-20"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.licencaTemplateEstoque.validade),
	      callback: function($$v) {
	        _vm.$set(_vm.licencaTemplateEstoque, "validade", $$v)
	      },
	      expression: "licencaTemplateEstoque.validade"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "w-80"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.licencaTemplateEstoque.observacoes),
	      expression: "licencaTemplateEstoque.observacoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Justificativa da seleção"
	    },
	    domProps: {
	      "value": (_vm.licencaTemplateEstoque.observacoes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.licencaTemplateEstoque, "observacoes", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), (_vm.editarLicencaEstoque && !_vm.editandoLinhaEstoque) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEstoque(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.adicionarEstoque()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Adicionar ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaEstoque && _vm.editandoLinhaEstoque) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 sessao-salvar"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEstoque(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicaoEstoque()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n             Salvar Edição ")])], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row end-centered"
	  }, [_c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarLicencas()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n       Salvar Licenças ")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-label label-head label-aviso"
	  }, [_c('b', [_vm._v("Atenção")]), _vm._v(": o prazo de execução/vigência precisa abranger este período previsto para não haver futuros aditivos de prorrogação.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-label label-head label-aviso"
	  }, [_c('b', [_vm._v("Atenção")]), _vm._v(": o prazo de execução/vigência precisa abranger este período previsto para não haver futuros aditivos de prorrogação.")])
	}]}

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP'
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [(_vm.usuarioLogado.ds_tipo_usuario === 'ENTIDADE' && _vm.usuarioLogado.ds_cpf === null) ? _c('div', {
	    staticClass: "column all-centered aviso-edital"
	  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario === 'ENTIDADE') ? _c('div', [_c('avisosLicencas')], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439) ? _c('span', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('visualiza-pendencias-projeto')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [(_vm.usuarioLogado.userType === 'ENTIDADE') ? _c('visualiza-roteiro') : _vm._e()], 1)]), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm.chamados && _vm.chamados.length > 0) ? _c('div', {
	    staticClass: "alert alert-dismissible alert-warning"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.chamados), function(chamado) {
	    return _c('span', [_vm._v("\n        Chamado número:\n        "), _c('router-link', {
	      attrs: {
	        "target": "_blank",
	        "to": {
	          name: 'cadastro-chamado-edita',
	          params: {
	            id: chamado.id
	          }
	        }
	      }
	    }, [_c('b', [_vm._v(_vm._s(chamado.id))])]), _vm._v("\n        - " + _vm._s(chamado.status.status)), _c('br')], 1)
	  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.mensagens), function(msg) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.mensagens.length > 0),
	        expression: "mensagens.length > 0"
	      }],
	      staticClass: "alert alert-link alert-dismissible alert-warning"
	    }, [_c('button', {
	      staticClass: "close",
	      attrs: {
	        "type": "button",
	        "data-dismiss": "alert",
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          _vm.show.info = false
	        }
	      }
	    }, [_vm._v("×")]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(msg)
	      }
	    })])
	  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || !_vm._.isEmpty(_vm.projetos)) ? _c('div', [_c('AvisoMudancas')], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'ENTIDADE' && !_vm._.isEmpty(_vm.projetos)),
	      expression: "usuarioLogado.userType === 'ENTIDADE' && !_.isEmpty(projetos)"
	    }],
	    staticClass: "alert alert-link alert-dismissible",
	    staticStyle: {
	      "border": "1px solid #000000 !important",
	      "text-align": "justify",
	      "text-justify": "inter-word"
	    }
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', [_c('Integridade')], 1)], 2)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Inicial\n    ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Inicial")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), _c('b', [_vm._v("Atenção")]), _vm._v(": Esta conta permite apenas ver os projetos que já foram aprovados. Se você precisar fazer alterações ou enviar novas propostas, por favor, saia desta conta e entre novamente usando a conta do "), _c('b', [_vm._v("Representante Legal")]), _vm._v(" da sua organização.\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v("   Atenção: existe(m) chamado(s) que dependem de providências da sua instituição:")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa fa-info"
	  }), _vm._v("   Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção! Mudança de e-mail.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('p', [_vm._v("Prezados parceiros,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Informamos que o e-mail para tratar de assuntos relacionados ao andamento do projeto mudou de\n          implementação@fbb.org.br para: "), _c('strong', [_vm._v("assessoramento@fbb.org.br")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Respeitosamente e sempre à sua disposição,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n          Fundação Banco do Brasil"), _c('br')])])
	}]}

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": "SGP - Impressão da Proposta"
	    }
	  }), _vm._v(" "), _c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Impressão da Proposta\n        "), _vm._v(" "), (_vm.bloqueiaBotoes === false) ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "disabled": false,
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir ")])], 1) : _vm._e()])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    attrs: {
	      "id": "proposta"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.ultimaTarefaEntidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [(_vm._.isUndefined(_vm.ultimaTarefaEntidade) || _vm._.isNull(_vm.ultimaTarefaEntidade.termino)) ? _c('span', {
	    staticClass: "ressaltar atencao"
	  }, [_vm._v("Essa proposta ainda não foi enviada para Fundação BB")]) : _c('span', [_vm._v("\n                  Essa proposta foi enviada por\n                  "), (_vm.ultimaTarefaEntidade.usuario) ? _c('span', {
	    staticClass: "ressaltar atencao"
	  }, [_vm._v(_vm._s(_vm.ultimaTarefaEntidade.usuario.ds_nome_usuario))]) : _vm._e(), _vm._v(" em\n                  "), _c('span', {
	    staticClass: "ressaltar atencao"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ultimaTarefaEntidade.termino, "DD/MM/YYYY")))]), _vm._v(" às\n                  "), _c('span', {
	    staticClass: "ressaltar atencao"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ultimaTarefaEntidade.termino, "HH:mm")))])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Resumo do Projeto")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Nome do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.ds_nome))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Período de Realização do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ehNulo(_vm.proposta.dt_assinatura_convenio, _vm.proposta.dt_data_inicial), 'MM/YYYY')) + "  a  " + _vm._s(_vm.proposta.dataFinal) + "  (" + _vm._s(_vm.proposta.nr_periodos) + " meses)")])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalProjeto)))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalFBB)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalCtrp)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalParc)))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
	    return m.ds_municipio + '/' + m.ds_uf
	  })), function(municipio) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(municipio[0].ds_municipio))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(municipio[0].ds_uf))])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Entidade Proponente")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s((_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato)) ? (_vm.ehNulo(_vm.proposta.entidade.contato.ds_telefone, _vm.proposta.entidade.contato.ds_celular) | _vm.telefone) : ''))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_c('thead', [_c('tr', [(_vm.proposta.entidade.endereco) ? _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Endereço" + _vm._s((_vm.proposta.entidade.endereco.length > 1 ? 's' : '')))]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Complemento")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("CEP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_rua))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_numero))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_bairro))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_complemento))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(endereco.ds_cidade))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(endereco.ds_estado))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(_vm._f("cep")(endereco.ds_cep)))])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)")]), _vm._v(" "), _vm._l((_vm.proposta.entidade.dirigentes), function(dirigente) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered lista"
	    }, [_c('tbody', [(dirigente.cargo) ? _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w30"
	    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cargo")]), _vm._v(" "), (dirigente.cargo.ds_descricao) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Final do Mandato")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]) : _vm._e(), _vm._v(" "), (dirigente.contato) ? _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_rg) + " - " + _vm._s(dirigente.ds_orgao_emissor) + "/" + _vm._s(dirigente.ds_uf))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_estado_civil))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Profissão")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.ds_profissao))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Telefone")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("telefone")(dirigente.contato.ds_telefone)))])]) : _vm._e(), _vm._v(" "), (dirigente.endereco) ? _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Endereço")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.endereco.ds_rua) + ", " + _vm._s(dirigente.endereco.ds_numero) + ", " + _vm._s(dirigente.endereco.ds_bairro) + ", " + _vm._s(dirigente.endereco.ds_complemento))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("CEP")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(_vm._f("cep")(dirigente.endereco.ds_cep)))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cidade/UF")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.endereco.ds_cidade) + " / " + _vm._s(dirigente.endereco.ds_uf))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(dirigente.contato.ds_email))])]) : _vm._e()])])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.ds_nome_coordenador))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar centralizado"
	  }, [_vm._v(_vm._s(_vm._f("cpf")(_vm.proposta.ds_cpf_coordenador)))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar centralizado"
	  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.ehNulo(_vm.proposta.ds_telefone_coordenador, _vm.proposta.ds_celular_coordenador))))]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar centralizado"
	  }, [_vm._v(_vm._s(_vm.proposta.ds_email_coordenador))])])])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Introdução da Entidade Proponente")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_introducao)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_resumo)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Apresentação da Entidade Proponente")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_apresentacao)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Informação sobre Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_territorio)
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_justificativa)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_operacao)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Relacionamento com a Comunidade e Parcerias")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_parceria)
	    }
	  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Público-alvo do projeto")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.publicos_alvo), function(publico) {
	    return _c('tr', [(publico.fonte.ds_descricao) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(publico.fonte.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(publico.nr_participantes_diretos))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(publico.nr_jovens))]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar centralizado"
	    }, [_vm._v(_vm._s(publico.nr_mulheres))])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivo Geral")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
	    }
	  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_acoes_comunicacao)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos, Metas e Atividades")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed m0 obj_met_atv"
	  }, [_c('tbody', [_vm._l((_vm.proposta.objetivos), function(objetivo, idxObjetivo) {
	    return [_c('tr', {
	      staticClass: "objetivo"
	    }, [(objetivo.ds_descricao) ? _c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('span', {
	      staticClass: "tag"
	    }, [_vm._v("objetivo")]), _vm._v(_vm._s(objetivo.ds_descricao))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.proposta.metas), function(meta, idxMeta) {
	      return (_vm._.find(meta.objetivos, function(o) {
	        return o.ds_descricao === objetivo.ds_descricao
	      })) ? [_c('tr', {
	        staticClass: "meta"
	      }, [(meta.ds_descricao) ? _c('td', [_c('span', {
	        staticClass: "tag vertical"
	      }, [_vm._v("meta")]), _vm._v(_vm._s(meta.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
	        staticClass: "ressaltar"
	      }, [_vm._v(_vm._s(meta.nr_quantidade) + " " + _vm._s(meta.ds_unidade_medida))]), _vm._v(" e indicar a execução como "), _c('span', {
	        staticClass: "ressaltar"
	      }, [_vm._v(_vm._s(meta.ds_indicadores_execucao))])])]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade, idxAtividade) {
	        return (_vm._.find(atividade.metas, function(m) {
	          return m.ds_descricao === meta.ds_descricao
	        })) ? [_c('tr', {
	          staticClass: "atividade"
	        }, [(atividade.descricao) ? _c('td', [_c('span', {
	          staticClass: "tag vertical"
	        }, [_vm._v("atividade")]), _vm._v(_vm._s(atividade.descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Executar\n                              "), (atividade.inicio === atividade.termino) ? _c('span', [_vm._v(" no " + _vm._s(atividade.inicio) + "º ")]) : _c('span', [_vm._v(" do " + _vm._s(atividade.inicio) + "º  ao  " + _vm._s(atividade.termino) + "º ")]), _vm._v("\n                              mês e comprovar com "), _c('span', {
	          staticClass: "ressaltar"
	        }, [_vm._v(_vm._s(atividade.ds_documento_comprobatorio))])])])] : _vm._e()
	      }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.atividades, 'metas', meta.ds_descricao)) ? [_c('tr', {
	        staticClass: "atividade atencao"
	      }, [_c('td', {
	        attrs: {
	          "colspan": "2"
	        }
	      }, [_vm._v("* Não há atividades para a Meta acima")])])] : _vm._e()] : _vm._e()
	    }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.metas, 'objetivos', objetivo.ds_descricao)) ? [_c('tr', {
	      staticClass: "meta atencao"
	    }, [_c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("* Não há metas para o Objetivo acima")])])] : _vm._e()]
	  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cronograma de Execução das Atividades")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho w40 b1 b4"
	  }, [_vm._v("Atividade")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho direita w10 b1"
	  }, [_vm._v("Valor total")]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(mes) {
	    return _c('th', {
	      staticClass: "centralizado b1 b2 b4",
	      style: ('zoom:' + _vm.ganttZoom)
	    }, [_vm._v(_vm._s(mes + 1))])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.atividades), function(atividade) {
	    return _c('tr', [_c('td', {
	      staticClass: "ressaltar b3 b4"
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "direita b3"
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
	      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
	    }))))]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(m) {
	      return _c('td', {
	        staticClass: "centralizado b2 b3 b4",
	        style: ((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1)) ? 'background: gray !important' : '')
	      }, [((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1))) ? _c('span', {
	        style: ('zoom:' + _vm.ganttZoom + '; color: gray')
	      }, [_c('i', {
	        staticClass: "fa fa-circle"
	      })]) : _c('span', [_vm._v(" ")])])
	    })], 2)
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cursos")]), _vm._v(" "), _vm._l((_vm.proposta.cursos), function(curso) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered lista"
	    }, [_c('tbody', [_c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Título")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(curso.ds_titulo))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v("Alunos inscritos em outros cursos deste projeto?")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(('' + curso.outroCurso) === '0' ? 'Não' : 'Sim'))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Carga Horária")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(curso.nr_carga_horaria))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Qtde Educadores")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(curso.nr_qt_educadores))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Qtde de Turmas")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(curso.nr_qt_turmas))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Qtde Alunos por Turma")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar w10"
	    }, [_vm._v(_vm._s(curso.nr_qt_alunos_turma))])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_c('span', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Público-alvo")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_publico_alvo))])])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_c('span', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Conteúdo Programárico")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_conteudo))])])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_c('span', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Detalhamento do perfil/experiência/qualificação dos profissionais a serem contratados")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_perfil_profissional))])])]), _vm._v(" "), _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "8"
	      }
	    }, [_c('span', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Especificação dos serviços a serem prestados")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_especificacao_servico))])])])])])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Equipe do projeto")]), _vm._v(" "), _vm._l((_vm.proposta.equipes), function(equipe) {
	    return _c('div', [_c('table', {
	      staticClass: "table table-condensed table-bordered lista"
	    }, [_c('tbody', [_c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Cargo no projeto")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(equipe.ds_cargo))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Quantidade")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(equipe.nr_quantidade))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("É remunerado pelo projeto?")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(('' + equipe.bt_remunerado) === '0' ? 'Não' : 'Sim'))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Forma de contratação")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(equipe.ds_forma_contratacao))])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Perfil profissional pretendido")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar",
	      attrs: {
	        "colspan": "5"
	      }
	    }, [_vm._v(_vm._s(equipe.ds_perfil_desejado))]), _vm._v(" "), _c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Carga horária semanal")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(equipe.dc_carga_horaria) + " horas")])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticClass: "cabecalho"
	    }, [_vm._v("Resumo das atividades")]), _vm._v(" "), _c('td', {
	      staticClass: "ressaltar",
	      attrs: {
	        "colspan": "7"
	      }
	    }, [_vm._v(_vm._s(equipe.ds_resumo_atividades))])])])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    staticClass: "caixa_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_resultados)
	    }
	  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Orçamento do projeto - por atividade")]), _vm._v(" "), _c('table', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_vm._l((_vm.proposta.atividades), function(atividade) {
	    return [_c('tr', {
	      staticStyle: {
	        "font-weight": "bold"
	      }
	    }, [_c('td', {
	      staticClass: "esquerda nome_atividade bl1 bl3 bl4"
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado bl1 bl3"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado bl1 bl3"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
	      staticClass: "direita bl1 bl2 bl3",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
	      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
	    }))))])]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item) {
	      return _c('tr', [(!item.editando) ? [_c('td', {
	        staticClass: "bl4 b3"
	      }, [_c('span', {}, [(('' + item.origem).substr(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substr(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substr(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel).substr(0, 1) === '1') ? _c('span', {
	        staticClass: "adiantavel"
	      }, [_vm._v(" (Adiantável)")]) : _vm._e()]), _vm._v(" "), _c('span', {
	        staticClass: "esmaecido"
	      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('div', {
	        staticClass: "observacao esquerda"
	      }, [_vm._v(_vm._s(item.observacao))])]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3"
	      }, [_vm._v(_vm._s(item.periodo_inicial))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3"
	      }, [_vm._v(_vm._s(item.periodo_final))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3"
	      }, [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_unitario)))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado b3 bl2"
	      }, [_vm._v(_vm._s(_vm._f("real")(item.quantidade * item.valor_unitario)))])] : _vm._e()], 2)
	    })]
	  })], 2)])]) : _vm._e()])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "table imprimir"
	  }, [_c('tr', [_c('td', [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "direita"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "40px !important"
	    }
	  }, [_vm._v("Proposta")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Fundação")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Proponente")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Terceiros")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("E-mail")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Público-alvo")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Participantes diretos")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Jovens atendidos")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Mulheres atendidas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Atividade / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho centralizado"
	  }, [_vm._v("Valor Total")])])])
	}]}

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [(_vm.showgrid) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.formEditavel) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.inserirAtividade()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Atividade")]) : _vm._e()])]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {}, [_c('div', {
	    key: _vm.altera,
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: 'ATIVIDADES-' + _vm.atualizar,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' ? _vm._.union(_vm.table.items, _vm._.filter(_vm.propsPropostaBackup.atividades, function(a) {
	        return _vm._.includes(_vm._.get(_vm.processoSolicitacao, 'exclusao', []), a.id)
	      })) : _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "tbody-tr-class": _vm.modificacaoLinha,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "metas",
	      fn: function(row) {
	        return _vm._l((row.value), function(meta) {
	          return _c('div', [_c('span', [_vm._v(_vm._s(meta.ds_descricao))])])
	        })
	      }
	    }, {
	      key: "ds_nome",
	      fn: function(row) {
	        return [_c('div', {
	          staticStyle: {
	            "display": "flex",
	            "justify-content": "space-evenly",
	            "align-items": "center"
	          }
	        }, [(('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO') ? _c('span', {
	          staticClass: "pull-left"
	        }, [(_vm.ehItemNovo(row.item)) ? _c('span', {
	          staticClass: "label label-info"
	        }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), (_vm.ehItemExcluido(row.item)) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v("Excluído")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-block"
	          }
	        }, [_c('span', [_c('strong', [_vm._v(_vm._s(row.value))])]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_nome.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado",
	          staticStyle: {
	            "text-align": "left"
	          }
	        }, [_vm._v("\n                      " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_nome.0')) + "\n                    ")]) : _vm._e()])])]
	      }
	    }, {
	      key: "ds_documento_comprobatorio",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-block"
	          }
	        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_documento_comprobatorio.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_documento_comprobatorio.0', '0')) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "nr_periodo_inicial",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-block"
	          }
	        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_periodo_inicial.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_periodo_inicial.0', '0')) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "nr_periodo_final",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-block"
	          }
	        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_periodo_final.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_periodo_final.0', '0')) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm._.isNaN(row.item.percAtingimento) || row.item.percAtingimento < 1 || _vm._.includes(['CADASTRO', 'ANALISE', 'DEFERIMENTO', 'FORMALIZACAO', 'APROVACAO_PROJETO', 'REVISAO'], _vm.propsProposta.ds_fase)) ? _c('div', [(_vm.ehItemExcluido(row.item)) ? _c('span', [_c('b-button', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (false),
	            expression: "false"
	          }],
	          staticClass: "btn btn-warning btn-sm btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm._.remove(_vm.processoSolicitacao.exclusao, row.item.id);
	              _vm.$forceUpdate()
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-refresh",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Reincluir")])], 1) : _c('span', [(_vm.formEditavel) ? _c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm.formEditavel) ? _c('b-button', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.exclui(row); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>APAGAR</b> a atividade ' + row.item.ds_nome + ' ?'
	            }),
	            expression: "{ok: retorno => exclui(row), cancel: doNothing, message: 'Deseja <b>APAGAR</b> a atividade ' + row.item.ds_nome + ' ?'}"
	          }],
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir\n                    ")]) : _vm._e()], 1)]) : _vm._e()]
	      }
	    }], null, false, 3707088559)
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('meta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "objective"
	    }
	  }, [_vm._v("Metas:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticStyle: {
	      "font-size": "4px"
	    },
	    attrs: {
	      "options": _vm.propsMetas,
	      "multiple": true,
	      "placeholder": "Selecione um ou mais metas",
	      "label": "ds_descricao",
	      "track-by": "ds_descricao",
	      "preselect-first": false,
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "selectedLabel": "",
	      "name": "meta",
	      "value": _vm.metaIndex
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }], null, false, 579952095),
	    model: {
	      value: (_vm.metaIndex),
	      callback: function($$v) {
	        _vm.metaIndex = $$v
	      },
	      expression: "metaIndex"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('meta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('meta')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome da atividade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome da atividade: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.atividadeForm.ds_nome),
	      expression: "atividadeForm.ds_nome"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome da atividade",
	      "id": "proposal-activity-name",
	      "title": '<h5>A atividade é uma ação que será realizada para atingir o objetivo acima</h5>',
	      "placeholder": "Qual atividade será realizada para cumprir o objetivo acima",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.atividadeForm.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.atividadeForm, "ds_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome da atividade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da atividade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Documento comprobatório')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Documento comprobatório: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.atividadeForm.ds_documento_comprobatorio),
	      expression: "atividadeForm.ds_documento_comprobatorio"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Documento comprobatório",
	      "type": "text",
	      "maxlength": "255",
	      "title": '<h5>Que tipo de documento será usado para comprovar a execução da atividade?</h5>',
	      "placeholder": "Informe o tipo de documento que será usado para comprovar a execução da atividade"
	    },
	    domProps: {
	      "value": (_vm.atividadeForm.ds_documento_comprobatorio)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.atividadeForm, "ds_documento_comprobatorio", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Documento comprobatório')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Documento comprobatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin": "0 0 20px -20px !important"
	    }
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Período de início')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Período da atividade: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1"
	  }, [_c('div', [_vm._v("\n              Início:\n              "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.atividadeForm.nr_periodo_inicial),
	      expression: "atividadeForm.nr_periodo_inicial"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:' + _vm.terminoAtividade),
	      expression: "'required|min_value:1|max_value:' + terminoAtividade"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "Período de início",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.atividadeForm.nr_periodo_inicial)
	    },
	    on: {
	      "change": _vm.alteraPeriodo,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.atividadeForm, "nr_periodo_inicial", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Período de início')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Período de início')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('Período de fim')
	    }
	  }, [_c('div', {
	    staticClass: "col-md-1"
	  }, [_c('div', [_vm._v("\n              Fim:\n              "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.atividadeForm.nr_periodo_final),
	      expression: "atividadeForm.nr_periodo_final"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:' + _vm.inicioAtividade + '|max_value:' + _vm.periodoProjeto),
	      expression: "'required|min_value:' + inicioAtividade + '|max_value:' + periodoProjeto"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "Período de fim",
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.atividadeForm.nr_periodo_final)
	    },
	    on: {
	      "change": _vm.alteraPeriodo,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.atividadeForm, "nr_periodo_final", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Período de fim')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Período de fim')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.meta, _vm.atividadeForm)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [(!_vm.telaProjeto) ? _c('legend', {
	    staticStyle: {
	      "background-color": "#fcfcfc"
	    }
	  }, [_vm._v("\n     Cadastro de Licenças\n ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), (!_vm.editarLicencas) ? _c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n    Detalhar/Editar Cadastro de Licenças ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('g-button-ujarak', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "warning"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n      Cancelar ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('cadastroLicencas', {
	    attrs: {
	      "idProposta": _vm.idProposta,
	      "fecharAnalise": _vm.fecharLicencas
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.editarLicencas) ? _c('b-container', {
	    staticClass: "w-100 table-container",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "prazo_apresentacao",
	      fn: function(row) {
	        return [_vm._v("\n             " + _vm._s(row.value == '' ? '-' : _vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]
	      }
	    }, {
	      key: "data_apresentacao",
	      fn: function(row) {
	        return [(row.value == '') ? _c('div', [_c('b', [_vm._v("Não Apresentado")])]) : _c('div', [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")])]
	      }
	    }, {
	      key: "status",
	      fn: function(row) {
	        return [_c('span', {
	          class: _vm.statusClass(row.value)
	        }, [_vm._v("\n                 " + _vm._s(row.value) + "\n             ")])]
	      }
	    }, {
	      key: "tipo_licenca",
	      fn: function(row) {
	        return [_vm._v("\n                 " + _vm._s(row.value.replace('_', ' ')) + "\n             ")]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.todasLicencas) ? _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "data-cy": "exclui-licenca-procedimento"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.confirmaExclusao('Atenção, este procedimento não poderá ser desfeito. Confirma Exclusão?', function () { return _vm.preparaExclusao(row.item); })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")]) : _vm._e()]
	      }
	    }], null, false, 2664264219)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-end w-100"
	  }, [_vm._v("\n             (" + _vm._s(_vm.table.items.length) + ") Licenças Encontradas\n         ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(0), _vm._v(" "), (_vm.eventosDisponiveis.length > 0) ? _c('div', [_c('label', [_vm._v("Eventos")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.solenizacao),
	      expression: "solenizacao"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "profiles"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.solenizacao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.eventosDisponiveis), function(evento) {
	    return _c('option', {
	      domProps: {
	        "value": evento
	      }
	    }, [_vm._v(_vm._s(evento.event))])
	  }), 0), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "uib-tooltip": "Inclui um evento na tabela abaixo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addEvent(_vm.solenizacao)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir Evento")])]) : _vm._e(), _vm._v(" "), (_vm.eventosTabela.length > 0) ? _c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('table', {
	    staticClass: "table",
	    attrs: {
	      "ng-table": "tableEvents"
	    }
	  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.eventosTabela), function(evento, eventoIndex) {
	    return _c('tbody', [_c('tr', {
	      staticClass: "ng-table-group",
	      attrs: {
	        "ng-hide": "eventos.event === ''"
	      }
	    }, [_c('td', [_c('strong', [_vm._v(_vm._s(evento.event))])]), _vm._v(" "), _c('td', [_c('button', {
	      staticClass: "btn btn-sm btn-flat",
	      attrs: {
	        "type": "button",
	        "ng-disabled": "!solemnizationCtrl.isNewAvaiable()",
	        "ng-class": "{'btn-danger':solemnizationCtrl.approvalState!='VIEW_TYPE', 'btn-default':solemnizationCtrl.approvalState=='VIEW_TYPE'}"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDelete(evento, eventoIndex)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])])])])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', [_c('ol', [_c('li', [_vm._v("A Convenente informará à FBB pelo e-mail fbb.imprensa@fbb.org.br, 30 dias antes da data de assinatura do convênio:\n        "), _c('ul', [_c('li', [_vm._v("Entidade convenente, responsável legal e contatos")]), _vm._v(" "), _c('li', [_vm._v("Objeto do convênio")]), _vm._v(" "), _c('li', [_vm._v("Data, local e horário provável do evento")]), _vm._v(" "), _c('li', [_vm._v("Autoridades precistas no cerimonial e nº de participantes")]), _vm._v(" "), _c('li', [_vm._v("Programação prévia e contatos da imprensa local")])])]), _c('li', [_vm._v("Informar no Assunto do e-mail: Nº e nome do Projeto - Assinatura de convênio")]), _vm._v(" "), _c('li', [_vm._v("A Convenente fará, obrigatoriamente, a cobertura fotográfica do evento, com uso de, no mínimo, um banner indicativo do investimento social da FBB"), _c('br'), _vm._v("\n        e enviará as fotos com resolução mínima 320 x 233 pixels ou o equivalente a 150 DPI, formato 12 x 10 cm, similar ou proporcional.\n      ")]), _vm._v(" "), _c('li', [_vm._v("No evento deverá participar funcionário do BB.")]), _vm._v(" "), _c('li', [_vm._v("Se possível, a Convenente fará a filmagem e/ou cobertura fotográfica de outras fases do convênio e divulgará em sua página na Internet.")]), _vm._v(" "), _c('li', [_vm._v("Após o evento, enviar foto para o e-mail descrito no item 1.")])])]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin": "30px"
	    }
	  }, [_vm._v("Valor Padrão (Após Criação):"), _c('br'), _vm._v("\n      Cifrato: Não\n    ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('td', [_c('strong', [_vm._v("Tabela de Eventos Adicionados")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Ações")])])])])
	}]}

/***/ }),
/* 2060 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.formEditavel) ? _c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova equipe")]) : _vm._e()])]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "bt_remunerado",
	      fn: function(row) {
	        return [_vm._v(_vm._s(('' + row.value) === '1' ? 'Sim' : 'Não'))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.formEditavel) ? _c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.exclui(row); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>APAGAR</b> o item ' + row.item.ds_cargo + ' ?'
	            }),
	            expression: "{ok: retorno => exclui(row), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> o item ' + row.item.ds_cargo + ' ?'}"
	          }],
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cargo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v("Cargo no projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.ds_cargo),
	      expression: "equipe.ds_cargo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cargo",
	      "type": "text",
	      "maxlength": "255",
	      "data-vv-as": "Cargo no Projeto"
	    },
	    domProps: {
	      "value": (_vm.equipe.ds_cargo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "ds_cargo", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('cargo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cargo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('quantidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "quantidade"
	    }
	  }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    attrs: {
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.nr_quantidade),
	      expression: "equipe.nr_quantidade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "quantidade",
	      "type": "number",
	      "min": "1",
	      "max": "2147483647",
	      "data-vv-as": "Quantidade"
	    },
	    domProps: {
	      "value": (_vm.equipe.nr_quantidade)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "nr_quantidade", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('perfil profissional pretendido')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "perfilProf"
	    }
	  }, [_vm._v("Perfil profissional pretendido:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.ds_perfil_desejado),
	      expression: "equipe.ds_perfil_desejado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Informar a escolaridade",
	      "data-vv-as": "Perfil profissional pretendido",
	      "name": "perfil profissional pretendido",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.equipe.ds_perfil_desejado)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "ds_perfil_desejado", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('perfil profissional pretendido')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('perfil profissional pretendido')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('forma de contratação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "formaContratacao"
	    }
	  }, [_vm._v("Forma de contratação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.ds_forma_contratacao),
	      expression: "equipe.ds_forma_contratacao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "forma de contratação",
	      "data-vv-as": "Forma de contratação"
	    },
	    on: {
	      "select": _vm.buscaFormaContratacao,
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.equipe, "ds_forma_contratacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.formasContratacao), function(forma) {
	    return _c('option', {
	      domProps: {
	        "value": forma
	      }
	    }, [_vm._v(_vm._s(forma))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('forma de contratação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma de contratação')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('carga horaria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "cargaHoraria"
	    }
	  }, [_vm._v("Carga horária semanal:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.dc_carga_horaria),
	      expression: "equipe.dc_carga_horaria"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "carga horaria",
	      "type": "number",
	      "min": "1",
	      "max": "2147483647",
	      "data-vv-as": "Carga horária semanal"
	    },
	    domProps: {
	      "value": (_vm.equipe.dc_carga_horaria)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "dc_carga_horaria", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("Horas")])]), _vm._v(" "), (_vm.errors.first('carga horaria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('carga horaria')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('remunerado pelo projeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "remunerado"
	    }
	  }, [_vm._v("É remunerado pelo projeto?")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.bt_remunerado),
	      expression: "equipe.bt_remunerado"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "remunerado pelo projeto",
	      "data-vv-as": "É remunerado pelo projeto?"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.equipe, "bt_remunerado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('remunerado pelo projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('remunerado pelo projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Resumo das atividades')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "resumoAtividade"
	    }
	  }, [_vm._v("Resumo das atividades:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('textarea', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.equipe.ds_resumo_atividades),
	      expression: "equipe.ds_resumo_atividades"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Resumo das atividades",
	      "placeholder": "Descreva as principais atividades que serão executadas no projeto por esse(s) proficional(is)",
	      "rows": "3",
	      "data-vv-as": "Resumo das atividades"
	    },
	    domProps: {
	      "value": (_vm.equipe.ds_resumo_atividades)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.equipe, "ds_resumo_atividades", $event.target.value)
	      }
	    }
	  }, [_vm._v("              " + _vm._s(_vm.equipe.ds_resumo_atividades) + "\n            ")])]), _vm._v(" "), (_vm.errors.first('Resumo das atividades')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resumo das atividades')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2061 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column start-centered indicativo-container"
	  }, [_c('div', [_vm._v("Indique a agência de abertura de conta para movimentação dos recursos do Projeto:")]), _vm._v(" "), (!this.gravando) ? _c('div', {
	    staticClass: "column start-centered indicativo-agencia-container"
	  }, [_c('div', {
	    staticClass: "row-flex centered-start indicativo-form"
	  }, [_c('label', {
	    staticClass: "control-label indicativo-label f-required",
	    attrs: {
	      "for": "título do curso"
	    }
	  }, [_vm._v("Agência:")]), _vm._v(" "), _c('the-mask', {
	    staticClass: "form-control indicativo-input",
	    attrs: {
	      "mask": '####',
	      "name": "título do curso",
	      "type": "text"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.digitandoAgencia()
	      }
	    },
	    model: {
	      value: (_vm.consultaAgencia),
	      callback: function($$v) {
	        _vm.consultaAgencia = $$v
	      },
	      expression: "consultaAgencia"
	    }
	  })], 1), _vm._v(" "), (this.consultando) ? _c('div', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), (!this.consultando && this.agenciaSelecionada.nomeAgencia !== '') ? _c('div', {
	    staticClass: "column start-centered indicativo-info-container"
	  }, [_c('div', {
	    staticClass: "row start-centered"
	  }, [_c('label', [_vm._v("Número: ")]), _vm._v(" " + _vm._s(this.agenciaSelecionada.agencia) + "\n         ")]), _vm._v(" "), _c('div', {
	    staticClass: "row start-centered"
	  }, [_c('label', [_vm._v("Nome: ")]), _vm._v(" " + _vm._s(this.agenciaSelecionada.nomeAgencia) + "\n         ")]), _vm._v(" "), _c('div', {
	    staticClass: "row start-centered"
	  }, [_c('label', [_vm._v("E-mail: ")]), _vm._v(" " + _vm._s(this.agenciaSelecionada.emailAgencia) + "\n         ")])]) : _vm._e()]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }],
	    attrs: {
	      "options": _vm.listaBancos,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Selecione um banco",
	      "custom-label": _vm.bancoNome,
	      "track-by": "codigo",
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "banco",
	      "data-vv-as": "banco",
	      "disabled": _vm.$attrs.disabled
	    },
	    on: {
	      "select": _vm.selecionaBanco
	    },
	    model: {
	      value: (_vm.bancoSelecionado),
	      callback: function($$v) {
	        _vm.bancoSelecionado = $$v
	      },
	      expression: "bancoSelecionado"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('banco')))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2063 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarOpcoes),
	      expression: "mostrarOpcoes"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "quadro_opcoes",
	    style: ('min-height: ' + ((_vm.atividades.length * 30) + 20) + 'px;')
	  }, [_c('div', {
	    staticClass: "zoom"
	  }, [_vm._v("Zoom no gantt "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.zoom),
	      expression: "zoom"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.zoom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm._.range([_vm.start = 1], 3, [_vm.step = .5])), function(z) {
	    return _c('option', [_vm._v(_vm._s(z))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "margem"
	  }, [_vm._v("Distância das atividades "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tamanho_nome_atividade),
	      expression: "tamanho_nome_atividade"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.tamanho_nome_atividade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm._.range([_vm.start = 400], 700, [_vm.step = 50])), function(d) {
	    return _c('option', [_vm._v(_vm._s(d))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "tipo_barra"
	  }, [_vm._v("Mostrar execução por "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipo_barra),
	      expression: "tipo_barra"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.tipo_barra = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "financeiro"
	    }
	  }, [_vm._v("% do orçado / liberado")]), _c('option', {
	    attrs: {
	      "value": "declarado"
	    }
	  }, [_vm._v("% informado no relatório")])])]), _vm._v(" "), _c('div', {
	    staticClass: "mostrar_exec_financeira"
	  }, [_vm._v("Mostrar Valor Liberado e Orçado "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mostrar_execucao_financeira),
	      expression: "mostrar_execucao_financeira"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mostrar_execucao_financeira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": true
	    }
	  }, [_vm._v("Sim")]), _c('option', {
	    domProps: {
	      "value": false
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
	    staticClass: "mostrar_exec_declarada"
	  }, [_vm._v("Mostrar Percentual Declarado "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mostrar_execucao_declarada),
	      expression: "mostrar_execucao_declarada"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mostrar_execucao_declarada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": true
	    }
	  }, [_vm._v("Sim")]), _c('option', {
	    domProps: {
	      "value": false
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), _c('div', [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large'}"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": '<h5>Clique para trazer os dados salvos até o momento</h5>'
	    },
	    on: {
	      "click": _vm.carregaAtividades
	    }
	  }, [_c('i', {
	    class: 'fa fa-refresh'
	  }), _vm._v(" Atualizar o gráfico")])])])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "col-md-12 gantt_atividades",
	    style: (_vm.projeto.hoje_dias ? '' : 'margin-left: -15px')
	  }, [_c('div', [_c('div', {
	    staticClass: "cabecalho"
	  }, [_c('div', {
	    staticClass: "linha_marcadoras",
	    style: ('height: ' + ((_vm.atividades.length * 30) + 30) + 'px;')
	  }, [_c('div', {
	    staticClass: "titulo",
	    style: ('width: ' + _vm.tamanho_nome_atividade + 'px')
	  }, [_vm._v("Atividades")]), _vm._v(" "), _vm._l((_vm.projeto.periodos), function(periodo) {
	    return _c('div', {
	      staticClass: "periodos_projeto",
	      style: ('margin-left: ' + (parseInt(_vm.tamanho_nome_atividade) + ((30 * _vm.zoom) * (periodo - 1))) + 'px;' + 'width: ' + (30 * _vm.zoom) + 'px;')
	    }, [_vm._v(_vm._s(periodo) + "\n            ")])
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.projeto.hoje_dias),
	      expression: "projeto.hoje_dias"
	    }],
	    staticClass: "hoje",
	    style: ('margin-left: ' + (parseInt(_vm.tamanho_nome_atividade) + ((_vm.projeto.hoje_dias < ((_vm.projeto.periodos * 30) + 30) ? _vm.projeto.hoje_dias : ((_vm.projeto.periodos * 30) + 30))) * _vm.zoom) + 'px; height: ' + ((_vm.atividades.length * 30) + 60) + 'px; padding: ' + ((_vm.atividades.length * 30) + 40) + 'px 10px 0px 5px;')
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        theme: 'light'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', theme: 'light'}"
	    }],
	    attrs: {
	      "title": '<h5>' + (_vm.dia_noite === 'DIA' ? 'Bom dia!' : _vm.dia_noite === 'TARDE' ? 'Boa Tarde!' : 'Boa noite!') + '<br/> Já se passaram <b>' + _vm.projeto.hoje_dias + ' dias' + '</b> do início do projeto</h5>'
	    }
	  }, [_c('i', {
	    class: _vm.dia_noite === 'DIA' ? 'fa fa-sun-o' : _vm.dia_noite === 'TARDE' ? 'fa fa-sun-o' : 'fa fa-moon-o'
	  }), _vm._v(" Hoje")])])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "atividades",
	    style: ('width: ' + ((30 * _vm.projeto.periodos * _vm.zoom) + parseInt(_vm.tamanho_nome_atividade) + 150) + 'px')
	  }, _vm._l((_vm.atividades), function(atividade) {
	    return _c('div', {
	      staticClass: "atividade"
	    }, [_c('div', {
	      staticClass: "nome_atividade quebrar_texto",
	      style: ('width: ' + _vm.tamanho_nome_atividade + 'px')
	    }, [_vm._v(_vm._s(atividade.descricao))]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large'}"
	      }],
	      staticClass: "barra",
	      style: ('margin-left: ' + (atividade.dias_inicio * _vm.zoom) + 'px; width: ' + (((atividade.dias_termino - atividade.dias_inicio) * _vm.zoom)) + 'px'),
	      attrs: {
	        "title": _vm.projeto.hoje_dias === null ? '<h5>' + atividade.descricao + '</h5>' : ('<h5>' +
	          atividade.descricao +
	          '<hr>' +
	          'Duração: ' + atividade.dias_termino + ' dias<br/>' +
	          '% Tempo decorrido: <span class=\'realce\'>' + (_vm.projeto.hoje_dias <= atividade.dias_inicio ? 0 : _vm.projeto.hoje_dias >= atividade.dias_termino ? 100 : ((_vm.projeto.hoje_dias / atividade.dias_termino) * 100) | _vm.percentage) + '%</span>' +
	          '<hr>' +
	          'Orçado: R$ ' + (parseFloat(atividade.orcado) | _vm.real) + '<br/>' +
	          'Liberado: R$ ' + (parseFloat(atividade.executado) | _vm.real) + '<br/>' +
	          '% Lib. Financeira: <span class=\'realce\'>' + (_vm.percentualExecutado(atividade.orcado, atividade.executado) | _vm.percentage) + '%</span>' +
	          '<hr>' +
	          '% Execução da Atividade: <span class=\'realce\'>' + (_vm._.isNil(atividade.execucao) ? '0' : atividade.execucao) + '%' + '</span></h5>')
	      }
	    }, [_c('div', {
	      class: (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) >= 0 &&
	        (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) < 100 ? 'atividade_executada alinha_esquerda sem_tamanho' : (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) >= 100 ? 'atividade_completa' : 'atividade_erro alinha_esquerda sem_tamanho',
	      style: ('width: ' + (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) + '% !important')
	    }, [(_vm.mostrar_execucao_financeira && parseFloat(atividade.executado) > 0 && (parseFloat(atividade.executado) < parseFloat(atividade.orcado))) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(parseFloat(atividade.executado))))]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
	      staticClass: "atividade_prevista alinha_esquerda",
	      style: ('width: ' + (100 - (_vm.tipo_barra === 'declarado' && !_vm._.isNil(atividade.execucao) ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado))) + '% !important')
	    }, [_c('span', [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
	      staticClass: "info_adicional"
	    }, [(_vm.mostrar_execucao_financeira) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(parseFloat(atividade.orcado))))]) : _vm._e(), _vm._v(" "), (_vm.mostrar_execucao_declarada) ? _c('span', {
	      staticClass: "percentual_execucao"
	    }, [_vm._v(_vm._s(atividade.execucao) + "%")]) : _vm._e()])])
	  }), 0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.projeto.hoje_dias),
	      expression: "projeto.hoje_dias"
	    }],
	    staticClass: "rodape"
	  }, [_c('div', {
	    staticClass: "opcoes",
	    on: {
	      "click": function($event) {
	        _vm.mostrarOpcoes = !_vm.mostrarOpcoes
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" Opções\n          ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        interactive: true,
	        theme: 'light',
	        trigger: 'click'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', trigger: 'click'}"
	    }],
	    staticClass: "legenda",
	    attrs: {
	      "title": '<table class=\'legenda_tabela\'>' +
	        '<tr><td class=\'atividade_executada\'>&nbsp;</td><td>Total liberado em pagamento, prestação de contas e contrapartidas</td></tr>' +
	        '<tr><td class=\'atividade_prevista\'>&nbsp;</td><td> Atividade prevista, valor não liberado </td></tr>' +
	        '<tr><td class=\'atividade_completa\'>&nbsp;</td><td> Atividade financeiramente completada </td></tr>' +
	        '<tr><td class=\'atividade_erro\'>&nbsp;</td><td> Erro de preenchimento da execução da atividade no relatório </td></tr>' +
	        '<tr><td style= \'background: #ca1b1b61\'>&nbsp;</td><td> Data atual no projeto </td></tr>' +
	        '</table>'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  }), _vm._v(" Legenda\n          ")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block",
	      "z-index": "100"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper listaPropostas",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": "SGP - Listagem de Propostas"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Propostas")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Lista',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row collapse in",
	    staticStyle: {
	      "width": "inherit",
	      "height": "auto"
	    },
	    attrs: {
	      "aria-expanded": "true",
	      "aria-hidden": "false"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('download-excel', {
	    attrs: {
	      "data": _vm._.filter(_vm.json_data, function(p) {
	        return _vm._.includes(_vm._.toLower(p.NomeEntidade + p.ds_nome + p.ds_fase + p.ds_numero_edital), _vm._.toLower(_vm.table.filter))
	      }),
	      "meta": _vm.json_meta,
	      "type": "xls",
	      "fields": _vm.json_fields,
	      "name": "propostas.xls"
	    }
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Exportar para Excel")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid ng-valid-mask ng-valid-maxlength ng-valid-date",
	    attrs: {
	      "name": "frmSearch",
	      "id": "filtroProposta",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-sm-offset-2 col-md-8"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 text-right"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "onclick": "location.reload(true)",
	      "color": "success",
	      "size": "button--size-ss"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atualizar Lista")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "ds_numero_edital",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value === '' ? 'Prospecção Direta' : row.value))]
	      }
	    }, {
	      key: "NomeEntidade",
	      fn: function(row) {
	        return [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	          staticClass: "esmaecido"
	        }, [_vm._v("[ "), _c('b', [_vm._v(_vm._s(row.item.id))]), _vm._v(" ]")]) : _vm._e(), _c('span', {
	          staticClass: "esmaecido"
	        }, [_vm._v(" " + _vm._s(_vm._f("cnpj")(row.item.ds_cnpj)))]), _vm._v(" " + _vm._s(row.value) + " "), (row.item.ds_codigo_projeto_erp) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(row.item.ds_codigo_projeto_erp) + ")")])]) : _vm._e()]
	      }
	    }, {
	      key: "dt_criado",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "ds_fase",
	      fn: function(row) {
	        return [(_vm.ehEdital(row.item)) ? _c('span', [(_vm._.includes(['CADASTRO', 'REVISAO', '', 'ANALISE'], row.value)) ? _c('span', [(!_vm.ehEditalAtivoNaoFinalizado(row.item)) ? _c('span', [_vm._v("Edital finalizado")]) : _vm._e(), _vm._v(" "), (_vm.ehEditalAtivoNaoFinalizado(row.item)) ? _c('span', [_vm._v("Edital em andamento")]) : _vm._e(), _vm._v(" "), (!_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm._.includes(['ANALISE'], row.value) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'proposta-edita',
	              params: {
	                id: row.item.id,
	                processo: row.item.ds_fase
	              }
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.enumeradores[row.value]))])], 1) : _vm._e(), _vm._v(" "), (!_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm._.includes(['REVISAO'], row.value) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('br'), _vm._v(" "), _c('router-link', {
	          attrs: {
	            "to": {
	              name: 'proposta-edita',
	              params: {
	                id: row.item.id,
	                processo: row.item.ds_fase
	              }
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.enumeradores[row.value]))])], 1) : _vm._e()]) : _c('span', {
	          class: _vm._.includes(['ANULACAO', 'ANULADO'], row.value) ? 'text-red' : (_vm._.includes(['APROVADO'], row.value) ? 'text-green' : '')
	        }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['ANULACAO', 'ANULADO', 'APROVADO'], row.value) && !_vm.editalComLimitacaoAcesso()) ? _c('span', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'proposta-edita',
	              params: {
	                id: row.item.id,
	                processo: row.item.ds_fase
	              }
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.enumeradores[row.value]))])], 1) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.value]))])])]) : _c('span', {
	          class: _vm._.includes(['ANULACAO', 'ANULADO'], row.value) ? 'text-red' : (_vm._.includes(['APROVADO'], row.value) ? 'text-green' : '')
	        }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['ANULACAO', 'ANULADO', 'APROVADO'], row.value)) ? _c('span', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'proposta-edita',
	              params: {
	                id: row.item.id,
	                processo: row.item.ds_fase
	              }
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.enumeradores[row.value]))])], 1) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.value]))])])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(!_vm.ehEdital(row.item) || (_vm.ehEdital(row.item) && ((_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType !== 'FUNDACAO') || (!_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType === 'FUNDACAO')))) ? _c('span', [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	          }],
	          attrs: {
	            "color": "primary",
	            "target": "_blank",
	            "size": "button--size-ss",
	            "disabled": false,
	            "title": '<h5>Mostra uma versão para impressão do que já foi preenchida da proposta</h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'imprimir-proposta',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-file-text",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Versão para impressão \n                      ")]), _vm._v(" "), (_vm.ehEdital(row.item) && (_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType !== 'FUNDACAO') && row.item.ds_fase === 'ANALISE') ? _c('g-button-ujarak', {
	          staticClass: "btn-primary",
	          staticStyle: {
	            "margin-top": "10px"
	          },
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.alteraTarefaPropostaEdital(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Revisar Proposta\n                      ")]) : _vm._e(), _vm._v(" "), ((_vm.$root.authorize('proposta-cadastro-completo') || _vm.$root.authorize('minha-proposta-editar')) && (_vm._.includes(['CADASTRO', 'REVISAO', ''], row.item.ds_fase) || _vm._.isNull(row.item.ds_fase))) ? _c('div', [_c('div', [_c('g-button-ujarak', {
	          staticClass: "btn-primary",
	          staticStyle: {
	            "margin-top": "10px"
	          },
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'proposta-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.ds_fase === 'CADASTRO' || _vm._.isNull(row.item.ds_fase) ? 'Editar' : (row.item.ds_fase === 'REVISAO' ? 'Revisar' : '')) + "\n                          ")]), _vm._v(" "), (row.item.ds_fase === 'ANALISE') ? _c('g-button-ujarak', {
	          staticClass: "btn-primary",
	          staticStyle: {
	            "margin-top": "10px"
	          },
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'proposta-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver para revisão\n                          ")]) : _vm._e()], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.ehEdital(row.item) && ((!_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType !== 'FUNDACAO')))) ? _c('span', [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	          }],
	          attrs: {
	            "color": "primary",
	            "target": "_blank",
	            "size": "button--size-ss",
	            "disabled": false,
	            "title": '<h5>Mostra uma versão para impressão do que já foi preenchida da proposta</h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'imprimir-proposta',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-file-text",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Versão para impressão\n                      ")]), _vm._v(" "), (_vm.ehEdital(row.item) && (_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType !== 'FUNDACAO') && row.item.ds_fase === 'ANALISE') ? _c('g-button-ujarak', {
	          staticClass: "btn-primary",
	          staticStyle: {
	            "margin-top": "10px"
	          },
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.alteraTarefaPropostaEdital(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Revisar Proposta\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.ehEditalExcecao(row.item)) ? _c('g-button-ujarak', {
	          staticClass: "btn-primary",
	          staticStyle: {
	            "margin-top": "10px"
	          },
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'proposta-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.ds_fase === 'CADASTRO' || _vm._.isNull(row.item.ds_fase) ? 'Editar' : (row.item.ds_fase === 'REVISAO' ? 'Revisar' : '')) + "\n                        ")]) : _vm._e(), _vm._v(" "), ((_vm.$root.authorize('proposta-cadastro-completo') || _vm.$root.authorize('minha-proposta-editar')) && (_vm._.includes(['CADASTRO', 'REVISAO', ''], row.item.ds_fase) || _vm._.isNull(row.item.ds_fase)) && _vm.ehEditalAtivoNaoFinalizado(row.item)) ? _c('div', [_c('div', [_c('g-button-ujarak', {
	          staticClass: "btn-primary",
	          staticStyle: {
	            "margin-top": "10px"
	          },
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'proposta-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.ds_fase === 'CADASTRO' || _vm._.isNull(row.item.ds_fase) ? 'Editar' : (row.item.ds_fase === 'REVISAO' ? 'Revisar' : '')) + "\n                          ")]), _vm._v(" "), (row.item.ds_fase === 'ANALISE') ? _c('g-button-ujarak', {
	          staticClass: "btn-primary",
	          staticStyle: {
	            "margin-top": "10px"
	          },
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'proposta-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver para revisão\n                          ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), ((_vm.$root.authorize('proposta-cadastro-completo') || _vm.$root.authorize('minha-proposta-editar')) && (_vm._.includes(['REVISAO', ''], row.item.ds_fase) || _vm._.isNull(row.item.ds_fase))) ? _c('div', [_c('div', [_c('g-button-ujarak', {
	          staticClass: "btn-primary",
	          staticStyle: {
	            "margin-top": "10px"
	          },
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'proposta-edita',
	                params: {
	                  id: row.item.id
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.ds_fase === 'CADASTRO' || _vm._.isNull(row.item.ds_fase) ? 'Editar' : (row.item.ds_fase === 'REVISAO' ? 'Revisar' : '')) + "\n                          ")])], 1)]) : _vm._e()], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Lista de Propostas")])])
	}]}

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Solicitações'
	    }
	  }), _vm._v(" "), _c('h1', [_c('i', {
	    staticClass: "fa fa-file-pdf-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" BAIXANDO ARQUIVO... " + _vm._s(_vm.$route.params.id))])], 1), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column all-centered overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-cloud-download prest-scale"
	  }), _vm._v("\n        Aguarde...\n   ")])
	}]}

/***/ }),
/* 2066 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("FAV")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Lista',
	        href: '#'
	      }, {
	        text: 'FAV',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "disabled": !this.$root.authorize('fav-editar'),
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-fav-nova'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Fav ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "situation",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.$router.push({
	                name: 'cadastro-fav-edita',
	                params: {
	                  fav: row.item
	                }
	              })
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v("  Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "warning",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.inativa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.situation ? ' Inativar' : ' Ativar'))])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Fav")])])
	}]}

/***/ }),
/* 2067 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento
	      }
	    }, [_vm._v(_vm._s(documento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-3"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file"
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })])]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Vigencia')
	    },
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "Vigencia"
	    }
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-3"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dt_data_vigencia),
	      expression: "dt_data_vigencia"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('validdate'),
	      expression: "'validdate'"
	    }],
	    ref: "Vigencia",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "Vigencia",
	      "id": "Vigencia",
	      "data-vv-as": "Vigencia",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.dt_data_vigencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dt_data_vigencia = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Vigencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Vigencia')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.cancelar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "padding": "0px"
	    }
	  }, [(_vm.disable === false) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": '<h5>Cadastrar novo participante</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.novoParticipante()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Novo Participante")])]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "padding": "0px"
	    }
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": '<h5>Busca Participantes de Relatórios Anteriores</h5>',
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.buscarParticipantes()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-family": "Arial",
	      "font-size": "small"
	    }
	  }, [_vm._v(" Buscar(GETEC)")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Exportar o conteúdo da listagem para Excel</h5>'
	    }
	  }, [_c('download-excel', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "data": _vm.json_data,
	      "meta": _vm.json_meta,
	      "type": "xls",
	      "fields": _vm.json_fields,
	      "name": _vm.nomeExcel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Exportar para Excel\n              ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('span', {
	    staticClass: "box-title control-label",
	    staticStyle: {
	      "font-size": "medium"
	    }
	  }, [_vm._v(_vm._s(_vm.table.items.length) + " " + _vm._s(_vm.table.items.length > 1 ? 'participantes cadastrados' : 'participante cadastrado') + "\n            "), (_vm.$route.params.row.item.sequencia > 1) ? _c('span', {
	    staticClass: "text-muted"
	  }, [(_vm.propsRelatorio.tipo_relatorio === 'FINAL') ? _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle icone_ajuda",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>O sistema mostra todos os participantes cadastrados anteriormente, excluindo duplicidade de CPF e nome.<br/>A instituição poderá alterar ou excluir participantes neste Relatório Final.</h5>'
	    }
	  }) : _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-question-circle icone_ajuda",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>O sistema mostra todos os participantes cadastrados anteriormente, excluindo duplicidade de CPF e nome.<br/>A instituição poderá alterar ou excluir participantes somente no Relatório Final.</h5>'
	    }
	  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "tabelaUsuarios",
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "data_nascimento",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.disable || (_vm._.has(row.item, 'editavel') && row.item.editavel === 0 && _vm.propsRelatorio.tipo_relatorio === 'PARCIAL')) ? _c('span', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.visualiza(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar")])], 1) : _c('span', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	          attrs: {
	            "color": "error",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.exclui(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome do Participante')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "nomeParticipante"
	    }
	  }, [_vm._v("Nome Completo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participantes.nome),
	      expression: "participantes.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "nomeParticipante",
	      "name": "Nome do Participante",
	      "type": "text",
	      "maxlength": "255",
	      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
	    },
	    domProps: {
	      "value": (_vm.participantes.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.participantes, "nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome do Participante')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome do Participante')))]) : _vm._e()])])])]), _vm._v(" "), (_vm.calculaIdade < 18) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "cpfParticipante"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf'),
	      expression: "'cpf'"
	    }],
	    ref: "cpfParticipante",
	    staticClass: "form-control",
	    attrs: {
	      "id": "cpfParticipante",
	      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0),
	      "name": "CPF do Participante",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.participantes.cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.participantes, "cpf", $$v)
	      },
	      expression: "participantes.cpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CPF do Participante')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF do Participante')))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.calculaIdade > 18) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('CPF do Participante')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "cpfParticipante"
	    }
	  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    ref: "cpfParticipante",
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0),
	      "name": "CPF do Participante",
	      "type": "text",
	      "mask": '###.###.###-##'
	    },
	    model: {
	      value: (_vm.participantes.cpf),
	      callback: function($$v) {
	        _vm.$set(_vm.participantes, "cpf", $$v)
	      },
	      expression: "participantes.cpf"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CPF do Participante')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF do Participante')))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Data de nascimento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "Data de nascimento"
	    }
	  }, [_vm._v("\n              Data de nascimento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dt_nascimento_participante),
	      expression: "dt_nascimento_participante"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|dateeqpast'),
	      expression: "'required|validdate|dateeqpast'"
	    }],
	    ref: "Data de nascimento",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "Data de nascimento",
	      "name": "Data de nascimento",
	      "data-vv-as": "Data de nascimento",
	      "masked": _vm.masked,
	      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
	    },
	    domProps: {
	      "value": (_vm.dt_nascimento_participante)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dt_nascimento_participante = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Data de nascimento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Data de nascimento')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [(_vm.dt_nascimento_participante) ? _c('span', [_vm._v(" Idade: "), _c('b', [_vm._v(_vm._s(_vm.calculaIdade))]), _vm._v(" anos")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "foneParticipante"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('the-mask', {
	    ref: "foneParticipante",
	    staticClass: "form-control",
	    attrs: {
	      "id": "foneParticipante",
	      "name": "Telefone do Participante",
	      "type": "text",
	      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0),
	      "masked": false,
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.participantes.telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.participantes, "telefone", $$v)
	      },
	      expression: "participantes.telefone"
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Sexo do Participante')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "sexoParticipante"
	    }
	  }, [_vm._v("Gênero:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participantes.sexo),
	      expression: "participantes.sexo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "sexoParticipante",
	    staticClass: "form-control",
	    attrs: {
	      "id": "sexoParticipante",
	      "name": "Sexo do Participante",
	      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.participantes, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Masculino"
	    }
	  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Feminino"
	    }
	  }, [_vm._v("Feminino")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Não Binário"
	    }
	  }, [_vm._v("Não Binário")])])]), _vm._v(" "), (_vm.errors.first('Sexo do Participante')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Sexo do Participante')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Escolaridade do Participante')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "escParticipante"
	    }
	  }, [_vm._v("Escolaridade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participantes.escolaridade),
	      expression: "participantes.escolaridade"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "escParticipante",
	    staticClass: "form-control",
	    attrs: {
	      "id": "escParticipante",
	      "name": "Escolaridade do Participante",
	      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.participantes, "escolaridade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Analfabeto"
	    }
	  }, [_vm._v("Analfabeto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ensino Fundamental"
	    }
	  }, [_vm._v("Ensino Fundamental")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ensino Médio"
	    }
	  }, [_vm._v("Ensino Médio")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Superior Incompleto"
	    }
	  }, [_vm._v("Superior Incompleto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Superior Completo"
	    }
	  }, [_vm._v("Superior Completo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Pós-graduação"
	    }
	  }, [_vm._v("Pós-graduação")])])]), _vm._v(" "), (_vm.errors.first('Escolaridade do Participante')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Escolaridade do Participante')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('ufParticipante')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "ufParticipante"
	    }
	  }, [_vm._v("UF:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participantes.UF),
	      expression: "participantes.UF"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ufParticipante",
	      "id": "ufParticipante",
	      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.participantes, "UF", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.carregaMunicipios(_vm.participantes.UF)
	      }]
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.participantes.UF,
	      "selected": _vm.participantes.UF
	    }
	  }, [_vm._v(_vm._s(_vm.participantes.UF))]), _vm._v(" "), _vm._l((_vm.estados), function(uf) {
	    return _c('option', {
	      domProps: {
	        "value": uf
	      }
	    }, [_vm._v(_vm._s(uf))])
	  })], 2)]), _vm._v(" "), (_vm.errors.first('ufParticipante')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo UF do participante é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('munParticipante')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3",
	    attrs: {
	      "for": "munParticipante"
	    }
	  }, [_vm._v("Municipio:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.municipios,
	      "id": "munParticipante",
	      "multiple": false,
	      "disabled": !_vm.participantes.UF || _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0),
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um Município",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaListaMunicipios,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "munParticipante"
	    },
	    model: {
	      value: (_vm.participantes.municipio),
	      callback: function($$v) {
	        _vm.$set(_vm.participantes, "municipio", $$v)
	      },
	      expression: "participantes.municipio"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('munParticipante')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Município do participante é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "descricao-publico-alvo-container"
	  }, [_c('publicoAlvoDescricao', {
	    ref: "publicoAlvoDescricao",
	    attrs: {
	      "proposta": _vm.propsRelatorio.id_proposta,
	      "idParticipante": _vm.idParticipante,
	      "fixado": true,
	      "permiteEditar": _vm.permiteEditarDescricao,
	      "abrirAbas": true,
	      "telaParticipante": true,
	      "tipoDescricao": "REALIZADO",
	      "dataNascimentoEdit": _vm.dt_nascimento_participante,
	      "sexoEdit": _vm.participantes.sexo,
	      "escolaridadeEdit": _vm.participantes.escolaridade
	    },
	    on: {
	      "descricaoParticipanteDefs": function($event) {
	        _vm.descricaoParticipante = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row container-botoes"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [(!(_vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0))) ? _c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-team-add"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-team-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n              ")])])])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    style: ('min-height: ' + _vm.alturaContentWrapper + 'px' + (_vm.ehAcessoPorLink ? ';margin-left: 0; background: white;' : ''))
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Edição de Sumário Executivo'
	    }
	  }), _vm._v(" "), (!_vm.ehAcessoPorLink) ? _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm._.isNull(_vm.sumarioCarregado.id) ? 'Novo Sumário' : (_vm.ehVisualizacao ? 'Visualiza' : 'Edição de') + ' sumário executivo ID ' + _vm.sumarioCarregado.id))]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('span', [(_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', [(_vm.salvaSumario.statusSalvamento !== 'PROCESSANDO') ? _c('g-button-moema', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    attrs: {
	      "color": "primary",
	      "type": "button",
	      "title": '<h5>Ao clicar ele criará este sumério no sistema para uso. Então antes de fazê-lo verifique se não existe um sumário executivo desejado já criado</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cria novo sumário")]) : _vm._e(), _vm._v(" "), (_vm.salvaSumario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
	    staticClass: "button--moema warning",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 50px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-borda-dark) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Criando Sumário ...")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', [(_vm.salvaSumario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
	    staticClass: "button--moema warning",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 50px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-borda-dark) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Salvando")]) : (_vm.salvaSumario.statusSalvamento === 'FEITO') ? _c('span', {
	    staticClass: "button--moema success",
	    staticStyle: {
	      "font-size": "12px",
	      "padding": "8px 10px 10px 15px",
	      "border-radius": "2px !important",
	      "background": "var(--cor-verde) !important",
	      "cursor": "not-allowed"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" Sumário salvo")]) : _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarEdicao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar alterações")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'lista-sumario-executivo'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm._.isNull(_vm.participanteEditando) && _vm._.isNull(_vm.investimentoEditando)) ? _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimir()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir")]) : _vm._e()], 1), _vm._v(" "), (!_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', {
	    attrs: {
	      "stylple": "float: right; font-size: 14px;margin: 14px 10px 0 0"
	    }
	  }, [_vm._v("última atualização em " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.updated_at, "DD/MM/YYYY HH:mm:ss")))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.ehAcessoPorLink) ? _c('section', {
	    staticClass: "content",
	    attrs: {
	      "id": "sumario"
	    }
	  }, [_c('div', {
	    staticClass: "row nao_imprimir"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('acao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Ação")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sumarioCarregado.sumario.acao),
	      expression: "sumarioCarregado.sumario.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "acao",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "acao",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Título do evento</h5>'
	    },
	    domProps: {
	      "value": (_vm.sumarioCarregado.sumario.acao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sumarioCarregado.sumario, "acao", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('acao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O título do evento (ação) a ser realizada é obrigatório")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Data")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    class: {
	      'has-error': _vm.errors.first('data')
	    },
	    attrs: {
	      "type": "date",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "name": "data",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "disabled-dates": {
	        to: new Date(new Date().getTime() - 86400000)
	      },
	      "format": "dd/MM/yyyy",
	      "title": '<h5>Data da ação</h5>'
	    },
	    model: {
	      value: (_vm.sumarioCarregado.sumario.data),
	      callback: function($$v) {
	        _vm.$set(_vm.sumarioCarregado.sumario, "data", $$v)
	      },
	      expression: "sumarioCarregado.sumario.data"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Horário")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sumarioCarregado.sumario.inicio),
	      expression: "sumarioCarregado.sumario.inicio"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "inicio",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Horário de Início</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.sumarioCarregado.sumario, "inicio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.horarios), function(hora) {
	    return _c('option', [_vm._v(_vm._s(hora))])
	  }), 0)])]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sumarioCarregado.sumario.termino),
	      expression: "sumarioCarregado.sumario.termino"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "termino",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Horário de término</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.sumarioCarregado.sumario, "termino", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm._.takeRight(_vm.horarios, (_vm.horarios.length - (_vm._.indexOf(_vm.horarios, _vm.sumarioCarregado.sumario.inicio))))), function(hora) {
	    return _c('option', [_vm._v(_vm._s(hora))])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Local")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sumarioCarregado.sumario.local),
	      expression: "sumarioCarregado.sumario.local"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "local",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "local",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Local onde será a ação</h5>'
	    },
	    domProps: {
	      "value": (_vm.sumarioCarregado.sumario.local)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sumarioCarregado.sumario, "local", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('objeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Objeto")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sumarioCarregado.sumario.objeto),
	      expression: "sumarioCarregado.sumario.objeto"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "objeto",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "objeto",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>O objeto da ação</h5>'
	    },
	    domProps: {
	      "value": (_vm.sumarioCarregado.sumario.objeto)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sumarioCarregado.sumario, "objeto", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('objeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O objeto da ação é obrigatório")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('finalidade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Finalidade")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "col-md-10",
	    attrs: {
	      "title": '<h5>Finalidade da ação</h5>'
	    }
	  }, [_c('quill-editor', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "refQuillEditor",
	    attrs: {
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "options": _vm.quillOptionsCompleto,
	      "name": "finalidade"
	    },
	    model: {
	      value: (_vm.sumarioCarregado.sumario.finalidade),
	      callback: function($$v) {
	        _vm.$set(_vm.sumarioCarregado.sumario, "finalidade", $$v)
	      },
	      expression: "sumarioCarregado.sumario.finalidade"
	    }
	  }), _vm._v(" "), (_vm.errors.first('finalidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" A Finalidade da ação é obrigatória")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('sinopse')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Sinopse")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "col-md-10",
	    attrs: {
	      "title": '<h5>Sinopse da ação</h5>'
	    }
	  }, [_c('quill-editor', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "refQuillEditor",
	    attrs: {
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "options": _vm.quillOptionsCompleto,
	      "name": "sinopse"
	    },
	    model: {
	      value: (_vm.sumarioCarregado.sumario.sinopse),
	      callback: function($$v) {
	        _vm.$set(_vm.sumarioCarregado.sumario, "sinopse", $$v)
	      },
	      expression: "sumarioCarregado.sumario.sinopse"
	    }
	  }), _vm._v(" "), (_vm.errors.first('sinopse')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" A Sinopse da ação é obrigatória")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('participantes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Participantes / Interlocutores")]), _vm._v(" "), (_vm._.isNull(_vm.participanteEditando)) ? _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "w20"
	  }, [_vm._v("Participante")]), _vm._v(" "), _c('th', [_vm._v("Interlocutores")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Mostrar / Ocultar")]), _vm._v(" "), (_vm._.isNull(_vm.investimentoEditando)) ? _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.novoParticipante()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (!_vm.ehVisualizacao && (_vm._.get(_vm.sumarioCarregado, 'sumario.participantes', [])).length > 0) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.sumarioCarregado.sumario.participantes = []
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Excluir Todos")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('draggable', _vm._b({
	    attrs: {
	      "group": "lista_participantes",
	      "disabled": _vm.ehVisualizacao,
	      "tag": "tbody"
	    },
	    model: {
	      value: (_vm.sumarioCarregado.sumario.participantes),
	      callback: function($$v) {
	        _vm.$set(_vm.sumarioCarregado.sumario, "participantes", $$v)
	      },
	      expression: "sumarioCarregado.sumario.participantes"
	    }
	  }, 'draggable', {
	    animation: 200,
	    group: 'lista_participantes',
	    disabled: false,
	    ghostClass: 'ghost'
	  }, false), _vm._l((_vm._.get(_vm.sumarioCarregado, 'sumario.participantes', [])), function(participante, idx) {
	    return _c('tr', {
	      staticClass: "handle_conteudo",
	      staticStyle: {
	        "cursor": "grab"
	      }
	    }, [_c('td', [_vm._v(_vm._s(participante.participante))]), _vm._v(" "), _c('td', [(_vm._.get(participante, 'interlocutores', []).length > 0) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      attrs: {
	        "title": '<h5>' + _vm._.join(_vm._.map(participante.interlocutores, function(i) {
	          return i.nome + ' (' + i.cargo + ')'
	        }), ', ') + '</h5>'
	      }
	    }, [_vm._v("\n                                " + _vm._s(_vm._.join(_vm._.map(_vm._.take(participante.interlocutores, 2), function(i) {
	      return i.nome + ' (' + i.cargo + ')'
	    }), ', ')) + "\n                                "), (_vm._.get(participante, 'interlocutores', []).length > 2) ? _c('span', [_vm._v(" ... mais " + _vm._s(participante.interlocutores.length - 2))]) : _vm._e()]) : _c('span', {
	      staticClass: "label label-danger"
	    }, [_vm._v("Sem interlocutores")])]), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	      }],
	      staticClass: "text-left indicadores-cb-inline w10 text-center",
	      attrs: {
	        "title": '<h5>Mostra ou Oculta na impressão</h5>'
	      }
	    }, [(!_vm.ehVisualizacao) ? _c('i', {
	      class: (_vm._.get(participante, 'mostrarParticipante', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	      on: {
	        "click": function($event) {
	          return _vm.mostrarOcultar(participante, 'mostrarParticipante')
	        }
	      }
	    }) : _c('i', {
	      class: (_vm._.get(participante, 'mostrarParticipante', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	      staticStyle: {
	        "color": "var(--cor-fraca)"
	      }
	    })]), _vm._v(" "), (!_vm.ehVisualizacao && _vm._.isNull(_vm.investimentoEditando)) ? _c('td', {
	      staticClass: "text-right w30 text-center"
	    }, [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editaParticipante(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplicaParticipante(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.removeParticipante(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('td', {
	      staticClass: "text-right w30 text-center"
	    }, [_c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editaParticipante(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-user",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Detalhar")])], 1)])
	  }), 0)], 1)]) : _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "well",
	    style: ('background: ' + (!_vm._.isNull(_vm.interlocutorEditando) ? '#fff' : '#f1f6ff'))
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('participante')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Participante")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participanteEditando.participante),
	      expression: "participanteEditando.participante"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "participante",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "participante",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Organização participante da ação</h5>'
	    },
	    domProps: {
	      "value": (_vm.participanteEditando.participante)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.buscaParticipantesJaCadastrados()
	      },
	      "blur": function($event) {
	        return _vm.ocultaListaParticipantesJaCadastrados()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.participanteEditando, "participante", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('participante')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Participante é obrigatório")]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pesquisa.participantes),
	      expression: "loading.pesquisa.participantes"
	    }],
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "display": "block",
	      "font-size": "20px",
	      "color": "var(--cor-destaque)"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm.pesquisa.participantes.mostrar && _vm.pesquisa.participantes.lista.length > 0) ? _c('div', {
	    staticClass: "pesquisa_autocomplete"
	  }, [_c('ul', _vm._l((_vm.pesquisa.participantes.lista), function(item) {
	    return _c('li', {
	      staticClass: "truncar",
	      on: {
	        "click": function($event) {
	          return _vm.selecionaParticipanteJaCadastrado(item)
	        }
	      }
	    }, [_vm._v(_vm._s(item.nomfor))])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Logomarca")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [(!_vm._.has(_vm.participanteEditando, 'logomarca.ds_nome_arquivo')) ? _c('span', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "logomarca",
	    attrs: {
	      "type": "file",
	      "name": "logomarca",
	      "id": "logomarca",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando)
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })]) : (_vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando)) ? _c('span', {
	    staticStyle: {
	      "color": "var(--cor-destaque)"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "max-height": "16px",
	      "max-width": "30px"
	    },
	    attrs: {
	      "src": _vm.participanteEditando.logomarca.file
	    }
	  }), _vm._v("\n                              " + _vm._s(_vm.participanteEditando.logomarca.ds_nome_arquivo) + "\n                            ")]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticStyle: {
	      "color": "var(--cor-destaque)",
	      "cursor": "pointer"
	    },
	    attrs: {
	      "title": '<h5>Clique para alterar a logomarca</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.participanteEditando.logomarca = {}
	      }
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "max-height": "16px",
	      "max-width": "30px"
	    },
	    attrs: {
	      "src": _vm.participanteEditando.logomarca.file
	    }
	  }), _vm._v("\n                              " + _vm._s(_vm.participanteEditando.logomarca.ds_nome_arquivo) + " "), _c('i', {
	    staticClass: "fa fa-pencil"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Sobre\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarSobre', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	    on: {
	      "click": function($event) {
	        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarSobre')
	      }
	    }
	  }) : _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarSobre', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('quill-editor', {
	    ref: "refQuillEditor",
	    attrs: {
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "options": _vm.quillOptionsCompleto,
	      "name": "sobre"
	    },
	    model: {
	      value: (_vm.participanteEditando.sobre),
	      callback: function($$v) {
	        _vm.$set(_vm.participanteEditando, "sobre", $$v)
	      },
	      expression: "participanteEditando.sobre"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Grupo/empresa(s)\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarGrupoEmpresa', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	    on: {
	      "click": function($event) {
	        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarGrupoEmpresa')
	      }
	    }
	  }) : _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarGrupoEmpresa', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participanteEditando.grupo),
	      expression: "participanteEditando.grupo"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "grupo",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "grupo",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Grupo de empresas que faz parte se houver</h5>'
	    },
	    domProps: {
	      "value": (_vm.participanteEditando.grupo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.participanteEditando, "grupo", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Segmento de atuação\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarSegmentoAtuacao', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	    on: {
	      "click": function($event) {
	        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarSegmentoAtuacao')
	      }
	    }
	  }) : _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarSegmentoAtuacao', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participanteEditando.atuacao),
	      expression: "participanteEditando.atuacao"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "atuacao",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "atuacao",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Informar qual o segmento de atuação da organização se houver</h5>'
	    },
	    domProps: {
	      "value": (_vm.participanteEditando.atuacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.participanteEditando, "atuacao", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Histórico\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarHistorico', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	    on: {
	      "click": function($event) {
	        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarHistorico')
	      }
	    }
	  }) : _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarHistorico', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('quill-editor', {
	    ref: "refQuillEditor",
	    attrs: {
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "options": _vm.quillOptionsCompleto,
	      "name": "historico"
	    },
	    model: {
	      value: (_vm.participanteEditando.historico),
	      callback: function($$v) {
	        _vm.$set(_vm.participanteEditando, "historico", $$v)
	      },
	      expression: "participanteEditando.historico"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Interlocutores\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarInterlocutores', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	    on: {
	      "click": function($event) {
	        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarInterlocutores')
	      }
	    }
	  }) : _c('i', {
	    class: (_vm._.get(_vm.participanteEditando, 'mostrarInterlocutores', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  })]), _vm._v(" "), (_vm._.isNull(_vm.interlocutorEditando)) ? _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered",
	    staticStyle: {
	      "background": "white"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Cargo")]), _vm._v(" "), (_vm._.isNull(_vm.investimentoEditando)) ? _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.novoInterlocutor()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (!_vm.ehVisualizacao && (_vm._.get(_vm.participanteEditando, 'interlocutores', [])).length > 0) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.participanteEditando.interlocutores = []
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Excluir Todos")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('draggable', _vm._b({
	    attrs: {
	      "group": "lista_interlocutores",
	      "disabled": _vm.ehVisualizacao,
	      "tag": "tbody"
	    },
	    model: {
	      value: (_vm.participanteEditando.interlocutores),
	      callback: function($$v) {
	        _vm.$set(_vm.participanteEditando, "interlocutores", $$v)
	      },
	      expression: "participanteEditando.interlocutores"
	    }
	  }, 'draggable', {
	    animation: 200,
	    group: 'lista_interlocutores',
	    disabled: false,
	    ghostClass: 'ghost'
	  }, false), _vm._l((_vm._.get(_vm.participanteEditando, 'interlocutores', [])), function(interlocutor, idx2) {
	    return _c('tr', {
	      staticClass: "handle_conteudo",
	      staticStyle: {
	        "cursor": "grab"
	      }
	    }, [_c('td', [_vm._v(_vm._s(interlocutor.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(interlocutor.cargo))]), _vm._v(" "), (!_vm.ehVisualizacao && _vm._.isNull(_vm.investimentoEditando)) ? _c('td', {
	      staticClass: "text-right w30",
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editaInterlocutor(_vm.participanteEditando, idx2)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplicaInterlocutor(_vm.participanteEditando, idx2)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.removeInterlocutor(_vm.participanteEditando, idx2)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('td', {
	      staticClass: "text-right w30",
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editaInterlocutor(_vm.participanteEditando, idx2)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-user",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Detalhar")])], 1)])
	  }), 0)], 1)]) : _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "well",
	    style: ('background: ' + (!_vm._.isNull(_vm.interlocutorEditando) ? '#f1f6ff' : '#fff'))
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.interlocutorEditando.nome),
	      expression: "interlocutorEditando.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "nome",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Nome da pessoa que estará na ação representando o participante</h5>'
	    },
	    domProps: {
	      "value": (_vm.interlocutorEditando.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.interlocutorEditando, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Nome do interlocutor é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cargo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Cargo")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.interlocutorEditando.cargo),
	      expression: "interlocutorEditando.cargo"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "cargo",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "cargo",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando),
	      "title": '<h5>Cargo do interlocutor na organização participante</h5>'
	    },
	    domProps: {
	      "value": (_vm.interlocutorEditando.cargo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.interlocutorEditando, "cargo", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cargo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Cargo do interlocutor é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.interlocutorEditando.linkedin),
	      expression: "interlocutorEditando.linkedin"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "linkedin",
	    staticClass: "form-control",
	    attrs: {
	      "type": "url",
	      "name": "linkedin",
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando),
	      "placeholder": "https://www.linkedin.com/in/...",
	      "title": '<h5>Url para o currículo digital no Linkedin, se houver</h5>'
	    },
	    domProps: {
	      "value": (_vm.interlocutorEditando.linkedin)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.interlocutorEditando, "linkedin", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && _vm._.isNull(_vm.investimentoEditando)) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.okEdicaoInterlocutor(_vm.participanteEditando)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelaEdicaoInterlocutor(_vm.participanteEditando)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando) ? 'Fechar' : 'Cancelar'))])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [(_vm._.isNull(_vm.interlocutorEditando)) ? _c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && _vm._.isNull(_vm.investimentoEditando)) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.okEdicaoParticipante()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelaEdicaoParticipante()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando) ? 'Fechar' : 'Cancelar'))])], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('investimentos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Investimento socioambiental")]), _vm._v(" "), (_vm._.isNull(_vm.investimentoEditando)) ? _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "w20"
	  }, [_vm._v("Origem")]), _vm._v(" "), _c('th', [_vm._v("Investimento")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Mostrar / Ocultar")]), _vm._v(" "), (_vm._.isNull(_vm.participanteEditando)) ? _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.novoInvestimento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Incluir")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (!_vm.ehVisualizacao && (_vm._.get(_vm.sumarioCarregado, 'sumario.investimentos', [])).length > 0) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.sumarioCarregado.sumario.investimentos = []
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Excluir Todos")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('draggable', _vm._b({
	    attrs: {
	      "group": "lista_investimentos",
	      "disabled": _vm.ehVisualizacao,
	      "tag": "tbody"
	    },
	    model: {
	      value: (_vm.sumarioCarregado.sumario.investimentos),
	      callback: function($$v) {
	        _vm.$set(_vm.sumarioCarregado.sumario, "investimentos", $$v)
	      },
	      expression: "sumarioCarregado.sumario.investimentos"
	    }
	  }, 'draggable', {
	    animation: 200,
	    group: 'lista_investimentos',
	    disabled: false,
	    ghostClass: 'ghost'
	  }, false), _vm._l((_vm._.get(_vm.sumarioCarregado, 'sumario.investimentos', [])), function(investimento, idx) {
	    return _c('tr', {
	      staticClass: "handle_conteudo",
	      staticStyle: {
	        "cursor": "grab"
	      }
	    }, [_c('td', [_vm._v(_vm._s(investimento.origem))]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Próprios: " + _vm._s(_vm._f("real")(investimento.valorFBB)))]), _vm._v(" | "), _c('span', [_vm._v("Contrapartida: " + _vm._s(_vm._f("real")(investimento.valorContrapartida)))]), _vm._v(" "), (investimento.valorParceiros > 0) ? _c('span', [_vm._v(" | Terceiros: " + _vm._s(_vm._f("real")(investimento.valorParceiros)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	      }],
	      staticClass: "text-left indicadores-cb-inline w10 text-center",
	      attrs: {
	        "title": '<h5>Mostra ou Oculta na impressão</h5>'
	      }
	    }, [(!_vm.ehVisualizacao) ? _c('i', {
	      class: (_vm._.get(investimento, 'mostrarInvestimento', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	      on: {
	        "click": function($event) {
	          return _vm.mostrarOcultar(investimento, 'mostrarInvestimento')
	        }
	      }
	    }) : _c('i', {
	      class: (_vm._.get(investimento, 'mostrarInvestimento', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	      staticStyle: {
	        "color": "var(--cor-fraca)"
	      }
	    })]), _vm._v(" "), (!_vm.ehVisualizacao && _vm._.isNull(_vm.participanteEditando)) ? _c('td', {
	      staticClass: "text-right w30 text-center"
	    }, [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editaInvestimento(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.duplicaInvestimento(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.removeInvestimento(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")])], 1) : _c('td', {
	      staticClass: "text-right w30 text-center"
	    }, [_c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editaInvestimento(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-user",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Detalhar")])], 1)])
	  }), 0)], 1)]) : _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "background": "#f1f6ff"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('origem')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Origem")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.investimentoEditando.origem),
	      expression: "investimentoEditando.origem"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    ref: "origem",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "origem",
	      "disabled": _vm.ehVisualizacao,
	      "title": '<h5>Origem do investimento em geral é um título de projeto ou de uma articulação</h5>'
	    },
	    domProps: {
	      "value": (_vm.investimentoEditando.origem)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.buscaProjetosAprovados()
	      },
	      "blur": function($event) {
	        return _vm.ocultaListaProjetosAprovados()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.investimentoEditando, "origem", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pesquisa.projetos),
	      expression: "loading.pesquisa.projetos"
	    }],
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "display": "block",
	      "font-size": "20px",
	      "color": "var(--cor-destaque)"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), (_vm.pesquisa.projetos.mostrar && _vm.pesquisa.projetos.lista.length > 0) ? _c('div', {
	    staticClass: "pesquisa_autocomplete"
	  }, [_c('ul', _vm._l((_vm.pesquisa.projetos.lista), function(item) {
	    return _c('li', {
	      staticClass: "truncar",
	      on: {
	        "click": function($event) {
	          return _vm.selecionaProjetosAprovados(item)
	        }
	      }
	    }, [_vm._v(_vm._s(item.nomprj))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Pbjeto é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Próprios (Fundação BB)\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
	    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorFBB', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	    on: {
	      "click": function($event) {
	        return _vm.mostrarOcultar(_vm.investimentoEditando, 'mostrarValorFBB')
	      }
	    }
	  }) : _c('i', {
	    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorFBB', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "valorFBB",
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.investimentoEditando.valorFBB),
	      callback: function($$v) {
	        _vm.$set(_vm.investimentoEditando, "valorFBB", $$v)
	      },
	      expression: "investimentoEditando.valorFBB"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Contrapartida\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
	    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorContrapartida', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	    on: {
	      "click": function($event) {
	        return _vm.mostrarOcultar(_vm.investimentoEditando, 'mostrarValorContrapartida')
	      }
	    }
	  }) : _c('i', {
	    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorContrapartida', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "valorContrapartida",
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.investimentoEditando.valorContrapartida),
	      callback: function($$v) {
	        _vm.$set(_vm.investimentoEditando, "valorContrapartida", $$v)
	      },
	      expression: "investimentoEditando.valorContrapartida"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Parceiros Estratégicos\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
	    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorParceiros', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
	    on: {
	      "click": function($event) {
	        return _vm.mostrarOcultar(_vm.investimentoEditando, 'mostrarValorParceiros')
	      }
	    }
	  }) : _c('i', {
	    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorParceiros', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "valorParceiros",
	      "disabled": _vm.ehVisualizacao
	    },
	    model: {
	      value: (_vm.investimentoEditando.valorParceiros),
	      callback: function($$v) {
	        _vm.$set(_vm.investimentoEditando, "valorParceiros", $$v)
	      },
	      expression: "investimentoEditando.valorParceiros"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Observação")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "col-md-10",
	    attrs: {
	      "title": '<h5>Caso haja alguma observação pertinente ao investimento</h5>'
	    }
	  }, [_c('quill-editor', {
	    ref: "refQuillEditor",
	    attrs: {
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando),
	      "options": _vm.quillOptionsCompleto,
	      "name": "observacao"
	    },
	    model: {
	      value: (_vm.investimentoEditando.observacao),
	      callback: function($$v) {
	        _vm.$set(_vm.investimentoEditando, "observacao", $$v)
	      },
	      expression: "investimentoEditando.observacao"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-2"
	  }, [(!_vm.ehVisualizacao && _vm._.isNull(_vm.participanteEditando)) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.okEdicaoInvestimento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.cancelaEdicaoInvestimento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) ? 'Fechar' : 'Cancelar'))])], 1)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Produto")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
	    }],
	    staticClass: "col-md-10",
	    attrs: {
	      "title": '<h5>Se houver um produto resultado da ação, então gere descritivo sobre ele</h5>'
	    }
	  }, [_c('quill-editor', {
	    ref: "refQuillEditor",
	    attrs: {
	      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
	      "options": _vm.quillOptionsCompleto,
	      "name": "produto"
	    },
	    model: {
	      value: (_vm.sumarioCarregado.sumario.produto),
	      callback: function($$v) {
	        _vm.$set(_vm.sumarioCarregado.sumario, "produto", $$v)
	      },
	      expression: "sumarioCarregado.sumario.produto"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row imprimir",
	    staticStyle: {
	      "font-family": "'BancoDoBrasil Textos'"
	    },
	    attrs: {
	      "id": "sumario_impresso"
	    }
	  }, [_c('div', {
	    staticClass: "cabecalho_sumario_executivo"
	  }, [_c('span', [_vm._v("Sumário Executivo")]), _vm._v(" "), (!_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', [_vm._v("última atualização em " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.updated_at, "DD/MM/YYYY HH:mm:ss")))]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "sumario_criticidade"
	  }, [_vm._v("#interna")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "titulo_sumario_executivo",
	    staticStyle: {
	      "font-family": "'BancoDoBrasil Titulos ExtraBold'"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.sumarioCarregado.sumario.acao) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Ação: " + _vm._s(_vm.sumarioCarregado.sumario.acao))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Data/horário:")]), _vm._v(" " + _vm._s(_vm.moment(_vm.sumarioCarregado.sumario.data).add(1, 'day').format('DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.inicio, "HH:mm")) + " as " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.termino, "HH:mm"))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Local:")]), _vm._v(" " + _vm._s(_vm.sumarioCarregado.sumario.local) + "\n        ")]), _vm._v(" "), (_vm.sumarioCarregado.sumario.participantes.length > 0) ? _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Participantes/Interlocutores")]), _vm._v(" "), _vm._l((_vm.sumarioCarregado.sumario.participantes), function(participante) {
	    return (_vm._.get(participante, 'mostrarParticipante', true)) ? _c('div', {
	      staticStyle: {
	        "display": "flex",
	        "justify-content": "space-between",
	        "margin-bottom": "20px"
	      }
	    }, [_c('span', [_c('span', {
	      staticClass: "participante_sumario_executivo text-bold"
	    }, [_vm._v(_vm._s(participante.participante))]), _c('br'), _vm._v(" "), _vm._l((participante.interlocutores), function(interlocutor) {
	      return (_vm._.get(participante, 'mostrarInterlocutores', true)) ? _c('span', [_c('span', {
	        staticClass: "interlocutor_sumario_executivo"
	      }, [_vm._v(_vm._s(interlocutor.nome) + " - " + _vm._s(interlocutor.cargo))]), _c('br')]) : _vm._e()
	    })], 2), _vm._v(" "), (_vm._.has(participante, 'logomarca.file')) ? _c('span', [_c('img', {
	      staticStyle: {
	        "max-height": "70px"
	      },
	      attrs: {
	        "src": participante.logomarca.file
	      }
	    })]) : _vm._e()]) : _vm._e()
	  })], 2) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Objeto:")]), _vm._v(" " + _vm._s(_vm.sumarioCarregado.sumario.objeto) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Finalidade:")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.finalidade)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Sinopse:")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.sinopse)
	    }
	  })]), _vm._v(" "), ((_vm._.get(_vm.sumarioCarregado, 'sumario.investimentos', [])).length > 0) ? _c('span', [_c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Investimento socioambiental:")]), _c('br'), _vm._v(" "), _vm._l((_vm.sumarioCarregado.sumario.investimentos), function(investimento) {
	    return (_vm._.get(investimento, 'mostrarInvestimento', true)) ? _c('span', [_c('span', {
	      staticClass: "investimento_sumario_executivo"
	    }, [_vm._v(_vm._s(investimento.origem))]), _c('br'), _vm._v(" "), _c('ul', [(_vm._.get(investimento, 'mostrarValorFBB', true)) ? _c('li', [_vm._v("Próprios: " + _vm._s(_vm._f("real")(investimento.valorFBB)))]) : _vm._e(), _vm._v(" "), (_vm._.get(investimento, 'mostrarValorContrapartida', true)) ? _c('li', [_vm._v("Contrapartida: " + _vm._s(_vm._f("real")(investimento.valorContrapartida)))]) : _vm._e(), _vm._v(" "), (_vm._.get(investimento, 'mostrarValorParceiros', true)) ? _c('li', [_vm._v("Terceiros: " + _vm._s(_vm._f("real")(investimento.valorParceiros)))]) : _vm._e()]), _c('br'), _vm._v(" "), (_vm._.get(investimento, 'observacao')) ? _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm._.get(investimento, 'observacao', ''))
	      }
	    }) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.sumarioCarregado.sumario.participantes.length > 0) ? _c('span', _vm._l((_vm.sumarioCarregado.sumario.participantes), function(participante) {
	    return (_vm._.get(participante, 'mostrarParticipante', true) && (_vm._.get(participante, 'mostrarSobre', true) || _vm._.get(participante, 'mostrarGrupoEmpresa', true) || _vm._.get(participante, 'mostrarSegmentoAtuacao', true) || _vm._.get(participante, 'mostrarHistorico', true))) ? _c('div', [_c('div', {
	      staticClass: "titulo_sumario_executivo"
	    }, [_vm._v("\n              Sobre " + _vm._s(participante.participante) + "\n            ")]), _vm._v(" "), (_vm._.get(participante, 'mostrarSobre', true)) ? _c('div', {
	      staticClass: "bloco_sumario_executivo"
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(participante.sobre)
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "bloco_sumario_executivo"
	    }, [_c('table', {
	      staticClass: "table table-condensed table-bordered table-striped"
	    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [(_vm._.get(participante, 'mostrarGrupoEmpresa', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Grupo/empresa(s):")]), _vm._v(" " + _vm._s(participante.grupo))])]) : _vm._e(), _vm._v(" "), (_vm._.get(participante, 'mostrarSegmentoAtuacao', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Segmento de atuação:")]), _vm._v(" " + _vm._s(participante.atuacao))])]) : _vm._e(), _vm._v(" "), (_vm._.get(participante, 'mostrarHistorico', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Histórico/Destaques mercadológicos e institucionais/Estratégia do grupo:")]), _vm._v(" "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(participante.historico)
	      }
	    })])]) : _vm._e()])])])]) : _vm._e()
	  }), 0) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioCarregado, 'sumario.produto') && !_vm._.isEmpty(_vm.sumarioCarregado.sumario.produto)) ? _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Sobre o produto")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.produto)
	    }
	  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.ehAcessoPorLink) ? _c('section', {
	    staticClass: "content",
	    attrs: {
	      "id": "sumario_acesso_externo"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "cabecalho_sumario_executivo"
	  }, [_c('span', {
	    staticClass: "text-bold"
	  }, [_vm._v("Sumário Executivo")]), _c('br'), _vm._v(" "), (!_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', [_vm._v("atualizado em " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.updated_at, "DD/MM/YYYY HH:mm:ss")))]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "sumario_criticidade"
	  }, [_vm._v("#interna")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "titulo_sumario_executivo"
	  }, [_vm._v(_vm._s(_vm.sumarioCarregado.sumario.acao))]), _vm._v(" "), _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Ação: " + _vm._s(_vm.sumarioCarregado.sumario.acao))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Data/horário:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.data, "L")) + " - " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.inicio, "HH:mm")) + " as " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.termino, "HH:mm"))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Local:")]), _vm._v(" " + _vm._s(_vm.sumarioCarregado.sumario.local) + "\n        ")]), _vm._v(" "), (_vm.sumarioCarregado.sumario.participantes.length > 0) ? _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Participantes/Interlocutores")]), _vm._v(" "), _vm._l((_vm.sumarioCarregado.sumario.participantes), function(participante) {
	    return (_vm._.get(participante, 'mostrarParticipante', true)) ? _c('div', {
	      staticStyle: {
	        "display": "flex",
	        "justify-content": "space-between",
	        "margin-bottom": "20px"
	      }
	    }, [_c('span', [_c('span', {
	      staticClass: "participante_sumario_executivo text-bold"
	    }, [_vm._v(_vm._s(participante.participante))]), _c('br'), _vm._v(" "), _vm._l((participante.interlocutores), function(interlocutor) {
	      return (_vm._.get(participante, 'mostrarInterlocutores', true)) ? _c('span', [(_vm._.has(interlocutor, 'linkedin') && !_vm._.isEmpty(interlocutor.linkedin)) ? _c('span', {
	        staticClass: "interlocutor_sumario_executivo"
	      }, [_c('a', {
	        attrs: {
	          "href": interlocutor.linkedin
	        }
	      }, [_vm._v(" " + _vm._s(interlocutor.nome) + " "), _c('span', {
	        staticStyle: {
	          "font-style": "italic"
	        }
	      }, [_vm._v("(" + _vm._s(interlocutor.cargo) + ") "), _c('i', {
	        staticClass: "fa fa-linkedin-square"
	      })])])]) : _c('span', {
	        staticClass: "interlocutor_sumario_executivo"
	      }, [_vm._v(_vm._s(interlocutor.nome) + "  "), _c('span', {
	        staticStyle: {
	          "font-style": "italic"
	        }
	      }, [_vm._v("(" + _vm._s(interlocutor.cargo) + ")")])]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()
	    })], 2), _vm._v(" "), (_vm._.has(participante, 'logomarca.file')) ? _c('span', [_c('img', {
	      staticStyle: {
	        "max-height": "70px"
	      },
	      attrs: {
	        "src": participante.logomarca.file
	      }
	    })]) : _vm._e()]) : _vm._e()
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "titulo_sumario_executivo"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Objeto:")]), _vm._v(" " + _vm._s(_vm.sumarioCarregado.sumario.objeto))]), _vm._v(" "), _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Finalidade:")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.finalidade)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Sinopse:")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.sinopse)
	    }
	  })]), _vm._v(" "), ((_vm._.get(_vm.sumarioCarregado, 'sumario.investimentos', [])).length > 0) ? _c('span', [_c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Investimento socioambiental:")]), _c('br'), _vm._v(" "), _vm._l((_vm.sumarioCarregado.sumario.investimentos), function(investimento) {
	    return (_vm._.get(investimento, 'mostrarInvestimento', true)) ? _c('span', [_c('span', {
	      staticClass: "investimento_sumario_executivo text-bold"
	    }, [_vm._v(_vm._s(investimento.origem))]), _c('br'), _vm._v(" "), _c('ul', [(_vm._.get(investimento, 'mostrarValorFBB', true)) ? _c('li', [_vm._v("Próprios: " + _vm._s(_vm._f("real")(investimento.valorFBB)))]) : _vm._e(), _vm._v(" "), (_vm._.get(investimento, 'mostrarValorContrapartida', true)) ? _c('li', [_vm._v("Contrapartida: " + _vm._s(_vm._f("real")(investimento.valorContrapartida)))]) : _vm._e(), _vm._v(" "), (_vm._.get(investimento, 'mostrarValorParceiros', true)) ? _c('li', [_vm._v("Terceiros: " + _vm._s(_vm._f("real")(investimento.valorParceiros)))]) : _vm._e()]), _c('br'), _vm._v(" "), (_vm._.get(investimento, 'observacao')) ? _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm._.get(investimento, 'observacao', ''))
	      }
	    }) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.sumarioCarregado.sumario.participantes.length > 0) ? _c('span', _vm._l((_vm.sumarioCarregado.sumario.participantes), function(participante) {
	    return (_vm._.get(participante, 'mostrarParticipante', true) && (_vm._.get(participante, 'mostrarSobre', true) || _vm._.get(participante, 'mostrarGrupoEmpresa', true) || _vm._.get(participante, 'mostrarSegmentoAtuacao', true) || _vm._.get(participante, 'mostrarHistorico', true))) ? _c('div', [_c('div', {
	      staticClass: "titulo_sumario_executivo"
	    }, [_vm._v("Sobre " + _vm._s(participante.participante))]), _vm._v(" "), (_vm._.get(participante, 'mostrarSobre', true)) ? _c('div', {
	      staticClass: "bloco_sumario_executivo"
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(participante.sobre)
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "bloco_sumario_executivo"
	    }, [_c('table', {
	      staticClass: "table table-condensed"
	    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', [(_vm._.get(participante, 'mostrarGrupoEmpresa', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Grupo/empresa(s):")]), _vm._v(" " + _vm._s(participante.grupo))])]) : _vm._e(), _vm._v(" "), (_vm._.get(participante, 'mostrarSegmentoAtuacao', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Segmento de atuação:")]), _vm._v(" " + _vm._s(participante.atuacao))])]) : _vm._e(), _vm._v(" "), (_vm._.get(participante, 'mostrarHistorico', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Histórico/Destaques mercadológicos e institucionais/Estratégia do grupo:")]), _vm._v(" "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(participante.historico)
	      }
	    })])]) : _vm._e()])])])]) : _vm._e()
	  }), 0) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioCarregado, 'sumario.produto') && !_vm._.isEmpty(_vm.sumarioCarregado.sumario.produto)) ? _c('div', {
	    staticClass: "bloco_sumario_executivo"
	  }, [_c('strong', [_vm._v("Sobre o produto")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.produto)
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "font-size": "10px",
	      "font-style": "italic",
	      "border-top": "1px solid silver"
	    }
	  }, [_vm._v("Término do Sumário Executivo")])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Linkedin "), _c('i', {
	    staticClass: "fa fa-linkedin-square"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Visão Geral")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Visão Geral")])])])
	}]}

/***/ }),
/* 2070 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Ações e Proprietário")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Ações e Proprietário',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('form', {
	    staticClass: "ng-pristine ng-invalid ng-invalid-required",
	    attrs: {
	      "name": "authForm"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-6"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-1"
	  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('profiles', {
	    attrs: {
	      "disabled": true,
	      "propsProfile": _vm.profile
	    },
	    on: {
	      "profileSelected": function($event) {
	        _vm.profile = _vm.profile
	      }
	    },
	    model: {
	      value: (_vm.profile),
	      callback: function($$v) {
	        _vm.profile = $$v
	      },
	      expression: "profile"
	    }
	  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._l((_vm.auths), function(item, index) {
	    return _c('div', {
	      staticClass: "col-lg-6 col-md-2 col-sm-12"
	    }, [_c('div', {
	      staticClass: "box box-default box-solid"
	    }, [_c('div', {
	      staticClass: "box-header with-border"
	    }, [_c('h3', {
	      staticClass: "box-title ng-binding"
	    }, [_vm._v(_vm._s(_vm.$t('authority.register.' + index)))]), _vm._v(" "), _c('div', {
	      staticClass: "pull-right"
	    }, [_c('label', {
	      staticClass: "checkbox-inline new-control new-control-checkbox",
	      staticStyle: {
	        "margin-top": "-20px"
	      }
	    }, [_c('input', {
	      staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
	      attrs: {
	        "disabled": true,
	        "type": "checkbox",
	        "name": "selectAll",
	        "ng-model": "selectAll",
	        "ng-change": "change(item, selectAll)"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])]), _vm._v(" "), _c('div', {
	      staticClass: "box-body permission-list"
	    }, _vm._l((item), function(authority) {
	      return _c('div', {
	        staticClass: "ng-scope"
	      }, [_c('div', {
	        staticClass: "checkbox-inline col-md-6 col-sm-12"
	      }, [_c('label', {
	        staticClass: "checkbox-inline new-control new-control-checkbox ng-binding"
	      }, [_c('input', {
	        staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
	        attrs: {
	          "disabled": true,
	          "type": "checkbox"
	        },
	        domProps: {
	          "checked": _vm.verifica(authority.name)
	        },
	        on: {
	          "change": function($event) {
	            return _vm.adiciona(authority)
	          }
	        }
	      }), _vm._v(_vm._s(_vm.$t('authority.register.' + authority.name)) + "\n                              "), _c('div', {
	        staticClass: "new-control-indicator"
	      })])])])
	    }), 0)])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', [_c('div', {}, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "disabled": _vm.show.userForm || Object.keys(this.profile).length < 1 || _vm.profile.authorities.some(function (o) { return o.name === 'perfil-admin'; })
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.userForm = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atribuir")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('form', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show.userForm),
	      expression: "show.userForm"
	    }],
	    staticClass: "form-horizontal well well-sm no-shadow",
	    attrs: {
	      "name": "formUsuario"
	    }
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('usuarios')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "usersProfile"
	    }
	  }, [_vm._v("Usuários:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "input-group borda",
	    class: {
	      'has-error': _vm.errors.first('usuarios')
	    }
	  }, [_c('multiselect', {
	    attrs: {
	      "name": "usuarios",
	      "options": _vm.usuariosPesquisa,
	      "close-on-select": true,
	      "hide-selected": true,
	      "preserve-search": false,
	      "placeholder": "Escolha um usuário",
	      "label": "userName",
	      "track-by": "userName",
	      "preselect-first": true
	    },
	    scopedSlots: _vm._u([{
	      key: "tag",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "custom__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.option.userName))]), _c('span', {
	          staticClass: "custom__remove",
	          staticStyle: {
	            "cursor": "pointer"
	          },
	          on: {
	            "click": function($event) {
	              return props.remove(props.option)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.usersAdicionar),
	      callback: function($$v) {
	        _vm.usersAdicionar = $$v
	      },
	      expression: "usersAdicionar"
	    }
	  })], 1), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('usuarios')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('dataInicial')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "dataInicial"
	    }
	  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "dataInicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.profileConstraint.initialDate),
	      callback: function($$v) {
	        _vm.$set(_vm.profileConstraint, "initialDate", $$v)
	      },
	      expression: "profileConstraint.initialDate"
	    }
	  })], 1), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('dataInicial')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-2",
	    attrs: {
	      "for": "dt_inicial"
	    }
	  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "inactivateDate",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.profileConstraint.inactivateDate),
	      callback: function($$v) {
	        _vm.$set(_vm.profileConstraint, "inactivateDate", $$v)
	      },
	      expression: "profileConstraint.inactivateDate"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-10 col-sm-offset-2 ng-binding"
	  }, [_c('span', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.adicionaUsuario($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('span', {
	    staticClass: "btn btn-default btn-flat",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onCancelUserToProfile($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.bordered,
	      "items": _vm.users,
	      "hover": _vm.hover,
	      "fields": _vm.fields,
	      "filter": _vm.filter,
	      "current-page": _vm.currentPage,
	      "per-page": 5,
	      "sort-by": _vm.sortBy,
	      "sort-desc": _vm.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        _vm.sortBy = $event
	      },
	      "update:sort-by": function($event) {
	        _vm.sortBy = $event
	      },
	      "update:sortDesc": function($event) {
	        _vm.sortDesc = $event
	      },
	      "update:sort-desc": function($event) {
	        _vm.sortDesc = $event
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "active",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "updatedAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": _vm.profile.name === 'Administrador',
	            "to": {
	              name: 'cadastro-usuarios-altera',
	              params: {
	                id: row.item.user.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": _vm.profile.name === 'Administrador'
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.deleteUser(row.item.user.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.totalRows,
	      "per-page": _vm.perPage
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Permissões de Gerência")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', [_vm._v("Usuários com estas permissões")])])
	}]}

/***/ }),
/* 2071 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body avaliacoesProjeto"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.loading.formulariosDisponiveis) ? _c('span', [_vm._m(0)]) : _c('span', [(_vm.listaFormulariosDisponiveis.length === 0) ? _c('div', {
	    staticClass: "box-header bg-info"
	  }, [_vm._v("\n            Não há formulário disponível para avaliação deste projeto " + _vm._s(_vm.numeroProjeto) + "\n          ")]) : _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'top',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "row",
	    attrs: {
	      "title": '<h5>Se desejar enviar um formulário de avaliação para a entidade parceira neste projeto ' + _vm.numeroProjeto + ', então selecione o formulário desejado e clique em Enviar</h5>'
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaFormulariosDisponiveis,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": 'Formulários disponíveis para envio',
	      "track-by": "id",
	      "label": "nome",
	      "selectedLabel": "selecionado",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "name": "formularios_disponiveis",
	      "data-vv-as": "formularios_disponiveis"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('table', {
	          staticClass: "w100"
	        }, [_c('tr', [_c('td', {
	          staticClass: "w40"
	        }, [_c('span', {
	          staticClass: "text-warning text-bold"
	        }, [_vm._v(_vm._s(props.option.id) + " ")]), _vm._v(" " + _vm._s(props.option.nome) + " "), _c('br')]), _vm._v(" "), _c('td', {
	          staticClass: "w20",
	          staticStyle: {
	            "font-style": "italic"
	          }
	        }, [_vm._v(_vm._s(_vm._.find(_vm.tipoFormulario, ['codigo', props.option.tipo])['descricao']))]), _vm._v(" "), _c('td', {
	          staticClass: "w20"
	        }, [_c('span', {
	          class: props.option.uso === 0 ? 'text-danger' : 'text-info'
	        }, [_vm._v(_vm._s(props.option.uso === 0 ? 'Nenhum' : props.option.uso + ' preenchido' + (props.option.uso > 1 ? 's' : '')))])])])])]
	      }
	    }, {
	      key: "noResult",
	      fn: function(props) {
	        return [_vm._v("\n                  Não encontrei formulário com este nome\n                ")]
	      }
	    }], null, false, 1715438566),
	    model: {
	      value: (_vm.formularioSelecionadoEnvioManual),
	      callback: function($$v) {
	        _vm.formularioSelecionadoEnvioManual = $$v
	      },
	      expression: "formularioSelecionadoEnvioManual"
	    }
	  })], 1), _vm._v(" "), (!_vm._.isNull(_vm.formularioSelecionadoEnvioManual)) ? _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.encaminharFormularioParaEntidade($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Enviar")])], 1) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('br') : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('table', {
	    staticClass: "table b-table table-hover table-bordered b-table-stacked-md"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "centralizado w10"
	  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Formulário")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado w20"
	  }, [_vm._v("Situação")]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('th', {
	    staticClass: "centralizado w30"
	  }, [_vm._v("Ação")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.avaliacoesProjeto), function(processo, idx) {
	    return _c('tr', [_c('td', {
	      staticClass: "centralizado"
	    }, [_c('strong', [_vm._v(_vm._s(processo.avaliacao.id))])]), _vm._v(" "), _c('td', {
	      staticClass: "text-left"
	    }, [_vm._v("\n                " + _vm._s(processo.formularioCadastrado.id + ' - ' + processo.formularioCadastrado.nome)), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm._.find(_vm.tipoFormulario, ['codigo', processo.formularioCadastrado.tipo])['descricao']))])]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado"
	    }, [(processo.avaliacao.situacao === 'FEITO') ? _c('span', {
	      staticStyle: {
	        "color": "var(--cor-sucesso)"
	      }
	    }, [_vm._v("Concluído")]) : (processo.avaliacao.situacao === 'CANCELADO') ? _c('span', {
	      staticStyle: {
	        "color": "var(--cor-atencao)"
	      }
	    }, [_vm._v("Cancelado")]) : (processo.avaliacao.situacao === 'EM_EXECUCAO') ? _c('span', {
	      staticStyle: {
	        "color": "var(--cor-destaque)"
	      }
	    }, [_vm._v("Em Execução")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado"
	    }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [(processo.avaliacao.situacao === 'EM_EXECUCAO' && processo.ultimaTarefa.nome === 'ANALISE') ? _c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          _vm.$router.push({
	            name: 'preenche-formulario',
	            params: {
	              id: _vm._.split(processo.formularioPreenchido.link_acesso, '-')[0]
	            }
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-gavel",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Validar")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['FEITO', 'CANCELADO'], processo.avaliacao.situacao)) ? _c('g-button-ujarak', {
	      attrs: {
	        "color": "warning",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.reativar(idx)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-play",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Reativar")]) : _vm._e(), _vm._v(" "), (processo.avaliacao.situacao !== 'CANCELADO') ? _c('g-button-ujarak', {
	      directives: [{
	        name: "confirm",
	        rawName: "v-confirm",
	        value: ({
	          ok: function (retorno) { return _vm.cancelar(processo.avaliacao.id); },
	          cancel: _vm.doNothing,
	          message: '<span class=\'avisoAlerta\'>Deseja <b>Cancelar</b> esta avaliação?</span>'
	        }),
	        expression: "{ok: retorno => cancelar(processo.avaliacao.id), cancel: doNothing, message: '<span class=\\'avisoAlerta\\'>Deseja <b>Cancelar</b> esta avaliação?</span>'}"
	      }],
	      attrs: {
	        "color": "error",
	        "size": "button--size-ss"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-ban",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && processo.avaliacao.situacao === 'EM_EXECUCAO' && _vm._.includes(['SOLICITACAO', 'REVISAO'], processo.ultimaTarefa.nome)) ? _c('span', [_c('g-button-ujarak', {
	      attrs: {
	        "color": "primary",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          _vm.$router.push({
	            name: 'preenche-formulario',
	            params: {
	              id: _vm._.split(processo.formularioPreenchido.link_acesso, '-')[1]
	            }
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar")])], 1) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	      attrs: {
	        "color": "success",
	        "size": "button--size-ss"
	      },
	      nativeOn: {
	        "click": function($event) {
	          _vm.$router.push({
	            name: 'preenche-formulario',
	            params: {
	              id: _vm._.split(processo.formularioPreenchido.link_acesso, '-')[2]
	            }
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-search",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Visualizar")])], 1)])
	  }), 0)])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Buscando formulários disponíveis para este projeto")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "color": "var(--cor-fraca)"
	    }
	  }, [_vm._v("Formulários vinculados neste projeto")])])
	}]}

/***/ }),
/* 2072 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Remessa',
	        href: '#'
	      }, {
	        text: 'Lista de Remessas',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaRemessas"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('numeroProjeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Numero do Projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formIntervencao.numeroProjeto),
	      expression: "formIntervencao.numeroProjeto"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "numeroProjeto",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.formIntervencao.numeroProjeto)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formIntervencao, "numeroProjeto", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('numeroProjeto')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('intervencao_bndes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Numero da Intervenção")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formIntervencao.intervencao_bndes),
	      expression: "formIntervencao.intervencao_bndes"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "intervencao_bndes",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.formIntervencao.intervencao_bndes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.formIntervencao, "intervencao_bndes", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('intervencao_bndes')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvar($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar\n                    ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.busca),
	      expression: "busca"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa (ID BNDES, nota, CNPJ, projeto, status)..."
	    },
	    domProps: {
	      "value": (_vm.busca)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.busca = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.busca,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.busca = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    ref: "tabelaRemessas",
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.provedorRemessas,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "cnpj",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))]
	      }
	    }, {
	      key: "data_envio",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, 'DD/MM/YYYYm')))]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b-pagination', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.table.totalRows > _vm.table.perPage),
	      expression: "table.totalRows > table.perPage"
	    }],
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage,
	      "align": "center"
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('span', [_vm._v("Remessas")])])
	}]}

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column all-end gerenciador-presenca-container",
	    class: _vm.podeEditar ? 'edicao-permitida' : 'edicao-nao-permitida'
	  }, [_c('div', [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('i', [_vm._v("Gerenciador de Edição da Proposta [ " + _vm._s(_vm.numeroProposta) + " ]")])]), _vm._v(" "), (Object.keys(_vm.sessaoAtiva).length > 0) ? _c('div', [_c('b', [_vm._v(_vm._s(_vm.sessaoAtiva.user_name == _vm.usuarioLogado.ds_nome_usuario && !_vm.podeEditar ? 'Você já está editando em outra aba ou navegador' : 'Editando agora: ' + _vm.sessaoAtiva.user_name))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.podeEditar) ? _c('div', [_vm._v("\n        Última Atualização de Presença: "), _c('b', [_vm._v(_vm._s(_vm.moment(_vm.sessaoAtiva.ultimo_ping).format('DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2074 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.opcoes && _vm.opcoes.length) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0"
	    }
	  }, _vm._l((_vm.opcoes), function(opcao, idx) {
	    return _c('div', {
	      key: 'op-' + idx,
	      staticClass: "col-md-6",
	      staticStyle: {
	        "padding": "4px 15px"
	      }
	    }, [_c('label', {
	      staticClass: "new-control new-control-checkbox",
	      staticStyle: {
	        "padding-top": "4px",
	        "font-weight": "normal",
	        "cursor": "pointer"
	      }
	    }, [_c('input', {
	      attrs: {
	        "type": "checkbox",
	        "disabled": _vm.disabled
	      },
	      domProps: {
	        "checked": _vm.estaSelecionado(opcao)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.alterna(opcao)
	        }
	      }
	    }), _vm._v("\n         " + _vm._s(opcao) + "\n        "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])
	  }), 0) : _c('div', {
	    staticClass: "mensagem",
	    staticStyle: {
	      "color": "#a8a8a8",
	      "font-weight": "normal",
	      "font-size": "14px",
	      "padding": "4px 0"
	    }
	  }, [_vm._v("\n    Selecione um Programa para ver os indicadores recomendados, ou adicione indicadores abaixo.\n  ")]), _vm._v(" "), (_vm.extrasVisiveis.length) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0",
	      "margin-top": "6px"
	    }
	  }, _vm._l((_vm.extrasVisiveis), function(item, idx) {
	    return _c('div', {
	      key: 'ex-' + idx,
	      staticClass: "col-md-6",
	      staticStyle: {
	        "padding": "4px 15px"
	      }
	    }, [_c('label', {
	      staticClass: "new-control new-control-checkbox",
	      staticStyle: {
	        "padding-top": "4px",
	        "font-weight": "normal",
	        "cursor": "pointer"
	      }
	    }, [_c('input', {
	      attrs: {
	        "type": "checkbox",
	        "disabled": _vm.disabled
	      },
	      domProps: {
	        "checked": _vm.estaSelecionado(item.descricao)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.alterna(item.descricao, item.custom)
	        }
	      }
	    }), _vm._v("\n         " + _vm._s(item.descricao) + "\n        "), (item.custom) ? _c('span', {
	      staticStyle: {
	        "color": "#a8a8a8"
	      }
	    }, [_vm._v(" (livre)")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])
	  }), 0) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0",
	      "margin-right": "0",
	      "margin-top": "8px",
	      "align-items": "flex-end"
	    }
	  }, [_c('div', {
	    staticClass: "form-group col-md-6",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.novoIndicador),
	      expression: "novoIndicador"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "maxlength": "255",
	      "placeholder": "Adicionar indicador não listado"
	    },
	    domProps: {
	      "value": (_vm.novoIndicador)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.adiciona($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.novoIndicador = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3",
	    staticStyle: {
	      "padding-top": "2px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm btn-flat",
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.novoIndicador
	    },
	    on: {
	      "click": _vm.adiciona
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Adicionar\n      ")])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2075 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "cotacaoContainer",
	    staticClass: "box-body cronogramaff"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    directives: [{
	      name: "confirm",
	      rawName: "v-confirm",
	      value: ({
	        ok: function (retorno) { return _vm.deleteTodos('ok'); },
	        cancel: _vm.doNothing,
	        message: 'Deseja <b>APAGAR</b> todos os itens ?'
	      }),
	      expression: "{ok: retorno => deleteTodos('ok'), cancel: doNothing, message: 'Deseja <b>APAGAR</b> todos os itens ?'}"
	    }],
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   Apagar todos os itens do cronograma\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.propsAtividades), function(atividade, atividadeIndex) {
	    return [_c('tr', {
	      staticClass: "atividade"
	    }, [_c('td', {
	      staticClass: "centralizado borda"
	    }, [_vm._v("\n                  Tipo Cotação\n                ")]), _vm._v(" "), _c('td', {
	      staticClass: "esquerda borda nome_atividade",
	      attrs: {
	        "colspan": _vm.proposta.ds_fase === 'ANALISE' ? 2 : 2
	      }
	    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado borda"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado borda"
	    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
	      staticClass: "direita borda",
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(_vm._f("real")(_vm.somaTotal(atividade.itens_orcamentos))))]), _vm._v(" "), _c('td', {
	      staticClass: "centralizado borda"
	    }, [(!_vm.editando && !_vm.adicionando) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "disable": _vm.bloqueiaBotoes,
	        "type": "button",
	        "id": "financial-physical-activity-0f"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.addItem(atividade, atividadeIndex)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Adicionar\n                  ")]) : _vm._e()])]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item, itemIndex) {
	      return _c('tr', {
	        attrs: {
	          "prefix": "activityItem",
	          "suffix": "item.id",
	          "row": "item"
	        }
	      }, [(!item.editando) ? [_c('td', {
	        staticClass: "centralizado borda w5",
	        class: _vm.verificaValidacao(item)
	      }, [(item.itemCotacao && item.itemCotacao[0] !== undefined) ? _c('div', {
	        staticClass: "cotacao-tipo"
	      }, [(item.itemCotacao[0].length > 0) ? _c('div', [_c('i', {
	        staticClass: "fa fa-plus-circle"
	      }), _vm._v(" Cotação Automática\n                      ")]) : _vm._e(), _vm._v(" "), (item.itemCotacaoManual[0].length > 0) ? _c('div', [_c('i', {
	        staticClass: "fa fa-cubes"
	      }), _vm._v(" Cotação Manual\n                      ")]) : _vm._e()]) : _c('div', {
	        staticClass: "cotacao-tipo"
	      }, [_c('i', {
	        staticClass: "fa fa-recycle"
	      }), _vm._v(" Cotação Manual Antiga\n                    ")])]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w10",
	        class: _vm.verificaValidacao(item)
	      }, [(('' + item.origem) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem) === '5') ? _c('span', [_vm._v("Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel) === '1') ? _c('span', [_c('br'), _vm._m(2, true)]) : _vm._e()]), _vm._v(" "), _c('td', {
	        staticClass: "borda",
	        class: _vm.verificaValidacao(item)
	      }, [_c('div', {
	        staticClass: "item"
	      }, [_c('div', {
	        class: (_vm.propostaDentroFbb && item.conta_financeira ? 'w50' : 'w100') + ' item_despesa esquerda'
	      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), (_vm.propostaDentroFbb && item.conta_financeira) ? _c('div', {
	        staticClass: "direita"
	      }, [_vm._v(_vm._s(item.conta_financeira.numero_conta) + " / " + _vm._s(item.conta_financeira.descricao))]) : _vm._e(), _vm._v(" "), _c('div', {
	        staticClass: "observacao esquerda"
	      }, [_vm._v(_vm._s(item.observacao))])])]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w5",
	        class: _vm.verificaValidacao(item)
	      }, [_vm._v(_vm._s(item.periodo_inicial))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w5",
	        class: _vm.verificaValidacao(item)
	      }, [_vm._v(_vm._s(item.periodo_final))]), _vm._v(" "), _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	        }],
	        staticClass: "centralizado borda w5",
	        class: _vm.verificaValidacao(item),
	        attrs: {
	          "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
	        }
	      }, [_vm._v("\n                    " + _vm._s(item.quantidade) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w10",
	        class: _vm.verificaValidacao(item)
	      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_unitario)))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado borda w10",
	        class: _vm.verificaValidacao(item)
	      }, [_vm._v(_vm._s(_vm._f("real")(item.quantidade * item.valor_unitario)))]), _vm._v(" "), _c('td', {
	        staticClass: "row-flex all-centered gap-5 acoes-coluna",
	        class: _vm.verificaValidacao(item)
	      }, [(!_vm.editando && !_vm.adicionando) ? _c('div', {
	        staticClass: "row-flex all-centered gap-5"
	      }, [_c('b-button', {
	        staticClass: "btn btn-primary btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.bloqueiaBotoes ? null : _vm.editaItem(atividade, atividadeIndex, item, itemIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-pencil-square-o",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	        directives: [{
	          name: "confirm",
	          rawName: "v-confirm",
	          value: ({
	            ok: function (retorno) { return _vm.deleteItem(atividade, atividadeIndex, item, itemIndex); },
	            cancel: _vm.doNothing,
	            message: 'Deseja <b>APAGAR</b> o item ' + item.item.ds_code + '-' + item.item.ds_description + ', da atividade ' + atividade.ds_nome + ' ?'
	          }),
	          expression: "{ok: retorno => deleteItem(atividade, atividadeIndex, item, itemIndex), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> o item ' + item.item.ds_code + '-' + item.item.ds_description + ', da atividade ' + atividade.ds_nome + ' ?'}"
	        }],
	        staticClass: "btn btn-danger btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": _vm.bloqueiaBotoes
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-trash",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Excluir")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editando && !_vm.adicionando && item.itemCotacao) ? _c('div', {
	        staticClass: "row-flex all-centered gap-5"
	      }, [(item.itemCotacaoValidado.validado) ? _c('b-button', {
	        staticClass: "btn btn-success btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.bloqueiaBotoes ? null : _vm.abrirCotacaoValidacao(item, true)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-shopping-cart",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Abrir Cotação")]) : _vm._e(), _vm._v(" "), (!item.itemCotacaoValidado.validado && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('b-button', {
	        staticClass: "btn btn-warning btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.bloqueiaBotoes ? null : _vm.abrirCotacaoValidacao(item, false)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-exclamation-triangle",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Validar Cotação")]) : _vm._e(), _vm._v(" "), (!item.itemCotacaoValidado.validado && _vm.usuarioLogado.userType === 'ENTIDADE') ? _c('b-button', {
	        staticClass: "btn btn-warning btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.bloqueiaBotoes ? null : _vm.abrirCotacaoValidacao(item, true)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-exclamation-triangle",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Abrir Cotação")]) : _vm._e()], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), [(_vm.validarCotacao && item.itemCotacao) ? _c('div', {
	        staticClass: "animated fadeInDownOutUp edicaoItem"
	      }, [_c('cotacaoItens', {
	        attrs: {
	          "idProposta": _vm.proposta.id,
	          "fk_cotacao": _vm.itemForm.fk_cotacao,
	          "cotacaoGravada": _vm.itemForm.itemCotacao,
	          "cotacaoManualGravada": _vm.itemForm.itemCotacaoManual,
	          "editarCotacao": _vm.editarCotacao,
	          "validandoCotacao": _vm.validarCotacao,
	          "visualizandoCotacao": _vm.visualizandoCotacao,
	          "cotacaoValidada": _vm.itemForm.itemCotacaoValidado,
	          "setDescricaoValor": _vm.setDescricaoValor,
	          "toggleCotacao": _vm.toggleCotacao,
	          "fecharValidacao": _vm.fecharValidacao,
	          "atividadeIndex": atividadeIndex,
	          "itemIndex": itemIndex,
	          "onAdd": _vm.onAdd,
	          "atividade": atividade,
	          "item": _vm.itemForm,
	          "gravarValidacaoRow": _vm.gravarValidacaoRow
	        }
	      })], 1) : _vm._e()], _vm._v(" "), (item.editando) ? [_c('td', {
	        attrs: {
	          "colspan": "10"
	        }
	      }, [_c('div', {
	        staticClass: "animated fadeInDownOutUp edicaoItem"
	      }, [(_vm.abrirSistemaCotacao) ? _c('cotacaoItens', {
	        attrs: {
	          "idProposta": _vm.proposta.id,
	          "fk_cotacao": _vm.itemForm.fk_cotacao,
	          "cotacaoGravada": _vm.itemForm.itemCotacao,
	          "cotacaoManualGravada": _vm.itemForm.itemCotacaoManual,
	          "editarCotacao": _vm.editarCotacao,
	          "cotacaoValidada": _vm.itemForm.itemCotacaoValidado,
	          "setDescricaoValor": _vm.setDescricaoValor,
	          "toggleCotacao": _vm.toggleCotacao,
	          "fecharValidacao": _vm.fecharValidacao,
	          "atividadeIndex": atividadeIndex,
	          "itemIndex": itemIndex,
	          "onAdd": _vm.onAdd,
	          "atividade": atividade,
	          "item": item,
	          "gravarValidacaoRow": _vm.gravarValidacaoRow
	        }
	      }) : _vm._e()], 1), _vm._v(" "), (!_vm.abrirSistemaCotacao && !_vm.abrirSistemaCotacaoManual) ? _c('div', {
	        staticClass: "animated fadeInDownOutUp edicaoItem"
	      }, [_c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('origem')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-5"
	      }, [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.origem),
	          expression: "itemForm.origem"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "name": "origem",
	          "aria-label": "origem"
	        },
	        on: {
	          "change": [function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.itemForm, "origem", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }, function($event) {
	            return _vm.zeraAdiantamento()
	          }]
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "1"
	        }
	      }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "2"
	        }
	      }, [_vm._v("Contrapartida")]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('option', {
	        attrs: {
	          "value": "5"
	        }
	      }, [_vm._v("P.Estratégico")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-1"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('inicio')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-1"
	      }, [_vm._v("Início:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-1"
	      }, [_c('div', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.periodo_inicial),
	          expression: "itemForm.periodo_inicial"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        ref: "periodo_inicial",
	        refInFor: true,
	        staticClass: "form-control text-right",
	        attrs: {
	          "type": "number",
	          "name": "inicio",
	          "maxlength": "2",
	          "aria-label": "Inicio do período",
	          "min": atividade.inicio,
	          "max": atividade.termino
	        },
	        domProps: {
	          "value": (_vm.itemForm.periodo_inicial)
	        },
	        on: {
	          "change": _vm.validaPeriodo,
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "periodo_inicial", $event.target.value)
	          }
	        }
	      })]), _vm._v(" "), (_vm.errors.first('inicio')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('inicio')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('fim')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-1"
	      }, [_vm._v("Fim:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-1"
	      }, [_c('div', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.periodo_final),
	          expression: "itemForm.periodo_final"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        ref: "periodo_final",
	        refInFor: true,
	        staticClass: "form-control text-right",
	        attrs: {
	          "type": "number",
	          "name": "fim",
	          "maxlength": "2",
	          "aria-label": "Fim do período",
	          "min": atividade.inicio,
	          "max": atividade.termino
	        },
	        domProps: {
	          "value": (_vm.itemForm.periodo_final)
	        },
	        on: {
	          "change": _vm.validaPeriodo,
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "periodo_final", $event.target.value)
	          }
	        }
	      })]), _vm._v(" "), (_vm.errors.first('fim')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('fim')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('item')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Item de despesa:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-10"
	      }, [_c('div', {
	        attrs: {
	          "approval": "finPhySchFormCtrl.approval",
	          "state": "finPhySchFormCtrl.approvalState"
	        }
	      }, [_c('multiselect', {
	        directives: [{
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        attrs: {
	          "name": "item",
	          "custom-label": _vm.itemCodigo,
	          "searchable": true,
	          "options": _vm.items,
	          "close-on-select": true,
	          "hide-selected": true,
	          "preserve-search": false,
	          "placeholder": "Escolha um item",
	          "disabled": _vm.itemForm.origem === null,
	          "label": "ds_description",
	          "track-by": "ds_code",
	          "preselect-first": false
	        },
	        on: {
	          "select": function($event) {
	            return _vm.buscaContasFinanceiras($event)
	          }
	        },
	        scopedSlots: _vm._u([{
	          key: "option",
	          fn: function(props) {
	            return [_c('div', {
	              staticClass: "option__desc"
	            }, [_c('span', {
	              staticClass: "option__title"
	            }, [_vm._v(_vm._s(props.option.ds_code) + " / " + _vm._s(props.option.ds_description))])])]
	          }
	        }], null, true),
	        model: {
	          value: (_vm.itemForm.item),
	          callback: function($$v) {
	            _vm.$set(_vm.itemForm, "item", $$v)
	          },
	          expression: "itemForm.item"
	        }
	      }, [_vm._v(" "), _c('span', {
	        attrs: {
	          "slot": "noResult"
	        },
	        slot: "noResult"
	      }, [_c('font', {
	        attrs: {
	          "color": "red"
	        }
	      }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('item')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('item')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('descrição item')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Descrição Item:")]), _vm._v(" "), _c('div', [_c('div', {
	        staticClass: "col-md-10"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.observacao),
	          expression: "itemForm.observacao"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "type": "text",
	          "name": "descrição item",
	          "maxlength": "255",
	          "aria-label": "Descrição do item"
	        },
	        domProps: {
	          "value": (_vm.itemForm.observacao)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "observacao", $event.target.value)
	          }
	        }
	      }), _vm._v(" "), (_vm.errors.first('descrição item')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('descrição item')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('quantidade')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-1"
	      }, [_c('div', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.quantidade),
	          expression: "itemForm.quantidade"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required|min_value:1'),
	          expression: "'required|min_value:1'"
	        }],
	        staticClass: "form-control text-right",
	        attrs: {
	          "type": "number",
	          "name": "quantidade",
	          "min": "1",
	          "maxlength": "6",
	          "aria-label": "Quantidade do recurso"
	        },
	        domProps: {
	          "value": (_vm.itemForm.quantidade)
	        },
	        on: {
	          "change": function($event) {
	            return _vm.valorTotal(_vm.itemForm)
	          },
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "quantidade", $event.target.value)
	          }
	        }
	      })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "col-sm-2"
	      }, [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.unidade_medida),
	          expression: "itemForm.unidade_medida"
	        }],
	        staticClass: "form-control",
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.itemForm, "unidade_medida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, _vm._l((_vm.medidas), function(unidade_medida) {
	        return _c('option', {
	          domProps: {
	            "value": unidade_medida
	          }
	        }, [_vm._v(_vm._s(unidade_medida))])
	      }), 0)]), _vm._v(" "), (_vm.itemForm.unidade_medida === 'Outros') ? _c('div', {
	        staticClass: "col-md-2 required-field",
	        class: {
	          'has-error': _vm.errors.first('medida outros')
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.medida_outros),
	          expression: "itemForm.medida_outros"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }, {
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	        }],
	        staticClass: "form-control text-right",
	        attrs: {
	          "type": "text",
	          "name": "medida outros",
	          "maxlength": "255",
	          "aria-label": "Outros",
	          "title": '<h5>Qual essa outra unidade de medida?</h5>'
	        },
	        domProps: {
	          "value": (_vm.itemForm.medida_outros)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.itemForm, "medida_outros", $event.target.value)
	          }
	        }
	      }), _vm._v(" "), (_vm.errors.first('medida outros')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('medida outros')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('valor unitario')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-1"
	      }, [_vm._v("Valor Unitário:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-2"
	      }, [_c('div', [_c('money', {
	        directives: [{
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required|min_value:0.01'),
	          expression: "'required|min_value:0.01'"
	        }],
	        staticClass: "form-control text-right",
	        attrs: {
	          "disabled": "",
	          "name": "valor unitario"
	        },
	        on: {
	          "change": function($event) {
	            return _vm.valorTotal(_vm.itemForm)
	          }
	        },
	        model: {
	          value: (_vm.itemForm.valor_unitario),
	          callback: function($$v) {
	            _vm.$set(_vm.itemForm, "valor_unitario", $$v)
	          },
	          expression: "itemForm.valor_unitario"
	        }
	      }), _vm._v(" "), _c('span', [_vm._v("Valor cotado: " + _vm._s(_vm._f("real")(_vm.itemForm.valor_cotado)) + " "), _c('i', {
	        staticClass: "fa fa-question-circle",
	        attrs: {
	          "aria-hidden": "true",
	          "title": "Valor médio dos preços cotados, ou da soma das médias, se houver mais de um produto/serviço"
	        }
	      })])], 1), _vm._v(" "), (_vm.errors.first('valor unitario')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('valor unitario')) + " \n                              \n                            ")]) : _vm._e()]), _vm._v(" "), _c('b-button', {
	        staticClass: "btn btn-primary btn-sm btn-flat",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.abrirCotacao()
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-plus-circle",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Adicionar/Editar Cotação")])], 1), _vm._v(" "), _c('div', {
	        staticClass: "row-flex all-end w-100"
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Valor Total: " + _vm._s(_vm._f("real")((_vm.itemForm.quantidade * _vm.itemForm.valor_unitario))))])])]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [(_vm.proposta.ds_fase === 'ANALISE') ? _c('div', {
	        staticClass: " required",
	        class: {
	          'has-error': _vm.errors.first('adiantavel')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Adiantável:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-2"
	      }, [_c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.itemForm.adiantavel),
	          expression: "itemForm.adiantavel"
	        }, {
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        staticClass: "form-control",
	        attrs: {
	          "disabled": _vm.itemForm.origem === '2' || _vm.itemForm.origem === 2,
	          "name": "adiantavel",
	          "required": ""
	        },
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.itemForm, "adiantavel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "0"
	        }
	      }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	        attrs: {
	          "value": "1"
	        }
	      }, [_vm._v("Sim")])]), _vm._v(" "), (_vm.errors.first('adiantavel')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('adiantavel')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.propostaDentroFbb()) ? _c('div', {
	        staticClass: "required",
	        class: {
	          'has-error': _vm.errors.first('conta financeira')
	        }
	      }, [_c('label', {
	        staticClass: "control-label col-md-2"
	      }, [_vm._v("Conta Financeira:")]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-6"
	      }, [_c('multiselect', {
	        directives: [{
	          name: "validate",
	          rawName: "v-validate",
	          value: ('required'),
	          expression: "'required'"
	        }],
	        attrs: {
	          "disabled": _vm.blockSelect === true,
	          "name": "conta financeira",
	          "custom-label": _vm.contaCodigo,
	          "options": _vm.contasFinanceiras,
	          "close-on-select": true,
	          "hide-selected": true,
	          "preserve-search": false,
	          "placeholder": "Escolha um item",
	          "label": "numero_conta",
	          "track-by": "numero_conta",
	          "preselect-first": false
	        },
	        on: {
	          "select": _vm.selecionaConta
	        },
	        scopedSlots: _vm._u([{
	          key: "option",
	          fn: function(props) {
	            return [_c('div', {
	              staticClass: "option__desc"
	            }, [_c('span', {
	              staticClass: "option__title"
	            }, [_vm._v(_vm._s(props.option.numero_conta) + " / " + _vm._s(props.option.descricao))])])]
	          }
	        }], null, true),
	        model: {
	          value: (_vm.itemForm.conta_financeira),
	          callback: function($$v) {
	            _vm.$set(_vm.itemForm, "conta_financeira", $$v)
	          },
	          expression: "itemForm.conta_financeira"
	        }
	      }, [_vm._v(" "), _c('span', {
	        attrs: {
	          "slot": "noResult"
	        },
	        slot: "noResult"
	      }, [_c('font', {
	        attrs: {
	          "color": "red"
	        }
	      }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('conta financeira')) ? _c('span', {
	        staticClass: "label label-danger"
	      }, [_vm._v(" " + _vm._s(_vm.errors.first('conta financeira')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "form-group row"
	      }, [_c('div', {
	        staticClass: "col-md-10 col-md-offset-2"
	      }, [_c('button', {
	        ref: "financial-physical-save-item",
	        refInFor: true,
	        staticClass: "btn btn-confirm btn-flat",
	        class: {
	          disabled: _vm.submitDisabled
	        },
	        attrs: {
	          "id": "financial-physical-save-item",
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onAdd(atividade, item, itemIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-check",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	        staticClass: "btn btn-back btn-flat",
	        attrs: {
	          "id": "financial-physical-cancel-item",
	          "type": "button"
	        },
	        on: {
	          "~click": function($event) {
	            return _vm.cancelaItem(atividade, item, itemIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-times-circle",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" Cancelar")])])])]) : _vm._e()])] : _vm._e()], 2)
	    })]
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_c('tr', [_c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.contrapartida !== 0) ? _c('span', [_vm._v("Total Contrapartida")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.adiantavel.total !== 0) ? _c('span', [_vm._v("Total Adiantável")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [_vm._v("Total do Projeto")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total da Fundação R$ <span class=\'realce\'>' + (_vm.totais.projeto.fbb).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.fbb + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.fbb / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total de Parceiro Estratégico R$ <span class=\'realce\'>' + (_vm.totais.projeto.parceiros).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.parceiros + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.parceiros / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.contrapartida !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total da Contrapartida R$ <span class=\'realce\'>' + (_vm.totais.projeto.contrapartida).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.contrapartida + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.contrapartida / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.adiantavel.total !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total Adiantável R$ <span class=\'realce\'>' + _vm.totais.adiantavel.total + '</span>, sendo R$ <span class=\'realce\'>' + _vm.totais.adiantavel.fbb + '</span> da Fundação e R$ <span class=\'realce\'>' + _vm.totais.adiantavel.parceiros + '</span> de Parc. Estratégico</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.adiantavel.total)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Total do Projeto R$ <span class=\'realce\'>' + _vm.totais.projeto.total + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.total + '</span> itens</h5>'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.total)))])])])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('table', {
	    staticClass: "totais",
	    staticStyle: {
	      "margin": "10px 0"
	    }
	  }, [_c('tr', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_c('td', {
	    staticStyle: {
	      "padding": "1px",
	      "text-align": "center",
	      "vertical-align": "baseline"
	    }
	  }, [_c('p', [_c('span', [_vm._v(" Investimento "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-info-circle",
	    attrs: {
	      "title": "Produtos, obra civil, seguros e IPVA"
	    }
	  })])]), _vm._v(" "), _c('p', [_c('span', [_c('strong', [_vm._v(" " + _vm._s((_vm.totalInvestimento / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")])])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(" " + _vm._s(_vm._f("real")(_vm.totalInvestimento)) + " ")])])]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "padding": "1px",
	      "text-align": "center",
	      "vertical-align": "baseline"
	    }
	  }, [_c('p', [_c('span', [_vm._v(" Custeio "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-info-circle",
	    attrs: {
	      "title": "O que não for investimento"
	    }
	  })])]), _vm._v(" "), _c('p', [_c('span', [_c('strong', [_vm._v(" " + _vm._s((_vm.totalCusteio / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")])])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(" " + _vm._s(_vm._f("real")(_vm.totalCusteio)) + " ")])]), _vm._v(" "), _c('p', [_vm._v("\n              Capacitação e assessoria\n              "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(((_vm.totalCapacitacao + _vm.totalAssessoria) / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")]), _vm._v("\n              (" + _vm._s(_vm._f("real")(_vm.totalCapacitacao + _vm.totalAssessoria)) + ")\n            ")])])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start legenda-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered gap-5"
	  }, [_c('div', {
	    staticClass: "validado-legenda legenda-box"
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "CV menor de 25%"
	    }
	  }, [_vm._v("\n            Validação Automática\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered gap-5"
	  }, [_c('div', {
	    staticClass: "validado legenda-box"
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "Cadastrado no Busca Preços mas com CV maior que 25% ou Remoção Manual de Itens"
	    }
	  }, [_vm._v("\n            Automático com validação manual\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered gap-5"
	  }, [_c('div', {
	    staticClass: "validado-manual legenda-box"
	  }), _vm._v(" "), _c('div', [_vm._v("\n            Manual Validado\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered gap-5"
	  }, [_c('div', {
	    staticClass: "legado-legenda legenda-box"
	  }), _vm._v(" "), _c('div', [_vm._v("\n            Cotação Manual Antiga\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered gap-5"
	  }, [_c('div', {
	    staticClass: "pendente-validacao-legenda legenda-box"
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "CV acima de 25% / Cotação Manual / Remoções manuais"
	    }
	  }, [_vm._v("\n            Pendente de validação\n          ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticClass: "cabecalho"
	  }, [_c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Tipo Cotação")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Atividade / Itens do Cronograma")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
	    staticClass: "centralizado"
	  }, [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', [_vm._v("Adiantável")])])
	}]}

/***/ }),
/* 2076 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body extratoff"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.loading.carregando) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(0)]) : _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.acertos.length === 0) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.acertoAcao === '') ? _c('p', {
	    staticClass: "bg-info"
	  }, [_vm._v("\n          Não há registros de acertos/devolução no Contas a Pagar nem a Receber no Sapiens\n        ")]) : _c('p', {
	    staticClass: "bg-danger"
	  }, [_vm._v(_vm._s(_vm.acertoAcao))])]) : _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.processando),
	      expression: "loading.processando"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed"
	  }, [_vm._l((_vm._.groupBy(_vm.acertos, 'origem')), function(recurso, codigoRecurso) {
	    return [_c('thead', [_c('tr', {
	      staticClass: "cabecalho"
	    }, [_c('th', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("Acertos por conta financeira em Recursos " + _vm._s(codigoRecurso === 1 ? 'da Fundação BB' : 'de Parceiro Estratégico'))]), _vm._v(" "), _c('th', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "centralizado",
	      staticStyle: {
	        "width": "80px"
	      },
	      attrs: {
	        "title": '<h5>Situação do título no Sapiens</h5>'
	      }
	    }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "centralizado",
	      staticStyle: {
	        "width": "130px"
	      },
	      attrs: {
	        "title": '<h5>Número do título criado no Sapiens</h5>'
	      }
	    }, [_vm._v("Nº do documento")]), _vm._v(" "), _c('th', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "centralizado",
	      staticStyle: {
	        "width": "140px"
	      },
	      attrs: {
	        "title": '<h5>Classificação do acerto se veio de um cancelamento de nota fiscal de entrada no Sapiens ou de título no contas a receber</h5>'
	      }
	    }, [_vm._v("Origem do acerto")]), _vm._v(" "), _c('th', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "centralizado",
	      staticStyle: {
	        "width": "100px"
	      },
	      attrs: {
	        "title": '<h5>Valor do título no Sapiens</h5>'
	      }
	    }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	      staticClass: "centralizado",
	      staticStyle: {
	        "width": "180px"
	      }
	    }, [_c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-question-circle",
	      attrs: {
	        "aria-hidden": "true",
	        "title": '<h5>Aqui constam os títulos de acertos registrados no Sapiens<br/><br/>O botão de Recomposição de saldo de itens permitirá acrescebtar saldo nos itens escolhidos sem alterar seu orçamento<br/> O botão de Cancelamento de processo de NF cancelará o ID da solicitação no SGP correspondente ao título cancelado no Sapiens.<br/>O botão de visualiar permite saber para quais itens foi a recomposiação do saldo se houver<br/>Este é um formulário dinâmico que sempre lê o Sapiens e as alterações registradas aqui <b>somente afetam o SGP</b></h5>'
	      }
	    })])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm._.groupBy(recurso, 'numeroContaFinanceira')), function(conta, numeroConta) {
	      return [_c('tr', {
	        staticClass: "atividade"
	      }, [_c('td', {
	        staticClass: "esquerda celula b1 b3 b4",
	        attrs: {
	          "colspan": "5"
	        }
	      }, [_vm._v(_vm._s(_vm._.first(conta)['numeroContaFinanceira']) + " / " + _vm._s(_vm._.first(conta)['nomeContaFinanceira']))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b2"
	      }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(conta, function(c) {
	        return parseFloat(c.valor)
	      }))))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b2"
	      }, [_vm._v(" ")])]), _vm._v(" "), _vm._l((conta), function(titulo, tituloIndex) {
	        return [_c('tr', [_c('td', {
	          staticClass: "centralizado celula b3 b4"
	        }, [_c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          attrs: {
	            "title": '<h5>Data de Entrada do título no Sapiens</h5>'
	          }
	        }, [_vm._v("\n                              " + _vm._s(_vm._f("moment")(titulo.dataEntrada, "L")) + "\n                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          attrs: {
	            "title": '<h5>Data de Pagamento</h5>'
	          }
	        }, [_vm._v("\n                              " + _vm._s(_vm._f("moment")(titulo.dataPagamento, "L")) + "\n                            ")])]), _vm._v(" "), _c('td', {
	          staticClass: "celula b3 b4"
	        }, [_c('strong', [_vm._v(_vm._s(titulo.codigoClienteFornecedor) + "  " + _vm._s(titulo.nomeClienteFornecedor))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(titulo.observacao))])]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b4"
	        }, [_c('span', [_vm._v(_vm._s(titulo.situacaoTitulo))])]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b4"
	        }, [_c('span', [_vm._v("\n                            " + _vm._s(titulo.numeroTitulo)), _c('br'), _vm._v("\n                            " + _vm._s(titulo.tipoTitulo) + "\n                          ")])]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b4"
	        }, [_c('span', [_vm._v(_vm._s(titulo.origemAcerto))])]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b4"
	        }, [_c('span', [_vm._v(_vm._s(_vm._f("real")(titulo.valor)))])]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b2 b3 b4"
	        }, [(!_vm.mostrarListaItens) ? _c('span', [(_vm.formEditavel) ? _c('span', [(titulo.origemAcerto === 'Título - Contas a Receber') ? _c('span', [(_vm._.find(_vm._.get(titulo, 'processo.documentosliberacao[0].itens_liberados'), ['tipo', 'BASE'])) ? _c('span', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.visualizaRecomposicaoSaldos(titulo)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search"
	        }), _vm._v(" Visualizar")])], 1) : _c('span', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.recomporSaldos(titulo)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-dollar"
	        }), _vm._v(" "), _c('i', {
	          staticClass: "fa fa-level-up",
	          staticStyle: {
	            "margin-left": "-2px"
	          }
	        }), _vm._v(" Recompor saldos")])], 1)]) : (titulo.origemAcerto === 'Cancelamento NF - Contas a Pagar') ? _c('span', [_c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.cancelarSolicitacao(titulo)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ban",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Cancelar solicitação")])], 1) : _vm._e()]) : _c('span', [(_vm._.find(_vm._.get(titulo, 'processo.documentosliberacao[0].itens_liberados'), ['tipo', 'BASE'])) ? _c('span', [(titulo.origemAcerto === 'Título - Contas a Receber') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.visualizaRecomposicaoSaldos(titulo)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search"
	        }), _vm._v(" Visualizar")]) : _vm._e()], 1) : _c('span', [_vm._v(" ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.mostrarListaItens && _vm.acertoEdicao.chave === titulo.chave) ? _c('tr', [_c('td', {
	          attrs: {
	            "colspan": "7"
	          }
	        }, [_c('div', {
	          staticClass: "quadroEdicaoItem",
	          staticStyle: {
	            "padding": "10px"
	          }
	        }, [_c('div', {
	          staticClass: "form-group"
	        }, [_c('label', {
	          staticClass: "control-label col-md-12",
	          staticStyle: {
	            "text-align": "left"
	          }
	        }, [_vm._v("Itens com a mesma conta financeira do acerto:")]), _vm._v(" "), _c('div', [_c('div', {
	          staticClass: "col-md-12"
	        }, [_c('table', {
	          staticClass: "table table-condensed table-bordered table-hover"
	        }, [_c('thead', [_c('tr', {
	          staticClass: "cabecalho"
	        }, [_c('th', {
	          attrs: {
	            "colspan": "2"
	          }
	        }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado",
	          attrs: {
	            "colspan": "2",
	            "title": '<h5>Valor total contratado no projeto por Atividade e Item</h5>'
	          }
	        }, [_vm._v("\n                                      Orçado\n                                    ")]), _vm._v(" "), _c('th', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado",
	          attrs: {
	            "rowspan": "2",
	            "title": '<h5>Valor para recomposição do saldo do item</h5>'
	          }
	        }, [_vm._v("\n                                      Recomposição\n                                    ")]), _vm._v(" "), _c('th', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado",
	          attrs: {
	            "colspan": "2",
	            "title": '<h5>Saldo restante de cada Atividade e Item</h5>'
	          }
	        }, [_vm._v("\n                                      Saldo\n                                    ")]), _vm._v(" "), _c('th', {
	          staticClass: "centralizado"
	        }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', {
	          staticClass: "cabecalho"
	        }, [_c('th', {
	          attrs: {
	            "colspan": "2"
	          }
	        }, [_vm._v("Atividade / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
	          staticClass: "centralizado"
	        }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	          staticClass: "centralizado"
	        }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	          staticClass: "centralizado"
	        }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
	          staticClass: "centralizado"
	        }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado",
	          attrs: {
	            "title": '<h5>Percentual aproximado já liberado<br/>Não considera Economicidade</h5>'
	          }
	        }, [_vm._v("\n                                      Atingimento\n                                    ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.itensRecomposiacaoEdicao), function(item) {
	          return [((_vm.acertoAcao === 'edicao') || (_vm.acertoAcao === 'visualizacao' && _vm._.has(item, 'Valor_solicitado') && item.Valor_solicitado !== 0)) ? _c('tr', [_c('td', {
	            staticClass: "centralizado celula b3 b4"
	          }, [(('' + item.origem).substring(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substring(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substring(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (item.adiantavel === '1' || item.adiantavel === 1) ? _c('span', [_c('br'), _vm._v("Adiantável")]) : _vm._e()]), _vm._v(" "), _c('td', {
	            staticClass: "celula b3 b4"
	          }, [_c('div', {
	            staticClass: "item"
	          }, [_c('div', {
	            staticClass: "item_despesa esquerda"
	          }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('div', {
	            staticClass: "conta_financeira direita"
	          }, [_vm._v(_vm._s(item.contaFinanceiraNumero) + " / " + _vm._s(item.contaFinanceiraDescricao))]), _vm._v(" "), _c('div', {
	            staticClass: "observacao esquerda",
	            domProps: {
	              "innerHTML": _vm._s('<span class=id_item>#' + item.id + '</span>  ' + item.observacao + '</span>')
	            }
	          })])]), _vm._v(" "), _c('td', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'perspective',
	                distance: '1',
	                size: 'large',
	                arrow: true
	              }),
	              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	            }],
	            staticClass: "centralizado celula b3 b4",
	            attrs: {
	              "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
	            }
	          }, [_vm._v("\n                                          " + _vm._s(item.quantidadeOrcado) + "\n                                        ")]), _vm._v(" "), _c('td', {
	            staticClass: "centralizado celula b3"
	          }, [_vm._v(_vm._s(_vm._f("decimal2")(item.valorOrcado)))]), _vm._v(" "), _c('td', {
	            staticClass: "centralizado celula b3 valorRecomposicao"
	          }, [_c('money', {
	            staticClass: "form-control text-right valorSolicitacao",
	            attrs: {
	              "name": "valor a recompor",
	              "type": "text",
	              "disabled": _vm.acertoAcao === 'visualizacao'
	            },
	            nativeOn: {
	              "keyup": function($event) {
	                item.Valor_solicitado = _vm.limitaFaixaEntrada(item, 0, _vm.acertoEdicao.valor)
	              }
	            },
	            model: {
	              value: (item.Valor_solicitado),
	              callback: function($$v) {
	                _vm.$set(item, "Valor_solicitado", $$v)
	              },
	              expression: "item.Valor_solicitado"
	            }
	          })], 1), _vm._v(" "), _c('td', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'perspective',
	                distance: '1',
	                size: 'large',
	                arrow: true
	              }),
	              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	            }],
	            staticClass: "centralizado celula b3 b4",
	            attrs: {
	              "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
	            }
	          }, [_vm._v("\n                                          " + _vm._s(item.quantidadeSaldo) + "\n                                        ")]), _vm._v(" "), _c('td', {
	            staticClass: "centralizado celula b3"
	          }, [_vm._v(_vm._s(_vm._f("decimal2")(item.valorSaldo + parseFloat(item.Valor_solicitado))))]), _vm._v(" "), _c('td', {
	            staticClass: "centralizado celula b3 b2"
	          }, [_vm._v("\n                                          " + _vm._s(_vm._f("percentage")(item.percAtingimento)) + "\n                                          "), (('' + item.economicidade) === '1') ? _c('i', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'perspective',
	                distance: '1',
	                size: 'large',
	                arrow: true
	              }),
	              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	            }],
	            staticClass: "fa fa-dollar economicidade",
	            attrs: {
	              "title": '<h5>Comprovado com Economicidade</h5>'
	            }
	          }) : _vm._e()])]) : _vm._e()]
	        })], 2)])])])]), _vm._v(" "), (_vm.formEditavel) ? _c('div', {
	          staticClass: "col-md-12 form-group required-field",
	          class: {
	            'has-error': _vm.errors.first('justificativa')
	          }
	        }, [_c('label', {
	          staticClass: "control-label col-md-2"
	        }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
	          staticClass: "col-md-10"
	        }, [_c('textarea', {
	          directives: [{
	            name: "resizable",
	            rawName: "v-resizable"
	          }, {
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.acertoEdicao.justificativa),
	            expression: "acertoEdicao.justificativa"
	          }, {
	            name: "validate",
	            rawName: "v-validate",
	            value: ('required'),
	            expression: "'required'"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "name": "justificativa",
	            "placeholder": "Descreva justificativa para recomposição dos itens deste acerto",
	            "rows": "3",
	            "data-vv-as": "Justificativa",
	            "disabled": _vm.acertoAcao === 'visualizacao'
	          },
	          domProps: {
	            "value": (_vm.acertoEdicao.justificativa)
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.acertoEdicao, "justificativa", $event.target.value)
	            }
	          }
	        }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "form-group"
	        }, [_c('div', {
	          staticClass: "col-md-10 col-md-offset-2"
	        }, [(_vm.acertoAcao !== 'visualizacao') ? _c('button', {
	          staticClass: "btn btn-confirm btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": _vm.ok
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-check",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
	          staticClass: "btn btn-back btn-flat",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "~click": function($event) {
	              return _vm.cancelar($event)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-times-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Cancelar")])])])])])]) : _vm._e()]
	      })]
	    })], 2)]
	  })], 2)])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v("  Verificando se há acertos de devolução no Sapiens e atualizando SGP...")])
	}]}

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.form.successful) ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [(_vm.dismissible) ? _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": _vm.dismiss
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _vm._t("default", [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.message)
	    }
	  })])], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
	    attrs: {
	      "name": "frmRegNotice",
	      "novalidate": "",
	      "_lpchecked": "1"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "extensao"
	    }
	  }, [_vm._v("Extensão:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true
	      }),
	      expression: "{required: true}"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoDoArquivo),
	      expression: "tipoDoArquivo"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "value": "1",
	      "checked": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tipoDoArquivo, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.tipoDoArquivo = "1"
	      }
	    }
	  }), _vm._v(" PDF\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipoDoArquivo),
	      expression: "tipoDoArquivo"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "type": "radio",
	      "name": "status",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tipoDoArquivo, "2")
	    },
	    on: {
	      "change": function($event) {
	        _vm.tipoDoArquivo = "2"
	      }
	    }
	  }), _vm._v(" Excel\n                      "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required",
	    class: {
	      'has-error': _vm.errors.first('tipoDoArquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "tipoDoArquivo"
	    }
	  }, [_vm._v("Relatório:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorio),
	      expression: "relatorio"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "name": "tipoRelatorio"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.relatorio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [(_vm.tipoDoArquivo == 1) ? _c('option', {
	    attrs: {
	      "value": "ANALISE"
	    }
	  }, [_vm._v("Análise")]) : _vm._e(), _vm._v(" "), (_vm.tipoDoArquivo == 1) ? _c('option', {
	    attrs: {
	      "value": "PROPOSTA"
	    }
	  }, [_vm._v("Proposta")]) : _vm._e(), _vm._v(" "), (_vm.tipoDoArquivo == 2) ? _c('option', {
	    attrs: {
	      "value": "APLICACAO"
	    }
	  }, [_vm._v("Proposta")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipoDoArquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [(_vm.relatorio !== '') ? _c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "href": "javascript:void(0)",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onDownload
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Gerar")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onClean
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eraser",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Impressão de Relatórios")])])
	}]}

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.showGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [(_vm.editando) ? _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento.ds_tipo),
	      expression: "documento.tipo_documento.ds_tipo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.documento.tipo_documento.ds_tipo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.documento.tipo_documento, "ds_tipo", $event.target.value)
	      }
	    }
	  })]) : _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento",
	      "disabled": _vm.desativado || _vm.editando
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(tipoDocumento) {
	    return _c('option', {
	      key: _vm.documento.id,
	      domProps: {
	        "value": tipoDocumento
	      }
	    }, [_vm._v(_vm._s(tipoDocumento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'tipo_documento') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'tipo_documento') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.tipo_documento.ds_tipo + '</h5>'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [(_vm.editando) ? _c('div', [_c('a', {
	    staticClass: "ng-binding",
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onDownload(_vm.documento)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.documento.ds_nome_arquivo))])]) : _c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file",
	      "disabled": _vm.desativado
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })])]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_nome_arquivo') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "margin-left": "-50px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'ds_nome_arquivo') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "margin-left": "-50px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.ds_nome_arquivo + '</h5>'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Vigencia')
	    },
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "expirationDate"
	    }
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.dt_data_vigencia),
	      expression: "documento.dt_data_vigencia"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: (_vm.documento.tipo_documento === undefined ? false : !!_vm.documento.tipo_documento.vigencia_obrigatoria),
	        validdate: true
	      }),
	      expression: "{required: (documento.tipo_documento === undefined ? false : !!documento.tipo_documento.vigencia_obrigatoria), validdate: true}"
	    }],
	    ref: "Vigencia",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "Vigencia",
	      "data-vv-as": "Vigencia",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.documento.dt_data_vigencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.documento, "dt_data_vigencia", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Vigencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Vigencia')))]) : _vm._e()]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'dt_data_vigencia') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "-10px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'dt_data_vigencia') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "-10px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.dt_data_vigencia + '</h5>'
	    }
	  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), (_vm.editando) ? _c('span', [_vm._v("Ok")]) : _c('span', [_vm._v("Adicionar Documento")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [(_vm.totalMb) ? _c('span', [_vm._v("     "), _c('b', [_vm._v(_vm._s(_vm.totalMb))]), _vm._v(" MB de "), _c('b', [_vm._v("80")]), _vm._v(" MB permitidos ")]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "col-md-4"
	  }, [(_vm.totalMb < 50) ? _c('div', {
	    staticClass: "bar",
	    style: ('height:15px;background:green;width:' + _vm.progress + '%')
	  }) : _vm._e(), _vm._v(" "), (_vm.totalMb > 50 && _vm.totalMb < 70) ? _c('div', {
	    staticClass: "bar",
	    style: ('height:15px;background:orange;width:' + _vm.progress + '%')
	  }) : _vm._e(), _vm._v(" "), (_vm.totalMb > 70) ? _c('div', {
	    staticClass: "bar",
	    style: ('height:15px;background:red;width:' + _vm.progress + '%')
	  }) : _vm._e()]), _vm._v(" "), (_vm.totalMb) ? _c('span', [_vm._v(_vm._s(_vm.progress) + " % (" + _vm._s(_vm.contador) + " arquivo(s) novo(s))")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.faseProposta !== 'FORMALIZACAO' && _vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO' && !_vm.ehParceiroEstrategico) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.novoDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento ")]), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "1px",
	      "color": "#048019"
	    },
	    attrs: {
	      "title": '<h5>Inclusões: ' + _vm.inclDocTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a inserção de novo(s) documento(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true && _vm.mostraExclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "1px",
	      "color": "#808080"
	    },
	    attrs: {
	      "title": '<h5>Exclusões: ' + _vm.excDocTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a exclusão de documento(s)")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), _c('td', [_vm._v("Vigência")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
	    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(pendente.ds_tipo))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [(!_vm.disable && !_vm.ehParceiroEstrategico) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
	      staticStyle: {
	        "max-width": "135px",
	        "text-align": "center"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onAddFile(pendente)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("\n                  Adicionar arquivo\n                ")]) : _vm._e()])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      key: indexDocumento,
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "value": documento
	      }
	    }, [(documento.tipo_documento) ? _c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]) : _c('td'), _vm._v(" "), (_vm.localUso === 'PROPOSTA_COMPLETA_DOCUMENTOS_ANEXOS') ? _c('td', [(documento.id || documento.file) ? _c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))]) : _c('span', {
	      attrs: {
	        "title": "Erro no upload, envie o arquivo novamente"
	      }
	    }, [_c('span', [_vm._v("\n                    " + _vm._s(documento.ds_nome_arquivo) + " \n                  ")]), _vm._v(" "), _vm._m(1, true)])]) : _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), (!documento.dt_data_validade) ? _c('td', [_vm._v("\n                " + _vm._s(_vm._f("moment")(documento.dt_data_vigencia, 'DD/MM/YYYY')) + "\n              ")]) : _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_data_validade, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(documento.id && !_vm.disable && !_vm.PropProrrogacaoEdit && !_vm.ehParceiroEstrategico) ? _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO'),
	        expression: "faseProposta !== 'APROVACAO_PROJETO' && faseProposta !== 'APROVACAO'"
	      }],
	      staticClass: "btn btn-primary btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editaDocumento(documento, indexDocumento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil-square-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Editar\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.disable && !_vm.PropEditandoAlteracaoProjeto && !_vm.ehParceiroEstrategico) ? _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO'),
	        expression: "faseProposta !== 'APROVACAO_PROJETO' && faseProposta !== 'APROVACAO'"
	      }, {
	        name: "confirm",
	        rawName: "v-confirm",
	        value: ({
	          ok: function (retorno) { return _vm.deletaDocumento(indexDocumento); },
	          cancel: _vm.doNothing,
	          message: 'Deseja <b>APAGAR</b> a documento ' + documento.ds_nome_arquivo + ' ?'
	        }),
	        expression: "{ok: retorno => deletaDocumento(indexDocumento), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> a documento ' + documento.ds_nome_arquivo + ' ?'}"
	      }],
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "type": "button"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-sm-offset-1 fa-lg"
	    }, [(_vm._.hasIn(_vm.atualizados, indexDocumento)) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true,
	          placement: 'left'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
	      }],
	      staticClass: "fa fa-warning",
	      staticStyle: {
	        "position": "relative",
	        "top": "8px",
	        "margin-left": "2px",
	        "color": "#fb2916"
	      },
	      attrs: {
	        "title": '<h5>Clique em editar para ver as mudanças.</h5>'
	      }
	    }) : _vm._e()])]) : _vm._e()])
	  })], 2)])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "text-danger"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pendente")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticStyle: {
	      "color": "#FF9900"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Erro no upload do arquivo ")])
	}]}

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.showGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [(_vm.editando) ? _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento.ds_tipo),
	      expression: "documento.tipo_documento.ds_tipo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.documento.tipo_documento.ds_tipo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.documento.tipo_documento, "ds_tipo", $event.target.value)
	      }
	    }
	  })]) : _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento",
	      "disabled": _vm.desativado || _vm.editando
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(tipoDocumento) {
	    return _c('option', {
	      key: _vm.documento.id,
	      domProps: {
	        "value": tipoDocumento
	      }
	    }, [_vm._v(_vm._s(tipoDocumento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'tipo_documento') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'tipo_documento') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-sm-offset-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "2px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.tipo_documento.ds_tipo + '</h5>'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4 col-lg-3",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-16"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [(_vm.editando) ? _c('div', [_c('a', {
	    staticClass: "ng-binding",
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onDownload(_vm.documento)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.documento.ds_nome_arquivo))])]) : _c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file",
	      "disabled": _vm.desativado
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })])]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_nome_arquivo') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "margin-left": "-50px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'ds_nome_arquivo') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "6px",
	      "margin-left": "-50px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.ds_nome_arquivo + '</h5>'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('Vigencia')
	    },
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-16"
	  }, [(_vm._.hasIn(_vm.mudancas, 'dt_data_vigencia') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "-10px",
	      "color": "#048019"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'dt_data_vigencia') && _vm.ocultaIcone === false) ? _c('div', {
	    staticClass: "col-md-2 fa-lg"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "-10px",
	      "color": "red"
	    },
	    attrs: {
	      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.dt_data_vigencia + '</h5>'
	    }
	  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [(_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "1px",
	      "color": "#048019"
	    },
	    attrs: {
	      "title": '<h5>Inclusões: ' + _vm.inclDocTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a inserção de novo(s) documento(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true && _vm.mostraExclusao) ? _c('div', [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        placement: 'right',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
	    }],
	    staticClass: "fa fa-warning",
	    staticStyle: {
	      "position": "relative",
	      "top": "8px",
	      "margin-left": "1px",
	      "color": "#808080"
	    },
	    attrs: {
	      "title": '<h5>Exclusões: ' + _vm.excDocTexto + '</h5>'
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("  Houve a exclusão de documento(s)")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
	    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(pendente.ds_tipo))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    })]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      key: indexDocumento,
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "value": documento
	      }
	    }, [(documento.tipo_documento) ? _c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]) : _c('td'), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))])])
	  })], 2)])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "text-danger"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pendente")])])
	}]}

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.propsAnalise.fep) ? _c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-fep',
	        params: {
	          id: _vm.propsAnalise.id
	        },
	        props: {
	          propsRel: _vm.propsAnalise
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  FEP")]) : _vm._e(), _vm._v(" "), (_vm.propsAnalise.fep) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-2",
	    class: {
	      'has-error': _vm.errors.first('numeroFEP')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número da FEP:")]), _vm._v("\n      " + _vm._s(_vm.propsAnalise.fep.ano) + "/" + _vm._s(_vm.propsAnalise.fep.numero) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('título do projeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Título do Projeto")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_nome),
	      expression: "propsAnalise.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "título do projeto",
	      "type": "text",
	      "maxlength": "255",
	      "placeholder": "Título do Projeto",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.propsAnalise.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propsAnalise, "ds_nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('título do projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('título do projeto')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('participantes diretos')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Participantes Diretos")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participantesDiretos),
	      expression: "participantesDiretos"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "participantes diretos",
	      "type": "text",
	      "maxlength": "255",
	      "placeholder": "Participantes Diretos",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.participantesDiretos)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.participantesDiretos = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group required-field col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivo Geral")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_objetivo_geral),
	      expression: "propsAnalise.ds_objetivo_geral"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "objetivo geral",
	      "type": "text",
	      "placeholder": "Objetivo Geral",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.propsAnalise.ds_objetivo_geral)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propsAnalise, "ds_objetivo_geral", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('orçamento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Orçamento")]), _vm._v(" "), _c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "orçamento",
	      "type": "text",
	      "maxlength": "255",
	      "readonly": ""
	    },
	    model: {
	      value: (_vm.totalFBB),
	      callback: function($$v) {
	        _vm.totalFBB = $$v
	      },
	      expression: "totalFBB"
	    }
	  }), _vm._v(" "), (_vm.errors.first('orçamento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('orçamento')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('proponente')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Proponente")]), _vm._v(" "), (_vm.propsAnalise.entidade) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.entidade.ds_nome),
	      expression: "propsAnalise.entidade.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:255'),
	      expression: "'required|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "proponente",
	      "type": "text",
	      "maxlength": "255",
	      "placeholder": "Proponente",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.propsAnalise.entidade.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.propsAnalise.entidade, "ds_nome", $event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.errors.first('proponente')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('proponente')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('tipo de ação')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.ds_fep_tipo_acao),
	      expression: "propsAnalise.ds_fep_tipo_acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "tipo de ação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "ds_fep_tipo_acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.fep.actionTypes), function(i) {
	    return _c('option', {
	      domProps: {
	        "value": i.code
	      }
	    }, [_vm._v(_vm._s(i.description))])
	  }), 0), _vm._v(" "), (_vm.errors.first('tipo de ação')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de ação')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('cnpj')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), (_vm.propsAnalise.entidade) ? _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cnpj",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens,
	      "readonly": ""
	    },
	    model: {
	      value: (_vm.propsAnalise.entidade.ds_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise.entidade, "ds_cnpj", $$v)
	      },
	      expression: "propsAnalise.entidade.ds_cnpj"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.errors.first('cnpj')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('abrangencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Abrangência Nacional")]), _vm._v(" "), _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.propsAnalise.bt_fep_abrangencia),
	      expression: "propsAnalise.bt_fep_abrangencia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "abrangencia"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.propsAnalise, "bt_fep_abrangencia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('abrangencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('abrangencia')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('parecer')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Parecer")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "parecer"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.propsAnalise.ds_fep_parecer),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise, "ds_fep_parecer", $$v)
	      },
	      expression: "propsAnalise.ds_fep_parecer"
	    }
	  }), _vm._v(" "), (_vm.errors.first('parecer')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('parecer')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('observacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "observacao"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.propsAnalise.ds_fep_observacao),
	      callback: function($$v) {
	        _vm.$set(_vm.propsAnalise, "ds_fep_observacao", $$v)
	      },
	      expression: "propsAnalise.ds_fep_observacao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('observacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('observacao')))]) : _vm._e()], 1)])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border",
	    staticStyle: {
	      "background-color": "#FCFCFC"
	    }
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("FEP")])])
	}]}

/***/ }),
/* 2082 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.propostas.length > 0) ? _c('div', {
	    staticClass: "box box-primary roteiro"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, _vm._l((_vm.propostas), function(proposta) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-md-7"
	    }, [_c('div', {
	      staticClass: "proposta_dados"
	    }, [_vm._v(_vm._s(proposta.nome))]), _vm._v(" "), _c('ol', {
	      staticClass: "lista"
	    }, _vm._l((proposta.passos), function(passo) {
	      return _c('li', [_c('span', {
	        staticClass: "passo"
	      }, [_vm._v(_vm._s(passo.texto))]), _c('span', {
	        class: 'situacao ' + passo.situacao_codigo
	      }, [_vm._v("\n                  " + _vm._s(passo.situacao) + "\n                  " + _vm._s(_vm._.includes(['concluido', 'cancelado', 'atencao'], passo.situacao_codigo) ? ' em ' : '') + "\n                  " + _vm._s(_vm._f("moment")((passo.situacao_codigo === 'atencao' ? passo.termino : (_vm._.includes(['concluido', 'cancelado'], passo.situacao_codigo) ? passo.termino : '')), 'DD/MM/YYYY')) + "\n\n                  "), (passo.codigo === 'cadastro_entidade' && !(_vm._.includes(['concluido', 'cancelado'], passo.situacao_codigo))) ? _c('a', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            placement: 'top',
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	        }],
	        attrs: {
	          "href": '/cadastro/entidades/edita/' + _vm.usuarioLogado.entity.id,
	          "target": "_blank",
	          "title": '<h5>Vá para ´Dados Cadastrais´ e complete o formulário</h5>'
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-external-link"
	      })]) : _vm._e(), _vm._v(" "), (passo.codigo === 'proposta' && !(_vm._.includes(['concluido', 'cancelado'], passo.situacao_codigo))) ? _c('a', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            placement: 'top',
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	        }],
	        attrs: {
	          "href": '/proposta/edita/' + proposta.id,
	          "target": "_blank",
	          "title": '<h5>Vá para a ´Minhas propostas´ e complete o formulário</h5>'
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-external-link"
	      })]) : _vm._e()]), _vm._v(" "), (_vm._.size(passo.info) > 0) ? _c('p', {
	        staticClass: "informacao"
	      }, [_vm._v(_vm._s(passo.info))]) : _vm._e()])
	    }), 0), _vm._v(" "), _c('i', [_vm._v("Atenção: A análise somente será iniciada quando o cadastro da entidade e a proposta forem concluídos")])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-5 lista_documentos"
	    }, [_c('span', [_vm._v("Documentos para download:")]), _vm._v(" "), (proposta.fk_edital === 3) ? _c('ul', [_c('li', [_c('a', {
	      attrs: {
	        "href": _vm.urlLaravel + '/docs/roteiro_voluntariado_2020_v1.pdf'
	      }
	    }, [_vm._v("Roteiro para preenchimento da proposta  "), _c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])]), _vm._v(" "), _c('li', [_c('a', {
	      attrs: {
	        "href": _vm.urlLaravel + '/docs/memoria_calculo_voluntariado_2020_v1.xls'
	      }
	    }, [_vm._v("Memória de Cálculo - Voluntariado 2020 "), _c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])]) : _vm._e(), _vm._v(" "), (proposta.fk_edital === 4) ? _c('ul', [_c('li', [_c('a', {
	      attrs: {
	        "href": _vm.urlLaravel + '/docs/roteiro_pis_2020_v1.pdf'
	      }
	    }, [_vm._v("Roteiro para preenchimento da proposta "), _c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])]), _vm._v(" "), _c('li', [_c('a', {
	      attrs: {
	        "href": _vm.urlLaravel + '/docs/memoria_calculo_pis_2020_v1.xls'
	      }
	    }, [_vm._v("Memória de Cálculo - PIS 2020 "), _c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])]) : _vm._e()])])
	  }), 0), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    attrs: {
	      "color": "dark-primary",
	      "size": "button--size-ss",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.carregarPropostas()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atualizar\n  ")])], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-map-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Roteiro\n    ")])])
	}]}

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Cadastro de Editais'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Edital")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Lista',
	        href: '#'
	      }, {
	        text: 'Editais',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "dark-primary",
	      "disabled": !this.$root.authorize('edital-novo'),
	      "size": "button--size-ss",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-editais-edita'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo Edital ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.table.filter,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.table.filter = ''
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "parametro",
	      fn: function(row) {
	        return [_vm._v("\n                            " + _vm._s(row.value) + " "), _c('a', {
	          attrs: {
	            "href": _vm.urlLaravel + '/autocredenciamento?' + row.value,
	            "target": "_blank"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-external-link"
	        })])]
	      }
	    }, {
	      key: "bt_ativo",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]
	      }
	    }, {
	      key: "edicao",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa fa-circle ', row.value === 'S' ? 'text-green' : 'text-red'],
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _c('span', [_vm._v(_vm._s(row.value === 'S' ? '  Ativo' : '  Desabilitado'))])]
	      }
	    }, {
	      key: "dt_data_inicial",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, ("DD/MM/YYYY [-] H[h]mm"))))]
	      }
	    }, {
	      key: "dt_data_final",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY [-] H[h]mm")))]
	      }
	    }, {
	      key: "dt_atualizado",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY [-] H[h]mm")))]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "to": {
	              name: 'cadastro-editais-edita',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.inativa(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" " + _vm._s(row.item.bt_ativo ? 'Inativar' : 'Ativar'))])], 1)]
	      }
	    }])
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.items.length,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v("\n-\n\n                      ")], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro de Editais")])])
	}]}

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.encerrado) ? _c('div', [(_vm.pendencias.cadastro !== null) ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Atualização cadastral devolvida para ajuste:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.respostaDevolucaoCadastro))])]) : _vm._e(), _vm._v(" "), (!_vm.numeroProjeto && _vm.loading.carregandoProjetos) ? _c('div', {
	    staticClass: "box"
	  }, [_vm._m(1)]) : (_vm.numeroProjeto || _vm.listaProjetos.length > 0 || !_vm._.isEmpty(_vm.projeto)) ? _c('div', {
	    staticClass: "box",
	    attrs: {
	      "id": "pendencias_projeto"
	    }
	  }, [(!_vm.propsNumeroProjeto) ? _c('div', {
	    staticClass: "box-header"
	  }, [(_vm.listaProjetos.length > 1) ? _c('span', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pendencias.mandatos || _vm.loading.pendencias.relatorios || _vm.loading.pendencias.itensOrcamento),
	      expression: "loading.pendencias.mandatos || loading.pendencias.relatorios || loading.pendencias.itensOrcamento"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Projeto:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.configuracoes.numeroProjetoSelecionado),
	      expression: "configuracoes.numeroProjetoSelecionado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "projeto",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.configuracoes, "numeroProjetoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.selecionaProjeto]
	    }
	  }, _vm._l((_vm.listaProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.ds_codigo_projeto_erp,
	        "selected": projeto.ds_codigo_projeto_erp === _vm.configuracoes.numeroProjetoSelecionado
	      }
	    }, [_vm._v(_vm._s(projeto.ds_codigo_projeto_erp) + " - " + _vm._s(projeto.ds_nome))])
	  }), 0)])])])]) : (_vm.listaProjetos.length === 1) ? _c('span', [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.listaProjetos[0].ds_codigo_projeto_erp) + " - " + _vm._s(_vm.listaProjetos[0].ds_nome))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.projeto)) ? _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "pendencias"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pendencias.mandatos),
	      expression: "loading.pendencias.mandatos"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Mandatos\n                "), (this.$root.authorize('minha-entidade-visualizar')) ? _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-external-link",
	    attrs: {
	      "title": '<h5>Vai para a tela do Cadastro da Entidade</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-entidade-edita',
	          params: {
	            id: _vm.usuarioLogado.entidade.id
	          }
	        })
	      }
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('table', {
	    staticClass: "table table-condensed b0"
	  }, [(_vm._.find(_vm.pendencias.mandatos, function(m) {
	    return _vm.situacaoPendencia(m.fim_mandato) > -30
	  })) ? _c('tbody', _vm._l((_vm.pendencias.mandatos), function(mandato) {
	    return (_vm.situacaoPendencia(mandato.fim_mandato) > -30) ? _c('tr', [_c('td', {
	      staticClass: "esmaecido w20"
	    }, [_vm._v(_vm._s(mandato.cargo))]), _vm._v(" "), _c('td', {
	      staticClass: "w30"
	    }, [_vm._v(_vm._s(mandato.nome))]), _vm._v(" "), _c('td', {
	      staticClass: "realce w20"
	    }, [_c('strong', [_vm._v("Término em " + _vm._s(_vm._f("moment")(mandato.fim_mandato, "L")))])]), _vm._v(" "), _c('td', [(_vm.situacaoPendencia(mandato.fim_mandato) > 0) ? _c('span', {
	      staticClass: "vencido"
	    }, [_vm._v("Vencido")]) : (_vm.situacaoPendencia(mandato.fim_mandato) === 0) ? _c('span', {
	      staticClass: "vence_hoje"
	    }, [_vm._v("Vence Hoje")]) : (_vm.situacaoPendencia(mandato.fim_mandato) > -30) ? _c('span', {
	      staticClass: "vence_breve"
	    }, [_vm._v("Vence em até 30 dias")]) : _vm._e()])]) : _vm._e()
	  }), 0) : _c('tbody', [_vm._m(2)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pendencias.relatorios),
	      expression: "loading.pendencias.relatorios"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Relatórios de Execução\n                "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-external-link",
	    attrs: {
	      "title": '<h5>Vai para a tela do cronograma dos Relatórios de Execução</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'visualiza-relatorio-execucao',
	          params: {
	            id: _vm.projeto.id_projeto
	          }
	        })
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-lg-8 col-md-10 col-sm-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed b0"
	  }, [_c('tbody', [(_vm.pendencias.relatorios.length > 0) ? [_vm._l((_vm.relatorioDisponivel()), function(relatorio) {
	    return [(_vm._.isNull(relatorio)) ? _c('tr', [_c('td', [_vm._v("Não há relatórios pendentes nem futuros para apresentar")])]) : _c('tr', [_c('td', {
	      staticClass: "esmaecido"
	    }, [_vm._v(_vm._s(relatorio.tipo))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "110px"
	      }
	    }, [_vm._v("Relatório nº " + _vm._s(relatorio.sequencia))]), _vm._v(" "), _c('td', {
	      staticClass: "realce"
	    }, [_c('strong', [_vm._v(_vm._s(relatorio.situacao))])]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "285px"
	      }
	    }, [(_vm._.includes(['Não apresentado'], relatorio.situacao.substr(0, 15))) ? _c('span', {
	      staticClass: "vencido"
	    }, [_vm._v("Limite para apresentação até " + _vm._s(_vm._f("moment")(relatorio.termino_concluir, "L")))]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Pendente de pre'], relatorio.situacao.substr(0, 15))) ? _c('span', {
	      staticClass: "vence_breve"
	    }, [_vm._v("Prazo regular para apresentação até " + _vm._s(_vm._f("moment")(relatorio.depois_30_final_ciclo, "L")))]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Devolvido para '], relatorio.situacao.substr(0, 15))) ? _c('span', {
	      staticClass: "vence_hoje"
	    }, [_vm._v("Rever o relatório")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Em análise pela'], relatorio.situacao.substr(0, 15))) ? _c('span', {}) : _vm._e(), _vm._v(" "), (_vm._.includes(['Fora do período'], relatorio.situacao.substr(0, 15)) && _vm._.has(relatorio, 'antes_30_final_ciclo')) ? _c('span', {
	      staticClass: "vence_breve"
	    }, [_vm._v("Ficará disponível a partir de " + _vm._s(_vm._f("moment")(relatorio.antes_30_final_ciclo, "L")))]) : _vm._e()])])]
	  })] : [_vm._m(3)]], 2)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pendencias.revisoes),
	      expression: "loading.pendencias.revisoes"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Tarefas para Revisão\n                "), _c('i', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	    }],
	    staticClass: "fa fa-external-link",
	    attrs: {
	      "title": '<h5>Vai para a tela de Solicitações onde pode listar e visualizar as tarefas</h5>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'solicitacao-lista'
	        })
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-lg-8 col-md-10 col-sm-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed b0"
	  }, [_c('tbody', [(_vm.pendencias.tarefasRevisao.length > 0) ? [_vm._l((_vm.pendencias.tarefasRevisao), function(tarefa) {
	    return [_c('tr', [_c('td', {
	      staticClass: "esmaecido"
	    }, [_vm._v("\n                          " + _vm._s(tarefa.id) + "\n                          "), (_vm._.includes(['ALTERACOES_PROJETO'], tarefa.nome)) ? _c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large'
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
	      }],
	      staticClass: "fa fa-external-link",
	      attrs: {
	        "title": '<h5>Vai direto para a solicitação ID ' + tarefa.id + '</h5>'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$router.push({
	            name: 'solicitacao-alteracoes-projeto',
	            params: {
	              id: tarefa.id
	            }
	          })
	        }
	      }
	    }) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(tarefa.processoTexto))]), _vm._v(" "), _c('td', [_c('span', {
	      staticClass: "esmaecido"
	    }, [_vm._v("Criado em ")]), _vm._v(" " + _vm._s(_vm._f("moment")(tarefa.inicioProcesso, "L")))]), _vm._v(" "), _c('td', [_c('span', {
	      staticClass: "esmaecido"
	    }, [_vm._v("Revisão desde ")]), _vm._v(" " + _vm._s(_vm._f("moment")(tarefa.inicioTarefa, "DD/MM/YYYY  HH:mm")))]), _vm._v(" "), _c('td', [(!_vm._.isNull(tarefa.valor)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(tarefa.valor)))]) : _c('span', [_vm._v(" ")])])])]
	  })] : [_vm._m(4)]], 2)])])])]), _vm._v(" "), (_vm.loading.pendencias.avaliacoes || _vm.pendencias.avaliacoes.length > 0) ? _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pendencias.avaliacoes),
	      expression: "loading.pendencias.avaliacoes"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-lg-8 col-md-10 col-sm-12"
	  }, [_c('table', {
	    staticClass: "table table-condensed b0"
	  }, [_c('tbody', [_vm._l((_vm.avaliacaoDisponivel()), function(avaliacao) {
	    return [_c('tr', {
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$router.push({
	            name: 'preenche-formulario',
	            params: {
	              id: avaliacao.acesso
	            }
	          })
	        }
	      }
	    }, [_c('td', [_c('i', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          arrow: true
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	      }],
	      staticClass: "fa fa-external-link",
	      attrs: {
	        "title": '<h5>Abre o formulário de Avaliação deste Projeto</h5>'
	      }
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "esmaecido",
	      staticStyle: {
	        "width": "120px"
	      }
	    }, [_vm._v(_vm._s(avaliacao.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(avaliacao.nome))]), _vm._v(" "), _c('td', {
	      staticClass: "realce"
	    }, [_c('strong', [_vm._v(_vm._s(avaliacao.situacao))])])]), _vm._v(" "), _c('tr', {
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$router.push({
	            name: 'preenche-formulario',
	            params: {
	              id: avaliacao.acesso
	            }
	          })
	        }
	      }
	    }, [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "225px"
	      },
	      attrs: {
	        "colspan": "3"
	      }
	    }, [(_vm._.includes(['SOLICITACAO', 'REVISAO'], avaliacao.tarefaAtual)) ? _c('span', {
	      class: avaliacao.info.classe
	    }, [_vm._v(_vm._s(avaliacao.info.texto))]) : _vm._e()])])]
	  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.pendencias.itensOrcamento),
	      expression: "loading.pendencias.itensOrcamento"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "box-body cronogramaff"
	  }, [(_vm._.find(_vm.pendencias.itensOrcamento, function(i) {
	    return ('' + i.economicidade) === '0' && _vm.percentual(i.liberado, i.orcado) < 100
	  }) && !_vm._.includes(['ENC', 'ESE'], _vm.projeto.situacao)) ? _c('div', {
	    staticClass: "col-lg-9 col-md-11 col-sm-12"
	  }, [_vm._l((_vm._.groupBy(_vm.pendencias.itensOrcamento, 'origem')), function(itensAtividades, origem) {
	    return [(_vm._.find(itensAtividades, function(i) {
	      return ('' + i.economicidade) === '0' && _vm.percentual(i.liberado, i.orcado) < 100
	    })) ? _c('table', {
	      staticClass: "table table-condensed b0"
	    }, [_c('tbody', [_c('tr', [_c('td', {
	      staticClass: "text-bold"
	    }, [_vm._v(_vm._s(origem))]), _vm._v(" "), _c('td', {
	      staticClass: "esmaecido"
	    }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
	      staticClass: "esmaecido"
	    }, [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm._.groupBy(itensAtividades, 'id_atividade')), function(itens, atividadeId) {
	      return [(_vm._.find(itens, function(i) {
	        return ('' + i.economicidade) === '0' && _vm.percentual(i.liberado, i.orcado) < 100
	      })) ? _c('tr', {
	        staticClass: "atividade",
	        attrs: {
	          "id": 'atividadeId' + atividadeId
	        },
	        on: {
	          "click": function($event) {
	            return _vm.mostraAtividade(itens)
	          }
	        }
	      }, [_c('td', {
	        staticClass: "esquerda celula b1 b3 b4 nome_atividade"
	      }, [_c('i', {
	        class: 'fa fa-caret-' + (itens[0]['mostrar'] ? 'up' : 'down'),
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v("  " + _vm._s(itens[0].descricao_atividade))]), _vm._v(" "), _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	        }],
	        staticClass: "centralizado celula b1 b3 b4 w10",
	        attrs: {
	          "title": '<h5>Início da atividade</h5>'
	        }
	      }, [_vm._v(_vm._s(_vm.periodoParaMesAno(itens[0].inicio_atividade, _vm.projeto.inicio, 'MMMM/YYYY')))]), _vm._v(" "), _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            inertia: true,
	            arrow: true,
	            animation: 'perspective',
	            distance: '1',
	            size: 'large',
	            arrow: true
	          }),
	          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	        }],
	        staticClass: "centralizado celula b1 b3 b4 w10",
	        attrs: {
	          "title": '<h5>Término da atividade</h5>'
	        }
	      }, [_vm._v(_vm._s(_vm.periodoParaMesAno(itens[0].termino_atividade, _vm.projeto.inicio, 'MMMM/YYYY')))]), _vm._v(" "), _c('td', {
	        staticClass: "centralizado celula b1 b3 b2",
	        staticStyle: {
	          "font-weight": "normal",
	          "width": "260px"
	        }
	      }, [(_vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) > itens[0].termino_atividade) ? _c('span', {
	        staticClass: "vencido"
	      }, [_vm._v("\n                            Atividade não concluída no prazo\n                          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._l((itens), function(item) {
	        return (('' + item.economicidade) === '0' && _vm.percentual(item.liberado, item.orcado) < 100 && item.mostrar) ? [_c('tr', {
	          attrs: {
	            "id": 'itemId_' + item.id
	          }
	        }, [_c('td', {
	          staticClass: "celula b3 b4"
	        }, [_c('div', {
	          staticClass: "item"
	        }, [_c('div', {
	          staticClass: "text-bold esquerda"
	        }, [_vm._v(_vm._s(item.item))]), _vm._v(" "), _c('div', {
	          staticClass: "observacao esquerda"
	        }, [_c('span', {
	          staticClass: "id_item"
	        }, [_vm._v("#" + _vm._s(item.id))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.observacao))])])])]), _vm._v(" "), _c('td', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado celula b3",
	          attrs: {
	            "title": '<h5>Valor orçado</h5>'
	          }
	        }, [_vm._v(_vm._s(_vm._f("decimal2")(item.orcado)))]), _vm._v(" "), _c('td', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	          }],
	          staticClass: "centralizado celula b3",
	          attrs: {
	            "title": '<h5>Valor liberado</h5>'
	          }
	        }, [_vm._v(_vm._s(_vm._f("decimal2")(item.liberado)))]), _vm._v(" "), _c('td', {
	          staticClass: "centralizado celula b3 b2"
	        }, [_c('span', {
	          staticClass: "realce"
	        }, [_vm._v(_vm._s(('' + item.economicidade) === '1' ? 100 : _vm.percentual(item.liberado, item.orcado)) + "%")])])])] : _vm._e()
	      })]
	    })], 2)]) : _vm._e()]
	  })], 2) : _c('div', {
	    staticClass: "col-md-8"
	  }, [_vm._v("Não há itens de orçamento pendentes para liberar" + _vm._s(_vm._.includes(['ENC', 'ESE'], _vm.projeto.situacao) ? '. Projeto encerrado' : ''))])])])])])]) : _vm._e()]) : _vm._e()]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Verificando pendências em projeto(s) ...")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_vm._v("Não há mandatos vencidos ou a vencer nos próximos 30 dias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_vm._v("Não foram enontrados relatórios de execução")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_vm._v("Não foram enontradas tarefas para que faça a revisão da solicitação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Avaliação de Projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Itens do Orçamento não executados")])])
	}]}

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return ((_vm._.has(_vm.propsProposta, 'adiantamento') && _vm.propsProposta.adiantamento.length > 0) || (_vm.totais.projeto.total !== 0) || (_vm.table.items.length > 0)) ? _c('div', {
	    staticClass: "box-body parcelasAdiantamento"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.formEditavel) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova parcela")]), _vm._v(" "), (_vm.table.items.length > 0) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button",
	      "title": '<h5>Redistribuirá proporcionalmente, o total de R$ <span class=\'realce\'>' + _vm.totais.projeto.total + '</span> nas <span class=\'realce\'>' + _vm.table.items.length + '</span> parcelas abaixo</h5>'
	    },
	    on: {
	      "click": _vm.distribuirValores
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-server",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Distribuir")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' ? _vm._.union(_vm.table.items, _vm._.filter(_vm.propsPropostaBackup.adiantamentos, function(a) {
	        return _vm._.includes(_vm._.get(_vm.processoSolicitacao, 'exclusao', []), a.id)
	      })) : _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "tbody-tr-class": _vm.modificacaoLinha,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "parcela",
	      fn: function(row) {
	        return [_c('div', {
	          staticStyle: {
	            "display": "flex",
	            "justify-content": "space-between",
	            "align-items": "center"
	          }
	        }, [_c('div', {
	          staticStyle: {
	            "width": "30px"
	          }
	        }, [(('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO') ? _c('span', {
	          staticClass: "pull-left"
	        }, [(_vm.ehItemNovo(row.item)) ? _c('span', {
	          staticClass: "label label-info"
	        }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), (_vm.ehItemExcluido(row.item)) ? _c('span', {
	          staticClass: "label label-danger"
	        }, [_vm._v("Excluído")]) : _vm._e()]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
	          staticStyle: {
	            "width": "30px"
	          }
	        }, [_vm._v(_vm._s(row.value))]), _vm._v(" "), _c('div', {
	          staticStyle: {
	            "width": "50px"
	          }
	        }, [(_vm.usuarioLogado.ds_tipo_usuario === 'FUNDACAO' && (_vm.formEditavel && !_vm._.has(row.item, 'requisitado'))) ? _c('span', {
	          staticClass: "botoesUpDown"
	        }, [(row.index > 0) ? _c('i', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	          }],
	          staticClass: "fa fa-chevron-up",
	          attrs: {
	            "title": '<h5>Move essa parcela para Cima<br/>Será a ' + (row.item.parcela - 1) + 'ª parcela</h5>'
	          },
	          on: {
	            "click": function($event) {
	              return _vm.moverLinha(row, 'cima')
	            }
	          }
	        }) : _vm._e(), _vm._v(" "), (row.index < _vm.table.items.length - 1) ? _c('i', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	          }],
	          staticClass: "fa fa-chevron-down",
	          attrs: {
	            "title": '<h5>Move essa parcela para Baixo<br/>Será a ' + (row.item.parcela + 1) + 'ª parcela</h5>'
	          },
	          on: {
	            "click": function($event) {
	              return _vm.moverLinha(row, 'baixo')
	            }
	          }
	        }) : _vm._e()]) : _c('span', [_vm._v(" ")])])])]
	      }
	    }, {
	      key: "origem",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [_c('span', [_vm._v(_vm._s(_vm.rotuloOrigemParcela(row.value)))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'origem.0')) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm.rotuloOrigemParcela('' + _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'origem.0', ''))) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "valor_fbb",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [(row.item.valor_fbb !== null && row.item.valor_fbb !== undefined) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm._f("real")(row.item.valor_fbb)) + "\n                  ")]) : _c('span', [_vm._v("-")])])]
	      }
	    }, {
	      key: "valor_parc",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [(row.item.valor_parc !== null && row.item.valor_parc !== undefined) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm._f("real")(row.item.valor_parc)) + "\n                  ")]) : _c('span', [_vm._v("-")])])]
	      }
	    }, {
	      key: "valor",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "input-group",
	          staticStyle: {
	            "display": "inline-table"
	          }
	        }, [_c('span', [_vm._v(_vm._s(_vm._f("real")(row.value)))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id])) ? _c('span', {
	          staticClass: "input-group-addon valorAlterado"
	        }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'valor.0', '0'))) + "\n                  ")]) : _vm._e()])]
	      }
	    }, {
	      key: "requisitado",
	      fn: function(row) {
	        return [_c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	          }],
	          attrs: {
	            "title": '<h5>Valor liberado ou em análise para liberação</h5>'
	          }
	        }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(row.value)) + "\n                ")])]
	      }
	    }, {
	      key: "percentual_comprovado",
	      fn: function(row) {
	        return [(row.value > 0) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	          }],
	          class: (row.value >= 1 ? 'atingido100' : (row.value >= 0.8 ? 'atingido80' : 'nao_atingido')),
	          attrs: {
	            "title": '<h5>Refere-se a todas as prestações de contas registradas no SGP sobre o valor requisitado</h5>'
	          }
	        }, [_vm._v("\n                  " + _vm._s(_vm._f("percentage")(row.value)) + "\n                ")]) : _vm._e()]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.propsLayout != 'EXECUCAO' || (_vm.formEditavel && !_vm._.has(row.item, 'requisitado')) || (_vm.formEditavel && _vm.ehParcelaSemOrigem(row.item))) ? _c('div', [(_vm.ehItemExcluido(row.item)) ? _c('span', [_c('b-button', {
	          staticClass: "btn btn-back btn-flat btn-sm",
	          attrs: {
	            "type": "button"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.reincluir(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-refresh",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Reincluir")])], 1) : _c('span', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.exclui(row); },
	              cancel: _vm.doNothing,
	              message: 'Deseja <b>APAGAR</b> a parcela número ' + row.item.parcela + ' ?'
	            }),
	            expression: "{ok: retorno => exclui(row), cancel: doNothing, message: 'Deseja <b>APAGAR</b> a parcela número ' + row.item.parcela + ' ?'}"
	          }],
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir\n                    ")])], 1)]) : _vm._e()]
	      }
	    }], null, false, 190802861)
	  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('table', {
	    staticClass: "totais"
	  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado"
	  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Soma de todas as parcelas da coluna Fundação BB (Fase 1)</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.fbb)) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Soma de todas as parcelas da coluna Parceiro Estratégico (Fase 5)</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.parceiros)) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [(_vm.normalizarMoeda(_vm.totais.projeto.total - _vm.totais.distribuidos.total) >= 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    attrs: {
	      "title": '<h5>Soma de todas as parcelas da coluna Valor Adiantável</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.total)) + "\n              ")]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "atencao",
	    attrs: {
	      "title": '<h5>O valor total distribuído ultrapassou o total adiantável no cronograma do projeto</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.total)) + "\n              ")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario === 'FUNDACAO') ? _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "atencao",
	    style: ((_vm.totais.saldoDisponivel.fbb >= -0.01 ? 'background: steelblue !important;' : '')),
	    attrs: {
	      "title": '<h5>' + (_vm.totais.saldoDisponivel.fbb >= -0.01 ? 'Saldo disponível para novas parcelas' : 'Ultrapassou o limite de valores da Fundação para distribuir em parcelas') + '</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")((Math.abs(_vm.totais.saldoDisponivel.fbb) < 0.01 ? 0 : _vm.totais.saldoDisponivel.fbb))) + "\n              ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "atencao",
	    style: ((_vm.totais.saldoDisponivel.parceiros >= -0.01 ? 'background: steelblue !important;' : '')),
	    attrs: {
	      "title": '<h5>' + (_vm.totais.saldoDisponivel.parceiros >= -0.01 ? 'Saldo disponível para novas parcelas' : 'Ultrapassou o limite de valores de Parceiro Estratégico para distribuir em parcelas') + '</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")((Math.abs(_vm.totais.saldoDisponivel.parceiros) < 0.01 ? 0 : _vm.totais.saldoDisponivel.parceiros))) + "\n              ")])]), _vm._v(" "), _c('td', {
	    staticClass: "centralizado valor"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
	    }],
	    staticClass: "atencao",
	    style: ((_vm.totais.saldoDisponivel.total >= -0.01 ? 'background: steelblue !important;' : '')),
	    attrs: {
	      "title": '<h5>' + (_vm.totais.saldoDisponivel.total >= -0.01 ? 'Saldo disponível para novas parcelas' : 'Ultrapassou o limite de valores do projeto para distribuir em parcelas') + '</h5>'
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm._f("real")((Math.abs(_vm.totais.saldoDisponivel.total) < 0.01 ? 0 : _vm.totais.saldoDisponivel.total))) + "\n              ")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e()])])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm._.has(_vm.parcela, 'parcela')),
	      expression: "_.has(parcela, 'parcela')"
	    }],
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Parcela:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(_vm._s(_vm.parcela.parcela))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('origem')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2",
	    attrs: {
	      "for": "origem"
	    }
	  }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.parcela.origem),
	      expression: "parcela.origem"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.existeFaseFBB === 0 && _vm.existeFaseParc === 0,
	      "name": "origem",
	      "id": "origem"
	    },
	    on: {
	      "click": _vm.verificaFase,
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.parcela, "origem", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [(_vm.existeFaseFBB > 0) ? _c('option', {
	    domProps: {
	      "value": 1
	    }
	  }, [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (_vm.existeFaseParc > 0) ? _c('option', {
	    domProps: {
	      "value": 5
	    }
	  }, [_vm._v("Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), (_vm.existeFaseParc > 0 && _vm.existeFaseFBB > 0) ? _c('option', {
	    domProps: {
	      "value": 0
	    }
	  }, [_vm._v("Parcela Mista")]) : _vm._e()])]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.existeFaseFBB === 0 && _vm.existeFaseParc === 0),
	      expression: "existeFaseFBB === 0 && existeFaseParc === 0"
	    }],
	    staticClass: "col-md-8"
	  }, [_c('span', {
	    staticClass: "atencao"
	  }, [_vm._v("Precisa ter algum item marcado como Adiantavel no cronograma")])])]), _vm._v(" "), (('' + _vm.parcela.origem) !== '0') ? _c('div', {
	    key: "campo-valor-unico",
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('valor')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valor:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:' + Math.max(0, _vm.limiteParcela(_vm.parcela)).toFixed(2)),
	      expression: "'required|min_value:1|max_value:' + Math.max(0, limiteParcela(parcela)).toFixed(2)"
	    }],
	    key: "money-valor-unico",
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "valor",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.parcela.valor),
	      callback: function($$v) {
	        _vm.$set(_vm.parcela, "valor", $$v)
	      },
	      expression: "parcela.valor"
	    }
	  })], 1)]), _vm._v(" "), (_vm.errors.first('valor')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v("Valor máximo permitido para esta parcela: "), _c('strong', [_vm._v(_vm._s(_vm._f("real")(Math.max(0, _vm.limiteParcela(_vm.parcela)))))])])]) : [_c('div', {
	    key: "campo-valor-fbb",
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('valor_fbb')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valor Fundação BB:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:0|max_value:' + Math.max(0, _vm.limiteParcelaFundacao(_vm.parcela)).toFixed(2)),
	      expression: "'required|min_value:0|max_value:' + Math.max(0, limiteParcelaFundacao(parcela)).toFixed(2)"
	    }],
	    key: "money-valor-fbb",
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "valor_fbb",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.parcela.valor_fbb),
	      callback: function($$v) {
	        _vm.$set(_vm.parcela, "valor_fbb", $$v)
	      },
	      expression: "parcela.valor_fbb"
	    }
	  })], 1)]), _vm._v(" "), (_vm.errors.first('valor_fbb')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor_fbb')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v("Limite Fundação: "), _c('strong', [_vm._v(_vm._s(_vm._f("real")(Math.max(0, _vm.limiteParcelaFundacao(_vm.parcela)))))])])]), _vm._v(" "), _c('div', {
	    key: "campo-valor-parc",
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('valor_parc')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Valor Parceiro Estratégico:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', [_c('money', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:0|max_value:' + Math.max(0, _vm.limiteParcelaParceiro(_vm.parcela)).toFixed(2)),
	      expression: "'required|min_value:0|max_value:' + Math.max(0, limiteParcelaParceiro(parcela)).toFixed(2)"
	    }],
	    key: "money-valor-parc",
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "valor_parc",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.parcela.valor_parc),
	      callback: function($$v) {
	        _vm.$set(_vm.parcela, "valor_parc", $$v)
	      },
	      expression: "parcela.valor_parc"
	    }
	  })], 1)]), _vm._v(" "), (_vm.errors.first('valor_parc')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor_parc')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._v("Limite Parceiro: "), _c('strong', [_vm._v(_vm._s(_vm._f("real")(Math.max(0, _vm.limiteParcelaParceiro(_vm.parcela)))))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Total da parcela:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('strong', [_vm._v(_vm._s(_vm._f("real")(((+_vm.parcela.valor_fbb || 0) + (+_vm.parcela.valor_parc || 0)))))])])])], _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-md-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-confirm btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onAdd
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")])])])], 2)]) : _vm._e()]) : _c('div', {
	    staticClass: "box-header"
	  }, [_vm._v("\n  Não há itens adiantáveis nem parcelas cadastradas\n")])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('colgroup', [_c('col', {
	    staticClass: "col-parcela"
	  }), _vm._v(" "), _c('col', {
	    staticClass: "col-origem"
	  }), _vm._v(" "), _c('col', {
	    staticClass: "col-fase1"
	  }), _vm._v(" "), _c('col', {
	    staticClass: "col-fase5"
	  }), _vm._v(" "), _c('col', {
	    staticClass: "col-valor-adiantavel"
	  }), _vm._v(" "), _c('col', {
	    staticClass: "col-valor-requisitado"
	  }), _vm._v(" "), _c('col', {
	    staticClass: "col-percentual"
	  }), _vm._v(" "), _c('col', {
	    staticClass: "col-acoes"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "centralizado"
	  }, [_c('span', [_vm._v("Total do Projeto")])])
	}]}

/***/ }),
/* 2086 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body timeline_box",
	    staticStyle: {
	      "overflow": "auto"
	    },
	    attrs: {
	      "id": "time"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarTotalizador || _vm.mostrarOpcoes),
	      expression: "mostrarTotalizador || mostrarOpcoes"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarOpcoes),
	      expression: "mostrarOpcoes"
	    }],
	    staticClass: "quadro_opcoes"
	  }, [_c('span', {
	    staticClass: "titulo_grupo"
	  }, [_vm._v("Opções do timeline:")]), _vm._v(" "), _c('div', {
	    staticClass: "visao"
	  }, [_vm._v("Visão "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.posicao),
	      expression: "posicao"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.posicao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": 'absoluto'
	    }
	  }, [_vm._v("Distâncias representam dias")]), _c('option', {
	    domProps: {
	      "value": 'relativo'
	    }
	  }, [_vm._v("Cada marcador virá atras do outro")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.posicao === 'absoluto'),
	      expression: "posicao === 'absoluto'"
	    }],
	    staticClass: "zoom"
	  }, [_vm._v("Zoom "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.zoom),
	      expression: "zoom"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.zoom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm._.range([_vm.start = 1], 6.5, [_vm.step = .5])), function(z) {
	    return _c('option', [_vm._v(_vm._s(z))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.posicao === 'absoluto'),
	      expression: "posicao === 'absoluto'"
	    }],
	    staticClass: "mostrar_escala"
	  }, [_vm._v("Mostrar escala "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mostrarEscala),
	      expression: "mostrarEscala"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mostrarEscala = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": true
	    }
	  }, [_vm._v("Sim")]), _c('option', {
	    domProps: {
	      "value": false
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
	    staticClass: "linha_situacoes"
	  }, [_vm._v("Mostrar situação do projeto na linha "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mostrarSituacoesHistoricas),
	      expression: "mostrarSituacoesHistoricas"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mostrarSituacoesHistoricas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": true
	    }
	  }, [_vm._v("Sim")]), _c('option', {
	    domProps: {
	      "value": false
	    }
	  }, [_vm._v("Não")])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarTotalizador),
	      expression: "mostrarTotalizador"
	    }],
	    staticClass: "quadro_totalizador"
	  }, [_c('div', {
	    staticClass: "grupo"
	  }, [_c('div', {
	    staticClass: "cabecalho_grupo"
	  }, [_c('div', {
	    staticClass: "titulo_grupo"
	  }, [_vm._v("Ocorrências")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_acompanhamento, ['INFORMACAO', 'OCORRENCIA_IMPEDITIVA'])) ? _c('div', [_c('div', [_vm._v("Em Ser")]), _vm._v(" "), _c('div', [_vm._v("Baixadas")])]) : _c('div', [_c('div', [_vm._v("Não houve")])])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.totalizador.total_acompanhamento, function (o) { return _vm._.includes(['INFORMACAO', 'OCORRENCIA_IMPEDITIVA'], o.codigo); })), function(item) {
	    return _c('div', {
	      staticClass: "coluna_grupo"
	    }, [_c('div', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large',
	          placement: 'top'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	      }],
	      attrs: {
	        "title": '<h5>' + item.descricao + '</h5>'
	      }
	    }, [_c('i', {
	      class: 'marcador ' + _vm.icone(item.codigo),
	      on: {
	        "click": function($event) {
	          return _vm.filtrarTimeline(item.codigo)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      class: item.ocorrencia_em_ser > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.ocorrencia_em_ser))]), _vm._v(" "), _c('div', {
	      class: item.ocorrencia_baixada > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.ocorrencia_baixada))])])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "grupo"
	  }, [_c('div', {
	    staticClass: "cabecalho_grupo"
	  }, [_c('div', {
	    staticClass: "titulo_grupo"
	  }, [_vm._v("Demandas")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_acompanhamento, ['DEMANDA_FBB', 'DEMANDA_PARCEIRO'])) ? _c('div', [_c('div', [_vm._v("Em Condução")]), _vm._v(" "), _c('div', [_vm._v("Concluídas")])]) : _c('div', [_c('div', [_vm._v("Não houve")])])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.totalizador.total_acompanhamento, function (o) { return _vm._.includes(['DEMANDA_FBB', 'DEMANDA_PARCEIRO'], o.codigo); })), function(item) {
	    return _c('div', {
	      staticClass: "coluna_grupo"
	    }, [_c('div', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large',
	          placement: 'top'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	      }],
	      attrs: {
	        "title": '<h5>' + item.descricao + '</h5>'
	      }
	    }, [_c('i', {
	      class: 'marcador ' + _vm.icone(item.codigo),
	      on: {
	        "click": function($event) {
	          return _vm.filtrarTimeline(item.codigo)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      class: item.demanda_em_conducao > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.demanda_em_conducao))]), _vm._v(" "), _c('div', {
	      class: item.demanda_concluida > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.demanda_concluida))])])])
	  })], 2), _vm._v(" "), _c('div', {
	    ref: "totalizador_contatos",
	    staticClass: "grupo"
	  }, [_c('div', {
	    staticClass: "cabecalho_grupo"
	  }, [_c('div', {
	    staticClass: "titulo_grupo"
	  }, [_vm._v("Contatos")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_acompanhamento, ['CONTATO'])) ? _c('div', [_c('div', [_vm._v("Total realizado")])]) : _c('div', [_c('div', [_vm._v("Não houve")])])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.totalizador.total_acompanhamento, function (o) { return _vm._.includes(['CONTATO'], o.codigo); })), function(item) {
	    return _c('div', {
	      staticClass: "coluna_grupo"
	    }, [_c('div', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large',
	          placement: 'top'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	      }],
	      attrs: {
	        "title": '<h5>' + item.descricao + '</h5>'
	      }
	    }, [_c('i', {
	      class: 'marcador ' + _vm.icone(item.codigo),
	      on: {
	        "click": function($event) {
	          return _vm.filtrarTimeline(item.codigo)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      class: item.contatos > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.contatos))])])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "grupo"
	  }, [_c('div', {
	    staticClass: "cabecalho_grupo"
	  }, [_c('div', {
	    staticClass: "titulo_grupo"
	  }, [_vm._v("Alterações em projetos")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_alteracoes, null)) ? _c('div', [_c('div', [_vm._v("Eficiência")]), _vm._v(" "), _c('div', [_vm._v("Externalidade")]), _vm._v(" "), _c('div', [_vm._v("FBB")]), _vm._v(" "), _c('div', [_vm._v("Falha planejamento")])]) : _c('div', [_c('div', [_vm._v("Não houve")])])]), _vm._v(" "), _vm._l((_vm.totalizador.total_alteracoes), function(item) {
	    return _c('div', {
	      staticClass: "coluna_grupo"
	    }, [_c('div', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large',
	          placement: 'top'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	      }],
	      attrs: {
	        "title": '<h5>' + item.descricao + '</h5>'
	      }
	    }, [_c('i', {
	      class: 'marcador ' + _vm.icone(item.codigo),
	      on: {
	        "click": function($event) {
	          return _vm.filtrarTimeline(item.codigo)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      class: item.eficiencia > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.eficiencia))]), _vm._v(" "), _c('div', {
	      class: item.externalidade > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.externalidade))]), _vm._v(" "), _c('div', {
	      class: item.fbb > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.fbb))]), _vm._v(" "), _c('div', {
	      class: item.falha > 0 ? 'realce' : 'esmaecer'
	    }, [_vm._v(_vm._s(item.falha))])])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "grupo"
	  }, [_c('div', {
	    staticClass: "cabecalho_grupo"
	  }, [_c('div', {
	    staticClass: "titulo_grupo"
	  }, [_vm._v("Relatórios de Execução")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_relatorios_execucao, null)) ? _c('div', [_c('div', [_vm._v("Entregue")]), _vm._v(" "), _c('div', [_vm._v("Pendente")])]) : _c('div', [_c('div', [_vm._v("Não há")])])]), _vm._v(" "), _vm._l((_vm.totalizador.total_relatorios_execucao), function(item) {
	    return _c('div', {
	      staticClass: "coluna_grupo"
	    }, [_c('div', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large',
	          placement: 'top'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	      }],
	      attrs: {
	        "title": '<h5>' + item.descricao + '</h5>'
	      }
	    }, [_c('i', {
	      class: 'marcador ' + _vm.icone(item.codigo),
	      on: {
	        "click": function($event) {
	          return _vm.filtrarTimeline(item.codigo)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "realce"
	    }, [_vm._v(_vm._s(item.entregue))]), _vm._v(" "), _c('div', {
	      staticClass: "realce"
	    }, [_vm._v(_vm._s(item.pendente))])])])
	  })], 2)])])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "ng-isolate-scope novo_timeline"
	  }, [_c('div', {
	    ref: "timeline",
	    staticClass: "linha_tempo"
	  }, [_vm._l((_vm._.range([_vm.start = 0], _vm.qdtEventos + 30, [_vm.step = 30])), function(dias) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.mostrarEscala && _vm.posicao === 'absoluto'),
	        expression: "mostrarEscala && posicao === 'absoluto'"
	      }],
	      staticClass: "marcacao_escala",
	      style: ('margin-left: ' + ((dias * parseInt(_vm.zoom)) + 56) + 'px; width: ' + (_vm.zoom) + 'px;')
	    }, [_c('span', {
	      staticClass: "texto_vertical"
	    }, [_vm._v(_vm._s(_vm.diasData(_vm.projeto.inicio, dias)))])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "eventos",
	    style: ('width: ' + ((_vm.posicao === 'absoluto') ? ((_vm.ultimaReferencia + 75) * _vm.zoom) : (_vm.eventos.length * 160)) + 'px')
	  }, [_c('div', {
	    staticClass: "linha",
	    style: ('width: ' + ((_vm.posicao === 'absoluto') ? ((_vm.ultimaReferencia + 75) * _vm.zoom) : (_vm.eventos.length * 160) + 80) + 'px')
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarSituacoesHistoricas),
	      expression: "mostrarSituacoesHistoricas"
	    }],
	    staticClass: "situacao_projeto"
	  }, [_vm._l((_vm.eventos), function(evento, eventoIndex) {
	    return (_vm.posicao === 'absoluto') ? _c('div', {
	      class: _vm.situacaoProjeto(evento.data),
	      style: ('width: ' + (eventoIndex === _vm.eventos.length - 1 ? 75 : (eventoIndex > 0 ? (evento.referencia - _vm.eventos[eventoIndex - 1].referencia) * _vm.zoom : 0)) + 'px')
	    }, [_vm._v(" ")]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.eventos), function(evento, eventoIndex) {
	    return (_vm.posicao === 'relativo') ? _c('div', {
	      class: _vm.situacaoProjeto(evento.data),
	      staticStyle: {
	        "width": "160px"
	      }
	    }, [_vm._v(" ")]) : _vm._e()
	  })], 2)]), _vm._v(" "), _vm._l((_vm.eventos), function(evento) {
	    return _c('div', {
	      class: 'evento posicao_' + _vm.posicao,
	      attrs: {
	        "id": evento.tag + '_' + evento.id
	      }
	    }, [_c('div', {
	      ref: _vm._.startsWith(evento.tag, 'HOJE') ? 'HOJE' : evento.id,
	      refInFor: true,
	      style: (_vm.posicao === 'absoluto' ? 'margin-left: ' + (evento.referencia * _vm.zoom) + 'px' : '')
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large',
	          placement: 'top'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	      }],
	      class: 'marcador' + (evento.id === _vm.temp ? ' evento_sinalizado' : ''),
	      style: ('background:' + _vm.cor(evento.situacao) + '; cursor: ' + (evento.grupo === 'projeto' ? 'unset' : 'pointer')),
	      attrs: {
	        "title": '<h5>' + evento.descricao + '<br/>' + evento.info + '</h5>'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.filtrarGrids(evento.grupo, evento.id)
	        }
	      }
	    }, [_c('i', {
	      class: _vm.icone(evento.tag),
	      style: ('vertical-align: middle;text-align: center;')
	    }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
	      class: 'info_superior' + (_vm.data_vertical ? ' texto_vertical' : '')
	    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.posicao === 'absoluto' ? '' : evento.data, 'DD/MMM/YY')))]), _vm._v(" "), _c('div', {
	      staticClass: "info_inferior",
	      style: ('padding-top: ' + (_vm.data_vertical ? 70 : 20) + 'px')
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.posicao === 'absoluto' ? '' : evento.descricao)
	      }
	    })])])])
	  })], 2)], 2), _vm._v(" "), _c('div', {
	    staticClass: "botoes_timeline"
	  }, [_c('div', {
	    staticClass: "opcoes",
	    on: {
	      "click": function($event) {
	        _vm.mostrarOpcoes = !_vm.mostrarOpcoes, _vm.mostrarTotalizador = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" Opções\n          ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        interactive: true,
	        theme: 'light',
	        trigger: 'click',
	        position: 'top'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', trigger: 'click', position: 'top'}"
	    }],
	    staticClass: "legenda",
	    attrs: {
	      "title": '<table class=\'legenda_tabela\'>' +
	        '<tr><td style=\'background:' + _vm.cor('FEITO') + '\'>&nbsp;</td><td>Datas de aprovação, início de execução, alterações no projeto, data do término da execução, data do encerramento; Relatório de execuação aprovado</td></tr>' +
	        '<tr><td style=\'background:' + _vm.cor('CONCLUIDO') + '\'>&nbsp;</td><td>Registros de contato, demandas concluídas, informações, ocorrências baixadas</td></tr>' +
	        '<tr><td style=\'background:' + _vm.cor('EM_CONDUCAO') + '\'>&nbsp;</td><td>Demandas FBB ou Parceiro com status “Em condução”; ocorrências impeditivas em ser; relatório de execução não disponível</td></tr>' +
	        '<tr><td style=\'background:' + _vm.cor('NORMAL') + '\'>&nbsp;</td><td>Relatório de execução disponível</td></tr>' +
	        '<tr><td style=\'font-size: xx-large; color:' + _vm.cor('FEITO') + '\'>_</td><td>Situação do projeto regular</td></tr>' +
	        '<tr><td style=\'font-size: xx-large; color:' + _vm.cor('EM_CONDUCAO') + '\'>_</td><td>Situação não regular do projeto</td></tr>' +
	        '</table>' + '<br>* Obs: Ao selecionar um registro de acompanhamento ou de alteração de projeto, a borda do evento na linha do tempo, ficará <span class=evento_sinalizado>assim</span>'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  }), _vm._v(" Legenda\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "totalizador",
	    on: {
	      "click": function($event) {
	        _vm.mostrarTotalizador = !_vm.mostrarTotalizador, _vm.mostrarOpcoes = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-question"
	  }), _vm._v(" Totais\n          ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        placement: 'top',
	        theme: 'light'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top', theme: 'light'}"
	    }],
	    staticClass: "hoje",
	    attrs: {
	      "title": '<h5>' + (_vm.projeto.turno === 'HOJE_DIA' ? 'Bom dia!' : 'Boa noite!') + '<br/>Duração do projeto de ' + _vm.projeto.periodos + ' meses<br/>' + ((_vm.projeto.hoje_dias / (_vm.projeto.periodos * 30)) <= 1 ? 'Já passou <b>' + parseInt(_vm.projeto.hoje_dias / (_vm.projeto.periodos * 30) * 100) + '%</b> desde seu início' : '') + '</h5>'
	    },
	    on: {
	      "click": _vm.moverParaHoje
	    }
	  }, [_c('i', {
	    class: 'fa ' + (_vm.icone(_vm.projeto.turno))
	  }), _vm._v(" Hoje " + _vm._s(_vm.diasData(new Date(), 0)) + "\n          ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.eventos.length !== _vm.eventosBackup.length),
	      expression: "eventos.length !== eventosBackup.length"
	    }],
	    staticClass: "reload",
	    on: {
	      "click": _vm.voltarBackupEventos
	    }
	  }, [_c('i', {
	    class: 'fa fa-refresh'
	  }), _vm._v(" Recarregar\n          ")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "ts-content-container"
	  }, [(!_vm.cadastrando && !_vm.permiteEditar && !_vm.ehParceiroEstrategico) ? _c('div', {
	    staticClass: "ts-button-alterar-container"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.permiteEditar = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                Alterar")])]) : _vm._e(), _vm._v(" "), _c('label', {
	    staticClass: "ts-label"
	  }, [_vm._m(0), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiTecnologiaSocial),
	      expression: "possuiTecnologiaSocial"
	    }],
	    staticClass: "form-control ts-label-dropdown",
	    attrs: {
	      "disabled": !_vm.permiteEditar
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiTecnologiaSocial = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.confirmarDialog()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": "",
	      "disabled": ""
	    }
	  }, [_vm._v(" Selecione ")]), _vm._v(" "), _c('option', {
	    domProps: {
	      "value": true
	    }
	  }, [_vm._v(" Sim ")]), _vm._v(" "), _c('option', {
	    domProps: {
	      "value": false
	    }
	  }, [_vm._v(" Não ")])])]), _vm._v(" "), (!_vm.cadastrando && _vm.possuiTecnologiaSocial && _vm.permiteEditar) ? _c('div', {
	    staticClass: "ts-button-container"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.ativarCadastro()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              Vincular Tecnologia Social")])]) : _vm._e(), _vm._v(" "), (!_vm.cadastrando && _vm.possuiTecnologiaSocial) ? _c('div', {
	    staticClass: "ts-table-container"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "hover": _vm.table.hover,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          directives: [{
	            name: "confirm",
	            rawName: "v-confirm",
	            value: ({
	              ok: function (retorno) { return _vm.excluiTecnologia(row.item); },
	              cancel: _vm.doNothing,
	              message: 'Confirma Exclusão?'
	            }),
	            expression: "{ok: retorno => excluiTecnologia(row.item), cancel: doNothing,\n                            message: 'Confirma Exclusão?'}"
	          }],
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": !_vm.permiteEditar,
	            "data-cy": "exclui-publico-alvo"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])], 1)]
	      }
	    }, {
	      key: "url",
	      fn: function(row) {
	        return [_c('a', {
	          attrs: {
	            "href": 'https://transforma.fbb.org.br/tecnologia-social/' + row.value,
	            "target": "_blank"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-external-link"
	        })])]
	      }
	    }], null, false, 2781655437)
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cadastrando && _vm.possuiTecnologiaSocial && _vm.permiteEditar) ? _c('div', {
	    staticClass: "ts-cadastro-container"
	  }, [_c('div', {
	    staticClass: "ts-search-container"
	  }, [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('div', {
	    staticClass: "ts-input-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.termoPesquisa),
	      expression: "termoPesquisa"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "name": "termoPesquisa",
	      "type": "text",
	      "minlength": "1",
	      "ng-maxlength": "255",
	      "placeholder": "Pesquise a Tecnologia Social aqui."
	    },
	    domProps: {
	      "value": (_vm.termoPesquisa)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.termoPesquisa = $event.target.value
	      }, _vm.debounceFiltro]
	    }
	  })]), _vm._v(" "), _c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": _vm.tsTable.bordered,
	      "items": _vm.tsTable.items,
	      "hover": _vm.tsTable.hover,
	      "fields": _vm.tsTable.fields,
	      "filter": _vm.tsTable.filter,
	      "current-page": _vm.tsTable.currentPage,
	      "per-page": _vm.tsTable.perPage,
	      "sort-by": _vm.tsTable.sortBy,
	      "sort-desc": _vm.tsTable.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tsTable, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tsTable, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tsTable, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tsTable, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('b-button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false,
	            "data-cy": "exclui-publico-alvo"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.selecionaTecnologia(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-check-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Selecionar")])], 1)]
	      }
	    }, {
	      key: "url",
	      fn: function(row) {
	        return [_c('a', {
	          attrs: {
	            "href": 'https://transforma.fbb.org.br/tecnologia-social/' + row.value,
	            "target": "_blank"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-external-link"
	        })])]
	      }
	    }], null, false, 693422140)
	  }), _vm._v(" "), (_vm.tsTable.items.length > _vm.tsTable.perPage) ? _c('b-row', {
	    staticClass: "ts-pagination-container"
	  }, [_c('b-pagination', {
	    attrs: {
	      "total-rows": _vm.tsTable.totalRows,
	      "per-page": _vm.tsTable.perPage
	    },
	    model: {
	      value: (_vm.tsTable.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tsTable, "currentPage", $$v)
	      },
	      expression: "tsTable.currentPage"
	    }
	  }), _vm._v(" "), (_vm.tsTable.currentPage === 10) ? _c('div', [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": _vm.carregarMais
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                    Carregar Mais")])]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "ts-button-cadastro-container"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": _vm.cancelar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                Cancelar")])])]) : _vm._e(), _vm._v(" "), (!_vm.cadastrando && _vm.possuiTecnologiaSocial && _vm.permiteEditar) ? _c('div', {
	    staticClass: "ts-button-cadastro-container"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": _vm.salvarTecnologia
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                Salvar")]), _vm._v(" "), (_vm.telaProjeto) ? _c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "color": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.permiteEditar = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                Cancelar")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ts-label-text"
	  }, [_vm._v("Existe "), _c('strong', [_vm._v("Tecnologia Social")]), _vm._v(" vinculada ao projeto? "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("*")])])
	}]}

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Solicitações'
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("Gerenciador de Arquivos de Documentos Fiscais")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), (_vm.loading.show) ? _c('div', {
	    staticClass: "overlay-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), (_vm.mostrarEmails) ? _c('div', {
	    staticClass: "column all-centered prest-emails-container",
	    on: {
	      "click": function($event) {
	        return _vm.toggleEmails(false)
	      }
	    }
	  }, [_c('prestacao-simplificada-emails', {
	    attrs: {
	      "toggleEmails": _vm.toggleEmails
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "prest-main-container"
	  }, [_c('div', {
	    staticClass: "prest-header row-flex centered-between"
	  }, [_vm._m(0), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        placement: 'top'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	    }],
	    staticClass: "row-flex centered-start prest-header-emails",
	    attrs: {
	      "title": "<h5>Verifica log de e-mails enviados</h5>"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleEmails(true)
	      }
	    }
	  }, [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Status de Prestação de Contas "), (this.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_vm._v(" do Processo Simplificado")]) : _vm._e()])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box-body row-flex centered-start prest-row-input"
	  }, [_c('div', {
	    staticClass: "prest-input-group"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        placement: 'top'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
	    }],
	    staticClass: "input-group",
	    attrs: {
	      "title": '<h5>Pesquise por nome, partes do nome, proposta ou número do projeto.<h5>'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa...",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSearch($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onSearch()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" ")])])])])]) : _vm._e(), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "bordered": true,
	      "items": _vm.table.items,
	      "striped": "",
	      "hover": "",
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Faça uma pesquisa acima",
	      "table-layout:": "",
	      "fixed": ""
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "data_atualizacao",
	      fn: function(row) {
	        return [(row.item.data_atualizacao) ? _c('div', [_vm._v("\n                  " + _vm._s(_vm._f("moment")(row.item.data_atualizacao, 'DD/MM/YYYY HH:mm:ss')) + "\n                ")]) : _c('div', [_vm._v("\n                  Não iniciado.\n                ")])]
	      }
	    }, {
	      key: "processos",
	      fn: function(row) {
	        return [(row.value.length > 0) ? _c('div', _vm._l((row.value), function(item, index) {
	          return _c('div', {
	            key: index,
	            staticClass: "column all-centered"
	          }, [_c('div', {
	            staticClass: "prest-item-processo"
	          }, [_c('b', [_vm._v("#" + _vm._s(item.fk_processo))]), _vm._v(" " + _vm._s(item.situacao.replace('_', ' ')) + "\n                    ")])])
	        }), 0) : _c('div', [_vm._v("\n                  Nenhum Processo encontrado.\n                ")])]
	      }
	    }, {
	      key: "valor_liberado",
	      fn: function(row) {
	        return [(row.item.valor_liberado) ? _c('div', [_vm._v("\n                  " + _vm._s(_vm._f("real")(row.value)) + "\n                ")]) : _c('div', [_vm._v("\n                  Nenhum Adiantamento encontrado.\n                ")])]
	      }
	    }, {
	      key: "total_gravado",
	      fn: function(row) {
	        return [(row.item.total_gravado) ? _c('div', [_vm._v("\n                  " + _vm._s(_vm._f("real")(row.value)) + "\n                  ")]) : _c('div', [_vm._v("\n                  -\n                ")])]
	      }
	    }, {
	      key: "ds_nome",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "column all-start"
	        }, [_c('div', [_c('router-link', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'right',
	              animation: 'perspective',
	              distance: '1',
	              size: 'small',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
	          }],
	          attrs: {
	            "title": '<h5>Ir para a página do Projeto</h5>',
	            "to": {
	              name: 'projeto',
	              params: {
	                numero: row.item.ds_codigo_projeto_erp
	              }
	            },
	            "target": "_blank"
	          }
	        }, [_vm._v(" "), _c('i', {
	          staticClass: "fa fa-external-link"
	        })]), _vm._v(" ["), _c('b', [_vm._v(_vm._s(row.item.id))]), _vm._v("] " + _vm._s(row.value) + "\n                  ")], 1), _vm._v(" "), _c('div', {
	          staticClass: "column all-end prest-item-entidade"
	        }, [_c('b', [_c('router-link', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              placement: 'right',
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }],
	          attrs: {
	            "title": '<h5>Ir para o Cadastro da entidade</h5>',
	            "to": {
	              name: 'cadastro-entidade-visualiza',
	              params: {
	                id: row.item.id_entidade
	              }
	            },
	            "target": "_blank"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user"
	        })]), _vm._v(" " + _vm._s(_vm._f("cnpj")(row.item.ds_cnpj_entidade)))], 1), _vm._v(" "), _c('i', [_vm._v(" " + _vm._s(row.item.ds_nome_entidade))])])])]
	      }
	    }, {
	      key: "status",
	      fn: function(row) {
	        return [(row.item.data_atualizacao && !row.item.processos) ? _c('div', {
	          staticClass: "prest-status-iniciado"
	        }, [_c('b', [_vm._v("Cadastro Iniciado")])]) : _vm._e(), _vm._v(" "), (row.item.processos && row.item.data_atualizacao) ? _c('div', {
	          staticClass: "prest-status-tarefa"
	        }, [_vm._v("\n                  Tarefa de Prestação de Contas\n                ")]) : _vm._e(), _vm._v(" "), (!row.item.data_atualizacao) ? _c('div', {
	          staticClass: "prest-status-pendente"
	        }, [_c('b', [_vm._v("Pendente Cadastro")])]) : _vm._e()]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [(_vm.usuarioLogado.userType === 'ENTIDADE' && row.item.valor_liberado) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.editarGED(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.editarGED(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && !row.item.valor_liberado) ? _c('div', [_vm._v("\n                      Sem parcela de Adiantamento.\n                    ")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('b-row', {
	    staticClass: "row-flex all-end"
	  }, [_vm._v("\n                " + _vm._s(_vm.table.totalRows) + " registro(s) encontrado(s).\n              ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "8",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1)], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "prest-box-title row-flex centered-start"
	  }, [_vm._v("Prestação de Contas "), _c('i', {
	    staticClass: "fa fa-file",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v("E-mails "), _c('i', {
	    staticClass: "fa fa-envelope",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ }),
/* 2089 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.favs.length > 1) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('dl', [_c('dd', [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('favs')
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preAnalise.proposal.fav),
	      expression: "preAnalise.proposal.fav"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "favs",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.preAnalise.proposal, "fav", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.montaQuestoes]
	    }
	  }, _vm._l((_vm.favs), function(fav) {
	    return _c('option', {
	      domProps: {
	        "value": fav
	      }
	    }, [_vm._v(_vm._s(fav.name))])
	  }), 0), _vm._v(" "), (_vm.errors.first('favs')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('favs')))]) : _vm._e()])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12",
	    class: {
	      'has-error-div': _vm.errors.first('respostaFAV')
	    }
	  }, [_c('table', {
	    staticClass: "table b-table table-hover table-bordered b-table-stacked-md",
	    attrs: {
	      "role": "table"
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', {
	    attrs: {
	      "role": "rowgroup"
	    }
	  }, [_vm._l((this.preAnalise.favAnswers), function(questao, index) {
	    return _c('tr', {
	      attrs: {
	        "aria-rowindex": "1",
	        "role": "row"
	      }
	    }, [_c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "aria-colindex": "1",
	        "data-label": "Número",
	        "role": "cell"
	      }
	    }, [_c('div', [_vm._v(_vm._s(questao.favQuestion.questionNumber))])]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "aria-colindex": "2",
	        "data-label": "Pergunta",
	        "role": "cell"
	      }
	    }, [_c('div', [_vm._v(_vm._s(questao.favQuestion.question))])]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "aria-colindex": "3",
	        "data-label": "Sim",
	        "role": "cell"
	      }
	    }, [_c('div', [_c('label', {
	      staticClass: "new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "25px"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (questao.conformity),
	        expression: "questao.conformity"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "respostaFAV",
	        "value": "YES"
	      },
	      domProps: {
	        "checked": _vm._q(questao.conformity, "YES")
	      },
	      on: {
	        "change": function($event) {
	          return _vm.$set(questao, "conformity", "YES")
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "aria-colindex": "4",
	        "data-label": "Não",
	        "role": "cell"
	      }
	    }, [_c('div', [_c('label', {
	      staticClass: "new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "25px"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (questao.conformity),
	        expression: "questao.conformity"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "respostaFAV",
	        "value": "NO"
	      },
	      domProps: {
	        "checked": _vm._q(questao.conformity, "NO")
	      },
	      on: {
	        "change": function($event) {
	          return _vm.$set(questao, "conformity", "NO")
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])]), _vm._v(" "), _c('td', {
	      staticClass: "text-center",
	      attrs: {
	        "aria-colindex": "5",
	        "data-label": "N/A",
	        "role": "cell"
	      }
	    }, [_c('div', [_c('label', {
	      staticClass: "new-control new-control-radio",
	      staticStyle: {
	        "padding-top": "25px"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (questao.conformity),
	        expression: "questao.conformity"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "respostaFAV",
	        "value": "NA"
	      },
	      domProps: {
	        "checked": _vm._q(questao.conformity, "NA")
	      },
	      on: {
	        "change": function($event) {
	          return _vm.$set(questao, "conformity", "NA")
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "new-control-indicator"
	    })])])])])
	  }), _vm._v(" "), (this.preAnalise.favAnswers.length === 0) ? _c('tr', [_c('td', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(" Nenhuma pergunta atribuída!")])]) : _vm._e()], 2)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Fichas de Auto Verificação - Seleção")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Ficha de Auto Verificação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "15%"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "1",
	      "aria-label": "Click to sort Descending"
	    }
	  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "50%"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "2",
	      "aria-label": "Click to sort Descending"
	    }
	  }, [_vm._v("Pergunta")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "6%"
	    },
	    attrs: {
	      "aria-colindex": "3"
	    }
	  }, [_vm._v("Sim")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "5%"
	    },
	    attrs: {
	      "aria-colindex": "4"
	    }
	  }, [_vm._v("Não")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "5%"
	    },
	    attrs: {
	      "aria-colindex": "5"
	    }
	  }, [_vm._v("N/A")])])])
	}]}

/***/ }),
/* 2090 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Validação Inicial")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Validação Inicial',
	        href: '#'
	      }, {
	        text: 'Primeira Aprovação',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "validaProp"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroPre"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'primeira'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'primeira'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Primeira Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPorFase))])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.faseAtual === 'segunda'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'segunda'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-peace-o"
	  }), _vm._v("Segunda Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadeSegundaFase))])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.faseAtual === 'finalizada'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'finalizada'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-flag-checkered"
	  }), _vm._v("Finalizadas "), _c('span', {
	    staticClass: "badge"
	  }, [_vm._v(_vm._s(_vm.quantidadesFinalizadas))])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.descricaoFase))]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative"
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative",
	      "margin-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('div', {
	    staticClass: "mailbox-controls"
	  }, [(_vm.faseAtual !== 'finalizada') ? _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.favorite = !_vm.filtro.favorite
	      }
	    },
	    model: {
	      value: (_vm.filtro.favorite),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "favorite", $$v)
	      },
	      expression: "filtro.favorite"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
	      }
	    },
	    model: {
	      value: (_vm.filtro.userId),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "userId", $$v)
	      },
	      expression: "filtro.userId"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSearch
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  })]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([(_vm.faseAtual !== 'finalizada') ? {
	      key: "favorite",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onFavorite(row.item)
	            }
	          }
	        })]
	      }
	    } : null, {
	      key: "entidade",
	      fn: function(row) {
	        return [_c('div', {}, [(row.item.simplificado > '0') ? _c('div', [_c('b', [_vm._v(_vm._s(row.item.simplificado))]), _c('br'), _vm._v("\n                        " + _vm._s(row.item.propostaNome) + "\n                      ")]) : _vm._e(), _vm._v("\n                      " + _vm._s(row.item.companyName) + "\n                    ")])]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "userName",
	      fn: function(row) {
	        return [(row.value) ? _c('span', {
	          staticStyle: {
	            "font-weight": "bold"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('div', {
	          staticClass: "btn-group"
	        }, [_c('button', {
	          staticClass: "btn btn-default",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ellipsis-h"
	        })]), _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu dropdown-menu-right",
	          attrs: {
	            "role": "menu",
	            "aria-labelledby": "new-register"
	          }
	        }, [_c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'detalhe-validacao-entidades',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ver mais")])], 1), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssignAndDo(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onUnassign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user-times",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', {
	          staticClass: "divider",
	          attrs: {
	            "role": "separator"
	          }
	        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: _vm.rota1,
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-play-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
	      }
	    }], null, true)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2091 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Sliders\n      "), _c('small', [_vm._v("range sliders")])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Sliders")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Ion Slider")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row margin"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    attrs: {
	      "id": "range_1",
	      "type": "text",
	      "name": "range_1",
	      "value": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    attrs: {
	      "id": "range_2",
	      "type": "text",
	      "name": "range_2",
	      "value": "1000;100000",
	      "data-type": "double",
	      "data-step": "500",
	      "data-postfix": " &euro;",
	      "data-from": "30000",
	      "data-to": "90000",
	      "data-hasgrid": "true"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    attrs: {
	      "id": "range_5",
	      "type": "text",
	      "name": "range_5",
	      "value": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    attrs: {
	      "id": "range_6",
	      "type": "text",
	      "name": "range_6",
	      "value": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('input', {
	    attrs: {
	      "id": "range_4",
	      "type": "text",
	      "name": "range_4",
	      "value": "10000;100000"
	    }
	  })])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Bootstrap Slider")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row margin"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "horizontal",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "red"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"red\"")]), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "horizontal",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "blue"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"blue\"")]), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "horizontal",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "green"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"green\"")]), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "horizontal",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "yellow"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"yellow\"")]), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "horizontal",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "aqua"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"aqua\"")]), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "horizontal",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "purple"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._v("data-slider-id=\"purple\"")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 text-center"
	  }, [_c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "vertical",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "red"
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "vertical",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "blue"
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "vertical",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "green"
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "vertical",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "yellow"
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "vertical",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "aqua"
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "slider form-control",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "data-slider-min": "-200",
	      "data-slider-max": "200",
	      "data-slider-step": "5",
	      "data-slider-value": "[-100,100]",
	      "data-slider-orientation": "vertical",
	      "data-slider-selection": "before",
	      "data-slider-tooltip": "show",
	      "data-slider-id": "purple"
	    }
	  })])])])])])])])])
	}]}

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.showGrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tipo de documento')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "tipo de documento"
	    }
	  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.documento.tipo_documento),
	      expression: "documento.tipo_documento"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
	    attrs: {
	      "name": "tipo de documento",
	      "id": "tipo de documento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.documentos), function(documento) {
	    return _c('option', {
	      domProps: {
	        "value": documento
	      }
	    }, [_vm._v(_vm._s(documento.ds_tipo))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('arquivo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "file"
	    }
	  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: true,
	        size: _vm.tamanhoPermitido,
	        mimes: _vm.tiposPermitidos
	      }),
	      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
	    }],
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": "arquivo",
	      "id": "file"
	    },
	    on: {
	      "change": _vm.handleFileUpload
	    }
	  })]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    attrs: {
	      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-3 col-lg-2",
	    attrs: {
	      "for": "expirationDate"
	    }
	  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    attrs: {
	      "ng-if": "!$ctrl.flagNovoDocumento",
	      "approval": "$ctrl.approval",
	      "state": "$ctrl.approvalStateForm"
	    }
	  }, [_c('datepicker', {
	    attrs: {
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy"
	    },
	    model: {
	      value: (_vm.documento.expirationDate),
	      callback: function($$v) {
	        _vm.$set(_vm.documento, "expirationDate", $$v)
	      },
	      expression: "documento.expirationDate"
	    }
	  })], 1)])])]), _vm._v(" "), (!_vm.foiAssinada) ? _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-add"
	    },
	    on: {
	      "click": _vm.adicionaDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "cmpt-upload-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n            ")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "myField",
	      "name": "myField",
	      "value": ""
	    }
	  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "disabled": _vm.foiAssinada,
	      "if": "permite_edicao",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.novoDocumento
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Novo documento")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), _c('td', [_vm._v("Vigência")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
	    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      },
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(pendente.type))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [(!_vm.disable) ? _c('button', {
	      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
	      staticStyle: {
	        "max-width": "135px",
	        "text-align": "center"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onAddFile(pendente)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-plus-circle",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Adicionar arquivo")]) : _vm._e()])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
	    return _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "ng-binding",
	      attrs: {
	        "href": "javascript:void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onDownload(documento)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_data_validade, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(!_vm.disable) ? _c('button', {
	      directives: [{
	        name: "confirm",
	        rawName: "v-confirm",
	        value: ({
	          ok: function (retorno) { return _vm.deletaDocumento(indexDocumento, documento); },
	          cancel: _vm.doNothing,
	          message: ("Deseja <b>excluir</b> o documento " + (documento.ds_nome_arquivo) + "? Essa ação é irreversível.")
	        }),
	        expression: "{ok: retorno => deletaDocumento(indexDocumento, documento), cancel: doNothing,\n                           message: `Deseja <b>excluir</b> o documento ${documento.ds_nome_arquivo}? Essa ação é irreversível.`}"
	      }],
	      staticClass: "btn btn-danger btn-sm btn-flat",
	      attrs: {
	        "disabled": _vm.foiAssinada,
	        "type": "button"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" Excluir")]) : _vm._e()]) : _vm._e()])
	  })], 2)])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "text-danger"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pendente")])])
	}]}

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "contentWrapper",
	    staticClass: "content-wrapper",
	    style: ('min-height: ' + _vm.alturaContentWrapper + 'px'),
	    attrs: {
	      "id": "validacoes"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - ' + _vm.enumeradores[_vm.validacao]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('p', {
	    staticClass: "visible-xs"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('h1', {
	    staticClass: "col-lg-5 col-md-6 col-sm-12 text-left"
	  }, [_vm._v("\n        " + _vm._s(_vm.enumeradores[_vm.validacao]) + "\n\n        "), (_vm.mostrarProcesso.length === 0) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostraCarregando),
	      expression: "!mostraCarregando"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-caret-down opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Abre as seções principais</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrarProcesso = _vm._.keys(_vm.listaValidacoes);
	        _vm.$refs['contentWrapper'].scrollIntoView()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.mostrarProcesso.length > 0 || _vm.mostrarAtividade.length > 0) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.mostraCarregando),
	      expression: "!mostraCarregando"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "fa fa-caret-up opcao",
	    attrs: {
	      "aria-hidden": "true",
	      "title": '<h5>Fecha todas as seções</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrarProcesso = [];
	        _vm.mostrarAtividade = [];
	        _vm.$refs['contentWrapper'].scrollIntoView()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.enumeradores[_vm.validacao] === 'Execução financeira') ? _c('img', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        delay: [500, 0],
	        placement: 'right'
	      }),
	      expression: "{\n              inertia:true,\n              arrow:true,\n              animation:'perspective',\n              distance:'1',\n              size:'large',\n              arrow:true,\n              delay: [500, 0],\n              placement: 'right'}"
	    }],
	    staticClass: "semaforo",
	    attrs: {
	      "src": __webpack_require__(507),
	      "title": '<h5 style=\'text-align:left\'><b>Pagamento, Ressarcimento e Adiantamento*</b></br><span style=\'text-align: left\'>' +
	        '<p></p>' +
	        '<p><i class=\'fa fa-square\' style=\'color:#218D1E\'></i> até 3 dias úteis</p>' +
	        '<p><i class=\'fa fa-square\' style=\'color:#DBC112\'></i> de 4 a 5 dias úteis</p>' +
	        '<p><i class=\'fa fa-square\' style=\'color:#A3100F\'></i> a partir do 6º dia útil</p>' +
	        '<hr></span></h5>' +
	        '<h5 style=\'text-align:left\'><b>Prestação de Contas e Devolução de Adiantamento*</b></br><span style=\'text-align:left\'' +
	        '<p></p>' +
	        '<p><i class=\'fa fa-square\' style=\'color:#218D1E\'></i> até 6 dias úteis</p>' +
	        '<p><i class=\'fa fa-square\' style=\'color:#DBC112\'></i> de 7 a 10 dias úteis</p>' +
	        '<p><i class=\'fa fa-square\' style=\'color:#A3100F\'></i> a partir do 11º dia útil</p>' +
	        '<hr></span></h5>' +
	        '<h5><p><b>*por limitações técnicas, os feriados são computados como dias úteis</b></p></h5>'
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-7 col-md-6 col-sm-5"
	  }, [_c('div', {
	    staticClass: "col-md-8 pull-right"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pesquisa),
	      expression: "pesquisa"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    ref: "caixaPesquisa",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa...",
	      "title": '<h5>Digite uma palavra ou número e pressione Enter</h5>'
	    },
	    domProps: {
	      "value": (_vm.pesquisa)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filtrar()
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pesquisa = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.pesquisa.length > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "input-group-btn",
	    attrs: {
	      "title": '<h5>Limpar essa pesquisa</h5>'
	    }
	  }, [_c('button', {
	    staticClass: "btn",
	    staticStyle: {
	      "background": "white",
	      "border-color": "#d2d6de",
	      "border-width": "1px 0px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pesquisa = '';
	        _vm.filtrar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  })])]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "disabled": !_vm.pesquisa,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filtrar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-4 col-md-3 col-sm-7 text-lg-left"
	  }, [_c('div', {
	    staticClass: "truncar",
	    staticStyle: {
	      "padding-top": "5px",
	      "font-size": "18px",
	      "color": "darkgray"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "margin-left": "5px",
	      "color": "firebrick",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.totalTarefas(_vm.listaValidacoes)))]), _vm._v(" tarefa(s)\n          "), (_vm.tarefasSelecionadas.length > 0) ? _c('span', [_vm._v(" com "), _c('span', {
	    staticStyle: {
	      "color": "var(--cor-azul)"
	    }
	  }, [_vm._v(_vm._s(_vm.tarefasSelecionadas.length))]), _vm._v(" selecionada" + _vm._s(_vm.tarefasSelecionadas.length > 1 ? 's' : ''))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-8 col-md-9 col-sm-12 text-right",
	    staticStyle: {
	      "line-height": "2em"
	    }
	  }, [_c('span', {
	    staticClass: "indicadores-cb-inline"
	  }, [_c('div', {
	    staticClass: "juntos",
	    attrs: {
	      "disabled": _vm.mostraProcessando
	    }
	  }, [_c('i', {
	    class: (_vm.selecionarTodasTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.selecionarTodasTarefas = (_vm.selecionarTodasTarefas === 'nao') ? 'sim' : 'nao'
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.selecionarTodasTarefas === 'nao' ? '' : 'selecionado'
	  }, [_vm._v("Selecionar tudo")])]), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [_c('i', {
	    class: (_vm.meusFavoritados === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.meusFavoritados = (_vm.meusFavoritados === 'nao') ? 'sim' : 'nao'
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.meusFavoritados === 'nao' ? '' : 'selecionado'
	  }, [_vm._v("Favoritos")])]), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [_c('i', {
	    class: (_vm.minhasTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.minhasTarefas = (_vm.minhasTarefas === 'nao') ? 'sim' : 'nao'
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.minhasTarefas === 'nao' ? '' : 'selecionado'
	  }, [_vm._v("Minhas Tarefas")])]), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [_c('i', {
	    class: (_vm.somenteComTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.somenteComTarefas = (_vm.somenteComTarefas === 'nao') ? 'sim' : 'nao'
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.somenteComTarefas === 'nao' ? '' : 'selecionado'
	  }, [_vm._v("Somente com Tarefas")])]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [(_vm.validacao === 'RELATORIO_DE_EXECUCAO') ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.minhaCarteira),
	      expression: "minhaCarteira"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "auto",
	      "float": "left",
	      "margin-right": "10px"
	    },
	    attrs: {
	      "title": '<h5>Filtrar pela carteira do projeto</h5>'
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.minhaCarteira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.filtrar]
	    }
	  }, [_c('option', {
	    staticStyle: {
	      "color": "var(--cor-destaque)"
	    },
	    attrs: {
	      "value": "",
	      "selected": ""
	    }
	  }, [_vm._v(_vm._s(_vm.minhaCarteira === '' ? 'Carteiras' : 'Limpar Filtro'))]), _vm._v(" "), _vm._l((_vm._.sortBy(_vm._.uniq(_vm._.compact(_vm._.map(_vm._.flatten(_vm._.valuesIn(_vm.listaValidacoes.RELATORIO_DE_EXECUCAO)), 'extra.carteira'))))), function(carteira) {
	    return _c('option', {
	      domProps: {
	        "value": carteira
	      }
	    }, [_vm._v(_vm._s(carteira))])
	  })], 2) : _vm._e(), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ordenacao.por),
	      expression: "ordenacao.por"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "auto",
	      "float": "left"
	    },
	    attrs: {
	      "title": '<h5>Selecione por qual critério deseja ordenar</h5>'
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.ordenacao, "por", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "id_processo"
	    }
	  }, [_vm._v("ID")]), _vm._v(" "), (!_vm._.includes(['ENTIDADES', 'PARCEIRO_ESTRATEGICO'], _vm.validacao)) ? _c('option', {
	    attrs: {
	      "value": "projeto"
	    }
	  }, [_vm._v("Projeto")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('option', {
	    attrs: {
	      "value": "extra.situacao_projeto"
	    }
	  }, [_vm._v("Situação do Projeto")]) : _vm._e(), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "entidade"
	    }
	  }, [_vm._v("Entidade")]), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('option', {
	    attrs: {
	      "value": "valor"
	    }
	  }, [_vm._v("Valor")]) : _vm._e(), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "data_solicitacao"
	    }
	  }, [_vm._v("Data da Solicitação")]), _vm._v(" "), (_vm._.includes(['OCORRENCIAS'], _vm.validacao)) ? _c('option', {
	    attrs: {
	      "value": "codigo_ocorrencia"
	    }
	  }, [_vm._v("Código da Ocorrência")]) : _vm._e()]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
	    }],
	    staticClass: "btn btn-default btn-flat",
	    staticStyle: {
	      "float": "left"
	    },
	    attrs: {
	      "type": "button",
	      "title": '<h5>Clique para inverter a ordenação por ' + _vm._.replace(_vm.ordenacao.por, '_', ' ') + '</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.ordenacao.ordem = _vm.ordenacao.ordem === 'asc' ? 'desc' : 'asc'
	      }
	    }
	  }, [_c('i', {
	    class: 'fa fa-sort-alpha-' + _vm.ordenacao.ordem,
	    staticStyle: {
	      "font-size": "14px"
	    }
	  })])])])])]), _vm._v(" "), (_vm.tarefasSelecionadas.length > 0) ? _c('div', {
	    staticClass: "col-xs-12 text-left"
	  }, [(!_vm.mostraProcessando) ? _c('span', [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5>Favoritar todos os selecionados</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.favoritarLote(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  }), _vm._v(" Favoritar\n          ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Desfavoritar todos os selecionados</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.favoritarLote(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star-o"
	  }), _vm._v(" Desfavoritar\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5>Atribuir a mim todos os selecionado</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.atribuirLote(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" Assumir\n          ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss",
	      "title": '<h5>Desatribuir todos os selecionado</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.atribuirLote(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user-times"
	  }), _vm._v(" Desatribuir\n          ")]), _vm._v(" "), (this.usuarioLogado.perfis.some(function (perfil) { return perfil.ds_nome === 'Gerentes'; })) ? _c('span', [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true }"
	    }],
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "title": '<h5>Atribuir as tarefas selecionadas a funcionário</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.showModal = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user-plus"
	  }), _vm._v(" Atribuir\n            ")]), _vm._v(" "), (_vm.showModal) ? _c('div', {
	    staticClass: "modal-overlay"
	  }, [_c('div', {
	    staticClass: "modal-container",
	    staticStyle: {
	      "display": "flex",
	      "flex-direction": "column",
	      "align-items": "center"
	    }
	  }, [_c('button', {
	    staticClass: "btn-close",
	    on: {
	      "click": _vm.cancelarAtribuicao
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.funcionarioBusca),
	      expression: "funcionarioBusca"
	    }],
	    staticStyle: {
	      "display": "inline-block",
	      "margin-bottom": "10px",
	      "margin-right": "10px"
	    },
	    attrs: {
	      "type": "text",
	      "id": "searchFuncionario",
	      "placeholder": "Digite o nome ou a matrícula do funcionário"
	    },
	    domProps: {
	      "value": (_vm.funcionarioBusca)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.buscarFuncionario($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.funcionarioBusca = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn-confirm",
	    staticStyle: {
	      "display": "inline-block"
	    },
	    on: {
	      "click": _vm.buscarFuncionario
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), (_vm.funcionarioEncontrado) ? _c('div', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_c('p', [_c('strong', [_vm._v("Funcionário:")]), _vm._v(" " + _vm._s(_vm.funcionarioEncontrado.nome))]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-top": "-15px"
	    }
	  }, [_c('strong', [_vm._v("Matrícula:")]), _vm._v(" " + _vm._s(_vm.formatarMatricula(_vm.funcionarioEncontrado.matricula)))])]) : _vm._e(), _vm._v(" "), (_vm.funcionarioEncontrado) ? _c('div', [_c('p', [_vm._v("Deseja realmente atribuir as tarefas selecionadas?")]), _vm._v(" "), _c('div', {
	    staticClass: "modal-actions"
	  }, [_c('button', {
	    staticClass: "btn-confirm",
	    on: {
	      "click": _vm.confirmarAtribuicao
	    }
	  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn-cancel",
	    on: {
	      "click": _vm.cancelarAtribuicao
	    }
	  }, [_vm._v("Cancelar")])])]) : _vm._e()])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "title": '<h5>Baixar <span class=\'realce\'>' + _vm.tarefasSelecionadas.length + '</span> item(ns) selecionado(s) em Excel</h5>'
	    }
	  }, [_c('download-excel', {
	    attrs: {
	      "data": _vm.tarefasSelecionadas,
	      "meta": _vm.excel_meta,
	      "fields": _vm.excel_campos,
	      "type": "xls",
	      "name": "validacoes.xls"
	    }
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Baixar planilha\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mostraProcessando) ? _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
	    staticClass: "content",
	    staticStyle: {
	      "padding-top": "60px"
	    }
	  }, [_c('p', {
	    staticClass: "visible-sm visible-xs"
	  }, [_vm._v(" ")]), _c('p', {
	    staticClass: "visible-xs"
	  }, [_vm._v(" ")]), _c('p', {
	    staticClass: "visible-xs"
	  }, [_vm._v(" ")]), _vm._v(" "), (_vm.mostraCarregando) ? _c('h4', {
	    staticClass: "box-body text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]) : _vm._e(), _vm._v(" "), (_vm.somenteComTarefas === 'sim' && _vm.totalTarefas(_vm.listaValidacoes) === 0) ? _c('h4', {
	    staticClass: "box-body"
	  }, [_vm._v("Não há tarefas para o filtro selecionado")]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.keysIn(_vm.listaValidacoes)), function(processo) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm.mostraCarregando),
	        expression: "!mostraCarregando"
	      }],
	      staticClass: "box box-widget"
	    }, [_c('div', {
	      staticClass: "box-header"
	    }, [_c('h3', {
	      staticClass: "box-title"
	    }, [_c('span', {
	      staticClass: "grupoMostrarOcultar",
	      on: {
	        "click": function($event) {
	          return _vm.mostrar('processo', processo)
	        }
	      }
	    }, [_c('i', {
	      class: 'fa fa-caret-' + (!_vm._.isUndefined(_vm._.find(_vm.mostrarProcesso, function(p) {
	        return p === processo
	      })) ? 'up' : 'down'),
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.enumeradores[processo])), _c('span', {
	      staticClass: "contador"
	    }, [_vm._v(_vm._s(_vm.totalTarefas(_vm.listaValidacoes[processo])))])])]), _vm._v(" "), (processo === 'CONTRAPARTIDA' && _vm.filtroContrapartida) ? _c('div', {
	      staticStyle: {
	        "margin-top": "20px"
	      }
	    }, [_c('div', {
	      staticClass: "filtroCarteira mt-5"
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.filtroCarteiraContrapartida),
	        expression: "filtroCarteiraContrapartida"
	      }],
	      staticClass: "form-control",
	      staticStyle: {
	        "width": "auto",
	        "float": "left"
	      },
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.filtroCarteiraContrapartida = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, function($event) {
	          return _vm.onChangeFiltroCarteiraContrapartida()
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": "",
	        "value": ""
	      }
	    }, [_vm._v("Filtrar por carteira")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": ""
	      }
	    }, [_vm._v("Todas as carteiras")]), _vm._v(" "), _vm._l((_vm.carteiras), function(carteira) {
	      return _c('option', {
	        domProps: {
	          "value": carteira
	        }
	      }, [_vm._v("\n                " + _vm._s(carteira) + "\n              ")])
	    })], 2)])]) : _vm._e(), _vm._v(" "), (processo === 'ALTERACOES_PROJETO') ? _c('span', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          placement: 'top',
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', delay: [500, 0]}"
	      }],
	      staticClass: "pull-right",
	      attrs: {
	        "title": '<h5>Lista com processos de alteração de projeto nas tarefas listadas abaixo</h5>'
	      }
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.meusProcessos),
	        expression: "meusProcessos"
	      }],
	      staticClass: "form-control",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.meusProcessos = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, _vm.filtrar]
	      }
	    }, [_c('option', {
	      staticStyle: {
	        "color": "var(--cor-destaque)"
	      },
	      attrs: {
	        "value": "",
	        "selected": ""
	      }
	    }, [_vm._v(_vm._s(_vm.meusProcessos === '' ? 'Processos' : 'Limpar Filtro'))]), _vm._v(" "), _vm._l((_vm._.uniq(_vm._.flatten(_vm._.map(_vm._.flatten(_vm._.valuesIn(_vm.listaValidacoes.ALTERACOES_PROJETO)), 'extra.processos')))), function(prc) {
	      return _c('option', {
	        domProps: {
	          "value": prc
	        }
	      }, [_vm._v(_vm._s(_vm.enumeradores[prc]))])
	    })], 2)]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'perspective',
	          distance: '1',
	          size: 'large',
	          placement: 'top',
	          delay: [500, 0]
	        }),
	        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', delay: [500, 0]}"
	      }],
	      staticClass: "pull-right",
	      staticStyle: {
	        "margin": "0px 10px"
	      },
	      attrs: {
	        "title": '<h5>Lista com as carteiras nas tarefas listadas abaixo</h5>'
	      }
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.minhaCarteira),
	        expression: "minhaCarteira"
	      }],
	      staticClass: "form-control",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.minhaCarteira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, _vm.filtrar]
	      }
	    }, [_c('option', {
	      staticStyle: {
	        "color": "var(--cor-destaque)"
	      },
	      attrs: {
	        "value": "",
	        "selected": ""
	      }
	    }, [_vm._v(_vm._s(_vm.minhaCarteira === '' ? 'Carteiras' : 'Limpar Filtro'))]), _vm._v(" "), _vm._l((_vm._.uniq(_vm._.map(_vm._.flatten(_vm._.valuesIn(_vm.listaValidacoes.ALTERACOES_PROJETO)), 'extra.carteira'))), function(carteira) {
	      return _c('option', {
	        domProps: {
	          "value": carteira
	        }
	      }, [_vm._v(_vm._s(carteira))])
	    })], 2)])]) : _vm._e()]), _vm._v(" "), (!_vm._.isUndefined(_vm._.find(_vm.mostrarProcesso, function(p) {
	      return p === processo
	    }))) ? _c('div', {
	      staticClass: "box-body"
	    }, _vm._l((_vm._.keysIn(_vm.listaValidacoes[processo])), function(atividade) {
	      return _c('div', {
	        staticClass: "box box-widget"
	      }, [_c('div', {
	        staticClass: "box-header"
	      }, [_c('h3', {
	        staticClass: "box-title"
	      }, [_c('span', {
	        staticClass: "grupoMostrarOcultar",
	        on: {
	          "click": function($event) {
	            _vm.mostrar('atividade', (processo + '.' + atividade))
	          }
	        }
	      }, [_c('i', {
	        class: 'fa fa-caret-' + (!_vm._.isUndefined(_vm._.find(_vm.mostrarAtividade, function(p) {
	          return p === (processo + '.' + atividade)
	        })) ? 'up' : 'down'),
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" " + _vm._s(_vm.enumeradores[atividade])), _c('span', {
	        staticClass: "contador"
	      }, [_vm._v(_vm._s(_vm.totalTarefas(_vm.listaValidacoes[processo][atividade])))])])])]), _vm._v(" "), (!_vm._.isUndefined(_vm._.find(_vm.mostrarAtividade, function(p) {
	        return p === (processo + '.' + atividade)
	      }))) ? _c('div', {
	        ref: processo + '.' + atividade,
	        refInFor: true,
	        staticClass: "box-body"
	      }, [_c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm.mostraProcessando),
	          expression: "mostraProcessando"
	        }],
	        staticClass: "overlay box box-widget",
	        staticStyle: {
	          "position": "absolute",
	          "top": "0px",
	          "left": "0px",
	          "width": "100%",
	          "height": "100%",
	          "display": "block"
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-refresh fa-spin"
	      })]), _vm._v(" "), (true) ? _c('div', [_c('b-container', {
	        attrs: {
	          "fluid": ""
	        }
	      }, _vm._l(((_vm._.includes(['projeto', 'entidade'], _vm.ordenacao.por) ?
	        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [function(termo) {
	          return _vm._.lowerCase(termo[_vm.ordenacao.por])
	        }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
	        _vm._.includes(['valor'], _vm.ordenacao.por) ? // se for um valor deve converter primeiro antes de ordenar
	        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [function(termo) {
	          return parseFloat(termo[_vm.ordenacao.por])
	        }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
	        _vm._.includes(['codigo_ocorrencia'], _vm.ordenacao.por) ? // se código de oorrência deve pegar no 'extra'
	        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], ['extra.codigo_ocorrencia'], [_vm.ordenacao.ordem]) :
	        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [_vm.ordenacao.por], [_vm.ordenacao.ordem]))), function(tarefa) {
	        return _c('div', {
	          staticClass: "row tarefa",
	          style: ('border-left: 10px solid ' + (_vm.sinalizaCor(tarefa)))
	        }, [_c('div', {
	          staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12",
	          staticStyle: {
	            "height": "46px"
	          }
	        }, [_c('div', {
	          staticClass: "col-xs-2",
	          staticStyle: {
	            "padding": "2px 0"
	          }
	        }, [_c('span', {
	          staticClass: "indicadores"
	        }, [_c('i', {
	          class: (_vm._.find(_vm.tarefasSelecionadas, ['id_processo', tarefa.id_processo]) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' selecao',
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.selecionarItem(tarefa)
	            }
	          }
	        }), _vm._v(" "), _c('i', {
	          class: (tarefa.favoritado === 'sim_fav' ? 'fa fa-star favorito' : 'fa fa-star-o'),
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), ((_vm._.get(tarefa.extra, 'chamados', [])).length === 1) ? _c('span', _vm._l((_vm._.get(tarefa.extra, 'chamados', [])), function(chamado) {
	          return _c('a', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'perspective',
	                distance: '1',
	                size: 'large',
	                placement: 'top',
	                interactive: true
	              }),
	              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', interactive:true}"
	            }],
	            attrs: {
	              "href": _vm.urlLaravel + '/cadastro/chamado/edita/' + chamado.id,
	              "target": "_blank",
	              "title": '<h5 class=\'text-left\'>Chamado SGP <span class=\'realce\'>' + chamado.id + '</span><br/>' + ((chamado.descricao).substr(0, 50) + (chamado.descricao.length > 50 ? '...' : '')) + '</h5>'
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-comments-o",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          })])
	        }), 0) : _vm._e(), _vm._v(" "), ((_vm._.get(tarefa.extra, 'chamados', [])).length > 1) ? _c('span', {
	          staticClass: "dropup menu_chamados"
	        }, [_c('span', {
	          staticClass: "balao_chamado dropdown",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('span', [_c('i', {
	          staticClass: "fa fa-comments-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })]), _vm._v(" "), _c('span', {
	          staticClass: "contador_chamado"
	        }, [_vm._v(_vm._s((_vm._.get(tarefa.extra, 'chamados', [])).length))])]), _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu"
	        }, _vm._l((_vm._.get(tarefa.extra, 'chamados', [])), function(chamado) {
	          return _c('li', {
	            attrs: {
	              "role": "menuitem"
	            }
	          }, [_c('a', {
	            staticClass: "item_chamado",
	            attrs: {
	              "href": _vm.urlLaravel + '/cadastro/chamado/edita/' + chamado.id,
	              "target": "_blank"
	            }
	          }, [_vm._v("\n                                                      Chamado SGP "), _c('span', {
	            staticClass: "realce"
	          }, [_vm._v(_vm._s(chamado.id))]), _vm._v(" "), _c('i', {
	            staticClass: "fa fa-external-link"
	          }), _c('br'), _vm._v(_vm._s(((chamado.descricao).substr(0, 50) + (chamado.descricao.length > 50 ? '...' : ''))))])])
	        }), 0)]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'parametros') && _vm._.find(tarefa.extra.parametros, ['parametro', 'SUPORTE_FBB'])) ? _c('span', _vm._l((_vm.parametroStringToObject(tarefa.extra.parametros, 'SUPORTE_FBB')), function(suporte) {
	          return _c('span', [_c('a', {
	            directives: [{
	              name: "tippy",
	              rawName: "v-tippy",
	              value: ({
	                inertia: true,
	                arrow: true,
	                animation: 'perspective',
	                distance: '1',
	                size: 'large',
	                arrow: true,
	                placement: 'top'
	              }),
	              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	            }],
	            attrs: {
	              "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
	              "target": "_blank",
	              "title": '<h5>Suporte FBB <span class=\'realce\'>' + suporte.numero + '</span><br/>' + suporte.local + ' para ' + suporte.areaoper + '<br/>' + suporte.problema + '</h5>'
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-commenting-o",
	            attrs: {
	              "aria-hidden": "true"
	            }
	          })])])
	        }), 0) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	          staticClass: "text-muted",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.id_processo)
	          }
	        })]), _vm._v(" "), _c('div', {
	          staticClass: "col-xs-10"
	        }, [_c('div', {
	          staticClass: "projeto truncar",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.projeto)
	          }
	        }), _vm._v(" "), _c('div', {
	          staticClass: "entidade truncar",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.entidade)
	          }
	        })])]), _vm._v(" "), _c('div', {
	          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-6 text-center",
	          staticStyle: {
	            "height": "46px",
	            "padding": "2px 0"
	          }
	        }, [(_vm._.includes(['ALTERACOES_PROJETO'], processo)) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top'}"
	          }],
	          attrs: {
	            "title": '<h5>' +
	              ((_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length === 0 ? ((_vm._.get(tarefa, 'extra.solicitacao.justificativa', '')).substr(0, 100) + '...') :
	                (_vm._.join(_vm._.orderBy(_vm._.uniq(_vm._.map(_vm._.get(tarefa.extra.solicitacao, 'processos', []), function(p) {
	                  return _vm.enumeradores[p.nome]
	                })), null, ['asc']), ', '))) + '</h5>'
	          }
	        }, [_vm._v("\n                      " + _vm._s((_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length > 1 ? (_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length + ' processos' : '1 processo') + "\n                    ")]) : (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('span', [(!_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'situacao_projeto')) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          style: ('font-weight: bold; color:' + (tarefa.extra.situacao_projeto === 'APR' ? 'var(--cor-destaque)' : 'var(--cor-atencao)')),
	          attrs: {
	            "title": '<h5>' + tarefa.extra.descricao_situacao + '</h5>'
	          }
	        }, [_vm._v("\n                        " + _vm._s(tarefa.extra.situacao_projeto) + "\n                      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.has(tarefa.extra, 'codigo_ocorrencia')) ? _c('span', {
	          staticClass: "text-bold"
	        }, _vm._l(([(_vm._.get(tarefa, 'extra.codigo_ocorrencia')).substr(0, 1)]), function(nivel) {
	          return _c('span', {
	            style: ('color: var(--cor-' + (nivel === '4' ? 'atencao' : (nivel === '3' ? 'alerta' : (nivel === '2' ? 'destaque' : 'fraca'))) + ')')
	          }, [_vm._v("\n                        " + _vm._s(_vm._.get(tarefa, 'extra.codigo_ocorrencia')) + "\n                      ")])
	        }), 0) : _c('span', {
	          domProps: {
	            "innerHTML": _vm._s(tarefa.info)
	          }
	        })]), _vm._v(" "), _c('div', {
	          class: (_vm._.includes(['SOLICITACOES'], _vm.validacao) ? 'col-lg-2 col-md-4 col-sm-4 col-xs-6' : 'col-lg-2 col-md-6 col-sm-5 col-xs-6') + ' text-center',
	          staticStyle: {
	            "height": "46px"
	          }
	        }, [(atividade === 'FINALIZADAS') ? _c('div', {
	          staticClass: "aprovado_por usuario"
	        }, [_vm._v("Aprovado por"), _c('br'), _c('div', {
	          staticClass: "truncar",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.nome_usuario)
	          }
	        })]) : _c('div', [(tarefa.nome_usuario) ? _c('div', {
	          staticClass: "usuario",
	          domProps: {
	            "innerHTML": _vm._s(tarefa.nome_usuario)
	          }
	        }) : _c('div', {
	          staticClass: "text-muted"
	        }, [_vm._v("Aguardando atendimento")])])]), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('div', {
	          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-4 text-left",
	          staticStyle: {
	            "height": "46px"
	          }
	        }, [(_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], processo)) ? _c('span', [(_vm._.includes(['AUTORIZACAO', 'ANALISE_TRIBUTARIA', 'LIQUIDACAO_FINANCEIRA'], atividade)) ? _c('span', [_c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          attrs: {
	            "title": '<h5>Tributado: <span class=\'realce\'>' + (_vm._.get(_vm._.last(_vm._.filter(tarefa.extra.parametros, ['parametro', 'TRIBUTACAO'])), 'valor') === 'TRIBUTADO' ? 'Sim' : 'Não') + '</span></h5>'
	          }
	        }, [_vm._v("\n                          " + _vm._s(_vm._f("real")(tarefa.valor)) + "\n                        ")]), _vm._v(" "), (atividade === 'AUTORIZACAO' && !_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'parametros') && _vm._.find(tarefa.extra.parametros, ['parametro', 'VALOR_TRIBUTADO'])) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true,
	              placement: 'top'
	            }),
	            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
	          }],
	          staticStyle: {
	            "color": "var(--cor-destaque)"
	          },
	          attrs: {
	            "title": '<h5>Valor Líquido</h5>'
	          }
	        }, [_c('br'), _vm._v(_vm._s(_vm._f("real")(tarefa.valor - (_vm._.toNumber(_vm._.get(_vm._.last(_vm._.filter(tarefa.extra.parametros, ['parametro', 'VALOR_TRIBUTADO'])), 'valor'))))) + "\n                        ")]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(_vm._f("real")(tarefa.valor)))])]) : _c('span', [_vm._v(_vm._s(_vm._f("real")(tarefa.valor)))])]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-4 text-right",
	          staticStyle: {
	            "height": "46px"
	          }
	        }, [(_vm._.isNull(tarefa.data_solicitacao)) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(tarefa.inicio, "DD/MM/YYYY HH:mm")))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(tarefa.data_solicitacao, "DD/MM/YYYY HH:mm")))])]), _vm._v(" "), _c('div', {
	          class: (_vm._.includes(['SOLICITACOES'], _vm.validacao) ? 'col-lg-1 col-md-2 col-sm-2 col-xs-4' : 'col-lg-2 col-md-2 col-sm-3 col-xs-8') + ' text-right',
	          staticStyle: {
	            "height": "46px",
	            "padding": "2px 0"
	          }
	        }, [_c('g-button-ujarak', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'perspective',
	              distance: '1',
	              size: 'large',
	              arrow: true
	            }),
	            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	          }],
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss",
	            "title": '<h5>Assumir e Fazer</h5>'
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.verificarAtribuicao(tarefa)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1)])
	      }), 0)], 1) : _vm._e()]) : _vm._e()])
	    }), 0) : _vm._e()])
	  })], 2)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticStyle: {
	      "margin-bottom": "30px"
	    }
	  }, [_c('strong', [_vm._v("Selecione o funcionário:")])])
	}]}

/***/ }),
/* 2094 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Validação de Entidade")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Validação de Entidade',
	        href: '#'
	      }, {
	        text: 'Primeira Aprovação',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "validaProp"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-solid"
	  }, [_c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills nav-stacked",
	    attrs: {
	      "id": "filtroPre"
	    }
	  }, [_c('li', {
	    class: {
	      'active': _vm.faseAtual === 'primeira'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'primeira'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v("Primeira Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesPrimeiraAprov))])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.faseAtual === 'segunda'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'segunda'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-hand-peace-o"
	  }), _vm._v("Segunda Aprovação "), _c('span', {
	    staticClass: "label label-primary pull-right"
	  }, [_vm._v(_vm._s(_vm.quantidadesSegundaAprov))])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.faseAtual === 'finalizada'
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.faseAtual = 'finalizada'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-flag-checkered"
	  }), _vm._v("Finalizadas "), _c('span', {
	    staticClass: "badge"
	  }, [_vm._v(_vm._s(_vm.quantidadesFinalizadas))])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.descricaoFase))]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative"
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right",
	    staticStyle: {
	      "position": "relative",
	      "margin-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.table.filter),
	      expression: "table.filter"
	    }],
	    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "text",
	      "placeholder": "Pesquisa..."
	    },
	    domProps: {
	      "value": (_vm.table.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.table, "filter", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-padding"
	  }, [_c('div', {
	    staticClass: "mailbox-controls"
	  }, [(_vm.faseAtual !== 'finalizada') ? _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.favorite = !_vm.filtro.favorite
	      }
	    },
	    model: {
	      value: (_vm.filtro.favorite),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "favorite", $$v)
	      },
	      expression: "filtro.favorite"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
	      }
	    },
	    model: {
	      value: (_vm.filtro.userId),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "userId", $$v)
	      },
	      expression: "filtro.userId"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSearch
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  })]), _vm._v(" "), _c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    attrs: {
	      "show-empty": "",
	      "striped": "",
	      "stacked": "md",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "filter": _vm.table.filter,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc,
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "filtered": _vm.onFiltered,
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([(_vm.faseAtual !== 'finalizada') ? {
	      key: "favorite",
	      fn: function(row) {
	        return [_c('i', {
	          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
	          attrs: {
	            "aria-hidden": "true"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onFavorite(row.item)
	            }
	          }
	        })]
	      }
	    } : null, {
	      key: "entidade",
	      fn: function(row) {
	        return [_c('div', {}, [(row.item.simplificado > '0') ? _c('div', [_c('b', [_vm._v(_vm._s(row.item.simplificado))]), _c('br')]) : _vm._e(), _vm._v("\n                      " + _vm._s(row.item.companyName) + "\n                    ")])]
	      }
	    }, {
	      key: "createdAt",
	      fn: function(row) {
	        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
	      }
	    }, {
	      key: "userName",
	      fn: function(row) {
	        return [(row.value) ? _c('span', {
	          staticStyle: {
	            "font-weight": "bold"
	          }
	        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
	      }
	    }, {
	      key: "actions",
	      fn: function(row) {
	        return [_c('div', [_c('div', {
	          staticClass: "btn-group"
	        }, [_c('button', {
	          staticClass: "btn btn-default",
	          attrs: {
	            "data-toggle": "dropdown",
	            "aria-haspopup": "true",
	            "aria-expanded": "false"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ellipsis-h"
	        })]), _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu dropdown-menu-right",
	          attrs: {
	            "role": "menu",
	            "aria-labelledby": "new-register"
	          }
	        }, [_c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'detalhe-validacao-entidades',
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Ver mais")])], 1), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', {
	          staticClass: "ng-scope"
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onAssignAndDo(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', [_c('a', {
	          attrs: {
	            "href": "javascript:void(0)"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.onUnassign(row.item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user-times",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', {
	          staticClass: "divider",
	          attrs: {
	            "role": "separator"
	          }
	        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId && _vm.faseAtual !== 'finalizada') ? _c('li', [_c('router-link', {
	          attrs: {
	            "to": {
	              name: _vm.rota1,
	              params: {
	                id: row.item.id
	              }
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-play-circle",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
	      }
	    }], null, true)
	  }), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "6",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.table.totalRows,
	      "per-page": _vm.table.perPage
	    },
	    model: {
	      value: (_vm.table.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.table, "currentPage", $$v)
	      },
	      expression: "table.currentPage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])], 1)])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2095 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Relatório de Análise\n        "), (!_vm.loading.show) ? _c('span', [(!_vm.somenteLeitura) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gravaRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), (!_vm.somenteLeitura && _vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.calculaRisco($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calculator",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Calcular Risco")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.imprimirRelatorio($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Imprimir ")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group",
	    staticStyle: {
	      "margin-bottom": "-5px"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closewindow(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("Sair e SALVAR")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closewindow(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("Sair SEM SALVAR")])])])])], 1) : _c('span', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.proposta.ds_codigo_projeto_erp == null) ? _c('span', {
	    staticClass: "alertaCamposPendentes"
	  }, [_vm._v(" " + _vm._s(_vm.proposta.ds_codigo_projeto_erp) + "ALERTA: Após o preenchimento da proposta e geração do número de projeto o relatório disponibilizará todos os seus efetivos campos.")]) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Validação',
	        href: '/'
	      }, {
	        text: 'Propostas',
	        href: '#'
	      }, {
	        text: 'Relatório de Análise',
	        active: true
	      }]
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    staticClass: "column all-centered etapa-carga-log-button",
	    attrs: {
	      "title": '<h5>Verificar Log de Carregamento</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.mostrarLogCarga = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-warning"
	  })])], 1), _vm._v(" "), (_vm.itemSemContaFinanceiraFBB || _vm.itemSemContaFinanceiraParceiro || _vm.semProjetoDuplicador) ? _c('div', {
	    staticClass: "column centered-start etapa-aviso-conta-container-geral"
	  }, [(_vm.itemSemContaFinanceiraFBB || _vm.itemSemContaFinanceiraParceiro) ? _c('div', {
	    staticClass: "etapa-aviso-conta-container"
	  }, [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção: Existem itens de orçamento sem conta financeira cadastrada. Favor Verificar.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.semProjetoDuplicador) ? _c('div', {
	    staticClass: "etapa-aviso-conta-container"
	  }, [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção: Projeto de Duplicação ainda não foi selecionado. Favor verificar.\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarLogCarga) ? _c('div', {
	    staticClass: "column centered-start etapa-carga-container"
	  }, [(_vm.mostrarAviso) ? _c('div', {
	    staticClass: "column all-centered etapa-aviso-container"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row-flex start-centered etapa-aviso-button-container"
	  }, [_c('div', {
	    staticClass: "row-flex all-centered etapa-button-ok",
	    on: {
	      "click": function($event) {
	        _vm.mostrarLogCarga = false
	      }
	    }
	  }, [_vm._v("\n            Estou Ciente, continuar.\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-centered etapa-button-reload",
	    on: {
	      "click": function($event) {
	        return _vm.recarregarRelatorio()
	      }
	    }
	  }, [_vm._v("\n            Recarregar Relatório.\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column centered-start etapa-carga-content"
	  }, [_c('div', {
	    staticClass: "column all-end etapa-close-container"
	  }, [_c('i', {
	    staticClass: "fa fa-close etapa-close-button",
	    on: {
	      "click": function($event) {
	        _vm.mostrarLogCarga = false
	      }
	    }
	  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._l((_vm.etapaCarga), function(etapa, index) {
	    return _c('div', {
	      staticClass: "column all-centered etapa-carga-info"
	    }, [_c('div', {
	      staticClass: "row-flex centered-between etapa-carga-row"
	    }, [_c('div', {
	      staticClass: "row-flex etapa-carga-nome"
	    }, [_vm._v("\n              " + _vm._s(index + 1) + " - " + _vm._s(etapa.nome) + "\n            ")]), _vm._v(" "), _c('div', {
	      staticClass: "row-flex all-centered etapa-carga-status",
	      class: etapa.status === 'OK' ? 'status-ok' : etapa.status === 'Carregando' ? 'status-carregando' : 'status-erro'
	    }, [_vm._v("\n              " + _vm._s(etapa.status) + " "), (etapa.status === 'Carregando') ? _c('i', {
	      staticClass: "fa fa-refresh ga-spin"
	    }) : _vm._e(), _vm._v(" "), (etapa.status === 'OK') ? _c('i', {
	      staticClass: "fa fa-check-circle"
	    }) : _vm._e(), _vm._v(" "), (etapa.status === 'ERRO') ? _c('i', {
	      staticClass: "fa fa-warning"
	    }) : _vm._e()])]), _vm._v(" "), (etapa.erro) ? _c('div', {
	      staticClass: "column start-centered etapa-carga-erro-container"
	    }, [(etapa.erro.response) ? _c('div', [_vm._v("\n              " + _vm._s(etapa.nome) + " | " + _vm._s(etapa.erro.response.data.message) + "\n            ")]) : _c('div', [_vm._v("\n              " + _vm._s(etapa.nome) + " | " + _vm._s(etapa.erro) + "\n            ")])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    attrs: {
	      "id": "relatorio_analise"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": _vm.proposta.ds_fase !== 'ANALISE'
	    }
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('table', {
	    staticClass: "w100"
	  }, [_c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
	    staticClass: "w50"
	  }, [_c('h4', {
	    staticClass: "titulo ressaltar"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "20px !important",
	      "font-family": "sans-serif"
	    }
	  }, [_vm._v("RELATÓRIO DE ANÁLISE")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm._.get(_vm.proposta, 'rating.consultas.PEP', 0) > 0) ? _c('span', [_vm._v("Alçada do Comitê Estratégico")]) : (_vm.ehVoluntariado) ? _c('span', [_vm._v("Alçada do Comitê de Desenvolvimento Social")]) : _c('span', [_vm._v("Alçada do " + _vm._s(_vm.faixaDoProjeto.alcada))])])]), _vm._v(" "), (_vm.proposta.ds_codigo_projeto_erp) ? _c('td', {
	    staticClass: "w20"
	  }, [_c('h4', {
	    staticClass: "ressaltar text-right",
	    staticStyle: {
	      "font-size": "28px !important",
	      "text-transform": "uppercase"
	    }
	  }, [_vm._v("Projeto nº " + _vm._s(_vm.proposta.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) || _vm.ehPis || _vm.ehVoluntariado) ? _c('div', [_c('div', {
	    staticClass: "titulo nao_imprimir alertaCamposPendentes"
	  }, [_vm._v("Modelo de Relatório de Análise para projetos " + _vm._s(_vm.ehPIS ? 'do PIS' : (_vm.ehVoluntariado ? 'de Voluntariado' : '')) + " entre " + _vm._s(_vm._f("real")(_vm.faixaDoProjeto.de)) + " à " + _vm._s(_vm._f("real")(_vm.faixaDoProjeto.para)))])]) : _vm._e(), _vm._v(" "), (_vm._.includes([1, 2], _vm.faixaDoProjeto.faixa)) ? _c('div', [_c('div', {
	    staticClass: "titulo nao_imprimir alertaCamposPendentes"
	  }, [_vm._v("Modelo de Relatório de Análise para projetos até " + _vm._s(_vm._f("real")(_vm.faixaDoProjeto.para)))])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Projetos da Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.todasPropostas), function(projetos) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(projetos.ds_codigo_projeto_erp))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(projetos.ds_nome))]), _vm._v(" "), (projetos.ds_situacao_erp !== null) ? _c('td', {
	      staticClass: "situacao_projeto text-center"
	    }, [_vm._v(_vm._s(projetos.ds_situacao_erp))]) : _vm._e(), _vm._v(" "), (projetos.ds_situacao_erp === null) ? _c('td', {
	      staticClass: "situacao_projeto text-center"
	    }, [_vm._v("Não aprovado, fase de\n                            "), (projetos.ds_fase === 'ANALISE') ? _c('span', [_vm._v("Análise")]) : _vm._e(), _vm._v(" "), (projetos.ds_fase === 'DEFERIMENTO') ? _c('span', [_vm._v("Deferimento")]) : _vm._e(), _vm._v(" "), (projetos.ds_fase === 'FORMALIZACAO') ? _c('span', [_vm._v("Formalização")]) : _vm._e()]) : _vm._e()])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])]), _vm._v(" "), (_vm.proposta.nr_projeto_duplicacao) ? _c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Projeto Superior")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.projetoSuperior))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm._.has(_vm.proposta, 'ds_fep_tipo_acao') ? (_vm.proposta.ds_fep_tipo_acao === 'AT' ? 'AT - Ação Tática' : (_vm.proposta.ds_fep_tipo_acao === 'AF' ? 'AF - Ação Finalística' : (_vm.proposta.ds_fep_tipo_acao === 'ISD' ? 'ISD - Investimento Social Direto' : 'Ação não informada'))) : 'Ação não informada'))])]), _vm._v(" "), (_vm.proposta) ? _c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Abrangência Nacional")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.bt_fep_abrangencia === '1' ? 'S - Sim' : 'N - Não'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Período Início e Fim Projeto")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ehNulo(_vm.proposta.dt_assinatura_convenio, _vm.proposta.dt_data_inicial), "MM/YYYY")) + "  a  " + _vm._s(_vm.dataFinalProjeto))]), _vm._v(" "), _c('td', [_vm._v("Prazo de execução")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.nr_periodos) + " meses")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('th', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)))])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)) + " ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida)) + " ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "34%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalParceiro)) + " ")])])]), _vm._v(" "), (_vm.ehVoluntariado || _vm.ehEditalMN) ? _c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("*A contrapartida corresponde a " + _vm._s(this.$root.formataNumero((_vm.totalContrapartida / _vm.totalFBB), 'percentual')) + "% do valor aportado pela FBB.")])]) : _c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("*A contrapartida corresponde a " + _vm._s(this.$root.formataNumero((_vm.totalContrapartida / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)), 'percentual')) + "% do valor total do projeto.")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Entidade Proponente")]), _vm._v(" "), _c('div', [(_vm.proposta.entidade) ? _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "cabecalho w30"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [(_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato) && _vm._.has(_vm.proposta.entidade.contato, 'ds_telefone') && !_vm._.isEmpty(_vm.proposta.entidade.contato.ds_telefone)) ? _c('span', [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_telefone)) + "  ")]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato) && _vm._.has(_vm.proposta.entidade.contato, 'ds_celular') && !_vm._.isEmpty(_vm.proposta.entidade.contato.ds_celular)) ? _c('span', [_vm._v("celular: " + _vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_celular)))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Endereço(s)")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar"
	  }, [(_vm.proposta.entidade.endereco) ? _c('span', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
	    return (endereco.bt_principal === 1) ? _c('p', {
	      staticClass: "ressaltar"
	    }, [_vm._v("\n                              " + _vm._s(endereco.ds_rua) + ", " + _vm._s(endereco.ds_numero) + ", " + _vm._s(endereco.ds_bairro) + ", " + _vm._s(endereco.ds_complemento) + ", " + _vm._s(endereco.ds_cidade) + " / " + _vm._s(endereco.ds_estado) + ", CEP: " + _vm._s(_vm._f("cep")(endereco.ds_cep)) + "\n                            ")]) : _vm._e()
	  }), 0) : _vm._e()])])])]) : _vm._e()])]), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante Legal da Entidade")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered lista"
	  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.dirigentes), function(dirigente) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")) + " até " + _vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [(_vm.proposta.municipalizacao) ? _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(8), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, _vm._l((_vm.municipios = _vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
	    return m.ds_municipio + '/' + m.ds_uf
	  })), function(municipio, key, index) {
	    return _c('span', [_vm._v("\n                              " + _vm._s(municipio[0].ds_municipio + (_vm._.isUndefined(municipio[0].ds_uf) ? '' : '/' + municipio[0].ds_uf) + (index != Object.keys(_vm.municipios).length - 1 ? ',' : '.')) + "\n                            ")])
	  }), 0)])])]) : _vm._e()]), _vm._v(" "), (_vm.ehPIS) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Apresentação da entidade proponente")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao_entidade')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "",
	      "name": "ds_problemas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.apresentacao_entidade),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "apresentacao_entidade", $$v)
	      },
	      expression: "relatorioAnalise.apresentacao_entidade"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.apresentacao_entidade)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) || _vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Qual(is) problema(s) a proponente quer resolver ?")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_problemas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "De forma sucinta, descreva a(s) situação(ões)-problema destacada(s) pela proponente.",
	      "name": "ds_problemas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_problemas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_problemas", $$v)
	      },
	      expression: "relatorioAnalise.ds_problemas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_problemas)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) || _vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("O que a proponente pretende fazer para solucionar o(s) problema(s) ?")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_solucao_problemas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "De forma sucinta, descreva o que a instituição propõe executar para solucionar o(s) problema(s) e os gastos previstos.",
	      "name": "ds_solucao_problemas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_solucao_problemas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_solucao_problemas", $$v)
	      },
	      expression: "relatorioAnalise.ds_solucao_problemas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_solucao_problemas)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.ehPIS) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(" Como a organização pretende operacionalizar as atividades propostas?")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('operacionalizacao_atividades')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "",
	      "name": "ds_problemas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.operacionalizacao_atividades),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "operacionalizacao_atividades", $$v)
	      },
	      expression: "relatorioAnalise.operacionalizacao_atividades"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.operacionalizacao_atividades)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && !_vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Quais os resultados esperados por meio da ação proposta ?")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_resultados_esperados')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "De forma sucinta, discorra sobre a efetividade da ação proposta, descrevendo os impactos e transformações esperados no cotidiano dos participantes por meio da implementação do projeto.",
	      "name": "ds_resultados_esperados"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_resultados_esperados),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_resultados_esperados", $$v)
	      },
	      expression: "relatorioAnalise.ds_resultados_esperados"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_resultados_esperados)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && (!_vm.ehPIS && !_vm.ehVoluntariado)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Principais aspectos positivos da proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_aspectos_positivos')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "De forma sucinta, discorra sobre os principais aspectos positivos da proposta, considerando pontos relacionados à metodologia apresentada pela proponente, ao grau de envolvimento do público participante e ao potencial de continuidade das ações após a execução das atividades (sustentabilidade do projeto).",
	      "name": "ds_aspectos_positivos"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_aspectos_positivos),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_aspectos_positivos", $$v)
	      },
	      expression: "relatorioAnalise.ds_aspectos_positivos"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_aspectos_positivos)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && (!_vm.ehPIS && !_vm.ehVoluntariado)) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Principais preocupações em relação à proposta")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_preocupacoes')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Se for o caso, discorra de forma sucinta sobre os principais aspectos que demandam cuidados em relação à proposta, considerando riscos relacionados às lacunas na metodologia, à qualidade das atividades propostas, aos possíveis impactos ambientais ou sociais negativos, à falta de participação da comunidade, à possível descontinuidade das ações e à ausência de parcerias/acordos com outras instituições.",
	      "name": "ds_preocupacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_preocupacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_preocupacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_preocupacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_preocupacoes)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Análise das condições internas da proponente")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Pontos Positivos:")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_condicoes_internas_positivas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "De forma sucinta, descreva os aspectos positivos sobre o ambiente INTERNO da proponente, destacando pontos como: infraestrutura, capacidade técnica, grau de organização/articulação social, etc.",
	      "name": "ds_condicoes_internas_positivas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_condicoes_internas_positivas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_internas_positivas", $$v)
	      },
	      expression: "relatorioAnalise.ds_condicoes_internas_positivas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_internas_positivas)
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_vm._v("Pontos de Atenção:")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_condicoes_internas_negativas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "De forma sucinta, descreva os aspectos negativos sobre o ambiente INTERNO da proponente, destacando pontos como: infraestrutura, capacidade técnica, grau de organização/articulação social, etc.",
	      "name": "ds_condicoes_internas_negativas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_condicoes_internas_negativas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_internas_negativas", $$v)
	      },
	      expression: "relatorioAnalise.ds_condicoes_internas_negativas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_internas_negativas)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Análise das condições externas da proponente")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Pontos Positivos:")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_condicoes_externas_positivas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "De forma sucinta, descreva os aspectos positivos e negativos sobre o ambiente EXTERNO da proponente, destacando pontos como: relacionamento com a gestão pública, mercado local, logística do município, fatores climáticos, stakeholders, etc.",
	      "name": "ds_condicoes_externas_positivas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_condicoes_externas_positivas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_externas_positivas", $$v)
	      },
	      expression: "relatorioAnalise.ds_condicoes_externas_positivas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_externas_positivas)
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_vm._v("Pontos de Atenção:")]), _vm._v(" "), _c('div', {
	    staticClass: "required",
	    class: {
	      'has-error': _vm.errors.first('ds_condicoes_externas_negativas')
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "De forma sucinta, descreva os aspectos negativos sobre o ambiente EXTERNO da proponente, destacando pontos como: relacionamento com a gestão pública, mercado local, logística do município, fatores climáticos, stakeholders, etc.",
	      "name": "ds_condicoes_externas_negativas"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_condicoes_externas_negativas),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_externas_negativas", $$v)
	      },
	      expression: "relatorioAnalise.ds_condicoes_externas_negativas"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_externas_negativas)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered m0"
	  }, [_vm._m(9), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.publicos_alvo), function(publico) {
	    return _c('tr', [(publico.fonte.ds_descricao) ? _c('td', {
	      staticClass: "ressaltar"
	    }, [_vm._v(_vm._s(publico.fonte.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_participantes_diretos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_jovens))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_mulheres))])])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos e Metas")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("O objetivo geral da proposta define o que se pretende com a implementação do projeto ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_geral),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_geral"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_indicadores_objetivo_geral"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_geral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Os objetivos específicos e as metas do projeto propiciam o atingimento do objetivo geral ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_especifico),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_especifico"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_indicadores_objetivo_especifico"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_especifico", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes estatutárias da FBB?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_compativel),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_compativel"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_indicadores_objetivo_compativel"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_compativel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), (!_vm.ehPIS && !_vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes de programa estruturado (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_estruturado),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_estruturado"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_indicadores_objetivo_estruturado"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_estruturado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.ehPIS || _vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Existe alguma crítica em relação aos objetivos, metas e indicadores apresentados pela proponente?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.existe_critica_objetivos_metas_indicadores),
	      expression: "relatorioAnalise.existe_critica_objetivos_metas_indicadores"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "existe_critica_objetivos_metas_indicadores"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "existe_critica_objetivos_metas_indicadores", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), ((_vm._.has(_vm.relatorioAnalise, 'existe_critica_objetivos_metas_indicadores') && _vm.relatorioAnalise.existe_critica_objetivos_metas_indicadores === 'Sim')) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "7",
	      "name": "critica_objetivos_metas_indicadores"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.critica_objetivos_metas_indicadores),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "critica_objetivos_metas_indicadores", $$v)
	      },
	      expression: "relatorioAnalise.critica_objetivos_metas_indicadores"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.critica_objetivos_metas_indicadores)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehPIS && !_vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes do plano de trabalho firmado no âmbito de parcerias estratégicas (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_estrategico),
	      expression: "relatorioAnalise.ds_indicadores_objetivo_estrategico"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_indicadores_objetivo_estrategico"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_estrategico", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivo Geral")]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Objetivo Geral do Projeto",
	      "name": "objetivo Geral",
	      "rows": "4",
	      "disabled": true
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_objetivo_geral),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_objetivo_geral", $$v)
	      },
	      expression: "proposta.ds_objetivo_geral"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos Específicos e Metas")]), _vm._v(" "), _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.objetivos), function(objetivo) {
	    return _c('tr', [_c('td', {
	      staticStyle: {
	        "border-bottom": "2px solid silver !important"
	      }
	    }, [_vm._v(_vm._s(objetivo.ds_descricao))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "border-bottom": "2px solid silver !important"
	      }
	    }, [_c('table', _vm._l((_vm._.filter(_vm.proposta.metas, function(m) {
	      return _vm._.includes(_vm._.map(m.objetivos, 'ds_descricao'), objetivo.ds_descricao)
	    })), function(meta) {
	      return _c('tr', [_c('td', {
	        staticStyle: {
	          "border": "none",
	          "border-bottom": "1px solid silver"
	        }
	      }, [_vm._v(_vm._s(meta.ds_descricao))])])
	    }), 0)])])
	  }), 0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Indicadores de Resultado")]), _vm._v(" "), (_vm.indicadoresResultadoLista.length) ? _c('ul', {
	    staticStyle: {
	      "margin-top": "8px",
	      "padding-left": "20px"
	    }
	  }, _vm._l((_vm.indicadoresResultadoLista), function(indicador, idx) {
	    return _c('li', {
	      key: 'indicador-' + idx
	    }, [_vm._v(_vm._s(indicador.descricao))])
	  }), 0) : _c('div', {
	    staticStyle: {
	      "color": "#a8a8a8"
	    }
	  }, [_vm._v("Nenhum indicador selecionado.")]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir",
	    staticStyle: {
	      "color": "#a8a8a8",
	      "font-size": "13px"
	    }
	  }, [_vm._v("Os indicadores são informados na aba Análise da proposta.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Divulgação do projeto")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [(_vm._.includes([1, 2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Os recursos para realização das ações contidas no Plano de Comunicação foram previstos na memoria de cálculo?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_acoes_comunicacao_memoria_calculo),
	      expression: "relatorioAnalise.ds_acoes_comunicacao_memoria_calculo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_divulgacao_identificacao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_acoes_comunicacao_memoria_calculo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foi previsto no projeto o uso de banner obrigatório indicativo do apoio da Fundação ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_divulgacao_banner),
	      expression: "relatorioAnalise.ds_divulgacao_banner"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_divulgacao_banner"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_banner", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foi prevista a identificação de veículos a serem adquiridos com recursos financeiros do projeto (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_divulgacao_identificacao),
	      expression: "relatorioAnalise.ds_divulgacao_identificacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_divulgacao_identificacao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_identificacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foi prevista a instalação de placa provisória e definitiva em obras civis a serem realizadas com recursos financeiros do projeto (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_divulgacao_placa),
	      expression: "relatorioAnalise.ds_divulgacao_placa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_divulgacao_placa"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_placa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foi prevista no cronograma físico a realização de atividades relativa à solenização de assinatura de convênio ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_divulgacao_solenizacao),
	      expression: "relatorioAnalise.ds_divulgacao_solenizacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_divulgacao_solenizacao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_solenizacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "data-vv-as": "Ações",
	      "name": "acoes",
	      "rows": "4",
	      "disabled": true
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_acoes_comunicacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_acoes_comunicacao", $$v)
	      },
	      expression: "proposta.ds_acoes_comunicacao"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.proposta.ds_acoes_comunicacao)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Valores e contrapartida")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('th', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)))])]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)) + "  ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "33%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida)) + "  ")]), _vm._v(" "), _c('td', {
	    staticClass: "ressaltar",
	    staticStyle: {
	      "width": "34%"
	    }
	  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalParceiro)) + "  ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Recursos da Fundação")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensFbb), function(conta) {
	    return _c('tbody', [(conta.valor > 0) ? _c('tr', {
	      staticClass: "conta"
	    }, [_c('td', [_vm._v(_vm._s(conta.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(conta.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((conta.valor) / (_vm.totalFBB))))])]) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(13), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensContrapartida), function(contra) {
	    return _c('tbody', [(contra.conta) ? _c('tr', {
	      staticClass: "conta"
	    }, [_c('td', [_vm._v(_vm._s(contra.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.values(contra.item), function(i) {
	      return i.valor
	    }))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((_vm._.sumBy(_vm._.values(contra.item), function(i) {
	      return i.valor
	    })) / (_vm.totalContrapartida))))])]) : _vm._e()])
	  })], 2)]), _vm._v(" "), (_vm.totalParceiro > 0) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Recursos de Parcerias")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered"
	  }, [_vm._m(14), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensParceiro), function(conta) {
	    return _c('tbody', [(conta.valor > 0) ? _c('tr', {
	      staticClass: "conta"
	    }, [_c('td', [_vm._v(_vm._s(conta.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(conta.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((conta.valor) / (_vm.totalParceiro))))])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Os itens de despesa propostos são compatíveis com os objetivos, metas e atividades do projeto ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_itens),
	      expression: "relatorioAnalise.ds_valores_itens"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_valores_itens"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_itens", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A contrapartida proposta atende aos critérios específicos definidos para projetos abaixo de R$ 100 mil?' :
	    'A contrapartida proposta atende aos critérios definidos nos normativos vigentes?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_contrapartida),
	      expression: "relatorioAnalise.ds_valores_contrapartida"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_valores_contrapartida"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_contrapartida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), (!_vm.ehPIS && !_vm._.includes([2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'Os valores apresentados na memória de cálculo estão de acordo com os preços praticados no mercado ou com os parâmetros operacionais estabelecidos pela FBB?' :
	    'Os valores orçados na proposta, inclusive contrapartida, estão de acordo com os praticados no mercado, conforme orçamentos apresentados ?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_deacordo),
	      expression: "relatorioAnalise.ds_valores_deacordo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_valores_deacordo"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_deacordo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Os itens de despesa, cujos orçamentos não foram apresentados, enquandram-se nas diretrizes de dispensa ou nos parâmetros estabelecidos pela Fundação ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_enquadrados),
	      expression: "relatorioAnalise.ds_valores_enquadrados"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_valores_enquadrados"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_enquadrados", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observadas as vedações de itens de despesa, conforme norma vigente ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_vedacoes),
	      expression: "relatorioAnalise.ds_valores_vedacoes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_valores_vedacoes"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_vedacoes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observados os itens necessários para propostas que envolvam obra civil e/ou aquisição de bens fixos de uso industrial ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_industrial),
	      expression: "relatorioAnalise.ds_valores_industrial"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_valores_industrial"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_industrial", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observados os itens necessários para propostas que envolvam ações de formação, capacitação e/ou consultorias ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_formacao),
	      expression: "relatorioAnalise.ds_valores_formacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_valores_formacao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_formacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.ehPIS) ? _c('tr', [_c('td', [_vm._v("Foi verificado conformidade específica para obra civil?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.conforme_obra_civil),
	      expression: "relatorioAnalise.conforme_obra_civil"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "conforme_obra_civil"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "conforme_obra_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Foi realizado algum ajuste nos valores apresentados ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_valores_ajustes),
	      expression: "relatorioAnalise.ds_valores_ajustes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_valores_ajustes"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_ajustes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "placeholder": "Descreva a seguir as observações e ajustes realizados nos valores, bem como demais justificativas pertinentes.",
	      "name": "ds_valores_observacoes"
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_valores_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_valores_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_valores_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_valores_observacoes)
	    }
	  })]), _vm._v(" "), (!_vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Liberação de recursos")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Os parâmetros para concessão da modalidade de adiantamento de recursos foram atendidos conforme normativos vigentes ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_liberacao_adiantamentos),
	      expression: "relatorioAnalise.ds_liberacao_adiantamentos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_liberacao_adiantamentos"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_liberacao_adiantamentos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "placeholder": "Descreva a seguir, se for o caso, justificativa pela concessão de adiantamento.",
	      "name": "ds_liberacao_observacoes"
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_liberacao_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_liberacao_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_liberacao_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_liberacao_observacoes)
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Parcelas de Adiantamento")]), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [(_vm.proposta.adiantamentos) ? _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '10%' : '15%'))
	  }, [_c('b', [_vm._v("Parcela")])]), _vm._v(" "), _c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '30%' : '45%'))
	  }, [_c('b', [_vm._v("Origem")])]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_c('b', [_vm._v("Fundação")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_c('b', [_vm._v("Parceiro Estratégico")])]) : _vm._e(), _vm._v(" "), _c('td', {
	    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '20%' : '40%'))
	  }, [_c('b', [_vm._v("Valor")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parcelasAdiantamentoExibicao), function(adiantamento) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm.rotuloOrigemParcela(adiantamento.origem)))]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "text-right"
	    }, [(!_vm._.isNil(adiantamento.valor_fbb)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_fbb)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	      staticClass: "text-right"
	    }, [(!_vm._.isNil(adiantamento.valor_parc)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_parc)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor)))])])
	  }), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "ressaltar",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Total adiantável")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoFundacao)) + "\n                            "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoFundacao / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoParceiro)) + "\n                            "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoParceiro / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "text-right ressaltar"
	  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoGeral)) + "\n                            "), ((_vm.totalFBB + _vm.totalParceiro) > 0) ? _c('span', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoGeral / (_vm.totalFBB + _vm.totalParceiro)))) + ")")]) : _vm._e()])])], 2), _vm._v(" "), (_vm.parcelasAdiantamentoExibicao.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "100%"
	    }
	  }, [_vm._v("Nenhuma parcela de adiantamento cadastrada.")])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Prazo de execução e periodicidade de relatórios")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Há compatibilidade entre o prazo de execução indicado na proposta e as atividades a serem realizadas ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_execucao_compatibilidade),
	      expression: "relatorioAnalise.ds_execucao_compatibilidade"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_execucao_compatibilidade"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_execucao_compatibilidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual o prazo de execução do projeto ?\n                        ")]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_execucao_prazo),
	      expression: "relatorioAnalise.ds_execucao_prazo"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_titulo",
	      "disabled": true,
	      "id": "ds_execucao_prazo",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.relatorioAnalise.ds_execucao_prazo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorioAnalise, "ds_execucao_prazo", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual o prazo de vigência do projeto?")]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periodo_vigencia),
	      expression: "proposta.periodo_vigencia"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_titulo",
	      "disabled": true,
	      "id": "prazo_vigencia",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.periodo_vigencia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Qual a periodicidade dos relatórios de execução ?\n                        ")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "145px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_execucao_relatorios),
	      expression: "relatorioAnalise.ds_execucao_relatorios"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_execucao_relatorios",
	      "id": "ds_execucao_relatorios",
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.relatorioAnalise.ds_execucao_relatorios)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorioAnalise, "ds_execucao_relatorios", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "placeholder": "Informe observações relevantes referente ao prazo de execução do projeto.",
	      "name": "ds_execucao_observacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_execucao_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_execucao_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_execucao_observacoes"
	    }
	  })], 1), _vm._v(" "), (!_vm.ehVoluntariado) ? _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_execucao_observacoes)
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Regularidade da proposta e da proponente")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("A proposta é compatível com os objetivos estatutários e regimentais da entidade proponente?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_objetivos),
	      expression: "relatorioAnalise.ds_regularidade_objetivos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_regularidade_objetivos"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_objetivos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A proponente apresentou toda a documentação exigida para a análise de projetos abaixo de R$ 100 mil?' :
	    'A proponente apresentou toda a documentação exigida para a análise de projetos?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_documentação),
	      expression: "relatorioAnalise.ds_regularidade_documentação"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_regularidade_documentação"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_documentação", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A proponente encontra-se em regularidade cadastral, de acordo com as exigências específicas para projetos abaixo de R$ 100 mil?' :
	    'A proponente encontra-se em regularidade cadastral?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_cadastral),
	      expression: "relatorioAnalise.ds_regularidade_cadastral"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_regularidade_cadastral"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_cadastral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('tr', [_c('td', [_vm._v("A proponente encontra-se em conformidade (fiscal e documental) e relação a exigências específicas no âmbito de parceria estratégica (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_fiscal),
	      expression: "relatorioAnalise.ds_regularidade_fiscal"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_regularidade_fiscal"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_fiscal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("A proponente já executou projetos com a FBB ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_projetos),
	      expression: "relatorioAnalise.ds_regularidade_projetos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_regularidade_projetos"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_projetos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("A proponente encontra-se em regularidades junto à FBB (inexistência de ocorrências impeditivas) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_ocorrencias),
	      expression: "relatorioAnalise.ds_regularidade_ocorrencias"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_regularidade_ocorrencias"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_ocorrencias", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_vm._m(15), _vm._v(" "), (_vm.relatorioAnalise.ds_regularidade_rating) ? _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_regularidade_rating.ds_descricao),
	      expression: "relatorioAnalise.ds_regularidade_rating.ds_descricao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_titulo",
	      "id": "ds_regularidade_rating",
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": (_vm.relatorioAnalise.ds_regularidade_rating.ds_descricao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorioAnalise.ds_regularidade_rating, "ds_descricao", $event.target.value)
	      }
	    }
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), (_vm._.includes([1, 2], _vm.faixaDoProjeto.faixa)) ? _c('td', [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": "C"
	    }
	  })]) : _c('td', [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "readonly": _vm.somenteLeitura,
	      "type": "text",
	      "maxlength": "255",
	      "disabled": true
	    },
	    domProps: {
	      "value": !_vm.riscoCalculado ? 'Risco ainda não calculado' : _vm.riscoCalculado
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "placeholder": "Descreva a seguir possíveis comentários acerca da regularidade da proposta, proponente e condicionantes, se for o caso.",
	      "name": "ds_regularidade_observacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_regularidade_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_regularidade_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_regularidade_observacoes)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Licenciamento ambiental")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("As atividades propostas para o projeto são passíveis de dispensa, ou licenciamento ambiental (conforme Anexo I da Resolução CONAMA n° 237 - IN-BB 671) ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_licenciamento_conforme),
	      expression: "relatorioAnalise.ds_licenciamento_conforme"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_licenciamento_conforme"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_conforme", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual documentação foi apresentada (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_licenciamento_documentacao),
	      expression: "relatorioAnalise.ds_licenciamento_documentacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_titulo",
	      "id": "ds_licenciamento_documentacao",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.relatorioAnalise.ds_licenciamento_documentacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_documentacao", $event.target.value)
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "placeholder": "Descreva qual a documentação apresentada, inexigibilidade ou dispensa, conforme o caso.",
	      "name": "ds_licenciamento_observacoes"
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_licenciamento_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_licenciamento_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_licenciamento_observacoes)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Enquadramento e Parecer jurídico")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("A proposta foi enquadrada no controle orçamentário da FBB ?")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_enquadramento_orcamento),
	      expression: "relatorioAnalise.ds_enquadramento_orcamento"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_enquadramento_orcamento"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_orcamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Número da FEP?\n                        ")]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [(_vm._.has(_vm.proposta, 'fep') && _vm._.has(_vm.proposta.fep, 'numero') && _vm._.has(_vm.proposta.fep, 'ano')) ? _c('span', {
	    staticClass: "form-control",
	    staticStyle: {
	      "border": "none"
	    },
	    attrs: {
	      "name": "ds_enquadramento_fep",
	      "id": "ds_enquadramento_fep"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.fep.ano + "/" + _vm.proposta.fep.numero))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'Foi utilizada a minuta padrão aprovada para projetos abaixo de R$ 100 mil?' :
	    'Foi utilizada a minuta padrão aprovada que contemple as necessidades do projeto ?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.relatorioAnalise.ds_enquadramento_minuta),
	      expression: "relatorioAnalise.ds_enquadramento_minuta"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_enquadramento_minuta"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_minuta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.opcoes), function(opcao) {
	    return _c('option', {
	      domProps: {
	        "value": opcao
	      }
	    }, [_vm._v(_vm._s(opcao))])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control ressaltar juntos",
	    attrs: {
	      "placeholder": "Informe o embasamento jurídico, parecer e/ou minuta padrão utilizados para amparo legal da minuta de convênio.",
	      "name": "ds_enquadramento_observacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_enquadramento_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_enquadramento_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_enquadramento_observacoes)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Objetivos de Desenvolvimento Sustentável (ODS)")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [(_vm.odsCadastrado.length > 0) ? _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, _vm._l((_vm.odsCadastrado), function(ods) {
	    return _c('div', [_vm._v("\n                            " + _vm._s(ods.descricao) + "\n                            "), _vm._l((ods.metasDescricao), function(meta) {
	      return _c('div', [_c('i', [_vm._v("Meta " + _vm._s(meta.descricao))])])
	    })], 2)
	  }), 0) : _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_vm._v("\n                          Não Possui ODS cadastrado.\n                        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Tecnologia Social")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [(_vm.possuiTecnologiaSocial) ? _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, _vm._l((_vm.tecnologiasCadastradas), function(tecnologia) {
	    return _c('div', [_vm._v("\n                          " + _vm._s(tecnologia.nome) + "\n                        ")])
	  }), 0) : _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_vm._v("\n                        Não possui Tecnologias cadastradas.\n                      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Público-Alvo Previsto")]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [(_vm.publicoAlvoDefinicoes.length > 0) ? _c('div', {
	    staticClass: "column  all-start gap-5 container-padding"
	  }, _vm._l((_vm.publicoAlvoDefinicoes), function(definicao) {
	    return _c('div', [_vm._v("\n                           - " + _vm._s(definicao) + "\n                        ")])
	  }), 0) : _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_vm._v("\n                        Não possui Público-Alvo Previsto cadastrado.\n                      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Avaliação do Projeto")]), _vm._v(" "), (_vm.questoesAvaliacao.length > 0) ? _c('div', [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_c('b', [_vm._v(_vm._s(_vm.questoesAvaliacao[0].resposta))])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_vm._m(17), _vm._v(" "), _c('tbody', _vm._l((_vm.questoesAvaliacao), function(questao, index) {
	    return (index > 0) ? _c('tr', {
	      key: index
	    }, [_c('td', [_vm._v(_vm._s(questao.questao || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(questao.resposta))])]) : _vm._e()
	  }), 0)])]) : _c('div', {
	    staticClass: "column all-start gap-5 container-padding"
	  }, [_vm._v("\n                      -\n                    ")])]), _vm._v(" "), (_vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
	    staticClass: "box-body juntos"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Considerações finais")]), _vm._v(" "), _c('table', {
	    staticClass: "bloco"
	  }, [_c('tr', [_c('td', [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "7",
	      "name": "ds_consideracoes_finais"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_consideracoes_finais),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_consideracoes_finais", $$v)
	      },
	      expression: "relatorioAnalise.ds_consideracoes_finais"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_consideracoes_finais)
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "juntos"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(18), _vm._v(" "), _c('table', {
	    staticClass: "bloco"
	  }, [_c('tr', [_c('td', [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "7",
	      "name": "ds_parecer"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_parecer),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_parecer", $$v)
	      },
	      expression: "relatorioAnalise.ds_parecer"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_parecer)
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [(_vm.ehVoluntariado) ? _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Despacho dos Gerentes de Divisão")]) : _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Despacho do " + _vm._s(_vm.faixaDoProjeto.alcada))])]), _vm._v(" "), _c('table', {
	    staticClass: "bloco"
	  }, [_c('tr', [_c('td', [_c('div', {
	    staticClass: "nao_imprimir"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "7",
	      "name": "ds_despacho_observacoes"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.relatorioAnalise.ds_despacho_observacoes),
	      callback: function($$v) {
	        _vm.$set(_vm.relatorioAnalise, "ds_despacho_observacoes", $$v)
	      },
	      expression: "relatorioAnalise.ds_despacho_observacoes"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "imprimir bloco_texto",
	    domProps: {
	      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_despacho_observacoes)
	    }
	  })])])])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-danger btn-sm",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("Sair")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-danger dropdown-toggle btn-sm",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('span', {
	    staticClass: "caret"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle Dropdown")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" AVISO: Existem dados que não foram carregados para o relatório de análise conforme log abaixo. O que pode ocorrer nos casos em que a proposta ainda não possui projeto vinculado ou está com seu preenchimento incompleto. Revise o Log e caso necessário, entre em contato com o administrador do sistema ou recarregue o relatório.\n        ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start etapa-carga-titulo"
	  }, [_c('i', {
	    staticClass: "fa fa-user-secret"
	  }), _vm._v(" Status de Carga da Edição do Relatório de Análise")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "w30"
	  }, [_c('img', {
	    staticClass: "logo_relatorio",
	    attrs: {
	      "src": "/static/img/logo-login.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('td', {
	    staticClass: "w10"
	  }, [_c('b', [_vm._v("N° Projeto")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Nome")])]), _vm._v(" "), _c('td', {
	    staticClass: "situacao_projeto w20"
	  }, [_c('b', [_vm._v("Situação do Projeto")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Fundação")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contrapartida*")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Parcerias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "w30"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "width": "15%",
	      "text-align": "center"
	    }
	  }, [_vm._v("Cargo")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "width": "15%",
	      "text-align": "center"
	    }
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
	    staticClass: "w30 text-center",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Mandato")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Público-alvo")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho w20"
	  }, [_vm._v("Participantes Diretos")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho w20"
	  }, [_vm._v("Jovens")]), _vm._v(" "), _c('th', {
	    staticClass: "cabecalho w20"
	  }, [_vm._v("Mulheres")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "w30"
	  }, [_vm._v("Objetivos Específicos")]), _vm._v(" "), _c('th', [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Fundação")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Contrapartida")]), _c('th', {
	    staticClass: "cabecalho"
	  }, [_vm._v("Parcerias")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-left"
	  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w20"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w10"
	  }, [_vm._v("% Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-left"
	  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w20"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w10"
	  }, [_vm._v("% Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-left"
	  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w20"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center w10"
	  }, [_vm._v("% Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', [_vm._v("Rating calculado para a proponente")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', [_vm._v("Risco Calculado do Projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Questão")]), _vm._v(" "), _c('th', [_vm._v("Resposta")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Proposta")])])
	}]}

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Solicitações'
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("Solicitações de Prestação de Contas (Modelo Simplificado)")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_vm._v("\n        Lista de todos os IDs em aberto e seus respectivos estados\n    ")])])
	},staticRenderFns: []}

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarOpcoes),
	      expression: "mostrarOpcoes"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "quadro_opcoes",
	    style: ('min-height: ' + ((_vm.atividades.length * 30) + 20) + 'px;')
	  }, [_c('div', {
	    staticClass: "zoom"
	  }, [_vm._v("Zoom no gantt "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.zoom),
	      expression: "zoom"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.zoom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm._.range([_vm.start = 1], 3, [_vm.step = .5])), function(z) {
	    return _c('option', [_vm._v(_vm._s(z))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "margem"
	  }, [_vm._v("Distância das atividades "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tamanho_nome_atividade),
	      expression: "tamanho_nome_atividade"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.tamanho_nome_atividade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm._.range([_vm.start = 400], 700, [_vm.step = 50])), function(d) {
	    return _c('option', [_vm._v(_vm._s(d))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "tipo_barra"
	  }, [_vm._v("Mostrar execução por "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tipo_barra),
	      expression: "tipo_barra"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.tipo_barra = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "financeiro"
	    }
	  }, [_vm._v("% do orçado / liberado")]), _c('option', {
	    attrs: {
	      "value": "declarado"
	    }
	  }, [_vm._v("% informado no relatório")])])]), _vm._v(" "), _c('div', {
	    staticClass: "mostrar_exec_financeira"
	  }, [_vm._v("Mostrar Valor Liberado e Orçado "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mostrar_execucao_financeira),
	      expression: "mostrar_execucao_financeira"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mostrar_execucao_financeira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": true
	    }
	  }, [_vm._v("Sim")]), _c('option', {
	    domProps: {
	      "value": false
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
	    staticClass: "mostrar_exec_declarada"
	  }, [_vm._v("Mostrar Percentual Declarado "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mostrar_execucao_declarada),
	      expression: "mostrar_execucao_declarada"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mostrar_execucao_declarada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": true
	    }
	  }, [_vm._v("Sim")]), _c('option', {
	    domProps: {
	      "value": false
	    }
	  }, [_vm._v("Não")])])]), _vm._v(" "), _c('div', [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large'}"
	    }],
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "title": 'Clique para trazer os dados salvos até o momento'
	    },
	    on: {
	      "click": _vm.carregaAtividades
	    }
	  }, [_c('i', {
	    class: 'fa fa-refresh'
	  }), _vm._v(" Atualizar o gráfico")])])])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "col-md-12 gantt_atividades"
	  }, [_c('div', [_c('div', {
	    staticClass: "cabecalho"
	  }, [_c('div', {
	    staticClass: "linha_marcadoras",
	    style: ('height: ' + ((_vm.atividades.length * 30) + 30) + 'px;')
	  }, [_c('div', {
	    staticClass: "titulo",
	    style: ('width: ' + _vm.tamanho_nome_atividade + 'px')
	  }, [_vm._v("Atividades")]), _vm._v(" "), _vm._l((_vm.projeto.periodos), function(periodo) {
	    return _c('div', {
	      staticClass: "periodos_projeto",
	      style: ('margin-left: ' + (parseInt(_vm.tamanho_nome_atividade) + ((30 * _vm.zoom) * (periodo - 1))) + 'px;' + 'width: ' + (30 * _vm.zoom) + 'px;')
	    }, [_vm._v(_vm._s(periodo) + "\n            ")])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "hoje",
	    style: ('margin-left: ' + (parseInt(_vm.tamanho_nome_atividade) + ((_vm.projeto.hoje_dias < ((_vm.projeto.periodos * 30) + 30) ? _vm.projeto.hoje_dias : ((_vm.projeto.periodos * 30) + 30))) * _vm.zoom) + 'px; height: ' + ((_vm.atividades.length * 30) + 60) + 'px; padding: ' + ((_vm.atividades.length * 30) + 40) + 'px 10px 0px 5px;')
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        theme: 'light'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', theme: 'light'}"
	    }],
	    attrs: {
	      "title": (_vm.dia_noite === 'DIA' ? 'Bom dia!' : _vm.dia_noite === 'TARDE' ? 'Boa Tarde!' : 'Boa noite!') + '<br/> Já se passaram <b>' + _vm.projeto.hoje_dias + ' dias' + '</b> do início do projeto'
	    }
	  }, [_c('i', {
	    class: _vm.dia_noite === 'DIA' ? 'fa fa-sun-o' : _vm.dia_noite === 'TARDE' ? 'fa fa-sun-o' : 'fa fa-moon-o'
	  }), _vm._v(" Hoje")])])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "atividades",
	    style: ('width: ' + ((30 * _vm.projeto.periodos * _vm.zoom) + parseInt(_vm.tamanho_nome_atividade) + 150) + 'px')
	  }, _vm._l((_vm.atividades), function(atividade) {
	    return _c('div', {
	      staticClass: "atividade"
	    }, [_c('div', {
	      staticClass: "nome_atividade quebrar_texto",
	      style: ('width: ' + _vm.tamanho_nome_atividade + 'px')
	    }, [_vm._v(_vm._s(atividade.descricao))]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          inertia: true,
	          arrow: true,
	          animation: 'fade',
	          distance: '1',
	          size: 'large'
	        }),
	        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large'}"
	      }],
	      staticClass: "barra",
	      style: ('margin-left: ' + (atividade.dias_inicio * _vm.zoom) + 'px; width: ' + (((atividade.dias_termino - atividade.dias_inicio) * _vm.zoom)) + 'px'),
	      attrs: {
	        "title": '<h5>' +
	          atividade.descricao +
	          '<hr>' +
	          'Duração: ' + atividade.dias_termino + ' dias<br/>' +
	          '% Tempo decorrido: <span class=\'realce\'>' + (_vm.projeto.hoje_dias <= atividade.dias_inicio ? 0 : _vm.projeto.hoje_dias >= atividade.dias_termino ? 100 : ((_vm.projeto.hoje_dias / atividade.dias_termino) * 100) | _vm.percentage) + '%</span>' +
	          '<hr>' +
	          'Orçado: R$ ' + (parseFloat(atividade.orcado) | _vm.real) + '<br/>' +
	          'Liberado: R$ ' + (parseFloat(atividade.executado) | _vm.real) + '<br/>' +
	          '% Lib. Financeira: <span class=\'realce\'>' + (_vm.percentualExecutado(atividade.orcado, atividade.executado) | _vm.percentage) + '%</span>' +
	          '<hr>' +
	          '% Execução da Atividade: <span class=\'realce\'>' + (_vm._.isNil(atividade.execucao) ? '0' : atividade.execucao) + '%' + '</span></h5>'
	      }
	    }, [_c('div', {
	      class: (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) >= 0 &&
	        (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) < 100 ? 'atividade_executada alinha_esquerda sem_tamanho' : (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) >= 100 ? 'atividade_completa' : 'atividade_erro alinha_esquerda sem_tamanho',
	      style: ('width: ' + (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) + '% !important')
	    }, [(_vm.mostrar_execucao_financeira && parseFloat(atividade.executado) > 0 && (parseFloat(atividade.executado) < parseFloat(atividade.orcado))) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(parseFloat(atividade.executado))))]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
	      staticClass: "atividade_prevista alinha_esquerda",
	      style: ('width: ' + (100 - (_vm.tipo_barra === 'declarado' && !_vm._.isNil(atividade.execucao) ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado))) + '% !important')
	    }, [_c('span', [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
	      staticClass: "info_adicional"
	    }, [(_vm.mostrar_execucao_financeira) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(parseFloat(atividade.orcado))))]) : _vm._e(), _vm._v(" "), (_vm.mostrar_execucao_declarada) ? _c('span', {
	      staticClass: "percentual_execucao"
	    }, [_vm._v(_vm._s(atividade.execucao) + "%")]) : _vm._e()])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "rodape"
	  }, [_c('div', {
	    staticClass: "opcoes",
	    on: {
	      "click": function($event) {
	        _vm.mostrarOpcoes = !_vm.mostrarOpcoes
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" Opções\n          ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        interactive: true,
	        theme: 'light',
	        trigger: 'click'
	      }),
	      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', trigger: 'click'}"
	    }],
	    staticClass: "legenda",
	    attrs: {
	      "title": '<table class=\'legenda_tabela\'>' +
	        '<tr><td class=\'atividade_executada\'>&nbsp;</td><td>Total liberado em pagamento, prestação de contas e contrapartidas</td></tr>' +
	        '<tr><td class=\'atividade_prevista\'>&nbsp;</td><td> Atividade prevista, valor não liberado </td></tr>' +
	        '<tr><td class=\'atividade_completa\'>&nbsp;</td><td> Atividade financeiramente completada </td></tr>' +
	        '<tr><td class=\'atividade_erro\'>&nbsp;</td><td> Erro de preenchimento da execução da atividade no relatório </td></tr>' +
	        '<tr><td style= \'background: #ca1b1b61\'>&nbsp;</td><td> Data atual no projeto </td></tr>' +
	        '</table>'
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  }), _vm._v(" Legenda\n          ")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": _vm.titulo
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Entidades\n\n        "), (!_vm.boqueia && !_vm.loading.tela) ? _c('span', [(((_vm.entidade.ds_status !== 'PENDENTE_APROVACAO') && (_vm.usuarioLogado.userType === 'ENTIDADE') || (_vm.usuarioLogado.userType === 'FUNDACAO'))) ? _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "disabled": !_vm.isEditable()
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.permiteConcluir(_vm.frmCommonRegister)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), (((_vm.entidade.ds_status !== 'PENDENTE_APROVACAO') && (_vm.usuarioLogado.userType === 'ENTIDADE') || (_vm.usuarioLogado.userType === 'FUNDACAO'))) ? _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista")]), _vm._v(" "), (_vm.entidade.ds_status === 'PENDENTE_APROVACAO' && _vm.usuarioLogado.userType === 'ENTIDADE' && _vm.propostaUnicaEditalVigente) ? _c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.devolverRevisao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-repeat",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Devolver Revisão")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cadastro da Entidade    "), _c('a', {
	    attrs: {
	      "href": _vm.urlLaravel + '/docs/manual_cadastro_entidade_dirigentes_usuarios_v1.pdf',
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Manual")])])]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": _vm.boqueia === true
	    }
	  }, [_c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "dadosCadastrais"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), (!_vm._.isEmpty(_vm._.get(_vm._.head(_vm.historico_atualizado), 'observacao', null)) && !_vm._.isNull(_vm._.get(_vm._.head(_vm.historico_atualizado), 'termino', null))) ? _c('div', {
	    staticClass: "alert alert-dismissible alert-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm._.get(_vm._.head(_vm.historico_atualizado), 'observacao'))
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-7 col-lg-6",
	    attrs: {
	      "id": "cadastroJuri"
	    }
	  }, [_c('fieldset', {
	    attrs: {
	      "disabled": !_vm.isEditable() || _vm.boqueia === true
	    }
	  }, [_c('legend', [_vm._v("\n                        Dados da entidade:\n\n                          ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Razão social')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Razão social"
	    }
	  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_nome),
	      expression: "entidade.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Razão social",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Razão social",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.first('CNPJ')
	    }
	  }, [_c('label', {
	    ref: "CNPJ",
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "CNPJ"
	    }
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:14|max:14'),
	      expression: "'required|min:14|max:14'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ",
	      "type": "text",
	      "mask": "NN.NNN.NNN/NNNN-##",
	      "tokens": _vm.$cnpjTokens,
	      "disabled": "true"
	    },
	    model: {
	      value: (_vm.entidade.ds_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
	      },
	      expression: "entidade.ds_cnpj"
	    }
	  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('cnpjExpeditionTime') || _vm.erroData == true
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "cnpjExpeditionTime"
	    }
	  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-lg-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.data_expedicao_cnpj),
	      expression: "data_expedicao_cnpj"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##/##/####'),
	      expression: "'##/##/####'"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|validdate|date_format:dd/MM/yyyy|dateeqpast|after:01/01/1900'),
	      expression: "'required|validdate|date_format:dd/MM/yyyy|dateeqpast|after:01/01/1900'"
	    }],
	    ref: "cnpjExpeditionTime",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "cnpjExpeditionTime",
	      "name": "cnpjExpeditionTime",
	      "data-vv-as": "Expedição CNPJ",
	      "masked": _vm.masked
	    },
	    domProps: {
	      "value": (_vm.data_expedicao_cnpj)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.data_expedicao_cnpj = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpjExpeditionTime')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Nome fantasia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Nome fantasia"
	    }
	  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_nome_fantasia),
	      expression: "entidade.ds_nome_fantasia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:1|max:255'),
	      expression: "'required|min:1|max:255'"
	    }],
	    ref: "Nome fantasia",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome fantasia",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_nome_fantasia)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_nome_fantasia", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('forma_juridica')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "forma_jurídica"
	    }
	  }, [_vm._v(" Natureza jurídica: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaFormasJuridicas,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione uma Natureza Jurídica",
	      "track-by": "codigo",
	      "custom-label": _vm.etiquetaListaFormaJuridica,
	      "preselect-first": false,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "forma_juridica",
	      "data-vv-as": "Natureza jurídica"
	    },
	    model: {
	      value: (_vm.entidade.forma_juridica),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "forma_juridica", $$v)
	      },
	      expression: "entidade.forma_juridica"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('forma_juridica')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma_juridica')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('ramos_atividade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Ramo atividade"
	    }
	  }, [_vm._v(" Ramos de Atividade: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaRamosAtividade,
	      "multiple": true,
	      "close-on-select": false,
	      "clear-on-select": true,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione os Ramos de Atividade",
	      "label": "ds_codigo",
	      "track-by": "ds_codigo",
	      "custom-label": _vm.etiquetaListaRamosAtividade,
	      "selectedLabel": "Selecionado",
	      "selectLabel": "Aperte ENTER para selecionar",
	      "deselectLabel": "Aperte ENTER para remover",
	      "name": "ramos_atividade",
	      "data-vv-as": "Ramos de Atividade",
	      "options-limit": 1500
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "multiselect__tag"
	        }, [_c('span', [_vm._v(_vm._s(props.ds_codigo))]), _c('span', {
	          staticClass: "custom__remove",
	          on: {
	            "click": function($event) {
	              return props.remove(props)
	            }
	          }
	        }, [_vm._v("❌")])])]
	      }
	    }]),
	    model: {
	      value: (_vm.entidade.ramos_atividade),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "ramos_atividade", $$v)
	      },
	      expression: "entidade.ramos_atividade"
	    }
	  }, [_vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "noResult"
	    },
	    slot: "noResult"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('ramos_atividade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('ramos_atividade')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('listaDocConstituicao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "documento_constituicao"
	    }
	  }, [_vm._v(" Documento de constituição: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaDocConstituicao,
	      "multiple": false,
	      "close-on-select": true,
	      "searchable": false,
	      "track-by": "id",
	      "label": "ds_tipo",
	      "placeholder": "Selecione um Documento de constituição",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "listaDocConstituicao",
	      "data-vv-as": "Documento de constituição"
	    },
	    model: {
	      value: (_vm.entidade.documento_constituicao),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade, "documento_constituicao", $$v)
	      },
	      expression: "entidade.documento_constituicao"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('listaDocConstituicao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('listaDocConstituicao')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-lg-6",
	    attrs: {
	      "id": "contato"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "Telefone"
	    }
	  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10|max:11'),
	      expression: "'required|min:10|max:11'"
	    }],
	    ref: "Telefone",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "data-vv-as": "Telefone",
	      "type": "text",
	      "masked": false,
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.entidade.contato.ds_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade.contato, "ds_telefone", $$v)
	      },
	      expression: "entidade.contato.ds_telefone"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "mobile"
	    }
	  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-lg-4"
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('min:10|max:11'),
	      expression: "'min:10|max:11'"
	    }],
	    ref: "mobile",
	    staticClass: "form-control",
	    attrs: {
	      "name": "mobile",
	      "data-vv-as": "Celular",
	      "type": "text",
	      "masked": false,
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.entidade.contato.ds_celular),
	      callback: function($$v) {
	        _vm.$set(_vm.entidade.contato, "ds_celular", $$v)
	      },
	      expression: "entidade.contato.ds_celular"
	    }
	  }), _vm._v(" "), (_vm.errors.first('mobile')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('mobile')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_email),
	      expression: "entidade.ds_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|min:1|max:255'),
	      expression: "'required|email|min:1|max:255'"
	    }],
	    ref: "Email",
	    staticClass: "form-control",
	    attrs: {
	      "name": "Email",
	      "type": "text",
	      "data-vv-as": "E-Mail",
	      "delivery": "account",
	      "method": "uniqueUserEmail"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "website"
	    }
	  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.ds_website),
	      expression: "entidade.ds_website"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:255'),
	      expression: "'max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "nam": "website",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.entidade.ds_website)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "ds_website", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), (!_vm.propostaUnicaEditalVigente) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Possui CEBAS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiCebas),
	      expression: "possuiCebas"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "possuiCebas"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiCebas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.onChangeCebasCmas($event)
	      }]
	    }
	  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]) : _vm._e(), _vm._v(" "), (!_vm.propostaUnicaEditalVigente) ? _c('div', {
	    staticClass: "form-group required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-4"
	  }, [_vm._v("Possui CMAS/CAS:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.possuiCmas),
	      expression: "possuiCmas"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "possuiCmas"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.possuiCmas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.onChangeCebasCmas($event)
	      }]
	    }
	  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(1), _vm._v(" "), _c('endereco', {
	    attrs: {
	      "entEnderecos": _vm.entidade.endereco
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(2), _vm._v(" "), _c('dirigentes', {
	    ref: "componenteDirigentes",
	    attrs: {
	      "entDirigentes": _vm.entidade.dirigentes,
	      "entidadeParceira": _vm.entidade,
	      "name": "dirigentes",
	      "id": "dirigentes"
	    },
	    on: {
	      "validacaoDirigente": function($event) {
	        return _vm.adicionaRestricao($event)
	      },
	      "dirigenteAdicionado": function($event) {
	        return _vm.verificarDirigenteAtivo($event)
	      },
	      "dirigenteSalvo": function($event) {
	        return _vm.onDirigenteSalvo($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(3), _vm._v(" "), _c('assinaturaDirigentes', {
	    attrs: {
	      "visualiza": false
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(4), _vm._v(" "), _c('usuarios', {
	    attrs: {
	      "entUsuarios": _vm.entidade.usuarios
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "documentos"
	    }
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.entidade.documentos,
	      "documentTypes": _vm.entidade.tipos_documento,
	      "localUso": _vm.listaDocEntidades,
	      "salvouOK": _vm.salvouOK,
	      "disable": _vm.entidade.ds_status === 'PENDENTE_APROVACAO' && _vm.usuarioLogado.userType === 'ENTIDADE' ? 'disable' : ''
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('historico-entidade', {
	    attrs: {
	      "entHistorico": _vm.historico
	    },
	    on: {
	      "historico_itens": function($event) {
	        _vm.historico_atualizado = $event
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.entidade.resultadoAprovacao === 'Revisar') ? _c('div', {
	    staticClass: "form-group full",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao"
	    }
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entidade.observacao),
	      expression: "entidade.observacao"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "150px",
	      "resize": "none"
	    },
	    attrs: {
	      "name": "observacao",
	      "id": "observacao"
	    },
	    domProps: {
	      "value": (_vm.entidade.observacao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entidade, "observacao", $event.target.value)
	      }
	    }
	  })]) : _vm._e()])])])])])])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Endereço:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Dirigentes/Designados:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Quem vai assinar o convênio com a Fundação BB (Conforme estatuto e/ou procuração)")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Usuários do sistema:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos anexos:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico:")])])])
	}]}

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column centered-start cotacao-manual-main-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row-flex all-start w-100 gap-5"
	  }, [_c('div', {
	    ref: "nomeItemCotacao",
	    staticClass: "column all-start cotacao-input-container"
	  }, [_c('label', {
	    staticClass: "f-required"
	  }, [_vm._v("Item de cotação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nomeItem),
	      expression: "nomeItem"
	    }],
	    staticClass: "form-control",
	    class: _vm.errorInput ? 'error-input' : '',
	    attrs: {
	      "disabled": this.visualizacao,
	      "type": "text",
	      "placeholder": "Digite o nome do item a ser cotado, ref. histórico do cronograma."
	    },
	    domProps: {
	      "value": (_vm.nomeItem)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.nomeItem = $event.target.value
	      }, function($event) {
	        _vm.errorInput = false
	      }]
	    }
	  })]), _vm._v(" "), _c('div', {
	    ref: "nomeItemCotacao",
	    staticClass: "column all-start cotacao-input-container"
	  }, [_c('label', {
	    staticClass: "f-required"
	  }, [_vm._v("Valor:")]), _vm._v(" "), _c('money', {
	    staticClass: "form-control",
	    attrs: {
	      "disabled": this.visualizacao
	    },
	    model: {
	      value: (_vm.valor),
	      callback: function($$v) {
	        _vm.valor = $$v
	      },
	      expression: "valor"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered cotacao-manual-anexo-container"
	  }, [_c('label', {
	    staticClass: "control-label f-required"
	  }, [_vm._v("Anexo:")]), _vm._v(" "), (!_vm.carregandoAnexos) ? _c('uploadCotacaoManual', {
	    staticClass: "w-100",
	    attrs: {
	      "propDocumentos": _vm.anexos,
	      "localUso": "COTACAO_MANUAL",
	      "maxFiles": 3,
	      "disable": this.visualizacao
	    }
	  }) : _c('div', [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  }), _vm._v("\n            Carregando Anexos...\n          ")])], 1), _vm._v(" "), _c('div', {
	    ref: "nomeItemCotacao",
	    staticClass: "column all-start cotacao-input-container"
	  }, [_c('label', {
	    staticClass: "f-required"
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.justificativa),
	      expression: "justificativa"
	    }],
	    staticClass: "form-control justificativa-input",
	    attrs: {
	      "type": "text",
	      "disabled": this.visualizacao,
	      "placeholder": "Escreva a Justificativa para cotação Manual ( ex: Produto não encontrado no sistema de cotação | Meu valor é melhor)"
	    },
	    domProps: {
	      "value": (_vm.justificativa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.justificativa = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (!_vm.visualizacao) ? _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.gravarResultado()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar ")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "error"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleCotacaoManual(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar ")])], 1) : _c('div', {
	    staticClass: "row-flex centered-end w-100 gap-5"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleCotacaoManual(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar ")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-flex centered-start cotacao-header-container"
	  }, [_c('i', {
	    staticClass: "fa fa-dollar"
	  }), _vm._v(" Cotação Manual\n    ")])
	}]}

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Registro de Ocorrências'
	    }
	  }), _vm._v(" "), _c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Ocorrência',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "listaOcorrencias"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('edita-ocorrencias', {
	    attrs: {
	      "idProcesso": _vm.id,
	      "botaoVoltar": _vm.botaoVoltar
	    },
	    on: {
	      "acaoOcorrencia": function($event) {
	        _vm.ocorrenciaSelecionada = $event
	      },
	      "acaoProcessamento": function($event) {
	        _vm.loading.tela = true
	      },
	      "acaoAguardando": function($event) {
	        _vm.loading.tela = false
	      },
	      "acaoCancelar": function($event) {
	        return _vm.$router.go(-1)
	      },
	      "acaoOk": function($event) {
	        _vm.loading.tela = false
	      }
	    }
	  })], 1)])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('span', [_vm._v("Ocorrências")])])
	}]}

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "publico-alvo-previsto-container"
	  }, [_c('div', {
	    staticClass: "publico-alvo-descritivo"
	  }, [_vm._v("\n      Descrição de Público-alvo.\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "publico-alvo-content"
	  }, [_c('div', {
	    staticClass: "publico-alvo-definicao-container"
	  }, _vm._l((_vm.definicaoPublicoAlvo), function(item, index) {
	    return _c('div', {
	      staticClass: "publico-alvo-item-container",
	      class: {
	        'adjust-height': item.aberto
	      },
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.toogleItem(index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "publico-alvo-titulo",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.toogleItem(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-caret-right",
	      class: {
	        'rotate-icon': item.aberto
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _c('strong', [_vm._v(_vm._s(item.tipo))]), _vm._v(" (" + _vm._s(_vm.totalizadoresPorGrupo(item.tipo)) + ")\n          ")]), _vm._v(" "), (item.aberto) ? _c('div', {
	      staticClass: "divider",
	      class: {
	        'show-item': item.aberto
	      }
	    }) : _vm._e(), _vm._v(" "), (item.aberto) ? _c('div', {
	      staticClass: "publico-alvo-content-container"
	    }, _vm._l((item.subgrupos), function(detalhamento) {
	      return (item.aberto) ? _c('div', {
	        staticClass: "publico-alvo-items",
	        class: {
	          'show-item': item.aberto
	        },
	        attrs: {
	          "title": detalhamento.descricao
	        }
	      }, [_c('label', {
	        staticClass: "conjunto-item"
	      }, [_vm._v("\n                " + _vm._s(detalhamento.subgrupo)), _c('div', [_vm._v(_vm._s(detalhamento.totalizador))])])]) : _vm._e()
	    }), 0) : _vm._e()])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "publico-alvo-totalizador-content"
	  }, [_c('div', {
	    staticClass: "publico-alvo-total-container"
	  }, [_vm._v("\n        Total Geral de Participantes cadastrados com definições de Público-alvo:\n        "), _c('div', [_vm._v("\n          " + _vm._s(_vm.totalizadorGeral) + "\n        ")])])])]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": _vm.titulo
	    }
	  }), _vm._v(" "), _c('div', {}, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', {
	    attrs: {
	      "title": _vm.proposta.ds_codigo_projeto_erp + ' - ' + _vm.proposta.ds_nome
	    }
	  }, [_vm._v("\n        Emissão de Documentos: Projeto " + _vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome) + "\n      ")])]), _vm._v(" "), (!_vm.loading) ? _c('section', {
	    ref: "botoes",
	    staticClass: "content"
	  }, [(this.$root.isFundacao(this.usuarioLogado) && this.loading === false) ? _c('div', {
	    staticClass: "row"
	  }, [_c('b-card', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "max-width": "25%"
	    }
	  }, [_c('div', {
	    staticClass: "botaoGerarArquivo",
	    attrs: {
	      "id": "atestado"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.botaoDocumento($event)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "atestado",
	      "width": "40",
	      "height": "60",
	      "src": __webpack_require__(141)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "atestado"
	    }
	  }, [_vm._v("Atestado de Capacidade Técnica")])]), _vm._v(" "), _c('div', {
	    staticClass: "botaoGerarArquivo",
	    attrs: {
	      "id": "notificacaoAviso"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.botaoDocumento($event)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "notificacaoAviso",
	      "width": "40",
	      "height": "60",
	      "src": __webpack_require__(141)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "notificacaoAviso"
	    }
	  }, [_vm._v("Notificação Extrajudicial - Aviso")])]), _vm._v(" "), _c('div', {
	    staticClass: "botaoGerarArquivo",
	    attrs: {
	      "id": "notificacaoFinal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.botaoDocumento($event)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "notificacaoFinal",
	      "width": "40",
	      "height": "60",
	      "src": __webpack_require__(141)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "notificacaoFinal"
	    }
	  }, [_vm._v("Notificação Extrajudicial - Final")])]), _vm._v(" "), _c('div', {
	    staticClass: "botaoGerarArquivo",
	    attrs: {
	      "id": "relatorioMonitoramento"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.botaoDocumento($event)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "relatorioMonitoramento",
	      "width": "40",
	      "height": "60",
	      "src": __webpack_require__(141)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "relatorioMonitoramento"
	    }
	  }, [_vm._v("Relatório de Monitoramento Presencial")])]), _vm._v(" "), _c('div', {
	    staticClass: "botaoGerarArquivo",
	    attrs: {
	      "id": "briefing"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.botaoDocumento($event)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "briefing",
	      "width": "40",
	      "height": "60",
	      "src": __webpack_require__(141)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "briefing"
	    }
	  }, [_vm._v("Briefing")])])]), _vm._v(" "), (this.briefing) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', {
	    staticClass: "card-title"
	  }, [_vm._v("Dados que devem constar no Briefing")]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-block"
	  }, [_c('b-form-checkbox-group', {
	    staticClass: "mb-3",
	    attrs: {
	      "options": _vm.dadosBriefing,
	      "value-field": "id",
	      "text-field": "nome",
	      "stacked": ""
	    },
	    model: {
	      value: (_vm.selecionadosBriefing),
	      callback: function($$v) {
	        _vm.selecionadosBriefing = $$v
	      },
	      expression: "selecionadosBriefing"
	    }
	  })], 1), _vm._v(" "), _c('b-button', {
	    attrs: {
	      "variant": "primary",
	      "id": "briefing"
	    },
	    on: {
	      "click": _vm.gerarBriefing
	    }
	  }, [_vm._v("Gerar arquivo de Briefing\n            ")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": 'SGP - Abrindo chamado'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fade-transition"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Cadastro',
	        href: '#'
	      }, {
	        text: 'Chamados',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content "
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "row1"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmCommonRegister",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    attrs: {
	      "id": "chamado"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v("\n                          O chamado é para um projeto específico?\n                        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group required",
	    class: {
	      'has-error': _vm.errors.first('projetoSN')
	    }
	  }, [_c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projetoEspecifico),
	      expression: "projetoEspecifico"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "projetoSN",
	      "value": "SIM"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.projetoEspecifico, "SIM")
	    },
	    on: {
	      "change": function($event) {
	        _vm.projetoEspecifico = "SIM"
	      }
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projetoEspecifico),
	      expression: "projetoEspecifico"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "projetoSN",
	      "value": "NAO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.projetoEspecifico, "NAO")
	    },
	    on: {
	      "change": function($event) {
	        _vm.projetoEspecifico = "NAO"
	      }
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('projetoSN')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo acima deve ser marcado com Sim ou Não')))]) : _vm._e()])])])]), _vm._v(" "), (_vm.projetoEspecifico === 'SIM') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('projeto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2 tl",
	    attrs: {
	      "for": "projeto"
	    }
	  }, [_vm._v("Projeto:")]), _vm._v(" "), (_vm.loading.projetos) ? _c('div', {
	    staticClass: "col-md-10"
	  }, [_vm._m(1)]) : _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.projetoEspecifico === 'SIM'
	      }),
	      expression: "{required: projetoEspecifico === 'SIM'}"
	    }],
	    attrs: {
	      "options": _vm.projetos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um projeto",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTipos,
	      "selectLabel": "",
	      "label": "Projeto",
	      "track-by": "Projeto",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "projeto",
	      "data-vv-as": "Projeto",
	      "disabled": false
	    },
	    on: {
	      "select": function($event) {
	        return _vm.changeProjeto($event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "truncar"
	        }, [_c('span', {
	          staticClass: "identificadorIDProjeto"
	        }, [_vm._v(_vm._s(props.option.Projeto.substr(0, 5)))]), _vm._v(_vm._s(props.option.Projeto.substring(7)))])]
	      }
	    }], null, false, 1733405816),
	    model: {
	      value: (_vm.projeto),
	      callback: function($$v) {
	        _vm.projeto = $$v
	      },
	      expression: "projeto"
	    }
	  }, [_c('template', {
	    slot: "noOptions"
	  }, [_c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("Nenhum registro localizado!")])])], 2), _vm._v(" "), (_vm.errors.first('projeto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Projeto deve ser selecionado')))]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.projetoEspecifico === 'SIM' && _vm.projeto.Numero_projeto) ? _c('legend', [_vm._v("\n                          O chamado é para um ID específico?\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.projetoEspecifico === 'SIM' && _vm.projeto.Numero_projeto) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12 form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tarefaSN')
	    }
	  }, [_c('span', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefaEspecifica),
	      expression: "tarefaEspecifica"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tarefaSN",
	      "value": "SIM"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefaEspecifica, "SIM")
	    },
	    on: {
	      "change": function($event) {
	        _vm.tarefaEspecifica = "SIM"
	      }
	    }
	  }), _vm._v(" Sim "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "7px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tarefaEspecifica),
	      expression: "tarefaEspecifica"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tarefaSN",
	      "value": "NAO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.tarefaEspecifica, "NAO")
	    },
	    on: {
	      "change": function($event) {
	        _vm.tarefaEspecifica = "NAO"
	      }
	    }
	  }), _vm._v(" Não "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.errors.first('tarefaSN')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo acima deve ser marcado com Sim ou Não')))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.projetoEspecifico === 'SIM' && _vm.tarefaEspecifica === 'SIM') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('tarefa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2 tl",
	    attrs: {
	      "for": "tarefa"
	    }
	  }, [_vm._v("ID:")]), _vm._v(" "), (_vm.loading.ids) ? _c('div', {
	    staticClass: "col-md-10"
	  }, [_vm._m(2)]) : _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        required: _vm.tarefaEspecifica === 'SIM'
	      }),
	      expression: "{required: tarefaEspecifica === 'SIM'}"
	    }],
	    attrs: {
	      "options": _vm.tarefas,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um ID",
	      "preselect-first": false,
	      "custom-label": _vm.etiquetaTarefas,
	      "selectLabel": "",
	      "label": "id",
	      "track-by": "id",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "tarefa",
	      "data-vv-as": "Tarefa",
	      "disabled": false
	    },
	    on: {
	      "select": function($event) {
	        return _vm.changeTarefa($event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [(props.option.projeto === 'Cabeçalho de tarefas') ? _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "etiquetaTarefa"
	        }, [_c('span', [_vm._v("ID")]), _c('span', [_vm._v("Tipo")]), _c('span', [_vm._v("Valor")])])]) : _c('div', {
	          staticClass: "col-md-12"
	        }, [_c('div', {
	          staticClass: "etiquetaTarefa"
	        }, [_c('span', [_c('strong', [_vm._v(_vm._s(props.option.id))])]), _c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(props.option.tipo_solicitacao))]), _c('span', [_vm._v(_vm._s(_vm._f("real")(props.option.valor)))])])])]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "etiquetaTarefa"
	        }, [_c('span', [_c('span', {
	          staticClass: "identificadorIDProjeto"
	        }, [_vm._v(_vm._s(props.option.id))]), _c('span', [_vm._v(_vm._s(props.option.tipo_solicitacao))])]), _c('span', [_vm._v(_vm._s(_vm._f("real")(props.option.valor)))])])]
	      }
	    }], null, false, 2318851965),
	    model: {
	      value: (_vm.tarefa),
	      callback: function($$v) {
	        _vm.tarefa = $$v
	      },
	      expression: "tarefa"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")]), _vm._v(" "), _c('template', {
	    slot: "noOptions"
	  }, [_c('span', {
	    staticClass: "text-red"
	  }, [_vm._v("Não há solicitações para selecionado")])])], 2), _vm._v(" "), (_vm.errors.first('tarefa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo ID deve ser selecionado')))]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('assunto')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2 tl",
	    attrs: {
	      "for": "assunto"
	    }
	  }, [_vm._v("Assunto:")]), _vm._v(" "), (_vm.loading.assuntos) ? _c('div', {
	    staticClass: "col-md-10"
	  }, [_vm._m(3)]) : _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaAssuntos,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "hide-selected": false,
	      "preserve-search": true,
	      "placeholder": "Selecione um assunto",
	      "custom-label": _vm.etiquetaAssuntos,
	      "preselect-first": false,
	      "selectLabel": "",
	      "label": "id",
	      "track-by": "id",
	      "deselectLabel": "",
	      "selectedLabel": "Selecionado",
	      "name": "assunto",
	      "data-vv-as": "assunto",
	      "disabled": false
	    },
	    on: {
	      "select": function($event) {
	        return _vm.changeAssunto($event)
	      }
	    },
	    model: {
	      value: (_vm.assunto),
	      callback: function($$v) {
	        _vm.assunto = $$v
	      },
	      expression: "assunto"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "noOptions"
	    },
	    slot: "noOptions"
	  }, [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('assunto')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Assunto é obrigatório')))]) : _vm._e()], 1)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6",
	    attrs: {
	      "id": "chamado2"
	    }
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('descricao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Descrição do problema ou dúvida:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.chamadoObj.descricao),
	      expression: "chamadoObj.descricao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "height": "175px",
	      "resize": "none",
	      "border": "1px solid #a8a3a5"
	    },
	    attrs: {
	      "name": "descricao",
	      "placeholder": _vm.place
	    },
	    domProps: {
	      "value": (_vm.chamadoObj.descricao)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.chamadoObj, "descricao", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('descricao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(('O campo Descrição é obrigatório')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "large-12 medium-12 small-12 cell"
	  }, [_vm._m(4), _vm._v(" "), _c('upload-documentos-chamado', {
	    attrs: {
	      "propDocumentos": _vm.chamadoObj.anexos
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('g-button-ujarak', {
	    attrs: {
	      "color": "error",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'cadastro-chamado-lista'
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-ban",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar")]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvaChamado()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Enviar")])], 1)])])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Abrir Chamado")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando projetos...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando solicitações...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando assuntos ...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Anexo")])])
	}]}

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showgrid),
	      expression: "showgrid"
	    }]
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-show": "$ctrl.isNewAvaiable()"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "tooltip": "Adiciona um público alvo",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showgrid = !_vm.showgrid
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Atividade")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table b-table table-hover table-bordered b-table-stacked-md",
	    attrs: {
	      "role": "table",
	      "aria-busy": "false",
	      "aria-colcount": "7",
	      "aria-rowcount": "-1"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
	    attrs: {
	      "role": "rowgroup"
	    }
	  }, [_vm._l((_vm.propsObjetivos), function(objetivo, objetivoIndex) {
	    return [_vm._l((objetivo.goals), function(meta, metaIndex) {
	      return _vm._l((meta.activities), function(atividade, atividadeIndex) {
	        return _c('tr', {
	          attrs: {
	            "role": "row"
	          }
	        }, [_c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "aria-colindex": "1",
	            "data-label": "Meta",
	            "role": "cell"
	          }
	        }, [_c('div', [_vm._v("\n                      " + _vm._s(meta.description) + "\n                    ")])]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "aria-colindex": "2",
	            "data-label": "Nome da atividade",
	            "role": "cell"
	          }
	        }, [_c('div', [_vm._v("\n                      " + _vm._s(atividade.name) + "\n                    ")])]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "aria-colindex": "3",
	            "data-label": "Documento comprobatório",
	            "role": "cell"
	          }
	        }, [_c('div', [_vm._v("\n                      " + _vm._s(atividade.supportingDocument) + "\n                    ")])]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "aria-colindex": "4",
	            "data-label": "Início",
	            "role": "cell"
	          }
	        }, [_c('div', [_vm._v("\n                      " + _vm._s(atividade.startPeriod) + "\n                    ")])]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "aria-colindex": "5",
	            "data-label": "Fim",
	            "role": "cell"
	          }
	        }, [_c('div', [_vm._v("\n                      " + _vm._s(atividade.finalPeriod) + "\n                    ")])]), _vm._v(" "), _c('td', {
	          staticClass: "text-center",
	          attrs: {
	            "aria-colindex": "6",
	            "data-label": "Ações",
	            "role": "cell"
	          }
	        }, [_c('div', [_c('button', {
	          staticClass: "btn btn-primary btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.edita(atividade, meta)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]), _vm._v(" "), _c('button', {
	          staticClass: "btn btn-danger btn-sm btn-flat",
	          attrs: {
	            "type": "button",
	            "disabled": false
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.exclui(meta, atividadeIndex)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Excluir")])])])])
	      })
	    })]
	  })], 2)])])])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
	    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('meta')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "objective"
	    }
	  }, [_vm._v("Metas:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.meta),
	      expression: "meta"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "meta"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.meta = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.metas), function(meta, index) {
	    return _c('option', {
	      domProps: {
	        "value": meta
	      }
	    }, [_vm._v(_vm._s(meta.description))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('meta')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('meta')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('nome da atividade')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "description"
	    }
	  }, [_vm._v("Nome da atividade: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.atividadeForm.name),
	      expression: "atividadeForm.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome da atividade",
	      "id": "proposal-activity-name",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.atividadeForm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.atividadeForm, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome da atividade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da atividade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Documento comprobatório')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "quantity"
	    }
	  }, [_vm._v("Documento comprobatório: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.atividadeForm.supportingDocument),
	      expression: "atividadeForm.supportingDocument"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Documento comprobatório",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.atividadeForm.supportingDocument)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.atividadeForm, "supportingDocument", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Documento comprobatório')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Documento comprobatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Período de início')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "measurementUnit"
	    }
	  }, [_vm._v("Período de início: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.atividadeForm.startPeriod),
	      expression: "atividadeForm.startPeriod"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:' + _vm.meses),
	      expression: "'required|min_value:1|max_value:' + meses"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "Período de início",
	      "type": "number",
	      "min": "1",
	      "ng-change": "addActivityCtrl.onChangePeriod(frmAddActivity.startPeriod, frmAddActivity.finalPeriod)"
	    },
	    domProps: {
	      "value": (_vm.atividadeForm.startPeriod)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.atividadeForm, "startPeriod", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Período de início')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Período de início')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field",
	    class: {
	      'has-error': _vm.errors.first('Período de fim')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-4",
	    attrs: {
	      "for": "duration"
	    }
	  }, [_vm._v("Período de fim: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "approval": "addGoalCtrl.approval",
	      "state": "addGoalCtrl.approvalState"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.atividadeForm.finalPeriod),
	      expression: "atividadeForm.finalPeriod"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1|max_value:' + _vm.meses),
	      expression: "'required|min_value:1|max_value:' + meses"
	    }],
	    staticClass: "form-control text-right",
	    attrs: {
	      "name": "Período de fim",
	      "type": "number",
	      "min": "1",
	      "ng-max": "addActivityCtrl.periods",
	      "ng-change": "addActivityCtrl.onChangePeriod(frmAddActivity.startPeriod, frmAddActivity.finalPeriod)"
	    },
	    domProps: {
	      "value": (_vm.atividadeForm.finalPeriod)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.atividadeForm, "finalPeriod", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Período de fim')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Período de fim')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-goal-add"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onAdd(_vm.meta, _vm.atividadeForm)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "id": "proposal-goal-cancel"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {}, [_c('tr', [_c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "1"
	    }
	  }, [_vm._v("Meta")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "2"
	    }
	  }, [_vm._v("Nome da atividade")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "3"
	    }
	  }, [_vm._v("Documento comprobatório")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "4"
	    }
	  }, [_vm._v("Início")]), _vm._v(" "), _c('th', {
	    staticClass: "sorting text-center",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "tabindex": "0",
	      "aria-colindex": "5"
	    }
	  }, [_vm._v("Fim")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "text-align": "center",
	      "width": "13%"
	    },
	    attrs: {
	      "aria-colindex": "6"
	    }
	  }, [_vm._v("Ações")])])])
	}]}

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "793px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope"
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.fase) + "   \n        "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }]
	  }, [_c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(219)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 219\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'S')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525A\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(525, 'N')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 525S\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
	    }],
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "href": "javascript:void(0)",
	      "title": '<h5>248 - Monitoramento Administrativo</h5>'
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.emitir(248)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" 248\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Validação',
	        href: '#'
	      }, {
	        text: 'Pagamento',
	        active: true
	      }]
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 form-horizontal"
	  }, [_c('div', {
	    staticClass: "ng-scope ng-isolate-scope"
	  }, [((_vm.historicoTarefasTela.length > 0 && _vm.historicoTarefasTela[1].observacao != null && _vm.historicoTarefasTela[1].observacao !== '')) ? _c('div', {
	    staticClass: "alert alert-dismissible alert-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.historicoTarefasTela[1].observacao)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Validação de Pagamento - "), _c('i', [_c('span', {
	    staticStyle: {
	      "color": "black"
	    }
	  }, [_vm._v(" ID: " + _vm._s(_vm.validacao.id) + " - Projeto: ")]), _c('span', {
	    staticStyle: {
	      "color": "black"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "ng-if": "$ctrl.approvalState != 'DEFAULT'"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "name": "frmSearch",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group required"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Objetivo Geral: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.proposta.ds_objetivo_geral))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(_vm.validacao.situacao))])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "disabled": _vm.fase === 'Autorização'
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "switch",
	      rawName: "v-switch",
	      value: (_vm.validacao.nome),
	      expression: "validacao.nome"
	    }]
	  }, [('Pagamento') ? _c('div', [_c('cronograma-solicitacao-pagamento', {
	    key: _vm.componentKey,
	    ref: "tabelaCronograma",
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsProjeto": _vm.projeto,
	      "propsEtapa": _vm.etapa,
	      "propsValidacao": _vm.validacao
	    }
	  }), _vm._v(" "), _c('documento-fiscal', {
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsEtapa": _vm.etapa
	    }
	  }), _vm._v(" "), _c('forma-pagamento', {
	    key: _vm.force,
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsValidacao": _vm.validacao
	    }
	  }), _vm._v(" "), _c('fornecedor', {
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsValidacao": _vm.validacao
	    }
	  }), _vm._v(" "), (_vm.nota.forma_pagamento === 3 || _vm.nota.forma_pagamento === '3') ? _c('dados-bancarios', {
	    attrs: {
	      "propsNota": _vm.nota,
	      "propsValidacao": _vm.validacao
	    }
	  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos da Solicitação de " + _vm._s(_vm.validacao.nome))])]), _vm._v(" "), _c('upload-documentos-php', {
	    attrs: {
	      "propDocumentos": _vm.nota.documentos,
	      "documentTypes": '',
	      "disable": '',
	      "local-uso": 'TODOS'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(1), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
	    key: _vm.historicoBack.length,
	    attrs: {
	      "propsValidacao": _vm.validacao,
	      "propsHistorico": _vm.historicoBack
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.dataProcesso < '10/12/2020') ? _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderHistorico === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderHistorico = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataProcesso < '10/12/2020') ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(2), _vm._v(" "), _c('historico-antigo', {
	    key: _vm.historicoTarefas.length,
	    attrs: {
	      "propsValidacao": _vm.validacao,
	      "propsHistorico": _vm.historicoTarefas
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group full",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Opções para este documento:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: " new-control new-control-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nota.bypass),
	      expression: "nota.bypass"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "checkbox",
	      "false-value": '',
	      "true-value": 'BYPASS',
	      "name": "acao"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.nota.bypass) ? _vm._i(_vm.nota.bypass, null) > -1 : _vm._q(_vm.nota.bypass, 'BYPASS')
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.nota.bypass,
	          $$el = $event.target,
	          $$c = $$el.checked ? ('BYPASS') : ('');
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.nota, "bypass", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.nota, "bypass", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.nota, "bypass", $$c)
	        }
	      }, function($event) {
	        return _vm.atualizaOpcoes('BYPASS')
	      }]
	    }
	  }), _vm._v("Não integrar com Sapiens\n                          "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Análise deste documento para Pagamento/Ressarcimento")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group required full",
	    class: {
	      'has-error': _vm.errors.first('resultadoAprovacao')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "resultadoAprovacao"
	    }
	  }, [_vm._v("Decisão:")]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Aprovado",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Aprovado")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Aprovado")
	      }
	    }
	  }), _vm._v(" Aprovar\n                              documento\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Revisão",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Revisão")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Revisão")
	      }
	    }
	  }), _vm._v(" Encaminhar para\n                              revisão\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]), _vm._v(" "), (_vm.fase === 'Autorização') ? _c('label', {
	    staticClass: "radio-inline new-control new-control-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aprovacao.resultadoAprovacao),
	      expression: "aprovacao.resultadoAprovacao"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "resultadoAprovacao",
	      "value": "Retornar Análise",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Retornar Análise")
	    },
	    on: {
	      "click": function($event) {
	        _vm.showJustify = 'Retonar Análise'
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Retornar Análise")
	      }
	    }
	  }), _vm._v("\n                              Retornar para análise\n                              "), _c('div', {
	    staticClass: "new-control-indicator"
	  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('resultadoAprovacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultadoAprovacao')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão') ? _c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "motivo de devolucao"
	    }
	  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', [_c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.motivoDevolucao),
	      expression: "motivoDevolucao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "motivo de devolucao"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.motivoDevolucao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Limpar dados do motivo de devolução")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v("--------------------------------------------------------------------------")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ausência de documento - documento fiscal / holerite / ofício"
	    }
	  }, [_vm._v("Ausência de documento - documento fiscal / holerite / ofício")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ausência ou divergência de documentos de obra civil (termo de medição, contrato, ART ou RRT)"
	    }
	  }, [_vm._v("Ausência ou divergência de documentos de obra civil (termo de medição, contrato, ART ou RRT)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Ausência ou divergência do número do acordo BNDES "
	    }
	  }, [_vm._v("Ausência ou divergência do número do acordo BNDES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Cadastro desatualizado "
	    }
	  }, [_vm._v("Cadastro desatualizado")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Comprovante de pagamento ausente, divergente ou ilegível "
	    }
	  }, [_vm._v("Comprovante de pagamento ausente, divergente ou ilegível")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Dados bancários incorretos"
	    }
	  }, [_vm._v("Dados bancários incorretos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Dados do fornecedor incorretos"
	    }
	  }, [_vm._v("Dados do fornecedor incorretos")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Documento fiscal ilegível ou divergente"
	    }
	  }, [_vm._v("Documento fiscal ilegível ou divergente")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Existência de ocorrência impeditiva"
	    }
	  }, [_vm._v("Existência de ocorrência impeditiva")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Itens da nota fiscal divergentes do cronograma físico-financeiro"
	    }
	  }, [_vm._v("Itens da nota fiscal divergentes do cronograma físico-financeiro")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Pendência de prestação de contas"
	    }
	  }, [_vm._v("Pendência de prestação de contas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Recolhimento de tributos ausente ou divergente"
	    }
	  }, [_vm._v("Recolhimento de tributos ausente ou divergente")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "Outros"
	    }
	  }, [_vm._v("Outros")])])]), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Aprovado' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group full",
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observação"
	    }
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.validacao.glosa),
	      expression: "validacao.glosa"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observação",
	      "id": "obs",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.validacao.glosa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.validacao, "glosa", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão' || _vm.aprovacao.resultadoAprovacao === 'Retornar Análise' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group required-field full",
	    class: {
	      'has-error': _vm.errors.first('justificativa')
	    },
	    staticStyle: {
	      "margin-right": "0",
	      "margin-left": "0"
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justificativa"
	    }
	  }, [_vm._v("Motivo para revisão:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.validacao.glosa),
	      expression: "validacao.glosa"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "justificativa",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.validacao.glosa)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.validacao, "glosa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [(_vm.aprovacao.resultadoAprovacao || _vm.usuarioLogado.userType === 'ENTIDADE') ? _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.onSave($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir\n                          ")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.voltaPraSolicitacao($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à lista\n                          ")])], 1)])])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa fa-info"
	  }), _vm._v("   Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de solicitação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico Antigo")])])
	}]}

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('vue-headful', {
	    attrs: {
	      "title": _vm.titulo
	    }
	  }), _vm._v(" "), _c('div', {}, [_c('section', {
	    staticClass: "content-header "
	  }, [_c('h1', {
	    staticClass: "row-flex centered-start h1-container"
	  }, [_vm._v("Proposta\n          "), _vm._v(" "), (_vm.bloqueiaBotoes === false && _vm.travarEdicao === false && _vm.travaSessao === false) ? _c('span', [(_vm.mostrarRef('botao_concluir') && this.$router.currentRoute.name === 'proposta-edita') ? _c('g-button-moema', {
	    attrs: {
	      "color": "success",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.confirmaConclusao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('botao_salvar') && this.$router.currentRoute.name === 'proposta-edita') ? _c('g-button-moema', {
	    attrs: {
	      "color": "primary",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.confirmaSalvamento()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), ((_vm.proposta.ds_fase === 'ANALISE' || _vm.proposta.ds_fase === 'CADASTRO') &&
	    this.$router.currentRoute.name === 'proposta-edita' &&
	    _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "onclick": "alertaCancelamentoDialog.showModal()",
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar Proposta\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('botao_voltar') && this.$router.currentRoute.name === 'proposta-visualiza' && this.$route.params.aprovAnt) ? _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'validacao-inicial',
	          params: {
	            id: _vm.$route.params.aprovAnt
	          }
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('botao_voltar') && this.$router.currentRoute.name === 'proposta-visualiza' && this.$route.params.aprovAnt2) ? _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'validacao-entidades',
	          params: {
	            id: _vm.$route.params.aprovAnt2
	          }
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('botao_voltar') && this.$router.currentRoute.name === 'proposta-edita' || (this.$router.currentRoute.name === 'proposta-visualiza' && this.$route.params.aprovAnt === undefined && this.$route.params.aprovAnt2 === undefined)) ? _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('NavegadorProposta', {
	    staticClass: "navegador-proposta-container",
	    attrs: {
	      "ids": _vm.idsNavegador,
	      "offset": "300"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.proposta.ds_fase === 'DEFERIMENTO' || _vm.proposta.ds_fase === 'APROVACAO_PROJETO') ? _c('span', [_c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none",
	      "height": "34px",
	      "margin-top": "3px",
	      "padding-top": "8px",
	      "margin-left": "30px"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-analise',
	        params: {
	          id: this.$route.params.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v(" Relatório de Análise")]), _vm._v(" "), (_vm.proposta.fep) ? _c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none",
	      "height": "34px",
	      "margin-top": "3px",
	      "padding-top": "8px"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-fep',
	        params: {
	          id: this.$route.params.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  FEP nº " + _vm._s(_vm.proposta.fep.ano) + " / " + _vm._s(_vm.proposta.fep.numero))]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary btn-sm btn-flat",
	    staticStyle: {
	      "text-decoration": "none",
	      "height": "34px",
	      "margin-top": "3px",
	      "padding-top": "8px"
	    },
	    attrs: {
	      "to": {
	        name: 'relatorio-rating',
	        params: {
	          id: this.$route.params.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v("  Rating da Entidade")])], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.travarEdicao) ? _c('span', [_vm._v(" A edição da proposta neste edital está desabilitada. ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.progressBar.stepTotal) && _vm.finalizou === false) ? _c('b-progress', {
	    staticClass: "w-50 mb-2",
	    attrs: {
	      "max": _vm.progressBar.stepTotal
	    }
	  }, [_c('b-progress-bar', {
	    attrs: {
	      "value": _vm.progressBar.stepAtual
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.progressBar.tarefaAtual) + " :   "), _c('strong', [_vm._v(_vm._s(_vm.progressBar.stepAtual) + " / " + _vm._s(_vm.progressBar.stepTotal))])])], 1) : _vm._e(), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": [{
	        text: 'Inicial',
	        href: '/'
	      }, {
	        text: 'Proposta',
	        href: '#'
	      }, {
	        text: 'Edita',
	        active: true
	      }]
	    }
	  }), _vm._v(" "), (_vm.travaSessao) ? _c('div', {
	    staticClass: "row-flex centered-start trava-sessao-container"
	  }, [_c('i', {
	    staticClass: "fa fa-warning",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          ATENÇÃO: PROPOSTA EM "), _c('b', [_vm._v("VISUALIZAÇÃO")]), _vm._v(" - "), _c('b', [_vm._v("NÃO")]), _vm._v(" será possível salvar ou concluir.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('section', {
	    staticClass: "gerenciador-edicao-container"
	  }, [(_vm.verificaSessao) ? _c('GerenciadorEdicaoProposta', {
	    ref: "gerenciadorEdicao",
	    attrs: {
	      "numeroProposta": this.$route.params.id
	    },
	    on: {
	      "sessaoVerificada": function($event) {
	        return _vm.sessaoVerificada($event)
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.carregaProposta) ? _c('section', {
	    staticClass: "content"
	  }, [_c('br'), _vm._v(" "), (_vm.proposta.ds_fase === 'REVISAO' && !_vm._.isUndefined(_vm.historico_atualizado) && _vm.historico_atualizado.length > 1 && _vm.historico_atualizado[1].observacao !== null) ? _c('div', {
	    staticClass: "alert alert-dismissible alert-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.historico_atualizado[1].observacao)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    ref: "topo"
	  }, [(((!_vm._.isEmpty(_vm.restricoesAtivasProjetosDaEntidade) || !_vm._.isEmpty(_vm.restricoesAtivasEntidade)) && _vm.usuarioLogado.userType === 'FUNDACAO')) ? _c('div', {
	    staticClass: "alert alert-warning",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((this.restricoesAtivasEntidade), function(restricaoEntidade) {
	    return _c('p', [_vm._v("\n                  " + _vm._s(restricaoEntidade.codoco) + " - " + _vm._s(restricaoEntidade.desroc) + "\n                ")])
	  }), _vm._v(" "), _vm._l((this.restricoesAtivasProjetosDaEntidade), function(restricaoProjeto) {
	    return _c('p', [_vm._v("\n                  " + _vm._s(restricaoProjeto.codoco) + " - " + _vm._s(restricaoProjeto.desroc) + "\n                ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.proposta, 'rating.consultas.PEP', 0) > 0 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show.info = false
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("Indicou no Rating da Entidade que há " + _vm._s(_vm.proposta.rating.consultas.PEP) + " " + _vm._s(_vm.proposta.rating.consultas.PEP > 1 ? 'Pessoas Expostas' : 'Pessoa Exposta') + " Politicamente (PEP), então deve encaminhar o deferimento para o C.E.")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.proposta.ds_fase !== 'REVISAO' && _vm.proposta.ds_fase !== 'CADASTRO') ? _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconder === false) ? _c('a', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconder = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar a proposta "), _c('b', [(_vm.proposta.ds_codigo_projeto_erp) ? _c('span', [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - ")]) : _vm._e(), _vm._v(_vm._s(_vm.proposta.ds_nome))])]) : _vm._e(), _vm._v(" "), (_vm.esconder === true) ? _c('a', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconder = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar a proposta "), _c('b', [(_vm.proposta.ds_codigo_projeto_erp) ? _c('span', [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - ")]) : _vm._e(), _vm._v(_vm._s(_vm.proposta.ds_nome))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('fieldset', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.esconder === true || _vm.proposta.ds_fase === 'REVISAO' || _vm.proposta.ds_fase === 'REVISAO'),
	      expression: "esconder === true || proposta.ds_fase === 'REVISAO' || proposta.ds_fase === 'REVISAO'"
	    }],
	    attrs: {
	      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || (_vm._.includes(['DEFERIMENTO', 'FORMALIZACAO', 'APROVACAO_PROJETO'], _vm.proposta.ds_fase)) || _vm.proposta.ds_fase === 'FORMALIZACAO'
	    }
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "inicio"
	    }
	  }, [_c('div', {
	    staticClass: "form-group required-field required",
	    class: {
	      'has-error': _vm.errors.first('nome')
	    }
	  }, [_c('div', [
	    [_c('div', {
	      staticStyle: {
	        "text-align": "right"
	      },
	      attrs: {
	        "id": "contador"
	      }
	    }, [_c('label', {
	      staticClass: "control-label"
	    }, [_vm._v(" Tempo que falta para encerramento do edital: ")]), _vm._v(" "), _c('CountdownTimer', {
	      attrs: {
	        "endDate": new Date(_vm.dataHoraEncerramentoEdital)
	      }
	    })], 1)]
	  ], 2), _vm._v(" "), (_vm.mostrarRef('projeto_numero')) ? _c('div', [_c('div', [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nº do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposta.ds_codigo_projeto_erp"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_codigo_projeto_erp),
	      expression: "proposta.ds_codigo_projeto_erp"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": true,
	      "name": "idProjectErp",
	      "type": "number",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_codigo_projeto_erp)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_codigo_projeto_erp", $event.target.value)
	      }
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_nome')) ? _c('div', [_c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.name"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_nome),
	      expression: "proposta.ds_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:150'),
	      expression: "'required|max:150'"
	    }],
	    staticClass: "form-control col",
	    attrs: {
	      "name": "nome",
	      "data-vv-as": "Nome da Proposta",
	      "type": "text",
	      "maxlength": "150"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_nome)
	    },
	    on: {
	      "keypress": _vm.retiraAspas,
	      "paste": function($event) {
	        $event.preventDefault();
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.mostrarRef('coordenador') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), (_vm.mostrarRef('coordenador_nome')) ? _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('nome do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorName"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_nome_coordenador),
	      expression: "proposta.ds_nome_coordenador"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nome do coordenador",
	      "type": "text",
	      "data-vv-as": "Nome do Coordenador",
	      "maxlength": "100",
	      "data-cy": "nome_do_coordenador"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_nome_coordenador)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_nome_coordenador", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_cpf')) ? _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('cpf do coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorCpf"
	    }
	  }, [(this.$router.currentRoute.name === 'proposta-visualiza') ? _c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "data-vv-as": "CPF do Coordenador",
	      "mask": '###.###.###-##',
	      "data-cy": "cpf_do_coordenador"
	    },
	    model: {
	      value: (_vm.proposta.ds_cpf_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_cpf_coordenador", $$v)
	      },
	      expression: "proposta.ds_cpf_coordenador"
	    }
	  }) : _vm._e(), _vm._v(" "), (this.$router.currentRoute.name !== 'proposta-visualiza') ? _c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('cpf|required'),
	      expression: "'cpf|required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cpf do coordenador",
	      "type": "text",
	      "mask": '###.###.###-##',
	      "data-cy": "cpf_do_coordenador"
	    },
	    model: {
	      value: (_vm.proposta.ds_cpf_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_cpf_coordenador", $$v)
	      },
	      expression: "proposta.ds_cpf_coordenador"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_email')) ? _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('ds_email_coordenador')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorEmail"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_email_coordenador),
	      expression: "proposta.ds_email_coordenador"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email|max:255'),
	      expression: "'required|email|max:255'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "ds_email_coordenador",
	      "type": "email",
	      "data-vv-as": "E-mail do Coordenador",
	      "maxlength": "255",
	      "data-cy": "ds_email_coordenador"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_email_coordenador)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_email_coordenador", $event.target.value)
	      }, function($event) {
	        _vm.proposta.ds_email_coordenador = $event.target.value.toLowerCase()
	      }]
	    }
	  })]), _vm._v(" "), (_vm.errors.first('ds_email_coordenador')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('ds_email_coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_telefone')) ? _c('div', {
	    staticClass: "form-group col-md-12 required-field",
	    class: {
	      'has-error': _vm.errors.first('Telefone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone",
	      "type": "tel",
	      "data-vv-as": "Telefone do Coordenador",
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "data-cy": "ds_telefone_coordenador"
	    },
	    model: {
	      value: (_vm.proposta.ds_telefone_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_telefone_coordenador", $$v)
	      },
	      expression: "proposta.ds_telefone_coordenador"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_celular')) ? _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.coordinatorPhone"
	    }
	  }, [_c('the-mask', {
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Celular",
	      "type": "tel",
	      "data-vv-as": "Celular do Coordenador",
	      "mask": ['(##) ####-####', '(##) #####-####'],
	      "data-cy": "ds_celular_coordenador"
	    },
	    model: {
	      value: (_vm.proposta.ds_celular_coordenador),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_celular_coordenador", $$v)
	      },
	      expression: "proposta.ds_celular_coordenador"
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('legend', [_vm._v("Período de execução do projeto")]), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', [(_vm.mostrarRef('projeto_data_inicial')) ? _c('div', {
	    staticClass: " col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Data Inicial')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data prevista para início")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.initialDate"
	    }
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "Data Inicial",
	      "input-class": "form-control datepicker",
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": false,
	      "placeholder": "__ /__ /____",
	      "data-vv-as": "Data Inicial",
	      "format": "dd/MM/yyyy",
	      "data-cy": "dt_data_inicial"
	    },
	    model: {
	      value: (_vm.proposta.dt_data_inicial),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "dt_data_inicial", $$v)
	      },
	      expression: "proposta.dt_data_inicial"
	    }
	  })], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('periodo')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.periods"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.nr_periodos),
	      expression: "proposta.nr_periodos"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:1'),
	      expression: "'required|min_value:1'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Número de Meses do Projeto",
	      "lang": "pt-br",
	      "name": "periodo",
	      "type": "number",
	      "min": "1",
	      "data-cy": "nr_periodos"
	    },
	    domProps: {
	      "value": (_vm.proposta.nr_periodos)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "nr_periodos", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group required-field col-md-12 required"
	  }, [_c('div', {
	    staticClass: " col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('periodoVigencia')
	    },
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Período de vigência ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {}, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.periodo_vigencia),
	      expression: "proposta.periodo_vigencia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min_value:' + _vm.proposta.nr_periodos),
	      expression: "'required|min_value:' + proposta.nr_periodos"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "data-vv-as": "Período Vigência",
	      "lang": "pt-br",
	      "name": "periodoVigencia",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.proposta.periodo_vigencia)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.datas()
	      },
	      "keyup": function($event) {
	        return _vm.datas()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), (_vm.errors.first('periodoVigencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodoVigencia')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "form-group required-field col-md-12 required"
	  }, [_c('div', {
	    staticClass: " col-md-12 required",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Data de Vigência do Projeto ")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('dd', {}, [_vm._v(_vm._s(_vm.dataVigencia))])])]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodos') && _vm.mostrarRef('projeto_data_inicial')) ? _c('dl', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "margin-left": "-15px"
	    }
	  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {}, [_vm._v(_vm._s(_vm.dataFinal))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box box-widget",
	    attrs: {
	      "id": "dadosEntidade"
	    }
	  }, [_c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderEntidade === false) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderEntidade = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar dados da Entidade - "), _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]) : _vm._e(), _vm._v(" "), (_vm.esconderEntidade === true) ? _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderEntidade = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar dados da Entidade - "), _c('span', {
	    staticStyle: {
	      "color": "steelblue",
	      "font-weight": "bold"
	    }
	  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]) : _vm._e()]), _vm._v(" "), (_vm.esconderEntidade === true) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('legend', [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
	    staticClass: "proposal-definition-list"
	  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {}, [_c('router-link', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        placement: 'right',
	        animation: 'perspective',
	        distance: '1',
	        size: 'large',
	        arrow: true
	      }),
	      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
	    }],
	    attrs: {
	      "title": '<h5>Ir para o Cadastro da entidade</h5>',
	      "to": {
	        name: 'cadastro-entidade-visualiza',
	        params: {
	          id: _vm.proposta.entidade.id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.proposta.entidade.ds_nome) + "  "), _c('i', {
	    staticClass: "fa fa-external-link"
	  })])], 1), _vm._v(" "), _c('dt', [_vm._v("CNPJ")]), _vm._v(" "), _c('dd', [_vm._v("\n                                " + _vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)) + "\n                              ")]), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {}, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), (_vm.proposta.entidade.endereco[0]) ? _c('dd', {}, [_vm._v(_vm._s(_vm.proposta.entidade.endereco[0].ds_rua) + ", " + _vm._s(_vm.proposta.entidade.endereco[0].ds_numero) + " -\n                                " + _vm._s(_vm.proposta.entidade.endereco[0].ds_bairro) + ", " + _vm._s(_vm.proposta.entidade.endereco[0].ds_cidade) + " - " + _vm._s(_vm.proposta.entidade.endereco[0].ds_estado) + "\n                              ")]) : _vm._e(), _vm._v(" "), _c('dt', [_vm._v("Telefone")]), _vm._v(" "), _c('dd', {
	    attrs: {
	      "id": "phone"
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm.telefone) + "\n                              ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "informacoesProjeto"
	    }
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.mostrarRef('informacoes_introdutorias_introducao') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
	    staticClass: "form-group required-field required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('introducao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label ",
	    attrs: {
	      "for": "introduction"
	    }
	  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {}, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": _vm.ehEdital ? '' : 'Nenhum texto informativo...',
	      "min-height": 200,
	      "autosize": true,
	      "name": "introducao",
	      "data-vv-as": "Informações Introdutórias do Projeto",
	      "rows": "4",
	      "data-cy": "ds_introducao"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.onBlurTextarea($event)
	      }
	    },
	    model: {
	      value: (_vm.proposta.ds_introducao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_introducao", $$v)
	      },
	      expression: "proposta.ds_introducao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('introducao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('introducao')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_apresentacao')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('apresentacao')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "presentation"
	    }
	  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.presentation"
	    }
	  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4",
	      "min-height": 200,
	      "autosize": true,
	      "data-cy": "ds_apresentacao",
	      "data-vv-as": "Apresentação do Projeto"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_apresentacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_apresentacao", $$v)
	      },
	      expression: "proposta.ds_apresentacao"
	    }
	  }) : _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "apresentacao",
	      "rows": "4",
	      "min-height": 200,
	      "autosize": true,
	      "data-cy": "ds_apresentacao",
	      "data-vv-as": "Apresentação do Projeto",
	      "placeholder": "Descreva aqui histórico, capacidade técnica e experiências da sua organização. Utilize os tópicos abaixo para orientar seu texto:\n- Por que sua organização foi criada. Qual o seu propósito?\n- Quais são as principais atividades desenvolvidas pela sua instituição?\n- A sua organização possui experiência acumulada no mesmo tema da atual proposta? Cite os projetos mais importantes, descrevendo os resultados alcançados, perfil e número de participantes atendidos.\n- Qual a infraestrutura disponível para a sua organização? Existem planos para expansão?\n- Quais são seus principais parceiros e apoiadores?\n- Como sua organização garante a continuidade de suas ações?\n- A sua entidade possui uma estratégia de captação de recursos?\n- A sua instituição possui associados ou cooperados? Cite quantidade e perfil.\n- Como funciona a interação da organização com a comunidade?\n- A comunidade participa dos processos de tomada de decisão da sua organização?"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_apresentacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_apresentacao", $$v)
	      },
	      expression: "proposta.ds_apresentacao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('apresentacao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('apresentacao')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_territorio')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('territorio')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "territory"
	    }
	  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.territory"
	    }
	  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Território de Desenvolvimento do Projeto",
	      "name": "territorio",
	      "rows": "4",
	      "data-cy": "ds_territorio"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.onBlurTextarea($event)
	      }
	    },
	    model: {
	      value: (_vm.proposta.ds_territorio),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_territorio", $$v)
	      },
	      expression: "proposta.ds_territorio"
	    }
	  }) : _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Território de Desenvolvimento do Projeto",
	      "name": "territorio",
	      "rows": "4",
	      "data-cy": "ds_territorio",
	      "placeholder": "Descreva aqui o contexto local, considerando aspectos sociais, econômicos e ambientais do município e da comunidade a ser assistida. Utilize os tópicos abaixo para orientar seu texto:\n- Quais as características socioeconômicas, ambientais e culturais da região?\n- Além dos beneficiários e da sua organização, quem são os demais interessados pelo projeto?\n- Quais são os equipamentos sociais* e serviços públicos que estão disponíveis para a comunidade local?\n- Como é a relação da instituição e da comunidade com o poder público local?\n- De que maneira a realidade local se relaciona ao projeto proposto?\n- De que maneira a realidade local pode ser uma barreira para o desenvolvimento do projeto?\n\n*São equipamento sociais: postos de saúde, creches, pré-escolas, centros comunitários, etc."
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.onBlurTextarea($event)
	      }
	    },
	    model: {
	      value: (_vm.proposta.ds_territorio),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_territorio", $$v)
	      },
	      expression: "proposta.ds_territorio"
	    }
	  }), _vm._v(" "), (_vm.errors.first('territorio')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('territorio')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_justificativa')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12  required",
	    class: {
	      'has-error': _vm.errors.first('propostaJustificativa')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "justification"
	    }
	  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.justification"
	    }
	  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Justificativa do Projeto",
	      "name": "propostaJustificativa",
	      "rows": "4",
	      "data-cy": "ds_justificativa"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.onBlurTextarea($event)
	      }
	    },
	    model: {
	      value: (_vm.proposta.ds_justificativa),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_justificativa", $$v)
	      },
	      expression: "proposta.ds_justificativa"
	    }
	  }) : _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Justificativa do Projeto",
	      "name": "propostaJustificativa",
	      "rows": "4",
	      "data-cy": "ds_justificativa"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.onBlurTextarea($event)
	      }
	    },
	    model: {
	      value: (_vm.proposta.ds_justificativa),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_justificativa", $$v)
	      },
	      expression: "proposta.ds_justificativa"
	    }
	  }, [_vm._v("\n                                              placeholder=\"Descreva aqui o problema que a sua organização quer solucionar. Utilize os tópicos abaixo para orientar seu texto:\n- Qual é a situação-problema a ser solucionado?\n- Quais as suas origens?\n- Quais os fatores sociais, políticos, ambientais e culturais que o agravam?\n- Quais são as consequências desse problema para a região e para o público alvo da proposta?\">\n                                    ")]), _vm._v(" "), (_vm.errors.first('propostaJustificativa')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('propostaJustificativa')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_objetivo_geral')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12  required",
	    class: {
	      'has-error': _vm.errors.first('objetivo Geral')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "generalObjective"
	    }
	  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.generalObjective"
	    }
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Objetivo Geral do Projeto",
	      "name": "objetivo Geral",
	      "rows": "4",
	      "data-cy": "ds_objetivo_geral",
	      "placeholder": _vm.ehEdital ? '' : 'Defina de forma sucinta o que se pretende alcançar com o projeto. O objetivo geral deve refletir a transformação desejada pela sua organização, levando em consideração o problema apresentado e a solução proposta. Ele deve ser passível de ser alcançado por meio dos objetivos específicos e as atividades propostas. O objetivo deve ser iniciado com um verbo no infinitivo, exemplo: elevar, aprimorar, fortalecer, transformar, etc.'
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.onBlurTextarea($event)
	      }
	    },
	    model: {
	      value: (_vm.proposta.ds_objetivo_geral),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_objetivo_geral", $$v)
	      },
	      expression: "proposta.ds_objetivo_geral"
	    }
	  }), _vm._v(" "), (_vm.errors.first('objetivo Geral')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo Geral')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_resultados')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Resultados esperados')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "results"
	    }
	  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.results"
	    }
	  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Resultados Esperados do Projeto",
	      "name": "Resultados esperados",
	      "rows": "4",
	      "data-cy": "ds_resultados"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_resultados),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_resultados", $$v)
	      },
	      expression: "proposta.ds_resultados"
	    }
	  }) : _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Resultados Esperados do Projeto",
	      "name": "Resultados esperados",
	      "rows": "4",
	      "data-cy": "ds_resultados",
	      "placeholder": "Descreva quais os efeitos e reflexos esperados sobre o cotidiano da comunidade por meio da implantação do projeto proposto.\nOs resultados esperados devem ser coerentes com os objetivos propostos."
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_resultados),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_resultados", $$v)
	      },
	      expression: "proposta.ds_resultados"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_operacionalizacao') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Operacionalização')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "operation"
	    }
	  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.operation"
	    }
	  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Operacionalização do Projeto",
	      "name": "Operacionalização",
	      "rows": "4",
	      "data-cy": "ds_operacao"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_operacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_operacao", $$v)
	      },
	      expression: "proposta.ds_operacao"
	    }
	  }) : _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Operacionalização do Projeto",
	      "name": "Operacionalização",
	      "rows": "4",
	      "data-cy": "ds_operacao",
	      "placeholder": "Descreva aqui o que a sua organização apresenta como método para a execução das atividades. Utilize os tópicos abaixo para orientar seu texto:\n- Quais são as etapas, processos e rotinas previstas para o projeto?\n- O método já foi utilizado em outras situações?\n- Será utilizada alguma tecnologia social?\n- O método já foi sistematizado? Há previsão de sistematização (caso não haja processo sistematizado)?\n- Como será realizado o processo de seleção dos participantes?\n- Qual a estratégia para manutenção das ações do projeto após o fim da vigência do convênio com a FBB?"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_operacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_operacao", $$v)
	      },
	      expression: "proposta.ds_operacao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_parceria') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Parceria')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "partner"
	    }
	  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.partner"
	    }
	  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Parceria do Projeto",
	      "name": "Parceria",
	      "rows": "4",
	      "data-cy": "ds_parceria"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_parceria),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_parceria", $$v)
	      },
	      expression: "proposta.ds_parceria"
	    }
	  }) : _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "Parceria do Projeto",
	      "name": "Parceria",
	      "rows": "4",
	      "data-cy": "ds_parceria",
	      "placeholder": "Descreva aqui como a sua organização se relaciona com atores sociais da região. Utilize os tópicos abaixo para orientar o seu texto:\n- Como ocorrerá a participação da comunidade no projeto?\n- Como a comunidade contribuiu para identificação da demanda e elaboração da proposta?\n- Existe cooperação do governo, empresas ou outras fundações no projeto?\n- Existe envolvimento de outras organizações da sociedade civil, escolas ou universidades?\n- A sua instituição participa de alguma rede?\n- A sua instituição participa de conselho ou fórum de política pública relacionada ao tema da atual proposta?\n- A sua proposta interage com alguma política pública?"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_parceria),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_parceria", $$v)
	      },
	      expression: "proposta.ds_parceria"
	    }
	  }), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_resumo')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12  required",
	    class: {
	      'has-error': _vm.errors.first('sumario')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "summary"
	    }
	  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.summary"
	    }
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": _vm.ehEdital ? '' : 'Nenhum texto informativo...',
	      "data-vv-as": "Resumo do Projeto",
	      "name": "sumario",
	      "rows": "4",
	      "min-height": 200,
	      "autosize": true,
	      "data-cy": "ds_resumo"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_resumo),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_resumo", $$v)
	      },
	      expression: "proposta.ds_resumo"
	    }
	  }), _vm._v(" "), (_vm.errors.first('sumario')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('sumario')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_acoes') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group required-field col-md-12  required",
	    class: {
	      'has-error': _vm.errors.first('acoes')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "acoes"
	    }
	  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": _vm.ehEdital ? '' : 'Informe as acões de comunicação',
	      "min-height": 200,
	      "autosize": true,
	      "data-vv-as": "indicadores",
	      "name": "acoes",
	      "rows": "4",
	      "data-cy": "ds_acoes_comunicacao"
	    },
	    on: {
	      "input": _vm.resizable
	    },
	    model: {
	      value: (_vm.proposta.ds_acoes_comunicacao),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_acoes_comunicacao", $$v)
	      },
	      expression: "proposta.ds_acoes_comunicacao"
	    }
	  }), _vm._v(" "), (_vm.errors.first('acoes')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('acoes')))]) : _vm._e()], 1)])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "publicoAlvo"
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('publico-alvo', {
	    attrs: {
	      "propsPublicosGrid": _vm.proposta.publicos_alvo
	    },
	    on: {
	      "publicoAlvoAdicionado": function($event) {
	        _vm.proposta.publicos_alvo = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(6), _vm._v(" "), _c('publicoAlvoDescricaoProposta', {
	    ref: "publicoAlvoDescricao",
	    attrs: {
	      "proposta": this.$route.params.id,
	      "fixado": false,
	      "permiteEditar": true,
	      "abrirAbas": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "tecnologiaSocial"
	    }
	  }, [_vm._m(7), _vm._v(" "), _c('tecnologiaSocial', {
	    ref: "tecnologiaSocial",
	    attrs: {
	      "proposta": this.$route.params.id,
	      "fk_processo": _vm.proposta.fk_processo,
	      "telaProjeto": false
	    }
	  })], 1), _vm._v(" "), (_vm._.includes(['CADASTRO', 'REVISAO'], _vm.proposta.ds_fase)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(8), _vm._v(" "), _c('cadastroLicencas', {
	    ref: "licenciamentoAmbiental",
	    attrs: {
	      "idProposta": _vm.proposta.id,
	      "cadastroProposta": _vm._.includes(['CADASTRO', 'REVISAO'], _vm.proposta.ds_fase) ? true : false
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('equipe_do_projeto')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "equipeProjeto"
	    }
	  }, [_vm._m(9), _vm._v(" "), (_vm.entidadeEhFundacao) ? _c('span', {
	    staticClass: "col-md-12 entidadeEhFundacao"
	  }, [_vm._v("\n                          Dispensado registro pela proponente Fundação BB\n                        ")]) : _c('span', [_c('equipe-projeto', {
	    attrs: {
	      "propsEquipes": _vm.proposta.equipes
	    },
	    on: {
	      "equipeAdicionada": function($event) {
	        _vm.proposta.equipes = $event
	      }
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('entidade_executora_proponente')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "entidadeExecutora"
	    }
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.bt_entidade_executora),
	      expression: "proposta.bt_entidade_executora"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-true",
	      "value": "1",
	      "selected": "selected"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.bt_entidade_executora, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "bt_entidade_executora", "1")
	      }
	    }
	  }), _vm._v(" Sim\n                                  ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.bt_entidade_executora),
	      expression: "proposta.bt_entidade_executora"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "entityExecutingBool",
	      "id": "proposal-entity-executing-false",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.bt_entidade_executora, "0")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "bt_entidade_executora", "0")
	      }
	    }
	  }), _vm._v(" Não\n                                  ")])])]), _vm._v(" "), (_vm.proposta.bt_entidade_executora == 0) ? _c('div', [_c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field  col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Nome Entidade Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_entidade_nome),
	      expression: "proposta.ds_entidade_nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Nome Entidade Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_entidade_nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_entidade_nome", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Representante legal')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingProcurator"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_entidade_representante_legal),
	      expression: "proposta.ds_entidade_representante_legal"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_representante_legal'),
	      expression: "'required:!proposta.ds_entidade_representante_legal'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Representante legal",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_entidade_representante_legal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_entidade_representante_legal", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CNPJ entidade executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCNPJ"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_cnpj|cnpj'),
	      expression: "'required:!proposta.ds_entidade_cnpj|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CNPJ entidade executora",
	      "type": "text",
	      "mask": ['NN.NNN.NNN/NNNN-##'],
	      "tokens": _vm.$cnpjTokens
	    },
	    model: {
	      value: (_vm.proposta.ds_entidade_cnpj),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_entidade_cnpj", $$v)
	      },
	      expression: "proposta.ds_entidade_cnpj"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('E-mail executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingEmail"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.ds_entidade_email),
	      expression: "proposta.ds_entidade_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_email|email'),
	      expression: "'required:!proposta.ds_entidade_email|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "E-mail executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.ds_entidade_email)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "ds_entidade_email", $event.target.value)
	      }, function($event) {
	        _vm.proposta.ds_entidade_email = $event.target.value.toLowerCase()
	      }]
	    }
	  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingPhone"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_telefone'),
	      expression: "'required:!proposta.ds_entidade_telefone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone Executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.ds_entidade_telefone),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_entidade_telefone", $$v)
	      },
	      expression: "proposta.ds_entidade_telefone"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Telefone celular da executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingMobile"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.ds_entidade_celular'),
	      expression: "'required:!proposta.ds_entidade_celular'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Telefone celular da executora",
	      "type": "text",
	      "mask": ['(##) ####-####', '(##) #####-####']
	    },
	    model: {
	      value: (_vm.proposta.ds_entidade_celular),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "ds_entidade_celular", $$v)
	      },
	      expression: "proposta.ds_entidade_celular"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "col-md-4 col-sm-6 col-xs-12"
	  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('CEP da executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCEP"
	    }
	  }, [_c('the-mask', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "CEP da executora",
	      "type": "text",
	      "mask": ['#####-###']
	    },
	    model: {
	      value: (_vm.proposta.entityExecutingCEP),
	      callback: function($$v) {
	        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
	      },
	      expression: "proposta.entityExecutingCEP"
	    }
	  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('UF executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingState"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingState),
	      expression: "proposta.entityExecutingState"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "UF executora"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.estados), function(uf) {
	    return _c('option', {
	      domProps: {
	        "value": uf
	      }
	    }, [_vm._v(_vm._s(uf))])
	  }), 0)]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Cidade da Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingCity"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingCity),
	      expression: "proposta.entityExecutingCity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Cidade da Executora",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingCity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-group required-field col-md-12",
	    class: {
	      'has-error': _vm.errors.first('Endereço da Executora')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityExecutingAddress"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.entityExecutingAddress),
	      expression: "proposta.entityExecutingAddress"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required:!proposta.entityIsExecutioner'),
	      expression: "'required:!proposta.entityIsExecutioner'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Endereço da Executora",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.proposta.entityExecutingAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_de_duplicacao')) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "projetoDuplicacao"
	    }
	  }, [(_vm.$route.params.processo !== 'CADASTRO' && _vm.$route.params.processo !== 'SOLICITACAO' && _vm.$route.params.processo !== 'REVISAO') ? _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Projeto de duplicação")]), (_vm.$route.params.processo === 'ANALISE') ? _c('span', {
	    staticStyle: {
	      "color": "red",
	      "margin-left": "5px",
	      "font-size": "large",
	      "cursor": "pointer"
	    }
	  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.$route.params.processo !== 'CADASTRO' && _vm.$route.params.processo !== 'SOLICITACAO') ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12 required",
	    class: {
	      'has-error': _vm.errors.first('Projeto Duplicação')
	    }
	  }, [_c('div', {
	    attrs: {
	      "name": "proposal.duplicateProject"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.nr_projeto_duplicacao),
	      expression: "proposta.nr_projeto_duplicacao"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "Projeto Duplicação",
	      "aria-hidden": "true"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.proposta, "nr_projeto_duplicacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.duplicador]
	    }
	  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
	    return _c('option', {
	      domProps: {
	        "value": projeto.numprj
	      }
	    }, [_vm._v(_vm._s(projeto.numprj + ' / ' + projeto.nomprj))])
	  }), 0), _vm._v(" "), (_vm.projetoSuperior !== '') ? _c('div', [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Projeto Superior:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.projetoSuperior))])]) : _vm._e()])])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "edital"
	    }
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_vm._m(11), _vm._v(" "), (_vm._.has(_vm.proposta, 'fk_edital') & _vm.proposta.fk_edital !== null) ? _c('div', [_vm._v("\n                              " + _vm._s(_vm.proposta.fk_edital) + "-" + _vm._s(_vm.proposta.edital.ds_numero_edital) + "\n\n                              ")]) : _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-group row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Escolha o Edital a ser vinculado")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editalSelecionado),
	      expression: "editalSelecionado"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.editalSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Escolha o edital")]), _vm._v(" "), _vm._l((_vm.listaEditais), function(edital) {
	    return _c('option', {
	      domProps: {
	        "value": edital.id
	      }
	    }, [_vm._v(_vm._s(edital.ds_numero_edital))])
	  })], 2)]), _vm._v(" "), _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.editaEdital($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Confirmar")])], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('objetivo_especifico')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "objetivoEspecifico"
	    }
	  }, [_vm._m(12), _vm._v(" "), _c('objetivo-especifico', {
	    attrs: {
	      "editavel": true,
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsMetas": _vm.proposta.metas,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "objetivoAdicionado": function($event) {
	        _vm.proposta.objetivos = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('metas')) ? _c('div', {
	    ref: "tabelaMetas",
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "metas"
	    }
	  }, [_vm._m(13), _vm._v(" "), _c('metas', {
	    attrs: {
	      "editavel": true,
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsMetas": _vm.proposta.metas,
	      "propsAtividades": _vm.proposta.atividades,
	      "propsProposta": _vm.proposta,
	      "atvSemMetas": _vm.atvSemMetas
	    },
	    on: {
	      "metaAdicionada": function($event) {
	        _vm.proposta.metas = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('atividades')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "atividades"
	    }
	  }, [_vm._m(14), _vm._v(" "), _c('atividades', {
	    attrs: {
	      "editavel": true,
	      "meses": _vm.proposta.nr_periodos,
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsMetas": _vm.proposta.metas,
	      "propsAtividades": _vm.proposta.atividades,
	      "propsProposta": _vm.proposta
	    },
	    on: {
	      "atividadeAdicionada": function($event) {
	        _vm.proposta.atividades = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "cronograma"
	    }
	  }, [_vm._m(15), _vm._v(" "), (!_vm.previewCotacao && !_vm.ehExcecao) ? _c('cronograma', {
	    key: _vm.componentKey,
	    attrs: {
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsAtividades": _vm.proposta.atividades,
	      "metas": _vm.proposta.metas,
	      "proposta": _vm.proposta,
	      "meses": _vm.proposta.nr_periodos,
	      "projetoDuplicacao": _vm.proposta.nr_projeto_duplicacao,
	      "propostaSimplificada": _vm.propostaSimplificada
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.atividades = $event
	      },
	      "validacaoCronograma": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.ehExcecao) ? _c('cronogramaCotacao', {
	    key: _vm.componentKey,
	    ref: "cronogramaCotacao",
	    attrs: {
	      "propsObjetivos": _vm.proposta.objetivos,
	      "propsAtividades": _vm.proposta.atividades,
	      "metas": _vm.proposta.metas,
	      "proposta": _vm.proposta,
	      "meses": _vm.proposta.nr_periodos,
	      "projetoDuplicacao": _vm.proposta.nr_projeto_duplicacao
	    },
	    on: {
	      "itemAdicionado": function($event) {
	        _vm.proposta.atividades = $event
	      },
	      "validacaoCronograma": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.mostrarRef('gantt')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('visualiza-gantt', {
	    attrs: {
	      "numeroProjeto": null,
	      "propsProposta": _vm.proposta,
	      "tipoBarra": 'financeiro',
	      "mostrarExecFinanc": true,
	      "mostrarExecDeclarada": false
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.possuiAdiandamento && _vm.proposta.adiantamentos.length <= 0) ? _c('div', {
	    staticClass: "row-flex centered-start parcela-erro",
	    attrs: {
	      "id": "parcelaAdiantamento"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Atenção. Itens adiantáveis sem parcela de adiantamento cadastrada.\n                      ")]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.proposta.atividades, function(atv) {
	    return _vm._.find(_vm._.get(atv, 'itens_orcamentos', []), function(ite) {
	      return ('' + ite.adiantavel) === '1'
	    })
	  })) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._m(16), _vm._v(" "), _c('parcela-adiantamento', {
	    attrs: {
	      "editavel": true,
	      "propsParcelas": _vm.proposta.adiantamentos,
	      "propsAtividades": _vm.proposta.atividades
	    },
	    on: {
	      "parcelaAdicionada": function($event) {
	        _vm.proposta.adiantamentos = $event
	      },
	      "validacaoParcelasAdiantamento": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.proposta.ds_fase === 'CADASTRO') ? _c('div', {
	    staticClass: "col-md-4 col-sm-6",
	    class: {
	      'has-error': _vm.errors.first('abrangencia')
	    },
	    attrs: {
	      "id": "abrangenciaNacional"
	    }
	  }, [_c('div', [_c('fieldset', {
	    staticClass: "col-md-12"
	  }, [_c('legend', [_vm._v("O projeto é de Abrangência Nacional?")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "name": "proposal.entityIsExecutioner"
	    }
	  }, [_c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.bt_fep_abrangencia),
	      expression: "proposta.bt_fep_abrangencia"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "abrangencia",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.bt_fep_abrangencia, "1")
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.proposta, "bt_fep_abrangencia", "1")
	      }, function($event) {
	        return _vm.verificaAbrangenciaNacional()
	      }]
	    }
	  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
	    staticClass: "radio-inline control-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.proposta.bt_fep_abrangencia),
	      expression: "proposta.bt_fep_abrangencia"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "abrangencia",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.proposta.bt_fep_abrangencia, "0")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.proposta, "bt_fep_abrangencia", "0")
	      }
	    }
	  }), _vm._v(" Não\n                                ")])])])]), _vm._v(" "), (_vm.errors.first('abrangencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" " + _vm._s(_vm.errors.first('abrangencia')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('municipios')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "municipiosExecucao"
	    }
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('municipalizacao', {
	    ref: "municipalizacao",
	    attrs: {
	      "propsProposta": _vm.proposta,
	      "editavel": true,
	      "travarMunicipios": true
	    },
	    on: {
	      "municipioAdicionado": function($event) {
	        _vm.proposta.municipalizacao = $event
	      },
	      "validacaoMunicipio": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  }), _vm._v(" "), _c('municipiosNovos', {
	    attrs: {
	      "municipalizacao": _vm.proposta.municipalizacao
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cursos') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "cursos"
	    }
	  }, [_vm._m(18), _vm._v(" "), _c('cursos', {
	    attrs: {
	      "propsCursos": _vm.proposta.cursos
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cursos')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "testemunhas"
	    }
	  }, [_vm._m(19), _vm._v(" "), _c('testemunhas', {
	    ref: "testemunhas",
	    attrs: {
	      "idProposta": this.$route.params.id
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cursos')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "indicacaoAgencia"
	    }
	  }, [_vm._m(20), _vm._v(" "), _c('agenciaIndicativaContaProjeto', {
	    ref: "agenciaIndicativa",
	    attrs: {
	      "proposta": this.proposta,
	      "agenciaSelecionadaProp": this.proposta.hasOwnProperty('agenciaSelecionada') ? this.proposta.agenciaSelecionada : null
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('documentos')) ? _c('div', {
	    staticClass: "col-md-12",
	    attrs: {
	      "id": "anexos"
	    }
	  }, [_vm._m(21), _vm._v(" "), _c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.documentosProposta,
	      "documentTypes": _vm.proposta.tipo_documentos,
	      "localUso": 'PROPOSTA_COMPLETA_DOCUMENTOS_ANEXOS',
	      "propsEtapa": _vm.nulo
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "row-flex all-start gap-10"
	  }, [_c('label', [_vm._v("Mostra anexos cotação:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.abrirVisualizacaoCotacao),
	      expression: "abrirVisualizacaoCotacao"
	    }],
	    staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.abrirVisualizacaoCotacao) ? _vm._i(_vm.abrirVisualizacaoCotacao, null) > -1 : (_vm.abrirVisualizacaoCotacao)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.abrirVisualizacaoCotacao,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.abrirVisualizacaoCotacao = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.abrirVisualizacaoCotacao = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.abrirVisualizacaoCotacao = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-header"
	  }, [(_vm.abrirVisualizacaoCotacao) ? _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos da Cotacao")]) : _vm._e()]), _vm._v(" "), (_vm.abrirVisualizacaoCotacao) ? _c('visualizacaoDocumentosCotacao', {
	    attrs: {
	      "proposta": _vm.proposta
	    }
	  }) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.mostrarRef('historico')) ? _c('fieldset', {
	    attrs: {
	      "enabled": this.$router.currentRoute.name === 'proposta-visualiza',
	      "id": "historicoAprovacoes"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.esconder === true),
	      expression: "usuarioLogado.userType === 'FUNDACAO' && esconder === true"
	    }],
	    staticClass: "col-md-12"
	  }, [_vm._m(22), _vm._v(" "), _c('historico-proposta', {
	    attrs: {
	      "proposta": _vm.proposta
	    },
	    on: {
	      "historico_itens": function($event) {
	        _vm.historico_atualizado = $event
	      }
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('fieldset', [(_vm.esconder === true) ? _c('div', {
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.irTopo()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up"
	  }, [_vm._v(" Ir para o início")])])]) : _vm._e(), _vm._v(" "), ((this.$route.params.processo !== 'SOLICITACAO' && !_vm._.isNull(_vm.proposta) && !_vm._.isEmpty(_vm.proposta))) ? _c('fieldset', [((this.$route.params.processo === 'ANALISE') || (_vm.proposta.ds_fase === 'ANALISE' && !_vm._.isEmpty(this.analise))) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
	      expression: "usuarioLogado.userType === 'FUNDACAO'"
	    }]
	  }, [_c('analise', {
	    ref: "analise",
	    attrs: {
	      "propsAnalise": _vm.proposta,
	      "propsFluxo": _vm.fluxo,
	      "restricoesEntidade": _vm.restricoesEntidade
	    },
	    on: {
	      "analiseProposta": function($event) {
	        _vm.analise = $event
	      },
	      "setPropostaSimplificada": function($event) {
	        return _vm.setPropostaSimplificada($event)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && ((this.$router.currentRoute.name === 'proposta-visualiza' && _vm.proposta.ds_fase === 'ANALISE'))) ? _c('div', [_c('analise', {
	    ref: "analise",
	    attrs: {
	      "propsAnalise": _vm.proposta,
	      "propsFluxo": _vm.fluxo,
	      "restricoesEntidade": _vm.restricoesEntidade
	    },
	    on: {
	      "analiseProposta": function($event) {
	        _vm.analise = $event
	      },
	      "setPropostaSimplificada": function($event) {
	        return _vm.setPropostaSimplificada($event)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.proposta.ds_fase === 'DEFERIMENTO' || _vm.proposta.ds_fase === 'FORMALIZACAO' || _vm.proposta.ds_fase === 'APROVACAO_PROJETO') ? _c('div', {
	    staticClass: "text-left box-header"
	  }, [(_vm.esconderAnalise === false) ? _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderAnalise = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Mostrar a análise realizada em "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.analiseData, 'L')))]), _vm._v(" "), (_vm.analiseUsuario !== null) ? _c('span', [_vm._v(" por "), _c('b', [_vm._v(_vm._s(_vm.analiseUsuario))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderAnalise === true) ? _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.esconderAnalise = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Ocultar a análise")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderAnalise === true) ? _c('div', [_c('analise', {
	    ref: "analise",
	    attrs: {
	      "propsAnalise": _vm.proposta,
	      "propsFluxo": _vm.fluxo,
	      "restricoesEntidade": _vm.restricoesEntidade
	    },
	    on: {
	      "setPropostaSimplificada": function($event) {
	        return _vm.setPropostaSimplificada($event)
	      }
	    }
	  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && ((this.$route.params.processo === 'DEFERIMENTO' && this.$router.currentRoute.name !== 'proposta-visualiza') || (_vm.proposta.ds_fase === 'DEFERIMENTO' && !_vm._.isEmpty(this.deferimento)))) ? _c('div', [_c('deferimento', {
	    ref: "child",
	    attrs: {
	      "propsDeferimento": _vm.proposta,
	      "propsFluxo": _vm.fluxo
	    },
	    on: {
	      "deferimentoProposta": function($event) {
	        _vm.deferimento = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && this.$router.currentRoute.name === 'proposta-visualiza' && _vm.proposta.ds_fase === 'DEFERIMENTO') ? _c('div', [_c('deferimento', {
	    ref: "child",
	    attrs: {
	      "propsDeferimento": _vm.proposta,
	      "propsFluxo": _vm.fluxo
	    },
	    on: {
	      "deferimentoProposta": function($event) {
	        _vm.deferimento = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (this.$route.params.processo === 'FORMALIZACAO' && this.$router.currentRoute.name !== 'proposta-visualiza') || (_vm.proposta.ds_fase === 'FORMALIZACAO' && !_vm._.isEmpty(this.formalizacao) && this.$router.currentRoute.name !== 'proposta-visualiza')) ? _c('div', [_c('formalizacao', {
	    ref: "child",
	    attrs: {
	      "propsFormalizacao": _vm.proposta,
	      "propsAdiantaveis": _vm.possuiItensAdiantaveis
	    },
	    on: {
	      "formalizacaoProposta": function($event) {
	        _vm.proposta = $event
	      },
	      "validacaoFormalizacao": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && this.$router.currentRoute.name === 'proposta-visualiza' && _vm.proposta.ds_fase === 'FORMALIZACAO') ? _c('div', {
	    attrs: {
	      "propsAdiantaveis": _vm.possuiItensAdiantaveis
	    }
	  }, [_c('formalizacao', {
	    ref: "child",
	    attrs: {
	      "propsFormalizacao": _vm.proposta
	    },
	    on: {
	      "formalizacaoProposta": function($event) {
	        _vm.proposta = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (this.$route.params.processo === 'APROVACAO_PROJETO' && this.$router.currentRoute.name !== 'proposta-visualiza') || (_vm.proposta.ds_fase === 'APROVACAO_PROJETO' && !_vm._.isEmpty(this.aprovacao) && this.$router.currentRoute.name !== 'proposta-visualiza')) ? _c('div', [_c('aprovacao', {
	    ref: "child",
	    attrs: {
	      "propsAprovacao": _vm.proposta
	    },
	    on: {
	      "aprovacaoProposta": function($event) {
	        _vm.aprovacao = $event
	      },
	      "validacaoAprovacao": function($event) {
	        return _vm.adicionaRestricao($event)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && this.$router.currentRoute.name === 'proposta-visualiza' && _vm.proposta.ds_fase === 'APROVACAO_PROJETO') ? _c('div', [_c('aprovacao', {
	    ref: "child",
	    attrs: {
	      "propsAprovacao": _vm.proposta
	    },
	    on: {
	      "aprovacaoProposta": function($event) {
	        _vm.aprovacao = $event
	      }
	    }
	  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-content",
	    staticStyle: {
	      "z-index": "10000"
	    }
	  })])])])])]) : _vm._e()]), _vm._v(" "), _c('dialog', {
	    ref: "alertaCancelamentoDialog",
	    attrs: {
	      "id": "alertaCancelamentoDialog"
	    }
	  }, [_vm._m(23), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin": "25px 0"
	    }
	  }, [_vm._v("\n        Confirma a Exclusão da proposta?\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Justificativa (obrigatório)\n      ")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.justificativaCancelamento),
	      expression: "justificativaCancelamento"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border": "none",
	      "padding": "10px",
	      "margin": "0 0 10px 0",
	      "color": "#222"
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Escreva a justificativa (min. 10 caracteres)"
	    },
	    domProps: {
	      "value": (_vm.justificativaCancelamento)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.justificativaCancelamento = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-neutral",
	    staticStyle: {
	      "margin": "0 10px"
	    },
	    attrs: {
	      "onclick": "alertaCancelamentoDialog.close()"
	    }
	  }, [_vm._v("Não, Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "disabled": _vm.justificativaCancelamento.length < 10
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelarProposta()
	      }
	    }
	  }, [_vm._v("Sim, excluir a Proposta")])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa fa-info"
	  }), _vm._v("   Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Atenção!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("A Entidade possui restrições impeditivas")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Alerta!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Informações do Projeto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Público-alvo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Detalhamento do Público-alvo "), _c('strong', [_vm._v("Previsto")]), _vm._v(":")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Tecnologia Social:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Licenciamento Ambiental:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Equipe do Projeto")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Entidade executora")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Edital")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Objetivo Específico")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Metas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Atividades")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cronograma Físico-Financeiro")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Parcela de Adiantamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Municípios - Locais de execução")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Cursos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Testemunhas")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Indicação de Agência")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Documentos da Proposta")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Histórico de Aprovações:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("Atenção!")])])
	}]}

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "min-height": "870px"
	    }
	  }, [_c('div', {
	    staticClass: "fade-transition ng-scope",
	    attrs: {
	      "ng-view": ""
	    }
	  }, [_c('section', {
	    staticClass: "content-header ng-scope"
	  }, [_c('h1', [_vm._v("Detalhamento da Aprovação de Entidade")]), _vm._v(" "), _c('b-breadcrumb', {
	    attrs: {
	      "items": _vm.breadcrumb
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "content ng-scope"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [(_vm.detalhe.entityApprovalType) ? _c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), (_vm.detalhe.entityApprovalType === 'FIRST_APPROVAL' && _vm.detalhe.eventStatus !== 'DONE') ? _c('span', [_vm._v("Primeira Aprovação")]) : _vm._e(), _vm._v(" "), (_vm.detalhe.entityApprovalType === 'SECOND_APPROVAL' && _vm.detalhe.eventStatus !== 'DONE') ? _c('span', [_vm._v("Segunda Aprovação")]) : _vm._e(), _vm._v(" "), (_vm.detalhe.eventStatus === 'DONE') ? _c('span', [_vm._v("Aprovação Finalizada")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-padding",
	    attrs: {
	      "ssm-lte-loading": "loading-info"
	    }
	  }, [(!_vm.analise.approvalResult) ? _c('div', {
	    staticClass: "mailbox-controls with-border text-center"
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "mailbox-read-info"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [(_vm.detalhe.eventStatus === 'DONE') ? _c('p', {
	    staticClass: "form-control-static text-success"
	  }, [_vm._v("APROVADO")]) : _vm._e(), _vm._v(" "), (_vm.analise.approvalResult === 'REJECTED') ? _c('p', {
	    staticClass: "form-control-static text-danger"
	  }, [_vm._v("REJEITADO")]) : _vm._e(), _vm._v(" "), (_vm.analise.approvalResult === '' && _vm.detalhe.eventStatus !== 'DONE') ? _c('p', {
	    staticClass: "form-control-static text-primary"
	  }, [_vm._v("AGUARDANDO VALIDAÇÃO")]) : _vm._e()]), _vm._v(" "), (_vm.detalhe.updatedAt) ? _c('div', [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Data da operação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.dataAtualizacao))])])]) : _vm._e(), _vm._v(" "), (_vm.analise.justify) ? _c('div', [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.analise.justify))])])]) : _vm._e(), _vm._v(" "), (_vm.detalhe.proposalRelease) ? _c('div', [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Liberado para proposta:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [(_vm.detalhe.proposalRelease === 'true') ? _c('label', {
	    staticClass: "form-control-static text-success"
	  }, [_vm._v("SIM")]) : _vm._e(), _vm._v(" "), (_vm.detalhe.proposalRelease === 'false') ? _c('label', {
	    staticClass: "form-control-static text-danger"
	  }, [_vm._v("NÃO")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.detalhe.user) ? _c('div', [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Atendido por:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.detalhe.user.userName))])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.detalhe.entity.businessName))])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "ng-if": "mainEntDetAppCtrl.approval.entity.codForERp != null"
	    }
	  }, [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Código no Sapiens:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.detalhe.entity.codForERp))])])]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Criado em:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.dataCriacao))])])]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "col-md-2 control-label link-muted"
	  }, [_vm._v("Atualizado em:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('label', {
	    staticClass: "form-control-static"
	  }, [_vm._v(_vm._s(_vm.dataAtualizacao))])])])])])]), _vm._v(" "), (_vm.detalhe.entityApprovalType) ? _c('div', [_c('a', {
	    staticClass: "btn btn-default btn-sm",
	    on: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-reply",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar à tela anterior\n            ")])]) : _vm._e()])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.show),
	      expression: "loading.show"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "none",
	      "background": "rgba(255, 255, 255, 0.7)",
	      "z-index": "1000"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "position": "absolute",
	      "font-size": "30px"
	    }
	  })]), _vm._v(" "), (_vm.telaProjeto && _vm.definicoes.length === 0) ? _c('div', [_vm._m(0)]) : _c('div', {
	    staticClass: "publico-alvo-previsto-container"
	  }, [_c('div', {
	    staticClass: "publico-alvo-descritivo"
	  }, [_vm._v("\n      Descrição de Público-alvo.\n      "), (!_vm.editar && _vm.permiteEditar && !_vm.telaProjeto) ? _c('g-button-moema', {
	    staticClass: "botao-editar-publico",
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n        Alterar")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "column start-centered publico-alvo-table-container"
	  }, [_c('div', {
	    staticClass: "publico-alvo-subtitulo"
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Público-alvo "), _c('b', [_vm._v("previsto")]), _vm._v(" cadastrado (" + _vm._s(_vm.itemTable.length) + "):\n      ")]), _vm._v(" "), (!_vm.editar) ? _c('b-container', {
	    staticClass: "publico-alvo-table",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    key: _vm.tableDataKey,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "striped": "",
	      "bordered": _vm.table.bordered,
	      "items": _vm.table.items,
	      "fields": _vm.table.fields,
	      "current-page": _vm.table.currentPage,
	      "per-page": _vm.table.perPage,
	      "filter": _vm.table.filter,
	      "empty-text": "Nenhum registro encontrado",
	      "sort-by": _vm.table.sortBy,
	      "sort-desc": _vm.table.sortDesc
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.table, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.table, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "publico",
	      fn: function(row) {
	        return [_c('b', [_vm._v(_vm._s(row.value))])]
	      }
	    }, {
	      key: "tipo",
	      fn: function(row) {
	        return [_c('div', {
	          attrs: {
	            "title": row.item.descricao
	          }
	        }, [_vm._v("\n                        " + _vm._s(row.value) + "\n                      ")])]
	      }
	    }], null, false, 3855842344)
	  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.editar) ? _c('div', {
	    staticClass: "publico-alvo-content"
	  }, [_c('div', {
	    staticClass: "publico-alvo-definicao-container"
	  }, _vm._l((_vm.definicaoPublicoAlvo), function(item, index) {
	    return (!(item.tipo === 'Sociedade em geral' && _vm.telaParticipante)) ? _c('div', {
	      staticClass: "publico-alvo-item-container",
	      class: {
	        'adjust-height': item.aberto
	      },
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.toogleItem(index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "publico-alvo-titulo",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.toogleItem(index)
	        }
	      }
	    }, [_c('strong', [_vm._v(_vm._s(item.tipo))]), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-caret-right",
	      class: {
	        'rotate-icon': item.aberto
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]), _vm._v(" "), (item.aberto) ? _c('div', {
	      staticClass: "divider",
	      class: {
	        'show-item': item.aberto
	      }
	    }) : _vm._e(), _vm._v(" "), (item.aberto) ? _c('div', {
	      staticClass: "publico-alvo-content-container"
	    }, _vm._l((item.subgrupos), function(detalhamento) {
	      return (item.aberto) ? _c('div', {
	        staticClass: "publico-alvo-items",
	        class: {
	          'show-item': item.aberto
	        },
	        attrs: {
	          "title": detalhamento.descricao
	        }
	      }, [_c('label', {
	        staticClass: "conjunto-item"
	      }, [_vm._v("\n                " + _vm._s(detalhamento.subgrupo) + " "), _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (detalhamento.selecionado),
	          expression: "detalhamento.selecionado"
	        }],
	        staticClass: "publico-check",
	        attrs: {
	          "disabled": !_vm.editar,
	          "type": "checkbox"
	        },
	        domProps: {
	          "checked": Array.isArray(detalhamento.selecionado) ? _vm._i(detalhamento.selecionado, null) > -1 : (detalhamento.selecionado)
	        },
	        on: {
	          "change": [function($event) {
	            var $$a = detalhamento.selecionado,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = null,
	                $$i = _vm._i($$a, $$v);
	              if ($$el.checked) {
	                $$i < 0 && (_vm.$set(detalhamento, "selecionado", $$a.concat([$$v])))
	              } else {
	                $$i > -1 && (_vm.$set(detalhamento, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	              }
	            } else {
	              _vm.$set(detalhamento, "selecionado", $$c)
	            }
	          }, function($event) {
	            return _vm.updateSelecao(detalhamento.id, detalhamento.selecionado, item.tipo)
	          }]
	        }
	      })])]) : _vm._e()
	    }), 0) : _vm._e()]) : _vm._e()
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "publico-alvo-acoes-container"
	  }, [(_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
	    attrs: {
	      "color": "error",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleEdicao(false)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Cancelar Edição")]) : _vm._e(), _vm._v(" "), (_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.limparSelecao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Limpar")]) : _vm._e(), _vm._v(" "), (_vm.editar && !_vm.telaParticipante) ? _c('g-button-moema', {
	    attrs: {
	      "color": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.salvarSelecao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n        Salvar")]) : _vm._e()], 1)]), _vm._v(" "), _c('vue-snotify')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "publico-alvo-descritivo"
	  }, [_vm._v("Sem dados cadastrados de público-alvo "), _c('strong', [_vm._v("previsto")]), _vm._v(".")])
	}]}

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.acao === 'LISTAR') ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    class: _vm._.isNil(_vm.numeroProjeto) ? 'col-md-2' : 'col-md-3'
	  }, [(_vm._.includes(_vm.itensLayoutTela, 'botaoNovo')) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "primary",
	      "size": "button--size-ss",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.acaoOcorrencia('CRIAR', 0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Nova Ocorrência ")]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayoutTela, 'botaoExportarExcel') && _vm.ocorrencias.length > 0) ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.exportarExcel()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Exportar Excel ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    class: _vm._.isNil(_vm.numeroProjeto) ? 'col-md-10' : 'col-md-9'
	  }, [_c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "align-items": "center"
	    }
	  }, [(_vm._.includes(_vm.itensLayoutTela, 'caixaPesquisa')) ? _c('div', {
	    staticClass: "w30"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.buscaTipo),
	      expression: "buscaTipo"
	    }],
	    staticStyle: {
	      "margin": "5px",
	      "padding": "5px"
	    },
	    attrs: {
	      "type": "radio",
	      "name": "inlineRadioOptions",
	      "value": "projeto"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.buscaTipo, "projeto")
	    },
	    on: {
	      "change": function($event) {
	        _vm.buscaTipo = "projeto"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "form-check-label",
	    attrs: {
	      "for": "inlineRadio1"
	    }
	  }, [_vm._v("Projeto")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.buscaTipo),
	      expression: "buscaTipo"
	    }],
	    staticStyle: {
	      "margin": "5px",
	      "padding": "5px"
	    },
	    attrs: {
	      "type": "radio",
	      "name": "inlineRadioOptions",
	      "id": "inlineRadio2",
	      "value": "entidade"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.buscaTipo, "entidade")
	    },
	    on: {
	      "change": function($event) {
	        _vm.buscaTipo = "entidade"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "form-check-label",
	    attrs: {
	      "for": "inlineRadio2"
	    }
	  }, [_vm._v("Nome Entidade")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.buscaTipo),
	      expression: "buscaTipo"
	    }],
	    staticStyle: {
	      "margin": "5px",
	      "padding": "5px"
	    },
	    attrs: {
	      "type": "radio",
	      "name": "inlineRadioOptions",
	      "id": "inlineRadio2",
	      "value": "cnpj"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.buscaTipo, "cnpj")
	    },
	    on: {
	      "change": function($event) {
	        _vm.buscaTipo = "cnpj"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "form-check-label",
	    attrs: {
	      "for": "inlineRadio2"
	    }
	  }, [_vm._v("CNPJ")])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filtro.pesquisa),
	      expression: "filtro.pesquisa"
	    }, {
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholderCampoBusca.find(function (x) { return x.tipo === _vm.buscaTipo; }).placeholder,
	      "title": _vm.buscaTipo === 'projeto' ? '<h5>Informe o número do projeto</h5>' : '<h5>Informe o nome da entidade</h5>'
	    },
	    domProps: {
	      "value": (_vm.filtro.pesquisa)
	    },
	    on: {
	      "keyup": _vm.ajustaPesquisa,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.filtro, "pesquisa", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [(_vm.filtro.pesquisa.length > 0) ? _c('button', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.filtro.pesquisa = '';
	        _vm.ajustaPesquisa()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "w30"
	  }, [(_vm._.includes(_vm.itensLayoutTela, 'filtroCarteira')) ? _c('div', [_c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [(_vm.loading.carteiras) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando carteiras ...")]) : _c('span', [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaCarteiras,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "placeholder": "Carteiras de projeto",
	      "name": "carteiras_projeto"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_vm._v(_vm._s(props.option.usu_codcart) + " - " + _vm._s(props.option.usu_nomcart))]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_vm._v(_vm._s(props.option.usu_codcart) + " - " + _vm._s(props.option.usu_nomcart))]
	      }
	    }], null, false, 2587724374),
	    model: {
	      value: (_vm.filtro.carteira),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "carteira", $$v)
	      },
	      expression: "filtro.carteira"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)])]) : _vm._e()])]), _vm._v(" "), (_vm._.includes(_vm.itensLayoutTela, 'caixaPesquisa') || _vm._.includes(_vm.itensLayoutTela, 'filtroCarteira')) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12",
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "align-items": "center"
	    }
	  }, [(_vm._.includes(_vm.itensLayoutTela, 'filtroNivelOcorrencia')) ? _c('div', {
	    staticClass: "indicadores-cb-inline",
	    staticStyle: {
	      "width": "50%"
	    }
	  }, _vm._l((_vm.listaNiveis), function(item) {
	    return _c('div', {
	      staticClass: "juntos"
	    }, [_c('i', {
	      class: _vm._.find(_vm.filtro.nivel, ['nivel', item.nivel]) ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.checkboxNivel(item)
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      class: _vm._.find(_vm.filtro.nivel, ['nivel', item.nivel]) ? 'selecionado' : ''
	    }, [_vm._v(" " + _vm._s(_vm.enumeradores[item.codigo]))])])
	  }), 0) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayoutTela, 'filtroCodigoOcorrencia')) ? _c('div', {
	    staticClass: "w30"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [(_vm.loading.codigos) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando tipos de ocorrências ...")]) : _c('span', [_c('multiselect', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large',
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
	    }],
	    attrs: {
	      "options": _vm._.orderBy(_vm._.filter(_vm.listaTiposOcorrencias, ['consultar', true]), ['criar', 'codigo'], ['desc', 'asc']),
	      "multiple": true,
	      "custom-label": function (option) {
	        return ("" + (option.codigo))
	      },
	      "track-by": "codigo",
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "taggable": true,
	      "title": '<h5>Códigos disponíveis para consulta<br/>Em vermelho estão os códigos <span class=\'text-red\'> impedidos de criar novas ocorrências</span></h5>',
	      "placeholder": "Cód. Ocorrências",
	      "name": "tipos_ocorrencias"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('span', {
	          class: !props.option.criar ? 'text-red' : ''
	        }, [_vm._v(_vm._s(props.option.codigo) + " - " + _vm._s(props.option.descricao))])]
	      }
	    }], null, false, 3148997595),
	    model: {
	      value: (_vm.filtro.codigo),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "codigo", $$v)
	      },
	      expression: "filtro.codigo"
	    }
	  }, [_vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "espacamento_botoes"
	  }), _vm._v(" "), (_vm._.includes(_vm.itensLayoutTela, 'filtroSituacaoOcorrencia')) ? _c('div', {
	    staticClass: "w20"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('multiselect', {
	    attrs: {
	      "options": _vm.listaSituacoesOcorrencias,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "placeholder": "Situação",
	      "name": "situacao_ocorrencias"
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_vm._v(_vm._s(_vm.enumeradores[props.option]))]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "truncar"
	        }, [_vm._v(_vm._s(_vm.enumeradores[props.option]))])]
	      }
	    }], null, false, 684711505),
	    model: {
	      value: (_vm.filtro.situacao),
	      callback: function($$v) {
	        _vm.$set(_vm.filtro, "situacao", $$v)
	      },
	      expression: "filtro.situacao"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [(_vm.temFiltroPreenchido()) ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.pesquisarOcorrencias()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Pesquisar ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '2',
	        size: 'large',
	        delay: [500, 0]
	      }),
	      expression: "{inertia:true, arrow:true, animation:'fade', distance:'2', size:'large', delay: [500, 0]}"
	    }],
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "type": "button",
	      "title": '<h5>Limpar os parâmetros de pesquisa</h5>'
	    },
	    on: {
	      "click": function($event) {
	        _vm.limparPesquisa();
	        _vm.salvarConfiguracoes()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    style: ('color: var(--cor-fraca); margin-top: ' + (_vm._.isNil(_vm.numeroProjeto) ? 35 : 5) + 'px')
	  }, [(_vm.ocorrencias.length > 1) ? _c('span', [_vm._v(_vm._s(_vm.ocorrencias.length + ' ocorrências localizadas'))]) : (_vm.ocorrencias.length === 1) ? _c('span', [_vm._v(_vm._s('1 ocorrência localizada'))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {}, [(_vm.loading.tabelaOcorrencias) ? _c('div', [_vm._m(0)]) : _c('div', [_c('b-container', {
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('b-table', {
	    key: 'tabelaListaOcorrencias_' + _vm.tabelaListaOcorrencias.numeroAtualizacao,
	    attrs: {
	      "show-empty": "",
	      "stacked": "md",
	      "hover": "",
	      "bordered": true,
	      "items": _vm.ocorrencias,
	      "fields": _vm.tabelaListaOcorrencias.fields,
	      "current-page": _vm.tabelaListaOcorrencias.currentPage,
	      "per-page": _vm.tabelaListaOcorrencias.perPage,
	      "sort-by": _vm.tabelaListaOcorrencias.sortBy,
	      "sort-desc": _vm.tabelaListaOcorrencias.sortDesc,
	      "empty-filtered-text": 'Não encontrei nada relacionado a ´' + _vm.pesquisa + '´ na pesquisa',
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "update:sortBy": function($event) {
	        return _vm.$set(_vm.tabelaListaOcorrencias, "sortBy", $event)
	      },
	      "update:sort-by": function($event) {
	        return _vm.$set(_vm.tabelaListaOcorrencias, "sortBy", $event)
	      },
	      "update:sortDesc": function($event) {
	        return _vm.$set(_vm.tabelaListaOcorrencias, "sortDesc", $event)
	      },
	      "update:sort-desc": function($event) {
	        return _vm.$set(_vm.tabelaListaOcorrencias, "sortDesc", $event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "id",
	      fn: function(row) {
	        return [_vm._v(_vm._s(row.value))]
	      }
	    }, {
	      key: "codigo",
	      fn: function(row) {
	        return [_c('div', {
	          staticClass: "truncar",
	          staticStyle: {
	            "max-width": "250px"
	          }
	        }, [_vm._l(([('' + row.item.codigo).substr(0, 1)]), function(nivel) {
	          return _c('span', {
	            staticClass: "text-bold",
	            style: ('color: var(--cor-' + (nivel === '4' ? 'atencao' : (nivel === '3' ? 'alerta' : (nivel === '2' ? 'destaque' : 'fraca'))) + ')')
	          }, [_vm._v("\n                      " + _vm._s(row.item.codigo) + "\n                    ")])
	        }), _vm._v("\n                  " + _vm._s(row.item.descricao) + "\n                ")], 2)]
	      }
	    }, {
	      key: "projeto",
	      fn: function(row) {
	        return [(row.item.nomeProcesso === 'OCORRENCIA_ENTIDADE') ? _c('span', [_c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'fade',
	              distance: '1',
	              size: 'large',
	              delay: [500, 0]
	            }),
	            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
	          }],
	          staticClass: "truncar",
	          staticStyle: {
	            "max-width": "250px"
	          },
	          attrs: {
	            "title": '<h5>' + row.item.entidade + '</h5>'
	          }
	        }, [_c('i', [_vm._v(_vm._s(row.item.entidade))])])]) : _c('span', [_c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'fade',
	              distance: '1',
	              size: 'large',
	              delay: [500, 0]
	            }),
	            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
	          }],
	          attrs: {
	            "title": '<h5>' + row.item.numeroProjeto + ' - ' + row.item.projeto + '</br></br>' + row.item.entidade + '</h5>'
	          }
	        }, [_c('div', {
	          staticClass: "truncar",
	          staticStyle: {
	            "max-width": "250px",
	            "cursor": "pointer"
	          }
	        }, [_c('strong', {
	          staticClass: "linkProjeto",
	          on: {
	            "click": function($event) {
	              return _vm.abrePaginaNova('projetos/projeto/', row.item.numeroProjeto)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-external-link"
	        }), _vm._v(" " + _vm._s(row.item.numeroProjeto) + " - " + _vm._s(row.item.projeto))])]), _vm._v(" "), _c('div', {
	          staticClass: "truncar",
	          staticStyle: {
	            "max-width": "250px"
	          }
	        }, [_c('i', [_vm._v(_vm._s(row.item.entidade))])])])])]
	      }
	    }, {
	      key: "observacao",
	      fn: function(row) {
	        return [_c('span', {
	          staticStyle: {
	            "line-break": "anywhere",
	            "text-align": "left"
	          }
	        }, [((row.value).length <= 245) ? _c('div', {
	          domProps: {
	            "innerHTML": _vm._s(row.value)
	          }
	        }) : _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'fade',
	              distance: '1',
	              size: 'large',
	              delay: [500, 0]
	            }),
	            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
	          }],
	          attrs: {
	            "title": '<h5 style=\'text-align: left\'>' + row.value + '</h5>'
	          },
	          domProps: {
	            "innerHTML": _vm._s((row.value).length > 245 ? (row.value).substr(0, 245) + ' ...' : row.value)
	          }
	        })])]
	      }
	    }, {
	      key: "etapa",
	      fn: function(row) {
	        return [_vm._v("\n                " + _vm._s(_vm.enumeradores[row.value]) + "\n              ")]
	      }
	    }, {
	      key: "tarefaInicio",
	      fn: function(row) {
	        return [(('' + row.item.tarefaInicio).includes('00:00:00')) ? _c('span', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              inertia: true,
	              arrow: true,
	              animation: 'fade',
	              distance: '1',
	              size: 'large',
	              delay: [1000, 0]
	            }),
	            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [1000, 0]}"
	          }],
	          attrs: {
	            "title": '<h5>Migrado não possui hora</h5>'
	          }
	        }, [_vm._v(_vm._s(_vm._f("moment")(row.item.tarefaInicio, "DD/MM/YYYY")))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.item.tarefaInicio, "DD/MM/YYYY HH:mm")))])]
	      }
	    }, {
	      key: "acoes",
	      fn: function(row) {
	        return [(!_vm._.includes(['CANCELADO', 'BAIXADO'], row.item.etapa)) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "primary",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.acaoOcorrencia('EDITAR', row.item.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-pencil-square-o",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['CANCELADO', 'BAIXADO'], row.item.etapa)) ? _c('g-button-ujarak', {
	          attrs: {
	            "color": "success",
	            "size": "button--size-ss"
	          },
	          nativeOn: {
	            "click": function($event) {
	              return _vm.acaoOcorrencia('VISUALIZAR', row.item.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-search",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" Visualizar")]) : _vm._e()]
	      }
	    }], null, false, 933782560)
	  }), _vm._v(" "), (!_vm._.isEmpty(_vm.ocorrencias) && _vm.ocorrencias.length > _vm.tabelaListaOcorrencias.perPage && _vm.tabelaListaOcorrencias.totalRows > _vm.tabelaListaOcorrencias.perPage) ? _c('b-row', [_c('b-col', {
	    staticClass: "my-1",
	    attrs: {
	      "md": "12",
	      "right": ""
	    }
	  }, [_c('b-pagination', {
	    staticClass: "my-3",
	    attrs: {
	      "total-rows": _vm.tabelaListaOcorrencias.totalRows,
	      "per-page": _vm.tabelaListaOcorrencias.perPage
	    },
	    model: {
	      value: (_vm.tabelaListaOcorrencias.currentPage),
	      callback: function($$v) {
	        _vm.$set(_vm.tabelaListaOcorrencias, "currentPage", $$v)
	      },
	      expression: "tabelaListaOcorrencias.currentPage"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.acao !== 'LISTAR') ? _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading.tela),
	      expression: "loading.tela"
	    }],
	    staticClass: "overlay",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0px",
	      "left": "0px",
	      "width": "100%",
	      "height": "100%",
	      "display": "block"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    class: (_vm._.includes(_vm.itensLayoutTela, 'formatacaoCaixa') ? 'box' : '') + ' box-widget'
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('span', [(_vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO' || !_vm._.isNil(_vm.numeroProjeto)) ? _c('div', {
	    staticClass: "text-bold col-md-2",
	    staticStyle: {
	      "margin-top": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.ocorrencia.tipo))]) : _c('div', {
	    staticClass: "col-md-2 form-control-static",
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "space-between"
	    }
	  }, [_c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.tipo),
	      expression: "ocorrencia.tipo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tipoOcorrencia",
	      "id": "tipoOcorrenciaProjeto"
	    },
	    domProps: {
	      "value": 'PROJETO',
	      "checked": _vm._q(_vm.ocorrencia.tipo, 'PROJETO')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "tipo", 'PROJETO')
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "tipoOcorrenciaProjeto"
	    }
	  }, [_vm._v("Projeto")])]), _vm._v(" "), _c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.tipo),
	      expression: "ocorrencia.tipo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "tipoOcorrencia",
	      "id": "tipoOcorrenciaEntidade"
	    },
	    domProps: {
	      "value": 'ENTIDADE',
	      "checked": _vm._q(_vm.ocorrencia.tipo, 'ENTIDADE')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "tipo", 'ENTIDADE')
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "tipoOcorrenciaEntidade"
	    }
	  }, [_vm._v("Entidade")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [(_vm.loading.listaProjetosEntidades) ? _c('div', [_vm._m(1)]) : _c('div', {
	    ref: 'projeto_entidade_' + _vm.numeroAtualizacao
	  }, [(_vm.ocorrencia.tipo === 'PROJETO') ? _c('span', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaProjetosEntidades['projetos'],
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO' || !_vm._.isNil(_vm.numeroProjeto),
	      "custom-label": function (option) {
	        return ("" + (option.ds_codigo_projeto_erp + option.sitprj + option.ds_nome))
	      },
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "placeholder": "Selecione um projeto",
	      "name": "projeto_entidade"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.alteraListaTiposOcorrencias($event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "truncar"
	        }, [_c('span', {
	          staticClass: "text-bold"
	        }, [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" (" + _vm._s(props.option.sitprj) + ") " + _vm._s(props.option.ds_nome))])]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "truncar"
	        }, [_c('span', {
	          staticClass: "identificadorIDProjeto"
	        }, [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" "), _c('span', {
	          staticClass: "identificadorIDProjeto text-muted"
	        }, [_vm._v(_vm._s(props.option.sitprj))]), _vm._v(" " + _vm._s(props.option.ds_nome))])]
	      }
	    }], null, false, 2886987170),
	    model: {
	      value: (_vm.ocorrencia.alvo),
	      callback: function($$v) {
	        _vm.$set(_vm.ocorrencia, "alvo", $$v)
	      },
	      expression: "ocorrencia.alvo"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('projeto_entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve selecionar um projeto na lista")]) : _vm._e()], 1) : _c('span', [_c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm.listaProjetosEntidades['entidades'],
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO',
	      "custom-label": function (option) {
	        return ("" + (option.ds_cnpj + option.ds_nome))
	      },
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "placeholder": "Selecione uma entidade",
	      "name": "projeto_entidade"
	    },
	    on: {
	      "select": function($event) {
	        return _vm.alteraListaTiposOcorrencias($event)
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "truncar"
	        }, [_c('span', {
	          staticClass: "text-bold"
	        }, [_vm._v(_vm._s(_vm._f("cnpj")(props.option.ds_cnpj)))]), _vm._v(" " + _vm._s(props.option.ds_nome))])]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "truncar"
	        }, [_c('span', {
	          staticClass: "identificadorIDProjeto"
	        }, [_vm._v(_vm._s(_vm._f("cnpj")(props.option.ds_cnpj)))]), _vm._v(" " + _vm._s(props.option.ds_nome))])]
	      }
	    }], null, false, 926782840),
	    model: {
	      value: (_vm.ocorrencia.alvo),
	      callback: function($$v) {
	        _vm.$set(_vm.ocorrencia, "alvo", $$v)
	      },
	      expression: "ocorrencia.alvo"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('projeto_entidade')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve selecionar uma entidade na lista")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('codigo_ocorrencia') || _vm.errors.first('grupo_ocorrencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Código:")]), _vm._v(" "), (_vm.loading.listaOcorrencias) ? _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando lista de ocorrências...")]) : _c('span', [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.grupoOcorrencia),
	      expression: "grupoOcorrencia"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO',
	      "name": "grupo_ocorrencia"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.grupoOcorrencia = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        _vm.ocorrencia.enquadramento = null
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Informativa")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Alerta")]), _vm._v(" "), (_vm.ocorrencia.tipo === 'PROJETO') ? _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Restritiva Relativa")]) : _vm._e(), _vm._v(" "), (_vm.ocorrencia.tipo === 'ENTIDADE') ? _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Restritiva Absoluta")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('grupo_ocorrencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Selecione qual o grupo de ocorrências deseja")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [(!_vm._.isNull(_vm.grupoOcorrencia)) ? _c('multiselect', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "options": _vm._.orderBy(_vm._.filter(_vm.listaTiposOcorrencias, {
	        'tipo_ocorrencia': _vm._.toNumber(_vm.grupoOcorrencia),
	        'criar': true,
	        'automatico': false
	      }), ['codigo'], ['ASC']),
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO',
	      "multiple": false,
	      "placeholder": "Selecione uma ocorrência",
	      "label": "descricao",
	      "track-by": "codigo",
	      "custom-label": function (option) {
	        return ("" + (option.codigo + option.descricao))
	      },
	      "preselect-first": false,
	      "close-on-select": true,
	      "selectLabel": "",
	      "deselectLabel": "",
	      "selectedLabel": "",
	      "name": "codigo_ocorrencia"
	    },
	    on: {
	      "select": function($event) {
	        _vm.ocorrencia.prazo = null
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "option",
	      fn: function(props) {
	        return [_c('strong', [_vm._v(_vm._s(props.option.codigo))]), _vm._v(" " + _vm._s(props.option.descricao) + "\n                          ")]
	      }
	    }, {
	      key: "singleLabel",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "truncar"
	        }, [_c('span', {
	          staticClass: "identificadorIDProjeto"
	        }, [_vm._v(_vm._s(props.option.codigo))]), _vm._v(" " + _vm._s(props.option.descricao))])]
	      }
	    }], null, false, 484598346),
	    model: {
	      value: (_vm.ocorrencia.enquadramento),
	      callback: function($$v) {
	        _vm.$set(_vm.ocorrencia, "enquadramento", $$v)
	      },
	      expression: "ocorrencia.enquadramento"
	    }
	  }, [_vm._v(" "), _vm._v(" "), _c('template', {
	    slot: "noResult"
	  }, [_vm._v("Nenhum registro localizado!")])], 2) : _vm._e(), _vm._v(" "), (_vm.errors.first('codigo_ocorrencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Deve selecionar o código da ocorrência desejada na lista")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('observacao_ocorrencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Observação:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "observacao_ocorrencia",
	      "id": "observacao_ocorrencia",
	      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO',
	      "placeholder": !_vm._.isEmpty(_vm._.get(_vm.ocorrencia.enquadramento, 'informacao', '')) ? _vm.ocorrencia.enquadramento.informacao : 'Informe o detalhamento da situação que gerou a ocorrência'
	    },
	    model: {
	      value: (_vm.ocorrencia.observacao),
	      callback: function($$v) {
	        _vm.$set(_vm.ocorrencia, "observacao", $$v)
	      },
	      expression: "ocorrencia.observacao"
	    }
	  }), _vm._v(" "), (!_vm._.isNil(_vm.ocorrencia.observacao) && _vm.ocorrencia.observacao.length > 245 && _vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('span', {
	    staticClass: "label label-warning"
	  }, [_vm._v("Atenção! O SGP guardará essa observação com " + _vm._s(_vm.ocorrencia.observacao.length) + " caracteres, mas no Sapiens só os 245 primeiros caracteres serão gravados")]) : _vm._e(), _vm._v(" "), (!_vm._.isNil(_vm.ocorrencia.observacao) && _vm.ocorrencia.observacao.length > 1000 && _vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('span', {
	    staticClass: "label label-info"
	  }, [_vm._v("Atenção! O texto esta muito grande, indicamos que o resuma")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('observacao_ocorrencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Informe o quê se refere essa ocorrência")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm._.includes([2200, 2201, 2202, 2203], _vm._.get(_vm.ocorrencia, 'enquadramento.codigo', 0))) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "required-field",
	    class: {
	      'has-error': _vm.errors.first('prazo_ocorrencia')
	    }
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Prazo para baixa:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "name": "prazo_ocorrencia",
	      "input-class": "form-control datepicker",
	      "disabled": _vm.ehVisualizacao || !_vm._.includes(['SOLICITACAO', 'AGUARDA_APROVACAO'], _vm.etapa) || (_vm._.includes(['AGUARDA_APROVACAO'], _vm.etapa) && !_vm.ehGestor),
	      "language": _vm.$datePickerPtBR,
	      "maxlength": "20",
	      "use-utc": true,
	      "placeholder": "__ /__ /____",
	      "format": "dd/MM/yyyy",
	      "disabled-dates": {
	        to: new Date(_vm.hoje.getTime() - 86400000),
	        from: new Date(_vm.hoje.getTime() + 864000000)
	      }
	    },
	    model: {
	      value: (_vm.ocorrencia.prazo),
	      callback: function($$v) {
	        _vm.$set(_vm.ocorrencia, "prazo", $$v)
	      },
	      expression: "ocorrencia.prazo"
	    }
	  }), _vm._v(" "), (_vm.errors.first('prazo_ocorrencia')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" O prazo é obrigatório para ocorrência " + _vm._s(_vm._.get(_vm.ocorrencia, 'enquadramento.codigo')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Anexos:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10",
	    staticStyle: {
	      "margin-top": "-10px"
	    }
	  }, [_c('upload-documentos-php-novo', {
	    attrs: {
	      "propDocumentos": _vm.ocorrencia.anexos,
	      "documentTypes": '',
	      "disable": _vm.ehVisualizacao || (_vm.etapa !== 'SOLICITACAO' && _vm.ocorrencia.acao !== 'ASSENTAMENTO')
	    }
	  })], 1)])]), _vm._v(" "), (!_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Histórico:"), _c('br'), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "font-weight": "normal",
	      "font-style": "italic"
	    },
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        _vm.layoutHistorico = _vm.layoutHistorico === 'RESUMIDO' ? 'COMPLETO' : 'RESUMIDO'
	      }
	    }
	  }, [_vm._v("Mostrando " + _vm._s(_vm._.toLower(_vm.layoutHistorico)))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-bordered table-striped table-hover"
	  }, [_vm._m(2), _vm._v(" "), (_vm._.has(_vm.itemOcorrencia, 'historico') && !_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('tbody', _vm._l((_vm.itemOcorrencia.historico), function(item) {
	    return (_vm.layoutHistorico === 'COMPLETO' || (_vm.layoutHistorico === 'RESUMIDO' && !_vm._.includes(['CRIACAO_OCORRENCIA_SAPIENS', 'ATUALIZACAO_OCORRENCIA_SAPIENS', 'MIGRADO_MODULO_ACOMPANHAMENTO', 'AGUARDA_APROVACAO', 'AGUARDA_BAIXA', 'ENCAMINHAR_APROVACAO', 'BAIXAR', 'APROVAR'], item.nome))) ? _c('tr', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('td', [_vm._v(_vm._s(_vm.enumeradores[item.nome] + (item.nome === 'ASSENTAMENTO' ? ' nº ' + (_vm._.findIndex(_vm._.filter(_vm.itemOcorrencia.historico, ['nome', 'ASSENTAMENTO']), item) + 1) : '')))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "truncar",
	      staticStyle: {
	        "width": "90%"
	      }
	    }, [_vm._v(_vm._s(item.ds_nome_usuario))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(_vm._.isNull(item.termino) ? item.inicio : item.termino, "DD/MM/YYYY HH:mm")))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "left"
	      }
	    }, [(!_vm._.isNil(item.observacao)) ? _c('div', {
	      domProps: {
	        "innerHTML": _vm._s(item.observacao)
	      }
	    }) : _vm._e()])]) : _vm._e()
	  }), 0) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [(!_vm._.includes(['VISUALIZAR', 'CRIAR'], _vm.acao) && !_vm.ehVisualizacao && !_vm._.includes(['CANCELADO', 'BAIXADO'], _vm.etapa)) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-md-2"
	  }, [_vm._v("Decisão:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.acao),
	      expression: "ocorrencia.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "ASSENTAMENTO",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.ocorrencia.acao, "ASSENTAMENTO")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "acao", "ASSENTAMENTO")
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.enumeradores['ASSENTAMENTO']) + " "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]), _vm._v(" "), (_vm.etapa === 'LIBERADO') ? _c('div', [((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.acao),
	      expression: "ocorrencia.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "ENCAMINHAR_BAIXA",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.ocorrencia.acao, "ENCAMINHAR_BAIXA")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "acao", "ENCAMINHAR_BAIXA")
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.enumeradores['ENCAMINHAR_BAIXA']) + " "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e(), _vm._v(" "), ((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && !_vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo))) ? _c('div', [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.acao),
	      expression: "ocorrencia.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "BAIXAR",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.ocorrencia.acao, "BAIXAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "acao", "BAIXAR")
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.enumeradores['BAIXAR']) + " "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e(), _vm._v(" "), (('' + _vm.ocorrencia.enquadramento.codigo)[0] === '1' || (('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && !_vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo))) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }]
	  }, [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.acao),
	      expression: "ocorrencia.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "CANCELAR",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.ocorrencia.acao, "CANCELAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "acao", "CANCELAR")
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.enumeradores['CANCELAR']) + " "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.etapa === 'AGUARDA_APROVACAO' && _vm.ehGestor) ? _c('div', [((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.acao),
	      expression: "ocorrencia.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "APROVAR",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.ocorrencia.acao, "APROVAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "acao", "APROVAR")
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.enumeradores['APROVAR']) + " "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e(), _vm._v(" "), ((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.acao),
	      expression: "ocorrencia.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "CANCELAR",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.ocorrencia.acao, "CANCELAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "acao", "CANCELAR")
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.enumeradores['CANCELAR']) + " "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.etapa === 'AGUARDA_BAIXA' && _vm.ehGestor) ? _c('div', [((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.acao),
	      expression: "ocorrencia.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "BAIXAR",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.ocorrencia.acao, "BAIXAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "acao", "BAIXAR")
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.enumeradores['BAIXAR']) + " "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e(), _vm._v(" "), ((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
	    staticClass: "new-control new-control-radio",
	    staticStyle: {
	      "padding-top": "8px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ocorrencia.acao),
	      expression: "ocorrencia.acao"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "decisão",
	      "value": "CANCELAR",
	      "disabled": _vm.ehVisualizacao
	    },
	    domProps: {
	      "checked": _vm._q(_vm.ocorrencia.acao, "CANCELAR")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.ocorrencia, "acao", "CANCELAR")
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.enumeradores['CANCELAR']) + " "), _c('div', {
	    staticClass: "new-control-indicator"
	  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.enumeradores[_vm.ocorrencia.acao]) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    class: 'col-md-12' + (_vm._.includes(['CANCELAR', 'ASSENTAMENTO'], _vm.ocorrencia.acao) ? ' required-field ' : ' ') + (_vm.errors.first('observacao_decisao') ? ' has-error ' : '')
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "observacao_decisao"
	    }
	  }, [_vm._v("Observação para " + _vm._s(_vm.enumeradores[_vm.ocorrencia.acao]) + ":")]), _vm._v(" "), _c('textarea-autosize', {
	    directives: [{
	      name: "resizable",
	      rawName: "v-resizable"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm._.includes(['CANCELAR', 'ASSENTAMENTO'], _vm.ocorrencia.acao) ? 'required' : ''),
	      expression: "_.includes(['CANCELAR', 'ASSENTAMENTO'], ocorrencia.acao) ? 'required' : ''"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": (_vm._.includes(['CANCELAR', 'ASSENTAMENTO'], _vm.ocorrencia.acao) ? 'Informe' : 'Opcionalmente pode informar') + ' o motivo para ' + _vm._.toLower(_vm.enumeradores[_vm.ocorrencia.acao]) + ' esta ocorrência',
	      "disabled": _vm.ehVisualizacao,
	      "name": "observacao_decisao",
	      "id": "observacao_decisao"
	    },
	    model: {
	      value: (_vm.ocorrencia.observacaoDecisao),
	      callback: function($$v) {
	        _vm.$set(_vm.ocorrencia, "observacaoDecisao", $$v)
	      },
	      expression: "ocorrencia.observacaoDecisao"
	    }
	  }), _vm._v(" "), (!_vm._.isNil(_vm.ocorrencia.observacaoDecisao) && _vm.ocorrencia.observacaoDecisao.length > 245) ? _c('span', {
	    staticClass: "label label-warning"
	  }, [_vm._v("Atenção! O SGP guardará esse motivo com " + _vm._s(_vm.ocorrencia.observacaoDecisao.length) + " caracteres, mas no Sapiens só os 245 primeiros caracteres serão gravados")]) : _vm._e(), _vm._v(" "), (!_vm._.isNil(_vm.ocorrencia.observacaoDecisao) && _vm.ocorrencia.observacaoDecisao.length > 1000) ? _c('span', {
	    staticClass: "label label-info"
	  }, [_vm._v("Atenção! O texto esta muito grande, indicamos que o resuma")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('observacao_decisao')) ? _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(" Ao " + _vm._s(_vm.enumeradores[_vm.ocorrencia.acao]) + " é obrigatório informar um motivo para constar na observação da tarefa")]) : _vm._e()], 1)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 col-md-offset-2"
	  }, [(_vm.ehGestor || _vm._.includes(['SOLICITACAO', 'LIBERADO'], _vm.etapa) || _vm.ocorrencia.acao === 'ASSENTAMENTO') ? _c('span', [(_vm.acao !== 'VISUALIZAR') ? _c('g-button-ujarak', {
	    attrs: {
	      "color": "success",
	      "size": "button--size-ss"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.validaConclusao()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Concluir")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.botaoVoltar) ? _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$router.go(-1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Voltar")])], 1) : _c('span', [_c('g-button-ujarak', {
	    attrs: {
	      "color": "warning",
	      "type": "button"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.acaoOcorrencia('LISTAR', null)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Volta para lista")])], 1)]), _vm._v(" "), (!_vm._.isNull(_vm.id) && !_vm.loading.tela && !_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }],
	    staticClass: "col-md-3 text-right"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Ocorrência Ativa afeta o projeto/entidade. Inativa não afeta, pois foi baixada, cancelada ou ainda aguarda aprovação</h5>'
	    }
	  }, [(_vm.enumeradores[_vm.ativo] === 1) ? _c('span', {
	    staticClass: "label label-success"
	  }, [_vm._v("Ativo")]) : _c('span', {
	    staticClass: "label label-default"
	  }, [_vm._v("Inativo")])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Mostra a situação do processo <span class=\'realce\'>' + _vm.id + '</span> ligada a ocorrência. Em geral ficará em execução até ser baixada (passa para feito) ou cancelada</h5>'
	    }
	  }, [(_vm._.includes(['FEITO', 'CANCELADO'], _vm.itemOcorrencia.situacao)) ? _c('span', {
	    staticClass: "label label-default"
	  }, [_vm._v("Processo " + _vm._s(_vm.enumeradores[_vm.itemOcorrencia.situacao]))]) : _c('span', {
	    staticClass: "label label-primary",
	    staticStyle: {
	      "background": "var(--cor-alerta-light) !important"
	    }
	  }, [_vm._v("Processo " + _vm._s(_vm.enumeradores[_vm.itemOcorrencia.situacao]))])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        inertia: true,
	        arrow: true,
	        animation: 'fade',
	        distance: '1',
	        size: 'large'
	      }),
	      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large'}"
	    }],
	    attrs: {
	      "title": '<h5>Mostra a etapa atual/situação em que se encontra a ocorrência. Poder Liberada, Aguardando aprovção ou baixa, baixada ou cancelada</h5>'
	    }
	  }, [(_vm._.includes(['BAIXADO', 'CANCELADO'], _vm.etapa)) ? _c('span', {
	    staticClass: "label label-default"
	  }, [_vm._v(_vm._s(_vm.enumeradores[_vm.etapa]))]) : _c('span', {
	    staticClass: "label label-info"
	  }, [_vm._v(_vm._s(_vm.enumeradores[_vm.etapa]))])])]) : _vm._e()])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando tabela ...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "etiquetaCarregando"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  }), _vm._v(" Carregando lista de projetos e entidades...")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "150px",
	      "text-align": "center"
	    }
	  }, [_vm._v("Etapa")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "200px",
	      "text-align": "center"
	    }
	  }, [_vm._v("Usuário")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "120px",
	      "text-align": "center"
	    }
	  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Observação")])])])
	}]}

/***/ }),
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2255 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2256 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2257 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2258 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2259 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.2ab6f99de11dd672574c.js